// @ts-nocheck

export const FINAL_ICON_LIBRARY: { [key: string]: { defaultColors: string[]; getIcon: (colors?: string[]) => JSX.Element }; keywords?: string[]} = {
    "0-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["item","product","square","tile","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16L16 8C16 7.44772 15.5523 7 15 7L9 7C8.44772 7 8 7.44772 8 8L8 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "0-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["square","outline","box","frame","selection","option","select","item","inventory","product","placeholder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16L16 8C16 7.44772 15.5523 7 15 7L9 7C8.44772 7 8 7.44772 8 8L8 16Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "0-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","square","container","module","tile","product","item","category","section","option","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6L15 6C16.1046 6 17 6.89543 17 8V16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16L7 8C7 6.89543 7.89543 6 9 6ZM15 8L9 8V16H15L15 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "0": {
        defaultColors: ["#3D4C66"],
        keywords: ["rectangle","square","block","container","select","choose","option","interface","box","payment-method","void","discount","receipt","enter","details","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16L16 8C16 7.44772 15.5523 7 15 7L9 7C8.44772 7 8 7.44772 8 8L8 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "1": {
        defaultColors: ["#3D4C66"],
        keywords: ["line","separator","divider","pipe","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L12 12L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "1-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["vertical-line","divider","separator","stock","quantity","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.5523 6 13 6.44772 13 7L13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17L11 7C11 6.44772 11.4477 6 12 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "1-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["divider","separator","split","section","order-division","line","one"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L12 12L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "1-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["number-1","one","first","quantity","amount","position","order-number","table-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.5523 6 13 6.44772 13 7L13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17L11 7C11 6.44772 11.4477 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "10-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","items","options","settings","menu","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16C10 16.5523 10.4477 17 11 17H17C17.5523 17 18 16.5523 18 16L18 8C18 7.44772 17.5523 7 17 7L11 7C10.4477 7 10 7.44772 10 8L10 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "10-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["stock","inventory","numbers","quantity","display","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6C6.55229 6 7 6.44772 7 7L7 17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17L5 7C5 6.44772 5.44772 6 6 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 6L17 6C18.1046 6 19 6.89543 19 8V16C19 17.1046 18.1046 18 17 18H11C9.89543 18 9 17.1046 9 16L9 8C9 6.89543 9.89543 6 11 6ZM17 8L11 8V16H17L17 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "10-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ten","zero","10","number","quantity","amount","discount","percentage","inventory","count","order-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6C6.55229 6 7 6.44772 7 7L7 17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17L5 7C5 6.44772 5.44772 6 6 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 6L17 6C18.1046 6 19 6.89543 19 8V16C19 17.1046 18.1046 18 17 18H11C9.89543 18 9 17.1046 9 16L9 8C9 6.89543 9.89543 6 11 6ZM17 8L11 8V16H17L17 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["two","number-2","2","quantity","second","count","amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8L17 12C17 13.1046 16.1046 14 15 14L9 14L9 16L16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18L9 18C7.89543 18 7 17.1046 7 16L7 14C7 12.8954 7.89543 12 9 12L15 12L15 8L8 8C7.44771 8 7 7.55228 7 7C7 6.44772 7.44771 6 8 6L15 6C16.1046 6 17 6.89543 17 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "2-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["two","quantity","amount","number","count","discount-2","2-percent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L9 17C8.44772 17 8 16.5523 8 16L8 14C8 13.4477 8.44772 13 9 13L15 13C15.5523 13 16 12.5523 16 12L16 8C16 7.44772 15.5523 7 15 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "2": {
        defaultColors: ["#3D4C66"],
        keywords: ["number","two","quantity","items","second","duplicate","amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L9 17C8.44772 17 8 16.5523 8 16L8 14C8 13.4477 8.44772 13 9 13L15 13C15.5523 13 16 12.5523 16 12L16 8C16 7.44772 15.5523 7 15 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "10": {
        defaultColors: ["#3D4C66"],
        keywords: ["quantity","number","ten","10","discount","percentage","amount","number-pad","numeric-entry","price","total"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 7M11 7L17 7C17.5523 7 18 7.44772 18 8L18 16C18 16.5523 17.5523 17 17 17H11C10.4477 17 10 16.5523 10 16L10 8C10 7.44772 10.4477 7 11 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "2-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["number-2","two","quantity","second","discount","price","amount","count","split-bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 8L17 12C17 13.1046 16.1046 14 15 14L9 14L9 16L16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18L9 18C7.89543 18 7 17.1046 7 16L7 14C7 12.8954 7.89543 12 9 12L15 12L15 8L17 8ZM15 6C16.1046 6 17 6.89543 17 8L8 8C7.44771 8 7 7.55228 7 7C7 6.44772 7.44771 6 8 6L15 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "24sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["24/7","24 hours","availability","support","open","all day","around the clock","customer service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L10 14C9.44771 14 9 13.5523 9 13V13C9 12.4477 9.44771 12 10 12V12C10.5523 12 11 11.5523 11 11V11C11 10.4477 10.5523 10 10 10L9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 12M15 14L15 12M15 12L13 12L13 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7.00005L20.0002 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "24sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["24","hours","open","available","service","time","schedule","all-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L10 14C9.44771 14 9 13.5523 9 13V13C9 12.4477 9.44771 12 10 12V12C10.5523 12 11 11.5523 11 11V11C11 10.4477 10.5523 10 10 10L9 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 12M15 14L15 12M15 12L13 12L13 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7.00005L20.0002 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "24sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["24/7","24-7","open","hours","available","always","all-day","around-the-clock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0002 14.75C11.4144 14.75 11.7502 14.4142 11.7502 14C11.7502 13.5858 11.4144 13.25 11.0002 13.25H10.0002C9.86211 13.25 9.75018 13.1381 9.75018 13C9.75018 12.8619 9.86211 12.75 10.0002 12.75C10.9667 12.75 11.7502 11.9665 11.7502 11C11.7502 10.0335 10.9667 9.25 10.0002 9.25H9.00018C8.58597 9.25 8.25018 9.58579 8.25018 10C8.25018 10.4142 8.58597 10.75 9.00018 10.75H10.0002C10.1383 10.75 10.2502 10.8619 10.2502 11C10.2502 11.1381 10.1383 11.25 10.0002 11.25C9.03369 11.25 8.25018 12.0335 8.25018 13C8.25018 13.9665 9.03369 14.75 10.0002 14.75H11.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0002 9.25C15.4144 9.25 15.7502 9.58579 15.7502 10L15.7502 14C15.7502 14.4142 15.4144 14.75 15.0002 14.75C14.586 14.75 14.2502 14.4142 14.2502 14V12.75H13.0002C12.586 12.75 12.2502 12.4142 12.2502 12V10C12.2502 9.58579 12.586 9.25 13.0002 9.25C13.4144 9.25 13.7502 9.58579 13.7502 10V11.25H14.2502L14.2502 10C14.2502 9.58579 14.586 9.25 15.0002 9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.27534 9.80737C4.28126 6.02223 7.81755 3.25 12.0002 3.25C14.9772 3.25 17.6268 4.65441 19.2696 6.82886C19.3471 6.49716 19.6446 6.25009 19.9999 6.25006C20.4141 6.25003 20.7499 6.58579 20.75 7.00001L20.7502 9.98407C20.7541 10.1602 20.6953 10.3292 20.5898 10.4636C20.5255 10.5455 20.4439 10.6145 20.3486 10.6643C20.2704 10.7054 20.1841 10.7331 20.0927 10.7444C19.8908 10.7697 19.6929 10.7111 19.5396 10.592C19.4549 10.5261 19.3838 10.4419 19.3331 10.3431C19.3064 10.2913 19.2855 10.2359 19.2714 10.1779C18.4381 7.06954 15.5099 4.75 12.0002 4.75C8.48495 4.75 5.55305 7.07687 4.72503 10.1926C4.61864 10.5929 4.20787 10.8312 3.80756 10.7248C3.40724 10.6185 3.16896 10.2077 3.27534 9.80737Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.90283 13.2563C3.81554 13.2676 3.73295 13.2939 3.65775 13.3326C3.55726 13.384 3.47175 13.4566 3.40538 13.5431C3.33913 13.6292 3.29116 13.7301 3.26728 13.84C3.25476 13.8972 3.24885 13.9562 3.25019 14.0161L3.25019 17C3.25019 17.4142 3.58597 17.75 4.00019 17.75C4.35559 17.75 4.65326 17.5028 4.73061 17.1709C6.37341 19.3455 9.02307 20.75 12.0002 20.75C16.1828 20.75 19.7191 17.9778 20.725 14.1926C20.8314 13.7923 20.5931 13.3815 20.1928 13.2752C19.7925 13.1688 19.3817 13.4071 19.2753 13.8074C18.4473 16.9231 15.5154 19.25 12.0002 19.25C8.49052 19.25 5.56235 16.9305 4.72898 13.8222C4.71492 13.7644 4.69417 13.7092 4.66758 13.6575C4.61614 13.557 4.54356 13.4715 4.45703 13.4052C4.37098 13.339 4.27016 13.291 4.16036 13.2671C4.07742 13.2489 3.99047 13.2447 3.90283 13.2563Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "24sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["24","hours","24-hours","open","availability","clock","time","service","all-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L10 14C9.44771 14 9 13.5523 9 13V13C9 12.4477 9.44771 12 10 12V12C10.5523 12 11 11.5523 11 11V11C11 10.4477 10.5523 10 10 10L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 12M15 14L15 12M15 12L13 12L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7.00005L20.0002 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["filter","sort","arrange","layout","stack","organize","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7L15 7C15.5523 7 16 7.44772 16 8L16 12L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["three","3","number","quantity","discount","offer","third"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13L15 13L15 16H8C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H15C16.1046 18 17 17.1046 17 16L17 8C17 6.89543 16.1046 6 15 6H8C7.44772 6 7 6.44772 7 7C7 7.55229 7.44772 8 8 8L15 8L15 11L8 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["three","number","quantity","discount","loyalty-program","multiple-items","item-count","grouping","category","third"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13L15 13L15 16H8C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H15C16.1046 18 17 17.1046 17 16L17 8C17 6.89543 16.1046 6 15 6H8C7.44772 6 7 6.44772 7 7C7 7.55229 7.44772 8 8 8L15 8L15 11L8 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "3": {
        defaultColors: ["#3D4C66"],
        keywords: ["category","section","group","subsection","filter","organize","grouping","group-items","item-section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12M16 12L16 16C16 16.5523 15.5523 17 15 17L8 17M16 12L16 8C16 7.44772 15.5523 7 15 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "360-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["360","complete","cycle","full","overview","process","round","total","end-to-end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 15C21 16.1046 16.9706 17 12 17C7.02944 17 3 16.1046 3 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L8 11M8 11V11C8 11.9428 8 12.4142 7.70711 12.7071C7.41421 13 6.94281 13 6 13L5 13M8 11V11C8 10.0572 8 9.58579 7.70711 9.29289C7.70711 9.29289 7.70711 9.29289 7.70711 9.29289C7.41421 9 6.94281 9 6 9L5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L13 11L13 13L10 13L10 11ZM10 11L10 9L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H19L19 9L15 9L15 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "360-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["360","degree","overview","complete","circle","full-view","full view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 15C21 16.1046 16.9706 17 12 17C7.02944 17 3 16.1046 3 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L8 11M8 11V11C8 11.9428 8 12.4142 7.70711 12.7071C7.41421 13 6.94281 13 6 13L5 13M8 11V11C8 10.0572 8 9.58579 7.70711 9.29289C7.70711 9.29289 7.70711 9.29289 7.70711 9.29289C7.41421 9 6.94281 9 6 9L5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L13 11L13 13L10 13L10 11ZM10 11L10 9L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H19L19 9L15 9L15 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "360": {
        defaultColors: ["#3D4C66"],
        keywords: ["360","degree","full-circle","overview","complete","view","analysis","reporting","total","aggregated","all-in-one","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 15C21 16.1046 16.9706 17 12 17C7.02944 17 3 16.1046 3 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L8 11M8 11V11C8 11.9428 8 12.4142 7.70711 12.7071C7.41421 13 6.94281 13 6 13L5 13M8 11V11C8 10.0572 8 9.58579 7.70711 9.29289C7.70711 9.29289 7.70711 9.29289 7.70711 9.29289C7.41421 9 6.94281 9 6 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L13 11L13 13L10 13L10 11ZM10 11L10 9L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H19L19 9L15 9L15 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "360-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["360","degree","rotation","complete","overview","all-inclusive","circular","view","analysis","sales-overview","full-circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.08711 9.18182C7.08253 9.07819 7.07579 8.98988 7.06588 8.912C7.05248 8.80666 7.0367 8.75391 7.02745 8.73015C7.0253 8.72464 7.02364 8.72103 7.02259 8.71892L7.02117 8.71626L7.01866 8.71476C7.01666 8.71366 7.01324 8.7119 7.00804 8.70963C6.98555 8.69986 6.93563 8.68317 6.83596 8.66901C6.61844 8.63811 6.31495 8.63637 5.80645 8.63637H4.77419C4.34662 8.63637 4 8.27006 4 7.81819C4 7.36632 4.34662 7.00001 4.77419 7.00001L5.85264 7C6.29941 6.99995 6.70905 6.9999 7.04228 7.04724C7.40922 7.09938 7.79707 7.22205 8.11606 7.55917C8.43505 7.89628 8.55113 8.30616 8.60046 8.69396C8.64526 9.04612 8.64522 9.52784 8.64516 10C8.64522 10.4722 8.64526 10.9539 8.60046 11.306C8.55113 11.6938 8.43505 12.1037 8.11606 12.4408C7.79707 12.7779 7.40922 12.9006 7.04228 12.9528C6.70905 13.0001 6.29942 13.0001 5.85264 13L4.77419 13C4.34662 13 4 12.6337 4 12.1818C4 11.7299 4.34662 11.3636 4.77419 11.3636H5.80645C6.31495 11.3636 6.61844 11.3619 6.83596 11.331C6.93563 11.3168 6.98555 11.3001 7.00803 11.2904C7.01324 11.2881 7.01666 11.2863 7.01866 11.2852L7.02117 11.2837L7.02259 11.2811C7.02364 11.279 7.0253 11.2754 7.02745 11.2699C7.0367 11.2461 7.05248 11.1933 7.06588 11.088C7.07579 11.0101 7.08253 10.9218 7.08711 10.8182L4.77419 10.8182C4.34662 10.8182 4 10.4519 4 10C4 9.54813 4.34662 9.18182 4.77419 9.18182L7.08711 9.18182Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.8065 7.8182C13.8065 7.36633 13.4598 7.00002 13.0323 7.00002L9.93549 7.00002C9.50791 7.00002 9.1613 7.36633 9.1613 7.8182V12.1818C9.1613 12.6337 9.50791 13 9.93549 13H13.0323C13.4598 13 13.8065 12.6337 13.8065 12.1818V10C13.8065 9.78301 13.7249 9.57491 13.5797 9.42147C13.4345 9.26803 13.2376 9.18183 13.0323 9.18183L10.7097 9.18183V8.63638L13.0323 8.63637C13.4598 8.63637 13.8065 8.27006 13.8065 7.8182ZM10.7097 10.8182L12.2581 10.8182V11.3636H10.7097V10.8182Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2258 7.00002L15.0968 7.00002C14.6692 7.00002 14.3226 7.36633 14.3226 7.8182V12.1818C14.3226 12.3988 14.4042 12.6069 14.5493 12.7604C14.6945 12.9138 14.8914 13 15.0968 13H19.2258C19.4311 13 19.6281 12.9138 19.7732 12.7604C19.9184 12.6069 20 12.3988 20 12.1818V7.8182C20 7.36633 19.6534 7.00002 19.2258 7.00002ZM18.4516 11.3636H15.871V8.63638H18.4516V11.3636Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.76923 13C3.16102 13 3.4844 13.3264 3.53234 13.7485C3.57827 13.7999 3.6752 13.8843 3.8524 13.9881C4.23247 14.2106 4.83297 14.4369 5.63973 14.6367C7.24077 15.0331 9.48986 15.2857 12 15.2857C14.5101 15.2857 16.7592 15.0331 18.3603 14.6367C19.167 14.4369 19.7675 14.2106 20.1476 13.9881C20.3248 13.8843 20.4217 13.7999 20.4677 13.7485C20.5156 13.3264 20.839 13 21.2308 13C21.6556 13 22 13.3838 22 13.8571C22 14.2944 21.8176 14.6461 21.6091 14.8984C21.4044 15.1461 21.1394 15.3439 20.8631 15.5056C20.309 15.83 19.5577 16.0963 18.694 16.3101C16.9542 16.7409 14.5879 17 12 17C9.41213 17 7.04583 16.7409 5.30599 16.3101C4.44231 16.0963 3.69099 15.83 3.13686 15.5056C2.86058 15.3439 2.59562 15.1461 2.3909 14.8984C2.18238 14.6461 2 14.2944 2 13.8571C2 13.3838 2.3444 13 2.76923 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "3d-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["3D","product-view","augmented-reality","visualization","display","menu-item","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 15H13V9H14.3333C15.8061 9 17 10.3431 17 12C17 13.6569 15.8061 15 14.3333 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3d-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["3d","three-dimensional","augmented-reality","visualization","design","modeling","virtual-reality"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 15H13V9H14.3333C15.8061 9 17 10.3431 17 12C17 13.6569 15.8061 15 14.3333 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3d-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["3d","dimensional","design","modeling","display","view","presentation","inventory-visualization","product-preview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.3333 14.25H13.75V9.75H14.3333C15.3113 9.75 16.25 10.6719 16.25 12C16.25 13.3281 15.3113 14.25 14.3333 14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92944V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57533 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM7 8.25C6.58579 8.25 6.25 8.58579 6.25 9C6.25 9.41421 6.58579 9.75 7 9.75H8.5C8.91421 9.75 9.25 10.0858 9.25 10.5C9.25 10.9142 8.91421 11.25 8.5 11.25H7C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H8.5C8.91421 12.75 9.25 13.0858 9.25 13.5C9.25 13.9142 8.91421 14.25 8.5 14.25H7C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H8.5C9.74264 15.75 10.75 14.7426 10.75 13.5C10.75 12.9237 10.5334 12.3981 10.1771 12C10.5334 11.6019 10.75 11.0763 10.75 10.5C10.75 9.25736 9.74264 8.25 8.5 8.25H7ZM13 8.25C12.5858 8.25 12.25 8.58579 12.25 9V15C12.25 15.4142 12.5858 15.75 13 15.75H14.3333C16.3009 15.75 17.75 13.9856 17.75 12C17.75 10.0144 16.3009 8.25 14.3333 8.25H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "3d": {
        defaultColors: ["#3D4C66"],
        keywords: ["3d","graphics","design","render","visualization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13.2V10.8C4 8.18126 4 6.87188 4.58944 5.91001C4.91926 5.37178 5.37178 4.91926 5.91001 4.58944C6.87188 4 8.18126 4 10.8 4H13.2C15.8187 4 17.1281 4 18.09 4.58944C18.6282 4.91926 19.0807 5.37178 19.4106 5.91001C20 6.87188 20 8.18126 20 10.8V13.2C20 15.8187 20 17.1281 19.4106 18.09C19.0807 18.6282 18.6282 19.0807 18.09 19.4106C17.1281 20 15.8187 20 13.2 20H10.8C8.18126 20 6.87188 20 5.91001 19.4106C5.37178 19.0807 4.91926 18.6282 4.58944 18.09C4 17.1281 4 15.8187 4 13.2Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 15H13V9H14.3333C15.8061 9 17 10.3431 17 12C17 13.6569 15.8061 15 14.3333 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3g-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["3g","data","network","connection","internet","connectivity","signal","mobile","bandwidth","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3g": {
        defaultColors: ["#3D4C66"],
        keywords: ["3G","connection","network","connectivity","data","mobile-data","internet","wireless","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "3g-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["3g","data","network","connection","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0549 4.25H9.94513C8.57755 4.24998 7.47521 4.24997 6.60825 4.36653C5.70814 4.48754 4.95027 4.74644 4.34835 5.34835C3.74644 5.95027 3.48754 6.70814 3.36653 7.60825C3.24997 8.47521 3.24998 9.57752 3.25 10.9451V13.0549C3.24998 14.4225 3.24997 15.5248 3.36653 16.3918C3.48754 17.2919 3.74644 18.0497 4.34835 18.6517C4.95027 19.2536 5.70814 19.5125 6.60825 19.6335C7.47521 19.75 8.57753 19.75 9.94511 19.75H14.0549C15.4225 19.75 16.5248 19.75 17.3918 19.6335C18.2919 19.5125 19.0497 19.2536 19.6517 18.6517C20.2536 18.0497 20.5125 17.2919 20.6335 16.3918C20.75 15.5248 20.75 14.4225 20.75 13.0549V10.9451C20.75 9.57754 20.75 8.47522 20.6335 7.60825C20.5125 6.70814 20.2536 5.95027 19.6517 5.34835C19.0497 4.74644 18.2919 4.48754 17.3918 4.36653C16.5248 4.24997 15.4225 4.24998 14.0549 4.25ZM7 8.25H8.5C9.74264 8.25 10.75 9.25736 10.75 10.5C10.75 11.0763 10.5334 11.6019 10.1771 12C10.5334 12.3981 10.75 12.9237 10.75 13.5C10.75 14.7426 9.74264 15.75 8.5 15.75H7C6.58579 15.75 6.25 15.4142 6.25 15C6.25 14.5858 6.58579 14.25 7 14.25H8.5C8.91421 14.25 9.25 13.9142 9.25 13.5C9.25 13.0858 8.91421 12.75 8.5 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H8.5C8.91421 11.25 9.25 10.9142 9.25 10.5C9.25 10.0858 8.91421 9.75 8.5 9.75H7C6.58579 9.75 6.25 9.41421 6.25 9C6.25 8.58579 6.58579 8.25 7 8.25ZM13 8.25C12.8011 8.25 12.6103 8.32902 12.4697 8.46967C12.329 8.61032 12.25 8.80109 12.25 9V15C12.25 15.4142 12.5858 15.75 13 15.75H17C17.4142 15.75 17.75 15.4142 17.75 15V12C17.75 11.5858 17.4142 11.25 17 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H16.25V14.25H13.75V9.75H17C17.4142 9.75 17.75 9.41421 17.75 9C17.75 8.58579 17.4142 8.25 17 8.25H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "3g-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["3g","network","connection","mobile-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12H8.5M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9L7 9M8.5 12C9.32843 12 10 12.6716 10 13.5C10 14.3284 9.32843 15 8.5 15H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["four","quantity","number","discount-4","4-items","fourth"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19L15 14.625"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 14.625L15 14.625M15 14.625L15 7.76758C15 6.83164 13.8292 6.40861 13.231 7.12838L8.36245 12.9858C7.8209 13.6374 8.28425 14.625 9.13149 14.625L15 14.625Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["4","number-4","quantity","item-count","fourth","number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.9998 18C13.9998 18.5523 14.4476 19 14.9998 19C15.5521 19 15.9998 18.5523 15.9998 18V15H16.9998C17.5521 15 17.9998 14.5523 17.9998 14C17.9998 13.4478 17.5521 13 16.9998 13H15.9998V7.00005C15.9998 5.10949 13.6191 4.27438 12.4381 5.75066L7.43811 11.7507C6.39049 13.0602 7.32283 15 8.99985 15H13.9998V18ZM13.9998 13H8.99985L13.9998 7.00005L13.9998 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["four","quantity","number","4","count","discount","group","customer-count"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.9998 18C13.9998 18.5523 14.4476 19 14.9998 19C15.5521 19 15.9998 18.5523 15.9998 18V15H16.9998C17.5521 15 17.9998 14.5523 17.9998 14C17.9998 13.4478 17.5521 13 16.9998 13H15.9998V7.00005C15.9998 5.10949 13.6191 4.27438 12.4381 5.75066L7.43811 11.7507C6.39049 13.0602 7.32283 15 8.99985 15H13.9998V18ZM13.9998 13H8.99985L13.9998 7.00005L13.9998 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "4": {
        defaultColors: ["#3D4C66"],
        keywords: ["four","quantity","number","discount","item-count","numeric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 14.625L15 14.625M15 19L15 14.625M15 14.625L15 7.76758C15 6.83164 13.8292 6.40861 13.231 7.12838L8.36245 12.9858C7.8209 13.6374 8.28425 14.625 9.13149 14.625L15 14.625Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "404-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["404","error","not found","issue","problem","unavailable","page not found","system error","transaction error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 12V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 11C15 11.5523 15.4477 12 16 12H17M17 10V12M17 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10L7 11C7 11.5523 7.44772 12 8 12H9M9 10V12M9 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "404-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["404","error","not found","page not found","system error","offline","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 12V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 11C15 11.5523 15.4477 12 16 12H17M17 10V12M17 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10L7 11C7 11.5523 7.44772 12 8 12H9M9 10V12M9 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "404-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["404","error","not found","page not found","unavailable","problem","system error","network error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10.75C11.8619 10.75 11.75 10.8619 11.75 11V12C11.75 12.1381 11.8619 12.25 12 12.25C12.1381 12.25 12.25 12.1381 12.25 12V11C12.25 10.8619 12.1381 10.75 12 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.94513 4.25H15.0549C16.4225 4.24998 17.5248 4.24997 18.3918 4.36653C19.2919 4.48754 20.0497 4.74644 20.6517 5.34835C21.2536 5.95027 21.5125 6.70814 21.6335 7.60825C21.75 8.47522 21.75 9.57754 21.75 10.9451V13.0549C21.75 14.4225 21.75 15.5248 21.6335 16.3918C21.5125 17.2919 21.2536 18.0497 20.6517 18.6517C20.0497 19.2536 19.2919 19.5125 18.3918 19.6335C17.5248 19.75 16.4225 19.75 15.0549 19.75H8.94513C7.57755 19.75 6.47522 19.75 5.60825 19.6335C4.70814 19.5125 3.95027 19.2536 3.34835 18.6517C2.74644 18.0497 2.48754 17.2919 2.36653 16.3918C2.24997 15.5248 2.24998 14.4225 2.25 13.0549V10.9451C2.24998 9.57755 2.24997 8.47521 2.36653 7.60825C2.48754 6.70814 2.74644 5.95027 3.34835 5.34835C3.95027 4.74644 4.70814 4.48754 5.60825 4.36653C6.47521 4.24997 7.57755 4.24998 8.94513 4.25ZM7.75 10C7.75 9.58579 7.41421 9.25 7 9.25C6.58579 9.25 6.25 9.58579 6.25 10V11C6.25 11.9665 7.0335 12.75 8 12.75H8.25V14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14V10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10V11.25H8C7.86193 11.25 7.75 11.1381 7.75 11V10ZM12 9.25C12.9665 9.25 13.75 10.0335 13.75 11V12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12V11C10.25 10.0335 11.0335 9.25 12 9.25ZM15 9.25C15.4142 9.25 15.75 9.58579 15.75 10V11C15.75 11.1381 15.8619 11.25 16 11.25H16.25V10C16.25 9.58579 16.5858 9.25 17 9.25C17.4142 9.25 17.75 9.58579 17.75 10V14C17.75 14.4142 17.4142 14.75 17 14.75C16.5858 14.75 16.25 14.4142 16.25 14V12.75H16C15.0335 12.75 14.25 11.9665 14.25 11V10C14.25 9.58579 14.5858 9.25 15 9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "404": {
        defaultColors: ["#3D4C66"],
        keywords: ["404","error","not found","issue","problem","alert","warning","system-error","connection-error","service-unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 12V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 11C15 11.5523 15.4477 12 16 12H17M17 10V12M17 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10L7 11C7 11.5523 7.44772 12 8 12H9M9 10V12M9 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4g-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["4g","connectivity","network","data","speed","internet","online","mobile","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 9V12H11M11 9V12M11 15V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4g-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["4g","network","connectivity","connection","signal","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 9V12H11M11 9V12M11 15V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4g-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["4g","network","connectivity","connection","mobile-data","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V13.0549C20.75 14.4225 20.75 15.5248 20.6335 16.3918C20.5125 17.2919 20.2536 18.0497 19.6517 18.6517C19.0497 19.2536 18.2919 19.5125 17.3918 19.6335C16.5248 19.75 15.4225 19.75 14.0549 19.75H9.94513C8.57755 19.75 7.47522 19.75 6.60825 19.6335C5.70814 19.5125 4.95027 19.2536 4.34835 18.6517C3.74644 18.0497 3.48754 17.2919 3.36653 16.3918C3.24997 15.5248 3.24998 14.4225 3.25 13.0549V10.9451C3.24998 9.57755 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57755 4.24998 9.94513 4.25ZM7.5 9C7.5 8.58579 7.16421 8.25 6.75 8.25C6.33579 8.25 6 8.58579 6 9V12C6 12.4142 6.33579 12.75 6.75 12.75H10V15C10 15.4142 10.3358 15.75 10.75 15.75C11.1642 15.75 11.5 15.4142 11.5 15V9C11.5 8.58579 11.1642 8.25 10.75 8.25C10.3358 8.25 10 8.58579 10 9V11.25H7.5V9ZM13.25 8.25C12.8358 8.25 12.5 8.58579 12.5 9V15C12.5 15.4142 12.8358 15.75 13.25 15.75H17.25C17.6642 15.75 18 15.4142 18 15V12C18 11.5858 17.6642 11.25 17.25 11.25H15.25C14.8358 11.25 14.5 11.5858 14.5 12C14.5 12.4142 14.8358 12.75 15.25 12.75H16.5V14.25H14V9.75H17.25C17.6642 9.75 18 9.41421 18 9C18 8.58579 17.6642 8.25 17.25 8.25H13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "4k-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["4k","resolution","quality","display","screen","video","digital","high-definition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 11C8 11.5523 8.44772 12 9 12H11M11 10V12M11 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.75 14C13.75 14.4142 13.4142 14.75 13 14.75C12.5858 14.75 12.25 14.4142 12.25 14H13.75ZM12.25 10C12.25 9.58579 12.5858 9.25 13 9.25C13.4142 9.25 13.75 9.58579 13.75 10H12.25ZM15.4828 9.4569C15.7827 9.17123 16.2574 9.18281 16.5431 9.48276C16.8288 9.78271 16.8172 10.2574 16.5172 10.5431L15.4828 9.4569ZM16.5547 13.4952C16.8335 13.8016 16.8111 14.2759 16.5048 14.5547C16.1984 14.8335 15.7241 14.8111 15.4453 14.5048L16.5547 13.4952ZM14.05 11.8571L13.5328 11.314L14.0883 10.7849L14.6047 11.3524L14.05 11.8571ZM12.25 14V12.8571H13.75V14H12.25ZM12.25 12.8571V10H13.75V12.8571H12.25ZM12.4828 12.314L15.4828 9.4569L16.5172 10.5431L13.5172 13.4002L12.4828 12.314ZM12.4828 12.314L13.5328 11.314L14.5672 12.4002L13.5172 13.4002L12.4828 12.314ZM14.6047 11.3524L16.5547 13.4952L15.4453 14.5048L13.4953 12.3619L14.6047 11.3524Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "4g": {
        defaultColors: ["#3D4C66"],
        keywords: ["4g","signal","network","connection","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 9V12H11M11 9V12M11 15V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "4k-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["4k","resolution","display","high-quality","enhanced","upscale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 11C8 11.5523 8.44772 12 9 12H11M11 10V12M11 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.75 14C13.75 14.4142 13.4142 14.75 13 14.75C12.5858 14.75 12.25 14.4142 12.25 14H13.75ZM12.25 10C12.25 9.58579 12.5858 9.25 13 9.25C13.4142 9.25 13.75 9.58579 13.75 10H12.25ZM15.4828 9.4569C15.7827 9.17123 16.2574 9.18281 16.5431 9.48276C16.8288 9.78271 16.8172 10.2574 16.5172 10.5431L15.4828 9.4569ZM16.5547 13.4952C16.8335 13.8016 16.8111 14.2759 16.5048 14.5547C16.1984 14.8335 15.7241 14.8111 15.4453 14.5048L16.5547 13.4952ZM14.05 11.8571L13.5328 11.314L14.0883 10.7849L14.6047 11.3524L14.05 11.8571ZM12.25 14V12.8571H13.75V14H12.25ZM12.25 12.8571V10H13.75V12.8571H12.25ZM12.4828 12.314L15.4828 9.4569L16.5172 10.5431L13.5172 13.4002L12.4828 12.314ZM12.4828 12.314L13.5328 11.314L14.5672 12.4002L13.5172 13.4002L12.4828 12.314ZM14.6047 11.3524L16.5547 13.4952L15.4453 14.5048L13.4953 12.3619L14.6047 11.3524Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "4k-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["4k","resolution","display","high-resolution","quality","video","image","enhanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM16.5172 10.5431C16.8172 10.2574 16.8288 9.78271 16.5431 9.48276C16.2574 9.18281 15.7827 9.17123 15.4828 9.4569L13.75 11.1071V10C13.75 9.58579 13.4142 9.25 13 9.25C12.5858 9.25 12.25 9.58579 12.25 10V14C12.25 14.4142 12.5858 14.75 13 14.75C13.4142 14.75 13.75 14.4142 13.75 14V13.1786L14.0117 12.9294L15.4453 14.5048C15.7241 14.8111 16.1984 14.8335 16.5048 14.5547C16.8111 14.2759 16.8335 13.8016 16.5547 13.4952L15.0982 11.8946L16.5172 10.5431ZM8.75 10C8.75 9.58579 8.41421 9.25 8 9.25C7.58579 9.25 7.25 9.58579 7.25 10V11C7.25 11.9665 8.0335 12.75 9 12.75H10.25V14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14V10C11.75 9.58579 11.4142 9.25 11 9.25C10.5858 9.25 10.25 9.58579 10.25 10V11.25H9C8.86193 11.25 8.75 11.1381 8.75 11V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "4k": {
        defaultColors: ["#3D4C66"],
        keywords: ["4k","resolution","quality","display","settings","high-quality"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 11C8 11.5523 8.44772 12 9 12H11M11 10V12M11 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.75 14C13.75 14.4142 13.4142 14.75 13 14.75C12.5858 14.75 12.25 14.4142 12.25 14H13.75ZM12.25 10C12.25 9.58579 12.5858 9.25 13 9.25C13.4142 9.25 13.75 9.58579 13.75 10H12.25ZM15.4828 9.4569C15.7827 9.17123 16.2574 9.18281 16.5431 9.48276C16.8288 9.78271 16.8172 10.2574 16.5172 10.5431L15.4828 9.4569ZM16.5547 13.4952C16.8335 13.8016 16.8111 14.2759 16.5048 14.5547C16.1984 14.8335 15.7241 14.8111 15.4453 14.5048L16.5547 13.4952ZM14.05 11.8571L13.5328 11.314L14.0883 10.7849L14.6047 11.3524L14.05 11.8571ZM12.25 14V12.8571H13.75V14H12.25ZM12.25 12.8571V10H13.75V12.8571H12.25ZM12.4828 12.314L15.4828 9.4569L16.5172 10.5431L13.5172 13.4002L12.4828 12.314ZM12.4828 12.314L13.5328 11.314L14.5672 12.4002L13.5172 13.4002L12.4828 12.314ZM14.6047 11.3524L16.5547 13.4952L15.4453 14.5048L13.4953 12.3619L14.6047 11.3524Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "5-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["5","five","discount","percentage","price","number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "5-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["5","five","quantity","number-of-items","discount","fifth"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 7C17 6.44771 16.5523 6 16 6L9 6C7.89543 6 7 6.89543 7 8L7 11C7 12.1046 7.89543 13 9 13L15 13L15 16L8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18L15 18C16.1046 18 17 17.1046 17 16L17 13C17 11.8954 16.1046 11 15 11L9 11L9 8L16 8C16.5523 8 17 7.55229 17 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["5","number-5","quantity","discount-5","5-percent","five","number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 7C17 6.44771 16.5523 6 16 6L9 6C7.89543 6 7 6.89543 7 8L7 11C7 12.1046 7.89543 13 9 13L15 13L15 16L8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18L15 18C16.1046 18 17 17.1046 17 16L17 13C17 11.8954 16.1046 11 15 11L9 11L9 8L16 8C16.5523 8 17 7.55229 17 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "5": {
        defaultColors: ["#3D4C66"],
        keywords: ["5","number","five","quantity","count","discount","price","item-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "5g-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["5g","network","connection","speed","technology","connectivity","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H11V12H7V9H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "5g-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["5g","network","connection","data","speed","connectivity","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V13.0549C20.75 14.4225 20.75 15.5248 20.6335 16.3918C20.5125 17.2919 20.2536 18.0497 19.6517 18.6517C19.0497 19.2536 18.2919 19.5125 17.3918 19.6335C16.5248 19.75 15.4225 19.75 14.0549 19.75H9.94513C8.57755 19.75 7.47522 19.75 6.60825 19.6335C5.70814 19.5125 4.95027 19.2536 4.34835 18.6517C3.74644 18.0497 3.48754 17.2919 3.36653 16.3918C3.24997 15.5248 3.24998 14.4225 3.25 13.0549V10.9451C3.24998 9.57755 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57755 4.24998 9.94513 4.25ZM6.75 8.25C6.33579 8.25 6 8.58579 6 9V12C6 12.4142 6.33579 12.75 6.75 12.75H10V14.25H6.75C6.33579 14.25 6 14.5858 6 15C6 15.4142 6.33579 15.75 6.75 15.75H10.75C11.1642 15.75 11.5 15.4142 11.5 15V12C11.5 11.5858 11.1642 11.25 10.75 11.25H7.5V9.75H10.75C11.1642 9.75 11.5 9.41421 11.5 9C11.5 8.58579 11.1642 8.25 10.75 8.25H6.75ZM13.25 8.25C12.8358 8.25 12.5 8.58579 12.5 9V15C12.5 15.4142 12.8358 15.75 13.25 15.75H17.25C17.6642 15.75 18 15.4142 18 15V12C18 11.5858 17.6642 11.25 17.25 11.25H16.25C15.8358 11.25 15.5 11.5858 15.5 12C15.5 12.4142 15.8358 12.75 16.25 12.75H16.5V14.25H14V9.75H17.25C17.6642 9.75 18 9.41421 18 9C18 8.58579 17.6642 8.25 17.25 8.25H13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "5g": {
        defaultColors: ["#3D4C66"],
        keywords: ["5g","network","connection","fast","speed","data","technology"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H11V12H7V9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "5g-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["5g","network","connectivity","internet","speed","transaction","fast","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L13 9L13 15H17V12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H11V12H7V9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["number-6","six","quantity","discount","promotion","group","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L9 17C8.44772 17 8 16.5523 8 16L8 12ZM8 12L8 8C8 7.44772 8.44772 7 9 7L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L16 13C16 12.4477 15.5523 12 15 12L9 12C8.44772 12 8 12.4477 8 13L8 16C8 16.5523 8.44772 17 9 17L15 17C15.5523 17 16 16.5523 16 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "6-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["6","number","quantity","amount","discount","count","code","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 6C16.5523 6 17 6.44771 17 7C17 7.55229 16.5523 8 16 8L9 8L9 11L15 11C16.1046 11 17 11.8954 17 13L17 16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16L7 8C7 6.89543 7.89543 6 9 6L16 6ZM9 13L15 13V16H9L9 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["6","six","number","quantity","table-number","customer-count"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 6C16.5523 6 17 6.44771 17 7C17 7.55229 16.5523 8 16 8L9 8L9 11L15 11C16.1046 11 17 11.8954 17 13L17 16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16L7 8C7 6.89543 7.89543 6 9 6L16 6ZM9 13L15 13V16H9L9 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "6": {
        defaultColors: ["#3D4C66"],
        keywords: ["number-6","six","quantity","item-count","discount-code","table-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L15 12C15.5523 12 16 12.4477 16 13L16 16C16 16.5523 15.5523 17 15 17L9 17C8.44772 17 8 16.5523 8 16L8 12ZM8 12L8 8C8 7.44772 8.44772 7 9 7L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "7-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["corner","angle","L-shape","return","back","undo","arrow-left-up","go-back","previous","return-to-menu","previous-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L16 8C16 7.44772 15.5523 7 15 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "7-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["return","back","undo","previous","arrow-left-down","go-back","reverse-transaction","receipt-lookup","search-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 17L17 8C17 6.89543 16.1046 6 15 6L8 6C7.44772 6 7 6.44772 7 7C7 7.55229 7.44772 8 8 8L15 8L15 17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","corner","turn","back","return","undo","previous","left-up","navigation","go-back","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 17L17 8C17 6.89543 16.1046 6 15 6L8 6C7.44772 6 7 6.44772 7 7C7 7.55229 7.44772 8 8 8L15 8L15 17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "7": {
        defaultColors: ["#3D4C66"],
        keywords: ["corner","angle","redirect","return","back","undo","turn"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L16 8C16 7.44772 15.5523 7 15 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "8-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["discount","minus","subtract","remove","reduction","sale","cut","decrease","deduct"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L16 12L16 8C16 7.44772 15.5523 7 15 7L9 7C8.44772 7 8 7.44772 8 8L8 12L8 16C8 16.5523 8.44772 17 9 17L15 17C15.5523 17 16 16.5523 16 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "8-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["equal","equals","multiple","items","same","match","compare","equality"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 8C17 6.89543 16.1046 6 15 6L9 6C7.89543 6 7 6.89543 7 8L7 16C7 17.1046 7.89543 18 9 18H15C16.1046 18 17 17.1046 17 16L17 8ZM15 8L9 8L9 11L15 11L15 8ZM15 16H9L9 13L15 13L15 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["equals","same","equivalent","match","total","balance","due","payment-due"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 8C17 6.89543 16.1046 6 15 6L9 6C7.89543 6 7 6.89543 7 8L7 16C7 17.1046 7.89543 18 9 18H15C16.1046 18 17 17.1046 17 16L17 8ZM15 8L9 8L9 11L15 11L15 8ZM15 16H9L9 13L15 13L15 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "8": {
        defaultColors: ["#3D4C66"],
        keywords: ["rows","tables","categories","sections","grouping","inventory","organization","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12M8 12L8 8C8 7.44772 8.44772 7 9 7L15 7C15.5523 7 16 7.44772 16 8L16 12M8 12L8 16C8 16.5523 8.44772 17 9 17L15 17C15.5523 17 16 16.5523 16 16L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "9-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["number-9","nine","discount-9","ninety-percent-off","loyalty-program","account-number","customer-id","quantity","ninth","rank-9"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12L16 16C16 16.5523 15.5523 17 15 17L8 17M16 12L9 12C8.44772 12 8 11.5523 8 11L8 8C8 7.44772 8.44772 7 9 7L15 7C15.5523 7 16 7.44772 16 8L16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L15 12C15.5523 12 16 11.5523 16 11L16 8C16 7.44772 15.5523 7 15 7L9 7C8.44772 7 8 7.44772 8 8L8 11C8 11.5523 8.44772 12 9 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "9": {
        defaultColors: ["#3D4C66"],
        keywords: ["nine","number-9","quantity","discount","amount","price","numeric","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12L16 16C16 16.5523 15.5523 17 15 17L8 17M16 12L9 12C8.44772 12 8 11.5523 8 11L8 8C8 7.44772 8.44772 7 9 7L15 7C15.5523 7 16 7.44772 16 8L16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "9-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["nine","number-9","discount-9","table-number-9"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 13L9 13C7.89543 13 7 12.1046 7 11L7 8C7 6.89543 7.89543 6 9 6L15 6C16.1046 6 17 6.89543 17 8L17 16C17 17.1046 16.1046 18 15 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H15L15 13ZM15 8L15 11L9 11L9 8L15 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "9-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["nine","number","quantity","amount","discount","9","item-count","order-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 13L9 13C7.89543 13 7 12.1046 7 11L7 8C7 6.89543 7.89543 6 9 6L15 6C16.1046 6 17 6.89543 17 8L17 16C17 17.1046 16.1046 18 15 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H15L15 13ZM15 8L15 11L9 11L9 8L15 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "A-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["A","letter","alphabet","initial","text","label","category","type","group","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L7.5 15.5M18 19L16.5 15.5M7.5 15.5L10.1617 9.28935C10.9476 7.45551 11.3406 6.53859 12 6.53859C12.6594 6.53859 13.0524 7.45551 13.8383 9.28935L16.5 15.5M7.5 15.5H16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "A-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["a","letter","alphabet","initial","text","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L7.5 15.5M18 19L16.5 15.5M7.5 15.5L10.1617 9.28935C10.9476 7.45551 11.3406 6.53859 12 6.53859C12.6594 6.53859 13.0524 7.45551 13.8383 9.28935L16.5 15.5M7.5 15.5H16.5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "A-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-a","alphabetical","text","modifier","attribute","allergen","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9826 7.2896C11.7498 7.68655 11.4871 8.31579 11.0809 9.29896L9.01665 14H14.9834L12.9191 9.29896C12.5129 8.31579 12.2502 7.68655 12.0174 7.2896C12.0114 7.27949 12.0057 7.26974 12 7.26034C11.9943 7.26974 11.9886 7.27949 11.9826 7.2896ZM15.8405 16L17.0807 19.3711C17.2982 19.8976 17.8861 20.1415 18.3937 19.9159C18.9013 19.6902 19.1364 19.0805 18.9189 18.5539L14.7573 8.4818C14.7471 8.45706 14.7369 8.4324 14.7268 8.40784C14.3601 7.52011 14.0422 6.75061 13.726 6.21143C13.4179 5.68625 12.8957 5 12 5C11.1043 5 10.5821 5.68625 10.274 6.21143C9.95781 6.75061 9.63994 7.5201 9.27322 8.40782C9.26307 8.43239 9.25289 8.45705 9.24266 8.4818L5.08111 18.5539C4.86356 19.0805 5.0987 19.6902 5.60631 19.9159C6.11393 20.1415 6.70178 19.8976 6.91933 19.3711L8.15954 16H15.8405Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "abc-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["abc","alphabet","letters","categories","departments","sections","grouping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L7 9L4 15M9 13L5 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L12 15L14 15C14.5523 15 15 14.5523 15 14L15 12M12 12L12 9H14C14.5523 9 15 9.44772 15 10L15 12M12 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15L18 15C17.4477 15 17 14.5523 17 14L17 10C17 9.44772 17.4477 9 18 9L20 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "abc-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ABC","text","font","characters","initials"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L7 9L4 15M9 13L5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L12 15L14 15C14.5523 15 15 14.5523 15 14L15 12M12 12L12 9H14C14.5523 9 15 9.44772 15 10L15 12M12 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15L18 15C17.4477 15 17 14.5523 17 14L17 10C17 9.44772 17.4477 9 18 9L20 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    A: {
        defaultColors: ["#3D4C66"],
        keywords: ["ABC","text","font","characters","initials"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L7.5 15.5M18 19L16.5 15.5M7.5 15.5L10.1617 9.28935C10.9476 7.45551 11.3406 6.53859 12 6.53859C12.6594 6.53859 13.0524 7.45551 13.8383 9.28935L16.5 15.5M7.5 15.5H16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "abc-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["abc","text","inventory","item-details","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00022 8C6.37899 8 6.72525 8.214 6.89464 8.55279L8.88562 12.5347C8.89212 12.5471 8.89837 12.5596 8.90436 12.5722L9.89464 14.5528C10.1416 15.0468 9.94141 15.6474 9.44743 15.8944C8.95345 16.1414 8.35278 15.9412 8.10579 15.4472L7.38218 14L4.61825 14L3.89465 15.4472C3.64766 15.9412 3.04698 16.1414 2.55301 15.8944C2.05903 15.6474 1.8588 15.0468 2.10579 14.5528L3.09611 12.5722C3.10208 12.5596 3.10831 12.5471 3.11478 12.5348L5.10579 8.55279C5.27518 8.214 5.62144 8 6.00022 8ZM5.61825 12H6.38218L6.00022 11.2361L5.61825 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0002 9C11.0002 8.44772 11.448 8 12.0002 8H14.0002C15.1048 8 16.0002 8.89543 16.0002 10L16.0002 14C16.0002 15.1046 15.1048 16 14.0002 16L12.0002 16C11.735 16 11.4807 15.8946 11.2931 15.7071C11.1056 15.5196 11.0002 15.2652 11.0002 15L11.0002 9ZM13.0002 10V11L14.0002 11V10H13.0002ZM14.0002 13H13.0002L13.0002 14L14.0002 14L14.0002 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.0002 8H19.0002C17.8957 8 17.0002 8.89543 17.0002 10L17.0002 14C17.0002 15.1046 17.8957 16 19.0002 16L21.0002 16C21.5525 16 22.0002 15.5523 22.0002 15C22.0002 14.4477 21.5525 14 21.0002 14L19.0002 14L19.0002 10L21.0002 10C21.5525 10 22.0002 9.55228 22.0002 9C22.0002 8.44772 21.5525 8 21.0002 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    abc: {
        defaultColors: ["#3D4C66"],
        keywords: ["abc","text","inventory","item-details","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L7 9L4 15M9 13L5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L12 15L14 15C14.5523 15 15 14.5523 15 14L15 12M12 12L12 9H14C14.5523 9 15 9.44772 15 10L15 12M12 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15L18 15C17.4477 15 17 14.5523 17 14L17 10C17 9.44772 17.4477 9 18 9L20 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ac-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["air-conditioning","ac","temperature","cooling","climate","comfort","service","maintenance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 11H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 19C15.8954 19 15 18.1046 15 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19C8.10457 19 9 18.1046 9 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ac-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["air-conditioner","ac","cooling","climate-control","temperature","service","maintenance","repair"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 16C9.55228 16 10 16.4477 10 17C10 18.6569 8.65685 20 7 20C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18C7.55228 18 8 17.5523 8 17C8 16.4477 8.44772 16 9 16ZM12 16C12.5523 16 13 16.4477 13 17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V17C11 16.4477 11.4477 16 12 16ZM15 16C15.5523 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20C15.3431 20 14 18.6569 14 17C14 16.4477 14.4477 16 15 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 3L7.93417 3C7.04769 2.99995 6.28387 2.99991 5.67221 3.08215C5.0167 3.17028 4.38835 3.36902 3.87868 3.87868C3.36902 4.38835 3.17028 5.0167 3.08215 5.67221C2.99991 6.28387 2.99995 7.04769 3 7.93417L3 8V10L3 10.0658C2.99995 10.9523 2.99991 11.7161 3.08215 12.3278C3.17028 12.9833 3.36902 13.6117 3.87868 14.1213C4.38835 14.631 5.0167 14.8297 5.67221 14.9179C6.28387 15.0001 7.04769 15.0001 7.93417 15H16.0658C16.9523 15.0001 17.7161 15.0001 18.3278 14.9179C18.9833 14.8297 19.6117 14.631 20.1213 14.1213C20.631 13.6117 20.8297 12.9833 20.9179 12.3278C21.0001 11.7161 21.0001 10.9523 21 10.0658V7.9342C21.0001 7.0477 21.0001 6.28388 20.9179 5.67221C20.8297 5.0167 20.631 4.38835 20.1213 3.87868C19.6117 3.36902 18.9833 3.17028 18.3278 3.08215C17.7161 2.99991 16.9523 2.99995 16.0658 3L8 3ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12H16C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ac-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["air-conditioner","climate","environment","temperature","cooling","heating","comfort","indoor-climate","thermostat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="10"
                    rx="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 11H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 19C15.8954 19 15 18.1046 15 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19C8.10457 19 9 18.1046 9 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    ac: {
        defaultColors: ["#3D4C66"],
        keywords: ["air-conditioner","climate","environment","temperature","cooling","heating","comfort","indoor-climate","thermostat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 11H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 19C15.8954 19 15 18.1046 15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19C8.10457 19 9 18.1046 9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "acute-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["clock","time","fast","speed","delivery","late","timer","deadline","queue","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="13"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10V11C12 11.9428 12 12.4142 12.2929 12.7071C12.5858 13 13.0572 13 14 13H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 7H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 12L4 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "acute-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["time","clock","fast","delivery","order-time","service-time","quick","speed","deadline","duration","schedule","appointment","timer","late"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="13" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 10V11C12 11.9428 12 12.4142 12.2929 12.7071C12.5858 13 13.0572 13 14 13H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 7H5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17H5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 12L4 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "acute-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","waiting","delay","history","schedule","reminder","late","due","timestamp","service-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 4C9.58172 4 6 7.58172 6 12C6 16.4183 9.58172 20 14 20C18.4183 20 22 16.4183 22 12C22 7.58172 18.4183 4 14 4ZM14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10L12 11.0544C11.9999 11.4785 11.9998 11.8906 12.0455 12.2305C12.0971 12.6137 12.2226 13.051 12.5858 13.4142C12.949 13.7774 13.3863 13.903 13.7695 13.9545C14.1094 14.0002 14.5215 14.0001 14.9456 14L16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12H15C14.5003 12 14.2262 11.9979 14.036 11.9723L14.0287 11.9713L14.0277 11.964C14.0021 11.7738 14 11.4997 14 11V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    acute: {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","waiting","delay","history","schedule","reminder","late","due","timestamp","service-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="13" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 10V11C12 11.9428 12 12.4142 12.2929 12.7071C12.5858 13 13.0572 13 14 13H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 7H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 12L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["add","plus","new","create","increase","more","add-item","add-product","new-order","add-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "add-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["add","plus","new","create","increase","add-item","new-item","add-product","increase-quantity","add-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L16 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 8" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    add: {
        defaultColors: ["#3D4C66"],
        keywords: ["add","plus","new","create","increase","add-item","new-item","add-product","increase-quantity","add-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["add","plus","new","create","increase","addition","new-item","add-item","new-order","add-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L13 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11L13 11L13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8L11 11L8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H11L11 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Adobe-illustrator-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ai","artificial intelligence","settings","configuration","adobe illustrator","design","app settings","application settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "Advertisment-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["advertisement","ad","promotion","marketing","discount","offer","special-offer","campaign","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V9H14C14.9319 9 15.3978 9 15.7654 9.15224C16.2554 9.35523 16.6448 9.74458 16.8478 10.2346C17 10.6022 17 11.0681 17 12C17 12.9319 17 13.3978 16.8478 13.7654C16.6448 14.2554 16.2554 14.6448 15.7654 14.8478C15.3978 15 14.9319 15 14 15H13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Adobe-illustrator-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["AI","adobe-illustrator","software","design","graphics","image","edit","tool"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 3.25H14.0549H14.0549H14.0549C15.4225 3.24998 16.5248 3.24997 17.3918 3.36653C18.2919 3.48754 19.0497 3.74644 19.6517 4.34835C20.2536 4.95027 20.5125 5.70814 20.6335 6.60825C20.75 7.47522 20.75 8.57754 20.75 9.94513V14.0549C20.75 15.4225 20.75 16.5248 20.6335 17.3918C20.5125 18.2919 20.2536 19.0497 19.6517 19.6517C19.0497 20.2536 18.2919 20.5125 17.3918 20.6335C16.5248 20.75 15.4225 20.75 14.0549 20.75H9.94513C8.57754 20.75 7.47522 20.75 6.60825 20.6335C5.70814 20.5125 4.95027 20.2536 4.34835 19.6517C3.74644 19.0497 3.48754 18.2919 3.36653 17.3918C3.24997 16.5248 3.24998 15.4225 3.25 14.0549V14.0549V14.0549V9.94513V9.94511V9.94508C3.24998 8.57751 3.24997 7.47521 3.36653 6.60825C3.48754 5.70814 3.74644 4.95027 4.34835 4.34835C4.95027 3.74644 5.70814 3.48754 6.60825 3.36653C7.47521 3.24997 8.57751 3.24998 9.94508 3.25H9.94511H9.94513ZM16.4999 9.25C16.4999 8.83579 16.1641 8.5 15.7499 8.5C15.3357 8.5 14.9999 8.83579 14.9999 9.25V14.25C14.9999 14.6642 15.3357 15 15.7499 15C16.1641 15 16.4999 14.6642 16.4999 14.25V9.25ZM11.4655 9.00403C11.1706 8.41439 10.3292 8.41439 10.0344 9.00403L7.5791 13.9146C7.39386 14.2851 7.54403 14.7356 7.91451 14.9208C8.28499 15.1061 8.7355 14.9559 8.92074 14.5854L9.21387 13.9992C9.22582 13.9997 9.23784 14 9.24992 14H12.2864L12.5791 14.5854C12.7643 14.9559 13.2148 15.1061 13.5853 14.9208C13.9558 14.7356 14.106 14.2851 13.9207 13.9146L11.4655 9.00403ZM10.7499 10.9271L11.5364 12.5H9.96345L10.7499 10.9271Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Adobe-illustrator-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["AI","settings","configuration","preferences","system","options","administration","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Adobe-illustrator": {
        defaultColors: ["#3D4C66"],
        keywords: ["AI","adobe-illustrator","vector","design","graphic","art","create","image","logo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Advertisment-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["advertisement","ad","promotion","marketing","special-offer","deals","announcements"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V9H14C14.9319 9 15.3978 9 15.7654 9.15224C16.2554 9.35523 16.6448 9.74458 16.8478 10.2346C17 10.6022 17 11.0681 17 12C17 12.9319 17 13.3978 16.8478 13.7654C16.6448 14.2554 16.2554 14.6448 15.7654 14.8478C15.3978 15 14.9319 15 14 15H13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Advertisment-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["advertisement","ad","ads","marketing","promotion","advertise","campaign","announcement","sales","discount","special-offer","featured","highlight","publicity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 9.75C14.7262 9.75 15.0458 9.75041 15.2933 9.76729C15.534 9.78372 15.6512 9.81319 15.7284 9.84515C16.0346 9.97202 16.278 10.2154 16.4049 10.5216C16.4368 10.5988 16.4663 10.716 16.4827 10.9567C16.4996 11.2042 16.5 11.5238 16.5 12C16.5 12.4762 16.4996 12.7958 16.4827 13.0433C16.4663 13.284 16.4368 13.4012 16.4049 13.4784C16.278 13.7846 16.0346 14.028 15.7284 14.1549C15.6512 14.1868 15.534 14.2163 15.2933 14.2327C15.0458 14.2496 14.7262 14.25 14.25 14.25H14V9.75H14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M10 11.25H7.5V9.75H10V11.25Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 3.25H14.0549C15.4225 3.24998 16.5248 3.24997 17.3918 3.36653C18.2919 3.48754 19.0497 3.74644 19.6517 4.34835C20.2536 4.95027 20.5125 5.70814 20.6335 6.60825C20.75 7.47522 20.75 8.57754 20.75 9.94513V14.0549C20.75 15.4225 20.75 16.5248 20.6335 17.3918C20.5125 18.2919 20.2536 19.0497 19.6517 19.6517C19.0497 20.2536 18.2919 20.5125 17.3918 20.6335C16.5248 20.75 15.4225 20.75 14.0549 20.75H9.94513C8.57754 20.75 7.47522 20.75 6.60825 20.6335C5.70814 20.5125 4.95027 20.2536 4.34835 19.6517C3.74644 19.0497 3.48754 18.2919 3.36653 17.3918C3.24997 16.5248 3.24998 15.4225 3.25 14.0549V9.94513C3.24998 8.57755 3.24997 7.47521 3.36653 6.60825C3.48754 5.70814 3.74644 4.95027 4.34835 4.34835C4.95027 3.74644 5.70814 3.48754 6.60825 3.36653C7.47521 3.24997 8.57755 3.24998 9.94513 3.25ZM16.3024 8.45933C16.012 8.33905 15.7125 8.29241 15.3954 8.27077C15.0908 8.24999 14.7197 8.24999 14.2753 8.25H13.25C12.8358 8.25 12.5 8.58579 12.5 9V15C12.5 15.4142 12.8358 15.75 13.25 15.75H14.2753C14.7197 15.75 15.0908 15.75 15.3954 15.7292C15.7125 15.7076 16.012 15.661 16.3024 15.5407C16.9762 15.2616 17.5116 14.7262 17.7907 14.0524C17.911 13.762 17.9576 13.4625 17.9792 13.1454C18 12.8408 18 12.4697 18 12.0253V11.9747C18 11.5303 18 11.1592 17.9792 10.8546C17.9576 10.5375 17.911 10.238 17.7907 9.94762C17.5116 9.27379 16.9762 8.73844 16.3024 8.45933ZM6.75 8.25C6.33579 8.25 6 8.58579 6 9V15C6 15.4142 6.33579 15.75 6.75 15.75C7.16421 15.75 7.5 15.4142 7.5 15V12.75H10V15C10 15.4142 10.3358 15.75 10.75 15.75C11.1642 15.75 11.5 15.4142 11.5 15V9C11.5 8.58579 11.1642 8.25 10.75 8.25H6.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["aim","target","focus","search","find","locate","selection","precision","crosshairs","bullseye","cursor","gps","location","tracking","navigate","accuracy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["target","aim","focus","search","find","locate","precision","accuracy","customer-search","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["aim","target","focus","search","find","locate","scan","tracking","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.938C14.8095 19.7122 16.432 18.8817 17.6569 17.6569C18.8817 16.432 19.7122 14.8095 19.938 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V4ZM11.0033 6.0824C11.0452 6.59614 11.4755 7 12 7C12.5245 7 12.9548 6.59614 12.9967 6.0824C15.5119 6.5029 17.4971 8.48814 17.9176 11.0033C17.4039 11.0452 17 11.4755 17 12C17 12.5246 17.4039 12.9548 17.9177 12.9967C17.7077 14.2541 17.1068 15.3785 16.2426 16.2426C15.3785 17.1068 14.2541 17.7077 12.9967 17.9177C12.9548 17.4039 12.5246 17 12 17C11.4755 17 11.0452 17.4039 11.0033 17.9176C8.48814 17.4971 6.5029 15.5119 6.0824 12.9967C6.59614 12.9548 7 12.5245 7 12C7 11.4755 6.59614 11.0452 6.0824 11.0033C6.5029 8.48814 8.48814 6.5029 11.0033 6.0824Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","locate","search","find","customer-lookup","item-search","order-lookup","customer","item","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["target","aim","focus","search","find","locate","item-lookup","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12H20M4 12H5M12 5V4M12 20V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["aim","target","focus","search","find","locate","precision","accuracy","scan","lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12H20M4 12H5M12 5V4M12 20V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","location","find","search","customer","locator","precision","pinpoint","bullseye","accuracy","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V4ZM18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Advertisment: {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","location","find","search","customer","locator","precision","pinpoint","bullseye","accuracy","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V9H14C14.9319 9 15.3978 9 15.7654 9.15224C16.2554 9.35523 16.6448 9.74458 16.8478 10.2346C17 10.6022 17 11.0681 17 12C17 12.9319 17 13.3978 16.8478 13.7654C16.6448 14.2554 16.2554 14.6448 15.7654 14.8478C15.3978 15 14.9319 15 14 15H13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","location","find","customer","analytics","accuracy","precision","search","bullseye","goal","objective","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12H20M4 12H5M12 5V4M12 20V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["target","aim","focus","search","find","locate","customer","customer-search","product-search","lookup","item-lookup","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12H20M4 12H6M12 6V4M12 20V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["aim","target","focus","select","find","locate","search","customer","identify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12H20M4 12H6M12 6V4M12 20V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","search","find","locate","customer","loyalty","selection","analysis","targeting","marketing","promotion","sale","search-customer","locate-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V4ZM11.0033 6.0824C11.0452 6.59614 11.4755 7 12 7C12.5245 7 12.9548 6.59614 12.9967 6.0824C15.5119 6.5029 17.4971 8.48814 17.9176 11.0033C17.4039 11.0452 17 11.4755 17 12C17 12.5245 17.4039 12.9548 17.9176 12.9967C17.4971 15.5119 15.5119 17.4971 12.9967 17.9176C12.9548 17.4039 12.5245 17 12 17C11.4755 17 11.0452 17.4039 11.0033 17.9176C8.48814 17.4971 6.5029 15.5119 6.0824 12.9967C6.59614 12.9548 7 12.5245 7 12C7 11.4755 6.59614 11.0452 6.0824 11.0033C6.5029 8.48814 8.48814 6.5029 11.0033 6.0824Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","selection","bullseye","search","find","lookup","locate","filter","customer","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12H20M4 12H6M12 6V4M12 20V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["target","aim","focus","location","find","search","navigate","customer","employee","item","product","pin","selection","precision"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12H20M4 12H8M12 8V4M12 20V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Aim 5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["target","aim","focus","select","find","location","search","navigation","locator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H20M4 12H8M12 8V4M12 20V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","select","location","find","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V7.10002C9.04087 7.4977 7.4977 9.04087 7.10002 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H7.10002C7.4977 14.9591 9.04087 16.5023 11 16.9V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V16.9C14.9591 16.5023 16.5023 14.9591 16.9 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H16.9C16.5023 9.04087 14.9591 7.4977 13 7.10002V4ZM15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["aim","target","focus","search","find","locate","sku-lookup","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H19M12 17V19M5 12H7M12 7V5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","location","find","select","search","position","center","cursor","pin","map","gps","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H20M4 12H8M12 8V4M12 20V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["aim","target","focus","search","find","locate","scan","precision","accuracy","customer-search","product-search","order-search","report-search","location","gps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H19M12 17V19M5 12H7M12 7V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim-slash 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["disabled","inactive","not-available","unavailable","blocked","restricted","forbidden","canceled","void","voided","rejected","error","invalid","unsuccessful","failed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12H20M12 19V20M4 12H5M12 5V4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim-slash 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["target","aim","slash","blocked","disabled","unavailable","out-of-stock","deactivate","remove-target","aim-slash","disable-promotion","deactivate-coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12H20M12 19V20M4 12H5M12 5V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","focus","search","find","locate","selection","precision","inventory-check","item-lookup","customer-search","scan","barcode","qr-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.2089 20 16.2102 19.1035 17.6569 17.6569C19.1035 16.2102 20 14.2089 20 12C20 7.58172 16.4183 4 12 4ZM11 6.08296V7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7V6.08296C15.5125 6.50448 17.4955 8.48749 17.917 11H17C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13H17.9172C17.7066 14.2561 17.106 15.3793 16.2426 16.2426C15.3793 17.106 14.2561 17.7066 13 17.9172V17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17V17.917C8.48749 17.4955 6.50448 15.5125 6.08296 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H6.08296C6.50448 8.48749 8.48749 6.50448 11 6.08296Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim-slash 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["disabled","deactivated","unavailable","blocked","decline","reject","invalid","error","target-off","aim-off","cancel-order","stop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12H20M12 19V20M4 12H5M12 5V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Aim-slash 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","slash","disabled","cancel","void","unavailable","invalid","error","restriction","prohibited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C12.5523 3 13 3.44772 13 4V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.938C19.8184 13.9586 19.5291 14.8647 19.1013 15.6871L17.5926 14.1784C17.8557 13.5032 18 12.7687 18 12C18 8.68629 15.3137 6 12 6C11.2317 6 10.497 6.14442 9.82182 6.40761L8.31276 4.89854C9.13516 4.47066 10.0412 4.18145 11 4.06189V4C11 3.44772 11.4477 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 11.4477 3.44772 11 4 11H4.06189C4.24404 9.53929 4.81999 8.20088 5.68014 7.09436L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L16.9056 18.3198C15.7994 19.1795 14.4606 19.7557 13 19.938V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C7.38128 19.4869 4.51314 16.6187 4.06189 13H4C3.44772 13 3 12.5523 3 12ZM15.4766 16.8908L14.0318 15.446C13.4364 15.7977 12.7414 16 12 16C9.79086 16 8 14.2091 8 12C8 11.2582 8.20193 10.5635 8.55382 9.96803L7.10925 8.52347C6.41079 9.50428 6 10.7042 6 12C6 15.3137 8.68629 18 12 18C13.2963 18 14.4955 17.5897 15.4766 16.8908ZM10.0677 11.482C10.0236 11.6472 10 11.8208 10 12C10 13.1046 10.8954 14 12 14C12.1793 14 12.353 13.9765 12.5182 13.9324L10.0677 11.482Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9626 12.5484L11.4515 8.03729C11.6308 8.0127 11.8139 8 12 8C14.2091 8 16 9.79086 16 12C16 12.186 15.9873 12.3691 15.9626 12.5484Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Aim-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["target","slash","blocked","disable","unavailable","invalid","cancel","remove","hide","delete","error","not-found","issue","problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 6V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Aim-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["aim","slash","disable","deactivate","target","cancel","stop","invalid","error","blocked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 6V4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Aim-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","slash","disabled","inactive","unavailable","not-available","cancel","remove","delete","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H4.06189C4.24404 14.4607 4.81999 15.7991 5.68014 16.9056L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L16.9056 5.68014C15.7991 4.81999 14.4607 4.24404 13 4.06189V4ZM15.4765 7.10925C14.7527 6.59381 13.9096 6.23503 12.9967 6.0824C12.9548 6.59614 12.5245 7 12 7C11.4755 7 11.0452 6.59614 11.0033 6.0824C8.48814 6.5029 6.5029 8.48814 6.0824 11.0033C6.59614 11.0452 7 11.4755 7 12C7 12.5245 6.59614 12.9548 6.0824 12.9967C6.23503 13.9096 6.59381 14.7527 7.10925 15.4765L8.55382 14.032C8.20193 13.4365 8 12.7418 8 12C8 9.79086 9.79086 8 12 8C12.7418 8 13.4365 8.20193 14.032 8.55382L15.4765 7.10925ZM12.518 10.0677C12.3528 10.0236 12.1792 10 12 10C10.8954 10 10 10.8954 10 12C10 12.1792 10.0236 12.3528 10.0677 12.518L12.518 10.0677Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 17C12.5245 17 12.9548 17.4039 12.9967 17.9176C15.5119 17.4971 17.4971 15.5119 17.9176 12.9967C17.4039 12.9548 17 12.5245 17 12C17 11.4755 17.4039 11.0452 17.9176 11.0033C17.8492 10.594 17.7393 10.1987 17.5924 9.82182L19.1015 8.31276C19.5293 9.13516 19.8186 10.0412 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.9381C19.4869 16.6187 16.6187 19.4869 13 19.9381V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C10.0412 19.8186 9.13516 19.5293 8.31276 19.1015L9.82182 17.5924C10.1987 17.7393 10.594 17.8492 11.0033 17.9176C11.0452 17.4039 11.4755 17 12 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.4515 15.9627L15.9627 11.4515C15.9873 11.6308 16 11.8139 16 12C16 14.2091 14.2091 16 12 16C11.8139 16 11.6308 15.9873 11.4515 15.9627Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Aim: {
        defaultColors: ["#3D4C66"],
        keywords: ["target","aim","slash","disabled","inactive","unavailable","not-available","cancel","remove","delete","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H19M12 17V19M5 12H7M12 7V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Aim-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","slash","cancelled","unavailable","blocked","disabled","inactive","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 6V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Air-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wind","air","breeze","weather","environment","airflow","ventilation","forecast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C15.1046 9 16 8.10457 16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 15C11.1046 15 12 15.8954 12 17C12 18.1046 11.1046 19 10 19C8.89543 19 8 18.1046 8 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12C18.6569 12 20 13.3431 20 15C20 16.6569 18.6569 18 17 18C15.3431 18 14 16.6569 14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Air-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["air","wind","breeze","circulation","ventilation","refresh","temperature","airflow","exhaust","cool","dry","clean","purify","settings","options","change","system","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C15.1046 9 16 8.10457 16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 15C11.1046 15 12 15.8954 12 17C12 18.1046 11.1046 19 10 19C8.89543 19 8 18.1046 8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L8 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12C18.6569 12 20 13.3431 20 15C20 16.6569 18.6569 18 17 18C15.3431 18 14 16.6569 14 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C18.6569 12 20 13.3431 20 15C20 16.6569 18.6569 18 17 18C15.3431 18 14 16.6569 14 15C14 13.3431 15.3431 12 17 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Air-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["air","wind","weather","condition","environmental","ventilation","airflow","temperature","outside"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6C13.5511 6 13.1688 6.29657 13.0434 6.7068C12.8819 7.23496 12.3229 7.5322 11.7947 7.37073C11.2666 7.20925 10.9693 6.6502 11.1308 6.12204C11.5061 4.89456 12.6473 4 14 4C15.6569 4 17 5.34315 17 7C17 8.65685 15.6569 10 14 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H14C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6ZM8 12C8 11.4477 8.44772 11 9 11H18C20.2091 11 22 12.7909 22 15C22 17.2091 20.2091 19 18 19C16.0672 19 14.4565 17.6301 14.082 15.8088C14.0281 15.5468 14 15.2762 14 15C14 14.4477 14.4477 14 15 14C15.5523 14 16 14.4477 16 15C16 15.1401 16.0142 15.2757 16.041 15.406C16.2282 16.316 17.0353 17 18 17C19.1046 17 20 16.1046 20 15C20 13.8954 19.1046 13 18 13H9C8.44772 13 8 12.5523 8 12ZM3 15C3 14.4477 3.44772 14 4 14H10C11.6569 14 13 15.3431 13 17C13 18.6569 11.6569 20 10 20C8.77621 20 7.72572 19.2673 7.25912 18.2209C7.03421 17.7165 7.26079 17.1252 7.76521 16.9003C8.26962 16.6754 8.86086 16.902 9.08577 17.4064C9.24258 17.7581 9.59413 18 10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16H4C3.44772 16 3 15.5523 3 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "airpods-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","package","container","inventory","stock","storage","warehouse","products","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 11L19 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 13H10C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9H14C15.1046 9 16 9.89543 16 11C16 12.1046 15.1046 13 14 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "airpods-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["airpods","earbuds","audio","headphones","wireless","device","accessory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L19 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 13H10C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9H14C15.1046 9 16 9.89543 16 11C16 12.1046 15.1046 13 14 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Air: {
        defaultColors: ["#3D4C66"],
        keywords: ["airpods","earbuds","audio","headphones","wireless","device","accessory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C15.1046 9 16 8.10457 16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 15C11.1046 15 12 15.8954 12 17C12 18.1046 11.1046 19 10 19C8.89543 19 8 18.1046 8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12C18.6569 12 20 13.3431 20 15C20 16.6569 18.6569 18 17 18C15.3431 18 14 16.6569 14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    airpods: {
        defaultColors: ["#3D4C66"],
        keywords: ["airpods","earbuds","audio","headphones","wireless","device","accessory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 11L19 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 13H10C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9H14C15.1046 9 16 9.89543 16 11C16 12.1046 15.1046 13 14 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "alarm-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alarm","add","plus","reminder","set-reminder","create-reminder","new-reminder","notification","schedule","add-schedule","create-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 10V12H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12L10 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 5L4 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 5L20 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "alarm-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["alarm","add","plus","reminder","new-reminder","set-alarm","create-alarm","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10V12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 5L4 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 5L20 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "airpods-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","chain","connection","affiliate","relation","connected","linked-item","linked-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C4.02831 8.24768 4.00673 9.05535 4.0016 10H7.17071C7.58254 8.83481 8.69378 8 10 8H14C15.3062 8 16.4175 8.83481 16.8293 10H19.9984C19.9933 9.05535 19.9717 8.24768 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 10.7655V12H16.8293C16.4175 13.1652 15.3062 14 14 14H10C8.69378 14 7.58254 13.1652 7.17071 12H4V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 10.8744 20 10.8197 20 10.7655Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 11C9 10.4477 9.44772 10 10 10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H10C9.44772 12 9 11.5523 9 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "alarm-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alarm","add","plus","reminder","new-reminder","create-reminder","schedule","add-schedule","new-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70711 4.29289C6.09763 4.68342 6.09763 5.31658 5.70711 5.70711L3.70711 7.70711C3.31658 8.09763 2.68342 8.09763 2.29289 7.70711C1.90237 7.31658 1.90237 6.68342 2.29289 6.29289L4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 9C12.5523 9 13 9.44772 13 10V11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44771 11 10 11H11V10C11 9.44772 11.4477 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.2929 4.29289C17.9024 4.68342 17.9024 5.31658 18.2929 5.70711L20.2929 7.70711C20.6834 8.09763 21.3166 8.09763 21.7071 7.70711C22.0976 7.31658 22.0976 6.68342 21.7071 6.29289L19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "alarm-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["alarm","clock","add","plus","reminder","schedule","new-appointment","new-reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 10V12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 5L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 5L20 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ufo","alien","ship","delivery","fast-delivery","express-delivery","future","technology","innovation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.14286 10L4.90447 11.2516C4.4856 13.4506 4.27617 14.5501 4.87606 15.2751C5.47595 16 6.59524 16 8.83382 16H15.1662C17.4048 16 18.5241 16 19.1239 15.2751C19.7238 14.5501 19.5144 13.4506 19.0955 11.2516L18.8571 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10V9C17 6.23858 14.7614 4 12 4V4C9.23858 4 7 6.23858 7 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 19L15 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alien","ship","ufo","pickup","delivery","special-order","exotic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="4"
                    width="10"
                    height="11"
                    rx="5"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4.90447 11.2516L5.14286 10H18.8571L19.0955 11.2516C19.5144 13.4506 19.7238 14.5501 19.1239 15.2751C18.5241 16 17.4048 16 15.1662 16H8.83382C6.59524 16 5.47595 16 4.87606 15.2751C4.27617 14.5501 4.4856 13.4506 4.90447 11.2516Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M4.90447 11.2516L4.16771 11.1112L4.90447 11.2516ZM19.0955 11.2516L19.8323 11.1112L19.8323 11.1112L19.0955 11.2516ZM4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75V9.25ZM20 10.75C20.4142 10.75 20.75 10.4142 20.75 10C20.75 9.58579 20.4142 9.25 20 9.25V10.75ZM4.4061 9.85967L4.16771 11.1112L5.64122 11.3919L5.87961 10.1403L4.4061 9.85967ZM8.83382 16.75H15.1662V15.25H8.83382V16.75ZM19.8323 11.1112L19.5939 9.85967L18.1204 10.1403L18.3588 11.3919L19.8323 11.1112ZM15.1662 16.75C16.2623 16.75 17.1655 16.7518 17.8656 16.6519C18.5861 16.549 19.2318 16.3212 19.7018 15.7532L18.5461 14.7969C18.4162 14.9539 18.2023 15.0886 17.6536 15.1669C17.0844 15.2482 16.3086 15.25 15.1662 15.25V16.75ZM18.3588 11.3919C18.5725 12.5141 18.7159 13.2765 18.7426 13.8509C18.7683 14.4046 18.676 14.6399 18.5461 14.7969L19.7018 15.7532C20.1718 15.1852 20.2747 14.5084 20.241 13.7813C20.2082 13.0749 20.0374 12.188 19.8323 11.1112L18.3588 11.3919ZM4.16771 11.1112C3.96261 12.188 3.79183 13.0749 3.75904 13.7813C3.72528 14.5084 3.82824 15.1852 4.29824 15.7532L5.45388 14.7969C5.32398 14.6399 5.23172 14.4046 5.25742 13.8509C5.28409 13.2765 5.42746 12.5141 5.64122 11.3919L4.16771 11.1112ZM8.83382 15.25C7.6914 15.25 6.91563 15.2482 6.34645 15.1669C5.79772 15.0886 5.58377 14.9539 5.45388 14.7969L4.29824 15.7532C4.76824 16.3212 5.41388 16.549 6.13442 16.6519C6.83449 16.7518 7.73767 16.75 8.83382 16.75V15.25ZM4 10.75H5.14286V9.25H4V10.75ZM5.14286 10.75H18.8571V9.25H5.14286V10.75ZM18.8571 10.75H20V9.25H18.8571V10.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16 19L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","ship","ufo","future","science","technology","delivery","futuristic-delivery","space","unidentified-object","unknown-source"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17.5C11.45 17.5 11 17.95 11 18.5V20.5C11 21.05 11.45 21.5 12 21.5C12.55 21.5 13 21.05 13 20.5L13 18.5C13 17.95 12.55 17.5 12 17.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29 17.79L7.29 18.79C6.9 19.18 6.9 19.81 7.29 20.2C7.68 20.59 8.31 20.59 8.7 20.2L9.7 19.2C10.09 18.81 10.09 18.18 9.7 17.79C9.31 17.4 8.68 17.4 8.29 17.79Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.71 17.79C15.32 17.4 14.69 17.4 14.3 17.79C13.91 18.18 13.91 18.81 14.3 19.2L15.3 20.2C15.69 20.59 16.32 20.59 16.71 20.2C17.1 19.81 17.1 19.18 16.71 18.79L15.71 17.79Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.75 10C20.75 9.59 20.41 9.25 20 9.25H18V9C18 5.69 15.31 3 12 3C8.69 3 6 5.69 6 9V9.25H4C3.59 9.25 3.25 9.59 3.25 10C3.25 10.41 3.59 10.75 4 10.75H4.24L4.17 11.11V11.17C3.96 12.22 3.79 13.09 3.76 13.78C3.73 14.51 3.83 15.18 4.3 15.75C4.77 16.32 5.42 16.55 6.14 16.65C6.83 16.75 7.71 16.75 8.78 16.75H15.23C16.3 16.75 17.18 16.75 17.87 16.65C18.59 16.55 19.24 16.32 19.71 15.75C20.18 15.18 20.28 14.51 20.25 13.78C20.22 13.09 20.05 12.22 19.85 11.17L19.77 10.75H20.01C20.42 10.75 20.76 10.41 20.76 10H20.75ZM8 9C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9V9.25H8V9ZM10 14C9.45 14 9 13.55 9 13C9 12.45 9.45 12 10 12H14C14.55 12 15 12.45 15 13C15 13.55 14.55 14 14 14H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Alien-ship 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","ship","ufo","future","delivery","express","fast","unusual","special"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.14286 10L4.90447 11.2516C4.4856 13.4506 4.27617 14.5501 4.87606 15.2751C5.47595 16 6.59524 16 8.83382 16H15.1662C17.4048 16 18.5241 16 19.1239 15.2751C19.7238 14.5501 19.5144 13.4506 19.0955 11.2516L18.8571 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10V9C17 6.23858 14.7614 4 12 4V4C9.23858 4 7 6.23858 7 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 19L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["alien","ship","delivery","robot","future","technology","automation","transport","autonomous","drone","automated-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11H7C6.05719 11 5.58579 11 5.29289 11.2929C5.29289 11.2929 5.29289 11.2929 5.29289 11.2929C5 11.5858 5 12.0572 5 13V13C5 14.8856 5 15.8284 5.58579 16.4142C5.58579 16.4142 5.58579 16.4142 5.58579 16.4142C6.17157 17 7.11438 17 9 17L15 17C16.8856 17 17.8284 17 18.4142 16.4142C18.4142 16.4142 18.4142 16.4142 18.4142 16.4142C19 15.8284 19 14.8856 19 13V13C19 12.0572 19 11.5858 18.7071 11.2929C18.7071 11.2929 18.7071 11.2929 18.7071 11.2929C18.4142 11 17.9428 11 17 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14H16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","ship","ufo","future","unknown","extraterrestrial","reward","loyalty","fun","gift","promotion","game"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7002 11.8C19.6502 11.44 19.5402 11.07 19.2302 10.76C18.9202 10.45 18.5502 10.34 18.1902 10.29C18.1302 10.29 18.0602 10.29 17.9902 10.28V10C17.9902 6.69 15.3002 4 11.9902 4C8.68023 4 5.99023 6.69 5.99023 10V10.28C5.93023 10.28 5.85023 10.28 5.79023 10.29C5.43023 10.34 5.06023 10.45 4.75023 10.76C4.44023 11.07 4.33024 11.44 4.28024 11.8C4.24024 12.12 4.24023 12.52 4.24023 12.95V13.05C4.24023 13.95 4.24024 14.7 4.32024 15.29C4.40024 15.92 4.59024 16.48 5.05024 16.94C5.51024 17.4 6.07023 17.58 6.70023 17.67C6.81023 17.68 6.93024 17.69 7.05024 17.7C6.94024 18.04 7.01023 18.43 7.29023 18.7C7.68023 19.09 8.31023 19.09 8.70023 18.7L9.66023 17.74H11.0002V18.99C11.0002 19.54 11.4502 20 12.0002 20C12.5502 20 13.0002 19.54 13.0002 18.99V17.74H14.3402L15.3002 18.7C15.6902 19.09 16.3202 19.09 16.7102 18.7C16.9802 18.43 17.0502 18.04 16.9502 17.7C17.0702 17.7 17.1902 17.68 17.3002 17.67C17.9302 17.59 18.4902 17.4 18.9502 16.94C19.4102 16.48 19.5902 15.92 19.6802 15.29C19.7602 14.7 19.7602 13.95 19.7602 13.05V12.95C19.7602 12.52 19.7602 12.12 19.7202 11.8H19.7002ZM6.99023 14C6.99023 13.45 7.44023 13 7.99023 13H8.99023C9.54023 13 9.99023 13.45 9.99023 14C9.99023 14.55 9.54023 15 8.99023 15H7.99023C7.72023 15 7.49023 14.89 7.31023 14.72C7.26023 14.65 7.21023 14.58 7.16023 14.51C7.06023 14.36 6.99023 14.19 6.99023 13.99V14ZM16.6302 14.75C16.4602 14.9 16.2402 15 15.9902 15H14.9902C14.4402 15 13.9902 14.55 13.9902 14C13.9902 13.45 14.4402 13 14.9902 13H15.9902C16.5402 13 16.9902 13.45 16.9902 14C16.9902 14.14 16.9602 14.27 16.9102 14.39C16.8202 14.52 16.7202 14.64 16.6202 14.76L16.6302 14.75ZM11.9902 6C14.2002 6 15.9902 7.79 15.9902 10V10.25H7.99023V10C7.99023 7.79 9.78023 6 11.9902 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Alien-ship-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ufo","alien","space","delivery","future","technology","advanced","ship","transport","science-fiction","unidentified","unknown","new","arrival"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Alien-ship 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alien","ship","delivery","order","space","express","fast","Sci-fi","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="5"
                    width="10"
                    height="11"
                    rx="5"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17H15C16.8856 17 17.8284 17 18.4142 16.4142C19 15.8284 19 14.8856 19 13C19 12.0572 19 11.5858 18.7071 11.2929C18.4142 11 17.9428 11 17 11H7C6.05719 11 5.58579 11 5.29289 11.2929C5 11.5858 5 12.0572 5 13C5 14.8856 5 15.8284 5.58579 16.4142C6.17157 17 7.11438 17 9 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alien","ship","space","ufo","unidentified","flying","object","special-order","unique-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="4"
                    width="10"
                    height="11"
                    rx="5"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13C4 14.1046 7.58172 15 12 15C14.2091 15 16.2091 14.7761 17.6569 14.4142C19.1046 14.0523 20 13.5523 20 13C20 11.8954 16.4183 11 12 11C7.58172 11 4 11.8954 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Alien-ship 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ufo","alien","ship","future","delivery","transport","fast-delivery","robot","automated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11H7C6.05719 11 5.58579 11 5.29289 11.2929C5.29289 11.2929 5.29289 11.2929 5.29289 11.2929C5 11.5858 5 12.0572 5 13V13C5 14.8856 5 15.8284 5.58579 16.4142C5.58579 16.4142 5.58579 16.4142 5.58579 16.4142C6.17157 17 7.11438 17 9 17L15 17C16.8856 17 17.8284 17 18.4142 16.4142C18.4142 16.4142 18.4142 16.4142 18.4142 16.4142C19 15.8284 19 14.8856 19 13V13C19 12.0572 19 11.5858 18.7071 11.2929C18.7071 11.2929 18.7071 11.2929 18.7071 11.2929C18.4142 11 17.9428 11 17 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Alien-ship-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","ship","spaceship","gift","special-order","unique","unusual","discount","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9V10C18 10.2137 17.9888 10.4248 17.967 10.6327C18.7062 10.8217 19.3721 11.0603 19.8801 11.3606C20.3367 11.6305 21 12.152 21 13C21 13.848 20.3367 14.3695 19.8801 14.6394C19.3566 14.9488 18.6656 15.1928 17.8994 15.3844C16.3516 15.7713 14.2663 16 12 16C9.73373 16 7.64843 15.7713 6.10061 15.3844C5.33439 15.1928 4.64339 14.9488 4.11985 14.6394C3.66326 14.3695 3 13.848 3 13C3 12.152 3.66326 11.6305 4.11985 11.3606C4.62794 11.0603 5.29375 10.8217 6.03297 10.6327C6.01117 10.4248 6 10.2137 6 10V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 17.2929C10.0976 17.6834 10.0976 18.3166 9.70711 18.7071L8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071C6.90237 19.3166 6.90237 18.6834 7.29289 18.2929L8.29289 17.2929C8.68342 16.9024 9.31658 16.9024 9.70711 17.2929ZM12 17C12.5523 17 13 17.4477 13 18L13 20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20L11 18C11 17.4477 11.4477 17 12 17ZM14.2929 17.2934C14.6834 16.9029 15.3166 16.9029 15.7071 17.2934L16.7071 18.2934C17.0976 18.6839 17.0976 19.3171 16.7071 19.7076C16.3166 20.0981 15.6834 20.0981 15.2929 19.7076L14.2929 18.7076C13.9024 18.3171 13.9024 17.6839 14.2929 17.2934Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Alien-ship-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","spaceship","ufo","delivery","unusual","special","unique","discount","promotion","rare","event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 18.9995L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Alien-ship-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alien","ship","space","delivery","fast","futuristic","promotion","special-offer","unique","rare-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="5"
                    width="10"
                    height="11"
                    rx="5"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13C4 14.1046 7.58172 15 12 15C14.2091 15 16.2091 14.7761 17.6569 14.4142C19.1046 14.0523 20 13.5523 20 13C20 11.8954 16.4183 11 12 11C7.58172 11 4 11.8954 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16 18.9995L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Alien-ship-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["alien","ship","ufo","special-order","unique-item","novelty-item","custom-order","rare-item","gift","toy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.75 11.58C19.29 11.31 18.68 11.09 18 10.91V10.01C18 6.70001 15.31 4 12 4C8.69 4 6 6.70001 6 10.01V10.91C5.31 11.09 4.7 11.31 4.25 11.58C3.81 11.84 3.25 12.3 3.25 13C3.25 13.7 3.8 14.16 4.25 14.42C4.74 14.71 5.41 14.95 6.16 15.14C7.68 15.52 9.75 15.75 12 15.75C14.25 15.75 16.32 15.52 17.84 15.14C18.6 14.95 19.26 14.71 19.75 14.42C20.19 14.16 20.75 13.7 20.75 13C20.75 12.3 20.2 11.84 19.75 11.58ZM12 6.00001C14.21 6.00001 16 7.79001 16 10V10.52C14.8 10.35 13.45 10.25 12 10.25C10.55 10.25 9.2 10.35 8 10.52V10C8 7.79001 9.79 6.00001 12 6.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.8028 16.6056C15.2968 16.3586 15.8974 16.5588 16.1444 17.0528L16.8944 18.5528C17.1414 19.0468 16.9412 19.6474 16.4472 19.8944C15.9532 20.1414 15.3526 19.9412 15.1056 19.4472L14.3556 17.9472C14.1086 17.4532 14.3088 16.8526 14.8028 16.6056Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.19721 16.6056C9.69119 16.8526 9.89142 17.4532 9.64443 17.9472L8.89443 19.4472C8.64744 19.9412 8.04677 20.1414 7.55279 19.8944C7.05881 19.6474 6.85858 19.0468 7.10557 18.5528L7.85557 17.0528C8.10256 16.5588 8.70324 16.3586 9.19721 16.6056Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Alien-ship": {
        defaultColors: ["#3D4C66"],
        keywords: ["ufo","alien","ship","promotion","discount","special-offer","coupon","voucher","event","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 18L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 18L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "align-center-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["align","text","format","center","justification","layout","settings","receipt","invoice","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 6H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 18H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-center-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["align","alignment","text","format","justify","list","options","center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 6H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 18H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-justify-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","list","options","navigation","hamburger","align","justify","settings","filter","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-center-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","center","text","layout","format","paragraph","justification","align-center","table","row"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 6C7 5.44772 7.44772 5 8 5H16C16.5523 5 17 5.44772 17 6C17 6.55228 16.5523 7 16 7H8C7.44772 7 7 6.55228 7 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 18C7 17.4477 7.44772 17 8 17H16C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H19C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Alien-ship-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alien","ship","spaceship","ufo","unknown","extraterrestrial","special-order","custom-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11V10C17 7.23858 14.7614 5 12 5V5C9.23858 5 7 7.23858 7 10V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 14.4142L17.8388 15.1418L17.6569 14.4142ZM12 14.25C9.83371 14.25 7.89769 14.0298 6.52505 13.6866C5.83296 13.5136 5.32609 13.3195 5.0103 13.1328C4.64431 12.9165 4.75 12.8473 4.75 13H3.25C3.25 13.705 3.80341 14.1619 4.24706 14.4241C4.74092 14.716 5.40562 14.9529 6.16124 15.1418C7.68404 15.5225 9.74801 15.75 12 15.75V14.25ZM4.75 13C4.75 13.1527 4.64431 13.0835 5.0103 12.8672C5.32609 12.6805 5.83296 12.4864 6.52505 12.3134C7.89769 11.9702 9.83371 11.75 12 11.75V10.25C9.74801 10.25 7.68404 10.4775 6.16124 10.8582C5.40562 11.0471 4.74092 11.284 4.24706 11.5759C3.80341 11.8381 3.25 12.295 3.25 13H4.75ZM12 11.75C14.1663 11.75 16.1023 11.9702 17.475 12.3134C18.167 12.4864 18.6739 12.6805 18.9897 12.8672C19.3557 13.0835 19.25 13.1527 19.25 13H20.75C20.75 12.295 20.1966 11.8381 19.7529 11.5759C19.2591 11.284 18.5944 11.0471 17.8388 10.8582C16.316 10.4775 14.252 10.25 12 10.25V11.75ZM19.25 13C19.25 12.8473 19.3557 12.9165 18.9897 13.1328C18.6739 13.3195 18.167 13.5136 17.475 13.6866L17.8388 15.1418C18.5944 14.9529 19.2591 14.716 19.7529 14.4241C20.1966 14.1619 20.75 13.705 20.75 13H19.25ZM17.475 13.6866C16.1023 14.0298 14.1663 14.25 12 14.25V15.75C14.252 15.75 16.316 15.5225 17.8388 15.1418L17.475 13.6866Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 18.9995L15 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L9 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "align-justify-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","list","options","settings","navigation","hamburger-menu","layout","alignment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-center": {
        defaultColors: ["#3D4C66"],
        keywords: ["align-center","format","text","paragraph","layout","justification","arrangement","sort","order","list","content","edit","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 6H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 18H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-justify-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","list","hamburger","navigation","options","settings","categories","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15C4 14.4477 4.44772 14 5 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H5C4.44772 16 4 15.5523 4 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H19C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "align-justify-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["disabled","inactive","unavailable","disable","remove","block","not-available","deactivate","lines-crossed","restriction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70711 19.7071L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L17.5858 5H5C4.44772 5 4 5.44772 4 6C4 6.55228 4.44772 7 5 7H15.5858L14.5858 8H5C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H12.5858L11.5858 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H9.58579L8.58579 14H5C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H6.58579L5.58579 17H5C4.44772 17 4 17.4477 4 18C4 18.1821 4.04868 18.3529 4.13374 18.4999C3.91264 18.8824 3.96569 19.3799 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.4142 11L14.4142 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H16.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.4142 14L11.4142 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H13.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.4142 17L8.41421 19H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H10.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.3509 8.0633L17.4142 10H19C19.5523 10 20 9.55228 20 9C20 8.57119 19.7301 8.20542 19.3509 8.0633Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "align-justify-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","disable-list","remove-list","hide-list","delete-list","filter-off","deactivate-filters","clear-filters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-justify": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","categories","align","justify","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-justify-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","disabled","unavailable","settings","options","hidden","align","justify","slash","cancel","remove","hide","off","deactivate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","align","details","options","order-details","receipt","invoice","menu","transaction","report","alignment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12H5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 6H5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 18H5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-justify-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","remove","disable","delete-list","hide-list","disable-listing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","align","details","order-details","sales-details","receipt","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","align","left","menu","options","configuration","settings","display","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 6H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 18H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","list","menu","options","settings","details","summary","layout","arrangement","sort","filter","inventory","stock","items","products","categories","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6C4 5.44772 4.44772 5 5 5H13C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7H5C4.44772 7 4 6.55228 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 12C4 11.4477 4.44772 11 5 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H5C4.44772 13 4 12.5523 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 18C4 17.4477 4.44772 17 5 17H13C13.5523 17 14 17.4477 14 18C14 18.5523 13.5523 19 13 19H5C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H19C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "align-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","align","right","menu","options","settings","display","layout","content","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 6C10 5.44772 10.4477 5 11 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H11C10.4477 7 10 6.55228 10 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 12C10 11.4477 10.4477 11 11 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H11C10.4477 13 10 12.5523 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 18C10 17.4477 10.4477 17 11 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H11C10.4477 19 10 18.5523 10 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10H19C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "align-right-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["align","justify","text","format","settings","layout","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["align-right","text","justify","layout","formatting","receipt","display","menu","settings","reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "align-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["align-right","justify","order-list","options","settings","configuration","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 9H5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "ambulance-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ambulance","medical","emergency","hospital","delivery","urgent","healthcare","rescue","shipping","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8H16.7275C18.297 8 19.0817 8 19.6346 8.45319C20.1876 8.90638 20.3416 9.67585 20.6497 11.2148L21.0071 13L21.353 15.4383C21.654 17.561 21.8046 18.6223 21.2066 19.3112C20.6085 20 19.5365 20 17.3926 20H15.9967L14 19.9998V13.0109V8Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 13.0109L21.0071 13M14 13.0109V19.9998L15.9967 20H17.3926C19.5365 20 20.6085 20 21.2066 19.3112C21.8046 18.6223 21.654 17.561 21.353 15.4383L21.0071 13M14 13.0109V8H16.7275C18.297 8 19.0817 8 19.6346 8.45319C20.1876 8.90638 20.3416 9.67585 20.6497 11.2148L21.0071 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12.25H14.25V13.75H15V12.25ZM21.5 13.75C21.9142 13.75 22.25 13.4142 22.25 13C22.25 12.5858 21.9142 12.25 21.5 12.25V13.75ZM15 13.75H21.5V12.25H15V13.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M3.24114 19.8682C3.60777 19.997 8.07123 20.0014 9 19.9998H14V11.4285V8.00002L10 8.00003H6C4.11438 8.00003 3.17157 8.00003 2.58579 8.50213C2 9.00422 2 9.81233 2 11.4285V17.4276C2 18.2237 2 18.6218 2.15109 18.9357C2.35467 19.3588 2.74715 19.6945 3.24114 19.8682Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M1 15H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path
                    d="M17 2L17 3"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 20.0001C5.00098 21.1047 5.89599 22.0002 7.00005 22.0002C8.10411 22.0002 8.99913 21.1046 8.99913 20C8.99913 18.8954 8.10411 18 7.00005 18C5.89599 18 5.00098 18.8955 5.00098 20.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16.001 20.0001C16.001 21.1047 16.896 22.0002 18.0001 22.0002C19.1041 22.0002 19.9991 21.1046 19.9991 20C19.9991 18.8954 19.1041 18 18.0001 18C16.896 18 16.001 18.8955 16.001 20.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M20 3L19 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 3L15 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ambulance-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ambulance","emergency","delivery","medical","urgent","help","support","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8L18 7C18 6.44772 17.5523 6 17 6V6C16.4477 6 16 6.44772 16 7L16 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M2 16V16.9991C2 17.9278 2 18.3922 2.15109 18.7586C2.35467 19.2521 2.74715 19.6438 3.24114 19.8464C3.60777 19.9968 4.07215 19.9958 5.00092 19.994V19.994"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20V8H6C4.11438 8 3.17157 8 2.58579 8.58579C2 9.17157 2 10.1144 2 12V16.5714"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 15H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 20H16.0009"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13.0109L21.0071 13M14 8H16.7275C18.297 8 19.0817 8 19.6346 8.45319C20.1876 8.90638 20.3416 9.67585 20.6497 11.2148L21.0071 13M21.0071 13L21.72 18.0259C21.8678 19.0682 21.0588 20 20.0061 20V20M14 19.9998L15.9967 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 2L17 3"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 20.0001C5.00098 21.1047 5.89599 22.0002 7.00005 22.0002C8.10411 22.0002 8.99913 21.1046 8.99913 20C8.99913 18.8954 8.10411 18 7.00005 18C5.89599 18 5.00098 18.8955 5.00098 20.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 20.0001C16 21.1047 16.895 22.0002 17.9991 22.0002C19.1031 22.0002 19.9982 21.1046 19.9982 20C19.9982 18.8954 19.1031 18 17.9991 18C16.895 18 16 18.8955 16 20.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 3L19 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 3L15 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ambulance-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ambulance","medical","emergency","delivery","urgent","assistance","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.72 4.5C17.13 4.5 17.47 4.16 17.47 3.75V2.75C17.47 2.34 17.13 2 16.72 2C16.31 2 15.97 2.34 15.97 2.75V3.75C15.97 4.16 16.31 4.5 16.72 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.71997 18.75C5.88997 18.75 5.17997 19.25 4.87997 19.97C4.77997 20.2 4.72997 20.45 4.71997 20.72C4.71997 20.73 4.71997 20.74 4.71997 20.75C4.71997 21.01 4.76997 21.25 4.85997 21.47C5.14997 22.22 5.86997 22.75 6.71997 22.75C7.56997 22.75 8.26997 22.23 8.56997 21.5C8.65997 21.27 8.71997 21.02 8.71997 20.75C8.71997 20.48 8.66997 20.23 8.56997 20C8.26997 19.27 7.55997 18.75 6.71997 18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.53 19.91C19.21 19.23 18.52 18.75 17.72 18.75C16.92 18.75 16.17 19.27 15.87 20C15.78 20.23 15.72 20.48 15.72 20.75C15.72 21.02 15.77 21.27 15.87 21.5C16.17 22.23 16.88 22.75 17.72 22.75C18.56 22.75 19.32 22.19 19.6 21.41C19.67 21.2 19.72 20.98 19.72 20.75C19.72 20.71 19.72 20.68 19.71 20.64C19.7 20.38 19.64 20.13 19.53 19.91Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.72 5.5C18.91 5.5 19.1 5.43 19.25 5.28L20.25 4.28C20.54 3.99 20.54 3.51 20.25 3.22C19.96 2.93 19.48 2.93 19.19 3.22L18.19 4.22C17.9 4.51 17.9 4.99 18.19 5.28C18.34 5.43 18.53 5.5 18.72 5.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.19 5.28C14.34 5.43 14.53 5.5 14.72 5.5C14.91 5.5 15.1 5.43 15.25 5.28C15.54 4.99 15.54 4.51 15.25 4.22L14.25 3.22C13.96 2.93 13.48 2.93 13.19 3.22C12.9 3.51 12.9 3.99 13.19 4.28L14.19 5.28Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.82 16.08L21.6 14.5H14.49V13.01L14.74 13H21.24C21.24 13 21.32 13.02 21.37 13.03L21.13 11.81C20.8 10.16 20.62 9.25 19.86 8.63C19.47 8.31 19.06 8.07 18.5 8C18.52 7.9 18.5 7.87 18.5 7.76C18.5 6.8 17.71 6.01 16.75 6.01C15.79 6.01 15 6.8 15 7.76C15 7.85 14.98 7.93 15 8.01H5.75C3.68 8.01 2.64 8.01 1.85 8.69C1 9.42 1 10.46 1 12.19V14.51H14.5V16.01H1V18.19C1 19.07 1 19.56 1.23 20.02C1.52 20.63 2.06 21.09 2.75 21.33C2.82 21.35 2.94 21.4 3.63 21.43C3.58 21.21 3.55 20.98 3.55 20.75C3.55 20.72 3.55 20.7 3.55 20.68C3.55 20.42 3.6 20.17 3.66 19.93C4.02 18.56 5.26 17.55 6.74 17.55C8.22 17.55 9.5 18.6 9.84 20C9.9 20.24 9.94 20.49 9.94 20.75C9.94 21.01 9.9 21.26 9.84 21.5H14.64C14.58 21.26 14.54 21.01 14.54 20.75C14.54 20.49 14.58 20.24 14.64 20C14.98 18.6 16.24 17.55 17.74 17.55C18.95 17.55 20 18.24 20.54 19.24C20.69 19.52 20.81 19.81 20.87 20.13C20.91 20.33 20.93 20.54 20.93 20.75C20.93 20.85 20.91 20.94 20.9 21.04C21.12 20.91 21.33 20.76 21.5 20.56C22.32 19.61 22.15 18.37 21.82 16.09V16.08Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    ambulance: {
        defaultColors: ["#3D4C66"],
        keywords: ["ambulance","medical","emergency","delivery","urgent","assistance","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 16V16.9991C2 17.9278 2 18.3922 2.15109 18.7586C2.35467 19.2521 2.74715 19.6438 3.24114 19.8464C3.60777 19.9968 4.07215 19.9958 5.00092 19.994V19.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20V8H6C4.11438 8 3.17157 8 2.58579 8.58579C2 9.17157 2 10.1144 2 12V16.5714"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 15H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 20H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 20.0001C5.00098 21.1047 5.89599 22.0002 7.00005 22.0002C8.10411 22.0002 8.99913 21.1046 8.99913 20C8.99913 18.8954 8.10411 18 7.00005 18C5.89599 18 5.00098 18.8955 5.00098 20.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 20.0001C16 21.1047 16.895 22.0002 17.9991 22.0002C19.1031 22.0002 19.9982 21.1046 19.9982 20C19.9982 18.8954 19.1031 18 17.9991 18C16.895 18 16 18.8955 16 20.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13.0109L21.0071 13M14 8H16.7275C18.297 8 19.0817 8 19.6346 8.45319C20.1876 8.90638 20.3416 9.67585 20.6497 11.2148L21.0071 13M21.0071 13L21.72 18.0259C21.8678 19.0682 21.0588 20 20.0061 20V20M14 19.9998L15.9967 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8L18 7C18 6.44772 17.5523 6 17 6V6C16.4477 6 16 6.44772 16 7L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 2L17 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 3L19 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 3L15 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "amp-stories-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["column","columns","resize","layout","width","adjust","table"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7" y="5" width="10" height="14" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 6V18M20 6V18" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "amp-stories-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["group","stories","shelves","layout","group-items","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9342 4L11 4H13L13.0658 4C13.9523 3.99995 14.7161 3.99991 15.3278 4.08215C15.9833 4.17028 16.6117 4.36902 17.1213 4.87868C17.631 5.38835 17.8297 6.0167 17.9179 6.67221C18.0001 7.28387 18.0001 8.04769 18 8.93417V15.0658C18.0001 15.9523 18.0001 16.7161 17.9179 17.3278C17.8297 17.9833 17.631 18.6117 17.1213 19.1213C16.6117 19.631 15.9833 19.8297 15.3278 19.9179C14.7161 20.0001 13.9523 20.0001 13.0658 20H10.9342C10.0477 20.0001 9.28387 20.0001 8.67221 19.9179C8.0167 19.8297 7.38835 19.631 6.87868 19.1213C6.36902 18.6117 6.17028 17.9833 6.08215 17.3278C5.99991 16.7161 5.99995 15.9523 6 15.0658L6 9L6 8.93417C5.99995 8.04769 5.99991 7.28387 6.08215 6.67221C6.17028 6.0167 6.36902 5.38835 6.87868 4.87868C7.38835 4.36902 8.0167 4.17028 8.67221 4.08215C9.28387 3.99991 10.0477 3.99995 10.9342 4ZM5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V6ZM21 6C21 5.44772 20.5523 5 20 5C19.4477 5 19 5.44772 19 6V18C19 18.5523 19.4477 19 20 19C20.5523 19 21 18.5523 21 18V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "amp-stories-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","card-reader","tablet","payment","transaction","swipe","device","processing","screen","portrait","orientation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="5"
                    width="10"
                    height="14"
                    rx="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 6V18M20 6V18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "amp-stories": {
        defaultColors: ["#3D4C66"],
        keywords: ["stock","inventory","reorder","display","image-slider","carousel","fullscreen","preview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7" y="5" width="10" height="14" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 6V18M20 6V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "anchor-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["anchor","nautical","maritime","sea","shipping","import","export","navigation","dock","port","marina"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "anchor-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["anchor","maritime","sea","location","dock","boat","ship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "anchor-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["anchor","dock","security","stable","fixed","marine","shipping","mooring","lock","retain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V7L9 7C8.44772 7 8 7.44772 8 8C8 8.55228 8.44772 9 9 9H11V10H10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12H11V16.9C9.03926 16.502 7.49516 14.9566 7.09904 12.9952C7.60483 12.9454 8 12.5189 8 12C8 11.4477 7.55228 11 7 11H6C5.44772 11 5 11.4477 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.4477 18.5523 11 18 11H17C16.4477 11 16 11.4477 16 12C16 12.5189 16.3952 12.9454 16.901 12.9952C16.5048 14.9566 14.9607 16.502 13 16.9V12H14C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10H13V9H15C15.5523 9 16 8.55228 16 8C16 7.44771 15.5523 7 15 7L13 7V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "anchor-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["anchor","maritime","dock","port","shipping","nautical","sea","ocean"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6V18" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "anchor-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["anchor","secure","fixed","hold","marine","maritime","dock","port","shipping","loyalty","rewards","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "anchor-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["anchor","loyalty","membership","rewards","points","secure","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V7L9 7C8.44772 7 8 7.44772 8 8C8 8.55228 8.44772 9 9 9H11V10H10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12H11V16.9C9.03926 16.502 7.49516 14.9566 7.09904 12.9952C7.60483 12.9454 8 12.5189 8 12C8 11.4477 7.55228 11 7 11H6C5.44772 11 5 11.4477 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.4477 18.5523 11 18 11H17C16.4477 11 16 11.4477 16 12C16 12.5189 16.3952 12.9454 16.901 12.9952C16.5048 14.9566 14.9607 16.502 13 16.9V12H14C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10H13V9H15C15.5523 9 16 8.55228 16 8C16 7.44771 15.5523 7 15 7L13 7V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    anchor: {
        defaultColors: ["#3D4C66"],
        keywords: ["anchor","loyalty","membership","rewards","points","secure","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "anchor-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["anchor","shipping","maritime","hold","secure","fixed","location","stable","dock","port","customer","loyalty","rewards","customer-retention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6V18" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L15 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Android-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["android","system","device","settings","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19H7C6.05719 19 5.58579 19 5.29289 18.7071C5 18.4142 5 17.9428 5 17V15H12H19V17C19 17.9428 19 18.4142 18.7071 18.7071C18.4142 19 17.9428 19 17 19H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.47085 8.47085L7 5M14.5291 8.47085L17 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.47085 8.47085C6.85484 9.4849 5 12.0258 5 15H12H19C19 12.0258 17.1452 9.4849 14.5291 8.47085C13.7447 8.16678 12.8918 8 12 8C11.1082 8 10.2553 8.16678 9.47085 8.47085Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V12M14 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Android-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["android","robot","software","system","application","app","settings","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.47085 8.47085L7 5M14.5291 8.47085L17 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15C5 12.0258 6.85484 9.4849 9.47085 8.47085C10.2553 8.16678 11.1082 8 12 8C12.8918 8 13.7447 8.16678 14.5291 8.47085C17.1452 9.4849 19 12.0258 19 15M5 15H12H19M5 15V17C5 17.9428 5 18.4142 5.29289 18.7071C5.58579 19 6.05719 19 7 19H12H17C17.9428 19 18.4142 19 18.7071 18.7071C19 18.4142 19 17.9428 19 17V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V12M14 11V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Android: {
        defaultColors: ["#3D4C66"],
        keywords: ["android","robot","software","system","application","app","settings","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11V12M5 15C5 12.0258 6.85484 9.4849 9.47085 8.47085M5 15H12H19M5 15V17C5 17.9428 5 18.4142 5.29289 18.7071C5.58579 19 6.05719 19 7 19H12H17C17.9428 19 18.4142 19 18.7071 18.7071C19 18.4142 19 17.9428 19 17V15M9.47085 8.47085C10.2553 8.16678 11.1082 8 12 8C12.8918 8 13.7447 8.16678 14.5291 8.47085M9.47085 8.47085L7 5M14 11V12M19 15C19 12.0258 17.1452 9.4849 14.5291 8.47085M14.5291 8.47085L17 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "angular-js-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["badge","shield","letter-a","a","rewards","loyalty","promotions","security","verified","approved","authorization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.9487 15.487L4.086 6.86002C4.03661 6.36613 4.35697 5.91076 4.8385 5.79037L11.7575 4.06063C11.9167 4.02082 12.0833 4.02082 12.2425 4.06063L19.1615 5.79037C19.643 5.91076 19.9634 6.36613 19.914 6.86002L19.0513 15.487C19.0191 15.8089 18.8332 16.0953 18.5524 16.2558L12.4961 19.7165C12.1887 19.8922 11.8113 19.8922 11.5039 19.7165L5.4476 16.2558C5.16676 16.0953 4.98089 15.8089 4.9487 15.487Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L12 8L9 14M14 12L10 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "angular-js-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["A","letter-a","alphabetical","authorization","approve","authentication","admin","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.9487 15.487L4.086 6.86002C4.03661 6.36613 4.35697 5.91076 4.8385 5.79037L11.7575 4.06063C11.9167 4.02082 12.0833 4.02082 12.2425 4.06063L19.1615 5.79037C19.643 5.91076 19.9634 6.36613 19.914 6.86002L19.0513 15.487C19.0191 15.8089 18.8332 16.0953 18.5524 16.2558L12.4961 19.7165C12.1887 19.8922 11.8113 19.8922 11.5039 19.7165L5.4476 16.2558C5.16676 16.0953 4.98089 15.8089 4.9487 15.487Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L12 8L9 14M14 12L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Android-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["android","robot","device","settings","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.42014 4.18542C6.87006 3.86513 7.49444 3.97021 7.81474 4.42014L9.85802 7.29037C10.5406 7.10109 11.2591 7.00012 12 7.00012C12.7409 7.00012 13.4595 7.1011 14.1421 7.29041L16.1854 4.42014C16.5057 3.97021 17.1301 3.86513 17.58 4.18542C18.0299 4.50572 18.135 5.1301 17.8147 5.58002L16.0295 8.0878C18.4025 9.47408 19.9988 12.0481 20 14.9969L20 17.0546C20.0001 17.4787 20.0002 17.8908 19.9545 18.2306C19.903 18.6138 19.7774 19.0511 19.4142 19.4143C19.051 19.7776 18.6137 19.9031 18.2305 19.9546C17.8907 20.0003 17.4785 20.0002 17.0544 20.0001H6.94548C6.52145 20.0002 6.10938 20.0003 5.76949 19.9546C5.38629 19.9031 4.94902 19.7776 4.5858 19.4143C4.22259 19.0511 4.09706 18.6138 4.04554 18.2306C3.99984 17.8907 3.99992 17.4786 4.00001 17.0545L4.00001 15.0055L4 15.0001C4 12.0499 5.59664 9.4745 7.97063 8.08773L6.18542 5.58002C5.86513 5.1301 5.97021 4.50572 6.42014 4.18542ZM11 11.0001C11 10.4478 10.5523 10.0001 10 10.0001C9.44772 10.0001 9 10.4478 9 11.0001V12.0001C9 12.5524 9.44772 13.0001 10 13.0001C10.5523 13.0001 11 12.5524 11 12.0001V11.0001ZM15 11.0001C15 10.4478 14.5523 10.0001 14 10.0001C13.4477 10.0001 13 10.4478 13 11.0001V12.0001C13 12.5524 13.4477 13.0001 14 13.0001C14.5523 13.0001 15 12.5524 15 12.0001V11.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "angular-js-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alert","attention","important","information","letter-a","security","authorization","authentication","approved","verified","alert","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 10.2361L12.3819 11H11.618L12 10.2361Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5105 3.06033C11.8319 2.97989 12.1681 2.97989 12.4895 3.06033L19.4712 4.80779C20.443 5.05102 21.0896 5.97109 20.9899 6.969L20.1194 15.6844C20.0544 16.3347 19.6793 16.9134 19.1125 17.2376L13.0013 20.7338C12.3808 21.0887 11.6192 21.0887 10.9987 20.7338L4.8875 17.2376C4.32072 16.9134 3.9456 16.3347 3.88064 15.6844L3.01011 6.96899C2.91044 5.97109 3.55697 5.05102 4.52878 4.80779L11.5105 3.06033ZM12.8944 7.55279C12.725 7.214 12.3787 7 12 7C11.6212 7 11.2749 7.214 11.1055 7.55279L9.11454 11.5348C9.10806 11.5471 9.10184 11.5596 9.09586 11.5722L8.10555 13.5528C7.85856 14.0468 8.05878 14.6474 8.55276 14.8944C9.04674 15.1414 9.64741 14.9412 9.8944 14.4472L10.618 13H13.3819L14.1055 14.4472C14.3525 14.9412 14.9532 15.1414 15.4472 14.8944C15.9412 14.6474 16.1414 14.0468 15.8944 13.5528L14.9041 11.5722C14.8981 11.5596 14.8919 11.5471 14.8854 11.5347L12.8944 7.55279Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "angular-js": {
        defaultColors: ["#3D4C66"],
        keywords: ["angular","shield","A","protection","secure","secure-payment","authorization","access","admin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.9487 15.487L4.086 6.86002C4.03661 6.36613 4.35697 5.91076 4.8385 5.79037L11.7575 4.06063C11.9167 4.02082 12.0833 4.02082 12.2425 4.06063L19.1615 5.79037C19.643 5.91076 19.9634 6.36613 19.914 6.86002L19.0513 15.487C19.0191 15.8089 18.8332 16.0953 18.5524 16.2558L12.4961 19.7165C12.1887 19.8922 11.8113 19.8922 11.5039 19.7165L5.4476 16.2558C5.16676 16.0953 4.98089 15.8089 4.9487 15.487Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L12 8L9 14M14 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Api-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["api","connection","integration","data","settings","developer","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14V12M10 14V12M7 12V11.5C7 10.6716 7.67157 10 8.5 10V10C9.32843 10 10 10.6716 10 11.5V12M7 12H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12.6667V11.5C12 10.6716 12.6716 10 13.5 10V10C14.3284 10 15 10.6716 15 11.5V11.7204C15 12.243 14.5764 12.6667 14.0538 12.6667H12ZM12 12.6667V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Api-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["api","connection","integration","data","service","platform","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14V12M10 14V12M7 12V11.5C7 10.6716 7.67157 10 8.5 10V10C9.32843 10 10 10.6716 10 11.5V12M7 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12.6667V11.5C12 10.6716 12.6716 10 13.5 10V10C14.3284 10 15 10.6716 15 11.5V11.7204C15 12.243 14.5764 12.6667 14.0538 12.6667H12ZM12 12.6667V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Api-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["api","integration","system","connection","interface","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.20732 11.25C9.10437 10.9587 8.82656 10.75 8.5 10.75C8.17345 10.75 7.89564 10.9587 7.79268 11.25H9.20732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5 10.75C13.0858 10.75 12.75 11.0858 12.75 11.5V11.9167H14.0538C14.1621 11.9167 14.25 11.8288 14.25 11.7204V11.5C14.25 11.0858 13.9142 10.75 13.5 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V13.0549C20.75 14.4225 20.75 15.5248 20.6335 16.3918C20.5125 17.2919 20.2536 18.0497 19.6517 18.6517C19.0497 19.2536 18.2919 19.5125 17.3918 19.6335C16.5248 19.75 15.4225 19.75 14.0549 19.75H9.94513C8.57755 19.75 7.47522 19.75 6.60825 19.6335C5.70814 19.5125 4.95027 19.2536 4.34835 18.6517C3.74644 18.0497 3.48754 17.2919 3.36653 16.3918C3.24997 15.5248 3.24998 14.4225 3.25 13.0549V10.9451C3.24998 9.57755 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57755 4.24998 9.94513 4.25ZM6.25 11.5C6.25 10.2574 7.25736 9.25 8.5 9.25C9.74264 9.25 10.75 10.2574 10.75 11.5V14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14V12.75H7.75V14C7.75 14.4142 7.41421 14.75 7 14.75C6.58579 14.75 6.25 14.4142 6.25 14V11.5ZM13.5 9.25C14.7426 9.25 15.75 10.2574 15.75 11.5V11.7204C15.75 12.6572 14.9906 13.4167 14.0538 13.4167H12.75V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V11.5C11.25 10.2574 12.2574 9.25 13.5 9.25ZM17.75 10C17.75 9.58579 17.4142 9.25 17 9.25C16.5858 9.25 16.25 9.58579 16.25 10V14C16.25 14.4142 16.5858 14.75 17 14.75C17.4142 14.75 17.75 14.4142 17.75 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Api: {
        defaultColors: ["#3D4C66"],
        keywords: ["api","integration","system","connection","interface","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14V12M10 14V12M7 12V11.5C7 10.6716 7.67157 10 8.5 10V10C9.32843 10 10 10.6716 10 11.5V12M7 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12.6667V11.5C12 10.6716 12.6716 10 13.5 10V10C14.3284 10 15 10.6716 15 11.5V11.7204C15 12.243 14.5764 12.6667 14.0538 12.6667H12ZM12 12.6667V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "App Store-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["app-store","store","download","apps","application","platform","marketplace","installation","software"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13H17.35"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L13 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 7L12 8.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L10 11.5L9 13M7 16L8 14.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "App Store-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["app","store","download","install","application","updates","marketplace","platform","apps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13H17.35"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L13 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 7L12 8.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L10 11.5L9 13M7 16L8 14.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "App Store-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["app-store","download","install","application","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM11.8322 6.44528C11.5258 5.98576 10.9049 5.86158 10.4454 6.16793C9.98588 6.47429 9.8617 7.09516 10.1681 7.55468L10.7983 8.49998L8.46492 12H7.50011C6.94782 12 6.50011 12.4477 6.50011 13C6.50011 13.5523 6.94782 14 7.50011 14H8.98459C8.99433 14.0001 9.00406 14.0001 9.01378 14H12.0001C12.5524 14 13.0001 13.5523 13.0001 13C13.0001 12.4477 12.5524 12 12.0001 12H10.8686L12.8193 9.07394C12.828 9.0615 12.8364 9.04888 12.8445 9.0361L13.8322 7.55468C14.1385 7.09516 14.0143 6.47429 13.5548 6.16793C13.0953 5.86158 12.4744 5.98576 12.1681 6.44528L12.0001 6.69721L11.8322 6.44528ZM14.4988 10.4453C14.1925 9.98576 13.5716 9.86158 13.1121 10.1679C12.6525 10.4743 12.5284 11.0952 12.8347 11.5547L14.1595 13.5418C14.1617 13.5453 14.164 13.5488 14.1663 13.5523C14.1694 13.5569 14.1725 13.5615 14.1756 13.566L16.1681 16.5547C16.4744 17.0142 17.0953 17.1384 17.5548 16.832C18.0143 16.5257 18.1385 15.9048 17.8322 15.4453L16.8686 14H17.3501C17.9024 14 18.3501 13.5523 18.3501 13C18.3501 12.4477 17.9024 12 17.3501 12H15.5353L14.4988 10.4453ZM8.16549 16.0547C8.47184 15.5952 8.34767 14.9743 7.88814 14.6679C7.42861 14.3616 6.80774 14.4858 6.50139 14.9453L6.16806 15.4453C5.8617 15.9048 5.98588 16.5257 6.44541 16.832C6.90493 17.1384 7.5258 17.0142 7.83216 16.5547L8.16549 16.0547Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ar","augmented-reality","settings","configuration","adjustment","options","advanced-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["AR","augmented reality","add reality","augmented","reality","vr","marketing","advertising","menu","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["AR","augmented-reality","reality","reporting","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 11.25H7.5V9.75H10V11.25Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M14 9.75V12.25H15.25C15.9404 12.25 16.5 11.6904 16.5 11C16.5 10.3096 15.9404 9.75 15.25 9.75H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM6.75 8.25C6.33579 8.25 6 8.58579 6 9V15C6 15.4142 6.33579 15.75 6.75 15.75C7.16421 15.75 7.5 15.4142 7.5 15V12.75H10V15C10 15.4142 10.3358 15.75 10.75 15.75C11.1642 15.75 11.5 15.4142 11.5 15V9C11.5 8.58579 11.1642 8.25 10.75 8.25H6.75ZM13.25 8.25C12.8358 8.25 12.5 8.58579 12.5 9V15C12.5 15.4142 12.8358 15.75 13.25 15.75C13.6642 15.75 14 15.4142 14 15V13.7515C14.5519 13.7568 14.737 13.7777 14.8999 13.8452C15.0976 13.927 15.2699 14.0806 15.8912 14.7019L16.7197 15.5303C17.0126 15.8232 17.4874 15.8232 17.7803 15.5303C18.0732 15.2374 18.0732 14.7626 17.7803 14.4697L16.8665 13.5557C16.7984 13.4875 16.7322 13.4212 16.6674 13.3571C17.4659 12.8758 18 12.0003 18 11C18 9.48122 16.7688 8.25 15.25 8.25H13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "App Store": {
        defaultColors: ["#3D4C66"],
        keywords: ["app","application","download","store","install","software","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13H17.35"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 7L12 8.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L10 11.5L9 13M7 16L8 14.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Ar: {
        defaultColors: ["#3D4C66"],
        keywords: ["app","application","download","store","install","software","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15V12M11 15V12M7 12V9H11V12M7 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-alignment-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["alignment","text-alignment","justify","format","layout","list","options","menu","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 5L8 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 9H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alignment","align","justify","justify-left","text-alignment","vertical-line","text"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 8H17" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13H15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["align","alignment","format","justify","left-align","vertical-align","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 5L8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 9H17" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","sort","align","alignment","layout","list","options","settings","organize","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 3C7.55228 3 8 3.44772 8 4L8 18C8 18.5523 7.55229 19 7 19C6.44772 19 6 18.5523 6 18L6 4C6 3.44772 6.44772 3 7 3ZM10 8C10 7.44772 10.4477 7 11 7H17C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H11C10.4477 9 10 8.55228 10 8ZM10 13C10 12.4477 10.4477 12 11 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H11C10.4477 14 10 13.5523 10 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-alignment-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sort","arrange","align","layout","side-by-side","compare","view","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5L17 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 9H8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","alignment","layout","sidebar","menu","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 9H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alignment","align","text-alignment","layout","format","justify","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8.55228 4 9 4.44772 9 5L9 19C9 19.5523 8.55229 20 8 20C7.44772 20 7 19.5523 7 19V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.5 9C10.5 8.44772 10.9477 8 11.5 8H17C17.5523 8 18 8.44772 18 9C18 9.55228 17.5523 10 17 10H11.5C10.9477 10 10.5 9.55228 10.5 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.5 13C10.9477 13 10.5 13.4477 10.5 14C10.5 14.5523 10.9477 15 11.5 15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H11.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-alignment-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","alignment","text-alignment","layout","justify","item-alignment","interface","design","pos","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 4C16.4477 4 16 4.44772 16 5L16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19L18 5C18 4.44772 17.5523 4 17 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 9C14.5 8.44772 14.0523 8 13.5 8H7.5C6.94772 8 6.5 8.44772 6.5 9C6.5 9.55228 6.94772 10 7.5 10H13.5C14.0523 10 14.5 9.55228 14.5 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5 13C14.0523 13 14.5 13.4477 14.5 14C14.5 14.5523 14.0523 15 13.5 15H9.5C8.94772 15 8.5 14.5523 8.5 14C8.5 13.4477 8.94772 13 9.5 13H13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-alignment-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["alignment","layout","order","arrange","display","sidebar","menu","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 9H8" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14H10" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","text","format","layout","justification","left-align","edit","options","settings","paragraph"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 8H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alignment","list","order","items","group","organize","layout","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 8H17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-alignment": {
        defaultColors: ["#3D4C66"],
        keywords: ["alignment","options","configure","sort","menu","list","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 5L8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 9H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-block-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","decrease","reduce","discount","lower","minimize","scroll-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13H10L10 7C10 6.05719 10 5.58579 10.2929 5.29289C10.2929 5.29289 10.2929 5.29289 10.2929 5.29289C10.5858 5 11.0572 5 12 5V5C12.9428 5 13.4142 5 13.7071 5.29289C13.7071 5.29289 13.7071 5.29289 13.7071 5.29289C14 5.58579 14 6.05719 14 7L14 13H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10.4619 17.156C11.1738 18.0106 11.5298 18.4379 11.9981 18.438C12.4665 18.438 12.8226 18.0109 13.5348 17.1566L17 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-down-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","down","decrease","reduce","discount","scroll-down","move-down","lower","decrease-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.4619 17.156L7 13L10 13L10 5L14 5L14 13L17 13L13.5348 17.1566C12.8226 18.0109 12.4665 18.438 11.9981 18.4379C11.5298 18.4379 11.1738 18.0106 10.4619 17.156Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","discount","scroll-down","view-details","minimize","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.5348 17.1566C12.8226 18.0109 12.4665 18.438 11.9981 18.438C11.5298 18.4379 11.1738 18.0106 10.4619 17.156L7 13H10L10 7C10 6.05719 10 5.58579 10.2929 5.29289C10.2929 5.29289 10.2929 5.29289 10.2929 5.29289C10.5858 5 11.0572 5 12 5V5C12.9428 5 13.4142 5 13.7071 5.29289C13.7071 5.29289 13.7071 5.29289 13.7071 5.29289C14 5.58579 14 6.05719 14 7L14 13H17L13.5348 17.1566Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","download","decrease","lower","discount","scroll-down","dropdown","collapse","reduce","move-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.09446 12.8566C6.25906 12.5052 6.61203 12.2808 7.00001 12.2808H9.00001L9.00001 5.28082C9.00001 4.72854 9.44773 4.28082 10 4.28082L14 4.28082C14.5523 4.28082 15 4.72854 15 5.28082V12.2808H17C17.3881 12.2808 17.7411 12.5053 17.9056 12.8568C18.0702 13.2082 18.0166 13.6231 17.7681 13.9212L14.3029 18.0777C14.2899 18.0934 14.2768 18.109 14.2638 18.1246C13.9418 18.5111 13.6353 18.8789 13.3451 19.1408C13.0226 19.4319 12.5859 19.7189 11.9979 19.7188C11.41 19.7187 10.9734 19.4315 10.651 19.1403C10.3609 18.8782 10.0546 18.5104 9.73267 18.1237C9.71967 18.1081 9.70665 18.0925 9.6936 18.0768L6.23167 13.9209C5.98334 13.6228 5.92987 13.2079 6.09446 12.8566Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-block-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","left","back","return","previous","undo","navigate-back","go-back","retreat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 7V10H17C17.9428 10 18.4142 10 18.7071 10.2929C19 10.5858 19 11.0572 19 12V12C19 12.9428 19 13.4142 18.7071 13.7071C18.4142 14 17.9428 14 17 14H11V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 7L6.84403 10.4619C5.98944 11.1738 5.56214 11.5298 5.56205 11.9981C5.56196 12.4665 5.98912 12.8226 6.84343 13.5348L11 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-left-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","left","back","return","previous","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.84403 10.4619L11 7V10H19V14H11V17L6.84343 13.5348C5.98912 12.8226 5.56196 12.4665 5.56205 11.9981C5.56214 11.5298 5.98944 11.1738 6.84403 10.4619Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","navigate","go-back","previous-page","back-button"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.162 6.09446C11.5133 6.25906 11.7378 6.61203 11.7378 7.00001V9.00001H18.7378C19.29 9.00001 19.7378 9.44773 19.7378 10V14C19.7378 14.5523 19.29 15 18.7378 15H11.7378V17C11.7378 17.3881 11.5133 17.7411 11.1618 17.9056C10.8104 18.0702 10.3955 18.0166 10.0974 17.7681L5.94085 14.3029C5.9252 14.2899 5.90956 14.2768 5.89396 14.2638C5.50746 13.9418 5.13973 13.6353 4.87778 13.3451C4.58671 13.0226 4.29969 12.5859 4.2998 11.9979C4.29992 11.41 4.58711 10.9734 4.8783 10.651C5.14036 10.3609 5.50822 10.0546 5.89484 9.73267C5.91045 9.71967 5.92609 9.70665 5.94175 9.6936L10.0977 6.23167C10.3958 5.98334 10.8107 5.92987 11.162 6.09446Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-block-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","cancel","go-back","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.84403 10.4619L11 7V10H17C17.9428 10 18.4142 10 18.7071 10.2929C19 10.5858 19 11.0572 19 12C19 12.9428 19 13.4142 18.7071 13.7071C18.4142 14 17.9428 14 17 14H11V17L6.84343 13.5348C5.98912 12.8226 5.56196 12.4665 5.56205 11.9981C5.56214 11.5298 5.98944 11.1738 6.84403 10.4619Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-right-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","next","proceed","continue","forward","navigation","select","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 7V10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.58579 14 6.05719 14 7 14H11C11.9428 14 12.4142 14 12.7071 14.2929C13 14.5858 13 15.0572 13 16V17"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L17.156 10.4619C18.0106 11.1738 18.4379 11.5298 18.438 11.9981C18.438 12.4665 18.0109 12.8226 17.1566 13.5348L13 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-right-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","right","next","forward","continue","proceed","transaction","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.156 10.4619L13 7V10H5V14H13V17L17.1566 13.5348C18.0109 12.8226 18.438 12.4665 18.438 11.9981C18.4379 11.5298 18.0106 11.1738 17.156 10.4619Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","forward","continue","proceed","submit","checkout","payment","process","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.8756 17.9056C12.5242 17.741 12.2998 17.388 12.2998 17L12.2998 15L5.29981 15C4.74752 15 4.29981 14.5523 4.29981 14L4.2998 10C4.2998 9.44773 4.74752 9.00001 5.2998 9.00001L12.2998 9.00001L12.2998 7.00001C12.2998 6.61196 12.5243 6.25894 12.8757 6.09438C13.2272 5.92982 13.6421 5.98343 13.9401 6.23192L18.0967 9.6971C18.1124 9.71015 18.128 9.72317 18.1436 9.73618C18.5301 10.0583 18.8978 10.3647 19.1598 10.6549C19.4508 10.9774 19.7379 11.4142 19.7378 12.0021C19.7376 12.59 19.4504 13.0267 19.1593 13.349C18.8972 13.6391 18.5293 13.9454 18.1427 14.2674C18.1271 14.2804 18.1115 14.2934 18.0958 14.3064L13.9398 17.7684C13.6417 18.0167 13.2269 18.0702 12.8756 17.9056Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-block-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","forward","continue","submit","checkout","payment","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1566 13.5348C18.0109 12.8226 18.438 12.4665 18.438 11.9981C18.4379 11.5298 18.0106 11.1738 17.156 10.4619L13 7V10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.58579 14 6.05719 14 7 14H11C11.9428 14 12.4142 14 12.7071 14.2929C13 14.5858 13 15.0572 13 16V17L17.1566 13.5348Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-up-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","increase","quantity","raise","promote","ascend","move-up","elevate","add"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11.0001L14 11.0001L14 17.0001C14 17.9429 14 18.4143 13.7071 18.7072C13.7071 18.7072 13.7071 18.7072 13.7071 18.7072C13.4142 19.0001 12.9428 19.0001 12 19.0001V19.0001C11.0572 19.0001 10.5858 19.0001 10.2929 18.7072C10.2929 18.7072 10.2929 18.7072 10.2929 18.7072C10 18.4143 10 17.9429 10 17.0001L10 11.0001L7 11.0001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11.0001L13.5381 6.84415C12.8262 5.98956 12.4702 5.56226 12.0019 5.56217C11.5335 5.56208 11.1774 5.98924 10.4652 6.84355L7 11.0001"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-up-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","up","increase","add","higher","promote","ascend","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.4619 6.84403L7 11L10 11L10 19L14 19L14 11L17 11L13.5348 6.84343C12.8226 5.98912 12.4665 5.56196 11.9981 5.56205C11.5298 5.56214 11.1738 5.98944 10.4619 6.84403Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-block-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","raise","move-up","ascend","higher","increment","promote","upgrade","advance","scroll-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.9056 11.143C17.741 11.4943 17.388 11.7187 17 11.7187L15 11.7187L15 18.7187C15 19.271 14.5523 19.7187 14 19.7187H10C9.44773 19.7187 9.00001 19.271 9.00001 18.7187L9.00001 11.7187H7.00001C6.61196 11.7187 6.25894 11.4942 6.09438 11.1428C5.92982 10.7913 5.98343 10.3764 6.23192 10.0784L9.6971 5.92181C9.71015 5.90615 9.72317 5.89052 9.73618 5.87492C10.0583 5.48842 10.3647 5.12068 10.6549 4.85874C10.9774 4.56767 11.4142 4.28065 12.0021 4.28076C12.59 4.28088 13.0267 4.56807 13.349 4.85926C13.6391 5.12132 13.9454 5.48917 14.2674 5.8758C14.2804 5.89141 14.2934 5.90705 14.3064 5.92271L17.7684 10.0787C18.0167 10.3768 18.0702 10.7916 17.9056 11.143Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-block-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","upload","increase","raise","quantity","more","ascending","higher","elevate","promote","move-up","escalate","enqueue","promote","priority","upgrade"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.4652 6.84355C11.1774 5.98924 11.5335 5.56208 12.0019 5.56217C12.4702 5.56226 12.8262 5.98956 13.5381 6.84415L17 11.0001L14 11.0001L14 17.0001C14 17.9429 14 18.4143 13.7071 18.7072C13.7071 18.7072 13.7071 18.7072 13.7071 18.7072C13.4142 19.0001 12.9428 19.0001 12 19.0001V19.0001C11.0572 19.0001 10.5858 19.0001 10.2929 18.7072C10.2929 18.7072 10.2929 18.7072 10.2929 18.7072C10 18.4143 10 17.9429 10 17.0001L10 11.0001L7 11.0001L10.4652 6.84355Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","scroll","minimize","collapse","expand-down","dropdown","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L16 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","dropdown","select","options","scroll-down","sort","minimize","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 14C8.38071 14 9.63071 14.5596 10.5355 15.4645C11.4404 16.3693 12 17.6193 12 19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C15.6193 14 14.3693 14.5596 13.4645 15.4645C12.5596 16.3693 12 17.6193 12 19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","minimize","scroll-down","collapse","dropdown","menu","order-history","past-orders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 13C10.1953 14.7236 11.7092 16.1012 12 19C12.2908 16.1012 13.8047 14.7236 16 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","collapse","minimize","scroll-down","dropdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V14.5278C14.0608 13.5786 15.4636 13 17 13C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15C15.8952 15 14.8965 15.4466 14.1716 16.1716C13.4466 16.8965 13 17.8952 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 17.8952 10.5534 16.8965 9.82843 16.1716C9.10347 15.4466 8.10485 15 7 15C6.44772 15 6 14.5523 6 14C6 13.4477 6.44772 13 7 13C8.53636 13 9.93921 13.5786 11 14.5278V5C11 4.44772 11.4477 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","sort","dropdown","decrease","discount","scroll","expand","collapse","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 13C10.1953 14.7236 11.7092 16.1012 12 19C12.2908 16.1012 13.8047 14.7236 16 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","decrease","reduce","lower","dropdown","expand","collapse","discount","scroll-down","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 13C10.1953 14.7236 11.7092 16.1012 12 19C12.2908 16.1012 13.8047 14.7236 16 13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","sort","order","descending","decrease","direction","navigation","scroll","collapse","minimize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V14.3353C13.6913 13.5679 14.5149 12.8947 15.3825 12.2135C15.8169 11.8724 16.4455 11.9481 16.7866 12.3825C17.1276 12.8169 17.052 13.4455 16.6176 13.7865C15.5176 14.6502 14.688 15.3536 14.0869 16.1579C13.5091 16.931 13.1228 17.8267 12.995 19.0998C12.9438 19.6109 12.5137 20 12 20C11.4864 20 11.0563 19.6109 11.005 19.0998C10.8773 17.8267 10.491 16.931 9.91321 16.1579C9.31208 15.3536 8.48251 14.6502 7.38251 13.7865C6.94812 13.4455 6.87244 12.8169 7.21349 12.3825C7.55455 11.9481 8.18317 11.8724 8.61757 12.2135C9.48522 12.8947 10.3088 13.5679 11 14.3353V5C11 4.44772 11.4478 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","minimize","collapse","dropdown","select","payment","scroll-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 13L18 13M6 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 13L14 7C14 6.05719 14 5.58579 13.7071 5.29289C13.4142 5 12.9428 5 12 5V5C11.0572 5 10.5858 5 10.2929 5.29289C10 5.58579 10 6.05719 10 7L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 13L13.4142 17.5858C12.7475 18.2525 12.4142 18.5858 12 18.5858C11.5858 18.5858 11.2525 18.2525 10.5858 17.5858L6 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-18": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","down","dropdown","expand","collapse","sort","filter","scroll","select","more","options","checkout","payment","discount","apply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L10 13L10 7C10 6.05719 10 5.58579 10.2929 5.29289C10.2929 5.29289 10.2929 5.29289 10.2929 5.29289C10.5858 5 11.0572 5 12 5C12.9428 5 13.4142 5 13.7071 5.29289C13.7071 5.29289 13.7071 5.29289 13.7071 5.29289C14 5.58579 14 6.05719 14 7L14 13L18 13L13.4142 17.5858C12.7475 18.2525 12.4142 18.5858 12 18.5858C11.5858 18.5858 11.2525 18.2525 10.5858 17.5858L6 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","download","scroll","minimize","collapse","reduce","expand","sort-down","low-priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 13L18 13M6 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 13L14 7C14 6.05719 14 5.58579 13.7071 5.29289C13.4142 5 12.9428 5 12 5V5C11.0572 5 10.5858 5 10.2929 5.29289C10 5.58579 10 6.05719 10 7L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 13L13.4142 17.5858C12.7475 18.2525 12.4142 18.5858 12 18.5858C11.5858 18.5858 11.2525 18.2525 10.5858 17.5858L6 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","minimize","scroll-down","expand","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0021 13.3976C19.0021 13.6976 18.9021 13.8976 18.7021 14.0976L14.1021 18.6976C13.3021 19.4976 12.8021 19.9976 12.0021 19.9976C11.2021 19.9976 10.7021 19.4976 9.9021 18.6976L5.3021 14.0976C5.0021 13.7976 4.9021 13.3976 5.1021 12.9976C5.2021 12.6976 5.6021 12.3976 6.0021 12.3976H9.0021L9.0021 6.99756C9.0021 5.89756 9.0021 5.19756 9.6021 4.59756C10.2021 3.99756 10.9021 3.99756 12.0021 3.99756C13.1021 3.99756 13.8021 3.99756 14.4021 4.59756C15.0021 5.19756 15.0021 5.89756 15.0021 6.99756V12.3976H18.0021C18.4021 12.3976 18.8021 12.5976 18.9021 12.9976C19.0021 13.1976 19.0021 13.2976 19.0021 13.3976Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","sort","dropdown","scroll","load-more","expand","collapse","select","choose","view-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L16 13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","scroll","decrease","discount","next","navigation","open","expand","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.5523 6 13 6.44772 13 7V14.5858L15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929C17.0976 12.6834 17.0976 13.3166 16.7071 13.7071L12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929L11 14.5858V7C11 6.44772 11.4477 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","direction","scroll","dropdown","sort","descending","decrease","reduction","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13L12 8.2L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 13L12.8 13L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 13L10.3359 16.5039C11.0885 17.6328 11.4648 18.1972 12 18.1972C12.5352 18.1972 12.9115 17.6328 13.6641 16.5038L16 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","dropdown","select","sort","menu","scroll","options","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13L12 8.2L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 13L12.8 13L16 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 13L10.3359 16.5039C11.0885 17.6328 11.4648 18.1972 12 18.1972C12.5352 18.1972 12.9115 17.6328 13.6641 16.5038L16 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","dropdown","menu","expand","collapse","sort","filter","select","open","options","scroll"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13L8 13L10.3359 16.5039C11.0885 17.6328 11.4648 18.1972 12 18.1972C12.5352 18.1972 12.9115 17.6328 13.6641 16.5038L16 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","dropdown","select","minimize","collapse","hide","sort-down","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8797 12.9295C17.0537 13.2547 17.0347 13.6492 16.8301 13.9561L14.4942 17.4599C14.4815 17.479 14.4689 17.4979 14.4562 17.5169C14.1129 18.0321 13.7957 18.508 13.4905 18.8457C13.1609 19.2105 12.6836 19.5986 11.9981 19.5986C11.3125 19.5986 10.8352 19.2105 10.5056 18.8457C10.2004 18.508 9.88324 18.0321 9.53986 17.5169C9.52725 17.4979 9.51459 17.479 9.5019 17.4599L7.166 13.9561C6.96143 13.6492 6.94235 13.2547 7.11637 12.9295C7.29039 12.6044 7.62925 12.4014 7.99805 12.4014L10.998 12.4014L10.998 5.40137C10.998 4.84908 11.4458 4.40137 11.998 4.40137C12.5503 4.40137 12.998 4.84908 12.998 5.40137L12.998 12.4014L15.998 12.4014C16.3668 12.4014 16.7057 12.6044 16.8797 12.9295Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","discount","scroll-down","expand","minimize","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 14C8.38071 14 9.63071 14.5596 10.5355 15.4645C11.4404 16.3693 12 17.6193 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C15.6193 14 14.3693 14.5596 13.4645 15.4645C12.5596 16.3693 12 17.6193 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","dropdown","expand","collapse","menu","select","sort","filter","scroll-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 14C8.38071 14 9.63071 14.5596 10.5355 15.4645C11.4404 16.3693 12 17.6193 12 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C15.6193 14 14.3693 14.5596 13.4645 15.4645C12.5596 16.3693 12 17.6193 12 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom-left","previous","back","return","discount","apply-discount","navigate-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.14544 17.8631C7.6837 17.8617 7.12578 17.7733 6.67807 17.3256C6.23036 16.8779 6.14195 16.32 6.14064 15.8583C6.13945 15.4378 6.21321 14.9221 6.29179 14.3727C6.29484 14.3514 6.29789 14.33 6.30095 14.3086L6.92384 9.94846C6.9774 9.5735 7.23823 9.26098 7.59756 9.1412C7.95689 9.02142 8.35306 9.11495 8.62089 9.38278L10.9138 11.6757L16.1564 6.43303C16.547 6.04251 17.1801 6.04251 17.5706 6.43303C17.9612 6.82355 17.9612 7.45672 17.5706 7.84724L12.328 13.0899L14.6209 15.3828C14.8887 15.6506 14.9822 16.0468 14.8625 16.4061C14.7427 16.7654 14.4302 17.0263 14.0552 17.0798L9.69508 17.7027C9.67369 17.7058 9.65234 17.7088 9.63105 17.7119C9.08161 17.7905 8.56588 17.8642 8.14544 17.8631Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","bottom","left","return","go-back","previous","discount","apply-discount","coupon","previous-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 17L9 17C8.05719 17 7.58579 17 7.29289 16.7071C7 16.4142 7 15.9428 7 15L7 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","bottom","left","return","back","previous","undo","down","corner","exit","go-back","go-previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9996 7L11.3428 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 10L14 16L9.63986 16.6229C8.42993 16.7957 7.82496 16.8821 7.4714 16.5286C7.11785 16.175 7.20428 15.5701 7.37712 14.3601L8 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","bottom","left","return","back","undo","previous","menu","navigation","discount","apply-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 17L9 17C8.05719 17 7.58579 17 7.29289 16.7071C7 16.4142 7 15.9428 7 15L7 11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom-left","back","return","previous","navigate-back","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 15L9 15L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 9L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-bottom-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom","left","return","back","previous","go-back","menu","navigation","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L9.41423 16H13C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H9.00001C8.98186 18 8.96372 18 8.9456 18C8.52154 18.0001 8.10941 18.0002 7.7695 17.9545C7.38629 17.903 6.94902 17.7774 6.5858 17.4142L7.29291 16.7071L6.5858 17.4142C6.22258 17.051 6.09706 16.6137 6.04554 16.2305C5.99984 15.8906 5.99992 15.4785 6.00001 15.0544C6.00001 15.0363 6.00001 15.0182 6.00001 15L6.00001 11C6.00001 10.4477 6.44773 10 7.00001 10C7.5523 10 8.00001 10.4477 8.00001 11L8.00001 14.5858L16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-left-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","bottom-left","return","go-back","previous","undo","direction","navigation","discount","apply-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 9L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 15L9 15L9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","bottom-left","discount","navigate","back","return","previous","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 9L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14.6569 15L9 15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9V15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-bottom-left-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom","left","previous","back","return","undo","navigate-back","go-back","discount","apply-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8C9.55228 8 10 8.44772 10 9V12.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L11.4142 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H9C8.44772 16 8 15.5523 8 15V9C8 8.44772 8.44772 8 9 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-left-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom","left","back","previous","return","discount","apply-discount","go-back","navigate-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9996 7L11.3428 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.0508 15.9497L8.05078 9.94971"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16L9.63986 16.6229C8.42993 16.7957 7.82496 16.8821 7.4714 16.5286C7.11785 16.175 7.20428 15.5701 7.37712 14.3601L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-left-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","bottom","left","return","back","navigation","go-back","undo","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9996 7L11.3428 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.0508 15.9497L8.05078 9.94971"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16L9.63986 16.6229C8.42993 16.7957 7.82496 16.8821 7.4714 16.5286C7.11785 16.175 7.20428 15.5701 7.37712 14.3601L8 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-long-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","scroll-down","more","expand","open","minimize","collapse","dropdown","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 13.4L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L12 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L12 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-bottom-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","bottom-left","return","back","previous","undo","go-back","discount","previous-page","navigation","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 17L9 17C8.05719 17 7.58579 17 7.29289 16.7071C7 16.4142 7 15.9428 7 15L7 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-bottom-long-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","scroll-down","collapse","minimize","load-more","show-more","decrease","lower","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7052 14.2951C17.0957 14.6856 17.0957 15.3188 16.7052 15.7093L12.7193 19.6952L12.713 19.7014C12.7098 19.7045 12.704 19.7103 12.6968 19.7171C12.6848 19.7285 12.6537 19.7578 12.6108 19.7906C12.5196 19.8601 12.3067 19.998 11.998 19.998C11.6894 19.998 11.4765 19.8601 11.3853 19.7906C11.3424 19.7578 11.3113 19.7285 11.2993 19.7171C11.2921 19.7103 11.2863 19.7045 11.2831 19.7014L11.2768 19.6952L7.29094 15.7093C6.90041 15.3188 6.90041 14.6856 7.29094 14.2951C7.68146 13.9046 8.31463 13.9046 8.70515 14.2951L10.998 16.588L10.998 5.00219C10.998 4.4499 11.4458 4.00219 11.998 4.00219C12.5503 4.00219 12.998 4.4499 12.998 5.00219L12.998 16.588L15.2909 14.2951C15.6815 13.9046 16.3146 13.9046 16.7052 14.2951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-bottom-long": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","arrow-down","download","load","scroll-down","more","expand","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 13.4L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","reduce","minimize","scroll-down","dropdown","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L16 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-bottom-long-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","arrow-down","download","expand","scroll-down","more","dropdown","menu","load-more","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 13.4L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L12 19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L12 19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-circle-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","down","scroll-down","expand","more","options","menu","dropdown","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 11L12 13L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-bottom-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","circle","bottom","expand","collapse","more","options","menu","dropdown","scroll-down","load-more","show-more","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 11L12 13L10 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","down","scroll-down","more","expand","view-more","collapse","hide","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L12 11.5858L10.7071 10.2929C10.3166 9.90237 9.68342 9.90237 9.29289 10.2929C8.90237 10.6834 8.90237 11.3166 9.29289 11.7071L11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071L14.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","bottom","download","load-more","scroll-down","expand","see-more","menu","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 11L12 13L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","arrow","down","save","export","get","receive","import","discount","apply-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L12 15L14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","down","download","reduce","decrease","lower","dropdown","scroll-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11C20 15.4183 16.4183 19 12 19C7.58172 19 4 15.4183 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L12 14M12 14L10 12M12 14V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","download","decrease","reduce","lower","discount","scroll-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 20C16.9706 20 21 15.9706 21 11C21 6.02944 16.9706 2 12 2C7.02944 2 3 6.02944 3 11C3 15.9706 7.02944 20 12 20ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11.5858L10.7071 11.2929C10.3166 10.9024 9.68342 10.9024 9.29289 11.2929C8.90237 11.6834 8.90237 12.3166 9.29289 12.7071L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929C14.3166 10.9024 13.6834 10.9024 13.2929 11.2929L13 11.5858V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-down-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","down-left","return","back","previous","undo","recall","transaction-history","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L10 14L13 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","circle","down","left","return","discount","refund","previous","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 13L14 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L10 14L13 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","down","left","return","previous","back","undo","move-back","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.4142 13L14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L11 11.5858V11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11V14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H12.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-down-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","direction","left","down","previous","back","return","undo","refund","discount","apply-discount","navigate-back","go-back","sale","lower-price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L10 14L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","down","right","sales","report","download","export","move","direction","navigate","next","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L10 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L14 14L14 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","circle","down","right","move","next","select","choose","navigate","confirm","arrow-down-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L14 14L14 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","download","next","submit","confirm","select","continue","proceed","circle","right","down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L11.5858 13H11C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V11.5858L10.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","down","download","receive","get","import","receive-payment","get-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L12 15L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-down-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","down","right","direction","download","save","export","receive","incoming","transfer","transaction","confirm","select","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L14 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-lef-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","return","arrow","circle","left","undo","cancel","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14L11 12L13 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-lef-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","arrow","navigation","return","undo","left","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14L11 12L13 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-lef-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","left","back","previous","navigation","return","undo","cancel","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13.7071 13.2929C14.0976 13.6834 14.0976 14.3166 13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071L10.2929 12.7071C10.1054 12.5196 10 12.2652 10 12C10 11.7348 10.1054 11.4804 10.2929 11.2929L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L12.4142 12L13.7071 13.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-lef": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow","circle","undo","history","go-back","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14L11 12L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","return","arrow","left","circle","undo","reverse","cancel","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10L9 12L11 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","return","arrow","left","undo","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 14L9 12M9 12L11 10M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","undo","reverse","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H11.4142L11.7071 10.7071C12.0976 10.3166 12.0976 9.68342 11.7071 9.29289C11.3166 8.90237 10.6834 8.90237 10.2929 9.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071C12.0976 14.3166 12.0976 13.6834 11.7071 13.2929L11.4142 13H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10L9 12L11 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","right","circle","next","continue","proceed","forward","checkout","payment","submit","go","enter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 14L15 12M15 12L13 10M15 12L9 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","circle","next","proceed","continue","submit","checkout","payment","complete","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L9 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L15 12L13 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","next","right","circle","forward","continue","proceed","checkout","payment","submit","next-step"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H12.5858L12.2929 10.7071C11.9024 10.3166 11.9024 9.68342 12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071C11.9024 14.3166 11.9024 13.6834 12.2929 13.2929L12.5858 13H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","right","next","proceed","forward","continue","checkout","payment","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 14L13 12L11 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","right","next","proceed","continue","forward","go"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 14L13 12L11 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","right","circle","next","proceed","continue","forward","enter","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 14L13 12L11 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","forward","continue","proceed","checkout","navigation","circle","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10.2929 13.2929C9.90237 13.6834 9.90237 14.3166 10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12C14 11.7348 13.8946 11.4804 13.7071 11.2929L11.7071 9.29289C11.3166 8.90237 10.6834 8.90237 10.2929 9.29289C9.90237 9.68342 9.90237 10.3166 10.2929 10.7071L11.5858 12L10.2929 13.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","proceed","continue","arrow","right","submit","checkout","payment","process","circle","validate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L15 12L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-top-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","scroll","top","move-up","navigation","sort-ascending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13L12 11L14 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-top-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","up","scroll-up","move-up","navigate-up","sort-ascending","back-to-top","increase","quantity-up","page-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13L12 11L14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","scroll-up","back-to-top","sort-ascending","previous","circle","navigate-up","inventory-increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929L9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L12 12.4142L13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929L12.7071 10.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-up-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","arrow-up","up","circle","scroll-up","increase","quantity","upload","move-up","raise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L12 9L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","circle","scroll-up","move-up","sort-ascending","sort-up","return","back","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13L12 11L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","increase","raise","upload","scroll-up","navigate-up","sort-ascending","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 11L12 9M12 9L10 11M12 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","circle","scroll","scroll-up","inventory","increase","quantity","sort","sort-up","upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 11.4142V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V11.4142L10.7071 11.7071C10.3166 12.0976 9.68342 12.0976 9.29289 11.7071C8.90237 11.3166 8.90237 10.6834 9.29289 10.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L14.7071 10.2929C15.0976 10.6834 15.0976 11.3166 14.7071 11.7071C14.3166 12.0976 13.6834 12.0976 13.2929 11.7071L13 11.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-up-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","up","left","previous","back","return","undo","navigation","go-back","move","history","customer-history","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10L14 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","left","return","back","circle","previous","move","navigate","direction","history","undo","circle-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 11L14 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","up","left","previous","back","return","navigation","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10 9C9.44772 9 9 9.44772 9 10V13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13V12.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L12.4142 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-up-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","up","left","previous","back","return","navigate-back","undo","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","circle","direction","forward","advance","submit","send","next","continue","proceed","checkout","payment","approval","move-forward","go-ahead"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L14 10L11 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","circle","direction","go","next","proceed","forward","advance","submit","send","checkout","approve","complete","payment","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 11L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L14 10L11 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-circle-up-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","up","right","forward","next","proceed","continue","send","submit","complete","export","upload","move-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11H11.5858L9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L13 12.4142V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V10C15 9.73478 14.8946 9.48043 14.7071 9.29289C14.5196 9.10536 14.2652 9 14 9H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-up-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","circle","right","up","next","forward","proceed","continue","advance","complete","confirm","submit","payment","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L14 10L11 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["click","select","choose","confirm","arrow","cursor","action","tap","submit","interact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99951L6 5.99951" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0005H4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.0005 8L18 6M6 18L8.00049 15.9995"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4949 14.4949L14.7454 14.3385C16.6312 13.1613 17.5741 12.5726 17.4393 11.895C17.3044 11.2174 16.208 11.0347 14.0151 10.6692L12.7619 10.4603C11.5029 10.2505 10.8733 10.1456 10.5094 10.5094C10.1456 10.8733 10.2505 11.5029 10.4603 12.7619L10.6692 14.0151C11.0347 16.208 11.2174 17.3044 11.895 17.4393C12.5726 17.5741 13.1613 16.6312 14.3385 14.7454L14.4949 14.4949ZM14.4949 14.4949L20 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["click","select","choose","tap","arrow","cursor","interaction","confirm","submit","payment","process","next","action"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99951L6 5.99951" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0005H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.0005 8L18 6M6 18L8.00049 15.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.6695 14.0149L10.4606 12.7617C10.2508 11.5027 10.1459 10.8731 10.5097 10.5093C10.8736 10.1454 11.5032 10.2503 12.7622 10.4601L14.0154 10.669C16.2083 11.0345 17.3047 11.2172 17.4396 11.8948C17.5744 12.5724 16.6315 13.1611 14.7457 14.3383L14.4952 14.4947L14.3388 14.7452C13.1616 16.631 12.5729 17.574 11.8953 17.4391C11.2177 17.3042 11.035 16.2078 10.6695 14.0149Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M14.4952 14.4947L14.7457 14.3383C16.6315 13.1611 17.5744 12.5724 17.4396 11.8948C17.3047 11.2172 16.2083 11.0345 14.0154 10.669L12.7622 10.4601C11.5032 10.2503 10.8736 10.1454 10.5097 10.5093C10.1459 10.8731 10.2508 11.5027 10.4606 12.7617L10.6695 14.0149C11.035 16.2078 11.2177 17.3042 11.8953 17.4391C12.5729 17.574 13.1616 16.631 14.3388 14.7452L14.4952 14.4947ZM14.4952 14.4947L20.0003 19.9998"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["click","select","choose","tap","interact","selection","touch","arrow","cursor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.669 14.0149L10.4602 12.7617C10.2503 11.5027 10.1454 10.8732 10.5093 10.5093C10.8732 10.1454 11.5027 10.2503 12.7617 10.4601L14.0149 10.669C16.2078 11.0345 17.3043 11.2172 17.4391 11.8948C17.574 12.5725 16.6311 13.1611 14.7452 14.3384L14.4947 14.4947L14.3384 14.7452C13.1611 16.631 12.5725 17.574 11.8949 17.4391C11.2172 17.3042 11.0345 16.2078 10.669 14.0149Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9997 3C12.552 3 12.9997 3.44772 12.9997 4V7C12.9997 7.55228 12.552 8 11.9997 8C11.4474 8 10.9997 7.55228 10.9997 7V4C10.9997 3.44772 11.4474 3 11.9997 3ZM5.29308 5.29238C5.68365 4.9019 6.31682 4.90198 6.7073 5.29255L8.70681 7.29255C9.09728 7.68312 9.09721 8.31629 8.70663 8.70676C8.31606 9.09724 7.6829 9.09716 7.29242 8.70659L5.29291 6.70659C4.90243 6.31602 4.90251 5.68285 5.29308 5.29238ZM18.7074 5.29263C19.0979 5.68311 19.098 6.31628 18.7075 6.70685L16.708 8.70685C16.3175 9.09742 15.6844 9.0975 15.2938 8.70702C14.9032 8.31654 14.9032 7.68338 15.2936 7.29281L17.2931 5.29281C17.6836 4.90224 18.3168 4.90216 18.7074 5.29263ZM12.8608 9.46285C12.8825 9.46647 12.9043 9.47011 12.9261 9.47375L14.2565 9.69547C15.287 9.86717 16.165 10.0134 16.7963 10.2101C17.3863 10.394 18.2329 10.7603 18.4199 11.6996C18.6068 12.639 17.9649 13.3016 17.4903 13.6973C17.1325 13.9956 16.6521 14.3176 16.0895 14.6753L20.707 19.2927C21.0975 19.6832 21.0975 20.3164 20.707 20.7069C20.3164 21.0975 19.6833 21.0975 19.2927 20.7069L14.6753 16.0895C14.3176 16.6521 13.9956 17.1325 13.6973 17.4903C13.3016 17.9649 12.639 18.6068 11.6997 18.4199C10.7603 18.2329 10.394 17.3862 10.2102 16.7962C10.0135 16.165 9.86719 15.287 9.69549 14.2565L9.47377 12.9261C9.47013 12.9043 9.46649 12.8825 9.46286 12.8607C9.36729 12.2879 9.27817 11.7537 9.26976 11.3192C9.26058 10.845 9.33929 10.2651 9.80218 9.80217C10.2651 9.33928 10.8451 9.26057 11.3192 9.26975C11.7537 9.27816 12.2879 9.36728 12.8608 9.46285ZM3 12.0002C3 11.4479 3.44772 11.0002 4 11.0002H7C7.55228 11.0002 8 11.4479 8 12.0002C8 12.5525 7.55228 13.0002 7 13.0002H4C3.44772 13.0002 3 12.5525 3 12.0002ZM8.70793 15.2922C9.09845 15.6828 9.09845 16.3159 8.70793 16.7064L6.70744 18.7069C6.31691 19.0975 5.68375 19.0975 5.29322 18.7069C4.9027 18.3164 4.9027 17.6832 5.29322 17.2927L7.29371 15.2922C7.68424 14.9017 8.3174 14.9017 8.70793 15.2922Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-click-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","click","select","pointer","cursor","action","confirm","submit","input","interact","press"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99976L6 5.99976" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0002H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7.00024L12 4.00024" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.0005 8L18 6M6 18L8.00049 15.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.6075 15.2524L11.3771 13.6399C11.2043 12.4299 11.1179 11.825 11.4714 11.4714C11.825 11.1179 12.4299 11.2043 13.6399 11.3771L15.3006 11.6144C17.369 11.9099 18.4032 12.0576 18.6248 12.5735C18.6891 12.7233 18.7159 12.8865 18.7027 13.0491C18.6572 13.6087 17.7242 14.0786 15.8582 15.0186L15.8582 15.0186C15.6235 15.1368 15.5061 15.1959 15.4095 15.2812C15.379 15.3081 15.3502 15.3369 15.3232 15.3673C15.2376 15.4637 15.1781 15.5811 15.0589 15.8159C14.0858 17.7338 13.5992 18.6928 13.0186 18.7208C12.8769 18.7277 12.7354 18.7043 12.6034 18.6522C12.0627 18.4389 11.911 17.3767 11.6075 15.2524Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["click","tap","select","choose","interact","pointer","cursor","touch","arrow","arrow-click","confirmation","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99976L6 5.99976" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0002H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7.00024L12 4.00024" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L8.00049 15.9995" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16.001 8L18.0005 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.6075 15.2524L11.3771 13.6399C11.2043 12.4299 11.1179 11.825 11.4714 11.4714C11.825 11.1179 12.4299 11.2043 13.6399 11.3771L15.3006 11.6144C17.369 11.9099 18.4032 12.0576 18.6248 12.5735C18.6891 12.7233 18.7159 12.8865 18.7027 13.0491C18.6572 13.6087 17.7242 14.0786 15.8582 15.0186L15.8582 15.0186C15.6235 15.1368 15.5061 15.1959 15.4095 15.2812C15.379 15.3081 15.3502 15.3369 15.3232 15.3673C15.2376 15.4637 15.1781 15.5811 15.0589 15.8159C14.0858 17.7338 13.5992 18.6928 13.0186 18.7208C12.8769 18.7277 12.7354 18.7043 12.6034 18.6522C12.0627 18.4389 11.911 17.3767 11.6075 15.2524Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["click","select","choose","arrow","pointer","touch","pos-interaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99976L6 5.99976" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0002H4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7.00024L12 4.00024" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.0005 8L18 6M6 18L8.00049 15.9995"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.6075 15.2524L11.3771 13.6399C11.2043 12.4299 11.1179 11.825 11.4714 11.4714C11.825 11.1179 12.4299 11.2043 13.6399 11.3771L15.3006 11.6144C17.369 11.9099 18.4032 12.0576 18.6248 12.5735C18.6891 12.7233 18.7159 12.8865 18.7027 13.0491C18.6572 13.6087 17.7242 14.0786 15.8582 15.0186L15.8582 15.0186C15.6235 15.1368 15.5061 15.1959 15.4095 15.2812C15.379 15.3081 15.3502 15.3369 15.3232 15.3673C15.2376 15.4637 15.1781 15.5811 15.0589 15.8159C14.0858 17.7338 13.5992 18.6928 13.0186 18.7208C12.8769 18.7277 12.7354 18.7043 12.6034 18.6522C12.0627 18.4389 11.911 17.3767 11.6075 15.2524Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","click","select","choose","tap","interact","navigation","submit","confirm","payment","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.04308 5.29238C6.43365 4.9019 7.06682 4.90198 7.4573 5.29255L9.45681 7.29255C9.84728 7.68312 9.84721 8.31628 9.45663 8.70676C9.06606 9.09724 8.4329 9.09716 8.04242 8.70659L6.04291 6.70659C5.65243 6.31602 5.65251 5.68285 6.04308 5.29238Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.75 12.0002C3.75 11.4479 4.19772 11.0002 4.75 11.0002H7.75C8.30228 11.0002 8.75 11.4479 8.75 12.0002C8.75 12.5525 8.30228 13.0002 7.75 13.0002H4.75C4.19772 13.0002 3.75 12.5525 3.75 12.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7497 3C13.302 3 13.7497 3.44772 13.7497 4V7C13.7497 7.55228 13.302 8 12.7497 8C12.1974 8 11.7497 7.55228 11.7497 7V4C11.7497 3.44772 12.1974 3 12.7497 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.45793 15.2922C9.84845 15.6828 9.84845 16.3159 9.45793 16.7064L7.45744 18.7069C7.06691 19.0975 6.43375 19.0975 6.04322 18.7069C5.6527 18.3164 5.6527 17.6832 6.04322 17.2927L8.04371 15.2922C8.43424 14.9017 9.0674 14.9017 9.45793 15.2922Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4574 5.29263C19.8479 5.68311 19.848 6.31628 19.4575 6.70685L17.458 8.70685C17.0675 9.09742 16.4344 9.0975 16.0438 8.70702C15.6532 8.31654 15.6532 7.68338 16.0436 7.29281L18.0431 5.29281C18.4336 4.90223 19.0668 4.90216 19.4574 5.29263Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.4436 10.627L16.2047 10.8786C17.198 11.0205 18.0057 11.1359 18.5897 11.2842C18.8885 11.3601 19.1774 11.4559 19.4226 11.595C19.6753 11.7383 19.9241 11.9523 20.0637 12.2773C20.1763 12.5394 20.2232 12.8252 20.2001 13.1096C20.1714 13.4621 20.0039 13.7443 19.8102 13.9607C19.6221 14.1708 19.3789 14.3538 19.1199 14.5211C18.6138 14.8479 17.8851 15.215 16.989 15.6663L16.9454 15.6883C16.8217 15.7506 16.7531 15.7854 16.7025 15.8141C16.6703 15.8324 16.6584 15.8412 16.6555 15.8434C16.6479 15.8501 16.6407 15.8573 16.634 15.8649C16.6317 15.8678 16.6229 15.8798 16.6045 15.9119C16.5755 15.9626 16.5404 16.0313 16.4776 16.155L16.4549 16.1998C15.9876 17.1209 15.6076 17.8697 15.2691 18.3874C15.0959 18.6522 14.906 18.9007 14.6873 19.0908C14.4609 19.2875 14.1673 19.4523 13.8045 19.4698C13.5566 19.4817 13.3089 19.4408 13.078 19.3497C12.7406 19.2166 12.5156 18.9666 12.3645 18.7076C12.2185 18.4576 12.1187 18.1615 12.04 17.8556C11.8862 17.2576 11.7677 16.428 11.622 15.4081L11.3771 13.6936C11.297 13.1335 11.2256 12.634 11.2267 12.2322C11.2279 11.7992 11.3109 11.3209 11.6909 10.9409C12.0709 10.5609 12.5492 10.4779 12.9822 10.4767C13.384 10.4756 13.8835 10.547 14.4436 10.627Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-circle-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","circle","scroll-up","return","go-back","top","scroll-to-top","move-up","increase","raise","upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L12 9L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-crop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["crop","focus","resize","selection","area","adjust","frame","target","image-edit","edit-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H11C13.8285 7 15.2427 7 16.1213 7.87868C17 8.75736 17 10.1716 17 13V19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L13 17C10.1715 17 8.75733 17 7.87865 16.1213C6.99997 15.2426 6.99997 13.8284 6.99997 11L6.99997 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-crop-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["crop","focus","select","area","target","selection","customize","view","zoom","edit","image-editing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H11C13.8285 7 15.2427 7 16.1213 7.87868C17 8.75736 17 10.1716 17 13V19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L13 17C10.1715 17 8.75733 17 7.87865 16.1213C6.99997 15.2426 6.99997 13.8284 6.99997 11L6.99997 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-click": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","click","select","tap","choose","interact","perform","done","confirm","action","go","proceed","selection","input"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99951 7.99951L6 5.99951" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12.0005H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.0005 8L18 6M6 18L8.00049 15.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4949 14.4949L14.7454 14.3385C16.6312 13.1613 17.5741 12.5726 17.4393 11.895C17.3044 11.2174 16.208 11.0347 14.0151 10.6692L12.7619 10.4603C11.5029 10.2505 10.8733 10.1456 10.5094 10.5094C10.1456 10.8733 10.2505 11.5029 10.4603 12.7619L10.6692 14.0151C11.0347 16.208 11.2174 17.3044 11.895 17.4393C12.5726 17.5741 13.1613 16.6312 14.3385 14.7454L14.4949 14.4949ZM14.4949 14.4949L20 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-crop": {
        defaultColors: ["#3D4C66"],
        keywords: ["crop","selection","area","focus","zoom","select","edit","resize","transform","frame"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H11C13.8285 7 15.2427 7 16.1213 7.87868C17 8.75736 17 10.1716 17 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L13 17C10.1715 17 8.75733 17 7.87865 16.1213C6.99997 15.2426 6.99997 13.8284 6.99997 11L6.99997 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-double-chevrons-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","rewind","go-back","return","chevron-left","double-arrow","navigation-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L7 12L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L12 12L17 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-crop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crop","trim","select","area","focus","modify","edit","image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.99997 4C7.55226 4 7.99997 4.44772 7.99997 5L7.99997 6L11.0706 6C12.4247 5.99996 13.5413 5.99993 14.4251 6.11875C15.3529 6.2435 16.1723 6.51546 16.8285 7.17157C17.4846 7.82768 17.7565 8.64711 17.8813 9.57494C18.0001 10.4587 18.0001 11.5753 18 12.9294L18 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H18V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V18L12.9294 18C11.5753 18 10.4587 18.0001 9.57491 17.8812C8.64708 17.7565 7.82766 17.4845 7.17155 16.8284C6.51544 16.1723 6.24347 15.3529 6.11873 14.4251C5.99991 13.5413 5.99994 12.4247 5.99997 11.0706L5.99997 8H5C4.44772 8 4 7.55229 4 7C4 6.44772 4.44772 6 5 6H5.99997L5.99997 5C5.99997 4.44772 6.44769 4 6.99997 4ZM7.99997 8L7.99997 11C7.99997 12.4425 8.0021 13.4237 8.10089 14.1586C8.19582 14.8646 8.36319 15.1916 8.58576 15.4142C8.80833 15.6368 9.13535 15.8042 9.84141 15.8991C10.5762 15.9979 11.5575 16 13 16H16V13C16 11.5575 15.9979 10.5763 15.8991 9.84143C15.8042 9.13538 15.6368 8.80836 15.4142 8.58579C15.1917 8.36322 14.8646 8.19585 14.1586 8.10092C13.4238 8.00212 12.4425 8 11 8H7.99997Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-double-chevrons-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","rewind","return","navigation","arrow-left","page-back","scroll-left","item-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L7 12L12 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L12 12L17 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-double-chevrons-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","navigation","arrow-left","scroll-left","page-back","previous-page","go-back","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7071 6.29289C13.0976 6.68342 13.0976 7.31658 12.7071 7.70711L8.41421 12L12.7071 16.2929C13.0976 16.6834 13.0976 17.3166 12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929L11.2929 6.29289C11.6834 5.90237 12.3166 5.90237 12.7071 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L13.4142 12L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929L16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-double-chevrons-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","return","navigation","history","scroll-left","double-arrow-left","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L7 12L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L12 12L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-double-chevrons-right-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","advance","forward","double-arrow","move-forward","scroll","continue","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L16 12L10 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L11 12L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-double-chevrons-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","double-arrow","right","next","advance","scroll","forward","continue","process","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L16 12L10 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L11 12L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-double-chevrons-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","double-arrow","right","next","advance","proceed","skip","forward","fast-forward","scroll","continue","move-forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.29289 5.29289C8.90237 5.68342 8.90237 6.31658 9.29289 6.70711L14.5858 12L9.29289 17.2929C8.90237 17.6834 8.90237 18.3166 9.29289 18.7071C9.68342 19.0976 10.3166 19.0976 10.7071 18.7071L16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711L9.58579 12L7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L11.7071 12.7071C12.0976 12.3166 12.0976 11.6834 11.7071 11.2929L8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-double-chevrons-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","double-arrow","skip","advance","proceed","arrow","right","chevron-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L16 12L10 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L11 12L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-down-left-and-arrow-up-right-to-center-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["minimize","shrink","reduce","compress","close","exit","compact","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 19L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 5L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 13H11V18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L13 11L13 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-down-left-and-arrow-up-right-to-center-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minimize","collapse","reduce","arrows","shrink","compress","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13H11V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L11 13" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 11L13 11L13 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 5L13 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-down-left-and-arrow-up-right-to-center-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","reduce","compact","compress","shrink","collapse","hide","close","exit","remove","decrease","condense","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 13C5 12.4477 5.44772 12 6 12H11C11.5523 12 12 12.4477 12 13V18C12 18.5523 11.5523 19 11 19C10.4477 19 10 18.5523 10 18V15.4142L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.58579 14H6C5.44772 14 5 13.5523 5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.4142 10L18 10C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12L13 12C12.7348 12 12.4804 11.8946 12.2929 11.7071C12.1054 11.5196 12 11.2652 12 11V6C12 5.44772 12.4477 5 13 5C13.5523 5 14 5.44772 14 6V8.58579L18.2929 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-down-left-and-arrow-up-right-to-center": {
        defaultColors: ["#3D4C66"],
        keywords: ["compress","minimize","shrink","reduce","decrease","compact","consolidate","collapse","hide","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13H11V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 11L13 11L13 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 5L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-down-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","right","next","proceed","continue","select","choose","enter","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 16L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 11L17 15C17 15.9428 17 16.4142 16.7071 16.7071C16.4142 17 15.9428 17 15 17L11 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-down-right-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","arrow-down","arrow-right","next","continue","proceed","select","choose","pick","go-to"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8587 17.8631C16.3205 17.8617 16.8784 17.7733 17.3261 17.3256C17.7738 16.8779 17.8622 16.32 17.8635 15.8583C17.8647 15.4378 17.7909 14.9221 17.7124 14.3727C17.7093 14.3514 17.7063 14.33 17.7032 14.3086L17.0803 9.94846C17.0268 9.5735 16.7659 9.26098 16.4066 9.1412C16.0473 9.02142 15.6511 9.11495 15.3833 9.38278L13.0904 11.6757L7.84773 6.43303C7.45721 6.04251 6.82404 6.04251 6.43352 6.43303C6.04299 6.82355 6.04299 7.45672 6.43352 7.84724L11.6762 13.0899L9.38326 15.3828C9.11543 15.6506 9.02191 16.0468 9.14169 16.4061C9.26146 16.7654 9.57398 17.0263 9.94894 17.0798L14.3091 17.7027C14.3305 17.7058 14.3518 17.7088 14.3731 17.7119C14.9225 17.7905 15.4383 17.8642 15.8587 17.8631Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-down-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","right","move","select","choose","direction","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 16L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 11L17 15C17 15.9428 17 16.4142 16.7071 16.7071C16.4142 17 15.9428 17 15 17L11 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-down-right-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","right","direction","next","continue","proceed","go-to","select","choose","confirm","submission","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05078 7L12.7076 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 10L10 16L14.3601 16.6229C15.5701 16.7957 16.175 16.8821 16.5286 16.5286C16.8821 16.175 16.7957 15.5701 16.6229 14.3601L16 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-down-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","navigation","next","continue","redirect","select","discount","apply-discount","lower-price","reduce","checkout","confirm","download","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L16 14.5858V11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11V15C18 15.0182 18 15.0363 18 15.0544C18.0001 15.4785 18.0002 15.8906 17.9545 16.2305C17.903 16.6137 17.7774 17.051 17.4142 17.4142C17.051 17.7774 16.6137 17.9029 16.2305 17.9545C15.8906 18.0002 15.4785 18.0001 15.0544 18C15.0363 18 15.0182 18 15 18L11 18C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16L14.5858 16L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-down-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","right","direction","move","select","choose","next","continue","checkout","process","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 9L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15L15 15L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-down-right-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","right","next","continue","proceed","download","corner","transition","move-to-next","skip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 9L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9V15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L15 15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-down-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","select","choose","decrease","navigate","direction","next","continue","go-to","discount","apply-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L14 12.5858V9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H12.5858L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-down-right-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","direction","select","choose","navigate","next","move","checkout","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05078 7L12.7076 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15.9497L16 9.94971" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 16L14.3601 16.6229C15.5701 16.7957 16.175 16.8821 16.5286 16.5286C16.8821 16.175 16.7957 15.5701 16.6229 14.3601L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-down-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","navigate","next","direction","continue","scroll-down","move","transfer","download"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 16L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 11L17 15C17 15.9428 17 16.4142 16.7071 16.7071C16.4142 17 15.9428 17 15 17L11 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-down-right-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","right","direction","next","continue","scroll-down","go-to"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05078 7L12.7076 12.6569" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15.9497L16 9.94971" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 16L14.3601 16.6229C15.5701 16.7957 16.175 16.8821 16.5286 16.5286C16.8821 16.175 16.7957 15.5701 16.6229 14.3601L16 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-download-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","arrow","import","get","receive","update","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 11L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 19H17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13L13.4142 15.5858C12.7475 16.2525 12.4142 16.5858 12 16.5858C11.5858 16.5858 11.2525 16.2525 10.5858 15.5858L8 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-download-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","import","receive","arrow","arrow-down","get","data","export","receive-data","download-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 11L12 15" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 19H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13L14.8284 14.1716C13.4951 15.5049 12.8284 16.1716 12 16.1716C11.1716 16.1716 10.5049 15.5049 9.17157 14.1716L8 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow","import","data","receive","get","update","restore","backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5L13 14.5556C13.2968 14.2876 13.6529 13.9329 14.1213 13.4645L15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929C17.0976 12.6834 17.0976 13.3166 16.7071 13.7071L15.489 14.9252C14.8622 15.5521 14.3221 16.0922 13.8315 16.4666C13.3056 16.8678 12.7208 17.1716 12 17.1716C11.2792 17.1716 10.6944 16.8678 10.1685 16.4666C9.67789 16.0922 9.13782 15.5521 8.51101 14.9252L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929L9.87868 13.4645C10.3471 13.9329 10.7032 14.2876 11 14.5556L11 5C11 4.44772 11.4477 4 12 4ZM6 19C6 18.4477 6.44772 18 7 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-down-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","right","navigation","direction","next","checkout","confirm","select","submit","continue","proceed","discount","apply-discount","arrow-down-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L15 15L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 9L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-download": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow","import","receive","get","data","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 11L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 19H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13L13.4142 15.5858C12.7475 16.2525 12.4142 16.5858 12 16.5858C11.5858 16.5858 11.2525 16.2525 10.5858 15.5858L8 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-grow-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["decrease","down","arrow","decline","sales-decrease","revenue-decrease","loss","discount","price-drop","trending-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L11 9L8 12L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11V16H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-grow-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","decline","reduction","sales-down","performance-down","report","negative-trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 7.29289C4.68342 6.90237 5.31658 6.90237 5.70711 7.29289L8 9.58579L10.2929 7.29289C10.4804 7.10536 10.7348 7 11 7C11.2652 7 11.5196 7.10536 11.7071 7.29289L18 13.5858L18 11C18 10.4477 18.4477 10 19 10C19.5523 10 20 10.4477 20 11L20 16C20 16.2652 19.8946 16.5196 19.7071 16.7071C19.5196 16.8946 19.2652 17 19 17L14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15L16.5858 15L11 9.41421L8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12C7.73478 12 7.48043 11.8946 7.29289 11.7071L4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-grow-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decrease","decline","sales","discount","price-drop","reduction","loss","trend-down","falling"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L11 9L8 12L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11V16H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-grow-down-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","down","decrease","decline","sales","decrease-sales","discount","price-drop","decrease-price","markdown","loss","inventory","reduction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16L11 8L8 11L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16L19 16L19 11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-grow-top-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","grow","top","increase","sales","profit","growth","trending","rising","charts","metrics","analytics","performance","arrow-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L11 16L8 13L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H19V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-grow-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","increase","sales","growth","trend","analytics","revenue","profit","performance","up","rising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 16.7071C4.68342 17.0976 5.31658 17.0976 5.70711 16.7071L8 14.4142L10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17C11.2652 17 11.5196 16.8946 11.7071 16.7071L18 10.4142L18 13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13L20 8C20 7.73478 19.8946 7.48043 19.7071 7.29289C19.5196 7.10536 19.2652 7 19 7L14 7C13.4477 7 13 7.44772 13 8C13 8.55229 13.4477 9 14 9L16.5858 9L11 14.5858L8.70711 12.2929C8.51957 12.1054 8.26522 12 8 12C7.73478 12 7.48043 12.1054 7.29289 12.2929L4.29289 15.2929C3.90237 15.6834 3.90237 16.3166 4.29289 16.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-grow-top-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","grow","top","increase","sales","rise","trend","growth","performance","profit","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 8L11 16L8 13L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H19V13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-grow-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","grow","increase","sales","revenue","trending","top","up","growth","rising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L11 16L8 13L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H19V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-growth-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","growth","increase","trending","sales","profit","revenue","performance","up","rising","success","positive","improvement","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.53 10.5303C14.8229 10.2374 14.8229 9.76256 14.53 9.46967C14.2371 9.17678 13.7622 9.17678 13.4693 9.46967L14.53 10.5303ZM5.81244 17.1265C5.51955 17.4194 5.51955 17.8943 5.81244 18.1872C6.10534 18.4801 6.58021 18.4801 6.8731 18.1872L5.81244 17.1265ZM13.4693 9.46967L5.81244 17.1265L6.8731 18.1872L14.53 10.5303L13.4693 9.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 10H14V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-growth-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","growth","sales","increase","trend","rising","progress","performance","analytics","report","revenue","up","arrow-up","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 14.125 3.73647 16.078 4.9681 17.6177L11.5858 11H9.99997C9.44768 11 8.99997 10.5523 8.99997 10C8.99997 9.44772 9.44768 9 9.99997 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15C13.4477 15 13 14.5523 13 14V12.4142L6.38231 19.0319C7.92198 20.2635 9.87499 21 12 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-growth": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","growth","increase","sales","revenue","analytics","trending","progress","forward","trend","reports","metrics","forecast","arrow-up-right","circle-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.53 10.5303C14.8229 10.2374 14.8229 9.76256 14.53 9.46967C14.2371 9.17678 13.7622 9.17678 13.4693 9.46967L14.53 10.5303ZM5.81244 17.1265C5.51955 17.4194 5.51955 17.8943 5.81244 18.1872C6.10534 18.4801 6.58021 18.4801 6.8731 18.1872L5.81244 17.1265ZM13.4693 9.46967L5.81244 17.1265L6.8731 18.1872L14.53 10.5303L13.4693 9.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 10H14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-growth-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","growth","increase","sales","upward","trend","analytics","reporting","profit","positive","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.53 10.5303C14.8229 10.2374 14.8229 9.76256 14.53 9.46967C14.2371 9.17678 13.7622 9.17678 13.4693 9.46967L14.53 10.5303ZM5.81244 17.1265C5.51955 17.4194 5.51955 17.8943 5.81244 18.1872C6.10534 18.4801 6.58021 18.4801 6.8731 18.1872L5.81244 17.1265ZM13.4693 9.46967L5.81244 17.1265L6.8731 18.1872L14.53 10.5303L13.4693 9.46967Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M10 10H14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","left","back","return","previous","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12H13.4H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L7 12L11 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["back","previous","return","arrow-left","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C6.38071 12 7.63071 11.4404 8.53553 10.5355C9.44036 9.63071 10 8.38071 10 7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12C6.38071 12 7.63071 12.5596 8.53553 13.4645C9.44036 14.3693 10 15.6193 10 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","return","previous","undo","cancel","go-back","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6C10.5523 6 11 6.44772 11 7C11 8.53636 10.4214 9.93922 9.47219 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L9.47219 13C10.4214 14.0608 11 15.4636 11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17C9 15.8952 8.55338 14.8965 7.82843 14.1716C7.10348 13.4466 6.10485 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C6.10485 11 7.10347 10.5534 7.82843 9.82843C8.55338 9.10347 9 8.10485 9 7C9 6.44772 9.44772 6 10 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","go-back","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16C9.27645 13.8047 7.89876 12.2908 5 12C7.89876 11.7092 9.27645 10.1953 11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","left","back","return","previous","go-back","undo","navigation","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16C9.27645 13.8047 7.89876 12.2908 5 12C7.89876 11.7092 9.27645 10.1953 11 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","go-back","reverse","retreat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16C9.27645 13.8047 7.89876 12.2908 5 12C7.89876 11.7092 9.27645 10.1953 11 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6175 7.21349C12.0519 7.55455 12.1276 8.18317 11.7865 8.61757C11.1053 9.48522 10.4321 10.3088 9.66471 11L19 11C19.5523 11 20 11.4478 20 12C20 12.5523 19.5523 13 19 13L9.66471 13C10.4321 13.6913 11.1053 14.5149 11.7865 15.3825C12.1276 15.8169 12.0519 16.4455 11.6175 16.7866C11.1831 17.1276 10.5545 17.052 10.2135 16.6176C9.34983 15.5176 8.64638 14.688 7.84205 14.0869C7.06899 13.5091 6.17325 13.1228 4.90017 12.995C4.38911 12.9438 4 12.5137 4 12C4 11.4864 4.38911 11.0563 4.90017 11.005C6.17325 10.8773 7.06899 10.491 7.84205 9.91321C8.64638 9.31208 9.34983 8.48251 10.2135 7.38251C10.5545 6.94812 11.1831 6.87244 11.6175 7.21349Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","left","back","return","previous","undo","navigation","go-back","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 14L11 18M11 6L11 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 14L17 14C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12V12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 18L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L11 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","cancel","navigation","go-back","previous-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 14L11 18M11 6L11 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 14L17 14C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12V12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 18L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L11 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","left","back","previous","return","go-back","undo","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L7 12L11 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow","navigation","go-back","undo","reverse","retreat","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.6 19.0001C10.3 19.0001 10.1 18.9001 9.9 18.7001L5.3 14.1001C4.5 13.3001 4 12.8001 4 12.0001C4 11.2001 4.5 10.7001 5.3 9.90015L9.9 5.30015C10.2 5.00015 10.6 4.90015 11 5.10015C11.3 5.20015 11.6 5.60015 11.6 6.00015V9.00015H17C18.1 9.00015 18.8 9.00015 19.4 9.60015C20 10.2001 20 10.9001 20 12.0001C20 13.1001 20 13.8001 19.4 14.4001C18.8 15.0001 18.1 15.0001 17 15.0001H11.6V18.0001C11.6 18.4001 11.4 18.8001 11 18.9001C10.8 19.0001 10.7 19.0001 10.6 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-18": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","left","back","previous","return","navigation","go-back","undo","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 18L11 14H17C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10H11L11 6L6.41421 10.5858C5.74755 11.2525 5.41421 11.5858 5.41421 12C5.41421 12.4142 5.74755 12.7475 6.41421 13.4142L11 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","go-back","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711L9.41421 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H9.41421L11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071L6.29289 12.7071C6.10536 12.5196 6 12.2652 6 12C6 11.7348 6.10536 11.4804 6.29289 11.2929L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L14.2 12L11 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V11.2V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16L7.49615 13.6641C6.36723 12.9115 5.80278 12.5352 5.80278 12C5.80278 11.4648 6.36723 11.0885 7.49615 10.3359L11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","left","back","return","previous","navigation","undo","cancel","discard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L14.2 12L11 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V11.2V8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16L7.49615 13.6641C6.36723 12.9115 5.80278 12.5352 5.80278 12C5.80278 11.4648 6.36723 11.0885 7.49615 10.3359L11 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","left","back","previous","return","navigation","go-back","undo","cancel","item-return","discount-return","transaction-history","previous-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L11 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16L11 8L7.49615 10.3359C6.36723 11.0885 5.80278 11.4648 5.80278 12C5.80278 12.5352 6.36723 12.9115 7.49615 13.6641L11 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","go-back","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0685 16.8817C10.7433 17.0557 10.3488 17.0366 10.0419 16.8321L6.53809 14.4962C6.51905 14.4835 6.50007 14.4708 6.48113 14.4582C5.9659 14.1148 5.48999 13.7976 5.15228 13.4924C4.78753 13.1628 4.39941 12.6855 4.39941 12C4.39941 11.3145 4.78753 10.8372 5.15228 10.5076C5.48999 10.2024 5.9659 9.88519 6.48113 9.54182C6.50006 9.5292 6.51905 9.51654 6.53809 9.50385L10.0419 7.16795C10.3488 6.96338 10.7433 6.94431 11.0685 7.11833C11.3937 7.29235 11.5966 7.63121 11.5966 8L11.5966 11L18.5966 11C19.1489 11 19.5966 11.4477 19.5966 12C19.5966 12.5523 19.1489 13 18.5966 13L11.5966 13L11.5966 16C11.5966 16.3688 11.3937 16.7077 11.0685 16.8817Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","go-back","navigation","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C6.38071 12 7.63071 11.4404 8.53553 10.5355C9.44036 9.63071 10 8.38071 10 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12C6.38071 12 7.63071 12.5596 8.53553 13.4645C9.44036 14.3693 10 15.6193 10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","return","previous","arrow","left","undo","reverse","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C6.38071 12 7.63071 11.4404 8.53553 10.5355C9.44036 9.63071 10 8.38071 10 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12C6.38071 12 7.63071 12.5596 8.53553 13.4645C9.44036 14.3693 10 15.6193 10 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-left-from-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["login","enter","sign-in","arrow","right","import","proceed","next","continue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 12L7 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L13.5858 10.5858C14.2525 11.2525 14.5858 11.5858 14.5858 12C14.5858 12.4142 14.2525 12.7475 13.5858 13.4142L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-from-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["back","return","previous","go-back","undo","rewind","exit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L8.41421 13.4142C7.74755 12.7475 7.41421 12.4142 7.41421 12C7.41421 11.5858 7.74755 11.2525 8.41421 10.5858L10 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-from-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","previous","exit","leave","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7853 5C18.3375 5 18.7995 5.44772 18.7995 6V18C18.7995 18.5523 18.3375 19 17.7853 19C17.233 19 16.7853 18.5523 16.7853 18L16.7853 6C16.7853 5.44772 17.233 5 17.7853 5ZM9.49221 8.29289C9.88273 8.68342 9.88273 9.31658 9.49221 9.70711L8.19932 11H13.7851C14.3374 11 14.7851 11.4477 14.7851 12C14.7851 12.5523 14.3374 13 13.7851 13H8.19932L9.49221 14.2929C9.88274 14.6834 9.88274 15.3166 9.49221 15.7071C9.10169 16.0976 8.46852 16.0976 8.078 15.7071L6.49221 14.1213C6.47937 14.1085 6.46655 14.0957 6.45374 14.0829C6.15381 13.7831 5.86234 13.4917 5.6543 13.219C5.41976 12.9116 5.09961 12.5137 5.09961 12C5.09961 11.4863 5.41976 11.0884 5.65429 10.781C5.86233 10.5083 6.15381 10.217 6.45373 9.91715C6.46654 9.90434 6.47937 9.89152 6.49221 9.87868L8.078 8.29289C8.46852 7.90237 9.10169 7.90237 9.49221 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-from-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["exit","leave","back","return","arrow-left","arrow","undo","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L8.41421 13.4142C7.74755 12.7475 7.41421 12.4142 7.41421 12C7.41421 11.5858 7.74755 11.2525 8.41421 10.5858L10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-long-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","return","arrow-left","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16L5 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L5 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-left-long-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","left","back","previous","return","go-back","navigation","undo","sales-history","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16L5 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L5 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-left-long-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70297 16.7071C9.31244 17.0976 8.67928 17.0976 8.28875 16.7071L4.30289 12.7212L4.29666 12.715C4.2935 12.7118 4.28779 12.706 4.2809 12.6987C4.26952 12.6868 4.24023 12.6556 4.20748 12.6127C4.13794 12.5216 4 12.3086 4 12C4 11.6914 4.13794 11.4784 4.20748 11.3873C4.24023 11.3444 4.26952 11.3132 4.2809 11.3013C4.28779 11.294 4.2935 11.2882 4.29666 11.285L4.30289 11.2788L8.28875 7.29289C8.67928 6.90237 9.31244 6.90237 9.70296 7.29289C10.0935 7.68342 10.0935 8.31658 9.70296 8.70711L7.41007 11L18.9959 11C19.5481 11 19.9959 11.4477 19.9959 12C19.9959 12.5523 19.5481 13 18.9959 13L7.41007 13L9.70297 15.2929C10.0935 15.6834 10.0935 16.3166 9.70297 16.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-long": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","navigation","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-left-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exchange","swap","switch","transfer","arrows","direction","transaction","toggle","reverse","change","trade","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9L6 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12L6 9L9 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 15L18 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 12L18 15L15 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["transfer","exchange","swap","convert","change","move","arrows","shift","transaction","switch","swap-items","exchange-rate","conversion","replace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9L10.8 9L6 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12L6 9L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 15L13.2 15L18 15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 12L18 15L15 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["transfer","exchange","swap","arrows","left","right","move","transaction","switch","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 4.29289C10.0976 4.68342 10.0976 5.31658 9.70711 5.70711L8.41421 7L18 7C18.5523 7 19 7.44771 19 8C19 8.55228 18.5523 9 18 9L8.41421 9L9.70711 10.2929C10.0976 10.6834 10.0976 11.3166 9.70711 11.7071C9.31658 12.0976 8.68342 12.0976 8.29289 11.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289L8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2929 12.2929C14.6834 11.9024 15.3166 11.9024 15.7071 12.2929L18.7071 15.2929C18.8946 15.4804 19 15.7348 19 16C19 16.2652 18.8946 16.5196 18.7071 16.7071L15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071C13.9024 19.3166 13.9024 18.6834 14.2929 18.2929L15.5858 17L6 17C5.44772 17 5 16.5523 5 16C5 15.4477 5.44772 15 6 15L15.5858 15L14.2929 13.7071C13.9024 13.3166 13.9024 12.6834 14.2929 12.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["switch","exchange","swap","transfer","arrows","transaction","reverse","toggle","convert","change","bidirectional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9L6 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12L6 9L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 15L18 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 12L18 15L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-to-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","go-back","back","previous","left","enter","move-to-start","restart","reset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11.4142 13.4142C10.7475 12.7475 10.4142 12.4142 10.4142 12C10.4142 11.5858 10.7475 11.2525 11.4142 10.5858L13 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-to-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["exit","return","back","previous","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11.4142 13.4142C10.7475 12.7475 10.4142 12.4142 10.4142 12C10.4142 11.5858 10.7475 11.2525 11.4142 10.5858L13 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left-to-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exit","back","return","previous","go-back","arrow-left","left","tab","end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4931 8.29289C13.8836 8.68342 13.8836 9.31658 13.4931 9.70711L12.2002 11L17.786 11C18.3383 11 18.8005 11.4477 18.8005 12C18.8005 12.5523 18.3383 13 17.786 13H12.2002L13.4931 14.2929C13.8836 14.6834 13.8836 15.3166 13.4931 15.7071C13.1026 16.0976 12.4694 16.0976 12.0789 15.7071L10.4931 14.1213C10.4803 14.1085 10.4674 14.0957 10.4546 14.0829C10.1547 13.7831 9.86322 13.4917 9.65517 13.219C9.42064 12.9116 9.2002 12.5137 9.2002 12C9.2002 11.4863 9.42064 11.0884 9.65517 10.781C9.86321 10.5083 10.1547 10.217 10.4546 9.91715C10.4674 9.90434 10.4803 9.89152 10.4931 9.87868L12.0789 8.29289C12.4694 7.90237 13.1026 7.90237 13.4931 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.2002 19C5.64791 19 5.2002 18.5523 5.2002 18L5.2002 6C5.2002 5.44771 5.64791 5 6.2002 5C6.75248 5 7.2002 5.44771 7.2002 6L7.2002 18C7.2002 18.5523 6.75248 19 6.2002 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-left-to-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","go-back","previous","undo","exit","arrow-left","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11.4142 13.4142C10.7475 12.7475 10.4142 12.4142 10.4142 12C10.4142 11.5858 10.7475 11.2525 11.4142 10.5858L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","previous","return","undo","navigation","discount","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12H13.4H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L7 12L11 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","undo","revert","arrow-left","go-back","transaction-reversal","refund","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9H13.5C15.9853 9 18 11.0147 18 13.5V13.5C18 15.9853 15.9853 18 13.5 18H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 6L6 9L9 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["return","undo","back","reverse","transaction-reversal","refund","previous","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9H13.5C15.9853 9 18 11.0147 18 13.5V13.5C18 15.9853 15.9853 18 13.5 18H6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 6L6 9L9 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","back","reverse","arrow","previous","rollback","revert","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 5.29289C10.0976 5.68342 10.0976 6.31658 9.70711 6.70711L8.41421 8H13.5C16.5376 8 19 10.4624 19 13.5C19 16.5376 16.5376 19 13.5 19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H13.5C15.433 17 17 15.433 17 13.5C17 11.567 15.433 10 13.5 10H8.41421L9.70711 11.2929C10.0976 11.6834 10.0976 12.3166 9.70711 12.7071C9.31658 13.0976 8.68342 13.0976 8.29289 12.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289L8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-return-double-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","undo","back","reverse","transaction-reversal","previous-menu","payment-refund","go-back","recall","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.18182 9H14.5C16.9853 9 19 11.0147 19 13.5V13.5C19 15.9853 16.9853 18 14.5 18H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6L9 9L12 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L5 9L8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return-double-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["return","undo","rollback","previous","back","history","revert","cancel","go-back","arrow-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.18182 9H14.5C16.9853 9 19 11.0147 19 13.5V13.5C19 15.9853 16.9853 18 14.5 18H7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6L9 9L12 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L5 9L8 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return-double-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","revert","go-back","previous","reverse","transaction-reversal","undo-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L6.41421 9L8.70711 11.2929C9.09763 11.6834 9.09763 12.3166 8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289ZM12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L11.4142 8H14.5C17.5376 8 20 10.4624 20 13.5C20 16.5376 17.5376 19 14.5 19H7C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17H14.5C16.433 17 18 15.433 18 13.5C18 11.567 16.433 10 14.5 10H11.4142L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-return-double": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","reverse","back","rewind","previous","rollback","cancel","void","correction","transaction","undo-transaction","reverse-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.18182 9H14.5C16.9853 9 19 11.0147 19 13.5V13.5C19 15.9853 16.9853 18 14.5 18H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6L9 9L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L5 9L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-return": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","back","refund","reverse","transaction-reversal","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9H13.5C15.9853 9 18 11.0147 18 13.5V13.5C18 15.9853 15.9853 18 13.5 18H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 6L6 9L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","proceed","continue","forward","checkout","payment","select","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H12.4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L17 12L13 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","right","next","proceed","continue","forward","select","choose","go-to","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 17C14 15.6193 14.5596 14.3693 15.4645 13.4645C16.3693 12.5596 17.6193 12 19 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 7C14 8.38071 14.5596 9.63071 15.4645 10.5355C16.3693 11.4404 17.6193 12 19 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","checkout","payment","select","choose","go-to"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6C14.5523 6 15 6.44772 15 7C15 8.10485 15.4466 9.10347 16.1716 9.82843C16.8965 10.5534 17.8952 11 19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13C17.8952 13 16.8965 13.4466 16.1716 14.1716C15.4466 14.8965 15 15.8952 15 17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17C13 15.4636 13.5786 14.0608 14.5278 13L5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L14.5278 11C13.5786 9.93921 13 8.53636 13 7C13 6.44772 13.4477 6 14 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","checkout","payment","confirm","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 16C14.7236 13.8047 16.1012 12.2908 19 12C16.1012 11.7092 14.7236 10.1953 13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","proceed","continue","checkout","payment","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 16C14.7236 13.8047 16.1012 12.2908 19 12C16.1012 11.7092 14.7236 10.1953 13 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","right","next","forward","proceed","continue","submit","checkout","payment","confirmation","navigation","enter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 16C14.7236 13.8047 16.1012 12.2908 19 12C16.1012 11.7092 14.7236 10.1953 13 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","forward","continue","proceed","checkout","payment","submit","advance","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3825 7.21349C12.8169 6.87244 13.4455 6.94812 13.7865 7.38251C14.6502 8.48251 15.3536 9.31208 16.1579 9.91321C16.931 10.491 17.8267 10.8773 19.0998 11.005C19.6109 11.0563 20 11.4864 20 12C20 12.5137 19.6109 12.9438 19.0998 12.995C17.8267 13.1228 16.931 13.5091 16.1579 14.0869C15.3536 14.688 14.6502 15.5176 13.7865 16.6176C13.4455 17.052 12.8169 17.1276 12.3825 16.7866C11.9481 16.4455 11.8724 15.8169 12.2135 15.3825C12.8947 14.5149 13.5679 13.6913 14.3353 13L5 13C4.44772 13 4 12.5523 4 12C4 11.4478 4.44772 11 5 11L14.3353 11C13.5679 10.3088 12.8947 9.48522 12.2135 8.61757C11.8724 8.18317 11.9481 7.55455 12.3825 7.21349Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","checkout","payment","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 10L13 6M13 18L13 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10L7 10C6.05719 10 5.58579 10 5.29289 10.2929C5.29289 10.2929 5.29289 10.2929 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.29289 13.7071 5.29289 13.7071 5.29289 13.7071C5.58579 14 6.05719 14 7 14L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 6L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L13 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","forward","continue","process","checkout","proceed","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 10L13 6M13 18L13 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10L7 10C6.05719 10 5.58579 10 5.29289 10.2929C5.29289 10.2929 5.29289 10.2929 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.29289 13.7071 5.29289 13.7071 5.29289 13.7071C5.58579 14 6.05719 14 7 14L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 6L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L13 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-18": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","right","next","forward","proceed","continue","submit","checkout","payment","order-completion","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18V14H7C6.05719 14 5.58579 14 5.29289 13.7071C5 13.4142 5 12.9428 5 12C5 11.0572 5 10.5858 5.29289 10.2929C5.58579 10 6.05719 10 7 10H13L13 6L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","continue","proceed","forward","submit","process","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.4 4.99561C13.7 4.99561 13.9 5.09561 14.1 5.29561L18.7 9.8956C19.5 10.6956 20 11.1956 20 11.9956C20 12.7956 19.5 13.2956 18.7 14.0956L14.1 18.6956C13.8 18.9956 13.4 19.0956 13 18.8956C12.7 18.7956 12.4 18.3956 12.4 17.9956V14.9956H7C5.9 14.9956 5.2 14.9956 4.6 14.3956C4 13.7956 4 13.0956 4 11.9956C4 10.8956 4 10.1956 4.6 9.59561C5.2 8.99561 5.9 8.99561 7 8.99561L12.4 8.99561V5.99561C12.4 5.59561 12.6 5.19561 13 5.09561C13.2 4.99561 13.3 4.99561 13.4 4.99561Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","right","next","forward","proceed","continue","checkout","payment","submit","process","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L17 12L13 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","submit","forward","checkout","payment","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 16L16.5039 13.6641C17.6328 12.9115 18.1972 12.5352 18.1972 12C18.1972 11.4648 17.6328 11.0885 16.5039 10.3359L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","continue","forward","proceed","go","select","advance","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16V8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 16L16.5039 13.6641C17.6328 12.9115 18.1972 12.5352 18.1972 12C18.1972 11.4648 17.6328 11.0885 16.5039 10.3359L13 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","process","navigate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L17.7071 11.2929C17.8946 11.4804 18 11.7348 18 12C18 12.2652 17.8946 12.5196 17.7071 12.7071L13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929L14.5858 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H14.5858L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","payment","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8V16L16.5038 13.6641L16.5039 13.6641C17.6328 12.9115 18.1972 12.5352 18.1972 12C18.1972 11.4648 17.6328 11.0885 16.5038 10.3359L13 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","continue","proceed","forward","go","select","choose","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9285 7.11833C13.2537 6.94431 13.6482 6.96338 13.9551 7.16795L17.4589 9.50385C17.478 9.51654 17.497 9.52919 17.5159 9.54181C18.0311 9.88519 18.507 10.2024 18.8448 10.5076C19.2095 10.8372 19.5976 11.3145 19.5976 12C19.5976 12.6855 19.2095 13.1628 18.8448 13.4924C18.507 13.7976 18.0311 14.1148 17.5159 14.4582C17.497 14.4708 17.478 14.4835 17.4589 14.4962L13.9551 16.8321C13.6482 17.0366 13.2537 17.0557 12.9285 16.8817C12.6034 16.7077 12.4004 16.3688 12.4004 16V13H5.40039C4.84811 13 4.40039 12.5523 4.40039 12C4.40039 11.4477 4.84811 11 5.40039 11H12.4004V8C12.4004 7.63121 12.6034 7.29235 12.9285 7.11833Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","forward","proceed","checkout","payment","submit","continue","navigate","go","enter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 17C14 15.6193 14.5596 14.3693 15.4645 13.4645C16.3693 12.5596 17.6193 12 19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 7C14 8.38071 14.5596 9.63071 15.4645 10.5355C16.3693 11.4404 17.6193 12 19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","forward","proceed","continue","checkout","payment","submit","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 17C14 15.6193 14.5596 14.3693 15.4645 13.4645C16.3693 12.5596 17.6193 12 19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 7C14 8.38071 14.5596 9.63071 15.4645 10.5355C16.3693 11.4404 17.6193 12 19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-right-long-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","next","forward","proceed","continue","submit","payment","checkout","navigation","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12L13.4 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-right-long-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","right","next","continue","proceed","forward","submit","checkout","payment","navigation","enter","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12L13.4 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-right-long": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","forward","continue","proceed","submit","checkout","payment","process","rightarrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12L13.4 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-right-long-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","continue","proceed","forward","checkout","payment","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289L19.693 11.2788L19.6992 11.285C19.7024 11.2882 19.7081 11.294 19.715 11.3013C19.7263 11.3132 19.7556 11.3444 19.7884 11.3873C19.8579 11.4784 19.9959 11.6914 19.9959 12C19.9959 12.3086 19.8579 12.5216 19.7884 12.6127C19.7556 12.6556 19.7263 12.6868 19.715 12.6987C19.7081 12.706 19.7024 12.7118 19.6992 12.715L19.693 12.7212L15.7071 16.7071C15.3166 17.0976 14.6834 17.0976 14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929L16.5858 13L5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L16.5858 11L14.2929 8.70711C13.9024 8.31658 13.9024 7.68342 14.2929 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","next","proceed","continue","forward","checkout","payment","submit","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H12.4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L17 12L13 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-rotate-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["refresh","reload","rotate","circular-arrow","update","redo","retry","repeat","reset","synchronize","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-rotate-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rotate","arrow","refresh","reload","redo","reset","cycle","update","reverse","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-rotate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","redo","revert","undo","circular","arrow","repeat","cycle","update","sync","resync","retry","reset","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 6C7.68629 6 5 8.68629 5 12C5 15.3137 7.68629 18 11 18C12.6791 18 14.1956 17.3116 15.2858 16.1991C15.6723 15.8046 16.3054 15.7982 16.6999 16.1847C17.0944 16.5713 17.1008 17.2044 16.7142 17.5989C15.2634 19.0795 13.2383 20 11 20C6.58172 20 3 16.4183 3 12C3 7.58172 6.58172 4 11 4C14.6814 4 17.782 6.48664 18.7139 9.87193L19.2929 9.29289C19.6834 8.90237 20.3166 8.90237 20.7071 9.29289C21.0976 9.68342 21.0976 10.3166 20.7071 10.7071L18.7071 12.7071C18.3166 13.0976 17.6834 13.0976 17.2929 12.7071L15.2929 10.7071C14.9024 10.3166 14.9024 9.68342 15.2929 9.29289C15.5419 9.04388 15.8896 8.95365 16.2101 9.0222C15.1759 7.21656 13.23 6 11 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-rotate": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","arrow","undo","redo","refresh","reload","sync","update","repeat","circular","cycle","reverse","reset","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-route-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","back","return","undo","transaction-history","history","previous","rollback","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7H15.5C16.8807 7 18 8.11929 18 9.5V9.5C18 10.8807 16.8807 12 15.5 12H8.5C7.11929 12 6 13.1193 6 14.5V14.5C6 15.8807 7.11929 17 8.5 17H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5L6 7L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-route-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["undo","redo","rewind","back","return","previous","transaction-reversal","correction","adjustment","reverse","route","path"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7H15.5C16.8807 7 18 8.11929 18 9.5V9.5C18 10.8807 16.8807 12 15.5 12H8.5C7.11929 12 6 13.1193 6 14.5V14.5C6 15.8807 7.11929 17 8.5 17H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5L6 7L8 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-route-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","rewind","back","undo","reverse","transaction-history","previous","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L8.41421 7H15.5C17.433 7 19 8.567 19 10.5C19 12.433 17.433 14 15.5 14H8.5C7.67157 14 7 14.6716 7 15.5C7 16.3284 7.67157 17 8.5 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H8.5C6.567 19 5 17.433 5 15.5C5 13.567 6.567 12 8.5 12H15.5C16.3284 12 17 11.3284 17 10.5C17 9.67157 16.3284 9 15.5 9H8.41421L8.70711 9.29289C9.09763 9.68342 9.09763 10.3166 8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-sort-z-a-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","arrow","z-a","descending","order","items","inventory","products","sales","transactions","reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L7.58579 16.5858C8.25245 17.2525 8.58579 17.5858 9 17.5858C9.41421 17.5858 9.74755 17.2525 10.4142 16.5858L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6H18L14 10H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L15.9999 14L18 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-route": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","back","undo","reverse","transaction-reversal","payment-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7H15.5C16.8807 7 18 8.11929 18 9.5V9.5C18 10.8807 16.8807 12 15.5 12H8.5C7.11929 12 6 13.1193 6 14.5V14.5C6 15.8807 7.11929 17 8.5 17H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5L6 7L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-sort-z-a-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sort","order","z-a","descending","alphabetical","inventory","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6V18M8 18L5 15M8 18L11 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6H17L13 10H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 18L14.9999 14L17 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-sort-z-a-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow","descending","z-a","sort-z-a","sort-alphabetical","order","alphabetical-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 5C9.05228 5 9.5 5.44772 9.5 6V15.5858L10.7929 14.2929C11.1834 13.9024 11.8166 13.9024 12.2071 14.2929C12.5976 14.6834 12.5976 15.3166 12.2071 15.7071L9.20711 18.7071C8.81658 19.0976 8.18342 19.0976 7.79289 18.7071L4.79289 15.7071C4.40237 15.3166 4.40237 14.6834 4.79289 14.2929C5.18342 13.9024 5.81658 13.9024 6.20711 14.2929L7.5 15.5858V6C7.5 5.44772 7.94772 5 8.5 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 7C13.9477 7 13.5 6.55228 13.5 6C13.5 5.44772 13.9477 5 14.5 5H18.5C18.9045 5 19.2691 5.24364 19.4239 5.61732C19.5787 5.99099 19.4931 6.42111 19.2071 6.70711L16.9142 9H18.5C19.0523 9 19.5 9.44772 19.5 10C19.5 10.5523 19.0523 11 18.5 11H14.5C14.0955 11 13.7309 10.7564 13.5761 10.3827C13.4213 10.009 13.5069 9.57889 13.7929 9.29289L16.0858 7H14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4999 13C16.8787 13 17.2249 13.214 17.3943 13.5528L19.3944 17.5528C19.6414 18.0467 19.4412 18.6474 18.9472 18.8944C18.4533 19.1414 17.8526 18.9412 17.6056 18.4472L16.5 16.2361L15.3944 18.4472C15.1475 18.9412 14.5468 19.1414 14.0528 18.8944C13.5588 18.6475 13.3586 18.0468 13.6056 17.5528L15.6055 13.5528C15.7749 13.214 16.1211 13 16.4999 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-sort-z-a": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow","descending","z-a","alphabetical","order","filter","arrange","inventory-sort","price-high-to-low","sales-descending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L7.58579 16.5858C8.25245 17.2525 8.58579 17.5858 9 17.5858C9.41421 17.5858 9.74755 17.2525 10.4142 16.5858L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6H18L14 10H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L15.9999 14L18 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","arrow","down","import","square","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L12 15M12 15L10 13M12 15V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","arrow","square","export","receive","import","save","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L12 15L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","down","download","import","receive","decrease","reduce","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM11 9C11 8.4 11.4 8 12 8C12.6 8 13 8.4 13 9L13 12.6L13.3 12.3C13.7 11.9 14.3 11.9 14.7 12.3C15.1 12.7 15.1 13.3 14.7 13.7L12.7 15.7C12.3 16.1 11.7 16.1 11.3 15.7L9.3 13.7C8.9 13.3 8.9 12.7 9.3 12.3C9.7 11.9 10.3 11.9 10.7 12.3L11 12.6L11 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-down-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","square","down","left","move","reduce","decrease","import","download","exit","minimize","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H10L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","square","down","left","import","download","receive","reduce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H10M10 14L10 11M10 14L14 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","down","left","import","download","send","receive","transfer","receive-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H10L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","down","left","download","import","back","return","previous","undo","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L11 11.5858V11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11V14C9 14.2652 9.10536 14.5196 9.29289 14.7071C9.48043 14.8946 9.73478 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H12.4142L14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-down-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","square","down","right","download","export","save","move","transfer","send","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H14V11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","square","download","import","transaction","receive","discount","apply-discount","apply","arrow-down-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H14M14 14L14 11M14 14L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","download","checkout","save","export","next","proceed","go-to-payment","complete-order","order-summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L13 11.5858V11C13 10.4477 13.4477 10 14 10C14.5523 10 15 10.4477 15 11V14C15 14.2652 14.8946 14.5196 14.7071 14.7071C14.5196 14.8946 14.2652 15 14 15H11C10.4477 15 10 14.5523 10 14C10 13.4477 10.4477 13 11 13H11.5858L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-down-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","down","right","download","export","save","receive","import"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H14V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow-down","square","import","receive","income","load","add-to"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L12 15L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["back","arrow-left","previous","return","square","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 12L11 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","return","arrow-left","square","navigation","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 12M9 12L11 10M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","return","previous","navigation","go-back","undo","square","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM15 11C15.6 11 16 11.4 16 12C16 12.6 15.6 13 15 13L11.4 13L11.7 13.3C12.1 13.7 12.1 14.3 11.7 14.7C11.3 15.1 10.7 15.1 10.3 14.7L8.3 12.7C7.9 12.3 7.9 11.7 8.3 11.3L10.3 9.3C10.7 8.9 11.3 8.9 11.7 9.3C12.1 9.7 12.1 10.3 11.7 10.7L11.4 11L15 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","previous","undo","arrow","left","navigation","cancel","square","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 12L11 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","square","right","next","continue","forward","proceed","checkout","payment","submit","process","navigate","transition","advance","move-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L15 12L13 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","right","next","continue","proceed","checkout","confirm","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47975 2.99998 7.34594 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34594 2.99998 8.47975 3 9.88642V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM9 13C8.4 13 8 12.6 8 12C8 11.4 8.4 11 9 11H12.6L12.3 10.7C11.9 10.3 11.9 9.7 12.3 9.3C12.7 8.9 13.3 8.9 13.7 9.3L15.7 11.3C16.1 11.7 16.1 12.3 15.7 12.7L13.7 14.7C13.3 15.1 12.7 15.1 12.3 14.7C11.9 14.3 11.9 13.7 12.3 13.3L12.6 13H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","right","square","next","proceed","continue","checkout","submit","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L15 12M15 12L13 10M15 12L9 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","right","next","forward","proceed","checkout","payment","submit","confirm","continue","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L15 12L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["upload","square","arrow","up","send","submit","push","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L12 9L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","square","up","upload","send","submit","increase","increment","bump","ascend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L12 9M12 9L10 11M12 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","arrow","up","upload","increase","promote","sort-up","ascending","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM13 15C13 15.6 12.6 16 12 16C11.4 16 11 15.6 11 15V11.4L10.7 11.7C10.3 12.1 9.7 12.1 9.3 11.7C8.9 11.3 8.9 10.7 9.3 10.3L11.3 8.3C11.7 7.9 12.3 7.9 12.7 8.3L14.7 10.3C15.1 10.7 15.1 11.3 14.7 11.7C14.3 12.1 13.7 12.1 13.3 11.7L13 11.4V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-up-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","square","up","left","return","back","navigation","previous","move","go-back","recall","inventory-return","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L14 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","square","up","left","return","previous","back","navigation","go-back","previous-menu","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10M10 10L10 13M10 10L14 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","navigation","up","left","move","return","back","previous","undo","direction","inventory-transfer","report-generation","go-back","move-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H10L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","up","left","return","previous","back","go-back","navigate-back","receipt","refund","previous-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM12.4142 11L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L11 12.4142V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V10C9 9.73478 9.10536 9.48043 9.29289 9.29289C9.48043 9.10536 9.73478 9 10 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H12.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-square-up-right-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["arrow","square","up","right","forward","export","send","transfer","move","next","advance","checkout","submit","payment","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H14V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["square","arrow","up","right","next","proceed","continue","export","forward","navigation","move-on","go-ahead"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H14M14 10L14 13M14 10L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","up","right","export","send","submit","forward","process","transfer","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H14V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["upload","square","arrow-up","send","submit","update","export","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L12 9L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-square-up-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","square","up","right","next","forward","go","continue","proceed","send","submit","checkout","approve","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642C8.47976 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V14.1136C2.99998 15.5202 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52837 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52837 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5202 2.99998 14.1136 3ZM9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L13 12.4142V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V10C15 9.73478 14.8946 9.48043 14.7071 9.29289C14.5196 9.10536 14.2652 9 14 9H11C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11H11.5858L9.29289 13.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","increase","ascend","scroll-up","move-up","sort-ascending","upload","go-up","raise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L12 7L8 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","top","increase","rise","sort-up","promote","move-up","scroll-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9996 16.9498L11.3428 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14L14 8L9.63987 7.37712C8.42993 7.20428 7.82496 7.11785 7.4714 7.4714C7.11785 7.82496 7.20428 8.42993 7.37712 9.63987L8 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","navigation","move-up","scroll-up","previous","back","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.14544 6.14015C7.6837 6.14146 7.12578 6.22987 6.67807 6.67758C6.23036 7.12529 6.14195 7.68321 6.14064 8.14495C6.13945 8.56539 6.21321 9.08111 6.29179 9.63055C6.29484 9.65184 6.29789 9.67319 6.30095 9.69458L6.92384 14.0547C6.9774 14.4297 7.23823 14.7422 7.59756 14.862C7.95689 14.9818 8.35306 14.8883 8.62089 14.6204L10.9138 12.3275L16.1564 17.5702C16.547 17.9607 17.1801 17.9607 17.5706 17.5702C17.9612 17.1796 17.9612 16.5465 17.5706 16.156L12.328 10.9133L14.6209 8.62042C14.8887 8.35259 14.9822 7.95642 14.8625 7.59709C14.7427 7.23776 14.4302 6.97694 14.0552 6.92337L9.69508 6.30047C9.67369 6.29741 9.65234 6.29436 9.63105 6.29131C9.08161 6.21273 8.56588 6.13896 8.14544 6.14015Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","increase","raise","sort-up","scroll-up","ascend","higher","move-up","elevation","elevation-increase","quantity-increase","price-increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10C15.6193 10 14.3693 9.44036 13.4645 8.53553C12.5596 7.63071 12 6.38071 12 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10C8.38071 10 9.63071 9.44036 10.5355 8.53553C11.4404 7.63071 12 6.38071 12 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","raise","ascending","scroll-up","sort-ascending","priority","highest","increase-quantity","increase-amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10C15.6193 10 14.3693 9.44036 13.4645 8.53553C12.5596 7.63071 12 6.38071 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10C8.38071 10 9.63071 9.44036 10.5355 8.53553C11.4404 7.63071 12 6.38071 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","increase","sort-up","ascending","raise","increment","scroll-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10C15.6193 10 14.3693 9.44036 13.4645 8.53553C12.5596 7.63071 12 6.38071 12 5"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10C8.38071 10 9.63071 9.44036 10.5355 8.53553C11.4404 7.63071 12 6.38071 12 5"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","promote","upload","top","sort-asc","ascending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5C13 6.10485 13.4466 7.10348 14.1716 7.82843C14.8965 8.55338 15.8952 9 17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11C15.4636 11 14.0608 10.4214 13 9.47219V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V9.47219C9.93921 10.4214 8.53636 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C8.10485 9 9.10347 8.55338 9.82843 7.82843C10.5534 7.10348 11 6.10485 11 5C11 4.44772 11.4477 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","increase","ascend","sort-up","move-up","scroll-up","increase-quantity","higher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11C10.1953 9.27645 11.7092 7.89876 12 5C12.2908 7.89876 13.8047 9.27645 16 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","increase","sort","ascending","scroll-up","promote","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11C10.1953 9.27645 11.7092 7.89876 12 5C12.2908 7.89876 13.8047 9.27645 16 11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","raise","sort-ascending","scroll-up","move-up","uparrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5137 4 12.9438 4.38911 12.995 4.90017C13.1228 6.17325 13.5091 7.06899 14.0869 7.84205C14.688 8.64638 15.5176 9.34983 16.6176 10.2135C17.052 10.5545 17.1276 11.1831 16.7866 11.6175C16.4455 12.0519 15.8169 12.1276 15.3825 11.7865C14.5149 11.1053 13.6913 10.4321 13 9.66471V19C13 19.5523 12.5523 20 12 20C11.4478 20 11 19.5523 11 19V9.66471C10.3088 10.4321 9.48522 11.1053 8.61757 11.7865C8.18317 12.1276 7.55455 12.0519 7.21349 11.6175C6.87244 11.1831 6.94812 10.5545 7.38251 10.2135C8.48251 9.34983 9.31208 8.64638 9.91321 7.84205C10.491 7.06899 10.8773 6.17325 11.005 4.90017C11.0563 4.38911 11.4864 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","raise","sort","ascending","move-up","scroll-up","priority","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 11L6 11M18 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 11L10 17C10 17.9428 10 18.4142 10.2929 18.7071C10.5858 19 11.0572 19 12 19C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 11L10.5858 6.41421C11.2525 5.74755 11.5858 5.41421 12 5.41421C12.4142 5.41421 12.7475 5.74755 13.4142 6.41421L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","top","increase","more","quantity","raise","sort-up","sort","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L12 7L8 11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","arrow-up","sort","increase","upload","scroll-up","promote","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 11L6 11M18 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 11L10 17C10 17.9428 10 18.4142 10.2929 18.7071C10.5858 19 11.0572 19 12 19C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 11L10.5858 6.41421C11.2525 5.74755 11.5858 5.41421 12 5.41421C12.4142 5.41421 12.7475 5.74755 13.4142 6.41421L18 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-22": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","arrow-up","up","scroll-up","increase","ascending","sort-ascending","sort-up","promote","move-up","return","go-back","top"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L14 11L14 17C14 17.9428 14 18.4142 13.7071 18.7071H13.7071C13.4142 19 12.9428 19 12 19C11.0572 19 10.5858 19 10.2929 18.7071C10 18.4142 10 17.9428 10 17L10 11L6 11L10.5858 6.41421C11.2525 5.74755 11.5858 5.41421 12 5.41421C12.4142 5.41421 12.7475 5.74755 13.4142 6.41421L18 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","top","increase","higher","ascend","sort-up","scroll-up","quantity-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.99805 10.598C4.99805 10.298 5.09805 10.098 5.29805 9.89805L9.89805 5.29805C10.698 4.49805 11.198 3.99805 11.998 3.99805C12.798 3.99805 13.298 4.49805 14.098 5.29805L18.698 9.89805C18.998 10.198 19.098 10.598 18.898 10.998C18.798 11.298 18.398 11.598 17.998 11.598L14.998 11.598V16.998C14.998 18.098 14.998 18.798 14.398 19.398C13.798 19.998 13.098 19.998 11.998 19.998C10.898 19.998 10.198 19.998 9.59805 19.398C8.99805 18.798 8.99805 18.098 8.99805 16.998L8.99805 11.598L5.99805 11.598C5.59805 11.598 5.19805 11.398 5.09805 10.998C4.99805 10.798 4.99805 10.698 4.99805 10.598Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","ascend","scroll-up","move-up","sort-ascending","navigate-up","raise","elevate","promotion","payment-increase","quantity-increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289L16.7071 10.2929C17.0976 10.6834 17.0976 11.3166 16.7071 11.7071C16.3166 12.0976 15.6834 12.0976 15.2929 11.7071L13 9.41421V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V9.41421L8.70711 11.7071C8.31658 12.0976 7.68342 12.0976 7.29289 11.7071C6.90237 11.3166 6.90237 10.6834 7.29289 10.2929L11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","raise","sort-up","sort","increase-quantity","scroll-up","move-up","go-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11C10.1953 9.27645 11.7092 7.89876 12 5C12.2908 7.89876 13.8047 9.27645 16 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","upload","increase","sort-up","scroll-up","raise","ascending","move-up","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 14.2L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L12.8 11L16 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11L10.3359 7.49615C11.0885 6.36723 11.4648 5.80278 12 5.80278C12.5352 5.80278 12.9115 6.36723 13.6641 7.49615L16 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","increase","ascend","scroll-up","sort-ascending","move-up","promote","upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11H16L13.6641 7.49615C12.9115 6.36723 12.5352 5.80278 12 5.80278C11.4648 5.80278 11.0885 6.36723 10.3359 7.49615L8 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","arrow-up","up","move-up","sort","sort-ascending","increase","scroll-up","navigate-up","rise","growth","top"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 14.2L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L12.8 11L16 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11L10.3359 7.49615C11.0885 6.36723 11.4648 5.80278 12 5.80278C12.5352 5.80278 12.9115 6.36723 13.6641 7.49615L16 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","left","back","return","previous","navigate-up","undo","go-back","arrow-top-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9996 16.9498L11.3428 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 8L8 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 8L9.63986 7.37712C8.42993 7.20428 7.82496 7.11785 7.4714 7.4714C7.11785 7.82496 7.20428 8.42993 7.37712 9.63986L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","top","sort","ascending","move-up","scroll-up","inventory","increase","raise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9996 16.9498L11.3428 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14.0508 8L8.05078 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 8L9.63986 7.37712C8.42993 7.20428 7.82496 7.11785 7.4714 7.4714C7.11785 7.82496 7.20428 8.42993 7.37712 9.63986L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","ascending","sort-up","scroll-up","quantity-increase","price-increase","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.11637 11.0704C6.94235 10.7453 6.96143 10.3507 7.166 10.0439L9.5019 6.54004C9.51459 6.52101 9.52724 6.50202 9.53986 6.48309C9.88324 5.96786 10.2004 5.49194 10.5056 5.15423C10.8352 4.78948 11.3125 4.40137 11.998 4.40137C12.6836 4.40137 13.1609 4.78949 13.4905 5.15423C13.7957 5.49194 14.1129 5.96786 14.4562 6.48308C14.4689 6.50202 14.4815 6.521 14.4942 6.54004L16.8301 10.0439C17.0347 10.3507 17.0537 10.7453 16.8797 11.0704C16.7057 11.3956 16.3668 11.5986 15.998 11.5986L12.998 11.5986L12.998 18.5986C12.998 19.1509 12.5503 19.5986 11.998 19.5986C11.4458 19.5986 10.998 19.1509 10.998 18.5986L10.998 11.5986L7.99805 11.5986C7.62925 11.5986 7.29039 11.3956 7.11637 11.0704Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","order","arrows","up-down","arrange","reorder","change-order","sorting","order-by"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7299 11C14.5772 11 15.5008 11 15.7705 10.4242C16.0403 9.84831 15.449 9.13875 14.2664 7.71963L13.5364 6.84373C12.8244 5.98928 12.4684 5.56205 12 5.56205C11.5316 5.56205 11.1756 5.98928 10.4636 6.84373L9.73364 7.71963C8.55104 9.13875 7.95974 9.84831 8.22945 10.4242C8.49916 11 9.4228 11 11.2701 11L12.7299 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.73364 16.2804L10.4636 17.1563L10.4636 17.1563C11.1756 18.0107 11.5316 18.4379 12 18.4379C12.4684 18.4379 12.8244 18.0107 13.5364 17.1563L14.2664 16.2804C15.449 14.8612 16.0403 14.1517 15.7705 13.5758C15.5008 13 14.5772 13 12.7299 13L11.2701 13C9.4228 13 8.49916 13 8.22945 13.5758C7.95974 14.1517 8.55104 14.8612 9.73364 16.2804Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-bottom-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","sort","up","down","arrows","direction","reorder","rank"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2664 7.71963L13.5364 6.84373L13.5364 6.84373C12.8244 5.98928 12.4684 5.56205 12 5.56205C11.5316 5.56205 11.1756 5.98928 10.4636 6.84373L9.73364 7.71963C8.55104 9.13875 7.95974 9.84831 8.22945 10.4242C8.49916 11 9.4228 11 11.2701 11H12.7299C14.5772 11 15.5008 11 15.7705 10.4242C16.0403 9.84831 15.449 9.13875 14.2664 7.71963Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.73364 16.2804L10.4636 17.1563L10.4636 17.1563C11.1756 18.0107 11.5316 18.4379 12 18.4379C12.4684 18.4379 12.8244 18.0107 13.5364 17.1563L14.2664 16.2804C15.449 14.8612 16.0403 14.1517 15.7705 13.5758C15.5008 13 14.5772 13 12.7299 13L11.2701 13C9.4228 13 8.49916 13 8.22945 13.5758C7.95974 14.1517 8.55104 14.8612 9.73364 16.2804Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrows","up","down","reorder","order","sequence","arrange","priority","ranking","list","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.6533 4.64025C10.9757 4.34912 11.4124 4.06201 12.0003 4.06201C12.5883 4.06201 13.025 4.34912 13.3474 4.64025C13.6375 4.90225 13.9439 5.27005 14.2659 5.65661C14.2789 5.67222 14.292 5.68785 14.305 5.70351L15.0349 6.57941C15.0513 6.59908 15.0677 6.61868 15.0839 6.63821C15.6332 7.29725 16.1154 7.87582 16.4157 8.36498C16.7159 8.85412 17.0379 9.57666 16.6765 10.3483C16.3151 11.1199 15.5539 11.3351 14.9859 11.4176C14.4179 11.5001 13.6647 11.5 12.8068 11.5C12.7814 11.5 12.7559 11.5 12.7303 11.5H11.2704C11.2448 11.5 11.2193 11.5 11.1939 11.5C10.3359 11.5 9.58276 11.5001 9.01477 11.4176C8.44681 11.3351 7.68561 11.1199 7.3242 10.3483C6.9628 9.57666 7.28478 8.85412 7.585 8.36498C7.88524 7.87581 8.36747 7.29724 8.91676 6.6382C8.93304 6.61867 8.94937 6.59907 8.96576 6.57941L9.69568 5.70351C9.70873 5.68785 9.72175 5.67222 9.73475 5.65661C10.0568 5.27005 10.3632 4.90225 10.6533 4.64025ZM14.9859 12.5823C15.5539 12.6648 16.3151 12.88 16.6765 13.6516C17.0379 14.4233 16.7159 15.1458 16.4157 15.6349C16.1154 16.1241 15.6332 16.7027 15.0839 17.3617L14.305 18.2964C14.292 18.3121 14.2789 18.3277 14.2659 18.3433C13.9439 18.7299 13.6375 19.0977 13.3474 19.3597C13.025 19.6508 12.5883 19.9379 12.0003 19.9379C11.4124 19.9379 10.9757 19.6508 10.6533 19.3597C10.3632 19.0977 10.0568 18.7299 9.73476 18.3433C9.72176 18.3277 9.70873 18.3121 9.69568 18.2964L8.96576 17.4205C8.94937 17.4008 8.93304 17.3813 8.91677 17.3617C8.36747 16.7027 7.88524 16.1241 7.585 15.6349C7.28478 15.1458 6.9628 14.4233 7.3242 13.6517C7.68561 12.88 8.44681 12.6648 9.01477 12.5823C9.58276 12.4998 10.3359 12.4999 11.1939 12.5C11.2193 12.5 11.2448 12.5 11.2704 12.5L12.7303 12.5C12.7559 12.5 12.7814 12.5 12.8068 12.5C13.6647 12.4999 14.4179 12.4998 14.9859 12.5823Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-bottom-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","order","arrows","up-down","ascending","descending","price","quantity","date","transaction","history","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L15 10.8L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 8L15 5L18 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 6L9 13.2L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16L9 19L6 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-bottom-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrows","up-down","order","transactions","ranking","inventory","toggle","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L15 10.8L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 8L15 5L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 6L9 13.2L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16L9 19L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-bottom-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","arrows","up","down","sorting","order","transaction","history","price","ascending","descending","inventory","levels"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L15 10.8L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 8L15 5L18 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 6L9 13.2L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16L9 19L6 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-bottom-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrows","up","down","increase","decrease","ranking","order","reorder","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289L19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711C19.3166 9.09763 18.6834 9.09763 18.2929 8.70711L17 7.41421V18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18V7.41421L13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289L15.2929 4.29289C15.4804 4.10536 15.7348 4 16 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5C8.55228 5 9 5.44772 9 6L9 16.5858L10.2929 15.2929C10.6834 14.9024 11.3166 14.9024 11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071L8.70711 19.7071C8.51957 19.8946 8.26522 20 8 20C7.73478 20 7.48043 19.8946 7.29289 19.7071L4.29289 16.7071C3.90237 16.3166 3.90237 15.6834 4.29289 15.2929C4.68342 14.9024 5.31658 14.9024 5.70711 15.2929L7 16.5858L7 6C7 5.44772 7.44771 5 8 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","order","ascending","descending","up","down","arrows","arrange","list","reorder","change order","prioritize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7299 11C14.5772 11 15.5008 11 15.7705 10.4242C16.0403 9.84831 15.449 9.13875 14.2664 7.71963L13.5364 6.84373C12.8244 5.98928 12.4684 5.56205 12 5.56205C11.5316 5.56205 11.1756 5.98928 10.4636 6.84373L9.73364 7.71963C8.55104 9.13875 7.95974 9.84831 8.22945 10.4242C8.49916 11 9.4228 11 11.2701 11L12.7299 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.73364 16.2804L10.4636 17.1563L10.4636 17.1563C11.1756 18.0107 11.5316 18.4379 12 18.4379C12.4684 18.4379 12.8244 18.0107 13.5364 17.1563L14.2664 16.2804C15.449 14.8612 16.0403 14.1517 15.7705 13.5758C15.5008 13 14.5772 13 12.7299 13L11.2701 13C9.4228 13 8.49916 13 8.22945 13.5758C7.95974 14.1517 8.55104 14.8612 9.73364 16.2804Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top","left","return","back","previous","undo","navigation","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 8L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 13L7 9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7L13 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-left-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","top","left","return","back","undo","previous","history","navigate-back","go-back","move-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 13L19 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5385 12.5385C10.234 14.8429 9.0818 15.9951 7.96264 15.6906C7.90541 15.6751 7.84891 15.6569 7.79329 15.6364C6.70561 15.2336 6.43772 13.6263 5.90195 10.4117C5.50002 8.00013 5.29906 6.79434 5.96539 6.0745C6.00034 6.03674 6.03674 6.00034 6.0745 5.96539C6.79434 5.29906 8.00013 5.50002 10.4117 5.90195C13.6263 6.43772 15.2336 6.70561 15.6364 7.79329C15.6569 7.84891 15.6751 7.90541 15.6906 7.96264C15.9951 9.0818 14.8429 10.234 12.5385 12.5385Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-left-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","left","previous","back","return","navigate-back","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5022 4.90307C10.5267 4.90716 10.5512 4.91125 10.5759 4.91536L10.6568 4.92884C12.1953 5.18522 13.4578 5.39561 14.3797 5.68695C15.312 5.98161 16.2058 6.45152 16.5739 7.44589C16.6048 7.52932 16.632 7.61407 16.6554 7.69991C16.9337 8.72305 16.4795 9.62494 15.8921 10.4066C15.4297 11.0221 14.7616 11.7213 13.9517 12.5375L19.7069 18.2927C20.0974 18.6832 20.0974 19.3164 19.7069 19.7069C19.3164 20.0974 18.6832 20.0974 18.2927 19.7069L12.5375 13.9517C11.7213 14.7616 11.0221 15.4297 10.4066 15.8921C9.62494 16.4795 8.72305 16.9337 7.69991 16.6554C7.61407 16.632 7.52932 16.6048 7.44589 16.5739C6.45152 16.2058 5.98161 15.312 5.68695 14.3797C5.39561 13.4578 5.18522 12.1953 4.92884 10.6568L4.91536 10.5759C4.91125 10.5512 4.90716 10.5267 4.90307 10.5022C4.71255 9.35934 4.55214 8.39711 4.53319 7.63331C4.51333 6.83293 4.6392 6.0347 5.23134 5.395C5.28377 5.33836 5.33836 5.28377 5.395 5.23134C6.0347 4.6392 6.83293 4.51333 7.63331 4.53319C8.39711 4.55214 9.35934 4.71255 10.5022 4.90307Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","return","go-back","back","previous","undo","top-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 8L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 13L7 9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7L13 7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","left","back","return","previous","up","navigation","undo","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.94561 6.00001C8.96372 6.00001 8.98186 6.00001 9.00001 6.00001L13 6.00001C13.5523 6.00001 14 6.44773 14 7.00001C14 7.5523 13.5523 8.00001 13 8.00001H9.41423L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L8.00001 9.41423V13C8.00001 13.5523 7.5523 14 7.00001 14C6.44773 14 6.00001 13.5523 6.00001 13L6.00001 9.00001C6.00001 8.98186 6.00001 8.96372 6.00001 8.9456C5.99992 8.52153 5.99984 8.10941 6.04554 7.76949C6.09706 7.38629 6.22258 6.94902 6.5858 6.5858L6.5858 6.5858C6.94902 6.22258 7.38629 6.09706 7.76949 6.04554C8.10941 5.99984 8.52154 5.99992 8.94561 6.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-left-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","left","previous","back","return","navigation","go-back","item-up","item-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H9V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-left-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","left","return","back","previous","navigation","go-back","go-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 15L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9H9V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-left-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","top","left","navigation","back","return","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 15L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V9" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-left-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","left","previous","back","return","navigation","go-back","previous-screen","top-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H11.4142L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142V15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15V9C8 8.44772 8.44772 8 9 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-left-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","left","back","return","previous","go-back","navigation","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5385 12.5385V12.5385C14.8429 10.234 15.9951 9.0818 15.6906 7.96264C15.6751 7.90541 15.6569 7.84891 15.6364 7.79329C15.2336 6.70561 13.6263 6.43772 10.4117 5.90195V5.90195C8.00013 5.50002 6.79434 5.29906 6.0745 5.96539C6.03674 6.00034 6.00034 6.03674 5.96539 6.0745C5.29906 6.79434 5.50002 8.00013 5.90195 10.4117V10.4117C6.43772 13.6263 6.70561 15.2336 7.79329 15.6364C7.84891 15.6569 7.90541 15.6751 7.96264 15.6906C9.0818 15.9951 10.234 14.8429 12.5385 12.5385V12.5385ZM12.5385 12.5385L19 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-left-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top","left","back","return","previous","undo","direction","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 13L19 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5385 12.5385C10.234 14.8429 9.0818 15.9951 7.96264 15.6906C7.90541 15.6751 7.84891 15.6569 7.79329 15.6364C6.70561 15.2336 6.43772 13.6263 5.90195 10.4117V10.4117C5.50002 8.00013 5.29906 6.79434 5.96539 6.0745C6.00034 6.03674 6.03674 6.00034 6.0745 5.96539C6.79434 5.29906 8.00013 5.50002 10.4117 5.90195V5.90195C13.6263 6.43772 15.2336 6.70561 15.6364 7.79329C15.6569 7.84891 15.6751 7.90541 15.6906 7.96264C15.9951 9.0818 14.8429 10.234 12.5385 12.5385V12.5385V12.5385Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","previous","undo","arrow","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 8L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 13L7 9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7L13 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-long-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top","increase","up","sort-ascending","sort-up","scroll-up","move-up","ascend","go-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 10.6L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-long-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","up","scroll-up","sort-ascending","increase","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 10.6L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-long-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","rise","ascend","scroll-up","move-up","sort-ascending","trending-up","higher","more","increase-quantity","raise","elevation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.29094 9.70492C6.90042 9.31439 6.90042 8.68123 7.29094 8.29071L11.2768 4.30485L11.2831 4.29861C11.2863 4.29545 11.2921 4.28974 11.2993 4.28286C11.3113 4.27147 11.3424 4.24219 11.3853 4.20943C11.4765 4.1399 11.6894 4.00195 11.998 4.00195C12.3067 4.00195 12.5196 4.1399 12.6108 4.20943C12.6537 4.24219 12.6848 4.27147 12.6968 4.28286C12.704 4.28974 12.7098 4.29545 12.713 4.29861L12.7193 4.30485L16.7052 8.2907C17.0957 8.68123 17.0957 9.31439 16.7052 9.70492C16.3146 10.0954 15.6815 10.0954 15.2909 9.70492L12.998 7.41203V18.9978C12.998 19.5501 12.5503 19.9978 11.998 19.9978C11.4458 19.9978 10.998 19.5501 10.998 18.9978V7.41202L8.70515 9.70492C8.31463 10.0954 7.68146 10.0954 7.29094 9.70492Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-long": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","scroll-up","sort-ascending","ascending","move-up","raise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 10.6L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top","right","up","direction","navigation","next","forward","proceed","continue","advance","submit","send","go","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-right-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","top-right","forward","next","increase","trending","sales","profit","growth","move-forward","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.0498 16.9498L12.7067 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3601 7.37714L10 8.00004L16 14L16.6229 9.63989V9.63988C16.7957 8.42994 16.8822 7.82496 16.5286 7.47141C16.1751 7.11786 15.5701 7.20428 14.3601 7.37714Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-right-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","right","forward","next","proceed","submit","advance","continue","goto"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8587 6.14015C16.3205 6.14146 16.8784 6.22987 17.3261 6.67758C17.7738 7.12529 17.8622 7.68321 17.8635 8.14495C17.8647 8.56539 17.7909 9.08111 17.7124 9.63055C17.7093 9.65184 17.7063 9.67319 17.7032 9.69458L17.0803 14.0547C17.0268 14.4297 16.7659 14.7422 16.4066 14.862C16.0473 14.9818 15.6511 14.8883 15.3833 14.6204L13.0904 12.3275L7.84773 17.5702C7.45721 17.9607 6.82404 17.9607 6.43352 17.5702C6.04299 17.1796 6.04299 16.5465 6.43352 16.156L11.6762 10.9133L9.38327 8.62042C9.11543 8.35259 9.02191 7.95642 9.14169 7.59709C9.26147 7.23776 9.57398 6.97694 9.94895 6.92337L14.3091 6.30047C14.3305 6.29741 14.3518 6.29436 14.3731 6.29131C14.9226 6.21273 15.4383 6.13896 15.8587 6.14015Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","top","right","direction","move","forward","next","advance","sales","report","summary","navigation","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","right","up","forward","next","proceed","continue","navigate","move-forward","go-to","redirect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9.41423V13C16 13.5523 16.4477 14 17 14C17.5523 14 18 13.5523 18 13V9.00001C18 8.98186 18 8.96372 18 8.9456C18.0001 8.52153 18.0002 8.10941 17.9545 7.7695C17.903 7.38629 17.7774 6.94902 17.4142 6.5858C17.051 6.22259 16.6137 6.09706 16.2305 6.04554C15.8906 5.99984 15.4785 5.99992 15.0544 6.00001C15.0363 6.00001 15.0182 6.00001 15 6.00001H11C10.4477 6.00001 10 6.44773 10 7.00001C10 7.5523 10.4477 8.00001 11 8.00001H14.5858L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L16 9.41423Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","forward","next","continue","proceed","submit","checkout","payment","confirmation","success","go-to","navigate","top-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9H15V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 15L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-right-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","top-right","forward","next","continue","proceed","go","advance","submit","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9H15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14.6569L15 9" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-top-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top-right","direction","move","forward","proceed","next","submit","complete","checkout","navigate","increase","ascend","go-to","continue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 9H15V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-top-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","direction","navigation","next","forward","proceed","top-right","increase","upgrade","promotion","submit","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V11.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L12.5858 10H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-top-right-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top","right","forward","next","proceed","continue","submit","send","navigation","direction","move-forward","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.0498 16.9498L12.7067 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 8L13.6 11.6L16 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8L14.3601 7.37712C15.5701 7.20428 16.175 7.11785 16.5286 7.4714C16.8821 7.82496 16.7957 8.42993 16.6229 9.63986L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-right-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","top","right","upper-right","next","advance","proceed","move-forward","checkout","submit","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.0498 16.9498L12.7067 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 8L13.6 11.6L16 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8L14.3601 7.37712C15.5701 7.20428 16.175 7.11785 16.5286 7.4714C16.8821 7.82496 16.7957 8.42993 16.6229 9.63986L16 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","top-right","next","forward","send","submit","move-forward","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","ascending","sort-up","scroll-up","raise","move-up","go-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L12 7L8 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Arrow-trend-down-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sales-down","decline","loss","arrow-down","decrease","revenue-drop","falling","low-sales","sales-performance","negative-trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L12 10L10 12L8 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H16V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Arrow-trend-down-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","down","trend","decrease","decline","loss","sales-down","revenue-decrease","performance","discount","markdown","price-drop","promotion-end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 14L12 10L10 12L8 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H16V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Arrow-trend-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","decline","sales-down","revenue-down","loss","decrease","negative-trend","drop","arrow-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57535 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57527 3 9.92936V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.45868 21.0001 8.57527 21 9.92936 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0707V9.9294C21 8.57531 21.0001 7.45868 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM11.2929 9.2929C11.6834 8.90237 12.3166 8.90237 12.7071 9.2929L15 11.5858V11C15 10.4477 15.4477 10 16 10C16.5523 10 17 10.4477 17 11V14C17 14.5523 16.5523 15 16 15H13C12.4477 15 12 14.5523 12 14C12 13.4477 12.4477 13 13 13H13.5858L12 11.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.2929 12.7071L7.2929 10.7071C6.90237 10.3166 6.90237 9.68342 7.2929 9.2929C7.68342 8.90237 8.31658 8.90237 8.70711 9.2929L10 10.5858L11.2929 9.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Arrow-trend-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","trend","decrease","sales","report","analytics","loss","decline","performance","revenue-drop","negative-trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 14L12 10L10 12L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H16V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Arrow-trend-up-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trend","arrow-up","sales-increase","revenue","growth","performance","analytics","statistics","charts","metrics","increase","improvement","positive-trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10L12 14L10 12L8 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H16V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Arrow-trend-up-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","trend","up","growth","sales","increase","performance","analytics","metrics","reporting","statistics","progress","positive-trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9H14M14 9V12M14 9L9 15L6.95505 13.0449L4 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Arrow-trend-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trend","arrow","up","growth","sales","increase","performance","statistics","analytics","report","rising","profit","gain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57535 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57527 3 9.92936V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.45868 21.0001 8.57527 21 9.92936 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0707V9.9294C21 8.57531 21.0001 7.45868 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM10 13.4142L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L15 12.4142V13C15 13.5523 15.4477 14 16 14C16.5523 14 17 13.5523 17 13V10C17 9.44772 16.5523 9 16 9H13C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11H13.5858L12 12.5858L10.7071 11.2929C10.3166 10.9024 9.68342 10.9024 9.2929 11.2929L7.2929 13.2929C6.90237 13.6834 6.90237 14.3166 7.2929 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L10 13.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Arrow-trend-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["trend","arrow","up","graph","sales","increase","growth","analytics","report","statistics","performance","trending-up","rising","profit","charts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L12 14L10 12L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H16V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-turn-down-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","undo","back","previous","arrow","turn","reverse","recall","go-back","back-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L15 13C16.8856 13 17.8284 13 18.4142 12.4142C19 11.8284 19 10.8856 19 9V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 17L6.41421 14.4142C5.74755 13.7475 5.41421 13.4142 5.41421 13C5.41421 12.5858 5.74755 12.2525 6.41421 11.5858L9 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-turn-down-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","return","undo","previous","reverse","go-back","return-to-menu","previous-page"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L15 13C16.8856 13 17.8284 13 18.4142 12.4142C19 11.8284 19 10.8856 19 9V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 17L6.41421 14.4142C5.74755 13.7475 5.41421 13.4142 5.41421 13C5.41421 12.5858 5.74755 12.2525 6.41421 11.5858L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-turn-down-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","arrow-left","previous","back","undo","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0002 6C19.5525 6 20.0002 6.44772 20.0002 7L20.0002 9.06583C20.0003 9.95232 20.0003 10.7161 19.9181 11.3278C19.83 11.9833 19.6312 12.6117 19.1216 13.1213C18.6119 13.631 17.9835 13.8297 17.328 13.9179C16.7164 14.0001 15.9526 14.0001 15.0661 14L7.41445 14L9.70735 16.2929C10.0979 16.6834 10.0979 17.3166 9.70735 17.7071C9.31682 18.0976 8.68366 18.0976 8.29313 17.7071L5.70735 15.1213C5.69451 15.1085 5.68168 15.0957 5.66887 15.0829C5.36895 14.783 5.07747 14.4917 4.86943 14.219C4.6349 13.9116 4.40039 13.5137 4.40039 13C4.40039 12.4863 4.6349 12.0884 4.86943 11.781C5.07747 11.5083 5.36895 11.217 5.66887 10.9172C5.68168 10.9043 5.69451 10.8915 5.70735 10.8787L8.29313 8.29289C8.68366 7.90237 9.31682 7.90237 9.70735 8.29289C10.0979 8.68342 10.0979 9.31658 9.70735 9.70711L7.41445 12H15.0002C15.9713 12 16.599 11.9979 17.0615 11.9357C17.4953 11.8774 17.6312 11.7832 17.7073 11.7071C17.7835 11.631 17.8776 11.495 17.9359 11.0613C17.9981 10.5988 18.0002 9.97108 18.0002 9V7C18.0002 6.44772 18.448 6 19.0002 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-turn-down-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","back","previous","arrow-left","arrow","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L15 13C16.8856 13 17.8284 13 18.4142 12.4142C19 11.8284 19 10.8856 19 9V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 17L6.41421 14.4142C5.74755 13.7475 5.41421 13.4142 5.41421 13C5.41421 12.5858 5.74755 12.2525 6.41421 11.5858L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-turn-top-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","back","return","undo","previous","reverse","navigation","go-back","step-back","back-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L15 11C16.8856 11 17.8284 11 18.4142 11.5858C19 12.1716 19 13.1144 19 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 15L6.41421 12.4142C5.74755 11.7475 5.41421 11.4142 5.41421 11C5.41421 10.5858 5.74755 10.2525 6.41421 9.58579L9 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-turn-top-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","return","previous","undo","arrow","navigation","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L15 11C16.8856 11 17.8284 11 18.4142 11.5858C19 12.1716 19 13.1144 19 15V17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 15L6.41421 12.4142C5.74755 11.7475 5.41421 11.4142 5.41421 11C5.41421 10.5858 5.74755 10.2525 6.41421 9.58579L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-turn-top-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","undo","previous","arrow-left","go-back","reverse","cancel","correction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70735 6.29289C10.0979 6.68342 10.0979 7.31658 9.70735 7.70711L7.41445 10L15.0661 10C15.9526 9.99995 16.7164 9.99991 17.328 10.0821C17.9835 10.1703 18.6119 10.369 19.1216 10.8787C19.6312 11.3883 19.83 12.0167 19.9181 12.6722C20.0003 13.2839 20.0003 14.0477 20.0002 14.9342L20.0002 17C20.0002 17.5523 19.5525 18 19.0002 18C18.448 18 18.0002 17.5523 18.0002 17V15C18.0002 14.0289 17.9981 13.4012 17.9359 12.9387C17.8776 12.505 17.7835 12.369 17.7073 12.2929C17.6312 12.2168 17.4953 12.1226 17.0615 12.0643C16.599 12.0021 15.9713 12 15.0002 12H7.41445L9.70735 14.2929C10.0979 14.6834 10.0979 15.3166 9.70735 15.7071C9.31682 16.0976 8.68366 16.0976 8.29313 15.7071L5.70735 13.1213C5.69451 13.1085 5.68168 13.0957 5.66887 13.0829C5.36895 12.783 5.07747 12.4917 4.86943 12.219C4.6349 11.9116 4.40039 11.5137 4.40039 11C4.40039 10.4863 4.6349 10.0884 4.86943 9.78098C5.07747 9.50831 5.36895 9.21695 5.66887 8.91715C5.68168 8.90434 5.69451 8.89152 5.70735 8.87868L8.29313 6.29289C8.68366 5.90237 9.31682 5.90237 9.70735 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-turn-top-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","undo","previous","arrow","left","go-back","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L15 11C16.8856 11 17.8284 11 18.4142 11.5858C19 12.1716 19 13.1144 19 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 15L6.41421 12.4142C5.74755 11.7475 5.41421 11.4142 5.41421 11C5.41421 10.5858 5.74755 10.2525 6.41421 9.58579L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrows","up","down","sort","order","ascending","descending","toggle","inventory","price","change","swap","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6L14 18L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L16 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 18L10 6L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6L8 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","arrows","up-down","swap","change","reorder","arrange","inventory","transfer","stock","toggle","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6L14 18L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 18L10 6L8 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","up-down","sort","toggle","inventory","price-adjust","change","switch","transaction","adjustment","exchange","ordering"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6173 18.9239C13.2436 18.7691 13 18.4045 13 18V6.00003C13 5.44774 13.4477 5.00003 14 5.00003C14.5523 5.00003 15 5.44774 15 6.00003V15.5858L15.2929 15.2929C15.6834 14.9024 16.3166 14.9024 16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071L14.7071 18.7071C14.4211 18.9931 13.991 19.0787 13.6173 18.9239Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3827 5.07615C10.7564 5.23093 11 5.59557 11 6.00003L11 18C11 18.5523 10.5523 19 10 19C9.44771 19 9 18.5523 9 18L9 8.41424L8.70711 8.70714C8.31658 9.09766 7.68342 9.09766 7.29289 8.70714C6.90237 8.31661 6.90237 7.68345 7.29289 7.29292L9.29289 5.29292C9.57889 5.00692 10.009 4.92137 10.3827 5.07615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["swap","exchange","transfer","change","arrows","transaction","switch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 14L6 14L8 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10L18 10L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exchange","swap","switch","transfer","arrow","arrows","replace","change","shift","reverse","convert","move","cycle","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 14L6 14L8 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10L18 10L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14L8 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10L16 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["swap","switch","exchange","transfer","arrows","transaction","replace","toggle","invert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 14L6 14L8 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10L18 10L16 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","order","arrow","arrows","up","down","exchange","transfer","swap","change","inventory","reorder","data-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L11 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L13 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","swap","transaction","transfer","switch","convert","change","arrows-horizontal","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.07615 13.6173C5.23093 13.2436 5.59557 13 6.00003 13L18 13C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15L8.41424 15L8.70714 15.2929C9.09766 15.6834 9.09766 16.3166 8.70714 16.7071C8.31661 17.0976 7.68345 17.0976 7.29292 16.7071L5.29292 14.7071C5.00692 14.4211 4.92137 13.991 5.07615 13.6173Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289L18.7071 9.29289C18.9931 9.57889 19.0787 10.009 18.9239 10.3827C18.7691 10.7564 18.4045 11 18 11L6.00003 11C5.44774 11 5.00003 10.5523 5.00003 10C5.00003 9.44771 5.44774 9 6.00003 9L15.5858 9L15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sort","arrow-up","arrow-down","swap","switch","toggle","arrange","reorder","change","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11L11 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L13 15L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","down","transfer","sort","exchange","transaction","cycle","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM11 9.00003C11 8.59557 10.7564 8.23093 10.3827 8.07615C10.009 7.92137 9.57889 8.00692 9.29289 8.29292L7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0977 8.31658 12.0977 8.70711 11.7071L9 11.4142V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V9.00003ZM13 15C13 15.4045 13.2436 15.7691 13.6173 15.9239C13.991 16.0787 14.4211 15.9931 14.7071 15.7071L16.7071 13.7071C17.0976 13.3166 17.0976 12.6834 16.7071 12.2929C16.3166 11.9024 15.6834 11.9024 15.2929 12.2929L15 12.5858L15 9.00003C15 8.44774 14.5523 8.00003 14 8.00003C13.4477 8.00003 13 8.44774 13 9.00003V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-arrow-down-circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-up","arrow-down","circle","sort","transfer","exchange","transaction","synchronize","reconcile","adjust","toggle","inventory","stock","price-change","quantity-change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11L11 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L13 15L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-arrow-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","up","down","transfer","exchange","sort","ordering","sequence","scroll","adjust","inventory","movement","transaction","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6L14 18L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 18L10 6L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-from-square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["upload","export","arrow-up","send","share","submit","save","transfer","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L8.5 12C7.09554 12 6.39331 12 5.88886 12.3371C5.67048 12.483 5.48298 12.6705 5.33706 12.8889C5 13.3933 5 14.0955 5 15.5V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19L15.5 19C16.9045 19 17.6067 19 18.1111 18.6629C18.3295 18.517 18.517 18.3295 18.6629 18.1111C19 17.6067 19 16.9045 19 15.5V15.5C19 14.0955 19 13.3933 18.6629 12.8889C18.517 12.6705 18.3295 12.483 18.1111 12.3371C17.6067 12 16.9045 12 15.5 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 9L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-up-from-square-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["upload","export","send","share","data","transfer","output","backup","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L8.5 12C7.09554 12 6.39331 12 5.88886 12.3371C5.67048 12.483 5.48298 12.6705 5.33706 12.8889C5 13.3933 5 14.0955 5 15.5V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19L15.5 19C16.9045 19 17.6067 19 18.1111 18.6629C18.3295 18.517 18.517 18.3295 18.6629 18.1111C19 17.6067 19 16.9045 19 15.5V15.5C19 14.0955 19 13.3933 18.6629 12.8889C18.517 12.6705 18.3295 12.483 18.1111 12.3371C17.6067 12 16.9045 12 15.5 12L15 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 9L12 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-up-from-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["upload","export","arrow-up","square","send","data","transfer","backup","share","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 15.5486C4 15.5324 4 15.5162 4 15.5C4 15.4838 4 15.4676 4 15.4514C3.99997 14.7907 3.99995 14.2209 4.04727 13.7557C4.09745 13.2625 4.20898 12.7772 4.50559 12.3333C4.72447 12.0057 5.00572 11.7245 5.33329 11.5056C5.77721 11.209 6.26248 11.0974 6.75572 11.0473C7.22089 10.9999 7.29069 11 7.95143 11L8.5 11C9.05229 11 9.5 11.4477 9.5 12C9.5 12.5523 9.05229 13 8.5 13H8C7.27696 13 7.30995 13.0012 6.95813 13.037C6.62303 13.0711 6.50496 13.1281 6.44443 13.1685C6.33524 13.2415 6.24149 13.3352 6.16853 13.4444C6.12809 13.505 6.07109 13.623 6.037 13.9581C6.00121 14.3099 6 14.777 6 15.5C6 16.223 6.00121 16.6901 6.037 17.0419C6.07109 17.377 6.12809 17.495 6.16853 17.5556C6.24149 17.6648 6.33524 17.7585 6.44443 17.8315C6.50496 17.8719 6.62303 17.9289 6.95813 17.963C7.30995 17.9988 7.77696 18 8.5 18L15.5 18C16.223 18 16.6901 17.9988 17.0419 17.963C17.377 17.9289 17.495 17.8719 17.5556 17.8315C17.6648 17.7585 17.7585 17.6648 17.8315 17.5556C17.8719 17.495 17.9289 17.377 17.963 17.0419C17.9988 16.6901 18 16.223 18 15.5C18 14.777 17.9988 14.3099 17.963 13.9581C17.9289 13.623 17.8719 13.505 17.8315 13.4444C17.7585 13.3352 17.6648 13.2415 17.5556 13.1685C17.495 13.1281 17.377 13.0711 17.0419 13.037C16.6901 13.0012 16.723 13 16 13H15.5C14.9477 13 14.5 12.5523 14.5 12C14.5 11.4477 14.9477 11 15.5 11L16.0486 11C16.7093 11 16.7791 10.9999 17.2443 11.0473C17.7375 11.0974 18.2228 11.209 18.6667 11.5056C18.9943 11.7245 19.2755 12.0057 19.4944 12.3333C19.791 12.7772 19.9026 13.2625 19.9527 13.7557C20.0001 14.2209 20 14.7907 20 15.4514V15.5486C20 16.2093 20.0001 16.7791 19.9527 17.2443C19.9026 17.7375 19.791 18.2228 19.4944 18.6667C19.2755 18.9943 18.9943 19.2755 18.6667 19.4944C18.2228 19.791 17.7375 19.9026 17.2443 19.9527C16.7791 20.0001 16.2093 20 15.5486 20L8.5 20C8.48376 20 8.46758 20 8.45144 20C7.7907 20 7.22089 20.0001 6.75572 19.9527C6.26248 19.9026 5.77721 19.791 5.33329 19.4944C5.00572 19.2755 4.72447 18.9943 4.50559 18.6667C4.20898 18.2228 4.09745 17.7375 4.04727 17.2443C3.99995 16.7791 3.99997 16.2093 4 15.5486Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711C16.3166 10.0976 15.6834 10.0976 15.2929 9.70711L13 7.41421V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V7.41421L8.70711 9.70711C8.31658 10.0976 7.68342 10.0976 7.29289 9.70711C6.90237 9.31658 6.90237 8.68342 7.29289 8.29289L11.2929 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-from-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["upload","send","export","transfer","submit","backup","arrow-up","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L8.5 12C7.09554 12 6.39331 12 5.88886 12.3371C5.67048 12.483 5.48298 12.6705 5.33706 12.8889C5 13.3933 5 14.0955 5 15.5V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19L15.5 19C16.9045 19 17.6067 19 18.1111 18.6629C18.3295 18.517 18.517 18.3295 18.6629 18.1111C19 17.6067 19 16.9045 19 15.5V15.5C19 14.0955 19 13.3933 18.6629 12.8889C18.517 12.6705 18.3295 12.483 18.1111 12.3371C17.6067 12 16.9045 12 15.5 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-up-right-and-arrow-down-left-from-center-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["expand","arrows","resize","fullscreen","enlarge","scale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 19L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 5L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 19L5 19L5 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H19V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-right-and-arrow-down-left-from-center-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["expand","resize","fullscreen","enlarge","move","transfer","arrows","direction","scale","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19L5 19L5 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L11 13" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 5L19 5V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 5L13 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-up-right-and-arrow-down-left-from-center-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","arrows","resize","fullscreen","maximize","full-screen","enlarge","scale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6C13.4477 6 13 5.55228 13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V7.41421L13.7071 11.7071C13.3166 12.0976 12.6834 12.0976 12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929L16.5858 6H14ZM10.2929 12.2929C10.6834 11.9024 11.3166 11.9024 11.7071 12.2929C12.0976 12.6834 12.0976 13.3166 11.7071 13.7071L7.41421 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H5C4.44772 20 4 19.5523 4 19L4 14C4 13.4477 4.44772 13 5 13C5.55228 13 6 13.4477 6 14L6 16.5858L10.2929 12.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-right-and-arrow-down-left-from-center": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","resize","fullscreen","maximize","enlarge","increase","scale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19L5 19L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 5L19 5V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 5L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "arrow-up-short-wide-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","order","reorder","arrow-up","list","priority","arrange","increase","ascend","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-short-wide-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sort","order","increase","ascending","prioritize","reorder","list","arrow-up","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-short-wide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","order","list","arrow-up","priority","increase","ascending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.58579 6.99997C6.36683 6.21892 7.63316 6.21892 8.41421 6.99997L10.7071 9.29286C11.0976 9.68339 11.0976 10.3166 10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29289 10.7071L8 9.41418L8 17C8 17.5523 7.55229 18 7 18C6.44772 18 6 17.5523 6 17L6 9.41418L4.70711 10.7071C4.31658 11.0976 3.68342 11.0976 3.29289 10.7071C2.90237 10.3166 2.90237 9.68339 3.29289 9.29287L5.58579 6.99997ZM13 8.99997C13 8.44769 13.4477 7.99997 14 7.99997H18C18.5523 7.99997 19 8.44769 19 8.99997C19 9.55226 18.5523 9.99997 18 9.99997H14C13.4477 9.99997 13 9.55226 13 8.99997ZM13 12C13 11.4477 13.4477 11 14 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H14C13.4477 13 13 12.5523 13 12ZM13 15C13 14.4477 13.4477 14 14 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H14C13.4477 16 13 15.5523 13 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-wide-short-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sort","sort-up","order","prioritize","ranking","reorder","move-to-top","list","up","arrow","arrow-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-short-wide": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow-up","filter","order","queue","prioritize","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-wide-short-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow-up","arrow","upload","sort","sort-up","move-up","promote","list","lines","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrow-up-wide-short-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow-up","menu","options","organize","prioritize","reorder","sort-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 8.7858C13 8.23351 13.4477 7.7858 14 7.7858H20C20.5523 7.7858 21 8.23351 21 8.7858C21 9.33808 20.5523 9.7858 20 9.7858H14C13.4477 9.7858 13 9.33808 13 8.7858ZM13 11.7858C13 11.2335 13.4477 10.7858 14 10.7858H20C20.5523 10.7858 21 11.2335 21 11.7858C21 12.3381 20.5523 12.7858 20 12.7858H14C13.4477 12.7858 13 12.3381 13 11.7858ZM13 14.7858C13 14.2335 13.4477 13.7858 14 13.7858H18C18.5523 13.7858 19 14.2335 19 14.7858C19 15.3381 18.5523 15.7858 18 15.7858H14C13.4477 15.7858 13 15.3381 13 14.7858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.58579 6.7858C6.36683 6.00475 7.63316 6.00475 8.41421 6.7858L10.7071 9.07869C11.0976 9.46922 11.0976 10.1024 10.7071 10.4929C10.3166 10.8834 9.68342 10.8834 9.29289 10.4929L8 9.20001L8 16.7858C8 17.3381 7.55229 17.7998 7 17.7998C6.44772 17.7998 6 17.3381 6 16.7858L6 9.20001L4.70711 10.4929C4.31658 10.8834 3.68342 10.8834 3.29289 10.4929C2.90237 10.1024 2.90237 9.46922 3.29289 9.07869L5.58579 6.7858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrow-up-wide-short": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow","up","list","rank","priority","arrange","reorder","ascend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17L7 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10L6.29289 7.70711C6.68342 7.31658 7.31658 7.31658 7.70711 7.70711L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-cross-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cancel","close","remove","disable","arrows","cross","exchange","swap","disable-item","remove-item","cancel-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L6 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14V18H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10V6H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-cross-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","close","dismiss","exit","delete","arrows","cross","clear","discard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L6 18M6 18V14M6 18H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L6 6M6 6V10M6 6H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cross","cancel","reject","close","arrows","direction","navigation","exclude","remove","undo","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H8.41421L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L8.41421 17H10C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19H6C5.44772 19 5 18.5523 5 18V14C5 13.4477 5.44772 13 6 13C6.55228 13 7 13.4477 7 14V15.5858L10.5858 12L7 8.41421V10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10V6C5 5.44772 5.44772 5 6 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","cross","cancel","dismiss","close","exit","remove","delete","void","reject"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L6 18M6 18V14M6 18H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L6 6M6 6V10M6 6H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-down-to-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","export","backup","import","data","sync","arrows","line","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L8.70711 14.2929C8.31658 14.6834 7.68342 14.6834 7.29289 14.2929L5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12L16.7071 14.2929C16.3166 14.6834 15.6834 14.6834 15.2929 14.2929L13 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-down-to-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","import","receive","inventory","sync","update","arrows-down","data","backup","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L16 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L8.70711 14.2929C8.31658 14.6834 7.68342 14.6834 7.29289 14.2929L5 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12L16.7071 14.2929C16.3166 14.6834 15.6834 14.6834 15.2929 14.2929L13 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-down-to-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","arrows","down","inventory","receive-items","receive-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 16.5L20 16.5C20.5523 16.5 21 16.9477 21 17.5C21 18.0523 20.5523 18.5 20 18.5L4 18.5C3.44772 18.5 3 18.0523 3 17.5C3 16.9477 3.44772 16.5 4 16.5ZM18.4142 14.5C17.6332 15.281 16.3668 15.281 15.5858 14.5L13.2929 12.2071C12.9024 11.8166 12.9024 11.1834 13.2929 10.7929C13.6834 10.4024 14.3166 10.4024 14.7071 10.7929L16 12.0858L16 6.5C16 5.94772 16.4477 5.5 17 5.5C17.5523 5.5 18 5.94771 18 6.5L18 12.0858L19.2929 10.7929C19.6834 10.4024 20.3166 10.4024 20.7071 10.7929C21.0976 11.1834 21.0976 11.8166 20.7071 12.2071L18.4142 14.5ZM8.41422 14.5C7.63317 15.281 6.36684 15.2811 5.58579 14.5L3.29289 12.2071C2.90237 11.8166 2.90237 11.1834 3.29289 10.7929C3.68342 10.4024 4.31658 10.4024 4.70711 10.7929L6 12.0858L6 6.5C6 5.94772 6.44771 5.5 7 5.5C7.55228 5.5 8 5.94772 8 6.5L8 12.0858L9.29289 10.7929C9.68342 10.4024 10.3166 10.4024 10.7071 10.7929C11.0976 11.1834 11.0976 11.8166 10.7071 12.2071L8.41422 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-down-to-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","arrows","move-to","inventory","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L8.70711 14.2929C8.31658 14.6834 7.68342 14.6834 7.29289 14.2929L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12L16.7071 14.2929C16.3166 14.6834 15.6834 14.6834 15.2929 14.2929L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrows","left","right","switch","toggle","exchange","transfer","navigation","change","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 12L11 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4.41406 13.4142L6.99985 16V8L4.41406 10.5858C3.7474 11.2525 3.41406 11.5858 3.41406 12C3.41406 12.4142 3.7474 12.7475 4.41406 13.4142Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5858 10.5858L17 8V16L19.5858 13.4142C20.2525 12.7475 20.5858 12.4142 20.5858 12C20.5858 11.5858 20.2525 11.2525 19.5858 10.5858Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrows","left","right","switch","change","swap","transfer","move","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","switch","direction","transfer","move","change","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.38253 7.07615C7.75621 7.23093 7.99985 7.59557 7.99985 8.00003V11L15.9998 11V8.00003C15.9998 7.59557 16.2435 7.23093 16.6172 7.07615C16.9908 6.92137 17.421 7.00692 17.707 7.29292L20.3312 9.91717C20.6311 10.217 20.9226 10.5083 21.1307 10.781C21.3652 11.0884 21.5856 11.4864 21.5856 12C21.5856 12.5137 21.3652 12.9117 21.1307 13.219C20.9226 13.4917 20.6311 13.7831 20.3312 14.0829C20.3184 14.0957 20.3056 14.1085 20.2927 14.1213L17.707 16.7071C17.421 16.9931 16.9908 17.0787 16.6172 16.9239C16.2435 16.7691 15.9998 16.4045 15.9998 16V13L7.99985 13V16C7.99985 16.4045 7.75621 16.7691 7.38253 16.9239C7.00886 17.0787 6.57874 16.9931 6.29274 16.7071L3.70695 14.1213C3.69412 14.1085 3.68129 14.0957 3.66848 14.0829C3.36856 13.7831 3.07708 13.4917 2.86904 13.219C2.63451 12.9117 2.41406 12.5137 2.41406 12C2.41406 11.4864 2.63451 11.0884 2.86904 10.781C3.07708 10.5083 3.36856 10.217 3.66848 9.91717C3.68129 9.90437 3.69412 9.89155 3.70695 9.87871L6.29274 7.29292C6.57874 7.00692 7.00886 6.92137 7.38253 7.07615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-left-right-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrows","left","right","switch","change","swap","transfer","move","exchange","direction","horizontal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9L17.8667 10.4C18.8444 11.1333 19.3333 11.5 19.3333 12C19.3333 12.5 18.8444 12.8667 17.8667 13.6L16 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 15L6.13333 13.6C5.15555 12.8667 4.66667 12.5 4.66667 12C4.66667 11.5 5.15556 11.1333 6.13333 10.4L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrows-left-right-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","direction","switch","change","transfer","exchange","move","transaction","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9L17.8667 10.4C18.8444 11.1333 19.3333 11.5 19.3333 12C19.3333 12.5 18.8444 12.8667 17.8667 13.6L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 15L6.13333 13.6C5.15555 12.8667 4.66667 12.5 4.66667 12C4.66667 11.5 5.15556 11.1333 6.13333 10.4L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrows-left-right-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrows","left-right","switch","toggle","transfer","exchange","swap","reverse","move","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L10.6 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9L17.8667 10.4C18.8444 11.1333 19.3333 11.5 19.3333 12C19.3333 12.5 18.8444 12.8667 17.8667 13.6L16 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 15L6.13333 13.6C5.15555 12.8667 4.66667 12.5 4.66667 12C4.66667 11.5 5.15556 11.1333 6.13333 10.4L8 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrows-left-right-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","switch","toggle","change","exchange","transfer","direction","navigation","options","horizontal","adjust","mirror"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2003 8.40006C15.5317 7.95823 16.1585 7.86869 16.6003 8.20006L18.467 9.60006C18.4843 9.61302 18.5015 9.62596 18.5187 9.63886C18.9628 9.97181 19.3796 10.2843 19.6761 10.5825C20.0017 10.9099 20.3337 11.3669 20.3337 12.0001C20.3337 12.6332 20.0017 13.0902 19.6761 13.4177C19.3796 13.7158 18.9628 14.0283 18.5187 14.3613C18.5015 14.3742 18.4843 14.3871 18.467 14.4001L16.6003 15.8001C16.1585 16.1314 15.5317 16.0419 15.2003 15.6001C14.869 15.1582 14.9585 14.5314 15.4003 14.2001L17.0003 13.0001L7.00032 13.0001L8.60033 14.2001C9.04215 14.5314 9.1317 15.1582 8.80032 15.6001C8.46895 16.0419 7.84215 16.1314 7.40032 15.8001L5.53366 14.4001C5.51637 14.3871 5.49912 14.3742 5.48191 14.3613C5.03784 14.0283 4.62101 13.7158 4.32455 13.4177C3.99898 13.0902 3.66699 12.6332 3.66699 12.0001C3.66699 11.3669 3.99898 10.9099 4.32455 10.5825C4.621 10.2843 5.03783 9.97181 5.48191 9.63886C5.49912 9.62596 5.51637 9.61303 5.53366 9.60006L7.40033 8.20006C7.84215 7.86869 8.46895 7.95823 8.80033 8.40006C9.1317 8.84189 9.04215 9.46869 8.60033 9.80006L7.00033 11.0001L17.0003 11.0001L15.4003 9.80006C14.9585 9.46869 14.869 8.84189 15.2003 8.40006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-left-right-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","switch","swap","transfer","change","direction","move","transaction","exchange","back-and-forth"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","switch","swap","change","transfer","transaction","move","direction","toggle","shift"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41422 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","switch","swap","transfer","exchange","change","direction","move","transaction","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.70695 8.29289C8.09748 8.68342 8.09748 9.31658 7.70695 9.70711L6.41406 11L9.99985 11C10.5521 11 10.9998 11.4477 10.9998 12C10.9998 12.5523 10.5521 13 9.99985 13L6.41406 13L7.70696 14.2929C8.09748 14.6834 8.09748 15.3166 7.70696 15.7071C7.31643 16.0976 6.68327 16.0976 6.29274 15.7071L4.70696 14.1213C4.69412 14.1085 4.68129 14.0957 4.66848 14.0829C4.36856 13.7831 4.07708 13.4917 3.86904 13.219C3.63451 12.9116 3.41406 12.5137 3.41406 12C3.41406 11.4863 3.63451 11.0884 3.86904 10.781C4.07708 10.5083 4.36856 10.217 4.66848 9.91715C4.68129 9.90434 4.69412 9.89152 4.70696 9.87868L6.29274 8.29289C6.68327 7.90237 7.31643 7.90237 7.70695 8.29289ZM16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L19.2929 9.87868C19.3057 9.89151 19.3186 9.90434 19.3314 9.91714C19.6313 10.2169 19.9228 10.5083 20.1308 10.781C20.3653 11.0884 20.5858 11.4863 20.5858 12C20.5858 12.5137 20.3653 12.9116 20.1308 13.219C19.9228 13.4917 19.6313 13.783 19.3314 14.0828C19.3186 14.0957 19.3057 14.1085 19.2929 14.1213L17.7071 15.7071C17.3166 16.0976 16.6834 16.0976 16.2929 15.7071C15.9024 15.3166 15.9024 14.6834 16.2929 14.2929L17.5858 13L14 13C13.4477 13 13 12.5523 13 12C13 11.4477 13.4477 11 14 11L17.5858 11L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-left-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrows","left","right","switch","swap","transfer","transaction","change","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41422 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","transfer","switch","swap","toggle","change","move","adjustment","transaction","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.69328 8.29289C8.08381 8.68342 8.08381 9.31658 7.69328 9.70711L6.40039 11H9.98618C10.5385 11 10.9862 11.4477 10.9862 12C10.9862 12.5523 10.5385 13 9.98618 13H6.40039L7.69328 14.2929C8.08381 14.6834 8.08381 15.3166 7.69329 15.7071C7.30276 16.0976 6.6696 16.0976 6.27907 15.7071L4.69329 14.1213C4.68045 14.1085 4.66762 14.0957 4.65481 14.0829C4.35488 13.783 4.06341 13.4917 3.85537 13.219C3.62083 12.9116 3.40039 12.5137 3.40039 12C3.40039 11.4863 3.62083 11.0884 3.85537 10.781C4.06341 10.5083 4.35488 10.217 4.6548 9.91715C4.66762 9.90434 4.68045 9.89152 4.69328 9.87868L6.27907 8.29289C6.66959 7.90237 7.30276 7.90237 7.69328 8.29289ZM16.2792 8.29289C16.6697 7.90237 17.3029 7.90237 17.6934 8.29289L19.2792 9.87868C19.2921 9.89152 19.3049 9.90434 19.3177 9.91715C19.6176 10.217 19.9091 10.5083 20.1171 10.781C20.3517 11.0884 20.5721 11.4863 20.5721 12C20.5721 12.5137 20.3517 12.9116 20.1171 13.219C19.9091 13.4917 19.6176 13.7831 19.3177 14.0829C19.3049 14.0957 19.2921 14.1085 19.2792 14.1213L17.6934 15.7071C17.3029 16.0976 16.6697 16.0976 16.2792 15.7071C15.8887 15.3166 15.8887 14.6834 16.2792 14.2929L17.5721 13H13.9863C13.434 13 12.9863 12.5523 12.9863 12C12.9863 11.4477 13.434 11 13.9863 11H17.5721L16.2792 9.70711C15.8887 9.31658 15.8887 8.68342 16.2792 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-left-right-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","transfer","move","transaction","exchange","switch","resize","adjust","shift","balance","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 12L11 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 16V11.2V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 16L4.41421 13.4142C3.74755 12.7475 3.41421 12.4142 3.41421 12C3.41421 11.5858 3.74755 11.2525 4.41421 10.5858L7 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 8L17 12.8L17 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8L19.5858 10.5858C20.2525 11.2525 20.5858 11.5858 20.5858 12C20.5858 12.4142 20.2525 12.7475 19.5858 13.4142L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrows-left-right-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrows","left-right","swap","switch","transfer","exchange","toggle","move","shift","alternate","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41422 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrows","left","right","transfer","switch","swap","move","resize","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 12L11 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 16V11.2V8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 16L4.41421 13.4142C3.74755 12.7475 3.41421 12.4142 3.41421 12C3.41421 11.5858 3.74755 11.2525 4.41421 10.5858L7 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 8L17 12.8L17 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8L19.5858 10.5858C20.2525 11.2525 20.5858 11.5858 20.5858 12C20.5858 12.4142 20.2525 12.7475 19.5858 13.4142L17 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "arrows-left-right-to-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["resize","adjust","width","change","arrows","left-right","interface","layout","scale","dimensions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 6L21 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 6L3 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-to-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["adjust","resize","width","length","arrows","left","right","spacing","scale","change size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 6L21 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 6L3 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-to-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","exchange","transfer","adjust","width","resize","distance","gap","space"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 6L21 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 6L3 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-left-right-to-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","left","right","transfer","exchange","move","transaction","adjust","change","shift","size","resize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 5C2.05229 5 2.5 5.44772 2.5 6L2.5 18C2.5 18.5523 2.05228 19 1.5 19C0.947715 19 0.5 18.5523 0.5 18L0.500001 6C0.500001 5.44772 0.947716 5 1.5 5ZM22.5 5C23.0523 5 23.5 5.44772 23.5 6V18C23.5 18.5523 23.0523 19 22.5 19C21.9477 19 21.5 18.5523 21.5 18V6C21.5 5.44772 21.9477 5 22.5 5ZM7.70695 8.29289C8.09748 8.68342 8.09748 9.31658 7.70696 9.70711L6.41406 11L9.99985 11C10.5521 11 10.9998 11.4477 10.9998 12C10.9999 12.5523 10.5521 13 9.99985 13L6.41406 13L7.70696 14.2929C8.09748 14.6834 8.09748 15.3166 7.70696 15.7071C7.31643 16.0976 6.68327 16.0976 6.29274 15.7071L4.70696 14.1213C4.69412 14.1085 4.6813 14.0957 4.66849 14.0829C4.36856 13.7831 4.07708 13.4917 3.86904 13.219C3.63451 12.9116 3.41406 12.5137 3.41406 12C3.41406 11.4863 3.63451 11.0884 3.86904 10.781C4.07708 10.5083 4.36855 10.217 4.66847 9.91715C4.68129 9.90434 4.69412 9.89152 4.70695 9.87868L6.29274 8.29289C6.68327 7.90237 7.31643 7.90237 7.70695 8.29289ZM16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L19.2929 9.87868C19.3057 9.89152 19.3186 9.90435 19.3314 9.91716C19.6313 10.217 19.9228 10.5083 20.1308 10.781C20.3653 11.0884 20.5858 11.4863 20.5858 12C20.5858 12.5137 20.3653 12.9116 20.1308 13.219C19.9228 13.4917 19.6313 13.7831 19.3314 14.0829C19.3186 14.0957 19.3057 14.1085 19.2929 14.1213L17.7071 15.7071C17.3166 16.0976 16.6834 16.0976 16.2929 15.7071C15.9024 15.3166 15.9024 14.6834 16.2929 14.2929L17.5858 13L14 13C13.4477 13 13 12.5523 13 12C13 11.4477 13.4477 11 14 11L17.5858 11L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-left-right": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrows","left","right","switch","transfer","exchange","direction","move","scroll","navigation","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L17.5858 10.5858C18.2525 11.2525 18.5858 11.5858 18.5858 12C18.5858 12.4142 18.2525 12.7475 17.5858 13.4142L16 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6.41421 13.4142C5.74755 12.7475 5.41421 12.4142 5.41421 12C5.41421 11.5858 5.74755 11.2525 6.41421 10.5858L8 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-sort-a-z-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","sort-a-z","sort-down","sort-up","order","alphabetical","filter","arrows","arrange","inventory-sort","price-sort","date-sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 5C9.05228 5 9.5 5.44772 9.5 6V15.5858L10.7929 14.2929C11.1834 13.9024 11.8166 13.9024 12.2071 14.2929C12.5976 14.6834 12.5976 15.3166 12.2071 15.7071L9.20711 18.7071C8.81658 19.0976 8.18342 19.0976 7.79289 18.7071L4.79289 15.7071C4.40237 15.3166 4.40237 14.6834 4.79289 14.2929C5.18342 13.9024 5.81658 13.9024 6.20711 14.2929L7.5 15.5858V6C7.5 5.44772 7.94772 5 8.5 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 15C13.9477 15 13.5 14.5523 13.5 14C13.5 13.4477 13.9477 13 14.5 13H18.5C18.9045 13 19.2691 13.2436 19.4239 13.6173C19.5787 13.991 19.4931 14.4211 19.2071 14.7071L16.9142 17H18.5C19.0523 17 19.5 17.4477 19.5 18C19.5 18.5523 19.0523 19 18.5 19H14.5C14.0956 19 13.7309 18.7564 13.5761 18.3827C13.4214 18.009 13.5069 17.5789 13.7929 17.2929L16.0858 15H14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5001 5C16.8789 4.99999 17.2252 5.21399 17.3946 5.55277L19.3946 9.55277C19.6416 10.0467 19.4414 10.6474 18.9474 10.8944C18.4535 11.1414 17.8528 10.9412 17.6058 10.4472L16.5002 8.23607L15.3947 10.4472C15.1477 10.9412 14.547 11.1414 14.053 10.8944C13.559 10.6475 13.3588 10.0468 13.6058 9.5528L15.6057 5.5528C15.7751 5.21401 16.1213 5.00001 16.5001 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-sort-a-z-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sort","arrow","order","ascending","descending","alphabetical","a-z","z-a","filter","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6L8 18M8 18L5 15M8 18L11 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14H17L13 18H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L14.9999 6L17 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-sort-a-z-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sort","ascending","descending","order","alphabetical","a-z","inventory","list","price","filter","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 14H18L14 18H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10L15.9999 6L18 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L7.58579 16.5858C8.25245 17.2525 8.58579 17.5858 9 17.5858C9.41421 17.5858 9.74755 17.2525 10.4142 16.5858L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-sort-a-z": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","sort-alpha","sort-alphabetical","a-z","order","ascending","descending","filter","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 14H18L14 18H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10L15.9999 6L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L7.58579 16.5858C8.25245 17.2525 8.58579 17.5858 9 17.5858C9.41421 17.5858 9.74755 17.2525 10.4142 16.5858L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["split","arrow","left-right","separate","transaction","divide","payment-methods","cash-split"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["split","arrows","direction","move","separate","divide","redistribute","shift","transfer","transaction","split-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","arrows","divide","separate","transfer","move","split-payment","transfer-funds"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0004 5C12.5527 5 13.0004 5.44772 13.0004 6V18C13.0004 18.5523 12.5527 19 12.0004 19C11.4481 19 11.0004 18.5523 11.0004 18V6C11.0004 5.44772 11.4481 5 12.0004 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.2934 8.29289C17.684 7.90237 18.3171 7.90237 18.7076 8.29289L20.3319 9.91716C20.6318 10.217 20.9233 10.5083 21.1314 10.781C21.3659 11.0884 21.6005 11.4863 21.6005 12C21.6005 12.5137 21.3659 12.9116 21.1314 13.219C20.9233 13.4917 20.6318 13.783 20.3319 14.0828L18.7076 15.7071C18.3171 16.0976 17.684 16.0976 17.2934 15.7071C16.9029 15.3166 16.9029 14.6834 17.2934 14.2929L18.5863 13H15.0005C14.4483 13 14.0005 12.5523 14.0005 12C14.0005 11.4477 14.4483 11 15.0005 11L18.5863 11L17.2934 9.70711C16.9029 9.31658 16.9029 8.68342 17.2934 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.69328 8.29289C7.08381 8.68342 7.08381 9.31658 6.69328 9.70711L5.40039 11L8.98618 11C9.53846 11 9.98618 11.4477 9.98618 12C9.98618 12.5523 9.53846 13 8.98618 13L5.40039 13L6.69328 14.2929C7.08381 14.6834 7.08381 15.3166 6.69329 15.7071C6.30276 16.0976 5.6696 16.0976 5.27907 15.7071L3.65481 14.0829C3.35489 13.783 3.06341 13.4917 2.85537 13.219C2.62084 12.9116 2.40039 12.5137 2.40039 12C2.40039 11.4863 2.62083 11.0884 2.85537 10.781C3.06341 10.5083 3.35489 10.2169 3.65481 9.91714L5.27907 8.29289C5.66959 7.90237 6.30276 7.90237 6.69328 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-split-alt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["split","divide","separate","branch","options","segment","arrows","choice","variants","split-tender"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-alt-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["split","divide","separate","payment-split","split-payment","divide-payment","merge","combine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","divide","separate","arrows","alter","alternative","code","source-code","branch","fork"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-split-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","divide","separate","segment","arrows","between","navigation","sort","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9999 5C12.5521 5 12.9999 5.44772 12.9999 6L12.9998 18C12.9998 18.5523 12.5521 19 11.9998 19C11.4476 19 10.9998 18.5523 10.9998 18L10.9999 6C10.9999 5.44772 11.4476 5 11.9999 5ZM7.70695 8.29289C8.09748 8.68342 8.09748 9.31658 7.70695 9.70711L6.12117 11.2929C5.76785 11.6462 5.57549 11.8416 5.45908 11.9941C5.45757 11.9961 5.45609 11.9981 5.45464 12C5.45609 12.0019 5.45757 12.0039 5.45908 12.0059C5.57549 12.1584 5.76785 12.3538 6.12117 12.7071L7.70696 14.2929C8.09748 14.6834 8.09748 15.3166 7.70696 15.7071C7.31643 16.0976 6.68327 16.0976 6.29274 15.7071L4.70696 14.1213C4.69412 14.1085 4.68129 14.0957 4.66847 14.0828C4.36855 13.783 4.07708 13.4917 3.86904 13.219C3.63451 12.9116 3.41406 12.5137 3.41406 12C3.41406 11.4863 3.63451 11.0884 3.86904 10.781C4.07708 10.5083 4.36855 10.217 4.66847 9.91715C4.68129 9.90434 4.69412 9.89152 4.70696 9.87868L6.29274 8.29289C6.68327 7.90237 7.31643 7.90237 7.70695 8.29289ZM16.2927 8.29289C16.6833 7.90237 17.3164 7.90237 17.707 8.29289L19.2927 9.87868C19.3056 9.89152 19.3184 9.90434 19.3312 9.91715C19.6311 10.217 19.9226 10.5083 20.1307 10.781C20.3652 11.0884 20.5856 11.4863 20.5856 12C20.5856 12.5137 20.3652 12.9116 20.1307 13.219C19.9226 13.4917 19.6311 13.7831 19.3312 14.0829C19.3184 14.0957 19.3056 14.1085 19.2927 14.1213L17.707 15.7071C17.3164 16.0976 16.6833 16.0976 16.2927 15.7071C15.9022 15.3166 15.9022 14.6834 16.2927 14.2929L17.8785 12.7071C18.2319 12.3538 18.4242 12.1584 18.5406 12.0059C18.5421 12.0039 18.5436 12.0019 18.5451 12C18.5436 11.9981 18.5421 11.9961 18.5406 11.9941C18.4242 11.8416 18.2319 11.6462 17.8785 11.2929L16.2927 9.70711C15.9022 9.31658 15.9022 8.68342 16.2927 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-split": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","arrows","direction","left","right","separate","transfer","move","divide","split-order","split-payment","transfer-payment","transfer-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L5.41421 13.4142C4.74755 12.7475 4.41421 12.4142 4.41421 12C4.41421 11.5858 4.74755 11.2525 5.41421 10.5858L7 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-to-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","up-down","arrows","order","ranking","high-low","filter","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10L12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-to-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrow","up","down","order","rank","adjust","arrange","organize","high-low"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 5.41431L9.70711 6.7072C9.31658 7.09772 8.68342 7.09773 8.29289 6.7072C7.90237 6.31668 7.90237 5.68351 8.29289 5.29299L9.87868 3.7072C9.89152 3.69436 9.90434 3.68153 9.91715 3.66872C10.217 3.3688 10.5083 3.07733 10.781 2.86929C11.0884 2.63475 11.4863 2.41431 12 2.41431C12.5137 2.41431 12.9116 2.63475 13.219 2.86928C13.4917 3.07733 13.7831 3.36881 14.0829 3.66873C14.0957 3.68154 14.1085 3.69436 14.1213 3.7072L15.7071 5.29299C16.0976 5.68351 16.0976 6.31668 15.7071 6.7072C15.3166 7.09772 14.6834 7.09772 14.2929 6.7072L13 5.41431V9.00009C13 9.55238 12.5523 10.0001 12 10.0001C11.4477 10.0001 11 9.55238 11 9.00009V5.41431ZM20 12.0001C20 12.5524 19.5523 13.0001 19 13.0001L5 13.0001C4.44772 13.0001 4 12.5524 4 12.0001C4 11.4478 4.44772 11.0001 5 11.0001L19 11.0001C19.5523 11.0001 20 11.4478 20 12.0001ZM12 14.0001C12.5523 14.0001 13 14.4478 13 15.0001V18.5859L14.2929 17.293C14.6834 16.9025 15.3166 16.9025 15.7071 17.293C16.0976 17.6835 16.0976 18.3167 15.7071 18.7072L14.1213 20.293C14.1085 20.3058 14.0957 20.3186 14.0829 20.3315C13.7831 20.6314 13.4917 20.9229 13.219 21.1309C12.9116 21.3654 12.5137 21.5859 12 21.5859C11.4863 21.5859 11.0884 21.3654 10.781 21.1309C10.5083 20.9229 10.2169 20.6314 9.91714 20.3315C9.90433 20.3186 9.89151 20.3058 9.87868 20.293L8.29289 18.7072C7.90237 18.3167 7.90237 17.6835 8.29289 17.293C8.68342 16.9025 9.31658 16.9025 9.70711 17.293L11 18.5859L11 15.0001C11 14.4478 11.4477 14.0001 12 14.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-to-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrows","sort","filter","vertical","resize","expand","collapse","options","settings","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10L12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-to-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrows","up-down","reorder","adjust","change order","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10L12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["collapse","minimize","reduce","decrease","shrink","hide","compress","close","fold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L3 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L9.29289 12.7071C9.68342 12.3166 9.68342 11.6834 9.29289 11.2929L7 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L21 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L11.2929 9.29289C11.6834 9.68342 12.3166 9.68342 12.7071 9.29289L15 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["collapse","arrows","reduce","minimize","shrink","consolidate","compact","gather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L3 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L9.29289 12.7071C9.68342 12.3166 9.68342 11.6834 9.29289 11.2929L7 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L21 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L11.2929 9.29289C11.6834 9.68342 12.3166 9.68342 12.7071 9.29289L15 7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","up","upload","import","sort","increase","raise","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7L19 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L15.2929 9.70711C15.6834 9.31658 16.3166 9.31658 16.7071 9.70711L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L7.29289 9.70711C7.68342 9.31658 8.31658 9.31658 8.70711 9.70711L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","shrink","compress","reduce","compact","hide","collapse","group","merge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1C12.5523 1 13 1.44772 13 2L13 6.58579L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L13.4142 9C12.6332 9.78105 11.3668 9.78105 10.5858 9L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L11 6.58579L11 2C11 1.44772 11.4477 1 12 1ZM5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L9 10.5858C9.78105 11.3668 9.78105 12.6332 9 13.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L6.58579 13L2 13C1.44772 13 1 12.5523 1 12C1 11.4477 1.44771 11 2 11L6.58579 11L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289ZM17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L17.4142 11L22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13L17.4142 13L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L15 13.4142C14.219 12.6332 14.219 11.3668 15 10.5858L17.2929 8.29289ZM10.5858 15C11.3668 14.219 12.6332 14.2189 13.4142 15L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L13 17.4142L13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22L11 17.4142L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L10.5858 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "arrows-up-to-line-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["up","arrows","move-up","sort","arrange","bring-to-front","raise","increase","ascend","elevate","promote","increase-quantity","restock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7L19 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L15.2929 9.70711C15.6834 9.31658 16.3166 9.31658 16.7071 9.70711L19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L7.29289 9.70711C7.68342 9.31658 8.31658 9.31658 8.70711 9.70711L11 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","upload","arrange","bring-to-front","order","arrows","move-up","increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7L19 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L15.2929 9.70711C15.6834 9.31658 16.3166 9.31658 16.7071 9.70711L19 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L7.29289 9.70711C7.68342 9.31658 8.31658 9.31658 8.70711 9.70711L11 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","upload","increase","quantity","inventory","restock","add-stock","raise","adjustment","up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 7.5L4 7.5C3.44772 7.5 3 7.05229 3 6.5C3 5.94772 3.44772 5.5 4 5.5L20 5.5C20.5523 5.5 21 5.94772 21 6.5C21 7.05228 20.5523 7.5 20 7.5ZM5.58579 9.5C6.36683 8.71895 7.63316 8.71895 8.41421 9.5L10.7071 11.7929C11.0976 12.1834 11.0976 12.8166 10.7071 13.2071C10.3166 13.5976 9.68342 13.5976 9.29289 13.2071L8 11.9142L8 17.5C8 18.0523 7.55229 18.5 7 18.5C6.44772 18.5 6 18.0523 6 17.5L6 11.9142L4.70711 13.2071C4.31658 13.5976 3.68342 13.5976 3.29289 13.2071C2.90237 12.8166 2.90237 12.1834 3.29289 11.7929L5.58579 9.5ZM15.5858 9.5C16.3668 8.71895 17.6332 8.71895 18.4142 9.5L20.7071 11.7929C21.0976 12.1834 21.0976 12.8166 20.7071 13.2071C20.3166 13.5976 19.6834 13.5976 19.2929 13.2071L18 11.9142L18 17.5C18 18.0523 17.5523 18.5 17 18.5C16.4477 18.5 16 18.0523 16 17.5L16 11.9142L14.7071 13.2071C14.3166 13.5976 13.6834 13.5976 13.2929 13.2071C12.9024 12.8166 12.9024 12.1834 13.2929 11.7929L15.5858 9.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "artboard-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hashtag","number","tag","category","discount","loyalty","promotion","special-offer","price-group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "artboard-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hashtag","number","sort","filter","grid","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8H19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "arrows-up-to-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","converge","consolidate","focus","compress","reduce","zoom-in","minimize","compact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L3 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15L9.29289 12.7071C9.68342 12.3166 9.68342 11.6834 9.29289 11.2929L7 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L21 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L11.2929 9.29289C11.6834 9.68342 12.3166 9.68342 12.7071 9.29289L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "artboard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","hashtag","number","category","filter","tag","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 20C7.44772 20 7 19.5523 7 19V17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H7L7 9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H7V5C7 4.44771 7.44771 4 8 4C8.55228 4 9 4.44771 9 5V7H15V5C15 4.44771 15.4477 4 16 4C16.5523 4 17 4.44771 17 5V7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H17L17 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H17V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V17H9V19C9 19.5523 8.55228 20 8 20ZM15 15L15 9H9L9 15H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    artboard: {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","hashtag","number","category","filter","tag","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "artificial-intelligence-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ai","artificial intelligence","automation","smart","recommendation","algorithm","intelligence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "artificial-intelligence-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ai","artificial intelligence","automation","smart","recommendation","analysis","insights","machine learning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1136 3H9.88642H9.8864C8.47974 2.99998 7.34593 2.99996 6.4542 3.11985C5.52837 3.24433 4.74885 3.51062 4.12973 4.12973C3.51062 4.74885 3.24433 5.52837 3.11985 6.4542C2.99996 7.34593 2.99998 8.47974 3 9.8864V9.88642V14.1136V14.1136C2.99998 15.5203 2.99996 16.6541 3.11985 17.5458C3.24433 18.4716 3.51062 19.2512 4.12973 19.8703C4.74885 20.4894 5.52838 20.7557 6.4542 20.8801C7.34594 21 8.47976 21 9.88642 21H14.1136C15.5202 21 16.6541 21 17.5458 20.8801C18.4716 20.7557 19.2512 20.4894 19.8703 19.8703C20.4894 19.2512 20.7557 18.4716 20.8801 17.5458C21 16.6541 21 15.5202 21 14.1136V9.88642C21 8.47976 21 7.34594 20.8801 6.4542C20.7557 5.52838 20.4894 4.74885 19.8703 4.12973C19.2512 3.51062 18.4716 3.24433 17.5458 3.11985C16.6541 2.99996 15.5203 2.99998 14.1136 3H14.1136ZM11.671 9.66459C11.5439 9.4105 11.2842 9.25 11.0002 9.25C10.7161 9.25 10.4564 9.4105 10.3293 9.66459L8.32934 13.6646C8.1441 14.0351 8.29427 14.4856 8.66475 14.6708C9.03524 14.8561 9.48574 14.7059 9.67099 14.3354L9.96412 13.7492C9.97606 13.7497 9.98808 13.75 10.0002 13.75H12.0002C12.0122 13.75 12.0243 13.7497 12.0362 13.7492L12.3293 14.3354C12.5146 14.7059 12.9651 14.8561 13.3356 14.6708C13.7061 14.4856 13.8562 14.0351 13.671 13.6646L11.671 9.66459ZM11.0002 11.6771L11.2866 12.25H10.7137L11.0002 11.6771ZM15.7502 10C15.7502 9.58579 15.4144 9.25 15.0002 9.25C14.586 9.25 14.2502 9.58579 14.2502 10V14C14.2502 14.4142 14.586 14.75 15.0002 14.75C15.4144 14.75 15.7502 14.4142 15.7502 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "artificial-intelligence-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ai","artificial intelligence","automation","smart","intelligence","machine learning","recommendation","suggestion","predictive","data analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "artificial-intelligence": {
        defaultColors: ["#3D4C66"],
        keywords: ["ai","artificial intelligence","recommendation","suggestions","smart","analysis","automation","predictions","data","insights","reports","intelligence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 14L11 10L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14H14.25ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10H15.75ZM15.75 14V10H14.25V14H15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75V12.25ZM12 12.25H10V13.75H12V12.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "asterisk-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["asterisk","note","special","important","discount","promotion","warning","annotation","footnote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L16 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L16 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    asterisk: {
        defaultColors: ["#3D4C66"],
        keywords: ["asterisk","note","special","important","discount","promotion","warning","annotation","footnote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "asterisk-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["asterisk","note","special","discount","promotion","important","warning","details","additional-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L16 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L16 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "asterisk-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["asterisk","star","note","special","details","discount","sale","promotion","important","annotation","modifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V9.58579L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L9.58579 11H6C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H9.58579L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L11 14.4142V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V14.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L14.4142 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H14.4142L16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L13 9.58579V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "astermark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["asterisk","snowflake","cold","freezer","temperature","settings","options","multiplier","special"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "astermark-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["asterisk","annotation","important","note","special","promotion","discount","highlight","sales","markup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "astermark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["asterisk","note","special-note","discount","promotion","important","options","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 7C12.5523 7 13 7.44772 13 8V9.58579L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L14.4142 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H14.4142L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L13 14.4142V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L9.58579 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9.58579L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L11 9.58579V8C11 7.44772 11.4477 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    astermark: {
        defaultColors: ["#3D4C66"],
        keywords: ["asterisk","note","special-note","discount","promotion","important","options","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "atom-isolated-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["atom","molecule","connection","network","structure","core","system","process","interconnected","central"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "atom-isolated-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lightning","fast","energy","power","quick","charge","electricity","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="11.9999"
                    cy="11.9998"
                    rx="4"
                    ry="8"
                    transform="rotate(-45 11.9999 11.9998)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <ellipse
                    cx="12.0007"
                    cy="12.0004"
                    rx="4"
                    ry="8"
                    transform="rotate(45 12.0007 12.0004)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L11 12H13L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "atom-isolated-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["atomic","structure","connection","data","networking","cloud","service","platform","system","integration","api"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.5773 4.28194C13.058 4.42357 12.5292 4.61685 11.9989 4.85853C11.4686 4.61685 10.9398 4.42357 10.4205 4.28194C8.52743 3.76565 6.53726 3.893 5.21513 5.21513C3.893 6.53726 3.76565 8.52743 4.28194 10.4205C4.42357 10.9398 4.61685 11.4686 4.85853 11.9989C4.61685 12.5292 4.42357 13.058 4.28194 13.5773C3.76565 15.4704 3.893 17.4605 5.21513 18.7827C6.53726 20.1048 8.52743 20.2321 10.4205 19.7159C10.9398 19.5742 11.4686 19.3809 11.9989 19.1393C12.5292 19.3809 13.058 19.5742 13.5773 19.7159C15.4704 20.2321 17.4605 20.1048 18.7827 18.7827C20.1048 17.4605 20.2321 15.4704 19.7159 13.5773C19.5742 13.058 19.3809 12.5292 19.1393 11.9989C19.3809 11.4686 19.5742 10.9398 19.7159 10.4205C20.2321 8.52743 20.1048 6.53726 18.7827 5.21513C17.4605 3.893 15.4704 3.76565 13.5773 4.28194ZM6.62934 6.62934C6.05216 7.20653 5.80091 8.26331 6.17383 9.75051C6.65247 9.08488 7.20329 8.43553 7.81941 7.81941C8.43553 7.20329 9.08488 6.65247 9.75051 6.17383C8.26331 5.80091 7.20653 6.05216 6.62934 6.62934ZM17.3685 17.3685C16.7913 17.9456 15.7345 18.1969 14.2473 17.824C14.9129 17.3453 15.5623 16.7945 16.1784 16.1784C16.7945 15.5623 17.3453 14.9129 17.824 14.2473C18.1969 15.7345 17.9456 16.7913 17.3685 17.3685ZM12.4472 9.10555C11.9532 8.85856 11.3526 9.05878 11.1056 9.55276L10.1056 11.5528C9.95058 11.8628 9.96714 12.2309 10.1494 12.5257C10.3316 12.8205 10.6534 13 11 13H11.382L11.1056 13.5528C10.8586 14.0467 11.0588 14.6474 11.5528 14.8944C12.0468 15.1414 12.6474 14.9412 12.8944 14.4472L13.8944 12.4472C14.0494 12.1372 14.0329 11.7691 13.8507 11.4742C13.6684 11.1794 13.3466 11 13 11H12.618L12.8944 10.4472C13.1414 9.95321 12.9412 9.35254 12.4472 9.10555Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "atom-isolated-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","configuration","preferences","system","options","tools","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9999 4.85951C12.5302 4.61782 13.059 4.42454 13.5783 4.28292C15.4713 3.76662 17.4615 3.89398 18.7836 5.21611C20.1058 6.53824 20.2331 8.5284 19.7168 10.4215C19.5752 10.9408 19.3819 11.4696 19.1402 11.9999C19.3819 12.5302 19.5752 13.059 19.7168 13.5783C20.2331 15.4713 20.1058 17.4615 18.7836 18.7836C17.4615 20.1058 15.4713 20.2331 13.5783 19.7168C13.059 19.5752 12.5302 19.3819 11.9999 19.1402C11.4696 19.3819 10.9408 19.5752 10.4215 19.7168C8.5284 20.2331 6.53824 20.1058 5.21611 18.7836C3.89398 17.4615 3.76662 15.4713 4.28292 13.5783C4.42454 13.059 4.61782 12.5302 4.85951 11.9999C4.61782 11.4696 4.42454 10.9408 4.28292 10.4215C3.76662 8.5284 3.89398 6.53824 5.21611 5.21611C6.53824 3.89398 8.5284 3.76662 10.4215 4.28292C10.9408 4.42454 11.4696 4.61782 11.9999 4.85951ZM6.17481 9.75149C5.80189 8.26429 6.05314 7.2075 6.63032 6.63032C7.2075 6.05314 8.26429 5.80189 9.75149 6.17481C9.08586 6.65345 8.43651 7.20427 7.82039 7.82039C7.20427 8.43651 6.65345 9.08586 6.17481 9.75149ZM14.2483 17.8249C15.7355 18.1979 16.7922 17.9466 17.3694 17.3694C17.9466 16.7922 18.1979 15.7355 17.8249 14.2483C17.3463 14.9139 16.7955 15.5632 16.1794 16.1794C15.5632 16.7955 14.9139 17.3463 14.2483 17.8249ZM9.5 11.9998C9.5 10.619 10.6193 9.49976 12 9.49976C13.3807 9.49976 14.5 10.619 14.5 11.9998C14.5 13.3805 13.3807 14.4998 12 14.4998C10.6193 14.4998 9.5 13.3805 9.5 11.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "atom-isolated-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["atom","isolated","connection","network","system","relation","complex","integrated","interaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "atom-isolated-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["atom","isolated","scientific","settings","configuration","customization","options","system","core","nucleus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "atom-isolated-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["atom","orbital","orbit","science","configuration","system","settings","options","integration","connectivity","module","technology","platform","core"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "atom-isolated-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["settings","options","configuration","preferences","system","properties","advanced","details","control","atom"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "atom-isolated-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["atom","molecule","structure","settings","configuration","options","system","core"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9999 4.85951C12.5302 4.61782 13.059 4.42454 13.5783 4.28292C15.4713 3.76662 17.4615 3.89398 18.7836 5.21611C20.1058 6.53824 20.2331 8.5284 19.7168 10.4215C19.5752 10.9408 19.3819 11.4696 19.1402 11.9999C19.3819 12.5302 19.5752 13.059 19.7168 13.5783C20.2331 15.4713 20.1058 17.4615 18.7836 18.7836C17.4615 20.1058 15.4713 20.2331 13.5783 19.7168C13.059 19.5752 12.5302 19.3819 11.9999 19.1402C11.4696 19.3819 10.9408 19.5752 10.4215 19.7168C8.5284 20.2331 6.53824 20.1058 5.21611 18.7836C3.89398 17.4615 3.76662 15.4713 4.28292 13.5783C4.42454 13.059 4.61782 12.5302 4.85951 11.9999C4.61782 11.4696 4.42454 10.9408 4.28292 10.4215C3.76662 8.5284 3.89398 6.53824 5.21611 5.21611C6.53824 3.89398 8.5284 3.76662 10.4215 4.28292C10.9408 4.42454 11.4696 4.61782 11.9999 4.85951ZM6.17481 9.75149C5.80189 8.26429 6.05314 7.2075 6.63032 6.63032C7.2075 6.05314 8.26429 5.80189 9.75149 6.17481C9.08586 6.65345 8.43651 7.20427 7.82039 7.82039C7.20427 8.43651 6.65345 9.08586 6.17481 9.75149ZM14.2483 17.8249C15.7355 18.1979 16.7922 17.9466 17.3694 17.3694C17.9466 16.7922 18.1979 15.7355 17.8249 14.2483C17.3463 14.9139 16.7955 15.5632 16.1794 16.1794C15.5632 16.7955 14.9139 17.3463 14.2483 17.8249ZM9.5 11.9998C9.5 10.619 10.6193 9.49976 12 9.49976C13.3807 9.49976 14.5 10.619 14.5 11.9998C14.5 13.3805 13.3807 14.4998 12 14.4998C10.6193 14.4998 9.5 13.3805 9.5 11.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "atom-isolated-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["atom","energy","power","charge","lightning","bolt","science","technology","electricity","fast","high-voltage","acceleration","nuclear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="11.9999"
                    cy="11.9998"
                    rx="4"
                    ry="8"
                    transform="rotate(-45 11.9999 11.9998)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <ellipse
                    cx="12.0007"
                    cy="12.0004"
                    rx="4"
                    ry="8"
                    transform="rotate(45 12.0007 12.0004)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L11 12H13L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "atom-isolated-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["energy","electricity","bolt","atom","science","power","fast","charge","zap","electricity-bill","energy-consumption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="11.9999"
                    cy="11.9998"
                    rx="4"
                    ry="8"
                    transform="rotate(-45 11.9999 11.9998)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <ellipse
                    cx="12.0007"
                    cy="12.0004"
                    rx="4"
                    ry="8"
                    transform="rotate(45 12.0007 12.0004)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L11 12H13L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "atom-isolated": {
        defaultColors: ["#3D4C66"],
        keywords: ["atom","isolated","settings","configuration","options","system","preferences","advanced","process","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0767 5.92334C19.9944 7.84108 18.8284 12.1163 15.4724 15.4724C12.1163 18.8284 7.84108 19.9944 5.92334 18.0767C4.0056 16.1589 5.17157 11.8837 8.52762 8.52762C11.8837 5.17157 16.1589 4.0056 18.0767 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.92334 5.92334C4.0056 7.84108 5.17157 12.1163 8.52762 15.4724C11.8837 18.8284 16.1589 19.9944 18.0767 18.0767C19.9944 16.1589 18.8284 11.8837 15.4724 8.52762C12.1163 5.17157 7.84108 4.0056 5.92334 5.92334Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Attachment-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["attachment","paperclip","link","add-attachment","attach-file","add-file","notes","memo","receipt","documentation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15.5556V10C10 8.89543 10.8954 8 12 8V8C13.1046 8 14 8.89543 14 10V16C14 18.2091 12.2091 20 10 20V20C7.79086 20 6 18.2091 6 16V10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V15.5556"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Attachment-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","link","file","paperclip","document","attach-file","attach-document"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C9.23858 5 7 7.23858 7 10V16C7 17.6569 8.34315 19 10 19C11.6569 19 13 17.6569 13 16V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V15.5556C11 16.1078 10.5523 16.5556 10 16.5556C9.44772 16.5556 9 16.1078 9 15.5556V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V16C15 18.7614 12.7614 21 10 21C7.23858 21 5 18.7614 5 16V10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V15.5556C19 16.1078 18.5523 16.5556 18 16.5556C17.4477 16.5556 17 16.1078 17 15.5556V10C17 7.23858 14.7614 5 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Attachment: {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","link","file","paperclip","document","attach-file","attach-document"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15.5556V10C10 8.89543 10.8954 8 12 8V8C13.1046 8 14 8.89543 14 10V16C14 18.2091 12.2091 20 10 20V20C7.79086 20 6 18.2091 6 16V10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V15.5556"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Attachment-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","paperclip","link","connect","attach-document","add-file","order-attachment","transaction-attachment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15.5556V10C10 8.89543 10.8954 8 12 8V8C13.1046 8 14 8.89543 14 10V16C14 18.2091 12.2091 20 10 20V20C7.79086 20 6 18.2091 6 16V10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V15.5556"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "austral-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["almost-equal","approximately-equal","similar","equivalence","calculation","estimation","equal","match","comparison"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L12 5L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12H12L18 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15H12L18 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "austral-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["austral","sign","currency","amount","payment","finance","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L12 5L18 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12H12L18 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15H12L18 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "austral-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","austral","payment","austral-sign","price","transaction","international","financial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19L12 5L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12H12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15H12L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "austral-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["austral","austral-sign","currency","price","payment","money","symbol"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0003 4C12.4003 4 12.7618 4.2384 12.9194 4.60608L15.4454 10.5H18.0003C18.5525 10.5 19.0003 10.9477 19.0003 11.5C19.0003 12.0523 18.5525 12.5 18.0003 12.5H16.3025L16.9454 14H18.0003C18.5525 14 19.0003 14.4477 19.0003 15C19.0003 15.5523 18.5525 16 18.0003 16H17.8025L18.9194 18.6061C19.137 19.1137 18.9018 19.7016 18.3942 19.9191C17.8865 20.1367 17.2987 19.9015 17.0811 19.3939L15.6266 16H8.37394L6.9194 19.3939C6.70185 19.9015 6.11397 20.1367 5.60634 19.9191C5.09871 19.7016 4.86356 19.1137 5.08111 18.6061L6.198 16H6.00026C5.44797 16 5.00026 15.5523 5.00026 15C5.00026 14.4477 5.44797 14 6.00026 14H7.05515L7.698 12.5H6.00026C5.44797 12.5 5.00026 12.0523 5.00026 11.5C5.00026 10.9477 5.44797 10.5 6.00026 10.5H8.55515L11.0811 4.60608C11.2387 4.2384 11.6002 4 12.0003 4ZM9.87394 12.5L9.23108 14H14.7694L14.1266 12.5H9.87394ZM13.2694 10.5H10.7311L12.0003 7.53859L13.2694 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "B-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["B","letter","block","section","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12M8 12H12.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "B-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["b","letter-b","batch","barcode","bill","bonus","bulk","backorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12M8 12H12.5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "B-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["B","initial","brand","business","barcode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 4.00001C9.96372 4.00001 9.98186 4.00001 10 4.00001H12.5C14.9853 4.00001 17 6.01473 17 8.50001C17 9.91365 16.3482 11.175 15.3287 12C16.3482 12.825 17 14.0864 17 15.5C17 17.9853 14.9853 20 12.5 20H10C9.98186 20 9.96372 20 9.9456 20C9.52153 20.0001 9.10941 20.0002 8.76949 19.9545C8.38629 19.903 7.94902 19.7774 7.5858 19.4142C7.22259 19.051 7.09706 18.6137 7.04554 18.2305C6.99984 17.8906 6.99992 17.4785 7.00001 17.0544C7.00001 17.0363 7.00001 17.0182 7.00001 17V7.00001C7.00001 6.98186 7.00001 6.96372 7.00001 6.94561C6.99992 6.52154 6.99984 6.10941 7.04554 5.76949C7.09706 5.38629 7.22259 4.94902 7.5858 4.5858C7.94902 4.22259 8.38629 4.09706 8.76949 4.04554C9.10941 3.99984 9.52154 3.99992 9.94561 4.00001ZM12.5 11C13.8807 11 15 9.88073 15 8.50001C15 7.1193 13.8807 6.00001 12.5 6.00001H10C9.50034 6.00001 9.22618 6.00214 9.03599 6.02771C9.03351 6.02804 9.03108 6.02837 9.02871 6.02871C9.02838 6.03108 9.02804 6.03351 9.02771 6.03599C9.00214 6.22618 9.00001 6.50034 9.00001 7.00001V11H12.5ZM9.00001 13H12.5C13.8807 13 15 14.1193 15 15.5C15 16.8807 13.8807 18 12.5 18H10C9.50034 18 9.22618 17.9979 9.03599 17.9723C9.03351 17.972 9.03108 17.9717 9.02871 17.9713C9.02837 17.9689 9.02804 17.9665 9.02771 17.964C9.00214 17.7738 9.00001 17.4997 9.00001 17V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    B: {
        defaultColors: ["#3D4C66"],
        keywords: ["B","initial","brand","business","barcode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12M8 12H12.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "backward-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["history","time","back","undo","restore","transaction-history","past","previous","clock","sales-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L12 13L12 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["undo","back","rewind","10","seconds","backward","previous","transaction","rollback","edit","modify","time","history","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10L6 12L4 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="10" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M10 14V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rewind","back","previous","undo","reverse","replay","rollback","navigation","history","circular-arrows","return","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M12 4C16.4183 4 20 7.58172 20 12C20 15.3574 17.9318 18.2317 15 19.4185"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Backward-10sec-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","revert","back","return","cycle","arrow","refresh","reload","reverse","payment-reversal","transaction-reversal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1493 3.47427C11.3316 3.17945 11.6534 3 12 3C16.9706 3 21 7.02944 21 12C21 15.7786 18.6717 19.011 15.3752 20.3454C14.8633 20.5526 14.2803 20.3056 14.0731 19.7937C13.8658 19.2818 14.1129 18.6988 14.6248 18.4915C17.192 17.4524 19 14.9361 19 12C19 8.72933 16.7569 5.98256 13.7251 5.21418L13.8944 5.55279C14.1414 6.04676 13.9412 6.64744 13.4472 6.89443C12.9532 7.14142 12.3526 6.94119 12.1056 6.44721L11.1056 4.44721C10.9506 4.13723 10.9671 3.76909 11.1493 3.47427ZM7.45809 5.33827C7.82356 5.75234 7.78415 6.38427 7.37008 6.74974C5.91519 8.03386 5 9.90943 5 12C5 15.2707 7.24312 18.0174 10.2749 18.7858L10.1056 18.4472C9.85858 17.9532 10.0588 17.3526 10.5528 17.1056C11.0468 16.8586 11.6474 17.0588 11.8944 17.5528L12.8944 19.5528C13.0494 19.8628 13.0329 20.2309 12.8507 20.5257C12.6684 20.8205 12.3466 21 12 21C7.02944 21 3 16.9706 3 12C3 9.3118 4.17983 6.89792 6.04662 5.25026C6.46069 4.8848 7.09262 4.9242 7.45809 5.33827Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-10sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rewind","back","10 seconds","undo","previous","time","replay","transaction history","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10L6 12L4 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="10" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","back","previous","undo","time","10 seconds","transaction history","step back","replay","return","go back","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.25 12C19.25 8.54822 16.4518 5.75 13 5.75C10.3279 5.75 8.04741 7.42691 7.15356 9.78578L7.46967 9.46967C7.76256 9.17678 8.23744 9.17678 8.53033 9.46967C8.82322 9.76256 8.82322 10.2374 8.53033 10.5303L6.53033 12.5303C6.45842 12.6022 6.37555 12.6565 6.28709 12.6931C6.19866 12.7298 6.10169 12.75 6 12.75C5.89831 12.75 5.80134 12.7298 5.71291 12.6931C5.62445 12.6565 5.54158 12.6022 5.46967 12.5303L3.46967 10.5303C3.17678 10.2374 3.17678 9.76256 3.46967 9.46967C3.76256 9.17678 4.23744 9.17678 4.53033 9.46967L5.42329 10.3626C6.17474 6.86878 9.28155 4.25 13 4.25C17.2802 4.25 20.75 7.7198 20.75 12C20.75 16.2802 17.2802 19.75 13 19.75C10.8316 19.75 8.87009 18.8585 7.46432 17.4239C7.17441 17.1281 7.17923 16.6532 7.47507 16.3633C7.77092 16.0734 8.24577 16.0782 8.53568 16.3741C9.67094 17.5326 11.251 18.25 13 18.25C16.4518 18.25 19.25 15.4518 19.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.25 11.5C12.25 10.2574 13.2574 9.25 14.5 9.25C15.7426 9.25 16.75 10.2574 16.75 11.5V12.5C16.75 13.7426 15.7426 14.75 14.5 14.75C13.2574 14.75 12.25 13.7426 12.25 12.5V11.5ZM14.5 10.75C14.0858 10.75 13.75 11.0858 13.75 11.5V12.5C13.75 12.9142 14.0858 13.25 14.5 13.25C14.9142 13.25 15.25 12.9142 15.25 12.5V11.5C15.25 11.0858 14.9142 10.75 14.5 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V14C9.25 14.4142 9.58579 14.75 10 14.75C10.4142 14.75 10.75 14.4142 10.75 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-10sec-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","revert","refresh","reload","cycle","repeat","reverse","back","previous","transaction-history","circular","rotation","rotate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L7 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["replay","loop","repeat","redo","transaction-history","sync","refresh","update","reload","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L7 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["undo","back","previous","rewind","repeat","cycle","arrow","restart","rollback","correction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L7 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-10sec-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","sync","update","repeat","redo","revert","undo","rollback","transaction-history","sales-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.03379 9.74316C4.06936 5.84645 7.70637 3 12.0002 3C16.2941 3 19.9311 5.84645 20.9667 9.74316C21.0611 10.0985 20.953 10.4769 20.6851 10.7287C20.4172 10.9805 20.0328 11.0649 19.684 10.9487L16.684 9.94868C16.1601 9.77404 15.8769 9.20772 16.0516 8.68377C16.2262 8.15983 16.7925 7.87667 17.3165 8.05132L18.1919 8.34313C16.9193 6.3453 14.6308 5 12.0002 5C8.59625 5 5.76508 7.25264 4.9667 10.2568C4.82485 10.7906 4.27716 11.1083 3.74341 10.9665C3.20965 10.8246 2.89194 10.2769 3.03379 9.74316ZM20.2571 13.0335C20.7908 13.1754 21.1085 13.7231 20.9667 14.2568C19.9311 18.1535 16.2941 21 12.0002 21C7.70637 21 4.06936 18.1535 3.03379 14.2568C2.93937 13.9015 3.04751 13.5231 3.3154 13.2713C3.58328 13.0195 3.96771 12.9351 4.31647 13.0513L7.31647 14.0513C7.84042 14.226 8.12358 14.7923 7.94893 15.3162C7.77428 15.8402 7.20796 16.1233 6.68402 15.9487L5.80857 15.6569C7.08116 17.6547 9.36965 19 12.0002 19C15.4042 19 18.2354 16.7474 19.0338 13.7432C19.1756 13.2094 19.7233 12.8917 20.2571 13.0335Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-10sec-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","revert","history","rollback","transaction","refresh","circular","arrows","repeat","reload","reset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M12 4C16.4183 4 20 7.58172 20 12C20 15.3574 17.9318 18.2317 15 19.4185"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Backward-10sec-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["undo","rewind","previous","circular-arrows","replay","go-back","return","cancel","rollback","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L11 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M12 4C16.4183 4 20 7.58172 20 12C20 15.3574 17.9318 18.2317 15 19.4185"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Backward-10sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","back","10","seconds","undo","transaction","rollback","return","time","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10L6 12L4 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="10" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["history","time","clock","undo","redo","previous","past","rollback","transaction-history","order-history","customer-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L12 13L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["history","undo","recent","time","clock","past","transaction-history","order-history","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 8.68629 16.3137 6 13 6C9.68629 6 7 8.68629 7 12C7 12.2751 6.88894 12.5242 6.70922 12.705L6.70498 12.7092C6.6096 12.804 6.49986 12.8757 6.38278 12.9241C6.26575 12.9727 6.1345 12.9996 6 13C5.72612 12.9992 5.47396 12.8871 5.29382 12.708L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L5.28614 9.87193C6.21797 6.48664 9.31859 4 13 4C17.4183 4 21 7.58172 21 12C21 16.4183 17.4183 20 13 20C10.7617 20 8.73661 19.0795 7.28576 17.5989C6.89921 17.2044 6.90564 16.5713 7.3001 16.1847C7.69456 15.7982 8.3277 15.8046 8.71424 16.1991C9.80442 17.3116 11.3209 18 13 18C16.3137 18 19 15.3137 19 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 13C16 13.5523 15.5523 14 15 14H12C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V12H15C15.5523 12 16 12.4477 16 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-30sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rewind","back","previous","undo","30","seconds","30-seconds","time","navigation","replay","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-30sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rewind","30 seconds","undo","replay","back","previous","transaction","refund","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-30sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","30 seconds","undo","previous","transaction","discount","time","navigation","rollback","edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-30sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","30-seconds","rollback","undo","previous-state","timer","time-back","fast-rewind","replay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.362 3.6057C11.4987 3.38459 11.7401 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 9.3865 4.39675 7.03991 6.21205 5.4377C6.5226 5.1636 6.99656 5.19315 7.27066 5.5037C7.54475 5.81425 7.5152 6.28821 7.20465 6.5623C5.69827 7.89186 4.75 9.83473 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 8.42879 16.6679 5.46066 13.2689 4.86066L13.6708 5.66459C13.8561 6.03507 13.7059 6.48558 13.3354 6.67082C12.9649 6.85606 12.5144 6.70589 12.3292 6.33541L11.3292 4.33541C11.2129 4.10292 11.2254 3.82681 11.362 3.6057ZM7.25 10C7.25 9.58579 7.58579 9.25 8 9.25H9C9.9665 9.25 10.75 10.0335 10.75 11V13C10.75 13.9665 9.9665 14.75 9 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H9C9.13807 13.25 9.25 13.1381 9.25 13V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H9.25V11C9.25 10.8619 9.13807 10.75 9 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10ZM11.25 12C11.25 10.4812 12.4812 9.25 14 9.25C15.5188 9.25 16.75 10.4812 16.75 12C16.75 13.5188 15.5188 14.75 14 14.75C12.4812 14.75 11.25 13.5188 11.25 12ZM14 10.75C13.3096 10.75 12.75 11.3096 12.75 12C12.75 12.6904 13.3096 13.25 14 13.25C14.6904 13.25 15.25 12.6904 15.25 12C15.25 11.3096 14.6904 10.75 14 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-60sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["timer","time","rewind","undo","60-seconds","60","circular-arrow","circular-timer","delay","timeout","refund","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-60sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["60 seconds","sixty seconds","undo","reverse","back","time","timeout","discount timer","countdown","deal timer","sales timer","refresh","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.362 3.6057C11.4987 3.38459 11.7401 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 9.3865 4.39675 7.03991 6.21205 5.4377C6.5226 5.1636 6.99656 5.19315 7.27066 5.5037C7.54475 5.81425 7.5152 6.28821 7.20465 6.5623C5.69827 7.89186 4.75 9.83473 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 8.42879 16.6679 5.46066 13.2689 4.86066L13.6708 5.66459C13.8561 6.03507 13.7059 6.48558 13.3354 6.67082C12.9649 6.85606 12.5144 6.70589 12.3292 6.33541L11.3292 4.33541C11.2129 4.10292 11.2254 3.82681 11.362 3.6057Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.25 11.5C12.25 10.2574 13.2574 9.25 14.5 9.25C15.7426 9.25 16.75 10.2574 16.75 11.5V12.5C16.75 13.7426 15.7426 14.75 14.5 14.75C13.2574 14.75 12.25 13.7426 12.25 12.5V11.5ZM14.5 13.25C14.9142 13.25 15.25 12.9142 15.25 12.5V11.5C15.25 11.0858 14.9142 10.75 14.5 10.75C14.0858 10.75 13.75 11.0858 13.75 11.5V12.5C13.75 12.9142 14.0858 13.25 14.5 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 14.75C10.9665 14.75 11.75 13.9665 11.75 13C11.75 12.0335 10.9665 11.25 10 11.25H8.75V11C8.75 10.8619 8.86193 10.75 9 10.75H10C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25H9C8.0335 9.25 7.25 10.0335 7.25 11L7.25 13C7.25 13.9665 8.0335 14.75 9 14.75H10ZM8.75 12.75H10C10.1381 12.75 10.25 12.8619 10.25 13C10.25 13.1381 10.1381 13.25 10 13.25H9C8.86193 13.25 8.75 13.1381 8.75 13V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Backward-60sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rewind","60 seconds","time","undo","transaction history","customer history","payment history","previous order","return","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Backward-60sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["60 seconds","time","delay","wait","undo","rewind","rollback","timeout","postpone","delay-payment","time-window"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-fast-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rewind","back","previous","history","return","undo","backward","fast-backward","transaction-history","order-history","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.49444 16.1066C8.96946 15.9695 8.32973 15.3297 7.05025 14.0503C6.45796 13.458 6.16181 13.1618 6.01231 12.8377C5.76713 12.3061 5.76713 11.6939 6.01231 11.1623C6.16181 10.8382 6.45796 10.542 7.05025 9.94975L7.05025 9.94975C8.32973 8.67028 8.96946 8.03054 9.49444 7.89338C10.3613 7.66691 11.273 8.04454 11.7258 8.81763C12 9.28583 12 10.1906 12 12C12 13.8094 12 14.7142 11.7258 15.1824C11.273 15.9555 10.3613 16.3331 9.49444 16.1066Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4944 16.1066C15.9695 15.9695 15.3297 15.3297 14.0503 14.0503C13.458 13.458 13.1618 13.1618 13.0123 12.8377C12.7671 12.3061 12.7671 11.6939 13.0123 11.1623C13.1618 10.8382 13.458 10.542 14.0502 9.94975L14.0503 9.94975C15.3297 8.67028 15.9695 8.03054 16.4944 7.89338C17.3613 7.66691 18.273 8.04454 18.7258 8.81763C19 9.28583 19 10.1906 19 12C19 13.8094 19 14.7142 18.7258 15.1824C18.273 15.9555 17.3613 16.3331 16.4944 16.1066Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-fast-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rewind","backward","skip-back","previous","history","undo","replay","back","fast-backward","jump-back","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.49444 16.1066C8.96946 15.9695 8.32973 15.3297 7.05025 14.0503C6.45796 13.458 6.16181 13.1618 6.01231 12.8377C5.76713 12.3061 5.76713 11.6939 6.01231 11.1623C6.16181 10.8382 6.45796 10.542 7.05025 9.94975L7.05025 9.94975C8.32973 8.67028 8.96946 8.03054 9.49444 7.89338C10.3613 7.66691 11.273 8.04454 11.7258 8.81763C12 9.28583 12 10.1906 12 12C12 13.8094 12 14.7142 11.7258 15.1824C11.273 15.9555 10.3613 16.3331 9.49444 16.1066Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8L5 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4944 16.1066C15.9695 15.9695 15.3297 15.3297 14.0503 14.0503C13.458 13.458 13.1618 13.1618 13.0123 12.8377C12.7671 12.3061 12.7671 11.6939 13.0123 11.1623C13.1618 10.8382 13.458 10.542 14.0502 9.94975L14.0503 9.94975C15.3297 8.67028 15.9695 8.03054 16.4944 7.89338C17.3613 7.66691 18.273 8.04454 18.7258 8.81763C19 9.28583 19 10.1906 19 12C19 13.8094 19 14.7142 18.7258 15.1824C18.273 15.9555 17.3613 16.3331 16.4944 16.1066Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-fast-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","previous","back","fast-backward","skip-backward","earlier","undo","reverse","transaction-history","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.463 14.6461C13.2765 14.4619 13.1074 14.2949 12.9605 14.1423C12.9243 14.6349 12.8469 15.1444 12.5973 15.5653C11.9323 16.6864 10.5935 17.234 9.32057 16.9056C8.82558 16.7779 8.39311 16.4539 8.00424 16.1181C7.60205 15.7709 7.11321 15.2882 6.50938 14.6919L6.46306 14.6461C6.29299 14.4782 6.13745 14.3246 6 14.1832L6 16C6 16.5523 5.55229 17 5 17C4.44772 17 4 16.5523 4 16L4 8C4 7.44772 4.44771 7 5 7C5.55229 7 6 7.44772 6 8L6 9.81684C6.13744 9.67539 6.29298 9.5218 6.46305 9.35387L6.50952 9.30798C7.11334 8.71169 7.60205 8.22909 8.00424 7.88186C8.3931 7.54615 8.82558 7.22215 9.32057 7.09444C10.5935 6.76601 11.9323 7.31365 12.5973 8.43475C12.8469 8.85558 12.9243 9.36506 12.9605 9.85769C13.1074 9.70507 13.2765 9.5381 13.463 9.35387L13.5093 9.30823C14.1132 8.71183 14.602 8.22913 15.0042 7.88186C15.3931 7.54614 15.8256 7.22215 16.3206 7.09444C17.5935 6.76601 18.9323 7.31365 19.5973 8.43475C19.8559 8.87069 19.9297 9.40178 19.9642 9.9107C20 10.4371 20 11.1198 20 11.9632V12.0368C20 12.8802 20 13.5629 19.9642 14.0893C19.9297 14.5982 19.8559 15.1293 19.5973 15.5653C18.9323 16.6864 17.5935 17.234 16.3206 16.9056C15.8256 16.7779 15.3931 16.4539 15.0042 16.1181C14.602 15.7709 14.1132 15.2882 13.5093 14.6918L13.463 14.6461Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "backward-fast": {
        defaultColors: ["#3D4C66"],
        keywords: ["rewind","previous","skip-back","step-back","history","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.49444 16.1066C8.96946 15.9695 8.32973 15.3297 7.05025 14.0503C6.45796 13.458 6.16181 13.1618 6.01231 12.8377C5.76713 12.3061 5.76713 11.6939 6.01231 11.1623C6.16181 10.8382 6.45796 10.542 7.05025 9.94975L7.05025 9.94975C8.32973 8.67028 8.96946 8.03054 9.49444 7.89338C10.3613 7.66691 11.273 8.04454 11.7258 8.81763C12 9.28583 12 10.1906 12 12C12 13.8094 12 14.7142 11.7258 15.1824C11.273 15.9555 10.3613 16.3331 9.49444 16.1066Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4944 16.1066C15.9695 15.9695 15.3297 15.3297 14.0503 14.0503C13.458 13.458 13.1618 13.1618 13.0123 12.8377C12.7671 12.3061 12.7671 11.6939 13.0123 11.1623C13.1618 10.8382 13.458 10.542 14.0502 9.94975L14.0503 9.94975C15.3297 8.67028 15.9695 8.03054 16.4944 7.89338C17.3613 7.66691 18.273 8.04454 18.7258 8.81763C19 9.28583 19 10.1906 19 12C19 13.8094 19 14.7142 18.7258 15.1824C18.273 15.9555 17.3613 16.3331 16.4944 16.1066Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["previous","back","rewind","step-back","undo","earlier","return","go-back","navigate-back","backward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 16V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.732 9.60952L11.732 9.60953C10.8006 10.4245 10.335 10.8319 10.159 11.3126C9.99657 11.7565 9.99657 12.2435 10.159 12.6874C10.335 13.1681 10.8006 13.5755 11.732 14.3905C13.3839 15.8359 14.2098 16.5586 14.9091 16.5904C15.5489 16.6195 16.164 16.3404 16.5635 15.8397C17 15.2925 17 14.195 17 12C17 9.80501 17 8.70752 16.5635 8.16029C16.164 7.6596 15.5489 7.38049 14.9091 7.4096C14.2098 7.44142 13.3839 8.16412 11.732 9.60952Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["back","previous","rewind","step-back","undo","history","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.732 9.60952L11.732 9.60953C10.8006 10.4245 10.335 10.8319 10.159 11.3126C9.99657 11.7565 9.99657 12.2435 10.159 12.6874C10.335 13.1681 10.8006 13.5755 11.732 14.3905C13.3839 15.8359 14.2098 16.5586 14.9091 16.5904C15.5489 16.6195 16.164 16.3404 16.5635 15.8397C17 15.2925 17 14.195 17 12C17 9.80501 17 8.70752 16.5635 8.16029C16.164 7.6596 15.5489 7.38049 14.9091 7.4096C14.2098 7.44142 13.3839 8.16412 11.732 9.60952Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","backward","previous","rewind","return","undo","step-back","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7.55228 7 8 7.44772 8 8V16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16V8C6 7.44772 6.44772 7 7 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.7902 9.21386L11.851 9.16062C12.5598 8.53937 13.1371 8.03337 13.6158 7.68332C14.085 7.34013 14.6086 7.02975 15.2006 7.00278C16.0572 6.96374 16.8807 7.33804 17.4155 8.00952C17.785 8.4735 17.8966 9.0726 17.9478 9.65234C18 10.2437 18 11.0121 18 11.9555V12.0445C18 12.9879 18 13.7563 17.9478 14.3477C17.8966 14.9274 17.785 15.5265 17.4155 15.9905C16.8807 16.662 16.0572 17.0363 15.2006 16.9972C14.6086 16.9702 14.085 16.6599 13.6157 16.3167C13.1371 15.9666 12.5598 15.4606 11.851 14.8394L11.7902 14.7861C11.3979 14.4423 11.0622 14.1481 10.8085 13.885C10.5429 13.6096 10.3032 13.3054 10.1631 12.9219C9.94563 12.3266 9.94563 11.6734 10.1631 11.0781C10.3032 10.6946 10.5429 10.3904 10.8085 10.115C11.0622 9.85189 11.3979 9.55771 11.7902 9.21386Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "backward-step-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["previous","back","rewind","step-back","navigation","go-back","return","last-page","previous-page","undo","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16.5V7.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.732 9.60952L10.732 9.60953C9.80062 10.4245 9.33495 10.8319 9.15902 11.3126C8.99657 11.7565 8.99657 12.2435 9.15902 12.6874C9.33495 13.1681 9.80062 13.5755 10.732 14.3905C12.3839 15.8359 13.2098 16.5586 13.9091 16.5904C14.5489 16.6195 15.164 16.3404 15.5635 15.8397C16 15.2925 16 14.195 16 12C16 9.80501 16 8.70752 15.5635 8.16029C15.164 7.6596 14.5489 7.38049 13.9091 7.4096C13.2098 7.44142 12.3839 8.16412 10.732 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["back","step-back","previous","rewind","undo","transaction-history","go-back","restart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16.5V7.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.732 9.60952L10.732 9.60953C9.80062 10.4245 9.33495 10.8319 9.15902 11.3126C8.99657 11.7565 8.99657 12.2435 9.15902 12.6874C9.33495 13.1681 9.80062 13.5755 10.732 14.3905C12.3839 15.8359 13.2098 16.5586 13.9091 16.5904C14.5489 16.6195 15.164 16.3404 15.5635 15.8397C16 15.2925 16 14.195 16 12C16 9.80501 16 8.70752 15.5635 8.16029C15.164 7.6596 14.5489 7.38049 13.9091 7.4096C13.2098 7.44142 12.3839 8.16412 10.732 9.60952Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["back","backward","previous","rewind","step-back","history","undo","go-back","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16.5V7.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.732 9.60952L10.732 9.60953C9.80062 10.4245 9.33495 10.8319 9.15902 11.3126C8.99657 11.7565 8.99657 12.2435 9.15902 12.6874C9.33495 13.1681 9.80062 13.5755 10.732 14.3905C12.3839 15.8359 13.2098 16.5586 13.9091 16.5904C14.5489 16.6195 15.164 16.3404 15.5635 15.8397C16 15.2925 16 14.195 16 12C16 9.80501 16 8.70752 15.5635 8.16029C15.164 7.6596 14.5489 7.38049 13.9091 7.4096C13.2098 7.44142 12.3839 8.16412 10.732 9.60952Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "backward-step-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","undo","return","step-back","navigation","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17.4952C8.55 17.4952 9 17.0454 9 16.4956L9 14.2866C9.28 14.5865 9.63 14.9063 10.05 15.2961C10.9 16.0858 11.64 16.7655 12.2 17.1953C12.75 17.6152 13.32 17.965 13.94 17.995C14.88 18.035 15.78 17.6052 16.36 16.8355C16.75 16.3157 16.88 15.636 16.94 14.9163C17 14.1866 17 13.227 17 12.0375V11.9476C17 10.7481 17 9.7985 16.94 9.06881C16.88 8.34912 16.75 7.66941 16.36 7.15963C15.78 6.38995 14.88 5.96014 13.94 6.00012C13.32 6.03011 12.75 6.37996 12.2 6.79978C11.64 7.2296 10.96 7.85933 10.11 8.64899L10.05 8.69897C9.63 9.0888 9.28 9.40866 9 9.70854L9 7.49948C9 6.94972 8.55 6.49991 8 6.49991C7.45 6.49991 7 6.94972 7 7.49948L7 16.4956C7 17.0454 7.45 17.4952 8 17.4952Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "backward-step": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","step-back","rewind","undo","return","history","arrow-left","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.732 9.60952L11.732 9.60953C10.8006 10.4245 10.335 10.8319 10.159 11.3126C9.99657 11.7565 9.99657 12.2435 10.159 12.6874C10.335 13.1681 10.8006 13.5755 11.732 14.3905C13.3839 15.8359 14.2098 16.5586 14.9091 16.5904C15.5489 16.6195 16.164 16.3404 16.5635 15.8397C17 15.2925 17 14.195 17 12C17 9.80501 17 8.70752 16.5635 8.16029C16.164 7.6596 15.5489 7.38049 14.9091 7.4096C14.2098 7.44142 13.3839 8.16412 11.732 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    backward: {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","step-back","rewind","undo","return","history","arrow-left","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.13401 9.13401 5 13 5C16.866 5 20 8.13401 20 12C20 15.866 16.866 19 13 19C11.0413 19 9.27052 18.1955 8 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L12 13L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-discount-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["discount","percentage","sale","promotion","offer","coupon","price-off","reduction","special-offer","markdown","retail","badge","discount-badge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.0744 13.9516C3.64187 13.0148 3.64187 10.9849 5.0744 10.0481C5.57703 9.71946 5.84583 9.07044 5.72283 8.48262C5.37226 6.80727 6.80761 5.37192 8.48296 5.72248C9.07059 5.84544 9.71969 5.57687 10.0483 5.0744C10.985 3.64187 13.0149 3.64187 13.9517 5.0744C14.2803 5.5769 14.9293 5.84553 15.517 5.72257C17.1923 5.372 18.6277 6.80735 18.2771 8.4827C18.1541 9.07049 18.423 9.71948 18.9256 10.0481C20.3581 10.9849 20.3581 13.0148 18.9256 13.9516C18.4231 14.2802 18.1543 14.929 18.2772 15.5168C18.6278 17.1921 17.1924 18.6275 15.5171 18.2769C14.9294 18.1539 14.2803 18.423 13.9517 18.9256C13.0149 20.3581 10.985 20.3581 10.0483 18.9256C9.71961 18.423 9.0706 18.154 8.48283 18.277C6.80748 18.6275 5.37213 17.1922 5.7227 15.5168C5.84568 14.9291 5.57695 14.2802 5.0744 13.9516Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "badge-discount-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["discount","percentage","sale","promotion","offer","price-cut","reduced-price","markdown","rebate","coupon","special-offer","deal","savings","price-off","price-reduction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "badge-discount-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["discount","sale","percentage","promotion","offer","price-cut","reduced-price","markdown","rebate","special","deal","savings","coupon","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-discount-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","offer","promotion","price-off","reduced-price","special-offer","coupon","deals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.55 13.2501L19.8296 12.0001L20.5496 10.7501C20.9396 10.0701 20.7097 9.20014 20.0297 8.81014L18.7797 8.09014V6.64014C18.7797 5.86014 18.1396 5.22014 17.3596 5.22014H15.9097L15.1897 3.97014C14.9997 3.64014 14.6896 3.41014 14.3296 3.31014C13.9696 3.21014 13.5797 3.26014 13.2497 3.45014L11.9997 4.17014L10.7497 3.45014C10.0697 3.06014 9.19965 3.29014 8.80965 3.97014L8.08965 5.22014H6.63964C5.85964 5.22014 5.21966 5.86014 5.21966 6.64014V8.09014L3.95965 8.81014C3.27965 9.20014 3.04966 10.0701 3.43966 10.7501L4.15966 12.0001L3.43966 13.2501C3.04966 13.9301 3.27965 14.8001 3.95965 15.1901L5.20965 15.9101V17.3601C5.20965 18.1401 5.84966 18.7801 6.62966 18.7801H8.07964L8.79964 20.0301C8.98964 20.3601 9.29966 20.5901 9.65966 20.6901C10.0297 20.7901 10.4096 20.7401 10.7396 20.5501L11.9896 19.8301L13.2396 20.5501C13.4596 20.6801 13.6996 20.7401 13.9496 20.7401C14.0696 20.7401 14.1996 20.7201 14.3196 20.6901C14.6896 20.5901 14.9896 20.3601 15.1796 20.0301L15.8997 18.7801H17.3496C18.1296 18.7801 18.7696 18.1401 18.7696 17.3601V15.9101L20.0196 15.1901C20.6996 14.8001 20.94 13.9301 20.55 13.2501ZM8.68966 9.25014C9.09966 8.53014 10.0196 8.29014 10.7396 8.70014C11.4596 9.11014 11.6996 10.0301 11.2896 10.7501C10.8796 11.4701 9.95965 11.7101 9.23965 11.3001C8.51965 10.8901 8.27966 9.97014 8.68966 9.25014ZM10.5196 14.5301C10.2296 14.8201 9.74965 14.8201 9.45965 14.5301C9.16965 14.2401 9.16965 13.7601 9.45965 13.4701L13.4596 9.47014C13.7496 9.18014 14.2296 9.18014 14.5196 9.47014C14.8096 9.76014 14.8096 10.2401 14.5196 10.5301L10.5196 14.5301ZM15.2896 14.7501C14.8796 15.4701 13.9596 15.7101 13.2396 15.3001C12.5196 14.8901 12.2797 13.9701 12.6897 13.2501C13.0997 12.5301 14.0196 12.2901 14.7396 12.7001C15.4596 13.1101 15.6996 14.0301 15.2896 14.7501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-discount-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","price-cut","offer","reduced-price","special-offer","rebate","voucher","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "badge-discount-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","offer","coupon","price-reduction","special-offer","deal","markdown","price-cut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.0744 13.9516C3.64187 13.0148 3.64187 10.9849 5.0744 10.0481C5.57703 9.71946 5.84583 9.07044 5.72283 8.48262C5.37226 6.80727 6.80761 5.37192 8.48296 5.72248C9.07059 5.84544 9.71969 5.57687 10.0483 5.0744C10.985 3.64187 13.0149 3.64187 13.9517 5.0744C14.2803 5.5769 14.9293 5.84553 15.517 5.72257C17.1923 5.372 18.6277 6.80735 18.2771 8.4827C18.1541 9.07049 18.423 9.71948 18.9256 10.0481C20.3581 10.9849 20.3581 13.0148 18.9256 13.9516C18.4231 14.2802 18.1543 14.929 18.2772 15.5168C18.6278 17.1921 17.1924 18.6275 15.5171 18.2769C14.9294 18.1539 14.2803 18.423 13.9517 18.9256C13.0149 20.3581 10.985 20.3581 10.0483 18.9256C9.71961 18.423 9.0706 18.154 8.48283 18.277C6.80748 18.6275 5.37213 17.1922 5.7227 15.5168C5.84568 14.9291 5.57695 14.2802 5.0744 13.9516Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-discount-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","offer","coupon","price-reduction","special-offer","discount-code","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3275 9.4175C19.0875 9.2575 18.9375 8.9175 19.0075 8.6375C19.4675 6.4375 17.5675 4.5275 15.3575 4.9875C15.0675 5.0475 14.7375 4.9075 14.5775 4.6675C13.3475 2.7775 10.6475 2.7775 9.4175 4.6675C9.2575 4.9075 8.9175 5.0475 8.6375 4.9875C6.4375 4.5275 4.52751 6.4275 4.98751 8.6375C5.04751 8.9275 4.9075 9.2575 4.6675 9.4175C2.7775 10.6475 2.7775 13.3475 4.6675 14.5775C4.9075 14.7375 5.04751 15.0775 4.98751 15.3575C4.52751 17.5575 6.4275 19.4675 8.6375 19.0075C8.9275 18.9475 9.25751 19.0875 9.42751 19.3375C10.6575 21.2275 13.3575 21.2275 14.5875 19.3375C14.7475 19.0975 15.0875 18.9575 15.3675 19.0075C17.5675 19.4675 19.4775 17.5675 19.0175 15.3575C18.9575 15.0675 19.0975 14.7375 19.3375 14.5775C21.2275 13.3475 21.2175 10.6475 19.3275 9.4175ZM8.68752 9.2475C9.09752 8.5275 10.0175 8.2875 10.7375 8.6975C11.4575 9.1075 11.6975 10.0275 11.2875 10.7475C10.8775 11.4675 9.95751 11.7075 9.23751 11.2975C8.51751 10.8875 8.27752 9.9675 8.68752 9.2475ZM10.5175 14.5275C10.2275 14.8175 9.74751 14.8175 9.45751 14.5275C9.16751 14.2375 9.16751 13.7575 9.45751 13.4675L13.4575 9.4675C13.7475 9.1775 14.2275 9.1775 14.5175 9.4675C14.8075 9.7575 14.8075 10.2375 14.5175 10.5275L10.5175 14.5275ZM15.2875 14.7475C14.8775 15.4675 13.9575 15.7075 13.2375 15.2975C12.5175 14.8875 12.2775 13.9675 12.6875 13.2475C13.0975 12.5275 14.0175 12.2875 14.7375 12.6975C15.4575 13.1075 15.6975 14.0275 15.2875 14.7475Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-discount": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","offer","promotion","coupon","price-cut","savings","reward","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.0744 13.9516C3.64187 13.0148 3.64187 10.9849 5.0744 10.0481C5.57703 9.71946 5.84583 9.07044 5.72283 8.48262C5.37226 6.80727 6.80761 5.37192 8.48296 5.72248C9.07059 5.84544 9.71969 5.57687 10.0483 5.0744C10.985 3.64187 13.0149 3.64187 13.9517 5.0744C14.2803 5.5769 14.9293 5.84553 15.517 5.72257C17.1923 5.372 18.6277 6.80735 18.2771 8.4827C18.1541 9.07049 18.423 9.71948 18.9256 10.0481C20.3581 10.9849 20.3581 13.0148 18.9256 13.9516C18.4231 14.2802 18.1543 14.929 18.2772 15.5168C18.6278 17.1921 17.1924 18.6275 15.5171 18.2769C14.9294 18.1539 14.2803 18.423 13.9517 18.9256C13.0149 20.3581 10.985 20.3581 10.0483 18.9256C9.71961 18.423 9.0706 18.154 8.48283 18.277C6.80748 18.6275 5.37213 17.1922 5.7227 15.5168C5.84568 14.9291 5.57695 14.2802 5.0744 13.9516Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "badge-Dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","dollar","transaction","money","payment","bill","sales","invoice","purchase","checkout","amount","due","total","cost","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 20L19 4M5 4L5 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 4L17 5L15.5 4.00031L14 5L12 4L10 5L8.5 4.00031L7 5L5 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "badge-Dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","dollar","payment","transaction","sales","invoice","money","purchase","bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 4.64721L19 19.3528C19 19.6429 19 19.7879 18.9051 19.8465C18.8103 19.9051 18.6806 19.8403 18.4211 19.7106L17 19L15.5 19.9997L14 19L12 20L10 19L8.5 19.9997L7 19L5.57889 19.7106C5.31944 19.8403 5.18971 19.9051 5.09486 19.8465C5 19.7879 5 19.6429 5 19.3528V4.64721C5 4.35714 5 4.2121 5.09485 4.15348C5.18971 4.09485 5.31943 4.15972 5.57889 4.28944L7 5L8.5 4.00031L10 5L12 4L14 5L15.5 4.00031L17 5L18.4211 4.28944C18.6806 4.15972 18.8103 4.09485 18.9051 4.15348C19 4.2121 19 4.35714 19 4.64721Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "badge-Dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","money","transaction","payment","sales","finance","invoice","bill","charge","accounting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6646 3.32918C11.8758 3.22361 12.1243 3.22361 12.3355 3.32918L13.9462 4.13457L15.0841 3.37622C15.336 3.20835 15.6641 3.20835 15.916 3.37622L17.0539 4.13457L18.1105 3.60622C18.2162 3.55319 18.36 3.4811 18.4917 3.43802C18.6444 3.38803 18.9705 3.31215 19.2995 3.51549C19.6285 3.71883 19.7064 4.0444 19.7301 4.20339C19.7504 4.34041 19.7502 4.50122 19.7501 4.6195L19.7501 19.3805C19.7502 19.4988 19.7504 19.6596 19.7301 19.7966C19.7064 19.9556 19.6285 20.2812 19.2995 20.4845C18.9705 20.6879 18.6444 20.612 18.4917 20.562C18.36 20.5189 18.2163 20.4468 18.1106 20.3938L17.0539 19.8654L15.916 20.6238C15.6641 20.7917 15.336 20.7917 15.0841 20.6238L13.9462 19.8654L12.3355 20.6708C12.1243 20.7764 11.8758 20.7764 11.6646 20.6708L10.0539 19.8654L8.91598 20.6238C8.6641 20.7917 8.336 20.7917 8.08411 20.6238L6.94623 19.8654L5.91434 20.3814L5.88958 20.3938C5.78385 20.4468 5.64008 20.5189 5.50843 20.562C5.35567 20.612 5.02962 20.6879 4.70061 20.4845C4.37159 20.2812 4.29365 19.9556 4.27004 19.7966C4.24969 19.6596 4.24988 19.4988 4.25002 19.3805V4.61952C4.24988 4.50124 4.24969 4.34042 4.27004 4.20339C4.29365 4.0444 4.37159 3.71883 4.7006 3.51549C5.02962 3.31215 5.35567 3.38803 5.50843 3.43802C5.64009 3.4811 5.78385 3.55319 5.88958 3.60622L6.94623 4.13457L8.08411 3.37622C8.336 3.20835 8.6641 3.20835 8.91598 3.37622L10.0539 4.13457L11.6646 3.32918ZM12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25C11.0858 7.25 10.75 7.58579 10.75 8V8.37803C9.87611 8.68691 9.25 9.52034 9.25 10.5C9.25 11.7426 10.2574 12.75 11.5 12.75H12.3333C12.9159 12.75 13.25 13.1582 13.25 13.5C13.25 13.8418 12.9159 14.25 12.3333 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H10.75V16C10.75 16.4142 11.0858 16.75 11.5 16.75C11.9142 16.75 12.25 16.4142 12.25 16V15.75H12.3333C13.5917 15.75 14.75 14.815 14.75 13.5C14.75 12.185 13.5917 11.25 12.3333 11.25H11.5C11.0858 11.25 10.75 10.9142 10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75H13.3333C13.7475 9.75 14.0833 9.41421 14.0833 9C14.0833 8.58579 13.7475 8.25 13.3333 8.25H12.25V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-Dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","money","transaction","sales","bill","invoice","payment","total","balance","finance","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 20L19 4M5 4L5 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 4L17 5L15.5 4.00031L14 5L12 4L10 5L8.5 4.00031L7 5L5 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "badge-no-1-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["badge","first","medal","ribbon","award","promotion","top-seller","best-selling","loyalty","ranking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.05672 14.5018L5.63613 14.9391C4.5655 16.0522 4.03018 16.6088 4.17612 17.1539C4.18329 17.1807 4.19158 17.2072 4.20096 17.2333C4.3917 17.7644 5.14877 17.9167 6.66289 18.2212V18.2212C6.9776 18.2845 7.13495 18.3161 7.27236 18.3931C7.27972 18.3973 7.28702 18.4015 7.29427 18.4058C7.42969 18.4863 7.53577 18.6067 7.74793 18.8476V18.8476C8.7687 20.0066 9.27909 20.5862 9.83441 20.4858C9.86171 20.4809 9.88879 20.4748 9.91558 20.4676C10.4606 20.3214 10.675 19.5796 11.1036 18.0958L11.272 17.5129"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.0839 14.5018L18.5045 14.9391C19.5751 16.0522 20.1104 16.6088 19.9645 17.1539C19.9573 17.1807 19.949 17.2072 19.9397 17.2333C19.7489 17.7644 18.9919 17.9167 17.4777 18.2212V18.2212C17.163 18.2845 17.0057 18.3161 16.8683 18.3931C16.8609 18.3973 16.8536 18.4015 16.8464 18.4058C16.7109 18.4863 16.6049 18.6067 16.3927 18.8476V18.8476C15.3719 20.0066 14.8615 20.5862 14.3062 20.4858C14.2789 20.4809 14.2518 20.4748 14.225 20.4676C13.68 20.3214 13.4656 19.5796 13.037 18.0958L12.8686 17.5129"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 9L15 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-no-1-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["badge","number-one","first","rank","ranking","promotion","loyalty","reward","top-seller"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.66284 18.2213L6.02593 18.0932C5.08625 17.9042 4.61641 17.8097 4.39404 17.5591C4.20425 17.3452 4.11511 17.0603 4.14916 16.7763C4.18906 16.4437 4.52128 16.0983 5.18573 15.4074C5.49863 15.0821 5.65509 14.9195 5.84236 14.8396C6.00428 14.7705 6.18155 14.7454 6.35627 14.7668C6.55835 14.7916 6.75381 14.9044 7.14472 15.1301L10.1839 16.8848C10.5749 17.1105 10.7703 17.2234 10.8928 17.386C10.9987 17.5266 11.0656 17.6927 11.0867 17.8674C11.1112 18.0695 11.0486 18.2864 10.9233 18.72C10.6572 19.6409 10.5242 20.1013 10.2561 20.3022C10.0272 20.4736 9.73588 20.5389 9.45574 20.4815C9.12751 20.4142 8.81076 20.0545 8.17726 19.3352L7.74788 18.8477C7.53572 18.6068 7.42963 18.4864 7.29422 18.4059C7.28697 18.4016 7.27966 18.3974 7.2723 18.3932C7.1349 18.3162 6.97754 18.2846 6.66284 18.2213Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.4777 18.2212L18.1146 18.0931C19.0543 17.9041 19.5242 17.8096 19.7465 17.559C19.9363 17.3451 20.0255 17.0602 19.9914 16.7762C19.9515 16.4436 19.6193 16.0982 18.9548 15.4073C18.6419 15.082 18.4855 14.9194 18.2982 14.8395C18.1363 14.7704 17.959 14.7453 17.7843 14.7667C17.5822 14.7915 17.3868 14.9043 16.9959 15.13L13.9566 16.8847C13.5657 17.1104 13.3703 17.2233 13.2478 17.3859C13.1419 17.5265 13.075 17.6926 13.0538 17.8673C13.0294 18.0695 13.092 18.2863 13.2173 18.7199L13.2173 18.7199C13.4833 19.6408 13.6164 20.1012 13.8845 20.3021C14.1134 20.4735 14.4047 20.5388 14.6848 20.4814C15.0131 20.4141 15.3298 20.0545 15.9633 19.3352L16.3927 18.8476C16.6049 18.6067 16.7109 18.4863 16.8464 18.4058C16.8536 18.4015 16.8609 18.3973 16.8683 18.3931C17.0057 18.3161 17.163 18.2845 17.4777 18.2212Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 9L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-no-1-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","number-one","rank","best-seller","top-selling","first","medal","award","loyalty","program","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.46248 18.96C6.63248 18.99 6.80248 19.03 6.85248 19.05C6.89248 19.07 7.02248 19.22 7.13248 19.35L7.57248 19.85C8.31248 20.69 8.68248 21.11 9.25248 21.23C9.37248 21.25 9.48248 21.26 9.60248 21.26C9.98248 21.26 10.3525 21.14 10.6525 20.91C11.1125 20.56 11.2825 20 11.5725 18.99C11.3125 18.98 11.0625 18.95 10.8125 18.92C10.5625 18.88 10.3125 18.84 10.0725 18.78C8.30248 18.35 6.75248 17.34 5.66248 15.95C5.50248 15.75 5.35248 15.54 5.22248 15.33C5.08248 15.11 4.95248 14.89 4.83248 14.66C4.75248 14.74 4.68248 14.8 4.59248 14.9C3.83248 15.67 3.41248 16.1 3.34248 16.69C3.28248 17.19 3.44248 17.68 3.77248 18.06C4.16248 18.5 4.71248 18.61 5.82248 18.83L6.46248 18.96Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.6725 16.69C20.6025 16.11 20.1825 15.67 19.4225 14.89C19.2925 14.76 19.1925 14.66 19.0925 14.56C18.9825 14.79 18.8525 15.01 18.7125 15.23C18.5825 15.45 18.4325 15.65 18.2725 15.86C18.0625 16.14 17.8325 16.41 17.5825 16.66C16.5525 17.69 15.3025 18.39 13.9325 18.74C13.6925 18.8 13.4425 18.85 13.1925 18.89C12.9425 18.93 12.6925 18.96 12.4325 18.97C12.7225 19.98 12.8925 20.55 13.3525 20.9C13.6525 21.13 14.0225 21.25 14.4025 21.25C14.5225 21.25 14.6325 21.24 14.7525 21.21C15.3225 21.09 15.7025 20.67 16.4425 19.83L16.8725 19.34C16.9825 19.21 17.1125 19.07 17.1525 19.04C17.1925 19.02 17.3625 18.99 17.5325 18.95L18.1925 18.82C19.2825 18.6 19.8325 18.49 20.2225 18.05C20.5525 17.67 20.7125 17.18 20.6525 16.68L20.6725 16.69Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.4425 9.75001C10.0325 9.75001 9.69247 10.09 9.69247 10.5V11.5C9.69247 11.91 10.0325 12.25 10.4425 12.25C10.8525 12.25 11.1925 11.91 11.1925 11.5V10.5C11.1925 10.09 10.8525 9.75001 10.4425 9.75001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.0025 17.69C14.9825 17.39 15.8925 16.86 16.6625 16.15C16.7325 16.08 16.8125 16.02 16.8825 15.95C17.2425 15.59 17.5625 15.19 17.8325 14.77C17.9825 14.54 18.1125 14.31 18.2225 14.07C18.6825 13.13 18.9325 12.09 18.9325 11.01C18.9325 7.15001 15.86 4 12 4C8.14 4 4.94247 7.14001 4.94247 11C4.94247 12.11 5.21247 13.16 5.67247 14.1C5.78247 14.33 5.91247 14.56 6.05247 14.77C6.32247 15.19 6.63247 15.59 6.98247 15.94C7.83247 16.8 8.91247 17.43 10.1125 17.75C10.4125 17.83 10.7125 17.89 11.0325 17.93C11.2825 17.96 11.5325 17.98 11.7825 17.99C11.8325 17.99 11.8925 17.99 11.9425 17.99C12.0425 17.99 12.1425 17.98 12.2425 17.98C12.4925 17.97 12.7425 17.95 12.9925 17.91C13.3325 17.86 13.6725 17.79 14.0025 17.69ZM14.1925 9.00001C14.1925 8.59001 14.5325 8.25001 14.9425 8.25001C15.3525 8.25001 15.6925 8.59001 15.6925 9.00001V13C15.6925 13.41 15.3525 13.75 14.9425 13.75C14.5325 13.75 14.1925 13.41 14.1925 13V9.00001ZM10.4425 13.75C9.20247 13.75 8.19247 12.74 8.19247 11.5V10.5C8.19247 9.26001 9.20247 8.25001 10.4425 8.25001C11.6825 8.25001 12.6925 9.26001 12.6925 10.5V11.5C12.6925 12.74 11.6825 13.75 10.4425 13.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-no-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","ribbon","number-one","first","award","rank","loyalty","tier","achievement","promotion","discount","level","membership","rewards","vip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.05672 14.5018L5.63613 14.9391C4.5655 16.0522 4.03018 16.6088 4.17612 17.1539C4.18329 17.1807 4.19158 17.2072 4.20096 17.2333C4.3917 17.7644 5.14877 17.9167 6.66289 18.2212V18.2212C6.9776 18.2845 7.13495 18.3161 7.27236 18.3931C7.27972 18.3973 7.28702 18.4015 7.29427 18.4058C7.42969 18.4863 7.53577 18.6067 7.74793 18.8476V18.8476C8.7687 20.0066 9.27909 20.5862 9.83441 20.4858C9.86171 20.4809 9.88879 20.4748 9.91558 20.4676C10.4606 20.3214 10.675 19.5796 11.1036 18.0958L11.272 17.5129"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.0839 14.5018L18.5045 14.9391C19.5751 16.0522 20.1104 16.6088 19.9645 17.1539C19.9573 17.1807 19.949 17.2072 19.9397 17.2333C19.7489 17.7644 18.9919 17.9167 17.4777 18.2212V18.2212C17.163 18.2845 17.0057 18.3161 16.8683 18.3931C16.8609 18.3973 16.8536 18.4015 16.8464 18.4058C16.7109 18.4863 16.6049 18.6067 16.3927 18.8476V18.8476C15.3719 20.0066 14.8615 20.5862 14.3062 20.4858C14.2789 20.4809 14.2518 20.4748 14.225 20.4676C13.68 20.3214 13.4656 19.5796 13.037 18.0958L12.8686 17.5129"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 9L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Badge-star-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["badge","star","award","loyalty","reward","promotion","medal","achievement","vip","favorite","top","premium","featured","best seller","employee of the month","certification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.7082 9.25L12 7L11.2918 9.25H9L10.8541 10.7082L10 13L12 11.5836L14 13L13.1459 10.7082L15 9.25H12.7082Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Badge-star-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["badge","star","reward","loyalty","promotion","discount","achievement","recognition","employee-of-the-month","top-seller","sales","milestone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.3675 19.5442L10.4225 19.8592C8.92755 20.3575 8.18008 20.6066 7.74803 20.223C7.73759 20.2138 7.72734 20.2043 7.71729 20.1946C7.30169 19.7932 7.49279 19.0288 7.87498 17.5001C8.05322 16.7871 8.14234 16.4306 8.40517 16.2199C8.41193 16.2144 8.41876 16.2091 8.42566 16.2039C8.69388 16 9.06133 16 9.79625 16H14.2038C14.9387 16 15.3061 16 15.5743 16.2039C15.5812 16.2091 15.5881 16.2144 15.5948 16.2199C15.8577 16.4306 15.9468 16.7871 16.125 17.5001L16.125 17.5001C16.5072 19.0288 16.6983 19.7932 16.2827 20.1946C16.2727 20.2043 16.2624 20.2138 16.252 20.223C15.8199 20.6066 15.0724 20.3575 13.5775 19.8592L12.6325 19.5442C12.319 19.4397 12.1623 19.3874 12 19.3874C11.8377 19.3874 11.681 19.4397 11.3675 19.5442Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.7082 9.25L12 7L11.2918 9.25H9L10.8541 10.7082L10 13L12 11.5836L14 13L13.1459 10.7082L15 9.25H12.7082Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Badge-star-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","star","award","loyalty","reward","achievement","promotion","discount","vip","featured","top-seller","favorite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.69 20.75C11.85 20.7 11.95 20.66 11.97 20.64C12.06 20.65 12.16 20.69 12.32 20.75L13.27 21.07C15.01 21.65 16.06 22 16.98 21.17C17.81 20.37 17.54 19.29 17.1 17.51C16.99 17.06 16.89 16.69 16.74 16.38C17 16.18 17.25 15.97 17.48 15.73C18.94 14.27 19.75 12.32 19.75 10.25C19.75 5.98 16.27 2.5 12 2.5C7.73 2.5 4.25 5.98 4.25 10.25C4.25 12.74 5.42999 14.95 7.25999 16.37C7.10999 16.68 7.01999 17.05 6.89999 17.51C6.45999 19.29 6.18999 20.36 7.00999 21.15L7.08 21.22C7.43 21.53 7.82 21.66 8.27 21.66C8.92 21.66 9.71 21.4 10.73 21.06L11.67 20.75M11.04 18.85L10.09 19.17C9.46 19.38 8.82 19.59 8.47 19.65C8.5 19.29 8.67 18.61 8.83 17.99C8.88 17.78 8.94001 17.56 8.99001 17.4C9.91001 17.79 10.92 18 11.99 18C13.06 18 14.05 17.79 14.99 17.4C15.04 17.56 15.09 17.78 15.15 17.99C15.3 18.6 15.47 19.28 15.51 19.64C15.16 19.58 14.52 19.37 13.89 19.16L12.95 18.85C12.23 18.61 11.78 18.61 11.06 18.85M15.47 10.1L14.05 11.22L14.71 13C14.82 13.31 14.72 13.66 14.46 13.86C14.2 14.06 13.84 14.07 13.57 13.88L12 12.77L10.43 13.88C10.3 13.97 10.15 14.02 10 14.02C9.84 14.02 9.67999 13.97 9.53999 13.86C9.27999 13.66 9.17999 13.31 9.28999 13L9.95 11.22L8.53 10.1C8.28 9.9 8.18 9.57 8.28 9.27C8.38 8.97 8.67001 8.77 8.99001 8.77H10.73L11.27 7.04C11.37 6.73 11.66 6.52 11.99 6.52C12.32 6.52 12.61 6.73 12.71 7.04L13.25 8.77H14.99C15.31 8.77 15.59 8.97 15.7 9.27C15.8 9.57 15.7 9.91 15.45 10.1H15.47Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["badge","tick","check","approved","verified","completed","success","confirmation","checked","passed","valid","accepted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.86307 13.8642L4.86306 13.8642C4.44518 13.4462 4.23624 13.2373 4.10816 13.0216C3.73433 12.3919 3.73447 11.6083 4.10854 10.9788C4.23669 10.7632 4.44583 10.5542 4.8641 10.1362C5.04739 9.95303 5.13903 9.86145 5.21577 9.76274C5.43643 9.47894 5.57651 9.14091 5.62128 8.78422C5.63685 8.66017 5.63685 8.53068 5.63685 8.27171C5.63685 7.68064 5.63685 7.38511 5.69884 7.14196C5.87967 6.43269 6.4335 5.87885 7.14277 5.69803C7.38592 5.63604 7.6815 5.63604 8.27266 5.63604C8.53161 5.63604 8.66109 5.63604 8.78513 5.62047C9.14164 5.57573 9.47952 5.43577 9.76324 5.21531C9.86195 5.13861 9.95349 5.04706 10.1366 4.86397C10.5546 4.44589 10.7636 4.23686 10.9795 4.10873C11.6088 3.73511 12.392 3.73511 13.0214 4.10873C13.2372 4.23686 13.4462 4.44589 13.8643 4.86396L13.8643 4.86397C14.0474 5.04706 14.1389 5.13861 14.2376 5.21531C14.5213 5.43577 14.8592 5.57573 15.2157 5.62047C15.3398 5.63604 15.4692 5.63604 15.7281 5.63604C16.3194 5.63604 16.615 5.63604 16.8582 5.69806C17.5674 5.87891 18.1211 6.43266 18.302 7.14182C18.364 7.38504 18.364 7.6808 18.364 8.27232C18.364 8.53128 18.364 8.66076 18.3795 8.78476C18.4243 9.14115 18.5641 9.47893 18.7845 9.76261C18.8611 9.86131 18.9526 9.95284 19.1356 10.1359C19.5535 10.554 19.7625 10.7631 19.8906 10.9789C20.264 11.6083 20.2639 12.3914 19.8902 13.0207C19.762 13.2365 19.5529 13.4456 19.1345 13.8638C18.9512 14.047 18.8596 14.1386 18.7829 14.2373C18.5624 14.5211 18.4224 14.859 18.3776 15.2155C18.362 15.3396 18.362 15.4691 18.362 15.7281C18.362 16.3193 18.362 16.615 18.3 16.8582C18.1192 17.5673 17.5654 18.1211 16.8563 18.3019C16.613 18.364 16.3174 18.364 15.7262 18.364C15.4673 18.364 15.3378 18.364 15.2138 18.3795C14.8573 18.4243 14.5194 18.5642 14.2357 18.7847C14.1369 18.8614 14.0454 18.9529 13.8623 19.136L13.8623 19.136C13.4443 19.5541 13.2352 19.7631 13.0194 19.8913C12.3901 20.2649 11.6069 20.2649 10.9775 19.8913C10.7617 19.7631 10.5527 19.5541 10.1346 19.136C9.95154 18.9529 9.86 18.8614 9.76128 18.7847C9.47756 18.5642 9.13969 18.4243 8.78317 18.3795C8.65914 18.364 8.52968 18.364 8.27075 18.364C7.67952 18.364 7.3839 18.364 7.14068 18.3019C6.43152 18.1211 5.87777 17.5673 5.69692 16.8582C5.6349 16.615 5.6349 16.3192 5.6349 15.7278C5.6349 15.4689 5.6349 15.3395 5.61936 15.2156C5.57464 14.859 5.43466 14.521 5.21414 14.2372C5.13749 14.1386 5.04601 14.0471 4.86307 13.8642Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12.0317L10.5 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Badge-star": {
        defaultColors: ["#3D4C66"],
        keywords: ["star","badge","reward","loyalty","promotion","achievement","recognition","tier","membership","points","loyalty-program","reward-points"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7082 9.25L12 7L11.2918 9.25H9L10.8541 10.7082L10 13L12 11.5836L14 13L13.1459 10.7082L15 9.25H12.7082Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["badge","tick","check","approved","verified","success","confirmation","order-complete","payment-received","transaction-approved","validation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["verified","approved","check","tick","badge","confirmation","valid","success","complete","order-complete","payment-received","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.77 10.8698L20.12 11.9998H20.11L20.76 13.1298C21.22 13.9298 20.95 14.9498 20.15 15.4098L19.02 16.0598V17.3598C19.02 18.2798 18.27 19.0298 17.35 19.0298H16.05L15.4 20.1598C14.94 20.9598 13.92 21.2298 13.12 20.7698L11.99 20.1198L10.86 20.7698C10.6 20.9198 10.31 20.9898 10.03 20.9898C9.44997 20.9898 8.88997 20.6998 8.57997 20.1598L7.92997 19.0298H6.62997C5.70997 19.0298 4.95997 18.2798 4.95997 17.3598V16.0598L3.82997 15.4098C3.03997 14.9498 2.75997 13.9298 3.21997 13.1298L3.86997 11.9998L3.21997 10.8698C2.75997 10.0698 3.03997 9.04979 3.83997 8.58979L4.96997 7.93979V6.63979C4.96997 5.71979 5.71997 4.96979 6.63997 4.96979H7.93997L8.58997 3.83979C8.80997 3.44979 9.16997 3.17979 9.59997 3.05979C10.04 2.93979 10.48 2.99979 10.87 3.21979L12 3.87979L13.13 3.22979C13.92 2.76979 14.95 3.03979 15.41 3.83979L16.06 4.96979H17.36C18.28 4.96979 19.03 5.71979 19.03 6.63979V7.93979L20.16 8.58979C20.96 9.04979 21.23 10.0698 20.77 10.8698ZM15.7071 10.7069C16.0976 10.3163 16.0976 9.68317 15.7071 9.29265C15.3166 8.90212 14.6834 8.90212 14.2929 9.29265L11 12.5855L9.70711 11.2926C9.31658 10.9021 8.68342 10.9021 8.29289 11.2926C7.90237 11.6832 7.90237 12.3163 8.29289 12.7069L10.2929 14.7069C10.6834 15.0974 11.3166 15.0974 11.7071 14.7069L15.7071 10.7069Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["badge","tick","check","mark","approved","verified","confirmation","success","order-complete","payment-received","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.86307 13.8642L4.86306 13.8642C4.44518 13.4462 4.23624 13.2373 4.10816 13.0216C3.73433 12.3919 3.73447 11.6083 4.10854 10.9788C4.23669 10.7632 4.44583 10.5542 4.8641 10.1362C5.04739 9.95303 5.13903 9.86145 5.21577 9.76274C5.43643 9.47894 5.57651 9.14091 5.62128 8.78422C5.63685 8.66017 5.63685 8.53068 5.63685 8.27171C5.63685 7.68064 5.63685 7.38511 5.69884 7.14196C5.87967 6.43269 6.4335 5.87885 7.14277 5.69803C7.38592 5.63604 7.6815 5.63604 8.27266 5.63604C8.53161 5.63604 8.66109 5.63604 8.78513 5.62047C9.14164 5.57573 9.47952 5.43577 9.76324 5.21531C9.86195 5.13861 9.95349 5.04706 10.1366 4.86397C10.5546 4.44589 10.7636 4.23686 10.9795 4.10873C11.6088 3.73511 12.392 3.73511 13.0214 4.10873C13.2372 4.23686 13.4462 4.44589 13.8643 4.86396L13.8643 4.86397C14.0474 5.04706 14.1389 5.13861 14.2376 5.21531C14.5213 5.43577 14.8592 5.57573 15.2157 5.62047C15.3398 5.63604 15.4692 5.63604 15.7281 5.63604C16.3194 5.63604 16.615 5.63604 16.8582 5.69806C17.5674 5.87891 18.1211 6.43266 18.302 7.14182C18.364 7.38504 18.364 7.6808 18.364 8.27232C18.364 8.53128 18.364 8.66076 18.3795 8.78476C18.4243 9.14115 18.5641 9.47893 18.7845 9.76261C18.8611 9.86131 18.9526 9.95284 19.1356 10.1359C19.5535 10.554 19.7625 10.7631 19.8906 10.9789C20.264 11.6083 20.2639 12.3914 19.8902 13.0207C19.762 13.2365 19.5529 13.4456 19.1345 13.8638C18.9512 14.047 18.8596 14.1386 18.7829 14.2373C18.5624 14.5211 18.4224 14.859 18.3776 15.2155C18.362 15.3396 18.362 15.4691 18.362 15.7281C18.362 16.3193 18.362 16.615 18.3 16.8582C18.1192 17.5673 17.5654 18.1211 16.8563 18.3019C16.613 18.364 16.3174 18.364 15.7262 18.364C15.4673 18.364 15.3378 18.364 15.2138 18.3795C14.8573 18.4243 14.5194 18.5642 14.2357 18.7847C14.1369 18.8614 14.0454 18.9529 13.8623 19.136L13.8623 19.136C13.4443 19.5541 13.2352 19.7631 13.0194 19.8913C12.3901 20.2649 11.6069 20.2649 10.9775 19.8913C10.7617 19.7631 10.5527 19.5541 10.1346 19.136C9.95154 18.9529 9.86 18.8614 9.76128 18.7847C9.47756 18.5642 9.13969 18.4243 8.78317 18.3795C8.65914 18.364 8.52968 18.364 8.27075 18.364C7.67952 18.364 7.3839 18.364 7.14068 18.3019C6.43152 18.1211 5.87777 17.5673 5.69692 16.8582C5.6349 16.615 5.6349 16.3192 5.6349 15.7278C5.6349 15.4689 5.6349 15.3395 5.61936 15.2156C5.57464 14.859 5.43466 14.521 5.21414 14.2372C5.13749 14.1386 5.04601 14.0471 4.86307 13.8642Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12.0317L10.5 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","tick","check","verified","approved","completed","success","confirmation","valid","order-completed","payment-received","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.7498 10.4798C20.5598 10.1498 20.2998 9.89984 19.8398 9.43984C19.6998 9.29984 19.6298 9.22984 19.5698 9.15984C19.4598 9.01984 19.3898 8.84984 19.3698 8.66984C19.3598 8.57984 19.3698 8.47984 19.3698 8.27984C19.3698 7.62984 19.3698 7.26984 19.2798 6.89984C19.0098 5.83984 18.1798 5.00984 17.1098 4.72984C16.7498 4.63984 16.3898 4.63984 15.7298 4.63984C15.5298 4.63984 15.4298 4.63984 15.3398 4.63984C15.1598 4.61984 14.9898 4.54984 14.8498 4.43984C14.7798 4.37984 14.7098 4.30984 14.5698 4.16984C14.1098 3.70984 13.8498 3.44984 13.5298 3.25984C12.5798 2.69984 11.4098 2.69984 10.4698 3.25984C10.1498 3.44984 9.88984 3.70984 9.42984 4.16984C9.28984 4.30984 9.22984 4.37984 9.14984 4.42984C9.00984 4.53984 8.83984 4.60984 8.66984 4.62984C8.56984 4.63984 8.47984 4.62984 8.27984 4.62984C7.62984 4.62984 7.26984 4.62984 6.89984 4.71984C5.83984 4.98984 5.00984 5.81984 4.72984 6.88984C4.63984 7.24984 4.63984 7.60984 4.63984 8.25984C4.63984 8.45984 4.63984 8.54984 4.63984 8.64984C4.61984 8.82984 4.54984 8.99984 4.43984 9.13984C4.37984 9.20984 4.30984 9.27984 4.16984 9.41984C3.70984 9.87984 3.44984 10.1298 3.25984 10.4598C2.69984 11.4098 2.69984 12.5798 3.25984 13.5198C3.44984 13.8398 3.70984 14.0998 4.16984 14.5598C4.30984 14.6998 4.37984 14.7598 4.43984 14.8398C4.54984 14.9798 4.61984 15.1498 4.63984 15.3298C4.64984 15.4198 4.63984 15.5198 4.63984 15.7198C4.63984 16.3698 4.63984 16.7298 4.72984 17.0998C4.99984 18.1598 5.82984 18.9998 6.89984 19.2698C7.25984 19.3598 7.61984 19.3598 8.27984 19.3598C8.46984 19.3598 8.56984 19.3598 8.66984 19.3598C8.84984 19.3798 9.01984 19.4498 9.15984 19.5698C9.22984 19.6198 9.28984 19.6898 9.43984 19.8398C9.89984 20.2998 10.1598 20.5598 10.4798 20.7498C10.9498 21.0298 11.4798 21.1698 12.0098 21.1698C12.5398 21.1698 13.0698 21.0298 13.5398 20.7498C13.8698 20.5598 14.1198 20.2998 14.5798 19.8398C14.7198 19.6998 14.7798 19.6298 14.8598 19.5698C14.9998 19.4598 15.1698 19.3898 15.3498 19.3698C15.4398 19.3598 15.5398 19.3698 15.7398 19.3698C16.3898 19.3698 16.7498 19.3698 17.1198 19.2798C18.1798 19.0098 19.0098 18.1798 19.2898 17.1198C19.3798 16.7498 19.3798 16.3898 19.3798 15.7398C19.3798 15.5398 19.3798 15.4498 19.3798 15.3498C19.3998 15.1698 19.4698 15.0098 19.5798 14.8598C19.6398 14.7898 19.7098 14.7198 19.8498 14.5798C20.3098 14.1198 20.5598 13.8698 20.7498 13.5398C21.3098 12.5998 21.3098 11.4198 20.7498 10.4798ZM15.6598 10.7598L11.1598 14.7598C10.9798 14.9198 10.7398 15.0098 10.4998 15.0098C10.4698 15.0098 10.4398 15.0098 10.3998 15.0098C10.1198 14.9798 9.86984 14.8398 9.69984 14.6198L8.19984 12.6498C7.86984 12.2098 7.94984 11.5798 8.38984 11.2498C8.82984 10.9198 9.45984 10.9998 9.78984 11.4398L10.6398 12.5498L14.3298 9.26984C14.7398 8.89984 15.3698 8.93984 15.7398 9.34984C16.1098 9.75984 16.0698 10.3898 15.6598 10.7598Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-tick-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["badge","tick","check","checkmark","verified","approved","success","complete","confirmation","valid","accepted","checked","ok","authorize","confirm-order","payment-accepted","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.4572 5.86101C8.45275 5.33961 7.18612 5.50032 6.3433 6.34314C5.50045 7.18599 5.33976 8.45267 5.86121 9.45713C4.78214 9.79862 4 10.808 4 12C4 13.192 4.7821 14.2013 5.86115 14.5428C5.33968 15.5473 5.50037 16.814 6.34322 17.6569C7.18606 18.4997 8.45273 18.6604 9.45719 18.139C9.79873 19.2179 10.808 20 12 20C13.192 20 14.2013 19.2179 14.5428 18.1388C15.5473 18.6604 16.8141 18.4997 17.657 17.6569C18.4999 16.814 18.6606 15.5473 18.1391 14.5428C19.218 14.2012 20 13.1919 20 12C20 10.808 19.218 9.79874 18.139 9.4572C18.6605 8.45273 18.4998 7.18602 17.6569 6.34315C16.8141 5.50028 15.5473 5.3396 14.5428 5.86112C14.2013 4.78209 13.192 4 12 4C10.808 4 9.79875 4.78204 9.4572 5.86101Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L11 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","tick","check","approved","verified","completed","success","order-completed","payment-confirmed","valid","confirmation","accept","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.4572 5.86101C8.45275 5.33961 7.18612 5.50032 6.3433 6.34314C5.50045 7.18599 5.33976 8.45267 5.86121 9.45713C4.78214 9.79862 4 10.808 4 12C4 13.192 4.7821 14.2013 5.86115 14.5428C5.33968 15.5473 5.50037 16.814 6.34322 17.6569C7.18606 18.4997 8.45273 18.6604 9.45719 18.139C9.79873 19.2179 10.808 20 12 20C13.192 20 14.2013 19.2179 14.5428 18.1388C15.5473 18.6604 16.8141 18.4997 17.657 17.6569C18.4999 16.814 18.6606 15.5473 18.1391 14.5428C19.218 14.2012 20 13.1919 20 12C20 10.808 19.218 9.79874 18.139 9.4572C18.6605 8.45273 18.4998 7.18602 17.6569 6.34315C16.8141 5.50028 15.5473 5.3396 14.5428 5.86112C14.2013 4.78209 13.192 4 12 4C10.808 4 9.79875 4.78204 9.4572 5.86101Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L11 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tick","check","verified","valid","accepted","approved","confirmation","order-confirmation","payment-confirmation","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.4572 5.86101C8.45275 5.33961 7.18612 5.50032 6.3433 6.34314C5.50045 7.18599 5.33976 8.45267 5.86121 9.45713C4.78214 9.79862 4 10.808 4 12C4 13.192 4.7821 14.2013 5.86115 14.5428C5.33968 15.5473 5.50037 16.814 6.34322 17.6569C7.18606 18.4997 8.45273 18.6604 9.45719 18.139C9.79873 19.2179 10.808 20 12 20C13.192 20 14.2013 19.2179 14.5428 18.1388C15.5473 18.6604 16.8141 18.4997 17.657 17.6569C18.4999 16.814 18.6606 15.5473 18.1391 14.5428C19.218 14.2012 20 13.1919 20 12C20 10.808 19.218 9.79874 18.139 9.4572C18.6605 8.45273 18.4998 7.18602 17.6569 6.34315C16.8141 5.50028 15.5473 5.3396 14.5428 5.86112C14.2013 4.78209 13.192 4 12 4C10.808 4 9.79875 4.78204 9.4572 5.86101Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L11 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","tick","check","verified","approved","completed","success","valid","ok","confirmation","checked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C10.7263 3 9.60568 3.64905 8.94864 4.63328C7.78811 4.40196 6.53684 4.73539 5.63619 5.63603C4.73553 6.5367 4.40211 7.78798 4.63345 8.94853C3.64912 9.60555 3 10.7262 3 12C3 13.2738 3.64909 14.3944 4.63339 15.0514C4.40203 16.212 4.73544 17.4633 5.63612 18.364C6.53678 19.2646 7.78809 19.5981 8.94864 19.3667C9.60568 20.3509 10.7262 21 12 21C13.2738 21 14.3944 20.3509 15.0514 19.3667C16.212 19.5981 17.4634 19.2647 18.3641 18.364C19.2648 17.4633 19.5982 16.2119 19.3668 15.0513C20.351 14.3942 21 13.2737 21 12C21 10.7263 20.351 9.60571 19.3668 8.94867C19.5981 7.78809 19.2647 6.53674 18.364 5.63605C17.4633 4.73535 16.212 4.40194 15.0514 4.63334C14.3944 3.64907 13.2738 3 12 3ZM15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L10.2071 11.7929C9.81658 11.4024 9.18342 11.4024 8.79289 11.7929C8.40237 12.1834 8.40237 12.8166 8.79289 13.2071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "badge-tick-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","tick","check","checked","verified","approved","success","confirmation","completed","order-confirmation","payment-confirmation","transaction-approved","validation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["badge","tick","check","mark","verified","approved","success","completed","valid","confirmation","order-confirmation","payment-confirmation","transaction-successful"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63441 18.0358C6.26401 18.0358 5.96375 17.7356 5.96375 17.3652V15.7156C5.96375 15.5727 5.88751 15.4406 5.76375 15.3692L4.33572 14.5447C4.01495 14.3595 3.90504 13.9493 4.09024 13.6285L4.91485 12.2002C4.9863 12.0765 4.9863 11.924 4.91485 11.8002L4.08996 10.3715C3.90477 10.0507 4.01467 9.64053 4.33544 9.45532L5.76375 8.63068C5.88751 8.55922 5.96375 8.42717 5.96375 8.28427V6.63445C5.96375 6.26405 6.26401 5.96378 6.6344 5.96378H8.28446C8.42737 5.96378 8.55942 5.88754 8.63087 5.76378L9.45551 4.33545C9.6407 4.01467 10.0509 3.90476 10.3716 4.08996L11.8 4.91464C11.9238 4.9861 12.0762 4.9861 12.2 4.91464L13.6284 4.08996C13.9491 3.90476 14.3593 4.01467 14.5445 4.33545L15.3691 5.76378C15.4406 5.88754 15.5726 5.96378 15.7155 5.96378H17.3649C17.7353 5.96378 18.0356 6.26405 18.0356 6.63445V8.28389C18.0356 8.4268 18.1118 8.55885 18.2356 8.6303L19.6646 9.45532C19.9853 9.64053 20.0952 10.0507 19.91 10.3715L19.0852 11.8002C19.0137 11.924 19.0137 12.0765 19.0852 12.2002L19.9098 13.6285C20.095 13.9493 19.9851 14.3595 19.6643 14.5447L18.2356 15.3695C18.1118 15.441 18.0356 15.573 18.0356 15.716V17.3652C18.0356 17.7356 17.7353 18.0358 17.3649 18.0358H15.716C15.5731 18.0358 15.4411 18.1121 15.3696 18.2358L14.5448 19.6646C14.3596 19.9853 13.9494 20.0952 13.6286 19.91L12.2 19.0852C12.0762 19.0137 11.9238 19.0137 11.8 19.0852L10.3714 19.91C10.0506 20.0952 9.64043 19.9853 9.45523 19.6646L8.63038 18.2358C8.55893 18.1121 8.42687 18.0358 8.28397 18.0358H6.63441Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "badge-tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["tick","check","checkmark","verified","approved","confirmed","completed","order-complete","payment-received","transaction-approved","success","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.86307 13.8642L4.86306 13.8642C4.44518 13.4462 4.23624 13.2373 4.10816 13.0216C3.73433 12.3919 3.73447 11.6083 4.10854 10.9788C4.23669 10.7632 4.44583 10.5542 4.8641 10.1362C5.04739 9.95303 5.13903 9.86145 5.21577 9.76274C5.43643 9.47894 5.57651 9.14091 5.62128 8.78422C5.63685 8.66017 5.63685 8.53068 5.63685 8.27171C5.63685 7.68064 5.63685 7.38511 5.69884 7.14196C5.87967 6.43269 6.4335 5.87885 7.14277 5.69803C7.38592 5.63604 7.6815 5.63604 8.27266 5.63604C8.53161 5.63604 8.66109 5.63604 8.78513 5.62047C9.14164 5.57573 9.47952 5.43577 9.76324 5.21531C9.86195 5.13861 9.95349 5.04706 10.1366 4.86397C10.5546 4.44589 10.7636 4.23686 10.9795 4.10873C11.6088 3.73511 12.392 3.73511 13.0214 4.10873C13.2372 4.23686 13.4462 4.44589 13.8643 4.86396L13.8643 4.86397C14.0474 5.04706 14.1389 5.13861 14.2376 5.21531C14.5213 5.43577 14.8592 5.57573 15.2157 5.62047C15.3398 5.63604 15.4692 5.63604 15.7281 5.63604C16.3194 5.63604 16.615 5.63604 16.8582 5.69806C17.5674 5.87891 18.1211 6.43266 18.302 7.14182C18.364 7.38504 18.364 7.6808 18.364 8.27232C18.364 8.53128 18.364 8.66076 18.3795 8.78476C18.4243 9.14115 18.5641 9.47893 18.7845 9.76261C18.8611 9.86131 18.9526 9.95284 19.1356 10.1359C19.5535 10.554 19.7625 10.7631 19.8906 10.9789C20.264 11.6083 20.2639 12.3914 19.8902 13.0207C19.762 13.2365 19.5529 13.4456 19.1345 13.8638C18.9512 14.047 18.8596 14.1386 18.7829 14.2373C18.5624 14.5211 18.4224 14.859 18.3776 15.2155C18.362 15.3396 18.362 15.4691 18.362 15.7281C18.362 16.3193 18.362 16.615 18.3 16.8582C18.1192 17.5673 17.5654 18.1211 16.8563 18.3019C16.613 18.364 16.3174 18.364 15.7262 18.364C15.4673 18.364 15.3378 18.364 15.2138 18.3795C14.8573 18.4243 14.5194 18.5642 14.2357 18.7847C14.1369 18.8614 14.0454 18.9529 13.8623 19.136L13.8623 19.136C13.4443 19.5541 13.2352 19.7631 13.0194 19.8913C12.3901 20.2649 11.6069 20.2649 10.9775 19.8913C10.7617 19.7631 10.5527 19.5541 10.1346 19.136C9.95154 18.9529 9.86 18.8614 9.76128 18.7847C9.47756 18.5642 9.13969 18.4243 8.78317 18.3795C8.65914 18.364 8.52968 18.364 8.27075 18.364C7.67952 18.364 7.3839 18.364 7.14068 18.3019C6.43152 18.1211 5.87777 17.5673 5.69692 16.8582C5.6349 16.615 5.6349 16.3192 5.6349 15.7278C5.6349 15.4689 5.6349 15.3395 5.61936 15.2156C5.57464 14.859 5.43466 14.521 5.21414 14.2372C5.13749 14.1386 5.04601 14.0471 4.86307 13.8642Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12.0317L10.5 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v10-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","backpack","delivery","items","carry","school","travel","luggage","package","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L19.6972 15C19.9787 15 20.1195 15 20.2356 14.9719C20.5995 14.8836 20.8836 14.5995 20.9719 14.2356C21 14.1195 21 13.9787 21 13.6972V13.6972C21 13.5395 21 13.4607 20.989 13.3869C20.9548 13.1588 20.8428 12.9495 20.6719 12.7946C20.6167 12.7445 20.5511 12.7007 20.4199 12.6132L18 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15L4.30278 15C4.02128 15 3.88054 15 3.76444 14.9719C3.4005 14.8836 3.11635 14.5995 3.02814 14.2356C3 14.1195 3 13.9787 3 13.6972V13.6972C3 13.5395 3 13.4607 3.01105 13.3869C3.04524 13.1588 3.15725 12.9495 3.32809 12.7946C3.38329 12.7445 3.4489 12.7007 3.58013 12.6132L6 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L15 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9V9C18 9.93188 18 10.3978 17.8478 10.7654C17.6448 11.2554 17.2554 11.6448 16.7654 11.8478C16.3978 12 15.9319 12 15 12L9 12C8.06812 12 7.60218 12 7.23463 11.8478C6.74458 11.6448 6.35523 11.2554 6.15224 10.7654C6 10.3978 6 9.93188 6 9V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 7V7C9 5.89543 9.89543 5 11 5L13 5C14.1046 5 15 5.89543 15 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v10-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","backpack","delivery","shipping","carryout","pickup","order-ready","to-go","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L19.6972 15C19.9787 15 20.1195 15 20.2356 14.9719C20.5995 14.8836 20.8836 14.5995 20.9719 14.2356C21 14.1195 21 13.9787 21 13.6972V13.6972C21 13.5395 21 13.4607 20.989 13.3869C20.9548 13.1588 20.8428 12.9495 20.6719 12.7946C20.6167 12.7445 20.5511 12.7007 20.4199 12.6132L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15L4.30278 15C4.02128 15 3.88054 15 3.76444 14.9719C3.4005 14.8836 3.11635 14.5995 3.02814 14.2356C3 14.1195 3 13.9787 3 13.6972V13.6972C3 13.5395 3 13.4607 3.01105 13.3869C3.04524 13.1588 3.15725 12.9495 3.32809 12.7946C3.38329 12.7445 3.4489 12.7007 3.58013 12.6132L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 7V7C9 5.89543 9.89543 5 11 5L13 5C14.1046 5 15 5.89543 15 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3333 12H7.66667C7.04359 12 6.73205 12 6.5 11.866C6.34798 11.7783 6.22174 11.652 6.13397 11.5C6 11.2679 6 10.9564 6 10.3333C6 9.08718 6 8.4641 6.26795 8C6.44349 7.69596 6.69596 7.44349 7 7.26795C7.4641 7 8.08718 7 9.33333 7H14.6667C15.9128 7 16.5359 7 17 7.26795C17.304 7.44349 17.5565 7.69596 17.7321 8C18 8.4641 18 9.08718 18 10.3333C18 10.9564 18 11.2679 17.866 11.5C17.7783 11.652 17.652 11.7783 17.5 11.866C17.2679 12 16.9564 12 16.3333 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L15 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v10-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","luggage","suitcase","travel","delivery","package","takeout","order-pickup","carry-out","to-go"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35363 6.25008C8.68007 5.09579 9.74133 4.25 11.0001 4.25H13.0001C14.2589 4.25 15.3202 5.09579 15.6466 6.25008C16.0685 6.25143 16.4096 6.2627 16.7119 6.3437C17.6609 6.59799 18.4022 7.33924 18.6564 8.28825C18.7508 8.6404 18.7505 9.04514 18.7502 9.56895L18.7501 9.66667L18.7502 9.73078C18.7504 9.82006 18.7506 9.91084 18.7477 10.0011L18.7502 10V10.5986L20.8621 12.0066C20.9667 12.0761 21.0778 12.15 21.176 12.2391C21.475 12.5103 21.671 12.8766 21.7308 13.2758C21.7505 13.4069 21.7503 13.5403 21.7502 13.6659L21.7501 13.6972L21.7502 13.7555C21.7506 13.9758 21.751 14.2054 21.7009 14.4123C21.5465 15.0491 21.0493 15.5464 20.4124 15.7008C20.2055 15.7509 19.9759 15.7505 19.7556 15.7501L19.6974 15.75H18.7486C18.7443 16.3456 18.7285 16.8611 18.6702 17.2946C18.5858 17.9224 18.4002 18.4892 17.9447 18.9446C17.4892 19.4001 16.9224 19.5858 16.2946 19.6702C15.6999 19.7501 14.9507 19.7501 14.0522 19.7501H9.94816C9.0497 19.7501 8.30045 19.7501 7.70568 19.6702C7.07788 19.5858 6.51108 19.4001 6.05561 18.9446C5.60014 18.4892 5.41447 17.9224 5.33007 17.2946C5.27179 16.8611 5.256 16.3456 5.25173 15.75H4.30292L4.24468 15.7501C4.02435 15.7505 3.79473 15.7509 3.5879 15.7008C2.95102 15.5464 2.45376 15.0491 2.29939 14.4123C2.24926 14.2054 2.24967 13.9758 2.25007 13.7555L2.25014 13.6972L2.25012 13.6659C2.24998 13.5403 2.24983 13.4069 2.26948 13.2758C2.32931 12.8766 2.52532 12.5103 2.8243 12.2391C2.92246 12.15 3.03359 12.0761 3.13814 12.0066L5.25015 10.5986V10L5.25257 10.0011C5.2497 9.91081 5.24988 9.82009 5.25006 9.7308L5.25014 9.66667L5.2501 9.56895C5.24975 9.04514 5.24949 8.6404 5.34385 8.28825C5.59813 7.33924 6.33939 6.59799 7.28839 6.3437C7.5907 6.2627 7.93176 6.25143 8.35363 6.25008ZM10 6.25C10.2281 5.94639 10.5912 5.75 11.0001 5.75H13.0001C13.4091 5.75 13.7722 5.94639 14.0002 6.25H10ZM3.99629 13.2373L5.25015 12.4014V14.25H4.30292C4.156 14.25 4.06854 14.2499 4.00278 14.2471C3.96131 14.2454 3.94339 14.2431 3.93898 14.2424C3.84984 14.2199 3.78022 14.1503 3.75774 14.0612C3.75708 14.0568 3.75473 14.0389 3.75302 13.9974C3.75029 13.9316 3.75014 13.8442 3.75014 13.6972C3.75014 13.6143 3.75021 13.5674 3.75122 13.5319C3.75185 13.5096 3.7527 13.5002 3.75295 13.4978C3.76154 13.441 3.78943 13.3889 3.83193 13.3503C3.83375 13.3487 3.8411 13.3428 3.85931 13.3299C3.88834 13.3094 3.9273 13.2833 3.99629 13.2373ZM3.93898 14.2424L3.94125 14.243L3.93786 14.2422L3.93898 14.2424ZM20.004 13.2373L18.7502 12.4014L18.7502 14.25H19.6974C19.8443 14.25 19.9317 14.2499 19.9975 14.2471C20.039 14.2454 20.0569 14.2431 20.0613 14.2424C20.1504 14.2199 20.2201 14.1503 20.2425 14.0612C20.2432 14.0568 20.2456 14.0388 20.2473 13.9974C20.25 13.9316 20.2501 13.8442 20.2501 13.6972C20.2501 13.6143 20.2501 13.5675 20.2491 13.5319C20.2484 13.5096 20.2476 13.5002 20.2473 13.4978C20.2387 13.441 20.2109 13.3889 20.1684 13.3503C20.1665 13.3487 20.1592 13.3428 20.141 13.3299C20.1119 13.3094 20.073 13.2833 20.004 13.2373ZM9.00015 15.2501C8.58594 15.2501 8.25015 15.5859 8.25015 16.0001C8.25015 16.4143 8.58594 16.7501 9.00015 16.7501H15.0002C15.4144 16.7501 15.7502 16.4143 15.7502 16.0001C15.7502 15.5859 15.4144 15.2501 15.0002 15.2501H9.00015ZM10.0002 9.75C10.0002 9.33579 10.3359 9 10.7502 9H13.2502C13.6644 9 14.0002 9.33579 14.0002 9.75C14.0002 10.1642 13.6644 10.5 13.2502 10.5H10.7502C10.3359 10.5 10.0002 10.1642 10.0002 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v10": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","bags","shopping","delivery","takeout","order","carryout","package","retail","purchase","customer-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 15L19.6972 15C19.9787 15 20.1195 15 20.2356 14.9719C20.5995 14.8836 20.8836 14.5995 20.9719 14.2356C21 14.1195 21 13.9787 21 13.6972V13.6972C21 13.5395 21 13.4607 20.989 13.3869C20.9548 13.1588 20.8428 12.9495 20.6719 12.7946C20.6167 12.7445 20.5511 12.7007 20.4199 12.6132L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15L4.30278 15C4.02128 15 3.88054 15 3.76444 14.9719C3.4005 14.8836 3.11635 14.5995 3.02814 14.2356C3 14.1195 3 13.9787 3 13.6972V13.6972C3 13.5395 3 13.4607 3.01105 13.3869C3.04524 13.1588 3.15725 12.9495 3.32809 12.7946C3.38329 12.7445 3.4489 12.7007 3.58013 12.6132L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9V9C18 9.93188 18 10.3978 17.8478 10.7654C17.6448 11.2554 17.2554 11.6448 16.7654 11.8478C16.3978 12 15.9319 12 15 12L9 12C8.06812 12 7.60218 12 7.23463 11.8478C6.74458 11.6448 6.35523 11.2554 6.15224 10.7654C6 10.3978 6 9.93188 6 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L15 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7V7C9 5.89543 9.89543 5 11 5L13 5C14.1046 5 15 5.89543 15 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v11-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","backpack","delivery","ship","shipping","shopping","purchase","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M9 16H12H15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8V8C18 8.93188 18 9.39782 17.8478 9.76537C17.6448 10.2554 17.2554 10.6448 16.7654 10.8478C16.3978 11 15.9319 11 15 11L9 11C8.06812 11 7.60218 11 7.23463 10.8478C6.74458 10.6448 6.35523 10.2554 6.15224 9.76537C6 9.39783 6 8.93188 6 8V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v11-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","backpack","delivery","carryout","shipping","order","items","takeaway","merchandise","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3333 11H7.66667C7.04359 11 6.73205 11 6.5 10.866C6.34798 10.7783 6.22174 10.652 6.13397 10.5C6 10.2679 6 9.95641 6 9.33333C6 8.08718 6 7.4641 6.26795 7C6.44349 6.69596 6.69596 6.44349 7 6.26795C7.4641 6 8.08718 6 9.33333 6H14.6667C15.9128 6 16.5359 6 17 6.26795C17.304 6.44349 17.5565 6.69596 17.7321 7C18 7.4641 18 8.08718 18 9.33333C18 9.95641 18 10.2679 17.866 10.5C17.7783 10.652 17.652 10.7783 17.5 10.866C17.2679 11 16.9564 11 16.3333 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16H12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v11-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping-bag","takeaway","order","pickup","delivery","package","carryout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.33 18.54C5.41 19.17 5.6 19.73 6.06 20.19C6.52 20.65 7.08 20.83 7.71 20.92C8.3 21 9.05 21 9.95 21H14.05C14.95 21 15.7 21 16.29 20.92C16.92 20.84 17.48 20.65 17.94 20.19C18.4 19.73 18.58 19.17 18.67 18.54C18.73 18.11 18.74 17.74 18.75 17.15H19.7C19.7 17.15 19.74 17.15 19.76 17.15C19.98 17.15 20.21 17.15 20.42 17.1C21.06 16.95 21.55 16.45 21.71 15.81C21.76 15.6 21.75 15.37 21.75 15.15C21.75 15.13 21.75 15.11 21.75 15.09V15.06C21.75 14.93 21.76 14.8 21.74 14.67C21.68 14.27 21.48 13.9 21.19 13.63C21.09 13.54 20.98 13.47 20.88 13.4C20.88 13.4 20.86 13.39 20.85 13.38L18.97 12.13L18.76 11.99C18.64 11.99 18.51 11.99 18.37 11.99H5.64C5.5 11.99 5.38 11.99 5.25 11.99L5.04 12.13L3.16 13.38C3.16 13.38 3.14 13.39 3.13 13.4C3.03 13.47 2.91 13.54 2.82 13.63C2.52 13.9 2.33 14.27 2.27 14.67C2.25 14.81 2.25 14.94 2.25 15.07C2.25 15.08 2.25 15.09 2.25 15.1C2.25 15.12 2.25 15.14 2.25 15.16C2.25 15.38 2.25 15.61 2.3 15.82C2.45 16.46 2.95 16.95 3.59 17.11C3.8 17.16 4.03 17.16 4.25 17.16C4.27 17.16 4.29 17.16 4.31 17.16H5.26M15.01 15.51C15.42 15.51 15.76 15.85 15.76 16.26C15.76 16.67 15.42 17.01 15.01 17.01H9C8.59 17.01 8.25 16.67 8.25 16.26C8.25 15.85 8.59 15.51 9 15.51H15.01ZM5.26 15.66H4.31C4.16 15.66 4.08 15.66 4.01 15.66C3.97 15.66 3.95 15.66 3.95 15.66C3.86 15.64 3.79 15.57 3.77 15.48C3.77 15.48 3.77 15.46 3.77 15.42C3.77 15.35 3.77 15.27 3.77 15.12C3.77 15.04 3.77 14.99 3.77 14.95C3.77 14.93 3.77 14.92 3.77 14.92C3.77 14.86 3.81 14.81 3.85 14.77C3.85 14.77 3.85 14.77 3.88 14.75C3.91 14.73 3.95 14.7 4.02 14.66L5.27 13.82V15.67L5.26 15.66ZM20.27 15.4L20.26 15.47C20.24 15.56 20.17 15.63 20.08 15.65C20.08 15.65 20.06 15.65 20.02 15.65C19.95 15.65 19.87 15.65 19.72 15.65H18.77V13.8L20.02 14.64C20.09 14.69 20.13 14.71 20.16 14.73C20.18 14.74 20.19 14.75 20.19 14.75C20.23 14.79 20.26 14.84 20.27 14.9C20.27 14.9 20.27 14.91 20.27 14.93C20.27 14.97 20.27 15.01 20.27 15.1C20.27 15.25 20.27 15.33 20.27 15.4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.74999 10.91H18.75V10.11C18.75 9.21 18.75 8.55 18.67 7.96C18.63 7.66 18.56 7.37 18.46 7.1C18.35 6.81 18.18 6.54 17.95 6.31C17.94 6.3 17.92 6.29 17.9 6.27C17.45 5.85 16.9 5.66 16.3 5.58C16.12 5.56 15.92 5.54 15.71 5.53C15.71 5.53 15.71 5.51 15.71 5.5C15.7 5.47 15.71 5.44 15.69 5.41L15.24 4.52C15.24 4.52 15.24 4.5 15.23 4.49C15.11 4.25 14.99 4.01 14.87 3.83C14.74 3.62 14.57 3.42 14.32 3.26C14.07 3.1 13.81 3.05 13.57 3.02C13.33 3 13.07 3 12.8 3H11.21C10.93 3 10.67 3 10.45 3.02C10.2 3.05 9.94999 3.1 9.69999 3.26C9.44999 3.42 9.27999 3.62 9.14999 3.83C9.02999 4.02 8.91999 4.25 8.78999 4.49C8.78999 4.49 8.78999 4.51 8.77999 4.52L8.32999 5.41C8.32999 5.41 8.31999 5.47 8.30999 5.5C8.30999 5.5 8.30999 5.52 8.30999 5.53C8.09999 5.54 7.89999 5.56 7.71999 5.58C7.10999 5.66 6.55999 5.84 6.11999 6.27C6.10999 6.28 6.08999 6.29 6.06999 6.31C5.82999 6.55 5.66999 6.81 5.55999 7.1C5.44999 7.37 5.38999 7.65 5.34999 7.96C5.26999 8.55 5.26999 9.21 5.26999 10.11V10.91H6.76999H6.74999ZM10.12 5.19C10.26 4.91 10.34 4.75 10.41 4.63C10.44 4.58 10.46 4.55 10.47 4.54C10.47 4.54 10.47 4.54 10.48 4.54C10.5 4.54 10.53 4.53 10.59 4.52C10.72 4.51 10.9 4.51 11.22 4.51H12.75C13.07 4.51 13.25 4.51 13.38 4.52C13.44 4.52 13.47 4.53 13.49 4.54H13.5C13.51 4.55 13.53 4.58 13.56 4.63C13.63 4.74 13.71 4.9 13.85 5.19L14 5.5H9.95999L10.11 5.19H10.12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v11": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","travel","delivery","packing","carry-out","take-away","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8V8C18 8.93188 18 9.39782 17.8478 9.76537C17.6448 10.2554 17.2554 10.6448 16.7654 10.8478C16.3978 11 15.9319 11 15 11L9 11C8.06812 11 7.60218 11 7.23463 10.8478C6.74458 10.6448 6.35523 10.2554 6.15224 9.76537C6 9.39783 6 8.93188 6 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16H12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v12-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","backpack","travel","packing","delivery","shipment","carryout","customer-order","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M15 17H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V12C15 12.9428 15 13.4142 14.7071 13.7071C14.4142 14 13.9428 14 13 14H11C10.0572 14 9.58579 14 9.29289 13.7071C9 13.4142 9 12.9428 9 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v12-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","backpack","delivery","shipment","order","checkout","travel","item","package","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V12C15 12.9428 15 13.4142 14.7071 13.7071C14.4142 14 13.9428 14 13 14H11C10.0572 14 9.58579 14 9.29289 13.7071C9 13.4142 9 12.9428 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 17H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v12-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","luggage","carry-on","travel","delivery","package","pickup","to-go","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.8234 9.82317L9.82583 9.82179C9.82776 9.82078 9.83108 9.81917 9.83612 9.81709C9.8579 9.80813 9.90627 9.79284 10.0028 9.77986C10.2135 9.75152 10.5076 9.74993 11.0002 9.74993H13.0002C13.4928 9.74993 13.7868 9.75152 13.9975 9.77986C14.0941 9.79284 14.1424 9.80813 14.1642 9.81709C14.1663 9.81795 14.1681 9.81873 14.1696 9.81942C14.1717 9.8204 14.1734 9.8212 14.1745 9.82179L14.1769 9.82317L14.1783 9.8256L14.1795 9.82797L14.183 9.8359C14.192 9.85768 14.2073 9.90604 14.2202 10.0026C14.2486 10.2133 14.2502 10.5073 14.2502 10.9999V11.9999C14.2502 12.4925 14.2486 12.7865 14.2202 12.9973C14.2073 13.0938 14.192 13.1422 14.183 13.164L14.1807 13.1693L14.1783 13.1743L14.1769 13.1767L14.1745 13.1781C14.1726 13.1791 14.1692 13.1807 14.1642 13.1828C14.1424 13.1917 14.0941 13.207 13.9975 13.22C13.7868 13.2483 13.4928 13.2499 13.0002 13.2499H11.0002C10.5076 13.2499 10.2135 13.2483 10.0028 13.22C9.90627 13.207 9.8579 13.1917 9.83613 13.1828C9.83108 13.1807 9.82776 13.1791 9.82583 13.1781L9.8234 13.1767L9.82202 13.1743L9.82005 13.1702L9.81732 13.164C9.80836 13.1422 9.79307 13.0938 9.78008 12.9973C9.75175 12.7865 9.75016 12.4925 9.75016 11.9999V10.9999C9.75016 10.5073 9.75175 10.2133 9.78008 10.0026C9.79307 9.90604 9.80836 9.85768 9.81732 9.8359C9.81939 9.83085 9.82101 9.82754 9.82202 9.8256L9.8234 9.82317Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.52873 5.26578L8.79046 4.7423C8.9129 4.49736 9.02883 4.26544 9.14737 4.07913C9.27973 3.87111 9.4472 3.66646 9.69815 3.51137C9.94909 3.35627 10.207 3.29801 10.4523 3.27265C10.6719 3.24994 10.9312 3.24997 11.2051 3.25L12.7952 3.25C13.0691 3.24997 13.3283 3.24994 13.548 3.27265C13.7933 3.29801 14.0512 3.35627 14.3021 3.51137C14.5531 3.66646 14.7205 3.87111 14.8529 4.07913C14.9715 4.26544 15.0874 4.49737 15.2098 4.74231L15.4716 5.26578C15.7725 5.27711 16.0469 5.29654 16.2946 5.32984C16.9224 5.41424 17.4892 5.59992 17.9447 6.05539C18.4002 6.51085 18.5858 7.07765 18.6702 7.70545C18.7502 8.30021 18.7502 9.0494 18.7502 9.94784V11.5987L20.8621 13.0066C20.9667 13.0762 21.0778 13.1501 21.176 13.2392C21.475 13.5104 21.671 13.8766 21.7308 14.2759C21.7505 14.4069 21.7503 14.5404 21.7502 14.666L21.7501 14.6973L21.7502 14.7555C21.7506 14.9759 21.751 15.2055 21.7009 15.4123C21.5465 16.0492 21.0493 16.5465 20.4124 16.7008C20.2055 16.751 19.9759 16.7505 19.7556 16.7502L19.6974 16.7501H18.7486C18.7443 17.3455 18.7285 17.861 18.6702 18.2944C18.5858 18.9222 18.4002 19.489 17.9447 19.9445C17.4892 20.3999 16.9224 20.5856 16.2946 20.67C15.6999 20.75 14.9507 20.75 14.0523 20.7499H9.94816C9.04976 20.75 8.30042 20.75 7.70568 20.67C7.07788 20.5856 6.51108 20.3999 6.05561 19.9445C5.60014 19.489 5.41447 18.9222 5.33007 18.2944C5.2718 17.861 5.256 17.3455 5.25173 16.7501H4.30292L4.24468 16.7502C4.02435 16.7505 3.79473 16.751 3.5879 16.7008C2.95102 16.5465 2.45376 16.0492 2.29939 15.4123C2.24926 15.2055 2.24967 14.9759 2.25007 14.7555L2.25014 14.6973L2.25012 14.666C2.24998 14.5404 2.24983 14.4069 2.26948 14.2759C2.32931 13.8766 2.52532 13.5104 2.8243 13.2392C2.92246 13.1501 3.03359 13.0762 3.13814 13.0067L5.25015 11.5987V9.94793C5.25013 9.04948 5.2501 8.30022 5.33007 7.70545C5.41447 7.07766 5.60014 6.51085 6.05561 6.05538C6.51108 5.59992 7.07788 5.41424 7.70568 5.32984C7.95337 5.29654 8.22784 5.27711 8.52873 5.26578ZM13.7862 5.24993C13.7004 5.08048 13.6412 4.96896 13.5874 4.88438C13.5551 4.83367 13.5345 4.80864 13.5235 4.79685C13.5184 4.79135 13.5155 4.78889 13.5147 4.78822L13.5135 4.78734L13.5122 4.78668C13.5113 4.78626 13.5078 4.78478 13.5006 4.78267C13.4851 4.77813 13.4535 4.77088 13.3937 4.7647C13.2606 4.75093 13.0802 4.75 12.7641 4.75L11.2362 4.75C10.9201 4.75001 10.7397 4.75093 10.6066 4.7647C10.5468 4.77088 10.5152 4.77813 10.4997 4.78267C10.4925 4.78478 10.489 4.78626 10.4881 4.78668L10.4867 4.78734L10.4856 4.78822C10.4848 4.78889 10.4819 4.79135 10.4768 4.79685C10.4658 4.80864 10.4452 4.83367 10.4129 4.88438C10.3591 4.96896 10.2999 5.08048 10.2141 5.24993H13.7862ZM18.7502 15.2501V13.4015L20.004 14.2374C20.073 14.2834 20.1119 14.3094 20.141 14.33C20.1592 14.3429 20.1665 14.3488 20.1684 14.3503C20.2109 14.389 20.2387 14.4411 20.2473 14.4979C20.2476 14.5003 20.2484 14.5097 20.2491 14.532C20.2501 14.5675 20.2501 14.6144 20.2501 14.6973C20.2501 14.8442 20.25 14.9317 20.2473 14.9974C20.2456 15.0389 20.2432 15.0568 20.2425 15.0612C20.2201 15.1504 20.1504 15.22 20.0613 15.2425C20.0569 15.2431 20.039 15.2455 19.9975 15.2472C19.9317 15.2499 19.8443 15.2501 19.6974 15.2501H18.7502ZM5.25015 13.4015V15.2501H4.30292C4.156 15.2501 4.06854 15.2499 4.00278 15.2472C3.96131 15.2455 3.94339 15.2431 3.93898 15.2425C3.84984 15.22 3.78022 15.1504 3.75774 15.0612C3.75708 15.0568 3.75473 15.0389 3.75302 14.9974C3.75029 14.9317 3.75014 14.8442 3.75014 14.6973C3.75014 14.6144 3.75021 14.5675 3.75122 14.5319C3.75185 14.5097 3.7527 14.5003 3.75295 14.4979C3.76154 14.4411 3.78943 14.389 3.83193 14.3503C3.83375 14.3488 3.8411 14.3429 3.85931 14.33C3.88834 14.3094 3.9273 14.2834 3.99629 14.2374L5.25015 13.4015ZM3.93898 15.2425L3.94125 15.243L3.93786 15.2423L3.93898 15.2425ZM10.9554 8.24993H13.0449C13.4777 8.24988 13.8746 8.24983 14.1974 8.29323C14.5528 8.34102 14.9286 8.45347 15.2376 8.7625C15.5466 9.07152 15.6591 9.44724 15.7069 9.80272C15.7503 10.1255 15.7502 10.5224 15.7502 10.9552V12.0447C15.7502 12.4775 15.7503 12.8743 15.7069 13.1971C15.6591 13.5526 15.5466 13.9283 15.2376 14.2374C14.9286 14.5464 14.5528 14.6588 14.1974 14.7066C13.8746 14.75 13.4777 14.75 13.0449 14.7499H10.9554C10.5226 14.75 10.1258 14.75 9.80295 14.7066C9.44747 14.6588 9.07175 14.5464 8.76272 14.2374C8.4537 13.9283 8.34125 13.5526 8.29346 13.1971C8.25006 12.8743 8.25011 12.4775 8.25016 12.0447V10.9552C8.25011 10.5224 8.25006 10.1255 8.29346 9.80272C8.34125 9.44724 8.4537 9.07152 8.76272 8.7625C9.07175 8.45347 9.44747 8.34102 9.80295 8.29323C10.1258 8.24983 10.5226 8.24988 10.9554 8.24993ZM15.0002 18C15.4144 18 15.7502 17.6642 15.7502 17.25C15.7502 16.8358 15.4144 16.5 15.0002 16.5H9.00015C8.58594 16.5 8.25015 16.8358 8.25015 17.25C8.25015 17.6642 8.58594 18 9.00015 18H15.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v12": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","shipping","delivery","package","travel","luggage","carry-on","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V12C15 12.9428 15 13.4142 14.7071 13.7071C14.4142 14 13.9428 14 13 14H11C10.0572 14 9.58579 14 9.29289 13.7071C9 13.4142 9 12.9428 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 17H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","briefcase","business","work","sales","reports","documents","delivery","package","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12V13C9 13.9428 9 14.4142 9.29289 14.7071C9.58579 15 10.0572 15 11 15H13C13.9428 15 14.4142 15 14.7071 14.7071C15 14.4142 15 13.9428 15 13V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bags v2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","case","sales","reports","data","summary","day-end","end-of-day","cash-out","batch-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.5 15H10.5C10.0341 15 9.80109 15 9.61732 14.9239C9.37229 14.8224 9.17761 14.6277 9.07612 14.3827C9 14.1989 9 13.9659 9 13.5C9 13.0341 9 12.8011 9.07612 12.6173C9.17761 12.3723 9.37229 12.1776 9.61732 12.0761C9.80109 12 10.0341 12 10.5 12H13.5C13.9659 12 14.1989 12 14.3827 12.0761C14.6277 12.1776 14.8224 12.3723 14.9239 12.6173C15 12.8011 15 13.0341 15 13.5C15 13.9659 15 14.1989 14.9239 14.3827C14.8224 14.6277 14.6277 14.8224 14.3827 14.9239C14.1989 15 13.9659 15 13.5 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","case","carry","sales","reporting","summary","end-of-day","sales-summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 12V13C9 13.9428 9 14.4142 9.29289 14.7071C9.58579 15 10.0572 15 11 15H13C13.9428 15 14.4142 15 14.7071 14.7071C15 14.4142 15 13.9428 15 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","suitcase","case","box","shipping","delivery","package","orders","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.1 13.02C14.1 13.02 14.06 13.02 14 13.01C13.89 13.01 13.75 13.01 13.5 13.01H10.5C10.26 13.01 10.11 13.01 10 13.01C9.93 13.01 9.90002 13.02 9.90002 13.02C9.84002 13.05 9.80002 13.09 9.77002 13.15C9.77002 13.15 9.77001 13.19 9.76001 13.25C9.76001 13.36 9.76001 13.5 9.76001 13.75C9.76001 14 9.76001 14.14 9.76001 14.25C9.76001 14.32 9.77002 14.35 9.77002 14.35C9.80002 14.41 9.84002 14.46 9.90002 14.48C9.90002 14.48 9.94 14.48 10 14.49C10.11 14.49 10.25 14.49 10.5 14.49H13.5C13.74 14.49 13.89 14.49 14 14.49C14.07 14.49 14.09 14.48 14.1 14.48C14.16 14.45 14.2 14.41 14.23 14.35C14.23 14.35 14.23 14.31 14.24 14.25C14.24 14.14 14.24 14 14.24 13.75C14.24 13.5 14.24 13.36 14.24 13.25C14.24 13.18 14.23 13.15 14.23 13.15C14.2 13.09 14.16 13.04 14.1 13.02Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.72 13C15.72 13.05 15.74 13.1 15.74 13.15C15.75 13.32 15.75 13.51 15.75 13.73V13.77C15.75 13.98 15.75 14.18 15.74 14.35C15.73 14.53 15.7 14.72 15.62 14.92C15.44 15.35 15.1 15.69 14.67 15.87C14.47 15.95 14.28 15.98 14.1 15.99C13.93 16 13.74 16 13.52 16H10.48C10.27 16 10.07 16 9.90002 15.99C9.72002 15.98 9.53002 15.95 9.33002 15.87C8.90002 15.69 8.56 15.35 8.38 14.92C8.3 14.72 8.27001 14.53 8.26001 14.35C8.25001 14.18 8.25 13.99 8.25 13.77V13.73C8.25 13.52 8.25001 13.32 8.26001 13.15C8.26001 13.1 8.27003 13.05 8.28003 13H3.25C3.25 13.07 3.25 13.13 3.25 13.2V13.31C3.25 14.68 3.25 15.78 3.37 16.65C3.49 17.55 3.74998 18.31 4.34998 18.91C4.94998 19.51 5.70999 19.77 6.60999 19.89C7.47999 20.01 8.58001 20.01 9.95001 20.01H14.06C15.43 20.01 16.53 20.01 17.4 19.89C18.3 19.77 19.06 19.51 19.66 18.91C20.26 18.31 20.52 17.55 20.64 16.65C20.76 15.78 20.75 14.68 20.75 13.31V13.2C20.75 13.13 20.75 13.07 20.75 13H15.72Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.76001 11.5H20.75C20.74 10.88 20.7 10.33 20.64 9.86C20.52 8.96 20.26 8.2 19.66 7.6C19.06 7 18.3 6.74 17.4 6.62C16.92 6.56 16.38 6.53 15.76 6.51C15.76 6.15 15.76 5.83 15.72 5.55C15.67 5.19 15.56 4.82 15.25 4.51C14.94 4.2 14.57 4.09 14.21 4.04C13.89 4 13.49 4 13.06 4H10.97C10.54 4 10.14 4 9.82001 4.04C9.46001 4.09 9.09003 4.2 8.78003 4.51C8.47003 4.82 8.36 5.19 8.31 5.55C8.27 5.82 8.27002 6.15 8.27002 6.51C7.65002 6.52 7.1 6.55 6.63 6.62C5.73 6.74 4.97 7 4.37 7.6C3.77 8.2 3.51001 8.96 3.39001 9.86C3.33001 10.33 3.29998 10.88 3.28998 11.5H4.78998H4.76001ZM9.78003 5.75C9.79003 5.65 9.81001 5.61 9.82001 5.58C9.82001 5.58 9.82001 5.58 9.82001 5.57C9.82001 5.57 9.82002 5.57 9.83002 5.57C9.85002 5.57 9.9 5.55 10 5.53C10.21 5.5 10.5 5.5 11 5.5H13C13.49 5.5 13.79 5.5 14 5.53C14.1 5.54 14.15 5.56 14.17 5.57C14.17 5.57 14.17 5.57 14.18 5.57C14.18 5.57 14.18 5.57 14.18 5.58C14.18 5.6 14.2 5.65 14.22 5.75C14.24 5.92 14.25 6.15 14.25 6.5C14.19 6.5 14.12 6.5 14.06 6.5H9.95001C9.89001 6.5 9.82 6.5 9.75 6.5C9.75 6.15 9.75003 5.92 9.78003 5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","suitcase","travel","luggage","shipping","package","delivery","pickup","orders","briefcase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M15 19L15 7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","suitcase","luggage","travel","delivery","package","carry","shipping","order","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","delivery","package","shipping","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 20.25C8.25 20.66 8.59 21 9 21C9.41 21 9.75 20.66 9.75 20.25V19C9.21 19 8.71 19 8.25 18.99V20.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.78 4.75C9.79 4.65 9.81 4.61 9.82 4.58C9.82 4.58 9.82 4.58 9.82 4.57C9.82 4.57 9.82 4.57 9.83 4.57C9.85 4.57 9.9 4.55 10 4.53C10.21 4.5 10.5 4.5 11 4.5H13C13.49 4.5 13.79 4.5 14 4.53C14.1 4.54 14.15 4.56 14.17 4.57C14.17 4.57 14.17 4.57 14.18 4.57C14.18 4.57 14.18 4.57 14.18 4.58C14.18 4.6 14.2 4.65 14.22 4.75C14.24 4.92 14.25 5.15 14.25 5.5C14.79 5.5 15.29 5.5 15.75 5.51V5.25C15.75 5.25 15.75 5.2 15.75 5.18C15.75 4.95 15.73 4.74 15.71 4.55C15.66 4.19 15.55 3.82 15.24 3.51C14.93 3.2 14.56 3.09 14.2 3.04C13.87 3 13.48 3 13.05 3H10.96C10.53 3 10.13 3 9.81001 3.04C9.45001 3.09 9.08001 3.2 8.77001 3.51C8.46001 3.82 8.35001 4.19 8.30001 4.55C8.27001 4.74 8.26001 4.95 8.26001 5.18C8.26001 5.2 8.26001 5.23 8.26001 5.25V5.51C8.72001 5.51 9.22001 5.5 9.76001 5.5C9.76001 5.16 9.76001 4.92 9.79001 4.75H9.78Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.25 20.25C14.25 20.66 14.59 21 15 21C15.41 21 15.75 20.66 15.75 20.25V18.99C15.5292 18.99 15.2992 18.9923 15.06 18.9947C14.8008 18.9973 14.5308 19 14.25 19V20.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.25 5.51V5.52017L8.26 5.52001C8.71716 5.51007 9.21383 5.51001 9.75 5.51001V5.73V19L9.95 19H14.06L14.25 19C14.79 19 15.29 19 15.75 18.99C16.37 18.98 16.92 18.95 17.39 18.89C18.29 18.77 19.05 18.51 19.65 17.91C20.25 17.31 20.51 16.55 20.63 15.65C20.75 14.78 20.75 13.68 20.75 12.31V12.2C20.75 10.83 20.75 9.73001 20.63 8.86001C20.51 7.96001 20.25 7.20001 19.65 6.60001C19.05 6.00001 18.29 5.74001 17.39 5.62001C16.92 5.56001 16.37 5.53001 15.75 5.52001L15.75 5.51C15.5292 5.51 15.2992 5.5077 15.06 5.5053C14.8008 5.5027 14.5308 5.5 14.25 5.5V5.51001H14.06H9.95H9.76H9.75V5.5C9.21 5.5 8.71 5.5 8.25 5.51ZM14.25 5.51001V5.75V19C14.5308 19 14.8008 18.9973 15.06 18.9947C15.2992 18.9923 15.5292 18.99 15.75 18.99V5.52001C15.5292 5.52001 15.2992 5.51771 15.06 5.51531C14.8008 5.51271 14.5308 5.51001 14.25 5.51001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.62 5.62001C5.72 5.74001 4.96 6.00001 4.36 6.60001C3.75 7.20001 3.49 7.96001 3.37 8.86001C3.25 9.73001 3.25 10.83 3.25 12.2V12.31C3.25 13.68 3.25 14.78 3.37 15.65C3.49 16.55 3.75 17.31 4.35 17.91C4.95 18.51 5.71 18.77 6.61 18.89C7.08 18.95 7.63 18.98 8.25 18.99V5.52017C7.63408 5.53033 7.08747 5.56033 6.62 5.62001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","luggage","suitcase","travel","delivery","package","items","carry","export","import","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M15 19L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bags v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","briefcase","case","business","sales","reports","summary","transaction","deliveries","shipping","orders","documents"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 14L12 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","bag","case","sales","reports","summary","business","documents","day-end","sales-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","summary","report","end-of-day","sales-report","banking","transactions","case","portfolio","documents","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 14L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","suitcase","case","sales","reports","business","documents","summary","delivery","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.63 9.85C20.51 8.95 20.25 8.19 19.65 7.59C19.05 6.99 18.29 6.73 17.39 6.61C16.92 6.55 16.37 6.52 15.75 6.51C15.75 6.16 15.75 5.82 15.71 5.55C15.66 5.19 15.55 4.82 15.24 4.51C14.93 4.2 14.56 4.09 14.2 4.04C13.88 4 13.48 4 13.05 4H10.96C10.53 4 10.13 4 9.81001 4.04C9.45001 4.09 9.08001 4.2 8.77001 4.51C8.46001 4.82 8.35001 5.19 8.30001 5.55C8.26001 5.82 8.26001 6.15 8.26001 6.51C7.64001 6.52 7.09001 6.55 6.62001 6.61C5.72001 6.73 4.96001 6.99 4.36001 7.59C3.75001 8.19 3.49001 8.95 3.37001 9.85C3.31001 10.32 3.28001 10.87 3.26001 11.49H20.75C20.74 10.87 20.7 10.32 20.63 9.85ZM9.95001 6.49C9.88001 6.49 9.82001 6.49 9.76001 6.49C9.76001 6.15 9.76001 5.91 9.79001 5.74C9.80001 5.64 9.82001 5.6 9.83001 5.57C9.83001 5.57 9.83001 5.57 9.83001 5.56C9.83001 5.56 9.83001 5.56 9.84001 5.56C9.86001 5.56 9.91001 5.54 10.01 5.52C10.22 5.49 10.51 5.49 11.01 5.49H13.01C13.5 5.49 13.8 5.49 14.01 5.52C14.11 5.53 14.16 5.55 14.18 5.56C14.18 5.56 14.18 5.56 14.19 5.56C14.19 5.56 14.19 5.56 14.19 5.57C14.19 5.59 14.21 5.64 14.23 5.74C14.25 5.91 14.26 6.14 14.26 6.49C14.19 6.49 14.13 6.49 14.07 6.49H9.95001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.75 12.99V14.24C12.75 14.65 12.41 14.99 12 14.99C11.59 14.99 11.25 14.65 11.25 14.24V12.99H3.25V13.29C3.25 14.66 3.25 15.76 3.37 16.63C3.49 17.53 3.75 18.29 4.35 18.89C4.95 19.49 5.71 19.75 6.61 19.87C7.48 19.99 8.58 19.99 9.95 19.99H14.06C15.43 19.99 16.53 19.99 17.4 19.87C18.3 19.75 19.06 19.49 19.66 18.89C20.26 18.29 20.52 17.53 20.64 16.63C20.76 15.76 20.75 14.66 20.75 13.29V12.99H12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","backpack","delivery","shipping","order","items","package","carry","return","parcel","luggage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 16L4 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6L15.2604 4.8906C14.9698 4.45463 14.8244 4.23665 14.6033 4.11832C14.3822 4 14.1203 4 13.5963 4L10.4037 4C9.87973 4 9.61775 4 9.39666 4.11833C9.17557 4.23665 9.03024 4.45463 8.7396 4.8906L8 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 17H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5.29289 6.29289 5.29289 6.29289 5.29289 6.29289C5 6.58579 5 7.05719 5 8V8C5 9.88562 5 10.8284 5.58579 11.4142C5.58579 11.4142 5.58579 11.4142 5.58579 11.4142C6.17157 12 7.11438 12 9 12L15 12C16.8856 12 17.8284 12 18.4142 11.4142C18.4142 11.4142 18.4142 11.4142 18.4142 11.4142C19 10.8284 19 9.88562 19 8V8C19 7.05719 19 6.58579 18.7071 6.29289C18.7071 6.29289 18.7071 6.29289 18.7071 6.29289C18.4142 6 17.9428 6 17 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 13L9 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","backpack","travel","items","packing","carry","delivery","shipping","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.5C6 11.7761 6.22386 12 6.5 12H17.5C17.7761 12 18 11.7761 18 11.5V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 13L9 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 16L4 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6L15.2604 4.8906C14.9698 4.45463 14.8244 4.23665 14.6033 4.11832C14.3822 4 14.1203 4 13.5963 4L10.4037 4C9.87973 4 9.61775 4 9.39666 4.11833C9.17557 4.23665 9.03024 4.45463 8.7396 4.8906L8 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 13L15 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12H15C16.8856 12 17.8284 12 18.4142 11.4142C19 10.8284 19 9.88562 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8C5 9.88562 5 10.8284 5.58579 11.4142C6.17157 12 7.11438 12 9 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","bags","shopping-bag","shopping","purchase","order","checkout","delivery","package","carry","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.5 13.25C3.91421 13.25 4.25 13.5858 4.25 14V16C4.25 16.4142 3.91421 16.75 3.5 16.75C3.08579 16.75 2.75 16.4142 2.75 16L2.75 14C2.75 13.5858 3.08579 13.25 3.5 13.25ZM20.5 13.25C20.9142 13.25 21.25 13.5858 21.25 14V16C21.25 16.4142 20.9142 16.75 20.5 16.75C20.0858 16.75 19.75 16.4142 19.75 16V14C19.75 13.5858 20.0858 13.25 20.5 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25 12.118L5.25 16.052C5.24997 16.9504 5.24995 17.6997 5.32992 18.2945C5.41432 18.9223 5.59999 19.4891 6.05546 19.9445C6.51093 20.4 7.07773 20.5857 7.70553 20.6701C8.3003 20.7501 9.04951 20.75 9.94798 20.75H14.052C14.9505 20.75 15.6997 20.7501 16.2945 20.6701C16.9223 20.5857 17.4891 20.4 17.9445 19.9445C18.4 19.4891 18.5857 18.9223 18.6701 18.2945C18.7501 17.6997 18.75 16.9505 18.75 16.052L18.75 12.1179C18.3317 12.4493 17.8357 12.5973 17.2945 12.6701C17.0546 12.7023 16.7897 12.7216 16.5 12.7331V13C16.5 13.8284 15.8284 14.5 15 14.5C14.1716 14.5 13.5 13.8284 13.5 13V12.75H10.5V13C10.5 13.8284 9.82843 14.5 9 14.5C8.17157 14.5 7.5 13.8284 7.5 13V12.7331C7.21029 12.7216 6.94535 12.7023 6.70552 12.6701C6.16426 12.5973 5.66833 12.4493 5.25 12.118ZM15 17.75C15.4142 17.75 15.75 17.4142 15.75 17C15.75 16.5858 15.4142 16.25 15 16.25H9C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.37596 5.08398C7.34066 5.13692 7.31299 5.19272 7.29267 5.25009L6.63745 5.25008C6.35107 5.25006 6.08804 5.25004 5.86901 5.2699C5.63221 5.29136 5.37421 5.34067 5.12501 5.48454C4.85897 5.63814 4.63806 5.85905 4.48446 6.12509C4.34059 6.37429 4.29128 6.63229 4.26981 6.86909C4.24996 7.0881 4.24998 7.35103 4.25 7.63737L4.25001 7.70068C4.24999 8.29488 4.24998 8.79079 4.28656 9.19439C4.32477 9.61596 4.40757 10.0099 4.61844 10.3751C4.8598 10.7931 5.20695 11.1403 5.62501 11.3817C5.99023 11.5925 6.38413 11.6753 6.80571 11.7135C7.01261 11.7323 7.24377 11.7414 7.5 11.7459V11C7.5 10.1716 8.17157 9.5 9 9.5C9.82843 9.5 10.5 10.1716 10.5 11V11.7501L13.5 11.7501V11C13.5 10.1716 14.1716 9.5 15 9.5C15.8284 9.5 16.5 10.1716 16.5 11V11.7459C16.7562 11.7414 16.9874 11.7323 17.1943 11.7135C17.6159 11.6753 18.0098 11.5925 18.375 11.3817C18.7931 11.1403 19.1402 10.7931 19.3816 10.3751C19.5924 10.0099 19.6752 9.61596 19.7134 9.19439C19.75 8.79079 19.75 8.29489 19.75 7.70071L19.75 7.63755C19.75 7.35114 19.75 7.08815 19.7302 6.86909C19.7087 6.63229 19.6594 6.37429 19.5155 6.12509C19.362 5.85905 19.141 5.63814 18.875 5.48454C18.6258 5.34067 18.3678 5.29136 18.131 5.2699C17.912 5.25004 17.649 5.25006 17.3626 5.25008L16.7073 5.25008C16.687 5.19272 16.6593 5.13692 16.624 5.08398L15.8692 3.95168C15.737 3.75343 15.6111 3.56453 15.4885 3.41319C15.3514 3.24396 15.1863 3.07965 14.9572 2.95707C14.7282 2.8345 14.4999 2.78825 14.283 2.76803C14.0891 2.74995 13.8621 2.74998 13.6238 2.75L10.3762 2.75C10.1379 2.74998 9.91092 2.74995 9.71697 2.76803C9.50011 2.78825 9.2718 2.8345 9.04276 2.95707C8.81373 3.07965 8.64861 3.24396 8.51149 3.41319C8.38887 3.56452 8.26298 3.75339 8.13086 3.95163L7.37596 5.08398ZM14.6364 4.80663L14.932 5.25008L9.068 5.25009L9.36364 4.80663C9.51656 4.57724 9.60368 4.44792 9.67693 4.35751C9.7097 4.31707 9.72984 4.29709 9.74052 4.28758C9.74555 4.2831 9.74929 4.28039 9.74929 4.28039L9.75055 4.27959L9.75192 4.27899C9.75192 4.27899 9.75625 4.27737 9.76276 4.27568C9.77661 4.27207 9.8044 4.26639 9.85623 4.26156C9.97208 4.25075 10.128 4.25 10.4037 4.25L13.5963 4.25C13.872 4.25 14.0279 4.25075 14.1438 4.26156C14.1956 4.26639 14.2234 4.27207 14.2372 4.27567C14.2437 4.27737 14.2481 4.27899 14.2481 4.27899L14.2494 4.27959L14.2507 4.28039C14.2507 4.28039 14.2545 4.2831 14.2595 4.28758C14.2702 4.29709 14.2903 4.31707 14.3231 4.35751C14.3963 4.44792 14.4834 4.57724 14.6364 4.80663Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 10.25C9.41421 10.25 9.75 10.5858 9.75 11V13C9.75 13.4142 9.41421 13.75 9 13.75C8.58579 13.75 8.25 13.4142 8.25 13V11C8.25 10.5858 8.58579 10.25 9 10.25ZM15 10.25C15.4142 10.25 15.75 10.5858 15.75 11V13C15.75 13.4142 15.4142 13.75 15 13.75C14.5858 13.75 14.25 13.4142 14.25 13V11C14.25 10.5858 14.5858 10.25 15 10.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","deliveries","delivery","pickup","order-pickup","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 13L9 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 16L4 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5.29289 6.29289 5.29289 6.29289 5.29289 6.29289C5 6.58579 5 7.05719 5 8V8C5 9.88562 5 10.8284 5.58579 11.4142C5.58579 11.4142 5.58579 11.4142 5.58579 11.4142C6.17157 12 7.11438 12 9 12L15 12C16.8856 12 17.8284 12 18.4142 11.4142C18.4142 11.4142 18.4142 11.4142 18.4142 11.4142C19 10.8284 19 9.88562 19 8V8C19 7.05719 19 6.58579 18.7071 6.29289C18.7071 6.29289 18.7071 6.29289 18.7071 6.29289C18.4142 6 17.9428 6 17 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 6L15.2604 4.8906C14.9698 4.45463 14.8244 4.23665 14.6033 4.11832C14.3822 4 14.1203 4 13.5963 4L10.4037 4C9.87973 4 9.61775 4 9.39666 4.11833C9.17557 4.23665 9.03024 4.45463 8.7396 4.8906L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","backpack","delivery","order","shipping","items","carry","school","travel","luggage","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 6V6C9 4.89543 9.89543 4 11 4L13 4C14.1046 4 15 4.89543 15 6V6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 8V8C18 8.93188 18 9.39782 17.8478 9.76537C17.6448 10.2554 17.2554 10.6448 16.7654 10.8478C16.3978 11 15.9319 11 15 11L9 11C8.06812 11 7.60218 11 7.23463 10.8478C6.74458 10.6448 6.35523 10.2554 6.15224 9.76537C6 9.39783 6 8.93188 6 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v6-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","backpack","school","travel","items","products","packed","merchandise","pickup","carryout","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6V6C9 4.89543 9.89543 4 11 4L13 4C14.1046 4 15 4.89543 15 6V6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3333 11H7.66667C7.04359 11 6.73205 11 6.5 10.866C6.34798 10.7783 6.22174 10.652 6.13397 10.5C6 10.2679 6 9.95641 6 9.33333C6 8.08718 6 7.4641 6.26795 7C6.44349 6.69596 6.69596 6.44349 7 6.26795C7.4641 6 8.08718 6 9.33333 6H14.6667C15.9128 6 16.5359 6 17 6.26795C17.304 6.44349 17.5565 6.69596 17.7321 7C18 7.4641 18 8.08718 18 9.33333C18 9.95641 18 10.2679 17.866 10.5C17.7783 10.652 17.652 10.7783 17.5 10.866C17.2679 11 16.9564 11 16.3333 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 20L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","packing","items","products","merchandise","carry","luggage","travel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0001 3.25C9.7413 3.25 8.68002 4.09583 8.35361 5.25017C7.93174 5.25152 7.59069 5.26279 7.28839 5.34379C6.33939 5.59807 5.59813 6.33933 5.34384 7.28833C5.24949 7.64049 5.24975 8.04522 5.2501 8.56903L5.25014 8.66675L5.25006 8.73086C5.24957 8.97343 5.24907 9.22648 5.30977 9.45302C5.47159 10.0569 5.9433 10.5286 6.54721 10.6905C6.77375 10.7512 7.02679 10.7507 7.26936 10.7502L7.33347 10.7501H7.50014V10.25C7.50014 9.42157 8.17171 8.75 9.00014 8.75C9.82856 8.75 10.5001 9.42157 10.5001 10.25V10.7501H13.5001V10.25C13.5001 9.42157 14.1717 8.75 15.0001 8.75C15.8286 8.75 16.5001 9.42157 16.5001 10.25V10.7501H16.6668L16.7309 10.7502C16.9735 10.7507 17.2265 10.7512 17.4531 10.6905C18.057 10.5286 18.5287 10.0569 18.6905 9.45302C18.7512 9.22647 18.7507 8.97344 18.7502 8.73086L18.7501 8.66675L18.7502 8.56901C18.7505 8.04521 18.7508 7.64048 18.6564 7.28833C18.4022 6.33933 17.6609 5.59807 16.7119 5.34379C16.4096 5.26278 16.0685 5.25152 15.6467 5.25017C15.3203 4.09583 14.259 3.25 13.0001 3.25H11.0001ZM11.0001 4.75C10.5911 4.75 10.228 4.94642 9.99998 5.25008H14.0003C13.7722 4.94642 13.4091 4.75 13.0001 4.75H11.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.00014 9.75C9.41435 9.75 9.75014 10.0858 9.75014 10.5V11.5C9.75014 11.9142 9.41435 12.25 9.00014 12.25C8.58592 12.25 8.25014 11.9142 8.25014 11.5V10.5C8.25014 10.0858 8.58592 9.75 9.00014 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0001 9.75C15.4144 9.75 15.7501 10.0858 15.7501 10.5V11.5C15.7501 11.9142 15.4144 12.25 15.0001 12.25C14.5859 12.25 14.2501 11.9142 14.2501 11.5V10.5C14.2501 10.0858 14.5859 9.75 15.0001 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00014 13.2501C8.17171 13.2501 7.50014 12.5785 7.50014 11.7501H7.13758C6.8512 11.7501 6.58818 11.7502 6.36914 11.7303C6.13235 11.7088 5.87434 11.6595 5.62514 11.5157C5.48692 11.4359 5.36089 11.3379 5.25014 11.2249V12.5986L3.13814 14.0066C3.03359 14.0761 2.92246 14.15 2.8243 14.2391C2.52532 14.5103 2.32931 14.8766 2.26948 15.2758C2.24983 15.4069 2.24998 15.5403 2.25012 15.6659L2.25014 15.6972L2.25007 15.7555C2.24967 15.9758 2.24926 16.2054 2.29939 16.4123C2.45376 17.0491 2.95102 17.5464 3.5879 17.7008C3.79473 17.7509 4.02435 17.7505 4.24468 17.7501L4.30292 17.75H5.27941C5.29105 17.9439 5.30732 18.1255 5.33005 18.2946C5.41446 18.9224 5.60013 19.4892 6.0556 19.9447C6.51107 20.4001 7.07787 20.5858 7.70566 20.6702C8.30043 20.7502 9.04963 20.7501 9.94808 20.7501H14.0521C14.9506 20.7501 15.6999 20.7502 16.2946 20.6702C16.9224 20.5858 17.4892 20.4001 17.9447 19.9447C18.4002 19.4892 18.5858 18.9224 18.6702 18.2946C18.693 18.1255 18.7092 17.9439 18.7209 17.75H19.6974L19.7556 17.7501C19.9759 17.7505 20.2055 17.7509 20.4124 17.7008C21.0493 17.5464 21.5465 17.0491 21.7009 16.4123C21.751 16.2054 21.7506 15.9758 21.7502 15.7555L21.7501 15.6972L21.7502 15.6659C21.7503 15.5403 21.7505 15.4069 21.7308 15.2758C21.671 14.8766 21.475 14.5103 21.176 14.2391C21.0778 14.15 20.9667 14.0761 20.8621 14.0066L18.7501 12.5986V11.2249C18.6394 11.3379 18.5134 11.4359 18.3751 11.5157C18.1259 11.6595 17.8679 11.7088 17.6311 11.7303C17.4121 11.7502 17.1491 11.7501 16.8628 11.7501L16.5001 11.7501C16.5001 12.5785 15.8286 13.2501 15.0001 13.2501C14.1717 13.2501 13.5001 12.5785 13.5001 11.7501H10.5001C10.5001 12.5785 9.82857 13.2501 9.00014 13.2501ZM3.99629 15.2373L5.25014 14.4014L5.25016 16.25H4.30292C4.156 16.25 4.06854 16.2499 4.00278 16.2471C3.96131 16.2454 3.94339 16.2431 3.93899 16.2424L3.94125 16.243L3.93786 16.2422C3.93786 16.2422 3.93822 16.2423 3.93899 16.2424C3.84985 16.2199 3.78022 16.1503 3.75774 16.0612C3.75708 16.0568 3.75473 16.0389 3.75302 15.9974C3.75029 15.9316 3.75014 15.8442 3.75014 15.6972C3.75014 15.6143 3.75021 15.5674 3.75122 15.5319C3.75185 15.5096 3.75269 15.5002 3.75295 15.4978M3.99629 15.2373C3.9273 15.2833 3.88834 15.3094 3.85931 15.3299L3.99629 15.2373ZM3.85931 15.3299C3.8411 15.3428 3.83375 15.3487 3.83193 15.3503L3.85931 15.3299ZM19.6974 16.25H18.7501L18.7501 14.4014L20.004 15.2373C20.073 15.2833 20.1119 15.3094 20.141 15.3299C20.1592 15.3428 20.1665 15.3487 20.1684 15.3503C20.2109 15.3889 20.2387 15.441 20.2473 15.4978C20.2476 15.5002 20.2484 15.5096 20.2491 15.5319C20.2501 15.5675 20.2501 15.6143 20.2501 15.6972C20.2501 15.8442 20.25 15.9316 20.2473 15.9974C20.2456 16.0388 20.2432 16.0568 20.2425 16.0612C20.2201 16.1503 20.1504 16.2199 20.0613 16.2424C20.0569 16.2431 20.039 16.2454 19.9975 16.2471C19.9317 16.2499 19.8443 16.25 19.6974 16.25ZM8.25014 18.75C8.25014 19.1642 8.58592 19.5 9.00014 19.5C9.41435 19.5 9.75014 19.1642 9.75014 18.75V17.75C9.75014 17.3358 9.41435 17 9.00014 17C8.58592 17 8.25014 17.3358 8.25014 17.75V18.75ZM14.2501 18.75C14.2501 19.1642 14.5859 19.5 15.0001 19.5C15.4144 19.5 15.7501 19.1642 15.7501 18.75V17.75C15.7501 17.3358 15.4144 17 15.0001 17C14.5859 17 14.2501 17.3358 14.2501 17.75V18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","delivery","pickup","order","carryout","ship","packaging"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 8V8C18 8.93188 18 9.39782 17.8478 9.76537C17.6448 10.2554 17.2554 10.6448 16.7654 10.8478C16.3978 11 15.9319 11 15 11L9 11C8.06812 11 7.60218 11 7.23463 10.8478C6.74458 10.6448 6.35523 10.2554 6.15224 9.76537C6 9.39783 6 8.93188 6 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 6V6C9 4.89543 9.89543 4 11 4L13 4C14.1046 4 15 4.89543 15 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","luggage","shopping-bag","takeaway","pickup","delivery","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 11L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 19L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v7-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","luggage","suitcase","delivery","travel","ship","shipped","shipping","package","order","baggage","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 11L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 19L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v8-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping-bag","shopping","remove","delete","cancel-order","void","void-order","return-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L5.49615 12.3359C4.36723 13.0885 3.80278 13.4648 3.80278 14C3.80278 14.5352 4.36723 14.9115 5.49615 15.6641L6 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16L18.5039 15.6641C19.6328 14.9115 20.1972 14.5352 20.1972 14C20.1972 13.4648 19.6328 13.0885 18.5038 12.3359L18 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M9 14L15 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","bags","shopping-bag","shopping","checkout","purchase","items","products","cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.63 9.86C18.51 8.96 18.25 8.2 17.65 7.6C17.13 7.08 16.49 6.82 15.74 6.68C15.74 6.59 15.71 6.5 15.67 6.41L15.22 5.52C15.22 5.52 15.21 5.5 15.21 5.49C15.09 5.25 14.97 5.01 14.85 4.83C14.72 4.62 14.55 4.42 14.3 4.26C14.05 4.1 13.79 4.05 13.55 4.02C13.33 4 13.07 4 12.79 4H11.2C10.93 4 10.67 4 10.45 4.02C10.21 4.05 9.95 4.1 9.7 4.26C9.45 4.42 9.28 4.62 9.15 4.83C9.03 5.02 8.92 5.25 8.79 5.49C8.79 5.49 8.79 5.51 8.78 5.52L8.33 6.41C8.29 6.5 8.27 6.59 8.26 6.68C7.52 6.82 6.87 7.08 6.35 7.6C5.75 8.2 5.49 8.96 5.37 9.86C5.25 10.73 5.25 11.83 5.25 13.2V13.31C5.25 14.68 5.25 15.78 5.37 16.65C5.49 17.55 5.75 18.31 6.35 18.91C6.95 19.51 7.71 19.77 8.61 19.89C9.48 20.01 10.58 20 11.95 20H12.06C13.43 20 14.53 20.01 15.4 19.89C16.3 19.77 17.06 19.51 17.66 18.91C18.26 18.31 18.52 17.55 18.64 16.65C18.76 15.78 18.75 14.68 18.75 13.31V13.2C18.75 11.83 18.76 10.73 18.64 9.86H18.63ZM10.12 6.19C10.26 5.91 10.34 5.75 10.41 5.63C10.44 5.58 10.46 5.55 10.47 5.54C10.47 5.54 10.47 5.54 10.48 5.54C10.5 5.54 10.53 5.53 10.59 5.52C10.72 5.51 10.9 5.51 11.22 5.51H12.75C13.07 5.51 13.25 5.51 13.38 5.52C13.44 5.52 13.47 5.53 13.49 5.54H13.5C13.51 5.55 13.53 5.58 13.56 5.63C13.63 5.74 13.71 5.9 13.86 6.19L14.02 6.52C13.43 6.5 12.77 6.5 12.03 6.5H11.92C11.18 6.5 10.52 6.5 9.93 6.52L10.09 6.19H10.12ZM9.75 18C9.75 18.41 9.41 18.75 9 18.75C8.59 18.75 8.25 18.41 8.25 18V17C8.25 16.59 8.59 16.25 9 16.25C9.41 16.25 9.75 16.59 9.75 17V18ZM15.75 18C15.75 18.41 15.41 18.75 15 18.75C14.59 18.75 14.25 18.41 14.25 18V17C14.25 16.59 14.59 16.25 15 16.25C15.41 16.25 15.75 16.59 15.75 17V18ZM15 12H9C8.59 12 8.25 11.66 8.25 11.25C8.25 10.84 8.59 10.5 9 10.5H15C15.41 10.5 15.75 10.84 15.75 11.25C15.75 11.66 15.41 12 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v8-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","bags","shopping-bag","shopping-bags","tote","order","checkout","inventory","items","products","delivery","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L5.49615 12.3359C4.36723 13.0885 3.80278 13.4648 3.80278 14C3.80278 14.5352 4.36723 14.9115 5.49615 15.6641L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16L18.5039 15.6641C19.6328 14.9115 20.1972 14.5352 20.1972 14C20.1972 13.4648 19.6328 13.0885 18.5038 12.3359L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16V10C5.79731 8.37849 5.69597 7.56773 6.04622 6.97832C6.174 6.76328 6.34098 6.57412 6.53851 6.42065C7.07993 6 7.897 6 9.53113 6H15.2384C16.3263 6 16.8703 6 17.2637 6.17818C17.8614 6.44894 18.2883 6.99571 18.406 7.64128C18.4835 8.06612 18.3515 8.59383 18.0877 9.64924L18.0877 9.64929C18.0598 9.76098 18.0458 9.81683 18.0351 9.87321C18.0189 9.95853 18.0083 10.0448 18.0033 10.1315C18 10.1888 18 10.2464 18 10.3616V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 14L15 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","bags","shopping","checkout","carryout","order","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.74999 10.8002C5.38999 10.7502 5.01999 10.6402 4.70999 10.3302L4.71999 10.3202C4.40999 10.0102 4.29999 9.64016 4.24999 9.28016C4.20999 8.96016 4.20999 8.56016 4.20999 8.13016V8.04016C4.20999 7.61016 4.20999 7.21016 4.24999 6.89016C4.29999 6.53016 4.40999 6.16016 4.71999 5.85016C5.02999 5.54016 5.39999 5.43016 5.75999 5.38016C6.07999 5.34016 6.47999 5.34016 6.90999 5.34016H7.63999C8.55999 4.42016 9.16999 3.82016 9.83999 3.49016C11.17 2.84016 12.73 2.84016 14.06 3.50016C14.73 3.83016 15.34 4.43016 16.26 5.35016H16.99C17.42 5.35016 17.82 5.35016 18.14 5.39016C18.5 5.44016 18.87 5.55016 19.18 5.86016C19.49 6.17016 19.6 6.54016 19.65 6.90016C19.69 7.22016 19.69 7.62016 19.69 8.05016V8.14016C19.69 8.57016 19.69 8.97016 19.65 9.29016C19.6 9.65016 19.49 10.0202 19.18 10.3302C18.87 10.6402 18.5 10.7502 18.14 10.8002C17.82 10.8402 17.42 10.8402 16.99 10.8402H6.89999C6.46999 10.8402 6.06999 10.8402 5.74999 10.8002ZM13.39 4.84016C12.48 4.39016 11.41 4.39016 10.5 4.84016H10.51C10.29 4.95016 10.08 5.10016 9.79999 5.35016H14.1C13.81 5.10016 13.6 4.95016 13.39 4.84016Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0235 12.2365C19.4981 12.5555 19.9234 12.8414 20.22 13.1102L20.23 13.1002C20.57 13.4102 21 13.8302 21 14.4102C21 14.9902 20.57 15.4102 20.23 15.7202C19.9335 15.9889 19.5081 16.2748 19.0335 16.5938L18.92 16.6702L18.7 16.8202C18.69 17.4302 18.68 17.9502 18.62 18.3902C18.53 19.0202 18.35 19.5802 17.89 20.0402C17.43 20.5002 16.87 20.6902 16.24 20.7702C15.65 20.8502 14.9 20.8502 14 20.8502H9.9C9 20.8502 8.25 20.8502 7.66 20.7702C7.03 20.6802 6.47 20.5002 6.01 20.0402C5.55 19.5802 5.36 19.0202 5.28 18.3902C5.22 17.9502 5.2 17.4302 5.2 16.8202L5.03 16.7102C5.02 16.7052 5.0125 16.7002 5.005 16.6952C4.9975 16.6902 4.99 16.6852 4.98 16.6802L4.86652 16.6039C4.39192 16.2848 3.96655 15.9989 3.67 15.7302C3.33 15.4202 3 15.0002 3 14.4202C3 13.8402 3.33 13.4202 3.67 13.1102C3.96655 12.8414 4.39192 12.5555 4.86652 12.2365L4.98 12.1602C5 12.1502 5.03 12.1302 5.03 12.1302L5.2 12.0202L5.46 11.8502H18.43L18.69 12.0202L18.91 12.1602L19.0235 12.2365ZM4.51 14.4202C4.53 14.4502 4.57 14.5102 4.68 14.6102C4.81 14.7302 4.98 14.8602 5.2 15.0102V13.8302C4.98 13.9902 4.81 14.1202 4.68 14.2302C4.57 14.3302 4.53 14.3902 4.51 14.4202ZM19.22 14.6102C19.33 14.5102 19.39 14.4202 19.39 14.4202C19.37 14.3902 19.33 14.3302 19.22 14.2302C19.09 14.1102 18.92 13.9802 18.7 13.8302V15.0102C18.92 14.8502 19.09 14.7202 19.22 14.6102ZM15 14.6003H9C8.59 14.6003 8.25 14.2603 8.25 13.8503C8.25 13.4403 8.59 13.1003 9 13.1003H15C15.41 13.1003 15.75 13.4403 15.75 13.8503C15.75 14.2603 15.41 14.6003 15 14.6003ZM9 19.6003C9.41 19.6003 9.75 19.2603 9.75 18.8503V16.8503C9.75 16.4403 9.41 16.1003 9 16.1003C8.59 16.1003 8.25 16.4403 8.25 16.8503V18.8503C8.25 19.2603 8.59 19.6003 9 19.6003ZM15 19.6003C15.41 19.6003 15.75 19.2603 15.75 18.8503V16.8503C15.75 16.4403 15.41 16.1003 15 16.1003C14.59 16.1003 14.25 16.4403 14.25 16.8503V18.8503C14.25 19.2603 14.59 19.6003 15 19.6003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v8": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping-bag","tote","carry","purchase","checkout","order","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 12L5.49615 12.3359C4.36723 13.0885 3.80278 13.4648 3.80278 14C3.80278 14.5352 4.36723 14.9115 5.49615 15.6641L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16L18.5039 15.6641C19.6328 14.9115 20.1972 14.5352 20.1972 14C20.1972 13.4648 19.6328 13.0885 18.5038 12.3359L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 14L15 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags v9-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","bags","shopping-bag","shopping","purchase","carry","checkout","tote","package","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V10.5C6 8.61438 6 7.67157 6.58579 7.08579C7.17157 6.5 8.11438 6.5 10 6.5H14C15.8856 6.5 16.8284 6.5 17.4142 7.08579C18 7.67157 18 8.61438 18 10.5V13V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 11L16 11C17.6569 11 19 9.65685 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8C5 9.65686 6.34315 11 8 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 16L4 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v9-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","delivery","shipping","package","order","items","carry","travel","luggage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.7006 12.7499C13.96 13.1983 14.4447 13.5 15 13.5C15.5553 13.5 16.0401 13.1983 16.2994 12.7499C17.2427 12.7465 18.0867 12.3916 18.75 11.8109V16.0519C18.75 16.9504 18.7501 17.6996 18.6701 18.2944C18.5857 18.9222 18.4 19.489 17.9445 19.9444C17.4891 20.3999 16.9223 20.5856 16.2945 20.67C15.6997 20.7499 14.9505 20.7499 14.0521 20.7499H9.94798C9.04957 20.7499 8.30027 20.7499 7.70552 20.67C7.07773 20.5856 6.51093 20.3999 6.05546 19.9444C5.59999 19.489 5.41432 18.9222 5.32992 18.2944C5.24995 17.6996 5.24997 16.9503 5.25 16.0519V11.8109C5.91332 12.3916 6.75734 12.7465 7.7006 12.7499C7.95994 13.1983 8.44473 13.5 9 13.5C9.55526 13.5 10.04 13.1983 10.2994 12.7499L13.7006 12.7499ZM15.75 16.9999C15.75 17.4141 15.4142 17.7499 15 17.7499H9C8.58579 17.7499 8.25 17.4141 8.25 16.9999C8.25 16.5857 8.58579 16.2499 9 16.2499H15C15.4142 16.2499 15.75 16.5857 15.75 16.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.5 13.2499C3.91421 13.2499 4.25 13.5857 4.25 13.9999V15.9999C4.25 16.4141 3.91421 16.7499 3.5 16.7499C3.08579 16.7499 2.75 16.4141 2.75 15.9999V13.9999C2.75 13.5857 3.08579 13.2499 3.5 13.2499Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.5 13.2499C20.9142 13.2499 21.25 13.5857 21.25 13.9999V15.9999C21.25 16.4141 20.9142 16.7499 20.5 16.7499C20.0858 16.7499 19.75 16.4141 19.75 15.9999V13.9999C19.75 13.5857 20.0858 13.2499 20.5 13.2499Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.89093 3.40065C11.2199 2.7421 12.7801 2.7421 14.1091 3.40065C14.7832 3.73471 15.3893 4.32848 16.3107 5.24988L17.0448 5.24988C17.4776 5.24983 17.8744 5.24978 18.1972 5.29318C18.5527 5.34098 18.9284 5.45342 19.2374 5.76245C19.5465 6.07147 19.6589 6.4472 19.7067 6.80268C19.7501 7.12549 19.7501 7.52232 19.75 7.95514L19.75 7.99988C19.75 10.071 18.0711 11.7499 16 11.7499H15.75V11.9999C15.75 12.4141 15.4142 12.7499 15 12.7499C14.5858 12.7499 14.25 12.4141 14.25 11.9999V11.7499H9.75V11.9999C9.75 12.4141 9.41421 12.7499 9 12.7499C8.58579 12.7499 8.25 12.4141 8.25 11.9999V11.7499L8 11.7499C5.92893 11.7499 4.25 10.071 4.25 7.99988C4.25 7.98493 4.25 7.97001 4.25 7.95514C4.24995 7.52232 4.2499 7.12549 4.2933 6.80268C4.34109 6.4472 4.45354 6.07147 4.76256 5.76245C5.07159 5.45342 5.44731 5.34098 5.80279 5.29318C6.1256 5.24978 6.52243 5.24983 6.95525 5.24988C6.97012 5.24988 6.98504 5.24988 7 5.24988H7.68927C8.61069 4.32848 9.21679 3.73471 9.89093 3.40065ZM9.85178 5.24988H14.1482C13.866 5.00085 13.6553 4.84985 13.4431 4.74468C12.5338 4.29409 11.4662 4.29409 10.5569 4.74468C10.3447 4.84985 10.134 5.00085 9.85178 5.24988Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags v7-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping-bag","shopping","checkout","order","purchase","cart","summary","briefcase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 11L15 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 19L9 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags v9-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","bags","shopping-bag","shopping","purchase","order","delivery","carryout","takeout","pickup","merchandise","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 16L4 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 8V8C19 8 19 8 19 8C19 9.65685 17.6569 11 16 11C16 11 16 11 16 11L8 11C8 11 8 11 8 11C6.34315 11 5 9.65686 5 8C5 8 5 8 5 8V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8V8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6L17 6C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags v9": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","carry","products","items","delivery","shipping","sales","order","pickup","retail","package","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 8V8C19 8 19 8 19 8C19 9.65685 17.6569 11 16 11C16 11 16 11 16 11L8 11C8 11 8 11 8 11C6.34315 11 5 9.65686 5 8C5 8 5 8 5 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8V8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6L17 6C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 16L4 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 16L20 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping-bag","briefcase","tote","delivery","shipment","order","merchandise","products","package","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M4 15H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","suitcase","luggage","travel","carry-on","shipping","delivery","package","briefcase","items","products","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.25 12.5C3.25 12.88 3.25 13.27 3.25 13.7V13.81C3.25 13.88 3.25 13.94 3.25 14.01H20.75C20.75 13.94 20.75 13.88 20.75 13.81V13.7C20.75 13.27 20.75 12.88 20.75 12.5H3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.24 15.5H3.26001C3.27001 16.12 3.29999 16.67 3.35999 17.14C3.47999 18.04 3.74 18.8 4.34 19.4C4.94 20 5.70001 20.26 6.60001 20.38C7.47001 20.5 8.57 20.5 9.94 20.5H14.05C15.42 20.5 16.52 20.5 17.39 20.38C18.29 20.26 19.05 20 19.65 19.4C20.25 18.8 20.51 18.04 20.63 17.14C20.69 16.67 20.72 16.12 20.73 15.5H19.23H19.24Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.81 11H20.69C20.67 10.77 20.65 10.56 20.63 10.36C20.51 9.46 20.25 8.7 19.65 8.1C19.05 7.5 18.29 7.24 17.39 7.12C16.91 7.06 16.37 7.03 15.75 7.01V6.75C15.75 4.68 14.07 3 12 3C9.93 3 8.25 4.68 8.25 6.75V7.01C7.63 7.02 7.07999 7.05 6.60999 7.12C5.70999 7.24 4.95001 7.5 4.35001 8.1C3.75001 8.7 3.49 9.46 3.37 10.36C3.34 10.56 3.32 10.78 3.31 11H4.82001H4.81ZM9.75 6.75C9.75 5.51 10.76 4.5 12 4.5C13.24 4.5 14.25 5.51 14.25 6.75V7H9.75V6.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","luggage","carry-on","travel","product","inventory","item","merchandise","shopping-bag","cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 15H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","add","plus","new","package","add-item","create","create-box","add-package","new-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 15H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus v2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["box","package","add","plus","order","add-order","first-aid","medical","medicine","supplement","health","kit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 11H4C4 10.07 4 9.60504 4.10222 9.22354C4.37962 8.18827 5.18827 7.37962 6.22354 7.10222C6.60504 7 7.07003 7 8 7H16C16.93 7 17.395 7 17.7765 7.10222C18.8117 7.37962 19.6204 8.18827 19.8978 9.22354C20 9.60504 20 10.07 20 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 15H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","add","plus","order","add-order","new-item","inventory","restock","supply","shipment","receiving","addition","expansion","create","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 6.25001C14.25 5.7574 14.2484 5.71339 14.2201 5.50267C14.2071 5.40611 14.1918 5.35775 14.1828 5.33597C14.1808 5.33093 14.1791 5.32761 14.1781 5.32568L14.1768 5.32324L14.1743 5.32187C14.1724 5.32086 14.1691 5.31924 14.164 5.31717C14.1423 5.3082 14.0939 5.29291 13.9973 5.27993C13.7866 5.2516 13.4926 5.25001 13 5.25001L11 5.25001C10.5074 5.25001 10.2134 5.2516 10.0027 5.27993C9.90611 5.29291 9.85774 5.30821 9.83596 5.31717C9.83092 5.31924 9.8276 5.32086 9.82567 5.32187L9.82324 5.32324L9.82186 5.32568C9.82085 5.32761 9.81923 5.33093 9.81716 5.33597C9.8082 5.35775 9.79291 5.40611 9.77992 5.50267L9.77669 5.52666C9.75093 5.71752 9.74295 5.77666 9.74295 6.25001H14.25ZM7 6.25001H8.24295L8.24294 6.20525C8.24289 5.77244 8.2499 5.62561 8.2933 5.3028C8.34109 4.94732 8.45354 4.57159 8.76256 4.26257C9.07159 3.95355 9.44731 3.8411 9.80279 3.79331C10.1256 3.74991 10.5224 3.74995 10.9553 3.75L11 3.75001L13 3.75001L13.0447 3.75C13.4776 3.74995 13.8744 3.74991 14.1972 3.79331C14.5527 3.8411 14.9284 3.95355 15.2374 4.26257C15.5465 4.57159 15.6589 4.94732 15.7067 5.3028C15.7499 5.62428 15.7499 5.81561 15.7498 6.24468V6.25001H17C19.0711 6.25001 20.75 7.92894 20.75 10V10.75H3.25V10C3.25 7.92894 4.92893 6.25001 7 6.25001ZM20.7466 11.75H3.25345C3.24999 12.1234 3.25 12.5215 3.25 12.9449V12.9451V13.0548V13.0549C3.24998 14.4224 3.24997 15.5247 3.36653 16.3917C3.48754 17.2918 3.74644 18.0497 4.34835 18.6516C4.95027 19.2535 5.70814 19.5124 6.60825 19.6334C7.47522 19.75 8.57754 19.75 9.94513 19.75H14.0549C15.4225 19.75 16.5248 19.75 17.3918 19.6334C18.2919 19.5124 19.0497 19.2535 19.6517 18.6516C20.2536 18.0497 20.5125 17.2918 20.6335 16.3917C20.75 15.5247 20.75 14.4224 20.75 13.0548V12.9443V12.9441V12.944V12.9439C20.75 12.5208 20.75 12.1232 20.7466 11.75ZM12 13C12.4142 13 12.75 13.3358 12.75 13.75V15H14C14.4142 15 14.75 15.3358 14.75 15.75C14.75 16.1642 14.4142 16.5 14 16.5H12.75V17.75C12.75 18.1642 12.4142 18.5 12 18.5C11.5858 18.5 11.25 18.1642 11.25 17.75V16.5H10C9.58579 16.5 9.25 16.1642 9.25 15.75C9.25 15.3358 9.58579 15 10 15H11.25V13.75C11.25 13.3358 11.5858 13 12 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-plus v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","add","plus","new","create","addition","package","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 15H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","add","plus","new-order","create-order","new-bag","add-bag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 13H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 19L8 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 19L16 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bags-plus v3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","plus","add","items","add-items","package","add-package","new-order","create-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 19L8 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 19L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medical","first aid","add","plus","health","emergency","aid","box","kit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.62 9.85C20.5 8.95 20.24 8.19 19.64 7.59C19.04 6.99 18.28 6.73 17.38 6.61C16.91 6.55 16.36 6.52 15.74 6.51C15.74 6.16 15.74 5.82 15.7 5.55C15.65 5.19 15.54 4.82 15.23 4.51C14.92 4.2 14.55 4.09 14.19 4.04C13.87 4 13.47 4 13.04 4H10.95C10.52 4 10.12 4 9.8 4.04C9.44 4.09 9.07001 4.2 8.76001 4.51C8.45001 4.82 8.34001 5.19 8.29001 5.55C8.25001 5.82 8.25 6.15 8.25 6.51C7.63 6.52 7.08 6.55 6.61 6.61C5.71 6.73 4.95001 6.99 4.35001 7.59C3.75001 8.19 3.49001 8.95 3.37001 9.85C3.25001 10.72 3.25 11.82 3.25 13.19V13.3C3.25 14.67 3.25001 15.77 3.37001 16.64C3.49001 17.54 3.75001 18.3 4.35001 18.9C4.95001 19.5 5.71 19.76 6.61 19.88C7.48 20 8.58001 20 9.95001 20H14.06C15.43 20 16.53 20 17.4 19.88C18.3 19.76 19.06 19.5 19.66 18.9C20.26 18.3 20.52 17.54 20.64 16.64C20.76 15.77 20.75 14.67 20.75 13.3V13.19C20.75 11.82 20.74 10.72 20.62 9.85ZM9.99001 13.99C9.58001 13.99 9.24001 13.65 9.24001 13.24C9.24001 12.83 9.58001 12.49 9.99001 12.49H11.24V11.24C11.24 10.83 11.58 10.49 11.99 10.49C12.4 10.49 12.74 10.83 12.74 11.24V12.49H13.99C14.4 12.49 14.74 12.83 14.74 13.24C14.74 13.65 14.4 13.99 13.99 13.99H12.74V15.24C12.74 15.65 12.4 15.99 11.99 15.99C11.58 15.99 11.24 15.65 11.24 15.24V13.99H9.99001ZM6.24001 17.24V9.24C6.24001 8.83 6.58001 8.49 6.99001 8.49C7.40001 8.49 7.74001 8.83 7.74001 9.24V17.24C7.74001 17.65 7.40001 17.99 6.99001 17.99C6.58001 17.99 6.24001 17.65 6.24001 17.24ZM17.74 17.24C17.74 17.65 17.4 17.99 16.99 17.99C16.58 17.99 16.24 17.65 16.24 17.24V9.24C16.24 8.83 16.58 8.49 16.99 8.49C17.4 8.49 17.74 8.83 17.74 9.24V17.24ZM9.77 5.74C9.78 5.64 9.80001 5.6 9.81001 5.57C9.81001 5.57 9.81001 5.57 9.81001 5.56C9.81001 5.56 9.81001 5.56 9.82001 5.56C9.84001 5.56 9.89001 5.54 9.99001 5.52C10.2 5.49 10.49 5.49 10.99 5.49H12.99C13.48 5.49 13.78 5.49 13.99 5.52C14.09 5.53 14.14 5.55 14.16 5.56C14.16 5.56 14.16 5.56 14.17 5.56C14.17 5.56 14.17 5.56 14.17 5.57C14.17 5.59 14.19 5.64 14.21 5.74C14.23 5.91 14.24 6.14 14.24 6.49C14.17 6.49 14.11 6.49 14.05 6.49H9.94C9.87 6.49 9.81 6.49 9.75 6.49C9.75 6.15 9.75 5.91 9.78 5.74H9.77Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-plus v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","plus","add","package","new","add-package","add-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 19L8 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 19L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bags-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","package","add","plus","order","add-order","new-order","create-order","create","new","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","add","plus","create","new","add-item","new-order","add-order","create-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","add","plus","order","add-order","item","new-item","new-order","package","box","create"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.62 9.86C20.5 8.96 20.24 8.2 19.64 7.6C19.04 7 18.28 6.74 17.38 6.62C16.9 6.56 16.36 6.53 15.74 6.51C15.74 6.15 15.74 5.83 15.7 5.55C15.65 5.19 15.54 4.82 15.23 4.51C14.92 4.2 14.55 4.09 14.19 4.04C13.87 4 13.47 4 13.04 4H10.95C10.52 4 10.12 4 9.79999 4.04C9.43999 4.09 9.06998 4.2 8.75998 4.51C8.44998 4.82 8.33998 5.19 8.28998 5.55C8.24998 5.82 8.25 6.15 8.25 6.51C7.63 6.52 7.07999 6.55 6.60999 6.62C5.70999 6.74 4.94998 7 4.34998 7.6C3.74998 8.2 3.49 8.96 3.37 9.86C3.25 10.73 3.25 11.83 3.25 13.2V13.31C3.25 14.68 3.25 15.78 3.37 16.65C3.49 17.55 3.74998 18.31 4.34998 18.91C4.94998 19.51 5.70999 19.77 6.60999 19.89C7.47999 20.01 8.38 20 9.75 20H13.86C15.23 20 16.53 20.01 17.4 19.89C18.3 19.77 19.06 19.51 19.66 18.91C20.26 18.31 20.52 17.55 20.64 16.65C20.76 15.78 20.75 14.68 20.75 13.31V13.2C20.75 11.83 20.74 10.73 20.62 9.86ZM9.98999 14C9.57999 14 9.23999 13.66 9.23999 13.25C9.23999 12.84 9.57999 12.5 9.98999 12.5H11.24V11.25C11.24 10.84 11.58 10.5 11.99 10.5C12.4 10.5 12.74 10.84 12.74 11.25V12.5H13.99C14.4 12.5 14.74 12.84 14.74 13.25C14.74 13.66 14.4 14 13.99 14H12.74V15.25C12.74 15.66 12.4 16 11.99 16C11.58 16 11.24 15.66 11.24 15.25V14H9.98999ZM9.76999 5.75C9.77999 5.65 9.8 5.61 9.81 5.58C9.81 5.58 9.81 5.58 9.81 5.57C9.81 5.57 9.80998 5.57 9.81998 5.57C9.83998 5.57 9.88999 5.55 9.98999 5.53C10.2 5.5 10.49 5.5 10.99 5.5H12.99C13.48 5.5 13.78 5.5 13.99 5.53C14.09 5.54 14.14 5.56 14.16 5.57C14.16 5.57 14.16 5.57 14.17 5.57C14.17 5.57 14.17 5.57 14.17 5.58C14.17 5.6 14.19 5.65 14.21 5.75C14.23 5.92 14.24 6.15 14.24 6.5C14.18 6.5 14.11 6.5 14.05 6.5H9.94C9.88 6.5 9.80999 6.5 9.73999 6.5C9.73999 6.15 9.73999 5.92 9.76999 5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","add","plus","package","create","new","item","inventory","new-item","new-inventory","add-item","add-inventory","first-aid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-School v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["backpack","bag","school","items","carry","products","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M15 14H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 16V12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 8V8C14.9095 6.9095 14.3643 6.36425 13.7761 6.07278C12.657 5.51821 11.343 5.51821 10.2239 6.07278C9.63575 6.36425 9.0905 6.9095 8 8V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-School v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","school","item","products","inventory","supplies"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7602 13.9451C21.7602 13.8151 21.7402 13.5951 21.7202 13.4651C21.6602 13.0651 21.4602 12.6951 21.1702 12.4251C21.0702 12.3351 20.9602 12.2651 20.8602 12.1951C20.8602 12.1951 20.8402 12.1851 20.8302 12.1751L18.7402 10.7851C18.7402 10.0451 18.7302 9.4051 18.6602 8.8951C18.5802 8.2651 18.3902 7.7051 17.9302 7.2451C17.5002 6.8151 16.9802 6.6351 16.4002 6.5451C15.4202 5.5651 14.8002 4.9451 14.1002 4.5951C12.7702 3.9351 11.2102 3.9351 9.88023 4.5951C9.18023 4.9451 8.56023 5.5651 7.58023 6.5451C7.00023 6.6351 6.47024 6.8251 6.05024 7.2451C5.59024 7.7051 5.41024 8.2651 5.32024 8.8951C5.25024 9.4051 5.24023 10.0451 5.24023 10.7851L3.15023 12.1751C3.15023 12.1751 3.13024 12.1851 3.12024 12.1951C3.02024 12.2651 2.90023 12.3351 2.81023 12.4251C2.51023 12.6951 2.32023 13.0651 2.26023 13.4651C2.24023 13.5951 2.24023 13.7251 2.24023 13.8551V13.8851C2.24023 13.8851 2.24023 13.9251 2.24023 13.9451C2.24023 14.1651 2.24024 14.3951 2.29024 14.6051C2.44024 15.2451 2.94023 15.7351 3.58023 15.8951C3.79023 15.9451 4.02023 15.9451 4.24023 15.9451C4.26023 15.9451 4.28024 15.9451 4.30024 15.9451H5.25024C5.25024 16.5351 5.27023 17.0551 5.33023 17.4851C5.41023 18.1151 5.60023 18.6751 6.06023 19.1351C6.52023 19.5951 7.08024 19.7751 7.71024 19.8651C8.30024 19.9451 9.05024 19.9451 9.95024 19.9451H14.0502C14.9502 19.9451 15.7002 19.9451 16.2902 19.8651C16.9202 19.7851 17.4802 19.5951 17.9402 19.1351C18.4002 18.6751 18.5802 18.1151 18.6702 17.4851C18.7302 17.0551 18.7402 16.5351 18.7502 15.9451H19.7002C19.7002 15.9451 19.7402 15.9451 19.7602 15.9451C19.9802 15.9451 20.2102 15.9451 20.4202 15.8951C21.0602 15.7451 21.5502 15.2451 21.7102 14.6051C21.7602 14.3951 21.7602 14.1651 21.7602 13.9451C21.7602 13.9651 21.7602 13.9251 21.7602 13.9451ZM14.2402 18.1851V16.9351C14.2402 16.5251 14.5802 16.1851 14.9902 16.1851C15.4002 16.1851 15.7402 16.5251 15.7402 16.9351V18.1851C15.7402 18.2651 15.7202 18.3351 15.7002 18.4051C15.6002 18.7051 15.3302 18.9351 14.9902 18.9351C14.6502 18.9351 14.3902 18.7251 14.2902 18.4351C14.2602 18.3551 14.2402 18.2751 14.2402 18.1851ZM8.99023 12.4351H14.9902C15.4002 12.4351 15.7402 12.7751 15.7402 13.1851C15.7402 13.5951 15.4002 13.9351 14.9902 13.9351H8.99023C8.58023 13.9351 8.24023 13.5951 8.24023 13.1851C8.24023 12.7751 8.58023 12.4351 8.99023 12.4351ZM8.99023 18.9351C8.65023 18.9351 8.38024 18.7151 8.28024 18.4051C8.26024 18.3351 8.24023 18.2651 8.24023 18.1851V16.9351C8.24023 16.5251 8.58023 16.1851 8.99023 16.1851C9.40023 16.1851 9.74023 16.5251 9.74023 16.9351V18.1851C9.74023 18.2751 9.72024 18.3551 9.69024 18.4351C9.59024 18.7251 9.32023 18.9351 8.99023 18.9351ZM10.5502 5.9251C11.4602 5.4751 12.5302 5.4751 13.4402 5.9251C13.6502 6.0251 13.8602 6.1851 14.1402 6.4351C14.1102 6.4351 14.0802 6.4351 14.0502 6.4351H9.95024C9.95024 6.4351 9.89023 6.4351 9.85023 6.4351C10.1302 6.1851 10.3402 6.0351 10.5502 5.9251ZM4.00024 14.4251H3.94024C3.85024 14.4051 3.78023 14.3351 3.76023 14.2451C3.76023 14.2451 3.76023 14.2251 3.76023 14.1851C3.76023 14.1151 3.76023 14.0351 3.76023 13.8851C3.76023 13.8051 3.76023 13.7551 3.76023 13.7151C3.76023 13.6951 3.76023 13.6851 3.76023 13.6851C3.76023 13.6251 3.80024 13.5751 3.84024 13.5351C3.84024 13.5351 3.84024 13.5351 3.87024 13.5151C3.90024 13.4951 3.94023 13.4651 4.01023 13.4251L5.26023 12.5851V14.4351H4.31023C4.16023 14.4351 4.08023 14.4351 4.01023 14.4351L4.00024 14.4251ZM20.2402 14.1751V14.2351C20.2202 14.3251 20.1502 14.3951 20.0602 14.4151C20.0602 14.4151 20.0402 14.4151 20.0002 14.4151C19.9302 14.4151 19.8502 14.4151 19.7002 14.4151H18.7502V12.5651L20.0002 13.4051C20.0702 13.4551 20.1102 13.4751 20.1402 13.4951C20.1602 13.5051 20.1702 13.5151 20.1702 13.5151C20.2102 13.5551 20.2402 13.6051 20.2502 13.6651C20.2502 13.6651 20.2502 13.6751 20.2502 13.6951C20.2502 13.7351 20.2502 13.7751 20.2502 13.8651C20.2502 14.0151 20.2502 14.0951 20.2502 14.1651L20.2402 14.1751Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-School v2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","backpack","school","items","products","customer-order","takeaway","shipping","carry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 8V8C14.9095 6.9095 14.3643 6.36425 13.7761 6.07278C12.657 5.51821 11.343 5.51821 10.2239 6.07278C9.63575 6.36425 9.0905 6.9095 8 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16V12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-School v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["backpack","bag","school","items","package","delivery","pickup","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 16L19.6972 16C19.9787 16 20.1195 16 20.2356 15.9719C20.5995 15.8836 20.8836 15.5995 20.9719 15.2356C21 15.1195 21 14.9787 21 14.6972V14.6972C21 14.5395 21 14.4607 20.989 14.3869C20.9548 14.1588 20.8428 13.9495 20.6719 13.7946C20.6167 13.7445 20.5511 13.7007 20.4199 13.6132L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16L4.30278 16C4.02128 16 3.88054 16 3.76444 15.9719C3.4005 15.8836 3.11635 15.5995 3.02814 15.2356C3 15.1195 3 14.9787 3 14.6972V14.6972C3 14.5395 3 14.4607 3.01105 14.3869C3.04524 14.1588 3.15725 13.9495 3.32809 13.7946C3.38329 13.7445 3.4489 13.7007 3.58013 13.6132L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 8V8C14.9095 6.9095 14.3643 6.36425 13.7761 6.07278C12.657 5.51821 11.343 5.51821 10.2239 6.07278C9.63575 6.36425 9.0905 6.9095 8 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-School v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","case","briefcase","lunchbox","stock","inventory","sales","daily-sales","order","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11V11C20 12.1046 19.1046 13 18 13L6 13C4.89543 13 4 12.1046 4 11V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-School v3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","case","checkout","purchase","order","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 16H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.5 13H5.5C5.03406 13 4.80109 13 4.61732 12.9239C4.37229 12.8224 4.17761 12.6277 4.07612 12.3827C4 12.1989 4 11.9659 4 11.5C4 10.1022 4 9.40326 4.22836 8.85195C4.53284 8.11687 5.11687 7.53284 5.85195 7.22836C6.40326 7 7.10218 7 8.5 7H15.5C16.8978 7 17.5967 7 18.1481 7.22836C18.8831 7.53284 19.4672 8.11687 19.7716 8.85195C20 9.40326 20 10.1022 20 11.5C20 11.9659 20 12.1989 19.9239 12.3827C19.8224 12.6277 19.6277 12.8224 19.3827 12.9239C19.1989 13 18.9659 13 18.5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-School v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lunchbox","container","storage","box","takeout","package","order-ready","food-container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13.58C19.86 13.62 19.73 13.64 19.6 13.65C19.5 13.65 19.37 13.65 19.25 13.65C19.17 13.65 19.11 13.65 19.02 13.65H4.98C4.9 13.65 4.83 13.65 4.75 13.65C4.63 13.65 4.5 13.65 4.4 13.65C4.27 13.65 4.14 13.62 4 13.58C3.94 13.56 3.89 13.55 3.83 13.53C3.61 13.44 3.41 13.3 3.25 13.14C3.25 14.43 3.25 15.48 3.37 16.31C3.49 17.21 3.75 17.97 4.35 18.57C4.95 19.17 5.71 19.43 6.61 19.55C7.48 19.67 8.58 19.67 9.95 19.67H14.06C15.43 19.67 16.53 19.67 17.4 19.55C18.3 19.43 19.06 19.17 19.66 18.57C20.26 17.97 20.52 17.21 20.64 16.31C20.75 15.48 20.75 14.43 20.75 13.14C20.59 13.31 20.4 13.44 20.18 13.53C20.12 13.55 20.07 13.57 20.01 13.58H20ZM10 15.66H14C14.41 15.66 14.75 16 14.75 16.41C14.75 16.82 14.41 17.16 14 17.16H10C9.59 17.16 9.25 16.82 9.25 16.41C9.25 16 9.59 15.66 10 15.66Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.28 11.25C3.32 11.45 3.4 11.63 3.5 11.8C3.63 12.01 3.8 12.18 4 12.32C4.2 12.46 4.41 12.57 4.66 12.62C4.69 12.62 4.72 12.62 4.75 12.63C4.86 12.64 5.01 12.65 5.25 12.65H18.75C18.99 12.65 19.14 12.65 19.25 12.63C19.28 12.63 19.31 12.63 19.34 12.62C19.59 12.57 19.8 12.46 20 12.32C20.2 12.18 20.37 12.01 20.5 11.8C20.6 11.63 20.68 11.45 20.72 11.25C20.72 11.2 20.74 11.15 20.74 11.09C20.74 10.98 20.75 10.85 20.75 10.65C20.75 9.9 20.75 9.53 20.68 9.17C20.38 7.68 19.23 6.52 17.73 6.22C17.56 6.19 17.39 6.17 17.18 6.16C17.13 6.16 17.09 6.16 17.04 6.16C16.98 6.16 16.92 6.16 16.86 6.16C16.69 6.16 16.49 6.16 16.25 6.16H16.04C16.04 6.16 16.04 6.16 16.03 6.16H15.74C15.74 6 15.73 5.68 15.71 5.55C15.66 5.19 15.55 4.82 15.24 4.51C14.93 4.2 14.56 4.09 14.2 4.04C13.88 4 13.48 4 13.05 4H10.96C10.53 4 10.13 4 9.81 4.04C9.45 4.09 9.08 4.2 8.77 4.51C8.46 4.82 8.35 5.19 8.3 5.55C8.28 5.68 8.27 6.01 8.27 6.16H7.98C7.98 6.16 7.98 6.16 7.97 6.16H7.76C7.52 6.16 7.33 6.16 7.15 6.16C7.08 6.16 7.02 6.16 6.96 6.16C6.91 6.16 6.87 6.16 6.83 6.16C6.62 6.16 6.44 6.19 6.27 6.22C4.78 6.52 3.62 7.67 3.32 9.17C3.25 9.53 3.25 9.91 3.25 10.65C3.25 10.85 3.25 10.98 3.26 11.08C3.26 11.14 3.27 11.19 3.28 11.24V11.25ZM9.81 5.58C9.81 5.58 9.81 5.58 9.81 5.57C9.81 5.57 9.81 5.57 9.82 5.57C9.84 5.57 9.89 5.55 9.99 5.53C10.2 5.5 10.49 5.5 10.99 5.5H12.99C13.48 5.5 13.78 5.5 13.99 5.53C14.09 5.54 14.13 5.56 14.16 5.57C14.16 5.57 14.16 5.57 14.17 5.57C14.17 5.57 14.17 5.57 14.17 5.58C14.17 5.6 14.19 5.65 14.21 5.75C14.21 5.82 14.23 6.07 14.23 6.16H9.75C9.75 6.07 9.76 5.82 9.77 5.75C9.78 5.65 9.8 5.61 9.81 5.58Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-School v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","case","sales","reports","documents","day-end","summary","banking","deposit","cash-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 11V11C20 12.1046 19.1046 13 18 13L6 13C4.89543 13 4 12.1046 4 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-School v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","briefcase","reports","documents","day-end","settlement","close-batch","closing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11V11C20 11 20 11 20 11C20 12.6569 18.6569 14 17 14C17 14 17 14 17 14L7 14C7 14 7 14 7 14C5.34315 14 4 12.6569 4 11C4 11 4 11 4 11V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 7V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-School v4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","case","storage","items","documents","carry","delivery","pickup","takeout","order","products","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 7V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 13H5.5C5.03406 13 4.80109 13 4.61732 12.9239C4.37229 12.8224 4.17761 12.6277 4.07612 12.3827C4 12.1989 4 11.9659 4 11.5C4 10.1022 4 9.40326 4.22836 8.85195C4.53284 8.11687 5.11687 7.53284 5.85195 7.22836C6.40326 7 7.10218 7 8.5 7H15.5C16.8978 7 17.5967 7 18.1481 7.22836C18.8831 7.53284 19.4672 8.11687 19.7716 8.85195C20 9.40326 20 10.1022 20 11.5C20 11.9659 20 12.1989 19.9239 12.3827C19.8224 12.6277 19.6277 12.8224 19.3827 12.9239C19.1989 13 18.9659 13 18.5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-School v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","checkout","summary","order-summary","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2305 13.5H17.4805V14.75C17.4805 15.58 16.8105 16.25 15.9805 16.25C15.1505 16.25 14.4805 15.58 14.4805 14.75V13.5H9.48047V14.75C9.48047 15.58 8.81047 16.25 7.98047 16.25C7.15047 16.25 6.48047 15.58 6.48047 14.75V13.5H3.48047C3.39047 13.5 3.31047 13.5 3.23047 13.5V13.81C3.23047 15.18 3.23046 16.28 3.35046 17.15C3.47046 18.05 3.73047 18.81 4.33047 19.41C4.93047 20.01 5.69047 20.27 6.59047 20.39C7.46047 20.51 8.56047 20.51 9.93047 20.51H14.0405C15.4105 20.51 16.5105 20.51 17.3805 20.39C18.2805 20.27 19.0405 20.01 19.6405 19.41C20.2405 18.81 20.5005 18.05 20.6205 17.15C20.7405 16.28 20.7405 15.18 20.7405 13.81V13.51H19.2405L19.2305 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.2305 7.88C20.2005 7.83 20.0105 7.57 19.9805 7.52C19.8805 7.37 19.7705 7.23 19.6405 7.1C19.5105 6.97 19.3605 6.86 19.2105 6.75C19.1605 6.72 19.1205 6.69 19.0705 6.66C19.0005 6.61 18.9405 6.54 18.8605 6.5C18.0905 6.06 17.2205 6 15.6605 6C15.3105 4.29 13.8005 3 11.9905 3C10.1805 3 8.66047 4.29 8.32047 6C6.76047 6 5.89047 6.06 5.12047 6.5C5.04047 6.54 4.99048 6.61 4.91048 6.66C4.85048 6.7 4.80046 6.74 4.74046 6.79C4.41046 7.04 4.13047 7.33 3.90047 7.67C3.85047 7.74 3.90047 7.67 3.74046 7.88C3.24046 8.75 3.24046 9.75 3.24046 11.75V12.5H6.49046V12.25C6.49046 12.16 6.50048 12.08 6.52048 12C6.53048 11.91 6.56047 11.83 6.59047 11.75C6.70047 11.44 6.90047 11.18 7.17047 11C7.41047 10.84 7.69047 10.75 8.00047 10.75C8.31047 10.75 8.59048 10.84 8.83047 11C9.10047 11.18 9.30048 11.44 9.41048 11.75C9.44048 11.83 9.46047 11.91 9.48047 12C9.49047 12.08 9.51047 12.16 9.51047 12.25V12.5H14.5105V12.25C14.5105 12.16 14.5205 12.08 14.5405 12C14.5505 11.91 14.5805 11.83 14.6105 11.75C14.7205 11.44 14.9205 11.18 15.1905 11C15.4305 10.84 15.7105 10.75 16.0205 10.75C16.3305 10.75 16.6105 10.84 16.8505 11C17.1205 11.18 17.3205 11.44 17.4305 11.75C17.4605 11.83 17.4805 11.91 17.5005 12C17.5105 12.08 17.5305 12.16 17.5305 12.25V12.5H20.7805V11.75C20.7805 9.75 20.7305 8.75 20.2305 7.88ZM11.9805 4.5C12.9605 4.5 13.7805 5.13 14.0905 6H14.0705C14.0705 6 14.0505 6 14.0405 6H9.93047C9.93047 6 9.91047 6 9.90047 6H9.88046C10.1905 5.13 11.0105 4.5 11.9905 4.5H11.9805Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.73047 14.75V12.25C8.73047 12.16 8.71047 12.08 8.68047 12C8.65047 11.91 8.60047 11.82 8.53047 11.75C8.39047 11.6 8.20047 11.5 7.98047 11.5C7.76047 11.5 7.57047 11.6 7.43047 11.75C7.36047 11.82 7.31047 11.91 7.28047 12C7.25047 12.08 7.23047 12.16 7.23047 12.25V14.75C7.23047 15.16 7.57047 15.5 7.98047 15.5C8.39047 15.5 8.73047 15.16 8.73047 14.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.7305 14.75V12.25C16.7305 12.16 16.7105 12.08 16.6805 12C16.6505 11.91 16.6005 11.82 16.5305 11.75C16.3905 11.6 16.2005 11.5 15.9805 11.5C15.7605 11.5 15.5705 11.6 15.4305 11.75C15.3605 11.82 15.3105 11.91 15.2805 12C15.2505 12.08 15.2305 12.16 15.2305 12.25V14.75C15.2305 15.16 15.5705 15.5 15.9805 15.5C16.3905 15.5 16.7305 15.16 16.7305 14.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-School v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","item","package","delivery","pickup","satchel","case"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 11V11C20 11 20 11 20 11C20 12.6569 18.6569 14 17 14C17 14 17 14 17 14L7 14C7 14 7 14 7 14C5.34315 14 4 12.6569 4 11C4 11 4 11 4 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 7V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-School v5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","backpack","school","items","inventory","carry","supplies"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 17L10 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10V10C18 10.9319 18 11.3978 17.8478 11.7654C17.6448 12.2554 17.2554 12.6448 16.7654 12.8478C16.3978 13 15.9319 13 15 13L9 13C8.06812 13 7.60217 13 7.23463 12.8478C6.74458 12.6448 6.35523 12.2554 6.15224 11.7654C6 11.3978 6 10.9319 6 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L4 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L20 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-School v5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","backpack","school","items","products","supplies","accessories","merchandise","retail","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.5 13H9.5C8.09554 13 7.39331 13 6.88886 12.6629C6.67048 12.517 6.48298 12.3295 6.33706 12.1111C6 11.6067 6 10.9045 6 9.5C6 8.09554 6 7.39331 6.33706 6.88886C6.48298 6.67048 6.67048 6.48298 6.88886 6.33706C7.39331 6 8.09554 6 9.5 6H14.5C15.9045 6 16.6067 6 17.1111 6.33706C17.3295 6.48298 17.517 6.67048 17.6629 6.88886C18 7.39331 18 8.09554 18 9.5C18 10.9045 18 11.6067 17.6629 12.1111C17.517 12.3295 17.3295 12.517 17.1111 12.6629C16.6067 13 15.9045 13 14.5 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L4 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L20 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17L10 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-School v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["backpack","bag","items","school","travel","goods","merchandise","accessories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 13.7501H8.44215C8.03347 13.7501 7.75514 13.7502 7.51054 13.718C6.61975 13.6007 5.82944 13.1744 5.25 12.5496V16.052C5.24998 16.9505 5.24995 17.6998 5.32992 18.2945C5.41432 18.9223 5.59999 19.4891 6.05546 19.9446C6.51093 20.4001 7.07773 20.5857 7.70553 20.6701C8.3003 20.7501 9.04951 20.7501 9.94798 20.75H14.052C14.9505 20.7501 15.6997 20.7501 16.2945 20.6701C16.9223 20.5857 17.4891 20.4001 17.9445 19.9446C18.4 19.4891 18.5857 18.9223 18.6701 18.2945C18.7501 17.6997 18.75 16.9505 18.75 16.0521V12.5496C18.1706 13.1744 17.3803 13.6007 16.4895 13.718C16.2449 13.7502 15.9666 13.7501 15.5579 13.7501H15.5V14C15.5 14.8284 14.8284 15.5 14 15.5C13.1716 15.5 12.5 14.8284 12.5 14V13.7501H11.5V14C11.5 14.8284 10.8284 15.5 10 15.5C9.17157 15.5 8.5 14.8284 8.5 14V13.7501ZM10.052 17C9.63779 17 9.302 17.3358 9.302 17.75C9.302 18.1642 9.63778 18.5 10.052 18.5L14.052 18.5C14.4662 18.5 14.802 18.1642 14.802 17.75C14.802 17.3358 14.4662 17 14.052 17L10.052 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.3292 5.1646C8.31458 5.19384 8.30205 5.22358 8.29155 5.25364C8.1329 5.25652 7.98745 5.26163 7.85464 5.2707C7.53754 5.29233 7.23801 5.33897 6.94762 5.45926C6.27379 5.73837 5.73844 6.27372 5.45933 6.94755C5.33905 7.23794 5.29241 7.53746 5.27077 7.85456C5.24999 8.15917 5.24999 8.5302 5.25 8.97464V9.02518C5.24999 9.46963 5.24999 9.84068 5.27077 10.1453C5.29241 10.4624 5.33905 10.7619 5.45933 11.0523C5.73844 11.7261 6.2738 12.2615 6.94762 12.5406C7.23801 12.6609 7.53754 12.7075 7.85464 12.7292C8.04363 12.7421 8.25819 12.7469 8.5 12.7488V12C8.5 11.1716 9.17157 10.5 10 10.5C10.8284 10.5 11.5 11.1716 11.5 12V12.7499H12.5V12C12.5 11.1716 13.1716 10.5 14 10.5C14.8284 10.5 15.5 11.1716 15.5 12V12.7488C15.7418 12.7469 15.9564 12.7421 16.1454 12.7292C16.4625 12.7075 16.762 12.6609 17.0524 12.5406C17.7262 12.2615 18.2616 11.7261 18.5407 11.0523C18.661 10.7619 18.7076 10.4624 18.7292 10.1453C18.75 9.84068 18.75 9.46964 18.75 9.02518V8.97467C18.75 8.53021 18.75 8.15917 18.7292 7.85456C18.7076 7.53746 18.661 7.23794 18.5407 6.94755C18.2616 6.27372 17.7262 5.73837 17.0524 5.45926C16.762 5.33897 16.4625 5.29233 16.1454 5.2707C16.0126 5.26163 15.8671 5.25653 15.7085 5.25364C15.698 5.22358 15.6855 5.19384 15.6708 5.16459L15.2097 4.24231C15.0873 3.99737 14.9713 3.76544 14.8528 3.57913C14.7204 3.37111 14.553 3.16646 14.302 3.01137C14.0511 2.85627 13.7931 2.79801 13.5479 2.77265C13.3282 2.74994 13.0689 2.74997 12.7951 2.75L11.2049 2.75C10.9311 2.74997 10.6718 2.74994 10.4522 2.77265C10.2069 2.79801 9.94897 2.85627 9.69802 3.01137C9.44708 3.16646 9.27961 3.37111 9.14725 3.57913C9.0287 3.76544 8.91278 3.99736 8.79034 4.2423L8.3292 5.1646ZM13.882 4.94099L14.0365 5.24993H9.96358L10.1181 4.94099C10.2594 4.65826 10.3409 4.49731 10.4128 4.38438C10.445 4.33367 10.4657 4.30864 10.4766 4.29685C10.4818 4.29135 10.4846 4.28889 10.4854 4.28822L10.4866 4.28734L10.4879 4.28668C10.4889 4.28626 10.4924 4.28478 10.4996 4.28267C10.515 4.27813 10.5467 4.27088 10.6064 4.2647C10.7396 4.25093 10.92 4.25001 11.2361 4.25001L12.764 4.25C13.0801 4.25 13.2605 4.25093 13.3936 4.2647C13.4534 4.27088 13.485 4.27813 13.5004 4.28267C13.5077 4.28478 13.5111 4.28626 13.5121 4.28668L13.5134 4.28734L13.5146 4.28822C13.5154 4.28889 13.5183 4.29135 13.5234 4.29685C13.5344 4.30864 13.555 4.33367 13.5873 4.38438C13.6591 4.49731 13.7406 4.65826 13.882 4.94099Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 14.75C9.58579 14.75 9.25 14.4142 9.25 14V12C9.25 11.5858 9.58579 11.25 10 11.25C10.4142 11.25 10.75 11.5858 10.75 12V14C10.75 14.4142 10.4142 14.75 10 14.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 14.75C13.5858 14.75 13.25 14.4142 13.25 14V12C13.25 11.5858 13.5858 11.25 14 11.25C14.4142 11.25 14.75 11.5858 14.75 12V14C14.75 14.4142 14.4142 14.75 14 14.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.5 16.75C3.08579 16.75 2.75 16.4142 2.75 16L2.75 13C2.75 12.5858 3.08579 12.25 3.5 12.25C3.91421 12.25 4.25 12.5858 4.25 13L4.25 16C4.25 16.4142 3.91421 16.75 3.5 16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 16.75C20.0858 16.75 19.75 16.4142 19.75 16V13C19.75 12.5858 20.0858 12.25 20.5 12.25C20.9142 12.25 21.25 12.5858 21.25 13V16C21.25 16.4142 20.9142 16.75 20.5 16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-School v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","travel","package","delivery","carry","school","luggage","items","products","transport","ship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10V10C18 10.9319 18 11.3978 17.8478 11.7654C17.6448 12.2554 17.2554 12.6448 16.7654 12.8478C16.3978 13 15.9319 13 15 13L9 13C8.06812 13 7.60217 13 7.23463 12.8478C6.74458 12.6448 6.35523 12.2554 6.15224 11.7654C6 11.3978 6 10.9319 6 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L4 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17L10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6L14.5528 5.10557C14.2838 4.56766 14.1493 4.2987 13.9077 4.14935C13.666 4 13.3653 4 12.7639 4L11.2361 4C10.6347 4 10.334 4 10.0923 4.14935C9.85065 4.2987 9.71617 4.56766 9.44721 5.10557L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-School v6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["backpack","bag","school","items","carry","products","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0504 9.97119C19.4852 9.14276 20.2007 7.69575 19.6485 6.73919C19.0962 5.78262 17.4853 5.67871 16.0504 6.50713"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.59808 9.96387C4.1632 9.13544 3.4477 7.68842 3.99997 6.73186C4.55224 5.7753 6.16317 5.67138 7.59805 6.49981"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 19L10 17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.00002 11V11C6.00001 7.6863 8.68629 5 12 5V5C15.3137 5 18 7.68629 18 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11C7.47388 12.8412 9.61589 14 12 14C14.3841 14 16.5261 12.8412 18 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 11L18 13C18 15.8284 18 17.2426 17.1213 18.1213C17.1213 18.1213 17.1213 18.1213 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6.87868 18.1213 6.87868 18.1213 6.87868 18.1213C6 17.2426 6 15.8284 6 13L6 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-School v6-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["backpack","bag","school","inventory","supplies","delivery","pickup","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6485 6.73919C20.2007 7.69575 19.4852 9.14276 18.0504 9.97119L16.0504 6.50713C17.4853 5.67871 19.0962 5.78262 19.6485 6.73919Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.99997 6.73186C3.4477 7.68842 4.1632 9.13544 5.59808 9.96387L7.59805 6.49981C6.16317 5.67138 4.55224 5.7753 3.99997 6.73186Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C15.3137 5 18 7.68629 18 11L18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13L6.00002 11C6.00001 7.6863 8.68629 5 12 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M18 11L17.25 11V11L18 11ZM6.00002 11L6.75002 11V11L6.00002 11ZM18 13L18.75 13V13L18 13ZM6 13L5.25 13V13H6ZM6.87868 18.1213L6.34835 18.6516L6.34835 18.6516L6.87868 18.1213ZM17.1213 18.1213L17.6516 18.6516H17.6517L17.1213 18.1213ZM18.75 11C18.75 7.27208 15.7279 4.25 12 4.25V5.75C14.8995 5.75 17.25 8.10051 17.25 11L18.75 11ZM6.75002 11C6.75001 8.10051 9.10051 5.75 12 5.75V4.25C8.27208 4.25 5.25001 7.27208 5.25002 11L6.75002 11ZM18.75 13L18.75 11L17.25 11L17.25 13L18.75 13ZM6.75 13L6.75002 11L5.25002 11L5.25 13L6.75 13ZM5.25 13C5.25 14.393 5.24841 15.5132 5.36652 16.3918C5.48754 17.2919 5.74643 18.0497 6.34835 18.6516L7.40901 17.591C7.13225 17.3142 6.9518 16.9257 6.85315 16.1919C6.75159 15.4365 6.75 14.4354 6.75 13H5.25ZM12 18.25C10.5646 18.25 9.56347 18.2484 8.80812 18.1469C8.07434 18.0482 7.68577 17.8678 7.40901 17.591L6.34835 18.6516C6.95026 19.2536 7.70814 19.5125 8.60825 19.6335C9.48678 19.7516 10.607 19.75 12 19.75V18.25ZM17.25 13C17.25 14.4354 17.2484 15.4365 17.1469 16.1919C17.0482 16.9257 16.8678 17.3142 16.591 17.591L17.6517 18.6516C18.2536 18.0497 18.5125 17.2919 18.6335 16.3917C18.7516 15.5132 18.75 14.393 18.75 13L17.25 13ZM12 19.75C13.393 19.75 14.5132 19.7516 15.3917 19.6335C16.2919 19.5125 17.0497 19.2536 17.6516 18.6516L16.591 17.591C16.3142 17.8678 15.9257 18.0482 15.1919 18.1469C14.4365 18.2484 13.4354 18.25 12 18.25V19.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M10 19L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 11C7.47388 12.8412 9.61589 14 12 14C14.3841 14 16.5261 12.8412 18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bags-School v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lunch-box","container","school","bag","lunch","children","products","food","takeout","box","packed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.2274 5.21C17.5474 5.17 16.8074 5.33 16.0974 5.65C14.9574 4.78 13.5374 4.25 11.9974 4.25C10.4574 4.25 9.03743 4.77 7.89743 5.65C7.18743 5.32 6.44744 5.16 5.76744 5.21C4.95744 5.26 4.13743 5.61 3.69743 6.37C3.25743 7.13 3.36743 8.01 3.72743 8.74C4.04743 9.38 4.58743 9.97 5.27743 10.43C5.27743 10.52 5.27744 10.6 5.26744 10.69C5.49744 10.91 5.74743 11.11 5.99743 11.3C6.23743 11.48 6.48743 11.65 6.74743 11.81C8.23743 12.72 10.0374 13.26 11.9974 13.26C13.9574 13.26 15.7574 12.72 17.2474 11.81C17.5074 11.65 17.7574 11.48 17.9974 11.3C18.2574 11.11 18.4974 10.9 18.7274 10.69C18.7274 10.6 18.7274 10.52 18.7174 10.43C19.3974 9.97 19.9474 9.39 20.2674 8.74C20.6274 8.01 20.7374 7.13 20.2974 6.37C19.8574 5.61 19.0374 5.26 18.2274 5.21ZM5.62744 8.80001C5.38744 8.57001 5.19743 8.32001 5.07743 8.08001C4.85743 7.64001 4.88743 7.32001 4.99743 7.12001C5.10743 6.93001 5.37743 6.74001 5.86743 6.71001C6.11743 6.69001 6.40743 6.73001 6.71743 6.82001C6.24743 7.41001 5.87744 8.08001 5.62744 8.80001ZM18.9174 8.08013C18.7974 8.32013 18.6074 8.57013 18.3674 8.80013C18.1174 8.08013 17.7474 7.41013 17.2774 6.82013C17.5774 6.74013 17.8774 6.70013 18.1274 6.71013C18.6174 6.74013 18.8874 6.93013 18.9974 7.12013C19.1074 7.31013 19.1374 7.64013 18.9174 8.08013Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.2474 13.5301C15.6874 14.3101 13.8974 14.7601 11.9974 14.7601C10.0974 14.7601 8.30744 14.3101 6.74744 13.5301C6.48744 13.4001 6.23744 13.2601 5.99744 13.1101C5.73744 12.9501 5.48744 12.7901 5.24744 12.6101V13.0601C5.24744 14.4301 5.24743 15.5301 5.36743 16.4001C5.48743 17.3001 5.74744 18.0601 6.34744 18.6601C6.94744 19.2601 7.70744 19.5201 8.60744 19.6401C9.47744 19.7601 10.5774 19.7601 11.9474 19.7601H12.0574C13.4274 19.7601 14.5274 19.7601 15.3974 19.6401C16.2974 19.5201 17.0574 19.2601 17.6574 18.6601C18.2574 18.0601 18.5174 17.3001 18.6374 16.4001C18.7574 15.5301 18.7574 14.4301 18.7574 13.0601V12.6101C18.5174 12.7901 18.2674 12.9501 18.0074 13.1101C17.7674 13.2601 17.5174 13.4001 17.2574 13.5301H17.2474ZM10.7474 18.01C10.7474 18.1 10.7274 18.18 10.6974 18.25C10.5974 18.54 10.3274 18.76 9.99744 18.76C9.64744 18.76 9.37745 18.52 9.28745 18.2C9.26745 18.14 9.24744 18.08 9.24744 18.01V17.01C9.24744 16.6 9.58744 16.26 9.99744 16.26C10.4074 16.26 10.7474 16.6 10.7474 17.01V18.01ZM14.7474 18.01C14.7474 18.08 14.7274 18.14 14.7074 18.2C14.6174 18.52 14.3374 18.76 13.9974 18.76C13.6674 18.76 13.3974 18.55 13.2974 18.25C13.2674 18.17 13.2474 18.09 13.2474 18.01V17.01C13.2474 16.6 13.5874 16.26 13.9974 16.26C14.4074 16.26 14.7474 16.6 14.7474 17.01V18.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-School v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["bear","customer","account","profile","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.59808 9.96387C4.1632 9.13544 3.4477 7.68842 3.99997 6.73186C4.55224 5.7753 6.16317 5.67138 7.59805 6.49981"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 19L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.00002 11V11C6.00001 7.6863 8.68629 5 12 5V5C15.3137 5 18 7.68629 18 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11C7.47388 12.8412 9.61589 14 12 14C14.3841 14 16.5261 12.8412 18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 11L18 13C18 15.8284 18 17.2426 17.1213 18.1213C17.1213 18.1213 17.1213 18.1213 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6.87868 18.1213 6.87868 18.1213 6.87868 18.1213C6 17.2426 6 15.8284 6 13L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.0504 9.97119C19.4852 9.14276 20.2007 7.69575 19.6485 6.73919C19.0962 5.78262 17.4853 5.67871 16.0504 6.50713"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-school-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","backpack","items","products","merchandise","package","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7L8.0883 6.73509C8.52832 5.41505 8.74832 4.75503 9.2721 4.37752C9.79587 4 10.4916 4 11.883 4H12.117C13.5084 4 14.2041 4 14.7279 4.37752C15.2517 4.75503 15.4717 5.41505 15.9117 6.73509L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H12H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 15L4 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 15L20 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-school-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","school","item","products","inventory","belongings","luggage","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.94 7.57C17.48 7.11 16.92 6.93 16.29 6.84C16.12 6.82 15.93 6.8 15.74 6.79C15.74 6.64 15.74 6.49 15.72 6.36C15.7 6.04 15.65 5.74 15.53 5.45C15.25 4.78 14.72 4.24 14.04 3.96C13.75 3.84 13.45 3.79 13.13 3.77C12.83 3.75 12.45 3.75 12.01 3.75H11.96C11.52 3.75 11.14 3.75 10.84 3.77C10.52 3.79 10.22 3.84 9.93 3.96C9.26 4.24 8.72 4.77 8.44 5.45C8.32 5.74 8.27 6.04 8.25 6.36C8.25 6.49 8.24 6.63 8.23 6.79C8.04 6.8 7.85 6.82 7.68 6.84C7.05 6.92 6.49 7.11 6.03 7.57C5.57 8.03 5.39 8.59 5.3 9.22C5.22 9.81 5.22 10.56 5.22 11.46V15.56C5.22 16.46 5.22 17.21 5.3 17.8C5.38 18.43 5.57 18.99 6.03 19.45C6.49 19.91 7.05 20.09 7.68 20.18C8.27 20.26 9.02 20.25 9.92 20.25H14.02C14.92 20.25 15.67 20.26 16.26 20.18C16.89 20.1 17.45 19.91 17.91 19.45C18.37 18.99 18.55 18.43 18.64 17.8C18.72 17.21 18.72 16.46 18.72 15.56V11.46C18.72 10.56 18.72 9.81 18.64 9.22C18.56 8.59 18.37 8.03 17.91 7.57H17.94ZM14.25 18.26V17.01C14.25 16.6 14.59 16.26 15 16.26C15.41 16.26 15.75 16.6 15.75 17.01V18.26C15.75 18.44 15.68 18.61 15.57 18.74C15.43 18.9 15.23 19.01 15 19.01C14.77 19.01 14.59 18.91 14.45 18.76C14.33 18.63 14.25 18.45 14.25 18.26ZM9 11.76H15C15.41 11.76 15.75 12.1 15.75 12.51C15.75 12.92 15.41 13.26 15 13.26H9C8.59 13.26 8.25 12.92 8.25 12.51C8.25 12.1 8.59 11.76 9 11.76ZM9 19.01C8.77 19.01 8.57 18.9 8.43 18.74C8.32 18.61 8.25 18.45 8.25 18.26V17.01C8.25 16.6 8.59 16.26 9 16.26C9.41 16.26 9.75 16.6 9.75 17.01V18.26C9.75 18.45 9.67 18.63 9.55 18.76C9.41 18.91 9.22 19.01 9 19.01ZM9.77 6.47C9.79 6.23 9.82 6.11 9.85 6.03C9.98 5.72 10.22 5.48 10.53 5.35C10.61 5.32 10.72 5.29 10.97 5.27C11.22 5.25 11.54 5.25 12.01 5.25C12.48 5.25 12.81 5.25 13.05 5.27C13.29 5.29 13.41 5.32 13.49 5.35C13.8 5.48 14.04 5.72 14.17 6.03C14.2 6.11 14.23 6.22 14.25 6.47C14.25 6.56 14.25 6.66 14.26 6.76C14.19 6.76 14.13 6.76 14.07 6.76H9.95C9.88 6.76 9.82 6.76 9.76 6.76C9.76 6.65 9.76 6.55 9.77 6.47Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.5 10.77C3.09 10.77 2.75 11.11 2.75 11.52V15.52C2.75 15.93 3.09 16.27 3.5 16.27C3.91 16.27 4.25 15.93 4.25 15.52V11.52C4.25 11.11 3.91 10.77 3.5 10.77Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.5 10.77C20.09 10.77 19.75 11.11 19.75 11.52V15.52C19.75 15.93 20.09 16.27 20.5 16.27C20.91 16.27 21.25 15.93 21.25 15.52V11.52C21.25 11.11 20.91 10.77 20.5 10.77Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-school-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","backpack","school","carry","luggage","items","products","checkout","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 7V7C9 6.06812 9 5.60218 9.15224 5.23463C9.35523 4.74458 9.74458 4.35523 10.2346 4.15224C10.6022 4 11.0681 4 12 4V4C12.9319 4 13.3978 4 13.7654 4.15224C14.2554 4.35523 14.6448 4.74458 14.8478 5.23463C15 5.60218 15 6.06812 15 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 15L4 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 15L20 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-school": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","school","item","order","package","delivery","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7L8.0883 6.73509C8.52832 5.41505 8.74832 4.75503 9.2721 4.37752C9.79587 4 10.4916 4 11.883 4H12.117C13.5084 4 14.2041 4 14.7279 4.37752C15.2517 4.75503 15.4717 5.41505 15.9117 6.73509L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 19L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 19L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 15L4 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 15L20 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-smile-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping-bag","package","delivery","takeaway","carry-out","order","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15L15 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 20L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12L9 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 17L19 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-smile-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","backpack","delivery","order","package","carry","store","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.6617 6.83646L14.853 6.7169C14.9263 6.67104 14.963 6.64811 14.9907 6.62806C15.4667 6.2832 15.5441 5.60414 15.1578 5.16108C15.1353 5.13531 15.1047 5.10471 15.0435 5.04353C14.8438 4.8438 14.7439 4.74393 14.6545 4.66463C13.1399 3.32093 10.8601 3.32093 9.34546 4.66463C9.25607 4.74393 9.1562 4.8438 8.95647 5.04353C8.89529 5.10471 8.86469 5.13531 8.84222 5.16108C8.45594 5.60414 8.53328 6.2832 9.0093 6.62806C9.03698 6.64811 9.07366 6.67104 9.14702 6.71689L9.14705 6.7169L9.33834 6.83646L9.33835 6.83647C9.8611 7.16319 10.1225 7.32655 10.384 7.44206C11.4134 7.89666 12.5866 7.89666 13.616 7.44206C13.8775 7.32655 14.1389 7.16318 14.6617 6.83646Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16V10C5.79731 8.37849 5.69597 7.56773 6.04622 6.97832C6.174 6.76328 6.34098 6.57412 6.53851 6.42065C7.07993 6 7.897 6 9.53113 6H15.2384C16.3263 6 16.8703 6 17.2637 6.17818C17.8614 6.44894 18.2883 6.99571 18.406 7.64128C18.4835 8.06612 18.3515 8.59383 18.0877 9.64924L18.0877 9.64929C18.0598 9.76098 18.0458 9.81683 18.0351 9.87321C18.0189 9.95853 18.0083 10.0448 18.0033 10.1315C18 10.1888 18 10.2464 18 10.3616V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 12L9 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 20L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-smile": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","backpack","school","travel","delivery","parcel","shipment","package","order","carry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H7C6.05719 10 5.58579 10 5.29289 9.70711C5 9.41421 5 8.94281 5 8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H17C17.9428 6 18.4142 6 18.7071 6.29289C19 6.58579 19 7.05719 19 8C19 8.94281 19 9.41421 18.7071 9.70711C18.4142 10 17.9428 10 17 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 20L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12L9 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 20L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 12L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6V6C14.9095 4.9095 14.3643 4.36425 13.7761 4.07278C12.657 3.51821 11.343 3.51821 10.2239 4.07278C9.63575 4.36425 9.0905 4.9095 8 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 17L19.6972 17C19.9787 17 20.1195 17 20.2356 16.9719C20.5995 16.8836 20.8836 16.5995 20.9719 16.2356C21 16.1195 21 15.9787 21 15.6972V15.6972C21 15.5395 21 15.4607 20.989 15.3869C20.9548 15.1588 20.8428 14.9495 20.6719 14.7946C20.6167 14.7445 20.5511 14.7007 20.4199 14.6132L18 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17L4.30278 17C4.02128 17 3.88054 17 3.76444 16.9719C3.4005 16.8836 3.11635 16.5995 3.02814 16.2356C3 16.1195 3 15.9787 3 15.6972V15.6972C3 15.5395 3 15.4607 3.01105 15.3869C3.04524 15.1588 3.15725 14.9495 3.32809 14.7946C3.38329 14.7445 3.4489 14.7007 3.58013 14.6132L6 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-smile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["backpack","bag","delivery","shipping","carryout","takeout","pickup","orders","packaged-orders","ready-orders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.50014 11.75H5.25014L5.25014 12.5986L3.13814 14.0066C3.03359 14.0761 2.92246 14.15 2.8243 14.2391C2.52532 14.5103 2.32931 14.8766 2.26948 15.2758C2.24983 15.4069 2.24998 15.5403 2.25012 15.6659L2.25014 15.6972L2.25007 15.7555C2.24967 15.9758 2.24926 16.2054 2.29939 16.4123C2.45376 17.0491 2.95102 17.5464 3.5879 17.7008C3.79473 17.7509 4.02435 17.7505 4.24468 17.7501L4.30292 17.75H5.27942C5.29106 17.9439 5.30733 18.1254 5.33005 18.2945C5.41446 18.9223 5.60013 19.4891 6.0556 19.9445C6.51107 20.4 7.07787 20.5857 7.70566 20.6701C8.30044 20.75 9.04968 20.75 9.94815 20.75H14.0522C14.9506 20.75 15.6998 20.75 16.2946 20.6701C16.9224 20.5857 17.4892 20.4 17.9447 19.9445C18.4002 19.4891 18.5858 18.9223 18.6702 18.2945C18.693 18.1254 18.7092 17.9439 18.7209 17.75H19.6974L19.7556 17.7501C19.9759 17.7505 20.2055 17.7509 20.4124 17.7008C21.0493 17.5464 21.5465 17.0491 21.7009 16.4123C21.751 16.2054 21.7506 15.9758 21.7502 15.7555L21.7501 15.6972L21.7502 15.6659C21.7503 15.5403 21.7505 15.4069 21.7308 15.2758C21.671 14.8766 21.475 14.5103 21.176 14.2391C21.0778 14.15 20.9667 14.0761 20.8621 14.0066L18.7501 12.5986V11.75L16.5001 11.75V12C16.5001 12.8284 15.8286 13.5 15.0001 13.5C14.1717 13.5 13.5001 12.8284 13.5001 12V11.75H10.5001V12C10.5001 12.8284 9.82856 13.5 9.00014 13.5C8.17171 13.5 7.50014 12.8284 7.50014 12V11.75ZM3.99629 15.2373L5.25014 14.4014L5.25017 16.25H4.30292C4.156 16.25 4.06854 16.2499 4.00278 16.2471C3.96131 16.2454 3.94339 16.2431 3.93899 16.2424C3.84985 16.2199 3.78022 16.1503 3.75774 16.0612C3.75708 16.0568 3.75473 16.0389 3.75302 15.9974C3.75029 15.9316 3.75014 15.8442 3.75014 15.6972C3.75014 15.6143 3.75021 15.5674 3.75122 15.5319C3.75185 15.5096 3.75269 15.5002 3.75295 15.4978C3.76154 15.441 3.78943 15.3889 3.83193 15.3503C3.83375 15.3487 3.8411 15.3428 3.85931 15.3299C3.88834 15.3094 3.9273 15.2833 3.99629 15.2373ZM3.93899 16.2424L3.94125 16.243L3.93786 16.2422L3.93899 16.2424ZM19.6974 16.25H18.7501L18.7501 14.4014L20.004 15.2373C20.073 15.2833 20.1119 15.3094 20.141 15.3299C20.1592 15.3428 20.1665 15.3487 20.1684 15.3503C20.2109 15.3889 20.2387 15.441 20.2473 15.4978C20.2476 15.5002 20.2484 15.5096 20.2491 15.5319C20.2501 15.5675 20.2501 15.6143 20.2501 15.6972C20.2501 15.8442 20.25 15.9316 20.2473 15.9974C20.2456 16.0388 20.2432 16.0568 20.2425 16.0612C20.2201 16.1503 20.1504 16.2199 20.0613 16.2424C20.0569 16.2431 20.039 16.2454 19.9975 16.2471C19.9317 16.2499 19.8443 16.25 19.6974 16.25ZM9.00014 14.6499C8.58592 14.6499 8.25014 14.9857 8.25014 15.3999C8.25014 15.8141 8.58592 16.1499 9.00014 16.1499H15.0001C15.4144 16.1499 15.7501 15.8141 15.7501 15.3999C15.7501 14.9857 15.4144 14.6499 15.0001 14.6499H9.00014ZM9.00014 17.25C9.41435 17.25 9.75014 17.5858 9.75014 18V18.75C9.75014 19.1642 9.41435 19.5 9.00014 19.5C8.58592 19.5 8.25014 19.1642 8.25014 18.75V18C8.25014 17.5858 8.58592 17.25 9.00014 17.25ZM15.0001 17.25C15.4144 17.25 15.7501 17.5858 15.7501 18V18.75C15.7501 19.1642 15.4144 19.5 15.0001 19.5C14.5859 19.5 14.2501 19.1642 14.2501 18.75V18C14.2501 17.5858 14.5859 17.25 15.0001 17.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1092 3.40065C12.7803 2.7421 11.22 2.7421 9.89107 3.40065C9.21693 3.73471 8.61083 4.32848 7.68941 5.24988L6.95539 5.24988C6.52258 5.24983 6.12575 5.24978 5.80294 5.29318C5.44746 5.34098 5.07173 5.45342 4.76271 5.76245C4.45368 6.07147 4.34124 6.4472 4.29344 6.80268C4.25004 7.12549 4.25009 7.52232 4.25014 7.95514V8.04463C4.25009 8.47745 4.25004 8.87428 4.29344 9.19709C4.34124 9.55257 4.45368 9.9283 4.76271 10.2373C5.07173 10.5463 5.44746 10.6588 5.80294 10.7066C6.12575 10.75 6.52258 10.7499 6.95539 10.7499L7.50014 10.7499V10C7.50014 9.17157 8.17171 8.5 9.00014 8.5C9.82856 8.5 10.5001 9.17157 10.5001 10V10.7499L13.5001 10.7499V10C13.5001 9.17157 14.1717 8.5 15.0001 8.5C15.8286 8.5 16.5001 9.17157 16.5001 10V10.7499H17.0449C17.4777 10.7499 17.8745 10.75 18.1974 10.7066C18.5528 10.6588 18.9286 10.5463 19.2376 10.2373C19.5466 9.9283 19.659 9.55257 19.7068 9.19709C19.7502 8.87428 19.7502 8.47745 19.7501 8.04464V7.95514C19.7502 7.52233 19.7502 7.12549 19.7068 6.80268C19.659 6.4472 19.5466 6.07147 19.2376 5.76245C18.9286 5.45342 18.5528 5.34098 18.1974 5.29318C17.8745 5.24978 17.4777 5.24983 17.0449 5.24988L16.3109 5.24988C15.3895 4.32848 14.7834 3.73471 14.1092 3.40065ZM14.1484 5.24988H9.85193C10.1342 5.00085 10.3449 4.84985 10.5571 4.74468C11.4664 4.29409 12.5339 4.29409 13.4432 4.74468C13.6554 4.84985 13.8661 5.00085 14.1484 5.24988Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00014 9.25C9.41435 9.25 9.75014 9.58579 9.75014 10V12C9.75014 12.4142 9.41435 12.75 9.00014 12.75C8.58592 12.75 8.25014 12.4142 8.25014 12V10C8.25014 9.58579 8.58592 9.25 9.00014 9.25ZM15.0001 9.25C15.4144 9.25 15.7501 9.58579 15.7501 10V12C15.7501 12.4142 15.4144 12.75 15.0001 12.75C14.5859 12.75 14.2501 12.4142 14.2501 12V10C14.2501 9.58579 14.5859 9.25 15.0001 9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","suitcase","travel","luggage","briefcase","case","items","packing","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 13H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 7L14.8944 6.78885C14.5637 6.12731 14.3983 5.79654 14.149 5.55726C13.9449 5.36128 13.7015 5.21085 13.4349 5.11591C13.1094 5 12.7396 5 12 5V5C11.2604 5 10.8906 5 10.5651 5.11591C10.2985 5.21085 10.0551 5.36128 9.85096 5.55726C9.60173 5.79654 9.43634 6.12731 9.10557 6.78885L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","bag","suitcase","travel","delivery","shipment","order","carry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L14.8944 6.78885C14.5637 6.12731 14.3983 5.79654 14.149 5.55726C13.9449 5.36128 13.7015 5.21085 13.4349 5.11591C13.1094 5 12.7396 5 12 5V5C11.2604 5 10.8906 5 10.5651 5.11591C10.2985 5.21085 10.0551 5.36128 9.85096 5.55726C9.60173 5.79654 9.43634 6.12731 9.10557 6.78885L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","suitcase","travel","luggage","ship","delivery","package","dispatch","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 12.26C7.25 11.85 7.59 11.51 8 11.51C8.41 11.51 8.75 11.85 8.75 12.26V12.51H15.25V12.26C15.25 11.85 15.59 11.51 16 11.51C16.41 11.51 16.75 11.85 16.75 12.26V12.51H20.75C20.75 11.46 20.73 10.58 20.63 9.87C20.51 8.97 20.25 8.21 19.65 7.61C19.05 7.01 18.29 6.75 17.39 6.63C16.9 6.56 16.33 6.54 15.7 6.52C15.69 6.49 15.69 6.45 15.67 6.42L15.56 6.21C15.56 6.21 15.53 6.14 15.51 6.11C15.23 5.55 15.01 5.1 14.66 4.77C14.38 4.5 14.04 4.29 13.68 4.16C13.23 4 12.73 4 12.11 4C12.07 4 12.04 4 12 4C11.96 4 11.93 4 11.89 4C11.26 4 10.77 4 10.32 4.16C9.95 4.29 9.62 4.5 9.34 4.77C9 5.1 8.77 5.54 8.49 6.11C8.47 6.14 8.46 6.18 8.44 6.21L8.33 6.42C8.33 6.42 8.31 6.48 8.3 6.52C7.66 6.53 7.09 6.56 6.61 6.63C5.71 6.75 4.95 7.01 4.35 7.61C3.75 8.21 3.49 8.97 3.37 9.87C3.27 10.58 3.26 11.46 3.25 12.51H7.25V12.26ZM10.37 5.86C10.5 5.74 10.65 5.64 10.82 5.58C10.99 5.52 11.21 5.51 12 5.51C12.79 5.51 13.01 5.52 13.18 5.58C13.35 5.64 13.5 5.73 13.63 5.86C13.74 5.96 13.83 6.11 14.03 6.51H9.96C10.17 6.11 10.26 5.96 10.36 5.86H10.37Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.75 14.26C16.75 14.67 16.41 15.01 16 15.01C15.59 15.01 15.25 14.67 15.25 14.26V14.01H8.75V14.26C8.75 14.67 8.41 15.01 8 15.01C7.59 15.01 7.25 14.67 7.25 14.26V14.01H3.25C3.25 15.06 3.27 15.94 3.37 16.65C3.49 17.55 3.75 18.31 4.35 18.91C4.95 19.51 5.71 19.77 6.61 19.89C7.48 20.01 8.58 20.01 9.95 20.01H14.06C15.43 20.01 16.53 20.01 17.4 19.89C18.3 19.77 19.06 19.51 19.66 18.91C20.26 18.31 20.52 17.55 20.64 16.65C20.74 15.94 20.74 15.06 20.75 14.01H16.76V14.26H16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","suitcase","travel","sales","reports","documents","case","business","accounting","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L14.8944 6.78885C14.5637 6.12731 14.3983 5.79654 14.149 5.55726C13.9449 5.36128 13.7015 5.21085 13.4349 5.11591C13.1094 5 12.7396 5 12 5V5C11.2604 5 10.8906 5 10.5651 5.11591C10.2985 5.21085 10.0551 5.36128 9.85096 5.55726C9.60173 5.79654 9.43634 6.12731 9.10557 6.78885L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-Suitcase v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["briefcase","bag","suitcase","portfolio","documents","case","sales","business","reports","transactions","summary","day-end","cash-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","bag","suitcase","travel","delivery","shipment","transport","package","case","luggage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","suitcase","bag","sales","reports","documents","business","deals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.75 12.5V13.75C16.75 14.16 16.41 14.5 16 14.5C15.59 14.5 15.25 14.16 15.25 13.75V12.5H8.75V13.75C8.75 14.16 8.41 14.5 8 14.5C7.59 14.5 7.25 14.16 7.25 13.75V12.5H3.25C3.25 12.57 3.25 12.63 3.25 12.7V12.81C3.25 14.18 3.25 15.28 3.37 16.15C3.49 17.05 3.75 17.81 4.35 18.41C4.95 19.01 5.71 19.27 6.61 19.39C7.48 19.51 8.58 19.51 9.95 19.51H14.06C15.43 19.51 16.53 19.51 17.4 19.39C18.3 19.27 19.06 19.01 19.66 18.41C20.26 17.81 20.52 17.05 20.64 16.15C20.76 15.28 20.75 14.18 20.75 12.81V12.7C20.75 12.63 20.75 12.57 20.75 12.5H16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.76 11H20.75C20.74 10.38 20.7 9.83 20.64 9.36C20.52 8.46 20.26 7.7 19.66 7.1C19.06 6.5 18.3 6.24 17.4 6.12C16.93 6.06 16.38 6.03 15.76 6.02V5.71C15.76 5.28 15.76 4.88 15.72 4.56C15.67 4.2 15.56 3.83 15.25 3.52C14.94 3.21 14.57 3.1 14.21 3.05C13.87 3 13.48 3 13.04 3H10.95C10.52 3 10.12 3 9.8 3.04C9.44 3.09 9.07 3.2 8.76 3.51C8.45 3.82 8.34 4.19 8.29 4.55C8.25 4.87 8.25 5.27 8.25 5.7V6.01C7.63 6.02 7.08 6.05 6.61 6.11C5.71 6.23 4.95 6.49 4.35 7.09C3.75 7.69 3.49 8.45 3.37 9.35C3.31 9.82 3.28 10.37 3.27 10.99H4.77L4.76 11ZM9.75 5.75C9.75 5.26 9.75 4.96 9.78 4.75C9.79 4.65 9.81 4.61 9.82 4.58C9.82 4.58 9.82 4.58 9.82 4.57C9.82 4.57 9.82 4.57 9.83 4.57C9.85 4.57 9.9 4.55 10 4.53C10.21 4.5 10.5 4.5 11 4.5H13C13.49 4.5 13.79 4.5 14 4.53C14.1 4.54 14.14 4.56 14.17 4.57C14.17 4.57 14.17 4.57 14.18 4.57C14.18 4.57 14.18 4.57 14.18 4.58C14.18 4.6 14.2 4.65 14.22 4.75C14.25 4.96 14.25 5.25 14.25 5.75V6C14.18 6 14.12 6 14.05 6H9.94C9.87 6 9.81 6 9.74 6V5.75H9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","case","bag","report","sales","data","summary","tools","business","work"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["briefcase","bag","suitcase","reports","documents","sales","day-end","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11C4.91697 13.3003 8.15106 15 12 15C15.8489 15 19.083 13.3003 20 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8L15 7C15 6.06812 15 5.60217 14.8478 5.23463C14.6448 4.74458 14.2554 4.35523 13.7654 4.15224C13.3978 4 12.9319 4 12 4V4C11.0681 4 10.6022 4 10.2346 4.15224C9.74458 4.35523 9.35523 4.74458 9.15224 5.23463C9 5.60218 9 6.06812 9 7L9 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","briefcase","suitcase","shipping","delivery","package","case","luggage","travel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 7C15 6.06812 15 5.60217 14.8478 5.23463C14.6448 4.74458 14.2554 4.35523 13.7654 4.15224C13.3978 4 12.9319 4 12 4V4C11.0681 4 10.6022 4 10.2346 4.15224C9.74458 4.35523 9.35523 4.74458 9.15224 5.23463C9 5.60218 9 6.06812 9 7L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 11C4.91697 13.3003 8.15106 15 12 15C15.8489 15 19.083 13.3003 20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bags-Suitcase v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","suitcase","briefcase","travel","deliveries","shipping","orders","reports","summary","end-of-day","banking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.75 12.36C20.52 12.55 20.25 12.73 19.99 12.91C19.75 13.07 19.5 13.21 19.24 13.35C18.93 13.52 18.6 13.67 18.27 13.81C17.79 14.01 17.28 14.19 16.74 14.34V14.75C16.74 15.16 16.4 15.5 15.99 15.5C15.58 15.5 15.24 15.16 15.24 14.75V14.7C14.2 14.9 13.1 15 11.99 15C10.88 15 9.78001 14.89 8.74001 14.7V14.75C8.74001 15.16 8.40001 15.5 7.99001 15.5C7.58001 15.5 7.24001 15.16 7.24001 14.75V14.34C6.71001 14.19 6.20001 14.01 5.71001 13.81C5.37001 13.67 5.05001 13.51 4.74001 13.34C4.48001 13.2 4.23001 13.06 3.99001 12.9C3.73001 12.73 3.48 12.55 3.25 12.35C3.25 12.77 3.25 13.21 3.25 13.69V13.8C3.25 15.17 3.25001 16.27 3.37001 17.14C3.49001 18.04 3.75001 18.8 4.35001 19.4C4.95001 20 5.71 20.26 6.61 20.38C7.48 20.5 8.58001 20.5 9.95001 20.5H14.06C15.43 20.5 16.53 20.5 17.4 20.38C18.3 20.26 19.06 20 19.66 19.4C20.26 18.8 20.52 18.04 20.64 17.14C20.76 16.27 20.75 15.17 20.75 13.8V13.69C20.75 13.21 20.75 12.77 20.75 12.35V12.36Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.77 11.62C5.21 11.91 5.71 12.18 6.3 12.42C6.6 12.55 6.92 12.66 7.25 12.77V12.75C7.25 12.34 7.59 12 8 12C8.41 12 8.75 12.34 8.75 12.75V13.17C9.78 13.38 10.88 13.5 12 13.5C13.12 13.5 14.22 13.38 15.25 13.17V12.75C15.25 12.34 15.59 12 16 12C16.41 12 16.75 12.34 16.75 12.75V12.77C17.08 12.66 17.4 12.55 17.7 12.42C18.28 12.18 18.79 11.91 19.23 11.62C19.5 11.44 19.74 11.25 19.95 11.06C20.23 10.81 20.46 10.55 20.62 10.3C20.5 9.43 20.24 8.69 19.65 8.1C19.05 7.5 18.29 7.24 17.39 7.12C16.92 7.06 16.37 7.03 15.75 7.02V6.73C15.75 6.29 15.75 5.91 15.73 5.61C15.71 5.29 15.66 4.99 15.54 4.7C15.26 4.03 14.73 3.49 14.05 3.21C13.76 3.09 13.46 3.04 13.14 3.02C12.83 3 12.46 3 12.01 3H11.96C11.52 3 11.15 3 10.84 3.02C10.52 3.04 10.22 3.09 9.93001 3.21C9.26001 3.49 8.72 4.02 8.44 4.7C8.32 4.99 8.27 5.29 8.25 5.61C8.23 5.91 8.23001 6.29 8.23001 6.73V7.02C7.61001 7.03 7.06001 7.06 6.59001 7.12C5.69001 7.24 4.93 7.5 4.33 8.1C3.74 8.69 3.49 9.43 3.36 10.3C3.53 10.56 3.76 10.82 4.03 11.06C4.24 11.25 4.48 11.44 4.75 11.62H4.77ZM9.74001 6.75C9.74001 6.27 9.74001 5.95 9.76001 5.71C9.78001 5.47 9.81001 5.35 9.84001 5.27C9.97001 4.96 10.21 4.72 10.52 4.59C10.6 4.56 10.71 4.53 10.96 4.51C11.21 4.49 11.53 4.49 12 4.49C12.47 4.49 12.8 4.49 13.04 4.51C13.28 4.53 13.4 4.56 13.48 4.59C13.79 4.72 14.03 4.96 14.16 5.27C14.19 5.35 14.22 5.46 14.24 5.71C14.26 5.96 14.26 6.28 14.26 6.75V7C14.19 7 14.13 7 14.07 7H9.96001C9.89001 7 9.83001 7 9.76001 7V6.75H9.74001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","briefcase","portfolio","case","report","business","sales","delivery","ship","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 15L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 15L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 11C4.91697 13.3003 8.15106 15 12 15C15.8489 15 19.083 13.3003 20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8L15 7C15 6.06812 15 5.60217 14.8478 5.23463C14.6448 4.74458 14.2554 4.35523 13.7654 4.15224C13.3978 4 12.9319 4 12 4V4C11.0681 4 10.6022 4 10.2346 4.15224C9.74458 4.35523 9.35523 4.74458 9.15224 5.23463C9 5.60218 9 6.06812 9 7L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["briefcase","bag","case","reports","sales","summary","documents","work"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11C4.91697 12.1502 8.15106 13 12 13C15.8489 13 19.083 12.1502 20 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 14L12 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v5-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","bag","luggage","case","travel","sales","reports","documents","summary","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 14L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 11C4.91697 12.1502 8.15106 13 12 13C15.8489 13 19.083 12.1502 20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bags-Suitcase v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","case","reports","business","summary","sales","finance","documents","portfolio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.67 10.99C20.49 11.11 20.3 11.24 20.1 11.35C20.05 11.38 19.99 11.4 19.95 11.43C19.72 11.56 19.48 11.68 19.22 11.8C18.79 12 18.34 12.2 17.85 12.38C16.35 12.93 14.54 13.35 12.74 13.45V13.74C12.74 14.15 12.4 14.49 11.99 14.49C11.58 14.49 11.24 14.15 11.24 13.74V13.45C9.43999 13.35 7.63999 12.93 6.12999 12.38C5.63999 12.2 5.17999 12 4.75999 11.8C4.49999 11.68 4.25 11.55 4.03 11.43C3.98 11.4 3.91999 11.38 3.87999 11.35C3.67999 11.23 3.49 11.11 3.31 10.99C3.26 11.74 3.25 12.64 3.25 13.69V13.8C3.25 15.17 3.25 16.27 3.37 17.14C3.49 18.04 3.74999 18.8 4.34999 19.4C4.94999 20 5.71 20.26 6.61 20.38C7.48 20.5 8.58 20.5 9.95 20.5H14.06C15.43 20.5 16.53 20.5 17.4 20.38C18.3 20.26 19.06 20 19.66 19.4C20.26 18.8 20.52 18.04 20.64 17.14C20.76 16.27 20.75 15.17 20.75 13.8V13.69C20.75 12.63 20.76 11.74 20.7 10.99H20.67Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.59999 10.05C4.68999 10.1 4.79 10.15 4.89 10.21C5.38 10.47 5.96999 10.73 6.62999 10.98C8.21999 11.56 10.16 12 11.97 12C13.78 12 15.72 11.56 17.31 10.98C17.97 10.74 18.56 10.47 19.05 10.21C19.15 10.16 19.25 10.1 19.34 10.05C19.48 9.97 19.61 9.89 19.73 9.81C20.04 9.61 20.24 9.43 20.35 9.31C20.19 8.86 19.97 8.45 19.62 8.1C19.02 7.5 18.26 7.24 17.36 7.12C16.89 7.06 16.34 7.03 15.72 7.02V6.76C15.73 4.68 14.05 3 11.98 3C9.91 3 8.23 4.68 8.23 6.75V7.01C7.61 7.02 7.06 7.05 6.59 7.11C5.69 7.23 4.93 7.49 4.33 8.09C3.98 8.44 3.74999 8.85 3.59999 9.3C3.70999 9.43 3.91 9.6 4.22 9.8C4.33 9.88 4.46 9.95 4.61 10.04L4.59999 10.05ZM9.73 6.75C9.73 5.51 10.74 4.5 11.98 4.5C13.22 4.5 14.23 5.51 14.23 6.75V7C14.16 7 14.1 7 14.04 7H9.92999C9.85999 7 9.8 7 9.73 7V6.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","suitcase","delivery","shipment","orders","items","products","transport","shipping","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 14L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 11C4.91697 12.1502 8.15106 13 12 13C15.8489 13 19.083 12.1502 20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["briefcase","case","bag","shipping","delivery","package","reports","documents","work","travel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 13H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v6-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","suitcase","bag","travel","ship","shipping","delivery","orders","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","case","bag","sales","reports","documents","banking","cash-out","close-register","end-of-day","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.75 13.5V13.75C16.75 14.16 16.41 14.5 16 14.5C15.59 14.5 15.25 14.16 15.25 13.75V13.5H8.75V13.75C8.75 14.16 8.41 14.5 8 14.5C7.59 14.5 7.25 14.16 7.25 13.75V13.5H3.25V13.8C3.25 15.17 3.25 16.27 3.37 17.14C3.49 18.04 3.75001 18.8 4.35001 19.4C4.95001 20 5.71 20.26 6.61 20.38C7.48 20.5 8.58 20.5 9.95 20.5H14.06C15.43 20.5 16.53 20.5 17.4 20.38C18.3 20.26 19.06 20 19.66 19.4C20.26 18.8 20.52 18.04 20.64 17.14C20.76 16.27 20.75 15.17 20.75 13.8V13.5H16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.75 12H7.25V11.75C7.25 11.34 7.59 11 8 11C8.41 11 8.75 11.34 8.75 11.75V12H15.25V11.75C15.25 11.34 15.59 11 16 11C16.41 11 16.75 11.34 16.75 11.75V12H20.75C20.75 10.95 20.73 10.07 20.63 9.36C20.51 8.46 20.25 7.7 19.65 7.1C19.05 6.5 18.29 6.24 17.39 6.12C16.92 6.06 16.37 6.03 15.75 6.02V5.71C15.75 5.28 15.75 4.88 15.71 4.56C15.66 4.2 15.55 3.83 15.24 3.52C14.93 3.21 14.56 3.1 14.2 3.05C13.87 3 13.48 3 13.04 3H10.95C10.52 3 10.12 3 9.8 3.04C9.44 3.09 9.06999 3.2 8.75999 3.51C8.44999 3.82 8.33999 4.19 8.28999 4.55C8.24999 4.87 8.25 5.27 8.25 5.7V6.01C7.63 6.02 7.08 6.05 6.61 6.11C5.71 6.23 4.95001 6.49 4.35001 7.09C3.75001 7.69 3.49 8.45 3.37 9.35C3.27 10.06 3.26 10.94 3.25 11.99H4.75V12ZM9.75 5.75C9.75 5.26 9.75 4.96 9.78 4.75C9.79 4.65 9.81001 4.61 9.82001 4.58C9.82001 4.58 9.82001 4.58 9.82001 4.57C9.82001 4.57 9.82 4.57 9.83 4.57C9.85 4.57 9.9 4.55 10 4.53C10.21 4.5 10.5 4.5 11 4.5H13C13.49 4.5 13.79 4.5 14 4.53C14.1 4.54 14.15 4.56 14.17 4.57C14.17 4.57 14.17 4.57 14.18 4.57C14.18 4.57 14.18 4.57 14.18 4.58C14.18 4.6 14.2 4.65 14.22 4.75C14.25 4.96 14.25 5.25 14.25 5.75V6C14.18 6 14.12 6 14.06 6H9.95C9.88 6 9.82 6 9.75 6V5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","bag","case","documents","reports","sales","tools","sales-report","sales-tools","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 14L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 14L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L15 6C15 5.05719 15 4.58579 14.7071 4.29289C14.4142 4 13.9428 4 13 4L11 4C10.0572 4 9.58579 4 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v7-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["briefcase","case","bag","report","summary","sales","data","business","sales-report","sales-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M14 13H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-Suitcase v7-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","bag","suitcase","document","case","reports","sales","business","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase v7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","suitcase","briefcase","luggage","travel","ship","shipping","delivery","package","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00127 6.26071C8.00476 6.00069 8.01466 5.76131 8.0427 5.5528C8.09049 5.19732 8.20294 4.82159 8.51196 4.51257C8.82098 4.20355 9.19671 4.0911 9.55219 4.04331C9.875 3.99991 10.2718 3.99995 10.7046 4L12.7941 4C13.227 3.99995 13.6238 3.99991 13.9466 4.04331C14.3021 4.0911 14.6778 4.20355 14.9868 4.51257C15.2959 4.82159 15.4083 5.19732 15.4561 5.5528C15.4841 5.76131 15.494 6.00069 15.4975 6.26071C16.1195 6.27374 16.6657 6.3026 17.1411 6.36652C18.0412 6.48754 18.7991 6.74643 19.401 7.34835C20.003 7.95027 20.2618 8.70814 20.3829 9.60825C20.479 10.3232 20.4958 11.1982 20.4988 12.25H14.3959C14.0694 11.0957 13.0082 10.25 11.7494 10.25C10.4906 10.25 9.42936 11.0957 9.1029 12.25L3 12.25C3.00294 11.1982 3.01978 10.3232 3.11591 9.60825C3.23692 8.70814 3.49582 7.95027 4.09773 7.34835C4.69965 6.74643 5.45752 6.48754 6.35763 6.36652C6.83308 6.3026 7.37932 6.27374 8.00127 6.26071ZM12.7494 5.50001C13.242 5.50001 13.536 5.5016 13.7467 5.52993C13.8433 5.54291 13.8917 5.55821 13.9134 5.56717C13.9185 5.56924 13.9218 5.57086 13.9237 5.57187L13.9262 5.57324L13.9275 5.57568C13.9285 5.57761 13.9302 5.58093 13.9322 5.58597C13.9412 5.60775 13.9565 5.65611 13.9695 5.75267C13.9866 5.87974 13.9939 6.03709 13.9971 6.25001C13.9334 6.25 13.8691 6.25 13.8043 6.25H9.69451C9.62966 6.25 9.56538 6.25 9.50172 6.25001C9.50488 6.03709 9.51224 5.87974 9.52932 5.75267C9.5423 5.65611 9.55759 5.60775 9.56656 5.58597C9.56863 5.58093 9.57025 5.57761 9.57126 5.57568L9.57263 5.57324L9.57507 5.57187C9.577 5.57086 9.58032 5.56924 9.58536 5.56717C9.60714 5.55821 9.6555 5.54291 9.75206 5.52993C9.96278 5.5016 10.2568 5.50001 10.7494 5.50001L12.7494 5.50001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.3959 13.75H20.4988C20.4958 14.8018 20.479 15.6768 20.3829 16.3918C20.2618 17.2919 20.003 18.0497 19.401 18.6517C18.7991 19.2536 18.0412 19.5125 17.1411 19.6335C16.2742 19.75 15.1719 19.75 13.8043 19.75H9.69451C8.32693 19.75 7.2246 19.75 6.35763 19.6335C5.45752 19.5125 4.69965 19.2536 4.09773 18.6517C3.49582 18.0497 3.23692 17.2919 3.11591 16.3918C3.01978 15.6768 3.00294 14.8018 3 13.75L9.1029 13.75C9.42936 14.9043 10.4906 15.75 11.7494 15.75C13.0082 15.75 14.0694 14.9043 14.3959 13.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.7494 11.75C11.059 11.75 10.4994 12.3096 10.4994 13C10.4994 13.6904 11.059 14.25 11.7494 14.25C12.4397 14.25 12.9994 13.6904 12.9994 13C12.9994 12.3096 12.4397 11.75 11.7494 11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase v7": {
        defaultColors: ["#3D4C66"],
        keywords: ["briefcase","case","travel","bag","documents","reports","sales","summary","business","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 13H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 13H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bags-Suitcase-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","briefcase","case","archive","storage","documents","reports","sales-reports","records","item","items","safe-place","inventory","organized","organize","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 11H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 14H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["luggage","bag","suitcase","travel","shipping","delivery","package","items","orders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-Suitcase-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","suitcase","bag","inventory","storage","luggage","ship","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.64 9.8H20.63C20.51 8.9 20.25 8.14 19.65 7.54C19.05 6.94 18.29 6.68 17.39 6.56C16.92 6.5 16.37 6.47 15.75 6.46C15.75 6.13 15.75 5.81 15.71 5.56C15.66 5.2 15.55 4.83 15.24 4.52C14.93 4.21 14.56 4.1 14.2 4.05C13.87 4 13.48 4 13.04 4H10.95C10.52 4 10.12 4 9.8 4.04C9.44 4.09 9.07 4.2 8.76 4.51C8.45 4.82 8.34 5.19 8.29 5.55C8.26 5.81 8.25 6.12 8.25 6.45C7.63 6.46 7.08 6.49 6.61 6.55C5.71 6.67 4.95 6.93 4.35 7.53C3.75 8.13 3.49 8.9 3.37 9.8C3.34 10 3.32 10.21 3.31 10.44H20.72C20.7 10.21 20.66 10 20.64 9.8ZM9.76 6.44C9.76 6.13 9.76 5.91 9.79 5.75C9.8 5.65 9.82 5.61 9.83 5.58C9.83 5.58 9.83 5.57 9.84 5.57C9.86 5.57 9.91 5.55 10.01 5.53C10.22 5.5 10.51 5.5 11.01 5.5H13.01C13.5 5.5 13.8 5.5 14.01 5.53C14.11 5.54 14.16 5.56 14.18 5.57H14.19C14.19 5.57 14.21 5.65 14.23 5.75C14.25 5.91 14.26 6.13 14.26 6.44H9.76Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 11.94V13.25C3.25 14.62 3.25 15.72 3.37 16.59C3.49 17.49 3.75 18.25 4.35 18.85C4.95 19.45 5.71 19.71 6.61 19.83C7.48 19.95 8.58 19.95 9.95 19.95H14.06C15.43 19.95 16.53 19.95 17.4 19.83C18.3 19.71 19.06 19.45 19.66 18.85C20.26 18.25 20.52 17.49 20.64 16.59C20.76 15.72 20.75 14.62 20.75 13.25V11.94H3.25ZM14 14.94H10C9.59 14.94 9.25 14.6 9.25 14.19C9.25 13.78 9.59 13.44 10 13.44H14C14.41 13.44 14.75 13.78 14.75 14.19C14.75 14.6 14.41 14.94 14 14.94Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-Suitcase": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","case","briefcase","bag","storage","container","items","packed","carry","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 14H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7V7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bags-trolley v2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["luggage","suitcase","bag","travel","deliveries","shipment","package","order","baggage","trolley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","luggage","suitcase","delivery","shipping","travel","order","package","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 11H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","travel","packing","suitcase","checked-baggage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.62 8.35C19.5 7.45 19.24 6.69 18.64 6.09C18.04 5.49 17.28 5.23 16.38 5.11C16.18 5.08 15.96 5.06 15.74 5.05V4.7C15.74 4.27 15.74 3.87 15.7 3.55C15.65 3.19 15.54 2.82 15.23 2.51C14.92 2.2 14.55 2.09 14.19 2.04C13.87 2 13.47 2 13.04 2H10.95C10.52 2 10.12 2 9.8 2.04C9.44 2.09 9.06999 2.2 8.75999 2.51C8.44999 2.82 8.34 3.19 8.29 3.55C8.25 3.87 8.25 4.27 8.25 4.7V5.05C8.02 5.07 7.81 5.09 7.61 5.11C6.71 5.23 5.95 5.49 5.35 6.09C4.75 6.69 4.49 7.45 4.37 8.35C4.25 9.22 4.25 10.32 4.25 11.69V13.8C4.25 15.17 4.25 16.27 4.37 17.14C4.49 18.04 4.75 18.8 5.35 19.4C5.87 19.92 6.51 20.18 7.25 20.32V20.75C7.25 21.16 7.59 21.5 8 21.5C8.41 21.5 8.75 21.16 8.75 20.75V20.47C9.39 20.5 10.11 20.5 10.95 20.5H13.06C13.89 20.5 14.61 20.5 15.26 20.47V20.75C15.26 21.16 15.6 21.5 16.01 21.5C16.42 21.5 16.76 21.16 16.76 20.75V20.32C17.5 20.18 18.14 19.92 18.66 19.4C19.26 18.8 19.52 18.04 19.64 17.14C19.76 16.27 19.75 15.17 19.75 13.8V11.69C19.75 10.32 19.74 9.22 19.62 8.35ZM15.74 10.74C15.74 11.15 15.4 11.49 14.99 11.49H8.99C8.58 11.49 8.24 11.15 8.24 10.74C8.24 10.33 8.58 9.99 8.99 9.99H14.99C15.4 9.99 15.74 10.33 15.74 10.74ZM8.99 13.99H14.99C15.4 13.99 15.74 14.33 15.74 14.74C15.74 15.15 15.4 15.49 14.99 15.49H8.99C8.58 15.49 8.24 15.15 8.24 14.74C8.24 14.33 8.58 13.99 8.99 13.99ZM9.74 4.74C9.74 4.25 9.74 3.95 9.77 3.74C9.78 3.64 9.8 3.6 9.81 3.57C9.81 3.57 9.81 3.57 9.81 3.56C9.81 3.56 9.81 3.56 9.82 3.56C9.84 3.56 9.89 3.54 9.99 3.52C10.2 3.49 10.49 3.49 10.99 3.49H12.99C13.48 3.49 13.78 3.49 13.99 3.52C14.09 3.53 14.14 3.55 14.16 3.56C14.16 3.56 14.16 3.56 14.17 3.56C14.17 3.56 14.17 3.56 14.17 3.57C14.17 3.59 14.19 3.64 14.21 3.74C14.24 3.95 14.24 4.24 14.24 4.74V4.99C13.86 4.99 13.47 4.99 13.04 4.99H10.93C10.5 4.99 10.11 4.99 9.73 4.99V4.74H9.74Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","order","package","shipment","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","luggage","suitcase","travel","shipping","delivery","package","goods","items","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 18C18.1976 15.6997 15.3678 14 12 14C8.63218 14 5.80235 15.6997 5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","delivery","shipment","order","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 18C18.1976 15.6997 15.3678 14 12 14C8.63218 14 5.80235 15.6997 5 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","suitcase","bag","travel","packed","shipping","delivery","finished","complete","order-complete","checkout-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.62 8.61C19.5 7.71 19.24 6.95 18.64 6.35C18.04 5.75 17.28 5.49 16.38 5.37C16.18 5.34 15.96 5.32 15.74 5.31V4.96C15.74 4.53 15.74 4.13 15.7 3.81C15.65 3.45 15.54 3.08 15.23 2.77C14.92 2.46 14.55 2.35 14.19 2.3C13.86 2.25 13.47 2.25 13.04 2.25H10.95C10.52 2.25 10.12 2.25 9.8 2.29C9.44 2.34 9.07001 2.45 8.76001 2.76C8.45001 3.07 8.34001 3.44 8.29001 3.8C8.25001 4.12 8.25 4.52 8.25 4.95V5.3C8.02 5.32 7.81 5.34 7.61 5.36C6.71 5.48 5.95001 5.74 5.35001 6.34C4.75001 6.94 4.49001 7.7 4.37001 8.6C4.25001 9.47 4.25 10.57 4.25 11.94V14.05C4.25 14.68 4.25001 15.24 4.26001 15.76C4.49001 15.56 4.74 15.36 5 15.18C5.24 15.02 5.49 14.86 5.75 14.72C5.92 14.63 6.08001 14.54 6.26001 14.46C7.86001 13.69 9.86 13.25 12 13.25C14.14 13.25 16.14 13.69 17.74 14.46C17.91 14.54 18.08 14.63 18.25 14.72C18.51 14.86 18.76 15.02 19 15.18C19.26 15.36 19.51 15.55 19.74 15.76C19.75 15.24 19.75 14.68 19.75 14.05V11.94C19.75 10.57 19.74 9.48 19.62 8.61ZM9.74001 5C9.74001 4.51 9.74 4.21 9.77 4C9.78 3.9 9.8 3.86 9.81 3.83C9.81 3.83 9.81 3.83 9.81 3.82C9.81 3.82 9.81001 3.82 9.82001 3.82C9.84001 3.82 9.89001 3.8 9.99001 3.78C10.2 3.75 10.49 3.75 10.99 3.75H12.99C13.48 3.75 13.78 3.75 13.99 3.78C14.09 3.79 14.13 3.81 14.16 3.82C14.16 3.82 14.16 3.82 14.17 3.82C14.17 3.82 14.17 3.82 14.17 3.83C14.17 3.85 14.19 3.9 14.21 4C14.24 4.21 14.24 4.5 14.24 5V5.26C13.86 5.26 13.47 5.26 13.04 5.26H10.93C10.5 5.26 10.11 5.26 9.73001 5.26V5H9.74001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.2 16.48C17.87 16.24 17.5 16.02 17.08 15.82C15.7 15.16 13.93 14.76 11.98 14.76C10.03 14.76 8.26998 15.16 6.88998 15.82C6.46998 16.02 6.10999 16.25 5.76999 16.48C5.50999 16.66 5.26999 16.86 5.06999 17.06C4.80999 17.31 4.59999 17.58 4.42999 17.85C4.56999 18.55 4.82999 19.16 5.32999 19.66C5.84999 20.18 6.49 20.44 7.23 20.58V21.01C7.23 21.42 7.57 21.75 7.98 21.75C8.39 21.75 8.73 21.42 8.73 21.01V20.73C9.37 20.76 10.09 20.76 10.93 20.76H13.04C13.87 20.76 14.59 20.76 15.24 20.73V21.01C15.24 21.42 15.58 21.75 15.99 21.75C16.4 21.75 16.74 21.42 16.74 21.01V20.58C17.48 20.44 18.12 20.18 18.64 19.66C19.14 19.16 19.39 18.55 19.54 17.85C19.37 17.58 19.16 17.31 18.9 17.06C18.69 16.86 18.46 16.67 18.2 16.48Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley v4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["luggage","bag","suitcase","travel","remove","subtract","delete","order","remove-order","delete-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","carry-on","checked-bag","shipping","delivery","package","cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 18C18.1976 15.6997 15.3678 14 12 14C8.63218 14 5.80235 15.6997 5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["luggage","suitcase","bag","travel","airport","carry-on","checked-bag","shipping","delivery","package","items","products","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 13H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["suitcase","bag","luggage","travel","delivery","shipping","order","package","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.67 7.46C18.59 6.83 18.4 6.27 17.94 5.81C17.48 5.35 16.92 5.17 16.29 5.08C16.12 5.06 15.94 5.04 15.75 5.03V4.7C15.75 4.27 15.75 3.87 15.71 3.55C15.66 3.19 15.55 2.82 15.24 2.51C14.93 2.2 14.56 2.09 14.2 2.04C13.87 2 13.48 2 13.04 2H10.95C10.52 2 10.13 2 9.8 2.04C9.44 2.09 9.07 2.2 8.76 2.51C8.45 2.82 8.34 3.19 8.29 3.55C8.25 3.87 8.25 4.27 8.25 4.7V5.03C8.06 5.04 7.87 5.06 7.71 5.08C7.08 5.16 6.52 5.35 6.06 5.81C5.6 6.27 5.42 6.83 5.33 7.46C5.25 8.05 5.25 8.8 5.25 9.7V15.8C5.25 16.7 5.25 17.45 5.33 18.04C5.41 18.67 5.6 19.23 6.06 19.69C6.4 20.03 6.81 20.22 7.25 20.33V20.74C7.25 21.15 7.59 21.49 8 21.49C8.41 21.49 8.75 21.15 8.75 20.74V20.48C9.11 20.48 9.51 20.48 9.95 20.48H14.05C14.49 20.48 14.88 20.48 15.25 20.48V20.74C15.25 21.15 15.59 21.49 16 21.49C16.41 21.49 16.75 21.15 16.75 20.74V20.33C17.2 20.22 17.6 20.03 17.94 19.69C18.4 19.23 18.58 18.67 18.67 18.04C18.75 17.45 18.75 16.7 18.75 15.8V9.7C18.75 8.8 18.75 8.05 18.67 7.46ZM9.75 4.75C9.75 4.26 9.75 3.96 9.78 3.75C9.79 3.65 9.81 3.61 9.82 3.58C9.82 3.58 9.82 3.58 9.82 3.57C9.82 3.57 9.82 3.57 9.83 3.57C9.85 3.57 9.9 3.55 10 3.53C10.21 3.5 10.5 3.5 11 3.5H13C13.49 3.5 13.79 3.5 14 3.53C14.1 3.54 14.14 3.56 14.17 3.57C14.17 3.57 14.17 3.57 14.18 3.57C14.18 3.57 14.18 3.57 14.18 3.58C14.18 3.6 14.2 3.65 14.22 3.75C14.25 3.96 14.25 4.25 14.25 4.75V5C14.18 5 14.12 5 14.05 5H9.95C9.88 5 9.82 5 9.75 5V4.75ZM15 13.5H9C8.59 13.5 8.25 13.16 8.25 12.75C8.25 12.34 8.59 12 9 12H15C15.41 12 15.75 12.34 15.75 12.75C15.75 13.16 15.41 13.5 15 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","carry-on","baggage","delivery","shipment","package","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 16V10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6H14C15.8856 6 16.8284 6 17.4142 6.58579C18 7.17157 18 8.11438 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["luggage","bag","suitcase","travel","order","item","delivery","shipment","baggage","packed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.1213 8.87868C18 9.75736 18 11.1716 18 14C18 16.8284 18 18.2426 17.1213 19.1213C16.2426 20 14.8284 20 12 20C9.17157 20 7.75736 20 6.87868 19.1213C6 18.2426 6 16.8284 6 14C6 11.1716 6 9.75736 6.87868 8.87868C7.75736 8 9.17157 8 12 8C14.8284 8 16.2426 8 17.1213 8.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","delivery","shipment","package","orders","shipping","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.1213 8.87868C18 9.75736 18 11.1716 18 14C18 16.8284 18 18.2426 17.1213 19.1213C16.2426 20 14.8284 20 12 20C9.17157 20 7.75736 20 6.87868 19.1213C6 18.2426 6 16.8284 6 14C6 11.1716 6 9.75736 6.87868 8.87868C7.75736 8 9.17157 8 12 8C14.8284 8 16.2426 8 17.1213 8.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v5-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["luggage","bag","suitcase","travel","delivery","carry-on","goods","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 5C15 4.05719 15 3.58579 14.7071 3.29289C14.4142 3 13.9428 3 13 3L11 3C10.0572 3 9.58579 3 9.29289 3.29289C9 3.58579 9 4.05719 9 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17.1213 8.87868C18 9.75736 18 11.1716 18 14C18 16.8284 18 18.2426 17.1213 19.1213C16.2426 20 14.8284 20 12 20C9.17157 20 7.75736 20 6.87868 19.1213C6 18.2426 6 16.8284 6 14C6 11.1716 6 9.75736 6.87868 8.87868C7.75736 8 9.17157 8 12 8C14.8284 8 16.2426 8 17.1213 8.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 16H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","luggage","suitcase","travel","shipping","delivery","order","cart","package","ship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17C18.1976 14.6997 15.3678 13 12 13C8.63218 13 5.80235 14.6997 5 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8L15 7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7L9 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14C5 11.1716 5 9.75736 5.87868 8.87868C6.75736 8 8.17157 8 11 8H13C15.8284 8 17.2426 8 18.1213 8.87868C19 9.75736 19 11.1716 19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","order","delivery","shipping","carry-on","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.63 10.36C18.51 9.46 18.25 8.7 17.65 8.1C17.13 7.58 16.49 7.32 15.75 7.18V4.71C15.75 4.28 15.75 3.88 15.71 3.56C15.66 3.2 15.55 2.83 15.24 2.52C14.93 2.21 14.56 2.1 14.2 2.05C13.87 2 13.48 2 13.04 2H10.95C10.52 2 10.13 2 9.8 2.04C9.44 2.09 9.07 2.2 8.76 2.51C8.45 2.82 8.34 3.19 8.29 3.55C8.25 3.87 8.25 4.27 8.25 4.7V7.18C7.51 7.32 6.87 7.58 6.35 8.1C5.75 8.7 5.49 9.46 5.37 10.36C5.25 11.23 5.25 12.33 5.25 13.7V13.81C5.25 15.18 5.25 16.28 5.37 17.15C5.49 18.05 5.75 18.81 6.35 19.41C6.62 19.68 6.92 19.87 7.25 20.02V20.76C7.25 21.17 7.59 21.51 8 21.51C8.41 21.51 8.75 21.17 8.75 20.76V20.41C9.6 20.51 10.65 20.51 11.95 20.51H12.06C13.36 20.51 14.41 20.51 15.26 20.41V20.76C15.26 21.17 15.6 21.51 16.01 21.51C16.42 21.51 16.76 21.17 16.76 20.76V20.02C17.09 19.87 17.39 19.68 17.66 19.41C18.26 18.81 18.52 18.05 18.64 17.15C18.76 16.28 18.75 15.18 18.75 13.81V13.7C18.75 12.33 18.76 11.23 18.64 10.36H18.63ZM9.75 4.75C9.75 4.26 9.75 3.96 9.78 3.75C9.79 3.65 9.81 3.61 9.82 3.58C9.82 3.58 9.82 3.58 9.82 3.57C9.82 3.57 9.82 3.57 9.83 3.57C9.85 3.57 9.9 3.55 10 3.53C10.21 3.5 10.5 3.5 11 3.5H13C13.49 3.5 13.79 3.5 14 3.53C14.1 3.54 14.14 3.56 14.17 3.57C14.17 3.57 14.17 3.57 14.18 3.57C14.18 3.57 14.18 3.57 14.18 3.58C14.18 3.6 14.2 3.65 14.22 3.75C14.25 3.96 14.25 4.25 14.25 4.75V7.03C13.61 7 12.89 7 12.05 7H11.94C11.11 7 10.39 7 9.74 7.03V4.75H9.75ZM15 16.5H9C8.59 16.5 8.25 16.16 8.25 15.75C8.25 15.34 8.59 15 9 15H15C15.41 15 15.75 15.34 15.75 15.75C15.75 16.16 15.41 16.5 15 16.5ZM15 12.5H9C8.59 12.5 8.25 12.16 8.25 11.75C8.25 11.34 8.59 11 9 11H15C15.41 11 15.75 11.34 15.75 11.75C15.75 12.16 15.41 12.5 15 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley v6-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","luggage","suitcase","travel","delivery","shipment","package","carry-on","transport","products","baggage","case"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14C5 11.1716 5 9.75736 5.87868 8.87868C6.75736 8 8.17157 8 11 8H13C15.8284 8 17.2426 8 18.1213 8.87868C19 9.75736 19 11.1716 19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 17C18.1976 14.6997 15.3678 13 12 13C8.63218 13 5.80235 14.6997 5 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","luggage","trolley","suitcase","travel","delivery","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8L15 7C15 6.05719 15 5.58579 14.7071 5.29289C14.4142 5 13.9428 5 13 5L11 5C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14C5 11.1716 5 9.75736 5.87868 8.87868C6.75736 8 8.17157 8 11 8H13C15.8284 8 17.2426 8 18.1213 8.87868C19 9.75736 19 11.1716 19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 17C18.1976 14.6997 15.3678 13 12 13C8.63218 13 5.80235 14.6997 5 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","ship","shipping","delivery","order","package","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.63 10.36C19.51 9.46 19.25 8.7 18.65 8.1C18.05 7.5 17.29 7.24 16.39 7.12C16.19 7.09 15.97 7.07 15.75 7.06V6.71C15.75 6.28 15.75 5.88 15.71 5.56C15.66 5.2 15.55 4.83 15.24 4.52C14.93 4.21 14.56 4.1 14.2 4.05C13.87 4 13.48 4 13.04 4H10.95C10.52 4 10.12 4 9.8 4.04C9.44 4.09 9.07 4.2 8.76 4.51C8.45 4.82 8.34 5.19 8.29 5.55C8.25 5.87 8.25 6.27 8.25 6.7V7.05C8.02 7.07 7.81 7.09 7.61 7.11C6.71 7.23 5.95 7.49 5.35 8.09C4.75 8.7 4.49 9.46 4.37 10.36C4.25 11.23 4.25 12.33 4.25 13.7V13.81C4.25 14.05 4.25 14.29 4.25 14.52C4.82 14.01 5.5 13.57 6.26 13.21C7.86 12.44 9.86 12 12 12C14.14 12 16.14 12.44 17.74 13.21C18.49 13.57 19.18 14.01 19.75 14.52C19.75 14.29 19.75 14.05 19.75 13.81V13.7C19.75 12.33 19.75 11.23 19.63 10.36ZM10.95 7C10.52 7 10.13 7 9.75 7V6.74C9.75 6.25 9.75 5.95 9.78 5.74C9.79 5.64 9.81 5.6 9.82 5.57C9.82 5.57 9.82 5.57 9.82 5.56C9.82 5.56 9.82 5.56 9.83 5.56C9.85 5.56 9.9 5.54 10 5.52C10.21 5.49 10.5 5.49 11 5.49H13C13.49 5.49 13.79 5.49 14 5.52C14.1 5.53 14.14 5.55 14.17 5.56C14.17 5.56 14.17 5.56 14.18 5.56C14.18 5.56 14.18 5.56 14.18 5.57C14.18 5.59 14.2 5.64 14.22 5.74C14.25 5.95 14.25 6.24 14.25 6.74V7C13.87 7 13.48 7 13.05 7H10.94H10.95Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.09 14.56C15.71 13.9 13.94 13.5 12 13.5C10.06 13.5 8.29001 13.91 6.90001 14.56C5.65001 15.16 4.77001 15.94 4.32001 16.76C4.33001 16.89 4.35001 17.02 4.36001 17.14C4.48001 18.04 4.74001 18.8 5.34001 19.4C5.86001 19.92 6.50001 20.18 7.24001 20.32V20.75C7.24001 21.16 7.58001 21.5 7.99001 21.5C8.40001 21.5 8.74001 21.16 8.74001 20.75V20.47C9.38001 20.5 10.1 20.5 10.94 20.5H13.05C13.88 20.5 14.6 20.5 15.25 20.47V20.75C15.25 21.16 15.59 21.5 16 21.5C16.41 21.5 16.75 21.16 16.75 20.75V20.32C17.49 20.18 18.13 19.92 18.65 19.4C19.25 18.8 19.51 18.04 19.63 17.14C19.65 17.02 19.66 16.89 19.67 16.76C19.22 15.94 18.34 15.16 17.09 14.56Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["luggage","bag","suitcase","travel","shipping","delivery","baggage","carry-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9V5C9 4.05719 9 3.58579 9.29289 3.29289C9.58579 3 10.0572 3 11 3H13C13.9428 3 14.4142 3 14.7071 3.29289C15 3.58579 15 4.05719 15 5V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 20H10.5C8.15442 20 6.98164 20 6.17372 19.3801C5.96572 19.2205 5.77954 19.0343 5.61994 18.8263C5 18.0184 5 16.8456 5 14.5C5 12.1544 5 10.9816 5.61994 10.1737C5.77954 9.96572 5.96572 9.77954 6.17372 9.61994C6.98164 9 8.15442 9 10.5 9H13.5C15.8456 9 17.0184 9 17.8263 9.61994C18.0343 9.77954 18.2205 9.96572 18.3801 10.1737C19 10.9816 19 12.1544 19 14.5C19 16.8456 19 18.0184 18.3801 18.8263C18.2205 19.0343 18.0343 19.2205 17.8263 19.3801C17.0184 20 15.8456 20 13.5 20Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bags-trolley-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["suitcase","luggage","bag","travel","shipping","delivery","package","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9553 2.25H13.0447C13.4776 2.24995 13.8744 2.24991 14.1972 2.29331C14.5527 2.3411 14.9284 2.45355 15.2374 2.76257C15.5465 3.07159 15.6589 3.44732 15.7067 3.8028C15.7501 4.1256 15.7501 4.52242 15.75 4.95522L15.75 8.28516C15.9529 8.29667 16.1439 8.31195 16.3238 8.33222C17.0781 8.41725 17.7266 8.59808 18.2829 9.02493C18.5429 9.22443 18.7756 9.45716 18.9751 9.71715C19.4019 10.2734 19.5828 10.922 19.6678 11.6762C19.75 12.4057 19.75 13.3204 19.75 14.4548V14.5452C19.75 15.6796 19.75 16.5943 19.6678 17.3238C19.5828 18.0781 19.4019 18.7266 18.9751 19.2829C18.7756 19.5429 18.5429 19.7756 18.2829 19.9751C17.8343 20.3193 17.3257 20.5035 16.75 20.6066V21C16.75 21.4142 16.4142 21.75 16 21.75C15.5858 21.75 15.25 21.4142 15.25 21V20.7356C14.7466 20.75 14.1805 20.75 13.5454 20.75H10.4548C9.81981 20.75 9.25335 20.75 8.75 20.7356V21C8.75 21.4142 8.41422 21.75 8 21.75C7.58579 21.75 7.25 21.4142 7.25 21V20.6066C6.67434 20.5035 6.16575 20.3193 5.71714 19.9751C5.45715 19.7756 5.22443 19.5429 5.02493 19.2829C4.59808 18.7266 4.41725 18.0781 4.33221 17.3238C4.24997 16.5943 4.24999 15.6796 4.25 14.5452V14.4548C4.24999 13.3204 4.24997 12.4057 4.33221 11.6762C4.41725 10.922 4.59808 10.2734 5.02493 9.71715C5.22443 9.45716 5.45715 9.22443 5.71715 9.02493C6.27343 8.59808 6.92195 8.41725 7.67622 8.33222C7.85605 8.31195 8.04714 8.29667 8.25 8.28516L8.25 4.95526C8.24995 4.52244 8.2499 4.12561 8.2933 3.8028C8.34109 3.44732 8.45354 3.07159 8.76256 2.76257C9.07159 2.45355 9.44731 2.3411 9.80279 2.29331C10.1256 2.24991 10.5224 2.24995 10.9553 2.25ZM9.75 8.25083C9.97492 8.25 10.2097 8.25 10.4548 8.25001H13.5452C13.7903 8.25 14.0251 8.25 14.25 8.25083V5.00001C14.25 4.5074 14.2484 4.21339 14.2201 4.00267C14.2071 3.90611 14.1918 3.85775 14.1828 3.83597C14.1808 3.83093 14.1792 3.82761 14.1781 3.82568L14.1768 3.82324L14.1743 3.82187C14.1724 3.82086 14.1691 3.81924 14.164 3.81717C14.1423 3.80821 14.0939 3.79291 13.9973 3.77993C13.7866 3.7516 13.4926 3.75001 13 3.75001H11C10.5074 3.75001 10.2134 3.7516 10.0027 3.77993C9.90611 3.79291 9.85775 3.80821 9.83597 3.81717C9.83092 3.81924 9.82761 3.82086 9.82567 3.82187L9.82324 3.82324L9.82186 3.82568C9.82085 3.82761 9.81924 3.83093 9.81716 3.83597C9.8082 3.85775 9.79291 3.90611 9.77993 4.00267C9.75159 4.21339 9.75 4.5074 9.75 5.00001V8.25083ZM15 13.75C15.4142 13.75 15.75 13.4142 15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H9C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H15ZM15 16.75C15.4142 16.75 15.75 16.4142 15.75 16C15.75 15.5858 15.4142 15.25 15 15.25H9C8.58579 15.25 8.25 15.5858 8.25 16C8.25 16.4142 8.58579 16.75 9 16.75H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bags-trolley-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","suitcase","luggage","travel","delivery","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.5 20H10.5C8.15442 20 6.98164 20 6.17372 19.3801C5.96572 19.2205 5.77954 19.0343 5.61994 18.8263C5 18.0184 5 16.8456 5 14.5C5 12.1544 5 10.9816 5.61994 10.1737C5.77954 9.96572 5.96572 9.77954 6.17372 9.61994C6.98164 9 8.15442 9 10.5 9H13.5C15.8456 9 17.0184 9 17.8263 9.61994C18.0343 9.77954 18.2205 9.96572 18.3801 10.1737C19 10.9816 19 12.1544 19 14.5C19 16.8456 19 18.0184 18.3801 18.8263C18.2205 19.0343 18.0343 19.2205 17.8263 19.3801C17.0184 20 15.8456 20 13.5 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 13H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V5C9 4.05719 9 3.58579 9.29289 3.29289C9.58579 3 10.0572 3 11 3H13C13.9428 3 14.4142 3 14.7071 3.29289C15 3.58579 15 4.05719 15 5V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Bags: {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","suitcase","luggage","travel","delivery","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 8V7C9 5.34315 10.3431 4 12 4V4C13.6569 4 15 5.34315 15 7V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 15H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "baht-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["baht","currency","thai","money","payment","price","cost","total","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.04225 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12H7V18.9577C7 18.9811 7.01892 19 7.04225 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12H11.5C13.433 12 15 10.433 15 8.5C15 6.567 13.433 5 11.5 5H7.11852C7.05306 5 7 5.05306 7 5.11852V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 4L11 10.4L11 20"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bags-trolley": {
        defaultColors: ["#3D4C66"],
        keywords: ["luggage","bag","suitcase","travel","carry-on","ship","shipping","delivery","package","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.5 20H10.5C8.15442 20 6.98164 20 6.17372 19.3801C5.96572 19.2205 5.77954 19.0343 5.61994 18.8263C5 18.0184 5 16.8456 5 14.5C5 12.1544 5 10.9816 5.61994 10.1737C5.77954 9.96572 5.96572 9.77954 6.17372 9.61994C6.98164 9 8.15442 9 10.5 9H13.5C15.8456 9 17.0184 9 17.8263 9.61994C18.0343 9.77954 18.2205 9.96572 18.3801 10.1737C19 10.9816 19 12.1544 19 14.5C19 16.8456 19 18.0184 18.3801 18.8263C18.2205 19.0343 18.0343 19.2205 17.8263 19.3801C17.0184 20 15.8456 20 13.5 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V5C9 4.05719 9 3.58579 9.29289 3.29289C9.58579 3 10.0572 3 11 3H13C13.9428 3 14.4142 3 14.7071 3.29289C15 3.58579 15 4.05719 15 5V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 21L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 21L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "baht-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","baht","thai-baht","money","payment","amount","price","change","cash","finance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 3C11.5523 3 12 3.44772 12 4V4.02746C14.25 4.27619 16 6.18372 16 8.5C16 9.70431 15.5269 10.7981 14.7564 11.6058C16.0979 12.3847 17 13.837 17 15.5C17 17.9853 14.9853 20 12.5 20H12C12 20.5523 11.5523 21 11 21C10.4477 21 10 20.5523 10 20H7.04225C6.46663 20 6 19.5334 6 18.9577V5.11852C6 4.50077 6.50078 4 7.11852 4H10C10 3.44772 10.4477 3 11 3ZM10 6H8V11H10V6ZM10 13H8V18H10L10 13ZM12 18H12.5C13.8807 18 15 16.8807 15 15.5C15 14.1193 13.8807 13 12.5 13H12V18ZM12 10.95C13.1411 10.7184 14 9.70948 14 8.5C14 7.29052 13.1411 6.28164 12 6.05001V10.95Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "baht-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["baht","currency","money","payment","thai-baht","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.04225 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12H7V18.9577C7 18.9811 7.01892 19 7.04225 19Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12H11.5C13.433 12 15 10.433 15 8.5C15 6.567 13.433 5 11.5 5H7.11852C7.05306 5 7 5.05306 7 5.11852V12Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 4L11 10.4L11 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ball 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basketball","sports","team","league","event","tournament","game","athletics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 19L12 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 7C15.7683 8.25492 15 10.0309 15 12C15 13.9691 15.7683 15.7451 17 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 7C8.23169 8.25492 9 10.0309 9 12C9 13.9691 8.23169 15.7451 7 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 12L5 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "baht-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","baht","thai-baht","money","payment","price","cost","thai-currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.04225 19H12.5C14.433 19 16 17.433 16 15.5C16 13.567 14.433 12 12.5 12H7V18.9577C7 18.9811 7.01892 19 7.04225 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12H11.5C13.433 12 15 10.433 15 8.5C15 6.567 13.433 5 11.5 5H7.11852C7.05306 5 7 5.05306 7 5.11852V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 4L11 10.4L11 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ball 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["basketball","sports","team","merchandise","product","item","sell","purchase","athletic","game"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M17 7C15.7683 8.25492 15 10.0309 15 12C15 13.9691 15.7683 15.7451 17 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 7C8.23169 8.25492 9 10.0309 9 12C9 13.9691 8.23169 15.7451 7 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M19 12L5 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "ball 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basketball","sports","team","ball","merchandise","sporting-goods","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M17 7C15.7683 8.25492 15 10.0309 15 12C15 13.9691 15.7683 15.7451 17 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 7C8.23169 8.25492 9 10.0309 9 12C9 13.9691 8.23169 15.7451 7 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "ball-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ball","tennis","sports","recreation","activity","game","leisure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18.2454C15.1711 16.7793 14 14.5264 14 12C14 9.47362 15.1711 7.22076 17 5.75464M7 5.75464C8.82893 7.22076 10 9.47363 10 12C10 14.5264 8.82893 16.7793 7 18.2454"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 18.2454C18.8289 16.7793 20 14.5264 20 12C20 9.47362 18.8289 7.22075 17 5.75463C15.6304 4.65672 13.8919 4 12 4C10.1081 4 8.3696 4.65672 7 5.75463C5.17107 7.22075 4 9.47362 4 12C4 14.5264 5.17108 16.7793 7 18.2454C8.3696 19.3433 10.1081 20 12 20C13.8919 20 15.6304 19.3433 17 18.2454Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "ball 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["basketball","sports","ball","team","merchandise","product","sporting goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9996 4.06201C9.49715 4.24937 8.12406 4.85337 6.99963 5.75475C8.58339 7.02434 9.67385 8.88388 9.93774 11.0001H10.9996V4.06201Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.99963 18.2455C8.12406 19.1469 9.49715 19.7509 10.9996 19.9382V13.0001H9.93774C9.67385 15.1164 8.58339 16.9759 6.99963 18.2455Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.9996 19.9382C14.5021 19.7509 15.8752 19.1469 16.9996 18.2455C15.4159 16.9759 14.3254 15.1164 14.0615 13.0001H12.9996V19.9382Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.9996 5.75475C15.4159 7.02434 14.3254 8.88388 14.0615 11.0001H12.9996V4.06201C14.5021 4.24937 15.8752 4.85337 16.9996 5.75475Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.3998 7.19956C19.2155 8.2853 19.7613 9.58535 19.9377 11.0001L16.0826 11.0001C16.3424 9.4516 17.1953 8.10421 18.3998 7.19956Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.9377 13.0001C19.7613 14.4149 19.2155 15.7149 18.3998 16.8007C17.1953 15.896 16.3424 14.5486 16.0826 13.0001L19.9377 13.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.59947 16.8007C4.78379 15.7149 4.23794 14.4149 4.06152 13.0001H7.91667C7.65688 14.5486 6.80394 15.896 5.59947 16.8007Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.06152 11.0001C4.23794 9.58535 4.78378 8.2853 5.59947 7.19956C6.80394 8.10421 7.65688 9.4516 7.91667 11.0001L4.06152 11.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ball-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ball","tennis","tennis-ball","sport","activity","recreation","store","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00066 4.51525C8.43072 3.55841 10.1512 3 12 3C13.8489 3 15.5695 3.55848 16.9996 4.51542C14.8053 6.33138 13.4002 9.00324 13.4002 11.9999C13.4002 14.9967 14.8053 17.6686 16.9997 19.4845C15.5695 20.4415 13.849 21 12 21C10.1512 21 8.43066 20.4416 7.00059 19.4847C9.19505 17.6687 10.6002 14.9968 10.6002 11.9999C10.6002 9.00315 9.19508 6.33121 7.00066 4.51525Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.44464 5.83342C3.92981 7.44337 3 9.61334 3 12C3 14.3866 3.92979 16.5566 5.44458 18.1665C7.38572 16.6937 8.60023 14.4692 8.60023 11.9999C8.60023 9.53075 7.38575 7.30623 5.44464 5.83342Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.5556 18.1663C20.0703 16.5564 21 14.3865 21 12C21 9.61344 20.0703 7.44356 18.5556 5.83362C16.6146 7.30644 15.4002 9.53086 15.4002 11.9999C15.4002 14.4691 16.6146 16.6935 18.5556 18.1663Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ball-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ball","sports","tennis","leisure","activity","game","product","inventory","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18.2454C18.8289 16.7793 20 14.5264 20 12C20 9.47362 18.8289 7.22075 17 5.75463C15.6304 4.65672 13.8919 4 12 4C10.1081 4 8.3696 4.65672 7 5.75463C5.17107 7.22075 4 9.47362 4 12C4 14.5264 5.17108 16.7793 7 18.2454C8.3696 19.3433 10.1081 20 12 20C13.8919 20 15.6304 19.3433 17 18.2454Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 18.2454C15.1711 16.7793 14 14.5264 14 12C14 9.47362 15.1711 7.22076 17 5.75464M7 5.75464C8.82893 7.22076 10 9.47363 10 12C10 14.5264 8.82893 16.7793 7 18.2454"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bandage-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["injury","healthcare","medical","first-aid","bandage","repair","problem","fix","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7072 12.7072L11.293 11.293"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 7.75755L12.7069 7.05044C13.8785 5.87887 15.778 5.87887 16.9495 7.05044V7.05044C18.1211 8.22201 18.1211 10.1215 16.9495 11.2931L16.2424 12.0002M7.75714 12.0002L7.05003 12.7073C5.87846 13.8789 5.87846 15.7784 7.05003 16.9499V16.9499C8.2216 18.1215 10.1211 18.1215 11.2927 16.9499L11.9998 16.2428"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7068 16.95L7.04995 11.2931C5.87838 10.1215 5.87838 8.22205 7.04995 7.05047C8.22152 5.8789 10.121 5.8789 11.2926 7.05047L16.9494 12.7073C18.121 13.8789 18.121 15.7784 16.9494 16.95C15.7779 18.1215 13.8784 18.1215 12.7068 16.95Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    ball: {
        defaultColors: ["#3D4C66"],
        keywords: ["injury","healthcare","medical","first-aid","bandage","repair","problem","fix","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18.2454C15.1711 16.7793 14 14.5264 14 12C14 9.47362 15.1711 7.22076 17 5.75464M7 5.75464C8.82893 7.22076 10 9.47363 10 12C10 14.5264 8.82893 16.7793 7 18.2454"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 18.2454C18.8289 16.7793 20 14.5264 20 12C20 9.47362 18.8289 7.22075 17 5.75463C15.6304 4.65672 13.8919 4 12 4C10.1081 4 8.3696 4.65672 7 5.75463C5.17107 7.22075 4 9.47362 4 12C4 14.5264 5.17108 16.7793 7 18.2454C8.3696 19.3433 10.1081 20 12 20C13.8919 20 15.6304 19.3433 17 18.2454Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bandage-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bandage","health","medical","care","first-aid","treatment","injury","remedy","fix","patch","recovery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.04398 12.6638L12.7498 7.05635C13.9315 5.89501 15.8309 5.91152 16.9923 7.09324C18.1536 8.27495 18.1371 10.1744 16.9554 11.3357L11.2496 16.9432C10.0679 18.1045 8.16844 18.088 7.00709 16.9063C5.84575 15.7246 5.86227 13.8251 7.04398 12.6638Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7068 16.95L7.04995 11.2931C5.87838 10.1215 5.87838 8.22205 7.04995 7.05047C8.22152 5.8789 10.121 5.8789 11.2926 7.05047L16.9494 12.7073C18.121 13.8789 18.121 15.7784 16.9494 16.95C15.7779 18.1215 13.8784 18.1215 12.7068 16.95Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7072 12.7072L11.293 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bandage: {
        defaultColors: ["#3D4C66"],
        keywords: ["bandage","health","medical","care","first-aid","treatment","injury","remedy","fix","patch","recovery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9998 7.75755L12.7069 7.05044C13.8785 5.87887 15.778 5.87887 16.9495 7.05044V7.05044C18.1211 8.22201 18.1211 10.1215 16.9495 11.2931L16.2424 12.0002M7.75714 12.0002L7.05003 12.7073C5.87846 13.8789 5.87846 15.7784 7.05003 16.9499V16.9499C8.2216 18.1215 10.1211 18.1215 11.2927 16.9499L11.9998 16.2428"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7068 16.95L7.04995 11.2931C5.87838 10.1215 5.87838 8.22205 7.04995 7.05047C8.22152 5.8789 10.121 5.8789 11.2926 7.05047L16.9494 12.7073C18.121 13.8789 18.121 15.7784 16.9494 16.95C15.7779 18.1215 13.8784 18.1215 12.7068 16.95Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7072 12.7072L11.293 11.293"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bandage-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flower","round","medical","healthcare","first-aid","pharmacy","injury","healing","repair","maintenance","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17.799C13.6013 19.4003 16.1976 19.4003 17.799 17.799C19.3954 16.2026 19.4003 13.6173 17.8137 12.0148C19.3877 10.4187 19.3982 7.83978 17.8283 6.23078C16.2466 4.60971 13.6597 4.58705 12.0502 6.18018L12.0145 6.21553L12 6.20101C10.3987 4.59966 7.80236 4.59966 6.20101 6.20101C4.6046 7.79742 4.59968 10.3827 6.18625 11.9852C4.61226 13.5813 4.6018 16.1602 6.17171 17.7692C7.7534 19.3903 10.3403 19.4129 11.9498 17.8198L11.9855 17.7845L12 17.799ZM12 10.3431C11.5425 9.88562 10.8007 9.88562 10.3431 10.3431C9.88562 10.8007 9.88562 11.5425 10.3431 12L12 13.6569C12.4575 14.1144 13.1993 14.1144 13.6569 13.6569C14.1144 13.1993 14.1144 12.4575 13.6569 12L12 10.3431Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Barcode-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["barcode","scan","scanner","product","item","price","lookup","code","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Barcode-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["barcode","scan","scanner","product","item","price","code","identification","lookup","read","register","checkout","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Barcode-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["barcode","scan","scanner","item","product","price","lookup","inventory","code","barcode-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 4C8.95604 4 8.97799 4 9.00001 4H10C10.5523 4 11 4.44772 11 5C11 5.55229 10.5523 6 10 6H9.00001C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6.00001 8.02893 6.00001 9V10C6.00001 10.5523 5.55229 11 5.00001 11C4.44772 11 4.00001 10.5523 4.00001 10V9C4.00001 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 4C15.044 4 15.022 4 15 4H14C13.4477 4 13 4.44772 13 5C13 5.55229 13.4477 6 14 6H15C15.9711 6 16.5988 6.00213 17.0613 6.06431C17.495 6.12263 17.631 6.21677 17.7071 6.2929C17.7832 6.36902 17.8774 6.50497 17.9357 6.93871C17.9979 7.40122 18 8.02893 18 9V10C18 10.5523 18.4477 11 19 11C19.5523 11 20 10.5523 20 10V9C20 8.97799 20 8.95604 20 8.93417C20.0001 8.04769 20.0001 7.28387 19.9179 6.67221C19.8297 6.0167 19.631 5.38835 19.1213 4.87868C18.6117 4.36902 17.9833 4.17028 17.3278 4.08215C16.7161 3.99991 15.9523 3.99995 15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 20C15.044 20 15.022 20 15 20H14C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V15C20 15.022 20 15.044 20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 20C8.95604 20 8.97799 20 9.00001 20H10C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18L9.00001 18C8.02893 18 7.40122 17.9979 6.93871 17.9357C6.50497 17.8774 6.36902 17.7832 6.2929 17.7071C6.21677 17.631 6.12263 17.495 6.06431 17.0613C6.00213 16.5988 6 15.9711 6 15V14C6 13.4477 5.55229 13 5 13C4.44772 13 4 13.4477 4 14L4 15C4 15.022 4 15.044 4 15.0658C3.99995 15.9523 3.99991 16.7161 4.08215 17.3278C4.17028 17.9833 4.36902 18.6117 4.87868 19.1213C5.38835 19.631 6.0167 19.8297 6.67221 19.9179C7.28387 20.0001 8.04769 20.0001 8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00001 9C9.55229 9 10 9.44772 10 10V14C10 14.5523 9.55229 15 9.00001 15C8.44772 15 8.00001 14.5523 8.00001 14V10C8.00001 9.44772 8.44772 9 9.00001 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C12.5523 9 13 9.44772 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10C11 9.44772 11.4477 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9C15.5523 9 16 9.44772 16 10V14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14V10C14 9.44772 14.4477 9 15 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Barcode-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["barcode","scan","scanner","item","price","product","code","identification","lookup","search","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10V9C20 7.11438 20 6.17157 19.4142 5.58579C18.8284 5 17.8856 5 16 5H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19L9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Barcode-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["barcode","scan","scanner","product","item","code","identify","identification","price","lookup","inventory","pos","point-of-sale","retail","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10V9C20 7.11438 20 6.17157 19.4142 5.58579C18.8284 5 17.8856 5 16 5H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19L9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Barcode-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["barcode","scan","scanner","product","item","price","lookup","identify","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4C7.95604 4 7.97799 4 8 4H9C9.55229 4 10 4.44772 10 5C10 5.55229 9.55229 6 9 6H8C7.02893 6 6.40122 6.00213 5.93871 6.06431C5.50497 6.12263 5.36902 6.21677 5.2929 6.2929C5.21677 6.36902 5.12263 6.50497 5.06431 6.93871C5.00213 7.40122 5 8.02893 5 9V10C5 10.5523 4.55229 11 4 11C3.44772 11 3 10.5523 3 10V9C3 8.97799 3 8.95604 3 8.93417C2.99995 8.04769 2.99991 7.28387 3.08215 6.67221C3.17028 6.0167 3.36902 5.38835 3.87868 4.87868C4.38835 4.36902 5.0167 4.17028 5.67221 4.08215C6.28387 3.99991 7.04769 3.99995 7.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0658 4C16.044 4 16.022 4 16 4H15C14.4477 4 14 4.44772 14 5C14 5.55229 14.4477 6 15 6H16C16.9711 6 17.5988 6.00213 18.0613 6.06431C18.495 6.12263 18.631 6.21677 18.7071 6.2929C18.7832 6.36902 18.8774 6.50497 18.9357 6.93871C18.9979 7.40122 19 8.02893 19 9V10C19 10.5523 19.4477 11 20 11C20.5523 11 21 10.5523 21 10V9C21 8.97799 21 8.95604 21 8.93417C21 8.04769 21.0001 7.28387 20.9179 6.67221C20.8297 6.0167 20.631 5.38835 20.1213 4.87868C19.6117 4.36902 18.9833 4.17028 18.3278 4.08215C17.7161 3.99991 16.9523 3.99995 16.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0658 20C16.044 20 16.022 20 16 20L15 20C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18L16 18C16.9711 18 17.5988 17.9979 18.0613 17.9357C18.495 17.8774 18.631 17.7832 18.7071 17.7071C18.7832 17.631 18.8774 17.495 18.9357 17.0613C18.9979 16.5988 19 15.9711 19 15L19 14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14L21 15C21 15.022 21 15.044 21 15.0658C21 15.9523 21.0001 16.7161 20.9179 17.3278C20.8297 17.9833 20.631 18.6117 20.1213 19.1213C19.6117 19.631 18.9833 19.8297 18.3278 19.9179C17.7161 20.0001 16.9523 20 16.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 20C7.95604 20 7.97799 20 8 20L9.00001 20C9.55229 20 10 19.5523 10 19C10 18.4477 9.55229 18 9.00001 18L8 18C7.02893 18 6.40121 17.9979 5.93871 17.9357C5.50497 17.8774 5.36902 17.7832 5.2929 17.7071C5.21677 17.631 5.12263 17.495 5.06431 17.0613C5.00213 16.5988 5 15.9711 5 15L5 14C5 13.4477 4.55229 13 4 13C3.44772 13 3 13.4477 3 14L3 15C3 15.022 3 15.044 3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20 7.93417 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9C8.55228 9 9 9.44772 9 10V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V10C7 9.44772 7.44772 9 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C12.5523 9 13 9.44772 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10C11 9.44772 11.4477 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C16.5523 9 17 9.44772 17 10V14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14V10C15 9.44772 15.4477 9 16 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Barcode: {
        defaultColors: ["#3D4C66"],
        keywords: ["barcode","scan","scanner","product","item","price","lookup","identify","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Barcode-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["barcode","scan","scanner","product","price","lookup","item","code","sku","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10V9C20 7.11438 20 6.17157 19.4142 5.58579C18.8284 5 17.8856 5 16 5H15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19L15 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19L9 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bars-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","bars","navigation","options","list","hamburger","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H15H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H15H8C6.11438 9 5.17157 9 4.58579 9.58579C4 10.1716 4 11.1144 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7V19H14.9987L14.9998 7.00018C14.9999 6.0573 14.9999 5.58585 14.707 5.29293C14.4141 5 13.9427 5 12.9998 5H11C10.0572 5 9.58579 5 9.29289 5.29289C9 5.58579 9 6.05719 9 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15 19H9V7C9 6.05719 9 5.58579 9.29289 5.29289C9.58579 5 10.0572 5 11 5H12.9998C13.9427 5 14.4141 5 14.707 5.29293C14.9999 5.58585 14.9999 6.0573 14.9998 7.00018L14.9987 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bars-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["inventory","stock","management","warehouse","shelves","storage","organization","products","items","availability","count","statistics","dashboard","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 19V7C9 6.05719 9 5.58579 9.29289 5.29289C9.58579 5 10.0572 5 11 5H12.9998C13.9427 5 14.4141 5 14.707 5.29293C14.9999 5.58585 14.9999 6.0573 14.9998 7.00018L14.9987 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H12H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15V13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H8.99996"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11V7C9 6.05719 9 5.58579 9.29289 5.29289C9.58579 5 10.0572 5 11 5H12.9995C13.9425 5 14.414 5 14.7069 5.29297C14.9998 5.58594 14.9997 6.05744 14.9995 7.00043L14.9987 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bars-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bars","graph","statistics","report","sales","analysis","analytics","data","metrics","dashboard","performance","overview","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10C16 8.89543 16.8954 8 18 8H20C21.1046 8 22 8.89543 22 10V17C22 18.1046 21.1046 19 20 19H18C16.8954 19 16 18.1046 16 17V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2 10C2 8.89543 2.89543 8 4 8H6C7.10457 8 8 8.89543 8 10V17C8 18.1046 7.10457 19 6 19H4C2.89543 19 2 18.1046 2 17V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 6C9 4.89543 9.89543 4 11 4H13C14.1046 4 15 4.89543 15 6V17C15 18.1046 14.1046 19 13 19H11C9.89543 19 9 18.1046 9 17V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Bars: {
        defaultColors: ["#3D4C66"],
        keywords: ["bars","graph","statistics","report","sales","analysis","analytics","data","metrics","dashboard","performance","overview","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15V13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H8.99996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19H9V7C9 6.05719 9 5.58579 9.29289 5.29289C9.58579 5 10.0572 5 11 5H12.9998C13.9427 5 14.4141 5 14.707 5.29293C14.9999 5.58585 14.9999 6.0573 14.9998 7.00018L14.9987 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Baseball-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["baseball","sports","team","game","athletics","merchandise","ticket","event","product","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7C16.2066 7.99804 15 9.86346 15 12C15 14.1365 16.2066 16.002 18 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17C7.7934 16.002 9 14.1365 9 12C9 9.86346 7.7934 7.99804 6 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Baseball-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["baseball","sports","team","product","item","sale","inventory","menu","leisure","activity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.29167 6.00002C3.86651 7.59219 3 9.69476 3 12C3 14.3051 3.86656 16.4077 5.29167 18C6.71755 16.7415 7.69135 14.9826 7.93834 12.9981C7.41477 12.9663 7 12.5316 7 12C7 11.4684 7.41477 11.0337 7.93834 11.0019C7.69135 9.0174 6.71755 7.25853 5.29167 6.00002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.79125 4.65971C8.53506 6.27386 9.70258 8.50169 9.95062 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H9.95062C9.70257 15.4984 8.53502 17.7262 6.79117 19.3404C8.26129 20.3855 10.0589 21 12 21C13.9413 21 15.7388 20.3855 17.2089 19.3404C15.465 17.7262 14.2974 15.4984 14.0494 13H14C13.4477 13 13 12.5523 13 12C13 11.4477 13.4477 11 14 11H14.0494C14.2974 8.50165 15.465 6.27379 17.2088 4.65963C15.7387 3.61452 13.9411 3 12 3C11.7103 3 11.4234 3.01372 11.1402 3.04061C9.52901 3.19352 8.04166 3.77091 6.79125 4.65971Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7083 6.00002C17.2825 7.25853 16.3086 9.0174 16.0617 11.0019C16.5852 11.0337 17 11.4684 17 12C17 12.5316 16.5852 12.9663 16.0617 12.9981C16.3086 14.9826 17.2824 16.7414 18.7083 17.9999C19.9539 16.6081 20.7728 14.8262 20.9594 12.8598C20.9863 12.5766 21 12.2897 21 12C21 9.69494 20.1334 7.59228 18.7083 6.00002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Basket v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","buy","add-to-cart","view-cart","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11H6C4.89543 11 4 10.1046 4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9C20 10.1046 19.1046 11 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L8 5M18 7L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Baseball-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["baseball","sports","game","inventory","products","team"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 7C16.2066 7.99804 15 9.86346 15 12C15 14.1365 16.2066 16.002 18 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17C7.7934 16.002 9 14.1365 9 12C9 9.86346 7.7934 7.99804 6 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Basket v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","items","products","add-to-cart","remove-from-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 11.0001C4.25 11.0811 4.25781 11.161 4.27291 11.2388L4.6377 14.3395C4.78095 15.5572 4.89683 16.5424 5.08919 17.3142C5.28936 18.1174 5.59336 18.7844 6.17582 19.3023C6.75828 19.8203 7.45625 20.0443 8.2773 20.1492C9.06629 20.2501 10.0583 20.2501 11.2844 20.2501H12.7156C13.9417 20.2501 14.9337 20.2501 15.7227 20.1492C16.5437 20.0443 17.2417 19.8203 17.8242 19.3023C18.4066 18.7844 18.7106 18.1174 18.9108 17.3142C19.1032 16.5424 19.2191 15.5572 19.3623 14.3395L19.7271 11.2388C19.7422 11.161 19.75 11.0811 19.75 11.0001H4.25ZM11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V14ZM15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 4.29289C9.09763 4.68342 9.09763 5.31658 8.70711 5.70711L8.41421 6H15.5858L15.2929 5.70711C14.9024 5.31658 14.9024 4.68342 15.2929 4.29289C15.6834 3.90237 16.3166 3.90237 16.7071 4.29289L18.4142 6H19C20.1046 6 21 6.89543 21 8C21 9.10457 20.1046 10 19 10H5C3.89543 10 3 9.10457 3 8C3 6.89543 3.89543 6 5 6H5.58579L7.29289 4.29289C7.68342 3.90237 8.31658 3.90237 8.70711 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Baseball: {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","items","products","add-to-cart","remove-from-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7C16.2066 7.99804 15 9.86346 15 12C15 14.1365 16.2066 16.002 18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 17C7.7934 16.002 9 14.1365 9 12C9 9.86346 7.7934 7.99804 6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Basket v2-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","products","items","add-to-cart","view-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.6645 19H11.3355C8.79637 19 7.5268 19 6.67421 18.2418C5.82161 17.4837 5.67327 16.2228 5.37659 13.701L5.01377 10.617C5.00477 10.5795 5 10.5403 5 10.5L5.01377 10.617C5.06644 10.8367 5.26415 11 5.5 11H18.5C18.7358 11 18.9336 10.8367 18.9862 10.617L19 10.5C19 10.5403 18.9952 10.5795 18.9862 10.617L18.6234 13.701C18.3267 16.2228 18.1784 17.4837 17.3258 18.2418C16.4732 19 15.2036 19 12.6645 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11H6C4.89543 11 4 10.1046 4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9C20 10.1046 19.1046 11 18 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L8 5M18 7L16 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","purchase","checkout","order","items","products","sale","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11H6C4.89543 11 4 10.1046 4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9C20 10.1046 19.1046 11 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L8 5M18 7L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","items","products","buy","sale","retail","store","marketplace","add-to-cart","view-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15V13M14 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v3-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","buy","sale","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.8 5.60006C10.1314 5.15823 10.0418 4.53143 9.6 4.20006C9.15817 3.86869 8.53137 3.95823 8.2 4.40006L5.5 8.00006H4C3.44772 8.00006 3 8.44777 3 9.00006C3 9.55234 3.44772 10.0001 4 10.0001H4.09501L4.47127 13.7626C4.594 14.9903 4.69562 16.0068 4.88156 16.8087C5.07726 17.6527 5.3928 18.3884 6.03094 18.9659C6.66908 19.5434 7.43247 19.7842 8.29179 19.8949C9.10821 20.0001 10.1298 20.0001 11.3636 20.0001H12.6364C13.8702 20.0001 14.8918 20.0001 15.7082 19.8949C16.5675 19.7842 17.3309 19.5434 17.9691 18.9659C18.6072 18.3884 18.9227 17.6527 19.1184 16.8087C19.3044 16.0068 19.406 14.9903 19.5287 13.7627L19.905 10.0001H20C20.5523 10.0001 21 9.55234 21 9.00006C21 8.44777 20.5523 8.00006 20 8.00006H18.5L15.8 4.40006C15.4686 3.95823 14.8418 3.86869 14.4 4.20006C13.9582 4.53143 13.8686 5.15823 14.2 5.60006L16 8.00006H8L9.8 5.60006ZM11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V13ZM15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Basket v3-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","sale","add-to-cart","items","products","grocery","online-shopping","e-commerce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5 9H19L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.4597 13.597L6.20598 13.5224L5.4597 13.597ZM18.5403 13.597L19.2866 13.6717L18.5403 13.597ZM17.2981 18.2244L17.8013 18.7804L17.2981 18.2244ZM4 8.25C3.58579 8.25 3.25 8.58579 3.25 9C3.25 9.41421 3.58579 9.75 4 9.75V8.25ZM20 9.75C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25V9.75ZM4.25372 9.07463L4.71342 13.6716L6.20598 13.5224L5.74628 8.92537L4.25372 9.07463ZM11.4299 19.75H12.5701V18.25H11.4299V19.75ZM19.2866 13.6717L19.7463 9.07463L18.2537 8.92537L17.794 13.5224L19.2866 13.6717ZM12.5701 19.75C13.8403 19.75 14.8649 19.7515 15.6763 19.6469C16.5088 19.5396 17.2156 19.3105 17.8013 18.7804L16.7948 17.6683C16.5235 17.9138 16.1565 18.0726 15.4845 18.1592C14.7913 18.2485 13.8804 18.25 12.5701 18.25V19.75ZM17.794 13.5224C17.6636 14.8262 17.5716 15.7324 17.4137 16.4133C17.2606 17.0734 17.0661 17.4227 16.7948 17.6683L17.8013 18.7804C18.387 18.2504 18.6853 17.5699 18.8749 16.7522C19.0597 15.9553 19.1602 14.9356 19.2866 13.6717L17.794 13.5224ZM4.71342 13.6716C4.83982 14.9356 4.94032 15.9553 5.1251 16.7522C5.31471 17.5699 5.61295 18.2504 6.19869 18.7804L7.2052 17.6683C6.93386 17.4227 6.73938 17.0734 6.58633 16.4133C6.42845 15.7324 6.33637 14.8262 6.20598 13.5224L4.71342 13.6716ZM11.4299 18.25C10.1196 18.25 9.20872 18.2485 8.51548 18.1592C7.84347 18.0726 7.47654 17.9138 7.2052 17.6683L6.19869 18.7804C6.78443 19.3105 7.49118 19.5396 8.32375 19.6469C9.13507 19.7515 10.1597 19.75 11.4299 19.75V18.25ZM4 9.75H5V8.25H4V9.75ZM5 9.75H19V8.25H5V9.75ZM19 9.75H20V8.25H19V9.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M10 15V13M14 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","pos","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15V13M14 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","store","buy","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v4-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","purchase","checkout","order","items","products","summary","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 7.99991H18.5L15.8 4.39991C15.47 3.95991 14.84 3.86991 14.4 4.19991C13.96 4.52991 13.87 5.15991 14.2 5.59991L16 7.99991H8L9.8 5.59991C10.13 5.15991 10.04 4.52991 9.6 4.19991C9.16 3.86991 8.53 3.95991 8.2 4.39991L5.5 7.99991H4C3.45 7.99991 3 8.44991 3 8.99991C3 9.54991 3.45 9.99991 4 9.99991H4.1L4.48 13.7599C4.6 14.9899 4.7 15.9999 4.89 16.8099C5.09 17.6499 5.4 18.3899 6.04 18.9699C6.68 19.5499 7.44 19.7899 8.3 19.8999C9.12 20.0099 10.14 20.0099 11.37 20.0099H12.64C13.87 20.0099 14.9 20.0099 15.71 19.8999C16.57 19.7899 17.33 19.5499 17.97 18.9699C18.61 18.3899 18.92 17.6599 19.12 16.8099C19.31 16.0099 19.41 14.9899 19.53 13.7599L19.91 9.99991H20C20.55 9.99991 21 9.54991 21 8.99991C21 8.44991 20.55 7.99991 20 7.99991ZM10 14.9999C10 15.5499 9.55 15.9999 9 15.9999C8.45 15.9999 8 15.5499 8 14.9999V12.9999C8 12.4499 8.45 11.9999 9 11.9999C9.55 11.9999 10 12.4499 10 12.9999V14.9999ZM13 14.9999C13 15.5499 12.55 15.9999 12 15.9999C11.45 15.9999 11 15.5499 11 14.9999V12.9999C11 12.4499 11.45 11.9999 12 11.9999C12.55 11.9999 13 12.4499 13 12.9999V14.9999ZM16 14.9999C16 15.5499 15.55 15.9999 15 15.9999C14.45 15.9999 14 15.5499 14 14.9999V12.9999C14 12.4499 14.45 11.9999 15 11.9999C15.55 11.9999 16 12.4499 16 12.9999V14.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Basket v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping-cart","cart","checkout","order","purchase","buy","products","items","sale","add-to-cart","trolley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v4-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","sale","items","products","add-to-cart","shopping-basket","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5 9H19L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.4597 13.597L6.20598 13.5224L5.4597 13.597ZM18.5403 13.597L19.2866 13.6717L18.5403 13.597ZM17.2981 18.2244L17.8013 18.7804L17.2981 18.2244ZM4 8.25C3.58579 8.25 3.25 8.58579 3.25 9C3.25 9.41421 3.58579 9.75 4 9.75V8.25ZM20 9.75C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25V9.75ZM4.25372 9.07463L4.71342 13.6716L6.20598 13.5224L5.74628 8.92537L4.25372 9.07463ZM11.4299 19.75H12.5701V18.25H11.4299V19.75ZM19.2866 13.6717L19.7463 9.07463L18.2537 8.92537L17.794 13.5224L19.2866 13.6717ZM12.5701 19.75C13.8403 19.75 14.8649 19.7515 15.6763 19.6469C16.5088 19.5396 17.2156 19.3105 17.8013 18.7804L16.7948 17.6683C16.5235 17.9138 16.1565 18.0726 15.4845 18.1592C14.7913 18.2485 13.8804 18.25 12.5701 18.25V19.75ZM17.794 13.5224C17.6636 14.8262 17.5716 15.7324 17.4137 16.4133C17.2606 17.0734 17.0661 17.4227 16.7948 17.6683L17.8013 18.7804C18.387 18.2504 18.6853 17.5699 18.8749 16.7522C19.0597 15.9553 19.1602 14.9356 19.2866 13.6717L17.794 13.5224ZM4.71342 13.6716C4.83982 14.9356 4.94032 15.9553 5.1251 16.7522C5.31471 17.5699 5.61295 18.2504 6.19869 18.7804L7.2052 17.6683C6.93386 17.4227 6.73938 17.0734 6.58633 16.4133C6.42845 15.7324 6.33637 14.8262 6.20598 13.5224L4.71342 13.6716ZM11.4299 18.25C10.1196 18.25 9.20872 18.2485 8.51548 18.1592C7.84347 18.0726 7.47654 17.9138 7.2052 17.6683L6.19869 18.7804C6.78443 19.3105 7.49118 19.5396 8.32375 19.6469C9.13507 19.7515 10.1597 19.75 11.4299 19.75V18.25ZM4 9.75H5V8.25H4V9.75ZM5 9.75H19V8.25H5V9.75ZM19 9.75H20V8.25H19V9.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M9 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L9 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 9L15 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Basket v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["basket","shopping-basket","cart","shopping-cart","checkout","purchase","order","summary","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13M12 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Basket v5-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","items","products","sale","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 8H16.9C16.44 5.72 14.42 4 12 4C9.58 4 7.56 5.72 7.1 8H4C3.45 8 3 8.45 3 9C3 9.55 3.45 10 4 10V13.07C4 14.42 4 15.54 4.12 16.42C4.24 17.35 4.52 18.17 5.17 18.82C5.82 19.47 6.65 19.75 7.57 19.87C8.45 19.99 9.57 19.99 10.92 19.99H13.06C14.41 19.99 15.53 19.99 16.41 19.87C17.34 19.75 18.16 19.47 18.81 18.82C19.47 18.16 19.74 17.34 19.86 16.42C19.98 15.54 19.98 14.42 19.98 13.07V10C20.53 10 21 9.55 21 9C21 8.45 20.53 8 19.98 8H20ZM10 15C10 15.55 9.55 16 9 16C8.45 16 8 15.55 8 15V13C8 12.45 8.45 12 9 12C9.55 12 10 12.45 10 13V15ZM13 15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V13C11 12.45 11.45 12 12 12C12.55 12 13 12.45 13 13V15ZM9.18 8C9.59 6.84 10.69 6 12 6C13.31 6 14.4 6.84 14.82 8H9.18ZM16 15C16 15.55 15.55 16 15 16C14.45 16 14 15.55 14 15V13C14 12.45 14.45 12 15 12C15.55 12 16 12.45 16 13V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Basket v5-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","order","purchase","products","items","summary","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V9H19V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M18.1213 18.1213L18.6517 18.6517L18.6517 18.6517L18.1213 18.1213ZM5.87868 18.1213L5.34835 18.6517L5.34835 18.6517L5.87868 18.1213ZM4 8.25C3.58579 8.25 3.25 8.58579 3.25 9C3.25 9.41421 3.58579 9.75 4 9.75V8.25ZM20 9.75C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25V9.75ZM4.25 9V13H5.75V9H4.25ZM11 19.75H13V18.25H11V19.75ZM19.75 13V9H18.25V13H19.75ZM13 19.75C14.393 19.75 15.5132 19.7516 16.3918 19.6335C17.2919 19.5125 18.0497 19.2536 18.6517 18.6517L17.591 17.591C17.3142 17.8678 16.9257 18.0482 16.1919 18.1469C15.4365 18.2484 14.4354 18.25 13 18.25V19.75ZM18.25 13C18.25 14.4354 18.2484 15.4365 18.1469 16.1919C18.0482 16.9257 17.8678 17.3142 17.591 17.591L18.6517 18.6517C19.2536 18.0497 19.5125 17.2919 19.6335 16.3918C19.7516 15.5132 19.75 14.393 19.75 13H18.25ZM4.25 13C4.25 14.393 4.24841 15.5132 4.36652 16.3918C4.48754 17.2919 4.74643 18.0497 5.34835 18.6517L6.40901 17.591C6.13225 17.3142 5.9518 16.9257 5.85315 16.1919C5.75159 15.4365 5.75 14.4354 5.75 13H4.25ZM11 18.25C9.56458 18.25 8.56347 18.2484 7.80812 18.1469C7.07434 18.0482 6.68577 17.8678 6.40901 17.591L5.34835 18.6517C5.95027 19.2536 6.70814 19.5125 7.60825 19.6335C8.48678 19.7516 9.60699 19.75 11 19.75V18.25ZM4 9.75H5V8.25H4V9.75ZM5 9.75H19V8.25H5V9.75ZM19 9.75H20V8.25H19V9.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M9 15V13M12 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Basket v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping","cart","checkout","purchase","order","items","products","summary","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13M12 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Basket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["basket","shopping","cart","order","checkout","purchase","items","products","summary","view-cart","online-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Basket-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping-basket","cart","shopping-cart","checkout","order","items","products","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 8H7.10002C7.56329 5.71776 9.58104 4 12 4C14.419 4 16.4367 5.71776 16.9 8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H19.905L19.5287 13.7626C19.406 14.9902 19.3044 16.0067 19.1184 16.8086C18.9227 17.6527 18.6072 18.3883 17.9691 18.9658C17.3309 19.5433 16.5675 19.7841 15.7082 19.8948C14.8918 20.0001 13.8702 20 12.6364 20H11.3636C10.1298 20 9.10821 20.0001 8.29179 19.8948C7.43247 19.7841 6.66908 19.5433 6.03094 18.9658C5.3928 18.3883 5.07726 17.6527 4.88156 16.8086C4.69562 16.0067 4.594 14.9902 4.47127 13.7625L4.09501 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8ZM12 6C13.3062 6 14.4175 6.83481 14.8293 8H9.17071C9.58254 6.83481 10.6938 6 12 6ZM10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13V15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15V13ZM13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13ZM16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Basket-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["basket","shopping-basket","cart","shopping-cart","checkout","purchase","buy","order","items","products","trolley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5 9H19L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.4597 13.597L6.20598 13.5224L5.4597 13.597ZM18.5403 13.597L19.2866 13.6717L18.5403 13.597ZM17.2981 18.2244L17.8013 18.7804L17.2981 18.2244ZM4 8.25C3.58579 8.25 3.25 8.58579 3.25 9C3.25 9.41421 3.58579 9.75 4 9.75V8.25ZM20 9.75C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25V9.75ZM4.25372 9.07463L4.71342 13.6716L6.20598 13.5224L5.74628 8.92537L4.25372 9.07463ZM11.4299 19.75H12.5701V18.25H11.4299V19.75ZM19.2866 13.6717L19.7463 9.07463L18.2537 8.92537L17.794 13.5224L19.2866 13.6717ZM12.5701 19.75C13.8403 19.75 14.8649 19.7515 15.6763 19.6469C16.5088 19.5396 17.2156 19.3105 17.8013 18.7804L16.7948 17.6683C16.5235 17.9138 16.1565 18.0726 15.4845 18.1592C14.7913 18.2485 13.8804 18.25 12.5701 18.25V19.75ZM17.794 13.5224C17.6636 14.8262 17.5716 15.7324 17.4137 16.4133C17.2606 17.0734 17.0661 17.4227 16.7948 17.6683L17.8013 18.7804C18.387 18.2504 18.6853 17.5699 18.8749 16.7522C19.0597 15.9553 19.1602 14.9356 19.2866 13.6717L17.794 13.5224ZM4.71342 13.6716C4.83982 14.9356 4.94032 15.9553 5.1251 16.7522C5.31471 17.5699 5.61295 18.2504 6.19869 18.7804L7.2052 17.6683C6.93386 17.4227 6.73938 17.0734 6.58633 16.4133C6.42845 15.7324 6.33637 14.8262 6.20598 13.5224L4.71342 13.6716ZM11.4299 18.25C10.1196 18.25 9.20872 18.2485 8.51548 18.1592C7.84347 18.0726 7.47654 17.9138 7.2052 17.6683L6.19869 18.7804C6.78443 19.3105 7.49118 19.5396 8.32375 19.6469C9.13507 19.7515 10.1597 19.75 11.4299 19.75V18.25ZM4 9.75H5V8.25H4V9.75ZM5 9.75H19V8.25H5V9.75ZM19 9.75H20V8.25H19V9.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M9 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Basket: {
        defaultColors: ["#3D4C66"],
        keywords: ["basket","shopping-basket","cart","shopping-cart","checkout","purchase","buy","order","items","products","trolley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.4597 13.597C5.71648 16.1648 5.84487 17.4487 6.70195 18.2244C7.55902 19 8.84932 19 11.4299 19H12.5701C15.1507 19 16.441 19 17.2981 18.2244C18.1551 17.4487 18.2835 16.1648 18.5403 13.597L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bathtub-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bathtub","bath","spa","salon","hygiene","grooming","services","appointments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 11V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 11H4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 6H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 19L8 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 19L16 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bathtub-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bathtub","tub","plumbing","hotel","bathroom","amenities","service","cleaning","restroom","room"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 19L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 19L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 11V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 13V11H5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5.87868 18.1213L6.40901 17.591L5.87868 18.1213ZM18.1213 18.1213L18.6517 18.6517L18.1213 18.1213ZM20 11.75C20.4142 11.75 20.75 11.4142 20.75 11C20.75 10.5858 20.4142 10.25 20 10.25V11.75ZM4 10.25C3.58579 10.25 3.25 10.5858 3.25 11C3.25 11.4142 3.58579 11.75 4 11.75V10.25ZM18.25 11V13H19.75V11H18.25ZM13 18.25H11V19.75H13V18.25ZM5.75 13V11H4.25V13H5.75ZM11 18.25C9.56458 18.25 8.56347 18.2484 7.80812 18.1469C7.07434 18.0482 6.68577 17.8678 6.40901 17.591L5.34835 18.6517C5.95027 19.2536 6.70814 19.5125 7.60825 19.6335C8.48678 19.7516 9.60699 19.75 11 19.75V18.25ZM4.25 13C4.25 14.393 4.24841 15.5132 4.36652 16.3918C4.48754 17.2919 4.74643 18.0497 5.34835 18.6517L6.40901 17.591C6.13225 17.3142 5.9518 16.9257 5.85315 16.1919C5.75159 15.4365 5.75 14.4354 5.75 13H4.25ZM18.25 13C18.25 14.4354 18.2484 15.4365 18.1469 16.1919C18.0482 16.9257 17.8678 17.3142 17.591 17.591L18.6517 18.6517C19.2536 18.0497 19.5125 17.2919 19.6335 16.3918C19.7516 15.5132 19.75 14.393 19.75 13H18.25ZM13 19.75C14.393 19.75 15.5132 19.7516 16.3918 19.6335C17.2919 19.5125 18.0497 19.2536 18.6517 18.6517L17.591 17.591C17.3142 17.8678 16.9257 18.0482 16.1919 18.1469C15.4365 18.2484 14.4354 18.25 13 18.25V19.75ZM20 10.25H19V11.75H20V10.25ZM19 10.25H5V11.75H19V10.25ZM5 10.25H4V11.75H5V10.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bathtub-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bathtub","tub","cleaning","plumbing","service","appointment","maintenance","schedule","hygiene"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5C7.44772 5 7 5.44772 7 6V10H20C20.5523 10 21 10.4477 21 11C21 11.5523 20.5523 12 20 12V13.0705C20 14.4247 20.0001 15.5413 19.8812 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.3114 19.3454 17.693 19.6239 17 19.7798V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V19.9831C14.4213 20 13.7784 20 13.0706 20H10.9294C10.2216 20 9.57868 20 9 19.9831V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V19.7798C6.30702 19.6239 5.68859 19.3454 5.17157 18.8284C4.51546 18.1723 4.2435 17.3529 4.11875 16.4251C3.99993 15.5413 3.99996 14.4247 4 13.0706V12C3.44772 12 3 11.5523 3 11C3 10.4477 3.44772 10 4 10H5V6C5 4.34315 6.34315 3 8 3C9.30622 3 10.4175 3.83481 10.8293 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H9C8.44772 7 8 6.55228 8 6C8 5.62986 8.2011 5.30669 8.5 5.13378C8.35291 5.0487 8.18214 5 8 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bathtub: {
        defaultColors: ["#3D4C66"],
        keywords: ["bathtub","tub","cleaning","plumbing","service","appointment","maintenance","schedule","hygiene"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 11H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 6H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 19L8 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 19L16 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 11V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Battery charging-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["battery","charging","power","device-status","low-battery","full-battery","energy","electricity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["battery","charging","power","energy","device-power","battery-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17H8C6.11438 17 5.17157 17 4.58579 16.4142C4 15.8284 4 14.8856 4 13V11C4 9.11438 4 8.17157 4.58579 7.58579C5.17157 7 6.11438 7 8 7H9M13 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V13C18 14.8856 18 15.8284 17.4142 16.4142C16.8284 17 15.8856 17 14 17H13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","charge","power","charging","low battery","battery level","power supply","device power","system power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 6L8 6H9C9.55229 6 10 6.44772 10 7C10 7.55229 9.55229 8 9 8H8C7.02893 8 6.40122 8.00213 5.93871 8.06431C5.50497 8.12263 5.36902 8.21677 5.2929 8.2929C5.21677 8.36902 5.12263 8.50497 5.06431 8.93871C5.00213 9.40122 5 10.0289 5 11V13C5 13.9711 5.00213 14.5988 5.06431 15.0613C5.12263 15.495 5.21677 15.631 5.2929 15.7071C5.36902 15.7832 5.50497 15.8774 5.93871 15.9357C6.40122 15.9979 7.02893 16 8 16H9C9.55229 16 10 16.4477 10 17C10 17.5523 9.55229 18 9 18L7.93417 18C7.04769 18.0001 6.28387 18.0001 5.67221 17.9179C5.0167 17.8297 4.38835 17.631 3.87868 17.1213C3.36902 16.6117 3.17028 15.9833 3.08215 15.3278C2.99991 14.7161 2.99995 13.9523 3 13.0658L3 13V11L3 10.9342C2.99995 10.0477 2.99991 9.28387 3.08215 8.67221C3.17028 8.0167 3.36902 7.38835 3.87868 6.87868C4.38835 6.36902 5.0167 6.17028 5.67221 6.08215C6.28387 5.99991 7.04769 5.99995 7.93417 6ZM16.0613 8.06431C15.5988 8.00213 14.9711 8 14 8H13C12.4477 8 12 7.55229 12 7C12 6.44772 12.4477 6 13 6L14.0658 6C14.9523 5.99995 15.7161 5.99991 16.3278 6.08215C16.9833 6.17028 17.6117 6.36902 18.1213 6.87868C18.631 7.38835 18.8297 8.0167 18.9179 8.67221C19.0001 9.28387 19.0001 10.0477 19 10.9342V13.0658C19.0001 13.9523 19.0001 14.7161 18.9179 15.3278C18.8297 15.9833 18.631 16.6117 18.1213 17.1213C17.6117 17.631 16.9833 17.8297 16.3278 17.9179C15.7161 18.0001 14.9523 18.0001 14.0658 18L13 18C12.4477 18 12 17.5523 12 17C12 16.4477 12.4477 16 13 16H14C14.9711 16 15.5988 15.9979 16.0613 15.9357C16.495 15.8774 16.631 15.7832 16.7071 15.7071C16.7832 15.631 16.8774 15.495 16.9357 15.0613C16.9979 14.5988 17 13.9711 17 13V11C17 10.0289 16.9979 9.40122 16.9357 8.93871C16.8774 8.50497 16.7832 8.36902 16.7071 8.2929C16.631 8.21677 16.495 8.12263 16.0613 8.06431ZM21 9C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V10C20 9.44772 20.4477 9 21 9ZM10.1053 9.55283C10.3523 9.05883 10.953 8.85856 11.447 9.10551C11.9409 9.35246 12.1412 9.95312 11.8943 10.4471L11.6179 11H12C12.3466 11 12.6685 11.1794 12.8507 11.4743C13.0329 11.7691 13.0494 12.1373 12.8944 12.4473L11.8942 14.4473C11.6472 14.9412 11.0465 15.1414 10.5525 14.8944C10.0586 14.6473 9.85839 14.0467 10.1054 13.5527L10.3818 13H10C9.65343 13 9.33158 12.8205 9.14937 12.5257C8.96716 12.2309 8.95057 11.8628 9.10554 11.5528L10.1053 9.55283Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Battery charging-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["battery","charging","power","electricity","device","low-battery","battery-level","charge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="7"
                    width="14"
                    height="10"
                    rx="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M20 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","charging","power","electricity","device-power","low-battery","full-battery","power-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 6C7.04769 5.99995 6.28387 5.99991 5.67221 6.08215C5.0167 6.17028 4.38835 6.36902 3.87868 6.87868C3.36902 7.38835 3.17028 8.0167 3.08215 8.67221C2.99991 9.28387 2.99995 10.0477 3 10.9342V13.0658C2.99995 13.9523 2.99991 14.7161 3.08215 15.3278C3.17028 15.9833 3.36902 16.6117 3.87868 17.1213C4.38835 17.631 5.0167 17.8297 5.67221 17.9179C6.28387 18.0001 7.04769 18.0001 7.93417 18H14.0658C14.9523 18.0001 15.7161 18.0001 16.3278 17.9179C16.9833 17.8297 17.6117 17.631 18.1213 17.1213C18.631 16.6117 18.8297 15.9833 18.9179 15.3278C19.0001 14.7161 19.0001 13.9523 19 13.0658V10.9342C19.0001 10.0477 19.0001 9.28387 18.9179 8.67221C18.8297 8.0167 18.631 7.38835 18.1213 6.87868C17.6117 6.36902 16.9833 6.17028 16.3278 6.08215C15.7161 5.99991 14.9523 5.99995 14.0658 6H7.93417ZM10.1053 9.55283C10.3523 9.05883 10.953 8.85856 11.447 9.10551C11.9409 9.35246 12.1412 9.95312 11.8943 10.4471L11.6179 11H12C12.3466 11 12.6685 11.1794 12.8507 11.4743C13.0329 11.7691 13.0494 12.1373 12.8944 12.4473L11.8942 14.4473C11.6472 14.9412 11.0465 15.1414 10.5525 14.8944C10.0586 14.6473 9.85839 14.0467 10.1054 13.5527L10.3818 13H10C9.65343 13 9.33158 12.8205 9.14937 12.5257C8.96716 12.2309 8.95057 11.8628 9.10554 11.5528L10.1053 9.55283Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 9C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V10C20 9.44772 20.4477 9 21 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Battery charging-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","charging","power","electricity","device-status","low-battery","full-battery","charge-status","energy","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="20"
                    width="14"
                    height="10"
                    rx="2"
                    transform="rotate(-90 7 20)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 4L14 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 11.2682L11.1342 13.5001L12.8662 12.5001L13 14.7323"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["battery","charge","charging","power","energy","device","electricity","status","low-battery","full-battery","charging-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="20"
                    width="14"
                    height="10"
                    rx="2"
                    transform="rotate(-90 7 20)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 4L14 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 11.2682L11.1342 13.5001L12.8662 12.5001L13 14.7323"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","charging","power","electricity","device","energy","charge","battery-level","low-battery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 2C9.44772 2 9 2.44772 9 3C9 3.55228 9.44772 4 10 4L14 4C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.08215 18.3278C5.99991 17.7161 5.99995 16.9523 6 16.0658L6 9.93417C5.99995 9.04768 5.99991 8.28386 6.08215 7.6722C6.17028 7.01669 6.36902 6.38834 6.87868 5.87868C7.38835 5.36901 8.0167 5.17027 8.67221 5.08214C9.28387 4.9999 10.0477 4.99994 10.9342 4.99999L13.0658 4.99999C13.9523 4.99994 14.7161 4.9999 15.3278 5.08214C15.9833 5.17027 16.6117 5.36901 17.1213 5.87868C17.631 6.38834 17.8297 7.01669 17.9179 7.6722C18.0001 8.28386 18.0001 9.04768 18 9.93416V16.0658C18.0001 16.9523 18.0001 17.7161 17.9179 18.3278C17.8297 18.9833 17.631 19.6117 17.1213 20.1213C16.6117 20.631 15.9833 20.8297 15.3278 20.9179C14.7161 21.0001 13.9523 21 13.0659 21H10.9342C10.0477 21 9.28387 21.0001 8.67221 20.9179C8.0167 20.8297 7.38835 20.631 6.87868 20.1213C6.36902 19.6117 6.17028 18.9833 6.08215 18.3278ZM12 11C12 10.4477 11.5523 9.99999 11 10C10.4477 10 9.99999 10.4477 10 11L10 14C10 14.4045 10.2437 14.7691 10.6174 14.9239C10.991 15.0786 11.4212 14.9931 11.7071 14.7071L11.9997 14.4145L11.9997 15.0001C11.9996 15.5524 12.4473 16.0001 12.9996 16.0002C13.5519 16.0002 13.9996 15.5525 13.9997 15.0003L13.9999 12.0001C13.9999 11.5957 13.7563 11.231 13.3826 11.0762C13.0089 10.9214 12.5788 11.0069 12.2928 11.293L12 11.5858L12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Battery charging-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","charging","power","energy","electricity","full-battery","device-power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17H8C6.11438 17 5.17157 17 4.58579 16.4142C4 15.8284 4 14.8856 4 13V11C4 9.11438 4 8.17157 4.58579 7.58579C5.17157 7 6.11438 7 8 7H9M13 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V13C18 14.8856 18 15.8284 17.4142 16.4142C16.8284 17 15.8856 17 14 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["battery","charging","power","energy","electricity","low-battery","battery-status","device-power","terminal-power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17H8C6.11438 17 5.17157 17 4.58579 16.4142C4 15.8284 4 14.8856 4 13V11C4 9.11438 4 8.17157 4.58579 7.58579C5.17157 7 6.11438 7 8 7H9M13 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V13C18 14.8856 18 15.8284 17.4142 16.4142C16.8284 17 15.8856 17 14 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","power","charging","electricity","full-battery","low-battery","device-status","system-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.9998 10L10 12H12L10.9998 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["battery","power","charge","battery-level","full-battery","device-power","terminal-battery","low-battery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["battery","charge","power","device","low-battery","full-battery","battery-level","electricity","energy","terminal-battery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="7"
                    width="14"
                    height="10"
                    rx="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M20 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery charging-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["battery","charge","power","energy","outlet","charging","battery-level"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="7"
                    y="20"
                    width="14"
                    height="10"
                    rx="2"
                    transform="rotate(-90 7 20)"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 4L14 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 11.2682L11.1342 13.5001L12.8662 12.5001L13 14.7323"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","low-battery","power","charge","battery-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","low-battery","power","charge","energy","device-power","low-power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 6C7.04769 5.99995 6.28387 5.99991 5.67221 6.08215C5.0167 6.17028 4.38835 6.36902 3.87868 6.87868C3.36902 7.38835 3.17028 8.0167 3.08215 8.67221C2.99991 9.28387 2.99995 10.0477 3 10.9342V13.0658C2.99995 13.9523 2.99991 14.7161 3.08215 15.3278C3.17028 15.9833 3.36902 16.6117 3.87868 17.1213C4.38835 17.631 5.0167 17.8297 5.67221 17.9179C6.28387 18.0001 7.04769 18.0001 7.93417 18H14.0658C14.9523 18.0001 15.7161 18.0001 16.3278 17.9179C16.9833 17.8297 17.6117 17.631 18.1213 17.1213C18.631 16.6117 18.8297 15.9833 18.9179 15.3278C19.0001 14.7161 19.0001 13.9523 19 13.0658V10.9342C19.0001 10.0477 19.0001 9.28387 18.9179 8.67221C18.8297 8.0167 18.631 7.38835 18.1213 6.87868C17.6117 6.36902 16.9833 6.17028 16.3278 6.08215C15.7161 5.99991 14.9523 5.99995 14.0658 6H7.93417ZM8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10V14C6 14.5523 6.44772 15 7 15C7.55228 15 8 14.5523 8 14V10ZM11.5 10C11.5 9.44772 11.0523 9 10.5 9C9.94772 9 9.5 9.44772 9.5 10V14C9.5 14.5523 9.94772 15 10.5 15C11.0523 15 11.5 14.5523 11.5 14V10ZM14 9C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15C13.4477 15 13 14.5523 13 14V10C13 9.44772 13.4477 9 14 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 9C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V10C20 9.44772 20.4477 9 21 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Battery-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["battery","power","low-battery","charge","device","terminal","equipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Battery-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","low-battery","power","charge","battery-level","energy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 6C7.04769 5.99995 6.28387 5.99991 5.67221 6.08215C5.0167 6.17028 4.38835 6.36902 3.87868 6.87868C3.36902 7.38835 3.17028 8.0167 3.08215 8.67221C2.99991 9.28387 2.99995 10.0477 3 10.9342V13.0658C2.99995 13.9523 2.99991 14.7161 3.08215 15.3278C3.17028 15.9833 3.36902 16.6117 3.87868 17.1213C4.38835 17.631 5.0167 17.8297 5.67221 17.9179C6.28387 18.0001 7.04769 18.0001 7.93417 18H14.0658C14.9523 18.0001 15.7161 18.0001 16.3278 17.9179C16.9833 17.8297 17.6117 17.631 18.1213 17.1213C18.631 16.6117 18.8297 15.9833 18.9179 15.3278C19.0001 14.7161 19.0001 13.9523 19 13.0658V10.9342C19.0001 10.0477 19.0001 9.28387 18.9179 8.67221C18.8297 8.0167 18.631 7.38835 18.1213 6.87868C17.6117 6.36902 16.9833 6.17028 16.3278 6.08215C15.7161 5.99991 14.9523 5.99995 14.0658 6H7.93417ZM21 9C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V10C20 9.44772 20.4477 9 21 9ZM8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10V14C6 14.5523 6.44772 15 7 15C7.55228 15 8 14.5523 8 14V10ZM11.5 10C11.5 9.44772 11.0523 9 10.5 9C9.94772 9 9.5 9.44772 9.5 10V14C9.5 14.5523 9.94772 15 10.5 15C11.0523 15 11.5 14.5523 11.5 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Battery-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["battery","low-battery","power","device","charge","battery-level","energy","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="7"
                    width="14"
                    height="10"
                    rx="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M20 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Battery: {
        defaultColors: ["#3D4C66"],
        keywords: ["battery","low-battery","power","device","charge","battery-level","energy","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="7" width="14" height="10" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M20 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "beat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["beat","graph","analytics","pulse","fluctuations","trends","sales-performance","metrics","analysis","oscillations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 11L11 6L13 18L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H9M18 13H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    beat: {
        defaultColors: ["#3D4C66"],
        keywords: ["beat","graph","analytics","pulse","fluctuations","trends","sales-performance","metrics","analysis","oscillations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11H9L11 6L13 18L15 13H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "beat-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["beat","pulse","signal","health","monitoring","heartbeat","data","analytics","sales-trend","activity","fluctuation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11H9L11 6L13 18L15 13H18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bed-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bed","hotel","room","accommodation","lodging","sleep","checkout","check-in","reservation","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 10V10C18 8.11438 18 7.17157 17.4142 6.58579C16.8284 6 15.8856 6 14 6H10C8.11438 6 7.17157 6 6.58579 6.58579C6 7.17157 6 8.11438 6 10V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14V16H4V14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16V18M20 16V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "beat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","pulse","sales-trend","trend","activity","graph","frequency","transaction-activity","heartbeat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1074 5.00583C11.5533 5.05403 11.9126 5.39323 11.9864 5.83564L13.3988 14.3103L14.0715 12.6286C14.2234 12.249 14.5911 12 15 12H18C18.5522 12 19 12.4478 19 13C19 13.5523 18.5522 14 18 14H15.677L13.9284 18.3714C13.7619 18.7879 13.3384 19.0424 12.8925 18.9942C12.4466 18.946 12.0873 18.6068 12.0136 18.1644L10.6011 9.68977L9.92848 11.3714C9.77662 11.7511 9.40891 12 9 12H6C5.44772 12 5 11.5523 5 11C5 10.4478 5.44772 10 6 10H8.32296L10.0715 5.62865C10.2381 5.21222 10.6615 4.95763 11.1074 5.00583Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bed-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bed","room","hotel","lodging","accommodation","stay","night","vacancy","rest","sleep","available","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6H10C8.11438 6 7.17157 6 6.58579 6.58579C6 7.17157 6 8.11438 6 10H18C18 8.11438 18 7.17157 17.4142 6.58579C16.8284 6 15.8856 6 14 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16V18M20 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14V16H4V14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bed","room","accommodation","hotel","motel","booking","reservation","sleep","lodging","furniture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.93418 5C9.04769 4.99995 8.28387 4.99991 7.67221 5.08215C7.0167 5.17028 6.38835 5.36902 5.87868 5.87868C5.36902 6.38835 5.17028 7.0167 5.08215 7.67221C5.0594 7.84138 5.04295 8.02219 5.03105 8.21401C5.23953 8.15294 5.45437 8.11143 5.67221 8.08215C6.28387 7.99991 7.04769 7.99995 7.93417 8H16.0658C16.9523 7.99995 17.7161 7.99991 18.3278 8.08215C18.5456 8.11143 18.7605 8.15294 18.969 8.21401C18.9571 8.02219 18.9406 7.84138 18.9179 7.67221C18.8297 7.0167 18.631 6.38835 18.1213 5.87868C17.6117 5.36902 16.9833 5.17028 16.3278 5.08215C15.7161 4.99991 14.9523 4.99995 14.0658 5H9.93418Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 15C4.55228 15 5 16.4477 5 17V18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18V16C3 15.4477 3.44772 15 4 15ZM20 15C20.5523 15 21 15.4477 21 16V18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18V16C19 15.4477 19.4477 15 20 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 9C7.95604 9 7.97799 9 8 9L16.0658 9C16.9523 8.99995 17.7161 8.99991 18.3278 9.08215C18.9833 9.17028 19.6117 9.36902 20.1213 9.87868C20.631 10.3883 20.8297 11.0167 20.9179 11.6722C21.0001 12.2839 21.0001 13.0477 21 13.9342L21 16C21 16.5523 20.5523 17 20 17H4C3.44772 17 3 16.5523 3 16L3 14C3 13.978 3 13.956 3 13.9342C2.99995 13.0477 2.99991 12.2839 3.08215 11.6722C3.17028 11.0167 3.36902 10.3883 3.87868 9.87868C4.38835 9.36902 5.0167 9.17028 5.67221 9.08215C6.28387 8.99991 7.04769 8.99995 7.93417 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bee 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bee","bug","pollination","honey","sweetener","farm","nature","food","buzz"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12.0001C4 9.84697 6.14085 8.49869 8 9.16649V14.8337C6.14085 15.5015 4 14.1532 4 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12.0001C20 9.84697 17.8592 8.49869 16 9.16649L16 14.8337C17.8591 15.5015 20 14.1532 20 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 10H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bee 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bee","rewards","loyalty","points","honey","earn","sweet","collect","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12.0001C4 9.84697 6.14085 8.49869 8 9.16649V14.8337C6.14085 15.5015 4 14.1532 4 12.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12.0001C20 9.84697 17.8592 8.49869 16 9.16649L16 14.8337C17.8591 15.5015 20 14.1532 20 12.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    bed: {
        defaultColors: ["#3D4C66"],
        keywords: ["bee","rewards","loyalty","points","honey","earn","sweet","collect","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14V16H4V14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V10C18 8.11438 18 7.17157 17.4142 6.58579C16.8284 6 15.8856 6 14 6H10C8.11438 6 7.17157 6 6.58579 6.58579C6 7.17157 6 8.11438 6 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16V18M20 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bee 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bee","honey","rewards","loyalty","membership","points"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12.0001C4 9.84697 6.14085 8.49869 8 9.16649V14.8337C6.14085 15.5015 4 14.1532 4 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12.0001C20 9.84697 17.8592 8.49869 16 9.16649L16 14.8337C17.8591 15.5015 20 14.1532 20 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bee 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bee","honey","rewards","loyalty","VIP","membership","customer","loyalty-program","discounts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5905 8.01503C16.1368 6.96716 15.3347 6.1052 14.3304 5.57517L14.3416 5.5528C14.4853 5.26548 14.5603 5.11812 14.6237 5.01859L14.6266 5.01396L14.6321 5.01338C14.7494 5.00124 14.9148 5.00001 15.236 5.00001H16C16.5523 5.00001 17 4.55229 17 4.00001C17 3.44773 16.5523 3.00001 16 3.00001L15.1986 3C14.9305 2.99995 14.6593 2.9999 14.4264 3.02398C14.1596 3.05157 13.8609 3.11681 13.5665 3.29871C13.2722 3.48061 13.0803 3.71862 12.9363 3.94493C12.8106 4.14248 12.6894 4.38506 12.5695 4.62486L12.375 5.01385C12.2512 5.00467 12.1262 5 12 5C11.8738 5 11.7488 5.00467 11.625 5.01385L11.4305 4.62486C11.3106 4.38506 11.1894 4.14248 11.0637 3.94493C10.9197 3.71862 10.7278 3.48061 10.4335 3.29871C10.1391 3.11681 9.84041 3.05157 9.57359 3.02398C9.34068 2.9999 9.0695 2.99995 8.80142 3L8.00003 3.00001C7.44774 3.00001 7.00003 3.44773 7.00003 4.00001C7.00003 4.55229 7.44774 5.00001 8.00002 5.00001H8.76396C9.08519 5.00001 9.25056 5.00124 9.3679 5.01338L9.37337 5.01396L9.37634 5.01859C9.43967 5.11812 9.51472 5.26548 9.65838 5.5528L9.66957 5.57517C8.66525 6.10521 7.86323 6.96716 7.40951 8.01503C5.19812 7.7924 3 9.47513 3 12C3 14.5248 5.19811 16.2076 7.40949 15.9849C8.04966 17.4634 9.38318 18.5718 11 18.9V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V18.9C14.6168 18.5718 15.9503 17.4634 16.5905 15.9849C18.8019 16.2076 21 14.5248 21 12C21 9.47513 18.8019 7.7924 16.5905 8.01503ZM17 14.0062C18.0343 14.0018 19 13.1754 19 12C19 10.8246 18.0343 9.99821 17 9.99379L17 14.0062ZM7 9.99378C5.9657 9.99821 5 10.8246 5 12C5 13.1754 5.9657 14.0018 7 14.0062V9.99378ZM11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H11ZM11 13C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bee-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bee","insect","animal","bug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.7302 21C14 20.5 13.7302 19.7552 13.2112 19.4118L12 19L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.0001L8.8 14.4001C6.82229 15.8834 4 14.4722 4 12.0001C4 9.52794 6.82229 8.11679 8.8 9.60008L12 12.0001ZM12 12.0001L15.2 9.60008C17.1777 8.11679 20 9.52794 20 12.0001C20 14.4722 17.1777 15.8834 15.2 14.4001L12 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bee-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bee","honey","menu","sweet","buzz","pollinate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.7302 21C14 20.5 13.7302 19.7552 13.2112 19.4118L12 19L12 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.0001L8.8 14.4001C6.82229 15.8834 4 14.4722 4 12.0001C4 9.52794 6.82229 8.11679 8.8 9.60008L12 12.0001ZM12 12.0001L15.2 9.60008C17.1777 8.11679 20 9.52794 20 12.0001C20 14.4722 17.1777 15.8834 15.2 14.4001L12 12.0001Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bee-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bee","honey","sweet","discount","loyalty","rewards","promotion","sales","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6176 7.01031C16.1673 5.96025 15.3569 5.10019 14.3563 4.57016V4.55016C14.5064 4.26014 14.5864 4.12013 14.6465 4.02013C14.7665 4.01012 14.9266 4.01012 15.2468 4.01012H16.0072C16.5575 4.01012 17.0078 3.5601 17.0078 3.01006C17.0078 2.46003 16.5775 2 16.0272 2H15.2268C14.9566 2 14.6865 2 14.4564 2.02C14.1862 2.05 13.886 2.11001 13.5959 2.29002C13.3057 2.47003 13.1056 2.71004 12.9655 2.94006C12.8355 3.14007 12.7154 3.38009 12.5953 3.6201L12.4052 4.01012C12.2852 4.01012 12.1551 4.00012 12.025 4.00012C11.8949 4.00012 11.7749 4.00012 11.6448 4.01012L11.4547 3.6201C11.3346 3.38009 11.2146 3.14007 11.0845 2.94006C10.9444 2.71004 10.7443 2.48003 10.4541 2.29002C10.164 2.11001 9.86381 2.04 9.59366 2.02C9.36354 2 9.09339 2 8.82324 2H8.02279C7.47248 2 7.02223 2.45003 7.02223 3.00006C7.02223 3.5501 7.47248 4.00012 8.02279 4.00012H8.78321C9.10339 4.00012 9.27349 4.00012 9.38355 4.01012C9.44358 4.11013 9.52362 4.26014 9.6637 4.54016V4.56016C8.67315 5.09019 7.87271 5.95025 7.41245 7.00031C5.20122 6.7803 3 8.4704 3 10.9906C3 13.5107 5.20122 15.2008 7.41245 14.9808C8.05281 16.4609 9.39355 17.551 11.0044 17.881V17.991C11.0044 18.421 11.2746 18.801 11.6848 18.9411L12.7254 19.3011C12.7254 19.3011 12.7954 19.4011 12.8255 19.4711C12.8355 19.5111 12.8455 19.5411 12.8455 19.5511C12.6053 20.0311 12.7854 20.6212 13.2657 20.8812C13.756 21.1412 14.3563 20.9612 14.6165 20.4711C14.9166 19.9111 14.8766 19.3011 14.7165 18.821C14.5664 18.371 14.2563 17.931 13.836 17.631C15.0667 17.1409 16.0673 16.1909 16.5875 14.9808C18.7988 15.2008 21 13.5107 21 10.9906C21 8.4704 18.7988 6.7803 16.5875 7.00031L16.6176 7.01031ZM12.025 6.00025C13.2257 6.00025 14.2563 6.70029 14.7365 7.72036C14.6965 7.75036 14.6565 7.77036 14.6265 7.80036L12.025 9.75048L9.42357 7.80036C9.42357 7.80036 9.34352 7.74036 9.31351 7.72036C9.79377 6.70029 10.8243 6.00025 12.025 6.00025ZM9.02335 10.0005L10.3541 11.0006L9.02335 12.0006V10.0005ZM12.025 16.0009C10.8243 16.0009 9.79377 15.3008 9.31351 14.2808C9.35353 14.2508 9.39355 14.2308 9.42357 14.2008L12.025 12.2506L14.6265 14.2008C14.6265 14.2008 14.7065 14.2608 14.7365 14.2808C14.2563 15.3008 13.2257 16.0009 12.025 16.0009ZM15.0267 12.0006L13.6959 11.0006L15.0267 10.0005V12.0006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bee: {
        defaultColors: ["#3D4C66"],
        keywords: ["bee","honey","sweet","discount","loyalty","rewards","promotion","sales","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L10.5528 5.10557C10.2838 4.56766 10.1493 4.2987 9.9077 4.14935C9.66605 4 9.36534 4 8.76393 4L8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6L13.4472 5.10557C13.7162 4.56766 13.8507 4.2987 14.0923 4.14935C14.334 4 14.6347 4 15.2361 4H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.7302 21C14 20.5 13.7302 19.7552 13.2112 19.4118L12 19L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.0001L8.8 14.4001C6.82229 15.8834 4 14.4722 4 12.0001C4 9.52794 6.82229 8.11679 8.8 9.60008L12 12.0001ZM12 12.0001L15.2 9.60008C17.1777 8.11679 20 9.52794 20 12.0001C20 14.4722 17.1777 15.8834 15.2 14.4001L12 12.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Behance-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["brand","behance","social-media","network","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 6H8C9.65685 6 11 7.34315 11 9V9C11 10.6569 9.65685 12 8 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12H8C9.65685 12 11 13.3431 11 15V15C11 16.6569 9.65685 18 8 18H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 10H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2361 17C17.6868 17.6137 16.8885 18 16 18C14.3431 18 13 16.6569 13 15C13 13.3431 14.3431 12 16 12C17.6569 12 19 13.3431 19 15H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Behance-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["behance","social-media","design","portfolio","community","creativity","inspiration","user-profile","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 18V6" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 6H8C9.65685 6 11 7.34315 11 9V9C11 10.6569 9.65685 12 8 12H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12H8C9.65685 12 11 13.3431 11 15V15C11 16.6569 9.65685 18 8 18H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 10H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2361 17C17.6868 17.6137 16.8885 18 16 18C14.3431 18 13 16.6569 13 15C13 13.3431 14.3431 12 16 12C17.6569 12 19 13.3431 19 15H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Behance: {
        defaultColors: ["#3D4C66"],
        keywords: ["behance","social-media","design","portfolio","community","creativity","inspiration","user-profile","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 6H8C9.65685 6 11 7.34315 11 9V9C11 10.6569 9.65685 12 8 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12H8C9.65685 12 11 13.3431 11 15V15C11 16.6569 9.65685 18 8 18H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 10H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2361 17C17.6868 17.6137 16.8885 18 16 18C14.3431 18 13 16.6569 13 15C13 13.3431 14.3431 12 16 12C17.6569 12 19 13.3431 19 15H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bicycle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bicycle","bike","delivery","transport","shipping","courier","transportation","order-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.00191 10L8 8H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H12.0019M12.0019 15L15.5 10H9.00191L12.0019 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9962 12C17.5228 11.9994 17.0561 12.1121 16.635 12.3286C15.2813 13.0205 14.6592 14.6158 15.1872 16.0416C15.7152 17.4673 17.2263 18.2726 18.7041 17.9158C20.182 17.559 21.1592 16.1529 20.9785 14.6433C20.7979 13.1337 19.5165 11.998 17.9962 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.99619 12C5.52276 11.9994 5.05605 12.1121 4.63505 12.3286C3.2813 13.0205 2.65922 14.6158 3.1872 16.0416C3.71519 17.4673 5.22627 18.2726 6.70411 17.9158C8.18195 17.559 9.15919 16.1529 8.97854 14.6433C8.79789 13.1337 7.5165 11.998 5.99619 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L13.002 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Behance-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["behance","social","media","design","portfolio","network","creative","platform","connect","share","inspiration","browse","discover","visual","art","graphic","brand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5H5C4.44772 5 4 5.44772 4 6V18C4 18.5523 4.44772 19 5 19H8C10.2091 19 12 17.2091 12 15C12 13.8053 11.4762 12.7329 10.6458 12C11.4762 11.2671 12 10.1947 12 9C12 6.79086 10.2091 5 8 5ZM6 17H8C9.10457 17 10 16.1046 10 15C10 13.8954 9.10457 13 8 13H6V17ZM6 11H8C9.10457 11 10 10.1046 10 9C10 7.89543 9.10457 7 8 7H6V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 9C14 8.44772 14.4477 8 15 8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H15C14.4477 10 14 9.55228 14 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.903 16.2549C19.7133 16.0851 19.4768 16.001 19.2408 16H20C20.5523 16 21 15.5523 21 15C21 12.7909 19.2091 11 17 11C14.7909 11 13 12.7909 13 15C13 17.2091 14.7909 19 17 19C18.1848 19 19.2502 18.4836 19.9812 17.6669C20.3496 17.2554 20.3145 16.6232 19.903 16.2549ZM15 15C15 16.1046 15.8954 17 17 17C17.5922 17 18.1233 16.7438 18.491 16.3331C18.6875 16.1136 18.959 16.0012 19.2321 16H17C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14H18.7324C18.3866 13.4022 17.7403 13 17 13C15.8954 13 15 13.8954 15 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bicycle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bicycle","bike","delivery","transport","shipping","courier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.9962 12C17.5228 11.9994 17.0561 12.1121 16.635 12.3286C15.2813 13.0205 14.6592 14.6158 15.1872 16.0416C15.7152 17.4673 17.2263 18.2726 18.7041 17.9158C20.182 17.559 21.1592 16.1529 20.9785 14.6433C20.7979 13.1337 19.5165 11.998 17.9962 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.99619 12C5.52276 11.9994 5.05605 12.1121 4.63505 12.3286C3.2813 13.0205 2.65922 14.6158 3.1872 16.0416C3.71519 17.4673 5.22627 18.2726 6.70411 17.9158C8.18195 17.559 9.15919 16.1529 8.97854 14.6433C8.79789 13.1337 7.5165 11.998 5.99619 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.00191 10L8 8H7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H12.0019M12.0019 15L15.5 10H9.00191L12.0019 15Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L13.002 5H12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bicycle: {
        defaultColors: ["#3D4C66"],
        keywords: ["bicycle","bike","delivery","transport","shipping","courier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.9962 12C17.5228 11.9994 17.0561 12.1121 16.635 12.3286C15.2813 13.0205 14.6592 14.6158 15.1872 16.0416C15.7152 17.4673 17.2263 18.2726 18.7041 17.9158C20.182 17.559 21.1592 16.1529 20.9785 14.6433C20.7979 13.1337 19.5165 11.998 17.9962 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.99619 12C5.52276 11.9994 5.05605 12.1121 4.63505 12.3286C3.2813 13.0205 2.65922 14.6158 3.1872 16.0416C3.71519 17.4673 5.22627 18.2726 6.70411 17.9158C8.18195 17.559 9.15919 16.1529 8.97854 14.6433C8.79789 13.1337 7.5165 11.998 5.99619 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.00191 10L8 8H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H12.0019M12.0019 15L15.5 10H9.00191L12.0019 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L13.002 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bicycle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bicycle","bike","delivery","transport","courier","transportation","ride"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 5C11 4.44772 11.4478 4 12 4H13.002C13.3808 4 13.7271 4.21407 13.8965 4.55293L17.1626 11.0878C17.4357 11.0294 17.715 10.9997 17.9962 11C20.0228 10.998 21.7307 12.5121 21.9715 14.5245C22.2124 16.5373 20.9094 18.4121 18.9388 18.8878C16.9683 19.3636 14.9535 18.2898 14.2495 16.3888C13.6608 14.7993 14.1443 13.0516 15.3738 11.9823L14.7505 10.7351L12.3945 15.4472C12.2251 15.786 11.8788 16 11.5 16H9.87342C9.51311 17.3935 8.4127 18.532 6.93885 18.8878C4.9683 19.3636 2.95347 18.2898 2.24948 16.3888C1.54565 14.4883 2.37457 12.3617 4.17882 11.4388C4.74102 11.1498 5.36411 10.9994 5.99622 11C6.95723 10.999 7.84657 11.339 8.54179 11.9114L7.13805 9.50367C7.1274 9.4854 7.11734 9.4668 7.10787 9.4479L6.38254 8H6.00004C5.44776 8 5.00004 7.55228 5.00004 7C5.00004 6.44772 5.44776 6 6.00004 6H7.00004C7.37854 6 7.7246 6.2137 7.89413 6.5521L8.61946 8H13.3835L12.3839 6H12C11.4478 6 11 5.55228 11 5ZM12.882 10H9.74251L11.4326 12.8988L12.882 10ZM7.73234 14C7.38407 13.3971 6.7327 12.999 5.99755 13H5.99496C5.68107 12.9996 5.37163 13.0743 5.0925 13.2179L5.09019 13.2191C4.18775 13.6803 3.77302 14.7438 4.12501 15.6943C4.47699 16.6448 5.48432 17.1815 6.46946 16.9437C7.01985 16.8108 7.4661 16.4596 7.73177 16H7.00004C6.44776 16 6.00004 15.5523 6.00004 15C6.00004 14.4477 6.44776 14 7.00004 14H7.73234ZM16.3313 13.8979C15.9909 14.4142 15.8968 15.078 16.125 15.6943C16.477 16.6448 17.4843 17.1815 18.4695 16.9437C19.4546 16.7058 20.1061 15.7685 19.9857 14.7621C19.8701 13.7966 19.0791 13.0606 18.1202 13.0036L18.8945 14.5529C19.1415 15.0469 18.9411 15.6476 18.4471 15.8945C17.9531 16.1414 17.3525 15.9411 17.1055 15.4471L16.3313 13.8979Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bilibili-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tv","screen","display","media","entertainment","customer-display","advertisement","promotion","video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L10 6M16 4L14 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bilibili-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["robot","chatbot","customer-support","helpdesk","feedback","automation","agent","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L10 6M16 4L14 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13L15 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bilibili-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discord","chat","communication","support","help","customer-service","online-support","contact","messaging"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 4.29289C8.31658 3.90237 7.68342 3.90237 7.29289 4.29289C6.90237 4.68342 6.90237 5.31658 7.29289 5.70711L7.61703 6.03124C7.23951 6.04876 6.89222 6.0761 6.57494 6.11875C5.64711 6.2435 4.82769 6.51547 4.17158 7.17158C3.51547 7.82768 3.2435 8.64711 3.11876 9.57494C2.99994 10.4587 2.99997 11.5753 3 12.9294V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.4587 20.0001 8.57531 20 9.92943 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V12.9294C21 11.5753 21.0001 10.4587 20.8813 9.57494C20.7565 8.64711 20.4845 7.82768 19.8284 7.17158C19.1723 6.51547 18.3529 6.2435 17.4251 6.11875C17.1078 6.0761 16.7605 6.04876 16.383 6.03124L16.7071 5.70711C17.0976 5.31658 17.0976 4.68342 16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289L13.5858 6H10.4142L8.70711 4.29289ZM8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14V12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12V14ZM14 14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bilibili: {
        defaultColors: ["#3D4C66"],
        keywords: ["discord","chat","communication","support","help","customer-service","online-support","contact","messaging"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 4L10 6M16 4L14 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bill","receipt","invoice","payment","transaction","total","summary","statement","due"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","payment","total","summary","sale","sales-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V4.76847C5 4.41472 5 4.23785 5.11538 4.14777C5.23075 4.05769 5.40234 4.10059 5.74552 4.18638L9 5L12 4L15 5L18.2545 4.18638C18.5977 4.10059 18.7692 4.05769 18.8846 4.14777C19 4.23785 19 4.41472 19 4.76847V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","payment","total","cost","price","transaction","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6838 3.05132C11.8891 2.98289 12.111 2.98289 12.3163 3.05132L15.04 3.95923L18.0448 3.20801C18.1846 3.17288 18.3789 3.12404 18.5539 3.10625C18.7691 3.08437 19.1494 3.08575 19.5001 3.35957C19.8508 3.63338 19.9444 4.002 19.9753 4.21608C20.0005 4.3901 20.0003 4.59048 20.0001 4.73459L20.0001 19.2654C20.0002 19.4094 20.0005 19.6101 19.9753 19.7839C19.9444 19.998 19.8508 20.3666 19.5001 20.6404C19.1494 20.9142 18.7691 20.9156 18.5539 20.8938C18.379 20.876 18.1846 20.8271 18.0449 20.792L15.04 20.0408L12.3163 20.9487C12.111 21.0171 11.8891 21.0171 11.6838 20.9487L8.96009 20.0408L5.9553 20.792C5.81553 20.8271 5.62115 20.876 5.44622 20.8938C5.23102 20.9156 4.85072 20.9142 4.50002 20.6404C4.14933 20.3666 4.05575 19.998 4.02478 19.7839C3.99961 19.6099 3.99985 19.4095 4.00003 19.2654L4.00006 4.73465C3.99988 4.59056 3.99963 4.38993 4.02478 4.21608C4.05575 4.002 4.14933 3.63338 4.50002 3.35957C4.85072 3.08575 5.23103 3.08437 5.44622 3.10625C5.62118 3.12404 5.81554 3.17288 5.95531 3.20801L8.96009 3.95923L11.6838 3.05132ZM15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H9C8.44771 9 8 9.44772 8 10C8 10.5523 8.44771 11 9 11H15ZM14 15C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H10C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bill","receipt","invoice","transaction","sales","record","payment","history","details","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","history","record","list","summary","details","statement","checkout","purchase","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3279 3.08215C16.7162 2.99991 15.9524 2.99995 15.0659 3L8.93423 3C8.04777 2.99995 7.28391 2.99991 6.67227 3.08215C6.01675 3.17028 5.3884 3.36902 4.87874 3.87868C4.36908 4.38835 4.17033 5.0167 4.0822 5.67221C3.99996 6.28387 4.00001 7.04769 4.00006 7.93417L4.00003 19.2654C3.99985 19.4095 3.99961 19.6099 4.02478 19.7839C4.05575 19.998 4.14933 20.3666 4.50002 20.6404C4.85072 20.9143 5.23102 20.9156 5.44622 20.8938C5.62115 20.876 5.81548 20.8271 5.95525 20.792L8.96009 20.0408L11.6838 20.9487C11.8891 21.0171 12.111 21.0171 12.3163 20.9487L15.04 20.0408L18.0448 20.792C18.1846 20.8271 18.379 20.876 18.5539 20.8938C18.7691 20.9156 19.1494 20.9143 19.5001 20.6404C19.8508 20.3666 19.9444 19.998 19.9753 19.7839C20.0005 19.6101 20.0002 19.41 20.0001 19.2659L20.0001 7.93417C20.0001 7.04773 20.0002 6.28385 19.9179 5.67221C19.8298 5.0167 19.631 4.38835 19.1214 3.87868C18.6117 3.36902 17.9834 3.17028 17.3279 3.08215ZM8 9C8 8.44772 8.44772 8 9 8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5523 10 13 10H9C8.44772 10 8 9.55228 8 9ZM8 12C8 11.4477 8.44772 11 9 11L15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44771 13 8 12.5523 8 12ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","sales","paper","document","list","order","details","total","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","receipt","invoice","order","transaction","sales-report","summary","payment","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","payment","sales","document","record","statement","purchase","order","tab"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","payment","statement","purchase","total","summary","due","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","invoice","transaction","statement","sales","order","payment","history","record","details","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","sales","payment","transaction","history","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3279 3.08215C16.7162 2.99991 15.9524 2.99995 15.0659 3L8.93423 3L8.93416 3C8.0477 2.99995 7.28391 2.99991 6.67227 3.08215C6.01675 3.17028 5.3884 3.36902 4.87874 3.87868C4.36908 4.38835 4.17033 5.0167 4.0822 5.67221C3.99997 6.28386 4.00001 7.04764 4.00006 7.9341L4.00006 7.93417L4.00003 19.2654C3.99985 19.4095 3.99961 19.6099 4.02478 19.7839C4.05575 19.998 4.14933 20.3666 4.50002 20.6404C4.85072 20.9143 5.23102 20.9156 5.44622 20.8938C5.62115 20.876 5.81548 20.8271 5.95525 20.792L5.9553 20.792L8.96009 20.0408L11.6838 20.9487C11.8891 21.0171 12.111 21.0171 12.3163 20.9487L15.04 20.0408L18.0448 20.792L18.0449 20.792C18.1846 20.8271 18.379 20.876 18.5539 20.8938C18.7691 20.9156 19.1494 20.9143 19.5001 20.6404C19.8508 20.3666 19.9444 19.998 19.9753 19.7839C20.0005 19.6101 20.0002 19.41 20.0001 19.2659V19.2659V19.2654L20.0001 7.93417V7.93407C20.0001 7.04763 20.0002 6.28385 19.9179 5.67221C19.8298 5.0167 19.631 4.38835 19.1214 3.87868C18.6117 3.36902 17.9834 3.17028 17.3279 3.08215ZM7 9C7 8.44772 7.44772 8 8 8H11C11.5523 8 12 8.44772 12 9C12 9.55228 11.5523 10 11 10H8C7.44772 10 7 9.55228 7 9ZM7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12ZM7 15C7 14.4477 7.44772 14 8 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16H8C7.44772 16 7 15.5523 7 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","receipt","invoice","paper","document","sale","transaction","history","record","statement","order-summary","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","total","invoice","payment","transaction","sales","purchase","balance","summary","account","due"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3279 3.08215C16.7162 2.99991 15.9524 2.99995 15.0659 3L8.93423 3C8.04777 2.99995 7.28391 2.99991 6.67227 3.08215C6.01675 3.17028 5.3884 3.36902 4.87874 3.87868C4.36908 4.38835 4.17033 5.0167 4.0822 5.67221C3.99997 6.28386 4.00001 7.04764 4.00006 7.9341L4.00003 19.2654C3.99985 19.4095 3.99961 19.6099 4.02478 19.7839C4.05575 19.998 4.14933 20.3666 4.50002 20.6404C4.85072 20.9143 5.23102 20.9156 5.44622 20.8938C5.62115 20.876 5.81548 20.8271 5.95525 20.792L8.96009 20.0408L11.6838 20.9487C11.8891 21.0171 12.111 21.0171 12.3163 20.9487L15.04 20.0408L18.0448 20.792C18.1846 20.8271 18.379 20.876 18.5539 20.8938C18.7691 20.9156 19.1494 20.9143 19.5001 20.6404C19.8508 20.3666 19.9444 19.998 19.9753 19.7839C20.0005 19.6101 20.0002 19.41 20.0001 19.2659L20.0001 7.93417C20.0001 7.04773 20.0002 6.28385 19.9179 5.67221C19.8298 5.0167 19.631 4.38835 19.1214 3.87868C18.6117 3.36902 17.9834 3.17028 17.3279 3.08215ZM9 10C9 9.44772 9.44772 9 10 9H14C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H10C9.44772 11 9 10.5523 9 10ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","invoice","payment","transaction","order-summary","sales-record","purchase","expenses","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","bill","invoice","transaction","history","record","sales","paper","document","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","receipt","invoice","payment","transaction","record","sales","order-summary","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","sales","payment","order","history","details","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0659 3C15.9524 2.99995 16.7162 2.99991 17.3279 3.08215C17.9834 3.17028 18.6117 3.36902 19.1214 3.87868C19.631 4.38835 19.8298 5.0167 19.9179 5.67221C20.0002 6.28386 20.0001 7.04767 20.0001 7.93413V7.93417L20.0001 19.2654V19.2659C20.0002 19.4099 20.0005 19.6101 19.9753 19.7839C19.9444 19.998 19.8508 20.3666 19.5001 20.6404C19.1494 20.9143 18.7691 20.9156 18.5539 20.8938C18.379 20.876 18.1846 20.8271 18.0449 20.792L18.0448 20.792L15.04 20.0408L12.3163 20.9487C12.111 21.0171 11.8891 21.0171 11.6838 20.9487L8.96009 20.0408L5.9553 20.792L5.95525 20.792C5.81548 20.8271 5.62115 20.876 5.44622 20.8938C5.23103 20.9156 4.85072 20.9143 4.50002 20.6404C4.14933 20.3666 4.05575 19.998 4.02478 19.7839C3.99961 19.6099 3.99985 19.4095 4.00003 19.2654L4.00006 7.93417L4.00006 7.9341C4.00001 7.04764 3.99997 6.28386 4.0822 5.67221C4.17033 5.0167 4.36908 4.38835 4.87874 3.87868C5.3884 3.36902 6.01675 3.17028 6.67227 3.08215C7.28391 2.99991 8.0477 2.99995 8.93416 3L8.93423 3L15.0659 3ZM9 9C9 8.44772 9.44771 8 10 8H14C14.5523 8 15 8.44772 15 9C15 9.55228 14.5523 10 14 10H10C9.44771 10 9 9.55228 9 9ZM8 12C8 11.4477 8.44772 11 9 11L15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44771 13 8 12.5523 8 12ZM10 14C9.44771 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","invoice","transaction","payment","sales","record","document","summary","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 4V20M19 20V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 4L15 5L12 4L9 5L5 4.00031"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-confirm-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","confirm","checkmark","tick","payment-received","transaction-complete","order-confirmed","invoice","completed","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.67226 3.08215C7.28393 2.99991 8.04774 2.99995 8.93423 3H15.0659C15.9524 2.99995 16.7162 2.99991 17.3278 3.08215C17.9834 3.17028 18.6117 3.36902 19.1214 3.87868C19.631 4.38835 19.8298 5.0167 19.9179 5.67221C20.0001 6.28386 20.0001 7.0477 20.0001 7.93417L20.0001 19.0694C20.0003 19.2489 20.0005 19.4808 19.9714 19.6766C19.938 19.9019 19.8301 20.3444 19.3835 20.6204C18.9369 20.8965 18.4928 20.795 18.2764 20.7242C18.0883 20.6626 17.8809 20.5587 17.7204 20.4783L17.0718 20.1539L16.0546 20.8318C15.7188 21.0556 15.2813 21.0556 14.9455 20.8318L13.9283 20.1539L12.4473 20.8944C12.1657 21.0352 11.8344 21.0352 11.5528 20.8944L10.0718 20.1539L9.05464 20.8318C8.71879 21.0556 8.28132 21.0556 7.94548 20.8318L6.9283 20.1539L6.27963 20.4783C6.11913 20.5587 5.91184 20.6626 5.72376 20.7242C5.50729 20.795 5.0632 20.8965 4.6166 20.6204C4.17001 20.3444 4.06214 19.9019 4.02869 19.6766C3.99962 19.4808 3.99985 19.2489 4.00003 19.0694L4.00005 7.93417C4 7.04769 3.99996 6.28387 4.0822 5.67221C4.17033 5.0167 4.36907 4.38835 4.87874 3.87868C5.3884 3.36902 6.01675 3.17028 6.67226 3.08215ZM15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289C15.3166 6.90237 14.6834 6.90237 14.2929 7.29289L11 10.5858L9.70711 9.29289C9.31658 8.90237 8.68342 8.90237 8.29289 9.29289C7.90237 9.68342 7.90237 10.3166 8.29289 10.7071L10.2929 12.7071C10.6834 13.0976 11.3166 13.0976 11.7071 12.7071L15.7071 8.70711ZM15.0546 14.5H9.05464C8.50235 14.5 8.05464 14.9477 8.05464 15.5C8.05464 16.0523 8.50235 16.5 9.05464 16.5H15.0546C15.6069 16.5 16.0546 16.0523 16.0546 15.5C16.0546 14.9477 15.6069 14.5 15.0546 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-confirm-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","checkmark","confirmation","payment-confirmation","transaction-complete","order-complete","tick","invoice","approved","success","payment","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L11 12L15 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-confirm": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","check","confirm","validate","approved","completed","transaction","payment","bill","invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L11 12L15 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-payment-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","payment","receipt","dollar","transaction","invoice","money","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0659 3C15.9524 2.99995 16.7162 2.99991 17.3279 3.08215C17.9834 3.17028 18.6117 3.36902 19.1214 3.87868C19.631 4.38835 19.8298 5.0167 19.9179 5.67221C20.0002 6.28386 20.0001 7.04767 20.0001 7.93413V7.93417L20.0001 19.2654V19.2659C20.0002 19.4099 20.0005 19.6101 19.9753 19.7839C19.9444 19.998 19.8508 20.3666 19.5001 20.6404C19.1494 20.9143 18.7691 20.9156 18.5539 20.8938C18.379 20.876 18.1846 20.8271 18.0449 20.792L18.0448 20.792L15.0849 20.3328L12.3163 20.9487C12.111 21.0171 11.8891 21.0171 11.6838 20.9487L8.96009 20.0408L5.9553 20.792L5.95525 20.792C5.81548 20.8271 5.62115 20.876 5.44622 20.8938C5.23103 20.9156 4.85072 20.9143 4.50002 20.6404C4.14933 20.3666 4.05575 19.998 4.02478 19.7839C3.99961 19.6099 3.99985 19.4095 4.00003 19.2654L4.00006 7.93417L4.00006 7.9341C4.00001 7.04764 3.99997 6.28386 4.0822 5.67221C4.17033 5.0167 4.36908 4.38835 4.87874 3.87868C5.3884 3.36902 6.01675 3.17028 6.67227 3.08215C7.28391 2.99991 8.0477 2.99995 8.93416 3L8.93423 3L15.0659 3ZM14.5 8C14.5 7.44772 14.0523 7 13.5 7C12.9477 7 12.5 7.44772 12.5 8V8.20802C11.617 8.5938 11 9.47484 11 10.5C11 11.8807 12.1193 13 13.5 13H14.3333C14.8032 13 15 13.3204 15 13.5C15 13.6796 14.8032 14 14.3333 14H12C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16H12.5C12.5 16.5523 12.9477 17 13.5 17C14.0523 17 14.5 16.5523 14.5 16V15.995C15.8075 15.9161 17 14.9172 17 13.5C17 12.0228 15.7044 11 14.3333 11H13.5C13.2239 11 13 10.7761 13 10.5C13 10.2239 13.2239 10 13.5 10H15.3333C15.8856 10 16.3333 9.55228 16.3333 9C16.3333 8.44772 15.8856 8 15.3333 8H14.5ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H9.5C10.0523 13 10.5 12.5523 10.5 12C10.5 11.4477 10.0523 11 9.5 11H8ZM7 9C7 8.44772 7.44772 8 8 8H8.5C9.05228 8 9.5 8.44772 9.5 9C9.5 9.55228 9.05228 10 8.5 10H8C7.44772 10 7 9.55228 7 9ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H8.5C9.05228 16 9.5 15.5523 9.5 15C9.5 14.4477 9.05228 14 8.5 14H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-confirm-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bill","confirm","receipt","payment","done","complete","transaction","check","validated","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.0292V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.0292C19 19.4643 19 19.6819 18.8577 19.7698C18.7154 19.8577 18.5209 19.7604 18.1317 19.5658L17 19L15.5 19.9997L14 19L12 20L10 19L8.5 19.9997L7 19L5.86833 19.5658C5.47915 19.7604 5.28456 19.8577 5.14228 19.7698C5 19.6819 5 19.4643 5 19.0292Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L11 12L15 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-payment-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","bill","payment","dollar","transaction","sale","invoice","money","charge","due","balance","amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.2315V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.2315C19 19.5853 19 19.7621 18.8846 19.8522C18.7692 19.9423 18.5977 19.8994 18.2545 19.8136L18.2545 19.8136L15 19L12 20L9 19L5.74552 19.8136L5.74551 19.8136C5.40234 19.8994 5.23075 19.9423 5.11538 19.8522C5 19.7621 5 19.5853 5 19.2315Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-payment-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","payment","invoice","dollar","transaction","sales","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bill-payment": {
        defaultColors: ["#3D4C66"],
        keywords: ["bill","receipt","payment","dollar","money","transaction","invoice","total","due","charge","price","cost","finance","statement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bing-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","connection","signal","network","online","connectivity","wireless","internet","bluetooth","rssi","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15C4 17.7614 6.23858 20 9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 7C4 7.33684 4 12.4737 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13C17 9.68629 14.3137 7 11 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    bill: {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","signal","network","online","connectivity","wireless","internet","bluetooth","rssi","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bing-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["contactless","payment","wifi","signal","connection","wireless","tap-to-pay","nfc","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 4C11 3.44772 11.4477 3 12 3C16.9706 3 21 7.02944 21 12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12C19 8.13401 15.866 5 12 5C11.4477 5 11 4.55228 11 4ZM4 6C4.55228 6 5 6.44772 5 7V15C5 17.2091 6.79086 19 9 19C11.2091 19 13 17.2091 13 15C13 12.7909 11.2091 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9C12.3137 9 15 11.6863 15 15C15 18.3137 12.3137 21 9 21C5.68629 21 3 18.3137 3 15V7C3 6.44772 3.44772 6 4 6ZM10 7C10 6.44772 10.4477 6 11 6C14.866 6 18 9.13401 18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 10.2386 13.7614 8 11 8C10.4477 8 10 7.55228 10 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bill-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","invoice","transaction","payment","history","sales","record","details","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 4V20M19 20V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 4L15 5L12 4L9 5L5 4.00031"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Bing: {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","bill","invoice","transaction","payment","history","sales","record","details","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15C4 17.7614 6.23858 20 9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 7C4 7.33684 4 12.4737 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13C17 9.68629 14.3137 7 11 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bing-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bluetooth","connectivity","wireless","signal","connection","network","pairing","device","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15C4 17.7614 6.23858 20 9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 7C4 7.33684 4 12.4737 4 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13C17 9.68629 14.3137 7 11 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bitcoin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bitcoin","cryptocurrency","payment","digital-currency","btc","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5L9 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 18L9 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 5L11 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 18L11 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 6H12C13.6569 6 15 7.34315 15 9V9C15 10.6569 13.6569 12 12 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12H14C15.6569 12 17 13.3431 17 15V15C17 16.6569 15.6569 18 14 18H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 6L9 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 6H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 18H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bitcoin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bitcoin","cryptocurrency","payment","digital currency","btc","transaction","crypto"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.2998C9.55228 3.2998 10 3.74752 10 4.2998L10 4.9998H10.5V4.2998C10.5 3.74752 10.9477 3.2998 11.5 3.2998C12.0523 3.2998 12.5 3.74752 12.5 4.2998V4.9998C13.6319 4.9998 14.5524 5.4743 15.1637 6.26851C15.7513 7.03177 16 8.016 16 8.9998C16 9.79733 15.8365 10.5951 15.4616 11.2753C16.9478 11.859 18 13.3065 18 14.9998C18 17.2089 16.2091 18.9998 14 18.9998H12.5V19.4998C12.5 20.0521 12.0523 20.4998 11.5 20.4998C10.9477 20.4998 10.5 20.0521 10.5 19.4998V18.9998H10V19.4998C10 20.0521 9.55228 20.4998 9 20.4998C8.44772 20.4998 8 20.0521 8 19.4998V18.9998H7C6.44772 18.9998 6 18.5521 6 17.9998C6 17.4475 6.44772 16.9998 7 16.9998H8V6.9998H7C6.44772 6.9998 6 6.55209 6 5.9998C6 5.44752 6.44772 4.9998 7 4.9998H8V4.2998C8 3.74752 8.44772 3.2998 9 3.2998ZM10 6.9998V10.9998H12.5C13.0249 10.9998 13.3545 10.8027 13.5789 10.5112C13.8272 10.1886 14 9.67286 14 8.9998C14 8.32675 13.8272 7.81099 13.5789 7.48845C13.3545 7.19688 13.0249 6.9998 12.5 6.9998H10ZM10 12.9998V16.9998H14C15.1046 16.9998 16 16.1044 16 14.9998C16 13.8952 15.1046 12.9998 14 12.9998H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "blanket-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["stack","item-stack","bulk-order","folded","layers","inventory","multiple","bundle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 6H7C5.34315 6 4 7.34315 4 9V9C4 10.6569 5.34315 12 7 12H17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H7C5.34315 12 4 13.3431 4 15V15C4 16.6569 5.34315 18 7 18H17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 15L17 15C18.6569 15 20 13.6569 20 12V12C20 10.3431 18.6569 9 17 9L6 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 18L18.5 18C19.3284 18 20 17.3284 20 16.5V16.5C20 15.6716 19.3284 15 18.5 15L7 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    bitcoin: {
        defaultColors: ["#3D4C66"],
        keywords: ["stack","item-stack","bulk-order","folded","layers","inventory","multiple","bundle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6H12C13.6569 6 15 7.34315 15 9V9C15 10.6569 13.6569 12 12 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12H14C15.6569 12 17 13.3431 17 15V15C17 16.6569 15.6569 18 14 18H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 6L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 6H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 5L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 18L9 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 5L11 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 18L11 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 18H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bitcoin-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bitcoin","cryptocurrency","payment","digital currency","crypto","btc","accepted","accept-bitcoin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 4.2998L9 5.2998" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 18.5L9 19.5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4.2998L11 5.2998" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 18.5L11 19.5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 6H12C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12H9H14C15.6569 12 17 13.3431 17 15C17 16.6569 15.6569 18 14 18H9V6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 6H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 18H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "blanket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["blanket","folded","linen","stack","inventory","hotel","laundry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 9C3 6.79086 4.79086 5 7 5H17C17.5523 5 18 5.44772 18 6C18 6.55228 17.5523 7 17 7H7C5.89543 7 5 7.89543 5 9C5 10.1046 5.89543 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C5.89543 13 5 13.8954 5 15C5 16.1046 5.89543 17 7 17H17C16.9998 17 17.0002 17 17 17H18.5C18.7761 17 19 16.7761 19 16.5C19 16.2239 18.7761 16 18.5 16H17.0026C17.0017 16 17.0009 16 17 16L7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14H7.99868C7.99912 14 7.99956 14 8 14H17C17.0006 14 17.0012 14 17.0018 14C18.1056 13.999 19 13.104 19 12C19 10.8954 18.1046 10 17 10L7 10C6.44772 10 6 9.55228 6 9C6 8.44772 6.44772 8 7 8L17 8C19.2091 8 21 9.79086 21 12C21 12.973 20.6526 13.8649 20.075 14.5584C20.6394 15.0168 21 15.7163 21 16.5C21 17.8807 19.8807 19 18.5 19L8 19C7.99953 19 7.99907 19 7.9986 19H7C4.79086 19 3 17.2091 3 15C3 13.8053 3.52376 12.7329 4.35418 12C3.52376 11.2671 3 10.1947 3 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    blanket: {
        defaultColors: ["#3D4C66"],
        keywords: ["blanket","folded","linen","stack","inventory","hotel","laundry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 6H7C5.34315 6 4 7.34315 4 9V9C4 10.6569 5.34315 12 7 12H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H7C5.34315 12 4 13.3431 4 15V15C4 16.6569 5.34315 18 7 18H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 15L17 15C18.6569 15 20 13.6569 20 12V12C20 10.3431 18.6569 9 17 9L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 18L18.5 18C19.3284 18 20 17.3284 20 16.5V16.5C20 15.6716 19.3284 15 18.5 15L7 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "blender-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","configuration","options","preferences","tool","adjust","customize","setup","system-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9L12 3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L4 8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8L3 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 20C17.866 20 21 17.3137 21 14C21 10.6863 17.866 8 14 8C10.134 8 7 10.6863 7 14C7 17.3137 10.134 20 14 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16C15.6569 16 17 15.1046 17 14C17 12.8954 15.6569 12 14 12C12.3431 12 11 12.8954 11 14C11 15.1046 12.3431 16 14 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "blanket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["blanket","folded","stack","inventory","linen","hotel","spa","laundry","pile","layers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 6H7C5.34315 6 4 7.34315 4 9V9C4 10.6569 5.34315 12 7 12H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H7C5.34315 12 4 13.3431 4 15V15C4 16.6569 5.34315 18 7 18H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 15L17 15C18.6569 15 20 13.6569 20 12V12C20 10.3431 18.6569 9 17 9L6 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 18L18.5 18C19.3284 18 20 17.3284 20 16.5V16.5C20 15.6716 19.3284 15 18.5 15L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "blender-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["blender","menu","options","settings","tools","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L18.7071 8.29289C18.7412 8.32698 18.7723 8.36292 18.8005 8.40039C20.7193 9.65429 22 11.6538 22 14C22 18.0051 18.2681 21 14 21C9.76369 21 6.05563 18.0495 6.00062 14.0893L3.75259 16.6585C3.38891 17.0742 2.75715 17.1163 2.34151 16.7526C1.92587 16.3889 1.88375 15.7571 2.24744 15.3415L7.79626 9L4 9C3.44772 9 3 8.55228 3 8C3 7.44772 3.44772 7 4 7H14C14.2033 7 14.4054 7.0068 14.606 7.02017L11.2929 3.70711C10.9024 3.31658 10.9024 2.68342 11.2929 2.29289ZM11.324 11.7537C12.0526 11.268 13.0017 11 14 11C14.9983 11 15.9474 11.268 16.676 11.7537C17.3977 12.2349 18 13.0093 18 14C18 14.9907 17.3977 15.7651 16.676 16.2463C15.9474 16.732 14.9983 17 14 17C13.0017 17 12.0526 16.732 11.324 16.2463C10.6023 15.7651 10 14.9907 10 14C10 13.0093 10.6023 12.2349 11.324 11.7537ZM12.4334 13.4178C12.0693 13.6606 12 13.8861 12 14C12 14.1139 12.0693 14.3394 12.4334 14.5822C12.7905 14.8202 13.3415 15 14 15C14.6585 15 15.2095 14.8202 15.5666 14.5822C15.9307 14.3394 16 14.1139 16 14C16 13.8861 15.9307 13.6606 15.5666 13.4178C15.2095 13.1798 14.6585 13 14 13C13.3415 13 12.7905 13.1798 12.4334 13.4178Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "blender-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["blender","settings","configuration","tools","options","adjustments","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20C17.866 20 21 17.3137 21 14C21 10.6863 17.866 8 14 8C10.134 8 7 10.6863 7 14C7 17.3137 10.134 20 14 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 9L12 3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L4 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8L3 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 16C15.6569 16 17 15.1046 17 14C17 12.8954 15.6569 12 14 12C12.3431 12 11 12.8954 11 14C11 15.1046 12.3431 16 14 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "block-quote": {
        defaultColors: ["#3D4C66"],
        keywords: ["quote","block","text","paragraph","menu","list","options","receipt","invoice","details","description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "block-quote-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","list","options","navigation","settings","details","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12H18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16L6 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "block-quote-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["list","menu","options","settings","details","information","hamburger","navigation","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 16L6 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "block-quote-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","list","options","hamburger-menu","order-options","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 11.4477 9.44772 11 10 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H10C9.44772 13 9 12.5523 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 16C9 15.4477 9.44772 15 10 15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H10C9.44772 17 9 16.5523 9 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 17C5.44772 17 5 16.5523 5 16L5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12L7 16C7 16.5523 6.55228 17 6 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bloger-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rss","wifi","signal","connectivity","connection","wireless","feed","update","news","broadcast","internet","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="9" cy="15" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16C14 12.6863 11.3137 10 8 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bloger-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rss","feed","communication","updates","notifications","news","blog","internet","wifi","signal","broadcast","data-feed","pos-updates","server-communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="9"
                    cy="15"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16C14 12.6863 11.3137 10 8 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bloger-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rss","feed","broadcast","network","news","updates","notifications","data-feed","blog","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92944C8.57536 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57529 3 9.92937V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.45869 21.0001 8.57531 21 9.92942 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92944C21 8.57534 21.0001 7.45869 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4246 2.99997 14.0706 3ZM8 7C8 6.44772 8.44772 6 9 6C13.9706 6 18 10.0294 18 15C18 15.5523 17.5523 16 17 16C16.4477 16 16 15.5523 16 15C16 11.134 12.866 8 9 8C8.44772 8 8 7.55229 8 7ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C10.7614 11 13 13.2386 13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16C15 12.134 11.866 9 8 9ZM9 12.75C7.75736 12.75 6.75 13.7574 6.75 15C6.75 16.2426 7.75736 17.25 9 17.25C10.2426 17.25 11.25 16.2426 11.25 15C11.25 13.7574 10.2426 12.75 9 12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    blender: {
        defaultColors: ["#3D4C66"],
        keywords: ["rss","feed","broadcast","network","news","updates","notifications","data-feed","blog","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20C17.866 20 21 17.3137 21 14C21 10.6863 17.866 8 14 8C10.134 8 7 10.6863 7 14C7 17.3137 10.134 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16C15.6569 16 17 15.1046 17 14C17 12.8954 15.6569 12 14 12C12.3431 12 11 12.8954 11 14C11 15.1046 12.3431 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 9L12 3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L4 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8L3 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    bloger: {
        defaultColors: ["#3D4C66"],
        keywords: ["rss","feed","broadcast","network","news","updates","notifications","data-feed","blog","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="15" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16C14 12.6863 11.3137 10 8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bluetooth-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","connection","wireless","connectivity","peripheral","device","sync","connect","bluetooth-printer","bluetooth-scanner"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L12 11.4L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bluetooth-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["bluetooth","connection","connect","wireless","pairing","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L12 11.4L8 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bluetooth-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","connection","wireless","pairing","device","peripheral","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 15L9 11.4L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11.9946 9.30486C12.4944 8.85504 12.4167 8.05003 11.8401 7.70408L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L11.9946 15.3049C12.4944 14.855 12.4167 14.05 11.8401 13.7041L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10C16.3333 11.1046 16.3333 12.8954 15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 8C19.6667 10.2091 19.6667 13.7909 17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bluetooth-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bluetooth","connection","wireless","connectivity","device","pairing","sync","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 15L9 11.4L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11.9946 9.30486C12.4944 8.85504 12.4167 8.05003 11.8401 7.70408L9 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L11.9946 15.3049C12.4944 14.855 12.4167 14.05 11.8401 13.7041L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10C16.3333 11.1046 16.3333 12.8954 15 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 8C19.6667 10.2091 19.6667 13.7909 17 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bluetooth-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","connectivity","connection","wireless","pairing","device","peripheral","connect","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.506 5.43383C11.4571 5.50493 11.4171 5.58267 11.3877 5.66543C11.3463 5.78155 11.3277 5.90213 11.3303 6.0213V9.63402L8.84473 8.14266C8.37114 7.85851 7.75688 8.01208 7.47274 8.48566C7.18859 8.95924 7.34215 9.5735 7.81573 9.85764L10.6559 11.5617L7.66126 14.2569C7.25075 14.6263 7.21748 15.2586 7.58694 15.6691C7.95639 16.0796 8.58868 16.1129 8.99919 15.7434L11.3303 13.6454V17.9862C11.3269 18.2292 11.4115 18.4742 11.5869 18.6691C11.6971 18.7916 11.8307 18.8804 11.9748 18.9351C12.0652 18.9695 12.1619 18.9911 12.2627 18.9979C12.3265 19.0022 12.3908 19.0004 12.4544 18.9925C12.6098 18.9733 12.7542 18.9184 12.879 18.8363C12.9242 18.8066 12.9668 18.7734 13.0064 18.737L15.9938 16.0483C16.9934 15.1487 16.838 13.5386 15.6849 12.8467L14.0046 11.8386L15.9938 10.0483C16.9934 9.14867 16.838 7.53864 15.6849 6.84673L12.8621 5.15309C12.7689 5.09444 12.6653 5.05076 12.5547 5.0254C12.313 4.96967 12.0603 5.00691 11.8467 5.12463C11.7141 5.19769 11.5966 5.30175 11.506 5.43383ZM13.3303 13.7664V15.7547L14.6559 14.5617L13.3303 13.7664ZM13.3303 9.75471V7.7664L14.6559 8.56172L13.3303 9.75471Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bluetooth-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bluetooth","connection","wireless","pairing","device","peripheral","connect","printer","scale","payment","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18V6" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 15L9 11.4L5 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11.9946 9.30486C12.4944 8.85504 12.4167 8.05003 11.8401 7.70408L9 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L11.9946 15.3049C12.4944 14.855 12.4167 14.05 11.8401 13.7041L9 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10C16.3333 11.1046 16.3333 12.8954 15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 8C19.6667 10.2091 19.6667 13.7909 17 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bluetooth-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","connection","wireless","peripheral","device","connect","communication","pairing","network","bluetooth-printer","bluetooth-scanner","bluetooth-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.17593 5.43383C8.12699 5.50493 8.08701 5.58267 8.05763 5.66543C8.01625 5.78155 7.99761 5.90213 8.00024 6.0213V9.63402L5.51465 8.14266C5.04107 7.85851 4.42681 8.01208 4.14266 8.48566C3.85851 8.95924 4.01208 9.5735 4.48566 9.85764L7.32578 11.5617L4.33119 14.2569C3.92068 14.6263 3.8874 15.2586 4.25686 15.6691C4.62632 16.0796 5.25861 16.1129 5.66912 15.7434L8.00024 13.6454V17.9862C7.99679 18.2292 8.08142 18.4742 8.25686 18.6691C8.36705 18.7916 8.50063 18.8804 8.64473 18.9351C8.73515 18.9695 8.83185 18.9911 8.93264 18.9979C8.99647 19.0022 9.0607 19.0004 9.12437 18.9925C9.27975 18.9733 9.42408 18.9184 9.54893 18.8363C9.59408 18.8066 9.63668 18.7734 9.67633 18.737L12.6637 16.0483C13.6633 15.1487 13.508 13.5386 12.3548 12.8467L10.6745 11.8386L12.6637 10.0483C13.6633 9.14867 13.508 7.53864 12.3548 6.84673L9.53203 5.15309C9.43881 5.09444 9.33523 5.05076 9.22466 5.0254C8.98292 4.96967 8.73026 5.00691 8.51664 5.12463C8.38405 5.19769 8.26649 5.30175 8.17593 5.43383ZM10.0002 13.7664V15.7547L11.3258 14.5617L10.0002 13.7664ZM10.0002 9.75471V7.7664L11.3258 8.56172L10.0002 9.75471Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2302 9.36217C14.5825 8.93687 15.2129 8.87771 15.6382 9.23005C16.516 9.95727 17.0002 10.9557 17.0002 12.0001C17.0002 13.0446 16.516 14.043 15.6382 14.7702C15.2129 15.1225 14.5825 15.0634 14.2302 14.6381C13.8778 14.2128 13.937 13.5824 14.3623 13.23C14.8178 12.8527 15.0002 12.4034 15.0002 12.0001C15.0002 11.5969 14.8178 11.1475 14.3623 10.7702C13.937 10.4179 13.8778 9.78747 14.2302 9.36217Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2302 7.36217C16.5825 6.93687 17.2129 6.87771 17.6382 7.23005C19.1827 8.50956 20.0002 10.2318 20.0002 12.0001C20.0002 13.7684 19.1827 15.4907 17.6382 16.7702C17.2129 17.1225 16.5825 17.0634 16.2302 16.6381C15.8778 16.2128 15.937 15.5824 16.3623 15.23C17.4844 14.3004 18.0002 13.1272 18.0002 12.0001C18.0002 10.873 17.4844 9.69982 16.3623 8.7702C15.937 8.41787 15.8778 7.78747 16.2302 7.36217Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bluetooth-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bluetooth","disconnected","off","no connection","connection error","not connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 9L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bluetooth-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bluetooth","bluetooth-off","disconnected","offline","connection-error","no-connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 9L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bluetooth-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","disconnected","off","disabled","connection-error","no-connection","offline","error","trouble","communication-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 9L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bluetooth-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bluetooth","connection-off","disconnected","pairing-failed","device-error","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.3501 12.8496L14.8601 12.5496L13.4001 14.0096L14.3201 14.5596L12.9901 15.7496V14.4096L10.9901 16.4096V17.7696C10.9901 18.7196 12.1201 19.2196 12.8301 18.5896L15.6601 16.0496C16.6601 15.1496 16.5001 13.5396 15.3501 12.8496Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7101 4.28957C19.3201 3.89957 18.6901 3.89957 18.3001 4.28957L15.5801 7.00957C15.5101 6.94957 15.4401 6.88957 15.3601 6.83957L12.6701 5.22957C11.9401 4.78957 11.0001 5.31957 11.0001 6.16957V9.98957L8.60006 8.18957C8.16006 7.85957 7.53006 7.94957 7.20006 8.38957C6.87006 8.82957 6.96006 9.45957 7.40006 9.78957L10.4801 12.0996L4.29006 18.2896C3.90006 18.6796 3.90006 19.3096 4.29006 19.6996C4.68006 20.0896 5.31006 20.0896 5.70006 19.6996L19.7101 5.70957C20.1001 5.31957 20.1001 4.68957 19.7101 4.29957V4.28957ZM13.0001 7.75957L14.1401 8.43957L13.0001 9.57957V7.75957Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "blur-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["blur","off","unavailable","disabled","deactivate","drop","water-drop","filtration-off","filter-off","clear-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3385 4.25001C11.7165 3.91666 12.2835 3.91666 12.6615 4.25001L16.6669 7.78263C18.0974 9.06295 19 10.9267 19 13C19 14.5723 18.4816 16.0236 17.6064 17.1922L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L4.29289 6.70711C3.90237 6.31658 3.90237 5.68342 4.29289 5.29289C4.68342 4.90237 5.31658 4.90237 5.70711 5.29289L7.79203 7.37782L11.3385 4.25001ZM5.64576 10.06L14.9402 19.3544C14.0462 19.7688 13.0501 20 12 20C8.13401 20 5 16.866 5 13C5 11.9501 5.23147 10.9539 5.64576 10.06Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bluetooth: {
        defaultColors: ["#3D4C66"],
        keywords: ["blur","off","unavailable","disabled","deactivate","drop","water-drop","filtration-off","filter-off","clear-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L12 11.4L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.9946 9.30486C15.4944 8.85504 15.4167 8.05003 14.8401 7.70408L12 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L14.9946 15.3049C15.4944 14.855 15.4167 14.05 14.8401 13.7041L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "blur-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["disable","off","inactive","water-off","water-disable","liquid-off","liquid-disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L8 8.52779C6.7725 9.62643 6 11.223 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 11.223 17.2275 9.62643 16 8.52779L12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 20L5 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "blur-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["blur","disable","off","hidden","privacy","masked","blurred"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L8 8.52779C6.7725 9.62643 6 11.223 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 11.223 17.2275 9.62643 16 8.52779L12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 20L5 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "blur-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["disable","blocked","unavailable","not-available","restricted","off","blur-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L8 8.52779C6.7725 9.62643 6 11.223 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 11.223 17.2275 9.62643 16 8.52779L12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 20L5 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "board-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["board","presentation","display","analytics","sales-data","sales-board","analysis","report","metrics","graphical-data","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 8.11438 4 7.17157 4.58579 6.58579C5.17157 6 6.11438 6 8 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 11H17M15 13H17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12C7 13.1046 7.89543 14 9 14C9.55228 14 10.0523 13.7761 10.4142 13.4142C10.7761 13.0523 11 12.5523 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "board-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["display","screen","presentation","settings","configuration","menu","options","info","information","board","dashboard","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.67221 5.08215C6.28387 4.99991 7.04769 4.99995 7.93417 5H16.0658C16.9523 4.99995 17.7161 4.99991 18.3278 5.08215C18.9833 5.17028 19.6117 5.36902 20.1213 5.87868C20.631 6.38835 20.8297 7.0167 20.9179 7.67221C21.0001 8.28388 21.0001 9.0477 21 9.9342V14.0658C21.0001 14.9523 21.0001 15.7161 20.9179 16.3278C20.8297 16.9833 20.631 17.6117 20.1213 18.1213C19.6117 18.631 18.9833 18.8297 18.3278 18.9179C17.7161 19.0001 16.9523 19.0001 16.0658 19H7.93417C7.04769 19.0001 6.28387 19.0001 5.67221 18.9179C5.0167 18.8297 4.38835 18.631 3.87868 18.1213C3.36902 17.6117 3.17028 16.9833 3.08215 16.3278C2.99991 15.7161 2.99995 14.9523 3 14.0658V9.93417C2.99995 9.04769 2.99991 8.28387 3.08215 7.67221C3.17028 7.0167 3.36902 6.38835 3.87868 5.87868C4.38835 5.36902 5.0167 5.17028 5.67221 5.08215ZM6 12C6 10.3431 7.34315 9 9 9C10.6569 9 12 10.3431 12 12C12 12.8282 11.6631 13.5795 11.1213 14.1213C10.5795 14.6631 9.82815 15 9 15C7.34315 15 6 13.6569 6 12ZM15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15ZM15 13C14.4477 13 14 13.4477 14 14C14 14.5523 14.4477 15 15 15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "board-graph-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["board","graph","report","presentation","analytics","data","sales","statistics","screen","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M15 12H12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "board-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["presentation","board","graph","report","statistics","analytics","data","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 8.11438 4 7.17157 4.58579 6.58579C5.17157 6 6.11438 6 8 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 11H17M15 13H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12C7 13.1046 7.89543 14 9 14C9.55228 14 10.0523 13.7761 10.4142 13.4142C10.7761 13.0523 11 12.5523 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "board-graph-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["presentation","board","graph","data","sales","analytics","reporting","statistics","display","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 12H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "board-graph": {
        defaultColors: ["#3D4C66"],
        keywords: ["board","graph","presentation","analytics","statistics","sales-data","dashboard","reporting","trends","sales-trends","data-analysis","revenue","profit","loss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12C20 14.8284 20 16.2426 19.1213 17.1213C18.2426 18 16.8284 18 14 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M15 12H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "board-graph-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["board","presentation","graph","analytics","statistics","data","report","sales-report","trend","display","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 12.9797 10.3761 13.8131 11.25 14.122V12C11.25 11.5858 11.5858 11.25 12 11.25H14.122C13.8131 10.3761 12.9797 9.75 12 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12.75 12.75V14.122C13.3893 13.896 13.896 13.3893 14.122 12.75H12.75Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V5H14.0706C15.4246 4.99997 16.5413 4.99994 17.4251 5.11876C18.3529 5.2435 19.1723 5.51547 19.8284 6.17158C20.4845 6.82769 20.7565 7.64711 20.8813 8.57494C21.0001 9.45869 21 10.5753 21 11.9294V12.0706C21 13.4247 21.0001 14.5413 20.8813 15.4251C20.7565 16.3529 20.4845 17.1723 19.8284 17.8284C19.1723 18.4845 18.3529 18.7565 17.4251 18.8813C16.903 18.9514 16.2996 18.9802 15.614 18.9919L15.8944 19.5528C16.1414 20.0467 15.9412 20.6474 15.4472 20.8944C14.9532 21.1414 14.3525 20.9412 14.1055 20.4472L13.382 19H10.618L9.8944 20.4472C9.64741 20.9412 9.04674 21.1414 8.55276 20.8944C8.05878 20.6474 7.85856 20.0467 8.10555 19.5528L8.38598 18.9919C7.70039 18.9802 7.09703 18.9514 6.57494 18.8813C5.64711 18.7565 4.82769 18.4845 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11876 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0707V11.9294C2.99997 10.5753 2.99994 9.45867 3.11876 8.57494C3.2435 7.64711 3.51547 6.82769 4.17158 6.17158C4.82769 5.51547 5.64711 5.2435 6.57494 5.11876C7.45868 4.99994 8.57533 4.99997 9.9294 5H11V4C11 3.44772 11.4477 3 12 3ZM12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bold-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bold","text","font","format","letter","B"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12H13C14.6569 12 16 10.6569 16 9C16 7.34315 14.6569 6 13 6H10V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 18H13C14.6569 18 16 16.6569 16 15C16 13.3431 14.6569 12 13 12H10V18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    board: {
        defaultColors: ["#3D4C66"],
        keywords: ["bold","text","font","format","letter","B"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 8.11438 4 7.17157 4.58579 6.58579C5.17157 6 6.11438 6 8 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 11H17M15 13H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12C7 13.1046 7.89543 14 9 14C9.55228 14 10.0523 13.7761 10.4142 13.4142C10.7761 13.0523 11 12.5523 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 18L9 20M14 18L15 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bold-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bold","B","font","text","format"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12H13C14.6569 12 16 10.6569 16 9C16 7.34315 14.6569 6 13 6H10V12Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 18H13C14.6569 18 16 16.6569 16 15C16 13.3431 14.6569 12 13 12H10V18Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bold: {
        defaultColors: ["#3D4C66"],
        keywords: ["bold","B","font","text","format"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18H13C14.6569 18 16 16.6569 16 15V15C16 13.3431 14.6569 12 13 12H10V18ZM10 18H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6V12H13C14.6569 12 16 10.6569 16 9V9C16 7.34315 14.6569 6 13 6H10ZM10 6H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bold-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["B","bold","font","text","brand","button"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H9V17H8C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19H13C15.2091 19 17 17.2091 17 15C17 13.8053 16.4762 12.7329 15.6458 12C16.4762 11.2671 17 10.1947 17 9C17 6.79086 15.2091 5 13 5H8ZM13 11C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7H11V11H13ZM11 13V17H13C14.1046 17 15 16.1046 15 15C15 13.8954 14.1046 13 13 13H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bolt-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["bolt","lightning","fast","quick","speed","energy","electricity","charge","payment","express","instant","accelerate","turbo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.2466 10.5204L7.72147 7.6712C7.85449 6.87304 7.92101 6.47396 8.20075 6.23698C8.4805 6 8.88508 6 9.69425 6H12.9384C13.6483 6 14.0032 6 14.2448 6.14929C14.448 6.2748 14.5995 6.46887 14.672 6.6964C14.7582 6.967 14.6722 7.31134 14.5 8L14.2522 8.99117C14.1241 9.5036 14.5117 10 15.0399 10C15.7632 10 16.1255 10.8745 15.614 11.386L12.1206 14.8794C11.3852 15.6148 11.0175 15.9825 10.7595 16.052C10.2613 16.1862 9.74284 15.9193 9.56248 15.436C9.46906 15.1856 9.55455 14.6727 9.72553 13.6468L9.7534 13.4796C9.80135 13.1919 9.82533 13.048 9.8171 12.9303C9.78665 12.4946 9.47703 12.1291 9.05233 12.0275C8.93756 12 8.7917 12 8.5 12C8.20829 12 8.06244 12 7.94767 11.9725C7.52297 11.8709 7.21335 11.5054 7.1829 11.0697C7.17466 10.952 7.19864 10.8081 7.2466 10.5204Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bolt-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","fast","electricity","power","quick","charge","flash","energy","instant","speed","rush","express","accelerate","high-speed","rapid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.2466 10.5204L7.72147 7.6712C7.85449 6.87304 7.92101 6.47396 8.20075 6.23698C8.4805 6 8.88508 6 9.69425 6H12.9384C13.6483 6 14.0032 6 14.2448 6.14929C14.448 6.2748 14.5995 6.46887 14.672 6.6964C14.7582 6.967 14.6722 7.31134 14.5 8L14.2522 8.99117C14.1241 9.5036 14.5117 10 15.0399 10C15.7632 10 16.1255 10.8745 15.614 11.386L12.1206 14.8794C11.3852 15.6148 11.0175 15.9825 10.7595 16.052C10.2613 16.1862 9.74284 15.9193 9.56248 15.436C9.46906 15.1856 9.55455 14.6727 9.72553 13.6468L9.7534 13.4796C9.80135 13.1919 9.82533 13.048 9.8171 12.9303C9.78665 12.4946 9.47703 12.1291 9.05233 12.0275C8.93756 12 8.7917 12 8.5 12C8.20829 12 8.06244 12 7.94767 11.9725C7.52297 11.8709 7.21335 11.5054 7.1829 11.0697C7.17466 10.952 7.19864 10.8081 7.2466 10.5204Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bolt-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bolt","lightning","fast","quick","speed","energy","power","instant","electricity","flash","charge","rapid","accelerate","boost","express","urgent","high-speed","high-power","point-of-sale","transaction","processing","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L7 14H12V19L17 10H12V5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","fast","quick","charge","flash","electricity","speed","power","accelerate","energy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.64595 5.00001C9.28344 4.99993 8.92528 4.99986 8.62509 5.03734C8.28386 5.07994 7.89848 5.18248 7.55439 5.47397C7.21029 5.76547 7.0458 6.12874 6.94767 6.45832C6.86135 6.74828 6.80254 7.10156 6.74302 7.45916L6.26022 10.356L6.24949 10.4197C6.2128 10.6361 6.16845 10.8979 6.18534 11.1395C6.24626 12.0108 6.86549 12.7417 7.71488 12.9451C7.95047 13.0015 8.21592 13.0007 8.43546 13.0001L8.50001 13C8.65378 13 8.74018 13.0002 8.8032 13.0027L8.81575 13.0032L8.81424 13.0157C8.80632 13.0783 8.79229 13.1635 8.76702 13.3152L8.73395 13.5136C8.65288 14 8.58483 14.4082 8.55064 14.7249C8.52069 15.0023 8.48675 15.4135 8.62559 15.7856C8.98631 16.7523 10.0233 17.2859 11.0196 17.0176C11.4031 16.9143 11.7179 16.6477 11.9263 16.462C12.1641 16.2502 12.4567 15.9575 12.8054 15.6089L16.3211 12.0931C17.4051 11.0091 16.7305 9.19427 15.2772 9.01447L15.4793 8.20613C15.5575 7.89333 15.6315 7.59723 15.6709 7.34618C15.7129 7.07775 15.7368 6.74414 15.6248 6.3928C15.4798 5.93776 15.1768 5.54962 14.7705 5.29859C14.4568 5.10476 14.1274 5.047 13.8567 5.02269C13.6037 4.99994 13.2985 4.99998 12.976 5.00001L9.64595 5.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bolt-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","fast","quick","instant","electricity","energy","power","flash","speed","zap","urgent","charge","accelerate","boost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L7 14H12V19L17 10H12V5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bolt-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["bolt","lightning","flash","fast","quick","power","electricity","charge","energy","instant","promotion","discount","express","speed","zap","sale","special-offer","lightning-deal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L7 14H12V19L17 10H12V5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bolt: {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","flash","fast","quick","power","electricity","charge","energy","instant","promotion","discount","express","speed","zap","sale","special-offer","lightning-deal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.2466 10.5204L7.72147 7.6712C7.85449 6.87304 7.92101 6.47396 8.20075 6.23698C8.4805 6 8.88508 6 9.69425 6H12.9384C13.6483 6 14.0032 6 14.2448 6.14929C14.448 6.2748 14.5995 6.46887 14.672 6.6964C14.7582 6.967 14.6722 7.31134 14.5 8L14.2522 8.99117C14.1241 9.5036 14.5117 10 15.0399 10C15.7632 10 16.1255 10.8745 15.614 11.386L12.1206 14.8794C11.3852 15.6148 11.0175 15.9825 10.7595 16.052C10.2613 16.1862 9.74284 15.9193 9.56248 15.436C9.46906 15.1856 9.55455 14.6727 9.72553 13.6468L9.7534 13.4796C9.80135 13.1919 9.82533 13.048 9.8171 12.9303C9.78665 12.4946 9.47703 12.1291 9.05233 12.0275C8.93756 12 8.7917 12 8.5 12C8.20829 12 8.06244 12 7.94767 11.9725C7.52297 11.8709 7.21335 11.5054 7.1829 11.0697C7.17466 10.952 7.19864 10.8081 7.2466 10.5204Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bolt-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","flash","lightning","power","quick","charge","fast","speed","accelerate","energy","instant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5.00009C13 4.54442 12.6919 4.14637 12.2508 4.03206C11.8097 3.91776 11.3471 4.11612 11.1258 4.51445L6.12584 13.5144C5.95377 13.8242 5.95844 14.2018 6.13813 14.5072C6.31781 14.8126 6.64568 15.0001 7 15.0001H11V19.0001C11 19.4558 11.3081 19.8538 11.7492 19.9681C12.1903 20.0824 12.6529 19.8841 12.8742 19.4857L17.8742 10.4857C18.0462 10.176 18.0416 9.79834 17.8619 9.49297C17.6822 9.18759 17.3543 9.00009 17 9.00009H13V5.00009Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "book-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["book","catalog","menu","list","product-list","item-list","details","product-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 16V14H7C5.89543 14 5 14.8954 5 16V16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H17C17.9428 4 18.4142 4 18.7071 4.29289C19 4.58579 19 5.05719 19 6V18C19 18.9428 19 19.4142 18.7071 19.7071C18.4142 20 17.9428 20 17 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14V10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "book-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["book","ledger","record","report","inventory","catalog","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.0106 15.746C4.00358 15.8297 4 15.9144 4 16H4.01692C4.03241 16.5284 4.06204 17.0033 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.4587 21.0001 9.57531 21 10.9294 21L17.0544 21C17.4785 21.0001 17.8906 21.0002 18.2305 20.9545C18.6137 20.903 19.051 20.7774 19.4142 20.4142C19.7774 20.051 19.903 19.6137 19.9545 19.2305C20.0002 18.8907 20.0001 18.4786 20 18.0545V5.9456C20.0001 5.52158 20.0002 5.10938 19.9545 4.76949C19.903 4.38629 19.7774 3.94902 19.4142 3.5858C19.051 3.22259 18.6137 3.09706 18.2305 3.04554C17.8906 2.99984 17.4785 2.99992 17.0544 3.00001L10.9294 3.00001C9.57531 2.99998 8.4587 2.99995 7.57494 3.11877C6.64711 3.24351 5.82769 3.51548 5.17158 4.17159C4.51547 4.8277 4.2435 5.64712 4.11876 6.57495C3.99994 7.4587 3.99997 8.5753 4 9.92941V14.0706C3.99999 14.6764 3.99997 15.2348 4.0106 15.746ZM18 18C18 18.4997 17.9979 18.7738 17.9723 18.964L17.9713 18.9713L17.964 18.9723C17.7738 18.9979 17.4997 19 17 19H11C9.55752 19 8.57626 18.9979 7.84144 18.8991C7.13538 18.8042 6.80836 18.6368 6.58579 18.4142C6.36322 18.1917 6.19585 17.8646 6.10092 17.1586C6.05128 16.7894 6.02605 16.3579 6.01322 15.837C6.09107 15.3622 6.50323 15 7 15H18L18 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "book-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["book","ledger","register","record","journal","report","transaction","data","log"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H17C17.9428 4 18.4142 4 18.7071 4.29289C19 4.58579 19 5.05719 19 6V18C19 18.9428 19 19.4142 18.7071 19.7071C18.4142 20 17.9428 20 17 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14V10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.5 20H17C17.9428 20 18.4142 20 18.7071 19.7071C19 19.4142 19 18.9428 19 18V14H6.83877C5.82325 14 5 14.8232 5 15.8388V16.5C5 16.9644 5 17.1966 5.02567 17.3916C5.2029 18.7378 6.26222 19.7971 7.60842 19.9743C7.80337 20 8.03558 20 8.5 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    book: {
        defaultColors: ["#3D4C66"],
        keywords: ["book","ledger","register","record","journal","report","transaction","data","log"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H17C17.9428 4 18.4142 4 18.7071 4.29289C19 4.58579 19 5.05719 19 6V18C19 18.9428 19 19.4142 18.7071 19.7071C18.4142 20 17.9428 20 17 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 16V14H7C5.89543 14 5 14.8954 5 16V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "bookmark list-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","transaction","invoice","list","bill","sales-record","purchase","record","order-summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6.00048L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V6.00008C19 4.89548 18.1045 4.00004 16.9999 4.00008L6.99992 4.00048C5.89538 4.00052 5 4.89594 5 6.00048Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11H15M10 14H14M10 8H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark list-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","invoice","bill","transaction","order-details","purchase","sales-record","payment-history","transaction-history","record","list","menu","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6.00048L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V6.00008C19 4.89548 18.1045 4.00004 16.9999 4.00008L6.99992 4.00048C5.89538 4.00052 5 4.89594 5 6.00048Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11H15M10 14H14M10 8H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","list","order-details","transaction","invoice","menu","order","sales-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9999 3L6.99988 3.0004C5.34307 3.00046 4 4.34359 4 6.0004V19.9999C4 20.3576 4.19104 20.6881 4.50102 20.8665C4.81099 21.045 5.19269 21.0443 5.50203 20.8648L8.5 19.1245L11.498 20.8648C11.8084 21.045 12.1917 21.045 12.5021 20.8647L15.5001 19.124L18.498 20.8642C18.8073 21.0438 19.189 21.0445 19.499 20.866C19.809 20.6875 20 20.3571 20 19.9994V6C20 4.3431 18.6568 2.99993 16.9999 3ZM10 6.99988C9.44772 6.99988 9 7.44759 9 7.99988C9 8.55216 9.44772 8.99988 10 8.99988H14C14.5523 8.99988 15 8.55216 15 7.99988C15 7.44759 14.5523 6.99988 14 6.99988H10ZM9 9.99988C8.44772 9.99988 8 10.4476 8 10.9999C8 11.5522 8.44772 11.9999 9 11.9999H15C15.5523 11.9999 16 11.5522 16 10.9999C16 10.4476 15.5523 9.99988 15 9.99988H9ZM10 12.9999C9.44772 12.9999 9 13.4476 9 13.9999C9 14.5522 9.44772 14.9999 10 14.9999H14C14.5523 14.9999 15 14.5522 15 13.9999C15 13.4476 14.5523 12.9999 14 12.9999H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","flag","save","favorite","tag","loyalty","customer","member","rewards","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 7H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","favorite","save","loyalty","rewards","promotion","saved-item","saved-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark list": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","list","invoice","sales-report","transaction","record","history","details","summary","bill","sales","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6.00048L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V6.00008C19 4.89548 18.1045 4.00004 16.9999 4.00008L6.99992 4.00048C5.89538 4.00052 5 4.89594 5 6.00048Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11H15M10 14H14M10 8H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["bookmark","save","favorite","loyalty","customer","profile","tag","flag","saved-items","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","tag","label","promotion","offer","discount","loyalty","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3278 3.08215C15.7161 2.99991 14.9523 2.99995 14.0658 3L9.93418 3C9.04773 2.99995 8.28386 2.99991 7.67222 3.08215C7.01671 3.17028 6.38835 3.36902 5.87869 3.87868C5.36903 4.38835 5.17028 5.0167 5.08215 5.67221C4.99992 6.28387 4.99996 7.04769 5.00001 7.93417L5.00001 16.8346C4.99992 17.4987 4.99984 18.1057 5.07014 18.5791C5.1451 19.0839 5.33596 19.7047 5.94855 20.0833C6.56113 20.4619 7.20173 20.355 7.68673 20.1963C8.14162 20.0474 8.68444 19.7759 9.27843 19.4788L10.6584 18.7889C11.626 18.3051 11.8194 18.2361 12 18.2361C12.1806 18.2361 12.3741 18.3051 13.3417 18.7889L14.7216 19.4788C15.3155 19.7759 15.8584 20.0474 16.3133 20.1963C16.7983 20.355 17.4389 20.4619 18.0515 20.0833C18.6641 19.7047 18.8549 19.0839 18.9299 18.5791C19.0002 18.1057 19.0001 17.4988 19 16.8347C19.0001 15.9482 19.0001 6.28387 18.9179 5.67221C18.8297 5.0167 18.631 4.38835 18.1213 3.87868C17.6117 3.36902 16.9833 3.17028 16.3278 3.08215ZM10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8H14C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","loyalty","promotion","discount","tagged-item","saved-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C13.3541 2.99997 14.5413 2.99994 15.4251 3.11875C16.3529 3.2435 17.1723 3.51547 17.8284 4.17158C18.4845 4.82768 18.7565 5.64711 18.8813 6.57494C19.0001 7.4587 19 8.57531 19 9.92943L19 15.601L19 15.6729C19.0001 16.3679 19.0002 16.9987 18.9276 17.4877C18.8508 18.0041 18.6546 18.6475 18.0143 19.0242C17.3739 19.401 16.7163 19.2601 16.2275 19.0764C15.7648 18.9024 15.2135 18.596 14.6059 18.2584L14.4282 18.1596C13.6996 17.7548 13.2136 17.4861 12.8143 17.3118C12.4346 17.1461 12.2033 17.0985 12 17.0985C11.7967 17.0985 11.5654 17.1461 11.1857 17.3118C10.7864 17.4861 10.3004 17.7548 9.5718 18.1596L9.45694 18.2234L9.39408 18.2584L9.39404 18.2584C8.78652 18.596 8.23522 18.9024 7.77248 19.0764C7.28375 19.2601 6.62608 19.401 5.98576 19.0242C5.34543 18.6475 5.14918 18.0041 5.07247 17.4877C4.99984 16.9987 4.99992 16.368 5.00001 15.6729L5.00001 15.601L5.00001 9.92943L5.00001 9.92943C4.99998 8.57531 4.99995 7.4587 5.11876 6.57494C5.24351 5.64711 5.51548 4.82768 6.17158 4.17158C6.82769 3.51547 7.64712 3.2435 8.57495 3.11875C9.45871 2.99994 10.6459 2.99997 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","saved-items","loyalty","customer","profile","rewards","membership","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bookmark-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","tag","label","mark","saved-item","item-tag","product-tag","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bookmark-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["bookmark","save","favorite","tag","label","loyalty","customer","rewards","promotions","saved-items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bookmark-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","favorite","save","tag","promotion","loyalty","reward","discount","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 7H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","item","product","tag","label","category","discount","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18.9551C11.8484 18.9617 11.6406 19.0194 10.821 19.3999L10.8209 19.4C9.73163 19.9057 8.75616 20.3587 8.01077 20.59C7.24042 20.8291 6.42624 20.9375 5.64758 20.5442C5.4682 20.4537 5.29838 20.3453 5.14068 20.2207C4.45609 19.6801 4.21154 18.896 4.10399 18.0966C3.99993 17.3231 3.99996 16.3202 4 15.1192V15.1192L4 8.92943L4 8.92943C3.99997 7.57531 3.99994 6.4587 4.11876 5.57494C4.2435 4.64711 4.51547 3.82769 5.17158 3.17158C5.82768 2.51547 6.64711 2.2435 7.57494 2.11876C8.4587 1.99994 9.57531 1.99997 10.9294 2L10.9294 2L12 2H13.0706H13.0706C14.4247 1.99997 15.5413 1.99994 16.4251 2.11876C17.3529 2.2435 18.1723 2.51547 18.8284 3.17158C19.4845 3.82769 19.7565 4.64711 19.8812 5.57494C20.0001 6.4587 20 7.57531 20 8.92943L20 15.1192C20 16.3201 20.0001 17.3231 19.896 18.0966C19.7885 18.896 19.5439 19.6801 18.8593 20.2207C18.7016 20.3453 18.5318 20.4537 18.3524 20.5442C17.5738 20.9375 16.7596 20.8291 15.9892 20.59C15.2439 20.3587 14.2684 19.9058 13.1792 19.4L13.179 19.3999C12.3594 19.0194 12.1516 18.9617 12 18.9551Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","save","favorite","loyalty","rewards","promotion","item","product","saved-items","favorite-items","loyalty-program","promotion-tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 7H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","add","plus","save","favorite","add-favorite","add-bookmark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L14 10M12 10L10 10M12 10V8M12 10V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","add","plus","save","favorite","add-favorite","add-bookmark","promotion","add-promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L14 10M12 10L10 10M12 10V8M12 10V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","add","plus","favorite","add-favorite","save","add-item","tag","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C10.6459 2.99997 9.4587 2.99994 8.57495 3.11876C7.64712 3.2435 6.82769 3.51547 6.17158 4.17158C5.51548 4.82769 5.24351 5.64711 5.11876 6.57494C4.99995 7.4587 4.99998 8.57531 5.00001 9.92943L5.00001 15.6729C4.99992 16.368 4.99984 16.9987 5.07247 17.4877C5.14918 18.0041 5.34543 18.6475 5.98576 19.0242C6.62608 19.401 7.28375 19.2601 7.77248 19.0764C8.23523 18.9024 8.96426 18.4973 9.5718 18.1596C10.3004 17.7548 10.7864 17.4861 11.1857 17.3118C11.5654 17.1461 11.7967 17.0985 12 17.0985C12.2033 17.0985 12.4346 17.1461 12.8143 17.3118C13.2136 17.4861 13.6996 17.7548 14.4282 18.1596C15.0358 18.4973 15.7648 18.9024 16.2275 19.0764C16.7163 19.2601 17.3739 19.401 18.0143 19.0242C18.6546 18.6475 18.8508 18.0041 18.9276 17.4877C19.0002 16.9987 19.0001 16.3679 19 15.6729L19 9.92943C19 8.57531 19.0001 7.4587 18.8813 6.57494C18.7565 5.64711 18.4845 4.82769 17.8284 4.17158C17.1723 3.51547 16.3529 3.2435 15.4251 3.11876C14.5413 2.99994 13.3541 2.99997 12 3ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V9L10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44771 11 10 11L11 11V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V11L14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9L13 9V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-add-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","add","new-bookmark","save","plus","add-bookmark","favorite","new-favorite","add-favorite","coupon","add-coupon","new-coupon","discount","add-discount","new-discount","reward","add-reward","new-reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L15 11M12 11L9 11M12 11V8M12 11V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-add-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","add","plus","new-receipt","create-receipt","add-item","new","bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L15 11M12 11L9 11M12 11V8M12 11V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","add","new","plus","save","favorite","add-to-favorites","add-bookmark","tag","add-tag","label","add-label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L14 10M12 10L10 10M12 10V8M12 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-add-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","add","new-receipt","plus","transaction","add-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8284 4.17141C18.1722 3.51529 17.3528 3.24334 16.4249 3.11863C15.5411 2.99984 14.4245 2.99992 13.0703 3L10.9292 3.00009C9.57509 3.00011 8.45851 3.00012 7.57479 3.11897C6.64699 3.24375 5.8276 3.51573 5.17152 4.17184C4.51544 4.82794 4.24349 5.64734 4.11875 6.57514C3.99994 7.45886 3.99997 8.57541 4 9.92944L4 19.9998C4 20.3575 4.19105 20.6879 4.50102 20.8664C4.811 21.0449 5.1927 21.0442 5.50204 20.8646L8.5 19.1243L11.498 20.8646C11.8084 21.0448 12.1917 21.0448 12.5021 20.8646L15.5001 19.1238L18.498 20.8641C18.8073 21.0436 19.189 21.0443 19.499 20.8658C19.809 20.6873 20 20.3569 20 19.9992L20 9.92943C20 8.5753 20.0001 7.45859 19.8812 6.57483C19.7565 5.64697 19.4845 4.82752 18.8284 4.17141ZM13 7.99976C13 7.44747 12.5523 6.99976 12 6.99976C11.4477 6.99976 11 7.44747 11 7.99976V9.99976L9 9.99976C8.44772 9.99976 8 10.4475 8 10.9998C8 11.552 8.44772 11.9998 9 11.9998H11V13.9998C11 14.552 11.4477 14.9998 12 14.9998C12.5523 14.9998 13 14.552 13 13.9998V11.9998H15C15.5523 11.9998 16 11.552 16 10.9998C16 10.4475 15.5523 9.99976 15 9.99976L13 9.99976V7.99976Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-add-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","add","plus","new-receipt","add-receipt","create-receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L15 11M12 11L9 11M12 11V8M12 11V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","check","checkmark","complete","transaction","order-complete","payment-received","validated","confirmation","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","check","checkmark","verified","transaction","payment","approved","order-complete","success","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8284 4.17141C18.1722 3.51529 17.3528 3.24334 16.4249 3.11863C15.5411 2.99984 14.4245 2.99992 13.0703 3L10.9292 3.00009C9.57509 3.00011 8.45851 3.00012 7.57479 3.11897C6.64699 3.24375 5.8276 3.51573 5.17152 4.17184C4.51544 4.82794 4.24349 5.64734 4.11875 6.57514C3.99994 7.45886 3.99997 8.57541 4 9.92944L4 19.9998C4 20.3575 4.19105 20.6879 4.50102 20.8664C4.811 21.0449 5.1927 21.0442 5.50204 20.8646L8.5 19.1243L11.498 20.8646C11.8084 21.0448 12.1917 21.0448 12.5021 20.8646L15.5001 19.1238L18.498 20.8641C18.8073 21.0436 19.189 21.0443 19.499 20.8658C19.809 20.6873 20 20.3569 20 19.9992L20 9.92943C20 8.5753 20.0001 7.45859 19.8812 6.57483C19.7565 5.64697 19.4845 4.82752 18.8284 4.17141ZM15.7071 10.7069C16.0976 10.3163 16.0976 9.68317 15.7071 9.29265C15.3166 8.90212 14.6834 8.90212 14.2929 9.29265L11 12.5855L9.70711 11.2926C9.31658 10.9021 8.68342 10.9021 8.2929 11.2926C7.90237 11.6832 7.90237 12.3163 8.2929 12.7069L10.2929 14.7069C10.6834 15.0974 11.3166 15.0974 11.7071 14.7069L15.7071 10.7069Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-check-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","check","completed","saved","verified","approved","selected","confirm","flag","validated","ok","done"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.5L11.3333 12L14 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-check-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","check","checked","validated","confirmed","saved","completed","flagged","approved","order-confirmation","payment-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.5L11.3333 12L14 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","minus","remove","discount","delete","tag","remove-discount","subtract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L9 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-check-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","check","mark","saved","completed","confirmed","verified","selected","approved","flag","reminder","save","done","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1857 17.3118C11.5654 17.1461 11.7967 17.0985 12 17.0985C12.2033 17.0985 12.4346 17.1461 12.8143 17.3118C13.2136 17.4861 13.6996 17.7548 14.4282 18.1596C15.0357 18.4973 15.7648 18.9024 16.2275 19.0764C16.7162 19.2601 17.3739 19.401 18.0142 19.0242C18.6546 18.6475 18.8508 18.0041 18.9275 17.4877C19.0002 16.9987 19.0001 16.368 19 15.6729L19 9.92943C19 8.57532 19.0001 7.45869 18.8812 6.57494C18.7565 5.64711 18.4845 4.82769 17.8284 4.17158C17.1723 3.51547 16.3529 3.2435 15.4251 3.11876C14.5413 2.99994 13.3542 2.99997 12.0001 3C10.6459 2.99997 9.45871 2.99994 8.57495 3.11876C7.64712 3.2435 6.82769 3.51547 6.17158 4.17158C5.51548 4.82769 5.24351 5.64711 5.11876 6.57494C4.99995 7.4587 4.99998 8.57531 5.00001 9.92943L5.00001 15.6729C4.99992 16.368 4.99984 16.9987 5.07247 17.4877C5.14918 18.0041 5.34543 18.6475 5.98576 19.0242C6.62608 19.401 7.28375 19.2601 7.77248 19.0764C8.23523 18.9024 8.96426 18.4973 9.5718 18.1596C10.3004 17.7548 10.7864 17.4861 11.1857 17.3118ZM14.7474 9.66437C15.1143 9.25159 15.0772 8.61952 14.6644 8.2526C14.2516 7.88568 13.6195 7.92286 13.2526 8.33565L11.3333 10.4948L10.7474 9.83565C10.3805 9.42286 9.74843 9.38568 9.33565 9.7526C8.92286 10.1195 8.88568 10.7516 9.2526 11.1644L10.5859 12.6644C10.7757 12.8779 11.0477 13 11.3333 13C11.619 13 11.891 12.8779 12.0808 12.6644L14.7474 9.66437Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","check","confirmation","complete","transaction","payment","verified","order-complete","invoice","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","check","validated","confirmation","order-confirmation","payment-confirmation","complete","approved","bookmark","checked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","minus","discount","remove","subtract","delete","invoice","payment","bill","deduct"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L9 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","remove","discount","coupon","remove-coupon","loyalty","loyalty-points","reduce","minus","tag","remove-discount","sales","cut","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L9 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","slash","disable","remove","tag","unavailable","item-unavailable","promotion-unavailable","discount-unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","slash","disabled","inactive","removed","unavailable","unsaved","delete-bookmark","remove-bookmark","clear-bookmark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","remove","delete","minus","discount","coupon","remove-bookmark","delete-bookmark","discount-remove","coupon-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8284 4.17141C18.1722 3.51529 17.3528 3.24334 16.4249 3.11863C15.5411 2.99984 14.4245 2.99992 13.0703 3L10.9292 3.00009C9.57509 3.00011 8.45851 3.00012 7.57479 3.11897C6.64699 3.24375 5.8276 3.51573 5.17152 4.17184C4.51544 4.82794 4.24349 5.64734 4.11875 6.57514C3.99994 7.45886 3.99997 8.57541 4 9.92944L4 19.9998C4 20.3575 4.19105 20.6879 4.50102 20.8664C4.811 21.0449 5.1927 21.0442 5.50204 20.8646L8.5 19.1243L11.498 20.8646C11.8084 21.0448 12.1917 21.0448 12.5021 20.8646L15.5001 19.1238L18.498 20.8641C18.8073 21.0436 19.189 21.0443 19.499 20.8658C19.809 20.6873 20 20.3569 20 19.9992L20 9.92943C20 8.5753 20.0001 7.45859 19.8812 6.57483C19.7565 5.64697 19.4845 4.82752 18.8284 4.17141ZM9 9.99976C8.44772 9.99976 8 10.4475 8 10.9998C8 11.552 8.44772 11.9998 9 11.9998L15 11.9998C15.5523 11.9998 16 11.552 16 10.9998C16 10.4475 15.5523 9.99976 15 9.99976L9 9.99976Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-check-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","check","verified","saved","completed","approved","validated","flag","ok","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.5L11.3333 12L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","slash","remove","discount","cancel","delete-discount","remove-discount","disable-discount","no-discount","rejected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.69006 20.2C8.14006 20.05 8.69006 19.78 9.28006 19.48L10.6601 18.79C11.6301 18.31 11.8201 18.24 12.0001 18.24C12.1801 18.24 12.3701 18.31 13.3401 18.79L14.7201 19.48C15.3101 19.78 15.8601 20.05 16.3101 20.2C16.7901 20.36 17.4401 20.47 18.0501 20.09C18.6601 19.71 18.8501 19.09 18.9301 18.59C19.0001 18.12 19.0001 17.51 19.0001 16.85V8.41L7.08006 20.33C7.30006 20.31 7.50006 20.26 7.68006 20.2H7.69006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7101 4.29C19.3501 3.93 18.8001 3.92 18.4001 4.22C18.3201 4.1 18.2301 3.99 18.1201 3.88C17.6101 3.37 16.9801 3.17 16.3301 3.08C15.7201 3 14.9501 3 14.0701 3H9.93006C9.04006 3 8.28006 3 7.67006 3.08C7.01006 3.17 6.39006 3.37 5.88006 3.88C5.37006 4.39 5.17006 5.02 5.08006 5.67C5.00006 6.28 5.00006 7.05 5.00006 7.93V16.83C5.00006 17.09 5.00006 17.33 5.00006 17.57L4.29006 18.28C3.90006 18.67 3.90006 19.3 4.29006 19.69C4.68006 20.08 5.31006 20.08 5.70006 19.69L19.7101 5.71C20.1001 5.32 20.1001 4.69 19.7101 4.3V4.29Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-star-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","star","favorite","loyalty","rewards","saved-item","promotion","highlight","feature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 2H10.9294H10.9294C9.57529 1.99997 8.45869 1.99994 7.57494 2.11876C6.64711 2.2435 5.82769 2.51547 5.17158 3.17158C4.51547 3.82769 4.2435 4.64711 4.11876 5.57494C3.99994 6.4587 3.99997 7.57531 4 8.92943L4 8.92943L4 15.1192V15.1192C3.99996 16.3202 3.99993 17.3231 4.10399 18.0966C4.21154 18.896 4.45609 19.6801 5.14068 20.2207C5.29838 20.3453 5.46821 20.4537 5.64758 20.5442C6.42625 20.9375 7.24042 20.8291 8.01077 20.59C8.75616 20.3587 9.66578 19.9363 10.7551 19.4305L10.7551 19.4305L10.821 19.3999C11.6406 19.0194 11.8049 18.9626 11.9565 18.956C11.9855 18.9547 12.0145 18.9547 12.0435 18.956C12.1951 18.9626 12.3595 19.0194 13.179 19.3999L13.2449 19.4305C14.3342 19.9363 15.2438 20.3587 15.9892 20.59C16.7596 20.8291 17.5738 20.9375 18.3524 20.5442C18.5318 20.4537 18.7016 20.3453 18.8593 20.2207C19.5439 19.6801 19.7885 18.896 19.896 18.0966C20.0001 17.3231 20 16.3202 20 15.1191V8.92943C20 7.57531 20.0001 6.4587 19.8813 5.57494C19.7565 4.64711 19.4845 3.82769 18.8284 3.17158C18.1723 2.51547 17.3529 2.2435 16.4251 2.11876C15.5413 1.99994 14.4247 1.99997 13.0706 2H13.0706ZM12.9539 7.69977C12.8228 7.28328 12.4367 7 12.0001 7C11.5634 7 11.1773 7.28328 11.0462 7.69977L10.5582 9.25H9.00006C8.57385 9.25 8.19447 9.52014 8.05507 9.92291C7.91566 10.3257 8.04685 10.7725 8.38187 11.036L9.66221 12.043L9.06302 13.6508C8.90977 14.062 9.04253 14.5251 9.39038 14.7926C9.73823 15.0602 10.2199 15.0697 10.578 14.8161L12.0001 13.809L13.4221 14.8161C13.7802 15.0697 14.2619 15.0602 14.6097 14.7926C14.9576 14.5251 15.0904 14.062 14.9371 13.6508L14.3379 12.043L15.6183 11.036C15.9533 10.7725 16.0845 10.3257 15.9451 9.92291C15.8056 9.52014 15.4263 9.25 15.0001 9.25H13.4419L12.9539 7.69977Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","slash","disabled","inactive","unavailable","blocked","item-removed","not-favorite","deselected","tag-off","flag-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V16.7639C6 18.2143 6 18.9395 6.47427 19.2326C6.94854 19.5257 7.59717 19.2014 8.89443 18.5528L10.2111 17.8944C11.089 17.4555 11.5279 17.2361 12 17.2361C12.4721 17.2361 12.911 17.4555 13.7889 17.8944L15.1056 18.5528C16.4028 19.2014 17.0515 19.5257 17.5257 19.2326C18 18.9395 18 18.2143 18 16.7639V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bookmark-star-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","star","favorite","save","loyalty","reward","promotion","discount","vip","member","featured"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7082 10.25L12 8L11.2918 10.25H9L10.8541 11.7082L10 14L12 12.5836L14 14L13.1459 11.7082L15 10.25H12.7082Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-star": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","star","favorite","loyalty","rewards","saved-item","flag","special","promotions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7082 10.25L12 8L11.2918 10.25H9L10.8541 11.7082L10 14L12 12.5836L14 14L13.1459 11.7082L15 10.25H12.7082Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-star-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","star","favorite","save","item","popular","loyalty","rewards","promotion","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3H11C8.17157 3 6.75736 3 5.87868 3.87868C5 4.75736 5 6.17157 5 9V15.0465C5 17.5724 5 18.8354 5.76045 19.4359C5.86559 19.519 5.9788 19.5912 6.09839 19.6516C6.96333 20.0885 8.10885 19.5566 10.3999 18.4929C11.1447 18.1471 11.5171 17.9742 11.913 17.9569C11.971 17.9544 12.029 17.9544 12.087 17.9569C12.4829 17.9742 12.8553 18.1471 13.6001 18.4929C15.8912 19.5566 17.0367 20.0885 17.9016 19.6516C18.0212 19.5912 18.1344 19.519 18.2396 19.4359C19 18.8354 19 17.5724 19 15.0465V9C19 6.17157 19 4.75736 18.1213 3.87868C17.2426 3 15.8284 3 13 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7082 10.25L12 8L11.2918 10.25H9L10.8541 11.7082L10 14L12 12.5836L14 14L13.1459 11.7082L15 10.25H12.7082Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","x","cancel","delete","remove","tag","discount-tag","promotions","remove-promotion","cancel-promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","cancel","void","remove","delete","transaction","error","bill","invoice","cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","remove","delete","cancel","error","invalid","flag","discount-remove","promotion-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","x","delete","remove","cancel","flag","remove-item","delete-item","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8284 4.17141C18.1722 3.51529 17.3528 3.24334 16.4249 3.11863C15.5411 2.99984 14.4245 2.99992 13.0703 3L10.9292 3.00009C9.57509 3.00011 8.45851 3.00012 7.57479 3.11897C6.64699 3.24375 5.8276 3.51573 5.17152 4.17184C4.51544 4.82794 4.24349 5.64734 4.11875 6.57514C3.99994 7.45886 3.99997 8.57541 4 9.92944L4 19.9998C4 20.3575 4.19105 20.6879 4.50102 20.8664C4.811 21.0449 5.1927 21.0442 5.50204 20.8646L8.5 19.1243L11.498 20.8646C11.8084 21.0448 12.1917 21.0448 12.5021 20.8646L15.5001 19.1238L18.498 20.8641C18.8073 21.0436 19.189 21.0443 19.499 20.8658C19.809 20.6873 20 20.3569 20 19.9992L20 9.92943C20 8.5753 20.0001 7.45859 19.8812 6.57483C19.7565 5.64697 19.4845 4.82752 18.8284 4.17141ZM10.7071 8.29265C10.3166 7.90212 9.68342 7.90212 9.2929 8.29265C8.90237 8.68317 8.90237 9.31634 9.2929 9.70686L10.5858 10.9998L9.2929 12.2926C8.90237 12.6832 8.90237 13.3163 9.29289 13.7069C9.68342 14.0974 10.3166 14.0974 10.7071 13.7069L12 12.414L13.2929 13.7069C13.6834 14.0974 14.3166 14.0974 14.7071 13.7069C15.0976 13.3163 15.0976 12.6832 14.7071 12.2926L13.4142 10.9998L14.7071 9.70686C15.0976 9.31634 15.0976 8.68317 14.7071 8.29265C14.3166 7.90212 13.6834 7.90212 13.2929 8.29265L12 9.58554L10.7071 8.29265Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-x-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","remove","delete","cancel","flag","discount","remove-discount","delete-discount","cancel-discount","remove-item","delete-item","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C10.6459 2.99997 9.4587 2.99994 8.57495 3.11876C7.64712 3.2435 6.82769 3.51547 6.17158 4.17158C5.51548 4.82769 5.24351 5.64711 5.11876 6.57494C4.99995 7.4587 4.99998 8.57531 5.00001 9.92943L5.00001 15.6729C4.99992 16.368 4.99984 16.9987 5.07247 17.4877C5.14918 18.0041 5.34543 18.6475 5.98576 19.0242C6.62608 19.401 7.28375 19.2601 7.77248 19.0764C8.23523 18.9024 8.96426 18.4973 9.5718 18.1596C10.3004 17.7548 10.7864 17.4861 11.1857 17.3118C11.5654 17.1461 11.7967 17.0985 12 17.0985C12.2033 17.0985 12.4346 17.1461 12.8143 17.3118C13.2136 17.4861 13.6996 17.7548 14.4282 18.1596C15.0358 18.4973 15.7648 18.9024 16.2275 19.0764C16.7163 19.2601 17.3739 19.401 18.0143 19.0242C18.6546 18.6475 18.8508 18.0041 18.9276 17.4877C19.0002 16.9987 19.0001 16.3679 19 15.6729L19 9.92943C19 8.57531 19.0001 7.4587 18.8813 6.57494C18.7565 5.64711 18.4845 4.82769 17.8284 4.17158C17.1723 3.51547 16.3529 3.2435 15.4251 3.11876C14.5413 2.99994 13.3541 2.99997 12 3ZM10.7071 8.2929C10.3166 7.90237 9.68342 7.90237 9.29289 8.2929C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711L10.5858 11L9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L12 12.4142L13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929L13.4142 11L14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.2929L12 9.58579L10.7071 8.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bookmark-x-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bookmark","remove","delete","cancel","clear","item","remove-item","delete-item","cancel-item","flag","unflag","discount","remove-discount","clear-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bookmark","remove","delete","cancel","close","error","flag","marked-item","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bookmark-x": {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","delete","remove","cancel","favorite","discount","coupon","flag","special-offer","sale","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0003L5 20L8.5 17.9683L12 20L15.5 17.9677L19 19.9994V10.0002C19 7.17171 19 5.75744 18.1213 4.87876C17.2426 4.00007 15.8283 4.00013 12.9998 4.00024L10.9998 4.00032C8.17144 4.00043 6.75727 4.00049 5.87864 4.87916C5 5.75783 5 7.17199 5 10.0003Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L14 9M12 11L10 13M12 11L10 9M12 11L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bookmark: {
        defaultColors: ["#3D4C66"],
        keywords: ["bookmark","delete","remove","cancel","favorite","discount","coupon","flag","special-offer","sale","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V15.601C6 17.1152 6 17.8723 6.49287 18.1624C6.98574 18.4524 7.64759 18.0847 8.97129 17.3493L9.08614 17.2855C10.5105 16.4942 11.2226 16.0985 12 16.0985C12.7774 16.0985 13.4895 16.4942 14.9139 17.2855L15.0287 17.3493C16.3524 18.0847 17.0143 18.4524 17.5071 18.1624C18 17.8723 18 17.1152 18 15.601V10C18 7.17157 18 5.75736 17.1213 4.87868C16.2426 4 14.8284 4 12 4C9.17157 4 7.75736 4 6.87868 4.87868C6 5.75736 6 7.17157 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bootstrap-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bootstrap","B","brand","settings","configuration","options","preferences","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12V12C4.10457 12 5 11.1046 5 10V8.5C5 7.09554 5 6.39331 5.33706 5.88886C5.48298 5.67048 5.67048 5.48298 5.88886 5.33706C6.39331 5 7.09554 5 8.5 5H12H15.5C16.9045 5 17.6067 5 18.1111 5.33706C18.3295 5.48298 18.517 5.67048 18.6629 5.88886C19 6.39331 19 7.09554 19 8.5V10C19 11.1046 19.8954 12 21 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M21 12V12C19.8954 12 19 12.8954 19 14L19 15.5C19 16.9045 19 17.6067 18.6629 18.1111C18.517 18.3295 18.3295 18.517 18.1111 18.6629C17.6067 19 16.9045 19 15.5 19L12 19L8.5 19C7.09554 19 6.39331 19 5.88886 18.6629C5.67048 18.517 5.48298 18.3295 5.33706 18.1111C5 17.6067 5 16.9045 5 15.5L5 14C5 12.8954 4.10457 12 3 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H13C14.1046 12 15 12.8954 15 14V14C15 15.1046 14.1046 16 13 16H10V12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8H12C13.1046 8 14 8.89543 14 10V10C14 11.1046 13.1046 12 12 12H10V8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    bootstrap: {
        defaultColors: ["#3D4C66"],
        keywords: ["bootstrap","B","brand","settings","configuration","options","preferences","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12V12C4.10457 12 5 11.1046 5 10V8.5C5 7.09554 5 6.39331 5.33706 5.88886C5.48298 5.67048 5.67048 5.48298 5.88886 5.33706C6.39331 5 7.09554 5 8.5 5H12H15.5C16.9045 5 17.6067 5 18.1111 5.33706C18.3295 5.48298 18.517 5.67048 18.6629 5.88886C19 6.39331 19 7.09554 19 8.5V10C19 11.1046 19.8954 12 21 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M21 12V12C19.8954 12 19 12.8954 19 14L19 15.5C19 16.9045 19 17.6067 18.6629 18.1111C18.517 18.3295 18.3295 18.517 18.1111 18.6629C17.6067 19 16.9045 19 15.5 19L12 19L8.5 19C7.09554 19 6.39331 19 5.88886 18.6629C5.67048 18.517 5.48298 18.3295 5.33706 18.1111C5 17.6067 5 16.9045 5 15.5L5 14C5 12.8954 4.10457 12 3 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H13C14.1046 12 15 12.8954 15 14V14C15 15.1046 14.1046 16 13 16H10V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8H12C13.1046 8 14 8.89543 14 10V10C14 11.1046 13.1046 12 12 12H10V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bootstrap-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["b","bootstrap","button","brand","label","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8.5V10C5 11.1046 4.10457 12 3 12C4.10457 12 5 12.8954 5 14L5 15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09553 19 8.49999 19H8.5H15.5C16.9045 19 17.6067 19 18.1111 18.6629C18.3295 18.517 18.517 18.3295 18.6629 18.1111C19 17.6067 19 16.9045 19 15.5V14C19 12.8954 19.8954 12 21 12C19.8954 12 19 11.1046 19 10V8.5C19 7.09554 19 6.39331 18.6629 5.88886C18.517 5.67048 18.3295 5.48298 18.1111 5.33706C17.6067 5 16.9045 5 15.5 5H8.5C7.09554 5 6.39331 5 5.88886 5.33706C5.67048 5.48298 5.48298 5.67048 5.33706 5.88886C5 6.39331 5 7.09554 5 8.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H13C14.1046 12 15 12.8954 15 14V14C15 15.1046 14.1046 16 13 16H10V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8H12C13.1046 8 14 8.89543 14 10V10C14 11.1046 13.1046 12 12 12H10V8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bootstrap-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["B","text","font","button","category","brand","label","initial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 10C13 10.5523 12.5523 11 12 11H11V9H12C12.5523 9 13 9.44772 13 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 15V13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.45144 4H15.5486C16.2093 3.99998 16.7791 3.99995 17.2443 4.04727C17.7375 4.09745 18.2228 4.20898 18.6667 4.5056C18.9943 4.72447 19.2755 5.00572 19.4944 5.33329C19.791 5.77721 19.9026 6.26248 19.9527 6.75572C20.0001 7.22089 20 7.79069 20 8.45143V10C20 10.5523 20.4477 11 21 11V13C20.4477 13 20 13.4477 20 14V15.5486C20 16.2093 20.0001 16.7791 19.9527 17.2443C19.9026 17.7375 19.791 18.2228 19.4944 18.6667C19.2755 18.9943 18.9943 19.2755 18.6667 19.4944C18.2228 19.791 17.7375 19.9026 17.2443 19.9527C16.7791 20.0001 16.2093 20 15.5485 20H8.45134C7.79064 20 7.22086 20.0001 6.75572 19.9527C6.26248 19.9026 5.77721 19.791 5.33329 19.4944C5.00572 19.2755 4.72447 18.9943 4.50559 18.6667C4.20897 18.2228 4.09744 17.7375 4.04727 17.2443C3.99995 16.7791 3.99997 16.2093 4 15.5486L4 14C4 13.4477 3.55228 13 3 13V11C3.55228 11 4 10.5523 4 10L4 8.45145C3.99997 7.7907 3.99995 7.22089 4.04727 6.75572C4.09744 6.26248 4.20897 5.77721 4.50559 5.33329C4.72447 5.00572 5.00572 4.72447 5.33329 4.5056C5.77721 4.20898 6.26248 4.09745 6.75572 4.04727C7.22087 3.99995 7.79073 3.99998 8.45144 4ZM9 7H12C13.6569 7 15 8.34315 15 10C15 10.5347 14.8601 11.0366 14.615 11.4714C15.4479 12.0044 16 12.9377 16 14C16 15.6569 14.6569 17 13 17H9V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "box add-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","new-order","inventory","add-item","new-item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.3891 19.75 15.7052 19.7458 16H19V15C19 14.1716 18.3284 13.5 17.5 13.5C16.6716 13.5 16 14.1716 16 15V16H15C14.1716 16 13.5 16.6716 13.5 17.5C13.5 18.3284 14.1716 19 15 19H16V19.7458C15.7052 19.75 15.3891 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5 14.25C17.9142 14.25 18.25 14.5858 18.25 15V16.75H20C20.4142 16.75 20.75 17.0858 20.75 17.5C20.75 17.9142 20.4142 18.25 20 18.25H18.25V20C18.25 20.4142 17.9142 20.75 17.5 20.75C17.0858 20.75 16.75 20.4142 16.75 20V18.25H15C14.5858 18.25 14.25 17.9142 14.25 17.5C14.25 17.0858 14.5858 16.75 15 16.75H16.75V15C16.75 14.5858 17.0858 14.25 17.5 14.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box add-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","create","new","increase","addition","expand","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16.5 14V19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box add-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","add","plus","order","add-order","new-order","create-order","inventory","add-inventory","stock","restock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.5 14V19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "box check-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["check","checkmark","confirm","approve","success","complete","order-complete","payment-received","verified","ok","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box check-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","check","checkmark","order-received","delivery-confirmed","shipment","completed","verified","inventory","stock-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box check-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","check","checked","order-fulfilled","inventory","confirmed","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.5C19.3327 14.4999 18.9139 14.6481 18.5793 14.9493L16.4167 16.8956L15.9207 16.4493C15.2023 15.8027 14.0958 15.8609 13.4493 16.5793C12.8027 17.2977 12.8609 18.4042 13.5793 19.0508L14.3562 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.3075 15.7483C20.5846 16.0562 20.5596 16.5304 20.2517 16.8075L16.9184 19.8075C16.6332 20.0642 16.2002 20.0642 15.9149 19.8075L14.2483 18.3075C13.9404 18.0304 13.9154 17.5562 14.1925 17.2483C14.4696 16.9404 14.9438 16.9154 15.2517 17.1925L16.4167 18.241L19.2483 15.6925C19.5562 15.4154 20.0304 15.4404 20.3075 15.7483Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box check": {
        defaultColors: ["#000000"],
        keywords: ["box","package","check","complete","order-complete","order-check","inventory-check","confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box add": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","inventory","stock","new-stock","increase-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16.5 14V19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box click-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","click","select","choose","direction","next","continue","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.9217 17.9217L18.3087 17.68C19.4403 16.9737 20.006 16.6205 19.9251 16.2139C19.8442 15.8074 19.1863 15.6977 17.8706 15.4784L16.6571 15.2762C15.9017 15.1503 15.524 15.0873 15.3057 15.3057C15.0873 15.524 15.1503 15.9017 15.2762 16.6571L15.4784 17.8706C15.6977 19.1863 15.8074 19.8442 16.2139 19.9251C16.6205 20.006 16.9737 19.4403 17.68 18.3087L17.9217 17.9217ZM17.9217 17.9217L19.7108 19.7108L20.6054 20.6054"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box click-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","shipping","delivery","order","container","parcel","goods","products","inventory","stock","received","shipment","fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3987 18.3921L16.2302 17.381C16.1252 16.7514 16.0728 16.4367 16.2547 16.2547C16.4367 16.0728 16.7514 16.1252 17.381 16.2302L18.3921 16.3987C19.4886 16.5814 20.0368 16.6728 20.1043 17.0116C20.1717 17.3504 19.7002 17.6447 18.7573 18.2334L18.4347 18.4347L18.2334 18.7573C17.6447 19.7002 17.3504 20.1717 17.0116 20.1043C16.6728 20.0368 16.5814 19.4886 16.3987 18.3921Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path
                    d="M18.4347 18.4347L18.7573 18.2334C19.7002 17.6447 20.1717 17.3504 20.1043 17.0116C20.0368 16.6728 19.4886 16.5814 18.3921 16.3987L17.381 16.2302C16.7514 16.1252 16.4367 16.0728 16.2547 16.2547C16.0728 16.4367 16.1252 16.7514 16.2302 17.381L16.3987 18.3921C16.5814 19.4886 16.6728 20.0368 17.0116 20.1043C17.3504 20.1717 17.6447 19.7002 18.2334 18.7573L18.4347 18.4347ZM18.4347 18.4347L19.9257 19.9257L20.6712 20.6712"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box click-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","click","select","choose","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.9973C19.4358 14.9249 19.0869 14.8669 18.7562 14.8118L17.5756 14.615C17.321 14.5724 16.983 14.5159 16.6816 14.5101C16.3194 14.5031 15.6546 14.5568 15.1058 15.1056C14.557 15.6544 14.5033 16.3191 14.5103 16.6813C14.5161 16.9828 14.5727 17.3207 14.6153 17.5754L14.8121 18.756C14.8671 19.0868 14.9252 19.4358 14.9976 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.446 15.6072C17.4586 15.6094 17.4712 15.6115 17.4838 15.6136L18.495 15.7821C18.5104 15.7847 18.5257 15.7872 18.541 15.7898C19.0498 15.8745 19.4961 15.9489 19.8202 16.0498C20.1183 16.1427 20.609 16.3448 20.7174 16.8895C20.8258 17.4343 20.4499 17.8088 20.21 18.0087C20.0118 18.174 19.7424 18.3521 19.4322 18.5481L21.1133 20.2291C21.3573 20.4732 21.3573 20.8689 21.1133 21.113C20.8692 21.3571 20.4735 21.3571 20.2294 21.113L18.5483 19.432C18.3524 19.7421 18.1743 20.0116 18.009 20.2098C17.809 20.4496 17.4345 20.8256 16.8898 20.7171C16.345 20.6087 16.143 20.118 16.0501 19.8199C15.9491 19.4959 15.8748 19.0496 15.79 18.5407C15.7875 18.5255 15.7849 18.5102 15.7823 18.4948L15.6138 17.4836C15.6117 17.471 15.6096 17.4583 15.6075 17.4457C15.5605 17.1641 15.5145 16.8887 15.5101 16.662C15.5053 16.4107 15.5464 16.0792 15.8129 15.8127C16.0795 15.5461 16.4109 15.505 16.6622 15.5099C16.8889 15.5143 17.1643 15.5602 17.446 15.6072Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box disable-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","disable","not-available","unavailable","stock-out","out-of-stock","order-disable","package-disable","forbidden"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.8335 18.1663L18.1668 14.833"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box disable-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","disable","unavailable","remove","hide","cancel","box-disable","package-disable","item-disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.1256C19.0656 13.5775 18.1966 13.25 17.25 13.25C15.0383 13.25 13.25 15.0383 13.25 17.25C13.25 18.1966 13.5775 19.0656 14.1256 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.25 15.75C16.419 15.75 15.75 16.419 15.75 17.25C15.75 17.3846 15.7676 17.515 15.8005 17.639L17.639 15.8005C17.515 15.7676 17.3846 15.75 17.25 15.75ZM18.6996 16.8613L16.8613 18.6996C16.9852 18.7325 17.1155 18.75 17.25 18.75C18.081 18.75 18.75 18.081 18.75 17.25C18.75 17.1155 18.7325 16.9852 18.6996 16.8613ZM14.25 17.25C14.25 15.5906 15.5906 14.25 17.25 14.25C18.9094 14.25 20.25 15.5906 20.25 17.25C20.25 18.9094 18.9094 20.25 17.25 20.25C15.5906 20.25 14.25 18.9094 14.25 17.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box disable-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["disable","ban","prohibited","unavailable","not-allowed","cancel","remove","delete","block"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.8335 18.1668L18.1668 14.8335"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box disable": {
        defaultColors: ["#000000"],
        keywords: ["box","package","disable","unavailable","inactive","blocked","order-disabled","inventory-disabled","product-disabled","deactivate","deactivated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.8335 18.1668L18.1668 14.8335"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box dollar-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["dollar","money","currency","payment","price","cost","amount","sales","revenue","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box dollar-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","dollar","money","price","cost","value","sales","inventory","product-cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box dollar-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","dollar","money","value","price","cash","inventory","stock","shipping","order","item","product","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.2686 19.75 15.4765 19.7489 15.6757C19.7111 14.7642 18.976 14.0328 18.063 14.0006C17.7469 13.5469 17.2212 13.25 16.6263 13.25C15.8153 13.25 15.1332 13.8016 14.9347 14.55C14.2187 15.072 13.752 15.9177 13.752 16.8739C13.752 17.6134 14.0313 18.2877 14.4901 18.7971C14.1682 19.0256 13.9269 19.3602 13.8172 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3763 14.9995C17.376 14.5855 17.0403 14.25 16.6263 14.25C16.2121 14.25 15.8763 14.5858 15.8763 15V15.1556C15.2144 15.4449 14.752 16.1054 14.752 16.8739C14.752 17.909 15.5911 18.7482 16.6263 18.7482H17.2509C17.6029 18.7482 17.7501 18.9881 17.7501 19.1225C17.7501 19.1959 17.72 19.2724 17.6401 19.3425C17.557 19.4152 17.4226 19.4751 17.2509 19.4751H15.502C15.0877 19.4751 14.752 19.8109 14.752 20.2251C14.752 20.6393 15.0877 20.9751 15.502 20.9751H15.8763C15.8765 21.3891 16.2122 21.7246 16.6263 21.7246C17.0405 21.7246 17.3763 21.3888 17.3763 20.9746V20.9713C18.3393 20.914 19.2501 20.2012 19.2501 19.1225C19.2501 18.015 18.2788 17.2482 17.2509 17.2482H16.6263C16.4195 17.2482 16.252 17.0806 16.252 16.8739C16.252 16.6671 16.4195 16.4995 16.6263 16.4995H18.0004C18.4146 16.4995 18.7504 16.1638 18.7504 15.7495C18.7504 15.3353 18.4146 14.9995 18.0004 14.9995H17.3763Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box dollar": {
        defaultColors: ["#000000"],
        keywords: ["box","dollar","money","cash","price","cost","value","package","shipping","payment","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box edit-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","edit","order","modify","edit-order","package-edit","shipment","delivery","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0084 14.7068C17.3057 14.4141 17.7062 14.25 18.1234 14.25C19.0012 14.25 19.75 14.9988 19.75 15.8765C19.75 16.2938 19.5859 16.6943 19.2931 16.9916L19.2891 16.9957L16.8366 19.4482C16.6415 19.6402 16.3806 19.7431 16.1131 19.7421L15.2957 19.75L15.2766 19.7499C14.7148 19.741 14.259 19.2851 14.2501 18.7234L14.25 18.7043L14.2579 17.8868C14.2569 17.6194 14.3598 17.3585 14.5518 17.1634L14.556 17.1591L17.0084 14.7068Z"
                    fill={colors?.[2] || "#000000"}
                />
            </svg>
        )
    },
    "box edit-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","edit","modify","update","inventory","stock","product-details","item-details","edit-order","modify-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7212 4.30826C16.2336 4.24996 15.6334 4.24998 14.9211 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5982 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.8275C19.2999 13.4674 18.7329 13.2501 18.1235 13.2501C17.4437 13.2501 16.7912 13.5174 16.3068 13.9944L13.8489 16.4521L13.8391 16.4621C13.4604 16.8469 13.2579 17.3595 13.2579 17.8829L13.25 18.6948L13.25 18.7267L13.2502 18.7394C13.2561 19.1082 13.3599 19.4534 13.5367 19.7501L8.94798 19.75C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.748 15.7997C19.7059 14.9556 18.9754 14.2501 18.1234 14.2501C17.7062 14.2501 17.3057 14.4142 17.0084 14.7069L14.556 17.1593L14.5518 17.1635C14.3598 17.3586 14.2569 17.6195 14.2579 17.8869L14.25 18.7044L14.2501 18.7235C14.259 19.2843 14.7126 19.7396 15.273 19.75L15.2766 19.75L15.2957 19.7501L16.1131 19.7422C16.3806 19.7432 16.6415 19.6403 16.8366 19.4483L19.2891 16.9958L19.2931 16.9917C19.5594 16.7213 19.7192 16.3655 19.746 15.9894C19.7486 15.952 19.75 15.9144 19.75 15.8766C19.75 15.8509 19.7493 15.8253 19.748 15.7997Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box edit": {
        defaultColors: ["#000000"],
        keywords: ["box","package","edit","modify","inventory","update","stock","manage-stock","edit-order","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box edit-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["edit","pencil","modify","change","update","adjust","correct","revise","alter","amend","rectify","tweak","fine-tune","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box fast-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["fast","lightning","bolt","quick","express","speed","acceleration","charge","urgent","high-priority","instant","rapid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6667 15L17.0002 17H18.3335L17.6667 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box fast-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","shipping","fast","speed","express","lightning","fragile","urgent","rush","dispatch","order-dispatch","shipping-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6667 15L17.0002 17H18.3335L17.6667 19"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box fast-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","fast","delivery","shipping","speed","express"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.3767 19.75 15.6818 19.7463 15.9672C19.6285 15.8061 19.4857 15.6685 19.3253 15.5582L19.3269 15.5533C19.6325 14.6364 19.1369 13.6453 18.22 13.3398C17.3031 13.0342 16.312 13.5298 16.0065 14.4467L15.3399 16.4467C15.1621 16.9803 15.2516 17.5669 15.5805 18.0233C15.6995 18.1884 15.8447 18.3292 16.0081 18.4417L16.0065 18.4465C15.8585 18.8905 15.8983 19.3519 16.083 19.7445C15.7647 19.75 15.4209 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.9038 14.2884C17.5109 14.1575 17.0861 14.3699 16.9552 14.7628L16.2886 16.7628C16.2124 16.9915 16.2508 17.2429 16.3917 17.4385C16.5327 17.6341 16.7591 17.75 17.0002 17.75H17.2929L16.9552 18.7627C16.8242 19.1557 17.0365 19.5805 17.4295 19.7115C17.8224 19.8425 18.2472 19.6301 18.3782 19.2372L19.045 17.2372C19.1212 17.0085 19.0829 16.757 18.9419 16.5614C18.801 16.3659 18.5746 16.25 18.3335 16.25H18.0407L18.3782 15.2371C18.5092 14.8441 18.2968 14.4194 17.9038 14.2884Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box click": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","click","select","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.9217 17.9217L18.3087 17.68C19.4403 16.9737 20.006 16.6205 19.9251 16.2139C19.8442 15.8074 19.1863 15.6977 17.8706 15.4784L16.6571 15.2762C15.9017 15.1503 15.524 15.0873 15.3057 15.3057C15.0873 15.524 15.1503 15.9017 15.2762 16.6571L15.4784 17.8706C15.6977 19.1863 15.8074 19.8442 16.2139 19.9251C16.6205 20.006 16.9737 19.4403 17.68 18.3087L17.9217 17.9217ZM17.9217 17.9217L19.7108 19.7108L20.6054 20.6054"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box fast": {
        defaultColors: ["#000000"],
        keywords: ["box","fast","package","delivery","shipping","express","speed","inventory","stock","order-processing","fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6667 15L17.0002 17H18.3335L17.6667 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box finger-3": {
        defaultColors: ["#000000"],
        keywords: ["void","empty","null","nothing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.3149 19.75 15.565 19.748 15.8022C19.6686 15.7779 19.5866 15.7581 19.502 15.743L19.0499 15.6626V15.15C19.0499 14.1844 18.3129 13.25 17.2249 13.25C16.1368 13.25 15.3999 14.1844 15.3999 15.15V16.2548C14.9488 16.2884 14.5381 16.4983 14.2406 16.8228C13.6703 17.445 13.5946 18.3827 14.0272 19.0908L14.4301 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4 17.8499L16.078 17.4986C15.9321 17.3394 15.7342 17.25 15.5279 17.25C15.3216 17.25 15.1237 17.3394 14.9779 17.4986C14.7157 17.7846 14.675 18.2328 14.8806 18.5693L15.9476 20.3156C16.1517 20.6495 16.4952 20.85 16.863 20.85H18.9508C19.5056 20.85 19.9735 20.3993 20.0423 19.7988L20.2414 18.0607C20.3147 17.4204 19.9108 16.8314 19.327 16.7276L18.05 16.5004V15.15C18.05 14.6529 17.6806 14.25 17.225 14.25C16.7694 14.25 16.4 14.6529 16.4 15.15V17.8499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box finger-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["finger","point","touch","select","choose","option","selection","tap"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 17.5999L15.828 17.2486C15.6821 17.0894 15.4842 17 15.2779 17C15.0716 17 14.8737 17.0894 14.7279 17.2486C14.4657 17.5346 14.425 17.9828 14.6306 18.3193L15.6976 20.0656C15.9017 20.3995 16.2452 20.6 16.613 20.6H18.7008C19.2556 20.6 19.7235 20.1493 19.7923 19.5488L19.9914 17.8107C20.0647 17.1704 19.6608 16.5814 19.077 16.4776L17.8 16.2504V14.9C17.8 14.4029 17.4306 14 16.975 14C16.5194 14 16.15 14.4029 16.15 14.9V17.5999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box finger-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","finger","touch","select","order","process","delivery","select-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 17.5999L15.828 17.2486C15.6821 17.0894 15.4842 17 15.2779 17C15.0716 17 14.8737 17.0894 14.7279 17.2486C14.4657 17.5346 14.425 17.9828 14.6306 18.3193L15.6976 20.0656C15.9017 20.3995 16.2452 20.6 16.613 20.6H18.7008C19.2556 20.6 19.7235 20.1493 19.7923 19.5488L19.9914 17.8107C20.0647 17.1704 19.6608 16.5814 19.077 16.4776L17.8 16.2504V14.9C17.8 14.4029 17.4306 14 16.975 14C16.5194 14 16.15 14.4029 16.15 14.9V17.5999Z"
                    fill={colors?.[2] || "#000000"}
                />
            </svg>
        )
    },
    "box finger": {
        defaultColors: ["#000000"],
        keywords: ["box","finger","select","inventory","product","touch","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 17.5999L15.828 17.2486C15.6821 17.0894 15.4842 17 15.2779 17C15.0716 17 14.8737 17.0894 14.7279 17.2486C14.4657 17.5346 14.425 17.9828 14.6306 18.3193L15.6976 20.0656C15.9017 20.3995 16.2452 20.6 16.613 20.6H18.7008C19.2556 20.6 19.7235 20.1493 19.7923 19.5488L19.9914 17.8107C20.0647 17.1704 19.6608 16.5814 19.077 16.4776L17.8 16.2504V14.9C17.8 14.4029 17.4306 14 16.975 14C16.5194 14 16.15 14.4029 16.15 14.9V17.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box heart-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["heart","favorite","loyalty","rewards","preferred","wishlist","save","customer","customer-loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box heart": {
        defaultColors: ["#000000"],
        keywords: ["box","heart","favorite","save","wishlist","product-favorite","item-favorite","love","saved-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box heart-3": {
        defaultColors: ["#000000"],
        keywords: ["box","heart","favorite","loyalty","gift","special","promotion","preferred","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0056 15.5742C18.5857 15.2693 18.1369 15.1229 17.6543 15.24C17.4126 15.2986 17.1954 15.4177 16.9999 15.5589C16.8045 15.4177 16.5873 15.2986 16.3455 15.24C15.863 15.1229 15.4141 15.2693 14.9943 15.5742C14.9768 15.5869 14.9599 15.6006 14.9439 15.6151C14.2506 16.2435 14.2132 17.2817 14.8707 17.9523C14.8824 17.9641 14.8945 17.9755 14.9071 17.9864L16.6079 19.4542C16.8331 19.6486 17.1667 19.6486 17.392 19.4542L19.0928 17.9864C19.1054 17.9755 19.1175 17.9641 19.1291 17.9522C19.7867 17.2817 19.7492 16.2435 19.056 15.6151C19.0399 15.6006 19.0231 15.5869 19.0056 15.5742Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.8948C19.7426 14.8879 19.7351 14.881 19.7276 14.8742C19.6848 14.8354 19.6399 14.799 19.5932 14.765C19.0199 14.3487 18.2734 14.0608 17.4186 14.2682C17.2692 14.3044 17.1297 14.3532 17 14.4097C16.8702 14.3532 16.7307 14.3044 16.5813 14.2682C15.7265 14.0608 14.9801 14.3487 14.4068 14.765C14.36 14.799 14.3151 14.8355 14.2723 14.8743C13.1633 15.8796 13.0972 17.572 14.1567 18.6524C14.1878 18.6841 14.2202 18.7145 14.2538 18.7435L15.4198 19.7498C15.3001 19.75 15.1775 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.0056 15.5742C18.5857 15.2693 18.1369 15.1229 17.6543 15.24C17.4126 15.2986 17.1954 15.4177 16.9999 15.5589C16.8045 15.4177 16.5873 15.2986 16.3455 15.24C15.863 15.1229 15.4141 15.2693 14.9943 15.5742C14.9768 15.5869 14.9599 15.6006 14.9439 15.6151C14.2506 16.2435 14.2132 17.2817 14.8707 17.9523C14.8824 17.9641 14.8945 17.9755 14.9071 17.9864L16.6079 19.4542C16.8331 19.6486 17.1667 19.6486 17.392 19.4542L19.0928 17.9864C19.1054 17.9755 19.1175 17.9641 19.1291 17.9522C19.7867 17.2817 19.7492 16.2435 19.056 15.6151C19.0399 15.6006 19.0231 15.5869 19.0056 15.5742Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box heart-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","heart","favorites","preferred","special-order","gift","donation","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box mobile-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","parcel","delivery","shipping","order","inventory","products","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.6665 20.25V16.75C15.6665 15.925 15.6665 15.5126 15.9228 15.2563C16.1791 15 16.5915 15 17.4165 15H18.5832C19.4081 15 19.8206 15 20.0769 15.2563C20.3332 15.5126 20.3332 15.925 20.3332 16.75V20.25C20.3332 21.075 20.3332 21.4874 20.0769 21.7437C19.8206 22 19.4081 22 18.5832 22H17.4165C16.5915 22 16.1791 22 15.9228 21.7437C15.6665 21.4874 15.6665 21.075 15.6665 20.25Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.7441 19.958H18.2474" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "box mobile-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["mobile","phone","device","payment","transaction","mobile-payment","mobile-transaction","sales","terminal","pos","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 20V16C15 15.0572 15 14.5858 15.2929 14.2929C15.5858 14 16.0572 14 17 14H18.3333C19.2761 14 19.7475 14 20.0404 14.2929C20.3333 14.5858 20.3333 15.0572 20.3333 16V20C20.3333 20.9428 20.3333 21.4142 20.0404 21.7071C19.7475 22 19.2761 22 18.3333 22H17C16.0572 22 15.5858 22 15.2929 21.7071C15 21.4142 15 20.9428 15 20Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 19.6665H18.1115" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9.5V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box mobile-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","mobile","inventory","stock","shipment","delivery","storage","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.27886 4.30826C7.76639 4.24996 8.36665 4.24998 9.07894 4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53174 5.01875 6.0729C5.20434 5.58575 5.45019 5.15958 5.86918 4.83244C6.28817 4.5053 6.76124 4.37015 7.27886 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0644 14.47C18.8223 14.4374 18.5247 14.4375 18.2001 14.4375H17.1329C16.8084 14.4375 16.5107 14.4374 16.2686 14.47C16.002 14.5058 15.7202 14.5902 15.4884 14.8219C15.2567 15.0537 15.1723 15.3355 15.1365 15.6021C15.1039 15.8442 15.104 16.1418 15.104 16.4664V19.5336C15.104 19.5474 15.104 19.5612 15.104 19.5749C15.104 19.6343 15.1041 19.6927 15.1044 19.75C15.1056 19.9904 15.1113 20.2107 15.1365 20.3979C15.1723 20.6645 15.2567 20.9463 15.4884 21.1781C15.7202 21.4098 16.002 21.4942 16.2686 21.53C16.5107 21.5626 16.8084 21.5625 17.133 21.5625H18.2001C18.5247 21.5625 18.8223 21.5626 19.0644 21.53C19.331 21.4942 19.6128 21.4098 19.8446 21.1781C20.0764 20.9463 20.1607 20.6645 20.1965 20.3979C20.2291 20.1558 20.229 19.8582 20.229 19.5336V16.4664C20.229 16.1418 20.2291 15.8442 20.1965 15.6021C20.1607 15.3355 20.0764 15.0537 19.8446 14.8219C19.8139 14.7912 19.7823 14.7631 19.75 14.7374C19.5384 14.5687 19.2957 14.5011 19.0644 14.47ZM17.3339 19.1499C17.0025 19.1499 16.7339 19.4185 16.7339 19.7499C16.7339 20.0813 17.0025 20.3499 17.3339 20.3499H18.0006C18.3319 20.3499 18.6006 20.0813 18.6006 19.7499C18.6006 19.4185 18.3319 19.1499 18.0006 19.1499H17.3339Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052C4.24998 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.1043C14.104 19.6884 14.104 19.6283 14.104 19.5705V16.4296C14.1039 16.1343 14.1038 15.7787 14.1454 15.4689C14.1961 15.0922 14.3324 14.5638 14.7813 14.1148C15.2303 13.6659 15.7587 13.5296 16.1354 13.4789C16.4452 13.4373 16.8008 13.4374 17.0961 13.4375H18.237C18.5323 13.4374 18.8879 13.4373 19.1977 13.4789C19.3598 13.5007 19.5501 13.5384 19.75 13.61L19.75 9.75H15.75C15.75 10.1229 15.75 10.1541 15.7281 10.4158C15.7059 10.6822 15.655 10.9898 15.4804 11.2669C15.1839 11.7371 14.6815 12.0386 14.1271 12.0789C13.8004 12.1027 13.505 12.0028 13.2594 11.8971C13.018 11.7932 12.73 11.6397 12.4003 11.4639L12.3735 11.4495C12.242 11.3794 12.1675 11.34 12.1099 11.3129C12.0741 11.2961 12.0584 11.2907 12.0542 11.2894C12.0179 11.2813 11.9802 11.2813 11.944 11.2895C11.94 11.2907 11.9247 11.296 11.8886 11.3129C11.831 11.34 11.7566 11.3794 11.6252 11.4496L11.5983 11.4639C11.2694 11.6394 10.982 11.7927 10.741 11.8965C10.496 12.0021 10.2012 12.102 9.87504 12.0786C9.31917 12.0389 8.81548 11.7367 8.51873 11.265C8.34463 10.9882 8.29398 10.6811 8.27179 10.4152C8.24998 10.1539 8.24998 10.1229 8.24999 9.7507L4.25 9.75L4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box moving-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["menu","options","settings","list","navigation","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 15.0001L16 14.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20.0001L16 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17.5H17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box mobile": {
        defaultColors: ["#000000"],
        keywords: ["box","package","mobile","inventory","stock","shipment","order","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 20V16C15 15.0572 15 14.5858 15.2929 14.2929C15.5858 14 16.0572 14 17 14H18.3333C19.2761 14 19.7475 14 20.0404 14.2929C20.3333 14.5858 20.3333 15.0572 20.3333 16V20C20.3333 20.9428 20.3333 21.4142 20.0404 21.7071C19.7475 22 19.2761 22 18.3333 22H17C16.0572 22 15.5858 22 15.2929 21.7071C15 21.4142 15 20.9428 15 20Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 19.6665H18.1115" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9.5V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box moving-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","shipping","delivery","inventory","stock","order","shipment","receive","receiving","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 15.0001L16 14.9999" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 20.0001L16 19.9999" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5H17" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "box moving": {
        defaultColors: ["#000000"],
        keywords: ["box","package","move","moving","delivery","ship","shipping","inventory","stock","transfer","relocate","location","destination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 15.0001L16 14.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 20.0001L16 19.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5H17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box moving-3": {
        defaultColors: ["#000000"],
        keywords: ["box","moving","package","delivery","shipping","inventory","stock","transfer","relocation","warehouse","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.2501L17.0001 13.25C16.0336 13.25 15.25 14.0334 15.25 14.9999C15.25 15.7785 15.7584 16.4384 16.4614 16.6656C16.3266 16.9136 16.25 17.1979 16.25 17.5001C16.25 17.8022 16.3266 18.0864 16.4614 18.3345C15.8351 18.5369 15.3632 19.0827 15.2677 19.75C15.1968 19.75 15.1249 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 15C16.25 14.5857 16.5858 14.25 17 14.25L19 14.2501C19.4143 14.2501 19.75 14.5859 19.75 15.0001C19.75 15.4144 19.4142 15.7501 19 15.7501L17 15.75C16.5857 15.75 16.25 15.4142 16.25 15ZM17.25 17.5C17.25 17.0858 17.5858 16.75 18 16.75H20C20.4142 16.75 20.75 17.0858 20.75 17.5C20.75 17.9143 20.4142 18.25 20 18.25H18C17.5858 18.25 17.25 17.9143 17.25 17.5ZM16.25 20C16.25 19.5857 16.5858 19.25 17 19.25L19 19.2501C19.4143 19.2501 19.75 19.5859 19.75 20.0001C19.75 20.4144 19.4142 20.7501 19 20.7501L17 20.75C16.5857 20.75 16.25 20.4142 16.25 20Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box pin-3": {
        defaultColors: ["#000000"],
        keywords: ["pin","location","map","store-locator","map-pin","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.4815C19.7475 13.4796 19.745 13.4777 19.7425 13.4758C19.4855 13.2797 19.0284 13 18.3942 13C17.7599 13 17.3028 13.2797 17.0458 13.4758C16.8479 13.6268 16.658 13.8171 16.5344 13.9408L16.1239 14.3513L16.113 14.355C15.6397 14.5126 15.1397 14.6792 14.744 14.87C14.3168 15.0761 13.6532 15.4728 13.3279 16.2867C13.2291 16.534 13.1676 16.7946 13.1454 17.06C13.0818 17.8203 13.3889 18.4125 13.6608 18.8008L13.5126 18.949C13.2828 19.1788 13.1303 19.4565 13.055 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.5633 14.6645C19.4283 14.5293 19.2793 14.3802 19.136 14.2708C18.9669 14.1419 18.7211 14 18.3942 14C18.0672 14 17.8214 14.1419 17.6524 14.2708C17.509 14.3802 17.36 14.5293 17.225 14.6645L16.6641 15.2253L16.4726 15.2892C15.9644 15.4586 15.5157 15.6081 15.1784 15.7708C14.8272 15.9402 14.4419 16.1939 14.2565 16.6578C14.1945 16.8131 14.1558 16.9767 14.1419 17.1433C14.1003 17.6411 14.3314 18.0404 14.5698 18.349C14.6922 18.5074 14.8447 18.6767 15.018 18.8578L14.2197 19.6561C13.9268 19.949 13.9268 20.4239 14.2197 20.7168C14.5126 21.0097 14.9874 21.0097 15.2803 20.7168L16.0787 19.9185C16.2602 20.0922 16.4298 20.2451 16.5886 20.3678C16.8972 20.6062 17.2964 20.8373 17.7943 20.7956C17.9609 20.7817 18.1245 20.7431 18.2798 20.681C18.7436 20.4956 18.9974 20.1104 19.1668 19.7591C19.3295 19.4218 19.479 18.9731 19.6484 18.4649L19.7122 18.2731L20.2729 17.7124C20.4081 17.5774 20.5572 17.4284 20.6666 17.285C20.7955 17.116 20.9374 16.8701 20.9374 16.5432C20.9374 16.2163 20.7955 15.9704 20.6666 15.8014C20.5572 15.6581 20.4081 15.5091 20.2729 15.3741L19.5633 14.6645Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box pin-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["pin","location","map","mark","marker","address","customer","customer-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.4649 17.8384L20.2326 17.0707C20.5945 16.7088 20.7755 16.5279 20.7755 16.303C20.7755 16.0782 20.5945 15.8972 20.2326 15.5354L19.4649 14.7677C19.103 14.4058 18.9221 14.2249 18.6973 14.2249C18.4724 14.2249 18.2915 14.4058 17.9296 14.7677L17.1619 15.5354"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.162 15.5354L16.7973 15.6569C15.5298 16.0794 14.896 16.2907 14.7091 16.7584C14.6692 16.8583 14.6443 16.9637 14.6353 17.0709C14.5934 17.5729 15.0657 18.0452 16.0104 18.9899V18.9899C16.9552 19.9346 17.4275 20.407 17.9295 20.365C18.0367 20.3561 18.142 20.3312 18.242 20.2913C18.7097 20.1043 18.9209 19.4706 19.3434 18.2031L19.465 17.8384"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0098 18.9897L14.4744 20.5251"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box pin-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","damaged","broken","issue","problem","defect","return","refund","spoiled","missing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.2626 17.2403L19.6998 17.8032C19.6132 17.8898 19.5699 17.9331 19.538 17.9847C19.5061 18.0363 19.4867 18.0944 19.448 18.2106L19.4091 18.3272C19.0036 19.5438 18.8009 20.1521 18.3519 20.3315C18.256 20.3698 18.1549 20.3937 18.052 20.4023C17.5702 20.4426 17.1168 19.9892 16.21 19.0824C15.3033 18.1757 14.8499 17.7223 14.8902 17.2405C14.8988 17.1376 14.9226 17.0365 14.961 16.9406C15.1404 16.4916 15.7487 16.2889 16.9652 15.8833L17.0819 15.8444C17.1981 15.8057 17.2561 15.7864 17.3077 15.7545C17.3593 15.7226 17.4026 15.6793 17.4892 15.5927L18.0521 15.0298L18.0521 15.0298C18.3994 14.6825 18.5731 14.5088 18.7889 14.5088C19.0047 14.5088 19.1784 14.6825 19.5258 15.0298L20.2626 15.7666L20.2626 15.7667C20.6099 16.114 20.7836 16.2877 20.7836 16.5035C20.7836 16.7193 20.61 16.893 20.2626 17.2403Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.21 19.082L14.7363 20.5557" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "box pin": {
        defaultColors: ["#000000"],
        keywords: ["box","package","pin","location","inventory","stock","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.4649 17.8384L20.2326 17.0707C20.5945 16.7088 20.7755 16.5279 20.7755 16.303C20.7755 16.0782 20.5945 15.8972 20.2326 15.5354L19.4649 14.7677C19.103 14.4058 18.9221 14.2249 18.6973 14.2249C18.4724 14.2249 18.2915 14.4058 17.9296 14.7677L17.1619 15.5354"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.162 15.5354L16.7973 15.6569C15.5298 16.0794 14.896 16.2907 14.7091 16.7584C14.6692 16.8583 14.6443 16.9637 14.6353 17.0709C14.5934 17.5729 15.0657 18.0452 16.0104 18.9899V18.9899C16.9552 19.9346 17.4275 20.407 17.9295 20.365C18.0367 20.3561 18.142 20.3312 18.242 20.2913C18.7097 20.1043 18.9209 19.4706 19.3434 18.2031L19.465 17.8384"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.0098 18.9897L14.4744 20.5251" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box pointer-3": {
        defaultColors: ["#000000"],
        keywords: ["pointer","cursor","select","choose","option","interact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.07897 4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53175 5.01875 6.0729C5.20434 5.58575 5.45019 5.15958 5.86918 4.83244C6.28817 4.5053 6.76124 4.37015 7.27886 4.30826C7.76639 4.24996 8.36668 4.24998 9.07897 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25 9.75L4.25001 15.052C4.24998 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.9577C14.5615 19.5623 14.2126 19.337 14.0128 19.1372L14.0052 19.1297L13.9979 19.122C13.4053 18.5037 13.3841 17.5016 14.0128 16.873L14.3028 16.583L14.3109 16.5749L14.2855 16.5495L14.2782 16.5418C13.6856 15.9235 13.6644 14.9214 14.293 14.2928L14.3006 14.2853L14.3082 14.2779C14.9266 13.6853 15.9286 13.6642 16.5572 14.2928L16.5746 14.3102L16.8415 14.0137L16.8681 13.9881C17.4865 13.3955 18.4885 13.3744 19.1172 14.003L19.1247 14.0105L19.132 14.0182C19.3843 14.2814 19.6158 14.7268 19.75 15.2001C19.75 15.1512 19.75 15.1019 19.75 15.0521L19.75 9.75H15.75C15.75 10.1229 15.75 10.1541 15.7281 10.4158C15.7059 10.6822 15.655 10.9898 15.4804 11.2669C15.1839 11.7371 14.6815 12.0386 14.1271 12.0789C13.8004 12.1027 13.505 12.0028 13.2594 11.8971C13.018 11.7932 12.73 11.6397 12.4003 11.4639L12.3735 11.4495C12.242 11.3794 12.1675 11.34 12.1099 11.3129C12.0741 11.2961 12.0584 11.2907 12.0542 11.2894C12.0179 11.2813 11.9802 11.2813 11.944 11.2895C11.94 11.2907 11.9247 11.296 11.8886 11.3129C11.831 11.34 11.7566 11.3794 11.6252 11.4496L11.5983 11.4639C11.2694 11.6394 10.982 11.7927 10.741 11.8965C10.496 12.0021 10.2012 12.102 9.87504 12.0786C9.31917 12.0389 8.81548 11.7367 8.51873 11.265C8.34463 10.9882 8.29398 10.6811 8.27179 10.4152C8.24998 10.1539 8.24998 10.1229 8.24999 9.7507L4.25 9.75Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.5601 14.7101L17.29 15.0101C17.29 15.0101 17.23 15.1001 17.2 15.1401C17.17 15.1901 17.1501 15.2501 17.14 15.3001C17.1 15.4901 17.14 15.7001 17.29 15.8501C17.29 15.8501 17.29 15.8501 17.3 15.8501C17.51 16.0501 17.83 16.0601 18.0601 15.8901C18.08 15.8701 18.1101 15.8601 18.13 15.8401L18.41 15.5601C18.64 15.3301 18.64 14.9501 18.41 14.7101C18.18 14.4801 17.8 14.4801 17.5601 14.7101Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M20.7101 17.5201C20.6301 17.4601 20.5701 17.4101 20.5201 17.3801C20.3301 17.2901 20.0701 17.2001 19.8001 17.1101C19.7901 17.1101 19.7801 17.1101 19.7601 17.1001L18.6401 16.7301L17.9101 16.4901C17.9101 16.4901 17.8901 16.4901 17.8801 16.4801C17.6901 16.4201 17.3914 16.3401 17.2214 16.3101C17.1914 16.3101 17.2401 16.3201 17.2001 16.3101C17.0101 16.2901 16.7601 16.3101 16.5301 16.5101C16.5301 16.5101 16.5101 16.5301 16.5001 16.5401C16.2801 16.7601 16.2601 17.0301 16.2701 17.2201C16.2701 17.2401 16.2701 17.2701 16.2701 17.2901C16.2901 17.4601 16.3501 17.7001 16.4001 17.9001C16.4001 17.8901 16.4001 17.9101 16.4001 17.9001L16.6301 18.7601L16.9101 19.8201C16.9801 20.0701 17.0401 20.3601 17.1201 20.5501C17.1401 20.6001 17.1801 20.6801 17.2301 20.7501C17.3401 20.9201 17.5101 21.1001 17.8201 21.1401C18.2601 21.2001 18.5301 20.8901 18.6501 20.7401C18.6801 20.7001 18.7201 20.6401 18.7501 20.5801C18.8401 20.4401 18.9301 20.2901 19.0301 20.1201C19.0301 20.1101 19.0401 20.1001 19.0501 20.0901L19.4001 19.4701L19.8301 19.2801C19.8301 19.2801 19.8501 19.2701 19.8701 19.2601C20.1001 19.1601 20.3201 19.0601 20.4901 18.9701C20.5101 18.9601 20.5401 18.9501 20.5601 18.9401C20.7201 18.8401 21.0801 18.6001 21.0601 18.1401C21.0501 17.8301 20.8701 17.6401 20.7101 17.5201Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.2701 15.4899C16.2401 15.4199 16.2001 15.3499 16.1401 15.2899L15.8501 14.9999C15.6201 14.7699 15.2401 14.7699 15.0001 14.9999C14.7701 15.2299 14.7701 15.6099 15.0001 15.8499L15.2901 16.1399C15.3501 16.1899 15.4101 16.2399 15.4801 16.2599C15.6501 16.3299 15.8401 16.3099 16.0001 16.2299C16.0501 16.1999 16.1001 16.1799 16.1401 16.1399C16.1801 16.0999 16.2001 16.0499 16.2301 16.0099C16.3201 15.8499 16.3401 15.6599 16.2701 15.4899Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M15.5199 18.4601C15.5199 18.4601 15.5499 18.4301 15.5699 18.4201L15.8599 18.1301C16.0899 17.9001 16.0899 17.5301 15.8599 17.2901C15.6999 17.1301 15.4799 17.0901 15.2799 17.1401C15.2299 17.1501 15.1899 17.1701 15.1399 17.2001C15.0899 17.2301 15.0499 17.2501 15.0099 17.2901L14.7199 17.5801C14.4899 17.8101 14.4899 18.1901 14.7199 18.4301C14.9399 18.6501 15.2899 18.6601 15.5199 18.4601Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box pointer-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cursor","pointer","select","choose","touch","arrow","select-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8931 14.8931L14.536 14.536"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3929 14.5357L17.7501 14.1786"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.1786 17.7506L14.5357 17.3934"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1237 19.8206L16.4846 17.4239C16.3341 16.8596 16.2589 16.5775 16.4142 16.4313C16.5696 16.2852 16.8466 16.3776 17.4007 16.5623L19.7179 17.3347C20.4678 17.5846 20.8427 17.7096 20.853 17.9557C20.8632 18.2018 20.4999 18.3575 19.7734 18.6688L19.2202 18.9059C19.1112 18.9526 19.0567 18.976 19.0132 19.0148C18.9697 19.0536 18.9403 19.1051 18.8814 19.2081L18.4341 19.9909C18.0674 20.6326 17.8841 20.9534 17.6467 20.9225C17.4094 20.8917 17.3142 20.5347 17.1237 19.8206Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box pointer-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","paw","animal","pet","order","animal-products","pet-products","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.3931 14.3931L15.036 14.036"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8929 14.0357L18.2501 13.6786"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6786 17.2506L15.0357 16.8934"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6233 19.3211L16.9841 16.9244C16.8337 16.3601 16.7584 16.0779 16.9137 15.9318C17.0691 15.7857 17.3461 15.8781 17.9002 16.0628L20.2174 16.8352C20.9673 17.0851 21.3422 17.2101 21.3525 17.4562C21.3627 17.7023 20.9994 17.858 20.2729 18.1693L19.7198 18.4064C19.6107 18.4531 19.5562 18.4765 19.5127 18.5153C19.4692 18.554 19.4398 18.6055 19.381 18.7085L18.9336 19.4914C18.5669 20.1331 18.3836 20.4539 18.1462 20.423C17.9089 20.3922 17.8137 20.0351 17.6233 19.3211Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box pointer": {
        defaultColors: ["#000000"],
        keywords: ["cursor","mouse","pointer","select","navigation","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8931 14.8931L14.536 14.536"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3929 14.5357L17.7501 14.1786"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.1786 17.7506L14.5357 17.3934"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1237 19.8206L16.4846 17.4239C16.3341 16.8596 16.2589 16.5775 16.4142 16.4313C16.5696 16.2852 16.8466 16.3776 17.4007 16.5623L19.7179 17.3347C20.4678 17.5846 20.8427 17.7096 20.853 17.9557C20.8632 18.2018 20.4999 18.3575 19.7734 18.6688L19.2202 18.9059C19.1112 18.9526 19.0567 18.976 19.0132 19.0148C18.9697 19.0536 18.9403 19.1051 18.8814 19.2081L18.4341 19.9909C18.0674 20.6326 17.8841 20.9534 17.6467 20.9225C17.4094 20.8917 17.3142 20.5347 17.1237 19.8206Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box process-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["eye","look","view","focus","attention","customer","observe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box process-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","inventory","delivery","shipping","order","item","product","goods","stock","supply","distribution","completed","finished"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box receive-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","left","back","return","previous","undo","go-back","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 15L14 17L16 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17L19 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box process-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","process","order-processing","shipping","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.8938C19.0975 13.4858 18.3263 13.25 17.5 13.25C15.1528 13.25 13.25 15.1528 13.25 17.5C13.25 18.3263 13.4858 19.0975 13.8938 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 17.5C14.25 15.7051 15.7051 14.25 17.5 14.25C19.2949 14.25 20.75 15.7051 20.75 17.5C20.75 19.2949 19.2949 20.75 17.5 20.75C15.7051 20.75 14.25 19.2949 14.25 17.5ZM18.3841 17.6768C18.677 17.3839 18.677 16.909 18.3841 16.6162C18.0912 16.3233 17.6163 16.3233 17.3234 16.6162L16.9697 16.9699C16.6768 17.2628 16.6768 17.7377 16.9697 18.0306C17.2626 18.3235 17.7374 18.3235 18.0303 18.0306L18.3841 17.6768Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box process": {
        defaultColors: ["#000000"],
        keywords: ["box","package","process","shipping","delivery","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box receive-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","receive","inventory","stock","delivery","shipment","goods","products","receiving","stock-in"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.6951 19.75 16.2618 19.7207 16.75L18.4146 16.75C18.6007 16.2223 18.4827 15.6114 18.0607 15.1893C17.4749 14.6036 16.5251 14.6036 15.9393 15.1893L13.9393 17.1893C13.3536 17.7751 13.3536 18.7248 13.9393 19.3106L14.3787 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5303 20.7803C17.2374 21.0732 16.7625 21.0732 16.4696 20.7803L14.4697 18.7803C14.1768 18.4874 14.1768 18.0125 14.4697 17.7197L16.4697 15.7197C16.7626 15.4268 17.2374 15.4268 17.5303 15.7197C17.8232 16.0126 17.8232 16.4874 17.5303 16.7803L16.8107 17.5L20 17.5C20.4142 17.5 20.75 17.8358 20.75 18.25C20.75 18.6642 20.4142 19 20 19L16.8106 19L17.5303 19.7197C17.8232 20.0126 17.8232 20.4874 17.5303 20.7803Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box receive-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","receive","arrow-left","return","inventory-in","incoming-stock","shipment-received","order-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16 15L14 17L16 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "box refresh-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","refresh","reload","update","inventory","stock","cycle","repeat","resupply","restock","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9969 18.2197C18.8726 18.5956 18.663 18.9378 18.3847 19.2194C17.7903 19.8136 16.9505 20.0927 16.1187 19.9725C15.2869 19.8523 14.5605 19.3469 14.1587 18.6088"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8407 16.0552C18.4389 15.3171 17.7125 14.8117 16.8807 14.6915C16.0489 14.5713 15.2091 14.8504 14.6148 15.4446C14.3359 15.7262 14.1255 16.0683 14 16.4443"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8169 16.0562H18.9973V14.8774"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1818 18.606H14.0039V19.7847"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box refresh-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["refresh","reload","update","resync","retry","revert","exchange","loop","circular","arrows","synchronize","reconciliation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19V19H10.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9969 18.2197C18.8726 18.5956 18.663 18.9378 18.3847 19.2194C17.7903 19.8136 16.9505 20.0927 16.1187 19.9725C15.2869 19.8523 14.5605 19.3469 14.1587 18.6088"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8407 16.0552C18.4389 15.3171 17.7125 14.8117 16.8807 14.6915C16.0489 14.5713 15.2091 14.8504 14.6148 15.4446C14.3359 15.7262 14.1255 16.0683 14 16.4443"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8169 16.0562H18.9973V14.8774"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1818 18.606H14.0039V19.7847"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box receive": {
        defaultColors: ["#000000"],
        keywords: ["box","receive","delivery","package","inventory","stock","arrival","incoming","shipment","goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 15L14 17L16 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box refresh-3": {
        defaultColors: ["#000000"],
        keywords: ["box","refresh","update","inventory","stock","reload","sync","package","shipment","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.4599C19.6209 13.4295 19.4862 13.4134 19.3478 13.4134C19.0886 13.4134 18.8427 13.4699 18.6216 13.5709C18.2619 13.4134 17.879 13.3028 17.4815 13.2454C16.1053 13.0465 14.7158 13.5076 13.7315 14.4895L13.7246 14.4964L13.722 14.4991C13.254 14.9715 12.9011 15.5453 12.6906 16.1761C12.4969 16.7563 12.6242 17.3664 12.9761 17.8137C12.7434 18.1108 12.6046 18.4851 12.6046 18.8918V19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4352 15.2001C15.1968 14.4387 16.2728 14.0811 17.3386 14.2351C17.8377 14.3072 18.3071 14.4875 18.7181 14.756C18.8518 14.5498 19.0839 14.4134 19.3479 14.4134C19.7621 14.4134 20.0979 14.7492 20.0979 15.1634V16.3422C20.0979 16.7564 19.7621 17.0922 19.3479 17.0922H18.1675C17.7533 17.0922 17.4175 16.7564 17.4175 16.3422C17.4175 16.155 17.486 15.9839 17.5994 15.8525C17.449 15.7886 17.2894 15.7436 17.1241 15.7197C16.527 15.6334 15.9241 15.8335 15.497 16.2596C15.2998 16.4592 15.151 16.7014 15.0621 16.9676C14.931 17.3605 14.5061 17.5727 14.1132 17.4416C13.7203 17.3104 13.5081 16.8856 13.6393 16.4927C13.8012 16.0075 14.0727 15.5662 14.4326 15.2027L14.4352 15.2001ZM19.5835 17.7935C19.9768 17.9236 20.1901 18.3479 20.0599 18.7411C19.8993 19.2267 19.6286 19.6686 19.269 20.0324L19.2659 20.0356C18.5043 20.797 17.4283 21.1546 16.3625 21.0006C15.8635 20.9285 15.3942 20.7483 14.9833 20.4799C14.8494 20.685 14.6179 20.8205 14.3548 20.8205C13.9405 20.8205 13.6048 20.4847 13.6048 20.0705V18.8918C13.6048 18.4776 13.9405 18.1418 14.3548 18.1418H15.5327C15.9469 18.1418 16.2827 18.4776 16.2827 18.8918C16.2827 19.0794 16.2138 19.2509 16.1 19.3824C16.2509 19.4467 16.411 19.492 16.577 19.516C17.174 19.6023 17.7767 19.4023 18.2038 18.9764C18.4002 18.7772 18.548 18.5355 18.6359 18.2699C18.766 17.8767 19.1903 17.6634 19.5835 17.7935Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box refresh": {
        defaultColors: ["#000000"],
        keywords: ["box","refresh","reload","update","inventory","package","shipment","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19V19H10.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9969 18.2197C18.8726 18.5956 18.663 18.9378 18.3847 19.2194C17.7903 19.8136 16.9505 20.0927 16.1187 19.9725C15.2869 19.8523 14.5605 19.3469 14.1587 18.6088"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8407 16.0552C18.4389 15.3171 17.7125 14.8117 16.8807 14.6915C16.0489 14.5713 15.2091 14.8504 14.6148 15.4446C14.3359 15.7262 14.1255 16.0683 14 16.4443"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8169 16.0562H18.9973V14.8774"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1818 18.606H14.0039V19.7847"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box remove-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["remove","delete","cancel","close","reject","box","remove-box","package","remove-package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 15L18 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box remove-3": {
        defaultColors: ["#000000"],
        keywords: ["box","remove","delete","package","order","remove-order","delete-order","cancel","cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.7005C19.1764 14.369 18.4301 14.4486 17.9393 14.9393L17 15.8787L16.0607 14.9393C15.4749 14.3536 14.5251 14.3536 13.9393 14.9393C13.3536 15.5251 13.3536 16.4749 13.9393 17.0607L14.8787 18L13.9393 18.9393C13.7103 19.1684 13.5708 19.4531 13.5209 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.7005C19.1764 14.369 18.4301 14.4486 17.9393 14.9393L17 15.8787L16.0607 14.9393C15.4749 14.3536 14.5251 14.3536 13.9393 14.9393C13.3536 15.5251 13.3536 16.4749 13.9393 17.0607L14.8787 18L13.9393 18.9393C13.7103 19.1684 13.5708 19.4531 13.5209 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4697 15.4697C14.7626 15.1768 15.2374 15.1768 15.5303 15.4697L17 16.9393L18.4697 15.4697C18.7626 15.1768 19.2374 15.1768 19.5303 15.4697C19.8232 15.7626 19.8232 16.2374 19.5303 16.5303L18.0607 18L19.5303 19.4697C19.8232 19.7626 19.8232 20.2374 19.5303 20.5303C19.2374 20.8232 18.7626 20.8232 18.4697 20.5303L17 19.0607L15.5303 20.5303C15.2374 20.8232 14.7626 20.8232 14.4697 20.5303C14.1768 20.2374 14.1768 19.7626 14.4697 19.4697L15.9393 18L14.4697 16.5303C14.1768 16.2374 14.1768 15.7626 14.4697 15.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4697 15.4697C14.7626 15.1768 15.2374 15.1768 15.5303 15.4697L17 16.9393L18.4697 15.4697C18.7626 15.1768 19.2374 15.1768 19.5303 15.4697C19.8232 15.7626 19.8232 16.2374 19.5303 16.5303L18.0607 18L19.5303 19.4697C19.8232 19.7626 19.8232 20.2374 19.5303 20.5303C19.2374 20.8232 18.7626 20.8232 18.4697 20.5303L17 19.0607L15.5303 20.5303C15.2374 20.8232 14.7626 20.8232 14.4697 20.5303C14.1768 20.2374 14.1768 19.7626 14.4697 19.4697L15.9393 18L14.4697 16.5303C14.1768 16.2374 14.1768 15.7626 14.4697 15.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box remove-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","remove","delete","cancel","inventory","remove-item","box-remove","package-remove","order","order-cancel","product-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 15L18 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "box remove": {
        defaultColors: ["#000000"],
        keywords: ["box","package","remove","delete","order","remove-order","inventory","subtract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 15L18 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box reshare-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","resend","forward","transfer","redelivery","delivery-update","order-update","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box reshare-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["resend","recycle","repeat","sync","reload","refresh","update","reorder","circular","rotation","exchange","return","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19V19H10.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box reshare": {
        defaultColors: ["#000000"],
        keywords: ["box","package","share","reshare","inventory","transfer","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15.5C5 16.9045 5 17.6067 5.33706 18.1111C5.48298 18.3295 5.67048 18.517 5.88886 18.6629C6.39331 19 7.09554 19 8.5 19V19H10.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box reshare-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","reshare","share","export","transfer","inventory","stock","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 12.9738C19.0832 12.5988 18.2229 12.6951 17.6554 13.2626L17.3875 13.607L16.2465 13.6069L16.2006 13.6068C15.9145 13.6061 15.5005 13.6051 15.1072 13.7104C14.0596 13.9911 13.2414 14.8094 12.9607 15.857C12.8553 16.2503 12.8563 16.6643 12.8571 16.9504L12.8572 17.0713C12.8572 17.644 13.1323 18.1525 13.5576 18.4717L13.3727 18.6566C13.0787 18.9507 12.9001 19.3386 12.8661 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.3624 13.9697C18.6553 13.6768 19.1302 13.6768 19.423 13.9697L20.2802 14.8268C20.4208 14.9675 20.4999 15.1582 20.4999 15.3571C20.4999 15.5561 20.4208 15.7468 20.2802 15.8875L19.423 16.7446C19.1302 17.0375 18.6553 17.0375 18.3624 16.7446C18.1886 16.5708 18.1179 16.333 18.1504 16.1071L16.3214 16.107C15.8745 16.107 15.7982 16.1134 15.7541 16.1253C15.5693 16.1748 15.4249 16.3192 15.3753 16.5041C15.3635 16.5481 15.3571 16.6244 15.3571 17.0713C15.3571 17.4855 15.0213 17.8213 14.6071 17.8213C14.1929 17.8213 13.8571 17.4855 13.8571 17.0713C13.8571 17.0457 13.857 17.0202 13.857 16.995C13.8566 16.6741 13.8562 16.3781 13.9264 16.1158C14.1147 15.4133 14.6634 14.8646 15.3659 14.6764C15.6281 14.6061 15.9242 14.6065 16.245 14.6069C16.2703 14.607 16.2958 14.607 16.3214 14.607L18.1504 14.6071C18.118 14.3812 18.1886 14.1434 18.3624 13.9697Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9975 21.2816C15.7046 21.5744 15.2297 21.5744 14.9368 21.2816L14.0797 20.4244C13.939 20.2838 13.86 20.093 13.86 19.8941C13.86 19.6952 13.939 19.5044 14.0797 19.3637L14.9368 18.5066C15.2297 18.2137 15.7046 18.2137 15.9975 18.5066C16.1713 18.6804 16.2419 18.9182 16.2095 19.1441L18.0385 19.1442C18.4853 19.1442 18.5616 19.1378 18.6057 19.126C18.7906 19.0764 18.935 18.932 18.9845 18.7472C18.9963 18.7031 19.0028 18.6268 19.0028 18.1799C19.0028 17.7657 19.3386 17.4299 19.7528 17.4299C20.167 17.4299 20.5028 17.7657 20.5028 18.1799C20.5028 18.2055 20.5028 18.231 20.5029 18.2563C20.5033 18.5771 20.5037 18.8731 20.4334 19.1354C20.2452 19.8379 19.6965 20.3866 18.994 20.5749C18.7317 20.6451 18.4357 20.6447 18.1148 20.6443C18.0895 20.6443 18.0641 20.6442 18.0385 20.6442L16.2095 20.6441C16.2419 20.87 16.1712 21.1078 15.9975 21.2816Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box return-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["return","undo","back","revert","previous","go-back","history","cancel","refund","return-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box return-3": {
        defaultColors: ["#000000"],
        keywords: ["return","refund","arrow","undo","transaction","void","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.07891 4.25C8.36664 4.24998 7.76638 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H9.07891Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25 9.75L4.25001 15.052C4.24998 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75L9 19.75H12.6858C12.7192 19.4035 13.011 19.1328 13.3663 19.1328H17.1179C17.8915 19.1328 18.5185 18.5058 18.5185 17.7322C18.5185 16.9585 17.8915 16.3316 17.1179 16.3316H15.6689L15.804 16.4666C16.0708 16.7334 16.0708 17.1669 15.804 17.4337C15.5372 17.7005 15.1037 17.7005 14.8369 17.4337L14.4292 17.026C14.2342 16.8318 14.0432 16.64 13.9065 16.4608C13.7514 16.2574 13.6039 15.9914 13.6039 15.6471C13.6039 15.3028 13.7514 15.0369 13.9065 14.8334C14.0432 14.6542 14.235 14.4625 14.4292 14.2682L14.8369 13.8605C15.1037 13.5938 15.5372 13.5938 15.804 13.8605C16.0708 14.1273 16.0708 14.5608 15.804 14.8276L15.6689 14.9627H17.1179C18.3531 14.9627 19.3877 15.7774 19.7433 16.8952L19.7465 16.9052C19.7476 16.7629 19.7483 16.6171 19.7487 16.4657C19.75 16.2544 19.75 16.0331 19.75 15.8019L19.75 9.75H15.75C15.75 10.1229 15.75 10.1541 15.7281 10.4158C15.7059 10.6822 15.655 10.9898 15.4804 11.2669C15.1839 11.7371 14.6815 12.0386 14.1271 12.0789C13.8004 12.1027 13.505 12.0028 13.2594 11.8971C13.018 11.7932 12.73 11.6397 12.4003 11.4639L12.3735 11.4495C12.242 11.3794 12.1675 11.34 12.1099 11.3129C12.0741 11.2961 12.0584 11.2907 12.0542 11.2894C12.0179 11.2813 11.9802 11.2813 11.944 11.2895C11.94 11.2907 11.9247 11.296 11.8886 11.3129C11.831 11.34 11.7566 11.3794 11.6252 11.4496L11.5983 11.4639C11.2694 11.6394 10.982 11.7927 10.741 11.8965C10.496 12.0021 10.2012 12.102 9.87504 12.0786C9.31917 12.0389 8.81548 11.7367 8.51873 11.265C8.34463 10.9882 8.29398 10.6811 8.27179 10.4152C8.24998 10.1539 8.24998 10.1229 8.24999 9.7507L4.25 9.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box search-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["search","find","magnify","magnifying-glass","lookup","browse","inventory-search","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box return-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","return","box-return","package-return","shipment","shipping","delivery","order-return","product-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box return": {
        defaultColors: ["#000000"],
        keywords: ["box","package","return","refund","outgoing","shipment","delivery","order-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box search-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","shipping","delivery","inventory","order","search","find","item-lookup","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box search-3": {
        defaultColors: ["#000000"],
        keywords: ["box","search","find","package","inventory","lookup","item-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.252C19.0599 13.6292 18.1456 13.25 17.1429 13.25C14.9929 13.25 13.25 14.9929 13.25 17.1429C13.25 18.1456 13.6292 19.0599 14.2519 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 17.1429C14.25 15.5452 15.5452 14.25 17.1429 14.25C18.7405 14.25 20.0357 15.5452 20.0357 17.1429C20.0357 17.6691 19.8948 18.1631 19.649 18.5884L20.5303 19.4697C20.8232 19.7626 20.8232 20.2374 20.5303 20.5303C20.2374 20.8232 19.7626 20.8232 19.4697 20.5303L18.5884 19.649C18.1631 19.8948 17.6691 20.0357 17.1429 20.0357C15.5452 20.0357 14.25 18.7405 14.25 17.1429ZM17.1429 15.75C16.3736 15.75 15.75 16.3736 15.75 17.1429C15.75 17.9121 16.3736 18.5357 17.1429 18.5357C17.5277 18.5357 17.8749 18.3806 18.1278 18.1278C18.3806 17.8749 18.5357 17.5277 18.5357 17.1429C18.5357 16.3736 17.9121 15.75 17.1429 15.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box search": {
        defaultColors: ["#000000"],
        keywords: ["box","search","inventory","find","item","product","scan","lookup","stock","check-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box secure-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","secure","locked","order","protected","inventory","stock","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="15" y="16.875" width="4.375" height="3.125" rx="0.9375" fill={colors?.[2] || "#000000"} stroke={colors?.[2] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M18.4375 16.875V16.25C18.4375 15.5596 17.8779 15 17.1875 15V15C16.4971 15 15.9375 15.5596 15.9375 16.25V16.875"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box secure-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["lock","secure","security","privacy","safe","locked","protection","authorization","access","password","authenticate","encryption","verified","shield","guard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="15"
                    y="16.875"
                    width="4.375"
                    height="3.125"
                    rx="0.9375"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4375 16.875V16.25C18.4375 15.5596 17.8779 15 17.1875 15V15C16.4971 15 15.9375 15.5596 15.9375 16.25V16.875"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box secure-3": {
        defaultColors: ["#000000"],
        keywords: ["box","secure","lock","security","safe","private","encryption","protected","box-secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.07959 4.25H14.9217C15.634 4.24998 16.2342 4.24996 16.7218 4.30826C17.2394 4.37015 17.7125 4.5053 18.1315 4.83244C18.5504 5.15958 18.7963 5.58575 18.9819 6.0729C19.1567 6.53175 19.3023 7.11408 19.475 7.80514L19.5862 8.25H4.41504L4.52626 7.80513C4.699 7.11408 4.84456 6.53174 5.01937 6.0729C5.20496 5.58575 5.4508 5.15958 5.8698 4.83244C6.28879 4.5053 6.76186 4.37015 7.27948 4.30826C7.76701 4.24996 8.36729 4.24998 9.07959 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.94 13.25C18.23 13.25 19.33 14.06 19.75 15.2V12C19.75 11.92 19.75 11.87 19.75 11.85C19.75 11.73 19.75 11.62 19.75 11.5V9.75H15.75C15.75 10.12 15.75 10.15 15.73 10.42C15.71 10.69 15.66 10.99 15.48 11.27C15.18 11.74 14.68 12.04 14.13 12.08C13.8 12.1 13.51 12 13.26 11.9C13.02 11.8 12.73 11.64 12.4 11.47C12.27 11.39 12.16 11.35 12.11 11.32C12.07 11.3 12.12 11.32 12.11 11.32C11.97 11.25 11.88 11.32 11.88 11.32C11.82 11.35 11.72 11.39 11.59 11.46C11.26 11.65 10.97 11.8 10.73 11.91C10.49 12.02 10.19 12.12 9.86 12.09C9.3 12.05 8.8 11.75 8.5 11.28C8.33 11 8.28 10.7 8.25 10.43C8.23 10.17 8.23 10.14 8.23 9.76H4.25V16.06C4.25 16.06 4.25 16.08 4.25 16.09C4.25 16.54 4.28 16.95 4.32 17.3C4.4 17.93 4.59 18.49 5.05 18.95C5.51 19.41 6.07 19.59 6.7 19.68C7.29 19.76 8.04 19.76 8.94 19.76H13.1C13.06 19.59 13.03 19.43 13.02 19.29C13 19.04 13 18.75 13 18.5V18.39C13 18.14 13 17.86 13.02 17.6C13.05 17.31 13.12 16.89 13.36 16.47C13.52 16.19 13.73 15.94 13.98 15.74C14.22 14.33 15.45 13.25 16.94 13.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9375 14.25C15.8329 14.25 14.9375 15.1454 14.9375 16.25V16.3016C14.9062 16.3167 14.8749 16.3331 14.8438 16.3511C14.5872 16.4992 14.3742 16.7122 14.2261 16.9688C14.0864 17.2107 14.0392 17.4602 14.0188 17.6855C14 17.893 14 18.1414 14 18.4088V18.4662C14 18.7335 14 18.982 14.0188 19.1895C14.0392 19.4148 14.0864 19.6643 14.2261 19.9063C14.3742 20.1628 14.5872 20.3758 14.8438 20.5239C15.0857 20.6636 15.3352 20.7108 15.5605 20.7312C15.768 20.7501 16.0164 20.75 16.2838 20.75H17.5912C17.8585 20.75 18.107 20.7501 18.3145 20.7312C18.5398 20.7108 18.7893 20.6636 19.0313 20.5239C19.2878 20.3758 19.5008 20.1628 19.6489 19.9063C19.7886 19.6643 19.8358 19.4148 19.8562 19.1895C19.8751 18.982 19.875 18.7335 19.875 18.4662V18.4088C19.875 18.1415 19.8751 17.893 19.8562 17.6855C19.8358 17.4602 19.7886 17.2107 19.6489 16.9688C19.5008 16.7122 19.2878 16.4992 19.0313 16.3511C19.0001 16.3331 18.9688 16.3167 18.9375 16.3016V16.25C18.9375 15.1454 18.0421 14.25 16.9375 14.25ZM17.4217 16.125C17.3662 15.9093 17.1705 15.75 16.9375 15.75C16.7045 15.75 16.5088 15.9093 16.4533 16.125H17.4217Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box secure": {
        defaultColors: ["#000000"],
        keywords: ["box","secure","package","lock","security","inventory","protected","safe","delivery","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="15" y="16.875" width="4.375" height="3.125" rx="0.9375" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M18.4375 16.875V16.25C18.4375 15.5596 17.8779 15 17.1875 15V15C16.4971 15 15.9375 15.5596 15.9375 16.25V16.875"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box sent-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","send","next","forward","checkout","continue","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 15L19 17L17 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L14 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box sent-3": {
        defaultColors: ["#000000"],
        keywords: ["shipping","sent","delivered","package","box","delivery","order-sent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.3423 19.75 15.6171 19.7473 15.876L19.0607 15.1894C18.4749 14.6036 17.5252 14.6035 16.9394 15.1893C16.5173 15.6114 16.3994 16.2223 16.5854 16.75L15 16.75C14.1716 16.75 13.5 17.4216 13.5 18.25C13.5 19.0784 14.1716 19.75 15 19.75L15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4697 15.7197C17.7626 15.4268 18.2375 15.4268 18.5304 15.7197L20.5303 17.7197C20.8232 18.0126 20.8232 18.4875 20.5303 18.7803L18.5303 20.7803C18.2374 21.0732 17.7626 21.0732 17.4697 20.7803C17.1768 20.4874 17.1768 20.0126 17.4697 19.7197L18.1893 19L15 19C14.5858 19 14.25 18.6642 14.25 18.25C14.25 17.8358 14.5858 17.5 15 17.5L18.1894 17.5L17.4697 16.7803C17.1768 16.4874 17.1768 16.0126 17.4697 15.7197Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box sent-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","send","ship","order-shipped","delivery","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 15L19 17L17 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "box setting-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["settings","cog","gear","options","configuration","system","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box sent": {
        defaultColors: ["#000000"],
        keywords: ["shipping","box","sent","package","delivery","order-shipped","order-delivered"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 15L19 17L17 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box setting-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","settings","gear","configuration","order-settings","package-settings","inventory-settings","product-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box setting": {
        defaultColors: ["#000000"],
        keywords: ["box","package","settings","configuration","options","inventory","stock","adjust","manage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box shield-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["shield","security","protection","safe","secure","verified","warranty","authorized","guarantee","insurance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 17.0889V15.8571C15.8225 15.8571 17.3527 15.4258 18 15C18.6473 15.4258 20.1775 15.8571 21 15.8571V17.0889C21 18.9368 19.7631 20.5518 18 21C16.2369 20.5518 15 18.9368 15 17.0889Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box shield-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["package","box","shop","store","security","shield","protection","secure","safe","inventory","stock","damaged","broken","package-protection","inventory-protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17.7408V16.7143C16.6854 16.7143 17.9606 16.3548 18.5 16C19.0394 16.3548 20.3146 16.7143 21 16.7143V17.7408C21 19.2807 19.9693 20.6265 18.5 21C17.0307 20.6265 16 19.2807 16 17.7408Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box setting-3": {
        defaultColors: ["#000000"],
        keywords: ["settings","box","cog","preferences","configuration","inventory-settings","system-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.6801C19.4246 14.5306 19.0567 14.4821 18.6983 14.5486C18.4583 13.8685 17.8098 13.3811 17.0476 13.3811C16.2853 13.3811 15.6368 13.8685 15.3968 14.5486C14.6846 14.4164 13.9359 14.7384 13.557 15.4032C13.1811 16.0628 13.2811 16.8636 13.7482 17.4087C13.2811 17.9539 13.1811 18.7547 13.557 19.4142C13.6277 19.5383 13.7114 19.6505 13.8052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0478 14.3812C17.462 14.3812 17.7978 14.717 17.7978 15.1312V15.2668C18.0676 15.3612 18.3142 15.5052 18.5265 15.6878L18.6417 15.621C19.0001 15.4132 19.459 15.5353 19.6668 15.8936C19.8745 16.252 19.7525 16.7109 19.3941 16.9186L19.2777 16.9861C19.3035 17.1232 19.317 17.2646 19.317 17.4091C19.317 17.5534 19.3035 17.6947 19.2777 17.8316L19.3941 17.899C19.7525 18.1068 19.8745 18.5657 19.6668 18.924C19.459 19.2824 19.0001 19.4044 18.6417 19.1967L18.5268 19.1301C18.3144 19.3128 18.0678 19.4569 17.7978 19.5514V19.6866C17.7978 20.1009 17.462 20.4366 17.0478 20.4366C16.6336 20.4366 16.2978 20.1009 16.2978 19.6866V19.5513C16.0281 19.457 15.7817 19.3132 15.5695 19.1308L15.449 19.1995C15.0891 19.4046 14.6312 19.2791 14.4261 18.9192C14.221 18.5593 14.3465 18.1013 14.7063 17.8962L14.8182 17.8325C14.7924 17.6953 14.7789 17.5538 14.7789 17.4091C14.7789 17.2642 14.7924 17.1225 14.8183 16.9852L14.7063 16.9214C14.3465 16.7163 14.221 16.2583 14.4261 15.8985C14.6312 15.5386 15.0891 15.4131 15.449 15.6182L15.5698 15.687C15.782 15.5048 16.0283 15.3611 16.2978 15.2668V15.1312C16.2978 14.717 16.6336 14.3812 17.0478 14.3812ZM16.9934 16.6419C16.75 16.6589 16.538 16.7888 16.4095 16.9796C16.4032 16.9923 16.3965 17.0049 16.3894 17.0173C16.3799 17.034 16.3698 17.0503 16.3592 17.066C16.3078 17.1692 16.2789 17.2857 16.2789 17.4091C16.2789 17.5317 16.3074 17.6476 16.3583 17.7504C16.3692 17.7665 16.3796 17.7831 16.3894 17.8003C16.3969 17.8134 16.4039 17.8265 16.4104 17.8398C16.5387 18.0295 16.7494 18.1586 16.9915 18.1761C17.0101 18.1747 17.0288 18.174 17.0478 18.174C17.0668 18.174 17.0856 18.1747 17.1042 18.1761C17.5029 18.1473 17.817 17.8147 17.817 17.4091C17.817 17.0027 17.5018 16.6698 17.1023 16.6419C17.0843 16.6432 17.0661 16.6438 17.0478 16.6438C17.0295 16.6438 17.0114 16.6432 16.9934 16.6419Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box shield-3": {
        defaultColors: ["#000000"],
        keywords: ["security","shield","protection","safe","secure","warranty","insurance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.6673C19.7254 14.6579 19.7018 14.6486 19.6792 14.6395C19.613 14.6126 19.5597 14.5886 19.5196 14.5688C19.4818 14.5502 19.4641 14.5394 19.4618 14.538C18.8781 14.154 18.122 14.154 17.5383 14.538C17.536 14.5393 17.5182 14.5502 17.4804 14.5688C17.4403 14.5886 17.387 14.6126 17.3208 14.6395C17.1878 14.6934 17.0186 14.7522 16.826 14.807C16.4215 14.922 16.1093 14.9643 16 14.9643C15.0335 14.9643 14.25 15.7478 14.25 16.7143V17.7408C14.25 18.446 14.3936 19.1272 14.6572 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M18.9122 15.3734C18.662 15.2089 18.338 15.2089 18.0878 15.3734C17.9138 15.4879 17.5472 15.6415 17.0996 15.7688C16.6566 15.8948 16.2427 15.9643 16 15.9643C15.5858 15.9643 15.25 16.3001 15.25 16.7143V17.7408C15.25 19.6151 16.5051 21.2668 18.3152 21.7269C18.4365 21.7577 18.5635 21.7577 18.6848 21.7269C20.4949 21.2668 21.75 19.6151 21.75 17.7408V16.7143C21.75 16.3001 21.4142 15.9643 21 15.9643C20.7573 15.9643 20.3433 15.8948 19.9004 15.7688C19.4528 15.6415 19.0862 15.4879 18.9122 15.3734Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box shield": {
        defaultColors: ["#000000"],
        keywords: ["box","shield","protected","inventory","secure-inventory","safe","protection","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 17.0889V15.8571C15.8225 15.8571 17.3527 15.4258 18 15C18.6473 15.4258 20.1775 15.8571 21 15.8571V17.0889C21 18.9368 19.7631 20.5518 18 21C16.2369 20.5518 15 18.9368 15 17.0889Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box time-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["time","clock","schedule","delay","late","waiting","order-time","pickup-time","delivery-time","reservation-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 17.5C21 19.437 19.437 21 17.5 21C15.563 21 14 19.437 14 17.5C14 15.563 15.563 14 17.5 14C19.437 14 21 15.563 21 17.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2144 17.7138H17V16.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box time-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","love","favorite","wishlist","save-item","add-to-wishlist","gift","present","special-order","saved","tagged"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 18C21 19.6603 19.6603 21 18 21C16.3397 21 15 19.6603 15 18C15 16.3397 16.3397 15 18 15C19.6603 15 21 16.3397 21 18Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6122 18.1835H17.5713V17.1431"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box time-3": {
        defaultColors: ["#000000"],
        keywords: ["box","time","box-time","shipping-time","delivery-time","order-time","package-time","clock","deadline","shipping","delivery","delay","schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7212 4.30826C16.2336 4.24996 15.6334 4.24998 14.9211 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5982 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 13.8127C19.0485 13.3016 18.1844 13 17.25 13C14.9028 13 13 14.9028 13 17.25C13 18.1844 13.3016 19.0485 13.8127 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.75 15.1732C20.2183 15.7364 20.5 16.4603 20.5 17.25C20.5 19.0449 19.0449 20.5 17.25 20.5C16.4603 20.5 15.7364 20.2183 15.1732 19.75C14.4564 19.1538 14 18.2552 14 17.25C14 15.4551 15.4551 14 17.25 14C18.2552 14 19.1539 14.4564 19.75 15.1732ZM17.75 16C17.75 15.5858 17.4142 15.25 17 15.25C16.5858 15.25 16.25 15.5858 16.25 16V17.2138C16.25 17.628 16.5858 17.9638 17 17.9638H18.2144C18.6286 17.9638 18.9644 17.628 18.9644 17.2138C18.9644 16.7996 18.6286 16.4638 18.2144 16.4638H17.75V16Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box time": {
        defaultColors: ["#000000"],
        keywords: ["box","package","time","clock","delivery","shipping","schedule","order-time","delivery-time","arrival"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 17.5C21 19.437 19.437 21 17.5 21C15.563 21 14 19.437 14 17.5C14 15.563 15.563 14 17.5 14C19.437 14 21 15.563 21 17.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2144 17.7138H17V16.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box tracking-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["location","pin","map","gps","store-location","address","place","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box tracking-3": {
        defaultColors: ["#000000"],
        keywords: ["shipping","delivery","box","package","tracking","track-order","order-status","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.07959 4.25H14.9217C15.634 4.24998 16.2342 4.24996 16.7218 4.30826C17.2394 4.37015 17.7125 4.5053 18.1315 4.83244C18.5504 5.15958 18.7963 5.58575 18.9819 6.0729C19.1567 6.53175 19.3023 7.11408 19.475 7.80514L19.5862 8.25H4.41504L4.52626 7.80513C4.699 7.11408 4.84456 6.53174 5.01937 6.0729C5.20496 5.58575 5.4508 5.15958 5.8698 4.83244C6.28879 4.5053 6.76186 4.37015 7.27948 4.30826C7.76701 4.24996 8.36729 4.24998 9.07959 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M13.12 16.35C13.12 14.18 14.88 12.42 17.05 12.41C18.08 12.41 19.01 12.83 19.71 13.48C19.71 13.48 19.73 13.5 19.74 13.51V9.75H15.74C15.74 10.12 15.74 10.15 15.72 10.42C15.7 10.69 15.65 10.99 15.47 11.27C15.17 11.74 14.67 12.04 14.12 12.08C13.79 12.1 13.5 12 13.25 11.9C13.01 11.8 12.72 11.64 12.39 11.47C12.26 11.39 12.15 11.35 12.1 11.32C12.06 11.3 12.11 11.32 12.1 11.32C12.0604 11.2913 11.9645 11.2728 11.87 11.32C11.81 11.35 11.71 11.39 11.58 11.46C11.25 11.65 10.96 11.8 10.72 11.91C10.47 12.02 10.18 12.12 9.85 12.09C9.29 12.05 8.79 11.75 8.49 11.28C8.32 11 8.27 10.7 8.24 10.43C8.22 10.17 8.22 10.14 8.22 9.76H4.25V15.06C4.25 15.96 4.25 16.71 4.33 17.3C4.41 17.93 4.6 18.49 5.06 18.95C5.52 19.41 6.08 19.59 6.71 19.68C7.3 19.76 8.05 19.76 8.95 19.76H14.85C14.6 19.52 14.35 19.25 14.11 18.94C13.68 18.37 13.12 17.46 13.12 16.36V16.35Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.0599 13.4102C15.4399 13.4102 14.1299 14.7302 14.1299 16.3502C14.1299 17.1102 14.5299 17.8102 14.9199 18.3202C15.3199 18.8502 15.8099 19.3002 16.1499 19.5802C16.2499 19.6702 16.3699 19.7602 16.4999 19.8402C16.6399 19.9202 16.8299 20.0002 17.0699 20.0002C17.3099 20.0002 17.4999 19.9202 17.6299 19.8402C17.7599 19.7602 17.8799 19.6702 17.9799 19.5802C18.3199 19.2902 18.7999 18.8402 19.2099 18.3202C19.5999 17.8102 19.9999 17.1202 19.9999 16.3502C19.9999 14.7302 18.6799 13.4102 17.0699 13.4102H17.0599ZM17.0599 17.1102C16.6399 17.1102 16.2999 16.7702 16.2999 16.3502C16.2999 15.9302 16.6399 15.5902 17.0599 15.5902C17.4799 15.5902 17.8199 15.9302 17.8199 16.3502C17.8199 16.7702 17.4799 17.1102 17.0599 17.1102Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box tracking": {
        defaultColors: ["#000000"],
        keywords: ["box","package","tracking","delivery","inventory","stock","shipment","order-status","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box tracking-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","location","track","tracking","delivery","shipping","order-location","package-location","shipment","find-package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16.1875C15 17.2116 16.1175 18.3055 16.755 18.8465C17.1336 19.1677 17.2436 19.165 17.6194 18.8465C18.2575 18.3055 19.375 17.2116 19.375 16.1875C19.375 14.9794 18.3956 14 17.1875 14C15.9794 14 15 14.9794 15 16.1875Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1881 16.025C17.2778 16.0253 17.3502 16.0983 17.35 16.1879C17.3498 16.2776 17.277 16.3501 17.1873 16.35C17.0976 16.3499 17.025 16.2772 17.025 16.1875C17.0248 16.1442 17.0419 16.1027 17.0726 16.0721C17.1032 16.0416 17.1449 16.0246 17.1881 16.025"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box view-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["view","eye","visibility","details","observe","scan","check","inspect","show","reveal","track","monitor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.8 19C16.8838 18.9989 17.8527 18.3585 18.4962 17.3528C18.6346 17.1365 18.6346 16.8635 18.4962 16.6472C17.8527 15.6416 16.8838 15.0011 15.8 15C14.7162 15.0011 13.7473 15.6416 13.1038 16.6472C12.9654 16.8635 12.9654 17.1365 13.1038 17.3528C13.7473 18.3585 14.7162 18.9989 15.8 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7501 17.6999C16.1091 17.6999 16.4001 17.4089 16.4001 17.0499C16.4001 16.6909 16.1091 16.3999 15.7501 16.3999C15.3911 16.3999 15.1001 16.6909 15.1001 17.0499C15.1001 17.4089 15.3911 17.6999 15.7501 17.6999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box view-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","product","item","inventory","stock","delivery","shipping","order","product-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8008 14.25H15.7992C14.3987 14.2515 13.2167 15.0793 12.4721 16.243C12.176 16.7057 12.176 17.2944 12.4721 17.7571C13.2167 18.9207 14.3987 19.7485 15.7992 19.75H15.8008C17.2013 19.7485 18.3833 18.9207 19.1279 17.7571C19.424 17.2944 19.424 16.7057 19.1279 16.243C18.3833 15.0793 17.2013 14.2515 15.8008 14.25ZM16.4001 17.0499C16.4001 17.4089 16.1091 17.6999 15.7501 17.6999C15.3911 17.6999 15.1001 17.4089 15.1001 17.0499C15.1001 16.6909 15.3911 16.3999 15.7501 16.3999C16.1091 16.3999 16.4001 16.6909 16.4001 17.0499Z"
                    fill={colors?.[2] || "#000000"}
                />
            </svg>
        )
    },
    "box view-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","view","box-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8008 14.25H15.7992C14.3987 14.2515 13.2167 15.0793 12.4721 16.243C12.176 16.7057 12.176 17.2944 12.4721 17.7571C13.2004 18.8952 14.3471 19.7121 15.7075 19.7487C15.7379 19.7495 15.7685 19.75 15.7992 19.75H15.8008C15.8531 19.7499 15.9052 19.7487 15.9569 19.7464C17.289 19.6862 18.4111 18.8772 19.1279 17.7571C19.424 17.2944 19.424 16.7057 19.1279 16.243C18.3833 15.0793 17.2013 14.2515 15.8008 14.25ZM16.4001 17.0499C16.4001 17.4089 16.1091 17.6999 15.7501 17.6999C15.3911 17.6999 15.1001 17.4089 15.1001 17.0499C15.1001 16.6909 15.3911 16.3999 15.7501 16.3999C16.1091 16.3999 16.4001 16.6909 16.4001 17.0499Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.07897 4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53174 5.01875 6.0729C5.20434 5.58575 5.45019 5.15958 5.86918 4.83244C6.28817 4.5053 6.76124 4.37015 7.27886 4.30826C7.76639 4.24996 8.36667 4.24998 9.07897 4.25ZM4.25 9.75L4.25001 15.052C4.24998 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75L12.9481 19.75C12.4248 19.3454 11.9805 18.8441 11.6298 18.2961C11.1234 17.5048 11.1234 16.4953 11.6297 15.704C12.5082 14.3312 13.974 13.2519 15.7982 13.25L15.7992 13.25L15.8018 13.25C17.4811 13.2518 18.8566 14.1665 19.7498 15.3827C19.75 15.2748 19.75 15.1647 19.75 15.052L19.75 9.75H15.75C15.75 10.1235 15.75 10.1539 15.7281 10.4158C15.7059 10.6822 15.655 10.9898 15.4804 11.2668C15.1839 11.7371 14.6815 12.0386 14.1271 12.0789C13.8004 12.1027 13.505 12.0028 13.2594 11.8971C13.018 11.7932 12.73 11.6397 12.4003 11.4639L12.3735 11.4495C12.242 11.3794 12.1675 11.34 12.1099 11.3129C12.0741 11.2961 12.0584 11.2907 12.0542 11.2894C12.0179 11.2813 11.9802 11.2813 11.944 11.2895C11.94 11.2907 11.9247 11.296 11.8886 11.3129C11.831 11.34 11.7566 11.3794 11.6252 11.4496L11.5983 11.4639C11.2693 11.6394 10.982 11.7927 10.741 11.8965C10.496 12.0021 10.2012 12.102 9.87504 12.0786C9.31917 12.0389 8.81548 11.7367 8.51873 11.265C8.34463 10.9882 8.29398 10.6811 8.27179 10.4152C8.24996 10.1537 8.24998 10.1229 8.24999 9.75H4.25ZM15.9569 19.7464C15.8754 19.7474 15.7922 19.7482 15.7075 19.7487C14.3471 19.7121 13.2004 18.8952 12.4721 17.7571C12.176 17.2944 12.176 16.7057 12.4721 16.243C13.2167 15.0793 14.3987 14.2515 15.7992 14.25H15.8008C17.2013 14.2515 18.3833 15.0793 19.1279 16.243C19.424 16.7057 19.424 17.2944 19.1279 17.7571C18.4111 18.8772 17.289 19.6862 15.9569 19.7464ZM15.7501 17.6999C16.1091 17.6999 16.4001 17.4089 16.4001 17.0499C16.4001 16.6909 16.1091 16.3999 15.7501 16.3999C15.3911 16.3999 15.1001 16.6909 15.1001 17.0499C15.1001 17.4089 15.3911 17.6999 15.7501 17.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box view": {
        defaultColors: ["#000000"],
        keywords: ["box","view","package","inventory","stock","item","items","products","catalog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.8 19C16.8838 18.9989 17.8527 18.3585 18.4962 17.3528C18.6346 17.1365 18.6346 16.8635 18.4962 16.6472C17.8527 15.6416 16.8838 15.0011 15.8 15C14.7162 15.0011 13.7473 15.6416 13.1038 16.6472C12.9654 16.8635 12.9654 17.1365 13.1038 17.3528C13.7473 18.3585 14.7162 18.9989 15.8 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7501 17.6999C16.1091 17.6999 16.4001 17.4089 16.4001 17.0499C16.4001 16.6909 16.1091 16.3999 15.7501 16.3999C15.3911 16.3999 15.1001 16.6909 15.1001 17.0499C15.1001 17.4089 15.3911 17.6999 15.7501 17.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box warning-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","warning","alert","inventory","stock","damaged","problem","issue","shipment","delivery","out-of-stock","low-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box warning-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["triangle","warning","alert","caution","error","attention","issue","problem","alert-payment","warning-transaction","caution-operation","issue-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box warning-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","warning","alert","error","inventory","stock","problem","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 14.7376C19.7393 14.7228 19.7285 14.7082 19.7178 14.6938C19.4671 14.3571 19.0244 13.8414 18.2931 13.619C17.7715 13.4603 17.2144 13.4603 16.6927 13.619C15.9615 13.8414 15.5187 14.3571 15.268 14.6938C15.0282 15.0158 14.784 15.4312 14.5465 15.835L14.4642 15.975C14.2203 16.3894 13.971 16.8132 13.8032 17.1855C13.6292 17.5714 13.3878 18.2213 13.5581 18.98C13.6191 19.2518 13.7207 19.5112 13.8582 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9836 14.5757C17.3156 14.4748 17.6701 14.4748 18.0021 14.5757C18.4222 14.7035 18.7041 15.0068 18.9157 15.291C19.1227 15.569 19.3437 15.9449 19.5977 16.3766C19.6045 16.3883 19.6114 16.3999 19.6183 16.4116L19.639 16.4469C19.8996 16.8898 20.1257 17.2742 20.2709 17.5964C20.4187 17.9243 20.5497 18.3256 20.452 18.761C20.3751 19.1036 20.1969 19.4151 19.9406 19.6551C19.6148 19.9601 19.2026 20.0507 18.845 20.0895C18.4936 20.1277 18.0476 20.1277 17.5338 20.1277H17.4519C16.9381 20.1277 16.4921 20.1277 16.1408 20.0895C15.7832 20.0507 15.3709 19.9601 15.0452 19.6551C14.7889 19.4151 14.6107 19.1036 14.5338 18.761C14.436 18.3256 14.567 17.9243 14.7148 17.5964C14.86 17.2742 15.0862 16.8898 15.3467 16.4469C15.3536 16.4352 15.3605 16.4234 15.3675 16.4116C15.3744 16.3999 15.3812 16.3883 15.3881 16.3766C15.642 15.9449 15.8631 15.569 16.0701 15.291C16.2817 15.0068 16.5635 14.7035 16.9836 14.5757Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box warning": {
        defaultColors: ["#000000"],
        keywords: ["box","package","warning","alert","inventory","stock","problem","error","out-of-stock","low-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","package","remove","minus","order","remove-order","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 15H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","inventory","storage","products","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.948 4.25H15.052C15.9505 4.24997 16.6997 4.24995 17.2945 4.32992C17.9223 4.41432 18.4891 4.59999 18.9445 5.05546C19.4 5.51093 19.5857 6.07773 19.6701 6.70553C19.7501 7.3003 19.75 8.04951 19.75 8.94798V15.052C19.75 15.0951 19.75 15.138 19.75 15.1804V14.25L4.25 14.25V8.948C4.24997 8.04956 4.24995 7.30029 4.32992 6.70553C4.41432 6.07773 4.59999 5.51093 5.05546 5.05546C5.51093 4.59999 6.07773 4.41432 6.70553 4.32992C7.30029 4.24995 8.04956 4.24997 8.948 4.25ZM10 8.25C9.58579 8.25 9.25 8.58579 9.25 9C9.25 9.41421 9.58579 9.75 10 9.75H14C14.4142 9.75 14.75 9.41421 14.75 9C14.75 8.58579 14.4142 8.25 14 8.25H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.25158 15.75C4.25584 16.3455 4.27164 16.861 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7284 16.861 19.7442 16.3455 19.7484 15.75L4.25158 15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-archive-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","arrow","upload","import","receive","inbound","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9994 16V12M11.9994 12L14 14M11.9994 12L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","storage","container","inventory","products","items","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.36364 15L18.6364 15C18.7898 15 18.8666 15 18.9199 15.0399C18.9351 15.0513 18.9487 15.0649 18.9601 15.0801C19 15.1334 19 15.2102 19 15.3636C19 16.8983 19 17.6657 18.6011 18.1986C18.4868 18.3512 18.3512 18.4868 18.1986 18.6011C17.6657 19 16.8983 19 15.3636 19L8.63636 19C7.10168 19 6.33434 19 5.80144 18.6011C5.64876 18.4868 5.51321 18.3512 5.39892 18.1986C5 17.6657 5 16.8983 5 15.3636C5 15.2102 5 15.1334 5.03989 15.0801C5.05132 15.0649 5.06488 15.0513 5.08014 15.0399C5.13343 15 5.21017 15 5.36364 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-archive-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","upload","send","archive","inventory","transfer","send-inventory","upload-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.07887 4.25H14.9209C15.6332 4.24998 16.2335 4.24996 16.7211 4.30826C17.2387 4.37015 17.7117 4.5053 18.1307 4.83244C18.5497 5.15958 18.7956 5.58575 18.9812 6.0729C19.156 6.53175 19.3015 7.11408 19.4743 7.80514L19.5855 8.25H4.41432L4.52554 7.80513C4.69828 7.11408 4.84384 6.53175 5.01865 6.0729C5.20424 5.58575 5.45008 5.15958 5.86908 4.83244C6.28807 4.5053 6.76114 4.37015 7.27876 4.30826C7.76629 4.24996 8.36658 4.24998 9.07887 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6998 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9446C5.51093 19.4001 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04954 19.7501 8.94801 19.75H15.052C15.9505 19.7501 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4001 18.9445 18.9446C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6998 19.75 15.9505 19.75 15.052L19.75 9.75H4.25ZM11.9993 12C12.1982 12 12.389 12.079 12.5296 12.2196L14.5302 14.2196C14.8231 14.5124 14.8232 14.9873 14.5304 15.2803C14.2375 15.5732 13.7626 15.5733 13.4697 15.2804L12.7494 14.5603V16.75C12.7494 17.1642 12.4136 17.5 11.9994 17.5C11.5852 17.5 11.2494 17.1642 11.2494 16.75V14.561L10.5304 15.2803C10.2375 15.5732 9.76264 15.5733 9.4697 15.2804C9.17677 14.9876 9.1767 14.5127 9.46955 14.2197L11.469 12.2197C11.6096 12.0791 11.8004 12 11.9993 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-archive-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","archive","upload","export","backup","restore","ship","shipping","transfer","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.4C5 9.21144 5 9.11716 5.05858 9.05858C5.11716 9 5.21144 9 5.4 9H18.6C18.7886 9 18.8828 9 18.9414 9.05858C19 9.11716 19 9.21144 19 9.4V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9994 16V12M11.9994 12L14 14M11.9994 12L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-archive": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","upload","arrow","import","receive","inventory","stock","add-stock","restock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9994 16V12M11.9994 12L14 14M11.9994 12L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","container","package","storage","inventory","shipment","delivery","product","item","stock","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","container","storage","inventory","items","package","products","stock","warehouse","bin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","container","storage","drawer","inventory","items","package","archive","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.5 8.75C4.25736 8.75 3.25 7.74264 3.25 6.5C3.25 5.25736 4.25736 4.25 5.5 4.25H18.5C19.7426 4.25 20.75 5.25736 20.75 6.5C20.75 7.74264 19.7426 8.75 18.5 8.75H5.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052L4.25001 10H19.75L19.75 15.052C19.75 15.9505 19.7501 16.6997 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9445C18.4891 19.4 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.75 15.052 19.75H8.94801C8.04954 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24997 15.9504 4.25 15.052Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-big-heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","heart","package","favorite","loyalty","rewards","customer-appreciation","special-offer","gift","promotion","preferred-customer","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 12.3771C10.795 11.8743 9.93175 11.8743 9.39932 12.3771C8.86689 12.88 8.86689 13.6953 9.39932 14.1981L11.9869 16L14.6007 14.1981C15.1331 13.6953 15.1331 12.88 14.6007 12.3771C14.0683 11.8743 13.205 11.8743 12.6726 12.3771L12 13.0124L11.3274 12.3771Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-heart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","heart","gift","favorite","loyalty","reward","promotion","customer","special-order","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.3274 12.3771C10.795 11.8743 9.93175 11.8743 9.39932 12.3771C8.86689 12.88 8.86689 13.6953 9.39932 14.1981L11.9869 16L14.6007 14.1981C15.1331 13.6953 15.1331 12.88 14.6007 12.3771C14.0683 11.8743 13.205 11.8743 12.6726 12.3771L12 13.0124L11.3274 12.3771Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","remove","minus","order","remove-order","subtract","reduce","delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","heart","favorite","saved","preferred-customer","rewards","loyalty","customer-rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.25 6.5C3.25 7.74264 4.25736 8.75 5.5 8.75H18.5C19.7426 8.75 20.75 7.74264 20.75 6.5C20.75 5.25736 19.7426 4.25 18.5 4.25H5.5C4.25736 4.25 3.25 5.25736 3.25 6.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25001 10L4.25 15.052C4.24997 15.9504 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04954 19.75 8.94801 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.0521L19.75 10H4.25001ZM9.05601 13.0136C9.78113 12.3288 10.9456 12.3288 11.6707 13.0136L12 13.3246L12.3293 13.0136C13.0544 12.3288 14.2189 12.3288 14.944 13.0136C15.6853 13.7138 15.6853 14.8615 14.944 15.5616C14.9254 15.5792 14.9055 15.5953 14.8845 15.6098L12.2707 17.4117C12.0991 17.5299 11.8722 17.5294 11.7012 17.4103L9.11359 15.6084C9.09326 15.5943 9.07402 15.5786 9.05601 15.5616C8.31466 14.8615 8.31466 13.7138 9.05601 13.0136Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-big-heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","heart","package","favorite-order","loyalty","rewards","gift","special-order","valentines-day","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 12.3771C10.795 11.8743 9.93175 11.8743 9.39932 12.3771C8.86689 12.88 8.86689 13.6953 9.39932 14.1981L11.9869 16L14.6007 14.1981C15.1331 13.6953 15.1331 12.88 14.6007 12.3771C14.0683 11.8743 13.205 11.8743 12.6726 12.3771L12 13.0124L11.3274 12.3771Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","remove","subtract","order","remove-order","delete","delete-order","inventory","stock","reduce","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","remove","minus","order","remove-order","inventory","storage","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","package","check","checkmark","order","order-complete","delivery","confirmed","verified","inventory","stock","received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.5238L11 15L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","container","package","inventory","storage","categories","products","items","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6.6C4 5.71634 4.79594 5 5.77778 5H18.2222C19.2041 5 20 5.71634 20 6.6C20 6.9716 20 7.1574 19.9754 7.31287C19.8398 8.16865 19.1687 8.83983 18.3129 8.97538C18.1574 9 17.9716 9 17.6 9H6.4C6.0284 9 5.8426 9 5.68713 8.97538C4.83135 8.83983 4.16017 8.16865 4.02462 7.31287C4 7.1574 4 6.9716 4 6.6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","check","check-mark","order-received","confirmed","delivered","complete","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.4C5 9.21144 5 9.11716 5.05858 9.05858C5.11716 9 5.21144 9 5.4 9H18.6C18.7886 9 18.8828 9 18.9414 9.05858C19 9.11716 19 9.21144 19 9.4V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.5238L11 15L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-big-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","remove","subtract","delete","inventory","remove-item","decrease","order","cancel-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.5 8.75C4.25736 8.75 3.25 7.74264 3.25 6.5C3.25 5.25736 4.25736 4.25 5.5 4.25H18.5C19.7426 4.25 20.75 5.25736 20.75 6.5C20.75 7.74264 19.7426 8.75 18.5 8.75H5.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052L4.25001 10H19.75L19.75 15.052C19.75 15.9505 19.7501 16.6997 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9445C18.4891 19.4 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.75 15.052 19.75H8.94801C8.04954 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24997 15.9504 4.25 15.052ZM8 14C7.58579 14 7.25 14.3358 7.25 14.75C7.25 15.1642 7.58579 15.5 8 15.5H16C16.4142 15.5 16.75 15.1642 16.75 14.75C16.75 14.3358 16.4142 14 16 14H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","check","confirmed","order-confirmed","delivery","shipping","inventory","received","order-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6787 8.69414C19.6834 8.7402 19.6867 8.7977 19.6835 8.86262C19.7133 8.94501 19.728 9.02085 19.736 9.08061C19.7435 9.13644 19.747 9.19555 19.7487 9.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514L19.609 8.34349C19.6321 8.43557 19.6662 8.57108 19.6787 8.69414Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 10.75L19.75 10.75L19.75 15.052C19.75 15.9505 19.7501 16.6997 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9445C18.4891 19.4 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.75 15.052 19.75H8.94801C8.04954 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.0521L4.25 10.75ZM14.5303 13.5303C14.8232 13.2374 14.8232 12.7626 14.5303 12.4697C14.2374 12.1768 13.7625 12.1768 13.4696 12.4697L11.1117 14.8276L10.6209 14.1032C10.3886 13.7602 9.92225 13.6706 9.57932 13.9029C9.23638 14.1352 9.1467 14.6015 9.37901 14.9444L10.379 16.4206C10.5045 16.6059 10.7061 16.7254 10.9288 16.7466C11.1515 16.7678 11.3721 16.6885 11.5303 16.5303L14.5303 13.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.26401 9.08061C4.25651 9.13644 4.25298 9.19555 4.25134 9.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01875 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.39665 8.32109L4.39103 8.34349C4.36786 8.43557 4.33378 8.57107 4.32126 8.69413C4.31658 8.7402 4.31331 8.7977 4.31653 8.86262C4.28675 8.94501 4.27205 9.02085 4.26401 9.08061Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-cube-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","cube","inventory","package","stock","item","product","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8186V7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857V14.8186C4 15.4241 4 15.7268 4.15103 15.9695C4.30206 16.2121 4.5737 16.3458 5.11699 16.6131L11.117 19.5655C11.5505 19.7788 11.7673 19.8855 12 19.8855C12.2327 19.8855 12.4495 19.7788 12.883 19.5655L18.883 16.6131C19.4263 16.3458 19.6979 16.2121 19.849 15.9695C20 15.7268 20 15.4241 20 14.8186Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30206 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5195L19.9142 7.46534C19.9509 7.44962 19.9692 7.44176 19.9692 7.42857C19.9692 7.41538 19.9509 7.40752 19.9142 7.39181L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4.08579 7.39181C4.04911 7.40752 4.03077 7.41538 4.03077 7.42857C4.03077 7.44176 4.04911 7.44962 4.08579 7.46534L11.2122 10.5195C11.6005 10.686 11.7947 10.7692 12 10.7692C12.2053 10.7692 12.3994 10.686 12.7878 10.5195L12.7878 10.5195Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-cube-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","cube","inventory","package","product","stock","storage","item","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11L12 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M5 7.42871L12 10.8573L19 7.42871"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13.7238V9.92342C5 8.71008 5 8.10341 5.30302 7.61757C5.60604 7.13173 6.15087 6.86488 7.24053 6.33117L7.24053 6.33117L10.2405 4.86178C11.1045 4.4386 11.5365 4.22702 12 4.22702C12.4635 4.22702 12.8955 4.4386 13.7595 4.86178L16.7595 6.33117C17.8491 6.86488 18.394 7.13173 18.697 7.61757C19 8.10341 19 8.71008 19 9.92342V13.7238C19 14.865 19 15.4356 18.7264 15.9034C18.4527 16.3713 17.9554 16.6509 16.9607 17.2103L13.9607 18.8974C13.0027 19.4361 12.5238 19.7054 12 19.7054C11.4762 19.7054 10.9973 19.4361 10.0393 18.8974L7.03933 17.2103C6.04462 16.6509 5.54727 16.3713 5.27364 15.9034C5 15.4356 5 14.865 5 13.7238Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","check","order","confirmed","verified","delivery","shipment","inventory-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.5238L11 15L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-cube-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","cube","inventory","stock","item","product","package","storage","warehouse","supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L4.06844 6.58319L11.5007 9.82147C11.7081 9.91181 11.8244 9.96191 11.9144 9.9929C11.9544 10.0067 11.9771 10.0123 11.9889 10.0146C11.9945 10.0157 11.9975 10.0161 11.9986 10.0162L12 10.0163L12.0014 10.0162C12.0025 10.0161 12.0055 10.0157 12.0111 10.0146C12.0229 10.0123 12.0456 10.0067 12.0857 9.9929C12.1756 9.96191 12.292 9.91181 12.4993 9.82147L19.9316 6.5832L13.0833 3.64821L13.0072 3.61544Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.75 7.8628L13.0985 11.1966L13.0214 11.2304C12.933 11.2692 12.8426 11.3089 12.75 11.3459L12.75 20.4592C12.8804 20.4039 13.0065 20.3413 13.1291 20.2805L13.2142 20.2384L19.2422 17.2722C19.4896 17.1505 19.7239 17.0352 19.912 16.9171C20.122 16.7852 20.3288 16.6177 20.4857 16.3657C20.6426 16.1137 20.7015 15.8543 20.7271 15.6075C20.7501 15.3866 20.75 15.1256 20.75 14.8499L20.75 7.8628Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.25 20.4593L11.25 11.3459C11.1575 11.3089 11.0671 11.2692 10.9787 11.2304L10.9016 11.1966L3.25001 7.86279L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35745 16.1137 3.51431 16.3657C3.67116 16.6177 3.87796 16.7852 4.08802 16.9171C4.27616 17.0353 4.51033 17.1504 4.75773 17.2721L10.7859 20.2384L10.871 20.2805C10.9935 20.3413 11.1197 20.4039 11.25 20.4593Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-cube": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","cube","inventory","product","stock","item","package","storage","warehouse","supply","goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M5 7.42857V13.7238C5 14.865 5 15.4356 5.27364 15.9034C5.54727 16.3713 6.04462 16.6509 7.03933 17.2103L10.0393 18.8974C10.9973 19.4361 11.4762 19.7054 12 19.7054C12.5238 19.7054 13.0027 19.4361 13.9607 18.8974L16.9607 17.2103C17.9554 16.6509 18.4527 16.3713 18.7264 15.9034C19 15.4356 19 14.865 19 13.7238V7.42857M5 7.42857L12 10.8571L19 7.42857M5 7.42857L10.2405 4.86178C11.1045 4.4386 11.5365 4.22702 12 4.22702C12.4635 4.22702 12.8955 4.4386 13.7595 4.86178L19 7.42857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","package","delivery","shipping","order","send","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-delivery-circle-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipping","order","inventory","stock","receive","incoming"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 8C9.76656 8.00016 9.33568 8.00325 8.98335 8.05062C8.57341 8.10573 8.15946 8.23283 7.82115 8.57114C7.48284 8.90945 7.35575 9.32339 7.30063 9.73334C7.24992 10.1105 7.24996 10.5777 7.25001 11.103L7.25 12.897C7.24996 13.4224 7.24992 13.8896 7.30063 14.2667C7.35574 14.6767 7.48283 15.0906 7.82115 15.4289C8.15946 15.7672 8.5734 15.8943 8.98334 15.9494C9.3605 16.0001 9.82767 16.0001 10.353 16.0001H13.647C14.1723 16.0001 14.6395 16.0001 15.0167 15.9494C15.4266 15.8943 15.8405 15.7672 16.1789 15.4289C16.5172 15.0906 16.6443 14.6767 16.6994 14.2667C16.7501 13.8895 16.75 13.4224 16.75 12.897L16.75 11.103C16.7501 10.5777 16.7501 10.1105 16.6994 9.73334C16.6443 9.32339 16.5172 8.90945 16.1789 8.57114C15.8406 8.23283 15.4266 8.10573 15.0167 8.05062C14.6644 8.00325 14.2335 8.00016 13.75 8L13.75 9.5C13.7501 9.63902 13.7503 9.80888 13.7305 9.95565C13.7065 10.1341 13.6417 10.3856 13.4279 10.5995C13.214 10.8133 12.9625 10.8782 12.784 10.9022C12.6372 10.9219 12.4674 10.9218 12.3284 10.9217H11.6717C11.5327 10.9218 11.3628 10.9219 11.2161 10.9022C11.0376 10.8782 10.786 10.8133 10.5722 10.5995C10.3584 10.3856 10.2935 10.1341 10.2695 9.95565C10.2498 9.80888 10.2499 9.63902 10.25 9.5L10.25 8Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-delivery-circle-add-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","new","create","item","add-item","new-item","create-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9062 5.5H17.0938"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 4.09375V6.90625"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","delivery","shipping","inventory","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-add-2": {
        defaultColors: ["#323232", "#cdd1d8", "#000000"],
        keywords: ["box","package","add","plus","order","add-order","new-order","delivery","new-delivery","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9062 5.5H17.0938"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 4.09375V6.90625"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    fill={colors?.[1] || "#CDD1D8"}
                    stroke={colors?.[1] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V8.5H11V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-add-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","delivery","shipping","new-order","new-package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.3876 19.9314 10.7924 19.8018 10.2213C19.6796 9.68269 20.0171 9.147 20.5557 9.02479C21.0943 8.90258 21.63 9.24012 21.7522 9.77871C21.9145 10.4941 22 11.2377 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.7623 2 13.5059 2.08549 14.2213 2.24781C14.7599 2.37002 15.0974 2.90571 14.9752 3.4443C14.853 3.9829 14.3173 4.32044 13.7787 4.19823C13.2076 4.06863 12.6124 4 12 4Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.5 3C19.0523 3 19.5 3.44772 19.5 4V4.5H20C20.5523 4.5 21 4.94772 21 5.5C21 6.05228 20.5523 6.5 20 6.5H19.5V7C19.5 7.55228 19.0523 8 18.5 8C17.9477 8 17.5 7.55228 17.5 7V6.5H17C16.4477 6.5 16 6.05228 16 5.5C16 4.94772 16.4477 4.5 17 4.5H17.5V4C17.5 3.44772 17.9477 3 18.5 3Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 8C9.76656 8.00016 9.33568 8.00325 8.98335 8.05062C8.57341 8.10573 8.15946 8.23283 7.82115 8.57114C7.48284 8.90945 7.35575 9.32339 7.30063 9.73334C7.24992 10.1105 7.24996 10.5777 7.25001 11.103L7.25 12.897C7.24996 13.4224 7.24992 13.8896 7.30063 14.2667C7.35574 14.6767 7.48283 15.0906 7.82115 15.4289C8.15946 15.7672 8.5734 15.8943 8.98334 15.9494C9.3605 16.0001 9.82767 16.0001 10.353 16.0001H13.647C14.1723 16.0001 14.6395 16.0001 15.0167 15.9494C15.4266 15.8943 15.8405 15.7672 16.1789 15.4289C16.5172 15.0906 16.6443 14.6767 16.6994 14.2667C16.7501 13.8895 16.75 13.4224 16.75 12.897L16.75 11.103C16.7501 10.5777 16.7501 10.1105 16.6994 9.73334C16.6443 9.32339 16.5172 8.90945 16.1789 8.57114C15.8406 8.23283 15.4266 8.10573 15.0167 8.05062C14.6644 8.00325 14.2335 8.00016 13.75 8L13.75 9.5C13.7501 9.63902 13.7503 9.80888 13.7305 9.95565C13.7065 10.1341 13.6417 10.3856 13.4279 10.5995C13.214 10.8133 12.9625 10.8782 12.784 10.9022C12.6372 10.9219 12.4674 10.9218 12.3284 10.9217H11.6717C11.5327 10.9218 11.3628 10.9219 11.2161 10.9022C11.0376 10.8782 10.786 10.8133 10.5722 10.5995C10.3584 10.3856 10.2935 10.1341 10.2695 9.95565C10.2498 9.80888 10.2499 9.63902 10.25 9.5L10.25 8Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-delivery-circle-add": {
        defaultColors: ["#323232", "#000000"],
        keywords: ["plus","add","create","new","increase","more","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9062 5.5H17.0938"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 4.09375V6.90625"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-checkmark-2": {
        defaultColors: ["#323232", "#cdd1d8", "#000000"],
        keywords: ["box","package","checkmark","check","tick","delivered","delivery","order-received","received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5.75L18.25 7L20.25 5"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    fill={colors?.[1] || "#CDD1D8"}
                    stroke={colors?.[1] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V8.5H11V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-checkmark-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","checkmark","approved","order-received","order-fulfilled","shipment","verified","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.3876 19.9314 10.7924 19.8018 10.2213C19.6796 9.68269 20.0171 9.147 20.5557 9.02479C21.0943 8.90258 21.63 9.24012 21.7522 9.77871C21.9145 10.4941 22 11.2377 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.7623 2 13.5059 2.08549 14.2213 2.24781C14.7599 2.37002 15.0974 2.90571 14.9752 3.4443C14.853 3.9829 14.3173 4.32044 13.7787 4.19823C13.2076 4.06863 12.6124 4 12 4Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.9571 4.29289C21.3476 4.68342 21.3476 5.31658 20.9571 5.70711L18.9571 7.70711C18.5666 8.09763 17.9334 8.09763 17.5429 7.70711L16.2929 6.45711C15.9024 6.06658 15.9024 5.43342 16.2929 5.04289C16.6834 4.65237 17.3166 4.65237 17.7071 5.04289L18.25 5.58579L19.5429 4.29289C19.9334 3.90237 20.5666 3.90237 20.9571 4.29289Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 8C9.76656 8.00016 9.33568 8.00325 8.98335 8.05062C8.57341 8.10573 8.15946 8.23283 7.82115 8.57114C7.48284 8.90945 7.35575 9.32339 7.30063 9.73334C7.24992 10.1105 7.24996 10.5777 7.25001 11.103L7.25 12.897C7.24996 13.4224 7.24992 13.8896 7.30063 14.2667C7.35574 14.6767 7.48283 15.0906 7.82115 15.4289C8.15946 15.7672 8.5734 15.8943 8.98334 15.9494C9.3605 16.0001 9.82767 16.0001 10.353 16.0001H13.647C14.1723 16.0001 14.6395 16.0001 15.0167 15.9494C15.4266 15.8943 15.8405 15.7672 16.1789 15.4289C16.5172 15.0906 16.6443 14.6767 16.6994 14.2667C16.7501 13.8895 16.75 13.4224 16.75 12.897L16.75 11.103C16.7501 10.5777 16.7501 10.1105 16.6994 9.73334C16.6443 9.32339 16.5172 8.90945 16.1789 8.57114C15.8406 8.23283 15.4266 8.10573 15.0167 8.05062C14.6644 8.00325 14.2335 8.00016 13.75 8L13.75 9.5C13.7501 9.63902 13.7503 9.80888 13.7305 9.95565C13.7065 10.1341 13.6417 10.3856 13.4279 10.5995C13.214 10.8133 12.9625 10.8782 12.784 10.9022C12.6372 10.9219 12.4674 10.9218 12.3284 10.9217H11.6717C11.5327 10.9218 11.3628 10.9219 11.2161 10.9022C11.0376 10.8782 10.786 10.8133 10.5722 10.5995C10.3584 10.3856 10.2935 10.1341 10.2695 9.95565C10.2498 9.80888 10.2499 9.63902 10.25 9.5L10.25 8Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-delivery-circle-checkmark-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","package","delivery","checkmark","complete","order-complete","delivery-complete","confirmed","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5.75L18.25 7L20.25 5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-delivery-circle-checkmark": {
        defaultColors: ["#323232", "#000000"],
        keywords: ["checkmark","check","confirm","complete","verified","approved","done","success","order-received","payment-received","order-confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5.75L18.25 7L20.25 5"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-cross-2": {
        defaultColors: ["#323232", "#cdd1d8", "#000000"],
        keywords: ["box","package","remove","delete","cancel","void","cross","item","remove-item","delete-item","cancel-item","void-item","order","remove-order","delete-order","cancel-order","void-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.75 4.25L17.25 6.75"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.25 4.25L19.75 6.75"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    fill={colors?.[1] || "#CDD1D8"}
                    stroke={colors?.[1] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V8.5H11V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-cross": {
        defaultColors: ["#323232", "#000000"],
        keywords: ["cancel","remove","delete","cross","error","close","exit","void","refund","reject","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.75 4.25L17.25 6.75"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.25 4.25L19.75 6.75"
                    stroke={colors?.[0] || "#323232"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-cross-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","cancel","remove","cross","error","failed-delivery","problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.3876 19.9314 10.7924 19.8018 10.2213C19.6796 9.68269 20.0171 9.147 20.5557 9.02479C21.0943 8.90258 21.63 9.24012 21.7522 9.77871C21.9145 10.4941 22 11.2377 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.7623 2 13.5059 2.08549 14.2213 2.24781C14.7599 2.37002 15.0974 2.90571 14.9752 3.4443C14.853 3.9829 14.3173 4.32044 13.7787 4.19823C13.2076 4.06863 12.6124 4 12 4Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5429 3.54289C16.9334 3.15237 17.5666 3.15237 17.9571 3.54289L18.5 4.08579L19.0429 3.54289C19.4334 3.15237 20.0666 3.15237 20.4571 3.54289C20.8476 3.93342 20.8476 4.56658 20.4571 4.95711L19.9142 5.5L20.4571 6.04289C20.8476 6.43342 20.8476 7.06658 20.4571 7.45711C20.0666 7.84763 19.4334 7.84763 19.0429 7.45711L18.5 6.91421L17.9571 7.45711C17.5666 7.84763 16.9334 7.84763 16.5429 7.45711C16.1524 7.06658 16.1524 6.43342 16.5429 6.04289L17.0858 5.5L16.5429 4.95711C16.1524 4.56658 16.1524 3.93342 16.5429 3.54289Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 8C9.76656 8.00016 9.33568 8.00325 8.98335 8.05062C8.57341 8.10573 8.15946 8.23283 7.82115 8.57114C7.48284 8.90945 7.35575 9.32339 7.30063 9.73334C7.24992 10.1105 7.24996 10.5777 7.25001 11.103L7.25 12.897C7.24996 13.4224 7.24992 13.8896 7.30063 14.2667C7.35574 14.6767 7.48283 15.0906 7.82115 15.4289C8.15946 15.7672 8.5734 15.8943 8.98334 15.9494C9.3605 16.0001 9.82767 16.0001 10.353 16.0001H13.647C14.1723 16.0001 14.6395 16.0001 15.0167 15.9494C15.4266 15.8943 15.8405 15.7672 16.1789 15.4289C16.5172 15.0906 16.6443 14.6767 16.6994 14.2667C16.7501 13.8895 16.75 13.4224 16.75 12.897L16.75 11.103C16.7501 10.5777 16.7501 10.1105 16.6994 9.73334C16.6443 9.32339 16.5172 8.90945 16.1789 8.57114C15.8406 8.23283 15.4266 8.10573 15.0167 8.05062C14.6644 8.00325 14.2335 8.00016 13.75 8L13.75 9.5C13.7501 9.63902 13.7503 9.80888 13.7305 9.95565C13.7065 10.1341 13.6417 10.3856 13.4279 10.5995C13.214 10.8133 12.9625 10.8782 12.784 10.9022C12.6372 10.9219 12.4674 10.9218 12.3284 10.9217H11.6717C11.5327 10.9218 11.3628 10.9219 11.2161 10.9022C11.0376 10.8782 10.786 10.8133 10.5722 10.5995C10.3584 10.3856 10.2935 10.1341 10.2695 9.95565C10.2498 9.80888 10.2499 9.63902 10.25 9.5L10.25 8Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-delivery-circle": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipping","order","transport","circle","completed","confirmed","sent","arrival"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-full-open-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","open","package","delivery","inventory","shipping","unpack","empty-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L12 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V15.2358C5 16.774 5 17.5431 5.43992 18.0916C5.87983 18.64 6.63065 18.8068 8.13228 19.1405L11.1323 19.8072C11.5644 19.9032 11.7805 19.9512 12 19.9512C12.2195 19.9512 12.4356 19.9032 12.8677 19.8072L15.8677 19.1405C17.3694 18.8068 18.1202 18.64 18.5601 18.0916C19 17.5431 19 16.774 19 15.2358V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11L5 9M12 11L11.4846 12.0308C10.7745 13.4509 10.4195 14.161 9.75878 14.4517C9.09806 14.7423 8.33472 14.5242 6.80802 14.088L5.31713 13.662C4.24373 13.3554 3.70703 13.202 3.51794 12.7722C3.32885 12.3423 3.57847 11.8431 4.07772 10.8446L5 9M12 11V11C12.8441 12.6883 13.2662 13.5324 13.9875 13.9802C14.2277 14.1294 14.4879 14.2438 14.7602 14.3201C15.5777 14.5492 16.4852 14.29 18.3001 13.7714L18.7171 13.6522C19.7576 13.355 20.2778 13.2063 20.4713 12.7958C20.4787 12.7801 20.4857 12.7643 20.4922 12.7482C20.6641 12.3282 20.4221 11.8443 19.9382 10.8764L19 9M12 11L19 9M5 9L11.4506 7.15698C11.7235 7.079 11.8599 7.04002 12 7.04002C12.1401 7.04002 12.2765 7.079 12.5494 7.15698L19 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L17.6556 8.61589C18.237 8.782 18.5277 8.86505 18.7943 8.79412C18.8691 8.77422 18.9413 8.74569 19.0096 8.70912C19.2527 8.57879 19.4083 8.31956 19.7194 7.80108V7.80108C20.2442 6.92638 20.5066 6.48903 20.4131 6.09334C20.3876 5.98512 20.3442 5.88192 20.2846 5.78798C20.067 5.44453 19.5709 5.3264 18.5786 5.09013L16.7096 4.64515C15.3993 4.33317 14.7441 4.17718 14.1599 4.40683C13.5757 4.63647 13.2021 5.19684 12.455 6.31757L12 7ZM12 7V7C11.1902 5.78529 10.7853 5.17794 10.2082 4.83105C9.92178 4.65889 9.60862 4.53579 9.28163 4.46684C8.62279 4.32791 7.91269 4.49698 6.4925 4.83512L5.42145 5.09013C4.42912 5.3264 3.93295 5.44454 3.71536 5.78799C3.65585 5.88192 3.61242 5.98512 3.58686 6.09334C3.49342 6.48903 3.75583 6.92638 4.28065 7.80108V7.80108C4.59173 8.31956 4.74728 8.57879 4.99042 8.70912C5.05865 8.74569 5.1309 8.77422 5.20572 8.79412C5.47231 8.86506 5.76299 8.782 6.34437 8.61589L12 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-full-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","open","package","inventory","stock","shipment","delivery","unpack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.36493 16.1087C7.79753 16.0177 7.13059 15.8254 6.44373 15.6231C6.41387 15.6231 6.38401 15.6028 6.3641 15.6028L4.88089 15.1677C4.88089 15.1677 4.83112 15.1475 4.80126 15.1475C4.64199 15.0969 4.46281 15.0463 4.30354 14.9957V15.107C4.30354 15.8457 4.30354 16.473 4.36326 16.9688C4.42299 17.505 4.56235 17.9907 4.9008 18.4258C5.23925 18.8507 5.67724 19.1037 6.17496 19.2757C6.64282 19.4477 7.24008 19.5793 7.9568 19.7411L11.0526 20.4393C11.1323 20.4595 11.192 20.4697 11.2716 20.4798V15.3701C11.0427 15.5623 10.7938 15.7445 10.4852 15.876C9.73864 16.2099 9.01197 16.1998 8.36493 16.0986V16.1087Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.1754 15.1677L18.6876 15.3094C17.8515 15.5522 17.0949 15.7748 16.4579 15.8861C15.771 16.0177 15.0443 16.0581 14.2878 15.8457C13.8598 15.7242 13.4516 15.5421 13.0734 15.2993C12.9639 15.2284 12.8643 15.1374 12.7648 15.0666V20.5C12.8345 20.4798 12.9041 20.4696 12.9838 20.4595L16.0796 19.7614C16.7864 19.5995 17.3836 19.4679 17.8614 19.2959C18.3591 19.1138 18.7971 18.871 19.1356 18.446C19.474 18.0211 19.6134 17.5253 19.6731 16.989C19.7329 16.4831 19.7329 15.8659 19.7329 15.1273V15.016C19.5736 15.0666 19.4143 15.1171 19.265 15.1576C19.2351 15.1576 19.2152 15.1779 19.1854 15.1779L19.1754 15.1677Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.9075 11.6466C20.798 11.3127 20.5989 10.9181 20.3799 10.4628L20.1709 10.0378V10.0075C19.9917 9.67358 19.8523 9.38015 19.703 9.15755C19.6134 9.02602 19.5238 8.9046 19.4044 8.80342C19.5338 8.70224 19.6333 8.59094 19.7229 8.4594C19.8424 8.28739 19.9718 8.07491 20.1211 7.83208L20.141 7.7916C20.3899 7.37676 20.5989 7.02262 20.7283 6.71908C20.8677 6.40542 20.9573 6.07152 20.8677 5.71738C20.8279 5.55549 20.7681 5.3936 20.6786 5.25195C20.4894 4.93829 20.1908 4.7764 19.8723 4.65498C19.5736 4.54368 19.1754 4.4425 18.7076 4.3312L16.7864 3.86576C16.1593 3.71399 15.6416 3.59257 15.2235 3.53186C14.7756 3.47115 14.3774 3.49139 13.9792 3.64316C13.5811 3.79493 13.2824 4.06813 12.9938 4.41214C12.715 4.74604 12.4264 5.19124 12.068 5.73762L12.0083 5.81856C11.7893 5.49478 11.6001 5.22159 11.421 4.98888C11.1323 4.61451 10.8436 4.32108 10.4853 4.09848C10.1568 3.89612 9.78845 3.75446 9.41018 3.67352C9.00205 3.58245 8.59392 3.60269 8.12606 3.67352C7.66816 3.74434 7.12067 3.87588 6.43382 4.04789L5.34879 4.31096H5.31892C4.85107 4.43238 4.45289 4.52344 4.15426 4.64486C3.83572 4.76628 3.53709 4.92817 3.34795 5.24183C3.25836 5.38348 3.19864 5.54537 3.15882 5.70727C3.07918 6.0614 3.15882 6.3953 3.29818 6.70896C3.42759 7.01251 3.63663 7.36664 3.88549 7.78149L3.89544 7.81184V7.83208C4.05471 8.07491 4.17417 8.29751 4.30357 8.4594C4.39316 8.58082 4.49271 8.70224 4.62212 8.80342C4.50266 8.9046 4.41307 9.02602 4.32348 9.15755C4.17417 9.38015 4.03481 9.67358 3.86558 10.0075L3.65654 10.4324C3.41763 10.908 3.21855 11.3127 3.10905 11.6567C2.98959 12.021 2.93982 12.3954 3.10905 12.7799C3.27827 13.1643 3.58686 13.3768 3.92531 13.5387C4.03481 13.5893 4.16421 13.6298 4.29362 13.6804C4.55243 13.7714 4.84111 13.8625 5.17956 13.9637L6.73245 14.4089C7.46907 14.6214 8.05638 14.7934 8.5541 14.8743C9.07173 14.9553 9.52963 14.9451 9.97758 14.7428C10.4255 14.5404 10.7441 14.2065 11.0327 13.7613C11.1124 13.65 11.1821 13.4982 11.2617 13.3566C11.4707 12.9923 11.6798 12.5876 11.9286 12.0817L12.0083 11.9097C12.2273 12.3448 12.4264 12.7191 12.6155 13.0328C12.6553 13.1036 12.7051 13.1542 12.7449 13.2149C13.0236 13.6399 13.3223 13.9839 13.7105 14.2267C13.7204 14.2267 13.7304 14.2369 13.7403 14.247C14.0091 14.4089 14.2978 14.5404 14.5964 14.6315C15.1041 14.7731 15.6118 14.7529 16.209 14.6517C16.7864 14.5404 17.4832 14.338 18.3691 14.0851L18.8469 13.9434C19.1754 13.8524 19.4542 13.7613 19.703 13.6702C19.7926 13.6399 19.8922 13.6095 19.9718 13.5691C20.0017 13.5589 20.0415 13.5488 20.0713 13.5286C20.141 13.4982 20.2007 13.4679 20.2605 13.4274C20.5193 13.2858 20.7383 13.0935 20.8776 12.8001C20.8876 12.7799 20.8976 12.7495 20.9075 12.7293C21.0568 12.3549 21.0071 11.9906 20.8876 11.6365L20.9075 11.6466ZM12.3965 10.139L12.0182 10.2503L11.64 10.139L6.86185 8.75283L9.13146 8.09515L12.0182 7.25534L14.905 8.09515L17.1746 8.75283L12.3965 10.139Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-full-open-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","open","package","inventory","shipping","delivery","products","items","stock","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15.2358V13V12.0172C5 10.565 5 9.83888 5.4033 9.30421C5.80661 8.76954 6.50478 8.57006 7.90112 8.17111L10.7652 7.3528C11.3775 7.17784 11.6837 7.09036 11.9967 7.1005C12.3098 7.11063 12.6096 7.21773 13.2094 7.43193L16.3453 8.55191C17.6282 9.01008 18.2697 9.23917 18.6348 9.75734C19 10.2755 19 10.9566 19 12.3189V13V15.2358C19 16.774 19 17.5431 18.5601 18.0916C18.1202 18.64 17.3694 18.8068 15.8677 19.1405L12.8677 19.8072C12.4356 19.9032 12.2195 19.9512 12 19.9512C11.7805 19.9512 11.5644 19.9032 11.1323 19.8072L8.13228 19.1405C6.63065 18.8068 5.87983 18.64 5.43992 18.0916C5 17.5431 5 16.774 5 15.2358Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11L12 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L6.59599 9.456C5.83264 9.2379 5.45097 9.12885 5.12061 9.27417C4.79025 9.4195 4.61273 9.77454 4.25769 10.4846L4.07772 10.8446C3.57847 11.8431 3.32885 12.3423 3.51794 12.7722C3.70703 13.202 4.24373 13.3554 5.31713 13.662L6.80802 14.088C8.33471 14.5242 9.09806 14.7423 9.75878 14.4517C10.4195 14.161 10.7745 13.4509 11.4846 12.0308L12 11C12.8441 12.6883 13.2662 13.5324 13.9875 13.9802C14.2277 14.1294 14.4879 14.2438 14.7602 14.3201C15.5777 14.5492 16.4852 14.29 18.3001 13.7714L18.7171 13.6522C19.7576 13.355 20.2778 13.2063 20.4713 12.7958C20.4787 12.7801 20.4857 12.7643 20.4922 12.7482C20.6641 12.3282 20.4221 11.8443 19.9382 10.8764L19.7423 10.4846C19.3873 9.77454 19.2097 9.4195 18.8794 9.27418C18.549 9.12885 18.1674 9.2379 17.404 9.456L12 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 11L6.59599 9.456C5.83264 9.2379 5.45097 9.12885 5.12061 9.27417C4.79025 9.4195 4.61273 9.77454 4.25769 10.4846L4.07772 10.8446C3.57847 11.8431 3.32885 12.3423 3.51794 12.7722C3.70703 13.202 4.24373 13.3554 5.31713 13.662L6.80802 14.088C8.33472 14.5242 9.09806 14.7423 9.75878 14.4517C10.4195 14.161 10.7745 13.4509 11.4846 12.0308L12 11ZM12 11V11C12.8441 12.6883 13.2662 13.5324 13.9875 13.9802C14.2277 14.1294 14.4879 14.2438 14.7602 14.3201C15.5777 14.5492 16.4852 14.29 18.3001 13.7714L18.7171 13.6522C19.7576 13.355 20.2778 13.2063 20.4713 12.7958C20.4787 12.7801 20.4857 12.7643 20.4922 12.7482C20.6641 12.3282 20.4221 11.8443 19.9382 10.8764L19.7423 10.4846C19.3873 9.77454 19.2098 9.4195 18.8794 9.27418C18.549 9.12885 18.1674 9.2379 17.404 9.456L12 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L17.6556 8.61589C18.237 8.782 18.5277 8.86505 18.7943 8.79412C18.8691 8.77422 18.9413 8.74569 19.0096 8.70912C19.2527 8.57879 19.4083 8.31956 19.7194 7.80108C20.2442 6.92638 20.5066 6.48903 20.4131 6.09334C20.3876 5.98512 20.3442 5.88192 20.2846 5.78798C20.067 5.44453 19.5709 5.3264 18.5786 5.09013L16.7096 4.64515C15.3993 4.33317 14.7441 4.17718 14.1599 4.40683C13.5757 4.63647 13.2021 5.19684 12.455 6.31757L12 7C11.1902 5.78529 10.7853 5.17794 10.2082 4.83105C9.92178 4.65889 9.60862 4.53579 9.28163 4.46684C8.62279 4.32791 7.91269 4.49698 6.4925 4.83512L5.42144 5.09013C4.42912 5.3264 3.93295 5.44454 3.71536 5.78799C3.65585 5.88192 3.61242 5.98512 3.58686 6.09334C3.49342 6.48903 3.75583 6.92638 4.28065 7.80108C4.59173 8.31956 4.74728 8.57879 4.99042 8.70912C5.05865 8.74569 5.1309 8.77422 5.20571 8.79412C5.47231 8.86506 5.76299 8.782 6.34437 8.61589L12 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 7L17.6556 8.61589C18.237 8.782 18.5277 8.86505 18.7943 8.79412C18.8691 8.77422 18.9413 8.74569 19.0096 8.70912C19.2527 8.57879 19.4083 8.31956 19.7194 7.80108V7.80108C20.2442 6.92638 20.5066 6.48903 20.4131 6.09334C20.3876 5.98512 20.3442 5.88192 20.2846 5.78798C20.067 5.44453 19.5709 5.3264 18.5786 5.09013L16.7096 4.64515C15.3993 4.33317 14.7441 4.17718 14.1599 4.40683C13.5757 4.63647 13.2021 5.19684 12.455 6.31757L12 7ZM12 7V7C11.1902 5.78529 10.7853 5.17794 10.2082 4.83105C9.92178 4.65889 9.60862 4.53579 9.28163 4.46684C8.62279 4.32791 7.91269 4.49698 6.4925 4.83512L5.42145 5.09013C4.42912 5.3264 3.93295 5.44454 3.71536 5.78799C3.65585 5.88192 3.61242 5.98512 3.58686 6.09334C3.49342 6.48903 3.75583 6.92638 4.28065 7.80108V7.80108C4.59173 8.31956 4.74728 8.57879 4.99042 8.70912C5.05865 8.74569 5.1309 8.77422 5.20572 8.79412C5.47231 8.86506 5.76299 8.782 6.34437 8.61589L12 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-full-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","open","package","inventory","shipping","receiving","stock","empty","items","products","order-received","unpack","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L12 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V15.2358C5 16.774 5 17.5431 5.43992 18.0916C5.87983 18.64 6.63065 18.8068 8.13228 19.1405L11.1323 19.8072C11.5644 19.9032 11.7805 19.9512 12 19.9512C12.2195 19.9512 12.4356 19.9032 12.8677 19.8072L15.8677 19.1405C17.3694 18.8068 18.1202 18.64 18.5601 18.0916C19 17.5431 19 16.774 19 15.2358V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11L5 9M12 11L11.4846 12.0308C10.7745 13.4509 10.4195 14.161 9.75878 14.4517C9.09806 14.7423 8.33472 14.5242 6.80802 14.088L5.31713 13.662C4.24373 13.3554 3.70703 13.202 3.51794 12.7722C3.32885 12.3423 3.57847 11.8431 4.07772 10.8446L5 9M12 11V11C12.8441 12.6883 13.2662 13.5324 13.9875 13.9802C14.2277 14.1294 14.4879 14.2438 14.7602 14.3201C15.5777 14.5492 16.4852 14.29 18.3001 13.7714L18.7171 13.6522C19.7576 13.355 20.2778 13.2063 20.4713 12.7958C20.4787 12.7801 20.4857 12.7643 20.4922 12.7482C20.6641 12.3282 20.4221 11.8443 19.9382 10.8764L19 9M12 11L19 9M5 9L11.4506 7.15698C11.7235 7.079 11.8599 7.04002 12 7.04002C12.1401 7.04002 12.2765 7.079 12.5494 7.15698L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L17.6556 8.61589C18.237 8.782 18.5277 8.86505 18.7943 8.79412C18.8691 8.77422 18.9413 8.74569 19.0096 8.70912C19.2527 8.57879 19.4083 8.31956 19.7194 7.80108V7.80108C20.2442 6.92638 20.5066 6.48903 20.4131 6.09334C20.3876 5.98512 20.3442 5.88192 20.2846 5.78798C20.067 5.44453 19.5709 5.3264 18.5786 5.09013L16.7096 4.64515C15.3993 4.33317 14.7441 4.17718 14.1599 4.40683C13.5757 4.63647 13.2021 5.19684 12.455 6.31757L12 7ZM12 7V7C11.1902 5.78529 10.7853 5.17794 10.2082 4.83105C9.92178 4.65889 9.60862 4.53579 9.28163 4.46684C8.62279 4.32791 7.91269 4.49698 6.4925 4.83512L5.42145 5.09013C4.42912 5.3264 3.93295 5.44454 3.71536 5.78799C3.65585 5.88192 3.61242 5.98512 3.58686 6.09334C3.49342 6.48903 3.75583 6.92638 4.28065 7.80108V7.80108C4.59173 8.31956 4.74728 8.57879 4.99042 8.70912C5.05865 8.74569 5.1309 8.77422 5.20572 8.79412C5.47231 8.86506 5.76299 8.782 6.34437 8.61589L12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-half-storage-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["layer","stack","inventory","group","grouping","category","product-group","menu-categories","tiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13L5 10L12 7L19 10L12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14L12 17L19 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-delivery-circle-cross-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cross","remove","delete","cancel","error","close","reject","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5 3.35177C13.7063 3.12273 12.8675 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.1325 20.8773 10.2937 20.6482 9.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.75 4.25L17.25 6.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.25 4.25L19.75 6.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13.1V10.9C8 9.76863 8 9.20294 8.35147 8.85147C8.70294 8.5 9.26863 8.5 10.4 8.5H13.6C14.7314 8.5 15.2971 8.5 15.6485 8.85147C16 9.20294 16 9.76863 16 10.9V13.1C16 14.2314 16 14.7971 15.6485 15.1485C15.2971 15.5 14.7314 15.5 13.6 15.5H12H10.4C9.26863 15.5 8.70294 15.5 8.35147 15.1485C8 14.7971 8 14.2314 8 13.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10.5H12.3C12.63 10.5 12.795 10.5 12.8975 10.3975C13 10.295 13 10.13 13 9.8V9.2C13 8.87002 13 8.70503 12.8975 8.60251C12.795 8.5 12.63 8.5 12.3 8.5H11.7C11.37 8.5 11.205 8.5 11.1025 8.60251C11 8.70503 11 8.87002 11 9.2V9.8C11 10.13 11 10.295 11.1025 10.3975C11.205 10.5 11.37 10.5 11.7 10.5H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-half-storage-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layer","stack","levels","inventory","storage","organization","group","grouping","tier","tiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3937 6.08085C12.1421 5.97305 11.8574 5.97305 11.6058 6.08085L4.60585 9.08085C4.23817 9.23843 3.99977 9.59997 3.99977 10C3.99977 10.4 4.23817 10.7616 4.60585 10.9191L11.6058 13.9191C11.8574 14.027 12.1421 14.027 12.3937 13.9191L19.3937 10.9191C19.7614 10.7616 19.9998 10.4 19.9998 10C19.9998 9.59997 19.7614 9.23843 19.3937 9.08085L12.3937 6.08085Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.08062 13.6061C4.29818 13.0985 4.88606 12.8633 5.39369 13.0809L11.9998 15.912L18.6058 13.0809C19.1135 12.8633 19.7014 13.0985 19.9189 13.6061C20.1365 14.1137 19.9013 14.7016 19.3937 14.9191L12.3937 17.9191C12.1421 18.027 11.8574 18.027 11.6058 17.9191L4.60585 14.9191C4.09822 14.7016 3.86307 14.1137 4.08062 13.6061Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-half-storage-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["layers","stack","inventory","storage","organization","grouping","tiers","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13L5 10L12 7L19 10L12 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14L12 17L19 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-half-storage": {
        defaultColors: ["#3D4C66"],
        keywords: ["layers","inventory","stock","storage","organization","group","grouping","stack","tiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13L5 10L12 7L19 10L12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14L12 17L19 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-label": {
        defaultColors: ["#000000"],
        keywords: ["box","package","label","inventory","stock","product","item","container","storage","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M10 16L6 16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-label-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","shipping","delivery","inventory","item","product","label","box-label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16L6 16" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "box-label-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","label","inventory","product","stock","item","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.921 4.25H9.07897C8.36668 4.24998 7.76639 4.24996 7.27886 4.30826C6.76124 4.37015 6.28817 4.5053 5.86918 4.83244C5.45019 5.15958 5.20434 5.58575 5.01875 6.0729C4.84394 6.53174 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H19.5856L19.4744 7.80514C19.3016 7.11408 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.921 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25001 15.052L4.25 9.75H8.24999C8.24998 10.1222 8.24998 10.1539 8.27179 10.4152C8.29398 10.6811 8.34463 10.9882 8.51873 11.265C8.81548 11.7367 9.31917 12.0389 9.87504 12.0786C10.2012 12.102 10.496 12.0021 10.741 11.8965C10.982 11.7927 11.2693 11.6394 11.5983 11.4639L11.6252 11.4496C11.7566 11.3794 11.831 11.34 11.8886 11.3129C11.9247 11.296 11.94 11.2907 11.944 11.2895C11.9802 11.2813 12.0179 11.2813 12.0542 11.2894C12.0584 11.2907 12.0741 11.2961 12.1099 11.3129C12.1675 11.34 12.242 11.3794 12.3735 11.4495L12.4003 11.4639C12.73 11.6397 13.018 11.7932 13.2594 11.8971C13.505 12.0028 13.8004 12.1027 14.1271 12.0789C14.6815 12.0386 15.1839 11.7371 15.4804 11.2669C15.655 10.9898 15.7059 10.6822 15.7281 10.4158C15.75 10.1541 15.75 10.1235 15.75 9.75066L19.75 9.75L19.75 15.052C19.75 15.9505 19.7501 16.6997 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9445C18.4891 19.4 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70553 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6997 4.24998 15.9505 4.25001 15.052ZM6.5 15.25C6.08579 15.25 5.75 15.5858 5.75 16C5.75 16.4142 6.08579 16.75 6.5 16.75H10C10.4142 16.75 10.75 16.4142 10.75 16C10.75 15.5858 10.4142 15.25 10 15.25H6.5Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "Box-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","inventory","product","item","storage","container","archive","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-label-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["label","tag","price","discount","item","product","information","description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16L6 16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","storage","container","inventory","stock","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.4C5 9.21144 5 9.11716 5.05858 9.05858C5.11716 9 5.21144 9 5.4 9H18.6C18.7886 9 18.8828 9 18.9414 9.05858C19 9.11716 19 9.21144 19 9.4V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-line-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","remove","subtract","package","order","remove-order","delete","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 15L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-line-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","remove","subtract","order","remove-order","delete-order","minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 15L10 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Box-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","container","storage","inventory","stock","product","item","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9209 4.25H9.07887C8.36659 4.24998 7.76628 4.24996 7.27876 4.30826C6.76114 4.37015 6.28807 4.5053 5.86908 4.83244C5.45009 5.15958 5.20424 5.58575 5.01865 6.0729C4.84384 6.53175 4.69828 7.11408 4.52554 7.80513L4.41433 8.25H19.5855L19.4743 7.80514C19.3015 7.11409 19.156 6.53175 18.9812 6.0729C18.7956 5.58575 18.5497 5.15958 18.1307 4.83244C17.7117 4.5053 17.2387 4.37015 16.7211 4.30826C16.2335 4.24996 15.6332 4.24998 14.9209 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.25 15.052L4.25 9.75H11.25V14C11.25 14.4142 11.5858 14.75 12 14.75C12.4142 14.75 12.75 14.4142 12.75 14V9.75H19.75L19.75 15.052C19.75 15.9505 19.7501 16.6998 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9446C18.4891 19.4001 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.7501 15.052 19.7501H8.94801C8.04954 19.7501 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4001 5.05546 18.9446C4.59999 18.4891 4.41432 17.9223 4.32992 17.2945C4.24995 16.6998 4.24997 15.9505 4.25 15.052Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-line-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["drawer","box","remove","subtract","storage","inventory","remove-item","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.4C5 9.21144 5 9.11716 5.05858 9.05858C5.11716 9 5.21144 9 5.4 9H18.6C18.7886 9 18.8828 9 18.9414 9.05858C19 9.11716 19 9.21144 19 9.4V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.6364 9H5.36364C5.21017 9 5.13343 9 5.08014 8.96011C5.06488 8.94868 5.05132 8.93512 5.03989 8.91986C5 8.86657 5 8.78983 5 8.63636C5 7.10168 5 6.33434 5.39892 5.80144C5.51321 5.64876 5.64876 5.51321 5.80144 5.39892C6.33434 5 7.10168 5 8.63636 5H15.3636C16.8983 5 17.6657 5 18.1986 5.39892C18.3512 5.51321 18.4868 5.64876 18.6011 5.80144C19 6.33434 19 7.10168 19 8.63636C19 8.78983 19 8.86657 18.9601 8.91986C18.9487 8.93512 18.9351 8.94868 18.9199 8.96011C18.8666 9 18.7898 9 18.6364 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 15L10 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-line-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","drawer","storage","archive","inventory","products","organized","filing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7499 9.96077L19.75 9.75H4.25L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052L19.75 10.0354L19.75 10.0167C19.75 10 19.7501 9.98116 19.7499 9.96077ZM9.99996 14.25C9.58574 14.25 9.24996 14.5858 9.24996 15C9.24996 15.4142 9.58574 15.75 9.99996 15.75H14C14.4142 15.75 14.75 15.4142 14.75 15C14.75 14.5858 14.4142 14.25 14 14.25H9.99996Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.25022 8.25H19.7498C19.7486 7.6691 19.7413 7.17317 19.6956 6.76068C19.6385 6.24492 19.5139 5.76936 19.2015 5.35199C19.0443 5.14205 18.858 4.95567 18.648 4.79851C18.2306 4.48607 17.7551 4.36154 17.2393 4.30442C16.7476 4.24997 16.1372 4.24998 15.4057 4.25H8.59436C7.86282 4.24998 7.25244 4.24997 6.76068 4.30442C6.24492 4.36154 5.76936 4.48607 5.35199 4.79851C5.14205 4.95567 4.95567 5.14205 4.79851 5.35199C4.48607 5.76936 4.36154 6.24492 4.30442 6.76068C4.25875 7.17317 4.25139 7.6691 4.25022 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","shipping","delivery","inventory","item","product","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","open","inventory","package","deliveries","stock","container","shipment","products","receiving","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9H6.23607C5.63466 9 5.33395 9 5.0923 8.85065C4.85065 8.7013 4.71617 8.43234 4.44721 7.89443V7.89443C3.79858 6.59717 3.47427 5.94854 3.76738 5.47427C4.0605 5 4.78569 5 6.23607 5H6.52786C7.73068 5 8.33209 5 8.81539 5.2987C9.2987 5.5974 9.56766 6.13531 10.1056 7.21115L11 9ZM11 9H17.7639C18.3653 9 18.666 9 18.9077 8.85065C19.1493 8.7013 19.2838 8.43234 19.5528 7.89443V7.89443C20.2014 6.59717 20.5257 5.94854 20.2326 5.47427C19.9395 5 19.2143 5 17.7639 5H16.7082C14.904 5 14.0019 5 13.2769 5.44805C12.552 5.8961 12.1485 6.70297 11.3416 8.31672L11 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-10": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","inventory","storage","container","warehouse","stock","shipment","products","items","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.52388 4.25C5.18131 4.24996 4.86126 4.24992 4.59479 4.28179C4.29857 4.31721 3.98705 4.39941 3.70369 4.62065C3.42033 4.84189 3.26504 5.12417 3.15883 5.40295C3.06329 5.65374 2.9857 5.96424 2.90266 6.29659L2.88102 6.38313C2.74876 6.91196 2.6303 7.38558 2.59081 7.77407C2.54808 8.19437 2.57959 8.66493 2.9013 9.07698C3.22302 9.48902 3.67189 9.63372 4.09 9.69421C4.47647 9.75011 4.96467 9.75006 5.50978 9.75001H18.49C19.0351 9.75006 19.5233 9.75011 19.9098 9.69421C20.3279 9.63372 20.7768 9.48902 21.0985 9.07698C21.4202 8.66493 21.4517 8.19437 21.409 7.77407C21.3695 7.38559 21.251 6.91198 21.1188 6.38316L21.0971 6.2966C21.0141 5.96425 20.9365 5.65374 20.8409 5.40295C20.7347 5.12417 20.5794 4.84189 20.2961 4.62065C20.0127 4.39941 19.7012 4.31721 19.405 4.28179C19.1385 4.24992 18.8185 4.24996 18.4759 4.25H5.52388Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.24988 10.75L4.24988 15.052C4.24985 15.9504 4.24983 16.6997 4.32979 17.2945C4.4142 17.9223 4.59987 18.4891 5.05534 18.9445C5.51081 19.4 6.07761 19.5857 6.7054 19.6701C7.30018 19.7501 8.04939 19.75 8.94786 19.75H15.0519C15.9503 19.75 16.6996 19.7501 17.2944 19.6701C17.9222 19.5857 18.489 19.4 18.9444 18.9445C19.3999 18.4891 19.5856 17.9223 19.67 17.2945C19.7499 16.6997 19.7499 15.9505 19.7499 15.052L19.7499 10.75H4.24988ZM13.2499 16C13.2499 15.5858 13.5857 15.25 13.9999 15.25H15.9999C16.4141 15.25 16.7499 15.5858 16.7499 16C16.7499 16.4142 16.4141 16.75 15.9999 16.75H13.9999C13.5857 16.75 13.2499 16.4142 13.2499 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-open-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","open","inventory","stock","products","shipping","delivery","items","storage","container","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V11H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3.72147 6.6712L3.38813 8.6712C3.20796 9.75223 3.11788 10.2927 3.41744 10.6464C3.71701 11 4.26498 11 5.36092 11H18.6391C19.735 11 20.283 11 20.5826 10.6464C20.8821 10.2927 20.792 9.75223 20.6119 8.6712L20.2785 6.6712C20.1455 5.87304 20.079 5.47396 19.7992 5.23698C19.5195 5 19.1149 5 18.3057 5H5.69425C4.88508 5 4.4805 5 4.20075 5.23698C3.92101 5.47396 3.85449 5.87304 3.72147 6.6712Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","open","unpack","delivery","received","inventory","stock","products","items","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.4C5 9.21144 5 9.11716 5.05858 9.05858C5.11716 9 5.21144 9 5.4 9H18.6C18.7886 9 18.8828 9 18.9414 9.05858C19 9.11716 19 9.21144 19 9.4V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9H6.23607C5.63466 9 5.33396 9 5.0923 8.85065C4.85065 8.7013 4.71617 8.43234 4.44721 7.89443C3.79858 6.59717 3.47427 5.94854 3.76738 5.47427C4.0605 5 4.78569 5 6.23607 5H6.52786C7.73068 5 8.33209 5 8.81539 5.2987C9.2987 5.5974 9.56766 6.13531 10.1056 7.21115L11 9L11.3416 8.31672C12.1485 6.70297 12.552 5.8961 13.2769 5.44805C14.0019 5 14.904 5 16.7082 5H17.7639C19.2143 5 19.9395 5 20.2326 5.47427C20.5257 5.94854 20.2014 6.59717 19.5528 7.89443C19.2838 8.43234 19.1493 8.7013 18.9077 8.85065C18.666 9 18.3653 9 17.7639 9H11Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M11 9H6.23607C5.63466 9 5.33395 9 5.0923 8.85065C4.85065 8.7013 4.71617 8.43234 4.44721 7.89443V7.89443C3.79858 6.59717 3.47427 5.94854 3.76738 5.47427C4.0605 5 4.78569 5 6.23607 5H6.52786C7.73068 5 8.33209 5 8.81539 5.2987C9.2987 5.5974 9.56766 6.13531 10.1056 7.21115L11 9ZM11 9H17.7639C18.3653 9 18.666 9 18.9077 8.85065C19.1493 8.7013 19.2838 8.43234 19.5528 7.89443V7.89443C20.2014 6.59717 20.5257 5.94854 20.2326 5.47427C19.9395 5 19.2143 5 17.7639 5H16.7082C14.904 5 14.0019 5 13.2769 5.44805C12.552 5.8961 12.1485 6.70297 11.3416 8.31672L11 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","open","empty","inventory","shipment","delivery","stock","products","items","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10V14C5 15.8856 5 16.8284 5.58579 17.4142C6.17157 18 7.11438 18 9 18H15C16.8856 18 17.8284 18 18.4142 17.4142C19 16.8284 19 15.8856 19 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 6L6.23607 6C5.63466 6 5.33396 6 5.0923 6.14935C4.85065 6.2987 4.71617 6.56766 4.44721 7.10557V7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10L6.52786 10C7.73068 10 8.33209 10 8.81539 9.7013C9.2987 9.4026 9.56766 8.86469 10.1056 7.78886L11 6ZM11 6L17.7639 6C18.3653 6 18.666 6 18.9077 6.14935C19.1493 6.2987 19.2838 6.56766 19.5528 7.10557V7.10557C20.2014 8.40283 20.5257 9.05146 20.2326 9.52573C19.9395 10 19.2143 10 17.7639 10L16.7082 10C14.904 10 14.0019 10 13.2769 9.55195C12.552 9.10391 12.1485 8.29703 11.3416 6.68328L11 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","open","package","inventory","stock","shipment","delivery","receiving","products","items","storage","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10V14C5 15.8856 5 16.8284 5.58579 17.4142C6.17157 18 7.11438 18 9 18H15C16.8856 18 17.8284 18 18.4142 17.4142C19 16.8284 19 15.8856 19 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 6L6.23607 6C5.63466 6 5.33396 6 5.0923 6.14935C4.85065 6.2987 4.71617 6.56766 4.44721 7.10557V7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10L6.52786 10C7.73068 10 8.33209 10 8.81539 9.7013C9.2987 9.4026 9.56766 8.86469 10.1056 7.78886L11 6ZM11 6L17.7639 6C18.3653 6 18.666 6 18.9077 6.14935C19.1493 6.2987 19.2838 6.56766 19.5528 7.10557V7.10557C20.2014 8.40283 20.5257 9.05146 20.2326 9.52573C19.9395 10 19.2143 10 17.7639 10L16.7082 10C14.904 10 14.0019 10 13.2769 9.55195C12.552 9.10391 12.1485 8.29703 11.3416 6.68328L11 6Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["store","shop","building","location","business","marketplace","retail","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14V8H19V14C19 15.8856 19 16.8284 18.4142 17.4142C17.8284 18 16.8856 18 15 18H9C7.11438 18 6.17157 18 5.58579 17.4142C5 16.8284 5 15.8856 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 6L6.23607 6C5.63466 6 5.33396 6 5.0923 6.14935C4.85065 6.2987 4.71617 6.56766 4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10L6.52786 10C7.73068 10 8.33209 10 8.81539 9.7013C9.2987 9.4026 9.56766 8.86469 10.1056 7.78886L11 6L11.3416 6.68328C12.1485 8.29703 12.552 9.10391 13.2769 9.55195C14.0019 10 14.904 10 16.7082 10L17.7639 10C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557C19.2838 6.56766 19.1493 6.2987 18.9077 6.14935C18.666 6 18.3653 6 17.7639 6L11 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 6L6.23607 6C5.63466 6 5.33396 6 5.0923 6.14935C4.85065 6.2987 4.71617 6.56766 4.44721 7.10557V7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10L6.52786 10C7.73068 10 8.33209 10 8.81539 9.7013C9.2987 9.4026 9.56766 8.86469 10.1056 7.78886L11 6ZM11 6L17.7639 6C18.3653 6 18.666 6 18.9077 6.14935C19.1493 6.2987 19.2838 6.56766 19.5528 7.10557V7.10557C20.2014 8.40283 20.5257 9.05146 20.2326 9.52573C19.9395 10 19.2143 10 17.7639 10L16.7082 10C14.904 10 14.0019 10 13.2769 9.55195C12.552 9.10391 12.1485 8.29703 11.3416 6.68328L11 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","gift","present","open","package","reward","loyalty","promotion","discount","surprise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.26858 11.05C4.26687 11.0606 4.26537 11.0709 4.26406 11.0807C4.24971 11.1874 4.2499 11.3061 4.25002 11.3814L4.25005 11.4L4.25004 15.052C4.25002 15.9505 4.24999 16.6997 4.32996 17.2945C4.41436 17.9223 4.60003 18.4891 5.0555 18.9446C5.51097 19.4001 6.07777 19.5857 6.70557 19.6701C7.30034 19.7501 8.04955 19.7501 8.94802 19.75H10.25V11.05H4.26858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.75 19.75H15.052C15.9505 19.7501 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4001 18.9446 18.9446C19.4001 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.7501 15.9505 19.75 15.0521L19.75 11.4L19.7501 11.3814C19.7502 11.3061 19.7504 11.1874 19.736 11.0807C19.7347 11.0709 19.7332 11.0606 19.7315 11.05H11.75V19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.17897 4.25C5.50273 4.24995 4.91224 4.2499 4.45754 4.31742C3.97916 4.38846 3.44994 4.56125 3.12935 5.07998C2.80876 5.5987 2.89089 6.14933 3.04129 6.60897C3.18425 7.04587 3.44836 7.57399 3.75083 8.17882L3.79027 8.2577C3.91271 8.50264 4.02864 8.73457 4.14719 8.92088C4.27955 9.1289 4.44701 9.33355 4.69796 9.48864C4.94891 9.64374 5.20684 9.702 5.4521 9.72736C5.67175 9.75007 5.93102 9.75004 6.20485 9.75001H17.795C18.0689 9.75004 18.3282 9.75007 18.5478 9.72736C18.7931 9.702 19.051 9.64374 19.3019 9.48865C19.5529 9.33355 19.7204 9.1289 19.8527 8.92088C19.9713 8.73456 20.0872 8.50263 20.2097 8.25767L20.2491 8.17881C20.5516 7.57399 20.8157 7.04586 20.9586 6.60897C21.109 6.14933 21.1911 5.5987 20.8706 5.07998C20.55 4.56125 20.0207 4.38846 19.5424 4.31742C19.0877 4.2499 18.4972 4.24995 17.8209 4.25L16.669 4.25001C15.8001 4.24999 15.091 4.24998 14.5107 4.30999C14.0267 4.36003 13.5919 4.45481 13.1857 4.64583C13.0829 4.69414 12.982 4.74861 12.8826 4.81007C12.39 5.11451 12.0344 5.52831 11.7072 6.04263C11.4821 6.39644 11.2549 6.82361 11.0007 7.32444L10.7599 6.84275C10.505 6.33294 10.2886 5.90009 10.0727 5.56088C9.84292 5.19971 9.58142 4.89048 9.20965 4.66072C8.99881 4.53041 8.78097 4.44326 8.55422 4.38419C8.38114 4.3391 8.20286 4.31038 8.01854 4.29132C7.61861 4.24997 7.13468 4.24999 6.5647 4.25001L6.17897 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-open-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","open","package","inventory","products","items","delivery","shipment","stock","order","received","incoming"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.17897 10.75L6.5647 10.75C7.13468 10.75 7.61861 10.75 8.01854 10.7087C8.20286 10.6896 8.38114 10.6609 8.55422 10.6158C8.78097 10.5568 8.99881 10.4696 9.20965 10.3393C9.58142 10.1095 9.84292 9.8003 10.0727 9.43913C10.2886 9.09992 10.505 8.66707 10.7599 8.15726L11.0007 7.67558C11.2549 8.1764 11.4821 8.60357 11.7072 8.95738C12.0344 9.4717 12.39 9.8855 12.8826 10.1899C12.982 10.2514 13.0829 10.3059 13.1857 10.3542C13.5919 10.5452 14.0267 10.64 14.5107 10.69C15.091 10.75 15.8001 10.75 16.669 10.75L17.8209 10.75C18.4972 10.7501 19.0877 10.7501 19.5424 10.6826C20.0207 10.6116 20.55 10.4388 20.8706 9.92003C21.1911 9.40131 21.109 8.85068 20.9586 8.39104C20.8157 7.95415 20.5516 7.42602 20.2491 6.8212L20.2097 6.74234C20.0872 6.49739 19.9713 6.26545 19.8527 6.07913C19.7204 5.87111 19.5529 5.66646 19.3019 5.51137C19.051 5.35627 18.7931 5.29801 18.5478 5.27265C18.3282 5.24994 18.0689 5.24997 17.7951 5.25L6.20487 5.25C5.93104 5.24997 5.67175 5.24994 5.4521 5.27265C5.20684 5.29801 4.94891 5.35627 4.69796 5.51137C4.44701 5.66646 4.27955 5.87111 4.14719 6.07913C4.02864 6.26544 3.91271 6.49736 3.79028 6.7423L3.75083 6.82119C3.44836 7.42602 3.18425 7.95415 3.04129 8.39104C2.89089 8.85068 2.80876 9.40131 3.12935 9.92003C3.44994 10.4388 3.97916 10.6116 4.45754 10.6826C4.91224 10.7501 5.50273 10.7501 6.17897 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 18.9999H11.7499L11.7499 10.9124C11.8962 11.0332 12.0541 11.1474 12.2254 11.2532C12.9349 11.6917 13.6679 11.8595 14.3821 11.9334C15.0279 12.0001 15.794 12.0001 16.6221 12L17.8723 12C18.5007 12.0003 19.1766 12.0006 19.726 11.919C19.8107 11.9064 19.9027 11.8905 20 11.8698V14.0658C20.0001 14.9523 20.0001 15.7161 19.9179 16.3277C19.8297 16.9832 19.631 17.6116 19.1213 18.1213C18.6117 18.6309 17.9833 18.8297 17.3278 18.9178C16.7161 19 15.9523 19 15.0658 18.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.27393 11.919C4.8233 12.0006 5.49923 12.0003 6.12762 12L6.60276 12C7.13889 12.0001 7.68126 12.0002 8.14708 11.952C8.68072 11.8969 9.27816 11.7664 9.8668 11.4026C10.0054 11.3169 10.1326 11.2251 10.2499 11.1287L10.2499 18.9999H8.93417C8.0477 19 7.28387 19 6.67221 18.9178C6.0167 18.8297 5.38835 18.6309 4.87868 18.1213C4.36902 17.6116 4.17028 16.9832 4.08215 16.3277C3.99991 15.7161 3.99995 14.9523 4 14.0658L4 11.8698C4.09723 11.8905 4.18921 11.9064 4.27393 11.919Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-open-8": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","open","package","inventory","stock","item","order","delivery","shipment","products","supplies"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V11H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3.72147 6.6712L3.38813 8.6712C3.20796 9.75223 3.11788 10.2927 3.41744 10.6464C3.71701 11 4.26498 11 5.36092 11H18.6391C19.735 11 20.283 11 20.5826 10.6464C20.8821 10.2927 20.792 9.75223 20.6119 8.6712L20.2785 6.6712C20.1455 5.87304 20.079 5.47396 19.7992 5.23698C19.5195 5 19.1149 5 18.3057 5H5.69425C4.88508 5 4.4805 5 4.20075 5.23698C3.92101 5.47396 3.85449 5.87304 3.72147 6.6712Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open-9": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","storage","inventory","product","item","container","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V11H19V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3.72147 6.6712L3.38813 8.6712C3.20796 9.75223 3.11788 10.2927 3.41744 10.6464C3.71701 11 4.26498 11 5.36092 11H18.6391C19.735 11 20.283 11 20.5826 10.6464C20.8821 10.2927 20.792 9.75223 20.6119 8.6712L20.2785 6.6712C20.1455 5.87304 20.079 5.47396 19.7992 5.23698C19.5195 5 19.1149 5 18.3057 5H5.69425C4.88508 5 4.4805 5 4.20075 5.23698C3.92101 5.47396 3.85449 5.87304 3.72147 6.6712Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","open","package","delivery","inventory","stock","products","items","shipment","unpack","received","stock-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9H6.23607C5.63466 9 5.33395 9 5.0923 8.85065C4.85065 8.7013 4.71617 8.43234 4.44721 7.89443V7.89443C3.79858 6.59717 3.47427 5.94854 3.76738 5.47427C4.0605 5 4.78569 5 6.23607 5H6.52786C7.73068 5 8.33209 5 8.81539 5.2987C9.2987 5.5974 9.56766 6.13531 10.1056 7.21115L11 9ZM11 9H17.7639C18.3653 9 18.666 9 18.9077 8.85065C19.1493 8.7013 19.2838 8.43234 19.5528 7.89443V7.89443C20.2014 6.59717 20.5257 5.94854 20.2326 5.47427C19.9395 5 19.2143 5 17.7639 5H16.7082C14.904 5 14.0019 5 13.2769 5.44805C12.552 5.8961 12.1485 6.70297 11.3416 8.31672L11 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-pallet-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["package","box","pallet","delivery","shipping","stock","inventory","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 7H12.3C12.63 7 12.795 7 12.8975 6.89749C13 6.79497 13 6.62998 13 6.3V5.7C13 5.37002 13 5.20503 12.8975 5.10251C12.795 5 12.63 5 12.3 5H11.7C11.37 5 11.205 5 11.1025 5.10251C11 5.20503 11 5.37002 11 5.7V6.3C11 6.62998 11 6.79497 11.1025 6.89749C11.205 7 11.37 7 11.7 7H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9.6V7.4C8 6.26863 8 5.70294 8.35147 5.35147C8.70294 5 9.26863 5 10.4 5H13.6C14.7314 5 15.2971 5 15.6485 5.35147C16 5.70294 16 6.26863 16 7.4V9.6C16 10.7314 16 11.2971 15.6485 11.6485C15.2971 12 14.7314 12 13.6 12H12H10.4C9.26863 12 8.70294 12 8.35147 11.6485C8 11.2971 8 10.7314 8 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-pallet-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","pallet","inventory","stock","storage","warehouse","shipping","receiving","products","items","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V20"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V20"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15V20"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 15H21"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 20H21"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9.6V7.4C8 6.26863 8 5.70294 8.35147 5.35147C8.70294 5 9.26863 5 10.4 5H13.6C14.7314 5 15.2971 5 15.6485 5.35147C16 5.70294 16 6.26863 16 7.4V9.6C16 10.7314 16 11.2971 15.6485 11.6485C15.2971 12 14.7314 12 13.6 12H12H10.4C9.26863 12 8.70294 12 8.35147 11.6485C8 11.2971 8 10.7314 8 9.6Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7H12.3C12.63 7 12.795 7 12.8975 6.89749C13 6.79497 13 6.62998 13 6.3V5H11V6.3C11 6.62998 11 6.79497 11.1025 6.89749C11.205 7 11.37 7 11.7 7H12Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "box-pallet-3": {
        defaultColors: ["#000000"],
        keywords: ["box","pallet","inventory","stock","warehouse","shipping","receiving","products","items","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M10.25 4.25C9.76656 4.25016 9.33567 4.25325 8.98334 4.30062C8.5734 4.35573 8.15946 4.48283 7.82115 4.82114C7.48283 5.15945 7.35574 5.57339 7.30063 5.98334C7.24992 6.3605 7.24996 6.82768 7.25 7.35303V9.64696C7.24996 10.1723 7.24992 10.6395 7.30063 11.0167C7.35574 11.4266 7.48283 11.8405 7.82115 12.1789C8.15946 12.5172 8.5734 12.6443 8.98334 12.6994C9.3605 12.7501 9.82767 12.75 10.353 12.75H13.647C14.1723 12.75 14.6395 12.7501 15.0167 12.6994C15.4266 12.6443 15.8406 12.5172 16.1789 12.1789C16.5172 11.8405 16.6443 11.4266 16.6994 11.0167C16.7501 10.6395 16.7501 10.1723 16.75 9.64696V7.35304C16.7501 6.82769 16.7501 6.3605 16.6994 5.98334C16.6443 5.57339 16.5172 5.15945 16.1789 4.82114C15.8406 4.48283 15.4266 4.35573 15.0167 4.30062C14.6643 4.25325 14.2335 4.25016 13.75 4.25L13.75 6.32833C13.7501 6.46734 13.7503 6.63721 13.7305 6.78397C13.7065 6.96245 13.6417 7.21398 13.4278 7.42781C13.214 7.64164 12.9625 7.70649 12.784 7.73049C12.6372 7.75022 12.4674 7.7501 12.3284 7.75001H11.6717C11.5327 7.7501 11.3628 7.75022 11.216 7.73049C11.0376 7.70649 10.786 7.64164 10.5722 7.42781C10.3584 7.21398 10.2935 6.96245 10.2695 6.78397C10.2498 6.6372 10.2499 6.46734 10.25 6.32833L10.25 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "Box-product-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","product","inventory","stock","delivery","shipment","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12.2859L17 11.4287"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L16 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30206 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","product","inventory","delivery","shipment","stock","item","goods","container","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8186V7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857V14.8186C4 15.4241 4 15.7268 4.15103 15.9695C4.30206 16.2121 4.5737 16.3458 5.11699 16.6131L11.117 19.5655C11.5505 19.7788 11.7673 19.8855 12 19.8855C12.2327 19.8855 12.4495 19.7788 12.883 19.5655L18.883 16.6131C19.4263 16.3458 19.6979 16.2121 19.849 15.9695C20 15.7268 20 15.4241 20 14.8186Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30206 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5195L19.9142 7.46534C19.9509 7.44962 19.9692 7.44176 19.9692 7.42857C19.9692 7.41538 19.9509 7.40752 19.9142 7.39181L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4.08579 7.39181C4.04911 7.40752 4.03077 7.41538 4.03077 7.42857C4.03077 7.44176 4.04911 7.44962 4.08579 7.46534L11.2122 10.5195C11.6005 10.686 11.7947 10.7692 12 10.7692C12.2053 10.7692 12.3994 10.686 12.7878 10.5195L12.7878 10.5195Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.25 20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20H11.25ZM11.25 11V20H12.75V11H11.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15 12.2859L17 11.4287"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L17.5 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-pallet": {
        defaultColors: ["#000000"],
        keywords: ["box","pallet","inventory","stock","shipping","storage","warehouse","supply chain","package","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 9.6V7.4C8 6.26863 8 5.70294 8.35147 5.35147C8.70294 5 9.26863 5 10.4 5H13.6C14.7314 5 15.2971 5 15.6485 5.35147C16 5.70294 16 6.26863 16 7.4V9.6C16 10.7314 16 11.2971 15.6485 11.6485C15.2971 12 14.7314 12 13.6 12H12H10.4C9.26863 12 8.70294 12 8.35147 11.6485C8 11.2971 8 10.7314 8 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7H12.3C12.63 7 12.795 7 12.8975 6.89749C13 6.79497 13 6.62998 13 6.3V5.7C13 5.37002 13 5.20503 12.8975 5.10251C12.795 5 12.63 5 12.3 5H11.7C11.37 5 11.205 5 11.1025 5.10251C11 5.20503 11 5.37002 11 5.7V6.3C11 6.62998 11 6.79497 11.1025 6.89749C11.205 7 11.37 7 11.7 7H12Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","shipping","delivery","inventory","product","stock","order","shipment","supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L8.87723 4.52228L16.8132 8.09344L20.2241 6.70857L13.0833 3.64821L13.0072 3.61544Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.75 8.11398L13.0553 11.2381L12.9806 11.2686C12.9052 11.2994 12.8284 11.3309 12.7499 11.3607V20.4593C12.8803 20.4039 13.0065 20.3413 13.1291 20.2805L13.2142 20.2384L19.2422 17.2722C19.4896 17.1505 19.7239 17.0352 19.912 16.9171C20.122 16.7852 20.3288 16.6177 20.4857 16.3657C20.6426 16.1137 20.7015 15.8543 20.7271 15.6075C20.7501 15.3866 20.75 15.1256 20.75 14.8499L20.75 8.11398ZM17.2954 12.6893C17.6761 12.5261 17.8525 12.0852 17.6893 11.7045C17.5261 11.3238 17.0852 11.1474 16.7045 11.3106L14.7045 12.1677C14.3238 12.3309 14.1474 12.7718 14.3106 13.1525C14.4738 13.5332 14.9147 13.7096 15.2954 13.5464L17.2954 12.6893Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.2499 20.4592V11.35C11.1688 11.3176 11.0894 11.2833 11.0116 11.2496L10.9375 11.2177L3.25001 7.92318L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35745 16.1137 3.51431 16.3657C3.67116 16.6177 3.87796 16.7852 4.08802 16.9171C4.27616 17.0353 4.51033 17.1504 4.75773 17.2721L10.7859 20.2384L10.871 20.2805C10.9935 20.3413 11.1196 20.4039 11.2499 20.4592Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.00501 5.32466L14.8916 8.87361L12.491 9.84826C12.29 9.92985 12.1775 9.97499 12.0907 10.0027C12.052 10.0151 12.0301 10.0201 12.0187 10.0221L12.0135 10.023L12.0093 10.0235L12.008 10.0236L12.0066 10.0235C12.0055 10.0233 12.0026 10.023 11.9972 10.0219C11.9859 10.0196 11.9641 10.0143 11.9256 10.0012C11.8394 9.97174 11.7277 9.92445 11.5284 9.83902L3.99984 6.61259L7.00501 5.32466Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-product-open-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["box","open","package","inventory","stock","products","item","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M5 11V14.1111C5 15.6056 5 16.3529 5.4213 16.8945C5.84259 17.4362 6.56686 17.6202 8.01538 17.988L11.0154 18.7499C11.5051 18.8743 11.75 18.9365 12 18.9365C12.25 18.9365 12.4949 18.8743 12.9846 18.7499L15.9846 17.988C17.4331 17.6202 18.1574 17.4362 18.5787 16.8945C19 16.3529 19 15.6056 19 14.1111V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L5 7M12 9L10.7423 11.5154C10.3873 12.2255 10.2097 12.5805 9.87939 12.7258C9.54903 12.8712 9.16736 12.7621 8.40401 12.544L5.31713 11.662C4.24373 11.3554 3.70703 11.202 3.51794 10.7722C3.32885 10.3423 3.57847 9.84306 4.07772 8.84456L5 7M12 9L13.2577 11.5154C13.6127 12.2255 13.7903 12.5805 14.1206 12.7258C14.451 12.8712 14.8326 12.7621 15.596 12.544L18.6829 11.662C19.7563 11.3554 20.293 11.202 20.4821 10.7722C20.6712 10.3423 20.4215 9.84306 19.9223 8.84456L19 7M12 9L19 7M5 7L11.4506 5.15698C11.7235 5.079 11.8599 5.04002 12 5.04002C12.1401 5.04002 12.2765 5.079 12.5494 5.15698L19 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-open-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","open","product","inventory","stock","delivery","shipping","receiving","order","item","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14.1111V11.2819C5 11.1457 5 11.0776 5.03652 11.0257C5.07303 10.9739 5.13718 10.951 5.26547 10.9052L10.6547 8.98048C11.3206 8.74264 11.6536 8.62372 12 8.62372C12.3464 8.62372 12.6794 8.74264 13.3453 8.98048L18.7345 10.9052C18.8628 10.951 18.927 10.9739 18.9635 11.0257C19 11.0776 19 11.1457 19 11.2819V14.1111C19 15.6056 19 16.3529 18.5787 16.8945C18.1574 17.4362 17.4331 17.6202 15.9846 17.988L12.9846 18.7499L12.9846 18.7499C12.4949 18.8743 12.25 18.9365 12 18.9365C11.75 18.9365 11.5051 18.8743 11.0154 18.7499L11.0154 18.7499L8.01538 17.988C6.56686 17.6202 5.84259 17.4362 5.4213 16.8945C5 16.3529 5 15.6056 5 14.1111Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.4506 8.84302L6.34613 7.38461C5.80072 7.22878 5.52801 7.15086 5.52801 7C5.52801 6.84914 5.80072 6.77122 6.34613 6.61539L11.4506 5.15698C11.7235 5.079 11.8599 5.04002 12 5.04002C12.1401 5.04002 12.2765 5.079 12.5494 5.15698L17.6539 6.61539C18.1993 6.77122 18.472 6.84914 18.472 7C18.472 7.15086 18.1993 7.22878 17.6539 7.38461L12.5494 8.84302C12.2765 8.921 12.1401 8.95998 12 8.95998C11.8599 8.95998 11.7235 8.921 11.4506 8.84302Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L6.59599 7.456C5.83264 7.2379 5.45097 7.12885 5.12061 7.27417C4.79025 7.4195 4.61273 7.77454 4.25769 8.48462L4.07772 8.84456C3.57847 9.84306 3.32885 10.3423 3.51794 10.7722C3.70703 11.202 4.24373 11.3554 5.31713 11.662L8.40401 12.544C9.16736 12.7621 9.54903 12.8712 9.87939 12.7258C10.2097 12.5805 10.3873 12.2255 10.7423 11.5154L12 9L13.2577 11.5154L13.2577 11.5154C13.6127 12.2255 13.7903 12.5805 14.1206 12.7258C14.451 12.8712 14.8326 12.7621 15.596 12.544L18.6829 11.662C19.7563 11.3554 20.293 11.202 20.4821 10.7722C20.6712 10.3423 20.4215 9.84306 19.9223 8.84456L19.7423 8.48462C19.3873 7.77454 19.2097 7.4195 18.8794 7.27418C18.549 7.12885 18.1674 7.2379 17.404 7.456L12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 9L6.59599 7.456C5.83264 7.2379 5.45097 7.12885 5.12061 7.27417C4.79025 7.4195 4.61273 7.77454 4.25769 8.48462L4.07772 8.84456C3.57847 9.84306 3.32885 10.3423 3.51794 10.7722C3.70703 11.202 4.24373 11.3554 5.31713 11.662L8.40401 12.544C9.16736 12.7621 9.54903 12.8712 9.87939 12.7258C10.2097 12.5805 10.3873 12.2255 10.7423 11.5154L12 9ZM12 9L13.2577 11.5154C13.6127 12.2255 13.7903 12.5805 14.1206 12.7258C14.451 12.8712 14.8326 12.7621 15.596 12.544L18.6829 11.662C19.7563 11.3554 20.293 11.202 20.4821 10.7722C20.6712 10.3423 20.4215 9.84306 19.9223 8.84456L19.7423 8.48462C19.3873 7.77454 19.2098 7.4195 18.8794 7.27418C18.549 7.12885 18.1674 7.2379 17.404 7.456L12 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","open","product","inventory","shipment","delivery","stock","items","products","manage-inventory","open-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.95677 14.2472L5.7873 13.6384L5.04093 13.4323L4.8817 13.3832C4.68267 13.3242 4.48364 13.2752 4.29455 13.2162V14.1392C4.29455 15.7199 4.29455 16.5938 4.87175 17.3203C5.44895 18.0567 6.30479 18.2629 7.85725 18.6556L10.8427 19.4018C11.002 19.4411 11.1313 19.4705 11.2607 19.5V13.9035C11.0716 14.0704 10.8627 14.2275 10.6039 14.3355C9.69831 14.7283 8.89222 14.5025 7.96672 14.2374L7.95677 14.2472Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.9733 13.4224L18.2269 13.6286L16.0674 14.2374C15.4902 14.4043 14.9627 14.5515 14.4353 14.5515C14.1069 14.5515 13.7685 14.4926 13.4202 14.3355C13.1515 14.2177 12.9425 14.0704 12.7535 13.9035V19.5C12.8729 19.4705 13.0122 19.4411 13.1714 19.4018L16.1569 18.6556C17.7094 18.2629 18.5652 18.0567 19.1424 17.3203C19.7196 16.5938 19.7196 15.7199 19.7196 14.1392V13.2162C19.5305 13.2752 19.3315 13.3341 19.1325 13.3832L18.9733 13.4323V13.4224Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.20556 6.25503L11.9971 7.32523L15.7887 6.25503L16.8934 5.94085C16.9829 5.91139 17.0625 5.89175 17.1521 5.87212L12.7535 4.62518C12.1464 4.45827 11.8678 4.45827 11.2607 4.62518L6.85214 5.87212C6.93175 5.89175 7.02132 5.92121 7.10093 5.94085L8.20556 6.25503Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.3366 8.73907L20.1575 8.38561C19.8192 7.70815 19.5803 7.28596 19.1823 7.05032C19.1424 7.02086 19.1026 6.99141 19.0529 6.97177C18.7643 6.84413 18.4657 6.84413 18.0975 6.91286C17.8487 6.96195 17.58 7.03068 17.2417 7.12886L13.1914 8.26779L12.3753 8.49362L11.9972 8.60162L11.619 8.49362L10.803 8.26779L6.76258 7.11904C6.43417 7.02086 6.15553 6.95213 5.90674 6.91286C5.54848 6.84413 5.24993 6.84413 4.96133 6.97177C4.91157 6.99141 4.87176 7.03068 4.83196 7.05032C4.43389 7.28596 4.205 7.70815 3.85669 8.38561L3.67756 8.73907C3.13022 9.81909 2.82172 10.418 3.11032 11.0464C3.30935 11.4882 3.68752 11.7042 4.29457 11.9104C4.5135 11.989 4.7623 12.0577 5.04094 12.146C5.10065 12.1657 5.15041 12.1755 5.22007 12.1951L5.78732 12.3522L8.29514 13.0592C9.11117 13.285 9.5988 13.4323 10.0964 13.2162C10.594 13.0002 10.8229 12.5486 11.201 11.8024L12.0071 10.2118L12.7535 11.6846L12.8132 11.8122C13.1914 12.5584 13.4202 13.0101 13.9079 13.2261C14.0771 13.3046 14.2462 13.3341 14.4353 13.3341C14.7836 13.3341 15.1817 13.2261 15.7091 13.069L18.2169 12.3621L18.7842 12.205C18.8538 12.1853 18.9036 12.1755 18.9633 12.1559C19.242 12.0773 19.4908 11.9988 19.7097 11.9202C20.3068 11.714 20.6949 11.498 20.8939 11.0562C21.1726 10.418 20.874 9.82891 20.3267 8.74889L20.3366 8.73907Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-product-tape-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","product","inventory","ship","shipping","delivery","order","stock","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5 5.5L8 8.98036V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30205 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","open","package","inventory","stock","shipping","delivery","products","items","unpack","receiving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M5 11V14.1111C5 15.6056 5 16.3529 5.4213 16.8945C5.84259 17.4362 6.56686 17.6202 8.01538 17.988L11.0154 18.7499C11.5051 18.8743 11.75 18.9365 12 18.9365C12.25 18.9365 12.4949 18.8743 12.9846 18.7499L15.9846 17.988C17.4331 17.6202 18.1574 17.4362 18.5787 16.8945C19 16.3529 19 15.6056 19 14.1111V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L5 7M12 9L10.7423 11.5154C10.3873 12.2255 10.2097 12.5805 9.87939 12.7258C9.54903 12.8712 9.16736 12.7621 8.40401 12.544L5.31713 11.662C4.24373 11.3554 3.70703 11.202 3.51794 10.7722C3.32885 10.3423 3.57847 9.84306 4.07772 8.84456L5 7M12 9L13.2577 11.5154C13.6127 12.2255 13.7903 12.5805 14.1206 12.7258C14.451 12.8712 14.8326 12.7621 15.596 12.544L18.6829 11.662C19.7563 11.3554 20.293 11.202 20.4821 10.7722C20.6712 10.3423 20.4215 9.84306 19.9223 8.84456L19 7M12 9L19 7M5 7L11.4506 5.15698C11.7235 5.079 11.8599 5.04002 12 5.04002C12.1401 5.04002 12.2765 5.079 12.5494 5.15698L19 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-tape-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","delivery","shipment","order","inventory","stock","product","goods","supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8186V7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857V14.8186C4 15.4241 4 15.7268 4.15103 15.9695C4.30205 16.2121 4.5737 16.3458 5.11699 16.6131L11.117 19.5655C11.5505 19.7788 11.7673 19.8855 12 19.8855C12.2327 19.8855 12.4495 19.7788 12.883 19.5655L18.883 16.6131C19.4263 16.3458 19.6979 16.2121 19.849 15.9695C20 15.7268 20 15.4241 20 14.8186Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30205 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5195L19.9142 7.46534C19.9509 7.44962 19.9692 7.44176 19.9692 7.42857C19.9692 7.41538 19.9509 7.40752 19.9142 7.39181L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4.08579 7.39181C4.04911 7.40752 4.03077 7.41538 4.03077 7.42857C4.03077 7.44176 4.04911 7.44962 4.08579 7.46534L11.2122 10.5195C11.6005 10.686 11.7947 10.7692 12 10.7692C12.2053 10.7692 12.3994 10.686 12.7878 10.5195L12.7878 10.5195Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8.98047V12.0001"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 5.5L8 8.98036"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product-tape-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","ship","delivery","inventory","stock","product","item","supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L4.06841 6.5832L7.06493 7.88879C7.1125 7.85499 7.16482 7.82623 7.2214 7.8036L15.2685 4.58475L13.0833 3.64821L13.0072 3.61544Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.2183 5.42037L8.97104 8.71929L11.5197 9.82977C11.7223 9.91803 11.8358 9.96692 11.9236 9.99732C11.9627 10.0109 11.9849 10.0164 11.9964 10.0187C12.0018 10.0199 12.0048 10.0202 12.0059 10.0203L12.0073 10.0205L12.0087 10.0204C12.0098 10.0203 12.0128 10.02 12.0182 10.0189C12.0298 10.0168 12.052 10.0116 12.0914 9.99879C12.1797 9.96994 12.294 9.92305 12.4981 9.83837L20.1338 6.66988L17.2183 5.42037Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.75 8.03822L13.073 11.2238L12.9972 11.2555C12.9165 11.2892 12.8341 11.3237 12.7499 11.3561V20.4593C12.8803 20.4039 13.0065 20.3413 13.1291 20.2805L13.2142 20.2384L19.2422 17.2722C19.4896 17.1505 19.7239 17.0352 19.912 16.9171C20.122 16.7852 20.3288 16.6177 20.4857 16.3657C20.6426 16.1137 20.7015 15.8543 20.7271 15.6075C20.7501 15.3866 20.75 15.1256 20.75 14.8499L20.75 8.03822Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.2499 20.4592V11.3464C11.1634 11.3115 11.0788 11.2743 10.9959 11.2379L10.9206 11.2049L8.24995 10.0413V12C8.24995 12.4142 7.91416 12.75 7.49995 12.75C7.08573 12.75 6.74995 12.4142 6.74995 12V9.38775L3.25001 7.86281L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35745 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08802 16.9171C4.27616 17.0353 4.51033 17.1504 4.75773 17.2721L10.7859 20.2384L10.871 20.2805C10.9935 20.3413 11.1196 20.4039 11.2499 20.4592Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-product-tape": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","inventory","product","shipping","delivery","stock","order","item","goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30205 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 5.5L8 8.98036V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-ribbon-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","delivery","shipping","inventory","product","item","received","orders","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-ribbon-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","delivery","shipment","order","receiving","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5.4V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5.4C15 5.21144 15 5.11716 14.9414 5.05858C14.8828 5 14.7886 5 14.6 5H9.4C9.21144 5 9.11716 5 9.05858 5.05858C9 5.11716 9 5.21144 9 5.4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-product": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","product","inventory","stock","delivery","shipment","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42857V14.8186C20 15.4241 20 15.7268 19.849 15.9695C19.6979 16.2121 19.4263 16.3458 18.883 16.6131L12.883 19.5655C12.4495 19.7788 12.2327 19.8855 12 19.8855C11.7673 19.8855 11.5505 19.7788 11.117 19.5655L5.11699 16.6131C4.5737 16.3458 4.30206 16.2121 4.15103 15.9695C4 15.7268 4 15.4241 4 14.8186V7.42857M20 7.42857L12.7878 10.5195C12.3995 10.686 12.2053 10.7692 12 10.7692C11.7947 10.7692 11.6005 10.686 11.2122 10.5195L4 7.42857M20 7.42857L12.7878 4.33765C12.3995 4.17119 12.2053 4.08797 12 4.08797C11.7947 4.08797 11.6005 4.17119 11.2122 4.33765L4 7.42857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12.2859L17 11.4287"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-ribbon-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","delivery","shipment","inventory","product","item","stock","parcel","goods","order","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.25 4.25157C7.65449 4.25584 7.13899 4.27164 6.70553 4.32991C6.07773 4.41432 5.51093 4.59999 5.05546 5.05546C4.59999 5.51093 4.41432 6.07773 4.32992 6.70552C4.24995 7.30029 4.24997 8.04949 4.25 8.94794V15.052C4.24997 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052V8.94801C19.75 8.04954 19.7501 7.3003 19.6701 6.70552C19.5857 6.07773 19.4 5.51093 18.9445 5.05546C18.4891 4.59999 17.9223 4.41432 17.2945 4.32991C16.861 4.27164 16.3455 4.25584 15.75 4.25157V8.1C15.75 8.36343 15.6118 8.60755 15.3859 8.7431C15.16 8.87864 14.8796 8.88575 14.6471 8.76181L12.5875 7.66366C12.345 7.53438 12.2076 7.46193 12.1006 7.41708C12.0528 7.39702 12.0257 7.38896 12.0118 7.38563C12.0053 7.38407 12.0007 7.38345 12.0007 7.38345L11.9992 7.38333L11.9978 7.38345C11.9978 7.38345 11.9932 7.38407 11.9867 7.38564C11.9728 7.38897 11.9457 7.39703 11.8979 7.41711C11.7909 7.46198 11.6535 7.53446 11.411 7.6638L9.35302 8.76172C9.12057 8.88573 8.84009 8.87868 8.61417 8.74314C8.38824 8.60761 8.25 8.36346 8.25 8.1V4.25157ZM10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14C14.75 13.5858 14.4142 13.25 14 13.25H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.75 4.25H14.25V6.85017L13.269 6.32713C13.0595 6.21539 12.8599 6.10891 12.6808 6.03381C12.4805 5.94983 12.258 5.8833 11.9991 5.88333C11.7401 5.88336 11.5176 5.94994 11.3174 6.03397C11.1383 6.10911 10.9387 6.21564 10.7292 6.32742L9.75 6.84983V4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-ribbon": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","delivery","shipment","inventory","product","item","stock","order","receiving","ship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-speed-1": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["delivery","package","shipping","fast","speed","express","moving","transit","in-transit","dispatch","send","order-status","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8.0004L6.00049 8M3.99931 10.9996H6.00069M3 13.9996H5.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.65224 14.4343L6.50938 8.43431C6.7433 6.79689 6.86026 5.97818 7.42419 5.48909C7.98812 5 8.81514 5 10.4692 5H16.388C18.5339 5 19.6068 5 20.2049 5.6896C20.803 6.37919 20.6512 7.44135 20.3478 9.56567V9.56568L19.4906 15.5657C19.2567 17.2031 19.1397 18.0218 18.5758 18.5109C18.0119 19 17.1849 19 15.5308 19H9.61204C7.46614 19 6.3932 19 5.79511 18.3104C5.19703 17.6208 5.34877 16.5586 5.65224 14.4343Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4384 9H12.5616C11.3824 9 10.7928 9 10.4926 8.61541C10.1923 8.23082 10.3353 7.65886 10.6213 6.51493C10.8032 5.78737 10.8941 5.42359 11.1654 5.21179C11.4366 5 11.8116 5 12.5616 5H14.4384C15.6176 5 16.2072 5 16.5074 5.38459C16.8077 5.76918 16.6647 6.34114 16.3787 7.48507C16.1968 8.21263 16.1059 8.57641 15.8346 8.78821C15.5634 9 15.1884 9 14.4384 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-speed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","delivery","speed","fast","shipping","express","order","processing","dispatch","inventory","moving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8.0004L6.00049 8M3.99931 10.9996H6.00069M3 13.9996H5.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.65224 14.4343L6.50938 8.43431C6.7433 6.79689 6.86026 5.97818 7.42419 5.48909C7.98812 5 8.81514 5 10.4692 5H16.388C18.5339 5 19.6068 5 20.2049 5.6896C20.803 6.37919 20.6512 7.44135 20.3478 9.56567V9.56568L19.4906 15.5657C19.2567 17.2031 19.1397 18.0218 18.5758 18.5109C18.0119 19 17.1849 19 15.5308 19H9.61204C7.46614 19 6.3932 19 5.79511 18.3104C5.19703 17.6208 5.34877 16.5586 5.65224 14.4343Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 5L10.6213 6.51493C10.3353 7.65886 10.1923 8.23082 10.4926 8.61541C10.7928 9 11.3824 9 12.5616 9H14.4384C15.1884 9 15.5634 9 15.8346 8.78821C16.1059 8.57641 16.1968 8.21263 16.3787 7.48507L17 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Box-speed-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["package","shipping","delivery","fast","speed","order-ready","order-dispatch","checkout","shopping-bag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.6419 4.25L9.65576 7.53716C9.57786 7.79652 9.4976 8.06375 9.46399 8.29148C9.42593 8.54931 9.42157 8.9134 9.66911 9.2461C9.91665 9.5788 10.2666 9.67924 10.5245 9.71688C10.7523 9.75013 11.0313 9.75003 11.3021 9.74995L15.2832 9.74994C15.4381 9.75001 15.6118 9.75008 15.7624 9.73255C15.9415 9.71172 16.1634 9.6596 16.3741 9.5028C16.5849 9.346 16.6985 9.14844 16.7699 8.98293C16.83 8.84371 16.8798 8.67732 16.9243 8.52895L18.2005 4.27485C18.4842 4.28866 18.7447 4.31014 18.9816 4.34355C19.6785 4.44183 20.3039 4.65906 20.7715 5.1982C21.2391 5.73734 21.3657 6.38721 21.3644 7.09097C21.3632 7.76129 21.2432 8.60136 21.0982 9.61606L20.2264 15.7188C20.1152 16.4974 20.0218 17.1508 19.8803 17.6672C19.7303 18.2143 19.5038 18.6988 19.0672 19.0775C18.6306 19.4562 18.1189 19.6119 17.5561 19.683C17.0249 19.7501 16.3649 19.75 15.5784 19.75H9.55577C8.53077 19.75 7.68216 19.7501 7.01841 19.6565C6.32155 19.5582 5.69611 19.3409 5.22852 18.8018C4.76093 18.2627 4.63433 17.6128 4.63559 16.909C4.63665 16.321 4.72916 15.6023 4.84975 14.7496H3C2.58579 14.7496 2.25 14.4138 2.25 13.9996C2.25 13.5854 2.58579 13.2496 3 13.2496H5.06387L5.27816 11.7496H3.99931C3.58509 11.7496 3.24931 11.4138 3.24931 10.9996C3.24931 10.5854 3.58509 10.2496 3.99931 10.2496H5.49244L5.70665 8.75012L5.0003 8.75041C4.58609 8.75057 4.25017 8.41492 4.25 8.00071C4.24983 7.58649 4.58549 7.25057 4.9997 7.25041L5.92836 7.25003C5.98529 6.9082 6.04595 6.6019 6.11971 6.33281C6.26969 5.78569 6.49618 5.30117 6.93279 4.92251C7.36939 4.54384 7.88107 4.38815 8.4439 4.31705C8.9751 4.24996 9.63512 4.24998 10.4216 4.25H10.6419Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.208 4.25L11.1045 7.9281C11.0667 8.05415 11.0357 8.15785 11.0103 8.24822C11.1041 8.2499 11.2124 8.24994 11.344 8.24994H15.2559C15.3304 8.24994 15.39 8.24991 15.4414 8.2492C15.4568 8.20017 15.474 8.1431 15.4954 8.07177L16.6419 4.25002C16.5768 4.25 16.5109 4.25 16.4443 4.25H12.208Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-speed": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","shipping","delivery","fast-delivery","fast","speed","express","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 5L10.6213 6.51493C10.3353 7.65886 10.1923 8.23082 10.4926 8.61541C10.7928 9 11.3824 9 12.5616 9H14.4384C15.1884 9 15.5634 9 15.8346 8.78821C16.1059 8.57641 16.1968 8.21263 16.3787 7.48507L17 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8.0004L6.00049 8M3.99931 10.9996H6.00069M3 13.9996H5.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.65224 14.4343L6.50938 8.43431C6.7433 6.79689 6.86026 5.97818 7.42419 5.48909C7.98812 5 8.81514 5 10.4692 5H16.388C18.5339 5 19.6068 5 20.2049 5.6896C20.803 6.37919 20.6512 7.44135 20.3478 9.56567V9.56568L19.4906 15.5657C19.2567 17.2031 19.1397 18.0218 18.5758 18.5109C18.0119 19 17.1849 19 15.5308 19H9.61204C7.46614 19 6.3932 19 5.79511 18.3104C5.19703 17.6208 5.34877 16.5586 5.65224 14.4343Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","boxes","stacked","inventory","stock","storage","warehouse","products","items","supplies","shipment","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 15H7.8C8.12998 15 8.29497 15 8.39749 14.8975C8.5 14.795 8.5 14.63 8.5 14.3V13.7C8.5 13.37 8.5 13.205 8.39749 13.1025C8.29497 13 8.12998 13 7.8 13H7.2C6.87002 13 6.70503 13 6.60251 13.1025C6.5 13.205 6.5 13.37 6.5 13.7V14.3C6.5 14.63 6.5 14.795 6.60251 14.8975C6.70503 15 6.87002 15 7.2 15H7.5Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.5 17.6V15.4C3.5 14.2686 3.5 13.7029 3.85147 13.3515C4.20294 13 4.76863 13 5.9 13H9.1C10.2314 13 10.7971 13 11.1485 13.3515C11.5 13.7029 11.5 14.2686 11.5 15.4V17.6C11.5 18.7314 11.5 19.2971 11.1485 19.6485C10.7971 20 10.2314 20 9.1 20H5.9C4.76863 20 4.20294 20 3.85147 19.6485C3.5 19.2971 3.5 18.7314 3.5 17.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.5 15H16.8C17.13 15 17.295 15 17.3975 14.8975C17.5 14.795 17.5 14.63 17.5 14.3V13.7C17.5 13.37 17.5 13.205 17.3975 13.1025C17.295 13 17.13 13 16.8 13H16.2C15.87 13 15.705 13 15.6025 13.1025C15.5 13.205 15.5 13.37 15.5 13.7V14.3C15.5 14.63 15.5 14.795 15.6025 14.8975C15.705 15 15.87 15 16.2 15H16.5Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H16.5H18.1C19.2314 13 19.7971 13 20.1485 13.3515C20.5 13.7029 20.5 14.2686 20.5 15.4V17.6C20.5 18.7314 20.5 19.2971 20.1485 19.6485C19.7971 20 19.2314 20 18.1 20H16.5H14"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5.5H12.3C12.63 5.5 12.795 5.5 12.8975 5.39749C13 5.29497 13 5.12998 13 4.8V4.2C13 3.87002 13 3.70503 12.8975 3.60251C12.795 3.5 12.63 3.5 12.3 3.5H11.7C11.37 3.5 11.205 3.5 11.1025 3.60251C11 3.70503 11 3.87002 11 4.2V4.8C11 5.12998 11 5.29497 11.1025 5.39749C11.205 5.5 11.37 5.5 11.7 5.5H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8.1V5.9C8 4.76863 8 4.20294 8.35147 3.85147C8.70294 3.5 9.26863 3.5 10.4 3.5H13.6C14.7314 3.5 15.2971 3.5 15.6485 3.85147C16 4.20294 16 4.76863 16 5.9V8.1C16 9.23137 16 9.79706 15.6485 10.1485C15.2971 10.5 14.7314 10.5 13.6 10.5H12H10.4C9.26863 10.5 8.70294 10.5 8.35147 10.1485C8 9.79706 8 9.23137 8 8.1Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["boxes","packages","inventory","stock","storage","warehouse","products","shipment","supply","box-stacked","multiple-boxes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1345 20.75L18.1468 20.75C18.6721 20.7501 19.1393 20.7501 19.5165 20.6994C19.9264 20.6443 20.3404 20.5172 20.6787 20.1789C21.017 19.8406 21.1441 19.4266 21.1992 19.0167C21.2499 18.6395 21.2499 18.1723 21.2498 17.647V15.353C21.2499 14.8277 21.2499 14.3605 21.1992 13.9833C21.1441 13.5734 21.017 13.1595 20.6787 12.8211C20.3404 12.4828 19.9264 12.3557 19.5165 12.3006C19.1393 12.2499 18.6721 12.25 18.1468 12.25L13.3922 12.25C13.4451 12.4085 13.4782 12.5712 13.5 12.7333C13.5507 13.1105 13.5507 13.5777 13.5506 14.103V18.397C13.5507 18.9223 13.5507 19.3895 13.5 19.7667C13.4543 20.1069 13.359 20.4498 13.1345 20.75Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M5.85304 12.25C5.32769 12.25 4.86051 12.2499 4.48334 12.3006C4.0734 12.3557 3.65946 12.4828 3.32115 12.8211C2.98283 13.1595 2.85574 13.5734 2.80063 13.9833C2.74992 14.3605 2.74996 14.8277 2.75 15.353V17.647C2.74996 18.1723 2.74992 18.6395 2.80063 19.0167C2.85574 19.4266 2.98283 19.8406 3.32115 20.1789C3.65946 20.5172 4.0734 20.6443 4.48334 20.6994C4.8605 20.7501 5.32767 20.7501 5.85301 20.75H9.14697C9.6723 20.7501 10.1395 20.7501 10.5167 20.6994C10.9266 20.6443 11.3406 20.5172 11.6789 20.1789C12.0172 19.8406 12.1443 19.4266 12.1994 19.0167C12.2501 18.6395 12.2501 18.1723 12.25 17.647V15.353C12.2501 14.8277 12.2501 14.3605 12.1994 13.9833C12.1443 13.5734 12.0172 13.1595 11.6789 12.8211C11.3406 12.4828 10.9266 12.3557 10.5167 12.3006C10.1395 12.2499 9.67232 12.25 9.14697 12.25H5.85304Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M9.25003 12.25H5.75003L5.75001 14.3283C5.74992 14.4674 5.7498 14.6372 5.76953 14.784C5.79352 14.9625 5.85838 15.214 6.07221 15.4278C6.28604 15.6417 6.53757 15.7065 6.71605 15.7305C6.86281 15.7502 7.03267 15.7501 7.17169 15.75H7.82836C7.96738 15.7501 8.13724 15.7502 8.28401 15.7305C8.46248 15.7065 8.71401 15.6417 8.92785 15.4278C9.14168 15.214 9.20653 14.9625 9.23053 14.784C9.25026 14.6372 9.25014 14.4674 9.25004 14.3283L9.25003 12.25Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M18.25 12.25H14.75L14.75 14.3283C14.7499 14.4674 14.7498 14.6372 14.7695 14.784C14.7935 14.9625 14.8584 15.214 15.0722 15.4278C15.286 15.6417 15.5376 15.7065 15.716 15.7305C15.8628 15.7502 16.0327 15.7501 16.1717 15.75H16.8284C16.9674 15.7501 17.1372 15.7502 17.284 15.7305C17.4625 15.7065 17.714 15.6417 17.9278 15.4278C18.1417 15.214 18.2065 14.9625 18.2305 14.784C18.2503 14.6372 18.2501 14.4674 18.25 14.3283L18.25 12.25Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M10.353 2.75C9.82769 2.74996 9.36051 2.74992 8.98334 2.80063C8.5734 2.85574 8.15946 2.98283 7.82115 3.32115C7.48283 3.65946 7.35574 4.0734 7.30063 4.48334C7.24992 4.86051 7.24996 5.32769 7.25 5.85304V8.14697C7.24996 8.67232 7.24992 9.1395 7.30063 9.51667C7.35574 9.92661 7.48283 10.3406 7.82115 10.6789C8.15946 11.0172 8.5734 11.1443 8.98334 11.1994C9.3605 11.2501 9.82767 11.2501 10.353 11.25H13.647C14.1723 11.2501 14.6395 11.2501 15.0167 11.1994C15.4266 11.1443 15.8406 11.0172 16.1789 10.6789C16.5172 10.3406 16.6443 9.92661 16.6994 9.51667C16.7501 9.1395 16.7501 8.67232 16.75 8.14697V5.85305C16.7501 5.32769 16.7501 4.86051 16.6994 4.48334C16.6443 4.0734 16.5172 3.65946 16.1789 3.32115C15.8406 2.98283 15.4266 2.85574 15.0167 2.80063C14.6395 2.74992 14.1723 2.74996 13.647 2.75H10.353Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M13.75 2.75H10.25L10.25 4.82833C10.2499 4.96735 10.2498 5.13721 10.2695 5.28398C10.2935 5.46246 10.3584 5.71398 10.5722 5.92782C10.786 6.14165 11.0376 6.2065 11.216 6.2305C11.3628 6.25023 11.5327 6.25011 11.6717 6.25001H12.3284C12.4674 6.25011 12.6372 6.25023 12.784 6.2305C12.9625 6.2065 13.214 6.14165 13.4278 5.92782C13.6417 5.71398 13.7065 5.46246 13.7305 5.28398C13.7503 5.13721 13.7501 4.96735 13.75 4.82834L13.75 2.75Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "box-stacked-circle-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["inventory","stock","boxes","stacked","storage","products","warehouse","shipment","packages","deliveries","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-3": {
        defaultColors: ["#000000"],
        keywords: ["boxes","stacked","inventory","stock","warehouse","products","supplies","shipments","delivery","storage","organization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.75003 12.25C5.26656 12.2502 4.83567 12.2532 4.48334 12.3006C4.0734 12.3557 3.65946 12.4828 3.32115 12.8211C2.98283 13.1595 2.85574 13.5734 2.80063 13.9833C2.74992 14.3605 2.74996 14.8277 2.75 15.353V17.647C2.74996 18.1723 2.74992 18.6395 2.80063 19.0167C2.85574 19.4266 2.98283 19.8405 3.32115 20.1789C3.65946 20.5172 4.0734 20.6443 4.48334 20.6994C4.8605 20.7501 5.32767 20.75 5.85301 20.75H9.14697C9.6723 20.75 10.1395 20.7501 10.5167 20.6994C10.9266 20.6443 11.3406 20.5172 11.6789 20.1789C12.0172 19.8405 12.1443 19.4266 12.1994 19.0167C12.2501 18.6395 12.2501 18.1723 12.25 17.647V15.353C12.2501 14.8277 12.2501 14.3605 12.1994 13.9833C12.1443 13.5734 12.0172 13.1595 11.6789 12.8211C11.3406 12.4828 10.9266 12.3557 10.5167 12.3006C10.1643 12.2533 9.73348 12.2502 9.25003 12.25L9.25004 14.3283C9.25014 14.4673 9.25026 14.6372 9.23053 14.784C9.20653 14.9624 9.14168 15.214 8.92785 15.4278C8.71401 15.6416 8.46248 15.7065 8.28401 15.7305C8.13724 15.7502 7.96738 15.7501 7.82836 15.75H7.17169C7.03267 15.7501 6.86281 15.7502 6.71605 15.7305C6.53757 15.7065 6.28604 15.6416 6.07221 15.4278C5.85838 15.214 5.79352 14.9624 5.76953 14.784C5.7498 14.6372 5.74992 14.4673 5.75001 14.3283L5.75003 12.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.75 12.25L14.75 14.3283C14.7499 14.4673 14.7498 14.6372 14.7695 14.784C14.7935 14.9624 14.8584 15.214 15.0722 15.4278C15.286 15.6416 15.5376 15.7065 15.716 15.7305C15.8628 15.7502 16.0327 15.7501 16.1717 15.75H16.8284C16.9674 15.7501 17.1372 15.7502 17.284 15.7305C17.4625 15.7065 17.714 15.6416 17.9278 15.4278C18.1417 15.214 18.2065 14.9624 18.2305 14.784C18.2503 14.6372 18.2501 14.4674 18.25 14.3283L18.25 12.25C18.7334 12.2502 19.1642 12.2533 19.5165 12.3006C19.9264 12.3557 20.3404 12.4828 20.6787 12.8211C21.017 13.1595 21.1441 13.5734 21.1992 13.9833C21.2499 14.3605 21.2499 14.8277 21.2498 15.353V17.647C21.2499 18.1723 21.2499 18.6395 21.1992 19.0167C21.1441 19.4266 21.017 19.8405 20.6787 20.1789C20.3404 20.5172 19.9264 20.6443 19.5165 20.6994C19.1393 20.7501 18.6721 20.75 18.1468 20.75L13.1345 20.75C13.359 20.4498 13.4543 20.1069 13.5 19.7667C13.5507 19.3895 13.5507 18.9223 13.5506 18.397V14.103C13.5507 13.5777 13.5507 13.1105 13.5 12.7333C13.4782 12.5712 13.4451 12.4085 13.3922 12.25L14.75 12.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 2.75C9.76656 2.75016 9.33567 2.75325 8.98334 2.80062C8.5734 2.85573 8.15946 2.98283 7.82115 3.32114C7.48283 3.65945 7.35574 4.07339 7.30063 4.48334C7.24992 4.8605 7.24996 5.32768 7.25 5.85303V8.14696C7.24996 8.67231 7.24992 9.13949 7.30063 9.51666C7.35574 9.9266 7.48283 10.3405 7.82115 10.6789C8.15946 11.0172 8.5734 11.1443 8.98334 11.1994C9.3605 11.2501 9.82767 11.25 10.353 11.25H13.647C14.1723 11.25 14.6395 11.2501 15.0167 11.1994C15.4266 11.1443 15.8406 11.0172 16.1789 10.6789C16.5172 10.3405 16.6443 9.9266 16.6994 9.51666C16.7501 9.13949 16.7501 8.67231 16.75 8.14696V5.85304C16.7501 5.32769 16.7501 4.8605 16.6994 4.48334C16.6443 4.07339 16.5172 3.65945 16.1789 3.32114C15.8406 2.98283 15.4266 2.85573 15.0167 2.80062C14.6643 2.75325 14.2335 2.75016 13.75 2.75L13.75 4.82833C13.7501 4.96735 13.7503 5.1372 13.7305 5.28397C13.7065 5.46245 13.6417 5.71398 13.4278 5.92781C13.214 6.14164 12.9625 6.20649 12.784 6.23049C12.6372 6.25022 12.4674 6.2501 12.3284 6.25001H11.6717C11.5327 6.2501 11.3628 6.25022 11.216 6.23049C11.0376 6.20649 10.786 6.14164 10.5722 5.92781C10.3584 5.71398 10.2935 5.46245 10.2695 5.28397C10.2498 5.1372 10.2499 4.96734 10.25 4.82833L10.25 2.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-stacked-circle-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","package","inventory","storage","container","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-circle-3": {
        defaultColors: ["#000000"],
        keywords: ["boxes","stacked","inventory","stock","circle","package","shipment","storage","warehouse","products","goods","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM11.0541 6.77778C10.7928 6.77787 10.5599 6.77958 10.3694 6.8059C10.1478 6.83652 9.92406 6.90713 9.74119 7.09508C9.55831 7.28303 9.48962 7.513 9.45982 7.74074C9.43241 7.95028 9.43243 8.20982 9.43246 8.50168V9.77609C9.43243 10.0679 9.43241 10.3275 9.45982 10.537C9.48962 10.7648 9.55831 10.9947 9.74119 11.1827C9.92406 11.3706 10.1478 11.4413 10.3694 11.4719C10.5733 11.5 10.8258 11.5 11.1098 11.5H12.8903C13.1743 11.5 13.4268 11.5 13.6307 11.4719C13.8523 11.4413 14.076 11.3706 14.2589 11.1827C14.4418 10.9947 14.5105 10.7648 14.5403 10.537C14.5677 10.3275 14.5677 10.0679 14.5676 9.77609V8.50169C14.5677 8.20983 14.5677 7.95028 14.5403 7.74074C14.5105 7.513 14.4418 7.28303 14.2589 7.09508C14.076 6.90713 13.8523 6.83652 13.6307 6.8059C13.4403 6.77958 13.2073 6.77787 12.946 6.77778H11.0541ZM8.62165 12.2778C8.36031 12.2779 8.1274 12.2796 7.93695 12.3059C7.71536 12.3365 7.4916 12.4071 7.30873 12.5951C7.12586 12.783 7.05716 13.013 7.02737 13.2407C6.99996 13.4503 6.99998 13.7098 7 14.0017V15.2761C6.99998 15.5679 6.99996 15.8275 7.02737 16.037C7.05716 16.2648 7.12586 16.4947 7.30873 16.6827C7.4916 16.8706 7.71536 16.9413 7.93695 16.9719C8.14082 17 8.39334 17 8.6773 17H10.4579C10.7418 17 10.9944 17 11.1982 16.9719C11.4198 16.9413 11.6436 16.8706 11.8265 16.6827C12.0093 16.4947 12.078 16.2648 12.1078 16.037C12.1352 15.8275 12.1352 15.568 12.1352 15.2761V14.0017C12.1352 13.7098 12.1352 13.4503 12.1078 13.2407C12.078 13.013 12.0093 12.783 11.8265 12.5951C11.6436 12.4071 11.4198 12.3365 11.1982 12.3059C11.0078 12.2796 10.7749 12.2779 10.5136 12.2778H8.62165ZM15.3785 12.2778C15.6398 12.2779 15.8726 12.2796 16.063 12.3059C16.2846 12.3365 16.5084 12.4071 16.6913 12.5951C16.8741 12.783 16.9428 13.013 16.9726 13.2407C17 13.4503 17 13.7098 17 14.0017V15.2761C17 15.568 17 15.8275 16.9726 16.037C16.9428 16.2648 16.8741 16.4947 16.6913 16.6827C16.5084 16.8706 16.2846 16.9413 16.063 16.9719C15.8592 17 15.6066 17 15.3227 17L12.6133 17C12.7346 16.8332 12.7861 16.6427 12.8109 16.4537C12.8383 16.2442 12.8383 15.9846 12.8382 15.6928V13.3072C12.8383 13.0154 12.8383 12.7558 12.8109 12.5463C12.7991 12.4562 12.7812 12.3658 12.7526 12.2778L15.3785 12.2778Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-stacked-circle": {
        defaultColors: ["#000000"],
        keywords: ["box","boxes","stacked","circle","inventory","stock","warehouse","shipment","packages","orders","products","supply chain","storage","group","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-square-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","stacked","square","inventory","stock","storage","warehouse","product","items","packaging","shipment","receiving","back-stock","manage-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-square-3": {
        defaultColors: ["#000000"],
        keywords: ["boxes","inventory","stock","warehouse","packages","supplies","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9436 3.25H12.0564C13.8942 3.24999 15.3498 3.24997 16.489 3.40314C17.6614 3.56076 18.6104 3.89288 19.3588 4.64124C20.1071 5.38961 20.4392 6.33856 20.5969 7.51098C20.75 8.65018 20.75 10.1059 20.75 11.9436V12.0565C20.75 13.8942 20.75 15.3498 20.5969 16.489C20.4392 17.6614 20.1071 18.6104 19.3588 19.3588C18.6104 20.1071 17.6614 20.4392 16.489 20.5969C15.3498 20.75 13.8942 20.75 12.0564 20.75H11.9435C10.1058 20.75 8.65018 20.75 7.51098 20.5969C6.33856 20.4392 5.38961 20.1071 4.64124 19.3588C3.89288 18.6104 3.56076 17.6614 3.40314 16.489C3.24997 15.3498 3.24999 13.8942 3.25 12.0564V11.9436C3.24999 10.1058 3.24997 8.65019 3.40314 7.51098C3.56076 6.33856 3.89288 5.38961 4.64124 4.64124C5.38961 3.89288 6.33856 3.56076 7.51098 3.40314C8.65019 3.24997 10.1058 3.24999 11.9436 3.25ZM11.0541 6.77778C10.7928 6.77787 10.5599 6.77958 10.3694 6.8059C10.1478 6.83652 9.92406 6.90713 9.74119 7.09508C9.55831 7.28303 9.48962 7.513 9.45982 7.74074C9.43241 7.95028 9.43243 8.20982 9.43246 8.50168V9.77609C9.43243 10.0679 9.43241 10.3275 9.45982 10.537C9.48962 10.7648 9.55831 10.9947 9.74119 11.1827C9.92406 11.3706 10.1478 11.4413 10.3694 11.4719C10.5733 11.5 10.8258 11.5 11.1098 11.5H12.8903C13.1743 11.5 13.4268 11.5 13.6307 11.4719C13.8523 11.4413 14.076 11.3706 14.2589 11.1827C14.4418 10.9947 14.5105 10.7648 14.5403 10.537C14.5677 10.3275 14.5677 10.068 14.5676 9.77609V8.50169C14.5677 8.20983 14.5677 7.95028 14.5403 7.74074C14.5105 7.513 14.4418 7.28303 14.2589 7.09508C14.076 6.90713 13.8523 6.83652 13.6307 6.8059C13.4403 6.77958 13.2073 6.77787 12.946 6.77778H11.0541ZM8.62165 12.2778C8.36031 12.2779 8.1274 12.2796 7.93695 12.3059C7.71536 12.3365 7.49161 12.4071 7.30873 12.5951C7.12586 12.783 7.05716 13.013 7.02737 13.2407C6.99996 13.4503 6.99998 13.7098 7 14.0017V15.2761C6.99998 15.5679 6.99996 15.8275 7.02737 16.037C7.05716 16.2648 7.12586 16.4947 7.30873 16.6827C7.49161 16.8706 7.71536 16.9413 7.93695 16.9719C8.14082 17 8.39334 17 8.6773 17H10.4579C10.7418 17 10.9944 17 11.1982 16.9719C11.4198 16.9413 11.6436 16.8706 11.8265 16.6827C12.0093 16.4947 12.078 16.2648 12.1078 16.037C12.1352 15.8275 12.1352 15.568 12.1352 15.2761V14.0017C12.1352 13.7098 12.1352 13.4503 12.1078 13.2407C12.078 13.013 12.0093 12.783 11.8265 12.5951C11.6436 12.4071 11.4198 12.3365 11.1982 12.3059C11.0078 12.2796 10.7749 12.2779 10.5136 12.2778H8.62165ZM15.3785 12.2778C15.6398 12.2779 15.8726 12.2796 16.063 12.3059C16.2846 12.3365 16.5084 12.4071 16.6913 12.5951C16.8741 12.783 16.9428 13.013 16.9726 13.2407C17 13.4503 17 13.7098 17 14.0017V15.2761C17 15.568 17 15.8275 16.9726 16.037C16.9428 16.2648 16.8741 16.4947 16.6913 16.6827C16.5084 16.8706 16.2846 16.9413 16.063 16.9719C15.8592 17 15.6066 17 15.3227 17L12.6133 17C12.7346 16.8332 12.7861 16.6427 12.8109 16.4537C12.8383 16.2442 12.8383 15.9846 12.8382 15.6928V13.3072C12.8383 13.0154 12.8383 12.7558 12.8109 12.5463C12.7991 12.4562 12.7812 12.3658 12.7526 12.2778L15.3785 12.2778Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-stacked-square": {
        defaultColors: ["#000000"],
        keywords: ["box","package","boxes","packages","multiple","stacked","inventory","stock","storage","warehouse","shipment","deliveries","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked-square-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["inventory","stock","products","items","boxes","storage","warehouse","quantity","bulk","group","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    fillOpacity="0.85098"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14.6V14.4C7 13.2686 7 12.7029 7.35147 12.3515C7.70294 12 8.26863 12 9.4 12H9.6C10.7314 12 11.2971 12 11.6485 12.3515C12 12.7029 12 13.2686 12 14.4V14.6C12 15.7314 12 16.2971 11.6485 16.6485C11.2971 17 10.7314 17 9.6 17H9.4C8.26863 17 7.70294 17 7.35147 16.6485C7 16.2971 7 15.7314 7 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14.6V14.4C12 13.2686 12 12.7029 12.3515 12.3515C12.7029 12 13.2686 12 14.4 12H14.6C15.7314 12 16.2971 12 16.6485 12.3515C17 12.7029 17 13.2686 17 14.4V14.6C17 15.7314 17 16.2971 16.6485 16.6485C16.2971 17 15.7314 17 14.6 17H14.4C13.2686 17 12.7029 17 12.3515 16.6485C12 16.2971 12 15.7314 12 14.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.5 9.6V9.4C9.5 8.26863 9.5 7.70294 9.85147 7.35147C10.2029 7 10.7686 7 11.9 7H12.1C13.2314 7 13.7971 7 14.1485 7.35147C14.5 7.70294 14.5 8.26863 14.5 9.4V9.6C14.5 10.7314 14.5 11.2971 14.1485 11.6485C13.7971 12 13.2314 12 12.1 12H11.9C10.7686 12 10.2029 12 9.85147 11.6485C9.5 11.2971 9.5 10.7314 9.5 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-stacked": {
        defaultColors: ["#000000"],
        keywords: ["boxes","stacked","inventory","stock","products","warehouse","storage","shipment","supplies"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.5 17.6V15.4C3.5 14.2686 3.5 13.7029 3.85147 13.3515C4.20294 13 4.76863 13 5.9 13H9.1C10.2314 13 10.7971 13 11.1485 13.3515C11.5 13.7029 11.5 14.2686 11.5 15.4V17.6C11.5 18.7314 11.5 19.2971 11.1485 19.6485C10.7971 20 10.2314 20 9.1 20H5.9C4.76863 20 4.20294 20 3.85147 19.6485C3.5 19.2971 3.5 18.7314 3.5 17.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.5 15H7.8C8.12998 15 8.29497 15 8.39749 14.8975C8.5 14.795 8.5 14.63 8.5 14.3V13.7C8.5 13.37 8.5 13.205 8.39749 13.1025C8.29497 13 8.12998 13 7.8 13H7.2C6.87002 13 6.70503 13 6.60251 13.1025C6.5 13.205 6.5 13.37 6.5 13.7V14.3C6.5 14.63 6.5 14.795 6.60251 14.8975C6.70503 15 6.87002 15 7.2 15H7.5Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H16.5H18.1C19.2314 13 19.7971 13 20.1485 13.3515C20.5 13.7029 20.5 14.2686 20.5 15.4V17.6C20.5 18.7314 20.5 19.2971 20.1485 19.6485C19.7971 20 19.2314 20 18.1 20H16.5H14"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5 15H16.8C17.13 15 17.295 15 17.3975 14.8975C17.5 14.795 17.5 14.63 17.5 14.3V13.7C17.5 13.37 17.5 13.205 17.3975 13.1025C17.295 13 17.13 13 16.8 13H16.2C15.87 13 15.705 13 15.6025 13.1025C15.5 13.205 15.5 13.37 15.5 13.7V14.3C15.5 14.63 15.5 14.795 15.6025 14.8975C15.705 15 15.87 15 16.2 15H16.5Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8.1V5.9C8 4.76863 8 4.20294 8.35147 3.85147C8.70294 3.5 9.26863 3.5 10.4 3.5H13.6C14.7314 3.5 15.2971 3.5 15.6485 3.85147C16 4.20294 16 4.76863 16 5.9V8.1C16 9.23137 16 9.79706 15.6485 10.1485C15.2971 10.5 14.7314 10.5 13.6 10.5H12H10.4C9.26863 10.5 8.70294 10.5 8.35147 10.1485C8 9.79706 8 9.23137 8 8.1Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 5.5H12.3C12.63 5.5 12.795 5.5 12.8975 5.39749C13 5.29497 13 5.12998 13 4.8V4.2C13 3.87002 13 3.70503 12.8975 3.60251C12.795 3.5 12.63 3.5 12.3 3.5H11.7C11.37 3.5 11.205 3.5 11.1025 3.60251C11 3.70503 11 3.87002 11 4.2V4.8C11 5.12998 11 5.29497 11.1025 5.39749C11.205 5.5 11.37 5.5 11.7 5.5H12Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-storage-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["storage","box","layers","inventory","stock","warehouse","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11L5 8L12 5L19 8L12 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L12 15L19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16.2002L12 19.0002L19 16.2002"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-storage-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["stack","layers","storage","inventory","warehouse","tiers","organization","levels"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11L5 8L12 5L19 8L12 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L12 15L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16.2002L12 19.0002L19 16.2002"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-tape-1": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["box","package","inventory","stock","subtract","remove","reduce","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 9H11C10.0572 9 9.58579 9 9.29289 8.70711C9 8.41421 9 7.94281 9 7C9 6.05719 9 5.58579 9.29289 5.29289C9.58579 5 10.0572 5 11 5H13C13.9428 5 14.4142 5 14.7071 5.29289C15 5.58579 15 6.05719 15 7C15 7.94281 15 8.41421 14.7071 8.70711C14.4142 9 13.9428 9 13 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-storage": {
        defaultColors: ["#3D4C66"],
        keywords: ["layers","stack","inventory","stock","storage","warehouse","organization","grouping","tiers","levels","shelves"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11L5 8L12 5L19 8L12 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12L12 15L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16.2002L12 19.0002L19 16.2002"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-storage-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["storage","layers","inventory","stock","organization","stack","group","categories","tiers","shelves"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3942 4.08085C12.1426 3.97305 11.8579 3.97305 11.6063 4.08085L4.60632 7.08085C4.23864 7.23843 4.00024 7.59997 4.00024 8C4.00024 8.40003 4.23864 8.76157 4.60632 8.91915L11.6063 11.9191C11.8579 12.027 12.1426 12.027 12.3942 11.9191L19.3942 8.91915C19.7618 8.76157 20.0002 8.40003 20.0002 8C20.0002 7.59997 19.7618 7.23843 19.3942 7.08085L12.3942 4.08085Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.08111 11.6061C4.29867 11.0985 4.88655 10.8633 5.39418 11.0809L12.0003 13.912L18.6063 11.0809C19.114 10.8633 19.7018 11.0985 19.9194 11.6061C20.137 12.1137 19.9018 12.7016 19.3942 12.9192L12.3942 15.9192C12.1426 16.027 11.8579 16.027 11.6063 15.9192L4.60634 12.9192C4.09871 12.7016 3.86356 12.1137 4.08111 11.6061Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.37166 15.2715C4.85887 15.0664 4.2769 15.3158 4.07179 15.8286C3.86668 16.3414 4.11609 16.9233 4.62888 17.1284L11.6289 19.9284C11.8673 20.0238 12.1332 20.0238 12.3717 19.9284L19.3717 17.1284C19.8844 16.9233 20.1339 16.3414 19.9287 15.8286C19.7236 15.3158 19.1417 15.0664 18.6289 15.2715L12.0003 17.9229L5.37166 15.2715Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-tape-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","remove","minus","order","remove-order","delete-order","item","inventory","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 4.25H9.75V7C9.75 7.49261 9.75159 7.78661 9.77992 7.99734C9.79291 8.09389 9.8082 8.14226 9.81716 8.16404C9.81923 8.16908 9.82085 8.1724 9.82186 8.17433L9.82324 8.17676L9.82567 8.17814C9.8276 8.17915 9.83092 8.18077 9.83596 8.18284C9.85774 8.1918 9.90611 8.20709 10.0027 8.22008C10.2134 8.24841 10.5074 8.25 11 8.25H13C13.4926 8.25 13.7866 8.24841 13.9973 8.22008C14.0939 8.20709 14.1423 8.1918 14.164 8.18284C14.1691 8.18077 14.1724 8.17915 14.1743 8.17814L14.1768 8.17676L14.1781 8.17433L14.1803 8.16999L14.1828 8.16404C14.1918 8.14226 14.2071 8.09389 14.2201 7.99734C14.2484 7.78661 14.25 7.49261 14.25 7V4.25ZM6.70552 4.32991C7.13898 4.27164 7.65449 4.25584 8.25 4.25157V7L8.25 7.04475C8.24995 7.47756 8.2499 7.8744 8.2933 8.19721C8.34109 8.55269 8.45354 8.92841 8.76256 9.23744C9.07159 9.54646 9.44731 9.65891 9.80279 9.7067C10.1256 9.7501 10.5224 9.75005 10.9553 9.75L11 9.75H13L13.0447 9.75C13.4776 9.75005 13.8744 9.7501 14.1972 9.7067C14.5527 9.65891 14.9284 9.54646 15.2374 9.23744C15.5465 8.92841 15.6589 8.55269 15.7067 8.19721C15.7501 7.8744 15.7501 7.47756 15.75 7.04474L15.75 7V4.25157C16.3455 4.25584 16.861 4.27164 17.2945 4.32991C17.9223 4.41432 18.4891 4.59999 18.9445 5.05546C19.4 5.51093 19.5857 6.07773 19.6701 6.70552C19.7501 7.3003 19.75 8.04954 19.75 8.94801V15.052C19.75 15.9505 19.7501 16.6997 19.6701 17.2945C19.5857 17.9223 19.4 18.4891 18.9445 18.9445C18.4891 19.4 17.9223 19.5857 17.2945 19.6701C16.6997 19.7501 15.9505 19.75 15.052 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052V8.94797C4.24997 8.0495 4.24995 7.3003 4.32991 6.70552C4.41432 6.07773 4.59999 5.51093 5.05546 5.05546C5.51093 4.59999 6.07773 4.41432 6.70552 4.32991ZM9.25 14C9.25 13.5858 9.58579 13.25 10 13.25H14C14.4142 13.25 14.75 13.5858 14.75 14C14.75 14.4142 14.4142 14.75 14 14.75H10C9.58579 14.75 9.25 14.4142 9.25 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Box-tape-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","remove","minus","order","remove-order","inventory","decrease-inventory","shipment","decrease","withdrawal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V7C9 7.94281 9 8.41421 9.29289 8.70711C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 8.70711C15 8.41421 15 7.94281 15 7V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Box-tape": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","package","delivery","shipping","order","inventory","stock","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5V7C9 7.94281 9 8.41421 9.29289 8.70711C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 8.70711C15 8.41421 15 7.94281 15 7V5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-taped-2": {
        defaultColors: ["#CDD1D8", "#3D4C66"],
        keywords: ["box","package","sealed","shipment","delivery","stock","inventory","container","taped","close","full-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7262 11.7877L12.7941 11.8239C13.4394 12.1679 13.762 12.3399 14.0254 12.3332C14.3765 12.3243 14.6971 12.1319 14.8702 11.8263C15 11.5971 15 11.2314 15 10.5001C15 10.0341 15 9.80104 14.9238 9.61722C14.8223 9.37227 14.6277 9.17765 14.3828 9.07616C14.199 9 13.9659 9 13.4999 9H10.4999C10.0341 9 9.80114 9 9.61741 9.07608C9.37231 9.17758 9.17758 9.37231 9.07608 9.61741C9 9.80114 9 10.0341 9 10.4999C9 11.231 9 11.5965 9.12975 11.8257C9.30284 12.1315 9.62372 12.324 9.97499 12.3328C10.2383 12.3394 10.5608 12.1673 11.2059 11.8232L11.2721 11.7878L11.2722 11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4762 11.6544 12.7262 11.7877Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "box-taped-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["w","wave","link","connect","network","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "box-taped-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","shipping","delivery","order","packed","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.07897 4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53174 5.01875 6.0729C5.20434 5.58575 5.45019 5.15958 5.86918 4.83244C6.28817 4.5053 6.76124 4.37015 7.27886 4.30826C7.76639 4.24996 8.36667 4.24998 9.07897 4.25ZM4.25 9.75L4.25001 15.052C4.24998 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70553 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052L19.75 9.75H15.75V10.4542C15.75 10.8277 15.75 11.1539 15.7281 11.4158C15.7059 11.6822 15.655 11.9898 15.4804 12.2668C15.1839 12.7371 14.6815 13.0386 14.1271 13.0789C13.8004 13.1027 13.505 13.0028 13.2594 12.8971C13.018 12.7932 12.73 12.6397 12.4003 12.4639L12.3735 12.4495C12.242 12.3794 12.1675 12.34 12.1099 12.3129C12.0741 12.2961 12.0584 12.2907 12.0542 12.2894C12.0179 12.2813 11.9802 12.2813 11.944 12.2895C11.94 12.2907 11.9247 12.296 11.8886 12.3129C11.831 12.34 11.7566 12.3794 11.6252 12.4496L11.5983 12.4639C11.2693 12.6394 10.982 12.7927 10.741 12.8965C10.496 13.0021 10.2012 13.102 9.87504 13.0786C9.31917 13.0389 8.81548 12.7367 8.51873 12.265C8.34463 11.9882 8.29398 11.6811 8.27179 11.4152C8.24996 11.1537 8.24998 10.828 8.24999 10.4551L8.24999 9.75H4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "box-taped": {
        defaultColors: ["#000000"],
        keywords: ["box","package","inventory","shipping","delivery","item","stock","products","order-fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V10.4247C9 11.2226 9 11.6215 9.15356 11.8656C9.32314 12.1351 9.61096 12.3078 9.9286 12.3306C10.2163 12.3511 10.5682 12.1634 11.2722 11.7878V11.7878C11.5221 11.6545 11.6471 11.5878 11.778 11.5581C11.9236 11.5251 12.0747 11.5251 12.2203 11.5581C12.3513 11.5877 12.4763 11.6544 12.7263 11.7877V11.7877C13.4317 12.1638 13.7845 12.3519 14.0726 12.3309C14.3895 12.3079 14.6765 12.1356 14.8459 11.8669C15 11.6225 15 11.2229 15 10.4238V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Box: {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","inventory","shipping","delivery","item","stock","products","order-fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 15H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "boxes-pallet-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["boxes","pallet","inventory","stock","storage","warehouse","shipping","delivery","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 7H16.3C16.63 7 16.795 7 16.8975 6.89749C17 6.79497 17 6.62998 17 6.3V5.7C17 5.37002 17 5.20503 16.8975 5.10251C16.795 5 16.63 5 16.3 5H15.7C15.37 5 15.205 5 15.1025 5.10251C15 5.20503 15 5.37002 15 5.7V6.3C15 6.62998 15 6.79497 15.1025 6.89749C15.205 7 15.37 7 15.7 7H16Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 5H16H17.6C18.7314 5 19.2971 5 19.6485 5.35147C20 5.70294 20 6.26863 20 7.4V9.6C20 10.7314 20 11.2971 19.6485 11.6485C19.2971 12 18.7314 12 17.6 12H16H14.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "boxes-pallet-3": {
        defaultColors: ["#000000"],
        keywords: ["boxes","pallet","inventory","stock","shipping","receiving","warehouse","storage","delivery","supply chain","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H19.75V19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20C2.25 19.5858 2.58579 19.25 3 19.25H4.25V15.75H3C2.58579 15.75 2.25 15.4142 2.25 15ZM18.25 19.25V15.75H12.75V19.25H18.25ZM5.75 15.75H11.25V19.25H5.75V15.75Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M6.25003 4.25C5.76656 4.25016 5.33567 4.25325 4.98334 4.30062C4.5734 4.35573 4.15946 4.48283 3.82115 4.82114C3.48283 5.15945 3.35574 5.57339 3.30063 5.98334C3.24992 6.3605 3.24996 6.82768 3.25 7.35303V9.64696C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8405 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.75 6.35301 12.75H9.64697C10.1723 12.75 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8405 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64696V7.35304C12.7501 6.82769 12.7501 6.3605 12.6994 5.98334C12.6443 5.57339 12.5172 5.15945 12.1789 4.82114C11.8406 4.48283 11.4266 4.35573 11.0167 4.30062C10.6643 4.25325 10.2335 4.25016 9.75003 4.25L9.75004 6.32833C9.75014 6.46734 9.75026 6.63721 9.73053 6.78397C9.70653 6.96245 9.64168 7.21398 9.42785 7.42781C9.21401 7.64164 8.96248 7.70649 8.78401 7.73049C8.63724 7.75022 8.46738 7.7501 8.32836 7.75001H7.67169C7.53267 7.7501 7.36281 7.75022 7.21605 7.73049C7.03757 7.70649 6.78604 7.64164 6.57221 7.42781C6.35838 7.21398 6.29352 6.96245 6.26953 6.78397C6.2498 6.6372 6.24992 6.46734 6.25001 6.32833L6.25003 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.896 4.25L14.896 6.32833C14.8959 6.46735 14.8958 6.63721 14.9155 6.78398C14.9395 6.96245 15.0044 7.21398 15.2182 7.42781C15.432 7.64165 15.6836 7.7065 15.862 7.73049C16.0088 7.75023 16.1787 7.75011 16.3177 7.75001H16.9744C17.1134 7.75011 17.2832 7.75023 17.43 7.73049C17.6085 7.7065 17.86 7.64165 18.0738 7.42781C18.2877 7.21398 18.3525 6.96245 18.3765 6.78398C18.3963 6.63721 18.3961 6.46736 18.396 6.32835L18.396 4.25655C18.6219 4.26296 18.8297 4.27562 19.0157 4.30062C19.4256 4.35574 19.8396 4.48283 20.1779 4.82114C20.5162 5.15946 20.6433 5.5734 20.6984 5.98334C20.7491 6.3605 20.7491 6.8277 20.749 7.35304V9.64699C20.7491 10.1723 20.7491 10.6395 20.6984 11.0167C20.6433 11.4266 20.5162 11.8405 20.1779 12.1789C19.8396 12.5172 19.4256 12.6443 19.0157 12.6994C18.6385 12.7501 18.1713 12.75 17.646 12.75L13.2803 12.75C13.5047 12.4498 13.6 12.1069 13.6458 11.7667C13.6965 11.3895 13.6964 10.9223 13.6964 10.397V6.10303C13.6964 5.57769 13.6965 5.1105 13.6458 4.73334C13.624 4.57121 13.5909 4.40846 13.538 4.25L14.896 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "boxes-pallet-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["boxes","pallet","stock","inventory","warehouse","shipping","receiving","storage","products","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H19.75V19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20C2.25 19.5858 2.58579 19.25 3 19.25H4.25V15.75H3C2.58579 15.75 2.25 15.4142 2.25 15ZM18.25 19.25V15.75H12.75V19.25H18.25ZM5.75 15.75H11.25V19.25H5.75V15.75Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M6.35304 4.25C5.82769 4.24996 5.36051 4.24992 4.98334 4.30063C4.5734 4.35574 4.15946 4.48283 3.82115 4.82115C3.48283 5.15946 3.35574 5.5734 3.30063 5.98334C3.24992 6.36051 3.24996 6.82769 3.25 7.35304V9.64697C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8406 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.7501 6.35301 12.75H9.64697C10.1723 12.7501 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8406 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64697V7.35305C12.7501 6.82769 12.7501 6.36051 12.6994 5.98334C12.6443 5.5734 12.5172 5.15946 12.1789 4.82115C11.8406 4.48283 11.4266 4.35574 11.0167 4.30063C10.6395 4.24992 10.1723 4.24996 9.64697 4.25H6.35304Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9.75003 4.25H6.25003L6.25001 6.32833C6.24992 6.46735 6.2498 6.63721 6.26953 6.78398C6.29352 6.96246 6.35838 7.21398 6.57221 7.42782C6.78604 7.64165 7.03757 7.7065 7.21605 7.7305C7.36281 7.75023 7.53267 7.75011 7.67169 7.75001H8.32836C8.46738 7.75011 8.63724 7.75023 8.78401 7.7305C8.96248 7.7065 9.21401 7.64165 9.42785 7.42782C9.64168 7.21398 9.70653 6.96246 9.73053 6.78398C9.75026 6.63721 9.75014 6.46735 9.75004 6.32834L9.75003 4.25Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2798 12.75L17.6455 12.75C18.1708 12.7501 18.6381 12.7501 19.0152 12.6994C19.4252 12.6443 19.8391 12.5172 20.1774 12.1789C20.5157 11.8406 20.6428 11.4266 20.6979 11.0167C20.7486 10.6395 20.7486 10.1723 20.7486 9.647V7.35305C20.7486 6.82771 20.7486 6.3605 20.6979 5.98334C20.6428 5.5734 20.5157 5.15946 20.1774 4.82115C19.8391 4.48283 19.4252 4.35574 19.0152 4.30063C18.638 4.24992 18.1709 4.24996 17.6455 4.25L13.5375 4.25001C13.5904 4.40846 13.6235 4.57121 13.6453 4.73334C13.696 5.11051 13.6959 5.57769 13.6959 6.10304V10.397C13.6959 10.9223 13.696 11.3895 13.6453 11.7667C13.5995 12.1069 13.5042 12.4498 13.2798 12.75Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M18.3955 4.25H14.8955L14.8955 6.32833C14.8954 6.46735 14.8953 6.63721 14.915 6.78398C14.939 6.96246 15.0039 7.21398 15.2177 7.42782C15.4316 7.64165 15.6831 7.7065 15.8616 7.7305C16.0083 7.75023 16.1782 7.75011 16.3172 7.75001H16.9739C17.1129 7.75011 17.2827 7.75023 17.4295 7.7305C17.608 7.7065 17.8595 7.64165 18.0734 7.42782C18.2872 7.21398 18.352 6.96246 18.376 6.78398C18.3958 6.63721 18.3956 6.46735 18.3955 6.32834L18.3955 4.25Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "boxes-pallet": {
        defaultColors: ["#000000"],
        keywords: ["boxes","pallet","inventory","stock","shipping","packages","warehouse","storage","products","delivery","supply","goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 5H16H17.6C18.7314 5 19.2971 5 19.6485 5.35147C20 5.70294 20 6.26863 20 7.4V9.6C20 10.7314 20 11.2971 19.6485 11.6485C19.2971 12 18.7314 12 17.6 12H16H14.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7H16.3C16.63 7 16.795 7 16.8975 6.89749C17 6.79497 17 6.62998 17 6.3V5.7C17 5.37002 17 5.20503 16.8975 5.10251C16.795 5 16.63 5 16.3 5H15.7C15.37 5 15.205 5 15.1025 5.10251C15 5.20503 15 5.37002 15 5.7V6.3C15 6.62998 15 6.79497 15.1025 6.89749C15.205 7 15.37 7 15.7 7H16Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "brackets-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["brackets","quote","options","formatting","settings","grouping","parentheses","data","code","conditional","expression"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 4H20V20H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H4V20L8 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "brackets-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["brackets","code","syntax","programming","options","settings","grouping","enclosure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 4H20V20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H4V20L8 20"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "brackets-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["brackets","code","programming","grouping","section","layout","open","close","delimiter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 4C15 3.44772 15.4477 3 16 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H19V5H16C15.4477 5 15 4.55228 15 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H5V19L8 19C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21L4 21C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bright-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["loading","waiting","processing","syncing","updating","spinner","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H20M16 16L18 18M12 17V20M6 18L8 16M4 12H7M8 8L6 6M12 7V4M16 8L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 16L18 18M12 17V20M6 18L8 16M8 8L6 6M12 7V4M16 8L18 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    brackets: {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","waiting","processing","syncing","updating","spinner","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 4H20V20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H4V20L8 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bright-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","spinner","waiting","processing","syncing","busy","loading-data","waiting-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7V4C11 3.44772 11.4477 3 12 3ZM5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L8.70711 7.29289C9.09763 7.68342 9.09763 8.31658 8.70711 8.70711C8.31658 9.09763 7.68342 9.09763 7.29289 8.70711L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289ZM18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289ZM3 12C3 11.4477 3.44772 11 4 11H7C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H4C3.44772 13 3 12.5523 3 12ZM16 12C16 11.4477 16.4477 11 17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H17C16.4477 13 16 12.5523 16 12ZM8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L7.29289 15.2929C7.68342 14.9024 8.31658 14.9024 8.70711 15.2929ZM17.2929 18.7071L15.2929 16.7071C14.9024 16.3166 14.9024 15.6834 15.2929 15.2929C15.6834 14.9024 16.3166 14.9024 16.7071 15.2929L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071ZM12 16C12.5523 16 13 16.4477 13 17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V17C11 16.4477 11.4477 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bright-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","spinner","waiting","processing","syncing","updating","busy","calculating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H20M16 16L18 18M12 17V20M6 18L8 16M4 12H7M8 8L6 6M12 7V4M16 8L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    bright: {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","spinner","waiting","processing","syncing","updating","busy","calculating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H20M16 16L18 18M12 17V20M6 18L8 16M4 12H7M8 8L6 6M12 7V4M16 8L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "broadcast-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["broadcast","signal","wifi","wireless","connection","network","transmit","send","update","availability","online","connected","radio","communications"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 13L12 19M12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","signal","connection","network","internet","broadcast","online","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C9.79086 6 8 7.79086 8 10C8 11.8638 9.27477 13.4299 11 13.874L11 19C10.9999 19.5523 11.4477 20 11.9999 20C12.5522 20 13 19.5523 13 19L13 13.874C14.7252 13.4299 16 11.8638 16 10C16 7.79086 14.2091 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.27008 5.36207C8.62241 5.78738 8.56325 6.41777 8.13795 6.7701C7.09333 7.63549 6.5 8.78206 6.5 10C6.5 11.218 7.09333 12.3646 8.13795 13.2299C8.56325 13.5823 8.62241 14.2127 8.27008 14.638C7.91775 15.0633 7.28735 15.1224 6.86205 14.7701C5.43526 13.5881 4.5 11.9063 4.5 10C4.5 8.0938 5.43526 6.41194 6.86205 5.22995C7.28735 4.87762 7.91774 4.93677 8.27008 5.36207Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7299 5.36207C15.3776 5.78738 15.4367 6.41777 15.862 6.7701C16.9067 7.63549 17.5 8.78206 17.5 10C17.5 11.218 16.9067 12.3646 15.862 13.2299C15.4367 13.5823 15.3776 14.2127 15.7299 14.638C16.0823 15.0633 16.7127 15.1224 17.138 14.7701C18.5647 13.5881 19.5 11.9063 19.5 10C19.5 8.0938 18.5647 6.41194 17.138 5.22995C16.7127 4.87762 16.0823 4.93677 15.7299 5.36207Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "broadcast-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["broadcast","alert","notification","signal","radio","communication","speaker","announcement","message","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C6.7643 8.02369 6 9.4379 6 11C6 12.5621 6.7643 13.9763 8 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7C17.2357 8.02369 18 9.4379 18 11C18 12.5621 17.2357 13.9763 16 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L9.12127 17.5149C9.30316 16.7874 9.3941 16.4236 9.66536 16.2118C9.93663 16 10.3116 16 11.0616 16H12.9384C13.6884 16 14.0634 16 14.3346 16.2118C14.6059 16.4236 14.6968 16.7874 14.8787 17.5149L15 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "broadcast-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["broadcast","speaker","promotion","discount","announcement","alert","notification","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C6.7643 8.02369 6 9.4379 6 11C6 12.5621 6.7643 13.9763 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7C17.2357 8.02369 18 9.4379 18 11C18 12.5621 17.2357 13.9763 16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L9.12127 17.5149C9.30316 16.7874 9.3941 16.4236 9.66536 16.2118C9.93663 16 10.3116 16 11.0616 16H12.9384C13.6884 16 14.0634 16 14.3346 16.2118C14.6059 16.4236 14.6968 16.7874 14.8787 17.5149L15 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "broadcast-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["broadcast","notification","announcement","alert","promotion","speaker","loudspeaker","message","attention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.18787 7.18948C8.56866 6.78946 8.55307 6.15648 8.15304 5.7757C7.75302 5.39491 7.12005 5.4105 6.73926 5.81052C5.66871 6.93515 5 8.39027 5 10C5 11.6097 5.66871 13.0649 6.73926 14.1895C7.12005 14.5895 7.75302 14.6051 8.15304 14.2243C8.55307 13.8435 8.56866 13.2105 8.18787 12.8105C7.42521 12.0093 7 11.0332 7 10C7 8.96681 7.42521 7.99067 8.18787 7.18948Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.2607 5.81052C16.88 5.4105 16.247 5.39491 15.847 5.7757C15.4469 6.15648 15.4313 6.78946 15.8121 7.18948C16.5748 7.99067 17 8.96681 17 10C17 11.0332 16.5748 12.0093 15.8121 12.8105C15.4313 13.2105 15.4469 13.8435 15.847 14.2243C16.247 14.6051 16.88 14.5895 17.2607 14.1895C18.3313 13.0649 19 11.6097 19 10C19 8.39027 18.3313 6.93515 17.2607 5.81052Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0162 14.5C10.6807 14.4999 10.347 14.4999 10.0652 14.5336C9.74405 14.572 9.38256 14.6639 9.04995 14.9236C8.71735 15.1833 8.54047 15.5117 8.42532 15.8139C8.3243 16.0791 8.24342 16.4029 8.16213 16.7284L8.02986 17.2575C7.89591 17.7933 8.22167 18.3362 8.75746 18.4701C9.29326 18.6041 9.83619 18.2783 9.97014 17.7425L10.0914 17.2575C10.1883 16.8701 10.2411 16.6656 10.2943 16.526L10.2965 16.5202L10.3027 16.5194C10.451 16.5017 10.6622 16.5 11.0616 16.5H12.9384C13.3378 16.5 13.549 16.5017 13.6973 16.5194L13.7035 16.5202L13.7057 16.526C13.7589 16.6656 13.8117 16.8701 13.9086 17.2575L14.0299 17.7425C14.1638 18.2783 14.7067 18.6041 15.2425 18.4701C15.7783 18.3362 16.1041 17.7933 15.9701 17.2575L15.8379 16.7284C15.7566 16.4029 15.6757 16.0791 15.5747 15.8139C15.4595 15.5117 15.2827 15.1833 14.95 14.9236C14.6174 14.6639 14.2559 14.572 13.9348 14.5336C13.653 14.4999 13.3193 14.4999 12.9838 14.5H11.0162Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.5 10C8.5 8.067 10.067 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "broadcast-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","wifi","network","connection","broadcast","wireless","online","connectivity","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5C3.7643 6.27961 3 8.04738 3 10C3 11.9526 3.7643 13.7204 5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5C20.2357 6.27961 21 8.04738 21 10C21 11.9526 20.2357 13.7204 19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["signal","wifi","broadcast","network","connection","connectivity","online","internet","wireless","hotspot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5C3.7643 6.27961 3 8.04738 3 10C3 11.9526 3.7643 13.7204 5 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5C20.2357 6.27961 21 8.04738 21 10C21 11.9526 20.2357 13.7204 19 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["signal","wifi","connection","network","broadcast","transmit","data","wireless","hotspot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5C3.7643 6.27961 3 8.04738 3 10C3 11.9526 3.7643 13.7204 5 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5C20.2357 6.27961 21 8.04738 21 10C21 11.9526 20.2357 13.7204 19 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","wifi","network","connection","broadcast","transmit","pos-network","wireless","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.69466 4.28066C6.09194 4.66431 6.10299 5.29738 5.71934 5.69466C4.65986 6.79178 4 8.31199 4 10C4 11.688 4.65986 13.2082 5.71934 14.3053C6.10299 14.7026 6.09194 15.3357 5.69466 15.7193C5.29738 16.103 4.66431 16.0919 4.28066 15.6947C2.86873 14.2326 2 12.2172 2 10C2 7.78277 2.86873 5.76744 4.28066 4.30534C4.66431 3.90806 5.29738 3.89701 5.69466 4.28066ZM8.77008 5.36207C9.12241 5.78738 9.06325 6.41777 8.63795 6.7701C7.59333 7.63549 7 8.78206 7 10C7 11.218 7.59333 12.3646 8.63795 13.2299C9.06325 13.5823 9.12241 14.2127 8.77008 14.638C8.41775 15.0633 7.78735 15.1224 7.36205 14.7701C5.93526 13.5881 5 11.9063 5 10C5 8.0938 5.93526 6.41194 7.36205 5.22995C7.78735 4.87762 8.41774 4.93677 8.77008 5.36207ZM18.2807 5.69466C17.897 5.29738 17.9081 4.66431 18.3053 4.28066C18.7026 3.89701 19.3357 3.90806 19.7193 4.30534C21.1313 5.76744 22 7.78277 22 10C22 12.2172 21.1313 14.2326 19.7193 15.6947C19.3357 16.0919 18.7026 16.103 18.3053 15.7193C17.9081 15.3357 17.897 14.7026 18.2807 14.3053C19.3401 13.2082 20 11.688 20 10C20 8.31199 19.3401 6.79178 18.2807 5.69466ZM15.2299 5.36207C14.8776 5.78738 14.9367 6.41777 15.362 6.7701C16.4067 7.63549 17 8.78206 17 10C17 11.218 16.4067 12.3646 15.362 13.2299C14.9367 13.5823 14.8776 14.2127 15.2299 14.638C15.5823 15.0633 16.2127 15.1224 16.638 14.7701C18.0647 13.5881 19 11.9063 19 10C19 8.0938 18.0647 6.41194 16.638 5.22995C16.2127 4.87762 15.5823 4.93677 15.2299 5.36207ZM12 6C9.79086 6 8 7.79086 8 10C8 11.8639 9.27479 13.43 11 13.874L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19L13 13.874C14.7252 13.4299 16 11.8638 16 10C16 7.79086 14.2091 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "broadcast-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["broadcast","wifi","signal","network","connection","online","connected","wireless","communication","transmit","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13L12 19M12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","signal","connection","network","broadcast","connectivity","internet","router","online","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13L12 19M12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6C6.7643 7.02369 6 8.4379 6 10C6 11.5621 6.7643 12.9763 8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6C17.2357 7.02369 18 8.4379 18 10C18 11.5621 17.2357 12.9763 16 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-tower-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["broadcast","tower","signal","communication","radio","transmission","wireless","network","online","updates","notifications","connectivity","remote","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 12.9598C17.3284 11.9464 18 10.5464 18 9C18 7.43305 17.3105 6.01641 16.1991 5M7.80087 5C6.68954 6.01641 6 7.43305 6 9C6 10.567 6.68954 11.9836 7.80087 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="9" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.323 19H10.677C9.36002 19 8.70155 19 8.4052 18.6836C8.26059 18.5292 8.16867 18.333 8.14264 18.123C8.0893 17.6928 8.51085 17.187 9.35394 16.1753C10.3731 14.9523 10.8827 14.3408 11.5181 14.183C11.8345 14.1045 12.1655 14.1045 12.4819 14.183C13.1173 14.3408 13.6269 14.9523 14.6461 16.1753C15.4892 17.187 15.9107 17.6928 15.8574 18.123C15.8313 18.333 15.7394 18.5292 15.5948 18.6836C15.2985 19 14.64 19 13.323 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-tower-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["broadcast","tower","wifi","signal","communication","connection","network","transmit","receive","connectivity","online","hotspot","internet","radio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 12.9598C17.3284 11.9464 18 10.5464 18 9C18 7.43305 17.3105 6.01641 16.1991 5M7.80087 5C6.68954 6.01641 6 7.43305 6 9C6 10.567 6.68954 11.9836 7.80087 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="9"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.323 19H10.677C9.36002 19 8.70155 19 8.4052 18.6836C8.26059 18.5292 8.16867 18.333 8.14264 18.123C8.0893 17.6928 8.51085 17.187 9.35394 16.1753C10.3731 14.9523 10.8827 14.3408 11.5181 14.183C11.8345 14.1045 12.1655 14.1045 12.4819 14.183C13.1173 14.3408 13.6269 14.9523 14.6461 16.1753C15.4892 17.187 15.9107 17.6928 15.8574 18.123C15.8313 18.333 15.7394 18.5292 15.5948 18.6836C15.2985 19 14.64 19 13.323 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broadcast-tower-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["person","signal","wireless","broadcast","communication","alert","notification","promotion","sale","offer","discount","news","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.53879 4.32511C8.91152 4.73265 8.8833 5.36519 8.47576 5.73792C7.5541 6.58087 7 7.73659 7 9.00001C7 10.2634 7.5541 11.4191 8.47576 12.2621C8.8833 12.6348 8.91152 13.2674 8.53879 13.6749C8.16605 14.0824 7.53352 14.1107 7.12598 13.7379C5.82499 12.548 5 10.8705 5 9.00001C5 7.12952 5.82499 5.45197 7.12598 4.26209C7.53352 3.88936 8.16605 3.91757 8.53879 4.32511ZM15.4612 4.32511C15.8339 3.91757 16.4665 3.88936 16.874 4.26209C18.175 5.45197 19 7.12952 19 9.00001C19 10.8458 18.1966 12.504 16.925 13.6909C16.5212 14.0677 15.8884 14.0459 15.5116 13.6421C15.1348 13.2384 15.1566 12.6056 15.5603 12.2287C16.4603 11.3888 17 10.247 17 9.00001C17 7.73659 16.4459 6.58087 15.5242 5.73792C15.1167 5.36519 15.0885 4.73265 15.4612 4.32511Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 9.00001C8.5 7.06701 10.067 5.50001 12 5.50001C13.933 5.50001 15.5 7.06701 15.5 9.00001C15.5 10.933 13.933 12.5 12 12.5C10.067 12.5 8.5 10.933 8.5 9.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3373 13.4551C11.7725 13.3471 12.2275 13.3471 12.6627 13.4551C13.1666 13.5803 13.5676 13.8764 13.9433 14.2424C14.3057 14.5953 14.7088 15.079 15.1962 15.664L15.2499 15.7283C15.6478 16.2058 15.9855 16.6111 16.2122 16.9517C16.435 17.2864 16.6634 17.7171 16.6017 18.2153C16.5561 18.5827 16.3952 18.9262 16.1422 19.1963C15.799 19.5628 15.3218 19.663 14.9221 19.7061C14.5153 19.7501 13.9878 19.75 13.3662 19.75H10.6338C10.0122 19.75 9.48468 19.7501 9.07785 19.7061C8.6782 19.663 8.20104 19.5628 7.85783 19.1963C7.60476 18.9262 7.44388 18.5827 7.39834 18.2153C7.33657 17.7171 7.56505 17.2864 7.78775 16.9517C8.01445 16.6111 8.35217 16.2058 8.75011 15.7283C8.7593 15.7173 8.76852 15.7062 8.77777 15.6951L8.80376 15.664C9.29121 15.079 9.69429 14.5953 10.0567 14.2424C10.4324 13.8764 10.8334 13.5803 11.3373 13.4551Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "broken heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["heart","split","separated","broken","loyalty","reward","unfavorite","unlike","customer","profile","relationship","engagement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.12061 12.727L11 18V7.63679L10.5314 7.15417C9.03726 5.61528 6.61476 5.61528 5.12061 7.15417C3.62646 8.69307 3.62646 11.1881 5.12061 12.727Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8794 12.727L13 18V7.63679L13.4686 7.15417C14.9627 5.61528 17.3852 5.61528 18.8794 7.15417C20.3735 8.69307 20.3735 11.1881 18.8794 12.727Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broken heart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","split","broken","customer","loyalty","discount","split-bill","problem","error","customer-issue","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.12061 12.727L11 18V7.63679L10.5314 7.15417C9.03726 5.61528 6.61476 5.61528 5.12061 7.15417C3.62646 8.69307 3.62646 11.1881 5.12061 12.727Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8794 12.727L13 18V7.63679L13.4686 7.15417C14.9627 5.61528 17.3852 5.61528 18.8794 7.15417C20.3735 8.69307 20.3735 11.1881 18.8794 12.727Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    broadcast: {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","split","broken","customer","loyalty","discount","split-bill","problem","error","customer-issue","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C6.7643 8.02369 6 9.4379 6 11C6 12.5621 6.7643 13.9763 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7C17.2357 8.02369 18 9.4379 18 11C18 12.5621 17.2357 13.9763 16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L9.12127 17.5149C9.30316 16.7874 9.3941 16.4236 9.66536 16.2118C9.93663 16 10.3116 16 11.0616 16H12.9384C13.6884 16 14.0634 16 14.3346 16.2118C14.6059 16.4236 14.6968 16.7874 14.8787 17.5149L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "broken heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","broken","split","loyalty-program","rewards","cancel","refund","remove","discount","customer","loyalty","demote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.8901 6.80587L11.3587 7.28849C11.4493 7.3818 11.5 7.50674 11.5 7.63679V18C11.5 18.1973 11.384 18.3761 11.2038 18.4566C11.0237 18.537 10.813 18.504 10.6662 18.3722L4.78678 13.0992C4.77821 13.0916 4.7699 13.0836 4.76188 13.0753C3.07937 11.3424 3.07937 8.53877 4.76188 6.80587C6.45242 5.06471 9.19961 5.06471 10.8901 6.80587Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1099 6.80587L12.6413 7.28849C12.5507 7.3818 12.5 7.50674 12.5 7.63679V18C12.5 18.1973 12.616 18.3761 12.7962 18.4566C12.9763 18.537 13.187 18.504 13.3338 18.3722L19.2132 13.0992C19.2218 13.0916 19.2301 13.0836 19.2381 13.0753C20.9206 11.3424 20.9206 8.53877 19.2381 6.80587C17.5476 5.06471 14.8004 5.06471 13.1099 6.80587Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "broadcast-tower": {
        defaultColors: ["#3D4C66"],
        keywords: ["broadcast","tower","signal","wifi","radio","promotion","discount","announcement","notification","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 12.9598C17.3284 11.9464 18 10.5464 18 9C18 7.43305 17.3105 6.01641 16.1991 5M7.80087 5C6.68954 6.01641 6 7.43305 6 9C6 10.567 6.68954 11.9836 7.80087 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="9" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.323 19H10.677C9.36002 19 8.70155 19 8.4052 18.6836C8.26059 18.5292 8.16867 18.333 8.14264 18.123C8.0893 17.6928 8.51085 17.187 9.35394 16.1753C10.3731 14.9523 10.8827 14.3408 11.5181 14.183C11.8345 14.1045 12.1655 14.1045 12.4819 14.183C13.1173 14.3408 13.6269 14.9523 14.6461 16.1753C15.4892 17.187 15.9107 17.6928 15.8574 18.123C15.8313 18.333 15.7394 18.5292 15.5948 18.6836C15.2985 19 14.64 19 13.323 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "broken heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","broken","disconnect","unlink","cancel","void","refund","loyalty","reward","discount","unfavorite","unlike","block","deactivate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.12061 12.727L11 18V7.63679L10.5314 7.15417C9.03726 5.61528 6.61476 5.61528 5.12061 7.15417C3.62646 8.69307 3.62646 11.1881 5.12061 12.727Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8794 12.727L13 18V7.63679L13.4686 7.15417C14.9627 5.61528 17.3852 5.61528 18.8794 7.15417C20.3735 8.69307 20.3735 11.1881 18.8794 12.727Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "brush-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["brush","paint","edit","customize","appearance","settings","design","themes","style","format","cosmetic","apply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19V14H14V19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 15H11C8.17157 15 6.75736 15 5.87868 14.1213C5 13.2426 5 11.8284 5 9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3H13C15.8284 3 17.2426 3 18.1213 3.87868C19 4.75736 19 6.17157 19 9C19 11.8284 19 13.2426 18.1213 14.1213C17.2426 15 15.8284 15 13 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 11L19 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 3V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 3V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "brush-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["brush","paint","customize","design","edit","artwork","style","settings","theme"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11L19 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 3V8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 3V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 15H11C8.17157 15 6.75736 15 5.87868 14.1213C5 13.2426 5 11.8284 5 9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3H13C15.8284 3 17.2426 3 18.1213 3.87868C19 4.75736 19 6.17157 19 9C19 11.8284 19 13.2426 18.1213 14.1213C17.2426 15 15.8284 15 13 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 15V19C10 20.1046 10.8954 21 12 21V21C13.1046 21 14 20.1046 14 19V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    brush: {
        defaultColors: ["#3D4C66"],
        keywords: ["brush","paint","customize","design","edit","artwork","style","settings","theme"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11L19 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 3V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 3V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 15H11C8.17157 15 6.75736 15 5.87868 14.1213C5 13.2426 5 11.8284 5 9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3H13C15.8284 3 17.2426 3 18.1213 3.87868C19 4.75736 19 6.17157 19 9C19 11.8284 19 13.2426 18.1213 14.1213C17.2426 15 15.8284 15 13 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 15V19C10 20.1046 10.8954 21 12 21V21C13.1046 21 14 20.1046 14 19V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bubble-chart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bubble chart","graph","sales","inventory","statistics","data","analytics","trends","circle","diagram","visualization","insights","reporting","performance","kpi"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="8" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="17" cy="18" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "brush-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["brush","paint","art","customize","design","appearance","color","edit","modify","settings","theme","style"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9294 2H12V4.5C12 5.32843 12.4477 6 13 6C13.5523 6 14 5.32843 14 4.5V2.0016C14.9447 2.00673 15.7523 2.02831 16.4251 2.11876C17.3529 2.2435 18.1723 2.51547 18.8284 3.17158C19.4845 3.82769 19.7565 4.64711 19.8813 5.57494C20.0001 6.4587 20 7.71646 20 9.07058V9.07199C20 9.39467 20 9.70424 19.9984 10L4.0016 10C3.99999 9.70393 3.99999 9.39441 4 9.07136C3.99997 7.71724 3.99994 6.4587 4.11876 5.57494C4.2435 4.64711 4.51547 3.82769 5.17158 3.17158C5.82769 2.51547 6.64711 2.2435 7.57494 2.11876C7.7111 2.10045 7.85278 2.08497 8 2.07187V7.71429C8 8.42437 8.44772 9 9 9C9.55229 9 10 8.42437 10 7.71429V2.0016C10.2961 1.99999 10.6063 1.99999 10.9294 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.07187 12L19.9281 12C19.915 12.1472 19.8996 12.2889 19.8813 12.4251C19.7565 13.3529 19.4845 14.1723 18.8284 14.8284C18.1723 15.4845 17.3529 15.7565 16.4251 15.8813C16.0033 15.938 15.5284 15.9676 15 15.9831V19C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19V15.9831C8.4716 15.9676 7.99675 15.938 7.57494 15.8813C6.64711 15.7565 5.82769 15.4845 5.17158 14.8284C4.51547 14.1723 4.2435 13.3529 4.11876 12.4251C4.10045 12.2889 4.08497 12.1472 4.07187 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bubble-chart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sales data","chart","graphs","analytics","bubble chart","visualization","reports","performance","metrics","key performance indicators"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="14"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="8"
                    cy="16"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="17"
                    cy="18"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bubble-chart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bubbles","chart","graph","data","analysis","sales","inventory","reports","metrics","performance","trends"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.25 8C9.25 5.37665 11.3766 3.25 14 3.25C16.6234 3.25 18.75 5.37665 18.75 8C18.75 10.6234 16.6234 12.75 14 12.75C11.3766 12.75 9.25 10.6234 9.25 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 16C4.25 13.9289 5.92893 12.25 8 12.25C10.0711 12.25 11.75 13.9289 11.75 16C11.75 18.0711 10.0711 19.75 8 19.75C5.92893 19.75 4.25 18.0711 4.25 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 18C14.25 16.4812 15.4812 15.25 17 15.25C18.5188 15.25 19.75 16.4812 19.75 18C19.75 19.5188 18.5188 20.75 17 20.75C15.4812 20.75 14.25 19.5188 14.25 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bucket-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bucket","shopping-cart","basket","purchase","checkout","cart","products","items","order","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.006 3C9.58873 3 7.56447 4.71644 7.09982 6.99999L7.09868 6.99999C6.64432 6.99991 6.20635 6.99982 5.84792 7.04931C5.44588 7.10481 4.98409 7.24086 4.61452 7.63858C4.24495 8.03629 4.1431 8.5068 4.1172 8.91184C4.09411 9.27293 4.12628 9.70971 4.15965 10.1628L4.61999 16.429C4.68058 17.2544 4.73301 17.9687 4.85049 18.5394C4.97672 19.1526 5.20192 19.7336 5.70135 20.1977C6.20078 20.6617 6.79666 20.8438 7.41748 20.9247C7.99523 21.0001 8.71147 21.0001 9.53913 21H14.387C15.2071 21.0001 15.9173 21.0001 16.4907 20.9256C17.107 20.8456 17.6987 20.6657 18.1967 20.2075C18.6946 19.7492 18.9229 19.1744 19.0537 18.5669C19.1754 18.0016 19.2342 17.2939 19.3022 16.4765L19.8247 10.1913C19.8628 9.73442 19.8995 9.29448 19.8796 8.93066C19.8572 8.52288 19.7588 8.04801 19.3885 7.64564C19.0182 7.24328 18.5531 7.10583 18.1486 7.04981C17.7941 7.00071 17.362 6.99992 16.9123 6.99999C16.4476 4.71644 14.4234 3 12.006 3ZM12.006 5C10.6985 5 9.58438 5.83572 9.17109 7H14.841C14.4277 5.83572 13.3136 5 12.006 5ZM14.9996 14C14.9996 13.4477 14.5518 13 13.9996 13C13.4473 13 12.9996 13.4477 12.9996 14V16.0006C12.9996 16.5528 13.4473 17.0006 13.9996 17.0006C14.5518 17.0006 14.9996 16.5528 14.9996 16.0006V14ZM10.9996 14.0005C10.9996 13.4483 10.5518 13.0005 9.99956 13.0005C9.44727 13.0005 8.99956 13.4483 8.99956 14.0005V16.0005C8.99956 16.5528 9.44727 17.0005 9.99956 17.0005C10.5518 17.0005 10.9996 16.5528 10.9996 16.0005V14.0005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bubble-chart": {
        defaultColors: ["#3D4C66"],
        keywords: ["bubble chart","chart","data","sales","analytics","metrics","reporting","statistics","trends","growth","performance","visualization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="8" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="17" cy="18" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "bucket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shopping-bag","shopping","bag","purchase","buy","cart","checkout","basket","order","sale","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3112 16.3314L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.61313 16.2931C5.74229 18.0512 5.80687 18.9302 6.3825 19.4651C6.95813 20 7.83955 20 9.60239 20H14.325C16.0722 20 16.9458 20 17.5199 19.4716C18.094 18.9433 18.1664 18.0727 18.3112 16.3314Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16.0005V14.0005"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.0006V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00852 10V8M8 8C8 5.79086 9.79734 4 12.0065 4C14.2156 4 16.013 5.79086 16.013 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bucket-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shopping-basket","shopping","basket","cart","purchase","buy","checkout","order","tote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3112 16.3314L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.61313 16.2931C5.74229 18.0512 5.80687 18.9302 6.3825 19.4651C6.95813 20 7.83955 20 9.60239 20H14.325C16.0722 20 16.9458 20 17.5199 19.4716C18.094 18.9433 18.1664 18.0727 18.3112 16.3314Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16.0005V14.0005"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.0006V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00852 10V8M8 8C8 5.79086 9.79734 4 12.0065 4C14.2156 4 16.013 5.79086 16.013 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bug 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","problem","report","issue","remove","delete","decrease","minus","item-removal","quantity-decrease","discount-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","issue","problem","remove","subtract","delete","cancel","resolve","fix","debug","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    bucket: {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","problem","remove","subtract","delete","cancel","resolve","fix","debug","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3112 16.3314L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.61313 16.2931C5.74229 18.0512 5.80687 18.9302 6.3825 19.4651C6.95813 20 7.83955 20 9.60239 20H14.325C16.0722 20 16.9458 20 17.5199 19.4716C18.094 18.9433 18.1664 18.0727 18.3112 16.3314Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16.0005V14.0005"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.0006V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00852 10V8M8 8C8 5.79086 9.79734 4 12.0065 4C14.2156 4 16.013 5.79086 16.013 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "bug 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","report","issue","alert","warning","system-error","debug","incorrect","fault","failure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.05159 6.3165C3.87694 5.79256 4.1601 5.22624 4.68404 5.05159C5.20799 4.87694 5.77431 5.1601 5.94895 5.68404L6.19398 6.41913C6.29334 6.7172 6.34637 6.87282 6.39422 6.98032L6.39723 6.98704L6.40456 6.98778C6.52168 6.99918 6.68608 7.00027 7.00027 7.00027C7.10567 7.00027 7.20725 7.01658 7.30265 7.0468C7.51518 6.85268 7.74892 6.68126 8.00027 6.53614C8.52592 6.23266 9.09642 6.11109 9.7201 6.05457C10.3198 6.00022 11.0588 6.00023 11.9542 6.00024H12.0463C12.9418 6.00023 13.6808 6.00022 14.2804 6.05457C14.9041 6.11109 15.4746 6.23266 16.0003 6.53614C16.2516 6.68126 16.4854 6.85268 16.6979 7.0468C16.7933 7.01658 16.8949 7.00027 17.0003 7.00027C17.3145 7.00027 17.4789 6.99918 17.596 6.98778L17.6033 6.98704L17.6063 6.98032C17.6542 6.87282 17.7072 6.7172 17.8066 6.41913L18.0516 5.68404C18.2262 5.1601 18.7926 4.87694 19.3165 5.05159C19.8404 5.22624 20.1236 5.79256 19.949 6.3165L19.6926 7.08572C19.6093 7.33573 19.5258 7.58617 19.4335 7.79361C19.3288 8.02875 19.1809 8.28597 18.929 8.50617C18.8348 8.58848 18.7331 8.66178 18.6253 8.72509C18.3533 8.88472 18.0794 8.94628 17.8343 8.97371C17.8881 9.21381 17.9226 9.4624 17.9459 9.72008C17.9796 10.0919 17.9924 10.5172 17.9973 11.0002H19.0003C19.5526 11.0002 20.0003 11.448 20.0003 12.0002C20.0003 12.5525 19.5526 13.0002 19.0003 13.0002H17.9973C17.9924 13.4832 17.9796 13.9086 17.9459 14.2804C17.9226 14.5381 17.8881 14.7867 17.8343 15.0268C18.0794 15.0542 18.3533 15.1158 18.6253 15.2754C18.7331 15.3387 18.8348 15.412 18.929 15.4943C19.1809 15.7145 19.3288 15.9717 19.4335 16.2069C19.5258 16.4143 19.6093 16.6648 19.6926 16.9148L19.949 17.684C20.1236 18.2079 19.8404 18.7743 19.3165 18.9489C18.7926 19.1235 18.2262 18.8404 18.0516 18.3164L17.8066 17.5814C17.7072 17.2833 17.6542 17.1277 17.6063 17.0202L17.6033 17.0134L17.596 17.0127C17.4789 17.0013 17.3145 17.0002 17.0003 17.0002C16.8949 17.0002 16.7933 16.9839 16.6979 16.9537C16.4854 17.1478 16.2516 17.3192 16.0003 17.4643C15.4746 17.7678 14.9041 17.8894 14.2804 17.9459C13.6808 18.0003 12.9418 18.0003 12.0463 18.0002H11.9542C11.0588 18.0003 10.3198 18.0003 9.7201 17.9459C9.09642 17.8894 8.52592 17.7678 8.00027 17.4643C7.74891 17.3192 7.51518 17.1478 7.30264 16.9537C7.20725 16.9839 7.10567 17.0002 7.00027 17.0002C6.68608 17.0002 6.52168 17.0013 6.40456 17.0127L6.39723 17.0134L6.39422 17.0202C6.34637 17.1277 6.29334 17.2833 6.19398 17.5814L5.94895 18.3164C5.77431 18.8404 5.20799 19.1235 4.68404 18.9489C4.1601 18.7743 3.87694 18.2079 4.05159 17.684L4.30798 16.9148C4.39127 16.6648 4.47471 16.4143 4.56704 16.2069C4.67171 15.9717 4.81959 15.7145 5.07154 15.4943C5.16572 15.412 5.26741 15.3387 5.37528 15.2754C5.64723 15.1158 5.92115 15.0542 6.1662 15.0268C6.1124 14.7867 6.07795 14.5381 6.05459 14.2804C6.0209 13.9086 6.0081 13.4832 6.00324 13.0002H5.00027C4.44799 13.0002 4.00027 12.5525 4.00027 12.0002C4.00027 11.448 4.44799 11.0002 5.00027 11.0002H6.00324C6.0081 10.5172 6.0209 10.0919 6.05459 9.72008C6.07795 9.4624 6.1124 9.21381 6.1662 8.97371C5.92115 8.94628 5.64723 8.88472 5.37528 8.72509C5.26741 8.66178 5.16572 8.58848 5.07154 8.50617C4.81959 8.28597 4.67171 8.02875 4.56704 7.79361C4.47471 7.58616 4.39127 7.33571 4.30798 7.08568L4.05159 6.3165ZM10.0005 11.0002C9.4482 11.0002 9.00049 11.448 9.00049 12.0002C9.00049 12.5525 9.4482 13.0002 10.0005 13.0002H14.0005C14.5528 13.0002 15.0005 12.5525 15.0005 12.0002C15.0005 11.448 14.5528 11.0002 14.0005 11.0002H10.0005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","problem","report","delete","remove","subtract","decrease","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","issue","problem","report","malfunction","debug","failure","glitch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12H12M17 12H12M12 12V14.5M12 14.5L10 17M12 14.5L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","malfunction","debug","report","issue","system-error","system-issue","error-report","system-debug","report-problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M7 12H12M17 12H12M12 12V14.5M12 14.5L10 17M12 14.5L14 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","problem","debug","report","glitch","warning","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.17184 6.17157C9.89461 5.44881 10.896 5 12.0003 5C13.1046 5 14.1059 5.44881 14.8287 6.17157C15.3608 6.7037 15.7445 7.38684 15.9098 8.1509C16.0624 8.19415 16.2135 8.25118 16.3622 8.32698C16.6945 8.49628 16.9902 8.72494 17.2359 8.99954C17.4048 8.99855 17.5124 8.99566 17.596 8.98753L17.6033 8.98679L17.6063 8.98007C17.6542 8.87257 17.7072 8.71696 17.8066 8.41889L18.0516 7.6838C18.2262 7.15986 18.7926 6.8767 19.3165 7.05134C19.8404 7.22599 20.1236 7.79231 19.949 8.31626L19.6926 9.08543C19.6093 9.33545 19.5258 9.58593 19.4335 9.79336C19.3288 10.0285 19.1809 10.2857 18.929 10.5059C18.8348 10.5882 18.7331 10.6615 18.6253 10.7248C18.4061 10.8535 18.1856 10.9184 17.98 10.9532C18.0003 11.2975 18.0003 11.702 18.0003 12.1615V12.2413C18.0003 13.0462 18.0003 13.7106 17.9561 14.2518C17.9341 14.5203 17.9002 14.7783 17.8438 15.0276C18.0864 15.0556 18.3568 15.1176 18.6253 15.2752C18.7331 15.3385 18.8348 15.4118 18.929 15.4941C19.1809 15.7143 19.3288 15.9715 19.4335 16.2066C19.5258 16.4141 19.6093 16.6645 19.6926 16.9145L19.949 17.6837C20.1236 18.2077 19.8404 18.774 19.3165 18.9487C18.7926 19.1233 18.2262 18.8401 18.0516 18.3162L17.8066 17.5811C17.7072 17.283 17.6542 17.1274 17.6063 17.0199L17.6033 17.0132L17.596 17.0125C17.4789 17.0011 17.3145 17 17.0003 17C16.8949 17 16.7933 16.9837 16.6979 16.9534C16.4343 17.1942 16.1382 17.4 15.8162 17.564C15.3309 17.8113 14.8142 17.9099 14.2521 17.9558C13.7109 18 13.0465 18 12.2415 18H11.759C10.954 18 10.2896 18 9.74845 17.9558C9.18635 17.9099 8.66965 17.8113 8.18431 17.564C7.86239 17.4 7.56622 17.1942 7.30265 16.9534C7.20726 16.9837 7.10567 17 7.00027 17C6.68608 17 6.52168 17.0011 6.40456 17.0125L6.39723 17.0132L6.39422 17.0199C6.34637 17.1274 6.29334 17.283 6.19398 17.5811L5.94895 18.3162C5.77431 18.8401 5.20799 19.1233 4.68404 18.9487C4.1601 18.774 3.87694 18.2077 4.05159 17.6837L4.30798 16.9146C4.39127 16.6645 4.47471 16.4141 4.56704 16.2066C4.67171 15.9715 4.81959 15.7143 5.07154 15.4941C5.16572 15.4118 5.26741 15.3385 5.37528 15.2752C5.64374 15.1176 5.91411 15.0556 6.15675 15.0276C6.10034 14.7783 6.0664 14.5203 6.04447 14.2518C6.00025 13.7106 6.00026 13.0463 6.00027 12.2413L6.00027 12.1615C6.00026 11.702 6.00024 11.2975 6.02051 10.9532C5.81491 10.9184 5.59446 10.8535 5.37528 10.7248C5.26741 10.6615 5.16572 10.5882 5.07154 10.5059C4.81959 10.2857 4.67171 10.0285 4.56704 9.79336C4.47471 9.58592 4.39127 9.33546 4.30798 9.08543L4.05159 8.31626C3.87694 7.79231 4.1601 7.22599 4.68404 7.05134C5.20799 6.8767 5.77431 7.15986 5.94895 7.6838L6.19398 8.41889C6.29334 8.71696 6.34637 8.87257 6.39422 8.98007L6.39723 8.98679L6.40456 8.98753C6.48811 8.99566 6.59572 8.99855 6.76462 8.99954C7.01033 8.72494 7.30603 8.49628 7.6383 8.32698C7.78708 8.25118 7.93814 8.19415 8.09073 8.1509C8.25609 7.38684 8.63972 6.7037 9.17184 6.17157ZM10.2676 8H13.7329C13.6452 7.84839 13.5379 7.70924 13.4145 7.58579C13.0515 7.22276 12.5528 7 12.0003 7C11.4477 7 10.9491 7.22276 10.5861 7.58579C10.4626 7.70925 10.3554 7.84839 10.2676 8ZM8.00204 12.5C8.00517 12.9455 8.01384 13.7954 8.03782 14.089C8.07364 14.5274 8.13857 14.7516 8.21826 14.908C8.41001 15.2843 8.71597 15.5903 9.09229 15.782C9.20331 15.8386 9.3485 15.8877 9.58023 15.9243L11.0003 14.1492V12.5H8.00204ZM14.4203 15.9243C14.652 15.8877 14.7972 15.8386 14.9083 15.782C15.2846 15.5903 15.5905 15.2843 15.7823 14.908C15.862 14.7516 15.9269 14.5274 15.9627 14.089C15.9867 13.7954 15.9954 12.9455 15.9985 12.5H13.0003V14.1492L14.4203 15.9243Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bug","error","issue","problem","report","debugging","alerts","system-error","technical-problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M17 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 10H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5L10 7H14L15 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","report","debug","problem","technical-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H12M17 12H12M12 12V14.5M12 14.5L10 17M12 14.5L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bug","error","issue","malfunction","debug","report-issue","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 10H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5L10 7H14L15 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","warning","issue","problem","malfunction","software bug","system error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.8947 4.55301C9.64771 4.05903 9.04704 3.8588 8.55306 4.10579C8.05908 4.35278 7.85885 4.95345 8.10584 5.44743L8.52879 6.29332C8.34766 6.35763 8.17158 6.43721 8.00027 6.53612C7.74892 6.68123 7.51519 6.85264 7.30267 7.04676C7.20727 7.01653 7.10567 7.00022 7.00027 7.00022C6.68608 7.00022 6.52168 6.99912 6.40456 6.98772L6.39723 6.98699L6.39422 6.98027C6.34637 6.87276 6.29334 6.71715 6.19398 6.41908L5.94895 5.68399C5.77431 5.16005 5.20799 4.87689 4.68404 5.05154C4.1601 5.22618 3.87694 5.7925 4.05159 6.31645L4.29662 7.05154L4.30798 7.08563C4.39127 7.33566 4.47471 7.58611 4.56704 7.79356C4.67171 8.0287 4.81959 8.28592 5.07154 8.50612C5.16572 8.58843 5.26741 8.66173 5.37528 8.72504C5.64723 8.88467 5.92115 8.94622 6.16621 8.97365C6.11241 9.21377 6.07795 9.46237 6.05459 9.72005C6.0209 10.0919 6.00809 10.5172 6.00324 11.0002H5.00027C4.44799 11.0002 4.00027 11.4479 4.00027 12.0002C4.00027 12.5525 4.44799 13.0002 5.00027 13.0002H6.00324C6.00809 13.4832 6.0209 13.9086 6.05459 14.2804C6.07795 14.5381 6.11241 14.7867 6.16621 15.0268C5.92115 15.0542 5.64723 15.1158 5.37528 15.2754C5.26741 15.3387 5.16572 15.412 5.07154 15.4943C4.81959 15.7145 4.67171 15.9717 4.56704 16.2069C4.47471 16.4143 4.39127 16.6648 4.30798 16.9148L4.05159 17.684C3.87694 18.2079 4.1601 18.7743 4.68404 18.9489C5.20799 19.1236 5.77431 18.8404 5.94895 18.3164L6.19398 17.5814C6.29334 17.2833 6.34637 17.1277 6.39422 17.0202L6.39723 17.0135L6.40456 17.0127C6.52168 17.0013 6.68608 17.0002 7.00027 17.0002C7.10567 17.0002 7.20727 16.9839 7.30267 16.9537C7.51519 17.1478 7.74892 17.3192 8.00027 17.4643C8.52591 17.7678 9.09642 17.8894 9.7201 17.9459C10.3198 18.0002 11.1048 18.0002 12.0003 18.0002C12.8957 18.0002 13.6808 18.0002 14.2804 17.9459C14.9041 17.8894 15.4746 17.7678 16.0003 17.4643C16.2516 17.3192 16.4853 17.1478 16.6979 16.9537C16.7933 16.9839 16.8949 17.0002 17.0003 17.0002C17.3145 17.0002 17.4789 17.0013 17.596 17.0127L17.6033 17.0135L17.6063 17.0202C17.6542 17.1277 17.7072 17.2833 17.8066 17.5814L18.0516 18.3164C18.2262 18.8404 18.7926 19.1236 19.3165 18.9489C19.8404 18.7743 20.1236 18.2079 19.949 17.684L19.6926 16.9148C19.6093 16.6648 19.5258 16.4143 19.4335 16.2069C19.3288 15.9717 19.1809 15.7145 18.929 15.4943C18.8348 15.412 18.7331 15.3387 18.6253 15.2754C18.3533 15.1158 18.0794 15.0542 17.8343 15.0268C17.8881 14.7867 17.9226 14.5381 17.9459 14.2804C17.9796 13.9086 17.9924 13.4832 17.9973 13.0002H19.0003C19.5526 13.0002 20.0003 12.5525 20.0003 12.0002C20.0003 11.4479 19.5526 11.0002 19.0003 11.0002H17.9973C17.9924 10.5172 17.9796 10.0919 17.9459 9.72005C17.9226 9.46237 17.8881 9.21377 17.8343 8.97366C18.0794 8.94622 18.3533 8.88467 18.6253 8.72504C18.7331 8.66173 18.8348 8.58843 18.929 8.50612C19.1809 8.28592 19.3288 8.0287 19.4335 7.79356C19.5258 7.58611 19.6093 7.33567 19.6926 7.08565L19.949 6.31645C20.1236 5.7925 19.8404 5.22618 19.3165 5.05154C18.7926 4.87689 18.2262 5.16005 18.0516 5.68399L17.8066 6.41908C17.7072 6.71715 17.6542 6.87276 17.6063 6.98027L17.6033 6.98699L17.596 6.98772C17.4789 6.99912 17.3145 7.00022 17.0003 7.00022C16.8949 7.00022 16.7933 7.01653 16.6979 7.04676C16.4853 6.85264 16.2516 6.68123 16.0003 6.53612C15.829 6.43721 15.6529 6.35763 15.4718 6.29332L15.8947 5.44743C16.1417 4.95345 15.9415 4.35278 15.4475 4.10579C14.9535 3.8588 14.3528 4.05903 14.1058 4.55301L13.3822 6.00022H12.0003H10.6183L9.8947 4.55301ZM9.00027 10.0002C9.00027 9.44793 9.44799 9.00022 10.0003 9.00022H14.0003C14.5526 9.00022 15.0003 9.44793 15.0003 10.0002C15.0003 10.5525 14.5526 11.0002 14.0003 11.0002H10.0003C9.44799 11.0002 9.00027 10.5525 9.00027 10.0002ZM9.00027 14.0002C9.00027 13.4479 9.44799 13.0002 10.0003 13.0002H14.0003C14.5526 13.0002 15.0003 13.4479 15.0003 14.0002C15.0003 14.5525 14.5526 15.0002 14.0003 15.0002H10.0003C9.44799 15.0002 9.00027 14.5525 9.00027 14.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","problem","debug","report","feedback","technical-issue","software-bug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5981 8.5C17 9.19615 17 10.1308 17 12C17 13.8692 17 14.8038 16.5981 15.5C16.3348 15.9561 15.9561 16.3348 15.5 16.5981C14.8038 17 13.8692 17 12 17C10.1308 17 9.19615 17 8.5 16.5981C8.04394 16.3348 7.66523 15.9561 7.40192 15.5C7 14.8038 7 13.8692 7 12C7 10.1308 7 9.19615 7.40192 8.5C7.66523 8.04394 8.04394 7.66523 8.5 7.40192C9.19615 7 10.1308 7 12 7C13.8692 7 14.8038 7 15.5 7.40192C15.9561 7.66523 16.3348 8.04394 16.5981 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8V8C17.5896 8 17.8844 8 18.1188 7.86241C18.1727 7.83075 18.2236 7.79411 18.2707 7.75295C18.4753 7.57408 18.5685 7.29442 18.755 6.73509L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8V8C6.41042 8 6.11562 8 5.88122 7.86241C5.82728 7.83075 5.77644 7.79411 5.72935 7.75295C5.52469 7.57408 5.43147 7.29442 5.24503 6.73509L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 10H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5L10 7H14L15 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","issue","problem","error","report","defect","failure","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.55328 6.10579C9.04726 5.8588 9.64793 6.05903 9.89492 6.55301L10.6185 8.00022H13.3825L14.1061 6.55301C14.3531 6.05903 14.9537 5.8588 15.4477 6.10579C15.9417 6.35278 16.1419 6.95345 15.8949 7.44743L15.5799 8.07754C15.8448 8.12234 16.1069 8.19712 16.3622 8.32723C16.6945 8.49653 16.9902 8.72518 17.2359 8.99978C17.4048 8.9988 17.5124 8.99591 17.596 8.98778L17.6033 8.98704L17.6063 8.98032C17.6542 8.87282 17.7072 8.7172 17.8066 8.41913L18.0516 7.68404C18.2262 7.1601 18.7926 6.87694 19.3165 7.05159C19.8404 7.22624 20.1236 7.79256 19.949 8.3165L19.6926 9.08571C19.6093 9.33573 19.5258 9.58617 19.4335 9.79361C19.3288 10.0288 19.1809 10.286 18.929 10.5062C18.8348 10.5885 18.7331 10.6618 18.6253 10.7251C18.4061 10.8537 18.1856 10.9187 17.98 10.9534C18.0003 11.2977 18.0003 11.7421 18.0003 12.2016C18.0003 13.0066 18.0003 13.7109 17.9561 14.2521C17.9341 14.5205 17.9002 14.7786 17.8438 15.0279C18.0864 15.0558 18.3568 15.1178 18.6253 15.2754C18.7331 15.3387 18.8348 15.412 18.929 15.4943C19.1809 15.7145 19.3288 15.9717 19.4335 16.2069C19.5258 16.4143 19.6093 16.6648 19.6926 16.9148L19.949 17.684C20.1236 18.2079 19.8404 18.7743 19.3165 18.9489C18.7926 19.1235 18.2262 18.8404 18.0516 18.3164L17.8066 17.5814C17.7072 17.2833 17.6542 17.1277 17.6063 17.0202L17.6033 17.0134L17.596 17.0127C17.4789 17.0013 17.3145 17.0002 17.0003 17.0002C16.8949 17.0002 16.7933 16.9839 16.6979 16.9537C16.4343 17.1944 16.1382 17.4002 15.8162 17.5643C15.3309 17.8116 14.8142 17.9101 14.2521 17.9561C13.7109 18.0003 13.0465 18.0003 12.2415 18.0002H11.759C10.954 18.0003 10.2896 18.0003 9.74845 17.9561C9.18635 17.9101 8.66965 17.8116 8.18431 17.5643C7.86239 17.4002 7.56622 17.1944 7.30265 16.9537C7.20726 16.9839 7.10567 17.0002 7.00027 17.0002C6.68608 17.0002 6.52168 17.0013 6.40456 17.0127L6.39723 17.0134L6.39422 17.0202C6.34637 17.1277 6.29334 17.2833 6.19398 17.5814L5.94895 18.3164C5.77431 18.8404 5.20799 19.1235 4.68404 18.9489C4.1601 18.7743 3.87694 18.2079 4.05159 17.684L4.30798 16.9148C4.39127 16.6648 4.47471 16.4143 4.56704 16.2069C4.67171 15.9717 4.81959 15.7145 5.07154 15.4943C5.16572 15.412 5.26741 15.3387 5.37528 15.2754C5.64374 15.1178 5.91411 15.0558 6.15675 15.0279C6.10034 14.7786 6.0664 14.5205 6.04447 14.2521C6.00025 13.7109 6.00026 13.0066 6.00027 12.2016C6.00026 11.7422 6.00024 11.2977 6.02051 10.9534C5.81491 10.9187 5.59446 10.8537 5.37528 10.7251C5.26741 10.6618 5.16572 10.5885 5.07154 10.5062C4.81959 10.286 4.67171 10.0288 4.56704 9.79361C4.47471 9.58616 4.39127 9.33571 4.30798 9.08568L4.05159 8.3165C3.87694 7.79256 4.1601 7.22624 4.68404 7.05159C5.20799 6.87694 5.77431 7.1601 5.94895 7.68404L6.19398 8.41913C6.29334 8.7172 6.34637 8.87282 6.39422 8.98032L6.39723 8.98704L6.40456 8.98778C6.48811 8.99591 6.59572 8.9988 6.76462 8.99978C7.01033 8.72518 7.30603 8.49653 7.6383 8.32723C7.89377 8.19706 8.156 8.12227 8.42108 8.07747L8.10606 7.44743C7.85907 6.95345 8.0593 6.35278 8.55328 6.10579ZM9.00027 13.0002C9.00027 12.448 9.44799 12.0002 10.0003 12.0002H14.0003C14.5526 12.0002 15.0003 12.448 15.0003 13.0002C15.0003 13.5525 14.5526 14.0002 14.0003 14.0002H10.0003C9.44799 14.0002 9.00027 13.5525 9.00027 13.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug 5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","defect","problem","issue","remove","subtract","minus","delete","fix","debug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 13H12H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10 9H14L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","insect","error","problem","debug","remove","delete","subtract","minus","decrease","reduce","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 13H12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10 9H14L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 5-2": {
        defaultColors: ["#3d4c66", "#cdd1d8", "#000000"],
        keywords: ["bug","error","minus","remove","delete","subtract","decrease","discount","reduction","problem","issue","defect","troubleshooting","cancel","void","rollback","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 10V10C17.5896 10 17.8844 10 18.1188 9.86241C18.1727 9.83075 18.2236 9.79411 18.2707 9.75295C18.4753 9.57408 18.5685 9.29442 18.755 8.73509L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 10V10C6.41042 10 6.11562 10 5.88122 9.86241C5.82728 9.83075 5.77644 9.79411 5.72935 9.75295C5.52469 9.57408 5.43147 9.29442 5.24503 8.73509L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16V16C6.41042 16 6.11562 16 5.88122 16.1376C5.82728 16.1692 5.77644 16.2059 5.72935 16.2471C5.52469 16.4259 5.43147 16.7056 5.24503 17.2649L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 16V16C17.5896 16 17.8844 16 18.1188 16.1376C18.1727 16.1692 18.2236 16.2059 18.2707 16.247C18.4753 16.4259 18.5685 16.7056 18.755 17.2649L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 7L10 9H14L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    fill={colors?.[1] || "#CDD1D8"}
                    stroke={colors?.[1] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13H12H14" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","issue","problem","defect","debug","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M17 9H7V12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12V9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 9L6 8M17 9L18 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","options","configure","system","preferences","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L9.96818 5.55397C10.5636 5.20229 11.2586 5 12 5C12.7414 5 13.4364 5.20229 14.0318 5.55397L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L15.446 6.96818C15.634 7.28639 15.7792 7.63304 15.8738 8H16.5858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L18 9.41421V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H17.6586C17.4711 14.5304 17.2112 15.0265 16.8907 15.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L15.4765 16.8907C14.7536 17.4056 13.9117 17.7641 13 17.917V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V17.917C10.0883 17.7641 9.2464 17.4056 8.52347 16.8907L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L7.10925 15.4765C6.78878 15.0265 6.52887 14.5304 6.34141 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H6V9.41421L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L7.41421 8H8.12621C8.22075 7.63304 8.36603 7.28639 8.55397 6.96818L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289ZM13.4142 7.58579C13.5377 7.70924 13.6449 7.84839 13.7327 8H10.2673C10.3551 7.84839 10.4623 7.70924 10.5858 7.58579C10.9488 7.22276 11.4474 7 12 7C12.5526 7 13.0512 7.22276 13.4142 7.58579Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug 6-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","issue","report","diagnosis","system-error","software-bug","technical-problem","troubleshooting","debug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 9L6 8M17 9L18 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12 18L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 9H7V12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12V9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 6": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","issue","error","problem","fix","debug","report","alert","warning","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 9H7V12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12V9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 9L6 8M17 9L18 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12 18L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 7-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","problem","issue","debug","report","alert","notification","warning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M16 9H8L7.62017 12.0386C7.29087 14.6731 9.34504 17 12 17C14.655 17 16.7091 14.6731 16.3798 12.0386L16 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 9L7 8M16 9L17 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 12H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 7-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","problem","issue","report","debug","malfunction","system-error","technical-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 9L7 8M16 9L17 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 12H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 9H8L7.62017 12.0386C7.29087 14.6731 9.34504 17 12 17C14.655 17 16.7091 14.6731 16.3798 12.0386L16 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug 7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","settings","options","customize","configure","technical","issue","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C10.8957 5 9.89434 5.44881 9.17157 6.17157C8.72798 6.61517 8.38758 7.16371 8.1908 7.77658L7.70711 7.29289C7.31658 6.90237 6.68342 6.90237 6.29289 7.29289C5.90237 7.68342 5.90237 8.31658 6.29289 8.70711L6.9472 9.36141L6.74238 11H6C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H6.60056C6.66218 13.8217 6.91011 14.5975 7.30415 15.2818L7.29289 15.2929L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L8.60794 16.8063C9.28683 17.3533 10.1023 17.7411 11 17.9082V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V17.9083C13.8978 17.7412 14.7133 17.3535 15.3922 16.8064L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L16.7071 15.2929L16.6961 15.282C17.0902 14.5976 17.3381 13.8218 17.3998 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H17.2579L17.0531 9.36113L17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289L15.8092 7.77658C15.6124 7.16371 15.272 6.61517 14.8284 6.17157C14.1057 5.44881 13.1043 5 12 5ZM13.7327 8C13.6449 7.84839 13.5377 7.70924 13.4142 7.58579C13.0512 7.22276 12.5526 7 12 7C11.4474 7 10.9488 7.22276 10.5858 7.58579C10.4623 7.70924 10.3551 7.84839 10.2673 8H13.7327Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","problem","issue","debug","report-error","report-issue","system-error","system-bug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 8C14.25 8.41421 14.5858 8.75 15 8.75C15.4142 8.75 15.75 8.41421 15.75 8H14.25ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM9.53033 4.46967C9.23744 4.17678 8.76256 4.17678 8.46967 4.46967C8.17678 4.76256 8.17678 5.23744 8.46967 5.53033L9.53033 4.46967ZM15.5303 5.53033C15.8232 5.23744 15.8232 4.76256 15.5303 4.46967C15.2374 4.17678 14.7626 4.17678 14.4697 4.46967L15.5303 5.53033ZM10.409 5.34835L9.53033 4.46967L8.46967 5.53033L9.34835 6.40901L10.409 5.34835ZM12 4.25C10.9647 4.25 10.0261 4.67055 9.34835 5.34835L10.409 6.40901C10.817 6.00102 11.3785 5.75 12 5.75V4.25ZM9.34835 5.34835C8.67055 6.02614 8.25 6.96467 8.25 8H9.75C9.75 7.37847 10.001 6.817 10.409 6.40901L9.34835 5.34835ZM14.6517 6.40901L15.5303 5.53033L14.4697 4.46967L13.591 5.34835L14.6517 6.40901ZM12 5.75C12.6215 5.75 13.183 6.00102 13.591 6.40901L14.6517 5.34835C13.9739 4.67055 13.0353 4.25 12 4.25V5.75ZM13.591 6.40901C13.999 6.817 14.25 7.37847 14.25 8H15.75C15.75 6.96467 15.3294 6.02614 14.6517 5.34835L13.591 6.40901Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M17 8H7V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 8L6 7M17 8L18 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19L12 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug 7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","problem","issue","debug","report","failure","malfunction","glitch","defect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9H8L7.62017 12.0386C7.29087 14.6731 9.34504 17 12 17C14.655 17 16.7091 14.6731 16.3798 12.0386L16 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 9L7 8M16 9L17 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 12H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","report","issue","debug","problem","malfunction","system-error","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L9.96818 4.55397C10.5636 4.20229 11.2586 4 12 4C12.7414 4 13.4364 4.20229 14.0318 4.55397L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L15.446 5.96818C15.634 6.28639 15.7792 6.63304 15.8738 7H16.5858L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L18 8.41421V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H18C18 14.036 17.7374 15.0106 17.2752 15.861L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L16.0305 17.4447C15.1993 18.1989 14.1557 18.7232 13 18.917V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V18.917C9.84433 18.7232 8.80069 18.1989 7.96949 17.4447L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L6.72475 15.861C6.26255 15.0106 6 14.036 6 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H6V8.41421L5.29289 7.70711C4.90237 7.31658 4.90237 6.68342 5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289L7.41421 7H8.12621C8.22075 6.63304 8.36603 6.28639 8.55397 5.96818L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289ZM13.4142 6.58579C13.5377 6.70924 13.6449 6.84839 13.7327 7H10.2673C10.3551 6.84839 10.4623 6.70924 10.5858 6.58579C10.9488 6.22276 11.4474 6 12 6C12.5526 6 13.0512 6.22276 13.4142 6.58579Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","issue","problem","debug","settings","configuration","maintenance","troubleshooting","report-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 8L6 7M17 8L18 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 8C14.25 8.41421 14.5858 8.75 15 8.75C15.4142 8.75 15.75 8.41421 15.75 8H14.25ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM9.53033 4.46967C9.23744 4.17678 8.76256 4.17678 8.46967 4.46967C8.17678 4.76256 8.17678 5.23744 8.46967 5.53033L9.53033 4.46967ZM15.5303 5.53033C15.8232 5.23744 15.8232 4.76256 15.5303 4.46967C15.2374 4.17678 14.7626 4.17678 14.4697 4.46967L15.5303 5.53033ZM10.409 5.34835L9.53033 4.46967L8.46967 5.53033L9.34835 6.40901L10.409 5.34835ZM12 4.25C10.9647 4.25 10.0261 4.67055 9.34835 5.34835L10.409 6.40901C10.817 6.00102 11.3785 5.75 12 5.75V4.25ZM9.34835 5.34835C8.67055 6.02614 8.25 6.96467 8.25 8H9.75C9.75 7.37847 10.001 6.817 10.409 6.40901L9.34835 5.34835ZM14.6517 6.40901L15.5303 5.53033L14.4697 4.46967L13.591 5.34835L14.6517 6.40901ZM12 5.75C12.6215 5.75 13.183 6.00102 13.591 6.40901L14.6517 5.34835C13.9739 4.67055 13.0353 4.25 12 4.25V5.75ZM13.591 6.40901C13.999 6.817 14.25 7.37847 14.25 8H15.75C15.75 6.96467 15.3294 6.02614 14.6517 5.34835L13.591 6.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12 19L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 8H7V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 12H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bug-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","problem","issue","report","debug","technical-issue","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 10L6 9M17 10L18 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L17 18M8 17L7 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bug","error","issue","problem","report","debugging","technical-problem","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 5.29289C9.31658 4.90237 8.68342 4.90237 8.29289 5.29289C7.90237 5.68342 7.90237 6.31658 8.29289 6.70711L8.55397 6.96818C8.34046 7.32969 8.18201 7.72789 8.09046 8.1509C7.93787 8.19415 7.7868 8.25118 7.63803 8.32698C7.44396 8.42587 7.26237 8.545 7.09592 8.68171L6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711L6.06746 10.4817C6.05113 10.5891 6.0394 10.697 6.03057 10.805C6.00314 11.1407 6.00031 11.541 6.00003 12H5C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14H6.02714C6.03193 14.0868 6.03756 14.1707 6.0442 14.2518C6.09012 14.8139 6.18868 15.3306 6.43598 15.816C6.58282 16.1042 6.76315 16.3717 6.97206 16.6137L6.29289 17.2929C5.90237 17.6834 5.90237 18.3166 6.29289 18.7071C6.68342 19.0976 7.31658 19.0976 7.70711 18.7071L8.65647 17.7577C9.00221 17.8686 9.36462 17.9245 9.74818 17.9558C10.109 17.9853 10.5245 17.9951 11 17.9984V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V17.9984C13.4755 17.9951 13.891 17.9853 14.2518 17.9558C14.6354 17.9245 14.9978 17.8686 15.3435 17.7577L16.2929 18.7071C16.6834 19.0976 17.3166 19.0976 17.7071 18.7071C18.0976 18.3166 18.0976 17.6834 17.7071 17.2929L17.0279 16.6137C17.2368 16.3717 17.4172 16.1042 17.564 15.816C17.8113 15.3306 17.9099 14.8139 17.9558 14.2518C17.9624 14.1707 17.9681 14.0868 17.9729 14H19C19.5523 14 20 13.5523 20 13C20 12.4477 19.5523 12 19 12H18C17.9997 11.541 17.9969 11.1408 17.9694 10.805C17.9606 10.697 17.9489 10.5891 17.9325 10.4817L18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L16.9041 8.68171C16.7376 8.545 16.556 8.42586 16.362 8.32698C16.2132 8.25118 16.0621 8.19416 15.9095 8.1509C15.818 7.7279 15.6595 7.32969 15.446 6.96818L15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L14.0318 5.55397C13.4364 5.20229 12.7414 5 12 5C11.2586 5 10.5636 5.20229 9.96818 5.55397L9.70711 5.29289ZM13.7327 8C13.6449 7.84839 13.5377 7.70925 13.4142 7.58579C13.0512 7.22276 12.5526 7 12 7C11.4474 7 10.9488 7.22276 10.5858 7.58579C10.4623 7.70925 10.3551 7.84839 10.2673 8H13.7327Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bug-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bug","error","issue","problem","report","fix","debug","malfunction","alert","warning","system-error","log","log-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10L6 9M17 10L18 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L17 18M8 17L7 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bug-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bug","error","issue","problem","malfunction","debug","technical-error","glitch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 9C14.25 9.41421 14.5858 9.75 15 9.75C15.4142 9.75 15.75 9.41421 15.75 9H14.25ZM8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967C8.17678 5.76256 8.17678 6.23744 8.46967 6.53033L9.53033 5.46967ZM15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967C15.2374 5.17678 14.7626 5.17678 14.4697 5.46967L15.5303 6.53033ZM10.409 6.34835L9.53033 5.46967L8.46967 6.53033L9.34835 7.40901L10.409 6.34835ZM12 5.25C10.9647 5.25 10.0261 5.67055 9.34835 6.34835L10.409 7.40901C10.817 7.00102 11.3785 6.75 12 6.75V5.25ZM9.34835 6.34835C8.67055 7.02614 8.25 7.96467 8.25 9H9.75C9.75 8.37847 10.001 7.817 10.409 7.40901L9.34835 6.34835ZM14.6517 7.40901L15.5303 6.53033L14.4697 5.46967L13.591 6.34835L14.6517 7.40901ZM12 6.75C12.6215 6.75 13.183 7.00102 13.591 7.40901L14.6517 6.34835C13.9739 5.67055 13.0353 5.25 12 5.25V6.75ZM13.591 7.40901C13.999 7.817 14.25 8.37847 14.25 9H15.75C15.75 7.96467 15.3294 7.02614 14.6517 6.34835L13.591 7.40901Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M13.8 9H10.2C9.0799 9 8.51984 9 8.09202 9.21799C7.71569 9.40973 7.40973 9.71569 7.21799 10.092C7 10.5198 7 11.0799 7 12.2C7 13.8802 7 14.7202 7.32698 15.362C7.6146 15.9265 8.07354 16.3854 8.63803 16.673C9.27976 17 10.1198 17 11.8 17H12.2C13.8802 17 14.7202 17 15.362 16.673C15.9265 16.3854 16.3854 15.9265 16.673 15.362C17 14.7202 17 13.8802 17 12.2C17 11.0799 17 10.5198 16.782 10.092C16.5903 9.71569 16.2843 9.40973 15.908 9.21799C15.4802 9 14.9201 9 13.8 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 10L6 9M17 10L18 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L17 18M8 17L7 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 18L12 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 13H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 13H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "building-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["building","store","shop","location","business","company","enterprise","branch","outlet","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M4 19H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["building","storage","warehouse","inventory","stock","location","establishment","premises"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18V20H14V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","structure","warehouse","storage","inventory","stock","location","place","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H15V18C15 16.3431 13.6569 15 12 15C10.3431 15 9 16.3431 9 18V21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H10ZM9 11C9 10.4477 9.44772 10 10 10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H10C9.44772 12 9 11.5523 9 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bug: {
        defaultColors: ["#3D4C66"],
        keywords: ["building","structure","warehouse","storage","inventory","stock","location","place","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H7V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 8L6 7M17 8L18 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16L17 17M8 16L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.25 8C14.25 8.41421 14.5858 8.75 15 8.75C15.4142 8.75 15.75 8.41421 15.75 8H14.25ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM9.53033 4.46967C9.23744 4.17678 8.76256 4.17678 8.46967 4.46967C8.17678 4.76256 8.17678 5.23744 8.46967 5.53033L9.53033 4.46967ZM15.5303 5.53033C15.8232 5.23744 15.8232 4.76256 15.5303 4.46967C15.2374 4.17678 14.7626 4.17678 14.4697 4.46967L15.5303 5.53033ZM10.409 5.34835L9.53033 4.46967L8.46967 5.53033L9.34835 6.40901L10.409 5.34835ZM12 4.25C10.9647 4.25 10.0261 4.67055 9.34835 5.34835L10.409 6.40901C10.817 6.00102 11.3785 5.75 12 5.75V4.25ZM9.34835 5.34835C8.67055 6.02614 8.25 6.96467 8.25 8H9.75C9.75 7.37847 10.001 6.817 10.409 6.40901L9.34835 5.34835ZM14.6517 6.40901L15.5303 5.53033L14.4697 4.46967L13.591 5.34835L14.6517 6.40901ZM12 5.75C12.6215 5.75 13.183 6.00102 13.591 6.40901L14.6517 5.34835C13.9739 4.67055 13.0353 4.25 12 4.25V5.75ZM13.591 6.40901C13.999 6.817 14.25 7.37847 14.25 8H15.75C15.75 6.96467 15.3294 6.02614 14.6517 5.34835L13.591 6.40901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12 19L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "building-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["building","store","business","location","company","shop","enterprise","branch","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11V19M20 19V15C20 13.1144 20 12.1716 19.4142 11.5858C18.8284 11 17.8856 11 16 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19V17C8 15.8954 8.89543 15 10 15V15C11.1046 15 12 15.8954 12 17V19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 19V9C16 7.11438 16 6.17157 15.4142 5.58579C14.8284 5 13.8856 5 12 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 19L3 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-14": {
        defaultColors: ["#3d4c66", "#d9d1e0", "#FFFFFF"],
        keywords: ["printer","receipt","print","transaction","building","business","office"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15V18.8C8 18.9105 8.08954 19 8.2 19H19.8C19.9105 19 20 18.9105 20 18.8V15V13C20 11.8954 19.1046 11 18 11H10C8.89543 11 8 11.8954 8 13V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M17 18L17 10" stroke={colors?.[2] || "#FFFFFF"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4 12V18.8C4 18.9105 4.08954 19 4.2 19H15.8C15.9105 19 16 18.9105 16 18.8V12V7C16 5.89543 15.1046 5 14 5H6C4.89543 5 4 5.89543 4 7V12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15.75H16.75V14.25H16V15.75ZM15.5 14.25C15.0858 14.25 14.75 14.5858 14.75 15C14.75 15.4142 15.0858 15.75 15.5 15.75V14.25ZM16 14.25H15.5V15.75H16V14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 19L3 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 19L3 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17V19H12V17C12 15.8954 11.1046 15 10 15C8.89543 15 8 15.8954 8 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","warehouse","inventory","location","stock","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 18L21 14.9342C21.0001 14.0477 21.0001 13.2839 20.9179 12.6722C20.8297 12.0167 20.631 11.3883 20.1213 10.8787C19.6117 10.369 18.9833 10.1703 18.3278 10.0821C18.2294 10.0689 18.1512 10.0578 18.0856 10.0485C17.9769 10.0331 17.9027 10.0225 17.8282 10.0153C17.6687 9.99997 17.5077 9.99998 17.0017 10H17L17 8.93417C17.0001 8.04769 17.0001 7.28387 16.9179 6.67221C16.8297 6.0167 16.631 5.38835 16.1213 4.87868C15.6117 4.36902 14.9833 4.17028 14.3278 4.08215C13.7161 3.99991 12.9523 3.99995 12.0658 4H7.93417C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 18C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18ZM17.8199 12.0247C17.7019 12.0011 17.6964 12 17 12V14H16C15.4477 14 15 14.4477 15 15C15 15.5523 15.4477 16 16 16H17L17 18H19V15C19 14.0289 18.9979 13.4012 18.9357 12.9387C18.8774 12.505 18.7832 12.369 18.7071 12.2929C18.631 12.2168 18.495 12.1226 18.0613 12.0643C17.9305 12.0467 17.8665 12.0339 17.8199 12.0247ZM13 18L7 18V17C7 15.3431 8.34315 14 10 14C11.6569 14 13 15.3431 13 17V18ZM13 9C13 8.44772 12.5523 8 12 8H8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10L12 10C12.5523 10 13 9.55229 13 9ZM13 12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H12C12.5523 11 13 11.4477 13 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","location","shop","company","business","property","enterprise","branch","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11V19M20 19V15C20 13.1144 20 12.1716 19.4142 11.5858C18.8284 11 17.8856 11 16 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 19V9C16 7.11438 16 6.17157 15.4142 5.58579C14.8284 5 13.8856 5 12 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 19L3 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19V17C8 15.8954 8.89543 15 10 15V15C11.1046 15 12 15.8954 12 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "building-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","location","company","store","shop","branch","enterprise","business","establishment","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 7H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["building","store","location","property","real-estate","company","enterprise","branch","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 7H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["building","store","establishment","enterprise","shop","company","outlet","department","headquarters","business","branch","organization","warehouse","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 5.58579L16.8839 6.11612L16.8839 6.11612L17.4142 5.58579ZM6.58579 5.58579L7.11612 6.11612L6.58579 5.58579ZM4 18.25C3.58579 18.25 3.25 18.5858 3.25 19C3.25 19.4142 3.58579 19.75 4 19.75V18.25ZM20 19.75C20.4142 19.75 20.75 19.4142 20.75 19C20.75 18.5858 20.4142 18.25 20 18.25V19.75ZM5.25 9V19H6.75V9H5.25ZM18.75 19V9H17.25V19H18.75ZM10 5.75H14V4.25H10V5.75ZM18.75 9C18.75 8.07839 18.7516 7.31174 18.6701 6.70552C18.5857 6.07773 18.4 5.51093 17.9445 5.05546L16.8839 6.11612C17.0142 6.24643 17.1214 6.44393 17.1835 6.90539C17.2484 7.38843 17.25 8.03599 17.25 9H18.75ZM14 5.75C14.964 5.75 15.6116 5.75159 16.0946 5.81654C16.5561 5.87858 16.7536 5.9858 16.8839 6.11612L17.9445 5.05546C17.4891 4.59999 16.9223 4.41432 16.2945 4.32991C15.6883 4.24841 14.9216 4.25 14 4.25V5.75ZM6.75 9C6.75 8.03599 6.75159 7.38843 6.81654 6.90539C6.87858 6.44393 6.9858 6.24643 7.11612 6.11612L6.05546 5.05546C5.59999 5.51093 5.41432 6.07773 5.32991 6.70552C5.24841 7.31174 5.25 8.07839 5.25 9H6.75ZM10 4.25C9.07839 4.25 8.31174 4.24841 7.70552 4.32991C7.07773 4.41432 6.51093 4.59999 6.05546 5.05546L7.11612 6.11612C7.24643 5.9858 7.44393 5.87858 7.90539 5.81654C8.38843 5.75159 9.03599 5.75 10 5.75V4.25ZM4 19.75H6V18.25H4V19.75ZM6 19.75H18V18.25H6V19.75ZM18 19.75H20V18.25H18V19.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 17V19H14V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 18.25C3.58579 18.25 3.25 18.5858 3.25 19C3.25 19.4142 3.58579 19.75 4 19.75V18.25ZM20 19.75C20.4142 19.75 20.75 19.4142 20.75 19C20.75 18.5858 20.4142 18.25 20 18.25V19.75ZM4 19.75H20V18.25H4V19.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","structure","location","store","shop","marketplace","warehouse","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 14H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20V19C10 17.8954 10.8954 17 12 17V17C13.1046 17 14 17.8954 14 19V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "building-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["building","store","location","business","company","office","branch","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18V20H14V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 7H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","location","business","company","enterprise","branch","outlet","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM8 7C8 6.44772 8.44772 6 9 6H10C10.5523 6 11 6.44772 11 7C11 7.55228 10.5523 8 10 8H9C8.44772 8 8 7.55228 8 7ZM12 15.5C10.3431 15.5 9 16.8431 9 18.5V21H15V18.5C15 16.8431 13.6569 15.5 12 15.5ZM13 7C13 6.44772 13.4477 6 14 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H14C13.4477 8 13 7.55228 13 7ZM8 13C8 12.4477 8.44772 12 9 12H10C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H9C8.44772 14 8 13.5523 8 13ZM13 13C13 12.4477 13.4477 12 14 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H14C13.4477 14 13 13.5523 13 13ZM8 10C8 9.44772 8.44772 9 9 9H10C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11H9C8.44772 11 8 10.5523 8 10ZM13 10C13 9.44772 13.4477 9 14 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H14C13.4477 11 13 10.5523 13 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["drawer","cash-drawer","cash","register","money","refund","return","safe","till","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20V19C10 17.8954 10.8954 17 12 17V17C13.1046 17 14 17.8954 14 19V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 14H18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","structure","storage","warehouse","location","shop","store","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 6.54769 19 7.43417V12.5H5L5 7.43417C4.99995 6.54769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM10 7.5C9.44772 7.5 9 7.94772 9 8.5C9 9.05228 9.44772 9.5 10 9.5H14C14.5523 9.5 15 9.05228 15 8.5C15 7.94772 14.5523 7.5 14 7.5H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 14H19V19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 14ZM9 19C9 17.3431 10.3431 16 12 16C13.6569 16 15 17.3431 15 19V21H9V19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","shop","location","business","address","company","warehouse","establishment","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93417 4C9.04768 3.99995 8.28387 3.99991 7.67221 4.08215C7.01669 4.17028 6.38834 4.36902 5.87868 4.87868C5.36902 5.38835 5.17027 6.0167 5.08214 6.67221C4.9999 7.28387 4.99995 8.04769 5 8.93417L5 18H4C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20L9 20V17C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17V20L20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H19L19 8.93417C19.0001 8.04769 19.0001 7.28387 18.9179 6.67221C18.8297 6.0167 18.631 5.38835 18.1213 4.87868C17.6117 4.36902 16.9833 4.17028 16.3278 4.08215C15.7161 3.99991 14.9523 3.99995 14.0658 4H9.93417ZM8 7.5C8 6.94772 8.44772 6.5 9 6.5H15C15.5523 6.5 16 6.94772 16 7.5C16 8.05228 15.5523 8.5 15 8.5H9C8.44772 8.5 8 8.05228 8 7.5ZM8 11C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-22": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#FFFFFF"],
        keywords: ["machine","atm","vending","automate","dispense","cash","deposit","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10 19V20H14V19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 14H19" stroke={colors?.[2] || "#FFFFFF"} strokeWidth="1.5" />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","location","establishment","company","business","organization","enterprise","branch","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 7H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["building","location","store","company","establishment","address","property","real-estate","branch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 7H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","location","shop","business","company","address","establishment","marketplace","branch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 11H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["building","store","shop","location","address","branch","company","establishment","business","point-of-sale","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 11H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "building-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["building","storage","warehouse","inventory","location","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H15V19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19V21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM8 7C8 6.44772 8.44772 6 9 6H10C10.5523 6 11 6.44772 11 7C11 7.55228 10.5523 8 10 8H9C8.44772 8 8 7.55228 8 7ZM13 7C13 6.44772 13.4477 6 14 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H14C13.4477 8 13 7.55228 13 7ZM8 13C8 12.4477 8.44772 12 9 12H10C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H9C8.44772 14 8 13.5523 8 13ZM13 13C13 12.4477 13.4477 12 14 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H14C13.4477 14 13 13.5523 13 13ZM8 10C8 9.44772 8.44772 9 9 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H9C8.44772 11 8 10.5523 8 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "building-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["building","store","location","establishment","business","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18V20H14V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 7H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    building: {
        defaultColors: ["#3D4C66"],
        keywords: ["building","store","location","establishment","business","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 19H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bulb-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["idea","suggestion","tip","lightning","bolt","electricity","power","alert","warning","highlight","feature","improvement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 8L11 11H13L11.9998 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bulb-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bulb","idea","light","lightning","energy","power","innovation","suggestion","flash","zap","solution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9929 17.9964L14.9917 17.5196C14.9912 17.3133 14.991 17.2102 14.9422 17.1357C14.9195 17.1009 14.8897 17.0713 14.8549 17.0486C14.7803 17 14.6772 17 14.4709 17H9.52174C9.31417 17 9.21039 17 9.13546 17.0491C9.10108 17.0717 9.0717 17.1011 9.04915 17.1355C9 17.2104 9 17.3142 9 17.5217V18.0036C9 18.9321 9 19.3964 9.15117 19.7628C9.35421 20.2549 9.74509 20.6458 10.2372 20.8488C10.6036 21 11.0679 21 11.9964 21C12.927 21 13.3922 21 13.7591 20.8484C14.2519 20.6447 14.643 20.2527 14.8454 19.7595C14.9962 19.3922 14.9951 18.927 14.9929 17.9964V17.9964Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 8L11 11H13L11.9998 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bulb-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["idea","lightbulb","flash","lightning","energy","power","innovation","electricity","quick-sale","promotion","fast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.0158 19.0723C8.01744 19.1027 8.01924 19.1326 8.02123 19.1618C8.04357 19.4905 8.09273 19.8193 8.22679 20.1442C8.53135 20.8824 9.11766 21.4687 9.85586 21.7733C10.1808 21.9073 10.5096 21.9565 10.8382 21.9788C11.1504 22.0001 11.5275 22 11.9646 22H12.0284C12.4664 22 12.8443 22.0001 13.1571 21.9788C13.4863 21.9564 13.8157 21.9071 14.1411 21.7726C14.8802 21.4671 15.4668 20.8791 15.7706 20.1393C15.9043 19.8135 15.9528 19.484 15.9744 19.1548C15.9761 19.1286 15.9777 19.1019 15.9791 19.0748C14.7793 19.6672 13.4285 20 12 20C10.5694 20 9.21683 19.6662 8.0158 19.0723Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4729 17.6337C18.6009 16.1961 20 13.7614 20 11C20 6.58172 16.4183 3 12 3C7.58172 3 4 6.58172 4 11C4 13.9611 5.60881 16.5465 8.00003 17.9298C9.17672 18.6104 10.5429 19 12 19C13.6569 19 15.1961 18.4963 16.4729 17.6337ZM12.316 7.05133C11.792 6.87671 11.2257 7.1599 11.0511 7.68385L10.0513 10.6839C9.94966 10.9888 10.0008 11.324 10.1888 11.5848C10.3767 11.8455 10.6786 12 11 12H11.6125L11.0511 13.6837C10.8765 14.2077 11.1596 14.774 11.6835 14.9487C12.2075 15.1234 12.7738 14.8402 12.9485 14.3163L13.9487 11.3163C14.0503 11.0114 13.9992 10.6761 13.8113 10.4153C13.6233 10.1546 13.3214 10 13 10H12.3873L12.9485 8.3162C13.1231 7.79225 12.8399 7.22594 12.316 7.05133Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bulb-exclamation-on-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["warning","alert","attention","exclamation","notification","error","issue","problem","urgent","critical","system-alert","low-stock","inventory-warning","price-error","transaction-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 8L12 11M12 13.0342V14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 11H2"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17L4 18M5 5L4 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 4L19 5M20 18L19 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22 11H21"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bulb-exclamation-on-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["warning","alert","error","attention","issue","problem","notification","bulb","exclamation","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9929 17.9964L14.9917 17.5196C14.9912 17.3133 14.991 17.2102 14.9422 17.1357C14.9195 17.1009 14.8897 17.0713 14.8549 17.0486C14.7803 17 14.6772 17 14.4709 17H9.52174C9.31417 17 9.21039 17 9.13546 17.0491C9.10108 17.0717 9.0717 17.1011 9.04915 17.1355C9 17.2104 9 17.3142 9 17.5217V18.0036C9 18.9321 9 19.3964 9.15117 19.7628C9.35421 20.2549 9.74509 20.6458 10.2372 20.8488C10.6036 21 11.0679 21 11.9964 21C12.927 21 13.3922 21 13.7591 20.8484C14.2519 20.6447 14.643 20.2527 14.8454 19.7595C14.9962 19.3922 14.9951 18.927 14.9929 17.9964V17.9964Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 8L12 11M12 13.0342V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 11H2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17L4 18M5 5L4 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 4L19 5M20 18L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22 11H21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    bulb: {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","attention","issue","problem","notification","bulb","exclamation","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 8L11 11H13L11.9998 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "bulb-exclamation-on": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","notification","error","attention","issue","problem","lightbulb","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 8L12 11M12 13.0342V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 11H2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17L4 18M5 5L4 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 4L19 5M20 18L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22 11H21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bulbs-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["idea","lightbulb","suggestion","hint","tips","suggestion-box","feedback","improvement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.9905 18V18C14.9934 18.9256 14.9949 19.3884 14.8461 19.7541C14.6437 20.2512 14.25 20.6461 13.7536 20.85C13.3884 21 12.9248 21 11.9976 21V21C11.0686 21 10.6041 21 10.2381 20.8492C9.74526 20.6461 9.35388 20.2547 9.15082 19.7619C9 19.3959 9 18.9306 9 18V18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 18H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 18C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 18C15 16.5 16.5 15.5 17.1406 14.7513C18.2947 13.5032 19 11.834 19 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bulb-exclamation-on-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","notification","issue","problem","attention","critical","urgent","lightbulb","idea","exception"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.26113 18.9685C8.26368 19.0296 8.2668 19.0884 8.27064 19.1449C8.29212 19.4608 8.33844 19.7593 8.45788 20.0488C8.73706 20.7255 9.27451 21.263 9.95119 21.5422C10.2407 21.6616 10.5392 21.7079 10.8552 21.7294C11.1587 21.75 11.5284 21.75 11.9713 21.75H12.0217C12.4655 21.75 12.836 21.75 13.1401 21.7293C13.4566 21.7078 13.7557 21.6613 14.0456 21.5415C14.7232 21.2615 15.2609 20.7225 15.5393 20.0443C15.6584 19.7541 15.7041 19.455 15.7249 19.1384C15.7284 19.0846 15.7313 19.0288 15.7337 18.9709C14.6002 19.5027 13.3348 19.7999 12 19.7999C10.6631 19.7999 9.39589 19.5019 8.26113 18.9685Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 11C4.25 6.71979 7.71979 3.25 12 3.25C16.2802 3.25 19.75 6.71979 19.75 11C19.75 15.2802 16.2802 18.75 12 18.75C7.71979 18.75 4.25 15.2802 4.25 11ZM13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44772 11 8L11 11C11 11.5523 11.4477 12 12 12C12.5523 12 13 11.5523 13 11L13 8ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V14.4658C11 15.0181 11.4477 15.4658 12 15.4658C12.5523 15.4658 13 15.0181 13 14.4658V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.79289 3.29289C3.18342 2.90237 3.81658 2.90237 4.20711 3.29289L5.20711 4.29289C5.59763 4.68342 5.59763 5.31658 5.20711 5.70711C4.81658 6.09763 4.18342 6.09763 3.79289 5.70711L2.79289 4.70711C2.40237 4.31658 2.40237 3.68342 2.79289 3.29289ZM21.2071 3.29289C21.5976 3.68342 21.5976 4.31658 21.2071 4.70711L20.2071 5.70711C19.8166 6.09763 19.1834 6.09763 18.7929 5.70711C18.4024 5.31658 18.4024 4.68342 18.7929 4.29289L19.7929 3.29289C20.1834 2.90237 20.8166 2.90237 21.2071 3.29289ZM0.5 11C0.5 10.4477 0.947715 10 1.5 10H2.5C3.05228 10 3.5 10.4477 3.5 11C3.5 11.5523 3.05228 12 2.5 12H1.5C0.947715 12 0.5 11.5523 0.5 11ZM20.5 11C20.5 10.4477 20.9477 10 21.5 10H22.5C23.0523 10 23.5 10.4477 23.5 11C23.5 11.5523 23.0523 12 22.5 12H21.5C20.9477 12 20.5 11.5523 20.5 11ZM5.20711 16.2929C5.59763 16.6834 5.59763 17.3166 5.20711 17.7071L4.20711 18.7071C3.81658 19.0976 3.18342 19.0976 2.79289 18.7071C2.40237 18.3166 2.40237 17.6834 2.79289 17.2929L3.79289 16.2929C4.18342 15.9024 4.81658 15.9024 5.20711 16.2929ZM18.7929 16.2929C19.1834 15.9024 19.8166 15.9024 20.2071 16.2929L21.2071 17.2929C21.5976 17.6834 21.5976 18.3166 21.2071 18.7071C20.8166 19.0976 20.1834 19.0976 19.7929 18.7071L18.7929 17.7071C18.4024 17.3166 18.4024 16.6834 18.7929 16.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bulbs-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lightbulb","idea","tip","suggestion","advice","recommendation","innovation","new","concept","promotion","campaign","highlight","feature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7452 21H11.25C11.0178 21 10.9017 21 10.804 20.9904C9.85441 20.8968 9.10315 20.1456 9.00963 19.196C9 19.0983 9 18.9822 9 18.75C9 18.5178 9 18.4017 9.00963 18.304C9.10315 17.3544 9.85441 16.6032 10.804 16.5096C10.9017 16.5 11.0178 16.5 11.25 16.5H12.7452C12.977 16.5 13.0928 16.5 13.1905 16.5096C14.1387 16.6029 14.8894 17.352 14.9847 18.3C14.9945 18.3977 14.9948 18.5135 14.9952 18.7452C14.9957 18.9779 14.996 19.0942 14.9865 19.1921C14.8948 20.1432 14.143 20.8966 13.1921 20.9903C13.0942 21 12.9779 21 12.7452 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bulbs-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["lightbulb","idea","suggestion","tip","advice","hint","promotion","special-offer","smart-choice","solution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.00001 18.5373L8.00001 18.542C7.99994 18.7323 7.99987 18.8959 8.01447 19.0441C8.15475 20.4684 9.28164 21.5953 10.706 21.7356C10.8542 21.7502 11.0178 21.7501 11.2081 21.75H12.7873C12.9779 21.7501 13.1418 21.7502 13.2902 21.7355C14.7166 21.5949 15.8443 20.4648 15.9819 19.0382C15.9961 18.8909 15.9958 18.7284 15.9954 18.5396C14.7871 19.123 13.4317 19.45 12 19.45C10.5665 19.45 9.20951 19.1222 8.00001 18.5373Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 10.25C4 5.83172 7.58172 2.25 12 2.25C16.4183 2.25 20 5.83172 20 10.25C20 14.3299 16.9459 17.6965 12.9992 18.1882V13.6643L14.707 11.9572C15.0976 11.5668 15.0977 10.9336 14.7072 10.543C14.3168 10.1524 13.6836 10.1523 13.293 10.5428L12.9992 10.8365V9.25C12.9992 8.69772 12.5515 8.25 11.9992 8.25C11.4469 8.25 10.9992 8.69772 10.9992 9.25V10.8351L10.7072 10.543C10.3168 10.1524 9.68363 10.1523 9.29303 10.5428C8.90243 10.9332 8.90231 11.5664 9.29275 11.957L10.9992 13.6641V18.188C7.05328 17.6956 4 14.3293 4 10.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bulbs-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bulb","light","idea","suggestion","tip","inspiration","sales-tip","discount","promotion","new-idea"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 21H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 18C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 18C15 16.5 16.5 15.5 17.1406 14.7513C18.2947 13.5032 19 11.834 19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bulbs-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["idea","lightbulb","suggestion","innovation","tip","hint","inspiration","new-product","recommendation","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 18H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 21H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 18C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 18C15 16.5 16.5 15.5 17.1406 14.7513C18.2947 13.5032 19 11.834 19 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Bulbs-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lightbulb","idea","suggestion","tip","promotion","discount","new-feature","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9952 21H11C9.89543 21 9 20.1046 9 19C9 17.8954 9.89543 17 11 17H12.9952C14.098 17 14.9926 17.8925 14.9952 18.9952C14.9979 20.1017 14.1017 21 12.9952 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 18H9C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10C19 11.834 18.2947 13.5032 17.1406 14.7513C16.5 15.5 15 16.5 15 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M9 18H8.25V18.75H9V18ZM15 18V18.75H15.75V18H15ZM6.85941 14.7513L7.42928 14.2637L7.41988 14.2527L7.41006 14.2421L6.85941 14.7513ZM17.1406 14.7513L16.5899 14.2421L16.5801 14.2527L16.5707 14.2637L17.1406 14.7513ZM9 18.75H15V17.25H9V18.75ZM7.41006 14.2421C6.37903 13.1271 5.75 11.6379 5.75 10H4.25C4.25 12.0301 5.03152 13.8793 6.30875 15.2605L7.41006 14.2421ZM6.28953 15.2389C6.47906 15.4604 6.72593 15.6939 6.94352 15.9037C7.17416 16.1261 7.39849 16.3463 7.60041 16.5819C8.00906 17.0588 8.25 17.5132 8.25 18H9.75C9.75 16.9868 9.24094 16.1912 8.73944 15.6059C8.48629 15.3105 8.2155 15.0465 7.98473 14.8239C7.7409 14.5888 7.56005 14.4165 7.42928 14.2637L6.28953 15.2389ZM17.6912 15.2605C18.9685 13.8793 19.75 12.0301 19.75 10H18.25C18.25 11.6379 17.621 13.1271 16.5899 14.2421L17.6912 15.2605ZM16.5707 14.2637C16.44 14.4165 16.2591 14.5888 16.0153 14.8239C15.7845 15.0465 15.5137 15.3105 15.2606 15.6059C14.7591 16.1912 14.25 16.9868 14.25 18H15.75C15.75 17.5132 15.9909 17.0588 16.3996 16.5819C16.6015 16.3463 16.8258 16.1261 17.0565 15.9037C17.2741 15.6939 17.5209 15.4604 17.7105 15.2389L16.5707 14.2637ZM5.75 10C5.75 6.54822 8.54822 3.75 12 3.75V2.25C7.71979 2.25 4.25 5.71979 4.25 10H5.75ZM12 3.75C15.4518 3.75 18.25 6.54822 18.25 10H19.75C19.75 5.71979 16.2802 2.25 12 2.25V3.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bulbs-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["idea","lightbulb","suggestion","tip","innovation","new-product","promotion","special-offer","discount","inspiration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C7.58172 2 4 5.58172 4 10C4 12.0888 4.80183 13.9925 6.11268 15.4167C6.29059 15.6224 6.51225 15.8357 6.70696 16.023L6.76998 16.0837C7.0006 16.3061 7.21719 16.5189 7.41057 16.7446C7.80375 17.2034 8 17.601 8 18V19C8 20.6569 9.34315 22 11 22H12.9952C14.6525 22 15.9953 20.6564 15.9952 19H16V18C16 17.601 16.1963 17.2034 16.5894 16.7446C16.7828 16.5189 16.9994 16.3061 17.23 16.0837L17.2931 16.023C17.4878 15.8356 17.7094 15.6224 17.8873 15.4167C19.1982 13.9925 20 12.0888 20 10C20 5.58172 16.4183 2 12 2ZM12.9992 10C12.9992 9.44772 12.5515 9 11.9992 9C11.4469 9 10.9992 9.44772 10.9992 10V11.5851L10.7072 11.293C10.3168 10.9024 9.68363 10.9023 9.29303 11.2928C8.90243 11.6832 8.90231 12.3164 9.29275 12.707L10.9992 14.4141V18C10.9992 18.5523 11.4469 19 11.9992 19C12.5515 19 12.9992 18.5523 12.9992 18V14.4143L14.707 12.7072C15.0976 12.3168 15.0977 11.6836 14.7072 11.293C14.3168 10.9024 13.6836 10.9023 13.293 11.2928L12.9992 11.5865V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bulbs-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["lightbulb","idea","tip","suggestion","promotion","recommendation","insight","innovation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10C19 11.834 18.2947 13.5032 17.1406 14.7513C16.5 15.5 15 16.5 15 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9 18H8.25V18.75H9V18ZM15 18V18.75H15.75V18H15ZM6.85941 14.7513L7.42928 14.2637L7.41988 14.2527L7.41006 14.2421L6.85941 14.7513ZM17.1406 14.7513L16.5899 14.2421L16.5801 14.2527L16.5707 14.2637L17.1406 14.7513ZM9 18.75H15V17.25H9V18.75ZM7.41006 14.2421C6.37903 13.1271 5.75 11.6379 5.75 10H4.25C4.25 12.0301 5.03152 13.8793 6.30875 15.2605L7.41006 14.2421ZM6.28953 15.2389C6.47906 15.4604 6.72593 15.6939 6.94352 15.9037C7.17416 16.1261 7.39849 16.3463 7.60041 16.5819C8.00906 17.0588 8.25 17.5132 8.25 18H9.75C9.75 16.9868 9.24094 16.1912 8.73944 15.6059C8.48629 15.3105 8.2155 15.0465 7.98473 14.8239C7.7409 14.5888 7.56005 14.4165 7.42928 14.2637L6.28953 15.2389ZM17.6912 15.2605C18.9685 13.8793 19.75 12.0301 19.75 10H18.25C18.25 11.6379 17.621 13.1271 16.5899 14.2421L17.6912 15.2605ZM16.5707 14.2637C16.44 14.4165 16.2591 14.5888 16.0153 14.8239C15.7845 15.0465 15.5137 15.3105 15.2606 15.6059C14.7591 16.1912 14.25 16.9868 14.25 18H15.75C15.75 17.5132 15.9909 17.0588 16.3996 16.5819C16.6015 16.3463 16.8258 16.1261 17.0565 15.9037C17.2741 15.6939 17.5209 15.4604 17.7105 15.2389L16.5707 14.2637ZM5.75 10C5.75 6.54822 8.54822 3.75 12 3.75V2.25C7.71979 2.25 4.25 5.71979 4.25 10H5.75ZM12 3.75C15.4518 3.75 18.25 6.54822 18.25 10H19.75C19.75 5.71979 16.2802 2.25 12 2.25V3.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M15 21H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bulbs-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["bulb","lightbulb","idea","suggestion","promotion","discount","deal","special-offer","tip","solution","innovation","smart-pricing","pricing-strategy","pricing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 21C8 20.4477 8.44772 20 9 20H15C15.5523 20 16 20.4477 16 21C16 21.5523 15.5523 22 15 22H9C8.44772 22 8 21.5523 8 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.0888 19.1982 13.9925 17.8873 15.4167C17.7094 15.6224 17.4878 15.8356 17.2931 16.023L17.23 16.0837C16.9994 16.3061 16.7828 16.5189 16.5894 16.7446C16.1963 17.2034 16 17.601 16 18V19H12.9992V14.4143L14.707 12.7072C15.0976 12.3168 15.0977 11.6836 14.7072 11.293C14.3168 10.9024 13.6836 10.9023 13.293 11.2928L12.9992 11.5865V10C12.9992 9.44772 12.5515 9 11.9992 9C11.4469 9 10.9992 9.44772 10.9992 10V11.5851L10.7072 11.293C10.3168 10.9024 9.68363 10.9023 9.29303 11.2928C8.90243 11.6832 8.90231 12.3164 9.29275 12.707L10.9992 14.4141V19H8V18C8 17.601 7.80375 17.2034 7.41057 16.7446C7.21719 16.5189 7.0006 16.3061 6.76998 16.0837L6.70696 16.023C6.51225 15.8357 6.29059 15.6224 6.11268 15.4167C4.80183 13.9925 4 12.0888 4 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Bulbs-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["idea","lightbulb","suggestion","tip","innovation","settings","configuration","brainstorm","knowledge","power","on","smart","smart-device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Bulbs: {
        defaultColors: ["#3D4C66"],
        keywords: ["idea","lightbulb","suggestion","tip","innovation","settings","configuration","brainstorm","knowledge","power","on","smart","smart-device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 18V18C14.9934 18.9256 14.9949 19.3884 14.8461 19.7541C14.6437 20.2512 14.25 20.6461 13.7536 20.85C13.3884 21 12.9248 21 11.9976 21V21C11.0686 21 10.6041 21 10.2381 20.8492C9.74526 20.6461 9.35388 20.2547 9.15082 19.7619C9 19.3959 9 18.9306 9 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 18H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 18C9 16.5 7.5 15.5 6.85941 14.7513C5.70528 13.5032 5 11.834 5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 18C15 16.5 16.5 15.5 17.1406 14.7513C18.2947 13.5032 19 11.834 19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.9992 18V14M11.9992 14V10M11.9992 14L14 12M11.9992 14L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bullseye-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bullseye","target","focus","aim","center","point","goal","customer","customer-focus","analytics","metrics","marketing","accuracy","precision","achievement","sales-target","hit","bullseye-2"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="5"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
            </svg>
        )
    },
    "bullseye-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["target","bullseye","focus","accuracy","goal","sales-target","marketing","metric","objective","aim"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Bulbs-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bulb","idea","tip","insight","suggestion","highlight","notification","news","update","promotion","light-bulb","innovation","feature","point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9905 17L14.9929 17.9964C14.9951 18.927 14.9962 19.3922 14.8454 19.7595C14.643 20.2527 14.2519 20.6447 13.7591 20.8484C13.3922 21 12.927 21 11.9964 21V21C11.0679 21 10.6036 21 10.2372 20.8488C9.74509 20.6458 9.35421 20.2549 9.15117 19.7628C9 19.3964 9 18.9321 9 18.0036V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M11.9993 18V10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 12L11.9992 14L10 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "bullseye-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","bullseye","goal","accuracy","focus","marketing","promotion","rewards","loyalty-program","discounts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    bullseye: {
        defaultColors: ["#3D4C66"],
        keywords: ["target","bullseye","goal","accuracy","focus","marketing","promotion","rewards","loyalty-program","discounts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "bumble-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","hamburger","options","list","settings","navigation","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M8 12L16 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L15 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L15 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "bumble-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","hamburger-menu","navigation","list","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.55224 6.73567C6.40475 5.05731 8.12767 4 10.0101 4H13.9897C15.8721 4 17.5951 5.05731 18.4476 6.73567L19.9714 9.73567C20.6942 11.1587 20.6942 12.8413 19.9714 14.2643L18.4476 17.2643C17.5951 18.9427 15.8721 20 13.9897 20H10.0101C8.12767 20 6.40475 18.9427 5.55224 17.2643L4.02843 14.2643C3.30563 12.8413 3.30563 11.1587 4.02843 9.73567L5.55224 6.73567ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11L8 11ZM8 9C8 8.44772 8.44772 8 9 8L15 8C15.5523 8 16 8.44771 16 9C16 9.55228 15.5523 10 15 10L9 10C8.44772 10 8 9.55228 8 9ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "bumble-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","hamburger-menu","navigation","options","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M8 12L16 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Bus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bus","transport","delivery","route","shipment","transit","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.99919 19.5017V18.3021C7.99919 18.1365 7.86501 18.0022 7.69942 18.0021L5.3004 18.0002C5.13456 18.0001 5.00008 18.1346 5.00017 18.3004L5.00085 19.5006C4.97272 20.3013 5.64316 20.9721 6.49941 21C7.35565 20.9727 8.02663 20.3024 7.99919 19.5017Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9992 19.5017V18.3021C18.9992 18.1365 18.865 18.0022 18.6994 18.0021L16.3004 18.0002C16.1346 18.0001 16.0001 18.1346 16.0002 18.3004L16.0009 19.5006C15.9727 20.3013 16.6432 20.9721 17.4994 21C18.3557 20.9727 19.0266 20.3024 18.9992 19.5017Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 3H8C6.11438 3 5.17157 3 4.58579 3.58579C4 4.17157 4 5.11438 4 7V14C4 15.8856 4 16.8284 4.58579 17.4142C5.17157 18 6.11438 18 8 18H16C17.8856 18 18.8284 18 19.4142 17.4142C20 16.8284 20 15.8856 20 14V7C20 5.11438 20 4.17157 19.4142 3.58579C18.8284 3 17.8856 3 16 3Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H7M16 15H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H11.9998M4 6H11.9998M11.9998 6V12M11.9998 6H20M11.9998 12H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                />
            </svg>
        )
    },
    bumble: {
        defaultColors: ["#3D4C66"],
        keywords: ["bus","transport","delivery","route","shipment","transit","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M8 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Bus: {
        defaultColors: ["#3D4C66"],
        keywords: ["bus","transport","delivery","route","shipment","transit","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 3H8C6.11438 3 5.17157 3 4.58579 3.58579C4 4.17157 4 5.11438 4 7V14C4 15.8856 4 16.8284 4.58579 17.4142C5.17157 18 6.11438 18 8 18H16C17.8856 18 18.8284 18 19.4142 17.4142C20 16.8284 20 15.8856 20 14V7C20 5.11438 20 4.17157 19.4142 3.58579C18.8284 3 17.8856 3 16 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L5.00085 19.5006C4.97272 20.3013 5.64316 20.9721 6.49941 21C7.35565 20.9727 8.02663 20.3024 7.99919 19.5017V18.0023"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18L16.0009 19.5006C15.9727 20.3013 16.6432 20.9721 17.4994 21C18.3557 20.9727 19.0266 20.3024 18.9992 19.5017V18.0023"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H7M16 15H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H11.9998H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Bus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bus","transport","delivery","shipping","route","transit","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18L5.00085 19.5006C4.97272 20.3013 5.64316 20.9721 6.49941 21C7.35565 20.9727 8.02663 20.3024 7.99919 19.5017V18.0023"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18L16.0009 19.5006C15.9727 20.3013 16.6432 20.9721 17.4994 21C18.3557 20.9727 19.0266 20.3024 18.9992 19.5017V18.0023"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 3H8C6.11438 3 5.17157 3 4.58579 3.58579C4 4.17157 4 5.11438 4 7V14C4 15.8856 4 16.8284 4.58579 17.4142C5.17157 18 6.11438 18 8 18H16C17.8856 18 18.8284 18 19.4142 17.4142C20 16.8284 20 15.8856 20 14V7C20 5.11438 20 4.17157 19.4142 3.58579C18.8284 3 17.8856 3 16 3Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H7M16 15H17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12H11.9998M4 6H11.9998M11.9998 6V12M11.9998 6H20M11.9998 12H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "C-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-c","c","currency","change","incomplete","order-in-progress","processing","payment","credit","confirmation","loading","wait"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H15C11.134 5 8 8.13401 8 12C8 15.866 11.134 19 15 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Bus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bus","transport","transit","delivery","route","schedule","transportation","public-transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.052 2.25H7.948H7.94797H7.94794C7.04949 2.24997 6.30029 2.24995 5.70553 2.32992C5.07773 2.41432 4.51093 2.59999 4.05546 3.05546C3.59999 3.51093 3.41432 4.07773 3.32992 4.70552C3.30719 4.87458 3.29092 5.05611 3.27928 5.25H20.7207C20.7091 5.05611 20.6928 4.87458 20.6701 4.70552C20.5857 4.07773 20.4 3.51093 19.9445 3.05546C19.4891 2.59999 18.9223 2.41432 18.2945 2.32992C17.6997 2.24995 16.9505 2.24997 16.0521 2.25H16.052H16.052ZM3.25 6.94797L3.25003 6.75H11.2498V11.25H3.25L3.25 6.948V6.94797ZM3.25 14.052L3.25 12.75H20.75L20.75 14.052C20.75 14.9505 20.7501 15.6997 20.6701 16.2945C20.5857 16.9223 20.4 17.4891 19.9445 17.9445C19.8771 18.012 19.8073 18.0735 19.7351 18.1296C19.7444 18.1857 19.7492 18.2433 19.7492 18.3021V19.4902C19.7842 20.7453 18.7414 21.7108 17.5234 21.7496C17.5072 21.7502 17.4911 21.7501 17.475 21.7496C16.2571 21.7099 15.2152 20.7439 15.2509 19.489L15.2505 18.75H8.74923V19.4902C8.7842 20.7453 7.74144 21.7108 6.52336 21.7496C6.50725 21.7502 6.49113 21.7501 6.47502 21.7496C5.25709 21.7099 4.21517 20.7439 4.25089 19.489L4.25022 18.3008C4.25018 18.2423 4.25494 18.1849 4.26411 18.129C4.19225 18.073 4.12264 18.0117 4.05546 17.9445C3.59999 17.4891 3.41432 16.9223 3.32992 16.2945C3.24995 15.6997 3.24997 14.9505 3.25 14.052V14.052ZM20.75 6.94801L20.75 11.25H12.7498V6.75H20.75L20.75 6.94801ZM6.25 15.5C6.25 15.0858 6.58579 14.75 7 14.75H8C8.41421 14.75 8.75 15.0858 8.75 15.5C8.75 15.9142 8.41421 16.25 8 16.25H7C6.58579 16.25 6.25 15.9142 6.25 15.5ZM15.25 15.5C15.25 15.0858 15.5858 14.75 16 14.75H17C17.4142 14.75 17.75 15.0858 17.75 15.5C17.75 15.9142 17.4142 16.25 17 16.25H16C15.5858 16.25 15.25 15.9142 15.25 15.5ZM5.75047 18.7506L5.7509 19.5002C5.7509 19.5091 5.75075 19.518 5.75044 19.5269C5.73871 19.8606 6.02439 20.2223 6.49972 20.2493C6.97509 20.2226 7.26111 19.8611 7.24967 19.5274C7.24938 19.5189 7.24923 19.5103 7.24923 19.5017V18.7517L5.75047 18.7506ZM16.7505 18.7506L16.7509 19.5002C16.7509 19.5091 16.7507 19.518 16.7504 19.5269C16.7387 19.8606 17.0244 20.2223 17.4997 20.2493C17.9751 20.2226 18.2611 19.8611 18.2497 19.5274C18.2494 19.5189 18.2492 19.5103 18.2492 19.5017V18.7517L16.7505 18.7506Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "C-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["c","curve","pending","incomplete","processing","loading","waiting","incomplete-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H15C11.134 5 8 8.13401 8 12C8 15.866 11.134 19 15 19H16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cabinet-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cabinet","drawer","storage","inventory","stock","products","archive","filing","organization","documents"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 17H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "C-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["C","letter-c","currency","credit","customer","custom","cents","coupon","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 7.58172 10.5817 4 15 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H15C11.6863 6 9 8.68629 9 12C9 15.3137 11.6863 18 15 18H16C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20H15C10.5817 20 7 16.4183 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    C: {
        defaultColors: ["#3D4C66"],
        keywords: ["C","letter-c","currency","credit","customer","custom","cents","coupon","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H15C11.134 5 8 8.13401 8 12C8 15.866 11.134 19 15 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cabinet-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cabinet","drawer","storage","organization","file","filing-cabinet","reports","documents","inventory","products","item-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 17H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cabinet-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cabinet","drawers","storage","archive","inventory","organization","product-list","records","database"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93417 2H15.0658C15.9523 1.99995 16.7161 1.99991 17.3278 2.08215C17.9833 2.17028 18.6117 2.36902 19.1213 2.87868C19.631 3.38835 19.8297 4.0167 19.9179 4.67221C20.0001 5.28387 20.0001 6.04769 20 6.93417V17.0658C20.0001 17.9523 20.0001 18.7161 19.9179 19.3278C19.8297 19.9833 19.631 20.6117 19.1213 21.1213C18.6117 21.631 17.9833 21.8297 17.3278 21.9179C16.7161 22.0001 15.9523 22.0001 15.0658 22H8.9342C8.0477 22.0001 7.28388 22.0001 6.67221 21.9179C6.0167 21.8297 5.38835 21.631 4.87868 21.1213C4.36902 20.6117 4.17028 19.9833 4.08215 19.3278C3.99991 18.7161 3.99995 17.9523 4 17.0658L4 13H20V11H4L4 6.93417C3.99995 6.04769 3.99991 5.28387 4.08215 4.67221C4.17028 4.0167 4.36902 3.38835 4.87868 2.87868C5.38835 2.36902 6.0167 2.17028 6.67221 2.08215C7.28387 1.99991 8.04769 1.99995 8.93417 2ZM15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17ZM10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8H14C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "cactus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cactus","desert","plant","decoration","theme","southwest","restaurant","menu","item","display","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8V9C6 9.93188 6 10.3978 6.15224 10.7654C6.35523 11.2554 6.74458 11.6448 7.23463 11.8478C7.60218 12 8.06812 12 9 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8V11C18 11.9319 18 12.3978 17.8478 12.7654C17.6448 13.2554 17.2554 13.6448 16.7654 13.8478C16.3978 14 15.9319 14 15 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 8L15 19H9L9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z" fill={colors?.[1] || "#D9D1E0"} />
                <path
                    d="M15 19L15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8L9 19M6 19H18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Cabinet: {
        defaultColors: ["#3D4C66"],
        keywords: ["cactus","desert","plant","decoration","theme","southwest","restaurant","menu","item","display","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 17H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cactus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cactus","desert","plant","mexican","menu-icon","theme","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8V9C6 9.93188 6 10.3978 6.15224 10.7654C6.35523 11.2554 6.74458 11.6448 7.23463 11.8478C7.60218 12 8.06812 12 9 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8V11C18 11.9319 18 12.3978 17.8478 12.7654C17.6448 13.2554 17.2554 13.6448 16.7654 13.8478C16.3978 14 15.9319 14 15 14V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19L15 8C15 6.34315 13.6569 5 12 5V5C10.3431 5 9 6.34315 9 8L9 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 19L18 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cactus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cactus","desert","plant","southwest","nature","garden","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.15 14.77C17.88 14.47 18.47 13.88 18.77 13.15C19 12.6 19 12.03 19 11V8C19 7.45 18.55 7 18 7C17.45 7 17 7.45 17 8V11C17 11.72 17 12.2 16.92 12.38C16.82 12.62 16.62 12.82 16.38 12.92C16.3 12.95 16.17 12.97 16 12.98V8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8V10.98C7.83 10.97 7.69 10.95 7.62 10.92C7.38 10.82 7.18 10.62 7.08 10.38C7 10.2 7 9.72 7 9V8C7 7.45 6.55 7 6 7C5.45 7 5 7.45 5 8V9C5 10.03 5 10.6 5.23 11.15C5.53 11.88 6.12001 12.47 6.85001 12.77C7.19001 12.91 7.55 12.96 8 12.98V18H6C5.45 18 5 18.45 5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H16V14.98C16.45 14.96 16.81 14.91 17.15 14.77Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    cactus: {
        defaultColors: ["#3D4C66"],
        keywords: ["cactus","desert","plant","southwest","nature","garden","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19L15 8C15 6.34315 13.6569 5 12 5V5C10.3431 5 9 6.34315 9 8L9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V9C6 9.93188 6 10.3978 6.15224 10.7654C6.35523 11.2554 6.74458 11.6448 7.23463 11.8478C7.60218 12 8.06812 12 9 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 8V11C18 11.9319 18 12.3978 17.8478 12.7654C17.6448 13.2554 17.2554 13.6448 16.7654 13.8478C16.3978 14 15.9319 14 15 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 19L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Calculator-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calculator","calculate","math","numbers","total","payment","price","discount","tax","change","amount","sum","count","result","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7H9C8.05719 7 7.58579 7 7.29289 7.29289C7 7.58579 7 8.05719 7 9C7 9.94281 7 10.4142 7.29289 10.7071C7.58579 11 8.05719 11 9 11H15C15.9428 11 16.4142 11 16.7071 10.7071C17 10.4142 17 9.94281 17 9C17 8.05719 17 7.58579 16.7071 7.29289C16.4142 7 15.9428 7 15 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17L17 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Calculator-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calculator","math","calculate","discount","percentage","total","price","amount","change","payment","sales","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7H9C8.05719 7 7.58579 7 7.29289 7.29289C7 7.58579 7 8.05719 7 9C7 9.94281 7 10.4142 7.29289 10.7071C7.58579 11 8.05719 11 9 11H15C15.9428 11 16.4142 11 16.7071 10.7071C17 10.4142 17 9.94281 17 9C17 8.05719 17 7.58579 16.7071 7.29289C16.4142 7 15.9428 7 15 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Calculator-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calculator","calculate","math","total","amount","discount","price","change","payment","figures","accounting","sales","tax","add","subtract","multiply","divide","tally"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.45869 21 8.57533 21 9.92944V9.92946V14.0706V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H14.0705H9.92944H9.92942C8.5753 21 7.45869 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V14.0706V9.9294V9.92936C2.99997 8.57527 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57531 2.99997 9.9294 3H9.92943ZM7.7695 6.04554C8.10941 5.99984 8.52154 5.99992 8.94561 6.00001H15.0544C15.4785 5.99992 15.8906 5.99984 16.2305 6.04554C16.6137 6.09706 17.051 6.22259 17.4142 6.5858C17.7774 6.94902 17.903 7.38629 17.9545 7.7695C18.0002 8.10938 18.0001 8.52149 18 8.94553V8.94554V8.94555V8.94556V8.94557V8.94558V8.94559V8.94561V9.05444V9.05674V9.05679C18.0001 9.28936 18.0001 9.39322 17.9924 9.49652C17.9863 9.57985 17.9751 9.66281 17.955 9.8127L17.9545 9.81631C17.903 10.1995 17.7774 10.6368 17.4142 11C17.051 11.3632 16.6137 11.4887 16.2305 11.5403C15.8906 11.586 15.4785 11.5859 15.0544 11.5858H8.94559C8.52153 11.5859 8.10941 11.586 7.7695 11.5403C7.38629 11.4887 6.94902 11.3632 6.5858 11C6.22259 10.6368 6.09706 10.1995 6.04554 9.81631L6.04506 9.81273C6.02491 9.66282 6.01375 9.57985 6.00759 9.49651C5.99994 9.3932 5.99996 9.28933 6.00001 9.05669V9.05668L6.00001 9.05442V8.94561V8.9456C5.99993 8.52153 5.99984 8.10941 6.04554 7.7695C6.09706 7.38629 6.22259 6.94902 6.5858 6.5858C6.94902 6.22259 7.38629 6.09706 7.7695 6.04554ZM16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14V17ZM6 14C6 13.4477 6.44772 13 7 13H9C9.55229 13 10 13.4477 10 14C10 14.5523 9.55229 15 9 15H7C6.44772 15 6 14.5523 6 14ZM7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18H9C9.55229 18 10 17.5523 10 17C10 16.4477 9.55229 16 9 16H7ZM11 14C11 13.4477 11.4477 13 12 13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H12C11.4477 15 11 14.5523 11 14ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H14C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Calculator-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["reports","statistics","sales-report","summary","dashboard","charts","graphs","analytics","data","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 6.77772C19 7.78661 19 9.19108 19 12C19 14.8089 19 16.2134 18.3259 17.2223C18.034 17.659 17.659 18.034 17.2223 18.3259C16.2134 19 14.8089 19 12 19C9.19108 19 7.78661 19 6.77772 18.3259C6.34096 18.034 5.96596 17.659 5.67412 17.2223C5 16.2134 5 14.8089 5 12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5C14.8089 5 16.2134 5 17.2223 5.67412C17.659 5.96596 18.034 6.34096 18.3259 6.77772Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 13.1046 8.89543 14 10 14C10.5523 14 11.0523 13.7761 11.4142 13.4142C11.7761 13.0523 12 12.5523 12 12H10V10C8.89543 10 8 10.8954 8 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Calculator-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["calculator","calculate","math","discount","price","total","sum","payment","finance","accounting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7H9C8.05719 7 7.58579 7 7.29289 7.29289C7 7.58579 7 8.05719 7 9C7 9.94281 7 10.4142 7.29289 10.7071C7.58579 11 8.05719 11 9 11H15C15.9428 11 16.4142 11 16.7071 10.7071C17 10.4142 17 9.94281 17 9C17 8.05719 17 7.58579 16.7071 7.29289C16.4142 7 15.9428 7 15 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 17H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Calculator-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","statistics","data","dashboard","report","analytics","pie-chart","summary","sales-report","inventory-report","performance","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C10.6413 3.99999 9.49174 3.99997 8.61264 4.0894C7.70523 4.18171 6.91829 4.37751 6.22215 4.84265C5.6762 5.20745 5.20745 5.6762 4.84265 6.22215C4.37751 6.91829 4.18171 7.70523 4.0894 8.61264C3.99997 9.49173 3.99999 10.5874 4 11.946V12.0539C3.99999 13.4126 3.99997 14.5083 4.0894 15.3874C4.18171 16.2948 4.37751 17.0817 4.84265 17.7779C5.20745 18.3238 5.6762 18.7926 6.22215 19.1573C6.91829 19.6225 7.70523 19.8183 8.61264 19.9106C9.49171 20 10.6413 20 11.9999 20C13.3585 20 14.5083 20 15.3874 19.9106C16.2948 19.8183 17.0817 19.6225 17.7779 19.1573C18.3238 18.7926 18.7926 18.3238 19.1573 17.7779C19.6225 17.0817 19.8183 16.2948 19.9106 15.3874C20 14.5083 20 13.4127 20 12.0541V11.946C20 10.5874 20 9.49171 19.9106 8.61264C19.8183 7.70523 19.6225 6.91829 19.1573 6.22215C18.7926 5.6762 18.3238 5.20745 17.7779 4.84265C17.0817 4.37751 16.2948 4.18171 15.3874 4.0894C14.5083 3.99997 13.3587 3.99999 12 4ZM6.87 12C6.87 10.4812 8.10121 9.25 9.62 9.25C10.0342 9.25 10.37 9.58579 10.37 10V11.25H11.62C12.0342 11.25 12.37 11.5858 12.37 12C12.37 12.7592 12.0614 13.4477 11.5645 13.9445C11.0677 14.4414 10.3792 14.75 9.62 14.75C8.10121 14.75 6.87 13.5188 6.87 12ZM17.12 10C17.12 10.4142 16.7842 10.75 16.37 10.75H14.37C13.9558 10.75 13.62 10.4142 13.62 10C13.62 9.58579 13.9558 9.25 14.37 9.25H16.37C16.7842 9.25 17.12 9.58579 17.12 10ZM16.37 12.75C16.7842 12.75 17.12 12.4142 17.12 12C17.12 11.5858 16.7842 11.25 16.37 11.25H14.37C13.9558 11.25 13.62 11.5858 13.62 12C13.62 12.4142 13.9558 12.75 14.37 12.75H16.37ZM16.12 14C16.12 14.4142 15.7842 14.75 15.37 14.75H14.37C13.9558 14.75 13.62 14.4142 13.62 14C13.62 13.5858 13.9558 13.25 14.37 13.25H15.37C15.7842 13.25 16.12 13.5858 16.12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Calculator-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["reports","statistics","sales-report","chart","pie-chart","menu","settings","options","dashboard","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 6.77772C19 7.78661 19 9.19108 19 12C19 14.8089 19 16.2134 18.3259 17.2223C18.034 17.659 17.659 18.034 17.2223 18.3259C16.2134 19 14.8089 19 12 19C9.19108 19 7.78661 19 6.77772 18.3259C6.34096 18.034 5.96596 17.659 5.67412 17.2223C5 16.2134 5 14.8089 5 12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5C14.8089 5 16.2134 5 17.2223 5.67412C17.659 5.96596 18.034 6.34096 18.3259 6.77772Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 13.1046 8.89543 14 10 14C10.5523 14 11.0523 13.7761 11.4142 13.4142C11.7761 13.0523 12 12.5523 12 12H10V10C8.89543 10 8 10.8954 8 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Calculator: {
        defaultColors: ["#3D4C66"],
        keywords: ["reports","statistics","sales-report","chart","pie-chart","menu","settings","options","dashboard","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 6.77772C19 7.78661 19 9.19108 19 12C19 14.8089 19 16.2134 18.3259 17.2223C18.034 17.659 17.659 18.034 17.2223 18.3259C16.2134 19 14.8089 19 12 19C9.19108 19 7.78661 19 6.77772 18.3259C6.34096 18.034 5.96596 17.659 5.67412 17.2223C5 16.2134 5 14.8089 5 12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5C14.8089 5 16.2134 5 17.2223 5.67412C17.659 5.96596 18.034 6.34096 18.3259 6.77772Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 13.1046 8.89543 14 10 14C10.5523 14 11.0523 13.7761 11.4142 13.4142C11.7761 13.0523 12 12.5523 12 12H10V10C8.89543 10 8 10.8954 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","list","agenda","planning","daily","monthly","weekly","timeline","history","reservations","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","delivery-date","pickup-date","reservation","booking","due-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00001 13C7.00001 12.4477 7.44772 12 8.00001 12H12C12.5523 12 13 12.4477 13 13C13 13.5523 12.5523 14 12 14H8.00001C7.44772 14 7.00001 13.5523 7.00001 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.00001 9C7.44772 9 7.00001 9.44772 7.00001 10C7.00001 10.5523 7.44772 11 8.00001 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H8.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00001 5C9.00001 4.44772 8.55229 4 8.00001 4C7.44772 4 7.00001 4.44772 7.00001 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.06205 8.99675 4.03241 9.4716 4.01693 10H4L4 10.0706C3.99999 10.3941 3.99999 10.7041 4.0016 11.0006C3.99999 11.2962 4 11.6052 4.00001 11.9277L4.00001 13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64712 19.7565 7.57495 19.8813C8.4587 20.0001 9.57532 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V11.929C20 11.6056 20 11.2959 19.9984 10.9995C20 10.7034 20 10.3937 20 10.0706L20 10H19.9831C19.9676 9.4716 19.938 8.99674 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.5787 4.99997 9.00001 5.01692V5ZM17.9981 10.9995C17.9929 11.9181 17.9732 12.6076 17.8991 13.1586C17.8042 13.8646 17.6368 14.1916 17.4142 14.4142C17.1916 14.6368 16.8646 14.8042 16.1586 14.8991C15.4238 14.9979 14.4425 15 13 15H11C9.55752 15 8.57626 14.9979 7.84144 14.8991C7.13538 14.8042 6.80836 14.6368 6.58579 14.4142C6.36322 14.1916 6.19585 13.8646 6.10092 13.1586C6.02687 12.6078 6.00713 11.9186 6.00189 11.0005C6.00712 10.0819 6.02685 9.3924 6.10093 8.84143C6.19585 8.13538 6.36322 7.80836 6.5858 7.58579C6.80837 7.36322 7.13539 7.19585 7.84144 7.10092C8.57626 7.00213 9.55753 7 11 7H13C14.4425 7 15.4238 7.00213 16.1586 7.10092C16.8646 7.19585 17.1917 7.36322 17.4142 7.58579C17.6368 7.80836 17.8042 8.13538 17.8991 8.84143C17.9731 9.3922 17.9929 10.0814 17.9981 10.9995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","due-date","promotion","sales","sales-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 13H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar line-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["backpack","bag","inventory","products","items","storage","deliveries","stock","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17V17C5 14.1716 5 12.7574 5.87868 11.8787C6.75736 11 8.17157 11 11 11H13C15.8284 11 17.2426 11 18.1213 11.8787C19 12.7574 19 14.1716 19 17V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar line-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bag","handbag","purse","item","storage","container","save","export","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 20H8.5C8.03558 20 7.80337 20 7.60842 19.9743C6.26222 19.7971 5.2029 18.7378 5.02567 17.3916C5 17.1966 5 16.9644 5 16.5C5 13.6716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.6716 19 16.5C19 16.9644 19 17.1966 18.9743 17.3916C18.7971 18.7378 17.7378 19.7971 16.3916 19.9743C16.1966 20 15.9644 20 15.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16H14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar line-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","booking","time","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 16H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17V17C5 14.1716 5 12.7574 5.87868 11.8787C6.75736 11 8.17157 11 11 11H13C15.8284 11 17.2426 11 18.1213 11.8787C19 12.7574 19 14.1716 19 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar line": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","delivery date","pickup date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar minus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","minus","subtract","remove","decrease","schedule","event","delete-event","remove-appointment","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 11H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar line-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","planning","time","day","month","year","booking","reservation","availability","timeline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 16C9 15.4477 9.44772 15 10 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H10C9.44772 17 9 16.5523 9 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99999 14.5807 3.99998 15.0571 4.00632 15.5C3.99998 15.9429 3.99999 16.4193 4 16.9294L4 17H4.07187C4.08497 17.1472 4.10045 17.2889 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57534 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C19.8996 17.2889 19.915 17.1472 19.9281 17H20L20 16.9294C20 16.4193 20 15.9429 19.9937 15.5C20 15.0571 20 14.5806 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.57869 4.99997 9 5.01692V5ZM6.00673 15.5C6.0166 16.1757 6.04095 16.7125 6.10092 17.1586C6.19585 17.8646 6.36322 18.1916 6.58579 18.4142C6.80836 18.6368 7.13538 18.8042 7.84144 18.8991C8.57626 18.9979 9.55752 19 11 19H13C14.4425 19 15.4238 18.9979 16.1586 18.8991C16.8646 18.8042 17.1916 18.6368 17.4142 18.4142C17.6368 18.1916 17.8042 17.8646 17.8991 17.1586C17.9591 16.7125 17.9834 16.1757 17.9933 15.5C17.9834 14.8243 17.9591 14.2875 17.8991 13.8414C17.8042 13.1354 17.6368 12.8084 17.4142 12.5858C17.1916 12.3632 16.8646 12.1958 16.1586 12.1009C15.4238 12.0021 14.4425 12 13 12H11C9.55752 12 8.57626 12.0021 7.84144 12.1009C7.13538 12.1958 6.80836 12.3632 6.58579 12.5858C6.36322 12.8084 6.19585 13.1354 6.10092 13.8414C6.04095 14.2875 6.0166 14.8243 6.00673 15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","minus","remove","delete","schedule","cancel","appointment","event","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 11H14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","minus","remove","subtract","schedule","event","delete-event","cancel-event","discount-expiration","promotion-end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 10C9.44772 10 9.00001 10.4477 9.00001 11C9.00001 11.5523 9.44772 12 10 12H14C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00001 4C8.55229 4 9.00001 4.44772 9.00001 5V5.01692C9.5787 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C19.938 8.99674 19.9676 9.4716 19.9831 10H20L20 10.0706C20 10.3937 20 10.7034 19.9984 10.9995C20 11.2959 20 11.606 20 11.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57532 20 8.4587 20.0001 7.57495 19.8813C6.64712 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4.00001 13.0706L4.00001 11.9277C4 11.6052 3.99999 11.2962 4.0016 11.0006C3.99999 10.7041 3.99999 10.3941 4 10.0706L4 10H4.01693C4.03241 9.4716 4.06205 8.99675 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7.00001 5.22019V5C7.00001 4.44772 7.44772 4 8.00001 4ZM17.8991 13.1586C17.9732 12.6076 17.9929 11.9181 17.9981 10.9995C17.9929 10.0814 17.9731 9.3922 17.8991 8.84143C17.8042 8.13538 17.6368 7.80836 17.4142 7.58579C17.1917 7.36322 16.8646 7.19585 16.1586 7.10092C15.4238 7.00213 14.4425 7 13 7H11C9.55753 7 8.57626 7.00213 7.84144 7.10092C7.13539 7.19585 6.80837 7.36322 6.5858 7.58579C6.36322 7.80836 6.19585 8.13538 6.10093 8.84143C6.02685 9.3924 6.00712 10.0819 6.00189 11.0005C6.00713 11.9186 6.02687 12.6078 6.10092 13.1586C6.19585 13.8646 6.36322 14.1916 6.58579 14.4142C6.80836 14.6368 7.13538 14.8042 7.84144 14.8991C8.57626 14.9979 9.55752 15 11 15H13C14.4425 15 15.4238 14.9979 16.1586 14.8991C16.8646 14.8042 17.1916 14.6368 17.4142 14.4142C17.6368 14.1916 17.8042 13.8646 17.8991 13.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","remove","minus","subtract","schedule","appointment","event","cancel","delete-date","remove-date","cancel-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 11H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","time","day","month","year","booking","reservation","promotion","sale","discount","offer","special","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V5.22019C6.30703 5.37607 5.6886 5.65455 5.17158 6.17157C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.10045 8.71109 4.08497 8.85277 4.07187 9H19.9281C19.915 8.85277 19.8996 8.71109 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17157C18.3114 5.65455 17.693 5.37607 17 5.22019V4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4V5.01692C14.4213 4.99996 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.57869 4.99996 9 5.01692V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 11.9295C20 11.6061 20 11.2963 19.9984 11H4.0016C3.99999 11.2962 3.99999 11.6058 4 11.9289V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57528 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9295ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H10C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calendar","schedule","event","appointment","date","reminder","list","agenda","sales-report","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 4V6M15 4V6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 13H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","events","reminder","planning","agenda","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","due-date","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H12M10 17H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "calendar-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","schedule","date","event","appointment","reminder","booking","date-picker","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14H12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17H12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","time","booking","reservation","delivery date","due date","pickup date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 13.5C14 12.9477 14.4477 12.5 15 12.5H16C16.5523 12.5 17 12.9477 17 13.5C17 14.0523 16.5523 14.5 16 14.5H15C14.4477 14.5 14 14.0523 14 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 15.5C14.4477 15.5 14 15.9477 14 16.5C14 17.0523 14.4477 17.5 15 17.5H16C16.5523 17.5 17 17.0523 17 16.5C17 15.9477 16.5523 15.5 16 15.5H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 13.5C7 12.9477 7.44772 12.5 8 12.5H12C12.5523 12.5 13 12.9477 13 13.5C13 14.0523 12.5523 14.5 12 14.5H8C7.44772 14.5 7 14.0523 7 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 15.5C7.44772 15.5 7 15.9477 7 16.5C7 17.0523 7.44772 17.5 8 17.5H12C12.5523 17.5 13 17.0523 13 16.5C13 15.9477 12.5523 15.5 12 15.5H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4.5C9 3.94772 8.55229 3.5 8 3.5C7.44772 3.5 7 3.94772 7 4.5V4.72019C6.30703 4.87607 5.6886 5.15456 5.17158 5.67158C4.51547 6.32768 4.2435 7.14711 4.11876 8.07494C3.99994 8.95869 3.99997 10.0753 4 11.4294V13.5706C3.99999 13.8939 3.99999 14.2037 4.0016 14.5C3.99999 14.7963 3.99999 15.1061 4 15.4294L4 15.5H4.01692C4.03241 16.0284 4.06205 16.5033 4.11876 16.9251C4.2435 17.8529 4.51547 18.6723 5.17158 19.3284C5.82769 19.9845 6.64711 20.2565 7.57494 20.3813C8.45868 20.5001 9.57534 20.5 10.9294 20.5H13.0707C14.4247 20.5 15.5413 20.5001 16.4251 20.3813C17.3529 20.2565 18.1723 19.9845 18.8284 19.3284C19.4845 18.6723 19.7565 17.8529 19.8813 16.9251C19.938 16.5033 19.9676 16.0284 19.9831 15.5H20L20 15.4274C20 15.1048 20 14.7957 19.9984 14.5C20 14.2043 20 13.8946 20 13.572V11.4294C20 10.0753 20.0001 8.95868 19.8813 8.07494C19.7565 7.14711 19.4845 6.32768 18.8284 5.67158C18.3114 5.15455 17.693 4.87607 17 4.72019V4.5C17 3.94772 16.5523 3.5 16 3.5C15.4477 3.5 15 3.94772 15 4.5V4.51692C14.4213 4.49997 13.7784 4.49998 13.0706 4.5L13 4.5C13 3.94772 12.5523 3.5 12 3.5C11.4477 3.5 11 3.94772 11 4.5L10.9294 4.5C10.2216 4.49998 9.57869 4.49997 9 4.51692V4.5ZM6.00189 14.5C6.00713 15.4183 6.02686 16.1077 6.10092 16.6586C6.19585 17.3646 6.36322 17.6916 6.58579 17.9142C6.80836 18.1368 7.13538 18.3042 7.84144 18.3991C8.57626 18.4979 9.55752 18.5 11 18.5H13C14.4425 18.5 15.4238 18.4979 16.1586 18.3991C16.8646 18.3042 17.1916 18.1368 17.4142 17.9142C17.6368 17.6916 17.8042 17.3646 17.8991 16.6586C17.9731 16.1077 17.9929 15.4183 17.9981 14.5C17.9929 13.5817 17.9731 12.8923 17.8991 12.3414C17.8042 11.6354 17.6368 11.3084 17.4142 11.0858C17.1916 10.8632 16.8646 10.6958 16.1586 10.6009C15.4238 10.5021 14.4425 10.5 13 10.5H11C9.55752 10.5 8.57626 10.5021 7.84144 10.6009C7.13538 10.6958 6.80836 10.8632 6.58579 11.0858C6.36322 11.3084 6.19585 11.6354 6.10092 12.3414C6.02686 12.8923 6.00713 13.5817 6.00189 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","date-picker","time","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 20H8.5C8.03558 20 7.80337 20 7.60842 19.9743C6.26222 19.7971 5.2029 18.7378 5.02567 17.3916C5 17.1966 5 16.9644 5 16.5C5 13.6716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.6716 19 16.5C19 16.9644 19 17.1966 18.9743 17.3916C18.7971 18.7378 17.7378 19.7971 16.3916 19.9743C16.1966 20 15.9644 20 15.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14H16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17H16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14H12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17H12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","events","appointment","reservation","reminder","day","month","year","time","booking","promotion","special-offer","discount","event-scheduling"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 13H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reservation","booking","day","month","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V5.22019C6.30703 5.37607 5.6886 5.65455 5.17158 6.17157C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.10045 8.71109 4.08497 8.85277 4.07187 9H19.9281C19.915 8.85277 19.8996 8.71109 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17157C18.3114 5.65455 17.693 5.37607 17 5.22019V4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4V5.01692C14.4213 4.99996 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.57869 4.99996 9 5.01692V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 11.9295C20 11.6061 20 11.2963 19.9984 11H4.0016C3.99999 11.2962 3.99999 11.6058 4 11.9289V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57526 21 10.9293 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0707V11.9295ZM14 14C14 13.4477 14.4477 13 15 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15C14.4477 15 14 14.5523 14 14ZM15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18H16C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16H15ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H12C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","date-picker","time","availability","reservation","due-date","sales-report-schedule","promotion-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","planning","sales-report","reservations","booking","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","events","agenda","reminder","booking","reservations","promotion-schedule","discount-dates","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","event","date","schedule","appointment","reminder","planning","agenda","due-date","timeline","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 4V6M15 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 13H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","time","booking","reservation","due-date","delivery-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13H11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","time","day","month"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.5787 4.99996 10.2216 4.99998 10.9294 5H13.0706C13.7784 4.99998 14.4213 4.99996 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17157C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C19.9097 8.78658 19.9313 9.01158 19.9478 9.25H4.05221C4.06866 9.01158 4.0903 8.78658 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17157C5.6886 5.65455 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.0034 10.75C3.99998 11.1209 3.99999 11.5139 4 11.9294V12.25H11C11.4142 12.25 11.75 12.5858 11.75 13C11.75 13.4142 11.4142 13.75 11 13.75H4V14.0706C3.99999 14.486 3.99998 14.8791 4.0034 15.25H9C9.41422 15.25 9.75 15.5858 9.75 16C9.75 16.4142 9.41422 16.75 9 16.75H4.05221C4.06866 16.9884 4.0903 17.2134 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57527 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 11.514 20 11.1209 19.9966 10.75H4.0034Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","availability","timeline","promotion","sales-report","inventory-schedule","delivery-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","booking","reservation","sales-report","date-range","time-period","month","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","time","day","month","year","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reservation","booking","day","month","reminder","sales-report","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","promotion","discount","day","month","year","booking","reservations","events","date-picker","schedule-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","schedule","date","appointment","event","reminder","booking","reservation","timeline","date-range","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3C9.55229 3 10 3.44772 10 4V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V4C14 3.44772 14.4477 3 15 3C15.5523 3 16 3.44772 16 4V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45869 20 10.5754 20 11.9295V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.71109 5.10045 7.85278 5.08496 8 5.07187V4C8 3.44772 8.44772 3 9 3ZM7 13C7 12.4477 7.44772 12 8 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H8C7.44772 14 7 13.5523 7 13ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H8ZM7 16C7 15.4477 7.44772 15 8 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H8C7.44772 17 7 16.5523 7 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","month","year","time","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5V5.07187C7.85278 5.08496 7.71109 5.10045 7.57494 5.11875C6.64711 5.2435 5.82769 5.51547 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57534 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.1723 5.51547 17.3529 5.2435 16.4251 5.11875C16.2889 5.10045 16.1472 5.08496 16 5.07187V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.00159C13.7037 4.99998 13.3939 4.99999 13.0706 5H10.9294C10.6061 4.99999 10.2963 4.99998 10 5.00159V5ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-29": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","timeline","booking","reservation","due-date","promotion","offer","discount","loyalty-program","recurring-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-30": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","schedule","appointment","date","event","reminder","booking","reservation","availability","timeline","planning","due-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","promotion","discount","offers","loyalty-program","booking","reservation","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.5787 4.99996 10.2216 4.99998 10.9294 5H11C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5H13.0706C13.7784 4.99998 14.4213 4.99996 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17157C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C19.9097 8.78658 19.9313 9.01158 19.9478 9.25H4.05221C4.06866 9.01158 4.0903 8.78658 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17157C5.6886 5.65455 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.0034 10.75C3.99998 11.1209 3.99999 11.5139 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57527 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 11.514 20 11.1209 19.9966 10.75H4.0034ZM8.25 13C8.25 12.5858 8.58579 12.25 9 12.25H15C15.4142 12.25 15.75 12.5858 15.75 13C15.75 13.4142 15.4142 13.75 15 13.75H9C8.58579 13.75 8.25 13.4142 8.25 13ZM10.25 16C10.25 15.5858 10.5858 15.25 11 15.25H13C13.4142 15.25 13.75 15.5858 13.75 16C13.75 16.4142 13.4142 16.75 13 16.75H11C10.5858 16.75 10.25 16.4142 10.25 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","time","day","month"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","time","month","day","plan","agenda","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-34": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","day","month","time","booking","reservation","timeline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-36": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","booking","day","month","year","time","reservation","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="10" y="13" width="4" height="4" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-39": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","booking","delivery-schedule","time","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0277 14.036L11.0287 14.0287L11.036 14.0277C11.2262 14.0021 11.5003 14 12 14C12.4997 14 12.7738 14.0021 12.964 14.0277L12.9713 14.0287L12.9723 14.036C12.9979 14.2262 13 14.5003 13 15C13 15.4997 12.9979 15.7738 12.9723 15.964L12.9713 15.9713L12.964 15.9723C12.7738 15.9979 12.4997 16 12 16C11.5003 16 11.2262 15.9979 11.036 15.9723L11.0287 15.9713L11.0277 15.964C11.0021 15.7738 11 15.4997 11 15C11 14.5003 11.0021 14.2262 11.0277 14.036Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5V5.07187C7.85278 5.08496 7.7111 5.10045 7.57494 5.11875C6.64711 5.2435 5.82769 5.51547 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45868 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57535 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.1723 5.51547 17.3529 5.2435 16.4251 5.11875C16.2889 5.10045 16.1472 5.08496 16 5.07187V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.00159C13.7037 4.99998 13.3939 4.99999 13.0706 5H10.9294C10.6061 4.99999 10.2963 4.99998 10 5.00159V5ZM7 9C7 8.44772 7.44772 8 8 8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H8C7.44772 10 7 9.55228 7 9ZM11.9456 12C11.5215 11.9999 11.1094 11.9998 10.7695 12.0455C10.3863 12.0971 9.94902 12.2226 9.5858 12.5858C9.22259 12.949 9.09706 13.3863 9.04554 13.7695C8.99984 14.1094 8.99992 14.5215 9.00001 14.9456V15.0544C8.99992 15.4785 8.99984 15.8906 9.04554 16.2305C9.09706 16.6137 9.22259 17.051 9.5858 17.4142C9.94902 17.7774 10.3863 17.903 10.7695 17.9545C11.1094 18.0002 11.5215 18.0001 11.9456 18H12.0544C12.4785 18.0001 12.8906 18.0002 13.2305 17.9545C13.6137 17.903 14.051 17.7774 14.4142 17.4142C14.7774 17.051 14.903 16.6137 14.9545 16.2305C15.0002 15.8906 15.0001 15.4785 15 15.0544V14.9456C15.0001 14.5215 15.0002 14.1094 14.9545 13.7695C14.903 13.3863 14.7774 12.949 14.4142 12.5858C14.051 12.2226 13.6137 12.0971 13.2305 12.0455C12.8906 11.9998 12.4785 11.9999 12.0544 12H11.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-38": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","booking","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="10"
                    y="13"
                    width="4"
                    height="4"
                    rx="1"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","event","schedule","appointment","reminder","time","day","month","agenda","deadline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00001 5C9.00001 4.44772 8.55229 4 8.00001 4C7.44772 4 7.00001 4.44772 7.00001 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.06205 8.99675 4.03241 9.4716 4.01693 10H4L4 10.0706C3.99999 10.3941 3.99999 10.7041 4.0016 11.0006C3.99999 11.2967 4 11.6063 4.00001 11.9294L4.00001 13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64712 19.7565 7.57495 19.8813C8.4587 20.0001 9.57532 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V11.9294C20 11.606 20 11.296 19.9984 10.9995C20 10.7034 20 10.3937 20 10.0706L20 10H19.9831C19.9676 9.4716 19.938 8.99674 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.5787 4.99997 9.00001 5.01692V5ZM17.9981 10.9995C17.9929 10.0814 17.9731 9.3922 17.8991 8.84143C17.8042 8.13538 17.6368 7.80836 17.4142 7.58579C17.1917 7.36322 16.8646 7.19585 16.1586 7.10092C15.4238 7.00213 14.4425 7 13 7H11C9.55753 7 8.57626 7.00213 7.84144 7.10092C7.13539 7.19585 6.80837 7.36322 6.5858 7.58579C6.36322 7.80836 6.19585 8.13538 6.10093 8.84143C6.02685 9.3924 6.00712 10.0819 6.00189 11.0005C6.00713 11.9186 6.02687 12.6078 6.10092 13.1586C6.19585 13.8646 6.36322 14.1916 6.58579 14.4142C6.80836 14.6368 7.13538 14.8042 7.84144 14.8991C8.57626 14.9979 9.55752 15 11 15H13C14.4425 15 15.4238 14.9979 16.1586 14.8991C16.8646 14.8042 17.1916 14.6368 17.4142 14.4142C17.6368 14.1916 17.8042 13.8646 17.8991 13.1586C17.9732 12.6076 17.9929 11.9181 17.9981 10.9995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","time","booking","reservation","day","month","year","availability","agenda","planning","sales-date","promotion-date","event-date","discount-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="10" y="13" width="4" height="4" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-37": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","events","agenda","appointment","reminder","time","day","month","year","planning","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="10" y="13" width="4" height="4" rx="1" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-40": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="10" y="13" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-41": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","time","deadline","booking","reservation","calendar-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="10" y="13" width="4" height="4" rx="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-44": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","sales-report","reporting","date-range","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11C16 9.89543 15.1046 9 14 9C12.8954 9 12 9.89543 12 11C12 12.1046 12.8954 13 14 13C15.1046 13 16 12.1046 16 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-42": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","pos","sales-report","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="10"
                    y="13"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-43": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0707C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.71109 5.10045 7.85278 5.08496 8 5.07187V5C8 4.44772 8.44772 4 9 4ZM7 9C7 8.44772 7.44772 8 8 8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H8C7.44772 10 7 9.55228 7 9ZM12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-45": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","timeline","pos-calendar","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11C16 9.89543 15.1046 9 14 9C12.8954 9 12 9.89543 12 11C12 12.1046 12.8954 13 14 13C15.1046 13 16 12.1046 16 11Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-46": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","timeline","time","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11C16 9.89543 15.1046 9 14 9C12.8954 9 12 9.89543 12 11C12 12.1046 12.8954 13 14 13C15.1046 13 16 12.1046 16 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-47": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","time","day","month","year","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.06205 8.99675 4.03241 9.4716 4.01692 10H4L4 10.0706C3.99999 10.3937 3.99999 10.7039 4.0016 11C3.99999 11.2961 3.99999 11.6056 4 11.9286V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57527 21 10.9294 21H13.0706C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 11.6061 20 11.2962 19.9984 10.9999C20 10.704 20 10.3947 20 10.0719L20 10H19.9831C19.9676 9.4716 19.938 8.99675 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.57869 4.99997 9 5.01692V5ZM17.8991 13.1586C17.9732 12.6077 17.9929 11.9183 17.9981 10.9999C17.9929 10.0816 17.9731 9.39228 17.8991 8.84143C17.8042 8.13538 17.6368 7.80836 17.4142 7.58579C17.1916 7.36322 16.8646 7.19585 16.1586 7.10092C15.4238 7.00213 14.4425 7 13 7H11C9.55752 7 8.57626 7.00213 7.84144 7.10092C7.13538 7.19585 6.80836 7.36322 6.58579 7.58579C6.36322 7.80836 6.19585 8.13538 6.10092 8.84143C6.02686 9.3923 6.00713 10.0817 6.00189 11C6.00713 11.9184 6.02686 12.6077 6.10092 13.1586C6.19585 13.8646 6.36322 14.1916 6.58579 14.4142C6.80836 14.6368 7.13538 14.8042 7.84144 14.8991C8.57626 14.9979 9.55752 15 11 15H13C14.4425 15 15.4238 14.9979 16.1586 14.8991C16.8646 14.8042 17.1916 14.6368 17.4142 14.4142C17.6368 14.1916 17.8042 13.8646 17.8991 13.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9.75C8 9.33579 8.33579 9 8.75 9H9.75C10.1642 9 10.5 9.33579 10.5 9.75C10.5 10.1642 10.1642 10.5 9.75 10.5H8.75C8.33579 10.5 8 10.1642 8 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 12.25C8 11.8358 8.33579 11.5 8.75 11.5H9.75C10.1642 11.5 10.5 11.8358 10.5 12.25C10.5 12.6642 10.1642 13 9.75 13H8.75C8.33579 13 8 12.6642 8 12.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 10.25C13.8358 10.25 13.5 10.5858 13.5 11C13.5 11.4142 13.8358 11.75 14.25 11.75C14.6642 11.75 15 11.4142 15 11C15 10.5858 14.6642 10.25 14.25 10.25ZM12 11C12 9.75736 13.0074 8.75 14.25 8.75C15.4926 8.75 16.5 9.75736 16.5 11C16.5 12.2426 15.4926 13.25 14.25 13.25C13.0074 13.25 12 12.2426 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-49": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointments","events","time","reservation","availability","booking","daily-sales","monthly-sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H15C15.5523 13 16 12.5523 16 12V11C16 10.4477 15.5523 10 15 10H14C13.4477 10 13 10.4477 13 11V12C13 12.5523 13.4477 13 14 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-48": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","schedule","appointment","date","event","reminder","agenda","booking","reservation","timeline","due-date","monthly-view","daily-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 10H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H15C15.5523 13 16 12.5523 16 12V11C16 10.4477 15.5523 10 15 10H14C13.4477 10 13 10.4477 13 11V12C13 12.5523 13.4477 13 14 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","promotion","discount","offer","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10L19 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="10" y="13" width="4" height="4" rx="1" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-51": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","time","deadline","availability","planning","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0707 21H10.9294C9.57535 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V14.0706V11.9294V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.7111 5.10045 7.85278 5.08496 8 5.07187V5C8 4.44772 8.44772 4 9 4ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H10C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9H8ZM8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H8ZM7 16C7 15.4477 7.44772 15 8 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H8C7.44772 17 7 16.5523 7 16ZM14 9C12.8954 9 12 9.89543 12 11V12C12 13.1046 12.8954 14 14 14H15C16.1046 14 17 13.1046 17 12V11C17 9.89543 16.1046 9 15 9H14ZM14 11H15V12H14V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-52": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","day","month","year","time","agenda","plan","due-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-50": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","events","appointment","reminder","due-date","sales-report-date","promotion-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 10H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H15C15.5523 13 16 12.5523 16 12V11C16 10.4477 15.5523 10 15 10H14C13.4477 10 13 10.4477 13 11V12C13 12.5523 13.4477 13 14 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-54": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","timeline","planning","promotion","discount","sale","special-offer","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-55": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","booking","time","day","month","year","availability","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5V5.07187C7.85278 5.08496 7.7111 5.10045 7.57494 5.11875C6.64711 5.2435 5.82769 5.51547 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.06205 8.99675 4.03241 9.4716 4.01693 10H19.9831C19.9676 9.4716 19.938 8.99675 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.1723 5.51547 17.3529 5.2435 16.4251 5.11875C16.2889 5.10045 16.1472 5.08496 16 5.07187V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.00159C13.7037 4.99998 13.3939 4.99999 13.0706 5H10.9294C10.6061 4.99999 10.2963 4.99998 10 5.00159V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 11.9294C4 11.7835 3.99999 11.6404 4.00014 11.5H19.9999C20 11.6403 20 11.7833 20 11.9291V12.0706C20 13.4247 20.0001 14.5413 19.8813 15.4251C19.7565 16.3529 19.4845 17.1723 18.8284 17.8284C18.1723 18.4845 17.3529 18.7565 16.4251 18.8813C15.5413 19.0001 14.4247 19 13.0706 19H10.9294C9.57531 19 8.4587 19.0001 7.57494 18.8813C6.64711 18.7565 5.82769 18.4845 5.17158 17.8284C4.51547 17.1723 4.2435 16.3529 4.11876 15.4251C3.99994 14.5413 3.99997 13.4247 4 12.0706V11.9294ZM8 14C7.58579 14 7.25 14.3358 7.25 14.75C7.25 15.1642 7.58579 15.5 8 15.5H8.5C8.91422 15.5 9.25 15.1642 9.25 14.75C9.25 14.3358 8.91422 14 8.5 14H8ZM11 14C10.5858 14 10.25 14.3358 10.25 14.75C10.25 15.1642 10.5858 15.5 11 15.5H13C13.4142 15.5 13.75 15.1642 13.75 14.75C13.75 14.3358 13.4142 14 13 14H11ZM15.5 14C15.0858 14 14.75 14.3358 14.75 14.75C14.75 15.1642 15.0858 15.5 15.5 15.5H16C16.4142 15.5 16.75 15.1642 16.75 14.75C16.75 14.3358 16.4142 14 16 14H15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-53": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","schedule","date","appointment","event","reminder","date-range","time","deadline","sales-report","accounting-period"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 14H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-57": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","time","sales-report","reporting-period","promotion-schedule","discount-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L16 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 13H12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-56": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","due-date","timeline","sales-projection","promotion-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 13H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-59": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","time","reminder","due-date","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.5787 4.99996 10.2216 4.99998 10.9294 5H11C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5H13.0706C13.7784 4.99998 14.4213 4.99996 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17157C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C19.9097 8.78658 19.9313 9.01158 19.9478 9.25H4.05221C4.06866 9.01158 4.0903 8.78658 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17157C5.6886 5.65455 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.0034 10.75C3.99998 11.1209 3.99999 11.5139 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57527 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 11.514 20 11.1209 19.9966 10.75H4.0034ZM8 12.25C7.58579 12.25 7.25 12.5858 7.25 13C7.25 13.4142 7.58579 13.75 8 13.75H9C9.41421 13.75 9.75 13.4142 9.75 13C9.75 12.5858 9.41421 12.25 9 12.25H8ZM12 12.25C11.5858 12.25 11.25 12.5858 11.25 13C11.25 13.4142 11.5858 13.75 12 13.75H16C16.4142 13.75 16.75 13.4142 16.75 13C16.75 12.5858 16.4142 12.25 16 12.25H12ZM8 16.75H12C12.4142 16.75 12.75 16.4142 12.75 16C12.75 15.5858 12.4142 15.25 12 15.25H8C7.58579 15.25 7.25 15.5858 7.25 16C7.25 16.4142 7.58579 16.75 8 16.75ZM15 15.25C14.5858 15.25 14.25 15.5858 14.25 16C14.25 16.4142 14.5858 16.75 15 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16C16.75 15.5858 16.4142 15.25 16 15.25H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","deadline","booking","reservation","timestamp","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <rect x="10" y="13" width="4" height="4" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "calendar-58": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","event","promotion","discount","offer","appointment","reminder","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 13H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","sales-report","report-date","promotion-schedule","discount-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H12M10 17H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reminder","event","time","booking","reservation","deadline","due-date","promotion","sales-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9456 12C11.5215 11.9999 11.1094 11.9998 10.7695 12.0455C10.3863 12.0971 9.94902 12.2226 9.5858 12.5858C9.22259 12.949 9.09706 13.3863 9.04554 13.7695C8.99984 14.1094 8.99992 14.5215 9.00001 14.9456V15.0544C8.99992 15.4785 8.99984 15.8906 9.04554 16.2305C9.09706 16.6137 9.22259 17.051 9.5858 17.4142C9.94902 17.7774 10.3863 17.903 10.7695 17.9545C11.1094 18.0002 11.5215 18.0001 11.9456 18H12.0544C12.4785 18.0001 12.8906 18.0002 13.2305 17.9545C13.6137 17.903 14.051 17.7774 14.4142 17.4142C14.7774 17.051 14.903 16.6137 14.9545 16.2305C15.0002 15.8906 15.0001 15.4785 15 15.0544V14.9456C15.0001 14.5215 15.0002 14.1094 14.9545 13.7695C14.903 13.3863 14.7774 12.949 14.4142 12.5858C14.051 12.2226 13.6137 12.0971 13.2305 12.0455C12.8906 11.9998 12.4785 11.9999 12.0544 12H11.9456ZM11.0277 14.036L11.0287 14.0287L11.036 14.0277C11.2262 14.0021 11.5003 14 12 14C12.4997 14 12.7738 14.0021 12.964 14.0277L12.9713 14.0287L12.9723 14.036C12.9979 14.2262 13 14.5003 13 15C13 15.4997 12.9979 15.7738 12.9723 15.964L12.9713 15.9713L12.964 15.9723C12.7738 15.9979 12.4997 16 12 16C11.5003 16 11.2262 15.9979 11.036 15.9723L11.0287 15.9713L11.0277 15.964C11.0021 15.7738 11 15.4997 11 15C11 14.5003 11.0021 14.2262 11.0277 14.036Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.57869 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0707C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4ZM6.00189 11H17.9981C17.9999 11.3067 18 11.6389 18 12V14C18 15.4425 17.9979 16.4238 17.8991 17.1586C17.8042 17.8646 17.6368 18.1916 17.4142 18.4142C17.1916 18.6368 16.8646 18.8042 16.1586 18.8991C15.4238 18.9979 14.4425 19 13 19H11C9.55752 19 8.57626 18.9979 7.84144 18.8991C7.13538 18.8042 6.80836 18.6368 6.58579 18.4142C6.36322 18.1916 6.19585 17.8646 6.10092 17.1586C6.00213 16.4238 6 15.4425 6 14V12C6 11.6389 6.00014 11.3067 6.00189 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","promotion","discount","timeslot","availability","planning","management","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H12M10 17H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-add-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","add","schedule","event","appointment","reminder","new-event","create-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 11V11C18 8.17157 18 6.75736 17.1213 5.87868C16.2426 5 14.8284 5 12 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 10.5714V10.5714C4 9.15127 5.15127 8 6.57143 8H15C16.6569 8 18 9.34315 18 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M16 15V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16L17 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-add-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","add","schedule","event","appointment","new-event","create-schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.5 19H7.5C7.03558 19 6.80337 19 6.60842 18.9718C5.26222 18.7768 4.2029 17.6116 4.02567 16.1307C4 15.9163 4 15.6609 4 15.15C4 12.0387 4 9.9331 4.87868 8.96655C5.75736 8 7.17157 8 10 8H12C14.8284 8 16.2426 8 17.1213 8.96655C18 9.9331 18 12.0387 18 15.15C18 15.6609 18 15.9163 17.9743 16.1307C17.7971 17.6116 16.7378 18.7768 15.3916 18.9718C15.1966 19 14.9644 19 14.5 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="16"
                    r="4"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","add","schedule","event","appointment","create","new","plus","reminder","date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11V11C18 8.17157 18 6.75736 17.1213 5.87868C16.2426 5 14.8284 5 12 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 10.5714V10.5714C4 9.15127 5.15127 8 6.57143 8H15C16.6569 8 18 9.34315 18 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","add","schedule","event","appointment","new-appointment","new-event","add-appointment","add-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00001 3C7.55229 3 8.00001 3.44772 8.00001 4V4.01692C8.5787 3.99996 9.22162 3.99998 9.92943 4H10C10 3.44772 10.4477 3 11 3C11.5523 3 12 3.44772 12 4H13.046C13.3863 3.99999 13.704 3.99999 14 4.00297V4C14 3.44772 14.4477 3 15 3C15.5523 3 16 3.44772 16 4V4.16007C16.3508 4.23641 16.6835 4.35319 17 4.5359C17.6081 4.88697 18.113 5.39192 18.4641 6C18.9969 6.92287 18.9982 7.96573 19 9.48727L19 9.4988C19 9.4992 19 9.4996 19 9.5C19 10.0517 18.5531 10.4993 18.0012 10.5C17.454 10.5007 17.0089 10.0616 17.0001 9.51629C17 9.51102 17 9.50559 17 9.5C17 8.67157 16.3284 8 15.5 8H6.57143C5.75787 8 5.08871 8.61824 5.00814 9.41054C5.00038 9.8696 5.00001 10.3941 5.00001 11V12C5.00001 13.4425 5.00213 14.4237 5.10092 15.1586C5.19585 15.8646 5.36322 16.1916 5.58579 16.4142C5.79565 16.6241 6.09723 16.7838 6.71697 16.881C7.36598 16.9828 8.23354 16.9983 9.50122 16.9998C10.0535 17.0005 10.5007 17.4487 10.5 18.001C10.4993 18.5533 10.0511 19.0005 9.49879 18.9998C8.2682 18.9983 7.23775 18.9872 6.40699 18.8568C5.54697 18.7219 4.78703 18.4439 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11876 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0706V10.9294C2.99999 10.4466 2.99998 9.99403 3.00535 9.57143H3C3 9.4831 3.00321 9.39553 3.00951 9.30881C3.02207 8.65502 3.05121 8.07735 3.11876 7.57494C3.2435 6.64711 3.51547 5.82768 4.17158 5.17157C4.6886 4.65455 5.30703 4.37607 6.00001 4.22019V4C6.00001 3.44772 6.44772 3 7.00001 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 11.5C13.5147 11.5 11.5 13.5147 11.5 16C11.5 18.4853 13.5147 20.5 16 20.5C18.4853 20.5 20.5 18.4853 20.5 16C20.5 13.5147 18.4853 11.5 16 11.5ZM16 14.25C16.4142 14.25 16.75 14.5858 16.75 15V15.25H17C17.4142 15.25 17.75 15.5858 17.75 16C17.75 16.4142 17.4142 16.75 17 16.75H16.75V17C16.75 17.4142 16.4142 17.75 16 17.75C15.5858 17.75 15.25 17.4142 15.25 17V16.75H15C14.5858 16.75 14.25 16.4142 14.25 16C14.25 15.5858 14.5858 15.25 15 15.25H15.25V15C15.25 14.5858 15.5858 14.25 16 14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-cancel-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","cancel","delete","remove","appointment","schedule","event","unavailable","block","date","cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 20H8.5C8.03558 20 7.80337 20 7.60842 19.9743C6.26222 19.7971 5.2029 18.7378 5.02567 17.3916C5 17.1966 5 16.9644 5 16.5C5 13.6716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.6716 19 16.5C19 16.9644 19 17.1966 18.9743 17.3916C18.7971 18.7378 17.7378 19.7971 16.3916 19.9743C16.1966 20 15.9644 20 15.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15L14 13M12 15L10 17M12 15L10 13M12 15L14 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cancel-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","cancel","delete","remove","appointment","schedule","date","unavailable","blocked","time","event","reservation","cancellation","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15L14 13M12 15L10 17M12 15L10 13M12 15L14 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cancel": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","cancel","delete","remove","schedule","appointment","reservation","void","cancellation","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15L14 13M12 15L10 17M12 15L10 13M12 15L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cancel-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","cancel","date","remove","delete","appointment","schedule","void","cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L10.5858 15L9.29289 16.2929C8.90237 16.6834 8.90237 17.3166 9.29289 17.7071C9.68342 18.0976 10.3166 18.0976 10.7071 17.7071L12 16.4142L13.2929 17.7071C13.6834 18.0976 14.3166 18.0976 14.7071 17.7071C15.0976 17.3166 15.0976 16.6834 14.7071 16.2929L13.4142 15L14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929C14.3166 11.9024 13.6834 11.9024 13.2929 12.2929L12 13.5858L10.7071 12.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.57869 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.072C20 14.3948 20 14.7041 19.9984 15C20 15.2959 20 15.6052 20 15.928L20 16H19.9831C19.9676 16.5284 19.938 17.0033 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C4.06205 17.0033 4.03241 16.5284 4.01692 16H4L4 15.9294C3.99999 15.6061 3.99999 15.2963 4.0016 15C3.99999 14.7037 3.99999 14.3939 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4ZM6.10092 17.1586C6.02686 16.6077 6.00713 15.9183 6.00189 15C6.00713 14.0817 6.02686 13.3923 6.10092 12.8414C6.19585 12.1354 6.36322 11.8084 6.58579 11.5858C6.80836 11.3632 7.13538 11.1958 7.84144 11.1009C8.57626 11.0021 9.55752 11 11 11H13C14.4425 11 15.4238 11.0021 16.1586 11.1009C16.8646 11.1958 17.1916 11.3632 17.4142 11.5858C17.6368 11.8084 17.8042 12.1354 17.8991 12.8414C17.9731 13.3923 17.9929 14.0817 17.9981 15C17.9929 15.9183 17.9731 16.6077 17.8991 17.1586C17.8042 17.8646 17.6368 18.1916 17.4142 18.4142C17.1916 18.6368 16.8646 18.8042 16.1586 18.8991C15.4238 18.9979 14.4425 19 13 19H11C9.55752 19 8.57626 18.9979 7.84144 18.8991C7.13538 18.8042 6.80836 18.6368 6.58579 18.4142C6.36322 18.1916 6.19585 17.8646 6.10092 17.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-check-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","check","date","completed","confirmed","scheduled","agenda","event","appointment","reservation","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V10C18 8.13077 18 7.19615 17.5981 6.5C17.3348 6.04394 16.9561 5.66523 16.5 5.40192C15.8038 5 14.8692 5 13 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 14.8284 4 16.2426 4.87868 17.1213C5.75736 18 7.17157 18 10 18V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14.5 16L15.5 17L17.5 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-check-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","check","date","appointment","schedule","done","completed","confirmation","event","reminder","approved","task","agenda","booking","reservation","calendar-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V12C18 14.8284 18 16.2426 17.1213 17.1213C16.2426 18 14.8284 18 12 18H10C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="16"
                    r="4"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.5 16L15.5 17L17.5 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","check","schedule","appointment","confirmation","approved","event","date","reminder","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 10V10C18 8.13077 18 7.19615 17.5981 6.5C17.3348 6.04394 16.9561 5.66523 16.5 5.40192C15.8038 5 14.8692 5 13 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 14.8284 4 16.2426 4.87868 17.1213C5.75736 18 7.17157 18 10 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.5 16L15.5 17L17.5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","check","appointment","schedule","approved","confirmed","reservation","event","task-completed","date","time","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 4.25C8.25 3.69772 7.80229 3.25 7.25 3.25C6.69772 3.25 6.25 3.69772 6.25 4.25V4.47019C5.55703 4.62607 4.9386 4.90455 4.42158 5.42157C3.76547 6.07768 3.4935 6.89711 3.36876 7.82494C3.24994 8.70868 3.24997 9.82531 3.25 11.1794V12.3206C3.24997 13.6747 3.24994 14.7913 3.36876 15.6751C3.4935 16.6029 3.76547 17.4223 4.42158 18.0784C5.03703 18.6939 5.79697 18.9719 6.65699 19.1068C7.48775 19.2372 8.5182 19.2483 9.74879 19.2498C10.3011 19.2505 10.7493 18.8033 10.75 18.251C10.7507 17.6987 10.3035 17.2505 9.75122 17.2498C8.48354 17.2483 7.61598 17.2328 6.96697 17.131C6.34723 17.0338 6.04565 16.8741 5.83579 16.6642C5.61322 16.4416 5.44585 16.1146 5.35092 15.4086C5.25213 14.6737 5.25 13.6925 5.25 12.25V11.25C5.25 9.80752 5.25213 8.82625 5.35092 8.09143C5.44585 7.38538 5.61322 7.05836 5.83579 6.83579C6.05836 6.61322 6.38538 6.44584 7.09144 6.35092C7.82626 6.25212 8.80752 6.25 10.25 6.25H13.25C14.203 6.25 14.8509 6.25096 15.3496 6.29616C15.8346 6.34011 16.0795 6.41951 16.25 6.51795C16.554 6.69349 16.8065 6.94596 16.9821 7.25C17.1939 7.61688 17.248 8.05272 17.25 9.7512C17.2507 10.3035 17.6989 10.7507 18.2512 10.75C18.8035 10.7493 19.2507 10.3011 19.25 9.7488L19.25 9.73727C19.2482 8.21573 19.2469 7.17287 18.7141 6.25C18.363 5.64192 17.8581 5.13697 17.25 4.7859C16.9335 4.60319 16.6008 4.48641 16.25 4.41007V4.25C16.25 3.69772 15.8023 3.25 15.25 3.25C14.6977 3.25 14.25 3.69772 14.25 4.25V4.25297C13.954 4.24999 13.6363 4.24999 13.296 4.25H12.25C12.25 3.69772 11.8023 3.25 11.25 3.25C10.6977 3.25 10.25 3.69772 10.25 4.25H10.1794C9.47162 4.24998 8.8287 4.24996 8.25 4.26692V4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.75 8.75C7.19772 8.75 6.75 9.19772 6.75 9.75C6.75 10.3023 7.19772 10.75 7.75 10.75L13.25 10.75C13.8023 10.75 14.25 10.3023 14.25 9.75C14.25 9.19772 13.8023 8.75 13.25 8.75L7.75 8.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.75 13.25C6.75 12.6977 7.19772 12.25 7.75 12.25H10.25C10.8023 12.25 11.25 12.6977 11.25 13.25C11.25 13.8023 10.8023 14.25 10.25 14.25H7.75C7.19772 14.25 6.75 13.8023 6.75 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.75 16.25C11.75 13.7647 13.7647 11.75 16.25 11.75C18.7353 11.75 20.75 13.7647 20.75 16.25C20.75 18.7353 18.7353 20.75 16.25 20.75C13.7647 20.75 11.75 18.7353 11.75 16.25ZM18.2803 15.7803C18.5732 15.4874 18.5732 15.0126 18.2803 14.7197C17.9874 14.4268 17.5126 14.4268 17.2197 14.7197L15.75 16.1893L15.2803 15.7197C14.9874 15.4268 14.5126 15.4268 14.2197 15.7197C13.9268 16.0126 13.9268 16.4874 14.2197 16.7803L15.2197 17.7803C15.5126 18.0732 15.9874 18.0732 16.2803 17.7803L18.2803 15.7803Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-clock-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","clock","schedule","time","appointment","reminder","event","date","plan","timeline","reservation","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="16"
                    cy="16"
                    r="4"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V16H17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-clock-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["schedule","calendar","time","clock","appointment","reminder","event","due-date","planning","late","overdue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 5.40192L16.125 6.05144L16.5 5.40192ZM17.5981 6.5L16.9486 6.875L17.5981 6.5ZM3.25 11V12H4.75V11H3.25ZM10 5.75H13V4.25H10V5.75ZM13 5.75C13.9484 5.75 14.6096 5.75072 15.1222 5.79718C15.6245 5.8427 15.9101 5.92737 16.125 6.05144L16.875 4.7524C16.3937 4.47455 15.8639 4.35826 15.2576 4.3033C14.6616 4.24928 13.9208 4.25 13 4.25V5.75ZM18.75 10C18.75 9.07919 18.7507 8.33843 18.6967 7.7424C18.6417 7.13605 18.5254 6.60625 18.2476 6.125L16.9486 6.875C17.0726 7.0899 17.1573 7.37548 17.2028 7.87779C17.2493 8.39041 17.25 9.05158 17.25 10H18.75ZM16.125 6.05144C16.467 6.24892 16.7511 6.53296 16.9486 6.875L18.2476 6.125C17.9185 5.55493 17.4451 5.08154 16.875 4.7524L16.125 6.05144ZM3.25 12C3.25 13.393 3.24841 14.5132 3.36652 15.3918C3.48754 16.2919 3.74643 17.0497 4.34835 17.6517L5.40901 16.591C5.13225 16.3142 4.9518 15.9257 4.85315 15.1919C4.75159 14.4365 4.75 13.4354 4.75 12H3.25ZM10 17.25C8.56458 17.25 7.56347 17.2484 6.80812 17.1469C6.07434 17.0482 5.68577 16.8678 5.40901 16.591L4.34835 17.6517C4.95027 18.2536 5.70814 18.5125 6.60825 18.6335C7.48678 18.7516 8.60699 18.75 10 18.75V17.25ZM4.75 11C4.75 9.56458 4.75159 8.56347 4.85315 7.80812C4.9518 7.07434 5.13225 6.68577 5.40901 6.40901L4.34835 5.34835C3.74643 5.95027 3.48754 6.70814 3.36652 7.60825C3.24841 8.48678 3.25 9.60699 3.25 11H4.75ZM10 4.25C8.60699 4.25 7.48678 4.24841 6.60825 4.36652C5.70814 4.48754 4.95027 4.74643 4.34835 5.34835L5.40901 6.40901C5.68577 6.13225 6.07434 5.9518 6.80812 5.85315C7.56347 5.75159 8.56458 5.75 10 5.75V4.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M16 15V16H17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-clock-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","schedule","appointment","reminder","events","time","clock","booking","reservation","date","agenda","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 3C7.55229 3 8 3.44772 8 4V4.01692C8.5787 3.99996 9.22162 3.99998 9.92943 4H10C10 3.44772 10.4477 3 11 3C11.5523 3 12 3.44772 12 4H13.046C13.3863 3.99999 13.704 3.99999 14 4.00297V4C14 3.44772 14.4477 3 15 3C15.5523 3 16 3.44772 16 4V4.16007C16.3508 4.23641 16.6835 4.35319 17 4.5359C17.6081 4.88697 18.113 5.39192 18.4641 6C18.9969 6.92287 18.9982 7.96573 19 9.48727L19 9.4988C19.0007 10.0511 18.5535 10.4993 18.0012 10.5C17.4489 10.5007 17.0007 10.0535 17 9.5012C16.998 7.80272 16.9439 7.36688 16.7321 7C16.5565 6.69596 16.304 6.44349 16 6.26795C15.8295 6.16951 15.5846 6.09011 15.0996 6.04616C14.6009 6.00096 13.953 6 13 6H10C8.55752 6 7.57626 6.00212 6.84144 6.10092C6.13538 6.19584 5.80836 6.36322 5.58579 6.58579C5.36322 6.80836 5.19585 7.13538 5.10092 7.84143C5.00213 8.57625 5 9.55752 5 11V12C5 13.4425 5.00213 14.4237 5.10092 15.1586C5.19585 15.8646 5.36322 16.1916 5.58579 16.4142C5.79564 16.6241 6.09723 16.7838 6.71697 16.881C7.36598 16.9828 8.23354 16.9983 9.50122 16.9998C10.0535 17.0005 10.5007 17.4487 10.5 18.001C10.4993 18.5533 10.0511 19.0005 9.49878 18.9998C8.2682 18.9983 7.23775 18.9872 6.40699 18.8568C5.54696 18.7219 4.78702 18.4439 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11876 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0706V10.9294C2.99997 9.57533 2.99994 8.45869 3.11876 7.57494C3.2435 6.64711 3.51547 5.82768 4.17158 5.17157C4.6886 4.65455 5.30703 4.37607 6 4.22019V4C6 3.44772 6.44772 3 7 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.5 9.5C6.5 8.94772 6.94772 8.5 7.5 8.5L13 8.5C13.5523 8.5 14 8.94772 14 9.5C14 10.0523 13.5523 10.5 13 10.5L7.5 10.5C6.94772 10.5 6.5 10.0523 6.5 9.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.5 13C6.5 12.4477 6.94772 12 7.5 12H10C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H7.5C6.94772 14 6.5 13.5523 6.5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 11.5C13.5147 11.5 11.5 13.5147 11.5 16C11.5 18.4853 13.5147 20.5 16 20.5C18.4853 20.5 20.5 18.4853 20.5 16C20.5 13.5147 18.4853 11.5 16 11.5ZM16 14.25C16.4142 14.25 16.75 14.5858 16.75 15V15.25H17C17.4142 15.25 17.75 15.5858 17.75 16C17.75 16.4142 17.4142 16.75 17 16.75H16C15.5858 16.75 15.25 16.4142 15.25 16V15C15.25 14.5858 15.5858 14.25 16 14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-clock": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","clock","time","schedule","appointment","event","reminder","date","deadline","late","booking","reservation","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 10V10C18 8.13077 18 7.19615 17.5981 6.5C17.3348 6.04394 16.9561 5.66523 16.5 5.40192C15.8038 5 14.8692 5 13 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 14.8284 4 16.2426 4.87868 17.1213C5.75736 18 7.17157 18 10 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 10L13 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="16" cy="16" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 15V16H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cloud-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","cloud","date","schedule","online","backup","sync","calendar-cloud","appointments","cloud-calendar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.6667 12.5714C14.6667 11.1513 13.4728 10 12 10C10.7866 10 9.76245 10.7815 9.4394 11.851C8.59835 12.1563 8 12.9394 8 13.8571C8 15.0406 8.99492 16 10.2222 16H14.2222C14.7131 16 15.1576 15.8081 15.4793 15.4979C15.801 15.1877 16 14.7591 16 14.2857C16 13.4867 15.4332 12.8154 14.6661 12.6253C14.6665 12.6074 14.6667 12.5894 14.6667 12.5714Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cloud-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","cloud","date","schedule","appointment","weather","online","cloud-based","subscription","recurring","payment schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.6667 12.5714C14.6667 11.1513 13.4728 10 12 10C10.7866 10 9.76245 10.7815 9.4394 11.851C8.59835 12.1563 8 12.9394 8 13.8571C8 15.0406 8.99492 16 10.2222 16H14.2222C14.7131 16 15.1576 15.8081 15.4793 15.4979C15.801 15.1877 16 14.7591 16 14.2857C16 13.4867 15.4332 12.8154 14.6661 12.6253C14.6665 12.6074 14.6667 12.5894 14.6667 12.5714Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-cloud-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","cloud","schedule","appointment","online","cloud-calendar","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0707C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.71109 5.10045 7.85278 5.08496 8 5.07187V5C8 4.44772 8.44772 4 9 4ZM12 9C10.5243 9 9.23051 9.85404 8.65242 11.1122C7.67875 11.6435 7 12.6621 7 13.8571C7 15.6269 8.47723 17 10.2222 17H14.2222C14.9773 17 15.6691 16.704 16.1734 16.2177C16.6784 15.7308 17 15.0472 17 14.2857C17 13.2651 16.43 12.3976 15.609 11.9341C15.2985 10.2432 13.774 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-cloud": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","cloud","schedule","appointment","online","date","reminder","cloud-based","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.6667 12.5714C14.6667 11.1513 13.4728 10 12 10C10.7866 10 9.76245 10.7815 9.4394 11.851C8.59835 12.1563 8 12.9394 8 13.8571C8 15.0406 8.99492 16 10.2222 16H14.2222C14.7131 16 15.1576 15.8081 15.4793 15.4979C15.801 15.1877 16 14.7591 16 14.2857C16 13.4867 15.4332 12.8154 14.6661 12.6253C14.6665 12.6074 14.6667 12.5894 14.6667 12.5714Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-dashboard-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","dashboard","report","sales-report","overview","summary","metrics","performance","statistics","analysis","data","schedule","appointments","events","date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5C8 11.3284 8.67157 12 9.5 12C10.3284 12 11 11.3284 11 10.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15.5C11 14.6716 10.3284 14 9.5 14C8.67157 14 8 14.6716 8 15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10.5C16 9.67157 15.3284 9 14.5 9C13.6716 9 13 9.67157 13 10.5C13 11.3284 13.6716 12 14.5 12C15.3284 12 16 11.3284 16 10.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15.5C16 14.6716 15.3284 14 14.5 14C13.6716 14 13 14.6716 13 15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-dashboard-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","dashboard","schedule","dates","events","appointments","month-view","overview","sales-report","billing-cycle","subscription","due-date","analytics","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5C8 11.3284 8.67157 12 9.5 12C10.3284 12 11 11.3284 11 10.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15.5C11 14.6716 10.3284 14 9.5 14C8.67157 14 8 14.6716 8 15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10.5C16 9.67157 15.3284 9 14.5 9C13.6716 9 13 9.67157 13 10.5C13 11.3284 13.6716 12 14.5 12C15.3284 12 16 11.3284 16 10.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15.5C16 14.6716 15.3284 14 14.5 14C13.6716 14 13 14.6716 13 15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-dashboard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","dashboard","schedule","events","appointment","date","timeslot","availability","booking","reservation","overview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 8.5C8.39543 8.5 7.5 9.39543 7.5 10.5C7.5 11.6046 8.39543 12.5 9.5 12.5C10.6046 12.5 11.5 11.6046 11.5 10.5C11.5 9.39543 10.6046 8.5 9.5 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.5 13.5C8.39543 13.5 7.5 14.3954 7.5 15.5C7.5 16.6046 8.39543 17.5 9.5 17.5C10.6046 17.5 11.5 16.6046 11.5 15.5C11.5 14.3954 10.6046 13.5 9.5 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 13.5C13.3954 13.5 12.5 14.3954 12.5 15.5C12.5 16.6046 13.3954 17.5 14.5 17.5C15.6046 17.5 16.5 16.6046 16.5 15.5C16.5 14.3954 15.6046 13.5 14.5 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 10.5C12.5 9.39543 13.3954 8.5 14.5 8.5C15.6046 8.5 16.5 9.39543 16.5 10.5C16.5 11.6046 15.6046 12.5 14.5 12.5C13.3954 12.5 12.5 11.6046 12.5 10.5ZM15.3 10.5C15.3 10.0582 14.9418 9.7 14.5 9.7C14.0582 9.7 13.7 10.0582 13.7 10.5C13.7 10.9418 14.0582 11.3 14.5 11.3C14.9418 11.3 15.3 10.9418 15.3 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07186C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51546 18.8284 6.17157C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9293V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8812C15.5413 21.0001 14.4247 21 13.0707 21H10.9295C9.57538 21 8.45868 21.0001 7.57494 20.8812C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17157C5.82769 5.51546 6.64711 5.2435 7.57494 5.11875C7.7111 5.10045 7.85278 5.08496 8 5.07186V5C8 4.44772 8.44772 4 9 4ZM16.1586 7.10092C15.4238 7.00212 14.4425 7 13 7H11C9.55752 7 8.57626 7.00212 7.84144 7.10092C7.13538 7.19584 6.80836 7.36322 6.58579 7.58579C6.36322 7.80836 6.19585 8.13538 6.10092 8.84143C6.00213 9.57625 6 10.5575 6 12V14C6 15.4425 6.00213 16.4237 6.10092 17.1586C6.19585 17.8646 6.36322 18.1916 6.58579 18.4142C6.80836 18.6368 7.13538 18.8042 7.84144 18.8991C8.57626 18.9979 9.55752 19 11 19H13C14.4425 19 15.4238 18.9979 16.1586 18.8991C16.8646 18.8042 17.1916 18.6368 17.4142 18.4142C17.6368 18.1916 17.8042 17.8646 17.8991 17.1586C17.9979 16.4237 18 15.4425 18 14V12C18 10.5575 17.9979 9.57625 17.8991 8.84143C17.8042 8.13538 17.6368 7.80836 17.4142 7.58579C17.1916 7.36322 16.8646 7.19584 16.1586 7.10092Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-dashboard": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","events","reservation","booking","dashboard","summary","overview","reporting","timesheet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5C8 11.3284 8.67157 12 9.5 12C10.3284 12 11 11.3284 11 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15.5C11 14.6716 10.3284 14 9.5 14C8.67157 14 8 14.6716 8 15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10.5C16 9.67157 15.3284 9 14.5 9C13.6716 9 13 9.67157 13 10.5C13 11.3284 13.6716 12 14.5 12C15.3284 12 16 11.3284 16 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15.5C16 14.6716 15.3284 14 14.5 14C13.6716 14 13 14.6716 13 15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","month","year","time","due-date","first-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reservation","booking","day","time","reminder","due date","10th"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","day","tenth","10th","promotion","sale","discount","availability","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V5.22019C6.30703 5.37607 5.68859 5.65455 5.17158 6.17157C4.51547 6.82768 4.2435 7.64711 4.11875 8.57494C4.10045 8.71109 4.08496 8.85277 4.07187 9H19.9281C19.915 8.85277 19.8996 8.71109 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17157C18.3114 5.65455 17.693 5.37607 17 5.22019V4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4V5.01692C14.4213 4.99996 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.57869 4.99996 9 5.01692V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 11.9295C20 11.6061 20 11.2963 19.9984 11H4.00159C3.99998 11.2963 3.99999 11.6061 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11875 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82768 20.4845 6.64711 20.7565 7.57494 20.8812C8.4587 21.0001 9.57533 21 10.9295 21H13.0705C14.4247 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0705V11.9295ZM9 13C9.55229 13 10 13.4477 10 14V18C10 18.5523 9.55229 19 9 19C8.44772 19 8 18.5523 8 18V14C8 13.4477 8.44772 13 9 13ZM11 15.5C11 14.1193 12.1193 13 13.5 13C14.8807 13 16 14.1193 16 15.5V16.5C16 17.8807 14.8807 19 13.5 19C12.1193 19 11 17.8807 11 16.5V15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 15.5C13 15.2239 13.2239 15 13.5 15C13.7761 15 14 15.2239 14 15.5V16.5C14 16.7761 13.7761 17 13.5 17C13.2239 17 13 16.7761 13 16.5V15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","tenth","day","event","reminder","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","day","event","reminder","promotion","discount","offer","special-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","event","schedule","appointment","reminder","promotion","discount","offer","special-date","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 20H8.5C8.03558 20 7.80337 20 7.60842 19.9743C6.26222 19.7971 5.2029 18.7378 5.02567 17.3916C5 17.1966 5 16.9644 5 16.5C5 13.6716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.6716 19 16.5C19 16.9644 19 17.1966 18.9743 17.3916C18.7971 18.7378 17.7378 19.7971 16.3916 19.9743C16.1966 20 15.9644 20 15.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","day","event","reminder","tenth","promotion","sale","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 14.5C11 13.1193 12.1193 12 13.5 12C14.8807 12 16 13.1193 16 14.5V15.5C16 16.8807 14.8807 18 13.5 18C12.1193 18 11 16.8807 11 15.5V14.5ZM13.5 14C13.2239 14 13 14.2239 13 14.5V15.5C13 15.7761 13.2239 16 13.5 16C13.7761 16 14 15.7761 14 15.5V14.5C14 14.2239 13.7761 14 13.5 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 13C10 12.4477 9.55229 12 9 12C8.44772 12 8 12.4477 8 13V17C8 17.5523 8.44772 18 9 18C9.55229 18 10 17.5523 10 17V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99999 14.3939 3.99999 14.7037 4.0016 15C3.99999 15.2963 3.99999 15.6061 4 15.9294L4 16H4.01692C4.03241 16.5284 4.06205 17.0033 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57534 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C19.938 17.0033 19.9676 16.5284 19.9831 16H20L20 15.9278C20 15.6051 20 15.2958 19.9984 15C20 14.7042 20 14.3947 20 14.072V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.57869 4.99997 9 5.01692V5ZM6.00189 15C6.00713 15.9183 6.02686 16.6077 6.10092 17.1586C6.19585 17.8646 6.36322 18.1916 6.58579 18.4142C6.80836 18.6368 7.13538 18.8042 7.84144 18.8991C8.57626 18.9979 9.55752 19 11 19H13C14.4425 19 15.4238 18.9979 16.1586 18.8991C16.8646 18.8042 17.1916 18.6368 17.4142 18.4142C17.6368 18.1916 17.8042 17.8646 17.8991 17.1586C17.9731 16.6077 17.9929 15.9183 17.9981 15C17.9929 14.0817 17.9731 13.3923 17.8991 12.8414C17.8042 12.1354 17.6368 11.8084 17.4142 11.5858C17.1916 11.3632 16.8646 11.1958 16.1586 11.1009C15.4238 11.0021 14.4425 11 13 11H11C9.55752 11 8.57626 11.0021 7.84144 11.1009C7.13538 11.1958 6.80836 11.3632 6.58579 11.5858C6.36322 11.8084 6.19585 12.1354 6.10092 12.8414C6.02686 13.3923 6.00713 14.0817 6.00189 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","due-date","thirty-one","31","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V13M9 15H10C10.9428 15 11.4142 15 11.7071 14.7071C12 14.4142 12 13.9428 12 13V13M12 13H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","reminder","appointment","event","deadline","booking","reservation","promotion","discount","sales-end","monthly-report","end-of-month","31"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V13M9 15H10C10.9428 15 11.4142 15 11.7071 14.7071C12 14.4142 12 13.9428 12 13V13M12 13H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","deadline","promotion","discount","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V13M9 15H10C10.9428 15 11.4142 15 11.7071 14.7071C12 14.4142 12 13.9428 12 13V13M12 13H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","month","year","deadline","due-date","promotion","special-offer","discount","holiday"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.5787 4.99996 10.2216 4.99998 10.9294 5H11C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5H13.0706C13.7784 4.99998 14.4213 4.99996 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17157C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9293V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8812C15.5413 21.0001 14.4247 21 13.0707 21H10.9295C9.57538 21 8.45868 21.0001 7.57494 20.8812C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17157C5.6886 5.65455 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4ZM10 12C10.4997 12 10.7738 12.0021 10.964 12.0277L10.9713 12.0287L10.9723 12.036C10.9877 12.1502 10.9946 12.2946 10.9976 12.5H10C9.44772 12.5 9 12.9477 9 13.5C9 14.0523 9.44772 14.5 10 14.5H10.9976C10.9946 14.7054 10.9877 14.8498 10.9723 14.964L10.9713 14.9713L10.964 14.9723C10.7738 14.9979 10.4997 15 10 15H9C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17L10.0544 17C10.4785 17.0001 10.8906 17.0002 11.2305 16.9545C11.6137 16.903 12.051 16.7774 12.4142 16.4142C12.7774 16.051 12.903 15.6137 12.9545 15.2305C13.0002 14.8906 13.0001 14.4785 13 14.0544V12.9456C13.0001 12.5215 13.0002 12.1094 12.9545 11.7695C12.903 11.3863 12.7774 10.949 12.4142 10.5858C12.051 10.2226 11.6137 10.0971 11.2305 10.0455C10.8906 9.99984 10.4785 9.99992 10.0544 10L9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H10ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","event","schedule","reminder","appointment","booking","day","month","sales-date","promotion-date","discount-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","deadline","reminder","day","month","year","promotion","discount","special offer","last day","end of month","sales end","POS","reporting","sales data","time management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","deadline","promotion","discount","sales","day","month"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","thirty-one","31","event","reminder","sales-report","end-of-month","promotion-schedule","discount-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","day","month","year","promotion","discount","last day","end of month","billing cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.59316 6.74999 4.31329 7.45534 4.16965 8.25H19.8304C19.6867 7.45534 19.4069 6.74999 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5H10.9294C10.2216 4.99998 9.57869 4.99997 9 5.01692V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.1768 16.1768C11.1768 16.1768 11.177 16.1765 11.1768 16.1768V16.1768Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9745 9.75H4.02552C3.99996 10.3918 3.99998 11.118 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57527 21 10.9294 21H13.0706C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0707V11.9294C20 11.1181 20 10.3918 19.9745 9.75ZM15 12.25C15.4142 12.25 15.75 12.5858 15.75 13V17C15.75 17.4142 15.4142 17.75 15 17.75C14.5858 17.75 14.25 17.4142 14.25 17V13C14.25 12.5858 14.5858 12.25 15 12.25ZM10 13.75C10.4926 13.75 10.7866 13.7516 10.9973 13.7799C11.0939 13.7929 11.1423 13.8082 11.164 13.8172C11.1691 13.8192 11.1724 13.8209 11.1743 13.8219L11.1768 13.8232L11.1781 13.8257C11.1788 13.8269 11.1796 13.8286 11.1807 13.831C11.1814 13.8324 11.1821 13.8341 11.1828 13.836C11.1918 13.8578 11.2071 13.9061 11.2201 14.0027C11.2297 14.0741 11.2362 14.155 11.2406 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H11.2406C11.2362 15.845 11.2297 15.926 11.2201 15.9973C11.2071 16.0939 11.1918 16.1423 11.1828 16.164C11.1808 16.1691 11.1792 16.1724 11.1781 16.1743L11.1768 16.1768L11.1743 16.1781C11.1724 16.1792 11.1691 16.1808 11.164 16.1828C11.1423 16.1918 11.0939 16.2071 10.9973 16.2201C10.7866 16.2484 10.4926 16.25 10 16.25H9C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75L10.0447 17.75C10.4775 17.7501 10.8744 17.7501 11.1972 17.7067C11.5527 17.6589 11.9284 17.5465 12.2374 17.2374C12.5465 16.9284 12.6589 16.5527 12.7067 16.1972C12.7501 15.8744 12.7501 15.4776 12.75 15.0448V14.9553C12.7501 14.5224 12.7501 14.1256 12.7067 13.8028C12.6589 13.4473 12.5465 13.0716 12.2374 12.7626C11.9284 12.4535 11.5527 12.3411 11.1972 12.2933C10.8744 12.2499 10.4776 12.25 10.0447 12.25L9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","promotion","discount","offer","expiration","availability","booking","reservation","datetime"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","due-date","promotion","discount","sales","month-end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","due-date","monthly-report","end-of-month","billing-cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 10L19 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path
                    d="M15 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H10C10.9428 13 11.4142 13 11.7071 13.2929C12 13.5858 12 14.0572 12 15V15M9 17H10C10.9428 17 11.4142 17 11.7071 16.7071C12 16.4142 12 15.9428 12 15V15M12 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","promotion","discount","offer","campaign","end-date","start-date","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.5787 4.99996 10.2216 4.99998 10.9294 5H13.0706C13.7784 4.99998 14.4213 4.99996 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17157C19.4069 6.74999 19.6867 7.45534 19.8304 8.25H4.16965C4.31329 7.45534 4.59316 6.74999 5.17158 6.17157C5.6886 5.65455 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.02552 9.75C3.99996 10.3918 3.99998 11.118 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57527 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 11.118 20 10.3918 19.9745 9.75H4.02552ZM15 12.25C15.4142 12.25 15.75 12.5858 15.75 13V17C15.75 17.4142 15.4142 17.75 15 17.75C14.5858 17.75 14.25 17.4142 14.25 17V13C14.25 12.5858 14.5858 12.25 15 12.25ZM10 13.75C10.4926 13.75 10.7866 13.7516 10.9973 13.7799C11.0939 13.7929 11.1423 13.8082 11.164 13.8172L11.169 13.8193L11.1743 13.8219L11.1768 13.8232L11.1781 13.8257L11.1807 13.831L11.1828 13.836C11.1918 13.8577 11.2071 13.9061 11.2201 14.0027C11.2297 14.0741 11.2362 14.155 11.2406 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H11.2406C11.2362 15.845 11.2297 15.9259 11.2201 15.9973C11.2071 16.0939 11.1918 16.1423 11.1828 16.164C11.1808 16.1691 11.1792 16.1724 11.1781 16.1743L11.1768 16.1768L11.1743 16.1781C11.1724 16.1791 11.1691 16.1808 11.164 16.1828C11.1423 16.1918 11.0939 16.2071 10.9973 16.2201C10.7866 16.2484 10.4926 16.25 10 16.25H9C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75L10.0447 17.75C10.4775 17.7501 10.8744 17.7501 11.1972 17.7067C11.5527 17.6589 11.9284 17.5465 12.2374 17.2374C12.5465 16.9284 12.6589 16.5527 12.7067 16.1972C12.7501 15.8744 12.7501 15.4776 12.75 15.0448V14.9553C12.7501 14.5224 12.7501 14.1256 12.7067 13.8028C12.6589 13.4473 12.5465 13.0716 12.2374 12.7626C11.9284 12.4535 11.5527 12.3411 11.1972 12.2933C10.8744 12.2499 10.4776 12.2499 10.0448 12.25L9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointments","reservation","booking","day","first-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-29": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","day","event","reminder","promotion","sales-date","discount-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 10V10C19 12.8284 19 14.2426 18.1213 15.1213C17.2426 16 15.8284 16 13 16L11 16C8.17157 16 6.75736 16 5.87868 15.1213C5 14.2426 5 12.8284 5 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","month","year","deadline","due-date","promotion","sale","discount","availability","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 12C10.2239 12 10 12.2239 10 12.5V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V12.5C11 12.2239 10.7761 12 10.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.57869 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0707 21H10.9294C9.57535 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4ZM8 12.5C8 11.1193 9.11929 10 10.5 10C11.8807 10 13 11.1193 13 12.5V13.5C13 14.8807 11.8807 16 10.5 16C9.11929 16 8 14.8807 8 13.5V12.5ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-30": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","due-date","promotion-date","sale-date","reservation-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","15","day","time","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 10L12 10L12 12L14 12L14 14L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","time","promotion-date","sales-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00001 10.5C8.00001 9.11929 9.1193 8 10.5 8C11.8807 8 13 9.11929 13 10.5V11.5C13 12.8807 11.8807 14 10.5 14C9.1193 14 8.00001 12.8807 8.00001 11.5V10.5ZM10.5 10C10.2239 10 10 10.2239 10 10.5V11.5C10 11.7761 10.2239 12 10.5 12C10.7761 12 11 11.7761 11 11.5V10.5C11 10.2239 10.7761 10 10.5 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9V13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00001 5C9.00001 4.44772 8.55229 4 8.00001 4C7.44772 4 7.00001 4.44772 7.00001 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C4.06205 8.99675 4.03241 9.4716 4.01693 10H4L4 10.0706C3.99999 10.3941 3.99999 10.7041 4.0016 11.0006C3.99999 11.2962 4 11.6052 4.00001 11.9277L4.00001 13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64712 19.7565 7.57495 19.8813C8.4587 20.0001 9.57532 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V11.929C20 11.6056 20 11.2959 19.9984 10.9995C20 10.7034 20 10.3937 20 10.0706L20 10H19.9831C19.9676 9.4716 19.938 8.99674 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.5787 4.99997 9.00001 5.01692V5ZM17.9981 10.9995C17.9929 11.9181 17.9732 12.6076 17.8991 13.1586C17.8042 13.8646 17.6368 14.1916 17.4142 14.4142C17.1916 14.6368 16.8646 14.8042 16.1586 14.8991C15.4238 14.9979 14.4425 15 13 15H11C9.55752 15 8.57626 14.9979 7.84144 14.8991C7.13538 14.8042 6.80836 14.6368 6.58579 14.4142C6.36322 14.1916 6.19585 13.8646 6.10092 13.1586C6.02687 12.6078 6.00713 11.9186 6.00189 11.0005C6.00712 10.0819 6.02685 9.3924 6.10093 8.84143C6.19585 8.13538 6.36322 7.80836 6.5858 7.58579C6.80837 7.36322 7.13539 7.19585 7.84144 7.10092C8.57626 7.00213 9.55753 7 11 7H13C14.4425 7 15.4238 7.00213 16.1586 7.10092C16.8646 7.19585 17.1917 7.36322 17.4142 7.58579C17.6368 7.80836 17.8042 8.13538 17.8991 8.84143C17.9731 9.3922 17.9929 10.0814 17.9981 10.9995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","fifteenth","15","day","month","year","time","planning","due-date","delivery-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10L12 10L12 12L14 12L14 14L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-34": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reminder","event","promotion","discount","day","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 10L12 10L12 12L14 12L14 14L12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","fifteenth","15th","days","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V6.01692C9.57869 5.99996 10.2216 5.99998 10.9294 6L11 6V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V6L13.0706 6C13.7784 5.99998 14.4213 5.99996 15 6.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V6.22019C17.693 6.37607 18.3114 6.65455 18.8284 7.17157C19.4845 7.82768 19.7565 8.64711 19.8813 9.57494C20.0001 10.4587 20 11.5753 20 12.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8812C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V12.9294C3.99997 11.5753 3.99994 10.4587 4.11876 9.57494C4.2435 8.64711 4.51547 7.82768 5.17158 7.17157C5.6886 6.65455 6.30703 6.37607 7 6.22019V5C7 4.44772 7.44772 4 8 4ZM10.5 11C10.5 10.5858 10.1642 10.25 9.75 10.25C9.33579 10.25 9 10.5858 9 11V15C9 15.4142 9.33579 15.75 9.75 15.75C10.1642 15.75 10.5 15.4142 10.5 15V11ZM14.25 10.25H12.25C11.8358 10.25 11.5 10.5858 11.5 11V13C11.5 13.1989 11.579 13.3897 11.7197 13.5303C11.8603 13.671 12.0511 13.75 12.25 13.75H13.5V14.25H12.25C11.8358 14.25 11.5 14.5858 11.5 15C11.5 15.4142 11.8358 15.75 12.25 15.75H14.25C14.6642 15.75 15 15.4142 15 15V13C15 12.5858 14.6642 12.25 14.25 12.25H13V11.75H14.25C14.6642 11.75 15 11.4142 15 11C15 10.5858 14.6642 10.25 14.25 10.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-36": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","deadline","promotion","discount","sale","end-of-month","thirty-one","31"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H10C10.9428 10 11.4142 10 11.7071 10.2929C12 10.5858 12 11.0572 12 12V12M9 14H10C10.9428 14 11.4142 14 11.7071 13.7071C12 13.4142 12 12.9428 12 12V12M12 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-37": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","delivery-date","due-date","promotion-date","discount-date","billing-cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H10C10.9428 10 11.4142 10 11.7071 10.2929C12 10.5858 12 11.0572 12 12V12M9 14H10C10.9428 14 11.4142 14 11.7071 13.7071C12 13.4142 12 12.9428 12 12V12M12 12H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-38": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","31st","end-of-month","deadline","reminder","promotion","special-offer","loyalty-program","recurring-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H10C10.9428 10 11.4142 10 11.7071 10.2929C12 10.5858 12 11.0572 12 12V12M9 14H10C10.9428 14 11.4142 14 11.7071 13.7071C12 13.4142 12 12.9428 12 12V12M12 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-date-39": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","deadline","promotion","discount","sales-event","holiday","special-offer","time","day","month","year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1768 14.1768C11.177 14.1764 11.1772 14.1763 11.1768 14.1768V14.1768Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V6.01692C9.57869 5.99997 10.2216 5.99998 10.9294 6H11V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V6H13.0706C13.7784 5.99998 14.4213 5.99997 15 6.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V6.22019C17.693 6.37607 18.3114 6.65455 18.8284 7.17158C19.4845 7.82768 19.7565 8.64711 19.8813 9.57494C20.0001 10.4587 20 11.5753 20 12.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V12.9294C3.99997 11.5753 3.99994 10.4587 4.11876 9.57494C4.2435 8.64711 4.51547 7.82768 5.17158 7.17158C5.6886 6.65456 6.30703 6.37607 7 6.22019V5C7 4.44772 7.44772 4 8 4ZM10 11.75C10.4926 11.75 10.7866 11.7516 10.9973 11.7799C11.0939 11.7929 11.1423 11.8082 11.164 11.8172C11.1691 11.8192 11.1724 11.8209 11.1743 11.8219L11.1768 11.8232L11.1781 11.8257C11.1789 11.827 11.1799 11.8291 11.1811 11.832C11.1817 11.8331 11.1822 11.8345 11.1828 11.836C11.1918 11.8578 11.2071 11.9061 11.2201 12.0027C11.2297 12.0741 11.2362 12.155 11.2406 12.25H10C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75H11.2406C11.2362 13.845 11.2297 13.926 11.2201 13.9973C11.2071 14.0939 11.1918 14.1423 11.1828 14.164C11.1808 14.1691 11.1792 14.1724 11.1781 14.1743L11.1768 14.1768L11.1743 14.1781C11.1724 14.1792 11.1691 14.1808 11.164 14.1828C11.1423 14.1918 11.0939 14.2071 10.9973 14.2201C10.7866 14.2484 10.4926 14.25 10 14.25H9C8.58579 14.25 8.25 14.5858 8.25 15C8.25 15.4142 8.58579 15.75 9 15.75L10.0447 15.75C10.4775 15.7501 10.8744 15.7501 11.1972 15.7067C11.5527 15.6589 11.9284 15.5465 12.2374 15.2374C12.5465 14.9284 12.6589 14.5527 12.7067 14.1972C12.7501 13.8744 12.7501 13.4776 12.75 13.0448V12.9553C12.7501 12.5224 12.7501 12.1256 12.7067 11.8028C12.6589 11.4473 12.5465 11.0716 12.2374 10.7626C11.9284 10.4535 11.5527 10.3411 11.1972 10.2933C10.8744 10.2499 10.4776 10.25 10.0448 10.25L9 10.25C8.58579 10.25 8.25 10.5858 8.25 11C8.25 11.4142 8.58579 11.75 9 11.75H10ZM15.75 11C15.75 10.5858 15.4142 10.25 15 10.25C14.5858 10.25 14.25 10.5858 14.25 11V15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservation","first-day","month-start","promotion-start","sales-start"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-40": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","sales-date","promotion-date","discount-date","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-date-41": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","reservations","time","due-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-date-42": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","delivery-date","due-date","booking","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-date-43": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","booking","timeline","date range","availability","shift","time","day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 12C9.5 11.3096 10.0596 10.75 10.75 10.75C11.4404 10.75 12 11.3096 12 12C12 12.6904 11.4404 13.25 10.75 13.25C10.0596 13.25 9.5 12.6904 9.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V12.0706C20 13.4247 20.0001 14.5413 19.8813 15.4251C19.7565 16.3529 19.4845 17.1723 18.8284 17.8284C18.1723 18.4845 17.3529 18.7565 16.4251 18.8813C15.5413 19.0001 14.4247 19 13.0706 19H10.9294C9.57531 19 8.4587 19.0001 7.57494 18.8813C6.64711 18.7565 5.82769 18.4845 5.17158 17.8284C4.51547 17.1723 4.2435 16.3529 4.11876 15.4251C3.99994 14.5413 3.99997 13.4247 4 12.0706V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.7111 5.10045 7.85278 5.08496 8 5.07187V5C8 4.44772 8.44772 4 9 4ZM10.75 9.25C9.23122 9.25 8 10.4812 8 12C8 13.5188 9.23122 14.75 10.75 14.75C12.2688 14.75 13.5 13.5188 13.5 12C13.5 10.4812 12.2688 9.25 10.75 9.25ZM16 10C16 9.58579 15.6642 9.25 15.25 9.25C14.8358 9.25 14.5 9.58579 14.5 10V14C14.5 14.4142 14.8358 14.75 15.25 14.75C15.6642 14.75 16 14.4142 16 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","day","time","booking","reservation","due-date","promotion","sale-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","schedule","event","reminder","appointment","day","sales-date","report-date","promotion-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reservation","event","day","reminder","delivery-date","pickup-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 12C10.2239 12 10 12.2239 10 12.5V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V12.5C11 12.2239 10.7761 12 10.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 3C8.55229 3 9 3.44772 9 4V5.01692C9.57869 4.99997 10.2216 4.99998 10.9294 5H13.0706C13.7784 4.99998 14.4213 4.99997 15 5.01692V4C15 3.44772 15.4477 3 16 3C16.5523 3 17 3.44772 17 4V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0707 21H10.9294C9.57535 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45868 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7 5.22019V4C7 3.44772 7.44772 3 8 3ZM8 12.5C8 11.1193 9.11929 10 10.5 10C11.8807 10 13 11.1193 13 12.5V13.5C13 14.8807 11.8807 16 10.5 16C9.11929 16 8 14.8807 8 13.5V12.5ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-date-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","promotion","discount","availability","booking","reservation","day","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-date-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","appointment","reminder","due-date","promotion","discount","timeslot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="12" y="13" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M9 17V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-date": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reminder","day","month","year","booking","reservation","first-day","due-date","promotion-date","sale-date","special-offer","pos-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="11" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 15V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-discount-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","discount","percentage","sale","promotion","event","date","schedule","offer","special","coupon","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 15L14 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 10.1341C10.9781 10.4102 11.142 11.0217 10.8659 11.4999C10.5898 11.9781 9.9783 12.142 9.50008 11.8659C9.02187 11.5898 8.85802 10.9783 9.13412 10.5001C9.41022 10.0219 10.0217 9.85802 10.4999 10.1341Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 14.1341C14.9781 14.4102 15.142 15.0217 14.8659 15.4999C14.5898 15.9781 13.9783 16.142 13.5001 15.8659C13.0219 15.5898 12.858 14.9783 13.1341 14.5001C13.4102 14.0219 14.0217 13.858 14.4999 14.1341Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","discount","percentage","promotion","schedule","offer","date","sale","event","coupon","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15L14 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 10.1341C10.9781 10.4102 11.142 11.0217 10.8659 11.4999C10.5898 11.9781 9.9783 12.142 9.50008 11.8659C9.02187 11.5898 8.85802 10.9783 9.13412 10.5001C9.41022 10.0219 10.0217 9.85802 10.4999 10.1341Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 14.1341C14.9781 14.4102 15.142 15.0217 14.8659 15.4999C14.5898 15.9781 13.9783 16.142 13.5001 15.8659C13.0219 15.5898 12.858 14.9783 13.1341 14.5001C13.4102 14.0219 14.0217 13.858 14.4999 14.1341Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","discount","sale","percentage","promotion","event","date","reminder","schedule","offer","coupon","special offer","loyalty program","rewards","seasonal sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65455 5.17158 6.17157C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57528 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17157C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99996 13.7784 4.99998 13.0706 5H13C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5H10.9294C10.2216 4.99998 9.5787 4.99996 9 5.01692V5ZM7.98472 9.62517C8.4679 8.78827 9.53803 8.50153 10.3749 8.98471C11.2118 9.46789 11.4985 10.538 11.0154 11.3749C10.5322 12.2118 9.46206 12.4985 8.62517 12.0154C7.78828 11.5322 7.50154 10.4621 7.98472 9.62517ZM12.9847 14.6252C13.4679 13.7883 14.538 13.5015 15.3749 13.9847C16.2118 14.4679 16.4986 15.538 16.0154 16.3749C15.5322 17.2118 14.4621 17.4985 13.6252 17.0154C12.7883 16.5322 12.5015 15.4621 12.9847 14.6252ZM14.5303 11.5303C14.8232 11.2374 14.8232 10.7626 14.5303 10.4697C14.2374 10.1768 13.7626 10.1768 13.4697 10.4697L9.46967 14.4697C9.17678 14.7626 9.17678 15.2374 9.46967 15.5303C9.76256 15.8232 10.2374 15.8232 10.5303 15.5303L14.5303 11.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-discount-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","discount","percentage","promotion","offer","seasonal-discount","scheduled-promotion","sale","deal","coupon","date-based-discount","loyalty-program","reward","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.2499 9.20118C10.9672 9.61532 11.213 10.5326 10.7988 11.2499C10.3847 11.9672 9.46744 12.213 8.75013 11.7988C8.03281 11.3847 7.78703 10.4674 8.20118 9.75013C8.61532 9.03281 9.53256 8.78703 10.2499 9.20118Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.2499 14.2012C15.9672 14.6153 16.213 15.5326 15.7988 16.2499C15.3847 16.9672 14.4674 17.213 13.7501 16.7988C13.0328 16.3847 12.787 15.4674 13.2012 14.7501C13.6153 14.0328 14.5326 13.787 15.2499 14.2012Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","discount","percentage","sale","promotion","offer","event","schedule","date","special-offer","coupon","deals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L15 10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.2499 9.20118C10.9672 9.61532 11.213 10.5326 10.7988 11.2499C10.3847 11.9672 9.46744 12.213 8.75013 11.7988C8.03281 11.3847 7.78703 10.4674 8.20118 9.75013C8.61532 9.03281 9.53256 8.78703 10.2499 9.20118Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.2499 14.2012C15.9672 14.6153 16.213 15.5326 15.7988 16.2499C15.3847 16.9672 14.4674 17.213 13.7501 16.7988C13.0328 16.3847 12.787 15.4674 13.2012 14.7501C13.6153 14.0328 14.5326 13.787 15.2499 14.2012Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","discount","percentage","promotion","sale","offer","event","date","schedule","reminder","coupon","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L15 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.2499 9.20118C10.9672 9.61532 11.213 10.5326 10.7988 11.2499C10.3847 11.9672 9.46744 12.213 8.75013 11.7988C8.03281 11.3847 7.78703 10.4674 8.20118 9.75013C8.61532 9.03281 9.53256 8.78703 10.2499 9.20118Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.2499 14.2012C15.9672 14.6153 16.213 15.5326 15.7988 16.2499C15.3847 16.9672 14.4674 17.213 13.7501 16.7988C13.0328 16.3847 12.787 15.4674 13.2012 14.7501C13.6153 14.0328 14.5326 13.787 15.2499 14.2012Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","discount","percentage","promotion","offer","sale","date","scheduled-discount","time-limited-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 15L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.2499 9.20118C10.9672 9.61532 11.213 10.5326 10.7988 11.2499C10.3847 11.9672 9.46744 12.213 8.75013 11.7988C8.03281 11.3847 7.78703 10.4674 8.20118 9.75013C8.61532 9.03281 9.53256 8.78703 10.2499 9.20118Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.2499 14.2012C15.9672 14.6153 16.213 15.5326 15.7988 16.2499C15.3847 16.9672 14.4674 17.213 13.7501 16.7988C13.0328 16.3847 12.787 15.4674 13.2012 14.7501C13.6153 14.0328 14.5326 13.787 15.2499 14.2012Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-done-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","event","reservation","booking","reminder","time","checkmark","done","complete","approved","confirmed","valid","availability","scheduled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 15L11 17L15 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "calendar-discount-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","discount","percentage","promotion","sale","event","schedule","offer","time-limited","seasonal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65455 5.17158 6.17157C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8812C8.45868 21.0001 9.57528 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8812C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17157C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99996 13.7784 4.99998 13.0706 5H13C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5H10.9294C10.2216 4.99998 9.5787 4.99996 9 5.01692V5ZM10.3749 8.98471C9.53802 8.50153 8.46789 8.78827 7.98471 9.62517C7.50154 10.4621 7.78828 11.5322 8.62517 12.0154C9.46206 12.4985 10.5322 12.2118 11.0154 11.3749C11.4985 10.538 11.2118 9.46789 10.3749 8.98471ZM15.3749 13.9847C14.538 13.5015 13.4679 13.7883 12.9847 14.6252C12.5015 15.4621 12.7883 16.5322 13.6252 17.0154C14.4621 17.4985 15.5322 17.2118 16.0154 16.3749C16.4986 15.538 16.2118 14.4679 15.3749 13.9847ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L9.70711 16.7071C9.31658 17.0976 8.68342 17.0976 8.29289 16.7071C7.90237 16.3166 7.90237 15.6834 8.29289 15.2929L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-done-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","done","check","mark-as-done","appointment","schedule","completed","confirmation","event","reminder","date","task-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.5 20H8.5C8.03558 20 7.80337 20 7.60842 19.9743C6.26222 19.7971 5.2029 18.7378 5.02567 17.3916C5 17.1966 5 16.9644 5 16.5C5 13.6716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.6716 19 16.5C19 16.9644 19 17.1966 18.9743 17.3916C18.7971 18.7378 17.7378 19.7971 16.3916 19.9743C16.1966 20 15.9644 20 15.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15L11 17L15 13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-done-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","done","complete","schedule","confirmed","appointment","event","date","tick","approved","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929C15.3166 11.9024 14.6834 11.9024 14.2929 12.2929L11 15.5858L9.70711 14.2929C9.31658 13.9024 8.68342 13.9024 8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071L10.2929 17.7071C10.6834 18.0976 11.3166 18.0976 11.7071 17.7071L15.7071 13.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55229 4 9 4.44772 9 5V5.01692C9.57869 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.5753 20 11.9294V14.072C20 14.3948 20 14.7041 19.9984 15C20 15.2959 20 15.6052 20 15.928L20 16H19.9831C19.9676 16.5284 19.938 17.0033 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C4.06205 17.0033 4.03241 16.5284 4.01692 16H4L4 15.9294C3.99999 15.6061 3.99999 15.2963 4.0016 15C3.99999 14.7037 3.99999 14.3939 4 14.0706V11.9294C3.99997 10.5753 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7 5.22019V5C7 4.44772 7.44772 4 8 4ZM6.10092 17.1586C6.02686 16.6077 6.00713 15.9183 6.00189 15C6.00713 14.0817 6.02686 13.3923 6.10092 12.8414C6.19585 12.1354 6.36322 11.8084 6.58579 11.5858C6.80836 11.3632 7.13538 11.1958 7.84144 11.1009C8.57626 11.0021 9.55752 11 11 11H13C14.4425 11 15.4238 11.0021 16.1586 11.1009C16.8646 11.1958 17.1916 11.3632 17.4142 11.5858C17.6368 11.8084 17.8042 12.1354 17.8991 12.8414C17.9731 13.3923 17.9929 14.0817 17.9981 15C17.9929 15.9183 17.9731 16.6077 17.8991 17.1586C17.8042 17.8646 17.6368 18.1916 17.4142 18.4142C17.1916 18.6368 16.8646 18.8042 16.1586 18.8991C15.4238 18.9979 14.4425 19 13 19H11C9.55752 19 8.57626 18.9979 7.84144 18.8991C7.13538 18.8042 6.80836 18.6368 6.58579 18.4142C6.36322 18.1916 6.19585 17.8646 6.10092 17.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-done": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","done","completed","confirmed","scheduled","event","appointment","reservation","booking","valid","check","approved","availability","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 16V16C5 13.1716 5 11.7574 5.87868 10.8787C6.75736 10 8.17157 10 11 10H13C15.8284 10 17.2426 10 18.1213 10.8787C19 11.7574 19 13.1716 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15L11 17L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-exclamation-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","exclamation","warning","alert","schedule","reminder","event","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-exclamation-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","date","event","reminder","alert","warning","exclamation","schedule","appointment","deadline","important-date","pending-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","event","schedule","reminder","alert","notification","warning","error","issue","problem","urgent","important","deadline","appointment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V5.00159C10.2963 4.99998 10.6061 4.99999 10.9294 5H13.0706C13.3939 4.99999 13.7037 4.99998 14 5.00159V5C14 4.44772 14.4477 4 15 4C15.5523 4 16 4.44772 16 5V5.07187C16.1472 5.08496 16.2889 5.10045 16.4251 5.11875C17.3529 5.2435 18.1723 5.51547 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C20.0001 9.45868 20 10.6459 20 12C20 13.3541 20.0001 14.5413 19.8813 15.4251C19.7565 16.3529 19.4845 17.1723 18.8284 17.8284C18.1723 18.4845 17.3529 18.7565 16.4251 18.8813C15.5413 19.0001 14.4247 19 13.0706 19H10.9294C9.57531 19 8.4587 19.0001 7.57494 18.8813C6.64711 18.7565 5.82769 18.4845 5.17158 17.8284C4.51547 17.1723 4.2435 16.3529 4.11876 15.4251C3.99994 14.5413 3.99997 13.3541 4 12C3.99997 10.6459 3.99994 9.45869 4.11876 8.57494C4.2435 7.64711 4.51547 6.82768 5.17158 6.17158C5.82769 5.51547 6.64711 5.2435 7.57494 5.11875C7.71109 5.10045 7.85278 5.08496 8 5.07187V5C8 4.44772 8.44772 4 9 4ZM12 12C11.4477 12 11 11.5523 11 11V9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V11C13 11.5523 12.5523 12 12 12ZM11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V14.5C13 13.9477 12.5523 13.5 12 13.5C11.4477 13.5 11 13.9477 11 14.5V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","exclamation","warning","alert","reminder","schedule","event","important-date","appointment","due-date"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 12L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-like-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","event","schedule","appointment","reminder","promotion","loyalty","rewards","favorite-date","special-date","heart","marketing","customer","engagement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 10.9041C10.795 10.3653 9.93175 10.3653 9.39932 10.9041C8.86689 11.4428 8.86689 12.3163 9.39932 12.8551L10.0588 13.549L11.9869 15.5L14.6007 12.8551C15.1331 12.3163 15.1331 11.4428 14.6007 10.9041C14.0683 10.3653 13.205 10.3653 12.6726 10.9041L12 11.5847L11.3274 10.9041Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-like-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","event","schedule","appointment","loyalty","rewards","heart","favorite","promotion","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.3274 10.9041C10.795 10.3653 9.93175 10.3653 9.39932 10.9041C8.86689 11.4428 8.86689 12.3163 9.39932 12.8551L10.0588 13.549L11.9869 15.5L14.6007 12.8551C15.1331 12.3163 15.1331 11.4428 14.6007 10.9041C14.0683 10.3653 13.205 10.3653 12.6726 10.9041L12 11.5847L11.3274 10.9041Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-like": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","heart","valentine","appointment","schedule","reservation","loyalty","promotion","event","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.3274 10.9041C10.795 10.3653 9.93175 10.3653 9.39932 10.9041C8.86689 11.4428 8.86689 12.3163 9.39932 12.8551L10.0588 13.549L11.9869 15.5L14.6007 12.8551C15.1331 12.3163 15.1331 11.4428 14.6007 10.9041C14.0683 10.3653 13.205 10.3653 12.6726 10.9041L12 11.5847L11.3274 10.9041Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-like-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","heart","loyalty","rewards","favorite","schedule","events","promotions","customer-appreciation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5V5.07187C7.85278 5.08496 7.7111 5.10045 7.57494 5.11875C6.64711 5.2435 5.82769 5.51547 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45868 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57535 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.1723 5.51547 17.3529 5.2435 16.4251 5.11875C16.2889 5.10045 16.1472 5.08496 16 5.07187V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.00159C13.7037 4.99998 13.3939 4.99999 13.0706 5H10.9294C10.6061 4.99999 10.2963 4.99998 10 5.00159V5ZM8.68804 9.70116C9.59914 8.77922 11.0733 8.76646 12 9.66289C12.9267 8.76646 14.4009 8.77922 15.312 9.70116C16.2293 10.6295 16.2293 12.1297 15.312 13.058L12.6982 15.7029C12.5103 15.893 12.2542 16 11.9869 16C11.7196 16 11.4635 15.893 11.2756 15.7029L9.34755 13.7519L9.33401 13.7379L8.68032 13.0502C7.77066 12.1213 7.77324 10.6269 8.68804 9.70116Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-likes-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","promotion","events","heart","favorite","likes","customer-loyalty","appointment","reminders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11V11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17L11 17C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 9.40407C10.795 8.86531 9.93175 8.86531 9.39932 9.40407C8.86689 9.94284 8.86689 10.8163 9.39932 11.3551L10.0588 12.049L11.9869 14L14.6007 11.3551C15.1331 10.8163 15.1331 9.94284 14.6007 9.40407C14.0683 8.86531 13.205 8.86531 12.6726 9.40407L12 10.0847L11.3274 9.40407Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-likes-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","date","event","promotion","favorites","likes","rewards","loyalty","schedule","appointment","recurring","reminder","heart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.5 16H8.5C8.03558 16 7.80337 16 7.60842 15.9743C6.26222 15.7971 5.2029 14.7378 5.02567 13.3916C5 13.1966 5 12.9644 5 12.5C5 9.67157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.67157 19 12.5C19 12.9644 19 13.1966 18.9743 13.3916C18.7971 14.7378 17.7378 15.7971 16.3916 15.9743C16.1966 16 15.9644 16 15.5 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 9.40407C10.795 8.86531 9.93175 8.86531 9.39932 9.40407C8.86689 9.94284 8.86689 10.8163 9.39932 11.3551L10.0588 12.049L11.9869 14L14.6007 11.3551C15.1331 10.8163 15.1331 9.94284 14.6007 9.40407C14.0683 8.86531 13.205 8.86531 12.6726 9.40407L12 10.0847L11.3274 9.40407Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-likes-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","heart","likes","favorites","promotions","event","special-day","loyalty","rewards","recurring-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00001 4C8.55229 4 9.00001 4.44772 9.00001 5V5.01692C9.5787 4.99997 10.2216 4.99998 10.9294 5L11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5L13.0706 5C13.7784 4.99998 14.4213 4.99997 15 5.01692V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V5.22019C17.693 5.37607 18.3114 5.65455 18.8284 6.17158C19.4845 6.82768 19.7565 7.64711 19.8813 8.57494C19.9717 9.24768 19.9933 10.0553 19.9984 11H20L19.9999 11.4972C20 11.6384 20 11.7826 20 11.9294V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57527 21 8.45869 21.0001 7.57495 20.8813C6.64712 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.24351 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4.00001 14.0706L4.00014 11.5032C3.99999 11.3628 4 11.2196 4 11.0738L4 11.0706L4 11H4.0016C4.00673 10.0553 4.02831 9.24768 4.11876 8.57494C4.24351 7.64711 4.51547 6.82768 5.17158 6.17158C5.6886 5.65456 6.30703 5.37607 7.00001 5.22019V5C7.00001 4.44772 7.44772 4 8.00001 4ZM17.8991 14.1586C17.9861 13.5116 17.9981 12.6736 17.9998 11.498C17.9981 10.3245 17.986 9.48765 17.8991 8.84143C17.8042 8.13538 17.6368 7.80836 17.4142 7.58579C17.1917 7.36322 16.8646 7.19585 16.1586 7.10092C15.4238 7.00213 14.4425 7 13 7H11C9.55753 7 8.57626 7.00213 7.84144 7.10092C7.13539 7.19585 6.80837 7.36322 6.5858 7.58579C6.36322 7.80836 6.19585 8.13538 6.10093 8.84143C6.01394 9.48841 6.0019 10.3264 6.00026 11.5021C6.00192 12.6756 6.01404 13.5124 6.10092 14.1586C6.19585 14.8646 6.36322 15.1916 6.58579 15.4142C6.80836 15.6368 7.13538 15.8042 7.84144 15.8991C8.57626 15.9979 9.55752 16 11 16H13C14.4425 16 15.4238 15.9979 16.1586 15.8991C16.8646 15.8042 17.1916 15.6368 17.4142 15.4142C17.6368 15.1916 17.8042 14.8646 17.8991 14.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 8.66289C11.0733 7.76646 9.59915 7.77922 8.68805 8.70116C7.77324 9.62686 7.77067 11.1213 8.68032 12.0502L9.33401 12.7379L9.34755 12.7519L11.2756 14.7029C11.4635 14.893 11.7196 15 11.9869 15C12.2542 15 12.5103 14.893 12.6982 14.7029L15.312 12.058C16.2294 11.1297 16.2294 9.62947 15.312 8.70116C14.4009 7.77922 12.9267 7.76646 12 8.66289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-likes": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","heart","favorites","schedule","appointments","loyalty","rewards","promotions","special-days","date","event","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 11V11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17L11 17C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.3274 9.40407C10.795 8.86531 9.93175 8.86531 9.39932 9.40407C8.86689 9.94284 8.86689 10.8163 9.39932 11.3551L10.0588 12.049L11.9869 14L14.6007 11.3551C15.1331 10.8163 15.1331 9.94284 14.6007 9.40407C14.0683 8.86531 13.205 8.86531 12.6726 9.40407L12 10.0847L11.3274 9.40407Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-pen-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","schedule","edit","pen","appointment","reservation","booking","date","event","note","reminder","modify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14.5672L8.01187 13.3312C8.01009 13.2193 8.05237 13.1127 8.12957 13.0342L11.802 9.36186C12.0375 9.12997 12.3547 9 12.6852 9C13.3805 9 14 9.61954 14 10.3148C14 10.6453 13.87 10.9625 13.6381 11.198L9.96576 14.8704C9.88732 14.9476 9.78066 14.9899 9.66881 14.9881L8.43279 15C8.19751 14.9963 8.00374 14.8025 8 14.5672Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-pen-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","pen","edit","schedule","appointment","reservation","date","time","event","booking","modify","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14.5672L8.01187 13.3312C8.01009 13.2193 8.05237 13.1127 8.12957 13.0342L11.802 9.36186C12.0375 9.12997 12.3547 9 12.6852 9C13.3805 9 14 9.61954 14 10.3148C14 10.6453 13.87 10.9625 13.6381 11.198L9.96576 14.8704C9.88732 14.9476 9.78066 14.9899 9.66881 14.9881L8.43279 15C8.19751 14.9963 8.00374 14.8025 8 14.5672Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-pen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","edit","schedule","appointment","reservation","date","time","event","update","pencil","writing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V4.22019C6.30703 4.37607 5.6886 4.65456 5.17158 5.17158C4.51547 5.82768 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57533 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57534 20 10.9294 20H13.0707C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V10.9294C20 9.57531 20.0001 8.4587 19.8813 7.57494C19.7565 6.64711 19.4845 5.82768 18.8284 5.17158C18.3114 4.65455 17.693 4.37607 17 4.22019V4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4V4.01692C14.4213 3.99997 13.7784 3.99998 13.0706 4L13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L10.9294 4C10.2216 3.99998 9.57869 3.99997 9 4.01692V4ZM13.6852 8C13.0922 8 12.5229 8.23322 12.1003 8.6493L8.42244 12.3271L8.41684 12.3328C8.1522 12.6017 8.01024 12.9615 8.01183 13.3306L8.00005 14.5576C7.99997 14.5661 7.99999 14.5746 8.00013 14.5831C8.01246 15.3582 8.64177 15.9875 9.41688 15.9999C9.42539 16 9.43389 16 9.4424 16L10.6694 15.9882C11.0385 15.9898 11.3983 15.8478 11.6672 15.5832L15.3453 11.9052L15.3507 11.8997C15.7668 11.4771 16 10.9078 16 10.3148C16 9.06726 14.9327 8 13.6852 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-pen": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","schedule","appointment","booking","reservation","edit","update","pencil","date","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H12C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 14.5672L8.01187 13.3312C8.01009 13.2193 8.05237 13.1127 8.12957 13.0342L11.802 9.36186C12.0375 9.12997 12.3547 9 12.6852 9C13.3805 9 14 9.61954 14 10.3148C14 10.6453 13.87 10.9625 13.6381 11.198L9.96576 14.8704C9.88732 14.9476 9.78066 14.9899 9.66881 14.9881L8.43279 15C8.19751 14.9963 8.00374 14.8025 8 14.5672Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "calendar-search-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","search","date","appointment","schedule","find-schedule","find-appointment","date-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 11V11C19 9.13077 19 8.19615 18.5981 7.5C18.3348 7.04394 17.9561 6.66523 17.5 6.40192C16.8038 6 15.8692 6 14 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="16" cy="16" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M19 19L18.5 18.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-search-2": {
        defaultColors: ["#D9D1E0", "#3D4C66", "#2797E8"],
        keywords: ["calendar","search","date","find","schedule","appointment","view-schedule","lookup","date-search","find-appointment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="16" cy="17" r="3" stroke={colors?.[2] || "#2797E8"} strokeWidth="1.5" />
                <path d="M19 20L18.5 19.5" stroke={colors?.[2] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","search","find","schedule","appointment","reservation","event-search","date-search","booking-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45867 3.99997 10.5753 4 11.9293V13.5581C3.99998 14.6814 3.99996 15.6082 4.08379 16.3518C4.17134 17.1284 4.36078 17.828 4.82659 18.435C5.03939 18.7124 5.28763 18.9606 5.56496 19.1734C6.17202 19.6392 6.87165 19.8287 7.64822 19.9162C8.04579 19.961 8.4957 19.9819 9 19.9916V20L10.5 20C11.0523 20 11.5 19.5523 11.5 19C11.5 18.4477 11.0523 18 10.5 18L10.4217 18C9.26831 17.9999 8.47704 17.997 7.87227 17.9288C7.27407 17.8614 6.98335 17.7408 6.78248 17.5867C6.64382 17.4803 6.5197 17.3562 6.4133 17.2175C6.25917 17.0167 6.13864 16.7259 6.0712 16.1277C6.00149 15.5094 6.00001 14.696 6.00001 13.5V12C6.00001 10.5575 6.00213 9.57625 6.10092 8.84143C6.19585 8.13538 6.36322 7.80836 6.58579 7.58579C6.80836 7.36322 7.13538 7.19585 7.84144 7.10092C8.57626 7.00213 9.55752 7 11 7H14.5C15.2126 7 15.697 7.00054 16.0734 7.02623C16.4409 7.0513 16.6319 7.09695 16.7654 7.15224C17.2554 7.35523 17.6448 7.74458 17.8478 8.23464C17.9031 8.36813 17.9487 8.55915 17.9738 8.92661C17.9986 9.29021 17.9999 9.75452 18 10.4279L18 10.5C18 11.0523 18.4477 11.5 19 11.5C19.5523 11.5 20 11.0523 20 10.5L20 9H19.981C19.9777 8.92788 19.9738 8.85806 19.9691 8.79046C19.9371 8.32118 19.8686 7.88708 19.6955 7.46927C19.2895 6.48916 18.5109 5.71046 17.5307 5.30448C17.3571 5.23256 17.1806 5.17869 17 5.13799V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C14.8515 4.99957 14.6963 5 14.5344 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.57869 4.99997 9 5.01692V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20C16.7418 20 17.4365 19.7981 18.032 19.4462L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L19.4462 18.032C19.7981 17.4365 20 16.7418 20 16C20 13.7909 18.2091 12 16 12ZM14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-search-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reservation","event","query","search","find-date","check-availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142ZM13.4142 16.4142L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-search-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reservation","queue","waitlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142ZM13.4142 16.4142L14 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-search-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","appointment","reservation","event","availability","time","booking","open","query","search-availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5V5.22019C6.30703 5.37607 5.6886 5.65456 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.5753 4 11.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45868 21.0001 9.57534 21 10.9294 21H13.0707C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0706V11.9294C20 10.5753 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.3114 5.65455 17.693 5.37607 17 5.22019V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V5.01692C14.4213 4.99997 13.7784 4.99998 13.0706 5L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L10.9294 5C10.2216 4.99998 9.57869 4.99997 9 5.01692V5ZM13 7C13.7948 7 14.4495 7.00065 15.0002 7.01775C15.0096 7.56185 15.4536 8 16 8C16.451 8 16.8323 7.7014 16.957 7.2911C17.1606 7.37352 17.3009 7.4725 17.4142 7.58579C17.6368 7.80836 17.8042 8.13538 17.8991 8.84143C17.906 8.89305 17.9125 8.94588 17.9185 9H6.0815C6.08752 8.94588 6.09398 8.89305 6.10092 8.84143C6.19585 8.13538 6.36322 7.80836 6.58579 7.58579C6.69908 7.4725 6.83942 7.37352 7.04303 7.29111C7.16768 7.7014 7.54897 8 8 8C8.54636 8 8.99038 7.56185 8.99985 7.01775C9.55051 7.00065 10.2053 7 11 7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7ZM12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18C12.4628 18 12.9016 17.8948 13.2932 17.7074C13.6838 18.0976 14.3167 18.0975 14.7071 17.7071C15.0975 17.3167 15.0976 16.6838 14.7074 16.2932C14.8948 15.9016 15 15.4628 15 15C15 13.3431 13.6569 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16C12.2764 16 12.525 15.8892 12.7071 15.7071C12.8892 15.525 13 15.2764 13 15C13 14.4477 12.5523 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "calendar-search-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["calendar","search","schedule","appointment","date","find","time","event","reservation","booking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142ZM13.4142 16.4142L14 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-search": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","search","find","schedule","appointment","booking","reservation","availability","calendar-search","date-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11V11C19 9.13077 19 8.19615 18.5981 7.5C18.3348 7.04394 17.9561 6.66523 17.5 6.40192C16.8038 6 15.8692 6 14 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="16" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 19L18.5 18.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "calendar-smile-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["calendar","date","schedule","event","promotion","happy","reminder","appointment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11V10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14C13.5439 14.6072 12.8178 15 12 15C11.1822 15 10.4561 14.6072 10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-smile-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["calendar","smile","happy","date","event","promotion","special-day","scheduling","reminder","appointment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14C13.5439 14.6072 12.8178 15 12 15C11.1822 15 10.4561 14.6072 10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-smile": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","date","schedule","event","happy","appointment","reminder","promotion","discount","availability","booking","open","daily-specials"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 7V5M15 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14C13.5439 14.6072 12.8178 15 12 15C11.1822 15 10.4561 14.6072 10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "calendar-smile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["face","smile","customer-satisfaction","happy","feedback","rating","positive","review","mood"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5V5.07187C7.85278 5.08496 7.71109 5.10045 7.57494 5.11875C6.64711 5.2435 5.82769 5.51547 5.17158 6.17158C4.51547 6.82768 4.2435 7.64711 4.11876 8.57494C3.99994 9.45869 3.99997 10.6459 4 12C3.99997 13.3541 3.99994 14.5413 4.11876 15.4251C4.2435 16.3529 4.51547 17.1723 5.17158 17.8284C5.82769 18.4845 6.64711 18.7565 7.57494 18.8813C8.4587 19.0001 9.57531 19 10.9294 19H13.0706C14.4247 19 15.5413 19.0001 16.4251 18.8813C17.3529 18.7565 18.1723 18.4845 18.8284 17.8284C19.4845 17.1723 19.7565 16.3529 19.8813 15.4251C20.0001 14.5413 20 13.3541 20 12C20 10.6459 20.0001 9.45868 19.8813 8.57494C19.7565 7.64711 19.4845 6.82768 18.8284 6.17158C18.1723 5.51547 17.3529 5.2435 16.4251 5.11875C16.2889 5.10045 16.1472 5.08496 16 5.07187V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.00159C13.7037 4.99998 13.3939 4.99999 13.0706 5H10.9294C10.6061 4.99999 10.2963 4.99998 10 5.00159V5ZM11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V10ZM14 9C14.5523 9 15 9.44772 15 10V11C15 11.5523 14.5523 12 14 12C13.4477 12 13 11.5523 13 11V10C13 9.44772 13.4477 9 14 9ZM10.7996 13.3995C10.4679 12.9579 9.84106 12.8688 9.39948 13.2005C8.95789 13.5322 8.8688 14.1591 9.2005 14.6006C9.83732 15.4485 10.8544 16.0001 12.0001 16.0001C13.1457 16.0001 14.1628 15.4485 14.7996 14.6006C15.1313 14.1591 15.0422 13.5322 14.6006 13.2005C14.1591 12.8688 13.5322 12.9579 13.2005 13.3995C12.9251 13.7661 12.49 14.0001 12.0001 14.0001C11.5101 14.0001 11.075 13.7661 10.7996 13.3995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    calendar: {
        defaultColors: ["#3D4C66"],
        keywords: ["face","smile","customer-satisfaction","happy","feedback","rating","positive","review","mood"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 13H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 4V6M15 4V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","add","plus","new-customer","customer-support","order-by-phone","call-in-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 5V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","add","plus","new-call","create-call","contact","add-contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M16 5V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","add","plus","new-customer","customer","contact","add-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4.25C16.4142 4.25 16.75 4.58579 16.75 5V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V5C15.25 4.58579 15.5858 4.25 16 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.25 8C12.25 7.58579 12.5858 7.25 13 7.25H19C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H13C12.5858 8.75 12.25 8.41421 12.25 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","add","plus","new-customer","add-customer","contact","add-contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 5V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["call","support","customer service","headphones","audio","communication","help","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14C5 11.0545 8.13401 8 12 8C15.866 8 19 11.0545 19 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12C8.10457 12 9 12.8954 9 14C9 15.1046 8.10457 16 7 16C5.89543 16 5 15.1046 5 14C5 12.8954 5.89543 12 7 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 12C18.1046 12 19 12.8954 19 14C19 15.1046 18.1046 16 17 16C15.8954 16 15 15.1046 15 14C15 12.8954 15.8954 12 17 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","support","customer-service","headphones","assistance","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14C5 11.0545 8.13401 8 12 8C15.866 8 19 11.0545 19 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12C8.10457 12 9 12.8954 9 14C9 15.1046 8.10457 16 7 16C5.89543 16 5 15.1046 5 14C5 12.8954 5.89543 12 7 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 12C18.1046 12 19 12.8954 19 14C19 15.1046 18.1046 16 17 16C15.8954 16 15 15.1046 15 14C15 12.8954 15.8954 12 17 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["headset","customer support","help","assistance","phone","contact","call center","service","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.71652 10.6411C6.60785 11.6317 6 12.8774 6 14H4C4 12.177 4.95916 10.4228 6.38398 9.14972C7.81971 7.86693 9.80267 7 12 7C14.1973 7 16.1803 7.86693 17.616 9.14972C19.0408 10.4228 20 12.177 20 14H18C18 12.8774 17.3922 11.6317 16.2835 10.6411C15.1857 9.66031 13.6687 9 12 9C10.3313 9 8.8143 9.66031 7.71652 10.6411Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14C10 15.6569 8.65685 17 7 17C5.34315 17 4 15.6569 4 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 14C14 12.3431 15.3431 11 17 11C18.6569 11 20 12.3431 20 14C20 15.6569 18.6569 17 17 17C15.3431 17 14 15.6569 14 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","add","plus","new-customer","add-customer","add-phone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 5V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","add","plus","new-call","customer-support","contact","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 5V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","add","plus","new-customer","add-customer","contact","new-contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76302 7.88117C5.9379 6.70629 7.84279 6.70626 9.01769 7.88116C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91982 13.2337 6.18455 13.3056 5.00311 12.3517C4.99717 12.5322 4.99927 12.7161 5.00976 12.9027C5.09286 14.3797 5.70162 15.9269 6.88735 17.1126C8.07307 18.2983 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9968C10.6943 17.8154 10.7663 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1571 17.2936 18.062 16.1188 19.2369C14.8253 20.5304 12.8998 21.0947 10.9849 20.987C9.05541 20.8785 7.03268 20.0863 5.47313 18.5268C3.91358 16.9672 3.12147 14.9445 3.01292 13.015C2.90524 11.101 3.46907 9.17633 4.7613 7.88289L4.76302 7.88117Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C16.5523 4 17 4.44772 17 5V7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H17V11C17 11.5523 16.5523 12 16 12C15.4477 12 15 11.5523 15 11V9H13C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7H15V5C15 4.44772 15.4477 4 16 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","add","plus","contact","new-contact","add-contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 5V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-arrow-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","arrow","arrow-right","forward","transfer","call-transfer","call-forward","pos-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","arrow","right","outgoing","outbound","send","forward","redirect","transfer","call-forward","call-transfer","call-redirect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","arrow","forward","send","transfer","call-forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4697 5.46966C16.7626 5.17677 17.2375 5.17678 17.5304 5.46968L20.5303 8.4697C20.8232 8.76259 20.8232 9.23746 20.5303 9.53036L17.5303 12.5303C17.2374 12.8232 16.7626 12.8232 16.4697 12.5303C16.1768 12.2374 16.1768 11.7626 16.4697 11.4697L18.9393 9.00002L16.4697 6.53032C16.1768 6.23743 16.1768 5.76255 16.4697 5.46966Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 9C11.25 8.58579 11.5858 8.25 12 8.25L20 8.25C20.4142 8.25 20.75 8.58579 20.75 9C20.75 9.41421 20.4142 9.75 20 9.75L12 9.75C11.5858 9.75 11.25 9.41421 11.25 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["call-alt","arrow-right","transfer","re-route","redirect","forward","reroute","route","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","arrow","transfer","forward","redirect","re-route","customer-service","support","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","arrow","transfer","forward","call-transfer","call-forward","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-arrow-right-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","arrow","transfer","forward","redirect","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76302 7.88117C5.9379 6.70629 7.84279 6.70626 9.01769 7.88116C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91982 13.2337 6.18455 13.3056 5.00311 12.3517C4.99717 12.5322 4.99927 12.7161 5.00976 12.9027C5.09286 14.3797 5.70162 15.9269 6.88735 17.1126C8.07307 18.2983 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9968C10.6943 17.8154 10.7663 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1571 17.2936 18.062 16.1188 19.2369C14.8253 20.5304 12.8998 21.0947 10.9849 20.987C9.05541 20.8785 7.03268 20.0863 5.47313 18.5268C3.91358 16.9672 3.12147 14.9445 3.01292 13.015C2.90524 11.101 3.46907 9.17633 4.7613 7.88289L4.76302 7.88117Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2929 5.29289C16.6835 4.90237 17.3166 4.90237 17.7072 5.2929L20.7071 8.29292C21.0976 8.68345 21.0976 9.31661 20.7071 9.70713L17.7071 12.7071C17.3166 13.0976 16.6834 13.0976 16.2929 12.7071C15.9024 12.3166 15.9024 11.6834 16.2929 11.2929L17.5858 10L12 10C11.4477 10 11 9.55228 11 9C11 8.44771 11.4477 8 12 8L17.5858 8.00002L16.2929 6.7071C15.9024 6.31657 15.9024 5.6834 16.2929 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-arrow-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","arrow","outgoing-call","transfer","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L20 9.00002L17 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9L12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Calling-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","cancel","end-call","terminate","disconnect","customer-support","phone-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 6L18 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Calling-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","cancel","missed-call","rejected","decline","block-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M14 6L18 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Calling-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","cancel","decline","missed-call","reject","customer-support","support","communication","end-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289L18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071C18.3166 11.0976 17.6834 11.0976 17.2929 10.7071L13.2929 6.70711C12.9024 6.31658 12.9024 5.68342 13.2929 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L13.2929 9.29289C12.9024 9.68342 12.9024 10.3166 13.2929 10.7071C13.6834 11.0976 14.3166 11.0976 14.7071 10.7071L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-Calling-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","contact","support","customer-service","ringing","telephone","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C17 9.23858 14.7614 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Call-alt-Calling-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","telephone","customer-support","contact","support","order-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C17 9.23858 14.7614 7 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Call-alt-Calling-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","telephone","contact","support","customer service","communication","order support","help","hotline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C17 9.23858 14.7614 7 12 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Call-alt-Calling-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","contact","customer-service","support","communication","ringing","telephone","place-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9999 4C10.9999 3.44772 11.4476 3 11.9999 3C16.9705 3 20.9999 7.02944 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13C19.4476 13 18.9999 12.5523 18.9999 12C18.9999 8.13401 15.8659 5 11.9999 5C11.4476 5 10.9999 4.55228 10.9999 4ZM10.9999 7C10.9999 6.44772 11.4476 6 11.9999 6C15.3136 6 17.9999 8.68629 17.9999 12C17.9999 12.5523 17.5522 13 16.9999 13C16.4476 13 15.9999 12.5523 15.9999 12C15.9999 9.79086 14.2091 8 11.9999 8C11.4476 8 10.9999 7.55228 10.9999 7ZM4.76302 7.88118C5.9379 6.7063 7.84279 6.70627 9.01769 7.88117C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91982 13.2337 6.18455 13.3056 5.00311 12.3517C4.99717 12.5322 4.99927 12.7161 5.00976 12.9027C5.09286 14.3797 5.70162 15.9269 6.88735 17.1126C8.07307 18.2983 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9968C10.6943 17.8154 10.7663 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1572 17.2936 18.062 16.1188 19.2369C14.8253 20.5304 12.8998 21.0947 10.9849 20.987C9.05541 20.8785 7.03268 20.0864 5.47313 18.5268C3.91358 16.9673 3.12147 14.9445 3.01292 13.015C2.90519 11.1002 3.46957 9.17463 4.76302 7.88118Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-Calling": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","cancel","call","missed-call","decline","block-number","unavailable","do-not-call","contact","customer-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 6L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","cancel","delete","remove","end-call","decline","missed-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 6L18 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","cancel","remove","reject","decline","hang-up","missed-call","end-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M14 6L18 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","cancel","decline","reject","missed-call","phone-cancel","phone-decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76302 7.88125C5.9379 6.70637 7.84279 6.70634 9.01769 7.88123C10.1926 9.05612 10.1926 10.961 9.01769 12.1359C7.91982 13.2337 6.18455 13.3057 5.00311 12.3518C4.99717 12.5323 4.99927 12.7162 5.00976 12.9028C5.09286 14.3798 5.70162 15.9269 6.88735 17.1127C8.07307 18.2984 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9969C10.6943 17.8154 10.7663 16.0802 11.8641 14.9823C13.039 13.8074 14.9439 13.8074 16.1188 14.9823C17.2937 16.1572 17.2936 18.0621 16.1188 19.237C14.8253 20.5304 12.8998 21.0948 10.9849 20.9871C9.05541 20.8785 7.03268 20.0864 5.47313 18.5269C3.91358 16.9673 3.12147 14.9446 3.01292 13.0151C2.90524 11.1011 3.46907 9.17641 4.7613 7.88297L4.76302 7.88125Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1785 5.16468C13.57 4.77512 14.2032 4.77669 14.5927 5.16818L16.0034 6.58589L17.4211 5.17519C17.8126 4.78563 18.4458 4.7872 18.8353 5.17869C19.2249 5.57018 19.2233 6.20334 18.8318 6.5929L17.4141 8.00361L18.8248 9.42132C19.2144 9.81281 19.2128 10.446 18.8213 10.8355C18.4298 11.2251 17.7967 11.2235 17.4071 10.832L15.9964 9.41431L14.5787 10.825C14.1872 11.2146 13.5541 11.213 13.1645 10.8215C12.7749 10.43 12.7765 9.79686 13.168 9.40731L14.5857 7.9966L13.175 6.57889C12.7854 6.1874 12.787 5.55423 13.1785 5.16468Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","cancel","cross","delete","remove","decline","end-call","void","dismiss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 6L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-dot-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","telephone","call","incoming","missed","ringing","customer-service","support","notification","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dot-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","customer-service","contact","support","help","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dot-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","communication","contact","support","customer service","help","phone call","inquiry","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 8.5C11.25 7.25736 12.2574 6.25 13.5 6.25C14.7426 6.25 15.75 7.25736 15.75 8.5C15.75 9.74264 14.7426 10.75 13.5 10.75C12.2574 10.75 11.25 9.74264 11.25 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 8.5C16.25 7.25736 17.2574 6.25 18.5 6.25C19.7426 6.25 20.75 7.25736 20.75 8.5C20.75 9.74264 19.7426 10.75 18.5 10.75C17.2574 10.75 16.25 9.74264 16.25 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-dot": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","customer service","support","contact","help","ringing","incoming call","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dots v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","telephone","support","customer service","help","contact","phone","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dots v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","contact","support","help","assistance","more","options","details","communication","voice","phone-call","dots"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dots v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","contact","customer-support","help","support","assistance","communication","chat","message","connect","info","more","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 7C14.3284 7 15 7.67157 15 8.5C15 9.32843 14.3284 10 13.5 10C12.6716 10 12 9.32843 12 8.5C12 7.67157 12.6716 7 13.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.5 7C19.3284 7 20 7.67157 20 8.5C20 9.32843 19.3284 10 18.5 10C17.6716 10 17 9.32843 17 8.5C17 7.67157 17.6716 7 18.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-dots v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","contact","customer-service","support","dial","telephone","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76302 6.38117C5.9379 5.20629 7.84279 5.20626 9.01769 6.38116C10.1926 7.55605 10.1926 9.46092 9.01769 10.6358C7.91982 11.7337 6.18455 11.8056 5.00311 10.8517C4.99717 11.0322 4.99927 11.2161 5.00976 11.4027C5.09286 12.8797 5.70162 14.4269 6.88735 15.6126C8.07307 16.7983 9.62023 17.4071 11.0972 17.4902C11.2838 17.5007 11.4677 17.5028 11.6482 17.4968C10.6943 16.3154 10.7663 14.5801 11.8641 13.4822C13.039 12.3074 14.9439 12.3074 16.1188 13.4822C17.2937 14.6571 17.2936 16.562 16.1188 17.7369C14.8253 19.0304 12.8998 19.5947 10.9849 19.487C9.05541 19.3785 7.03268 18.5863 5.47313 17.0268C3.91358 15.4672 3.12147 13.4445 3.01292 11.515C2.90524 9.60101 3.46907 7.67633 4.7613 6.38289L4.76302 6.38117Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 4.5C15.1046 4.5 16 5.39543 16 6.5C16 7.60457 15.1046 8.5 14 8.5C12.8954 8.5 12 7.60457 12 6.5C12 5.39543 12.8954 4.5 14 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19 4.5C20.1046 4.5 21 5.39543 21 6.5C21 7.60457 20.1046 8.5 19 8.5C17.8954 8.5 17 7.60457 17 6.5C17 5.39543 17.8954 4.5 19 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-hung-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","contact","support","customer-service","phone","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12.3333C7 13.2538 7.74619 14 8.66667 14C9.58714 14 10.3333 13.2538 10.3333 12.3333C10.3333 11.4129 9.58714 10.6667 8.66667 10.6667C7.74619 10.6667 7 11.4129 7 12.3333ZM7 12.3333C7 10.4924 9.23858 9 12 9C14.7614 9 17 10.4924 17 12.3333M17 12.3333C17 11.4129 16.2538 10.6667 15.3333 10.6667C14.4129 10.6667 13.6667 11.4129 13.6667 12.3333C13.6667 13.2538 14.4129 14 15.3333 14C16.2538 14 17 13.2538 17 12.3333Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-hung": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","headset","customer-service","call","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12.3333C7 13.2538 7.74619 14 8.66667 14C9.58714 14 10.3333 13.2538 10.3333 12.3333C10.3333 11.4129 9.58714 10.6667 8.66667 10.6667C7.74619 10.6667 7 11.4129 7 12.3333ZM7 12.3333C7 10.4924 9.23858 9 12 9C14.7614 9 17 10.4924 17 12.3333M17 12.3333C17 11.4129 16.2538 10.6667 15.3333 10.6667C14.4129 10.6667 13.6667 11.4129 13.6667 12.3333C13.6667 13.2538 14.4129 14 15.3333 14C16.2538 14 17 13.2538 17 12.3333Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-hung-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","contact","phone","customer-service","support","help","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM7.90977 9.14426C6.82616 9.86666 6 10.9745 6 12.3333C6 13.8061 7.19391 15 8.66667 15C10.1394 15 11.3333 13.8061 11.3333 12.3333C11.3333 11.4787 10.9313 10.7179 10.3059 10.2299C10.8147 10.0844 11.3869 10 12 10C12.6131 10 13.1853 10.0844 13.6941 10.2299C13.0687 10.7179 12.6667 11.4787 12.6667 12.3333C12.6667 13.8061 13.8606 15 15.3333 15C16.8061 15 18 13.8061 18 12.3333C18 10.9745 17.1738 9.86666 16.0902 9.14426C14.9996 8.4172 13.5506 8 12 8C10.4494 8 9.00036 8.4172 7.90977 9.14426Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-Incoming-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","incoming call","phone","arrow","receive","customer support","contact","support","phone order","order by phone","customer service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-hung-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","call","support","customer-service","communication","audio","sound","headset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.66667 10.6667C9.58714 10.6667 10.3333 11.4129 10.3333 12.3333C10.3333 13.2538 9.58714 14 8.66667 14C7.74619 14 7 13.2538 7 12.3333C7 11.4129 7.74619 10.6667 8.66667 10.6667Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.3333 10.6667C16.2538 10.6667 17 11.4129 17 12.3333C17 13.2538 16.2538 14 15.3333 14C14.4129 14 13.6667 13.2538 13.6667 12.3333C13.6667 11.4129 14.4129 10.6667 15.3333 10.6667Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M7 12.3333C7 13.2538 7.74619 14 8.66667 14C9.58714 14 10.3333 13.2538 10.3333 12.3333C10.3333 11.4129 9.58714 10.6667 8.66667 10.6667C7.74619 10.6667 7 11.4129 7 12.3333ZM7 12.3333C7 10.4924 9.23858 9 12 9C14.7614 9 17 10.4924 17 12.3333M17 12.3333C17 11.4129 16.2538 10.6667 15.3333 10.6667C14.4129 10.6667 13.6667 11.4129 13.6667 12.3333C13.6667 13.2538 14.4129 14 15.3333 14C16.2538 14 17 13.2538 17 12.3333Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-Incoming-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","incoming","phone","arrow","receive-call","support","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Incoming": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","incoming","receive-call","customer-service","support","contact","arrow-down","order-placed","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Incoming-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","incoming-call","phone","arrow","receive","receive-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2928 4.29289C18.6833 3.90237 19.3165 3.90237 19.707 4.29289C20.0975 4.68342 20.0975 5.31658 19.707 5.70711L15.4141 10L17.9999 10C18.5522 10 18.9999 10.4477 18.9999 11C18.9999 11.5523 18.5522 12 17.9999 12L12.9999 12C12.7347 12 12.4803 11.8946 12.2928 11.7071C12.1053 11.5196 11.9999 11.2652 11.9999 11L12 5.99999C12 5.4477 12.4477 4.99999 13 5C13.5523 5.00001 14 5.44773 14 6.00002L14 8.58575L18.2928 4.29289ZM4.76302 7.88127C5.93784 6.70645 7.84273 6.70621 9.01769 7.88117C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91983 13.2337 6.18455 13.3057 5.00312 12.3517C4.99717 12.5322 4.99926 12.7162 5.00976 12.9028C5.09286 14.3798 5.70162 15.927 6.88735 17.1127C8.07307 18.2984 9.62023 18.9072 11.0972 18.9903C11.2839 19.0008 11.4678 19.0029 11.6483 18.9969C10.6943 17.8155 10.7662 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1572 17.2936 18.0621 16.1188 19.237C14.8253 20.5305 12.8998 21.0948 10.9849 20.9871C9.05541 20.8786 7.03268 20.0864 5.47313 18.5269C3.91358 16.9673 3.12147 14.9446 3.01292 13.0151C2.90519 11.1003 3.46957 9.17472 4.76302 7.88127Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-missed-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","help","missed-call","call","arrow","back","left","pending","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18C5 15.0545 8.13401 12 12 12C15.866 12 19 15.0545 19 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-missed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["headset","missed-call","customer-support","call","help","arrow-left","left-arrow","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 17.5C4 15.677 4.95916 13.9228 6.38398 12.6497C7.81971 11.3669 9.80267 10.5 12 10.5C14.1973 10.5 16.1803 11.3669 17.616 12.6497C19.0408 13.9228 20 15.677 20 17.5C20 19.1569 18.6569 20.5 17 20.5C15.3431 20.5 14 19.1569 14 17.5C14 15.9547 15.1684 14.6822 16.67 14.5179C16.5489 14.3889 16.42 14.2631 16.2835 14.1411C15.1857 13.1603 13.6687 12.5 12 12.5C10.3313 12.5 8.8143 13.1603 7.71652 14.1411C7.58002 14.2631 7.4511 14.3889 7.32998 14.5179C8.83158 14.6822 10 15.9547 10 17.5C10 19.1569 8.65685 20.5 7 20.5C5.34315 20.5 4 19.1569 4 17.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6839 3.77047C17.0869 4.1482 17.1073 4.78103 16.7295 5.18394L12.9795 9.18394C12.7979 9.37768 12.5467 9.49121 12.2813 9.49951C12.0158 9.50782 11.758 9.41021 11.5646 9.2282L9.00004 6.81446L9.00006 8.49999C9.00007 9.05227 8.55236 9.49999 8.00008 9.5C7.44779 9.50001 7.00007 9.0523 7.00006 8.50002L7 4.50002C7 4.2348 7.10535 3.98044 7.29289 3.7929C7.48042 3.60536 7.73478 3.5 8 3.5H12C12.5523 3.5 13 3.94772 13 4.5C13 5.05229 12.5523 5.5 12 5.5H10.5216L12.2057 7.0851L15.2705 3.81606C15.6482 3.41315 16.281 3.39274 16.6839 3.77047Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-missed-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headset","headphones","arrow-left","missed-call","support","customer-service","assistance","help","callback","back-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18C5 15.0545 8.13401 12 12 12C15.866 12 19 15.0545 19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-outgoing-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","outgoing","transfer","forward","arrow","redirect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-outgoing-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","outgoing","transfer","forward","communication","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-missed": {
        defaultColors: ["#3D4C66"],
        keywords: ["callback","return-call","re-dial","customer-service","missed-call","contact-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18C5 15.0545 8.13401 12 12 12C15.866 12 19 15.0545 19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-outgoing-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","outgoing","arrow","redirect","transfer","forward","call-forwarding","transfer-call","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.9999 6C13.4476 6 12.9999 5.55228 12.9999 5C12.9999 4.44772 13.4476 4 13.9999 4H18.9999C19.2651 4 19.5195 4.10536 19.707 4.2929C19.8946 4.48044 19.9999 4.7348 19.9999 5.00002L19.9998 10C19.9998 10.5523 19.5521 11 18.9998 11C18.4475 11 17.9998 10.5523 17.9998 9.99998L17.9999 7.41425L13.707 11.7071C13.3165 12.0976 12.6833 12.0976 12.2928 11.7071C11.9023 11.3166 11.9023 10.6834 12.2928 10.2929L16.5857 6H13.9999ZM4.76302 7.88118C5.9379 6.7063 7.84279 6.70627 9.01769 7.88117C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91982 13.2337 6.18455 13.3057 5.00311 12.3517C4.99717 12.5322 4.99927 12.7161 5.00976 12.9027C5.09286 14.3797 5.70162 15.9269 6.88735 17.1126C8.07307 18.2983 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9968C10.6943 17.8154 10.7663 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1572 17.2936 18.062 16.1188 19.2369C14.8253 20.5304 12.8998 21.0947 10.9849 20.987C9.05541 20.8785 7.03268 20.0864 5.47313 18.5268C3.91358 16.9673 3.12147 14.9445 3.01292 13.015C2.90519 11.1002 3.46957 9.17463 4.76302 7.88118Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-outgoing": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","outgoing","send","transfer","export","share","call-alt-outgoing","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Pause-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","pause","hold","customer-support","phone","communication","support","on-hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10V6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Pause-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","pause","hold","customer-service","support","on-hold","wait"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58838C3.37857 10.68 3.43505 15.0745 6.18032 17.8198C8.92559 20.5651 13.3201 20.6215 15.4117 18.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.5712 18.5298C11.7868 17.7454 11.7868 16.4737 12.5712 15.6894C13.3556 14.905 14.6273 14.905 15.4116 15.6894C16.196 16.4737 16.196 17.7454 15.4116 18.5298C14.6273 19.3142 13.3556 19.3142 12.5712 18.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.47011 11.4287C4.68574 10.6443 4.68575 9.37264 5.47011 8.58827C6.25447 7.80391 7.52618 7.80391 8.31054 8.58827C9.09491 9.37264 9.09491 10.6443 8.31054 11.4287C7.52618 12.2131 6.25447 12.2131 5.47011 11.4287Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","blocked","unavailable","disable","support","help","communication","no-call","call-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9657 13.1732L16.865 13.7127C17.5384 14.1168 17.8752 14.3189 17.9731 14.6552C18.0711 14.9916 17.8954 15.3428 17.5442 16.0453L17.1502 16.8333C17.0819 16.9698 17.0478 17.038 16.9884 17.1122C16.9289 17.1864 16.8876 17.22 16.8051 17.2873C14.9862 18.7683 11.486 17.8791 8.80341 15.1966C6.12086 12.514 5.23175 9.01382 6.71273 7.19494C6.77997 7.11236 6.81359 7.07107 6.88778 7.01162C6.96196 6.95218 7.0302 6.91806 7.16668 6.84982L7.95472 6.4558C8.6572 6.10456 9.00844 5.92895 9.34478 6.02689C9.68113 6.12484 9.88317 6.46158 10.2873 7.13504L10.8268 8.03427C11.0737 8.44582 11.1972 8.6516 11.206 8.88064C11.2148 9.10969 11.1075 9.32433 10.8928 9.7536L10.6438 10.2516C10.3657 10.8078 10.2266 11.086 10.2729 11.3708C10.3191 11.6557 10.539 11.8755 10.9787 12.3153L11.6847 13.0213C12.1245 13.461 12.3443 13.6809 12.6292 13.7271C12.914 13.7734 13.1922 13.6343 13.7484 13.3562L14.2464 13.1072C14.6757 12.8925 14.8903 12.7852 15.1194 12.794C15.3484 12.8028 15.5542 12.9263 15.9657 13.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","slash","off","disable","mute","blocked","unavailable","do-not-disturb","no-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.6246 12.9612L10.9787 12.3153C10.539 11.8755 10.3191 11.6557 10.2729 11.3708C10.2266 11.086 10.3657 10.8078 10.6438 10.2516L10.8928 9.7536C11.1075 9.32433 11.2148 9.10969 11.206 8.88064C11.1972 8.6516 11.0737 8.44582 10.8268 8.03428L10.2873 7.13504C9.88318 6.46159 9.68113 6.12484 9.34478 6.02689C9.00844 5.92895 8.6572 6.10456 7.95472 6.4558L7.16668 6.84982C7.0302 6.91806 6.96196 6.95218 6.88778 7.01162C6.81359 7.07107 6.77997 7.11236 6.71273 7.19494C5.23175 9.01382 6.12086 12.514 8.80341 15.1966C8.90172 15.2949 9.00113 15.3908 9.10151 15.4843L11.6246 12.9612Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.3674 13.0468L10.6951 16.7191C12.9655 18.1581 15.3924 18.4375 16.8051 17.2873C16.8876 17.22 16.9289 17.1864 16.9884 17.1122C17.0478 17.038 17.0819 16.9698 17.1502 16.8333L17.5442 16.0453C17.8954 15.3428 18.0711 14.9916 17.9731 14.6552C17.8752 14.3189 17.5384 14.1168 16.865 13.7127L15.9657 13.1732C15.5542 12.9263 15.3484 12.8028 15.1194 12.794C14.9129 12.7861 14.7182 12.8725 14.3674 13.0468Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-Pause-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","telephone","call","pause","hold","customer-support","customer-service","on-hold","support","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.9999 5C14.5522 5 14.9999 5.44772 14.9999 6V10C14.9999 10.5523 14.5522 11 13.9999 11C13.4476 11 12.9999 10.5523 12.9999 10V6C12.9999 5.44772 13.4476 5 13.9999 5ZM17.9999 5C18.5522 5 18.9999 5.44772 18.9999 6V10C18.9999 10.5523 18.5522 11 17.9999 11C17.4476 11 16.9999 10.5523 16.9999 10V6C16.9999 5.44772 17.4476 5 17.9999 5ZM4.76302 7.88118C5.9379 6.7063 7.84279 6.70627 9.01769 7.88117C10.1926 9.05605 10.1926 10.9609 9.01769 12.1358C7.91982 13.2337 6.18455 13.3057 5.00311 12.3517C4.99717 12.5322 4.99927 12.7161 5.00976 12.9027C5.09286 14.3797 5.70162 15.9269 6.88735 17.1126C8.07307 18.2983 9.62023 18.9071 11.0972 18.9902C11.2838 19.0007 11.4677 19.0028 11.6482 18.9968C10.6943 17.8154 10.7663 16.0801 11.8641 14.9822C13.039 13.8074 14.9439 13.8074 16.1188 14.9822C17.2937 16.1572 17.2936 18.062 16.1188 19.2369C14.8253 20.5304 12.8998 21.0947 10.9849 20.987C9.05541 20.8785 7.03268 20.0864 5.47313 18.5268C3.91358 16.9673 3.12147 14.9445 3.01292 13.015C2.90519 11.1002 3.46957 9.17463 4.76302 7.88118Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-alt-Slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","off","not-available","disabled","mute","do-not-disturb","no-calls","unavailable","support-unavailable","order-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9657 13.1732L16.865 13.7127C17.5384 14.1168 17.8752 14.3189 17.9731 14.6552C18.0711 14.9916 17.8954 15.3428 17.5442 16.0453L17.1502 16.8333C17.0819 16.9698 17.0478 17.038 16.9884 17.1122C16.9289 17.1864 16.8876 17.22 16.8051 17.2873C14.9862 18.7683 11.486 17.8791 8.80341 15.1966C6.12086 12.514 5.23175 9.01382 6.71273 7.19494C6.77997 7.11236 6.81359 7.07107 6.88778 7.01162C6.96196 6.95218 7.0302 6.91806 7.16668 6.84982L7.95472 6.4558C8.6572 6.10456 9.00844 5.92895 9.34478 6.02689C9.68113 6.12484 9.88317 6.46158 10.2873 7.13504L10.8268 8.03427C11.0737 8.44582 11.1972 8.6516 11.206 8.88064C11.2148 9.10969 11.1075 9.32433 10.8928 9.7536L10.6438 10.2516C10.3657 10.8078 10.2266 11.086 10.2729 11.3708C10.3191 11.6557 10.539 11.8755 10.9787 12.3153L11.6847 13.0213C12.1245 13.461 12.3443 13.6809 12.6292 13.7271C12.914 13.7734 13.1922 13.6343 13.7484 13.3562L14.2464 13.1072C14.6757 12.8925 14.8903 12.7852 15.1194 12.794C15.3484 12.8028 15.5542 12.9263 15.9657 13.1732Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Pause": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","pause","hold","customer-service","support","communication","mute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47021 8.58827C3.37857 10.6799 3.43505 15.0744 6.18032 17.8197C8.92559 20.565 13.3201 20.6214 15.4117 18.5298M5.47021 8.58827C4.68585 9.37264 4.68585 10.6443 5.47021 11.4287C6.25458 12.2131 7.52628 12.2131 8.31064 11.4287C9.09501 10.6443 9.09501 9.37264 8.31064 8.58827C7.52628 7.80391 6.25458 7.80391 5.47021 8.58827ZM15.4117 18.5298C16.1961 17.7454 16.1961 16.4737 15.4117 15.6894C14.6274 14.905 13.3557 14.905 12.5713 15.6894C11.7869 16.4737 11.7869 17.7454 12.5713 18.5298C13.3557 19.3142 14.6274 19.3142 15.4117 18.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-alt-Slash-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","slash","disabled","mute","no-call","phone-off","decline-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.47021 6.58827C5.37857 8.67991 5.43505 13.0744 8.18032 15.8197C10.9256 18.565 15.3201 18.6214 17.4117 16.5298M7.47021 6.58827C6.68585 7.37264 6.68585 8.64434 7.47021 9.42871C8.25458 10.2131 9.52628 10.2131 10.3106 9.42871C11.095 8.64434 11.095 7.37264 10.3106 6.58827C9.52628 5.80391 8.25458 5.80391 7.47021 6.58827ZM17.4117 16.5298C18.1961 15.7454 18.1961 14.4737 17.4117 13.6894C16.6274 12.905 15.3557 12.905 14.5713 13.6894C13.7869 14.4737 13.7869 15.7454 14.5713 16.5298C15.3557 17.3142 16.6274 17.3142 17.4117 16.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Slash-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","cancel","remove","blocked","unavailable","call-alt-slash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.47021 6.58827C5.37857 8.67991 5.43505 13.0744 8.18032 15.8197C10.9256 18.565 15.3201 18.6214 17.4117 16.5298M7.47021 6.58827C6.68585 7.37264 6.68585 8.64434 7.47021 9.42871C8.25458 10.2131 9.52628 10.2131 10.3106 9.42871C11.095 8.64434 11.095 7.37264 10.3106 6.58827C9.52628 5.80391 8.25458 5.80391 7.47021 6.58827ZM17.4117 16.5298C18.1961 15.7454 18.1961 14.4737 17.4117 13.6894C16.6274 12.905 15.3557 12.905 14.5713 13.6894C13.7869 14.4737 13.7869 15.7454 14.5713 16.5298C15.3557 17.3142 16.6274 17.3142 17.4117 16.5298Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt-Slash-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["no-call","mute","blocked-number","do-not-call","decline-call","call","slash","disable-call","ignore-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.47021 6.58838C5.37857 8.68002 5.43505 13.0745 8.18032 15.8198C10.9256 18.5651 15.3201 18.6215 17.4117 16.5299"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.5712 16.5298C13.7868 15.7454 13.7868 14.4737 14.5712 13.6894C15.3556 12.905 16.6273 12.905 17.4116 13.6894C18.196 14.4737 18.196 15.7454 17.4116 16.5298C16.6273 17.3142 15.3556 17.3142 14.5712 16.5298Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M7.47011 9.42871C6.68574 8.64434 6.68575 7.37264 7.47011 6.58827C8.25447 5.80391 9.52618 5.80391 10.3105 6.58827C11.0949 7.37264 11.0949 8.64434 10.3105 9.42871C9.52618 10.2131 8.25447 10.2131 7.47011 9.42871Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14.5712 16.5298C13.7868 15.7454 13.7868 14.4737 14.5712 13.6894C15.3556 12.905 16.6273 12.905 17.4116 13.6894C18.196 14.4737 18.196 15.7454 17.4116 16.5298C16.6273 17.3142 15.3556 17.3142 14.5712 16.5298Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.47011 9.42871C6.68574 8.64434 6.68575 7.37264 7.47011 6.58827C8.25447 5.80391 9.52618 5.80391 10.3105 6.58827C11.0949 7.37264 11.0949 8.64434 10.3105 9.42871C9.52618 10.2131 8.25447 10.2131 7.47011 9.42871Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphone","customer-support","help","service","support","call","contact","headphones"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14C5 11.0545 8.13401 8 12 8C15.866 8 19 11.0545 19 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12C8.10457 12 9 12.8954 9 14C9 15.1046 8.10457 16 7 16C5.89543 16 5 15.1046 5 14C5 12.8954 5.89543 12 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 12C18.1046 12 19 12.8954 19 14C19 15.1046 18.1046 16 17 16C15.8954 16 15 15.1046 15 14C15 12.8954 15.8954 12 17 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-alt-Slash-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-sound","mute","sound-off","volume-off","disable-sound","no-audio","audio-off","silence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0178 5.88116C9.84287 4.70626 7.93798 4.70629 6.7631 5.88117L6.76138 5.8829C5.46915 7.17633 4.90532 9.10101 5.013 11.015C5.12155 12.9445 5.91366 14.9672 7.47321 16.5268C7.57147 16.625 7.67156 16.7203 7.77335 16.8124L9.18987 15.3959C9.08673 15.3054 8.98583 15.211 8.88743 15.1126C7.7017 13.9269 7.09294 12.3797 7.00984 10.9027C6.99935 10.7161 6.99725 10.5322 7.00319 10.3517C8.18463 11.3056 9.91991 11.2337 11.0178 10.1358C12.1927 8.96092 12.1927 7.05605 11.0178 5.88116Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.9295 16.4847L9.43172 17.9825C10.5642 18.5917 11.7924 18.9199 12.985 18.987C14.8998 19.0947 16.8254 18.5304 18.1188 17.2369C19.2937 16.062 19.2938 14.1571 18.1189 12.9822C16.944 11.8074 15.0391 11.8074 13.8642 12.9822C12.7663 14.0801 12.6944 15.8154 13.6483 16.9968C13.4678 17.0028 13.2839 17.0007 13.0973 16.9902C12.3747 16.9495 11.6352 16.783 10.9295 16.4847Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-Calling-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["phone","call","telephone","support","customer-service","contact","ringing","phone-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11C17 8.79086 15.2091 7 13 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10C20 6.68629 17.3137 4 14 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Calling-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["phone","call","contact","customer-support","support","communication","telephone","ringing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11C17 8.79086 15.2091 7 13 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10C20 6.68629 17.3137 4 14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Call-alt-Slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","blocked","no-call","unavailable","do-not-disturb","mute-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9657 13.1732L16.865 13.7127C17.5384 14.1168 17.8752 14.3189 17.9731 14.6552C18.0711 14.9916 17.8954 15.3428 17.5442 16.0453L17.1502 16.8333C17.0819 16.9698 17.0478 17.038 16.9884 17.1122C16.9289 17.1864 16.8876 17.22 16.8051 17.2873C14.9862 18.7683 11.486 17.8791 8.80341 15.1966C6.12086 12.514 5.23175 9.01382 6.71273 7.19494C6.77997 7.11236 6.81359 7.07107 6.88778 7.01162C6.96196 6.95218 7.0302 6.91806 7.16668 6.84982L7.95472 6.4558C8.6572 6.10456 9.00844 5.92895 9.34478 6.02689C9.68113 6.12484 9.88317 6.46158 10.2873 7.13504L10.8268 8.03427C11.0737 8.44582 11.1972 8.6516 11.206 8.88064C11.2148 9.10969 11.1075 9.32433 10.8928 9.7536L10.6438 10.2516C10.3657 10.8078 10.2266 11.086 10.2729 11.3708C10.3191 11.6557 10.539 11.8755 10.9787 12.3153L11.6847 13.0213C12.1245 13.461 12.3443 13.6809 12.6292 13.7271C12.914 13.7734 13.1922 13.6343 13.7484 13.3562L14.2464 13.1072C14.6757 12.8925 14.8903 12.7852 15.1194 12.794C15.3484 12.8028 15.5542 12.9263 15.9657 13.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Call-Calling-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","calling","contact","support","customer-service","communication","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C12 6.44772 12.4477 6 13 6C15.7614 6 18 8.23858 18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 9.34315 14.6569 8 13 8C12.4477 8 12 7.55228 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 13.4477 3 14 3C17.866 3 21 6.13401 21 10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10C19 7.23858 16.7614 5 14 5C13.4477 5 13 4.55228 13 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-Circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","contact","support","customer-service","ring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.9829 12.5866L14.4325 12.8564C14.7692 13.0584 14.9376 13.1594 14.9866 13.3276C15.0355 13.4958 14.9477 13.6714 14.7721 14.0226L14.5751 14.4167C14.541 14.4849 14.5239 14.519 14.4942 14.5561C14.4645 14.5932 14.4438 14.61 14.4025 14.6436C13.4931 15.3841 11.743 14.9396 10.4017 13.5983C9.06043 12.257 8.61587 10.5069 9.35637 9.59747C9.38999 9.55618 9.4068 9.53553 9.44389 9.50581C9.48098 9.47609 9.5151 9.45903 9.58334 9.42491L9.97736 9.2279C10.3286 9.05228 10.5042 8.96447 10.6724 9.01345C10.8406 9.06242 10.9416 9.23079 11.1436 9.56752L11.4134 10.0171C11.5369 10.2229 11.5986 10.3258 11.603 10.4403C11.6074 10.5548 11.5537 10.6622 11.4464 10.8768L11.3219 11.1258C11.1829 11.4039 11.1133 11.543 11.1364 11.6854C11.1595 11.8278 11.2695 11.9378 11.4894 12.1576L11.8424 12.5106C12.0622 12.7305 12.1722 12.8405 12.3146 12.8636C12.457 12.8867 12.5961 12.8171 12.8742 12.6781L13.1232 12.5536C13.3378 12.4463 13.4452 12.3926 13.5597 12.397C13.6742 12.4014 13.7771 12.4631 13.9829 12.5866Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Calling": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","support","contact","customer-service","help","ringing","order-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11C17 8.79086 15.2091 7 13 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10C20 6.68629 17.3137 4 14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","contact","customer service","support","help","telephone","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11.8686 10.112C11.9121 10.2029 11.9481 10.3054 11.9527 10.4268C11.9574 10.5482 11.9294 10.6532 11.893 10.7472C11.8607 10.8309 11.8139 10.9244 11.7652 11.0217L11.635 11.2823C11.5618 11.4285 11.5206 11.5122 11.4971 11.5764C11.486 11.607 11.4829 11.6228 11.4822 11.6292C11.4849 11.6351 11.4928 11.6491 11.5131 11.6746C11.5556 11.7281 11.6212 11.7944 11.7368 11.9101L12.0898 12.2631C12.2055 12.3787 12.2718 12.4443 12.3253 12.4869C12.3508 12.5071 12.3648 12.515 12.3707 12.5177C12.3771 12.517 12.3929 12.514 12.4235 12.5028C12.4877 12.4793 12.5714 12.4381 12.7177 12.365L12.9782 12.2347C13.0756 12.186 13.169 12.1392 13.2528 12.1069C13.3467 12.0706 13.4517 12.0425 13.5731 12.0472C13.6945 12.0519 13.7971 12.0879 13.8879 12.1313C13.9689 12.17 14.0585 12.2238 14.1518 12.2797L14.6293 12.5663C14.7832 12.6586 14.9264 12.7444 15.0347 12.8303C15.1549 12.9255 15.2699 13.0488 15.3226 13.2297C15.3753 13.4106 15.3445 13.5763 15.2942 13.7212C15.2488 13.8518 15.1742 14.0011 15.0939 14.1616L14.8822 14.5849C14.8534 14.6429 14.8209 14.708 14.7673 14.7749C14.7142 14.8412 14.6693 14.8777 14.6276 14.9117L14.6235 14.915C14.0516 15.3807 13.2575 15.4428 12.4763 15.2404C11.6888 15.0364 10.8626 14.5541 10.1542 13.8457C9.44584 13.1373 8.96357 12.3112 8.75955 11.5237C8.55717 10.7425 8.61925 9.94836 9.08495 9.37641L9.08826 9.37235C9.12218 9.33065 9.15873 9.28573 9.22502 9.23261C9.29189 9.17903 9.35703 9.14657 9.41497 9.11769L9.83835 8.90602C9.99883 8.82575 10.1481 8.75108 10.2787 8.70574C10.4236 8.65545 10.5894 8.62466 10.7702 8.67733C10.9511 8.73001 11.0745 8.84499 11.1697 8.96518C11.2555 9.07356 11.3414 9.2167 11.4337 9.37057L11.7202 9.8481C11.7762 9.94139 11.83 10.031 11.8686 10.112Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-Circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","contact","support","customer service","help","phone-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.9829 12.5866L14.4325 12.8564C14.7692 13.0584 14.9376 13.1594 14.9866 13.3276C15.0355 13.4958 14.9477 13.6714 14.7721 14.0226L14.5751 14.4167C14.541 14.4849 14.5239 14.519 14.4942 14.5561C14.4645 14.5932 14.4438 14.61 14.4025 14.6436C13.4931 15.3841 11.743 14.9396 10.4017 13.5983C9.06043 12.257 8.61587 10.5069 9.35637 9.59747C9.38999 9.55618 9.4068 9.53553 9.44389 9.50581C9.48098 9.47609 9.5151 9.45903 9.58334 9.42491L9.97736 9.2279C10.3286 9.05228 10.5042 8.96447 10.6724 9.01345C10.8406 9.06242 10.9416 9.23079 11.1436 9.56752L11.4134 10.0171C11.5369 10.2229 11.5986 10.3258 11.603 10.4403C11.6074 10.5548 11.5537 10.6622 11.4464 10.8768L11.3219 11.1258C11.1829 11.4039 11.1133 11.543 11.1364 11.6854C11.1595 11.8278 11.2695 11.9378 11.4894 12.1576L11.8424 12.5106C12.0622 12.7305 12.1722 12.8405 12.3146 12.8636C12.457 12.8867 12.5961 12.8171 12.8742 12.6781L13.1232 12.5536C13.3378 12.4463 13.4452 12.3926 13.5597 12.397C13.6742 12.4014 13.7771 12.4631 13.9829 12.5866Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                />
            </svg>
        )
    },
    "Call-Circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","contact","customer-service","support","telephone","communication","ring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.9829 12.5866L14.4325 12.8564C14.7692 13.0584 14.9376 13.1594 14.9866 13.3276C15.0355 13.4958 14.9477 13.6714 14.7721 14.0226L14.5751 14.4167C14.541 14.4849 14.5239 14.519 14.4942 14.5561C14.4645 14.5932 14.4438 14.61 14.4025 14.6436C13.4931 15.3841 11.743 14.9396 10.4017 13.5983C9.06043 12.257 8.61587 10.5069 9.35637 9.59747C9.38999 9.55618 9.4068 9.53553 9.44389 9.50581C9.48098 9.47609 9.5151 9.45903 9.58334 9.42491L9.97736 9.2279C10.3286 9.05228 10.5042 8.96447 10.6724 9.01345C10.8406 9.06242 10.9416 9.23079 11.1436 9.56752L11.4134 10.0171C11.5369 10.2229 11.5986 10.3258 11.603 10.4403C11.6074 10.5548 11.5537 10.6622 11.4464 10.8768L11.3219 11.1258C11.1829 11.4039 11.1133 11.543 11.1364 11.6854C11.1595 11.8278 11.2695 11.9378 11.4894 12.1576L11.8424 12.5106C12.0622 12.7305 12.1722 12.8405 12.3146 12.8636C12.457 12.8867 12.5961 12.8171 12.8742 12.6781L13.1232 12.5536C13.3378 12.4463 13.4452 12.3926 13.5597 12.397C13.6742 12.4014 13.7771 12.4631 13.9829 12.5866Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Hung-Circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","hung-up","cancel","decline","reject","void","unavailable","communication","phone","end-call","disconnect","telephone","abandon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9.96744 13.7361L9.39838 13.8824C8.97219 13.9919 8.75909 14.0467 8.58732 13.9498C8.41555 13.8528 8.34608 13.6385 8.20716 13.2099L8.09746 12.8715C8.04657 12.7145 8.02113 12.636 8.0132 12.5104C8.00528 12.3848 8.01338 12.342 8.02959 12.2566C8.27075 10.985 9.95641 10 12 10C14.0436 10 15.7293 10.985 15.9704 12.2566C15.9866 12.342 15.9947 12.3848 15.9868 12.5104C15.9789 12.636 15.9534 12.7145 15.9025 12.8715L15.9025 12.8715L15.7928 13.2099C15.6539 13.6385 15.5845 13.8528 15.4127 13.9498C15.2409 14.0467 15.0278 13.9919 14.6016 13.8824L14.0326 13.7361C13.7721 13.6691 13.6419 13.6356 13.5478 13.5461C13.4537 13.4565 13.4113 13.3255 13.3264 13.0636L13.2279 12.7031C13.1179 12.3638 13.0629 12.1941 12.932 12.0971C12.801 12 12.6271 12 12.2792 12H11.7208C11.3729 12 11.199 12 11.068 12.0971C10.9371 12.1941 10.8821 12.3638 10.7721 12.7031L10.6736 13.0636C10.5887 13.3255 10.5463 13.4565 10.4522 13.5461C10.3581 13.6356 10.2279 13.6691 9.96744 13.7361Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                />
            </svg>
        )
    },
    "Call-Hung-Circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","contact","customer support","help","ring","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.96744 13.7361L9.39838 13.8824C8.97219 13.9919 8.75909 14.0467 8.58732 13.9498C8.41555 13.8528 8.34608 13.6385 8.20716 13.2099L8.09746 12.8715C8.04657 12.7145 8.02113 12.636 8.0132 12.5104C8.00528 12.3848 8.01338 12.342 8.02959 12.2566C8.27075 10.985 9.95641 10 12 10C14.0436 10 15.7293 10.985 15.9704 12.2566C15.9866 12.342 15.9947 12.3848 15.9868 12.5104C15.9789 12.636 15.9534 12.7145 15.9025 12.8715L15.9025 12.8715L15.7928 13.2099C15.6539 13.6385 15.5845 13.8528 15.4127 13.9498C15.2409 14.0467 15.0278 13.9919 14.6016 13.8824L14.0326 13.7361C13.7721 13.6691 13.6419 13.6356 13.5478 13.5461C13.4537 13.4565 13.4113 13.3255 13.3264 13.0636L13.2279 12.7031C13.1179 12.3638 13.0629 12.1941 12.932 12.0971C12.801 12 12.6271 12 12.2792 12H11.7208C11.3729 12 11.199 12 11.068 12.0971C10.9371 12.1941 10.8821 12.3638 10.7721 12.7031L10.6736 13.0636C10.5887 13.3255 10.5463 13.4565 10.4522 13.5461C10.3581 13.6356 10.2279 13.6691 9.96744 13.7361Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Hung-Circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","ringing","receiver","customer-service","support","help","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.96744 13.7361L9.39838 13.8824C8.97219 13.9919 8.75909 14.0467 8.58732 13.9498C8.41555 13.8528 8.34608 13.6385 8.20716 13.2099L8.09746 12.8715C8.04657 12.7145 8.02113 12.636 8.0132 12.5104C8.00528 12.3848 8.01338 12.342 8.02959 12.2566C8.27075 10.985 9.95641 10 12 10C14.0436 10 15.7293 10.985 15.9704 12.2566C15.9866 12.342 15.9947 12.3848 15.9868 12.5104C15.9789 12.636 15.9534 12.7145 15.9025 12.8715L15.9025 12.8715L15.7928 13.2099C15.6539 13.6385 15.5845 13.8528 15.4127 13.9498C15.2409 14.0467 15.0278 13.9919 14.6016 13.8824L14.0326 13.7361C13.7721 13.6691 13.6419 13.6356 13.5478 13.5461C13.4537 13.4565 13.4113 13.3255 13.3264 13.0636L13.2279 12.7031C13.1179 12.3638 13.0629 12.1941 12.932 12.0971C12.801 12 12.6271 12 12.2792 12H11.7208C11.3729 12 11.199 12 11.068 12.0971C10.9371 12.1941 10.8821 12.3638 10.7721 12.7031L10.6736 13.0636C10.5887 13.3255 10.5463 13.4565 10.4522 13.5461C10.3581 13.6356 10.2279 13.6691 9.96744 13.7361Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Hung-Circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","customer-service","support","contact","help","call-hung","missed-call","urgent-call","alert","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11.3445 13.264L11.443 12.9035C11.4687 12.8241 11.4889 12.7622 11.5074 12.709L11.5101 12.7013C11.567 12.7001 11.6335 12.7 11.7207 12.7H12.2792C12.3665 12.7 12.4329 12.7001 12.4899 12.7013L12.4926 12.709C12.5111 12.7622 12.5312 12.8241 12.557 12.9035L12.6554 13.264L12.6668 13.2989C12.7036 13.4127 12.7445 13.5388 12.7906 13.6461C12.8449 13.7724 12.9254 13.92 13.0651 14.053C13.2057 14.1869 13.3578 14.2599 13.4887 14.3075C13.5983 14.3474 13.7258 14.3801 13.8384 14.409L14.4582 14.5683C14.6439 14.6161 14.8441 14.6677 15.0196 14.6886C15.2261 14.7133 15.4914 14.7092 15.7568 14.5594C16.0196 14.411 16.1608 14.1882 16.2483 14.0026C16.3239 13.8421 16.3882 13.6437 16.449 13.4558L16.5752 13.0665C16.6222 12.9218 16.6718 12.7692 16.6854 12.5545C16.6981 12.3531 16.6814 12.249 16.6581 12.1262C16.4869 11.2231 15.8252 10.5119 15.0092 10.0442C14.1837 9.57106 13.1286 9.30005 12 9.30005C10.8714 9.30005 9.81629 9.57106 8.99079 10.0442C8.17472 10.5119 7.5131 11.2231 7.34183 12.1262C7.31854 12.249 7.30186 12.3531 7.31457 12.5545C7.32812 12.7692 7.37771 12.9218 7.42474 13.0665L7.55095 13.4558C7.61178 13.6436 7.67605 13.8421 7.75169 14.0026C7.83911 14.1882 7.98035 14.411 8.24319 14.5594C8.50856 14.7092 8.77383 14.7133 8.98033 14.6886C9.15582 14.6677 9.35607 14.6161 9.54176 14.5683L10.1616 14.409C10.2742 14.3801 10.4016 14.3474 10.5113 14.3075C10.6421 14.2599 10.7943 14.1869 10.9349 14.053C11.0746 13.92 11.155 13.7724 11.2093 13.6461C11.2555 13.5388 11.2963 13.4127 11.3332 13.2989L11.3445 13.264Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-Incoming-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["call","phone","incoming","receive-order","order-received","customer-service","support","contact","callback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Incoming-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","incoming","telephone","order-received","call-order","phone-order","receive-order","customer-call","support-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 11C19 11.5523 18.5523 12 18 12L13 12C12.7348 12 12.4804 11.8946 12.2929 11.7071C12.1054 11.5196 12 11.2652 12 11L12.0001 5.99999C12.0001 5.4477 12.4478 4.99999 13.0001 5C13.5524 5.00001 14.0001 5.44773 14.0001 6.00002L14 10L18 10C18.5523 10 19 10.4477 19 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.7071 11.7071C13.3166 12.0976 12.6834 12.0976 12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-Incoming-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["call","incoming","phone","arrow","customer-support","help","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Call-log-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["phone","call","log","call-log","history","customer-service","support","contact","records","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L20 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L20 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L20 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 14.1732L14.865 14.7127C15.5384 15.1168 15.8752 15.3189 15.9731 15.6552C16.0711 15.9916 15.8954 16.3428 15.5442 17.0453L15.1502 17.8333C15.0819 17.9698 15.0478 18.038 14.9884 18.1122C14.9289 18.1864 14.8876 18.22 14.8051 18.2873C12.9862 19.7683 9.48596 18.8791 6.80341 16.1966C4.12086 13.514 3.23175 10.0138 4.71273 8.19494C4.77997 8.11236 4.81359 8.07107 4.88778 8.01162C4.96196 7.95218 5.0302 7.91806 5.16668 7.84982L5.95472 7.4558C6.6572 7.10456 7.00844 6.92895 7.34478 7.02689C7.68113 7.12484 7.88317 7.46158 8.28725 8.13504L8.82679 9.03427C9.07372 9.44582 9.19719 9.6516 9.20598 9.88064C9.21478 10.1097 9.10746 10.3243 8.89282 10.7536L8.64382 11.2516C8.3657 11.8078 8.22664 12.086 8.27287 12.3708C8.31909 12.6557 8.53896 12.8755 8.97871 13.3153L9.68472 14.0213C10.1245 14.461 10.3443 14.6809 10.6292 14.7271C10.914 14.7734 11.1922 14.6343 11.7484 14.3562L12.2464 14.1072C12.6757 13.8925 12.8903 13.7852 13.1194 13.794C13.3484 13.8028 13.5542 13.9263 13.9657 14.1732Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Incoming": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","incoming","support","customer-service","help","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L13 11L13.0001 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-log-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["phone","call","contact","customer","order-history","call-log","support","communication","list","call-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L20 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L20 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 14.1732L14.865 14.7127C15.5384 15.1168 15.8752 15.3189 15.9731 15.6552C16.0711 15.9916 15.8954 16.3428 15.5442 17.0453L15.1502 17.8333C15.0819 17.9698 15.0478 18.038 14.9884 18.1122C14.9289 18.1864 14.8876 18.22 14.8051 18.2873C12.9862 19.7683 9.48596 18.8791 6.80341 16.1966C4.12086 13.514 3.23175 10.0138 4.71273 8.19494C4.77997 8.11236 4.81359 8.07107 4.88778 8.01162C4.96196 7.95218 5.0302 7.91806 5.16668 7.84982L5.95472 7.4558C6.6572 7.10456 7.00844 6.92895 7.34478 7.02689C7.68113 7.12484 7.88317 7.46158 8.28725 8.13504L8.82679 9.03427C9.07372 9.44582 9.19719 9.6516 9.20598 9.88064C9.21478 10.1097 9.10746 10.3243 8.89282 10.7536L8.64383 11.2516C8.3657 11.8078 8.22664 12.086 8.27287 12.3708C8.31909 12.6557 8.53896 12.8755 8.97871 13.3153L9.68472 14.0213C10.1245 14.461 10.3443 14.6809 10.6292 14.7271C10.914 14.7734 11.1922 14.6343 11.7484 14.3562L12.2464 14.1072C12.6757 13.8925 12.8903 13.7852 13.1194 13.794C13.3484 13.8028 13.5542 13.9263 13.9657 14.1732Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-log": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","history","log","call-log","customer-service","contact","recent-calls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L20 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L20 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11L20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 14.1732L14.865 14.7127C15.5384 15.1168 15.8752 15.3189 15.9731 15.6552C16.0711 15.9916 15.8954 16.3428 15.5442 17.0453L15.1502 17.8333C15.0819 17.9698 15.0478 18.038 14.9884 18.1122C14.9289 18.1864 14.8876 18.22 14.8051 18.2873C12.9862 19.7683 9.48596 18.8791 6.80341 16.1966C4.12086 13.514 3.23175 10.0138 4.71273 8.19494C4.77997 8.11236 4.81359 8.07107 4.88778 8.01162C4.96196 7.95218 5.0302 7.91806 5.16668 7.84982L5.95472 7.4558C6.6572 7.10456 7.00844 6.92895 7.34478 7.02689C7.68113 7.12484 7.88317 7.46158 8.28725 8.13504L8.82679 9.03427C9.07372 9.44582 9.19719 9.6516 9.20598 9.88064C9.21478 10.1097 9.10746 10.3243 8.89282 10.7536L8.64382 11.2516C8.3657 11.8078 8.22664 12.086 8.27287 12.3708C8.31909 12.6557 8.53896 12.8755 8.97871 13.3153L9.68472 14.0213C10.1245 14.461 10.3443 14.6809 10.6292 14.7271C10.914 14.7734 11.1922 14.6343 11.7484 14.3562L12.2464 14.1072C12.6757 13.8925 12.8903 13.7852 13.1194 13.794C13.3484 13.8028 13.5542 13.9263 13.9657 14.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-log-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","log","call-log","history","call-history","communication","support","customer-service","orders","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.9997 5C20.9997 5.55228 20.552 6 19.9997 6L15.9997 6C15.4474 6 14.9997 5.55228 14.9997 5C14.9997 4.44772 15.4474 4 15.9997 4L19.9997 4C20.552 4 20.9997 4.44772 20.9997 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.9997 8C20.9997 8.55228 20.552 9 19.9997 9H15.9997C15.4474 9 14.9997 8.55228 14.9997 8C14.9997 7.44772 15.4474 7 15.9997 7L19.9997 7C20.552 7 20.9997 7.44772 20.9997 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.9997 11C20.9997 11.5523 20.552 12 19.9997 12H15.9997C15.4474 12 14.9997 11.5523 14.9997 11C14.9997 10.4477 15.4474 10 15.9997 10H19.9997C20.552 10 20.9997 10.4477 20.9997 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.62276 6.60056C6.89188 6.50713 7.17781 6.45759 7.48427 6.54683C7.79074 6.63607 8.00537 6.83139 8.18225 7.05469C8.34568 7.26101 8.51143 7.53729 8.69995 7.85155C8.70518 7.86027 8.71043 7.86902 8.71569 7.87779L9.26574 8.79453C9.38022 8.9853 9.48336 9.15718 9.55654 9.31036C9.63651 9.47775 9.69739 9.65532 9.70531 9.86145C9.71323 10.0676 9.66614 10.2493 9.59925 10.4223C9.53803 10.5807 9.44837 10.76 9.34887 10.9589L9.09073 11.4752C8.94652 11.7636 8.85782 11.9427 8.8061 12.0844C8.7588 12.214 8.76168 12.2635 8.76611 12.2907C8.77053 12.318 8.78343 12.3658 8.86929 12.4738C8.96315 12.5918 9.10395 12.7337 9.33196 12.9617L10.038 13.6677C10.266 13.8958 10.4078 14.0365 10.5259 14.1304C10.6339 14.2163 10.6817 14.2292 10.709 14.2336C10.7362 14.238 10.7857 14.2409 10.9153 14.1936C11.057 14.1419 11.2361 14.0532 11.5245 13.909L12.0408 13.6508C12.2397 13.5513 12.419 13.4617 12.5774 13.4004C12.7504 13.3336 12.9321 13.2865 13.1382 13.2944C13.3444 13.3023 13.5219 13.3632 13.6893 13.4432C13.8425 13.5163 14.0144 13.6195 14.2051 13.7339L15.1481 14.2997C15.4624 14.4883 15.7387 14.654 15.945 14.8174C16.1683 14.9943 16.3636 15.209 16.4529 15.5154C16.5421 15.8219 16.4926 16.1078 16.3991 16.3769C16.3128 16.6256 16.1687 16.9138 16.0048 17.2415L15.5971 18.0569C15.5936 18.0639 15.5902 18.0708 15.5867 18.0777C15.5277 18.1959 15.4716 18.3084 15.3783 18.4249C15.2854 18.5407 15.2094 18.6026 15.1271 18.6696L15.1205 18.675C14.0435 19.5519 12.5292 19.6828 11.0024 19.2873C9.46663 18.8894 7.84473 17.9453 6.44955 16.5501C5.05437 15.155 4.11029 13.5331 3.71242 11.9973C3.31688 10.4705 3.44784 8.95616 4.3247 7.87924C4.32652 7.87701 4.32833 7.87478 4.33014 7.87256C4.39705 7.79034 4.45896 7.71427 4.57481 7.62144C4.6913 7.52809 4.80377 7.47197 4.92203 7.41296C4.92893 7.40952 4.93584 7.40607 4.94277 7.4026L5.73081 7.00859C5.73996 7.00401 5.74908 6.99945 5.75816 6.99491C6.08594 6.83099 6.37411 6.68688 6.62276 6.60056Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "call-missed-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["arrow","split","merge","split-tender","tender","payment","cashier","increase","promotion","upgrade"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L12 15L8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","up","split","increase","grow","payment","split-payment","tip","split-tip","increase-amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L12 15L8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","merge","combine","group","transfer","diverge","fork","multi-payment","payment-split","combine-orders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289L15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711C15.3166 9.09763 14.6834 9.09763 14.2929 8.70711L13 7.41421V14.5858L16.7071 18.2929C17.0976 18.6834 17.0976 19.3166 16.7071 19.7071C16.3166 20.0976 15.6834 20.0976 15.2929 19.7071L12 16.4142L8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071C6.90237 19.3166 6.90237 18.6834 7.29289 18.2929L11 14.5858V7.41421L9.70711 8.70711C9.31658 9.09763 8.68342 9.09763 8.29289 8.70711C7.90237 8.31658 7.90237 7.68342 8.29289 7.29289L11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "call-missed-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","back","undo","refund","previous","transaction-history","rollback","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 9L5 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","return","back","revert","transaction-reversal","refund","previous","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 9L5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","rollback","transaction","history","revert","back","return","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7593 8.34923C20.1187 8.76855 20.0701 9.39985 19.6508 9.75927L13.9524 14.6436C13.94 14.6542 13.9277 14.6648 13.9154 14.6754C13.6371 14.914 13.3625 15.1495 13.1077 15.3177C12.8183 15.5089 12.4552 15.6829 12 15.6829C11.5448 15.6829 11.1817 15.5089 10.8923 15.3177C10.6375 15.1495 10.3629 14.914 10.0846 14.6754C10.0723 14.6648 10.06 14.6542 10.0476 14.6436L6 11.1742V13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13V9.00002C4 8.44773 4.44772 8.00002 5 8.00002H9C9.55228 8.00002 10 8.44773 10 9.00002C10 9.5523 9.55228 10 9 10H7.70326L11.3492 13.1251C11.6794 13.4081 11.8575 13.5584 11.9945 13.6489C11.9964 13.6501 11.9982 13.6513 12 13.6525C12.0018 13.6513 12.0036 13.6501 12.0055 13.6489C12.1425 13.5584 12.3206 13.4081 12.6508 13.1251L18.3492 8.24076C18.7685 7.88134 19.3998 7.9299 19.7593 8.34923Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "call-missed-outgoing-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","outgoing","down","up","transaction","complete","undo","rollback","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H19V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["missed","missed-call","arrow","return","undo","back","history","previous","recall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 9L5 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-outgoing-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","outgoing","up","right","trending-up","increase","sales-increase","revenue-increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.24076 8.34923C4.60018 7.9299 5.23148 7.88134 5.65081 8.24076L11.3492 13.1251C11.6794 13.4081 11.8575 13.5584 11.9945 13.6489C11.9964 13.6501 11.9982 13.6513 12 13.6525C12.0018 13.6513 12.0036 13.6501 12.0055 13.6489C12.1425 13.5584 12.3206 13.4081 12.6508 13.1251L16.2968 10H15C14.4477 10 14 9.5523 14 9.00002C14 8.44773 14.4477 8.00002 15 8.00002H19C19.2652 8.00002 19.5196 8.10537 19.7071 8.29291C19.8947 8.48045 20 8.7348 20 9.00002L20 13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13V11.1742L13.9524 14.6436C13.94 14.6542 13.9277 14.6648 13.9154 14.6754C13.6371 14.914 13.3625 15.1495 13.1077 15.3177C12.8183 15.5089 12.4553 15.6829 12 15.6829C11.5448 15.6829 11.1817 15.5089 10.8923 15.3177C10.6376 15.1495 10.3629 14.914 10.0847 14.6754C10.0723 14.6648 10.06 14.6542 10.0476 14.6436L4.34923 9.75927C3.9299 9.39985 3.88134 8.76855 4.24076 8.34923Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "call-missed-outgoing-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","return","outgoing","transfer","send","export","direction","transaction","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H19V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed-outgoing": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","down","outgoing","transaction","export","inventory","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L10.6984 13.8844C11.3195 14.4167 11.6301 14.6829 12 14.6829C12.3699 14.6829 12.6805 14.4167 13.3016 13.8844L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H19V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "call-missed": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","separate","diverge","outgoing","transfer","direction","branch","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L12 15L8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-outgoing-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["phone","call","outgoing","order","customer-support","contact","arrow","send","new-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-outgoing-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","outgoing","arrow","support","contact","customer service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 5C13 4.44772 13.4477 4 14 4H19C19.2652 4 19.5196 4.10536 19.7071 4.2929C19.8946 4.48044 20 4.7348 20 5.00002L19.9999 10C19.9999 10.5523 19.5522 11 18.9999 11C18.4476 11 17.9999 10.5523 17.9999 9.99998L18 6H14C13.4477 6 13 5.55228 13 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 4.2929C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.7071 11.7071C13.3166 12.0976 12.6834 12.0976 12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-outgoing-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["phone","call","outgoing","sales-call","support","customer-support","contact","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Call-Pause-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["phone","pause","call","hold","on-hold","phone-pause","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10V6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Pause-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["call","phone","pause","hold","customer-support","phone-hold","call-pause","on-hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Call-outgoing": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","outgoing","call","arrow","export","send","communication","support","customer-service","outbound-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H19L18.9999 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-Pause": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","pause","hold","customer-support","support","on-hold","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64382 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-ring-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","call","ring","incoming-call","support","customer-service","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.1997 18.0012L13.5337 15.7769C13.7037 15.4935 13.7886 15.3518 13.9056 15.2489C14.0092 15.1578 14.1304 15.0891 14.2618 15.0472C14.4103 14.9997 14.5755 14.9997 14.9059 14.9997H15.3997C15.9598 14.9997 16.2398 14.9997 16.4537 15.1087C16.6419 15.2046 16.7949 15.3576 16.8908 15.5458C16.9997 15.7597 16.9997 16.0397 16.9997 16.5997V17.3997C16.9997 17.9491 16.9997 18.2237 16.8715 18.4519C16.7681 18.636 16.5635 18.8145 16.3671 18.8921C16.1237 18.9882 15.884 18.9554 15.4047 18.8899C14.2791 18.7361 13.1898 18.4268 12.1997 18.0012ZM12.1997 18.0012C10.8156 17.3965 9.56766 16.5382 8.51452 15.4851C7.46139 14.4319 6.60313 13.184 5.99839 11.7999M5.99839 11.7999L8.22278 10.4659C8.50615 10.296 8.64784 10.211 8.75076 10.094C8.84183 9.99045 8.91051 9.86919 8.95247 9.73783C8.99989 9.58938 8.99989 9.42417 8.99989 9.09375L8.99989 8.59989C8.99989 8.03983 8.99989 7.75981 8.89089 7.5459C8.79502 7.35773 8.64204 7.20475 8.45388 7.10888C8.23996 6.99989 7.95994 6.99989 7.39989 6.99989L6.59989 6.99989C6.05058 6.99989 5.77593 6.99989 5.54776 7.12811C5.36366 7.23157 5.18516 7.43612 5.10758 7.63253C5.01144 7.87597 5.04419 8.11562 5.10969 8.59491C5.26353 9.72057 5.57286 10.8098 5.99839 11.7999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11L18 11M13 5V6.06066M18 6L17 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-Pause-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","pause","phone","hold","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 5C14.5523 5 15 5.44772 15 6V10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10V6C13 5.44772 13.4477 5 14 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 5C18.5523 5 19 5.44772 19 6V10C19 10.5523 18.5523 11 18 11C17.4477 11 17 10.5523 17 10V6C17 5.44772 17.4477 5 18 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.9657 15.1732L14.865 15.7127C15.5384 16.1168 15.8752 16.3189 15.9731 16.6552C16.0711 16.9916 15.8954 17.3428 15.5442 18.0453L15.1502 18.8333C15.0819 18.9698 15.0478 19.038 14.9884 19.1122C14.9289 19.1864 14.8876 19.22 14.8051 19.2873C12.9862 20.7683 9.48596 19.8791 6.80341 17.1966C4.12086 14.514 3.23175 11.0138 4.71273 9.19494C4.77997 9.11236 4.81359 9.07107 4.88778 9.01162C4.96196 8.95218 5.0302 8.91806 5.16668 8.84982L5.95472 8.4558C6.6572 8.10456 7.00844 7.92895 7.34478 8.02689C7.68113 8.12484 7.88317 8.46158 8.28725 9.13504L8.82679 10.0343C9.07372 10.4458 9.19719 10.6516 9.20598 10.8806C9.21478 11.1097 9.10746 11.3243 8.89282 11.7536L8.64383 12.2516C8.3657 12.8078 8.22664 13.086 8.27287 13.3708C8.31909 13.6557 8.53896 13.8755 8.97871 14.3153L9.68472 15.0213C10.1245 15.461 10.3443 15.6809 10.6292 15.7271C10.914 15.7734 11.1922 15.6343 11.7484 15.3562L12.2464 15.1072C12.6757 14.8925 12.8903 14.7852 13.1194 14.794C13.3484 14.8028 13.5542 14.9263 13.9657 15.1732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-ring-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","ringing","customer-support","help","contact","phone-call","telephone","customer service","incoming call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.99989 8.59989C8.99989 8.03983 8.99989 7.75981 8.89089 7.5459C8.79502 7.35773 8.64204 7.20475 8.45388 7.10888C8.23996 6.99989 7.95994 6.99989 7.39989 6.99989L6.59989 6.99989C6.05058 6.99989 5.77593 6.99989 5.54776 7.12811C5.36366 7.23157 5.18516 7.43612 5.10758 7.63253C5.01144 7.87597 5.04419 8.11562 5.10969 8.59491C5.26353 9.72057 5.57286 10.8098 5.99839 11.7999L8.22278 10.4659C8.50615 10.296 8.64784 10.211 8.75076 10.094C8.84183 9.99045 8.91051 9.86919 8.95247 9.73783C8.99989 9.58938 8.99989 9.42417 8.99989 9.09375V8.59989Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.1997 18.0012L13.5337 15.7769C13.7037 15.4935 13.7886 15.3518 13.9056 15.2489C14.0092 15.1578 14.1304 15.0891 14.2618 15.0472C14.4103 14.9997 14.5755 14.9997 14.9059 14.9997H15.3997C15.9598 14.9997 16.2398 14.9997 16.4537 15.1087C16.6419 15.2046 16.7949 15.3576 16.8908 15.5458C16.9997 15.7597 16.9997 16.0397 16.9997 16.5997V17.3997C16.9997 17.9491 16.9997 18.2237 16.8715 18.4519C16.7681 18.636 16.5635 18.8145 16.3671 18.8921C16.1237 18.9882 15.884 18.9554 15.4047 18.8899C14.2791 18.7361 13.1898 18.4268 12.1997 18.0012ZM12.1997 18.0012C10.8156 17.3965 9.56766 16.5382 8.51452 15.4851C7.46139 14.4319 6.60313 13.184 5.99839 11.7999M5.99839 11.7999L8.22278 10.4659C8.50615 10.296 8.64784 10.211 8.75076 10.094C8.84183 9.99045 8.91051 9.86919 8.95247 9.73783C8.99989 9.58938 8.99989 9.42417 8.99989 9.09375L8.99989 8.59989C8.99989 8.03983 8.99989 7.75981 8.89089 7.5459C8.79502 7.35773 8.64204 7.20475 8.45388 7.10888C8.23996 6.99989 7.95994 6.99989 7.39989 6.99989L6.59989 6.99989C6.05058 6.99989 5.77593 6.99989 5.54776 7.12811C5.36366 7.23157 5.18516 7.43612 5.10758 7.63253C5.01144 7.87597 5.04419 8.11562 5.10969 8.59491C5.26353 9.72057 5.57286 10.8098 5.99839 11.7999Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11L18 11M13 5V6.06066M18 6L17 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-ring-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","ring","ringing","customer-service","support","contact","order-support","help","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9998 4C13.5521 4 13.9998 4.44772 13.9998 5V6.06066C13.9998 6.61294 13.5521 7.06066 12.9998 7.06066C12.4475 7.06066 11.9998 6.61294 11.9998 6.06066V5C11.9998 4.44772 12.4475 4 12.9998 4ZM18.7069 5.29289C19.0974 5.68342 19.0974 6.31658 18.7069 6.70711L17.7069 7.70711C17.3164 8.09763 16.6832 8.09763 16.2927 7.70711C15.9022 7.31658 15.9022 6.68342 16.2927 6.29289L17.2927 5.29289C17.6832 4.90237 18.3164 4.90237 18.7069 5.29289ZM6.56541 5.99988C6.57693 5.99988 6.58843 5.99989 6.59992 5.99989L7.39992 5.99989C7.41056 5.99989 7.42119 5.99989 7.43182 5.99988C7.6842 5.99985 7.92999 5.99982 8.13815 6.01683C8.36674 6.03551 8.63648 6.07958 8.9079 6.21787C9.28422 6.40962 9.59019 6.71558 9.78193 7.0919C9.92023 7.36333 9.9643 7.63306 9.98297 7.86166C9.99998 8.06981 9.99995 8.31561 9.99992 8.56799C9.99992 8.57861 9.99992 8.58924 9.99992 8.59989V9.09375C9.99992 9.11629 10 9.13947 10.0001 9.16322C10.001 9.41796 10.0021 9.73835 9.90509 10.0421C9.82117 10.3048 9.68381 10.5474 9.50166 10.7544C9.29106 10.9939 9.01571 11.1577 8.79679 11.2879C8.77637 11.3001 8.75645 11.3119 8.73712 11.3235L7.29711 12.1871C7.80971 13.1438 8.45994 14.0163 9.22166 14.778C9.98339 15.5397 10.8559 16.19 11.8126 16.7026L12.6761 15.2626C12.6877 15.2432 12.6996 15.2233 12.7117 15.2029C12.842 14.984 13.0058 14.7086 13.2452 14.498C13.4523 14.3159 13.6948 14.1785 13.9576 14.0946C14.2613 13.9976 14.5817 13.9987 14.8364 13.9996C14.8602 13.9997 14.8834 13.9997 14.9059 13.9997L15.4317 13.9997C15.6841 13.9997 15.9298 13.9997 16.138 14.0167C16.3666 14.0354 16.6363 14.0794 16.9078 14.2177C17.2841 14.4095 17.59 14.7154 17.7818 15.0918C17.9201 15.3632 17.9642 15.6329 17.9828 15.8615C17.9998 16.0697 17.9998 16.3155 17.9998 16.5679L17.9998 17.4343C17.9998 17.6789 17.9999 17.9276 17.9791 18.1424C17.9553 18.3888 17.8992 18.6644 17.7433 18.9418C17.5273 19.3262 17.1446 19.6601 16.7345 19.8221C16.2379 20.0183 15.7428 19.9479 15.3641 19.894C15.3317 19.8894 15.3 19.8849 15.2693 19.8807C14.0528 19.7145 12.8763 19.3805 11.8049 18.92L11.7994 18.9176C10.2993 18.2622 8.94765 17.3324 7.80745 16.1922C6.66725 15.052 5.73749 13.7003 5.08207 12.2003L5.07967 12.1948C4.61917 11.1233 4.2852 9.9469 4.11893 8.73032C4.11474 8.69963 4.11024 8.668 4.10563 8.63552C4.05181 8.25691 3.98141 7.76173 4.17754 7.26518C4.33952 6.85505 4.67346 6.47237 5.05788 6.25634C5.33528 6.10045 5.61086 6.04436 5.85723 6.02055C6.07208 5.99979 6.32081 5.99984 6.56541 5.99988ZM17.9998 10L18.9998 10C19.5521 10 19.9998 10.4477 19.9998 11C19.9998 11.5523 19.5521 12 18.9998 12H17.9998C17.4475 12 16.9998 11.5523 16.9998 11C16.9998 10.4477 17.4475 10 17.9998 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","phone","contact","customer-support","help","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.646 14.4821C15.118 14.0101 15.118 13.2448 14.646 12.7728C14.174 12.3007 13.4086 12.3007 12.9366 12.7728C12.4646 13.2448 12.4646 14.0101 12.9366 14.4821C13.4086 14.9541 14.174 14.9541 14.646 14.4821ZM14.646 14.4821C13.7019 15.4262 11.7886 15.0435 10.3726 13.6274C8.95648 12.2114 8.57383 10.2981 9.51788 9.35402M9.51788 9.35402C9.04585 9.82605 9.04585 10.5914 9.51788 11.0634C9.98991 11.5354 10.7552 11.5354 11.2272 11.0634C11.6993 10.5914 11.6993 9.82605 11.2272 9.35402C10.7552 8.88199 9.98991 8.88199 9.51788 9.35402Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-ring": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","ring","support","customer-service","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.1997 18.0012L13.5337 15.7769C13.7037 15.4935 13.7886 15.3518 13.9056 15.2489C14.0092 15.1578 14.1304 15.0891 14.2618 15.0472C14.4103 14.9997 14.5755 14.9997 14.9059 14.9997H15.3997C15.9598 14.9997 16.2398 14.9997 16.4537 15.1087C16.6419 15.2046 16.7949 15.3576 16.8908 15.5458C16.9997 15.7597 16.9997 16.0397 16.9997 16.5997V17.3997C16.9997 17.9491 16.9997 18.2237 16.8715 18.4519C16.7681 18.636 16.5635 18.8145 16.3671 18.8921C16.1237 18.9882 15.884 18.9554 15.4047 18.8899C14.2791 18.7361 13.1898 18.4268 12.1997 18.0012ZM12.1997 18.0012C10.8156 17.3965 9.56766 16.5382 8.51452 15.4851C7.46139 14.4319 6.60313 13.184 5.99839 11.7999M5.99839 11.7999L8.22278 10.4659C8.50615 10.296 8.64784 10.211 8.75076 10.094C8.84183 9.99045 8.91051 9.86919 8.95247 9.73783C8.99989 9.58938 8.99989 9.42417 8.99989 9.09375L8.99989 8.59989C8.99989 8.03983 8.99989 7.75981 8.89089 7.5459C8.79502 7.35773 8.64204 7.20475 8.45388 7.10888C8.23996 6.99989 7.95994 6.99989 7.39989 6.99989L6.59989 6.99989C6.05058 6.99989 5.77593 6.99989 5.54776 7.12811C5.36366 7.23157 5.18516 7.43612 5.10758 7.63253C5.01144 7.87597 5.04419 8.11562 5.10969 8.59491C5.26353 9.72057 5.57286 10.8098 5.99839 11.7999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 11L18 11M13 5V6.06066M18 6L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call-v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","contact","customer-service","support","telephone","customer-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11.6768 7.76492C10.6569 6.74503 9.00331 6.74503 7.98342 7.76492C7.04406 8.70428 6.8513 10.0393 7.09966 11.2811C7.34967 12.5311 8.05881 13.8128 9.12299 14.877C10.1872 15.9412 11.4689 16.6503 12.7189 16.9004C13.9608 17.1487 15.2957 16.956 16.2351 16.0166C17.255 14.9967 17.255 13.3431 16.2351 12.3232C15.2152 11.3033 13.5616 11.3033 12.5417 12.3232C11.9663 12.8986 11.7156 13.6757 11.7894 14.4269C11.3634 14.1836 10.9369 13.8625 10.5372 13.4628C10.1375 13.0631 9.81638 12.6366 9.57312 12.2106C10.3243 12.2845 11.1014 12.0337 11.6768 11.4583C12.6967 10.4384 12.6967 8.78482 11.6768 7.76492Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call-v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","contact","customer-support","help","assistance","ring","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.646 14.4821C15.118 14.0101 15.118 13.2448 14.646 12.7728C14.174 12.3007 13.4086 12.3007 12.9366 12.7728C12.4646 13.2448 12.4646 14.0101 12.9366 14.4821C13.4086 14.9541 14.174 14.9541 14.646 14.4821ZM14.646 14.4821C13.7019 15.4262 11.7886 15.0435 10.3726 13.6274C8.95648 12.2114 8.57383 10.2981 9.51788 9.35402M9.51788 9.35402C9.04585 9.82605 9.04585 10.5914 9.51788 11.0634C9.98991 11.5354 10.7552 11.5354 11.2272 11.0634C11.6993 10.5914 11.6993 9.82605 11.2272 9.35402C10.7552 8.88199 9.98991 8.88199 9.51788 9.35402Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call-v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","phone","contact","customer support","order support","help","customer service","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.9366 14.4821C12.4646 14.0101 12.4646 13.2448 12.9366 12.7728C13.4086 12.3007 14.174 12.3007 14.646 12.7728C15.118 13.2448 15.118 14.0101 14.646 14.4821C14.174 14.9541 13.4086 14.9541 12.9366 14.4821Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M9.51788 11.0634C9.04585 10.5914 9.04585 9.82605 9.51788 9.35402C9.98991 8.88199 10.7552 8.88199 11.2272 9.35402C11.6993 9.82605 11.6993 10.5914 11.2272 11.0634C10.7552 11.5354 9.98991 11.5354 9.51788 11.0634Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.646 14.4821C15.118 14.0101 15.118 13.2448 14.646 12.7728C14.174 12.3007 13.4086 12.3007 12.9366 12.7728C12.4646 13.2448 12.4646 14.0101 12.9366 14.4821C13.4086 14.9541 14.174 14.9541 14.646 14.4821ZM14.646 14.4821C13.7019 15.4262 11.7886 15.0435 10.3726 13.6274C8.95648 12.2114 8.57383 10.2981 9.51788 9.35402M9.51788 9.35402C9.04585 9.82605 9.04585 10.5914 9.51788 11.0634C9.98991 11.5354 10.7552 11.5354 11.2272 11.0634C11.6993 10.5914 11.6993 9.82605 11.2272 9.35402C10.7552 8.88199 9.98991 8.88199 9.51788 9.35402Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call_hung-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["call","phone","telephone","customer-service","support","contact","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 15.4721L6.79676 15.7647C5.94437 15.9839 5.51818 16.0934 5.17464 15.8995C4.83109 15.7056 4.69217 15.277 4.41432 14.4199L4.09746 13.4423C4.04623 13.2843 4.02062 13.2053 4.00943 13.1037C3.99823 13.0021 4.00377 12.9434 4.01484 12.8259C4.26867 10.1333 7.74671 8 12 8C16.2533 8 19.7313 10.1333 19.9852 12.8259C19.9962 12.9434 20.0018 13.0021 19.9906 13.1037C19.9794 13.2053 19.9538 13.2843 19.9025 13.4423L19.5857 14.4199C19.3078 15.277 19.1689 15.7056 18.8254 15.8995C18.4818 16.0934 18.0556 15.9839 17.2032 15.7647L16.0651 15.4721C15.5442 15.3382 15.2838 15.2713 15.0956 15.0921C14.9075 14.9129 14.8226 14.6511 14.6528 14.1273L14.4558 13.5196C14.2358 12.8409 14.1258 12.5015 13.864 12.3074C13.6021 12.1133 13.2542 12.1133 12.5585 12.1133H11.4415C10.7458 12.1133 10.3979 12.1133 10.136 12.3074C9.87416 12.5015 9.76416 12.8409 9.54415 13.5196L9.34718 14.1273C9.1774 14.6511 9.0925 14.9129 8.90436 15.0921C8.71621 15.2713 8.45577 15.3382 7.93489 15.4721L7.93489 15.4721Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Call_hung-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["call","phone","support","contact","customer-service","phone-call"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 15.4721L6.79676 15.7647C5.94437 15.9839 5.51818 16.0934 5.17464 15.8995C4.83109 15.7056 4.69217 15.277 4.41432 14.4199L4.09746 13.4423C4.04623 13.2843 4.02062 13.2053 4.00943 13.1037C3.99823 13.0021 4.00377 12.9434 4.01484 12.8259C4.26867 10.1333 7.74671 8 12 8C16.2533 8 19.7313 10.1333 19.9852 12.8259C19.9962 12.9434 20.0018 13.0021 19.9906 13.1037C19.9794 13.2053 19.9538 13.2843 19.9025 13.4423L19.5857 14.4199C19.3078 15.277 19.1689 15.7056 18.8254 15.8995C18.4818 16.0934 18.0556 15.9839 17.2032 15.7647L16.0651 15.4721C15.5442 15.3382 15.2838 15.2713 15.0956 15.0921C14.9075 14.9129 14.8226 14.6511 14.6528 14.1273L14.4558 13.5196C14.2358 12.8409 14.1258 12.5015 13.864 12.3074C13.6021 12.1133 13.2542 12.1133 12.5585 12.1133H11.4415C10.7458 12.1133 10.3979 12.1133 10.136 12.3074C9.87416 12.5015 9.76416 12.8409 9.54415 13.5196L9.34718 14.1273C9.1774 14.6511 9.0925 14.9129 8.90436 15.0921C8.71621 15.2713 8.45577 15.3382 7.93489 15.4721L7.93489 15.4721Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Call_hung-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["receiver","call","phone","contact","communication","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 15.4721L6.79676 15.7647C5.94437 15.9839 5.51818 16.0934 5.17464 15.8995C4.83109 15.7056 4.69217 15.277 4.41432 14.4199L4.09746 13.4423C4.04623 13.2843 4.02062 13.2053 4.00943 13.1037C3.99823 13.0021 4.00377 12.9434 4.01484 12.8259C4.26867 10.1333 7.74671 8 12 8C16.2533 8 19.7313 10.1333 19.9852 12.8259C19.9962 12.9434 20.0018 13.0021 19.9906 13.1037C19.9794 13.2053 19.9538 13.2843 19.9025 13.4423L19.5857 14.4199C19.3078 15.277 19.1689 15.7056 18.8254 15.8995C18.4818 16.0934 18.0556 15.9839 17.2032 15.7647L16.0651 15.4721C15.5442 15.3382 15.2838 15.2713 15.0956 15.0921C14.9075 14.9129 14.8226 14.6511 14.6528 14.1273L14.4558 13.5196C14.2358 12.8409 14.1258 12.5015 13.864 12.3074C13.6021 12.1133 13.2542 12.1133 12.5585 12.1133H11.4415C10.7458 12.1133 10.3979 12.1133 10.136 12.3074C9.87416 12.5015 9.76416 12.8409 9.54415 13.5196L9.34718 14.1273C9.1774 14.6511 9.0925 14.9129 8.90436 15.0921C8.71621 15.2713 8.45577 15.3382 7.93489 15.4721L7.93489 15.4721Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Call_hung: {
        defaultColors: ["#3D4C66"],
        keywords: ["receiver","call","phone","contact","communication","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 15.4721L6.79676 15.7647C5.94437 15.9839 5.51818 16.0934 5.17464 15.8995C4.83109 15.7056 4.69217 15.277 4.41432 14.4199L4.09746 13.4423C4.04623 13.2843 4.02062 13.2053 4.00943 13.1037C3.99823 13.0021 4.00377 12.9434 4.01484 12.8259C4.26867 10.1333 7.74671 8 12 8C16.2533 8 19.7313 10.1333 19.9852 12.8259C19.9962 12.9434 20.0018 13.0021 19.9906 13.1037C19.9794 13.2053 19.9538 13.2843 19.9025 13.4423L19.5857 14.4199C19.3078 15.277 19.1689 15.7056 18.8254 15.8995C18.4818 16.0934 18.0556 15.9839 17.2032 15.7647L16.0651 15.4721C15.5442 15.3382 15.2838 15.2713 15.0956 15.0921C14.9075 14.9129 14.8226 14.6511 14.6528 14.1273L14.4558 13.5196C14.2358 12.8409 14.1258 12.5015 13.864 12.3074C13.6021 12.1133 13.2542 12.1133 12.5585 12.1133H11.4415C10.7458 12.1133 10.3979 12.1133 10.136 12.3074C9.87416 12.5015 9.76416 12.8409 9.54415 13.5196L9.34718 14.1273C9.1774 14.6511 9.0925 14.9129 8.90436 15.0921C8.71621 15.2713 8.45577 15.3382 7.93489 15.4721L7.93489 15.4721Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Call_missed-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["call","missed","call-missed","arrow","decline","reject","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 19.4721L6.79676 19.7647C5.94437 19.9839 5.51818 20.0934 5.17464 19.8995C4.83109 19.7056 4.69217 19.277 4.41432 18.4199L4.09746 17.4423C4.04623 17.2843 4.02062 17.2053 4.00943 17.1037C3.99823 17.0021 4.00377 16.9434 4.01484 16.8259C4.26867 14.1333 7.74671 12 12 12C16.2533 12 19.7313 14.1333 19.9852 16.8259C19.9962 16.9434 20.0018 17.0021 19.9906 17.1037C19.9794 17.2053 19.9538 17.2843 19.9025 17.4423L19.5857 18.4199C19.3078 19.277 19.1689 19.7056 18.8254 19.8995C18.4818 20.0934 18.0556 19.9839 17.2032 19.7647L16.0651 19.4721C15.5442 19.3382 15.2838 19.2713 15.0956 19.0921C14.9075 18.9129 14.8226 18.6511 14.6528 18.1273L14.4558 17.5196C14.2358 16.8409 14.1258 16.5015 13.864 16.3074C13.6021 16.1133 13.2542 16.1133 12.5585 16.1133H11.4415C10.7458 16.1133 10.3979 16.1133 10.136 16.3074C9.87416 16.5015 9.76416 16.8409 9.54415 17.5196L9.34718 18.1273C9.1774 18.6511 9.0925 18.9129 8.90436 19.0921C8.71621 19.2713 8.45577 19.3382 7.93489 19.4721L7.93489 19.4721Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call_missed-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["call","missed","incoming","phone","support","customer","service","callback","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 19.4721L6.79676 19.7647C5.94437 19.9839 5.51818 20.0934 5.17464 19.8995C4.83109 19.7056 4.69217 19.277 4.41432 18.4199L4.09746 17.4423C4.04623 17.2843 4.02062 17.2053 4.00943 17.1037C3.99823 17.0021 4.00377 16.9434 4.01484 16.8259C4.26867 14.1333 7.74671 12 12 12C16.2533 12 19.7313 14.1333 19.9852 16.8259C19.9962 16.9434 20.0018 17.0021 19.9906 17.1037C19.9794 17.2053 19.9538 17.2843 19.9025 17.4423L19.5857 18.4199C19.3078 19.277 19.1689 19.7056 18.8254 19.8995C18.4818 20.0934 18.0556 19.9839 17.2032 19.7647L16.0651 19.4721C15.5442 19.3382 15.2838 19.2713 15.0956 19.0921C14.9075 18.9129 14.8226 18.6511 14.6528 18.1273L14.4558 17.5196C14.2358 16.8409 14.1258 16.5015 13.864 16.3074C13.6021 16.1133 13.2542 16.1133 12.5585 16.1133H11.4415C10.7458 16.1133 10.3979 16.1133 10.136 16.3074C9.87416 16.5015 9.76416 16.8409 9.54415 17.5196L9.34718 18.1273C9.1774 18.6511 9.0925 18.9129 8.90436 19.0921C8.71621 19.2713 8.45577 19.3382 7.93489 19.4721L7.93489 19.4721Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Call_missed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","call","missed-call","callback","customer","support","phone-support","phone-callback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93452 19.4721L6.79639 19.7647C5.944 19.9839 5.51781 20.0934 5.17427 19.8995C4.83072 19.7056 4.6918 19.277 4.41395 18.4199L4.09709 17.4423C4.04587 17.2843 4.02025 17.2053 4.00906 17.1037C3.99786 17.0021 4.0034 16.9434 4.01447 16.8259C4.2683 14.1333 7.74634 12 11.9996 12C16.2529 12 19.731 14.1333 19.9848 16.8259C19.9959 16.9434 20.0014 17.0021 19.9902 17.1037C19.979 17.2053 19.9534 17.2843 19.9022 17.4423L19.5853 18.4199C19.3075 19.277 19.1685 19.7056 18.825 19.8995C18.4815 20.0934 18.0553 19.9839 17.2029 19.7647L16.0647 19.4721C15.5439 19.3382 15.2834 19.2713 15.0953 19.0921C14.9071 18.913 14.8222 18.6511 14.6524 18.1273L14.4555 17.5196C14.2355 16.8409 14.1255 16.5015 13.8636 16.3074C13.6017 16.1133 13.2538 16.1133 12.5581 16.1133H11.4412C10.7454 16.1133 10.3976 16.1133 10.1357 16.3074C9.87379 16.5015 9.76379 16.8409 9.54378 17.5196L9.34682 18.1273C9.17703 18.6511 9.09213 18.913 8.90399 19.0921C8.71585 19.2713 8.4554 19.3382 7.93452 19.4721Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6836 5.27047C16.2807 4.89274 15.6478 4.91315 15.2701 5.31606L12.2054 8.5851L8.685 5.2718C8.28282 4.89329 7.64995 4.91246 7.27143 5.31464C6.89292 5.71681 6.91209 6.34969 7.31427 6.7282L11.5643 10.7282C11.7576 10.9102 12.0155 11.0078 12.2809 10.9995C12.5463 10.9912 12.7975 10.8777 12.9792 10.6839L16.7292 6.68394C17.1069 6.28103 17.0865 5.6482 16.6836 5.27047Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9996 6C12.9996 5.44772 12.5519 5 11.9996 5H7.99963C7.73441 5 7.48006 5.10536 7.29252 5.2929C7.10498 5.48044 6.99963 5.7348 6.99963 6.00002L6.99969 10C6.9997 10.5523 7.44742 11 7.99971 11C8.55199 11 8.9997 10.5523 8.99969 9.99999L8.99965 7H11.9996C12.5519 7 12.9996 6.55229 12.9996 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera rotate-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["returns","exchange","refresh","sync","bag","briefcase","product-returns","exchange-product","reconciliation","adjustment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.3333L15.7724 12.6667C15.2232 11.1131 13.7416 10 12 10C10.1361 10 8.57002 11.2748 8.12598 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00004 16.6667L8.22765 15.3333C8.77676 16.8869 10.2584 18 12 18C13.8639 18 15.43 16.7252 15.874 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera rotate-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","rotate","refresh","sync","image","scan","photo","re-scan","rescan","re-take","retake"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8H9C8.55343 8 8.33014 8 8.24275 7.85435C8.15536 7.7087 8.26044 7.51168 8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765C15.7396 7.51168 15.8446 7.7087 15.7572 7.85435C15.6699 8 15.4466 8 15 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.3333L15.7724 12.6667C15.2232 11.1131 13.7416 10 12 10C10.1361 10 8.57002 11.2748 8.12598 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00004 16.6667L8.22765 15.3333C8.77676 16.8869 10.2584 18 12 18C13.8639 18 15.43 16.7252 15.874 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Call_missed: {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","rotate","refresh","sync","image","scan","photo","re-scan","rescan","re-take","retake"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93489 19.4721L6.79676 19.7647C5.94437 19.9839 5.51818 20.0934 5.17464 19.8995C4.83109 19.7056 4.69217 19.277 4.41432 18.4199L4.09746 17.4423C4.04623 17.2843 4.02062 17.2053 4.00943 17.1037C3.99823 17.0021 4.00377 16.9434 4.01484 16.8259C4.26867 14.1333 7.74671 12 12 12C16.2533 12 19.7313 14.1333 19.9852 16.8259C19.9962 16.9434 20.0018 17.0021 19.9906 17.1037C19.9794 17.2053 19.9538 17.2843 19.9025 17.4423L19.5857 18.4199C19.3078 19.277 19.1689 19.7056 18.8254 19.8995C18.4818 20.0934 18.0556 19.9839 17.2032 19.7647L16.0651 19.4721C15.5442 19.3382 15.2838 19.2713 15.0956 19.0921C14.9075 18.9129 14.8226 18.6511 14.6528 18.1273L14.4558 17.5196C14.2358 16.8409 14.1258 16.5015 13.864 16.3074C13.6021 16.1133 13.2542 16.1133 12.5585 16.1133H11.4415C10.7458 16.1133 10.3979 16.1133 10.136 16.3074C9.87416 16.5015 9.76416 16.8409 9.54415 17.5196L9.34718 18.1273C9.1774 18.6511 9.0925 18.9129 8.90436 19.0921C8.71621 19.2713 8.45577 19.3382 7.93489 19.4721L7.93489 19.4721Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 6L12.25 10L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H8L8.00006 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera rotate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","rotate","refresh","sync","photo","re-take","update","inventory","scan","image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9546 4H12.0452C12.5911 3.99997 13.073 3.99995 13.4755 4.04072C13.9117 4.08491 14.3355 4.18282 14.7434 4.42753C15.1512 4.67224 15.437 5.00012 15.6813 5.3642C15.9067 5.70018 16.1334 6.12537 16.3903 6.60707L16.431 6.68324C16.488 6.78989 16.5554 6.91601 16.6141 7.04347C16.9033 7.06077 17.1736 7.08495 17.4251 7.11876C18.3529 7.2435 19.1723 7.51547 19.8284 8.17158C20.4845 8.82769 20.7565 9.64711 20.8813 10.5749C21.0001 11.4587 21 12.5753 21 13.9294V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92943C8.57531 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V13.9294C2.99997 12.5753 2.99994 11.4587 3.11876 10.5749C3.2435 9.64711 3.51547 8.82769 4.17158 8.17158C4.82769 7.51547 5.64711 7.2435 6.57494 7.11876C6.82631 7.08496 7.09652 7.06078 7.38568 7.04348C7.44436 6.91601 7.51178 6.78988 7.5688 6.68323L7.60941 6.60714C7.8663 6.1254 8.09304 5.7002 8.31846 5.3642C8.56271 5.00012 8.84855 4.67224 9.25639 4.42753C9.66424 4.18282 10.0881 4.08491 10.5242 4.04072C10.9268 3.99995 11.4087 3.99997 11.9546 4ZM11.982 9.00003C9.65872 9.00819 7.71107 10.6 7.1575 12.7507C7.01984 13.2856 7.34182 13.8308 7.87668 13.9684C8.41153 14.1061 8.95671 13.7841 9.09437 13.2493C9.42746 11.9551 10.6034 11 11.9999 11C13.3046 11 14.4172 11.8334 14.8295 12.9999C14.9812 13.4292 15.4038 13.7018 15.8575 13.663C16.3112 13.6242 16.6814 13.2838 16.7581 12.8349L16.9857 11.5016C17.0786 10.9572 16.7126 10.4405 16.1682 10.3476C15.9388 10.3084 15.7143 10.3508 15.5243 10.4536C14.6248 9.55938 13.3866 9.00484 12.0179 9.00003H11.982ZM11.9999 17C13.3964 17 14.5724 16.0449 14.9055 14.7507C15.0431 14.2159 15.5883 13.8939 16.1232 14.0316C16.658 14.1692 16.98 14.7144 16.8423 15.2493C16.2873 17.4056 14.3311 19 11.9999 19C10.6241 19 9.37901 18.4445 8.4755 17.5464C8.28557 17.6492 8.06107 17.6916 7.83165 17.6524C7.28724 17.5595 6.92124 17.0428 7.01418 16.4984L7.24179 15.1651C7.31841 14.7162 7.6886 14.3758 8.14229 14.337C8.59599 14.2982 9.01862 14.5708 9.17037 15.0001C9.58268 16.1666 10.6953 17 11.9999 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera video add-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","add","plus","record","add-video","add-record","new-video","new-record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera rotate": {
        defaultColors: ["#3D4C66"],
        keywords: ["package","rotate","refresh","box","sync","update","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 11.8889L14.8266 12.7778C14.4081 11.7421 13.2791 11 11.952 11C10.5317 11 9.33836 11.8498 9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16.1111L9.17344 15.2222C9.59187 16.2579 10.7209 17 12.048 17C13.4683 17 14.6616 16.1502 15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera video add-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","add","plus","record","new-recording","add-video","add-camera"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera video add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","video","add","new-video","record","plus","security","surveillance","add-footage","footage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 5H10.0706C11.4247 4.99997 12.5413 4.99994 13.4251 5.11875C14.3529 5.2435 15.1723 5.51547 15.8284 6.17158C16.4845 6.82768 16.7565 7.64711 16.8813 8.57494C17.0001 9.4587 17 10.5753 17 11.9294V12.0706C17 13.4247 17.0001 14.5413 16.8813 15.4251C16.7565 16.3529 16.4845 17.1723 15.8284 17.8284C15.1723 18.4845 14.3529 18.7565 13.4251 18.8813C12.5413 19.0001 11.4247 19 10.0706 19H9.92943C8.57531 19 7.4587 19.0001 6.57494 18.8813C5.64711 18.7565 4.82768 18.4845 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11875 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0706V11.9294C2.99997 10.5753 2.99994 9.4587 3.11875 8.57494C3.2435 7.64711 3.51547 6.82768 4.17158 6.17158C4.82768 5.51547 5.64711 5.2435 6.57494 5.11875C7.4587 4.99994 8.57531 4.99997 9.92943 5ZM6.84143 7.10092C6.13538 7.19585 5.80836 7.36322 5.58579 7.58579C5.36322 7.80836 5.19585 8.13538 5.10092 8.84143C5.00213 9.57625 5 10.5575 5 12C5 13.4425 5.00213 14.4238 5.10092 15.1586C5.19585 15.8646 5.36322 16.1916 5.58579 16.4142C5.80836 16.6368 6.13538 16.8042 6.84143 16.8991C7.57625 16.9979 8.55752 17 10 17C11.4425 17 12.4238 16.9979 13.1586 16.8991C13.8646 16.8042 14.1916 16.6368 14.4142 16.4142C14.6368 16.1916 14.8042 15.8646 14.8991 15.1586C14.9979 14.4238 15 13.4425 15 12C15 10.5575 14.9979 9.57625 14.8991 8.84143C14.8042 8.13538 14.6368 7.80836 14.4142 7.58579C14.1916 7.36322 13.8646 7.19585 13.1586 7.10092C12.4238 7.00213 11.4425 7 10 7C8.55752 7 7.57625 7.00213 6.84143 7.10092Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 9C10.5523 9 11 9.44772 11 10V11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H11V14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9V10C9 9.44772 9.44772 9 10 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.9355 9.70451C18.6393 9.80144 18.2316 10.0023 17.553 10.3416L16.4474 10.8944C15.9535 11.1414 15.3528 10.9411 15.1058 10.4472C14.8588 9.95319 15.059 9.35251 15.553 9.10552L16.6586 8.55274C16.6797 8.54218 16.7008 8.53164 16.7218 8.52114C17.3158 8.22404 17.8586 7.95253 18.3135 7.80368C18.7985 7.64499 19.4391 7.53809 20.0517 7.91668C20.6643 8.29528 20.8551 8.91606 20.9301 9.42082C21.0004 9.89426 21.0003 10.5012 21.0002 11.1654C21.0002 11.1889 21.0002 11.2124 21.0002 11.236V12.7639C21.0002 12.7875 21.0002 12.811 21.0002 12.8345C21.0003 13.4987 21.0004 14.1056 20.9301 14.5791C20.8551 15.0838 20.6643 15.7046 20.0517 16.0832C19.4391 16.4618 18.7985 16.3549 18.3135 16.1962C17.8586 16.0474 17.3158 15.7759 16.7218 15.4788C16.7008 15.4683 16.6797 15.4577 16.6586 15.4472L15.553 14.8944C15.059 14.6474 14.8588 14.0467 15.1058 13.5527C15.3528 13.0588 15.9535 12.8585 16.4474 13.1055L17.553 13.6583C18.2316 13.9976 18.6393 14.1985 18.9355 14.2954C18.9403 14.297 18.945 14.2985 18.9496 14.2999C18.9503 14.2952 18.951 14.2903 18.9518 14.2853C18.9976 13.977 19.0002 13.5225 19.0002 12.7639V11.236C19.0002 10.4774 18.9976 10.0229 18.9518 9.71459C18.951 9.70959 18.9503 9.70472 18.9496 9.69996C18.945 9.70142 18.9403 9.70294 18.9355 9.70451Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera video add": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","video","add","plus","record","new-record","new-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera video-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","record","surveillance","security","training","demonstration","tutorial","capture","recording"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.96482 3.13639C8.47647 2.9993 9.06713 2.99962 9.86252 3.00005L12.0001 3.0001C12.5524 3.0001 13.0001 3.44781 13.0001 4.0001C13.0001 4.55238 12.5524 5.0001 12.0001 5.0001H10.0001C9.00574 5.0001 8.70474 5.00869 8.48246 5.06824C7.79228 5.25318 7.25318 5.79227 7.06825 6.48246C7.0336 6.61177 7.0162 6.76772 7.00771 7.07131C7.81459 7.00007 8.7876 7.0001 9.92944 7.00012H10.0706C11.4247 7.00009 12.5413 7.00006 13.4251 7.11888C14.3529 7.24362 15.1723 7.51559 15.8284 8.1717C16.455 8.79825 16.7312 9.57373 16.8635 10.4503C17.4021 10.1814 17.8949 9.94072 18.3133 9.80381C18.7983 9.64511 19.4389 9.53821 20.0515 9.91681C20.6641 10.2954 20.8549 10.9162 20.9299 11.4209C21.0002 11.8944 21.0001 12.5013 21 13.1655V14.8346C21.0001 15.4988 21.0002 16.1058 20.9299 16.5792C20.8549 17.084 20.6641 17.7047 20.0515 18.0833C19.4389 18.4619 18.7983 18.355 18.3133 18.1963C17.8949 18.0594 17.4021 17.8188 16.8635 17.5498C16.7312 18.4265 16.455 19.202 15.8284 19.8286C15.1723 20.4847 14.3529 20.7566 13.4251 20.8814C12.5413 21.0002 11.4247 21.0002 10.0706 21.0001H9.92943C8.57531 21.0002 7.4587 21.0002 6.57494 20.8814C5.64711 20.7566 4.82769 20.4847 4.17158 19.8286C3.51547 19.1724 3.2435 18.353 3.11876 17.4252C2.99994 16.5415 2.99997 15.4248 3 14.0708V13.9295C2.99997 12.5754 2.99994 11.4588 3.11876 10.5751C3.2435 9.64723 3.51547 8.82781 4.17158 8.1717C4.42455 7.91873 4.70179 7.72287 5.00017 7.57053C5.00173 6.91911 5.01662 6.41181 5.13639 5.96482C5.50626 4.58445 6.58445 3.50626 7.96482 3.13639ZM6 14.0002C6 11.7911 7.79083 10.0001 10 10.0001C12.2092 10.0001 14 11.7911 14 14.0002C14 16.2094 12.2091 18.0001 10 18.0001C7.79089 18.0001 6 16.2094 6 14.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera video-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","record","surveillance","security","stream","live","monitor","camera-video","live-stream","video-record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 9C8.34314 9 7 10.3432 7 12.0001C7 13.6569 8.34315 15 10 15C11.6569 15 13 13.6569 13 12.0001C13 10.3432 11.6569 9 10 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera video-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","video","record","security","surveillance","monitor","footage","log","record-incident","capture","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12L17.1056 11.4472C18.4028 10.7986 19.0515 10.4743 19.5257 10.7674C20 11.0605 20 11.7857 20 13.2361V14V14.7639C20 16.2143 20 16.9395 19.5257 17.2326C19.0515 17.5257 18.4028 17.2014 17.1056 16.5528L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12V10V10C4 8.13077 4 7.19615 4.40192 6.5C4.66523 6.04394 5.04394 5.66523 5.5 5.40192C6.19615 5 7.13077 5 9 5H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 11C8.34314 11 7 12.3432 7 14.0001C7 15.6569 8.34315 17 10 17C11.6569 17 13 15.6569 13 14.0001C13 12.3432 11.6569 11 10 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera video-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","camera","record","surveillance","security","proof","evidence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14V13.2361C20 11.7857 20 11.0605 19.5257 10.7674C19.0515 10.4743 18.4028 10.7986 17.1056 11.4472C16.5677 11.7162 16.2987 11.8507 16.1493 12.0923C16 12.334 16 12.6347 16 13.2361V14.7639C16 15.3653 16 15.666 16.1493 15.9077C16.2987 16.1493 16.5677 16.2838 17.1056 16.5528C18.4028 17.2014 19.0515 17.5257 19.5257 17.2326C20 16.9395 20 16.2143 20 14.7639V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V8C6 7.07003 6 6.60504 6.10222 6.22354C6.37962 5.18827 7.18827 4.37962 8.22354 4.10222C8.60504 4 9.07003 4 10 4H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 11C8.34314 11 7 12.3432 7 14.0001C7 15.6569 8.34315 17 10 17C11.6569 17 13 15.6569 13 14.0001C13 12.3432 11.6569 11 10 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera video-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","video","record","security","surveillance","audit","log"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 9C8.34314 9 7 10.3432 7 12.0001C7 13.6569 8.34315 15 10 15C11.6569 15 13 13.6569 13 12.0001C13 10.3432 11.6569 9 10 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera video-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","video","record","surveillance","security","footage","proof-of-purchase","transaction-record","customer-verification","staff-monitoring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 9C8.34314 9 7 10.3432 7 12.0001C7 13.6569 8.34315 15 10 15C11.6569 15 13 13.6569 13 12.0001C13 10.3432 11.6569 9 10 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera video": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","video","record","surveillance","security","monitoring","event-logging","audit","evidence","proof-of-service","transaction-recording","incident-capture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12L17.1056 11.4472C18.4028 10.7986 19.0515 10.4743 19.5257 10.7674C20 11.0605 20 11.7857 20 13.2361V14V14.7639C20 16.2143 20 16.9395 19.5257 17.2326C19.0515 17.5257 18.4028 17.2014 17.1056 16.5528L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12V10V10C4 8.13077 4 7.19615 4.40192 6.5C4.66523 6.04394 5.04394 5.66523 5.5 5.40192C6.19615 5 7.13077 5 9 5H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 11C8.34314 11 7 12.3432 7 14.0001C7 15.6569 8.34315 17 10 17C11.6569 17 13 15.6569 13 14.0001C13 12.3432 11.6569 11 10 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera video-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","video","record","surveillance","security","customer-service","help","call","support","meeting","webinar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0706 5H9.92943C8.57536 4.99997 7.45868 4.99994 6.57494 5.11876C5.64711 5.2435 4.82769 5.51547 4.17158 6.17158C3.51547 6.82769 3.2435 7.64711 3.11876 8.57494C2.99994 9.45868 2.99997 10.5753 3 11.9294V12.0706C2.99997 13.4247 2.99994 14.5413 3.11876 15.4251C3.2435 16.3529 3.51547 17.1723 4.17158 17.8284C4.82769 18.4845 5.64711 18.7565 6.57494 18.8813C7.4587 19.0001 8.57531 19 9.92943 19H10.0706C11.4247 19 12.5413 19.0001 13.4251 18.8813C14.3529 18.7565 15.1723 18.4845 15.8284 17.8284C16.455 17.2019 16.7312 16.4263 16.8635 15.5497C17.4021 15.8186 17.8949 16.0593 18.3133 16.1962C18.7983 16.3549 19.4389 16.4618 20.0515 16.0832C20.6641 15.7046 20.8549 15.0838 20.9299 14.5791C21.0002 14.1056 21.0001 13.4987 21 12.8345V11.1654C21.0001 10.5012 21.0002 9.89427 20.9299 9.42082C20.8549 8.91606 20.6641 8.29529 20.0515 7.91669C19.4389 7.53809 18.7983 7.64499 18.3133 7.80369C17.8949 7.9406 17.4021 8.18128 16.8635 8.4502C16.7312 7.57361 16.455 6.79813 15.8284 6.17158C15.1723 5.51547 14.3529 5.2435 13.4251 5.11876C12.5413 4.99994 11.4247 4.99997 10.0706 5ZM6 12.0001C6 9.79096 7.79083 8 10 8C12.2092 8 14 9.79096 14 12.0001C14 14.2092 12.2091 16 10 16C7.79089 16 6 14.2092 6 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["camera","scan","image","photo","capture","id","identification","verification","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13L9 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L20 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13V12C4 10.1308 4 9.19615 4.40192 8.5C4.66523 8.04394 5.04394 7.66523 5.5 7.40192C6.19615 7 7.13077 7 9 7H9.29289C9.58131 7 9.72553 7 9.85991 6.96169C9.93374 6.94065 10.0049 6.91118 10.072 6.87386C10.1941 6.80592 10.2961 6.70394 10.5 6.5C11.1118 5.88817 11.4178 5.58225 11.7841 5.37843C11.9853 5.26647 12.1988 5.17805 12.4203 5.11492C12.8234 5 13.2561 5 14.1213 5H14.3431C16.8394 5 18.0875 5 18.9225 5.69692C19.0605 5.81213 19.1879 5.93952 19.3031 6.07755C20 6.91245 20 8.16059 20 10.6569V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M5 5H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.51" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","image","photo","scan","capture","product-image","add-image","verify-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 8L6.47059 7.11765C7.02085 6.0859 7.29598 5.57003 7.77101 5.28501C8.24603 5 8.83069 5 10 5V5C11.1693 5 11.754 5 12.229 5.28501C12.704 5.57003 12.9791 6.0859 13.5294 7.11765L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 20L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Camera-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","photo","image","scan","add-photo","product-image","inventory-image","upload-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.05229 7.90196L8.61538 6.84615C9.02312 6.08165 9.22699 5.6994 9.54399 5.44358C9.688 5.32737 9.84744 5.2317 10.0178 5.15932C10.3927 5 10.8259 5 11.6923 5H12.3077C13.1741 5 13.6073 5 13.9822 5.15932C14.1526 5.2317 14.312 5.32737 14.456 5.44358C14.773 5.6994 14.9769 6.08165 15.3846 6.84615L15.9477 7.90196C15.982 7.96633 16 8.03816 16 8.11111C16 8.60203 15.602 9 15.1111 9H8.88889C8.39797 9 8 8.60203 8 8.11111C8 8.03816 8.01796 7.96633 8.05229 7.90196Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 11H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","photo","capture","image","scan","take-photo","add-image","product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.05229 7.90196L6.61538 6.84615C7.02312 6.08165 7.22699 5.6994 7.54399 5.44358C7.688 5.32737 7.84744 5.2317 8.01776 5.15932C8.39265 5 8.82587 5 9.69231 5H10.3077C11.1741 5 11.6073 5 11.9822 5.15932C12.1526 5.2317 12.312 5.32737 12.456 5.44358C12.773 5.6994 12.9769 6.08165 13.3846 6.84615L13.9477 7.90196C13.982 7.96633 14 8.03816 14 8.11111C14 8.60203 13.602 9 13.1111 9H6.88889C6.39797 9 6 8.60203 6 8.11111C6 8.03816 6.01796 7.96633 6.05229 7.90196Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 20L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Camera-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","capture","product-image","add-photo","take-photo","inventory","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5427 4.00015L12.4573 4.00015C13.1734 3.99902 13.8056 3.99801 14.3734 4.2393C14.6288 4.34786 14.868 4.49136 15.084 4.66569C15.5641 5.0531 15.931 5.74352 16.267 6.37588L16.6233 7.04402C16.9091 7.06128 17.1763 7.08531 17.4251 7.11876C18.3529 7.2435 19.1723 7.51547 19.8284 8.17158C20.4845 8.82769 20.7565 9.64711 20.8813 10.5749C21.0001 11.4587 21 12.5753 21 13.9294V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92943C8.57531 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V13.9294C2.99997 12.5753 2.99994 11.4587 3.11876 10.5749C3.2435 9.64711 3.51547 8.82768 4.17158 8.17158C4.82769 7.51547 5.64711 7.2435 6.57494 7.11876C6.82369 7.08531 7.09088 7.06128 7.37663 7.04402L7.8033 6.24379C8.13927 5.61143 8.43591 5.0531 8.91598 4.66569C9.132 4.49136 9.37117 4.34786 9.62664 4.2393C10.1944 3.99801 10.8266 3.99902 11.5427 4.00015ZM10 10C7.79086 10 6 11.7909 6 14C6 16.2091 7.79086 18 10 18C12.2091 18 14 16.2091 14 14C14 11.7909 12.2091 10 10 10ZM18 11C18 11.5523 17.5523 12 17 12H16C15.4477 12 15 11.5523 15 11C15 10.4477 15.4477 10 16 10H17C17.5523 10 18 10.4477 18 11ZM18 14C18 14.5523 17.5523 15 17 15H16C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13H17C17.5523 13 18 13.4477 18 14ZM18 17C18 16.4477 17.5523 16 17 16H16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18H17C17.5523 18 18 17.5523 18 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","scan","image","add-photo","capture","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 8L6.47059 7.11765C7.02085 6.0859 7.29598 5.57003 7.77101 5.28501C8.24603 5 8.83069 5 10 5V5C11.1693 5 11.754 5 12.229 5.28501C12.704 5.57003 12.9791 6.0859 13.5294 7.11765L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M16 20L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Camera-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","capture","scan","add-image","add-photo","take-picture","upload-image","upload-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.63 10.36C20.51 9.46 20.25 8.7 19.65 8.1C19.05 7.5 18.29 7.24 17.39 7.12C16.61 7.02 15.63 7.01 14.45 7L14.05 6.24L13.99 6.12C13.64 5.47 13.37 4.96 12.93 4.6C12.73 4.44 12.51 4.31 12.28 4.21C11.76 4 11.18 4 10.44 4H10.31H9.69H9.56C8.82 4 8.24 4 7.72 4.22C7.49 4.32 7.27 4.45 7.07 4.61C6.63 4.96 6.36 5.48 6.01 6.13L5.95 6.25L5.39 7.31C5.39 7.31 5.35 7.41 5.33 7.45C4.97 7.6 4.64 7.81 4.34 8.1C3.75 8.7 3.49 9.46 3.37 10.36C3.25 11.23 3.25 12.33 3.25 13.7V13.81C3.25 15.18 3.25 16.28 3.37 17.15C3.49 18.05 3.75 18.81 4.35 19.41C4.95 20.01 5.71 20.27 6.61 20.39C7.48 20.51 8.58 20.5 9.95 20.5H14.06C15.43 20.5 16.53 20.51 17.4 20.39C18.3 20.27 19.06 20.01 19.66 19.41C20.26 18.81 20.52 18.05 20.64 17.15C20.76 16.28 20.75 15.18 20.75 13.81V13.7C20.75 12.33 20.75 11.23 20.63 10.36ZM10 17.5C7.93 17.5 6.25 15.82 6.25 13.75C6.25 11.68 7.93 10 10 10C12.07 10 13.75 11.68 13.75 13.75C13.75 15.82 12.07 17.5 10 17.5ZM17 16.5C17 17.05 16.55 17.5 16 17.5C15.45 17.5 15 17.05 15 16.5V11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11V16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","identify","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="12" r="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","scan","identity","capture","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="16" cy="12" r="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","product-scan","capture","take-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.4573 3.99967H11.5427C10.8266 3.99853 10.1944 3.99752 9.62664 4.23881C9.37117 4.34738 9.132 4.49088 8.91598 4.6652C8.43591 5.05261 8.13927 5.61094 7.8033 6.2433L7.37643 7.04391C7.09076 7.06117 6.82363 7.0852 6.57494 7.11863C5.64711 7.24338 4.82769 7.51535 4.17158 8.17145C3.51547 8.82756 3.2435 9.64699 3.11876 10.5748C2.99994 11.4586 2.99997 12.5752 3 13.9292V14.0705C2.99997 15.4246 2.99994 16.5412 3.11876 17.4249C3.2435 18.3528 3.51547 19.1722 4.17158 19.8283C4.82769 20.4844 5.64711 20.7564 6.57494 20.8811C7.4587 20.9999 8.57531 20.9999 9.92943 20.9999H14.0706C15.4247 20.9999 16.5413 20.9999 17.4251 20.8811C18.3529 20.7564 19.1723 20.4844 19.8284 19.8283C20.4845 19.1722 20.7565 18.3528 20.8813 17.4249C21.0001 16.5412 21 15.4246 21 14.0705V13.9293C21 12.5752 21.0001 11.4586 20.8813 10.5748C20.7565 9.64699 20.4845 8.82756 19.8284 8.17145C19.1723 7.51535 18.3529 7.24338 17.4251 7.11863C17.1764 7.0852 16.9092 7.06117 16.6235 7.04391L16.267 6.37539C15.931 5.74303 15.5641 5.05261 15.084 4.6652C14.868 4.49087 14.6288 4.34738 14.3734 4.23881C13.8056 3.99752 13.1734 3.99853 12.4573 3.99967ZM10 9.99988C7.79086 9.99988 6 11.7907 6 13.9999C6 16.209 7.79086 17.9999 10 17.9999C12.2091 17.9999 14 16.209 14 13.9999C14 11.7907 12.2091 9.99988 10 9.99988ZM15.084 10.9999C15.084 9.89531 15.9795 8.99988 17.084 8.99988C18.1886 8.99988 19.084 9.89531 19.084 10.9999C19.084 12.1044 18.1886 12.9999 17.084 12.9999C15.9795 12.9999 15.084 12.1044 15.084 10.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camera","photo","image","capture","scan","id","identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V12C4 10.1308 4 9.19615 4.40192 8.5C4.66523 8.04394 5.04394 7.66523 5.5 7.40192C6.19615 7 7.13077 7 9 7H9.29289C9.58131 7 9.72553 7 9.85991 6.96169C9.93374 6.94065 10.0049 6.91118 10.072 6.87386C10.1941 6.80592 10.2961 6.70394 10.5 6.5C11.1118 5.88817 11.4178 5.58225 11.7841 5.37843C11.9853 5.26647 12.1988 5.17805 12.4203 5.11492C12.8234 5 13.2561 5 14.1213 5H14.3431C16.8394 5 18.0875 5 18.9225 5.69692C19.0605 5.81213 19.1879 5.93952 19.3031 6.07755C20 6.91245 20 8.16059 20 10.6569V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L20 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 5H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.51" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","picture","add-image","add-photo","product-image","product-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","capture","scan","product-image","add-image","item-photo","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","photo","image","scan","capture","add-photo","add-image","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.05229 7.90196L8.61538 6.84615C9.02312 6.08165 9.22699 5.6994 9.54399 5.44358C9.688 5.32737 9.84744 5.2317 10.0178 5.15932C10.3927 5 10.8259 5 11.6923 5H12.3077C13.1741 5 13.6073 5 13.9822 5.15932C14.1526 5.2317 14.312 5.32737 14.456 5.44358C14.773 5.6994 14.9769 6.08165 15.3846 6.84615L15.9477 7.90196C15.982 7.96633 16 8.03816 16 8.11111C16 8.60203 15.602 9 15.1111 9H8.88889C8.39797 9 8 8.60203 8 8.11111C8 8.03816 8.01796 7.96633 8.05229 7.90196Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="12"
                    r="1"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Camera-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["briefcase","case","bag","documents","reports","cash","daily-sales","summaries","banking","finance","accounting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Camera-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","capture","product-image","receipt-scan","id-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V7C6.11438 7 5.17157 7 4.58579 7.58579C4 8.17157 4 9.11438 4 11V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V11C20 9.11438 20 8.17157 19.4142 7.58579C18.8284 7 17.8856 7 16 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 13L9 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L20 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","capture","product-image","camera-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0453 4H11.9548C11.4089 3.99997 10.9269 3.99995 10.5244 4.04072C10.0882 4.08491 9.66439 4.18282 9.25654 4.42753C8.8487 4.67224 8.56286 5.00011 8.31861 5.3642C8.09319 5.7002 7.86645 6.1254 7.60956 6.60714L7.37655 7.04403C7.09084 7.06129 6.82367 7.08532 6.57494 7.11876C5.64711 7.2435 4.82769 7.51547 4.17158 8.17158C3.51547 8.82769 3.2435 9.64711 3.11876 10.5749C2.99994 11.4587 2.99997 12.5753 3 13.9294V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.57531 21 9.92943 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V13.9294C21 12.5753 21.0001 11.4587 20.8813 10.5749C20.7565 9.64711 20.4845 8.82769 19.8284 8.17158C19.1723 7.51547 18.3529 7.2435 17.4251 7.11876C17.1764 7.08532 16.9092 7.06129 16.6235 7.04403L16.3905 6.60713C16.1336 6.1254 15.9069 5.7002 15.6815 5.3642C15.4372 5.00011 15.1514 4.67224 14.7435 4.42753C14.3357 4.18282 13.9119 4.08491 13.4757 4.04072C13.0731 3.99995 12.5912 3.99997 12.0453 4ZM14.3302 7.00003C14.2106 6.78323 14.1128 6.61589 14.0206 6.47843C13.8709 6.25538 13.7817 6.18282 13.7145 6.14251C13.6474 6.10221 13.5413 6.05761 13.2741 6.03054C12.9843 6.00119 12.6047 6.00001 12 6.00001C11.3953 6.00001 11.0157 6.00119 10.726 6.03054C10.4587 6.05761 10.3527 6.10221 10.2855 6.14251C10.2184 6.18282 10.1291 6.25538 9.97948 6.47843C9.88726 6.61589 9.78942 6.78323 9.66989 7.00003H14.3302ZM8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-26": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camera","photo","image","scan","capture","identification","id","verification","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V11C4 9.11438 4 8.17157 4.58579 7.58579C5.10128 7.07029 5.89325 7.00844 7.36091 7.00101C7.76463 6.99897 8.14682 6.81648 8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122C15.8532 6.81648 16.2354 6.99897 16.6391 7.00101C18.1067 7.00844 18.8987 7.07029 19.4142 7.58579C20 8.17157 20 9.11438 20 11V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 13L9 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L20 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","identify","item-identification","product-identification","take-picture","capture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.3614 3.99969L11.5225 3.99988H12.4775L12.6386 3.99969C13.4211 3.99832 14.1165 3.99711 14.7383 4.29597C15.3602 4.59484 15.7936 5.1386 16.2814 5.75049L16.3819 5.87641C16.4429 5.9527 16.5384 6.00037 16.6442 6.00091C17.3691 6.00457 18.018 6.02015 18.5621 6.11879C19.1349 6.22263 19.6746 6.43186 20.1213 6.87856C20.631 7.38822 20.8297 8.01657 20.9179 8.67209C21.0001 9.28376 21.0001 10.0476 21 10.9341L21 11.9999L15.874 11.9999C15.4299 10.2747 13.8638 8.99988 12 8.99988C10.1362 8.99988 8.57006 10.2747 8.12602 11.9999H3L3 10.9341C2.99995 10.0476 2.99991 9.28375 3.08215 8.67209C3.17028 8.01657 3.36902 7.38822 3.87868 6.87856C4.32538 6.43186 4.86509 6.22263 5.43792 6.11879C5.98206 6.02015 6.63092 6.00457 7.35585 6.00091C7.46161 6.00037 7.55713 5.9527 7.61816 5.87641L7.71865 5.75049C8.20641 5.1386 8.63986 4.59484 9.26169 4.29597C9.88352 3.99711 10.5789 3.99832 11.3614 3.99969Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 13.9999L3 15.0657C2.99995 15.9522 2.99991 16.716 3.08215 17.3277C3.17028 17.9832 3.36902 18.6115 3.87868 19.1212C4.38835 19.6309 5.0167 19.8296 5.67221 19.9177C6.28387 20 7.04769 19.9999 7.93417 19.9999H16.0658C16.9523 19.9999 17.7161 20 18.3278 19.9177C18.9833 19.8296 19.6117 19.6309 20.1213 19.1212C20.631 18.6115 20.8297 17.9832 20.9179 17.3277C21.0001 16.716 21.0001 15.9522 21 15.0657L21 13.9999H15.874C15.4299 15.7251 13.8638 16.9999 12 16.9999C10.1362 16.9999 8.57006 15.7251 8.12602 13.9999H3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-25": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["camera","photo","image","scan","take-photo","add-image","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 13L9 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L20 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 7V7C6.11438 7 5.17157 7 4.58579 7.58579C4 8.17157 4 9.11438 4 11V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V11C20 9.11438 20 8.17157 19.4142 7.58579C18.8284 7 17.8856 7 16 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","picture","scan","image","capture","product-image","inventory-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 5H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M20 13V7.90833C20 6.11174 20 5.21344 19.4642 4.6376C19.4315 4.60246 19.3975 4.5685 19.3624 4.5358C18.7866 4 17.8883 4 16.0917 4V4C15.0924 4 14.5927 4 14.1666 4.21584C14.1398 4.22942 14.1133 4.24359 14.0872 4.25835C13.6712 4.49317 13.3941 4.9089 12.8397 5.74038L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera-29": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","scan","id","identification","verification","product","item","capture","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H14C16.8284 7 18.2426 7 19.1213 7.87868C20 8.75736 20 10.1716 20 13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 5H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M20 13V7.90833C20 6.11174 20 5.21344 19.4642 4.6376C19.4315 4.60246 19.3975 4.5685 19.3624 4.5358C18.7866 4 17.8883 4 16.0917 4V4C15.0924 4 14.5927 4 14.1666 4.21584C14.1398 4.22942 14.1133 4.24359 14.0872 4.25835C13.6712 4.49317 13.3941 4.9089 12.8397 5.74038L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","scan","photo","image","capture","product-image","item-image","add-image","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.1461 4.15319C12.6864 3.99918 13.2527 3.9995 14.0012 3.99992L14.4051 3.99996C15.6005 3.99994 16.5865 3.99991 17.3746 4.09416C18.1988 4.19272 18.9371 4.40649 19.5633 4.92919C19.7473 5.08281 19.9172 5.25266 20.0708 5.43669C20.5935 6.06289 20.8072 6.80122 20.9058 7.62541C21.0001 8.41343 21 9.39944 21 10.5948L21 12H15.874C15.4299 10.2748 13.8638 9 12 9C10.1362 9 8.57006 10.2748 8.12602 12H3L3 11.9539C2.99999 11.0585 2.99997 10.3195 3.05433 9.7198C3.11085 9.09611 3.23242 8.52561 3.5359 7.99997C3.88698 7.39189 4.39193 6.88694 5 6.53586C5.52565 6.23238 6.09615 6.11081 6.71984 6.05429C7.31952 5.99994 8.0585 5.99995 8.95396 5.99996L9.2929 5.99997C9.44739 5.99997 9.5245 5.99963 9.58039 5.99662L9.58432 5.9964L9.58725 5.99378C9.62889 5.95639 9.68365 5.9021 9.7929 5.79286L9.87778 5.70791C10.4068 5.17829 10.807 4.77768 11.2979 4.50454C11.5662 4.35525 11.8509 4.23736 12.1461 4.15319Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.0016 14C3.00673 14.9446 3.02831 15.7523 3.11876 16.425C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8812C7.4587 20 8.57531 20 9.92943 20H14.0706C15.4247 20 16.5413 20 17.4251 19.8812C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.425C20.9717 15.7523 20.9933 14.9446 20.9984 14H15.874C15.4299 15.7252 13.8638 17 12 17C10.1362 17 8.57006 15.7252 8.12602 14H3.0016Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 4C4 3.44772 4.44772 3 5 3H7C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H5C4.44772 5 4 4.55228 4 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","image","photo","scan","identity","capture","product","item","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V7C7.07003 7 6.60504 7 6.22354 7.10222C5.18827 7.37962 4.37962 8.18827 4.10222 9.22354C4 9.60504 4 10.07 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 10.07 20 9.60504 19.8978 9.22354C19.6204 8.18827 18.8117 7.37962 17.7765 7.10222C17.395 7 16.93 7 16 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11 13C11 12.4477 11.4477 12 12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","identity","id","verification","capture","take-picture","profile","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.0001 13.0705V7C21.0001 6.77999 21.0066 6.57209 21.0132 6.36103L21.0142 6.32811C21.0209 6.11331 21.0278 5.88441 21.0233 5.66667C21.0146 5.24925 20.9657 4.70819 20.6606 4.22C20.3316 3.69371 19.8147 3.39288 19.2156 3.22471C18.6382 3.06262 17.905 3 17.0001 3H15.8028C14.8097 3 14.0427 3.15251 13.4152 3.5598C12.8418 3.93205 12.4895 4.46191 12.2077 4.88564L12.168 4.9453C11.7287 5.60422 10.9892 6 10.1973 6L7.74526 5.99996C7.05816 5.99964 6.54831 5.9994 6.10294 6.1019C4.61066 6.44535 3.44542 7.61059 3.10198 9.10287C2.99947 9.54824 2.99971 10.0581 3.00004 10.7452L3.00007 13.0706C3.00004 14.4247 3.00001 15.5413 3.11882 16.4251C3.24357 17.3529 3.51554 18.1723 4.17164 18.8284C4.82775 19.4845 5.64718 19.7565 6.57501 19.8812C7.45874 20.0001 8.57533 20 9.9294 20H14.0707C15.4247 20 16.5414 20.0001 17.4251 19.8812C18.353 19.7565 19.1724 19.4845 19.8285 18.8284C20.4846 18.1723 20.7566 17.3529 20.8813 16.4251C21.0001 15.5413 21.0001 14.4246 21.0001 13.0705ZM12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 3C4.44772 3 4 3.44772 4 4C4 4.55228 4.44772 5 5 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","capture","scan","product-scan","item-scan","barcode-scan","qr-code-scan","identification","verify","picture","add-image","add-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V7C7.07003 7 6.60504 7 6.22354 7.10222C5.18827 7.37962 4.37962 8.18827 4.10222 9.22354C4 9.60504 4 10.07 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 10.07 20 9.60504 19.8978 9.22354C19.6204 8.18827 18.8117 7.37962 17.7765 7.10222C17.395 7 16.93 7 16 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M11 13C11 12.4477 11.4477 12 12 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera-30": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camera","photo","picture","image","scan","add-image","add-photo","product-image","inventory-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V10.864C4 10.0608 4 9.65923 4.07643 9.32715C4.33401 8.20794 5.20794 7.33401 6.32715 7.07643C6.65923 7 7.06084 7 7.86405 7H10.1972C11.3235 7 12.3753 6.43712 13 5.5C13.6247 4.56288 14 4 15.8028 4H17C20.5 4 20 5 20 7V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20 7.90833V13M20 13V7C20 5 20.5 4 17 4H15.8028C14 4 13.6247 4.56288 13 5.5C12.3753 6.43712 11.3235 7 10.1972 7H7.86405C7.06084 7 6.65923 7 6.32715 7.07643C5.20794 7.33401 4.33401 8.20794 4.07643 9.32715C4 9.65923 4 10.0608 4 10.864V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 5H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Camera-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camera","photo","image","capture","add-photo","add-image","product-image","take-photo","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 10.07 4 9.60504 4.10222 9.22354C4.37962 8.18827 5.18827 7.37962 6.22354 7.10222C6.50564 7.02663 6.83338 7.00694 7.36102 7.00181C7.76473 6.99788 8.14682 6.81648 8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122C15.8532 6.81648 16.2353 6.99788 16.639 7.00181C17.1666 7.00694 17.4944 7.02663 17.7765 7.10222C18.8117 7.37962 19.6204 8.18827 19.8978 9.22354C20 9.60504 20 10.07 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 13C11 12.4477 11.4477 12 12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Camera-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","barcode","inventory","item","product","take-photo","capture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 13.0004C10 11.8958 10.8954 11.0004 12 11.0004C12.5523 11.0004 13 11.4481 13 12.0004C13 12.5527 12.5523 13.0004 12 13.0004C12 13.5527 11.5523 14.0004 11 14.0004C10.4477 14.0004 10 13.5527 10 13.0004Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3615 4.00018L11.5226 4.00037H12.4776L12.6387 4.00018C13.4212 3.99881 14.1166 3.99759 14.7384 4.29646C15.3602 4.59533 15.7937 5.13909 16.2815 5.75098L16.3819 5.8769C16.4418 5.95167 16.5378 6.00115 16.6488 6.00223C17.1726 6.00732 17.6169 6.02454 18.0354 6.13667C19.4157 6.50654 20.4939 7.58473 20.8638 8.96509C21.0009 9.47675 21.0006 10.0674 21.0001 10.8628L21.0001 13.0709C21.0001 14.4251 21.0002 15.5417 20.8813 16.4254C20.7566 17.3533 20.4846 18.1727 19.8285 18.8288C19.1724 19.4849 18.353 19.7569 17.4252 19.8816C16.5414 20.0004 15.4248 20.0004 14.0707 20.0004H9.92952C8.5754 20.0004 7.45879 20.0004 6.57503 19.8816C5.6472 19.7569 4.82778 19.4849 4.17167 18.8288C3.51556 18.1727 3.24359 17.3533 3.11885 16.4254C3.00003 15.5417 3.00006 14.4251 3.0001 13.0709L3.00005 10.8628C2.99962 10.0674 2.9993 9.47675 3.13639 8.96509C3.50626 7.58473 4.58445 6.50654 5.96482 6.13667C6.3833 6.02454 6.82757 6.00732 7.35139 6.00223C7.46241 6.00115 7.55843 5.95167 7.61825 5.8769L7.71874 5.75098C8.2065 5.13909 8.63995 4.59533 9.26178 4.29646C9.88361 3.99759 10.579 3.99881 11.3615 4.00018ZM8 13.0004C8 10.7912 9.79086 9.00037 12 9.00037C14.2091 9.00037 16 10.7912 16 13.0004C16 15.2095 14.2091 17.0004 12 17.0004C9.79086 17.0004 8 15.2095 8 13.0004ZM10 13.0004C10 11.8958 10.8954 11.0004 12 11.0004C12.5523 11.0004 13 11.4481 13 12.0004C13 12.5527 12.5523 13.0004 12 13.0004C12 13.5527 11.5523 14.0004 11 14.0004C10.4477 14.0004 10 13.5527 10 13.0004Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","capture","scan","product-image","item-image","add-image","update-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M17 11H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","scan","capture","image","product-image","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="10" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M17 11H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 14H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L16 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-click-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","scan","photo","image","capture","take-picture","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L10.4706 7.11765C11.0209 6.0859 11.296 5.57003 11.771 5.28501C12.246 5 12.8307 5 14 5V5C15.1693 5 15.754 5 16.229 5.28501C16.704 5.57003 16.9791 6.0859 17.5294 7.11765L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="14"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 11H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L7 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-click-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","capture","scan","take-photo","product-photo","add-photo","inventory-photo","item-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8L10.4706 7.11765C11.0209 6.0859 11.296 5.57003 11.771 5.28501C12.246 5 12.8307 5 14 5V5C15.1693 5 15.754 5 16.229 5.28501C16.704 5.57003 16.9791 6.0859 17.5294 7.11765L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="14" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 11H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L7 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-click-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","add-image","add-photo","product-image","inventory-image","take-photo","capture","scan","product-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0453 4H13.9548C13.4089 3.99997 12.9269 3.99995 12.5244 4.04072C12.0882 4.08491 11.6644 4.18282 11.2565 4.42753C10.8487 4.67224 10.5629 5.00011 10.3186 5.3642C10.0932 5.7002 9.86645 6.1254 9.60956 6.60714L9.39989 7.00027C8.28138 7.00208 7.34074 7.0158 6.57494 7.11876C5.64711 7.2435 4.82769 7.51547 4.17158 8.17158C3.51547 8.82769 3.2435 9.64711 3.11876 10.5749C2.99994 11.4587 2.99997 12.5753 3 13.9294V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.57531 21 9.92943 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V13.9294C21 12.5753 21.0001 11.4587 20.8813 10.5749C20.7565 9.64711 20.4845 8.82769 19.8284 8.17158C19.5394 7.88252 19.2186 7.66803 18.8709 7.50783L18.3905 6.60713C18.1336 6.1254 17.9069 5.7002 17.6815 5.3642C17.4372 5.00011 17.1514 4.67224 16.7435 4.42753C16.3357 4.18282 15.9119 4.08491 15.4757 4.04072C15.0731 3.99995 14.5912 3.99997 14.0453 4ZM14.0706 7C14.9229 6.99998 15.6811 6.99996 16.3464 7.02958C16.2195 6.79834 16.1169 6.62207 16.0206 6.47843C15.8709 6.25538 15.7817 6.18282 15.7145 6.14251C15.6474 6.10221 15.5413 6.05761 15.2741 6.03054C14.9843 6.00119 14.6047 6.00001 14 6.00001C13.3953 6.00001 13.0157 6.00119 12.726 6.03054C12.4587 6.05761 12.3527 6.10221 12.2855 6.14251C12.2184 6.18282 12.1291 6.25538 11.9795 6.47843C11.8873 6.61588 11.7894 6.78321 11.6699 7H14.0706ZM8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10H7C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H8ZM8 15C8.55229 15 9 14.5523 9 14C9 13.4477 8.55229 13 8 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H8ZM8 16C8.55229 16 9 16.4477 9 17C9 17.5523 8.55229 18 8 18H7C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16H8ZM10 14C10 11.7909 11.7909 10 14 10C16.2091 10 18 11.7909 18 14C18 16.2091 16.2091 18 14 18C11.7909 18 10 16.2091 10 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-click": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","capture","image","scan","barcode","qr-code","identity","verification","product","item","identification","payment","capture-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8L10.4706 7.11765C11.0209 6.0859 11.296 5.57003 11.771 5.28501C12.246 5 12.8307 5 14 5V5C15.1693 5 15.754 5 16.229 5.28501C16.704 5.57003 16.9791 6.0859 17.5294 7.11765L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="14" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 11H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L7 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-rotate-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rotate","arrows","circular","sync","refresh","update","reload","repeat","cycle","exchange","inventory","stock","synchronize","loop","pos","reverse","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-rotate-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["refresh","reload","update","sync","rotate","repeat","circle","arrow","reset","transaction-update","order-sync","price-update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-rotate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","refresh","sync","update","reload","change","process","reprocess"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 5.75C8.54832 5.75 5.7501 8.54822 5.7501 12C5.7501 12.4142 5.41431 12.75 5.0001 12.75C4.58588 12.75 4.2501 12.4142 4.2501 12C4.2501 7.71979 7.71989 4.25 12.0001 4.25C14.6418 4.25 16.9739 5.57144 18.3727 7.58867C18.5277 7.35273 18.8099 7.2146 19.1077 7.25776C19.5176 7.31717 19.8018 7.69765 19.7423 8.10758L19.4525 10.1076C19.402 10.456 19.1158 10.7225 18.7647 10.748C18.4135 10.7736 18.0918 10.5514 17.9914 10.2139C17.2229 7.63172 14.8303 5.75 12.0001 5.75ZM12.0001 8.25C9.92903 8.25 8.2501 9.92893 8.2501 12C8.2501 14.0711 9.92903 15.75 12.0001 15.75C14.0712 15.75 15.7501 14.0711 15.7501 12C15.7501 9.92893 14.0712 8.25 12.0001 8.25ZM18.2501 12C18.2501 15.4518 15.4519 18.25 12.0001 18.25C9.16994 18.25 6.77732 16.3683 6.00882 13.7861C5.90838 13.4486 5.5867 13.2264 5.23553 13.252C4.88435 13.2775 4.59824 13.544 4.54773 13.8924L4.25785 15.8924C4.19844 16.3024 4.48259 16.6828 4.89252 16.7422C5.1903 16.7854 5.47253 16.6473 5.62745 16.4113C7.02634 18.4286 9.35835 19.75 12.0001 19.75C16.2803 19.75 19.7501 16.2802 19.7501 12C19.7501 11.5858 19.4143 11.25 19.0001 11.25C18.5859 11.25 18.2501 11.5858 18.2501 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-rotate-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["sync","refresh","update","rotate","reload","retry","transaction","cycle","repeat","reset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="9" y="9" width="6" height="6" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-rotate-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["refresh","reload","sync","update","rotate","🔄","synchronize","repeat","cycle","loop","circular","reset","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="9" y="9" width="6" height="6" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-rotate-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rotate","refresh","reload","synchronize","update","exchange","redo","revert","recycle","inventory-sync","price-update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="9"
                    y="9"
                    width="6"
                    height="6"
                    rx="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Camera-rotate-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","refresh","reload","cycle","repeat","sync","update","transaction-history","sales-history","history","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.7501 12C5.7501 8.54822 8.54832 5.75 12.0001 5.75C14.8303 5.75 17.2229 7.63172 17.9914 10.2139C18.0918 10.5514 18.4135 10.7736 18.7647 10.748C19.1158 10.7225 19.402 10.456 19.4525 10.1076L19.7423 8.10758C19.8018 7.69765 19.5176 7.31717 19.1077 7.25776C18.8099 7.2146 18.5277 7.35273 18.3727 7.58867C16.9739 5.57144 14.6418 4.25 12.0001 4.25C7.71989 4.25 4.2501 7.71979 4.2501 12C4.2501 12.4142 4.58588 12.75 5.0001 12.75C5.41431 12.75 5.7501 12.4142 5.7501 12ZM19.7501 12C19.7501 11.5858 19.4143 11.25 19.0001 11.25C18.5859 11.25 18.2501 11.5858 18.2501 12C18.2501 15.4518 15.4519 18.25 12.0001 18.25C9.16994 18.25 6.77732 16.3683 6.00882 13.7861C5.90838 13.4486 5.5867 13.2264 5.23553 13.252C4.88435 13.2775 4.59824 13.544 4.54773 13.8924L4.25785 15.8924C4.19844 16.3024 4.48259 16.6828 4.89252 16.7422C5.1903 16.7854 5.47253 16.6473 5.62745 16.4113C7.02634 18.4286 9.35835 19.75 12.0001 19.75C16.2803 19.75 19.7501 16.2802 19.7501 12ZM11.9748 8.25H12.0253C12.4697 8.24999 12.8408 8.24999 13.1454 8.27077C13.4625 8.29241 13.762 8.33905 14.0524 8.45933C14.7262 8.73844 15.2616 9.27379 15.5407 9.94762C15.661 10.238 15.7076 10.5375 15.7292 10.8546C15.75 11.1592 15.75 11.5303 15.75 11.9747V11.9747V12.0253V12.0253C15.75 12.4697 15.75 12.8408 15.7292 13.1454C15.7076 13.4625 15.661 13.762 15.5407 14.0524C15.2616 14.7262 14.7262 15.2616 14.0524 15.5407C13.762 15.661 13.4625 15.7076 13.1454 15.7292C12.8408 15.75 12.4697 15.75 12.0253 15.75H12.0253H11.9747H11.9747C11.5303 15.75 11.1592 15.75 10.8546 15.7292C10.5375 15.7076 10.238 15.661 9.94762 15.5407C9.27379 15.2616 8.73844 14.7262 8.45933 14.0524C8.33905 13.762 8.29241 13.4625 8.27077 13.1454C8.24999 12.8408 8.24999 12.4697 8.25 12.0253V11.9747C8.24999 11.5303 8.24999 11.1592 8.27077 10.8546C8.29241 10.5375 8.33905 10.238 8.45933 9.94762C8.73844 9.27379 9.27379 8.73844 9.94762 8.45933C10.238 8.33905 10.5375 8.29241 10.8546 8.27077C11.1592 8.24999 11.5303 8.24999 11.9748 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-shutter-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["camera","shutter","photo","image","capture","scan","product-image","barcode-scan","qr-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M19 9L12 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L5 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.90186 7.43782L9.40186 13.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 10.4998L18.0981 16.562"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.9019 4.43782L9.40186 10.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 13.4998L11.0981 19.562"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Camera-rotate": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","sync","update","refresh","reload","circular","cycle","repeat","exchange","process","redo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 12C5 8.13401 8.13401 5 12 5C15.171 5 17.8496 7.10851 18.7101 10L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.82898 19 6.15043 16.8915 5.28988 14L5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-shutter-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shutter","camera","settings","configuration","adjust","image","photo","scan","focus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 9L12 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L5 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.90186 7.43782L9.40186 13.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 10.4998L18.0981 16.562"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.9019 4.43782L9.40186 10.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 13.4998L11.0981 19.562"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-shutter-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","shutter","capture","photo","image","scan","barcode","qr-code","product-scan","inventory","filter","adjust","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.8323 5.44562C7.44317 3.92921 9.61307 3 12 3C12.2714 3 12.54 3.01201 12.8052 3.03553L9.67077 8.14894C10.3502 7.73709 11.1474 7.5 12 7.5C12.1358 7.5 12.2702 7.50602 12.4029 7.51779L14.882 3.47133C17.1493 4.23721 19.0119 5.88186 20.0645 8.00004L14.0637 8.00004C14.9138 8.43954 15.6059 9.14211 16.0323 10H20.777C20.9229 10.6433 21 11.3126 21 12C21 13.8198 20.4599 15.5135 19.5312 16.9294L16.4933 11.7526C16.4978 11.8345 16.5 11.917 16.5 12C16.5 12.9098 16.23 13.7566 15.7657 14.4646L18.1677 18.5544C16.5568 20.0708 14.3869 21 12 21C11.7286 21 11.46 20.988 11.1947 20.9645L14.3293 15.851C13.6498 16.2629 12.8526 16.5 12 16.5C11.8642 16.5 11.7298 16.494 11.597 16.4822L9.11799 20.5287C6.85072 19.7628 4.98817 18.1182 3.93554 16L9.93648 16C9.0863 15.5606 8.39416 14.858 7.96778 14L3.22303 14C3.07706 13.3568 3 12.6874 3 12C3 10.1802 3.54012 8.4865 4.46881 7.07054L7.50669 12.2475C7.50225 12.1655 7.5 12.083 7.5 12C7.5 11.0901 7.77002 10.2434 8.23431 9.53542L5.8323 5.44562ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-shutter": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","shutter","aperture","image","photo","capture","scan","scan-item","scan-product","scan-barcode","scan-qr-code","product-image","take-photo","focus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 9L12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.90186 7.43782L9.40186 13.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 10.4998L18.0981 16.562"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.9019 4.43782L9.40186 10.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5981 13.4998L11.0981 19.562"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","slash","disabled","no-image","no-photo","remove-image","remove-photo","camera-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M5 21L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-slash-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","photo","image","disable","blocked","not-allowed","restricted","no-image","camera-off","no-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 21L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","disabled","no-image","image-capture-disabled","no-photo","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L5.70711 21.7071C5.31658 22.0976 4.68342 22.0976 4.29289 21.7071C3.90237 21.3166 3.90237 20.6834 4.29289 20.2929L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9547 4H12.0452H12.0453C12.5912 3.99998 13.073 3.99995 13.4756 4.04073C13.9117 4.08491 14.3356 4.18282 14.7434 4.42753C15.1513 4.67224 15.4371 5.00012 15.6813 5.3642C15.9068 5.7002 16.1335 6.1254 16.3904 6.60713L16.6234 7.04403C16.9091 7.06129 17.1763 7.08532 17.4251 7.11876C17.4374 7.12042 17.4497 7.1221 17.462 7.12381L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L5.70711 21.7071C5.31658 22.0976 4.68342 22.0976 4.29289 21.7071C3.90237 21.3166 3.90237 20.6834 4.29289 20.2929L4.48306 20.1027C4.37556 20.0197 4.27167 19.9285 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V14.0706V13.9294V13.9294C2.99997 12.5753 2.99994 11.4587 3.11876 10.5749C3.2435 9.64711 3.51547 8.82769 4.17158 8.17158C4.82769 7.51547 5.64711 7.2435 6.57494 7.11876C6.82363 7.08532 7.09076 7.0613 7.37644 7.04404L7.60945 6.60714C7.86634 6.1254 8.09308 5.7002 8.3185 5.3642C8.56275 5.00012 8.84859 4.67224 9.25643 4.42753C9.66428 4.18282 10.0881 4.08491 10.5243 4.04073C10.9268 3.99995 11.4087 3.99998 11.9546 4H11.9547ZM8.55382 16.032L14.032 10.5538C13.4365 10.2019 12.7418 10 12 10C9.79086 10 8 11.7909 8 14C8 14.7418 8.20193 15.4365 8.55382 16.032ZM15.9627 13.4515L20.4243 8.98988C20.6705 9.46804 20.8041 10.0007 20.8813 10.5749C21.0001 11.4587 21 12.5753 21 13.9294V13.9294V13.9294V14.0706V14.0706V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92943C9.38915 21 8.88667 21 8.42172 20.9925L11.4515 17.9627C11.6308 17.9873 11.8139 18 12 18C14.2091 18 16 16.2091 16 14C16 13.8139 15.9873 13.6308 15.9627 13.4515Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Camera-slash-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","slash","disabled","no-image","unavailable","blocked","restricted","no-photo","camera-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V7C7.07003 7 6.60504 7 6.22354 7.10222C5.18827 7.37962 4.37962 8.18827 4.10222 9.22354C4 9.60504 4 10.07 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 10.07 20 9.60504 19.8978 9.22354C19.6204 8.18827 18.8117 7.37962 17.7765 7.10222C17.395 7 16.93 7 16 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 20L19 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-slash-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","image","disable","no-image","no-photo","camera-off","image-off","media-unavailable","no-media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V7C7.07003 7 6.60504 7 6.22354 7.10222C5.18827 7.37962 4.37962 8.18827 4.10222 9.22354C4 9.60504 4 10.07 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 10.07 20 9.60504 19.8978 9.22354C19.6204 8.18827 18.8117 7.37962 17.7765 7.10222C17.395 7 16.93 7 16 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M5 20L19 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","disabled","not-allowed","blocked","no-image","no-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 8L8.47059 7.11765C9.02085 6.0859 9.29598 5.57003 9.77101 5.28501C10.246 5 10.8307 5 12 5V5C13.1693 5 13.754 5 14.229 5.28501C14.704 5.57003 14.9791 6.0859 15.5294 7.11765L16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 21L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Camera-slash-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["camera","photo","image","disabled","off","blocked","unavailable","no-photo","image-capture-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7L8.39902 6.50122C8.98912 5.7636 9.28417 5.39479 9.69487 5.19739C10.1056 5 10.5779 5 11.5225 5H12.4775C13.4221 5 13.8944 5 14.3051 5.19739C14.7158 5.39479 15.0109 5.7636 15.601 6.50122L16 7H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13C4 10.1716 4 8.75736 4.87868 7.87868C5.75736 7 7.17157 7 10 7H16C16.93 7 17.395 7 17.7765 7.10222C18.8117 7.37962 19.6204 8.18827 19.8978 9.22354C20 9.60504 20 10.07 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 20L19 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Camera: {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","disabled","off","blocked","unavailable","no-photo","image-capture-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V12C4 10.1308 4 9.19615 4.40192 8.5C4.66523 8.04394 5.04394 7.66523 5.5 7.40192C6.19615 7 7.13077 7 9 7H9.29289C9.58131 7 9.72553 7 9.85991 6.96169C9.93374 6.94065 10.0049 6.91118 10.072 6.87386C10.1941 6.80592 10.2961 6.70394 10.5 6.5C11.1118 5.88817 11.4178 5.58225 11.7841 5.37843C11.9853 5.26647 12.1988 5.17805 12.4203 5.11492C12.8234 5 13.2561 5 14.1213 5H14.3431C16.8394 5 18.0875 5 18.9225 5.69692C19.0605 5.81213 19.1879 5.93952 19.3031 6.07755C20 6.91245 20 8.16059 20 10.6569V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M4 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 5H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.51" strokeLinecap="round" />
            </svg>
        )
    },
    "camp-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["camp","tent","camping","outdoor","lodging","retreat","event","location","venue","temporary","shelter","festival"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13C11.8333 14.3333 11 17.4 9 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 13C12.1667 14.3333 13 17.4 15 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 19H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 19L12 8M14 5L12 8M19 19L12 8M10 5L12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "camp-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camp","tent","outdoor","event","reservation","camping","services","booth","stall","market"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19H5L12 8L19 19Z" fill={colors?.[0] || "#D9D1E0"} />
                <path
                    d="M4 19H20M19 19L12 8M12 8L10 5M12 8L5 19M12 8L14 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 19H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 18.9998H15C13.8645 17.1074 13.2968 16.1612 12.5109 15.9535C12.176 15.8651 11.824 15.8651 11.4891 15.9535C10.7032 16.1612 10.1355 17.1074 9 18.9998Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Camera-slash-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","slash","no-camera","image","photo","disable-camera","blocked","not-allowed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5226 3.99988L11.3615 3.99969C10.579 3.99832 9.88357 3.99711 9.26174 4.29597C8.63992 4.59484 8.20647 5.1386 7.71871 5.75049L7.61822 5.87641L7.48938 6.03746C7.16089 6.05503 6.85613 6.0808 6.57494 6.1186C5.64711 6.24335 4.82769 6.51532 4.17158 7.17142C3.51547 7.82753 3.2435 8.64696 3.11876 9.57479C2.99994 10.4585 2.99997 11.5751 3 12.9292V12.9292V13.0704V13.0705C2.99997 14.4245 2.99994 15.5412 3.11876 16.4249C3.2435 17.3527 3.51547 18.1722 4.17158 18.8283C4.27167 18.9284 4.37557 19.0195 4.48308 19.1026L4.29289 19.2928C3.90237 19.6833 3.90237 20.3165 4.29289 20.707C4.68342 21.0975 5.31658 21.0975 5.70711 20.707L19.7071 6.70698C20.0976 6.31646 20.0976 5.6833 19.7071 5.29277C19.3166 4.90225 18.6834 4.90225 18.2929 5.29277L17.5406 6.04506C17.229 6.00911 16.8826 6.00153 16.4808 6.00008L16.3819 5.87641L16.2814 5.75049C15.7937 5.1386 15.3602 4.59484 14.7384 4.29597C14.1165 3.99711 13.4212 3.99832 12.6387 3.99969L12.4776 3.99988H11.5226ZM14.032 9.5537C13.4365 9.20181 12.7418 8.99988 12 8.99988C9.79086 8.99988 8 10.7907 8 12.9999C8 13.7417 8.20193 14.4363 8.55382 15.0318L14.032 9.5537ZM9.92923 19.9999C9.38904 19.9999 8.88664 19.9999 8.42175 19.9923L11.4515 16.9626C11.6308 16.9872 11.8139 16.9999 12 16.9999C14.2091 16.9999 16 15.209 16 12.9999C16 12.8138 15.9873 12.6307 15.9627 12.4514L20.4458 7.9683C20.6272 8.27591 20.7688 8.61029 20.8637 8.96458C21.0008 9.47623 21.0005 10.0669 21.0001 10.8623L21 13.0704V13.0704V13.0705C21 14.4246 21.0001 15.5412 20.8813 16.4249C20.7565 17.3527 20.4845 18.1722 19.8284 18.8283C19.1723 19.4844 18.3529 19.7564 17.4251 19.8811C16.5413 19.9999 15.4247 19.9999 14.0706 19.9999H9.92943H9.92923Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "camp-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tent","temporary","popup","event","booth","fair","market","outdoor-event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.4453 4.16806C9.90483 3.8617 10.5257 3.98588 10.8321 4.44541L12 6.19733L13.1679 4.44541C13.4743 3.98588 14.0952 3.8617 14.5547 4.16806C15.0142 4.47441 15.1384 5.09528 14.8321 5.55481L13.1934 8.0128L19.5489 18.0001H20C20.5523 18.0001 21 18.4478 21 19.0001C21 19.5524 20.5523 20.0001 20 20.0001H4C3.44772 20.0001 3 19.5524 3 19.0001C3 18.4478 3.44772 18.0001 4 18.0001H4.45105L10.8066 8.0128L9.16795 5.55481C8.8616 5.09528 8.98577 4.47441 9.4453 4.16806ZM12 14.0001C12.1672 14.0001 12.3233 14.0837 12.416 14.2228L14.416 17.2228C14.5183 17.3762 14.5278 17.5735 14.4408 17.7361C14.3538 17.8986 14.1844 18.0001 14 18.0001H10C9.8156 18.0001 9.64617 17.8986 9.55916 17.7361C9.47215 17.5735 9.48169 17.3762 9.58398 17.2228L11.584 14.2228C11.6767 14.0837 11.8328 14.0001 12 14.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "camp-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["tent","camping","outdoor","event","popup","market","booth","stall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 19H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 19L12 8M14 5L12 8M19 19L12 8M10 5L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 18.9998V18.9998C10.1355 17.1074 10.7032 16.1612 11.4891 15.9535C11.824 15.8651 12.176 15.8651 12.5109 15.9535C13.2968 16.1612 13.8645 17.1074 15 18.9998V18.9998"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "camp-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tent","camp","camping","event","outdoor","festival","tourism","reservation","availability","rental","space","booth","vendor","stall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19H5L12 8L19 19Z" fill={colors?.[0] || "#D9D1E0"} />
                <path
                    d="M4 19H20M19 19L12 8M12 8L10 5M12 8L5 19M12 8L14 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 19C11 17.4 11.8333 14.3333 12 13C12.1667 14.3333 13 17.4 15 19H9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 19H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "camp-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["tent","camping","outdoor","unavailable","closed","event","popup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.4453 4.16806C9.90483 3.8617 10.5257 3.98588 10.8321 4.44541L12 6.19733L13.1679 4.44541C13.4743 3.98588 14.0952 3.8617 14.5547 4.16806C15.0142 4.47441 15.1384 5.09528 14.8321 5.55481L13.1934 8.0128L19.5489 18.0001H20C20.5523 18.0001 21 18.4478 21 19.0001C21 19.5524 20.5523 20.0001 20 20.0001H4C3.44772 20.0001 3 19.5524 3 19.0001C3 18.4478 3.44772 18.0001 4 18.0001H4.45105L10.8066 8.0128L9.16795 5.55481C8.8616 5.09528 8.98577 4.47441 9.4453 4.16806ZM12 12.2501C12.3783 12.2501 12.6973 12.5318 12.7443 12.9071C12.88 13.9933 13.5732 15.3982 15.4686 16.9145C15.7173 17.1134 15.8132 17.4478 15.7078 17.7484C15.6023 18.0489 15.3186 18.2501 15 18.2501H9.00004C8.68153 18.2501 8.39775 18.0489 8.29232 17.7484C8.18689 17.4478 8.2828 17.1134 8.53152 16.9145C10.4268 15.3982 11.1201 13.9933 11.2558 12.9071C11.3027 12.5318 11.6218 12.2501 12 12.2501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "camp-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["camp","tent","location","event","outdoor","promotion","special-offer","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18.9998V18.9998C10.1355 17.1074 10.7032 16.1612 11.4891 15.9535C11.824 15.8651 12.176 15.8651 12.5109 15.9535C13.2968 16.1612 13.8645 17.1074 15 18.9998V18.9998"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 19H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 19L12 8M14 5L12 8M19 19L12 8M10 5L12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "camp-fire-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["fire","camp","camping","outdoor","cooking","heat","fireplace","flame","bonfire"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0109 15C14.214 15 16 13.0805 16 10.7126C16 8.58255 15.1135 8.21554 14.6703 7.85825C14.8919 8.33463 15.1947 9.99226 14.0054 10.0019C12.3333 10.0156 12 5.5 12.0109 5C10.1493 6.1433 9.8892 8.45206 10 9.28571L9.019 7.14369C8.22117 7.71534 7.91091 9.28349 8.02172 10.7126C8.02172 13.0805 9.80772 15 12.0109 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M6 20L18 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 20L6 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "camp-fire-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fire","camp","burning","outdoor","cooking","catering","event","warm","heat","flame"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0109 15C14.214 15 16 13.0805 16 10.7126C16 8.58255 15.1135 8.21554 14.6703 7.85825C14.8919 8.33463 15.1947 9.99226 14.0054 10.0019C12.3333 10.0156 12 5.5 12.0109 5C10.1493 6.1433 9.8892 8.45206 10 9.28571L9.019 7.14369C8.22117 7.71534 7.91091 9.28349 8.02172 10.7126C8.02172 13.0805 9.80772 15 12.0109 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M6 20L18 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 20L6 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "camp-fire-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","promotion","sale","hot","special","offer","seasonal","event","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20L11.9803 16L15 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L12 16L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0136 16C14.7675 16 17 13.6966 17 10.8551C17 8.29906 15.8919 7.85864 15.3378 7.42991C15.6149 8.00156 15.9934 9.99071 14.5068 10.0023C12.4167 10.0187 12.4167 4.85714 12.0136 4C9.68659 5.37196 9.3615 8.14247 9.5 9.14286L8.27374 6.57243C7.27646 7.25841 6.88864 9.14019 7.02715 10.8551C7.02715 13.6966 9.25965 16 12.0136 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "camp-fire-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["fire","hot","hazard","restaurant","cook","warn","alert","gas","fuel","energy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20L11.9803 16L15 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L12 16L17 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0136 16C14.7675 16 17 13.6966 17 10.8551C17 8.29906 15.8919 7.85864 15.3378 7.42991C15.6149 8.00156 15.9934 9.99071 14.5068 10.0023C12.4167 10.0187 12.4167 4.85714 12.0136 4C9.68659 5.37196 9.3615 8.14247 9.5 9.14286L8.27374 6.57243C7.27646 7.25841 6.88864 9.14019 7.02715 10.8551C7.02715 13.6966 9.25965 16 12.0136 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "camp-fire-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","camp","campfire","outdoors","cooking","event","promotion","hot","warm","menu-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9488 15.6838C19.1234 16.2077 18.8403 16.7741 18.3163 16.9487L15.1623 18L18.3163 19.0513C18.8402 19.226 19.1234 19.7923 18.9487 20.3163C18.7741 20.8402 18.2077 21.1234 17.6838 20.9487L12.0001 19.0541L6.31631 20.9487C5.79237 21.1234 5.22605 20.8402 5.0514 20.3163C4.87675 19.7923 5.15991 19.226 5.68385 19.0513L8.83778 18L5.6838 16.9487C5.15986 16.7741 4.8767 16.2077 5.05134 15.6838C5.22599 15.1599 5.79231 14.8767 6.31626 15.0513L12.0001 16.9459L17.6839 15.0513C18.2078 14.8767 18.7741 15.1599 18.9488 15.6838Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5085 4.13262C12.826 4.31476 13.0186 4.65579 13.0107 5.02172C13.021 5.17729 13.0503 5.65043 13.0765 5.88194C13.1292 6.34793 13.216 6.91457 13.3484 7.45599C13.4845 8.01232 13.6524 8.47218 13.8367 8.76938C13.8498 8.79043 13.8622 8.8097 13.8741 8.82733C13.87 8.74741 13.8741 8.58203 13.7636 8.28006C13.5675 7.85842 13.6879 7.35721 14.0541 7.07066C14.4204 6.78411 14.9358 6.78785 15.2979 7.0797C15.4699 7.20083 15.9924 7.56999 16.3253 8.05385C16.7481 8.6684 17 9.50792 17 10.7126C17 13.5636 14.833 16 12.0109 16C9.20179 16 7.04173 13.586 7.02191 10.752C6.96408 9.95818 7.01901 9.11251 7.21056 8.35994C7.39697 7.62757 7.75556 6.81879 8.43661 6.33081C8.67941 6.15684 8.98726 6.10052 9.27593 6.17725C9.38324 6.20577 9.48372 6.25157 9.57401 6.31181C9.95148 5.51926 10.5536 4.72149 11.4876 4.14787C11.7995 3.95633 12.1911 3.95047 12.5085 4.13262Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "camp-fire-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["fire","campfire","flame","heat","cooking","outdoor","restaurant","special","promotion","event","seasonal","menu","hot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20L11.9803 16L15 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L12 16L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0136 16C14.7675 16 17 13.6966 17 10.8551C17 8.29906 15.8919 7.85864 15.3378 7.42991C15.6149 8.00156 15.9934 9.99071 14.5068 10.0023C12.4167 10.0187 12.4167 4.85714 12.0136 4C9.68659 5.37196 9.3615 8.14247 9.5 9.14286L8.27374 6.57243C7.27646 7.25841 6.88864 9.14019 7.02715 10.8551C7.02715 13.6966 9.25965 16 12.0136 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "camp-fire-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","promotion","special","event","limited","offer","seasonal","burning","warm","popular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9185 3.57444C12.7987 3.3198 12.5773 3.1274 12.3084 3.04444C12.0395 2.96149 11.7481 2.99566 11.5057 3.13858C10.2639 3.87069 9.50379 4.92618 9.05784 5.95179C8.92557 5.78469 8.74197 5.66257 8.53233 5.60645C8.24969 5.53078 7.94809 5.5827 7.70701 5.74852C6.92212 6.28841 6.48824 7.20293 6.25791 8.07165C6.02328 8.95662 5.95542 9.956 6.02727 10.896C6.04143 13.1122 7.20595 15.0708 8.95618 16.1405L6.62863 17.0715C6.11585 17.2766 5.86643 17.8586 6.07155 18.3714C6.27666 18.8842 6.85863 19.1336 7.37141 18.9285L9.05236 18.2561L8.19817 19.4025C7.8682 19.8454 7.95972 20.4719 8.40259 20.8019C8.84546 21.1319 9.47197 21.0403 9.80195 20.5975L11.9856 17.6667L14.2019 20.6025C14.5347 21.0433 15.1618 21.1309 15.6026 20.7981C16.0434 20.4654 16.1309 19.8383 15.7982 19.3975L14.9317 18.2497L16.6286 18.9285C17.1414 19.1336 17.7234 18.8842 17.9285 18.3714C18.1336 17.8586 17.8842 17.2766 17.3714 17.0715L15.0602 16.147C16.8272 15.0722 18 13.0927 18 10.8551C18 9.42985 17.6891 8.4594 17.1895 7.76227C16.803 7.22295 16.2815 6.86718 16.0484 6.7082C16.0042 6.67804 15.9704 6.65495 15.9498 6.63904C15.5826 6.35491 15.0682 6.36087 14.7077 6.65343C14.3472 6.94599 14.2355 7.4482 14.4379 7.866C14.4589 7.90929 14.512 8.05209 14.5518 8.25973C14.5905 8.46169 14.6048 8.664 14.5886 8.82741C14.5797 8.91651 14.5644 8.97044 14.5536 8.99954C14.5405 9.00099 14.5226 9.00218 14.499 9.00237L14.4964 9.00241C14.4663 9.00304 14.3486 9.00549 14.1471 8.67331C13.9333 8.32071 13.7528 7.77935 13.6035 7.11077C13.4664 6.49692 13.3719 5.85612 13.2856 5.27149L13.2685 5.15549C13.2243 4.8565 13.1802 4.56403 13.1329 4.3169C13.0909 4.09707 13.0286 3.80849 12.9185 3.57444ZM14.581 8.99489C14.5838 8.99411 14.5851 8.99357 14.585 8.99349C14.5849 8.99345 14.5845 8.99353 14.5839 8.99373C14.5832 8.99395 14.5822 8.99433 14.581 8.99489Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "camp-fire": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","campfire","hot","cooking","outdoor","special","promotion","event","seasonal","summer","heat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0109 15C14.214 15 16 13.0805 16 10.7126C16 8.58255 15.1135 8.21554 14.6703 7.85825C14.8919 8.33463 15.1947 9.99226 14.0054 10.0019C12.3333 10.0156 12 5.5 12.0109 5C10.1493 6.1433 9.8892 8.45206 10 9.28571L9.019 7.14369C8.22117 7.71534 7.91091 9.28349 8.02172 10.7126C8.02172 13.0805 9.80772 15 12.0109 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M6 20L18 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 20L6 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "capsule-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["capsule","pill","medicine","pharmacy","prescription","health","medical","item","product","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.51465 9.51465L14.4852 14.4852" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M7.02944 12L9.51472 9.51472L12 7.02944C13.3726 5.65685 15.598 5.65685 16.9706 7.02944C18.3431 8.40202 18.3431 10.6274 16.9706 12L14.4853 14.4853L12 16.9706C10.6274 18.3431 8.40202 18.3431 7.02944 16.9706C5.65685 15.598 5.65685 13.3726 7.02944 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "capsule-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["capsule","pill","medication","pharmacy","health","medical","prescription","drugs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.02944 12L9.51472 9.51472L12 7.02944C13.3726 5.65685 15.598 5.65685 16.9706 7.02944C18.3431 8.40202 18.3431 10.6274 16.9706 12L14.4853 14.4853L12 16.9706C10.6274 18.3431 8.40202 18.3431 7.02944 16.9706C5.65685 15.598 5.65685 13.3726 7.02944 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9.51472 9.51472L7.02944 12C5.65685 13.3726 5.65685 15.598 7.02944 16.9706C8.40202 18.3431 10.6274 18.3431 12 16.9706L14.4853 14.4853M9.51472 9.51472L14.4853 14.4853M9.51472 9.51472L12 7.02944C13.3726 5.65685 15.598 5.65685 16.9706 7.02944C18.3431 8.40202 18.3431 10.6274 16.9706 12L14.4853 14.4853"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4852 14.4853L9.51465 9.51472L11.9999 7.02944C13.3725 5.65685 15.5979 5.65685 16.9705 7.02944C18.3431 8.40202 18.3431 10.6274 16.9705 12L14.4852 14.4853Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "capsule-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["capsule","pill","medicine","prescription","pharmacy","drug","medication","healthcare","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6923 13.864L10.136 10.3076L7.73655 12.7071C6.75449 13.6892 6.75449 15.2814 7.73654 16.2635C8.7186 17.2455 10.3108 17.2455 11.2929 16.2635L13.6923 13.864ZM11.2929 6.32232C13.056 4.55922 15.9146 4.55923 17.6777 6.32233C19.4408 8.08544 19.4408 10.944 17.6777 12.7071L12.7071 17.6777C10.944 19.4408 8.08544 19.4408 6.32233 17.6777C4.55923 15.9146 4.55922 13.056 6.32232 11.2929L11.2929 6.32232Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    camp: {
        defaultColors: ["#3D4C66"],
        keywords: ["capsule","pill","medicine","prescription","pharmacy","drug","medication","healthcare","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13C11.8333 14.3333 11 17.4 9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 13C12.1667 14.3333 13 17.4 15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 19H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 19L12 8M14 5L12 8M19 19L12 8M10 5L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    capsule: {
        defaultColors: ["#3D4C66"],
        keywords: ["capsule","pill","medicine","prescription","pharmacy","drug","medication","healthcare","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.51472 9.51472L7.02944 12C5.65685 13.3726 5.65685 15.598 7.02944 16.9706C8.40202 18.3431 10.6274 18.3431 12 16.9706L14.4853 14.4853M9.51472 9.51472L14.4853 14.4853M9.51472 9.51472L12 7.02944C13.3726 5.65685 15.598 5.65685 16.9706 7.02944C18.3431 8.40202 18.3431 10.6274 16.9706 12L14.4853 14.4853"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "car-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["car","vehicle","delivery","transport","customer","transportation","drive-thru","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.99919 17.0023V18.5017C7.02663 19.3024 6.35565 19.9727 5.49941 20C4.64316 19.9721 3.97272 19.3013 4.00085 18.5006V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17L19.9991 18.5006C20.0273 19.3013 19.3568 19.9721 18.5006 20C17.6444 19.9727 16.9734 19.3024 17.0008 18.5017V17.0023"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.9982 11C15.9982 9.89539 15.1031 9 13.9991 9C12.895 9 12 9.89547 12 11.0001"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 10L19 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10L5 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11H6C5.06812 11 4.60218 11 4.23463 11.1522C3.74458 11.3552 3.35523 11.7446 3.15224 12.2346C3 12.6022 3 13.0681 3 14C3 14.9319 3 15.3978 3.15224 15.7654C3.35523 16.2554 3.74458 16.6448 4.23463 16.8478C4.60218 17 5.06812 17 6 17H18C18.9319 17 19.3978 17 19.7654 16.8478C20.2554 16.6448 20.6448 16.2554 20.8478 15.7654C21 15.3978 21 14.9319 21 14C21 13.0681 21 12.6022 20.8478 12.2346C20.6448 11.7446 20.2554 11.3552 19.7654 11.1522C19.3978 11 18.9319 11 18 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11L18.5571 8.3424C18.291 6.74608 18.158 5.94792 17.5985 5.47396C17.039 5 16.2298 5 14.6115 5H9.38851C7.77017 5 6.961 5 6.4015 5.47396C5.84201 5.94792 5.70899 6.74608 5.44293 8.3424L5 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14.0016H8M18 14H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "car-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["car","delivery","vehicle","transport","shipping","auto"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11L18.5571 8.3424C18.291 6.74608 18.158 5.94792 17.5985 5.47396C17.039 5 16.2298 5 14.6115 5H9.38851C7.77017 5 6.961 5 6.4015 5.47396C5.84201 5.94792 5.70899 6.74608 5.44293 8.3424L5 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.99919 18.5017V17.3021C6.99919 17.1365 6.86501 17.0022 6.69942 17.0021L4.3004 17.0002C4.13456 17.0001 4.00008 17.1346 4.00017 17.3004L4.00085 18.5006C3.97272 19.3013 4.64316 19.9721 5.49941 20C6.35565 19.9727 7.02663 19.3024 6.99919 18.5017Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11.0001C12 12.1047 12.895 13.0002 13.9991 13.0002C15.1031 13.0002 15.9982 12.1046 15.9982 11C15.9982 9.89539 15.1031 9 13.9991 9C12.895 9 12 9.89547 12 11.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9992 18.5017V17.3021C19.9992 17.1365 19.865 17.0022 19.6994 17.0021L17.3004 17.0002C17.1346 17.0001 17.0001 17.1346 17.0002 17.3004L17.0009 18.5006C16.9727 19.3013 17.6432 19.9721 18.4994 20C19.3557 19.9727 20.0266 19.3024 19.9992 18.5017Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11H6C5.06812 11 4.60218 11 4.23463 11.1522C3.74458 11.3552 3.35523 11.7446 3.15224 12.2346C3 12.6022 3 13.0681 3 14C3 14.9319 3 15.3978 3.15224 15.7654C3.35523 16.2554 3.74458 16.6448 4.23463 16.8478C4.60218 17 5.06812 17 6 17H18C18.9319 17 19.3978 17 19.7654 16.8478C20.2554 16.6448 20.6448 16.2554 20.8478 15.7654C21 15.3978 21 14.9319 21 14C21 13.0681 21 12.6022 20.8478 12.2346C20.6448 11.7446 20.2554 11.3552 19.7654 11.1522C19.3978 11 18.9319 11 18 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14.0016H8M18 14H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "car-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["car","vehicle","delivery","transport","drive-thru","curbside","pickup","dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.34187 4.25H14.6584C15.4276 4.24998 16.0739 4.24996 16.5951 4.31503C17.1476 4.38401 17.6505 4.53497 18.0834 4.9017C18.5163 5.26843 18.7479 5.73966 18.9068 6.2733C19.0566 6.7767 19.1628 7.41414 19.2893 8.17298L19.6499 10.3364C19.7864 10.3652 19.9204 10.4046 20.0524 10.4593C20.7262 10.7384 21.2616 11.2738 21.5407 11.9476C21.661 12.238 21.7076 12.5375 21.7292 12.8546C21.75 13.1593 21.75 13.5303 21.75 13.9747V14.0253C21.75 14.4697 21.75 14.8408 21.7292 15.1454C21.7076 15.4625 21.661 15.762 21.5407 16.0524C21.3645 16.4776 21.0863 16.8477 20.7357 17.133C20.7446 17.1881 20.7492 17.2445 20.7492 17.3021V18.4902C20.7842 19.7453 19.7414 20.7108 18.5234 20.7496C18.5072 20.7501 18.4911 20.7501 18.475 20.7496C17.2571 20.7099 16.2152 19.7439 16.2509 18.489L16.2505 17.75H7.74923V18.4902C7.7842 19.7453 6.74144 20.7108 5.52336 20.7496C5.50725 20.7501 5.49113 20.7501 5.47502 20.7496C4.25709 20.7099 3.21517 19.7439 3.25089 18.489L3.25022 17.3008C3.25018 17.2435 3.25474 17.1873 3.26355 17.1324C2.91326 16.8472 2.63535 16.4773 2.45933 16.0524C2.33905 15.762 2.29241 15.4625 2.27077 15.1454C2.24999 14.8408 2.24999 14.4697 2.25 14.0253V13.9748C2.24999 13.5303 2.24999 13.1592 2.27077 12.8546C2.29241 12.5375 2.33905 12.238 2.45933 11.9476C2.73844 11.2738 3.27379 10.7384 3.94762 10.4593C4.07972 10.4046 4.21371 10.3651 4.35039 10.3363L4.71094 8.17299C4.83739 7.41415 4.94361 6.7767 5.09348 6.2733C5.25235 5.73966 5.48393 5.26843 5.91684 4.9017C6.34975 4.53497 6.85264 4.38401 7.40514 4.31503C7.92632 4.24996 8.57261 4.24998 9.34187 4.25ZM11.3535 10.25L5.88546 10.25L6.18285 8.46571C6.31904 7.64855 6.41112 7.10438 6.53112 6.7013C6.64514 6.31829 6.75982 6.15346 6.8864 6.04623C7.01298 5.939 7.19443 5.85298 7.59097 5.80347C8.00829 5.75137 8.5602 5.75001 9.38863 5.75001H14.6116C15.44 5.75001 15.9919 5.75137 16.4093 5.80347C16.8058 5.85298 16.9873 5.939 17.1138 6.04623C17.2404 6.15346 17.3551 6.31829 17.4691 6.7013C17.5891 7.10438 17.6812 7.64855 17.8174 8.46571L18.1148 10.25L16.6447 10.25C16.3183 9.09589 15.2577 8.25 13.9991 8.25C12.7405 8.25 11.6798 9.09593 11.3535 10.25ZM15 14C15 13.4477 15.4477 13 16 13H18C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15H16C15.4477 15 15 14.5523 15 14ZM5 14.0016C5 13.4494 5.44772 13.0016 6 13.0016H8C8.55229 13.0016 9 13.4494 9 14.0016C9 14.5539 8.55229 15.0016 8 15.0016H6C5.44772 15.0016 5 14.5539 5 14.0016Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "car-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["car","vehicle","delivery","transport","shipping","automobile","drive-thru","curbside","car-hop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V17C4.05719 17 3.58579 17 3.29289 16.7071C3 16.4142 3 15.9428 3 15V13C3 12.0572 3 11.5858 3.29289 11.2929C3.58579 11 4.05719 11 5 11H19C19.9428 11 20.4142 11 20.7071 11.2929C21 11.5858 21 12.0572 21 13V15C21 15.9428 21 16.4142 20.7071 16.7071C20.4142 17 19.9428 17 19 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.99815 17.0001L14.9982 16.9997M8.99815 17.0001C8.99815 18.1047 8.10314 19.0002 6.99908 19.0002C5.89502 19.0002 5 18.1048 5 17.0002C5 15.8955 5.89502 15.0001 6.99908 15.0001C8.10314 15.0001 8.99815 15.8955 8.99815 17.0001ZM14.9982 16.9997C14.9982 18.1043 15.8932 19.0002 16.9972 19.0002C18.1013 19.0002 18.9963 18.1046 18.9963 17C18.9963 15.8954 18.1013 15 16.9972 15C15.8932 15 14.9982 15.8951 14.9982 16.9997Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11L16.1875 6.7812C15.6062 5.90927 15.3155 5.4733 14.8733 5.23665C14.4312 5 13.9072 5 12.8593 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 5V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 14H5M21 14H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "car-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["car","vehicle","delivery","transport","automobile","shipping","drive-thru","curbside pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 14H5M21 14H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17V17C4.05719 17 3.58579 17 3.29289 16.7071C3 16.4142 3 15.9428 3 15V13C3 12.0572 3 11.5858 3.29289 11.2929C3.58579 11 4.05719 11 5 11H19C19.9428 11 20.4142 11 20.7071 11.2929C21 11.5858 21 12.0572 21 13V15C21 15.9428 21 16.4142 20.7071 16.7071C20.4142 17 19.9428 17 19 17V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.99817 16.9999L14.9982 16.9995"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17.0002C5 18.1048 5.89502 19.0002 6.99908 19.0002C8.10314 19.0002 8.99815 18.1047 8.99815 17.0001C8.99815 15.8955 8.10314 15.0001 6.99908 15.0001C5.89502 15.0001 5 15.8955 5 17.0002Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.9982 16.9997C14.9982 18.1043 15.8932 19.0002 16.9972 19.0002C18.1013 19.0002 18.9963 18.1046 18.9963 17C18.9963 15.8954 18.1013 15 16.9972 15C15.8932 15 14.9982 15.8951 14.9982 16.9997Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11L16.1875 6.7812C15.6062 5.90927 15.3155 5.4733 14.8733 5.23665C14.4312 5 13.9072 5 12.8593 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "car-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["car","delivery","shipping","vehicle","transport","automobile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11H5C4.05719 11 3.58579 11 3.29289 11.2929C3 11.5858 3 12.0572 3 13V15C3 15.9428 3 16.4142 3.29289 16.7071C3.58579 17 4.05719 17 5 17H19C19.9428 17 20.4142 17 20.7071 16.7071C21 16.4142 21 15.9428 21 15V13C21 12.0572 21 11.5858 20.7071 11.2929C20.4142 11 19.9428 11 19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17.0002C5 18.1048 5.89502 19.0002 6.99908 19.0002C8.10314 19.0002 8.99815 18.1047 8.99815 17.0001C8.99815 15.8955 8.10314 15.0001 6.99908 15.0001C5.89502 15.0001 5 15.8955 5 17.0002Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.9982 16.9997C14.9982 18.1043 15.8932 19.0002 16.9972 19.0002C18.1013 19.0002 18.9963 18.1046 18.9963 17C18.9963 15.8954 18.1013 15 16.9972 15C15.8932 15 14.9982 15.8951 14.9982 16.9997Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M5 17.0002C5 18.1048 5.89502 19.0002 6.99908 19.0002C8.10314 19.0002 8.99815 18.1047 8.99815 17.0001C8.99815 15.8955 8.10314 15.0001 6.99908 15.0001C5.89502 15.0001 5 15.8955 5 17.0002Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.9982 16.9997C14.9982 18.1043 15.8932 19.0002 16.9972 19.0002C18.1013 19.0002 18.9963 18.1046 18.9963 17C18.9963 15.8954 18.1013 15 16.9972 15C15.8932 15 14.9982 15.8951 14.9982 16.9997Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11L16.1875 6.7812C15.6062 5.90927 15.3155 5.4733 14.8733 5.23665C14.4312 5 13.9072 5 12.8593 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 5V11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    car: {
        defaultColors: ["#3D4C66"],
        keywords: ["car","delivery","shipping","vehicle","transport","automobile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11H6C5.06812 11 4.60218 11 4.23463 11.1522C3.74458 11.3552 3.35523 11.7446 3.15224 12.2346C3 12.6022 3 13.0681 3 14C3 14.9319 3 15.3978 3.15224 15.7654C3.35523 16.2554 3.74458 16.6448 4.23463 16.8478C4.60218 17 5.06812 17 6 17H18C18.9319 17 19.3978 17 19.7654 16.8478C20.2554 16.6448 20.6448 16.2554 20.8478 15.7654C21 15.3978 21 14.9319 21 14C21 13.0681 21 12.6022 20.8478 12.2346C20.6448 11.7446 20.2554 11.3552 19.7654 11.1522C19.3978 11 18.9319 11 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 11L18.5571 8.3424C18.291 6.74608 18.158 5.94792 17.5985 5.47396C17.039 5 16.2298 5 14.6115 5H9.38851C7.77017 5 6.961 5 6.4015 5.47396C5.84201 5.94792 5.70899 6.74608 5.44293 8.3424L5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.9982 11C15.9982 9.89539 15.1031 9 13.9991 9C12.895 9 12 9.89547 12 11.0001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14.0016H8M18 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.99919 17.0023V18.5017C7.02663 19.3024 6.35565 19.9727 5.49941 20C4.64316 19.9721 3.97272 19.3013 4.00085 18.5006V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17L19.9991 18.5006C20.0273 19.3013 19.3568 19.9721 18.5006 20C17.6444 19.9727 16.9734 19.3024 17.0008 18.5017V17.0023"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 10L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10L5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-bottom-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","dropdown","select","menu","expand","caret","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.4 11.2L10.4 13.8667C11.1333 14.8444 11.5 15.3333 12 15.3333C12.5 15.3333 12.8667 14.8444 13.6 13.8667L15.6 11.2C16.6472 9.80372 17.1708 9.10557 16.8944 8.55279C16.618 8 15.7454 8 14 8L10 8C8.25464 8 7.38197 8 7.10557 8.55279C6.82918 9.10557 7.35279 9.80372 8.4 11.2Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-bottom-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","down","caret","expand","collapse","more","options","dropdown","menu","scroll-down","show-more","navigation","sort","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.4 11.2L10.4 13.8667C11.1333 14.8444 11.5 15.3333 12 15.3333C12.5 15.3333 12.8667 14.8444 13.6 13.8667L15.6 11.2C16.6472 9.80372 17.1708 9.10557 16.8944 8.55279C16.618 8 15.7454 8 14 8L10 8C8.25464 8 7.38197 8 7.10557 8.55279C6.82918 9.10557 7.35279 9.80372 8.4 11.2Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "car-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["car","delivery","shipping","transport","vehicle","automobile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18.0002C5 19.1048 5.89502 20.0002 6.99908 20.0002C8.10314 20.0002 8.99815 19.1047 8.99815 18.0001C8.99815 16.8955 8.10314 16.0001 6.99908 16.0001C5.89502 16.0001 5 16.8956 5 18.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.9982 17.9997C14.9982 19.1044 15.8932 20.0002 16.9972 20.0002C18.1013 20.0002 18.9963 19.1046 18.9963 18C18.9963 16.8954 18.1013 16 16.9972 16C15.8932 16 14.9982 16.8951 14.9982 17.9997Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.84144 4.25H12.892C13.388 4.24999 13.8108 4.24998 14.1631 4.28282C14.5386 4.31784 14.8877 4.39366 15.2272 4.5754C15.5668 4.75714 15.8236 5.00553 16.061 5.29854C16.2837 5.57346 16.5182 5.92519 16.7934 6.33799L19.402 10.2509C19.6958 10.2534 19.9656 10.2622 20.1972 10.2933C20.5527 10.3411 20.9284 10.4535 21.2374 10.7626C21.5465 11.0716 21.6589 11.4473 21.7067 11.8028C21.7251 11.9395 21.7357 12.0896 21.7418 12.25H19C18.5858 12.25 18.25 12.5858 18.25 13C18.25 13.4142 18.5858 13.75 19 13.75H21.75V12.8495L21.75 15.0447C21.7501 15.4776 21.7501 15.8744 21.7067 16.1972C21.6589 16.5527 21.5465 16.9284 21.2374 17.2374C21.0094 17.4655 20.7451 17.5865 20.4794 17.6534C20.3054 15.8836 18.8134 14.5 16.9972 14.5C15.1483 14.5 13.6349 15.9339 13.5069 17.75H10.4894C10.3612 15.9342 8.84808 14.5001 6.99908 14.5001C5.18325 14.5001 3.6915 15.8832 3.51705 17.6525C3.25254 17.5854 2.98956 17.4644 2.76257 17.2374C2.45355 16.9284 2.3411 16.5527 2.29331 16.1972C2.24991 15.8744 2.24995 15.4776 2.25 15.0448L2.25 13.75H5C5.41421 13.75 5.75 13.4142 5.75 13C5.75 12.5858 5.41421 12.25 5 12.25H2.25824C2.26433 12.0896 2.27492 11.9395 2.29331 11.8028C2.3411 11.4473 2.45355 11.0716 2.76257 10.7626C2.96108 10.5641 3.18712 10.4467 3.41763 10.3754L4.38995 7.45845C4.59872 6.83208 4.77514 6.30275 4.96878 5.88651C5.1746 5.44408 5.4297 5.06018 5.83357 4.76909C6.23745 4.47799 6.68231 4.35738 7.16713 4.30203C7.62322 4.24996 8.18121 4.24998 8.84144 4.25ZM5.04058 10.25H9.25001V5.75H8.88304C8.17005 5.75 7.69828 5.75114 7.33727 5.79235C6.99543 5.83138 6.83054 5.89953 6.71064 5.98595C6.59074 6.07237 6.47394 6.20725 6.32881 6.51921C6.17555 6.84866 6.02529 7.29586 5.79982 7.97226L5.04058 10.25ZM10.75 5.75V10.25H17.5986L15.5634 7.19723C15.2652 6.74985 15.0691 6.45705 14.8955 6.24286C14.7318 6.04074 14.6221 5.95282 14.5195 5.89791C14.4169 5.843 14.2829 5.8005 14.0238 5.77635C13.7494 5.75075 13.3969 5.75 12.8593 5.75H10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "caret-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dropdown","arrow","down","expand","options","menu","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.3861 16.0093C13.0587 16.3348 12.6016 16.6668 11.9685 16.6668C11.3353 16.6668 10.8783 16.3348 10.5509 16.0093C10.2527 15.7128 9.94023 15.296 9.60728 14.8519C9.59438 14.8347 9.58145 14.8175 9.56848 14.8002L7.56848 12.1335C7.55334 12.1133 7.53824 12.0932 7.52319 12.0731C7.03846 11.4269 6.60888 10.8543 6.34628 10.3711C6.07906 9.87936 5.81277 9.1728 6.17963 8.43908C6.54649 7.70536 7.27151 7.49445 7.82522 7.4132C8.36933 7.33336 9.08522 7.33342 9.893 7.3335C9.91807 7.3335 9.94324 7.3335 9.96848 7.3335L13.9685 7.33351C13.9937 7.33351 14.0189 7.3335 14.044 7.3335C14.8517 7.33343 15.5676 7.33336 16.1117 7.4132C16.6655 7.49445 17.3905 7.70536 17.7573 8.43908C18.1242 9.1728 17.8579 9.87936 17.5907 10.3711C17.3281 10.8543 16.8985 11.4269 16.4138 12.0731C16.3987 12.0932 16.3836 12.1133 16.3685 12.1335L14.3685 14.8002C14.3555 14.8175 14.3426 14.8347 14.3297 14.8519C13.9967 15.296 13.6842 15.7128 13.3861 16.0093Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "caret-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["dropdown","menu","expand","collapse","options","select","caret-down","arrow-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.4 11.2L10.4 13.8667C11.1333 14.8444 11.5 15.3333 12 15.3333C12.5 15.3333 12.8667 14.8444 13.6 13.8667L15.6 11.2C16.6472 9.80372 17.1708 9.10557 16.8944 8.55279C16.618 8 15.7454 8 14 8L10 8C8.25464 8 7.38197 8 7.10557 8.55279C6.82918 9.10557 7.35279 9.80372 8.4 11.2Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-left-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","navigation","go-back","caret-left","reverse","undo","left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10C16 8.25464 16 7.38197 15.4472 7.10557C14.8944 6.82918 14.1963 7.35279 12.8 8.4L10.1333 10.4C9.15556 11.1333 8.66667 11.5 8.66667 12C8.66667 12.5 9.15556 12.8667 10.1333 13.6L12.8 15.6C14.1963 16.6472 14.8944 17.1708 15.4472 16.8944C16 16.618 16 15.7454 16 14L16 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","left","return","undo","arrow","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.65756 13.4178C7.33199 13.0904 7 12.6334 7 12.0002C7 11.3671 7.33199 10.91 7.65756 10.5826C7.95401 10.2845 8.37084 9.97197 8.81492 9.63902C8.83213 9.62612 8.84938 9.61319 8.86667 9.60022L11.5333 7.60022C11.5535 7.58507 11.5737 7.56998 11.5937 7.55493C12.2399 7.0702 12.8126 6.64061 13.2958 6.37802C13.7875 6.11079 14.494 5.84451 15.2278 6.21137C15.9615 6.57823 16.1724 7.30325 16.2536 7.85696C16.3335 8.40107 16.3334 9.11696 16.3333 9.92474C16.3333 9.94981 16.3333 9.97497 16.3333 10.0002L16.3333 14.0002C16.3333 14.0255 16.3333 14.0506 16.3333 14.0757C16.3334 14.8835 16.3335 15.5994 16.2536 16.1435C16.1724 16.6972 15.9615 17.4222 15.2278 17.7891C14.494 18.1559 13.7875 17.8897 13.2958 17.6224C12.8126 17.3598 12.2399 16.9302 11.5937 16.4455C11.5737 16.4305 11.5535 16.4154 11.5333 16.4002L8.86667 14.4002C8.84938 14.3873 8.83213 14.3743 8.81491 14.3614C8.37084 14.0285 7.95401 13.716 7.65756 13.4178Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "caret-left-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["back","previous","left","caret","arrow","navigation","return","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8 8.4L10.1333 10.4C9.15556 11.1333 8.66667 11.5 8.66667 12C8.66667 12.5 9.15556 12.8667 10.1333 13.6L12.8 15.6C14.1963 16.6472 14.8944 17.1708 15.4472 16.8944C16 16.618 16 15.7454 16 14L16 10C16 8.25464 16 7.38197 15.4472 7.10557C14.8944 6.82918 14.1963 7.35279 12.8 8.4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","left","arrow","return","undo","navigation","go-back","back-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10C16 8.25464 16 7.38197 15.4472 7.10557C14.8944 6.82918 14.1963 7.35279 12.8 8.4L10.1333 10.4C9.15556 11.1333 8.66667 11.5 8.66667 12C8.66667 12.5 9.15556 12.8667 10.1333 13.6L12.8 15.6C14.1963 16.6472 14.8944 17.1708 15.4472 16.8944C16 16.618 16 15.7454 16 14L16 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-right-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","proceed","continue","play","arrow-right","caret-right","advance","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10C8 8.25464 8 7.38197 8.55279 7.10557C9.10557 6.82918 9.80372 7.35279 11.2 8.4L13.8667 10.4C14.8444 11.1333 15.3333 11.5 15.3333 12C15.3333 12.5 14.8444 12.8667 13.8667 13.6L11.2 15.6C9.80372 16.6472 9.10557 17.1708 8.55279 16.8944C8 16.618 8 15.7454 8 14L8 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-right-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["play","next","continue","proceed","right","arrow","forward","submit","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2 8.4L13.8667 10.4C14.8444 11.1333 15.3333 11.5 15.3333 12C15.3333 12.5 14.8444 12.8667 13.8667 13.6L11.2 15.6C9.80372 16.6472 9.10557 17.1708 8.55279 16.8944C8 16.618 8 15.7454 8 14L8 10C8 8.25464 8 7.38197 8.55279 7.10557C9.10557 6.82918 9.80372 7.35279 11.2 8.4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","next","right","forward","advance","continue","process","order","checkout","arrow","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10C8 8.25464 8 7.38197 8.55279 7.10557C9.10557 6.82918 9.80372 7.35279 11.2 8.4L13.8667 10.4C14.8444 11.1333 15.3333 11.5 15.3333 12C15.3333 12.5 14.8444 12.8667 13.8667 13.6L11.2 15.6C9.80372 16.6472 9.10557 17.1708 8.55279 16.8944C8 16.618 8 15.7454 8 14L8 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-top-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["up","triangle","sort","increase","ascending","move-up","scroll-up","rise","caret","caret-up","navigation-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16C15.7454 16 16.618 16 16.8944 15.4472C17.1708 14.8944 16.6472 14.1963 15.6 12.8L13.6 10.1333C12.8667 9.15556 12.5 8.66667 12 8.66667C11.5 8.66667 11.1333 9.15556 10.4 10.1333L8.4 12.8C7.35279 14.1963 6.82918 14.8944 7.10557 15.4472C7.38197 16 8.25464 16 10 16L14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-top-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow","up","triangle","sort","increase","ascend","go-up","caret","scroll-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.6 12.8L13.6 10.1333C12.8667 9.15556 12.5 8.66667 12 8.66667C11.5 8.66667 11.1333 9.15556 10.4 10.1333L8.4 12.8C7.35279 14.1963 6.82918 14.8944 7.10557 15.4472C7.38197 16 8.25464 16 10 16L14 16C15.7454 16 16.618 16 16.8944 15.4472C17.1708 14.8944 16.6472 14.1963 15.6 12.8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "caret-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["caret","arrow","triangle","up","increase","sort-up","ascending","scroll-up","move-up","quantity-up","price-up","priority-up","raise","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5509 7.99105C10.8783 7.66548 11.3353 7.3335 11.9685 7.3335C12.6016 7.3335 13.0587 7.66549 13.3861 7.99106C13.6842 8.28751 13.9967 8.70434 14.3297 9.14842C14.3426 9.16563 14.3555 9.18288 14.3685 9.20016L16.3685 11.8668C16.3836 11.887 16.3987 11.9072 16.4138 11.9272C16.8985 12.5734 17.3281 13.1461 17.5907 13.6293C17.8579 14.121 18.1242 14.8275 17.7573 15.5613C17.3905 16.295 16.6655 16.5059 16.1117 16.5871C15.5676 16.667 14.8517 16.6669 14.044 16.6668C14.0189 16.6668 13.9937 16.6668 13.9685 16.6668L9.96848 16.6668C9.94324 16.6668 9.91807 16.6668 9.893 16.6668C9.08522 16.6669 8.36933 16.667 7.82522 16.5871C7.27151 16.5059 6.54649 16.295 6.17963 15.5613C5.81277 14.8275 6.07906 14.121 6.34628 13.6293C6.60887 13.1461 7.03846 12.5734 7.52318 11.9272C7.53823 11.9072 7.55333 11.887 7.56849 11.8668L9.56849 9.20016C9.58145 9.18287 9.59439 9.16562 9.60729 9.14841C9.94023 8.70433 10.2527 8.28751 10.5509 7.99105Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "caret-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-up","sort-ascending","increase","move-up","scroll-up","increase-price","higher","go-up","caret-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16C15.7454 16 16.618 16 16.8944 15.4472C17.1708 14.8944 16.6472 14.1963 15.6 12.8L13.6 10.1333C12.8667 9.15556 12.5 8.66667 12 8.66667C11.5 8.66667 11.1333 9.15556 10.4 10.1333L8.4 12.8C7.35279 14.1963 6.82918 14.8944 7.10557 15.4472C7.38197 16 8.25464 16 10 16L14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart Bag-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shopping bag","shopping","bag","cart","checkout","purchase","order","retail","store","products","items","online shopping","ecommerce","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2929 11.7071L9.70711 13.2929C9.31658 13.6834 9.31658 14.3166 9.70711 14.7071L11.2929 16.2929C11.6834 16.6834 12.3166 16.6834 12.7071 16.2929L14.2929 14.7071C14.6834 14.3166 14.6834 13.6834 14.2929 13.2929L12.7071 11.7071C12.3166 11.3166 11.6834 11.3166 11.2929 11.7071Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cart Bag-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping bag","purchase","checkout","cart","shop","shopping","sale","order","retail","pos","tote","handbag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0004 7V7.0294C16.1714 7.04006 16.3334 7.05458 16.4857 7.07436C17.1019 7.15438 17.6935 7.3342 18.1914 7.79235C18.6893 8.25051 18.9177 8.82513 19.0486 9.4326C19.1704 9.99774 19.2293 10.7053 19.2974 11.5226L19.6416 15.6537C19.7212 16.6083 19.7895 17.4264 19.7536 18.0835C19.7154 18.7851 19.5533 19.4674 19.0344 20.0313C18.5155 20.5952 17.849 20.8134 17.153 20.9098C16.5012 21.0001 15.6802 21.0001 14.7223 21H9.27839C8.32049 21.0001 7.4995 21.0001 6.84772 20.9098C6.15174 20.8134 5.48518 20.5952 4.96631 20.0313C4.44745 19.4674 4.28537 18.7851 4.2471 18.0835C4.21126 17.4264 4.27949 16.6083 4.35909 15.6537L4.70335 11.5226C4.7714 10.7053 4.83033 9.99774 4.95213 9.4326C5.08305 8.82513 5.31138 8.25051 5.8093 7.79235C6.30722 7.3342 6.89882 7.15438 7.51506 7.07436C7.66735 7.05458 7.82928 7.04006 8.00036 7.0294V7C8.00036 4.79086 9.79122 3 12.0004 3C14.2095 3 16.0004 4.79086 16.0004 7ZM10.0004 7C10.0004 5.89543 10.8958 5 12.0004 5C13.1049 5 14.0004 5.89543 14.0004 7H10.0004ZM12.6872 12.1609C12.2544 11.9464 11.7463 11.9464 11.3135 12.1609C11.0803 12.2764 10.8847 12.4735 10.7257 12.6337L10.68 12.6796L10.634 12.7254C10.4738 12.8843 10.2768 13.0799 10.1612 13.3131C9.94675 13.7459 9.94675 14.2541 10.1612 14.6869C10.2768 14.9201 10.4738 15.1157 10.634 15.2746L10.68 15.3204L10.7257 15.3663C10.8847 15.5265 11.0803 15.7236 11.3135 15.8392C11.7463 16.0536 12.2544 16.0536 12.6872 15.8392C12.9205 15.7236 13.116 15.5265 13.275 15.3663L13.3207 15.3204L13.3667 15.2746C13.5269 15.1157 13.7239 14.9201 13.8395 14.6869C14.054 14.2541 14.054 13.7459 13.8395 13.3131C13.7239 13.0799 13.5269 12.8843 13.3667 12.7254L13.3207 12.6796L13.275 12.6337C13.116 12.4735 12.9205 12.2764 12.6872 12.1609Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart Bag-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","cart","checkout","purchase","order","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.444 15.4818C12.5911 15.4089 12.7274 15.2726 13 15C13.2726 14.7274 13.4089 14.5911 13.4818 14.444C13.6204 14.1642 13.6204 13.8358 13.4818 13.556C13.4089 13.4089 13.2726 13.2726 13 13C12.7274 12.7274 12.5911 12.5911 12.444 12.5182C12.1642 12.3796 11.8358 12.3796 11.556 12.5182C11.4089 12.5911 11.2726 12.7274 11 13C10.7274 13.2726 10.5911 13.4089 10.5182 13.556C10.3796 13.8358 10.3796 14.1642 10.5182 14.444C10.5911 14.5911 10.7274 14.7274 11 15C11.2726 15.2726 11.4089 15.4089 11.556 15.4818C11.8358 15.6204 12.1642 15.6204 12.444 15.4818Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cart Bag": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","checkout","purchase","cart","retail","sale","order","shopping-bag","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2929 11.7071L9.70711 13.2929C9.31658 13.6834 9.31658 14.3166 9.70711 14.7071L11.2929 16.2929C11.6834 16.6834 12.3166 16.6834 12.7071 16.2929L14.2929 14.7071C14.6834 14.3166 14.6834 13.6834 14.2929 13.2929L12.7071 11.7071C12.3166 11.3166 11.6834 11.3166 11.2929 11.7071Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "caret-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","right","arrow","continue","proceed","advance","navigation","play"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.6754 10.5824C16.001 10.9098 16.333 11.3668 16.333 12C16.333 12.6331 16.001 13.0902 15.6754 13.4176C15.379 13.7157 14.9622 14.0282 14.5181 14.3612C14.5009 14.3741 14.4836 14.387 14.4663 14.4L11.7997 16.4C11.7795 16.4151 11.7594 16.4302 11.7393 16.4453C11.0931 16.93 10.5204 17.3596 10.0372 17.6222C9.54553 17.8894 8.83897 18.1557 8.10525 17.7888C7.37153 17.422 7.16062 16.697 7.07937 16.1432C6.99953 15.5991 6.99959 14.8832 6.99967 14.0755C6.99967 14.0504 6.99967 14.0252 6.99967 14L6.99968 9.99998C6.99968 9.97473 6.99967 9.94957 6.99967 9.92449C6.99959 9.11672 6.99953 8.40083 7.07937 7.85672C7.16062 7.303 7.37153 6.57798 8.10525 6.21112C8.83897 5.84426 9.54553 6.11055 10.0373 6.37778C10.5204 6.64037 11.0931 7.06995 11.7393 7.55468C11.7593 7.56973 11.7795 7.58483 11.7997 7.59998L14.4663 9.59998C14.4836 9.61295 14.5009 9.62588 14.5181 9.63879C14.9622 9.97173 15.379 10.2842 15.6754 10.5824Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart full-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shopping bag","cart","checkout","purchase","order","retail","bag","shopping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart full-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","shopping","cart","bag","purchase","checkout","sale","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4311 3H10.5686C9.29096 2.99997 8.23463 2.99994 7.39347 3.11017C6.50888 3.22609 5.72478 3.47837 5.07938 4.08469C4.43398 4.69102 4.13328 5.45785 3.9624 6.33349C3.79992 7.16615 3.73405 8.22039 3.65439 9.49554L3.39559 13.6363C3.30605 15.0684 3.23242 16.2459 3.30193 17.18C3.37476 18.1588 3.61294 19.031 4.27786 19.7388C4.94278 20.4466 5.79847 20.7387 6.77078 20.8724C7.69869 21.0001 8.87857 21 10.3134 21H13.6862C15.121 21 16.3009 21.0001 17.2289 20.8724C18.2012 20.7387 19.0568 20.4466 19.7218 19.7388C20.3867 19.031 20.6249 18.1588 20.6977 17.18C20.7672 16.246 20.6936 15.0684 20.604 13.6364L20.3452 9.49556C20.2656 8.2204 20.1997 7.16615 20.0372 6.33349C19.8664 5.45785 19.5657 4.69102 18.9203 4.08469C18.2748 3.47837 17.4908 3.22609 16.6062 3.11017C15.765 2.99994 14.7087 2.99997 13.4311 3ZM11.9998 13C14.209 13 15.9998 11.2091 15.9998 9C15.9998 8.44772 15.5521 8 14.9998 8C14.4475 8 13.9998 8.44772 13.9998 9C13.9998 10.1046 13.1044 11 11.9998 11C10.8952 11 9.99982 10.1046 9.99982 9C9.99982 8.44772 9.5521 8 8.99982 8C8.44753 8 7.99982 8.44772 7.99982 9C7.99982 11.2091 9.79068 13 11.9998 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart full-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shopping-bag","bag","shopping","cart","checkout","purchase","order","retail","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart full": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","cart","checkout","purchase","order","buy","sale","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","checkout","order","purchase","basket","store","buy","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 4H7L7.66929 11.3621C7.82635 13.0898 7.90488 13.9537 8.47775 14.4768C9.05062 15 9.91804 15 11.6529 15H14.4689C16.1502 15 16.9909 15 17.558 14.4994C18.1252 13.9987 18.2294 13.1645 18.438 11.4961L18.719 9.24807C18.85 8.20029 18.9155 7.67639 18.6169 7.3382C18.3183 7 17.7904 7 16.7344 7H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","buy","add-to-cart","basket","trolley","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 3.5C4 2.94772 4.44772 2.5 5 2.5H7C7.5172 2.5 7.94907 2.89439 7.99589 3.40946L8.18594 5.5H16.7344C16.7541 5.5 16.7738 5.5 16.7934 5.49999C17.2701 5.4999 17.7269 5.49982 18.0986 5.55197C18.5139 5.61024 18.9934 5.75367 19.3666 6.1764C19.7397 6.59912 19.8226 7.09274 19.8289 7.512C19.8345 7.88732 19.7778 8.34056 19.7186 8.81358C19.7162 8.83306 19.7137 8.85257 19.7113 8.8721L19.4227 11.1804C19.325 11.9631 19.2401 12.6423 19.1011 13.1841C18.9516 13.7672 18.711 14.3154 18.2198 14.749C17.7286 15.1827 17.1548 15.3533 16.5577 15.4294C16.0028 15.5001 15.3183 15.5 14.5296 15.5H11.5907C10.7765 15.5 10.0711 15.5001 9.50123 15.4263C8.88849 15.347 8.30015 15.1689 7.80341 14.7153C7.30668 14.2616 7.076 13.6918 6.94155 13.0888C6.8165 12.5279 6.75269 11.8255 6.67901 11.0145L6.08679 4.5H5C4.44772 4.5 4 4.05228 4 3.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 18.75C7.25 17.5074 8.25736 16.5 9.5 16.5C10.7426 16.5 11.75 17.5074 11.75 18.75C11.75 19.9926 10.7426 21 9.5 21C8.25736 21 7.25 19.9926 7.25 18.75ZM13 18.75C13 17.5074 14.0074 16.5 15.25 16.5C16.4926 16.5 17.5 17.5074 17.5 18.75C17.5 19.9926 16.4926 21 15.25 21C14.0074 21 13 19.9926 13 18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart v2-3": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cart","shopping","checkout","purchase","buy","sale","basket","trolley","order","items","products","add-to-cart","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4689 15H11.6529C9.91804 15 9.05062 15 8.47775 14.4768C7.90488 13.9537 7.82635 13.0898 7.66929 11.3621L7.27273 7H16.7344C17.7904 7 18.3183 7 18.6169 7.3382C18.9155 7.67639 18.85 8.20029 18.719 9.24807L18.438 11.4961C18.2294 13.1645 18.1252 13.9987 17.558 14.4994C16.9909 15 16.1502 15 14.4689 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 4H7L7.66929 11.3621C7.82635 13.0898 7.90488 13.9537 8.47775 14.4768C9.05062 15 9.91804 15 11.6529 15H14.4689C16.1502 15 16.9909 15 17.558 14.4994C18.1252 13.9987 18.2294 13.1645 18.438 11.4961L18.719 9.24807C18.85 8.20029 18.9155 7.67639 18.6169 7.3382C18.3183 7 17.7904 7 16.7344 7H7.27273"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cart","shopping","bag","purchase","checkout","order","items","basket","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","basket","buy","order","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 4H7L7.66929 11.3621C7.82635 13.0898 7.90488 13.9537 8.47775 14.4768C9.05062 15 9.91804 15 11.6529 15H14.4689C16.1502 15 16.9909 15 17.558 14.4994C18.1252 13.9987 18.2294 13.1645 18.438 11.4961L18.719 9.24807C18.85 8.20029 18.9155 7.67639 18.6169 7.3382C18.3183 7 17.7904 7 16.7344 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","bag","shopping-bag","purchase","checkout","order","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5686 3H13.4311C14.7087 2.99997 15.765 2.99994 16.6062 3.11017C17.4908 3.22609 18.2748 3.47837 18.9203 4.0847C19.5657 4.69102 19.8664 5.45785 20.0372 6.33349C20.0779 6.5418 20.1125 6.76397 20.1428 7H3.85687C3.88715 6.76397 3.92175 6.5418 3.9624 6.33349C4.13328 5.45785 4.43398 4.69102 5.07938 4.0847C5.72478 3.47837 6.50888 3.22609 7.39347 3.11017C8.23463 2.99994 9.29097 2.99997 10.5686 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.68561 9H20.314C20.3243 9.16036 20.3346 9.32455 20.3451 9.49259L20.604 13.6364C20.6936 15.0684 20.7672 16.246 20.6977 17.18C20.6249 18.1588 20.3867 19.031 19.7218 19.7388C19.0568 20.4466 18.2012 20.7387 17.2289 20.8724C16.3009 21.0001 15.1211 21 13.6863 21H10.3134C8.87861 21 7.69868 21.0001 6.77078 20.8724C5.79847 20.7387 4.94278 20.4466 4.27786 19.7388C3.61294 19.031 3.37476 18.1588 3.30193 17.18C3.23242 16.2459 3.30605 15.0684 3.39559 13.6363L3.65439 9.49554C3.66495 9.32649 3.67527 9.16129 3.68561 9ZM11.9998 16.5C14.209 16.5 15.9998 14.7091 15.9998 12.5C15.9998 11.9477 15.5521 11.5 14.9998 11.5C14.4475 11.5 13.9998 11.9477 13.9998 12.5C13.9998 13.6046 13.1044 14.5 11.9998 14.5C10.8952 14.5 9.99982 13.6046 9.99982 12.5C9.99982 11.9477 9.5521 11.5 8.99982 11.5C8.44753 11.5 7.99982 11.9477 7.99982 12.5C7.99982 14.7091 9.79068 16.5 11.9998 16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","bag","online","purchase","checkout","store","retail","order","ecommerce","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 8L19 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","order","add-to-cart","basket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 3.25C4.58579 3.25 4.25 3.58579 4.25 4C4.25 4.41421 4.58579 4.75 5 4.75V3.25ZM8 4H8.75C8.75 3.58579 8.41421 3.25 8 3.25V4ZM18.6169 7.3382L18.0546 7.83455L18.6169 7.3382ZM18.438 11.4961L17.6938 11.4031L18.438 11.4961ZM17.558 14.4994L17.0617 13.9371L17.558 14.4994ZM8.58579 14.4142L9.11612 13.8839L8.58579 14.4142ZM5 4.75H8V3.25H5V4.75ZM12 15.75H14.4689V14.25H12V15.75ZM19.1822 11.5892L19.4632 9.3411L17.9748 9.15504L17.6938 11.4031L19.1822 11.5892ZM7.25 4V7H8.75V4H7.25ZM7.25 7V11H8.75V7H7.25ZM16.7344 6.25H8V7.75H16.7344V6.25ZM19.4632 9.3411C19.5259 8.83955 19.5845 8.38489 19.5789 8.01576C19.5731 7.62526 19.4964 7.20116 19.1792 6.84185L18.0546 7.83455C18.055 7.835 18.0542 7.83401 18.0536 7.83292C18.0532 7.83211 18.0553 7.83572 18.0586 7.84679C18.0661 7.87182 18.0774 7.92779 18.0791 8.03832C18.0827 8.27763 18.0431 8.60881 17.9748 9.15504L19.4632 9.3411ZM16.7344 7.75C17.2849 7.75 17.6185 7.75175 17.8555 7.785C17.9649 7.80036 18.0191 7.81852 18.043 7.82905C18.0536 7.83371 18.0569 7.8363 18.0561 7.83576C18.0551 7.83504 18.0542 7.8341 18.0546 7.83455L19.1792 6.84185C18.862 6.48253 18.4506 6.35381 18.0639 6.29955C17.6983 6.24825 17.2399 6.25 16.7344 6.25V7.75ZM14.4689 15.75C15.2898 15.75 15.9765 15.7514 16.5261 15.6814C17.0968 15.6087 17.6151 15.4494 18.0544 15.0616L17.0617 13.9371C16.9339 14.0499 16.7483 14.141 16.3365 14.1934C15.9036 14.2486 15.3293 14.25 14.4689 14.25V15.75ZM17.6938 11.4031C17.5871 12.2569 17.5144 12.8266 17.406 13.2493C17.3029 13.6514 17.1895 13.8242 17.0617 13.9371L18.0544 15.0616C18.4937 14.6738 18.716 14.1792 18.859 13.622C18.9966 13.0853 19.0804 12.4038 19.1822 11.5892L17.6938 11.4031ZM12 14.25C11.036 14.25 10.3884 14.2484 9.90539 14.1835C9.44393 14.1214 9.24643 14.0142 9.11612 13.8839L8.05546 14.9445C8.51093 15.4 9.07773 15.5857 9.70552 15.6701C10.3117 15.7516 11.0784 15.75 12 15.75V14.25ZM7.25 11C7.25 11.9216 7.24841 12.6883 7.32991 13.2945C7.41432 13.9223 7.59999 14.4891 8.05546 14.9445L9.11612 13.8839C8.9858 13.7536 8.87858 13.5561 8.81654 13.0946C8.75159 12.6116 8.75 11.964 8.75 11H7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","buy","order","basket","trolley","e-commerce","add-to-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 3.25C4.58579 3.25 4.25 3.58579 4.25 4C4.25 4.41421 4.58579 4.75 5 4.75V3.25ZM8 4H8.75C8.75 3.58579 8.41421 3.25 8 3.25V4ZM18.6169 7.3382L18.0546 7.83455L18.6169 7.3382ZM18.438 11.4961L17.6938 11.4031L18.438 11.4961ZM17.558 14.4994L17.0617 13.9371L17.558 14.4994ZM8.58579 14.4142L9.11612 13.8839L8.58579 14.4142ZM5 4.75H8V3.25H5V4.75ZM12 15.75H14.4689V14.25H12V15.75ZM19.1822 11.5892L19.4632 9.3411L17.9748 9.15504L17.6938 11.4031L19.1822 11.5892ZM7.25 4V7H8.75V4H7.25ZM7.25 7V11H8.75V7H7.25ZM16.7344 6.25H8V7.75H16.7344V6.25ZM19.4632 9.3411C19.5259 8.83955 19.5845 8.38489 19.5789 8.01576C19.5731 7.62526 19.4964 7.20116 19.1792 6.84185L18.0546 7.83455C18.055 7.835 18.0542 7.83401 18.0536 7.83292C18.0532 7.83211 18.0553 7.83572 18.0586 7.84679C18.0661 7.87182 18.0774 7.92779 18.0791 8.03832C18.0827 8.27763 18.0431 8.60881 17.9748 9.15504L19.4632 9.3411ZM16.7344 7.75C17.2849 7.75 17.6185 7.75175 17.8555 7.785C17.9649 7.80036 18.0191 7.81852 18.043 7.82905C18.0536 7.83371 18.0569 7.8363 18.0561 7.83576C18.0551 7.83504 18.0542 7.8341 18.0546 7.83455L19.1792 6.84185C18.862 6.48253 18.4506 6.35381 18.0639 6.29955C17.6983 6.24825 17.2399 6.25 16.7344 6.25V7.75ZM14.4689 15.75C15.2898 15.75 15.9765 15.7514 16.5261 15.6814C17.0968 15.6087 17.6151 15.4494 18.0544 15.0616L17.0617 13.9371C16.9339 14.0499 16.7483 14.141 16.3365 14.1934C15.9036 14.2486 15.3293 14.25 14.4689 14.25V15.75ZM17.6938 11.4031C17.5871 12.2569 17.5144 12.8266 17.406 13.2493C17.3029 13.6514 17.1895 13.8242 17.0617 13.9371L18.0544 15.0616C18.4937 14.6738 18.716 14.1792 18.859 13.622C18.9966 13.0853 19.0804 12.4038 19.1822 11.5892L17.6938 11.4031ZM12 14.25C11.036 14.25 10.3884 14.2484 9.90539 14.1835C9.44393 14.1214 9.24643 14.0142 9.11612 13.8839L8.05546 14.9445C8.51093 15.4 9.07773 15.5857 9.70552 15.6701C10.3117 15.7516 11.0784 15.75 12 15.75V14.25ZM7.25 11C7.25 11.9216 7.24841 12.6883 7.32991 13.2945C7.41432 13.9223 7.59999 14.4891 8.05546 14.9445L9.11612 13.8839C8.9858 13.7536 8.87858 13.5561 8.81654 13.0946C8.75159 12.6116 8.75 11.964 8.75 11H7.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-6": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","buy","add-to-cart","basket","trolley","store","products","items","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 19.25C7.25 18.0074 8.25736 17 9.5 17C10.7426 17 11.75 18.0074 11.75 19.25C11.75 20.4926 10.7426 21.5 9.5 21.5C8.25736 21.5 7.25 20.4926 7.25 19.25ZM13 19.25C13 18.0074 14.0074 17 15.25 17C16.4926 17 17.5 18.0074 17.5 19.25C17.5 20.4926 16.4926 21.5 15.25 21.5C14.0074 21.5 13 20.4926 13 19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 4C4 3.44772 4.44772 3 5 3H8C8.55228 3 9 3.44772 9 4V6H16.7344C16.7541 6 16.7738 6 16.7934 5.99999C17.2701 5.9999 17.7269 5.99982 18.0986 6.05197C18.5139 6.11024 18.9934 6.25367 19.3666 6.6764C19.7397 7.09912 19.8226 7.59274 19.8289 8.012C19.8345 8.38732 19.7778 8.84056 19.7186 9.31358C19.7162 9.33306 19.7137 9.35257 19.7113 9.3721L19.4227 11.6804C19.325 12.4631 19.2401 13.1423 19.1011 13.6841C18.9516 14.2672 18.711 14.8154 18.2198 15.249C17.7286 15.6827 17.1548 15.8533 16.5577 15.9294C16.0028 16.0001 15.3183 16 14.5296 16H11.9342C11.0477 16.0001 10.2839 16.0001 9.67221 15.9179C9.01669 15.8297 8.38834 15.631 7.87868 15.1213C7.36902 14.6117 7.17027 13.9833 7.08214 13.3278C6.99991 12.7161 6.99995 11.9523 7 11.0658L7 5H5C4.44772 5 4 4.55228 4 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-bag v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","items","order","grocery","retail","sale","tote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.9198 9.67C18.8298 9.01 18.6298 8.39 18.1198 7.88C17.6098 7.37 16.9798 7.17 16.3298 7.08C16.2298 7.07 16.1098 7.06 15.9998 7.05V7C15.9998 4.79 14.2098 3 11.9998 3C9.78984 3 7.99984 4.79 7.99984 7V7.05C7.88984 7.05 7.77984 7.07 7.66984 7.08C7.00984 7.17 6.38984 7.37 5.87984 7.88C5.36984 8.39 5.16984 9.02 5.07984 9.67C5.02984 10.05 5.00984 10.5 4.99984 11H18.9898C18.9898 10.5 18.9698 10.06 18.9198 9.67ZM11.9998 5C13.0998 5 13.9998 5.9 13.9998 7H9.99984C9.99984 5.9 10.8998 5 11.9998 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4398 15.45L19.1298 12.99C19.1298 12.99 19.0398 12.99 18.9998 12.99H4.99984C4.99984 12.99 4.90984 12.99 4.86984 12.99L4.55984 15.45C4.43984 16.44 4.33984 17.28 4.33984 17.96C4.34984 18.68 4.48984 19.39 5.00984 19.98C5.52984 20.57 6.21984 20.8 6.93984 20.9C7.60984 20.99 8.45984 20.99 9.45984 20.99H14.5398C15.5398 20.99 16.3898 20.99 17.0598 20.9C17.7798 20.8 18.4598 20.57 18.9898 19.98C19.5098 19.39 19.6498 18.68 19.6598 17.96C19.6698 17.28 19.5598 16.44 19.4398 15.45Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-7": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cart","shopping","checkout","purchase","buy","order","basket","online-shopping","e-commerce","add-to-cart","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4689 15H12C10.1144 15 9.17157 15 8.58579 14.4142C8 13.8284 8 12.8856 8 11V7H16.7344C17.7904 7 18.3183 7 18.6169 7.3382C18.9155 7.67639 18.85 8.20029 18.719 9.24807L18.438 11.4961C18.2294 13.1645 18.1252 13.9987 17.558 14.4994C16.9909 15 16.1502 15 14.4689 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 3.25C4.58579 3.25 4.25 3.58579 4.25 4C4.25 4.41421 4.58579 4.75 5 4.75V3.25ZM8 4H8.75C8.75 3.58579 8.41421 3.25 8 3.25V4ZM18.438 11.4961L17.6938 11.4031L18.438 11.4961ZM18.719 9.24807L19.4632 9.3411L18.719 9.24807ZM18.6169 7.3382L18.0546 7.83455L18.0546 7.83455L18.6169 7.3382ZM8.58579 14.4142L9.11612 13.8839L9.11612 13.8839L8.58579 14.4142ZM5 4.75H8V3.25H5V4.75ZM12 15.75H14.4689V14.25H12V15.75ZM19.1822 11.5892L19.4632 9.3411L17.9748 9.15504L17.6938 11.4031L19.1822 11.5892ZM7.25 4V7H8.75V4H7.25ZM7.25 7V11H8.75V7H7.25ZM16.7344 6.25H8V7.75H16.7344V6.25ZM19.4632 9.3411C19.5259 8.83955 19.5845 8.38489 19.5789 8.01576C19.5731 7.62526 19.4964 7.20116 19.1792 6.84185L18.0546 7.83455C18.055 7.835 18.0542 7.83401 18.0536 7.83292C18.0532 7.83211 18.0553 7.83572 18.0586 7.84679C18.0661 7.87182 18.0774 7.92779 18.0791 8.03832C18.0827 8.27763 18.0431 8.6088 17.9748 9.15504L19.4632 9.3411ZM16.7344 7.75C17.2849 7.75 17.6185 7.75175 17.8555 7.785C17.9649 7.80036 18.0191 7.81852 18.043 7.82905C18.0536 7.83371 18.0569 7.8363 18.0561 7.83576C18.0551 7.83504 18.0542 7.8341 18.0546 7.83455L19.1792 6.84185C18.862 6.48253 18.4506 6.35381 18.0639 6.29955C17.6983 6.24825 17.2399 6.25 16.7344 6.25V7.75ZM14.4689 15.75C15.2898 15.75 15.9765 15.7514 16.5261 15.6814C17.0968 15.6087 17.6151 15.4494 18.0544 15.0616L17.0617 13.9371C16.9339 14.0499 16.7483 14.141 16.3365 14.1934C15.9036 14.2486 15.3293 14.25 14.4689 14.25V15.75ZM17.6938 11.4031C17.587 12.2569 17.5144 12.8266 17.406 13.2493C17.3029 13.6514 17.1895 13.8242 17.0617 13.9371L18.0544 15.0616C18.4937 14.6738 18.716 14.1792 18.859 13.622C18.9966 13.0853 19.0804 12.4038 19.1822 11.5892L17.6938 11.4031ZM12 14.25C11.036 14.25 10.3884 14.2484 9.90539 14.1835C9.44393 14.1214 9.24643 14.0142 9.11612 13.8839L8.05546 14.9445C8.51093 15.4 9.07773 15.5857 9.70552 15.6701C10.3117 15.7516 11.0784 15.75 12 15.75V14.25ZM7.25 11C7.25 11.9216 7.24841 12.6883 7.32991 13.2945C7.41432 13.9223 7.59999 14.4891 8.05546 14.9445L9.11612 13.8839C8.9858 13.7536 8.87858 13.5561 8.81654 13.0946C8.75159 12.6116 8.75 11.964 8.75 11H7.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Cart-bag v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shopping bag","shopping","bag","purchase","checkout","cart","sale","retail","goods","merchandise","transaction","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12L18.438 15.5039C18.6999 17.5994 18.8309 18.6472 18.2338 19.3236C17.6367 20 16.5807 20 14.4689 20H12H9.53113C7.41925 20 6.36332 20 5.76621 19.3236C5.1691 18.6472 5.30007 17.5994 5.56202 15.5039L6 12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-bag v2-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","shopping","purchase","checkout","cart","sale","retail","order","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12L18.438 15.5039C18.6999 17.5994 18.8309 18.6472 18.2338 19.3236C17.6367 20 16.5807 20 14.4689 20H12H9.53113C7.41925 20 6.36332 20 5.76621 19.3236C5.1691 18.6472 5.30007 17.5994 5.56202 15.5039L6 12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-bag v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping bag","bag","cart","purchase","checkout","sale","order","retail","goods","merchandise","payment","transaction","summary","receipt","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8H14C15.8856 8 16.8284 8 17.4142 8.58579C18 9.17157 18 10.1144 18 12L18.438 15.5039C18.6999 17.5994 18.8309 18.6472 18.2338 19.3236C17.6367 20 16.5807 20 14.4689 20H12H9.53113C7.41925 20 6.36332 20 5.76621 19.3236C5.1691 18.6472 5.30007 17.5994 5.56202 15.5039L6 12C6 10.1144 6 9.17157 6.58579 8.58579C7.17157 8 8.11438 8 10 8H12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-bag v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shopping","bag","cart","purchase","checkout","sale","store","item","product","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V12C5.34199 13.5634 5.51299 14.3451 5.96994 14.9023C6.23241 15.2224 6.55828 15.4847 6.92705 15.6727C7.56906 16 8.36923 16 9.96959 16L14.0304 16C15.6308 16 16.4309 16 17.073 15.6727C17.4417 15.4847 17.7676 15.2224 18.0301 14.9023C18.487 14.3451 18.658 13.5634 19 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 12C5 11.07 5 10.605 5.10222 10.2235C5.37962 9.18827 6.18827 8.37962 7.22354 8.10222C7.60504 8 8.07003 8 9 8H15C15.93 8 16.395 8 16.7765 8.10222C17.8117 8.37962 18.6204 9.18827 18.8978 10.2235C19 10.605 19 11.07 19 12V12L19.157 13.2558C19.5499 16.3991 19.7464 17.9708 18.8507 18.9854C17.955 20 16.3711 20 13.2033 20H10.7967C7.62888 20 6.04498 20 5.14931 18.9854C4.25365 17.9708 4.45011 16.3991 4.84303 13.2558L5 12V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-bag v3-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","order","retail","sale","completed-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9996 3.25C9.60718 3.25 7.62784 5.01877 7.29795 7.31998C7.205 7.33555 7.11573 7.35456 7.02907 7.37778C5.73497 7.72453 4.72417 8.73533 4.37742 10.0294C4.24916 10.5081 4.24934 11.0662 4.24961 11.8842L4.24963 11.9533L4.09118 13.221C3.90088 14.7432 3.74815 15.9649 3.76268 16.9302C3.7777 17.9291 3.97094 18.7842 4.58669 19.4818C5.20245 20.1793 6.02701 20.4771 7.01638 20.6159C7.97241 20.75 9.20355 20.75 10.7376 20.75H10.7377H13.2616H13.2617C14.7957 20.75 16.0269 20.75 16.9829 20.6159C17.9723 20.4771 18.7968 20.1793 19.4126 19.4818C20.0283 18.7842 20.2216 17.9291 20.2366 16.9302C20.2511 15.9649 20.0984 14.7432 19.9081 13.221V13.221L19.7496 11.9533L19.7497 11.8842C19.7499 11.0662 19.7501 10.5081 19.6219 10.0294C19.2751 8.73533 18.2643 7.72453 16.9702 7.37778C16.8835 7.35456 16.7943 7.33555 16.7013 7.31999C16.3714 5.01878 14.3921 3.25 11.9996 3.25ZM15.1154 7.24997L15.1627 7.24996C14.8241 5.81663 13.5364 4.75 11.9996 4.75C10.4629 4.75 9.17521 5.81663 8.83662 7.24996L8.88384 7.24997L8.99964 7.25H14.9996L15.1154 7.24997ZM9.92195 17.75H12.0628H12.0628C12.8352 17.75 13.4621 17.75 13.9744 17.7064C14.5054 17.6611 14.9727 17.5655 15.4133 17.3408C15.8742 17.1058 16.2816 16.778 16.6097 16.3779C16.9233 15.9955 17.1166 15.5595 17.2742 15.0503C17.4263 14.5592 17.5603 13.9468 17.7253 13.1923L17.7253 13.1922L17.7323 13.1603C17.8208 12.7556 17.5646 12.3558 17.1599 12.2673C16.7553 12.1788 16.3555 12.4351 16.267 12.8397C16.0933 13.6339 15.9724 14.1836 15.8414 14.6066C15.7138 15.0185 15.5931 15.2519 15.4498 15.4267C15.2529 15.6668 15.0085 15.8635 14.7319 16.0045C14.5306 16.1072 14.2767 16.1752 13.8471 16.2118C13.4059 16.2494 12.843 16.25 12.0301 16.25H9.92195C9.07909 16.25 8.34995 15.6631 8.16983 14.8397L7.73233 12.8397C7.64382 12.4351 7.24403 12.1788 6.83939 12.2673C6.43474 12.3558 6.17847 12.7556 6.26698 13.1603L6.70448 15.1603C7.03524 16.6723 8.37418 17.75 9.92195 17.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-bag v3-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","shopping","purchase","checkout","cart","sale","retail","items","products","order","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 11.07 5 10.605 5.10222 10.2235C5.37962 9.18827 6.18827 8.37962 7.22354 8.10222C7.60504 8 8.07003 8 9 8H15C15.93 8 16.395 8 16.7765 8.10222C17.8117 8.37962 18.6204 9.18827 18.8978 10.2235C19 10.605 19 11.07 19 12L19.157 13.2558C19.5499 16.3991 19.7464 17.9708 18.8507 18.9854C17.955 20 16.3711 20 13.2033 20H10.7967C7.62888 20 6.04498 20 5.14931 18.9854C4.25365 17.9708 4.45011 16.3991 4.84303 13.2558L5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12L5.4375 14V14C5.69293 15.1677 6.72698 16 7.92229 16L14.0304 16C15.6308 16 16.4309 16 17.073 15.6727C17.4417 15.4847 17.7676 15.2224 18.0301 14.9023C18.487 14.3451 18.658 13.5634 19 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-bag v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","purchase","checkout","cart","shopping-bag","order","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 11.07 5 10.605 5.10222 10.2235C5.37962 9.18827 6.18827 8.37962 7.22354 8.10222C7.60504 8 8.07003 8 9 8H15C15.93 8 16.395 8 16.7765 8.10222C17.8117 8.37962 18.6204 9.18827 18.8978 10.2235C19 10.605 19 11.07 19 12V12L19.157 13.2558C19.5499 16.3991 19.7464 17.9708 18.8507 18.9854C17.955 20 16.3711 20 13.2033 20H10.7967C7.62888 20 6.04498 20 5.14931 18.9854C4.25365 17.9708 4.45011 16.3991 4.84303 13.2558L5 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12V12C5.34199 13.5634 5.51299 14.3451 5.96994 14.9023C6.23241 15.2224 6.55828 15.4847 6.92705 15.6727C7.56906 16 8.36923 16 9.96959 16L14.0304 16C15.6308 16 16.4309 16 17.073 15.6727C17.4417 15.4847 17.7676 15.2224 18.0301 14.9023C18.487 14.3451 18.658 13.5634 19 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cart-bag v4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bag","shopping bag","cart","remove","delete","subtract","decrease","discount","sale","remove-from-cart","empty-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-bag v4-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping-bag","cart","shopping","purchase","remove","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 3C9.52971 3 7.47774 4.79163 7.0727 7.14643C6.30949 7.27427 5.62796 7.5266 5.05209 8.05647C4.41065 8.64668 4.10149 9.39614 3.91656 10.2542C3.74079 11.0698 3.65471 12.1031 3.55068 13.3519L3.53897 13.4924C3.41747 14.9499 3.31765 16.1474 3.3695 17.098C3.42379 18.0933 3.64959 18.9831 4.317 19.7084C4.98442 20.4338 5.85238 20.7327 6.83976 20.8695C7.78273 21.0001 8.98434 21 10.4469 21H13.5533C15.0159 21 16.2175 21.0001 17.1605 20.8695C18.1479 20.7327 19.0158 20.4338 19.6833 19.7084C20.3507 18.9831 20.5765 18.0933 20.6308 17.098C20.6826 16.1474 20.5828 14.95 20.4613 13.4924L20.4613 13.4923L20.4496 13.3519C20.3456 12.1031 20.2595 11.0698 20.0837 10.2542C19.8988 9.39614 19.5896 8.64668 18.9482 8.05647C18.3723 7.5266 17.6908 7.27427 16.9276 7.14643C16.5225 4.79163 14.4706 3 12.0001 3ZM13.5464 7C14.0033 6.99999 14.4315 6.99998 14.8313 7.00517C14.4209 5.83728 13.3083 5 12.0001 5C10.692 5 9.57939 5.83728 9.16902 7.00517C9.56877 6.99998 9.99694 6.99999 10.4539 7H13.5464ZM10.0001 13C9.44784 13 9.00012 13.4477 9.00012 14C9.00012 14.5523 9.44784 15 10.0001 15H14.0001C14.5524 15 15.0001 14.5523 15.0001 14C15.0001 13.4477 14.5524 13 14.0001 13H10.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-bag v4-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","cart","shopping","remove","delete","purchase","checkout","discount","remove-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-bag v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","retail","sale","order","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-Bag v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shopping-bag","bag","shopping","cart","checkout","purchase","order","items","products","sale","happy","customer","complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.79952 16.6224 10.8498 17 12 17C13.1502 17 14.2005 16.6224 15 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag v5-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","bag","shopping","checkout","purchase","order","tote","retail","sale","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 3C9.52971 3 7.47774 4.79163 7.0727 7.14643C6.30949 7.27427 5.62796 7.5266 5.05209 8.05647C4.41065 8.64668 4.10149 9.39614 3.91656 10.2542C3.74079 11.0698 3.65471 12.1031 3.55068 13.3519L3.53897 13.4924C3.41747 14.9499 3.31765 16.1474 3.3695 17.098C3.42379 18.0933 3.64959 18.9831 4.317 19.7084C4.98442 20.4338 5.85238 20.7327 6.83976 20.8695C7.78273 21.0001 8.98434 21 10.4469 21H13.5533C15.0159 21 16.2175 21.0001 17.1605 20.8695C18.1479 20.7327 19.0158 20.4338 19.6833 19.7084C20.3507 18.9831 20.5765 18.0933 20.6308 17.098C20.6826 16.1474 20.5828 14.95 20.4613 13.4924L20.4496 13.3519C20.3456 12.1031 20.2595 11.0698 20.0837 10.2542C19.8988 9.39614 19.5896 8.64668 18.9482 8.05647C18.3723 7.5266 17.6908 7.27427 16.9276 7.14643C16.5225 4.79163 14.4706 3 12.0001 3ZM13.5464 7C14.0033 6.99999 14.4315 6.99998 14.8313 7.00517C14.4209 5.83728 13.3083 5 12.0001 5C10.692 5 9.57939 5.83728 9.16902 7.00517C9.56877 6.99998 9.99694 6.99999 10.4539 7H13.5464ZM10.0001 12C10.0001 11.4477 9.55239 11 9.00011 11C8.44782 11 8.00011 11.4477 8.00011 12V13C8.00011 13.5523 8.44782 14 9.00011 14C9.55239 14 10.0001 13.5523 10.0001 13V12ZM16.0001 12C16.0001 11.4477 15.5524 11 15.0001 11C14.4478 11 14.0001 11.4477 14.0001 12V13C14.0001 13.5523 14.4478 14 15.0001 14C15.5524 14 16.0001 13.5523 16.0001 13V12ZM9.61436 15.2109C9.17855 14.8716 8.55024 14.9499 8.211 15.3857C7.87176 15.8216 7.95004 16.4499 8.38585 16.7891C9.36413 17.5506 10.6314 18 12.0001 18C13.3688 18 14.6361 17.5506 15.6144 16.7891C16.0502 16.4499 16.1285 15.8216 15.7892 15.3857C15.45 14.9499 14.8217 14.8716 14.3859 15.2109C13.7651 15.6941 12.9319 16 12.0001 16C11.0683 16 10.2351 15.6941 9.61436 15.2109Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Bag v5-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","tote","retail","sale","order","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.79952 16.6224 10.8498 17 12 17C13.1502 17 14.2005 16.6224 15 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","cart","purchase","buy","checkout","success","happy","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.79952 16.6224 10.8498 17 12 17C13.1502 17 14.2005 16.6224 15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag v6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping bag","cart","purchase","checkout","order","sale","items","products","summary","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4.60196 12.5725C4.79071 9.93005 4.88508 8.60882 5.749 7.80441C6.61292 7 7.93752 7 10.5867 7H13.4133C16.0625 7 17.3871 7 18.251 7.80441C19.1149 8.60882 19.2093 9.93005 19.398 12.5725L19.5409 14.5725C19.756 17.5833 19.8635 19.0887 18.9737 20.0444C18.0838 21 16.5746 21 13.5561 21H10.4439C7.42539 21 5.91616 21 5.02634 20.0444C4.13652 19.0887 4.24405 17.5833 4.45911 14.5725L4.60196 12.5725Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 9V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag v6-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","order","summary","items","basket","sale","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 2C9.52702 2 7.47332 3.79545 7.07136 6.15396C6.31394 6.28534 5.63769 6.54175 5.06763 7.07255C4.4239 7.67194 4.11951 8.43131 3.94253 9.29944C3.84272 9.789 3.77586 10.3559 3.71914 11H20.281C20.2243 10.3559 20.1574 9.789 20.0576 9.29944C19.8806 8.43131 19.5763 7.67194 18.9325 7.07255C18.3625 6.54175 17.6862 6.28534 16.9288 6.15396C16.5268 3.79545 14.4731 2 12.0001 2ZM13.4809 6C13.9627 5.99999 14.4127 5.99997 14.8315 6.00596C14.4213 4.83765 13.3085 4 12.0001 4C10.6916 4 9.57884 4.83765 9.16869 6.00596C9.58742 5.99997 10.0375 5.99999 10.5192 6H13.4809Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.4312 13H3.56896L3.45649 14.5746C3.35338 16.0176 3.26863 17.2037 3.33064 18.1449C3.3956 19.1308 3.62854 20.0105 4.29456 20.7258C4.96058 21.4411 5.82151 21.7361 6.80027 21.8712C7.73461 22.0001 8.92377 22 10.3704 22H13.6297C15.0764 22 16.2656 22.0001 17.1999 21.8712C18.1786 21.7361 19.0396 21.4411 19.7056 20.7258C20.3716 20.0105 20.6046 19.1308 20.6695 18.1449C20.7315 17.2037 20.6468 16.0176 20.5437 14.5747L20.4312 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Bag v6-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","sale","retail","order","items","products","transaction","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.60196 12.5725C4.79071 9.93005 4.88508 8.60882 5.749 7.80441C6.61292 7 7.93752 7 10.5867 7H13.4133C16.0625 7 17.3871 7 18.251 7.80441C19.1149 8.60882 19.2093 9.93005 19.398 12.5725L19.5409 14.5725C19.756 17.5833 19.8635 19.0887 18.9737 20.0444C18.0838 21 16.5746 21 13.5561 21H10.4439C7.42539 21 5.91616 21 5.02634 20.0444C4.13652 19.0887 4.24405 17.5833 4.45911 14.5725L4.60196 12.5725Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 9V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-Bag v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","cart","purchase","checkout","order","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.60196 12.5725C4.79071 9.93005 4.88508 8.60882 5.749 7.80441C6.61292 7 7.93752 7 10.5867 7H13.4133C16.0625 7 17.3871 7 18.251 7.80441C19.1149 8.60882 19.2093 9.93005 19.398 12.5725L19.5409 14.5725C19.756 17.5833 19.8635 19.0887 18.9737 20.0444C18.0838 21 16.5746 21 13.5561 21H10.4439C7.42539 21 5.91616 21 5.02634 20.0444C4.13652 19.0887 4.24405 17.5833 4.45911 14.5725L4.60196 12.5725Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 9V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-Bag-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","order","items","products","retail","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12L6.48249 12.9899C7.23334 13.4912 7.60877 13.7419 8.0344 13.871C8.46003 14 8.91146 14 9.81432 14H14.1851C15.0877 14 15.539 14 15.9645 13.871C16.39 13.7421 16.7653 13.4915 17.516 12.9905L19 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","order","products","items","sale","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9276 7.14643C17.6908 7.27427 18.3723 7.5266 18.9482 8.05647C19.5896 8.64668 19.8988 9.39614 20.0837 10.2542C20.2595 11.0698 20.3456 12.1031 20.4496 13.3519L20.4613 13.4924C20.5828 14.95 20.6826 16.1474 20.6308 17.098C20.5765 18.0933 20.3507 18.9831 19.6833 19.7084C19.0158 20.4338 18.1479 20.7327 17.1605 20.8695C16.2175 21.0001 15.0159 21 13.5533 21H10.447C8.98435 21 7.78273 21.0001 6.83976 20.8695C5.85238 20.7327 4.98442 20.4338 4.317 19.7084C3.64959 18.9831 3.42379 18.0933 3.3695 17.098C3.31765 16.1474 3.41747 14.9499 3.53897 13.4924L3.55068 13.3519C3.65471 12.1031 3.74079 11.0698 3.91656 10.2542C4.10149 9.39614 4.41065 8.64668 5.05209 8.05647C5.62796 7.5266 6.30949 7.27427 7.0727 7.14643C7.47774 4.79163 9.52971 3 12.0001 3C14.4706 3 16.5225 4.79163 16.9276 7.14643ZM9.16902 7.00517C9.56876 6.99998 9.99694 6.99999 10.4539 7H13.5464C14.0033 6.99999 14.4315 6.99998 14.8313 7.00517C14.4209 5.83728 13.3083 5 12.0001 5C10.692 5 9.57939 5.83728 9.16902 7.00517ZM7.51229 13.4521C7.2097 13.1693 6.7351 13.1852 6.45224 13.4878C6.16937 13.7904 6.18536 14.265 6.48796 14.5479L6.99696 15.0238C7.75485 15.7329 8.28144 16.2256 8.94695 16.4882C9.61245 16.7508 10.3336 16.7505 11.3715 16.75H12.6285C13.6662 16.7505 14.3871 16.7508 15.0525 16.4884C15.7178 16.2259 16.2444 15.7334 17.0022 15.0246L17.5122 14.548C17.8148 14.2652 17.8309 13.7906 17.5481 13.4879C17.2653 13.1853 16.7907 13.1692 16.4881 13.452L16.0772 13.8359C15.1805 14.6739 14.8691 14.9482 14.502 15.093C14.1348 15.2379 13.7201 15.25 12.4928 15.25H11.5073C10.2797 15.25 9.86479 15.2379 9.49755 15.0929C9.13032 14.948 8.81894 14.6736 7.92213 13.8352L7.51229 13.4521Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Bag-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","cart","shopping","purchase","checkout","order","items","products","sale","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 12L6.48249 12.9899C7.23334 13.4912 7.60877 13.7419 8.0344 13.871C8.46003 14 8.91146 14 9.81432 14H14.1851C15.0877 14 15.539 14 15.9645 13.871C16.39 13.7421 16.7653 13.4915 17.516 12.9905L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-Bag": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","cart","purchase","checkout","order","tote","retail","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 12L6.48249 12.9899C7.23334 13.4912 7.60877 13.7419 8.0344 13.871C8.46003 14 8.91146 14 9.81432 14H14.1851C15.0877 14 15.539 14 15.9645 13.871C16.39 13.7421 16.7653 13.4915 17.516 12.9905L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cart-heart-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","heart","favorite","saved-items","wishlist","charity","donation","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 3C9.52971 3 7.47774 4.79163 7.0727 7.14643C6.30949 7.27427 5.62796 7.5266 5.05209 8.05647C4.41065 8.64668 4.10149 9.39614 3.91656 10.2542C3.74079 11.0698 3.65471 12.1031 3.55068 13.3519L3.53897 13.4924C3.41747 14.9499 3.31765 16.1474 3.3695 17.098C3.42379 18.0933 3.64959 18.9831 4.317 19.7084C4.98442 20.4338 5.85238 20.7327 6.83976 20.8695C7.78273 21.0001 8.98434 21 10.4469 21H13.5533C15.0159 21 16.2175 21.0001 17.1605 20.8695C18.1479 20.7327 19.0158 20.4338 19.6833 19.7084C20.3507 18.9831 20.5765 18.0933 20.6308 17.098C20.6826 16.1474 20.5828 14.95 20.4613 13.4924L20.4496 13.3519C20.3456 12.1031 20.2595 11.0698 20.0837 10.2542C19.8988 9.39614 19.5896 8.64668 18.9482 8.05647C18.3723 7.5266 17.6908 7.27427 16.9276 7.14643C16.5225 4.79163 14.4706 3 12.0001 3ZM13.5464 7C14.0033 6.99999 14.4315 6.99998 14.8313 7.00517C14.4209 5.83728 13.3083 5 12.0001 5C10.692 5 9.57939 5.83728 9.16902 7.00517C9.56877 6.99998 9.99694 6.99999 10.4539 7H13.5464ZM12.0001 17L9.4804 14.8029C8.84005 14.1617 8.84005 13.1221 9.4804 12.4809C10.1207 11.8397 11.159 11.8397 11.7993 12.4809L12.0001 12.7143L12.201 12.4809C12.8413 11.8397 13.8795 11.8397 14.5199 12.4809C15.1602 13.1221 15.1602 14.1617 14.5199 14.8029L12.0001 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "cart-heart-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shopping-bag","heart","loyalty","favorites","wishlist","rewards","save","cart","favorite-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.48026 14.8029L12 17L14.5197 14.8029C15.1601 14.1617 15.1601 13.1221 14.5197 12.4809C13.8794 11.8397 12.8412 11.8397 12.2008 12.4809L12 12.7143L11.7992 12.4809C11.1588 11.8397 10.1206 11.8397 9.48026 12.4809C8.83991 13.1221 8.83991 14.1617 9.48026 14.8029Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cart-heart-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shopping","cart","bag","heart","favorites","wishlist","loyalty","rewards","saved-items","promotion","charity","donation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.48026 14.8029L12 17L14.5197 14.8029C15.1601 14.1617 15.1601 13.1221 14.5197 12.4809C13.8794 11.8397 12.8412 11.8397 12.2008 12.4809L12 12.7143L11.7992 12.4809C11.1588 11.8397 10.1206 11.8397 9.48026 12.4809C8.83991 13.1221 8.83991 14.1617 9.48026 14.8029Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cart-heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","favorite","wishlist","loyalty","rewards","promotions","gift","purchase","checkout","favorites"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.54152 13.5017C4.75914 10.8904 4.86794 9.58471 5.72907 8.79235C6.5902 8 7.9004 8 10.5208 8H13.4792C16.0996 8 17.4098 8 18.2709 8.79235C19.1321 9.58471 19.2409 10.8904 19.4585 13.5017V13.5017C19.7119 16.5423 19.8386 18.0627 18.9472 19.0313C18.0559 20 16.5304 20 13.4792 20H10.5208C7.46964 20 5.94406 20 5.05275 19.0313C4.16145 18.0627 4.28814 16.5423 4.54152 13.5017V13.5017Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.48026 14.8029L12 17L14.5197 14.8029C15.1601 14.1617 15.1601 13.1221 14.5197 12.4809C13.8794 11.8397 12.8412 11.8397 12.2008 12.4809L12 12.7143L11.7992 12.4809C11.1588 11.8397 10.1206 11.8397 9.48026 12.4809C8.83991 13.1221 8.83991 14.1617 9.48026 14.8029Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-Speed v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cart","shopping-cart","checkout","fast","speed","quick","express","purchase","buy","order","processing","delivery","shipping","transaction","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-Speed v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","fast","speed","checkout","purchase","express","delivery","quick-checkout","rapid","accelerated","expedited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C3 3.44772 3.44772 3 4 3H7C7.55228 3 8 3.44772 8 4V6H17.7344C17.7541 6 17.7738 6 17.7934 5.99999C18.2701 5.9999 18.7269 5.99982 19.0986 6.05197C19.5139 6.11024 19.9934 6.25367 20.3666 6.6764C20.7397 7.09912 20.8226 7.59274 20.8289 8.012C20.8345 8.38732 20.7778 8.84056 20.7186 9.31358C20.7162 9.33306 20.7137 9.35257 20.7113 9.3721L20.4227 11.6804C20.3249 12.4631 20.2401 13.1423 20.1011 13.6841C19.9516 14.2672 19.711 14.8154 19.2198 15.249C18.7286 15.6827 18.1548 15.8533 17.5577 15.9294C17.0028 16.0001 16.3183 16 15.5296 16H10.9342C10.0477 16.0001 9.28387 16.0001 8.67221 15.9179C8.01669 15.8297 7.38834 15.631 6.87868 15.1213C6.36902 14.6117 6.17027 13.9833 6.08214 13.3278C5.99991 12.7161 5.99995 11.9523 6 11.0658L6 5H4C3.44772 5 3 4.55228 3 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25 19.25C5.25 18.0074 6.25736 17 7.5 17C8.74264 17 9.75 18.0074 9.75 19.25C9.75 20.4926 8.74264 21.5 7.5 21.5C6.25736 21.5 5.25 20.4926 5.25 19.25ZM12.25 19.25C12.25 18.0074 13.2574 17 14.5 17C15.7426 17 16.75 18.0074 16.75 19.25C16.75 20.4926 15.7426 21.5 14.5 21.5C13.2574 21.5 12.25 20.4926 12.25 19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 7C1 6.44772 1.44772 6 2 6H3.99621C4.54849 6 4.99621 6.44772 4.99621 7C4.99621 7.55228 4.54849 8 3.99621 8H2C1.44772 8 1 7.55228 1 7ZM1.99747 10C1.99747 9.44772 2.44519 9 2.99747 9H3.99621C4.54849 9 4.99621 9.44772 4.99621 10C4.99621 10.5523 4.54849 11 3.99621 11H2.99747C2.44519 11 1.99747 10.5523 1.99747 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Speed v2-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","order","speed","fast-checkout","express-checkout","quick-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-Speed v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","order","speed","fast","delivery","express","quick","cart-speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-Speed-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping cart","speed","fast","checkout","purchase","buy","order","express checkout","rush order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75V6.25ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H10V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Speed-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","speed","fast","express","delivery","purchase","order","quick-checkout","rush-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 18.95C5.5 17.7073 6.50736 16.7 7.75 16.7C8.99264 16.7 10 17.7073 10 18.95C10 20.1926 8.99264 21.2 7.75 21.2C6.50736 21.2 5.5 20.1926 5.5 18.95ZM12.25 18.95C12.25 17.7073 13.2574 16.7 14.5 16.7C15.7426 16.7 16.75 17.7073 16.75 18.95C16.75 20.1926 15.7426 21.2 14.5 21.2C13.2574 21.2 12.25 20.1926 12.25 18.95Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C3 3.44772 3.44772 3 4 3H6C6.43043 3 6.81257 3.27543 6.94868 3.68377L7.72076 6H17.7344C17.7541 6 17.7738 6 17.7934 5.99999C18.2701 5.9999 18.7269 5.99982 19.0986 6.05197C19.5139 6.11024 19.9934 6.25367 20.3666 6.6764C20.7397 7.09912 20.8226 7.59274 20.8289 8.012C20.8345 8.38732 20.7778 8.84056 20.7186 9.31358C20.7162 9.33306 20.7137 9.35257 20.7113 9.3721L20.4227 11.6804C20.3249 12.4631 20.2401 13.1423 20.1011 13.6841C19.9516 14.2672 19.711 14.8154 19.2198 15.249C18.7286 15.6827 18.1548 15.8533 17.5577 15.9294C17.0028 16.0001 16.3183 16 15.5296 16H10.9342C10.0477 16.0001 9.28387 16.0001 8.67221 15.9179C8.01669 15.8297 7.38834 15.631 6.87868 15.1213C6.36902 14.6117 6.17027 13.9833 6.08214 13.3278C5.9999 12.7161 5.99995 11.9523 6 11.0658L6 7.16228L5.27924 5H4C3.44772 5 3 4.55228 3 4ZM1 7C1 6.44772 1.44772 6 2 6H3.99621C4.54849 6 4.99621 6.44772 4.99621 7C4.99621 7.55228 4.54849 8 3.99621 8H2C1.44772 8 1 7.55228 1 7ZM1.99747 10C1.99747 9.44772 2.44519 9 2.99747 9H3.99621C4.54849 9 4.99621 9.44772 4.99621 10C4.99621 10.5523 4.54849 11 3.99621 11H2.99747C2.44519 11 1.99747 10.5523 1.99747 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-Speed-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","checkout","speed","fast","express","quick-checkout","accelerated","purchase","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-Speed": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","speed","fast","checkout","express","delivery","purchase","buy","quick-order","speed-checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75V6.25ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H10V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-trolley v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","basket","buy","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75V6.25ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H10V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","sale","items","products","order","basket","add-to-cart","view-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C3 3.44772 3.44772 3 4 3H6C6.43043 3 6.81257 3.27543 6.94868 3.68377L7.72076 6H17.7344C17.7541 6 17.7738 6 17.7934 5.99999C18.2701 5.9999 18.7269 5.99982 19.0986 6.05197C19.5139 6.11024 19.9934 6.25367 20.3666 6.6764C20.7397 7.09912 20.8226 7.59274 20.8289 8.012C20.8345 8.38732 20.7778 8.84056 20.7186 9.31358C20.7162 9.33306 20.7137 9.35257 20.7113 9.3721L20.4227 11.6804C20.3249 12.4631 20.2401 13.1423 20.1011 13.6841C19.9516 14.2672 19.711 14.8154 19.2198 15.249C18.7286 15.6827 18.1548 15.8533 17.5577 15.9294C17.0028 16.0001 16.3183 16 15.5296 16H10.9342C10.0477 16.0001 9.28387 16.0001 8.67221 15.9179C8.01669 15.8297 7.38834 15.631 6.87868 15.1213C6.36902 14.6117 6.17027 13.9833 6.08214 13.3278C5.99991 12.7161 5.99995 11.9523 6 11.0658L6 7.16228L5.27924 5H4C3.44772 5 3 4.55228 3 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 19.25C5.5 18.0074 6.50736 17 7.75 17C8.99264 17 10 18.0074 10 19.25C10 20.4926 8.99264 21.5 7.75 21.5C6.50736 21.5 5.5 20.4926 5.5 19.25ZM12.25 19.25C12.25 18.0074 13.2574 17 14.5 17C15.7426 17 16.75 18.0074 16.75 19.25C16.75 20.4926 15.7426 21.5 14.5 21.5C13.2574 21.5 12.25 20.4926 12.25 19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v2-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","add-to-cart","order","sales","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-trolley v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","buy","purchase","order","basket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","order","basket","trolley","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75V6.25ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H10V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-trolley v3-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","order","basket","buy","items","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 4C3 3.44772 3.44772 3 4 3H6C6.43043 3 6.81257 3.27543 6.94868 3.68377L7.72076 6H17.7344C17.7541 6 17.7738 6 17.7934 5.99999C18.2701 5.9999 18.7269 5.99982 19.0986 6.05197C19.5139 6.11024 19.9934 6.25367 20.3666 6.6764C20.7397 7.09912 20.8226 7.59274 20.8289 8.012C20.8345 8.38732 20.7778 8.84056 20.7186 9.31358C20.7162 9.33306 20.7137 9.35257 20.7113 9.3721L20.4227 11.6804C20.3249 12.4631 20.2401 13.1423 20.1011 13.6841C19.9516 14.2672 19.711 14.8154 19.2198 15.249C18.7286 15.6827 18.1548 15.8533 17.5577 15.9294C17.0028 16.0001 16.3183 16 15.5296 16H10.9342C10.0477 16.0001 9.28387 16.0001 8.67221 15.9179C8.01669 15.8297 7.38834 15.631 6.87868 15.1213C6.36902 14.6117 6.17027 13.9833 6.08214 13.3278C5.99991 12.7161 5.99995 11.9523 6 11.0658L6 7.16228L5.27924 5H4C3.44772 5 3 4.55228 3 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 19.25C5.5 18.0074 6.50736 17 7.75 17C8.99264 17 10 18.0074 10 19.25C10 20.4926 8.99264 21.5 7.75 21.5C6.50736 21.5 5.5 20.4926 5.5 19.25ZM12.25 19.25C12.25 18.0074 13.2574 17 14.5 17C15.7426 17 16.75 18.0074 16.75 19.25C16.75 20.4926 15.7426 21.5 14.5 21.5C13.2574 21.5 12.25 20.4926 12.25 19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v3-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","trolley","purchase","checkout","basket","buy","order","sale","products","items","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-trolley v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","trolley","remove","minus","reduce","decrease","checkout","order","cart-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 12L15 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","trolley","checkout","buy","purchase","order","basket","products","items","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-trolley v4-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","order","items","products","sale","basket","add-to-cart","view-cart","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 12L15 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-trolley v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","trolley","shopping","checkout","purchase","order","buy","sale","pos","basket","items","products","add-to-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM6 4L6.71151 3.76283C6.60943 3.45657 6.32282 3.25 6 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H6V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM17.7344 6.25H7V7.75H17.7344V6.25ZM5.28849 4.23717L6.28849 7.23717L7.71151 6.76283L6.71151 3.76283L5.28849 4.23717ZM6.25 7V11H7.75V7H6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 12L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-trolley v5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","trolley","shopping","checkout","purchase","order","basket","add-to-cart","pos","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 9L16 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.3557 15.0754L10.3557 15.6111C8.31876 15.793 7.30027 15.8839 6.65013 15.2892C6 14.6946 6 13.672 6 11.6269V6H18C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V11.0912C20 12.8286 20 13.6973 19.4758 14.2705C18.9515 14.8436 18.0863 14.9209 16.3557 15.0754Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-trolley v5-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","trolley","shopping","checkout","purchase","basket","buy","order","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3557 15.0754L10.3557 15.6111C8.31876 15.793 7.30027 15.8839 6.65013 15.2892C6 14.6946 6 13.672 6 11.6269V6H18C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V11.0912C20 12.8286 20 13.6973 19.4758 14.2705C18.9515 14.8436 18.0863 14.9209 16.3557 15.0754Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 9L16 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-trolley v4-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","order","sale","retail","pos","add-to-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 19.25C5.5 18.0074 6.50736 17 7.75 17C8.99264 17 10 18.0074 10 19.25C10 20.4926 8.99264 21.5 7.75 21.5C6.50736 21.5 5.5 20.4926 5.5 19.25ZM12.25 19.25C12.25 18.0074 13.2574 17 14.5 17C15.7426 17 16.75 18.0074 16.75 19.25C16.75 20.4926 15.7426 21.5 14.5 21.5C13.2574 21.5 12.25 20.4926 12.25 19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 3C3.44772 3 3 3.44772 3 4C3 4.55228 3.44772 5 4 5H5.27924L6 7.16228L6 11.0658C5.99995 11.9523 5.99991 12.7161 6.08214 13.3278C6.17027 13.9833 6.36902 14.6117 6.87868 15.1213C7.38834 15.631 8.01669 15.8297 8.67221 15.9179C9.28387 16.0001 10.0477 16.0001 10.9342 16H15.5296C16.3183 16 17.0028 16.0001 17.5577 15.9294C18.1548 15.8533 18.7286 15.6827 19.2198 15.249C19.711 14.8154 19.9516 14.2672 20.1011 13.6841C20.2401 13.1423 20.3249 12.4631 20.4227 11.6805L20.7186 9.31358C20.7778 8.84056 20.8345 8.38732 20.8289 8.012C20.8226 7.59274 20.7397 7.09912 20.3666 6.6764C19.9934 6.25367 19.5139 6.11024 19.0986 6.05197C18.7269 5.99982 18.2701 5.9999 17.7934 5.99999L7.72076 6L6.94868 3.68377C6.81257 3.27543 6.43043 3 6 3H4ZM15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v5-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","trolley","checkout","buy","purchase","order","basket","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.29999 19.75C5.29999 18.5074 6.30735 17.5 7.54999 17.5C8.79263 17.5 9.79999 18.5074 9.79999 19.75C9.79999 20.9926 8.79263 22 7.54999 22C6.30735 22 5.29999 20.9926 5.29999 19.75ZM12.05 19.75C12.05 18.5074 13.0573 17.5 14.3 17.5C15.5426 17.5 16.55 18.5074 16.55 19.75C16.55 20.9926 15.5426 22 14.3 22C13.0573 22 12.05 20.9926 12.05 19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4H4.27924L5 6.16228L5 11.6963C4.99995 12.6595 4.9999 13.4847 5.09076 14.1394C5.18775 14.8384 5.40734 15.5077 5.9752 16.0271C6.54307 16.5465 7.22928 16.7057 7.93404 16.7402C8.59424 16.7724 9.41617 16.699 10.3755 16.6133L16.5066 16.0659C17.3188 15.9934 18.0224 15.9306 18.5842 15.8063C19.1882 15.6726 19.759 15.4424 20.2136 14.9454C20.6682 14.4484 20.8467 13.8594 20.9262 13.2459C21.0001 12.6753 21 11.9689 21 11.1534L21 7.94557C21.0001 7.52151 21.0002 7.10939 20.9545 6.76948C20.903 6.38628 20.7774 5.949 20.4142 5.58579C20.051 5.22257 19.6137 5.09705 19.2305 5.04553C18.8906 4.99983 18.4785 4.99991 18.0544 4.99999L6.72076 5L5.94868 2.68377C5.81257 2.27543 5.43043 2 5 2H3ZM16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10L18 10C18.5523 10 19 9.55228 19 9C19 8.44772 18.5523 8 18 8H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","order","sale","add-to-cart","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3557 15.0754L10.3557 15.6111C8.31876 15.793 7.30027 15.8839 6.65013 15.2892C6 14.6946 6 13.672 6 11.6269V6H18C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V11.0912C20 12.8286 20 13.6973 19.4758 14.2705C18.9515 14.8436 18.0863 14.9209 16.3557 15.0754Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 9L16 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-trolley-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","buy","items","order","basket","add-to-cart","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 9H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 6H20.75C20.75 5.58579 20.4142 5.25 20 5.25V6ZM6 6V5.25H5.25V6H6ZM16.3557 15.0754L16.289 14.3284L16.3557 15.0754ZM19.4758 14.2705L18.9223 13.7643L19.4758 14.2705ZM10.4224 16.3581L16.4224 15.8224L16.289 14.3284L10.289 14.8641L10.4224 16.3581ZM20.75 11.0912V6H19.25V11.0912H20.75ZM20 5.25H6V6.75H20V5.25ZM5.25 6V11.6269H6.75V6H5.25ZM16.4224 15.8224C17.2676 15.7469 17.9736 15.6854 18.5302 15.5622C19.1077 15.4344 19.6227 15.2211 20.0292 14.7767L18.9223 13.7643C18.8046 13.893 18.6248 14.0049 18.206 14.0976C17.7663 14.195 17.1744 14.2493 16.289 14.3284L16.4224 15.8224ZM19.25 11.0912C19.25 11.9801 19.2485 12.5745 19.1907 13.0211C19.1356 13.4465 19.0401 13.6355 18.9223 13.7643L20.0292 14.7767C20.4356 14.3323 20.6023 13.8004 20.6783 13.2138C20.7515 12.6485 20.75 11.9398 20.75 11.0912H19.25ZM10.289 14.8641C9.24847 14.957 8.54588 15.018 8.01949 14.9923C7.51467 14.9676 7.2993 14.8666 7.15633 14.7358L6.14394 15.8426C6.6511 16.3065 7.27005 16.4574 7.94625 16.4905C8.60087 16.5225 9.42601 16.4471 10.4224 16.3581L10.289 14.8641ZM5.25 11.6269C5.25 12.6273 5.2483 13.4559 5.33839 14.1051C5.43145 14.7757 5.63677 15.3787 6.14394 15.8426L7.15633 14.7358C7.01336 14.605 6.89362 14.3995 6.82415 13.8989C6.7517 13.3769 6.75 12.6716 6.75 11.6269H5.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-trolley-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","basket","buy","sale","pos","retail","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 19.75C5.5 18.5074 6.50736 17.5 7.75 17.5C8.99264 17.5 10 18.5074 10 19.75C10 20.9926 8.99264 22 7.75 22C6.50736 22 5.5 20.9926 5.5 19.75ZM12.25 19.75C12.25 18.5074 13.2574 17.5 14.5 17.5C15.7426 17.5 16.75 18.5074 16.75 19.75C16.75 20.9926 15.7426 22 14.5 22C13.2574 22 12.25 20.9926 12.25 19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4H4.27924L5 6.16228L5 11.6963C4.99995 12.6595 4.9999 13.4847 5.09076 14.1394C5.18775 14.8384 5.40734 15.5077 5.9752 16.0271C6.54307 16.5465 7.22928 16.7057 7.93404 16.7402C8.59424 16.7724 9.41617 16.699 10.3755 16.6133L16.5066 16.0659C17.3188 15.9934 18.0224 15.9306 18.5842 15.8063C19.1882 15.6726 19.759 15.4424 20.2136 14.9454C20.6682 14.4484 20.8467 13.8594 20.9262 13.2459C21.0001 12.6753 21 11.9689 21 11.1534L21 6C21 5.44772 20.5523 5 20 5H6.72076L5.94868 2.68377C5.81257 2.27543 5.43043 2 5 2H3ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H12C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H11C11.5523 13 12 12.5523 12 12C12 11.4477 11.5523 11 11 11H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-trolley-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","trolley","checkout","purchase","order","buy","add-to-cart","shopping-cart","item","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3557 15.0754L10.3557 15.6111C8.31876 15.793 7.30027 15.8839 6.65013 15.2892C6 14.6946 6 13.672 6 11.6269V6H20V11.0912C20 12.8286 20 13.6973 19.4758 14.2705C18.9515 14.8436 18.0863 14.9209 16.3557 15.0754Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10.3557 15.6111L10.4224 16.3581L10.3557 15.6111ZM16.3557 15.0754L16.4224 15.8224L16.3557 15.0754ZM20 6H20.75C20.75 5.58579 20.4142 5.25 20 5.25V6ZM6 6V5.25H5.25V6H6ZM19.4758 14.2705L18.9223 13.7643V13.7643L19.4758 14.2705ZM10.4224 16.3581L16.4224 15.8224L16.289 14.3284L10.289 14.8641L10.4224 16.3581ZM20.75 11.0912V6H19.25V11.0912H20.75ZM20 5.25H6V6.75H20V5.25ZM5.25 6V11.6269H6.75V6H5.25ZM16.4224 15.8224C17.2676 15.7469 17.9736 15.6854 18.5302 15.5622C19.1077 15.4344 19.6227 15.2211 20.0292 14.7767L18.9223 13.7643C18.8046 13.893 18.6248 14.0049 18.206 14.0976C17.7663 14.195 17.1744 14.2493 16.289 14.3284L16.4224 15.8224ZM19.25 11.0912C19.25 11.9801 19.2485 12.5745 19.1907 13.0211C19.1356 13.4465 19.0401 13.6355 18.9223 13.7643L20.0292 14.7767C20.4356 14.3323 20.6023 13.8004 20.6783 13.2138C20.7515 12.6485 20.75 11.9398 20.75 11.0912H19.25ZM10.289 14.8641C9.24847 14.957 8.54588 15.018 8.01949 14.9923C7.51467 14.9676 7.2993 14.8666 7.15633 14.7358L6.14394 15.8426C6.6511 16.3065 7.27005 16.4574 7.94625 16.4905C8.60087 16.5225 9.42601 16.4471 10.4224 16.3581L10.289 14.8641ZM5.25 11.6269C5.25 12.6273 5.2483 13.4559 5.33839 14.1051C5.43145 14.7757 5.63677 15.3787 6.14394 15.8426L7.15633 14.7358C7.01336 14.605 6.89362 14.3995 6.82415 13.8989C6.7517 13.3769 6.75 12.6716 6.75 11.6269H5.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9H6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12H6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-trolley": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","buy","trolley","basket","add-to-cart","order","products","items","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 6H20.75C20.75 5.58579 20.4142 5.25 20 5.25V6ZM6 6V5.25H5.25V6H6ZM16.3557 15.0754L16.289 14.3284L16.3557 15.0754ZM19.4758 14.2705L18.9223 13.7643L19.4758 14.2705ZM10.4224 16.3581L16.4224 15.8224L16.289 14.3284L10.289 14.8641L10.4224 16.3581ZM20.75 11.0912V6H19.25V11.0912H20.75ZM20 5.25H6V6.75H20V5.25ZM5.25 6V11.6269H6.75V6H5.25ZM16.4224 15.8224C17.2676 15.7469 17.9736 15.6854 18.5302 15.5622C19.1077 15.4344 19.6227 15.2211 20.0292 14.7767L18.9223 13.7643C18.8046 13.893 18.6248 14.0049 18.206 14.0976C17.7663 14.195 17.1744 14.2493 16.289 14.3284L16.4224 15.8224ZM19.25 11.0912C19.25 11.9801 19.2485 12.5745 19.1907 13.0211C19.1356 13.4465 19.0401 13.6355 18.9223 13.7643L20.0292 14.7767C20.4356 14.3323 20.6023 13.8004 20.6783 13.2138C20.7515 12.6485 20.75 11.9398 20.75 11.0912H19.25ZM10.289 14.8641C9.24847 14.957 8.54588 15.018 8.01949 14.9923C7.51467 14.9676 7.2993 14.8666 7.15633 14.7358L6.14394 15.8426C6.6511 16.3065 7.27005 16.4574 7.94625 16.4905C8.60087 16.5225 9.42601 16.4471 10.4224 16.3581L10.289 14.8641ZM5.25 11.6269C5.25 12.6273 5.2483 13.4559 5.33839 14.1051C5.43145 14.7757 5.63677 15.3787 6.14394 15.8426L7.15633 14.7358C7.01336 14.605 6.89362 14.3995 6.82415 13.8989C6.7517 13.3769 6.75 12.6716 6.75 11.6269H5.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 19.5C6 18.6716 6.67157 18 7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 19.5C13 18.6716 13.6716 18 14.5 18C15.3284 18 16 18.6716 16 19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 3H5L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cart-wheel-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","order","trolley","buy","add-to-cart","basket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 18C16 19.1046 15.1046 20 14 20C12.8954 20 12 19.1046 12 18C12 16.8954 12.8954 16 14 16C15.1046 16 16 16.8954 16 18Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 4L4 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.99603 4L6.4379 9.60355C6.23331 11.6576 6.13102 12.6846 6.72646 13.3423C7.32191 14 8.35401 14 10.4182 14H15.3599C16.4438 14 16.9858 14 17.4233 13.7696C17.6143 13.6691 17.7878 13.5382 17.9369 13.3822C18.2786 13.0248 18.4275 12.5037 18.7253 11.4615V11.4615C19.2218 9.72361 19.4701 8.85465 19.1787 8.19342C19.0538 7.91015 18.8649 7.65972 18.6269 7.46186C18.0711 7 17.1674 7 15.3599 7H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-wheel-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","purchase","buy","order","basket","add-to-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 18C4.25 16.4812 5.48122 15.25 7 15.25C8.51878 15.25 9.75 16.4812 9.75 18C9.75 19.5188 8.51878 20.75 7 20.75C5.48122 20.75 4.25 19.5188 4.25 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 18C11.25 16.4812 12.4812 15.25 14 15.25C15.5188 15.25 16.75 16.4812 16.75 18C16.75 19.5188 15.5188 20.75 14 20.75C12.4812 20.75 11.25 19.5188 11.25 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 2C3.44772 2 3 2.44772 3 3C3 3.55228 3.44772 4 4 4H5.89148L5.44283 8.50444C5.44051 8.52766 5.43821 8.55081 5.43591 8.57387C5.33948 9.5415 5.25692 10.3699 5.28293 11.0356C5.31069 11.7458 5.46479 12.4387 5.98514 13.0135C6.50549 13.5882 7.17966 13.8102 7.88365 13.9082C8.54346 14.0001 9.376 14.0001 10.3484 14H15.4001C15.9077 14 16.352 14 16.7221 13.9673C17.1188 13.9322 17.509 13.8547 17.8892 13.6545C18.1757 13.5036 18.4359 13.3073 18.6597 13.0732C18.9567 12.7626 19.1384 12.4088 19.2812 12.037C19.4143 11.6901 19.5363 11.263 19.6758 10.7749L19.7022 10.6822C19.9374 9.85937 20.1364 9.163 20.2334 8.59093C20.3344 7.99522 20.3549 7.38268 20.0938 6.79013C19.9065 6.36522 19.6231 5.98958 19.266 5.69279C18.768 5.2789 18.1734 5.13031 17.5729 5.06381C16.9962 4.99994 16.2719 4.99997 15.4162 5L7.80178 5L7.98215 3.18907C7.99387 3.12785 8 3.06464 8 3C8 2.45159 7.55854 2.00628 7.01159 2.00007C7.00773 2.00002 7.00387 2 7 2L4 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-wheel": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping","checkout","order","purchase","buy","add-to-cart","trolley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 18C16 19.1046 15.1046 20 14 20C12.8954 20 12 19.1046 12 18C12 16.8954 12.8954 16 14 16C15.1046 16 16 16.8954 16 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 4L4 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.99603 4L6.4379 9.60355C6.23331 11.6576 6.13102 12.6846 6.72646 13.3423C7.32191 14 8.35401 14 10.4182 14H15.3599C16.4438 14 16.9858 14 17.4233 13.7696C17.6143 13.6691 17.7878 13.5382 17.9369 13.3822C18.2786 13.0248 18.4275 12.5037 18.7253 11.4615V11.4615C19.2218 9.72361 19.4701 8.85465 19.1787 8.19342C19.0538 7.91015 18.8649 7.65972 18.6269 7.46186C18.0711 7 17.1674 7 15.3599 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-with-item-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping cart","full cart","checkout","order","purchase","buy","complete order","items","products","express","fast order","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 21.5C9.99264 21.5 11 20.4926 11 19.25C11 18.0074 9.99264 17 8.75 17C7.50736 17 6.5 18.0074 6.5 19.25C6.5 20.4926 7.50736 21.5 8.75 21.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.5 21.5C16.7426 21.5 17.75 20.4926 17.75 19.25C17.75 18.0074 16.7426 17 15.5 17C14.2574 17 13.25 18.0074 13.25 19.25C13.25 20.4926 14.2574 21.5 15.5 21.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 9H4C3.45 9 3 9.45 3 10C3 10.55 3.45 11 4 11H5C5.55 11 6 10.55 6 10C6 9.45 5.55 9 5 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H5C5.55 8 6 7.55 6 7C6 6.45 5.55 6 5 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.37 6.68C21 6.26 20.52 6.11 20.1 6.06C19.78 6.02 19.39 6.01 18.99 6.01C18.99 5.97 18.99 5.93 18.99 5.89C18.98 5.7 18.95 5.47 18.85 5.24C18.65 4.75 18.26 4.36 17.77 4.16C17.54 4.06 17.31 4.03 17.12 4.02C16.95 4.01 16.74 4.01 16.53 4.01H16.48C16.27 4.01 16.07 4.01 15.89 4.02C15.84 4.02 15.79 4.02 15.74 4.03C15.66 3.88 15.56 3.73 15.42 3.59C15.06 3.23 14.62 3.1 14.24 3.05C13.89 3 13.48 3 13.05 3H12.54C12.26 3 11.99 3.01 11.76 3.05C11.72 3.05 11.69 3.06 11.65 3.07C11.65 3.07 11.65 3.07 11.64 3.07C11.29 3.14 10.9 3.27 10.58 3.59C10.21 3.95 10.09 4.39 10.04 4.77C9.99 5.11 9.99 5.52 9.99 5.95C9.99 5.97 9.99 5.99 9.99 6H8.99V4C9 3.45 8.55 3 8 3H5C4.45 3 4 3.45 4 4C4 4.55 4.45 5 5 5H7V11.07C7 11.96 7 12.72 7.08 13.33C7.17 13.99 7.37 14.61 7.88 15.12C8.39 15.63 9.02 15.83 9.67 15.92C10.28 16 11.05 16 11.93 16H16.53C17.32 16 18 16 18.56 15.93C19.16 15.85 19.73 15.68 20.22 15.25C20.71 14.82 20.95 14.27 21.1 13.69C21.24 13.15 21.32 12.47 21.42 11.69L21.71 9.38C21.71 9.38 21.71 9.34 21.71 9.32C21.77 8.85 21.83 8.39 21.82 8.02C21.82 7.6 21.73 7.11 21.36 6.68H21.37Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cart-with-item-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cart","shopping","checkout","buy","purchase","order","items","products","sale","add-to-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 7L13 6C13 5.05719 13 4.58579 12.7071 4.29289C12.7071 4.29289 12.7071 4.29289 12.7071 4.29289C12.4142 4 11.9428 4 11 4V4C10.0572 4 9.58579 4 9.29289 4.29289C9.29289 4.29289 9.29289 4.29289 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 7V7C17 6.05719 17 5.58579 16.7071 5.29289C16.7071 5.29289 16.7071 5.29289 16.7071 5.29289C16.4142 5 15.9428 5 15 5V5C14.0572 5 13.5858 5 13.2929 5.29289C13.2929 5.29289 13.2929 5.29289 13.2929 5.29289C13 5.58579 13 6.05719 13 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-wheel-3": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cart","shopping","checkout","purchase","buy","order","items","products","retail","sale","add-to-cart","view-cart","shopping-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 18C16 19.1046 15.1046 20 14 20C12.8954 20 12 19.1046 12 18C12 16.8954 12.8954 16 14 16C15.1046 16 16 16.8954 16 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 4L4 4"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.4182 14H15.3599C16.4438 14 16.9858 14 17.4233 13.7696C17.6143 13.6691 17.7878 13.5382 17.9369 13.3822C18.2786 13.0248 18.4275 12.5037 18.7253 11.4615L18.7253 11.4615C19.2218 9.7236 19.4701 8.85464 19.1787 8.19342C19.0538 7.91015 18.8649 7.65972 18.6269 7.46186C18.0711 7 17.1674 7 15.3599 7H6.69722L6.4379 9.60355C6.23331 11.6576 6.13102 12.6846 6.72646 13.3423C7.32191 14 8.35401 14 10.4182 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.99603 4L6.4379 9.60355C6.23331 11.6576 6.13102 12.6846 6.72646 13.3423C7.32191 14 8.35401 14 10.4182 14H15.3599C16.4438 14 16.9858 14 17.4233 13.7696C17.6143 13.6691 17.7878 13.5382 17.9369 13.3822C18.2786 13.0248 18.4275 12.5037 18.7253 11.4615V11.4615C19.2218 9.72361 19.4701 8.85465 19.1787 8.19342C19.0538 7.91015 18.8649 7.65972 18.6269 7.46186C18.0711 7 17.1674 7 15.3599 7H6.69722"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cart-with-item": {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","checkout","purchase","buy","order","item","items","speed","fast","delivery","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.6169 7.3382L19.0546 7.83455L19.6169 7.3382ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM18.558 14.4994L18.0617 13.9371L18.558 14.4994ZM7.58579 14.4142L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.60881 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.5871 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L13 6C13 5.05719 13 4.58579 12.7071 4.29289C12.7071 4.29289 12.7071 4.29289 12.7071 4.29289C12.4142 4 11.9428 4 11 4V4C10.0572 4 9.58579 4 9.29289 4.29289C9.29289 4.29289 9.29289 4.29289 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 7V7C17 6.05719 17 5.58579 16.7071 5.29289C16.7071 5.29289 16.7071 5.29289 16.7071 5.29289C16.4142 5 15.9428 5 15 5V5C14.0572 5 13.5858 5 13.2929 5.29289C13.2929 5.29289 13.2929 5.29289 13.2929 5.29289C13 5.58579 13 6.05719 13 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Cart: {
        defaultColors: ["#3D4C66"],
        keywords: ["cart","shopping-cart","checkout","purchase","buy","order","item","items","speed","fast","delivery","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64839 9.62573C4.815 6.95993 4.89831 5.62704 5.76426 4.81352C6.63021 4 7.96571 4 10.6367 4H13.3633C16.0343 4 17.3698 4 18.2357 4.81352C19.1017 5.62704 19.185 6.95993 19.3516 9.62573L19.6016 13.6257C19.7884 16.614 19.8818 18.1082 18.9931 19.0541C18.1045 20 16.6074 20 13.6133 20H10.3867C7.39257 20 5.89551 20 5.00687 19.0541C4.11824 18.1082 4.21162 16.614 4.39839 13.6257L4.64839 9.62573Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cart-with-item-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cart","shopping","checkout","speed","fast","express","rush","purchase","buy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4689 15H11C9.11438 15 8.17157 15 7.58579 14.4142C7 13.8284 7 12.8856 7 11V7H17.7344C18.7904 7 19.3183 7 19.6169 7.3382C19.9155 7.67639 19.85 8.20029 19.719 9.24807L19.438 11.4961C19.2294 13.1645 19.1252 13.9987 18.558 14.4994C17.9909 15 17.1502 15 15.4689 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM7 4H7.75C7.75 3.58579 7.41421 3.25 7 3.25V4ZM19.438 11.4961L18.6938 11.4031L19.438 11.4961ZM19.719 9.24807L20.4632 9.3411L19.719 9.24807ZM19.6169 7.3382L19.0546 7.83455L19.0546 7.83455L19.6169 7.3382ZM7.58579 14.4142L8.11612 13.8839L8.11612 13.8839L7.58579 14.4142ZM4 4.75H7V3.25H4V4.75ZM11 15.75H15.4689V14.25H11V15.75ZM20.1822 11.5892L20.4632 9.3411L18.9748 9.15504L18.6938 11.4031L20.1822 11.5892ZM6.25 4V7H7.75V4H6.25ZM6.25 7V11H7.75V7H6.25ZM17.7344 6.25H7V7.75H17.7344V6.25ZM20.4632 9.3411C20.5259 8.83955 20.5845 8.38489 20.5789 8.01576C20.5731 7.62526 20.4964 7.20116 20.1792 6.84185L19.0546 7.83455C19.055 7.835 19.0542 7.83401 19.0536 7.83292C19.0532 7.83211 19.0553 7.83572 19.0586 7.84679C19.0661 7.87182 19.0774 7.92779 19.0791 8.03832C19.0827 8.27763 19.0431 8.6088 18.9748 9.15504L20.4632 9.3411ZM17.7344 7.75C18.2849 7.75 18.6185 7.75175 18.8555 7.785C18.9649 7.80036 19.0191 7.81852 19.043 7.82905C19.0536 7.83371 19.0569 7.8363 19.0561 7.83576C19.0551 7.83504 19.0542 7.8341 19.0546 7.83455L20.1792 6.84185C19.862 6.48253 19.4506 6.35381 19.0639 6.29955C18.6983 6.24825 18.2399 6.25 17.7344 6.25V7.75ZM15.4689 15.75C16.2898 15.75 16.9765 15.7514 17.5261 15.6814C18.0968 15.6087 18.6151 15.4494 19.0544 15.0616L18.0617 13.9371C17.9339 14.0499 17.7483 14.141 17.3365 14.1934C16.9036 14.2486 16.3293 14.25 15.4689 14.25V15.75ZM18.6938 11.4031C18.587 12.2569 18.5144 12.8266 18.406 13.2493C18.3029 13.6514 18.1895 13.8242 18.0617 13.9371L19.0544 15.0616C19.4937 14.6738 19.716 14.1792 19.859 13.622C19.9966 13.0853 20.0804 12.4038 20.1822 11.5892L18.6938 11.4031ZM11 14.25C10.036 14.25 9.38843 14.2484 8.90539 14.1835C8.44393 14.1214 8.24643 14.0142 8.11612 13.8839L7.05546 14.9445C7.51093 15.4 8.07773 15.5857 8.70552 15.6701C9.31174 15.7516 10.0784 15.75 11 15.75V14.25ZM6.25 11C6.25 11.9216 6.24841 12.6883 6.32991 13.2945C6.41432 13.9223 6.59999 14.4891 7.05546 14.9445L8.11612 13.8839C7.9858 13.7536 7.87858 13.5561 7.81654 13.0946C7.75159 12.6116 7.75 11.964 7.75 11H6.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 18.5C6 17.6716 6.67157 17 7.5 17C8.32843 17 9 17.6716 9 18.5C9 19.3284 8.32843 20 7.5 20C6.67157 20 6 19.3284 6 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18.5C13 17.6716 13.6716 17 14.5 17C15.3284 17 16 17.6716 16 18.5C16 19.3284 15.3284 20 14.5 20C13.6716 20 13 19.3284 13 18.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.99621 7H3M4.99621 10H3.99747"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L13 6C13 5.05719 13 4.58579 12.7071 4.29289C12.7071 4.29289 12.7071 4.29289 12.7071 4.29289C12.4142 4 11.9428 4 11 4V4C10.0572 4 9.58579 4 9.29289 4.29289C9.29289 4.29289 9.29289 4.29289 9.29289 4.29289C9 4.58579 9 5.05719 9 6L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 7V7C17 6.05719 17 5.58579 16.7071 5.29289C16.7071 5.29289 16.7071 5.29289 16.7071 5.29289C16.4142 5 15.9428 5 15 5V5C14.0572 5 13.5858 5 13.2929 5.29289C13.2929 5.29289 13.2929 5.29289 13.2929 5.29289C13 5.58579 13 6.05719 13 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cassette-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cassette","cash-drawer","till","money","cash","drawer","register","change","payment","safe","cash-register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 13C7 14.1046 7.89543 15 9 15C9.55228 15 10.0523 14.7761 10.4142 14.4142C10.7761 14.0523 11 13.5523 11 13C11 11.8954 10.1046 11 9 11C7.89543 11 7 11.8954 7 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 14.1046 13.8954 15 15 15C15.5523 15 16.0523 14.7761 16.4142 14.4142C16.7761 14.0523 17 13.5523 17 13C17 11.8954 16.1046 11 15 11C13.8954 11 13 11.8954 13 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 5L16.9117 5.26491C16.4717 6.58495 16.2517 7.24497 15.7279 7.62248C15.2041 8 14.5084 8 13.117 8L10.883 8C9.49159 8 8.79587 8 8.2721 7.62249C7.74832 7.24497 7.52832 6.58495 7.0883 5.26491L7 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cassette-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cassette","retro","music","media","audio","recording","tape","playback","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 13C7 14.1046 7.89543 15 9 15C9.55228 15 10.0523 14.7761 10.4142 14.4142C10.7761 14.0523 11 13.5523 11 13C11 11.8954 10.1046 11 9 11C7.89543 11 7 11.8954 7 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 14.1046 13.8954 15 15 15C15.5523 15 16.0523 14.7761 16.4142 14.4142C16.7761 14.0523 17 13.5523 17 13C17 11.8954 16.1046 11 15 11C13.8954 11 13 11.8954 13 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 5L16.9117 5.26491C16.4717 6.58495 16.2517 7.24497 15.7279 7.62248C15.2041 8 14.5084 8 13.117 8L10.883 8C9.49159 8 8.79587 8 8.2721 7.62249C7.74832 7.24497 7.52832 6.58495 7.0883 5.26491L7 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cassette-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cash-drawer","register","till","money","cash","payment","checkout","sales","cassette"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7784 9L11.2215 9C10.486 9.00004 9.84519 9.00008 9.32226 8.93588C8.75838 8.86666 8.2155 8.71178 7.73763 8.32002C7.25977 7.92827 7.00143 7.42631 6.82296 6.88695C6.65746 6.38676 6.53182 5.75837 6.38761 5.03712L6.21539 4.17601C5.43486 4.3215 4.74159 4.60157 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45868 2.99997 9.57526 3 10.9293V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92936 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V10.9295C21 9.57536 21.0001 8.45869 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.2584 4.60156 18.5651 4.32149 17.7846 4.176L17.6124 5.03713C17.4682 5.75838 17.3425 6.38676 17.177 6.88695C16.9986 7.42631 16.7402 7.92827 16.2624 8.32002C15.7845 8.71178 15.2416 8.86665 14.6777 8.93588C14.1548 9.00008 13.514 9.00004 12.7784 9ZM7 13C7 11.8954 7.89543 11 9 11C10.1046 11 11 11.8954 11 13C11 13.5521 10.7754 14.053 10.4142 14.4142C10.053 14.7754 9.5521 15 9 15C7.89543 15 7 14.1046 7 13ZM13 13C13 11.8954 13.8954 11 15 11C16.1046 11 17 11.8954 17 13C17 13.5521 16.7754 14.053 16.4142 14.4142C16.053 14.7754 15.5521 15 15 15C13.8954 15 13 14.1046 13 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.92921 4C9.31077 3.99999 8.74186 3.99997 8.22205 4.01129L8.33747 4.58835C8.49632 5.38264 8.59937 5.88892 8.72172 6.25866C8.83541 6.60227 8.93052 6.71178 9.00561 6.77334C9.08071 6.8349 9.20674 6.90668 9.56597 6.95079C9.95253 6.99824 10.4692 7 11.2792 7H12.7208C13.5308 7 14.0475 6.99824 14.434 6.95079C14.7932 6.90668 14.9193 6.8349 14.9944 6.77334C15.0695 6.71178 15.1646 6.60227 15.2783 6.25866C15.4006 5.88892 15.5037 5.38264 15.6625 4.58835L15.7779 4.01129C15.2581 3.99997 14.6892 3.99999 14.0708 4H9.92921Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "category-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["category","group","shapes","circle","triangle","square","grouping","tag","categorize","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="14"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="14"
                    y="14"
                    width="6"
                    height="6"
                    rx="1"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L12 4L8 10H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Cassette: {
        defaultColors: ["#3D4C66"],
        keywords: ["category","group","shapes","circle","triangle","square","grouping","tag","categorize","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 13C7 14.1046 7.89543 15 9 15C9.55228 15 10.0523 14.7761 10.4142 14.4142C10.7761 14.0523 11 13.5523 11 13C11 11.8954 10.1046 11 9 11C7.89543 11 7 11.8954 7 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 14.1046 13.8954 15 15 15C15.5523 15 16.0523 14.7761 16.4142 14.4142C16.7761 14.0523 17 13.5523 17 13C17 11.8954 16.1046 11 15 11C13.8954 11 13 11.8954 13 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 5L16.9117 5.26491C16.4717 6.58495 16.2517 7.24497 15.7279 7.62248C15.2041 8 14.5084 8 13.117 8L10.883 8C9.49159 8 8.79587 8 8.2721 7.62249C7.74832 7.24497 7.52832 6.58495 7.0883 5.26491L7 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "category-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["category","categories","shapes","filter","group","grouping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 17C3 14.7909 4.79086 13 7 13C9.20914 13 11 14.7909 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.6626 13L15.7 13H18.3L18.3374 13L18.3374 13C18.6323 13 18.9194 12.9999 19.1612 13.0229C19.4282 13.0483 19.7412 13.1086 20.045 13.2947C20.3141 13.4596 20.5404 13.6859 20.7053 13.955C20.8914 14.2588 20.9517 14.5718 20.9771 14.8388C21.0001 15.0806 21.0001 15.3677 21 15.6626L21 15.7V18.3L21 18.3374C21.0001 18.6323 21.0001 18.9194 20.9771 19.1612C20.9517 19.4282 20.8914 19.7412 20.7053 20.045C20.5404 20.3141 20.3141 20.5404 20.045 20.7053C19.7412 20.8914 19.4282 20.9517 19.1612 20.9771C18.9194 21.0001 18.6323 21.0001 18.3374 21L18.3 21H15.7L15.6626 21C15.3677 21.0001 15.0806 21.0001 14.8388 20.9771C14.5718 20.9517 14.2588 20.8914 13.955 20.7053C13.6859 20.5404 13.4596 20.3141 13.2947 20.045C13.1086 19.7412 13.0483 19.4282 13.0229 19.1612C12.9999 18.9194 13 18.6323 13 18.3374L13 18.3374L13 18.3V15.7L13 15.6626L13 15.6626C13 15.3677 12.9999 15.0806 13.0229 14.8388C13.0483 14.5718 13.1086 14.2588 13.2947 13.955C13.4596 13.6859 13.6859 13.4596 13.955 13.2947C14.2588 13.1086 14.5718 13.0483 14.8388 13.0229C15.0806 12.9999 15.3677 13 15.6626 13L15.6626 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 3C12.3344 3 12.6466 3.1671 12.8321 3.4453L16.8321 9.4453C17.0366 9.75216 17.0557 10.1467 16.8817 10.4719C16.7077 10.797 16.3688 11 16 11H8C7.63121 11 7.29235 10.797 7.11833 10.4719C6.94431 10.1467 6.96338 9.75216 7.16795 9.4453L11.168 3.4453C11.3534 3.1671 11.6656 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "category-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["category","categories","group","shapes","square","circle","triangle","grouping","organize","classification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="14" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="14" y="14" width="6" height="6" rx="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M16 10L12 4L8 10H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CC-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["closed-caption","accessibility","subtitle","cc","text","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14L11 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H15C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14L16 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CC-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["closed-captions","CC","accessibility","options","settings","audio","visual","impairment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9H9.66667C8.19391 9 7 10.3431 7 12C7 13.6569 8.19391 15 9.66667 15L11 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15.6667C14.1939 9 13 10.3431 13 12C13 13.6569 14.1939 15 15.6667 15L17 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    category: {
        defaultColors: ["#3D4C66"],
        keywords: ["closed-captions","CC","accessibility","options","settings","audio","visual","impairment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="14" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="14" y="14" width="6" height="6" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 10L12 4L8 10H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CC-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["closed-caption","cc","accessibility","subtitle","hearing-impaired","audio","settings","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4H8.92943C7.57533 3.99997 6.45869 3.99994 5.57494 4.11876C4.64711 4.2435 3.82769 4.51547 3.17158 5.17158C2.51547 5.82769 2.2435 6.64711 2.11876 7.57494C1.99994 8.45869 1.99997 9.57529 2 10.9294V13.0706C1.99997 14.4247 1.99994 15.5413 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706V10.9295C22 9.57534 22.0001 8.4587 21.8813 7.57494C21.7565 6.64711 21.4845 5.82768 20.8284 5.17158C20.1723 4.51547 19.3529 4.2435 18.4251 4.11876C17.5413 3.99994 16.4247 3.99997 15.0706 4ZM9.66667 15.75H11C11.4142 15.75 11.75 15.4142 11.75 15C11.75 14.5858 11.4142 14.25 11 14.25H9.66667C8.68873 14.25 7.75 13.3281 7.75 12C7.75 10.6719 8.68873 9.75 9.66667 9.75H11C11.4142 9.75 11.75 9.41421 11.75 9C11.75 8.58579 11.4142 8.25 11 8.25H9.66667C7.69909 8.25 6.25 10.0144 6.25 12C6.25 13.9856 7.69909 15.75 9.66667 15.75ZM15.6667 15.75H17C17.4142 15.75 17.75 15.4142 17.75 15C17.75 14.5858 17.4142 14.25 17 14.25H15.6667C14.6887 14.25 13.75 13.3281 13.75 12C13.75 10.6719 14.6887 9.75 15.6667 9.75H17C17.4142 9.75 17.75 9.41421 17.75 9C17.75 8.58579 17.4142 8.25 17 8.25H15.6667C13.6991 8.25 12.25 10.0144 12.25 12C12.25 13.9856 13.6991 15.75 15.6667 15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "cc-disabled-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["closed-caption","cc","disabled","unavailable","not-available","prohibited","restricted","settings-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14L11 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H15C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "cc-disabled-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cc","closed-captions","disabled","unavailable","not-available","blocked","restricted","not-allowed","prohibited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14L11 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H15C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14L16 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "cc-disabled-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["disabled","not-allowed","restricted","unavailable","closed-captions-off","cc-off","off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294H10.9294H10.9294C9.57529 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57526 4 10.9293V10.9294V10.9294V13.0706V13.0706V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.19596 16.9993 4.32955 17.532 4.57568 18.0101L8.19177 14.394C7.46779 13.8463 7.00001 12.9778 7.00001 12C7.00001 10.3431 8.34315 9 10 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11L10 11C9.44772 11 9.00001 11.4477 9.00001 12C9.00001 12.4288 9.26991 12.7946 9.64909 12.9367L18.0101 4.57568C17.532 4.32955 16.9993 4.19596 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4H13.0706H13.0706ZM19.4243 5.98989L16.3509 9.0633C16.7301 9.20542 17 9.57119 17 10C17 10.5523 16.5523 11 16 11L15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15C13.7603 15 12.6962 14.248 12.239 13.1753L11.8834 13.5309C11.9578 13.6708 12 13.8305 12 14C12 14.5523 11.5523 15 11 15H10.4142L5.98989 19.4243C6.46804 19.6705 7.00073 19.8041 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V10.9294C20 9.57531 20.0001 8.4587 19.8813 7.57494C19.8041 7.00073 19.6705 6.46804 19.4243 5.98989Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "CD-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cd","disc","music","data","storage","backup","restore","media","audio","video","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cc-disabled": {
        defaultColors: ["#3D4C66"],
        keywords: ["closed-caption","cc","disabled","unavailable","not-available","subtitles-off","subtitles-disabled","audio-description-off","accessibility-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14L11 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H15C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    CC: {
        defaultColors: ["#3D4C66"],
        keywords: ["closed-caption","cc","disabled","unavailable","not-available","subtitles-off","subtitles-disabled","audio-description-off","accessibility-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14L11 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10H15C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CD-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["connection","status","network","device","connected","settings","pairing","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "CD-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["blueberry","fruit","menu","item","dessert","ingredient","topping","food","pastry","smoothie","juice","breakfast","snack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.1154 7C9.29024 7 7 9.29024 7 12.1154C7 12.5615 7.36162 12.9231 7.80769 12.9231C8.25377 12.9231 8.61538 12.5615 8.61538 12.1154C8.61538 10.1824 10.1824 8.61538 12.1154 8.61538C12.5615 8.61538 12.9231 8.25377 12.9231 7.80769C12.9231 7.36162 12.5615 7 12.1154 7ZM12.1154 10.2308C11.0745 10.2308 10.2308 11.0745 10.2308 12.1154C10.2308 13.1562 11.0745 14 12.1154 14C13.1562 14 14 13.1562 14 12.1154C14 11.0745 13.1562 10.2308 12.1154 10.2308Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    CD: {
        defaultColors: ["#3D4C66"],
        keywords: ["blueberry","fruit","menu","item","dessert","ingredient","topping","food","pastry","smoothie","juice","breakfast","snack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "celebration-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["celebration","party","confetti","reward","achievement","discount","promotion","special offer","loyalty","event","surprise","gift","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20L18 10H6L12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 4L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 6C7.10457 6 8 6.89543 8 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6C16.8954 6 16 6.89543 16 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "celebration-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["celebration","party","discount","promotion","special-offer","coupon","voucher","event","sale","achievement","reward","congratulations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20L18 10H6L12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 4L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 6C7.10457 6 8 6.89543 8 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6C16.8954 6 16 6.89543 16 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "celebration-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["celebration","discount","promotion","special-offer","reward","loyalty","gift","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.1298 9.5073C5.30731 9.19379 5.63973 9 6 9H18C18.3603 9 18.6927 9.19379 18.8702 9.5073C19.0477 9.82081 19.0429 10.2056 18.8575 10.5145L12.8575 20.5145C12.6768 20.8157 12.3513 21 12 21C11.6487 21 11.3232 20.8157 11.1425 20.5145L5.14251 10.5145C4.95715 10.2056 4.95229 9.82081 5.1298 9.5073Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C12.5523 2 13 2.44772 13 3V7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7V3C11 2.44772 11.4477 2 12 2ZM5 5C5 4.44772 5.44772 4 6 4C7.65685 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44771 6.55228 6 6 6C5.44772 6 5 5.55228 5 5ZM15 7C15 5.34315 16.3431 4 18 4C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6C17.4477 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    celebration: {
        defaultColors: ["#3D4C66"],
        keywords: ["celebration","discount","promotion","special-offer","reward","loyalty","gift","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20L18 10H6L12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 4L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 6C7.10457 6 8 6.89543 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6C16.8954 6 16 6.89543 16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "celsius-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["celsius","temperature","degree","weather","cold","hot","thermometer","temperature-setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 15C19 16.6569 17.6569 18 16 18C14.3431 18 13 16.6569 13 15V9C13 7.34315 14.3431 6 16 6C17.6569 6 19 7.34315 19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "celsius-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["celsius","temperature","degree","weather","climate","cold","hot","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 15C19 16.6569 17.6569 18 16 18C14.3431 18 13 16.6569 13 15V9C13 7.34315 14.3431 6 16 6C17.6569 6 19 7.34315 19 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" fill={colors?.[1] || "#3D4C66"} stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "celsius-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["celsius","temperature","weather","degree","heat","cold","climate","temperature-setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5C5.34315 5 4 6.34315 4 8C4 9.65685 5.34315 11 7 11C8.65685 11 10 9.65685 10 8C10 6.34315 8.65685 5 7 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 7C14.8954 7 14 7.89543 14 9V15C14 16.1046 14.8954 17 16 17C17.1046 17 18 16.1046 18 15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15C20 17.2091 18.2091 19 16 19C13.7909 19 12 17.2091 12 15V9C12 6.79086 13.7909 5 16 5C18.2091 5 20 6.79086 20 9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9C18 7.89543 17.1046 7 16 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    celsius: {
        defaultColors: ["#3D4C66"],
        keywords: ["celsius","temperature","weather","degree","heat","cold","climate","temperature-setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 15C19 16.6569 17.6569 18 16 18C14.3431 18 13 16.6569 13 15V9C13 7.34315 14.3431 6 16 6C17.6569 6 19 7.34315 19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "cent-sign-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cent","cents","currency","price","change","discount","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 6L13 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 20L13 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6.56482C13.6065 5.5001 10.677 5.94793 8.75867 7.84692C6.41378 10.1681 6.41378 13.8319 8.75867 16.1531C10.677 18.0521 13.6065 18.4999 16 17.4352"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cent-sign-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cent","currency","discount","price","change","small-change","cents","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 6L13 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 20L13 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6.56482C13.6065 5.5001 10.677 5.94793 8.75867 7.84692C6.41378 10.1681 6.41378 13.8319 8.75867 16.1531C10.677 18.0521 13.6065 18.4999 16 17.4352"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cent-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cent","currency","price","discount","change","money","payment","cash","cents"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 3C13.5523 3 14 3.44771 14 4L14 5.0303C14.825 5.10344 15.6399 5.31014 16.4064 5.65114C16.9111 5.87562 17.1381 6.46666 16.9137 6.97126C16.6892 7.47587 16.0982 7.70297 15.5936 7.47849C13.5581 6.57303 11.0736 6.96246 9.46218 8.5576C7.51261 10.4875 7.51261 13.5125 9.46218 15.4424C11.0736 17.0375 13.5581 17.427 15.5936 16.5215C16.0982 16.297 16.6892 16.5241 16.9137 17.0287C17.1381 17.5333 16.9111 18.1244 16.4064 18.3489C15.6399 18.6899 14.825 18.8966 14 18.9697L14 20C14 20.5523 13.5523 21 13 21C12.4477 21 12 20.5523 12 20L12 18.8856C10.5465 18.6321 9.15933 17.9568 8.05516 16.8638C5.31495 14.1512 5.31495 9.84878 8.05516 7.13623L8.75867 7.84692L8.05516 7.13623C9.15933 6.04321 10.5465 5.3679 12 5.1144L12 4C12 3.44772 12.4477 3 13 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "cent-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["cent","cents","currency","price","discount","change","money","value","coin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 6L13 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 20L13 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6.56482C13.6065 5.5001 10.677 5.94793 8.75867 7.84692C6.41378 10.1681 6.41378 13.8319 8.75867 16.1531C10.677 18.0521 13.6065 18.4999 16 17.4352"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "center-align-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["align","center","text","layout","alignment","justify","formatting","edit","interface","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L12 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 9H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "center-align-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["center","align","center-align","layout","format","text-alignment","position","justify","content"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 9H7" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H9" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "center-align-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["center","align","justify","text-alignment","formatting","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C11.4477 4 11 4.44772 11 5V8H7C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H11V13H9C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H13V10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H13V5C13 4.44772 12.5523 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "center-align": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","center","justify","text-alignment","format","formatting","paragraph"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 9H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "character-recognition-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["OCR","optical character recognition","text recognition","scan","scanning","item recognition","automatic","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L12 9L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H12H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "character-recognition-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ocr","character recognition","scan","text","identify","alphabet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L12 9L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "character-recognition-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ocr","character recognition","text recognition","scan","scan-text","item-description","product-identification","automatic","character"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 3L9.81246 3C8.51405 2.99997 7.44322 2.99994 6.59272 3.10989C5.70105 3.22517 4.90941 3.476 4.26182 4.08413C4.20074 4.14148 4.14148 4.20074 4.08413 4.26181C3.476 4.90941 3.22517 5.70105 3.10989 6.59272C2.99994 7.44322 2.99997 8.51401 3 9.81241L3 10C3 10.5523 3.44772 11 4 11C4.55229 11 5 10.5523 5 10V9.88C5 8.49702 5.00197 7.55633 5.09339 6.84914C5.18139 6.16842 5.3371 5.84918 5.54207 5.63091C5.57074 5.60037 5.60037 5.57074 5.63091 5.54207C5.84918 5.3371 6.16842 5.18139 6.84914 5.09339C7.55633 5.00196 8.49702 5 9.88 5H10C10.5523 5 11 4.55229 11 4C11 3.44772 10.5523 3 10 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 3L14.1875 3C15.4859 2.99997 16.5568 2.99994 17.4073 3.10989C18.299 3.22517 19.0906 3.476 19.7382 4.08413C19.7993 4.14148 19.8585 4.20074 19.9159 4.26181C20.524 4.90941 20.7748 5.70105 20.8901 6.59272C21.0001 7.44323 21 8.51404 21 9.81246V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V9.88C19 8.49702 18.998 7.55633 18.9066 6.84914C18.8186 6.16842 18.6629 5.84918 18.4579 5.63091C18.4293 5.60037 18.3996 5.57074 18.3691 5.54207C18.1508 5.3371 17.8316 5.18139 17.1509 5.09339C16.4437 5.00196 15.503 5 14.12 5H14C13.4477 5 13 4.55229 13 4C13 3.44772 13.4477 3 14 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.1875 21L14 21C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19H14.12C15.503 19 16.4437 18.998 17.1509 18.9066C17.8316 18.8186 18.1508 18.6629 18.3691 18.4579C18.3996 18.4293 18.4293 18.3996 18.4579 18.3691C18.6629 18.1508 18.8186 17.8316 18.9066 17.1509C18.998 16.4437 19 15.503 19 14.12V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14L21 14.1875C21 15.486 21.0001 16.5568 20.8901 17.4073C20.7748 18.299 20.524 19.0906 19.9159 19.7382C19.8585 19.7993 19.7993 19.8585 19.7382 19.9159C19.0906 20.524 18.299 20.7748 17.4073 20.8901C16.5568 21.0001 15.486 21 14.1875 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 21L9.81246 21C8.51404 21 7.44323 21.0001 6.59272 20.8901C5.70105 20.7748 4.90941 20.524 4.26182 19.9159C4.20074 19.8585 4.14148 19.7993 4.08413 19.7382C3.476 19.0906 3.22517 18.299 3.10989 17.4073C2.99994 16.5568 2.99997 15.486 3 14.1876L3 14C3 13.4477 3.44772 13 4 13C4.55229 13 5 13.4477 5 14V14.12C5 15.503 5.00197 16.4437 5.09339 17.1509C5.18139 17.8316 5.3371 18.1508 5.54207 18.3691C5.57074 18.3996 5.60037 18.4293 5.63091 18.4579C5.84918 18.6629 6.16842 18.8186 6.84914 18.9066C7.55633 18.998 8.49702 19 9.88 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0002 8C12.379 8 12.7253 8.214 12.8946 8.55279L14.8919 12.5473C14.894 12.5514 14.896 12.5554 14.898 12.5595L15.8946 14.5528C16.1416 15.0468 15.9414 15.6474 15.4474 15.8944C14.9535 16.1414 14.3528 15.9412 14.1058 15.4472L13.3822 14H10.6183L9.89465 15.4472C9.64766 15.9412 9.04699 16.1414 8.55301 15.8944C8.05903 15.6474 7.8588 15.0468 8.10579 14.5528L9.09255 12.5793C9.10064 12.5619 9.10922 12.5447 9.11826 12.5278L11.1058 8.55279C11.2752 8.214 11.6214 8 12.0002 8ZM11.6183 12H12.3822L12.0002 11.2361L11.6183 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "charging-plug-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["power","charge","charging","plug","electricity","device","outlet","connected","battery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 20C14.5951 19.8901 14.1799 19.8397 13.7643 19.8501C11.7167 19.8501 12.0152 18.1623 12.0152 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12V9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V12C17 12.9428 17 13.4142 16.7071 13.7071C16.4142 14 15.9428 14 15 14H9C8.05719 14 7.58579 14 7.29289 13.7071C7 13.4142 7 12.9428 7 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14V16C14 16.5523 13.5523 17 13 17H11C10.4477 17 10 16.5523 10 16V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L9 5C9 4.44772 9.44772 4 10 4L14 4C14.5523 4 15 4.44771 15 5L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "character-recognition": {
        defaultColors: ["#3D4C66"],
        keywords: ["OCR","text-recognition","scan","character-recognition","alphabet","letter","A","scan-text","scan-character"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L12 9L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13H12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "charging-plug-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["power","charging","plug","electricity","charge","device","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9999 6.02181C16 6.01455 16 6.00728 16 6V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V6C8 6.00728 8.00004 6.01455 8.00012 6.02181C7.92026 6.02788 7.84318 6.03564 7.76949 6.04554C7.38629 6.09706 6.94902 6.22259 6.5858 6.5858C6.22259 6.94902 6.09706 7.38629 6.04554 7.7695C5.99984 8.10941 5.99992 8.52154 6.00001 8.94561V12.0544C5.99992 12.4785 5.99984 12.8906 6.04554 13.2305C6.09706 13.6137 6.22259 14.051 6.5858 14.4142C6.94902 14.7774 7.38629 14.903 7.76949 14.9545C8.10941 15.0002 8.52153 15.0001 8.9456 15H15.0544C15.4785 15.0001 15.8906 15.0002 16.2305 14.9545C16.6137 14.903 17.051 14.7774 17.4142 14.4142C17.7774 14.051 17.903 13.6137 17.9545 13.2305C18.0002 12.8906 18.0001 12.4785 18 12.0544V8.9456C18.0001 8.52154 18.0002 8.1094 17.9545 7.7695C17.903 7.38629 17.7774 6.94902 17.4142 6.5858C17.051 6.22259 16.6137 6.09706 16.2305 6.04554C16.1568 6.03564 16.0798 6.02788 15.9999 6.02181Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 16C15 17.1039 14.1057 17.9989 13.002 18C13.0088 18.2479 13.0331 18.4271 13.0744 18.5564C13.1137 18.6794 13.1549 18.7178 13.1887 18.7407C13.2336 18.7712 13.3812 18.8486 13.7534 18.85C14.2621 18.8387 14.769 18.9011 15.262 19.0349C15.795 19.1796 16.1098 19.729 15.9651 20.262C15.8204 20.795 15.271 21.1098 14.738 20.9651C14.4256 20.8803 14.1072 20.8418 13.7892 20.8497C13.7809 20.85 13.7726 20.8501 13.7643 20.8501C13.1207 20.8501 12.5402 20.7176 12.0657 20.3957C11.5795 20.0658 11.3114 19.6096 11.1694 19.1654C11.0401 18.7609 11.0081 18.3454 11.0015 18H11C9.89543 18 9 17.1046 9 16H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "charging-plug-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["charging","plug","electricity","device","power","outlet","charger","battery","charge","adapter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16V15C14 14.4477 13.5523 14 13 14H11C10.4477 14 10 14.4477 10 15V16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5L9 6C9 6.55229 9.44772 7 10 7L14 7C14.5523 7 15 6.55228 15 6L15 5C15 4.44771 14.5523 4 14 4L10 4C9.44772 4 9 4.44772 9 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12V9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V12C17 12.9428 17 13.4142 16.7071 13.7071C16.4142 14 15.9428 14 15 14H9C8.05719 14 7.58579 14 7.29289 13.7071C7 13.4142 7 12.9428 7 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 20C14.5951 19.8901 14.1799 19.8397 13.7643 19.8501C11.7167 19.8501 12.0152 18.1623 12.0152 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "charging-plug": {
        defaultColors: ["#3D4C66"],
        keywords: ["charging","plug","power","charge","electricity","device","electric","charger"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12V9C7 8.05719 7 7.58579 7.29289 7.29289C7.58579 7 8.05719 7 9 7H15C15.9428 7 16.4142 7 16.7071 7.29289C17 7.58579 17 8.05719 17 9V12C17 12.9428 17 13.4142 16.7071 13.7071C16.4142 14 15.9428 14 15 14H9C8.05719 14 7.58579 14 7.29289 13.7071C7 13.4142 7 12.9428 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14V16C14 16.5523 13.5523 17 13 17H11C10.4477 17 10 16.5523 10 16V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L9 5C9 4.44772 9.44772 4 10 4L14 4C14.5523 4 15 4.44771 15 5L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20C14.5951 19.8901 14.1799 19.8397 13.7643 19.8501C11.7167 19.8501 12.0152 18.1623 12.0152 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chart-Growth-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["arrow","growth","increase","sales","trend","up","statistics","analytics","positive","profit","rise","earnings","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 17.5L14 10M14 10H10M14 10V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Chart-Growth-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","right","growth","increase","sales","trending","analytics","reports","summary","progress","forward","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.5 17.5L14 10M14 10H10M14 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chart-Growth": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","direction","sales","growth","increase","trending-up","next","forward","checkout","continue","proceed","progress","submit","done","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6.5 17.5L14 10M14 10H10M14 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chart-Growth-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["growth","arrow","up","trend","sales","increase","profit","revenue","analytics","reporting","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C9.87499 21 7.92199 20.2635 6.38231 19.0319L13 12.4142V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H10C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H11.5858L4.9681 17.6177C3.73647 16.078 3 14.125 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chart-pie-slice-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["chart","pie","slice","statistics","report","analytics","sales","performance","dashboard","data","segment","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12H12M12 5V12M12 12L7.05029 16.9497"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Chart-pie-slice-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["pie-chart","chart","slice","statistics","sales","reports","analytics","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 13.9073 5.76281 15.6364 7 16.899L12 12V5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 19C15.866 19 19 15.866 19 12H12L7.05029 16.9497C8.31283 18.1869 10.0927 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19 12H19.75V11.25H19V12ZM7.05029 16.9497L6.51996 16.4194L5.98423 16.9552L6.52537 17.4854L7.05029 16.9497ZM12 12V11.25C11.8011 11.25 11.6104 11.329 11.4697 11.4697L12 12ZM18.25 12C18.25 15.4518 15.4518 18.25 12 18.25V19.75C16.2802 19.75 19.75 16.2802 19.75 12H18.25ZM12 18.25C10.3045 18.25 8.70907 17.5252 7.57522 16.4141L6.52537 17.4854C7.91659 18.8487 9.88088 19.75 12 19.75V18.25ZM12 12.75H19V11.25H12V12.75ZM11.4697 11.4697L6.51996 16.4194L7.58062 17.4801L12.5304 12.5303L11.4697 11.4697Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5V12H19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Chart-pie-slice-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","pie","slice","analytics","report","sales","dashboard","statistics","performance","segment","division","portion","overview","data","diagram"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.03 4C7.07 4.49 4 7.87 4 11.97C4 13.83 4.63 15.53 5.69 16.89L11.03 11.55V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.10999 18.31C8.46999 19.37 10.18 20 12.03 20C16.13 20 19.51 16.93 20 12.97H12.45L7.10999 18.31Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M13.03 4V10.96H20C19.55 7.33 16.67 4.45 13.03 4Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "Chart-pie-slice-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["clock","time","schedule","deadline","timer","late","overtime","shift","hours","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H12V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Chart-pie-slice-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chart","pie","slice","sales-report","statistics","analytics","data-analysis","revenue","performance","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M19 12C19 8.13401 15.866 5 12 5V12H19Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    d="M12 5V4.25H11.25V5H12ZM19 12V12.75H19.75V12H19ZM12 12H11.25C11.25 12.4142 11.5858 12.75 12 12.75V12ZM12 5.75C15.4518 5.75 18.25 8.54822 18.25 12H19.75C19.75 7.71979 16.2802 4.25 12 4.25V5.75ZM11.25 5V12H12.75V5H11.25ZM12 12.75H19V11.25H12V12.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chart-pie-slice-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","pie","slice","report","statistics","sales","analytics","dashboard","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM11 6.08296C8.16229 6.55904 6 9.027 6 12C6 15.3137 8.68629 18 12 18C14.973 18 17.441 15.8377 17.917 13H12C11.4477 13 11 12.5523 11 12V6.08296Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chart-pie-slice": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","pie","slice","statistics","sales-data","analytics","dashboard","reporting","trends","inventory-analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C10.067 19 8.317 18.2165 7.05025 16.9497M19 12C19 8.13401 15.866 5 12 5M19 12H12M12 5C8.13401 5 5 8.13401 5 12C5 13.933 5.7835 15.683 7.05025 16.9497M12 5V12M12 12L7.05025 16.9497"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","comment","feedback","notes","communication","customer-service","support","conversation","dialogue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.8822 5.36042L10.7442 4.84317C7.60086 4.45025 6.02918 4.25379 5.01459 5.14946C4 6.04512 4 7.62902 4 10.7968V12.0001C4 13.8694 4 14.804 4.40192 15.5001C4.66523 15.9562 5.04394 16.3349 5.5 16.5982C5.83717 16.7929 6.23028 16.8933 6.75843 16.945C7.93888 17.0607 8.52911 17.1186 8.9179 17.2713C9.06071 17.3275 9.14783 17.3686 9.28184 17.4434C9.64668 17.6468 9.95971 17.9599 10.5858 18.5859L10.5858 18.5859C11.2525 19.2526 11.5858 19.5859 12 19.5859C12.4142 19.5859 12.7475 19.2526 13.4142 18.5859C14.0403 17.9599 14.3533 17.6468 14.7182 17.4434C14.8522 17.3686 14.9393 17.3275 15.0821 17.2713C15.4709 17.1186 16.0611 17.0607 17.2416 16.945C17.7697 16.8933 18.1628 16.7929 18.5 16.5982C18.9561 16.3349 19.3348 15.9562 19.5981 15.5001C20 14.804 20 13.8694 20 12.0001V11.1577C20 8.77154 20 7.57844 19.3228 6.74993C19.2747 6.6911 19.2244 6.63411 19.172 6.5791C18.4339 5.80438 17.25 5.65639 14.8822 5.36042Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chart-pie-slice-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","pie","slice","report","sales","analytics","dashboard","statistics","performance","overview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 12H12V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "chat-bubble-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","bubble","message","support","customer-service","feedback","questions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12C16 12.8284 15.3284 13.5 14.5 13.5C13.6716 13.5 13 12.8284 13 12C13 11.1716 13.6716 10.5 14.5 10.5C15.3284 10.5 16 11.1716 16 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "chat-bubble-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","customer-support","feedback","comment","notes","dialog","notification","conversation","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58171 4 4.00001 7.58186 4.00001 12.0001C4.00001 13.2829 4.30267 14.4974 4.84093 15.5739L4.06355 17.6492C3.94852 17.9563 3.99136 18.3003 4.17818 18.5697C4.36501 18.8392 4.67209 19 5.00001 19H8.35555C9.39279 19.546 10.6367 20 12 20C16.4183 20 20 16.4183 20 12.0001C20 7.58186 16.4183 4 12 4ZM9.5 10C8.39543 10 7.5 10.8954 7.5 12C7.5 13.1046 8.39543 14 9.5 14C10.6046 14 11.5 13.1046 11.5 12C11.5 10.8954 10.6046 10 9.5 10ZM14.5 10C13.3954 10 12.5 10.8954 12.5 12C12.5 13.1046 13.3954 14 14.5 14C15.6046 14 16.5 13.1046 16.5 12C16.5 10.8954 15.6046 10 14.5 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-bubble-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","bubble","comments","feedback","support","conversation","customer-service","notification","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 12C16 12.8284 15.3284 13.5 14.5 13.5C13.6716 13.5 13 12.8284 13 12C13 11.1716 13.6716 10.5 14.5 10.5C15.3284 10.5 16 11.1716 16 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","communication","support","feedback","comments","conversation","bubble","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11.1576C20 8.77139 20 7.5783 19.3228 6.74979C19.2747 6.69095 19.2244 6.63397 19.172 6.57895C18.4339 5.80424 17.25 5.65625 14.8822 5.36028L10.7442 4.84303C7.60086 4.45011 6.02918 4.25365 5.01459 5.14931C4 6.04498 4 7.62888 4 10.7967V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-bubble": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","support","feedback","customer-service","communication","bubble","owl"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12C16 12.8284 15.3284 13.5 14.5 13.5C13.6716 13.5 13 12.8284 13 12C13 11.1716 13.6716 10.5 14.5 10.5C15.3284 10.5 16 11.1716 16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Chat-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","dollar","money","payment","price","cost","sales","message","notification","promotion","discount","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.16527 16.9822 7.04832 16.9992 8.75672 17C8.91208 17 9.06172 17.0617 9.17157 17.1716C10.5049 18.5049 11.1716 19.1716 12 19.1716C12.8284 19.1716 13.4951 18.5049 14.8284 17.1716C14.9383 17.0617 15.0879 17 15.2433 17C16.9517 16.9992 17.8347 16.9822 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 8H13M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","dollar","payment","message","price","notification","finance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L14.8284 17.1716C13.4951 18.5049 12.8284 19.1716 12 19.1716C11.1716 19.1716 10.5049 18.5049 9.17157 17.1716L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 8H13M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","chat","message","payment","transaction","finance","currency","sales","price","bill","invoice","cost","amount","charge","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0549 3.25H9.94513C8.57754 3.24998 7.47521 3.24996 6.60825 3.36652C5.70814 3.48754 4.95027 3.74643 4.34835 4.34835C3.74643 4.95027 3.48754 5.70814 3.36652 6.60825C3.24996 7.47521 3.24998 8.57753 3.25 9.94511V12.0358C3.24999 12.94 3.24999 13.6693 3.3033 14.2576C3.35826 14.8639 3.47456 15.3938 3.75241 15.875C4.08154 16.4451 4.55493 16.9185 5.125 17.2476C5.58505 17.5132 6.08903 17.631 6.66168 17.689C7.20907 17.7444 7.87565 17.7494 8.68927 17.7499C9.31957 18.3803 9.84589 18.906 10.3202 19.2678C10.8238 19.6521 11.3559 19.9216 12 19.9216C12.6441 19.9216 13.1762 19.6521 13.6798 19.2678C14.1541 18.906 14.6804 18.3803 15.3107 17.7499C16.1244 17.7494 16.7909 17.7444 17.3383 17.689C17.911 17.631 18.4149 17.5132 18.875 17.2476C19.4451 16.9185 19.9185 16.4451 20.2476 15.875C20.5254 15.3938 20.6417 14.8639 20.6967 14.2576C20.75 13.6693 20.75 12.94 20.75 12.0358V9.94513C20.75 8.57754 20.75 7.47522 20.6335 6.60825C20.5125 5.70814 20.2536 4.95027 19.6517 4.34835C19.0497 3.74643 18.2919 3.48754 17.3918 3.36652C16.5248 3.24996 15.4225 3.24998 14.0549 3.25ZM12.25 7C12.25 6.58579 11.9142 6.25 11.5 6.25C11.0858 6.25 10.75 6.58579 10.75 7V7.37803C9.87611 7.68691 9.25 8.52034 9.25 9.5C9.25 10.7426 10.2574 11.75 11.5 11.75H12.3333C12.9159 11.75 13.25 12.1582 13.25 12.5C13.25 12.8418 12.9159 13.25 12.3333 13.25H10C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H10.75V15C10.75 15.4142 11.0858 15.75 11.5 15.75C11.9142 15.75 12.25 15.4142 12.25 15V14.75H12.3333C13.5917 14.75 14.75 13.815 14.75 12.5C14.75 11.185 13.5917 10.25 12.3333 10.25H11.5C11.0858 10.25 10.75 9.91421 10.75 9.5C10.75 9.08579 11.0858 8.75 11.5 8.75H13C13.4142 8.75 13.75 8.41421 13.75 8C13.75 7.58579 13.4142 7.25 13 7.25H12.25V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","support","feedback","comment","notes","dialog","conversation","query","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0998 6.06854C20.0398 5.98854 19.9697 5.91855 19.8997 5.83855C18.9198 4.80855 17.5298 4.62854 15.0098 4.31854L10.8698 3.79854C7.53975 3.37854 5.70974 3.14855 4.35974 4.34855C3.00974 5.53855 3.00977 7.38854 3.00977 10.7485V11.9485C3.00977 13.9285 3.00974 15.0185 3.54974 15.9485C3.89974 16.5585 4.40977 17.0585 5.00977 17.4085C5.45977 17.6685 5.96976 17.8185 6.68976 17.8885C7.69976 17.9885 8.29975 18.0485 8.55975 18.1485C8.65975 18.1885 8.70974 18.2185 8.79974 18.2685C9.03974 18.4085 9.32976 18.6885 9.87976 19.2485C10.6598 20.0285 11.1698 20.5385 11.9998 20.5385C12.8298 20.5385 13.3398 20.0285 14.1198 19.2485C14.6798 18.6885 14.9598 18.4085 15.1998 18.2685C15.2898 18.2185 15.3498 18.1885 15.4398 18.1485C15.6998 18.0485 16.3097 17.9885 17.3297 17.8885C18.0297 17.8185 18.5397 17.6685 18.9897 17.4085C19.5997 17.0585 20.0998 16.5485 20.4498 15.9485C20.9898 15.0185 20.9897 13.9285 20.9897 11.9485V11.1085C20.9897 8.56855 20.9898 7.16854 20.0898 6.06854H20.0998ZM12.9998 13.9485H8.99976C8.44976 13.9485 7.99976 13.4985 7.99976 12.9485C7.99976 12.3985 8.44976 11.9485 8.99976 11.9485H12.9998C13.5498 11.9485 13.9998 12.3985 13.9998 12.9485C13.9998 13.4985 13.5498 13.9485 12.9998 13.9485ZM14.9998 9.94855H8.99976C8.44976 9.94855 7.99976 9.49855 7.99976 8.94855C7.99976 8.39855 8.44976 7.94855 8.99976 7.94855H14.9998C15.5498 7.94855 15.9998 8.39855 15.9998 8.94855C15.9998 9.49855 15.5498 9.94855 14.9998 9.94855Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chat-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","chat","speech-bubble","price","cost","payment","sale","discount","finance","transaction","estimate","billing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L14.8284 17.1716C13.4951 18.5049 12.8284 19.1716 12 19.1716C11.1716 19.1716 10.5049 18.5049 9.17157 17.1716L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 8H13M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-history-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","history","time","log","clock","schedule","appointment","reservation","chat-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10V11C11 11.9428 11 12.4142 11.2929 12.7071C11.5858 13 12.0572 13 13 13H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-history-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","history","log","time","clock","chat-history","order-history","support-history","conversation","past-orders","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10V11C11 11.9428 11 12.4142 11.2929 12.7071C11.5858 13 12.0572 13 13 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-history-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["history","chat","time","clock","past","conversation-history","order-history","chat-log"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0049 4C7.59492 4 4.00492 7.59 4.00492 12C4.00492 13.24 4.29494 14.47 4.84494 15.57L4.06492 17.65C3.94492 17.96 3.99491 18.3 4.18491 18.57C4.37491 18.84 4.67492 19 5.00492 19H8.35489C9.63489 19.67 10.8249 20 12.0049 20C16.4149 20 20.0049 16.41 20.0049 12C20.0049 7.59 16.4149 4 12.0049 4ZM14.0049 14H13.0049C11.9049 14 11.1749 14 10.5949 13.41C10.0149 12.82 10.0049 12.1 10.0049 11V10C10.0049 9.45 10.4549 9 11.0049 9C11.5549 9 12.0049 9.45 12.0049 10V11C12.0049 11.37 12.0049 11.77 12.0349 11.97C12.2349 12 12.6449 12 13.0049 12H14.0049C14.5549 12 15.0049 12.45 15.0049 13C15.0049 13.55 14.5549 14 14.0049 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chat-history": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","history","clock","time","message","order-history","transaction-history","purchase-history","conversation","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10V11C11 11.9428 11 12.4142 11.2929 12.7071C11.5858 13 12.0572 13 13 13H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Chat-private-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","private","lock","security","secure-chat","encrypted","confidential","message","bubble","admin","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="9"
                    y="12"
                    width="6"
                    height="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12V11C14 9.89543 13.1046 9 12 9V9C10.8954 9 10 9.89543 10 11V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Chat-private-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","private","lock","secure","message","encrypted","authentication","security","safe-chat","private-message"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="9"
                    y="12"
                    width="6"
                    height="3"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12V11C14 9.89543 13.1046 9 12 9V9C10.8954 9 10 9.89543 10 11V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Chat-private-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","private","lock","secure","message","communication","encrypted-communication","secure-message","secure-chat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58171 4 4.00001 7.58186 4.00001 12.0001C4.00001 13.2829 4.30267 14.4974 4.84093 15.5739L4.06355 17.6492C3.94852 17.9563 3.99136 18.3003 4.17818 18.5697C4.36501 18.8392 4.67209 19 5.00001 19H8.35555C9.39279 19.546 10.6367 20 12 20C16.4183 20 20 16.4183 20 12.0001C20 7.58186 16.4183 4 12 4ZM12 8.25C10.4812 8.25 9.25 9.48122 9.25 11V11.275C8.67944 11.3908 8.25 11.8953 8.25 12.5V14.5C8.25 15.1904 8.80964 15.75 9.5 15.75H14.5C15.1904 15.75 15.75 15.1904 15.75 14.5V12.5C15.75 11.8953 15.3206 11.3908 14.75 11.275V11C14.75 9.48122 13.5188 8.25 12 8.25ZM13.25 11V11.25H10.75V11C10.75 10.3096 11.3096 9.75 12 9.75C12.6904 9.75 13.25 10.3096 13.25 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chat-private": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","private","lock","secure","communication","security","message","encryption","safe-chat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="9"
                    y="12"
                    width="6"
                    height="3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12V11C14 9.89543 13.1046 9 12 9V9C10.8954 9 10 9.89543 10 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "chat-reply v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","reply","comment","feedback","customer-service","support","dialog","conversation","equal","comparison","compare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H14M10 14H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-reply v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","reply","customer-service","feedback","comment","communication","notes","customer-notes","order-notes","equals","chat-reply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H14M10 14H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-reply v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","notes","comments","feedback","customer-feedback","order-notes","support","assistance","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0049 4C7.59492 4 4.00492 7.59 4.00492 12C4.00492 13.24 4.29491 14.47 4.84491 15.57L4.06492 17.65C3.94492 17.96 3.99491 18.3 4.18491 18.57C4.37491 18.84 4.67492 19 5.00492 19H8.35492C9.63492 19.67 10.8249 20 12.0049 20C16.4149 20 20.0049 16.41 20.0049 12C20.0049 7.59 16.4149 4 12.0049 4ZM14.0049 15H10.0049C9.45492 15 9.00492 14.55 9.00492 14C9.00492 13.45 9.45492 13 10.0049 13H14.0049C14.5549 13 15.0049 13.45 15.0049 14C15.0049 14.55 14.5549 15 14.0049 15ZM14.0049 11H10.0049C9.45492 11 9.00492 10.55 9.00492 10C9.00492 9.45 9.45492 9 10.0049 9H14.0049C14.5549 9 15.0049 9.45 15.0049 10C15.0049 10.55 14.5549 11 14.0049 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-reply v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","feedback","support","communication","notification","comment","dialog","contact","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H14M10 14H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-reply-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","reply","text","comment","feedback","communication","note","notification","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V19H12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-reply-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","reply","message","support","feedback","customer-service","comments","notes","communication","dialogue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V19H12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-reply-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","reply","message","comment","feedback","conversation","notes","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.59 4 4 7.59 4 12V19C4 19.55 4.45 20 5 20H12C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM11 8H13C13.55 8 14 8.45 14 9C14 9.55 13.55 10 13 10H11C10.45 10 10 9.55 10 9C10 8.45 10.45 8 11 8ZM13 16H11C10.45 16 10 15.55 10 15C10 14.45 10.45 14 11 14H13C13.55 14 14 14.45 14 15C14 15.55 13.55 16 13 16ZM14 13H10C9.45 13 9 12.55 9 12C9 11.45 9.45 11 10 11H14C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-reply": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","reply","comment","feedback","note","communication","customer-service","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V19H12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-slash-1": {
        defaultColors: ["#3D4C66", "#8E5EE5"],
        keywords: ["chat","message","blocked","disabled","muted","no-messages","chat-off","message-off","communication-off","communication-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16V16C15.8692 16 16.8038 16 17.5 15.5981C17.9561 15.3348 18.3348 14.9561 18.5981 14.5C19 13.8038 19 12.8692 19 11V11C19 9.13077 19 8.19615 18.5981 7.5C18.3348 7.04394 17.9561 6.66523 17.5 6.40192C16.8038 6 15.8692 6 14 6H10C8.13077 6 7.19615 6 6.5 6.40192C6.04394 6.66523 5.66523 7.04394 5.40192 7.5C5 8.19615 5 9.13077 5 11V11C5 12.8692 5 13.8038 5.40192 14.5C5.66523 14.9561 6.04394 15.3348 6.5 15.5981C7.19615 16 8.13077 16 10 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16L13.6641 16.5038C12.9115 17.6328 12.5352 18.1972 12 18.1972C11.4648 18.1972 11.0885 17.6328 10.3359 16.5038L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#8E5EE5"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chat-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","slash","disabled","mute","no-messages","unavailable","communication-error","offline","support-unavailable","chat-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6H10C8.13077 6 7.19615 6 6.5 6.40192C6.04394 6.66523 5.66523 7.04394 5.40192 7.5C5 8.19615 5 9.13077 5 11C5 12.8692 5 13.8038 5.40192 14.5C5.66523 14.9561 6.04394 15.3348 6.5 15.5981C7.11648 15.954 7.91996 15.9947 9.39389 15.9994C9.7722 16.0006 10.126 16.1891 10.3359 16.5038C11.0885 17.6328 11.4648 18.1972 12 18.1972C12.5352 18.1972 12.9115 17.6328 13.6641 16.5038C13.874 16.1891 14.2278 16.0006 14.6061 15.9994C16.08 15.9947 16.8835 15.954 17.5 15.5981C17.9561 15.3348 18.3348 14.9561 18.5981 14.5C19 13.8038 19 12.8692 19 11C19 9.13077 19 8.19615 18.5981 7.5C18.3348 7.04394 17.9561 6.66523 17.5 6.40192C16.8038 6 15.8692 6 14 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chat-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","slash","disabled","mute","silence","no-chat","inactive","blocked","interruption","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.71 4.29006C19.32 3.90006 18.69 3.90006 18.3 4.29006L17.34 5.25006C16.54 5.00006 15.54 5.00006 14.01 5.00006H10.01C8.03001 5.00006 6.94001 5.00006 6.01001 5.54006C5.40001 5.89006 4.88998 6.40006 4.53998 7.00006C3.99998 7.93006 4 9.02006 4 11.0001C4 12.9801 3.99998 14.0701 4.53998 15.0001C4.88998 15.6101 5.4 16.1101 6 16.4601C6.03 16.4801 6.06003 16.4801 6.09003 16.5001L4.29999 18.2901C3.90999 18.6801 3.90999 19.3101 4.29999 19.7001C4.49999 19.9001 4.75001 19.9901 5.01001 19.9901C5.27001 19.9901 5.51997 19.8901 5.71997 19.7001L19.72 5.70006C20.11 5.31006 20.11 4.68006 19.72 4.29006H19.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.82001 17.5301C10.51 18.5501 11.06 19.1901 12 19.1901C13.07 19.1901 13.64 18.3401 14.49 17.0501C14.52 17.0101 14.56 16.9901 14.6 16.9901C16.14 16.9901 17.14 16.9501 17.99 16.4601C18.6 16.1101 19.1 15.6001 19.45 15.0001C19.99 14.0701 20 12.98 20 11C20 9.44 19.99 8.44006 19.72 7.62006L9.81 17.5301H9.82001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","slash","disabled","blocked","mute","no-chat","inactive","unavailable","do-not-disturb","communication-error","offline-support","disable-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16V16C15.8692 16 16.8038 16 17.5 15.5981C17.9561 15.3348 18.3348 14.9561 18.5981 14.5C19 13.8038 19 12.8692 19 11V11C19 9.13077 19 8.19615 18.5981 7.5C18.3348 7.04394 17.9561 6.66523 17.5 6.40192C16.8038 6 15.8692 6 14 6H10C8.13077 6 7.19615 6 6.5 6.40192C6.04394 6.66523 5.66523 7.04394 5.40192 7.5C5 8.19615 5 9.13077 5 11V11C5 12.8692 5 13.8038 5.40192 14.5C5.66523 14.9561 6.04394 15.3348 6.5 15.5981C7.19615 16 8.13077 16 10 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16L13.6641 16.5038C12.9115 17.6328 12.5352 18.1972 12 18.1972C11.4648 18.1972 11.0885 17.6328 10.3359 16.5038L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chat-sms-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","conversation","feedback","comment","support","notification","text","sms","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 13.7924 6.63505 16.2029 9 17.3264V19.9997L16 16.7453C18 15.5 19 13.3787 19 11C19 7.13401 15.866 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-sms-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","sms","comment","feedback","notes","communication","support","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 13.7924 6.63505 16.2029 9 17.3264V19.9997L16 16.7453C18 15.5 19 13.3787 19 11C19 7.13401 15.866 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-sms-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","feedback","comment","communication","customer-support","support","sms"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.59 3 4 6.59 4 11C4 13.86 5.55 16.51 8 17.93V20C8 20.34 8.16999 20.66 8.45999 20.84C8.61999 20.94 8.81 21 9 21C9.14 21 9.29001 20.97 9.42001 20.91L16.42 17.66C16.42 17.66 16.49 17.62 16.53 17.6C18.74 16.23 20 13.82 20 11.01C20 6.6 16.41 3.01 12 3.01V3ZM13 14H9C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM15 10H9C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8H15C15.55 8 16 8.45 16 9C16 9.55 15.55 10 15 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-sms": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","sms","communication","feedback","customer-support","comment","notes","dialog","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.13401 4 5 7.13401 5 11C5 13.7924 6.63505 16.2029 9 17.3264V19.9997L16 16.7453C18 15.5 19 13.3787 19 11C19 7.13401 15.866 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-voice-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["chat","voice","microphone","audio","support","help","communication","message","sound","voice-input","speech","audio-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L15 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.46381 14.8662 6.25469 16L5 19H12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-voice-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","voice","audio","message","communication","notes","customer-support","support","feedback","record","voice-command"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.46381 14.8662 6.25469 16L5 19H12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13L15 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chat-voice-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","voice","speech","audio","message","customer-support","communication","feedback","notification","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.59 4 4 7.59 4 12C4 13.46 4.39 14.86 5.13 16.1L4.08002 18.61C3.95002 18.92 3.98998 19.27 4.16998 19.55C4.34998 19.83 4.67 20 5 20H12C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM10 13C10 13.55 9.55 14 9 14C8.45 14 8 13.55 8 13V11C8 10.45 8.45 10 9 10C9.55 10 10 10.45 10 11V13ZM13 14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14V10C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10V14ZM16 13C16 13.55 15.55 14 15 14C14.45 14 14 13.55 14 13V11C14 10.45 14.45 10 15 10C15.55 10 16 10.45 16 11V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chat-voice": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","voice","audio","message","customer-support","microphone","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14L12 10M15 13L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.46381 14.8662 6.25469 16L5 19H12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    chat: {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","voice","audio","message","customer-support","microphone","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11.1576C20 8.77139 20 7.5783 19.3228 6.74979C19.2747 6.69095 19.2244 6.63397 19.172 6.57895C18.4339 5.80424 17.25 5.65625 14.8822 5.36028L10.7442 4.84303C7.60086 4.45011 6.02918 4.25365 5.01459 5.14931C4 6.04498 4 7.62888 4 10.7967V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["check","tick","validate","confirm","approve","success","completed","verified","ok","check-mark","selection","accept","correct","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11L12 14L19 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","tick","confirmation","complete","done","approved","valid","success","ok","checkmark","verified","accept","order-complete","payment-received","transaction-complete","inventory-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11L12 14L19 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","tick","checkmark","approved","verified","complete","confirm","order-complete","payment-received","transaction-complete","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM19.6585 5.24742C20.0741 5.61111 20.1163 6.24287 19.7526 6.6585L12.7526 14.6585C12.5703 14.8668 12.3099 14.9902 12.0333 14.9994C11.7567 15.0087 11.4886 14.9028 11.2929 14.7071L8.29289 11.7071C7.90237 11.3166 7.90237 10.6834 8.29289 10.2929C8.68342 9.90237 9.31658 9.90237 9.70711 10.2929L11.9513 12.5371L18.2474 5.3415C18.6111 4.92586 19.2429 4.88374 19.6585 5.24742Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Check-tick-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","tick","circle","complete","done","confirm","approve","verified","success","payment-received","order-confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5 5.93648C14.4704 5.34088 13.275 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.0717 18.8193 10.1856 18.4912 9.375"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L17 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","tick","confirm","validate","approve","completed","success","order-complete","payment-received","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5 5.93648C14.4704 5.34088 13.275 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.0717 18.8193 10.1856 18.4912 9.375"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L17 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["check","tick","confirm","ok","done","approved","verified","completed","success","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5 5.93648C14.4704 5.34088 13.275 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.0717 18.8193 10.1856 18.4912 9.375"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L11 14L17 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Check-tick-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","tick","confirm","approve","validate","success","complete","order-complete","transaction-complete","payment-received","verified","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.5573 17.9522 11.1269 17.8619 10.7133C17.7441 10.1737 18.086 9.64082 18.6256 9.52301C19.1652 9.40521 19.6981 9.74712 19.8159 10.2867C19.9366 10.8396 20 11.4129 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C13.0315 4 14.0198 4.19574 14.9278 4.55301C15.0979 4.6199 15.265 4.69243 15.4291 4.77037C15.9279 5.00735 16.1402 5.60387 15.9033 6.10272C15.6663 6.60158 15.0698 6.81387 14.5709 6.57689C14.448 6.51852 14.3229 6.46421 14.1956 6.41415C13.5169 6.14714 12.7769 6 12 6ZM17.7071 7.2929C18.0976 7.68342 18.0976 8.31659 17.7071 8.70711L11.7071 14.7071C11.3165 15.0976 10.6834 15.0976 10.2928 14.7071L8.29285 12.7071C7.90232 12.3166 7.90232 11.6834 8.29285 11.2929C8.68337 10.9024 9.31654 10.9024 9.70706 11.2929L11 12.5858L16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Check-tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","tick","checkmark","approved","confirm","confirmation","complete","completed","ok","success","verified","acceptance","accepted","done","order-confirmation","payment-received","inventory-check","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11L12 14L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chess-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chess","strategy","planning","game","board game","thinking","competition","puzzle","decision","tactic","tournament"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L15 13L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17L9 13L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7C8.8 7.75462 10.72 8.8111 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C15.2 7.75462 13.28 8.8111 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 13H17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chess-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chess","piece","king","queen","strategy","game","promotion","leadership","loyalty","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.8166 6.4228L12 5L11.1834 6.4228C10.9617 6.73643 10.7525 6.87347 10.5873 6.93728C10.4172 7.00293 10.2226 7.01816 9.99568 6.97766C9.50836 6.89069 8.99783 6.5665 8.68618 6.27253C8.37386 5.97792 7.90834 5.91556 7.52949 6.11756C7.15065 6.31957 6.94302 6.74086 7.01361 7.16436L7.81955 12H7C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H7.71921L7.21922 16H6C5.44772 16 5 16.4477 5 17C5 17.5522 5.44772 18 6 18H18C18.5523 18 19 17.5522 19 17C19 16.4477 18.5523 16 18 16H16.7808L16.2808 14H17C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12H16.1805L16.9766 7.22297C17.1253 6.33095 16.0465 5.60545 15.2834 6.30071C14.958 6.59719 14.4543 6.90464 13.9805 6.98172C13.76 7.01758 13.5704 7.00022 13.4034 6.93363C13.2404 6.86861 13.0346 6.73124 12.8166 6.4228ZM14.1529 12L14.6737 8.87524C14.5522 8.908 14.4281 8.93521 14.3016 8.95577C13.7931 9.0385 13.2266 9.01631 12.6624 8.79129C12.4297 8.69847 12.2084 8.5755 12 8.42269C11.7826 8.58209 11.5512 8.70896 11.3077 8.80299C10.7328 9.02504 10.1574 9.03811 9.64432 8.94655C9.53654 8.92732 9.43046 8.90332 9.32634 8.87523L9.84713 12H14.1529Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chess-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chess","queen","strategy","game","promotion","loyalty","reward","VIP","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 13L8 17H16L15 13L15.9252 7.44897L15.9902 7.0586C15.9934 7.0397 15.9711 7.02701 15.9569 7.03991C15.1329 7.79075 13.2576 8.77938 12 7C10.72 8.8111 8.8 7.75462 8 7L9 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9 13L9.72761 13.1819C9.75256 13.0821 9.75671 12.9782 9.7398 12.8767L9 13ZM8 7L8.51463 6.45442C8.28039 6.23347 7.93126 6.1867 7.64712 6.3382C7.36298 6.48971 7.20727 6.80568 7.2602 7.1233L8 7ZM12 7L12.6125 6.56713L12 5.70053L11.3875 6.56713L12 7ZM15.9569 7.03991L15.4518 6.48553L15.4518 6.48554L15.9569 7.03991ZM15 13L14.2602 12.8767C14.2433 12.9782 14.2474 13.0821 14.2724 13.1819L15 13ZM6 16.25C5.58579 16.25 5.25 16.5858 5.25 17C5.25 17.4142 5.58579 17.75 6 17.75V16.25ZM18 17.75C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25V17.75ZM15.9252 7.44897L15.1854 7.32567V7.32567L15.9252 7.44897ZM15.9902 7.0586L15.2504 6.9353L15.2504 6.9353L15.9902 7.0586ZM8.72761 17.1819L9.72761 13.1819L8.27239 12.8181L7.27239 16.8181L8.72761 17.1819ZM9.7398 12.8767L8.7398 6.8767L7.2602 7.1233L8.2602 13.1233L9.7398 12.8767ZM7.48537 7.54558C7.95163 7.98539 8.75873 8.5346 9.68824 8.70048C10.1655 8.78565 10.6933 8.77231 11.2177 8.56982C11.7456 8.36593 12.2187 7.99 12.6125 7.43287L11.3875 6.56713C11.1413 6.91555 10.8944 7.08672 10.6773 7.17053C10.4567 7.25574 10.2145 7.27069 9.95176 7.22381C9.40127 7.12557 8.84837 6.76923 8.51463 6.45442L7.48537 7.54558ZM15.4518 6.48554C15.1048 6.80176 14.5583 7.14106 14.0206 7.22852C13.7642 7.27024 13.5274 7.25227 13.3108 7.16587C13.0972 7.08066 12.8546 6.90967 12.6125 6.56713L11.3875 7.43287C11.7742 7.98002 12.2376 8.35272 12.7551 8.55912C13.2695 8.76434 13.7889 8.78592 14.2615 8.70906C15.1819 8.55933 15.9851 8.02891 16.4621 7.59428L15.4518 6.48554ZM16.7276 16.8181L15.7276 12.8181L14.2724 13.1819L15.2724 17.1819L16.7276 16.8181ZM6 17.75H8V16.25H6V17.75ZM8 17.75H16V16.25H8V17.75ZM16 17.75H18V16.25H16V17.75ZM15.7398 13.1233L16.665 7.57227L15.1854 7.32567L14.2602 12.8767L15.7398 13.1233ZM16.665 7.57227L16.73 7.1819L15.2504 6.9353L15.1854 7.32567L16.665 7.57227ZM16.4621 7.59429C15.9146 8.09315 15.1444 7.57124 15.2504 6.9353L16.73 7.18191C16.8423 6.50817 16.0276 5.96086 15.4518 6.48553L16.4621 7.59429Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 17H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","expand","collapse","dropdown","menu","select","options","more","chevron","view-more","show-more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10L12 14L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    chess: {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","expand","collapse","dropdown","menu","select","options","more","chevron","view-more","show-more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L9 13L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7C8.8 7.75462 10.72 8.8111 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C15.2 7.75462 13.28 8.8111 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L15 13L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","return","previous","arrow-left","go-back","navigation","chevron"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8L10 12L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-bottom-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chevron","arrow-down","expand","collapse","more","options","menu","dropdown","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 10L12 14" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 10L12 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chevron-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","return","arrow-left","navigation","go-back","chevron-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 8L10 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16L10 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chevron-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","down","expand","dropdown","options","menu","more","chevron","select","open"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L14.1213 13.2929C14.1085 13.3057 14.0957 13.3186 14.0829 13.3314C13.783 13.6313 13.4917 13.9228 13.219 14.1308C12.9116 14.3653 12.5137 14.5858 12 14.5858C11.4863 14.5858 11.0884 14.3653 10.781 14.1308C10.5083 13.9228 10.217 13.6313 9.91715 13.3314C9.90434 13.3186 9.89152 13.3057 9.87868 13.2929L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289C7.68342 8.90237 8.31658 8.90237 8.70711 9.29289L11.2929 11.8787C11.6462 12.232 11.8416 12.4244 11.9941 12.5408C11.9961 12.5423 11.9981 12.5438 12 12.5452C12.0019 12.5438 12.0039 12.5423 12.0059 12.5408C12.1584 12.4244 12.3538 12.232 12.7071 11.8787L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevron-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["chevron","bottom","arrow","down","expand","more","options","dropdown","collapse","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10L12 14L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","navigation","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.707 7.29289C15.0975 7.68342 15.0975 8.31658 14.707 8.70711L12.1212 11.2929C11.7678 11.6462 11.5755 11.8416 11.4591 11.9941C11.4576 11.9961 11.4561 11.9981 11.4546 12C11.4561 12.0019 11.4576 12.0039 11.4591 12.0059C11.5755 12.1584 11.7678 12.3538 12.1212 12.7071L14.707 15.2929C15.0975 15.6834 15.0975 16.3166 14.707 16.7071C14.3164 17.0976 13.6833 17.0976 13.2927 16.7071L10.707 14.1213C10.6941 14.1085 10.6813 14.0957 10.6685 14.0829C10.3686 13.783 10.0771 13.4917 9.86904 13.219C9.63451 12.9116 9.41406 12.5137 9.41406 12C9.41406 11.4863 9.63451 11.0884 9.86904 10.781C10.0771 10.5083 10.3686 10.217 10.6685 9.91715C10.6813 9.90434 10.6941 9.89152 10.707 9.87868L13.2927 7.29289C13.6833 6.90237 14.3164 6.90237 14.707 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevron-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","return","arrow-left","navigate-back","go-back","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8L10 12L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chevron","right","arrow","next","forward","proceed","continue","details","select","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L14 12L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["right","arrow","next","proceed","continue","go-next","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L14 12L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chevron","right","arrow","next","forward","proceed","navigation","select","details","more-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 16L14 12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chevron-top-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort-up","sort","arrow-up","scroll-up","increase","expand","rise","chevron","up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14L12 10L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L16 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-top-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chevron","arrow","up","sort","expand","collapse","scroll-up","increase","ascending","top","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 14L12 10" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 14L12 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "chevron-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-up","chevron-up","scroll-up","sort-ascending","increase","move-up","navigate-up","go-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9941 11.4592C11.8416 11.5756 11.6462 11.768 11.2929 12.1213L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L9.87868 10.7071C9.89152 10.6942 9.90434 10.6814 9.91715 10.6686C10.217 10.3687 10.5083 10.0772 10.781 9.86916C11.0884 9.63463 11.4863 9.41418 12 9.41418C12.5137 9.41418 12.9116 9.63463 13.219 9.86916C13.4917 10.0772 13.783 10.3687 14.0829 10.6686C14.0957 10.6814 14.1085 10.6942 14.1213 10.7071L16.7071 13.2929C17.0976 13.6834 17.0976 14.3166 16.7071 14.7071C16.3166 15.0976 15.6834 15.0976 15.2929 14.7071L12.7071 12.1213C12.3538 11.768 12.1584 11.5756 12.0059 11.4592C12.0039 11.4577 12.0019 11.4562 12 11.4548C11.9981 11.4562 11.9961 11.4577 11.9941 11.4592Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevrons-double-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","return","left","navigation","browse","chevron","double-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18L8 12L14 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L13 12L16 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevron-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","scroll","sort","increase","navigate-up","move-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14L12 10L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevrons-double-left-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","double-left","page-back","step-back","arrow-left","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18L8 12L14 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L13 12L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevrons-double-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","left","history","page","navigation","chevron","double-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711L14.4142 12L16.7071 14.2929C17.0976 14.6834 17.0976 15.3166 16.7071 15.7071C16.3166 16.0976 15.6834 16.0976 15.2929 15.7071L12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevron-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","continue","proceed","select","arrow","right","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L13.2929 9.87868C13.3057 9.89152 13.3186 9.90434 13.3314 9.91715C13.6313 10.217 13.9228 10.5083 14.1308 10.781C14.3653 11.0884 14.5858 11.4863 14.5858 12C14.5858 12.5137 14.3653 12.9116 14.1308 13.219C13.9228 13.4917 13.6313 13.783 13.3314 14.0828C13.3186 14.0957 13.3057 14.1085 13.2929 14.1213L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929L11.8787 12.7071C12.232 12.3538 12.4244 12.1584 12.5408 12.0059C12.5423 12.0039 12.5438 12.0019 12.5452 12C12.5438 11.9981 12.5423 11.9961 12.5408 11.9941C12.4244 11.8416 12.232 11.6462 11.8787 11.2929L9.29289 8.70711C8.90237 8.31658 8.90237 7.68342 9.29289 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevrons-double-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","navigation","chevron","double-chevron","rewind","go-back","return","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 18L8 12L14 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L13 12L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevrons-double-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["next","forward","advance","proceed","scroll-right","skip","fast-forward","continue","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L17 12L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L12 12L7 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevrons-double-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["double-arrow","right","next","forward","advance","skip","fast-forward","scroll-right","move-right","pagination","carousel","next-item","arrow-right","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2929 17.7071C10.9024 17.3166 10.9024 16.6834 11.2929 16.2929L15.5858 12L11.2929 7.70711C10.9024 7.31658 10.9024 6.68342 11.2929 6.29289C11.6834 5.90237 12.3166 5.90237 12.7071 6.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.2929 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.2929 17.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "chevrons-double-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["double-arrow","right","next","advance","scroll","forward","skip","fast-forward","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L17 12L12 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L12 12L7 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "chevrons-double-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","double-arrow","right","forward","advance","skip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L17 12L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L12 12L7 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "child-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["child","baby","customer","age","demographic","infant","kids-menu","profile","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2418 5.22461C9.6013 6.85834 10.2706 8.71363 11.8068 9.56275"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7648 10.1914C17.7674 6.47893 13.9641 4.26276 10.2408 5.2245C7.80035 5.86016 5.88931 7.75665 5.23577 10.1914C4.62667 9.84867 3.8615 9.9719 3.39092 10.4885C2.92033 11.0051 2.86906 11.7781 3.2673 12.3522C3.66555 12.9264 4.40774 13.1495 5.05677 12.8902C5.50346 16.3831 8.47744 19 12.0003 19C15.5231 19 18.4971 16.3831 18.9438 12.8902C19.5928 13.1495 20.335 12.9264 20.7332 12.3522C21.1315 11.7781 21.0802 11.0051 20.6096 10.4885C20.139 9.9719 19.3739 9.84867 18.7648 10.1914Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9M15 11H16M11 15H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "child-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["child","kid","children","baby","customer","discount","age"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2418 5.22461C9.6013 6.85834 10.2706 8.71363 11.8068 9.56275"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7648 10.1914C17.7674 6.47893 13.9641 4.26276 10.2408 5.2245C7.80035 5.86016 5.88931 7.75665 5.23577 10.1914C4.62667 9.84867 3.8615 9.9719 3.39092 10.4885C2.92033 11.0051 2.86906 11.7781 3.2673 12.3522C3.66555 12.9264 4.40774 13.1495 5.05677 12.8902C5.50346 16.3831 8.47744 19 12.0003 19C15.5231 19 18.4971 16.3831 18.9438 12.8902C19.5928 13.1495 20.335 12.9264 20.7332 12.3522C21.1315 11.7781 21.0802 11.0051 20.6096 10.4885C20.139 9.9719 19.3739 9.84867 18.7648 10.1914Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9M15 11H16M11 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chrome-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["browser","web","internet","settings","configuration","connectivity","updates","integration","external-system","system-options","chrome"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M8 12C8 9.79086 9.79086 8 12 8M8 12L6 6.5M12 8C14.2091 8 16 9.79086 16 12C16 13.0144 15.6224 13.9407 15 14.6458M12 8L19 8M12 20C12.5031 18.9939 14.5934 15.4589 15 14.6458"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "child-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["child","baby","customer","age","demographic","discount","child-discount","age-verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.01038 4.57989C6.99789 5.39141 5.39777 6.98787 4.58259 8.99982C3.8691 8.97656 3.15809 9.25912 2.65167 9.81504C1.8672 10.6762 1.78169 11.965 2.44562 12.9222C2.87366 13.5393 3.53998 13.913 4.24925 13.9848C5.14129 17.4831 8.30709 20 12.0003 20C15.6935 20 18.8593 17.4831 19.7513 13.9848C20.4606 13.913 21.1269 13.5393 21.5549 12.9222C22.2189 11.965 22.1334 10.6762 21.3489 9.81504C20.8426 9.25925 20.1318 8.97669 19.4185 8.99981C18.0623 5.64445 14.597 3.61275 11.0096 4.06154C10.9264 5.02259 11.4082 5.97513 12.2907 6.46296C12.7741 6.73013 12.9494 7.33855 12.6822 7.82191C12.415 8.30528 11.8066 8.48054 11.3232 8.21337C9.94676 7.45255 9.11146 6.06328 9.01038 4.57989ZM7 11C7 10.4477 7.44772 10 8 10H9C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H8C7.44772 12 7 11.5523 7 11ZM14 11C14 10.4477 14.4477 10 15 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H15C14.4477 12 14 11.5523 14 11ZM10 15C10 14.4477 10.4477 14 11 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H11C10.4477 16 10 15.5523 10 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    child: {
        defaultColors: ["#3D4C66"],
        keywords: ["child","baby","customer","age","demographic","discount","child-discount","age-verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2418 5.22461C9.6013 6.85834 10.2706 8.71363 11.8068 9.56275"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7648 10.1914C17.7674 6.47893 13.9641 4.26276 10.2408 5.2245C7.80035 5.86016 5.88931 7.75665 5.23577 10.1914C4.62667 9.84867 3.8615 9.9719 3.39092 10.4885C2.92033 11.0051 2.86906 11.7781 3.2673 12.3522C3.66555 12.9264 4.40774 13.1495 5.05677 12.8902C5.50346 16.3831 8.47744 19 12.0003 19C15.5231 19 18.4971 16.3831 18.9438 12.8902C19.5928 13.1495 20.335 12.9264 20.7332 12.3522C21.1315 11.7781 21.0802 11.0051 20.6096 10.4885C20.139 9.9719 19.3739 9.84867 18.7648 10.1914Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9M15 11H16M11 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Chrome-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chrome","browser","internet","web","application","settings","configuration","system","pos-system","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.90705 4.57861C8.35531 3.58283 10.1096 3 12 3C15.8622 3 19.1563 5.43284 20.4332 8.84967L14.0172 7.42389C13.3991 7.15108 12.7159 7.00001 12 7.00001C10.4423 7.00001 9.05101 7.71232 8.13402 8.82897L6.96154 4.72529C6.94696 4.67426 6.92867 4.6253 6.90705 4.57861Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.25688 6.03911C3.85247 7.62662 3 9.71376 3 12C3 16.1515 5.81085 19.6464 9.63321 20.6856C9.77852 20.4649 9.94117 20.2243 10.111 19.9761C10.5763 19.2962 11.1515 18.4789 11.719 17.6742L12.1972 16.9962C12.1318 16.9987 12.0661 17 12 17C9.28794 17 7.08019 14.8407 7.00215 12.1475L5.25688 6.03911Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 21C11.9449 21 11.8899 20.9995 11.835 20.9985C12.2776 20.3539 12.8147 19.5907 13.3534 18.8269L13.5347 18.5699C14.04 17.8536 14.5369 17.1492 14.9406 16.565C15.3129 16.0264 15.6522 15.5251 15.8273 15.2176C16.5585 14.3485 17 13.2247 17 12C17 11.3071 16.859 10.6473 16.6044 10.0476L20.7831 10.9762C20.8372 10.9882 20.8913 10.9956 20.9449 10.9986C20.9813 11.3274 21 11.6615 21 12C21 16.9706 16.9706 21 12 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Chrome-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["browser","internet","web","navigation","settings","configuration","application"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458C15.6224 13.9407 16 13.0144 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M8 12C8 9.79086 9.79086 8 12 8M8 12L6 6.5M12 8C14.2091 8 16 9.79086 16 12C16 13.0144 15.6224 13.9407 15 14.6458M12 8L19 8M12 20C12.5031 18.9939 14.5934 15.4589 15 14.6458"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Chrome: {
        defaultColors: ["#3D4C66"],
        keywords: ["browser","internet","web","navigation","settings","configuration","application"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M8 12C8 9.79086 9.79086 8 12 8M8 12L6 6.5M12 8C14.2091 8 16 9.79086 16 12C16 13.0144 15.6224 13.9407 15 14.6458M12 8L19 8M12 20C12.5031 18.9939 14.5934 15.4589 15 14.6458"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","round","void","empty","deselect","clear","remove","reset","void-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12C20 16.4183 16.4183 20 12 20V20C7.58172 20 4 16.4183 4 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["circle","status","indicator","payment-status","order-status","availability","table-status","table","round"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","status","availability","indicator","on","off","void","refund","complete","pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-backward-step-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","previous","rewind","step-back","transaction-history","order-history","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.8716 9.00008C11.4171 9.00554 10.893 9.55061 9.84485 10.6408C9.3607 11.1443 9.11863 11.3961 9.04027 11.6911C8.98658 11.8932 8.98658 12.1068 9.04027 12.3089C9.11863 12.6039 9.3607 12.8557 9.84485 13.3592C10.893 14.4494 11.4171 14.9945 11.8716 14.9999C12.1764 15.0036 12.4693 14.8774 12.6823 14.6507C13 14.3125 13 13.5417 13 12C13 10.4583 13 9.68746 12.6823 9.34935C12.4693 9.12262 12.1764 8.99641 11.8716 9.00008Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Circle-backward-step-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","rewind","step-back","history","undo","earlier","circle","navigation","transaction-history","order-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 15L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.8716 9.00008C11.4171 9.00554 10.893 9.55061 9.84485 10.6408C9.3607 11.1443 9.11863 11.3961 9.04027 11.6911C8.98658 11.8932 8.98658 12.1068 9.04027 12.3089C9.11863 12.6039 9.3607 12.8557 9.84485 13.3592C10.893 14.4494 11.4171 14.9945 11.8716 14.9999C12.1764 15.0036 12.4693 14.8774 12.6823 14.6507C13 14.3125 13 13.5417 13 12C13 10.4583 13 9.68746 12.6823 9.34935C12.4693 9.12262 12.1764 8.99641 11.8716 9.00008Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-backward-step-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["previous","back","rewind","step-back","previous-item","back-navigation","circle-back","circle-previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V9ZM12.4111 8.66463C12.0108 8.23847 11.4511 7.99304 10.8596 8.00015C10.2478 8.0075 9.76394 8.3683 9.43017 8.65431C9.07423 8.9593 8.6533 9.39712 8.15991 9.9103L8.09882 9.97384C7.87845 10.203 7.67007 10.4197 7.51097 10.6176C7.33672 10.8344 7.16329 11.0974 7.07377 11.4344C6.97541 11.8048 6.97541 12.1952 7.07377 12.5656C7.16329 12.9026 7.33672 13.1656 7.51097 13.3824C7.67007 13.5803 7.87845 13.797 8.09882 14.0262L8.15994 14.0897C8.65331 14.6029 9.07424 15.0407 9.43017 15.3457C9.76394 15.6317 10.2478 15.9925 10.8596 15.9999C11.4511 16.007 12.0108 15.7615 12.4111 15.3354C12.8192 14.901 12.9145 14.3165 12.956 13.8691C13 13.3948 13 12.7782 13 12.05V11.9499C13 11.2218 13 10.6052 12.956 10.1309C12.9145 9.68355 12.8192 9.09897 12.4111 8.66463Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-backward-step": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","previous","rewind","step-back","undo","go-back","return","navigation-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 15L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.8716 9.00008C11.4171 9.00554 10.893 9.55061 9.84485 10.6408C9.3607 11.1443 9.11863 11.3961 9.04027 11.6911C8.98658 11.8932 8.98658 12.1068 9.04027 12.3089C9.11863 12.6039 9.3607 12.8557 9.84485 13.3592C10.893 14.4494 11.4171 14.9945 11.8716 14.9999C12.1764 15.0036 12.4693 14.8774 12.6823 14.6507C13 14.3125 13 13.5417 13 12C13 10.4583 13 9.68746 12.6823 9.34935C12.4693 9.12262 12.1764 8.99641 11.8716 9.00008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-bolt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["lightning","bolt","flash","fast","quick","charge","electricity","speed","instant","rush","urgent","alert","circle","energy","power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-bolt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["lightning","bolt","speed","fast","charge","power","electricity","quick-pay","fast-checkout","rush-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","flash","electricity","power","charge","fast","quick","speed","energy","circle-bolt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM11.0511 8.68385C11.2257 8.1599 11.792 7.87671 12.316 8.05133C12.8399 8.22594 13.1231 8.79225 12.9485 9.3162L12.3873 11H13C13.3214 11 13.6233 11.1546 13.8113 11.4153C13.9992 11.6761 14.0503 12.0114 13.9487 12.3163L12.9485 15.3163C12.7738 15.8402 12.2075 16.1234 11.6835 15.9487C11.1596 15.774 10.8765 15.2077 11.0511 14.6837L11.6125 13H11C10.6786 13 10.3767 12.8455 10.1888 12.5848C10.0008 12.324 9.94966 11.9888 10.0513 11.6839L11.0511 8.68385Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-bolt": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","circle","lightning","flash","electricity","power","charge","quick-action","instant","energy","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","circle","complete","done","approved","success","confirmation","order-complete","payment-received","transaction-complete","inventory-checked","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["check","checkmark","approved","complete","order-complete","payment-received","transaction-approved","verified","success","done"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","circle","validate","accept","confirm","approve","ok","completed","success","verified","correct","agree"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","check","tick","approve","approved","confirm","confirmed","complete","completed","success","valid","order-complete","payment-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-cloud-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","data","storage","network","backup","online","server","sync","cloud-sync","cloud-storage","data-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12C14 11.652 13.9407 11.3178 13.8318 11.007M13.8318 11.007C13.8872 11.0024 13.9433 11 14 11C15.1046 11 16 11.8954 16 13C16 14.1046 15.1046 15 14 15H11C9.34315 15 8 13.6569 8 12C8 10.3431 9.34315 9 11 9C12.3088 9 13.4219 9.83814 13.8318 11.007Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-cloud-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","data","storage","backup","sync","server","internet","cloud-storage","cloud-sync","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12C8 13.6569 9.34315 15 11 15H14C15.1046 15 16 14.1046 16 13C16 11.8954 15.1046 11 14 11C13.9433 11 13.8872 11.0024 13.8318 11.007C13.4219 9.83814 12.3088 9 11 9C9.34315 9 8 10.3431 8 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 12C14 11.652 13.9407 11.3178 13.8318 11.007M13.8318 11.007C13.8872 11.0024 13.9433 11 14 11C15.1046 11 16 11.8954 16 13C16 14.1046 15.1046 15 14 15H11C9.34315 15 8 13.6569 8 12C8 10.3431 9.34315 9 11 9C12.3088 9 13.4219 9.83814 13.8318 11.007Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-cloud-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","server","storage","data","sync","backup","cloud-storage","cloud-data","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM8.75 12C8.75 10.7574 9.75736 9.75 11 9.75C11.9804 9.75 12.8163 10.3775 13.124 11.2552C13.2054 11.4873 13.25 11.7376 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75C14.4142 12.75 14.75 12.4142 14.75 12V11.9999C15.0536 12.228 15.25 12.591 15.25 13C15.25 13.6904 14.6904 14.25 14 14.25H11C9.75736 14.25 8.75 13.2426 8.75 12ZM11 8.25C12.4477 8.25 13.7023 9.07 14.3274 10.2693C15.6918 10.4311 16.75 11.592 16.75 13C16.75 14.5188 15.5188 15.75 14 15.75H11C8.92893 15.75 7.25 14.0711 7.25 12C7.25 9.92893 8.92893 8.25 11 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-cloud": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","online","backup","sync","server","network","circle","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12C14 11.652 13.9407 11.3178 13.8318 11.007M13.8318 11.007C13.8872 11.0024 13.9433 11 14 11C15.1046 11 16 11.8954 16 13C16 14.1046 15.1046 15 14 15H11C9.34315 15 8 13.6569 8 12C8 10.3431 9.34315 9 11 9C12.3088 9 13.4219 9.83814 13.8318 11.007Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-code-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["code","coding","development","settings","configuration","customization","api","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L17 12L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 16L13 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-code-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["code","programming","development","settings","configuration","script","customization","integration","api"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L17 12L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 16L13 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-code-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","development","script","customization","integration","api","settings","configuration","edit","source-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM13.9701 8.24277C14.1041 7.70698 13.7783 7.16404 13.2425 7.03009C12.7067 6.89615 12.1638 7.22191 12.0299 7.7577L10.0299 15.7577C9.89591 16.2935 10.2217 16.8364 10.7575 16.9704C11.2933 17.1043 11.8362 16.7786 11.9701 16.2428L13.9701 8.24277ZM9.24351 10.7073C9.63403 10.3168 9.63403 9.68365 9.24351 9.29313C8.85298 8.90261 8.21982 8.90261 7.82929 9.29313L5.82929 11.2931C5.43877 11.6837 5.43877 12.3168 5.82929 12.7073L7.82929 14.7073C8.21982 15.0979 8.85298 15.0979 9.24351 14.7073C9.63403 14.3168 9.63403 13.6837 9.24351 13.2931L7.95061 12.0002L9.24351 10.7073ZM16.2148 9.29313C15.8243 8.90261 15.1911 8.90261 14.8006 9.29313C14.4101 9.68365 14.4101 10.3168 14.8006 10.7073L16.0935 12.0002L14.8006 13.2931C14.4101 13.6837 14.4101 14.3168 14.8006 14.7073C15.1911 15.0979 15.8243 15.0979 16.2148 14.7073L18.2148 12.7073C18.6053 12.3168 18.6053 11.6837 18.2148 11.2931L16.2148 9.29313Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-code": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","script","settings","configuration","technical","integration","development","customization","api"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L17 12L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 16L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-cross-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cancel","remove","delete","error","close","exit","reject","decline","cross","circle-cross","void","cancel-order","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18L18 6M18 18L6 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cancel","remove","delete","close","error","incorrect","circle","cross","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 18L18 6M18 18L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "circle-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","delete","remove","error","close","void","reject","decline","incorrect","blocked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.9681 6.38231C3.73647 7.92199 3 9.87499 3 12C3 14.1251 3.7365 16.0781 4.96817 17.6178L10.5859 12.0001L4.9681 6.38231Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.38231 4.9681L12.0001 10.5859L17.6178 4.96817C16.0781 3.7365 14.1251 3 12 3C9.87499 3 7.92198 3.73647 6.38231 4.9681Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.032 6.3824L13.4143 12.0001L19.0319 17.6177C20.2635 16.078 21 14.125 21 12C21 9.87502 20.2636 7.92206 19.032 6.3824Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.6177 19.0319L12.0001 13.4143L6.3824 19.032C7.92206 20.2636 9.87503 21 12 21C14.125 21 16.078 20.2635 17.6177 19.0319Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","close","exit","void","cross","incorrect","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 18L18 6M18 18L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Circle-crown-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["crown","loyalty","rewards","premium","vip","membership","tier","ranking","authorization","admin","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14L16 9L14 10L12 8L10 10L8 9L9 14H15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M9 16L15 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Circle-crown-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","rewards","vip","premium","membership","privilege","tier","exclusive","leaderboard","top-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12.7071 6.79289C12.5196 6.60535 12.2652 6.5 12 6.5C11.7348 6.5 11.4804 6.60536 11.2929 6.7929L9.80258 8.28324L8.44725 7.60557C8.10564 7.43477 7.69656 7.47346 7.39304 7.70529C7.08951 7.93712 6.94455 8.3216 7.01945 8.69612L8.01945 13.1961C8.11294 13.6635 8.52335 14 9.00003 14H15C15.4767 14 15.8871 13.6635 15.9806 13.1961L16.9806 8.69612C17.0555 8.3216 16.9106 7.93712 16.607 7.70529C16.3035 7.47346 15.8944 7.43477 15.5528 7.60557L14.1975 8.28324L12.7071 6.79289ZM9.00003 15C8.44775 15 8.00003 15.4477 8.00003 16C8.00003 16.5523 8.44775 17 9.00003 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H9.00003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-crown-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["crown","loyalty","premium","vip","rewards","special","privilege","tier","membership","promotion","rank","favorite","best","top-seller"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14L16 9L14 10L12 8L10 10L8 9L9 14H15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M9 16L15 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Circle-crown": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","rewards","vip","premium","membership","tier","privilege","customer-segment","customer-rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14L16 9L14 10L12 8L10 10L8 9L9 14H15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M9 16L15 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-diamond-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["diamond","loyalty","rewards","points","vip","premium","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9678 9H10.0322C9.631 9 9.43037 9 9.25548 9.06804C9.14173 9.11229 9.03705 9.17699 8.9466 9.25893C8.80753 9.38493 8.71781 9.56438 8.53836 9.92327C8.33102 10.338 8.22735 10.5453 8.21778 10.7575C8.21157 10.8951 8.23387 11.0326 8.28329 11.1612C8.35947 11.3595 8.52339 11.5234 8.85123 11.8512L12 15L15.1488 11.8512C15.4766 11.5234 15.6405 11.3595 15.7167 11.1612C15.7661 11.0326 15.7884 10.8951 15.7822 10.7575C15.7727 10.5453 15.669 10.338 15.4616 9.92327L15.4616 9.92326C15.2822 9.56438 15.1925 9.38493 15.0534 9.25893C14.963 9.17699 14.8583 9.11229 14.7445 9.06804C14.5696 9 14.369 9 13.9678 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-diamond-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["diamond","reward","loyalty","premium","gift","points","vip","gem","award","promotion","loyalty-program","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9678 9H10.0322C9.631 9 9.43037 9 9.25548 9.06804C9.14173 9.11229 9.03705 9.17699 8.9466 9.25893C8.80753 9.38493 8.71781 9.56438 8.53836 9.92327C8.33102 10.338 8.22735 10.5453 8.21778 10.7575C8.21157 10.8951 8.23387 11.0326 8.28329 11.1612C8.35947 11.3595 8.52339 11.5234 8.85123 11.8512L12 15L15.1488 11.8512C15.4766 11.5234 15.6405 11.3595 15.7167 11.1612C15.7661 11.0326 15.7884 10.8951 15.7822 10.7575C15.7727 10.5453 15.669 10.338 15.4616 9.92327L15.4616 9.92326C15.2822 9.56438 15.1925 9.38493 15.0534 9.25893C14.963 9.17699 14.8583 9.11229 14.7445 9.06804C14.5696 9 14.369 9 13.9678 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-diamond": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","loyalty","rewards","premium","circle","badge","vip","exclusive","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9678 9H10.0322C9.631 9 9.43037 9 9.25548 9.06804C9.14173 9.11229 9.03705 9.17699 8.9466 9.25893C8.80753 9.38493 8.71781 9.56438 8.53836 9.92327C8.33102 10.338 8.22735 10.5453 8.21778 10.7575C8.21157 10.8951 8.23387 11.0326 8.28329 11.1612C8.35947 11.3595 8.52339 11.5234 8.85123 11.8512L12 15L15.1488 11.8512C15.4766 11.5234 15.6405 11.3595 15.7167 11.1612C15.7661 11.0326 15.7884 10.8951 15.7822 10.7575C15.7727 10.5453 15.669 10.338 15.4616 9.92327L15.4616 9.92326C15.2822 9.56438 15.1925 9.38493 15.0534 9.25893C14.963 9.17699 14.8583 9.11229 14.7445 9.06804C14.5696 9 14.369 9 13.9678 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-diamond-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","circle","payment","loyalty","rewards","premium","vip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM7.61 10.13C7.67 9.97 7.76 9.79 7.86 9.61V9.59C7.86 9.59 7.89 9.54 7.91 9.52C8.05 9.24 8.2 8.93 8.45 8.71C8.61 8.57 8.79 8.45 8.99 8.38C9.3 8.26 9.64 8.26 9.96 8.26C9.99 8.26 10.01 8.26 10.04 8.26H13.98C13.98 8.26 14.03 8.26 14.06 8.26C14.38 8.26 14.72 8.26 15.03 8.38C15.23 8.46 15.41 8.57 15.57 8.71C15.82 8.93 15.97 9.24 16.11 9.52C16.12 9.54 16.13 9.57 16.15 9.59V9.61C16.26 9.8 16.34 9.98 16.41 10.13C16.48 10.3 16.54 10.5 16.55 10.72C16.55 10.81 16.55 10.9 16.53 11H7.48C7.47 10.91 7.46 10.82 7.46 10.72C7.47 10.5 7.53 10.3 7.6 10.13H7.61ZM12.53 15.53C12.24 15.82 11.76 15.82 11.47 15.53L8.44 12.5H15.56L12.53 15.53Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-divide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["divide","division","split","fraction","calculate","discount","calculation","split-bill","percentage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 10H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-divide-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["divide","split","share","discount","calculation","math","reduction","percentage","division","split-bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-divide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["division","divide","split","calculation","discount","split-payment","round-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13.5 9C13.5 9.55228 13.0523 10 12.5 10H11.5C10.9477 10 10.5 9.55228 10.5 9C10.5 8.44772 10.9477 8 11.5 8H12.5C13.0523 8 13.5 8.44772 13.5 9ZM16 12C16 12.5523 15.5523 13 15 13H9C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11H15C15.5523 11 16 11.4477 16 12ZM12.5 16C13.0523 16 13.5 15.5523 13.5 15C13.5 14.4477 13.0523 14 12.5 14H11.5C10.9477 14 10.5 14.4477 10.5 15C10.5 15.5523 10.9477 16 11.5 16H12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-divide": {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","split","circle","discount","percentage","share","calculation","split-bill","split-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dollar","money","currency","payment","cash","transaction","sales","price","amount","finance","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12C10.8954 12 10 11.1605 10 10.125C10 9.08947 10.8954 8.25 12 8.25M12 12C13.1046 12 14 12.8395 14 13.875C14 14.9105 13.1046 15.75 12 15.75M12 12L12 15.75M12 12V8.25M14 10.125C14 9.08947 13.1046 8.25 12 8.25M12 8.25V7M10 13.875C10 14.9105 10.8954 15.75 12 15.75M12 15.75L12 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","money","payment","cash","finance","currency","usd","circle-dollar","transaction","price","cost","amount","sale","revenue","profit","earnings","income"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12C10.8954 12 10 11.1605 10 10.125C10 9.08947 10.8954 8.25 12 8.25M12 12C13.1046 12 14 12.8395 14 13.875C14 14.9105 13.1046 15.75 12 15.75M12 12L12 15.75M12 12V8.25M14 10.125C14 9.08947 13.1046 8.25 12 8.25M12 8.25V7M10 13.875C10 14.9105 10.8954 15.75 12 15.75M12 15.75L12 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","currency","payment","price","cost","cash","transaction","sale","revenue","circle-dollar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.75 10.125C10.75 9.77604 10.9381 9.4373 11.25 9.2243V11.0257C10.9381 10.8127 10.75 10.474 10.75 10.125Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.25 13.875C13.25 14.224 13.0619 14.5627 12.75 14.7757V12.9743C13.0619 13.1873 13.25 13.526 13.25 13.875Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V7.59993C10.1192 7.90718 9.25 8.89219 9.25 10.125C9.25 11.3578 10.1192 12.3428 11.25 12.6501V14.7757C10.9381 14.5627 10.75 14.224 10.75 13.875C10.75 13.4608 10.4142 13.125 10 13.125C9.58579 13.125 9.25 13.4608 9.25 13.875C9.25 15.1078 10.1192 16.0928 11.25 16.4001L11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17L12.75 16.4001C13.8808 16.0928 14.75 15.1078 14.75 13.875C14.75 12.6422 13.8808 11.6572 12.75 11.3499V9.2243C13.0619 9.4373 13.25 9.77604 13.25 10.125C13.25 10.5392 13.5858 10.875 14 10.875C14.4142 10.875 14.75 10.5392 14.75 10.125C14.75 8.89219 13.8808 7.90718 12.75 7.59993V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-Download-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","import","get","arrow-down","circle","data","receive","update","load"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12L10.5858 12.5858C11.2525 13.2525 11.5858 13.5858 12 13.5858C12.4142 13.5858 12.7475 13.2525 13.4142 12.5858L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 13L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Circle-Download-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","import","arrow","arrow-down","update","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13C13.4548 13.4654 13.1821 13.6981 12.888 13.8225C12.3285 14.0592 11.6715 14.0592 11.112 13.8225C10.8179 13.6981 10.5452 13.4654 10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 14L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","currency","money","payment","cash","finance","sales","revenue","price","cost","transaction","circle-dollar","circle","dollar-sign","discount","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12C10.8954 12 10 11.1605 10 10.125C10 9.08947 10.8954 8.25 12 8.25M12 12C13.1046 12 14 12.8395 14 13.875C14 14.9105 13.1046 15.75 12 15.75M12 12L12 15.75M12 12V8.25M14 10.125C14 9.08947 13.1046 8.25 12 8.25M12 8.25V7M10 13.875C10 14.9105 10.8954 15.75 12 15.75M12 15.75L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Circle-Download-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow","circle","import","save","transaction-history","reporting","data-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Circle-Download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","update","data","arrow-down","receive","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11.5361C10.9047 11.4567 10.7897 11.3593 10.6492 11.2394C10.2291 10.8808 9.59795 10.9307 9.2394 11.3508C8.88084 11.7709 8.93071 12.4021 9.35078 12.7606L9.44581 12.8418C9.89546 13.2266 10.2819 13.5572 10.7224 13.7435C11.531 14.0855 12.469 14.0855 13.2776 13.7435C13.7181 13.5572 14.1045 13.2266 14.5542 12.8418L14.6492 12.7606C15.0693 12.4021 15.1192 11.7709 14.7606 11.3508C14.4021 10.9307 13.7709 10.8808 13.3508 11.2394C13.2103 11.3593 13.0953 11.4567 13 11.5361V7ZM9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-Download-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","arrow-down","import","data","receive","save","export","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Circle-Download-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow","import","get","receive","update","data","circle","history","archive","sales-report","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44772 11 8L11 13.5556C10.7032 13.2876 10.3471 12.9328 9.87868 12.4645L9.70711 12.2929C9.31658 11.9024 8.68342 11.9024 8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071L8.46447 13.8787L8.51101 13.9252C9.13782 14.5521 9.67789 15.0922 10.1685 15.4666C10.6944 15.8678 11.2792 16.1716 12 16.1716C12.7208 16.1716 13.3056 15.8678 13.8315 15.4666C14.3221 15.0922 14.8622 14.5521 15.489 13.9252L15.5355 13.8787L15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929C15.3166 11.9024 14.6834 11.9024 14.2929 12.2929L14.1213 12.4645C13.6529 12.9328 13.2968 13.2876 13 13.5556L13 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-Download": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","get","arrow-down","save","receive","update","synchronize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12L10.5858 12.5858C11.2525 13.2525 11.5858 13.5858 12 13.5858C12.4142 13.5858 12.7475 13.2525 13.4142 12.5858L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 13L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 16H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Circle-Download-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","arrow","down","get","receive","import","get-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 13L14.8284 13.1716C13.4951 14.5049 12.8284 15.1716 12 15.1716C11.1716 15.1716 10.5049 14.5049 9.17157 13.1716L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-exclamation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exclamation","warning","error","alert","attention","issue","problem","circle-exclamation-2"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-exclamation-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["warning","alert","error","issue","problem","notification","exclamation","attention","critical","alerting","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","attention","problem","issue","exclamation","notification","critical","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 17C11.4477 17 11 16.5523 11 16V15.5C11 14.9477 11.4477 14.5 12 14.5C12.5523 14.5 13 14.9477 13 15.5V16C13 16.5523 12.5523 17 12 17ZM12 13.25C11.4477 13.25 11 12.8023 11 12.25V8.25C11 7.69772 11.4477 7.25 12 7.25C12.5523 7.25 13 7.69771 13 8.25V12.25C13 12.8023 12.5523 13.25 12 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","issue","problem","notification","invalid","attention","important","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-flag-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["flag","circle","promotion","notification","alert","special-offer","marketing","event","location","destination","completed","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 17.4183 7.58172 21 12 21C16.4183 21 20 17.4183 20 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0006V13V17M9 9V10.9994"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H15L14.0833 11.4993L15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-flag-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","reminder","highlight","priority","flagged","important","notification","circle","marked","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.93 9H9.75V12.5H13.93L13.38 11.01C13.32 10.84 13.32 10.66 13.38 10.49L13.93 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM15.7 12.99C15.78 13.22 15.75 13.48 15.61 13.68C15.47 13.88 15.24 14 14.99 14H9.73999V16.25C9.73999 16.66 9.39999 17 8.98999 17C8.57999 17 8.23999 16.66 8.23999 16.25V8.25C8.23999 7.84 8.57999 7.5 8.98999 7.5H14.99C15.24 7.5 15.46 7.62 15.61 7.82C15.75 8.02 15.78 8.28 15.7 8.51L14.88 10.75L15.7 12.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-forward-step-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["next","skip","forward","advance","play","continue","process","order-processing","step"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.1284 9.00008C12.5829 9.00554 13.107 9.55061 14.1552 10.6408C14.6393 11.1443 14.8814 11.3961 14.9597 11.6911C15.0134 11.8932 15.0134 12.1068 14.9597 12.3089C14.8814 12.6039 14.6393 12.8557 14.1552 13.3592C13.107 14.4494 12.5829 14.9945 12.1284 14.9999C11.8236 15.0036 11.5307 14.8774 11.3177 14.6507C11 14.3125 11 13.5417 11 12C11 10.4583 11 9.68746 11.3177 9.34935C11.5307 9.12262 11.8236 8.99641 12.1284 9.00008Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-flag": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","circle","marked","completed","order-complete","task-complete","achievement","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 17.4183 7.58172 21 12 21C16.4183 21 20 17.4183 20 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0006V13V17M9 9V10.9994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14H15L14.0833 11.4993L15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-forward-step-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["forward","next","continue","proceed","transaction-step","queue-next","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.1284 9.00008C12.5829 9.00554 13.107 9.55061 14.1552 10.6408C14.6393 11.1443 14.8814 11.3961 14.9597 11.6911C15.0134 11.8932 15.0134 12.1068 14.9597 12.3089C14.8814 12.6039 14.6393 12.8557 14.1552 13.3592C13.107 14.4494 12.5829 14.9945 12.1284 14.9999C11.8236 15.0036 11.5307 14.8774 11.3177 14.6507C11 14.3125 11 13.5417 11 12C11 10.4583 11 9.68746 11.3177 9.34935C11.5307 9.12262 11.8236 8.99641 12.1284 9.00008Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-forward-step-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","skip","continue","process","advance","arrow-right","go","proceed","play-next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9L8 15C8 15.5523 8.44772 16 9 16C9.55229 16 10 15.5523 10 15V9ZM11.5889 8.66463C11.9892 8.23847 12.5489 7.99304 13.1404 8.00015C13.7522 8.0075 14.2361 8.3683 14.5698 8.65431C14.9258 8.9593 15.3467 9.39712 15.8401 9.9103L15.9012 9.97384C16.1216 10.203 16.3299 10.4197 16.489 10.6176C16.6633 10.8344 16.8367 11.0974 16.9262 11.4344C17.0246 11.8048 17.0246 12.1952 16.9262 12.5656C16.8367 12.9026 16.6633 13.1656 16.489 13.3824C16.3299 13.5803 16.1216 13.797 15.9012 14.0262L15.8401 14.0897C15.3467 14.6029 14.9258 15.0407 14.5698 15.3457C14.2361 15.6317 13.7522 15.9925 13.1404 15.9999C12.5489 16.007 11.9892 15.7615 11.5889 15.3354C11.1808 14.901 11.0855 14.3165 11.044 13.8691C11 13.3948 11 12.7782 11 12.05V11.9499C11 11.2218 11 10.6052 11.044 10.1309C11.0855 9.68355 11.1808 9.09897 11.5889 8.66463Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-flag-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","location","mark","promotion","event","reminder","important","special"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 17.4183 7.58172 21 12 21C16.4183 21 20 17.4183 20 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0006V13V17M9 9V10.9994"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.0833 11.4993L15 14H9V9H15L14.0833 11.4993Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-location-arrow-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","arrow","send","direction","navigate","map","navigation","gps","destination","delivery","order-tracking","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.3547 11.8695L13.7414 13.505C13.463 14.2472 13.3239 14.6183 13.1804 14.7561C12.8135 15.1083 12.2246 15.0748 11.9001 14.6831C11.7732 14.53 11.6771 14.1455 11.4848 13.3764C11.4414 13.2028 11.4197 13.1159 11.3844 13.0401C11.2974 12.853 11.147 12.7026 10.9599 12.6156C10.8841 12.5804 10.7973 12.5586 10.6236 12.5152C9.85456 12.323 9.47003 12.2268 9.31685 12.0999C8.92521 11.7754 8.89167 11.1866 9.24393 10.8197C9.38171 10.6762 9.75282 10.537 10.4951 10.2587L12.1305 9.64534C13.6412 9.07885 14.3965 8.7956 14.7934 9.16925C14.8062 9.18132 14.8187 9.19378 14.8308 9.20661C15.2044 9.60353 14.9212 10.3588 14.3547 11.8695Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-forward-step": {
        defaultColors: ["#3D4C66"],
        keywords: ["skip","forward","next","advance","circle","play","order","queue","customer","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.1284 9.00008C12.5829 9.00554 13.107 9.55061 14.1552 10.6408C14.6393 11.1443 14.8814 11.3961 14.9597 11.6911C15.0134 11.8932 15.0134 12.1068 14.9597 12.3089C14.8814 12.6039 14.6393 12.8557 14.1552 13.3592C13.107 14.4494 12.5829 14.9945 12.1284 14.9999C11.8236 15.0036 11.5307 14.8774 11.3177 14.6507C11 14.3125 11 13.5417 11 12C11 10.4583 11 9.68746 11.3177 9.34935C11.5307 9.12262 11.8236 8.99641 12.1284 9.00008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-location-arrow-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","arrow","direction","map","navigate","go","send","delivery","destination","point-of-sale","pos","location-arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.3547 11.8695L13.7414 13.505C13.463 14.2472 13.3239 14.6183 13.1804 14.7561C12.8135 15.1083 12.2246 15.0748 11.9001 14.6831C11.7732 14.53 11.6771 14.1455 11.4848 13.3764C11.4414 13.2028 11.4197 13.1159 11.3844 13.0401C11.2974 12.853 11.147 12.7026 10.9599 12.6156C10.8841 12.5804 10.7973 12.5586 10.6236 12.5152C9.85456 12.323 9.47003 12.2268 9.31685 12.0999C8.92521 11.7754 8.89167 11.1866 9.24393 10.8197C9.38171 10.6762 9.75282 10.537 10.4951 10.2587L12.1305 9.64534C13.6412 9.07885 14.3965 8.7956 14.7934 9.16925C14.8062 9.18132 14.8187 9.19378 14.8308 9.20661C15.2044 9.60353 14.9212 10.3588 14.3547 11.8695Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-location-arrow": {
        defaultColors: ["#3D4C66"],
        keywords: ["navigation","location","direction","arrow","map","shipping","delivery","tracking","wayfinding","gps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.3547 11.8695L13.7414 13.505C13.463 14.2472 13.3239 14.6183 13.1804 14.7561C12.8135 15.1083 12.2246 15.0748 11.9001 14.6831C11.7732 14.53 11.6771 14.1455 11.4848 13.3764C11.4414 13.2028 11.4197 13.1159 11.3844 13.0401C11.2974 12.853 11.147 12.7026 10.9599 12.6156C10.8841 12.5804 10.7973 12.5586 10.6236 12.5152C9.85456 12.323 9.47003 12.2268 9.31685 12.0999C8.92521 11.7754 8.89167 11.1866 9.24393 10.8197C9.38171 10.6762 9.75282 10.537 10.4951 10.2587L12.1305 9.64534C13.6412 9.07885 14.3965 8.7956 14.7934 9.16925C14.8062 9.18132 14.8187 9.19378 14.8308 9.20661C15.2044 9.60353 14.9212 10.3588 14.3547 11.8695Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-location-arrow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","arrow","direction","navigation","map","point of sale","delivery","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM15.4788 8.44121C14.8947 7.89136 14.1531 7.96969 13.6628 8.07863C13.1659 8.18899 12.4764 8.44764 11.7794 8.7091L10.1194 9.33161C9.76923 9.46293 9.47192 9.57442 9.24656 9.67169C9.05428 9.75468 8.7482 9.89221 8.5226 10.1272C7.76791 10.9132 7.83977 12.1748 8.67883 12.87C8.92966 13.0778 9.24937 13.1797 9.44983 13.2403C9.68478 13.3114 10.1249 13.4216 10.4878 13.5124C10.5785 13.8752 10.6887 14.3153 10.7598 14.5503C10.8204 14.7507 10.9223 15.0704 11.1301 15.3213C11.8254 16.1603 13.087 16.2322 13.873 15.4775C14.1079 15.2519 14.2455 14.9458 14.3285 14.7535C14.4257 14.5282 14.5372 14.2309 14.6685 13.8807L15.291 12.2207C15.5525 11.5237 15.8111 10.8342 15.9215 10.3373C16.0304 9.84696 16.1087 9.10534 15.5589 8.52126C15.533 8.49377 15.5063 8.46707 15.4788 8.44121Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minus","remove","decrease","subtract","delete","reduce","discount","lower","circle-minus","remove-item","discount-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-minus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["minus","remove","decrease","subtract","discount","delete","reduction","circle-minus","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L14 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","minus","remove","subtract","decrease","delete","reduce","quantity","discount","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","circle","remove","decrease","subtract","delete","reduce","discount","order","item","remove-item","delete-item","decrease-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-pen-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","pencil","modify","update","revise","change","write","circle","adjust","correction","alter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.43279 15L10.6688 14.9881C10.7807 14.9899 10.8873 14.9476 10.9658 14.8704L14.6381 11.198C14.87 10.9625 15 10.6453 15 10.3148C15 9.61954 14.3805 9 13.6852 9C13.3547 9 13.0375 9.12997 12.802 9.36186L9.12957 13.0342C9.05237 13.1127 9.01009 13.2193 9.01187 13.3312L9 14.5672C9.00374 14.8025 9.19751 14.9963 9.43279 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-pen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","modify","circle","pen","write","alter","revise","adjustment","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12.1003 8.6493C12.5229 8.23322 13.0922 8 13.6852 8C14.9327 8 16 9.06726 16 10.3148C16 10.9078 15.7668 11.4771 15.3507 11.8997L15.3453 11.9052L11.6672 15.5832C11.3983 15.8478 11.0385 15.9898 10.6694 15.9882L9.4424 16C9.43389 16 9.42539 16 9.41688 15.9999C8.64177 15.9875 8.01246 15.3582 8.00013 14.5831C7.99999 14.5746 7.99996 14.5661 8.00005 14.5576L8.01183 13.3306C8.01024 12.9615 8.15221 12.6017 8.41684 12.3328L8.42244 12.3271L12.1003 8.6493Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-pen-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","write","modify","circle","pen","update","adjust","change","description","notes","remark","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.43279 15L10.6688 14.9881C10.7807 14.9899 10.8873 14.9476 10.9658 14.8704L14.6381 11.198C14.87 10.9625 15 10.6453 15 10.3148C15 9.61954 14.3805 9 13.6852 9C13.3547 9 13.0375 9.12997 12.802 9.36186L9.12957 13.0342C9.05237 13.1127 9.01009 13.2193 9.01187 13.3312L9 14.5672C9.00374 14.8025 9.19751 14.9963 9.43279 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-pen": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","modify","update","pencil","circle","write","change","adjust","alter","revise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.43279 15L10.6688 14.9881C10.7807 14.9899 10.8873 14.9476 10.9658 14.8704L14.6381 11.198C14.87 10.9625 15 10.6453 15 10.3148C15 9.61954 14.3805 9 13.6852 9C13.3547 9 13.0375 9.12997 12.802 9.36186L9.12957 13.0342C9.05237 13.1127 9.01009 13.2193 9.01187 13.3312L9 14.5672C9.00374 14.8025 9.19751 14.9963 9.43279 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Circle-Play-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["play","start","resume","begin","video","media","transaction","playback","execute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1796 8.00808C11.7455 8.0591 12.4303 8.57274 13.8 9.6C14.7629 10.3222 15.2444 10.6833 15.4555 11.1056C15.737 11.6686 15.737 12.3314 15.4555 12.8944C15.2444 13.3167 14.7629 13.6778 13.8 14.4L13.8 14.4C12.4303 15.4273 11.7455 15.9409 11.1796 15.9919C10.4251 16.0599 9.69696 15.6959 9.2987 15.0515C9 14.5682 9 13.7121 9 12C9 10.2879 9 9.43184 9.2987 8.94854C9.69696 8.30413 10.4251 7.94005 11.1796 8.00808Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-Play-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["play","video","start","tutorial","help","guide","demonstration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.1796 8.00808C11.7455 8.0591 12.4303 8.57274 13.8 9.6C14.7629 10.3222 15.2444 10.6833 15.4555 11.1056C15.737 11.6686 15.737 12.3314 15.4555 12.8944C15.2444 13.3167 14.7629 13.6778 13.8 14.4L13.8 14.4C12.4303 15.4273 11.7455 15.9409 11.1796 15.9919C10.4251 16.0599 9.69696 15.6959 9.2987 15.0515C9 14.5682 9 13.7121 9 12C9 10.2879 9 9.43184 9.2987 8.94854C9.69696 8.30413 10.4251 7.94005 11.1796 8.00808Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-plus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["add","plus","create","new","item","add-item","increase","circle-plus","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L14 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Circle-Play": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","arrow","circle","start","resume","continue","video","audio","media","process","begin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1796 8.00808C11.7455 8.0591 12.4303 8.57274 13.8 9.6C14.7629 10.3222 15.2444 10.6833 15.4555 11.1056C15.737 11.6686 15.737 12.3314 15.4555 12.8944C15.2444 13.3167 14.7629 13.6778 13.8 14.4L13.8 14.4C12.4303 15.4273 11.7455 15.9409 11.1796 15.9919C10.4251 16.0599 9.69696 15.6959 9.2987 15.0515C9 14.5682 9 13.7121 9 12C9 10.2879 9 9.43184 9.2987 8.94854C9.69696 8.30413 10.4251 7.94005 11.1796 8.00808Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-Play-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","start","resume","video","audio","media","playback","begin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM15.1122 13.8303C15.3586 13.6172 15.5898 13.3792 15.7442 13.0733C16.0853 12.3976 16.0853 11.6024 15.7442 10.9267C15.5898 10.6208 15.3586 10.3828 15.1122 10.1697C14.8736 9.96325 14.5616 9.73151 14.1932 9.4578L14.1423 9.42001C13.6121 9.02611 13.1768 8.70274 12.8169 8.47567C12.4604 8.25077 12.071 8.04816 11.6407 8.00973C10.7266 7.92809 9.8444 8.36499 9.36188 9.13827C9.13474 9.5023 9.06472 9.93244 9.03251 10.3498C8.99998 10.7712 8.99999 11.3102 9 11.9667V12.0334C8.99999 12.6898 8.99998 13.2288 9.03251 13.6502C9.06472 14.0676 9.13474 14.4977 9.36189 14.8617C9.8444 15.635 10.7266 16.0719 11.6407 15.9903C12.071 15.9518 12.4604 15.7492 12.8169 15.5243C13.1768 15.2973 13.6121 14.9739 14.1423 14.58L14.1932 14.5422C14.5616 14.2685 14.8736 14.0367 15.1122 13.8303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["add","plus","circle","new","create","item","add-item","new-item","increase","more","add-product","new-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","plus","add","new","create","increase","positive","round","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 15C11.4477 15 11 14.5523 11 14V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13V14C13 14.5523 12.5523 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["add","plus","create","new","item","add-item","new-item","increase","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-question-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["question","help","support","faq","information","query","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-question-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["question","help","support","faq","information","query","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15.5V16.5M10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5C14 10.0523 13.7761 10.5523 13.4142 10.9142C12.8007 11.5277 12 12.2034 12 13.071V13.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-question-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","information","query","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V12.8293C14.1652 12.4175 15 11.3062 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10ZM13 15.75C13 15.1977 12.5523 14.75 12 14.75C11.4477 14.75 11 15.1977 11 15.75V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-question-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["question","help","support","faq","unknown","assistance","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15.5V16.5M10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5C14 10.0523 13.7761 10.5523 13.4142 10.9142C12.8007 11.5277 12 12.2034 12 13.071V13.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-question-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","unknown","query","information","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 10.8284 14.6642 11.5784 14.1213 12.1213C13.8037 12.4389 13.4153 12.6856 12.9818 12.8357C12.4599 13.0163 12 13.4477 12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-question-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["question","help","support","faq","query","information","assistance","unknown","circle-question","contact-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 10.8284 14.6642 11.5784 14.1213 12.1213C13.8037 12.4389 13.4153 12.6856 12.9818 12.8357C12.4599 13.0163 12 13.4477 12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16V17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-question-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["question","help","support","faq","information","query","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 10.8284 14.6642 11.5784 14.1213 12.1213C13.8037 12.4389 13.4153 12.6856 12.9818 12.8357C12.4599 13.0163 12 13.4477 12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16V17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-question-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","information","query","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 6C10.3431 6 9 7.34315 9 9C9 9.55228 9.44772 10 10 10C10.5523 10 11 9.55228 11 9C11 8.44771 11.4477 8 12 8C12.5523 8 13 8.44771 13 9C13 9.27642 12.8892 9.52505 12.7071 9.70711C12.6556 9.75865 12.5973 9.81559 12.5344 9.87702C12.2804 10.125 11.951 10.4467 11.6893 10.7813C11.3501 11.2151 11 11.8166 11 12.571V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V12.571C13 12.4577 13.0503 12.2876 13.2648 12.0133C13.4359 11.7945 13.6347 11.5998 13.8737 11.3656C13.9518 11.2891 14.0342 11.2084 14.1213 11.1213C14.6631 10.5795 15 9.82815 15 9C15 7.34315 13.6569 6 12 6ZM13 17V16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-question-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","information","query","assistance","unknown","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 6C9.79086 6 8 7.79086 8 10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 10.5526 13.7772 11.0512 13.4142 11.4142C13.2016 11.6268 12.9424 11.7911 12.6546 11.8907C11.9235 12.1438 11 12.8476 11 14C11 14.5523 11.4477 15 12 15C12.5514 15 12.9986 14.5537 13 14.0026C13.0026 13.9951 13.0114 13.9774 13.0372 13.9489C13.0902 13.8901 13.1859 13.8232 13.3089 13.7807C13.8882 13.5801 14.4059 13.251 14.8284 12.8284C15.5512 12.1057 16 11.1043 16 10C16 7.79086 14.2091 6 12 6ZM13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-question-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["help","question","support","faq","circle-question","assistance","information","query","troubleshooting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-question-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["question","help","support","faq","information","query","assistance","circle-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "circle-question": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","circle-question","information","query","unknown","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15.5V16.5M10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5C14 10.0523 13.7761 10.5523 13.4142 10.9142C12.8007 11.5277 12 12.2034 12 13.071V13.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "circle-radio-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["radio","circle","select","option","choice","payment-method","delivery-option","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12C20 16.4183 16.4183 20 12 20V20C7.58172 20 4 16.4183 4 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "circle-radio-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["radio","option","select","choice","circle","radio-button","select-option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-radio-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["radio-button","radio","select","option","choice","toggle","selection","circle","dot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-share-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["share","network","connection","collaborate","collaboration","integration","sync","synchronize","linked","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.07089 14.0002C5.02417 13.6736 5 13.3397 5 13.0002C5 10.2078 6.63505 7.79729 9 6.67383M8.39241 19.0002C9.44596 19.635 10.6803 20.0002 12 20.0002C13.3197 20.0002 14.554 19.635 15.6076 19.0002M18.9291 14.0002C18.9758 13.6736 19 13.3397 19 13.0002C19 10.2078 17.3649 7.79729 15 6.67383"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14C7.65685 14 9 15.3431 9 17C9 18.1159 8.39076 19.0895 7.48675 19.6063C7.0485 19.8568 6.54097 20 6 20C4.34315 20 3 18.6569 3 17C3 16.0341 3.45644 15.1749 4.16539 14.6262C4.67258 14.2336 5.30901 14 6 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C13.6569 4 15 5.34315 15 7C15 8.11588 14.3908 9.08947 13.4868 9.60627C13.0485 9.85681 12.541 10 12 10C10.3431 10 9 8.65685 9 7C9 6.03414 9.45644 5.17488 10.1654 4.62617C10.6726 4.23361 11.309 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.1159 20.3908 19.0895 19.4868 19.6063C19.0485 19.8568 18.541 20 18 20C16.3431 20 15 18.6569 15 17C15 16.0341 15.4564 15.1749 16.1654 14.6262C16.6726 14.2336 17.309 14 18 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["share","transfer","connection","network","distribution","linking","interaction","collaboration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.07089 14.0002C5.02417 13.6736 5 13.3397 5 13.0002C5 10.2078 6.63505 7.79729 9 6.67383M8.39241 19.0002C9.44596 19.635 10.6803 20.0002 12 20.0002C13.3197 20.0002 14.554 19.635 15.6076 19.0002M18.9291 14.0002C18.9758 13.6736 19 13.3397 19 13.0002C19 10.2078 17.3649 7.79729 15 6.67383"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14C7.65685 14 9 15.3431 9 17C9 18.1159 8.39076 19.0895 7.48675 19.6063C7.0485 19.8568 6.54097 20 6 20C4.34315 20 3 18.6569 3 17C3 16.0341 3.45644 15.1749 4.16539 14.6262C4.67258 14.2336 5.30901 14 6 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C13.6569 4 15 5.34315 15 7C15 8.11588 14.3908 9.08947 13.4868 9.60627C13.0485 9.85681 12.541 10 12 10C10.3431 10 9 8.65685 9 7C9 6.03414 9.45644 5.17488 10.1654 4.62617C10.6726 4.23361 11.309 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.1159 20.3908 19.0895 19.4868 19.6063C19.0485 19.8568 18.541 20 18 20C16.3431 20 15 18.6569 15 17C15 16.0341 15.4564 15.1749 16.1654 14.6262C16.6726 14.2336 17.309 14 18 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","distribute","connect","network","relationship","linking","transfer","collaboration","synchronize","link","affiliate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5569 20.1674C14.4847 20.7004 13.2762 20.9999 12 20.9999C10.7238 20.9999 9.5153 20.7004 8.44315 20.1674C7.76738 20.6894 6.91996 21 6 21C3.79086 21 2 19.2091 2 17C2 15.5124 2.81203 14.2145 4.01702 13.5253C4.00573 13.3515 4 13.1763 4 12.9999C4 9.98543 5.66731 7.36216 8.12632 5.99883C8.57077 4.2742 10.1366 3 12 3C13.8634 3 15.4292 4.2742 15.8737 5.99883C18.3327 7.36216 20 9.98543 20 12.9999C20 13.1763 19.9943 13.3515 19.983 13.5253C21.188 14.2145 22 15.5124 22 17C22 19.2091 20.2091 21 18 21C17.08 21 16.2326 20.6894 15.5569 20.1674ZM12 11C13.7415 11 15.2231 9.88705 15.7723 8.33361C17.1321 9.43431 18 11.1164 18 12.9999C18 12.9999 18 12.9999 18 12.9999C15.7909 12.9999 14 14.7909 14 17C14 17.5459 14.1094 18.0663 14.3074 18.5405C13.5978 18.8364 12.8188 18.9999 12 18.9999C11.1812 18.9999 10.4022 18.8364 9.6926 18.5405C9.89062 18.0663 10 17.5459 10 17C10 14.7909 8.20914 13 6 13C6 11.1165 6.86787 9.4343 8.2277 8.3336C8.7769 9.88705 10.2585 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-radio": {
        defaultColors: ["#3D4C66"],
        keywords: ["radio","button","circle","select","option","choice","selection","payment-method","payment","toggle","on","off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12C20 16.4183 16.4183 20 12 20V20C7.58172 20 4 16.4183 4 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","network","group","connect","transfer","distribution","collaboration","social","referral","export","multi-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.07089 14.0002C5.02417 13.6736 5 13.3397 5 13.0002C5 10.2078 6.63505 7.79729 9 6.67383M8.39241 19.0002C9.44596 19.635 10.6803 20.0002 12 20.0002C13.3197 20.0002 14.554 19.635 15.6076 19.0002M18.9291 14.0002C18.9758 13.6736 19 13.3397 19 13.0002C19 10.2078 17.3649 7.79729 15 6.67383"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14C7.65685 14 9 15.3431 9 17C9 18.1159 8.39076 19.0895 7.48675 19.6063C7.0485 19.8568 6.54097 20 6 20C4.34315 20 3 18.6569 3 17C3 16.0341 3.45644 15.1749 4.16539 14.6262C4.67258 14.2336 5.30901 14 6 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4C13.6569 4 15 5.34315 15 7C15 8.11588 14.3908 9.08947 13.4868 9.60627C13.0485 9.85681 12.541 10 12 10C10.3431 10 9 8.65685 9 7C9 6.03414 9.45644 5.17488 10.1654 4.62617C10.6726 4.23361 11.309 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.1159 20.3908 19.0895 19.4868 19.6063C19.0485 19.8568 18.541 20 18 20C16.3431 20 15 18.6569 15 17C15 16.0341 15.4564 15.1749 16.1654 14.6262C16.6726 14.2336 17.309 14 18 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["not-allowed","restriction","cancel","disabled","remove","prohibited","unavailable","error","stop","no","decline","rejected","block","ban"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "circle-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cancel","remove","delete","disable","unavailable","not-available","void","circle-slash","prohibited","error","invalid","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "circle-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","disable","block","prohibit","restriction","unavailable","not-allowed","remove","error","denied","delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.39361 7.80783C5.5184 8.97641 5 10.4277 5 12C5 15.866 8.13401 19 12 19C13.5723 19 15.0236 18.4816 16.1922 17.6064L6.39361 7.80783ZM7.80783 6.39362L17.6064 16.1922C18.4816 15.0236 19 13.5723 19 12C19 8.13401 15.866 5 12 5C10.4277 5 8.97641 5.5184 7.80783 6.39362ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","delete","remove","prohibit","ban","unavailable","disable","block","not-allowed","no"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Circle-stop-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["stop","pause","block","cancel","circle","end","interrupt","hold","cease","halt","abort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-stop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["stop","block","halt","cancel","abort","terminate","end","pause","circle","round","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-stop": {
        defaultColors: ["#3D4C66"],
        keywords: ["stop","circle","end","halt","pause","cancel","transaction-cancel","order-cancel","payment-cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-stop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["stop","block","circle","halt","pause","cancel","end","square","restrict","prevention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13.1624 8.02135C12.8491 7.99998 12.4707 7.99999 12.032 8H12.032H11.968H11.968C11.5293 7.99999 11.1509 7.99998 10.8376 8.02135C10.5078 8.04386 10.1779 8.09336 9.85195 8.22836C9.11687 8.53284 8.53284 9.11687 8.22836 9.85195C8.09336 10.1779 8.04386 10.5078 8.02135 10.8376C7.99998 11.1509 7.99999 11.5613 8 12C7.99999 12.4387 7.99998 12.8491 8.02135 13.1624C8.04386 13.4922 8.09336 13.8221 8.22836 14.1481C8.53284 14.8831 9.11687 15.4672 9.85195 15.7716C10.1779 15.9066 10.5078 15.9561 10.8376 15.9787C11.1509 16 11.5294 16 11.968 16H12.032C12.4706 16 12.8491 16 13.1624 15.9787C13.4922 15.9561 13.8221 15.9066 14.1481 15.7716C14.8831 15.4672 15.4672 14.8831 15.7716 14.1481C15.9066 13.8221 15.9561 13.4922 15.9787 13.1624C16 12.8491 16 12.4386 16 12C16 11.5614 16 11.1509 15.9787 10.8376C15.9561 10.5078 15.9066 10.1779 15.7716 9.85195C15.4672 9.11687 14.8831 8.53284 14.1481 8.22836C13.8221 8.09336 13.4922 8.04386 13.1624 8.02135Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-User-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","member","staff","employee","login","circle-user","user-profile","user-account","customer-profile","customer-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 18V18C6.43394 17.1321 6.65091 16.6982 7.01094 16.4192C7.12247 16.3327 7.24283 16.2583 7.37001 16.1972C7.78058 16 8.26574 16 9.23607 16H14.7639C15.7343 16 16.2194 16 16.63 16.1972C16.7572 16.2583 16.8775 16.3327 16.9891 16.4192C17.3491 16.6982 17.5661 17.1321 18 18V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-User-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","customer","employee","account","member","person","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 20C14.2879 20 16.3514 19.0396 17.8095 17.5C17.3756 16.6321 17.3491 16.6982 16.9891 16.4192C16.8775 16.3327 16.7572 16.2583 16.63 16.1972C16.2194 16 15.7343 16 14.7639 16H8.00001C7.38714 16 6.82688 16.3463 6.55279 16.8944L6.19051 17.5C7.6486 19.0396 9.71215 20 12 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M17.8095 17.5L18.3541 18.0157L18.7152 17.6344L18.4803 17.1646L17.8095 17.5ZM6.19051 17.5L5.54689 17.115L5.25498 17.6029L5.64595 18.0157L6.19051 17.5ZM6.55279 16.8944L7.19641 17.2795C7.2061 17.2633 7.21517 17.2467 7.22361 17.2298L6.55279 16.8944ZM16.9891 16.4192L17.4485 15.8263L17.4485 15.8263L16.9891 16.4192ZM16.63 16.1972L16.3052 16.8733L16.3052 16.8733L16.63 16.1972ZM17.265 16.9843C15.9426 18.3806 14.0735 19.25 12 19.25V20.75C14.5023 20.75 16.7602 19.6987 18.3541 18.0157L17.265 16.9843ZM12 19.25C9.92656 19.25 8.05741 18.3806 6.73506 16.9843L5.64595 18.0157C7.23978 19.6987 9.49773 20.75 12 20.75V19.25ZM5.90918 16.5094L5.54689 17.115L6.83412 17.885L7.19641 17.2795L5.90918 16.5094ZM8.00001 16.75H14.7639V15.25H8.00001V16.75ZM18.4803 17.1646C18.2698 16.7435 18.1184 16.4631 17.9474 16.2582C17.772 16.0481 17.5459 15.9018 17.4485 15.8263L16.5296 17.012C16.582 17.0525 16.6277 17.0864 16.6645 17.1135C16.7038 17.1425 16.7269 17.1596 16.7475 17.1756C16.7794 17.2004 16.7871 17.2089 16.7958 17.2193C16.8365 17.2681 16.9153 17.3886 17.1387 17.8354L18.4803 17.1646ZM14.7639 16.75C15.2614 16.75 15.5888 16.7506 15.8442 16.772C16.0867 16.7924 16.2117 16.8284 16.3052 16.8733L16.9548 15.5212C16.6377 15.3689 16.3149 15.3062 15.9696 15.2773C15.6371 15.2494 15.2368 15.25 14.7639 15.25V16.75ZM17.4485 15.8263C17.2951 15.7075 17.1296 15.6052 16.9548 15.5212L16.3052 16.8733C16.3847 16.9115 16.4599 16.958 16.5296 17.012L17.4485 15.8263ZM7.22361 17.2298C7.37065 16.9358 7.67122 16.75 8.00001 16.75V15.25C7.10306 15.25 6.2831 15.7568 5.88197 16.559L7.22361 17.2298Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Circle-User-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","contact","user-profile","customer-profile","employee-profile","member-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.2664 20.1622 16.3372 18.7795 17.9195C18.729 17.8239 18.6782 17.7284 18.6276 17.6341C18.4234 17.2536 18.2164 16.882 18.0342 16.5836C17.9435 16.4349 17.8535 16.2954 17.7689 16.1784C17.6984 16.0807 17.5862 15.9332 17.4484 15.8263C17.2951 15.7075 17.1296 15.6052 16.9547 15.5212C16.6376 15.3689 16.3148 15.3062 15.9695 15.2773C15.644 15.25 15.2534 15.25 14.7935 15.25H9.20646C8.7465 15.25 8.3559 15.25 8.03043 15.2773C7.68513 15.3062 7.36229 15.3689 7.04523 15.5212C6.87035 15.6052 6.70486 15.7075 6.55151 15.8263C6.41367 15.9332 6.30154 16.0807 6.23097 16.1784C6.14646 16.2954 6.05641 16.4349 5.96568 16.5836C5.78351 16.882 5.57649 17.2536 5.3723 17.6341C5.32168 17.7284 5.27094 17.8238 5.22046 17.9195C3.83774 16.3372 3 14.2664 3 12ZM8.74992 11C8.74992 9.20507 10.205 7.75 11.9999 7.75C13.7948 7.75 15.2499 9.20507 15.2499 11C15.2499 12.7949 13.7948 14.25 11.9999 14.25C10.205 14.25 8.74992 12.7949 8.74992 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.34653 19.0031C7.89167 20.252 9.85849 21 12 21C14.1415 21 16.1083 20.2521 17.6534 19.0032C17.5401 18.7845 17.4225 18.5607 17.3059 18.3434C17.1066 17.972 16.9147 17.6286 16.7539 17.3651C16.6731 17.2327 16.6056 17.1296 16.553 17.0567C16.5285 17.0227 16.5123 17.0027 16.5041 16.9928C16.4417 16.9469 16.3751 16.9069 16.3051 16.8733C16.2116 16.8284 16.0866 16.7924 15.8441 16.772C15.5887 16.7506 15.2614 16.75 14.7639 16.75H9.23606C8.73856 16.75 8.41119 16.7506 8.15582 16.772C7.91331 16.7924 7.78828 16.8284 7.69477 16.8733C7.62486 16.9069 7.55824 16.9469 7.49578 16.9928C7.48759 17.0027 7.47146 17.0227 7.44695 17.0567C7.39429 17.1296 7.3268 17.2327 7.24602 17.3651C7.08518 17.6286 6.89331 17.972 6.69399 18.3434C6.57738 18.5607 6.45987 18.7844 6.34653 19.0031Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-User-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","account","profile","customer","employee","member","person","circle-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="11" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.43394 18.1321 8.65091 17.6982 9.01094 17.4192C9.12247 17.3327 9.24283 17.2583 9.37001 17.1972C9.78058 17 10.2657 17 11.2361 17H12.7639C13.7343 17 14.2194 17 14.63 17.1972C14.7572 17.2583 14.8775 17.3327 14.9891 17.4192C15.3491 17.6982 15.5661 18.1321 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Circle-User-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","circle-user","user-profile","customer-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.43394 18.1321 8.65091 17.6982 9.01094 17.4192C9.12247 17.3327 9.24283 17.2583 9.37001 17.1972C9.78058 17 10.2657 17 11.2361 17H12.7639C13.7343 17 14.2194 17 14.63 17.1972C14.7572 17.2583 14.8775 17.3327 14.9891 17.4192C15.3491 17.6982 15.5661 18.1321 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Circle-User-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","manager","cashier","user-profile","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 20C13.4571 20 14.8233 19.6807 16 19C15.5661 18.1321 15.3491 17.6982 14.9891 17.4192C14.8775 17.3327 14.7572 17.2583 14.63 17.1972C14.2194 17 13.7343 17 12.7639 17H10C9.38713 17 8.82687 17.3463 8.55279 17.8944L8 19C9.17669 19.6807 10.5429 20 12 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 19L16.3755 19.6492L16.9864 19.2958L16.6708 18.6646L16 19ZM8 19L7.32918 18.6646L7.01356 19.2958L7.62446 19.6492L8 19ZM14.9891 17.4192L15.4485 16.8263L15.4485 16.8263L14.9891 17.4192ZM14.63 17.1972L14.9548 16.5212L14.9548 16.5212L14.63 17.1972ZM15.6245 18.3508C14.5801 18.9549 13.348 19.25 12 19.25V20.75C13.5663 20.75 15.0665 20.4064 16.3755 19.6492L15.6245 18.3508ZM12 19.25C10.652 19.25 9.41989 18.9549 8.37554 18.3508L7.62446 19.6492C8.93349 20.4064 10.4337 20.75 12 20.75V19.25ZM7.88197 17.559L7.32918 18.6646L8.67082 19.3354L9.22361 18.2298L7.88197 17.559ZM10 17.75H12.7639V16.25H10V17.75ZM16.6708 18.6646C16.4594 18.2417 16.2809 17.8833 16.1072 17.5984C15.9269 17.3025 15.7265 17.0418 15.4485 16.8263L14.5296 18.012C14.6116 18.0755 14.6997 18.1713 14.8264 18.3791C14.9597 18.5979 15.1067 18.8904 15.3292 19.3354L16.6708 18.6646ZM12.7639 17.75C13.2614 17.75 13.5888 17.7506 13.8442 17.772C14.0867 17.7924 14.2117 17.8284 14.3052 17.8733L14.9548 16.5212C14.6377 16.3689 14.3149 16.3062 13.9696 16.2773C13.6371 16.2494 13.2368 16.25 12.7639 16.25V17.75ZM15.4485 16.8263C15.2951 16.7075 15.1296 16.6052 14.9548 16.5212L14.3052 17.8733C14.3847 17.9115 14.4599 17.958 14.5296 18.012L15.4485 16.8263ZM9.22361 18.2298C9.37064 17.9358 9.67121 17.75 10 17.75V16.25C9.10305 16.25 8.28309 16.7568 7.88197 17.559L9.22361 18.2298Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-User-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","member","person","staff","clerk","cashier","role","identity","avatar","circle-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 15.027 19.5056 17.7049 17.2144 19.3364C17.023 19.0096 16.8077 18.6595 16.5974 18.3328C16.391 18.012 16.1826 17.7035 15.9991 17.453C15.8394 17.2349 15.6361 16.9717 15.4485 16.8263C15.2951 16.7075 15.1296 16.6052 14.9547 16.5212C14.6377 16.3689 14.3148 16.3062 13.9695 16.2773C13.6441 16.25 13.2535 16.25 12.7936 16.25H9.99998C9.11314 16.25 8.30156 16.7454 7.89567 17.532L6.81001 19.3537C4.50499 17.724 3 15.0377 3 12ZM8.74998 11C8.74998 9.20507 10.2051 7.75 12 7.75C13.7949 7.75 15.25 9.20507 15.25 11C15.25 12.7949 13.7949 14.25 12 14.25C10.2051 14.25 8.74998 12.7949 8.74998 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.10268 20.1147C9.28191 20.6821 10.6038 21 12 21C13.4068 21 14.7383 20.6772 15.9243 20.1017C15.7465 19.7979 15.5414 19.4635 15.3361 19.1447C15.1391 18.8386 14.9486 18.5571 14.7891 18.3394C14.6417 18.1382 14.5586 18.045 14.5357 18.0193C14.5302 18.0131 14.5296 18.012 14.5296 18.012C14.4599 17.958 14.3847 17.9115 14.3052 17.8733C14.2117 17.8284 14.0867 17.7924 13.8442 17.772C13.5888 17.7506 13.2614 17.75 12.7639 17.75H9.99998C9.67119 17.75 9.37063 17.9358 9.22359 18.2298C9.21534 18.2463 9.20648 18.2625 9.19704 18.2784L8.10268 20.1147Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Circle-User": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","member","login","user-profile","customer-profile","employee-profile","account-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 18V18C6.43394 17.1321 6.65091 16.6982 7.01094 16.4192C7.12247 16.3327 7.24283 16.2583 7.37001 16.1972C7.78058 16 8.26574 16 9.23607 16H14.7639C15.7343 16 16.2194 16 16.63 16.1972C16.7572 16.2583 16.8775 16.3327 16.9891 16.4192C17.3491 16.6982 17.5661 17.1321 18 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "circle-xmark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["circle","x","xmark","cross","cancel","close","delete","remove","error","reject","void","undo","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-xmark-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cancel","close","remove","delete","exit","clear","dismiss","circle","x","error","void","discard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "circle-xmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","close","error","reject","decline","void","circle","xmark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM14.7071 9.29289C15.0977 9.68342 15.0977 10.3166 14.7071 10.7071L13.4142 12L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L12 13.4142L10.7071 14.7071C10.3166 15.0976 9.68345 15.0976 9.29292 14.7071C8.9024 14.3166 8.9024 13.6834 9.29292 13.2929L10.5858 12L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L12 10.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "circle-xmark": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","clear","x","close","circle-xmark","discard","reject","erase","void","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    circle: {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","clear","x","close","circle-xmark","discard","reject","erase","void","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12C20 16.4183 16.4183 20 12 20V20C7.58172 20 4 16.4183 4 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "clarify-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["list","details","options","information","configuration","settings","menu","preferences","properties","tabs","receipt","summary","transaction history","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 9H12M12 15H8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12H12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L16 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "clarify-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","menu","options","settings","configuration","details","invoice","receipt","order-details","transaction-details","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 9H12M12 15H8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12H12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L16 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "clarify-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","list","settings","navigation","sidebar","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45868 21 9.57528 21 10.9294V13.0705C21 14.4246 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0707 20H9.92943C8.57535 20 7.45868 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99997 9.57535 2.99994 8.45868 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57534 3.99997 9.92943 4ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55229 7.44772 10 8 10H12C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8H8ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14H8ZM7 12C7 11.4477 7.44772 11 8 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12ZM17 9C17 8.44772 16.5523 8 16 8C15.4477 8 15 8.44772 15 9V15C15 15.5523 15.4477 16 16 16C16.5523 16 17 15.5523 17 15V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    clarify: {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","list","settings","navigation","sidebar","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 9H12M12 15H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L16 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Classic-cart v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["drink","glass","liquid","beverage","water","juice","soda","cocktail","milk","refreshment","menu-item","add-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L5.875 9.5C6.41719 9.80983 7.08281 9.80983 7.625 9.5V9.5C8.16719 9.19017 8.83281 9.19017 9.375 9.5V9.5C9.91719 9.80983 10.5828 9.80983 11.125 9.5V9.5C11.6672 9.19017 12.3328 9.19017 12.875 9.5V9.5C13.4172 9.80983 14.0828 9.80983 14.625 9.5V9.5C15.1672 9.19017 15.8328 9.19017 16.375 9.5V9.5C16.9172 9.80983 17.5828 9.80983 18.125 9.5L19 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 5V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L5.875 5.5C6.41719 5.80983 7.08281 5.80983 7.625 5.5V5.5C8.16719 5.19017 8.83281 5.19017 9.375 5.5V5.5C9.91719 5.80983 10.5828 5.80983 11.125 5.5V5.5C11.6672 5.19017 12.3328 5.19017 12.875 5.5V5.5C13.4172 5.80983 14.0828 5.80983 14.625 5.5V5.5C15.1672 5.19017 15.8328 5.19017 16.375 5.5V5.5C16.9172 5.80983 17.5828 5.80983 18.125 5.5L19 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Classic-cart v2-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["cake","bakery","dessert","layered","sweet","food","pastry","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9996 10.5003C19.9996 10.5003 19.8018 10.6935 19.4958 10.8683L18.6208 11.3683C17.7711 11.8538 16.7281 11.8538 15.8785 11.3683C15.6437 11.2342 15.3555 11.2342 15.1208 11.3683C14.2711 11.8538 13.2281 11.8538 12.3785 11.3683C12.1437 11.2342 11.8555 11.2342 11.6208 11.3683C10.7711 11.8538 9.72811 11.8538 8.87848 11.3683C8.64372 11.2342 8.35552 11.2342 8.12076 11.3683C7.27113 11.8538 6.22811 11.8538 5.37848 11.3683L4.50348 10.8683C3.99962 10.5003 3.99962 10.5003 3.99962 10.5003C3.99828 10.7803 3.99961 10.6257 3.99962 10.9296V13.0707C3.99959 14.4249 3.99956 15.5415 4.11837 16.4252C4.24312 17.3531 4.51509 18.1725 5.1712 18.8286C5.8273 19.4847 6.64673 19.7567 7.57456 19.8814C8.4583 20.0002 9.57489 20.0002 10.929 20.0002H13.0702C14.4243 20.0002 15.5409 20.0002 16.4247 19.8814C17.3525 19.7567 18.1719 19.4847 18.8281 18.8286C19.4842 18.1725 19.7561 17.3531 19.8809 16.4252C19.9997 15.5415 19.9997 14.4249 19.9996 13.0708V10.9296C19.9996 10.6257 20.001 10.7803 19.9996 10.5003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.13138 4.50403C4.40539 4.02451 5.01624 3.85792 5.49576 4.13193L6.37076 4.63193C6.60552 4.76608 6.89372 4.76608 7.12848 4.63193C7.97811 4.14643 9.02113 4.14643 9.87076 4.63193C10.1055 4.76608 10.3937 4.76608 10.6285 4.63193C11.4781 4.14643 12.5211 4.14643 13.3708 4.63193C13.6055 4.76608 13.8937 4.76608 14.1285 4.63193C14.9781 4.14643 16.0211 4.14643 16.8708 4.63193C17.1055 4.76608 17.3937 4.76608 17.6285 4.63193L18.5035 4.13193C18.983 3.85792 19.5939 4.02451 19.8679 4.50403C20.1419 4.98355 19.9753 5.5944 19.4958 5.86841L18.6208 6.36841C17.7711 6.85392 16.7281 6.85392 15.8785 6.36841C15.6437 6.23426 15.3555 6.23426 15.1208 6.36841C14.2711 6.85392 13.2281 6.85392 12.3785 6.36841C12.1437 6.23426 11.8555 6.23426 11.6208 6.36841C10.7711 6.85392 9.72811 6.85392 8.87848 6.36841C8.64372 6.23426 8.35552 6.23426 8.12076 6.36841C7.27113 6.85392 6.22811 6.85392 5.37848 6.36841L4.50348 5.86841C4.02396 5.5944 3.85737 4.98355 4.13138 4.50403Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.13155 8.1042C4.40556 7.62469 5.01641 7.45809 5.49593 7.7321L6.37093 8.2321C6.60569 8.36625 6.89389 8.36625 7.12865 8.2321C7.97828 7.7466 9.0213 7.7466 9.87093 8.2321C10.1057 8.36625 10.3939 8.36625 10.6287 8.2321C11.4783 7.7466 12.5213 7.7466 13.3709 8.2321C13.6057 8.36625 13.8939 8.36625 14.1287 8.2321C14.9783 7.7466 16.0213 7.7466 16.8709 8.2321C17.1057 8.36625 17.3939 8.36625 17.6287 8.2321L18.5037 7.7321C18.9832 7.45809 19.594 7.62469 19.868 8.1042C20.142 8.58372 19.9754 9.19458 19.4959 9.46859L18.6209 9.96859C17.7713 10.4541 16.7283 10.4541 15.8787 9.96859C15.6439 9.83444 15.3557 9.83444 15.1209 9.96859C14.2713 10.4541 13.2283 10.4541 12.3787 9.96859C12.1439 9.83444 11.8557 9.83444 11.6209 9.96859C10.7713 10.4541 9.72828 10.4541 8.87865 9.96859C8.64389 9.83444 8.35569 9.83444 8.12093 9.96859C7.2713 10.4541 6.22828 10.4541 5.37865 9.96859L4.50365 9.46859C4.02413 9.19458 3.85754 8.58372 4.13155 8.1042Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Classic-cart v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["calendar","schedule","events","agenda","dates","month","time","appointments","plans"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 5V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 9L5.875 9.5C6.41719 9.80983 7.08281 9.80983 7.625 9.5V9.5C8.16719 9.19017 8.83281 9.19017 9.375 9.5V9.5C9.91719 9.80983 10.5828 9.80983 11.125 9.5V9.5C11.6672 9.19017 12.3328 9.19017 12.875 9.5V9.5C13.4172 9.80983 14.0828 9.80983 14.625 9.5V9.5C15.1672 9.19017 15.8328 9.19017 16.375 9.5V9.5C16.9172 9.80983 17.5828 9.80983 18.125 9.5L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L5.875 5.5C6.41719 5.80983 7.08281 5.80983 7.625 5.5V5.5C8.16719 5.19017 8.83281 5.19017 9.375 5.5V5.5C9.91719 5.80983 10.5828 5.80983 11.125 5.5V5.5C11.6672 5.19017 12.3328 5.19017 12.875 5.5V5.5C13.4172 5.80983 14.0828 5.80983 14.625 5.5V5.5C15.1672 5.19017 15.8328 5.19017 16.375 5.5V5.5C16.9172 5.80983 17.5828 5.80983 18.125 5.5L19 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Classic-cart v2-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cake","dessert","pastry","bakery","sweet","food","item","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 9L5.875 9.5C6.41719 9.80983 7.08281 9.80983 7.625 9.5V9.5C8.16719 9.19017 8.83281 9.19017 9.375 9.5V9.5C9.91719 9.80983 10.5828 9.80983 11.125 9.5V9.5C11.6672 9.19017 12.3328 9.19017 12.875 9.5V9.5C13.4172 9.80983 14.0828 9.80983 14.625 9.5V9.5C15.1672 9.19017 15.8328 9.19017 16.375 9.5V9.5C16.9172 9.80983 17.5828 9.80983 18.125 9.5L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L5.875 5.5C6.41719 5.80983 7.08281 5.80983 7.625 5.5V5.5C8.16719 5.19017 8.83281 5.19017 9.375 5.5V5.5C9.91719 5.80983 10.5828 5.80983 11.125 5.5V5.5C11.6672 5.19017 12.3328 5.19017 12.875 5.5V5.5C13.4172 5.80983 14.0828 5.80983 14.625 5.5V5.5C15.1672 5.19017 15.8328 5.19017 16.375 5.5V5.5C16.9172 5.80983 17.5828 5.80983 18.125 5.5L19 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Classic-cart-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shopping bag","shopping","bag","purchase","sale","checkout","cart","buy","order","retail","store","ecommerce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.444 15.4818C12.5911 15.4089 12.7274 15.2726 13 15C13.2726 14.7274 13.4089 14.5911 13.4818 14.444C13.6204 14.1642 13.6204 13.8358 13.4818 13.556C13.4089 13.4089 13.2726 13.2726 13 13C12.7274 12.7274 12.5911 12.5911 12.444 12.5182C12.1642 12.3796 11.8358 12.3796 11.556 12.5182C11.4089 12.5911 11.2726 12.7274 11 13C10.7274 13.2726 10.5911 13.4089 10.5182 13.556C10.3796 13.8358 10.3796 14.1642 10.5182 14.444C10.5911 14.5911 10.7274 14.7274 11 15C11.2726 15.2726 11.4089 15.4089 11.556 15.4818C11.8358 15.6204 12.1642 15.6204 12.444 15.4818Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Classic-cart-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping bag","bag","purchase","cart","checkout","sale","retail","transaction","order","payment","goods","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0004 7C10.0004 5.89543 10.8958 5 12.0004 5C13.1049 5 14.0004 5.89543 14.0004 7H10.0004ZM16.0004 7V7.0294C16.1714 7.04006 16.3334 7.05458 16.4857 7.07436C17.1019 7.15438 17.6935 7.3342 18.1914 7.79235C18.6893 8.25051 18.9177 8.82513 19.0486 9.4326C19.1704 9.99774 19.2293 10.7053 19.2974 11.5226L19.6416 15.6537C19.7212 16.6083 19.7895 17.4264 19.7536 18.0835C19.7154 18.7851 19.5533 19.4674 19.0344 20.0313C18.5155 20.5952 17.849 20.8134 17.153 20.9098C16.5012 21.0001 15.6802 21.0001 14.7223 21H9.27839C8.32049 21.0001 7.4995 21.0001 6.84772 20.9098C6.15174 20.8134 5.48518 20.5952 4.96631 20.0313C4.44745 19.4674 4.28537 18.7851 4.2471 18.0835C4.21126 17.4264 4.27949 16.6083 4.35909 15.6537L4.70335 11.5226C4.7714 10.7053 4.83033 9.99774 4.95213 9.4326C5.08305 8.82513 5.31138 8.25051 5.8093 7.79235C6.30722 7.3342 6.89882 7.15438 7.51506 7.07436C7.66735 7.05458 7.82928 7.04006 8.00036 7.0294V7C8.00036 4.79086 9.79122 3 12.0004 3C14.2095 3 16.0004 4.79086 16.0004 7ZM13.4745 12.4134C13.2618 12.1997 13.0394 11.9761 12.7774 11.8463C12.2878 11.6037 11.7129 11.6037 11.2233 11.8463C10.9614 11.9761 10.7389 12.1997 10.5262 12.4134L10.47 12.4698L10.4136 12.526C10.1999 12.7386 9.97636 12.9611 9.84655 13.2231C9.60393 13.7127 9.60393 14.2875 9.84655 14.7771C9.97636 15.0391 10.1999 15.2616 10.4136 15.4742L10.47 15.5304L10.5262 15.5868C10.7389 15.8005 10.9614 16.0241 11.2233 16.1539C11.7129 16.3965 12.2878 16.3965 12.7774 16.1539C13.0394 16.0241 13.2618 15.8005 13.4745 15.5868L13.4745 15.5868L13.5307 15.5304L13.5871 15.4742C13.8008 15.2616 14.0244 15.0391 14.1542 14.7771C14.3968 14.2875 14.3968 13.7127 14.1542 13.2231C14.0244 12.9611 13.8008 12.7386 13.5871 12.526L13.5307 12.4698L13.4745 12.4134Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Classic-cart": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","purchase","checkout","cart","sale","retail","payment","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.444 15.4818C12.5911 15.4089 12.7274 15.2726 13 15C13.2726 14.7274 13.4089 14.5911 13.4818 14.444C13.6204 14.1642 13.6204 13.8358 13.4818 13.556C13.4089 13.4089 13.2726 13.2726 13 13C12.7274 12.7274 12.5911 12.5911 12.444 12.5182C12.1642 12.3796 11.8358 12.3796 11.556 12.5182C11.4089 12.5911 11.2726 12.7274 11 13C10.7274 13.2726 10.5911 13.4089 10.5182 13.556C10.3796 13.8358 10.3796 14.1642 10.5182 14.444C10.5911 14.5911 10.7274 14.7274 11 15C11.2726 15.2726 11.4089 15.4089 11.556 15.4818C11.8358 15.6204 12.1642 15.6204 12.444 15.4818Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Classic-cart-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","purchase","checkout","sale","retail","store","cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3057 11.6678L18.639 15.6678C18.8079 17.6949 18.8924 18.7084 18.2982 19.3542C17.704 20 16.6869 20 14.6528 20H12H9.3472C7.31309 20 6.29604 20 5.70183 19.3542C5.10763 18.7084 5.19209 17.6949 5.36102 15.6678L5.69435 11.6678C5.83942 9.92692 5.91196 9.05647 6.48605 8.52824C7.06013 8 7.9336 8 9.68053 8H12H14.3195C16.0664 8 16.9399 8 17.514 8.52824C18.088 9.05647 18.1606 9.92692 18.3057 11.6678Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V7C15 5.34315 13.6569 4 12 4V4C10.3431 4 9 5.34315 9 7V9.99889"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.444 15.4818C12.5911 15.4089 12.7274 15.2726 13 15C13.2726 14.7274 13.4089 14.5911 13.4818 14.444C13.6204 14.1642 13.6204 13.8358 13.4818 13.556C13.4089 13.4089 13.2726 13.2726 13 13C12.7274 12.7274 12.5911 12.5911 12.444 12.5182C12.1642 12.3796 11.8358 12.3796 11.556 12.5182C11.4089 12.5911 11.2726 12.7274 11 13C10.7274 13.2726 10.5911 13.4089 10.5182 13.556C10.3796 13.8358 10.3796 14.1642 10.5182 14.444C10.5911 14.5911 10.7274 14.7274 11 15C11.2726 15.2726 11.4089 15.4089 11.556 15.4818C11.8358 15.6204 12.1642 15.6204 12.444 15.4818Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Clock-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["clock","time","wait","timer","schedule","late","delay","pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11V13H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Clock-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["clock","time","schedule","late","waiting","duration","history","past"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="6"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 11V13H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Clock-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","schedule","appointment","duration","reminder","late","delay","pending","history","clock-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12ZM12 11C12 10.4477 11.5523 10 11 10C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H12V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Clock: {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","schedule","appointment","duration","reminder","late","delay","pending","history","clock-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11V13H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "clothes-hanger-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hanger","clothes","clothing","apparel","retail","inventory","items","products","wardrobe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.1459 17L7.8541 17C6.83011 17 6 16.1699 6 15.1459C6 14.4436 6.39678 13.8016 7.02492 13.4875L12 11L16.9751 13.4875C17.6032 13.8016 18 14.4436 18 15.1459C18 16.1699 17.1699 17 16.1459 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "clothes-hanger-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hanger","clothing","apparel","fashion","item","product","inventory","rack","wardrobe","clothes-hanger"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1459 17L7.8541 17C6.83011 17 6 16.1699 6 15.1459C6 14.4436 6.39678 13.8016 7.02492 13.4875L12 11L16.9751 13.4875C17.6032 13.8016 18 14.4436 18 15.1459C18 16.1699 17.1699 17 16.1459 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "clothes-hanger-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hanger","clothes","clothing","retail","apparel","fashion","garment","dry cleaning","boutique","store","inventory","merchandise","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C11.4477 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10C9.44772 10 9 9.55228 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 9.76836 14.7111 10.4693 14.2361 11L17.4223 12.5931C18.3892 13.0766 19 14.0648 19 15.1459C19 16.7222 17.7222 18 16.1459 18H7.8541C6.27782 18 5 16.7222 5 15.1459C5 14.0648 5.61078 13.0766 6.57771 12.5931L11.7639 10H12C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "clothes-hanger": {
        defaultColors: ["#3D4C66"],
        keywords: ["hanger","clothing","apparel","garment","inventory","items","products","retail","fashion","style"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1459 17L7.8541 17C6.83011 17 6 16.1699 6 15.1459C6 14.4436 6.39678 13.8016 7.02492 13.4875L12 11L16.9751 13.4875C17.6032 13.8016 18 14.4436 18 15.1459C18 16.1699 17.1699 17 16.1459 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud bolt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cloud","lightning","storm","alert","warning","power","surge","error","interruption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0006 11L10 15H14L13.0002 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud bolt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","lightning","bolt","storm","weather","server","cloud-server","connection-problem","outage","network","error","warning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.0006 11L10 15H14L13.0002 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","bolt","lightning","weather","alert","warning","error","power","electrical","storm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5714 4C10.6301 4 8.89836 5.04659 8.07476 6.63209C8.04988 6.63175 8.02496 6.63158 8 6.63158C5.31759 6.63158 3 8.65294 3 11.3158C3 13.9786 5.31759 16 8 16H8.26792C8.01027 15.5538 7.93299 15.0214 8.05976 14.5147L9.06034 10.5147C9.32838 9.4431 10.4143 8.79172 11.4859 9.05977C12.5574 9.32781 13.2088 10.4138 12.9408 11.4853L12.5619 13H14C14.6158 13 15.1973 13.2837 15.5764 13.7691C15.9554 14.2545 16.0896 14.8875 15.9403 15.485L15.8116 16H16C18.6824 16 21 13.9786 21 11.3158C21 9.03677 19.2967 7.22323 17.128 6.75186C16.3307 5.09952 14.5616 4 12.5714 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2432 10.0299C10.7075 9.89586 10.1645 10.2215 10.0305 10.7573L9.02988 14.7573C8.95515 15.0561 9.02224 15.3726 9.21174 15.6154C9.40125 15.8581 9.69203 16 9.99999 16H12.7193L12.03 18.7575C11.8961 19.2933 12.2219 19.8362 12.7577 19.9701C13.2935 20.1041 13.8364 19.7783 13.9703 19.2425L14.9701 15.2425C15.0448 14.9437 14.9777 14.6273 14.7882 14.3846C14.5987 14.1419 14.3079 14 14 14H11.2809L11.9707 11.2427C12.1047 10.7069 11.779 10.1639 11.2432 10.0299Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud bolt": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","lightning","bolt","storm","weather","power","electricity","surge","alert","warning","issue","error","offline","update","flash","danger","failure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0006 11L10 15H14L13.0002 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud music-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","music","audio","song","playlist","background-music","cafe-music","store-music","entertainment","soundtrack","mood-setting","atmosphere"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud music-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","cloud","audio","playlist","background-music","entertainment","stream","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 13.5V9V13.5Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 15C10.6664 14.9825 10 14.3161 10 13.5C10 12.6839 10.6664 12.0175 11.5 12C12.3336 12.0175 13 12.6839 13 13.5C13 14.3161 12.3336 14.9825 11.5 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud music-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","music","audio","online","streaming","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.43121 8.57643C6.41705 5.90562 8.98482 4 12 4C15.6658 4 18.6734 6.8178 18.9751 10.4056C20.7539 11.1713 22 12.9392 22 15C22 16.3804 21.4393 17.6318 20.5355 18.5355C19.6318 19.4393 18.3804 20 17 20H8C4.68629 20 2 17.3137 2 14C2 11.6041 3.40391 9.53828 5.43121 8.57643ZM13.7071 8.29292C13.4211 8.00692 12.991 7.92137 12.6173 8.07615C12.2436 8.23093 12 8.59557 12 9.00003V11.0555C11.8448 11.0226 11.6846 11.0037 11.521 11.0002C11.507 11 11.493 11 11.479 11.0002C10.1211 11.0288 9 12.1204 9 13.5C9 14.8797 10.1211 15.9713 11.479 15.9998C11.493 16.0001 11.507 16.0001 11.521 15.9998C12.8789 15.9713 14 14.8797 14 13.5V11C14.2559 11 14.5118 10.9024 14.7071 10.7071C15.0976 10.3166 15.0976 9.68345 14.7071 9.29292L13.7071 8.29292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud music": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","cloud","online","song","playlist","entertainment","audio","background-music","jukebox","mood"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud rain-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["weather","rain","forecast","outdoor-dining","weather-alert","bad-weather","seasonal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11914 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L7 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17L11 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L15 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud rain-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rain","weather","cloud","forecast","delay","bad-weather","shipping-delay","service-disruption","unavailability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11914 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L7 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17L11 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L15 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud rain-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["weather","rain","cloud","forecast","alert","warning","outdoor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11914 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 16.2929C8.31658 15.9024 7.68342 15.9024 7.29289 16.2929L6.29289 17.2929C5.90237 17.6834 5.90237 18.3166 6.29289 18.7071C6.68342 19.0976 7.31658 19.0976 7.70711 18.7071L8.70711 17.7071C9.09763 17.3166 9.09763 16.6834 8.70711 16.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7071 16.2929C12.3166 15.9024 11.6834 15.9024 11.2929 16.2929L10.2929 17.2929C9.90237 17.6834 9.90237 18.3166 10.2929 18.7071C10.6834 19.0976 11.3166 19.0976 11.7071 18.7071L12.7071 17.7071C13.0976 17.3166 13.0976 16.6834 12.7071 16.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7071 16.2929C16.3166 15.9024 15.6834 15.9024 15.2929 16.2929L14.2929 17.2929C13.9024 17.6834 13.9024 18.3166 14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071L16.7071 17.7071C17.0976 17.3166 17.0976 16.6834 16.7071 16.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud rain": {
        defaultColors: ["#3D4C66"],
        keywords: ["weather","cloud","rain","forecast","bad-weather","warning","alert","service-unavailable","service-alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11914 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L7 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","sync","update","backup","online","data","cloud-sync","cloud-backup","cloud-storage","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 14.0004C15.9347 13.2983 16.6153 12.2763 16.8793 11.097M16.8793 11.097C16.9583 10.7439 17 10.3768 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 10.3768 7.04169 10.7439 7.12071 11.097M16.8793 11.097C18.6654 11.4976 20 13.0929 20 15C20 17.2091 18.2091 19 16 19H8C5.79086 19 4 17.2091 4 15C4 13.0929 5.33457 11.4976 7.12071 11.097M10.6458 12C9.94069 11.3776 9.01445 11 8 11C7.69791 11 7.40364 11.0335 7.12071 11.097"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.9999 10C16.9999 10.3768 16.9582 10.7439 16.8792 11.097C16.6152 12.2763 15.9346 13.2983 14.9999 14.0004M10.6457 12C9.94059 11.3776 9.01434 11 7.9999 11C7.69781 11 7.40354 11.0335 7.12061 11.097"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-10": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","cloud-storage","backup","online","data","sync","cloud-sync","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","server","data","backup","storage","cloud-storage","online","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.98482 4 6.41705 5.90562 5.43121 8.57643C3.40391 9.53828 2 11.6041 2 14C2 17.3137 4.68629 20 8 20H17C18.3804 20 19.6318 19.4393 20.5355 18.5355C21.4393 17.6318 22 16.3804 22 15C22 12.9392 20.7539 11.1713 18.9751 10.4056C18.6734 6.8178 15.6658 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","storage","online","backup","sync","data","network","server","cloud-storage","cloud-backup","cloud-sync","cloud-data","remote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.71851 9.69085C8.48542 9.65191 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.4276 9.84081 16.412 9.65088M16.5714 11C16.5714 8.79086 14.7806 7 12.5714 7C10.3623 7 8.57143 8.79086 8.57143 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","storage","data","backup","online","network","server","sync","cloud-storage","cloud-backup","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.71851 9.69085C8.48542 9.65191 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.4276 9.84081 16.412 9.65088M16.5714 11C16.5714 8.79086 14.7806 7 12.5714 7C10.3623 7 8.57143 8.79086 8.57143 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5715 11C16.5715 8.79086 14.7807 7 12.5715 7C10.3624 7 8.57153 8.79086 8.57153 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-14": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","storage","backup","data","online","sync","cloud-storage","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.3544 9.84262 16.3389 9.65269C15.7858 8.1064 14.3078 7 12.5714 7C10.8134 7 9.32034 8.13409 8.78381 9.71056C8.55072 9.67162 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8.78381 9.71056C8.55072 9.67162 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.3544 9.84262 16.3389 9.65269M16.5714 11C16.5714 8.79086 14.7806 7 12.5714 7C10.3623 7 8.57143 8.79086 8.57143 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","backup","server","online","network","cloud-storage","cloud-backup","cloud-server","cloud-network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5714 6C14.5247 6 16.2144 7.11958 17.0374 8.74974C19.2057 9.21143 21 11.0097 21 13.3158C21 15.9786 18.6824 18 16 18H8C5.31759 18 3 15.9786 3 13.3158C3 10.6529 5.31759 8.63158 8 8.63158C8.05416 8.63158 8.10943 8.63296 8.16507 8.63545C9.00825 7.06737 10.6642 6 12.5714 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","server","data","storage","backup","online","remote","network","sync","update","cloud-storage","cloud-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C5.79086 10 4 11.7909 4 14C4 16.2091 5.79086 18 8 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10ZM16 10C16 11.0144 15.6224 11.9407 15 12.6458"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","sync","data","online","backup","cloud-storage","server"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C5.79086 10 4 11.7909 4 14C4 16.2091 5.79086 18 8 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10ZM16 10C16 11.0144 15.6224 11.9407 15 12.6458"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 11.0144 15.6224 11.9407 15 12.6458"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-18": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","server","data","backup","sync","online","network","storage","cloud-storage","remote","update","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C9.79086 6 8 7.79086 8 10C5.79086 10 4 11.7909 4 14C4 16.2091 5.79086 18 8 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C16 7.79086 14.2091 6 12 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C5.79086 10 4 11.7909 4 14C4 16.2091 5.79086 18 8 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10ZM16 10C16 11.0144 15.6224 11.9407 15 12.6458"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","network","data","backup","server","storage","online","remote","update","sync","cloud-storage","cloud-backup","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C9.23858 5 7 7.23858 7 10C7 10.3768 7.04169 10.7439 7.12071 11.097C5.33457 11.4976 4 13.0929 4 15C4 17.2091 5.79086 19 8 19H16C18.2091 19 20 17.2091 20 15C20 13.0929 18.6654 11.4976 16.8793 11.097C16.9583 10.7439 17 10.3768 17 10C17 7.23858 14.7614 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M15 14.0004C15.9347 13.2983 16.6153 12.2763 16.8793 11.097M16.8793 11.097C16.9583 10.7439 17 10.3768 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 10.3768 7.04169 10.7439 7.12071 11.097M16.8793 11.097C18.6654 11.4976 20 13.0929 20 15C20 17.2091 18.2091 19 16 19H8C5.79086 19 4 17.2091 4 15C4 13.0929 5.33457 11.4976 7.12071 11.097M10.6458 12C9.94069 11.3776 9.01445 11 8 11C7.69791 11 7.40364 11.0335 7.12071 11.097"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","backup","sync","online","server","remote-access","cloud-storage","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9162 9.08376C16.4859 6.75992 14.4485 5 12 5C9.55154 5 7.51413 6.75992 7.08376 9.08376C4.75992 9.51413 3 11.5515 3 14C3 16.7614 5.23858 19 8 19H16C18.7614 19 21 16.7614 21 14C21 11.5515 19.2401 9.51413 16.9162 9.08376ZM16.6362 11.8752C16.8434 11.3633 16.5964 10.7803 16.0845 10.5731C15.5725 10.3659 14.9895 10.6129 14.7823 11.1248C14.6543 11.4411 14.4735 11.7312 14.2503 11.9841C13.8848 12.3982 13.9242 13.0301 14.3383 13.3956C14.7523 13.761 15.3843 13.7216 15.7498 13.3076C16.1204 12.8876 16.422 12.4043 16.6362 11.8752Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","network","online","backup","cloud-storage","cloud-data","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.4276 9.84081 16.412 9.65088C15.927 8.11914 14.3911 7 12.5714 7C10.736 7 9.18926 8.13864 8.71851 9.69085C8.48542 9.65191 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cloud-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","backup","online","server","network","cloud-storage","cloud-data","pos-data","sync","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.4276 9.84081 16.412 9.65088C15.927 8.11914 14.3911 7 12.5714 7C10.736 7 9.18926 8.13864 8.71851 9.69085C8.48542 9.65191 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cloud-22": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","server","storage","backup","data","network","online","sync","cloud-storage","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17C18.2091 17 20 15.3505 20 13.3158C20 11.4092 18.4276 9.84081 16.412 9.65088C15.927 8.11914 14.3911 7 12.5714 7C10.736 7 9.18926 8.13864 8.71851 9.69085C8.48542 9.65191 8.24529 9.63158 8 9.63158C5.79086 9.63158 4 11.2811 4 13.3158C4 15.3505 5.79086 17 8 17H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cloud-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","server","data","backup","online","sync","storage","cloud-storage","network","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5714 6C10.6301 6 8.89836 7.04659 8.07476 8.63209C8.04988 8.63175 8.02496 8.63158 8 8.63158C5.31759 8.63158 3 10.6529 3 13.3158C3 15.9786 5.31759 18 8 18H16C18.6824 18 21 15.9786 21 13.3158C21 11.0368 19.2967 9.22323 17.128 8.75186C16.3307 7.09952 14.5616 6 12.5714 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","storage","backup","online","sync","cloud-storage","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 10C18 10.1378 17.9953 10.2746 17.9861 10.4103C19.7593 11.1787 21 12.9436 21 15C21 17.7614 18.7614 20 16 20H8C5.23858 20 3 17.7614 3 15C3 12.9436 4.24073 11.1787 6.01385 10.4103C6.00466 10.2746 6 10.1378 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","data","backup","sync","storage","server","network","cloud-storage","cloud-backup","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","server","data","storage","network","backup","cloud-sync","online"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.0001 11.9997C16.0001 11.3037 15.8815 10.6353 15.6636 10.0137"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cloud","data","storage","backup","sync","online","network","cloud-based","pos-system","cloud-pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 15.3137 6.68629 18 10 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C15.8867 10 15.7744 10.0047 15.6635 10.014C14.8438 7.67628 12.6176 6 10 6C6.68629 6 4 8.68629 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","online","data","storage","network","backup","remote","sync","cloud-storage","cloud-backup","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-9": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","network","data","storage","sync","backup","online","server","connection","remote","cloud-data","cloud-storage","cloud-sync","cloud-backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11C18 7.68629 15.3137 5 12 5C9.26981 5 6.96552 6.82352 6.23865 9.31906C4.34628 10.0315 3 11.8585 3 14C3 16.7614 5.23858 19 8 19H17C18.1046 19 19.1046 18.5523 19.8284 17.8284C20.5523 17.1046 21 16.1046 21 15C21 13.1357 19.7246 11.5693 17.9987 11.1257C17.9996 11.0839 18 11.042 18 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-download-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","download","update","import","arrow","data","cloud-download","cloud-update","system-update","receive","synchronize","pos-update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 19L12 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17C13.7231 18.2769 13.0846 18.9154 12.2313 18.9899C12.0776 19.0034 11.9224 19.0034 11.7687 18.9899C10.9154 18.9154 10.2769 18.2769 9 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-download-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","download","update","import","arrow-down","sync","data","restore","backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 18" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 17L10.5858 17.5858C11.2525 18.2525 11.5858 18.5858 12 18.5858C12.4142 18.5858 12.7475 18.2525 13.4142 17.5858L14 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","server","database","storage","data","network","backup","sync","online","remote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3312 9.0108C15.2104 6.64105 12.7979 5 10 5C6.13401 5 3 8.13401 3 12C3 15.866 6.13401 19 10 19H16C18.7614 19 21 16.7614 21 14C21 11.3499 18.9382 9.18127 16.3312 9.0108ZM16.9953 11.9025C16.9414 11.3528 16.4521 10.9509 15.9025 11.0048C15.3528 11.0587 14.9509 11.548 15.0048 12.0977C15.0208 12.2603 15.029 12.4254 15.029 12.5928C15.029 13.1451 15.4767 13.5928 16.029 13.5928C16.5813 13.5928 17.029 13.1451 17.029 12.5928C17.029 12.3601 17.0176 12.1298 16.9953 11.9025Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","download","import","data","backup","restore","update","pos-data","cloud-backup","cloud-restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C12.5523 13 13 13.4477 13 14V17.5858L13.2929 17.2929C13.6834 16.9024 14.3166 16.9024 14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071L14.1213 19.2929C14.1085 19.3057 14.0957 19.3186 14.0829 19.3314C13.7831 19.6313 13.4917 19.9228 13.219 20.1308C12.9116 20.3653 12.5137 20.5858 12 20.5858C11.4863 20.5858 11.0884 20.3653 10.781 20.1308C10.5083 19.9228 10.217 19.6313 9.91715 19.3314C9.90434 19.3186 9.89152 19.3057 9.87868 19.2929L9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929C9.68342 16.9024 10.3166 16.9024 10.7071 17.2929L11 17.5858L11 14C11 13.4477 11.4477 13 12 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5714 4C10.6301 4 8.89836 5.04659 8.07476 6.63209C8.04988 6.63175 8.02496 6.63158 8 6.63158C5.31759 6.63158 3 8.65294 3 11.3158C3 13.9786 5.31759 16 8 16H10V14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14V16H16C18.6824 16 21 13.9786 21 11.3158C21 9.03677 19.2967 7.22323 17.128 6.75186C16.3307 5.09952 14.5616 4 12.5714 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-download": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","download","backup","restore","data","update","import","cloud-download","get-data","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15C18.2091 15 20 13.3505 20 11.3158C20 9.40917 18.4276 7.84081 16.412 7.65088C15.927 6.11913 14.3911 5 12.5714 5C10.736 5 9.18926 6.13864 8.71851 7.69085C8.48542 7.65191 8.24529 7.63158 8 7.63158C5.79086 7.63158 4 9.28106 4 11.3158C4 13.3505 5.79086 15 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 17L10.5858 17.5858C11.2525 18.2525 11.5858 18.5858 12 18.5858C12.4142 18.5858 12.7475 18.2525 13.4142 17.5858L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","offline","disconnected","no-connection","sync-error","network-error","disable-cloud","data-loss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cloud-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","off","disconnected","offline","no connection","sync error","network issue","data unavailable","server down","connection lost","no cloud service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cloud-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","offline","no-connection","disconnected","sync-error","no-sync","data-loss","error","disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.35177 6.76598C3.90899 8.04821 3 9.91795 3 12C3 15.866 6.13401 19 10 19H16C16.4823 19 16.9487 18.9317 17.39 18.8042L5.35177 6.76598Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.2306 17.8163L7.05979 5.64558C7.95376 5.23124 8.94987 5 10 5C12.7979 5 15.2104 6.64105 16.3312 9.0108C18.9382 9.18127 21 11.3499 21 14C21 15.5298 20.3129 16.8992 19.2306 17.8163Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","off","offline","disconnected","no-connection","sync-error","disabled-sync","network-error","server-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 15.3137 6.68629 18 10 18H16C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C15.8867 10 15.7744 10.0047 15.6635 10.014C14.8438 7.67628 12.6176 6 10 6C6.68629 6 4 8.68629 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 12C16 11.3039 15.8815 10.6356 15.6635 10.014M15.6635 10.014C15.7744 10.0047 15.8867 10 16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H10C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C12.6176 6 14.8438 7.67628 15.6635 10.014Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cloud-upload-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cloud","upload","data","backup","sync","update","information","server","online","cloud-upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13L12 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16C18.2091 16 20 14.3505 20 12.3158C20 10.4092 18.4276 8.84081 16.412 8.65088C15.927 7.11913 14.3911 6 12.5714 6C10.736 6 9.18926 7.13864 8.71851 8.69085C8.48542 8.65191 8.24529 8.63158 8 8.63158C5.79086 8.63158 4 10.2811 4 12.3158C4 14.3505 5.79086 16 8 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cloud-upload-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","upload","backup","sync","data","transfer","online","server","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 16C18.2091 16 20 14.3505 20 12.3158C20 10.4092 18.4276 8.84081 16.412 8.65088C15.927 7.11913 14.3911 6 12.5714 6C10.736 6 9.18926 7.13864 8.71851 8.69085C8.48542 8.65191 8.24529 8.63158 8 8.63158C5.79086 8.63158 4 10.2811 4 12.3158C4 14.3505 5.79086 16 8 16H16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 12L12 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 14C10.2769 12.7231 10.9154 12.0846 11.7687 12.0101C11.9224 11.9966 12.0776 11.9966 12.2313 12.0101C13.0846 12.0846 13.7231 12.7231 15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Cloud-upload-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","upload","backup","data","sync","cloud-storage","export","cloud-upload","update","cloud-backup","cloud-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 14.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L14.1213 12.7071C14.1085 12.6943 14.0957 12.6814 14.0829 12.6686C13.783 12.3687 13.4917 12.0772 13.219 11.8692C12.9116 11.6347 12.5137 11.4142 12 11.4142C11.4863 11.4142 11.0884 11.6347 10.781 11.8692C10.5083 12.0772 10.217 12.3687 9.91715 12.6686C9.90434 12.6814 9.89152 12.6943 9.87868 12.7071L9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L11 14.4142L11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V14.4142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5714 5C10.6301 5 8.89836 6.04659 8.07476 7.63209C8.04988 7.63175 8.02496 7.63158 8 7.63158C5.31759 7.63158 3 9.65294 3 12.3158C3 14.9786 5.31759 17 8 17H10V16.0001C9.48816 16.0001 8.97631 15.8048 8.58579 15.4143C7.80474 14.6333 7.80474 13.3669 8.58579 12.5859L9.22724 11.9444C9.50973 11.6615 9.84606 11.3248 10.1744 11.0743C10.5707 10.7719 11.1798 10.4143 12 10.4143C12.8202 10.4143 13.4293 10.7719 13.8256 11.0743C14.1539 11.3248 14.4903 11.6615 14.7728 11.9444L15.4142 12.5859C16.1953 13.3669 16.1953 14.6333 15.4142 15.4143C15.0237 15.8048 14.5118 16.0001 14 16.0001V17H16C18.6824 17 21 14.9786 21 12.3158C21 10.0368 19.2967 8.22323 17.128 7.75186C16.3307 6.09952 14.5616 5 12.5714 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cloud-upload": {
        defaultColors: ["#7E47E1", "#3D4C66"],
        keywords: ["cloud","upload","backup","data","sync","cloud-upload","send-data","update","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13L12 18" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16C18.2091 16 20 14.3505 20 12.3158C20 10.4092 18.4276 8.84081 16.412 8.65088C15.927 7.11913 14.3911 6 12.5714 6C10.736 6 9.18926 7.13864 8.71851 8.69085C8.48542 8.65191 8.24529 8.63158 8 8.63158C5.79086 8.63158 4 10.2811 4 12.3158C4 14.3505 5.79086 16 8 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Cloud: {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","upload","backup","data","sync","cloud-upload","send-data","update","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 14.0004C15.9347 13.2983 16.6153 12.2763 16.8793 11.097M16.8793 11.097C16.9583 10.7439 17 10.3768 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 10.3768 7.04169 10.7439 7.12071 11.097M16.8793 11.097C18.6654 11.4976 20 13.0929 20 15C20 17.2091 18.2091 19 16 19H8C5.79086 19 4 17.2091 4 15C4 13.0929 5.33457 11.4976 7.12071 11.097M10.6458 12C9.94069 11.3776 9.01445 11 8 11C7.69791 11 7.40364 11.0335 7.12071 11.097"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "code-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["code","tags","html","xml","programming","script","customization","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L5 12L8 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L19 12L16 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 18L13 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "code-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["code","programming","script","development","customization","settings","options","advanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L5 12L8 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L19 12L16 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 18L13 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "code-box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["code","programming","script","html","settings","configuration","developer","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V12C20 8.22876 20 6.34315 18.8284 5.17157C18.8284 5.17157 18.8284 5.17157 18.8284 5.17157C17.6569 4 15.7712 4 12 4V4C8.22876 4 6.34315 4 5.17157 5.17157C5.17157 5.17157 5.17157 5.17157 5.17157 5.17157C4 6.34315 4 8.22876 4 12V12C4 15.7712 4 17.6569 5.17157 18.8284C5.17157 18.8284 5.17157 18.8284 5.17157 18.8284C6.34315 20 8.22876 20 12 20V20C15.7712 20 17.6569 20 18.8284 18.8284C18.8284 18.8284 18.8284 18.8284 18.8284 18.8284C20 17.6569 20 15.7712 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L17 12L15 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L11 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","script","developer","settings","configuration","options","advanced","technical","integration","api"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.70711 8.2928C9.09763 8.68333 9.09763 9.31649 8.70711 9.70702L6.41421 11.9999L8.70711 14.2928C9.09763 14.6833 9.09763 15.3165 8.70711 15.707C8.31658 16.0975 7.68342 16.0975 7.29289 15.707L4.29289 12.707C3.90237 12.3165 3.90237 11.6833 4.29289 11.2928L7.29289 8.2928C7.68342 7.90228 8.31658 7.90228 8.70711 8.2928Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2929 15.707C14.9024 15.3165 14.9024 14.6833 15.2929 14.2928L17.5858 11.9999L15.2929 9.70702C14.9024 9.31649 14.9024 8.68333 15.2929 8.29281C15.6834 7.90228 16.3166 7.90228 16.7071 8.29281L19.7071 11.2928C20.0976 11.6833 20.0976 12.3165 19.7071 12.707L16.7071 15.707C16.3166 16.0975 15.6834 16.0975 15.2929 15.707Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1644 5.01352C13.7092 5.10431 14.0772 5.61954 13.9864 6.16431L11.9864 18.1643C11.8956 18.7091 11.3804 19.0771 10.8356 18.9863C10.2908 18.8955 9.92281 18.3803 10.0136 17.8355L12.0136 5.83551C12.1044 5.29074 12.6196 4.92272 13.1644 5.01352Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "code-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["code","programming","settings","configuration","customize","developer","api","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L17 12L15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L11 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","development","script","html","programming","customization","settings","advanced-options","technical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26703 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM13.9701 8.24253C14.1041 7.70673 13.7783 7.1638 13.2425 7.02985C12.7067 6.8959 12.1638 7.22166 12.0299 7.75746L10.0299 15.7575C9.89591 16.2933 10.2217 16.8362 10.7575 16.9701C11.2933 17.1041 11.8362 16.7783 11.9701 16.2425L13.9701 8.24253ZM9.70711 10.7071C10.0976 10.3166 10.0976 9.68341 9.70711 9.29289C9.31658 8.90236 8.68342 8.90236 8.29289 9.29289L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071C10.0976 14.3166 10.0976 13.6834 9.70711 13.2929L8.41421 12L9.70711 10.7071ZM15.7071 9.29289C15.3166 8.90236 14.6834 8.90236 14.2929 9.29289C13.9024 9.68341 13.9024 10.3166 14.2929 10.7071L15.5858 12L14.2929 13.2929C13.9024 13.6834 13.9024 14.3166 14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071L17.7071 12.7071C18.0976 12.3166 18.0976 11.6834 17.7071 11.2929L15.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "code-s-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["code","programming","brackets","less-than","greater-than","settings","configuration","edit","development"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","development","settings","configuration","customization","advanced-options","script","source-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V12C20 8.22876 20 6.34315 18.8284 5.17157C18.8284 5.17157 18.8284 5.17157 18.8284 5.17157C17.6569 4 15.7712 4 12 4V4C8.22876 4 6.34315 4 5.17157 5.17157C5.17157 5.17157 5.17157 5.17157 5.17157 5.17157C4 6.34315 4 8.22876 4 12V12C4 15.7712 4 17.6569 5.17157 18.8284C5.17157 18.8284 5.17157 18.8284 5.17157 18.8284C6.34315 20 8.22876 20 12 20V20C15.7712 20 17.6569 20 18.8284 18.8284C18.8284 18.8284 18.8284 18.8284 18.8284 18.8284C20 17.6569 20 15.7712 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L17 12L15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L7 12L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8L11 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-s-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["code","brackets","less-than","greater-than","programming","developer","settings","configuration","previous","next","navigation","scroll","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-s-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","less-than","greater-than","tags","programming","development","back","forward","previous","next","scroll","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2 8.40006C14.8686 8.84189 14.9582 9.46869 15.4 9.80006L18.3333 12.0001L15.4 14.2001C14.9582 14.5314 14.8686 15.1582 15.2 15.6001C15.5314 16.0419 16.1582 16.1314 16.6 15.8001L20.6 12.8001C20.8518 12.6112 21 12.3148 21 12.0001C21 11.6853 20.8518 11.3889 20.6 11.2001L16.6 8.20006C16.1582 7.86869 15.5314 7.95823 15.2 8.40006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.8 8.40006C9.13137 8.84189 9.04183 9.46869 8.6 9.80006L5.66667 12.0001L8.6 14.2001C9.04183 14.5314 9.13137 15.1582 8.8 15.6001C8.46863 16.0419 7.84183 16.1314 7.4 15.8001L3.4 12.8001C3.14819 12.6112 3 12.3148 3 12.0001C3 11.6853 3.14819 11.3889 3.4 11.2001L7.4 8.20006C7.84183 7.86869 8.46863 7.95823 8.8 8.40006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "code-s-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["code","programming","script","customize","settings","advanced","technical","develop","edit","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6L10 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-s-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["code","programming","script","html","settings","customize","technical","developer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6L10 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-s-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","script","customization","settings","configuration","developer","technical","integration","api"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2 8.40027C14.8686 8.8421 14.9582 9.4689 15.4 9.80027L18.3333 12.0003L15.4 14.2003C14.9582 14.5316 14.8686 15.1584 15.2 15.6003C15.5314 16.0421 16.1582 16.1316 16.6 15.8003L20.6 12.8003C20.8518 12.6114 21 12.315 21 12.0003C21 11.6855 20.8518 11.3891 20.6 11.2003L16.6 8.20027C16.1582 7.8689 15.5314 7.95844 15.2 8.40027Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.8 8.40027C9.13137 8.8421 9.04183 9.4689 8.6 9.80027L5.66667 12.0003L8.6 14.2003C9.04183 14.5316 9.13137 15.1584 8.8 15.6003C8.46863 16.0421 7.84183 16.1316 7.4 15.8003L3.4 12.8003C3.14819 12.6114 3 12.315 3 12.0003C3 11.6855 3.14819 11.3891 3.4 11.2003L7.4 8.20027C7.84183 7.8689 8.46863 7.95844 8.8 8.40027Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.3162 5.05159C14.8402 5.22624 15.1233 5.79256 14.9487 6.3165L10.9487 18.3165C10.774 18.8404 10.2077 19.1236 9.68377 18.949C9.15983 18.7743 8.87667 18.208 9.05132 17.684L13.0513 5.68404C13.226 5.1601 13.7923 4.87694 14.3162 5.05159Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "code-s-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","programming","developer","html","edit","settings","configuration","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6L10 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "code-s": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","greater-than","less-than","arrow","next","previous","navigate","scroll"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9L20 12L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L4 12L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    code: {
        defaultColors: ["#3D4C66"],
        keywords: ["code","greater-than","less-than","arrow","next","previous","navigate","scroll"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L5 12L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L19 12L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 18L13 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "CodePen-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["box","cube","3d","inventory","stock","warehouse","storage","package","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5V9M12 15V19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10.0617L12 5L19 10.0617M5 10.0617L12 15L19 10.0617M5 10.0617V14.0617M19 10.0617V14.0617M5 14.0617L12 9L19 14.0617M5 14.0617L12 19L19 14.0617"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CodePen-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cube","box","inventory","stock","3d","warehouse","storage","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0617L12 5M5 10.0617L12 15M5 10.0617V14.0617M12 5L19 10.0617M12 5V9M19 10.0617L12 15M19 10.0617V14.0617M12 15V19M5 14.0617L12 9M5 14.0617L12 19M12 9L19 14.0617M19 14.0617L12 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CodePen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","cube","inventory","stock","warehouse","storage","item","package","3d","three-dimensional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.414 4.18966C11.7638 3.93678 12.2362 3.93678 12.586 4.18966L19.586 9.25139C19.846 9.43942 20 9.74083 20 10.0617V14.0617C20 14.3868 19.842 14.6915 19.5765 14.8789L12.5765 19.8171C12.2308 20.061 11.7692 20.061 11.4235 19.8171L4.42354 14.8789C4.15796 14.6915 4 14.3868 4 14.0617V10.0617C4 9.74083 4.154 9.43942 4.41404 9.25139L11.414 4.18966ZM6 11.991L6.07951 12.0471L6 12.1046V11.991ZM6.72049 14.0517L11 17.0707V15.5183L7.80718 13.2659L6.72049 14.0517ZM9.52049 12.027L12 13.7762L14.4795 12.027L12 10.2341L9.52049 12.027ZM13 8.48905L16.2072 10.8082L17.2795 10.0517L13 6.95715V8.48905ZM11 6.95715V8.48905L7.79282 10.8082L6.72049 10.0517L11 6.95715ZM18 11.991L17.9205 12.0471L18 12.1046V11.991ZM17.2795 14.0517L16.1928 13.2659L13 15.5183V17.0707L17.2795 14.0517Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    CodePen: {
        defaultColors: ["#3D4C66"],
        keywords: ["box","cube","inventory","stock","warehouse","storage","item","package","3d","three-dimensional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.0617L12 5M5 10.0617L12 15M5 10.0617V14.0617M12 5L19 10.0617M12 5V9M19 10.0617L12 15M19 10.0617V14.0617M12 15V19M5 14.0617L12 9M5 14.0617L12 19M12 9L19 14.0617M19 14.0617L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cog-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","gear","configuration","options","adjust","preferences","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 18.1986 14.9689 17.7973 15.5355 18.364C16.3166 19.145 17.5829 19.145 18.3639 18.364C19.145 17.5829 19.145 16.3166 18.3639 15.5355C17.7973 14.9689 18.1986 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C18.1986 10 17.7974 9.0311 18.364 8.46446C19.145 7.68341 19.145 6.41708 18.364 5.63603C17.583 4.85498 16.3166 4.85498 15.5356 5.63603C14.9689 6.20269 14 5.80138 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 5.80138 9.0311 6.20271 8.46444 5.63605C7.68339 4.855 6.41706 4.855 5.63602 5.63605C4.85497 6.4171 4.85497 7.68343 5.63602 8.46448C6.20266 9.03112 5.80135 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C5.80136 14 6.20273 14.9689 5.63608 15.5355C4.85503 16.3166 4.85503 17.5829 5.63608 18.364C6.41713 19.145 7.68346 19.145 8.46451 18.364C9.03114 17.7973 10 18.1987 10 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cog-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flower","rewards","loyalty","vip","customer","settings","customization","appearance","theme"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 18.1986 14.9689 17.7973 15.5355 18.364C16.3166 19.145 17.5829 19.145 18.3639 18.364C19.145 17.5829 19.145 16.3166 18.3639 15.5355C17.7973 14.9689 18.1986 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C18.1986 10 17.7974 9.0311 18.364 8.46446C19.145 7.68341 19.145 6.41708 18.364 5.63603C17.583 4.85498 16.3166 4.85498 15.5356 5.63603C14.9689 6.20269 14 5.80138 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 5.80138 9.0311 6.20271 8.46444 5.63605C7.68339 4.855 6.41706 4.855 5.63602 5.63605C4.85497 6.4171 4.85497 7.68343 5.63602 8.46448C6.20266 9.03112 5.80135 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C5.80136 14 6.20273 14.9689 5.63608 15.5355C4.85503 16.3166 4.85503 17.5829 5.63608 18.364C6.41713 19.145 7.68346 19.145 8.46451 18.364C9.03114 17.7973 10 18.1987 10 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cog-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","configuration","options","preferences","flower","gear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0005 12C10.0005 10.8954 10.8959 10 12.0005 10C13.1051 10 14.0005 10.8954 14.0005 12C14.0005 13.1046 13.1051 14 12.0005 14C10.8959 14 10.0005 13.1046 10.0005 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0004 2.27002C10.4954 2.27002 9.27539 3.49507 9.27539 5.00004C9.27539 5.15552 9.08742 5.23337 8.97749 5.12344C7.91331 4.05926 6.18793 4.05926 5.12375 5.12344C4.05957 6.18762 4.05957 7.91299 5.12375 8.97717C5.23369 9.08711 5.1558 9.27504 5.00039 9.27504C3.49541 9.27504 2.27539 10.4951 2.27539 12C2.27539 13.505 3.49541 14.725 5.00039 14.725C5.15592 14.725 5.23369 14.913 5.12382 15.0229C4.05964 16.0871 4.05964 17.8125 5.12382 18.8766C6.188 19.9408 7.91337 19.9408 8.97755 18.8766C9.08743 18.7668 9.27539 18.8446 9.27539 19C9.27539 20.505 10.4954 21.725 12.0004 21.725C13.5054 21.725 14.7254 20.505 14.7254 19C14.7254 18.8446 14.9133 18.7668 15.0232 18.8767C16.0874 19.9408 17.8128 19.9408 18.877 18.8767C19.9412 17.8125 19.9412 16.0871 18.877 15.0229C18.7671 14.913 18.8449 14.725 19.0004 14.725C20.5054 14.725 21.7305 13.505 21.7305 12C21.7305 10.4951 20.5054 9.27504 19.0004 9.27504C18.845 9.27504 18.7671 9.08712 18.877 8.97715C19.9412 7.91298 19.9412 6.1876 18.877 5.12342C17.8129 4.05924 16.0875 4.05924 15.0233 5.12342C14.9133 5.23339 14.7254 5.15547 14.7254 5.00004C14.7254 3.49507 13.5054 2.27002 12.0004 2.27002ZM12.0005 8.00002C9.79135 8.00002 8.00049 9.79088 8.00049 12C8.00049 14.2092 9.79135 16 12.0005 16C14.2096 16 16.0005 14.2092 16.0005 12C16.0005 9.79088 14.2096 8.00002 12.0005 8.00002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    cog: {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","configuration","options","preferences","flower","gear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 18.1986 14.9689 17.7973 15.5355 18.364C16.3166 19.145 17.5829 19.145 18.3639 18.364C19.145 17.5829 19.145 16.3166 18.3639 15.5355C17.7973 14.9689 18.1986 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C18.1986 10 17.7974 9.0311 18.364 8.46446C19.145 7.68341 19.145 6.41708 18.364 5.63603C17.583 4.85498 16.3166 4.85498 15.5356 5.63603C14.9689 6.20269 14 5.80138 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 5.80138 9.0311 6.20271 8.46444 5.63605C7.68339 4.855 6.41706 4.855 5.63602 5.63605C4.85497 6.4171 4.85497 7.68343 5.63602 8.46448C6.20266 9.03112 5.80135 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C5.80136 14 6.20273 14.9689 5.63608 15.5355C4.85503 16.3166 4.85503 17.5829 5.63608 18.364C6.41713 19.145 7.68346 19.145 8.46451 18.364C9.03114 17.7973 10 18.1987 10 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["euro","money","currency","payment","price","cash","amount","euro-symbol","discount","cost","total"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9998 5.29045C14.1345 4.439 11.0447 5.50089 9.30823 7.93388C7.57173 10.3669 7.57173 13.634 9.30823 16.067C11.0447 18.5 14.1345 19.5619 16.9998 18.7105"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H6M10 14H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","currency","euro","money","payment","price","cost","cash","finance","transaction","refund","change","discount","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9998 5.29045C14.1345 4.439 11.0447 5.50089 9.30823 7.93388C7.57173 10.3669 7.57173 13.634 9.30823 16.067C11.0447 18.5 14.1345 19.5619 16.9998 18.7105"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H6M10 14H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","currency","money","payment","cash","change","price","amount","total","europe","exchange","refund","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.49446 7.353C10.479 4.57245 14.0102 3.35885 17.2849 4.33195C17.8143 4.48927 18.1159 5.04597 17.9586 5.57537C17.8013 6.10478 17.2446 6.40641 16.7151 6.24909C14.2592 5.51927 11.6108 6.42947 10.1224 8.51488C10.0097 8.67272 9.90557 8.83465 9.80997 9.00006H10C10.5523 9.00006 11 9.44778 11 10.0001C11 10.5523 10.5523 11.0001 10 11.0001H9.08986C8.97814 11.6618 8.97809 12.3383 9.0897 13.0001H10C10.5523 13.0001 11 13.4478 11 14.0001C11 14.5524 10.5523 15.0001 10 15.0001H9.80945C9.90519 15.1658 10.0095 15.328 10.1224 15.4862C11.6108 17.5716 14.2592 18.4818 16.7151 17.7519C17.2446 17.5946 17.8013 17.8963 17.9586 18.4257C18.1159 18.9551 17.8143 19.5118 17.2849 19.6691C14.0102 20.6422 10.479 19.4286 8.49446 16.648C8.12323 16.1279 7.82144 15.5744 7.5891 15.0001H6C5.44772 15.0001 5 14.5524 5 14.0001C5 13.4478 5.44772 13.0001 6 13.0001H7.06858C6.98515 12.3361 6.98518 11.664 7.0687 11.0001H6C5.44772 11.0001 5 10.5523 5 10.0001C5 9.44778 5.44772 9.00006 6 9.00006H7.58946C7.82176 8.42603 8.12343 7.87285 8.49446 7.353Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","bill","invoice","transaction","payment","dollar","money","sale","total","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","currency","money","payment","price","cash","coin","change","refund","transaction","symbol"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9998 5.29045C14.1345 4.439 11.0447 5.50089 9.30823 7.93388C7.57173 10.3669 7.57173 13.634 9.30823 16.067C11.0447 18.5 14.1345 19.5619 16.9998 18.7105"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10H6M10 14H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","dollar","money","bill","sales","transaction","payment","invoice","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.3528V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.3528C19 19.6429 19 19.7879 18.9051 19.8465C18.8103 19.9051 18.6806 19.8403 18.4211 19.7106L17 19L15.5 19.9997L14 19L12 20L10 19L8.5 19.9997L7 19L5.57889 19.7106C5.31943 19.8403 5.18971 19.9051 5.09485 19.8465C5 19.7879 5 19.6429 5 19.3528Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","transaction","sales","invoice","payment","bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.94805 3.25H15.052C15.9505 3.24997 16.6998 3.24995 17.2945 3.32992C17.9223 3.41432 18.4891 3.59999 18.9446 4.05546C19.4001 4.51093 19.5857 5.07773 19.6701 5.70552C19.7501 6.3003 19.7501 7.04951 19.75 7.94798L19.7501 19.3805C19.7502 19.4988 19.7504 19.6596 19.7301 19.7966C19.7064 19.9556 19.6285 20.2812 19.2995 20.4845C18.9705 20.6879 18.6444 20.612 18.4917 20.562C18.36 20.5189 18.2163 20.4468 18.1106 20.3938L17.0539 19.8654L15.916 20.6238C15.6641 20.7917 15.336 20.7917 15.0841 20.6238L13.9462 19.8654L12.3355 20.6708C12.1243 20.7764 11.8758 20.7764 11.6646 20.6708L10.0539 19.8654L8.91598 20.6238C8.6641 20.7917 8.336 20.7917 8.08411 20.6238L6.94623 19.8654L5.88961 20.3938C5.78387 20.4468 5.6401 20.5189 5.50843 20.562C5.35567 20.612 5.02962 20.6879 4.7006 20.4845C4.37159 20.2812 4.29365 19.9556 4.27004 19.7966C4.24969 19.6596 4.24988 19.4988 4.25002 19.3805L4.25005 7.948C4.25002 7.04953 4.24999 6.30031 4.32996 5.70552C4.41436 5.07773 4.60003 4.51093 5.0555 4.05546C5.51097 3.59999 6.07777 3.41432 6.70557 3.32992C7.30034 3.24995 8.04959 3.24997 8.94805 3.25ZM14.25 8C14.25 7.58579 13.9142 7.25 13.5 7.25C13.0858 7.25 12.75 7.58579 12.75 8V8.37803C11.8761 8.68691 11.25 9.52034 11.25 10.5C11.25 11.7426 12.2574 12.75 13.5 12.75H14.3333C14.9159 12.75 15.25 13.1582 15.25 13.5C15.25 13.8418 14.9159 14.25 14.3333 14.25L12 14.25C11.5858 14.25 11.25 14.5858 11.25 15C11.25 15.4142 11.5858 15.75 12 15.75H12.75V16C12.75 16.4142 13.0858 16.75 13.5 16.75C13.9142 16.75 14.25 16.4142 14.25 16V15.75H14.3333C15.5917 15.75 16.75 14.815 16.75 13.5C16.75 12.185 15.5917 11.25 14.3333 11.25H13.5C13.0858 11.25 12.75 10.9142 12.75 10.5C12.75 10.0858 13.0858 9.75 13.5 9.75H15.3333C15.7475 9.75 16.0833 9.41422 16.0833 9C16.0833 8.58579 15.7475 8.25 15.3333 8.25H14.25V8ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H10C10.4142 12.75 10.75 12.4142 10.75 12C10.75 11.5858 10.4142 11.25 10 11.25H8ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H9C9.41421 8.25 9.75 8.58579 9.75 9C9.75 9.41421 9.41421 9.75 9 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM8 14.25C7.58579 14.25 7.25 14.5858 7.25 15C7.25 15.4142 7.58579 15.75 8 15.75H9C9.41421 15.75 9.75 15.4142 9.75 15C9.75 14.5858 9.41421 14.25 9 14.25H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["coin","money","currency","payment","change","cash","balance","transaction","round"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15V13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <ellipse cx="12" cy="10" rx="7" ry="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 10V13C5 14.6278 8.13401 16 12 16C15.866 16 19 14.6278 19 13V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","bill","invoice","transaction","payment","dollar","money","sales","finance","accounting","total","summary","purchase","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 9H15.3333M13.5 9C12.6716 9 12 9.67157 12 10.5C12 11.3284 12.6716 12 13.5 12H14.3333C15.2538 12 16 12.6716 16 13.5C16 14.3284 15.2538 15 14.3333 15H13.5M13.5 9V8M12 15L13.5 15M13.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 20L7 19L8.5 19.9997L10 19L12 20L14 19L15.5 19.9997L17 19L19 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["dollar","currency","money","payment","price","cost","sale","finance","cash","usd"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6V4.5M12 18V19.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","currency","payment","price","cost","cash","sale","transaction","amount","finance","revenue","profit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.5C12.5523 3.5 13 3.94772 13 4.5V5.12602C14.7252 5.57006 16 7.13616 16 9C16 9.55228 15.5523 10 15 10C14.4477 10 14 9.55228 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C14.2091 11 16 12.7909 16 15C16 16.8638 14.7252 18.4299 13 18.874V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V18.874C9.27477 18.4299 8 16.8638 8 15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C9.79086 13 8 11.2091 8 9C8 7.13616 9.27477 5.57006 11 5.12602V4.5C11 3.94772 11.4477 3.5 12 3.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","currency","list","transaction","bill","finance","payment","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8.5 9H10M8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12H9.33333C10.2538 12 11 12.6716 11 13.5C11 14.3284 10.2538 15 9.33333 15H8.5M8.5 9V8M7 15L8.5 15M8.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dollar","sign","price","list","menu","options","money","amount","currency","billing","payment","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8.5 9H10M8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12H9.33333C10.2538 12 11 12.6716 11 13.5C11 14.3284 10.2538 15 9.33333 15H8.5M8.5 9V8M7 15L8.5 15M8.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["coin","round","currency","money","payment","change","cash","balance","credit","discount","loyalty","points","rewards","tip","coin-stack","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V13C5 14.6278 8.13401 16 12 16C15.866 16 19 14.6278 19 13V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <ellipse
                    cx="12"
                    cy="10"
                    rx="7"
                    ry="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Coin-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","money","price","list","pricelist","menu","options","billing","payment","finance","cost","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.5 9H10M8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12H9.33333C10.2538 12 11 12.6716 11 13.5C11 14.3284 10.2538 15 9.33333 15H8.5M8.5 9V8M7 15L8.5 15M8.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","currency","price","payment","cost","money","list","options","settings","details","payment-options","price-list","pricing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM9.25 8C9.25 7.58579 8.91421 7.25 8.5 7.25C8.08579 7.25 7.75 7.58579 7.75 8V8.37803C6.87611 8.68691 6.25 9.52034 6.25 10.5C6.25 11.7426 7.25736 12.75 8.5 12.75H9.33333C9.91588 12.75 10.25 13.1582 10.25 13.5C10.25 13.8418 9.91588 14.25 9.33333 14.25H7C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H7.75V16C7.75 16.4142 8.08579 16.75 8.5 16.75C8.91421 16.75 9.25 16.4142 9.25 16V15.75H9.33333C10.5917 15.75 11.75 14.815 11.75 13.5C11.75 12.185 10.5917 11.25 9.33333 11.25H8.5C8.08579 11.25 7.75 10.9142 7.75 10.5C7.75 10.0858 8.08579 9.75 8.5 9.75H10C10.4142 9.75 10.75 9.41421 10.75 9C10.75 8.58579 10.4142 8.25 10 8.25H9.25V8ZM14 8.25C13.5858 8.25 13.25 8.58579 13.25 9C13.25 9.41421 13.5858 9.75 14 9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H14ZM14 11.25C13.5858 11.25 13.25 11.5858 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H14ZM14 14.25C13.5858 14.25 13.25 14.5858 13.25 15C13.25 15.4142 13.5858 15.75 14 15.75H15C15.4142 15.75 15.75 15.4142 15.75 15C15.75 14.5858 15.4142 14.25 15 14.25H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","money","currency","cash","payment","change","refund","discount","loyalty-points","credit","round","token","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.96 9.68C19.87 9.07 19.57 8.54 19.16 8.13C18.69 7.65 18.05 7.26 17.34 6.96C15.92 6.35 14.03 6 12 6C9.97 6 8.07 6.35 6.66 6.96C5.95 7.26 5.32 7.65 4.84 8.13C4.36 8.61 4 9.25 4 10V14C4 14.75 4.36 15.38 4.84 15.86C5.31 16.34 5.95 16.72 6.65 17.03C8.07 17.64 9.96 18 12 18C14.04 18 15.93 17.64 17.35 17.03C18.06 16.73 18.69 16.34 19.16 15.86C19.64 15.38 20 14.75 20 14V9.85C20 9.76 19.98 9.71 19.96 9.68ZM7.45 15.19C6.89 14.95 6.5 14.69 6.26 14.45C6.03 14.21 6 14.06 6 14V12.72C6.21 12.84 6.43 12.95 6.66 13.04C7.07 13.22 7.52 13.36 8 13.49V15.4C7.8 15.33 7.62 15.26 7.45 15.19ZM12 16C11.3 16 10.62 15.95 10 15.86V13.86C10.65 13.94 11.31 13.99 12 13.99C12.69 13.99 13.35 13.94 14 13.86V15.86C13.38 15.95 12.7 16 12 16ZM17.74 14.45C17.5 14.69 17.11 14.95 16.55 15.19C16.38 15.26 16.19 15.34 16 15.4V13.49C16.48 13.36 16.94 13.21 17.34 13.04C17.57 12.94 17.79 12.83 18 12.72V14C18 14.06 17.97 14.22 17.74 14.45Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","currency","money","payment","cash","balance","sales","transaction","price","finance","cost","tip","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9H11.5C10.6716 9 10 9.67157 10 10.5V10.5C10 11.3284 10.6716 12 11.5 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15H12.5C13.3284 15 14 14.3284 14 13.5V13.5C14 12.6716 13.3284 12 12.5 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","money","dollar","currency","payment","change","cash","discount","price","balance","value","finance","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9H11.5C10.6716 9 10 9.67157 10 10.5V10.5C10 11.3284 10.6716 12 11.5 12H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15H12.5C13.3284 15 14 14.3284 14 13.5V13.5C14 12.6716 13.3284 12 12.5 12H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["coin","dollar","currency","payment","money","cash","price","discount","change","refund","transaction","balance","total","amount","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H11.5C10.6716 9 10 9.67157 10 10.5V10.5C10 11.3284 10.6716 12 11.5 12H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L18 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15H12.5C13.3284 15 14 14.3284 14 13.5V13.5C14 12.6716 13.3284 12 12.5 12H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","money","dollar","currency","payment","cash","amount","price","discount","sale","revenue","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V8.05001C9.85888 8.28164 9 9.29052 9 10.5C9 11.8807 10.1193 13 11.5 13H12.5C12.7761 13 13 13.2239 13 13.5C13 13.7761 12.7761 14 12.5 14H10C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16H11C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.95C14.1411 15.7184 15 14.7095 15 13.5C15 12.1193 13.8807 11 12.5 11H11.5C11.2239 11 11 10.7761 11 10.5C11 10.2239 11.2239 10 11.5 10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H13ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H6ZM17 11C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","currency","money","payment","price","cost","cash","finance","sales","revenue","income","transaction","amount","usd"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18M12 6C13.6569 6 15 7.34315 15 9M12 6V5M12 18C10.3431 18 9 16.6569 9 15M12 18V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","currency","payment","price","cost","cash","finance","pay","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","fast","payment","speed","transaction","quick-pay","express-checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.31383 12.9993H4C3.44772 12.9993 3 12.5516 3 11.9993C3 11.447 3.44772 10.9993 4 10.9993H5.31401C5.35791 10.6588 5.42391 10.3252 5.51053 10H5C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8H6.36069C7.71758 5.75263 10.1833 4.25 13 4.25C17.2802 4.25 20.75 7.71979 20.75 12C20.75 16.2802 17.2802 19.75 13 19.75C10.1832 19.75 7.71732 18.2472 6.36047 15.9996L5.00027 16C4.44798 16.0001 4.00015 15.5526 4 15.0003C3.99985 14.448 4.44745 14.0001 4.99973 14L5.51049 13.9999C5.42377 13.6743 5.35772 13.3402 5.31383 12.9993ZM13.25 8C13.25 7.58579 12.9142 7.25 12.5 7.25C12.0858 7.25 11.75 7.58579 11.75 8V8.37803C10.8761 8.68691 10.25 9.52034 10.25 10.5C10.25 11.7426 11.2574 12.75 12.5 12.75H13.3333C13.9159 12.75 14.25 13.1582 14.25 13.5C14.25 13.8418 13.9159 14.25 13.3333 14.25H11C10.5858 14.25 10.25 14.5858 10.25 15C10.25 15.4142 10.5858 15.75 11 15.75H11.75V16C11.75 16.4142 12.0858 16.75 12.5 16.75C12.9142 16.75 13.25 16.4142 13.25 16V15.75H13.3333C14.5917 15.75 15.75 14.815 15.75 13.5C15.75 12.185 14.5917 11.25 13.3333 11.25H12.5C12.0858 11.25 11.75 10.9142 11.75 10.5C11.75 10.0858 12.0858 9.75 12.5 9.75H14.3333C14.7475 9.75 15.0833 9.41421 15.0833 9C15.0833 8.58579 14.7475 8.25 14.3333 8.25H13.25V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dollar","currency","money","payment","cash","price","cost","sales","revenue","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6V5M12 18V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["coin","dollar","money","payment","transaction","speed","fast-payment","express-payment","circle","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9H6.5M4 11.9993H6M5 15L6.5 14.9996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="13"
                    cy="12"
                    r="7"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5 9H14.3333M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","cash","payment","change","refund","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 17H18.7083C17.0604 18.8412 14.6655 20 12 20C9.3345 20 6.93964 18.8412 5.29168 17H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["coin","dollar","money","cash","payment","change","refund","balance","tip","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 17H18.7083C17.0604 18.8412 14.6655 20 12 20C9.3345 20 6.93964 18.8412 5.29168 17H3"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","payment","change","cash","insert-coin","balance","refund","currency","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 17H18.7083C17.0604 18.8412 14.6655 20 12 20C9.3345 20 6.93964 18.8412 5.29168 17H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","cash","change","refund","currency","finance","earnings","deposit","revenue","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 17C2 16.4477 2.44772 16 3 16H5.73869L6.03681 16.3331C7.5031 17.9713 9.63076 19 12 19C14.3692 19 16.4969 17.9713 17.9632 16.3331L18.2613 16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H19.1414C17.3276 19.8502 14.7975 21 12 21C9.20251 21 6.67241 19.8502 4.85858 18H3C2.44772 18 2 17.5523 2 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 12.933 18.2165 14.683 16.9497 15.9497C15.683 17.2165 13.933 18 12 18ZM12.25 7C12.25 6.58579 11.9142 6.25 11.5 6.25C11.0858 6.25 10.75 6.58579 10.75 7V7.37803C9.87611 7.68691 9.25 8.52034 9.25 9.5C9.25 10.7426 10.2574 11.75 11.5 11.75H12.3333C12.9159 11.75 13.25 12.1582 13.25 12.5C13.25 12.8418 12.9159 13.25 12.3333 13.25H10C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H10.75V15C10.75 15.4142 11.0858 15.75 11.5 15.75C11.9142 15.75 12.25 15.4142 12.25 15V14.75H12.3333C13.5917 14.75 14.75 13.815 14.75 12.5C14.75 11.185 13.5917 10.25 12.3333 10.25H11.5C11.0858 10.25 10.75 9.91421 10.75 9.5C10.75 9.08579 11.0858 8.75 11.5 8.75H13.3333C13.7475 8.75 14.0833 8.41421 14.0833 8C14.0833 7.58579 13.7475 7.25 13.3333 7.25H12.25V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-circle-dollar-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","cash","change","currency","transaction","finance","deposit","balance","refund","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 18H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","payment","currency","finance","cash","sales","earnings","revenue","deposit","amount","price","cost","change","balance","payment-method"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 18H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["coin","dollar","money","cash","payment","finance","currency","price","cost","balance","tip","change","refund","discount","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11C5 14.866 8.13401 18 12 18C13.933 18 15.683 17.2165 16.9497 15.9497C18.2165 14.683 19 12.933 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 8H13.3333M11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11H12.3333C13.2538 11 14 11.6716 14 12.5C14 13.3284 13.2538 14 12.3333 14H11.5M11.5 8V7M10 14L11.5 14M11.5 14V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 18H4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","cash","change","currency","finance","transaction","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 11C4.25 6.71979 7.71979 3.25 12 3.25C16.2802 3.25 19.75 6.71979 19.75 11C19.75 13.1399 18.8817 15.0784 17.4801 16.4801C17.2212 16.7389 16.944 16.9796 16.6506 17.2H7.34924C5.46728 15.786 4.25 13.5352 4.25 11ZM12.25 7C12.25 6.58579 11.9142 6.25 11.5 6.25C11.0858 6.25 10.75 6.58579 10.75 7V7.37803C9.87611 7.68691 9.25 8.52034 9.25 9.5C9.25 10.7426 10.2574 11.75 11.5 11.75H12.3333C12.9159 11.75 13.25 12.1582 13.25 12.5C13.25 12.8418 12.9159 13.25 12.3333 13.25H10C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H10.75V15C10.75 15.4142 11.0858 15.75 11.5 15.75C11.9142 15.75 12.25 15.4142 12.25 15V14.75H12.3333C13.5917 14.75 14.75 13.815 14.75 12.5C14.75 11.185 13.5917 10.25 12.3333 10.25H11.5C11.0858 10.25 10.75 9.91421 10.75 9.5C10.75 9.08579 11.0858 8.75 11.5 8.75H13.3333C13.7475 8.75 14.0833 8.41421 14.0833 8C14.0833 7.58579 13.7475 7.25 13.3333 7.25H12.25V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 19C3.25 18.5858 3.58579 18.25 4 18.25H20C20.4142 18.25 20.75 18.5858 20.75 19C20.75 19.4142 20.4142 19.75 20 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-circle-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","currency","money","payment","coin","circle","cash","price","sale","income","revenue","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","currency","cash","change","price","value","sales","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 13.5C10.5 14.3284 11.1716 15 12 15M12 12C12.8284 12 13.5 12.6716 13.5 13.5C13.5 14.3284 12.8284 15 12 15M12 15L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 10.5C13.5 9.67157 12.8284 9 12 9M12 12C11.1716 12 10.5 11.3284 10.5 10.5C10.5 9.67157 11.1716 9 12 9M12 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","payment","cash","currency","price","cost","sale","finance","transaction","coin-circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 13.5C10.5 14.3284 11.1716 15 12 15M12 12C12.8284 12 13.5 12.6716 13.5 13.5C13.5 14.3284 12.8284 15 12 15M12 15L12 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 10.5C13.5 9.67157 12.8284 9 12 9M12 12C11.1716 12 10.5 11.3284 10.5 10.5C10.5 9.67157 11.1716 9 12 9M12 9V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-22": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["coin","dollar","money","payment","currency","cash","price","amount","finance","transaction","sale","discount","revenue","profit","balance","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 13.5C10.5 14.3284 11.1716 15 12 15M12 12C12.8284 12 13.5 12.6716 13.5 13.5C13.5 14.3284 12.8284 15 12 15M12 15L12 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 10.5C13.5 9.67157 12.8284 9 12 9M12 12C11.1716 12 10.5 11.3284 10.5 10.5C10.5 9.67157 11.1716 9 12 9M12 9V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","currency","payment","cash","sales","finance","revenue","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V8.37803C10.3761 8.68691 9.75 9.52034 9.75 10.5C9.75 11.7426 10.7574 12.75 12 12.75C12.4142 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5C11.25 13.0858 10.9142 12.75 10.5 12.75C10.0858 12.75 9.75 13.0858 9.75 13.5C9.75 14.4797 10.3761 15.3131 11.25 15.622V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V15.622C13.6239 15.3131 14.25 14.4797 14.25 13.5C14.25 12.2574 13.2426 11.25 12 11.25C11.5858 11.25 11.25 10.9142 11.25 10.5C11.25 10.0858 11.5858 9.75 12 9.75C12.4142 9.75 12.75 10.0858 12.75 10.5C12.75 10.9142 13.0858 11.25 13.5 11.25C13.9142 11.25 14.25 10.9142 14.25 10.5C14.25 9.52034 13.6239 8.68691 12.75 8.37803V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-circle-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","currency","payment","cash","price","cost","amount","change","finance","revenue","income","sale","discount","balance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25C11.0858 7.25 10.75 7.58579 10.75 8V8.37803C9.87611 8.68691 9.25 9.52034 9.25 10.5C9.25 11.7426 10.2574 12.75 11.5 12.75H12.3333C12.9159 12.75 13.25 13.1582 13.25 13.5C13.25 13.8418 12.9159 14.25 12.3333 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H10.75V16C10.75 16.4142 11.0858 16.75 11.5 16.75C11.9142 16.75 12.25 16.4142 12.25 16V15.75H12.3333C13.5917 15.75 14.75 14.815 14.75 13.5C14.75 12.185 13.5917 11.25 12.3333 11.25H11.5C11.0858 11.25 10.75 10.9142 10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75H13C13.4142 9.75 13.75 9.41421 13.75 9C13.75 8.58579 13.4142 8.25 13 8.25H12.25V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-circle-dollar-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","currency","payment","cash","change","price","discount","total","amount","sale","finance","value","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 10C14 8.89543 13.1046 8 12 8M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16M12 8V7M12 16C10.8954 16 10 15.1046 10 14M12 16V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","currency","payment","sales","finance","cash","circle","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 10C14 8.89543 13.1046 8 12 8M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16M12 8V7M12 16C10.8954 16 10 15.1046 10 14M12 16V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","coin","currency","money","payment","price","cash","finance","revenue","sales","transaction","value","earnings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10C14 8.89543 13.1046 8 12 8M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16M12 8V7M12 16C10.8954 16 10 15.1046 10 14M12 16V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","currency","payment","cash","finance","transaction","revenue","sales","price","cost","amount","change","balance","investment","profit","value","discount","expense"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-circle-dollar-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","payment","fast-payment","fast-money","transaction","speed","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9H6.5M4 11.9993H6M5 15L6.5 14.9996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="13" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.5 9H14.3333M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","fast","speed","transaction","express-payment","quick-pay","rapid","accelerated","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9H6.5M4 11.9993H6M5 15L6.5 14.9996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="13" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.5 9H14.3333M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-circle-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","currency","cash","price","amount","sale","discount","balance","change","finance","transaction","circle-dollar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "coin-front-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","dollar","money","payment","cash","currency","finance","sales","revenue","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12V12C11.4477 12 11 11.5523 11 11V11C11 10.4477 11.4477 10 12 10H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "coin-front-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["coin","dollar","money","payment","currency","cash","change","price","sale","discount","refund","tip","balance","transaction","financial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14V15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12V12C11.4477 12 11 11.5523 11 11V11C11 10.4477 11.4477 10 12 10H13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "coin-front-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","money","payment","cash","currency","change","refund","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6.75C9.1005 6.75 6.75 9.10051 6.75 12C6.75 14.8995 9.1005 17.25 12 17.25C14.8995 17.25 17.25 14.8995 17.25 12C17.25 9.10051 14.8995 6.75 12 6.75ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V9.41841C10.6588 9.69927 10.25 10.3019 10.25 11C10.25 11.9665 11.0335 12.75 12 12.75C12.1381 12.75 12.25 12.8619 12.25 13C12.25 13.1381 12.1381 13.25 12 13.25H11C10.5858 13.25 10.25 13.5858 10.25 14C10.25 14.4142 10.5858 14.75 11 14.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V14.5816C13.3412 14.3007 13.75 13.6981 13.75 13C13.75 12.0335 12.9665 11.25 12 11.25C11.8619 11.25 11.75 11.1381 11.75 11C11.75 10.8619 11.8619 10.75 12 10.75H13C13.4142 10.75 13.75 10.4142 13.75 10C13.75 9.58579 13.4142 9.25 13 9.25H12.75V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "coin-front": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","dollar","currency","money","payment","cash","change","amount","balance","transaction","finance","sale","price","value","discount","reward","loyalty","cash-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12V12C11.4477 12 11 11.5523 11 11V11C11 10.4477 11.4477 10 12 10H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-Repeat-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dollar","money","repeat","recurring","payment","transaction","refund","exchange","currency","arrow","cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 9H12.3333M10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12H11.3333C12.2538 12 13 12.6716 13 13.5C13 14.3284 12.2538 15 11.3333 15H10.5M10.5 9V8M9 15L10.5 15M10.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-Repeat-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","money","repeat","reload","currency","exchange","return","refund","transaction","payment","cashback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 9H12.3333M10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12H11.3333C12.2538 12 13 12.6716 13 13.5C13 14.3284 12.2538 15 11.3333 15H10.5M10.5 9V8M9 15L10.5 15M10.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-Repeat-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","currency","exchange","transfer","payment","finance","transaction","reload","money-transfer","recurring","recurrent","subscription","refund","chargeback","cashback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.6296 9.3601C20.2796 9.0101 19.7096 9.0101 19.3596 9.3601L18.6496 10.0701C17.7896 6.6401 14.6896 4.1001 10.9996 4.1001C6.63961 4.1001 3.09961 7.6401 3.09961 12.0001C3.09961 16.3601 6.63961 19.9001 10.9996 19.9001C13.2096 19.9001 15.2096 18.9901 16.6396 17.5301C16.9896 17.1801 16.9796 16.6101 16.6296 16.2601C16.2796 15.9101 15.7096 15.9201 15.3596 16.2701C14.2496 17.4001 12.7096 18.1001 10.9996 18.1001C7.62961 18.1001 4.89961 15.3701 4.89961 12.0001C4.89961 8.6301 7.62961 5.9001 10.9996 5.9001C13.3696 5.9001 15.4196 7.2501 16.4296 9.2201C16.0896 9.0301 15.6596 9.0701 15.3696 9.3601C15.0196 9.7101 15.0196 10.2801 15.3696 10.6301L17.3696 12.6301C17.4496 12.7101 17.5496 12.7801 17.6596 12.8201C17.8796 12.9101 18.1296 12.9101 18.3496 12.8201C18.4596 12.7701 18.5596 12.7101 18.6396 12.6301L20.6396 10.6301C20.9896 10.2801 20.9896 9.7101 20.6396 9.3601H20.6296Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4896 16.9001C10.9896 16.9001 11.3896 16.5001 11.3896 16.0001V15.9001C12.6896 15.8701 13.8896 14.8901 13.8896 13.5001C13.8896 12.1101 12.6496 11.1001 11.3196 11.1001H10.4896C10.1596 11.1001 9.8896 10.8301 9.8896 10.5001C9.8896 10.1701 10.1596 9.9001 10.4896 9.9001H12.3196C12.8196 9.9001 13.2196 9.5001 13.2196 9.0001C13.2196 8.5001 12.8196 8.1001 12.3196 8.1001H11.3896V8.0001C11.3896 7.5001 10.9896 7.1001 10.4896 7.1001C9.9896 7.1001 9.5896 7.5001 9.5896 8.0001V8.2701C8.7096 8.6301 8.0896 9.4901 8.0896 10.5001C8.0896 11.8301 9.1596 12.9001 10.4896 12.9001H11.3196C11.8396 12.9001 12.0896 13.2601 12.0896 13.5001C12.0896 13.7401 11.8396 14.1001 11.3196 14.1001H8.9896C8.4896 14.1001 8.0896 14.5001 8.0896 15.0001C8.0896 15.5001 8.4896 15.9001 8.9896 15.9001H9.5896V16.0001C9.5896 16.5001 9.9896 16.9001 10.4896 16.9001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-Repeat-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","currency","repeat","recurring","refund","transaction","arrow","money-back","exchange","payment-cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 9H12.3333M10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12H11.3333C12.2538 12 13 12.6716 13 13.5C13 14.3284 12.2538 15 11.3333 15H10.5M10.5 9V8M9 15L10.5 15M10.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Coin-Return-dollar-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["coin","dollar","return","refund","transaction","money-back","exchange","currency","cash","payment","reverse-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 10H13.3333M11.5 10C10.6716 10 10 10.6716 10 11.5C10 12.3284 10.6716 13 11.5 13H12.3333C13.2538 13 14 13.6716 14 14.5C14 15.3284 13.2538 16 12.3333 16H11.5M11.5 10V9M10 16L11.5 16M11.5 16V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5.77778L10.25 7.55556M12 5.77778L10.25 4M12 5.77778C8.13401 5.77778 5 8.96153 5 12.8889C5 16.8162 8.13401 20 12 20C15.866 20 19 16.8162 19 12.8889C19 9.90455 17.1904 7.34959 14.625 6.29468"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-Return-dollar-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["dollar","money","return","refund","transaction","exchange","currency","arrow","circle","cashback","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 10H13.3333M11.5 10C10.6716 10 10 10.6716 10 11.5C10 12.3284 10.6716 13 11.5 13H12.3333C13.2538 13 14 13.6716 14 14.5C14 15.3284 13.2538 16 12.3333 16H11.5M11.5 10V9M10 16L11.5 16M11.5 16V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5.77778L10.25 7.55556M12 5.77778L10.25 4M12 5.77778C8.13401 5.77778 5 8.96153 5 12.8889C5 16.8162 8.13401 20 12 20C15.866 20 19 16.8162 19 12.8889C19 9.90455 17.1904 7.34959 14.625 6.29468"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Coin-Return-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["money","dollar","return","refund","transaction","exchange","cashback","reimbursement","payment-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3996 9.4026C12.3996 8.9026 11.9996 8.5026 11.4996 8.5026C10.9996 8.5026 10.5996 8.9026 10.5996 9.4026V9.6726C9.71961 10.0326 9.09961 10.8926 9.09961 11.9026C9.09961 13.2326 10.1696 14.3026 11.4996 14.3026H12.3296C12.8496 14.3026 13.0996 14.6626 13.0996 14.9026C13.0996 15.1426 12.8496 15.5026 12.3296 15.5026H9.99961C9.49961 15.5026 9.09961 15.9026 9.09961 16.4026C9.09961 16.9026 9.49961 17.3026 9.99961 17.3026H10.5996V17.4026C10.5996 17.9026 10.9996 18.3026 11.4996 18.3026C11.9996 18.3026 12.3996 17.9026 12.3996 17.4026V17.3026C13.6996 17.2726 14.8996 16.2926 14.8996 14.9026C14.8996 13.5126 13.6596 12.5026 12.3296 12.5026H11.4996C11.1696 12.5026 10.8996 12.2326 10.8996 11.9026C10.8996 11.5726 11.1696 11.3026 11.4996 11.3026H13.3296C13.8296 11.3026 14.2296 10.9026 14.2296 10.4026C14.2296 9.9026 13.8296 9.5026 13.3296 9.5026H12.3996V9.4026Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.3396 4.7526C14.8796 4.5626 14.3496 4.7926 14.1696 5.2526C13.9796 5.7126 14.2096 6.2426 14.6696 6.4226C17.2696 7.4726 19.1096 10.0326 19.1096 13.0026C19.1096 16.9226 15.9296 20.1026 12.0096 20.1026C8.08961 20.1026 4.89961 16.9226 4.89961 13.0026C4.89961 9.8226 6.98961 7.1326 9.86961 6.2326L9.29961 6.9426C8.98961 7.3326 9.04961 7.8926 9.43961 8.2126C9.82961 8.5226 10.3896 8.4626 10.7096 8.0726L12.7096 5.5726C12.9996 5.2126 12.9696 4.7026 12.6396 4.3726L10.6396 2.3626C10.2896 2.0126 9.71961 2.0126 9.36961 2.3626C9.01961 2.7126 9.01961 3.2826 9.36961 3.6326L10.0496 4.3126C6.06961 5.2126 3.09961 8.7626 3.09961 13.0026C3.09961 17.9226 7.07961 21.9026 11.9996 21.9026C16.9196 21.9026 20.8996 17.9226 20.8996 13.0026C20.8996 9.2626 18.5996 6.0726 15.3396 4.7526Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Coin-Return-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","refund","money","dollar","transaction","reverse-transaction","currency","coin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 10H13.3333M11.5 10C10.6716 10 10 10.6716 10 11.5C10 12.3284 10.6716 13 11.5 13H12.3333C13.2538 13 14 13.6716 14 14.5C14 15.3284 13.2538 16 12.3333 16H11.5M11.5 10V9M10 16L11.5 16M11.5 16V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5.77778L10.25 7.55556M12 5.77778L10.25 4M12 5.77778C8.13401 5.77778 5 8.96153 5 12.8889C5 16.8162 8.13401 20 12 20C15.866 20 19 16.8162 19 12.8889C19 9.90455 17.1904 7.34959 14.625 6.29468"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Coin: {
        defaultColors: ["#3D4C66"],
        keywords: ["return","refund","money","dollar","transaction","reverse-transaction","currency","coin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="10" rx="7" ry="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 10V13C5 14.6278 8.13401 16 12 16C15.866 16 19 14.6278 19 13V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "command-code-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["command","terminal","input","code","script","customization","settings","configuration","prompt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 15L10.8667 13.6C11.8444 12.8667 12.3333 12.5 12.3333 12C12.3333 11.5 11.8444 11.1333 10.8667 10.4L9 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 15H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "command-code-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["command","code","terminal","script","run","execute","input","advanced","settings","developer","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15L10.8667 13.6C11.8444 12.8667 12.3333 12.5 12.3333 12C12.3333 11.5 11.8444 11.1333 10.8667 10.4L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 15H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "command-code-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["command","prompt","input","terminal","execute","arrow","next","enter","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM9.6 8.2C9.15817 7.86863 8.53137 7.95817 8.2 8.4C7.86863 8.84183 7.95817 9.46863 8.4 9.8L10.2667 11.2C10.7811 11.5858 11.0766 11.8106 11.2576 11.9926L11.2649 12L11.2576 12.0074C11.0766 12.1894 10.7811 12.4142 10.2667 12.8L8.4 14.2C7.95817 14.5314 7.86863 15.1582 8.2 15.6C8.53137 16.0418 9.15817 16.1314 9.6 15.8L11.5184 14.3612C11.9625 14.0283 12.3793 13.7157 12.6758 13.4176C13.0013 13.0902 13.3333 12.6332 13.3333 12C13.3333 11.3668 13.0013 10.9098 12.6758 10.5824C12.3793 10.2843 11.9625 9.97175 11.5184 9.6388L9.6 8.2ZM14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "command-code": {
        defaultColors: ["#3D4C66"],
        keywords: ["command","code","terminal","script","programming","customization","settings","advanced-settings","configuration","debug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 15L10.8667 13.6C11.8444 12.8667 12.3333 12.5 12.3333 12C12.3333 11.5 11.8444 11.1333 10.8667 10.4L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 15H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "comment-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","message","chat","feedback","notes","customer-feedback","order-notes","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["comment","chat","message","feedback","customer-service","support","note","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","chat","message","feedback","notes","customer-feedback","customer-service","support","dialog","conversation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 11M15 13L15 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","chat","message","note","feedback","customer-note","order-note","conversation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 11M15 13L15 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","notes","feedback","customer-feedback","order-notes","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0049 4C7.59492 4 4.00492 7.59 4.00492 12C4.00492 13.24 4.29491 14.47 4.84491 15.57L4.06492 17.65C3.94492 17.96 3.99491 18.3 4.18491 18.57C4.37491 18.84 4.67492 19 5.00492 19H8.35492C9.63492 19.67 10.8249 20 12.0049 20C16.4149 20 20.0049 16.41 20.0049 12C20.0049 7.59 16.4149 4 12.0049 4ZM10.0049 13C10.0049 13.55 9.55492 14 9.00492 14C8.45492 14 8.00492 13.55 8.00492 13V11C8.00492 10.45 8.45492 10 9.00492 10C9.55492 10 10.0049 10.45 10.0049 11V13ZM13.0049 13C13.0049 13.55 12.5549 14 12.0049 14C11.4549 14 11.0049 13.55 11.0049 13V11C11.0049 10.45 11.4549 10 12.0049 10C12.5549 10 13.0049 10.45 13.0049 11V13ZM16.0049 13C16.0049 13.55 15.5549 14 15.0049 14C14.4549 14 14.0049 13.55 14.0049 13V11C14.0049 10.45 14.4549 10 15.0049 10C15.5549 10 16.0049 10.45 16.0049 11V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","feedback","message","note","customer-feedback","support","communication","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.951 4.25C7.67097 4.25 4.20097 7.72 4.20097 12C4.20097 13.41 4.39097 14.85 5.13097 16.09L4.24097 18.76C4.16097 18.99 4.20097 19.24 4.34097 19.44C4.48097 19.64 4.71097 19.75 4.95097 19.75H11.951C16.231 19.75 19.701 16.28 19.701 12C19.701 7.72 16.231 4.25 11.951 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Comment-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","feedback","notes","communication","customer-service","support","question","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12 11M15 13L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13L9 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cancel","remove","delete","error","box","x","close","reject","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14L13.7889 12.8944C12.6627 12.3314 11.3373 12.3314 10.2111 12.8944L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["remove","delete","cancel","close","reject","disable","cross","error","invalid","item-removal","order-cancellation","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.83 6.17C17.66 5 16.01 5 13 5H11C8 5 6.33998 5 5.16998 6.17C3.99998 7.34 4 9 4 12C4 15 3.99998 16.66 5.16998 17.83C6.33998 19 8 19 11 19H13C16 19 17.66 19 18.83 17.83C20 16.66 20 15 20 12C20 9 20 7.34 18.83 6.17ZM16.45 13.1C16.94 13.35 17.14 13.95 16.9 14.44C16.65 14.93 16.05 15.13 15.56 14.89L13.35 13.78C12.51 13.36 11.51 13.36 10.67 13.78L8.46002 14.89C8.32002 14.96 8.16001 15 8.01001 15C7.64001 15 7.28999 14.8 7.10999 14.45C6.85999 13.96 7.06 13.36 7.56 13.11L9.77002 12L7.56 10.89C7.07 10.64 6.86999 10.04 7.10999 9.55C7.35999 9.06 7.96001 8.85 8.45001 9.1L10.66 10.21C11.5 10.63 12.5 10.63 13.34 10.21L15.55 9.1C16.04 8.85 16.64 9.05 16.89 9.55C17.14 10.04 16.94 10.64 16.44 10.89L14.23 12L16.44 13.11L16.45 13.1Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["close","cancel","remove","delete","error","reject","discard","exit","cross","x","incorrect","invalid","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14L13.7889 12.8944C12.6627 12.3314 11.3373 12.3314 10.2111 12.8944L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["remove","delete","cross","cancel","box","package","error","invalid","close","void","reject","transaction-error","payment-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14L13.7889 12.8944C12.6627 12.3314 11.3373 12.3314 10.2111 12.8944L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","speech bubble","heart","like","feedback","customer feedback","review","customer review","loyalty","favorite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.48026 11.8029L11 14L13.5197 11.8029C14.1601 11.1617 14.1601 10.1221 13.5197 9.48091C12.8794 8.8397 11.8412 8.8397 11.2008 9.48091L11 9.71429L10.7992 9.48091C10.1588 8.8397 9.12061 8.8397 8.48026 9.48091C7.83991 10.1221 7.83991 11.1617 8.48026 11.8029Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","like","love","favorite","feedback","review","comment","rating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.48026 11.8029L11 14L13.5197 11.8029C14.1601 11.1617 14.1601 10.1221 13.5197 9.48091C12.8794 8.8397 11.8412 8.8397 11.2008 9.48091L11 9.71429L10.7992 9.48091C10.1588 8.8397 9.12061 8.8397 8.48026 9.48091C7.83991 10.1221 7.83991 11.1617 8.48026 11.8029Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["feedback","comment","heart","like","customer feedback","reviews","ratings","loyalty","customer satisfaction","sentiment analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7004 10.19L10.5504 10.37C10.3604 10.59 10.0804 10.72 9.79035 10.72C9.50035 10.72 9.2204 10.59 9.0304 10.37L8.83039 10.14C8.69039 10.01 8.22035 9.95002 7.98035 10.19C7.74035 10.43 7.73039 10.83 7.96039 11.08L9.79035 12.68L11.6504 11.06C11.8504 10.86 11.8503 10.45 11.6003 10.2C11.3603 9.96002 10.9404 9.96002 10.7004 10.2V10.19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7 4 5.33998 4 4.16998 5.17C2.99998 6.34 3 8 3 11V12C3 13.98 3.00003 15.07 3.53003 16C3.88003 16.61 4.38999 17.11 4.98999 17.47C5.43999 17.73 5.94997 17.88 6.65997 17.95C7.66997 18.05 8.28999 18.11 8.54999 18.21C8.63999 18.25 8.69998 18.27 8.78998 18.32C9.02998 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM13.02 12.51L10.45 14.75C10.26 14.91 10.03 15 9.78998 15C9.54998 15 9.32 14.92 9.13 14.75L6.60999 12.55C6.60999 12.55 6.58 12.52 6.56 12.5C5.53 11.47 5.53 9.79 6.56 8.77C7.41 7.92 8.79998 7.77 9.78998 8.38C10.82 7.75 12.17 7.94 13.01 8.77C14.04 9.8 14.04 11.48 13.01 12.51H13.02ZM17 14C17 14.55 16.55 15 16 15C15.45 15 15 14.55 15 14V9C15 8.45 15.45 8 16 8C16.55 8 17 8.45 17 9V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-heart v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["feedback","customer-feedback","love","like","favorite","comment","message","customer-satisfaction","reviews","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.48026 11.8029L11 14L13.5197 11.8029C14.1601 11.1617 14.1601 10.1221 13.5197 9.48091C12.8794 8.8397 11.8412 8.8397 11.2008 9.48091L11 9.71429L10.7992 9.48091C10.1588 8.8397 9.12061 8.8397 8.48026 9.48091C7.83991 10.1221 7.83991 11.1617 8.48026 11.8029Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","heart","feedback","message","customer-feedback","loyalty","rewards","like","favorite","tips","comment-heart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.64035 11.9241L12 15L15.3596 11.9241C16.2134 11.0264 16.2135 9.57096 15.3596 8.67327C14.5058 7.77558 13.1216 7.77558 12.2678 8.67327L12 9L11.7322 8.67327C10.8784 7.77558 9.49415 7.77558 8.64035 8.67327C7.78655 9.57096 7.78655 11.0264 8.64035 11.9241Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","like","favorite","loyalty","rewards","feedback","customer-feedback","comment","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.64035 11.9241L12 15L15.3596 11.9241C16.2134 11.0264 16.2135 9.57096 15.3596 8.67327C14.5058 7.77558 13.1216 7.77558 12.2678 8.67327L12 9L11.7322 8.67327C10.8784 7.77558 9.49415 7.77558 8.64035 8.67327C7.78655 9.57096 7.78655 11.0264 8.64035 11.9241Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","heart","feedback","love","favorite","like","customer-feedback","customer-engagement","loyalty","rewards","message","chat","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.64035 11.9241L12 15L15.3596 11.9241C16.2134 11.0264 16.2135 9.57096 15.3596 8.67327C14.5058 7.77558 13.1216 7.77558 12.2678 8.67327L12 9L11.7322 8.67327C10.8784 7.77558 9.49415 7.77558 8.64035 8.67327C7.78655 9.57096 7.78655 11.0264 8.64035 11.9241Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","chat","message","feedback","customer-feedback","note","customer-support","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.20913 14.8662 6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19H5L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","like","love","favorites","loyalty","reward","customer-appreciation","feedback","saved-items","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7 4 5.34001 4 4.17001 5.17C3.00001 6.34 3 8 3 11V12C3 13.98 3 15.07 3.53 16C3.88 16.61 4.38999 17.11 4.98999 17.47C5.43999 17.73 5.95 17.88 6.66 17.95C7.67 18.05 8.28999 18.11 8.54999 18.21C8.63999 18.25 8.70001 18.27 8.79001 18.32C9.03001 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM16.09 12.61L12.68 15.73C12.49 15.9 12.25 15.99 12.01 15.99C11.77 15.99 11.53 15.9 11.34 15.73L7.98001 12.65C7.98001 12.65 7.94999 12.62 7.92999 12.6C6.71999 11.32 6.71999 9.25 7.92999 7.97C8.99999 6.85 10.8 6.69 12.02 7.58C13.28 6.67 15.04 6.86 16.1 7.97C17.31 9.25 17.31 11.32 16.1 12.6L16.09 12.61Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.9903 9.35982L12.7703 9.62982C12.5803 9.85982 12.3004 9.99982 12.0004 9.99982C11.7004 9.99982 11.4204 9.86982 11.2304 9.63982L10.9603 9.30982C10.6103 8.94982 9.81035 8.89982 9.37035 9.35982C8.89035 9.85982 8.89036 10.6998 9.35036 11.2098L12.0104 13.6398L14.6904 11.1798C15.1204 10.7198 15.1204 9.85982 14.6404 9.35982C14.1904 8.88982 13.4404 8.88982 13.0004 9.35982H12.9903Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Comment-line-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","feedback","notes","message","customer-feedback","order-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","message","chat","note","remark","feedback","customer-note","order-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.20913 14.8662 6 16L5 19H12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 16L6.71151 16.2372L6.83062 15.8798L6.61514 15.5709L6 16ZM5 19L4.28849 18.7628C4.21225 18.9915 4.2506 19.243 4.39157 19.4385C4.53253 19.6341 4.75892 19.75 5 19.75V19ZM18.25 12C18.25 15.4518 15.4518 18.25 12 18.25V19.75C16.2802 19.75 19.75 16.2802 19.75 12H18.25ZM5.75 12C5.75 8.54822 8.54822 5.75 12 5.75V4.25C7.71979 4.25 4.25 7.71979 4.25 12H5.75ZM12 5.75C15.4518 5.75 18.25 8.54822 18.25 12H19.75C19.75 7.71979 16.2802 4.25 12 4.25V5.75ZM6.61514 15.5709C5.95539 14.6251 5.75 13.4327 5.75 12H4.25C4.25 13.5418 4.46286 15.1073 5.38486 16.4291L6.61514 15.5709ZM12 18.25H5V19.75H12V18.25ZM5.28849 15.7628L4.28849 18.7628L5.71151 19.2372L6.71151 16.2372L5.28849 15.7628Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 10H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-line-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","chat","message","note","feedback","customer-feedback","order-note","order-comment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","note","feedback","customer-note","order-note","transaction-note","chat-bubble"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0008 4.25C7.72077 4.25 4.25077 7.72 4.25077 12C4.25077 13.41 4.44077 14.85 5.18077 16.09L4.29077 18.76C4.21077 18.99 4.25077 19.24 4.39077 19.44C4.53077 19.64 4.76077 19.75 5.00077 19.75H12.0008C16.2808 19.75 19.7508 16.28 19.7508 12C19.7508 7.72 16.2808 4.25 12.0008 4.25ZM12.0008 15H10.0008C9.45077 15 9.00077 14.55 9.00077 14C9.00077 13.45 9.45077 13 10.0008 13H12.0008C12.5508 13 13.0008 13.45 13.0008 14C13.0008 14.55 12.5508 15 12.0008 15ZM14.0008 11H10.0008C9.45077 11 9.00077 10.55 9.00077 10C9.00077 9.45 9.45077 9 10.0008 9H14.0008C14.5508 9 15.0008 9.45 15.0008 10C15.0008 10.55 14.5508 11 14.0008 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Comment-line-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","chat","message","notes","customer-notes","order-notes","feedback","customer-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L14 12M11 15L13 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9L13 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Comment-line-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","message","feedback","notes","customer-feedback","order-notes","chat","support","conversation","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0049 4C7.59492 4 4.00492 7.59 4.00492 12C4.00492 13.24 4.29491 14.47 4.84491 15.57L4.06492 17.65C3.94492 17.96 3.99491 18.3 4.18491 18.57C4.37491 18.84 4.67492 19 5.00492 19H8.35492C9.63492 19.67 10.8249 20 12.0049 20C16.4149 20 20.0049 16.41 20.0049 12C20.0049 7.59 16.4149 4 12.0049 4ZM11.0049 8H13.0049C13.5549 8 14.0049 8.45 14.0049 9C14.0049 9.55 13.5549 10 13.0049 10H11.0049C10.4549 10 10.0049 9.55 10.0049 9C10.0049 8.45 10.4549 8 11.0049 8ZM13.0049 16H11.0049C10.4549 16 10.0049 15.55 10.0049 15C10.0049 14.45 10.4549 14 11.0049 14H13.0049C13.5549 14 14.0049 14.45 14.0049 15C14.0049 15.55 13.5549 16 13.0049 16ZM14.0049 13H10.0049C9.45492 13 9.00492 12.55 9.00492 12C9.00492 11.45 9.45492 11 10.0049 11H14.0049C14.5549 11 15.0049 11.45 15.0049 12C15.0049 12.55 14.5549 13 14.0049 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Comment-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","feedback","note","customer-note","order-note","add-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.4872 5.20913 14.8662 6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19H5L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-o1-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","speech-bubble","message","notification","chat","information","oi","alert","customer-feedback","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-o1-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","message","feedback","notes","oi","customer-feedback","chat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 10C10.22 10 10 10.22 10 10.5V11.5C10 11.78 10.22 12 10.5 12C10.78 12 11 11.78 11 11.5V10.5C11 10.22 10.78 10 10.5 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7 4 5.33998 4 4.16998 5.17C2.99998 6.34 3 8 3 11V12C3 13.98 3.00003 15.07 3.53003 16C3.88003 16.61 4.38999 17.11 4.98999 17.47C5.43999 17.73 5.94997 17.88 6.65997 17.95C7.66997 18.05 8.28999 18.11 8.54999 18.21C8.63999 18.25 8.69998 18.27 8.78998 18.32C9.02998 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM13 11.5C13 12.88 11.88 14 10.5 14C9.12 14 8 12.88 8 11.5V10.5C8 9.12 9.12 8 10.5 8C11.88 8 13 9.12 13 10.5V11.5ZM16 13C16 13.55 15.55 14 15 14C14.45 14 14 13.55 14 13V9C14 8.45 14.45 8 15 8C15.55 8 16 8.45 16 9V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-o1": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","feedback","notification","order-comment","transaction-comment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-o1-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","message","notification","chat","support","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="9" y="9" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 13V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","chat","message","feedback","customer-feedback","notes","notification","reply","conversation","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17C10.2901 17 10.4352 17 10.5779 17.0137C10.8497 17.0397 11.1167 17.1027 11.3714 17.201C11.5052 17.2526 11.6349 17.3175 11.8944 17.4472L14.3167 18.6584L14.3167 18.6584C15.4174 19.2087 15.9678 19.4839 16.3942 19.301C16.4853 19.2619 16.57 19.2095 16.6457 19.1455C17.6263 18.3162 17.0916 16.9941 18.215 16.3718C19.2057 15.823 20 14.9647 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H15M9.0375 13H13.8012"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","comment","feedback","message","notification","customer-support","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17 4 14 4H10C7 4 5.34001 4 4.17001 5.17C3.00001 6.34 3 8 3 11C3 14 3.00001 15.66 4.17001 16.83C5.34001 18 7 18 10 18C10.24 18 10.36 18 10.48 18C10.66 18.02 10.84 18.06 11.01 18.12C11.12 18.16 11.23 18.22 11.45 18.33L13.87 19.54C14.82 20.01 15.49 20.35 16.11 20.35C16.34 20.35 16.56 20.31 16.79 20.21C16.97 20.13 17.14 20.03 17.29 19.9C18 19.3 18.19 18.55 18.32 18C18.45 17.48 18.5 17.34 18.69 17.24C20.15 16.43 20.99 15.25 20.99 13.99V10.99C20.99 7.99 20.99 6.33 19.82 5.16L19.83 5.17ZM13.8 14H9.04001C8.49001 14 8.04001 13.55 8.04001 13C8.04001 12.45 8.49001 12 9.04001 12H13.8C14.35 12 14.8 12.45 14.8 13C14.8 13.55 14.35 14 13.8 14ZM15 10H9C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8H15C15.55 8 16 8.45 16 9C16 9.55 15.55 10 15 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-reply-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","chat","message","note","feedback","customer-feedback","support","help","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17V17C17 18.2306 17 18.8459 16.6457 19.1455C16.57 19.2095 16.4853 19.2619 16.3942 19.301C15.9678 19.4839 15.4174 19.2087 14.3167 18.6584L11 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H15M9.0375 13H13.8012"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","reply","message","chat","feedback","note","customer-note","order-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 17H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V17C15 18.2306 15 18.8459 14.6457 19.1455C14.57 19.2095 14.4853 19.2619 14.3942 19.301C13.9678 19.4839 13.4174 19.2087 12.3167 18.6584L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","chat","message","feedback","notes","reply","customer-service","support","interaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 17H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17V17C15 18.2306 15 18.8459 14.6457 19.1455C14.57 19.2095 14.4853 19.2619 14.3942 19.301C13.9678 19.4839 13.4174 19.2087 12.3167 18.6584L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","message","reply","feedback","note","communication","chat","conversation","remarks","customer-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.99269 16.8825 6.60482 16.9657 7.58318 16.99C8.33738 17.0087 8.71449 17.0181 9.03512 17.098C9.35575 17.1779 9.65946 17.3297 10.2669 17.6334L12.3167 18.6584L12.3167 18.6584C13.4174 19.2087 13.9678 19.4839 14.3942 19.301C14.4853 19.2619 14.57 19.2095 14.6457 19.1455C15.5859 18.3504 16.0028 17.0639 17.2285 16.9462C17.7633 16.8948 18.1601 16.7943 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","message","feedback","customer-feedback","support","conversation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17 4 14 4H10C7 4 5.33998 4 4.16998 5.17C2.99998 6.34 3 8 3 11V12C3 13.98 2.99998 15.07 3.53998 16C3.88998 16.61 4.4 17.11 5 17.46C5.7 17.86 6.50002 17.96 7.58002 17.99C8.23002 18.01 8.57998 18.01 8.78998 18.07C8.99998 18.12 9.27001 18.26 9.82001 18.53L11.87 19.55C12.82 20.02 13.49 20.36 14.11 20.36C14.34 20.36 14.56 20.32 14.79 20.22C14.97 20.14 15.14 20.04 15.29 19.91C15.69 19.57 16 19.18 16.27 18.84C16.75 18.23 16.98 17.98 17.32 17.95C18.02 17.88 18.54 17.74 19 17.47C19.61 17.12 20.11 16.61 20.46 16.01C21 15.08 21 13.99 21 12.01V11.01C21 8.01 21 6.35 19.83 5.18V5.17ZM13 14H9C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM15 10H9C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8H15C15.55 8 16 8.45 16 9C16 9.55 15.55 10 15 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "comment-smile-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["comment","feedback","happy","smile","customer-feedback","customer-satisfaction","message","chat","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14.044C14.8109 14.5136 14.5069 14.9283 14.116 15.25C12.8748 16.2613 11.0903 16.2483 9.864 15.219C9.47841 14.8915 9.18131 14.4723 9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-reply": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","chat","feedback","notes","message","customer-feedback","order-notes","support","customer-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17V17C17 18.2306 17 18.8459 16.6457 19.1455C16.57 19.2095 16.4853 19.2619 16.3942 19.301C15.9678 19.4839 15.4174 19.2087 14.3167 18.6584L11 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H15M9.0375 13H13.8012"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-smile-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["comment","smile","feedback","customer-feedback","chat","happy","satisfaction","customer-satisfaction","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14.044C14.8109 14.5136 14.5069 14.9283 14.116 15.25C12.8748 16.2613 11.0903 16.2483 9.864 15.219C9.47841 14.8915 9.18131 14.4723 9 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "comment-smile": {
        defaultColors: ["#3D4C66"],
        keywords: ["feedback","chat","comment","smile","happy","customer-service","support","satisfaction","review","testimonial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14.044C14.8109 14.5136 14.5069 14.9283 14.116 15.25C12.8748 16.2613 11.0903 16.2483 9.864 15.219C9.47841 14.8915 9.18131 14.4723 9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Compact-dish-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compact-disk","queue","wait","serving","process","cd","disk","restaurant","order-ready","order-processing","order-queue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19ZM12 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "comment-smile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","feedback","review","message","chat","support","customer-service","satisfaction","happiness","happy","smile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0049 4C7.59492 4 4.00492 7.59 4.00492 12C4.00492 13.24 4.29494 14.47 4.84494 15.57L4.06492 17.65C3.94492 17.96 3.99491 18.3 4.18491 18.57C4.37491 18.84 4.67492 19 5.00492 19H8.35489C9.63489 19.67 10.8249 20 12.0049 20C16.4149 20 20.0049 16.41 20.0049 12C20.0049 7.59 16.4149 4 12.0049 4ZM15.9349 14.42C15.6849 15.04 15.2749 15.6 14.7549 16.02C13.9549 16.67 12.9849 17 12.0149 17C11.0449 17 10.0349 16.66 9.22489 15.99C8.70489 15.55 8.30493 14.99 8.07493 14.36C7.87493 13.84 8.13494 13.27 8.65494 13.07C9.16494 12.87 9.74492 13.13 9.94492 13.65C10.0649 13.96 10.2649 14.25 10.5249 14.46C11.3749 15.17 12.6249 15.18 13.4949 14.48C13.7549 14.27 13.9549 13.99 14.0849 13.68C14.2949 13.17 14.8749 12.92 15.3849 13.13C15.8949 13.34 16.1449 13.92 15.9349 14.43V14.42Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    comment: {
        defaultColors: ["#3D4C66"],
        keywords: ["comment","feedback","review","message","chat","support","customer-service","satisfaction","happiness","happy","smile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12.0001C19 8.13413 15.866 5 12 5C8.134 5 5 8.13413 5 12.0001C5 13.2751 5.34087 14.4704 5.93645 15.5L5 18H8.60847C9.6132 18.5575 10.7695 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Compact-dish-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dish","plate","serving","clean","order","tableware","dine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19ZM12 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Compact-dish-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dish","compact","plate","tray","serving","food","menu","item","order","course"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 18H17.2916C18.9525 16.5341 20 14.3894 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Compact-dish": {
        defaultColors: ["#3D4C66"],
        keywords: ["dish","compact","round","circle","order","serving","food","restaurant","kitchen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19ZM12 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "compass-drafting-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["compass","drafting","drawing","measurement","precision","settings","configurations","adjustments","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 20L13 10H12H11L6 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13C17.6027 15.3912 14.9912 17 12 17C9.00885 17 6.39726 15.3912 5 13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compass-drafting-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","drafting","settings","configuration","adjust","preferences","tools","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 8.36769 15.3136 9.57506 14.2664 10.2964L16.3718 14.5072C17.082 13.9555 17.6827 13.2725 18.1368 12.4954C18.4154 12.0186 19.0278 11.8579 19.5047 12.1365C19.9815 12.4152 20.1422 13.0276 19.8636 13.5044C19.2136 14.6167 18.3301 15.5782 17.2799 16.3232L18.8946 19.5528C19.1416 20.0468 18.9414 20.6474 18.4474 20.8944C17.9535 21.1414 17.3528 20.9412 17.1058 20.4472L15.5296 17.2947C14.4443 17.7489 13.2516 17.9999 12.0002 17.9999C10.7488 17.9999 9.55609 17.7489 8.47086 17.2948L6.89465 20.4472C6.64766 20.9412 6.04698 21.1414 5.55301 20.8944C5.05903 20.6474 4.8588 20.0468 5.10579 19.5528L6.72055 16.3233C5.67023 15.5783 4.78674 14.6168 4.13676 13.5044C3.85812 13.0276 4.0188 12.4152 4.49565 12.1365C4.97249 11.8579 5.58493 12.0186 5.86356 12.4954C6.31767 13.2725 6.91842 13.9555 7.62858 14.5072L9.73388 10.2966C8.68656 9.57531 8 8.36783 8 7ZM9.368 15.5005C10.1815 15.8227 11.0697 15.9999 12.0002 15.9999C12.9307 15.9999 13.8189 15.8226 14.6324 15.5005L12.3822 11H11.6183L9.368 15.5005ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Compress-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compress","minimize","reduce","shrink","collapse","remove","delete","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H6C7.88562 10 8.82843 10 9.41421 9.41421C10 8.82843 10 7.88562 10 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10H18C16.1144 10 15.1716 10 14.5858 9.41421C14 8.82843 14 7.88562 14 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L18 14C16.1144 14 15.1716 14 14.5858 14.5858C14 15.1716 14 16.1144 14 18L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L6 14C7.88562 14 8.82843 14 9.41421 14.5858C10 15.1716 10 16.1144 10 18L10 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compass-drafting": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","drafting","measurement","precision","geometry","report","analysis","planning","blueprint"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 20L13 10H12H11L6 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13C17.6027 15.3912 14.9912 17 12 17C9.00885 17 6.39726 15.3912 5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Compress-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["compress","reduce","minimize","shrink","decrease","consolidate","remove","delete","close","exit","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H6C7.88562 10 8.82843 10 9.41421 9.41421C10 8.82843 10 7.88562 10 6V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10H18C16.1144 10 15.1716 10 14.5858 9.41421C14 8.82843 14 7.88562 14 6V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L18 14C16.1144 14 15.1716 14 14.5858 14.5858C14 15.1716 14 16.1144 14 18L14 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L6 14C7.88562 14 8.82843 14 9.41421 14.5858C10 15.1716 10 16.1144 10 18L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compass-drafting-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","drafting","measurement","accuracy","precision","blueprint","design","engineering","scale","calculate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 20L13 10H12H11L6 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13C17.6027 15.3912 14.9912 17 12 17C9.00885 17 6.39726 15.3912 5 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Compress-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compress","shrink","minimize","reduce","collapse","close","exit","remove","delete","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4C10.5523 4 11 4.44772 11 5V6C11 6.02202 11 6.04396 11 6.06583C11.0001 6.95232 11.0001 7.71613 10.9179 8.32779C10.8297 8.98331 10.631 9.61166 10.1213 10.1213C9.61166 10.631 8.98331 10.8297 8.32779 10.9179C7.71613 11.0001 6.95232 11.0001 6.06583 11C6.04396 11 6.02202 11 6 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H6C6.97108 9 7.59879 8.99788 8.0613 8.93569C8.49504 8.87738 8.63098 8.78323 8.70711 8.70711C8.78323 8.63098 8.87738 8.49504 8.93569 8.0613C8.99788 7.59879 9 6.97108 9 6V5C9 4.44772 9.44772 4 10 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 4C13.4477 4 13 4.44772 13 5V6C13 6.02202 13 6.04396 13 6.06583C12.9999 6.95232 12.9999 7.71613 13.0821 8.32779C13.1703 8.98331 13.369 9.61166 13.8787 10.1213C14.3883 10.631 15.0167 10.8297 15.6722 10.9179C16.2839 11.0001 17.0477 11.0001 17.9342 11C17.956 11 17.978 11 18 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H18C17.0289 9 16.4012 8.99788 15.9387 8.93569C15.505 8.87738 15.369 8.78323 15.2929 8.70711C15.2168 8.63098 15.1226 8.49504 15.0643 8.0613C15.0021 7.59879 15 6.97108 15 6V5C15 4.44772 14.5523 4 14 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 20C13.4477 20 13 19.5523 13 19V18C13 17.978 13 17.956 13 17.9342C12.9999 17.0477 12.9999 16.2839 13.0821 15.6722C13.1703 15.0167 13.369 14.3883 13.8787 13.8787C14.3883 13.369 15.0167 13.1703 15.6722 13.0821C16.2839 12.9999 17.0477 12.9999 17.9342 13C17.956 13 17.978 13 18 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H18C17.0289 15 16.4012 15.0021 15.9387 15.0643C15.505 15.1226 15.369 15.2168 15.2929 15.2929C15.2168 15.369 15.1226 15.505 15.0643 15.9387C15.0021 16.4012 15 17.0289 15 18V19C15 19.5523 14.5523 20 14 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 20C10.5523 20 11 19.5523 11 19V18C11 17.978 11 17.956 11 17.9342C11.0001 17.0477 11.0001 16.2839 10.9179 15.6722C10.8297 15.0167 10.631 14.3883 10.1213 13.8787C9.61166 13.369 8.98331 13.1703 8.32779 13.0821C7.71613 12.9999 6.95232 12.9999 6.06583 13C6.04396 13 6.02202 13 6 13H5C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H6C6.97108 15 7.59879 15.0021 8.0613 15.0643C8.49504 15.1226 8.63098 15.2168 8.70711 15.2929C8.78323 15.369 8.87738 15.505 8.93569 15.9387C8.99788 16.4012 9 17.0289 9 18V19C9 19.5523 9.44772 20 10 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "compress-wide-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compress","shrink","reduce","size","minimize","resize","fit","collapse","detach","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10H5C6.88562 10 7.82843 10 8.41421 9.41421C9 8.82843 9 7.88562 9 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10H19C17.1144 10 16.1716 10 15.5858 9.41421C15 8.82843 15 7.88562 15 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L19 14C17.1144 14 16.1716 14 15.5858 14.5858C15 15.1716 15 16.1144 15 18L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L5 14C6.88562 14 7.82843 14 8.41421 14.5858C9 15.1716 9 16.1144 9 18L9 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compress-wide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minimize","shrink","compress","collapse","hide","less","contract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10H5C6.88562 10 7.82843 10 8.41421 9.41421C9 8.82843 9 7.88562 9 6V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10H19C17.1144 10 16.1716 10 15.5858 9.41421C15 8.82843 15 7.88562 15 6V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L19 14C17.1144 14 16.1716 14 15.5858 14.5858C15 15.1716 15 16.1144 15 18L15 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L5 14C6.88562 14 7.82843 14 8.41421 14.5858C9 15.1716 9 16.1144 9 18L9 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compress-wide": {
        defaultColors: ["#3D4C66"],
        keywords: ["compress","shrink","reduce","minimize","collapse","less","smaller","compact","fold","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 10H5C6.88562 10 7.82843 10 8.41421 9.41421C9 8.82843 9 7.88562 9 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10H19C17.1144 10 16.1716 10 15.5858 9.41421C15 8.82843 15 7.88562 15 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14L19 14C17.1144 14 16.1716 14 15.5858 14.5858C15 15.1716 15 16.1144 15 18L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L5 14C6.88562 14 7.82843 14 8.41421 14.5858C9 15.1716 9 16.1144 9 18L9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Compress: {
        defaultColors: ["#3D4C66"],
        keywords: ["compress","shrink","reduce","minimize","collapse","less","smaller","compact","fold","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H6C7.88562 10 8.82843 10 9.41421 9.41421C10 8.82843 10 7.88562 10 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10H18C16.1144 10 15.1716 10 14.5858 9.41421C14 8.82843 14 7.88562 14 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L18 14C16.1144 14 15.1716 14 14.5858 14.5858C14 15.1716 14 16.1144 14 18L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L6 14C7.88562 14 8.82843 14 9.41421 14.5858C10 15.1716 10 16.1144 10 18L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "compress-wide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compress","shrink","reduce","minimize","collapse","close","fold","hide","remove","exit","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55229 4 10 4.44772 10 5V6C10 6.02202 10 6.04396 10 6.06583C10.0001 6.95232 10.0001 7.71613 9.91786 8.32779C9.82973 8.98331 9.63098 9.61166 9.12132 10.1213C8.61166 10.631 7.98331 10.8297 7.32779 10.9179C6.71613 11.0001 5.95232 11.0001 5.06583 11C5.04396 11 5.02202 11 5 11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H5C5.97108 9 6.59879 8.99788 7.0613 8.93569C7.49504 8.87738 7.63098 8.78323 7.70711 8.70711C7.78323 8.63098 7.87738 8.49504 7.93569 8.0613C7.99788 7.59879 8 6.97108 8 6V5C8 4.44772 8.44772 4 9 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 4C14.4477 4 14 4.44772 14 5V6C14 6.02202 14 6.04396 14 6.06583C13.9999 6.95232 13.9999 7.71613 14.0821 8.32779C14.1703 8.98331 14.369 9.61166 14.8787 10.1213C15.3883 10.631 16.0167 10.8297 16.6722 10.9179C17.2839 11.0001 18.0477 11.0001 18.9342 11C18.956 11 18.978 11 19 11H20C20.5523 11 21 10.5523 21 10C21 9.44772 20.5523 9 20 9H19C18.0289 9 17.4012 8.99788 16.9387 8.93569C16.505 8.87738 16.369 8.78323 16.2929 8.70711C16.2168 8.63098 16.1226 8.49504 16.0643 8.0613C16.0021 7.59879 16 6.97108 16 6V5C16 4.44772 15.5523 4 15 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 20C14.4477 20 14 19.5523 14 19V18C14 17.978 14 17.956 14 17.9342C13.9999 17.0477 13.9999 16.2839 14.0821 15.6722C14.1703 15.0167 14.369 14.3883 14.8787 13.8787C15.3883 13.369 16.0167 13.1703 16.6722 13.0821C17.2839 12.9999 18.0477 12.9999 18.9342 13C18.956 13 18.978 13 19 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H19C18.0289 15 17.4012 15.0021 16.9387 15.0643C16.505 15.1226 16.369 15.2168 16.2929 15.2929C16.2168 15.369 16.1226 15.505 16.0643 15.9387C16.0021 16.4012 16 17.0289 16 18V19C16 19.5523 15.5523 20 15 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 20C9.55229 20 10 19.5523 10 19V18C10 17.978 10 17.956 10 17.9342C10.0001 17.0477 10.0001 16.2839 9.91786 15.6722C9.82973 15.0167 9.63098 14.3883 9.12132 13.8787C8.61166 13.369 7.98331 13.1703 7.32779 13.0821C6.71613 12.9999 5.95232 12.9999 5.06583 13C5.04396 13 5.02202 13 5 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H5C5.97108 15 6.59879 15.0021 7.0613 15.0643C7.49504 15.1226 7.63098 15.2168 7.70711 15.2929C7.78323 15.369 7.87738 15.505 7.93569 15.9387C7.99788 16.4012 8 17.0289 8 18V19C8 19.5523 8.44772 20 9 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "controller-gen-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["time","timer","clock","waiting","pending","delay","service-time","order-time","estimated-time","duration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M13 11L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "controller-gen-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["clock","time","timer","delay","schedule","wait","duration","service-time","order-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M13 11L14 10" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "controller-gen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","timer","scheduling","late","early","hours","minutes","deadline","appointment","reminder","history","reports","metrics","average-time","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268H11.9268H11.9268C10.1034 2.99998 8.63361 2.99996 7.47767 3.15537C6.27753 3.31672 5.26703 3.66191 4.46447 4.46447C3.66191 5.26703 3.31672 6.27753 3.15537 7.47767C2.99996 8.63361 2.99998 10.1033 3 11.9268V11.9268V11.9268V12.0732V12.0732V12.0732C2.99998 13.8966 2.99996 15.3664 3.15537 16.5223C3.31672 17.7225 3.66192 18.733 4.46447 19.5355C5.26703 20.3381 6.27753 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27753 20.3381 5.26703 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99996 13.8966 2.99998 12.0732 3H12.0732H12.0732ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L12.2929 10.2929C11.9024 10.6834 11.9024 11.3166 12.2929 11.7071C12.6834 12.0976 13.3166 12.0976 13.7071 11.7071L14.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["conveyor","belt","boxes","packages","shipping","delivery","stock","inventory","supply-chain","automation","production","manufacturing","processing","distribution","fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 7H16.3C16.63 7 16.795 7 16.8975 6.89749C17 6.79497 17 6.62998 17 6.3V5.7C17 5.37002 17 5.20503 16.8975 5.10251C16.795 5 16.63 5 16.3 5H15.7C15.37 5 15.205 5 15.1025 5.10251C15 5.20503 15 5.37002 15 5.7V6.3C15 6.62998 15 6.79497 15.1025 6.89749C15.205 7 15.37 7 15.7 7H16Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 5H16H17.6C18.7314 5 19.2971 5 19.6485 5.35147C20 5.70294 20 6.26863 20 7.4V9.6C20 10.7314 20 11.2971 19.6485 11.6485C19.2971 12 18.7314 12 17.6 12H16H14.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "controller-gen": {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","timer","time","duration","scheduling","wait","waiting","pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M13 11L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "conveyor-belt-boxes-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["conveyor-belt","boxes","production","shipping","automation","inventory","manufacturing","assembly-line","process","delivery","order-processing","fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="2"
                    y="15"
                    width="20"
                    height="5"
                    rx="2.5"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M6.35304 4.25C5.82769 4.24996 5.36051 4.24992 4.98334 4.30063C4.5734 4.35574 4.15946 4.48283 3.82115 4.82115C3.48283 5.15946 3.35574 5.5734 3.30063 5.98334C3.24992 6.36051 3.24996 6.82769 3.25 7.35304V9.64697C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8406 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.7501 6.35301 12.75H9.64697C10.1723 12.7501 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8406 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64697V7.35305C12.7501 6.82769 12.7501 6.36051 12.6994 5.98334C12.6443 5.5734 12.5172 5.15946 12.1789 4.82115C11.8406 4.48283 11.4266 4.35574 11.0167 4.30063C10.6395 4.24992 10.1723 4.24996 9.64697 4.25H6.35304Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9.75003 4.25H6.25003L6.25001 6.32833C6.24992 6.46735 6.2498 6.63721 6.26953 6.78398C6.29352 6.96246 6.35838 7.21398 6.57221 7.42782C6.78604 7.64165 7.03757 7.7065 7.21605 7.7305C7.36281 7.75023 7.53267 7.75011 7.67169 7.75001H8.32836C8.46738 7.75011 8.63724 7.75023 8.78401 7.7305C8.96248 7.7065 9.21401 7.64165 9.42785 7.42782C9.64168 7.21398 9.70653 6.96246 9.73053 6.78398C9.75026 6.63721 9.75014 6.46735 9.75004 6.32834L9.75003 4.25Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2798 12.75L17.6455 12.75C18.1708 12.7501 18.6381 12.7501 19.0152 12.6994C19.4252 12.6443 19.8391 12.5172 20.1774 12.1789C20.5157 11.8406 20.6428 11.4266 20.6979 11.0167C20.7486 10.6395 20.7486 10.1723 20.7486 9.647V7.35305C20.7486 6.82771 20.7486 6.3605 20.6979 5.98334C20.6428 5.5734 20.5157 5.15946 20.1774 4.82115C19.8391 4.48283 19.4252 4.35574 19.0152 4.30063C18.638 4.24992 18.1709 4.24996 17.6455 4.25L13.5375 4.25001C13.5904 4.40846 13.6235 4.57121 13.6453 4.73334C13.696 5.11051 13.6959 5.57769 13.6959 6.10304V10.397C13.6959 10.9223 13.696 11.3895 13.6453 11.7667C13.5995 12.1069 13.5042 12.4498 13.2798 12.75Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M18.3955 4.25H14.8955L14.8955 6.32833C14.8954 6.46735 14.8953 6.63721 14.915 6.78398C14.939 6.96246 15.0039 7.21398 15.2177 7.42782C15.4316 7.64165 15.6831 7.7065 15.8616 7.7305C16.0083 7.75023 16.1782 7.75011 16.3172 7.75001H16.9739C17.1129 7.75011 17.2827 7.75023 17.4295 7.7305C17.608 7.7065 17.8595 7.64165 18.0734 7.42782C18.2872 7.21398 18.352 6.96246 18.376 6.78398C18.3958 6.63721 18.3956 6.46735 18.3955 6.32834L18.3955 4.25Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-3": {
        defaultColors: ["#000000"],
        keywords: ["conveyor","belt","boxes","delivery","shipping","inventory","stock","products","manufacturing","automation","supply-chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25 17.5C1.25 15.7051 2.70507 14.25 4.5 14.25H19.5C21.2949 14.25 22.75 15.7051 22.75 17.5C22.75 19.2949 21.2949 20.75 19.5 20.75H4.5C2.70507 20.75 1.25 19.2949 1.25 17.5ZM5 16.75C5.41421 16.75 5.75 17.0858 5.75 17.5V17.52C5.75 17.9342 5.41421 18.27 5 18.27C4.58579 18.27 4.25 17.9342 4.25 17.52V17.5C4.25 17.0858 4.58579 16.75 5 16.75ZM12 16.75C12.4142 16.75 12.75 17.0858 12.75 17.5V17.52C12.75 17.9342 12.4142 18.27 12 18.27C11.5858 18.27 11.25 17.9342 11.25 17.52V17.5C11.25 17.0858 11.5858 16.75 12 16.75ZM19.75 17.5C19.75 17.0858 19.4142 16.75 19 16.75C18.5858 16.75 18.25 17.0858 18.25 17.5V17.52C18.25 17.9342 18.5858 18.27 19 18.27C19.4142 18.27 19.75 17.9342 19.75 17.52V17.5Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M6.25003 4.25C5.76656 4.25016 5.33567 4.25325 4.98334 4.30062C4.5734 4.35573 4.15946 4.48283 3.82115 4.82114C3.48283 5.15945 3.35574 5.57339 3.30063 5.98334C3.24992 6.3605 3.24996 6.82768 3.25 7.35303V9.64696C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8405 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.75 6.35301 12.75H9.64697C10.1723 12.75 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8405 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64696V7.35304C12.7501 6.82769 12.7501 6.3605 12.6994 5.98334C12.6443 5.57339 12.5172 5.15945 12.1789 4.82114C11.8406 4.48283 11.4266 4.35573 11.0167 4.30062C10.6643 4.25325 10.2335 4.25016 9.75003 4.25L9.75004 6.32833C9.75014 6.46734 9.75026 6.63721 9.73053 6.78397C9.70653 6.96245 9.64168 7.21398 9.42785 7.42781C9.21401 7.64164 8.96248 7.70649 8.78401 7.73049C8.63724 7.75022 8.46738 7.7501 8.32836 7.75001H7.67169C7.53267 7.7501 7.36281 7.75022 7.21605 7.73049C7.03757 7.70649 6.78604 7.64164 6.57221 7.42781C6.35838 7.21398 6.29352 6.96245 6.26953 6.78397C6.2498 6.6372 6.24992 6.46734 6.25001 6.32833L6.25003 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.896 4.25L14.896 6.32833C14.8959 6.46735 14.8958 6.63721 14.9155 6.78398C14.9395 6.96245 15.0044 7.21398 15.2182 7.42781C15.432 7.64165 15.6836 7.7065 15.862 7.73049C16.0088 7.75023 16.1787 7.75011 16.3177 7.75001H16.9744C17.1134 7.75011 17.2832 7.75023 17.43 7.73049C17.6085 7.7065 17.86 7.64165 18.0738 7.42781C18.2877 7.21398 18.3525 6.96245 18.3765 6.78398C18.3963 6.63721 18.3961 6.46736 18.396 6.32835L18.396 4.25655C18.6219 4.26296 18.8297 4.27562 19.0157 4.30062C19.4256 4.35574 19.8396 4.48283 20.1779 4.82114C20.5162 5.15946 20.6433 5.5734 20.6984 5.98334C20.7491 6.3605 20.7491 6.8277 20.749 7.35304V9.64699C20.7491 10.1723 20.7491 10.6395 20.6984 11.0167C20.6433 11.4266 20.5162 11.8405 20.1779 12.1789C19.8396 12.5172 19.4256 12.6443 19.0157 12.6994C18.6385 12.7501 18.1713 12.75 17.646 12.75L13.2803 12.75C13.5047 12.4498 13.6 12.1069 13.6458 11.7667C13.6965 11.3895 13.6964 10.9223 13.6964 10.397V6.10303C13.6964 5.57769 13.6965 5.1105 13.6458 4.73334C13.624 4.57121 13.5909 4.40846 13.538 4.25L14.896 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-4": {
        defaultColors: ["#000000"],
        keywords: ["conveyor-belt","boxes","inventory","shipping","receiving","stock","products","automation","production","warehouse","supply-chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 9.6V7.4C8 6.26863 8 5.70294 8.35147 5.35147C8.70294 5 9.26863 5 10.4 5H13.6C14.7314 5 15.2971 5 15.6485 5.35147C16 5.70294 16 6.26863 16 7.4V9.6C16 10.7314 16 11.2971 15.6485 11.6485C15.2971 12 14.7314 12 13.6 12H10.4C9.26863 12 8.70294 12 8.35147 11.6485C8 11.2971 8 10.7314 8 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7H12.3C12.63 7 12.795 7 12.8975 6.89749C13 6.79497 13 6.62998 13 6.3V5.7C13 5.37002 13 5.20503 12.8975 5.10251C12.795 5 12.63 5 12.3 5H11.7C11.37 5 11.205 5 11.1025 5.10251C11 5.20503 11 5.37002 11 5.7V6.3C11 6.62998 11 6.79497 11.1025 6.89749C11.205 7 11.37 7 11.7 7H12Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-5": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["delivery","package","shipping","conveyor","belt","boxes","inventory","stock","goods","products","warehouse","logistics","supply-chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 7H12.3C12.63 7 12.795 7 12.8975 6.89749C13 6.79497 13 6.62998 13 6.3V5.7C13 5.37002 13 5.20503 12.8975 5.10251C12.795 5 12.63 5 12.3 5H11.7C11.37 5 11.205 5 11.1025 5.10251C11 5.20503 11 5.37002 11 5.7V6.3C11 6.62998 11 6.79497 11.1025 6.89749C11.205 7 11.37 7 11.7 7H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9.6V7.4C8 6.26863 8 5.70294 8.35147 5.35147C8.70294 5 9.26863 5 10.4 5H13.6C14.7314 5 15.2971 5 15.6485 5.35147C16 5.70294 16 6.26863 16 7.4V9.6C16 10.7314 16 11.2971 15.6485 11.6485C15.2971 12 14.7314 12 13.6 12H10.4C9.26863 12 8.70294 12 8.35147 11.6485C8 11.2971 8 10.7314 8 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-6": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["conveyor","belt","automation","production","assembly","processing","flow","manufacturing","inventory","logistics","process","line","system","transport","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="2"
                    y="15"
                    width="20"
                    height="5"
                    rx="2.5"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M10.353 4.25C9.82769 4.24996 9.36051 4.24992 8.98334 4.30063C8.5734 4.35574 8.15946 4.48283 7.82115 4.82115C7.48283 5.15946 7.35574 5.5734 7.30063 5.98334C7.24992 6.36051 7.24996 6.82769 7.25 7.35304V9.64697C7.24996 10.1723 7.24992 10.6395 7.30063 11.0167C7.35574 11.4266 7.48283 11.8406 7.82115 12.1789C8.15946 12.5172 8.5734 12.6443 8.98334 12.6994C9.3605 12.7501 9.82767 12.7501 10.353 12.75H13.647C14.1723 12.7501 14.6395 12.7501 15.0167 12.6994C15.4266 12.6443 15.8406 12.5172 16.1789 12.1789C16.5172 11.8406 16.6443 11.4266 16.6994 11.0167C16.7501 10.6395 16.7501 10.1723 16.75 9.64697V7.35305C16.7501 6.82769 16.7501 6.36051 16.6994 5.98334C16.6443 5.5734 16.5172 5.15946 16.1789 4.82115C15.8406 4.48283 15.4266 4.35574 15.0167 4.30063C14.6395 4.24992 14.1723 4.24996 13.647 4.25H10.353Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M13.75 4.25H10.25L10.25 6.32833C10.2499 6.46735 10.2498 6.63721 10.2695 6.78398C10.2935 6.96246 10.3584 7.21398 10.5722 7.42782C10.786 7.64165 11.0376 7.7065 11.216 7.7305C11.3628 7.75023 11.5327 7.75011 11.6717 7.75001H12.3284C12.4674 7.75011 12.6372 7.75023 12.784 7.7305C12.9625 7.7065 13.214 7.64165 13.4278 7.42782C13.6417 7.21398 13.7065 6.96246 13.7305 6.78398C13.7503 6.63721 13.7501 6.46735 13.75 6.32834L13.75 4.25Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
            </svg>
        )
    },
    "conveyor-belt-boxes-7": {
        defaultColors: ["#000000"],
        keywords: ["conveyor belt","boxes","packages","shipping","delivery","production","inventory","stock","manufacturing","assembly line","fulfillment","logistics","distribution","automation","supply chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25 17.5C1.25 15.7051 2.70507 14.25 4.5 14.25H19.5C21.2949 14.25 22.75 15.7051 22.75 17.5C22.75 19.2949 21.2949 20.75 19.5 20.75H4.5C2.70507 20.75 1.25 19.2949 1.25 17.5ZM5 16.75C5.41421 16.75 5.75 17.0858 5.75 17.5V17.52C5.75 17.9342 5.41421 18.27 5 18.27C4.58579 18.27 4.25 17.9342 4.25 17.52V17.5C4.25 17.0858 4.58579 16.75 5 16.75ZM12 16.75C12.4142 16.75 12.75 17.0858 12.75 17.5V17.52C12.75 17.9342 12.4142 18.27 12 18.27C11.5858 18.27 11.25 17.9342 11.25 17.52V17.5C11.25 17.0858 11.5858 16.75 12 16.75ZM19.75 17.5C19.75 17.0858 19.4142 16.75 19 16.75C18.5858 16.75 18.25 17.0858 18.25 17.5V17.52C18.25 17.9342 18.5858 18.27 19 18.27C19.4142 18.27 19.75 17.9342 19.75 17.52V17.5Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M10.25 4.25C9.76656 4.25016 9.33567 4.25325 8.98334 4.30062C8.5734 4.35573 8.15946 4.48283 7.82115 4.82114C7.48283 5.15945 7.35574 5.57339 7.30063 5.98334C7.24992 6.3605 7.24996 6.82768 7.25 7.35303V9.64696C7.24996 10.1723 7.24992 10.6395 7.30063 11.0167C7.35574 11.4266 7.48283 11.8405 7.82115 12.1789C8.15946 12.5172 8.5734 12.6443 8.98334 12.6994C9.3605 12.7501 9.82767 12.75 10.353 12.75H13.647C14.1723 12.75 14.6395 12.7501 15.0167 12.6994C15.4266 12.6443 15.8406 12.5172 16.1789 12.1789C16.5172 11.8405 16.6443 11.4266 16.6994 11.0167C16.7501 10.6395 16.7501 10.1723 16.75 9.64696V7.35304C16.7501 6.82769 16.7501 6.3605 16.6994 5.98334C16.6443 5.57339 16.5172 5.15945 16.1789 4.82114C15.8406 4.48283 15.4266 4.35573 15.0167 4.30062C14.6643 4.25325 14.2335 4.25016 13.75 4.25L13.75 6.32833C13.7501 6.46734 13.7503 6.63721 13.7305 6.78397C13.7065 6.96245 13.6417 7.21398 13.4278 7.42781C13.214 7.64164 12.9625 7.70649 12.784 7.73049C12.6372 7.75022 12.4674 7.7501 12.3284 7.75001H11.6717C11.5327 7.7501 11.3628 7.75022 11.216 7.73049C11.0376 7.70649 10.786 7.64164 10.5722 7.42781C10.3584 7.21398 10.2935 6.96245 10.2695 6.78397C10.2498 6.6372 10.2499 6.46734 10.25 6.32833L10.25 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "conveyor-belt-boxes": {
        defaultColors: ["#000000"],
        keywords: ["conveyor","belt","boxes","inventory","stock","delivery","manufacturing","shipping","receiving","warehouse","automation","supply-chain","goods","products","packages","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 5H16H17.6C18.7314 5 19.2971 5 19.6485 5.35147C20 5.70294 20 6.26863 20 7.4V9.6C20 10.7314 20 11.2971 19.6485 11.6485C19.2971 12 18.7314 12 17.6 12H16H14.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7H16.3C16.63 7 16.795 7 16.8975 6.89749C17 6.79497 17 6.62998 17 6.3V5.7C17 5.37002 17 5.20503 16.8975 5.10251C16.795 5 16.63 5 16.3 5H15.7C15.37 5 15.205 5 15.1025 5.10251C15 5.20503 15 5.37002 15 5.7V6.3C15 6.62998 15 6.79497 15.1025 6.89749C15.205 7 15.37 7 15.7 7H16Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "copper-coin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coin","payment","cash","currency","money","balance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L15 12L12 9L9 12L12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "copper-coin-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["diamond","shape","button","option","toggle","choice","navigation","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L15 12L12 9L9 12L12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "copper-coin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","currency","money","payment","cash","finance","transaction","change","balance","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13.5858L10.4142 12L12 10.4142L13.5858 12L12 13.5858Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM15.7071 11.2929L12.7071 8.29289C12.3166 7.90237 11.6834 7.90237 11.2929 8.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "copper-coin": {
        defaultColors: ["#3D4C66"],
        keywords: ["coin","discount","loyalty","reward","currency","payment","money","cash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L15 12L12 9L9 12L12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Copy-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["copy","duplicate","clone","replicate","same","identical","backup","repeat","item","copy-item","duplicate-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10L19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20L9 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 5.87868C16 6.75736 16 8.17157 16 11C16 13.8284 16 15.2426 15.1213 16.1213C14.2426 17 12.8284 17 10 17C7.17157 17 5.75736 17 4.87868 16.1213C4 15.2426 4 13.8284 4 11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5C12.8284 5 14.2426 5 15.1213 5.87868Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Copy-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["copy","duplicate","clone","repeat","transaction","receipt","record","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10L19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20L9 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 5.87868C16 6.75736 16 8.17157 16 11C16 13.8284 16 15.2426 15.1213 16.1213C14.2426 17 12.8284 17 10 17C7.17157 17 5.75736 17 4.87868 16.1213C4 15.2426 4 13.8284 4 11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5C12.8284 5 14.2426 5 15.1213 5.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Copy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["copy","duplicate","clone","clone-order","duplicate-order","copy-order","order","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.8991 17.1586C17.9979 16.4237 18 15.4425 18 14L18 10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10L20 14.0706C20 15.4247 20.0001 16.5413 19.8812 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8812C15.5413 21.0001 14.4247 21 13.0706 21L9 21C8.44771 21 8 20.5523 8 20C8 19.4477 8.44771 19 9 19L13 19C14.4425 19 15.4237 18.9979 16.1586 18.8991C16.8646 18.8042 17.1916 18.6368 17.4142 18.4142C17.6368 18.1916 17.8042 17.8646 17.8991 17.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H10.0706C11.4247 3.99997 12.5413 3.99994 13.4251 4.11875C14.3529 4.2435 15.1723 4.51547 15.8284 5.17158C16.4845 5.82768 16.7565 6.64711 16.8813 7.57494C17.0001 8.4587 17 9.57531 17 10.9294V11.0706C17 12.4247 17.0001 13.5413 16.8813 14.4251C16.7565 15.3529 16.4845 16.1723 15.8284 16.8284C15.1723 17.4845 14.3529 17.7565 13.4251 17.8813C12.5413 18.0001 11.4247 18 10.0706 18H9.92943C8.57531 18 7.4587 18.0001 6.57494 17.8813C5.64711 17.7565 4.82768 17.4845 4.17158 16.8284C3.51547 16.1723 3.2435 15.3529 3.11875 14.4251C2.99994 13.5413 2.99997 12.4247 3 11.0706V10.9294C2.99997 9.57531 2.99994 8.4587 3.11875 7.57494C3.2435 6.64711 3.51547 5.82768 4.17158 5.17158C4.82768 4.51547 5.64711 4.2435 6.57494 4.11875C7.4587 3.99994 8.57531 3.99997 9.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Copy: {
        defaultColors: ["#3D4C66"],
        keywords: ["copy","duplicate","clone","clone-order","duplicate-order","copy-order","order","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10L19 14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20L9 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 5.87868C16 6.75736 16 8.17157 16 11C16 13.8284 16 15.2426 15.1213 16.1213C14.2426 17 12.8284 17 10 17C7.17157 17 5.75736 17 4.87868 16.1213C4 15.2426 4 13.8284 4 11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5C12.8284 5 14.2426 5 15.1213 5.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "copyright-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["copyright","license","agreement","terms","legal","intellectual-property"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8.37655C12.4044 7.66673 10.4514 7.96529 9.17245 9.23128C7.60918 10.7788 7.60918 13.2212 9.17245 14.7687C10.4514 16.0347 12.4044 16.3333 14 15.6235"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    copyright: {
        defaultColors: ["#3D4C66"],
        keywords: ["copyright","license","agreement","terms","legal","intellectual-property"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8.37655C12.4044 7.66673 10.4514 7.96529 9.17245 9.23128C7.60918 10.7788 7.60918 13.2212 9.17245 14.7687C10.4514 16.0347 12.4044 16.3333 14 15.6235"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "copyright-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["c","circle","copyright","license","terms","conditions","customization","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8.37655C12.4044 7.66673 10.4514 7.96529 9.17245 9.23128C7.60918 10.7788 7.60918 13.2212 9.17245 14.7687C10.4514 16.0347 12.4044 16.3333 14 15.6235"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "copyright-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["copyright","C","circle","information","legal","symbol","ownership","rights","protected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM14.4064 7.46286C12.4528 6.59379 10.0548 6.95075 8.46894 8.52058C6.51035 10.4594 6.51035 13.5406 8.46894 15.4794C10.0548 17.0492 12.4528 17.4062 14.4064 16.5371C14.9111 16.3126 15.1381 15.7216 14.9137 15.217C14.6892 14.7124 14.0982 14.4853 13.5936 14.7098C12.3559 15.2603 10.8479 15.0202 9.87596 14.058C8.70801 12.9019 8.70801 11.0981 9.87596 9.94196C10.8479 8.9798 12.3559 8.73965 13.5936 9.29021C14.0982 9.51469 14.6892 9.28759 14.9137 8.78298C15.1381 8.27837 14.9111 7.68734 14.4064 7.46286Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cpu-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cpu","chip","processor","settings","system","configuration","hardware","technology","device","component"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect
                    x="6"
                    y="6"
                    width="12"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Cpu-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cpu","chip","processor","technology","hardware","system","update","settings","performance","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="6" y="6" width="12" height="12" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    Cpu: {
        defaultColors: ["#3D4C66"],
        keywords: ["cpu","chip","processor","technology","hardware","system","update","settings","performance","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="6" width="12" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Cpu-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cpu","processor","chip","technology","hardware","computer","electronics","system","component","circuit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4C14.5523 4 15 4.44772 15 5V5.07187C15.1472 5.08497 15.2889 5.10045 15.4251 5.11876C16.3529 5.2435 17.1723 5.51547 17.8284 6.17158C18.4845 6.82769 18.7565 7.64711 18.8813 8.57494C18.8996 8.71109 18.915 8.85278 18.9281 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H18.9984C19 11.2963 19 11.6061 19 11.9294V12.0706C19 12.3939 19 12.7037 18.9984 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H18.9281C18.915 15.1472 18.8996 15.2889 18.8813 15.4251C18.7565 16.3529 18.4845 17.1723 17.8284 17.8284C17.1723 18.4845 16.3529 18.7565 15.4251 18.8813C15.2889 18.8996 15.1472 18.915 15 18.9281V19C15 19.5523 14.5523 20 14 20C13.4477 20 13 19.5523 13 19V18.9984C12.7037 19 12.3939 19 12.0706 19H11.9294C11.6061 19 11.2963 19 11 18.9984V19C11 19.5523 10.5523 20 10 20C9.44772 20 9 19.5523 9 19V18.9281C8.85278 18.915 8.71109 18.8996 8.57494 18.8813C7.64711 18.7565 6.82769 18.4845 6.17158 17.8284C5.51547 17.1723 5.2435 16.3529 5.11876 15.4251C5.10045 15.2889 5.08497 15.1472 5.07187 15H5C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13H5.0016C4.99999 12.7037 4.99999 12.3939 5 12.0706V11.9294C4.99999 11.6061 4.99999 11.2963 5.0016 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H5.07187C5.08497 8.85278 5.10045 8.71109 5.11876 8.57494C5.2435 7.64711 5.51547 6.82769 6.17158 6.17158C6.82769 5.51547 7.64711 5.2435 8.57494 5.11876C8.71109 5.10045 8.85278 5.08497 9 5.07187V5C9 4.44772 9.44772 4 10 4C10.5523 4 11 4.44772 11 5V5.0016C11.2963 4.99999 11.6061 4.99999 11.9294 5H12.0706C12.3939 4.99999 12.7037 4.99999 13 5.0016V5C13 4.44772 13.4477 4 14 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "creative-commons-nc-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["no-cash","no-money","dollar-off","discount-denied","payment-denied","no-charge","free-item-removed","credit-denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "creative-commons-nc-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["no-charge","free","zero-cost","discount-denied","no-discount","payment-refused","payment-rejected","dollar-off","dollar-denied","no-money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "creative-commons-nc-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-money","no-cash","prohibited","not-allowed","payment-declined","cash-not-accepted","non-commercial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.94709 8.22037L3.36321 6.63649C3.01174 6.28502 3.01174 5.71517 3.36321 5.3637C3.71469 5.01223 4.28453 5.01223 4.63601 5.3637L18.636 19.3637C18.9875 19.7152 18.9875 20.285 18.636 20.6365C18.2845 20.988 17.7147 20.988 17.3632 20.6365L15.7793 19.0526C14.6538 19.6571 13.3668 20 11.9997 20C7.58143 20 3.99971 16.4183 3.99971 12C3.99971 10.6329 4.34261 9.34595 4.94709 8.22037ZM12.4729 15.7462C12.4264 15.7487 12.3798 15.75 12.333 15.75H12.2497V16C12.2497 16.4142 11.9139 16.75 11.4997 16.75C11.0855 16.75 10.7497 16.4142 10.7497 16V15.75H9.99971C9.58549 15.75 9.24971 15.4142 9.24971 15C9.24971 14.5858 9.58549 14.25 9.99971 14.25H10.9767L12.4729 15.7462Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.09406 5.68014L10.1293 8.71536C10.3153 8.57233 10.5242 8.45772 10.7497 8.37803V8C10.7497 7.58579 11.0855 7.25 11.4997 7.25C11.9139 7.25 12.2497 7.58579 12.2497 8V8.25H13.333C13.7473 8.25 14.083 8.58579 14.083 9C14.083 9.41421 13.7473 9.75 13.333 9.75H11.4997C11.4002 9.75 11.3053 9.76936 11.2184 9.80452L12.6889 11.275C13.7476 11.4239 14.6574 12.2267 14.7431 13.3292L18.3196 16.9056C19.3726 15.551 19.9997 13.8487 19.9997 12C19.9997 7.58172 16.418 4 11.9997 4C10.151 4 8.44875 4.62708 7.09406 5.68014Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "creative-commons-nc": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-money","no-charge","not-for-sale","unavailable","free","discount-denied","payment-rejected","invalid-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "creative-commons-nd-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["equal","equals","equivalence","same","total","amount","match","summary","sum","balance","subtotal","result"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M9 10H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M9 14H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "creative-commons-nd-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["equals","equal","balance","total","sum","result","equivalence","match","amount-due"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 10H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M9 14H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "creative-commons-nd-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["equal","equals","total","amount","balance","calculation","price","sum","result"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM9 11V9H15V11H9ZM9 13V15H15V13H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "creative-commons-nd": {
        defaultColors: ["#3D4C66"],
        keywords: ["equals","equal-sign","match","total","balance","summary","calculation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M9 10H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M9 14H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Credit-Card v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["credit-card","payment","card","debit-card","checkout","money","transaction","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 11H3M3 15H12M15 15H17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Credit-Card v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["credit-card","card","payment","pay","finance","transaction","checkout","debit-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M21 11H3M3 15H12M15 15H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","payment","pay","card","debit","transaction","purchase","checkout","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.0706 4C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82768 21.7565 6.64711 21.8813 7.57494C21.9717 8.24768 21.9933 9.05535 21.9984 10H2.0016C2.00673 9.05535 2.02831 8.24768 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45869 3.99994 7.57529 3.99997 8.9294 4H15.0706Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 12V13.0706C1.99999 13.3939 1.99999 13.7037 2.0016 14H12C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16H2.07187C2.08497 16.1472 2.10045 16.2889 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706L22 12H2ZM16 14C15.4477 14 15 14.4477 15 15C15 15.5523 15.4477 16 16 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Credit-Card v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","payment","card","pay","purchase","transaction","checkout","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M21 11H3M3 15H12M15 15H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card v3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["credit-card","card","payment","pay","finance","transaction","debit-card","credit","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M21 9H3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 12H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 15H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["credit-card","card","payment","pay","transaction","credit","debit","charge","finance","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 9H3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M3 12H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 15H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit card","payment","card","pay","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.0711 4C16.4252 3.99997 17.5418 3.99994 18.4255 4.11876C19.3534 4.2435 20.1728 4.51547 20.8289 5.17158C21.485 5.82768 21.757 6.64711 21.8817 7.57494C21.9384 7.99675 21.9681 8.4716 21.9835 9H2.01738C2.03287 8.4716 2.0625 7.99675 2.11921 7.57494C2.24396 6.64711 2.51592 5.82769 3.17203 5.17158C3.82814 4.51547 4.64757 4.2435 5.5754 4.11876C6.45915 3.99994 7.57575 3.99997 8.92986 4H15.0711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.00046 10.811C2.00046 10.8502 2.00046 10.8897 2.00046 10.9294V10.811Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.00046 11L1.99414 13H8.99414C9.54643 13 9.99414 13.4477 9.99414 14C9.99414 14.5523 9.54643 15 8.99414 15H2.00046C2.01095 15.7329 2.04515 15.8742 2.11921 16.4251C2.24396 17.3529 2.51592 18.1723 3.17203 18.8284C3.82814 19.4845 4.64757 19.7565 5.5754 19.8813C6.45914 20.0001 7.57573 20 8.92981 20H15.071C16.4251 20 17.5418 20.0001 18.4255 19.8813C19.3534 19.7565 20.1728 19.4845 20.8289 18.8284C21.485 18.1723 21.757 17.3529 21.8817 16.4251C22.0005 15.5413 22.0005 14.4247 22.0005 13.0706L22.0005 11H2.00046Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Credit-Card v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","payment","pay","card","checkout","money","transaction","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M21 9H3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 12H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 15H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["credit-card","payment","card","debit-card","wallet","transaction","pay","purchase","finance","money","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 10C10 11.1046 9.10457 12 8 12C7.44772 12 6.94772 11.7761 6.58579 11.4142C6.22386 11.0523 6 10.5523 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M21 15H3M13 10H21" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["credit-card","payment","card","pay","transaction","finance","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10C10 11.1046 9.10457 12 8 12C7.44772 12 6.94772 11.7761 6.58579 11.4142C6.22386 11.0523 6 10.5523 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 15H3M13 10H21" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Credit-Card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit card","payment","transaction","debit card","card","pay","finance","money","credit","charge","magnetic stripe","swipe","reader"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82768 21.7565 6.64711 21.8813 7.57494C21.938 7.99675 21.9676 8.4716 21.9831 9H14C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11H22L22 13.0705C22 13.3939 22 13.7037 21.9984 14H2.0016C1.99999 13.7037 1.99999 13.3939 2 13.0706V10.9294C1.99997 9.57533 1.99994 8.45869 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45869 3.99994 7.57529 3.99997 8.9294 4H15.0706ZM8 7C6.34315 7 5 8.34315 5 10C5 10.8282 5.33688 11.5795 5.87868 12.1213C6.42048 12.6631 7.17185 13 8 13C9.65686 13 11 11.6569 11 10C11 8.34315 9.65686 7 8 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.07187 16C2.08497 16.1472 2.10045 16.2889 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C21.8996 16.2889 21.915 16.1472 21.9281 16H2.07187Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Credit-Card-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["credit-card","payment","card","pay","credit","debit","method","cashless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11C10 12.1046 9.10457 13 8 13C7.44772 13 6.94772 12.7761 6.58579 12.4142C6.22386 12.0523 6 11.5523 6 11C6 9.89543 6.89543 9 8 9C9.10457 9 10 9.89543 10 11Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 13H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Credit-Card-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["credit-card","card","payment","pay","debit","money","transaction","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 13H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11C10 12.1046 9.10457 13 8 13C7.44772 13 6.94772 12.7761 6.58579 12.4142C6.22386 12.0523 6 11.5523 6 11C6 9.89543 6.89543 9 8 9C9.10457 9 10 9.89543 10 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Credit-Card-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","payment","pay","card","transaction","finance","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82768 21.7565 6.64711 21.8813 7.57494C22.0001 8.4587 22 9.57531 22 10.9294V10.9295V13.0705V13.0706C22 14.4247 22.0001 15.5413 21.8813 16.4251C21.7565 17.3529 21.4845 18.1723 20.8284 18.8284C20.1723 19.4845 19.3529 19.7565 18.4251 19.8813C17.5413 20.0001 16.4247 20 15.0707 20H15.0706H8.92943H8.92935C7.57527 20 6.45868 20.0001 5.57494 19.8813C4.64711 19.7565 3.82769 19.4845 3.17158 18.8284C2.51547 18.1723 2.2435 17.3529 2.11876 16.4251C1.99994 15.5413 1.99997 14.4247 2 13.0706V13.0706V10.9294V10.9294C1.99997 9.57529 1.99994 8.45869 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45869 3.99994 7.57529 3.99997 8.9294 4H8.92943H15.0706H15.0706ZM8 8C6.34315 8 5 9.34315 5 11C5 11.8282 5.33688 12.5795 5.87868 13.1213C6.42048 13.6631 7.17185 14 8 14C9.65686 14 11 12.6569 11 11C11 9.34315 9.65686 8 8 8ZM14 12C13.4477 12 13 12.4477 13 13C13 13.5523 13.4477 14 14 14H18C18.5523 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12H14ZM16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17H18C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Credit-Card-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","card","payment","pay","transaction","finance","debit-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 13H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11C10 12.1046 9.10457 13 8 13C7.44772 13 6.94772 12.7761 6.58579 12.4142C6.22386 12.0523 6 11.5523 6 11C6 9.89543 6.89543 9 8 9C9.10457 9 10 9.89543 10 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Credit-Card-mastercard-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["credit-card","card","payment","mastercard","pay","finance","transaction","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9.76389C12.5308 9.28885 13.2316 9 14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C13.2316 15 12.5308 14.7111 12 14.2361M12 9.76389C11.3863 10.3132 11 11.1115 11 12C11 12.8885 11.3863 13.6868 12 14.2361M12 9.76389C11.4692 9.28885 10.7684 9 10 9C8.34315 9 7 10.3431 7 12C7 13.6569 8.34315 15 10 15C10.7684 15 11.4692 14.7111 12 14.2361"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Credit-Card-mastercard-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["credit","card","mastercard","payment","finance","transaction","pay","credit-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16C11.2091 16 13 14.2091 13 12C13 9.79087 11.2091 8 9 8C6.79087 8 5 9.79087 5 12C5 14.2091 6.79087 16 9 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16C17.2091 16 19 14.2091 19 12C19 9.79087 17.2091 8 15 8C12.7909 8 11 9.79087 11 12C11 14.2091 12.7909 16 15 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Credit-Card-mastercard": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit","card","payment","mastercard","pay","credit-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9.76389C12.5308 9.28885 13.2316 9 14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C13.2316 15 12.5308 14.7111 12 14.2361M12 9.76389C11.3863 10.3132 11 11.1115 11 12C11 12.8885 11.3863 13.6868 12 14.2361M12 9.76389C11.4692 9.28885 10.7684 9 10 9C8.34315 9 7 10.3431 7 12C7 13.6569 8.34315 15 10 15C10.7684 15 11.4692 14.7111 12 14.2361"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Credit-Card-mastercard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinite","loyalty","program","rewards","membership","continuous","recurring","subscription","unlimited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 12C7.25 10.7574 8.25736 9.75 9.5 9.75C10.1252 9.75 10.6911 10.0046 11.0995 10.4175C10.8752 10.8987 10.75 11.4354 10.75 12C10.75 12.5655 10.8729 13.0994 11.0991 13.583C10.6907 13.9956 10.1249 14.25 9.5 14.25C8.25736 14.25 7.25 13.2426 7.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 14.25C13.7181 14.25 13.0289 13.8518 12.6246 13.2436C12.3879 12.8877 12.25 12.4611 12.25 12C12.25 11.5389 12.3879 11.1123 12.6246 10.7564C13.0289 10.1482 13.7181 9.75 14.5 9.75C15.7426 9.75 16.75 10.7574 16.75 12C16.75 13.2426 15.7426 14.25 14.5 14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0549 4.25H8.94513C7.57754 4.24998 6.47521 4.24996 5.60825 4.36652C4.70814 4.48754 3.95027 4.74643 3.34835 5.34835C2.74643 5.95027 2.48754 6.70814 2.36652 7.60825C2.24996 8.47521 2.24998 9.57753 2.25 10.9451V13.0549C2.24998 14.4225 2.24996 15.5248 2.36652 16.3918C2.48754 17.2919 2.74643 18.0497 3.34835 18.6517C3.95027 19.2536 4.70814 19.5125 5.60825 19.6335C6.47522 19.75 7.57754 19.75 8.94512 19.75H15.0549C16.4225 19.75 17.5248 19.75 18.3918 19.6335C19.2919 19.5125 20.0497 19.2536 20.6517 18.6517C21.2536 18.0497 21.5125 17.2919 21.6335 16.3918C21.75 15.5248 21.75 14.4225 21.75 13.0549V10.9451C21.75 9.57754 21.75 8.47522 21.6335 7.60825C21.5125 6.70814 21.2536 5.95027 20.6517 5.34835C20.0497 4.74643 19.2919 4.48754 18.3918 4.36652C17.5248 4.24996 16.4225 4.24998 15.0549 4.25ZM9.5 8.25C10.4608 8.25 11.337 8.61171 12 9.20499C12.663 8.61171 13.5392 8.25 14.5 8.25C16.5711 8.25 18.25 9.92894 18.25 12C18.25 14.0711 16.5711 15.75 14.5 15.75C13.5392 15.75 12.663 15.3883 12 14.795C11.337 15.3883 10.4608 15.75 9.5 15.75C7.42894 15.75 5.75 14.0711 5.75 12C5.75 9.92894 7.42894 8.25 9.5 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Credit-Card": {
        defaultColors: ["#3D4C66"],
        keywords: ["credit-card","card","payment","pay","charge","transaction","credit","debit","method","bank"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10C10 11.1046 9.10457 12 8 12C7.44772 12 6.94772 11.7761 6.58579 11.4142C6.22386 11.0523 6 10.5523 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 15H3M13 10H21" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Crop-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["crop","trim","resize","edit","image","selection","focus","adjust","layout","area","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8L11 8L13 8C14.8856 8 15.8284 8 16.4142 8.58579C17 9.17157 17 10.1144 17 12L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 16L13 16L11 16C9.11438 16 8.17157 16 7.58579 15.4142C7 14.8284 7 13.8856 7 12L7 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Crop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crop","resize","edit","image","selection","adjust","transform","cut","focus","portion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 15H18V11.93C18 11.04 18 10.28 17.92 9.67C17.83 9.01 17.63 8.39 17.12 7.88C16.61 7.37 15.98 7.17 15.33 7.08C14.72 7 13.95 7 13.07 7H8V6C8 5.45 7.55 5 7 5C6.45 5 6 5.45 6 6V7H5C4.45 7 4 7.45 4 8C4 8.55 4.45 9 5 9H6V12.07C6 12.96 6 13.72 6.08 14.33C6.17 14.99 6.37 15.61 6.88 16.12C7.39 16.63 8.02 16.83 8.67 16.92C9.28 17 10.05 17 10.93 17H16V18C16 18.55 16.45 19 17 19C17.55 19 18 18.55 18 18V17H19C19.55 17 20 16.55 20 16C20 15.45 19.55 15 19 15ZM11 15C10.03 15 9.4 15 8.94 14.94C8.51 14.88 8.37 14.79 8.29 14.71C8.21 14.63 8.12 14.5 8.06 14.06C8 13.6 8 12.97 8 12V9H13C13.97 9 14.6 9 15.06 9.06C15.49 9.12 15.63 9.21 15.71 9.29C15.79 9.37 15.88 9.5 15.94 9.94C16 10.4 16 11.03 16 12V15H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Crop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["crop","focus","resize","selection","area","adjust","image","edit","transform","zoom","frame"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8L11 8L13 8C14.8856 8 15.8284 8 16.4142 8.58579C17 9.17157 17 10.1144 17 12L17 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 16L13 16L11 16C9.11438 16 8.17157 16 7.58579 15.4142C7 14.8284 7 13.8856 7 12L7 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Crop: {
        defaultColors: ["#3D4C66"],
        keywords: ["crop","focus","resize","selection","area","adjust","image","edit","transform","zoom","frame"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18V12C17 10.1144 17 9.17157 16.4142 8.58579C15.8284 8 14.8856 8 13 8L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 6L7 12C7 13.8856 7 14.8284 7.58579 15.4142C8.17157 16 9.11438 16 11 16L19 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cross","x","remove","delete","cancel","close","clear","exit","discard","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15L15 9M15 15L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15L9 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "cross-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cross","close","remove","delete","cancel","exit","clear","error","invalid","void","reject","discard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15L15 9M15 15L9 9" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cross","delete","remove","cancel","clear","close","discard","reject","exit","error","item-removal","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L12 10.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L13.4142 12L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L12 13.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L10.5858 12L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "cross-sign-church-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cross","religious","donation","charity","non-profit","church","religious-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12V18C10 18.9428 10 19.4142 10.2929 19.7071C10.5858 20 11.0572 20 12 20V20C12.9428 20 13.4142 20 13.7071 19.7071C14 19.4142 14 18.9428 14 18V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8L14 6C14 5.05719 14 4.58579 13.7071 4.29289C13.7071 4.29289 13.7071 4.29289 13.7071 4.29289C13.4142 4 12.9428 4 12 4V4C11.0572 4 10.5858 4 10.2929 4.29289C10.2929 4.29289 10.2929 4.29289 10.2929 4.29289C10 4.58579 10 5.05719 10 6L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L16 12C16.9428 12 17.4142 12 17.7071 11.7071C17.7071 11.7071 17.7071 11.7071 17.7071 11.7071C18 11.4142 18 10.9428 18 10V10C18 9.05719 18 8.58579 17.7071 8.29289C17.7071 8.29289 17.7071 8.29289 17.7071 8.29289C17.4142 8 16.9428 8 16 8L14 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L8 12C7.05719 12 6.58579 12 6.29289 11.7071C6.29289 11.7071 6.29289 11.7071 6.29289 11.7071C6 11.4142 6 10.9428 6 10V10C6 9.05719 6 8.58579 6.29289 8.29289C6.29289 8.29289 6.29289 8.29289 6.29289 8.29289C6.58579 8 7.05719 8 8 8L10 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cross-sign-church-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["cross","religious","charity","donation","church","non-profit","religious-organization","offering","fundraising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18V14C10 13.0572 10 12.5858 9.70711 12.2929C9.41421 12 8.94281 12 8 12C7.05719 12 6.58579 12 6.29289 11.7071C6 11.4142 6 10.9428 6 10C6 9.05719 6 8.58579 6.29289 8.29289C6.58579 8 7.05719 8 8 8C8.94281 8 9.41421 8 9.70711 7.70711C10 7.41421 10 6.94281 10 6C10 5.05719 10 4.58579 10.2929 4.29289C10.5858 4 11.0572 4 12 4C12.9428 4 13.4142 4 13.7071 4.29289C14 4.58579 14 5.05719 14 6L14 8L16 8C16.9428 8 17.4142 8 17.7071 8.29289C18 8.58579 18 9.05719 18 10C18 10.9428 18 11.4142 17.7071 11.7071C17.4142 12 16.9428 12 16 12L14 12V18C14 18.9428 14 19.4142 13.7071 19.7071C13.4142 20 12.9428 20 12 20C11.0572 20 10.5858 20 10.2929 19.7071C10 19.4142 10 18.9428 10 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cross-sign-church": {
        defaultColors: ["#3D4C66"],
        keywords: ["cross","add","plus","increase","add-item","promotion","loyalty","special"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12V18C10 18.9428 10 19.4142 10.2929 19.7071C10.5858 20 11.0572 20 12 20V20C12.9428 20 13.4142 20 13.7071 19.7071C14 19.4142 14 18.9428 14 18V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8L14 6C14 5.05719 14 4.58579 13.7071 4.29289C13.7071 4.29289 13.7071 4.29289 13.7071 4.29289C13.4142 4 12.9428 4 12 4V4C11.0572 4 10.5858 4 10.2929 4.29289C10.2929 4.29289 10.2929 4.29289 10.2929 4.29289C10 4.58579 10 5.05719 10 6L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L16 12C16.9428 12 17.4142 12 17.7071 11.7071C17.7071 11.7071 17.7071 11.7071 17.7071 11.7071C18 11.4142 18 10.9428 18 10V10C18 9.05719 18 8.58579 17.7071 8.29289C17.7071 8.29289 17.7071 8.29289 17.7071 8.29289C17.4142 8 16.9428 8 16 8L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L8 12C7.05719 12 6.58579 12 6.29289 11.7071C6.29289 11.7071 6.29289 11.7071 6.29289 11.7071C6 11.4142 6 10.9428 6 10V10C6 9.05719 6 8.58579 6.29289 8.29289C6.29289 8.29289 6.29289 8.29289 6.29289 8.29289C6.58579 8 7.05719 8 8 8L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "cross-sign-church-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cross","church","non-profit","religious","donation","charity","tithe","payment","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9456 3.00001C11.5215 2.99992 11.1094 2.99984 10.7695 3.04554C10.3863 3.09706 9.94902 3.22259 9.5858 3.5858C9.22258 3.94902 9.09706 4.38629 9.04554 4.7695C8.99984 5.10941 8.99992 5.52153 9.00001 5.9456L9.00001 6.00001C9.00001 6.49969 8.99789 6.77385 8.97232 6.96404L8.97132 6.97132L8.96404 6.97232C8.77385 6.99789 8.49969 7.00001 8.00001 7.00001L7.9456 7.00001C7.52153 6.99992 7.10941 6.99984 6.7695 7.04554C6.38629 7.09706 5.94902 7.22259 5.5858 7.5858C5.22258 7.94902 5.09706 8.38629 5.04554 8.7695C4.99984 9.10941 4.99992 9.52154 5.00001 9.94561V10.0544C4.99992 10.4785 4.99984 10.8906 5.04554 11.2305C5.09706 11.6137 5.22259 12.051 5.5858 12.4142C5.94902 12.7774 6.38629 12.903 6.76949 12.9545C7.10941 13.0002 7.52154 13.0001 7.94561 13L8.00001 13C8.49969 13 8.77385 13.0021 8.96404 13.0277L8.97132 13.0287L8.97232 13.036C8.99789 13.2262 9.00001 13.5003 9.00001 14L9.00001 18.0544C8.99992 18.4785 8.99984 18.8906 9.04554 19.2305C9.09706 19.6137 9.22258 20.051 9.5858 20.4142C9.94902 20.7774 10.3863 20.903 10.7695 20.9545C11.1094 21.0002 11.5215 21.0001 11.9456 21H12.0544C12.4785 21.0001 12.8906 21.0002 13.2305 20.9545C13.6137 20.903 14.051 20.7774 14.4142 20.4142C14.7774 20.051 14.903 19.6137 14.9545 19.2305C15.0002 18.8906 15.0001 18.4785 15 18.0544L15 13L16.0544 13C16.4785 13.0001 16.8906 13.0002 17.2305 12.9545C17.6137 12.903 18.051 12.7774 18.4142 12.4142C18.7774 12.051 18.903 11.6137 18.9545 11.2305C19.0002 10.8906 19.0001 10.4785 19 10.0544V9.9456C19.0001 9.52154 19.0002 9.10941 18.9545 8.76949C18.903 8.38629 18.7774 7.94902 18.4142 7.5858C18.051 7.22258 17.6137 7.09706 17.2305 7.04554C16.8906 6.99984 16.4785 6.99992 16.0544 7.00001L15 7.00001L15 5.9456C15.0001 5.52154 15.0002 5.10941 14.9545 4.7695C14.903 4.38629 14.7774 3.94902 14.4142 3.5858C14.051 3.22258 13.6137 3.09706 13.2305 3.04554C12.8906 2.99984 12.4785 2.99992 12.0544 3.00001H11.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    cross: {
        defaultColors: ["#3D4C66"],
        keywords: ["cross","church","non-profit","religious","donation","charity","tithe","payment","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15L15 9M15 15L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Crown 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["crown","loyalty","rewards","vip","premium","top","ranked","king","best","exclusive","membership","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L18.4644 11.2002C18.6951 9.31282 18.8104 8.36914 18.2597 8.03377C17.709 7.69839 16.9235 8.23395 15.3525 9.30507L15 9.54545L13.6692 7.52912C12.9152 6.38664 12.5381 5.8154 12 5.8154C11.4618 5.8154 11.0848 6.38664 10.3308 7.52912L8.99997 9.54545L8.64749 9.30513C7.07649 8.23398 6.291 7.69841 5.74028 8.03379C5.18956 8.36916 5.3049 9.31285 5.53558 11.2002L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15H12H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["crown","loyalty","rewards","premium","vip","privilege","special-offer","status","customer-segment","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L9.99994 15L6 15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H10H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.0642 14.4728L18.4642 11.2002C18.6949 9.31285 18.8103 8.36917 18.2595 8.0338C17.7088 7.69842 16.9233 8.23398 15.3523 9.3051L14.9998 9.54548L13.669 7.52915C12.915 6.38667 12.5379 5.81543 11.9998 5.81543C11.4616 5.81543 11.0846 6.38667 10.3306 7.52915L8.99978 9.54548L8.6473 9.30515C7.07631 8.23401 6.29081 7.69844 5.74009 8.03382C5.18938 8.36919 5.30472 9.31287 5.53539 11.2002L5.7676 13.1001L5.93538 14.4728C5.96605 14.7238 5.98139 14.8493 6.06653 14.9247C6.15167 15 6.27633 15 6.52564 15H17.4729C17.7229 15 17.848 15 17.9331 14.9247C18.0182 14.8493 18.0336 14.7238 18.0642 14.4728Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","rewards","vip","premium","member","loyalty-program","privilege","promotion","special-offer","tier","customer-segment","customer-appreciation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5205 16.9099C18.3805 16.7699 18.1905 16.6899 17.9905 16.6899H5.99048C5.58048 16.6899 5.24048 17.0299 5.24048 17.4399H5.99048C5.24048 17.4399 5.24048 17.4399 5.24048 17.4399V17.4799C5.24048 17.4999 5.24048 17.5099 5.24048 17.5299C5.24048 17.5699 5.25048 17.6099 5.26048 17.6599C5.28048 17.7499 5.32048 17.8699 5.38048 17.9899C5.50048 18.2399 5.70048 18.5399 6.04048 18.8799C6.50048 19.3399 7.06048 19.5199 7.69048 19.6099C8.28048 19.6899 9.03048 19.6899 9.93048 19.6899H14.0305C14.9305 19.6899 15.6805 19.6899 16.2705 19.6099C16.9005 19.5299 17.4705 19.3399 17.9205 18.8799C18.2605 18.5399 18.4605 18.2399 18.5805 17.9899C18.6405 17.8699 18.6705 17.7599 18.7005 17.6599C18.7105 17.6099 18.7205 17.5699 18.7205 17.5299C18.7205 17.5099 18.7205 17.4899 18.7205 17.4799V17.4399C18.7205 17.4399 18.7205 17.4399 17.9705 17.4399H18.7205C18.7205 17.2399 18.6405 17.0499 18.5005 16.9099H18.5205Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.6404 7.33C18.0204 6.95 17.3604 7.16 16.8504 7.41C16.3904 7.63 15.8404 8 15.2004 8.44L14.2904 7.06C14.2904 7.06 14.2704 7.03 14.2604 7.01C13.9104 6.48 13.6004 6.01 13.3104 5.68C13.0004 5.33 12.5804 5 12.0004 5C11.4204 5 11.0004 5.33 10.6904 5.68C10.4004 6.01 10.0904 6.47 9.74037 7.01C9.73037 7.03 9.72037 7.04 9.71037 7.06L8.80037 8.44C8.16037 8 7.61037 7.64 7.15037 7.41C6.64037 7.16 5.98037 6.95 5.36037 7.33C4.74037 7.71 4.62037 8.39 4.60037 8.96C4.59037 9.53 4.68037 10.28 4.79037 11.17L5.20037 14.5V14.52C5.21037 14.62 5.23037 14.76 5.26037 14.88C5.30037 15.03 5.38037 15.24 5.58037 15.42C5.78037 15.59 5.99037 15.65 6.15037 15.67C6.27037 15.69 6.41037 15.69 6.51037 15.69H17.5004C17.6004 15.69 17.7404 15.69 17.8704 15.67C18.0204 15.65 18.2404 15.6 18.4404 15.42C18.6404 15.24 18.7204 15.03 18.7604 14.88C18.7904 14.76 18.8104 14.62 18.8204 14.52V14.5L19.2304 11.17C19.3404 10.28 19.4097 9.53 19.3997 8.96C19.3897 8.4 19.2904 7.72 18.6604 7.33H18.6404Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Crown 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","reward","premium","vip","membership","privilege","tier","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L18.4644 11.2002C18.6951 9.31282 18.8104 8.36914 18.2597 8.03377C17.709 7.69839 16.9235 8.23395 15.3525 9.30507L15 9.54545L13.6692 7.52912C12.9152 6.38664 12.5381 5.8154 12 5.8154C11.4618 5.8154 11.0848 6.38664 10.3308 7.52912L8.99997 9.54545L8.64749 9.30513C7.07649 8.23398 6.291 7.69841 5.74028 8.03379C5.18956 8.36916 5.3049 9.31285 5.53558 11.2002L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15H12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 3-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","rewards","vip","promotion","leadership","management","tier","premium"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.715 8.85831C12.9491 7.58187 12.5662 6.94365 12 6.94365C11.4338 6.94365 11.0508 7.58187 10.285 8.85831L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 3-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["crown","loyalty","rewards","vip","premium","membership","tier","privilege","points","promotion","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.715 8.85831C12.9491 7.58187 12.5662 6.94365 12 6.94365C11.4338 6.94365 11.0508 7.58187 10.285 8.85831L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","premium","vip","award","discount","reward","promotion","tier","status","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.6381 6.94629C10.9501 6.56667 11.379 6.2002 12.0002 6.2002C12.6213 6.2002 13.0503 6.56667 13.3622 6.94629C13.6601 7.30872 13.9712 7.8273 14.3286 8.42318C14.3385 8.43959 14.3484 8.45606 14.3583 8.47259L15.2155 9.9013C15.842 9.43267 16.3773 9.04196 16.8258 8.79633C17.3278 8.52142 17.9899 8.2764 18.6382 8.64203C19.2866 9.00767 19.4195 9.70101 19.4439 10.2728C19.4687 10.8528 19.3914 11.6253 19.2994 12.545L19.1018 14.5214C19.0204 15.3359 18.9522 16.0182 18.827 16.5581C18.6945 17.1295 18.4783 17.6383 18.0355 18.0391C17.5926 18.44 17.0648 18.6044 16.483 18.6794C15.9333 18.7502 15.2476 18.7502 14.4291 18.7502H9.57126C8.75272 18.7502 8.06704 18.7502 7.51737 18.6794C6.93557 18.6044 6.40777 18.44 5.96488 18.0391C5.52198 17.6383 5.30586 17.1295 5.17336 16.558C5.04818 16.0182 4.97997 15.3359 4.89856 14.5214L4.70093 12.545C4.60892 11.6254 4.53163 10.8528 4.55645 10.2728C4.58092 9.70101 4.71382 9.00767 5.36218 8.64204C6.01054 8.27641 6.67261 8.52143 7.17457 8.79635C7.62303 9.04197 8.15834 9.43268 8.78483 9.9013L9.64206 8.47259C9.65197 8.45606 9.66185 8.4396 9.67169 8.42319C10.0292 7.82731 10.3403 7.30873 10.6381 6.94629Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Crown 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","reward","vip","privilege","promotion","premium","hierarchy","role","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.715 8.85831C12.9491 7.58187 12.5662 6.94365 12 6.94365C11.4338 6.94365 11.0508 7.58187 10.285 8.85831L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["crown","loyalty","rewards","vip","premium","membership","status","privilege","leaderboard","rank","authorization","management","administrator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.4142 9.41422C12.7475 8.74755 12.4142 8.41422 12 8.41421C11.5858 8.41421 11.2524 8.74754 10.5858 9.41421L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20H12H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["crown","loyalty","reward","premium","vip","promotion","royalty","tier","membership","exclusive","benefit","perk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.4142 9.41422C12.7475 8.74755 12.4142 8.41422 12 8.41421C11.5858 8.41421 11.2524 8.74754 10.5858 9.41421L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20H12H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","rewards","vip","premium","member","privilege","tier","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7601 7.91003C17.6901 7.31003 16.6801 7.98003 15.0901 9.17003L14.1201 8.20003C13.3401 7.42003 12.8301 6.91003 12.0001 6.91003C11.1701 6.91003 10.6601 7.42003 9.88015 8.20003L8.91015 9.17003C7.32015 7.98003 6.31015 7.31003 5.24015 7.91003C4.10015 8.55003 4.24015 9.89003 4.46015 12.12L4.65014 13.99C4.84014 15.89 4.94014 16.94 5.80014 17.72C6.66014 18.5 7.71014 18.5 9.62014 18.5H14.3801C16.2901 18.5 17.3501 18.5 18.2001 17.72C19.0601 16.94 19.1601 15.9 19.3501 13.99L19.5298 12.12C19.7598 9.82003 19.9001 8.55003 18.7601 7.91003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 19.48H6C5.45 19.48 5 19.93 5 20.48C5 21.03 5.45 21.48 6 21.48H18C18.55 21.48 19.0098 21.05 19.0098 20.5C19.0098 19.95 18.55 19.48 18 19.48Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.53 6 13.04 5.79 13.41 5.41C13.79 5.03 14 4.53 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Crown 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","loyalty","reward","premium","vip","membership","promotion","tier","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3602 14.398L18.5468 12.5314C18.7412 10.5878 18.8384 9.61593 18.2696 9.29516C17.7008 8.97439 16.9195 9.56039 15.3568 10.7324L15 11L13.4142 9.41422C12.7475 8.74755 12.4142 8.41422 12 8.41421C11.5858 8.41421 11.2524 8.74754 10.5858 9.41421L8.99997 11L8.64321 10.7324C7.08053 9.56041 6.29919 8.9744 5.73039 9.29517C5.16159 9.61594 5.25877 10.5878 5.45313 12.5314L5.63978 14.398C5.81096 16.1099 5.89655 16.9658 6.46794 17.4829C7.03932 18 7.89952 18 9.61993 18H14.38C16.1004 18 16.9606 18 17.532 17.4829C18.1034 16.9658 18.189 16.1099 18.3602 14.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20H12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Crown-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["crown","loyalty","rewards","vip","premium","special","promotion","perks","member","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L18.4644 11.2002C18.6951 9.31282 18.8104 8.36914 18.2597 8.03377C17.709 7.69839 16.9235 8.23395 15.3525 9.30507L15 9.54545L13.6692 7.52912C12.9152 6.38664 12.5381 5.8154 12 5.8154C11.4618 5.8154 11.0848 6.38664 10.3308 7.52912L8.99997 9.54545L8.64749 9.30513C7.07649 8.23398 6.291 7.69841 5.74028 8.03379C5.18956 8.36916 5.3049 9.31285 5.53558 11.2002L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Crown-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["crown","loyalty","reward","premium","vip","membership","points","status","tier","customer","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.9998 15L18.4642 11.2002C18.6949 9.31285 18.8103 8.36917 18.2595 8.0338C17.7088 7.69842 16.9233 8.23398 15.3523 9.3051L14.9998 9.54548L13.669 7.52915C12.915 6.38667 12.5379 5.81543 11.9998 5.81543C11.4616 5.81543 11.0846 6.38667 10.3306 7.52915L8.99978 9.54548L8.6473 9.30515C7.07631 8.23401 6.29081 7.69844 5.74009 8.03382C5.18938 8.36919 5.30472 9.31287 5.53539 11.2002L5.99981 15C5.99981 16.8856 5.99981 17.8285 6.5856 18.4142C7.17139 19 8.11419 19 9.9998 19H9.99981H13.9998H13.9998C15.8854 19 16.8282 19 17.414 18.4142C17.9998 17.8285 17.9998 16.8856 17.9998 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Crown-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","royalty","loyalty","vip","premium","promotion","reward","customer","loyalty-program","rank","tier","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7498 14C10.7498 13.3096 11.3094 12.75 11.9998 12.75C12.6901 12.75 13.2498 13.3096 13.2498 14C13.2498 14.6904 12.6901 15.25 11.9998 15.25C11.3094 15.25 10.7498 14.6904 10.7498 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9997 4.81543C11.3097 4.81543 10.8308 5.20864 10.5011 5.57674C10.1954 5.9181 9.87796 6.39927 9.53378 6.92092L8.72399 8.14788C8.16767 7.77169 7.6732 7.45061 7.25057 7.24381C6.72866 6.98843 5.96158 6.72808 5.21993 7.17973C4.47828 7.63137 4.35754 8.4324 4.34491 9.0133C4.33216 9.59978 4.426 10.367 4.5334 11.2451L4.99977 15.0609L4.99977 15.0659C4.99972 15.9523 4.99968 16.7162 5.08191 17.3278C5.17004 17.9833 5.36879 18.6117 5.87845 19.1213C6.38811 19.631 7.01646 19.8298 7.67198 19.9179C8.28363 20.0001 9.04745 20.0001 9.93393 20H14.0656C14.9521 20.0001 15.7159 20.0001 16.3276 19.9179C16.9831 19.8298 17.6114 19.631 18.1211 19.1213C18.6308 18.6117 18.8295 17.9833 18.9176 17.3278C18.9999 16.7162 18.9998 15.9523 18.9998 15.0659V15.0609L19.4662 11.2451C19.5735 10.367 19.6674 9.59975 19.6546 9.01327C19.642 8.43237 19.5213 7.63136 18.7796 7.17971C18.038 6.72806 17.2709 6.9884 16.749 7.24378C16.3263 7.45059 15.8318 7.77168 15.2755 8.14789L14.4657 6.92091C14.1215 6.39926 13.804 5.9181 13.4983 5.57674C13.1687 5.20864 12.6898 4.81543 11.9997 4.81543ZM11.9998 11.25C10.481 11.25 9.24976 12.4812 9.24976 14C9.24976 15.5188 10.481 16.75 11.9998 16.75C13.5185 16.75 14.7498 15.5188 14.7498 14C14.7498 12.4812 13.5185 11.25 11.9998 11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Crown: {
        defaultColors: ["#3D4C66"],
        keywords: ["crown","royalty","loyalty","vip","premium","promotion","reward","customer","loyalty-program","rank","tier","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15L18.4644 11.2002C18.6951 9.31282 18.8104 8.36914 18.2597 8.03377C17.709 7.69839 16.9235 8.23395 15.3525 9.30507L15 9.54545L13.6692 7.52912C12.9152 6.38664 12.5381 5.8154 12 5.8154C11.4618 5.8154 11.0848 6.38664 10.3308 7.52912L8.99997 9.54545L8.64749 9.30513C7.07649 8.23398 6.291 7.69841 5.74028 8.03379C5.18956 8.36916 5.3049 9.31285 5.53558 11.2002L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "css3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["code","development","programming","technology","software","web","shield","security","protected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11H16.2857"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5C9.78946 5 14.2105 5 17 5L16.2857 11L15.5 17L11.2857 19L7 17V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "css3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["menu","options","settings","configuration","preferences","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11H16.2857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5C9.78946 5 14.2105 5 17 5L16.2857 11L15.5 17L11.2857 19L7 17V16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "css3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["development","code","website","web","programming","frontend","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6H15.8739L15.3977 10H7C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H15.1462L14.5792 16.3301L11.2821 17.8948L8 16.3631V16C8 15.4477 7.55228 15 7 15C6.44772 15 6 15.4477 6 16V17C6 17.3885 6.22504 17.7419 6.57711 17.9062L10.8628 19.9062C11.1329 20.0322 11.4452 20.0312 11.7145 19.9034L15.9287 17.9034C16.2355 17.7578 16.4474 17.4665 16.4915 17.1298L17.2759 11.1404C17.2776 11.1288 17.279 11.1172 17.2802 11.1056L17.993 5.11821C18.0268 4.83441 17.9375 4.54971 17.7477 4.336C17.558 4.12229 17.2858 4 17 4H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    css3: {
        defaultColors: ["#3D4C66"],
        keywords: ["development","code","website","web","programming","frontend","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5C9.78946 5 14.2105 5 17 5L16.2857 11M7 11H16.2857M16.2857 11L15.5 17L11.2857 19L7 17V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-Hot-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cup","coffee","tea","beverage","drink","hot","menu-item","order","add-item","add-order","customer-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.2478 9H17.0474C17.0212 9 17 9.02124 17 9.04743V14.9114C17 14.9556 17.0426 14.9872 17.0849 14.9745L19.0386 14.3884C20.2028 14.0392 21 12.9677 21 11.7522C21 10.2322 19.7678 9 18.2478 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 9H17V13.9C17 15.8641 17 16.8461 16.5579 17.5675C16.3106 17.9712 15.9712 18.3106 15.5675 18.5579C14.8461 19 13.8641 19 11.9 19H10.1C8.13594 19 7.15391 19 6.4325 18.5579C6.02884 18.3106 5.68945 17.9712 5.44208 17.5675C5 16.8461 5 15.8641 5 13.9V9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M4 19H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 6L14 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 6L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-Hot-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coffee","tea","hot-drink","beverage","cup","mug","drink","menu-item","order","hot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 3C11.5523 3 12 3.44772 12 4V6C12 6.55228 11.5523 7 11 7C10.4477 7 10 6.55228 10 6V4C10 3.44772 10.4477 3 11 3ZM15.7071 5.70711C16.0976 5.31658 16.0976 4.68342 15.7071 4.29289C15.3166 3.90237 14.6834 3.90237 14.2929 4.29289L13.2929 5.29289C12.9024 5.68342 12.9024 6.31658 13.2929 6.70711C13.6834 7.09763 14.3166 7.09763 14.7071 6.70711L15.7071 5.70711ZM5 8C4.44772 8 4 8.44772 4 9V13.9484V13.9485C3.99998 14.8893 3.99997 15.6656 4.05975 16.2944C4.12197 16.9488 4.25593 17.5458 4.58944 18.09C4.7983 18.4308 5.05637 18.7373 5.35425 19H4C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H18.5C19.0523 21 19.5 20.5523 19.5 20C19.5 19.4477 19.0523 19 18.5 19H16.6458C16.9436 18.7373 17.2017 18.4308 17.4106 18.09C17.7441 17.5458 17.878 16.9488 17.9403 16.2944C17.9554 16.1349 17.9667 15.9658 17.9752 15.787L19.5411 15.3955C20.9862 15.0342 22 13.7358 22 12.2462C22 10.4534 20.5466 9 18.7538 9H18C18 8.44772 17.5523 8 17 8H5ZM19.056 13.4552L18 13.7192V11H18.7538C19.4421 11 20 11.5579 20 12.2462C20 12.8181 19.6108 13.3165 19.056 13.4552ZM6.29289 5.70711C5.90237 5.31658 5.90237 4.68342 6.29289 4.29289C6.68342 3.90237 7.31658 3.90237 7.70711 4.29289L8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711C8.31658 7.09763 7.68342 7.09763 7.29289 6.70711L6.29289 5.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cup-Hot-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cup","hot","coffee","tea","drink","beverage","menu-item","order","hot-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 9H18.2478C19.7678 9 21 10.2322 21 11.7522V11.7522C21 12.9677 20.2028 14.0392 19.0386 14.3884L17 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 9H17V13.9C17 15.8641 17 16.8461 16.5579 17.5675C16.3106 17.9712 15.9712 18.3106 15.5675 18.5579C14.8461 19 13.8641 19 11.9 19H10.1C8.13594 19 7.15391 19 6.4325 18.5579C6.02884 18.3106 5.68945 17.9712 5.44208 17.5675C5 16.8461 5 15.8641 5 13.9V9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M4 19H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 6L14 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 6L8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-Hot": {
        defaultColors: ["#3D4C66"],
        keywords: ["cup","coffee","tea","drink","hot","beverage","menu-item","cappuccino","latte","espresso"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9H17V13.9C17 15.8641 17 16.8461 16.5579 17.5675C16.3106 17.9712 15.9712 18.3106 15.5675 18.5579C14.8461 19 13.8641 19 11.9 19H10.1C8.13594 19 7.15391 19 6.4325 18.5579C6.02884 18.3106 5.68945 17.9712 5.44208 17.5675C5 16.8461 5 15.8641 5 13.9V9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M4 19H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 9H18.2478C19.7678 9 21 10.2322 21 11.7522V11.7522C21 12.9677 20.2028 14.0392 19.0386 14.3884L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6L14 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 6L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-tea-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["coffee","tea","cup","drink","hot beverage","beverage","menu","order","hot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9H17.2478C18.7678 9 20 10.2322 20 11.7522V11.7522C20 12.9677 19.2028 14.0392 18.0386 14.3884L16 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 6L8 7M15 6L14 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V13C5 11.1144 5 10.1716 5.58579 9.58579C6.17157 9 7.11438 9 9 9H16L16.5602 14.602C16.7657 16.6567 16.8684 17.684 16.2729 18.342C15.6775 19 14.645 19 12.58 19H11H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-tea-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tea","coffee","cup","drink","beverage","hot","order","hot-drink","hot-beverage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.2478 9H16.0474C16.0212 9 16 9.02124 16 9.04743V14.9114C16 14.9556 16.0426 14.9872 16.0849 14.9745L18.0386 14.3884C19.2028 14.0392 20 12.9677 20 11.7522C20 10.2322 18.7678 9 17.2478 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 6L8 7M15 6L14 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V13C5 11.1144 5 10.1716 5.58579 9.58579C6.17157 9 7.11438 9 9 9H16L16.5602 14.602C16.7657 16.6567 16.8684 17.684 16.2729 18.342C15.6775 19 14.645 19 12.58 19H11H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Cup-tea-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cup","tea","coffee","drink","beverage","hot","menu","order","add-order","item","hot-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.66301 4.29289C6.05353 3.90237 6.6867 3.90237 7.07722 4.29289L8.07722 5.29289C8.46775 5.68342 8.46775 6.31658 8.07722 6.70711C7.6867 7.09763 7.05353 7.09763 6.66301 6.70711L5.66301 5.70711C5.27249 5.31658 5.27249 4.68342 5.66301 4.29289ZM15.0772 4.29289C15.4677 4.68342 15.4677 5.31658 15.0772 5.70711L14.0772 6.70711C13.6867 7.09763 13.0535 7.09763 12.663 6.70711C12.2725 6.31658 12.2725 5.68342 12.663 5.29289L13.663 4.29289C14.0535 3.90237 14.6867 3.90237 15.0772 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3701 3C10.9224 3 11.3701 3.44772 11.3701 4V6C11.3701 6.55228 10.9224 7 10.3701 7C9.81783 7 9.37012 6.55228 9.37012 6V4C9.37012 3.44772 9.81783 3 10.3701 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3701 8.37L15.8501 8.43C15.7201 8.32 15.5501 8.25 15.3701 8.25H8.32012C7.42012 8.25 6.67012 8.25 6.08012 8.33C5.45012 8.41 4.89012 8.6 4.43012 9.06C3.97012 9.51 3.78012 10.08 3.70012 10.71C3.62012 11.3 3.62012 12.05 3.62012 12.95V15.05C3.62012 15.95 3.62012 16.7 3.70012 17.29C3.78012 17.92 3.97012 18.48 4.43012 18.94C4.89012 19.4 5.45012 19.58 6.08012 19.67C6.67012 19.75 7.42012 19.75 8.32012 19.75H12.0101C13.0001 19.75 13.8101 19.75 14.4601 19.66C15.1401 19.57 15.7401 19.36 16.2101 18.84C16.6701 18.33 16.8201 17.7 16.8501 17.02C16.8701 16.62 16.8401 16.15 16.7901 15.62L17.8501 15.3C19.3501 14.85 20.3901 13.46 20.3901 11.89C20.3701 9.76 18.4901 8.1 16.3701 8.37ZM17.2601 13.39L16.5801 13.59L16.2601 10.39L16.6201 10.35C17.5501 10.23 18.3701 10.96 18.3701 11.9C18.3701 12.59 17.9201 13.19 17.2601 13.39Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Cup-tea": {
        defaultColors: ["#3D4C66"],
        keywords: ["tea","coffee","drink","hot","beverage","menu-item","order","cup","mug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 9H17.2478C18.7678 9 20 10.2322 20 11.7522V11.7522C20 12.9677 19.2028 14.0392 18.0386 14.3884L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 6L8 7M15 6L14 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V13C5 11.1144 5 10.1716 5.58579 9.58579C6.17157 9 7.11438 9 9 9H16L16.5602 14.602C16.7657 16.6567 16.8684 17.684 16.2729 18.342C15.6775 19 14.645 19 12.58 19H11H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "customize-dashboard-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","add","plus","customize","grid","layout","add-item","add-category","add-product","add-section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16H16M16 16V14M16 16V18M16 16H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "customize-dashboard": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","customize","add-widget","add","plus","modules","sections","layout","add-section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16H16M16 16V13M16 16V19M16 16H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "customize-dashboard-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","add","customize","modules","add-module","options","plus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 16H16M16 16V14M16 16V18M16 16H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "customize-dashboard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["add-section","add-category","add-group","grouping","sections","categories","add","plus","dashboard","customize","settings","modules","new-item","create-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0178 4.5H15.9822C15.5314 4.5 15.1677 4.49999 14.8717 4.52019C14.5673 4.54096 14.2981 4.58474 14.0433 4.6903C13.4307 4.94404 12.944 5.43072 12.6903 6.04329C12.5847 6.29814 12.541 6.56728 12.5202 6.87165C12.5 7.16765 12.5 7.53136 12.5 7.98223V8.01776C12.5 8.46863 12.5 8.83235 12.5202 9.12835C12.541 9.43272 12.5847 9.70186 12.6903 9.95671C12.944 10.5693 13.4307 11.056 14.0433 11.3097C14.2981 11.4153 14.5673 11.459 14.8717 11.4798C15.1677 11.5 15.5314 11.5 15.9822 11.5H16.0178C16.4686 11.5 16.8323 11.5 17.1283 11.4798C17.4327 11.459 17.7019 11.4153 17.9567 11.3097C18.5693 11.056 19.056 10.5693 19.3097 9.95671C19.4153 9.70186 19.459 9.43272 19.4798 9.12835C19.5 8.83234 19.5 8.46864 19.5 8.01776V7.98224C19.5 7.53136 19.5 7.16766 19.4798 6.87165C19.459 6.56728 19.4153 6.29814 19.3097 6.04329C19.056 5.43072 18.5693 4.94404 17.9567 4.6903C17.7019 4.58474 17.4327 4.54096 17.1283 4.52019C16.8323 4.49999 16.4686 4.5 16.0178 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 4.5H7.98224C7.53137 4.5 7.16766 4.49999 6.87165 4.52019C6.56728 4.54096 6.29814 4.58474 6.04329 4.6903C5.43072 4.94404 4.94404 5.43072 4.6903 6.04329C4.58474 6.29814 4.54096 6.56728 4.52019 6.87165C4.49999 7.16766 4.5 7.53136 4.5 7.98224V8.01776C4.5 8.46863 4.49999 8.83234 4.52019 9.12835C4.54096 9.43272 4.58474 9.70186 4.6903 9.95671C4.94404 10.5693 5.43072 11.056 6.04329 11.3097C6.29814 11.4153 6.56728 11.459 6.87165 11.4798C7.16764 11.5 7.53133 11.5 7.98218 11.5H8.01776C8.46861 11.5 8.83236 11.5 9.12835 11.4798C9.43272 11.459 9.70186 11.4153 9.95671 11.3097C10.5693 11.056 11.056 10.5693 11.3097 9.95671C11.4153 9.70186 11.459 9.43272 11.4798 9.12835C11.5 8.83236 11.5 8.46867 11.5 8.01782V7.98224C11.5 7.53139 11.5 7.16764 11.4798 6.87165C11.459 6.56728 11.4153 6.29814 11.3097 6.04329C11.056 5.43072 10.5693 4.94404 9.95671 4.6903C9.70186 4.58474 9.43272 4.54096 9.12835 4.52019C8.83234 4.49999 8.46863 4.5 8.01776 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 12.5H7.98224C7.53138 12.5 7.16765 12.5 6.87165 12.5202C6.56728 12.541 6.29814 12.5847 6.04329 12.6903C5.43072 12.944 4.94404 13.4307 4.6903 14.0433C4.58474 14.2981 4.54096 14.5673 4.52019 14.8717C4.49999 15.1677 4.5 15.5314 4.5 15.9822V16.0178C4.5 16.4686 4.49999 16.8323 4.52019 17.1283C4.54096 17.4327 4.58474 17.7019 4.6903 17.9567C4.94404 18.5693 5.43072 19.056 6.04329 19.3097C6.29814 19.4153 6.56728 19.459 6.87165 19.4798C7.16766 19.5 7.53136 19.5 7.98224 19.5H8.01776C8.46864 19.5 8.83234 19.5 9.12835 19.4798C9.43272 19.459 9.70186 19.4153 9.95671 19.3097C10.5693 19.056 11.056 18.5693 11.3097 17.9567C11.4153 17.7019 11.459 17.4327 11.4798 17.1283C11.5 16.8324 11.5 16.4687 11.5 16.0178V15.9822C11.5 15.5314 11.5 15.1676 11.4798 14.8717C11.459 14.5673 11.4153 14.2981 11.3097 14.0433C11.056 13.4307 10.5693 12.944 9.95671 12.6903C9.70186 12.5847 9.43272 12.541 9.12835 12.5202C8.83235 12.5 8.46862 12.5 8.01776 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 13C16.5523 13 17 13.4477 17 14V15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H17V18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18V17H14C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15H15V14C15 13.4477 15.4477 13 16 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "CV-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cv","curriculum vitae","resume","profile","customer","customer-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H9C8.44772 10 8 10.4477 8 11V13C8 13.5523 8.44772 14 9 14H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L15.857 10.4325C15.0703 12.8108 14.677 14 14 14C13.323 14 12.9297 12.8108 12.143 10.4325L12 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CV-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["CV","initials","identifier","code","customer","validation","verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H9C8.44772 10 8 10.4477 8 11V13C8 13.5523 8.44772 14 9 14H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L15.857 10.4325C15.0703 12.8108 14.677 14 14 14C13.323 14 12.9297 12.8108 12.143 10.4325L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "CV-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cv","initials","identifier","profile","customer","loyalty","account","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57534 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57528 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM7 11C7 9.89543 7.89543 9 9 9H10C10.547 9 10.9915 9.43924 10.9999 9.98427C11.0064 9.57066 11.2711 9.18784 11.686 9.05061C12.2104 8.87719 12.776 9.16167 12.9494 9.68602L13.0925 10.1185C13.4863 11.3092 13.756 12.1188 14 12.6451C14.2441 12.1188 14.5138 11.3092 14.9076 10.1185L15.0506 9.68602C15.224 9.16167 15.7897 8.87719 16.314 9.05061C16.8384 9.22403 17.1229 9.78969 16.9494 10.314L16.7831 10.8171C16.4096 11.9463 16.0991 12.8853 15.7914 13.5358C15.6341 13.8683 15.4408 14.2078 15.1825 14.4738C14.9024 14.7622 14.5066 15 14 15C13.4934 15 13.0977 14.7622 12.8175 14.4738C12.5592 14.2078 12.366 13.8683 12.2087 13.5358C11.9009 12.8853 11.5904 11.9463 11.217 10.8171L11.0506 10.314C11.0179 10.2151 11.0015 10.1146 10.9999 10.0156C10.9915 10.5607 10.5471 11 10 11H9V13H10C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H9C7.89543 15 7 14.1046 7 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    CV: {
        defaultColors: ["#3D4C66"],
        keywords: ["cv","initials","identifier","profile","customer","loyalty","account","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H9C8.44772 10 8 10.4477 8 11V13C8 13.5523 8.44772 14 9 14H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L15.857 10.4325C15.0703 12.8108 14.677 14 14 14C13.323 14 12.9297 12.8108 12.143 10.4325L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cycle-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bike","bicycle","delivery","transport","cycle","eco-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="14" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="18" cy="14" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M6 14H12M12 14L15 9M12 14L8 9M15 9H8M15 9L18 14M15 9V8C15 7.44772 14.5523 7 14 7V7M8 9V7M8 7H7M8 7H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cycle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["bicycle","cycle","delivery","transport","bike-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="6"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="18"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14H12M12 14L15 9M12 14L8 9M15 9H8M15 9L18 14M15 9V8C15 7.44772 14.5523 7 14 7V7M8 9V7M8 7H7M8 7H9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "cycle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bicycle","bike","delivery","transport","shipping","courier","transportation","delivery-bike"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6C6 5.44772 6.44772 5 7 5H9C9.55228 5 10 5.44772 10 6C10 6.55228 9.55228 7 9 7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5C15.1046 5 16 5.89543 16 7V7.76393L17.162 10.0879C17.4322 10.0303 17.7126 10 18 10C20.2091 10 22 11.7909 22 14C22 16.2091 20.2091 18 18 18C15.7909 18 14 16.2091 14 14C14 12.7961 14.5319 11.7164 15.3735 10.9831L15 10.2361L12.8944 14.4472C12.725 14.786 12.3788 15 12 15H9.87398C9.42994 16.7252 7.86384 18 6 18C3.79086 18 2 16.2091 2 14C2 11.7909 3.79086 10 6 10C7.29796 10 8.45154 10.6182 9.18232 11.5763L7.16795 8.5547C7.05844 8.39043 7 8.19742 7 8V7C6.44772 7 6 6.55228 6 6ZM9.86852 9L11.8762 12.0115L13.382 9H9.86852ZM10.1315 13L9.46523 12.0006C9.6441 12.31 9.78273 12.6455 9.87398 13H10.1315ZM7.73244 13C7.38663 12.4022 6.74028 12 6 12C4.89543 12 4 12.8954 4 14C4 15.1046 4.89543 16 6 16C6.74028 16 7.38663 15.5978 7.73244 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H7.73244ZM16.3309 12.8978C16.1218 13.2138 16 13.5927 16 14C16 15.1046 16.8954 16 18 16C19.1046 16 20 15.1046 20 14C20 12.9357 19.1686 12.0655 18.1198 12.0035L18.8944 13.5528C19.1414 14.0468 18.9412 14.6474 18.4472 14.8944C17.9532 15.1414 17.3526 14.9412 17.1056 14.4472L16.3309 12.8978Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    cycle: {
        defaultColors: ["#3D4C66"],
        keywords: ["bicycle","bike","delivery","transport","shipping","courier","transportation","delivery-bike"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 14H12M12 14L15 9M12 14L8 9M15 9H8M15 9L18 14M15 9V8C15 7.44772 14.5523 7 14 7V7M8 9V7M8 7H7M8 7H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "D-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["D","discount","delete","remove","day","denomination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5H10C13.866 5 17 8.13401 17 12V12C17 15.866 13.866 19 10 19H7V5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "D-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["D","discount","description","details","data","draft"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5H10C13.866 5 17 8.13401 17 12V12C17 15.866 13.866 19 10 19H7V5Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "D-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["D","discount","deal","delete","decline","draft","data","denomination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 4H10C14.4183 4 18 7.58172 18 12C18 16.4183 14.4183 20 10 20H6V4ZM8 6V18H10C13.3137 18 16 15.3137 16 12C16 8.68629 13.3137 6 10 6H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    D: {
        defaultColors: ["#3D4C66"],
        keywords: ["D","discount","deal","delete","decline","draft","data","denomination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5H10C13.866 5 17 8.13401 17 12V12C17 15.866 13.866 19 10 19H7V5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dashboard","layout","grid","overview","summary","reports","statistics","data","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 11H12H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","overview","summary","analytics","statistics","reporting","data","key-performance-indicators","kpis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13C5 12.0572 5 11.5858 5.29289 11.2929C5.58579 11 6.05719 11 7 11H17C17.9428 11 18.4142 11 18.7071 11.2929C19 11.5858 19 12.0572 19 13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 19V11" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "Dashboard-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","grid","layout","overview","summary","interface","section","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11875C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.4587 20 9.57531 20 10.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.4587 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C8.4587 3.99994 9.57531 3.99997 10.9294 4ZM18 12L13 12V18C14.4425 18 15.4238 17.9979 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9979 15.4238 18 14.4425 18 13V12ZM11 12V18C9.55752 18 8.57625 17.9979 7.84143 17.8991C7.13538 17.8042 6.80836 17.6368 6.58579 17.4142C6.36322 17.1916 6.19585 16.8646 6.10092 16.1586C6.00213 15.4238 6 14.4425 6 13V12H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","summary","overview","analytics","reports","statistics","grid","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H12M12 10V5M12 10V19M19 14L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Dashboard-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dashboard","layout","grid","sections","overview","summary","reports","analytics","modules","widgets","arrangement","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10H12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L12 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","analytics","summary","overview","reporting","statistics","metrics","status","performance","key-performance-indicators","kpi","insights","sales-overview","transaction-overview","inventory-overview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12H6.75C6.04777 12 5.69665 12 5.44443 11.8315C5.33524 11.7585 5.24149 11.6648 5.16853 11.5556C5 11.3033 5 10.9522 5 10.25C5 8.14331 5 7.08996 5.50559 6.33329C5.72447 6.00572 6.00572 5.72447 6.33329 5.50559C7.08996 5 8.14331 5 10.25 5H12V10C12 10.9428 12 11.4142 11.7071 11.7071C11.4142 12 10.9428 12 10 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L17.25 12C17.9522 12 18.3033 12 18.5556 12.1685C18.6648 12.2415 18.7585 12.3352 18.8315 12.4444C19 12.6967 19 13.0478 19 13.75C19 15.8567 19 16.91 18.4944 17.6667C18.2755 17.9943 17.9943 18.2755 17.6667 18.4944C16.91 19 15.8567 19 13.75 19L12 19L12 14C12 13.0572 12 12.5858 12.2929 12.2929C12.5858 12 13.0572 12 14 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","blocks","grid","summary","overview","analytics","reports","statistics","modules","sales-data","performance","key-metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11875C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.4587 20 9.57531 20 10.9294V13.0706C20 13.3751 20 13.6675 19.9987 13.948C19.9996 13.9653 20 13.9826 20 14C20 14.0212 19.9993 14.0423 19.998 14.0631C19.9923 14.9807 19.9697 15.7674 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99999 10.625 3.99999 10.3325 4.00133 10.052C4.00045 10.0348 4 10.0174 4 10C4 9.97879 4.00066 9.95773 4.00196 9.93685C4.00773 9.0193 4.03033 8.23264 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C8.4587 3.99994 9.57531 3.99997 10.9294 4ZM6 11V13C6 14.4425 6.00213 15.4238 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18V11H6ZM13 6V13L18 13V11C18 9.55752 17.9979 8.57625 17.8991 7.84143C17.8042 7.13538 17.6368 6.80836 17.4142 6.58579C17.1916 6.36322 16.8646 6.19585 16.1586 6.10092C15.4238 6.00213 14.4425 6 13 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","grid","layout","overview","summary","statistics","reports","analytics","modules","sections","widget","interface","gui"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10H12M12 10V5M12 10V19M19 14L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Dashboard-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dashboard","layout","grid","structure","organization","summary","reports","analytics","overview","arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 14L12 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 5V10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Dashboard-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","square","layout","arrangement","overview","summary","analytics","metrics","reports","data","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10H6.25C6.01767 10 5.90151 10 5.80491 9.98079C5.40822 9.90188 5.09812 9.59178 5.01921 9.19509C5 9.09849 5 8.98233 5 8.75C5 8.05302 5 7.70453 5.05764 7.41473C5.29436 6.22466 6.22466 5.29436 7.41473 5.05764C7.70453 5 8.05302 5 8.75 5H12V8C12 8.94281 12 9.41421 11.7071 9.70711C11.4142 10 10.9428 10 10 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L17.75 14C17.9823 14 18.0985 14 18.1951 14.0192C18.5918 14.0981 18.9019 14.4082 18.9808 14.8049C19 14.9015 19 15.0177 19 15.25C19 15.947 19 16.2955 18.9424 16.5853C18.7056 17.7753 17.7753 18.7056 16.5853 18.9424C16.2955 19 15.947 19 15.25 19L12 19L12 16C12 15.0572 12 14.5858 12.2929 14.2929C12.5858 14 13.0572 14 14 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 5V10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Dashboard-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["apps","menu","grid","dashboard","categories","sections","modules","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","tiles","summary","overview","analytics","reporting","sales data","performance","metrics","key indicators","at-a-glance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11875C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.4587 20 9.57531 20 10.9294V13.0706C20 13.3751 20 13.6675 19.9987 13.948C19.9996 13.9653 20 13.9826 20 14C20 14.0212 19.9993 14.0423 19.998 14.0631C19.9923 14.9807 19.9697 15.7674 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99999 10.625 3.99999 10.3325 4.00133 10.052C4.00045 10.0348 4 10.0174 4 10C4 9.97879 4.00066 9.95773 4.00196 9.93685C4.00773 9.0193 4.03033 8.23264 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C8.4587 3.99994 9.57531 3.99997 10.9294 4ZM11 10.9294H6.01774C6.03168 10.4806 6.05655 8.17144 6.10092 7.84143C6.19585 7.13538 6.36322 6.80836 6.58579 6.58579C6.80836 6.36322 7.13538 6.19585 7.84143 6.10092C8.57625 6.00213 9.55752 6 11 6V10.9294ZM18 13.0706H13.0706L13 18C14.4425 18 15.4238 17.9979 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9435 15.8286 17.9861 13.5194 18 13.0706Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","summary","overview","analytics","reports","status","metrics","performance","key-metrics","sales-overview","store-status","manager","management","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.5 11H6.5C6.03406 11 5.80109 11 5.61732 10.9239C5.37229 10.8224 5.17761 10.6277 5.07612 10.3827C5 10.1989 5 9.96594 5 9.5C5 8.10218 5 7.40326 5.22836 6.85195C5.53284 6.11687 6.11687 5.53284 6.85195 5.22836C7.40326 5 8.10218 5 9.5 5H14.5C15.8978 5 16.5967 5 17.1481 5.22836C17.8831 5.53284 18.4672 6.11687 18.7716 6.85195C19 7.40326 19 8.10218 19 9.5C19 9.96594 19 10.1989 18.9239 10.3827C18.8224 10.6277 18.6277 10.8224 18.3827 10.9239C18.1989 11 17.9659 11 17.5 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "Dashboard-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","squares","grid","menu","categories","tiles","apps","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-22": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","modules","menu","options","categories","sections","overview","summary","main-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","menu","categories","options","grid","tiles","modules","apps","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0178 4.5H15.9822C15.5314 4.5 15.1677 4.49999 14.8717 4.52019C14.5673 4.54096 14.2981 4.58474 14.0433 4.6903C13.4307 4.94404 12.944 5.43072 12.6903 6.04329C12.5847 6.29814 12.541 6.56728 12.5202 6.87165C12.5 7.16765 12.5 7.53134 12.5 7.98221V8.01776C12.5 8.46862 12.5 8.83235 12.5202 9.12835C12.541 9.43272 12.5847 9.70186 12.6903 9.95671C12.944 10.5693 13.4307 11.056 14.0433 11.3097C14.2981 11.4153 14.5673 11.459 14.8717 11.4798C15.1676 11.5 15.5313 11.5 15.9822 11.5H16.0178C16.4686 11.5 16.8324 11.5 17.1283 11.4798C17.4327 11.459 17.7019 11.4153 17.9567 11.3097C18.5693 11.056 19.056 10.5693 19.3097 9.95671C19.4153 9.70186 19.459 9.43272 19.4798 9.12835C19.5 8.83234 19.5 8.46864 19.5 8.01776V7.98224C19.5 7.53136 19.5 7.16766 19.4798 6.87165C19.459 6.56728 19.4153 6.29814 19.3097 6.04329C19.056 5.43072 18.5693 4.94404 17.9567 4.6903C17.7019 4.58474 17.4327 4.54096 17.1283 4.52019C16.8323 4.49999 16.4686 4.5 16.0178 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 4.5H7.98224C7.53137 4.5 7.16766 4.49999 6.87165 4.52019C6.56728 4.54096 6.29814 4.58474 6.04329 4.6903C5.43072 4.94404 4.94404 5.43072 4.6903 6.04329C4.58474 6.29814 4.54096 6.56728 4.52019 6.87165C4.49999 7.16766 4.5 7.53136 4.5 7.98224V8.01776C4.5 8.46863 4.49999 8.83234 4.52019 9.12835C4.54096 9.43272 4.58474 9.70186 4.6903 9.95671C4.94404 10.5693 5.43072 11.056 6.04329 11.3097C6.29814 11.4153 6.56728 11.459 6.87165 11.4798C7.16764 11.5 7.53132 11.5 7.98216 11.5H8.01776C8.4686 11.5 8.83236 11.5 9.12835 11.4798C9.43272 11.459 9.70186 11.4153 9.95671 11.3097C10.5693 11.056 11.056 10.5693 11.3097 9.95671C11.4153 9.70186 11.459 9.43272 11.4798 9.12835C11.5 8.83236 11.5 8.46868 11.5 8.01784V7.98224C11.5 7.5314 11.5 7.16764 11.4798 6.87165C11.459 6.56728 11.4153 6.29814 11.3097 6.04329C11.056 5.43072 10.5693 4.94404 9.95671 4.6903C9.70186 4.58474 9.43272 4.54096 9.12835 4.52019C8.83234 4.49999 8.46863 4.5 8.01776 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 12.5H7.98224C7.53139 12.5 7.16765 12.5 6.87165 12.5202C6.56728 12.541 6.29814 12.5847 6.04329 12.6903C5.43072 12.944 4.94404 13.4307 4.6903 14.0433C4.58474 14.2981 4.54096 14.5673 4.52019 14.8717C4.49999 15.1677 4.5 15.5314 4.5 15.9822V16.0178C4.5 16.4686 4.49999 16.8323 4.52019 17.1283C4.54096 17.4327 4.58474 17.7019 4.6903 17.9567C4.94404 18.5693 5.43072 19.056 6.04329 19.3097C6.29814 19.4153 6.56728 19.459 6.87165 19.4798C7.16766 19.5 7.53136 19.5 7.98224 19.5H8.01776C8.46864 19.5 8.83234 19.5 9.12835 19.4798C9.43272 19.459 9.70186 19.4153 9.95671 19.3097C10.5693 19.056 11.056 18.5693 11.3097 17.9567C11.4153 17.7019 11.459 17.4327 11.4798 17.1283C11.5 16.8324 11.5 16.4687 11.5 16.0178V15.9822C11.5 15.5314 11.5 15.1676 11.4798 14.8717C11.459 14.5673 11.4153 14.2981 11.3097 14.0433C11.056 13.4307 10.5693 12.944 9.95671 12.6903C9.70186 12.5847 9.43272 12.541 9.12835 12.5202C8.83236 12.5 8.46861 12.5 8.01776 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 12.5C14.067 12.5 12.5 14.067 12.5 16C12.5 17.933 14.067 19.5 16 19.5C17.933 19.5 19.5 17.933 19.5 16C19.5 14.067 17.933 12.5 16 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","grid","menu","apps","categories","sections","modules","shortcuts","main-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 13.1522C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 13.1522C18.2554 13.3552 18.6448 13.7446 18.8478 14.2346C19 14.6022 19 15.0681 19 16C19 16.9319 19 17.3978 18.8478 17.7654C18.6448 18.2554 18.2554 18.6448 17.7654 18.8478C17.3978 19 16.9319 19 16 19C15.0681 19 14.6022 19 14.2346 18.8478C13.7446 18.6448 13.3552 18.2554 13.1522 17.7654C13 17.3978 13 16.9319 13 16C13 15.0681 13 14.6022 13.1522 14.2346C13.3552 13.7446 13.7446 13.3552 14.2346 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","grid","squares","modules","categories","sections","options","all-apps","menu","tiles"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 13.1522C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 13.1522C18.2554 13.3552 18.6448 13.7446 18.8478 14.2346C19 14.6022 19 15.0681 19 16C19 16.9319 19 17.3978 18.8478 17.7654C18.6448 18.2554 18.2554 18.6448 17.7654 18.8478C17.3978 19 16.9319 19 16 19C15.0681 19 14.6022 19 14.2346 18.8478C13.7446 18.6448 13.3552 18.2554 13.1522 17.7654C13 17.3978 13 16.9319 13 16C13 15.0681 13 14.6022 13.1522 14.2346C13.3552 13.7446 13.7446 13.3552 14.2346 13.1522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-26": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","menu","grid","options","modules","launcher","applications","app-launcher","overview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.23463 5.15224C6.60218 5 7.06812 5 8 5C8.93188 5 9.39782 5 9.76537 5.15224C10.2554 5.35523 10.6448 5.74458 10.8478 6.23463C11 6.60218 11 7.06812 11 8C11 8.93188 11 9.39782 10.8478 9.76537C10.6448 10.2554 10.2554 10.6448 9.76537 10.8478C9.39782 11 8.93188 11 8 11C7.06812 11 6.60218 11 6.23463 10.8478C5.74458 10.6448 5.35523 10.2554 5.15224 9.76537C5 9.39782 5 8.93188 5 8C5 7.06812 5 6.60218 5.15224 6.23463C5.35523 5.74458 5.74458 5.35523 6.23463 5.15224Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.23463 13.1522C6.60218 13 7.06812 13 8 13C8.93188 13 9.39782 13 9.76537 13.1522C10.2554 13.3552 10.6448 13.7446 10.8478 14.2346C11 14.6022 11 15.0681 11 16C11 16.9319 11 17.3978 10.8478 17.7654C10.6448 18.2554 10.2554 18.6448 9.76537 18.8478C9.39782 19 8.93188 19 8 19C7.06812 19 6.60218 19 6.23463 18.8478C5.74458 18.6448 5.35523 18.2554 5.15224 17.7654C5 17.3978 5 16.9319 5 16C5 15.0681 5 14.6022 5.15224 14.2346C5.35523 13.7446 5.74458 13.3552 6.23463 13.1522Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 5.15224C14.6022 5 15.0681 5 16 5C16.9319 5 17.3978 5 17.7654 5.15224C18.2554 5.35523 18.6448 5.74458 18.8478 6.23463C19 6.60218 19 7.06812 19 8C19 8.93188 19 9.39782 18.8478 9.76537C18.6448 10.2554 18.2554 10.6448 17.7654 10.8478C17.3978 11 16.9319 11 16 11C15.0681 11 14.6022 11 14.2346 10.8478C13.7446 10.6448 13.3552 10.2554 13.1522 9.76537C13 9.39782 13 8.93188 13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.2346 13.1522C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 13.1522C18.2554 13.3552 18.6448 13.7446 18.8478 14.2346C19 14.6022 19 15.0681 19 16C19 16.9319 19 17.3978 18.8478 17.7654C18.6448 18.2554 18.2554 18.6448 17.7654 18.8478C17.3978 19 16.9319 19 16 19C15.0681 19 14.6022 19 14.2346 18.8478C13.7446 18.6448 13.3552 18.2554 13.1522 17.7654C13 17.3978 13 16.9319 13 16C13 15.0681 13 14.6022 13.1522 14.2346C13.3552 13.7446 13.7446 13.3552 14.2346 13.1522Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","modules","grid","shortcuts","main-menu","applications","launcher","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0178 4.5H15.9822C15.5314 4.5 15.1677 4.49999 14.8717 4.52019C14.5673 4.54096 14.2981 4.58474 14.0433 4.6903C13.4307 4.94404 12.944 5.43072 12.6903 6.04329C12.5847 6.29814 12.541 6.56728 12.5202 6.87165C12.5 7.16765 12.5 7.53134 12.5 7.98221V8.01776C12.5 8.46862 12.5 8.83235 12.5202 9.12835C12.541 9.43272 12.5847 9.70186 12.6903 9.95671C12.944 10.5693 13.4307 11.056 14.0433 11.3097C14.2981 11.4153 14.5673 11.459 14.8717 11.4798C15.1676 11.5 15.5313 11.5 15.9822 11.5H16.0178C16.4686 11.5 16.8324 11.5 17.1283 11.4798C17.4327 11.459 17.7019 11.4153 17.9567 11.3097C18.5693 11.056 19.056 10.5693 19.3097 9.95671C19.4153 9.70186 19.459 9.43272 19.4798 9.12835C19.5 8.83234 19.5 8.46864 19.5 8.01776V7.98224C19.5 7.53136 19.5 7.16766 19.4798 6.87165C19.459 6.56728 19.4153 6.29814 19.3097 6.04329C19.056 5.43072 18.5693 4.94404 17.9567 4.6903C17.7019 4.58474 17.4327 4.54096 17.1283 4.52019C16.8323 4.49999 16.4686 4.5 16.0178 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 4.5H7.98224C7.53137 4.5 7.16766 4.49999 6.87165 4.52019C6.56728 4.54096 6.29814 4.58474 6.04329 4.6903C5.43072 4.94404 4.94404 5.43072 4.6903 6.04329C4.58474 6.29814 4.54096 6.56728 4.52019 6.87165C4.49999 7.16766 4.5 7.53136 4.5 7.98224V8.01776C4.5 8.46863 4.49999 8.83234 4.52019 9.12835C4.54096 9.43272 4.58474 9.70186 4.6903 9.95671C4.94404 10.5693 5.43072 11.056 6.04329 11.3097C6.29814 11.4153 6.56728 11.459 6.87165 11.4798C7.16764 11.5 7.53132 11.5 7.98216 11.5H8.01776C8.4686 11.5 8.83236 11.5 9.12835 11.4798C9.43272 11.459 9.70186 11.4153 9.95671 11.3097C10.5693 11.056 11.056 10.5693 11.3097 9.95671C11.4153 9.70186 11.459 9.43272 11.4798 9.12835C11.5 8.83236 11.5 8.46868 11.5 8.01784V7.98224C11.5 7.5314 11.5 7.16764 11.4798 6.87165C11.459 6.56728 11.4153 6.29814 11.3097 6.04329C11.056 5.43072 10.5693 4.94404 9.95671 4.6903C9.70186 4.58474 9.43272 4.54096 9.12835 4.52019C8.83234 4.49999 8.46863 4.5 8.01776 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.01776 12.5H7.98224C7.53139 12.5 7.16765 12.5 6.87165 12.5202C6.56728 12.541 6.29814 12.5847 6.04329 12.6903C5.43072 12.944 4.94404 13.4307 4.6903 14.0433C4.58474 14.2981 4.54096 14.5673 4.52019 14.8717C4.49999 15.1677 4.5 15.5314 4.5 15.9822V16.0178C4.5 16.4686 4.49999 16.8323 4.52019 17.1283C4.54096 17.4327 4.58474 17.7019 4.6903 17.9567C4.94404 18.5693 5.43072 19.056 6.04329 19.3097C6.29814 19.4153 6.56728 19.459 6.87165 19.4798C7.16766 19.5 7.53136 19.5 7.98224 19.5H8.01776C8.46864 19.5 8.83234 19.5 9.12835 19.4798C9.43272 19.459 9.70186 19.4153 9.95671 19.3097C10.5693 19.056 11.056 18.5693 11.3097 17.9567C11.4153 17.7019 11.459 17.4327 11.4798 17.1283C11.5 16.8324 11.5 16.4687 11.5 16.0178V15.9822C11.5 15.5314 11.5 15.1676 11.4798 14.8717C11.459 14.5673 11.4153 14.2981 11.3097 14.0433C11.056 13.4307 10.5693 12.944 9.95671 12.6903C9.70186 12.5847 9.43272 12.541 9.12835 12.5202C8.83236 12.5 8.46861 12.5 8.01776 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0178 12.5H15.9822C15.5314 12.5 15.1677 12.5 14.8717 12.5202C14.5673 12.541 14.2981 12.5847 14.0433 12.6903C13.4307 12.944 12.944 13.4307 12.6903 14.0433C12.5847 14.2981 12.541 14.5673 12.5202 14.8717C12.5 15.1677 12.5 15.5314 12.5 15.9822V16.0178C12.5 16.4686 12.5 16.8323 12.5202 17.1283C12.541 17.4327 12.5847 17.7019 12.6903 17.9567C12.944 18.5693 13.4307 19.056 14.0433 19.3097C14.2981 19.4153 14.5673 19.459 14.8717 19.4798C15.1677 19.5 15.5314 19.5 15.9822 19.5H16.0178C16.4686 19.5 16.8323 19.5 17.1283 19.4798C17.4327 19.459 17.7019 19.4153 17.9567 19.3097C18.5693 19.056 19.056 18.5693 19.3097 17.9567C19.4153 17.7019 19.459 17.4327 19.4798 17.1283C19.5 16.8323 19.5 16.4686 19.5 16.0178V15.9822C19.5 15.5314 19.5 15.1677 19.4798 14.8717C19.459 14.5673 19.4153 14.2981 19.3097 14.0433C19.056 13.4307 18.5693 12.944 17.9567 12.6903C17.7019 12.5847 17.4327 12.541 17.1283 12.5202C16.8323 12.5 16.4686 12.5 16.0178 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","grid","menu","options","modules","categories","sections","layout","tiles"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V8C19 7.06812 19 6.60218 18.8478 6.23463C18.6448 5.74458 18.2554 5.35523 17.7654 5.15224C17.3978 5 16.9319 5 16 5C15.0681 5 14.6022 5 14.2346 5.15224C13.7446 5.35523 13.3552 5.74458 13.1522 6.23463C13 6.60218 13 7.06812 13 8V10C13 10.9319 13 11.3978 13.1522 11.7654C13.3552 12.2554 13.7446 12.6448 14.2346 12.8478C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 12.8478C18.2554 12.6448 18.6448 12.2554 18.8478 11.7654C19 11.3978 19 10.9319 19 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 15H15C14.0572 15 13.5858 15 13.2929 15.2929C13 15.5858 13 16.0572 13 17C13 17.9428 13 18.4142 13.2929 18.7071C13.5858 19 14.0572 19 15 19H17C17.9428 19 18.4142 19 18.7071 18.7071C19 18.4142 19 17.9428 19 17C19 16.0572 19 15.5858 18.7071 15.2929C18.4142 15 17.9428 15 17 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14L5 16C5 16.9319 5 17.3978 5.15224 17.7654C5.35523 18.2554 5.74458 18.6448 6.23463 18.8478C6.60218 19 7.06812 19 8 19C8.93188 19 9.39782 19 9.76537 18.8478C10.2554 18.6448 10.6448 18.2554 10.8478 17.7654C11 17.3978 11 16.9319 11 16L11 14C11 13.0681 11 12.6022 10.8478 12.2346C10.6448 11.7446 10.2554 11.3552 9.76537 11.1522C9.39782 11 8.93188 11 8 11C7.06812 11 6.60217 11 6.23463 11.1522C5.74458 11.3552 5.35523 11.7446 5.15224 12.2346C5 12.6022 5 13.0681 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 9L9 9C9.94281 9 10.4142 9 10.7071 8.70711C11 8.41421 11 7.94281 11 7C11 6.05719 11 5.58579 10.7071 5.29289C10.4142 5 9.94281 5 9 5L7 5C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7C5 7.94281 5 8.41421 5.29289 8.70711C5.58579 9 6.05719 9 7 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-29": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","menu","grid","layout","options","modules","application","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V8C19 7.06812 19 6.60218 18.8478 6.23463C18.6448 5.74458 18.2554 5.35523 17.7654 5.15224C17.3978 5 16.9319 5 16 5C15.0681 5 14.6022 5 14.2346 5.15224C13.7446 5.35523 13.3552 5.74458 13.1522 6.23463C13 6.60218 13 7.06812 13 8V10C13 10.9319 13 11.3978 13.1522 11.7654C13.3552 12.2554 13.7446 12.6448 14.2346 12.8478C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 12.8478C18.2554 12.6448 18.6448 12.2554 18.8478 11.7654C19 11.3978 19 10.9319 19 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 15H15C14.0572 15 13.5858 15 13.2929 15.2929C13 15.5858 13 16.0572 13 17C13 17.9428 13 18.4142 13.2929 18.7071C13.5858 19 14.0572 19 15 19H17C17.9428 19 18.4142 19 18.7071 18.7071C19 18.4142 19 17.9428 19 17C19 16.0572 19 15.5858 18.7071 15.2929C18.4142 15 17.9428 15 17 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14L5 16C5 16.9319 5 17.3978 5.15224 17.7654C5.35523 18.2554 5.74458 18.6448 6.23463 18.8478C6.60218 19 7.06812 19 8 19C8.93188 19 9.39782 19 9.76537 18.8478C10.2554 18.6448 10.6448 18.2554 10.8478 17.7654C11 17.3978 11 16.9319 11 16L11 14C11 13.0681 11 12.6022 10.8478 12.2346C10.6448 11.7446 10.2554 11.3552 9.76537 11.1522C9.39782 11 8.93188 11 8 11C7.06812 11 6.60217 11 6.23463 11.1522C5.74458 11.3552 5.35523 11.7446 5.15224 12.2346C5 12.6022 5 13.0681 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 9L9 9C9.94281 9 10.4142 9 10.7071 8.70711C11 8.41421 11 7.94281 11 7C11 6.05719 11 5.58579 10.7071 5.29289C10.4142 5 9.94281 5 9 5L7 5C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7C5 7.94281 5 8.41421 5.29289 8.70711C5.58579 9 6.05719 9 7 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","modules","overview","summary","analytics","reports","monitoring","statistics","sales-data","business-intelligence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4H10.9294ZM11 6C9.55752 6 8.57626 6.00213 7.84144 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84144C6.02686 8.3923 6.00713 10.0817 6.00189 11H11L11 6ZM17.9981 11H13L13 6C14.4425 6 15.4238 6.00213 16.1586 6.10092C16.8646 6.19585 17.1916 6.36322 17.4142 6.58579C17.6368 6.80836 17.8042 7.13538 17.8991 7.84144C17.9731 8.3923 17.9929 10.0817 17.9981 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-30": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","modules","sections","menu","overview","summary","navigation","layout","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V8C19 7.06812 19 6.60218 18.8478 6.23463C18.6448 5.74458 18.2554 5.35523 17.7654 5.15224C17.3978 5 16.9319 5 16 5C15.0681 5 14.6022 5 14.2346 5.15224C13.7446 5.35523 13.3552 5.74458 13.1522 6.23463C13 6.60218 13 7.06812 13 8V10C13 10.9319 13 11.3978 13.1522 11.7654C13.3552 12.2554 13.7446 12.6448 14.2346 12.8478C14.6022 13 15.0681 13 16 13C16.9319 13 17.3978 13 17.7654 12.8478C18.2554 12.6448 18.6448 12.2554 18.8478 11.7654C19 11.3978 19 10.9319 19 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 15H15C14.0572 15 13.5858 15 13.2929 15.2929C13 15.5858 13 16.0572 13 17C13 17.9428 13 18.4142 13.2929 18.7071C13.5858 19 14.0572 19 15 19H17C17.9428 19 18.4142 19 18.7071 18.7071C19 18.4142 19 17.9428 19 17C19 16.0572 19 15.5858 18.7071 15.2929C18.4142 15 17.9428 15 17 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14L5 16C5 16.9319 5 17.3978 5.15224 17.7654C5.35523 18.2554 5.74458 18.6448 6.23463 18.8478C6.60218 19 7.06812 19 8 19C8.93188 19 9.39782 19 9.76537 18.8478C10.2554 18.6448 10.6448 18.2554 10.8478 17.7654C11 17.3978 11 16.9319 11 16L11 14C11 13.0681 11 12.6022 10.8478 12.2346C10.6448 11.7446 10.2554 11.3552 9.76537 11.1522C9.39782 11 8.93188 11 8 11C7.06812 11 6.60217 11 6.23463 11.1522C5.74458 11.3552 5.35523 11.7446 5.15224 12.2346C5 12.6022 5 13.0681 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 9L9 9C9.94281 9 10.4142 9 10.7071 8.70711C11 8.41421 11 7.94281 11 7C11 6.05719 11 5.58579 10.7071 5.29289C10.4142 5 9.94281 5 9 5L7 5C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7C5 7.94281 5 8.41421 5.29289 8.70711C5.58579 9 6.05719 9 7 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","grid","layout","modules","sections","overview","summary","sales-overview","reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.03292 9.5C9.47616 9.50003 9.85807 9.50005 10.1639 9.45893C10.4917 9.41487 10.8058 9.31549 11.0607 9.06066C11.3155 8.80583 11.4149 8.49166 11.4589 8.1639C11.5001 7.85807 11.5 7.47616 11.5 7.03292V6.96709C11.5 6.52384 11.5001 6.14194 11.4589 5.83611C11.4149 5.50835 11.3155 5.19417 11.0607 4.93934C10.8058 4.68451 10.4917 4.58514 10.1639 4.54107C9.85808 4.49996 9.47618 4.49998 9.03296 4.5H6.96709C6.52386 4.49998 6.14193 4.49996 5.83611 4.54107C5.50835 4.58514 5.19417 4.68451 4.93934 4.93934C4.68451 5.19417 4.58514 5.50835 4.54107 5.83611C4.49996 6.14193 4.49998 6.52383 4.5 6.96706V7.03292C4.49998 7.47615 4.49996 7.85808 4.54107 8.1639C4.58514 8.49166 4.68451 8.80583 4.93934 9.06066C5.19417 9.3155 5.50835 9.41487 5.83611 9.45893C6.14194 9.50005 6.52384 9.50003 6.96709 9.5H9.03292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0178 4.50001H15.9822C15.5314 4.5 15.1677 4.5 14.8717 4.5202C14.5673 4.54096 14.2981 4.58474 14.0433 4.69031C13.4307 4.94404 12.944 5.43073 12.6903 6.0433C12.5847 6.29815 12.541 6.56729 12.5202 6.87166C12.5 7.16766 12.5 7.53137 12.5 7.98225V10.0178C12.5 10.4686 12.5 10.8323 12.5202 11.1284C12.541 11.4327 12.5847 11.7019 12.6903 11.9567C12.944 12.5693 13.4307 13.056 14.0433 13.3097C14.2981 13.4153 14.5673 13.459 14.8717 13.4798C15.1677 13.5 15.5314 13.5 15.9822 13.5H16.0178C16.4686 13.5 16.8323 13.5 17.1284 13.4798C17.4327 13.459 17.7019 13.4153 17.9567 13.3097C18.5693 13.056 19.056 12.5693 19.3097 11.9567C19.4153 11.7019 19.459 11.4327 19.4798 11.1284C19.5 10.8324 19.5 10.4687 19.5 10.0179V7.98224C19.5 7.53141 19.5 7.16764 19.4798 6.87166C19.459 6.56729 19.4153 6.29815 19.3097 6.0433C19.056 5.43073 18.5693 4.94404 17.9567 4.69031C17.7019 4.58474 17.4327 4.54096 17.1284 4.5202C16.8323 4.5 16.4686 4.5 16.0178 4.50001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.9671 14.5C14.5238 14.5 14.1419 14.5 13.8361 14.5411C13.5084 14.5851 13.1942 14.6845 12.9393 14.9393C12.6845 15.1942 12.5851 15.5084 12.5411 15.8361C12.5 16.1419 12.5 16.5238 12.5 16.9671V17.0329C12.5 17.4762 12.5 17.8581 12.5411 18.1639C12.5851 18.4917 12.6845 18.8058 12.9393 19.0607C13.1942 19.3155 13.5084 19.4149 13.8361 19.4589C14.1419 19.5001 14.5238 19.5 14.9671 19.5H17.0329C17.4762 19.5 17.8581 19.5001 18.1639 19.4589C18.4917 19.4149 18.8058 19.3155 19.0607 19.0607C19.3155 18.8058 19.4149 18.4917 19.4589 18.1639C19.5001 17.8581 19.5 17.4762 19.5 17.0329V16.9671C19.5 16.5238 19.5001 16.1419 19.4589 15.8361C19.4149 15.5084 19.3155 15.1942 19.0607 14.9393C18.8058 14.6845 18.4917 14.5851 18.1639 14.5411C17.8581 14.5 17.4762 14.5 17.0329 14.5H14.9671Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.98225 19.5H8.01776C8.46864 19.5 8.83235 19.5 9.12835 19.4798C9.43272 19.459 9.70186 19.4153 9.95671 19.3097C10.5693 19.056 11.056 18.5693 11.3097 17.9567C11.4153 17.7019 11.459 17.4327 11.4798 17.1284C11.5 16.8323 11.5 16.4686 11.5 16.0178V13.9822C11.5 13.5314 11.5 13.1677 11.4798 12.8717C11.459 12.5673 11.4153 12.2981 11.3097 12.0433C11.056 11.4307 10.5693 10.944 9.95671 10.6903C9.70186 10.5847 9.43272 10.541 9.12835 10.5202C8.83235 10.5 8.46865 10.5 8.01778 10.5H7.98224C7.53137 10.5 7.16766 10.5 6.87166 10.5202C6.56729 10.541 6.29815 10.5847 6.0433 10.6903C5.43073 10.944 4.94404 11.4307 4.69031 12.0433C4.58474 12.2981 4.54096 12.5673 4.5202 12.8717C4.5 13.1677 4.5 13.5314 4.50001 13.9822L4.50001 16.0178C4.5 16.4686 4.5 16.8323 4.5202 17.1284C4.54096 17.4327 4.58474 17.7019 4.69031 17.9567C4.94404 18.5693 5.43073 19.056 6.0433 19.3097C6.29815 19.4153 6.56729 19.459 6.87166 19.4798C7.16766 19.5 7.53137 19.5 7.98225 19.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","menu","grid","application","options","categories","apps","settings","main-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16C5 14.3431 6.34315 13 8 13C9.65685 13 11 14.3431 11 16C11 17.6569 9.65685 19 8 19C6.34315 19 5 17.6569 5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 8C13 6.34315 14.3431 5 16 5C17.6569 5 19 6.34315 19 8C19 9.65685 17.6569 11 16 11C14.3431 11 13 9.65685 13 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-33": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","categories","modules","apps","shortcuts","menu","grid","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16C5 14.3431 6.34315 13 8 13C9.65685 13 11 14.3431 11 16C11 17.6569 9.65685 19 8 19C6.34315 19 5 17.6569 5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 8C13 6.34315 14.3431 5 16 5C17.6569 5 19 6.34315 19 8C19 9.65685 17.6569 11 16 11C14.3431 11 13 9.65685 13 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","menu","grid","options","modules","categories","shortcuts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 9.933 6.067 11.5 8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 12.5C6.067 12.5 4.5 14.067 4.5 16C4.5 17.933 6.067 19.5 8 19.5C9.933 19.5 11.5 17.933 11.5 16C11.5 14.067 9.933 12.5 8 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 4.5C14.067 4.5 12.5 6.067 12.5 8C12.5 9.933 14.067 11.5 16 11.5C17.933 11.5 19.5 9.933 19.5 8C19.5 6.067 17.933 4.5 16 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 12.5C14.067 12.5 12.5 14.067 12.5 16C12.5 17.933 14.067 19.5 16 19.5C17.933 19.5 19.5 17.933 19.5 16C19.5 14.067 17.933 12.5 16 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-34": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","grid","squares","modules","overview","sections","analytics","menu","navigation","sales-overview","reports","insights","data","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 16C5 14.3431 6.34315 13 8 13C9.65685 13 11 14.3431 11 16C11 17.6569 9.65685 19 8 19C6.34315 19 5 17.6569 5 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 8C13 6.34315 14.3431 5 16 5C17.6569 5 19 6.34315 19 8C19 9.65685 17.6569 11 16 11C14.3431 11 13 9.65685 13 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dashboard","layout","structure","grid","sections","overview","summary","reports","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 11V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 11H9H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","layout","grid","sections","overview","summary","reporting","analytics","main-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H9M19 11H9M9 11V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Dashboard-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","overview","summary","analytics","reports","data","performance","statistics","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.5 11H6.5C6.03406 11 5.80109 11 5.61732 10.9239C5.37229 10.8224 5.17761 10.6277 5.07612 10.3827C5 10.1989 5 9.96594 5 9.5C5 8.10218 5 7.40326 5.22836 6.85195C5.53284 6.11687 6.11687 5.53284 6.85195 5.22836C7.40326 5 8.10218 5 9.5 5H14.5C15.8978 5 16.5967 5 17.1481 5.22836C17.8831 5.53284 18.4672 6.11687 18.7716 6.85195C19 7.40326 19 8.10218 19 9.5C19 9.96594 19 10.1989 18.9239 10.3827C18.8224 10.6277 18.6277 10.8224 18.3827 10.9239C18.1989 11 17.9659 11 17.5 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 11V5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "Dashboard-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","summary","overview","statistics","metrics","reports","analytics","data","pos","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11875C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.4587 20 10.5753 20 11.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V11.9294C3.99997 10.5753 3.99994 8.4587 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C7.93727 4.07004 8.33874 4.0413 8.77968 4.02435C8.85056 4.00841 8.9243 4 9 4C9.05439 4 9.10775 4.00434 9.15978 4.0127C9.69639 3.99997 10.2861 3.99998 10.9294 4ZM8 6.0815C7.94588 6.08752 7.89305 6.09398 7.84143 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84143C6.02686 8.3923 6.00712 10.0817 6.00189 11H8V6.0815ZM10 11V6.00189C10.3067 6.00014 10.6389 6 11 6H13C14.4425 6 15.4238 6.00213 16.1586 6.10092C16.8646 6.19585 17.1916 6.36322 17.4142 6.58579C17.6368 6.80836 17.8042 7.13538 17.8991 7.84143C17.9731 8.3923 17.9929 10.0817 17.9981 11L10 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","layout","sections","overview","summary","analytics","reports","metrics","performance","at-a-glance","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H12M19 11H12M12 11V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Dashboard-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dashboard","layout","grid","section","organize","view","table","summary","overview","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 11H12H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-biscuits-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dashboard","grid","layout","options","settings","controls","arrangement","modules","interface","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 11H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Dashboard-biscuits-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dashboard","summary","overview","report","statistics","analytics","metrics","data","grid","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M5 11H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M5 15H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "Dashboard-biscuits-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","table","matrix","structure","organization","layout","dashboard","report","modules","inventory","categories","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99998 13.7139 3.99997 14.3036 4.0127 14.8402C4.00434 14.8922 4 14.9456 4 15C4 15.0757 4.00841 15.1494 4.02436 15.2203C4.04131 15.6613 4.07004 16.0627 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C19.93 16.0627 19.9587 15.6613 19.9757 15.2203C19.9916 15.1494 20 15.0757 20 15C20 14.9456 19.9957 14.8923 19.9873 14.8402C20 14.3036 20 13.714 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM17.9981 14C17.9999 13.6933 18 13.3611 18 13V12H13L13 14H17.9981ZM11 14L11 12H6V13C6 13.3611 6.00014 13.6933 6.00189 14H11ZM6.0815 16H11L11 18C9.55752 18 8.57626 17.9979 7.84144 17.8991C7.13538 17.8042 6.80836 17.6368 6.58579 17.4142C6.36322 17.1916 6.19585 16.8646 6.10092 16.1586C6.09398 16.107 6.08752 16.0541 6.0815 16ZM13 16H17.9185C17.9125 16.0541 17.906 16.107 17.8991 16.1586C17.8042 16.8646 17.6368 17.1916 17.4142 17.4142C17.1916 17.6368 16.8646 17.8042 16.1586 17.8991C15.4238 17.9979 14.4425 18 13 18L13 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Dashboard-biscuits": {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","layout","grid","sections","overview","summary","analytics","reports","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Dashboard: {
        defaultColors: ["#3D4C66"],
        keywords: ["dashboard","layout","grid","sections","overview","summary","analytics","reports","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 11H12M19 11H12M12 11V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "data-saver-on-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["add","plus","create","new","increase","add-item","add-product","add-customer","new-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 12L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L12 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "data-saver-on-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["add","plus","new","create","increase","expand","add-item","add-product","new-order","new-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.45809 5.33828C7.82356 5.75235 7.78415 6.38429 7.37008 6.74975C5.91519 8.03387 5 9.90944 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 9.31181 4.17983 6.89793 6.04662 5.25027C6.46069 4.88481 7.09263 4.92421 7.45809 5.33828Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9998 5C11.0696 5 10.1842 5.18088 9.37499 5.50846C8.86306 5.71568 8.28006 5.46867 8.07284 4.95673C7.86561 4.4448 8.11263 3.86181 8.62456 3.65458C9.66818 3.23213 10.8081 3 11.9998 3C15.7784 3 19.0108 5.32832 20.3452 8.62479C20.5524 9.13672 20.3054 9.71971 19.7935 9.92694C19.2815 10.1342 18.6985 9.88715 18.4913 9.37521C17.4521 6.80802 14.9359 5 11.9998 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "data-saver-on": {
        defaultColors: ["#3D4C66"],
        keywords: ["add","plus","create","new","increase","addition","add-item","increase-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 12L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L12 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "data-saver-on-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["add","plus","create","new","item","add-item","circle","add-new","add-product","new-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 12L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L12 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "data-usage-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["loading","processing","waiting","sync","updating","refreshing","circle","data-usage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "data-usage-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["circle","progress","loading","updating","synchronizing","waiting","status","data usage","processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "data-usage-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","processing","waiting","syncing","refresh","circle","status","in-progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C11.0699 5 10.1845 5.18088 9.37522 5.50846C8.86328 5.71568 8.28029 5.46867 8.07306 4.95673C7.86584 4.4448 8.11285 3.86181 8.62478 3.65458C9.6684 3.23213 10.8083 3 12 3C15.7786 3 19.011 5.32832 20.3454 8.62479C20.5526 9.13672 20.3056 9.71971 19.7937 9.92694C19.2818 10.1342 18.6988 9.88715 18.4915 9.37521C17.4524 6.80802 14.9361 5 12 5ZM7.45809 5.33827C7.82356 5.75234 7.78415 6.38427 7.37008 6.74974C5.91519 8.03386 5 9.90943 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 9.3118 4.17983 6.89792 6.04662 5.25026C6.46069 4.8848 7.09263 4.9242 7.45809 5.33827Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9998 5C11.0696 5 10.1842 5.18088 9.37499 5.50846C8.86306 5.71568 8.28006 5.46867 8.07284 4.95673C7.86561 4.4448 8.11263 3.86181 8.62456 3.65458C9.66818 3.23213 10.8081 3 11.9998 3C15.7784 3 19.0108 5.32832 20.3452 8.62479C20.5524 9.13672 20.3054 9.71971 19.7935 9.92694C19.2815 10.1342 18.6985 9.88715 18.4913 9.37521C17.4521 6.80802 14.9359 5 11.9998 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "data-usage": {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","waiting","circle","sync","refresh","processing","updating","connecting","data","usage","cycle","loop","status","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.61061 5.04751 7.46589 6.70835 6M9 4.58152C9.92643 4.20651 10.9391 4 12 4C15.3574 4 18.2317 6.06817 19.4185 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "database-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["database","storage","data","server","backup","cloud","stack","inventory","catalog","records"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 8C19 6.34315 15.866 5 12 5C8.13401 5 5 6.34315 5 8C5 9.65686 8.13401 11 12 11C15.866 11 19 9.65685 19 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.6569 15.866 15 12 15C8.13401 15 5 13.6569 5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 16C19 17.6569 15.866 19 12 19C8.13401 19 5 17.6569 5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "database-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["database","storage","data","server","information","records","inventory","products","sales","transactions","reports","backup","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 8C19 6.34315 15.866 5 12 5C8.13401 5 5 6.34315 5 8C5 9.65686 8.13401 11 12 11C15.866 11 19 9.65685 19 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.6569 15.866 15 12 15C8.13401 15 5 13.6569 5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 16C19 17.6569 15.866 19 12 19C8.13401 19 5 17.6569 5 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "database-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["database","storage","data","inventory","records","backup","server","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C9.96482 4 8.07486 4.3516 6.65633 4.95954C5.94885 5.26274 5.31243 5.64947 4.83835 6.12983C4.36003 6.61449 4 7.24762 4 8C4 8.75238 4.36003 9.38551 4.83835 9.87017C5.31243 10.3505 5.94885 10.7373 6.65633 11.0405C8.07486 11.6484 9.96482 12 12 12C14.0352 12 15.9251 11.6484 17.3437 11.0405C18.0512 10.7373 18.6876 10.3505 19.1617 9.87017C19.64 9.38551 20 8.75238 20 8C20 7.24762 19.64 6.61449 19.1617 6.12983C18.6876 5.64946 18.0511 5.26274 17.3437 4.95953C15.9251 4.3516 14.0352 4 12 4ZM4.70452 11.8534C5.18328 11.5781 5.79459 11.743 6.06992 12.2218C6.26168 12.5552 6.84993 13.0221 7.97338 13.4043C9.04806 13.7699 10.448 14 11.9999 14C13.5519 14 14.9518 13.7699 16.0265 13.4043C17.15 13.0221 17.7382 12.5552 17.93 12.2218C18.2053 11.743 18.8166 11.5781 19.2954 11.8534C19.7741 12.1288 19.939 12.7401 19.6637 13.2189C19.1027 14.1944 17.9358 14.8673 16.6706 15.2977C15.3567 15.7447 13.7346 16 11.9999 16C10.2653 16 8.64318 15.7447 7.32925 15.2977C6.06408 14.8673 4.89717 14.1944 4.33618 13.2189C4.06085 12.7401 4.22576 12.1288 4.70452 11.8534ZM6.06992 16.0015C5.79459 15.5227 5.18328 15.3578 4.70452 15.6331C4.22576 15.9084 4.06085 16.5198 4.33618 16.9985C4.89717 17.974 6.06408 18.647 7.32925 19.0774C8.64318 19.5244 10.2653 19.7796 11.9999 19.7796C13.7346 19.7796 15.3567 19.5244 16.6706 19.0774C17.9358 18.647 19.1027 17.974 19.6637 16.9985C19.939 16.5198 19.7741 15.9084 19.2954 15.6331C18.8166 15.3578 18.2053 15.5227 17.93 16.0015C17.7382 16.3349 17.15 16.8018 16.0265 17.1839C14.9518 17.5495 13.5519 17.7796 11.9999 17.7796C10.448 17.7796 9.04806 17.5495 7.97338 17.1839C6.84993 16.8018 6.26168 16.3349 6.06992 16.0015Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dekstop-screen-disabled-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["disabled","screen","offline","unavailable","disconnected","monitor-off","inactive","out-of-service","terminal-disabled","register-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "dekstop-screen-disabled-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["screen","desktop","disabled","offline","unavailable","disconnected","out-of-service","terminal-error","system-failure","no-display","monitor-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    database: {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","desktop","disabled","offline","unavailable","disconnected","out-of-service","terminal-error","system-failure","no-display","monitor-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 8C19 6.34315 15.866 5 12 5C8.13401 5 5 6.34315 5 8C5 9.65686 8.13401 11 12 11C15.866 11 19 9.65685 19 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.6569 15.866 15 12 15C8.13401 15 5 13.6569 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 16C19 17.6569 15.866 19 12 19C8.13401 19 5 17.6569 5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dekstop-screen-disabled-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","disabled","offline","unavailable","error","inactive","deactivated","out-of-service","terminal-error","system-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9451 4.25H13.0549C14.4225 4.24998 15.5248 4.24997 16.3918 4.36653C17.2919 4.48754 18.0497 4.74644 18.6517 5.34835C19.2536 5.95027 19.5125 6.70814 19.6335 7.60825C19.75 8.47522 19.75 9.57753 19.75 10.9451V11.0549C19.75 12.4225 19.75 13.5248 19.6335 14.3918C19.5125 15.2919 19.2536 16.0497 18.6517 16.6517C18.4889 16.8144 18.3147 16.9521 18.1294 17.0688L5.94597 4.88531C6.42866 4.60056 6.98428 4.45042 7.60825 4.36653C8.47521 4.24997 9.57755 4.24998 10.9451 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.88531 5.94597C4.60056 6.42866 4.45042 6.98428 4.36653 7.60825C4.24997 8.47521 4.24998 9.57752 4.25 10.9451V11.0549C4.24998 12.4225 4.24997 13.5248 4.36653 14.3918C4.48754 15.2919 4.74644 16.0497 5.34835 16.6517C5.95027 17.2536 6.70814 17.5125 7.60825 17.6335C8.47522 17.75 9.57753 17.75 10.9451 17.75H11.25V18.75H10C9.58579 18.75 9.25 19.0858 9.25 19.5C9.25 19.9142 9.58579 20.25 10 20.25H14C14.4142 20.25 14.75 19.9142 14.75 19.5C14.75 19.0858 14.4142 18.75 14 18.75H12.75V17.75H13.0549C14.4225 17.75 15.5248 17.75 16.3918 17.6335C16.445 17.6263 16.4977 17.6187 16.5499 17.6105L4.88531 5.94597Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dekstop-screen-disabled": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","monitor","disabled","offline","unavailable","inactive","deactivated","disconnected","service-down","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "delivery  tracking-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["map-pin","location","gps","delivery","address","map","tracking","pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery  tracking-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["delivery","tracking","package","location","shipping","order-tracking","parcel","map-pin","box-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery  tracking-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","tracking","package","shipping","order-status","order-tracking","location","route","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.9064C14.7682 19.5972 14.6304 19.4338 14.4988 19.2618C14.07 18.7016 13.5 17.7868 13.5 16.6875C13.5 14.5129 15.2629 12.75 17.4375 12.75C18.3016 12.75 19.1007 13.0283 19.75 13.5003L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 16.6875C14.5 15.0652 15.8152 13.75 17.4375 13.75C19.0598 13.75 20.375 15.0652 20.375 16.6875C20.375 17.4513 19.971 18.1459 19.582 18.6541C19.177 19.1831 18.6933 19.6312 18.3544 19.9186C18.2551 20.0027 18.1353 20.0995 18.0051 20.1749C17.8668 20.2551 17.6759 20.3357 17.4403 20.3364C17.2045 20.3371 17.0126 20.2573 16.8729 20.1769C16.7413 20.1012 16.6205 20.0038 16.5197 19.9183C16.1812 19.6311 15.6978 19.183 15.2929 18.654C14.904 18.1459 14.5 17.4513 14.5 16.6875ZM17.4349 17.4499C17.8574 17.4499 18.1999 17.1074 18.1999 16.6849C18.1999 16.2624 17.8574 15.9199 17.4349 15.9199C17.0124 15.9199 16.6699 16.2624 16.6699 16.6849C16.6699 17.1074 17.0124 17.4499 17.4349 17.4499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery  tracking": {
        defaultColors: ["#000000"],
        keywords: ["delivery","tracking","package","box","shipping","order-status","location","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery add-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","add","plus","order","add-order","delivery","increase","inventory","restock","receive","stock-in","shipment","add-shipment","add-item","plus-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M17 15V19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery add-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","create","new","item","add-item","new-item","add-product","new-product","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 15V19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery add-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","delivery","new-delivery","create-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 4.25H9.07896H9.07894C8.36666 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25ZM4.25 9.75L4.25 15.052V15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.3507 19.75 15.6328 19.75 15.8983 19.7471C14.9791 19.6944 14.25 18.9324 14.25 18C14.25 17.0335 15.0335 16.25 16 16.25H16.25V16C16.25 15.0335 17.0335 14.25 18 14.25C18.9324 14.25 19.6944 14.9791 19.7471 15.8983C19.75 15.6328 19.75 15.3507 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999ZM12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H14.921H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 15.25C18.4142 15.25 18.75 15.5858 18.75 16V17.25H20C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75H18.75V20C18.75 20.4142 18.4142 20.75 18 20.75C17.5858 20.75 17.25 20.4142 17.25 20V18.75H16C15.5858 18.75 15.25 18.4142 15.25 18C15.25 17.5858 15.5858 17.25 16 17.25H17.25V16C17.25 15.5858 17.5858 15.25 18 15.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery add": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","delivery","new-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 15V19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17H19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery box label-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["label","tag","price","discount","item","product","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery box label-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","shipping","item","order","product","inventory","stock","label","shipment","receiving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery box label-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","box","package","shipping","order","item","received","delivered"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path d="M8.75 15.2513V13.75H12.2521V15.2513H8.75Z" fill={colors?.[0] || "#000000"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052L19.75 9.75H4.25ZM8 12.25C7.58579 12.25 7.25 12.5858 7.25 13V16.0013C7.25 16.4155 7.58579 16.7513 8 16.7513H13.0021C13.4163 16.7513 13.7521 16.4155 13.7521 16.0013V13C13.7521 12.5858 13.4163 12.25 13.0021 12.25H8Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery box label": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","label","shipping","order","inventory","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery box-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","open","delivery","order","shipment","inventory","received","receiving","stock","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery box-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["minus","remove","decrease","subtract","discount","reduction","delete","reduce","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery box-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipping","order","inventory","stock","supply","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36668 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53174 4.69837 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58577 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58577 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery box": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipping","order","receive","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery check-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["check","checkmark","confirm","done","complete","approve","verify","tick","success","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery check-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","check","checkmark","delivery","delivery-check","order","order-check","confirm","confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery check-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","check","box","package","shipping","received","confirmed","order-confirmation","delivery-confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.3562L13.5793 19.0508C12.8609 18.4042 12.8027 17.2977 13.4493 16.5793C14.0958 15.8609 15.2023 15.8027 15.9207 16.4493L16.4167 16.8956L18.5793 14.9493C18.9139 14.6481 19.3327 14.4999 19.75 14.5L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.3075 15.7483C20.5846 16.0562 20.5596 16.5304 20.2517 16.8075L16.9184 19.8075C16.6332 20.0642 16.2002 20.0642 15.915 19.8075L14.2483 18.3075C13.9404 18.0304 13.9154 17.5562 14.1925 17.2483C14.4696 16.9404 14.9438 16.9154 15.2517 17.1925L16.4167 18.241L19.2483 15.6925C19.5562 15.4154 20.0304 15.4404 20.3075 15.7483Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery check": {
        defaultColors: ["#000000"],
        keywords: ["delivery","check","box","package","approved","confirmed","order-received","shipment","tick"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17.5L15.6667 19L19 16"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery click-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["package","box","delivery","shipping","order","send","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3987 18.3921L16.2302 17.381C16.1252 16.7514 16.0728 16.4367 16.2547 16.2547C16.4367 16.0728 16.7514 16.1252 17.381 16.2302L18.3921 16.3987C19.4886 16.5814 20.0368 16.6728 20.1043 17.0116C20.1717 17.3504 19.7002 17.6447 18.7573 18.2334L18.4347 18.4347L18.2334 18.7573C17.6447 19.7002 17.3504 20.1717 17.0116 20.1043C16.6728 20.0368 16.5814 19.4886 16.3987 18.3921Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path
                    d="M18.4347 18.4347L18.7573 18.2334C19.7002 17.6447 20.1717 17.3504 20.1043 17.0116C20.0368 16.6728 19.4886 16.5814 18.3921 16.3987L17.381 16.2302C16.7514 16.1252 16.4367 16.0728 16.2547 16.2547C16.0728 16.4367 16.1252 16.7514 16.2302 17.381L16.3987 18.3921C16.5814 19.4886 16.6728 20.0368 17.0116 20.1043C17.3504 20.1717 17.6447 19.7002 18.2334 18.7573L18.4347 18.4347ZM18.4347 18.4347L19.9257 19.9257L20.6712 20.6712"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery click-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","pointer","select","choose","direction","navigation","cursor","touch","click"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9217 17.9217L18.3087 17.68C19.4403 16.9737 20.006 16.6205 19.9251 16.2139C19.8442 15.8074 19.1863 15.6977 17.8706 15.4784L16.6571 15.2762C15.9017 15.1503 15.524 15.0873 15.3057 15.3057C15.0873 15.524 15.1503 15.9017 15.2762 16.6571L15.4784 17.8706C15.6977 19.1863 15.8074 19.8442 16.2139 19.9251C16.6205 20.006 16.9737 19.4403 17.68 18.3087L17.9217 17.9217ZM17.9217 17.9217L19.7108 19.7108L20.6054 20.6054"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery click-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","truck","shipping","transport","package","order","send","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69837 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052C4.25 15.2092 4.24999 15.3618 4.25041 15.5099C4.25039 16.408 4.24996 16.6998 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75L14.9976 19.75C14.9252 19.4358 14.8671 19.0869 14.8121 18.7562L14.6153 17.5754C14.5727 17.3207 14.5161 16.9828 14.5103 16.6813C14.5033 16.3191 14.557 15.6544 15.1058 15.1056C15.6546 14.5568 16.3194 14.5031 16.6816 14.5101C16.983 14.5159 17.3208 14.5724 17.5755 14.615L18.7562 14.8118C19.0869 14.8669 19.4358 14.9249 19.75 14.9973L19.75 9.75H4.25L4.25 15.052ZM9.99999 11.25C9.58577 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58577 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.446 15.6072L18.541 15.7898C19.0117 15.8682 19.429 15.9377 19.7454 16.0276C19.771 16.0349 19.7959 16.0423 19.8202 16.0498C20.1183 16.1427 20.609 16.3448 20.7174 16.8895C20.8258 17.4343 20.4499 17.8088 20.21 18.0087C20.0118 18.174 19.7424 18.3521 19.4322 18.5481L21.1133 20.2291C21.3573 20.4732 21.3573 20.8689 21.1133 21.113C20.8692 21.3571 20.4735 21.3571 20.2294 21.113L18.5483 19.432C18.3524 19.7421 18.1743 20.0116 18.009 20.2098C17.809 20.4496 17.4345 20.8256 16.8898 20.7171C16.345 20.6087 16.143 20.118 16.0501 19.8199C16.0425 19.7957 16.0352 19.7709 16.0279 19.7454C15.938 19.429 15.8684 19.0116 15.79 18.5407L15.6075 17.4457C15.5605 17.1641 15.5145 16.8887 15.5101 16.662C15.5053 16.4107 15.5464 16.0792 15.8129 15.8127C16.0795 15.5461 16.4109 15.505 16.6622 15.5099C16.8889 15.5143 17.1643 15.5602 17.446 15.6072Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery click": {
        defaultColors: ["#000000"],
        keywords: ["delivery","truck","shipping","package","transport","order","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9217 17.9217L18.3087 17.68C19.4403 16.9737 20.006 16.6205 19.9251 16.2139C19.8442 15.8074 19.1863 15.6977 17.8706 15.4784L16.6571 15.2762C15.9017 15.1503 15.524 15.0873 15.3057 15.3057C15.0873 15.524 15.1503 15.9017 15.2762 16.6571L15.4784 17.8706C15.6977 19.1863 15.8074 19.8442 16.2139 19.9251C16.6205 20.006 16.9737 19.4403 17.68 18.3087L17.9217 17.9217ZM17.9217 17.9217L19.7108 19.7108L20.6054 20.6054"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery disable-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["disable","not allowed","prohibited","restriction","unavailable","cancel","void","remove","delete","stop","block","deny"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.833 18.1668L18.1663 14.8335"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery disable-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","disabled","not-available","unavailable","cancel-delivery","cancel-order","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.833 18.1668L18.1663 14.8335"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery disable-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","disable","unavailable","not-available","blocked","shipping-disabled","delivery-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75H19.75L19.7502 14.1256C19.0657 13.5775 18.1967 13.25 17.2502 13.25C15.0385 13.25 13.2502 15.0383 13.2502 17.25C13.2502 18.1966 13.5777 19.0656 14.1258 19.75L8.94798 19.75C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052L4.25 9.75ZM9.24999 12C9.24999 11.5858 9.58578 11.25 9.99999 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H9.99999C9.58578 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2502 17.25C14.2502 15.5906 15.5907 14.25 17.2502 14.25C18.1569 14.25 18.9684 14.6502 19.518 15.284C19.6013 15.3801 19.6786 15.4815 19.7493 15.5877C20.0659 16.0632 20.2502 16.6347 20.2502 17.25C20.2502 18.9094 18.9096 20.25 17.2502 20.25C16.635 20.25 16.0636 20.0658 15.5881 19.7493C15.4874 19.6823 15.3909 19.6093 15.2993 19.5309L15.2842 19.5178C14.6504 18.9682 14.2502 18.1567 14.2502 17.25ZM17.2502 15.75C16.4192 15.75 15.7502 16.419 15.7502 17.25C15.7502 17.3846 15.7677 17.515 15.8007 17.639L17.6392 15.8005C17.5152 15.7676 17.3848 15.75 17.2502 15.75ZM18.6997 16.8613L16.8615 18.6996C16.9854 18.7325 17.1156 18.75 17.2502 18.75C18.0812 18.75 18.7502 18.081 18.7502 17.25C18.7502 17.1155 18.7326 16.9852 18.6997 16.8613Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery dollar-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["dollar","money","currency","payment","price","cost","sale","discount","cash","finance","value","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery disable": {
        defaultColors: ["#000000"],
        keywords: ["delivery","disable","not-available","unavailable","shipping-disabled","no-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.833 18.1668L18.1663 14.8335"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery dollar-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","dollar","delivery","package","shipping","cost","price","order-cost","delivery-cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery dollar-3": {
        defaultColors: ["#000000"],
        keywords: ["dollar","money","delivery","shipping","cost","price","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.8172C14.9269 19.3602 15.1682 19.0256 15.4901 18.7971C15.0313 18.2877 14.752 17.6134 14.752 16.8739C14.752 15.9177 15.2187 15.072 15.9347 14.55C16.1332 13.8016 16.8153 13.25 17.6263 13.25C18.2212 13.25 18.7469 13.5469 19.063 14.0006C19.3082 14.0093 19.5406 14.0683 19.75 14.1677L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.75C14.1642 12.75 14.5 12.4142 14.5 12C14.5 11.5858 14.1642 11.25 13.75 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.3763 14.9995C18.376 14.5855 18.0403 14.25 17.6263 14.25C17.2121 14.25 16.8763 14.5858 16.8763 15V15.1556C16.2144 15.4449 15.752 16.1054 15.752 16.8739C15.752 17.909 16.5911 18.7482 17.6263 18.7482H18.2509C18.6029 18.7482 18.7501 18.9881 18.7501 19.1225C18.7501 19.1959 18.72 19.2724 18.6401 19.3425C18.557 19.4152 18.4226 19.4751 18.2509 19.4751L16.502 19.4751C16.0877 19.4751 15.752 19.8109 15.752 20.2251C15.752 20.6393 16.0877 20.9751 16.502 20.9751H16.8763C16.8765 21.3891 17.2122 21.7246 17.6263 21.7246C18.0405 21.7246 18.3763 21.3888 18.3763 20.9746V20.9713C19.3393 20.914 20.2501 20.2012 20.2501 19.1225C20.2501 18.015 19.2788 17.2482 18.2509 17.2482H17.6263C17.4195 17.2482 17.252 17.0806 17.252 16.8739C17.252 16.6671 17.4195 16.4995 17.6263 16.4995H19.0004C19.4147 16.4995 19.7504 16.1638 19.7504 15.7495C19.7504 15.3353 19.4147 14.9995 19.0004 14.9995H18.3763Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery dollar": {
        defaultColors: ["#000000"],
        keywords: ["delivery","dollar","money","shipping-cost","delivery-cost","price","delivery-price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3125 14.875H17.9167M16.3125 14.875C15.5876 14.875 15 15.4626 15 16.1875C15 16.9124 15.5876 17.5 16.3125 17.5H17.0417C17.8471 17.5 18.5 18.0876 18.5 18.8125C18.5 19.5374 17.8471 20.0996 17.0417 20.0996H16.3125M16.3125 14.875V14M15 20.0996L16.3125 20.0996M16.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery edit-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["edit","pen","modify","change","update","revise","pencil"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery edit-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","edit","modify","order","shipment","update-order","edit-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0084 14.7068C17.3057 14.4141 17.7062 14.25 18.1234 14.25C19.0012 14.25 19.75 14.9988 19.75 15.8765C19.75 16.2938 19.5859 16.6943 19.2931 16.9916L19.2891 16.9957L16.8366 19.4482C16.6415 19.6402 16.3806 19.7431 16.1131 19.7421L15.2957 19.75L15.2766 19.7499C14.7148 19.741 14.259 19.2851 14.2501 18.7234L14.25 18.7043L14.2579 17.8868C14.2569 17.6194 14.3598 17.3585 14.5518 17.1634L14.556 17.1591L17.0084 14.7068Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery edit-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","edit","package","box","modify","update","order","shipping","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69837 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.32991 17.2945C4.26363 16.8015 4.2523 16.2023 4.25039 15.5L4.25 15.1391L4.25 9.75H19.75L19.7502 13.8275C19.3001 13.4674 18.7331 13.2501 18.1236 13.2501C17.4439 13.2501 16.7914 13.5174 16.307 13.9944L13.8491 16.4521L13.8393 16.4621C13.4606 16.8469 13.2581 17.3595 13.2581 17.8829L13.2502 18.6948L13.2502 18.7267L13.2504 18.7394C13.2563 19.1082 13.3601 19.4534 13.5369 19.7501L8.94798 19.75C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945ZM9.24999 12C9.24999 11.5858 9.58577 11.25 9.99999 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H9.99999C9.58577 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.7482 15.7997L19.7481 15.7967C19.7044 14.954 18.9746 14.2501 18.1236 14.2501C17.7064 14.2501 17.3059 14.4142 17.0086 14.7069L14.5562 17.1593L14.552 17.1635C14.36 17.3586 14.257 17.6195 14.258 17.8869L14.2502 18.7044L14.2502 18.7235C14.2592 19.2843 14.7127 19.7396 15.2732 19.75L15.2767 19.75L15.2959 19.7501L16.1133 19.7422C16.3807 19.7432 16.6417 19.6403 16.8367 19.4483L19.2893 16.9958L19.2933 16.9917C19.5588 16.722 19.7185 16.3674 19.7459 15.9925L19.7461 15.9894C19.7488 15.952 19.7501 15.9144 19.7501 15.8766C19.7501 15.8509 19.7495 15.8253 19.7482 15.7997Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery edit": {
        defaultColors: ["#000000"],
        keywords: ["delivery","box","package","edit","modify","order","delivery-order","order-edit","shipping","manage-delivery","update-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery fast-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["bolt","lightning","fast","quick","speed","energy","instant","express","electricity","power"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6662 15L16.9997 17H18.333L17.6662 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery fast-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["package","box","delivery","fast","lightning","shipping","express","order","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.6662 15L16.9997 17H18.333L17.6662 19"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery fast-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","shipping","delivery","fast","speed","truck","transit","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.4209 19.75 15.7647 19.75 16.083 19.7445C15.8983 19.3519 15.8585 18.8905 16.0065 18.4465L16.0081 18.4417C15.8447 18.3292 15.6996 18.1884 15.5805 18.0233C15.2516 17.5669 15.1621 16.9803 15.3399 16.4467L16.0065 14.4467C16.312 13.5298 17.3031 13.0342 18.22 13.3398C19.1369 13.6453 19.6325 14.6364 19.3269 15.5533L19.3253 15.5582C19.4857 15.6685 19.6285 15.8061 19.7463 15.9672C19.75 15.6818 19.75 15.3767 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.9038 14.2884C17.5109 14.1575 17.0861 14.3699 16.9552 14.7628L16.2886 16.7628C16.2124 16.9915 16.2508 17.2429 16.3917 17.4385C16.5327 17.6341 16.7591 17.75 17.0002 17.75H17.2929L16.9552 18.7627C16.8242 19.1557 17.0365 19.5805 17.4295 19.7115C17.8224 19.8425 18.2472 19.6301 18.3782 19.2372L19.045 17.2372C19.1212 17.0085 19.0829 16.757 18.9419 16.5614C18.801 16.3659 18.5746 16.25 18.3335 16.25H18.0407L18.3782 15.2371C18.5092 14.8441 18.2968 14.4194 17.9038 14.2884Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery fast": {
        defaultColors: ["#000000"],
        keywords: ["delivery","fast","shipping","package","truck","time","speed","order","transit","express","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6662 15L16.9997 17H18.333L17.6662 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery finger-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["finger","tap","select","touch","choose","point","press","payment","interaction","selection","command"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.65 17.5999L15.328 17.2486C15.1821 17.0894 14.9842 17 14.7779 17C14.5716 17 14.3737 17.0894 14.2279 17.2486C13.9657 17.5346 13.925 17.9828 14.1306 18.3193L15.1976 20.0656C15.4017 20.3995 15.7452 20.6 16.113 20.6H18.2008C18.7556 20.6 19.2235 20.1493 19.2923 19.5488L19.4914 17.8107C19.5647 17.1704 19.1608 16.5814 18.577 16.4776L17.3 16.2504V14.9C17.3 14.4029 16.9306 14 16.475 14C16.0194 14 15.65 14.4029 15.65 14.9V17.5999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery finger-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","finger","hand","select","delivery","order","choose","select-delivery","select-order","confirm-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.65 17.5999L15.328 17.2486C15.1821 17.0894 14.9842 17 14.7779 17C14.5716 17 14.3737 17.0894 14.2279 17.2486C13.9657 17.5346 13.925 17.9828 14.1306 18.3193L15.1976 20.0656C15.4017 20.3995 15.7452 20.6 16.113 20.6H18.2008C18.7556 20.6 19.2235 20.1493 19.2923 19.5488L19.4914 17.8107C19.5647 17.1704 19.1608 16.5814 18.577 16.4776L17.3 16.2504V14.9C17.3 14.4029 16.9306 14 16.475 14C16.0194 14 15.65 14.4029 15.65 14.9V17.5999Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery finger-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","finger","touch","confirmation","approve","validate","process","order-confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H13.9301L13.5272 19.0908C13.0946 18.3827 13.1703 17.445 13.7406 16.8228C14.0381 16.4983 14.4488 16.2884 14.8999 16.2548V15.15C14.8999 14.1844 15.6368 13.25 16.7249 13.25C17.8129 13.25 18.5499 14.1844 18.5499 15.15V15.6626L19.002 15.743C19.2782 15.7922 19.5274 15.8925 19.7453 16.0313C19.75 15.7276 19.75 15.4011 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9 17.8499L15.578 17.4986C15.4321 17.3394 15.2342 17.25 15.0279 17.25C14.8216 17.25 14.6237 17.3394 14.4779 17.4986C14.2157 17.7846 14.175 18.2328 14.3806 18.5693L15.4476 20.3156C15.6517 20.6495 15.9952 20.85 16.363 20.85H18.4508C19.0056 20.85 19.4735 20.3993 19.5423 19.7988L19.7414 18.0607C19.8147 17.4204 19.4108 16.8314 18.827 16.7276L17.55 16.5004V15.15C17.55 14.6529 17.1806 14.25 16.725 14.25C16.2694 14.25 15.9 14.6529 15.9 15.15V17.8499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery finger": {
        defaultColors: ["#000000"],
        keywords: ["delivery","finger","touch","select","confirm","order-ready","order-confirmation","touchscreen","dispatch","delivery-confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.65 17.5999L15.328 17.2486C15.1821 17.0894 14.9842 17 14.7779 17C14.5716 17 14.3737 17.0894 14.2279 17.2486C13.9657 17.5346 13.925 17.9828 14.1306 18.3193L15.1976 20.0656C15.4017 20.3995 15.7452 20.6 16.113 20.6H18.2008C18.7556 20.6 19.2235 20.1493 19.2923 19.5488L19.4914 17.8107C19.5647 17.1704 19.1608 16.5814 18.577 16.4776L17.3 16.2504V14.9C17.3 14.4029 16.9306 14 16.475 14C16.0194 14 15.65 14.4029 15.65 14.9V17.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery heart-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["heart","favorite","like","loyalty","rewards","customer","saved","preferred","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery heart-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","heart","favorite-order","saved-order","preferred-delivery","special-order","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery heart-3": {
        defaultColors: ["#000000"],
        keywords: ["heart","love","favorite","loyalty","rewards","preferred","donation","charity","healthcare","medical","valentine","gift","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.1773 19.75 15.3004 19.75 15.4198 19.7498L14.2538 18.7435C14.2202 18.7145 14.1878 18.6841 14.1567 18.6524C13.0972 17.572 13.1633 15.8796 14.2723 14.8743C14.3151 14.8355 14.36 14.799 14.4068 14.765C14.9801 14.3487 15.7265 14.0608 16.5813 14.2682C16.7307 14.3044 16.8702 14.3532 17 14.4097C17.1297 14.3532 17.2692 14.3044 17.4185 14.2682C18.2734 14.0608 19.0198 14.3487 19.5932 14.765C19.6399 14.799 19.6848 14.8354 19.7276 14.8742L19.75 14.8948L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.0055 15.5742C18.5857 15.2693 18.1369 15.1229 17.6543 15.24C17.4126 15.2986 17.1954 15.4177 16.9999 15.5589C16.8045 15.4177 16.5873 15.2986 16.3455 15.24C15.863 15.1229 15.4141 15.2693 14.9943 15.5742C14.9768 15.5869 14.9599 15.6006 14.9439 15.6151C14.2506 16.2435 14.2132 17.2817 14.8707 17.9523C14.8824 17.9641 14.8945 17.9755 14.9071 17.9864L16.6079 19.4542C16.8331 19.6486 17.1667 19.6486 17.3919 19.4542L19.0928 17.9864C19.1054 17.9755 19.1175 17.9641 19.1291 17.9522C19.7867 17.2817 19.7492 16.2435 19.056 15.6151C19.0399 15.6006 19.0231 15.5869 19.0055 15.5742Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery heart": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","package","box","heart","love","favorite-delivery","preferred-shipping","customer-loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery mobile-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["mobile","phone","device","payment","transaction","order","pos","terminal","processing","checkout","sale","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H18.3333C19.2761 13 19.7475 13 20.0404 13.2929C20.3333 13.5858 20.3333 14.0572 20.3333 15V19C20.3333 19.9428 20.3333 20.4142 20.0404 20.7071C19.7475 21 19.2761 21 18.3333 21H17C16.0572 21 15.5858 21 15.2929 20.7071C15 20.4142 15 19.9428 15 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 18.6665H18.1115" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery mobile-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["delivery","truck","shipping","vehicle","mobile-delivery","transport","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.6665 18.25V14.75C15.6665 13.925 15.6665 13.5126 15.9228 13.2563C16.1791 13 16.5915 13 17.4165 13H18.5832C19.4081 13 19.8206 13 20.0769 13.2563C20.3332 13.5126 20.3332 13.925 20.3332 14.75V18.25C20.3332 19.075 20.3332 19.4874 20.0769 19.7437C19.8206 20 19.4081 20 18.5832 20H17.4165C16.5915 20 16.1791 20 15.9228 19.7437C15.6665 19.4874 15.6665 19.075 15.6665 18.25Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.7441 17.958H18.2474" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery mobile-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","mobile","truck","shipping","transport","package","order","tracking","logistic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2686 14.47C16.5107 14.4374 16.8083 14.4375 17.1329 14.4375H18.2001C18.5247 14.4375 18.8223 14.4374 19.0644 14.47C19.2957 14.5011 19.5384 14.5687 19.75 14.7374C19.7823 14.7631 19.8139 14.7912 19.8446 14.8219C20.0764 15.0537 20.1607 15.3355 20.1965 15.6021C20.2291 15.8442 20.2291 16.1418 20.229 16.4664V19.5336C20.2291 19.8582 20.2291 20.1558 20.1965 20.3979C20.1607 20.6645 20.0764 20.9463 19.8446 21.1781C19.6128 21.4098 19.331 21.4942 19.0644 21.53C18.8223 21.5626 18.5247 21.5625 18.2001 21.5625H17.133C16.8084 21.5625 16.5107 21.5626 16.2686 21.53C16.002 21.4942 15.7202 21.4098 15.4884 21.1781C15.2567 20.9463 15.1723 20.6645 15.1365 20.3979C15.1113 20.2107 15.1056 19.9904 15.1044 19.75C15.1041 19.6927 15.104 19.6343 15.104 19.5749L15.104 16.4664C15.104 16.1418 15.1039 15.8442 15.1365 15.6021C15.1723 15.3355 15.2567 15.0537 15.4884 14.8219C15.7202 14.5902 16.002 14.5058 16.2686 14.47ZM16.7339 19.7499C16.7339 19.4185 17.0025 19.1499 17.3339 19.1499H18.0006C18.3319 19.1499 18.6006 19.4185 18.6006 19.7499C18.6006 20.0813 18.3319 20.3499 18.0006 20.3499H17.3339C17.0025 20.3499 16.7339 20.0813 16.7339 19.7499Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75L14.1043 19.75C14.104 19.6884 14.104 19.6283 14.104 19.5705V16.4296C14.1039 16.1343 14.1038 15.7787 14.1454 15.4689C14.1961 15.0922 14.3324 14.5638 14.7813 14.1148C15.2303 13.6659 15.7587 13.5296 16.1354 13.4789C16.4452 13.4373 16.8008 13.4374 17.0961 13.4375H18.237C18.5323 13.4374 18.8879 13.4373 19.1977 13.4789C19.3598 13.5007 19.5501 13.5384 19.75 13.61L19.75 9.75H4.25L4.25 15.052ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery moving-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["menu","options","settings","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15.0001L17 14.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 20.0001L17 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17.5H18"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery moving-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","shipping","inventory","order","goods","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M19 15.0001L17 14.9999" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 20.0001L17 19.9999" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 17.5H18" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery mobile": {
        defaultColors: ["#000000"],
        keywords: ["delivery","mobile","van","truck","shipping","transport","order","tracking","dispatch","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H18.3333C19.2761 13 19.7475 13 20.0404 13.2929C20.3333 13.5858 20.3333 14.0572 20.3333 15V19C20.3333 19.9428 20.3333 20.4142 20.0404 20.7071C19.7475 21 19.2761 21 18.3333 21H17C16.0572 21 15.5858 21 15.2929 20.7071C15 20.4142 15 19.9428 15 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 18.6665H18.1115" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery moving-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","package","moving","box","transport","order","shipment","receiving","inbound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15.4999C16 15.0857 16.3358 14.7499 16.75 14.75L18.75 14.7501C19.1643 14.7501 19.5 15.0859 19.5 15.5001C19.5 15.9143 19.1642 16.2501 18.75 16.2501L16.75 16.25C16.3357 16.2499 16 15.9141 16 15.4999ZM17 18C17 17.5858 17.3358 17.25 17.75 17.25H19.75C20.1642 17.25 20.5 17.5858 20.5 18C20.5 18.4142 20.1642 18.75 19.75 18.75H17.75C17.3358 18.75 17 18.4142 17 18ZM16 20.4999C16 20.0857 16.3358 19.7499 16.75 19.75L18.75 19.7501C19.1643 19.7501 19.5 20.0859 19.5 20.5001C19.5 20.9143 19.1642 21.2501 18.75 21.25L16.75 21.25C16.3357 21.2499 16 20.9141 16 20.4999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.0911 19.75 15.1299 19.75 15.1684 19.75C15.3737 19.3179 15.7508 18.9833 16.2114 18.8345C16.0766 18.5864 16 18.3022 16 18.0001C16 17.6979 16.0766 17.4136 16.2114 17.1656C15.5084 16.9384 15 16.2785 15 15.4999C15 14.5334 15.7836 13.75 16.7501 13.75L19.75 13.7501L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.5C13.9142 12.75 14.25 12.4142 14.25 12C14.25 11.5858 13.9142 11.25 13.5 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery pin-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["pin","location","map","marker","delivery","address","sales-location","store-location","set-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4649 17.8384L20.2326 17.0707C20.5945 16.7088 20.7755 16.5279 20.7755 16.303C20.7755 16.0782 20.5945 15.8972 20.2326 15.5354L19.4649 14.7677C19.103 14.4058 18.9221 14.2249 18.6973 14.2249C18.4724 14.2249 18.2915 14.4058 17.9296 14.7677L17.1619 15.5354"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.162 15.5354L16.7973 15.6569C15.5298 16.0794 14.896 16.2907 14.7091 16.7584C14.6692 16.8583 14.6443 16.9637 14.6353 17.0709C14.5934 17.5729 15.0657 18.0452 16.0104 18.9899V18.9899C16.9552 19.9346 17.4275 20.407 17.9295 20.365C18.0367 20.3561 18.142 20.3312 18.242 20.2913C18.7097 20.1043 18.9209 19.4706 19.3434 18.2031L19.465 17.8384"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0098 18.9897L14.4744 20.5251"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery moving": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","box","package","moving","out-for-delivery","dispatch","order-dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 15.0001L17 14.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 20.0001L17 19.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 17.5H18" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery pin-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","shipping","order","receive","damage","broken","missing-item","problem","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20.2626 17.2403L19.6998 17.8032C19.6132 17.8898 19.5699 17.9331 19.538 17.9847C19.5061 18.0363 19.4867 18.0944 19.448 18.2106L19.4091 18.3272C19.0036 19.5438 18.8009 20.1521 18.3519 20.3315C18.256 20.3698 18.1549 20.3937 18.052 20.4023C17.5702 20.4426 17.1168 19.9892 16.21 19.0824C15.3033 18.1757 14.8499 17.7223 14.8902 17.2405C14.8988 17.1376 14.9226 17.0365 14.961 16.9406C15.1404 16.4916 15.7487 16.2889 16.9652 15.8833L17.0819 15.8444C17.1981 15.8057 17.2561 15.7864 17.3077 15.7545C17.3593 15.7226 17.4026 15.6793 17.4892 15.5927L18.0521 15.0298L18.0521 15.0298C18.3994 14.6825 18.5731 14.5088 18.7889 14.5088C19.0047 14.5088 19.1784 14.6825 19.5258 15.0298L20.2626 15.7666L20.2626 15.7667C20.6099 16.114 20.7836 16.2877 20.7836 16.5035C20.7836 16.7193 20.61 16.893 20.2626 17.2403Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.21 19.082L14.7363 20.5557" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery pin": {
        defaultColors: ["#000000"],
        keywords: ["delivery","pin","location","address","shipping","destination","map","customer","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4649 17.8384L20.2326 17.0707C20.5945 16.7088 20.7755 16.5279 20.7755 16.303C20.7755 16.0782 20.5945 15.8972 20.2326 15.5354L19.4649 14.7677C19.103 14.4058 18.9221 14.2249 18.6973 14.2249C18.4724 14.2249 18.2915 14.4058 17.9296 14.7677L17.1619 15.5354"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.162 15.5354L16.7973 15.6569C15.5298 16.0794 14.896 16.2907 14.7091 16.7584C14.6692 16.8583 14.6443 16.9637 14.6353 17.0709C14.5934 17.5729 15.0657 18.0452 16.0104 18.9899V18.9899C16.9552 19.9346 17.4275 20.407 17.9295 20.365C18.0367 20.3561 18.142 20.3312 18.242 20.2913C18.7097 20.1043 18.9209 19.4706 19.3434 18.2031L19.465 17.8384"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.0098 18.9897L14.4744 20.5251" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery pin-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","pin","location","map","address","destination","shipping","order-tracking","store-location","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52563 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36668 4.24998 7.76637 4.24996 7.27885 4.30826C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84393 6.53175 4.69837 7.11408 4.52563 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.136 14.5208C19.2793 14.6302 19.4283 14.7793 19.5633 14.9145L20.2729 15.6241C20.4081 15.7591 20.5572 15.9081 20.6666 16.0514C20.7955 16.2204 20.9374 16.4663 20.9374 16.7932C20.9374 17.1201 20.7955 17.366 20.6666 17.535C20.5572 17.6784 20.4081 17.8274 20.2729 17.9624L19.7122 18.5231L19.6484 18.7149C19.479 19.2231 19.3295 19.6718 19.1668 20.0091C18.9974 20.3604 18.7436 20.7456 18.2798 20.931C18.1245 20.9931 17.9609 21.0317 17.7943 21.0456C17.2964 21.0873 16.8972 20.8562 16.5886 20.6178C16.4298 20.4951 16.2602 20.3422 16.0787 20.1685L15.2803 20.9668C14.9874 21.2597 14.5126 21.2597 14.2197 20.9668C13.9268 20.6739 13.9268 20.199 14.2197 19.9061L15.018 19.1078C14.8447 18.9267 14.6922 18.7574 14.5698 18.599C14.3314 18.2904 14.1003 17.8911 14.1419 17.3933C14.1558 17.2267 14.1945 17.0631 14.2565 16.9078C14.4419 16.4439 14.8272 16.1902 15.1784 16.0208C15.5157 15.8581 15.9643 15.7086 16.4725 15.5392L16.6641 15.4753L17.225 14.9145C17.36 14.7793 17.509 14.6302 17.6524 14.5208C17.8214 14.3919 18.0672 14.25 18.3942 14.25C18.7211 14.25 18.9669 14.3919 19.136 14.5208Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75H19.75L19.75 13.7315L19.7425 13.7258C19.4855 13.5297 19.0284 13.25 18.3942 13.25C17.7599 13.25 17.3028 13.5297 17.0458 13.7258C16.8479 13.8768 16.658 14.0671 16.5344 14.1908L16.1239 14.6013L16.113 14.605C15.6397 14.7626 15.1397 14.9292 14.744 15.12C14.3168 15.3261 13.6532 15.7228 13.3279 16.5367C13.2291 16.784 13.1676 17.0446 13.1454 17.31C13.0818 18.0703 13.3889 18.6625 13.6608 19.0508L13.5126 19.199C13.3493 19.3623 13.225 19.5498 13.1398 19.75H8.94797C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.25388 16.7289 4.25016 16.0238 4.25 15.1834L4.25 9.75ZM9.24999 12C9.24999 11.5858 9.58577 11.25 9.99999 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H9.99999C9.58577 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery pointer-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cursor","pointer","location","navigate","click","touch","select","delivery","gps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M14.8931 14.8929L14.536 14.5357"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3929 14.5357L17.7501 14.1786"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.1786 17.7506L14.5357 17.3934"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1233 19.8211L16.4841 17.4244C16.3337 16.8601 16.2584 16.5779 16.4137 16.4318C16.5691 16.2857 16.8461 16.3781 17.4002 16.5628L19.7174 17.3352C20.4673 17.5851 20.8422 17.7101 20.8525 17.9562C20.8627 18.2023 20.4994 18.358 19.7729 18.6693L19.2198 18.9064C19.1107 18.9531 19.0562 18.9765 19.0127 19.0153C18.9692 19.054 18.9398 19.1055 18.881 19.2085L18.4336 19.9914C18.0669 20.6331 17.8836 20.9539 17.6462 20.923C17.4089 20.8922 17.3137 20.5351 17.1233 19.8211Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery pointer-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","pet","animal","paw","shipping","order","tracking","pet-supplies","animal-supplies"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M15.3931 15.3929L15.036 15.0357"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.8929 15.0357L18.2501 14.6786"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6786 18.2506L15.0357 17.8934"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6233 20.3211L16.9841 17.9244C16.8337 17.3601 16.7584 17.0779 16.9137 16.9318C17.0691 16.7857 17.3461 16.8781 17.9002 17.0628L20.2174 17.8352C20.9673 18.0851 21.3422 18.2101 21.3525 18.4562C21.3627 18.7023 20.9994 18.858 20.2729 19.1693L19.7198 19.4064C19.6107 19.4531 19.5562 19.4765 19.5127 19.5153C19.4692 19.554 19.4398 19.6055 19.381 19.7085L18.9336 20.4914C18.5669 21.1331 18.3836 21.4539 18.1462 21.423C17.9089 21.3922 17.8137 21.0351 17.6233 20.3211Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery pointer-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","pointer","location","map","gps","navigation","shipping","tracking","address","destination","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.07896 4.25H11.25V8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53175 5.01874 6.0729C5.20433 5.58575 5.45018 5.15958 5.86917 4.83244C6.28816 4.5053 6.76124 4.37015 7.27885 4.30826C7.76638 4.24996 8.36669 4.24998 9.07896 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052L4.25 9.75H19.75L19.75 15.052C19.75 15.1018 19.75 15.1512 19.75 15.2001C19.6158 14.7268 19.3843 14.2814 19.132 14.0182L19.1247 14.0105L19.1172 14.003C18.4885 13.3744 17.4865 13.3955 16.8681 13.9881L16.8415 14.0137L16.5746 14.3102L16.5572 14.2928C15.9286 13.6642 14.9266 13.6853 14.3082 14.2779L14.3006 14.2853L14.293 14.2928C13.6644 14.9214 13.6856 15.9235 14.2782 16.5418L14.2855 16.5495L14.3109 16.5749L14.3028 16.583L14.0128 16.873C13.3841 17.5016 13.4053 18.5037 13.9979 19.122L14.0052 19.1297L14.0128 19.1372C14.2126 19.337 14.5615 19.5623 14.9577 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052ZM9.24999 12C9.24999 11.5858 9.58578 11.25 9.99999 11.25H13.5C13.9142 11.25 14.25 11.5858 14.25 12C14.25 12.4142 13.9142 12.75 13.5 12.75H9.99999C9.58578 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514L19.5856 8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.5601 14.7101L17.2901 15.0101C17.2901 15.0101 17.2301 15.1001 17.2001 15.1401C17.1701 15.1901 17.1501 15.2501 17.1401 15.3001C17.1001 15.4901 17.1401 15.7001 17.2901 15.8501C17.2901 15.8501 17.2901 15.8501 17.3001 15.8501C17.5101 16.0501 17.8301 16.0601 18.0601 15.8901C18.0801 15.8701 18.1101 15.8601 18.1301 15.8401L18.4101 15.5601C18.64 15.3301 18.64 14.9501 18.4101 14.7101C18.1801 14.4801 17.8001 14.4801 17.5601 14.7101Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M20.7101 17.5201C20.6301 17.4601 20.5701 17.4101 20.5201 17.3801C20.3301 17.2901 20.0701 17.2001 19.8001 17.1101C19.7901 17.1101 19.7801 17.1101 19.7601 17.1001L18.6401 16.7301L17.9101 16.4901C17.9101 16.4901 17.8901 16.4901 17.8801 16.4801C17.6901 16.4201 17.3914 16.3401 17.2214 16.3101C17.1914 16.3101 17.2401 16.3201 17.2001 16.3101C17.0101 16.2901 16.7601 16.3101 16.5301 16.5101C16.5301 16.5101 16.5101 16.5301 16.5001 16.5401C16.2801 16.7601 16.2601 17.0301 16.2701 17.2201C16.2701 17.2401 16.2701 17.2701 16.2701 17.2901C16.2901 17.4601 16.3501 17.7001 16.4001 17.9001C16.4001 17.8901 16.4001 17.9101 16.4001 17.9001L16.6301 18.7601L16.9101 19.8201C16.9801 20.0701 17.0401 20.3601 17.1201 20.5501C17.1401 20.6001 17.1801 20.6801 17.2301 20.7501C17.3401 20.9201 17.5101 21.1001 17.8201 21.1401C18.2601 21.2001 18.5301 20.8901 18.6501 20.7401C18.6801 20.7001 18.7201 20.6401 18.7501 20.5801C18.8401 20.4401 18.9301 20.2901 19.0301 20.1201C19.0301 20.1101 19.0401 20.1001 19.0501 20.0901L19.4001 19.4701L19.8301 19.2801C19.8301 19.2801 19.8501 19.2701 19.8701 19.2601C20.1001 19.1601 20.3201 19.0601 20.4901 18.9701C20.5101 18.9601 20.5401 18.9501 20.5601 18.9401C20.7201 18.8401 21.0801 18.6001 21.0601 18.1401C21.0501 17.8301 20.8701 17.6401 20.7101 17.5201Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.2701 15.4899C16.2401 15.4199 16.2001 15.3499 16.1401 15.2899L15.8501 14.9999C15.6201 14.7699 15.2401 14.7699 15.0001 14.9999C14.7701 15.2299 14.7701 15.6099 15.0001 15.8499L15.2901 16.1399C15.3501 16.1899 15.4101 16.2399 15.4801 16.2599C15.6501 16.3299 15.8401 16.3099 16.0001 16.2299C16.0501 16.1999 16.1001 16.1799 16.1401 16.1399C16.1801 16.0999 16.2001 16.0499 16.2301 16.0099C16.3201 15.8499 16.3401 15.6599 16.2701 15.4899Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M15.5199 18.4601C15.5199 18.4601 15.5499 18.4301 15.5699 18.4201L15.8599 18.1301C16.0899 17.9001 16.0899 17.5301 15.8599 17.2901C15.6999 17.1301 15.4799 17.0901 15.2799 17.1401C15.2299 17.1501 15.1899 17.1701 15.1399 17.2001C15.0899 17.2301 15.0499 17.2501 15.0099 17.2901L14.7199 17.5801C14.4899 17.8101 14.4899 18.1901 14.7199 18.4301C14.9399 18.6501 15.2899 18.6601 15.5199 18.4601Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery process-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["eye","vision","view","focus","scan","track","observation","monitor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery pointer": {
        defaultColors: ["#000000"],
        keywords: ["delivery","pointer","gps","location","map","shipping","tracking","order-tracking","delivery-tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M14.8931 14.8929L14.536 14.5357"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3929 14.5357L17.7501 14.1786"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.1786 17.7506L14.5357 17.3934"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.1233 19.8211L16.4841 17.4244C16.3337 16.8601 16.2584 16.5779 16.4137 16.4318C16.5691 16.2857 16.8461 16.3781 17.4002 16.5628L19.7174 17.3352C20.4673 17.5851 20.8422 17.7101 20.8525 17.9562C20.8627 18.2023 20.4994 18.358 19.7729 18.6693L19.2198 18.9064C19.1107 18.9531 19.0562 18.9765 19.0127 19.0153C18.9692 19.054 18.9398 19.1055 18.881 19.2085L18.4336 19.9914C18.0669 20.6331 17.8836 20.9539 17.6462 20.923C17.4089 20.8922 17.3137 20.5351 17.1233 19.8211Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery process-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["delivery","package","shipping","box","cart","order","delivery-cart","moving","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery process-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","process","shipping","package","box","order","transit","send","outgoing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H13.8127C13.3016 19.0485 13 18.1844 13 17.25C13 14.9028 14.9028 13 17.25 13C18.1844 13 19.0485 13.3016 19.75 13.8127L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 17.25C14 15.4551 15.4551 14 17.25 14C19.0449 14 20.5 15.4551 20.5 17.25C20.5 19.0449 19.0449 20.5 17.25 20.5C15.4551 20.5 14 19.0449 14 17.25ZM18.1341 17.4268C18.427 17.1339 18.427 16.659 18.1341 16.3662C17.8412 16.0733 17.3663 16.0733 17.0734 16.3662L16.7197 16.7199C16.4268 17.0128 16.4268 17.4877 16.7197 17.7806C17.0126 18.0735 17.4874 18.0735 17.7803 17.7806L18.1341 17.4268Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery process": {
        defaultColors: ["#000000"],
        keywords: ["delivery","process","shipping","order","status","track","package","transit","box","truck","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20C18.8807 20 20 18.8807 20 17.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 17.5003L17.783 17.2172L17.8538 17.1465"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery receive-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","left","back","previous","return","cancel","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L14 17L16 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17L19 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery receive-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","return","arrow-left","order-return","shipment-return","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M16 15L14 17L16 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery receive-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","receive","box","package","add","plus","order","add-order","inventory","stock","receiving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 4.25H9.07896H9.07894C8.36666 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25ZM4.25 9.75L4.25 15.052V15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.2751L13.7625 19.2374C13.0791 18.554 13.0792 17.446 13.7626 16.7625L15.7626 14.7626C16.446 14.0791 17.554 14.0791 18.2374 14.7626C18.6429 15.168 18.8078 15.723 18.7322 16.25L19.741 16.25C19.75 15.886 19.75 15.4864 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999ZM12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H14.921H12.75V8.25ZM15.3536 18L15.8447 17.5088C15.8559 17.5506 15.8699 17.592 15.8868 17.6327C15.9464 17.7765 16.0371 17.9011 16.1492 18C16.0371 18.0988 15.9464 18.2234 15.8868 18.3673C15.8699 18.408 15.8559 18.4494 15.8447 18.4911L15.3536 18Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5303 20.5303C17.2374 20.8232 16.7625 20.8232 16.4696 20.5303L14.4697 18.5303C14.1768 18.2374 14.1768 17.7625 14.4697 17.4697L16.4697 15.4697C16.7626 15.1768 17.2374 15.1768 17.5303 15.4697C17.8232 15.7626 17.8232 16.2374 17.5303 16.5303L16.8107 17.25L20 17.25C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75L16.8106 18.75L17.5303 19.4697C17.8232 19.7626 17.8232 20.2374 17.5303 20.5303Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery refresh-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["refresh","update","reload","sync","repeat","circular-arrows","resync","refresh-data","update-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9972 17.998C18.8573 18.4208 18.6217 18.8055 18.3087 19.1221C17.6403 19.7903 16.696 20.1042 15.7607 19.969C14.8253 19.8339 14.0085 19.2655 13.5566 18.4355"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 15.5644C18.3694 14.7343 17.5526 14.166 16.6172 14.0308C15.6819 13.8957 14.7376 14.2096 14.0692 14.8777C13.7556 15.1944 13.519 15.579 13.3779 16.0018"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 15.5657H18.9973V14.2402"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 18.4326H13.3823V19.7581"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery receive": {
        defaultColors: ["#000000"],
        keywords: ["box","package","receive","delivery","inventory","stock","arrival","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16 15L14 17L16 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery refresh-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","refresh","reload","update","delivery","resupply","restock","inventory-update","order-update","shipment-update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.9972 17.998C18.8573 18.4208 18.6217 18.8055 18.3087 19.1221C17.6403 19.7903 16.696 20.1042 15.7607 19.969C14.8253 19.8339 14.0085 19.2655 13.5566 18.4355"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 15.5644C18.3694 14.7343 17.5526 14.166 16.6172 14.0308C15.6819 13.8957 14.7376 14.2096 14.0692 14.8777C13.7556 15.1944 13.519 15.579 13.3779 16.0018"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 15.5657H18.9973V14.2402"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 18.4326H13.3823V19.7581"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery refresh-3": {
        defaultColors: ["#000000"],
        keywords: ["refresh","update","reload","resync","delivery","shipping","package","arrows","circular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H12.5045V18.9419C12.5045 18.5352 12.6433 18.1609 12.876 17.8637C12.5241 17.4164 12.3968 16.8064 12.5905 16.2262C12.801 15.5954 13.1539 15.0216 13.6219 14.5491L13.6245 14.5465L13.6314 14.5396C14.6157 13.5576 16.0052 13.0966 17.3814 13.2954C17.7789 13.3529 18.1618 13.4634 18.5215 13.621C18.7426 13.52 18.9885 13.4635 19.2477 13.4635C19.4223 13.4635 19.5909 13.489 19.75 13.5366L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.3352 15.2502C15.0968 14.4888 16.1728 14.1311 17.2386 14.2851C17.7377 14.3572 18.2071 14.5376 18.6181 14.806C18.7518 14.5999 18.9839 14.4635 19.2479 14.4635C19.6621 14.4635 19.9979 14.7993 19.9979 15.2135V16.3922C19.9979 16.8064 19.6621 17.1422 19.2479 17.1422H18.0675C17.6533 17.1422 17.3175 16.8064 17.3175 16.3922C17.3175 16.2051 17.386 16.034 17.4994 15.9026C17.349 15.8387 17.1894 15.7936 17.0241 15.7697C16.427 15.6834 15.8241 15.8835 15.397 16.3097C15.1998 16.5092 15.051 16.7515 14.9621 17.0177C14.831 17.4106 14.4061 17.6228 14.0132 17.4916C13.6203 17.3605 13.4081 16.9357 13.5393 16.5428C13.7012 16.0576 13.9727 15.6162 14.3326 15.2528L14.3352 15.2502ZM19.4835 17.8436C19.8768 17.9737 20.0901 18.3979 19.9599 18.7912C19.7993 19.2768 19.5286 19.7187 19.169 20.0825L19.1659 20.0856C18.4043 20.847 17.3283 21.2047 16.2625 21.0507C15.7635 20.9786 15.2942 20.7983 14.8833 20.5299C14.7494 20.735 14.5179 20.8706 14.2548 20.8706C13.8405 20.8706 13.5048 20.5348 13.5048 20.1206V18.9418C13.5048 18.5276 13.8405 18.1918 14.2548 18.1918H15.4327C15.8469 18.1918 16.1827 18.5276 16.1827 18.9418C16.1827 19.1294 16.1138 19.3009 16 19.4325C16.1509 19.4968 16.311 19.5421 16.477 19.5661C17.074 19.6523 17.6767 19.4524 18.1038 19.0264C18.3002 18.8273 18.448 18.5855 18.5359 18.32C18.666 17.9267 19.0903 17.7134 19.4835 17.8436Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery remove-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cancel","remove","delete","close","exit","cross","error","reject","void","discard","clear","eliminate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L19 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15L15 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery refresh": {
        defaultColors: ["#000000"],
        keywords: ["delivery","refresh","update","reload","arrows","shipping","package","status","delivery-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9972 17.998C18.8573 18.4208 18.6217 18.8055 18.3087 19.1221C17.6403 19.7903 16.696 20.1042 15.7607 19.969C14.8253 19.8339 14.0085 19.2655 13.5566 18.4355"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 15.5644C18.3694 14.7343 17.5526 14.166 16.6172 14.0308C15.6819 13.8957 14.7376 14.2096 14.0692 14.8777C13.7556 15.1944 13.519 15.579 13.3779 16.0018"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 15.5657H18.9973V14.2402"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 18.4326H13.3823V19.7581"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery remove-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","remove","delete","cancel","order","remove-order","cancel-order","return","shipment","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M15 15L19 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15L15 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery remove-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","remove","box","package","minus","subtract","order","delete-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7197 15.4697C16.0126 15.1768 16.4874 15.1768 16.7803 15.4697L17.75 16.4393L18.7197 15.4697C19.0126 15.1768 19.4874 15.1768 19.7803 15.4697C20.0732 15.7626 20.0732 16.2374 19.7803 16.5303L18.8107 17.5L19.7803 18.4697C20.0732 18.7626 20.0732 19.2374 19.7803 19.5303C19.4874 19.8232 19.0126 19.8232 18.7197 19.5303L17.75 18.5607L16.7803 19.5303C16.4874 19.8232 16.0126 19.8232 15.7197 19.5303C15.4268 19.2374 15.4268 18.7626 15.7197 18.4697L16.6893 17.5L15.7197 16.5303C15.4268 16.2374 15.4268 15.7626 15.7197 15.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.6683C14.3603 19.1003 14.475 18.3001 15.0126 17.7626L15.2751 17.5L15.0126 17.2374C14.3291 16.554 14.3291 15.446 15.0126 14.7626C15.696 14.0791 16.804 14.0791 17.4874 14.7626L17.75 15.0251L18.0126 14.7626C18.4829 14.2923 19.1543 14.1456 19.75 14.3226L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery remove": {
        defaultColors: ["#000000"],
        keywords: ["delivery","remove","box","package","delete","cancel","order","remove-order","cancel-order","package-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L19 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 15L15 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery reshare-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["sync","resync","refresh","reload","update","arrows","circular","repeat","reorder","exchange","loop","cycle","rotate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery reshare-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","reshare","return","transfer","redelivery","shipping","order-transfer","package-return","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery reshare-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","reshare","share","forward","order","delivery-order","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.52564 7.80513L4.41442 8.25H11.25V4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.4744 7.80514L19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11409 19.4744 7.80514Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.423 13.9697C19.1302 13.6768 18.6553 13.6768 18.3624 13.9697C18.1886 14.1434 18.118 14.3812 18.1504 14.6071L16.245 14.6069C15.9242 14.6065 15.6281 14.6061 15.3659 14.6764C14.6634 14.8646 14.1147 15.4133 13.9264 16.1158C13.8562 16.3781 13.8566 16.6741 13.857 16.995L13.8571 17.0713C13.8571 17.4855 14.1929 17.8213 14.6071 17.8213C15.0213 17.8213 15.3571 17.4855 15.3571 17.0713C15.3571 16.6244 15.3635 16.5481 15.3753 16.5041C15.4249 16.3192 15.5693 16.1748 15.7541 16.1253C15.7982 16.1134 15.8745 16.107 16.3214 16.107L18.1504 16.1071C18.1179 16.333 18.1886 16.5708 18.3624 16.7446C18.6553 17.0375 19.1302 17.0375 19.423 16.7446L20.2802 15.8875C20.4208 15.7468 20.4999 15.5561 20.4999 15.3571C20.4999 15.1582 20.4208 14.9675 20.2802 14.8268L19.423 13.9697Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M15.9975 21.2815C15.7046 21.5744 15.2297 21.5744 14.9368 21.2815L14.0797 20.4244C13.939 20.2838 13.86 20.093 13.86 19.8941C13.86 19.8454 13.8647 19.7971 13.874 19.75C13.9024 19.6047 13.9735 19.47 14.0797 19.3637L14.9368 18.5066C15.2297 18.2137 15.7046 18.2137 15.9975 18.5066C16.1713 18.6804 16.2419 18.9182 16.2095 19.1441L18.0385 19.1442C18.4853 19.1442 18.5616 19.1378 18.6057 19.126C18.7906 19.0764 18.935 18.932 18.9845 18.7472C18.9963 18.7031 19.0028 18.6268 19.0028 18.1799C19.0028 17.801 19.2839 17.4876 19.6489 17.4371C19.6829 17.4324 19.7175 17.4299 19.7528 17.4299C20.167 17.4299 20.5028 17.7657 20.5028 18.1799L20.5029 18.2563C20.5033 18.5771 20.5037 18.8731 20.4334 19.1354C20.2452 19.8379 19.6965 20.3866 18.994 20.5749C18.7317 20.6451 18.4357 20.6447 18.1149 20.6443L16.2095 20.6441C16.2419 20.87 16.1712 21.1078 15.9975 21.2815Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75L12.8661 19.75C12.9001 19.3386 13.0787 18.9507 13.3727 18.6566L13.5576 18.4717C13.1323 18.1525 12.8572 17.644 12.8572 17.0713L12.8571 16.9504C12.8563 16.6643 12.8553 16.2503 12.9607 15.857C13.2414 14.8094 14.0596 13.9911 15.1072 13.7104C15.5005 13.6051 15.9145 13.6061 16.2006 13.6068L16.2465 13.6069L17.3875 13.607L17.6554 13.2626C18.2229 12.6951 19.0832 12.5988 19.75 12.9738L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery reshare": {
        defaultColors: ["#000000"],
        keywords: ["unavailable","not-available","not-found","error","disabled","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 18.2368 19.0003 18.6409 18.7492 18.8919C18.4982 19.143 18.0941 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery return-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","return","refund","delivery-return","order-return","item-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1431 14L15.7246 14.4184C15.2485 14.8946 15.0104 15.1327 15.0104 15.4286C15.0104 15.7244 15.2485 15.9625 15.7246 16.4387L16.1431 16.8571"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery return-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["return","arrow","undo","refund","reverse","transaction-reversal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1431 14L15.7246 14.4184C15.2485 14.8946 15.0104 15.1327 15.0104 15.4286C15.0104 15.7244 15.2485 15.9625 15.7246 16.4387L16.1431 16.8571"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery return-3": {
        defaultColors: ["#000000"],
        keywords: ["return","delivery","box","package","reverse","refund","exchange","send-back","sales-return","rma"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.27885 4.30826C7.76638 4.24996 8.36666 4.24998 9.07894 4.25H11.25V8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53175 5.01874 6.0729C5.20433 5.58575 5.45018 5.15958 5.86917 4.83244C6.28816 4.5053 6.76124 4.37015 7.27885 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75H19.75L19.75 15.8019C19.75 16.0331 19.75 16.2544 19.7487 16.4657C19.7483 16.6171 19.7476 16.7629 19.7465 16.9052L19.7433 16.8952C19.7348 16.8684 19.7259 16.8418 19.7166 16.8154C19.338 15.7388 18.3235 14.9627 17.1179 14.9627H15.6689L15.804 14.8276C16.0708 14.5608 16.0708 14.1273 15.804 13.8605C15.5372 13.5938 15.1037 13.5938 14.8369 13.8605L14.4292 14.2682C14.235 14.4625 14.0432 14.6542 13.9065 14.8334C13.7514 15.0369 13.6039 15.3028 13.6039 15.6471C13.6039 15.9914 13.7514 16.2574 13.9065 16.4608C14.0432 16.64 14.2341 16.8318 14.4292 17.026L14.8369 17.4337C15.1037 17.7005 15.5372 17.7005 15.804 17.4337C16.0708 17.1669 16.0708 16.7334 15.804 16.4666L15.6689 16.3316H17.1179C17.8915 16.3316 18.5185 16.9585 18.5185 17.7322C18.5185 18.5058 17.8915 19.1328 17.1179 19.1328H13.3663C13.011 19.1328 12.7192 19.4035 12.6858 19.75L8.94798 19.75C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052L4.25 9.75ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13C13.4142 12.75 13.75 12.4142 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery return": {
        defaultColors: ["#000000"],
        keywords: ["delivery","return","box","package","arrow","undo","exchange","refund","inventory","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1431 14L15.7246 14.4184C15.2485 14.8946 15.0104 15.1327 15.0104 15.4286C15.0104 15.7244 15.2485 15.9625 15.7246 16.4387L16.1431 16.8571"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery search-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["search","find","magnify","lookup","inventory-search","customer-search","product-search","transaction-search","locate","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery search-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["delivery","truck","package","shipping","transport","box","moving","vehicle","distribution","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery search-3": {
        defaultColors: ["#000000"],
        keywords: ["search","find","delivery","package","magnify","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H14.2519C13.6292 19.0599 13.25 18.1456 13.25 17.1429C13.25 14.9929 14.9929 13.25 17.1429 13.25C18.1456 13.25 19.0599 13.6292 19.75 14.2519L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 17.1429C14.25 15.5452 15.5452 14.25 17.1429 14.25C18.7405 14.25 20.0357 15.5452 20.0357 17.1429C20.0357 17.6691 19.8948 18.1631 19.649 18.5884L20.5303 19.4697C20.8232 19.7626 20.8232 20.2374 20.5303 20.5303C20.2374 20.8232 19.7626 20.8232 19.4697 20.5303L18.5884 19.649C18.1631 19.8948 17.6691 20.0357 17.1429 20.0357C15.5452 20.0357 14.25 18.7405 14.25 17.1429ZM17.1429 15.75C16.3736 15.75 15.75 16.3736 15.75 17.1429C15.75 17.9121 16.3736 18.5357 17.1429 18.5357C17.5277 18.5357 17.8749 18.3806 18.1278 18.1278C18.3806 17.8749 18.5357 17.5277 18.5357 17.1429C18.5357 16.3736 17.9121 15.75 17.1429 15.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery search": {
        defaultColors: ["#000000"],
        keywords: ["delivery","search","magnifier","truck","shipping","find","track","package-search","delivery-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6581 18.6581L20 20M18.6581 18.6581C19.0459 18.2703 19.2857 17.7346 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857C17.7346 19.2857 18.2703 19.0459 18.6581 18.6581Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery secure-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["lock","secure","security","protected","access","authorization","verified","safe","lockdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="15"
                    y="17.875"
                    width="4.375"
                    height="3.125"
                    rx="0.9375"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4375 17.875V17.25C18.4375 16.5596 17.8779 16 17.1875 16V16C16.4971 16 15.9375 16.5596 15.9375 17.25V17.875"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery secure-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","secure","locked","order-security","secure-delivery","secure-order","lock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <rect x="15" y="17.875" width="4.375" height="3.125" rx="0.9375" fill={colors?.[2] || "#000000"} stroke={colors?.[2] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M18.4375 17.875V17.25C18.4375 16.5596 17.8779 16 17.1875 16V16C16.4971 16 15.9375 16.5596 15.9375 17.25V17.875"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery secure-3": {
        defaultColors: ["#000000"],
        keywords: ["secure","delivery","padlock","lock","security","shipping","protection","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.27885 4.30826C7.76638 4.24996 8.36666 4.24998 9.07894 4.25H11.25V8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53175 5.01874 6.0729C5.20433 5.58575 5.45018 5.15958 5.86917 4.83244C6.28816 4.5053 6.76124 4.37015 7.27885 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9375 14.75C15.8329 14.75 14.9375 15.6454 14.9375 16.75V16.8016C14.9062 16.8167 14.8749 16.8331 14.8438 16.8511C14.5872 16.9992 14.3742 17.2122 14.2261 17.4688C14.0864 17.7107 14.0392 17.9602 14.0188 18.1855C14 18.393 14 18.6414 14 18.9087V18.9662C14 19.2335 14 19.482 14.0188 19.6895C14.0206 19.7095 14.0226 19.7297 14.0249 19.75C14.0483 19.959 14.0988 20.1858 14.2261 20.4063C14.3742 20.6628 14.5872 20.8758 14.8438 21.0239C15.0857 21.1636 15.3352 21.2108 15.5605 21.2312C15.768 21.2501 16.0164 21.25 16.2838 21.25H17.5912C17.8585 21.25 18.107 21.2501 18.3145 21.2312C18.5398 21.2108 18.7893 21.1636 19.0313 21.0239C19.2878 20.8758 19.5008 20.6628 19.6489 20.4063C19.7886 20.1643 19.8358 19.9148 19.8562 19.6895C19.8751 19.482 19.875 19.2335 19.875 18.9662V18.9088C19.875 18.6415 19.8751 18.393 19.8562 18.1855C19.8358 17.9602 19.7886 17.7107 19.6489 17.4688L19.6448 17.4617C19.4969 17.2083 19.2854 16.9978 19.0313 16.8511C19.0001 16.8331 18.9688 16.8167 18.9375 16.8016V16.75C18.9375 15.6454 18.0421 14.75 16.9375 14.75ZM17.4218 16.625C17.3662 16.4093 17.1705 16.25 16.9375 16.25C16.7045 16.25 16.5088 16.4093 16.4533 16.625H17.4218Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052L4.25 9.75H19.75L19.75 15.052C19.75 15.2759 19.75 15.4915 19.7488 15.6967C19.3279 14.5584 18.2288 13.75 16.94 13.75C15.45 13.75 14.22 14.83 13.98 16.24C13.73 16.44 13.52 16.69 13.36 16.97C13.12 17.39 13.05 17.81 13.02 18.1C13 18.36 13 18.64 13 18.89V19C13 19.2368 13 19.5094 13.017 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.07773 19.5857 5.51093 19.4 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052ZM9.24999 12C9.24999 11.5858 9.58578 11.25 9.99999 11.25H13.5C13.9142 11.25 14.25 11.5858 14.25 12C14.25 12.4142 13.9142 12.75 13.5 12.75H9.99999C9.58578 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery secure": {
        defaultColors: ["#000000"],
        keywords: ["box","package","secure","lock","delivered","delivery","safe","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="15" y="17.875" width="4.375" height="3.125" rx="0.9375" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M18.4375 17.875V17.25C18.4375 16.5596 17.8779 16 17.1875 16V16C16.4971 16 15.9375 16.5596 15.9375 17.25V17.875"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery sent-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","sent","outgoing","ship","shipping","order","order-sent","order-shipped"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M17 15L19 17L17 19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery sent-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","send","next","proceed","forward","submit","checkout","process","continue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15L19 17L17 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L14 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery sent-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","sent","package","shipping","delivered","truck","transit","box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 4.25H9.07896H9.07894C8.36666 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25ZM4.25 9.75L4.25 15.052V15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.0959 19.75 15.1394 19.75 15.1826 19.75L15 19.75C14.0335 19.75 13.25 18.9665 13.25 18C13.25 17.0335 14.0335 16.25 15 16.25L16.2679 16.25C16.1922 15.723 16.3571 15.168 16.7626 14.7625C17.446 14.0791 18.5541 14.0792 19.2375 14.7626L19.75 15.2751C19.75 15.2018 19.75 15.1274 19.75 15.052L19.75 9.75H4.25ZM19.5459 17.8994L19.1553 17.5089C19.1441 17.5506 19.1301 17.592 19.1132 17.6327C19.0536 17.7766 18.9629 17.9012 18.8508 18C18.9629 18.0989 19.0536 18.2235 19.1132 18.3673C19.1301 18.408 19.1441 18.4494 19.1553 18.4912L19.4351 18.2114C19.478 18.1102 19.5146 18.0061 19.5459 17.8994ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H9.99999ZM12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H14.921H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4697 15.4697C17.7626 15.1768 18.2375 15.1768 18.5304 15.4697L20.5303 17.4697C20.8232 17.7626 20.8232 18.2375 20.5303 18.5303L18.5303 20.5303C18.2374 20.8232 17.7626 20.8232 17.4697 20.5303C17.1768 20.2374 17.1768 19.7626 17.4697 19.4697L18.1893 18.75L15 18.75C14.5858 18.75 14.25 18.4142 14.25 18C14.25 17.5858 14.5858 17.25 15 17.25L18.1894 17.25L17.4697 16.5303C17.1768 16.2374 17.1768 15.7626 17.4697 15.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery sent": {
        defaultColors: ["#000000"],
        keywords: ["delivery","sent","package","box","shipping","delivered","order-shipped","order-delivered"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 15L19 17L17 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery setting-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["settings","options","gear","configuration","adjustments","preferences","setup","system-settings","point-of-sale-settings","pos-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery setting-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","settings","gear","cog","configure","delivery","shipping","order-settings","delivery-settings","package-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery setting-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","settings","shipping","gear","cog","configuration","options","system","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H13.1499C13.0266 19.6337 12.9182 19.4974 12.83 19.3425C12.4225 18.6275 12.5743 17.7465 13.1467 17.2052C13.1457 17.1704 13.1452 17.1356 13.1452 17.1006C13.1452 17.0657 13.1457 17.0308 13.1467 16.996C12.5743 16.4546 12.4225 15.5736 12.83 14.8586C13.241 14.1373 14.0876 13.8195 14.8504 14.0476C14.908 14.0121 14.9667 13.9782 15.0264 13.9459C15.2089 13.1743 15.9022 12.6001 16.7295 12.6001C17.557 12.6001 18.2503 13.1744 18.4327 13.9461C18.4923 13.9783 18.5509 14.0122 18.6084 14.0477C18.9894 13.9337 19.3916 13.9559 19.75 14.0968L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75L13.25 12.75C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25L9.99999 11.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7294 13.6001C17.1436 13.6001 17.4794 13.9359 17.4794 14.3501V14.6267C17.8635 14.743 18.2098 14.9463 18.4953 15.2136L18.7322 15.0763C19.0905 14.8685 19.5494 14.9906 19.7572 15.3489C19.9649 15.7073 19.8429 16.1662 19.4845 16.3739L19.2465 16.512C19.2905 16.7011 19.3138 16.8982 19.3138 17.1006C19.3138 17.3031 19.2905 17.5001 19.2465 17.6892L19.4845 17.8272C19.8429 18.035 19.9649 18.4939 19.7572 18.8522C19.5494 19.2106 19.0905 19.3326 18.7322 19.1249L18.4954 18.9876C18.2099 19.255 17.8636 19.4583 17.4794 19.5746V19.851C17.4794 20.2652 17.1436 20.601 16.7294 20.601C16.3151 20.601 15.9794 20.2652 15.9794 19.851V19.5746C15.5958 19.4586 15.2499 19.2558 14.9646 18.9891L14.7216 19.1276C14.3617 19.3327 13.9037 19.2072 13.6986 18.8474C13.4935 18.4875 13.619 18.0295 13.9789 17.8244L14.2127 17.6911C14.1685 17.5015 14.1451 17.3038 14.1451 17.1006C14.1451 16.8974 14.1685 16.6997 14.2128 16.51L13.9789 16.3767C13.619 16.1716 13.4935 15.7136 13.6986 15.3538C13.9037 14.9939 14.3617 14.8684 14.7216 15.0735L14.9648 15.2121C15.25 14.9454 15.5958 14.7427 15.9794 14.6267V14.3501C15.9794 13.9359 16.3151 13.6001 16.7294 13.6001ZM16.664 16.0182C16.3124 16.0391 16.0062 16.227 15.8236 16.5038C15.816 16.5196 15.8078 16.5352 15.799 16.5507C15.7877 16.5704 15.7757 16.5895 15.763 16.6078C15.6876 16.7556 15.6451 16.9231 15.6451 17.1006C15.6451 17.278 15.6875 17.4452 15.7627 17.5929C15.7755 17.6113 15.7876 17.6305 15.799 17.6504C15.8079 17.6661 15.8162 17.6819 15.8239 17.6979C16.0063 17.9742 16.3119 18.1618 16.6629 18.183C16.6848 18.1811 16.7069 18.1801 16.7294 18.1801C16.7518 18.1801 16.774 18.1811 16.7959 18.183C17.3641 18.1487 17.8138 17.677 17.8138 17.1006C17.8138 16.5239 17.3635 16.052 16.7948 16.0182C16.7732 16.0201 16.7514 16.021 16.7294 16.021C16.7073 16.021 16.6855 16.0201 16.664 16.0182Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery setting": {
        defaultColors: ["#000000"],
        keywords: ["delivery","setting","shipping","location","address","package","order","destination","customer","send","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.5334L15.0175 15.9876"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.8302L18.9784 18.2845"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.2845L15.0175 17.8302"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.9876L18.9784 15.5334"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 15.0747C17.6133 15.0747 18.4339 15.8966 18.4339 16.9091C18.4339 17.9216 17.6133 18.7435 16.5995 18.7435C15.5858 18.7435 14.7651 17.9228 14.7651 16.9091C14.7651 15.8954 15.5858 15.0747 16.5995 15.0747"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery shield-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["shield","security","protection","safe","guarantee","warranty","secure-payment","secure-transaction","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.0889V14.8571C14.8225 14.8571 16.3527 14.4258 17 14C17.6473 14.4258 19.1775 14.8571 20 14.8571V16.0889C20 17.9368 18.7631 19.5518 17 20C15.2369 19.5518 14 17.9368 14 16.0889Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery shield-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["damaged","box","package","broken","returned","issue","refund","delivery-problem","damaged-goods","faulty","incomplete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16.7408V15.7143C15.6854 15.7143 16.9606 15.3548 17.5 15C18.0394 15.3548 19.3146 15.7143 20 15.7143V16.7408C20 18.2807 18.9693 19.6265 17.5 20C16.0307 19.6265 15 18.2807 15 16.7408Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery shield-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shield","protection","secure","safe","shipping","insurance","guarantee","warranty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69838 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.1616 19.75 15.269 19.75 15.3741 19.7499C14.7406 18.9024 14.375 17.8524 14.375 16.7408V15.7143C14.375 14.8168 15.1025 14.0893 16 14.0893C16.1259 14.0893 16.4509 14.0436 16.8602 13.9272C17.0552 13.8717 17.229 13.8116 17.3677 13.7554C17.4368 13.7273 17.4933 13.7019 17.5368 13.6804C17.5583 13.6697 17.5752 13.6608 17.5876 13.6538L17.6019 13.6456L17.6056 13.6432L17.6066 13.6426C18.1486 13.2861 18.8511 13.2859 19.3931 13.6424L19.3944 13.6432L19.3982 13.6456L19.4124 13.6538C19.4248 13.6608 19.4417 13.6697 19.4632 13.6804C19.5067 13.7019 19.5632 13.7273 19.6323 13.7554C19.6692 13.7703 19.7085 13.7855 19.75 13.8008L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.625C14.0392 12.75 14.375 12.4142 14.375 12C14.375 11.5858 14.0392 11.25 13.625 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M18.8435 14.4779C18.635 14.3407 18.365 14.3407 18.1565 14.4779C17.9666 14.6028 17.5854 14.7606 17.1338 14.8891C16.686 15.0164 16.2594 15.0893 16 15.0893C15.6548 15.0893 15.375 15.3691 15.375 15.7143V16.7408C15.375 18.5593 16.5927 20.1601 18.346 20.6057C18.4471 20.6314 18.5529 20.6314 18.654 20.6057C20.4073 20.1601 21.625 18.5593 21.625 16.7408V15.7143C21.625 15.3691 21.3452 15.0893 21 15.0893C20.7406 15.0893 20.314 15.0164 19.8662 14.8891C19.4146 14.7606 19.0334 14.6028 18.8435 14.4779Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery shield": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shield","protection","secure","order","delivery-order","safe-delivery","guarantee","insurance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.0889V14.8571C14.8225 14.8571 16.3527 14.4258 17 14C17.6473 14.4258 19.1775 14.8571 20 14.8571V16.0889C20 17.9368 18.7631 19.5518 17 20C15.2369 19.5518 14 17.9368 14 16.0889Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery time-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","delivery","favorite","liked","save","saved-order","wishlist","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 18C21 19.6603 19.6603 21 18 21C16.3397 21 15 19.6603 15 18C15 16.3397 16.3397 15 18 15C19.6603 15 21 16.3397 21 18Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6122 18.1835H17.5713V17.1431"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery time-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["clock","time","delivery","schedule","appointment","timer","wait","delivery-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 17.5C21 19.437 19.437 21 17.5 21C15.563 21 14 19.437 14 17.5C14 15.563 15.563 14 17.5 14C19.437 14 21 15.563 21 17.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2144 17.7138H17V16.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery time-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","time","clock","shipping","package","arrival","deadline","schedule","express","fast","timer","delivery-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.27885 4.30826C7.76638 4.24996 8.36666 4.24998 9.07894 4.25H11.25V8.25H4.41442L4.52564 7.80513C4.69838 7.11408 4.84394 6.53175 5.01874 6.0729C5.20433 5.58575 5.45018 5.15958 5.86917 4.83244C6.28816 4.5053 6.76124 4.37015 7.27885 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.75 15.4232C20.2183 15.9864 20.5 16.7103 20.5 17.5C20.5 19.2949 19.0449 20.75 17.25 20.75C16.4603 20.75 15.7364 20.4683 15.1732 20C15.0791 19.9217 14.9895 19.8383 14.9048 19.75C14.3444 19.1661 14 18.3733 14 17.5C14 15.7051 15.4551 14.25 17.25 14.25C18.2552 14.25 19.1539 14.7064 19.75 15.4232ZM17.75 16.25C17.75 15.8358 17.4142 15.5 17 15.5C16.5858 15.5 16.25 15.8358 16.25 16.25V17.4638C16.25 17.878 16.5858 18.2138 17 18.2138H18.2144C18.6286 18.2138 18.9644 17.878 18.9644 17.4638C18.9644 17.0496 18.6286 16.7138 18.2144 16.7138H17.75V16.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H13.6438C13.2358 19.0975 13 18.3263 13 17.5C13 15.1528 14.9028 13.25 17.25 13.25C18.1844 13.25 19.0485 13.5516 19.75 14.0627L19.75 9.75H4.25ZM9.99999 11.25C9.58578 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58578 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery time": {
        defaultColors: ["#000000"],
        keywords: ["delivery","time","clock","shipping","order","package","delivery-time","calendar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.5M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 17.5C21 19.437 19.437 21 17.5 21C15.563 21 14 19.437 14 17.5C14 15.563 15.563 14 17.5 14C19.437 14 21 15.563 21 17.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2144 17.7138H17V16.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery view-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["eye","view","visibility","observe","details","review","preview","monitor","track","customer-view","order-details","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1999 19C17.2837 18.9989 18.2526 18.3585 18.8961 17.3528C19.0345 17.1365 19.0345 16.8635 18.8961 16.6472C18.2526 15.6416 17.2837 15.0011 16.1999 15C15.1161 15.0011 14.1472 15.6416 13.5037 16.6472C13.3653 16.8635 13.3653 17.1365 13.5037 17.3528C14.1472 18.3585 15.1161 18.9989 16.1999 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.15 17.6999C16.509 17.6999 16.8 17.4089 16.8 17.0499C16.8 16.6909 16.509 16.3999 16.15 16.3999C15.791 16.3999 15.5 16.6909 15.5 17.0499C15.5 17.4089 15.791 17.6999 16.15 17.6999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery view-3": {
        defaultColors: ["#000000"],
        keywords: ["view","delivery","list","status","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 4.25H9.07896C8.36668 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53174 4.69837 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.5856 8.25H12.75V4.25H14.921C15.6333 4.24998 16.2336 4.24996 16.7212 4.30826C17.2388 4.37015 17.7118 4.5053 18.1308 4.83244C18.5498 5.15958 18.7957 5.58575 18.9813 6.0729C19.1561 6.53175 19.3016 7.11408 19.4744 7.80514L19.5856 8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2069 19.9964C16.7306 19.9727 17.2219 19.8333 17.6688 19.6048C18.3587 19.252 18.943 18.6868 19.3779 18.0071C19.674 17.5444 19.674 16.9557 19.3779 16.493C18.6333 15.3293 17.4513 14.5015 16.0508 14.5H16.0492C14.6487 14.5015 13.4667 15.3293 12.7221 16.493C12.426 16.9557 12.426 17.5444 12.7221 18.0071C13.2229 18.7897 13.9216 19.4204 14.7515 19.75C15.1285 19.8997 15.5326 19.9873 15.9575 19.9987C15.9879 19.9995 16.0185 20 16.0492 20H16.0508C16.1031 19.9999 16.1552 19.9987 16.2069 19.9964ZM16.6501 17.2999C16.6501 17.6589 16.3591 17.9499 16.0001 17.9499C15.6411 17.9499 15.3501 17.6589 15.3501 17.2999C15.3501 16.9409 15.6411 16.6499 16.0001 16.6499C16.3591 16.6499 16.6501 16.9409 16.6501 17.2999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 15.052L4.25 9.75H19.75L19.75 13L19.75 15.052C19.75 15.1413 19.75 15.2291 19.7499 15.3155C18.8593 14.2608 17.5816 13.5016 16.0518 13.5L16.0492 13.5L16.0482 13.5C14.224 13.5019 12.7582 14.5812 11.8797 15.954C11.3734 16.7453 11.3734 17.7548 11.8798 18.5461C12.1614 18.9862 12.5034 19.3961 12.8981 19.75H8.94798C8.04951 19.75 7.3003 19.7501 6.70552 19.6701C6.13609 19.5935 5.61684 19.4337 5.18533 19.0647C5.1411 19.0269 5.0978 18.9869 5.05546 18.9445C4.59999 18.4891 4.41432 17.9223 4.32991 17.2945C4.24995 16.6997 4.24997 15.9505 4.25 15.052ZM9.24999 12C9.24999 11.5858 9.58577 11.25 9.99999 11.25H13.25C13.6642 11.25 14 11.5858 14 12C14 12.4142 13.6642 12.75 13.25 12.75H9.99999C9.58577 12.75 9.24999 12.4142 9.24999 12Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery view-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["delivery","delivery-truck","truck","car","shipping","transport","vehicle","out-for-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8008 14.25H15.7992C14.3987 14.2515 13.2167 15.0793 12.4721 16.243C12.176 16.7057 12.176 17.2944 12.4721 17.7571C13.2167 18.9207 14.3987 19.7485 15.7992 19.75H15.8008C17.2013 19.7485 18.3833 18.9207 19.1279 17.7571C19.424 17.2944 19.424 16.7057 19.1279 16.243C18.3833 15.0793 17.2013 14.2515 15.8008 14.25ZM16.4001 17.0499C16.4001 17.4089 16.1091 17.6999 15.7501 17.6999C15.3911 17.6999 15.1001 17.4089 15.1001 17.0499C15.1001 16.6909 15.3911 16.3999 15.7501 16.3999C16.1091 16.3999 16.4001 16.6909 16.4001 17.0499Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery view": {
        defaultColors: ["#000000"],
        keywords: ["delivery","view","shipping","package","truck","delivery-truck","order","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H11.271M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1999 19C17.2837 18.9989 18.2526 18.3585 18.8961 17.3528C19.0345 17.1365 19.0345 16.8635 18.8961 16.6472C18.2526 15.6416 17.2837 15.0011 16.1999 15C15.1161 15.0011 14.1472 15.6416 13.5037 16.6472C13.3653 16.8635 13.3653 17.1365 13.5037 17.3528C14.1472 18.3585 15.1161 18.9989 16.1999 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.15 17.6999C16.509 17.6999 16.8 17.4089 16.8 17.0499C16.8 16.6909 16.509 16.3999 16.15 16.3999C15.791 16.3999 15.5 16.6909 15.5 17.0499C15.5 17.4089 15.791 17.6999 16.15 17.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery warning-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["triangle","warning","alert","caution","error","issue","problem","danger","attention","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery warning-2": {
        defaultColors: ["#cdd1d8", "#3d4c66", "#000000"],
        keywords: ["box","package","damaged","broken","defective","issue","problem","delivery-problem","shipment-problem","return","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9.49242C5 9.24652 5 9.12357 5.01498 9.00184C5.02997 8.88012 5.05979 8.76084 5.11943 8.52228L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8806 8.52228C18.9402 8.76084 18.97 8.88012 18.985 9.00184C19 9.12357 19 9.24652 19 9.49242V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    fill={colors?.[2] || "#000000"}
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18.4877 9H5.51231C5.27648 9 5.15857 9 5.09851 8.92308C5.03846 8.84616 5.06706 8.73177 5.12425 8.50299L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.8757 8.50299C18.9329 8.73177 18.9615 8.84616 18.9015 8.92308C18.8414 9 18.7235 9 18.4877 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9V5"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery warning-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","warning","alert","shipping","problem","issue","box","package","error","damaged"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7336 14.5757C17.0656 14.4748 17.4201 14.4748 17.7521 14.5757C18.1722 14.7035 18.4541 15.0068 18.6657 15.291C18.8727 15.569 19.0937 15.9449 19.3477 16.3766L19.389 16.4469C19.6496 16.8898 19.8757 17.2742 20.0209 17.5964C20.1687 17.9243 20.2997 18.3256 20.202 18.761C20.1251 19.1036 19.9469 19.4151 19.6906 19.6551C19.3648 19.9601 18.9526 20.0507 18.595 20.0895C18.2436 20.1277 17.7976 20.1277 17.2838 20.1277H17.2019C16.6881 20.1277 16.2421 20.1277 15.8908 20.0895C15.5332 20.0507 15.1209 19.9601 14.7952 19.6551C14.5389 19.4151 14.3607 19.1036 14.2838 18.761C14.186 18.3256 14.317 17.9243 14.4648 17.5964C14.61 17.2742 14.8362 16.8898 15.0967 16.4469C15.1036 16.4352 15.1105 16.4234 15.1175 16.4116C15.1244 16.3999 15.1312 16.3883 15.1381 16.3766C15.392 15.9449 15.6131 15.569 15.8201 15.291C16.0317 15.0068 16.3135 14.7035 16.7336 14.5757Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M11.25 4.25H9.07896C8.36669 4.24998 7.76638 4.24996 7.27885 4.30826C6.76124 4.37015 6.28816 4.5053 5.86917 4.83244C5.45018 5.15958 5.20433 5.58575 5.01874 6.0729C4.84394 6.53175 4.69837 7.11408 4.52564 7.80513L4.41442 8.25H11.25V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 9.75L4.25 15.052C4.24997 15.9505 4.24995 16.6997 4.32991 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H13.6111C13.4713 19.508 13.3681 19.2449 13.3068 18.9688C13.1368 18.2188 13.3868 17.5688 13.5568 17.1788C13.7268 16.8088 13.9768 16.3788 14.2168 15.9688L14.2968 15.8288C14.3368 15.7621 14.3768 15.6949 14.4168 15.6277C14.6168 15.2916 14.8168 14.9554 15.0168 14.6888C15.2668 14.3588 15.7068 13.8388 16.4368 13.6188C16.9568 13.4588 17.5168 13.4588 18.0468 13.6288C18.7768 13.8488 19.2168 14.3588 19.4668 14.6988C19.5612 14.8247 19.6556 14.966 19.75 15.1156C19.75 15.0945 19.75 15.0733 19.75 15.052L19.75 9.75H4.25ZM9.99999 11.25C9.58577 11.25 9.24999 11.5858 9.24999 12C9.24999 12.4142 9.58577 12.75 9.99999 12.75H13.25C13.6642 12.75 14 12.4142 14 12C14 11.5858 13.6642 11.25 13.25 11.25H9.99999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.75 8.25H19.5856L19.4744 7.80514C19.3016 7.11409 19.1561 6.53175 18.9813 6.0729C18.7957 5.58575 18.5498 5.15958 18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30826C16.2336 4.24996 15.6333 4.24998 14.9211 4.25H12.75V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery warning": {
        defaultColors: ["#000000"],
        keywords: ["delivery","warning","box","package","alert","shipping","problem","issue","error","notification","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H12M5 9H19M5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9M19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9V5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery-box-move-arows-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrows","move","transaction","scroll","navigation","swipe","shift","left-right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.3335V14.778C3 13.5209 3 12.8924 3.39052 12.5019C3.78105 12.1113 4.40959 12.1113 5.66667 12.1113H10.3333C11.5904 12.1113 12.219 12.1113 12.6095 12.5019C13 12.8924 13 13.5209 13 14.778V18.3336C13 19.5906 13 20.2192 12.6095 20.6097C12.219 21.0002 11.5904 21.0002 10.3333 21.0002H5.66667C4.40959 21.0002 3.78105 21.0002 3.39052 20.6097C3 20.2192 3 19.5906 3 18.3335Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14.651H8.47222C8.83887 14.651 9.02219 14.651 9.1361 14.5371C9.25 14.4232 9.25 14.2399 9.25 13.8732V12.8891C9.25 12.5225 9.25 12.3391 9.1361 12.2252C9.02219 12.1113 8.83887 12.1113 8.47222 12.1113H7.52778C7.16113 12.1113 6.97781 12.1113 6.8639 12.2252C6.75 12.3391 6.75 12.5225 6.75 12.8891V13.8732C6.75 14.2399 6.75 14.4232 6.8639 14.5371C6.97781 14.651 7.16113 14.651 7.52778 14.651H8Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11.8889H18.3333C19.5904 11.8889 20.219 11.8889 20.6095 11.4984C21 11.1078 21 10.4793 21 9.22222V5.66667C21 4.40959 21 3.78105 20.6095 3.39052C20.219 3 19.5904 3 18.3333 3H13.6667C12.4096 3 11.781 3 11.3905 3.39052C11 3.78105 11 4.40959 11 5.66667V7.44444V9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 5.53968H16.4722C16.8389 5.53968 17.0222 5.53968 17.1361 5.42578C17.25 5.31188 17.25 5.12855 17.25 4.7619V3.77778C17.25 3.41113 17.25 3.22781 17.1361 3.1139C17.0222 3 16.8389 3 16.4722 3H15.5278C15.1611 3 14.9778 3 14.8639 3.1139C14.75 3.22781 14.75 3.41113 14.75 3.77778V4.7619C14.75 5.12855 14.75 5.31188 14.8639 5.42578C14.9778 5.53968 15.1611 5.53968 15.5278 5.53968H16Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 18.5H16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 20.5L21 18.5L19 16.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 5.5H8"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 3.5L3 5.5L5 7.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "delivery-box-move-arows-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["boxes","packages","inventory","shipments","receive","received","shipping","multiple-orders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.61853 11.3613C5.03126 11.3613 4.51712 11.3613 4.10371 11.4168C3.65745 11.4768 3.21804 11.6137 2.8602 11.9715C2.50236 12.3294 2.3655 12.7688 2.30551 13.215C2.24993 13.6285 2.24996 14.1426 2.25 14.7299L2.25 18.3817C2.24996 18.969 2.24993 19.4831 2.30551 19.8965C2.3655 20.3428 2.50236 20.7822 2.8602 21.14C3.21804 21.4979 3.65745 21.6347 4.10371 21.6947C4.51712 21.7503 5.03125 21.7503 5.61852 21.7502H10.3815C10.9687 21.7503 11.4829 21.7503 11.8963 21.6947C12.3426 21.6347 12.782 21.4979 13.1398 21.14C13.4977 20.7822 13.6345 20.3428 13.6945 19.8965C13.7501 19.4831 13.75 18.969 13.75 18.3817V14.7299C13.75 14.1426 13.7501 13.6285 13.6945 13.215C13.6345 12.7688 13.4976 12.3294 13.1398 11.9715C12.782 11.6137 12.3426 11.4768 11.8963 11.4168C11.4829 11.3613 10.9688 11.3613 10.3815 11.3613H5.61853Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00002 11.3608H10V13.8727C10 13.8827 10 13.8927 10 13.9029C10.0001 14.0589 10.0002 14.2422 9.9791 14.3994C9.95368 14.5885 9.88598 14.8474 9.66645 15.0669C9.44692 15.2865 9.18797 15.3542 8.9989 15.3796C8.84167 15.4007 8.6584 15.4006 8.50242 15.4005C8.49224 15.4005 8.48218 15.4005 8.47225 15.4005H7.5278C7.51787 15.4005 7.50781 15.4005 7.49763 15.4005C7.34165 15.4006 7.15838 15.4007 7.00115 15.3796C6.81208 15.3542 6.55313 15.2865 6.3336 15.067C6.11407 14.8474 6.04637 14.5885 6.02095 14.3994C5.99981 14.2422 5.99992 14.0589 6.00001 13.9029C6.00002 13.8927 6.00002 13.8827 6.00002 13.8727V11.3608Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M12.1037 2.30551C12.5171 2.24993 13.0313 2.24996 13.6185 2.25H18.3815C18.9688 2.24996 19.4829 2.24993 19.8963 2.30551C20.3426 2.3655 20.782 2.50236 21.1398 2.8602C21.4976 3.21804 21.6345 3.65746 21.6945 4.10371C21.7501 4.51712 21.75 5.03126 21.75 5.61852V9.27038C21.75 9.85764 21.7501 10.3718 21.6945 10.7852C21.6345 11.2314 21.4977 11.6709 21.1398 12.0287C20.782 12.3865 20.3426 12.5234 19.8963 12.5834C19.4829 12.639 18.9688 12.6389 18.3815 12.6389H15.2478C15.2435 12.289 15.2309 11.9746 15.1945 11.7036C15.1345 11.2573 14.9976 10.8179 14.6398 10.4601C14.282 10.1022 13.8426 9.96536 13.3963 9.90536C12.9829 9.84978 12.4688 9.84981 11.8815 9.84986H10.2522C10.25 9.66612 10.25 9.47258 10.25 9.27037L10.25 5.61852C10.25 5.03125 10.2499 4.51712 10.3055 4.10371C10.3655 3.65745 10.5024 3.21804 10.8602 2.8602C11.218 2.50236 11.6575 2.3655 12.1037 2.30551Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 2.25H18V4.7619C18 4.77184 18 4.7819 18 4.79207C18.0001 4.94805 18.0002 5.13133 17.9791 5.28856C17.9537 5.47762 17.886 5.73658 17.6665 5.95611C17.4469 6.17564 17.188 6.24334 16.9989 6.26876C16.8417 6.2899 16.6584 6.28979 16.5024 6.28969C16.4922 6.28969 16.4822 6.28968 16.4722 6.28968H15.5278C15.5179 6.28968 15.5078 6.28969 15.4976 6.28969C15.3417 6.28979 15.1584 6.2899 15.0011 6.26876C14.8121 6.24334 14.5531 6.17564 14.3336 5.95611C14.1141 5.73658 14.0464 5.47762 14.021 5.28856C13.9998 5.13133 13.9999 4.94805 14 4.79207C14 4.7819 14 4.77183 14 4.7619V2.25Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path d="M21 18.5H16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M19 20.5L21 18.5L19 16.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 5.5H8" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 3.5L3 5.5L5 7.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "delivery-box-move-arows-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","box","package","move","arrows","shipping","order","transit","relocate","stock-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.00002 11.3613H5.61853C5.03126 11.3613 4.51712 11.3613 4.10371 11.4168C3.65745 11.4768 3.21804 11.6137 2.8602 11.9715C2.50236 12.3294 2.3655 12.7688 2.30551 13.215C2.24993 13.6285 2.24996 14.1426 2.25 14.7299L2.25 18.3817C2.24996 18.969 2.24993 19.4831 2.30551 19.8965C2.3655 20.3428 2.50236 20.7822 2.8602 21.14C3.21804 21.4979 3.65745 21.6347 4.10371 21.6947C4.51712 21.7503 5.03125 21.7503 5.61851 21.7502H10.3815C10.9687 21.7503 11.4829 21.7503 11.8963 21.6947C12.3426 21.6347 12.782 21.4979 13.1398 21.14C13.4977 20.7822 13.6345 20.3428 13.6945 19.8965C13.7501 19.4831 13.75 18.969 13.75 18.3817V14.7299C13.75 14.1426 13.7501 13.6284 13.6945 13.215C13.6345 12.7688 13.4976 12.3294 13.1398 11.9715C12.782 11.6137 12.3426 11.4768 11.8963 11.4168C11.4829 11.3613 10.9688 11.3613 10.3815 11.3613H10L10 13.9032C10.0001 14.0591 10.0002 14.2424 9.9791 14.3996C9.95368 14.5887 9.88598 14.8477 9.66645 15.0672C9.44692 15.2867 9.18797 15.3544 8.9989 15.3798C8.84167 15.401 8.6584 15.4009 8.50242 15.4008H7.49763C7.34165 15.4009 7.15838 15.401 7.00115 15.3798C6.81208 15.3544 6.55313 15.2867 6.3336 15.0672C6.11407 14.8477 6.04637 14.5887 6.02095 14.3996C5.99981 14.2424 5.99992 14.0591 6.00001 13.9032L6.00002 11.3613Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14 2.25H13.6185C13.0313 2.24996 12.5171 2.24993 12.1037 2.30551C11.6575 2.3655 11.218 2.50236 10.8602 2.8602C10.5024 3.21804 10.3655 3.65745 10.3055 4.10371C10.2499 4.51712 10.25 5.03125 10.25 5.61852L10.25 9.27037C10.25 9.47258 10.25 9.66612 10.2522 9.84986H11.8815C12.4688 9.84981 12.9829 9.84978 13.3963 9.90536C13.8426 9.96536 14.282 10.1022 14.6398 10.4601C14.9976 10.8179 15.1345 11.2573 15.1945 11.7036C15.2309 11.9746 15.2435 12.289 15.2478 12.6389H18.3815C18.9687 12.6389 19.4829 12.639 19.8963 12.5834C20.3426 12.5234 20.782 12.3865 21.1398 12.0287C21.4977 11.6709 21.6345 11.2314 21.6945 10.7852C21.7501 10.3718 21.75 9.85765 21.75 9.27039V5.61852C21.75 5.03126 21.7501 4.51712 21.6945 4.10371C21.6345 3.65746 21.4976 3.21804 21.1398 2.8602C20.782 2.50236 20.3426 2.3655 19.8963 2.30551C19.4829 2.24993 18.9688 2.24996 18.3815 2.25H18L18 4.79183C18.0001 4.94781 18.0002 5.13109 17.9791 5.28831C17.9537 5.47738 17.886 5.73634 17.6665 5.95587C17.4469 6.17539 17.188 6.24309 16.9989 6.26851C16.8417 6.28965 16.6584 6.28954 16.5024 6.28945H15.4976C15.3417 6.28954 15.1584 6.28965 15.0011 6.26851C14.8121 6.24309 14.5531 6.17539 14.3336 5.95587C14.1141 5.73634 14.0464 5.47738 14.021 5.28831C13.9998 5.13108 13.9999 4.94781 14 4.79183L14 2.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2929 15.7929C18.6834 15.4024 19.3166 15.4024 19.7071 15.7929L21.7071 17.7929C22.0976 18.1834 22.0976 18.8166 21.7071 19.2071L19.7071 21.2071C19.3166 21.5976 18.6834 21.5976 18.2929 21.2071C17.9024 20.8166 17.9024 20.1834 18.2929 19.7929L18.5858 19.5H16C15.4477 19.5 15 19.0523 15 18.5C15 17.9477 15.4477 17.5 16 17.5H18.5858L18.2929 17.2071C17.9024 16.8166 17.9024 16.1834 18.2929 15.7929Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.70711 2.79289C6.09763 3.18342 6.09763 3.81658 5.70711 4.20711L5.41421 4.5H8C8.55228 4.5 9 4.94772 9 5.5C9 6.05228 8.55228 6.5 8 6.5H5.41421L5.70711 6.79289C6.09763 7.18342 6.09763 7.81658 5.70711 8.20711C5.31658 8.59763 4.68342 8.59763 4.29289 8.20711L2.29289 6.20711C1.90237 5.81658 1.90237 5.18342 2.29289 4.79289L4.29289 2.79289C4.68342 2.40237 5.31658 2.40237 5.70711 2.79289Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "delivery-box-move-arows": {
        defaultColors: ["#000000"],
        keywords: ["delivery","box","move","arrows","package","shipping","relocate","transfer","stock-transfer","dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.3335V14.778C3 13.5209 3 12.8924 3.39052 12.5019C3.78105 12.1113 4.40959 12.1113 5.66667 12.1113H10.3333C11.5904 12.1113 12.219 12.1113 12.6095 12.5019C13 12.8924 13 13.5209 13 14.778V18.3336C13 19.5906 13 20.2192 12.6095 20.6097C12.219 21.0002 11.5904 21.0002 10.3333 21.0002H5.66667C4.40959 21.0002 3.78105 21.0002 3.39052 20.6097C3 20.2192 3 19.5906 3 18.3335Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14.651H8.47222C8.83887 14.651 9.02219 14.651 9.1361 14.5371C9.25 14.4232 9.25 14.2399 9.25 13.8732V12.8891C9.25 12.5225 9.25 12.3391 9.1361 12.2252C9.02219 12.1113 8.83887 12.1113 8.47222 12.1113H7.52778C7.16113 12.1113 6.97781 12.1113 6.8639 12.2252C6.75 12.3391 6.75 12.5225 6.75 12.8891V13.8732C6.75 14.2399 6.75 14.4232 6.8639 14.5371C6.97781 14.651 7.16113 14.651 7.52778 14.651H8Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11.8889H18.3333C19.5904 11.8889 20.219 11.8889 20.6095 11.4984C21 11.1078 21 10.4793 21 9.22222V5.66667C21 4.40959 21 3.78105 20.6095 3.39052C20.219 3 19.5904 3 18.3333 3H13.6667C12.4096 3 11.781 3 11.3905 3.39052C11 3.78105 11 4.40959 11 5.66667V7.44444V9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 5.53968H16.4722C16.8389 5.53968 17.0222 5.53968 17.1361 5.42578C17.25 5.31188 17.25 5.12855 17.25 4.7619V3.77778C17.25 3.41113 17.25 3.22781 17.1361 3.1139C17.0222 3 16.8389 3 16.4722 3H15.5278C15.1611 3 14.9778 3 14.8639 3.1139C14.75 3.22781 14.75 3.41113 14.75 3.77778V4.7619C14.75 5.12855 14.75 5.31188 14.8639 5.42578C14.9778 5.53968 15.1611 5.53968 15.5278 5.53968H16Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21 18.5H16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M19 20.5L21 18.5L19 16.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 5.5H8" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 3.5L3 5.5L5 7.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "Diamond-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["diamond","loyalty","rewards","premium","vip","gems","expensive","gift","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5L8.50105 6.99579C8.25286 7.98854 8.12877 8.48492 8.1722 8.98505C8.21563 9.48517 8.42344 9.95273 8.83904 10.8878L12 18L15.161 10.8878C15.5766 9.95273 15.7844 9.48517 15.8278 8.98505C15.8712 8.48492 15.7471 7.98854 15.4989 6.99579L15 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9L19 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8027 5H8.19732C7.26497 5 6.7988 5 6.40142 5.18248C6.2521 5.25105 6.1118 5.33776 5.9837 5.44065C5.64277 5.71447 5.43429 6.13142 5.01733 6.96534C4.58646 7.82707 4.37103 8.25794 4.36158 8.70786C4.35803 8.87678 4.3759 9.04547 4.41477 9.2099C4.51828 9.64785 4.81921 10.024 5.42107 10.7763L10.4383 17.0478C11.159 17.9488 11.5194 18.3992 12 18.3992C12.4806 18.3992 12.841 17.9488 13.5617 17.0478L18.5789 10.7763L18.5789 10.7763C19.1808 10.024 19.4817 9.64785 19.5852 9.2099C19.6241 9.04547 19.642 8.87678 19.6384 8.70786C19.629 8.25794 19.4135 7.82707 18.9827 6.96534C18.5657 6.13142 18.3572 5.71447 18.0163 5.44065C17.8882 5.33776 17.7479 5.25105 17.5986 5.18248C17.2012 5 16.735 5 15.8027 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Diamond-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["diamond","reward","loyalty","points","premium","vip","perk","valuable","bonus","redeem","gems"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8027 5H8.19732C7.26497 5 6.7988 5 6.40142 5.18248C6.2521 5.25105 6.1118 5.33776 5.9837 5.44065C5.64277 5.71447 5.43429 6.13142 5.01733 6.96534C4.58646 7.82707 4.37103 8.25794 4.36158 8.70786C4.35803 8.87678 4.3759 9.04547 4.41477 9.2099C4.51828 9.64785 4.81921 10.024 5.42107 10.7763L10.4383 17.0478C11.159 17.9488 11.5194 18.3992 12 18.3992C12.4806 18.3992 12.841 17.9488 13.5617 17.0478L18.5789 10.7763L18.5789 10.7763C19.1808 10.024 19.4817 9.64785 19.5852 9.2099C19.6241 9.04547 19.642 8.87678 19.6384 8.70786C19.629 8.25794 19.4135 7.82707 18.9827 6.96534C18.5657 6.13142 18.3572 5.71447 18.0163 5.44065C17.8882 5.33776 17.7479 5.25105 17.5986 5.18248C17.2012 5 16.735 5 15.8027 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5L8.50105 6.99579C8.25286 7.98854 8.12877 8.48492 8.1722 8.98505C8.21563 9.48517 8.42344 9.95273 8.83904 10.8878L12 18L15.161 10.8878C15.5766 9.95273 15.7844 9.48517 15.8278 8.98505C15.8712 8.48492 15.7471 7.98854 15.4989 6.99579L15 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Diamond-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","gem","loyalty","rewards","premium","vip","membership","points","sale","promotion","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.8765 3.99987H8.19796L8.03678 3.99969C7.26693 3.99838 6.58657 3.99723 5.98474 4.2736C5.76076 4.37645 5.55031 4.50652 5.35815 4.66085C4.84181 5.07554 4.53858 5.68459 4.19546 6.37376L4.12354 6.518L4.1071 6.55088C3.9057 6.95364 3.72827 7.30846 3.60386 7.61884C3.52147 7.82438 3.4522 8.0339 3.40918 8.25521C3.4391 8.25158 3.46956 8.24972 3.50045 8.24972H7.54228C7.62579 7.74991 7.80549 7.21167 8.02971 6.54008L8.8765 3.99987Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.53721 9.74972C3.63091 9.99743 3.75837 10.2199 3.90203 10.4334C4.08872 10.7108 4.33655 11.0206 4.61788 11.3722L9.69706 17.7212C10.0235 18.1294 10.3325 18.5157 10.6259 18.7908C10.9506 19.0952 11.3954 19.3991 12.0006 19.3991C12.6059 19.3991 13.0507 19.0952 13.3754 18.7908C13.6688 18.5157 13.9778 18.1294 14.3042 17.7212L19.3834 11.3722C19.6647 11.0206 19.9126 10.7108 20.0993 10.4334C20.2429 10.2199 20.3704 9.99743 20.4641 9.74972H16.3657C16.2146 10.25 15.9531 10.7723 15.6236 11.4305L12.6713 17.3351C12.5442 17.5892 12.2845 17.7497 12.0005 17.7497C11.7164 17.7497 11.4567 17.5892 11.3296 17.3351L8.37727 11.4305C8.04777 10.7723 7.78629 10.25 7.63521 9.74972H3.53721Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.591 8.24972C20.5479 8.03043 20.4791 7.82268 20.3974 7.61884C20.273 7.30848 20.0956 6.9537 19.8942 6.55097L19.8777 6.518L19.8058 6.37375C19.4627 5.68459 19.1595 5.07554 18.6431 4.66085C18.451 4.50652 18.2405 4.37645 18.0165 4.2736C17.4147 3.99722 16.7344 3.99838 15.9645 3.99969L15.8033 3.99987H15.1244L15.9712 6.54008C16.1954 7.21167 16.3751 7.74991 16.4586 8.24972H20.591Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5433 3.99987H10.4576L9.49788 6.87914C9.28492 7.51801 9.14918 7.93671 9.07234 8.24972H14.9286C14.8517 7.93671 14.716 7.51801 14.503 6.87914L13.5433 3.99987Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.23454 9.74972C9.35595 10.028 9.53208 10.3859 9.78272 10.8872L12.0005 15.3227L14.2182 10.8872C14.4688 10.3859 14.645 10.028 14.7664 9.74972H9.23454Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "diamond-exclamation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["warning","alert","error","notification","exclamation","issue","problem","attention","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.41421 13.4142C4.63316 12.6332 4.63317 11.3668 5.41421 10.5858L10.5858 5.41421C11.3668 4.63316 12.6332 4.63317 13.4142 5.41421L18.5858 10.5858C19.3668 11.3668 19.3668 12.6332 18.5858 13.4142L13.4142 18.5858C12.6332 19.3668 11.3668 19.3668 10.5858 18.5858L5.41421 13.4142Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "diamond-exclamation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["warning","exclamation","alert","error","issue","problem","attention","notification","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.41421 13.4142C4.63316 12.6332 4.63317 11.3668 5.41421 10.5858L10.5858 5.41421C11.3668 4.63316 12.6332 4.63317 13.4142 5.41421L18.5858 10.5858C19.3668 11.3668 19.3668 12.6332 18.5858 13.4142L13.4142 18.5858C12.6332 19.3668 11.3668 19.3668 10.5858 18.5858L5.41421 13.4142Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "diamond-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","issue","problem","attention","notification","flag","critical","low-stock","stock-alert","invalid","invalid-input","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0768 4.86023C12.9298 3.71326 11.0702 3.71325 9.92322 4.86023L4.86023 9.92322C3.71326 11.0702 3.71325 12.9298 4.86023 14.0768L9.92322 19.1398C11.0702 20.2867 12.9298 20.2867 14.0768 19.1398L19.1398 14.0768C20.2867 12.9298 20.2867 11.0702 19.1398 9.92322L14.0768 4.86023ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7ZM13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "diamond-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","issue","problem","attention","notification","critical","danger","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.41421 13.4142C4.63316 12.6332 4.63317 11.3668 5.41421 10.5858L10.5858 5.41421C11.3668 4.63316 12.6332 4.63317 13.4142 5.41421L18.5858 10.5858C19.3668 11.3668 19.3668 12.6332 18.5858 13.4142L13.4142 18.5858C12.6332 19.3668 11.3668 19.3668 10.5858 18.5858L5.41421 13.4142Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Diamond-shine-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["diamond","shine","rewards","loyalty","premium","gem","expensive","VIP","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11L19 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L8.50105 8.99579C8.25286 9.98854 8.12877 10.4849 8.1722 10.985C8.21563 11.4852 8.42344 11.9527 8.83904 12.8878L12 20L15.161 12.8878C15.5766 11.9527 15.7844 11.4852 15.8278 10.985C15.8712 10.4849 15.7471 9.98854 15.4989 8.99579L15 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8027 7H8.19732C7.26497 7 6.7988 7 6.40142 7.18248C6.2521 7.25105 6.1118 7.33776 5.9837 7.44065C5.64277 7.71447 5.43429 8.13142 5.01733 8.96534C4.58646 9.82707 4.37103 10.2579 4.36158 10.7079C4.35803 10.8768 4.3759 11.0455 4.41477 11.2099C4.51828 11.6478 4.81921 12.024 5.42107 12.7763L10.4383 19.0478C11.159 19.9488 11.5194 20.3992 12 20.3992C12.4806 20.3992 12.841 19.9488 13.5617 19.0478L18.5789 12.7763L18.5789 12.7763C19.1808 12.024 19.4817 11.6478 19.5852 11.2099C19.6241 11.0455 19.642 10.8768 19.6384 10.7079C19.629 10.2579 19.4135 9.82707 18.9827 8.96534C18.5657 8.13142 18.3572 7.71447 18.0163 7.44065C17.8882 7.33776 17.7479 7.25105 17.5986 7.18248C17.2012 7 16.735 7 15.8027 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 4L7 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 4L17 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Diamond-shine-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["diamond","loyalty","rewards","premium","vip","value","points","gems"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8027 7H8.19732C7.26497 7 6.7988 7 6.40142 7.18248C6.2521 7.25105 6.1118 7.33776 5.9837 7.44065C5.64277 7.71447 5.43429 8.13142 5.01733 8.96534C4.58646 9.82707 4.37103 10.2579 4.36158 10.7079C4.35803 10.8768 4.3759 11.0455 4.41477 11.2099C4.51828 11.6478 4.81921 12.024 5.42107 12.7763L10.4383 19.0478C11.159 19.9488 11.5194 20.3992 12 20.3992C12.4806 20.3992 12.841 19.9488 13.5617 19.0478L18.5789 12.7763L18.5789 12.7763C19.1808 12.024 19.4817 11.6478 19.5852 11.2099C19.6241 11.0455 19.642 10.8768 19.6384 10.7079C19.629 10.2579 19.4135 9.82707 18.9827 8.96534C18.5657 8.13142 18.3572 7.71447 18.0163 7.44065C17.8882 7.33776 17.7479 7.25105 17.5986 7.18248C17.2012 7 16.735 7 15.8027 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L8.50105 8.99579C8.25286 9.98854 8.12877 10.4849 8.1722 10.985C8.21563 11.4852 8.42344 11.9527 8.83904 12.8878L12 20L15.161 12.8878C15.5766 11.9527 15.7844 11.4852 15.8278 10.985C15.8712 10.4849 15.7471 9.98854 15.4989 8.99579L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 11L19 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 4L7 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 4L17 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Diamond-shine-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","shine","reward","loyalty","premium","vip","special","gift","high-value","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.64197 6.24995L8.05696 6.24985C7.26385 6.24901 6.63849 6.24835 6.08862 6.50086C5.8833 6.59515 5.69039 6.71437 5.51424 6.85585C5.04247 7.23474 4.7634 7.79437 4.40946 8.50413L4.33363 8.65601C4.12931 9.06462 3.95596 9.4113 3.83546 9.71193C3.76386 9.89053 3.70459 10.0676 3.66504 10.25H7.49295C7.56558 9.83629 7.70031 9.38788 7.86566 8.83755L8.64197 6.24995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.80615 11.75C3.88681 11.94 3.99035 12.1176 4.10899 12.2939C4.28981 12.5626 4.53195 12.8653 4.81735 13.222L9.88466 19.5561C10.2176 19.9723 10.5164 20.346 10.7964 20.6085C10.9942 20.7939 11.227 20.9672 11.5073 21.0654C11.4227 20.9918 11.3541 20.8987 11.3088 20.791L8.09751 13.1643C7.86507 12.6129 7.67746 12.1679 7.56191 11.75H3.80615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.4924 21.0657C12.7731 20.9674 13.006 20.794 13.2039 20.6085C13.4839 20.346 13.7828 19.9723 14.1157 19.5561L19.183 13.222C19.4684 12.8653 19.7106 12.5626 19.8914 12.2939C20.01 12.1176 20.1136 11.94 20.1942 11.75H16.4381C16.3225 12.1679 16.1349 12.6129 15.9025 13.1643L12.6912 20.791C12.6458 20.8988 12.5771 20.992 12.4924 21.0657Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.3353 10.25C20.2958 10.0676 20.2365 9.89053 20.1649 9.71193C20.0444 9.41131 19.8711 9.06465 19.6668 8.65606L19.5909 8.50413C19.237 7.79438 18.9579 7.23474 18.4861 6.85585C18.31 6.71437 18.1171 6.59515 17.9118 6.50086C17.3619 6.24835 16.7365 6.24901 15.9434 6.24985L15.358 6.24995L16.1343 8.83755C16.2997 9.38788 16.4344 9.83629 16.507 10.25H20.3353Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.792 6.24995H10.208L9.33794 9.15023C9.18994 9.64354 9.08906 9.98734 9.02515 10.25H14.9748C14.9109 9.98734 14.8101 9.64354 14.6621 9.15023L13.792 6.24995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.14151 11.75C9.23146 11.9879 9.35662 12.2892 9.52794 12.6961L12 18.5672L14.4721 12.6961C14.6434 12.2892 14.7685 11.9879 14.8585 11.75H9.14151Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1.5C12.5523 1.5 13 1.94772 13 2.5V4.5C13 5.05228 12.5523 5.5 12 5.5C11.4477 5.5 11 5.05228 11 4.5V2.5C11 1.94772 11.4477 1.5 12 1.5ZM18.7071 2.79289C19.0976 3.18342 19.0976 3.81658 18.7071 4.20711L17.7071 5.20711C17.3166 5.59763 16.6834 5.59763 16.2929 5.20711C15.9024 4.81658 15.9024 4.18342 16.2929 3.79289L17.2929 2.79289C17.6834 2.40237 18.3166 2.40237 18.7071 2.79289ZM5.29289 2.79289C5.68341 2.40237 6.31658 2.40237 6.7071 2.79289L7.7071 3.79289C8.09763 4.18342 8.09763 4.81658 7.7071 5.20711C7.31658 5.59763 6.68341 5.59763 6.29289 5.20711L5.29289 4.20711C4.90236 3.81658 4.90236 3.18342 5.29289 2.79289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Diamond-shine": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","shine","premium","loyalty","rewards","vip","special","luxury","gem","jewelry","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 7L8.50105 8.99579C8.25286 9.98854 8.12877 10.4849 8.1722 10.985C8.21563 11.4852 8.42344 11.9527 8.83904 12.8878L12 20L15.161 12.8878C15.5766 11.9527 15.7844 11.4852 15.8278 10.985C15.8712 10.4849 15.7471 9.98854 15.4989 8.99579L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 11L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8027 7H8.19732C7.26497 7 6.7988 7 6.40142 7.18248C6.2521 7.25105 6.1118 7.33776 5.9837 7.44065C5.64277 7.71447 5.43429 8.13142 5.01733 8.96534C4.58646 9.82707 4.37103 10.2579 4.36158 10.7079C4.35803 10.8768 4.3759 11.0455 4.41477 11.2099C4.51828 11.6478 4.81921 12.024 5.42107 12.7763L10.4383 19.0478C11.159 19.9488 11.5194 20.3992 12 20.3992C12.4806 20.3992 12.841 19.9488 13.5617 19.0478L18.5789 12.7763L18.5789 12.7763C19.1808 12.024 19.4817 11.6478 19.5852 11.2099C19.6241 11.0455 19.642 10.8768 19.6384 10.7079C19.629 10.2579 19.4135 9.82707 18.9827 8.96534C18.5657 8.13142 18.3572 7.71447 18.0163 7.44065C17.8882 7.33776 17.7479 7.25105 17.5986 7.18248C17.2012 7 16.735 7 15.8027 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 4L7 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 4L17 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "direction-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["direction","sign","way","navigation","route","right","next","arrow","go","continue","next-step"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.7 14L15.3917 14C15.7544 14 15.9358 14 16.0983 13.9422C16.1904 13.9095 16.2772 13.8634 16.356 13.8054C16.4949 13.7032 16.5965 13.553 16.7998 13.2525L18.3556 10.9525C18.6114 10.5744 18.7393 10.3854 18.7768 10.1775C18.798 10.0601 18.798 9.93989 18.7768 9.82252C18.7393 9.61464 18.6114 9.42559 18.3556 9.04747L16.7998 6.74747L16.7998 6.74746C16.5965 6.44703 16.4949 6.29682 16.356 6.19459C16.2772 6.13663 16.1904 6.09054 16.0983 6.05778C15.9358 6 15.7544 6 15.3917 6L6.7 6C6.04531 6 5.71797 6 5.4775 6.14736C5.34295 6.22982 5.22982 6.34295 5.14736 6.4775C5 6.71797 5 7.04531 5 7.7L5 12.3C5 12.9547 5 13.282 5.14736 13.5225C5.22982 13.6571 5.34295 13.7702 5.4775 13.8526C5.71797 14 6.04531 14 6.7 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Diamond: {
        defaultColors: ["#3D4C66"],
        keywords: ["direction","sign","way","navigation","route","right","next","arrow","go","continue","next-step"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5L8.50105 6.99579C8.25286 7.98854 8.12877 8.48492 8.1722 8.98505C8.21563 9.48517 8.42344 9.95273 8.83904 10.8878L12 18L15.161 10.8878C15.5766 9.95273 15.7844 9.48517 15.8278 8.98505C15.8712 8.48492 15.7471 7.98854 15.4989 6.99579L15 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8027 5H8.19732C7.26497 5 6.7988 5 6.40142 5.18248C6.2521 5.25105 6.1118 5.33776 5.9837 5.44065C5.64277 5.71447 5.43429 6.13142 5.01733 6.96534C4.58646 7.82707 4.37103 8.25794 4.36158 8.70786C4.35803 8.87678 4.3759 9.04547 4.41477 9.2099C4.51828 9.64785 4.81921 10.024 5.42107 10.7763L10.4383 17.0478C11.159 17.9488 11.5194 18.3992 12 18.3992C12.4806 18.3992 12.841 17.9488 13.5617 17.0478L18.5789 10.7763L18.5789 10.7763C19.1808 10.024 19.4817 9.64785 19.5852 9.2099C19.6241 9.04547 19.642 8.87678 19.6384 8.70786C19.629 8.25794 19.4135 7.82707 18.9827 6.96534C18.5657 6.13142 18.3572 5.71447 18.0163 5.44065C17.8882 5.33776 17.7479 5.25105 17.5986 5.18248C17.2012 5 16.735 5 15.8027 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "direction-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["direction","arrows","navigation","route","options","choice","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 21" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 3L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.7 9H15.734C15.9624 9 16.0765 9 16.1856 8.97529C16.2477 8.96121 16.3084 8.94124 16.3667 8.91563C16.4691 8.87066 16.5609 8.80281 16.7445 8.66711L16.7445 8.6671L17.1504 8.3671C17.84 7.85741 18.1848 7.60257 18.2786 7.27663C18.3306 7.09588 18.3306 6.90412 18.2786 6.72337C18.1848 6.39743 17.84 6.14259 17.1504 5.6329L17.1504 5.6329L16.7445 5.3329C16.5609 5.19719 16.4691 5.12934 16.3667 5.08437C16.3084 5.05876 16.2477 5.03879 16.1856 5.02471C16.0765 5 15.9624 5 15.734 5H6.7C6.04531 5 5.71797 5 5.4775 5.14736C5.34295 5.22982 5.22982 5.34295 5.14736 5.4775C5 5.71797 5 6.04531 5 6.7V7.3C5 7.95469 5 8.28203 5.14736 8.5225C5.22982 8.65705 5.34295 8.77018 5.4775 8.85264C5.71797 9 6.04531 9 6.7 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3 12L8.26595 12C8.03764 12 7.92348 12 7.81439 12.0247C7.75227 12.0388 7.69163 12.0588 7.63331 12.0844C7.53089 12.1293 7.43909 12.1972 7.25549 12.3329L7.25549 12.3329L6.8496 12.6329C6.16003 13.1426 5.81524 13.3974 5.72142 13.7234C5.66939 13.9041 5.66939 14.0959 5.72142 14.2766C5.81524 14.6026 6.16003 14.8574 6.8496 15.3671L6.8496 15.3671L7.25549 15.6671C7.43909 15.8028 7.53089 15.8707 7.63331 15.9156C7.69163 15.9412 7.75227 15.9612 7.81439 15.9753C7.92348 16 8.03764 16 8.26595 16L17.3 16C17.9547 16 18.282 16 18.5225 15.8526C18.6571 15.7702 18.7702 15.6571 18.8526 15.5225C19 15.282 19 14.9547 19 14.3L19 13.7C19 13.0453 19 12.718 18.8526 12.4775C18.7702 12.3429 18.6571 12.2298 18.5225 12.1474C18.282 12 17.9547 12 17.3 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "direction-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["direction","sign","navigation","route","options","settings","choose","location","waypoint","path","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 21" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 3L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 9H16.2941L19 7L16.2941 5H5V9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12L7.70588 12L5 14L7.70588 16L19 16L19 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "direction-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["direction","directions","choice","choices","navigate","navigation","route","routes","options","switch","alternative","alternatives","multiple","paths","path"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 9H16.2941L19 7L16.2941 5H5V9Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C12.5523 2 13 2.44772 13 3V4H16.2941C16.5081 4 16.7164 4.06864 16.8885 4.19582L19.5944 6.19582C19.8495 6.38438 20 6.68278 20 7C20 7.31722 19.8495 7.61562 19.5944 7.80418L16.8885 9.80418C16.7164 9.93136 16.5081 10 16.2941 10H13V11L19 11C19.2652 11 19.5196 11.1054 19.7071 11.2929C19.8946 11.4804 20 11.7348 20 12V16C20 16.5523 19.5523 17 19 17L13 17V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 17H7.70588C7.4919 17 7.28357 16.9314 7.11149 16.8042L4.40561 14.8042C4.15051 14.6156 4 14.3172 4 14C4 13.6828 4.15051 13.3844 4.40561 13.1958L7.11149 11.1958C7.28357 11.0686 7.4919 11 7.70588 11H11V10H5C4.44772 10 4 9.55228 4 9V5C4 4.44772 4.44772 4 5 4H11V3C11 2.44772 11.4477 2 12 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "direction-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["direction","sign","next","route","navigation","arrow","pointing","way","path","next-step","menu","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.7 14L15.3917 14C15.7544 14 15.9358 14 16.0983 13.9422C16.1904 13.9095 16.2772 13.8634 16.356 13.8054C16.4949 13.7032 16.5965 13.553 16.7998 13.2525L18.3556 10.9525C18.6114 10.5744 18.7393 10.3854 18.7768 10.1775C18.798 10.0601 18.798 9.93989 18.7768 9.82252C18.7393 9.61464 18.6114 9.42559 18.3556 9.04747L16.7998 6.74747L16.7998 6.74746C16.5965 6.44703 16.4949 6.29682 16.356 6.19459C16.2772 6.13663 16.1904 6.09054 16.0983 6.05778C15.9358 6 15.7544 6 15.3917 6L6.7 6C6.04531 6 5.71797 6 5.4775 6.14736C5.34295 6.22982 5.22982 6.34295 5.14736 6.4775C5 6.71797 5 7.04531 5 7.7L5 12.3C5 12.9547 5 13.282 5.14736 13.5225C5.22982 13.6571 5.34295 13.7702 5.4775 13.8526C5.71797 14 6.04531 14 6.7 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "direction-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["direction","directions","sign","signpost","route","navigation","options","choices","menu","settings","preferences","customer-choices","order-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9H16.2941L19 7L16.2941 5H5V9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12L7.70588 12L5 14L7.70588 16L19 16L19 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16L12 21" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 3L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "direction-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["direction","right","arrow","next","go","continue","sign","way","path","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V5.00025L6.66262 5.00041C6.36775 5.00037 6.08057 5.00033 5.83877 5.02332C5.57184 5.0487 5.25877 5.10899 4.95501 5.29513C4.6859 5.46005 4.45964 5.68631 4.29473 5.95542C4.10858 6.25918 4.0483 6.57225 4.02292 6.83918C3.99992 7.08102 3.99996 7.36811 4 7.66302L4.00001 12.3378C3.99997 12.6327 3.99993 12.9198 4.02292 13.1616C4.0483 13.4286 4.10858 13.7416 4.29473 14.0454C4.45964 14.3145 4.6859 14.5408 4.95501 14.7057C5.25878 14.8918 5.57184 14.9521 5.83877 14.9775C6.08058 15.0005 6.36775 15.0005 6.66263 15.0004L11 15.0005L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20L13 15.0005L15.4754 15.0005C15.7552 15.0016 16.1085 15.0029 16.441 14.8847C16.6252 14.8192 16.7989 14.727 16.9564 14.6111C17.2406 14.4019 17.4798 14.0455 17.6357 13.8131L19.2459 11.4335C19.4431 11.1449 19.6919 10.7809 19.7686 10.3553C19.811 10.1205 19.811 9.88007 19.7686 9.64532C19.6919 9.21969 19.3888 8.77603 19.1916 8.48745L17.5933 6.1244C17.4374 5.89199 17.2406 5.59863 16.9564 5.38946C16.7989 5.27355 16.6252 5.18137 16.441 5.11586C16.1085 4.99763 15.7552 4.999 15.4754 5.00009L13 5.00018V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    direction: {
        defaultColors: ["#3D4C66"],
        keywords: ["direction","right","arrow","next","go","continue","sign","way","path","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.7 14L15.3917 14C15.7544 14 15.9358 14 16.0983 13.9422C16.1904 13.9095 16.2772 13.8634 16.356 13.8054C16.4949 13.7032 16.5965 13.553 16.7998 13.2525L18.3556 10.9525C18.6114 10.5744 18.7393 10.3854 18.7768 10.1775C18.798 10.0601 18.798 9.93989 18.7768 9.82252C18.7393 9.61464 18.6114 9.42559 18.3556 9.04747L16.7998 6.74747L16.7998 6.74746C16.5965 6.44703 16.4949 6.29682 16.356 6.19459C16.2772 6.13663 16.1904 6.09054 16.0983 6.05778C15.9358 6 15.7544 6 15.3917 6L6.7 6C6.04531 6 5.71797 6 5.4775 6.14736C5.34295 6.22982 5.22982 6.34295 5.14736 6.4775C5 6.71797 5 7.04531 5 7.7L5 12.3C5 12.9547 5 13.282 5.14736 13.5225C5.22982 13.6571 5.34295 13.7702 5.4775 13.8526C5.71797 14 6.04531 14 6.7 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 14L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 4L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "dislike-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dislike","thumbs-down","decline","reject","negative","remove","cancel","undo","refund","discount-denied","feedback","bad","poor","unsatisfied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10L16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6L20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75L10 13.25ZM10.3958 17.6252L9.65601 17.5019L10.3958 17.6252ZM10.3828 17.7051L11.1246 17.8157L10.3828 17.7051ZM14.3862 18.4551L15.1138 18.637L14.3862 18.4551ZM14.3722 18.5105L13.647 18.319L14.3722 18.5105ZM10.8356 14.9864L11.5754 15.1097L10.8356 14.9864ZM11.1356 17.7485L11.5754 15.1097L10.0958 14.8631L9.65601 17.5019L11.1356 17.7485ZM15.2724 11.8181L13.6586 18.2732L15.1138 18.637L16.7276 12.1819L15.2724 11.8181ZM9.65601 17.5019C9.64956 17.5406 9.6447 17.5695 9.64098 17.5945L11.1246 17.8157C11.1259 17.8067 11.1281 17.7937 11.1356 17.7485L9.65601 17.5019ZM12.4076 19.25C12.3617 19.25 12.3485 19.25 12.3395 19.2498L12.3137 20.7496C12.339 20.75 12.3683 20.75 12.4076 20.75L12.4076 19.25ZM9.64098 17.5945C9.39602 19.2376 10.6527 20.7211 12.3137 20.7496L12.3395 19.2498C11.5845 19.2369 11.0132 18.5626 11.1246 17.8157L9.64098 17.5945ZM13.6586 18.2732C13.651 18.3038 13.6488 18.3123 13.647 18.319L15.0974 18.7019C15.1023 18.6833 15.1072 18.6633 15.1138 18.637L13.6586 18.2732ZM12.4076 20.75C12.4347 20.75 12.4553 20.75 12.4745 20.7498L12.4548 19.2499C12.4478 19.25 12.4391 19.25 12.4076 19.25L12.4076 20.75ZM13.647 18.319C13.5038 18.8618 13.0162 19.2425 12.4548 19.2499L12.4745 20.7498C13.7095 20.7336 14.7821 19.896 15.0974 18.7019L13.647 18.319ZM11.5754 15.1097C11.7376 14.1362 10.9869 13.25 10 13.25L10 14.75C10.06 14.75 10.1057 14.8039 10.0958 14.8631L11.5754 15.1097Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 12L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L11.2238 4C8.98843 4 7.87077 4 7.0593 4.6292C6.24784 5.2584 5.96949 6.34085 5.41281 8.50576L4.64236 11.5019C4.34689 12.651 4.19915 13.2255 4.49941 13.6128C4.79967 14 5.39289 14 6.57935 14L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 7L18 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "dislike-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dislike","thumbs-down","decline","reject","cancel","remove","decrease","bad","negative","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.1213 3.87868C15.6117 3.36902 14.9833 3.17028 14.3278 3.08215C13.7161 2.99991 12.9523 2.99995 12.0658 3L11.1641 3C10.0972 2.99997 9.20897 2.99995 8.48931 3.08568C7.72965 3.17616 7.04861 3.37211 6.44655 3.83894C5.84449 4.30577 5.48511 4.91656 5.20829 5.62975C4.94604 6.30538 4.72484 7.16568 4.45919 8.1989L4.4443 8.25671L4.44349 8.25997L3.67388 11.2529L3.65804 11.3144C3.52395 11.8356 3.39753 12.3268 3.3533 12.7354C3.30453 13.1859 3.33004 13.7366 3.70915 14.2255C4.08826 14.7145 4.61524 14.8763 5.0637 14.9413C5.47042 15.0002 5.97771 15.0001 6.5158 15L6.57936 15H9.81955L9.40816 17.4683C9.40244 17.5027 9.39757 17.5319 9.39372 17.5576C9.12649 19.3501 10.4974 20.9685 12.3095 20.9996C12.3355 21 12.365 21 12.3998 21C13.747 20.9824 14.9952 20.0684 15.3391 18.7656L17 12.1231L17 7.93417C17.0001 7.04769 17.0001 6.28387 16.9179 5.67221C16.8297 5.0167 16.631 4.38835 16.1213 3.87868ZM14.0613 5.06431C13.5988 5.00213 12.9711 5 12 5H11.2238C10.0819 5 9.31336 5.00165 8.72588 5.07164C8.165 5.13845 7.88148 5.2571 7.67208 5.41947C7.46267 5.58184 7.27715 5.82688 7.07276 6.35344C6.85889 6.90445 6.66607 7.64741 6.38215 8.75153L6.38133 8.75481L5.61087 11.751C5.45526 12.3561 5.36839 12.7039 5.34169 12.9507L5.34065 12.9605L5.35043 12.9619C5.59602 12.9975 5.95453 13 6.57935 13H10C11.1414 13 12.0097 14.0249 11.822 15.1508L11.3822 17.7896C11.3745 17.8359 11.3728 17.8463 11.3719 17.8526C11.2828 18.45 11.7398 18.9895 12.3438 18.9999C12.3501 19 12.3606 19 12.4076 19L12.4516 18.9999C12.9006 18.994 13.2907 18.6895 13.4053 18.2552L13.4161 18.2126L15 11.8769V8C15 7.02893 14.9979 6.40121 14.9357 5.93871C14.8774 5.50497 14.7832 5.36902 14.7071 5.2929C14.631 5.21677 14.495 5.12263 14.0613 5.06431Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 11C18.5523 11 19 10.5523 19 10L19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6L17 10C17 10.5523 17.4477 11 18 11ZM21 10C21 11.6569 19.6569 13 18 13C16.3431 13 15 11.6569 15 10L15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6L21 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dislike-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dislike","thumb-down","negative","reject","decline","cancel","remove","feedback","rating","low-rating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0691 18.5872C12.7586 19.829 11.6429 20.7002 10.3628 20.7002C8.63907 20.7002 7.32787 19.1524 7.61125 17.4521L8.05105 14.8133C8.06092 14.7541 8.01526 14.7002 7.95525 14.7002L4.5346 14.7002C4.51726 14.7002 4.49999 14.7002 4.48277 14.7002C3.93414 14.7003 3.44315 14.7003 3.05478 14.644C2.6349 14.5832 2.18382 14.4376 1.86195 14.0225C1.54009 13.6074 1.51143 13.1343 1.55709 12.7125C1.59932 12.3224 1.72165 11.8468 1.85833 11.3155L2.65328 8.22408C2.92175 7.17994 3.13977 6.33202 3.39658 5.6704C3.66435 4.98054 4.002 4.41547 4.55498 3.9867C5.10796 3.55792 5.73931 3.37164 6.47412 3.28411C7.17886 3.20016 8.05436 3.20018 9.13248 3.2002L10.0072 3.2002C10.9057 3.20017 11.6549 3.20014 12.2497 3.28011C12.8775 3.36451 13.4443 3.55018 13.8998 4.00565C14.3553 4.46112 14.5409 5.02792 14.6253 5.65572C14.7053 6.2505 14.7053 6.99972 14.7052 7.8982L14.7052 12.0425L13.0691 18.5872Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4552 11.2002C20.0075 11.2002 20.4552 10.7525 20.4552 10.2002L20.4552 6.2002C20.4552 5.64791 20.0075 5.2002 19.4552 5.2002C18.903 5.2002 18.4552 5.64791 18.4552 6.2002L18.4552 10.2002C18.4552 10.7525 18.903 11.2002 19.4552 11.2002ZM22.4552 10.2002C22.4552 11.857 21.1121 13.2002 19.4552 13.2002C17.7984 13.2002 16.4552 11.857 16.4552 10.2002V6.2002C16.4552 4.54334 17.7984 3.2002 19.4552 3.2002C21.1121 3.2002 22.4552 4.54334 22.4552 6.2002L22.4552 10.2002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    dislike: {
        defaultColors: ["#3D4C66"],
        keywords: ["dislike","thumb-down","negative","reject","decline","cancel","remove","feedback","rating","low-rating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75L10 13.25ZM10.3958 17.6252L9.65601 17.5019L10.3958 17.6252ZM10.3828 17.7051L11.1246 17.8157L10.3828 17.7051ZM14.3862 18.4551L15.1138 18.637L14.3862 18.4551ZM14.3722 18.5105L13.647 18.319L14.3722 18.5105ZM10.8356 14.9864L11.5754 15.1097L10.8356 14.9864ZM11.1356 17.7485L11.5754 15.1097L10.0958 14.8631L9.65601 17.5019L11.1356 17.7485ZM15.2724 11.8181L13.6586 18.2732L15.1138 18.637L16.7276 12.1819L15.2724 11.8181ZM9.65601 17.5019C9.64956 17.5406 9.6447 17.5695 9.64098 17.5945L11.1246 17.8157C11.1259 17.8067 11.1281 17.7937 11.1356 17.7485L9.65601 17.5019ZM12.4076 19.25C12.3617 19.25 12.3485 19.25 12.3395 19.2498L12.3137 20.7496C12.339 20.75 12.3683 20.75 12.4076 20.75L12.4076 19.25ZM9.64098 17.5945C9.39602 19.2376 10.6527 20.7211 12.3137 20.7496L12.3395 19.2498C11.5845 19.2369 11.0132 18.5626 11.1246 17.8157L9.64098 17.5945ZM13.6586 18.2732C13.651 18.3038 13.6488 18.3123 13.647 18.319L15.0974 18.7019C15.1023 18.6833 15.1072 18.6633 15.1138 18.637L13.6586 18.2732ZM12.4076 20.75C12.4347 20.75 12.4553 20.75 12.4745 20.7498L12.4548 19.2499C12.4478 19.25 12.4391 19.25 12.4076 19.25L12.4076 20.75ZM13.647 18.319C13.5038 18.8618 13.0162 19.2425 12.4548 19.2499L12.4745 20.7498C13.7095 20.7336 14.7821 19.896 15.0974 18.7019L13.647 18.319ZM11.5754 15.1097C11.7376 14.1362 10.9869 13.25 10 13.25L10 14.75C10.06 14.75 10.1057 14.8039 10.0958 14.8631L11.5754 15.1097Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 12L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L11.2238 4C8.98843 4 7.87077 4 7.0593 4.6292C6.24784 5.2584 5.96949 6.34085 5.41281 8.50576L4.64236 11.5019C4.34689 12.651 4.19915 13.2255 4.49941 13.6128C4.79967 14 5.39289 14 6.57935 14L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6L20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M18 7L18 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "display-setting-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["display","settings","monitor","configuration","adjustments","preferences","screen","options","customize","display-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 9H12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10L14 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L10 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L16 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 13L10 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "display-setting-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["display","settings","adjust","screen","configuration","preferences","customize","display-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0549 4.25H9.94513C8.57756 4.24998 7.47521 4.24997 6.60825 4.36653C5.70814 4.48754 4.95027 4.74644 4.34835 5.34835C3.74644 5.95027 3.48754 6.70814 3.36653 7.60825C3.24997 8.47521 3.24998 9.57754 3.25 10.9451V11.0549C3.24998 12.4225 3.24997 13.5248 3.36653 14.3918C3.48754 15.2919 3.74644 16.0497 4.34835 16.6517C4.95027 17.2536 5.70814 17.5125 6.60825 17.6335C7.47521 17.75 8.57754 17.75 9.94512 17.75H11.25V18.75H10C9.58579 18.75 9.25 19.0858 9.25 19.5C9.25 19.9142 9.58579 20.25 10 20.25H14C14.4142 20.25 14.75 19.9142 14.75 19.5C14.75 19.0858 14.4142 18.75 14 18.75H12.75V17.75H14.0549C15.4225 17.75 16.5248 17.75 17.3918 17.6335C18.2919 17.5125 19.0497 17.2536 19.6517 16.6517C20.2536 16.0497 20.5125 15.2919 20.6335 14.3918C20.75 13.5248 20.75 12.4225 20.75 11.0549V10.9451C20.75 9.57754 20.75 8.47522 20.6335 7.60825C20.5125 6.70814 20.2536 5.95027 19.6517 5.34835C19.0497 4.74644 18.2919 4.48754 17.3918 4.36653C16.5248 4.24997 15.4224 4.24998 14.0549 4.25ZM14.75 8C14.75 7.58579 14.4142 7.25 14 7.25C13.5858 7.25 13.25 7.58579 13.25 8V10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10V9.75H16C16.4142 9.75 16.75 9.41421 16.75 9C16.75 8.58579 16.4142 8.25 16 8.25H14.75V8ZM8 8.25C7.58579 8.25 7.25 8.58579 7.25 9C7.25 9.41421 7.58579 9.75 8 9.75H11.5C11.9142 9.75 12.25 9.41421 12.25 9C12.25 8.58579 11.9142 8.25 11.5 8.25H8ZM10.75 12C10.75 11.5858 10.4142 11.25 10 11.25C9.58579 11.25 9.25 11.5858 9.25 12V12.25H8C7.58579 12.25 7.25 12.5858 7.25 13C7.25 13.4142 7.58579 13.75 8 13.75H9.25V14C9.25 14.4142 9.58579 14.75 10 14.75C10.4142 14.75 10.75 14.4142 10.75 14V12ZM12.5 12.25C12.0858 12.25 11.75 12.5858 11.75 13C11.75 13.4142 12.0858 13.75 12.5 13.75H16C16.4142 13.75 16.75 13.4142 16.75 13C16.75 12.5858 16.4142 12.25 16 12.25H12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "display-setting-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["display","settings","adjust","configuration","screen","monitor","options","preferences","customize","display settings","adjust screen","configure display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 9H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10L14 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L10 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "display-setting": {
        defaultColors: ["#3D4C66"],
        keywords: ["display-setting","monitor","computer","screen","settings","adjustment","sliders","configuration","preferences","customize","system-settings","tune"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M8 9H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10L14 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L10 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L16 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "disqus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["comment","feedback","letter-d","disqus","support","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9H12C13.6569 9 15 10.3431 15 12V12C15 13.6569 13.6569 15 12 15H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.5937 20 9.27224 19.6372 8.12399 19H5V15.876C4.36284 14.7278 4 13.4063 4 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "disqus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["D","letter","message","chat","comment","feedback","discounts","deals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.5937 20 9.27224 19.6372 8.12399 19H5V15.876C4.36284 14.7278 4 13.4063 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9H12C13.6569 9 15 10.3431 15 12V12C15 13.6569 13.6569 15 12 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "disqus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-d","initials","communication","customer-support","dialog","settings","details","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14H10V10H12C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C10.5144 21 9.11032 20.6393 7.87325 20H4V16.1267C3.36073 14.8897 3 13.4856 3 12ZM8 9C8 8.44772 8.44772 8 9 8H12C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16H9C8.44772 16 8 15.5523 8 15V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    disqus: {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-d","initials","communication","customer-support","dialog","settings","details","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9H12C13.6569 9 15 10.3431 15 12V12C15 13.6569 13.6569 15 12 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.5937 20 9.27224 19.6372 8.12399 19H5V15.876C4.36284 14.7278 4 13.4063 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "divide-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["divide","division","split","calculation","math","percentage","discount","ratio","portion","breakdown","separate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C13.6569 20 15 18.6569 15 17C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17C9 18.6569 10.3431 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 12L20 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "divide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["divide","division","split","separate","share","discount","calculation","price-breakdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C13.6569 20 15 18.6569 15 17C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17C9 18.6569 10.3431 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 12L20 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "divide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","split","reduction","discount","percentage","calculator","split-bill","discount-bill","math"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.49988 6.5C8.49988 4.567 10.0669 3 11.9999 3C13.9329 3 15.4999 4.567 15.4999 6.5C15.4999 8.433 13.9329 10 11.9999 10C10.0669 10 8.49988 8.433 8.49988 6.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.49988 17.5C8.49988 15.567 10.0669 14 11.9999 14C13.9329 14 15.4999 15.567 15.4999 17.5C15.4999 19.433 13.9329 21 11.9999 21C10.0669 21 8.49988 19.433 8.49988 17.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 13L20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    divide: {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","split","reduction","discount","percentage","calculator","split-bill","discount-bill","math"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20C13.6569 20 15 18.6569 15 17C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17C9 18.6569 10.3431 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 12L20 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Doc-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","doc","record","paperwork","receipt","invoice","report","statement","file","information","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10H7C8.10457 10 9 10.8954 9 12V12C9 13.1046 8.10457 14 7 14H6V10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 11.5C11 10.6716 11.6716 10 12.5 10V10C13.3284 10 14 10.6716 14 11.5V12.5C14 13.3284 13.3284 14 12.5 14V14C11.6716 14 11 13.3284 11 12.5V11.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10H17.75C16.7835 10 16 10.8954 16 12C16 13.1046 16.7835 14 17.75 14H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Doc-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","doc","documentation","receipt","invoice","record","report","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10H7C8.10457 10 9 10.8954 9 12V12C9 13.1046 8.10457 14 7 14H6V10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 11.5C11 10.6716 11.6716 10 12.5 10V10C13.3284 10 14 10.6716 14 11.5V12.5C14 13.3284 13.3284 14 12.5 14V14C11.6716 14 11 13.3284 11 12.5V11.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10H17.75C16.7835 10 16 10.8954 16 12C16 13.1046 16.7835 14 17.75 14H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Doc-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["doc","document","report","information","record","details","invoice","receipt","statement","terms","conditions","policy","agreements"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.75 13.25V10.75H7C7.69036 10.75 8.25 11.3096 8.25 12C8.25 12.6904 7.69036 13.25 7 13.25H6.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5 10.75C12.0858 10.75 11.75 11.0858 11.75 11.5V12.5C11.75 12.9142 12.0858 13.25 12.5 13.25C12.9142 13.25 13.25 12.9142 13.25 12.5V11.5C13.25 11.0858 12.9142 10.75 12.5 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V13.0549C20.75 14.4225 20.75 15.5248 20.6335 16.3918C20.5125 17.2919 20.2536 18.0497 19.6517 18.6517C19.0497 19.2536 18.2919 19.5125 17.3918 19.6335C16.5248 19.75 15.4225 19.75 14.0549 19.75H9.94513C8.57756 19.75 7.47521 19.75 6.60825 19.6335C5.70814 19.5125 4.95027 19.2536 4.34835 18.6517C3.74644 18.0497 3.48754 17.2919 3.36653 16.3918C3.24997 15.5248 3.24998 14.4225 3.25 13.0549V10.9451C3.24998 9.57755 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57755 4.24998 9.94513 4.25ZM6 9.25C5.58579 9.25 5.25 9.58579 5.25 10V14C5.25 14.4142 5.58579 14.75 6 14.75H7C8.51878 14.75 9.75 13.5188 9.75 12C9.75 10.4812 8.51878 9.25 7 9.25H6ZM10.25 11.5C10.25 10.2574 11.2574 9.25 12.5 9.25C13.7426 9.25 14.75 10.2574 14.75 11.5V12.5C14.75 13.7426 13.7426 14.75 12.5 14.75C11.2574 14.75 10.25 13.7426 10.25 12.5V11.5ZM17.75 9.25C16.2783 9.25 15.25 10.5784 15.25 12C15.25 13.4216 16.2783 14.75 17.75 14.75H18C18.4142 14.75 18.75 14.4142 18.75 14C18.75 13.5858 18.4142 13.25 18 13.25H17.75C17.2887 13.25 16.75 12.7876 16.75 12C16.75 11.2124 17.2887 10.75 17.75 10.75H18C18.4142 10.75 18.75 10.4142 18.75 10C18.75 9.58579 18.4142 9.25 18 9.25H17.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "doc-bi-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["document","file","report","analytics","business-intelligence","bi","statement","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14V13.25C7.58579 13.25 7.25 13.5858 7.25 14H8ZM8 16H7.25C7.25 16.4142 7.58579 16.75 8 16.75V16ZM8 14.75H10V13.25H8V14.75ZM10 15.25H8V16.75H10V15.25ZM8.75 16V14H7.25V16H8.75ZM10 14.75C10.1381 14.75 10.25 14.8619 10.25 15H11.75C11.75 14.0335 10.9665 13.25 10 13.25V14.75ZM10 16.75C10.9665 16.75 11.75 15.9665 11.75 15H10.25C10.25 15.1381 10.1381 15.25 10 15.25V16.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12L8.75 12ZM7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14L7.25 14ZM8.75 14L8.75 12L7.25 12L7.25 14L8.75 14Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M12.25 16C12.25 16.4142 12.5858 16.75 13 16.75C13.4142 16.75 13.75 16.4142 13.75 16L12.25 16ZM13.75 12C13.75 11.5858 13.4142 11.25 13 11.25C12.5858 11.25 12.25 11.5858 12.25 12L13.75 12ZM13.75 16L13.75 12L12.25 12L12.25 16L13.75 16Z"
                    fill={colors?.[0] || "#2797E8"}
                />
            </svg>
        )
    },
    "doc-bi-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","file","report","invoice","record","receipt","bill","statement","data","doc","bi"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14V13.25C7.58579 13.25 7.25 13.5858 7.25 14H8ZM8 16H7.25C7.25 16.4142 7.58579 16.75 8 16.75V16ZM8 14.75H10V13.25H8V14.75ZM10 15.25H8V16.75H10V15.25ZM8.75 16V14H7.25V16H8.75ZM10 14.75C10.1381 14.75 10.25 14.8619 10.25 15H11.75C11.75 14.0335 10.9665 13.25 10 13.25V14.75ZM10 16.75C10.9665 16.75 11.75 15.9665 11.75 15H10.25C10.25 15.1381 10.1381 15.25 10 15.25V16.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12L8.75 12ZM7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14L7.25 14ZM8.75 14L8.75 12L7.25 12L7.25 14L8.75 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.25 16C12.25 16.4142 12.5858 16.75 13 16.75C13.4142 16.75 13.75 16.4142 13.75 16L12.25 16ZM13.75 12C13.75 11.5858 13.4142 11.25 13 11.25C12.5858 11.25 12.25 11.5858 12.25 12L13.75 12ZM13.75 16L13.75 12L12.25 12L12.25 16L13.75 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "doc-bi-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","file","report","billing-information","statement","invoice","receipt","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 15.25V14.75H10C10.1381 14.75 10.25 14.8619 10.25 15C10.25 15.1381 10.1381 15.25 10 15.25H8.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 4.08605C13.6837 3.99889 13.0522 3.99945 12.3137 4.00011L10.9294 4.00023C9.57532 4.00019 8.4587 4.00016 7.57495 4.11898C6.64712 4.24373 5.82769 4.51569 5.17158 5.1718C4.51547 5.82791 4.2435 6.64734 4.11876 7.57517C3.99995 8.45888 3.99997 9.5755 4 10.9295V13.0709C3.99997 14.4249 3.99995 15.5416 4.11876 16.4253C4.2435 17.3531 4.51547 18.1725 5.17158 18.8287C5.82769 19.4848 6.64712 19.7567 7.57495 19.8815C8.45869 20.0003 9.57527 20.0003 10.9294 20.0002H13.0706C14.4247 20.0003 15.5413 20.0003 16.4251 19.8815C17.3529 19.7567 18.1723 19.4848 18.8284 18.8287C19.4845 18.1725 19.7565 17.3531 19.8813 16.4253C20.0001 15.5416 20 14.425 20 13.0709L20.0001 11.9612C20.0007 11.059 20.0011 10.3746 19.7745 9.72854L19.7694 9.71406C19.7386 9.72053 19.7114 9.72499 19.6893 9.72822C19.5362 9.75055 19.3505 9.75039 19.2004 9.75026L18.948 9.75025C18.0495 9.75027 17.3003 9.7503 16.7055 9.67033C16.0777 9.58593 15.5109 9.40026 15.0555 8.94479C14.6 8.48932 14.4143 7.92252 14.3299 7.29472C14.25 6.69994 14.25 5.95072 14.25 5.05224L14.25 4.08605ZM8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12V16C7.25 16.4142 7.58579 16.75 8 16.75H10C10.9665 16.75 11.75 15.9665 11.75 15C11.75 14.0335 10.9665 13.25 10 13.25H8.75V12ZM14.25 12C14.25 11.5858 13.9142 11.25 13.5 11.25C13.0858 11.25 12.75 11.5858 12.75 12V16C12.75 16.4142 13.0858 16.75 13.5 16.75C13.9142 16.75 14.25 16.4142 14.25 16V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 5.00024V4.98174C15.8579 5.05538 15.9556 5.1453 16.0391 5.24963L18.4389 8.24948C17.7741 8.24685 17.2881 8.23516 16.9054 8.18371C16.4439 8.12167 16.2464 8.01444 16.1161 7.88413C15.9858 7.75381 15.8786 7.55631 15.8165 7.09485C15.7516 6.61182 15.75 5.96426 15.75 5.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Doc: {
        defaultColors: ["#3D4C66"],
        keywords: ["document","file","report","billing-information","statement","invoice","receipt","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10H7C8.10457 10 9 10.8954 9 12V12C9 13.1046 8.10457 14 7 14H6V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 11.5C11 10.6716 11.6716 10 12.5 10V10C13.3284 10 14 10.6716 14 11.5V12.5C14 13.3284 13.3284 14 12.5 14V14C11.6716 14 11 13.3284 11 12.5V11.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10H17.75C16.7835 10 16 10.8954 16 12C16 13.1046 16.7835 14 17.75 14H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "doc-bi": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","file","report","analytics","data","statistics","information","summary","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14V13.25C7.58579 13.25 7.25 13.5858 7.25 14H8ZM8 16H7.25C7.25 16.4142 7.58579 16.75 8 16.75V16ZM8 14.75H10V13.25H8V14.75ZM10 15.25H8V16.75H10V15.25ZM8.75 16V14H7.25V16H8.75ZM10 14.75C10.1381 14.75 10.25 14.8619 10.25 15H11.75C11.75 14.0335 10.9665 13.25 10 13.25V14.75ZM10 16.75C10.9665 16.75 11.75 15.9665 11.75 15H10.25C10.25 15.1381 10.1381 15.25 10 15.25V16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12L8.75 12ZM7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14L7.25 14ZM8.75 14L8.75 12L7.25 12L7.25 14L8.75 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.25 16C12.25 16.4142 12.5858 16.75 13 16.75C13.4142 16.75 13.75 16.4142 13.75 16L12.25 16ZM13.75 12C13.75 11.5858 13.4142 11.25 13 11.25C12.5858 11.25 12.25 11.5858 12.25 12L13.75 12ZM13.75 16L13.75 12L12.25 12L12.25 16L13.75 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","clipboard","check","checkmark","validation","confirm","approved","completed","verified","report","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["document","check","checkmark","clipboard","complete","done","order-complete","transaction-complete","payment-received","verified","approved","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C10.3431 4 9 5.34315 9 7V8H15V7C15 5.34315 13.6569 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clipboard","checklist","check","complete","done","order-complete","payment-received","verified","approved","confirmation","task-complete","success","finished"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.83682 5C9.39855 3.81753 10.6038 3 12 3C13.3962 3 14.6015 3.81753 15.1632 5H8.83682Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93417 6H14.0658C14.9523 5.99995 15.7161 5.99991 16.3278 6.08215C16.9833 6.17028 17.6117 6.36902 18.1213 6.87868C18.631 7.38835 18.8297 8.0167 18.9179 8.67221C19.0001 9.28387 19.0001 10.0477 19 10.9342V15.0658C19.0001 15.9523 19.0001 16.7161 18.9179 17.3278C18.8297 17.9833 18.631 18.6117 18.1213 19.1213C17.6117 19.631 16.9833 19.8297 16.3278 19.9179C15.7161 20.0001 14.9523 20.0001 14.0658 20H9.93417C9.04769 20.0001 8.28387 20.0001 7.67221 19.9179C7.0167 19.8297 6.38835 19.631 5.87868 19.1213C5.36902 18.6117 5.17028 17.9833 5.08215 17.3278C4.99991 16.7161 4.99995 15.9523 5 15.0658V10.9342C4.99995 10.0477 4.99991 9.28387 5.08215 8.67221C5.17028 8.0167 5.36902 7.38835 5.87868 6.87868C6.38835 6.36902 7.0167 6.17028 7.67221 6.08215C8.28387 5.99991 9.04769 5.99995 9.93417 6ZM14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L11 12.5858L10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L14.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","list","report","invoice","details","order-details","receipt","record","summary","transaction","sales-report","data","clipboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","list","clipboard","report","invoice","receipt","notes","checklist","record","form"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","list","menu","details","receipt","report","summary","invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4C10 3.44772 9.55229 3 9 3C8.44772 3 8 3.44772 8 4V4.07187C7.85278 4.08496 7.7111 4.10045 7.57494 4.11875C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82768 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57527 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82768 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11875C16.2889 4.10045 16.1472 4.08496 16 4.07187V4C16 3.44772 15.5523 3 15 3C14.4477 3 14 3.44772 14 4V4.00159C13.7037 3.99998 13.3939 3.99999 13.0706 4H10.9294C10.6061 3.99999 10.2963 3.99998 10 4.00159V4ZM15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H9C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H15ZM14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12ZM11 14C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","check","invoice","order","complete","confirm","validate","receipt","approved","verified","transaction-complete","payment-received","order-confirmation","receipt-validation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L11 15L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","check","verified","approved","order-confirmation","report","invoice","completed","transaction","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 14L11 15L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","page","receipt","list","order-list","invoice","sales-report","transaction","record","notes","notepad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","check","checkmark","approve","complete","verified","confirmation","receipt","invoice","order-confirmation","transaction-complete","payment-verified","report","validated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9296C3.99997 9.57551 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929C14.3166 10.9024 13.6834 10.9024 13.2929 11.2929L11 13.5858L10.7071 13.2929C10.3166 12.9024 9.68342 12.9024 9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071L10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071L14.7071 12.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","check","validated","approved","report","invoice","receipt","confirmation","order-confirmation","transaction-approved","payment-processed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L11 15L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","file","cross","delete","remove","cancel","void","transaction","receipt","error","invoice","order","void-transaction","cancel-order","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.5 11.5L13.5 14.5M13.5 11.5L10.5 14.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Document-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","file","cross","delete","remove","cancel","discard","error","invalid","rejected","void","void-transaction","void-sale","refund","declined"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9296C3.99997 9.57551 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM11.2071 10.7929C10.8166 10.4024 10.1834 10.4024 9.79289 10.7929C9.40237 11.1834 9.40237 11.8166 9.79289 12.2071L10.5858 13L9.79289 13.7929C9.40237 14.1834 9.40237 14.8166 9.79289 15.2071C10.1834 15.5976 10.8166 15.5976 11.2071 15.2071L12 14.4142L12.7929 15.2071C13.1834 15.5976 13.8166 15.5976 14.2071 15.2071C14.5976 14.8166 14.5976 14.1834 14.2071 13.7929L13.4142 13L14.2071 12.2071C14.5976 11.8166 14.5976 11.1834 14.2071 10.7929C13.8166 10.4024 13.1834 10.4024 12.7929 10.7929L12 11.5858L11.2071 10.7929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","cross","remove","delete","cancel","void","void-transaction","cancel-transaction","error","file","reject"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.5 11.5L13.5 14.5M13.5 11.5L10.5 14.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Document-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","file","remove","delete","cancel","void","transaction","delete-transaction","cancel-transaction","void-transaction","receipt","remove-receipt","delete-receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 11.5L13.5 14.5M13.5 11.5L10.5 14.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Document-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","list","menu","options","receipt","transaction-history","report","settings","order-details","invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","receipt","list","details","order-details","invoice","menu","items","transaction","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","list","lines","details","order-details","receipt","invoice","transaction-details","summary","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM15 10C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8H9C8.44772 8 8 8.44772 8 9C8 9.55229 8.44772 10 9 10H15ZM14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12ZM11 14C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","list","menu","receipt","report","invoice","details","order-details","transaction-history","record","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","note","notepad","list","details","order-details","transaction-details","sales-report","receipt","invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9L11 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L11 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","note","list","details","order-details","invoice","receipt","transaction-details","record","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 14L6 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10L6 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","note","list","details","receipt","invoice","sales-data","record","order-details","transaction-details","summary","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4246 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57535 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C4.06205 16.0033 4.03241 15.5284 4.01692 15H4C3.44772 15 3 14.5523 3 14C3 13.4477 3.44772 13 4 13L4 11C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H4.01692C4.03241 8.4716 4.06205 7.99675 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45867 3.99994 9.57536 3.99997 10.9294 4ZM15 10C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8H9C8.44772 8 8 8.44772 8 9C8 9.55229 8.44772 10 9 10H15ZM14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12ZM11 14C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-Note-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","note","list","order-list","receipt","details","invoice","transaction-details","sales-report","report","record","purchase-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M6 15L8 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L8 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L8 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9L11 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L11 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","note","list","invoice","receipt","order-details","transaction-history","report","record","details","notepad","sales-report","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 4H10.9342C10.0477 3.99995 9.28387 3.99991 8.67221 4.08215C8.0167 4.17028 7.38835 4.36902 6.87868 4.87868C6.36902 5.38835 6.17028 6.0167 6.08215 6.67221C6.03041 7.05703 6.01124 7.50207 6.00415 8H6C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10L6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13L6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16H6.00415C6.01124 16.4979 6.03041 16.943 6.08215 17.3278C6.17028 17.9833 6.36902 18.6117 6.87868 19.1213C7.38835 19.631 8.0167 19.8297 8.67221 19.9179C9.28387 20.0001 10.0477 20.0001 10.9342 20H15.0658C15.9523 20.0001 16.7161 20.0001 17.3278 19.9179C17.9833 19.8297 18.6117 19.631 19.1213 19.1213C19.631 18.6117 19.8297 17.9833 19.9179 17.3278C20.0001 16.7161 20.0001 15.9523 20 15.0658V8.93417C20.0001 8.04769 20.0001 7.28387 19.9179 6.67221C19.8297 6.0167 19.631 5.38835 19.1213 4.87868C18.6117 4.36902 17.9833 4.17028 17.3278 4.08215C16.7161 3.99991 15.9523 3.99995 15.0658 4ZM15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10L11 10C10.4477 10 10 9.55228 10 9C10 8.44771 10.4477 8 11 8L15 8ZM15 12C15 11.4477 14.5523 11 14 11L11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H14C14.5523 13 15 12.5523 15 12ZM13 14C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H11C10.4477 16 10 15.5523 10 15C10 14.4477 10.4477 14 11 14H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-Note-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","note","list","order-details","receipt","invoice","checklist","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 15L6 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L6 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9L6 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 9L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["notebook","document","note","list","receipt","invoice","checklist","tasks","menu","order-details","report","summary","logs","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 15L6 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L6 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9L6 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 9L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L9 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","note","list","menu","order-details","transaction","history","report","inventory-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 15L6 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L6 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9L6 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 9L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L9 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","note","list","menu","receipt","invoice","details","order-details","notepad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H11.9294C10.5753 3.99997 9.45868 3.99994 8.57494 4.11876C7.64711 4.2435 6.82768 4.51547 6.17158 5.17158C5.51547 5.82769 5.2435 6.64711 5.11875 7.57494C5.10045 7.7111 5.08496 7.85278 5.07187 8H5C4.44772 8 4 8.44772 4 9C4 9.55229 4.44772 10 5 10H5.00159C4.99998 10.2963 4.99999 10.6061 5 10.9294L5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13L5 13.0706C4.99999 13.3939 4.99998 13.7037 5.00159 14H5C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H5.07187C5.08496 16.1472 5.10045 16.2889 5.11875 16.4251C5.2435 17.3529 5.51547 18.1723 6.17158 18.8284C6.82768 19.4845 7.64711 19.7565 8.57494 19.8813C9.45868 20.0001 10.5753 20 11.9294 20H13.0707C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V10.9294C20 9.57531 20.0001 8.4587 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM13 8C13.5523 8 14 8.44772 14 9C14 9.55229 13.5523 10 13 10L9 10C8.44772 10 8 9.55229 8 9C8 8.44772 8.44772 8 9 8L13 8ZM13 12C13 11.4477 12.5523 11 12 11L9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44771 13 9 13H12C12.5523 13 13 12.5523 13 12ZM11 14C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-Note-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","note","list","details","record","notepad","invoice","receipt","transactions","inventory","reports","settings","customer-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 14L6 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10L6 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","note","list","menu","details","receipt","invoice","record","sales-record","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 14L6 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10L6 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-Note": {
        defaultColors: ["#3D4C66"],
        keywords: ["notes","list","order-list","menu","invoice","report","history","details","record","receipt","notepad","document"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 9L11 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L11 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-notebook-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","notebook","list","order-list","report","sales-report","notepad","receipt","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L10 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L10 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-notebook-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","notebook","note","memo","list","task-list","notepad","record","sales-record","sales-report","summary","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L10 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-notebook-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["notebook","document","report","sales-report","inventory","stock","list","clipboard","notepad","notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.5C9.55228 3.5 10 3.94772 10 4.5H14C14 3.94772 14.4477 3.5 15 3.5C15.5523 3.5 16 3.94772 16 4.5V4.5467C16.1136 4.55637 16.223 4.56805 16.3278 4.58215C16.9833 4.67028 17.6117 4.86902 18.1213 5.37868C18.631 5.88835 18.8297 6.5167 18.9179 7.17221C19.0001 7.78387 19.0001 8.54769 19 9.43417V15.5658C19.0001 16.4523 19.0001 17.2161 18.9179 17.8278C18.8297 18.4833 18.631 19.1117 18.1213 19.6213C17.6117 20.131 16.9833 20.3297 16.3278 20.4179C15.7161 20.5001 14.9523 20.5001 14.0658 20.5H9.93417C9.04769 20.5001 8.28387 20.5001 7.67221 20.4179C7.0167 20.3297 6.38835 20.131 5.87868 19.6213C5.36902 19.1117 5.17028 18.4833 5.08215 17.8278C4.99991 17.2161 4.99995 16.4523 5 15.5658V9.43417C4.99995 8.54769 4.99991 7.78387 5.08215 7.17221C5.17028 6.5167 5.36902 5.88835 5.87868 5.37868C6.38835 4.86902 7.0167 4.67028 7.67221 4.58215C7.77706 4.56805 7.88637 4.55637 8 4.5467V4.5C8 3.94772 8.44772 3.5 9 3.5ZM14 8.5C14.5523 8.5 15 8.94772 15 9.5C15 10.0523 14.5523 10.5 14 10.5L10 10.5C9.44772 10.5 9 10.0523 9 9.5C9 8.94771 9.44772 8.5 10 8.5L14 8.5ZM14 12.5C14 11.9477 13.5523 11.5 13 11.5L10 11.5C9.44771 11.5 9 11.9477 9 12.5C9 13.0523 9.44771 13.5 10 13.5H13C13.5523 13.5 14 13.0523 14 12.5ZM12 14.5C12.5523 14.5 13 14.9477 13 15.5C13 16.0523 12.5523 16.5 12 16.5H10C9.44772 16.5 9 16.0523 9 15.5C9 14.9477 9.44772 14.5 10 14.5H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-notebook": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","notebook","notes","list","clipboard","report","summary","invoice","receipt","record","sales-report","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 4L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 4L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-page-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","page","file","receipt","report","invoice","details","summary","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-page-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","page","invoice","receipt","details","summary","report","records","transaction-details","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 12H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-page-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","page","menu","options","details","list","receipt","invoice","order-details","transaction-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6847 4.00009C12.7445 3.99925 13.5493 3.99862 14.2881 4.30466C15.0269 4.61069 15.5955 5.1802 16.3444 5.93021L18.07 7.6558C18.82 8.40463 19.3895 8.97325 19.6955 9.71208C20.0016 10.4509 20.0009 11.2557 20.0001 12.3155L20 13.0707C20 14.4248 20.0001 15.5415 19.8813 16.4252C19.7565 17.3531 19.4845 18.1725 18.8284 18.8286C18.1723 19.4847 17.3529 19.7567 16.4251 19.8814C15.5413 20.0002 14.4247 20.0002 13.0706 20.0002H10.9294C9.57531 20.0002 8.4587 20.0002 7.57494 19.8814C6.64711 19.7567 5.82769 19.4847 5.17158 18.8286C4.51547 18.1725 4.2435 17.3531 4.11876 16.4252C3.99994 15.5415 3.99997 14.4249 4 13.0708V10.9296C3.99997 9.57551 3.99994 8.45885 4.11876 7.57511C4.2435 6.64728 4.51547 5.82785 5.17158 5.17175C5.82769 4.51564 6.64711 4.24367 7.57494 4.11893C8.4587 4.00011 9.57531 4.00014 10.9294 4.00017L11.6847 4.00009ZM9 11.0002C8.44772 11.0002 8 11.448 8 12.0002C8 12.5525 8.44772 13.0002 9 13.0002H15C15.5523 13.0002 16 12.5525 16 12.0002C16 11.448 15.5523 11.0002 15 11.0002H9ZM9 14.5002C8.44772 14.5002 8 14.948 8 15.5002C8 16.0525 8.44772 16.5002 9 16.5002H15C15.5523 16.5002 16 16.0525 16 15.5002C16 14.948 15.5523 14.5002 15 14.5002H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-page": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","page","receipt","report","invoice","record","file","details","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-paper-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","paper","list","report","invoice","receipt","record","notes","information","summary","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-paper-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","paper","report","invoice","receipt","bill","transaction","record","history","details","statement","order","form","file"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-paper-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","paper","report","invoice","receipt","transaction","sales-report","summary","details","record","list","statement","bill","history","account","sales","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9296C3.99997 9.57551 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM8 7.5C7.44772 7.5 7 7.94772 7 8.5C7 9.05228 7.44772 9.5 8 9.5H10C10.5523 9.5 11 9.05228 11 8.5C11 7.94772 10.5523 7.5 10 7.5H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11L8 11ZM8 14.5C7.44772 14.5 7 14.9477 7 15.5C7 16.0523 7.44772 16.5 8 16.5H13C13.5523 16.5 14 16.0523 14 15.5C14 14.9477 13.5523 14.5 13 14.5H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-paper-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","paper","receipt","invoice","report","record","statement","sales","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-paper-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","paper","file","list","receipt","invoice","record","report","statement","bill","details","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-paper-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","paper","file","receipt","invoice","report","record","statement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 12H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-paper-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","paper","file","receipt","invoice","report","transaction","details","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9296C3.99997 9.57551 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9ZM9 14.5C8.44772 14.5 8 14.9477 8 15.5C8 16.0523 8.44772 16.5 9 16.5H15C15.5523 16.5 16 16.0523 16 15.5C16 14.9477 15.5523 14.5 15 14.5H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-paper": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","paper","receipt","invoice","report","order-details","transaction","sales-report","record","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Document-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["add","package","new","box","plus","add-package","new-package","create","create-package","shopping-bag","add-item","new-item","add-product","new-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Document-plus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["document","plus","add","new","create","add-document","new-document","create-document","invoice","add-invoice","new-invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C10.3431 4 9 5.34315 9 7V8H15V7C15 5.34315 13.6569 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Document-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["package","add","plus","new-item","new","item","add-item","product","add-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.83679 5C9.39852 3.81753 10.6038 3 12 3C13.3962 3 14.6014 3.81753 15.1632 5H8.83679Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93417 6H14.0658C14.9523 5.99995 15.7161 5.99991 16.3278 6.08215C16.9833 6.17028 17.6117 6.36902 18.1213 6.87868C18.631 7.38835 18.8297 8.0167 18.9179 8.67221C19.0001 9.28387 19.0001 10.0477 19 10.9342V15.0658C19.0001 15.9523 19.0001 16.7161 18.9179 17.3278C18.8297 17.9833 18.631 18.6117 18.1213 19.1213C17.6117 19.631 16.9833 19.8297 16.3278 19.9179C15.7161 20.0001 14.9523 20.0001 14.0658 20H9.93417C9.04769 20.0001 8.28387 20.0001 7.67221 19.9179C7.0167 19.8297 6.38835 19.631 5.87868 19.1213C5.36902 18.6117 5.17028 17.9833 5.08215 17.3278C4.99991 16.7161 4.99995 15.9523 5 15.0658V10.9342C4.99995 10.0477 4.99991 9.28387 5.08215 8.67221C5.17028 8.0167 5.36902 7.38835 5.87868 6.87868C6.38835 6.36902 7.0167 6.17028 7.67221 6.08215C8.28387 5.99991 9.04769 5.99995 9.93417 6ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V12H10C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Document-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","plus","add","new","create","item","add-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 13H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Document: {
        defaultColors: ["#3D4C66"],
        keywords: ["document","plus","add","new","create","item","add-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 9.11438 6 8.17157 6.58579 7.58579C7.17157 7 8.11438 7 10 7H14C15.8856 7 16.8284 7 17.4142 7.58579C18 8.17157 18 9.11438 18 11V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dolly-3": {
        defaultColors: ["#000000"],
        keywords: ["dolly","shipping","delivery","move","transport","box","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 4C2 3.44772 2.44772 3 3 3H5.83349C6.66247 3 7.40553 3.51141 7.70159 4.28572L11.2046 13.4474C11.3372 13.4321 11.472 13.4242 11.6088 13.4242C12.8779 13.4242 13.9887 14.1018 14.5993 15.1149L20.6489 12.8463C21.166 12.6524 21.7424 12.9144 21.9363 13.4315C22.1302 13.9486 21.8682 14.525 21.3511 14.7189L15.0946 17.0651C15.0152 18.9217 13.4849 20.4025 11.6088 20.4025C9.68177 20.4025 8.11963 18.8403 8.11963 16.9133C8.11963 15.8401 8.60418 14.8801 9.36643 14.24L5.83349 5H3C2.44772 5 2 4.55228 2 4Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M13.1534 6.61507L13.7174 8.10682C13.7551 8.20663 13.8011 8.32859 13.8551 8.42859C13.9208 8.55019 14.0356 8.71313 14.2471 8.80859C14.4587 8.90404 14.6568 8.88232 14.7914 8.85111C14.9021 8.82544 15.024 8.77925 15.1238 8.74145L15.5952 8.56321C15.695 8.52555 15.8169 8.47953 15.9169 8.42553C16.0385 8.35987 16.2015 8.24505 16.2969 8.03352C16.3924 7.82199 16.3707 7.62384 16.3394 7.48921C16.3138 7.37851 16.2676 7.25662 16.2298 7.15686L15.6657 5.66511C16.0128 5.534 16.323 5.41926 16.5887 5.35763C16.898 5.28593 17.2296 5.2648 17.5643 5.41582C17.8989 5.56684 18.1025 5.82948 18.2533 6.10878C18.3921 6.36575 18.5189 6.70111 18.6614 7.07822L19.284 8.72483C19.4267 9.10192 19.5535 9.43727 19.6195 9.72176C19.6912 10.031 19.7123 10.3626 19.5613 10.6973C19.4103 11.0319 19.1476 11.2355 18.8683 11.3864C18.6113 11.5251 18.276 11.6519 17.8989 11.7945L15.5344 12.6885C15.1573 12.8311 14.822 12.9579 14.5375 13.0239C14.2283 13.0956 13.8967 13.1167 13.562 12.9657C13.2273 12.8147 13.0238 12.5521 12.8729 12.2727C12.7342 12.0158 12.6074 11.6804 12.4648 11.3033L11.8422 9.6567C11.6996 9.27961 11.5728 8.94427 11.5068 8.65977C11.4351 8.35055 11.414 8.01892 11.565 7.68426C11.716 7.34959 11.9787 7.14601 12.258 6.99518C12.498 6.86556 12.8064 6.7464 13.1534 6.61507Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "dolly-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["dolly","hand truck","move","delivery","shipping","transport","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="11.6088" cy="16.913" r="2.73913" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M11 8.5L15.7841 6.69214C16.2913 6.50047 16.8589 6.74796 17.0636 7.25007L19 12"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7827 7.91211L13.9566 11.0425"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dolly-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["dolly","delivery","shipping","package","box","transport","cart","moving","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="11.6088"
                    cy="16.913"
                    r="2.73913"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2274 6.58747C12.8503 6.73003 12.5149 6.8568 12.258 6.99557C11.9787 7.1464 11.716 7.34998 11.565 7.68464C11.414 8.01931 11.4351 8.35094 11.5068 8.66016C11.5728 8.94466 11.6996 9.27999 11.8422 9.65708L12.4648 11.3037C12.6074 11.6808 12.7342 12.0162 12.8729 12.2731C13.0238 12.5524 13.2273 12.8151 13.562 12.9661C13.8967 13.1171 14.2283 13.096 14.5375 13.0243C14.822 12.9583 15.1573 12.8315 15.5344 12.6889L17.8989 11.7948C18.276 11.6523 18.6113 11.5255 18.8683 11.3867C19.1476 11.2359 19.4103 11.0323 19.5613 10.6977C19.7123 10.363 19.6912 10.0314 19.6195 9.72215C19.5535 9.43765 19.4267 9.10231 19.284 8.72522L18.6614 7.07862C18.5189 6.7015 18.3921 6.36614 18.2533 6.10917C18.1025 5.82987 17.8989 5.56723 17.5643 5.41621C17.2296 5.26519 16.898 5.28631 16.5887 5.35802C16.3042 5.42399 15.9689 5.55082 15.5918 5.69344L13.2274 6.58747Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M15.6657 5.66527L13.1533 6.61523L13.7174 8.10708C13.7551 8.2069 13.8011 8.32886 13.8551 8.42885C13.9208 8.55045 14.0356 8.7134 14.2471 8.80885C14.4587 8.90431 14.6568 8.88259 14.7914 8.85137C14.9021 8.8257 15.024 8.77951 15.1238 8.74171L15.5952 8.56348C15.695 8.52582 15.8169 8.4798 15.9169 8.4258C16.0385 8.36014 16.2015 8.24531 16.2969 8.03378C16.3924 7.82226 16.3707 7.6241 16.3394 7.48948C16.3138 7.37877 16.2676 7.25688 16.2298 7.15711L15.6657 5.66527Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "dolly-blank-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["circle","ring","void","empty","null","reset","default","status","pending","clear","remove","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="11.6088"
                    cy="16.913"
                    r="2.73913"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dolly-blank-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","dolly","transport","move","cargo","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 4C2 3.44772 2.44772 3 3 3H5.83349C6.66247 3 7.40553 3.51141 7.70159 4.28572L11.2046 13.4474C11.3372 13.4321 11.472 13.4242 11.6088 13.4242C12.8779 13.4242 13.9887 14.1018 14.5993 15.1149L20.6489 12.8463C21.166 12.6524 21.7424 12.9144 21.9363 13.4315C22.1302 13.9486 21.8682 14.525 21.3511 14.7189L15.0946 17.0651C15.0152 18.9217 13.4849 20.4025 11.6088 20.4025C9.68177 20.4025 8.11963 18.8403 8.11963 16.9133C8.11963 15.8401 8.60418 14.8801 9.36643 14.24L5.83349 5H3C2.44772 5 2 4.55228 2 4Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "dolly-blank": {
        defaultColors: ["#000000"],
        keywords: ["dolly","blank","empty","shipping","delivery","package","inventory","stock","warehouse","move","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="11.6088" cy="16.913" r="2.73913" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    dolly: {
        defaultColors: ["#000000"],
        keywords: ["dolly","blank","empty","shipping","delivery","package","inventory","stock","warehouse","move","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="11.6088" cy="16.913" r="2.73913" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M11 8.5L15.7841 6.69214C16.2913 6.50047 16.8589 6.74796 17.0636 7.25007L19 12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7827 7.91211L13.9566 11.0425"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dong-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["currency","dong","money","payment","price","vietnam","vietnamese"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="9"
                    y="10"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 6V16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L16 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dong-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","dong","vietnam","payment","money","transaction","price","cost","amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 5C15.5523 5 16 5.44772 16 6C16.5523 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8V16C16 16.5523 15.5523 17 15 17C14.5946 17 14.2456 16.7588 14.0886 16.4121C13.4807 16.785 12.7654 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C12.7286 9 13.4117 9.19479 14 9.53513V8H13C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6H14C14 5.44772 14.4477 5 15 5ZM14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13ZM5 19C5 18.4477 5.44772 18 6 18H18C18.5523 18 19 18.4477 19 19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dong-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["dong","currency","vietnam","money","payment","price","cost","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="10" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 6V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "door-closed-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["door","closed","exit","entry","access","leave","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dong-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dong","vietnam","currency","money","payment","price","cost","vnd","vietnamese-dong","symbol"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="10" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 6V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 7L16 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "door-closed-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["door","exit","close","access","locked","security","leave","logout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C8.11438 5 7.17157 5 6.58579 5.58579C6 6.17157 6 7.11438 6 9V19H18V9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19M4 19H20"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "door-closed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["door","exit","login","logout","entrance","leave","access","portal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 4.08215C8.28387 3.99991 9.04768 3.99995 9.93417 4H14.0658C14.9523 3.99995 15.7161 3.99991 16.3278 4.08215C16.9833 4.17028 17.6117 4.36902 18.1213 4.87868C18.631 5.38835 18.8297 6.0167 18.9179 6.67221C19.0001 7.28387 19.0001 8.04769 19 8.93417L19 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H5L5 8.93417C4.99995 8.04769 4.9999 7.28387 5.08214 6.67221C5.17027 6.0167 5.36902 5.38835 5.87868 4.87868C6.38834 4.36902 7.01669 4.17028 7.67221 4.08215ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dots-ellipsis-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["more","options","menu","settings","actions","ellipsis","dots"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#3D4C66"} />
                <rect x="10" y="10" width="4" height="4" rx="2" fill={colors?.[1] || "#2797E8"} />
                <rect x="16" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "dots-ellipsis-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["more","options","menu","settings","ellipsis","dots","actions","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#D9D1E0"} />
                <rect x="10" y="10" width="4" height="4" rx="2" fill={colors?.[1] || "#3D4C66"} />
                <rect x="16" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#D9D1E0"} />
            </svg>
        )
    },
    "door-closed": {
        defaultColors: ["#3D4C66"],
        keywords: ["door","access","exit","close","closed","security","authorization","locked","building","room","log-out","logout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dolly-blank-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["circle","void","empty","blank","item","nothing","void-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 13.7822L16.3043 15.5431L15.1304 15.9833L14.5435 16.2034"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 4H5.83349C6.24798 4 6.61951 4.2557 6.76754 4.64286L9.06522 10.6522L10.337 13.9783"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="11.6088"
                    cy="16.913"
                    r="2.73913"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dots-ellipsis-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","menu","settings","actions","ellipsis","dots","context-menu","additional-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 13.1046 4.89543 14 6 14C6.55228 14 7.05228 13.7761 7.41421 13.4142C7.77614 13.0523 8 12.5523 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 12C16 13.1046 16.8954 14 18 14C18.5523 14 19.0523 13.7761 19.4142 13.4142C19.7761 13.0523 20 12.5523 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dots-ellipsis-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","menu","ellipsis","settings","actions","customize","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 13.1046 4.89543 14 6 14C6.55228 14 7.05228 13.7761 7.41421 13.4142C7.77614 13.0523 8 12.5523 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C16 13.1046 16.8954 14 18 14C18.5523 14 19.0523 13.7761 19.4142 13.4142C19.7761 13.0523 20 12.5523 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dots-ellipsis-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["more","options","menu","ellipsis","dots","settings","actions","context-menu","additional-options","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 13.1046 4.89543 14 6 14C6.55228 14 7.05228 13.7761 7.41421 13.4142C7.77614 13.0523 8 12.5523 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C16 13.1046 16.8954 14 18 14C18.5523 14 19.0523 13.7761 19.4142 13.4142C19.7761 13.0523 20 12.5523 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dots-ellipsis-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["more","options","settings","menu","ellipsis","dots","actions","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 13.1046 4.89543 14 6 14C6.55228 14 7.05228 13.7761 7.41421 13.4142C7.77614 13.0523 8 12.5523 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C16 13.1046 16.8954 14 18 14C18.5523 14 19.0523 13.7761 19.4142 13.4142C19.7761 13.0523 20 12.5523 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dots-ellipsis-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","menu","settings","ellipsis","dots","additional-actions","actions","item-options","product-options","order-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 12C2 10.3431 3.34315 9 5 9C6.65685 9 8 10.3431 8 12C8 12.8282 7.66312 13.5795 7.12132 14.1213C6.57952 14.6631 5.82815 15 5 15C3.34315 15 2 13.6569 2 12ZM5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.27642 13 5.52505 12.8892 5.70711 12.7071C5.88917 12.525 6 12.2764 6 12C6 11.4477 5.55228 11 5 11ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.8282 14.6631 13.5795 14.1213 14.1213C13.5795 14.6631 12.8282 15 12 15C10.3431 15 9 13.6569 9 12ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.2764 13 12.525 12.8892 12.7071 12.7071C12.8892 12.525 13 12.2764 13 12C13 11.4477 12.5523 11 12 11ZM16 12C16 10.3431 17.3431 9 19 9C20.6569 9 22 10.3431 22 12C22 12.8282 21.6631 13.5795 21.1213 14.1213C20.5795 14.6631 19.8282 15 19 15C17.3431 15 16 13.6569 16 12ZM19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.2764 13 19.525 12.8892 19.7071 12.7071C19.8892 12.525 20 12.2764 20 12C20 11.4477 19.5523 11 19 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dots-ellipsis-vertical-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["more","options","menu","settings","actions","ellipsis","dots","vertical","overflow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C10.8954 4 10 4.89543 10 6C10 6.55228 10.2239 7.05228 10.5858 7.41421C10.9477 7.77614 11.4477 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 10C10.8954 10 10 10.8954 10 12C10 12.5523 10.2239 13.0523 10.5858 13.4142C10.9477 13.7761 11.4477 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 16.8954 10 18C10 18.5523 10.2239 19.0523 10.5858 19.4142C10.9477 19.7761 11.4477 20 12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dots-ellipsis-vertical-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","menu","settings","actions","ellipsis","vertical","dots"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C13.6569 2 15 3.34315 15 5C15 6.65685 13.6569 8 12 8C11.1718 8 10.4205 7.66312 9.87868 7.12132C9.33688 6.57952 9 5.82815 9 5C9 3.34315 10.3431 2 12 2ZM13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.27642 11.1108 5.52505 11.2929 5.70711C11.475 5.88917 11.7236 6 12 6C12.5523 6 13 5.55228 13 5ZM12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.1718 15 10.4205 14.6631 9.87868 14.1213C9.33688 13.5795 9 12.8282 9 12C9 10.3431 10.3431 9 12 9ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.2764 11.1108 12.525 11.2929 12.7071C11.475 12.8892 11.7236 13 12 13C12.5523 13 13 12.5523 13 12ZM12 16C13.6569 16 15 17.3431 15 19C15 20.6569 13.6569 22 12 22C11.1718 22 10.4205 21.6631 9.87868 21.1213C9.33688 20.5795 9 19.8282 9 19C9 17.3431 10.3431 16 12 16ZM13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.2764 11.1108 19.525 11.2929 19.7071C11.475 19.8892 11.7236 20 12 20C12.5523 20 13 19.5523 13 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dots-ellipsis-vertical": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","more","options","settings","ellipsis","dots","vertical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C10.8954 4 10 4.89543 10 6C10 6.55228 10.2239 7.05228 10.5858 7.41421C10.9477 7.77614 11.4477 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 10C10.8954 10 10 10.8954 10 12C10 12.5523 10.2239 13.0523 10.5858 13.4142C10.9477 13.7761 11.4477 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 16.8954 10 18C10 18.5523 10.2239 19.0523 10.5858 19.4142C10.9477 19.7761 11.4477 20 12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dots-ellipsis": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","menu","settings","ellipsis","actions","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#3D4C66"} />
                <rect x="10" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#3D4C66"} />
                <rect x="16" y="10" width="4" height="4" rx="2" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "dots-ellipsis-vertical-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["more","options","menu","settings","actions","ellipsis","vertical","dots","context-menu","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C10.8954 4 10 4.89543 10 6C10 6.55228 10.2239 7.05228 10.5858 7.41421C10.9477 7.77614 11.4477 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 10C10.8954 10 10 10.8954 10 12C10 12.5523 10.2239 13.0523 10.5858 13.4142C10.9477 13.7761 11.4477 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 16.8954 10 18C10 18.5523 10.2239 19.0523 10.5858 19.4142C10.9477 19.7761 11.4477 20 12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Double-coin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["coins","double-coins","payment","money","currency","dollar","transaction","finance","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="10" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="10" cy="14" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9.5 11H11.3333M9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14H10.3333C11.2538 14 12 14.6716 12 15.5C12 16.3284 11.2538 17 10.3333 17H9.5M9.5 11V10M8 17L9.5 17M9.5 17V18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Double-coin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["coins","money","dollar","payment","finance","cash","currency","price","cost","double","two-coins"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="14"
                    cy="10"
                    r="7"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="14"
                    r="7"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.5 11H11.3333M9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14H10.3333C11.2538 14 12 14.6716 12 15.5C12 16.3284 11.2538 17 10.3333 17H9.5M9.5 11V10M8 17L9.5 17M9.5 17V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Double-coin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["coins","currency","dollar","money","payment","cash","finance","transaction","sales","revenue","price","amount","funds"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.40573 6.21884C8.71709 3.93675 11.179 2.3999 13.9999 2.3999C18.1973 2.3999 21.5999 5.80254 21.5999 9.9999C21.5999 12.8208 20.0631 15.2827 17.781 16.594C18.0527 15.7788 18.1998 14.9066 18.1998 14C18.1998 9.47131 14.5285 5.80005 9.9998 5.80005C9.09323 5.80005 8.22101 5.94717 7.40573 6.21884Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 21C13.866 21 17 17.866 17 14C17 10.134 13.866 7 10 7C6.13401 7 3 10.134 3 14C3 17.866 6.13401 21 10 21ZM10.25 10C10.25 9.58579 9.91421 9.25 9.5 9.25C9.08579 9.25 8.75 9.58579 8.75 10V10.378C7.87611 10.6869 7.25 11.5203 7.25 12.5C7.25 13.7426 8.25736 14.75 9.5 14.75H10.3333C10.9159 14.75 11.25 15.1582 11.25 15.5C11.25 15.8418 10.9159 16.25 10.3333 16.25H8C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H8.75V18C8.75 18.4142 9.08579 18.75 9.5 18.75C9.91421 18.75 10.25 18.4142 10.25 18V17.75H10.3333C11.5917 17.75 12.75 16.815 12.75 15.5C12.75 14.185 11.5917 13.25 10.3333 13.25H9.5C9.08579 13.25 8.75 12.9142 8.75 12.5C8.75 12.0858 9.08579 11.75 9.5 11.75H11.3333C11.7475 11.75 12.0833 11.4142 12.0833 11C12.0833 10.5858 11.7475 10.25 11.3333 10.25H10.25V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Double-coin": {
        defaultColors: ["#3D4C66"],
        keywords: ["coins","currency","dollar","money","payment","change","finance","balance","price","cash","transaction","value","funds","investment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="10" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="10" cy="14" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9.5 11H11.3333M9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14H10.3333C11.2538 14 12 14.6716 12 15.5C12 16.3284 11.2538 17 10.3333 17H9.5M9.5 11V10M8 17L9.5 17M9.5 17V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "double-tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","tick","double-check","verified","confirmation","approved","success","complete","paid","order-fulfilled","receipt-validated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L9 17L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L9 13L8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "double-tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["double-tick","check","confirmed","verified","approval","completed","ok","authorize","accepted","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12L10 17L19 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10L10 13L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "double-tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","tick","checkmark","verified","approved","confirmed","order-complete","payment-received","inventory-verified","transaction-success","double-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.669 6.25671C20.0795 6.62617 20.1128 7.25846 19.7433 7.66897L10.7433 17.669C10.5598 17.8729 10.3005 17.9925 10.0263 17.9997C9.75204 18.0069 9.48688 17.9011 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L9.96181 15.5476L18.2567 6.33104C18.6262 5.92053 19.2585 5.88726 19.669 6.25671ZM15.6727 6.26007C16.0813 6.63158 16.1114 7.26402 15.7399 7.67268L10.7399 13.1727C10.556 13.375 10.2972 13.4932 10.0238 13.4997C9.7504 13.5062 9.48627 13.4005 9.29289 13.2071L6.29289 10.2071C5.90237 9.81659 5.90237 9.18343 6.29289 8.7929C6.68342 8.40238 7.31658 8.40238 7.70711 8.7929L9.96553 11.0513L14.2601 6.32734C14.6316 5.91868 15.264 5.88856 15.6727 6.26007Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "double-tick-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cancel","reject","deny","declined","invalid","error","disabled","inactive","cross","void","cancellation","return","refund","unapproved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L9 17L6 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L9 13L8 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 4L20 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "double-tick-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","disabled","incorrect","invalid","denied","rejected","crossed","slash","remove","delete","cancellation","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.7 19.2901L4.71002 3.29006C4.32002 2.90006 3.68996 2.90006 3.29996 3.29006C2.90996 3.68006 2.90002 4.32006 3.29002 4.71006L9.29002 10.7001L8.97002 11.0501L8.71002 10.7901C8.32002 10.4001 7.69002 10.4001 7.30002 10.7901C6.91002 11.1801 6.91002 11.8101 7.30002 12.2001L8.30002 13.2001C8.49002 13.3901 8.76002 13.5001 9.03002 13.4901C9.30002 13.4901 9.56002 13.3701 9.75002 13.1601L10.71 12.1001L11.42 12.8101L8.97002 15.5301L6.72002 13.2801C6.33002 12.8901 5.70002 12.8901 5.31002 13.2801C4.92002 13.6701 4.92002 14.3001 5.31002 14.6901L8.31002 17.6901C8.50002 17.8801 8.77002 17.9901 9.04002 17.9801C9.31002 17.9701 9.57002 17.8501 9.76002 17.6501L12.84 14.2201L19.31 20.6901C19.7 21.0801 20.33 21.0801 20.72 20.6901C21.11 20.3001 21.09 19.6801 20.7 19.2901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.11 11.7001L18.74 7.67006C19.11 7.26006 19.08 6.63006 18.67 6.26006C18.26 5.89006 17.63 5.92006 17.26 6.33006L13.7 10.2801L15.12 11.7001H15.11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.74 7.67006C15.11 7.26006 15.08 6.63006 14.67 6.26006C14.26 5.89006 13.63 5.92006 13.26 6.33006L11.58 8.17006L13 9.59006L14.74 7.68006V7.67006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "double-tick-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cancel","decline","reject","remove","unchecked","invalid","error","forbidden","no","not-allowed","disapprove","disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L9 17L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L9 13L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 4L20 20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "double-tick-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","decline","void","error","rejected","not-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L9 17L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L9 13L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 4L20 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "double-tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","double-check","verified","approved","confirmed","validated","completed","success","ok","done","receipt-printed","paid","payment-received"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L9 17L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L9 13L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Download-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["download","import","receive","get","arrow-down","data","sales-data","import-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L10.5858 13.5858C11.2525 14.2525 11.5858 14.5858 12 14.5858C12.4142 14.5858 12.7475 14.2525 13.4142 13.5858L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 14L12 5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Download-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","arrow","save","get","receive","update","install"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5L13 13.53C13.331 13.2528 13.7264 12.8594 14.2929 12.2929C14.6834 11.9024 15.3166 11.9024 15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071L15.6638 13.7504C15.0624 14.3519 14.5449 14.8695 14.0676 15.2377C13.5529 15.6347 13.0014 15.9265 12.3183 15.9861C12.2125 15.9954 12.1063 16 12 16C11.8937 16 11.7875 15.9954 11.6817 15.9861C10.9986 15.9265 10.4471 15.6347 9.93242 15.2377C9.45513 14.8695 8.93762 14.3519 8.3362 13.7504L8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929C8.68342 11.9024 9.31658 11.9024 9.70711 12.2929C10.2736 12.8594 10.669 13.2528 11 13.53L11 5C11 4.44772 11.4477 4 12 4ZM19 11C19.5523 11 20 11.4477 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.4477 18.4477 11 19 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Download-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","import","arrow-down","receive","data","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 13C13.7231 14.2769 13.0846 14.9154 12.2313 14.9899C12.0776 15.0034 11.9224 15.0034 11.7687 14.9899C10.9154 14.9154 10.2769 14.2769 9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Download-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["download","import","receive","data","arrow","update","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12L14.8284 13.1716C13.4951 14.5049 12.8284 15.1716 12 15.1716C11.1716 15.1716 10.5049 14.5049 9.17157 13.1716L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","arrow","inbox","get","data","update","install"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V13.5556C13.2968 13.2876 13.6529 12.9329 14.1213 12.4645L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L15.489 13.9252C14.8622 14.5521 14.3221 15.0922 13.8315 15.4666C13.3056 15.8678 12.7208 16.1716 12 16.1716C11.2792 16.1716 10.6944 15.8678 10.1685 15.4666C9.67789 15.0922 9.13782 14.5521 8.51101 13.9252L7.2929 12.7071C6.90237 12.3166 6.90237 11.6834 7.2929 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L9.87868 12.4645C10.3471 12.9328 10.7032 13.2876 11 13.5556L11 5C11 4.44772 11.4477 4 12 4ZM5 11C5.55229 11 6 11.4477 6 12V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H13C14.4425 18 15.4238 17.9979 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9979 15.4237 18 14.4425 18 13V12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12L20 13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8812C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 12C4 11.4477 4.44772 11 5 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Download-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","get","arrow-down","restore","backup","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 10H9C7.11438 10 6.17157 10 5.58579 10.5858C5 11.1716 5 12.1144 5 14V14C5 15.8856 5 16.8284 5.58579 17.4142C6.17157 18 7.11438 18 9 18H15C16.8856 18 17.8284 18 18.4142 17.4142C19 16.8284 19 15.8856 19 14V14C19 12.1144 19 11.1716 18.4142 10.5858C17.8284 10 16.8856 10 15 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13L10.5858 13.5858C11.2525 14.2525 11.5858 14.5858 12 14.5858C12.4142 14.5858 12.7475 14.2525 13.4142 13.5858L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Download-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["download","import","receive","get","arrow-down","data","restore","backup","receive-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15L12 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 10H9C8.07003 10 7.60504 10 7.22354 10.1022C6.18827 10.3796 5.37962 11.1883 5.10222 12.2235C5 12.605 5 13.07 5 14V14C5 14.93 5 15.395 5.10222 15.7765C5.37962 16.8117 6.18827 17.6204 7.22354 17.8978C7.60504 18 8.07003 18 9 18H15C15.93 18 16.395 18 16.7765 17.8978C17.8117 17.6204 18.6204 16.8117 18.8978 15.7765C19 15.395 19 14.93 19 14V14C19 13.07 19 12.605 18.8978 12.2235C18.6204 11.1883 17.8117 10.3796 16.7765 10.1022C16.395 10 15.93 10 15 10H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Download-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["download","import","receive","update","get","arrow-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 10H9C8.07003 10 7.60504 10 7.22354 10.1022C6.18827 10.3796 5.37962 11.1883 5.10222 12.2235C5 12.605 5 13.07 5 14V14C5 14.93 5 15.395 5.10222 15.7765C5.37962 16.8117 6.18827 17.6204 7.22354 17.8978C7.60504 18 8.07003 18 9 18H15C15.93 18 16.395 18 16.7765 17.8978C17.8117 17.6204 18.6204 16.8117 18.8978 15.7765C19 15.395 19 14.93 19 14V14C19 13.07 19 12.605 18.8978 12.2235C18.6204 11.1883 17.8117 10.3796 16.7765 10.1022C16.395 10 15.93 10 15 10H14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 13C13.7231 14.2769 13.0846 14.9154 12.2313 14.9899C12.0776 15.0034 11.9224 15.0034 11.7687 14.9899C10.9154 14.9154 10.2769 14.2769 9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Download-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","arrow-down","get","receive","load"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 5C12.5524 5 13.0001 5.44772 13.0001 6V13.53C13.3311 13.2528 13.7264 12.8594 14.293 12.2929C14.6835 11.9024 15.3167 11.9024 15.7072 12.2929C16.0977 12.6834 16.0977 13.3166 15.7072 13.7071L15.6639 13.7504C15.0625 14.3519 14.545 14.8695 14.0677 15.2377C13.553 15.6347 13.0015 15.9265 12.3184 15.9861C12.2126 15.9954 12.1064 16 12.0001 16C11.8938 16 11.7876 15.9954 11.6818 15.9861C10.9987 15.9265 10.4472 15.6347 9.93252 15.2377C9.45523 14.8695 8.93772 14.3519 8.3363 13.7504L8.29299 13.7071C7.90247 13.3166 7.90247 12.6834 8.29299 12.2929C8.68351 11.9024 9.31668 11.9024 9.7072 12.2929C10.2737 12.8594 10.6691 13.2528 11.0001 13.53L11.0001 6C11.0001 5.44772 11.4478 5 12.0001 5ZM8.86251 8.99995C8.90771 8.99998 8.95356 9 9.0001 9C9.55238 9 10.0001 9.44772 10.0001 10C10.0001 10.5523 9.55238 11 9.0001 11C8.00574 11 7.70474 11.0086 7.48246 11.0681C6.79227 11.2531 6.25318 11.7922 6.06824 12.4824C6.00869 12.7046 6.0001 13.0056 6.0001 14C6.0001 14.9944 6.00869 15.2954 6.06824 15.5176C6.25318 16.2078 6.79227 16.7469 7.48246 16.9319C7.70474 16.9914 8.00574 17 9.0001 17H15.0001C15.9944 17 16.2955 16.9914 16.5177 16.9319C17.2079 16.7469 17.747 16.2078 17.9319 15.5176C17.9915 15.2954 18.0001 14.9944 18.0001 14C18.0001 13.0056 17.9915 12.7046 17.9319 12.4824C17.747 11.7922 17.2079 11.2531 16.5177 11.0681C16.2955 11.0086 15.9944 11 15.0001 11C14.4478 11 14.0001 10.5523 14.0001 10C14.0001 9.44772 14.4478 9 15.0001 9C15.0466 9 15.0925 8.99998 15.1377 8.99995C15.9331 8.99952 16.5237 8.9992 17.0354 9.1363C18.4157 9.50617 19.4939 10.5844 19.8638 11.9647C20.0009 12.4764 20.0006 13.067 20.0001 13.8624C20.0001 13.9076 20.0001 13.9535 20.0001 14C20.0001 14.0465 20.0001 14.0924 20.0001 14.1376C20.0006 14.933 20.0009 15.5236 19.8638 16.0353C19.4939 17.4156 18.4157 18.4938 17.0354 18.8637C16.5237 19.0008 15.9331 19.0005 15.1377 19C15.0925 19 15.0466 19 15.0001 19H9.0001C8.95356 19 8.90771 19 8.86252 19C8.06713 19.0005 7.47647 19.0008 6.96482 18.8637C5.58445 18.4938 4.50626 17.4156 4.13639 16.0353C3.9993 15.5236 3.99962 14.933 4.00005 14.1376C4.00007 14.0924 4.0001 14.0465 4.0001 14C4.0001 13.9535 4.00007 13.9076 4.00005 13.8624C3.99962 13.067 3.9993 12.4764 4.13639 11.9647C4.50626 10.5844 5.58445 9.50617 6.96482 9.1363C7.47647 8.9992 8.06713 8.99952 8.86251 8.99995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Download-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow","import","receive","get","data","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Download-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","import","receive","arrow-down","arrow","data","get","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Download: {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","arrow-down","arrow","data","get","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L10.5858 13.5858C11.2525 14.2525 11.5858 14.5858 12 14.5858C12.4142 14.5858 12.7475 14.2525 13.4142 13.5858L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 14L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Dribbble-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["circle","network","connection","globe","world","online","dribbble","social"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9245 19C14.2476 13.7719 11.4914 7.4888 10.0734 5M16.7976 6.46077C15.9722 8.69214 14.0768 10.3881 11.7242 11.0004C9.37242 11.6158 6.86033 11.0701 5 9.53967M7.20135 17.5392C8.02763 15.3081 9.92264 13.6119 12.2749 12.9981C14.6272 12.3842 17.1391 12.9304 19 14.4603"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Dribbble-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ball","basketball","sports","game","recreation","activities","events","team"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9245 19C14.2476 13.7719 11.4914 7.4888 10.0734 5M16.7976 6.46077C15.9722 8.69214 14.0768 10.3881 11.7242 11.0004C9.37242 11.6158 6.86033 11.0701 5 9.53967M7.20135 17.5392C8.02763 15.3081 9.92264 13.6119 12.2749 12.9981C14.6272 12.3842 17.1391 12.9304 19 14.4603"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Dribbble-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","globe","connection","multi-store","franchise","international","world"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.98233 4.5887C7.14189 5.33883 5.64355 6.7546 4.78634 8.53697C6.62967 9.975 9.07093 10.4877 11.3706 9.90597C10.5574 7.66471 9.64143 5.76061 8.98233 4.5887Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.13456 10.5311C4.04619 11.0073 4 11.4982 4 12C4 13.9817 4.72052 15.795 5.91387 17.1924C7.10144 14.7234 9.34809 12.8812 12.0617 12.1731L12.1116 12.1602C12.0769 12.0421 12.0417 11.9244 12.0059 11.8072L11.9373 11.8253C9.25536 12.5269 6.4071 12.044 4.13456 10.5311Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.48186 18.6029C8.76748 19.4843 10.3235 20 12 20C12.4089 20 12.8106 19.9693 13.203 19.9101C13.3138 18.0576 13.0654 16.0568 12.6178 14.0952L12.5667 14.1083C10.2129 14.7225 8.32435 16.4039 7.48186 18.6029Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.2265 19.3227C16.9713 18.5528 18.3891 17.1775 19.2136 15.4631C17.8958 14.4358 16.273 13.8805 14.6146 13.8591C15.0123 15.6577 15.2579 17.5223 15.2265 19.3227Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.8654 13.4692C19.9538 12.9929 20 12.5019 20 12C20 10.018 19.2793 8.20442 18.0856 6.80693C17.1957 8.65855 15.7097 10.1575 13.8777 11.0895C13.9569 11.3457 14.0341 11.605 14.1088 11.8669C16.1428 11.782 18.165 12.3376 19.8654 13.4692Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5173 5.39649C15.2318 4.51546 13.6761 4 12 4C11.653 4 11.3112 4.02209 10.9759 4.06494C11.6478 5.32067 12.4808 7.11122 13.2306 9.16853C14.7328 8.32917 15.9037 7.00062 16.5173 5.39649Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Dribbble: {
        defaultColors: ["#3D4C66"],
        keywords: ["network","globe","connection","multi-store","franchise","international","world"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.9245 19C14.2476 13.7719 11.4914 7.4888 10.0734 5M16.7976 6.46077C15.9722 8.69214 14.0768 10.3881 11.7242 11.0004C9.37242 11.6158 6.86033 11.0701 5 9.53967M7.20135 17.5392C8.02763 15.3081 9.92264 13.6119 12.2749 12.9981C14.6272 12.3842 17.1391 12.9304 19 14.4603"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "drink-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["drink","beverage","cup","straw","soda","juice","menu-item","refreshment","order-item","iced-drink","cold-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H6L6.71596 16.3068C6.85074 18.0589 6.91813 18.9349 7.49323 19.4674C8.06832 20 8.94694 20 10.7042 20H13.2959C15.0532 20 15.9318 20 16.5069 19.4674C17.082 18.9349 17.1494 18.0588 17.2841 16.3068L18 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM6.71596 16.3068L5.96817 16.3643L6.71596 16.3068ZM17.2841 16.3068L18.0319 16.3643V16.3643L17.2841 16.3068ZM16.5069 19.4674L17.0165 20.0177H17.0165L16.5069 19.4674ZM7.49323 19.4674L6.98364 20.0177H6.98364L7.49323 19.4674ZM4 7.75H6V6.25H4V7.75ZM6 7.75H18V6.25H6V7.75ZM18 7.75H20V6.25H18V7.75ZM5.25221 7.05753L5.96817 16.3643L7.46375 16.2493L6.74779 6.94247L5.25221 7.05753ZM17.2522 6.94248L16.5364 16.2492L18.0319 16.3643L18.7478 7.05752L17.2522 6.94248ZM10.7042 20.75H13.2959V19.25H10.7042V20.75ZM16.5364 16.2492C16.4674 17.1455 16.4198 17.7451 16.3265 18.1908C16.2377 18.6154 16.1263 18.7977 15.9973 18.9172L17.0165 20.0177C17.4626 19.6047 17.6724 19.0826 17.7947 18.498C17.9126 17.9345 17.9661 17.2201 18.0319 16.3643L16.5364 16.2492ZM13.2959 20.75C14.1542 20.75 14.8707 20.7515 15.4416 20.6772C16.0338 20.6 16.5704 20.4308 17.0165 20.0177L15.9973 18.9172C15.8683 19.0366 15.6781 19.1337 15.2479 19.1897C14.7963 19.2485 14.1949 19.25 13.2959 19.25V20.75ZM5.96817 16.3643C6.034 17.2201 6.08747 17.9346 6.20537 18.4981C6.32769 19.0826 6.53758 19.6047 6.98364 20.0177L8.00281 18.9172C7.87378 18.7977 7.76243 18.6155 7.67358 18.1908C7.58032 17.7451 7.5327 17.1456 7.46375 16.2493L5.96817 16.3643ZM10.7042 19.25C9.80523 19.25 9.20379 19.2485 8.75225 19.1897C8.32206 19.1337 8.13184 19.0366 8.00281 18.9172L6.98364 20.0177C7.42971 20.4308 7.96634 20.6 8.55855 20.6772C9.1294 20.7515 9.84588 20.75 10.7042 20.75V19.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17 13L16.5008 13.2496C15.5727 13.7136 14.4672 13.6448 13.6039 13.0692V13.0692C12.6326 12.4218 11.3674 12.4218 10.3961 13.0692V13.0692C9.5328 13.6448 8.42726 13.7136 7.4992 13.2496L7 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4H11L12 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "drink-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["drink","cup","beverage","soda","juice","water","straw","order-item","menu-item","refreshment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 13L16.5008 13.2496C15.5727 13.7136 14.4672 13.6448 13.6039 13.0692V13.0692C12.6326 12.4218 11.3674 12.4218 10.3961 13.0692V13.0692C9.5328 13.6448 8.42726 13.7136 7.4992 13.2496L7 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4H11L12 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 7H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L6.71596 16.3068C6.85074 18.0589 6.91813 18.9349 7.49323 19.4674C8.06832 20 8.94694 20 10.7042 20H13.2959C15.0532 20 15.9318 20 16.5069 19.4674C17.082 18.9349 17.1494 18.0588 17.2841 16.3068L18 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "drink-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["drink","beverage","cup","straw","smoothie","juice","soda","iced-drink","add-drink","order","refreshment","cold-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 6H12.72L11.95 3.68C11.81 3.27 11.43 3 11 3H9C8.45 3 8 3.45 8 4C8 4.55 8.45 5 9 5H10.28L10.61 6H4C3.45 6 3 6.45 3 7C3 7.55 3.45 8 4 8H5.07L5.43 12.68C5.75 12.46 6.18 12.44 6.53 12.66L7.08 13.01C7.82 13.47 8.76 13.41 9.43 12.85C10.92 11.61 13.08 11.61 14.56 12.85C15.23 13.41 16.17 13.47 16.91 13.01L17.46 12.66C17.81 12.44 18.24 12.47 18.56 12.68L18.92 8H19.99C20.54 8 21 7.55 21 7C21 6.45 20.54 6 19.99 6H20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.29 14.37C12.54 13.75 11.46 13.75 10.72 14.37C9.39 15.48 7.5 15.61 6.03 14.69L5.57 14.41L5.73 16.45C5.79 17.27 5.85 17.98 5.97 18.55C6.1 19.16 6.32 19.74 6.82 20.2C7.32 20.66 7.91 20.84 8.53 20.92C9.11 21 9.82 21 10.65 21H13.37C14.2 21 14.91 20.99 15.49 20.92C16.11 20.84 16.7 20.66 17.2 20.2C17.7 19.74 17.93 19.16 18.05 18.55C18.17 17.98 18.22 17.27 18.29 16.45L18.45 14.41L17.99 14.69C16.52 15.61 14.63 15.48 13.3 14.37H13.29Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    drink: {
        defaultColors: ["#3D4C66"],
        keywords: ["drink","beverage","cup","straw","smoothie","juice","soda","iced-drink","add-drink","order","refreshment","cold-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L6.71596 16.3068C6.85074 18.0589 6.91813 18.9349 7.49323 19.4674C8.06832 20 8.94694 20 10.7042 20H13.2959C15.0532 20 15.9318 20 16.5069 19.4674C17.082 18.9349 17.1494 18.0588 17.2841 16.3068L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13L16.5008 13.2496C15.5727 13.7136 14.4672 13.6448 13.6039 13.0692V13.0692C12.6326 12.4218 11.3674 12.4218 10.3961 13.0692V13.0692C9.5328 13.6448 8.42726 13.7136 7.4992 13.2496L7 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4H11L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "drive-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["drive","cloud","storage","backup","sync","data","files","documents","remote-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 14H9M9 14L6 20M9 14L11.5204 9.02916M11.5204 9.02916L8 4M11.5204 9.02916L15 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M8 4L3 15L6 20H12H18L21 14L16 4H8Z" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "drive-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["drive","storage","cloud","backup","data","files","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L3 15L6 20H12H18L21 14L16 4H8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M21 14H9M9 14L6 20M9 14L11.5204 9.02916M11.5204 9.02916L8 4M11.5204 9.02916L15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "drive-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["storage","drive","cloud","files","data","backup","archive","server"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.12841 4.04598L2.12012 15.0642L5.10787 20.0438L8.35586 13.5478L10.6078 9.10653L7.12841 4.04598Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.86586 21H18.8658L21.8658 15.0001H15.2618C15.253 15.0002 15.2443 15.0002 15.2355 15.0001H9.86581L6.86586 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.8658 13.0001L16.8658 3H8.83637L12.5898 8.45918L15.7684 13.0001H21.8658Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M10.876 13.0001L11.9056 10.9694L13.3271 13.0001H10.876Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    drive: {
        defaultColors: ["#3D4C66"],
        keywords: ["storage","drive","cloud","files","data","backup","archive","server"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 14H9M9 14L6 20M9 14L11.5204 9.02916M11.5204 9.02916L8 4M11.5204 9.02916L15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 4L3 15L6 20H12H18L21 14L16 4H8Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "drum-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["drum","music","entertainment","party","event","rhythm","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="10" rx="7" ry="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 10V15.0526C5 16.6804 8.13401 18 12 18C15.866 18 19 16.6804 19 15.0526V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 17V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 9L19 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "drum-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["drum","music","entertainment","sound","band","performance","live-music","percussion","rhythm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="12"
                    cy="10"
                    rx="7"
                    ry="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10V15.0526C5 16.6804 8.13401 18 12 18C15.866 18 19 16.6804 19 15.0526V10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 17V13" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 9L19 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17V13" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "drum-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["drum","music","entertainment","performance","event","show","live-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4472 6.8944C19.9412 6.64741 20.1414 6.04674 19.8944 5.55276C19.6474 5.05878 19.0468 4.85856 18.5528 5.10555L15.8474 6.45826C14.6992 6.1622 13.3821 5.99997 12 5.99997C9.97 5.99997 8.07 6.34997 6.66 6.95997C5.95 7.25997 5.32 7.64997 4.84 8.12997C4.36 8.60997 4 9.24997 4 9.99997V15.05C4 15.8 4.37 16.43 4.84 16.91C5.31 17.38 5.95 17.76 6.66 18.06C8.08 18.66 9.96 19 12 19C14.04 19 15.92 18.65 17.34 18.06C18.05 17.76 18.68 17.38 19.16 16.91C19.64 16.43 20 15.81 20 15.05V9.99997C20 9.24997 19.64 8.60997 19.16 8.12997C18.9184 7.88321 18.6318 7.66023 18.3139 7.46104L19.4472 6.8944ZM18.3139 7.46104L13.4472 9.8944C12.9532 10.1414 12.3526 9.94117 12.1056 9.44719C11.8586 8.95321 12.0588 8.35254 12.5528 8.10555L15.8474 6.45826C16.3856 6.59706 16.8868 6.76527 17.34 6.95997C17.685 7.10575 18.0135 7.27277 18.3139 7.46104ZM6.26 15.5C6.49 15.73 6.88 15.98 7.44 16.22V16.21C7.61 16.28 7.8 16.35 8 16.42V13.49C7.52 13.36 7.07 13.22 6.66 13.04C6.43 12.95 6.21 12.84 6 12.72V15.06C6 15.12 6.03 15.27 6.26 15.5ZM10 16.87C10.62 16.95 11.3 17 12 17C12.7 17 13.38 16.95 14 16.87V13.87C13.35 13.95 12.69 14 12 14C11.31 14 10.65 13.95 10 13.87V16.87ZM16.56 16.21C17.12 15.98 17.51 15.72 17.74 15.49V15.5C17.97 15.27 18 15.12 18 15.06V12.72C17.79 12.83 17.57 12.94 17.34 13.04C16.94 13.21 16.48 13.36 16 13.49V16.42C16.2 16.35 16.38 16.28 16.56 16.21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    drum: {
        defaultColors: ["#3D4C66"],
        keywords: ["drum","music","entertainment","performance","event","show","live-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="10" rx="7" ry="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 10V15.0526C5 16.6804 8.13401 18 12 18C15.866 18 19 16.6804 19 15.0526V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 17V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 9L19 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "dumble-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dumbbell","fitness","gym","health","workout","exercise","weight","sports","equipment","training"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L16 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 9L7 9C6.05719 9 5.58579 9 5.29289 9.29289C5 9.58579 5 10.0572 5 11L5 13C5 13.9428 5 14.4142 5.29289 14.7071C5.58579 15 6.05719 15 7 15L8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 8V16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L5 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L20 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 15L17 15C17.9428 15 18.4142 15 18.7071 14.7071C19 14.4142 19 13.9428 19 13L19 11C19 10.0572 19 9.58579 18.7071 9.29289C18.4142 9 17.9428 9 17 9L16 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 16L16 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "dumble-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["dumbbell","fitness","gym","exercise","sports","health","equipment","weight","workout","strength"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L20 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 9L8 9L8 15H7C6.05719 15 5.58579 15 5.29289 14.7071C5 14.4142 5 13.9428 5 13V11C5 10.0572 5 9.58579 5.29289 9.29289C5.58579 9 6.05719 9 7 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M8 9H8.75H8ZM7 9V9.75V9ZM5.29289 14.7071L4.76256 15.2374L4.76256 15.2374L5.29289 14.7071ZM5.29289 9.29289L5.82322 9.82322L5.82322 9.82322L5.29289 9.29289ZM8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8H8.75ZM7.25 16C7.25 16.4142 7.58579 16.75 8 16.75C8.41421 16.75 8.75 16.4142 8.75 16H7.25ZM8 8.25L7 8.25V9.75L8 9.75V8.25ZM4.25 11V13H5.75V11H4.25ZM7 15.75H8V14.25H7V15.75ZM4.25 13C4.25 13.4502 4.24841 13.8633 4.2933 14.1972C4.34109 14.5527 4.45354 14.9284 4.76256 15.2374L5.82322 14.1768C5.82277 14.1763 5.82279 14.1763 5.82307 14.1766C5.82335 14.177 5.82351 14.1772 5.82347 14.1772C5.82341 14.1771 5.82286 14.1762 5.82186 14.1743C5.82085 14.1724 5.81923 14.1691 5.81716 14.164C5.8082 14.1423 5.79291 14.0939 5.77992 13.9973C5.75159 13.7866 5.75 13.4926 5.75 13H4.25ZM7 14.25C6.50739 14.25 6.21339 14.2484 6.00266 14.2201C5.90611 14.2071 5.85774 14.1918 5.83596 14.1828C5.83092 14.1808 5.8276 14.1791 5.82567 14.1781C5.82376 14.1771 5.82292 14.1766 5.82283 14.1765C5.82276 14.1765 5.823 14.1766 5.82335 14.1769C5.8237 14.1772 5.82368 14.1772 5.82322 14.1768L4.76256 15.2374C5.07159 15.5465 5.44731 15.6589 5.80279 15.7067C6.1367 15.7516 6.5498 15.75 7 15.75V14.25ZM7 8.25C6.5498 8.25 6.1367 8.24841 5.80279 8.2933C5.44731 8.34109 5.07159 8.45354 4.76256 8.76256L5.82322 9.82322C5.82368 9.82277 5.8237 9.82279 5.82335 9.82307C5.823 9.82335 5.82277 9.82351 5.82283 9.82347C5.82292 9.82341 5.82376 9.82286 5.82567 9.82186C5.8276 9.82085 5.83092 9.81923 5.83596 9.81716C5.85774 9.8082 5.90611 9.79291 6.00266 9.77992C6.21339 9.75159 6.50739 9.75 7 9.75V8.25ZM5.75 11C5.75 10.5074 5.75159 10.2134 5.77992 10.0027C5.79291 9.90611 5.8082 9.85774 5.81716 9.83596C5.81923 9.83092 5.82085 9.8276 5.82186 9.82567C5.82286 9.82376 5.82341 9.82292 5.82347 9.82283C5.82351 9.82277 5.82335 9.823 5.82307 9.82335C5.82279 9.8237 5.82277 9.82368 5.82322 9.82322L4.76256 8.76256C4.45354 9.07159 4.34109 9.44731 4.2933 9.80279C4.24841 10.1367 4.25 10.5498 4.25 11H5.75ZM7.25 8V9H8.75V8H7.25ZM7.25 9L7.25 15H8.75L8.75 9H7.25ZM7.25 15L7.25 16H8.75L8.75 15H7.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M17 15H16V9L17 9C17.9428 9 18.4142 9 18.7071 9.29289C19 9.58579 19 10.0572 19 11L19 13C19 13.9428 19 14.4142 18.7071 14.7071C18.4142 15 17.9428 15 17 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M19 13H19.75H19ZM19 11H18.25H19ZM17 9V9.75V9ZM18.7071 9.29289L19.2374 8.76256L19.2374 8.76256L18.7071 9.29289ZM18.7071 14.7071L18.1768 14.1768L18.1768 14.1768L18.7071 14.7071ZM15.25 16C15.25 16.4142 15.5858 16.75 16 16.75C16.4142 16.75 16.75 16.4142 16.75 16H15.25ZM16.75 8C16.75 7.58579 16.4142 7.25 16 7.25C15.5858 7.25 15.25 7.58579 15.25 8H16.75ZM16 15.75H17V14.25H16V15.75ZM19.75 13L19.75 11H18.25L18.25 13H19.75ZM17 8.25L16 8.25L16 9.75L17 9.75V8.25ZM19.75 11C19.75 10.5498 19.7516 10.1367 19.7067 9.80279C19.6589 9.44731 19.5465 9.07159 19.2374 8.76256L18.1768 9.82322C18.1772 9.82368 18.1772 9.8237 18.1769 9.82335C18.1766 9.823 18.1765 9.82276 18.1765 9.82283C18.1766 9.82292 18.1771 9.82376 18.1781 9.82567C18.1792 9.8276 18.1808 9.83092 18.1828 9.83596C18.1918 9.85774 18.2071 9.90611 18.2201 10.0027C18.2484 10.2134 18.25 10.5074 18.25 11H19.75ZM17 9.75C17.4926 9.75 17.7866 9.75159 17.9973 9.77992C18.0939 9.79291 18.1423 9.8082 18.164 9.81716C18.1691 9.81923 18.1724 9.82085 18.1743 9.82186C18.1762 9.82286 18.1771 9.82341 18.1772 9.82347C18.1772 9.82351 18.177 9.82335 18.1767 9.82307C18.1763 9.82279 18.1763 9.82277 18.1768 9.82322L19.2374 8.76256C18.9284 8.45354 18.5527 8.34109 18.1972 8.2933C17.8633 8.24841 17.4502 8.25 17 8.25V9.75ZM17 15.75C17.4502 15.75 17.8633 15.7516 18.1972 15.7067C18.5527 15.6589 18.9284 15.5465 19.2374 15.2374L18.1768 14.1768C18.1763 14.1772 18.1763 14.1772 18.1767 14.1769C18.177 14.1766 18.1772 14.1765 18.1772 14.1765C18.1771 14.1766 18.1762 14.1771 18.1743 14.1781C18.1724 14.1791 18.1691 14.1808 18.164 14.1828C18.1423 14.1918 18.0939 14.2071 17.9973 14.2201C17.7866 14.2484 17.4926 14.25 17 14.25V15.75ZM18.25 13C18.25 13.4926 18.2484 13.7866 18.2201 13.9973C18.2071 14.0939 18.1918 14.1423 18.1828 14.164C18.1808 14.1691 18.1792 14.1724 18.1781 14.1743C18.1771 14.1762 18.1766 14.1771 18.1765 14.1772C18.1765 14.1772 18.1766 14.177 18.1769 14.1766C18.1772 14.1763 18.1772 14.1763 18.1768 14.1768L19.2374 15.2374C19.5465 14.9284 19.6589 14.5527 19.7067 14.1972C19.7516 13.8633 19.75 13.4502 19.75 13H18.25ZM16.75 16V15H15.25V16H16.75ZM16.75 15V9H15.25V15H16.75ZM16.75 9V8H15.25V9H16.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "dumble-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dumbbell","weight","fitness","gym","exercise","strength","workout","equipment","item","merchandise","product","sport","training"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7C8.55228 7 9 7.44772 9 8V11L15 11V8C15 7.44772 15.4477 7 16 7C16.5523 7 17 7.44772 17 8C17.0182 8 17.0363 8 17.0544 7.99999C17.4785 7.99991 17.8906 7.99983 18.2305 8.04553C18.6137 8.09705 19.051 8.22257 19.4142 8.58579C19.7774 8.949 19.903 9.38628 19.9545 9.76948C20.0002 10.1094 20.0001 10.5215 20 10.9456C20 10.9637 20 10.9819 20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13C20 13.0181 20 13.0363 20 13.0544C20.0001 13.4785 20.0002 13.8906 19.9545 14.2305C19.903 14.6137 19.7774 15.051 19.4142 15.4142C19.051 15.7774 18.6137 15.903 18.2305 15.9545C17.8906 16.0002 17.4785 16.0001 17.0544 16C17.0363 16 17.0182 16 17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V13H9L9 16C9 16.5523 8.55229 17 8 17C7.44772 17 7 16.5523 7 16C6.98184 16 6.96371 16 6.94559 16C6.52152 16.0001 6.10939 16.0002 5.76948 15.9545C5.38628 15.903 4.949 15.7774 4.58579 15.4142C4.22257 15.051 4.09705 14.6137 4.04553 14.2305C3.99983 13.8906 3.99991 13.4785 3.99999 13.0544C4 13.0363 4 13.0182 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4 10.9818 4 10.9637 3.99999 10.9456C3.99991 10.5215 3.99983 10.1094 4.04553 9.76948C4.09705 9.38628 4.22257 8.949 4.58579 8.58579C4.949 8.22257 5.38628 8.09705 5.76948 8.04553C6.10939 7.99983 6.52152 7.99991 6.94559 7.99999C6.96371 8 6.98184 8 7 8C7 7.44772 7.44772 7 8 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    dumble: {
        defaultColors: ["#000000"],
        keywords: ["dumbbell","weight","fitness","gym","exercise","strength","workout","equipment","item","merchandise","product","sport","training"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L7 9C6.05719 9 5.58579 9 5.29289 9.29289C5 9.58579 5 10.0572 5 11L5 13C5 13.9428 5 14.4142 5.29289 14.7071C5.58579 15 6.05719 15 7 15L8 15"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M8 8V16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12L16 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L5 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L20 12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 15L17 15C17.9428 15 18.4142 15 18.7071 14.7071C19 14.4142 19 13.9428 19 13L19 11C19 10.0572 19 9.58579 18.7071 9.29289C18.4142 9 17.9428 9 17 9L16 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M16 16L16 8" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Duplicate-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["duplicate","copy","clone","replicate","identical","two","squares","double","repeat","reproduce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16C11.1716 16 9.75736 16 8.87868 15.1213C8 14.2426 8 12.8284 8 10C8 7.17157 8 5.75736 8.87868 4.87868C9.75736 4 11.1716 4 14 4C16.8284 4 18.2426 4 19.1213 4.87868Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Duplicate-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["duplicate","copy","clone","item","order","repeat","same","replication","backup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8V8C8 7.07003 8 6.60504 8.10222 6.22354C8.37962 5.18827 9.18827 4.37962 10.2235 4.10222C10.605 4 11.07 4 12 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V12C20 12.93 20 13.395 19.8978 13.7765C19.6204 14.8117 18.8117 15.6204 17.7765 15.8978C17.395 16 16.93 16 16 16V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Duplicate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["duplicate","copy","clone","item","product","variant","modifier","menu","duplicate-item","copy-item","clone-item","settings","preset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.0706 3H13.9294C12.5753 2.99997 11.4587 2.99994 10.5749 3.11876C9.64711 3.2435 8.82769 3.51547 8.17158 4.17158C7.64144 4.70171 7.36209 5.33848 7.20857 6.0529C7.99882 5.99983 8.90086 5.99992 9.8768 6.00001H10.1232C11.4315 5.99988 12.6069 5.99977 13.5583 6.12769C14.597 6.26734 15.6627 6.5916 16.5356 7.46448C17.4084 8.33736 17.7327 9.40299 17.8723 10.4417C18.0003 11.3931 18.0002 12.5685 18 13.8768V14.1232C18.0001 15.0992 18.0002 16.0012 17.9471 16.7914C18.6615 16.6379 19.2983 16.3586 19.8284 15.8284C20.4845 15.1723 20.7565 14.3529 20.8813 13.4251C21.0001 12.5413 21 11.4247 21 10.0706V9.92943C21 8.57531 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 7H10.0706C11.4247 6.99996 12.5413 6.99994 13.4251 7.11875C14.3529 7.2435 15.1723 7.51547 15.8284 8.17157C16.4845 8.82768 16.7565 9.64711 16.8813 10.5749C17.0001 11.4587 17 12.5753 17 13.9294V14.0706C17 15.4247 17.0001 16.5413 16.8813 17.4251C16.7565 18.3529 16.4845 19.1723 15.8284 19.8284C15.1723 20.4845 14.3529 20.7565 13.4251 20.8812C12.5413 21.0001 11.4247 21 10.0706 21H9.92943C8.57531 21 7.4587 21.0001 6.57494 20.8812C5.64711 20.7565 4.82768 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11875 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V13.9294C2.99997 12.5753 2.99994 11.4587 3.11875 10.5749C3.2435 9.64711 3.51547 8.82768 4.17158 8.17157C4.82768 7.51547 5.64711 7.2435 6.57494 7.11875C7.4587 6.99994 8.57531 6.99996 9.92943 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Duplicate: {
        defaultColors: ["#3D4C66"],
        keywords: ["duplicate","copy","clone","item","product","variant","modifier","menu","duplicate-item","copy-item","clone-item","settings","preset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8V8C8 7.07003 8 6.60504 8.10222 6.22354C8.37962 5.18827 9.18827 4.37962 10.2235 4.10222C10.605 4 11.07 4 12 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V12C20 12.93 20 13.395 19.8978 13.7765C19.6204 14.8117 18.8117 15.6204 17.7765 15.8978C17.395 16 16.93 16 16 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.1213 8.87868C16 9.75736 16 11.1716 16 14C16 16.8284 16 18.2426 15.1213 19.1213C14.2426 20 12.8284 20 10 20C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8C12.8284 8 14.2426 8 15.1213 8.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "dvr-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["monitor","screen","display","list","order-list","transaction-history","reports","dashboard","summary","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 9L11 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L11 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L8 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "dvr-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["display","monitor","screen","list","menu","settings","options","configurations","dvr"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4H9.92943C8.57536 3.99997 7.45868 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45868 2.99997 9.57526 3 10.9293V11.0706C2.99997 12.4247 2.99994 13.5413 3.11876 14.4251C3.2435 15.3529 3.51547 16.1723 4.17158 16.8284C4.82769 17.4845 5.64711 17.7565 6.57494 17.8813C7.4587 18.0001 8.57531 18 9.92943 18L11 18V19H10C9.44772 19 9 19.4477 9 20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20C15 19.4477 14.5523 19 14 19H13V18L14.0706 18C15.4247 18 16.5413 18.0001 17.4251 17.8813C18.3529 17.7565 19.1723 17.4845 19.8284 16.8284C20.4845 16.1723 20.7565 15.3529 20.8813 14.4251C21.0001 13.5413 21 12.4247 21 11.0706V10.9295C21 9.57536 21.0001 8.45869 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4246 3.99997 14.0706 4ZM10 9C10 9.55229 9.55229 10 9 10H8C7.44772 10 7 9.55229 7 9C7 8.44772 7.44772 8 8 8H9C9.55229 8 10 8.44772 10 9ZM16 10C16.5523 10 17 9.55229 17 9C17 8.44772 16.5523 8 16 8L12 8C11.4477 8 11 8.44772 11 9C11 9.55229 11.4477 10 12 10H16ZM16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12H12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14H16ZM9 14C9.55229 14 10 13.5523 10 13C10 12.4477 9.55229 12 9 12H8C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "dvr-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["monitor","screen","display","menu","options","settings","list","configuration","dashboard","information","details","dvr"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 9L11 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    dvr: {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","screen","display","menu","options","settings","list","configuration","dashboard","information","details","dvr"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 9L11 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L8 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "E-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["E","error","edit","remove","erase","email","exit","end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "E-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["letter-e","edit","extend","expand","enterprise","employee","email"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "E-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["E","number","alphanumeric","quantity","price","ID"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 4.00001C9.96372 4.00001 9.98186 4.00001 10 4.00001H16C16.5523 4.00001 17 4.44773 17 5.00001C17 5.5523 16.5523 6.00001 16 6.00001H10C9.50034 6.00001 9.22618 6.00214 9.03599 6.02771C9.03351 6.02804 9.03108 6.02837 9.02871 6.02871C9.02838 6.03108 9.02804 6.03351 9.02771 6.03599C9.00214 6.22618 9.00001 6.50034 9.00001 7.00001V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H9.00001V17C9.00001 17.4997 9.00214 17.7738 9.02771 17.964C9.02804 17.9665 9.02837 17.9689 9.02871 17.9713C9.03108 17.9717 9.03351 17.972 9.03599 17.9723C9.22618 17.9979 9.50034 18 10 18H16C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20H10C9.98186 20 9.96372 20 9.9456 20C9.52153 20.0001 9.10941 20.0002 8.76949 19.9545C8.38629 19.903 7.94902 19.7774 7.5858 19.4142C7.22259 19.051 7.09706 18.6137 7.04554 18.2305C6.99984 17.8906 6.99992 17.4785 7.00001 17.0544C7.00001 17.0363 7.00001 17.0182 7.00001 17V7.00001C7.00001 6.98186 7.00001 6.96372 7.00001 6.94561C6.99992 6.52154 6.99984 6.10941 7.04554 5.76949C7.09706 5.38629 7.22259 4.94902 7.5858 4.5858C7.94902 4.22259 8.38629 4.09706 8.76949 4.04554C9.10941 3.99984 9.52154 3.99992 9.94561 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    E: {
        defaultColors: ["#3D4C66"],
        keywords: ["E","number","alphanumeric","quantity","price","ID"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V17C8 17.9428 8 18.4142 8.29289 18.7071C8.58579 19 9.05719 19 10 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ear-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ear","listening","hearing","audio","sound","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9.90909C6 6.64559 8.68629 4 12 4C15.3137 4 18 6.64559 18 9.90909C18 11.2394 17.5537 12.4669 16.8004 13.4545C15.6 15.2273 13.6 14.6364 13 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10V16.5C6 18.433 7.567 20 9.5 20H10C11.6569 20 13 18.6569 13 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ear-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["listen","hearing","audio","sound","customer-service","communication","accessibility","hear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 10C5 6.18966 8.12858 3 12 3C15.8515 3 19 6.07897 19 9.90909C19 11.4574 18.4828 12.8881 17.6121 14.0392C16.9349 15.0248 16.0225 15.4642 15.3919 15.7679C15.2974 15.8134 15.209 15.8559 15.1289 15.8967C14.7962 16.0662 14.5739 16.2079 14.4017 16.3884C14.255 16.5422 14.1076 16.7641 13.9975 17.1421C13.9227 19.2854 12.1616 21 10 21H9.5C7.01472 21 5 18.9853 5 16.5L5 10ZM10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ear-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ear","listen","hearing","sound","feedback","support","assistance","notification","alert","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C15.3137 4 18 6.64559 18 9.90909C18 11.2394 17.5537 12.4669 16.8004 13.4545C15.6 15.2273 13.6 14.6364 13 17C13 18.6569 11.6569 20 10 20H9.5C7.567 20 6 18.433 6 16.5L6 10C6 6.7365 8.68629 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Ear: {
        defaultColors: ["#3D4C66"],
        keywords: ["ear","listen","hearing","sound","feedback","support","assistance","notification","alert","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9.90909C6 6.64559 8.68629 4 12 4C15.3137 4 18 6.64559 18 9.90909C18 11.2394 17.5537 12.4669 16.8004 13.4545C15.6 15.2273 13.6 14.6364 13 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10V16.5C6 18.433 7.567 20 9.5 20H10C11.6569 20 13 18.6569 13 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "edit-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["edit","pencil","modify","change","update","revise","alter","correct","adjust","write","description","remark","comment","note","record","review","amend","rewrite","fine-tune","debug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.55175 12L13.379 15.8272C13.4836 15.9302 13.6258 15.9865 13.7749 15.9842L15.4229 16C15.7366 15.995 15.995 15.7366 16 15.4229L15.9842 13.7749C15.9865 13.6258 15.9302 13.4836 15.8272 13.379L12 9.55175M9.55175 12L8.48248 10.9307C8.1733 10.6167 8 10.1937 8 9.75307C8 8.82605 8.82605 8 9.75307 8C10.1937 8 10.6167 8.1733 10.9307 8.48248L12 9.55175M9.55175 12L12 9.55175"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "edit-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","revise","alter","correct","adjust","edit-order","modify-order","edit-item","modify-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H11.8004C13.0267 4 13.6398 4 14.1911 4.22836C14.7424 4.45672 15.176 4.89027 16.0431 5.75736L18.2426 7.95693C19.1097 8.82402 19.5433 9.25756 19.7716 9.80888C20 10.3602 20 10.9733 20 12.1996V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.4144 4.34292C16.0811 3.67626 16.4144 3.34292 16.8286 3.34292C17.2428 3.34292 17.5762 3.67626 18.2428 4.34292L19.657 5.75714C20.3237 6.4238 20.657 6.75714 20.657 7.17135C20.657 7.58556 20.3237 7.9189 19.657 8.58556L16.1215 12.1211L14.3978 13.8448C14.0243 14.2183 13.8376 14.405 13.6118 14.536C13.3861 14.667 13.1313 14.7365 12.6218 14.8755L10.7223 15.3935C10.1257 15.5562 9.4877 15.3868 9.05044 14.9495C8.61318 14.5123 8.44374 13.8742 8.60645 13.2777L9.12449 11.3782C9.26345 10.8687 9.33293 10.6139 9.46395 10.3881C9.59497 10.1624 9.78169 9.97563 10.1551 9.6022L11.8789 7.87846L15.4144 4.34292Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M13 5L19 11" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" />
            </svg>
        )
    },
    "edit-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","adjust","write","rewrite","correct","POS-edit","edit-item","edit-quantity","edit-price","discount-edit","note-edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.8272 3L11 3C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H10.8789C9.51213 5 8.55925 5.00111 7.82312 5.07304C7.10258 5.14344 6.69667 5.27409 6.39306 5.46667C6.01979 5.70345 5.70345 6.01979 5.46667 6.39306C5.27409 6.69667 5.14344 7.10258 5.07304 7.82312C5.00112 8.55925 5 9.51212 5 10.8789V12C5 13.9139 5.00213 15.2487 5.13753 16.2558C5.26907 17.2342 5.50966 17.7523 5.87868 18.1213C6.2477 18.4903 6.76579 18.7309 7.74416 18.8625C8.7513 18.9979 10.0861 19 12 19H13C14.4253 19 15.419 18.9988 16.1849 18.9209C16.9342 18.8446 17.354 18.7034 17.6667 18.4944C17.9943 18.2755 18.2755 17.9943 18.4944 17.6667C18.7034 17.354 18.8446 16.9342 18.9209 16.1849C18.9988 15.419 19 14.4253 19 13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V13.054C21 14.4126 21 15.5083 20.9106 16.3874C20.8183 17.2948 20.6225 18.0817 20.1574 18.7779C19.7926 19.3238 19.3238 19.7926 18.7779 20.1573C18.0817 20.6225 17.2948 20.8183 16.3874 20.9106C15.5083 21 14.4126 21 13.054 21H11.9269C10.1034 21 8.63363 21 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732L3 10.8272C2.99999 9.52425 2.99998 8.47345 3.08252 7.62863C3.16767 6.75709 3.34814 5.99911 3.77779 5.32177C4.17241 4.69964 4.69965 4.17241 5.32177 3.77779C5.99911 3.34814 6.7571 3.16767 7.62864 3.08252C8.47345 2.99997 9.52425 2.99999 10.8272 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.5728 3.96643L20.0336 5.42719C20.347 5.7406 20.6171 6.01063 20.8043 6.25596C21.0049 6.51888 21.1568 6.8113 21.1568 7.17169C21.1568 7.53207 21.0049 7.8245 20.8043 8.08742C20.6171 8.33275 20.347 8.60278 20.0336 8.91618L19.182 9.7678L14.2322 4.81805L15.0839 3.96643C15.3973 3.65299 15.6673 3.38293 15.9126 3.19575C16.1755 2.99515 16.468 2.84326 16.8283 2.84326C17.1887 2.84326 17.4812 2.99515 17.7441 3.19575C17.9894 3.38293 18.2594 3.653 18.5728 3.96643Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.818 6.23226L9.75833 9.29194C9.42609 9.62397 9.19552 9.85439 9.03123 10.1375C8.86693 10.4206 8.78126 10.7351 8.65782 11.1883L8.1238 13.1464C7.91388 13.9161 8.13249 14.7393 8.69662 15.3034C9.26075 15.8675 10.0839 16.0862 10.8536 15.8762L12.8117 15.3422C13.2649 15.2188 13.5794 15.1331 13.8625 14.9688C14.1456 14.8045 14.3761 14.5739 14.7081 14.2417L17.7678 11.182L12.818 6.23226Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "edit-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","alter","revise","correct","adjust","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.4229 16L13.7749 15.9842C13.6258 15.9865 13.4836 15.9302 13.379 15.8272L9.55175 12L8.48248 10.9307C8.1733 10.6167 8 10.1937 8 9.75307C8 8.82605 8.82605 8 9.75307 8C10.1937 8 10.6167 8.1733 10.9307 8.48248L12 9.55175L15.8272 13.379C15.9302 13.4836 15.9865 13.6258 15.9842 13.7749L16 15.4229C15.995 15.7366 15.7366 15.995 15.4229 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M9.55175 12L13.379 15.8272C13.4836 15.9302 13.6258 15.9865 13.7749 15.9842L15.4229 16C15.7366 15.995 15.995 15.7366 16 15.4229L15.9842 13.7749C15.9865 13.6258 15.9302 13.4836 15.8272 13.379L12 9.55175M9.55175 12L8.48248 10.9307C8.1733 10.6167 8 10.1937 8 9.75307C8 8.82605 8.82605 8 9.75307 8C10.1937 8 10.6167 8.1733 10.9307 8.48248L12 9.55175M9.55175 12L12 9.55175"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.55176 12L12 9.55176"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "edit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","modify","update","change","adjust","item-edit","order-edit","price-edit","quantity-edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6847 4.00009C12.7445 3.99925 13.5493 3.99862 14.2881 4.30466C15.0269 4.61069 15.5955 5.1802 16.3444 5.93021L18.07 7.65581C18.82 8.40464 19.3895 8.97325 19.6955 9.71208C20.0016 10.4509 20.0009 11.2557 20.0001 12.3155L20 13.0708C20 14.4249 20.0001 15.5415 19.8813 16.4252C19.7565 17.3531 19.4845 18.1725 18.8284 18.8286C18.1723 19.4847 17.3529 19.7567 16.4251 19.8814C15.5413 20.0002 14.4247 20.0002 13.0706 20.0002H10.9294C9.57531 20.0002 8.4587 20.0002 7.57494 19.8814C6.64711 19.7567 5.82769 19.4847 5.17158 18.8286C4.51547 18.1725 4.2435 17.3531 4.11876 16.4252C3.99994 15.5415 3.99997 14.4249 4 13.0708V10.9296C3.99997 9.57548 3.99994 8.45885 4.11876 7.57511C4.2435 6.64728 4.51547 5.82785 5.17158 5.17175C5.82769 4.51564 6.64711 4.24367 7.57494 4.11893C8.4587 4.00011 9.57531 4.00014 10.9294 4.00017L11.6847 4.00009ZM8 10.2027C8 9.01926 9.01902 8.00024 10.2025 8.00024C10.765 8.00024 11.305 8.22148 11.7059 8.61618L11.7103 8.62052L15.632 12.5423C15.8644 12.7784 15.9892 13.0949 15.9874 13.4201L16 14.7309L16 14.7381L15.9999 14.7513C15.989 15.4342 15.4339 15.9893 14.7511 16.0001L14.7429 16.0002L14.7307 16.0002L13.4199 15.9876C13.0947 15.9895 12.7782 15.8646 12.542 15.6322L12.5375 15.6277L8.61592 11.7061C8.22122 11.3053 8 10.7653 8 10.2027Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "edit-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","modify","update","change","description","note","write","order-edit","item-edit","price-edit","quantity-edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11L5 13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.8663 10.5L11.6039 15.7625C11.4601 15.904 11.2645 15.9815 11.0595 15.9782L8.79346 16C8.36211 15.9931 8.00687 15.6379 8 15.2065L8.02177 12.9405C8.0185 12.7355 8.09601 12.5399 8.23755 12.3961L13.5 7.13365M16.8663 10.5L18.3366 9.02975C18.7617 8.598 19 8.01639 19 7.41047C19 6.13583 17.8642 5 16.5895 5C15.9836 5 15.402 5.23828 14.9702 5.6634L13.5 7.13365M16.8663 10.5L13.5 7.13365"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "edit-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","square","modify","change","update","write","notes","description","alter","revamp"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11L5 13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.8663 10.5L11.6039 15.7625C11.4601 15.904 11.2645 15.9815 11.0595 15.9782L8.79346 16C8.36211 15.9931 8.00687 15.6379 8 15.2065L8.02177 12.9405C8.0185 12.7355 8.09601 12.5399 8.23755 12.3961L13.5 7.13365M16.8663 10.5L18.3366 9.02975C18.7617 8.598 19 8.01639 19 7.41047C19 6.13583 17.8642 5 16.5895 5C15.9836 5 15.402 5.23828 14.9702 5.6634L13.5 7.13365M16.8663 10.5L13.5 7.13365"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "edit-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","pencil","square","modify","update","change","alter","adjust","revise","correction","edit-order","edit-item","modify-item","edit-transaction","amend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11L5 13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.79346 16L11.0595 15.9782C11.2645 15.9815 11.4601 15.904 11.6039 15.7625L16.8663 10.5L18.3366 9.02975C18.7617 8.598 19 8.01639 19 7.41047C19 6.13583 17.8642 5 16.5895 5C15.9836 5 15.402 5.23828 14.9702 5.6634L13.5 7.13365L8.23755 12.3961C8.09601 12.5399 8.0185 12.7355 8.02177 12.9405L8 15.2065C8.00687 15.6379 8.36211 15.9931 8.79346 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16.8663 10.5L11.6039 15.7625C11.4601 15.904 11.2645 15.9815 11.0595 15.9782L8.79346 16C8.36211 15.9931 8.00687 15.6379 8 15.2065L8.02177 12.9405C8.0185 12.7355 8.09601 12.5399 8.23755 12.3961L13.5 7.13365M16.8663 10.5L18.3366 9.02975C18.7617 8.598 19 8.01639 19 7.41047C19 6.13583 17.8642 5 16.5895 5C15.9836 5 15.402 5.23828 14.9702 5.6634L13.5 7.13365M16.8663 10.5L13.5 7.13365"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3366 9.02975C18.7617 8.598 19 8.01639 19 7.41047C19 6.13583 17.8642 5 16.5895 5C15.9836 5 15.402 5.23828 14.9702 5.6634L13.5 7.13365L16.8663 10.5L18.3366 9.02975Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "edit-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","square","modify","update","change","revise","correct","adjustment","alter","rewrite","fix","edit-order","edit-item","edit-price","edit-quantity","edit-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.92943 4L11 4C11.5523 4 12 4.44772 12 5C12 5.55229 11.5523 6 11 6H10C8.55752 6 8.57626 6.00213 7.84144 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84143C6.00213 8.57625 6 9.55752 6 11V13C6 14.4425 6.00213 15.4238 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84144 17.8991C8.57626 17.9979 9.55752 18 11 18H13C14.4425 18 15.4238 17.9979 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9979 15.4238 18 15.4425 18 14V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13L20 14.0706C20 15.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0707 20H10.9294C9.57534 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 10.9294C3.99997 9.57533 3.99994 8.45869 4.11876 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11875C8.45869 3.99994 8.57533 3.99997 9.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.5 7.41047C19.5 5.85968 18.1403 4.5 16.5895 4.5C15.8523 4.5 15.1447 4.7899 14.6194 5.30713L14.6167 5.30984L13.9204 6.00614L17.9938 10.0796L18.6929 9.38057C19.2101 8.85528 19.5 8.14765 19.5 7.41047Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5796 11.4938L12.5061 7.42036L7.88115 12.0454C7.6456 12.2847 7.51827 12.6073 7.52172 12.9413L7.49988 15.2145C7.51104 15.9158 8.08422 16.4888 8.78548 16.4999L8.79824 16.5001L11.0587 16.4783C11.3927 16.4817 11.7153 16.3544 11.9546 16.1188L11.9574 16.116L16.5796 11.4938Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "edit-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","write","revise","adjust","alter","correct","review","amend","rewrite","draft","note","remark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4H11V4C8.19108 4 6.78661 4 5.77772 4.67412C5.34096 4.96596 4.96596 5.34096 4.67412 5.77772C4 6.78661 4 8.19108 4 11V12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20H13C15.8089 20 17.2134 20 18.2223 19.3259C18.659 19.034 19.034 18.659 19.3259 18.2223C20 17.2134 20 15.8089 20 13V13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4144 4.34292C16.0811 3.67626 16.4144 3.34292 16.8286 3.34292C17.2428 3.34292 17.5762 3.67626 18.2428 4.34292L19.657 5.75714C20.3237 6.4238 20.657 6.75714 20.657 7.17135C20.657 7.58556 20.3237 7.9189 19.657 8.58556L16.1215 12.1211L14.3978 13.8448C14.0243 14.2183 13.8376 14.405 13.6118 14.536C13.3861 14.667 13.1313 14.7365 12.6218 14.8755L10.7223 15.3935C10.1257 15.5562 9.4877 15.3868 9.05044 14.9495V14.9495C8.61318 14.5123 8.44374 13.8742 8.60645 13.2777L9.12449 11.3782C9.26345 10.8687 9.33293 10.6139 9.46395 10.3881C9.59497 10.1624 9.78169 9.97563 10.1551 9.6022L11.8789 7.87846L15.4144 4.34292Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 5.75732L18.2426 9.99996" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "edit-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","pencil","modify","update","change","adjust","alter","correct","revise","amend","edit-order","update-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 5.75732L18.2426 9.99996" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 4H11V4C8.19108 4 6.78661 4 5.77772 4.67412C5.34096 4.96596 4.96596 5.34096 4.67412 5.77772C4 6.78661 4 8.19108 4 11V12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20H13C15.8089 20 17.2134 20 18.2223 19.3259C18.659 19.034 19.034 18.659 19.3259 18.2223C20 17.2134 20 15.8089 20 13V13V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4144 4.34292C16.0811 3.67626 16.4144 3.34292 16.8286 3.34292C17.2428 3.34292 17.5762 3.67626 18.2428 4.34292L19.657 5.75714C20.3237 6.4238 20.657 6.75714 20.657 7.17135C20.657 7.58556 20.3237 7.9189 19.657 8.58556L16.1215 12.1211L14.3978 13.8448C14.0243 14.2183 13.8376 14.405 13.6118 14.536C13.3861 14.667 13.1313 14.7365 12.6218 14.8755L10.7223 15.3935C10.1257 15.5562 9.4877 15.3868 9.05044 14.9495V14.9495C8.61318 14.5123 8.44374 13.8742 8.60645 13.2777L9.12449 11.3782C9.26345 10.8687 9.33293 10.6139 9.46395 10.3881C9.59497 10.1624 9.78169 9.97563 10.1551 9.6022L11.8789 7.87846L15.4144 4.34292Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "emoji-emoji-oh-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["surprised","error","exception","warning","alert","notification","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 17C14.3284 17 15 16.1046 15 15C15 13.8954 14.3284 13 13.5 13C12.6716 13 12 13.8954 12 15C12 16.1046 12.6716 17 13.5 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    edit: {
        defaultColors: ["#3D4C66"],
        keywords: ["surprised","error","exception","warning","alert","notification","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.55175 12L13.379 15.8272C13.4836 15.9302 13.6258 15.9865 13.7749 15.9842L15.4229 16C15.7366 15.995 15.995 15.7366 16 15.4229L15.9842 13.7749C15.9865 13.6258 15.9302 13.4836 15.8272 13.379L12 9.55175M9.55175 12L8.48248 10.9307C8.1733 10.6167 8 10.1937 8 9.75307C8 8.82605 8.82605 8 9.75307 8C10.1937 8 10.6167 8.1733 10.9307 8.48248L12 9.55175M9.55175 12L12 9.55175"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "emoji-emoji-oh-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["surprised","alert","warning","attention","notification","issue","error","exception","face","emoji","oh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 17C14.3284 17 15 16.1046 15 15C15 13.8954 14.3284 13 13.5 13C12.6716 13 12 13.8954 12 15C12 16.1046 12.6716 17 13.5 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-Face-confused-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["confused","face","emoji","error","issue","problem","decline","reject","cancel","invalid","negative","sad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9.25889 15.5187C9.76258 14.7551 10.7129 14.0938 11.8978 13.7764C13.0827 13.4589 14.2364 13.5564 15.0544 13.9658"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-emoji-oh-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["surprise","alert","notification","error","warning","attention","message","oops","unexpected","issue","problem","feedback","customer-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2393 14.1858C13.1097 14.3586 13 14.6432 13 15C13 15.3568 13.1097 15.6414 13.2393 15.8142C13.3687 15.9867 13.4711 16 13.5 16C13.5289 16 13.6313 15.9867 13.7607 15.8142C13.8903 15.6414 14 15.3568 14 15C14 14.6432 13.8903 14.3586 13.7607 14.1858C13.6313 14.0133 13.5289 14 13.5 14C13.4711 14 13.3687 14.0133 13.2393 14.1858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 8C9.55228 8 10 8.44772 10 9V10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10V9C8 8.44772 8.44772 8 9 8ZM11.6393 12.9858C12.0529 12.4344 12.7005 12 13.5 12C14.2995 12 14.9471 12.4344 15.3607 12.9858C15.7739 13.5368 16 14.2523 16 15C16 15.7477 15.7739 16.4632 15.3607 17.0142C14.9471 17.5656 14.2995 18 13.5 18C12.7005 18 12.0529 17.5656 11.6393 17.0142C11.2261 16.4632 11 15.7477 11 15C11 14.2523 11.2261 13.5368 11.6393 12.9858ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-Face-confused-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["confused","face","emoji","error","issue","problem","warning","alert","customer-issue","transaction-error","system-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 8C9.55228 8 10 8.44772 10 9V10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10V9C8 8.44772 8.44772 8 9 8ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8ZM14.5132 14.86C15.0071 15.1073 15.6078 14.9073 15.855 14.4134C16.1022 13.9196 15.9023 13.3188 15.4084 13.0716C14.3294 12.5315 12.9167 12.443 11.5454 12.8104C10.1741 13.1779 8.99487 13.9609 8.33049 14.9681C8.02639 15.4291 8.1536 16.0494 8.61462 16.3535C9.07565 16.6576 9.6959 16.5304 10 16.0694C10.343 15.5493 11.0645 15.0098 12.063 14.7423C13.0615 14.4747 13.9561 14.5812 14.5132 14.86Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-Face-confused-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["error","issue","problem","sad","unhappy","customer-issue","customer-problem","payment-error","transaction-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9.25889 15.5187C9.76258 14.7551 10.7129 14.0938 11.8978 13.7764C13.0827 13.4589 14.2364 13.5564 15.0544 13.9658"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-emoji-oh": {
        defaultColors: ["#3D4C66"],
        keywords: ["surprised","error","unexpected","issue","face","alert","notification","problem","warning","attention","feedback","exception"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 17C14.3284 17 15 16.1046 15 15C15 13.8954 14.3284 13 13.5 13C12.6716 13 12 13.8954 12 15C12 16.1046 12.6716 17 13.5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-Face-confused": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","problem","issue","cancel","failed","incorrect","invalid","unhappy","sad","face","customer-issue","payment-failed","transaction-failed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9.25889 15.5187C9.76258 14.7551 10.7129 14.0938 11.8978 13.7764C13.0827 13.4589 14.2364 13.5564 15.0544 13.9658"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-dizzy-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["error","failure","issue","problem","alert","cancelled","dead","disabled","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-dizzy-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","alert","failed","issue","problem","dizzy","dead","invalid","cancel","delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-dizzy": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","failure","cancelled","denied","rejected","issue","problem","unavailable","out-of-stock","sold-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-eyes-xmarks-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["error","failure","sad","cancel","cancelled","declined","rejected","unavailable","out-of-stock","disabled","deactivated","x","cross"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-dizzy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","unavailable","disabled","out-of-stock","issue","problem","blocked","denied","invalid","dead","failure","cancelled","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3259 15.3338C10.1926 15.4004 10.1104 15.4575 10.0604 15.5C10.1104 15.5425 10.1926 15.5996 10.3259 15.6662C10.7027 15.8546 11.2932 16 12 16C12.7068 16 13.2973 15.8546 13.6741 15.6662C13.8074 15.5996 13.8896 15.5425 13.9396 15.5C13.8896 15.4575 13.8074 15.4004 13.6741 15.3338C13.2973 15.1454 12.7068 15 12 15C11.2932 15 10.7027 15.1454 10.3259 15.3338Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711L7.58579 10L7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L9 11.4142L9.29289 11.7071C9.68342 12.0976 10.3166 12.0976 10.7071 11.7071C11.0976 11.3166 11.0976 10.6834 10.7071 10.2929L10.4142 10L10.7071 9.70711C11.0976 9.31658 11.0976 8.68342 10.7071 8.29289C10.3166 7.90237 9.68342 7.90237 9.29289 8.29289L9 8.58579L8.70711 8.29289ZM14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289C12.9024 8.68342 12.9024 9.31658 13.2929 9.70711L13.5858 10L13.2929 10.2929C12.9024 10.6834 12.9024 11.3166 13.2929 11.7071C13.6834 12.0976 14.3166 12.0976 14.7071 11.7071L15 11.4142L15.2929 11.7071C15.6834 12.0976 16.3166 12.0976 16.7071 11.7071C17.0976 11.3166 17.0976 10.6834 16.7071 10.2929L16.4142 10L16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289L15 8.58579L14.7071 8.29289ZM12 13C11.05 13 10.1405 13.1904 9.43147 13.5449C8.78227 13.8695 8 14.503 8 15.5C8 16.497 8.78227 17.1305 9.43147 17.4551C10.1405 17.8096 11.05 18 12 18C12.95 18 13.8595 17.8096 14.5685 17.4551C15.2177 17.1305 16 16.497 16 15.5C16 14.503 15.2177 13.8695 14.5685 13.5449C13.8595 13.1904 12.95 13 12 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "emoji-face-eyes-xmarks-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","cancel","dead","disabled","inactive","failure","problem","issue","unavailable","down","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711L7.58588 10.0001L7.29308 10.2929C6.90256 10.6834 6.90256 11.3166 7.29308 11.7071C7.6836 12.0976 8.31677 12.0976 8.70729 11.7071L9.00009 11.4143L9.29289 11.7071C9.68342 12.0976 10.3166 12.0976 10.7071 11.7071C11.0976 11.3166 11.0976 10.6834 10.7071 10.2929L10.4143 10.0001L10.7073 9.70711C11.0978 9.31658 11.0978 8.68342 10.7073 8.29289C10.3168 7.90237 9.6836 7.90237 9.29308 8.29289L9.00009 8.58588L8.70711 8.29289ZM14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289C12.9024 8.68342 12.9024 9.31658 13.2929 9.70711L13.5859 10.0001L13.2931 10.2929C12.9026 10.6834 12.9026 11.3166 13.2931 11.7071C13.6836 12.0976 14.3168 12.0976 14.7073 11.7071L15.0001 11.4143L15.2929 11.7071C15.6834 12.0976 16.3166 12.0976 16.7071 11.7071C17.0976 11.3166 17.0976 10.6834 16.7071 10.2929L16.4143 10.0001L16.7073 9.70711C17.0978 9.31658 17.0978 8.68342 16.7073 8.29289C16.3168 7.90237 15.6836 7.90237 15.2931 8.29289L15.0001 8.58588L14.7071 8.29289ZM14.3363 16.7479C14.7493 17.1145 15.3814 17.0769 15.748 16.6638C16.1146 16.2507 16.077 15.6187 15.6639 15.2521C14.7615 14.4511 13.4198 14 12.0001 14C10.5804 14 9.23873 14.4511 8.33629 15.2521C7.92323 15.6187 7.88558 16.2507 8.25218 16.6638C8.61879 17.0769 9.25084 17.1145 9.6639 16.7479C10.1298 16.3344 10.9664 16 12.0001 16C13.0338 16 13.8704 16.3344 14.3363 16.7479Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "emoji-face-eyes-xmarks": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","disabled","inactive","unavailable","out-of-stock","terminated","cancel","cancelled","failure","rejected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-Face-meh-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["meh","neutral","face","feedback","survey","rating","customer-satisfaction","emotion","expression","average","unsatisfied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "emoji-face-eyes-xmarks-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","problem","issue","failed","failure","canceled","invalid","inactive","disabled","out-of-stock","unavailable","refunded","declined","rejected","unsuccessful"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 11L8 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 11L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L16 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-Face-meh-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["face","meh","neutral","customer","satisfaction","feedback","rating","review","average","okay","indifferent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-Face-meh-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["meh","neutral","indifferent","feedback","customer-feedback","survey","rating","unhappy","dissatisfied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V9ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-Face-meh": {
        defaultColors: ["#3D4C66"],
        keywords: ["feedback","neutral","meh","rating","customer-satisfaction","customer-feedback","satisfaction","report","survey","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "emoji-face-smile-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["face","smile","happy","customer","add","plus","new-customer","add-customer","loyalty","rewards","happy-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 13C3 8.58172 6.58172 5 11 5C15.4183 5 19 8.58172 19 13C19 17.4183 15.4183 21 11 21C6.58172 21 3 17.4183 3 13ZM8 9C8.55229 9 9 9.44772 9 10V11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11V10C7 9.44772 7.44772 9 8 9ZM14 9C14.5523 9 15 9.44772 15 10V11C15 11.5523 14.5523 12 14 12C13.4477 12 13 11.5523 13 11V10C13 9.44772 13.4477 9 14 9ZM7.2521 14.3362C7.61871 13.9232 8.25075 13.8855 8.66381 14.2521C9.12972 14.6656 9.96628 15 11 15C12.0337 15 12.8703 14.6656 13.3362 14.2521C13.7493 13.8855 14.3813 13.9232 14.7479 14.3362C15.1145 14.7493 15.0769 15.3813 14.6638 15.7479C13.7614 16.5489 12.4197 17 11 17C9.58035 17 8.23864 16.5489 7.33621 15.7479C6.92315 15.3813 6.88549 14.7493 7.2521 14.3362Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 3C20 2.44772 19.5523 2 19 2C18.4477 2 18 2.44772 18 3V4L17 4C16.4477 4 16 4.44772 16 5C16 5.55228 16.4477 6 17 6L18 6V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7V6L21 6C21.5523 6 22 5.55228 22 5C22 4.44771 21.5523 4 21 4L20 4V3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "emoji-face-smile-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["customer","add-customer","new-customer","happy","plus","add","loyalty","reward","add-reward","smile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 20C14.866 20 18 16.866 18 13C18 9.13401 14.866 6 11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 15C13.3158 15.6072 12.2267 16 11 16C9.7733 16 8.68417 15.6072 8 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 5L17 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L19 3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "emoji-face-surprise-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["surprise","alert","warning","error","notification","issue","problem","customer-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-smile-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy-customer","customer","add-customer","plus","add","loyalty","reward","user","add-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 20C14.866 20 18 16.866 18 13C18 9.13401 14.866 6 11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 15C13.3158 15.6072 12.2267 16 11 16C9.7733 16 8.68417 15.6072 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 5L17 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L19 3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "emoji-face-surprise-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["surprise","alert","warning","notification","unexpected","issue","problem","error","customer-feedback","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-smile-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["customer","add-customer","new-customer","happy","plus","add","create-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 20C14.866 20 18 16.866 18 13C18 9.13401 14.866 6 11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 15C13.3158 15.6072 12.2267 16 11 16C9.7733 16 8.68417 15.6072 8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 5L17 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L19 3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "emoji-face-surprise-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["surprise","alert","warning","notification","error","issue","problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.4334 14.4178C10.0693 14.6606 10 14.8861 10 15C10 15.1139 10.0693 15.3394 10.4334 15.5822C10.7905 15.8202 11.3415 16 12 16C12.6585 16 13.2095 15.8202 13.5666 15.5822C13.9307 15.3394 14 15.1139 14 15C14 14.8861 13.9307 14.6606 13.5666 14.4178C13.2095 14.1798 12.6585 14 12 14C11.3415 14 10.7905 14.1798 10.4334 14.4178Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 8C9.55228 8 10 8.44772 10 9V10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10V9C8 8.44772 8.44772 8 9 8ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8ZM9.32398 12.7537C10.0526 12.268 11.0017 12 12 12C12.9983 12 13.9474 12.268 14.676 12.7537C15.3977 13.2349 16 14.0093 16 15C16 15.9907 15.3977 16.7651 14.676 17.2463C13.9474 17.732 12.9983 18 12 18C11.0017 18 10.0526 17.732 9.32398 17.2463C8.6023 16.7651 8 15.9907 8 15C8 14.0093 8.6023 13.2349 9.32398 12.7537Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "emoji-face-woozy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","issue","problem","failure","invalid","unhappy","sad","cancel","delete","remove","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10.7071 8.29289C11.0976 8.68342 11.0976 9.31658 10.7071 9.70711L8.70711 11.7071C8.31658 12.0976 7.68342 12.0976 7.29289 11.7071C6.90237 11.3166 6.90237 10.6834 7.29289 10.2929L9.29289 8.29289C9.68342 7.90237 10.3166 7.90237 10.7071 8.29289ZM13.2929 8.29289C12.9024 8.68342 12.9024 9.31658 13.2929 9.70711L15.2929 11.7071C15.6834 12.0976 16.3166 12.0976 16.7071 11.7071C17.0976 11.3166 17.0976 10.6834 16.7071 10.2929L14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289ZM9.38768 15.0939C9.63549 14.9684 9.93479 15.0176 10.1307 15.216C11.1631 16.2613 12.8369 16.2613 13.8693 15.216C14.0652 15.0176 14.3645 14.9684 14.6123 15.0939L15.5526 15.57C16.0466 15.82 16.6472 15.6173 16.8942 15.1172C17.1412 14.617 16.941 14.0088 16.447 13.7587L15.5067 13.2827C14.489 12.7674 13.2598 12.9694 12.4552 13.7841C12.2038 14.0386 11.7962 14.0386 11.5448 13.7841C10.7402 12.9694 9.51105 12.7674 8.4933 13.2827L7.55298 13.7587C7.05902 14.0088 6.85881 14.617 7.10579 15.1172C7.35277 15.6173 7.95341 15.82 8.44737 15.57L9.38768 15.0939Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "emoji-face-surprise": {
        defaultColors: ["#3D4C66"],
        keywords: ["surprise","emoji","face","customer-feedback","alert","error","warning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 17C13.6569 17 15 16.1046 15 15C15 13.8954 13.6569 13 12 13C10.3431 13 9 13.8954 9 15C9 16.1046 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "emoji-face-woozy-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["error","warning","issue","problem","feedback","customer-feedback","alert","notification","delay","slow","performance-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L8.94036 14.5298C9.57317 14.2134 10.3374 14.3374 10.8377 14.8377V14.8377C11.4796 15.4796 12.5204 15.4796 13.1623 14.8377V14.8377C13.6626 14.3374 14.4268 14.2134 15.0596 14.5298L16 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "emoji-face-woozy-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["drunk","dizzy","error","warning","exception","problem","issue","failed","woozy","mistake"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L8.94036 14.5298C9.57317 14.2134 10.3374 14.3374 10.8377 14.8377V14.8377C11.4796 15.4796 12.5204 15.4796 13.1623 14.8377V14.8377C13.6626 14.3374 14.4268 14.2134 15.0596 14.5298L16 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "emoji-face-woozy": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","face","woozy","error","problem","issue","sad","unhappy","customer-issue","report-problem","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 11L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 15L8.94036 14.5298C9.57317 14.2134 10.3374 14.3374 10.8377 14.8377V14.8377C11.4796 15.4796 12.5204 15.4796 13.1623 14.8377V14.8377C13.6626 14.3374 14.4268 14.2134 15.0596 14.5298L16 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-beam-sweat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","face","smile","sweat","happy","busy","stress","satisfaction","mood"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.98 9.9825C22.34 8.6025 22.34 6.4325 20.98 5.0525L19.21 3.2925C18.82 2.9025 18.19 2.9025 17.8 3.2925L16.74 4.3425C15.36 3.4425 13.79 3.0025 12 3.0025C7.03 3.0025 3 7.0325 3 12.0025C3 16.9725 7.03 21.0025 12 21.0025C16.97 21.0025 21 16.9725 21 12.0025C21 11.4325 20.91 10.7525 20.79 10.1525C20.85 10.1025 20.91 10.0425 20.97 9.9825H20.98ZM17.27 8.7425C16.63 8.0925 16.58 7.1025 17.16 6.4025C17.19 6.3625 17.23 6.3225 17.27 6.2825L18.51 5.0525L19.75 6.2825C20.43 6.9725 20.43 8.0425 19.75 8.7425C19.57 8.9225 19.35 9.0625 19.1 9.1525C18.45 9.3825 17.74 9.2125 17.27 8.7525V8.7425ZM7.8 10.2925C8.74 9.3525 10.27 9.3525 11.21 10.2925C11.6 10.6825 11.6 11.3125 11.21 11.7025C10.82 12.0925 10.19 12.0925 9.8 11.7025C9.64 11.5425 9.38 11.5425 9.21 11.7025C8.82 12.0925 8.19 12.0925 7.8 11.7025C7.41 11.3125 7.41 10.6825 7.8 10.2925ZM16.11 15.7925C15.09 16.5625 13.59 16.9925 12 16.9925C10.41 16.9925 8.91 16.5625 7.89 15.7925C7.45 15.4625 7.37 14.8325 7.7 14.3925C8.03 13.9525 8.66 13.8725 9.1 14.2025C9.68 14.6425 10.72 15.0025 11.99 15.0025C13.26 15.0025 14.3 14.6525 14.88 14.2025C15.32 13.8725 15.95 13.9525 16.28 14.3925C16.61 14.8325 16.53 15.4625 16.09 15.7925H16.11ZM16.21 11.7025C15.82 12.0925 15.19 12.0925 14.8 11.7025C14.64 11.5425 14.38 11.5425 14.21 11.7025C13.82 12.0925 13.19 12.0925 12.8 11.7025C12.41 11.3125 12.41 10.6825 12.8 10.2925C13.74 9.3525 15.27 9.3525 16.21 10.2925C16.6 10.6825 16.6 11.3125 16.21 11.7025Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-grin-beam-sweat-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","happy","sweat","busy","overwhelmed","sales","target-reached","success","payment-processing","stress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2674 9.27257C20.0084 9.53158 19.6917 9.73099 19.3411 9.85588C18.4281 10.1784 17.4027 9.94917 16.7321 9.27257C15.8184 8.35038 15.7523 6.92278 16.5771 5.92636C16.6262 5.86795 16.6779 5.81153 16.7321 5.75712L18.4997 4L20.2674 5.75712C21.2442 6.74132 21.2442 8.28838 20.2674 9.27257Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-beam-sweat": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","emotion","satisfied","success","completed","sweat","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2674 9.27257C20.0084 9.53158 19.6917 9.73099 19.3411 9.85588C18.4281 10.1784 17.4027 9.94917 16.7321 9.27257C15.8184 8.35038 15.7523 6.92278 16.5771 5.92636C16.6262 5.86795 16.6779 5.81153 16.7321 5.75712L18.4997 4L20.2674 5.75712C21.2442 6.74132 21.2442 8.28838 20.2674 9.27257V9.27257Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5.75463C15.6304 4.65672 13.8919 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.3094 19.9125 10.6392 19.748 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-squint-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["happy","satisfied","good","completed","success","customer-feedback","positive","feedback","rating","review","done","thank-you"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9L9.99985 9.99985L9 10.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L14.0002 10.0002L15 9.0003"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-squint-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["happy","satisfied","content","smile","emoji","customer satisfaction","reward","positive feedback","celebration","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9L9.99985 9.99985L9 10.9997"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L14.0002 10.0002L15 9.0003"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-squint-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","success","completed","promotion","discount","reward","customer-satisfaction","grin","squint"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L10.707 9.29274C11.0975 9.68327 11.0975 10.3164 10.707 10.707L9.70711 11.7068C9.31658 12.0973 8.68342 12.0973 8.29289 11.7068C7.90237 11.3163 7.90237 10.6831 8.29289 10.2926L8.58564 9.99985L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289ZM8.2521 14.3362C8.61871 13.9232 9.25075 13.8855 9.66381 14.2521C10.1297 14.6656 10.9663 15 12 15C13.0337 15 13.8703 14.6656 14.3362 14.2521C14.7493 13.8855 15.3813 13.9232 15.7479 14.3362C16.1145 14.7493 16.0769 15.3813 15.6638 15.7479C14.7614 16.5489 13.4197 17 12 17C10.5803 17 9.23864 16.5489 8.33621 15.7479C7.92315 15.3813 7.88549 14.7493 8.2521 14.3362ZM15.7071 11.7071C15.3166 12.0976 14.6834 12.0976 14.2929 11.7071L13.293 10.7073C12.9025 10.3167 12.9025 9.68357 13.293 9.29304L14.2929 8.2932C14.6834 7.90267 15.3166 7.90267 15.7071 8.2932C16.0976 8.68372 16.0976 9.31688 15.7071 9.70741L15.4144 10.0002L15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-grin-squint-tears-1": {
        defaultColors: ["#3d4c66", "#2797e8", "#FFFFFF"],
        keywords: ["emoji","happy","customer satisfaction","positive feedback","grin","satisfied","successful","tears","squint"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_87692)">
                    <path
                        d="M17.657 17.657C20.5417 14.7722 20.7628 10.2326 18.3203 7.09413M6.34326 6.34326C8.4371 4.24943 11.4028 3.55888 14.0718 4.27162M16.2464 3.133C16.6127 3.13301 16.9776 3.21594 17.3139 3.37556C18.1875 3.79309 18.7505 4.68021 18.7463 5.63287C18.7403 6.93102 17.7775 7.98726 16.4897 8.10862C16.4137 8.11515 16.3373 8.1185 16.2605 8.11867L13.7681 8.11121L13.7606 5.61879C13.7659 4.23218 14.8598 3.13825 16.2464 3.133Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                    />
                    <path
                        d="M16.2426 12C16.1882 12.9132 15.6958 13.9611 14.8284 14.8285C13.961 15.6959 12.9132 16.1883 12 16.2427"
                        stroke={colors?.[1] || "#2797E8"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M9.17163 13.4141V13.4141C9.17163 12.633 9.8048 11.9998 10.5858 11.9998V11.9998"
                        stroke={colors?.[1] || "#2797E8"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 10.5859V10.5859C12 9.80489 12.6332 9.17172 13.4142 9.17172V9.17172"
                        stroke={colors?.[1] || "#2797E8"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.2464 3.13311C16.6127 3.13312 16.9776 3.21605 17.3139 3.37567C18.1875 3.7932 18.7505 4.68032 18.7463 5.63298C18.7402 6.93114 17.7775 7.98737 16.4897 8.10873C16.4137 8.11526 16.3372 8.11861 16.2605 8.11878L13.7681 8.11132L13.7606 5.61891C13.7658 4.2323 14.8598 3.13836 16.2464 3.13311V3.13311Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M17.657 17.657C14.7722 20.5417 10.2326 20.7628 7.09413 18.3203M6.34326 6.34326C4.24943 8.4371 3.55888 11.4028 4.27162 14.0718M3.133 16.2464C3.13301 16.6127 3.21594 16.9776 3.37556 17.3139C3.79309 18.1875 4.68021 18.7505 5.63287 18.7463C6.93102 18.7403 7.98726 17.7775 8.10862 16.4897C8.11515 16.4137 8.1185 16.3373 8.11867 16.2605L8.11121 13.7681L5.61879 13.7606C4.23218 13.7659 3.13825 14.8598 3.133 16.2464Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_87692">
                        <rect width="24" height="24" fill={colors?.[2] || "#FFFFFF"} />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Emoji-grin-beam-sweat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["emoji","grin","sweat","happy","busy","stress","overwhelmed","processing","loading","working","waiting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5.75463C15.6304 4.65672 13.8919 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.3094 19.9125 10.6392 19.748 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2674 9.27257C20.0084 9.53158 19.6917 9.73099 19.3411 9.85588C18.4281 10.1784 17.4027 9.94917 16.7321 9.27257C15.8184 8.35038 15.7523 6.92278 16.5771 5.92636C16.6262 5.86795 16.6779 5.81153 16.7321 5.75712L18.4997 4L20.2674 5.75712C21.2442 6.74132 21.2442 8.28838 20.2674 9.27257V9.27257Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-squint-tears-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","feedback","satisfaction","happy","grin","customer-feedback","customer-satisfaction","happy-customer","sentiment","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.3138 3.37556C16.9775 3.21594 16.6126 3.13301 16.2463 3.133C14.8597 3.13825 13.7657 4.23219 13.7605 5.6188L13.7679 8.11121L16.2604 8.11867C16.3371 8.1185 16.4136 8.11515 16.4896 8.10862C17.7774 7.98726 18.7401 6.93102 18.7462 5.63287C18.7503 4.68021 18.1874 3.79309 17.3138 3.37556Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.2426 12C16.1882 12.9132 15.6958 13.9611 14.8284 14.8285C13.961 15.6959 12.9132 16.1883 12 16.2427"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.17163 13.4141V13.4141C9.17163 12.633 9.8048 11.9998 10.5858 11.9998V11.9998"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10.5859V10.5859C12 9.80489 12.6332 9.17172 13.4142 9.17172V9.17172"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2464 3.13311C16.6127 3.13312 16.9776 3.21605 17.3139 3.37567C18.1875 3.7932 18.7505 4.68032 18.7463 5.63298C18.7402 6.93114 17.7775 7.98737 16.4897 8.10873C16.4137 8.11526 16.3372 8.11861 16.2605 8.11878L13.7681 8.11132L13.7606 5.61891C13.7658 4.2323 14.8598 3.13836 16.2464 3.13311Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.37556 17.3138C3.21594 16.9775 3.13301 16.6126 3.133 16.2463C3.13825 14.8597 4.23219 13.7657 5.6188 13.7605L8.11121 13.7679L8.11867 16.2604C8.1185 16.3371 8.11515 16.4136 8.10862 16.4896C7.98726 17.7774 6.93102 18.7401 5.63287 18.7462C4.68021 18.7503 3.79309 18.1874 3.37556 17.3138Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Emoji-grin-squint-tears-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sync","synchronize","refresh","reload","update","exchange","rotate","loop","repeat","automation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7901 10.87C16.2401 10.84 15.7701 11.26 15.7301 11.81C15.6901 12.43 15.3401 13.26 14.6101 13.99C13.8801 14.72 13.0501 15.08 12.4301 15.11C11.8801 15.14 11.4601 15.62 11.4901 16.17C11.5201 16.72 12.0001 17.14 12.5501 17.11C13.7501 17.04 15.0201 16.41 16.0301 15.4C17.0301 14.4 17.6601 13.13 17.7401 11.92C17.7701 11.37 17.3501 10.9 16.8001 10.86L16.7901 10.87Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9601 6.85C20.1301 6.44 20.2301 5.98 20.2301 5.5C20.2301 4.15 19.4401 2.92 18.2301 2.34C17.7601 2.12 17.2501 2 16.7301 2C15.7501 2 14.8701 2.4 14.2401 3.04C11.3901 2.48 8.33012 3.3 6.12012 5.5C3.92012 7.71 3.10012 10.78 3.66012 13.62C3.02012 14.25 2.62012 15.13 2.62012 16.11C2.62012 16.63 2.74012 17.14 2.96012 17.61C3.54012 18.83 4.78012 19.62 6.12012 19.61C6.60012 19.61 7.05012 19.51 7.47012 19.34C10.9701 21.69 15.7501 21.32 18.8501 18.23C21.9401 15.14 22.3101 10.35 19.9601 6.85ZM7.54012 6.92C9.11012 5.35 11.2501 4.68 13.3001 4.92C13.2701 5.1 13.2501 5.29 13.2501 5.49V8.15C12.2401 8.43 11.4901 9.36 11.4901 10.47C11.4901 10.75 11.6001 11 11.7801 11.18C11.6001 11 11.3501 10.89 11.0701 10.89C9.96012 10.89 9.04012 11.64 8.75012 12.66H6.11012C5.92012 12.66 5.73012 12.68 5.54012 12.71C5.30012 10.66 5.97012 8.52 7.54012 6.95V6.92ZM17.4401 16.82C15.1801 19.08 11.7401 19.47 9.08012 17.99C9.36012 17.54 9.54012 17.02 9.60012 16.46C9.60012 16.35 9.61012 16.24 9.61012 16.14V14.28C9.61012 14.28 9.64012 14.29 9.66012 14.29C10.2101 14.29 10.6601 13.84 10.6601 13.29C10.6601 13.06 10.8501 12.88 11.0701 12.88C11.6201 12.88 12.0701 12.43 12.0701 11.88C12.0701 11.6 11.9601 11.35 11.7801 11.17C11.9601 11.35 12.2101 11.46 12.4901 11.46C13.0401 11.46 13.4901 11.01 13.4901 10.46C13.4901 10.23 13.6801 10.05 13.9001 10.05C14.4501 10.05 14.9001 9.6 14.9001 9.05C14.9001 9.03 14.8901 9.01 14.8901 8.99H16.7401C16.8401 8.99 16.9501 8.99 17.0501 8.98C17.6101 8.93 18.1301 8.74 18.5801 8.46C20.0701 11.12 19.6801 14.56 17.4101 16.82H17.4401Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-grin-squint-tears": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["happy","emoji","customer-satisfaction","customer-feedback","positive-review","success","reward","loyalty","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_87685)">
                    <path
                        d="M17.657 17.657C20.5417 14.7722 20.7628 10.2326 18.3203 7.09413M6.34326 6.34326C8.4371 4.24943 11.4028 3.55888 14.0718 4.27162M16.2464 3.133C16.6127 3.13301 16.9776 3.21594 17.3139 3.37556C18.1875 3.79309 18.7505 4.68021 18.7463 5.63287C18.7403 6.93102 17.7775 7.98726 16.4897 8.10862C16.4137 8.11515 16.3373 8.1185 16.2605 8.11867L13.7681 8.11121L13.7606 5.61879C13.7659 4.23218 14.8598 3.13825 16.2464 3.133Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                    />
                    <path
                        d="M16.2426 12C16.1882 12.9132 15.6958 13.9611 14.8284 14.8285C13.961 15.6959 12.9132 16.1883 12 16.2427"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M9.17163 13.4141V13.4141C9.17163 12.633 9.8048 11.9998 10.5858 11.9998V11.9998"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 10.5859V10.5859C12 9.80489 12.6332 9.17172 13.4142 9.17172V9.17172"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.2464 3.13311C16.6127 3.13312 16.9776 3.21605 17.3139 3.37567C18.1875 3.7932 18.7505 4.68032 18.7463 5.63298C18.7402 6.93114 17.7775 7.98737 16.4897 8.10873C16.4137 8.11526 16.3372 8.11861 16.2605 8.11878L13.7681 8.11132L13.7606 5.61891C13.7658 4.2323 14.8598 3.13836 16.2464 3.13311V3.13311Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M17.657 17.657C14.7722 20.5417 10.2326 20.7628 7.09413 18.3203M6.34326 6.34326C4.24943 8.4371 3.55888 11.4028 4.27162 14.0718M3.133 16.2464C3.13301 16.6127 3.21594 16.9776 3.37556 17.3139C3.79309 18.1875 4.68021 18.7505 5.63287 18.7463C6.93102 18.7403 7.98726 17.7775 8.10862 16.4897C8.11515 16.4137 8.1185 16.3373 8.11867 16.2605L8.11121 13.7681L5.61879 13.7606C4.23218 13.7659 3.13825 14.8598 3.133 16.2464Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_87685">
                        <rect width="24" height="24" fill={colors?.[1] || "#FFFFFF"} />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Emoji-grin-wink-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["emoji","wink","face","expression","happy","fun","mood","customer-feedback","review","sentiment","satisfaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 11V11C13.5522 10.4478 14.4475 10.4478 14.9997 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-wink-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","wink","happy","customer-satisfaction","feedback","confirmation","success","complete","transaction-complete","payment-successful"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 11V11C13.5522 10.4478 14.4475 10.4478 14.9997 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-wink-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","wink","grin","smile","happy","customer-satisfaction","user-feedback","discount","loyalty-program","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM8 10C8 9.45 8.45 9 9 9C9.55 9 10 9.45 10 10V11C10 11.55 9.55 12 9 12C8.45 12 8 11.55 8 11V10ZM15.93 14.36C15.69 14.99 15.29 15.55 14.77 15.98C13.97 16.66 12.98 17 11.99 17C11 17 10.02 16.66 9.21 15.98C8.7 15.55 8.3 14.98 8.05 14.36C7.92 14.03 7.98 13.65 8.2 13.37C8.42 13.09 8.78 12.95 9.13 13.01C10.08 13.16 11.04 13.24 12 13.27C12.91 13.25 13.88 13.16 14.82 13.01C15.18 12.95 15.53 13.09 15.75 13.37C15.97 13.65 16.03 14.03 15.9 14.36H15.93ZM15.7 11.71C15.31 12.1 14.68 12.1 14.29 11.71C14.13 11.55 13.87 11.55 13.7 11.71C13.31 12.1 12.68 12.1 12.29 11.71C11.9 11.32 11.9 10.69 12.29 10.3C13.23 9.36 14.76 9.36 15.7 10.3C16.09 10.69 16.09 11.32 15.7 11.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-grin-squint": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","grin","happy","satisfied","customer-satisfaction","feedback","positive","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9L9.99985 9.99985L9 10.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L14.0002 10.0002L15 9.0003"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-grin-wink": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","wink","smile","happy","customer-satisfaction","tip","reward","loyalty","loyalty-program","feedback","rate","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 11V11C13.5522 10.4478 14.4475 10.4478 14.9997 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-laugh-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["happy","customer","satisfaction","feedback","rating","smiley","face","review","positive","emoticon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-laugh-beam-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["customer-feedback","happy","satisfied","success","customer-satisfaction","positive-review","enjoy","payment-success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-laugh-beam-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","face","laugh","happy","customer-satisfaction","satisfaction","good-service","smiley"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-laugh-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","laugh","happy","customer-satisfaction","feedback","rating","positive-feedback","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-laugh-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","customer","satisfaction","positive","feedback","success","complete-order","smile","face"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 9C9.55228 9 10 9.44772 10 10V11C10 11.5523 9.55228 12 9 12C8.44772 12 8 11.5523 8 11V10C8 9.44772 8.44772 9 9 9ZM15 9C15.5523 9 16 9.44772 16 10V11C16 11.5523 15.5523 12 15 12C14.4477 12 14 11.5523 14 11V10C14 9.44772 14.4477 9 15 9ZM9.15469 13.2621C8.80164 13.2068 8.44593 13.3441 8.2216 13.6223C7.99727 13.9004 7.93843 14.2772 8.06724 14.6105C8.31042 15.2398 8.70809 15.7977 9.22358 16.2328C10.8266 17.5887 13.1744 17.5887 14.7774 16.2328C15.2927 15.7975 15.6901 15.2394 15.9329 14.6101C16.0616 14.2768 16.0026 13.9001 15.7783 13.6221C15.5539 13.344 15.1983 13.2068 14.8453 13.2621C13.9035 13.4095 12.953 13.495 12 13.5177C11.047 13.4949 10.0965 13.4095 9.15469 13.2621Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-laugh-beam-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","happy","customer-satisfaction","feedback","success","approval","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM7.94 9.71C8.88 8.77 10.41 8.77 11.35 9.71C11.74 10.1 11.74 10.73 11.35 11.12C10.96 11.51 10.33 11.51 9.94 11.12C9.78 10.96 9.52 10.96 9.35 11.12C8.96 11.51 8.33 11.51 7.94 11.12C7.55 10.73 7.55 10.1 7.94 9.71ZM15.93 13.78C15.69 14.41 15.29 14.97 14.77 15.4C13.97 16.08 12.98 16.42 11.99 16.42C11 16.42 10.02 16.08 9.21 15.4C8.7 14.97 8.3 14.41 8.05 13.78C7.9 13.38 8.01 12.94 8.33 12.66C8.65 12.38 9.11 12.34 9.48 12.55C9.48 12.55 10.23 12.92 11.98 12.92C13.05 12.92 13.43 12.8 13.86 12.67C14.12 12.59 14.41 12.5 14.82 12.43C15.18 12.37 15.53 12.51 15.75 12.79C15.97 13.07 16.03 13.45 15.9 13.78H15.93ZM16.06 11.13C15.67 11.52 15.04 11.52 14.65 11.13C14.49 10.97 14.23 10.97 14.06 11.13C13.67 11.52 13.04 11.52 12.65 11.13C12.26 10.74 12.26 10.11 12.65 9.72C13.59 8.78 15.12 8.78 16.06 9.72C16.45 10.11 16.45 10.74 16.06 11.13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-laugh-beam": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","customer","positive","feedback","smile","smiley","face","success","satisfied","excellent","rating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11V11C9.55228 10.4477 10.4477 10.4477 11 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11V11C13.5523 10.4477 14.4477 10.4477 15 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-sad-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sad","unhappy","error","failure","issue","problem","cancel","rejected","denied","negative","feedback","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-sad-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sad","unhappy","error","failed","problem","issue","negative","decline","declined","rejected","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-laugh": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","customer","satisfaction","feedback","success","completed","positive","review","ratings","smiley","face"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.869 15.219C11.0994 16.26 12.9016 16.26 14.132 15.219C14.5191 14.892 14.8176 14.4727 15 14C14.007 14.1555 13.0048 14.245 12 14.268C10.9952 14.245 9.99299 14.1555 9 14C9.18273 14.4728 9.48158 14.8921 9.869 15.219Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Emoji-sad-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sad","unhappy","negative","problem","error","issue","feedback","customer-complaint","low-satisfaction","rating","bad-review","failure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V9ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8ZM14.3362 15.7479C14.7492 16.1145 15.3813 16.0768 15.7479 15.6638C16.1145 15.2507 16.0768 14.6187 15.6638 14.2521C14.7614 13.4511 13.4197 13 12 13C10.5803 13 9.23862 13.4511 8.33619 14.2521C7.92313 14.6187 7.88547 15.2507 8.25208 15.6638C8.61869 16.0768 9.25073 16.1145 9.66379 15.7479C10.1297 15.3344 10.9663 15 12 15C13.0337 15 13.8703 15.3344 14.3362 15.7479Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-sad": {
        defaultColors: ["#3D4C66"],
        keywords: ["sad","unhappy","error","problem","issue","negative","decline","failed","failure","reject","rejection","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16C9.68417 15.3928 10.7733 15 12 15C13.2267 15 14.3158 15.3928 15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-sleep-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sleep","inactive","offline","unavailable","standby","pause","break","zz","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 21C13.866 21 17 17.866 17 14C17 10.134 13.866 7 10 7C6.13401 7 3 10.134 3 14C3 17.866 6.13401 21 10 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 17H7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 11L7.99985 11.9998L7 12.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L12.0002 12.0002L13 11.0003"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 3L21.3333 3L20.6667 5H22"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L18.3333 6L17.6667 8H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-sleep": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","inactive","offline","break","downtime","unavailable","rest","snooze","tired","asleep"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 21C13.866 21 17 17.866 17 14C17 10.134 13.866 7 10 7C6.13401 7 3 10.134 3 14C3 17.866 6.13401 21 10 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 17H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 11L7.99985 11.9998L7 12.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L12.0002 12.0002L13 11.0003"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 3L21.3333 3L20.6667 5H22"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L18.3333 6L17.6667 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-sleep-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","sleeping","tired","zzz","away","offline","disabled","unavailable","downtime","break"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 14C2 9.58172 5.58172 6 10 6C14.4183 6 18 9.58172 18 14C18 18.4183 14.4183 22 10 22C5.58172 22 2 18.4183 2 14ZM6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929L8.70696 11.2927C9.09748 11.6833 9.09748 12.3164 8.70696 12.707L7.70711 13.7068C7.31658 14.0973 6.68342 14.0973 6.29289 13.7068C5.90237 13.3163 5.90237 12.6831 6.29289 12.2926L6.58564 11.9998L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929ZM12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071C14.0976 13.3166 14.0976 12.6834 13.7071 12.2929L13.4144 12.0002L13.7071 11.7074C14.0976 11.3169 14.0976 10.6837 13.7071 10.2932C13.3166 9.90267 12.6834 9.90267 12.2929 10.2932L11.293 11.293C10.9025 11.6836 10.9025 12.3167 11.293 12.7073L12.2929 13.7071ZM6 17C6 16.4477 6.44772 16 7 16H13C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H7C6.44772 18 6 17.5523 6 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 3C19 2.44772 19.4477 2 20 2L21.3333 2C21.6548 2 21.9566 2.15452 22.1446 2.41529C22.3325 2.67606 22.3837 3.01128 22.282 3.31622L22.0536 4.00141C22.581 4.02928 23 4.4657 23 5C23 5.55228 22.5523 6 22 6H20.6667C20.3452 6 20.0434 5.84548 19.8554 5.58471C19.6675 5.32395 19.6163 4.98872 19.718 4.68378L19.9464 3.99859C19.419 3.97072 19 3.5343 19 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 6C16 5.44772 16.4477 5 17 5L18.3333 5C18.6548 5 18.9566 5.15452 19.1446 5.41529C19.3325 5.67606 19.3837 6.01128 19.282 6.31622L19.0536 7.00141C19.581 7.02928 20 7.4657 20 8C20 8.55228 19.5523 9 19 9H17.6667C17.3452 9 17.0434 8.84548 16.8554 8.58471C16.6675 8.32395 16.6163 7.98872 16.718 7.68378L16.9464 6.99859C16.419 6.97073 16 6.5343 16 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-smile-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["emoji","surprise","shock","reaction","alert","warning","error","notification","attention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 13H11C9.89543 13 9 13.8954 9 15C9 16.1046 9.89543 17 11 17H13C14.1046 17 15 16.1046 15 15C15 13.8954 14.1046 13 13 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-sleep-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sleep","zzz","offline","away","unavailable","break","downtime","idle","do-not-disturb"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 21C13.866 21 17 17.866 17 14C17 10.134 13.866 7 10 7C6.13401 7 3 10.134 3 14C3 17.866 6.13401 21 10 21Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 17H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 11L7.99985 11.9998L7 12.9997"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L12.0002 12.0002L13 11.0003"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 3L21.3333 3L20.6667 5H22"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L18.3333 6L17.6667 8H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-smile-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["surprise","shock","alert","notification","error","warning","unexpected","problem","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 13H11C9.89543 13 9 13.8954 9 15C9 16.1046 9.89543 17 11 17H13C14.1046 17 15 16.1046 15 15C15 13.8954 14.1046 13 13 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-smile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["surprised","shocked","astonished","amazed","error","alert","customer-issue","unexpected","face","emoji","reaction","mistake","problem","warning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15C10 14.4477 10.4477 14 11 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H11C10.4477 16 10 15.5523 10 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 8C9.55228 8 10 8.44772 10 9V10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10V9C8 8.44772 8.44772 8 9 8ZM15 8C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8ZM11 12C9.34315 12 8 13.3431 8 15C8 16.6569 9.34315 18 11 18H13C14.6569 18 16 16.6569 16 15C16 13.3431 14.6569 12 13 12H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-smile-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["smiley","face","wink","happy","customer-satisfaction","feedback","success","confirmation","good"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10V10C13.5522 9.4478 14.4475 9.4478 14.9997 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-smile-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","smile","wink","happy","customer-satisfaction","feedback","rate","rating","reward","discount","thanks"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10V10C13.5522 9.4478 14.4475 9.4478 14.9997 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-smile-beam-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["happy","satisfied","feedback","customer-satisfaction","order-complete","success","positive-review","thank-you"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 10V10C10.4477 10.5523 9.55228 10.5523 9 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V10C14.4477 10.5523 13.5523 10.5523 13 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-smile-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","smile","wink","happy","customer-satisfaction","feedback","rating","mood","loyalty","confirmation","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9.00001 8C9.5523 8 10 8.44772 10 9V10C10 10.5523 9.5523 11 9.00001 11C8.44773 11 8.00001 10.5523 8.00001 10V9C8.00001 8.44772 8.44773 8 9.00001 8ZM12.293 10.707C11.9024 10.3164 11.9024 9.68327 12.293 9.29274C13.2357 8.35002 14.7641 8.35002 15.7069 9.29274C16.0974 9.68327 16.0974 10.3164 15.7069 10.707C15.3163 11.0975 14.6832 11.0975 14.2927 10.707C14.131 10.5453 13.8689 10.5453 13.7072 10.707C13.3167 11.0975 12.6835 11.0975 12.293 10.707ZM9.66381 14.2521C9.25075 13.8855 8.61871 13.9231 8.2521 14.3362C7.88549 14.7493 7.92315 15.3813 8.33621 15.7479C9.23864 16.5489 10.5803 17 12 17C13.4197 17 14.7614 16.5489 15.6638 15.7479C16.0769 15.3813 16.1145 14.7493 15.7479 14.3362C15.3813 13.9231 14.7493 13.8855 14.3362 14.2521C13.8703 14.6656 13.0337 15 12 15C10.9663 15 10.1297 14.6656 9.66381 14.2521Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-smile-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["emoji","smile","happy","success","wink","customer-satisfaction","feedback","rating","customer-experience"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10V10C13.5522 9.4478 14.4475 9.4478 14.9997 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Emoji-smile-beam-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["emoji","smile","customer-satisfaction","happy","feedback","rating","satisfaction","mood"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 10V10C10.4477 10.5523 9.55228 10.5523 9 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V10C14.4477 10.5523 13.5523 10.5523 13 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-smile-beam-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["emoji","smile","happy","customer-satisfaction","feedback","positive-feedback","success","thank-you"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10.7071 9.29289C11.0976 9.68342 11.0976 10.3166 10.7071 10.7071C9.7643 11.6499 8.2357 11.6499 7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289C7.68342 8.90237 8.31658 8.90237 8.70711 9.29289C8.86887 9.45465 9.13113 9.45465 9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289ZM8.2521 14.3362C8.61871 13.9232 9.25075 13.8855 9.66381 14.2521C10.1297 14.6656 10.9663 15 12 15C13.0337 15 13.8703 14.6656 14.3362 14.2521C14.7493 13.8855 15.3813 13.9232 15.7479 14.3362C16.1145 14.7493 16.0769 15.3813 15.6638 15.7479C14.7614 16.5489 13.4197 17 12 17C10.5803 17 9.23864 16.5489 8.33621 15.7479C7.92315 15.3813 7.88549 14.7493 8.2521 14.3362ZM16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071C15.7643 11.6499 14.2357 11.6499 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C14.8689 9.45465 15.1311 9.45465 15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Emoji-smile-beam": {
        defaultColors: ["#3D4C66"],
        keywords: ["happy","satisfied","customer","feedback","rating","positive","smile","approval","completed","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C14.3158 15.6072 13.2267 16 12 16C10.7733 16 9.68417 15.6072 9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 10V10C10.4477 10.5523 9.55228 10.5523 9 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10V10C14.4477 10.5523 13.5523 10.5523 13 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Emoji-smile": {
        defaultColors: ["#3D4C66"],
        keywords: ["shock","surprise","warning","error","alert","unexpected","issue","problem","customer-feedback","negative-feedback","concern"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 13H11C9.89543 13 9 13.8954 9 15C9 16.1046 9.89543 17 11 17H13C14.1046 17 15 16.1046 15 15C15 13.8954 14.1046 13 13 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "empty-set-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["unavailable","not-available","disabled","prohibited","restriction","cancel","delete","remove","block","void","void-transaction","void-item","clear","reset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 5L5 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "empty-set-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["not-allowed","prohibited","disabled","unavailable","cancel","remove","delete","error","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M19 5L5 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "empty-set-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["unavailable","disabled","not-available","blocked","restricted","error","no-access","out-of-stock","sold-out","item-unavailable","item-disabled","remove","delete","cancel","void","deletion","removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L16.9056 5.68014C15.551 4.62708 13.8487 4 12 4C7.58172 4 4 7.58172 4 12C4 13.8487 4.62708 15.551 5.68014 16.9056L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.31276 19.1015L19.1015 8.31276C19.6755 9.41616 20 10.6702 20 12C20 16.4183 16.4183 20 12 20C10.6702 20 9.41616 19.6755 8.31276 19.1015Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "empty-set": {
        defaultColors: ["#3D4C66"],
        keywords: ["not-available","unavailable","disabled","inactive","out-of-stock","sold-out","error","cancel","remove","prohibited","no","decline","stop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 5L5 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "english-input-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["english","language","en","translation","international","localization","input-method","keyboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8V16C5 16.9428 5 17.4142 5.29289 17.7071C5.58579 18 6.05719 18 7 18H11M11 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L19 15C19 13.3431 17.6569 12 16 12V12C14.3431 12 13 13.3431 13 15L13 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L13 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "english-input-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["english","language","localization","international","region","translation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 5.00001L6.44561 5.00001C6.02154 4.99992 5.60941 4.99984 5.26949 5.04554C4.88629 5.09706 4.44902 5.22259 4.0858 5.5858C3.72259 5.94902 3.59706 6.38629 3.54554 6.76949C3.49984 7.10941 3.49992 7.52154 3.50001 7.94561V16.0544C3.49992 16.4785 3.49984 16.8906 3.54554 17.2305C3.59706 17.6137 3.72259 18.051 4.0858 18.4142C4.44902 18.7774 4.88629 18.903 5.26949 18.9545C5.60939 19.0002 6.02152 19.0001 6.44557 19L10.5 19C11.0523 19 11.5 18.5523 11.5 18C11.5 17.4477 11.0523 17 10.5 17H6.50001C6.00034 17 5.72618 16.9979 5.53599 16.9723L5.52871 16.9713L5.52771 16.964C5.50214 16.7738 5.50001 16.4997 5.50001 16V13H10.5C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11H5.50001V8.00001C5.50001 7.50034 5.50214 7.22618 5.52771 7.03599L5.52871 7.02871L5.53599 7.02771C5.72618 7.00214 6.00034 7.00001 6.50001 7.00001H10.5C11.0523 7.00001 11.5 6.5523 11.5 6.00001C11.5 5.44773 11.0523 5.00001 10.5 5.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5 19C12.9477 19 12.5 18.5523 12.5 18V12C12.5 11.4477 12.9477 11 13.5 11C13.9054 11 14.2544 11.2412 14.4114 11.5879C15.0193 11.215 15.7346 11 16.5 11C18.7092 11 20.5 12.7909 20.5 15V18C20.5 18.5523 20.0523 19 19.5 19C18.9477 19 18.5 18.5523 18.5 18V15C18.5 13.8954 17.6046 13 16.5 13C15.3954 13 14.5 13.8954 14.5 15V18C14.5 18.5523 14.0523 19 13.5 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "english-input-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["language","english","input","keyboard","locale","localization","internationalization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8V16C5 16.9428 5 17.4142 5.29289 17.7071C5.58579 18 6.05719 18 7 18H11M11 12H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L19 15C19 13.3431 17.6569 12 16 12V12C14.3431 12 13 13.3431 13 15L13 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L13 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "english-input": {
        defaultColors: ["#3D4C66"],
        keywords: ["english","language","input","keyboard","locale","text","transaction","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6H7C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8V16C5 16.9428 5 17.4142 5.29289 17.7071C5.58579 18 6.05719 18 7 18H11M11 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L19 15C19 13.3431 17.6569 12 16 12V12C14.3431 12 13 13.3431 13 15L13 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "error 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["error","warning","alert","exclamation","triangle","issue","problem","notification","alerting","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 12M12 15.0342V16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "error 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","exclamation","problem","issue","notification","incorrect","invalid","system-error","transaction-failed","out-of-stock","low-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 12M12 15.0342V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "error 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","warning","alert","exclamation","problem","issue","notification","incorrect","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 9L12 12M12 15.0342V16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "error 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","exclamation","problem","issue","attention","caution","incorrect","invalid","exception"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9512 5.13517C11.6387 4.95493 12.362 4.95494 13.0494 5.13522C14.0236 5.39068 14.7332 6.09774 15.3705 6.96745C16.0026 7.82986 16.6882 9.03289 17.5434 10.5333C18.3693 11.9825 19.0985 13.2618 19.5051 14.2147C19.9164 15.1787 20.1538 16.1197 19.887 17.0577C19.6979 17.7227 19.3388 18.3286 18.8442 18.8174C18.1466 19.5067 17.1991 19.7638 16.1462 19.8826C15.1052 20 13.7514 20 12.0666 20H11.9336C10.2487 20 8.8949 20 7.85388 19.8826C6.80085 19.7638 5.85337 19.5067 5.15573 18.8173C4.66113 18.3286 4.30206 17.7226 4.11293 17.0576C3.84618 16.1196 4.08361 15.1785 4.49499 14.2145C4.90168 13.2616 5.63094 11.9822 6.45704 10.533C7.31225 9.03265 7.99796 7.82966 8.63003 6.96729C9.26744 6.09761 9.97708 5.39058 10.9512 5.13517ZM13 9C13 8.44771 12.5523 8 12 8C11.4477 8 11 8.44772 11 9L11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12L13 9ZM13 15.0342C13 14.4819 12.5523 14.0342 12 14.0342C11.4477 14.0342 11 14.4819 11 15.0342V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.0342Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "error 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["error","warning","attention","alert","issue","problem","notification","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17.6481 13.0397L15.4872 9.19784C13.9428 6.45224 13.1707 5.07944 12.001 5.07941C10.8313 5.07938 10.0591 6.45214 8.5146 9.19767L6.35339 13.0395C4.8606 15.6932 4.11421 17.02 4.69338 18.0103C5.27256 19.0007 6.79492 19.0007 9.83963 19.0007H14.1618C17.2064 19.0007 18.7286 19.0007 19.3078 18.0104C19.887 17.0201 19.1407 15.6933 17.6481 13.0397Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "error 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","exclamation","problem","issue","notification","attention","caution","invalid","failed","incorrect","bug","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.4679 5.4237C10.0952 4.65573 10.8823 3.99997 12.0004 4C13.1186 4.00003 13.9056 4.65582 14.5329 5.42382C15.1445 6.17267 15.7888 7.26049 16.5688 8.57724L18.9429 12.5851C19.6959 13.8561 20.3199 14.9094 20.6663 15.7704C21.0232 16.6574 21.199 17.6115 20.6472 18.5072C20.0955 19.4029 19.1336 19.7252 18.1444 19.8647C17.1843 20.0001 15.9115 20 14.3757 20H9.62455C8.08864 20 6.81579 20.0001 5.85561 19.8647C4.86636 19.7252 3.90444 19.4029 3.35272 18.5071C2.80101 17.6114 2.97681 16.6573 3.33379 15.7702C3.68027 14.9092 4.30435 13.8559 5.05743 12.5849L7.38811 8.65085C8.16813 7.33415 8.85627 6.17252 9.4679 5.4237ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13L11 16ZM11 9.9658C11 10.5181 11.4477 10.9658 12 10.9658C12.5523 10.9658 13 10.5181 13 9.9658V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V9.9658Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "error 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","warning","alert","notification","information","issue","problem","attention","system-error","transaction-error","invalid-input","configuration-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.6481 13.0397L15.4872 9.19784C13.9428 6.45224 13.1707 5.07944 12.001 5.07941C10.8313 5.07938 10.0591 6.45214 8.5146 9.19767L6.35339 13.0395C4.8606 15.6932 4.11421 17.02 4.69338 18.0103C5.27256 19.0007 6.79492 19.0007 9.83963 19.0007H14.1618C17.2064 19.0007 18.7286 19.0007 19.3078 18.0104C19.887 17.0201 19.1407 15.6933 17.6481 13.0397Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "error-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["warning","alert","information","error","attention","notification","issue","problem","caution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "error-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","warning","alert","information","problem","attention","issue","notification","exclamation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "error 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","issue","problem","attention","exclamation","notification","invalid","incorrect","unsuccessful","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17.6481 13.0397L15.4872 9.19784C13.9428 6.45224 13.1707 5.07944 12.001 5.07941C10.8313 5.07938 10.0591 6.45214 8.5146 9.19767L6.35339 13.0395C4.8606 15.6932 4.11421 17.02 4.69338 18.0103C5.27256 19.0007 6.79492 19.0007 9.83963 19.0007H14.1618C17.2064 19.0007 18.7286 19.0007 19.3078 18.0104C19.887 17.0201 19.1407 15.6933 17.6481 13.0397Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "error-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","notification","problem","issue","incorrect","invalid","attention","exclamation","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0494 5.13522C12.362 4.95494 11.6387 4.95493 10.9512 5.13517C9.97708 5.39058 9.26744 6.09761 8.63003 6.96729C7.99796 7.82966 7.31226 9.03265 6.45705 10.533C5.63094 11.9822 4.90168 13.2616 4.49499 14.2145C4.08361 15.1785 3.84618 16.1196 4.11293 17.0576C4.30206 17.7226 4.66113 18.3286 5.15573 18.8173C5.85337 19.5067 6.80085 19.7638 7.85388 19.8826C8.8949 20 10.2487 20 11.9336 20H12.0666C13.7514 20 15.1052 20 16.1462 19.8826C17.1991 19.7638 18.1466 19.5067 18.8442 18.8174C19.3388 18.3286 19.6979 17.7227 19.887 17.0577C20.1538 16.1197 19.9164 15.1787 19.5051 14.2147C19.0985 13.2618 18.3693 11.9825 17.5434 10.5333C16.6882 9.03289 16.0026 7.82986 15.3705 6.96745C14.7332 6.09774 14.0236 5.39068 13.0494 5.13522ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13L11 16ZM11 9.9658C11 10.5181 11.4477 10.9658 12 10.9658C12.5523 10.9658 13 10.5181 13 9.9658V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V9.9658Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "error-med-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["error","warning","alert","waveform","signal","communication","problem","issue","disturbance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 13L10.2 11L11.4 13L12.6 11L13.8 13L15 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "error-med-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["error","warning","alert","issue","problem","notification","incorrect","invalid","fault","bug"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 13L10.2 11L11.4 13L12.6 11L13.8 13L15 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "error-med-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["error","warning","alert","issue","problem","notification","system-error","network-error","connection-error","unavailable","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM15.8576 11.5144C16.1418 11.0408 15.9882 10.4266 15.5146 10.1424C15.0411 9.85827 14.4268 10.0118 14.1427 10.4854L13.8002 11.0563L13.4576 10.4854C13.2769 10.1842 12.9514 9.99991 12.6002 9.99991C12.2489 9.99991 11.9234 10.1842 11.7427 10.4854L11.4002 11.0563L11.0576 10.4854C10.8769 10.1842 10.5514 9.99991 10.2002 9.99991C9.84889 9.99991 9.52338 10.1842 9.34266 10.4854L8.14266 12.4854C7.85851 12.959 8.01207 13.5733 8.48566 13.8574C8.95924 14.1415 9.5735 13.988 9.85764 13.5144L10.2002 12.9436L10.5427 13.5144C10.7234 13.8156 11.0489 13.9999 11.4002 13.9999C11.7514 13.9999 12.0769 13.8156 12.2576 13.5144L12.6002 12.9436L12.9427 13.5144C13.1234 13.8156 13.4489 13.9999 13.8002 13.9999C14.1514 13.9999 14.4769 13.8156 14.6576 13.5144L15.8576 11.5144Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "error-med": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","notification","issue","problem","caution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 13L10.2 11L11.4 13L12.6 11L13.8 13L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    error: {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","notification","issue","problem","caution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L12 13M12 9.9658L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.7713 6.21973C13.9949 6.54488 14.8595 8.08198 16.5887 11.1562C18.2603 14.128 19.0961 15.6139 18.76 16.8114C18.6211 17.3062 18.3574 17.7571 17.9942 18.1207C17.1153 19.0007 15.4105 19.0007 12.0008 19.0007C8.59091 19.0007 6.88597 19.0007 6.00707 18.1207C5.64387 17.757 5.3802 17.3061 5.24132 16.8113C4.90525 15.6138 5.74116 14.1279 7.41297 11.156C9.14229 8.08184 10.007 6.54478 11.2306 6.2197C11.7354 6.08558 12.2665 6.08559 12.7713 6.21973Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "euro-coin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["euro","coin","currency","money","payment","cash","europe","price","cost","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 8.46713C14.4285 8.16897 13.776 8 13.0833 8C10.8282 8 9 9.79086 9 12C9 14.2091 10.8282 16 13.0833 16C13.776 16 14.4285 15.831 15 15.5329"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9H10M10 13H9H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "euro-coin-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["euro","money","currency","payment","price","cash","europe","cost","balance","refund","change","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8.46713C14.4285 8.16897 13.776 8 13.0833 8C10.8282 8 9 9.79086 9 12C9 14.2091 10.8282 16 13.0833 16C13.776 16 14.4285 15.831 15 15.5329"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9H10M10 13H9H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "euro-coin": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","coin","currency","money","payment","cash","change","price","europe","euro-coin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 8.46713C14.4285 8.16897 13.776 8 13.0833 8C10.8282 8 9 9.79086 9 12C9 14.2091 10.8282 16 13.0833 16C13.776 16 14.4285 15.831 15 15.5329"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11H9H10M10 13H9H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "euro-symbol-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["euro","currency","payment","price","europe","money","cash","symbol","balance","amount","value","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16.1991C16.9412 17.3105 15.4656 18 13.8333 18C10.6117 18 8 15.3137 8 12C8 8.68629 10.6117 6 13.8333 6C15.4656 6 16.9412 6.68954 18 7.80087"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10H8.5H11M11 14H8.5H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "euro-coin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","coin","currency","money","payment","cash","change","price","europe","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM8.25655 11.75C8.2522 11.8328 8.25 11.9161 8.25 12C8.25 12.0839 8.2522 12.1672 8.25655 12.25H8C7.58579 12.25 7.25 12.5858 7.25 13C7.25 13.4142 7.58579 13.75 8 13.75H8.58804C9.29891 15.513 11.0517 16.75 13.0833 16.75C13.8992 16.75 14.6704 16.5508 15.3469 16.1978C15.7141 16.0062 15.8565 15.5532 15.665 15.186C15.4734 14.8187 15.0203 14.6763 14.6531 14.8679C14.1866 15.1113 13.6529 15.25 13.0833 15.25C11.8783 15.25 10.8327 14.6303 10.2476 13.7082C10.5401 13.6059 10.75 13.3275 10.75 13C10.75 12.5858 10.4142 12.25 10 12.25H9.75977C9.75329 12.1674 9.75 12.0841 9.75 12C9.75 11.9159 9.75329 11.8326 9.75977 11.75H10C10.4142 11.75 10.75 11.4142 10.75 11C10.75 10.6725 10.5401 10.3941 10.2476 10.2918C10.8327 9.36971 11.8783 8.75 13.0833 8.75C13.6529 8.75 14.1866 8.8887 14.6531 9.13208C15.0203 9.32367 15.4734 9.18128 15.665 8.81403C15.8565 8.44679 15.7141 7.99377 15.3469 7.80218C14.6704 7.44924 13.8992 7.25 13.0833 7.25C11.0517 7.25 9.29891 8.48702 8.58804 10.25H8C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75H8.25655Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "euro-symbol-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","currency","money","payment","price","cost","sale","europe","european-union","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.65856 9C8.75142 6.6436 11.0929 5 13.8333 5C15.7547 5 17.4875 5.81321 18.724 7.1111C19.105 7.51096 19.0896 8.14394 18.6898 8.52489C18.2899 8.90585 17.6569 8.89052 17.276 8.49065C16.3949 7.56588 15.1764 7 13.8333 7C12.2627 7 10.852 7.78107 9.96573 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H9.09625C9.03316 11.3226 9 11.6569 9 12C9 12.3431 9.03316 12.6774 9.09625 13H11C11.5523 13 12 13.4477 12 14C12 14.5523 11.5523 15 11 15H9.96573C10.852 16.2189 12.2627 17 13.8333 17C15.1764 17 16.395 16.4341 17.276 15.5094C17.6569 15.1095 18.2899 15.0942 18.6898 15.4751C19.0896 15.8561 19.105 16.489 18.724 16.8889C17.4875 18.1868 15.7547 19 13.8333 19C11.0929 19 8.75142 17.3564 7.65856 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H7.06946C7.02368 12.6731 7 12.3392 7 12C7 11.6608 7.02368 11.3269 7.06946 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H7.65856Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "euro-symbol-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["euro","currency","money","price","payment","europe","cash","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16.1991C16.9412 17.3105 15.4656 18 13.8333 18C10.6117 18 8 15.3137 8 12C8 8.68629 10.6117 6 13.8333 6C15.4656 6 16.9412 6.68954 18 7.80087"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10H8.5H11M11 14H8.5H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "euro-symbol": {
        defaultColors: ["#3D4C66"],
        keywords: ["euro","currency","money","payment","price","cost","value","sale","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16.1991C16.9412 17.3105 15.4656 18 13.8333 18C10.6117 18 8 15.3137 8 12C8 8.68629 10.6117 6 13.8333 6C15.4656 6 16.9412 6.68954 18 7.80087"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10H8.5H11M11 14H8.5H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ev-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["EV","event","events","voucher","e-voucher","electronic-voucher","coupon","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9H9C8.05719 9 7.58579 9 7.29289 9.29289C7 9.58579 7 10.0572 7 11V12M11 15H9C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13V12M7 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 9L15 15L17 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ev-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ev","initials","sales","reports","settings","configuration","user-profile","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9H9C8.05719 9 7.58579 9 7.29289 9.29289C7 9.58579 7 10.0572 7 11V12M11 15H9C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13V12M7 12H11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 9L15 15L17 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "ev-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ev","initials","name","customer","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4H9.92943C8.57535 3.99997 7.45868 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45868 2.99997 9.57527 3 10.9294V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92935 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V10.9295C21 9.57536 21.0001 8.45869 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4247 3.99997 14.0706 4ZM8.94561 8.00001L11 8.00002C11.5448 8.00002 11.9878 8.43559 11.9998 8.97746C12.009 8.56734 12.272 8.18852 12.6836 8.05134C13.2075 7.8767 13.7738 8.15986 13.9485 8.6838L14.9998 11.8378L16.0511 8.6838C16.2257 8.15986 16.7921 7.8767 17.316 8.05134C17.84 8.22599 18.1231 8.79231 17.9485 9.31626L15.9485 15.3163C15.8124 15.7246 15.4302 16 14.9998 16C14.5694 16 14.1872 15.7246 14.0511 15.3163L12.0511 9.31626C12.0186 9.21885 12.002 9.11998 11.9998 9.02244C11.9878 9.56437 11.5448 10 11 10H9.00002C8.50034 10 8.22618 10.0021 8.03599 10.0277L8.02871 10.0287L8.02771 10.036C8.00214 10.2262 8.00002 10.5003 8.00002 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H8.00002C8.00002 13.4997 8.00214 13.7738 8.02771 13.964L8.02871 13.9713L8.03599 13.9723C8.22618 13.9979 8.50034 14 9.00002 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16L8.9456 16C8.52154 16.0001 8.10941 16.0002 7.7695 15.9545C7.38629 15.903 6.94902 15.7774 6.5858 15.4142C6.22259 15.051 6.09706 14.6137 6.04554 14.2305C5.99984 13.8906 5.99992 13.4785 6.00001 13.0544V10.9456C5.99992 10.5215 5.99984 10.1094 6.04554 9.7695C6.09706 9.38629 6.22259 8.94902 6.5858 8.5858C6.94902 8.22259 7.38629 8.09706 7.7695 8.04554C8.10941 7.99984 8.52154 7.99992 8.94561 8.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    ev: {
        defaultColors: ["#3D4C66"],
        keywords: ["ev","initials","name","customer","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9H9C8.05719 9 7.58579 9 7.29289 9.29289C7 9.58579 7 10.0572 7 11V12M11 15H9C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13V12M7 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 9L15 15L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "event-list-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","view","options","menu","table","event","schedule","agenda"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2929 17.7071C15.5858 18 16.0572 18 17 18C17.9428 18 18.4142 18 18.7071 17.7071C19 17.4142 19 16.9428 19 16C19 15.0572 19 14.5858 18.7071 14.2929C18.4142 14 17.9428 14 17 14C16.0572 14 15.5858 14 15.2929 14.2929C15 14.5858 15 15.0572 15 16C15 16.9428 15 17.4142 15.2929 17.7071Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.2929 9.70711C15.5858 10 16.0572 10 17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6C16.0572 6 15.5858 6 15.2929 6.29289C15 6.58579 15 7.05719 15 8C15 8.94281 15 9.41421 15.2929 9.70711Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 8L5 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16L5 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "event-list-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","event","table","options","menu","view","items","record","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2929 17.7071C15.5858 18 16.0572 18 17 18C17.9428 18 18.4142 18 18.7071 17.7071C19 17.4142 19 16.9428 19 16C19 15.0572 19 14.5858 18.7071 14.2929C18.4142 14 17.9428 14 17 14C16.0572 14 15.5858 14 15.2929 14.2929C15 14.5858 15 15.0572 15 16C15 16.9428 15 17.4142 15.2929 17.7071Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.2929 9.70711C15.5858 10 16.0572 10 17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6C16.0572 6 15.5858 6 15.2929 6.29289C15 6.58579 15 7.05719 15 8C15 8.94281 15 9.41421 15.2929 9.70711Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 8L5 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16L5 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "event-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","details","order-details","item-details","event","events"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2929 17.7071C15.5858 18 16.0572 18 17 18C17.9428 18 18.4142 18 18.7071 17.7071C19 17.4142 19 16.9428 19 16C19 15.0572 19 14.5858 18.7071 14.2929C18.4142 14 17.9428 14 17 14C16.0572 14 15.5858 14 15.2929 14.2929C15 14.5858 15 15.0572 15 16C15 16.9428 15 17.4142 15.2929 17.7071Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.2929 9.70711C15.5858 10 16.0572 10 17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6C16.0572 6 15.5858 6 15.2929 6.29289C15 6.58579 15 7.05719 15 8C15 8.94281 15 9.41421 15.2929 9.70711Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 8L5 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16L5 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "event-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","options","menu","events","event-list","category","categorize","sort","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 5.00001L16.9456 5.00001C16.5215 4.99992 16.1094 4.99984 15.7695 5.04554C15.3863 5.09706 14.949 5.22259 14.5858 5.5858C14.2226 5.94902 14.0971 6.38629 14.0455 6.76949C13.9998 7.1094 13.9999 7.52151 14 7.94557V7.94558V7.94559V7.94561L14 8.00001L14 8.05442V8.05443V8.05445V8.05446C13.9999 8.47851 13.9998 8.89063 14.0455 9.23053C14.0971 9.61374 14.2226 10.051 14.5858 10.4142C14.949 10.7774 15.3863 10.903 15.7695 10.9545C16.1094 11.0002 16.5215 11.0001 16.9456 11H16.9456L17 11L17.0544 11H17.0544C17.4785 11.0001 17.8906 11.0002 18.2305 10.9545C18.6137 10.903 19.051 10.7774 19.4142 10.4142C19.7774 10.051 19.903 9.61374 19.9545 9.23053C20.0002 8.89062 20.0001 8.47849 20 8.05442L20 8.00001L20 7.9456C20.0001 7.52153 20.0002 7.10941 19.9545 6.7695C19.903 6.38629 19.7774 5.94902 19.4142 5.5858C19.051 5.22259 18.6137 5.09706 18.2305 5.04554C17.8906 4.99984 17.4785 4.99992 17.0544 5.00001L17 5.00001ZM17 13L16.9456 13H16.9456C16.5215 12.9999 16.1094 12.9998 15.7695 13.0455C15.3863 13.0971 14.949 13.2226 14.5858 13.5858C14.2226 13.949 14.0971 14.3863 14.0455 14.7695C13.9998 15.1094 13.9999 15.5215 14 15.9455V15.9456V15.9456V15.9456V15.9456V15.9456L14 16L14 16.0544V16.0544V16.0544V16.0545V16.0545V16.0545C13.9999 16.4785 13.9998 16.8906 14.0455 17.2305C14.0971 17.6137 14.2226 18.051 14.5858 18.4142C14.949 18.7774 15.3863 18.903 15.7695 18.9545C16.1094 19.0002 16.5215 19.0001 16.9456 19L17 19L17.0544 19C17.4785 19.0001 17.8906 19.0002 18.2305 18.9545C18.6137 18.903 19.051 18.7774 19.4142 18.4142C19.7774 18.051 19.903 17.6137 19.9545 17.2305C20.0002 16.8906 20.0001 16.4785 20 16.0544L20 16L20 15.9456C20.0001 15.5215 20.0002 15.1094 19.9545 14.7695C19.903 14.3863 19.7774 13.949 19.4142 13.5858C19.051 13.2226 18.6137 13.0971 18.2305 13.0455C17.8906 12.9998 17.4785 12.9999 17.0544 13H17.0544L17 13ZM4 8C4 7.44772 4.44772 7 5 7L11 7C11.5523 7 12 7.44771 12 8C12 8.55228 11.5523 9 11 9L5 9C4.44772 9 4 8.55228 4 8ZM5 15C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17L11 17C11.5523 17 12 16.5523 12 16C12 15.4477 11.5523 15 11 15L5 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchange-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["exchange","transfer","swap","return","reverse","transaction","change","convert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchange-box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exchange","transfer","swap","arrows","trade","transaction","convert","return","refund","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.19108 5 6.78661 5 5.77772 5.67412C5.34096 5.96596 4.96596 6.34096 4.67412 6.77772C4 7.78661 4 9.19108 4 12C4 14.8089 4 16.2134 4.67412 17.2223C4.96596 17.659 5.34096 18.034 5.77772 18.3259C6.78661 19 8.19108 19 11 19H13C15.8089 19 17.2134 19 18.2223 18.3259C18.659 18.034 19.034 17.659 19.3259 17.2223C20 16.2134 20 14.8089 20 12C20 9.19108 20 7.78661 19.3259 6.77772C19.034 6.34096 18.659 5.96596 18.2223 5.67412C17.2134 5 15.8089 5 13 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchange-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exchange","swap","transfer","change","return","refund","replace","arrows","transaction","switch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchange-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","swap","transfer","change","convert","replace","arrows","transaction","refund","switch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13.3801 8.23983C12.9602 8.02988 12.4497 8.20008 12.2397 8.61996C12.1545 8.79045 12.1319 8.97589 12.1633 9.15009H8.99999C8.53054 9.15009 8.14999 9.53065 8.14999 10.0001C8.14999 10.4695 8.53054 10.8501 8.99999 10.8501H15C15.3942 10.8501 15.7367 10.579 15.8272 10.1954C15.9178 9.81171 15.7327 9.41612 15.3801 9.23983L13.3801 8.23983ZM15 14.8501L11.8367 14.8501C11.8681 15.0243 11.8455 15.2097 11.7602 15.3802C11.5503 15.8001 11.0397 15.9703 10.6199 15.7604L8.61985 14.7604C8.26726 14.5841 8.08215 14.1885 8.17272 13.8048C8.26329 13.4211 8.60577 13.1501 8.99999 13.1501H15C15.4694 13.1501 15.85 13.5306 15.85 14.0001C15.85 14.4695 15.4694 14.8501 15 14.8501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchange-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exchange","transfer","swap","arrows","return","refund","switch","change","convert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.19108 5 6.78661 5 5.77772 5.67412C5.34096 5.96596 4.96596 6.34096 4.67412 6.77772C4 7.78661 4 9.19108 4 12C4 14.8089 4 16.2134 4.67412 17.2223C4.96596 17.659 5.34096 18.034 5.77772 18.3259C6.78661 19 8.19108 19 11 19H13C15.8089 19 17.2134 19 18.2223 18.3259C18.659 18.034 19.034 17.659 19.3259 17.2223C20 16.2134 20 14.8089 20 12C20 9.19108 20 7.78661 19.3259 6.77772C19.034 6.34096 18.659 5.96596 18.2223 5.67412C17.2134 5 15.8089 5 13 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchange-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","transfer","swap","trade","switch","arrows","reverse","transaction","move","shift","convert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0539 4H10.9461C9.5874 3.99999 8.49174 3.99997 7.61265 4.0894C6.70523 4.18171 5.91829 4.3775 5.22215 4.84265C4.6762 5.20745 4.20745 5.6762 3.84265 6.22215C3.3775 6.91829 3.18171 7.70523 3.0894 8.61264C2.99997 9.49173 2.99999 10.5874 3 11.946V12.0539C2.99999 13.4126 2.99997 14.5083 3.0894 15.3874C3.18171 16.2948 3.37751 17.0817 3.84265 17.7779C4.20745 18.3238 4.6762 18.7926 5.22215 19.1573C5.91829 19.6225 6.70523 19.8183 7.61265 19.9106C8.49173 20 9.58735 20 10.946 20H13.054C14.4126 20 15.5083 20 16.3874 19.9106C17.2948 19.8183 18.0817 19.6225 18.7779 19.1573C19.3238 18.7926 19.7926 18.3238 20.1573 17.7779C20.6225 17.0817 20.8183 16.2948 20.9106 15.3874C21 14.5083 21 13.4126 21 12.054V11.946C21 10.5874 21 9.49172 20.9106 8.61264C20.8183 7.70523 20.6225 6.91829 20.1573 6.22215C19.7926 5.6762 19.3238 5.20745 18.7779 4.84265C18.0817 4.3775 17.2948 4.18171 16.3874 4.0894C15.5083 3.99997 14.4126 3.99999 13.0539 4ZM13.3801 8.23983C12.9602 8.02988 12.4497 8.20008 12.2397 8.61996C12.1545 8.79045 12.1319 8.97589 12.1633 9.15009H8.99999C8.53054 9.15009 8.14999 9.53065 8.14999 10.0001C8.14999 10.4695 8.53054 10.8501 8.99999 10.8501H15C15.3942 10.8501 15.7367 10.579 15.8272 10.1954C15.9178 9.81171 15.7327 9.41612 15.3801 9.23983L13.3801 8.23983ZM15 14.8501L11.8367 14.8501C11.8681 15.0243 11.8455 15.2097 11.7602 15.3802C11.5503 15.8001 11.0397 15.9703 10.6199 15.7604L8.61985 14.7604C8.26726 14.5841 8.08215 14.1885 8.17272 13.8048C8.2633 13.4211 8.60577 13.1501 8.99999 13.1501H15C15.4694 13.1501 15.85 13.5306 15.85 14.0001C15.85 14.4695 15.4694 14.8501 15 14.8501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchange-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","transfer","arrows","swap","return","refund","transaction","change","box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.19108 5 6.78661 5 5.77772 5.67412C5.34096 5.96596 4.96596 6.34096 4.67412 6.77772C4 7.78661 4 9.19108 4 12C4 14.8089 4 16.2134 4.67412 17.2223C4.96596 17.659 5.34096 18.034 5.77772 18.3259C6.78661 19 8.19108 19 11 19H13C15.8089 19 17.2134 19 18.2223 18.3259C18.659 18.034 19.034 17.659 19.3259 17.2223C20 16.2134 20 14.8089 20 12C20 9.19108 20 7.78661 19.3259 6.77772C19.034 6.34096 18.659 5.96596 18.2223 5.67412C17.2134 5 15.8089 5 13 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    exchange: {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","transfer","arrows","swap","return","refund","transaction","change","box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 10H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 14L15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchnage-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","currency","exchange","money","transaction","transfer","refund","payment","change","cash-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14M4.25205 10C5.14017 6.54955 8.27251 4 12.0002 4C16.4185 4 20 7.58172 20 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "exchnage-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","dollar","money","currency","refund","transaction","transfer","payment","returns","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.4775 9.80078C4.45439 6.00545 7.89885 3.2002 12.0004 3.2002C16.8605 3.2002 20.8002 7.14011 20.8002 12.0002C20.8002 12.3238 20.6053 12.6155 20.3063 12.7393C20.0074 12.8631 19.6633 12.7947 19.4345 12.5659L17.4345 10.5659C17.1221 10.2535 17.1221 9.74693 17.4345 9.43451C17.7469 9.12209 18.2535 9.12209 18.5659 9.43451L18.8217 9.69034C17.8592 6.84688 15.1689 4.8002 12.0004 4.8002C8.64655 4.8002 5.82635 7.09404 5.02699 10.1996C4.91686 10.6275 4.48071 10.8851 4.05283 10.7749C3.62495 10.6648 3.36736 10.2287 3.4775 9.80078ZM11.5002 7.2002C11.942 7.2002 12.3002 7.55837 12.3002 8.0002V8.2002H13.0002C13.442 8.2002 13.8002 8.55837 13.8002 9.0002C13.8002 9.44202 13.442 9.8002 13.0002 9.8002H11.5002C11.1136 9.8002 10.8002 10.1136 10.8002 10.5002C10.8002 10.8868 11.1136 11.2002 11.5002 11.2002H12.3335C13.6145 11.2002 14.8002 12.1527 14.8002 13.5002C14.8002 14.8476 13.6145 15.8002 12.3335 15.8002H12.3002V16.0002C12.3002 16.442 11.942 16.8002 11.5002 16.8002C11.0584 16.8002 10.7002 16.442 10.7002 16.0002V15.8002H10.0002C9.55837 15.8002 9.2002 15.442 9.2002 15.0002C9.2002 14.5584 9.55837 14.2002 10.0002 14.2002H12.3335C12.8935 14.2002 13.2002 13.8096 13.2002 13.5002C13.2002 13.1908 12.8935 12.8002 12.3335 12.8002H11.5002C10.2299 12.8002 9.2002 11.7705 9.2002 10.5002C9.2002 9.51126 9.82434 8.6681 10.7002 8.34314V8.0002C10.7002 7.55837 11.0584 7.2002 11.5002 7.2002ZM3.69405 11.2611C3.99299 11.1373 4.33708 11.2057 4.56588 11.4345L6.56588 13.4345C6.8783 13.7469 6.8783 14.2535 6.56588 14.5659C6.25346 14.8783 5.74693 14.8783 5.43451 14.5659L5.17875 14.3101C6.14132 17.1535 8.83188 19.2002 12.0004 19.2002C15.3542 19.2002 18.1741 16.9064 18.9733 13.8008C19.0834 13.3729 19.5196 13.1153 19.9475 13.2254C20.3753 13.3356 20.6329 13.7717 20.5228 14.1996C19.546 17.9949 16.1019 20.8002 12.0004 20.8002C7.1403 20.8002 3.2002 16.8603 3.2002 12.0002C3.2002 11.6766 3.39511 11.3849 3.69405 11.2611Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchnage-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exchange","dollar","currency","money","transaction","payment","refund","returns","cashback","transfer","convert","currency-exchange","money-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14M4.25205 10C5.14017 6.54955 8.27251 4 12.0002 4C16.4185 4 20 7.58172 20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "exchnage-funds-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exchange","funds","payment","transaction","currency","arrows","circular","reload","refresh","return","transfer","cash-flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.25195 10C5.14008 6.54955 8.27241 4 12.0001 4C16.4184 4 19.9999 7.58172 19.9999 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L13 13L11 11L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchnage-funds-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","funds","transfer","payment","arrows","circle","transaction","money","currency","refund","return","swap"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.42927 9.78802C4.41171 5.97113 7.87568 3.1499 12.0006 3.1499C16.8883 3.1499 20.8504 7.11221 20.8504 11.9999C20.8504 12.3437 20.6433 12.6536 20.3257 12.7852C20.008 12.9168 19.6424 12.844 19.3993 12.6009L17.3994 10.6009C17.0674 10.269 17.0674 9.73081 17.3994 9.39886C17.7313 9.06691 18.2695 9.06692 18.6014 9.39886L18.7004 9.49784C17.6862 6.78298 15.0692 4.8499 12.0006 4.8499C8.67011 4.8499 5.86942 7.12776 5.07561 10.2118C4.95859 10.6664 4.49518 10.9401 4.04056 10.8231C3.58594 10.7061 3.31225 10.2426 3.42927 9.78802ZM10.3993 10.3989C10.7313 10.0669 11.2695 10.0669 11.6014 10.3989L13.0004 11.7978L14.3994 10.3989C14.7313 10.0669 15.2695 10.0669 15.6014 10.3989C15.9334 10.7308 15.9334 11.269 15.6014 11.6009L13.6014 13.6009C13.2695 13.9329 12.7313 13.9329 12.3994 13.6009L11.0004 12.202L9.60143 13.6009C9.26949 13.9329 8.7313 13.9329 8.39935 13.6009C8.0674 13.269 8.0674 12.7308 8.39935 12.3989L10.3993 10.3989ZM3.67511 11.2146C3.99273 11.083 4.35833 11.1558 4.60143 11.3989L6.60143 13.3989C6.93338 13.7308 6.93338 14.269 6.60143 14.6009C6.26949 14.9329 5.7313 14.9329 5.39935 14.6009L5.30045 14.502C6.3148 17.2168 8.93199 19.1499 12.0006 19.1499C15.331 19.1499 18.1314 16.8721 18.9251 13.788C19.0421 13.3334 19.5055 13.0597 19.9601 13.1767C20.4147 13.2937 20.6884 13.7571 20.5714 14.2118C19.5891 18.0286 16.1255 20.8499 12.0006 20.8499C7.11288 20.8499 3.15039 16.8876 3.15039 11.9999C3.15039 11.6561 3.35749 11.3462 3.67511 11.2146Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchnage-funds": {
        defaultColors: ["#3D4C66"],
        keywords: ["exchange","funds","cycle","arrows","payment","transaction","currency","transfer","refresh","sync","circulation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14M4.25205 10C5.14017 6.54955 8.27251 4 12.0002 4C16.4185 4 20 7.58172 20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L13 13L11 11L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exchnage-funds-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exchange","funds","arrows","circle","transaction","payment","transfer","money","currency","rotation","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14M4.25205 10C5.14017 6.54955 8.27251 4 12.0002 4C16.4185 4 20 7.58172 20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L13 13L11 11L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Exit-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["exit","logout","sign-out","leave","arrow","right","return","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L15 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 10L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 8V7V7C15 5.89543 14.1046 5 13 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13C14.1046 19 15 18.1046 15 17V17V16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Exit-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exit","logout","sign-out","arrow","right","leave","return","back","logout-user","exit-session"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L15 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 10L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 8V7V7C15 5.89543 14.1046 5 13 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13C14.1046 19 15 18.1046 15 17V17V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Exit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["exit","logout","sign-out","leave","arrow","right","end-session","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7071 11.2929C19.7191 11.3049 19.7307 11.3171 19.742 11.3295C19.8207 11.4165 19.8814 11.514 19.9241 11.6172C19.97 11.7278 19.9965 11.8483 19.9997 11.9747C19.9999 11.9831 20 11.9915 20 12C20 12.1364 19.9727 12.2664 19.9232 12.3849C19.8745 12.5021 19.8024 12.6118 19.7071 12.7071L19.705 12.7092L17.7071 14.7071C17.3166 15.0976 16.6834 15.0976 16.2929 14.7071C15.9024 14.3166 15.9024 13.6834 16.2929 13.2929L16.5858 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11H16.5858L16.2929 10.7071C15.9024 10.3166 15.9024 9.68342 16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289L19.7071 11.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93417 4C8.95604 4 8.97799 4 9 4H13C14.6569 4 16 5.34315 16 7V8C16 8.55229 15.5523 9 15 9C14.4477 9 14 8.55229 14 8V7C14 6.44772 13.5523 6 13 6H9C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6 8.02893 6 9V15C6 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9 18H13C13.5523 18 14 17.5523 14 17V16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16V17C16 18.6569 14.6569 20 13 20L8.93417 20C8.04769 20.0001 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 9C4 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exchnage-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","exchange","currency-exchange","money","transaction","transfer","payment","refund","cash-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58191 20 12.0002 20C15.7279 20 18.8599 17.4505 19.7479 14M4.25205 10C5.14017 6.54955 8.27251 4 12.0002 4C16.4185 4 20 7.58172 20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Exit-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["exit","logout","sign-out","arrow","right","return","back","leave","close-session"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 12L15 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Exit-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["exit","logout","sign-out","arrow","right","leave","return","back","end-session","close","quit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 12L15 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Exit-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exit","logout","sign-out","arrow","right","leave","back","return","end-session","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 12L15 12L19 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8L19 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16L19 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "exit-picture-in-picture-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minimize","shrink","reduce","contract","collapse","hide","arrow-down","arrow-left","exit-fullscreen","decrease","detach","go-back","return","fold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V13H6C7.88562 13 8.82843 13 9.41421 13.5858C10 14.1716 10 15.1144 10 17V19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12V9.33333M13 12H15.6667M13 12L17 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exit-picture-in-picture-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["minimize","shrink","arrow","window","screen","exit","down","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13H6C7.88562 13 8.82843 13 9.41421 13.5858C10 14.1716 10 15.1144 10 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12V9.33333M13 12H15.6667M13 12L17 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "exit-picture-in-picture": {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","shrink","reduce","decrease","collapse","picture-in-picture","exit-fullscreen","down","arrow-down","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13H6C7.88562 13 8.82843 13 9.41421 13.5858C10 14.1716 10 15.1144 10 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12V9.33333M13 12H15.6667M13 12L17 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Exit-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["exit","logout","sign-out","arrow","leave","end-session","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4L12 4C12.5523 4 13 4.44772 13 5C13 5.55229 12.5523 6 12 6H11C9.55752 6 8.57625 6.00213 7.84143 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84143C6.00213 8.57625 6 9.55752 6 11V13C6 14.4425 6.00213 15.4238 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H12C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.4587 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C8.4587 3.99994 9.57531 3.99997 10.9294 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.7071 12.7071L15.7071 16.7071C15.3166 17.0976 14.6834 17.0976 14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929L16.5858 13L9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11L16.5858 11L14.2929 8.70711C13.9024 8.31658 13.9024 7.68342 14.2929 7.2929C14.6834 6.90237 15.3166 6.90237 15.7071 7.2929L19.7061 11.2919C19.7093 11.2951 19.7125 11.2983 19.7156 11.3015C19.8916 11.4818 20 11.7282 20 12C20 12.1356 19.973 12.2649 19.9241 12.3828C19.8753 12.5007 19.803 12.6112 19.7071 12.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "exit-picture-in-picture-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shrink","minimize","collapse","reduce","import","transfer","download","move","box","arrow","down","import-data","reduce-size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.57494 4.11876C7.45869 3.99994 8.57533 3.99997 9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45868 21 9.5753 21 10.9294V13.0706C21 14.4247 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0706 20H9.92943C8.57531 20 7.4587 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99997 9.57529 2.99994 8.45869 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876ZM5.58579 6.58579C5.80836 6.36322 6.13538 6.19585 6.84144 6.10092C7.57626 6.00213 8.55752 6 10 6H14C15.4425 6 16.4238 6.00213 17.1586 6.10092C17.8646 6.19585 18.1916 6.36322 18.4142 6.58579C18.6368 6.80836 18.8042 7.13538 18.8991 7.84144C18.9979 8.57626 19 9.55752 19 11V13C19 14.4425 18.9979 15.4238 18.8991 16.1586C18.8042 16.8646 18.6368 17.1916 18.4142 17.4142C18.1916 17.6368 17.8646 17.8042 17.1586 17.8991C16.4238 17.9979 15.4425 18 14 18H11L11 16.9342C11.0001 16.0477 11.0001 15.2839 10.9179 14.6722C10.8297 14.0167 10.631 13.3883 10.1213 12.8787C9.61166 12.369 8.98331 12.1703 8.32779 12.0821C7.71613 11.9999 6.95232 12 6.06583 12L5 12V11C5 9.55752 5.00213 8.57626 5.10092 7.84144C5.19585 7.13538 5.36322 6.80836 5.58579 6.58579Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7071 7.2929C18.0976 7.68342 18.0976 8.31659 17.7071 8.70711L15.4142 11H15.6667C16.219 11 16.6667 11.4477 16.6667 12C16.6667 12.5523 16.219 13 15.6667 13H13C12.4477 13 12 12.5523 12 12V9.33334C12 8.78105 12.4477 8.33334 13 8.33334C13.5523 8.33334 14 8.78105 14 9.33334V9.58579L16.2929 7.2929C16.6834 6.90237 17.3166 6.90237 17.7071 7.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Exit: {
        defaultColors: ["#3D4C66"],
        keywords: ["shrink","minimize","collapse","reduce","import","transfer","download","move","box","arrow","down","import-data","reduce-size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L15 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 10L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 8V7V7C15 5.89543 14.1046 5 13 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H13C14.1046 19 15 18.1046 15 17V17V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "expand-content-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["expand","fullscreen","resize","enlarge","maximize","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5L18 5C18.5523 5 19 5.44772 19 6L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13L5 18C5 18.5523 5.44772 19 6 19L11 19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "expand-content-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","content","resize","fullscreen","expand-view","view-details","zoom"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C12 4.44772 12.4477 4 13 4L18 4C19.1046 4 20 4.89543 20 6V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V6L13 6C12.4477 6 12 5.55228 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 12C5.55229 12 6 12.4477 6 13L6 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H6C4.89543 20 4 19.1046 4 18L4 13C4 12.4477 4.44772 12 5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "expand-content-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["expand","fullscreen","maximize","resize","extend","open","enlarge","view-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5L18 5C18.5523 5 19 5.44772 19 6L19 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13L5 18C5 18.5523 5.44772 19 6 19L11 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "expand-wide-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","brackets","full-screen","enlarge","resize","widen","stretch","expand-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19L15 19C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15L19 9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5L14 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "expand-content": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","maximize","fullscreen","arrows-out","increase","enlarge","expand-content","view-details","zoom-in","open"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5L18 5C18.5523 5 19 5.44772 19 6L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13L5 18C5 18.5523 5.44772 19 6 19L11 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "expand-wide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["expand","full-screen","maximize","brackets","interface","layout","stretch","resize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19L15 19C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15L19 9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5L14 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "expand-wide": {
        defaultColors: ["#3D4C66"],
        keywords: ["bracket","brackets","separator","group","enclose","grouping","section","divide","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15L19 9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5L14 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "explict-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["E","edit","exemption","erase","error","employee","email","enter","expiration","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.8 19L12.2 19C14.8187 19 16.1281 19 17.09 18.4106C17.6282 18.0807 18.0807 17.6282 18.4106 17.09C19 16.1281 19 14.8187 19 12.2L19 11.8C19 9.18126 19 7.87189 18.4106 6.91001C18.0807 6.37179 17.6282 5.91926 17.09 5.58944C16.1281 5 14.8187 5 12.2 5L11.8 5C9.18126 5 7.87188 5 6.91 5.58944C6.37178 5.91926 5.91926 6.37178 5.58944 6.91001C5 7.87188 5 9.18126 5 11.8L5 12L5 12.2C5 14.8187 5 16.1281 5.58944 17.09C5.91926 17.6282 6.37178 18.0807 6.91 18.4106C7.87188 19 9.18125 19 11.8 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 15L11.7 15C11.0453 15 10.718 15 10.4775 14.8526C10.3429 14.7702 10.2298 14.6571 10.1474 14.5225C10 14.282 10 13.9547 10 13.3L10 12L10 10.7C10 10.0453 10 9.71797 10.1474 9.4775C10.2298 9.34295 10.3429 9.22982 10.4775 9.14736C10.718 9 11.0453 9 11.7 9L14 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "explict-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["E","edit","employee","enter","employee-menu","options","settings","employee-settings","employee-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 15L11.7 15C11.0453 15 10.718 15 10.4775 14.8526C10.3429 14.7702 10.2298 14.6571 10.1474 14.5225C10 14.282 10 13.9547 10 13.3L10 12L10 10.7C10 10.0453 10 9.71797 10.1474 9.4775C10.2298 9.34295 10.3429 9.22982 10.4775 9.14736C10.718 9 11.0453 9 11.7 9L14 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.8 19L12.2 19C14.8187 19 16.1281 19 17.09 18.4106C17.6282 18.0807 18.0807 17.6282 18.4106 17.09C19 16.1281 19 14.8187 19 12.2L19 11.8C19 9.18126 19 7.87189 18.4106 6.91001C18.0807 6.37179 17.6282 5.91926 17.09 5.58944C16.1281 5 14.8187 5 12.2 5L11.8 5C9.18126 5 7.87188 5 6.91 5.58944C6.37178 5.91926 5.91926 6.37178 5.58944 6.91001C5 7.87188 5 9.18126 5 11.8L5 12L5 12.2C5 14.8187 5 16.1281 5.58944 17.09C5.91926 17.6282 6.37178 18.0807 6.91 18.4106C7.87188 19 9.18125 19 11.8 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "expand-wide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["expand","wide","full-screen","resize","fullscreen","layout","display","maximize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93417 4C8.95604 4 8.97799 4.00001 9 4.00001H10C10.5523 4.00001 11 4.44772 11 5.00001C11 5.55229 10.5523 6.00001 10 6.00001H9C8.02893 6.00001 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6.00001 8.02893 6.00001 9.00001V15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20L8.93417 20C8.04769 20.0001 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 9.00001C4 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87869C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 20C15.044 20 15.022 20 15 20H14C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18H15C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15L18 9.00001C18 8.02893 17.9979 7.40121 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431C16.5988 6.00213 15.9711 6.00001 15 6.00001L14 6.00001C13.4477 6.00001 13 5.55229 13 5.00001C13 4.44772 13.4477 4 14 4L15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20.0001 8.04769 20 8.93417L20 15C20 15.022 20 15.044 20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "explict-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["E","letter","edit","employee","email","entry","expense","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2502 20H11.7498C10.4831 20 9.46141 20 8.63902 19.9218C7.7909 19.8412 7.05198 19.6704 6.38751 19.2632C5.71473 18.8509 5.14908 18.2853 4.7368 17.6125C4.32961 16.948 4.15881 16.2091 4.07817 15.361C3.99998 14.5386 3.99999 13.5169 4 12.2502V11.7497C3.99999 10.483 3.99998 9.46141 4.07817 8.63902C4.15881 7.7909 4.32961 7.05198 4.7368 6.38751C5.14908 5.71473 5.71473 5.14908 6.38751 4.7368C7.05198 4.32961 7.79091 4.15881 8.63903 4.07817C9.46142 3.99998 10.4831 3.99999 11.7498 4H12.2502C13.517 3.99999 14.5386 3.99998 15.361 4.07817C16.2091 4.15881 16.948 4.32961 17.6125 4.7368C18.2853 5.14908 18.8509 5.71473 19.2632 6.38751C19.6704 7.05198 19.8412 7.79091 19.9218 8.63903C20 9.46141 20 10.483 20 11.7498V12.2502C20 13.517 20 14.5386 19.9218 15.361C19.8412 16.2091 19.6704 16.948 19.2632 17.6125C18.8509 18.2853 18.2853 18.8509 17.6125 19.2632C16.948 19.6704 16.2091 19.8412 15.361 19.9218C14.5386 20 13.517 20 12.2502 20ZM11.0281 13.9861C11.1635 13.999 11.3533 14 11.7 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16L11.6626 16C11.3677 16.0001 11.0806 16.0001 10.8388 15.9771C10.5718 15.9517 10.2588 15.8914 9.95501 15.7053C9.6859 15.5404 9.45964 15.3141 9.29473 15.045C9.10858 14.7412 9.0483 14.4282 9.02292 14.1612C8.99992 13.9194 8.99996 13.6323 9 13.3374L9 10.6626C8.99996 10.3677 8.99992 10.0806 9.02292 9.83877C9.0483 9.57184 9.10858 9.25878 9.29473 8.95501C9.45964 8.6859 9.6859 8.45964 9.95501 8.29473C10.2588 8.10858 10.5718 8.0483 10.8388 8.02292C11.0806 7.99992 11.3677 7.99996 11.6626 8L14 8.00001C14.5523 8.00001 15 8.44772 15 9.00001C15 9.55229 14.5523 10 14 10H11.7C11.3533 10 11.1635 10.0011 11.0281 10.0139L11.0152 10.0152L11.0139 10.0281C11.0011 10.1635 11 10.3533 11 10.7V11L14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13L11 13V13.3C11 13.6467 11.0011 13.8365 11.0139 13.9719L11.0152 13.9848L11.0281 13.9861Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    explict: {
        defaultColors: ["#3D4C66"],
        keywords: ["E","letter","edit","employee","email","entry","expense","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 15L11.7 15C11.0453 15 10.718 15 10.4775 14.8526C10.3429 14.7702 10.2298 14.6571 10.1474 14.5225C10 14.282 10 13.9547 10 13.3L10 12L10 10.7C10 10.0453 10 9.71797 10.1474 9.4775C10.2298 9.34295 10.3429 9.22982 10.4775 9.14736C10.718 9 11.0453 9 11.7 9L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 12L10 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.8 19L12.2 19C14.8187 19 16.1281 19 17.09 18.4106C17.6282 18.0807 18.0807 17.6282 18.4106 17.09C19 16.1281 19 14.8187 19 12.2L19 11.8C19 9.18126 19 7.87189 18.4106 6.91001C18.0807 6.37179 17.6282 5.91926 17.09 5.58944C16.1281 5 14.8187 5 12.2 5L11.8 5C9.18126 5 7.87188 5 6.91 5.58944C6.37178 5.91926 5.91926 6.37178 5.58944 6.91001C5 7.87188 5 9.18126 5 11.8L5 12L5 12.2C5 14.8187 5 16.1281 5.58944 17.09C5.91926 17.6282 6.37178 18.0807 6.91 18.4106C7.87188 19 9.18125 19 11.8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Explore 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","explore","navigation","search","find","location","discovery","browse","categories","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["explore","compass","navigate","sales-trend","sales-analysis","location","map","discover","directions","metrics","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9487 9.31626C16.0685 8.95692 15.975 8.56075 15.7071 8.29292C15.4393 8.02509 15.0431 7.93157 14.6838 8.05134L10.1838 9.55134C9.88519 9.65088 9.65088 9.88519 9.55134 10.1838L8.05134 14.6838C7.93157 15.0431 8.02509 15.4393 8.29292 15.7071C8.56075 15.975 8.95692 16.0685 9.31626 15.9487L13.8163 14.4487C14.1149 14.3492 14.3492 14.1149 14.4487 13.8163L15.9487 9.31626ZM10.5812 13.4189L11.2906 11.2906L13.4189 10.5812L12.7095 12.7095L10.5812 13.4189Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.938C19.7122 14.8095 18.8817 16.432 17.6569 17.6569C16.432 18.8817 14.8095 19.7122 13 19.938V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C7.38128 19.4869 4.51314 16.6187 4.06189 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.06189C4.51314 7.38128 7.38128 4.51314 11 4.06189V4C11 3.44772 11.4477 3 12 3ZM12 7C11.4755 7 11.0452 6.59614 11.0033 6.0824C8.48814 6.5029 6.5029 8.48814 6.0824 11.0033C6.59614 11.0452 7 11.4755 7 12C7 12.5245 6.59614 12.9548 6.0824 12.9967C6.5029 15.5119 8.48814 17.4971 11.0033 17.9176C11.0452 17.4039 11.4755 17 12 17C12.5246 17 12.9548 17.4039 12.9967 17.9177C14.2541 17.7077 15.3785 17.1068 16.2426 16.2426C17.1068 15.3785 17.7077 14.2541 17.9177 12.9967C17.4039 12.9548 17 12.5246 17 12C17 11.4755 17.4039 11.0452 17.9176 11.0033C17.4971 8.48814 15.5119 6.5029 12.9967 6.0824C12.9548 6.59614 12.5245 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","explore","search","find","navigate","location","directions","browse","discovery","map","inventory","products","customers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["compass","navigation","explore","search","find","locate","direction","reporting","analytics","inventory-tracking","route","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["compass","explore","navigation","map","location","store-locator","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 6.34326L7.04988 7.05037"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 17.6567L7.04988 16.9496"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 17.6567L16.9501 16.9496"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 6.34326L16.9501 7.05037"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","navigation","direction","explore","map","location","find","discovery","wayfinding","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9976 5.07054C12.9614 5.58991 12.5286 6 12 6C11.4714 6 11.0386 5.58991 11.0024 5.07054C9.81464 5.24001 8.72296 5.70767 7.80563 6.39527C8.14693 6.78811 8.13077 7.38384 7.75714 7.75748C7.38352 8.13109 6.78783 8.14726 6.39498 7.80601C5.70754 8.72326 5.23999 9.81481 5.07054 11.0024C5.58991 11.0386 6 11.4714 6 12C6 12.5286 5.58991 12.9614 5.07054 12.9976C5.24 14.1853 5.70762 15.2769 6.39515 16.1942C6.788 15.8528 7.38381 15.869 7.75747 16.2426C8.13114 16.6163 8.14727 17.2121 7.80588 17.6049C8.72316 18.2924 9.81475 18.76 11.0024 18.9295C11.0386 18.4101 11.4714 18 12 18C12.5286 18 12.9614 18.4101 12.9976 18.9295C14.1854 18.76 15.277 18.2923 16.1944 17.6047C15.8531 17.2119 15.8692 16.6162 16.2429 16.2425C16.6165 15.8689 17.2122 15.8527 17.605 16.194C18.2925 15.2767 18.76 14.1852 18.9295 12.9976C18.4101 12.9614 18 12.5286 18 12C18 11.4714 18.4101 11.0386 18.9295 11.0024C18.76 9.81471 18.2924 8.72307 17.6048 7.80577C17.212 8.14718 16.6162 8.13105 16.2425 7.75738C15.8689 7.38372 15.8527 6.78792 16.1941 6.39508C15.2768 5.70758 14.1852 5.24 12.9976 5.07054ZM18.3734 18.3545C19.9965 16.7266 21 14.4805 21 12C21 7.02944 16.9706 3 12 3C9.51933 3 7.27306 4.00363 5.6451 5.62699L5.63582 5.63615L5.62661 5.64548C4.00347 7.27341 3 9.51952 3 12C3 16.9706 7.02944 21 12 21C14.4807 21 16.7269 19.9964 18.3549 18.373L18.3642 18.3638L18.3734 18.3545ZM15.9487 9.31626C16.0685 8.95692 15.975 8.56075 15.7071 8.29292C15.4393 8.02509 15.0431 7.93157 14.6838 8.05134L10.1838 9.55134C9.88519 9.65088 9.65088 9.88519 9.55134 10.1838L8.05134 14.6838C7.93157 15.0431 8.02509 15.4393 8.29292 15.7071C8.56075 15.975 8.95692 16.0685 9.31626 15.9487L13.8163 14.4487C14.1149 14.3492 14.3492 14.1149 14.4487 13.8163L15.9487 9.31626ZM10.5812 13.4189L11.2906 11.2906L13.4189 10.5812L12.7095 12.7095L10.5812 13.4189Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","explore","location","navigation","direction","find","search","map","settings","more","options","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 6.34326L7.04988 7.05037"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 17.6567L7.04988 16.9496"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 17.6567L16.9501 16.9496"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 6.34326L16.9501 7.05037"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","explore","search","navigate","find","location","discover","browse","directory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 6.34326L7.04988 7.05037"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.34277 17.6567L7.04988 16.9496"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 17.6567L16.9501 16.9496"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6572 6.34326L16.9501 7.05037"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","explore","navigation","direction","search","find","locations","tracking","store-locator","map","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["compass","explore","navigation","location","find","search","map","direction","browse","discovery","categories","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["explore","compass","navigation","search","find","discovery","browse","map","location","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 10L9 15L14 14M10 10L15 9L14 14M10 10L14 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","explore","navigation","location","map","search","find","browse","discover","direction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["explore","compass","navigation","settings","location","discovery","find","search","browse","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9487 9.31626C16.0685 8.95692 15.975 8.56075 15.7071 8.29292C15.4393 8.02509 15.0431 7.93157 14.6838 8.05134L10.1838 9.55134C9.88519 9.65088 9.65088 9.88519 9.55134 10.1838L8.05134 14.6838C7.93157 15.0431 8.02509 15.4393 8.29292 15.7071C8.56075 15.975 8.95692 16.0685 9.31626 15.9487L13.8163 14.4487C14.1149 14.3492 14.3492 14.1149 14.4487 13.8163L15.9487 9.31626ZM10.5812 13.4189L11.2906 11.2906L13.4189 10.5812L12.7095 12.7095L10.5812 13.4189Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.9976 5.07054C12.9614 5.58991 12.5286 6 12 6C11.4714 6 11.0386 5.58991 11.0024 5.07054C7.93478 5.50823 5.50823 7.93478 5.07054 11.0024C5.58991 11.0386 6 11.4714 6 12C6 12.5286 5.58991 12.9614 5.07054 12.9976C5.50823 16.0652 7.93478 18.4918 11.0024 18.9295C11.0386 18.4101 11.4714 18 12 18C12.5286 18 12.9614 18.4101 12.9976 18.9295C16.0652 18.4918 18.4918 16.0652 18.9295 12.9976C18.4101 12.9614 18 12.5286 18 12C18 11.4714 18.4101 11.0386 18.9295 11.0024C18.4918 7.93478 16.0652 5.50823 12.9976 5.07054Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore 5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["compass","explore","navigate","discover","location","map","search","browse","directory","find","categories","navigate-menu","site-map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 10L9 15L14 14M10 10L15 9L14 14M10 10L14 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","explore","navigation","location","map","directions","find","search","browse","discover","categories","products","services"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM15.7071 8.29291C15.9435 8.52933 16.0462 8.86827 15.9806 9.19613L14.9806 14.1961C14.9014 14.592 14.592 14.9014 14.1961 14.9806L9.19613 15.9806C8.86827 16.0462 8.52933 15.9435 8.29291 15.7071C8.05649 15.4707 7.95386 15.1318 8.01944 14.8039L9.01944 9.8039C9.09861 9.40804 9.40804 9.09861 9.8039 9.01944L14.8039 8.01944C15.1318 7.95386 15.4707 8.05649 15.7071 8.29291ZM11.9717 13.3859L10.6142 12.0284L10.2748 13.7253L11.9717 13.3859ZM12.0284 10.6142L13.3859 11.9717L13.7253 10.2748L12.0284 10.6142Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore 6-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["explore","compass","navigation","search","find","scan","discover"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12C13.7909 12 12 13.7909 12 16C12 13.7909 10.2091 12 8 12C10.2091 12 12 10.2091 12 8C12 10.2091 13.7909 12 16 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","navigation","direction","explore","location","map","find","search","discover"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 10L9 15L14 14M10 10L15 9L14 14M10 10L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore 6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["explore","target","focus","navigation","search","location","find","scan","selection","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 9.65685 9.65685 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C9.65685 13 11 14.3431 11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 14.3431 14.3431 13 16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C14.3431 11 13 9.65685 13 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM6 12C6 11.4714 5.58991 11.0386 5.07054 11.0024C5.50823 7.93478 7.93478 5.50823 11.0024 5.07054C11.0386 5.58991 11.4714 6 12 6C12.5286 6 12.9614 5.58991 12.9976 5.07054C16.0652 5.50823 18.4918 7.93478 18.9295 11.0024C18.4101 11.0386 18 11.4714 18 12C18 12.5286 18.4101 12.9614 18.9295 12.9976C18.4918 16.0652 16.0652 18.4918 12.9976 18.9295C12.9614 18.4101 12.5286 18 12 18C11.4714 18 11.0386 18.4101 11.0024 18.9295C7.93478 18.4918 5.50823 16.0652 5.07054 12.9976C5.58991 12.9614 6 12.5286 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore 6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["explore","search","find","target","compass","discovery","location","scan","navigate","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C12 13.7909 13.7909 12 16 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C12 13.7909 10.2091 12 8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8C12 10.2091 10.2091 12 8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8C12 10.2091 13.7909 12 16 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Explore 6": {
        defaultColors: ["#3D4C66"],
        keywords: ["explore","compass","location","find","search","discovery","navigation","map","target","focus","poi","store-locator","discover"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 20L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C12 13.7909 13.7909 12 16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C12 13.7909 10.2091 12 8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8C12 10.2091 10.2091 12 8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8C12 10.2091 13.7909 12 16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Explore-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["explore","compass","location","navigation","search","find","browse","discover","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12M12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12M12 19V18M5 12C5 8.13401 8.13401 5 12 5M5 12H6M19 12C19 8.13401 15.866 5 12 5M19 12H18M12 5V6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6V5V4M6 12H5H4M12 18V19V20M18 12H19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","explore","navigation","location","search","browse","discover","map","find","directory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12M12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12M12 19V18M12 19V20M5 12C5 8.13401 8.13401 5 12 5M5 12H6M5 12H4M19 12C19 8.13401 15.866 5 12 5M19 12H18M19 12H20M12 5V6M12 5V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","location","explore","navigation","direction","tracking","store-locator","find","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4551 9.65172C15.5599 9.3373 15.478 8.99066 15.2437 8.7563C15.0093 8.52195 14.6627 8.44012 14.3483 8.54493L10.4108 9.85742C10.1495 9.94451 9.94451 10.1495 9.85742 10.4108L8.54493 14.3483C8.44012 14.6627 8.52195 15.0093 8.7563 15.2437C8.99066 15.478 9.3373 15.5599 9.65172 15.4551L13.5892 14.1426C13.8505 14.0555 14.0555 13.8505 14.1426 13.5892L15.4551 9.65172Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.938C14.8095 19.7122 16.432 18.8817 17.6569 17.6569C18.8817 16.432 19.7122 14.8095 19.938 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V4ZM12.9967 6.0824C12.9548 6.59614 12.5245 7 12 7C11.4822 7 11.0564 6.6065 11.0052 6.10224L11.0033 6.0824C8.48814 6.5029 6.5029 8.48814 6.0824 11.0033C6.59613 11.0453 7 11.4755 7 12C7 12.5178 6.6065 12.9436 6.10224 12.9948L6.0824 12.9967C6.5029 15.5119 8.48814 17.4971 11.0033 17.9176C11.0452 17.4039 11.4755 17 12 17C12.5178 17 12.9436 17.3935 12.9948 17.8978L12.9967 17.9177C14.2541 17.7077 15.3785 17.1068 16.2426 16.2426C17.1068 15.3785 17.7077 14.2541 17.9177 12.9967C17.4039 12.9548 17 12.5246 17 12C17 11.4822 17.3935 11.0564 17.8978 11.0052L17.9176 11.0033C17.4971 8.48814 15.5119 6.5029 12.9967 6.0824Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Explore-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","location","explore","navigate","search","discovery","find","directions","map","browse","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["compass","explore","search","discover","navigation","find","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Explore: {
        defaultColors: ["#3D4C66"],
        keywords: ["compass","explore","search","discover","navigation","find","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C8.13401 19 5 15.866 5 12M12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12M12 19V18M12 19V20M5 12C5 8.13401 8.13401 5 12 5M5 12H6M5 12H4M19 12C19 8.13401 15.866 5 12 5M19 12H18M19 12H20M12 5V6M12 5V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Eye-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","visible","show","display","eye-icon","preview","observe","see","watch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C14.7095 16.9972 17.1317 15.3962 18.7405 12.8821C19.0865 12.3414 19.0865 11.6588 18.7405 11.1181C17.1317 8.60388 14.7095 7.00284 12 7C9.29051 7.00284 6.8683 8.60388 5.25948 11.1181C4.9135 11.6588 4.91351 12.3414 5.25949 12.8821C6.86831 15.3962 9.29052 16.9972 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Explore-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","navigation","map","store-locator","direction","explore","compass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5 13.5L15 9L10.5 10.5L9 15L13.5 13.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Explore-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["explore","compass","navigation","menu","discover","browse","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM15.9487 9.31623C16.0685 8.95689 15.9749 8.56073 15.7071 8.29289C15.4393 8.02506 15.0431 7.93154 14.6838 8.05132L10.1838 9.55132C9.88517 9.65085 9.65085 9.88517 9.55132 10.1838L8.05132 14.6838C7.93154 15.0431 8.02506 15.4393 8.29289 15.7071C8.56073 15.9749 8.95689 16.0685 9.31623 15.9487L13.8162 14.4487C14.1148 14.3491 14.3491 14.1148 14.4487 13.8162L15.9487 9.31623ZM11.2906 11.2906L10.5811 13.4189L12.7094 12.7094L13.4189 10.5811L11.2906 11.2906Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["eye","view","visibility","observe","look","hidden","show","password","visibility-settings","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","reveal","display","details","inspect","look-up","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V8.06447C9.80971 8.21787 8.69383 8.63953 7.68484 9.27063L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.09975 10.514C5.47105 11.1193 4.90623 11.8148 4.41717 12.5791C3.86094 13.4484 3.86094 14.5518 4.41719 15.4211C6.1608 18.1458 8.86721 19.9967 11.999 20H12.001C15.1328 19.9967 17.8392 18.1458 19.5828 15.4211C20.1391 14.5518 20.1391 13.4484 19.5828 12.5791C19.0938 11.8148 18.529 11.1193 17.9002 10.514L19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289C19.3166 6.90237 18.6834 6.90237 18.2929 7.29289L16.3152 9.27063C15.3062 8.63953 14.1903 8.21787 13 8.06447V5ZM9 14C9 12.3432 10.3431 11 12 11C13.6569 11 15 12.3432 15 14C15 15.6569 13.6568 17 12 17C10.3432 17 9 15.6569 9 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","observe","details","show","inspect","scan","browse","search","find","reveal","hidden","look","overview","monitor","preview","audit","track"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","display","observe","monitor","see","eye-12"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","show","see","details","observe","look","inspect","monitor","review","display","track","reporting","audit","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","details","see","observation","show","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.002 5C15.5657 5.00377 18.5623 7.12759 20.445 10.0945C21.185 11.2606 21.185 12.7396 20.445 13.9057C18.5623 16.8725 15.5656 18.9962 12.002 19H11.998C8.43439 18.9962 5.4377 16.8725 3.55501 13.9057C2.815 12.7396 2.815 11.2606 3.55499 10.0945C5.43766 7.12759 8.43434 5.00377 11.998 5L12.002 5ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3432 10.3431 9 12 9C13.6569 9 15 10.3432 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","visible","show","reveal","inspect","monitor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C15.866 17 19 14.7614 19 12.0001C19 9.23866 15.866 7 12 7C8.13401 7 5 9.23866 5 12.0001C5 14.7614 8.13401 17 12 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["eye","view","visibility","show","details","observe","display","reveal","monitor","track","inventory","item-details","order-details","customer-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C15.866 17 19 14.7614 19 12.0001C19 9.23866 15.866 7 12 7C8.13401 7 5 9.23866 5 12.0001C5 14.7614 8.13401 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","details","monitor","observe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.46901 7.65078C7.92391 6.61154 9.8826 6 12 6C14.1174 6 16.0761 6.61154 17.531 7.65078C18.984 8.68864 20 10.2126 20 12.0001C20 13.7875 18.984 15.3115 17.531 16.3493C16.0761 17.3885 14.1174 18 12 18C9.88261 18 7.92393 17.3885 6.46902 16.3493C5.01603 15.3114 4 13.7875 4 12.0001C4 10.2126 5.01602 8.68864 6.46901 7.65078ZM10 12C10 10.8955 10.8954 10 12 10C13.1046 10 14 10.8955 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM12 8C9.79084 8 8 9.79093 8 12C8 14.2092 9.79087 16 12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2092 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","display","reveal","details","preview","monitor","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C15.866 17 19 14.7614 19 12.0001C19 9.23866 15.866 7 12 7C8.13401 7 5 9.23866 5 12.0001C5 14.7614 8.13401 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","details","observe","monitor","display","show","reveal","inspect","look-up","search","customer","customer-data","review","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C14.7095 16.9972 17.1317 15.3962 18.7405 12.8821C19.0865 12.3414 19.0865 11.6588 18.7405 11.1181C17.1317 8.60388 14.7095 7.00284 12 7C9.29051 7.00284 6.8683 8.60388 5.25948 11.1181C4.9135 11.6588 4.91351 12.3414 5.25949 12.8821C6.86831 15.3962 9.29052 16.9972 12 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","preview","review","details","eye-20"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","details","order-details","see","hidden","invoice","transaction","customer-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8955 10.8954 10 12 10C12.5525 10 13.0512 10.2228 13.4142 10.5858C13.7772 10.9488 14 11.4475 14 12C14 13.1046 13.1046 14 12 14C11.4474 14 10.9488 13.7772 10.5858 13.4142C10.2228 13.0512 10 12.5526 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.002 5C15.2398 5.00391 17.8913 7.20285 19.5249 10.1448C20.1584 11.2858 20.1584 12.7144 19.5248 13.8554C17.8913 16.7973 15.2398 18.9961 12.002 19H11.998C8.7602 18.9961 6.1087 16.7973 4.47517 13.8554C3.84162 12.7144 3.84161 11.2858 4.47515 10.1448C6.10866 7.20285 8.76015 5.00391 11.998 5L12.002 5ZM12 8C9.79084 8 8 9.79093 8 12C8 13.1043 8.44881 14.1057 9.17157 14.8284C9.89433 15.5512 10.8957 16 12 16C14.2091 16 16 14.2092 16 12C16 10.8957 15.5512 9.89436 14.8284 9.17159C14.1057 8.44883 13.1043 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","hidden","password","show","hide","details","item-details","order-details","customer-details","employee-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-22": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","show","details","order-details","transaction-details","customer-details","product-details","inventory-details","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","details","overview","observe","monitor","track","search","lookup","find","audit","review","inspect","scan","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","show","display","see","preview","observe","details","item-details","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","details","reveal","inspect","monitor","track","observation","see","display","review","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-26": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","watch","observe","monitor","details","security","inventory","audit","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-29": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","show","display","details","overview","monitor","review","check","look","inspect","observation","scan","see","visible","viewable","hide","hidden"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","details","see","monitor","search","find","lookup","scan","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.11 9.22C16.53 8.01 14.36 7.25 12 7.25C9.64 7.25 7.47 8.01 5.89 9.22C4.31 10.43 3.25 12.13 3.25 14C3.25 15.87 4.31 17.57 5.89 18.78C7.47 19.99 9.64 20.75 12 20.75C14.36 20.75 16.53 19.99 18.11 18.78C19.69 17.57 20.75 15.87 20.75 14C20.75 12.13 19.69 10.43 18.11 9.22ZM12 17.25C10.21 17.25 8.75 15.79 8.75 14C8.75 12.21 10.21 10.75 12 10.75C13.79 10.75 15.25 12.21 15.25 14C15.25 15.79 13.79 17.25 12 17.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 6C12.55 6 13 5.55 13 5V3C13 2.45 12.55 2 12 2C11.45 2 11 2.45 11 3V5C11 5.55 11.45 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.79 7.71C5.18 8.1 5.81 8.1 6.2 7.71C6.59 7.32 6.59 6.69 6.2 6.3L5.2 5.3C4.81 4.91 4.18 4.91 3.79 5.3C3.4 5.69 3.4 6.32 3.79 6.71L4.79 7.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.21 7.71L20.21 6.71C20.6 6.32 20.6 5.69 20.21 5.3C19.82 4.91 19.19 4.91 18.8 5.3L17.8 6.3C17.41 6.69 17.41 7.32 17.8 7.71C18.19 8.1 18.82 8.1 19.21 7.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C11.45 12 11 12.45 11 13C11 13.55 11.45 14 12 14C12 14.55 12.45 15 13 15C13.55 15 14 14.55 14 14C14 12.9 13.1 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","visibility","view","details","show","observe","look","check","review","display","eye-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.999 6L12.001 6C15.1328 6.00328 17.8392 7.85426 19.5828 10.5791C20.1391 11.4484 20.1391 12.5518 19.5828 13.4211C17.8392 16.1458 15.1328 17.9967 12.001 18H11.999C8.86721 17.9967 6.1608 16.1458 4.41719 13.4211C3.86094 12.5518 3.86094 11.4484 4.41717 10.5791C6.16077 7.85426 8.86718 6.00328 11.999 6ZM9 12C9 10.3432 10.3431 9 12 9C13.6569 9 15 10.3432 15 12C15 13.6569 13.6568 15 12 15C10.3432 15 9 13.6569 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","details","review","overview","browse","scan","look-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.002 5C15.5657 5.00377 18.5623 7.12759 20.445 10.0945C21.185 11.2606 21.185 12.7396 20.445 13.9057C18.5623 16.8725 15.5656 18.9962 12.002 19H11.998C8.43439 18.9962 5.4377 16.8725 3.55501 13.9057C2.815 12.7396 2.815 11.2606 3.55499 10.0945C5.43766 7.12759 8.43434 5.00377 11.998 5L12.002 5ZM12 8C9.79084 8 8 9.79093 8 12C8 14.2092 9.79087 16 12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2092 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12C10 10.8955 10.8954 10 12 10C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-30": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","details","show","reveal","observe","eye-30"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","observe","security","privacy","monitoring","track","customer-view","analytics","insights"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C15.866 19 19 16.7614 19 14.0001C19 11.2387 15.866 9 12 9C8.13401 9 5 11.2387 5 14.0001C5 16.7614 8.13401 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["eye","view","visibility","preview","watch","observe","show","display","tracking","analytics","security","monitoring","eye-5"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C15.866 19 19 16.7614 19 14.0001C19 11.2387 15.866 9 12 9C8.13401 9 5 11.2387 5 14.0001C5 16.7614 8.13401 19 12 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["eye","visibility","view","details","review","inspection","security","watch","look-up","check","surveillance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C15.866 19 19 16.7614 19 14.0001C19 11.2387 15.866 9 12 9C8.13401 9 5 11.2387 5 14.0001C5 16.7614 8.13401 19 12 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["eye","view","visibility","hidden","details","see","observe","monitor","surveillance","watch","tracking","item-details","product-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-big-1": {
        defaultColors: ["#2797e8", "#3d4c66", "#FFFFFF"],
        keywords: ["eye","view","visibility","observe","watch","details","inventory","review","check","preview","inspection","surveillance","monitor","browse","records","scan","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_61756)">
                    <g filter="url(#filter0_d_1_61756)">
                        <path
                            d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                            stroke={colors?.[0] || "#2797E8"}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            shapeRendering="crispEdges"
                        />
                    </g>
                    <path
                        d="M12 19.9999C16.4183 19.9999 20 17.1563 20 14.0004C20 10.8445 16.4183 8.00098 12 8.00098C7.58172 8.00098 4 10.8445 4 14.0004C4 17.1563 7.58172 19.9999 12 19.9999Z"
                        stroke={colors?.[1] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                        stroke={colors?.[0] || "#2797E8"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_d_1_61756"
                        x="3.25"
                        y="7.25"
                        width="17.5"
                        height="17.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_61756" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_61756" result="shape" />
                    </filter>
                    <clipPath id="clip0_1_61756">
                        <rect width="24" height="24" fill={colors?.[2] || "#FFFFFF"} />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Eye-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","look","visibility","security","monitoring","inspection","audit","surveillance","observation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V8.04596C14.2921 8.16554 15.4999 8.51463 16.5381 9.04772L18.2929 7.29289C18.6834 6.90237 19.3166 6.90237 19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711L18.2114 10.2028C19.2914 11.1983 20 12.5073 20 14.0001C20 15.7875 18.984 17.3115 17.531 18.3493C16.0761 19.3885 14.1174 20 12 20C9.88261 20 7.92393 19.3885 6.46902 18.3493C5.01603 17.3114 4 15.7875 4 14.0001C4 12.5073 4.70861 11.1983 5.78856 10.2028L4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289C4.68342 6.90237 5.31658 6.90237 5.70711 7.29289L7.46193 9.04772C8.50009 8.51463 9.70791 8.16554 11 8.04596V5C11 4.44772 11.4477 4 12 4ZM9 14C9 12.3432 10.3431 11 12 11C13.6569 11 15 12.3432 15 14C15 15.6569 13.6568 17 12 17C10.3432 17 9 15.6569 9 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","show","observe","display","preview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10M19 8C19 8 18.4408 8.55918 17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-big-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","view","visibility","show","display","monitor","observe","review","details","overview"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19.9999C16.4183 19.9999 20 17.1563 20 14.0004C20 10.8445 16.4183 8.00098 12 8.00098C7.58172 8.00098 4 10.8445 4 14.0004C4 17.1563 7.58172 19.9999 12 19.9999Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-big-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","details","inspect","check","monitor","review","see","sales-data","analytics","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2C12.5523 2 13 2.44772 13 3V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V3C11 2.44772 11.4477 2 12 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.29289 5.29289C4.68342 4.90237 5.31658 4.90237 5.70711 5.29289L6.70711 6.29289C7.09763 6.68342 7.09763 7.31658 6.70711 7.70711C6.31658 8.09763 5.68342 8.09763 5.29289 7.70711L4.29289 6.70711C3.90237 6.31658 3.90237 5.68342 4.29289 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.2929 5.29289C18.6834 4.90237 19.3166 4.90237 19.7071 5.29289C20.0976 5.68342 20.0976 6.31658 19.7071 6.70711L18.7071 7.70711C18.3166 8.09763 17.6834 8.09763 17.2929 7.70711C16.9024 7.31658 16.9024 6.68342 17.2929 6.29289L18.2929 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.8652 7.00178C9.49961 7.03005 7.33601 7.80099 5.73629 9.02242C4.11418 10.2609 3 12.0287 3 14.0004C3 15.9721 4.11418 17.7399 5.73629 18.9784C7.36635 20.223 9.58187 20.9999 12 20.9999C14.4181 20.9999 16.6337 20.223 18.2637 18.9784C19.8858 17.7399 21 15.9721 21 14.0004C21 12.0287 19.8858 10.2609 18.2637 9.02242C16.664 7.80098 14.5004 7.03005 12.1348 7.00178C12.09 7.0006 12.0451 7 12 7C11.9549 7 11.91 7.0006 11.8652 7.00178ZM11.9057 9.00146C10.2925 9.05129 9 10.3748 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3748 13.7075 9.05129 12.0943 9.00146C12.0629 9.00114 12.0315 9.00098 12 9.00098C11.9685 9.00098 11.9371 9.00114 11.9057 9.00146Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-lasses-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["visibility","eye","view","settings","show","display","details","reveal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6M19 5C19 5 18.6141 5.38592 18 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18M5 19C5 19 5.38592 18.6141 6 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","preview","search","look-up","scan","eye-view","visibility-settings","see"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 0.5C12.5523 0.5 13 0.947715 13 1.5V3.5C13 4.05228 12.5523 4.5 12 4.5C11.4477 4.5 11 4.05228 11 3.5V1.5C11 0.947715 11.4477 0.5 12 0.5ZM4.29289 3.29289C4.68342 2.90237 5.31658 2.90237 5.70711 3.29289L6.70711 4.29289C7.09763 4.68342 7.09763 5.31658 6.70711 5.70711C6.31658 6.09763 5.68342 6.09763 5.29289 5.70711L4.29289 4.70711C3.90237 4.31658 3.90237 3.68342 4.29289 3.29289ZM19.7071 3.29289C20.0976 3.68342 20.0976 4.31658 19.7071 4.70711L18.7071 5.70711C18.3166 6.09763 17.6834 6.09763 17.2929 5.70711C16.9024 5.31658 16.9024 4.68342 17.2929 4.29289L18.2929 3.29289C18.6834 2.90237 19.3166 2.90237 19.7071 3.29289ZM17.2929 18.2929C17.6834 17.9024 18.3166 17.9024 18.7071 18.2929L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L17.2929 19.7071C16.9024 19.3166 16.9024 18.6834 17.2929 18.2929ZM6.70711 18.2929C7.09763 18.6834 7.09763 19.3166 6.70711 19.7071L5.70711 20.7071C5.31658 21.0976 4.68342 21.0976 4.29289 20.7071C3.90237 20.3166 3.90237 19.6834 4.29289 19.2929L5.29289 18.2929C5.68342 17.9024 6.31658 17.9024 6.70711 18.2929ZM12 19.5C12.5523 19.5 13 19.9477 13 20.5V22.5C13 23.0523 12.5523 23.5 12 23.5C11.4477 23.5 11 23.0523 11 22.5V20.5C11 19.9477 11.4477 19.5 12 19.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.888 7.22112C7.47248 6.01133 9.63412 5.25098 12 5.25098C14.3659 5.25098 16.5275 6.01133 18.112 7.22112C19.6905 8.42636 20.75 10.1272 20.75 12.0004C20.75 13.8737 19.6905 15.5745 18.112 16.7797C16.5275 17.9895 14.3659 18.7499 12 18.7499C9.63412 18.7499 7.47248 17.9895 5.888 16.7797C4.30949 15.5745 3.25 13.8737 3.25 12.0004C3.25 10.1272 4.30949 8.42636 5.888 7.22112ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3432 10.3431 9 12 9C13.6569 9 15 10.3432 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-lasses-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["eye","view","visibility","observe","hidden","details","look-up","search","scan","inspect","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6M19 5C19 5 18.6141 5.38592 18 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18M5 19C5 19 5.38592 18.6141 6 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-big": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","view","visibility","overview","details","inspect","observation","reporting","monitoring","eye-icon","show","display","scan","eye-scan","item-view","search","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19.9999C16.4183 19.9999 20 17.1563 20 14.0004C20 10.8445 16.4183 8.00098 12 8.00098C7.58172 8.00098 4 10.8445 4 14.0004C4 17.1563 7.58172 19.9999 12 19.9999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 18.6141 7.38592 18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["visibility-off","hide","invisible","obscure","private","privacy","do-not-show","mask"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 5C19 5 15.1141 8.88592 14.5 9.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 19C5 19 8.88592 15.1141 9.5 14.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hidden","visibility","disabled","eye","obscured","private","unavailable","invisibility","concealed","off","do-not-show"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6M19 5C19 5 15.1141 8.88592 14.5 9.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18M5 19C5 19 8.88593 15.1141 9.5 14.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","visibility","show","view","preview","search","magnify","look-up","details","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6M19 5C19 5 18.6141 5.38592 18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18M5 19C5 19 5.38592 18.6141 6 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["visibility","hidden","eye","slash","hide","obscure","conceal","disabled","view","not visible","access denied","restricted view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17.9999C16.4183 17.9999 20 15.1563 20 12.0004C20 8.84451 16.4183 6.00098 12 6.00098C7.58172 6.00098 4 8.84451 4 12.0004C4 15.1563 7.58172 17.9999 12 17.9999Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 2C12 2.51415 12 3.25357 12 4M5 5C5 5 5.38592 5.38592 6 6M19 5C19 5 15.1141 8.88592 14.5 9.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 22C12 21.4859 12 20.7464 12 20M19 19C19 19 18.6141 18.6141 18 18M5 19C5 19 8.88593 15.1141 9.5 14.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 9 12 9C10.3431 9 9 10.3432 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-lasses-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","eye","visibility","invisible","off","disabled","conceal","mask","private","obscure","block","restrict","anonymize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 1.5C13 0.947715 12.5523 0.5 12 0.5C11.4477 0.5 11 0.947715 11 1.5V3.5C11 4.05228 11.4477 4.5 12 4.5C12.5523 4.5 13 4.05228 13 3.5V1.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.29289 3.29289C4.68342 2.90237 5.31658 2.90237 5.70711 3.29289L6.70711 4.29289C7.09763 4.68342 7.09763 5.31658 6.70711 5.70711C6.31658 6.09763 5.68342 6.09763 5.29289 5.70711L4.29289 4.70711C3.90237 4.31658 3.90237 3.68342 4.29289 3.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 22.5C11 23.0523 11.4477 23.5 12 23.5C12.5523 23.5 13 23.0523 13 22.5V20.5C13 19.9477 12.5523 19.5 12 19.5C11.4477 19.5 11 19.9477 11 20.5L11 22.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L17.2929 19.7071C16.9024 19.3166 16.9024 18.6834 17.2929 18.2929C17.6834 17.9024 18.3166 17.9024 18.7071 18.2929L19.7071 19.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.7071 4.70711C21.0976 4.31658 21.0976 3.68342 20.7071 3.29289C20.3166 2.90237 19.6834 2.90237 19.2929 3.29289L16.393 6.1928C15.0977 5.59669 13.5953 5.25098 12 5.25098C9.63412 5.25098 7.47248 6.01133 5.888 7.22112C4.30949 8.42636 3.25 10.1272 3.25 12.0004C3.25 13.8553 4.2888 15.5411 5.84169 16.7441L3.29289 19.2929C2.90237 19.6834 2.90237 20.3166 3.29289 20.7071C3.68342 21.0976 4.31658 21.0976 4.70711 20.7071L7.60644 17.8078C8.90181 18.404 10.4045 18.7499 12 18.7499C14.3659 18.7499 16.5275 17.9895 18.112 16.7797C19.6905 15.5745 20.75 13.8737 20.75 12.0004C20.75 10.1454 19.711 8.45941 18.1578 7.25638L20.7071 4.70711ZM10.7066 14.7076C11.0982 14.895 11.5369 15 12 15C13.6569 15 15 13.6569 15 12C15 11.5369 14.895 11.0982 14.7076 10.7066L18.1578 7.25638L18.112 7.22112C17.5959 6.82709 17.0186 6.48073 16.393 6.1928L13.2934 9.29238C12.9018 9.10496 12.4631 9 12 9C10.3431 9 9 10.3432 9 12C9 12.4632 9.10495 12.9018 9.29237 13.2934L5.84169 16.7441L5.888 16.7797C6.40391 17.1736 6.98102 17.5199 7.60644 17.8078L10.7066 14.7076Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "eye-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hide","visibility","invisible","eye","slash","disable","security","obscure","mask","conceal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 8C19 8 15.4408 11.5592 14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 20.9998L10.8787 16.1211" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "eye-slash-13": {
        defaultColors: ["#3d4c66", "#7e47e1", "#000000"],
        keywords: ["hide","visibility","off","invisible","privacy","obscure","mask","blind"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M5 19L9 15M19 5L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 12C11 11.4477 11.4477 11 12 11" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Eye-slash-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","slash","hide","visibility","hidden","disable","private","obfuscate","mask","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 15.1141 10.8859 14.5 11.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.5 16.5C9.5 16.5 6.61408 19.3859 6 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-slash-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","eye","invisible","mask","disable","view","obscure","secret"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 3.5C13 2.94772 12.5523 2.5 12 2.5C11.4477 2.5 11 2.94772 11 3.5V5.5C11 6.05228 11.4477 6.5 12 6.5C12.5523 6.5 13 6.05228 13 5.5V3.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14C12 14.5523 12.4477 15 13 15C13.5523 15 14 14.5523 14 14C14 12.8955 13.1046 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.7071 5.29289C20.3166 4.90237 19.6834 4.90237 19.2929 5.29289L16.3923 8.19347C15.0972 7.59755 13.595 7.25195 12 7.25195C9.63412 7.25195 7.47248 8.01231 5.888 9.2221C4.30949 10.4273 3.25 12.1282 3.25 14.0014C3.25 15.8559 4.28838 17.5414 5.84074 18.7443L4.29289 20.2929C3.90237 20.6835 3.90237 21.3166 4.29289 21.7071C4.68342 22.0977 5.31658 22.0977 5.70711 21.7071L7.60516 19.8082C8.90083 20.4048 10.4039 20.7508 12 20.7508C14.3659 20.7508 16.5275 19.9905 18.112 18.7807C19.6905 17.5755 20.75 15.8746 20.75 14.0014C20.75 12.1461 19.7107 10.46 18.1573 9.25693L20.7071 6.70711C21.0976 6.31658 21.0976 5.68342 20.7071 5.29289ZM12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17C13.6568 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.20711 5.79289C4.81658 5.40237 4.18342 5.40237 3.79289 5.79289C3.40237 6.18342 3.40237 6.81658 3.79289 7.20711L4.79289 8.20711C5.18342 8.59763 5.81658 8.59763 6.20711 8.20711C6.59763 7.81658 6.59763 7.18342 6.20711 6.79289L5.20711 5.79289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "eye-slash-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","visibility","private","hidden","invisible","eye","eye-slash","mask","obscure","show","unshow","reveal","show-password","hide-password"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L9 15M19 5L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "eye-slash-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eye","slash","hide","invisible","privacy","hidden","masked","obfuscated","private","visibility","hide-item","hide-price","hide-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.999 6L12.001 6C15.1376 6.00331 17.8505 7.87215 19.6007 10.6303C20.1331 11.4693 20.1331 12.5309 19.6006 13.3699C17.8504 16.128 15.1375 17.9967 12.001 18H11.999C8.86245 17.9967 6.14956 16.128 4.39935 13.3699C3.86689 12.5309 3.86688 11.4693 4.39933 10.6303C6.14954 7.87215 8.86243 6.00331 11.999 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2092 16 12C16 9.79093 14.2091 8 12 8C9.79086 8 8 9.79093 8 12C8 14.2092 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L9 15M19 5L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "eye-slash-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","invisible","hidden","password","security","privacy","mask","obscure","off","disabled","reveal","sensitive-data","private","secret"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L16.1981 6.34034C14.9322 5.64886 13.518 5.2516 12.0017 5.25L11.9983 5.25C8.54136 5.25365 5.61563 7.31373 3.76607 10.2284C3.07797 11.3128 3.07797 12.6874 3.7661 13.7718C4.41311 14.7914 5.19192 15.7064 6.07911 16.4653L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L7.74117 17.626C9.02284 18.3382 10.4583 18.7484 11.9991 18.75H12.0017C15.4586 18.7464 18.3843 16.6864 20.2339 13.7718C20.922 12.6874 20.922 11.3128 20.2339 10.2284C19.576 9.19163 18.782 8.26298 17.8762 7.49656L19.7071 5.70711ZM11 13C11.5523 13 12 12.5523 12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C10.8954 10 10 10.8955 10 12C10 12.5523 10.4477 13 11 13ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.0671 13.933 8.5 12 8.5C10.067 8.5 8.5 10.0671 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-slash-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","invisible","visibility","hidden","private","eye-slash","obscure","mask","obfuscate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L9.87867 14.1213M19 5L14.1213 9.87869"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-slash-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hide","visibility","invisible","password","obscure","mask","private","privacy","conceal","off","disable","hidden"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L9.87867 14.1213M19 5L14.1213 9.87869"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "eye-slash-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["eye","slash","hide","visibility","invisible","obscure","private","security","hidden","mask"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 8C19 8 15.4408 11.5592 14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 20.9998L10.8787 16.1211" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Eye-slash-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hide","visibility","invisible","eye","slash","privacy","obscure","mask","security","do-not-show"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9992 6L12.0008 6C14.7454 6.00331 17.1192 7.87215 18.6506 10.6303C19.1165 11.4693 19.1165 12.5309 18.6506 13.3699C17.1191 16.128 14.7454 17.9967 12.0008 18H11.9992C9.25465 17.9967 6.88087 16.128 5.34943 13.3699C4.88353 12.5309 4.88352 11.4693 5.34942 10.6303C6.88084 7.87215 9.25463 6.00331 11.9992 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L9.87867 14.1213M19 5L14.1213 9.87869"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 11.1716 14.6642 10.4216 14.1213 9.87869C13.5784 9.33579 12.8284 9 12 9C10.3431 9 9 10.3432 9 12C9 12.8284 9.33578 13.5784 9.87867 14.1213C10.4216 14.6642 11.1716 15 12 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "eye-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["eye","slash","hide","invisible","hidden","obscure","privacy","security","disabled","off","blocked","restricted","view","show"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V7.06447C14.1903 7.21787 15.3062 7.63953 16.3152 8.27063L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L17.9002 9.51397C18.529 10.1193 19.0938 10.8148 19.5828 11.5791C20.1391 12.4484 20.1391 13.5518 19.5828 14.4211C17.8392 17.1458 15.1328 18.9967 12.001 19H11.999C10.9466 18.9989 9.94232 18.7892 9.00643 18.4078L6.70711 20.7071C6.31658 21.0976 5.68342 21.0976 5.29289 20.7071C4.90237 20.3166 4.90237 19.6834 5.29289 19.2929L7.18923 17.3966C6.11301 16.6227 5.17432 15.6043 4.41719 14.4211C3.86094 13.5518 3.86094 12.4484 4.41717 11.5791C4.90623 10.8148 5.47105 10.1193 6.09975 9.51397L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289C4.68342 5.90237 5.31658 5.90237 5.70711 6.29289L7.68484 8.27063C8.69383 7.63953 9.80971 7.21787 11 7.06447V4C11 3.44772 11.4477 3 12 3ZM9 13C9 11.3432 10.3431 10 12 10C12.7229 10 13.3862 10.2557 13.9041 10.6817C14.4417 11.1237 14.8229 11.7491 14.9519 12.4623C14.9835 12.6367 15 12.8165 15 13C15 14.6569 13.6568 16 12 16C11.8164 16 11.6367 15.9835 11.4623 15.9519C10.7491 15.8229 10.1237 15.4418 9.68165 14.9042C9.25572 14.3862 9 13.723 9 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-slash-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","eye","visibility","invisibility","obscure","mask","private","conceal","view","reveal","security","privacy","blind","secret"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 5.70711L17.7361 7.67811C18.4207 8.40133 19.0212 9.23775 19.5249 10.1448C20.1584 11.2858 20.1584 12.7144 19.5248 13.8554C17.8912 16.7974 15.2389 18.9961 12.0012 19H11.9988C10.4416 18.9981 9.01974 18.4885 7.78154 17.6327L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L6.26385 16.3219C5.57926 15.5988 4.9788 14.7624 4.47517 13.8554C3.84162 12.7144 3.84161 11.2858 4.47515 10.1448C6.10874 7.20271 8.7611 5.00391 11.9988 5L12.0012 5C13.5584 5.00188 14.9802 5.5115 16.2184 6.36736L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711ZM8 12C8 9.79093 9.79084 8 12 8C13.1043 8 14.1057 8.44883 14.8284 9.17159C15.5512 9.89436 16 10.8957 16 12C16 14.2092 14.2091 16 12 16C10.8957 16 9.89433 15.5512 9.17157 14.8284C8.44881 14.1057 8 13.1043 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 12C10 10.8955 10.8954 10 12 10C12.5525 10 13.0512 10.2228 13.4142 10.5858C13.7772 10.9488 14 11.4475 14 12C14 13.1046 13.1046 14 12 14C11.4474 14 10.9488 13.7772 10.5858 13.4142C10.2228 13.0512 10 12.5526 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Eye-slash-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","hidden","visibility","invisibility","eye","eye-slash","obscure","disable","mask","private","confidential","authentication","permissions","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 15.1141 10.8859 14.5 11.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.5 16.5C9.5 16.5 6.61408 19.3859 6 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Eye-slash-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hide","invisible","disable","visibility","conceal","mask","obfuscate","redact","private","privacy","eye-slash","view","not visible","hidden","mask data","hide details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20.0008C16.4183 20.0008 20 17.1573 20 14.0014C20 10.8455 16.4183 8.00195 12 8.00195C7.58172 8.00195 4 10.8455 4 14.0014C4 17.1573 7.58172 20.0008 12 20.0008Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C12 4.51415 12 5.25357 12 6M5 7C5 7 5.38592 7.38592 6 8M19 7C19 7 15.1141 10.8859 14.5 11.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.5 16.5C9.5 16.5 6.61408 19.3859 6 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3432 13.6569 11 12 11C10.3431 11 9 12.3432 9 14C9 15.6569 10.3431 17 12 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14C13 13.4477 12.5523 13 12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "eye-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["hide","invisible","hidden","disable","view","eye","security","privacy","mask"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C13.1046 16 14 15.1046 14 14C14 12.8955 13.1046 12 12 12C10.8954 12 10 12.8955 10 14C10 15.1046 10.8954 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 8.18198 12 6.23103 12 5M5 8C5 8 5.55918 8.55918 7 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 8C19 8 15.4408 11.5592 14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C14.7095 18.9972 17.1317 17.3962 18.7405 14.8821C19.0865 14.3414 19.0865 13.6588 18.7405 13.1181C17.1317 10.6039 14.7095 9.00284 12 9C9.29051 9.00284 6.8683 10.6039 5.25948 13.1181C4.9135 13.6588 4.91351 14.3414 5.25949 14.8821C6.86831 17.3962 9.29052 18.9972 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 20.9998L10.8787 16.1211" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "F-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["F","filter","find","featured","favorites","function"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "F-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["f","font","text","filter","find","search","fast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "F-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["F","letter-F","function","filter","format","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 4.00001C9.96372 4.00001 9.98186 4.00001 10 4.00001H16C16.5523 4.00001 17 4.44773 17 5.00001C17 5.5523 16.5523 6.00001 16 6.00001H10C9.50034 6.00001 9.22618 6.00214 9.03599 6.02771C9.03351 6.02804 9.03108 6.02837 9.02871 6.02871C9.02838 6.03108 9.02804 6.03351 9.02771 6.03599C9.00214 6.22618 9.00001 6.50034 9.00001 7.00001V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H9.00001V19C9.00001 19.5523 8.5523 20 8.00001 20C7.44773 20 7.00001 19.5523 7.00001 19V7.00001C7.00001 6.98186 7.00001 6.96372 7.00001 6.94561C6.99992 6.52154 6.99984 6.10941 7.04554 5.76949C7.09706 5.38629 7.22259 4.94902 7.5858 4.5858C7.94902 4.22259 8.38629 4.09706 8.76949 4.04554C9.10941 3.99984 9.52154 3.99992 9.94561 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Eye: {
        defaultColors: ["#3D4C66"],
        keywords: ["F","letter-F","function","filter","format","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C14.7095 16.9972 17.1317 15.3962 18.7405 12.8821C19.0865 12.3414 19.0865 11.6588 18.7405 11.1181C17.1317 8.60388 14.7095 7.00284 12 7C9.29051 7.00284 6.8683 8.60388 5.25948 11.1181C4.9135 11.6588 4.91351 12.3414 5.25949 12.8821C6.86831 15.3962 9.29052 16.9972 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    F: {
        defaultColors: ["#3D4C66"],
        keywords: ["F","letter-F","function","filter","format","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H10C9.05719 5 8.58579 5 8.29289 5.29289C8 5.58579 8 6.05719 8 7V12M16 12H8M8 12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "facebook-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["facebook","social media","login","connect","share","promotion","customer","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 17V11C11 10.07 11 9.60504 11.1022 9.22354C11.3796 8.18827 12.1883 7.37962 13.2235 7.10222C13.605 7 14.07 7 15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "facebook-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["facebook","social-media","connect","customer","loyalty","share","promotion","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 17V11C11 10.07 11 9.60504 11.1022 9.22354C11.3796 8.18827 12.1883 7.37962 13.2235 7.10222C13.605 7 14.07 7 15 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "facebook-circle-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["facebook","social-media","promotion","marketing","connect","share","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 15H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 19V13C11 12.07 11 11.605 11.1022 11.2235C11.3796 10.1883 12.1883 9.37962 13.2235 9.10222C13.605 9 14.07 9 15 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "facebook-circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["facebook","social-media","marketing","customer","loyalty","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 15H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 19V13C11 12.07 11 11.605 11.1022 11.2235C11.3796 10.1883 12.1883 9.37962 13.2235 9.10222C13.605 9 14.07 9 15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "facebook-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["facebook","social-media","connect","share","marketing","advertising","customer-engagement","loyalty","promotions","news","feed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 6.0001L14.8624 6.00005C14.067 5.99962 13.4764 5.9993 12.9647 6.13639C11.5844 6.50626 10.5062 7.58445 10.1363 8.96482C9.9992 9.47647 9.99952 10.0671 9.99995 10.8625L10 12.0001H9C8.44772 12.0001 8 12.4478 8 13.0001C8 13.5524 8.44772 14.0001 9 14.0001H10V17.0001C10 17.5524 10.4477 18.0001 11 18.0001C11.5523 18.0001 12 17.5524 12 17.0001V14.0001H13C13.5523 14.0001 14 13.5524 14 13.0001C14 12.4478 13.5523 12.0001 13 12.0001H12V11.0001C12 10.0057 12.0086 9.70474 12.0681 9.48246C12.2531 8.79227 12.7922 8.25318 13.4824 8.06824C13.7046 8.00869 14.0056 8.0001 15 8.0001C15.5523 8.0001 16 7.55238 16 7.0001C16 6.44781 15.5523 6.0001 15 6.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "facebook-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["facebook","social media","social","connect","share","customer","promotion","marketing","news","updates"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.2832 5.99207 19.8676 10.0001 20.777V16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H10.0001L10 12.8624C9.99962 12.067 9.9993 11.4763 10.1364 10.9647C10.5063 9.58433 11.5845 8.50614 12.9648 8.13627C13.4765 7.99917 14.0671 7.99949 14.8625 7.99993L15.0001 7.99997C15.5524 7.99997 16.0001 8.44769 16.0001 8.99997C16.0001 9.55226 15.5524 9.99997 15.0001 9.99997C14.0057 9.99997 13.7047 10.0086 13.4825 10.0681C12.7923 10.2531 12.2532 10.7922 12.0682 11.4823C12.0087 11.7046 12.0001 12.0056 12.0001 13V14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H12.0001V21C16.9706 20.9999 21 16.9705 21 12C21 7.02944 16.9706 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "facebook-circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["facebook","social media","customer","loyalty","marketing","promotion","share","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 19V13C11 12.07 11 11.605 11.1022 11.2235C11.3796 10.1883 12.1883 9.37962 13.2235 9.10222C13.605 9 14.07 9 15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    facebook: {
        defaultColors: ["#3D4C66"],
        keywords: ["facebook","social media","customer","loyalty","marketing","promotion","share","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 13H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 17.0001V11C11 10.0701 11 9.60513 11.1022 9.22363C11.3796 8.18835 12.1883 7.37971 13.2235 7.10231C13.605 7.00009 14.07 7.00009 15 7.00009V7.00009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "fahrenheit-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["temperature","fahrenheit","degree","weather","cooking","baking","temperature-setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18V8C13 7.05719 13 6.58579 13.2929 6.29289C13.5858 6 14.0572 6 15 6H19M19 12H13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" fill={colors?.[1] || "#3D4C66"} stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "fahrenheit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fahrenheit","temperature","hot","cold","weather","degree","measurement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9456 5.00001L19 5.00001C19.5523 5.00001 20 5.44773 20 6.00001C20 6.5523 19.5523 7.00001 19 7.00001H15C14.5003 7.00001 14.2262 7.00214 14.036 7.02771L14.0287 7.02871L14.0277 7.03599C14.0021 7.22618 14 7.50034 14 8.00001V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H14V18C14 18.5523 13.5523 19 13 19C12.4477 19 12 18.5523 12 18L12 7.94561C11.9999 7.52154 11.9998 7.10941 12.0455 6.76949C12.0971 6.38629 12.2226 5.94902 12.5858 5.5858C12.949 5.22259 13.3863 5.09706 13.7695 5.04554C14.1094 4.99984 14.5215 4.99992 14.9456 5.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 5C5.34315 5 4 6.34315 4 8C4 9.65685 5.34315 11 7 11C8.65685 11 10 9.65685 10 8C10 6.34315 8.65685 5 7 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "fahrenheit-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fahrenheit","temperature","weather","degree","hot","cold","climate","settings","measurement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18V8C13 7.05719 13 6.58579 13.2929 6.29289C13.5858 6 14.0572 6 15 6H19M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    fahrenheit: {
        defaultColors: ["#3D4C66"],
        keywords: ["fahrenheit","temperature","weather","degree","hot","cold","climate","settings","measurement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18V8C13 7.05719 13 6.58579 13.2929 6.29289C13.5858 6 14.0572 6 15 6H19M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="8" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "fast-charging-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fast","lightning","bolt","charge","charging","speed","quick","fast-charging","update","power","boost","accelerate","increase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H9.5M7 11.9993H9M8 15L9.5 14.9996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 13L14 8V11H17L14 16V13H11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "fast-charging-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fast","charging","speed","lightning","electricity","power","accelerate","boost","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 9H9.5M7 11.9993H9M8 15L9.5 14.9996"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 13L14 8V11H17L14 16V13H11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fast-charging": {
        defaultColors: ["#3D4C66"],
        keywords: ["fast","charge","electricity","power","speed","zap","battery","energy","lightning","boost","accelerate","efficiency","current","voltage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H9.5M7 11.9993H9M8 15L9.5 14.9996"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 13L14 8V11H17L14 16V13H11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Feed-1": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["receipt","invoice","bill","order","transaction","sale","history","record","report","print","document","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 6L20 12.2381C20 12.6589 19.6589 13 19.2381 13L16 13L16 9L16 5.5C16 5.22386 16.2239 5 16.5 5L19 5C19.5523 5 20 5.44772 20 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V11V16V16.8408C4 18.4211 4 19.2112 4.29964 19.6951C4.64258 20.2489 5.23371 20.601 5.88397 20.6387C6.45214 20.6718 7.14691 20.2954 8.53644 19.5428C9.03412 19.2732 9.28299 19.1384 9.54381 19.0773C9.84387 19.007 10.1561 19.007 10.4562 19.0773C10.717 19.1384 10.9659 19.2732 11.4636 19.5428L11.4636 19.5428C12.8531 20.2954 13.5479 20.6718 14.116 20.6387C14.7663 20.601 15.3574 20.2489 15.7004 19.6951C16 19.2112 16 18.4211 16 16.8408V9V5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16 5H16.75V4.25H16V5ZM8.53644 19.5428L8.89365 20.2022L8.53644 19.5428ZM9.54381 19.0773L9.71488 19.8075H9.71488L9.54381 19.0773ZM11.4636 19.5428L11.1063 20.2022L11.1172 20.2081L11.1282 20.2136L11.4636 19.5428ZM10.4562 19.0773L10.6273 18.3471V18.3471L10.4562 19.0773ZM11.4636 19.5428L11.8208 18.8833L11.81 18.8774L11.799 18.8719L11.4636 19.5428ZM14.116 20.6387L14.0725 19.89L14.0725 19.89L14.116 20.6387ZM15.7004 19.6951L15.0627 19.3002L15.7004 19.6951ZM4.29964 19.6951L4.93727 19.3002H4.93727L4.29964 19.6951ZM5.88397 20.6387L5.92748 19.89L5.92748 19.89L5.88397 20.6387ZM8 5.75H16V4.25H8V5.75ZM4.75 16V11H3.25V16H4.75ZM4.75 11V9H3.25V11H4.75ZM8 4.25C7.07839 4.25 6.31174 4.24841 5.70552 4.32991C5.07773 4.41432 4.51093 4.59999 4.05546 5.05546L5.11612 6.11612C5.24643 5.9858 5.44393 5.87858 5.90539 5.81654C6.38843 5.75159 7.03599 5.75 8 5.75V4.25ZM4.75 9C4.75 8.03599 4.75159 7.38843 4.81654 6.90539C4.87858 6.44393 4.9858 6.24643 5.11612 6.11612L4.05546 5.05546C3.59999 5.51093 3.41432 6.07773 3.32991 6.70552C3.24841 7.31174 3.25 8.07839 3.25 9H4.75ZM3.25 16V16.8408H4.75V16H3.25ZM16.75 16.8408V9H15.25V16.8408H16.75ZM8.89365 20.2022C9.42833 19.9126 9.57498 19.8403 9.71488 19.8075L9.37274 18.3471C8.99099 18.4365 8.63991 18.6338 8.17923 18.8833L8.89365 20.2022ZM11.8208 18.8833C11.3601 18.6337 11.009 18.4365 10.6273 18.3471L10.2851 19.8075C10.425 19.8403 10.5717 19.9126 11.1063 20.2022L11.8208 18.8833ZM9.71488 19.8075C9.90242 19.7636 10.0976 19.7636 10.2851 19.8075L10.6273 18.3471C10.2147 18.2504 9.78533 18.2504 9.37273 18.3471L9.71488 19.8075ZM11.1282 20.2136L11.1282 20.2136L11.799 18.8719L11.799 18.8719L11.1282 20.2136ZM11.1064 20.2022C11.7896 20.5723 12.3425 20.8725 12.7958 21.0719C13.2464 21.2701 13.695 21.4145 14.1595 21.3875L14.0725 19.89C13.9689 19.896 13.786 19.8687 13.3998 19.6989C13.0163 19.5302 12.5271 19.2659 11.8208 18.8833L11.1064 20.2022ZM15.25 16.8408C15.25 17.6441 15.2494 18.2001 15.2151 18.6177C15.1805 19.0382 15.1174 19.212 15.0627 19.3002L16.338 20.09C16.583 19.6944 16.6697 19.2312 16.71 18.7406C16.7506 18.247 16.75 17.6178 16.75 16.8408H15.25ZM14.1595 21.3875C15.0537 21.3355 15.8665 20.8514 16.338 20.09L15.0627 19.3002C14.8484 19.6463 14.4789 19.8664 14.0725 19.89L14.1595 21.3875ZM3.25 16.8408C3.25 17.6178 3.2494 18.247 3.28998 18.7406C3.33031 19.2312 3.41703 19.6944 3.662 20.09L4.93727 19.3002C4.88261 19.212 4.81951 19.0382 4.78493 18.6177C4.7506 18.2001 4.75 17.6441 4.75 16.8408H3.25ZM8.17923 18.8833C7.47293 19.2659 6.98371 19.5302 6.60022 19.6989C6.214 19.8687 6.03114 19.896 5.92748 19.89L5.84046 21.3875C6.30498 21.4145 6.75358 21.2701 7.20417 21.0719C7.65749 20.8725 8.21042 20.5723 8.89365 20.2022L8.17923 18.8833ZM3.662 20.09C4.13354 20.8514 4.94635 21.3355 5.84046 21.3875L5.92748 19.89C5.52107 19.8664 5.15161 19.6463 4.93727 19.3002L3.662 20.09ZM15.25 5V9H16.75V5H15.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12 10L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fast-charging-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fast","lightning","charge","power","menu","options","settings","bolt","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57535 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57527 3 9.92936V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.45868 21.0001 8.57527 21 9.92936 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0707V9.9294C21 8.57531 21.0001 7.45868 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM15.2336 7.53274C15.6126 7.64072 15.875 7.99554 15.875 8.40006V10.2H17.625C17.9402 10.2 18.2311 10.3744 18.3864 10.6566C18.5417 10.9387 18.5375 11.285 18.3753 11.5631L15.7503 16.063C15.548 16.4099 15.1455 16.5752 14.7664 16.4673C14.3874 16.3593 14.125 16.0045 14.125 15.5999V13.8H12.375C12.0598 13.8 11.7689 13.6256 11.6136 13.3434C11.4583 13.0613 11.4625 12.715 11.6247 12.4369L14.2497 7.93703C14.452 7.59015 14.8545 7.42476 15.2336 7.53274ZM7.5 8C6.94772 8 6.5 8.44772 6.5 9C6.5 9.55229 6.94772 10 7.5 10H8.5C9.05229 10 9.5 9.55229 9.5 9C9.5 8.44772 9.05229 8 8.5 8H7.5ZM6.5 10.9993C5.94772 10.9993 5.5 11.447 5.5 11.9993C5.5 12.5516 5.94772 12.9993 6.5 12.9993H8.5C9.05229 12.9993 9.5 12.5516 9.5 11.9993C9.5 11.447 9.05229 10.9993 8.5 10.9993H6.5ZM7.5 14C6.94772 14 6.5 14.4477 6.5 15C6.5 15.5523 6.94772 16 7.5 16H8.5C9.05229 16 9.5 15.5523 9.5 15C9.5 14.4477 9.05229 14 8.5 14H7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Feed-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","invoice","bill","transaction","history","record","sales-record","payment","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2381 14C20.2112 14 21 13.2111 21 12.2381L21 5.62181C21 5 20.6046 4 19.5 4C18.6716 4 18.0001 4.73456 18.0001 5.56299L18.0001 14.063L19.2381 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 16.8839C2.99999 17.6374 2.99998 18.2643 3.04082 18.7611C3.08212 19.2633 3.17277 19.7748 3.44946 20.2216C3.96387 21.0523 4.85056 21.5804 5.82596 21.6371C6.35062 21.6676 6.84351 21.5037 7.30483 21.3007C7.76108 21.1001 8.31226 20.8015 8.97466 20.4427L8.9748 20.4426L9.01273 20.4221C9.55974 20.1258 9.67231 20.0743 9.77191 20.0509C9.92194 20.0158 10.0781 20.0158 10.2281 20.0509C10.3277 20.0743 10.4403 20.1258 10.9873 20.4221L11.0253 20.4426L11.0253 20.4427C11.6877 20.8015 12.2389 21.1001 12.6952 21.3008C13.1565 21.5037 13.6494 21.6676 14.174 21.6371C15.1494 21.5804 16.0361 21.0523 16.5505 20.2216C16.8272 19.7748 16.9179 19.2633 16.9592 18.7611C17 18.2643 17 17.6374 17 16.884V4H8ZM12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11H8C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9L12 9ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13H8C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Feed: {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["receipt","invoice","bill","transaction","history","record","sales-record","payment","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10L8 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L8 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L16 7C16 5.89543 16.8954 5 18 5V5C19.1046 5 20 5.89543 20 7L20 12.2381C20 12.6589 19.6589 13 19.2381 13L16 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 11V16.8408C4 18.4211 4 19.2112 4.29964 19.6951C4.64258 20.2489 5.23371 20.601 5.88397 20.6387C6.45214 20.6718 7.14691 20.2954 8.53644 19.5428V19.5428C9.03414 19.2732 9.28298 19.1384 9.54381 19.0773C9.84387 19.007 10.1561 19.007 10.4562 19.0773C10.717 19.1384 10.9659 19.2732 11.4636 19.5428V19.5428C12.8531 20.2954 13.5479 20.6718 14.116 20.6387C14.7663 20.601 15.3574 20.2489 15.7004 19.6951C16 19.2112 16 18.4211 16 16.8408V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Female-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["male","gender","man","customer","demographics","profile","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 19C14.3137 19 17 16.3137 17 13C17 11.3431 16.3284 9.84314 15.2426 8.75736C14.1569 7.67157 12.6569 7 11 7C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 5H15M19 5V9M19 5L15.2338 8.7662"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Female-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["male","gender","man","customer","user","employee","demographic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6H16.5858L15.1921 7.39368C14.0239 6.51899 12.5719 6 11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20C14.866 20 18 16.866 18 13C18 11.4281 17.481 9.97614 16.6063 8.8079L18 7.41421V9C18 9.55228 18.4477 10 19 10C19.5523 10 20 9.55228 20 9V5C20 4.44772 19.5523 4 19 4H15ZM14.4316 9.36349C14.4602 9.40179 14.4919 9.43851 14.5267 9.4733C14.5615 9.5081 14.5982 9.53979 14.6365 9.56839C15.4828 10.4647 16 11.6711 16 13C16 15.7614 13.7614 18 11 18C8.23858 18 6 15.7614 6 13C6 10.2386 8.23858 8 11 8C12.3289 8 13.5353 8.51722 14.4316 9.36349Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Female-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["male","gender","customer","demographic","employee","user","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 5H15M19 5V9M19 5L15.2338 8.7662"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19C14.3137 19 17 16.3137 17 13C17 11.3431 16.3284 9.84314 15.2426 8.75736C14.1569 7.67157 12.6569 7 11 7C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Female: {
        defaultColors: ["#3D4C66"],
        keywords: ["male","gender","customer","demographic","employee","user","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 19C14.3137 19 17 16.3137 17 13C17 11.3431 16.3284 9.84314 15.2426 8.75736C14.1569 7.67157 12.6569 7 11 7C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 5H15M19 5V9M19 5L15.2338 8.7662"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "figma-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["brand","logo","business","initials","bp","jb","profile","settings","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6C18 6 18 6 18 6C18 7.65685 16.6569 9 15 9C15 9 15 9 15 9L12 9L12 3L15 3C15 3 15 3 15 3C16.6569 3 18 4.34315 18 6C18 6 18 6 18 6V6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12C18 13.6569 16.6569 15 15 15V15C13.3431 15 12 13.6569 12 12V12C12 10.3431 13.3431 9 15 9V9C16.6569 9 18 10.3431 18 12V12Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 6C6 4.34315 7.34315 3 9 3H12V9H9C7.34315 9 6 7.65685 6 6V6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12C6 10.3431 7.34315 9 9 9H12V15H9C7.34315 15 6 13.6569 6 12V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 18C6 16.3431 7.34315 15 9 15H12V18C12 19.6569 10.6569 21 9 21V21C7.34315 21 6 19.6569 6 18V18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "figma-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["abstract","logo","figma","design","app","brand","software","development","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 6C6 4.34315 7.34315 3 9 3H12V9H9C7.34315 9 6 7.65685 6 6V6Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12C6 10.3431 7.34315 9 9 9H12V15H9C7.34315 15 6 13.6569 6 12V12Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 18C6 16.3431 7.34315 15 9 15H12V18C12 19.6569 10.6569 21 9 21V21C7.34315 21 6 19.6569 6 18V18Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6C18 6 18 6 18 6C18 7.65685 16.6569 9 15 9C15 9 15 9 15 9L12 9L12 3L15 3C15 3 15 3 15 3C16.6569 3 18 4.34315 18 6C18 6 18 6 18 6V6Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12C18 13.6569 16.6569 15 15 15V15C13.3431 15 12 13.6569 12 12V12C12 10.3431 13.3431 9 15 9V9C16.6569 9 18 10.3431 18 12V12Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    figma: {
        defaultColors: ["#3D4C66"],
        keywords: ["abstract","logo","figma","design","app","brand","software","development","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 6C6 4.34315 7.34315 3 9 3H12V9H9C7.34315 9 6 7.65685 6 6V6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12C6 10.3431 7.34315 9 9 9H12V15H9C7.34315 15 6 13.6569 6 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 18C6 16.3431 7.34315 15 9 15H12V18C12 19.6569 10.6569 21 9 21V21C7.34315 21 6 19.6569 6 18V18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6C18 6 18 6 18 6C18 7.65685 16.6569 9 15 9C15 9 15 9 15 9L12 9L12 3L15 3C15 3 15 3 15 3C16.6569 3 18 4.34315 18 6C18 6 18 6 18 6V6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 12C18 13.6569 16.6569 15 15 15V15C13.3431 15 12 13.6569 12 12V12C12 10.3431 13.3431 9 15 9V9C16.6569 9 18 10.3431 18 12V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "file-bin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["bin","recycle","delete","remove","trash","discard","file","document","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 11V13M7 13L7 14.5C7 14.9659 7 15.1989 7.07612 15.3827C7.17761 15.6277 7.37229 15.8224 7.61732 15.9239C7.80109 16 8.03406 16 8.5 16V16C8.96594 16 9.19891 16 9.38268 15.9239C9.62771 15.8224 9.82239 15.6277 9.92388 15.3827C10 15.1989 10 14.9659 10 14.5V14.5C10 14.0341 10 13.8011 9.92388 13.6173C9.82239 13.3723 9.62771 13.1776 9.38268 13.0761C9.19891 13 8.96594 13 8.5 13H7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16V14.5C14 14.0341 14 13.8011 14.0761 13.6173C14.1776 13.3723 14.3723 13.1776 14.6173 13.0761C14.8011 13 15.0341 13 15.5 13V13C15.9659 13 16.1989 13 16.3827 13.0761C16.6277 13.1776 16.8224 13.3723 16.9239 13.6173C17 13.8011 17 14.0341 17 14.5V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 14L12 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "file-bin-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bin","recycle","trash","delete","remove","discard","clear","file","document","paper","cancel","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.2929 9.29289L14.7071 5.70711C14.4462 5.44617 14 5.63098 14 6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10C18.369 10 18.5538 9.55383 18.2929 9.29289Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 11V13M7 13L7 14.5C7 14.9659 7 15.1989 7.07612 15.3827C7.17761 15.6277 7.37229 15.8224 7.61732 15.9239C7.80109 16 8.03406 16 8.5 16V16C8.96594 16 9.19891 16 9.38268 15.9239C9.62771 15.8224 9.82239 15.6277 9.92388 15.3827C10 15.1989 10 14.9659 10 14.5V14.5C10 14.0341 10 13.8011 9.92388 13.6173C9.82239 13.3723 9.62771 13.1776 9.38268 13.0761C9.19891 13 8.96594 13 8.5 13H7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16V14.5C14 14.0341 14 13.8011 14.0761 13.6173C14.1776 13.3723 14.3723 13.1776 14.6173 13.0761C14.8011 13 15.0341 13 15.5 13V13C15.9659 13 16.1989 13 16.3827 13.0761C16.6277 13.1776 16.8224 13.3723 16.9239 13.6173C17 13.8011 17 14.0341 17 14.5V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 14L12 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "figma-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["brand","logo","identifier","company","profile","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 22C6.79 22 5 20.21 5 18C5 16.81 5.53 15.73 6.36 15C5.53 14.27 5 13.19 5 12C5 10.81 5.53 9.73 6.36 9C5.53 8.27 5 7.19 5 6C5 3.79 6.79 2 9 2H15C17.21 2 19 3.79 19 6C19 7.19 18.47 8.27 17.64 9C18.47 9.73 19 10.81 19 12C19 14.21 17.21 16 15 16C14.27 16 13.59 15.8 13 15.46V18C13 20.21 11.21 22 9 22ZM9 16C7.9 16 7 16.9 7 18C7 19.1 7.9 20 9 20C10.1 20 11 19.1 11 18V16H9ZM13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10C13.9 10 13 10.9 13 12ZM9 14H11V10H9C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14ZM13 8H15C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4H13V8ZM9 8H11V4H9C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "file-bin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bin","recycle","delete","remove","trash","discard","clear","empty","waste","file","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.75 14.5V13.75H8.5C8.74324 13.75 8.8881 13.7504 8.99611 13.7578C9.06293 13.7623 9.09134 13.7684 9.09869 13.7703C9.15753 13.7956 9.20442 13.8425 9.2297 13.9013C9.23157 13.9087 9.23767 13.9371 9.24223 14.0039C9.2496 14.1119 9.25 14.2568 9.25 14.5C9.25 14.7432 9.2496 14.8881 9.24223 14.9961C9.23767 15.0629 9.23157 15.0913 9.2297 15.0987C9.20442 15.1575 9.15753 15.2044 9.0987 15.2297C9.09134 15.2316 9.06294 15.2377 8.99611 15.2422C8.8881 15.2496 8.74324 15.25 8.5 15.25C8.25677 15.25 8.11191 15.2496 8.0039 15.2422C7.93707 15.2377 7.90866 15.2316 7.90131 15.2297C7.84248 15.2044 7.79558 15.1575 7.77031 15.0987C7.76844 15.0913 7.76234 15.0629 7.75778 14.9961C7.75041 14.8881 7.75 14.7432 7.75 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57495 19.8815C6.64712 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.24351 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9295C3.99997 9.57551 3.99995 8.45888 4.11876 7.57517C4.24351 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64712 4.24373 7.57495 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM7.75 11C7.75 10.5858 7.41422 10.25 7 10.25C6.58579 10.25 6.25 10.5858 6.25 11L6.25 14.5218C6.24999 14.736 6.24998 14.9329 6.26126 15.0982C6.27338 15.2759 6.30099 15.4712 6.38321 15.6697C6.56083 16.0985 6.90151 16.4392 7.33031 16.6168C7.52881 16.699 7.72415 16.7266 7.90179 16.7387C8.06712 16.75 8.26397 16.75 8.47824 16.75H8.52176C8.73604 16.75 8.93289 16.75 9.09821 16.7387C9.27586 16.7266 9.4712 16.699 9.6697 16.6168C10.0985 16.4392 10.4392 16.0985 10.6168 15.6697C10.699 15.4712 10.7266 15.2759 10.7387 15.0982C10.75 14.9329 10.75 14.736 10.75 14.5218V14.4782C10.75 14.264 10.75 14.0671 10.7387 13.9018C10.7266 13.7241 10.699 13.5288 10.6168 13.3303C10.4392 12.9015 10.0985 12.5608 9.6697 12.3832C9.4712 12.301 9.27586 12.2734 9.09821 12.2613C8.93289 12.25 8.73604 12.25 8.52176 12.25L7.75 12.25V11ZM12.75 11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12V11ZM15.5218 12.25H15.4782C15.264 12.25 15.0671 12.25 14.9018 12.2613C14.7242 12.2734 14.5288 12.301 14.3303 12.3832C13.9015 12.5608 13.5608 12.9015 13.3832 13.3303C13.301 13.5288 13.2734 13.7241 13.2613 13.9018C13.25 14.0671 13.25 14.264 13.25 14.4782L13.25 16C13.25 16.4142 13.5858 16.75 14 16.75C14.4142 16.75 14.75 16.4142 14.75 16V14.5C14.75 14.2568 14.7504 14.1119 14.7578 14.0039C14.7623 13.9371 14.7684 13.9087 14.7703 13.9013C14.7956 13.8425 14.8425 13.7956 14.9013 13.7703C14.9087 13.7684 14.9371 13.7623 15.0039 13.7578C15.1119 13.7504 15.2568 13.75 15.5 13.75C15.7432 13.75 15.8881 13.7504 15.9961 13.7578C16.0629 13.7623 16.0913 13.7684 16.0987 13.7703C16.1575 13.7956 16.2044 13.8425 16.2297 13.9013C16.2316 13.9087 16.2377 13.9371 16.2422 14.0039C16.2496 14.1119 16.25 14.2568 16.25 14.5V16C16.25 16.4142 16.5858 16.75 17 16.75C17.4142 16.75 17.75 16.4142 17.75 16V14.4782C17.75 14.264 17.75 14.0671 17.7387 13.9018C17.7266 13.7241 17.699 13.5288 17.6168 13.3303C17.4392 12.9015 17.0985 12.5608 16.6697 12.3832C16.4712 12.301 16.2759 12.2734 16.0982 12.2613C15.9329 12.25 15.736 12.25 15.5218 12.25ZM12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.0391 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "file-bin": {
        defaultColors: ["#3D4C66"],
        keywords: ["bin","file","delete","remove","trash","archive","trash-item","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 11V13M7 13L7 14.5C7 14.9659 7 15.1989 7.07612 15.3827C7.17761 15.6277 7.37229 15.8224 7.61732 15.9239C7.80109 16 8.03406 16 8.5 16V16C8.96594 16 9.19891 16 9.38268 15.9239C9.62771 15.8224 9.82239 15.6277 9.92388 15.3827C10 15.1989 10 14.9659 10 14.5V14.5C10 14.0341 10 13.8011 9.92388 13.6173C9.82239 13.3723 9.62771 13.1776 9.38268 13.0761C9.19891 13 8.96594 13 8.5 13H7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16V14.5C14 14.0341 14 13.8011 14.0761 13.6173C14.1776 13.3723 14.3723 13.1776 14.6173 13.0761C14.8011 13 15.0341 13 15.5 13V13C15.9659 13 16.1989 13 16.3827 13.0761C16.6277 13.1776 16.8224 13.3723 16.9239 13.6173C17 13.8011 17 14.0341 17 14.5V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 14L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "File-Download-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["download","file","import","receive","arrow-down","save","get-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 13L10.5858 13.5858C11.2525 14.2525 11.5858 14.5858 12 14.5858C12.4142 14.5858 12.7475 14.2525 13.4142 13.5858L14 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.6029C14.2621 5 15.0918 5 15.7795 5.3894C16.4673 5.7788 16.8941 6.49021 17.7478 7.91302L18.145 8.57493C18.5698 9.28308 18.7823 9.63715 18.8911 10.0302C19 10.4232 19 10.8361 19 11.6619V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "File-Download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","download","import","data","receive","arrow-down","document","get","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2881 4.30466C13.5493 3.99862 12.7445 3.99925 11.6847 4.00009L11.5147 4.00017L10.9294 4.00017L10.9294 4.00017C9.57531 4.00014 8.4587 4.00011 7.57494 4.11893C6.64711 4.24367 5.82769 4.51564 5.17158 5.17175C4.51547 5.82785 4.2435 6.64728 4.11876 7.57511C3.99994 8.45886 3.99997 9.57546 4 10.9296V10.9296V13.0707V13.0708C3.99997 14.4249 3.99994 15.5415 4.11876 16.4252C4.2435 17.3531 4.51547 18.1725 5.17158 18.8286C5.82769 19.4847 6.64711 19.7567 7.57494 19.8814C8.4587 20.0002 9.57531 20.0002 10.9294 20.0002H13.0706C14.4247 20.0002 15.5413 20.0002 16.4251 19.8814C17.3529 19.7567 18.1723 19.4847 18.8284 18.8286C19.4845 18.1725 19.7565 17.3531 19.8813 16.4252C20.0001 15.5415 20 14.4249 20 13.0708V13.0707L20 12.4855L20.0001 12.3155C20.0009 11.2557 20.0016 10.4509 19.6955 9.71208C19.3895 8.97325 18.82 8.40464 18.07 7.65581L18.07 7.6558L17.9498 7.53571L16.4645 6.05043L16.3444 5.93021C15.5955 5.1802 15.0269 4.61069 14.2881 4.30466ZM11.7 16.0002H12H12.3C13.5 15.9002 14.3 15.1002 15.7 13.7002L15.7 13.7002C16.1 13.3002 16.1 12.7002 15.7 12.3002C15.3 11.9002 14.7 11.9002 14.3 12.3002C13.7 12.8002 13.3 13.2002 13 13.5002V9.00024C13 8.40024 12.6 8.00024 12 8.00024C11.4 8.00024 11 8.40024 11 9.00024V13.5002C10.7 13.3002 10.3 12.9002 9.7 12.3002C9.3 11.9002 8.7 11.9002 8.3 12.3002C7.9 12.7002 7.9 13.3002 8.3 13.7002C9.7 15.1002 10.5 15.9002 11.7 16.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "File-Download-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","download","import","receipt","backup","data","arrow-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12L10.5858 12.5858C11.2525 13.2525 11.5858 13.5858 12 13.5858C12.4142 13.5858 12.7475 13.2525 13.4142 12.5858L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "File-Download-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","download","import","arrow-down","receive","document","get-data","update","data-import"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 15L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 13C13.7231 14.2769 13.0846 14.9154 12.2313 14.9899C12.0776 15.0034 11.9224 15.0034 11.7687 14.9899C10.9154 14.9154 10.2769 14.2769 9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "File-Download-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","file","document","import","save","arrow-down","receive","get-file"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12L10.5858 12.5858C11.2525 13.2525 11.5858 13.5858 12 13.5858C12.4142 13.5858 12.7475 13.2525 13.4142 12.5858L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16H10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "File-Download-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","download","import","receive","update","get","arrow-down","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L10.2111 12.1056C11.089 12.5445 11.5279 12.7639 12 12.7639C12.4721 12.7639 12.911 12.5445 13.7889 12.1056L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "File-Download-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","download","import","receive","arrow-down","data","get-data","transaction-download","report-download","invoice-download","menu-download"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 4.08605C13.6837 3.99889 13.0522 3.99945 12.3137 4.00011L10.9294 4.00023C9.57532 4.00019 8.4587 4.00016 7.57494 4.11898C6.64711 4.24373 5.82769 4.51569 5.17158 5.1718C4.51547 5.82791 4.2435 6.64734 4.11876 7.57517C3.99994 8.45889 3.99997 9.5755 4 10.9296V13.0708C3.99997 14.4249 3.99994 15.5416 4.11876 16.4253C4.2435 17.3531 4.51547 18.1725 5.17158 18.8287C5.82769 19.4848 6.64711 19.7567 7.57494 19.8815C8.45868 20.0003 9.57527 20.0003 10.9294 20.0002H13.0706C14.4247 20.0003 15.5413 20.0003 16.4251 19.8815C17.3529 19.7567 18.1723 19.4848 18.8284 18.8287C19.4845 18.1725 19.7565 17.3531 19.8813 16.4253C20.0001 15.5416 20 14.425 20 13.0709L20.0001 11.9612C20.0007 11.059 20.0011 10.3746 19.7745 9.72854L19.7694 9.71406C19.7386 9.72053 19.7114 9.72499 19.6893 9.72822C19.5362 9.75055 19.3505 9.75039 19.2004 9.75026L18.948 9.75025C18.0495 9.75027 17.3003 9.7503 16.7055 9.67033C16.0777 9.58593 15.5109 9.40026 15.0555 8.94479C14.6 8.48932 14.4143 7.92252 14.3299 7.29472C14.25 6.69994 14.25 5.95072 14.25 5.05224L14.25 4.08605ZM12.85 8.9999C12.85 8.53046 12.4694 8.1499 12 8.1499C11.5305 8.1499 11.15 8.53046 11.15 8.9999L11.15 11.6199C10.997 11.5468 10.8138 11.4565 10.5912 11.3452L10.3801 11.2396C9.96022 11.0297 9.44965 11.1999 9.2397 11.6198C9.02976 12.0397 9.19995 12.5502 9.61984 12.7602L9.97011 12.9355C10.7085 13.3059 11.3221 13.6138 12 13.6138C12.6778 13.6138 13.2914 13.3059 14.0298 12.9355L14.3801 12.7602C14.8 12.5502 14.9702 12.0397 14.7602 11.6198C14.5503 11.1999 14.0397 11.0297 13.6198 11.2396L13.4087 11.3452C13.1861 11.4565 13.0029 11.5468 12.85 11.6199V8.9999ZM9.99997 14.4999C9.53053 14.4999 9.14997 14.8805 9.14997 15.3499C9.14997 15.8193 9.53053 16.1999 9.99997 16.1999H14C14.4694 16.1999 14.85 15.8193 14.85 15.3499C14.85 14.8805 14.4694 14.4999 14 14.4999H9.99997Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 5.00024V4.98174C15.8579 5.05538 15.9556 5.1453 16.039 5.24963L18.4389 8.24948C17.7741 8.24685 17.2881 8.23516 16.9054 8.18371C16.4439 8.12167 16.2464 8.01444 16.1161 7.88413C15.9858 7.75381 15.8786 7.55631 15.8165 7.09485C15.7516 6.61182 15.75 5.96426 15.75 5.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "file-garph-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["report","statistics","sales","analysis","data","file","document","graphs","chart","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15L12 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15L15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "file-garph-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","report","analytics","graph","document","statistics","data","sales-report","summary","charts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15L15 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "File-Download": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","download","import","arrow-down","receive","data","get-data","load","load-data","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 13L10.5858 13.5858C11.2525 14.2525 11.5858 14.5858 12 14.5858C12.4142 14.5858 12.7475 14.2525 13.4142 13.5858L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.6029C14.2621 5 15.0918 5 15.7795 5.3894C16.4673 5.7788 16.8941 6.49021 17.7478 7.91302L18.145 8.57493C18.5698 9.28308 18.7823 9.63715 18.8911 10.0302C19 10.4232 19 10.8361 19 11.6619V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "file-garph-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","document","graph","report","statistics","sales-report","analytics","data","chart","business-report","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V10.9296C3.99997 9.57551 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM13 11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V11.5ZM10 13.5C10 12.9477 9.55229 12.5 9 12.5C8.44772 12.5 8 12.9477 8 13.5V15C8 15.5523 8.44772 16 9 16C9.55229 16 10 15.5523 10 15V13.5ZM16 13.5C16 12.9477 15.5523 12.5 15 12.5C14.4477 12.5 14 12.9477 14 13.5V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "file-garph": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","document","graph","report","sales","analytics","data","statistics","summary","performance","charts","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15L12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "file-manager-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["notification","message","alert","reminder","update","pending","information","report","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="8" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "file-manager-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","manager","report","list","document","information","options","settings","file-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.92943 4L11 4C11.5523 4 12 4.44772 12 5C12 5.55229 11.5523 6 11 6H10C8.55752 6 8.57626 6.00213 7.84144 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84143C6.00213 8.57625 6 9.55752 6 11V13C6 14.4425 6.00213 15.4238 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84144 17.8991C8.57626 17.9979 9.55752 18 11 18H13C14.4425 18 15.4238 17.9979 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9979 15.4238 18 15.4425 18 14V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13L20 14.0706C20 15.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0707 20H10.9294C9.57534 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57533 3.99994 8.45869 4.11876 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11875C8.45869 3.99994 8.57533 3.99997 9.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5 4.5C14.8431 4.5 13.5 5.84315 13.5 7.5C13.5 9.15685 14.8431 10.5 16.5 10.5C18.1569 10.5 19.5 9.15685 19.5 7.5C19.5 5.84315 18.1569 4.5 16.5 4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5 12C7.5 11.4477 7.94772 11 8.5 11H13.5C14.0523 11 14.5 11.4477 14.5 12C14.5 12.5523 14.0523 13 13.5 13H8.5C7.94772 13 7.5 12.5523 7.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5 15.5C7.5 14.9477 7.94772 14.5 8.5 14.5H12.5C13.0523 14.5 13.5 14.9477 13.5 15.5C13.5 16.0523 13.0523 16.5 12.5 16.5H8.5C7.94772 16.5 7.5 16.0523 7.5 15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "file-manager-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","document","notification","report","invoice","receipt","pending","alert","settings","order","menu","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="8"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 13H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "file-manager": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","document","notification","message","pending","alert","info","details","record","receipt","order","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="8" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "file-search-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["file","document","search","find","query","receipt","transaction-history","record","lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142ZM13.4142 14.4142L14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "file-search-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","search","document","query","find","lookup","order-lookup","transaction-search","invoice-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142ZM13.4142 14.4142L14 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "file-search": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","document","search","query","find","report","transaction","history","record","lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142ZM13.4142 14.4142L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "File-upload-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["file","upload","import","arrow-up","document","send","transfer","receipt-upload","report-upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "File-upload-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["file","upload","import","document","arrow-up","add-file","import-data","upload-sales","upload-inventory","upload-products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L13.7889 11.8944C12.911 11.4555 12.4721 11.2361 12 11.2361C11.5279 11.2361 11.089 11.4555 10.2111 11.8944L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "file-search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","search","query","find","report","document","lookup","inventory-search","transaction-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 4.00011C13.0522 3.99945 13.6837 3.99889 14.25 4.08605L14.25 5.05224C14.25 5.95072 14.25 6.69994 14.3299 7.29472C14.4143 7.92252 14.6 8.48932 15.0555 8.94479C15.5109 9.40026 16.0777 9.58593 16.7055 9.67033C17.3003 9.7503 18.0495 9.75027 18.948 9.75025L19.2004 9.75026C19.3505 9.75039 19.5362 9.75055 19.6893 9.72822C19.7114 9.72499 19.7386 9.72053 19.7694 9.71406L19.7745 9.72854C20.0011 10.3746 20.0007 11.059 20.0001 11.9612L20 13.0709C20 14.425 20.0001 15.5416 19.8813 16.4253C19.7565 17.3531 19.4845 18.1725 18.8284 18.8287C18.1723 19.4848 17.3529 19.7567 16.4251 19.8815C15.5413 20.0003 14.4247 20.0003 13.0706 20.0002H10.9294C9.57527 20.0003 8.45869 20.0003 7.57494 19.8815C6.64711 19.7567 5.82769 19.4848 5.17158 18.8287C4.51547 18.1725 4.2435 17.3531 4.11876 16.4253C3.99995 15.5416 3.99997 14.4249 4 13.0709V13.0708V10.9296V10.9295C3.99997 9.57548 3.99995 8.45889 4.11876 7.57517C4.2435 6.64734 4.51547 5.82791 5.17158 5.1718C5.82769 4.51569 6.64711 4.24373 7.57494 4.11898C8.4587 4.00016 9.57532 4.00019 10.9294 4.00023L12.3137 4.00011ZM15.75 4.98174V5.00024C15.75 5.96426 15.7516 6.61182 15.8165 7.09485C15.8786 7.55631 15.9858 7.75381 16.1161 7.88413C16.2464 8.01444 16.4439 8.12167 16.9054 8.18371C17.2881 8.23516 17.7741 8.24685 18.4389 8.24948L16.039 5.24963C15.9556 5.1453 15.8579 5.05538 15.75 4.98174ZM12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C12.4628 16 12.9016 15.8948 13.2932 15.7074L13.7929 16.2071C14.1834 16.5976 14.8166 16.5976 15.2071 16.2071C15.5976 15.8166 15.5976 15.1834 15.2071 14.7929L14.7074 14.2932C14.8948 13.9016 15 13.4628 15 13C15 11.3431 13.6569 10 12 10ZM11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.2764 12.8892 13.525 12.7071 13.7071C12.525 13.8892 12.2764 14 12 14C11.4477 14 11 13.5523 11 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "File-upload-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","upload","import","data","document","receipt","invoice","export","file-upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 4.08605C13.6837 3.99889 13.0522 3.99945 12.3137 4.00011L10.9294 4.00023C9.57532 4.00019 8.4587 4.00016 7.57494 4.11898C6.64711 4.24373 5.82769 4.51569 5.17158 5.1718C4.51547 5.82791 4.2435 6.64734 4.11876 7.57517C3.99994 8.45889 3.99997 9.5755 4 10.9296V13.0708C3.99997 14.4249 3.99994 15.5416 4.11876 16.4253C4.2435 17.3531 4.51547 18.1725 5.17158 18.8287C5.82769 19.4848 6.64711 19.7567 7.57494 19.8815C8.45868 20.0003 9.57527 20.0003 10.9294 20.0002H13.0706C14.4247 20.0003 15.5413 20.0003 16.4251 19.8815C17.3529 19.7567 18.1723 19.4848 18.8284 18.8287C19.4845 18.1725 19.7565 17.3531 19.8813 16.4253C20.0001 15.5416 20 14.425 20 13.0709L20.0001 11.9612C20.0007 11.059 20.0011 10.3746 19.7745 9.72854L19.7694 9.71406C19.7386 9.72053 19.7114 9.72499 19.6893 9.72822C19.5362 9.75055 19.3505 9.75039 19.2004 9.75026L18.948 9.75025C18.0495 9.75027 17.3003 9.7503 16.7055 9.67033C16.0777 9.58593 15.5109 9.40026 15.0555 8.94479C14.6 8.48932 14.4143 7.92252 14.3299 7.29472C14.25 6.69994 14.25 5.95072 14.25 5.05224L14.25 4.08605ZM10.5912 12.6546C10.8138 12.5433 10.997 12.453 11.15 12.3799V14.9999C11.15 15.4694 11.5305 15.8499 12 15.8499C12.4694 15.8499 12.85 15.4694 12.85 14.9999V12.3799C13.0029 12.453 13.1861 12.5433 13.4087 12.6546L13.6198 12.7602C14.0397 12.9701 14.5503 12.7999 14.7602 12.38C14.9702 11.9602 14.8 11.4496 14.3801 11.2397L14.0298 11.0644C13.2914 10.6939 12.6778 10.386 12 10.386C11.3221 10.386 10.7085 10.6939 9.97011 11.0644L9.61984 11.2397C9.19995 11.4496 9.02976 11.9602 9.2397 12.3801C9.44965 12.7999 9.96022 12.9701 10.3801 12.7602L10.5912 12.6546Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 5.00024V4.98174C15.8579 5.05538 15.9556 5.1453 16.039 5.24963L18.4389 8.24948C17.7741 8.24685 17.2881 8.23516 16.9054 8.18371C16.4439 8.12167 16.2464 8.01444 16.1161 7.88413C15.9858 7.75381 15.8786 7.55631 15.8165 7.09485C15.7516 6.61182 15.75 5.96426 15.75 5.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "File-upload": {
        defaultColors: ["#3D4C66"],
        keywords: ["file","upload","document","import","data","transfer","add-file","invoice-upload","receipt-upload","report-upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H11.5147C12.741 5 13.3541 5 13.9054 5.22836C14.4567 5.45672 14.8903 5.89027 15.7574 6.75736L17.2426 8.24264C18.1097 9.10973 18.5433 9.54328 18.7716 10.0946C19 10.6459 19 11.259 19 12.4853V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L13.4142 13.4142C12.7475 12.7475 12.4142 12.4142 12 12.4142C11.5858 12.4142 11.2525 12.7475 10.5858 13.4142L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Fill-sidebar-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sidebar","navigation","menu","options","panel","drawer","fill","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 20L16 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Fill-sidebar-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["sidebar","menu","navigation","options","settings","categories","products","reports","tools","sections"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 20L16 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Fill-sidebar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sidebar","split","layout","interface","section","navigation","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 20.9831C16.5284 20.9676 17.0033 20.938 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92946C21 8.57535 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C17.0033 3.06205 16.5284 3.03241 16 3.01693L16 20.9831Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 3H9.92943C8.57535 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57527 3 9.92936V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.5753 21 9.92942 21H14L14 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Fill-sidebar-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sidebar","navigation","menu","left-menu","filter","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 20L8 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Fill-sidebar-left-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["sidebar","menu","navigation","section","panel","options","settings","categories","filters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 20L8 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Fill-sidebar-left": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sidebar","menu","navigation","options","settings","panel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 20L8 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "filter-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","sort","refine","search","selection","funnel","criteria"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.82993 8.30158L9.51851 11.4383C9.75668 11.7161 9.87577 11.8551 9.93788 12.023C10 12.1909 10 12.3739 10 12.7398V15.7639C10 17.2143 10 17.9395 10.4743 18.2326C10.9485 18.5257 11.5972 18.2014 12.8944 17.5528C13.4323 17.2838 13.7013 17.1493 13.8507 16.9077C14 16.666 14 16.3653 14 15.7639V12.7398C14 12.3739 14 12.1909 14.0621 12.023C14.1242 11.8551 14.2433 11.7161 14.4815 11.4383L17.1701 8.30158C18.3914 6.87672 19.002 6.16429 18.7343 5.58214C18.4665 5 17.5282 5 15.6516 5H8.34844C6.47178 5 5.53346 5 5.26571 5.58214C4.99796 6.16429 5.60862 6.87672 6.82993 8.30158Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Fill-sidebar": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sidebar","menu","navigation","interface","layout","panel","section","fill","extend","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 20L16 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Fill-sidebar-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sidebar","menu","navigation","section","toggle","hide-menu","show-menu","collapse","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 3.01692C7.4716 3.03241 6.99675 3.06204 6.57494 3.11875C5.64711 3.2435 4.82768 3.51546 4.17157 4.17157C3.51546 4.82768 3.2435 5.64711 3.11875 6.57494C2.99993 7.45869 2.99996 8.5753 3 9.92941L3 14.0705C2.99997 15.4247 2.99994 16.5413 3.11875 17.4251C3.2435 18.3529 3.51546 19.1723 4.17157 19.8284C4.82768 20.4845 5.64711 20.7565 6.57494 20.8813C6.99675 20.938 7.4716 20.9676 8.00001 20.9831L8 3.01692Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92943C21 8.57534 21.0001 7.45868 20.8813 6.57494C20.7565 5.64711 20.4845 4.82768 19.8284 4.17157C19.1723 3.51546 18.3529 3.2435 17.4251 3.11875C16.5413 2.99993 15.4247 2.99996 14.0706 3L10 3L10 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "filter-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["filter","funnel","sort","refine","search","settings","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.82993 8.30158L9.51851 11.4383C9.75668 11.7161 9.87577 11.8551 9.93788 12.023C10 12.1909 10 12.3739 10 12.7398V15.7639C10 17.2143 10 17.9395 10.4743 18.2326C10.9485 18.5257 11.5972 18.2014 12.8944 17.5528C13.4323 17.2838 13.7013 17.1493 13.8507 16.9077C14 16.666 14 16.3653 14 15.7639V12.7398C14 12.3739 14 12.1909 14.0621 12.023C14.1242 11.8551 14.2433 11.7161 14.4815 11.4383L17.1701 8.30158C18.3914 6.87672 19.002 6.16429 18.7343 5.58214C18.4665 5 17.5282 5 15.6516 5H8.34844C6.47178 5 5.53346 5 5.26571 5.58214C4.99796 6.16429 5.60862 6.87672 6.82993 8.30158Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "filter-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","sort","funnel","organize","refine","selection","options","categorize","filter-options","price-filter","category-filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4407 6.02C19.1407 5.36 18.4807 5.16 17.9307 5.08C17.3707 5 16.6307 5 15.7407 5H8.31074C7.43074 5 6.68074 5 6.12074 5.08C5.57074 5.16 4.92074 5.36 4.61074 6.02C4.31074 6.68 4.58074 7.31 4.88074 7.78C5.18074 8.26 5.67074 8.82 6.24074 9.5C6.25074 9.52 6.27074 9.53 6.28074 9.55L8.97074 12.69C9.10074 12.84 9.17074 12.92 9.21074 12.98C9.23074 13.01 9.24074 13.03 9.25074 13.03C9.25074 13.04 9.25074 13.06 9.25074 13.1C9.25074 13.18 9.25074 13.29 9.25074 13.48V16.56C9.25074 17.24 9.25074 17.83 9.32074 18.28C9.39074 18.76 9.56074 19.29 10.0807 19.61C10.6007 19.93 11.1507 19.85 11.6107 19.7C12.0507 19.56 12.5807 19.29 13.1807 18.99L13.2607 18.95C13.5007 18.83 13.7407 18.71 13.9207 18.59C14.1307 18.46 14.3307 18.29 14.4907 18.04C14.6507 17.79 14.7007 17.53 14.7307 17.29C14.7507 17.07 14.7507 16.81 14.7507 16.54V13.48C14.7507 13.29 14.7507 13.18 14.7507 13.1C14.7507 13.06 14.7507 13.04 14.7507 13.03C14.7507 13.03 14.7707 13 14.7907 12.98C14.8407 12.92 14.9107 12.83 15.0307 12.69L17.7607 9.51C18.3407 8.84 18.8207 8.27 19.1207 7.79C19.4207 7.32 19.6907 6.69 19.3907 6.03L19.4407 6.02Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "filter-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","hamburger","options","navigation","list","filter","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "filter-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","settings","filter","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "filter-6": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","navigation","hamburger","lines","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "filter-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger-menu","options","navigation","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 16C7 15.4477 7.44772 15 8 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H8C7.44772 17 7 16.5523 7 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44771 13 7 13L17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11L7 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "filter-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["filter","remove-filter","no-filter","clear-filter","disable-filter","menu","options","remove","slash","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "filter-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","not-equal","unequal","exclude","reject","remove-filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "filter-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","disable-filter","remove-filter","filters","no-filter","exclude","not-equal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    filter: {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","disable-filter","remove-filter","filters","no-filter","exclude","not-equal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.82993 8.30158L9.51851 11.4383C9.75668 11.7161 9.87577 11.8551 9.93788 12.023C10 12.1909 10 12.3739 10 12.7398V15.7639C10 17.2143 10 17.9395 10.4743 18.2326C10.9485 18.5257 11.5972 18.2014 12.8944 17.5528C13.4323 17.2838 13.7013 17.1493 13.8507 16.9077C14 16.666 14 16.3653 14 15.7639V12.7398C14 12.3739 14 12.1909 14.0621 12.023C14.1242 11.8551 14.2433 11.7161 14.4815 11.4383L17.1701 8.30158C18.3914 6.87672 19.002 6.16429 18.7343 5.58214C18.4665 5 17.5282 5 15.6516 5H8.34844C6.47178 5 5.53346 5 5.26571 5.58214C4.99796 6.16429 5.60862 6.87672 6.82993 8.30158Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "filter-slash-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","disabled","not-equal","restriction","unavailable","exclude","remove-filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L17 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "finger-print-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fingerprint","security","authentication","login","identification","user-verification","biometrics","employee-login","secure-access","id"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13V18C20 18.5523 19.5523 19 19 19C18.4477 19 18 18.5523 18 18V13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13V18C6 18.5523 5.55228 19 5 19C4.44772 19 4 18.5523 4 18V13ZM8.08298 9.92366C8.99432 8.75712 10.4078 8 12 8C14.7808 8 17 10.2954 17 13.0833C17 13.6356 16.5523 14.0833 16 14.0833C15.4477 14.0833 15 13.6356 15 13.0833C15 11.3609 13.6375 10 12 10C11.0586 10 10.2135 10.4452 9.65904 11.1549C9.31903 11.5902 8.69059 11.6673 8.25537 11.3273C7.82016 10.9873 7.74297 10.3589 8.08298 9.92366ZM12 12C12.5523 12 13 12.4477 13 13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13C11 12.4477 11.4477 12 12 12ZM8 12.5C8.55228 12.5 9 12.9477 9 13.5V18C9 18.5523 8.55228 19 8 19C7.44772 19 7 18.5523 7 18V13.5C7 12.9477 7.44772 12.5 8 12.5ZM16 15C16.5523 15 17 15.4477 17 16V18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18V16C15 15.4477 15.4477 15 16 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "finger-print-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fingerprint","security","authorization","access","identification","verify","user-authentication","login","user-id","biometric","identity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17V15M8 17V12.0833M16 12.0833C16 9.82817 14.2091 8 12 8C10.5363 8 9.2563 8.8025 8.55906 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 17V12" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "finger-print-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fingerprint","security","identification","authentication","login","access","verified","secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17V15M8 17V12.0833M16 12.0833C16 9.82817 14.2091 8 12 8C10.5363 8 9.2563 8.8025 8.55906 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 17V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "finger-print": {
        defaultColors: ["#3D4C66"],
        keywords: ["fingerprint","security","authentication","authorization","login","user-identification","biometric","identity","access-control","secure-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17V15M8 17V12.0833M16 12.0833C16 9.82817 14.2091 8 12 8C10.5363 8 9.2563 8.8025 8.55906 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 17V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "fire-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","trending","popular","special","deal","promotion","burn","flame","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.3211 19 18.0001 16.3127 18.0001 12.9977C18.0001 10.8233 16.6648 9.50019 16 9C16.3324 9.66693 15.7839 11.9892 14 12.0027C11.4918 12.0218 10.4837 6 9.99997 5C7.20758 6.60062 6.00005 9.5 6.00005 13C6.00005 16.315 8.71164 19 12.0163 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fire-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["fire","hot","temperature","urgent","alert","warning","promotion","deal","special","discount","trending","popular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.3211 19 18.0001 16.3127 18.0001 12.9977C18.0001 10.8233 16.6648 9.50019 16 9C16.3324 9.66693 15.7839 11.9892 14 12.0027C11.4918 12.0218 10.4837 6 9.99997 5C7.20758 6.60062 6.00005 9.5 6.00005 13C6.00005 16.315 8.71164 19 12.0163 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fire-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","promotion","special","sale","trending","popular","deal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9001 4.56456C10.7794 4.31488 10.5603 4.12657 10.2953 4.04463C10.0304 3.9627 9.74325 3.99449 9.50262 4.13243C6.30049 5.96792 5 9.27231 5 13C5 16.8719 8.16396 20 12.0163 20C15.8762 20 19 16.862 19 12.9977C19 10.3788 17.3905 8.79478 16.6011 8.2009C16.2305 7.92205 15.7167 7.93467 15.3602 8.23138C15.0149 8.51877 14.9049 8.99963 15.0864 9.40677C15.0864 9.40677 15.0865 9.41026 15.0871 9.41514C15.0897 9.43862 15.0979 9.51127 15.0839 9.64478C15.0629 9.84584 15.0001 10.0878 14.8915 10.3147C14.6704 10.7768 14.3671 10.9999 13.9923 11.0028C13.8102 11.0041 13.5376 10.9047 13.1705 10.4385C12.8078 9.97807 12.4744 9.30538 12.1741 8.52461C11.8783 7.75513 11.6387 6.94604 11.4377 6.24359L11.3682 6.00014C11.2957 5.74537 11.2271 5.50464 11.165 5.29922C11.0884 5.0461 10.9996 4.77023 10.9001 4.56456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "fire-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","popular","trending","promotion","special","deal","offer","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.321 19 18 16.3127 18 12.9977C18 10.0156 16.6703 9.50175 16.0054 9.00156C16.3378 9.66848 16.7921 11.9892 15.0081 12.0027C12.5 12.0218 12.5 6 12.0163 5C9.22391 6.60062 8.8338 9.83288 9 11L7.52849 8.00117C6.33175 8.80148 5.86637 10.9969 6.03258 12.9977C6.03258 16.3127 8.71158 19 12.0163 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fire-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","promotion","special-offer","trending","popular","burn","urgent","sales","featured"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.321 19 18 16.3127 18 12.9977C18 10.0156 16.6703 9.50175 16.0054 9.00156C16.3378 9.66848 16.7921 11.9892 15.0081 12.0027C12.5 12.0218 12.5 6 12.0163 5C9.22391 6.60062 8.8338 9.83288 9 11L7.52849 8.00117C6.33175 8.80148 5.86637 10.9969 6.03258 12.9977C6.03258 16.3127 8.71158 19 12.0163 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    fire: {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","promotion","special-offer","trending","popular","burn","urgent","sales","featured"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.3211 19 18.0001 16.3127 18.0001 12.9977C18.0001 10.8233 16.6648 9.50019 16 9C16.3324 9.66693 15.7839 11.9892 14 12.0027C11.4918 12.0218 10.4837 6 9.99997 5C7.20758 6.60062 6.00005 9.5 6.00005 13C6.00005 16.315 8.71164 19 12.0163 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fire-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["fire","hot","sale","promotion","discount","popular","trending","fast","burn","energy","urgent","important","special-offer","deal","flash-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0163 19C15.321 19 18 16.3127 18 12.9977C18 10.0156 16.6703 9.50175 16.0054 9.00156C16.3378 9.66848 16.7921 11.9892 15.0081 12.0027C12.5 12.0218 12.5 6 12.0163 5C9.22391 6.60062 8.8338 9.83288 9 11L7.52849 8.00117C6.33175 8.80148 5.86637 10.9969 6.03258 12.9977C6.03258 16.3127 8.71158 19 12.0163 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fire-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["fire","hot","deal","promotion","discount","popular","trending","sale","special","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9165 4.56456C12.7957 4.31488 12.5767 4.12657 12.3117 4.04463C12.0467 3.9627 11.7596 3.99449 11.519 4.13243C9.91751 5.0504 8.99702 6.42173 8.50014 7.71127L8.42623 7.56065C8.29919 7.30176 8.06657 7.11031 7.78807 7.03545C7.50957 6.96059 7.21231 7.00961 6.97259 7.16992C6.08553 7.76313 5.5781 8.78342 5.30465 9.78614C5.02752 10.8023 4.94685 11.9543 5.0327 13.0396C5.05522 16.8847 8.17034 20 12.0163 20C15.8762 20 19 16.862 19 12.9977C19 11.3539 18.6311 10.2544 18.057 9.47556C17.6167 8.87832 17.0356 8.49103 16.7455 8.29768C16.6855 8.25769 16.6379 8.22599 16.6066 8.20245C16.236 7.92361 15.7222 7.93623 15.3657 8.23293C15.0092 8.52964 14.9035 9.03255 15.1104 9.44766C15.1432 9.51338 15.2102 9.69303 15.2596 9.94347C15.3079 10.1883 15.3267 10.4382 15.3056 10.6456C15.2836 10.8612 15.2284 10.9433 15.2139 10.9598C15.2106 10.9635 15.2065 10.9682 15.1904 10.9749C15.1709 10.9831 15.1147 11.0019 15.0005 11.0028C14.8565 11.0038 14.6604 10.9469 14.399 10.5279C14.1284 10.0942 13.9076 9.44319 13.7277 8.65964C13.5619 7.9382 13.4478 7.18581 13.3444 6.50471L13.3237 6.36836C13.2706 6.01911 13.2181 5.68078 13.1621 5.39584C13.1115 5.13852 13.0394 4.81855 12.9165 4.56456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "fish 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fish","seafood","menu","food","item","product","restaurant","order","dish"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.5685 8.36125C3.28323 8.46936 3.07039 8.73161 3.00695 9.05315C2.99016 9.17434 3.00393 9.29822 3.0468 9.41154L3.77067 11.6514C3.84318 11.8781 3.84318 12.1247 3.77067 12.3514L3.04552 14.5969C3.00447 14.7078 2.99116 14.8285 3.00695 14.9468C3.06991 15.2684 3.28224 15.5309 3.5672 15.6395C3.85215 15.7482 4.16852 15.6873 4.40196 15.4788L6.12998 14.2189C6.35486 14.0704 6.62778 14.0352 6.87828 14.1225C7.12878 14.2097 7.33229 14.4108 7.43627 14.6739C10.6557 21.7169 18.6851 19.6114 20.9531 12.3122C21.0156 12.1096 21.0156 11.8904 20.9531 11.6878C18.6851 4.3886 10.6557 2.28311 7.43627 9.32614C7.33275 9.58925 7.12968 9.79067 6.87946 9.87844C6.62924 9.96621 6.35637 9.93174 6.13126 9.78392L4.40325 8.52398C4.17015 8.31482 3.85376 8.25314 3.5685 8.36125Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10C16.5304 10 17.0391 10.2107 17.4142 10.5858C17.7893 10.9609 18 11.4696 18 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fish 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fish","seafood","menu","item","food","restaurant","order","fish-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.5685 8.36125C3.28323 8.46936 3.07039 8.73161 3.00695 9.05315C2.99016 9.17434 3.00393 9.29822 3.0468 9.41154L3.77067 11.6514C3.84318 11.8781 3.84318 12.1247 3.77067 12.3514L3.04552 14.5969C3.00447 14.7078 2.99116 14.8285 3.00695 14.9468C3.06991 15.2684 3.28224 15.5309 3.5672 15.6395C3.85215 15.7482 4.16852 15.6873 4.40196 15.4788L6.12998 14.2189C6.35486 14.0704 6.62778 14.0352 6.87828 14.1225C7.12878 14.2097 7.33229 14.4108 7.43627 14.6739C10.6557 21.7169 18.6851 19.6114 20.9531 12.3122C21.0156 12.1096 21.0156 11.8904 20.9531 11.6878C18.6851 4.3886 10.6557 2.28311 7.43627 9.32614C7.33275 9.58925 7.12968 9.79067 6.87946 9.87844C6.62924 9.96621 6.35637 9.93174 6.13126 9.78392L4.40325 8.52398C4.17015 8.31482 3.85376 8.25314 3.5685 8.36125Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10C16.5304 10 17.0391 10.2107 17.4142 10.5858C17.7893 10.9609 18 11.4696 18 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fish 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fish","seafood","menu-item","special","order","food","dish"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.535 13.1426C21.8217 12.4088 21.8217 11.5911 21.535 10.8573C20.145 7.29897 17.4042 4.89849 14.4786 4.36238C13.0085 4.09298 11.5031 4.30017 10.1467 5.06809C8.79229 5.83482 7.63353 7.13322 6.79951 8.97004C6.79397 8.98225 6.78875 8.99461 6.78387 9.0071C6.75219 9.08815 6.70114 9.12374 6.67006 9.13472C6.64566 9.14334 6.61806 9.14348 6.58665 9.12577L4.88767 7.87867C4.45294 7.50657 3.8542 7.38915 3.30706 7.59791C2.75463 7.80868 2.38009 8.30171 2.27102 8.85819C2.26829 8.87212 2.26596 8.88613 2.26402 8.90019C2.23122 9.13856 2.25604 9.38303 2.3378 9.6106L3.06415 11.8733C3.09013 11.9556 3.08989 12.0479 3.0639 12.1302L2.3358 14.4C2.25687 14.6233 2.23256 14.8625 2.26352 15.096C2.2655 15.111 2.26794 15.1259 2.27082 15.1407C2.37906 15.6971 2.7526 16.1905 3.30429 16.4023C3.85106 16.6122 4.45021 16.496 4.88576 16.1245L6.58645 14.8762C6.61815 14.858 6.64597 14.8581 6.67045 14.8667C6.70146 14.8776 6.75251 14.913 6.78431 14.9939C6.78906 15.006 6.79413 15.018 6.79951 15.0299C7.63353 16.8667 8.79229 18.1651 10.1467 18.9318C11.5031 19.6998 13.0085 19.9069 14.4786 19.6375C17.4042 19.1014 20.145 16.701 21.535 13.1426ZM16 14.5C17.3807 14.5 18.5 13.3807 18.5 12C18.5 11.337 18.2366 10.7011 17.7678 10.2322C17.2989 9.76339 16.663 9.5 16 9.5C14.6193 9.5 13.5 10.6193 13.5 12C13.5 13.3807 14.6193 14.5 16 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "fish 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["fish","menu","seafood","item","product","food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.5685 8.36125C3.28323 8.46936 3.07039 8.73161 3.00695 9.05315C2.99016 9.17434 3.00393 9.29822 3.0468 9.41154L3.77067 11.6514C3.84318 11.8781 3.84318 12.1247 3.77067 12.3514L3.04552 14.5969C3.00447 14.7078 2.99116 14.8285 3.00695 14.9468C3.06991 15.2684 3.28224 15.5309 3.5672 15.6395C3.85215 15.7482 4.16852 15.6873 4.40196 15.4788L6.12998 14.2189C6.35486 14.0704 6.62778 14.0352 6.87828 14.1225C7.12878 14.2097 7.33229 14.4108 7.43627 14.6739C10.6557 21.7169 18.6851 19.6114 20.9531 12.3122C21.0156 12.1096 21.0156 11.8904 20.9531 11.6878C18.6851 4.3886 10.6557 2.28311 7.43627 9.32614C7.33275 9.58925 7.12968 9.79067 6.87946 9.87844C6.62924 9.96621 6.35637 9.93174 6.13126 9.78392L4.40325 8.52398C4.17015 8.31482 3.85376 8.25314 3.5685 8.36125Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10C16.5304 10 17.0391 10.2107 17.4142 10.5858C17.7893 10.9609 18 11.4696 18 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fish-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fish","menu","seafood","dish","food","allergy","remove","subtract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.57441 8.29868C3.28618 8.40865 3.07112 8.67541 3.00702 9.00248C2.99006 9.12575 3.00398 9.25175 3.04729 9.36702L3.77868 11.6454C3.85194 11.876 3.85194 12.1269 3.77868 12.3574L3.04599 14.6415C3.00452 14.7543 2.99107 14.8772 3.00702 14.9975C3.07064 15.3246 3.28518 15.5916 3.57309 15.7021C3.86101 15.8127 4.18067 15.7507 4.41654 15.5386L6.16253 14.257C6.38975 14.106 6.66551 14.0702 6.91861 14.159C7.17172 14.2477 7.37735 14.4523 7.48241 14.7198C10.6048 21.5964 18.2047 19.6067 20.8364 12.8698C21.0545 12.3115 21.0545 11.6885 20.8364 11.1302C18.2047 4.39333 10.6048 2.40358 7.48241 9.28016C7.37781 9.54779 7.17263 9.75267 6.91981 9.84196C6.66699 9.93124 6.39128 9.89617 6.16383 9.74581L4.41784 8.4642C4.18232 8.25145 3.86264 8.18871 3.57441 8.29868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L17 12.0001"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fish-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fish","seafood","menu-item","add-item","order-fish","food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.57441 8.29868C3.28618 8.40865 3.07112 8.67541 3.00702 9.00248C2.99006 9.12575 3.00398 9.25175 3.04729 9.36702L3.77868 11.6454C3.85194 11.876 3.85194 12.1269 3.77868 12.3574L3.04599 14.6415C3.00452 14.7543 2.99107 14.8772 3.00702 14.9975C3.07064 15.3246 3.28518 15.5916 3.57309 15.7021C3.86101 15.8127 4.18067 15.7507 4.41654 15.5386L6.16253 14.257C6.38975 14.106 6.66551 14.0702 6.91861 14.159C7.17172 14.2477 7.37735 14.4523 7.48241 14.7198C10.6048 21.5964 18.2047 19.6067 20.8364 12.8698C21.0545 12.3115 21.0545 11.6885 20.8364 11.1302C18.2047 4.39333 10.6048 2.40358 7.48241 9.28016C7.37781 9.54779 7.17263 9.75267 6.91981 9.84196C6.66699 9.93124 6.39128 9.89617 6.16383 9.74581L4.41784 8.4642C4.18232 8.25145 3.86264 8.18871 3.57441 8.29868Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L17 12.0001"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fit-screen-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fit-screen","screen","resize","window","view","full-screen","expand","display","scale","zoom"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="8" y="9" width="8" height="6" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "fish-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fish","seafood","menu","item","food","dish","restaurant","order","sea-food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.535 13.1426C21.8217 12.4088 21.8217 11.5911 21.535 10.8573C20.145 7.29897 17.4042 4.89849 14.4786 4.36238C13.0085 4.09298 11.5031 4.30017 10.1467 5.06809C8.79229 5.83482 7.63353 7.13322 6.79951 8.97004C6.79397 8.98225 6.78875 8.99461 6.78387 9.0071C6.75219 9.08815 6.70114 9.12374 6.67006 9.13472C6.64566 9.14334 6.61806 9.14348 6.58665 9.12577L4.88767 7.87867C4.45294 7.50657 3.8542 7.38915 3.30706 7.59791C2.75463 7.80868 2.38009 8.30171 2.27102 8.85819C2.26829 8.87212 2.26596 8.88613 2.26402 8.90019C2.23122 9.13856 2.25604 9.38303 2.3378 9.6106L3.06415 11.8733C3.09013 11.9556 3.08989 12.0479 3.0639 12.1302L2.3358 14.4C2.25687 14.6233 2.23256 14.8625 2.26352 15.096C2.2655 15.111 2.26794 15.1259 2.27082 15.1407C2.37906 15.6971 2.7526 16.1905 3.30429 16.4023C3.85106 16.6122 4.45021 16.496 4.88576 16.1245L6.58645 14.8762C6.61815 14.858 6.64597 14.8581 6.67045 14.8667C6.70146 14.8776 6.75251 14.913 6.78431 14.9939C6.78906 15.006 6.79413 15.018 6.79951 15.0299C7.63353 16.8667 8.79229 18.1651 10.1467 18.9318C11.5031 19.6998 13.0085 19.9069 14.4786 19.6375C17.4042 19.1014 20.145 16.701 21.535 13.1426ZM14 13.0001L16.9999 13.0001C17.5522 13.0001 17.9999 12.5524 17.9999 12.0001C17.9999 11.4478 17.5522 11.0001 16.9999 11.0001L14 11.0001C13.4477 11 13 11.4478 13 12C13 12.5523 13.4477 13 14 13.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "fit-screen-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fit-screen","screen","adjust","display","view","window","maximize","resize","scale","full-screen","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="8"
                    y="9"
                    width="8"
                    height="6"
                    rx="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "fit-screen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fit-to-screen","expand","fullscreen","resize","maximize","view","scale","layout","display","zoom","fit","screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 4C8.95604 4 8.97799 4 9.00001 4H10C10.5523 4 11 4.44772 11 5C11 5.55229 10.5523 6 10 6H9.00001C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6.00001 8.02893 6.00001 9V10C6.00001 10.5523 5.55229 11 5.00001 11C4.44772 11 4.00001 10.5523 4.00001 10V9C4.00001 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H14C13.4477 6 13 5.55229 13 5C13 4.44772 13.4477 4 14 4H15C15.022 4 15.044 4 15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20.0001 8.04769 20 8.93417C20 8.95604 20 8.97799 20 9V10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 13C19.5523 13 20 13.4477 20 14V15C20 15.022 20 15.044 20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20C15.044 20 15.022 20 15 20H14C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18H15C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15V14C18 13.4477 18.4477 13 19 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 13C5.55229 13 6 13.4477 6 14L6.00001 15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9.00001 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H9.00001C8.97799 20 8.95604 20 8.93417 20C8.04769 20.0001 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658C4 15.044 4 15.022 4 15L4 14C4 13.4477 4.44772 13 5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.032 8H10.968C10.5294 7.99999 10.1509 7.99998 9.83762 8.02136C9.5078 8.04386 9.17788 8.09336 8.85196 8.22837C8.11687 8.53285 7.53285 9.11687 7.22837 9.85196C7.09336 10.1779 7.04386 10.5078 7.02136 10.8376C6.99998 11.1509 6.99999 11.5293 7.00001 11.968V12.032C6.99999 12.4706 6.99998 12.8491 7.02136 13.1624C7.04386 13.4922 7.09336 13.8221 7.22837 14.1481C7.53285 14.8831 8.11687 15.4672 8.85196 15.7716C9.17788 15.9066 9.5078 15.9562 9.83762 15.9787C10.1509 16 10.5294 16 10.968 16H13.032C13.4706 16 13.8491 16 14.1624 15.9787C14.4922 15.9562 14.8221 15.9066 15.1481 15.7716C15.8831 15.4672 16.4672 14.8831 16.7716 14.1481C16.9066 13.8221 16.9562 13.4922 16.9787 13.1624C17 12.8491 17 12.4707 17 12.032V11.968C17 11.5294 17 11.1509 16.9787 10.8376C16.9562 10.5078 16.9066 10.1779 16.7716 9.85196C16.4672 9.11687 15.8831 8.53285 15.1481 8.22837C14.8221 8.09336 14.4922 8.04386 14.1624 8.02136C13.8491 7.99998 13.4706 7.99999 13.032 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    fish: {
        defaultColors: ["#3D4C66"],
        keywords: ["fit-to-screen","expand","fullscreen","resize","maximize","view","scale","layout","display","zoom","fit","screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.57441 8.29868C3.28618 8.40865 3.07112 8.67541 3.00702 9.00248C2.99006 9.12575 3.00398 9.25175 3.04729 9.36702L3.77868 11.6454C3.85194 11.876 3.85194 12.1269 3.77868 12.3574L3.04599 14.6415C3.00452 14.7543 2.99107 14.8772 3.00702 14.9975C3.07064 15.3246 3.28518 15.5916 3.57309 15.7021C3.86101 15.8127 4.18067 15.7507 4.41654 15.5386L6.16253 14.257C6.38975 14.106 6.66551 14.0702 6.91861 14.159C7.17172 14.2477 7.37735 14.4523 7.48241 14.7198C10.6048 21.5964 18.2047 19.6067 20.8364 12.8698C21.0545 12.3115 21.0545 11.6885 20.8364 11.1302C18.2047 4.39333 10.6048 2.40358 7.48241 9.28016C7.37781 9.54779 7.17263 9.75267 6.91981 9.84196C6.66699 9.93124 6.39128 9.89617 6.16383 9.74581L4.41784 8.4642C4.18232 8.25145 3.86264 8.18871 3.57441 8.29868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L17 12.0001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "fit-screen": {
        defaultColors: ["#3D4C66"],
        keywords: ["fit-screen","screen","resize","adjust","layout","view","expand","full-screen","maximize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="8" y="9" width="8" height="6" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "flag 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","promotion","highlight","alert","notification","pending","reminder","important","mark","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9992 12H8C7.05719 12 6.58579 12 6.29289 11.7071C6 11.4142 6 10.9428 6 10V8.50104V7C6 6.05719 6 5.58579 6.29289 5.29289C6.58579 5 7.05719 5 8 5H15.0004C16.1945 5 16.7915 5 17.0894 5.32993C17.1746 5.42435 17.241 5.53416 17.2851 5.65348C17.4391 6.07042 17.162 6.59927 16.6078 7.65696C16.4142 8.02656 16.3174 8.21136 16.2996 8.40969C16.2942 8.46909 16.2942 8.52885 16.2995 8.58825C16.3173 8.78659 16.4141 8.97145 16.6077 9.34119C17.1625 10.4007 17.4399 10.9305 17.2851 11.3478C17.2411 11.4663 17.1752 11.5753 17.0906 11.6692C16.7927 12 16.1949 12 14.9992 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","mark","highlight","priority","important","completed","task","milestone","feature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12H14.9992C16.1949 12 16.7927 12 17.0906 11.6692C17.1752 11.5753 17.2411 11.4663 17.2851 11.3478C17.4399 10.9305 17.1625 10.4007 16.6077 9.34119V9.34119C16.4141 8.97145 16.3173 8.78659 16.2995 8.58825C16.2942 8.52885 16.2942 8.46909 16.2996 8.40969C16.3174 8.21136 16.4142 8.02656 16.6078 7.65696V7.65696C17.162 6.59927 17.4391 6.07042 17.2851 5.65348C17.241 5.53416 17.1746 5.42435 17.0894 5.32993C16.7915 5 16.1945 5 15.0004 5H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 5V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","priority","important","attention","alert","bookmark","save","highlight","promotion","featured","special-offer","reminder","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12H14.9992C16.1949 12 16.7927 12 17.0906 11.6692C17.1752 11.5753 17.2411 11.4663 17.2851 11.3478C17.4399 10.9305 17.1625 10.4007 16.6077 9.34119V9.34119C16.4141 8.97145 16.3173 8.78659 16.2995 8.58825C16.2942 8.52885 16.2942 8.46909 16.2996 8.40969C16.3174 8.21136 16.4142 8.02656 16.6078 7.65696V7.65696C17.162 6.59927 17.4391 6.07042 17.2851 5.65348C17.241 5.53416 17.1746 5.42435 17.0894 5.32993C16.7915 5 16.1945 5 15.0004 5H8C7.05719 5 6.58579 5 6.29289 5.29289C6 5.58579 6 6.05719 6 7V8.49895M6 12V8.50104M6 12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","promotion","notification","alert","highlight","important","attention","sales","discount","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.72817 6.301C5.34212 6.45113 5.15087 6.88579 5.301 7.27183C5.45113 7.65788 5.88579 7.84913 6.27183 7.699L5.72817 6.301ZM5.72817 14.301C5.34212 14.4511 5.15087 14.8858 5.301 15.2718C5.45113 15.6579 5.88579 15.8491 6.27183 15.699L5.72817 14.301ZM13.577 7.45996L13.367 8.17996L13.577 7.45996ZM13.224 15.357L13.014 16.077L13.224 15.357ZM11.2201 6.77253L11.4301 6.05253L11.2201 6.77253ZM17.25 7.83033V14.5374H18.75V7.83033H17.25ZM11.0101 7.49253L13.367 8.17996L13.787 6.73996L11.4301 6.05253L11.0101 7.49253ZM11.0101 15.4925L13.014 16.077L13.434 14.637L11.4301 14.0525L11.0101 15.4925ZM17.8407 15.8667C18.3889 15.6535 18.75 15.1256 18.75 14.5374H17.25C17.25 14.507 17.2687 14.4797 17.297 14.4687L17.8407 15.8667ZM6.27183 15.699C7.78545 15.1104 9.45102 15.0378 11.0101 15.4925L11.4301 14.0525C9.55394 13.5053 7.54962 13.5927 5.72817 14.301L6.27183 15.699ZM17.498 7.99995C17.3787 8.04635 17.25 7.95834 17.25 7.83033H18.75C18.75 6.9033 17.8183 6.26595 16.9543 6.60195L17.498 7.99995ZM16.9543 6.60195C15.9425 6.99541 14.8292 7.04393 13.787 6.73996L13.367 8.17996C14.7263 8.57641 16.1784 8.51313 17.498 7.99995L16.9543 6.60195ZM17.297 14.4687C16.063 14.9486 14.7051 15.0077 13.434 14.637L13.014 16.077C14.6022 16.5402 16.2988 16.4663 17.8407 15.8667L17.297 14.4687ZM6.27183 7.699C7.78545 7.11038 9.45102 7.0378 11.0101 7.49253L11.4301 6.05253C9.55394 5.50531 7.54962 5.59265 5.72817 6.301L6.27183 7.699Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","highlight","important","feature","pending","alert","attention","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.6201 8.53C17.6501 8.42 17.7201 8.31 17.8201 8.12C18.4701 6.89 18.8601 6.14 18.5501 5.31C18.4601 5.07 18.3301 4.85 18.1601 4.66C17.5601 4 16.7201 4 15.3301 4H6.33008C5.78008 4 5.33008 4.45 5.33008 5V8.5V18.99C5.33008 19.54 5.78008 20 6.33008 20C6.88008 20 7.33008 19.54 7.33008 18.99V12.96C7.63008 12.98 7.95008 12.99 8.33008 12.99H15.3301C16.7301 12.99 17.5701 12.99 18.1701 12.32C18.3401 12.13 18.4701 11.92 18.5601 11.68C18.8701 10.85 18.4801 10.1 17.8301 8.86C17.7301 8.67 17.6601 8.55 17.6301 8.52L17.6201 8.53Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","report","mark","important","flag-item","mark-item","alert","notification","sales-target","target","goal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.87 6.37C15.91 6.74 14.85 6.79 13.86 6.5L11.5 5.81C10.03 5.38 8.48 5.33 7 5.66V5C7 4.45 6.55 4 6 4C5.45 4 5 4.45 5 5V8.5V19C5 19.55 5.45 20 6 20C6.55 20 7 19.55 7 19V15.74C8.29 15.37 9.64999 15.35 10.94 15.73L12.94 16.31C14.58 16.79 16.33 16.71 17.93 16.09C18.58 15.84 19 15.22 19 14.53V7.83C19 6.73 17.89 5.97 16.86 6.37H16.87Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","mark","attention","highlight","important","priority","special","reminder","notification","promotion","sale","event","discount","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 14.5376V7.83057C18 7.43106 17.5985 7.15639 17.2261 7.30119C16.0604 7.75451 14.7777 7.81041 13.577 7.4602L11.2201 6.77277C9.50248 6.2718 7.66753 6.35176 6 7.00024V15.0002C7.66753 14.3518 9.50248 14.2718 11.2201 14.7728L13.224 15.3572C14.6536 15.7742 16.1809 15.7077 17.5688 15.1679C17.8288 15.0668 18 14.8165 18 14.5376Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M11.2201 6.77277L11.0101 7.49277L11.2201 6.77277ZM13.577 7.4602L13.367 8.1802L13.577 7.4602ZM11.2201 14.7728L11.0101 15.4928L11.2201 14.7728ZM13.224 15.3572L13.014 16.0772L13.224 15.3572ZM17.5688 15.1679L17.8407 15.8669L17.5688 15.1679ZM6 15.0002H5.25V16.0966L6.27183 15.6992L6 15.0002ZM17.2261 7.30119L16.9543 6.60219V6.60219L17.2261 7.30119ZM6 7.00024L5.72817 6.30124L5.25 6.48719V7.00024H6ZM17.25 7.83057V14.5376H18.75V7.83057H17.25ZM11.0101 7.49277L13.367 8.1802L13.787 6.7402L11.4301 6.05277L11.0101 7.49277ZM11.0101 15.4928L13.014 16.0772L13.434 14.6372L11.4301 14.0528L11.0101 15.4928ZM17.8407 15.8669C18.3889 15.6537 18.75 15.1258 18.75 14.5376H17.25C17.25 14.5072 17.2687 14.4799 17.297 14.4689L17.8407 15.8669ZM6.27183 15.6992C7.78545 15.1106 9.45102 15.038 11.0101 15.4928L11.4301 14.0528C9.55394 13.5056 7.54962 13.5929 5.72817 14.3012L6.27183 15.6992ZM17.498 8.00019C17.3787 8.04659 17.25 7.95858 17.25 7.83057H18.75C18.75 6.90354 17.8183 6.26619 16.9543 6.60219L17.498 8.00019ZM16.9543 6.60219C15.9425 6.99565 14.8292 7.04417 13.787 6.7402L13.367 8.1802C14.7263 8.57665 16.1784 8.51337 17.498 8.00019L16.9543 6.60219ZM17.297 14.4689C16.063 14.9488 14.7051 15.008 13.434 14.6372L13.014 16.0772C14.6022 16.5405 16.2988 16.4665 17.8407 15.8669L17.297 14.4689ZM6.27183 7.69924C7.78545 7.11062 9.45102 7.03804 11.0101 7.49277L11.4301 6.05277C9.55394 5.50556 7.54962 5.5929 5.72817 6.30124L6.27183 7.69924ZM5.25 7.00024V15.0002H6.75V7.00024H5.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 8.50104V19M6 5V8.49895"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","marker","highlight","attention","notification","reminder","alert","promotion","important","priority","special-offer","campaign","event","milestone","sale","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.72817 6.301C5.34212 6.45113 5.15087 6.88579 5.301 7.27183C5.45113 7.65788 5.88579 7.84913 6.27183 7.699L5.72817 6.301ZM5.72817 14.301C5.34212 14.4511 5.15087 14.8858 5.301 15.2718C5.45113 15.6579 5.88579 15.8491 6.27183 15.699L5.72817 14.301ZM13.577 7.45996L13.367 8.17996L13.577 7.45996ZM13.224 15.357L13.014 16.077L13.224 15.357ZM11.2201 6.77253L11.4301 6.05253L11.2201 6.77253ZM17.25 7.83033V14.5374H18.75V7.83033H17.25ZM11.0101 7.49253L13.367 8.17996L13.787 6.73996L11.4301 6.05253L11.0101 7.49253ZM11.0101 15.4925L13.014 16.077L13.434 14.637L11.4301 14.0525L11.0101 15.4925ZM17.8407 15.8667C18.3889 15.6535 18.75 15.1256 18.75 14.5374H17.25C17.25 14.507 17.2687 14.4797 17.297 14.4687L17.8407 15.8667ZM6.27183 15.699C7.78545 15.1104 9.45102 15.0378 11.0101 15.4925L11.4301 14.0525C9.55394 13.5053 7.54962 13.5927 5.72817 14.301L6.27183 15.699ZM17.498 7.99995C17.3787 8.04635 17.25 7.95834 17.25 7.83033H18.75C18.75 6.9033 17.8183 6.26595 16.9543 6.60195L17.498 7.99995ZM16.9543 6.60195C15.9425 6.99541 14.8292 7.04393 13.787 6.73996L13.367 8.17996C14.7263 8.57641 16.1784 8.51313 17.498 7.99995L16.9543 6.60195ZM17.297 14.4687C16.063 14.9486 14.7051 15.0077 13.434 14.637L13.014 16.077C14.6022 16.5402 16.2988 16.4663 17.8407 15.8667L17.297 14.4687ZM6.27183 7.699C7.78545 7.11038 9.45102 7.0378 11.0101 7.49253L11.4301 6.05253C9.55394 5.50531 7.54962 5.59265 5.72817 6.301L6.27183 7.699Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["flag","mark","highlight","important","alert","promotion","special","offer","saved-items","saved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4271 14H13V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8H16.4267C17.6107 8 18.2027 8 18.5029 8.38633C18.8032 8.77267 18.6562 9.34965 18.3623 10.5036C18.2995 10.7504 18.268 10.8738 18.268 10.9991C18.268 11.1244 18.2994 11.2479 18.3623 11.4949C18.6563 12.6499 18.8033 13.2274 18.5031 13.6137C18.2028 14 17.6109 14 16.4271 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H5V7C5 6.05719 5 5.58579 5.29289 5.29289C5.58579 5 6.05719 5 7 5H11C11.9428 5 12.4142 5 12.7071 5.29289C13 5.58579 13 6.05719 13 7V12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 12H13V7C13 6.05719 13 5.58579 12.7071 5.29289C12.4142 5 11.9428 5 11 5H7C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7V12ZM5 12V19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","promotion","notification","alert","highlight","favorite","bookmark","event","sale","special-offer","mark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4271 14H13V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8H16.4267C17.6107 8 18.2027 8 18.5029 8.38633C18.8032 8.77267 18.6562 9.34965 18.3623 10.5036C18.2995 10.7504 18.268 10.8738 18.268 10.9991C18.268 11.1244 18.2994 11.2479 18.3623 11.4949C18.6563 12.6499 18.8033 13.2274 18.5031 13.6137C18.2028 14 17.6109 14 16.4271 14Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H13V7C13 6.05719 13 5.58579 12.7071 5.29289C12.4142 5 11.9428 5 11 5H7C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7V12ZM5 12V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","important","reminder","pending","attention","alert","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H13V7C13 6.05719 13 5.58579 12.7071 5.29289C12.4142 5 11.9428 5 11 5H7C6.05719 5 5.58579 5 5.29289 5.29289C5 5.58579 5 6.05719 5 7V12ZM5 12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4271 14H13V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8H16.4267C17.6107 8 18.2027 8 18.5029 8.38633C18.8032 8.77267 18.6562 9.34965 18.3623 10.5036C18.2995 10.7504 18.268 10.8738 18.268 10.9991C18.268 11.1244 18.2994 11.2479 18.3623 11.4949C18.6563 12.6499 18.8033 13.2274 18.5031 13.6137C18.2028 14 17.6109 14 16.4271 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","important","reminder","promotion","notification","loyalty","alert","special-offer","event","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3852 11.31C19.3552 11.18 19.3152 11.03 19.3152 11C19.3152 10.97 19.3552 10.82 19.3852 10.69C19.7152 9.39 19.9152 8.6 19.3852 7.93C18.8552 7.25 18.0552 7.25 16.7152 7.25H15.2852C14.7852 7.25 14.3852 7.25 14.0352 7.31V7C14.0352 5.92 14.0352 5.28 13.5252 4.76C13.0152 4.24 12.3652 4.25 11.2852 4.25H7.28516C6.76516 4.25 6.35516 4.25 6.00516 4.31C5.82516 4.12 5.57516 4 5.28516 4C4.73516 4 4.28516 4.45 4.28516 5V19C4.28516 19.55 4.73516 20 5.28516 20C5.83516 20 6.28516 19.55 6.28516 19V12.75H12.5352V14C12.5352 14.41 12.8752 14.75 13.2852 14.75H16.7152C18.0552 14.75 18.8552 14.75 19.3852 14.07C19.9152 13.39 19.7052 12.61 19.3852 11.31Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag 5-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","mark","attention","location","important","priority","highlight","promotion","sale","event","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H15C15.9428 12 16.4142 12 16.7071 11.7071C17 11.4142 17 10.9428 17 10V7C17 6.05719 17 5.58579 16.7071 5.29289C16.4142 5 15.9428 5 15 5H7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","notification","highlight","reminder","sales-target","goal","promotion","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.41 4.59C16.82 4 16.1 4 15 4H9C9 4 8.96 4 8.94 4H7.02C7.02 4 7.01 4 7 4C7 4 7.00001 4 6.99001 4H6.93001C6.41001 4.05 6 4.47 6 5V19C6 19.55 6.45 20 7 20C7.55 20 8 19.55 8 19V12.97C8.3 12.99 8.62 13 9 13H15C16.1 13 16.83 13 17.41 12.41C18 11.82 18 11.1 18 10V7C18 5.9 18 5.17 17.41 4.59Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","promotion","event","alert","important","notification","featured","special","warning","pending","status","marking","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.72817 5.301C5.34212 5.45113 5.15087 5.88579 5.301 6.27183C5.45113 6.65788 5.88579 6.84913 6.27183 6.699L5.72817 5.301ZM5.72817 13.301C5.34212 13.4511 5.15087 13.8858 5.301 14.2718C5.45113 14.6579 5.88579 14.8491 6.27183 14.699L5.72817 13.301ZM13.577 6.45996L13.367 7.17996L13.577 6.45996ZM13.224 14.357L13.014 15.077L13.224 14.357ZM11.2201 5.77253L11.4301 5.05253L11.2201 5.77253ZM17.25 6.83033V13.5374H18.75V6.83033H17.25ZM11.0101 6.49253L13.367 7.17996L13.787 5.73996L11.4301 5.05253L11.0101 6.49253ZM11.0101 14.4925L13.014 15.077L13.434 13.637L11.4301 13.0525L11.0101 14.4925ZM17.8407 14.8667C18.3889 14.6535 18.75 14.1256 18.75 13.5374H17.25C17.25 13.507 17.2687 13.4797 17.297 13.4687L17.8407 14.8667ZM6.27183 14.699C7.78545 14.1104 9.45102 14.0378 11.0101 14.4925L11.4301 13.0525C9.55394 12.5053 7.54962 12.5927 5.72817 13.301L6.27183 14.699ZM17.498 6.99995C17.3787 7.04635 17.25 6.95834 17.25 6.83033H18.75C18.75 5.9033 17.8183 5.26595 16.9543 5.60195L17.498 6.99995ZM16.9543 5.60195C15.9425 5.99541 14.8292 6.04393 13.787 5.73996L13.367 7.17996C14.7263 7.57641 16.1784 7.51313 17.498 6.99995L16.9543 5.60195ZM17.297 13.4687C16.063 13.9486 14.7051 14.0077 13.434 13.637L13.014 15.077C14.6022 15.5402 16.2988 15.4663 17.8407 14.8667L17.297 13.4687ZM6.27183 6.699C7.78545 6.11038 9.45102 6.0378 11.0101 6.49253L11.4301 5.05253C9.55394 4.50531 7.54962 4.59265 5.72817 5.301L6.27183 6.699Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M6 9.25097V12.5V19M6 6V9.24903"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","tag","label","mark","location","loyalty","rewards","promotion","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12H15C15.9428 12 16.4142 12 16.7071 11.7071C17 11.4142 17 10.9428 17 10V7C17 6.05719 17 5.58579 16.7071 5.29289C16.4142 5 15.9428 5 15 5H9C8.05719 5 7.58579 5 7.29289 5.29289C7 5.58579 7 6.05719 7 7V12ZM7 12V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag 5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","mark","highlight","attention","reminder","important","priority","alert","notification","special-order","custom-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H9C8.05719 12 7.58579 12 7.29289 11.7071C7 11.4142 7 10.9428 7 10V7C7 6.05719 7 5.58579 7.29289 5.29289C7.58579 5 8.05719 5 9 5H15C15.9428 5 16.4142 5 16.7071 5.29289C17 5.58579 17 6.05719 17 7V10C17 10.9428 17 11.4142 16.7071 11.7071C16.4142 12 15.9428 12 15 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5V12V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","notification","alert","reminder","priority","status","attention","important","mark","saved","saved-items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8.80152V6.92062C6 6.23662 6 5.89463 6.22504 5.61869C6.45008 5.34274 6.73698 5.28384 7.31077 5.16603C8.6007 4.90119 9.94284 4.95248 11.2201 5.32502L13.577 6.01245C14.7777 6.36266 16.0604 6.30676 17.2261 5.85344C17.5985 5.70864 18 5.98331 18 6.38282V13.0899C18 13.3688 17.8288 13.6191 17.5688 13.7202C16.1809 14.2599 14.6536 14.3265 13.224 13.9095L11.2201 13.325C9.50248 12.824 7.66753 12.904 6 13.5525V8.80152Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M11.2201 5.32502L11.0101 6.04502L11.2201 5.32502ZM13.577 6.01245L13.367 6.73245L13.577 6.01245ZM11.2201 13.325L11.0101 14.045L11.2201 13.325ZM13.224 13.9095L13.014 14.6295L13.224 13.9095ZM17.5688 13.7202L17.8407 14.4192L17.5688 13.7202ZM6 13.5525H5.25V14.6489L6.27183 14.2515L6 13.5525ZM17.2261 5.85344L16.9543 5.15443V5.15443L17.2261 5.85344ZM7.31077 5.16603L7.46161 5.90071L7.31077 5.16603ZM6.22504 5.61869L6.80626 6.09269L6.80626 6.09269L6.22504 5.61869ZM5.25 6.92062V8.80152H6.75V6.92062H5.25ZM17.25 6.38282V13.0899H18.75V6.38282H17.25ZM11.0101 6.04502L13.367 6.73245L13.787 5.29245L11.4301 4.60502L11.0101 6.04502ZM11.0101 14.045L13.014 14.6295L13.434 13.1895L11.4301 12.605L11.0101 14.045ZM17.8407 14.4192C18.3889 14.206 18.75 13.6781 18.75 13.0899H17.25C17.25 13.0595 17.2687 13.0322 17.297 13.0212L17.8407 14.4192ZM6.27183 14.2515C7.78545 13.6629 9.45102 13.5903 11.0101 14.045L11.4301 12.605C9.55394 12.0578 7.54962 12.1451 5.72817 12.8535L6.27183 14.2515ZM17.498 6.55244C17.3787 6.59884 17.25 6.51083 17.25 6.38282H18.75C18.75 5.45578 17.8183 4.81843 16.9543 5.15443L17.498 6.55244ZM16.9543 5.15443C15.9425 5.5479 14.8292 5.59641 13.787 5.29245L13.367 6.73245C14.7263 7.1289 16.1784 7.06562 17.498 6.55244L16.9543 5.15443ZM17.297 13.0212C16.063 13.501 14.7051 13.5602 13.434 13.1895L13.014 14.6295C14.6022 15.0927 16.2988 15.0188 17.8407 14.4192L17.297 13.0212ZM7.46161 5.90071C8.63249 5.6603 9.85075 5.70687 11.0101 6.04502L11.4301 4.60502C10.0349 4.19809 8.56891 4.14207 7.15993 4.43136L7.46161 5.90071ZM6.75 13.5525V8.80152H5.25V13.5525H6.75ZM6.75 6.92062C6.75 6.55839 6.75161 6.36148 6.7712 6.21835C6.78665 6.10546 6.80524 6.09395 6.80626 6.09269L5.64382 5.14468C5.4198 5.41936 5.32587 5.71682 5.28506 6.01491C5.24839 6.28277 5.25 6.59886 5.25 6.92062H6.75ZM7.15993 4.43136C6.66247 4.53349 6.07016 4.62191 5.64382 5.14468L6.80626 6.09269C6.82081 6.07485 6.83024 6.06148 6.89904 6.03584C7.004 5.99672 7.15337 5.96399 7.46161 5.90071L7.15993 4.43136Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 9.25097V12.5V19M6 6V9.24903"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","report","mark","completed","priority","status","task","highlight","important","pending","hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.1124 5.15009C16.1024 5.54009 14.9824 5.59009 13.9424 5.29009L11.5824 4.60009C10.1824 4.19009 8.72237 4.14009 7.31237 4.43009C7.28237 4.43009 7.24237 4.44009 7.21237 4.45009C6.88237 4.52009 6.02237 4.76009 5.52237 5.24009C5.39237 5.35009 5.28237 5.48009 5.22237 5.65009C5.17237 5.76009 5.15237 5.88009 5.15237 6.00009C5.07237 6.10009 5.09237 6.09009 5.15237 6.05009V9.25009V19.0001C5.15237 19.5501 5.60237 20.0001 6.15237 20.0001C6.70237 20.0001 7.15237 19.5501 7.15237 19.0001V14.0401C8.46237 13.6801 9.85237 13.6701 11.1624 14.0401L13.1624 14.6201C14.7524 15.0801 16.4424 15.0101 17.9924 14.4101C18.5424 14.2001 18.9024 13.6701 18.9024 13.0801V6.38009C18.9024 5.45009 17.9724 4.82009 17.1024 5.15009H17.1124Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag-pennant-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","mark","notification","promotion","special-offer","reminder","important","pending","alert","event","milestone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.62 7.15L7 5.28V5C7 4.45 6.55 4 6 4C5.45 4 5 4.45 5 5V8.5V19C5 19.55 5.45 20 6 20C6.55 20 7 19.55 7 19V14.74C8.95 14.08 8.17 14.33 8.95 14.08L12.62 12.85C15.43 11.91 16.83 11.45 16.83 10C16.83 8.55 15.42 8.09 12.62 7.15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flag-pennant-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flag","promotion","special","event","notification","announcement","alert","sale","discount","campaign","marker","highlight"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 14L12.3079 11.8974C14.6611 11.113 15.8377 10.7208 15.8377 10C15.8377 9.27924 14.6611 8.88704 12.3079 8.10263L6 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag-pennant-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flag","pennant","promotion","sale","highlight","notification","special-offer","event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3079 11.8974L8.63246 13.1225C7.4312 13.5229 6.83058 13.7231 6.41529 13.4238C6 13.1245 6 12.4914 6 11.2251V6L12.3079 8.10263C14.6611 8.88704 15.8377 9.27924 15.8377 10C15.8377 10.7208 14.6611 11.113 12.3079 11.8974L12.3079 11.8974Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 6L12.3079 8.10263C14.6611 8.88704 15.8377 9.27924 15.8377 10C15.8377 10.7208 14.6611 11.113 12.3079 11.8974L8.63246 13.1225C7.4312 13.5229 6.83058 13.7231 6.41529 13.4238C6 13.1245 6 12.4914 6 11.2251V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flag-pennant": {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","pennant","mark","completed","priority","checkpoint","milestone","attention","notification","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8.50104V12V19M6 5V8.49895"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14L12.3079 11.8974C14.6611 11.113 15.8377 10.7208 15.8377 10C15.8377 9.27924 14.6611 8.88704 12.3079 8.10263L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    flag: {
        defaultColors: ["#3D4C66"],
        keywords: ["flag","pennant","mark","completed","priority","checkpoint","milestone","attention","notification","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9.25097V12.5V19M6 6V9.24903"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.72817 5.301C5.34212 5.45113 5.15087 5.88579 5.301 6.27183C5.45113 6.65788 5.88579 6.84913 6.27183 6.699L5.72817 5.301ZM5.72817 13.301C5.34212 13.4511 5.15087 13.8858 5.301 14.2718C5.45113 14.6579 5.88579 14.8491 6.27183 14.699L5.72817 13.301ZM13.577 6.45996L13.367 7.17996L13.577 6.45996ZM13.224 14.357L13.014 15.077L13.224 14.357ZM11.2201 5.77253L11.4301 5.05253L11.2201 5.77253ZM17.25 6.83033V13.5374H18.75V6.83033H17.25ZM11.0101 6.49253L13.367 7.17996L13.787 5.73996L11.4301 5.05253L11.0101 6.49253ZM11.0101 14.4925L13.014 15.077L13.434 13.637L11.4301 13.0525L11.0101 14.4925ZM17.8407 14.8667C18.3889 14.6535 18.75 14.1256 18.75 13.5374H17.25C17.25 13.507 17.2687 13.4797 17.297 13.4687L17.8407 14.8667ZM6.27183 14.699C7.78545 14.1104 9.45102 14.0378 11.0101 14.4925L11.4301 13.0525C9.55394 12.5053 7.54962 12.5927 5.72817 13.301L6.27183 14.699ZM17.498 6.99995C17.3787 7.04635 17.25 6.95834 17.25 6.83033H18.75C18.75 5.9033 17.8183 5.26595 16.9543 5.60195L17.498 6.99995ZM16.9543 5.60195C15.9425 5.99541 14.8292 6.04393 13.787 5.73996L13.367 7.17996C14.7263 7.57641 16.1784 7.51313 17.498 6.99995L16.9543 5.60195ZM17.297 13.4687C16.063 13.9486 14.7051 14.0077 13.434 13.637L13.014 15.077C14.6022 15.5402 16.2988 15.4663 17.8407 14.8667L17.297 13.4687ZM6.27183 6.699C7.78545 6.11038 9.45102 6.0378 11.0101 6.49253L11.4301 5.05253C9.55394 4.50531 7.54962 4.59265 5.72817 5.301L6.27183 6.699Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flashlight-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound-off","volume-off","mute","disable-sound","silence","no-sound","audio-off","notification-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7413 5.3437C16.3057 5.09758 16.9104 4.91676 17.5432 5.03944C18.2538 5.17721 18.8933 5.58042 19.3442 6.17498C19.7458 6.70444 19.8799 7.35106 19.9404 7.99122C20 8.62175 20 9.42438 20 10.3891V13.6109C20 14.5756 20 15.3782 19.9404 16.0088C19.8799 16.6489 19.7458 17.2956 19.3442 17.825C18.8933 18.4196 18.2538 18.8228 17.5432 18.9606C16.9104 19.0832 16.3057 18.9024 15.7413 18.6563C15.4502 18.5294 15.1274 18.2924 14.77 18.0299C14.4447 17.7911 14.0907 17.5312 13.7059 17.3142L13.6594 17.2879C13.3447 17.1104 13.2818 17.0785 13.2231 17.0572C13.1694 17.0377 13.1141 17.0231 13.058 17.0136C12.9967 17.0031 12.927 17 12.57 17L8.93417 17C8.04769 17.0001 7.28387 17.0001 6.67221 16.9135C6.0167 16.8207 5.38835 16.6114 4.87868 16.0747C4.36902 15.538 4.17028 14.8764 4.08215 14.1861C3.99992 13.5421 3.99995 13.003 4 12.0698L4 11.9307C3.99995 10.9975 3.99992 10.4579 4.08215 9.8139C4.17028 9.12362 4.36902 8.46196 4.87868 7.92527C5.38835 7.38858 6.0167 7.1793 6.67221 7.0865C7.28387 6.9999 8.04769 6.99995 8.93417 7L12.57 7C12.927 7 12.9967 6.99689 13.058 6.98644C13.1141 6.97686 13.1694 6.96226 13.2231 6.9428C13.2819 6.92154 13.3447 6.88962 13.6594 6.7121L13.7059 6.68583C14.0907 6.46876 14.4447 6.20888 14.77 5.97005C15.1274 5.70763 15.4502 5.47061 15.7413 5.3437ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flashlight-off-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flashlight","off","scan","item-not-found","product-not-found","scanner-error","disabled-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1_91456)">
                    <path d="M13 12H12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <path
                    d="M14.1316 16.3919V16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5.58579 15.4142 5.58579 15.4142 5.58579 15.4142C5 14.8284 5 13.8856 5 12V12C5 10.1144 5 9.17157 5.58579 8.58579C5.58579 8.58579 5.58579 8.58579 5.58579 8.58579C6.17157 8 7.11438 8 9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76202 14.1316 7.60807V7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <defs>
                    <filter
                        id="filter0_d_1_91456"
                        x="7.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91456" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91456" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flashlight","off","disabled","inactive","feature-off","function-off","hardware-off","service-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76203 14.1316 7.60808L14.1316 7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919L14.1316 16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5 14.8284 5 13.8856 5 12C5 10.1144 5 9.17157 5.58579 8.58579C6.17157 8 7.11438 8 9 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <g filter="url(#filter0_d_1_91459)">
                    <path d="M13 12H12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <defs>
                    <filter
                        id="filter0_d_1_91459"
                        x="7.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91459" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91459" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["volume","off","mute","sound","audio","notification-off","no-sound","disable-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1_91453)">
                    <path d="M13 12H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <path
                    d="M14.1316 16.3919V16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5.58579 15.4142 5.58579 15.4142 5.58579 15.4142C5 14.8284 5 13.8856 5 12V12C5 10.1144 5 9.17157 5.58579 8.58579C5.58579 8.58579 5.58579 8.58579 5.58579 8.58579C6.17157 8 7.11438 8 9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76202 14.1316 7.60807V7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <defs>
                    <filter
                        id="filter0_d_1_91453"
                        x="7.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91453" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91453" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-on-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flashlight","light","search","find","scan","illuminate","highlight","torch","bright","brightness"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1_91495)">
                    <path d="M11 12H10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <path
                    d="M12.1316 16.3919V16.3919C11.8442 16.238 11.7005 16.161 11.5483 16.1086C11.4407 16.0717 11.3302 16.044 11.218 16.0258C11.0591 16 10.8961 16 10.57 16H7C5.11438 16 4.17157 16 3.58579 15.4142C3.58579 15.4142 3.58579 15.4142 3.58579 15.4142C3 14.8284 3 13.8856 3 12V12C3 10.1144 3 9.17157 3.58579 8.58579C3.58579 8.58579 3.58579 8.58579 3.58579 8.58579C4.17157 8 5.11438 8 7 8L10.57 8C10.8961 8 11.0591 8 11.218 7.97424C11.3302 7.95605 11.4407 7.92832 11.5483 7.89135C11.7005 7.839 11.8442 7.76202 12.1316 7.60807V7.60807C13.8259 6.70039 14.6731 6.24655 15.3621 6.3734C15.8359 6.46062 16.2622 6.71589 16.5628 7.0923C17 7.63975 17 8.60083 17 10.523V13.477C17 15.3992 17 16.3602 16.5628 16.9077C16.2622 17.2841 15.8359 17.5394 15.3621 17.6266C14.6731 17.7535 13.8259 17.2996 12.1316 16.3919Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_1_91495"
                        x="5.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91495" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91495" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-on": {
        defaultColors: ["#3D4C66"],
        keywords: ["flashlight","search","find","focus","highlight","scan","locate","inventory","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_1_91489)">
                    <path d="M11 12H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <path
                    d="M12.1316 16.3919V16.3919C11.8442 16.238 11.7005 16.161 11.5483 16.1086C11.4407 16.0717 11.3302 16.044 11.218 16.0258C11.0591 16 10.8961 16 10.57 16H7C5.11438 16 4.17157 16 3.58579 15.4142C3.58579 15.4142 3.58579 15.4142 3.58579 15.4142C3 14.8284 3 13.8856 3 12V12C3 10.1144 3 9.17157 3.58579 8.58579C3.58579 8.58579 3.58579 8.58579 3.58579 8.58579C4.17157 8 5.11438 8 7 8L10.57 8C10.8961 8 11.0591 8 11.218 7.97424C11.3302 7.95605 11.4407 7.92832 11.5483 7.89135C11.7005 7.839 11.8442 7.76202 12.1316 7.60807V7.60807C13.8259 6.70039 14.6731 6.24655 15.3621 6.3734C15.8359 6.46062 16.2622 6.71589 16.5628 7.0923C17 7.63975 17 8.60083 17 10.523V13.477C17 15.3992 17 16.3602 16.5628 16.9077C16.2622 17.2841 15.8359 17.5394 15.3621 17.6266C14.6731 17.7535 13.8259 17.2996 12.1316 16.3919Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_1_91489"
                        x="5.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91489" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91489" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-on-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flashlight","search","scan","find","illuminate","light","investigate","debug","troubleshoot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8L10.57 8C10.8961 8 11.0591 8 11.218 7.97424C11.3302 7.95605 11.4407 7.92832 11.5483 7.89135C11.7005 7.839 11.8442 7.76203 12.1316 7.60808L12.1316 7.60807C13.8259 6.70039 14.6731 6.24655 15.3621 6.3734C15.8359 6.46062 16.2622 6.71589 16.5628 7.0923C17 7.63975 17 8.60083 17 10.523V13.477C17 15.3992 17 16.3602 16.5628 16.9077C16.2622 17.2841 15.8359 17.5394 15.3621 17.6266C14.6731 17.7535 13.8259 17.2996 12.1316 16.3919L12.1316 16.3919C11.8442 16.238 11.7005 16.161 11.5483 16.1086C11.4407 16.0717 11.3302 16.044 11.218 16.0258C11.0591 16 10.8961 16 10.57 16H7C5.11438 16 4.17157 16 3.58579 15.4142C3 14.8284 3 13.8856 3 12C3 10.1144 3 9.17157 3.58579 8.58579C4.17157 8 5.11438 8 7 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <g filter="url(#filter0_d_1_91501)">
                    <path d="M11 12H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                </g>
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <filter
                        id="filter0_d_1_91501"
                        x="5.25"
                        y="11.25"
                        width="10.5"
                        height="9.5"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_91501" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_91501" result="shape" />
                    </filter>
                </defs>
            </svg>
        )
    },
    "Flashlight-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mute","volume-off","disable-sound","no-sound","silent","mute-alerts","disable-notifications"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.1316 16.3919V16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5.58579 15.4142 5.58579 15.4142 5.58579 15.4142C5 14.8284 5 13.8856 5 12V12C5 10.1144 5 9.17157 5.58579 8.58579C5.58579 8.58579 5.58579 8.58579 5.58579 8.58579C6.17157 8 7.11438 8 9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76202 14.1316 7.60807V7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Flashlight-on-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flashlight","search","find","highlight","locate","scan","illumination","light"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5432 5.03944C13.9104 4.91676 13.3057 5.09758 12.7413 5.3437C12.4502 5.47061 12.1274 5.70763 11.77 5.97005C11.4447 6.20888 11.0907 6.46876 10.7059 6.68583L10.6594 6.7121C10.3447 6.88962 10.2819 6.92154 10.2231 6.9428C10.1694 6.96226 10.1141 6.97686 10.058 6.98644C9.99674 6.99689 9.92703 7 9.57004 7L5.93417 7C5.04769 6.99995 4.28387 6.9999 3.67221 7.0865C3.0167 7.1793 2.38835 7.38858 1.87868 7.92527C1.36902 8.46196 1.17028 9.12362 1.08215 9.8139C0.999924 10.4579 0.999953 10.9975 1 11.9307L1 12.0698C0.999953 13.003 0.999924 13.5421 1.08215 14.1861C1.17028 14.8764 1.36902 15.538 1.87868 16.0747C2.38835 16.6114 3.0167 16.8207 3.67221 16.9135C4.28387 17.0001 5.04769 17.0001 5.93417 17L9.57004 17C9.92703 17 9.99674 17.0031 10.058 17.0136C10.1141 17.0231 10.1694 17.0377 10.2231 17.0572C10.2818 17.0785 10.3447 17.1104 10.6594 17.2879L10.7059 17.3142C11.0907 17.5312 11.4447 17.7911 11.77 18.0299L11.77 18.03C12.1274 18.2924 12.4502 18.5294 12.7413 18.6563C13.3057 18.9024 13.9104 19.0832 14.5432 18.9606C15.2538 18.8228 15.8933 18.4196 16.3442 17.825C16.7458 17.2956 16.8799 16.6489 16.9404 16.0088C17 15.3782 17 14.5756 17 13.6109V10.3891C17 9.42438 17 8.62175 16.9404 7.99122C16.8799 7.35106 16.7458 6.70444 16.3442 6.17498C15.8933 5.58042 15.2538 5.17721 14.5432 5.03944ZM8 12C8 11.4477 8.44772 11 9 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H9C8.44772 13 8 12.5523 8 12ZM20.7076 8.70711C21.0981 8.31658 21.0981 7.68342 20.7076 7.29289C20.3171 6.90237 19.6839 6.90237 19.2934 7.29289L18.2934 8.29289C17.9029 8.68342 17.9029 9.31658 18.2934 9.70711C18.6839 10.0976 19.3171 10.0976 19.7076 9.70711L20.7076 8.70711ZM18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929C18.6834 13.9024 19.3166 13.9024 19.7071 14.2929L20.7071 15.2929C21.0976 15.6834 21.0976 16.3166 20.7071 16.7071C20.3166 17.0976 19.6834 17.0976 19.2929 16.7071L18.2929 15.7071ZM19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flashlight-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-sound","mute","sound-off","disable-sound","notification-off","silent-mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.1316 16.3919V16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5.58579 15.4142 5.58579 15.4142 5.58579 15.4142C5 14.8284 5 13.8856 5 12V12C5 10.1144 5 9.17157 5.58579 8.58579C5.58579 8.58579 5.58579 8.58579 5.58579 8.58579C6.17157 8 7.11438 8 9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76202 14.1316 7.60807V7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Flashlight-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mute","sound-off","volume-off","disable-sound","no-sound","silent","notifications-off","alerts-off","audio-off","disable-audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8L12.57 8C12.8961 8 13.0591 8 13.218 7.97424C13.3302 7.95605 13.4407 7.92832 13.5483 7.89135C13.7005 7.839 13.8442 7.76203 14.1316 7.60808L14.1316 7.60807C15.8259 6.70039 16.6731 6.24655 17.3621 6.3734C17.8359 6.46062 18.2622 6.71589 18.5628 7.0923C19 7.63975 19 8.60083 19 10.523V13.477C19 15.3992 19 16.3602 18.5628 16.9077C18.2622 17.2841 17.8359 17.5394 17.3621 17.6266C16.6731 17.7535 15.8259 17.2996 14.1316 16.3919L14.1316 16.3919C13.8442 16.238 13.7005 16.161 13.5483 16.1086C13.4407 16.0717 13.3302 16.044 13.218 16.0258C13.0591 16 12.8961 16 12.57 16H9C7.11438 16 6.17157 16 5.58579 15.4142C5 14.8284 5 13.8856 5 12C5 10.1144 5 9.17157 5.58579 8.58579C6.17157 8 7.11438 8 9 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Flashlight-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","sound-off","no-sound","volume-off","disable-sound","silence","notifications-off","alert-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L17.5458 5.03995C17.5449 5.03978 17.5441 5.03961 17.5432 5.03944C16.9104 4.91676 16.3057 5.09758 15.7413 5.3437C15.4502 5.47061 15.1274 5.70763 14.77 5.97005C14.4447 6.20888 14.0907 6.46876 13.7059 6.68583L13.6594 6.7121C13.3447 6.88962 13.2819 6.92154 13.2231 6.9428C13.1694 6.96226 13.1141 6.97686 13.058 6.98644C12.9967 6.99689 12.927 7 12.57 7L8.93417 7C8.04769 6.99995 7.28387 6.9999 6.67221 7.0865C6.0167 7.1793 5.38835 7.38858 4.87868 7.92527C4.36902 8.46196 4.17028 9.12362 4.08215 9.8139C4.0034 10.4306 4.0001 11.1942 4 12.0775L4 12.0693L4 12.1862C4.0001 13.0488 4.0034 13.5694 4.08215 14.1861C4.17028 14.8764 4.36902 15.538 4.87868 16.0747C5.1741 16.3858 5.50939 16.5869 5.86674 16.7191L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L19.7071 5.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.57 17L10.4142 17L19.8817 7.53249C19.9073 7.68464 19.926 7.83811 19.9404 7.99122C20 8.62175 20 9.42438 20 10.3891V13.6109C20 14.5756 20 15.3782 19.9404 16.0088C19.8799 16.6489 19.7458 17.2956 19.3442 17.825C18.8933 18.4196 18.2538 18.8228 17.5432 18.9606C16.9104 19.0832 16.3057 18.9024 15.7413 18.6563C15.4502 18.5294 15.1274 18.2924 14.77 18.03C14.4447 17.7911 14.0907 17.5312 13.7059 17.3142L13.6594 17.2879C13.3447 17.1104 13.2818 17.0785 13.2231 17.0572C13.1694 17.0377 13.1141 17.0231 13.058 17.0136C12.9967 17.0031 12.927 17 12.57 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flask-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flask","beaker","potion","experiment","chemistry","science","lab","ingredients","recipe","mix","formula"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14L17 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4V8.89206C9 9.44262 9 9.7179 8.92743 9.9799C8.85486 10.2419 8.71323 10.4779 8.42997 10.95L6.63479 13.942C5.02328 16.6279 4.21752 17.9708 4.79198 18.9854C5.36644 20 6.93255 20 10.0648 20H12H13.9352C17.0675 20 18.6336 20 19.208 18.9854C19.7825 17.9708 18.9767 16.6279 17.3652 13.942L15.57 10.95C15.2868 10.4779 15.1451 10.2419 15.0726 9.9799C15 9.7179 15 9.44262 15 8.89206V4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4L8 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L14.5 7L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Flask-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flask","beaker","potion","ingredients","inventory","potion-inventory","ingredients-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.99965 4C6.99965 3.44772 7.44737 3 7.99965 3H15.9997C16.5519 3 16.9997 3.44772 16.9997 4C16.9997 4.55228 16.5519 5 15.9997 5V6.98537C15.9997 6.99024 15.9998 6.99511 15.9998 7C15.9998 7.00489 15.9997 7.00976 15.9997 7.01463V8.89206C15.9997 9.49571 16.008 9.61202 16.0359 9.71297C16.0639 9.81391 16.1166 9.91793 16.4272 10.4356L18.2657 13.4997C19.0346 14.7811 19.6702 15.8403 20.0297 16.7073C20.3988 17.5972 20.5964 18.5622 20.0779 19.4781C19.5593 20.394 18.6301 20.721 17.6772 20.8623C16.7487 21.0001 15.5135 21 14.019 21H9.98026C8.48582 21 7.25055 21.0001 6.32211 20.8623C5.36919 20.721 4.43999 20.394 3.92143 19.4781C3.40288 18.5622 3.60054 17.5972 3.96959 16.7073C4.32915 15.8403 4.96471 14.7812 5.73363 13.4997L7.57213 10.4356C7.8827 9.91793 7.93541 9.81391 7.96337 9.71297C7.99133 9.61202 7.99965 9.49571 7.99965 8.89206L7.99965 5C7.44737 5 6.99965 4.55228 6.99965 4ZM13.9997 6C13.4474 6.00006 12.9998 6.44775 12.9998 7C12.9998 7.55225 13.4474 7.99994 13.9997 8L13.9996 8.98486C13.9991 9.44392 13.9987 9.8503 14.1085 10.2468C14.2183 10.6434 14.4278 10.9916 14.6644 11.385L15.6335 13L8.36584 13L9.33491 11.385C9.57151 10.9916 9.78096 10.6434 9.8908 10.2468C10.0006 9.8503 10.0002 9.44392 9.99972 8.98487L9.99965 5H13.9997V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flask-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flask","beaker","potion","ingredient","recipe","experiment","lab","chemistry","scientific","solution","mixture","chemical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.43028 10.95L6.6351 13.942C5.02359 16.6279 4.21783 17.9708 4.79229 18.9854C5.36675 20 6.93285 20 10.0651 20H13.9355C17.0678 20 18.6339 20 19.2083 18.9854C19.7828 17.9708 18.977 16.6279 17.3655 13.942L15.5703 10.95C15.2871 10.4779 15.1454 10.2419 15.0729 9.9799C15.0003 9.7179 15.0003 9.44262 15.0003 8.89206V4H9.00031V8.89206C9.00031 9.44262 9.00031 9.7179 8.92774 9.9799C8.85517 10.2419 8.71354 10.478 8.43028 10.95Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6.6351 13.942L5.99198 13.5561L6.6351 13.942ZM8.43028 10.95L9.0734 11.3359L9.0734 11.3359L8.43028 10.95ZM17.3655 13.942L18.0086 13.5561L17.3655 13.942ZM15.5703 10.95L14.9272 11.3359V11.3359L15.5703 10.95ZM19.2083 18.9854L19.861 19.3549L19.2083 18.9854ZM8.92774 9.9799L8.20495 9.7797V9.7797L8.92774 9.9799ZM15.0729 9.9799L14.3501 10.1801L14.3501 10.1801L15.0729 9.9799ZM4.79229 18.9854L5.44494 18.6159H5.44494L4.79229 18.9854ZM16.0003 4.75C16.4145 4.75 16.7503 4.41421 16.7503 4C16.7503 3.58579 16.4145 3.25 16.0003 3.25V4.75ZM8.00031 3.25C7.58609 3.25 7.25031 3.58579 7.25031 4C7.25031 4.41421 7.58609 4.75 8.00031 4.75V3.25ZM7.27822 14.3279L9.0734 11.3359L7.78716 10.5642L5.99198 13.5561L7.27822 14.3279ZM9.75031 8.89206V4H8.25031V8.89206H9.75031ZM18.0086 13.5561L16.2135 10.5642L14.9272 11.3359L16.7224 14.3279L18.0086 13.5561ZM15.7503 8.89206V4H14.2503V8.89206H15.7503ZM16.7224 14.3279C17.5412 15.6926 18.1092 16.6432 18.4139 17.3777C18.7165 18.1073 18.6694 18.415 18.5557 18.6159L19.861 19.3549C20.3217 18.5412 20.159 17.6701 19.7994 16.8031C19.442 15.9411 18.8013 14.8773 18.0086 13.5561L16.7224 14.3279ZM13.9355 20.75C15.4763 20.75 16.7181 20.752 17.6412 20.6151C18.5696 20.4773 19.4003 20.1686 19.861 19.3549L18.5557 18.6159C18.4419 18.8167 18.2023 19.0154 17.421 19.1313C16.6344 19.248 15.527 19.25 13.9355 19.25V20.75ZM9.0734 11.3359C9.33617 10.898 9.5445 10.5629 9.65052 10.1801L8.20495 9.7797C8.16584 9.92091 8.0909 10.0579 7.78716 10.5642L9.0734 11.3359ZM8.25031 8.89206C8.25031 9.48244 8.24407 9.63849 8.20495 9.7797L9.65052 10.1801C9.75655 9.79731 9.75031 9.4028 9.75031 8.89206H8.25031ZM16.2135 10.5642C15.9097 10.0579 15.8348 9.92091 15.7957 9.7797L14.3501 10.1801C14.4561 10.5629 14.6644 10.898 14.9272 11.3359L16.2135 10.5642ZM14.2503 8.89206C14.2503 9.4028 14.2441 9.79731 14.3501 10.1801L15.7957 9.7797C15.7566 9.63849 15.7503 9.48244 15.7503 8.89206H14.2503ZM5.99198 13.5561C5.19928 14.8773 4.55866 15.9411 4.20117 16.8031C3.84162 17.6701 3.67892 18.5412 4.13964 19.3549L5.44494 18.6159C5.33121 18.415 5.28415 18.1073 5.58674 17.3777C5.89139 16.6432 6.4594 15.6926 7.27822 14.3279L5.99198 13.5561ZM10.0651 19.25C8.47358 19.25 7.36623 19.248 6.57958 19.1313C5.79827 19.0154 5.55867 18.8167 5.44494 18.6159L4.13964 19.3549C4.60036 20.1686 5.43105 20.4773 6.35946 20.6151C7.28253 20.752 8.52434 20.75 10.0651 20.75V19.25ZM16.0003 3.25H15.0003V4.75H16.0003V3.25ZM15.0003 3.25H9.00031V4.75H15.0003V3.25ZM9.00031 3.25H8.00031V4.75H9.00031V3.25ZM13.9355 19.25H10.0651V20.75H13.9355V19.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 4L8 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L14.5 7L15 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14L17 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Flask-vails-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pill","medicine","medical","pharmacy","medication","healthcare","remedy","tablet","capsule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.3466 4.65352C17.8476 3.15456 15.4173 3.15455 13.9184 4.65352L8.86224 9.70964C8.71427 9.85762 8.46736 9.95566 8.1472 9.95566C4.89026 9.95566 2.25 12.5959 2.25 15.8529C2.25 19.1098 4.89026 21.7501 8.1472 21.7501C11.4041 21.7501 14.0444 19.1098 14.0444 15.8529C14.0444 15.5327 14.1424 15.2859 14.2904 15.1379L17.9627 11.4656L15.6756 9.35383C15.2851 8.96331 15.2851 8.33014 15.6756 7.93962C16.0661 7.5491 16.6993 7.5491 17.0898 7.93962L19.3768 10.0512C20.8455 8.54995 20.8354 6.14234 19.3466 4.65352ZM6 15.9999C6 15.4476 5.55228 14.9999 5 14.9999C4.44772 14.9999 4 15.4476 4 15.9999C4 18.209 5.79086 19.9999 8 19.9999C8.55229 19.9999 9 19.5522 9 18.9999C9 18.4476 8.55229 17.9999 8 17.9999C6.89543 17.9999 6 17.1044 6 15.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Flask-vails-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["earbuds","headphones","audio","sound","device","accessory","connection","bluetooth","settings","playback","volume","mute","pair","connectivity","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.1472 21C10.9899 21 13.2944 18.6955 13.2944 15.8528C13.2944 15.3926 13.4347 14.9329 13.76 14.6075L18.0517 10.3158L18.8162 9.55132C20.0223 8.34526 20.0223 6.38984 18.8162 5.18378C17.6102 3.97771 15.6548 3.97771 14.4487 5.18378L9.39257 10.2399C9.06716 10.5653 8.6074 10.7056 8.1472 10.7056C5.30448 10.7056 3 13.0101 3 15.8528C3 18.6955 5.30448 21 8.1472 21Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16.3827 8.64685L18.0517 10.3158M18.0517 10.3158L18.8162 9.55132C20.0223 8.34526 20.0223 6.38984 18.8162 5.18378V5.18378C17.6102 3.97771 15.6548 3.97771 14.4487 5.18378L9.39257 10.2399C9.06716 10.5653 8.6074 10.7056 8.1472 10.7056V10.7056C5.30448 10.7056 3 13.0101 3 15.8528C3 18.6955 5.30448 21 8.1472 21C10.9899 21 13.2944 18.6955 13.2944 15.8528V15.8528C13.2944 15.3926 13.4347 14.9329 13.76 14.6075L18.0517 10.3158Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.3828 8.64697L18.0518 10.316"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 19C6.34315 19 5 17.6569 5 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Flask: {
        defaultColors: ["#3D4C66"],
        keywords: ["earbuds","headphones","audio","sound","device","accessory","connection","bluetooth","settings","playback","volume","mute","pair","connectivity","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 4V8.89206C9 9.44262 9 9.7179 8.92743 9.9799C8.85486 10.2419 8.71323 10.4779 8.42997 10.95L6.63479 13.942C5.02328 16.6279 4.21752 17.9708 4.79198 18.9854C5.36644 20 6.93255 20 10.0648 20H12H13.9352C17.0675 20 18.6336 20 19.208 18.9854C19.7825 17.9708 18.9767 16.6279 17.3652 13.942L15.57 10.95C15.2868 10.4779 15.1451 10.2419 15.0726 9.9799C15 9.7179 15 9.44262 15 8.89206V4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4L8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L14.5 7L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Flask-vails-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["flask","vial","potion","liquid","beverage","inventory","stock","item","medical","science","dose","medicine","ingredient"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19C6.34315 19 5 17.6569 5 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.3827 8.64685L18.0517 10.3158M18.0517 10.3158L18.8162 9.55132C20.0223 8.34526 20.0223 6.38984 18.8162 5.18378V5.18378C17.6102 3.97771 15.6548 3.97771 14.4487 5.18378L9.39257 10.2399C9.06716 10.5653 8.6074 10.7056 8.1472 10.7056V10.7056C5.30448 10.7056 3 13.0101 3 15.8528C3 18.6955 5.30448 21 8.1472 21C10.9899 21 13.2944 18.6955 13.2944 15.8528V15.8528C13.2944 15.3926 13.4347 14.9329 13.76 14.6075L18.0517 10.3158Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Flask-vails": {
        defaultColors: ["#3D4C66"],
        keywords: ["scoop","spoon","portion","serving","ice-cream","measure","food","drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19C6.34315 19 5 17.6569 5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.3827 8.64685L18.0517 10.3158M18.0517 10.3158L18.8162 9.55132C20.0223 8.34526 20.0223 6.38984 18.8162 5.18378V5.18378C17.6102 3.97771 15.6548 3.97771 14.4487 5.18378L9.39257 10.2399C9.06716 10.5653 8.6074 10.7056 8.1472 10.7056V10.7056C5.30448 10.7056 3 13.0101 3 15.8528C3 18.6955 5.30448 21 8.1472 21C10.9899 21 13.2944 18.6955 13.2944 15.8528V15.8528C13.2944 15.3926 13.4347 14.9329 13.76 14.6075L18.0517 10.3158Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "flickr-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["connect","link","network","circles","relationship","associate","combine","integration","link-accounts","related"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flickr-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["more","options","settings","menu","dots","ellipsis","overflow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 8C14.2909 8 12.5 9.79086 12.5 12C12.5 14.2091 14.2909 16 16.5 16C18.7091 16 20.5 14.2091 20.5 12C20.5 9.79086 18.7091 8 16.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.5 8C5.29086 8 3.5 9.79086 3.5 12C3.5 14.2091 5.29086 16 7.5 16C9.70914 16 11.5 14.2091 11.5 12C11.5 9.79086 9.70914 8 7.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flickr-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["options","settings","preferences","accounts","users","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    flickr: {
        defaultColors: ["#3D4C66"],
        keywords: ["options","settings","preferences","accounts","users","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "floppy-disks-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["save","floppy","disk","data","backup","storage","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 7.3L15 5.51C15 5.31359 15 5.21539 14.9558 5.14325C14.9311 5.10288 14.8971 5.06894 14.8567 5.04421C14.7846 5 14.6864 5 14.49 5L9.51 5C9.31359 5 9.21539 5 9.14325 5.04421C9.10288 5.06894 9.06894 5.10288 9.04421 5.14325C9 5.21539 9 5.31359 9 5.51L9 7.3C9 7.95469 9 8.28203 9.14736 8.5225C9.22982 8.65705 9.34295 8.77018 9.4775 8.85264C9.71797 9 10.0453 9 10.7 9L13.3 9C13.9547 9 14.282 9 14.5225 8.85264C14.6571 8.77018 14.7702 8.65705 14.8526 8.5225C15 8.28203 15 7.95469 15 7.3Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "floppy-disks-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["save","floppy-disk","backup","data","export","download"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 5V7C9 7.94281 9 8.41421 9.29289 8.70711C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 8.70711C15 8.41421 15 7.94281 15 7V5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "floppy-disks-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["floppy disk","save","backup","storage","data","save-data","floppy","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4591 6.47266L18.5559 7.84379C19.12 8.54783 19.5479 9.08202 19.7745 9.72806C20.0011 10.3741 20.0007 11.0585 20.0001 11.9607L20 13.0704C20 14.4245 20.0001 15.5411 19.8813 16.4248C19.7565 17.3526 19.4845 18.1721 18.8284 18.8282C18.1723 19.4843 17.3529 19.7562 16.4251 19.881C15.5413 19.9998 14.4247 19.9998 13.0706 19.9997H10.9294C9.57531 19.9998 8.4587 19.9998 7.57494 19.881C6.64711 19.7562 5.82769 19.4843 5.17158 18.8282C4.51547 18.1721 4.2435 17.3526 4.11876 16.4248C3.99994 15.5411 3.99997 14.4244 4 13.0704V10.9291C3.99997 9.57505 3.99994 8.45842 4.11876 7.57468C4.2435 6.64685 4.51547 5.82742 5.17158 5.17132C5.82769 4.51521 6.64711 4.24324 7.57494 4.1185C8.4587 3.99968 9.57531 3.99971 10.9294 3.99974C10.2216 3.99972 9.57869 3.99995 9 4.01691V7.3C9 7.95469 9 8.28203 9.14736 8.5225C9.22982 8.65706 9.34295 8.77019 9.4775 8.85264C9.71797 9 10.0453 9 10.7 9L13.3 9C13.9547 9 14.282 9 14.5225 8.85264C14.6571 8.77019 14.7702 8.65706 14.8526 8.5225C15 8.28203 15 7.95469 15 7.3V4.27244C14.314 4.02274 13.5467 4.00077 12.5991 3.99957C13.6828 4.0009 14.5307 4.02917 15.2909 4.39453C16.1165 4.79136 16.6963 5.51738 17.4591 6.47266ZM9 14.4998C9 12.8429 10.3431 11.4998 12 11.4998C13.6569 11.4998 15 12.8429 15 14.4998C15 16.1566 13.6569 17.4998 12 17.4998C10.3431 17.4998 9 16.1566 9 14.4998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "floppy-disks": {
        defaultColors: ["#3D4C66"],
        keywords: ["save","floppy","disk","backup","data","export","configuration","settings","persist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V7C9 7.94281 9 8.41421 9.29289 8.70711C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 8.70711C15 8.41421 15 7.94281 15 7V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "flow-chart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flowchart","process","workflow","steps","sequence","diagram","automation","operations","tasks","decision","routing","path","conditional","order-processing","fulfillment","production","pipeline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L17 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8H8V4H4V8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20H19V16H15V20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 6L17 3L14 6L17 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flow-chart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["flow","chart","process","workflow","diagram","sequence","automation","nodes","steps","business-process","cashflow","analysis","reporting","decision-making"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8H8V4H4V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20H19V16H15V20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 6L17 3L14 6L17 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "flow-chart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["flow","chart","process","workflow","sequence","decision","path","conditional","automation","routing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.53 7.0275C20.82 6.7375 20.82 6.2575 20.53 5.9675L17.53 2.9675C17.24 2.6775 16.76 2.6775 16.47 2.9675L13.94 5.4975H8.75V4.4975C8.75 4.0875 8.41 3.7475 8 3.7475H4C3.59 3.7475 3.25 4.0875 3.25 4.4975V8.4975C3.25 8.9075 3.59 9.2475 4 9.2475H8C8.41 9.2475 8.75 8.9075 8.75 8.4975V7.4975H13.94L16 9.5575V15.7475H15C14.59 15.7475 14.25 16.0875 14.25 16.4975V17.4975H8.56C8.16 16.4775 7.17 15.7475 6 15.7475C4.48 15.7475 3.25 16.9775 3.25 18.4975C3.25 20.0175 4.48 21.2475 6 21.2475C7.16 21.2475 8.15 20.5175 8.56 19.4975H14.25V20.4975C14.25 20.9075 14.59 21.2475 15 21.2475H19C19.41 21.2475 19.75 20.9075 19.75 20.4975V16.4975C19.75 16.0875 19.41 15.7475 19 15.7475H18V9.5575L20.53 7.0275Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "flow-chart": {
        defaultColors: ["#3D4C66"],
        keywords: ["flow","chart","process","workflow","logic","steps","sequence","automation","transaction","pos-process","diagram","order-flow","payment-flow","inventory-flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8H8V4H4V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20H19V16H15V20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L20 6L17 3L14 6L17 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "foggy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fog","weather","environment","forecast","conditions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 16C3 15.4477 3.44772 15 4 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H4C3.44772 17 3 16.5523 3 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 16C3 15.4477 3.44772 15 4 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H4C3.44772 17 3 16.5523 3 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 19C6 18.4477 6.44772 18 7 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.25 7C7.90279 7 6 8.90279 6 11.25C6 11.8023 5.55228 12.25 5 12.25C4.44772 12.25 4 11.8023 4 11.25C4 7.79822 6.79822 5 10.25 5C12.7222 5 14.8572 6.43493 15.8711 8.51509C18.1828 8.7038 20 10.6397 20 13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13C18 11.9655 17.3717 11.0778 16.4759 10.6976C16.4918 10.8797 16.5 11.064 16.5 11.25C16.5 11.8023 16.0523 12.25 15.5 12.25C14.9477 12.25 14.5 11.8023 14.5 11.25C14.5 10.7552 14.4158 10.2821 14.2619 9.84311C13.6808 8.18594 12.1026 7 10.25 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "foggy-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["fog","mist","weather","environment","forecast","visibility","alert","warning","notification","service-unavailable","down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15H4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 11.25C15.5 10.6409 15.3963 10.0561 15.2056 9.51221M5 11.25C5 8.35051 7.35051 6 10.25 6C12.5404 6 14.4883 7.46675 15.2056 9.51221M19 13C19 11.067 17.433 9.5 15.5 9.5C15.4008 9.5 15.3026 9.50412 15.2056 9.51221"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "foggy-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["fog","weather","environment","mist","condition","forecast","visibility","climate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 11.25C15.5 10.6409 15.3963 10.0561 15.2056 9.51221M5 11.25C5 8.35051 7.35051 6 10.25 6C12.5404 6 14.4883 7.46675 15.2056 9.51221M19 13C19 11.067 17.433 9.5 15.5 9.5C15.4008 9.5 15.3026 9.50412 15.2056 9.51221"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    foggy: {
        defaultColors: ["#3D4C66"],
        keywords: ["fog","weather","environment","mist","condition","forecast","visibility","climate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 11.25C15.5 10.6409 15.3963 10.0561 15.2056 9.51221M5 11.25C5 8.35051 7.35051 6 10.25 6C12.5404 6 14.4883 7.46675 15.2056 9.51221M19 13C19 11.067 17.433 9.5 15.5 9.5C15.4008 9.5 15.3026 9.50412 15.2056 9.51221"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder dots-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","directory","archive","documents","files","inventory","reports","data","record","transactions","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14.5C8 15.3284 8.67157 16 9.5 16C9.91421 16 10.2892 15.8321 10.5607 15.5607C10.8321 15.2892 11 14.9142 11 14.5C11 13.6716 10.3284 13 9.5 13C8.67157 13 8 13.6716 8 14.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14.5C13 15.3284 13.6716 16 14.5 16C14.9142 16 15.2892 15.8321 15.5607 15.5607C15.8321 15.2892 16 14.9142 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder dots-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","archive","directory","storage","documents","reports","records","sales-data","customer-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14.5C8 15.3284 8.67157 16 9.5 16C9.91421 16 10.2892 15.8321 10.5607 15.5607C10.8321 15.2892 11 14.9142 11 14.5C11 13.6716 10.3284 13 9.5 13C8.67157 13 8 13.6716 8 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14.5C13 15.3284 13.6716 16 14.5 16C14.9142 16 15.2892 15.8321 15.5607 15.5607C15.8321 15.2892 16 14.9142 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder dots": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","dots","reports","sales-data","inventory","records","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14.5C8 15.3284 8.67157 16 9.5 16C9.91421 16 10.2892 15.8321 10.5607 15.5607C10.8321 15.2892 11 14.9142 11 14.5C11 13.6716 10.3284 13 9.5 13C8.67157 13 8 13.6716 8 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 14.5C13 15.3284 13.6716 16 14.5 16C14.9142 16 15.2892 15.8321 15.5607 15.5607C15.8321 15.2892 16 14.9142 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","heart","favorites","customer-loyalty","customer","loyalty","profile","saved-items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L9.44877 13.7065C8.82381 13.0427 8.8552 12.0338 9.52037 11.4058C10.5 10.6648 11.1429 11.0143 12 11.8455C12.8572 11.0143 13.5 10.6647 14.4796 11.4057C15.1448 12.0338 15.1762 13.0426 14.5512 13.7065L12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder dots-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","files","documents","archive","more","options","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM9.5 12.5C8.39543 12.5 7.5 13.3954 7.5 14.5C7.5 15.6046 8.39543 16.5 9.5 16.5C10.0521 16.5 10.5528 16.2756 10.9142 15.9142C11.2756 15.5528 11.5 15.0521 11.5 14.5C11.5 13.3954 10.6046 12.5 9.5 12.5ZM14.5 12.5C13.3954 12.5 12.5 13.3954 12.5 14.5C12.5 15.6046 13.3954 16.5 14.5 16.5C15.0521 16.5 15.5528 16.2756 15.9142 15.9142C16.2756 15.5528 16.5 15.0521 16.5 14.5C16.5 13.3954 15.6046 12.5 14.5 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder heart-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","heart","favorites","customers","loyalty","rewards","saved-orders","profile","customer-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L9.44877 13.7065C8.82381 13.0427 8.8552 12.0338 9.52037 11.4058C10.5 10.6648 11.1429 11.0143 12 11.8455C12.8572 11.0143 13.5 10.6647 14.4796 11.4057C15.1448 12.0338 15.1762 13.0426 14.5512 13.7065L12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","favorites","loyalty","customer-data","customer-profile","rewards","heart","saved-items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM9.44877 13.7065L12 16L14.5512 13.7065C15.1762 13.0426 15.1448 12.0338 14.4796 11.4057C13.5 10.6647 12.8572 11.0143 12 11.8455C11.1429 11.0143 10.5 10.6648 9.52037 11.4058C8.8552 12.0338 8.82381 13.0427 9.44877 13.7065Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","heart","favorites","saved","reports","loyalty","customer-data","customer-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L9.44877 13.7065C8.82381 13.0427 8.8552 12.0338 9.52037 11.4058C10.5 10.6648 11.1429 11.0143 12 11.8455C12.8572 11.0143 13.5 10.6647 14.4796 11.4057C15.1448 12.0338 15.1762 13.0426 14.5512 13.7065L12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder user-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","user","profile","account","customer","employee","directory","clients"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9.18638 18.2545L9.38638 17.4545C9.44095 17.2362 9.46823 17.1271 9.54961 17.0635C9.63099 17 9.74348 17 9.96847 17H14.0315C14.2565 17 14.369 17 14.4504 17.0635C14.5318 17.1271 14.5591 17.2362 14.6136 17.4545L14.6136 17.4545L14.8136 18.2545C14.8994 18.5977 14.9423 18.7692 14.8522 18.8846C14.7621 19 14.5853 19 14.2315 19H9.76847C9.41472 19 9.23785 19 9.14777 18.8846C9.05769 18.7692 9.10059 18.5977 9.18638 18.2545Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder user-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["folder","user","customer","profile","directory","clients","customer-folder","user-folder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 19L9.12127 18.5149C9.30316 17.7874 9.3941 17.4236 9.66536 17.2118C9.93663 17 10.3116 17 11.0616 17H12.9384C13.6884 17 14.0634 17 14.3346 17.2118C14.6059 17.4236 14.6968 17.7874 14.8787 18.5149L15 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="13" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Folder user-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","user","customer","profile","account","customer-folder","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM9.99763 12.4451C9.99763 11.3461 10.8996 10.4441 11.9976 10.4451C13.0966 10.4451 13.9976 11.3461 13.9976 12.4451C13.9976 13.5431 13.0966 14.4131 11.9976 14.4131C10.8996 14.4131 9.99763 13.5431 9.99763 12.4451ZM9.77805 15.1631C9.78857 15.1631 9.79942 15.1631 9.81062 15.1631H14.1856C14.1968 15.1631 14.2077 15.1631 14.2182 15.1631C14.4519 15.1629 14.5239 15.1629 14.6856 15.2261C14.8066 15.2721 14.9016 15.3571 14.9976 15.4451C15.1326 15.5671 15.1636 15.6201 15.2796 15.8511C15.2939 15.8797 15.3076 15.9071 15.3207 15.9332C15.5533 16.398 15.6006 16.4925 15.5296 16.8191C15.4776 17.0531 15.3406 17.2631 15.1536 17.4131C14.8796 17.6351 14.7866 17.6631 14.1856 17.6631H9.81062C9.20962 17.6631 9.11563 17.6341 8.84163 17.4131C8.65463 17.2631 8.51763 17.0531 8.46663 16.8191C8.39163 16.4751 8.41662 16.3881 8.68562 15.8511C8.79773 15.6269 8.85941 15.5708 8.98437 15.4571C8.98871 15.4532 8.99313 15.4492 8.99763 15.4451C9.09363 15.3571 9.18962 15.2721 9.31062 15.2261C9.47234 15.1629 9.54432 15.1629 9.77805 15.1631Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["folder","directory","category","archive","sales-report","inventory","reports","data","management","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder user": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","user","customer","profile","account","directory","clients","sales-person","manager","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="13" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 19L9.12127 18.5149C9.30316 17.7874 9.3941 17.4236 9.66536 17.2118C9.93663 17 10.3116 17 11.0616 17H12.9384C13.6884 17 14.0634 17 14.3346 17.2118C14.6059 17.4236 14.6968 17.7874 14.8787 18.5149L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","sales-report","reports","transactions","archive","organization","categories","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4C7.95604 4 7.97799 4 8 4H8.8769C8.89551 4 8.91407 4 8.93256 4C9.63488 3.99996 10.2482 3.99993 10.7508 4.06003C11.2934 4.12491 11.8165 4.2698 12.2847 4.63539C12.7529 5.00097 13.0204 5.47327 13.2149 5.9839C13.3951 6.45693 13.5438 7.05198 13.7141 7.73335L13.7276 7.78733C13.7589 7.91232 13.8712 8 14 8L16.0658 8C16.9523 7.99995 17.7161 7.99991 18.3278 8.08215C18.9833 8.17028 19.6117 8.36902 20.1213 8.87868C20.631 9.38835 20.8297 10.0167 20.9179 10.6722C21.0001 11.2839 21.0001 12.0477 21 12.9342V15.0658C21.0001 15.9523 21.0001 16.7161 20.9179 17.3278C20.8297 17.9833 20.631 18.6117 20.1213 19.1213C19.6117 19.631 18.9833 19.8297 18.3278 19.9179C17.7161 20.0001 16.9523 20.0001 16.0658 20H7.93417C7.04769 20.0001 6.28387 20.0001 5.67221 19.9179C5.0167 19.8297 4.38835 19.631 3.87868 19.1213C3.36902 18.6117 3.17028 17.9833 3.08215 17.3278C2.99991 16.7161 2.99995 15.9523 3 15.0658L3 9C3 8.97799 3 8.95604 3 8.93417C2.99995 8.04769 2.99991 7.28387 3.08215 6.67221C3.17028 6.0167 3.36902 5.38835 3.87868 4.87868C4.38835 4.36902 5.0167 4.17028 5.67221 4.08215C6.28387 3.99991 7.04769 3.99995 7.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 8.75951V8C21 6.34315 19.6569 5 18 5H13.5767C13.7161 5.23666 13.8252 5.47926 13.9157 5.71691C14.0848 6.1606 14.2256 6.69179 14.3662 7.25002L16.0996 7.25001C16.9562 7.24988 17.765 7.24975 18.4277 7.33885C19.1664 7.43816 19.9794 7.67613 20.6517 8.34837C20.7838 8.48052 20.8992 8.61811 21 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-arrow-down-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","download","archive","import","backup","save","export","data","arrow","arrow-down-left","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16V13.3333M10 16H12.6667M10 16L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","directory","category","sales-records","reports","files","inventory-records","documents","archive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-arrow-down-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","download","arrow","archive","import","data","storage","retrieve","transaction-history","sales-report","download-report","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929C14.3166 10.9024 13.6834 10.9024 13.2929 11.2929L11 13.5858V13.3333C11 12.781 10.5523 12.3333 10 12.3333C9.44772 12.3333 9 12.781 9 13.3333V16C9 16.5523 9.44772 17 10 17H12.6667C13.219 17 13.6667 16.5523 13.6667 16C13.6667 15.4477 13.219 15 12.6667 15H12.4142L14.7071 12.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-arrow-down-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","download","archive","save","export","backup","history","transactions","reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16V13.3333M10 16H12.6667M10 16L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-arrow-down-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","download","import","archive","save","arrow-down","get-data","retrieve","backup","export","download-data","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16V13.3333M10 16H12.6667M10 16L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","delete","remove","archive","cancel","close","discard","clear","file","rejected","declined"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM10.7071 10.2929C10.3166 9.90237 9.68342 9.90237 9.29289 10.2929C8.90237 10.6834 8.90237 11.3166 9.29289 11.7071L10.5858 13L9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L12 14.4142L13.2929 15.7071C13.6834 16.0976 14.3166 16.0976 14.7071 15.7071C15.0976 15.3166 15.0976 14.6834 14.7071 14.2929L13.4142 13L14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L12 11.5858L10.7071 10.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["folder","remove","delete","cancel","close","archive","discard","reject","error","no-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V7C4 5.89543 4.89543 5 6 5H9.76393C10.7343 5 11.2194 5 11.63 5.19724C11.7572 5.25834 11.8775 5.33272 11.9891 5.41915L11.9891 5.41916C13.0807 6.26515 13.6265 6.68815 13.7815 6.76975C14.0902 6.93225 14.022 6.90891 14.3655 6.96955C14.538 7 14.6557 7 14.8912 7H16C17.8856 7 18.8284 7 19.4142 7.58579C20 8.17157 20 9.11438 20 11V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-cross-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","remove","delete","cancel","discard","archive","closed","void","rejected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V11C20 9.11438 20 8.17157 19.4142 7.58579C18.8284 7 17.8856 7 16 7H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 7V7C4 5.89543 4.89543 5 6 5H9.76393C10.7343 5 11.2194 5 11.63 5.19724C11.7572 5.25834 11.8775 5.33272 11.9891 5.41915C12.3491 5.69817 12.5661 6.13211 13 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-download-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","download","import","receive","backup","restore","data","archive","receive-data","import-data","download-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L10.2111 15.1056C11.089 15.5445 11.5279 15.7639 12 15.7639C12.4721 15.7639 12.911 15.5445 13.7889 15.1056L14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","cross","delete","remove","archive","cancel","discard","clear-folder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V11C20 9.11438 20 8.17157 19.4142 7.58579C18.8284 7 17.8856 7 16 7H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 7V7C4 5.89543 4.89543 5 6 5H9.76393C10.7343 5 11.2194 5 11.63 5.19724C11.7572 5.25834 11.8775 5.33272 11.9891 5.41915C12.3491 5.69817 12.5661 6.13211 13 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-download-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","download","archive","import","data","backup","reports","sales-data","download-reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L10.2111 15.1056C11.089 15.5445 11.5279 15.7639 12 15.7639C12.4721 15.7639 12.911 15.5445 13.7889 15.1056L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Folder-download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","download","import","data","archive","backup","restore","catalog","inventory","file","get","receive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V14.3805C10.8982 14.3306 10.7849 14.2744 10.6584 14.2111L10.4472 14.1056C9.95324 13.8586 9.35257 14.0588 9.10558 14.5528C8.85859 15.0468 9.05881 15.6474 9.55279 15.8944L9.76394 16L9.91376 16.0751C10.6397 16.4398 11.2851 16.7639 12 16.7639C12.7149 16.7639 13.3603 16.4398 14.0862 16.0751L14.0863 16.0751L14.2361 16L14.4472 15.8944C14.9412 15.6474 15.1414 15.0468 14.8944 14.5528C14.6474 14.0588 14.0468 13.8586 13.5528 14.1056L13.3416 14.2111C13.2151 14.2744 13.1018 14.3306 13 14.3805V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-download": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","download","import","archive","data","backup","restore","file","load"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L10.2111 15.1056C11.089 15.5445 11.5279 15.7639 12 15.7639C12.4721 15.7639 12.911 15.5445 13.7889 15.1056L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-gallery-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","gallery","image","media","categories","inventory","products","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0556 16H10.6797C9.05668 16 8.24519 16 7.96122 15.4775C7.67725 14.9551 8.11862 14.2741 9.00135 12.9122L9.26786 12.501C10.0016 11.369 10.3684 10.803 10.9016 10.7945C11.4347 10.786 11.8195 11.34 12.5889 12.448L13.0648 13.1333M15.0556 16H11.2857M15.0556 16V16C15.2163 16 15.2966 16 15.3519 15.9938C16.0273 15.9185 16.4324 15.2059 16.1517 14.587C16.1288 14.5363 16.0877 14.4673 16.0054 14.3292L15.2751 13.1021C15.0624 12.7448 14.956 12.5662 14.8491 12.4676C14.4582 12.1069 13.8533 12.1155 13.4727 12.487C13.3686 12.5886 13.2673 12.7702 13.0648 13.1333V13.1333M15.0556 16L13.0648 13.1333"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-gallery-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","gallery","images","media","catalog","inventory","products","categories","menu","files"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0556 16H10.6797C9.05668 16 8.24519 16 7.96122 15.4775C7.67725 14.9551 8.11862 14.2741 9.00135 12.9122L9.26786 12.501C10.0016 11.369 10.3684 10.803 10.9016 10.7945C11.4347 10.786 11.8195 11.34 12.5889 12.448L13.0648 13.1333M15.0556 16H11.2857M15.0556 16V16C15.2163 16 15.2966 16 15.3519 15.9938C16.0273 15.9185 16.4324 15.2059 16.1517 14.587C16.1288 14.5363 16.0877 14.4673 16.0054 14.3292L15.2751 13.1021C15.0624 12.7448 14.956 12.5662 14.8491 12.4676C14.4582 12.1069 13.8533 12.1155 13.4727 12.487C13.3686 12.5886 13.2673 12.7702 13.0648 13.1333V13.1333M15.0556 16L13.0648 13.1333"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-gallery": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","gallery","images","archive","organized","storage","directory","media","photos","records","collection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0556 16H10.6797C9.05668 16 8.24519 16 7.96122 15.4775C7.67725 14.9551 8.11862 14.2741 9.00135 12.9122L9.26786 12.501C10.0016 11.369 10.3684 10.803 10.9016 10.7945C11.4347 10.786 11.8195 11.34 12.5889 12.448L13.0648 13.1333M15.0556 16H11.2857M15.0556 16V16C15.2163 16 15.2966 16 15.3519 15.9938C16.0273 15.9185 16.4324 15.2059 16.1517 14.587C16.1288 14.5363 16.0877 14.4673 16.0054 14.3292L15.2751 13.1021C15.0624 12.7448 14.956 12.5662 14.8491 12.4676C14.4582 12.1069 13.8533 12.1155 13.4727 12.487C13.3686 12.5886 13.2673 12.7702 13.0648 13.1333V13.1333M15.0556 16L13.0648 13.1333"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-gallery-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","gallery","images","media","storage","archive","records","files","documents","organize","inventory","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM12.2035 10.6893C12.4738 10.9773 12.7589 11.3787 13.0773 11.8365C13.745 11.3008 14.7159 11.3244 15.3576 11.9163C15.4805 12.0296 15.5743 12.1615 15.65 12.2771C15.7253 12.3923 15.812 12.5379 15.9116 12.7052L16.6499 13.9455L16.668 13.976C16.7313 14.082 16.7937 14.1867 16.8347 14.2772C17.326 15.3603 16.617 16.6073 15.4351 16.7392C15.3364 16.7502 15.2145 16.7501 15.091 16.75H15.091L15.0555 16.75H10.6796L10.6204 16.75C9.85962 16.7501 9.20497 16.7501 8.70849 16.6766C8.19699 16.6009 7.61723 16.4152 7.30226 15.8357C6.98728 15.2562 7.14678 14.6687 7.36146 14.1983C7.56982 13.7417 7.92592 13.1924 8.33972 12.554L8.33973 12.554L8.37197 12.5043L8.63848 12.0931L8.66857 12.0467C9.00952 11.5205 9.30998 11.0569 9.59696 10.7309C9.9023 10.384 10.3111 10.0539 10.8896 10.0446C11.4681 10.0354 11.8872 10.3524 12.2035 10.6893ZM15.4052 15.1887L13.951 13.0945C13.9817 13.0452 13.9976 13.0242 14.0016 13.0189C14.0953 12.9324 14.2393 12.9303 14.3354 13.0141C14.3399 13.0197 14.3584 13.0427 14.3949 13.0986C14.4506 13.1837 14.5208 13.3013 14.6306 13.4857L15.361 14.7128C15.4034 14.784 15.4305 14.8296 15.4501 14.8639C15.4632 14.8867 15.4686 14.897 15.4698 14.8993C15.5162 15.0045 15.4838 15.12 15.4052 15.1887Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-less-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","remove","discount","minus","subtract","delete","remove-item","delete-item","discount-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-less-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","remove","subtract","delete","archive","discount","reduce","folder-remove","category-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-less": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","remove","delete","subtract","discount","remove-item","delete-item","void","void-item","minus","less","decrease","reduce","discount-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["folder","directory","remove","delete","archive","documents","reports","data","records","transaction-history","sales-data","customer-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-less-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["folder","remove","minus","delete","discount","remove-item","delete-item","void","void-item","cancel","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509C12.9644 7.89329 13.1125 8 13.2792 8H16C17.8856 8 18.8284 8 19.4142 8.58579C20 9.17157 20 10.1144 20 12V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","remove","delete","archive","file","discount","remove-discount","delete-file","subtract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","category","archive","storage","file","documents","reports","inventory","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","remove","delete","archive","minus","discount","file","remove-file","delete-file","archive-file","manage-files","remove-folder","delete-folder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-music-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","music","audio","files","media","playlist","songs","entertainment","folder-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4L8 4H8.8769L8.93256 4C9.63488 3.99996 10.2482 3.99993 10.7508 4.06003C11.2934 4.12491 11.8165 4.2698 12.2847 4.63539C12.7529 5.00097 13.0204 5.47327 13.2149 5.9839C13.3951 6.45692 13.5438 7.05194 13.7141 7.73328L13.7141 7.73332L13.7141 7.73335L13.7276 7.78733C13.7589 7.91232 13.8712 8 14 8L16.0658 8H16.0659C16.9523 7.99995 17.7161 7.99991 18.3278 8.08215C18.9833 8.17028 19.6117 8.36902 20.1213 8.87868C20.631 9.38835 20.8297 10.0167 20.9179 10.6722C21.0001 11.2839 21.0001 12.0477 21 12.9342V15.0658C21.0001 15.9523 21.0001 16.7161 20.9179 17.3278C20.8297 17.9833 20.631 18.6117 20.1213 19.1213C19.6117 19.631 18.9833 19.8297 18.3278 19.9179C17.7161 20.0001 16.9523 20.0001 16.0658 20H7.93417C7.04769 20.0001 6.28387 20.0001 5.67221 19.9179C5.0167 19.8297 4.38835 19.631 3.87868 19.1213C3.36902 18.6117 3.17028 17.9833 3.08215 17.3278C2.99991 16.7161 2.99995 15.9523 3 15.0658L3 9L3 8.93417C2.99995 8.04769 2.99991 7.28387 3.08215 6.67221C3.17028 6.0167 3.36902 5.38835 3.87868 4.87868C4.38835 4.36902 5.0167 4.17028 5.67221 4.08215C6.28387 3.99991 7.04769 3.99995 7.93417 4ZM13.7071 10.2929C13.4211 10.0069 12.991 9.92137 12.6173 10.0761C12.2436 10.2309 12 10.5956 12 11V12.0555C11.8448 12.0226 11.6846 12.0037 11.521 12.0002C11.507 12 11.493 12 11.479 12.0002C10.1211 12.0288 9 13.1204 9 14.5C9 15.8797 10.1211 16.9713 11.479 16.9998C11.493 17.0001 11.507 17.0001 11.521 16.9998C12.8789 16.9713 14 15.8797 14 14.5V13C14.2559 13 14.5118 12.9024 14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929L13.7071 10.2929ZM11.5 14.0006C11.7979 14.0173 12 14.2533 12 14.5C12 14.7467 11.7979 14.9827 11.5 14.9994C11.2021 14.9827 11 14.7467 11 14.5C11 14.2533 11.2021 14.0173 11.5 14.0006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-music-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","music","playlist","audio","media","entertainment","record","track","songs","files","collection","music-library"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-music-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["music","folder","media","entertainment","audio","playlist","juke-box","background-music","soundtrack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 14.5V11V14.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 16C10.6664 15.9825 10 15.3161 10 14.5C10 13.6839 10.6664 13.0175 11.5 13C12.3336 13.0175 13 13.6839 13 14.5C13 15.3161 12.3336 15.9825 11.5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-music-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["folder","music","song","files","media","entertainment","playlist","audio","folder-music","catalogue","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-music-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","music","audio","media","content","playlist","entertainment","record","sound","track","files","songs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-music-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","music","entertainment","media","files","audio","songs","playlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM13.7071 10.2929C13.4211 10.0069 12.991 9.92137 12.6173 10.0761C12.2436 10.2309 12 10.5956 12 11V12.0555C11.8448 12.0226 11.6846 12.0037 11.521 12.0002C11.507 12 11.493 12 11.479 12.0002C10.1211 12.0288 9 13.1204 9 14.5C9 15.8797 10.1211 16.9713 11.479 16.9998C11.493 17.0001 11.507 17.0001 11.521 16.9998C12.8789 16.9713 14 15.8797 14 14.5V13C14.2559 13 14.5118 12.9024 14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929L13.7071 10.2929ZM11.5 14.0006C11.7979 14.0173 12 14.2533 12 14.5C12 14.7467 11.7979 14.9827 11.5 14.9994C11.2021 14.9827 11 14.7467 11 14.5C11 14.2533 11.2021 14.0173 11.5 14.0006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-music": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","music","media","playlist","files","archive","entertainment","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-open-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["folder","directory","open","browse","files","archive","history","reports","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.45682 13.9011L6 12H17.3599C19.1674 12 20.0711 12 20.6269 12.4619C20.8649 12.6597 21.0538 12.9101 21.1787 13.1934C21.4701 13.8546 21.2218 14.7236 20.7253 16.4615C20.4275 17.5037 20.2786 18.0248 19.9369 18.3822C19.7878 18.5382 19.6143 18.6691 19.4233 18.7696C18.9858 19 18.4438 19 17.3599 19H9.30292C6.8709 19 5.65489 19 5.05476 18.2044C4.45463 17.4088 4.7887 16.2396 5.45682 13.9011Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-music-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["music","folder","audio","entertainment","playlist","jukebox","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509C12.9644 7.89329 13.1125 8 13.2792 8H16C17.8856 8 18.8284 8 19.4142 8.58579C20 9.17157 20 10.1144 20 12V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 14.5V11V14.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 16C10.6664 15.9825 10 15.3161 10 14.5C10 13.6839 10.6664 13.0175 11.5 13C12.3336 13.0175 13 13.6839 13 14.5C13 15.3161 12.3336 15.9825 11.5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 14.5V11L14 12M13 14.5C13 13.6839 12.3336 13.0175 11.5 13C10.6664 13.0175 10 13.6839 10 14.5C10 15.3161 10.6664 15.9825 11.5 16C12.3336 15.9825 13 15.3161 13 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","open","directory","browse","files","documents","records","reports","transactions","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0033 8.85961V8.1001C21.0033 6.44325 19.6602 5.1001 18.0033 5.1001H13.58C13.7195 5.33676 13.8285 5.57936 13.9191 5.81701C14.0881 6.2607 14.229 6.79189 14.3696 7.35012L16.103 7.35011C16.9595 7.34998 17.7684 7.34985 18.4311 7.43895C19.1697 7.53826 19.9827 7.77623 20.655 8.44847C20.7871 8.58062 20.9025 8.71821 21.0033 8.85961Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.9375 4.1001C7.05102 4.10005 6.29916 4.11161 5.6875 4.19385C5.03199 4.28198 4.38467 4.46544 3.875 4.9751C3.36534 5.48477 3.18188 6.13209 3.09375 6.7876C3.01151 7.39926 2.99995 8.15112 3 9.0376C3 9.05947 3 9.07809 3 9.1001V15.1626C2.99999 15.3352 3.03065 15.437 3.03125 15.6001C3.13055 15.0774 3.17391 14.6787 3.5 13.5376C3.51039 13.5013 4.0625 11.5376 4.0625 11.5376C4.3078 10.679 5.10703 10.1001 6 10.1001C7.41999 10.1001 17.4042 10.1001 17.4062 10.1001C18.6638 10.1001 19.1506 10.1031 19.6875 10.1626C20.1511 10.2139 20.4674 10.4488 20.8438 10.6001C20.7427 10.0157 20.5838 9.43392 20.125 8.9751C19.6154 8.46544 18.968 8.28198 18.3125 8.19385C17.7008 8.11161 16.949 8.10005 16.0625 8.1001H14C13.8712 8.1001 13.7501 8.00634 13.7188 7.88135V7.81885C13.5484 7.13748 13.399 6.54188 13.2188 6.06885C13.0243 5.55822 12.7494 5.09068 12.2812 4.7251C11.813 4.35951 11.2926 4.22748 10.75 4.1626C10.2474 4.1025 9.63982 4.10006 8.9375 4.1001C8.91901 4.1001 8.89361 4.1001 8.875 4.1001H8C7.97799 4.1001 7.95937 4.1001 7.9375 4.1001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 11.3501C5.66514 11.3501 5.37324 11.5594 5.28125 11.8813L4.75 13.7876C3.82853 17.0128 3.72594 17.7716 4.46875 18.7563C5.21156 19.7411 5.95834 19.8501 9.3125 19.8501H17.375C18.8786 19.8501 19.2418 19.8217 19.7812 19.5376C20.0437 19.3995 20.2636 19.221 20.4688 19.0063C20.7384 18.7243 20.9238 18.3913 21.0938 17.9126C21.1872 17.6494 21.252 17.4055 21.4375 16.7563C22.123 14.3568 22.2364 13.8264 21.875 13.0063C21.7033 12.6168 21.421 12.2471 21.0938 11.9751C20.4044 11.4022 19.8703 11.3501 17.375 11.3501H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-open-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","open","directory","browse","files","archive","categories","reports","data","records","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.45682 13.9011L6 12H17.3599C19.1674 12 20.0711 12 20.6269 12.4619C20.8649 12.6597 21.0538 12.9101 21.1787 13.1934C21.4701 13.8546 21.2218 14.7236 20.7253 16.4615C20.4275 17.5037 20.2786 18.0248 19.9369 18.3822C19.7878 18.5382 19.6143 18.6691 19.4233 18.7696C18.9858 19 18.4438 19 17.3599 19H9.30292C6.8709 19 5.65489 19 5.05476 18.2044C4.45463 17.4088 4.7887 16.2396 5.45682 13.9011Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","open","browse","files","records","reports","history","transactions","archive","documents","sales-data","inventory","customers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.45682 13.9011L6 12H17.3599C19.1674 12 20.0711 12 20.6269 12.4619C20.8649 12.6597 21.0538 12.9101 21.1787 13.1934C21.4701 13.8546 21.2218 14.7236 20.7253 16.4615C20.4275 17.5037 20.2786 18.0248 19.9369 18.3822C19.7878 18.5382 19.6143 18.6691 19.4233 18.7696C18.9858 19 18.4438 19 17.3599 19H9.30292C6.8709 19 5.65489 19 5.05476 18.2044C4.45463 17.4088 4.7887 16.2396 5.45682 13.9011Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","add","plus","new-folder","create-folder","add-category","add-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["folder","add","plus","create","new-folder","add-folder","new","category","add-category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509C12.9644 7.89329 13.1125 8 13.2792 8H16C17.8856 8 18.8284 8 19.4142 8.58579C20 9.17157 20 10.1144 20 12V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","add","plus","create","new-folder","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4L7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417L3 9L3 15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8H16.0658L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335L13.7141 7.73332C13.5438 7.05196 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L8.8769 4H8ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V12H10C9.44772 12 9.00001 12.4477 9.00001 13C9.00001 13.5523 9.44772 14 10 14H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-search-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","search","find","lookup","directory","browse","reports","transactions","history","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14C10 15.1046 10.8954 16 12 16C12.5523 16 13.0523 15.7761 13.4142 15.4142C13.7761 15.0523 14 14.5523 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.4142 15.4142C13.7761 15.0523 14 14.5523 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C12.5523 16 13.0523 15.7761 13.4142 15.4142ZM13.4142 15.4142L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","add","plus","new-folder","create-folder","new-category","add-category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V12C20 10.1144 20 9.17157 19.4142 8.58579C18.8284 8 17.8856 8 16 8H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 8V8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H9.11696C10.5084 5 11.2041 5 11.7279 5.37752C12.2517 5.75503 12.4717 6.41505 12.9117 7.73509L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-search-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","search","find","lookup","inventory","reports","documents","history","transactions","customers","suppliers","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4142 15.4142C13.7761 15.0523 14 14.5523 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C12.5523 16 13.0523 15.7761 13.4142 15.4142ZM13.4142 15.4142L14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder-search": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","search","find","history","archive","lookup","inventory","report","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4142 15.4142C13.7761 15.0523 14 14.5523 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C12.5523 16 13.0523 15.7761 13.4142 15.4142ZM13.4142 15.4142L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Folder-upload-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["folder","upload","import","data","transfer","information","file","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L13.7889 12.8944C12.911 12.4555 12.4721 12.2361 12 12.2361C11.5279 12.2361 11.089 12.4555 10.2111 12.8944L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-upload-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["folder","directory","category","organize","filing","reports","documents","records","archive","sales-data","inventory","customers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 13L13.7889 12.8944C12.911 12.4555 12.4721 12.2361 12 12.2361C11.5279 12.2361 11.089 12.4555 10.2111 12.8944L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect
                    x="10"
                    y="6"
                    width="10"
                    height="6"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986C12.9 8.60002 13.4123 9 14 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Folder-upload-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","directory","archive","file","data","storage","backup","import","export","configuration","settings","reports","logs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 13L13.7889 12.8944C12.911 12.4555 12.4721 12.2361 12 12.2361C11.5279 12.2361 11.089 12.4555 10.2111 12.8944L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M21.0034 8.75951V8C21.0034 6.34315 19.6602 5 18.0034 5H13.5801C13.7195 5.23666 13.8286 5.47926 13.9191 5.71691C14.0882 6.1606 14.229 6.69179 14.3696 7.25002L16.103 7.25001C16.9595 7.24988 17.7684 7.24975 18.4311 7.33885C19.1698 7.43816 19.9828 7.67613 20.655 8.34837C20.7872 8.48052 20.9026 8.61811 21.0034 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4C7.95604 4 7.97799 4 8 4H8.8769C8.89551 4 8.91407 4 8.93256 4C9.63488 3.99996 10.2482 3.99993 10.7508 4.06003C11.2934 4.12491 11.8165 4.2698 12.2847 4.63539C12.7529 5.00097 13.0204 5.47327 13.2149 5.9839C13.3951 6.45693 13.5438 7.05198 13.7141 7.73335L13.7276 7.78733C13.7589 7.91232 13.8712 8 14 8L16.0658 8C16.9523 7.99995 17.7161 7.99991 18.3278 8.08215C18.9833 8.17028 19.6117 8.36902 20.1213 8.87868C20.631 9.38835 20.8297 10.0167 20.9179 10.6722C21.0001 11.2839 21.0001 12.0477 21 12.9342V15.0658C21.0001 15.9523 21.0001 16.7161 20.9179 17.3278C20.8297 17.9833 20.631 18.6117 20.1213 19.1213C19.6117 19.631 18.9833 19.8297 18.3278 19.9179C17.7161 20.0001 16.9523 20.0001 16.0658 20H7.93417C7.04769 20.0001 6.28387 20.0001 5.67221 19.9179C5.0167 19.8297 4.38835 19.631 3.87868 19.1213C3.36902 18.6117 3.17028 17.9833 3.08215 17.3278C2.99991 16.7161 2.99995 15.9523 3 15.0658L3 9C3 8.97799 3 8.95604 3 8.93417C2.99995 8.04769 2.99991 7.28387 3.08215 6.67221C3.17028 6.0167 3.36902 5.38835 3.87868 4.87868C4.38835 4.36902 5.0167 4.17028 5.67221 4.08215C6.28387 3.99991 7.04769 3.99995 7.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Folder-search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","search","lookup","find","directory","browse","inventory","item-lookup","customer-records","reports","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0033 8.75951V8C21.0033 6.34315 19.6602 5 18.0033 5H13.58C13.7194 5.23666 13.8285 5.47926 13.919 5.71691C14.0881 6.1606 14.2289 6.69179 14.3695 7.25002L16.1029 7.25001C16.9594 7.24988 17.7683 7.24975 18.431 7.33885C19.1697 7.43816 19.9827 7.67613 20.6549 8.34837C20.7871 8.48052 20.9025 8.61811 21.0033 8.75951Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417V15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C17.7161 7.99991 16.9523 7.99995 16.0659 8L14 8C13.8712 8 13.7589 7.91232 13.7276 7.78733L13.7141 7.73335C13.5438 7.05199 13.3951 6.45693 13.2149 5.9839C13.0204 5.47327 12.7529 5.00097 12.2847 4.63539C11.8165 4.2698 11.2934 4.12491 10.7508 4.06003C10.2482 3.99993 9.63488 3.99996 8.93256 4L7.93417 4ZM12 11.25C10.4812 11.25 9.25 12.4812 9.25 14C9.25 15.5188 10.4812 16.75 12 16.75C12.4866 16.75 12.9441 16.6232 13.3407 16.4014L13.4697 16.5303C13.7626 16.8232 14.2374 16.8232 14.5303 16.5303C14.8232 16.2374 14.8232 15.7626 14.5303 15.4697L14.4014 15.3407C14.6232 14.9441 14.75 14.4866 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 14C13 13.506 12.5957 13.0335 12 13C11.4043 13.0335 11 13.506 11 14C11 14.494 11.4043 14.9665 12 15C12.5957 14.9665 13 14.494 13 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-case-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["font","case","text","uppercase","lowercase","typography","formatting","change-case","edit-text","modify-text"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5.8 15M13 17L12.2 15M5.8 15L7.14305 11.6424C7.92966 9.67585 8.32297 8.69258 9 8.69258C9.67703 8.69258 10.0703 9.67585 10.857 11.6424L12.2 15M5.8 15H12.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.25 17C19.25 17.4142 19.5858 17.75 20 17.75C20.4142 17.75 20.75 17.4142 20.75 17H19.25ZM20.75 11C20.75 10.5858 20.4142 10.25 20 10.25C19.5858 10.25 19.25 10.5858 19.25 11H20.75ZM20.75 17V11H19.25V17H20.75ZM19.25 14C19.25 15.3765 18.3443 16.25 17.5 16.25V17.75C19.4172 17.75 20.75 15.9372 20.75 14H19.25ZM17.5 16.25C16.6557 16.25 15.75 15.3765 15.75 14H14.25C14.25 15.9372 15.5828 17.75 17.5 17.75V16.25ZM15.75 14C15.75 12.6235 16.6557 11.75 17.5 11.75V10.25C15.5828 10.25 14.25 12.0628 14.25 14H15.75ZM17.5 11.75C18.3443 11.75 19.25 12.6235 19.25 14H20.75C20.75 12.0628 19.4172 10.25 17.5 10.25V11.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "Folder-upload": {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","upload","import","data","file","transfer","backup","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L13.7889 12.8944C12.911 12.4555 12.4721 12.2361 12 12.2361C11.5279 12.2361 11.089 12.4555 10.2111 12.8944L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 13L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Folder: {
        defaultColors: ["#3D4C66"],
        keywords: ["folder","upload","import","data","file","transfer","backup","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V13C20 11.1144 20 10.1716 19.4142 9.58579C18.8284 9 17.8856 9 16 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H8.87689C10.3768 5 11.1267 5 11.6693 5.42359C12.2118 5.84718 12.3937 6.57474 12.7575 8.02986L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-case-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","text","uppercase","lowercase","case","formatting","display","label","typography","print"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.98037 9.92644C8.74238 10.3424 8.47699 10.9993 8.0713 12.0136L7.27681 13.9998H10.7227L9.92826 12.0136C9.52256 10.9993 9.25718 10.3424 9.01918 9.92644C9.01256 9.91485 9.00608 9.9037 8.99978 9.89297C8.99347 9.9037 8.987 9.91485 8.98037 9.92644ZM11.5227 15.9998L12.0713 17.3712C12.2764 17.884 12.8584 18.1334 13.3712 17.9283C13.884 17.7232 14.1334 17.1412 13.9283 16.6284L11.7852 11.2708C11.7755 11.2465 11.7658 11.2224 11.7562 11.1983C11.3878 10.277 11.0714 9.48608 10.7551 8.93323C10.4538 8.40657 9.92967 7.69238 8.99978 7.69238C8.06989 7.69238 7.54574 8.40657 7.24442 8.93323C6.92811 9.48608 6.6118 10.277 6.24334 11.1983C6.23371 11.2224 6.22405 11.2465 6.21435 11.2708L4.0713 16.6284C3.86619 17.1412 4.1156 17.7232 4.62839 17.9283C5.14117 18.1334 5.72314 17.884 5.92825 17.3712L6.47681 15.9998H11.5227ZM17.4998 11.9998C16.8343 11.9998 15.9998 12.7168 15.9998 13.9998C15.9998 15.2828 16.8343 15.9998 17.4998 15.9998C18.1652 15.9998 18.9998 15.2828 18.9998 13.9998C18.9998 12.7168 18.1652 11.9998 17.4998 11.9998ZM19.155 10.4645C18.6756 10.171 18.1177 9.9998 17.4998 9.9998C15.4038 9.9998 13.9998 11.9691 13.9998 13.9998C13.9998 16.0305 15.4038 17.9998 17.4998 17.9998C18.1177 17.9998 18.6756 17.8286 19.155 17.5351C19.3323 17.8144 19.6444 17.9998 19.9998 17.9998C20.5521 17.9998 20.9998 17.5521 20.9998 16.9998V10.9998C20.9998 10.4475 20.5521 9.9998 19.9998 9.9998C19.6444 9.9998 19.3323 10.1852 19.155 10.4645Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-case-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","case","uppercase","lowercase","text","format","typography","character"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5.8 15M13 17L12.2 15M5.8 15L7.14305 11.6424C7.92966 9.67585 8.32297 8.69258 9 8.69258C9.67703 8.69258 10.0703 9.67585 10.857 11.6424L12.2 15M5.8 15H12.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.25 17C19.25 17.4142 19.5858 17.75 20 17.75C20.4142 17.75 20.75 17.4142 20.75 17H19.25ZM20.75 11C20.75 10.5858 20.4142 10.25 20 10.25C19.5858 10.25 19.25 10.5858 19.25 11H20.75ZM20.75 17V11H19.25V17H20.75ZM19.25 14C19.25 15.3765 18.3443 16.25 17.5 16.25V17.75C19.4172 17.75 20.75 15.9372 20.75 14H19.25ZM17.5 16.25C16.6557 16.25 15.75 15.3765 15.75 14H14.25C14.25 15.9372 15.5828 17.75 17.5 17.75V16.25ZM15.75 14C15.75 12.6235 16.6557 11.75 17.5 11.75V10.25C15.5828 10.25 14.25 12.0628 14.25 14H15.75ZM17.5 11.75C18.3443 11.75 19.25 12.6235 19.25 14H20.75C20.75 12.0628 19.4172 10.25 17.5 10.25V11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-case": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","uppercase","lowercase","text","formatting","Aa","edit-text","adjust-case"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5.8 15M13 17L12.2 15M5.8 15L7.14305 11.6424C7.92966 9.67585 8.32297 8.69258 9 8.69258C9.67703 8.69258 10.0703 9.67585 10.857 11.6424L12.2 15M5.8 15H12.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.25 17C19.25 17.4142 19.5858 17.75 20 17.75C20.4142 17.75 20.75 17.4142 20.75 17H19.25ZM20.75 11C20.75 10.5858 20.4142 10.25 20 10.25C19.5858 10.25 19.25 10.5858 19.25 11H20.75ZM20.75 17V11H19.25V17H20.75ZM19.25 14C19.25 15.3765 18.3443 16.25 17.5 16.25V17.75C19.4172 17.75 20.75 15.9372 20.75 14H19.25ZM17.5 16.25C16.6557 16.25 15.75 15.3765 15.75 14H14.25C14.25 15.9372 15.5828 17.75 17.5 17.75V16.25ZM15.75 14C15.75 12.6235 16.6557 11.75 17.5 11.75V10.25C15.5828 10.25 14.25 12.0628 14.25 14H15.75ZM17.5 11.75C18.3443 11.75 19.25 12.6235 19.25 14H20.75C20.75 12.0628 19.4172 10.25 17.5 10.25V11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-color-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["font","text","typography","format","style","font-color","underline","text-formatting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17L12 5L17 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 12L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M19 19H5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-color-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","color","text","edit","format","typography","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17L12 5L17 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 12L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M19 19H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-color-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","text","color","format","typography","adjust","settings","customize","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.4037 3 12.7678 3.24274 12.9231 3.61538L17.9231 15.6154C18.1355 16.1252 17.8944 16.7107 17.3846 16.9231C16.8748 17.1355 16.2893 16.8944 16.0769 16.3846L14.25 12H9.75L7.92308 16.3846C7.71066 16.8944 7.12519 17.1355 6.61538 16.9231C6.10558 16.7107 5.86451 16.1252 6.07692 15.6154L11.0769 3.61538C11.2322 3.24274 11.5963 3 12 3ZM10.5833 10H13.4167L12 6.6L10.5833 10ZM4 19C4 18.4477 4.44772 18 5 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-color": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","text","typography","character","format","style","edit","letter","options","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17L12 5L17 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 12L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M19 19H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-mono-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["font","text","format","filter","options","display","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18V8C9 7.05719 9 6.58579 9.29289 6.29289C9.58579 6 10.0572 6 11 6H15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-mono-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","text","filter","featured","find","format"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9456 5.00001C10.5215 4.99992 10.1094 4.99984 9.7695 5.04554C9.38629 5.09706 8.94902 5.22259 8.5858 5.5858C8.22259 5.94902 8.09706 6.38629 8.04554 6.76949C7.99984 7.10941 7.99992 7.52154 8.00001 7.94561L8.00001 11.9945L8 12L8.00001 12.0055V18C8.00001 18.5523 8.44773 19 9.00001 19C9.5523 19 10 18.5523 10 18V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H10V8.00001C10 7.50034 10.0021 7.22618 10.0277 7.03599L10.0287 7.02871L10.036 7.02771C10.2262 7.00214 10.5003 7.00001 11 7.00001H15C15.5523 7.00001 16 6.5523 16 6.00001C16 5.44773 15.5523 5.00001 15 5.00001L10.9456 5.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "font-mono-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["font","text","formatting","filter","price-filter","category-filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18V8C9 7.05719 9 6.58579 9.29289 6.29289C9.58579 6 10.0572 6 11 6H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "font-mono": {
        defaultColors: ["#3D4C66"],
        keywords: ["F","font","text","discount","loyalty","member","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 18V8C9 7.05719 9 6.58579 9.29289 6.29289C9.58579 6 10.0572 6 11 6H15M15 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "format-image-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["layout","format","image","text","arrange","design","product-display","menu-layout","interface","template"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 14.7071C10 14.4142 10 13.9428 10 13V11C10 10.0572 10 9.58579 9.70711 9.29289C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 18H4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12H20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "format-image-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["layout","format","image","content","page","section","design","template","receipt","order-details","product-description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 14.7071C10 14.4142 10 13.9428 10 13V11C10 10.0572 10 9.58579 9.70711 9.29289C9.41421 9 8.94281 9 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H20" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 18H4" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "format-image-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","text","layout","format","description","product-description","item-details","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 14.7071C10 14.4142 10 13.9428 10 13V11C10 10.0572 10 9.58579 9.70711 9.29289C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 18H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "format-image-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","image-left","format","list","product-details","details","description","item-details","product-layout","category-layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.94561 8.00001H8.05442C8.47849 7.99992 8.89062 7.99984 9.23053 8.04554C9.61374 8.09706 10.051 8.22259 10.4142 8.5858C10.7774 8.94902 10.903 9.38629 10.9545 9.7695C11.0002 10.1094 11.0001 10.5215 11 10.9456V13.0544C11.0001 13.4785 11.0002 13.8906 10.9545 14.2305C10.903 14.6137 10.7774 15.051 10.4142 15.4142C10.051 15.7774 9.61374 15.903 9.23053 15.9545C8.89062 16.0002 8.47849 16.0001 8.05442 16H5.9456C5.52153 16.0001 5.10941 16.0002 4.76949 15.9545C4.38629 15.903 3.94902 15.7774 3.5858 15.4142C3.22259 15.051 3.09706 14.6137 3.04554 14.2305C2.99984 13.8906 2.99992 13.4785 3.00001 13.0544V10.9456C2.99992 10.5215 2.99984 10.1094 3.04554 9.7695C3.09706 9.38629 3.22259 8.94902 3.5858 8.5858C3.94902 8.22259 4.38629 8.09706 4.76949 8.04554C5.10941 7.99984 5.52154 7.99992 5.94561 8.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 18C3 17.4477 3.44772 17 4 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16H20C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 9C13 8.44772 13.4477 8 14 8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H14C13.4477 10 13 9.55228 13 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "format-size-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","format","font","size","font-size","text-size","format-text","description","change-text"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V7M10 17H7.5M10 17H12.5M10 7H5V9.22222M10 7H15V9.22222"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 17V12M16.5 17H15.25M16.5 17H17.75M16.5 12H14V13.1111M16.5 12H19V13.1111"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "format-size-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["text","format","size","font","typography","edit-text","change-size","modify-text"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V7M10 17H7.5M10 17H12.5M10 7H5V9.22222M10 7H15V9.22222"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 17V12M16.5 17H15.25M16.5 17H17.75M16.5 12H14V13.1111M16.5 12H19V13.1111"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "format-size-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","format","size","font","edit","display","options","customer-display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6C4.44772 6 4 6.44772 4 7V9.22222C4 9.77451 4.44772 10.2222 5 10.2222C5.55228 10.2222 6 9.77451 6 9.22222V8H9V16H7.5C6.94772 16 6.5 16.4477 6.5 17C6.5 17.5523 6.94772 18 7.5 18H12.5C13.0523 18 13.5 17.5523 13.5 17C13.5 16.4477 13.0523 16 12.5 16H11V8H14V9.22222C14 9.77451 14.4477 10.2222 15 10.2222C15.5523 10.2222 16 9.77451 16 9.22222V7C16 6.44772 15.5523 6 15 6H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 11C13.4477 11 13 11.4477 13 12V13.1111C13 13.6634 13.4477 14.1111 14 14.1111C14.5523 14.1111 15 13.6634 15 13.1111V13H15.5V16H15.25C14.6977 16 14.25 16.4477 14.25 17C14.25 17.5523 14.6977 18 15.25 18H17.75C18.3023 18 18.75 17.5523 18.75 17C18.75 16.4477 18.3023 16 17.75 16H17.5V13H18V13.1111C18 13.6634 18.4477 14.1111 19 14.1111C19.5523 14.1111 20 13.6634 20 13.1111V12C20 11.4477 19.5523 11 19 11H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["forward","next","continue","skip","fast-forward","playback-speed","advance","queue","expedite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.268 9.60952L17.268 9.60953C18.1994 10.4245 18.665 10.8319 18.841 11.3126C19.0034 11.7565 19.0034 12.2435 18.841 12.6874C18.665 13.1681 18.1994 13.5755 17.268 14.3905C15.6161 15.8359 14.7902 16.5586 14.0909 16.5904C13.4511 16.6195 12.836 16.3404 12.4365 15.8397C12 15.2925 12 14.195 12 12C12 9.80501 12 8.70752 12.4365 8.16029C12.836 7.6596 13.4511 7.38049 14.0909 7.4096C14.7902 7.44142 15.6161 8.16412 17.268 9.60952Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.26803 9.60952L9.26804 9.60953C10.1994 10.4245 10.665 10.8319 10.841 11.3126C11.0034 11.7565 11.0034 12.2435 10.841 12.6874C10.665 13.1681 10.1994 13.5755 9.26804 14.3905C7.61614 15.8359 6.79019 16.5586 6.0909 16.5904C5.45106 16.6195 4.83598 16.3404 4.43655 15.8397C4 15.2925 4 14.195 4 12C4 9.80501 4 8.70752 4.43655 8.16029C4.83598 7.6596 5.45105 7.38049 6.0909 7.4096C6.79019 7.44142 7.61614 8.16412 9.26803 9.60952Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "format-size": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","size","font-size","adjust-text","edit-text","description","product-description","notes","receipt-notes","customer-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V7M10 17H7.5M10 17H12.5M10 7H5V9.22222M10 7H15V9.22222"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 17V12M16.5 17H15.25M16.5 17H17.75M16.5 12H14V13.1111M16.5 12H19V13.1111"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Forward-10sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["forward","repeat","undo","redo","fast-forward","10-seconds","skip","replay","rewind"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="11" y="10" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 14V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Forward-10sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["forward","skip","rewind","10-seconds","fast-forward","replay","repeat","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="11" y="10" width="3" height="4" rx="1.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Forward-10sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","redo","retry","replay","previous","rewind","back","10","seconds","time","undo","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.75 12C4.75 8.54822 7.54822 5.75 11 5.75C13.6721 5.75 15.9526 7.42691 16.8464 9.78578L16.5303 9.46967C16.2374 9.17678 15.7626 9.17678 15.4697 9.46967C15.1768 9.76256 15.1768 10.2374 15.4697 10.5303L17.4697 12.5303C17.5416 12.6022 17.6245 12.6565 17.7129 12.6931C17.8013 12.7298 17.8983 12.75 18 12.75C18.1017 12.75 18.1987 12.7298 18.2871 12.6931C18.3755 12.6565 18.4584 12.6022 18.5303 12.5303L20.5303 10.5303C20.8232 10.2374 20.8232 9.76256 20.5303 9.46967C20.2374 9.17678 19.7626 9.17678 19.4697 9.46967L18.5767 10.3626C17.8253 6.86878 14.7185 4.25 11 4.25C6.71979 4.25 3.25 7.7198 3.25 12C3.25 16.2802 6.71979 19.75 11 19.75C13.1684 19.75 15.1299 18.8585 16.5357 17.4239C16.8256 17.1281 16.8208 16.6532 16.5249 16.3633C16.2291 16.0734 15.7542 16.0782 15.4643 16.3741C14.3291 17.5326 12.749 18.25 11 18.25C7.54822 18.25 4.75 15.4518 4.75 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.25 11.5C10.25 10.2574 11.2574 9.25 12.5 9.25C13.7426 9.25 14.75 10.2574 14.75 11.5V12.5C14.75 13.7426 13.7426 14.75 12.5 14.75C11.2574 14.75 10.25 13.7426 10.25 12.5V11.5ZM12.5 10.75C12.0858 10.75 11.75 11.0858 11.75 11.5V12.5C11.75 12.9142 12.0858 13.25 12.5 13.25C12.9142 13.25 13.25 12.9142 13.25 12.5V11.5C13.25 11.0858 12.9142 10.75 12.5 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.75 10C8.75 9.58579 8.41421 9.25 8 9.25C7.58579 9.25 7.25 9.58579 7.25 10L7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["forward","next","advance","skip","fast-forward","arrow","right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.268 9.60952L17.268 9.60953C18.1994 10.4245 18.665 10.8319 18.841 11.3126C19.0034 11.7565 19.0034 12.2435 18.841 12.6874C18.665 13.1681 18.1994 13.5755 17.268 14.3905C15.6161 15.8359 14.7902 16.5586 14.0909 16.5904C13.4511 16.6195 12.836 16.3404 12.4365 15.8397C12 15.2925 12 14.195 12 12C12 9.80501 12 8.70752 12.4365 8.16029C12.836 7.6596 13.4511 7.38049 14.0909 7.4096C14.7902 7.44142 15.6161 8.16412 17.268 9.60952Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.26803 9.60952L9.26804 9.60953C10.1994 10.4245 10.665 10.8319 10.841 11.3126C11.0034 11.7565 11.0034 12.2435 10.841 12.6874C10.665 13.1681 10.1994 13.5755 9.26804 14.3905C7.61614 15.8359 6.79019 16.5586 6.0909 16.5904C5.45106 16.6195 4.83598 16.3404 4.43655 15.8397C4 15.2925 4 14.195 4 12C4 9.80501 4 8.70752 4.43655 8.16029C4.83598 7.6596 5.45105 7.38049 6.0909 7.4096C6.79019 7.44142 7.61614 8.16412 9.26803 9.60952Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Forward-10sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","10","arrow","redo","replay","fast-forward","skip","timer","recall","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12C18 8.13401 14.866 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C12.9587 19 14.7295 18.1955 16 16.899"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L18 12L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="11" y="10" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","next","advance","skip","fast-forward","continue","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.65482 7.53686C4.25397 6.78581 5.17658 6.36716 6.13635 6.41082C6.79952 6.44099 7.38615 6.78815 7.9119 7.172C8.44817 7.56353 9.09495 8.12948 9.88904 8.82433L9.95715 8.88392C10.3813 9.255 10.7463 9.57435 11.0267 9.8607C11.0347 9.68818 11.045 9.52605 11.0585 9.37434C11.1158 8.72591 11.2408 8.05581 11.6548 7.53686C12.254 6.78581 13.1766 6.36716 14.1363 6.41082C14.7995 6.44099 15.3861 6.78815 15.9119 7.172C16.4482 7.56353 17.0949 8.12948 17.889 8.82432L17.9572 8.88393C18.3967 9.26852 18.7728 9.59754 19.057 9.89185C19.3546 10.1999 19.6231 10.5402 19.7801 10.9691C20.0237 11.6349 20.0237 12.3655 19.7801 13.0313C19.6231 13.4602 19.3546 13.8005 19.057 14.1085C18.7728 14.4028 18.3967 14.7318 17.9572 15.1164L17.8891 15.176C17.095 15.8709 16.4482 16.4368 15.9119 16.8284C15.3861 17.2122 14.7995 17.5594 14.1363 17.5895C13.1766 17.6332 12.254 17.2146 11.6548 16.4635C11.2408 15.9446 11.1158 15.2745 11.0585 14.626C11.045 14.4743 11.0347 14.3122 11.0267 14.1397C10.7463 14.426 10.3813 14.7454 9.95716 15.1164L9.88905 15.176C9.09496 15.8709 8.44817 16.4368 7.9119 16.8284C7.38615 17.2122 6.79952 17.5594 6.13635 17.5895C5.17658 17.6332 4.25397 17.2146 3.65482 16.4635C3.24083 15.9446 3.11579 15.2745 3.05846 14.626C2.99997 13.9646 2.99999 13.1052 3 12.05V11.9504C2.99999 10.8952 2.99997 10.0357 3.05846 9.37434C3.11579 8.72591 3.24082 8.05581 3.65482 7.53686Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-30sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["forward","skip","advance","time","30","seconds","fast-forward","speed-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-30sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["forward","skip","time","seconds","playback","fast-forward","30-seconds","order-skip","jump"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-30sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","repeat","transaction","history","rollback","time","rewind","30 seconds","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C12.2599 3.25 12.5013 3.38459 12.638 3.6057C12.7746 3.82681 12.7871 4.10292 12.6708 4.33541L11.6708 6.33541C11.4856 6.70589 11.0351 6.85606 10.6646 6.67082C10.2941 6.48558 10.1439 6.03507 10.3292 5.66459L10.7311 4.86066C7.33207 5.46066 4.75 8.42879 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 9.83473 18.3017 7.89186 16.7953 6.5623C16.4848 6.28821 16.4552 5.81425 16.7293 5.5037C17.0034 5.19315 17.4774 5.1636 17.7879 5.4377C19.6033 7.03991 20.75 9.3865 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 10C7.25 9.58579 7.58579 9.25 8 9.25H9C9.9665 9.25 10.75 10.0335 10.75 11V13C10.75 13.9665 9.9665 14.75 9 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H9C9.13807 13.25 9.25 13.1381 9.25 13V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H9.25V11C9.25 10.8619 9.13807 10.75 9 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10ZM11.25 12C11.25 10.4812 12.4812 9.25 14 9.25C15.5188 9.25 16.75 10.4812 16.75 12C16.75 13.5188 15.5188 14.75 14 14.75C12.4812 14.75 11.25 13.5188 11.25 12ZM14 10.75C13.3096 10.75 12.75 11.3096 12.75 12C12.75 12.6904 13.3096 13.25 14 13.25C14.6904 13.25 15.25 12.6904 15.25 12C15.25 11.3096 14.6904 10.75 14 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-60sec-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["forward","skip","time","60 seconds","fast forward","replay","rewind","customer history","order history","transaction history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-30sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","rewind","skip","thirty-seconds","time","delay","fast-forward","30","replay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12M10 12L10 11C10 10.4477 9.55228 10 9 10L8 10M10 12L10 13C10 13.5523 9.55228 14 9 14L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-60sec-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["time","60","seconds","timer","delay","timeout","wait","forward","pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-60sec-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["time","sixty","60","seconds","forward","skip","advance","timer","delay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C12.2599 3.25 12.5013 3.38459 12.638 3.6057C12.7746 3.82681 12.7871 4.10292 12.6708 4.33541L11.6708 6.33541C11.4856 6.70589 11.0351 6.85606 10.6646 6.67082C10.2941 6.48558 10.1439 6.03507 10.3292 5.66459L10.7311 4.86066C7.33207 5.46066 4.75 8.42879 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 9.83473 18.3017 7.89186 16.7953 6.5623C16.4848 6.28821 16.4552 5.81425 16.7293 5.5037C17.0034 5.19315 17.4774 5.1636 17.7879 5.4377C19.6033 7.03991 20.75 9.3865 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.25 11.5C12.25 10.2574 13.2574 9.25 14.5 9.25C15.7426 9.25 16.75 10.2574 16.75 11.5V12.5C16.75 13.7426 15.7426 14.75 14.5 14.75C13.2574 14.75 12.25 13.7426 12.25 12.5V11.5ZM14.5 13.25C14.9142 13.25 15.25 12.9142 15.25 12.5V11.5C15.25 11.0858 14.9142 10.75 14.5 10.75C14.0858 10.75 13.75 11.0858 13.75 11.5V12.5C13.75 12.9142 14.0858 13.25 14.5 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 14.75C10.9665 14.75 11.75 13.9665 11.75 13C11.75 12.0335 10.9665 11.25 10 11.25H8.75V11C8.75 10.8619 8.86193 10.75 9 10.75H10C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25H9C8.0335 9.25 7.25 10.0335 7.25 11L7.25 13C7.25 13.9665 8.0335 14.75 9 14.75H10ZM8.75 12.75H10C10.1381 12.75 10.25 12.8619 10.25 13C10.25 13.1381 10.1381 13.25 10 13.25H9C8.86193 13.25 8.75 13.1381 8.75 13V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-60sec": {
        defaultColors: ["#3D4C66"],
        keywords: ["60","seconds","time","limit","countdown","timer","delay","wait","refresh","reload","update","transaction","clock","interval"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.61061 18.9525 7.46589 17.2916 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 11.5V12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5V11.5C13 10.6716 13.6716 10 14.5 10C15.3284 10 16 10.6716 16 11.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12L10 12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14L9 14C8.44772 14 8 13.5523 8 13L8 12ZM8 12L8 11C8 10.4477 8.44772 10 9 10L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-fast-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["skip","forward","next","fast-forward","advance","continue","process","speed-up","sequence","flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5056 7.89338C15.0305 8.03054 15.6703 8.67027 16.9497 9.94975C17.542 10.542 17.8382 10.8382 17.9877 11.1623C18.2329 11.6939 18.2329 12.3061 17.9877 12.8377C17.8382 13.1618 17.542 13.458 16.9498 14.0502L16.9497 14.0503C15.6703 15.3297 15.0305 15.9695 14.5056 16.1066C13.6387 16.3331 12.727 15.9555 12.2742 15.1824C12 14.7142 12 13.8094 12 12C12 10.1906 12 9.28583 12.2742 8.81763C12.727 8.04454 13.6387 7.66691 14.5056 7.89338Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.50556 7.89338C8.03054 8.03054 8.67027 8.67027 9.94975 9.94975C10.542 10.542 10.8382 10.8382 10.9877 11.1623C11.2329 11.6939 11.2329 12.3061 10.9877 12.8377C10.8382 13.1618 10.542 13.458 9.94975 14.0502L9.94975 14.0503C8.67027 15.3297 8.03054 15.9695 7.50556 16.1066C6.63872 16.3331 5.72704 15.9555 5.27423 15.1824C5 14.7142 5 13.8094 5 12C5 10.1906 5 9.28583 5.27423 8.81763C5.72703 8.04454 6.63872 7.66691 7.50556 7.89338Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-fast-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","fast-forward","skip","next","advance","expedite","queue","jump","skip-ahead","speed-up","process","payment","accelerate","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.537 9.35389C10.7235 9.53811 10.8926 9.70507 11.0395 9.85768C11.0757 9.36506 11.1531 8.85558 11.4027 8.43475C12.0677 7.31365 13.4065 6.76601 14.6794 7.09444C15.1744 7.22215 15.6069 7.54614 15.9958 7.88186C16.398 8.22909 16.8868 8.71182 17.4906 9.30811L17.5369 9.35386C17.707 9.52179 17.8626 9.67538 18 9.81684V8C18 7.44772 18.4477 7 19 7C19.5523 7 20 7.44772 20 8V16C20 16.5523 19.5523 17 19 17C18.4477 17 18 16.5523 18 16V14.1832C17.8626 14.3246 17.707 14.4782 17.537 14.6461L17.4905 14.692C16.8867 15.2883 16.398 15.7709 15.9958 16.1181C15.6069 16.4539 15.1744 16.7779 14.6794 16.9056C13.4065 17.234 12.0677 16.6864 11.4027 15.5653C11.1531 15.1444 11.0757 14.6349 11.0395 14.1423C10.8926 14.2949 10.7235 14.4619 10.537 14.6461L10.4907 14.6918C9.8868 15.2882 9.398 15.7709 8.99576 16.1181C8.6069 16.4539 8.17442 16.7779 7.67943 16.9056C6.40648 17.234 5.06766 16.6864 4.40271 15.5653C4.14414 15.1293 4.07034 14.5982 4.03576 14.0893C3.99999 13.5629 3.99999 12.8802 4 12.0368V11.9632C3.99999 11.1198 3.99999 10.4371 4.03576 9.9107C4.07033 9.40178 4.14414 8.87069 4.40271 8.43475C5.06765 7.31365 6.40648 6.76601 7.67943 7.09444C8.17442 7.22215 8.60689 7.54614 8.99576 7.88186C9.39799 8.22912 9.88678 8.71181 10.4907 9.30818L10.537 9.35389Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-fast-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["skip","next","forward","fast-forward","end","complete","process","finish","fast","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5056 7.89338C15.0305 8.03054 15.6703 8.67027 16.9497 9.94975C17.542 10.542 17.8382 10.8382 17.9877 11.1623C18.2329 11.6939 18.2329 12.3061 17.9877 12.8377C17.8382 13.1618 17.542 13.458 16.9498 14.0502L16.9497 14.0503C15.6703 15.3297 15.0305 15.9695 14.5056 16.1066C13.6387 16.3331 12.727 15.9555 12.2742 15.1824C12 14.7142 12 13.8094 12 12C12 10.1906 12 9.28583 12.2742 8.81763C12.727 8.04454 13.6387 7.66691 14.5056 7.89338Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.50556 7.89338C8.03054 8.03054 8.67027 8.67027 9.94975 9.94975C10.542 10.542 10.8382 10.8382 10.9877 11.1623C11.2329 11.6939 11.2329 12.3061 10.9877 12.8377C10.8382 13.1618 10.542 13.458 9.94975 14.0502L9.94975 14.0503C8.67027 15.3297 8.03054 15.9695 7.50556 16.1066C6.63872 16.3331 5.72704 15.9555 5.27423 15.1824C5 14.7142 5 13.8094 5 12C5 10.1906 5 9.28583 5.27423 8.81763C5.72703 8.04454 6.63872 7.66691 7.50556 7.89338Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-fast": {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","fast-forward","skip","next","advance","playback","jump","continue","accelerate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5056 7.89338C15.0305 8.03054 15.6703 8.67027 16.9497 9.94975C17.542 10.542 17.8382 10.8382 17.9877 11.1623C18.2329 11.6939 18.2329 12.3061 17.9877 12.8377C17.8382 13.1618 17.542 13.458 16.9498 14.0502L16.9497 14.0503C15.6703 15.3297 15.0305 15.9695 14.5056 16.1066C13.6387 16.3331 12.727 15.9555 12.2742 15.1824C12 14.7142 12 13.8094 12 12C12 10.1906 12 9.28583 12.2742 8.81763C12.727 8.04454 13.6387 7.66691 14.5056 7.89338Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.50556 7.89338C8.03054 8.03054 8.67027 8.67027 9.94975 9.94975C10.542 10.542 10.8382 10.8382 10.9877 11.1623C11.2329 11.6939 11.2329 12.3061 10.9877 12.8377C10.8382 13.1618 10.542 13.458 9.94975 14.0502L9.94975 14.0503C8.67027 15.3297 8.03054 15.9695 7.50556 16.1066C6.63872 16.3331 5.72704 15.9555 5.27423 15.1824C5 14.7142 5 13.8094 5 12C5 10.1906 5 9.28583 5.27423 8.81763C5.72703 8.04454 6.63872 7.66691 7.50556 7.89338Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["forward","next","skip","advance","play","fast-forward","continue","order","queue","transaction","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 16V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.268 9.60952L12.268 9.60953C13.1994 10.4245 13.665 10.8319 13.841 11.3126C14.0034 11.7565 14.0034 12.2435 13.841 12.6874C13.665 13.1681 13.1994 13.5755 12.268 14.3905C10.6161 15.8359 9.79019 16.5586 9.0909 16.5904C8.45106 16.6195 7.83598 16.3404 7.43655 15.8397C7 15.2925 7 14.195 7 12C7 9.80501 7 8.70752 7.43655 8.16029C7.83598 7.6596 8.45105 7.38049 9.0909 7.4096C9.79019 7.44142 10.6161 8.16412 12.268 9.60952Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["next","forward","step","advance","continue","skip","process","transaction","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.268 9.60952L12.268 9.60953C13.1994 10.4245 13.665 10.8319 13.841 11.3126C14.0034 11.7565 14.0034 12.2435 13.841 12.6874C13.665 13.1681 13.1994 13.5755 12.268 14.3905C10.6161 15.8359 9.79019 16.5586 9.0909 16.5904C8.45106 16.6195 7.83598 16.3404 7.43655 15.8397C7 15.2925 7 14.195 7 12C7 9.80501 7 8.70752 7.43655 8.16029C7.83598 7.6596 8.45105 7.38049 9.0909 7.4096C9.79019 7.44142 10.6161 8.16412 12.268 9.60952Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","continue","advance","proceed","skip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.5V7.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","forward","advance","skip","proceed","queue","add-to-queue","next-customer","next-order","step-forward","fast-forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 17C16.4477 17 16 16.5523 16 16L16 8C16 7.44771 16.4477 7 17 7C17.5523 7 18 7.44771 18 8L18 16C18 16.5523 17.5523 17 17 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.2098 14.7861L12.149 14.8394C11.4402 15.4606 10.8629 15.9666 10.3842 16.3167C9.91497 16.6599 9.39136 16.9702 8.79943 16.9972C7.94277 17.0363 7.11926 16.662 6.58448 15.9905C6.21495 15.5265 6.10335 14.9274 6.05218 14.3477C5.99998 13.7563 5.99999 12.9879 6 12.0445L6 11.9555C5.99999 11.0121 5.99998 10.2437 6.05218 9.65234C6.10335 9.0726 6.21495 8.4735 6.58448 8.00952C7.11926 7.33804 7.94277 6.96374 8.79943 7.00278C9.39136 7.02975 9.91497 7.34014 10.3842 7.68332C10.8629 8.03337 11.4402 8.53936 12.149 9.1606L12.2098 9.21389C12.6021 9.55773 12.9378 9.8519 13.1915 10.115C13.4571 10.3904 13.6968 10.6946 13.8369 11.0781C14.0544 11.6734 14.0544 12.3266 13.8369 12.9219C13.6967 13.3054 13.4571 13.6096 13.1915 13.885C12.9378 14.1481 12.6021 14.4423 12.2098 14.7861Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "forward-step-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["forward","next","proceed","continue","skip","fast-forward","advance","submit","checkout","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.5V7.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["forward","next","continue","proceed","skip","advance","order","queue","checkout","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.5V7.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step-7": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["forward","next","skip","advance","continue","process","flow","move-forward","fast-forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_45532)">
                    <path
                        d="M16 6.49991C15.45 6.49991 15 6.94972 15 7.49948V9.70854C14.72 9.40866 14.37 9.0888 13.95 8.69897C13.1 7.90931 12.36 7.2296 11.8 6.79978C11.25 6.37996 10.68 6.03011 10.06 6.00012C9.12 5.96014 8.22 6.38995 7.64 7.15963C7.25 7.6794 7.12 8.35911 7.06 9.07881C7 9.80849 7 10.7681 7 11.9576V12.0475C7 13.247 7 14.1966 7.06 14.9263C7.12 15.646 7.25 16.3257 7.64 16.8355C8.22 17.6052 9.12 18.035 10.06 17.995C10.68 17.965 11.25 17.6152 11.8 17.1953C12.36 16.7655 13.04 16.1358 13.89 15.3461L13.95 15.2961C14.37 14.9063 14.72 14.5865 15 14.2866V16.4956C15 17.0454 15.45 17.4952 16 17.4952C16.55 17.4952 17 17.0454 17 16.4956V7.49948C17 6.94972 16.55 6.49991 16 6.49991Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_45532">
                        <rect width="10" height="12" fill={colors?.[1] || "#FFFFFF"} transform="translate(7 6)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    forward: {
        defaultColors: ["#3D4C66"],
        keywords: ["forward","next","skip","advance","continue","process","flow","move-forward","fast-forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.268 9.60952L17.268 9.60953C18.1994 10.4245 18.665 10.8319 18.841 11.3126C19.0034 11.7565 19.0034 12.2435 18.841 12.6874C18.665 13.1681 18.1994 13.5755 17.268 14.3905C15.6161 15.8359 14.7902 16.5586 14.0909 16.5904C13.4511 16.6195 12.836 16.3404 12.4365 15.8397C12 15.2925 12 14.195 12 12C12 9.80501 12 8.70752 12.4365 8.16029C12.836 7.6596 13.4511 7.38049 14.0909 7.4096C14.7902 7.44142 15.6161 8.16412 17.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.26803 9.60952L9.26804 9.60953C10.1994 10.4245 10.665 10.8319 10.841 11.3126C11.0034 11.7565 11.0034 12.2435 10.841 12.6874C10.665 13.1681 10.1994 13.5755 9.26804 14.3905C7.61614 15.8359 6.79019 16.5586 6.0909 16.5904C5.45106 16.6195 4.83598 16.3404 4.43655 15.8397C4 15.2925 4 14.195 4 12C4 9.80501 4 8.70752 4.43655 8.16029C4.83598 7.6596 5.45105 7.38049 6.0909 7.4096C6.79019 7.44142 7.61614 8.16412 9.26803 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Fragile-Glass-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["fragile","glass","breakable","shipping","damage","warning","handle-with-care","return","damaged-goods","fragile-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14V14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4L11 6H13L12 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "forward-step": {
        defaultColors: ["#3D4C66"],
        keywords: ["skip","next","forward","fast-forward","next-item","queue","playback-control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.268 9.60952L12.268 9.60953C13.1994 10.4245 13.665 10.8319 13.841 11.3126C14.0034 11.7565 14.0034 12.2435 13.841 12.6874C13.665 13.1681 13.1994 13.5755 12.268 14.3905C10.6161 15.8359 9.79019 16.5586 9.0909 16.5904C8.45106 16.6195 7.83598 16.3404 7.43655 15.8397C7 15.2925 7 14.195 7 12C7 9.80501 7 8.70752 7.43655 8.16029C7.83598 7.6596 8.45105 7.38049 9.0909 7.4096C9.79019 7.44142 10.6161 8.16412 12.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Fragile-Glass-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fragile","glass","breakable","warning","handle-with-care","shipment","packaging"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 14V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4L11 6H13L12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Fragile-Glass-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fragile","breakable","glass","warning","damage","handling","shipping","packaging","fragile-item","handle-with-care"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.382 3H6.99989C6.48614 3 6.05597 3.38929 6.00485 3.9005L5.60187 7.93027C5.25724 11.3766 7.69038 14.4078 10.9999 14.923V19H6.99989C6.4476 19 5.99989 19.4477 5.99989 20C5.99989 20.5523 6.4476 21 6.99989 21H16.9999C17.5522 21 17.9999 20.5523 17.9999 20C17.9999 19.4477 17.5522 19 16.9999 19H12.9999V14.923C16.3094 14.4078 18.7425 11.3766 18.3979 7.93027L17.9949 3.9005C17.9438 3.38929 17.5136 3 16.9999 3H13.618L12.618 4.99997H13C13.3466 4.99997 13.6684 5.17943 13.8507 5.47424C14.0329 5.76906 14.0494 6.1372 13.8944 6.44719L12.8944 8.44719C12.6474 8.94117 12.0468 9.14139 11.5528 8.8944C11.0588 8.64741 10.8586 8.04674 11.1056 7.55276L11.382 6.99997H11C10.6534 6.99997 10.3316 6.82052 10.1494 6.52571C9.96714 6.23089 9.95058 5.86275 10.1056 5.55276L11.382 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Fragile-Glass": {
        defaultColors: ["#3D4C66"],
        keywords: ["fragile","glass","broken","damage","warning","breakable","handle-with-care","shipping","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14V14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4L11 6H13L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Full-screen-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["fullscreen","expand","maximize","view","display","zoom","layout","full-screen","full screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5H9.16667H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 5H14.8333H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19L14.8333 19L15 19C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15L19 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 19L9.16667 19L9 19C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15L5 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Full-screen-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["fullscreen","expand","maximize","view","full-view","zoom","enlarge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5H9.16667H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 5H14.8333H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 19L14.8333 19L15 19C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15L19 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 19L9.16667 19L9 19C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Full-screen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["fullscreen","expand","maximize","zoom","display","layout","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 4C8.95604 4 8.97799 4 9.00001 4H10C10.5523 4 11 4.44772 11 5C11 5.55229 10.5523 6 10 6H9.00001C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6.00001 8.02893 6.00001 9V10C6.00001 10.5523 5.55229 11 5.00001 11C4.44772 11 4.00001 10.5523 4.00001 10V9C4.00001 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 4C15.044 4 15.022 4 15 4H14C13.4477 4 13 4.44772 13 5C13 5.55229 13.4477 6 14 6H15C15.9711 6 16.5988 6.00213 17.0613 6.06431C17.495 6.12263 17.631 6.21677 17.7071 6.2929C17.7832 6.36902 17.8774 6.50497 17.9357 6.93871C17.9979 7.40122 18 8.02893 18 9V10C18 10.5523 18.4477 11 19 11C19.5523 11 20 10.5523 20 10V9C20 8.97799 20 8.95604 20 8.93417C20.0001 8.04769 20.0001 7.28387 19.9179 6.67221C19.8297 6.0167 19.631 5.38835 19.1213 4.87868C18.6117 4.36902 17.9833 4.17028 17.3278 4.08215C16.7161 3.99991 15.9523 3.99995 15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 20C15.044 20 15.022 20 15 20H14C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V15C20 15.022 20 15.044 20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 20C8.95604 20 8.97799 20 9.00001 20H10C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18L9.00001 18C8.02893 18 7.40122 17.9979 6.93871 17.9357C6.50497 17.8774 6.36902 17.7832 6.2929 17.7071C6.21677 17.631 6.12263 17.495 6.06431 17.0613C6.00213 16.5988 6 15.9711 6 15V14C6 13.4477 5.55229 13 5 13C4.44772 13 4 13.4477 4 14L4 15C4 15.022 4 15.044 4 15.0658C3.99995 15.9523 3.99991 16.7161 4.08215 17.3278C4.17028 17.9833 4.36902 18.6117 4.87868 19.1213C5.38835 19.631 6.0167 19.8297 6.67221 19.9179C7.28387 20.0001 8.04769 20.0001 8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Full-screen": {
        defaultColors: ["#3D4C66"],
        keywords: ["fullscreen","expand","maximize","interface","display","screen","view","size","zoom","enlarge","full-screen","expand-screen","maximize-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "functions-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sum","sigma","total","calculation","aggregate","functions","operations","mathematics","discounts","subtotal","total-amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L12 13L6 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7L6 7M18 19L6 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "functions-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sum","total","calculation","aggregate","math","functions","sigma"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.61887 6.0752C5.5003 6.124 5.38922 6.19657 5.29289 6.29289C5.19702 6.38877 5.12468 6.49927 5.07588 6.61722C5.02699 6.73512 5 6.86441 5 7C5 7.13667 5.02742 7.26693 5.07705 7.3856C5.12396 7.498 5.19229 7.60358 5.28205 7.69609L5.29434 7.70855L10.5858 13L5.29289 18.2929C5.19702 18.3888 5.12468 18.4993 5.07588 18.6172C5.02699 18.7351 5 18.8644 5 19C5 19.1367 5.02742 19.2669 5.07705 19.3856C5.12357 19.4971 5.19116 19.6018 5.27981 19.6938C5.28846 19.7028 5.29727 19.7116 5.30624 19.7202C5.48605 19.8935 5.73058 20 6 20L18 20C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18L8.41421 18L12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13C13 12.7348 12.8946 12.4804 12.7071 12.2929L8.41422 8L18 8C18.5523 8 19 7.55229 19 7C19 6.44772 18.5523 6 18 6H6.00197H6L5.98327 6.00014L5.61887 6.0752Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    functions: {
        defaultColors: ["#3D4C66"],
        keywords: ["sum","total","calculation","aggregate","math","functions","sigma"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L6 7L12 13L6 19L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "funds-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["arrow","up","trend","increase","growth","sales","revenue","profit","performance","analytics","reporting","metrics","rising","success","progress","funds"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 16L7.95505 13.0449L10 15L14 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.9999 12C19.9999 16.4183 16.4185 20 12.0002 20C7.58191 20 4 16.4183 4 12C4 7.58172 7.58191 4 12.0002 4C16.4185 4 19.9999 7.58172 19.9999 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11H14V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "functions-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sum","total","calculate","functions","sigma","math","statistics","equation","summary","aggregation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L12 13L6 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7L6 7M18 19L6 19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "funds-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["growth","increase","trend","analytics","sales","revenue","statistics","chart","diagram","rising","profits","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9999 12C19.9999 16.4183 16.4185 20 12.0002 20C7.58191 20 4 16.4183 4 12C4 7.58172 7.58191 4 12.0002 4C16.4185 4 19.9999 7.58172 19.9999 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11H14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16L7.95505 13.0449L10 15L14 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "funds-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sales","graph","arrow","up","trending","growth","increase","profits","revenue","analytics","data","charts","performance","statistics","metrics","rise","progress","development"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0003 21C16.9709 21 21 16.9706 21 12C21 7.02944 16.9709 3 12.0003 3C7.02968 3 3 7.02944 3 12C3 13.4002 3.31976 14.7257 3.89025 15.9075L7.35391 12.4438C7.6806 12.1171 8.2084 12.1112 8.54234 12.4305L9.98655 13.8112L11.9478 11.8499H10.9999C10.5305 11.8499 10.1499 11.4693 10.1499 10.9999C10.1499 10.5305 10.5305 10.1499 10.9999 10.1499H13.9999C14.4693 10.1499 14.8499 10.5305 14.8499 10.9999V13.9999C14.8499 14.4693 14.4693 14.8499 13.9999 14.8499C13.5305 14.8499 13.1499 14.4693 13.1499 13.9999V13.052L10.6009 15.6009C10.2743 15.9276 9.74646 15.9336 9.41252 15.6143L7.96831 14.2336L4.80048 17.4014C6.44259 19.5866 9.05641 21 12.0003 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "funds-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","trend","sales","growth","increase","rising","profit","revenue","analytics","stats","graph","chart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 19H11C8.19108 19 6.78661 19 5.77772 18.3259C5.34096 18.034 4.96596 17.659 4.67412 17.2223C4 16.2134 4 14.8089 4 12C4 9.19108 4 7.78661 4.67412 6.77772C4.96596 6.34096 5.34096 5.96596 5.77772 5.67412C6.78661 5 8.19108 5 11 5H13C15.8089 5 17.2134 5 18.2223 5.67412C18.659 5.96596 19.034 6.34096 19.3259 6.77772C20 7.78661 20 9.19108 20 12C20 14.8089 20 16.2134 19.3259 17.2223C19.034 17.659 18.659 18.034 18.2223 18.3259C17.2134 19 15.8089 19 13 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L12 14L10 12L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H16V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "funds-box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sales","increase","growth","profit","analytics","trend","statistics","performance","metrics","reporting","arrow-up","charts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 19H11C8.19108 19 6.78661 19 5.77772 18.3259C5.34096 18.034 4.96596 17.659 4.67412 17.2223C4 16.2134 4 14.8089 4 12C4 9.19108 4 7.78661 4.67412 6.77772C4.96596 6.34096 5.34096 5.96596 5.77772 5.67412C6.78661 5 8.19108 5 11 5H13C15.8089 5 17.2134 5 18.2223 5.67412C18.659 5.96596 19.034 6.34096 19.3259 6.77772C20 7.78661 20 9.19108 20 12C20 14.8089 20 16.2134 19.3259 17.2223C19.034 17.659 18.659 18.034 18.2223 18.3259C17.2134 19 15.8089 19 13 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L12 14L10 12L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H16V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "funds-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["statistics","arrow","up","growth","sales","trending","increase","charts","profits","analytics","performance","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9461 4H13.0539C14.4126 3.99999 15.5083 3.99997 16.3874 4.0894C17.2948 4.18171 18.0817 4.3775 18.7779 4.84265C19.3238 5.20745 19.7926 5.6762 20.1573 6.22215C20.6225 6.91829 20.8183 7.70523 20.9106 8.61264C21 9.49172 21 10.5874 21 11.946V12.054C21 13.4126 21 14.5083 20.9106 15.3874C20.8183 16.2948 20.6225 17.0817 20.1573 17.7779C19.7926 18.3238 19.3238 18.7926 18.7779 19.1573C18.0817 19.6225 17.2948 19.8183 16.3874 19.9106C15.5083 20 14.4126 20 13.054 20H10.946C9.5874 20 8.49173 20 7.61265 19.9106C6.70523 19.8183 5.91829 19.6225 5.22215 19.1573C4.6762 18.7926 4.20745 18.3238 3.84265 17.7779C3.3775 17.0817 3.18171 16.2948 3.0894 15.3874C2.99997 14.5083 2.99999 13.4126 3 12.054V11.9461C2.99999 10.5874 2.99997 9.49173 3.0894 8.61264C3.18171 7.70523 3.37751 6.91829 3.84265 6.22215C4.20745 5.6762 4.6762 5.20745 5.22215 4.84265C5.91829 4.3775 6.70523 4.18171 7.61265 4.0894C8.49173 3.99997 9.5874 3.99999 10.9461 4ZM12.1499 9.9999C12.1499 10.4693 12.5305 10.8499 12.9999 10.8499H13.9478L11.9999 12.7978L10.6009 11.3989C10.269 11.0669 9.73081 11.0669 9.39886 11.3989L7.39886 13.3989C7.06692 13.7308 7.06692 14.269 7.39886 14.6009C7.73081 14.9329 8.269 14.9329 8.60094 14.6009L9.9999 13.202L11.3989 14.6009C11.7308 14.9329 12.269 14.9329 12.6009 14.6009L15.1499 12.052V12.9999C15.1499 13.4693 15.5305 13.8499 15.9999 13.8499C16.4693 13.8499 16.8499 13.4693 16.8499 12.9999V9.9999C16.8499 9.53046 16.4693 9.1499 15.9999 9.1499H12.9999C12.5305 9.1499 12.1499 9.53046 12.1499 9.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "funds-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","graph","arrow","increase","growth","trend","sales","profit","analytics","metrics","reporting","statistics","progress","rising","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 19H11C8.19108 19 6.78661 19 5.77772 18.3259C5.34096 18.034 4.96596 17.659 4.67412 17.2223C4 16.2134 4 14.8089 4 12C4 9.19108 4 7.78661 4.67412 6.77772C4.96596 6.34096 5.34096 5.96596 5.77772 5.67412C6.78661 5 8.19108 5 11 5H13C15.8089 5 17.2134 5 18.2223 5.67412C18.659 5.96596 19.034 6.34096 19.3259 6.77772C20 7.78661 20 9.19108 20 12C20 14.8089 20 16.2134 19.3259 17.2223C19.034 17.659 18.659 18.034 18.2223 18.3259C17.2134 19 15.8089 19 13 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L12 14L10 12L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H16V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    funds: {
        defaultColors: ["#3D4C66"],
        keywords: ["square","graph","arrow","increase","growth","trend","sales","profit","analytics","metrics","reporting","statistics","progress","rising","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9999 12C19.9999 16.4183 16.4185 20 12.0002 20C7.58191 20 4 16.4183 4 12C4 7.58172 7.58191 4 12.0002 4C16.4185 4 19.9999 7.58172 19.9999 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11H14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16L7.95505 13.0449L10 15L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "G-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["g","initial","transaction","gift","card","payment","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.1807 19 17.8659 16.8786 18.7179 13.9736C18.9472 13.192 19.0618 12.8012 18.7618 12.4006C18.4618 12 17.9746 12 17 12H12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "G-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["g","letter-g","google","vendor","supplier","guest","group","customer-group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.1807 19 17.8659 16.8786 18.7179 13.9736C18.9472 13.192 19.0618 12.8012 18.7618 12.4006C18.4618 12 17.9746 12 17 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "G-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["G","letter","text","initial","gateway","generic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C14.7248 18 17.0278 16.1828 17.7583 13.6921C17.8173 13.4912 17.8612 13.3409 17.8937 13.2113C17.9135 13.1324 17.9256 13.0739 17.9329 13.0304C17.8613 13.0194 17.7599 13.0107 17.6109 13.0057C17.4436 13.0001 17.2486 13 17 13H12C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11H17C17.0216 11 17.0432 11 17.0649 11C17.495 10.9998 17.9391 10.9996 18.3092 11.0656C18.7618 11.1462 19.2185 11.3422 19.5623 11.8012C19.8768 12.2212 19.9719 12.6687 19.9351 13.1247C19.9068 13.4754 19.7943 13.858 19.6951 14.1952C19.6892 14.2153 19.6833 14.2353 19.6775 14.255C18.7039 17.5744 15.6365 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "g-mobile-data-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["g","data","mobile","network","connection","settings","configuration","account","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 7H10C9.05719 7 8.58579 7 8.29289 7.29289C8 7.58579 8 8.05719 8 9V15C8 15.9428 8 16.4142 8.29289 16.7071C8.58579 17 9.05719 17 10 17H14C14.9428 17 15.4142 17 15.7071 16.7071C16 16.4142 16 15.9428 16 15V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "g-mobile-data-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["g","letter-g","gateway","settings","configuration","options","general"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 7H10C9.05719 7 8.58579 7 8.29289 7.29289C8 7.58579 8 8.05719 8 9V15C8 15.9428 8 16.4142 8.29289 16.7071C8.58579 17 9.05719 17 10 17H14C14.9428 17 15.4142 17 15.7071 16.7071C16 16.4142 16 15.9428 16 15V12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "g-mobile-data": {
        defaultColors: ["#3D4C66"],
        keywords: ["G","letter","g-mobile-data","initial","alphabet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8H11C10.0572 8 9.58579 8 9.29289 8.29289C9 8.58579 9 9.05719 9 10V14C9 14.9428 9 15.4142 9.29289 15.7071C9.58579 16 10.0572 16 11 16H13C13.9428 16 14.4142 16 14.7071 15.7071C15 15.4142 15 14.9428 15 14V14C15 13.0572 15 12.5858 14.7071 12.2929C14.4142 12 13.9428 12 13 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    G: {
        defaultColors: ["#3D4C66"],
        keywords: ["G","letter","g-mobile-data","initial","alphabet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.1807 19 17.8659 16.8786 18.7179 13.9736C18.9472 13.192 19.0618 12.8012 18.7618 12.4006C18.4618 12 17.9746 12 17 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "g-mobile-data-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["G","letter","alphabet","group","global","gift","gross","gain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.94561 6.00001C9.52154 5.99992 9.10941 5.99984 8.76949 6.04554C8.38629 6.09706 7.94902 6.22259 7.5858 6.5858C7.22259 6.94902 7.09706 7.38629 7.04554 7.76949C6.99984 8.10941 6.99992 8.52154 7.00001 8.94561V15.0544C6.99992 15.4785 6.99984 15.8906 7.04554 16.2305C7.09706 16.6137 7.22259 17.051 7.5858 17.4142C7.94902 17.7774 8.38629 17.903 8.76949 17.9545C9.10941 18.0002 9.52153 18.0001 9.94559 18H14.0544C14.4785 18.0001 14.8906 18.0002 15.2305 17.9545C15.6137 17.903 16.051 17.7774 16.4142 17.4142C16.7774 17.051 16.903 16.6137 16.9545 16.2305C17.0002 15.8906 17.0001 15.4785 17 15.0544L17 12C17 11.7929 16.9371 11.6005 16.8292 11.4409C16.7222 11.2825 16.5711 11.1565 16.3934 11.0804C16.2727 11.0286 16.1397 11 16 11H12C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13H15V15C15 15.4997 14.9979 15.7738 14.9723 15.964L14.9713 15.9713L14.964 15.9723C14.7738 15.9979 14.4997 16 14 16H10C9.50034 16 9.22618 15.9979 9.03599 15.9723L9.02871 15.9713L9.02771 15.964C9.00214 15.7738 9.00001 15.4997 9.00001 15V9.00001C9.00001 8.50034 9.00214 8.22618 9.02771 8.03599L9.02871 8.02871L9.03599 8.02771C9.22618 8.00214 9.50034 8.00001 10 8.00001H16C16.5523 8.00001 17 7.5523 17 7.00001C17 6.44773 16.5523 6.00001 16 6.00001L9.94561 6.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery line 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","picture","media","add-image","add-media","select-image","select-media","display-image","display-media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 15L18.4965 14.6979C16.3538 13.4123 15.2825 12.7695 14.1741 12.9687C13.0657 13.1679 12.2852 14.1435 10.7243 16.0947L10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 19H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery line 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","photo","gallery","media","product-image","add-image","display-image","select-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 15L18.4965 14.6979C16.3538 13.4123 15.2825 12.7695 14.1741 12.9687C13.0657 13.1679 12.2852 14.1435 10.7243 16.0947L10 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery line 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","browse","picture","select-image","choose-image","logo","brand-image","add-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 3.25H10.9294C9.57533 3.24997 8.45869 3.24994 7.57494 3.36876C6.64711 3.4935 5.82769 3.76547 5.17158 4.42158C4.51547 5.07769 4.2435 5.89711 4.11876 6.82494C3.99994 7.70869 3.99997 8.82529 4 10.1794V10.3206C3.99997 11.6747 3.99994 12.7913 4.11876 13.6751C4.2435 14.6029 4.51547 15.4223 5.17158 16.0784C5.82769 16.7345 6.64711 17.0065 7.57494 17.1313C7.76279 17.1565 7.96116 17.1764 8.17009 17.1921C8.1819 17.1745 8.19433 17.1573 8.2074 17.1403L10.0283 14.7731C10.7609 13.8206 11.3683 13.0311 11.9354 12.4603C12.5326 11.8592 13.1728 11.408 13.9992 11.246C14.8257 11.0841 15.5888 11.2603 16.3688 11.5915C17.1094 11.906 17.9697 12.4079 19.0077 13.0134L19.8991 13.5334C20.0001 12.673 20 11.6034 20 10.3207V10.1794C20 8.82534 20.0001 7.70868 19.8813 6.82494C19.7565 5.89711 19.4845 5.07769 18.8284 4.42158C18.1723 3.76547 17.3529 3.4935 16.4251 3.36876C15.5413 3.24994 14.4247 3.24997 13.0706 3.25ZM9.5 6.5C8.25734 6.5 7.25 7.50742 7.25 8.75003C7.25 9.9927 8.25738 11 9.5 11C10.7426 11 11.75 9.9927 11.75 8.75003C11.75 7.50741 10.7427 6.5 9.5 6.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.2917 15.4945L18.0563 14.7738C16.9476 14.1271 16.1968 13.6913 15.5871 13.4324C15.0034 13.1846 14.6682 13.153 14.3839 13.2087C14.0995 13.2644 13.801 13.4202 13.3541 13.87C12.8872 14.3399 12.3564 15.0269 11.5738 16.0442L10.6463 17.25C10.7395 17.25 10.8339 17.25 10.9294 17.25H13.0706C14.4247 17.25 15.5413 17.2501 16.4251 17.1313C17.3529 17.0065 18.1723 16.7345 18.8284 16.0784C19.0108 15.896 19.1636 15.701 19.2917 15.4945Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 19.75C20 19.1977 19.5523 18.75 19 18.75H5C4.44772 18.75 4 19.1977 4 19.75C4 20.3023 4.44772 20.75 5 20.75H19C19.5523 20.75 20 20.3023 20 19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery line 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","photo","gallery","media","browse","select-image","choose-image","visual","artwork"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 15L18.4965 14.6979C16.3538 13.4123 15.2825 12.7695 14.1741 12.9687C13.0657 13.1679 12.2852 14.1435 10.7243 16.0947L10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 19H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","picture","media","product-image","add-image","select-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 7C8.89543 7 8 7.89547 8 9.00004C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9.00004C12 7.89547 11.1046 7 10 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 13.9585L18.3338 13.5644C16.2626 12.3388 15.227 11.726 14.1496 11.9043C13.0721 12.0825 12.289 12.9961 10.7228 14.8234L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 20H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","picture","media","browse","view","show","display","select-image","choose-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 7C8.89543 7 8 7.89547 8 9.00004C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9.00004C12 7.89547 11.1046 7 10 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 13.9585L18.3338 13.5644C16.2626 12.3388 15.227 11.726 14.1496 11.9043C13.0721 12.0825 12.289 12.9961 10.7228 14.8234L8 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 20H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","photo","gallery","view","picture","media","add-image","upload-image","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 2.2002H10.9294C9.57533 2.20016 8.45869 2.20013 7.57494 2.31895C6.64711 2.44369 5.82769 2.71566 5.17158 3.37177C4.51547 4.02788 4.2435 4.84731 4.11876 5.77514C3.99994 6.65889 3.99997 7.77549 4 9.1296V11.2708C3.99997 12.6249 3.99994 13.7415 4.11876 14.6253C4.2435 15.5531 4.51547 16.3725 5.17158 17.0286C5.46264 17.3197 5.78584 17.5352 6.13639 17.6957C6.16788 17.6419 6.20488 17.5903 6.24744 17.5417L10.1383 13.095C10.8593 12.2709 11.4591 11.5854 12.011 11.0899C12.5933 10.5672 13.2044 10.1779 13.9709 10.0392C14.7374 9.9005 15.4462 10.0509 16.1747 10.3365C16.8652 10.6072 17.6672 11.039 18.6313 11.5582L19.9978 12.294C20 11.9695 20 11.6284 20 11.2708V9.12962C20 7.77554 20.0001 6.65888 19.8813 5.77514C19.7565 4.84731 19.4845 4.02788 18.8284 3.37177C18.1723 2.71566 17.3529 2.44369 16.4251 2.31895C15.5413 2.20013 14.4247 2.20016 13.0706 2.2002ZM9.50002 5.4502C8.25736 5.4502 7.25003 6.45761 7.25003 7.70023C7.25003 8.94289 8.25741 9.9502 9.50003 9.9502C10.7426 9.9502 11.75 8.94289 11.75 7.70023C11.75 6.45761 10.7427 5.4502 9.50002 5.4502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.8958 14.5106L17.7367 13.348C16.7052 12.7926 16.0095 12.4199 15.4448 12.1986C14.9054 11.9871 14.593 11.9591 14.327 12.0072C14.061 12.0554 13.7782 12.1911 13.3471 12.5781C12.8958 12.9833 12.3748 13.5762 11.6033 14.4579L8.36777 18.1556C9.0992 18.2002 9.95251 18.2002 10.9294 18.2002H13.0706C14.4247 18.2002 15.5413 18.2003 16.4251 18.0814C17.3529 17.9567 18.1723 17.6847 18.8284 17.0286C19.4845 16.3725 19.7565 15.5531 19.8813 14.6253C19.8863 14.5875 19.8912 14.5493 19.8958 14.5106Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 20.7002C20 20.1479 19.5523 19.7002 19 19.7002H5C4.44772 19.7002 4 20.1479 4 20.7002C4 21.2525 4.44772 21.7002 5 21.7002H19C19.5523 21.7002 20 21.2525 20 20.7002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery scene-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gallery","image","photo","landscape","scenery","view","background","display","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C14.8954 5 14 5.89547 14 7.00004C14 8.10461 14.8954 9 16 9C17.1046 9 18 8.10461 18 7.00004C18 5.89547 17.1046 5 16 5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.2778 19H10.5434C8.62825 19 7.67068 19 7.12528 18.5686C6.73885 18.2629 6.47886 17.8253 6.39516 17.3397C6.27703 16.6544 6.73491 15.8134 7.65067 14.1314V14.1314C8.60919 12.3709 9.08844 11.4906 9.74744 11.2211C10.2138 11.0304 10.7349 11.0227 11.2067 11.1996C11.8733 11.4495 12.3784 12.3153 13.3884 14.0468L13.4907 14.2222M16.2778 19H11M16.2778 19V19C17.5285 19 18.3419 17.6838 17.7826 16.5652L16.5913 14.1825C15.9474 12.8947 14.1015 12.9184 13.4907 14.2222V14.2222M16.2778 19L13.4907 14.2222"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery scene-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["gallery","image","picture","scene","landscape","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C14.8954 5 14 5.89547 14 7.00004C14 8.10461 14.8954 9 16 9C17.1046 9 18 8.10461 18 7.00004C18 5.89547 17.1046 5 16 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 19H10.5434C8.62825 19 7.67068 19 7.12528 18.5686C6.73885 18.2629 6.47886 17.8253 6.39516 17.3397C6.27703 16.6544 6.73491 15.8134 7.65067 14.1314C8.60919 12.3709 9.08844 11.4906 9.74744 11.2211C10.2138 11.0304 10.7349 11.0227 11.2067 11.1996C11.8733 11.4495 12.3784 12.3153 13.3884 14.0468L13.4907 14.2222C14.1015 12.9184 15.9474 12.8947 16.5913 14.1825L17.7826 16.5652C18.3419 17.6838 17.5285 19 16.2778 19H11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16.2778 19H10.5434C8.62825 19 7.67068 19 7.12528 18.5686C6.73885 18.2629 6.47886 17.8253 6.39516 17.3397C6.27703 16.6544 6.73491 15.8134 7.65067 14.1314V14.1314C8.60919 12.3709 9.08844 11.4906 9.74744 11.2211C10.2138 11.0304 10.7349 11.0227 11.2067 11.1996C11.8733 11.4495 12.3784 12.3153 13.3884 14.0468L13.4907 14.2222M16.2778 19H11M16.2778 19V19C17.5285 19 18.3419 17.6838 17.7826 16.5652L16.5913 14.1825C15.9474 12.8947 14.1015 12.9184 13.4907 14.2222V14.2222M16.2778 19L13.4907 14.2222"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery scene-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","images","media","display","pictures","view","add-media","add-images"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.5653 12.5491C14.8737 11.8241 16.6971 12.1866 17.4698 13.6969H17.4801L18.706 16.0933C19.6229 17.8856 18.2836 20 16.2335 20H10.3305C9.36208 20 8.56883 20 7.94041 19.9396C7.31198 19.8792 6.68356 19.7483 6.16846 19.3455C5.57095 18.8824 5.16917 18.2279 5.03524 17.4929C4.92192 16.8585 5.09705 16.2544 5.3443 15.6906C5.59155 15.1166 5.97272 14.432 6.43631 13.6063C6.50135 13.49 6.56472 13.3762 6.62659 13.2651C7.02531 12.5493 7.3618 11.9451 7.68286 11.4919C8.04343 10.9683 8.47611 10.4749 9.10453 10.2232C9.82567 9.94127 10.6292 9.92114 11.3607 10.193C11.9891 10.4246 12.4424 10.9079 12.8236 11.4214C13.0605 11.7335 13.2974 12.1161 13.5653 12.5491Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.375 4.25C15.0633 4.25 14 5.31338 14 6.62504C14 7.93674 15.0633 9 16.375 9C17.6867 9 18.75 7.93673 18.75 6.62504C18.75 5.31338 17.6867 4.25 16.375 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery line": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","photo","picture","gallery","media","add-image","product-image","upload-image","select-image","insert-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 7C8.89543 7 8 7.89547 8 9.00004C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9.00004C12 7.89547 11.1046 7 10 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 13.9585L18.3338 13.5644C16.2626 12.3388 15.227 11.726 14.1496 11.9043C13.0721 12.0825 12.289 12.9961 10.7228 14.8234L8 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 20H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery scene": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","scene","image","browse","media","photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C14.8954 5 14 5.89547 14 7.00004C14 8.10461 14.8954 9 16 9C17.1046 9 18 8.10461 18 7.00004C18 5.89547 17.1046 5 16 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.2778 19H10.5434C8.62825 19 7.67068 19 7.12528 18.5686C6.73885 18.2629 6.47886 17.8253 6.39516 17.3397C6.27703 16.6544 6.73491 15.8134 7.65067 14.1314V14.1314C8.60919 12.3709 9.08844 11.4906 9.74744 11.2211C10.2138 11.0304 10.7349 11.0227 11.2067 11.1996C11.8733 11.4495 12.3784 12.3153 13.3884 14.0468L13.4907 14.2222M16.2778 19H11M16.2778 19V19C17.5285 19 18.3419 17.6838 17.7826 16.5652L16.5913 14.1825C15.9474 12.8947 14.1015 12.9184 13.4907 14.2222V14.2222M16.2778 19L13.4907 14.2222"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v10-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["image","gallery","media","photo","landscape","artwork","add-image","select-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.0556 16H10.196C8.76142 16 8.04412 16 7.7503 15.5305C7.45648 15.0609 7.77008 14.4158 8.39727 13.1256L9.15176 11.5735C9.9104 10.0129 10.2897 9.23258 10.9058 9.22405C11.522 9.21551 11.9228 9.98502 12.7243 11.524L13.0648 12.1778M15.0556 16H11.2857M15.0556 16V16C15.4114 16 15.5893 16 15.7157 15.9664C16.2119 15.8343 16.5274 15.3479 16.4457 14.8409C16.4249 14.7118 16.3524 14.5493 16.2073 14.2245L15.2819 12.1514C15.1183 11.785 15.0365 11.6017 14.9619 11.506C14.5555 10.9839 13.7632 10.9933 13.3693 11.5249C13.2971 11.6224 13.2197 11.8075 13.0648 12.1778V12.1778M15.0556 16L13.0648 12.1778"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v10-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","picture","media","photo","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.39727 13.1256L9.15176 11.5735C9.9104 10.0129 10.2897 9.23258 10.9058 9.22405C11.522 9.21551 11.9228 9.98502 12.7243 11.524L13.0648 12.1778L13.0648 12.1778C13.2197 11.8075 13.2971 11.6224 13.3693 11.5249C13.7632 10.9933 14.5555 10.9839 14.9619 11.506C15.0365 11.6017 15.1183 11.785 15.2819 12.1514L15.2819 12.1514L16.2073 14.2245C16.3524 14.5493 16.4249 14.7118 16.4457 14.8409C16.5274 15.3479 16.2119 15.8343 15.7157 15.9664C15.5893 16 15.4114 16 15.0556 16H11.2857H10.196C8.76142 16 8.04412 16 7.7503 15.5305C7.45648 15.0609 7.77008 14.4158 8.39727 13.1256Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.0556 16H10.196C8.76142 16 8.04412 16 7.7503 15.5305C7.45648 15.0609 7.77008 14.4158 8.39727 13.1256L9.15176 11.5735C9.9104 10.0129 10.2897 9.23258 10.9058 9.22405C11.522 9.21551 11.9228 9.98502 12.7243 11.524L13.0648 12.1778M15.0556 16H11.2857M15.0556 16V16C15.4114 16 15.5893 16 15.7157 15.9664C16.2119 15.8343 16.5274 15.3479 16.4457 14.8409C16.4249 14.7118 16.3524 14.5493 16.2073 14.2245L15.2819 12.1514C15.1183 11.785 15.0365 11.6017 14.9619 11.506C14.5555 10.9839 13.7632 10.9933 13.3693 11.5249C13.2971 11.6224 13.2197 11.8075 13.0648 12.1778V12.1778M15.0556 16L13.0648 12.1778"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v10-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","pictures","albums","view","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM13.1424 10.7044C12.8569 10.1615 12.6014 9.6974 12.3533 9.35431C12.0387 8.91915 11.5852 8.46459 10.8954 8.47415C10.2057 8.4837 9.76496 8.95064 9.46251 9.39435C9.16464 9.83133 8.86032 10.4574 8.50358 11.1914L7.69789 12.8488C7.40557 13.4501 7.14994 13.9758 7.01303 14.4105C6.86873 14.8687 6.79356 15.4155 7.11451 15.9284C7.43547 16.4412 7.96006 16.6127 8.43523 16.6832C8.88604 16.7501 9.4706 16.7501 10.1391 16.75L15.0555 16.75L15.1326 16.7501C15.4069 16.7507 15.6829 16.7512 15.9086 16.6911C16.7769 16.46 17.3291 15.6088 17.1862 14.7217C17.149 14.4912 17.036 14.2394 16.9237 13.9891L16.8922 13.9187L15.9617 11.8344C15.8842 11.661 15.8187 11.5142 15.7634 11.4C15.7104 11.2908 15.6429 11.1598 15.5537 11.0453C14.9555 10.2767 13.8794 10.1663 13.1424 10.7044Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v10": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","picture","browse","images","photos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.0556 16H10.196C8.76142 16 8.04412 16 7.7503 15.5305C7.45648 15.0609 7.77008 14.4158 8.39727 13.1256L9.15176 11.5735C9.9104 10.0129 10.2897 9.23258 10.9058 9.22405C11.522 9.21551 11.9228 9.98502 12.7243 11.524L13.0648 12.1778M15.0556 16H11.2857M15.0556 16V16C15.4114 16 15.5893 16 15.7157 15.9664C16.2119 15.8343 16.5274 15.3479 16.4457 14.8409C16.4249 14.7118 16.3524 14.5493 16.2073 14.2245L15.2819 12.1514C15.1183 11.785 15.0365 11.6017 14.9619 11.506C14.5555 10.9839 13.7632 10.9933 13.3693 11.5249C13.2971 11.6224 13.2197 11.8075 13.0648 12.1778V12.1778M15.0556 16L13.0648 12.1778"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v11-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cloud","storage","gallery","media","files","backup","restore","cloud-storage","cloud-backup","cloud-restore","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v11-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cloud","storage","backup","cloud-storage","cloud-backup","data","sync","online","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778C13.4731 10.2015 14.8505 10.1851 15.2819 11.1514L16.2073 13.2245C16.5798 14.0588 15.9692 15 15.0556 15H11.2857H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v11": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","library","picture","cloud-storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v12-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","picture","photo","media","display","item-image","product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 19C13 15.6863 15.6863 13 19 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Gallery v12-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","media","photo","picture","album","browse","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19C13 15.6863 15.6863 13 19 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v11-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cloud","storage","backup","data","restore","sync","cloud-storage","cloud-backup","data-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM13.2337 9.92387C13.1817 9.84219 13.1309 9.7702 13.08 9.70788C11.9599 8.33705 9.85527 8.3662 8.77358 9.76753C8.59939 9.99321 8.43091 10.3402 8.20224 10.8112L8.00965 11.2074C7.76214 11.7157 7.57618 12.0977 7.50582 12.4295C7.19843 13.8791 8.09485 15.3116 9.53294 15.6688C9.86209 15.7506 10.2869 15.7504 10.8524 15.75L15.0555 15.75C16.5125 15.75 17.4861 14.2491 16.8922 12.9187L15.9667 10.8457C15.4639 9.71924 14.1681 9.41656 13.2337 9.92387Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v12": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","library","add-image","choose-image","select-image","product-image","menu-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 19C13 15.6863 15.6863 13 19 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Gallery v12-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","media","browse","photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H12V19C12 15.134 15.134 12 19 12H20V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM9.5 7.25C8.25734 7.25 7.25 8.25742 7.25 9.50003C7.25 10.7427 8.25738 11.75 9.5 11.75C10.7426 11.75 11.75 10.7427 11.75 9.50003C11.75 8.25741 10.7427 7.25 9.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.9984 14H19C16.2386 14 14 16.2386 14 19V19.9984C14.9447 19.9933 15.7523 19.9717 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C19.9717 15.7523 19.9933 14.9447 19.9984 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v13-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","photo","media","upload","import","picture","assets","images"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.7796 15.5099C14.4891 16 13.6594 16 12 16C10.3406 16 9.51088 16 9.22038 15.5099C9.19078 15.4599 9.16559 15.4075 9.14508 15.3532C8.94384 14.8202 9.46215 14.1723 10.4988 12.8765C11.1617 12.0479 11.4931 11.6336 11.9306 11.6032C11.9768 11.6 12.0232 11.6 12.0694 11.6032C12.5069 11.6336 12.8383 12.0479 13.5012 12.8765C14.5378 14.1723 15.0562 14.8202 14.8549 15.3532C14.8344 15.4075 14.8092 15.4599 14.7796 15.5099Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8C14.4477 8 14 8.44774 14 9.00002C14 9.55231 14.4477 10 15 10C15.5523 10 16 9.55231 16 9.00002C16 8.44774 15.5523 8 15 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v13-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","browse","pictures"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM13 9.00002C13 7.89548 13.8954 7 15 7C16.1046 7 17 7.89548 17 9.00002C17 10.1046 16.1045 11 15 11C13.8955 11 13 10.1046 13 9.00002ZM12.1424 11.0045C12.0476 10.9985 11.9524 10.9985 11.8576 11.0045C11.2883 11.0407 10.8748 11.3136 10.5715 11.5788C10.2953 11.8204 10.0034 12.154 9.69521 12.5061C9.20179 13.0697 8.685 13.6599 8.40878 14.0812C8.13288 14.502 7.8327 15.1139 8.11086 15.7872C8.15294 15.889 8.20463 15.9873 8.26537 16.081C8.66689 16.7 9.37728 16.8681 9.90924 16.9341C10.4418 17.0002 11.1386 17.0001 11.9284 17.0001H12.0716C12.8614 17.0001 13.5582 17.0002 14.0908 16.9341C14.6227 16.8681 15.3331 16.7 15.7346 16.081C15.7954 15.9873 15.8471 15.889 15.8891 15.7872C16.1673 15.1139 15.8671 14.502 15.5912 14.0812C15.315 13.6599 14.7982 13.0697 14.3048 12.5061C13.9966 12.154 13.7047 11.8204 13.4285 11.5788C13.1252 11.3136 12.7117 11.0407 12.1424 11.0045Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v13": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","media","upload","picture","display","add-image","select-image","browse-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.7796 15.5099C14.4891 16 13.6594 16 12 16C10.3406 16 9.51088 16 9.22038 15.5099C9.19078 15.4599 9.16559 15.4075 9.14508 15.3532C8.94384 14.8202 9.46215 14.1723 10.4988 12.8765C11.1617 12.0479 11.4931 11.6336 11.9306 11.6032C11.9768 11.6 12.0232 11.6 12.0694 11.6032C12.5069 11.6336 12.8383 12.0479 13.5012 12.8765C14.5378 14.1723 15.0562 14.8202 14.8549 15.3532C14.8344 15.4075 14.8092 15.4599 14.7796 15.5099Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8C14.4477 8 14 8.44774 14 9.00002C14 9.55231 14.4477 10 15 10C15.5523 10 16 9.55231 16 9.00002C16 8.44774 15.5523 8 15 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v13-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","media","pictures","customer","user","profile","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.7796 15.5099C14.4891 16 13.6594 16 12 16C10.3406 16 9.51088 16 9.22038 15.5099C9.19078 15.4599 9.16559 15.4075 9.14508 15.3532C8.94384 14.8202 9.46215 14.1723 10.4988 12.8765C11.1617 12.0479 11.4931 11.6336 11.9306 11.6032C11.9768 11.6 12.0232 11.6 12.0694 11.6032C12.5069 11.6336 12.8383 12.0479 13.5012 12.8765C14.5378 14.1723 15.0562 14.8202 14.8549 15.3532C14.8344 15.4075 14.8092 15.4599 14.7796 15.5099Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8C14.4477 8 14 8.44774 14 9.00002C14 9.55231 14.4477 10 15 10C15.5523 10 16 9.55231 16 9.00002C16 8.44774 15.5523 8 15 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v14-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","picture","photo","media","landscape","browse","select-image","view-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8C10.8954 8 10 8.89547 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89547 13.1046 8 12 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L7.30819 13.9224C7.67332 13.4356 8.38499 13.385 8.8153 13.8153L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17L14.3867 14.6133C14.7386 14.2614 15.2957 14.2218 15.6938 14.5204L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Gallery v14-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","pictures","media","landscape","display-image","select-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8C10.8954 8 10 8.89547 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89547 13.1046 8 12 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L7.30819 13.9224C7.67332 13.4356 8.38499 13.385 8.8153 13.8153L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17L14.3867 14.6133C14.7386 14.2614 15.2957 14.2218 15.6938 14.5204L19 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v14": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","picture","photo","add-image","select-image","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8C10.8954 8 10 8.89547 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89547 13.1046 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L7.30819 13.9224C7.67332 13.4356 8.38499 13.385 8.8153 13.8153L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17L14.3867 14.6133C14.7386 14.2614 15.2957 14.2218 15.6938 14.5204L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Gallery v15-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["image","photo","gallery","media","picture","add-image","product-image","update-image","new-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 19L10.1102 16.3341C11.9008 14.7993 12.796 14.032 13.7526 14.2251C14.7091 14.4183 15.2365 15.4729 16.2911 17.5822L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v14-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","picture","landscape","mountain","media","add-image","upload-image","add-photo","upload-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.3113 3.99994 15.3526 4.09133 16.1981L6.52635 13.2219C7.27563 12.3062 8.6518 12.2375 9.48848 13.0742L12 15.5858L13.653 13.9328C14.3796 13.2062 15.5384 13.1484 16.3337 13.7991L19.8441 16.6712C19.8578 16.5901 19.8701 16.508 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM12.5 7.25C11.2573 7.25 10.25 8.25742 10.25 9.50003C10.25 10.7427 11.2574 11.75 12.5 11.75C13.7426 11.75 14.75 10.7427 14.75 9.50003C14.75 8.25741 13.7427 7.25 12.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.0391 18.5967L15.0672 15.347L13.4142 17L15.7071 19.2929C15.8842 19.4699 15.981 19.6968 15.9975 19.9284C16.1456 19.9152 16.2881 19.8997 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C18.9036 18.7533 18.9737 18.676 19.0391 18.5967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5856 19.9998L8.07427 14.4884L4.84036 18.441C4.93821 18.5757 5.04809 18.7049 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C13.2462 20 13.4179 20 13.5856 19.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v15-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","media","picture","browse","upload","select","icon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 19L10.1102 16.3341C11.9008 14.7993 12.796 14.032 13.7526 14.2251C14.7091 14.4183 15.2365 15.4729 16.2911 17.5822L17 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v15-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","media","photo","landscape","add-image","product-image","edit-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.29611 18.953 5.42653 19.0637 5.56245 19.1621L9.49138 15.6697C10.3389 14.9163 11.0562 14.2787 11.6862 13.8637C12.3518 13.4253 13.0908 13.1181 13.9456 13.2828C14.8004 13.4474 15.3724 14.007 15.8275 14.6612C16.2584 15.2806 16.6876 16.1389 17.1947 17.1533L18.2593 19.2825C18.4603 19.1563 18.6504 19.0065 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM9.5 7.25C8.25734 7.25 7.25 8.25742 7.25 9.50003C7.25 10.7427 8.25738 11.75 9.5 11.75C10.7426 11.75 11.75 10.7427 11.75 9.50003C11.75 8.25741 10.7427 7.25 9.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.3288 19.8936L15.4398 18.1156C14.8894 17.0149 14.5238 16.2892 14.1858 15.8034C13.8624 15.3386 13.6818 15.2687 13.5673 15.2467C13.4529 15.2246 13.2592 15.2224 12.7864 15.5339C12.2921 15.8595 11.6832 16.3974 10.7634 17.215L7.74066 19.9019C8.59694 20.0001 9.65856 20 10.9294 20H13.0706C14.3759 20 15.4607 20.0001 16.3288 19.8936Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v15": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","picture","media","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 19L10.1102 16.3341C11.9008 14.7993 12.796 14.032 13.7526 14.2251C14.7091 14.4183 15.2365 15.4729 16.2911 17.5822L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","media","pictures","browse","select","thumbnail","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15L8.40998 13.8633C9.66385 13.4454 10.2908 13.2364 10.8847 13.4054C11.4786 13.5743 11.9017 14.082 12.7478 15.0973L16 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","picture","photo","media","browse","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15L8.40998 13.8633C9.66385 13.4454 10.2908 13.2364 10.8847 13.4054C11.4786 13.5743 11.9017 14.082 12.7478 15.0973L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","picture","gallery","media","photo","browse","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99999 13.4448 3.99998 13.8009 4.00248 14.139L8.14071 12.8458C8.73112 12.6612 9.24976 12.4991 9.69406 12.4124C10.1748 12.3185 10.6602 12.2921 11.1688 12.4475C11.6775 12.603 12.0652 12.8962 12.4113 13.2427C12.7312 13.563 13.0706 13.9874 13.457 14.4704L17.5723 19.6145C18.0364 19.4463 18.4584 19.1985 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM14.5 7.25C15.7426 7.25 16.75 8.25736 16.75 9.5C16.75 10.7426 15.7426 11.75 14.5 11.75C13.2574 11.75 12.25 10.7426 12.25 9.5C12.25 8.90326 12.4871 8.33097 12.909 7.90901C13.331 7.48705 13.9033 7.25 14.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.2975 19.9725L11.9267 15.7591C11.4996 15.2252 11.2287 14.8889 10.9962 14.6561C10.7812 14.4408 10.6668 14.3854 10.5843 14.3602C10.5018 14.335 10.376 14.317 10.0774 14.3753C9.75443 14.4384 9.3419 14.5658 8.68927 14.7697L4.09222 16.2063C4.10033 16.2808 4.10916 16.3537 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C13.902 20 14.644 20 15.2975 19.9725Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","pictures","product-image","add-image","upload-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15L8.40998 13.8633C9.66385 13.4454 10.2908 13.2364 10.8847 13.4054C11.4786 13.5743 11.9017 14.082 12.7478 15.0973L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","photo","picture","media","add-image","add-photo","browse-images","browse-photos","select-image","select-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 15.1057C8.09505 12.7111 10.3066 14.8587 10.9348 15.4829L11.2735 15.8283L12.546 17.0928C12.9334 17.4778 14.4077 18.9218 16 18.997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","picture","gallery","media","browse-images","select-image","add-image","product-image","menu-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 15.1057C8.09505 12.7111 10.3066 14.8587 10.9348 15.4829L11.2735 15.8283L12.546 17.0928C12.9334 17.4778 14.4077 18.9218 16 18.997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","landscape","add-image","select-image","upload","pictures"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99999 13.6109 3.99997 14.1135 4.00751 14.5785L4.40837 14.2991C6.19238 12.9274 7.84791 12.7915 9.1885 13.207C10.4574 13.6003 11.315 14.4509 11.6396 14.7735L11.6488 14.7826L11.9829 15.1234L13.2509 16.3834C13.434 16.5654 13.8463 16.9691 14.3831 17.3339C14.9292 17.7049 15.505 17.9666 16.0277 17.997C16.3946 17.9988 16.9441 18.0269 17.4286 18.1149C17.6673 18.1582 17.9604 18.2279 18.2185 18.3534C18.3336 18.4094 18.6152 18.5615 18.807 18.8497C18.8142 18.8426 18.8213 18.8356 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM14.5 7.25C13.2573 7.25 12.25 8.25742 12.25 9.50003C12.25 10.7427 13.2574 11.75 14.5 11.75C15.7426 11.75 16.75 10.7427 16.75 9.50003C16.75 8.25741 15.7427 7.25 14.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.5727 19.959C14.663 19.8263 13.8564 19.3939 13.2592 18.9882C12.564 18.5159 12.0455 18.0051 11.8412 17.8021L10.5595 16.5285L10.2254 16.1877C9.92079 15.8853 9.36034 15.3541 8.59642 15.1173C7.90552 14.9032 6.91524 14.8882 5.61193 15.8966L5.59228 15.9118L4.19566 16.8854C4.34627 17.6249 4.62623 18.2831 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.0211 20 14.8547 20 15.5727 19.959Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","photo","gallery","product-image","add-image","select-image","media","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 15.1057C8.09505 12.7111 10.3066 14.8587 10.9348 15.4829L11.2735 15.8283L12.546 17.0928C12.9334 17.4778 14.4077 18.9218 16 18.997"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","photo","media","picture","browse","select-image","select-photo","add-image","add-photo","product-image","item-image","edit-image","edit-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14.5758C18.0471 13.6034 16.719 13 15.25 13C12.3505 13 10 15.3506 10 18.2501C10 18.5047 10.0181 18.7551 10.0532 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","account","profile","person","contact","member","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14.5758C18.0471 13.6034 16.719 13 15.25 13C12.3505 13 10 15.3506 10 18.2501C10 18.5047 10.0181 18.7551 10.0532 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","media","photo","browse","selection","visuals","pictures"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.05337 19.9456 8.60004 19.9751 9.21569 19.9886C9.13879 19.681 9.1029 19.4245 9.07429 19.2201L9.06323 19.1416C9.02151 18.8499 9 18.5522 9 18.2501C9 14.7983 11.7982 12 15.25 12C16.9898 12 18.5651 12.7122 19.6971 13.8585C19.7784 13.9344 19.8813 14.0354 19.9974 14.1565C20 13.8133 20 13.4514 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM9.5 7.25C8.25734 7.25 7.25 8.25742 7.25 9.50003C7.25 10.7427 8.25738 11.75 9.5 11.75C10.7426 11.75 11.75 10.7427 11.75 9.50003C11.75 8.25741 10.7427 7.25 9.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.7429 17.1536C19.6899 17.0921 19.6435 17.0232 19.6056 16.9472C19.2843 16.3047 18.6186 15.585 18.3213 15.3102L18.3031 15.2934L18.2858 15.2757C17.5132 14.4873 16.4394 14 15.25 14C12.9028 14 11 15.9029 11 18.2501C11 18.4572 11.0147 18.6602 11.0431 18.8584C11.0472 18.8871 11.0512 18.9165 11.0554 18.9467C11.0932 19.2217 11.1396 19.5586 11.3191 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.3069 18.3499 19.5811 17.7846 19.7429 17.1536Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","media","pictures","add-image","product-image","product-gallery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 13C8.38054 13 11.5161 14.7639 13.2714 17.653L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","product-image","item-image","stock-image","display-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14.5758C18.0471 13.6034 16.719 13 15.25 13C12.3505 13 10 15.3506 10 18.2501C10 18.5047 10.0181 18.7551 10.0532 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","gallery","photo","media","placeholder","broken-image","no-image","missing-image","image-not-found"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 13C8.38054 13 11.5161 14.7639 13.2714 17.653L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","media","album","picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V12.0459C4.39334 12.0125 4.74753 12 5.00001 12C8.72984 12 12.1894 13.9461 14.1261 17.1337L14.1435 17.1623L14.1589 17.192C14.7685 18.3657 15.069 19.1618 15.2562 19.9742C15.6831 19.9571 16.0726 19.9286 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM14.5 7.25C13.2573 7.25 12.25 8.25742 12.25 9.50003C12.25 10.7427 13.2574 11.75 14.5 11.75C15.7426 11.75 16.75 10.7427 16.75 9.50003C16.75 8.25741 15.7427 7.25 14.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.1952 20C13.0388 19.48 12.8019 18.9211 12.3997 18.1441C10.8225 15.5702 8.0203 14 5.00001 14C4.76718 14 4.40157 14.0142 4.00191 14.0542C4.00758 14.9756 4.03004 15.7652 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C13.1123 20 13.1539 20 13.1952 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","photo","gallery","media","browse","pictures","display-image","product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 13C8.38054 13 11.5161 14.7639 13.2714 17.653L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","landscape","picture","photo","media","add-image","select-image","choose-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99998 13.7465 3.99997 14.3633 4.01473 14.9214C5.02772 14.2979 6.19262 13.8775 7.44832 13.8685C8.77422 13.859 10.0621 14.2446 11.2028 14.9586C13.4521 12.7799 16.6939 12.4783 19.4257 13.7635L19.4701 13.7844L19.5123 13.8095C19.6474 13.8901 19.8156 13.9919 19.9978 14.1041C20 13.7765 20 13.432 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM12.25 8.50003C12.25 7.25742 13.2573 6.25 14.5 6.25C15.7427 6.25 16.75 7.25741 16.75 8.50003C16.75 9.7427 15.7426 10.75 14.5 10.75C13.2574 10.75 12.25 9.7427 12.25 8.50003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.8839 16.405C19.7968 16.3463 19.7013 16.2832 19.6002 16.2177C19.2306 15.9781 18.8155 15.7234 18.531 15.553C16.5288 14.6292 14.3055 14.8548 12.7281 16.2719C12.8467 16.4111 12.9608 16.5525 13.0676 16.6891C13.7292 17.535 14.5732 18.6617 14.8809 19.9863C15.4573 19.9719 15.9718 19.9422 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C19.8821 16.4184 19.883 16.4117 19.8839 16.405Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.7986 20C12.5444 19.3388 12.0699 18.6599 11.4922 17.9212C11.1809 17.5232 10.9056 17.2178 10.716 17.0644C9.73077 16.2668 8.59649 15.8603 7.46265 15.8685C6.35175 15.8764 5.2394 16.3919 4.2681 17.1957C4.43121 17.8097 4.70374 18.3606 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H12.7986Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v6-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","media","pictures","browse-images","select-image","upload-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15.4369C7.16011 14.4207 9.51349 14.8044 11.3452 16.2871M13.4714 19C12.9192 17.8829 12.1874 16.9688 11.3452 16.2871M19 14.6684C16.3569 13.4249 13.2573 13.8898 11.3452 16.2871"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","photo","picture","display","landscape","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15.4369C7.16011 14.4207 9.51349 14.8044 11.3452 16.2871M13.4714 19C12.9192 17.8829 12.1874 16.9688 11.3452 16.2871M19 14.6684C16.3569 13.4249 13.2573 13.8898 11.3452 16.2871"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","photo","gallery","media","add-image","add-photo","upload","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15.4369C7.16011 14.4207 9.51349 14.8044 11.3452 16.2871M13.4714 19C12.9192 17.8829 12.1874 16.9688 11.3452 16.2871M19 14.6684C16.3569 13.4249 13.2573 13.8898 11.3452 16.2871"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v7-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["image","photo","gallery","media","pictures","add-image","add-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12L16.4144 14.0685C15.2541 14.9967 14.674 15.4608 13.9912 15.4722C13.3084 15.4836 12.7091 15.0361 11.5104 14.1411V14.1411C10.3024 13.2391 9.69834 12.7881 9.0111 12.8023C8.32387 12.8166 7.74297 13.289 6.58119 14.234L5 15.52"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v7": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","photo","add-image","select-image","product-image","edit-image","upload-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12L16.4144 14.0685C15.2541 14.9967 14.674 15.4608 13.9912 15.4722C13.3084 15.4836 12.7091 15.0361 11.5104 14.1411V14.1411C10.3024 13.2391 9.69834 12.7881 9.0111 12.8023C8.32387 12.8166 7.74297 13.289 6.58119 14.234L5 15.52"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v7-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","photo","gallery","landscape","view","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12L16.4144 14.0685C15.2541 14.9967 14.674 15.4608 13.9912 15.4722C13.3084 15.4836 12.7091 15.0361 11.5104 14.1411V14.1411C10.3024 13.2391 9.69834 12.7881 9.0111 12.8023C8.32387 12.8166 7.74297 13.289 6.58119 14.234L5 15.52"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","media","landscape","photo","browse","view","artwork"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.2995 3.99994 15.3329 4.08876 16.174L5.98137 14.5452C6.51674 14.0844 6.98376 13.6825 7.40525 13.399C7.85965 13.0934 8.35177 12.8607 8.94619 12.8324C8.97198 12.8312 8.99779 12.8303 9.0236 12.8297C9.61855 12.8168 10.1256 13.0149 10.6001 13.2883C11.0402 13.542 11.5339 13.9106 12.0999 14.3333L12.1444 14.3666C12.7471 14.8166 13.1311 15.1013 13.4444 15.2829C13.7353 15.4514 13.8706 15.4729 13.9619 15.4725C13.9703 15.4725 13.9787 15.4724 13.9871 15.4721C14.0783 15.4695 14.2128 15.4435 14.498 15.2653C14.8051 15.0734 15.1793 14.776 15.7667 14.3061L18.3875 12.2094L20 11V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM12.25 9.50003C12.25 8.25742 13.2573 7.25 14.5 7.25C15.7427 7.25 16.75 8.25741 16.75 9.50003C16.75 10.7427 15.7426 11.75 14.5 11.75C13.2574 11.75 12.25 10.7427 12.25 9.50003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.9999 13.5002L19.6125 13.7907L16.9738 15.9017C16.4411 16.3278 15.9758 16.7002 15.5579 16.9613C15.1071 17.2431 14.6229 17.4544 14.0456 17.4713C14.0204 17.472 13.9953 17.4724 13.9702 17.4725C13.3926 17.4749 12.9016 17.2799 12.4416 17.0133C12.0153 16.7663 11.5377 16.4096 10.9912 16.0015L10.9478 15.9691C10.3242 15.5035 9.92601 15.2082 9.60139 15.0211C9.29961 14.8472 9.16041 14.8272 9.06703 14.8292C9.05843 14.8294 9.04983 14.8297 9.04123 14.8301C8.94793 14.8346 8.81045 14.8642 8.52143 15.0585C8.21053 15.2676 7.83371 15.5898 7.24382 16.0974L4.72256 18.2672C4.84772 18.4653 4.99587 18.6527 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C19.9873 15.6366 19.9987 14.6627 19.9999 13.5002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v8-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["image","picture","photo","gallery","media","landscape","browse","select-image","add-image","set-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14.3333L7.17483 13.5048C8.01377 13.1852 8.95176 13.2581 9.73123 13.7036L10.9478 14.3987C11.6228 14.7844 12.4211 14.893 13.1746 14.7017L13.4023 14.6439C14.1843 14.4453 15.0133 14.57 15.7022 14.9899L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v8-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","media","landscape","add-image","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14.3333L7.17483 13.5048C8.01377 13.1852 8.95176 13.2581 9.73123 13.7036L10.9478 14.3987C11.6228 14.7844 12.4211 14.893 13.1746 14.7017L13.4023 14.6439C14.1843 14.4453 15.0133 14.57 15.7022 14.9899L19 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","photo","media","landscape","browse","view-images","select-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99999 13.3744 3.99999 13.6664 4.00132 13.9464L6.68897 12.7247C7.85886 12.193 9.21299 12.2557 10.3287 12.8932L11.4439 13.5305C11.8939 13.7876 12.4262 13.86 12.9285 13.7325L13.1381 13.6792C14.1949 13.4108 15.3155 13.5855 16.2405 14.1628L19.88 16.4343C19.8804 16.4312 19.8808 16.4281 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM12.25 9.50003C12.25 8.25742 13.2573 7.25 14.5 7.25C15.7427 7.25 16.75 8.25741 16.75 9.50003C16.75 10.7427 15.7426 11.75 14.5 11.75C13.2574 11.75 12.25 10.7427 12.25 9.50003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.2081 18.3725L15.1816 15.8595C14.7191 15.5708 14.1588 15.4835 13.6304 15.6177L13.4208 15.6709C12.4161 15.9261 11.3516 15.7813 10.4516 15.267L9.33646 14.6297C8.77859 14.3109 8.10152 14.2796 7.51658 14.5455L4.08188 16.1067C4.09268 16.216 4.10491 16.3221 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C18.9727 18.6841 19.0984 18.532 19.2081 18.3725Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v9-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gallery","image","photo","media","pictures","landscape","view","browse-image","select-image","item-image","product-image","add-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L6.99485 14.7202C7.79167 13.8095 9.20833 13.8095 10.0052 14.7202L10.4948 15.2798C11.2917 16.1905 12.7083 16.1905 13.5052 15.2798L13.9948 14.7202C14.7917 13.8095 16.2083 13.8095 17.0052 14.7202L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Gallery v8": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","picture","landscape","media","browse","add-image","product-image","add-product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 14.3333L7.17483 13.5048C8.01377 13.1852 8.95176 13.2581 9.73123 13.7036L10.9478 14.3987C11.6228 14.7844 12.4211 14.893 13.1746 14.7017L13.4023 14.6439C14.1843 14.4453 15.0133 14.57 15.7022 14.9899L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 9.46957 12.2107 8.96086 12.5858 8.58579C12.9609 8.21071 13.4696 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery v9-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","photo","landscape","media","browse-media","add-image","add-photo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L6.99485 14.7202C7.79167 13.8095 9.20833 13.8095 10.0052 14.7202L10.4948 15.2798C11.2917 16.1905 12.7083 16.1905 13.5052 15.2798L13.9948 14.7202C14.7917 13.8095 16.2083 13.8095 17.0052 14.7202L19 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery v9-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","media","photo","browse","view","landscape","product-image","menu-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4017 3.99994 15.5033 4.1128 16.3798L6.24906 14.0062C7.45201 12.6696 9.55252 12.6842 10.7367 14.0375L11.2474 14.6213C11.6458 15.0766 12.3542 15.0766 12.7526 14.6213L13.2633 14.0375C14.4475 12.6842 16.548 12.6696 17.751 14.0062L19.8872 16.3798C20.0001 15.5033 20 14.4017 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM14.5 7.25C13.2573 7.25 12.25 8.25742 12.25 9.50003C12.25 10.7427 13.2574 11.75 14.5 11.75C15.7426 11.75 16.75 10.7427 16.75 9.50003C16.75 8.25741 15.7427 7.25 14.5 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.1107 18.5066L16.2644 15.3441C15.8634 14.8986 15.1632 14.9035 14.7685 15.3546L14.2577 15.9383C13.0625 17.3043 10.9375 17.3043 9.74228 15.9383L9.23152 15.3546C8.8368 14.9035 8.13663 14.8986 7.73564 15.3441L4.88935 18.5066C4.97452 18.6178 5.06829 18.7251 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C18.9317 18.7251 19.0255 18.6178 19.1107 18.5066Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery v9": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","photo","pictures","add-image","select-image","media","browse","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8C12.8954 8 12 8.89547 12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89547 15.1046 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17L6.99485 14.7202C7.79167 13.8095 9.20833 13.8095 10.0052 14.7202L10.4948 15.2798C11.2917 16.1905 12.7083 16.1905 13.5052 15.2798L13.9948 14.7202C14.7917 13.8095 16.2083 13.8095 17.0052 14.7202L19 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Gallery-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","photo","gallery","media","pictures","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 19L7.60801 16.4272C9.13034 13.9915 9.8915 12.7736 11 12.7736C12.1085 12.7736 12.8697 13.9915 14.392 16.4272L16 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16V16C14.8829 14.9405 15.3244 14.4107 15.8583 14.2299C16.2745 14.0888 16.7255 14.0888 17.1417 14.2299C17.6756 14.4107 18.1171 14.9405 19 16V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gallery","image","picture","photo","media","landscape","mountain","sun","album","add-image","select-image","browse-images"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3857 18.0829L18.2254 16.6325C17.7755 16.0926 17.4795 15.7392 17.2328 15.4925C16.9919 15.2516 16.8773 15.1961 16.8209 15.1769C16.6128 15.1064 16.3872 15.1064 16.1791 15.1769C16.1048 15.2021 16.0042 15.2506 15.7974 15.4545C15.6607 15.5893 15.5056 15.763 15.304 15.9996L16.8402 18.4575L17.6038 19.6029C18.0555 19.435 18.4668 19.1901 18.8284 18.8284C19.0578 18.5991 19.2402 18.3498 19.3857 18.0829Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.4421 19.9659L15.1598 19.5424L13.544 16.9572C13.4358 16.784 13.3325 16.6188 13.2336 16.4612C13.2267 16.4508 13.2201 16.4403 13.2137 16.4297C12.6107 15.4696 12.1712 14.7948 11.7798 14.3357C11.3304 13.8086 11.1164 13.7736 11 13.7736C10.8836 13.7736 10.6696 13.8086 10.2202 14.3357C9.76065 14.8747 9.23487 15.711 8.45601 16.9572L8.4502 16.9664L6.69819 19.7024C6.97747 19.7835 7.27036 19.8403 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C13.964 20 14.7541 20 15.4421 19.9659Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.0315 20 14.8728 19.9576 15.5962L19.7746 15.3675L19.7397 15.3256C19.3226 14.825 18.9669 14.3982 18.6471 14.0783C18.3131 13.7443 17.94 13.4444 17.4626 13.2827C16.8383 13.0712 16.1617 13.0712 15.5374 13.2827C15.0778 13.4384 14.7261 13.7021 14.3934 14.0302C14.3265 14.0961 14.2579 14.1672 14.1872 14.2432C13.8762 13.7759 13.5846 13.3699 13.3018 13.0382C12.7129 12.3475 11.9921 11.7736 11 11.7736C10.0079 11.7736 9.28708 12.3475 8.69821 13.0382C8.13075 13.7038 7.52753 14.669 6.80345 15.8276L6.76291 15.8925L5.00089 18.6442C4.46691 18.0214 4.23208 17.268 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57529 3.99994 8.45869 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45869 3.99994 9.57533 3.99997 10.9294 4ZM17.75 8.5C17.75 7.25736 16.7426 6.25 15.5 6.25C14.9033 6.25 14.331 6.48705 13.909 6.90901C13.4871 7.33097 13.25 7.90326 13.25 8.5C13.25 9.74264 14.2574 10.75 15.5 10.75C16.7426 10.75 17.75 9.74264 17.75 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gallery-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["image","photo","gallery","pictures","display","media","product-image","item-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 19L7.60801 16.4272C9.13034 13.9915 9.8915 12.7736 11 12.7736C12.1085 12.7736 12.8697 13.9915 14.392 16.4272L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16V16C14.8829 14.9405 15.3244 14.4107 15.8583 14.2299C16.2745 14.0888 16.7255 14.0888 17.1417 14.2299C17.6756 14.4107 18.1171 14.9405 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gallery-polaroid-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["image","gallery","picture","product-image","add-image","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 14.4L17.8328 13.8397C15.9811 12.9509 15.0553 12.5066 14.1138 12.6671C13.1723 12.8277 12.4461 13.5539 10.9938 15.0062L10 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 16H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Gallery-polaroid-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gallery","image","picture","media","landscape","mountain","display","photos","album","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16L18.1935 15.3548C16.1988 13.759 15.2015 12.9612 14.0567 13.0246C12.912 13.088 12.0089 13.9911 10.2027 15.7973L10 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 16H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gallery-polaroid-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","media","picture","landscape","display-image","view-image","select-image","product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93417 4H15.0658C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20.0001 8.04769 20 8.93417L20 15.1321L18.5908 14.1919C16.6422 12.6349 15.5633 11.9402 14.0014 12.0267C13.1494 12.0739 12.446 12.4415 11.7663 12.9667C11.1317 13.4571 10.4297 14.1567 9.58578 15.0006H4L4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215ZM7.25 9.50005C7.25 8.25741 8.25736 7.25 9.5 7.25C10.7426 7.25 11.75 8.25741 11.75 9.50005C11.75 10.7427 10.7426 11.75 9.5 11.75C8.25736 11.75 7.25 10.7427 7.25 9.50005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.04675 17.0006C4.05641 17.114 4.06807 17.2231 4.08215 17.3278C4.17028 17.9833 4.36902 18.6117 4.87868 19.1213C5.38835 19.631 6.0167 19.8297 6.67221 19.9179C7.28387 20.0001 8.04769 20.0001 8.93417 20H15.0658C15.9523 20.0001 16.7161 20.0001 17.3278 19.9179C17.9833 19.8297 18.6117 19.631 19.1213 19.1213C19.631 18.6117 19.8297 17.9833 19.9179 17.3278C19.9366 17.1888 19.951 17.0418 19.9622 16.8874C19.8227 16.9601 19.665 17.0006 19.5 17.0006H4.04675Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.4555 15.0006H16.366C15.1473 14.1038 14.6927 13.9915 14.112 14.0236C13.8194 14.0399 13.4988 14.1555 12.9892 14.5493C12.8225 14.6781 12.6467 14.8276 12.4555 15.0006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Gallery: {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","media","picture","landscape","display-image","view-image","select-image","product-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 19L7.60801 16.4272C9.13034 13.9915 9.8915 12.7736 11 12.7736C12.1085 12.7736 12.8697 13.9915 14.392 16.4272L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16V16C14.8829 14.9405 15.3244 14.4107 15.8583 14.2299C16.2745 14.0888 16.7255 14.0888 17.1417 14.2299C17.6756 14.4107 18.1171 14.9405 19 16V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Game-control-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["game","controller","game-control","entertainment","fun","reward","loyalty-program","gaming","customer","experience"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9724 9C11.9724 7.66979 12.2593 5.82416 10.9831 5.50057C10.5804 5.40893 10.1676 5.36694 9.75435 5.37559C7.71833 5.37559 8.01512 3.96884 8.01512 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 16.1666V15C3 12.1716 3 10.7574 3.87868 9.87868C4.75736 9 6.17157 9 9 9H15C17.8284 9 19.2426 9 20.1213 9.87868C21 10.7574 21 12.1716 21 15V15.9065C21 17.8644 21 18.8433 20.5606 19.5631C20.3121 19.9702 19.9702 20.3121 19.5631 20.5606C18.8433 21 17.8644 21 15.9065 21H15.6032C15.3331 21 15.198 21 15.0686 20.9831C14.7197 20.9373 14.389 20.8004 14.1099 20.5859C14.0065 20.5065 13.9109 20.4109 13.7199 20.2199C13.318 19.818 13.117 19.617 12.9054 19.4902C12.3279 19.1441 11.6151 19.1118 11.0087 19.4041C10.7864 19.5113 10.5681 19.6932 10.1315 20.0571L9.85171 20.2902L9.85169 20.2903C9.55999 20.5333 9.41413 20.6549 9.25269 20.7452C9.06276 20.8515 8.85675 20.9261 8.64279 20.9661C8.46091 21 8.26745 21 7.88052 21C6.13743 21 5.26588 21 4.61472 20.661C4.06865 20.3767 3.62326 19.9313 3.33899 19.3853C3 18.7341 3 17.8783 3 16.1666Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 17V15.0006M8 15.0006V13M8 15.0006H10M8 15.0006H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15C14 16.1046 14.8954 17 16 17C16.5523 17 17.0523 16.7761 17.4142 16.4142C17.7761 16.0523 18 15.5523 18 15C18 13.8954 17.1046 13 16 13C14.8954 13 14 13.8954 14 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gallery-polaroid": {
        defaultColors: ["#3D4C66"],
        keywords: ["image","gallery","photo","product-image","add-image","edit-image","media","picture","thumbnail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 8C8.89543 8 8 8.89547 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89547 11.1046 8 10 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14.4L17.8328 13.8397C15.9811 12.9509 15.0553 12.5066 14.1138 12.6671C13.1723 12.8277 12.4461 13.5539 10.9938 15.0062L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 16H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Game-control-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["game","controller","gamepad","entertainment","settings","configuration","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9724 9C11.9724 7.66979 12.2593 5.82416 10.9831 5.50057C10.5804 5.40893 10.1676 5.36694 9.75435 5.37559C7.71833 5.37559 8.01512 3.96884 8.01512 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 16.1666V15C3 12.1716 3 10.7574 3.87868 9.87868C4.75736 9 6.17157 9 9 9H15C17.8284 9 19.2426 9 20.1213 9.87868C21 10.7574 21 12.1716 21 15V15.9065C21 17.8644 21 18.8433 20.5606 19.5631C20.3121 19.9702 19.9702 20.3121 19.5631 20.5606C18.8433 21 17.8644 21 15.9065 21H15.6032C15.3331 21 15.198 21 15.0686 20.9831C14.7197 20.9373 14.389 20.8004 14.1099 20.5859C14.0065 20.5065 13.9109 20.4109 13.7199 20.2199C13.318 19.818 13.117 19.617 12.9054 19.4902C12.3279 19.1441 11.6151 19.1118 11.0087 19.4041C10.7864 19.5113 10.5681 19.6932 10.1315 20.0571L9.85171 20.2902L9.85169 20.2903C9.55999 20.5333 9.41413 20.6549 9.25269 20.7452C9.06276 20.8515 8.85675 20.9261 8.64279 20.9661C8.46091 21 8.26745 21 7.88052 21C6.13743 21 5.26588 21 4.61472 20.661C4.06865 20.3767 3.62326 19.9313 3.33899 19.3853C3 18.7341 3 17.8783 3 16.1666Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 15L16 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 17V15.0006M8 15.0006V13M8 15.0006H10M8 15.0006H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Game-control-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["game","game-control","gaming","controller","entertainment","rewards","loyalty","points","customer-engagement","entertainment-system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.01512 2C8.5674 2 9.01512 2.44772 9.01512 3C9.01512 3.12393 9.01095 3.25324 9.00731 3.36609C9.00681 3.38165 9.00631 3.3969 9.00585 3.41177C9.00172 3.5424 8.99883 3.65637 9.00045 3.76504C9.00381 3.99143 9.0273 4.12061 9.05558 4.19478C9.07308 4.24065 9.08447 4.25231 9.11804 4.2714C9.17535 4.304 9.34751 4.37449 9.74502 4.37557C10.236 4.36624 10.7264 4.41658 11.205 4.5255L11.217 4.52822L11.2289 4.53124C11.8061 4.67759 12.2362 5.0152 12.5193 5.45923C12.7827 5.8725 12.8946 6.33801 12.9478 6.74251C13.0018 7.15313 13.0043 7.57938 12.9971 7.95658C12.9938 8.1288 12.989 8.28114 12.9845 8.42388C12.9782 8.62544 12.9724 8.80784 12.9724 9C12.9724 9.55228 12.5247 10 11.9724 10C11.4201 10 10.9724 9.55228 10.9724 9C10.9724 8.78811 10.9799 8.53947 10.987 8.30578C10.9912 8.16795 10.9952 8.03531 10.9975 7.91849C11.0042 7.5654 10.9987 7.26061 10.9648 7.00309C10.9302 6.73946 10.8745 6.59975 10.8328 6.53438C10.812 6.50161 10.7996 6.48692 10.7466 6.47234C10.4283 6.40113 10.102 6.36853 9.77525 6.37537L9.7648 6.37559H9.75434C9.14048 6.37559 8.58847 6.27107 8.12925 6.00988C7.64583 5.73493 7.34967 5.33436 7.18686 4.90743C7.03484 4.50881 7.00528 4.10465 7.00067 3.79479C6.9983 3.63533 7.00268 3.48045 7.00684 3.3487C7.00735 3.33243 7.00786 3.31659 7.00835 3.30114C7.0121 3.18404 7.01512 3.0894 7.01512 3C7.01512 2.44772 7.46283 2 8.01512 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.92943 8H15.0706H15.0706C16.4247 7.99997 17.5413 7.99994 18.4251 8.11876C19.3529 8.2435 20.1723 8.51547 20.8284 9.17158C21.4845 9.82769 21.7565 10.6471 21.8813 11.5749C22.0001 12.4587 22 13.5753 22 14.9294V14.9295V15.9549C22 16.8927 22 17.6666 21.9406 18.2935C21.8788 18.9459 21.7456 19.5411 21.4141 20.0842C21.0828 20.6269 20.6269 21.0828 20.0842 21.4141C19.5411 21.7456 18.9459 21.8788 18.2935 21.9406C17.6666 22 16.8927 22 15.9548 22L15.5572 22C15.3323 22.0001 15.1345 22.0002 14.9387 21.9746C14.4153 21.906 13.9192 21.7005 13.5006 21.3789C13.344 21.2586 13.2043 21.1187 13.0454 20.9596L13.0128 20.927C12.5695 20.4837 12.4708 20.3956 12.3913 20.3479C12.1026 20.1749 11.7462 20.1587 11.443 20.3049C11.3595 20.3452 11.2532 20.424 10.7716 20.8253L10.4424 21.0998C10.1995 21.3024 9.98546 21.4811 9.74109 21.6179C9.45619 21.7773 9.14718 21.8892 8.82624 21.9491C8.55088 22.0005 8.26829 22.0003 7.9468 22L7.83868 22H7.83866C7.00268 22 6.3147 22 5.75649 21.9543C5.17846 21.9069 4.64719 21.8053 4.15296 21.548C3.42487 21.169 2.83102 20.5751 2.45199 19.847C2.19568 19.3547 2.09344 18.8289 2.04582 18.2566C1.99998 17.7056 1.99999 17.0288 2 16.2087L2 14.9294V14.9294C1.99997 13.5753 1.99994 12.4587 2.11876 11.5749C2.2435 10.6471 2.51547 9.82769 3.17158 9.17158C3.82769 8.51547 4.64711 8.2435 5.57494 8.11876C6.45868 7.99994 7.57531 7.99997 8.9294 8H8.92943ZM9 13C9 12.4477 8.55229 12 8 12C7.44772 12 7 12.4477 7 13V14.0006H6C5.44772 14.0006 5 14.4484 5 15.0006C5 15.5529 5.44772 16.0006 6 16.0006H7V17C7 17.5523 7.44772 18 8 18C8.55229 18 9 17.5523 9 17V16.0006H10C10.5523 16.0006 11 15.5529 11 15.0006C11 14.4484 10.5523 14.0006 10 14.0006H9V13ZM15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929C17.0976 12.6834 17.0976 13.3166 16.7071 13.7071L14.7071 15.7071C14.3166 16.0976 13.6834 16.0976 13.2929 15.7071C12.9024 15.3166 12.9024 14.6834 13.2929 14.2929L15.2929 12.2929ZM18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071L16.7071 17.7071C16.3166 18.0976 15.6834 18.0976 15.2929 17.7071C14.9024 17.3166 14.9024 16.6834 15.2929 16.2929L17.2929 14.2929C17.6834 13.9024 18.3166 13.9024 18.7071 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Game-control": {
        defaultColors: ["#3D4C66"],
        keywords: ["game","control","joystick","gamepad","entertainment","arcade","fun","reward","loyalty","bonus","customer-engagement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9724 9C11.9724 7.66979 12.2593 5.82416 10.9831 5.50057C10.5804 5.40893 10.1676 5.36694 9.75435 5.37559C7.71833 5.37559 8.01512 3.96884 8.01512 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 16.1666V15C3 12.1716 3 10.7574 3.87868 9.87868C4.75736 9 6.17157 9 9 9H15C17.8284 9 19.2426 9 20.1213 9.87868C21 10.7574 21 12.1716 21 15V15.9065C21 17.8644 21 18.8433 20.5606 19.5631C20.3121 19.9702 19.9702 20.3121 19.5631 20.5606C18.8433 21 17.8644 21 15.9065 21H15.6032C15.3331 21 15.198 21 15.0686 20.9831C14.7197 20.9373 14.389 20.8004 14.1099 20.5859C14.0065 20.5065 13.9109 20.4109 13.7199 20.2199C13.318 19.818 13.117 19.617 12.9054 19.4902C12.3279 19.1441 11.6151 19.1118 11.0087 19.4041C10.7864 19.5113 10.5681 19.6932 10.1315 20.0571L9.85171 20.2902L9.85169 20.2903C9.55999 20.5333 9.41413 20.6549 9.25269 20.7452C9.06276 20.8515 8.85675 20.9261 8.64279 20.9661C8.46091 21 8.26745 21 7.88052 21C6.13743 21 5.26588 21 4.61472 20.661C4.06865 20.3767 3.62326 19.9313 3.33899 19.3853C3 18.7341 3 17.8783 3 16.1666Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 17V15.0006M8 15.0006V13M8 15.0006H10M8 15.0006H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15C14 16.1046 14.8954 17 16 17C16.5523 17 17.0523 16.7761 17.4142 16.4142C17.7761 16.0523 18 15.5523 18 15C18 13.8954 17.1046 13 16 13C14.8954 13 14 13.8954 14 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gamepad-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["game","gaming","entertainment","arcade","joystick","controller","reward","loyalty program","game selection","entertainment options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 9H9C6.17157 9 4.75736 9 3.87868 9.87868C3 10.7574 3 12.1716 3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15C21 12.1716 21 10.7574 20.1213 9.87868C19.2426 9 17.8284 9 15 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 4V5C10 5.55228 10.4477 6 11 6V6C11.5523 6 12 6.44772 12 7V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 16L8 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L6 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L13 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 14L17 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L15 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gamepad-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["game","gamepad","entertainment","leisure","arcade","gaming","console"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4V5C10 5.55228 10.4477 6 11 6V6C11.5523 6 12 6.44772 12 7V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 8H9C6.17157 8 4.75736 8 3.87868 8.87868C3 9.75736 3 11.1716 3 14C3 16.8284 3 18.2426 3.87868 19.1213C4.75736 20 6.17157 20 9 20H15C17.8284 20 19.2426 20 20.1213 19.1213C21 18.2426 21 16.8284 21 14C21 11.1716 21 9.75736 20.1213 8.87868C19.2426 8 17.8284 8 15 8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 16L8 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L6 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L13 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 14L17 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L15 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gamepad-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["game","gamepad","gaming","entertainment","arcade","promotion","reward","loyalty","fun"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.75 4C10.75 3.58579 10.4142 3.25 10 3.25C9.58579 3.25 9.25 3.58579 9.25 4V5C9.25 5.9665 10.0335 6.75 11 6.75C11.1381 6.75 11.25 6.86193 11.25 7V7.25L8.94512 7.25C7.57754 7.24998 6.47522 7.24996 5.60825 7.36652C4.70814 7.48754 3.95027 7.74643 3.34835 8.34835C2.74643 8.95027 2.48754 9.70814 2.36652 10.6082C2.24996 11.4752 2.24998 12.5775 2.25 13.9451V14.0549C2.24998 15.4225 2.24996 16.5248 2.36652 17.3918C2.48754 18.2919 2.74643 19.0497 3.34835 19.6517C3.95027 20.2536 4.70814 20.5125 5.60825 20.6335C6.47522 20.75 7.57754 20.75 8.94513 20.75H15.0549C16.4225 20.75 17.5248 20.75 18.3918 20.6335C19.2919 20.5125 20.0497 20.2536 20.6517 19.6516C21.2536 19.0497 21.5125 18.2919 21.6335 17.3918C21.75 16.5248 21.75 15.4225 21.75 14.0549V13.9451C21.75 12.5775 21.75 11.4752 21.6335 10.6082C21.5125 9.70814 21.2536 8.95027 20.6517 8.34835C20.0497 7.74643 19.2919 7.48754 18.3918 7.36652C17.5248 7.24996 16.4225 7.24998 15.0549 7.25L12.75 7.25V7C12.75 6.0335 11.9665 5.25 11 5.25C10.8619 5.25 10.75 5.13807 10.75 5V4ZM8.75 12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12V13.25H6C5.58579 13.25 5.25 13.5858 5.25 14C5.25 14.4142 5.58579 14.75 6 14.75H7.25V16C7.25 16.4142 7.58579 16.75 8 16.75C8.41421 16.75 8.75 16.4142 8.75 16V14.75H10C10.4142 14.75 10.75 14.4142 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25H8.75V12ZM16 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25ZM13 13.25C12.5858 13.25 12.25 13.5858 12.25 14C12.25 14.4142 12.5858 14.75 13 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14C14.75 13.5858 14.4142 13.25 14 13.25H13ZM17 13.25C16.5858 13.25 16.25 13.5858 16.25 14C16.25 14.4142 16.5858 14.75 17 14.75H18C18.4142 14.75 18.75 14.4142 18.75 14C18.75 13.5858 18.4142 13.25 18 13.25H17ZM15 15.25C14.5858 15.25 14.25 15.5858 14.25 16C14.25 16.4142 14.5858 16.75 15 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16C16.75 15.5858 16.4142 15.25 16 15.25H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ghost-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ghost","halloween","hidden","invisible","error","alert","warning","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19V11C5 7.13401 8.13401 4 12 4V4C15.866 4 19 7.13401 19 11V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 19L5.9957 18.5448C6.71826 18.2145 7.56829 18.3481 8.15464 18.8842V18.8842C8.86119 19.5302 9.92877 19.5781 10.6903 18.9979L10.7879 18.9235C11.5039 18.378 12.4961 18.378 13.2121 18.9235L13.3097 18.9979C14.0712 19.5781 15.1388 19.5302 15.8454 18.8842V18.8842C16.4317 18.3481 17.2817 18.2145 18.0043 18.5448L19 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Gamepad: {
        defaultColors: ["#3D4C66"],
        keywords: ["ghost","halloween","hidden","invisible","error","alert","warning","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8H9C6.17157 8 4.75736 8 3.87868 8.87868C3 9.75736 3 11.1716 3 14C3 16.8284 3 18.2426 3.87868 19.1213C4.75736 20 6.17157 20 9 20H15C17.8284 20 19.2426 20 20.1213 19.1213C21 18.2426 21 16.8284 21 14C21 11.1716 21 9.75736 20.1213 8.87868C19.2426 8 17.8284 8 15 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 4V5C10 5.55228 10.4477 6 11 6V6C11.5523 6 12 6.44772 12 7V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 16L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 14L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ghost-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ghost","unavailable","error","issue","offline","temporary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 11C4.25 6.71979 7.71979 3.25 12 3.25C16.2802 3.25 19.75 6.71979 19.75 11V19C19.75 19.2553 19.6201 19.493 19.4054 19.631C19.1906 19.769 18.9204 19.7882 18.6882 19.6821L17.6925 19.2269C17.2437 19.0218 16.7157 19.1048 16.3514 19.4378C15.3772 20.3285 13.9052 20.3945 12.8552 19.5945L12.7576 19.5201C12.3101 19.1791 11.6899 19.1791 11.2424 19.5201L11.1448 19.5945C10.0948 20.3945 8.62279 20.3285 7.64856 19.4378C7.28434 19.1048 6.75634 19.0218 6.30752 19.2269L5.31182 19.6821C5.07964 19.7882 4.80942 19.769 4.59464 19.631C4.37985 19.493 4.25 19.2553 4.25 19V11ZM10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10V12C8 12.5523 8.44772 13 9 13C9.55228 13 10 12.5523 10 12V10ZM16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ghost-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ghost","error","failure","problem","alert","halloween","spooky","unavailable","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V19L18.0043 18.5448C17.2817 18.2145 16.4317 18.3481 15.8454 18.8842C15.1388 19.5302 14.0712 19.5781 13.3097 18.9979L13.2121 18.9235C12.4961 18.378 11.5039 18.378 10.7879 18.9235L10.6903 18.9979C9.92877 19.5781 8.86119 19.5302 8.15464 18.8842C7.56829 18.3481 6.71826 18.2145 5.9957 18.5448L5 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L9 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Ghost: {
        defaultColors: ["#3D4C66"],
        keywords: ["ghost","error","failure","problem","alert","halloween","spooky","unavailable","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19V11C5 7.13401 8.13401 4 12 4V4C15.866 4 19 7.13401 19 11V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 19L5.9957 18.5448C6.71826 18.2145 7.56829 18.3481 8.15464 18.8842V18.8842C8.86119 19.5302 9.92877 19.5781 10.6903 18.9979L10.7879 18.9235C11.5039 18.378 12.4961 18.378 13.2121 18.9235L13.3097 18.9979C14.0712 19.5781 15.1388 19.5302 15.8454 18.8842V18.8842C16.4317 18.3481 17.2817 18.2145 18.0043 18.5448L19 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "gif-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gif","animation","image","media","file","type","format"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.9998V11C16 10.4477 16.4477 10 17 10M16 11.9998V13.9998M16 11.9998H17M16 11.9998H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14C10.1046 14 11 13.1046 11 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "gif-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gif","animation","image","media","graphics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.9998V11C16 10.4477 16.4477 10 17 10M16 11.9998V13.9998M16 11.9998H17M16 11.9998H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14C10.1046 14 11 13.1046 11 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    gif: {
        defaultColors: ["#3D4C66"],
        keywords: ["gif","animation","image","media","graphics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.9998V11C16 10.4477 16.4477 10 17 10M16 11.9998V13.9998M16 11.9998H17M16 11.9998H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10V12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14C10.1046 14 11 13.1046 11 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gift-box-1": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift","box","reward","promotion","discount","surprise","coupon","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9H18V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "gif-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gif","animation","image","media","marketing","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4H8.92943C7.57533 3.99997 6.45869 3.99994 5.57494 4.11876C4.64711 4.2435 3.82769 4.51547 3.17158 5.17158C2.51547 5.82769 2.2435 6.64711 2.11876 7.57494C1.99994 8.45869 1.99997 9.57529 2 10.9294V13.0706C1.99997 14.4247 1.99994 15.5413 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706V10.9295C22 9.57534 22.0001 8.4587 21.8813 7.57494C21.7565 6.64711 21.4845 5.82768 20.8284 5.17158C20.1723 4.51547 19.3529 4.2435 18.4251 4.11876C17.5413 3.99994 16.4247 3.99997 15.0706 4ZM7.75 12C7.75 11.3096 8.30965 10.75 9 10.75C9.41421 10.75 9.75 10.4142 9.75 10C9.75 9.58579 9.41421 9.25 9 9.25C7.48122 9.25 6.25 10.4812 6.25 12C6.25 13.5188 7.48122 14.75 9 14.75C10.5188 14.75 11.75 13.5188 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H10.0001C9.77204 13.0536 9.40896 13.25 9 13.25C8.30965 13.25 7.75 12.6904 7.75 12ZM13.75 10C13.75 9.58579 13.4142 9.25 13 9.25C12.5858 9.25 12.25 9.58579 12.25 10V14C12.25 14.4142 12.5858 14.75 13 14.75C13.4142 14.75 13.75 14.4142 13.75 14V10ZM16.75 11C16.75 10.8619 16.8619 10.75 17 10.75C17.4142 10.75 17.75 10.4142 17.75 10C17.75 9.58579 17.4142 9.25 17 9.25C16.0335 9.25 15.25 10.0335 15.25 11V11.2498H15C14.5858 11.2498 14.25 11.5856 14.25 11.9998C14.25 12.4141 14.5858 12.7498 15 12.7498H15.25V13.9998C15.25 14.4141 15.5858 14.7498 16 14.7498C16.4142 14.7498 16.75 14.4141 16.75 13.9998V12.7498H17C17.4142 12.7498 17.75 12.4141 17.75 11.9998C17.75 11.5856 17.4142 11.2498 17 11.2498H16.75V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-10": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","loyalty","promotion","special-offer","coupon","discount","redemption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.75 11.75H12.75V20.75H14.052C14.9505 20.75 15.6997 20.7501 16.2945 20.6701C16.9223 20.5857 17.4891 20.4 17.9445 19.9445C18.4 19.4891 18.5857 18.9223 18.6701 18.2945C18.7501 17.6997 18.75 16.9505 18.75 16.052L18.75 11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.25 20.75V11.75H5.25L5.25 16.052C5.24997 16.9504 5.24995 17.6997 5.32991 18.2945C5.41432 18.9223 5.59999 19.4891 6.05546 19.9445C6.51093 20.4 7.07773 20.5857 7.70552 20.6701C8.3003 20.7501 9.04951 20.75 9.94798 20.75H11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 6C7.25 4.48122 8.48122 3.25 10 3.25C10.788 3.25 11.4986 3.58144 12 4.11253C12.5014 3.58144 13.212 3.25 14 3.25C15.5188 3.25 16.75 4.48122 16.75 6C16.75 6.45011 16.6419 6.87497 16.4501 7.25H18C18.9665 7.25 19.75 8.0335 19.75 9C19.75 9.9665 18.9665 10.75 18 10.75H6C5.0335 10.75 4.25 9.9665 4.25 9C4.25 8.0335 5.0335 7.25 6 7.25H7.54985C7.35814 6.87497 7.25 6.45011 7.25 6ZM10 7.25H11.25V6C11.25 5.30964 10.6904 4.75 10 4.75C9.30964 4.75 8.75 5.30964 8.75 6C8.75 6.69036 9.30964 7.25 10 7.25ZM12.75 6V7.25H14C14.6904 7.25 15.25 6.69036 15.25 6C15.25 5.30964 14.6904 4.75 14 4.75C13.3096 4.75 12.75 5.30964 12.75 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","box","present","discount","promotion","reward","loyalty","coupon","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 12V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gift-box-12": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","present","discount","promotion","loyalty","reward","bonus","special offer","gift card","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 19L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-14": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","loyalty-program","promotion","coupon","special-offer","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 7C7.25 5.48122 8.48122 4.25 10 4.25C10.788 4.25 11.4986 4.58144 12 5.11253C12.5014 4.58144 13.212 4.25 14 4.25C15.5188 4.25 16.75 5.48122 16.75 7C16.75 7.45011 16.6419 7.87497 16.4501 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9C19.75 9.41421 19.4142 9.75 19 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9C4.25 8.58579 4.58579 8.25 5 8.25H7.54985C7.35814 7.87497 7.25 7.45011 7.25 7ZM10 8.25H11.25V7C11.25 6.30964 10.6904 5.75 10 5.75C9.30964 5.75 8.75 6.30964 8.75 7C8.75 7.69036 9.30964 8.25 10 8.25ZM12.75 7V8.25H14C14.6904 8.25 15.25 7.69036 15.25 7C15.25 6.30964 14.6904 5.75 14 5.75C13.3096 5.75 12.75 6.30964 12.75 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.25 10.75L5.25 15.052C5.24997 15.9504 5.24995 16.6997 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.13899 19.7284 8.65448 19.7442 9.25 19.7484L9.25 10.75H5.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M10.5 19.75H13.5L13.5 10.75H10.5L10.5 19.75Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M14.75 19.7484C15.3455 19.7442 15.861 19.7284 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7501 16.6997 18.75 15.9505 18.75 15.052L18.75 10.75H14.75L14.75 19.7484Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-13": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift","present","promotion","discount","loyalty program","reward","coupon","special offer","gift card","voucher","sale","christmas","birthday","holiday","campaign"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9H18V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 19L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M14 19L14 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "Gift-box-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","gift-card","box","present","loyalty","reward","promotion","discount","special-offer","coupon","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 19L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-16": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","box","present","loyalty-program","promotion","special-offer","discount","reward","gift-card","voucher","event","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 8V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-17": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["gift","present","box","discount","loyalty","rewards","coupon","promotion","special-offer","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V12H18V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 8V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gift-box-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","loyalty","promotion","discount","box","ribbon","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 8V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gift-box-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","box","promotion","reward","loyalty","bonus","coupon","special-offer","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.25 10.75L5.25 15.052C5.24997 15.9504 5.24995 16.6997 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.3003 19.7501 9.04951 19.75 9.94798 19.75H14.052C14.9505 19.75 15.6997 19.7501 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7501 16.6997 18.75 15.9505 18.75 15.052L18.75 10.75H14.7325C14.8374 11.4762 14.4748 12.2191 13.7826 12.5652C13.1896 12.8618 12.5087 12.79 12 12.4365C11.4913 12.79 10.8104 12.8618 10.2174 12.5652C9.52517 12.2191 9.16257 11.4762 9.26747 10.75H5.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 7C7.25 5.48122 8.48122 4.25 10 4.25C10.788 4.25 11.4986 4.58144 12 5.11253C12.5014 4.58144 13.212 4.25 14 4.25C15.5188 4.25 16.75 5.48122 16.75 7C16.75 7.45011 16.6419 7.87497 16.4501 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9C19.75 9.41421 19.4142 9.75 19 9.75H13.2135L13.6708 10.6646C13.8561 11.0351 13.7059 11.4856 13.3354 11.6708C12.9649 11.8561 12.5144 11.7059 12.3292 11.3354L12 10.6771L11.6708 11.3354C11.4856 11.7059 11.0351 11.8561 10.6646 11.6708C10.2941 11.4856 10.1439 11.0351 10.3292 10.6646L10.7865 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9C4.25 8.58579 4.58579 8.25 5 8.25H7.54985C7.35814 7.87497 7.25 7.45011 7.25 7ZM10 8.25H11.25V7C11.25 6.30964 10.6904 5.75 10 5.75C9.30964 5.75 8.75 6.30964 8.75 7C8.75 7.69036 9.30964 8.25 10 8.25ZM12.75 7V8.25H14C14.6904 8.25 15.25 7.69036 15.25 7C15.25 6.30964 14.6904 5.75 14 5.75C13.3096 5.75 12.75 6.30964 12.75 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-18": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","box","gift-box","reward","loyalty","promotion","coupon","special-offer","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.25 11.75H18.75L18.75 16.052C18.75 16.9505 18.7501 17.6997 18.6701 18.2945C18.5857 18.9223 18.4 19.4891 17.9445 19.9445C17.4891 20.4 16.9223 20.5857 16.2945 20.6701C15.6997 20.7501 14.9505 20.75 14.052 20.75H9.94801C9.04954 20.75 8.3003 20.7501 7.70552 20.6701C7.07773 20.5857 6.51093 20.4 6.05546 19.9445C5.59999 19.4891 5.41432 18.9223 5.32991 18.2945C5.24995 17.6997 5.24997 16.9505 5.25 16.0521L5.25 11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 6C7.25 4.48122 8.48122 3.25 10 3.25C10.788 3.25 11.4986 3.58144 12 4.11253C12.5014 3.58144 13.212 3.25 14 3.25C15.5188 3.25 16.75 4.48122 16.75 6C16.75 6.45011 16.6419 6.87497 16.4501 7.25H18C18.9665 7.25 19.75 8.0335 19.75 9C19.75 9.9665 18.9665 10.75 18 10.75H6C5.0335 10.75 4.25 9.9665 4.25 9C4.25 8.0335 5.0335 7.25 6 7.25H7.54985C7.35814 6.87497 7.25 6.45011 7.25 6ZM10 7.25H11.25V6C11.25 5.30964 10.6904 4.75 10 4.75C9.30964 4.75 8.75 5.30964 8.75 6C8.75 6.69036 9.30964 7.25 10 7.25ZM12.75 6V7.25H14C14.6904 7.25 15.25 6.69036 15.25 6C15.25 5.30964 14.6904 4.75 14 4.75C13.3096 4.75 12.75 5.30964 12.75 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-20": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","box","present","reward","loyalty","promotion","special-offer","discount","coupon","giveaway"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9V11H10C8.89543 11 8 10.1046 8 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 7.89543 15.1046 7 14 7C12.8954 7 12 7.89543 12 9V11H14C15.1046 11 16 10.1046 16 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L6 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L18 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 14H6.5C6.03406 14 5.80109 14 5.61732 13.9239C5.37229 13.8224 5.17761 13.6277 5.07612 13.3827C5 13.1989 5 12.9659 5 12.5C5 12.0341 5 11.8011 5.07612 11.6173C5.17761 11.3723 5.37229 11.1776 5.61732 11.0761C5.80109 11 6.03406 11 6.5 11H17.5C17.9659 11 18.1989 11 18.3827 11.0761C18.6277 11.1776 18.8224 11.3723 18.9239 11.6173C19 11.8011 19 12.0341 19 12.5C19 12.9659 19 13.1989 18.9239 13.3827C18.8224 13.6277 18.6277 13.8224 18.3827 13.9239C18.1989 14 17.9659 14 17.5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14V17C6 18.8856 6 19.8284 6.58579 20.4142C7.17157 21 8.11438 21 10 21H14C15.8856 21 16.8284 21 17.4142 20.4142C18 19.8284 18 18.8856 18 17V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 11L12 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift","box","reward","promotion","discount","present","surprise","loyalty","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9V11H10C8.89543 11 8 10.1046 8 9Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 7.89543 15.1046 7 14 7C12.8954 7 12 7.89543 12 9V11H14C15.1046 11 16 10.1046 16 9Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L6 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17V14.6C6 14.3172 6 14.1757 6.08787 14.0879C6.17574 14 6.31716 14 6.6 14H17.4C17.6828 14 17.8243 14 17.9121 14.0879C18 14.1757 18 14.3172 18 14.6V17C18 18.8856 18 19.8284 17.4142 20.4142C16.8284 21 15.8856 21 14 21H10C8.11438 21 7.17157 21 6.58579 20.4142C6 19.8284 6 18.8856 6 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 5L18 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 14H6.5C6.03406 14 5.80109 14 5.61732 13.9239C5.37229 13.8224 5.17761 13.6277 5.07612 13.3827C5 13.1989 5 12.9659 5 12.5C5 12.0341 5 11.8011 5.07612 11.6173C5.17761 11.3723 5.37229 11.1776 5.61732 11.0761C5.80109 11 6.03406 11 6.5 11H17.5C17.9659 11 18.1989 11 18.3827 11.0761C18.6277 11.1776 18.8224 11.3723 18.9239 11.6173C19 11.8011 19 12.0341 19 12.5C19 12.9659 19 13.1989 18.9239 13.3827C18.8224 13.6277 18.6277 13.8224 18.3827 13.9239C18.1989 14 17.9659 14 17.5 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 11L12 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-22": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","loyalty","promotion","offer","coupon","discount","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.25003 14.75L5.25003 17.052C5.25 17.9505 5.24998 18.6997 5.32994 19.2945C5.41435 19.9223 5.60002 20.4891 6.05549 20.9446C6.51096 21.4 7.07776 21.5857 7.70555 21.6701C8.30033 21.7501 9.04955 21.7501 9.94803 21.75H14.052C14.9505 21.7501 15.6997 21.7501 16.2945 21.6701C16.9223 21.5857 17.4891 21.4 17.9446 20.9446C18.4 20.4891 18.5857 19.9223 18.6701 19.2945C18.7501 18.6997 18.7501 17.9505 18.75 17.0521L18.75 14.75H5.25003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V5C11.25 5.41421 11.5858 5.75 12 5.75C12.4142 5.75 12.75 5.41421 12.75 5V3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L5.46967 6.53033C5.76256 6.82322 6.23744 6.82322 6.53033 6.53033C6.82322 6.23744 6.82322 5.76256 6.53033 5.46967L5.53033 4.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L17.4697 5.46967C17.1768 5.76256 17.1768 6.23744 17.4697 6.53033C17.7626 6.82322 18.2374 6.82322 18.5303 6.53033L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6.25C8.48122 6.25 7.25 7.48122 7.25 9C7.25 9.45011 7.35814 9.87497 7.54985 10.25H6C5.0335 10.25 4.25 11.0335 4.25 12C4.25 12.9665 5.0335 13.75 6 13.75H18C18.9665 13.75 19.75 12.9665 19.75 12C19.75 11.0335 18.9665 10.25 18 10.25H16.4501C16.6419 9.87497 16.75 9.45011 16.75 9C16.75 7.48122 15.5188 6.25 14 6.25C13.212 6.25 12.5014 6.58144 12 7.11253C11.4986 6.58144 10.788 6.25 10 6.25ZM14 10.25C14.6904 10.25 15.25 9.69036 15.25 9C15.25 8.30964 14.6904 7.75 14 7.75C13.3096 7.75 12.75 8.30964 12.75 9V10.25H14ZM11.25 10.25V9C11.25 8.30964 10.6904 7.75 10 7.75C9.30964 7.75 8.75 8.30964 8.75 9C8.75 9.69036 9.30964 10.25 10 10.25H11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","bonus","loyalty","promotion","discount","special-offer","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-4": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","box","present","discount","promotion","voucher","reward","loyalty","special-offer","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 14H18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","box","reward","promotion","discount","loyalty","coupon","special-offer","surprise","giveaway","present"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.5 14H6.5C6.03406 14 5.80109 14 5.61732 13.9239C5.37229 13.8224 5.17761 13.6277 5.07612 13.3827C5 13.1989 5 12.9659 5 12.5C5 12.0341 5 11.8011 5.07612 11.6173C5.17761 11.3723 5.37229 11.1776 5.61732 11.0761C5.80109 11 6.03406 11 6.5 11H17.5C17.9659 11 18.1989 11 18.3827 11.0761C18.6277 11.1776 18.8224 11.3723 18.9239 11.6173C19 11.8011 19 12.0341 19 12.5C19 12.9659 19 13.1989 18.9239 13.3827C18.8224 13.6277 18.6277 13.8224 18.3827 13.9239C18.1989 14 17.9659 14 17.5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14V17C6 18.8856 6 19.8284 6.58579 20.4142C7.17157 21 8.11438 21 10 21H14C15.8856 21 16.8284 21 17.4142 20.4142C18 19.8284 18 18.8856 18 17V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 11L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9V11H10C8.89543 11 8 10.1046 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 7.89543 15.1046 7 14 7C12.8954 7 12 7.89543 12 9V11H14C15.1046 11 16 10.1046 16 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 5L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gift-box-5": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift","present","reward","loyalty","promotion","coupon","special-offer","discount","redemption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9H18V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 14H18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-6": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","box","present","reward","promotion","discount","special-offer","loyalty","loyalty-program","voucher","coupon","giveaway"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4.25C8.48122 4.25 7.25 5.48122 7.25 7C7.25 7.45011 7.35814 7.87497 7.54985 8.25H5C4.58579 8.25 4.25 8.58579 4.25 9C4.25 9.41421 4.58579 9.75 5 9.75H10.7865L10.3292 10.6646C10.1439 11.0351 10.2941 11.4856 10.6646 11.6708C11.0351 11.8561 11.4856 11.7059 11.6708 11.3354L12 10.6771L12.3292 11.3354C12.5144 11.7059 12.9649 11.8561 13.3354 11.6708C13.7059 11.4856 13.8561 11.0351 13.6708 10.6646L13.2135 9.75H19C19.4142 9.75 19.75 9.41421 19.75 9C19.75 8.58579 19.4142 8.25 19 8.25H16.4501C16.6419 7.87497 16.75 7.45011 16.75 7C16.75 5.48122 15.5188 4.25 14 4.25C13.212 4.25 12.5014 4.58144 12 5.11253C11.4986 4.58144 10.788 4.25 10 4.25ZM11.25 8.25H10C9.30964 8.25 8.75 7.69036 8.75 7C8.75 6.30964 9.30964 5.75 10 5.75C10.6904 5.75 11.25 6.30964 11.25 7V8.25ZM12.75 8.25V7C12.75 6.30964 13.3096 5.75 14 5.75C14.6904 5.75 15.25 6.30964 15.25 7C15.25 7.69036 14.6904 8.25 14 8.25H12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.25 15.052L5.25 10.75H9.26747C9.16257 11.4762 9.52517 12.2191 10.2174 12.5652C10.8104 12.8618 11.4913 12.79 12 12.4365C12.5087 12.79 13.1896 12.8618 13.7826 12.5652C14.4748 12.2191 14.8374 11.4762 14.7325 10.75H18.75L18.75 15.052C18.75 15.1188 18.75 15.1848 18.75 15.25L5.25003 15.25C5.25 15.1848 5.25 15.1188 5.25 15.052Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.27928 16.75C5.29092 16.9439 5.30719 17.1254 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.3003 19.7501 9.04951 19.75 9.94798 19.75H14.052C14.9505 19.75 15.6997 19.7501 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.6928 17.1254 18.7091 16.9439 18.7207 16.75L5.27928 16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Gift-box-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift","present","reward","loyalty","promotion","coupon","voucher","special-offer","discount","perk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 14H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-box-9": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift","box","present","loyalty","reward","promotion","special-offer","discount","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 16V12H18V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 12V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Gift-box": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","box","present","reward","promotion","coupon","discount","loyalty","redemption","special-offer","package"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7V9H10C8.89543 9 8 8.10457 8 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7V9H14C15.1046 9 16 8.10457 16 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 11L12 9L13 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Gift-box-8": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["gift","box","present","reward","loyalty","coupon","discount","promotion","special offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6V8H10C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 6C16 4.89543 15.1046 4 14 4C12.8954 4 12 4.89543 12 6V8H14C15.1046 8 16 7.10457 16 6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H7C6.05719 12 5.58579 12 5.29289 11.7071C5 11.4142 5 10.9428 5 10C5 9.05719 5 8.58579 5.29289 8.29289C5.58579 8 6.05719 8 7 8H17C17.9428 8 18.4142 8 18.7071 8.29289C19 8.58579 19 9.05719 19 10C19 10.9428 19 11.4142 18.7071 11.7071C18.4142 12 17.9428 12 17 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 12V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-card-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gift card","gift","card","present","loyalty","reward","coupon","discount","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M3 12L21 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5V12H10.5C9.67157 12 9 11.3284 9 10.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10C16 8.89543 15.1046 8 14 8C12.8954 8 12 8.89543 12 10V12H14C15.1046 12 16 11.1046 16 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 14L12 12L13 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["gift card","present","reward","voucher","loyalty","gift","card","box","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M3 12L21 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5V12H10.5C9.67157 12 9 11.3284 9 10.5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10C16 8.89543 15.1046 8 14 8C12.8954 8 12 8.89543 12 10V12H14C15.1046 12 16 11.1046 16 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 14L12 12L13 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Gift-card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift card","gift","present","card","reward","loyalty","promotion","voucher","certificate","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.94513 4.25H15.0549C16.4225 4.24998 17.5248 4.24997 18.3918 4.36653C19.2919 4.48754 20.0497 4.74644 20.6517 5.34835C21.2536 5.95027 21.5125 6.70814 21.6335 7.60825C21.75 8.47522 21.75 9.57754 21.75 10.9451V11.25H16.4501C16.6419 10.875 16.75 10.4501 16.75 10C16.75 8.48122 15.5188 7.25 14 7.25C13.0062 7.25 12.1355 7.77716 11.6524 8.5671C11.3153 8.36572 10.9212 8.25 10.5 8.25C9.25736 8.25 8.25 9.25736 8.25 10.5C8.25 10.763 8.29512 11.0154 8.37803 11.25H2.25V10.9451C2.24998 9.57755 2.24997 8.47521 2.36653 7.60825C2.48754 6.70814 2.74644 5.95027 3.34835 5.34835C3.95027 4.74644 4.70814 4.48754 5.60825 4.36653C6.47521 4.24997 7.57755 4.24998 8.94513 4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.25 12.75V13.0549C2.24998 14.4225 2.24997 15.5248 2.36653 16.3918C2.48754 17.2919 2.74644 18.0497 3.34835 18.6517C3.95027 19.2536 4.70814 19.5125 5.60825 19.6335C6.47522 19.75 7.57753 19.75 8.94512 19.75H15.0549C16.4225 19.75 17.5248 19.75 18.3918 19.6335C19.2919 19.5125 20.0497 19.2536 20.6517 18.6517C21.2536 18.0497 21.5125 17.2919 21.6335 16.3918C21.75 15.5248 21.75 14.4225 21.75 13.0549V12.75H13.2135L13.6708 13.6646C13.8561 14.0351 13.7059 14.4856 13.3354 14.6708C12.9649 14.8561 12.5144 14.7059 12.3292 14.3354L12 13.6771L11.6708 14.3354C11.4856 14.7059 11.0351 14.8561 10.6646 14.6708C10.2941 14.4856 10.1439 14.0351 10.3292 13.6646L10.7865 12.75H2.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.5 9.75C10.9142 9.75 11.25 10.0858 11.25 10.5V11.25H10.5C10.0858 11.25 9.75 10.9142 9.75 10.5C9.75 10.0858 10.0858 9.75 10.5 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.75 10V11.25H14C14.6904 11.25 15.25 10.6904 15.25 10C15.25 9.30965 14.6904 8.75 14 8.75C13.3096 8.75 12.75 9.30965 12.75 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-branch-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["split","branch","merge","diverge","options","choices","routing","workflow","multi-payment","split-payment","variants","variations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 16L7 15C7 13.3431 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 8L17 9C17 10.6569 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C15 4.89543 15.8954 4 17 4C18.1046 4 19 4.89543 19 6C19 7.10457 18.1046 8 17 8C15.8954 8 15 7.10457 15 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Gift-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["gift-card","gift","card","present","reward","loyalty","promotion","coupon","discount","voucher","payment-method"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M3 12L21 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5V12H10.5C9.67157 12 9 11.3284 9 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10C16 8.89543 15.1046 8 14 8C12.8954 8 12 8.89543 12 10V12H14C15.1046 12 16 11.1046 16 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 14L12 12L13 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "git-branch-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["branch","merge","split","variant","fork","options","workflow","pipeline","process","scenario","routing","multi-choice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 16L7 15C7 13.3431 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 8L17 9C17 10.6569 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C15 4.89543 15.8954 4 17 4C18.1046 4 19 4.89543 19 6C19 7.10457 18.1046 8 17 8C15.8954 8 15 7.10457 15 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-branch-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["branch","split","diverge","route","path","fork","merge","options","choices","variations","flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 6C20 4.3 18.7 3 17 3C15.3 3 14 4.3 14 6C14 7.34 14.82 8.43 16 8.83V9C16 10.1 15.1 11 14 11H10C9.3 11 8.6 11.2 8 11.6V8.83C9.18 8.43 10 7.35 10 6C10 4.3 8.7 3 7 3C5.3 3 4 4.3 4 6C4 7.34 4.82 8.43 6 8.83V15.18C4.82 15.58 4 16.66 4 18.01C4 19.71 5.3 21 7 21C8.7 21 10 19.71 10 18.01C10 16.67 9.18 15.58 8 15.18V15.01C8 13.91 8.9 13.01 10 13.01H14C16.2 13.01 18 11.21 18 9.01V8.84C19.18 8.44 20 7.36 20 6.01V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-branch": {
        defaultColors: ["#3D4C66"],
        keywords: ["branch","split","merge","options","alternatives","variations","versions","choices","route","path","workflow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C15 4.89543 15.8954 4 17 4C18.1046 4 19 4.89543 19 6C19 7.10457 18.1046 8 17 8C15.8954 8 15 7.10457 15 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 16L7 15C7 13.3431 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 8L17 9C17 10.6569 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-close-pull-request-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","cancel","disconnect","remove","unlink","delete","connection","break"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6C10 4.34 8.66 3 7 3C5.34 3 4 4.34 4 6C4 7.3 4.84 8.4 6 8.82V15.19C4.84 15.6 4 16.7 4 18.01C4 19.67 5.34 21 7 21C8.66 21 10 19.67 10 18.01C10 16.71 9.16 15.61 8 15.19V8.82C9.16 8.41 10 7.31 10 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 15.18V10.89C18 10.34 17.55 9.89 17 9.89C16.45 9.89 16 10.34 16 10.89V15.18C14.84 15.59 14 16.69 14 18C14 19.66 15.34 21 17 21C18.66 21 20 19.66 20 18C20 16.7 19.16 15.6 18 15.18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.41 6L19.7 4.71C20.09 4.32 20.09 3.69 19.7 3.3C19.31 2.91 18.68 2.91 18.29 3.3L17 4.59L15.71 3.3C15.32 2.91 14.69 2.91 14.3 3.3C13.91 3.69 13.91 4.32 14.3 4.71L15.59 6L14.3 7.29C13.91 7.68 13.91 8.31 14.3 8.7C14.69 9.09 15.32 9.09 15.71 8.7L17 7.41L18.29 8.7C18.68 9.09 19.31 9.09 19.7 8.7C20.09 8.31 20.09 7.68 19.7 7.29L18.41 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-close-pull-request-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["link","connection","cancel","disconnect","remove-link","unlink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10L17 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L17 6M17 6L19 4M17 6L15 8M17 6L15 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-close-pull-request-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["close","pull-request","cancel","transaction","void","error","connection","network","issue","resolve"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L17 6M17 6L19 4M17 6L15 8M17 6L15 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-close-pull-request": {
        defaultColors: ["#3D4C66"],
        keywords: ["flow","process","workflow","cancel","reject","decline","undo","revert","rollback","back","chain","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L17 6M17 6L19 4M17 6L15 8M17 6L15 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-commit-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["commit","update","synchronize","history","log","transaction","version","checkpoint","save","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-commit-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["commit","update","change","record","history","log","version","track","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L19 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-commit": {
        defaultColors: ["#3D4C66"],
        keywords: ["git","commit","history","version","control","record","save","transaction","checkpoint"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-commit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["record","history","log","commit","transaction","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11H15.86C15.41 9.28 13.86 8 12 8C10.14 8 8.59 9.28 8.14 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13H8.14C8.59 14.72 10.14 16 12 16C13.86 16 15.41 14.72 15.86 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-merge-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["merge","branch","combine","network","connection","link","options","route","split","variants","variations","flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 8L7 9C7 10.6569 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 15C17 13.3431 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-merge-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["merge","combine","unite","branch","connect","link","git","git-merge","combination","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 15.17V15C18 12.8 16.2 11 14 11H10C8.9 11 8 10.1 8 9V8.83C9.18 8.43 10 7.35 10 6C10 4.3 8.7 3 7 3C5.3 3 4 4.3 4 6C4 7.34 4.82 8.43 6 8.83V15.18C4.82 15.58 4 16.66 4 18.01C4 19.71 5.3 21 7 21C8.7 21 10 19.71 10 18.01C10 16.67 9.18 15.58 8 15.18V12.41C8.6 12.81 9.3 13.01 10 13.01H14C15.1 13.01 16 13.91 16 15.01V15.18C14.82 15.58 14 16.66 14 18.01C14 19.71 15.3 21 17 21C18.7 21 20 19.71 20 18.01C20 16.67 19.18 15.58 18 15.18V15.17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-merge-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["merge","combine","split","tree","branch","network","connection","relationship","hierarchy","process","workflow","integration","synchronize","flow","diagram"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 8L7 9C7 10.6569 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 15C17 13.3431 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-pull-request-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["arrow","pull","request","swap","exchange","transfer","connect","link","merge","reconcile","undo","revert","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 8V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 7C17 6.44772 16.5523 6 16 6L13 6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L13 6L15 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-pull-request-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["transfer","sync","merge","pull","request","git","import","export","data-transfer","update","synchronize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 8V16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 7C17 6.44772 16.5523 6 16 6L13 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L13 6L15 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-merge": {
        defaultColors: ["#3D4C66"],
        keywords: ["merge","branch","combine","options","split","flow","workflow","alternative","choose","path"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 8L7 9C7 10.6569 8.34315 12 10 12L13 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 15C17 13.3431 15.6569 12 14 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "git-pull-request-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["transfer","move","redirect","flow","process","transaction","reverse","return","undo","history","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7071 4.70711C16.0976 4.31658 16.0976 3.68342 15.7071 3.29289C15.3166 2.90237 14.6834 2.90237 14.2929 3.29289L12.2929 5.29289C12.1054 5.48043 12 5.73478 12 6C12 6.26522 12.1054 6.51957 12.2929 6.70711L14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C15.9022 8.51201 15.9998 8.25635 16 8.00064V15.1707C14.8348 15.5825 14 16.6938 14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18C20 16.6938 19.1652 15.5825 18 15.1707V7C18 5.89543 17.1046 5 16 5H15.4142L15.7071 4.70711ZM16 7.99936V7H15.4142L15.7071 7.29289C15.9022 7.48799 15.9998 7.74365 16 7.99936Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 6C4 4.34315 5.34315 3 7 3C8.65685 3 10 4.34315 10 6C10 7.30622 9.16519 8.41746 8 8.82929L8 15.1707C9.16519 15.5825 10 16.6938 10 18C10 19.6569 8.65685 21 7 21C5.34315 21 4 19.6569 4 18C4 16.6938 4.83481 15.5825 6 15.1707L6 8.82929C4.83481 8.41746 4 7.30622 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "git-pull-request": {
        defaultColors: ["#3D4C66"],
        keywords: ["transfer","link","relation","relationship","connect","association","switch","change","interaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 7C17 6.44772 16.5523 6 16 6L13 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L13 6L15 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "gitlab-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["loyalty","badge","reward","customer","vip","perk","discount","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L9 10L15 10L16 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.39794 3.55276C7.64495 3.22025 8.11474 3.15094 8.44724 3.39794C8.77975 3.64495 8.84906 4.11474 8.60206 4.44724L7.39794 3.55276ZM12.4748 19.4194C12.7954 19.6816 12.8428 20.1541 12.5806 20.4748C12.3184 20.7954 11.8459 20.8428 11.5252 20.5806L12.4748 19.4194ZM5.7967 14.9272L6.27148 14.3466L5.7967 14.9272ZM4.22331 12.5622L3.50608 12.7815L4.22331 12.5622ZM5.07871 7.93248L5.68077 8.37972C5.6761 8.386 5.67134 8.39221 5.66648 8.39834L5.07871 7.93248ZM4.47665 7.48523L7.39794 3.55276L8.60206 4.44724L5.68077 8.37972L4.47665 7.48523ZM11.5252 20.5806L5.32192 15.5078L6.27148 14.3466L12.4748 19.4194L11.5252 20.5806ZM5.32192 15.5078C4.46529 14.8073 3.83457 13.856 3.50608 12.7815L4.94054 12.3429C5.1848 13.1419 5.65072 13.839 6.27148 14.3466L5.32192 15.5078ZM5.66648 8.39834C4.80207 9.48895 4.52353 10.9789 4.94054 12.3429L3.50608 12.7815C2.9476 10.9547 3.31458 8.95081 4.49094 7.46662L5.66648 8.39834Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16.6021 3.55276C16.3551 3.22025 15.8853 3.15094 15.5528 3.39794C15.2202 3.64495 15.1509 4.11474 15.3979 4.44724L16.6021 3.55276ZM11.5252 19.4194C11.2046 19.6816 11.1572 20.1541 11.4194 20.4748C11.6816 20.7954 12.1541 20.8428 12.4748 20.5806L11.5252 19.4194ZM18.2033 14.9272L17.7285 14.3466L18.2033 14.9272ZM19.7767 12.5622L20.4939 12.7815L19.7767 12.5622ZM18.9213 7.93248L18.3192 8.37972C18.3239 8.386 18.3287 8.39221 18.3335 8.39834L18.9213 7.93248ZM19.5233 7.48523L16.6021 3.55276L15.3979 4.44724L18.3192 8.37972L19.5233 7.48523ZM12.4748 20.5806L18.6781 15.5078L17.7285 14.3466L11.5252 19.4194L12.4748 20.5806ZM18.6781 15.5078C19.5347 14.8073 20.1654 13.856 20.4939 12.7815L19.0595 12.3429C18.8152 13.1419 18.3493 13.839 17.7285 14.3466L18.6781 15.5078ZM18.3335 8.39834C19.1979 9.48895 19.4765 10.9789 19.0595 12.3429L20.4939 12.7815C21.0524 10.9547 20.6854 8.95081 19.5091 7.46662L18.3335 8.39834Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "gitlab-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gitlab","tag","loyalty","rewards","customer","program","badge","coupon","discount","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.0726 3.75242C16.4225 2.90323 15.1085 3.27076 14.9393 4.28571L14.1536 9.00003H10.0168L9.23105 4.28571C9.06189 3.27075 7.74788 2.90323 7.09769 3.75242C6.47209 4.5695 5.62266 5.71697 4.87968 6.80565C4.50851 7.34953 4.15797 7.88739 3.87346 8.36701C3.60613 8.81766 3.36166 9.27501 3.23029 9.65626C2.73906 10.9251 2.83633 13.5205 5.52386 15.7636L11.2214 20.6491C11.666 21.0303 12.3209 21.0349 12.7708 20.66L18.6409 15.7682C21.3339 13.5241 21.4316 10.926 20.94 9.65627C20.8087 9.27502 20.5642 8.81767 20.2969 8.36701C20.0124 7.88739 19.6618 7.34953 19.2907 6.80565C18.5477 5.71697 17.6982 4.5695 17.0726 3.75242Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "gitlab-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["gitlab","fox","mascot","logo","payment","loyalty","rewards","coupon","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.1691 10H12.0002H9.33852C9.24076 10 9.15732 9.92932 9.14124 9.83288L8.24411 4.45008C8.21546 4.27818 7.99709 4.22194 7.89114 4.36031C6.65402 5.97609 4.53955 8.88865 4.1691 10C3.83576 10.8333 3.7691 13 6.1691 15L11.8718 19.8899C11.9459 19.9535 12.055 19.9543 12.13 19.8918L18.0002 15C20.4002 13 20.3335 10.8333 20.0002 10C19.6297 8.88865 17.5152 5.97609 16.2781 4.36031C16.1722 4.22194 15.9538 4.27818 15.9251 4.45008L15.028 9.83288C15.0119 9.92932 14.9285 10 14.8307 10H12.1691Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12.0002 10H14.8307C14.9285 10 15.0119 9.92932 15.028 9.83288L15.9251 4.45008C15.9538 4.27818 16.1722 4.22194 16.2781 4.36031C17.5152 5.97609 19.6297 8.88864 20.0002 10C20.3335 10.8333 20.4002 13 18.0002 15L12.13 19.8918C12.055 19.9543 11.9459 19.9535 11.8718 19.8899L6.1691 15C3.7691 13 3.83576 10.8333 4.1691 10C4.53955 8.88864 6.65402 5.97609 7.89114 4.36031C7.99709 4.22194 8.21546 4.27818 8.24411 4.45008L9.14124 9.83288C9.15732 9.92932 9.24076 10 9.33852 10H12.1691"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    gitlab: {
        defaultColors: ["#3D4C66"],
        keywords: ["gitlab","fox","mascot","logo","payment","loyalty","rewards","coupon","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4L9 10L15 10L16 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.39794 3.55276C7.64495 3.22025 8.11474 3.15094 8.44724 3.39794C8.77975 3.64495 8.84906 4.11474 8.60206 4.44724L7.39794 3.55276ZM12.4748 19.4194C12.7954 19.6816 12.8428 20.1541 12.5806 20.4748C12.3184 20.7954 11.8459 20.8428 11.5252 20.5806L12.4748 19.4194ZM5.7967 14.9272L6.27148 14.3466L5.7967 14.9272ZM4.22331 12.5622L3.50608 12.7815L4.22331 12.5622ZM5.07871 7.93248L5.68077 8.37972C5.6761 8.386 5.67134 8.39221 5.66648 8.39834L5.07871 7.93248ZM4.47665 7.48523L7.39794 3.55276L8.60206 4.44724L5.68077 8.37972L4.47665 7.48523ZM11.5252 20.5806L5.32192 15.5078L6.27148 14.3466L12.4748 19.4194L11.5252 20.5806ZM5.32192 15.5078C4.46529 14.8073 3.83457 13.856 3.50608 12.7815L4.94054 12.3429C5.1848 13.1419 5.65072 13.839 6.27148 14.3466L5.32192 15.5078ZM5.66648 8.39834C4.80207 9.48895 4.52353 10.9789 4.94054 12.3429L3.50608 12.7815C2.9476 10.9547 3.31458 8.95081 4.49094 7.46662L5.66648 8.39834Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.6021 3.55276C16.3551 3.22025 15.8853 3.15094 15.5528 3.39794C15.2202 3.64495 15.1509 4.11474 15.3979 4.44724L16.6021 3.55276ZM11.5252 19.4194C11.2046 19.6816 11.1572 20.1541 11.4194 20.4748C11.6816 20.7954 12.1541 20.8428 12.4748 20.5806L11.5252 19.4194ZM18.2033 14.9272L17.7285 14.3466L18.2033 14.9272ZM19.7767 12.5622L20.4939 12.7815L19.7767 12.5622ZM18.9213 7.93248L18.3192 8.37972C18.3239 8.386 18.3287 8.39221 18.3335 8.39834L18.9213 7.93248ZM19.5233 7.48523L16.6021 3.55276L15.3979 4.44724L18.3192 8.37972L19.5233 7.48523ZM12.4748 20.5806L18.6781 15.5078L17.7285 14.3466L11.5252 19.4194L12.4748 20.5806ZM18.6781 15.5078C19.5347 14.8073 20.1654 13.856 20.4939 12.7815L19.0595 12.3429C18.8152 13.1419 18.3493 13.839 17.7285 14.3466L18.6781 15.5078ZM18.3335 8.39834C19.1979 9.48895 19.4765 10.9789 19.0595 12.3429L20.4939 12.7815C21.0524 10.9547 20.6854 8.95081 19.5091 7.46662L18.3335 8.39834Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "glass-water-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["glass","water","drink","beverage","soda","juice","refreshment","cup","water-glass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12L16.5008 12.2496C15.5727 12.7136 14.4672 12.6448 13.6039 12.0692V12.0692C12.6326 11.4218 11.3674 11.4218 10.3961 12.0692V12.0692C9.5328 12.6448 8.42726 12.7136 7.4992 12.2496L7 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 5H18L17.2654 15.285C17.1395 17.0466 17.0766 17.9275 16.5007 18.4637C15.9247 19 15.0417 19 13.2755 19H10.7245C8.95835 19 8.07528 19 7.49933 18.4637C6.92339 17.9275 6.86047 17.0466 6.73464 15.285L6 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "glass-water": {
        defaultColors: ["#3D4C66"],
        keywords: ["glass","water","drink","beverage","juice","liquid","menu-item","refreshment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 5H18L17.2654 15.285C17.1395 17.0466 17.0766 17.9275 16.5007 18.4637C15.9247 19 15.0417 19 13.2755 19H10.7245C8.95835 19 8.07528 19 7.49933 18.4637C6.92339 17.9275 6.86047 17.0466 6.73464 15.285L6 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12L16.5008 12.2496C15.5727 12.7136 14.4672 12.6448 13.6039 12.0692V12.0692C12.6326 11.4218 11.3674 11.4218 10.3961 12.0692V12.0692C9.5328 12.6448 8.42726 12.7136 7.4992 12.2496L7 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "glass-water-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["glass","water","drink","beverage","menu-item","refreshment","order","add-item","liquid","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 5H18L17.2654 15.285C17.1395 17.0466 17.0766 17.9275 16.5007 18.4637C15.9247 19 15.0417 19 13.2755 19H10.7245C8.95835 19 8.07528 19 7.49933 18.4637C6.92339 17.9275 6.86047 17.0466 6.73464 15.285L6 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12L16.5008 12.2496C15.5727 12.7136 14.4672 12.6448 13.6039 12.0692V12.0692C12.6326 11.4218 11.3674 11.4218 10.3961 12.0692V12.0692C9.5328 12.6448 8.42726 12.7136 7.4992 12.2496L7 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "glass-water-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["drink","glass","water","beverage","refreshment","menu-item","order-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 4C5.72241 4 5.45731 4.11539 5.26814 4.31855C5.07897 4.52171 4.98277 4.79436 5.00254 5.07125L5.43835 11.1726C5.70804 10.9898 6.06165 10.9422 6.38484 11.0769L7.01451 11.3393C7.85033 11.6875 8.79957 11.6342 9.59109 11.1944C11.0893 10.3621 12.9111 10.3621 14.4094 11.1944C15.2009 11.6342 16.1501 11.6875 16.9859 11.3393L17.6156 11.0769C17.9386 10.9423 18.292 10.9898 18.5617 11.1723L18.9975 5.07125C19.0172 4.79436 18.921 4.52171 18.7319 4.31855C18.5427 4.11539 18.2776 4 18 4H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.4383 12.8989C18.4209 12.9074 18.403 12.9155 18.3848 12.9231L17.7552 13.1854C16.3547 13.7689 14.7643 13.6795 13.4381 12.9427C12.5439 12.446 11.4566 12.446 10.5624 12.9427C9.23617 13.6795 7.64571 13.7689 6.24528 13.1854L5.61561 12.9231C5.59727 12.9154 5.57928 12.9073 5.56165 12.8987L5.74167 15.419C5.8007 16.2461 5.85178 16.9618 5.96835 17.5336C6.09361 18.148 6.31814 18.7303 6.81789 19.1956C7.31763 19.6609 7.91438 19.8434 8.53615 19.9246C9.11482 20.0001 9.83233 20 10.6615 20H13.3384C14.1677 20 14.8852 20.0001 15.4639 19.9246C16.0856 19.8434 16.6824 19.6609 17.1821 19.1956C17.6819 18.7303 17.9064 18.148 18.0317 17.5336C18.1482 16.9618 18.1993 16.2461 18.2583 15.419L18.4383 12.8989Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Glasses-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["glasses","goggles","virtual-reality","vr","safety","eye-protection","protection","eye-wear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.9529V12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12V13.9529C21 14.9268 21 15.4138 20.888 15.8121C20.605 16.8185 19.8185 17.605 18.8121 17.888C18.4138 18 17.9268 18 16.9529 18C16.5573 18 16.3595 18 16.1774 17.966C15.7213 17.8808 15.3091 17.6397 15.0113 17.284C14.8924 17.142 14.7954 16.9695 14.6014 16.6247L14.5395 16.5148C13.8474 15.2843 13.5014 14.6691 13.0874 14.4009C12.4258 13.9723 11.5742 13.9723 10.9126 14.4009C10.4986 14.6691 10.1526 15.2843 9.46045 16.5148L9.3986 16.6247C9.20463 16.9695 9.10765 17.142 8.98873 17.284C8.69089 17.6397 8.27865 17.8808 7.82261 17.966C7.64053 18 7.44271 18 7.04706 18C6.07317 18 5.58623 18 5.1879 17.888C4.1815 17.605 3.39501 16.8185 3.11201 15.8121C3 15.4138 3 14.9268 3 13.9529Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Glasses-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["glasses","sunglasses","vision","prescription","eyewear","optics","accessories","products","medical","eye-care"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.9529V12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12V13.9529C21 14.9268 21 15.4138 20.888 15.8121C20.605 16.8185 19.8185 17.605 18.8121 17.888C18.4138 18 17.9268 18 16.9529 18C16.5573 18 16.3595 18 16.1774 17.966C15.7213 17.8808 15.3091 17.6397 15.0113 17.284C14.8924 17.142 14.7954 16.9695 14.6014 16.6247L14.5395 16.5148C13.8474 15.2843 13.5014 14.6691 13.0874 14.4009C12.4258 13.9723 11.5742 13.9723 10.9126 14.4009C10.4986 14.6691 10.1526 15.2843 9.46045 16.5148L9.3986 16.6247C9.20463 16.9695 9.10765 17.142 8.98873 17.284C8.69089 17.6397 8.27865 17.8808 7.82261 17.966C7.64053 18 7.44271 18 7.04706 18C6.07317 18 5.58623 18 5.1879 17.888C4.1815 17.605 3.39501 16.8185 3.11201 15.8121C3 15.4138 3 14.9268 3 13.9529Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Glasses-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["glasses","vr","virtual-reality","augmented-reality","product-display","try-on","wearables"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.0707 5H8.92954C7.57543 4.99997 6.45879 4.99994 5.57504 5.11876C4.64721 5.2435 3.82779 5.51547 3.17168 6.17158C2.51557 6.82769 2.2436 7.64711 2.11886 8.57494C2.00004 9.4587 2.00007 10.5753 2.0001 11.9294L2.00005 14.097C1.99958 14.9299 1.99923 15.5486 2.14945 16.0828C2.52678 17.4247 3.57544 18.4733 4.91731 18.8507C5.45152 19.0009 6.07022 19.0005 6.9031 19.0001L7.11562 19C7.44345 19.0003 7.73065 19.0005 8.00637 18.949C8.69043 18.8212 9.30879 18.4595 9.75555 17.926C9.93562 17.7109 10.0762 17.4605 10.2367 17.1747L10.3321 17.005C10.6855 16.3768 10.9251 15.952 11.126 15.6472C11.3306 15.3367 11.4279 15.2586 11.4564 15.2402C11.7872 15.0259 12.213 15.0259 12.5438 15.2402C12.5723 15.2586 12.6697 15.3367 12.8742 15.6472C13.0751 15.952 13.3147 16.3768 13.6681 17.005L13.7635 17.1747C13.924 17.4605 14.0646 17.7109 14.2447 17.926C14.6914 18.4595 15.3098 18.8212 15.9938 18.949C16.2696 19.0005 16.5568 19.0003 16.8846 19L17.0971 19.0001C17.93 19.0005 18.5487 19.0009 19.0829 18.8507C20.4248 18.4733 21.4734 17.4247 21.8508 16.0828C22.001 15.5486 22.0006 14.9299 22.0002 14.097L22.0001 11.9295C22.0001 10.5753 22.0002 9.4587 21.8814 8.57494C21.7566 7.64711 21.4846 6.82769 20.8285 6.17158C20.1724 5.51547 19.353 5.2435 18.4252 5.11876C17.5414 4.99994 16.4248 4.99997 15.0707 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Globe-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["globe","world","international","language","currency","location","global","online","web"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5C18.3843 15.2832 19 13.7135 19 12C19 10.2865 18.3843 8.71677 17.3621 7.5C16.078 5.97153 14.1525 5 12 5C9.84752 5 7.92196 5.97153 6.63789 7.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Globe-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["globe","earth","international","language","localization","currency","region","world","export","import","shipping","global"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5C18.3843 15.2832 19 13.7135 19 12C19 10.2865 18.3843 8.71677 17.3621 7.5C16.078 5.97153 14.1525 5 12 5C9.84752 5 7.92196 5.97153 6.63789 7.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M5 12H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Glasses: {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","earth","international","language","localization","currency","region","world","export","import","shipping","global"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.9529V12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12V13.9529C21 14.9268 21 15.4138 20.888 15.8121C20.605 16.8185 19.8185 17.605 18.8121 17.888C18.4138 18 17.9268 18 16.9529 18C16.5573 18 16.3595 18 16.1774 17.966C15.7213 17.8808 15.3091 17.6397 15.0113 17.284C14.8924 17.142 14.7954 16.9695 14.6014 16.6247L14.5395 16.5148C13.8474 15.2843 13.5014 14.6691 13.0874 14.4009C12.4258 13.9723 11.5742 13.9723 10.9126 14.4009C10.4986 14.6691 10.1526 15.2843 9.46045 16.5148L9.3986 16.6247C9.20463 16.9695 9.10765 17.142 8.98873 17.284C8.69089 17.6397 8.27865 17.8808 7.82261 17.966C7.64053 18 7.44271 18 7.04706 18C6.07317 18 5.58623 18 5.1879 17.888C4.1815 17.605 3.39501 16.8185 3.11201 15.8121C3 15.4138 3 14.9268 3 13.9529Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Globe-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["globe","world","international","location","region","shipping","global","network","planet","countries","worldwide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63789 7.5C7.92196 9.02847 9.84752 10 12 10C14.1525 10 16.078 9.02847 17.3621 7.5M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5M6.63789 7.5C7.92196 5.97153 9.84752 5 12 5C14.1525 5 16.078 5.97153 17.3621 7.5M17.3621 7.5C18.3843 8.71677 19 10.2865 19 12C19 13.7135 18.3843 15.2832 17.3621 16.5M6.63789 16.5C7.92196 14.9715 9.84752 14 12 14C14.1525 14 16.078 14.9715 17.3621 16.5M6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Globe-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","network","international","location","shipping","sales region","worldwide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C11.7563 4 11.5126 4.08728 11.3201 4.26184C9.48509 5.92592 8.26005 8.31574 8.01431 11H4C4.19708 9.43348 4.85095 8.00649 5.82438 6.85676C7.30177 5.1118 9.52052 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 13H15.9857C15.7399 15.6843 14.5149 18.0741 12.6799 19.7382C12.2949 20.0873 11.7051 20.0873 11.3201 19.7382C9.48509 18.0741 8.26005 15.6843 8.01431 13H4C4.19708 14.5665 4.85095 15.9935 5.82438 17.1432C7.30177 18.8882 9.52052 20 12 20C14.4795 20 16.6982 18.8882 18.1756 17.1432C19.1491 15.9935 19.8029 14.5665 20 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9857 11H20C19.8029 9.43348 19.149 8.00649 18.1756 6.85676C16.6982 5.1118 14.4795 4 12 4C12.2437 4 12.4874 4.08728 12.6799 4.26184C14.5149 5.92592 15.7399 8.31574 15.9857 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 6.43712C13.0492 7.65863 13.7622 9.23831 13.9599 11H10.0401C10.2378 9.23831 10.9508 7.65863 12 6.43712Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 17.5629C10.9508 16.3414 10.2378 14.7617 10.0401 13H13.9599C13.7622 14.7617 13.0492 16.3414 12 17.5629Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Globe-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","world","international","location","language","region","global","market","location-settings","language-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63789 7.5C7.92196 9.02847 9.84752 10 12 10C14.1525 10 16.078 9.02847 17.3621 7.5M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5M6.63789 7.5C7.92196 5.97153 9.84752 5 12 5C14.1525 5 16.078 5.97153 17.3621 7.5M17.3621 7.5C18.3843 8.71677 19 10.2865 19 12C19 13.7135 18.3843 15.2832 17.3621 16.5M6.63789 16.5C7.92196 14.9715 9.84752 14 12 14C14.1525 14 16.078 14.9715 17.3621 16.5M6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Globe-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","world","international","location","region","language","customer","global","address","network","connectivity","online","web"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C12.2418 4 12.4836 4.08728 12.6746 4.26184C13.645 5.1487 14.4435 6.2417 15.0146 7.47555C15.9072 7.15142 16.72 6.68821 17.4218 6.11748C15.9971 4.80393 14.0921 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.57822 6.11747C8.00292 4.80392 9.90792 4 12 4C11.7582 4 11.5164 4.08728 11.3254 4.26184C10.355 5.1487 9.55651 6.2417 8.98542 7.47554C8.09283 7.15141 7.28 6.6882 6.57822 6.11747Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.28775 7.64585C4.47348 8.89893 4 10.395 4 12C4 13.605 4.47348 15.1011 5.28776 16.3541C6.17601 15.6263 7.20136 15.0422 8.3214 14.6378C8.11158 13.7955 8 12.911 8 12C8 11.089 8.11158 10.2045 8.3214 9.36216C7.20136 8.95783 6.17601 8.37373 5.28775 7.64585Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.57822 17.8825C8.00228 19.1955 9.9062 19.9993 11.9972 20C11.7563 19.9993 11.5156 19.912 11.3254 19.7382C10.355 18.8513 9.55651 17.7583 8.98542 16.5245C8.09283 16.8486 7.28001 17.3118 6.57822 17.8825Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.0015 20C14.093 19.9996 15.9974 19.1958 17.4218 17.8825C16.72 17.3118 15.9072 16.8486 15.0146 16.5245C14.4435 17.7583 13.645 18.8513 12.6746 19.7382C12.484 19.9124 12.2428 19.9996 12.0015 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7122 16.3541C19.5265 15.1011 20 13.605 20 12C20 10.395 19.5265 8.89894 18.7122 7.64586C17.824 8.37373 16.7986 8.95784 15.6786 9.36216C15.8884 10.2045 16 11.089 16 12C16 12.911 15.8884 13.7955 15.6786 14.6378C16.7986 15.0422 17.824 15.6263 18.7122 16.3541Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 6.43712C12.388 6.89236 12.7296 7.39735 13.0158 7.94297C12.6833 7.98059 12.3443 8.00001 12 8.00001C11.6557 8.00001 11.3167 7.98059 10.9842 7.94297C11.2704 7.39735 11.612 6.89236 12 6.43712Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 12C10 11.2586 10.09 10.5419 10.2581 9.8617C10.8246 9.95268 11.4067 10 12 10C12.5933 10 13.1754 9.95268 13.7419 9.8617C13.91 10.5419 14 11.2586 14 12C14 12.7414 13.91 13.4581 13.7419 14.1383C13.1754 14.0473 12.5933 14 12 14C11.4067 14 10.8246 14.0473 10.2581 14.1383C10.09 13.4581 10 12.7414 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 16C12.3443 16 12.6833 16.0194 13.0158 16.057C12.7296 16.6027 12.388 17.1076 12 17.5629C11.612 17.1076 11.2704 16.6027 10.9842 16.057C11.3167 16.0194 11.6557 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Globe-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["globe","earth","worldwide","international","location","region","shipping","global","network","marketplace","multi-store","language","currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5C18.3843 15.2832 19 13.7135 19 12C19 10.2865 18.3843 8.71677 17.3621 7.5C16.078 5.97153 14.1525 5 12 5C9.84752 5 7.92196 5.97153 6.63789 7.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.6377 7.5C7.92177 9.02847 9.84733 10 11.9998 10C14.1523 10 16.0778 9.02847 17.3619 7.5M6.6377 16.5C7.92177 14.9715 9.84733 14 11.9998 14C14.1523 14 16.0779 14.9715 17.3619 16.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "globe-stand-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["globe","world","location","international","shipping","worldwide","region","countries","mapping","delivery","import","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.01698 5C6.76929 6.27326 6 8.01708 6 9.94057C6 13.8394 9.16061 17 13.0594 17C14.9829 17 16.7267 16.2307 18 14.983"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="13"
                    cy="10"
                    r="4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 17L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "globe-stand-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["globe","world","international","location","region","shipping","country","international-shipping","international-order","language","currency","localization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.01698 5C6.76929 6.27326 6 8.01708 6 9.94057C6 13.8394 9.16061 17 13.0594 17C14.9829 17 16.7267 16.2307 18 14.983"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="13"
                    cy="10"
                    r="4"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 17L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "globe-stand-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","world","international","location","map","shipping","global","countries","region","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.71688 3.28576C9.11134 3.6723 9.11776 4.30544 8.73122 4.6999C7.65927 5.79382 7 7.2892 7 8.94057C7 12.2871 9.7129 15 13.0594 15C14.7108 15 16.2062 14.3407 17.3001 13.2688C17.6946 12.8822 18.3277 12.8887 18.7142 13.2831C19.1008 13.6776 19.0944 14.3107 18.6999 14.6973C17.4574 15.9148 15.8202 16.7342 13.9986 16.9458C13.9995 16.9637 14 16.9818 14 17V19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H11C10.4477 21 10 20.5523 10 20C10 19.4477 10.4477 19 11 19H12V17C12 16.9769 12.0008 16.954 12.0023 16.9313C8.05078 16.4136 5 13.0334 5 8.94057C5 6.74495 5.87931 4.7527 7.30274 3.3001C7.68928 2.90564 8.32241 2.89922 8.71688 3.28576ZM13 4C10.2386 4 8 6.23858 8 9C8 11.7614 10.2386 14 13 14C15.7614 14 18 11.7614 18 9C18 6.23858 15.7614 4 13 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Globe: {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","world","international","location","map","shipping","global","countries","region","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.63789 7.5C5.61568 8.71677 5 10.2865 5 12C5 13.7135 5.61568 15.2832 6.63789 16.5C7.92196 18.0285 9.84752 19 12 19C14.1525 19 16.078 18.0285 17.3621 16.5C18.3843 15.2832 19 13.7135 19 12C19 10.2865 18.3843 8.71677 17.3621 7.5C16.078 5.97153 14.1525 5 12 5C9.84752 5 7.92196 5.97153 6.63789 7.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C10.1658 6.6763 9 9.19004 9 12C9 14.81 10.1658 17.3237 12 19C13.8342 17.3237 15 14.81 15 12C15 9.19004 13.8342 6.6763 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M5 12H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Google-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["g","google","alphabet","letter","payment-method","guest"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5556 4.83157C14.4845 4.29929 13.2772 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "globe-stand": {
        defaultColors: ["#3D4C66"],
        keywords: ["globe","world","location","international","store-location","customer-location","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.01698 5C6.76929 6.27326 6 8.01708 6 9.94057C6 13.8394 9.16061 17 13.0594 17C14.9829 17 16.7267 16.2307 18 14.983"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="13"
                    cy="10"
                    r="4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 17L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Google-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["G","google","account","profile","settings","guest"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5556 4.83157C14.4845 4.29929 13.2772 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12H12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Google-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["google","g","payment","profile","account","settings","google-pay","wallet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.5265 19 18.4439 16.3923 18.9291 13H12C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11H20C20.5523 11 21 11.4477 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C13.435 3 14.7943 3.3366 16.0006 3.93606C16.4952 4.18184 16.6969 4.78203 16.4511 5.27661C16.2053 5.77118 15.6051 5.97287 15.1105 5.72709C14.1746 5.26199 13.1193 5 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "google-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["google","plus","add","new","social","network","share","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 7C7.23858 7 5 9.23858 5 12C5 14.7614 7.23858 17 10 17C12.7614 17 15 14.7614 15 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 9H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 11L17 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "google-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["google","plus","add","social","network","account","new","addition","enhanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8C7.79086 8 6 9.79086 6 12C6 14.2091 7.79086 16 10 16C11.8638 16 13.4299 14.7252 13.874 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H15C15.5523 11 16 11.4477 16 12C16 15.3137 13.3137 18 10 18C6.68629 18 4 15.3137 4 12C4 8.68629 6.68629 6 10 6C10.5523 6 11 6.44772 11 7C11 7.55228 10.5523 8 10 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 9C14 8.44772 14.4477 8 15 8H16V7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H18V11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11V10H15C14.4477 10 14 9.55228 14 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "google-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["G","plus","add","social","google","add-user","profile","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 7C7.23858 7 5 9.23858 5 12C5 14.7614 7.23858 17 10 17C12.7614 17 15 14.7614 15 12H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 11L17 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Google: {
        defaultColors: ["#3D4C66"],
        keywords: ["G","plus","add","social","google","add-user","profile","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5556 4.83157C14.4845 4.29929 13.2772 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "google-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["google","plus","add","social","network","google-plus","add-customer","new-customer","social-media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 7C7.23858 7 5 9.23858 5 12C5 14.7614 7.23858 17 10 17C12.7614 17 15 14.7614 15 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 11L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "graduation-cap-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graduation","cap","mortarboard","education","employee-training","certification","rewards","loyalty-program","milestone","achievement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10V14.346C7 14.531 7 14.6234 7.00723 14.7082C7.0648 15.3837 7.46067 15.9841 8.05888 16.3031C8.13396 16.3431 8.21896 16.3796 8.38897 16.4524V16.4524C8.84022 16.6458 9.06585 16.7425 9.28816 16.8226C11.0409 17.4541 12.9591 17.4541 14.7118 16.8226C14.9342 16.7425 15.1598 16.6458 15.611 16.4524V16.4524C15.781 16.3796 15.866 16.3431 15.9411 16.3031C16.5393 15.9841 16.9352 15.3837 16.9928 14.7082C17 14.6234 17 14.531 17 14.346V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.75 9C5.75 8.58579 5.41421 8.25 5 8.25C4.58579 8.25 4.25 8.58579 4.25 9L5.75 9ZM4.25 11C4.25 11.4142 4.58579 11.75 5 11.75C5.41421 11.75 5.75 11.4142 5.75 11L4.25 11ZM5.75 11L5.75 9L4.25 9L4.25 11L5.75 11Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M6.49688 9.93633L6.23354 10.6386L6.49688 9.93633ZM4.924 9H5.674H4.924ZM12.7022 11.7367L12.4389 11.0344L12.7022 11.7367ZM11.2978 11.7367L11.0344 12.4389L11.2978 11.7367ZM12 11.932V11.182V11.932ZM19.076 9H19.826H19.076ZM12.7022 6.26334L12.4389 6.96559L12.7022 6.26334ZM11.2978 6.26334L11.0344 5.5611L11.2978 6.26334ZM12.4389 6.96559L17.2398 8.76592L17.7665 7.36142L12.9656 5.5611L12.4389 6.96559ZM17.2398 9.23408L12.4389 11.0344L12.9656 12.4389L17.7665 10.6386L17.2398 9.23408ZM11.0344 5.5611L6.23353 7.36142L6.76022 8.76592L11.5611 6.96559L11.0344 5.5611ZM6.23354 10.6386L11.0344 12.4389L11.5611 11.0344L6.76022 9.23408L6.23354 10.6386ZM6.23353 7.36142C5.73237 7.54936 5.27935 7.71737 4.96074 7.88949C4.68291 8.03958 4.174 8.36507 4.174 9H5.674C5.674 9.12883 5.61643 9.22354 5.58143 9.2627C5.56276 9.28358 5.5738 9.26319 5.6737 9.20922C5.87938 9.09811 6.2128 8.9712 6.76022 8.76592L6.23353 7.36142ZM6.76022 9.23408C6.2128 9.0288 5.87938 8.90189 5.6737 8.79078C5.5738 8.73681 5.56276 8.71642 5.58143 8.7373C5.61643 8.77646 5.674 8.87117 5.674 9H4.174C4.174 9.63492 4.68291 9.96042 4.96074 10.1105C5.27935 10.2826 5.73237 10.4506 6.23354 10.6386L6.76022 9.23408ZM12.4389 11.0344C12.2559 11.1031 12.1538 11.1409 12.0751 11.1643C12.0401 11.1747 12.0203 11.1789 12.01 11.1807C12.005 11.1815 12.0023 11.1818 12.0013 11.1819C12.0003 11.182 12 11.182 12 11.182V12.682C12.3488 12.682 12.6698 12.5498 12.9656 12.4389L12.4389 11.0344ZM11.0344 12.4389C11.3302 12.5498 11.6512 12.682 12 12.682V11.182C12 11.182 11.9997 11.182 11.9987 11.1819C11.9977 11.1818 11.995 11.1815 11.99 11.1807C11.9797 11.1789 11.9599 11.1747 11.9249 11.1643C11.8462 11.1409 11.7441 11.1031 11.5611 11.0344L11.0344 12.4389ZM17.2398 8.76592C17.7872 8.9712 18.1206 9.09811 18.3263 9.20922C18.4262 9.26319 18.4372 9.28358 18.4186 9.2627C18.3836 9.22354 18.326 9.12883 18.326 9H19.826C19.826 8.36507 19.3171 8.03958 19.0393 7.88949C18.7207 7.71737 18.2676 7.54936 17.7665 7.36142L17.2398 8.76592ZM17.7665 10.6386C18.2676 10.4506 18.7207 10.2826 19.0393 10.1105C19.3171 9.96042 19.826 9.63492 19.826 9H18.326C18.326 8.87117 18.3836 8.77646 18.4186 8.7373C18.4372 8.71642 18.4262 8.73681 18.3263 8.79078C18.1206 8.90189 17.7872 9.0288 17.2398 9.23408L17.7665 10.6386ZM12.9656 5.5611C12.6698 5.45016 12.3488 5.318 12 5.318V6.818C12 6.818 12.0003 6.81799 12.0013 6.81808C12.0023 6.81817 12.005 6.81845 12.01 6.8193C12.0203 6.82109 12.0401 6.82532 12.0751 6.83573C12.1538 6.85912 12.2559 6.89695 12.4389 6.96559L12.9656 5.5611ZM11.5611 6.96559C11.7441 6.89695 11.8462 6.85912 11.9249 6.83573C11.9599 6.82532 11.9797 6.82109 11.99 6.8193C11.995 6.81845 11.9977 6.81817 11.9987 6.81808C11.9997 6.81799 12 6.818 12 6.818V5.318C11.6512 5.318 11.3302 5.45016 11.0344 5.5611L11.5611 6.96559Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "graduation-cap-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graduation","cap","mortarboard","education","certification","loyalty program","rewards","customer tier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C11.6327 5 11.2942 5.13195 11.0278 5.23583L6.14052 7.11818C5.67365 7.29788 5.22975 7.46873 4.90928 7.64652C4.62888 7.80209 4 8.19754 4 9V11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11L6.00001 10.8277L6.00001 14.3783C5.99995 14.5313 5.99991 14.6647 6.01085 14.7931C6.09722 15.8064 6.69102 16.7069 7.58834 17.1855C7.70203 17.2461 7.82476 17.2986 7.96541 17.3589L8.02679 17.3852C8.44794 17.5657 8.69884 17.6732 8.9492 17.7634C10.921 18.4739 13.079 18.4739 15.0508 17.7634C15.3012 17.6732 15.5521 17.5657 15.9732 17.3852L16.0347 17.3588C16.1753 17.2986 16.298 17.2461 16.4117 17.1855C17.309 16.7069 17.9028 15.8064 17.9892 14.7931C18.0001 14.6648 18.0001 14.5313 18 14.3783L18 10.8277C18.4147 10.6676 18.8026 10.5133 19.0907 10.3535C19.3711 10.1979 20 9.80246 20 9C20 8.19754 19.3711 7.80209 19.0907 7.64652C18.7703 7.46873 18.3264 7.29788 17.8595 7.11819L12.9722 5.23583C12.7058 5.13195 12.3673 5 12 5ZM12.9722 12.7642L16 11.5979V14.346C16 14.5493 15.9991 14.5911 15.9964 14.6233C15.9676 14.961 15.7697 15.2612 15.4706 15.4207C15.442 15.4359 15.404 15.4532 15.2171 15.5333C14.755 15.7313 14.5609 15.8141 14.3729 15.8818C12.8392 16.4344 11.1608 16.4344 9.62716 15.8818C9.43911 15.8141 9.245 15.7313 8.78291 15.5333C8.59608 15.4532 8.55798 15.4359 8.52946 15.4207C8.23035 15.2612 8.03242 14.961 8.00363 14.6233C8.00088 14.5911 8.00001 14.5493 8.00001 14.346V11.5979L11.0278 12.7642C11.2942 12.868 11.6327 13 12 13C12.3673 13 12.7058 12.868 12.9722 12.7642Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "graduation-cap-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["graduation","education","student","academic","scholarship","rewards","loyalty-program","achievement","milestone","certification","training"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10V14.346C7 14.531 7 14.6234 7.00723 14.7082C7.0648 15.3837 7.46067 15.9841 8.05888 16.3031C8.13396 16.3431 8.21896 16.3796 8.38897 16.4524C8.84022 16.6458 9.06585 16.7425 9.28816 16.8226C11.0409 17.4541 12.9591 17.4541 14.7118 16.8226C14.9342 16.7425 15.1598 16.6458 15.611 16.4524C15.781 16.3796 15.866 16.3431 15.9411 16.3031C16.5393 15.9841 16.9352 15.3837 16.9928 14.7082C17 14.6234 17 14.531 17 14.346V10H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.75 9C5.75 8.58579 5.41421 8.25 5 8.25C4.58579 8.25 4.25 8.58579 4.25 9L5.75 9ZM4.25 11C4.25 11.4142 4.58579 11.75 5 11.75C5.41421 11.75 5.75 11.4142 5.75 11L4.25 11ZM5.75 11L5.75 9L4.25 9L4.25 11L5.75 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.5031 8.06367L12.7022 6.26334C12.355 6.13311 12.1813 6.068 12 6.068C11.8187 6.068 11.645 6.13311 11.2978 6.26334L6.49688 8.06367C5.44829 8.45689 4.924 8.6535 4.924 9C4.924 9.3465 5.44829 9.54311 6.49688 9.93633L11.2978 11.7367C11.645 11.8669 11.8187 11.932 12 11.932C12.1813 11.932 12.355 11.8669 12.7022 11.7367L17.5031 9.93633C18.5517 9.54311 19.076 9.3465 19.076 9C19.076 8.6535 18.5517 8.45689 17.5031 8.06367Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12.7022 6.26334L12.4389 6.96559V6.96559L12.7022 6.26334ZM17.5031 8.06367L17.7665 7.36142L17.5031 8.06367ZM17.5031 9.93633L17.7665 10.6386L17.5031 9.93633ZM12.7022 11.7367L12.9656 12.4389L12.7022 11.7367ZM11.2978 6.26334L11.5611 6.96559L11.5611 6.96559L11.2978 6.26334ZM6.49688 8.06367L6.76022 8.76592L6.49688 8.06367ZM6.49688 9.93633L6.23354 10.6386L6.49688 9.93633ZM11.2978 11.7367L11.0344 12.4389L11.2978 11.7367ZM12.4389 6.96559L17.2398 8.76592L17.7665 7.36142L12.9656 5.5611L12.4389 6.96559ZM17.2398 9.23408L12.4389 11.0344L12.9656 12.4389L17.7665 10.6386L17.2398 9.23408ZM11.0344 5.5611L6.23353 7.36142L6.76022 8.76592L11.5611 6.96559L11.0344 5.5611ZM6.23354 10.6386L11.0344 12.4389L11.5611 11.0344L6.76022 9.23408L6.23354 10.6386ZM6.23353 7.36142C5.73237 7.54936 5.27935 7.71737 4.96074 7.88949C4.68291 8.03958 4.174 8.36507 4.174 9H5.674C5.674 9.12883 5.61643 9.22354 5.58143 9.2627C5.56276 9.28358 5.5738 9.26319 5.6737 9.20922C5.87938 9.09811 6.2128 8.9712 6.76022 8.76592L6.23353 7.36142ZM6.76022 9.23408C6.2128 9.0288 5.87938 8.90189 5.6737 8.79078C5.5738 8.73681 5.56276 8.71642 5.58143 8.7373C5.61643 8.77646 5.674 8.87117 5.674 9H4.174C4.174 9.63492 4.68291 9.96042 4.96074 10.1105C5.27935 10.2826 5.73237 10.4506 6.23354 10.6386L6.76022 9.23408ZM12.4389 11.0344C12.2559 11.1031 12.1538 11.1409 12.0751 11.1643C12.0401 11.1747 12.0203 11.1789 12.01 11.1807C12.005 11.1815 12.0023 11.1818 12.0013 11.1819C12.0003 11.182 12 11.182 12 11.182V12.682C12.3488 12.682 12.6698 12.5498 12.9656 12.4389L12.4389 11.0344ZM11.0344 12.4389C11.3302 12.5498 11.6512 12.682 12 12.682V11.182C12 11.182 11.9997 11.182 11.9987 11.1819C11.9977 11.1818 11.995 11.1815 11.99 11.1807C11.9797 11.1789 11.9599 11.1747 11.9249 11.1643C11.8462 11.1409 11.7441 11.1031 11.5611 11.0344L11.0344 12.4389ZM17.2398 8.76592C17.7872 8.9712 18.1206 9.09811 18.3263 9.20922C18.4262 9.26319 18.4372 9.28358 18.4186 9.2627C18.3836 9.22354 18.326 9.12883 18.326 9H19.826C19.826 8.36507 19.3171 8.03958 19.0393 7.88949C18.7207 7.71737 18.2676 7.54936 17.7665 7.36142L17.2398 8.76592ZM17.7665 10.6386C18.2676 10.4506 18.7207 10.2826 19.0393 10.1105C19.3171 9.96042 19.826 9.63492 19.826 9H18.326C18.326 8.87117 18.3836 8.77646 18.4186 8.7373C18.4372 8.71642 18.4262 8.73681 18.3263 8.79078C18.1206 8.90189 17.7872 9.0288 17.2398 9.23408L17.7665 10.6386ZM12.9656 5.5611C12.6698 5.45016 12.3488 5.318 12 5.318V6.818C12 6.818 12.0003 6.81799 12.0013 6.81808C12.0023 6.81817 12.005 6.81845 12.01 6.8193C12.0203 6.82109 12.0401 6.82532 12.0751 6.83573C12.1538 6.85912 12.2559 6.89695 12.4389 6.96559L12.9656 5.5611ZM11.5611 6.96559C11.7441 6.89695 11.8462 6.85912 11.9249 6.83573C11.9599 6.82532 11.9797 6.82109 11.99 6.8193C11.995 6.81845 11.9977 6.81817 11.9987 6.81808C11.9997 6.81799 12 6.818 12 6.818V5.318C11.6512 5.318 11.3302 5.45016 11.0344 5.5611L11.5611 6.96559Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "graduation-cap": {
        defaultColors: ["#3D4C66"],
        keywords: ["graduation","cap","mortarboard","education","certificate","achievement","rewards","loyalty program","milestone","customer tier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10V14.346C7 14.531 7 14.6234 7.00723 14.7082C7.0648 15.3837 7.46067 15.9841 8.05888 16.3031C8.13396 16.3431 8.21896 16.3796 8.38897 16.4524V16.4524C8.84022 16.6458 9.06585 16.7425 9.28816 16.8226C11.0409 17.4541 12.9591 17.4541 14.7118 16.8226C14.9342 16.7425 15.1598 16.6458 15.611 16.4524V16.4524C15.781 16.3796 15.866 16.3431 15.9411 16.3031C16.5393 15.9841 16.9352 15.3837 16.9928 14.7082C17 14.6234 17 14.531 17 14.346V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5.75 9C5.75 8.58579 5.41421 8.25 5 8.25C4.58579 8.25 4.25 8.58579 4.25 9L5.75 9ZM4.25 11C4.25 11.4142 4.58579 11.75 5 11.75C5.41421 11.75 5.75 11.4142 5.75 11L4.25 11ZM5.75 11L5.75 9L4.25 9L4.25 11L5.75 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.49688 9.93633L6.23354 10.6386L6.49688 9.93633ZM4.924 9H5.674H4.924ZM12.7022 11.7367L12.4389 11.0344L12.7022 11.7367ZM11.2978 11.7367L11.0344 12.4389L11.2978 11.7367ZM12 11.932V11.182V11.932ZM19.076 9H19.826H19.076ZM12.7022 6.26334L12.4389 6.96559L12.7022 6.26334ZM11.2978 6.26334L11.0344 5.5611L11.2978 6.26334ZM12.4389 6.96559L17.2398 8.76592L17.7665 7.36142L12.9656 5.5611L12.4389 6.96559ZM17.2398 9.23408L12.4389 11.0344L12.9656 12.4389L17.7665 10.6386L17.2398 9.23408ZM11.0344 5.5611L6.23353 7.36142L6.76022 8.76592L11.5611 6.96559L11.0344 5.5611ZM6.23354 10.6386L11.0344 12.4389L11.5611 11.0344L6.76022 9.23408L6.23354 10.6386ZM6.23353 7.36142C5.73237 7.54936 5.27935 7.71737 4.96074 7.88949C4.68291 8.03958 4.174 8.36507 4.174 9H5.674C5.674 9.12883 5.61643 9.22354 5.58143 9.2627C5.56276 9.28358 5.5738 9.26319 5.6737 9.20922C5.87938 9.09811 6.2128 8.9712 6.76022 8.76592L6.23353 7.36142ZM6.76022 9.23408C6.2128 9.0288 5.87938 8.90189 5.6737 8.79078C5.5738 8.73681 5.56276 8.71642 5.58143 8.7373C5.61643 8.77646 5.674 8.87117 5.674 9H4.174C4.174 9.63492 4.68291 9.96042 4.96074 10.1105C5.27935 10.2826 5.73237 10.4506 6.23354 10.6386L6.76022 9.23408ZM12.4389 11.0344C12.2559 11.1031 12.1538 11.1409 12.0751 11.1643C12.0401 11.1747 12.0203 11.1789 12.01 11.1807C12.005 11.1815 12.0023 11.1818 12.0013 11.1819C12.0003 11.182 12 11.182 12 11.182V12.682C12.3488 12.682 12.6698 12.5498 12.9656 12.4389L12.4389 11.0344ZM11.0344 12.4389C11.3302 12.5498 11.6512 12.682 12 12.682V11.182C12 11.182 11.9997 11.182 11.9987 11.1819C11.9977 11.1818 11.995 11.1815 11.99 11.1807C11.9797 11.1789 11.9599 11.1747 11.9249 11.1643C11.8462 11.1409 11.7441 11.1031 11.5611 11.0344L11.0344 12.4389ZM17.2398 8.76592C17.7872 8.9712 18.1206 9.09811 18.3263 9.20922C18.4262 9.26319 18.4372 9.28358 18.4186 9.2627C18.3836 9.22354 18.326 9.12883 18.326 9H19.826C19.826 8.36507 19.3171 8.03958 19.0393 7.88949C18.7207 7.71737 18.2676 7.54936 17.7665 7.36142L17.2398 8.76592ZM17.7665 10.6386C18.2676 10.4506 18.7207 10.2826 19.0393 10.1105C19.3171 9.96042 19.826 9.63492 19.826 9H18.326C18.326 8.87117 18.3836 8.77646 18.4186 8.7373C18.4372 8.71642 18.4262 8.73681 18.3263 8.79078C18.1206 8.90189 17.7872 9.0288 17.2398 9.23408L17.7665 10.6386ZM12.9656 5.5611C12.6698 5.45016 12.3488 5.318 12 5.318V6.818C12 6.818 12.0003 6.81799 12.0013 6.81808C12.0023 6.81817 12.005 6.81845 12.01 6.8193C12.0203 6.82109 12.0401 6.82532 12.0751 6.83573C12.1538 6.85912 12.2559 6.89695 12.4389 6.96559L12.9656 5.5611ZM11.5611 6.96559C11.7441 6.89695 11.8462 6.85912 11.9249 6.83573C11.9599 6.82532 11.9797 6.82109 11.99 6.8193C11.995 6.81845 11.9977 6.81817 11.9987 6.81808C11.9997 6.81799 12 6.818 12 6.818V5.318C11.6512 5.318 11.3302 5.45016 11.0344 5.5611L11.5611 6.96559Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph up-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","chart","growth","sales","analytics","increase","trending","performance","statistics","data","metrics","rising","progress","profit","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7H18M18 7V10M18 7L13 13L10.9551 11.0449L8 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph up-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","arrow-up","trend","sales","report","growth","statistics","analytics","performance","increase","chart","diagram"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7H18M18 7V10M18 7L13 13L10.9551 11.0449L8 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-bar-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","bar chart","sales","statistics","analytics","performance","metrics","report","dashboard","sales-report","revenue","trends","growth","chart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 15V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 15V9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","chart","increase","growth","sales","performance","analytics","trending","statistics","metrics","report","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 7C14 6.44772 14.4477 6 15 6H18C18.5523 6 19 6.44772 19 7V10C19 10.5523 18.5523 11 18 11C17.4477 11 17 10.5523 17 10V9.76205L13.7682 13.6402C13.5909 13.853 13.3331 13.9827 13.0565 13.9984C12.7799 14.0141 12.5092 13.9143 12.309 13.7228L10.9708 12.4434L8.70711 14.7071C8.31659 15.0976 7.68342 15.0976 7.2929 14.7071C6.90237 14.3166 6.90237 13.6834 7.2929 13.2929L10.2479 10.3378C10.6323 9.95351 11.2532 9.94653 11.6461 10.3221L12.9172 11.5373L15.865 8H15C14.4477 8 14 7.55228 14 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph up": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","growth","chart","sales","increase","trending","statistics","performance","analytics","report","metrics","profit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7H18M18 7V10M18 7L13 13L10.9551 11.0449L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-bar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","bar chart","sales","statistics","analytics","reports","performance","trends","data","metrics","summary","charts","visualizations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 15V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Graph-bar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","bar chart","statistics","analytics","sales data","trends","performance","reports","charts","metrics","visualization","data analysis","pos reports","sales trends","financial data","business intelligence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 10C9.55229 10 10 10.4477 10 11V15C10 15.5523 9.55229 16 9 16C8.44772 16 8 15.5523 8 15V11C8 10.4477 8.44772 10 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8C12.5523 8 13 8.44772 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.44772 11.4477 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 10C15.5523 10 16 10.4477 16 11V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V11C14 10.4477 14.4477 10 15 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 10C18.5523 10 19 10.4477 19 11V15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15V11C17 10.4477 17.4477 10 18 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph-bar-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","chart","statistics","sales","performance","analysis","data","report","trend","growth","metrics","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-bar-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","bar-chart","statistics","sales","analytics","report","trends","performance","data","growth","metrics","visualization","summary","dashboard","insights","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L9 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph-bar-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","chart","bar-chart","statistics","sales","analytics","reports","performance","metrics","data","trends","growth","dashboard","insights","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-bar-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","bar graph","sales","analytics","statistics","reports","performance","metrics","charts","trends","data","growth","analysis","financial","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 16C11.4477 16 11 15.5523 11 15L11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V15C13 15.5523 12.5523 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 16C8.44772 16 8 15.5523 8 15V11C8 10.4477 8.44772 10 9 10C9.55229 10 10 10.4477 10 11V15C10 15.5523 9.55229 16 9 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 16C14.4477 16 14 15.5523 14 15V11C14 10.4477 14.4477 10 15 10C15.5523 10 16 10.4477 16 11V15C16 15.5523 15.5523 16 15 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph-bar": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","bar-chart","statistics","analytics","sales","report","growth","trend","data","chart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 15V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Graph-fall-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","statistics","sales","revenue","analytics","performance","chart","decrease","trends","reporting","insights","metrics","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.57494 12C9.12722 12 9.57494 12.4477 9.57494 13V15C9.57494 15.5523 9.12722 16 8.57494 16C8.02265 16 7.57494 15.5523 7.57494 15V13C7.57494 12.4477 8.02265 12 8.57494 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5749 7C15.1272 7 15.5749 7.44772 15.5749 8V10C15.5749 10.5523 15.1272 11 14.5749 11C14.0227 11 13.5749 10.5523 13.5749 10V8C13.5749 7.44772 14.0227 7 14.5749 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5749 6C18.1272 6 18.5749 6.44772 18.5749 7V15C18.5749 15.5523 18.1272 16 17.5749 16C17.0227 16 16.5749 15.5523 16.5749 15V7C16.5749 6.44772 17.0227 6 17.5749 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5749 10C12.1272 10 12.5749 10.4477 12.5749 11V13C12.5749 13.5523 12.1272 14 11.5749 14C11.0227 14 10.5749 13.5523 10.5749 13V11C10.5749 10.4477 11.0227 10 11.5749 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph-fall-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","chart","sales","report","analytics","statistics","trends","data","growth","performance","metrics","dashboard","insights","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 15V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Graph-fall": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","statistics","sales","analytics","performance","reports","trends","decrease","loss","revenue","metrics","charts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 15V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Graph-fall-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["graph","chart","sales","report","statistics","analytics","trends","growth","data","performance","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 15V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 15V7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 13V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Graph-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","sales","statistics","reports","chart","analysis","dashboard","metrics","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","chart","statistics","report","sales","inventory","analysis","dashboard","performance","metrics","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","report","statistics","sales","analysis","dashboard","data","metrics","performance","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H9C8.44772 10 8 9.55228 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C8 14.4477 8.44772 14 9 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H9C8.44772 16 8 15.5523 8 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph-mountain-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","mountain","chart","analytics","sales-data","statistics","trends","reporting","performance","growth","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","report","analytics","sales","statistics","dashboard","summary","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-mountain-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sales-chart","trend","sales-trend","statistics","sales-statistics","graph","mountain","sales-mountain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778C13.4731 10.2015 14.8505 10.1851 15.2819 11.1514L16.2073 13.2245C16.5798 14.0588 15.9692 15 15.0556 15H11.2857H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph-mountain-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","mountain","chart","report","analytics","trends","sales-data","performance","statistics","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.9213 10.5076C12.4788 9.97958 11.6472 9.99081 11.2199 10.5306C11.2199 10.5306 11.217 10.5342 11.211 10.543C11.2049 10.5518 11.1964 10.5648 11.1852 10.5831C11.162 10.6208 11.1319 10.6736 11.0915 10.749C11.0088 10.9035 10.9048 11.1118 10.7526 11.417L10.6484 11.6259C10.2933 12.3382 10.2174 12.5098 10.1973 12.6022C10.0758 13.1606 10.43 13.7124 10.9982 13.85C11.0922 13.8728 11.2837 13.8813 12.0961 13.8813H14.7492L13.4136 11.381C13.2528 11.0801 13.1429 10.8747 13.0558 10.7224C13.0133 10.6481 12.9817 10.5963 12.9575 10.5592C12.9457 10.5412 12.9368 10.5284 12.9305 10.5198C12.9243 10.5111 12.9213 10.5076 12.9213 10.5076ZM16.5402 15.9998H12.0961C12.0488 15.9998 12.0021 15.9999 11.956 15.9999C11.3618 16.0005 10.8659 16.0009 10.4742 15.9061C8.76968 15.4932 7.70715 13.8378 8.07151 12.1627C8.15523 11.7778 8.37244 11.3433 8.63274 10.8225C8.65293 10.7821 8.67339 10.7412 8.69406 10.6997L8.79825 10.4908C8.81807 10.451 8.83758 10.4118 8.8568 10.3732C9.09676 9.89097 9.29233 9.49794 9.49966 9.23608C10.7818 7.61672 13.2765 7.58303 14.6041 9.16715C14.6202 9.18643 14.6364 9.20645 14.6524 9.2272C15.772 8.77468 17.2012 9.17179 17.7783 10.432L18.7838 12.6279C19.5093 14.2124 18.32 15.9998 16.5402 15.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph_down-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","down","decrease","sales","loss","decline","report","analytics","performance","negative","trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 15H18M18 15V12M18 15L13 9L10.9551 10.9551L8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Graph_down-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","down","decrease","decline","sales","report","loss","negative","statistics","analytics","trend","decrease-sales","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15H18M18 15V12M18 15L13 9L10.9551 10.9551L8 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Graph_down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","down","trend","sales","decrease","loss","report","analytics","performance","decline","metrics","chart","negative","drop","revenue","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55229 4 6 4.44772 6 5V13C6 14.4425 6.00213 15.4237 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84143 17.8991C8.57625 17.9979 9.55752 18 11 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L10.9294 20C9.57531 20 8.4587 20.0001 7.57494 19.8812C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706L4 5C4 4.44772 4.44772 4 5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 15C14 15.5523 14.4477 16 15 16H18C18.5523 16 19 15.5523 19 15V12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12V12.238L13.7682 8.35982C13.5909 8.14698 13.3331 8.01726 13.0565 8.0016C12.7799 7.98594 12.5092 8.08573 12.309 8.27718L10.9708 9.55655L8.70711 7.29289C8.31659 6.90237 7.68342 6.90237 7.2929 7.29289C6.90237 7.68342 6.90237 8.31658 7.2929 8.70711L10.2479 11.6622C10.6323 12.0465 11.2532 12.0535 11.6461 11.6779L12.9172 10.4627L15.865 14H15C14.4477 14 14 14.4477 14 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Graph-mountain": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","mountain","statistics","data","trends","analysis","reports","sales-data","performance","charts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.0556 15H10.9653C10.2893 15 9.95128 15 9.71378 14.941C8.6679 14.6811 8.01596 13.6393 8.23951 12.5851C8.29028 12.3457 8.43806 12.0417 8.73361 11.4337L8.8295 11.2365C9.10427 10.6712 9.24165 10.3886 9.36729 10.2258C10.154 9.20668 11.6846 9.18548 12.4992 10.1825C12.6293 10.3417 12.7745 10.6204 13.0648 11.1778V11.1778M15.0556 15H11.2857M15.0556 15V15C15.9692 15 16.5798 14.0588 16.2073 13.2245L15.2819 11.1514C14.8505 10.1851 13.4731 10.2015 13.0648 11.1778V11.1778M15.0556 15L13.0648 11.1778"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "grid-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["grid","table","layout","view","categories","matrix","menu","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 16L19 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 8L19 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Graph_down: {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","table","layout","view","categories","matrix","menu","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15H18M18 15V12M18 15L13 9L10.9551 10.9551L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "grid-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["grid","layout","table","menu","categories","inventory","products","matrix","display","arrange","items","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 16L19 16" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L19 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 8L19 8" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "grid-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","matrix","layout","categories","menu","sections","grouping","arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55228 4 9 4.44772 9 5V7H11V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V7H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H17V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H17V15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H17V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V17H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V17H9V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H7V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H7V9H5C4.44772 9 4 8.55229 4 8C4 7.44772 4.44772 7 5 7H7V5C7 4.44772 7.44772 4 8 4ZM9 9V11H11V9H9ZM13 9V11H15V9H13ZM15 13H13V15H15V13ZM11 15V13H9V15H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    grid: {
        defaultColors: ["#3D4C66"],
        keywords: ["grid","matrix","layout","categories","menu","sections","grouping","arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 16L19 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "group-meeting-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["group","meeting","collaboration","team","staff","employees","customer","loyalty","program","circle","network","connections","sales","representatives","management","teamwork"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="6"
                    r="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="18"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="18"
                    r="2"
                    transform="rotate(180 12 18)"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="6"
                    cy="12"
                    r="2"
                    transform="rotate(180 6 12)"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 4.99951L8 7.99951M16 15.9995L19 18.9995"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L8 16M19 5L16 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "group-meeting-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["group","people","meeting","team","collaboration","users","staff","employees","circle","network","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" transform="rotate(180 12 18)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="12" r="2" transform="rotate(180 6 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 4.99951L8 7.99951M16 15.9995L19 18.9995"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L8 16M19 5L16 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "group-meeting": {
        defaultColors: ["#3D4C66"],
        keywords: ["team","group","collaborate","network","staff","employees","connections","shared","circle","people"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" transform="rotate(180 12 18)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="12" r="2" transform="rotate(180 6 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 4.99951L8 7.99951M16 15.9995L19 18.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L8 16M19 5L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Grow-Graph-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["graph","growth","sales","statistics","analytics","trend","chart","performance","report","metrics","data","increase","progress","analysis","dashboard","insights","business","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L8.32966 7.25275C8.59586 7.05311 8.72896 6.95328 8.85704 6.88365C9.54205 6.51123 10.381 6.57085 11.0065 7.0364C11.1235 7.12345 11.2411 7.2411 11.4764 7.47638V7.47638C11.7185 7.71851 11.8396 7.83957 11.9594 7.92815C12.6008 8.40243 13.4627 8.45017 14.1526 8.04962C14.2815 7.97481 14.4152 7.86786 14.6826 7.65396L18 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 19V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 19V11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18.8V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18.8V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Grow-Graph-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["graph","chart","analytics","growth","trend","sales","performance","metrics","statistics","data","reporting","sales-report","financial-data","sales-analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L8.32966 7.25275C8.59586 7.05311 8.72896 6.95328 8.85704 6.88365C9.54205 6.51123 10.381 6.57085 11.0065 7.0364C11.1235 7.12345 11.2411 7.2411 11.4764 7.47638V7.47638C11.7185 7.71851 11.8396 7.83957 11.9594 7.92815C12.6008 8.40243 13.4627 8.45017 14.1526 8.04962C14.2815 7.97481 14.4152 7.86786 14.6826 7.65396L18 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 19V11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 19V11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18.8V14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18.8V14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "group-meeting-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["group","team","meeting","collaboration","staff","employees","users","roles","permissions","team-management","staff-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 12C21 13.6569 19.6569 15 18 15C16.3431 15 15 13.6569 15 12C15 10.3431 16.3431 9 18 9C19.6569 9 21 10.3431 21 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 16.3431 10.3431 15 12 15C13.6569 15 15 16.3431 15 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.2929 4.29221C4.68342 3.90169 5.31659 3.90169 5.70711 4.29221L8.70711 7.29221C9.09764 7.68274 9.09764 8.3159 8.70711 8.70643C8.31659 9.09695 7.68342 9.09695 7.2929 8.70643L4.2929 5.70643C3.90238 5.3159 3.90238 4.68274 4.2929 4.29221ZM15.2929 15.2922C15.6834 14.9017 16.3166 14.9017 16.7071 15.2922L19.7071 18.2922C20.0976 18.6827 20.0976 19.3159 19.7071 19.7064C19.3166 20.097 18.6834 20.097 18.2929 19.7064L15.2929 16.7064C14.9024 16.3159 14.9024 15.6827 15.2929 15.2922Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L7.29289 15.2929C7.68342 14.9024 8.31658 14.9024 8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071ZM15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Grow-Graph": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","analytics","sales","growth","increase","statistics","data","report","chart","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L8.32966 7.25275C8.59586 7.05311 8.72896 6.95328 8.85704 6.88365C9.54205 6.51123 10.381 6.57085 11.0065 7.0364C11.1235 7.12345 11.2411 7.2411 11.4764 7.47638V7.47638C11.7185 7.71851 11.8396 7.83957 11.9594 7.92815C12.6008 8.40243 13.4627 8.45017 14.1526 8.04962C14.2815 7.97481 14.4152 7.86786 14.6826 7.65396L18 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 19V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 19V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18.8V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18.8V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Grow-Graph-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","chart","sales","analytics","statistics","growth","trend","performance","revenue","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7809 4.37534C19.1259 4.8066 19.056 5.4359 18.6248 5.78091L15.3073 8.43486C15.2912 8.44773 15.2753 8.46047 15.2596 8.47309C15.0399 8.64901 14.8501 8.8011 14.6548 8.91447C13.62 9.51529 12.327 9.44368 11.3649 8.73225C11.1833 8.59802 11.0114 8.42589 10.8126 8.2268C10.7983 8.21251 10.7839 8.19809 10.7693 8.18353C10.5102 7.92435 10.4535 7.87137 10.4095 7.83862C10.0967 7.60584 9.67725 7.57603 9.33474 7.76224C9.28654 7.78844 9.22295 7.83287 8.92972 8.05279L6.60006 9.80004C6.15823 10.1314 5.53143 10.0419 5.20006 9.60004C4.86869 9.15821 4.95823 8.53141 5.40006 8.20004L7.72972 6.45279C7.74568 6.44082 7.76148 6.42895 7.77713 6.4172C7.99595 6.25288 8.18537 6.11065 8.37946 6.00513C9.40697 5.4465 10.6655 5.53594 11.6037 6.23427C11.7809 6.36617 11.9483 6.53377 12.1416 6.72738C12.1555 6.74123 12.1694 6.7552 12.1835 6.76931C12.4503 7.03609 12.5089 7.09082 12.554 7.12411C12.8747 7.36125 13.3056 7.38512 13.6506 7.18485C13.699 7.15674 13.7633 7.10881 14.0579 6.87313L17.3754 4.21917C17.8066 3.87416 18.4359 3.94408 18.7809 4.37534Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.0001 10C18.5523 10 19.0001 10.4478 19.0001 11V19C19.0001 19.5523 18.5523 20 18.0001 20C17.4478 20 17.0001 19.5523 17.0001 19V11C17.0001 10.4478 17.4478 10 18.0001 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0001 10C10.5523 10 11.0001 10.4478 11.0001 11V19C11.0001 19.5523 10.5523 20 10.0001 20C9.44777 20 9.00006 19.5523 9.00006 19V11C9.00006 10.4478 9.44777 10 10.0001 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00006 13C6.55234 13 7.00006 13.4478 7.00006 14V18.8C7.00006 19.3523 6.55234 19.8 6.00006 19.8C5.44777 19.8 5.00006 19.3523 5.00006 18.8V14C5.00006 13.4478 5.44777 13 6.00006 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0001 13C14.5523 13 15.0001 13.4478 15.0001 14V18.8C15.0001 19.3523 14.5523 19.8 14.0001 19.8C13.4478 19.8 13.0001 19.3523 13.0001 18.8V14C13.0001 13.4478 13.4478 13 14.0001 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "H-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["H","hospital","help","hotel","history","home","hour"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19H7.25ZM8.75 5C8.75 4.58579 8.41421 4.25 8 4.25C7.58579 4.25 7.25 4.58579 7.25 5H8.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19H15.25ZM16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8.75 19V5H7.25V19H8.75ZM16.75 19V5H15.25V19H16.75ZM8 12.75H16V11.25H8V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "H-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["H","history","help","hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4C8.55228 4 9 4.44772 9 5V11H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V13H9V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V5C7 4.44772 7.44772 4 8 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    H: {
        defaultColors: ["#3D4C66"],
        keywords: ["H","history","help","hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19H7.25ZM8.75 5C8.75 4.58579 8.41421 4.25 8 4.25C7.58579 4.25 7.25 4.58579 7.25 5H8.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19H15.25ZM16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8.75 19V5H7.25V19H8.75ZM16.75 19V5H15.25V19H16.75ZM8 12.75H16V11.25H8V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "H-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["h","hotel","table","hospitality","section","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19H7.25ZM8.75 5C8.75 4.58579 8.41421 4.25 8 4.25C7.58579 4.25 7.25 4.58579 7.25 5H8.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19H15.25ZM16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8.75 19V5H7.25V19H8.75ZM16.75 19V5H15.25V19H16.75ZM8 12.75H16V11.25H8V12.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "half heart-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["half-heart","favorite","partial","incomplete","customer","loyalty","reward","discount","part","share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19L12 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L5.2807 12.8482C3.5731 11.0528 3.5731 8.14192 5.2807 6.34654C6.9883 4.55116 9.75687 4.55115 11.4645 6.34654L12 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half heart-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["heart","favorite","loyalty","rewards","like","wishlist","save","preferred"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.2807 12.8482L12 19L18.7193 12.8482C20.4269 11.0528 20.4269 8.14192 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 7L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","half","like","favorite","loyalty","customer","rewards","discount","save","preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.2807 12.8482L12 19L12 7L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night","dark-mode","sleep","toggle-dark-mode","display-mode","settings","late-night","off-hours"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12C7 15.866 10.134 19 14 19C15.0736 19 16.0907 18.7583 17 18.3264C14.6351 17.2029 13 14.7924 13 12C13 9.2076 14.6351 6.7971 17 5.67363C16.0907 5.24169 15.0736 5 14 5C10.134 5 7 8.13401 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["favorite","loyalty","heart","love","wishlist","save","preferred","like","customer-loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5.46788C14.1135 3.44946 17.404 3.51262 19.4439 5.65736C21.5187 7.83882 21.5187 11.3559 19.4439 13.5374C19.428 13.5541 19.4116 13.5702 19.3946 13.5858L12.6753 19.7376C12.2931 20.0875 11.7069 20.0875 11.3247 19.7376L4.60543 13.5858C4.58843 13.5702 4.57198 13.5541 4.5561 13.5374C2.4813 11.3559 2.4813 7.83882 4.5561 5.65736C6.59598 3.51262 9.88646 3.44946 12 5.46788Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "half-moon-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["moon","half-moon","time","night","close","suspend","sleep","interruption","hold","wait","inactive","downtime"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12C7 15.866 10.134 19 14 19C15.0736 19 16.0907 18.7583 17 18.3264C14.6351 17.2029 13 14.7924 13 12C13 9.2076 14.6351 6.7971 17 5.67363C16.0907 5.24169 15.0736 5 14 5C10.134 5 7 8.13401 7 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","half-moon","night","dark","mode","sleep","idle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4C9.58172 4 6 7.58172 6 12C6 16.4183 9.58172 20 14 20C15.2251 20 16.3886 19.7239 17.4291 19.2296C17.7778 19.064 18 18.7124 18 18.3264C18 17.9403 17.7778 17.5888 17.4291 17.4231C15.3997 16.459 14 14.392 14 12C14 9.60802 15.3997 7.54096 17.4291 6.57689C17.7778 6.41124 18 6.05968 18 5.67363C18 5.28759 17.7778 4.93602 17.4291 4.77037C16.3886 4.27608 15.2251 4 14 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "half-moon-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night","dark mode","evening","settings","sleep","sleep mode","display","display settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.80975 16.1903C10.2227 18.6032 14.135 18.6032 16.548 16.1903C17.2181 15.5202 17.7021 14.7344 18 13.8973C15.8227 14.6722 13.2976 14.1882 11.5547 12.4453C9.8118 10.7024 9.32779 8.17732 10.1027 6C9.26556 6.29792 8.47984 6.78193 7.80975 7.45202C5.39675 9.86502 5.39675 13.7773 7.80975 16.1903Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["half-moon","moon","night-mode","dark-mode","sleep","timeout","pause","rest","break","evening","schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.80975 16.1903C10.2227 18.6032 14.135 18.6032 16.548 16.1903C17.2181 15.5202 17.7021 14.7344 18 13.8973C15.8227 14.6722 13.2976 14.1882 11.5547 12.4453C9.8118 10.7024 9.32779 8.17732 10.1027 6C9.26556 6.29792 8.47984 6.78193 7.80975 7.45202C5.39675 9.86502 5.39675 13.7773 7.80975 16.1903Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","half-moon","night-mode","dark-mode","display-theme","mode","theme","settings","sleep"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1027 6C9.26556 6.29792 8.47984 6.78193 7.80975 7.45202C5.39675 9.86502 5.39675 13.7773 7.80975 16.1903C10.2227 18.6032 14.135 18.6032 16.548 16.1903C17.2181 15.5202 17.7021 14.7344 18 13.8973"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1026 6C9.32771 8.17732 9.81172 10.7024 11.5546 12.4453C13.2975 14.1882 15.8226 14.6722 17.9999 13.8973"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["night mode","dark mode","sleep","off hours","after hours","closed","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0448 6.33532C11.1742 5.97162 11.0828 5.5659 10.8098 5.29292C10.5368 5.01995 10.1311 4.92848 9.76739 5.05791C8.79338 5.40455 7.87989 5.96769 7.10264 6.74495C4.29912 9.54847 4.29912 14.0939 7.10264 16.8974C9.90616 19.7009 14.4516 19.7009 17.2551 16.8974C18.0323 16.1201 18.5955 15.2066 18.9421 14.2326C19.0716 13.8689 18.9801 13.4632 18.7071 13.1902C18.4341 12.9173 18.0284 12.8258 17.6647 12.9552C15.8373 13.6056 13.7216 13.198 12.2618 11.7382C10.802 10.2785 10.3945 8.16268 11.0448 6.33532Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","settings","sidebar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "half-moon": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night","dark","mode","toggle","sleep","setting","disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12C7 15.866 10.134 19 14 19C15.0736 19 16.0907 18.7583 17 18.3264C14.6351 17.2029 13 14.7924 13 12C13 9.2076 14.6351 6.7971 17 5.67363C16.0907 5.24169 15.0736 5 14 5C10.134 5 7 8.13401 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7C5 6.44772 5.44772 6 6 6H18C18.5523 6 19 6.44772 19 7C19 7.55228 18.5523 8 18 8H6C5.44772 8 5 7.55228 5 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","list","hamburger-menu","options","navigation","category","item-list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["menu","navigation","hamburger","options","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","options","list","navigation","settings","hamburger","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","options","list","hamburger","navigation","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 7H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7H4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","list","hamburger-menu","navigation","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H5C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 6C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 12C7 11.4477 7.44772 11 8 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H8C7.44772 13 7 12.5523 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 12C3 11.4477 3.44772 11 4 11H5C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13H4C3.44772 13 3 12.5523 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H5C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-center-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","navigation","options","settings","hamburger","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-center-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-center-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 6.44772 7.44772 6 8 6H16C16.5523 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8H8C7.44772 8 7 7.55228 7 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 17C7 16.4477 7.44772 16 8 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-center": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger-menu","navigation","options","settings","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","hamburger-menu","list","options","navigation","sidebar","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","sidebar","drawer","expand","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7ZM5 17C5 16.4477 5.44772 16 6 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H6C5.44772 18 5 17.5523 5 17ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-left-right-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","sidebar","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","drawer","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","hamburger-menu","options","navigation","sidebar","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","list","sidebar","drawer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7C9 6.44772 9.44772 6 10 6H18C18.5523 6 19 6.44772 19 7C19 7.55228 18.5523 8 18 8H10C9.44772 8 9 7.55228 9 7ZM5 17C5 16.4477 5.44772 16 6 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H6C5.44772 18 5 17.5523 5 17ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hamburger-left-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","list","options","navigation","sidebar","drawer","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger","lines","options","settings","navigation","sidebar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["menu","hamburger-menu","options","navigation","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","hamburger","options","navigation","sidebar","drawer","settings","list","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","navigation","hamburger-menu","list","settings","filter","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7C9 6.44772 9.44772 6 10 6H18C18.5523 6 19 6.44772 19 7C19 7.55228 18.5523 8 18 8H10C9.44772 8 9 7.55228 9 7ZM9 17C9 16.4477 9.44772 16 10 16H18C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18H10C9.44772 18 9 17.5523 9 17ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Hamburger: {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","navigation","hamburger-menu","list","settings","filter","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hamburger-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","navigation","options","settings","list","hamburger-menu","drawer","sidebar","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hardisk-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hard-drive","storage","data","backup","system","database","server","memory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14L17.7292 5.48467C17.5389 4.77091 17.4437 4.41402 17.1743 4.20701C16.9048 4 16.5355 4 15.7968 4L8.20322 4C7.46451 4 7.09516 4 6.82571 4.20701C6.55626 4.41402 6.46109 4.77091 6.27075 5.48467L4 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14H20V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H8C6.11438 20 5.17157 20 4.58579 19.4142C4 18.8284 4 17.8856 4 16V14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 17L8 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L12 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hardisk-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hard-drive","storage","data","backup","server","database","memory","system-data","storage-device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.27075 5.48467L4.20123 13.2454C4.10876 13.5922 4.06252 13.7655 4.15259 13.8828C4.24265 14 4.42209 14 4.78097 14L19.219 14C19.5779 14 19.7573 14 19.8474 13.8828C19.9375 13.7655 19.8912 13.5922 19.7988 13.2454L17.7292 5.48467C17.5389 4.7709 17.4437 4.41402 17.1743 4.20701C16.9048 4 16.5355 4 15.7968 4L8.20322 4C7.46451 4 7.09516 4 6.82571 4.20701C6.55626 4.41402 6.46109 4.77091 6.27075 5.48467Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14H20V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H8C6.11438 20 5.17157 20 4.58579 19.4142C4 18.8284 4 17.8856 4 16V14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 17L8 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hardisk-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hard drive","data","storage","backup","database","server","system","memory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.6839 5.18367L20.9597 13.7179C20.9859 13.8073 21 13.902 21 14L21 16.0658C21.0001 16.9523 21.0001 17.7161 20.9179 18.3278C20.8297 18.9833 20.631 19.6116 20.1213 20.1213C19.6117 20.631 18.9833 20.8297 18.3278 20.9178C17.7161 21.0001 16.9523 21 16.0658 21H7.93417C7.04769 21 6.28387 21.0001 5.67221 20.9178C5.0167 20.8297 4.38835 20.631 3.87868 20.1213C3.36902 19.6116 3.17028 18.9833 3.08215 18.3278C2.99991 17.7161 2.99995 16.9523 3 16.0658L3 14C3 13.9036 3.01364 13.8104 3.03909 13.7222L5.31601 5.18372C5.40106 4.86453 5.48579 4.54654 5.58932 4.28624C5.70739 3.98939 5.88623 3.66771 6.21643 3.41404C6.54662 3.16036 6.90352 3.07043 7.22076 3.03284C7.49895 2.99987 7.82805 2.99994 8.15838 3.00001L15.8415 3.00001C16.1719 2.99994 16.501 2.99987 16.7791 3.03284C17.0964 3.07043 17.4533 3.16035 17.7835 3.41403C18.1137 3.66771 18.2925 3.98939 18.4106 4.28624C18.5141 4.54651 18.5988 4.86451 18.6839 5.18367ZM16.763 5.74235L18.6983 13H5.30157L7.23694 5.74235C7.33832 5.3622 7.3934 5.16197 7.44772 5.0254L7.45001 5.01968L7.45613 5.01894C7.60208 5.00164 7.80974 5.00001 8.20318 5.00001L15.7967 5.00001C16.1902 5.00001 16.3978 5.00164 16.5438 5.01894L16.5499 5.01968L16.5522 5.0254C16.6065 5.16197 16.6616 5.3622 16.763 5.74235ZM9 17C9 17.5523 8.55228 18 8 18H7C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16H8C8.55228 16 9 16.4477 9 17ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16H11C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    hardisk: {
        defaultColors: ["#3D4C66"],
        keywords: ["hard drive","data","storage","backup","database","server","system","memory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14L17.7292 5.48467C17.5389 4.77091 17.4437 4.41402 17.1743 4.20701C16.9048 4 16.5355 4 15.7968 4L8.20322 4C7.46451 4 7.09516 4 6.82571 4.20701C6.55626 4.41402 6.46109 4.77091 6.27075 5.48467L4 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 14H20V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H8C6.11438 20 5.17157 20 4.58579 19.4142C4 18.8284 4 17.8856 4 16V14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 17L8 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hastag-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hashtag","tag","category","group","filter","search","label","topic","trending","social-media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 19L9 5M15 19L16 5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hastag-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hashtag","tag","category","filter","label","group","grouping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 19L9 5M15 19L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hastag-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hashtag","tag","label","category","discount-code","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.07129 4.00258C9.62217 4.04193 10.0368 4.52041 9.9975 5.07129L9.78831 8H14.7832L15.0026 4.9288C15.0419 4.37791 15.5204 3.96324 16.0713 4.00258C16.6222 4.04193 17.0368 4.52041 16.9975 5.07129L16.7883 8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H16.6455L16.3597 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H16.2169L15.9975 19.0713C15.9582 19.6222 15.4797 20.0368 14.9288 19.9975C14.3779 19.9582 13.9632 19.4797 14.0026 18.9288L14.2118 16H9.21688L8.9975 19.0713C8.95815 19.6222 8.47968 20.0368 7.9288 19.9975C7.37791 19.9582 6.96324 19.4797 7.00258 18.9288L7.21178 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H7.35464L7.64036 10H5C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8H7.78321L8.00258 4.9288C8.04193 4.37791 8.52041 3.96324 9.07129 4.00258ZM9.64545 10L9.35974 14H14.3546L14.6404 10H9.64545Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    hastag: {
        defaultColors: ["#3D4C66"],
        keywords: ["hashtag","tag","label","category","discount-code","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 19L9 5M15 19L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hat-chef-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","employee","staff","cooking","preparation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.438 15.4961L17.9668 11.2654C18.5998 10.7153 19 9.9044 19 9C19 7.34315 17.6569 6 16 6C15.6639 6 15.0535 6 14.5631 6.44019C14.0364 5.57657 13.0856 5 12 5C10.9166 5 9.9674 5.57425 9.44007 6.43497C9 6 8.35064 6 8 6C6.34315 6 5 7.34315 5 9C5 9.9044 5.4002 10.7153 6.03317 11.2654L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.438 15.4961L16.6938 15.4031L17.438 15.4961ZM6.56202 15.4961L5.81781 15.5892L6.56202 15.4961ZM7.44196 18.4994L7.93831 17.9371L7.44196 18.4994ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM14.25 8C14.25 8.41421 14.5858 8.75 15 8.75C15.4142 8.75 15.75 8.41421 15.75 8H14.25ZM16 11.25C15.5858 11.25 15.25 11.5858 15.25 12C15.25 12.4142 15.5858 12.75 16 12.75V11.25ZM13.9697 5.96967C13.6768 6.26256 13.6768 6.73744 13.9697 7.03033C14.2626 7.32322 14.7374 7.32322 15.0303 7.03033L13.9697 5.96967ZM8 12.75C8.41421 12.75 8.75 12.4142 8.75 12C8.75 11.5858 8.41421 11.25 8 11.25V12.75ZM17.2558 10.907L17.2226 11.1723L18.711 11.3584L18.7442 11.093L17.2558 10.907ZM17.2226 11.1723L16.6938 15.4031L18.1822 15.5892L18.711 11.3584L17.2226 11.1723ZM13.4689 18.25H10.5311V19.75H13.4689V18.25ZM7.30623 15.4031L6.77738 11.1723L5.28896 11.3584L5.81781 15.5892L7.30623 15.4031ZM6.77738 11.1723L6.74421 10.907L5.25579 11.093L5.28896 11.3584L6.77738 11.1723ZM10.5311 18.25C9.67069 18.25 9.09635 18.2486 8.66348 18.1934C8.25169 18.141 8.06615 18.0499 7.93831 17.9371L6.94561 19.0616C7.38489 19.4494 7.90325 19.6087 8.47392 19.6814C9.02352 19.7514 9.7102 19.75 10.5311 19.75V18.25ZM5.81781 15.5892C5.91963 16.4038 6.00339 17.0853 6.14104 17.622C6.28396 18.1792 6.50632 18.6738 6.94561 19.0616L7.93831 17.9371C7.81048 17.8242 7.69714 17.6514 7.59401 17.2493C7.4856 16.8266 7.41295 16.2569 7.30623 15.4031L5.81781 15.5892ZM16.6938 15.4031C16.587 16.2569 16.5144 16.8266 16.406 17.2493C16.3029 17.6514 16.1895 17.8242 16.0617 17.9371L17.0544 19.0616C17.4937 18.6738 17.716 18.1792 17.859 17.622C17.9966 17.0853 18.0804 16.4038 18.1822 15.5892L16.6938 15.4031ZM13.4689 19.75C14.2898 19.75 14.9765 19.7514 15.5261 19.6814C16.0968 19.6087 16.6151 19.4494 17.0544 19.0616L16.0617 17.9371C15.9339 18.0499 15.7483 18.141 15.3365 18.1934C14.9036 18.2486 14.3293 18.25 13.4689 18.25V19.75ZM9.75 8C9.75 7.5687 9.87062 7.16786 10.0796 6.82678L8.80055 6.04316C8.45122 6.61335 8.25 7.28432 8.25 8H9.75ZM10.0796 6.82678C10.4763 6.17929 11.1883 5.75 12 5.75V4.25C10.6449 4.25 9.45851 4.96922 8.80055 6.04316L10.0796 6.82678ZM12 5.75C12.8133 5.75 13.5266 6.18103 13.9228 6.83069L15.2034 6.04968C14.5463 4.97212 13.3578 4.25 12 4.25V5.75ZM13.9228 6.83069C14.1303 7.17092 14.25 7.57033 14.25 8H15.75C15.75 7.28706 15.5503 6.61846 15.2034 6.04968L13.9228 6.83069ZM16 6.75C17.2426 6.75 18.25 7.75736 18.25 9H19.75C19.75 6.92893 18.0711 5.25 16 5.25V6.75ZM18.25 9C18.25 9.67816 17.9509 10.2856 17.4749 10.6992L18.4588 11.8315C19.2487 11.1451 19.75 10.1306 19.75 9H18.25ZM17.4749 10.6992C17.0795 11.0428 16.5649 11.25 16 11.25V12.75C16.94 12.75 17.8009 12.4032 18.4588 11.8315L17.4749 10.6992ZM15.0303 7.03033C15.0415 7.01915 15.0528 7.00849 15.0641 6.99831L14.0621 5.88206C14.0309 5.91008 14.0001 5.93927 13.9697 5.96967L15.0303 7.03033ZM15.0641 6.99831C15.3193 6.76928 15.6516 6.75 16 6.75V5.25C15.6763 5.25 14.7877 5.23073 14.0621 5.88207L15.0641 6.99831ZM8 5.25C5.92893 5.25 4.25 6.92893 4.25 9H5.75C5.75 7.75736 6.75736 6.75 8 6.75V5.25ZM4.25 9C4.25 10.1306 4.75131 11.1451 5.54123 11.8315L6.52511 10.6992C6.04909 10.2856 5.75 9.67816 5.75 9H4.25ZM5.54123 11.8315C6.19911 12.4032 7.05998 12.75 8 12.75V11.25C7.43511 11.25 6.92048 11.0428 6.52511 10.6992L5.54123 11.8315ZM9.9673 5.90157C9.27753 5.21978 8.30497 5.25 8 5.25V6.75C8.17853 6.75 8.35713 6.75189 8.53364 6.78863C8.70547 6.8244 8.82791 6.88444 8.91283 6.96838L9.9673 5.90157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M14 16L10 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hat-chef-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","restaurant","staff","employee","menu","food","cooking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 16L10 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 11L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L18 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6C15.6494 6 15.3128 6.06015 15 6.17071"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C8.35064 6 8.68722 6.06015 9 6.17071"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "hat-chef-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","staff","employee","role","restaurant","cuisine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4.25C10.916 4.25 9.94001 4.71021 9.25605 5.44407C8.75704 5.24742 8.26576 5.24912 8.03736 5.24991L8 5.25C5.92893 5.25 4.25 6.92893 4.25 9C4.25 10.0223 4.65986 10.9496 5.32233 11.6254L5.82377 15.6369C5.92293 16.4304 6.00609 17.0958 6.14104 17.622C6.28396 18.1792 6.50632 18.6738 6.94561 19.0616C7.38489 19.4494 7.90325 19.6087 8.47392 19.6814C9.01274 19.75 9.68332 19.75 10.483 19.75H13.5169C14.3166 19.75 14.9873 19.75 15.5261 19.6814C16.0968 19.6087 16.6151 19.4494 17.0544 19.0616C17.4937 18.6738 17.716 18.1792 17.859 17.622C17.9939 17.0958 18.0771 16.4304 18.1762 15.6368L18.6777 11.6254C19.3401 10.9496 19.75 10.0223 19.75 9C19.75 6.92893 18.0711 5.25 16 5.25L15.9728 5.24997C15.7369 5.24961 15.2579 5.24889 14.7523 5.45309C14.068 4.71398 13.0884 4.25 12 4.25ZM10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hat-chef-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","restaurant","menu","staff","employee","role","prepare","food","chef-hat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 15L7 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 8C9 7.4054 9.17298 6.85121 9.47137 6.38499M9.47137 6.38499C9.03664 6.13986 8.53465 6 8 6C6.34315 6 5 7.34315 5 9C5 9.9044 5.4002 10.7153 6.03317 11.2654L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L17.9668 11.2654C18.5998 10.7153 19 9.9044 19 9C19 7.34315 17.6569 6 16 6C15.4653 6 14.9634 6.13986 14.5286 6.38499M9.47137 6.38499C10.0044 5.55209 10.9377 5 12 5C13.0623 5 13.9956 5.55209 14.5286 6.38499M14.5286 6.38499C14.827 6.85121 15 7.4054 15 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "hat-chef-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["chef","hat","cook","restaurant","kitchen","employee","staff","role","cooking","menu","food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8C9 7.4054 9.17298 6.85121 9.47137 6.38499M9.47137 6.38499C9.03664 6.13986 8.53465 6 8 6C6.34315 6 5 7.34315 5 9C5 9.9044 5.4002 10.7153 6.03317 11.2654L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L17.9668 11.2654C18.5998 10.7153 19 9.9044 19 9C19 7.34315 17.6569 6 16 6C15.4653 6 14.9634 6.13986 14.5286 6.38499M9.47137 6.38499C10.0044 5.55209 10.9377 5 12 5C13.0623 5 13.9956 5.55209 14.5286 6.38499M14.5286 6.38499C14.827 6.85121 15 7.4054 15 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 15L7 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hat-chef-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","staff","employee","menu","restaurant","cuisine","chef-hat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C6.34315 6 5 7.34315 5 9C5 9.9044 5.4002 10.7153 6.03317 11.2654L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L17.9668 11.2654C18.5998 10.7153 19 9.9044 19 9C19 7.34315 17.6569 6 16 6C15.4653 6 14.9634 6.13986 14.5286 6.38499C13.9956 5.55209 13.0623 5 12 5C10.9377 5 10.0044 5.55209 9.47137 6.38499C9.03664 6.13986 8.53465 6 8 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9 8C9 7.4054 9.17298 6.85121 9.47137 6.38499M9.47137 6.38499C9.03664 6.13986 8.53465 6 8 6C6.34315 6 5 7.34315 5 9C5 9.9044 5.4002 10.7153 6.03317 11.2654L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L17.9668 11.2654C18.5998 10.7153 19 9.9044 19 9C19 7.34315 17.6569 6 16 6C15.4653 6 14.9634 6.13986 14.5286 6.38499M9.47137 6.38499C10.0044 5.55209 10.9377 5 12 5C13.0623 5 13.9956 5.55209 14.5286 6.38499M14.5286 6.38499C14.827 6.85121 15 7.4054 15 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17.4999 15L6.5 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hat-chef-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["chef","hat","cook","kitchen","menu","recipe","restaurant","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4.25C10.9081 4.25 9.92552 4.71709 9.24091 5.4604C8.85201 5.32407 8.43418 5.25 8 5.25C5.92893 5.25 4.25 6.92893 4.25 9C4.25 10.0223 4.65986 10.9496 5.32233 11.6254L5.61916 14H18.3701C18.3737 14 18.3773 14 18.3808 14.0001L18.6777 11.6254C19.3401 10.9496 19.75 10.0223 19.75 9C19.75 6.92893 18.0711 5.25 16 5.25C15.5658 5.25 15.148 5.32407 14.7591 5.4604C14.0745 4.71709 13.092 4.25 12 4.25ZM18.1306 15.9998C18.1247 15.9999 18.1187 16 18.1127 16H6.0001C5.95543 16 5.91144 15.9971 5.86832 15.9914C5.94954 16.6304 6.0267 17.1762 6.14104 17.622C6.28396 18.1792 6.50632 18.6738 6.94561 19.0616C7.38489 19.4494 7.90325 19.6087 8.47392 19.6814C9.01274 19.75 9.68332 19.75 10.483 19.75H10.4831H13.5169H13.517C14.3167 19.75 14.9873 19.75 15.5261 19.6814C16.0968 19.6087 16.6151 19.4494 17.0544 19.0616C17.4937 18.6738 17.716 18.1792 17.859 17.622C17.9728 17.1781 18.0498 16.6352 18.1306 15.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hat-chef": {
        defaultColors: ["#3D4C66"],
        keywords: ["chef","cook","kitchen","restaurant","menu","food","cooking","hat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 16L10 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 11L6.56202 15.4961C6.77057 17.1645 6.87484 17.9987 7.44196 18.4994C8.00908 19 8.84976 19 10.5311 19H13.4689C15.1502 19 15.9909 19 16.558 18.4994C17.1252 17.9987 17.2294 17.1645 17.438 15.4961L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6C15.6494 6 15.3128 6.06015 15 6.17071"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C8.35064 6 8.68722 6.06015 9 6.17071"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "HD-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["HD","high-definition","settings","configuration","display","resolution","quality","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M8 12H11M8 12V14M11 10V12M11 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14V14.75C12.5858 14.75 12.25 14.4142 12.25 14H13ZM13 10H12.25C12.25 9.58579 12.5858 9.25 13 9.25V10ZM12.25 14V10H13.75V14H12.25ZM13 9.25H14V10.75H13V9.25ZM13 13.25H14V14.75H13V13.25ZM14 13.25C14.6904 13.25 15.25 12.6904 15.25 12H16.75C16.75 13.5188 15.5188 14.75 14 14.75V13.25ZM14 9.25C15.5188 9.25 16.75 10.4812 16.75 12H15.25C15.25 11.3096 14.6904 10.75 14 10.75V9.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "HD-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hd","high definition","image quality","settings","configuration","display settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M8 12H11M8 12V14M11 10V12M11 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14V14.75C12.5858 14.75 12.25 14.4142 12.25 14H13ZM13 10H12.25C12.25 9.58579 12.5858 9.25 13 9.25V10ZM12.25 14V10H13.75V14H12.25ZM13 9.25H14V10.75H13V9.25ZM13 13.25H14V14.75H13V13.25ZM14 13.25C14.6904 13.25 15.25 12.6904 15.25 12H16.75C16.75 13.5188 15.5188 14.75 14 14.75V13.25ZM14 9.25C15.5188 9.25 16.75 10.4812 16.75 12H15.25C15.25 11.3096 14.6904 10.75 14 10.75V9.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "HD-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hd","high-definition","quality","settings","options","display","resolution","graphics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.25 12C15.25 11.3096 14.6904 10.75 14 10.75H13.75V13.25H14C14.6904 13.25 15.25 12.6904 15.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM8.75 10C8.75 9.58579 8.41421 9.25 8 9.25C7.58579 9.25 7.25 9.58579 7.25 10V14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14V12.75H10.25V14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14V10C11.75 9.58579 11.4142 9.25 11 9.25C10.5858 9.25 10.25 9.58579 10.25 10V11.25H8.75V10ZM14 9.25C15.5188 9.25 16.75 10.4812 16.75 12C16.75 13.5188 15.5188 14.75 14 14.75H13C12.5858 14.75 12.25 14.4142 12.25 14V10C12.25 9.58579 12.5858 9.25 13 9.25H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    HD: {
        defaultColors: ["#3D4C66"],
        keywords: ["hd","high-definition","quality","settings","options","display","resolution","graphics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M8 12H11M8 12V14M11 10V12M11 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14V14.75C12.5858 14.75 12.25 14.4142 12.25 14H13ZM13 10H12.25C12.25 9.58579 12.5858 9.25 13 9.25V10ZM12.25 14V10H13.75V14H12.25ZM13 9.25H14V10.75H13V9.25ZM13 13.25H14V14.75H13V13.25ZM14 13.25C14.6904 13.25 15.25 12.6904 15.25 12H16.75C16.75 13.5188 15.5188 14.75 14 14.75V13.25ZM14 9.25C15.5188 9.25 16.75 10.4812 16.75 12H15.25C15.25 11.3096 14.6904 10.75 14 10.75V9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "HDR-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["HDR","high-dynamic-range","display settings","enhanced graphics","visual quality","screen mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6152 10H11V14H11.6152C12.38 14 13 13.1046 13 12C13 10.8954 12.38 10 11.6152 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12.1537V10.0009H15.7476C16.4119 9.9761 16.9724 10.4575 17.0012 11.0773C16.9724 11.6971 16.4119 12.1785 15.7476 12.1537H15ZM15 12.1537L15.0004 14M15 12.1537L17.0008 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14V12M7 12V10M7 12H9M9 12V14M9 12V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "HDR-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["HDR","high dynamic range","settings","image quality","display","visuals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6152 10H11V14H11.6152C12.38 14 13 13.1046 13 12C13 10.8954 12.38 10 11.6152 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12.1537V10.0009H15.7476C16.4119 9.9761 16.9724 10.4575 17.0012 11.0773C16.9724 11.6971 16.4119 12.1785 15.7476 12.1537H15ZM15 12.1537L15.0004 14M15 12.1537L17.0008 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14V12M7 12V10M7 12H9M9 12V14M9 12V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "HDR-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["HDR","settings","display","resolution","high-dynamic-range","configuration","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9778 12.9873C11.8946 13.1075 11.8156 13.1743 11.75 13.2104V10.7896C11.8156 10.8257 11.8946 10.8925 11.9778 11.0127C12.1312 11.2342 12.25 11.581 12.25 12C12.25 12.419 12.1312 12.7658 11.9778 12.9873Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 10.7509V11.4037C15.7585 11.4037 15.7671 11.4039 15.7756 11.4042C16.0561 11.4147 16.2203 11.2328 16.2481 11.0773C16.2203 10.9218 16.0561 10.7399 15.7756 10.7504C15.7671 10.7507 15.7585 10.7509 15.75 10.7509Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4H8.92943C7.57533 3.99997 6.45869 3.99994 5.57494 4.11876C4.64711 4.2435 3.82769 4.51547 3.17158 5.17158C2.51547 5.82769 2.2435 6.64711 2.11876 7.57494C1.99994 8.45869 1.99997 9.57529 2 10.9294V13.0706C1.99997 14.4247 1.99994 15.5413 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706V10.9295C22 9.57534 22.0001 8.4587 21.8813 7.57494C21.7565 6.64711 21.4845 5.82768 20.8284 5.17158C20.1723 4.51547 19.3529 4.2435 18.4251 4.11876C17.5413 3.99994 16.4247 3.99997 15.0706 4ZM7.75 10C7.75 9.58579 7.41421 9.25 7 9.25C6.58579 9.25 6.25 9.58579 6.25 10V14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14V12.75H8.25V14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14V10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10V11.25H7.75V10ZM11 9.25C10.5858 9.25 10.25 9.58579 10.25 10V14C10.25 14.4142 10.5858 14.75 11 14.75H11.6152C12.3133 14.75 12.8652 14.3406 13.211 13.8412C13.5588 13.3388 13.75 12.6856 13.75 12C13.75 11.3144 13.5588 10.6612 13.211 10.1588C12.8652 9.65943 12.3133 9.25 11.6152 9.25H11ZM17.7504 11.0426C17.7007 9.96998 16.7561 9.22071 15.7353 9.25092H15C14.5858 9.25092 14.25 9.58671 14.25 10.0009L14.2504 14.0002C14.2505 14.4144 14.5864 14.7501 15.0006 14.75C15.4148 14.7499 15.7505 14.414 15.7504 13.9998L15.7504 13.8667L16.4921 14.5512C16.7965 14.8321 17.271 14.813 17.5519 14.5086C17.8328 14.2042 17.8138 13.7297 17.5094 13.4488L16.6924 12.6949C17.2825 12.4036 17.7171 11.8303 17.7504 11.112C17.7515 11.0889 17.7515 11.0657 17.7504 11.0426Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    HDR: {
        defaultColors: ["#3D4C66"],
        keywords: ["HDR","settings","display","resolution","high-dynamic-range","configuration","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.6152 10H11V14H11.6152C12.38 14 13 13.1046 13 12C13 10.8954 12.38 10 11.6152 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12.1537V10.0009H15.7476C16.4119 9.9761 16.9724 10.4575 17.0012 11.0773C16.9724 11.6971 16.4119 12.1785 15.7476 12.1537H15ZM15 12.1537L15.0004 14M15 12.1537L17.0008 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14V12M7 12V10M7 12H9M9 12V14M9 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Heading-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["header","heading","title","section","text","formatting","align","alignment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 6V18M17 6V18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 6H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Heading-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["heading","header","title","section","headline","text","formatting","bold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 6V18M17 6V18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 6H8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6H18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Heading-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heading","text","header","title","label","section","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6C5 5.44772 5.44772 5 6 5H8C8.55228 5 9 5.44772 9 6C9 6.55228 8.55228 7 8 7V11L16 11V7C15.4477 7 15 6.55228 15 6C15 5.44772 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7V17C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H16C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17V13L8 13V17C8.55228 17 9 17.4477 9 18C9 18.5523 8.55228 19 8 19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17V7C5.44772 7 5 6.55228 5 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Heading: {
        defaultColors: ["#3D4C66"],
        keywords: ["heading","text","header","title","label","section","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 6V18M17 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 6H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Headphone-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["headphones","support","help","customer-service","audio","sound","headset","call-center","assistance","agent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17.25L5.51493 17.3787C6.65886 17.6647 7.23082 17.8077 7.61541 17.5074C8 17.2072 8 16.6176 8 15.4384L8 14.5616C8 13.3824 8 12.7928 7.61541 12.4926C7.23082 12.1923 6.65886 12.3353 5.51493 12.6213L5 12.75"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 17.25L18.4851 17.3787C17.3411 17.6647 16.7692 17.8077 16.3846 17.5074C16 17.2072 16 16.6176 16 15.4384L16 14.5616C16 13.3824 16 12.7928 16.3846 12.4926C16.7692 12.1923 17.3411 12.3353 18.4851 12.6213L19 12.75"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5V5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Headphone-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphone","headphones","support","audio","customer-service","helpdesk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5V5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 15.1127L8 14.2359C8 13.0567 8 12.4672 7.61541 12.1669C7.23082 11.8666 6.65886 12.0096 5.51493 12.2956L5.51493 12.2956L5.45448 12.3107C5.23621 12.3652 5.12708 12.3925 5.06354 12.4739C5 12.5553 5 12.6678 5 12.8928V16.3935C5 16.7055 5.2123 16.9774 5.51493 17.053C6.65886 17.339 7.23082 17.482 7.61541 17.1817C8 16.8815 8 16.2919 8 15.1127Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 15.1127V14.2359C16 13.0567 16 12.4672 16.3846 12.1669C16.7692 11.8666 17.3411 12.0096 18.4851 12.2956C18.7877 12.3712 19 12.6431 19 12.9551V16.4558C19 16.6808 19 16.7933 18.9365 16.8747C18.8729 16.9561 18.7638 16.9834 18.5455 17.0379L18.4851 17.053C17.3411 17.339 16.7692 17.482 16.3846 17.1817C16 16.8815 16 16.2919 16 15.1127Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8 15.1127L8 14.2359C8 13.0567 8 12.4672 7.61541 12.1669C7.23082 11.8666 6.65886 12.0096 5.51493 12.2956L5.51493 12.2956L5.45448 12.3107C5.23621 12.3652 5.12708 12.3925 5.06354 12.4739C5 12.5553 5 12.6678 5 12.8928V16.3935C5 16.7055 5.2123 16.9774 5.51493 17.053C6.65886 17.339 7.23082 17.482 7.61541 17.1817C8 16.8815 8 16.2919 8 15.1127Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 15.1127V14.2359C16 13.0567 16 12.4672 16.3846 12.1669C16.7692 11.8666 17.3411 12.0096 18.4851 12.2956C18.7877 12.3712 19 12.6431 19 12.9551V16.4558C19 16.6808 19 16.7933 18.9365 16.8747C18.8729 16.9561 18.7638 16.9834 18.5455 17.0379L18.4851 17.053C17.3411 17.339 16.7692 17.482 16.3846 17.1817C16 16.8815 16 16.2919 16 15.1127Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Headphone-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","audio","support","customer-service","settings","help","music","sound","headset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58177 4 4.00005 7.58172 4.00005 12V12.8121C3.99998 12.8318 4 12.8502 4.00002 12.8669L4.00005 17C4.00005 16.9998 4.00005 17.0002 4.00005 17L4.00005 17.0491C4.00005 17.8184 4.52464 18.4889 5.27244 18.6755C5.79109 18.805 6.34191 18.9425 6.74883 18.9838C7.19787 19.0293 7.74557 19.0005 8.23087 18.6224C8.71617 18.2442 8.87705 17.7209 8.94167 17.2751C9.00023 16.8712 9.00014 16.3677 9.00005 15.8342L9.00005 14.1661C9.00014 13.6325 9.00023 13.1291 8.94167 12.7251C8.87705 12.2793 8.71617 11.756 8.23087 11.3779C7.74557 10.9998 7.19787 10.9709 6.74883 11.0165C6.55782 11.0358 6.31705 11.0809 6.06169 11.1367C6.48025 8.23202 8.97949 6 12 6C15.0219 6 17.522 8.23392 17.9389 11.1404C17.6825 11.085 17.417 11.0333 17.2513 11.0165C16.8022 10.9709 16.2545 10.9998 15.7692 11.3779C15.2839 11.756 15.123 12.2793 15.0584 12.7251C14.9999 13.1291 14.9999 13.6325 15 14.1661L15 15.8341C15 16.3676 14.9999 16.8712 15.0584 17.2751C15.123 17.7209 15.2839 18.2442 15.7692 18.6224C16.2545 19.0005 16.8022 19.0293 17.2513 18.9838C17.6582 18.9425 18.1476 18.8203 18.6662 18.6908C18.7539 18.6691 19.0342 18.5994 19.1551 18.5534C19.3115 18.4939 19.5392 18.3807 19.7247 18.1435C19.9103 17.9063 19.9652 17.6584 19.985 17.4926C20.0004 17.3645 20.0002 17.2239 20 17.1337V12C20 7.58172 16.4183 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Headphone: {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","audio","support","customer-service","settings","help","music","sound","headset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17V12C19 8.13401 15.866 5 12 5V5C8.13401 5 5 8.13401 5 12V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 17.25L5.51493 17.3787C6.65886 17.6647 7.23082 17.8077 7.61541 17.5074C8 17.2072 8 16.6176 8 15.4384L8 14.5616C8 13.3824 8 12.7928 7.61541 12.4926C7.23082 12.1923 6.65886 12.3353 5.51493 12.6213L5 12.75"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 17.25L18.4851 17.3787C17.3411 17.6647 16.7692 17.8077 16.3846 17.5074C16 17.2072 16 16.6176 16 15.4384L16 14.5616C16 13.3824 16 12.7928 16.3846 12.4926C16.7692 12.1923 17.3411 12.3353 18.4851 12.6213L19 12.75"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headphones","support","customer-service","help","agent","call-center","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 15V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13V15C8 16.1046 7.10457 17 6 17C4.89543 17 4 16.1046 4 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13V15C20 16.1046 19.1046 17 18 17C16.8954 17 16 16.1046 16 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones support-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","help","customer-service","assistance","call-center","audio","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V13C4 12.0572 4 11.5858 4.29289 11.2929C4.58579 11 5.05719 11 6 11C6.94281 11 7.41421 11 7.70711 11.2929C8 11.5858 8 12.0572 8 13V15C8 15.9428 8 16.4142 7.70711 16.7071C7.41421 17 6.94281 17 6 17C5.05719 17 4.58579 17 4.29289 16.7071C4 16.4142 4 15.9428 4 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 12.0572 16 11.5858 16.2929 11.2929C16.5858 11 17.0572 11 18 11C18.9428 11 19.4142 11 19.7071 11.2929C20 11.5858 20 12.0572 20 13V15C20 15.9428 20 16.4142 19.7071 16.7071C19.4142 17 18.9428 17 18 17C17.0572 17 16.5858 17 16.2929 16.7071C16 16.4142 16 15.9428 16 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-support","help","assistant","agent","call-center","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12L21 15.0544C21 15.0965 21 15.1385 21 15.1804V16.0658C21.0001 16.9523 21.0001 17.7161 20.9179 18.3278C20.8297 18.9833 20.631 19.6117 20.1213 20.1213C19.6117 20.631 18.9833 20.8297 18.3278 20.9179C17.7162 21.0001 16.9524 21.0001 16.0659 21L12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19H16C16.9711 19 17.5988 18.9979 18.0613 18.9357C18.495 18.8774 18.631 18.7832 18.7071 18.7071C18.7832 18.631 18.8774 18.495 18.9357 18.0613C18.9392 18.0354 18.9425 18.009 18.9456 17.9821C18.6709 18.0001 18.3659 18.0001 18.0544 18H17.9456C17.5215 18.0001 17.1094 18.0002 16.7695 17.9545C16.3863 17.903 15.949 17.7774 15.5858 17.4142C15.2226 17.051 15.0971 16.6137 15.0455 16.2305C14.9998 15.8906 14.9999 15.4785 15 15.0544V12.9456C14.9999 12.5215 14.9998 12.1094 15.0455 11.7695C15.0971 11.3863 15.2226 10.949 15.5858 10.5858C15.949 10.2226 16.3863 10.0971 16.7695 10.0455C17.1094 9.99984 17.5215 9.99992 17.9456 10H18.0544C18.2801 9.99996 18.5023 9.99992 18.7121 10.0068C17.8538 7.1118 15.1735 5 12 5C8.8265 5 6.14625 7.1118 5.28787 10.0068C5.49768 9.99992 5.71995 9.99996 5.94561 10H6.05442C6.47849 9.99992 6.89062 9.99984 7.23053 10.0455C7.61374 10.0971 8.05101 10.2226 8.41423 10.5858C8.77744 10.949 8.90297 11.3863 8.95449 11.7695C9.00019 12.1094 9.0001 12.5215 9.00002 12.9456V15.0544C9.0001 15.4785 9.00019 15.8906 8.95449 16.2305C8.90297 16.6137 8.77744 17.051 8.41423 17.4142C8.05101 17.7774 7.61374 17.903 7.23053 17.9545C6.89062 18.0002 6.47849 18.0001 6.05442 18H5.9456C5.52153 18.0001 5.10941 18.0002 4.7695 17.9545C4.38629 17.903 3.94902 17.7774 3.5858 17.4142C3.22259 17.051 3.09706 16.6137 3.04554 16.2305C2.99984 15.8906 2.99992 15.4785 3.00001 15.0544L3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones support-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","customer-support","help","call-center","assistance","contact","service","operator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 15V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13V15C8 16.1046 7.10457 17 6 17C4.89543 17 4 16.1046 4 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13V15C20 16.1046 19.1046 17 18 17C16.8954 17 16 16.1046 16 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer service","help","assistance","call center","audio","communication","agent","operator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 15C3 16.6569 4.34315 18 6 18C7.65685 18 9 16.6569 9 15V13C9 11.3431 7.65685 10 6 10C5.74586 10 5.49911 10.0316 5.26345 10.0911C6.09439 7.1529 8.79578 5 12 5C15.2042 5 17.9056 7.1529 18.7366 10.0911C18.5009 10.0316 18.2541 10 18 10C16.3431 10 15 11.3431 15 13V15C15 16.6569 16.3431 18 18 18C18.3356 18 18.6583 17.9449 18.9597 17.8432C18.9529 17.92 18.9449 17.9925 18.9357 18.0613C18.8774 18.495 18.7832 18.631 18.7071 18.7071C18.631 18.7832 18.495 18.8774 18.0613 18.9357C17.5988 18.9979 16.9711 19 16 19H12C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21L16.0658 21C16.9523 21.0001 17.7162 21.0001 18.3278 20.9179C18.9833 20.8297 19.6117 20.631 20.1213 20.1213C20.631 19.6117 20.8297 18.9833 20.9179 18.3278C21.0001 17.7161 21.0001 16.9523 21 16.0658L21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones support-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","help","customer-service","call-center","assistance","contact","agent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17V17C5.05719 17 4.58579 17 4.29289 16.7071C4.29289 16.7071 4.29289 16.7071 4.29289 16.7071C4 16.4142 4 15.9428 4 15V15C4 14.0572 4 13.5858 4.29289 13.2929C4.29289 13.2929 4.29289 13.2929 4.29289 13.2929C4.58579 13 5.05719 13 6 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 13V13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 13V13C18.9428 13 19.4142 13 19.7071 13.2929C19.7071 13.2929 19.7071 13.2929 19.7071 13.2929C20 13.5858 20 14.0572 20 15V15C20 15.9428 20 16.4142 19.7071 16.7071C19.7071 16.7071 19.7071 16.7071 19.7071 16.7071C19.4142 17 18.9428 17 18 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17V17C17.4477 17 17 16.5523 17 16L17 14C17 13.4477 17.4477 13 18 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 16V16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headphones","support","customer-support","help","call-center","assistance","operator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 16V16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17V17C5.05719 17 4.58579 17 4.29289 16.7071C4.29289 16.7071 4.29289 16.7071 4.29289 16.7071C4 16.4142 4 15.9428 4 15V15C4 14.0572 4 13.5858 4.29289 13.2929C4.29289 13.2929 4.29289 13.2929 4.29289 13.2929C4.58579 13 5.05719 13 6 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 13V13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 13V13C18.9428 13 19.4142 13 19.7071 13.2929C19.7071 13.2929 19.7071 13.2929 19.7071 13.2929C20 13.5858 20 14.0572 20 15V15C20 15.9428 20 16.4142 19.7071 16.7071C19.7071 16.7071 19.7071 16.7071 19.7071 16.7071C19.4142 17 18.9428 17 18 17V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17V17C17.4477 17 17 16.5523 17 16L17 14C17 13.4477 17.4477 13 18 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones support-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","customer-service","help","mic","call-center","agent","technical-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.29289 16.7071C4 16.4142 4 15.9428 4 15C4 14.0572 4 13.5858 4.29289 13.2929C4.58579 13 5.05719 13 6 13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17C5.05719 17 4.58579 17 4.29289 16.7071Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.7071 13.2929C20 13.5858 20 14.0572 20 15C20 15.9428 20 16.4142 19.7071 16.7071C19.4142 17 18.9428 17 18 17C17.4477 17 17 16.5523 17 16V14C17 13.4477 17.4477 13 18 13C18.9428 13 19.4142 13 19.7071 13.2929Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 16V16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-service","call-center","help","assistance","communication","operator","contact","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C16.8954 12 16 12.8954 16 14V16C16 17.0472 16.8047 17.9063 17.8295 17.9928C17.6206 17.9997 17.3575 18 17 18H12C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20H17.032C17.4706 20 17.8491 20 18.1624 19.9787C18.4922 19.9561 18.8221 19.9066 19.1481 19.7716C19.8831 19.4672 20.4672 18.8831 20.7716 18.1481C20.9066 17.8221 20.9561 17.4922 20.9786 17.1624C21 16.8491 21 16.4707 21 16.0321V16C21 15.9469 20.9959 15.8947 20.9879 15.8439C21.0001 15.5965 21.0001 15.3279 21 15.0544V14.9456C21.0001 14.5215 21.0002 14.1094 20.9545 13.7695C20.903 13.3863 20.7774 12.949 20.4142 12.5858C20.2837 12.4553 20.1437 12.3555 20 12.2788V12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V12.2788C3.85634 12.3555 3.71629 12.4553 3.5858 12.5858C3.22258 12.949 3.09706 13.3863 3.04554 13.7695C2.99984 14.1094 2.99992 14.5215 3.00001 14.9456V15.0544C2.99992 15.4785 2.99984 15.8906 3.04554 16.2305C3.09706 16.6137 3.22259 17.051 3.5858 17.4142C3.94902 17.7774 4.38629 17.903 4.7695 17.9545C5.10941 18.0002 5.52153 18.0001 5.9456 18L6.00001 18C7.10458 18 8.00001 17.1046 8.00001 16L8.00001 14C8.00001 12.8954 7.10457 12 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones support-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-support","help","assistance","call-center","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V13C4 12.0572 4 11.5858 4.29289 11.2929C4.58579 11 5.05719 11 6 11C6.94281 11 7.41421 11 7.70711 11.2929C8 11.5858 8 12.0572 8 13V15C8 15.9428 8 16.4142 7.70711 16.7071C7.41421 17 6.94281 17 6 17C5.05719 17 4.58579 17 4.29289 16.7071C4 16.4142 4 15.9428 4 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 12.0572 16 11.5858 16.2929 11.2929C16.5858 11 17.0572 11 18 11C18.9428 11 19.4142 11 19.7071 11.2929C20 11.5858 20 12.0572 20 13V15C20 15.9428 20 16.4142 19.7071 16.7071C19.4142 17 18.9428 17 18 17C17.0572 17 16.5858 17 16.2929 16.7071C16 16.4142 16 15.9428 16 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones support-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","headphones","customer-support","assistance","help","call-center","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V13C4 12.0572 4 11.5858 4.29289 11.2929C4.58579 11 5.05719 11 6 11C6.94281 11 7.41421 11 7.70711 11.2929C8 11.5858 8 12.0572 8 13V15C8 15.9428 8 16.4142 7.70711 16.7071C7.41421 17 6.94281 17 6 17C5.05719 17 4.58579 17 4.29289 16.7071C4 16.4142 4 15.9428 4 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 12.0572 16 11.5858 16.2929 11.2929C16.5858 11 17.0572 11 18 11C18.9428 11 19.4142 11 19.7071 11.2929C20 11.5858 20 12.0572 20 13V15C20 15.9428 20 16.4142 19.7071 16.7071C19.4142 17 18.9428 17 18 17C17.0572 17 16.5858 17 16.2929 16.7071C16 16.4142 16 15.9428 16 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones support": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-service","help","call-center","assistance","operator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 15V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13V15C8 16.1046 7.10457 17 6 17C4.89543 17 4 16.1046 4 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 15V13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13V15C20 16.1046 19.1046 17 18 17C16.8954 17 16 16.1046 16 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 14V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "headphones-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headphones","support","customer-service","call-center","audio","headset","helpdesk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 17V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17V15C4 14.0572 4 13.5858 4.29289 13.2929C4.58579 13 5.05719 13 6 13C6.94281 13 7.41421 13 7.70711 13.2929C8 13.5858 8 14.0572 8 15V17C8 17.9428 8 18.4142 7.70711 18.7071C7.41421 19 6.94281 19 6 19C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 14.0572 16 13.5858 16.2929 13.2929C16.5858 13 17.0572 13 18 13C18.9428 13 19.4142 13 19.7071 13.2929C20 13.5858 20 14.0572 20 15V17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19C17.0572 19 16.5858 19 16.2929 18.7071C16 18.4142 16 17.9428 16 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","customer-service","audio","settings","preference","sound","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 19V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 13.8954 4.89543 13 6 13C7.10457 13 8 13.8954 8 15V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 13.8954 16.8954 13 18 13C19.1046 13 20 13.8954 20 15V17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","music","sound","audio","support","helpdesk","employee","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13V19C21 19.5523 20.5523 20 20 20C19.7241 20 19.4743 19.8883 19.2934 19.7076C18.9018 19.895 18.4631 20 18 20C16.3431 20 15 18.6569 15 17V15C15 13.3431 16.3431 12 18 12C18.3318 12 18.651 12.0539 18.9493 12.1533C18.5313 8.68659 15.5794 6 12 6C8.42059 6 5.46866 8.68659 5.05069 12.1533C5.34903 12.0539 5.66823 12 6 12C7.65685 12 9 13.3431 9 15V17C9 18.6569 7.65685 20 6 20C5.53685 20 5.09822 19.895 4.70659 19.7076C4.52566 19.8883 4.27588 20 4 20C3.44772 20 3 19.5523 3 19V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","support","customer-service","audio","headset","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 17V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17V15C4 14.0572 4 13.5858 4.29289 13.2929C4.58579 13 5.05719 13 6 13C6.94281 13 7.41421 13 7.70711 13.2929C8 13.5858 8 14.0572 8 15V17C8 17.9428 8 18.4142 7.70711 18.7071C7.41421 19 6.94281 19 6 19C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 14.0572 16 13.5858 16.2929 13.2929C16.5858 13 17.0572 13 18 13C18.9428 13 19.4142 13 19.7071 13.2929C20 13.5858 20 14.0572 20 15V17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19C17.0572 19 16.5858 19 16.2929 18.7071C16 18.4142 16 17.9428 16 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","help","customer-service","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.00001 17.0544C2.99992 17.4785 2.99984 17.8906 3.04554 18.2305C3.09706 18.6137 3.22259 19.051 3.5858 19.4142C3.94902 19.7774 4.38629 19.903 4.7695 19.9545C5.10941 20.0002 5.52153 20.0001 5.9456 20H6.05442C6.47849 20.0001 6.89062 20.0002 7.23053 19.9545C7.61374 19.903 8.05101 19.7774 8.41423 19.4142C8.77744 19.051 8.90297 18.6137 8.95449 18.2305C9.00019 17.8906 9.0001 17.4785 9.00002 17.0544V14.9456C9.0001 14.5215 9.00019 14.1094 8.95449 13.7695C8.90297 13.3863 8.77744 12.949 8.41423 12.5858C8.05101 12.2226 7.61374 12.0971 7.23053 12.0455C6.89062 11.9998 6.4785 11.9999 6.05443 12H5.94561C5.63945 11.9999 5.3395 11.9999 5.06847 12.0171C5.54634 8.61645 8.46762 6 12 6C15.5324 6 18.4537 8.61645 18.9315 12.0171C18.6605 11.9999 18.3606 11.9999 18.0544 12H17.9456C17.5215 11.9999 17.1094 11.9998 16.7695 12.0455C16.3863 12.0971 15.949 12.2226 15.5858 12.5858C15.2226 12.949 15.0971 13.3863 15.0455 13.7695C14.9998 14.1094 14.9999 14.5215 15 14.9456V17.0544C14.9999 17.4785 14.9998 17.8906 15.0455 18.2305C15.0971 18.6137 15.2226 19.051 15.5858 19.4142C15.949 19.7774 16.3863 19.903 16.7695 19.9545C17.1094 20.0002 17.5215 20.0001 17.9456 20H18.0544C18.4785 20.0001 18.8906 20.0002 19.2305 19.9545C19.6137 19.903 20.051 19.7774 20.4142 19.4142C20.7774 19.051 20.903 18.6137 20.9545 18.2305C21.0002 17.8906 21.0001 17.4785 21 17.0544V14.9456C21 14.9031 21 14.8607 21 14.8184V13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13L3.00001 17.0544Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-service","call-center","audio","communication","helpdesk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17V17C5.05719 17 4.58579 17 4.29289 16.7071C4.29289 16.7071 4.29289 16.7071 4.29289 16.7071C4 16.4142 4 15.9428 4 15V15C4 14.0572 4 13.5858 4.29289 13.2929C4.29289 13.2929 4.29289 13.2929 4.29289 13.2929C4.58579 13 5.05719 13 6 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 13V13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 13V13C18.9428 13 19.4142 13 19.7071 13.2929C19.7071 13.2929 19.7071 13.2929 19.7071 13.2929C20 13.5858 20 14.0572 20 15V15C20 15.9428 20 16.4142 19.7071 16.7071C19.7071 16.7071 19.7071 16.7071 19.7071 16.7071C19.4142 17 18.9428 17 18 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17V17C17.4477 17 17 16.5523 17 16L17 14C17 13.4477 17.4477 13 18 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headphones","support","customer-service","help","assistance","headset","call-center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17V17C5.05719 17 4.58579 17 4.29289 16.7071C4.29289 16.7071 4.29289 16.7071 4.29289 16.7071C4 16.4142 4 15.9428 4 15V15C4 14.0572 4 13.5858 4.29289 13.2929C4.29289 13.2929 4.29289 13.2929 4.29289 13.2929C4.58579 13 5.05719 13 6 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 13V13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 13V13C18.9428 13 19.4142 13 19.7071 13.2929C19.7071 13.2929 19.7071 13.2929 19.7071 13.2929C20 13.5858 20 14.0572 20 15V15C20 15.9428 20 16.4142 19.7071 16.7071C19.7071 16.7071 19.7071 16.7071 19.7071 16.7071C19.4142 17 18.9428 17 18 17V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17V17C17.4477 17 17 16.5523 17 16L17 14C17 13.4477 17.4477 13 18 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["headphones","music","audio","support","customer-service","help","headset","call-center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12C5 8.13401 8.13401 5 12 5V5C15.866 5 19 8.13401 19 12V13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.29289 16.7071C4 16.4142 4 15.9428 4 15C4 14.0572 4 13.5858 4.29289 13.2929C4.58579 13 5.05719 13 6 13C6.55228 13 7 13.4477 7 14L7 16C7 16.5523 6.55228 17 6 17C5.05719 17 4.58579 17 4.29289 16.7071Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.7071 13.2929C20 13.5858 20 14.0572 20 15C20 15.9428 20 16.4142 19.7071 16.7071C19.4142 17 18.9428 17 18 17C17.4477 17 17 16.5523 17 16V14C17 13.4477 17.4477 13 18 13C18.9428 13 19.4142 13 19.7071 13.2929Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","audio","customer-service","support","call-center","headset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 19V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 13.8954 4.89543 13 6 13C7.10457 13 8 13.8954 8 15V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 13.8954 16.8954 13 18 13C19.1046 13 20 13.8954 20 15V17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "headphones-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","headset","audio","support","helpdesk","customer-service","communication","call-center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C8.68629 6 6 8.68629 6 12C7.10457 12 8.00001 12.8954 8.00001 14L8.00001 16C8.00001 17.1046 7.10458 18 6.00001 18L5.9456 18C5.52153 18.0001 5.10941 18.0002 4.7695 17.9545C4.38629 17.903 3.94902 17.7774 3.5858 17.4142C3.22259 17.051 3.09706 16.6137 3.04554 16.2305C2.99984 15.8906 2.99992 15.4785 3.00001 15.0544V14.9456C2.99992 14.5215 2.99984 14.1094 3.04554 13.7695C3.09706 13.3863 3.22258 12.949 3.5858 12.5858C3.71629 12.4553 3.85634 12.3555 4 12.2788V12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12V12.2788C20.1437 12.3555 20.2837 12.4553 20.4142 12.5858C20.7774 12.949 20.903 13.3863 20.9545 13.7695C21.0002 14.1094 21.0001 14.5215 21 14.9456V15.0544C21.0001 15.4785 21.0002 15.8906 20.9545 16.2305C20.903 16.6137 20.7774 17.051 20.4142 17.4142C20.051 17.7774 19.6137 17.903 19.2305 17.9545C18.8906 18.0002 18.4785 18.0001 18.0544 18L18 18C16.8954 18 16 17.1046 16 16V14C16 12.8954 16.8954 12 18 12C18 8.68631 15.3137 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "headphones-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["headphones","support","customer-service","call-center","audio","help","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 19V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 13.8954 4.89543 13 6 13C7.10457 13 8 13.8954 8 15V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 13.8954 16.8954 13 18 13C19.1046 13 20 13.8954 20 15V17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    headphones: {
        defaultColors: ["#3D4C66"],
        keywords: ["headphones","support","customer-service","call-center","audio","help","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 17V13C4 8.58172 7.58172 5 12 5V5C16.4183 5 20 8.58172 20 13V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17V15C4 14.0572 4 13.5858 4.29289 13.2929C4.58579 13 5.05719 13 6 13C6.94281 13 7.41421 13 7.70711 13.2929C8 13.5858 8 14.0572 8 15V17C8 17.9428 8 18.4142 7.70711 18.7071C7.41421 19 6.94281 19 6 19C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 17V15C16 14.0572 16 13.5858 16.2929 13.2929C16.5858 13 17.0572 13 18 13C18.9428 13 19.4142 13 19.7071 13.2929C20 13.5858 20 14.0572 20 15V17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19C17.0572 19 16.5858 19 16.2929 18.7071C16 18.4142 16 17.9428 16 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "health-2": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#000000"],
        keywords: ["add-customer","new-customer","customer","add","plus","person","new","user","add-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 20H20" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","arch","supplement","health","add-item","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-3": {
        defaultColors: ["#000000"],
        keywords: ["heart","health","favorite","loyalty","reward","care","love","wellness"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H14.75V18C14.75 16.4812 13.5188 15.25 12 15.25C10.4812 15.25 9.25 16.4812 9.25 18V21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3ZM12 6C12.5523 6 13 6.44772 13 7V8H14C14.5523 8 15 8.44772 15 9C15 9.55228 14.5523 10 14 10H13V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V10H10C9.44772 10 9 9.55228 9 9C9 8.44772 9.44772 8 10 8H11V7C11 6.44772 11.4477 6 12 6Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "health-jar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["jar","medicine","medical","health","pharmacy","add","plus","inventory","stock","prescription","supplement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L17.3282 9.9923C17.6616 10.4925 17.8284 10.7426 17.9142 11.026C18 11.3094 18 11.61 18 12.2111V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16L6 12.2111C6 11.61 6 11.3094 6.08582 11.026C6.17163 10.7426 6.33835 10.4925 6.6718 9.9923L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-jar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","health","medicine","add-medicine","pharmacy","medical","plus","add","supplement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.96557 3.50001C6.76046 3.49993 6.53866 3.49984 6.35145 3.52501C6.13212 3.5545 5.85193 3.63033 5.61613 3.86613C5.38033 4.10193 5.3045 4.38212 5.27501 4.60145C5.24984 4.78866 5.24993 5.01046 5.25001 5.21557L5.25001 5.78446C5.24993 5.98958 5.24984 6.21137 5.27501 6.39859C5.3045 6.61791 5.38033 6.8981 5.61614 7.1339C5.85193 7.3697 6.13212 7.44554 6.35145 7.47502C6.53866 7.5002 6.76046 7.50011 6.96557 7.50003H17.0345C17.2396 7.50011 17.4614 7.5002 17.6486 7.47502C17.8679 7.44554 18.1481 7.3697 18.3839 7.1339C18.6197 6.8981 18.6955 6.61791 18.725 6.39859C18.7502 6.21138 18.7501 5.9896 18.75 5.78449V5.21558C18.7501 5.01047 18.7502 4.78866 18.725 4.60145C18.6955 4.38212 18.6197 4.10194 18.3839 3.86614C18.1481 3.63034 17.8679 3.5545 17.6486 3.52501C17.4614 3.49984 17.2396 3.49993 17.0345 3.50001H6.96557Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.70938 8.58397C6.84848 8.37533 7.08265 8.25 7.33342 8.25H16.6667C16.9175 8.25 17.1517 8.37533 17.2908 8.58397L18.0013 9.64966C18.2873 10.0781 18.5134 10.4166 18.6321 10.8086C18.7508 11.2007 18.7505 11.6077 18.7501 12.1229L18.7501 16.052C18.7501 16.9505 18.7501 17.6997 18.6702 18.2945C18.5858 18.9223 18.4001 19.4891 17.9446 19.9445C17.4892 20.4 16.9224 20.5857 16.2946 20.6701C15.6998 20.7501 14.9506 20.75 14.0521 20.75H9.94809C9.04962 20.75 8.30038 20.7501 7.7056 20.6701C7.07781 20.5857 6.51101 20.4 6.05554 19.9445C5.60007 19.4891 5.4144 18.9223 5.32999 18.2945C5.25003 17.6997 5.25005 16.9505 5.25008 16.052L5.25004 12.1229C5.24967 11.6077 5.24938 11.2007 5.36808 10.8086C5.48678 10.4166 5.71281 10.0781 5.99887 9.64966L6.70938 8.58397ZM12.75 12.5C12.75 12.0858 12.4142 11.75 12 11.75C11.5858 11.75 11.25 12.0858 11.25 12.5V13.75H10C9.58579 13.75 9.25 14.0858 9.25 14.5C9.25 14.9142 9.58579 15.25 10 15.25H11.25V16.5C11.25 16.9142 11.5858 17.25 12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5V15.25H14C14.4142 15.25 14.75 14.9142 14.75 14.5C14.75 14.0858 14.4142 13.75 14 13.75H12.75V12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "health-jar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bottle","medicine","pill","health","prescription","pharmacy","add-prescription","add-medication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16V11.6569C18 10.8394 18 10.4306 17.8478 10.0631C17.6955 9.69552 17.4065 9.40649 16.8284 8.82844L16.8284 8.82843L16 8H9.41421C8.83737 8 8.54895 8 8.28018 8.07661C8.13253 8.1187 7.99022 8.17764 7.85606 8.25229C7.61183 8.38817 7.40789 8.59211 7 9C6.59211 9.40789 6.38817 9.61183 6.25229 9.85606C6.17764 9.99022 6.1187 10.1325 6.07661 10.2802C6 10.5489 6 10.8374 6 11.4142V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-jar": {
        defaultColors: ["#3D4C66"],
        keywords: ["medicine","medical","pharmacy","drugs","prescription","health","bottle","add-item","add-medicine","refill","supplement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L17.3282 9.9923C17.6616 10.4925 17.8284 10.7426 17.9142 11.026C18 11.3094 18 11.61 18 12.2111V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16L6 12.2111C6 11.61 6 11.3094 6.08582 11.026C6.17163 10.7426 6.33835 10.4925 6.6718 9.9923L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-location-plus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["location","add-location","plus","add","new-location","pin","map","add-pin","new-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M10 11H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "health-location-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","add-location","plus","add","map-pin","new-store","new-location","add-store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C7.15171 2 3 5.90757 3 10.7976C3 14.2828 5.03514 17.2902 7.97814 18.7143L7.9969 18.7231C8.35654 18.888 8.98398 19.2426 9.60821 19.7384C10.2393 20.2396 10.7968 20.8297 11.1056 21.4472C11.275 21.786 11.6212 22 12 22C12.3788 22 12.725 21.786 12.8944 21.4472C13.2032 20.8297 13.7607 20.2396 14.3918 19.7384C15.016 19.2426 15.6435 18.888 16.0031 18.7231L16.0219 18.7143C18.9649 17.2902 21 14.2828 21 10.7976C21 5.90757 16.8483 2 12 2ZM6.25 11C6.25 7.82436 8.82436 5.25 12 5.25C15.1756 5.25 17.75 7.82436 17.75 11C17.75 14.1756 15.1756 16.75 12 16.75C8.82436 16.75 6.25 14.1756 6.25 11ZM12 14C11.4477 14 11 13.5523 11 13V12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10H11V9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H13V13C13 13.5523 12.5523 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "health-location-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","add","plus","new-location","add-location","map-pin","map-marker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="11"
                    r="5"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 11H14" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "health-location-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map-pin","add","plus","new-location","create-location","new-store","add-store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 11H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "health-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["add","plus","create","new","addition","increase","positive","add-item","add-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 14L10 17C10 17.9428 10 18.4142 10.2929 18.7071C10.5858 19 11.0572 19 12 19V19C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10L14 7C14 6.05719 14 5.58579 13.7071 5.29289C13.4142 5 12.9428 5 12 5V5C11.0572 5 10.5858 5 10.2929 5.29289C10 5.58579 10 6.05719 10 7L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.58579 14 6.05719 14 7 14H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14L17 14C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12V12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "health-plus-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["add","plus","new","create","increase","addition","new-order","add-item","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12C5 12.9428 5 13.4142 5.29289 13.7071C5.58579 14 6.05719 14 7 14H10V17C10 17.9428 10 18.4142 10.2929 18.7071C10.5858 19 11.0572 19 12 19C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17V14H17C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10H16C15.0572 10 14.5858 10 14.2929 9.70711C14 9.41421 14 8.94281 14 8V7C14 6.05719 14 5.58579 13.7071 5.29289C13.4142 5 12.9428 5 12 5C11.0572 5 10.5858 5 10.2929 5.29289C10 5.58579 10 6.05719 10 7V8C10 8.94281 10 9.41421 9.70711 9.70711C9.41421 10 8.94281 10 8 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "health-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["plus","add","create","new","more","increase","addition","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9456 4.00001C11.5215 3.99992 11.1094 3.99984 10.7695 4.04554C10.3863 4.09706 9.94902 4.22259 9.5858 4.5858C9.22259 4.94902 9.09706 5.38629 9.04554 5.7695C8.99984 6.10941 8.99992 6.52154 9.00001 6.9456L9.00001 8.00001C9.00001 8.49969 8.99789 8.77385 8.97232 8.96404L8.97132 8.97132L8.96404 8.97232C8.77385 8.99789 8.49969 9.00001 8.00001 9.00001L6.9456 9.00001C6.52153 8.99992 6.10941 8.99984 5.76949 9.04554C5.38629 9.09706 4.94902 9.22258 4.5858 9.5858C4.22259 9.94902 4.09706 10.3863 4.04554 10.7695C3.99984 11.1094 3.99992 11.5215 4.00001 11.9456V12.0544C3.99992 12.4785 3.99984 12.8906 4.04554 13.2305C4.09706 13.6137 4.22259 14.051 4.5858 14.4142C4.94902 14.7774 5.38629 14.903 5.76949 14.9545C6.10941 15.0002 6.52153 15.0001 6.94559 15L9.00001 15L9.00001 17.0544C8.99992 17.4785 8.99984 17.8906 9.04554 18.2305C9.09706 18.6137 9.22259 19.051 9.5858 19.4142C9.94902 19.7774 10.3863 19.903 10.7695 19.9545C11.1094 20.0002 11.5215 20.0001 11.9455 20H12.0544C12.4785 20.0001 12.8906 20.0002 13.2305 19.9545C13.6137 19.903 14.051 19.7774 14.4142 19.4142C14.7774 19.051 14.903 18.6137 14.9545 18.2305C15.0002 17.8906 15.0001 17.4785 15 17.0544L15 15L17.0544 15C17.4785 15.0001 17.8906 15.0002 18.2305 14.9545C18.6137 14.903 19.051 14.7774 19.4142 14.4142C19.7774 14.051 19.903 13.6137 19.9545 13.2305C20.0002 12.8906 20.0001 12.4785 20 12.0545V11.9456C20.0001 11.5216 20.0002 11.1094 19.9545 10.7695C19.903 10.3863 19.7774 9.94902 19.4142 9.5858C19.051 9.22258 18.6137 9.09706 18.2305 9.04554C17.8906 8.99984 17.4785 8.99992 17.0544 9.00001L16 9.00001C15.5003 9.00001 15.2262 8.99789 15.036 8.97232L15.0287 8.97132L15.0277 8.96404C15.0021 8.77385 15 8.49969 15 8.00001L15 6.9456C15.0001 6.52154 15.0002 6.10941 14.9545 5.76949C14.903 5.38629 14.7774 4.94902 14.4142 4.5858C14.051 4.22259 13.6137 4.09706 13.2305 4.04554C12.8906 3.99984 12.4785 3.99992 12.0544 4.00001H11.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "health-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["plus","add","create","new","increase","positive","addition","include","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12V12C5 12.9428 5 13.4142 5.29289 13.7071C5.58579 14 6.05719 14 7 14H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 14L10 17C10 17.9428 10 18.4142 10.2929 18.7071C10.5858 19 11.0572 19 12 19V19C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14L17 14C17.9428 14 18.4142 14 18.7071 13.7071C19 13.4142 19 12.9428 19 12V12C19 11.0572 19 10.5858 18.7071 10.2929C18.4142 10 17.9428 10 17 10L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 10L14 7C14 6.05719 14 5.58579 13.7071 5.29289C13.4142 5 12.9428 5 12 5V5C11.0572 5 10.5858 5 10.2929 5.29289C10 5.58579 10 6.05719 10 7L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    health: {
        defaultColors: ["#3d4c66", "#000000"],
        keywords: ["plus","add","create","new","increase","positive","addition","include","expand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "heart plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["heart","plus","add","favorites","add-favorite","loyalty","loyalty-program","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","plus","add","favorite","loyalty","rewards","loyalty-program","add-favorite","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2343 5.35265C17.7769 4.19521 16.3753 3.74967 14.9272 4.13405C13.8716 4.41423 12.9185 5.1117 12.0001 5.96793C11.0816 5.11169 10.1285 4.41425 9.07287 4.1341C7.62472 3.74976 6.22306 4.19533 4.76574 5.35277C4.73704 5.37556 4.70962 5.39991 4.6836 5.42571C2.53177 7.55915 2.42964 10.9896 4.45215 13.2455C4.4707 13.2662 4.4901 13.2861 4.51031 13.3052L11.3136 19.7269C11.699 20.0906 12.3012 20.0906 12.6865 19.7269L19.4897 13.3051C19.5099 13.286 19.5293 13.2661 19.5479 13.2454C21.5704 10.9895 21.4682 7.55903 19.3164 5.42559C19.2904 5.39979 19.263 5.37544 19.2343 5.35265ZM13 9.99976C13 9.44747 12.5523 8.99976 12 8.99976C11.4477 8.99976 11 9.44747 11 9.99976V10.9998H10C9.44772 10.9998 9 11.4475 9 11.9998C9 12.552 9.44772 12.9998 10 12.9998H11V13.9998C11 14.552 11.4477 14.9998 12 14.9998C12.5523 14.9998 13 14.552 13 13.9998V12.9998H14C14.5523 12.9998 15 12.552 15 11.9998C15 11.4475 14.5523 10.9998 14 10.9998H13V9.99976Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["favorite","add","plus","wishlist","add-to-wishlist","loyalty","add-loyalty","reward","add-reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","plus","add","favorite","add-favorite","loyalty","add-loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["heart","love","favorite","loyalty","rewards","preferred","wishlist","save","like"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.82349 13.5371L12 8.03711" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M10.2064 6.13141C8.78661 4.62286 6.48466 4.62286 5.06485 6.13141C3.64505 7.63995 3.64505 10.0858 5.06485 11.5943L6.82353 13.5371L11.9651 19L18.9351 11.5943C20.3549 10.0858 20.3549 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709L10.2064 6.13141Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "heart v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","favorites","loyalty","rewards","customer","appreciation","like","love","save","wishlist","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.06485 6.13141C6.48466 4.62286 8.78661 4.62286 10.2064 6.13141L12 8.03709L13.7936 6.13141C15.2134 4.62286 17.5153 4.62286 18.9351 6.13141C20.3549 7.63995 20.3549 10.0858 18.9351 11.5943L11.9651 19L6.82353 13.5371L5.06485 11.5943C3.64505 10.0858 3.64505 7.63995 5.06485 6.13141Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6.82353 13.5371L11.9651 19L18.9351 11.5943C20.355 10.0858 20.355 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709M6.82353 13.5371L12 8.03709M6.82353 13.5371L5.06485 11.5943C3.64505 10.0858 3.64505 7.63995 5.06485 6.13141C6.48466 4.62286 8.78661 4.62286 10.2064 6.13141L12 8.03709"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.2064 6.13141C8.78661 4.62286 6.48466 4.62286 5.06485 6.13141C3.64505 7.63995 3.64505 10.0858 5.06485 11.5943L6.82353 13.5371L12 8.03709L10.2064 6.13141Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "heart v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","like","loyalty","rewards","customer","save","wishlist","promotion","loyalty program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.6633 5.44604C17.8487 3.51799 14.88 3.51799 13.0654 5.44604L12 6.57801L10.9346 5.44604C9.11998 3.51799 6.15129 3.51799 4.33665 5.44604C2.55679 7.33714 2.55445 10.3781 4.32963 12.2722L6.08868 14.2154L11.9651 20.4591L19.6633 12.2797C21.4455 10.3861 21.4455 7.33963 19.6633 5.44604ZM8.19678 13.5371L11.9651 17.5409L18.2069 10.909C19.2644 9.78546 19.2644 7.94026 18.2069 6.81677C17.182 5.72774 15.5468 5.72774 14.5218 6.81677L8.19678 13.5371Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","loyalty","rewards","customer","like","love","preferred","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.82353 13.5371L11.9651 19L18.9351 11.5943C20.355 10.0858 20.355 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709M6.82353 13.5371L12 8.03709M6.82353 13.5371L5.06485 11.5943C3.64505 10.0858 3.64505 7.63995 5.06485 6.13141C6.48466 4.62286 8.78661 4.62286 10.2064 6.13141L12 8.03709"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "heart v3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["heart","favorite","loyalty","rewards","customer-loyalty","wishlist","save","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 18.9999L5.19672 12.5782C3.53015 10.7193 3.61387 7.8947 5.38766 6.13606C8.00003 4.06127 9.71433 5.03989 12.0001 7.36731"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19L18.8032 12.5782C20.4698 10.7193 20.3861 7.89466 18.6123 6.13602C15.9999 4.06123 14.2857 5.03997 12 7.36739"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v3-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["heart","favorite","loyalty","rewards","like","preferred","wishlist","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","like","loyalty","rewards","wishlist","saved-items","customer-loyalty","preferred","donation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.9272 4.13405C16.3753 3.74967 17.7769 4.19521 19.2343 5.35265C19.263 5.37544 19.2904 5.39979 19.3164 5.42559C21.4682 7.55903 21.5704 10.9895 19.5479 13.2454C19.5293 13.2661 19.5099 13.286 19.4897 13.3051L12.6865 19.7269C12.3012 20.0906 11.699 20.0906 11.3136 19.7269L4.51031 13.3052C4.4901 13.2861 4.4707 13.2662 4.45215 13.2455C2.42964 10.9896 2.53177 7.55915 4.6836 5.42571C4.70962 5.39991 4.73704 5.37556 4.76574 5.35277C6.22306 4.19533 7.62472 3.74976 9.07287 4.1341C10.1285 4.41425 11.0816 5.11169 12.0001 5.96793C12.9185 5.1117 13.8716 4.41423 14.9272 4.13405Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","wishlist","loyalty","rewards","like","save","customer-preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["heart","favorite","love","loyalty","wishlist","preferred","saved","liked","popular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6.90967L13.1429 8.46162"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.2807 12.8482L12 19L18.7193 12.8482C20.4269 11.0528 20.4269 8.14192 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 6.90959L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v4-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["heart","favorite","like","loyalty","rewards","wishlist","saved","preferred","customer","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.2807 12.8482L12 19L18.7193 12.8482C20.4269 11.0528 20.4269 8.14192 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 6.90959L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M12 6.90959L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482L12 19L18.7193 12.8482C20.4269 11.0528 20.4269 8.14192 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 6.90959ZM12 6.90959L13.1429 8.46154"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","loyalty","rewards","customer","liked","favourites","wishlist","heart-icon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4439 5.65736C17.404 3.51262 14.1135 3.44946 12 5.46788C9.88646 3.44946 6.59598 3.51262 4.5561 5.65736C2.4813 7.83882 2.4813 11.3559 4.5561 13.5374C4.57198 13.5541 4.58843 13.5702 4.60543 13.5858L11.3247 19.7376C11.7069 20.0875 12.2931 20.0875 12.6753 19.7376L19.3946 13.5858C19.4116 13.5702 19.428 13.5541 19.4439 13.5374C21.5187 11.3559 21.5187 7.83882 19.4439 5.65736ZM13.5708 6.51348C13.3022 6.19821 12.8288 6.16042 12.5135 6.42908C12.1983 6.69774 12.1605 7.17111 12.4291 7.48638L13.185 8.37344C13.4537 8.68871 13.9271 8.7265 14.2423 8.45784C14.5576 8.18919 14.5954 7.71582 14.3267 7.40055L13.5708 6.51348Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","like","love","loyalty","reward","customer-appreciation","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6.90959L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482L12 19L18.7193 12.8482C20.4269 11.0528 20.4269 8.14192 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 6.90959ZM12 6.90959L13.1429 8.46154"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorite","like","loyalty","rewards","customer-rewards","saved-items","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2064 6.13141C8.78661 4.62286 6.48466 4.62286 5.06485 6.13141C3.64505 7.63995 3.64505 10.0858 5.06485 11.5943L6.82353 13.5371L11.9651 19L18.9351 11.5943C20.3549 10.0858 20.3549 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709L10.2064 6.13141Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["heart","favorite","loyalty","rewards","customer","love","preferred","saved","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2064 6.13141C8.78661 4.62286 6.48466 4.62286 5.06485 6.13141C3.64505 7.63995 3.64505 10.0858 5.06485 11.5943L6.82353 13.5371L11.9651 19L18.9351 11.5943C20.3549 10.0858 20.3549 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709L10.2064 6.13141Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","favorites","loyalty","rewards","preferred","wishlist","love","like","save","favorite-customer","vip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.33665 5.44604C6.15129 3.51799 9.11998 3.51799 10.9346 5.44604L12 6.57801L13.0654 5.44604C14.88 3.51799 17.8487 3.51799 19.6633 5.44604C21.4455 7.33963 21.4455 10.3861 19.6633 12.2797L12.6933 19.6854C12.5043 19.8862 12.2408 20 11.9651 20C11.6894 20 11.4259 19.8862 11.2369 19.6854L4.32963 12.2722C2.55445 10.3781 2.55679 7.33714 4.33665 5.44604Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-care-1": {
        defaultColors: ["#2797e8", "#000000"],
        keywords: ["queue","line","customer-flow","waiting","service","next","number","take-a-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12.0234 7.02341L11.3411 7.6899C10.6285 8.38602 10.6861 9.54888 11.464 10.1712C12.0697 10.6557 12.9303 10.6557 13.536 10.1712L15 9L19.7393 12.3491"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.26071 5.43248C5.94167 3.52251 8.66703 3.52251 10.348 5.43248L12 7L12.0234 7.02341L13.652 5.43248C15.333 3.52251 18.0583 3.52251 19.7393 5.43248C21.4202 7.34246 21.4202 10.4391 19.7393 12.3491L12 20L4.26071 12.3491C2.57976 10.4391 2.57976 7.34246 4.26071 5.43248Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-care-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["heart","loyalty","membership","rewards","favorites","love","care","health","well-being","customer-loyalty","customer-rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L10.348 5.43248C8.66703 3.52251 5.94167 3.52251 4.26071 5.43248C2.57976 7.34246 2.57976 10.4391 4.26071 12.3491L12 20L19.7393 12.3491"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.652 5.43248C15.3329 3.52251 18.0583 3.52251 19.7393 5.43248C21.4202 7.34246 21.4202 10.4391 19.7393 12.3491L15 9L13.536 10.1712C12.9303 10.6557 12.0697 10.6557 11.464 10.1712C10.6861 9.54888 10.6285 8.38602 11.3411 7.6899L13.652 5.43248Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-care-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","loyalty","rewards","care","membership","favorite","customer","patients"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3098 4.93061C18.3328 2.68422 15.0866 2.6768 13.1012 4.90835L10.8101 7.14648C9.77086 8.16162 9.85483 9.85738 10.9892 10.7649C11.8725 11.4715 13.1275 11.4715 14.0108 10.7649L15.0283 9.95086L19.3007 12.97C19.6017 13.1827 20.0089 13.1476 20.269 12.8943C20.2831 12.8807 20.2967 12.8664 20.3098 12.8515C22.2434 10.6544 22.2434 7.12765 20.3098 4.93061Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.9274 4.93492L9.76187 6.07347C8.07814 7.71826 8.21419 10.4658 10.0522 11.9362C11.4833 13.0811 13.5167 13.0811 14.9478 11.9362L15.0842 11.8271L18.435 14.195C18.5394 14.2688 18.648 14.3325 18.7598 14.3864L12.5343 20.5407C12.2382 20.8334 11.7618 20.8334 11.4657 20.5407L3.7264 12.8898C3.71389 12.8775 3.70181 12.8647 3.69019 12.8515C1.75659 10.6544 1.75659 7.12765 3.69019 4.93061C5.66595 2.68566 8.90922 2.67681 10.895 4.90407L10.9274 4.93492Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-care": {
        defaultColors: ["#000000"],
        keywords: ["heart","health","care","favorite","loyalty","rewards","medical","wellness"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L10.348 5.43248C8.66703 3.52251 5.94167 3.52251 4.26071 5.43248C2.57976 7.34246 2.57976 10.4391 4.26071 12.3491L12 20L19.7393 12.3491M19.7393 12.3491C21.4202 10.4391 21.4202 7.34246 19.7393 5.43248C18.0583 3.52251 15.333 3.52251 13.652 5.43248L11.3411 7.6899C10.6285 8.38602 10.6861 9.54888 11.464 10.1712C12.0697 10.6557 12.9303 10.6557 13.536 10.1712L15 9L19.7393 12.3491Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-circle-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["favorite","add-favorite","add-item-to-wishlist","wishlist","add","plus","heart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7925 11C20.2745 9.4132 19.9168 7.60558 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 7L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482L12 19L14 17.1689"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="17" cy="14" r="4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M17 13V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14L18 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-circle-plus-2": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#FFFFFF"],
        keywords: ["favorite","add-favorite","add","plus","heart","circle","loyalty","reward","add-loyalty","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle
                    cx="17"
                    cy="14"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 13V15" stroke={colors?.[2] || "#FFFFFF"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 14L18 14" stroke={colors?.[2] || "#FFFFFF"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "heart-circle-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","add","plus","favorite","loyalty","reward","add-favorite","add-loyalty","add-reward","customer","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2343 5.35265C17.7769 4.19521 16.3753 3.74967 14.9272 4.13405C13.8716 4.41423 12.9185 5.1117 12.0001 5.96793C11.0816 5.11169 10.1285 4.41425 9.07287 4.13409C7.62472 3.74976 6.22306 4.19533 4.76574 5.35277C4.73704 5.37556 4.70962 5.39991 4.6836 5.42571C2.53177 7.55915 2.42964 10.9896 4.45215 13.2455C4.4707 13.2662 4.4901 13.2861 4.51031 13.3052L11.3136 19.7269C11.699 20.0906 12.3012 20.0906 12.6865 19.7269L14.2969 18.2068C12.9151 17.3171 12 15.7653 12 13.9998C12 11.2383 14.2386 8.99976 17 8.99976C18.543 8.99976 19.9227 9.69867 20.8399 10.7972C21.2946 8.92484 20.7789 6.87563 19.3164 5.42559C19.2904 5.39979 19.263 5.37544 19.2343 5.35265Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 9.99976C14.7909 9.99976 13 11.7906 13 13.9998C13 16.2089 14.7909 17.9998 17 17.9998C19.2091 17.9998 21 16.2089 21 13.9998C21 11.7906 19.2091 9.99976 17 9.99976ZM17 11.9998C17.3682 11.9998 17.6667 12.2982 17.6667 12.6664V13.3331H18.3333C18.7015 13.3331 19 13.6316 19 13.9998C19 14.3679 18.7015 14.6664 18.3333 14.6664H17.6667V15.3331C17.6667 15.7013 17.3682 15.9998 17 15.9998C16.6318 15.9998 16.3333 15.7013 16.3333 15.3331V14.6664H15.6667C15.2985 14.6664 15 14.3679 15 13.9998C15 13.6316 15.2985 13.3331 15.6667 13.3331H16.3333V12.6664C16.3333 12.2982 16.6318 11.9998 17 11.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-circle-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["favorite","add","heart","plus","love","add-favorite","add-to-favorites","loyalty","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7925 11C20.2745 9.4132 19.9168 7.60558 18.7193 6.34654C17.0117 4.55116 14.2431 4.55115 12.5355 6.34654L12 7L11.4645 6.34654C9.75687 4.55115 6.9883 4.55116 5.2807 6.34654C3.5731 8.14192 3.5731 11.0528 5.2807 12.8482L12 19L14 17.1689"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="17" cy="14" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M17 13V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 14L18 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-crack-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["heart","broken","failure","error","problem","issue","cancel","decline","unavailable","out-of-stock","damage","fault","defect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8L11 10.0001H13L11.9998 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-crack-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","zap","failure","issue","error","electrical","damage","defect","loyalty-issue","customer-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8L11 11.0002H13L11.9998 14.0002"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-crack": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","broken","error","unavailable","discount-expired","issue","problem","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8L11 10.0001H13L11.9998 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-crack-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","broken","damage","error","cancel","problem","issue","reject","failure","fault","malfunction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2343 5.35265C17.7769 4.19521 16.3753 3.74967 14.9272 4.13405C14.2453 4.31504 13.6062 4.67017 12.9915 5.12973C12.99 5.14119 12.9883 5.15266 12.9864 5.16415L12.1805 9.99998H13C13.3215 9.99998 13.6233 10.1545 13.8113 10.4153C13.9992 10.6761 14.0503 11.0113 13.9487 11.3163L12.9485 14.3163C12.7738 14.8402 12.2075 15.1233 11.6835 14.9486C11.1596 14.774 10.8765 14.2076 11.0511 13.6837L11.6125 12H11C10.706 12 10.427 11.8707 10.237 11.6464C10.047 11.4221 9.96528 11.1255 10.0136 10.8356L10.9694 5.10062C10.3668 4.65519 9.74032 4.31123 9.07287 4.13409C7.62472 3.74976 6.22306 4.19533 4.76574 5.35277C4.73704 5.37556 4.70962 5.39991 4.6836 5.42571C2.53177 7.55915 2.42964 10.9896 4.45215 13.2455C4.4707 13.2662 4.4901 13.2861 4.51031 13.3052L11.3136 19.7269C11.699 20.0906 12.3012 20.0906 12.6865 19.7269L19.4897 13.3051C19.5099 13.286 19.5293 13.2661 19.5479 13.2454C21.5704 10.9895 21.4682 7.55903 19.3164 5.42559C19.2904 5.39979 19.263 5.37544 19.2343 5.35265Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-pulse v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["heart","pulse","health","wellness","vitality","loyalty","rewards","membership","customer","care"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H10.5L11.25 10L12.75 14L13.5 12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-pulse v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","pulse","health","wellness","medical","loyalty","rewards","customer-health","heartbeat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H10.5L11.25 10L12.75 14L13.5 12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-pulse v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["loyalty","rewards","heart","pulse","health","wellness","customer-loyalty","rewards-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2343 5.35265C17.7769 4.19521 16.3753 3.74967 14.9272 4.13405C13.8716 4.41423 12.9185 5.1117 12.0001 5.96793C11.0816 5.11169 10.1285 4.41425 9.07287 4.13409C7.62472 3.74976 6.22306 4.19533 4.76574 5.35277C4.73704 5.37556 4.70962 5.39991 4.6836 5.42571C2.53177 7.55915 2.42964 10.9896 4.45215 13.2455C4.4707 13.2662 4.4901 13.2861 4.51031 13.3052L11.3136 19.7269C11.699 20.0906 12.3012 20.0906 12.6865 19.7269L19.4897 13.3051C19.5099 13.286 19.5293 13.2661 19.5479 13.2454C21.5704 10.9895 21.4682 7.55903 19.3164 5.42559C19.2904 5.39979 19.263 5.37544 19.2343 5.35265ZM12.1863 9.64863C12.04 9.25833 11.6668 8.99976 11.25 8.99976C10.8332 8.99976 10.46 9.25833 10.3137 9.64863L9.807 10.9998H9C8.44772 10.9998 8 11.4475 8 11.9998C8 12.552 8.44772 12.9998 9 12.9998H10.5C10.7674 12.9998 11.0168 12.8934 11.1999 12.7141L11.8137 14.3509C11.96 14.7412 12.3332 14.9998 12.75 14.9998C13.1668 14.9998 13.54 14.7412 13.6863 14.3509L14.193 12.9998H15C15.5523 12.9998 16 12.552 16 11.9998C16 11.4475 15.5523 10.9998 15 10.9998H13.5C13.2326 10.9998 12.9832 11.1061 12.8001 11.2854L12.1863 9.64863Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-pulse v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","pulse","health","wellness","loyalty","rewards","customer","healthcare","vital","monitor","rate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H10.5L11.25 10L12.75 14L13.5 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-pulse-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["heart","pulse","loyalty","rewards","health","vitality","metrics","data","heartbeat","customer-health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H10L11 10L13 14L14 12H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-pulse-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","pulse","health","vitality","wellness","customer-loyalty","rewards","loyalty-program","membership","VIP"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H10L11 10L13 14L14 12H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-pulse-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","pulse","health","wellness","loyalty","rewards","customer","member","membership","healthy-choice","loyalty-program","customer-rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2343 5.35265C17.7769 4.19521 16.3753 3.74967 14.9272 4.13405C13.8716 4.41423 12.9185 5.1117 12.0001 5.96793C11.0816 5.11169 10.1285 4.41425 9.07287 4.1341C7.62472 3.74976 6.22306 4.19533 4.76574 5.35277C4.73704 5.37556 4.70962 5.39991 4.6836 5.42571C3.16817 6.92819 2.66933 9.07399 3.21327 10.9998H9.38197L10.1056 9.55254C10.275 9.21376 10.6212 8.99976 11 8.99976C11.3788 8.99976 11.725 9.21376 11.8944 9.55254L13 11.7637L13.1056 11.5525C13.275 11.2138 13.6212 10.9998 14 10.9998H20.7867C21.3307 9.07396 20.8319 6.92811 19.3164 5.42559C19.2904 5.39979 19.263 5.37544 19.2343 5.35265Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.7561 12.9998H14.618L13.8944 14.447C13.725 14.7858 13.3788 14.9998 13 14.9998C12.6212 14.9998 12.275 14.7858 12.1056 14.447L11 12.2358L10.8944 12.447C10.725 12.7858 10.3788 12.9998 10 12.9998H4.24382C4.31057 13.0831 4.38001 13.1651 4.45215 13.2455C4.4707 13.2662 4.4901 13.2861 4.51031 13.3052L11.3136 19.7269C11.699 20.0906 12.3012 20.0906 12.6865 19.7269L19.4897 13.3051C19.5099 13.286 19.5293 13.2661 19.5479 13.2454C19.62 13.165 19.6894 13.0831 19.7561 12.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "heart-pulse": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","health","pulse","monitor","medical","wellness","loyalty","rewards","favorites","customer-health","heartbeat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H10L11 10L13 14L14 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "heart-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["heart","slash","remove-favorite","unfavorite","disable","unavailable","out-of-stock","discount-unavailable","loyalty-program-inactive","heart-slash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M18 18L4 4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "heart-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heart","slash","remove","delete","unavailable","dislike","unfavorite","block","disable","no-favorites"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M18 18L4 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "heart-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","slash","remove","delete","unlike","blacklist","block","disable","unavailable","out-of-stock","dislike","favorite-remove","discount-remove","promotion-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 19L5.19672 12.5783C3.53015 10.7194 3.61387 7.89478 5.38766 6.13614C8.00003 4.06135 9.71433 5.03997 12.0001 7.36739C14.2858 5.03997 16 4.06123 18.6123 6.13602C20.3861 7.89466 20.4699 10.7193 18.8033 12.5782L12.0001 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M18 18L4 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "heart-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","slash","remove-favorite","unlike","unfavorite","no-loyalty","cancel-membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.3201 5.43006C19.3201 5.43006 19.2701 5.38006 19.2401 5.36006C17.7801 4.20006 16.3801 3.76006 14.9301 4.14006C13.8701 4.42006 12.9201 5.12006 12.0001 5.97006C11.0801 5.11006 10.1301 4.42006 9.07006 4.14006C8.03006 3.86006 7.01006 4.02006 5.97006 4.57006L4.71006 3.29006C4.32006 2.90006 3.68006 2.90006 3.29006 3.29006C2.90006 3.68006 2.90006 4.32006 3.29006 4.71006L17.2901 18.7101C17.6801 19.1001 18.3101 19.1001 18.7001 18.7101C19.0901 18.3201 19.0901 17.6901 18.7001 17.3001L17.0301 15.6301L19.4801 13.3101C19.4801 13.3101 19.5201 13.2701 19.5401 13.2501C21.5601 10.9901 21.4601 7.56006 19.3101 5.43006H19.3201Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.45006 13.2501C4.45006 13.2501 4.49006 13.2901 4.51006 13.3101L11.3101 19.7301C11.7001 20.0901 12.3001 20.0901 12.6801 19.7301L14.5501 17.9701L3.57006 6.98006C2.59006 9.00006 2.87006 11.4801 4.45006 13.2401V13.2501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    heart: {
        defaultColors: ["#3D4C66"],
        keywords: ["heart","slash","remove-favorite","unlike","unfavorite","no-loyalty","cancel-membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2064 6.13141C8.78661 4.62286 6.48466 4.62286 5.06485 6.13141C3.64505 7.63995 3.64505 10.0858 5.06485 11.5943L6.82353 13.5371L11.9651 19L18.9351 11.5943C20.3549 10.0858 20.3549 7.63995 18.9351 6.13141C17.5153 4.62286 15.2134 4.62286 13.7936 6.13141L12 8.03709L10.2064 6.13141Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","hexagon","confirm","validation","approved","success","order-confirmation","payment-successful","inventory-ok","available","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11.8933L11 13.8756L15 9.91113"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hexagon","check","tick","confirm","validate","approved","success","completed","order-complete","payment-received","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11.8933L11 13.8756L15 9.91113"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","check","confirmation","success","approved","verified","valid","accept","complete","correct","tick","ok","confirmation","completed","passed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.39649 4C7.89052 4 6.51218 4.84584 5.83018 6.18854L3.79843 10.1885C3.22018 11.327 3.22018 12.673 3.79843 13.8115L5.83018 17.8115C6.51218 19.1542 7.89052 20 9.39649 20H14.6034C16.1093 20 17.4877 19.1542 18.1697 17.8115L20.2014 13.8115C20.7797 12.673 20.7797 11.327 20.2014 10.1885L18.1697 6.18854C17.4877 4.84584 16.1093 4 14.6034 4H9.39649ZM15.7039 10.6214C16.0962 10.2326 16.099 9.59946 15.7103 9.20719C15.3215 8.81493 14.6883 8.8121 14.2961 9.20087L11 12.4676L9.70394 11.1831C9.31168 10.7943 8.67852 10.7971 8.28974 11.1894C7.90097 11.5817 7.90379 12.2148 8.29606 12.6036L10.2961 14.5858C10.6858 14.9721 11.3142 14.9721 11.7039 14.5858L15.7039 10.6214Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["check","hexagon","confirm","validate","success","completed","approved","order-confirmed","payment-success","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11.8933L11 13.8756L15 9.91113"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-divide-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["divide","split","share","discount","reduction","calculation","hexagon","split-bill","equal-payments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-divide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["divide","division","split","share","percentage","discount","calculation","math","calculation","distribute","fraction","rate","split-bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M15 12H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 10H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-divide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","division","split","split-bill","calculation","discount","percentage","ratio","share","allocate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM11.4999 8C10.9476 8 10.4999 8.44772 10.4999 9C10.4999 9.55228 10.9476 10 11.4999 10H12.4999C13.0522 10 13.4999 9.55228 13.4999 9C13.4999 8.44772 13.0522 8 12.4999 8H11.4999ZM8.99988 11C8.44759 11 7.99988 11.4477 7.99988 12C7.99988 12.5523 8.44759 13 8.99988 13H14.9999C15.5522 13 15.9999 12.5523 15.9999 12C15.9999 11.4477 15.5522 11 14.9999 11H8.99988ZM11.4999 14C10.9476 14 10.4999 14.4477 10.4999 15C10.4999 15.5523 10.9476 16 11.4999 16H12.4999C13.0522 16 13.4999 15.5523 13.4999 15C13.4999 14.4477 13.0522 14 12.4999 14H11.4999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-divide": {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","division","split","discount","split-bill","split-tender","calculations","calculation","math","mathematics","hexagon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-exclamation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alert","warning","error","exclamation","notification","problem","issue","danger","caution","attention","flag","important","critical","invalid","incorrect","exception","event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-exclamation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["exclamation","warning","error","alert","attention","issue","problem","critical","notification","flag","pending","invalid","exception","trouble","incorrect","fault","urgent","important","attention-needed","error-message"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","exclamation","alert","error","problem","issue","notification","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.39698 4C7.89101 4 6.51267 4.84584 5.83067 6.18854L3.79892 10.1885C3.22067 11.327 3.22067 12.673 3.79892 13.8115L5.83066 17.8115C6.51267 19.1542 7.89101 20 9.39698 20H14.6039C16.1098 20 17.4882 19.1542 18.1702 17.8115L20.2019 13.8115C20.7802 12.673 20.7802 11.327 20.2019 10.1885L18.1702 6.18854C17.4882 4.84584 16.1098 4 14.6039 4H9.39698ZM11.0005 12C11.0005 12.5523 11.4482 13 12.0005 13C12.5528 13 13.0005 12.5523 13.0005 12V8C13.0005 7.44772 12.5528 7 12.0005 7C11.4482 7 11.0005 7.44772 11.0005 8L11.0005 12ZM11.0005 16C11.0005 16.5523 11.4482 17 12.0005 17C12.5528 17 13.0005 16.5523 13.0005 16V15C13.0005 14.4477 12.5528 14 12.0005 14C11.4482 14 11.0005 14.4477 11.0005 15V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","exclamation","error","alert","attention","issue","problem","incorrect","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-info-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["info","information","details","help","support","faq","about","hexagon","alert","warning","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-info-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["info","information","details","more-info","help","support","explanation","about","hexagon","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-info-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","about","help","hexagon","alert","warning","support","question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM12.9999 9C12.9999 8.44772 12.5522 8 11.9999 8C11.4476 8 10.9999 8.44772 10.9999 9V9.5C10.9999 10.0523 11.4476 10.5 11.9999 10.5C12.5522 10.5 12.9999 10.0523 12.9999 9.5V9ZM12.9999 12.5C12.9999 11.9477 12.5522 11.5 11.9999 11.5C11.4476 11.5 10.9999 11.9477 10.9999 12.5V15C10.9999 15.5523 11.4476 16 11.9999 16C12.5522 16 12.9999 15.5523 12.9999 15V12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-info": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","hexagon","alert","warning","notification","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hexagon","minus","subtract","remove","delete","less","decrease","reduction","discount","price-reduction","quantity-decrease","item-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","minus","subtract","decrease","remove","delete","less","discount","reduction","quantity","item","decrease-quantity","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM9.99988 11C9.44759 11 8.99988 11.4477 8.99988 12C8.99988 12.5523 9.44759 13 9.99988 13H13.9999C14.5522 13 14.9999 12.5523 14.9999 12C14.9999 11.4477 14.5522 11 13.9999 11H9.99988Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minus","remove","delete","subtract","decrease","reduction","less","discount","remove-item","reduce","hexagon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["remove","subtract","decrease","minus","discount","delete","reduce","cut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hexagon","plus","add","new","create","item","add-item","new-item","inventory","add-inventory","new-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["add","plus","create","new","item","add-item","new-item","inventory","new-inventory","add-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","plus","add","new","create","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM12.9999 10C12.9999 9.44772 12.5522 9 11.9999 9C11.4476 9 10.9999 9.44772 10.9999 10V11H9.99988C9.44759 11 8.99988 11.4477 8.99988 12C8.99988 12.5523 9.44759 13 9.99988 13H10.9999V14C10.9999 14.5523 11.4476 15 11.9999 15C12.5522 15 12.9999 14.5523 12.9999 14V13H13.9999C14.5522 13 14.9999 12.5523 14.9999 12C14.9999 11.4477 14.5522 11 13.9999 11H12.9999V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","plus","add","create","new","item","add-item","add-product","new-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-question-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["question","help","support","faq","information","query","assistance","unknown","doubt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-question-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["question","help","support","faq","information","unknown","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-question-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","information","query","assistance","unknown","doubt","hexagon","quiz"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM10.7499 10C10.7499 9.30964 11.3095 8.75 11.9999 8.75C12.6902 8.75 13.2499 9.30964 13.2499 10C13.2499 10.6904 12.6902 11.25 11.9999 11.25C11.5857 11.25 11.2499 11.5858 11.2499 12V13C11.2499 13.4142 11.5857 13.75 11.9999 13.75C12.4141 13.75 12.7499 13.4142 12.7499 13V12.6465C13.9041 12.32 14.7499 11.2588 14.7499 10C14.7499 8.48122 13.5187 7.25 11.9999 7.25C10.4811 7.25 9.24988 8.48122 9.24988 10C9.24988 10.4142 9.58566 10.75 9.99988 10.75C10.4141 10.75 10.7499 10.4142 10.7499 10ZM12.7499 15.5C12.7499 15.0858 12.4141 14.75 11.9999 14.75C11.5857 14.75 11.2499 15.0858 11.2499 15.5V15.75C11.2499 16.1642 11.5857 16.5 11.9999 16.5C12.4141 16.5 12.7499 16.1642 12.7499 15.75V15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-question": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","unknown","query","assistance","information","hexagon","doubt","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-slash-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hexagon","slash","prohibited","blocked","disabled","invalid","error","unavailable","restricted","access-denied","not-allowed","not-available"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 17L7 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hexagon","slash","disable","block","restriction","unavailable","forbidden","cancel","remove","delete","void","reject"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L7 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hexagon-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["disabled","unavailable","prohibited","blocked","no","cancel","remove","delete","error","invalid","hexagon","slash","restriction","denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.47484 6.88906L3.79892 10.1885C3.22067 11.327 3.22067 12.673 3.79892 13.8115L5.83066 17.8115C6.51267 19.1542 7.89101 20 9.39698 20H14.6039C15.6771 20 16.6855 19.5704 17.4233 18.8375L5.47484 6.88906Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.5257 17.1115L20.2019 13.8115C20.7802 12.673 20.7802 11.327 20.2019 10.1885L18.1702 6.18854C17.4882 4.84584 16.1098 4 14.6039 4H9.39698C8.32352 4 7.31491 4.42976 6.57711 5.16289L18.5257 17.1115Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","slash","forbidden","restricted","unavailable","disable","block","inactive","not-available","not-allowed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L7 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Hexagon-User-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","profile","account","customer","employee","hexagon","user-profile","user-account","customer-profile","employee-profile","manager","supervisor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.89443 13.7889L5.89443 17.7889C6.572 19.144 7.95705 20 9.47214 20H12H14.5279C16.043 20 17.428 19.144 18.1056 17.7889L20.1056 13.7889C20.6686 12.6627 20.6686 11.3373 20.1056 10.2111L18.1056 6.21114C17.428 4.85601 16.043 4 14.5279 4H12H9.47214C7.95705 4 6.572 4.85601 5.89443 6.21114L3.89443 10.2111C3.33137 11.3373 3.33137 12.6627 3.89443 13.7889Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6 15H11.4C10.0745 15 9 15.2462 9 16.1667C9 16.6269 9.44772 17 10 17H14C14.5523 17 15 16.6269 15 16.1667C15 15.2462 13.9255 15 12.6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Hexagon-User-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","user-profile","customer-profile","employee-profile","login","access","manage-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.89443 13.7889L5.89443 17.7889C6.572 19.144 7.95705 20 9.47214 20H12H14.5279C16.043 20 17.428 19.144 18.1056 17.7889L20.1056 13.7889C20.6686 12.6627 20.6686 11.3373 20.1056 10.2111L18.1056 6.21114C17.428 4.85601 16.043 4 14.5279 4H12H9.47214C7.95705 4 6.572 4.85601 5.89443 6.21114L3.89443 10.2111C3.33137 11.3373 3.33137 12.6627 3.89443 13.7889Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6 15H11.4C10.0745 15 9 15.2462 9 16.1667C9 16.6269 9.44772 17 10 17H14C14.5523 17 15 16.6269 15 16.1667C15 15.2462 13.9255 15 12.6 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Hexagon-User-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","hexagon-user","user-profile","user-account","user-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.22364 5.87573C6.02825 4.26651 7.673 3.25 9.47217 3.25H14.5279C16.3271 3.25 17.9718 4.26651 18.7764 5.87573L20.7764 9.87574C21.4451 11.213 21.4451 12.787 20.7764 14.1243L18.7764 18.1243C17.9718 19.7335 16.3271 20.75 14.5279 20.75H9.47217C7.673 20.75 6.02825 19.7335 5.22364 18.1243L3.22364 14.1243C2.55501 12.787 2.55501 11.213 3.22364 9.87574L5.22364 5.87573ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7ZM9.42043 14.5434C9.99455 14.3099 10.7154 14.25 11.4 14.25H12.6C13.2846 14.25 14.0055 14.3099 14.5796 14.5434C14.8754 14.6637 15.173 14.8461 15.3981 15.1289C15.6325 15.4232 15.75 15.7787 15.75 16.1667C15.75 17.1633 14.8327 17.75 14 17.75H10C9.16735 17.75 8.25 17.1633 8.25 16.1667C8.25 15.7787 8.36755 15.4232 8.60188 15.1289C8.82701 14.8461 9.12465 14.6637 9.42043 14.5434Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Hexagon-User": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","login","staff","employee","member","customer-profile","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.89443 13.7889L5.89443 17.7889C6.572 19.144 7.95705 20 9.47214 20H12H14.5279C16.043 20 17.428 19.144 18.1056 17.7889L20.1056 13.7889C20.6686 12.6627 20.6686 11.3373 20.1056 10.2111L18.1056 6.21114C17.428 4.85601 16.043 4 14.5279 4H12H9.47214C7.95705 4 6.572 4.85601 5.89443 6.21114L3.89443 10.2111C3.33137 11.3373 3.33137 12.6627 3.89443 13.7889Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6 15H11.4C10.0745 15 9 15.2462 9 16.1667C9 16.6269 9.44772 17 10 17H14C14.5523 17 15 16.6269 15 16.1667C15 15.2462 13.9255 15 12.6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "hexagon-xmark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cancel","remove","delete","error","close","x","incorrect","invalid","hexagon-x","void","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.92011 13.8115L6.44392 16.8115C7.12592 18.1542 8.50426 19 10.0102 19H12H13.9898C15.4957 19 16.8741 18.1542 17.5561 16.8115L19.0799 13.8115C19.6581 12.673 19.6581 11.327 19.0799 10.1885L17.5561 7.18854C16.8741 5.84584 15.4957 5 13.9898 5H12H10.0102C8.50426 5 7.12592 5.84584 6.44392 7.18854L4.92011 10.1885C4.34186 11.327 4.34186 12.673 4.92011 13.8115Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-xmark-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["cancel","remove","delete","x","close","error","void","reject","discard","hexagon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hexagon-xmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","error","incorrect","invalid","close","exit","discard","void","hexagon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83018 6.18854C6.51218 4.84584 7.89052 4 9.39649 4H14.6034C16.1093 4 17.4877 4.84584 18.1697 6.18854L20.2014 10.1885C20.7797 11.327 20.7797 12.673 20.2014 13.8115L18.1697 17.8115C17.4877 19.1542 16.1093 20 14.6034 20H9.39649C7.89052 20 6.51218 19.1542 5.83018 17.8115L3.79843 13.8115C3.22018 12.673 3.22018 11.327 3.79843 10.1885L5.83018 6.18854ZM14.707 10.7071C15.0975 10.3166 15.0975 9.68342 14.707 9.29289C14.3165 8.90237 13.6833 8.90237 13.2928 9.29289L11.9999 10.5858L10.707 9.29289C10.3165 8.90237 9.6833 8.90237 9.29277 9.29289C8.90225 9.68342 8.90225 10.3166 9.29277 10.7071L10.5857 12L9.29277 13.2929C8.90225 13.6834 8.90225 14.3166 9.29277 14.7071C9.6833 15.0976 10.3165 15.0976 10.707 14.7071L11.9999 13.4142L13.2928 14.7071C13.6833 15.0976 14.3165 15.0976 14.707 14.7071C15.0975 14.3166 15.0975 13.6834 14.707 13.2929L13.4141 12L14.707 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hexagon-xmark": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","xmark","x","cancel","remove","delete","error","no","decline","void","void-transaction","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.69008 13.3586L6.72183 17.3586C7.23333 18.3656 8.26708 19 9.39656 19H12H14.6034C15.7329 19 16.7667 18.3656 17.2782 17.3586L19.3099 13.3586C19.7436 12.5048 19.7436 11.4952 19.3099 10.6414L17.2782 6.6414C16.7667 5.63438 15.7329 5 14.6034 5H12H9.39656C8.26708 5 7.23333 5.63438 6.72183 6.6414L4.69008 10.6414C4.2564 11.4952 4.2564 12.5048 4.69008 13.3586Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hindi-alphabet-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["language","localization","internationalization","translation","customer-language","multilingual"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 9H10C11.1046 9 12 9.89543 12 11V13C12 14.1046 11.1046 15 10 15H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15L14 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hindi-alphabet-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["language","hindi","alphabet","translation","internationalization","localization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9H10C11.1046 9 12 9.89543 12 11V13C12 14.1046 11.1046 15 10 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L14 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15L14 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hindi-alphabet-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["font","character","language","internationalization","localization","text","display","settings","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 11C13 10.6436 12.9378 10.3017 12.8238 9.98452C12.881 9.99469 12.9399 10 13 10V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM8 9C8 8.44772 8.44772 8 9 8H10C10.7796 8 11.4898 8.29737 12.0232 8.78488C12.1216 8.33599 12.5216 8 13 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10V15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15V13C13 14.6569 11.6569 16 10 16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H11C11 10.4477 10.5523 10 10 10H9C8.44772 10 8 9.55229 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hindi-alphabet": {
        defaultColors: ["#3D4C66"],
        keywords: ["language","localization","international","customer","hindi","translation","multilingual","alphabet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 9H10C11.1046 9 12 9.89543 12 11V13C12 14.1046 11.1046 15 10 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["home","profile","account","user","customer","employee","manager","settings","my-account","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16C13.4773 15.3612 12.755 15 12 15C11.245 15 10.5227 15.3612 10 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.37895 13.5432L5.33413 13.0503C5.17152 11.2617 5.09022 10.3674 5.46761 9.60712C5.845 8.84688 6.6065 8.37094 8.1295 7.41906L8.82001 6.9875C10.3664 6.02099 11.1396 5.53774 12 5.53774C12.8604 5.53774 13.6336 6.02099 15.18 6.9875L15.8705 7.41906C17.3935 8.37094 18.155 8.84688 18.5324 9.60712C18.9098 10.3674 18.8285 11.2617 18.6659 13.0503L18.6211 13.5432C18.3855 16.1345 18.2677 17.4302 17.4084 18.2149C16.5492 18.9996 15.2482 18.9997 12.6462 18.9999L12 19L11.3538 18.9999C8.7518 18.9997 7.45078 18.9996 6.59155 18.2149C5.73233 17.4302 5.61453 16.1345 5.37895 13.5432Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["profile","user","account","customer","employee","staff","member","person","management","user-profile","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.37895 13.5432L5.33413 13.0503C5.17152 11.2617 5.09022 10.3674 5.46761 9.60712C5.845 8.84688 6.6065 8.37094 8.1295 7.41906L8.82001 6.9875C10.3664 6.02099 11.1396 5.53774 12 5.53774C12.8604 5.53774 13.6336 6.02099 15.18 6.9875L15.8705 7.41906C17.3935 8.37094 18.155 8.84688 18.5324 9.60712C18.9098 10.3674 18.8285 11.2617 18.6659 13.0503L18.6211 13.5432C18.3855 16.1345 18.2677 17.4302 17.4084 18.2149C16.5492 18.9996 15.2482 18.9997 12.6462 18.9999L12 19L11.3538 18.9999C8.7518 18.9997 7.45078 18.9996 6.59155 18.2149C5.73233 17.4302 5.61453 16.1345 5.37895 13.5432Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16C13.4773 15.3612 12.755 15 12 15C11.245 15 10.5227 15.3612 10 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","profile","account","user","customer","employee","staff","location","settings","my-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16C13.4773 15.3612 12.755 15 12 15C11.245 15 10.5227 15.3612 10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.37895 13.5432L5.33413 13.0503C5.17152 11.2617 5.09022 10.3674 5.46761 9.60712C5.845 8.84688 6.6065 8.37094 8.1295 7.41906L8.82001 6.9875C10.3664 6.02099 11.1396 5.53774 12 5.53774C12.8604 5.53774 13.6336 6.02099 15.18 6.9875L15.8705 7.41906C17.3935 8.37094 18.155 8.84688 18.5324 9.60712C18.9098 10.3674 18.8285 11.2617 18.6659 13.0503L18.6211 13.5432C18.3855 16.1345 18.2677 17.4302 17.4084 18.2149C16.5492 18.9996 15.2482 18.9997 12.6462 18.9999L12 19L11.3538 18.9999C8.7518 18.9997 7.45078 18.9996 6.59155 18.2149C5.73233 17.4302 5.61453 16.1345 5.37895 13.5432Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","staff","employee","member","person","identity","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.4102 8.62C18.9102 7.61 18.0347 7.05 16.4047 6.03L15.7147 5.6C14.0647 4.57 13.1547 4 12.0047 4C10.8547 4 9.9447 4.57 8.2947 5.6L7.6047 6.03C5.9747 7.05 5.0847 7.61 4.5747 8.62C4.0747 9.63 4.16468 10.68 4.33468 12.6L4.3847 13.09C4.6347 15.84 4.78471 17.36 5.92471 18.41C7.06471 19.46 8.59468 19.46 11.3647 19.46H12.6547C15.4247 19.46 16.9447 19.46 18.0947 18.41C19.2447 17.36 19.3747 15.85 19.6347 13.09L19.6702 12.59C19.8402 10.68 19.9202 9.63 19.4102 8.62ZM11.9947 7.5C13.3747 7.5 14.4947 8.62 14.4947 10C14.4947 11.38 13.3747 12.5 11.9947 12.5C10.6147 12.5 9.49468 11.38 9.49468 10C9.49468 8.62 10.6147 7.5 11.9947 7.5ZM14.6347 16.23C14.4447 16.38 14.2247 16.46 14.0047 16.46C13.7147 16.46 13.4247 16.33 13.2247 16.09C12.5547 15.27 11.4447 15.27 10.7747 16.09C10.4247 16.52 9.79468 16.58 9.36468 16.23C8.93468 15.88 8.8747 15.25 9.2247 14.82C9.9347 13.95 10.9447 13.45 11.9947 13.45C13.0447 13.45 14.0547 13.95 14.7647 14.82C15.1147 15.25 15.0547 15.88 14.6247 16.23H14.6347Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home profile-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","profile","account","user","customer","location","employee","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11V11V11C10 9.89543 10.8954 9 12 9V9C13.1046 9 14 9.89543 14 11V11V11C14 12.1046 13.1046 13 12 13V13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15C10.6561 16.3335 13.3436 16.3332 15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","profile","account","user","address","location","my-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15C10.6561 16.3335 13.3436 16.3332 15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home profile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","profile","user","account","settings","customer","employee","management","login","access","user-profile","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.52 4.96L7.53 6.1C5.95 7 5.07999 7.5 4.53999 8.43C3.99999 9.36 4 10.36 4 12.18V12.7C4 15.7 4 17.36 5.17 18.53C6.34 19.7 7.99 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM12 7.95C13.52 7.95 14.75 9.18 14.75 10.7C14.75 12.22 13.52 13.45 12 13.45C10.48 13.45 9.25 12.22 9.25 10.7C9.25 9.18 10.48 7.95 12 7.95ZM15.63 15.48C14.61 16.3 13.31 16.71 12 16.71C10.69 16.71 9.39 16.3 8.37 15.48C7.94 15.13 7.87 14.5 8.22 14.07C8.57 13.64 9.20001 13.57 9.63 13.92C10.92 14.96 13.09 14.95 14.38 13.92C14.81 13.57 15.44 13.64 15.79 14.07C16.14 14.5 16.07 15.13 15.64 15.48H15.63Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home profile": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","profile","account","user","employee","customer","dashboard","settings","my-account","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11V11V11C10 9.89543 10.8954 9 12 9V9C13.1046 9 14 9.89543 14 11V11V11C14 12.1046 13.1046 13 12 13V13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 15C10.6561 16.3335 13.3436 16.3332 15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Home Smart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","wifi","network","internet","connection","smart","smart-home","connected","device","location","branch","store","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 10L5.4597 14.597C5.71648 17.1648 5.84487 18.4487 6.70195 19.2244C7.55902 20 8.84932 20 11.4299 20H12.5701C15.1507 20 16.441 20 17.2981 19.2244C18.1551 18.4487 18.2835 17.1648 18.5403 14.597L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="15" r="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 13C9.59883 11.8044 10.7181 11 12 11C13.2819 11 14.4012 11.8044 15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Home Smart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","wifi","network","connection","smart","device","internet","automation","remote","access","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5468 20H11.4067C8.82607 20 7.53577 20 6.67869 19.2244C5.82162 18.4487 5.69323 17.1648 5.43645 14.597L5 10.2326L9.57674 6.8C10.7323 5.93333 11.3101 5.5 11.9767 5.5C12.6434 5.5 13.2212 5.93333 14.3767 6.8L18.9535 10.2326L18.517 14.597C18.2603 17.1648 18.1319 18.4487 17.2748 19.2244C16.4177 20 15.1274 20 12.5468 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 10L5.4597 14.597C5.71648 17.1648 5.84487 18.4487 6.70195 19.2244C7.55902 20 8.84932 20 11.4299 20H12.5701C15.1507 20 16.441 20 17.2981 19.2244C18.1551 18.4487 18.2835 17.1648 18.5403 14.597L19 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="15"
                    r="1"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9.59883 11.8044 10.7181 11 12 11C13.2819 11 14.4012 11.8044 15 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Home Smart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","smart","wifi","network","connection","status","connected","store","restaurant","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.5989 9.7L14.9989 5.5C13.7489 4.56 12.9989 4 11.9989 4C10.9989 4 10.2489 4.56 8.99893 5.5L3.39893 9.7C2.95893 10.03 2.86893 10.66 3.19893 11.1C3.43893 11.42 3.82893 11.54 4.18893 11.47L4.45893 14.19C4.72893 16.92 4.87893 18.42 6.02893 19.46C7.17893 20.5 8.68893 20.49 11.4289 20.49H12.5689C15.3089 20.49 16.8289 20.49 17.9689 19.46C19.1089 18.43 19.2589 16.92 19.5389 14.19L19.8089 11.46C19.8689 11.47 19.9389 11.49 19.9989 11.49C20.2989 11.49 20.5989 11.35 20.7989 11.09C21.1289 10.65 21.0389 10.03 20.5989 9.7ZM11.9989 16.25C11.0389 16.25 10.2489 15.46 10.2489 14.5C10.2489 13.54 11.0389 12.75 11.9989 12.75C12.9589 12.75 13.7489 13.54 13.7489 14.5C13.7489 15.46 12.9589 16.25 11.9989 16.25ZM15.4489 13.39C14.9589 13.64 14.3589 13.44 14.1089 12.94C13.6589 12.05 12.8589 11.49 11.9989 11.49C11.1389 11.49 10.3389 12.04 9.88893 12.94C9.71893 13.29 9.35893 13.49 8.99893 13.49C8.84893 13.49 8.69893 13.46 8.54893 13.38C8.05893 13.13 7.85893 12.53 8.09893 12.04C8.88893 10.47 10.3789 9.49 11.9889 9.49C13.5989 9.49 15.0989 10.47 15.8789 12.04C16.1289 12.53 15.9289 13.13 15.4289 13.38L15.4489 13.39Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Home Smart": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","wifi","network","connection","smart-home","settings","configuration","connected","status","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 10L5.4597 14.597C5.71648 17.1648 5.84487 18.4487 6.70195 19.2244C7.55902 20 8.84932 20 11.4299 20H12.5701C15.1507 20 16.441 20 17.2981 19.2244C18.1551 18.4487 18.2835 17.1648 18.5403 14.597L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="15" r="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 13C9.59883 11.8044 10.7181 11 12 11C13.2819 11 14.4012 11.8044 15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home user v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","account","profile","customer","employee","login","home","user-account","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home user v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","manager","admin","login","contact","person","human"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5462 16H11.4538C10.4818 16 9.9958 16 9.59227 16.1893C9.36712 16.2949 9.16363 16.4415 8.99226 16.6217C8.6851 16.9447 8.53142 17.4058 8.22405 18.3279C8.14061 18.5782 8.09889 18.7033 8.13368 18.8008C8.15274 18.8543 8.18657 18.9012 8.23123 18.9362C8.31272 19 8.44465 19 8.70851 19H15.2915C15.5554 19 15.6873 19 15.7688 18.9362C15.8134 18.9012 15.8473 18.8543 15.8663 18.8008C15.9011 18.7033 15.8594 18.5782 15.7759 18.3279C15.4686 17.4058 15.3149 16.9447 15.0077 16.6217C14.8364 16.4415 14.6329 16.2949 14.4077 16.1893C14.0042 16 13.5182 16 12.5462 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home user v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","home","account","profile","customer","client","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3748 8.5C18.8348 7.45 17.8648 6.9 16.1148 5.89L14.4848 4.96C13.4348 4.36 12.8048 4 12.0048 4C11.2048 4 10.5748 4.36 9.52485 4.96L7.88483 5.9C6.13483 6.9 5.16482 7.45 4.62482 8.5C4.08482 9.55 4.19484 10.66 4.39484 12.67L4.46479 13.39C4.73479 16.12 4.88479 17.62 6.03479 18.66C7.17479 19.69 8.69482 19.69 11.4348 19.69H12.5748C15.3148 19.69 16.8348 19.69 17.9748 18.66C19.1148 17.62 19.2648 16.12 19.5348 13.39L19.6048 12.67C19.8048 10.66 19.9148 9.56 19.3748 8.5ZM16.2648 17.62C16.2048 17.79 16.0948 17.94 15.9548 18.06C15.6748 18.27 15.3948 18.27 15.0748 18.27H8.92481C8.59481 18.27 8.31481 18.27 8.05481 18.06C7.90481 17.94 7.79481 17.78 7.73481 17.61C7.62481 17.3 7.71482 17.03 7.81482 16.72C8.12482 15.79 8.29483 15.28 8.69483 14.86C8.91483 14.63 9.17479 14.44 9.46479 14.3C9.93479 14.08 10.4448 14.06 11.2748 14.06C10.2548 13.74 9.51484 12.8 9.51484 11.68C9.51484 10.3 10.6348 9.18 12.0148 9.18C13.3948 9.18 14.5148 10.3 14.5148 11.68C14.5148 12.8 13.7748 13.74 12.7548 14.06C13.5848 14.06 14.0848 14.08 14.5648 14.3C14.8548 14.43 15.1148 14.62 15.3348 14.85C15.7348 15.27 15.9048 15.78 16.2148 16.71C16.3148 17.02 16.4048 17.29 16.2948 17.61L16.2648 17.62Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home user v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","customer","account","home","location","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home user-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","user","account","profile","employee","customer","location","address","staff","my-account","personal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home user-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","home","address","employee","manager","user-profile","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.5462 16H11.4538C10.4818 16 9.9958 16 9.59227 16.1893C9.36712 16.2949 9.16363 16.4415 8.99226 16.6217C8.6851 16.9447 8.53142 17.4058 8.22405 18.3279C8.14061 18.5782 8.09889 18.7033 8.13368 18.8008C8.15274 18.8543 8.18657 18.9012 8.23123 18.9362C8.31272 19 8.44465 19 8.70851 19H15.2915C15.5554 19 15.6873 19 15.7688 18.9362C15.8134 18.9012 15.8473 18.8543 15.8663 18.8008C15.9011 18.7033 15.8594 18.5782 15.7759 18.3279C15.4686 17.4058 15.3149 16.9447 15.0077 16.6217C14.8364 16.4415 14.6329 16.2949 14.4077 16.1893C14.0042 16 13.5182 16 12.5462 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home user-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","home","user-profile","customer-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 7.43C18.92 6.5 18.05 6 16.47 5.1L14.48 3.96C13.43 3.36 12.8 3 12 3C11.2 3 10.57 3.36 9.52002 3.96L7.52002 5.1C5.94002 6 5.07998 6.5 4.53998 7.43C3.99998 8.36 4 9.36 4 11.18V11.7C4 14.7 3.99998 16.36 5.16998 17.53C6.33998 18.7 7.99 18.7 11 18.7H13C16 18.7 17.66 18.7 18.83 17.53C20 16.36 20 14.7 20 11.7V11.18C20 9.36 20 8.36 19.46 7.43ZM16.11 16.62C16.06 16.78 15.95 16.93 15.81 17.04C15.55 17.24 15.27 17.24 14.96 17.24H9.03998C8.72998 17.24 8.45001 17.24 8.20001 17.04C8.05001 16.92 7.95001 16.77 7.89001 16.61C7.78001 16.31 7.86997 16.05 7.96997 15.76C8.26997 14.86 8.43 14.37 8.81 13.97C9.02 13.74 9.26999 13.57 9.54999 13.44C9.97999 13.24 10.44 13.21 11.16 13.21C10.19 12.87 9.47998 11.95 9.47998 10.86C9.47998 9.48 10.6 8.36 11.98 8.36C13.36 8.36 14.48 9.48 14.48 10.86C14.48 11.95 13.78 12.87 12.8 13.21C13.54 13.21 14.01 13.24 14.44 13.44C14.72 13.57 14.96 13.75 15.18 13.97C15.56 14.37 15.73 14.87 16.02 15.76C16.12 16.06 16.21 16.32 16.09 16.63L16.11 16.62Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home user": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","home","address","my-account","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v10 circle line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","security","camera","surveillance","location","store","premises","monitoring","dashboard","access","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11V11V11C10 9.89543 10.8954 9 12 9V9C13.1046 9 14 9.89543 14 11V11V11C14 12.1046 13.1046 13 12 13V13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v10 circle line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","location","main","menu","start","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v10 circle line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","main","dashboard","menu","start","beginning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.51999 4.96L7.51999 6.1C5.93999 7 5.08001 7.5 4.54001 8.43C4.00001 9.36 4 10.36 4 12.18V12.7C4 15.7 4.00001 17.36 5.17001 18.53C6.34001 19.7 7.99 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM12 7.95C13.52 7.95 14.75 9.18 14.75 10.7C14.75 12.22 13.52 13.45 12 13.45C10.48 13.45 9.25 12.22 9.25 10.7C9.25 9.18 10.48 7.95 12 7.95ZM14 16.7H10C9.45 16.7 9 16.25 9 15.7C9 15.15 9.45 14.7 10 14.7H14C14.55 14.7 15 15.15 15 15.7C15 16.25 14.55 16.7 14 16.7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v10 circle line": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","shop","store","main","menu","dashboard","location","circle","address","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13C10.8954 13 10 12.1046 10 11V11V11C10 9.89543 10.8954 9 12 9V9C13.1046 9 14 9.89543 14 11V11V11C14 12.1046 13.1046 13 12 13V13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v11 line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","main","menu","dashboard","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v11 line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","location","main-menu","menu","navigation","setting","configuration","admin","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v11 line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","shop","store","main","menu","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3748 8.5C18.8348 7.45 17.8648 6.9 16.1148 5.89L14.4848 4.96C13.4348 4.36 12.8048 4 12.0048 4C11.2048 4 10.5748 4.36 9.52483 4.96L7.88485 5.9C6.13485 6.9 5.16484 7.45 4.62484 8.5C4.08484 9.55 4.19483 10.66 4.39483 12.67L4.46483 13.39C4.73483 16.12 4.88484 17.62 6.03484 18.66C7.17484 19.69 8.69484 19.69 11.4348 19.69H12.5748C15.3148 19.69 16.8348 19.69 17.9748 18.66C19.1148 17.62 19.2648 16.12 19.5348 13.39L19.6048 12.67C19.8048 10.66 19.9148 9.56 19.3748 8.5ZM12.9948 13.69C12.9948 14.24 12.5448 14.69 11.9948 14.69C11.4448 14.69 10.9948 14.24 10.9948 13.69V11.69C10.9948 11.14 11.4448 10.69 11.9948 10.69C12.5448 10.69 12.9948 11.14 12.9948 11.69V13.69Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v11 line": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","location","main","menu","dashboard","start","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v12 line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","menu","remove","minimize","dash","hide","collapse","house","back","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v12 line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","remove","delete","back","return","main-menu","navigation","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v12 line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","dashboard","main-menu","overview","reports","navigation","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3748 8.5C18.8348 7.45 17.8648 6.9 16.1148 5.89L14.4848 4.96C13.4348 4.36 12.8048 4 12.0048 4C11.2048 4 10.5748 4.36 9.52485 4.96L7.88483 5.9C6.13483 6.9 5.16482 7.45 4.62482 8.5C4.08482 9.55 4.19484 10.66 4.39484 12.67L4.46479 13.39C4.73479 16.12 4.88479 17.62 6.03479 18.66C7.17479 19.69 8.69482 19.69 11.4348 19.69H12.5748C15.3148 19.69 16.8348 19.69 17.9748 18.66C19.1148 17.62 19.2648 16.12 19.5348 13.39L19.6048 12.67C19.8048 10.66 19.9148 9.56 19.3748 8.5ZM14.9948 16.69H8.99482C8.44482 16.69 7.99482 16.24 7.99482 15.69C7.99482 15.14 8.44482 14.69 8.99482 14.69H14.9948C15.5448 14.69 15.9948 15.14 15.9948 15.69C15.9948 16.24 15.5448 16.69 14.9948 16.69Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v12 line": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","store","shop","main","menu","dashboard","location","address","return","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 13.597L5.38746 12.8746C5.19939 10.9939 5.10535 10.0535 5.51232 9.26412C5.91929 8.47469 6.73981 8.00582 8.38085 7.06809L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.6192 7.06809C17.2602 8.00582 18.0807 8.47469 18.4877 9.26412C18.8946 10.0535 18.8006 10.9939 18.6125 12.8746L18.5403 13.597C18.2835 16.1648 18.1551 17.4487 17.2981 18.2244C16.441 19 15.1507 19 12.5701 19H11.4299C8.84932 19 7.55902 19 6.70195 18.2244C5.84487 17.4487 5.71648 16.1648 5.4597 13.597Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v13 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","main-menu","dashboard","start","starting-point","location","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V9.42857L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L18 9.42857V12C18 14.8284 18 16.2426 17.1213 17.1213C16.2426 18 14.8284 18 12 18C9.17157 18 7.75736 18 6.87868 17.1213C6 16.2426 6 14.8284 6 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 9.42857V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V9.42857"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v13 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","dashboard","main-menu","circle","navigation","home-screen","start","restaurant-home","shop-home"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v13 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main-menu","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.5052 8.82L18.5152 8.25C18.5152 8.25 18.5052 8.25 18.4952 8.25L14.4852 5.96C13.4352 5.36 12.8052 5 12.0052 5C11.2052 5 10.5752 5.36 9.52524 5.96L5.51523 8.25C5.51523 8.25 5.50521 8.25 5.49521 8.25L4.50522 8.82C4.02522 9.09 3.85522 9.7 4.13522 10.18C4.31522 10.5 4.65522 10.68 5.00522 10.68V11.68C5.00522 14.68 5.0052 16.34 6.1752 17.51C7.3452 18.68 8.99522 18.68 12.0052 18.68C15.0152 18.68 16.6652 18.68 17.8352 17.51C19.0052 16.34 19.0052 14.68 19.0052 11.68V10.68C19.3552 10.68 19.68 10.5 19.87 10.18C20.14 9.7 19.9852 9.09 19.5052 8.82ZM13.9552 14.63C13.4352 15.15 12.7452 15.44 12.0152 15.44C10.4952 15.44 9.26523 14.21 9.26523 12.69C9.26523 11.17 10.4952 9.94 12.0152 9.94C13.5352 9.94 14.7652 11.17 14.7652 12.69C14.7652 13.42 14.4752 14.12 13.9552 14.63Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v13 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","main-menu","dashboard","settings","account","profile","storefront","navigation","location","address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v14 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","dashboard","main-menu","navigation","shortcut","starting-point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L6.17801 13.068C6.56376 15.3826 6.75664 16.5399 7.55038 17.2441C7.58462 17.2745 7.61955 17.3041 7.65515 17.3328C8.48028 18 9.65352 18 12 18V18C14.3465 18 15.5197 18 16.3448 17.3328C16.3804 17.3041 16.4154 17.2745 16.4496 17.2441C17.2434 16.5399 17.4362 15.3826 17.822 13.068L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10L14.6032 6.23128C13.361 5.16653 12.7398 4.63416 12 4.63416C11.2602 4.63416 10.639 5.16653 9.39683 6.23128L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "home v14 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","main-menu","dashboard","circle","location","store","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.16957 13.0176L5.54614 9.532L9.39683 6.23141C10.639 5.16665 11.2602 4.63428 12 4.63428C12.7398 4.63428 13.361 5.16665 14.6032 6.23141L18.5821 9.64194L17.912 13.1362C17.4787 15.4473 17.262 16.6029 16.4459 17.2921C16.4328 17.3032 16.4195 17.3142 16.4062 17.325C15.5784 18.0001 14.4027 18.0001 12.0513 18.0001C9.65462 18.0001 8.45628 18.0001 7.62226 17.306C7.60887 17.2948 7.59559 17.2836 7.5824 17.2722C6.76059 16.5637 6.56358 15.3816 6.16957 13.0176Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.54614 9.532L6.16957 13.0176C6.56358 15.3816 6.76059 16.5637 7.5824 17.2722C7.59559 17.2836 7.60887 17.2948 7.62226 17.306C8.45628 18.0001 9.65462 18.0001 12.0513 18.0001C14.4027 18.0001 15.5784 18.0001 16.4062 17.325C16.4195 17.3142 16.4328 17.3032 16.4459 17.2921C17.262 16.6029 17.4787 15.4473 17.912 13.1362L18.5821 9.64194M19 10.0001L14.6032 6.23141C13.361 5.16665 12.7398 4.63428 12 4.63428C11.2602 4.63428 10.639 5.16665 9.39683 6.23141L5 10.0001"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v14 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","main menu","dashboard","starting point","location","storefront","return","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6506 9.61L15.2506 5.84C13.8706 4.66 13.1106 4 12.0006 4C10.8906 4 10.1306 4.65 8.75059 5.84L4.35056 9.61C3.93056 9.97 3.88058 10.6 4.24058 11.02C4.39058 11.19 4.58057 11.3 4.79057 11.35L5.18058 13.55C5.60058 16.07 5.83057 17.45 6.98057 18.44C8.09057 19.37 9.50058 19.37 12.0506 19.37C14.6006 19.37 15.9306 19.37 17.0906 18.43C18.1806 17.51 18.4306 16.16 18.8906 13.7L19.3506 11.31C19.5006 11.25 19.6406 11.16 19.7606 11.02C20.1206 10.6 20.0706 9.97 19.6506 9.61ZM12.0006 15.12C10.4806 15.12 9.25059 13.89 9.25059 12.37C9.25059 10.85 10.4806 9.62 12.0006 9.62C13.5206 9.62 14.7506 10.85 14.7506 12.37C14.7506 13.89 13.5206 15.12 12.0006 15.12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v14 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","location","main-menu","dashboard","hq","headquarters","main","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L6.17801 13.068C6.56376 15.3826 6.75664 16.5399 7.55038 17.2441C7.58462 17.2745 7.61955 17.3041 7.65515 17.3328C8.48028 18 9.65352 18 12 18V18C14.3465 18 15.5197 18 16.3448 17.3328C16.3804 17.3041 16.4154 17.2745 16.4496 17.2441C17.2434 16.5399 17.4362 15.3826 17.822 13.068L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10L14.6032 6.23128C13.361 5.16653 12.7398 4.63416 12 4.63416C11.2602 4.63416 10.639 5.16653 9.39683 6.23128L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "home v15 bolt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","bolt","lightning","power","energy","charge","outlet","electricity","service","utilities","status","alert","error","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 10L11 13H13L11.9998 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v15 bolt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bolt","lightning","power","energy","fast","charge","electricity","alert","notification","urgent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 10L11 13H13L11.9998 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v15 bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","bolt","lightning","charge","electricity","dashboard","status","power","outlet","fast","quick","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.52002 4.96L7.52002 6.1C5.94002 7 5.07998 7.5 4.53998 8.43C3.99998 9.36 4 10.36 4 12.18V12.7C4 15.7 3.99998 17.36 5.16998 18.53C6.33998 19.7 7.99 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM13.95 13.01L12.95 16.01C12.81 16.43 12.42 16.69 12 16.69C11.9 16.69 11.79 16.67 11.68 16.64C11.16 16.47 10.87 15.9 11.05 15.37L11.61 13.69H11C10.68 13.69 10.38 13.54 10.19 13.27C10 13.01 9.94999 12.67 10.05 12.37L11.05 9.37C11.22 8.85 11.78 8.56 12.31 8.74C12.83 8.91 13.12 9.48 12.94 10.01L12.38 11.69H12.99C13.31 11.69 13.61 11.84 13.8 12.11C13.99 12.37 14.04 12.71 13.94 13.01H13.95Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v15 bolt": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","bolt","power","electrical","service","energy","utility","quick-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 10L11 13H13L11.9998 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v16 bolt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","lightning","bolt","energy","power","utilities","smart-home","automation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10L6.39033 13.1227C6.65712 15.257 6.79052 16.3241 7.43987 17.0304C7.58098 17.1839 7.73772 17.3223 7.90753 17.4433C8.68892 18 9.76437 18 11.9153 18V18C14.1342 18 15.2437 18 16.0362 17.4179C16.2082 17.2916 16.3662 17.1473 16.5076 16.9875C17.159 16.2509 17.2595 15.146 17.4603 12.9362L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 11L11 13H13L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v16 bolt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","bolt","power","lightning","dashboard","settings","energy","outlet","electricity","quick","fast","electrical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.35746 13.1453L5.875 9.5L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L17.7901 9.30864L17.462 12.918C17.2595 15.1454 17.1583 16.2591 16.4977 16.9985C16.3622 17.1503 16.2115 17.2879 16.0481 17.4091C15.2519 18 14.1336 18 11.8971 18C9.7436 18 8.66687 18 7.88416 17.4403C7.72321 17.3252 7.57404 17.1945 7.43883 17.0501C6.78129 16.3475 6.64002 15.2801 6.35746 13.1453Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M5.875 9.5L6.35746 13.1453C6.64002 15.2801 6.78129 16.3475 7.43883 17.0501C7.57404 17.1945 7.72321 17.3252 7.88416 17.4403C8.66687 18 9.7436 18 11.8971 18V18C14.1336 18 15.2519 18 16.0481 17.4091C16.2115 17.2879 16.3622 17.1503 16.4977 16.9985C17.1583 16.2591 17.2595 15.1454 17.462 12.918L18 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 11L11 13H13L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v16 bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","bolt","house","lightning","power","electricity","energy","location","premises","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.4852 8.81L18.8552 8.45L19.0052 6.78C19.0552 6.23 18.6452 5.74 18.0952 5.69C17.5252 5.65 17.0552 6.05 17.0052 6.6L16.9352 7.36L14.4852 5.96C13.4352 5.36 12.8052 5 12.0052 5C11.2052 5 10.5752 5.36 9.52524 5.96L5.40524 8.31C5.40524 8.31 5.3752 8.33 5.3652 8.33L4.50522 8.82C4.02522 9.09 3.85522 9.7 4.13522 10.18C4.33522 10.52 4.70522 10.71 5.06522 10.68L5.3652 12.97C5.6652 15.23 5.83523 16.48 6.70523 17.41C6.88523 17.6 7.0852 17.78 7.2952 17.93C8.3352 18.68 9.59522 18.68 11.8852 18.68C14.1752 18.68 15.5652 18.68 16.6352 17.89C16.8552 17.73 17.0552 17.55 17.2352 17.34C18.1152 16.35 18.2352 15.05 18.4452 12.68L18.6352 10.61C19.0852 10.78 19.63 10.61 19.87 10.17C20.14 9.69 19.9652 9.08 19.4852 8.81ZM13.9052 13.14L12.9052 15.14C12.7252 15.49 12.3752 15.69 12.0052 15.69C11.8552 15.69 11.7052 15.66 11.5552 15.58C11.0652 15.33 10.8652 14.73 11.1052 14.24L11.3852 13.69H11.0052C10.6552 13.69 10.3352 13.51 10.1552 13.22C9.97524 12.93 9.9552 12.56 10.1152 12.25L11.1152 10.25C11.3652 9.76 11.9652 9.56 12.4552 9.8C12.9452 10.05 13.1452 10.65 12.9052 11.14L12.6252 11.69H13.0052C13.3552 11.69 13.6752 11.87 13.8552 12.16C14.0352 12.45 14.0552 12.82 13.8952 13.13L13.9052 13.14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v16 bolt": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","bolt","electricity","power","energy","utilities","outlet","electrical-failure","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10L6.39033 13.1227C6.65712 15.257 6.79052 16.3241 7.43987 17.0304C7.58098 17.1839 7.73772 17.3223 7.90753 17.4433C8.68892 18 9.76437 18 11.9153 18V18C14.1342 18 15.2437 18 16.0362 17.4179C16.2082 17.2916 16.3662 17.1473 16.5076 16.9875C17.159 16.2509 17.2595 15.146 17.4603 12.9362L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 11L11 13H13L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v17-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","main-menu","dashboard","navigation","storefront","welcome","start","settings","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.17801 13.0682L5.55481 9.52457L9.39683 6.23141C10.639 5.16665 11.2602 4.63428 12 4.63428C12.7398 4.63428 13.361 5.16665 14.6032 6.23141L18.4827 9.55674L17.822 13.0682C17.4362 15.3827 17.2434 16.54 16.4496 17.2442C16.4154 17.2746 16.3804 17.3042 16.3448 17.333C15.5197 18.0001 14.3465 18.0001 12 18.0001C9.65352 18.0001 8.48028 18.0001 7.65515 17.333C7.61955 17.3042 7.58462 17.2746 7.55038 17.2442C6.75664 16.54 6.56376 15.3827 6.17801 13.0682Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.55481 9.52457L6.17801 13.0682C6.56376 15.3827 6.75664 16.54 7.55038 17.2442C7.58462 17.2746 7.61955 17.3042 7.65515 17.333C8.48028 18.0001 9.65352 18.0001 12 18.0001C14.3465 18.0001 15.5197 18.0001 16.3448 17.333C16.3804 17.3042 16.4154 17.2746 16.4496 17.2442C17.2434 16.54 17.4362 15.3827 17.822 13.0682L18.4827 9.55674M19 10.0001L14.6032 6.23141C13.361 5.16665 12.7398 4.63428 12 4.63428C11.2602 4.63428 10.639 5.16665 9.39683 6.23141L5 10.0001"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v17-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","main","menu","navigation","dashboard","location","address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L6.17801 13.068C6.56376 15.3826 6.75664 16.5399 7.55038 17.2441C7.58462 17.2745 7.61955 17.3041 7.65515 17.3328C8.48028 18 9.65352 18 12 18V18C14.3465 18 15.5197 18 16.3448 17.3328C16.3804 17.3041 16.4154 17.2745 16.4496 17.2441C17.2434 16.5399 17.4362 15.3826 17.822 13.068L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10L14.6032 6.23128C13.361 5.16653 12.7398 4.63416 12 4.63416C11.2602 4.63416 10.639 5.16653 9.39683 6.23128L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v17-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","main-menu","navigation","dashboard","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6506 9.6L19.1506 9.17C19.1506 9.17 19.1306 9.15 19.1206 9.15L15.2506 5.83C13.8706 4.65 13.1106 4 12.0006 4C10.8906 4 10.1306 4.65 8.75057 5.84L4.35057 9.61C3.93057 9.97 3.88057 10.6 4.24057 11.02C4.39057 11.19 4.59057 11.3 4.79057 11.35L5.19058 13.6C5.60058 16.06 5.83057 17.42 6.88057 18.35L7.02057 18.47C8.12057 19.36 9.50057 19.36 11.9906 19.36C14.4806 19.36 15.8606 19.36 16.9706 18.47L17.1006 18.36C18.1606 17.42 18.3806 16.06 18.7906 13.62L19.2206 11.34C19.4206 11.29 19.6206 11.18 19.7606 11.02C20.1206 10.6 20.0706 9.96 19.6506 9.6ZM12.0006 16.36C10.3506 16.36 9.00057 15.01 9.00057 13.36C9.00057 12.81 9.45057 12.36 10.0006 12.36C10.5506 12.36 11.0006 12.81 11.0006 13.36C11.0006 13.91 11.4506 14.36 12.0006 14.36C12.5506 14.36 13.0006 13.91 13.0006 13.36C13.0006 12.81 13.4506 12.36 14.0006 12.36C14.5506 12.36 15.0006 12.81 15.0006 13.36C15.0006 15.01 13.6506 16.36 12.0006 16.36Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v17": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","shop","main","menu","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12L6.17801 13.068C6.56376 15.3826 6.75664 16.5399 7.55038 17.2441C7.58462 17.2745 7.61955 17.3041 7.65515 17.3328C8.48028 18 9.65352 18 12 18V18C14.3465 18 15.5197 18 16.3448 17.3328C16.3804 17.3041 16.4154 17.2745 16.4496 17.2441C17.2434 16.5399 17.4362 15.3826 17.822 13.068L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10L14.6032 6.23128C13.361 5.16653 12.7398 4.63416 12 4.63416C11.2602 4.63416 10.639 5.16653 9.39683 6.23128L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v18-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","main-menu","dashboard","start","house","location","address","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v18-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","store","main-menu","start","shop","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.36598 7.30494L5 11.1252L5.34303 13.7444C5.65585 16.247 5.81226 17.4982 6.66294 18.2492C7.51362 19.0002 8.77464 19.0002 11.2967 19.0002H12.7033C15.2254 19.0002 16.4864 19.0002 17.3371 18.2492C18.1877 17.4982 18.3442 16.247 18.657 13.7444L18.9859 11.1129L14.634 7.30494C13.379 6.20679 12.7515 5.65771 12 5.65771C11.2485 5.65771 10.621 6.20679 9.36598 7.30494Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9.36598 7.30494L8.8721 6.74051L9.36598 7.30494ZM14.634 7.30494L14.1401 7.86938L14.634 7.30494ZM19.5061 12.5646C19.8178 12.8374 20.2917 12.8058 20.5644 12.4941C20.8372 12.1823 20.8056 11.7085 20.4939 11.4357L19.5061 12.5646ZM5.34303 13.7444L6.08725 13.6514L6.08668 13.647L5.34303 13.7444ZM18.657 13.7444L17.9128 13.6514L18.657 13.7444ZM4.49388 12.5646L5.49388 11.6896L4.50612 10.5607L3.50612 11.4357L4.49388 12.5646ZM5.49388 11.6896L9.85986 7.86938L8.8721 6.74051L4.50612 10.5607L5.49388 11.6896ZM14.1401 7.86938L18.492 11.6773L19.4798 10.5484L15.1279 6.74051L14.1401 7.86938ZM18.492 11.6773L19.5061 12.5646L20.4939 11.4357L19.4798 10.5484L18.492 11.6773ZM9.85986 7.86938C10.5022 7.30736 10.9316 6.93344 11.2907 6.69162C11.6323 6.46164 11.8305 6.40771 12 6.40771V4.90771C11.4181 4.90771 10.9268 5.12833 10.4529 5.44742C9.99662 5.75468 9.48483 6.20437 8.8721 6.74051L9.85986 7.86938ZM15.1279 6.74051C14.5152 6.20437 14.0034 5.75468 13.5471 5.44742C13.0732 5.12833 12.5819 4.90771 12 4.90771V6.40771C12.1695 6.40771 12.3677 6.46164 12.7093 6.69162C13.0684 6.93344 13.4978 7.30736 14.1401 7.86938L15.1279 6.74051ZM4.25635 11.2226L4.59938 13.8418L6.08668 13.647L5.74365 11.0278L4.25635 11.2226ZM11.2967 19.7502H12.7033V18.2502H11.2967V19.7502ZM19.4012 13.8374L19.7301 11.2059L18.2417 11.0198L17.9128 13.6514L19.4012 13.8374ZM19.7301 11.2059L19.7442 11.0932L18.2558 10.9072L18.2417 11.0198L19.7301 11.2059ZM12.7033 19.7502C13.9446 19.7502 14.9465 19.7516 15.7417 19.6503C16.558 19.5463 17.2523 19.3244 17.8334 18.8115L16.8407 17.687C16.5711 17.925 16.2096 18.0786 15.5522 18.1623C14.8737 18.2488 13.9841 18.2502 12.7033 18.2502V19.7502ZM17.9128 13.6514C17.7539 14.9223 17.6422 15.8048 17.4722 16.4673C17.3076 17.1093 17.1103 17.4489 16.8407 17.687L17.8334 18.8115C18.4145 18.2985 18.7208 17.6371 18.9252 16.84C19.1244 16.0635 19.2472 15.0691 19.4012 13.8374L17.9128 13.6514ZM4.59882 13.8374C4.75278 15.0691 4.87564 16.0635 5.0748 16.84C5.27924 17.6371 5.58552 18.2985 6.16659 18.8115L7.15929 17.687C6.88968 17.4489 6.69242 17.1093 6.52777 16.4673C6.35785 15.8048 6.2461 14.9223 6.08723 13.6514L4.59882 13.8374ZM11.2967 18.2502C10.0159 18.2502 9.12632 18.2488 8.44783 18.1623C7.79043 18.0786 7.42891 17.925 7.15929 17.687L6.16659 18.8115C6.74765 19.3244 7.44198 19.5463 8.25827 19.6503C9.05348 19.7516 10.0554 19.7502 11.2967 19.7502V18.2502Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10 17V19L14 19V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v18-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","main-menu","dashboard","start","location","store","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.7526 12.6587C20.4981 12.9495 20.1125 13.0574 19.7614 12.9715L19.6412 13.9332C19.4917 15.1293 19.3678 16.1207 19.1674 16.9021C18.9563 17.725 18.6319 18.4401 17.9989 18.9989C17.3659 19.5577 16.6161 19.7909 15.7733 19.8983C15.5335 19.9288 15.2758 19.9502 15 19.9652V17C15 15.3431 13.6569 14 12 14C10.3432 14 9.00002 15.3431 9.00002 17V19.9652C8.72425 19.9502 8.46654 19.9288 8.22669 19.8983C7.38392 19.7909 6.63413 19.5577 6.00115 18.9989C5.36818 18.4401 5.04372 17.725 4.83265 16.9021C4.63223 16.1207 4.50834 15.1293 4.35886 13.9332L4.35113 13.8713L4.23344 12.9728C3.88377 13.0564 3.50063 12.9481 3.24744 12.6587C2.88375 12.243 2.92587 11.6113 3.34151 11.2476L8.75291 6.51262C9.34153 5.99752 9.85261 5.55027 10.3133 5.24006C10.8092 4.90611 11.3493 4.65771 12 4.65771C12.6507 4.65771 13.1908 4.90611 13.6867 5.24006C14.1474 5.55027 14.6585 5.99751 15.2471 6.5126L20.6585 11.2476C21.0742 11.6113 21.1163 12.243 20.7526 12.6587Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 20C11.1444 20.0002 11.0806 20.0002 11.2314 20.0002H12.7686C12.9179 20.0002 12.857 20.0002 13 20V17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17V20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v18": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","dashboard","main-menu","menu","navigation","start","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v19-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","main-menu","dashboard","start","house","location","address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.14286 10L5.84176 15.5039C6.05318 17.1688 6.15889 18.0013 6.72567 18.5006C7.29244 19 8.13159 19 9.8099 19H10M5.14286 10L9.64331 6.71842C10.7799 5.88962 11.3483 5.47522 12 5.47522C12.6517 5.47522 13.2201 5.88962 14.3567 6.71842L18.8571 10M5.14286 10L4 11M18.8571 10L18.1582 15.5039C17.9468 17.1688 17.8411 18.0013 17.2743 18.5006C16.7076 19 15.8684 19 14.1901 19H14M18.8571 10L20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v19-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","main-menu","dashboard","navigation","start","store","location","address","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.84176 15.5038L5.14286 9.99987L9.64331 6.71829C10.7799 5.8895 11.3483 5.4751 12 5.4751C12.6517 5.4751 13.2201 5.8895 14.3567 6.71829L18.8571 9.99987L18.1582 15.5038C17.9468 17.1687 17.8411 18.0012 17.2743 18.5005C16.7076 18.9999 15.8684 18.9999 14.1901 18.9999C14.0851 18.9999 14 18.9148 14 18.8098V16.9999C14 15.8953 13.1046 14.9999 12 14.9999C10.8954 14.9999 10 15.8953 10 16.9999V18.8098C10 18.9148 9.91489 18.9999 9.8099 18.9999C8.13159 18.9999 7.29244 18.9999 6.72567 18.5005C6.15889 18.0012 6.05318 17.1687 5.84176 15.5038Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.14286 9.99987L4.70098 9.39387L4.67405 9.4135L4.64898 9.43544L5.14286 9.99987ZM5.84176 15.5038L5.09774 15.5982L5.84176 15.5038ZM18.1582 15.5038L18.9023 15.5982L18.1582 15.5038ZM18.8571 9.99987L19.351 9.43544C19.3343 9.42082 19.317 9.40695 19.299 9.39387L18.8571 9.99987ZM9.64331 6.71829L10.0852 7.3243V7.3243L9.64331 6.71829ZM14.3567 6.71829L13.9148 7.3243L14.3567 6.71829ZM3.50612 10.4354C3.19439 10.7082 3.16281 11.182 3.43557 11.4938C3.70833 11.8055 4.18215 11.8371 4.49388 11.5643L3.50612 10.4354ZM19.5061 11.5643C19.8178 11.8371 20.2917 11.8055 20.5644 11.4938C20.8372 11.182 20.8056 10.7082 20.4939 10.4354L19.5061 11.5643ZM17.2743 18.5005L17.7701 19.0633L17.2743 18.5005ZM6.72567 18.5005L6.22986 19.0633H6.22986L6.72567 18.5005ZM4.39883 10.0944L5.09774 15.5982L6.58579 15.4093L5.88688 9.90539L4.39883 10.0944ZM18.9023 15.5982L19.6012 10.0944L18.1131 9.90539L17.4142 15.4093L18.9023 15.5982ZM5.58474 10.6059L10.0852 7.3243L9.20143 6.11229L4.70098 9.39387L5.58474 10.6059ZM13.9148 7.3243L18.4153 10.6059L19.299 9.39387L14.7986 6.11229L13.9148 7.3243ZM4.64898 9.43544L3.50612 10.4354L4.49388 11.5643L5.63674 10.5643L4.64898 9.43544ZM18.3633 10.5643L19.5061 11.5643L20.4939 10.4354L19.351 9.43544L18.3633 10.5643ZM10.0852 7.3243C10.6676 6.89964 11.0538 6.61946 11.3733 6.4384C11.6759 6.26693 11.8509 6.2251 12 6.2251V4.7251C11.4974 4.7251 11.0624 4.89047 10.6337 5.13339C10.222 5.36674 9.75568 5.70815 9.20143 6.11229L10.0852 7.3243ZM14.7986 6.11229C14.2443 5.70815 13.778 5.36673 13.3663 5.13339C12.9376 4.89047 12.5026 4.7251 12 4.7251V6.2251C12.1491 6.2251 12.3241 6.26693 12.6267 6.4384C12.9462 6.61946 13.3324 6.89964 13.9148 7.3243L14.7986 6.11229ZM17.4142 15.4093C17.306 16.2613 17.2324 16.8298 17.1234 17.2516C17.0197 17.6528 16.9063 17.8252 16.7785 17.9378L17.7701 19.0633C18.2091 18.6765 18.432 18.183 18.5757 17.6269C18.7141 17.0913 18.799 16.4111 18.9023 15.5982L17.4142 15.4093ZM14.1901 19.7499C15.0095 19.7499 15.695 19.7513 16.2437 19.6815C16.8135 19.6089 17.3311 19.45 17.7701 19.0633L16.7785 17.9378C16.6508 18.0504 16.4654 18.1411 16.0544 18.1935C15.6222 18.2485 15.049 18.2499 14.1901 18.2499V19.7499ZM5.09774 15.5982C5.20096 16.4111 5.28591 17.0913 5.42432 17.6269C5.56804 18.183 5.79087 18.6765 6.22986 19.0633L7.22147 17.9378C7.09369 17.8252 6.98028 17.6528 6.8766 17.2516C6.76761 16.8298 6.69398 16.2613 6.58579 15.4093L5.09774 15.5982ZM9.8099 18.2499C8.95101 18.2499 8.37777 18.2485 7.94565 18.1935C7.5346 18.1411 7.34925 18.0504 7.22147 17.9378L6.22986 19.0633C6.66886 19.45 7.18646 19.6089 7.75626 19.6815C8.30499 19.7513 8.99048 19.7499 9.8099 19.7499V18.2499ZM10.75 18.8098V16.9999H9.25V18.8098H10.75ZM14.75 18.8098V16.9999H13.25V18.8098H14.75ZM14.75 16.9999C14.75 15.4811 13.5188 14.2499 12 14.2499V15.7499C12.6904 15.7499 13.25 16.3095 13.25 16.9999H14.75ZM10.75 16.9999C10.75 16.3095 11.3096 15.7499 12 15.7499V14.2499C10.4812 14.2499 9.25 15.4811 9.25 16.9999H10.75ZM9.8099 19.7499C10.3291 19.7499 10.75 19.329 10.75 18.8098H9.25C9.25 18.5005 9.50067 18.2499 9.8099 18.2499V19.7499ZM14.1901 18.2499C14.4993 18.2499 14.75 18.5005 14.75 18.8098H13.25C13.25 19.329 13.6709 19.7499 14.1901 19.7499V18.2499Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5.14286 9.99987L4.70098 9.39387L4.67405 9.4135L4.64898 9.43544L5.14286 9.99987ZM18.8571 9.99987L19.351 9.43544C19.3343 9.42082 19.317 9.40695 19.299 9.39387L18.8571 9.99987ZM9.64331 6.71829L10.0852 7.3243V7.3243L9.64331 6.71829ZM14.3567 6.71829L13.9148 7.3243L14.3567 6.71829ZM3.50612 10.4354C3.19439 10.7082 3.16281 11.182 3.43557 11.4938C3.70833 11.8055 4.18215 11.8371 4.49388 11.5643L3.50612 10.4354ZM19.5061 11.5643C19.8178 11.8371 20.2917 11.8055 20.5644 11.4938C20.8372 11.182 20.8056 10.7082 20.4939 10.4354L19.5061 11.5643ZM12 5.4751V6.2251V5.4751ZM5.58474 10.6059L10.0852 7.3243L9.20143 6.11229L4.70098 9.39387L5.58474 10.6059ZM13.9148 7.3243L18.4153 10.6059L19.299 9.39387L14.7986 6.11229L13.9148 7.3243ZM4.64898 9.43544L3.50612 10.4354L4.49388 11.5643L5.63674 10.5643L4.64898 9.43544ZM18.3633 10.5643L19.5061 11.5643L20.4939 10.4354L19.351 9.43544L18.3633 10.5643ZM10.0852 7.3243C10.6676 6.89964 11.0538 6.61946 11.3733 6.4384C11.6759 6.26693 11.8509 6.2251 12 6.2251V4.7251C11.4974 4.7251 11.0624 4.89047 10.6337 5.13339C10.222 5.36674 9.75568 5.70815 9.20143 6.11229L10.0852 7.3243ZM14.7986 6.11229C14.2443 5.70815 13.778 5.36673 13.3663 5.13339C12.9376 4.89047 12.5026 4.7251 12 4.7251V6.2251C12.1491 6.2251 12.3241 6.26693 12.6267 6.4384C12.9462 6.61946 13.3324 6.89964 13.9148 7.3243L14.7986 6.11229Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v19-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","main","menu","dashboard","start"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.6207 11.9254C20.0053 12.0831 20.4636 11.9887 20.7526 11.6584C21.1163 11.2427 21.0742 10.611 20.6585 10.2473L19.5157 9.2473C19.4934 9.2278 19.4702 9.20931 19.4463 9.19187L14.9032 5.87914C14.3714 5.49136 13.9056 5.15166 13.4896 4.91589C13.0399 4.66106 12.5616 4.4751 12 4.4751C11.4384 4.4751 10.9601 4.66106 10.5105 4.91589C10.0944 5.15165 9.62862 5.49136 9.09688 5.87912C9.08269 5.88948 9.06844 5.89986 9.05415 5.91028L4.5178 9.21804L3.34151 10.2473C2.92587 10.611 2.88375 11.2427 3.24744 11.6584C3.53645 11.9887 3.99475 12.0831 4.37936 11.9254L4.85738 15.6899C4.95651 16.4709 5.04255 17.1488 5.18228 17.6895C5.33268 18.2714 5.57375 18.8184 6.06461 19.2508C6.55547 19.6833 7.12846 19.8536 7.72471 19.9295C8.27871 20 8.96202 19.9999 9.74928 19.9999L9.80991 19.9999C10.4672 19.9999 11 19.467 11 18.8098V16.9999C11 16.4476 11.4477 15.9999 12 15.9999C12.5523 15.9999 13 16.4476 13 16.9999V18.8098C13 19.467 13.5328 19.9999 14.1901 19.9999L14.2507 19.9999C15.038 19.9999 15.7213 20 16.2753 19.9295C16.8716 19.8536 17.4446 19.6833 17.9354 19.2508C18.4263 18.8184 18.6673 18.2714 18.8177 17.6895C18.9575 17.1488 19.0435 16.4709 19.1427 15.6899L19.6207 11.9254Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v19": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","main-menu","dashboard","start","location","house","address","default"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.14286 10L5.84176 15.5039C6.05318 17.1688 6.15889 18.0013 6.72567 18.5006C7.29244 19 8.13159 19 9.8099 19H10M5.14286 10L9.64331 6.71842C10.7799 5.88962 11.3483 5.47522 12 5.47522C12.6517 5.47522 13.2201 5.88962 14.3567 6.71842L18.8571 10M5.14286 10L4 11M18.8571 10L18.1582 15.5039C17.9468 17.1688 17.8411 18.0013 17.2743 18.5006C16.7076 19 15.8684 19 14.1901 19H14M18.8571 10L20 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 19V17C10 15.8954 10.8954 15 12 15V15C13.1046 15 14 15.8954 14 17V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["home","location","main-menu","homepage","start","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18V16C10 14.8954 10.8954 14 12 14V14C13.1046 14 14 14.8954 14 16V18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10L6.37983 13.0386C6.65679 15.2544 6.79528 16.3622 7.48743 17.081C7.59989 17.1978 7.72164 17.3052 7.85147 17.4023C8.65052 18 9.76701 18 12 18V18C14.233 18 15.3495 18 16.1485 17.4023C16.2784 17.3052 16.4001 17.1978 16.5126 17.081C17.2047 16.3622 17.3432 15.2544 17.6202 13.0386L18 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","main-menu","dashboard","location","address","store","main"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.34396 13.0432L5.875 9.5L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L18.125 9.5L17.656 13.0432C17.3604 15.2771 17.2126 16.394 16.5025 17.1109C16.403 17.2114 16.2966 17.3047 16.1839 17.3902C15.38 18 14.2533 18 12 18C9.7467 18 8.62004 18 7.8161 17.3902C7.70344 17.3047 7.59696 17.2114 7.49746 17.1109C6.78744 16.394 6.63961 15.277 6.34396 13.0432Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M5.875 9.5L6.34396 13.0432C6.63961 15.277 6.78744 16.394 7.49746 17.1109C7.59696 17.2114 7.70344 17.3047 7.8161 17.3902C8.62004 18 9.7467 18 12 18V18C14.2533 18 15.38 18 16.1839 17.3902C16.2966 17.3047 16.403 17.2114 16.5025 17.1109C17.2126 16.394 17.3604 15.277 17.656 13.0432L18.125 9.5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 16V18L14 18V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","store","main","menu","location","shop","start"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.5052 8.83L18.6452 8.34C18.6452 8.34 18.6152 8.32 18.6052 8.32L14.4852 5.96C13.4352 5.36 12.8052 5 12.0052 5C11.2052 5 10.5752 5.36 9.52522 5.96L5.40522 8.32C5.40522 8.32 5.37522 8.34 5.36522 8.34L4.50522 8.83C4.02522 9.1 3.85522 9.71 4.13522 10.19C4.33522 10.53 4.71522 10.72 5.06522 10.69L5.35522 12.87C5.66522 15.25 5.84522 16.55 6.78522 17.51C6.91522 17.64 7.05522 17.77 7.20522 17.88C8.27522 18.69 9.59522 18.69 11.9952 18.69C14.3952 18.69 15.7152 18.69 16.7852 17.88C16.9352 17.77 17.0752 17.64 17.2052 17.51C18.1552 16.55 18.3252 15.25 18.6352 12.87L18.9252 10.69C19.3052 10.72 19.68 10.53 19.87 10.19C20.14 9.71 19.9852 9.1 19.5052 8.83ZM14.7552 16.6C14.7552 17.01 14.4152 17.35 14.0052 17.35H10.0052C9.59522 17.35 9.25522 17.01 9.25522 16.6V14.6C9.25522 13.08 10.4852 11.85 12.0052 11.85C13.5252 11.85 14.7552 13.08 14.7552 14.6V16.6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","store","location","main","menu","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10L6.37983 13.0386C6.65679 15.2544 6.79528 16.3622 7.48743 17.081C7.59989 17.1978 7.72164 17.3052 7.85147 17.4023C8.65052 18 9.76701 18 12 18V18C14.233 18 15.3495 18 16.1485 17.4023C16.2784 17.3052 16.4001 17.1978 16.5126 17.081C17.2047 16.3622 17.3432 15.2544 17.6202 13.0386L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 18V16C10 14.8954 10.8954 14 12 14V14C13.1046 14 14 14.8954 14 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v20-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","main","menu","dashboard","start","location","address","hub"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.66667L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L20 9.66667M5.14286 9.66667V13C5.14286 15.8284 5.14286 17.2426 6.02154 18.1213C6.90022 19 8.31443 19 11.1429 19H12.8571C15.6856 19 17.0998 19 17.9785 18.1213C18.8571 17.2426 18.8571 15.8284 18.8571 13V6.16667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v20-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","main-menu","dashboard","location","address","store","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8571 19H11.1429C8.31443 19 6.90022 19 6.02154 18.1213C5.14286 17.2426 5.14286 15.8284 5.14286 13V9L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L18.8571 9V13C18.8571 15.8284 18.8571 17.2426 17.9785 18.1213C17.0998 19 15.6856 19 12.8571 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 9.66667L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L20 9.66667M5.14286 9V13C5.14286 15.8284 5.14286 17.2426 6.02154 18.1213C6.90022 19 8.31443 19 11.1429 19H12.8571C15.6856 19 17.0998 19 17.9785 18.1213C18.8571 17.2426 18.8571 15.8284 18.8571 13V6.16667"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v20-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.75015 13C9.75015 11.7574 10.7575 10.75 12.0002 10.75C13.2428 10.75 14.2502 11.7574 14.2502 13C14.2502 13.6215 13.9991 14.183 13.5911 14.591C13.1832 14.999 12.6217 15.25 12.0002 15.25C10.7575 15.25 9.75015 14.2426 9.75015 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4813 5.28966L17.8573 7.25899V6.16669C17.8573 5.6144 18.305 5.16669 18.8573 5.16669C19.4096 5.16669 19.8573 5.6144 19.8573 6.16669V8.42565L20.504 8.80291C20.9811 9.08119 21.1422 9.69351 20.8639 10.1706C20.6526 10.5329 20.2485 10.713 19.8573 10.6567L19.8573 13.0706C19.8573 14.4247 19.8574 15.5413 19.7386 16.4251C19.6138 17.3529 19.3418 18.1723 18.6857 18.8285C18.0296 19.4846 17.2102 19.7565 16.2824 19.8813C15.3986 20.0001 14.282 20.0001 12.9279 20H11.0724C9.71833 20.0001 8.60171 20.0001 7.71796 19.8813C6.79013 19.7565 5.9707 19.4846 5.31459 18.8285C4.65848 18.1723 4.38652 17.3529 4.26177 16.4251C4.14295 15.5413 4.14298 14.4247 4.14302 13.0706L4.14302 10.6567C3.75186 10.713 3.34776 10.5329 3.13638 10.1706C2.8581 9.69351 3.01924 9.08119 3.49629 8.80291L9.51899 5.28967C9.97791 5.02193 10.3834 4.78539 10.7423 4.62116C11.1313 4.44316 11.5361 4.31543 12.0002 4.31543C12.4642 4.31543 12.869 4.44316 13.258 4.62116C13.617 4.78539 14.0224 5.02193 14.4813 5.28966ZM12.0002 9.25C9.92908 9.25 8.25015 10.9289 8.25015 13C8.25015 15.0711 9.92908 16.75 12.0002 16.75C13.0355 16.75 13.974 16.3294 14.6518 15.6516C15.3296 14.9739 15.7502 14.0353 15.7502 13C15.7502 10.9289 14.0712 9.25 12.0002 9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v20": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main","menu","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.66667L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L20 9.66667M5.14286 9.66667V13C5.14286 15.8284 5.14286 17.2426 6.02154 18.1213C6.90022 19 8.31443 19 11.1429 19H12.8571C15.6856 19 17.0998 19 17.9785 18.1213C18.8571 17.2426 18.8571 15.8284 18.8571 13V6.16667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v21-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","main-menu","dashboard","start","location","address","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.56202 15.4961C5.77057 17.1645 5.87484 17.9987 6.44196 18.4994C7.00908 19 7.84976 19 9.53113 19H14.4689C16.1502 19 16.9909 19 17.558 18.4994C18.1252 17.9987 18.2294 17.1645 18.438 15.4961L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v21-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","location","store","main","address","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.6 6.8L5 10.25L5.56202 15.4961C5.77057 17.1645 5.87484 17.9987 6.44196 18.4994C7.00908 19 7.84976 19 9.53113 19H14.4689C16.1502 19 16.9909 19 17.558 18.4994C18.1252 17.9987 18.2294 17.1645 18.438 15.4961L19 10.25L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4 11L9.6 6.8C10.7556 5.93333 11.3333 5.5 12 5.5C12.6667 5.5 13.2444 5.93333 14.4 6.8L20 11M5 10.25L5.56202 15.4961C5.77057 17.1645 5.87484 17.9987 6.44196 18.4994C7.00908 19 7.84976 19 9.53113 19H14.4689C16.1502 19 16.9909 19 17.558 18.4994C18.1252 17.9987 18.2294 17.1645 18.438 15.4961L19 10.25"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v21-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","homepage","menu","dashboard","main-menu","navigation","main"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0001 12.5C10.0001 11.3954 10.8955 10.5 12.0001 10.5C13.1046 10.5 14.0001 11.3954 14.0001 12.5C14.0001 13.6046 13.1046 14.5 12.0001 14.5C10.8955 14.5 10.0001 13.6046 10.0001 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.8001 11.1C20.5649 11.4135 20.181 11.5497 19.82 11.4839L19.4324 15.1027L19.4303 15.1202L19.4228 15.1804C19.325 15.9631 19.2401 16.6423 19.1012 17.1841C18.9516 17.7672 18.7111 18.3154 18.2199 18.749C17.7287 19.1827 17.1549 19.3533 16.5577 19.4294C16.0029 19.5001 15.3184 19.5 14.5296 19.5H9.47047C8.68175 19.5 7.99724 19.5001 7.44239 19.4294C6.84523 19.3533 6.27141 19.1827 5.78022 18.749C5.28902 18.3154 5.04849 17.7672 4.89893 17.1841C4.75997 16.6423 4.67511 15.9631 4.57733 15.1804L4.5698 15.1202L4.56777 15.1027L4.18009 11.4839C3.81909 11.5497 3.4352 11.4135 3.20006 11.1C2.86869 10.6582 2.95823 10.0314 3.40006 9.7L9.04327 5.46759C9.58404 5.06196 10.0572 4.70705 10.4803 4.46075C10.9374 4.19467 11.4252 4 12.0001 4C12.5749 4 13.0627 4.19467 13.5198 4.46075C13.9429 4.70705 14.4161 5.06195 14.9568 5.46757L20.6001 9.7C21.0419 10.0314 21.1314 10.6582 20.8001 11.1ZM12.0001 8.5C9.79092 8.5 8.00006 10.2909 8.00006 12.5C8.00006 14.7091 9.79092 16.5 12.0001 16.5C14.2092 16.5 16.0001 14.7091 16.0001 12.5C16.0001 10.2909 14.2092 8.5 12.0001 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v21": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main","main-menu","address","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.56202 15.4961C5.77057 17.1645 5.87484 17.9987 6.44196 18.4994C7.00908 19 7.84976 19 9.53113 19H14.4689C16.1502 19 16.9909 19 17.558 18.4994C18.1252 17.9987 18.2294 17.1645 18.438 15.4961L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v3 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","location","main","menu","circle","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v3 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","location","store","main","menu","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v3 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","circle","menu","main-menu","dashboard","navigation","front-desk","table-management","store","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.52 4.96L7.52 6.1C5.94 7 5.08 7.5 4.54 8.43C4 9.36 4 10.36 4 12.18V12.7C4 15.7 4 17.36 5.17 18.53C6.34 19.7 7.99 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM14.65 15.35C13.94 16.06 13 16.45 12 16.45C9.93 16.45 8.25 14.77 8.25 12.7C8.25 10.63 9.93 8.95 12 8.95C14.07 8.95 15.75 10.63 15.75 12.7C15.75 13.7 15.36 14.64 14.65 15.35Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v3 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main-menu","settings","dashboard","start","headquarters","outlet","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v4 line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","remove","delete","decrease","minimize","dashboard","main-menu","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13L11 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v4 line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","remove","delete","minimize","discount","customer","return","remove-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13L11 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v4 line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","main","menu","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.52 4.96L7.52 6.1C5.94 7 5.07999 7.5 4.53999 8.43C3.99999 9.36 4 10.36 4 12.18V12.7C4 15.7 4 17.36 5.17 18.53C6.34 19.7 7.99 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM13 13.7H11C10.45 13.7 10 13.25 10 12.7C10 12.15 10.45 11.7 11 11.7H13C13.55 11.7 14 12.15 14 12.7C14 13.25 13.55 13.7 13 13.7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v4 line": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","remove","delete","discount","house","location","address","remove-location","delete-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13L11 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home v5 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","location","address","store","main","main-screen","dashboard","headquarters","circle","menu","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v5 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","location","main","menu","dashboard","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.36598 7.30494L5 11.1717L5.34303 13.7444C5.65585 16.247 5.81226 17.4982 6.66294 18.2492C7.51362 19.0002 8.77464 19.0002 11.2967 19.0002H12.7033C15.2254 19.0002 16.4864 19.0002 17.3371 18.2492C18.1877 17.4982 18.3442 16.247 18.657 13.7444L19 11.1252L14.634 7.30494C13.379 6.20679 12.7515 5.65771 12 5.65771C11.2485 5.65771 10.621 6.20679 9.36598 7.30494Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M3.00274 11.9387C2.69266 12.2134 2.66391 12.6874 2.93854 12.9974C3.21317 13.3075 3.68717 13.3363 3.99726 13.0616L3.00274 11.9387ZM9.36598 7.30494L8.8721 6.7405L8.86873 6.74349L9.36598 7.30494ZM14.634 7.30494L14.1401 7.86938V7.86938L14.634 7.30494ZM19.5061 12.5646C19.8178 12.8374 20.2917 12.8058 20.5644 12.4941C20.8372 12.1823 20.8056 11.7085 20.4939 11.4357L19.5061 12.5646ZM5.34303 13.7444L6.08726 13.6514L6.08645 13.6453L5.34303 13.7444ZM18.657 13.7444L17.9133 13.647L17.9128 13.6514L18.657 13.7444ZM3.99726 13.0616L5.49726 11.7332L4.50274 10.6102L3.00274 11.9387L3.99726 13.0616ZM5.49726 11.7332L9.86324 7.8664L8.86873 6.74349L4.50274 10.6102L5.49726 11.7332ZM14.1401 7.86938L18.5061 11.6896L19.4939 10.5607L15.1279 6.74051L14.1401 7.86938ZM18.5061 11.6896L19.5061 12.5646L20.4939 11.4357L19.4939 10.5607L18.5061 11.6896ZM9.85986 7.86938C10.5022 7.30736 10.9316 6.93344 11.2907 6.69162C11.6323 6.46164 11.8305 6.40771 12 6.40771V4.90771C11.4181 4.90771 10.9268 5.12833 10.4529 5.44742C9.99662 5.75468 9.48483 6.20437 8.8721 6.74051L9.85986 7.86938ZM15.1279 6.74051C14.5152 6.20437 14.0034 5.75468 13.5471 5.44742C13.0732 5.12833 12.5819 4.90771 12 4.90771V6.40771C12.1695 6.40771 12.3677 6.46164 12.7093 6.69162C13.0684 6.93344 13.4978 7.30736 14.1401 7.86938L15.1279 6.74051ZM4.25658 11.2708L4.59961 13.8435L6.08645 13.6453L5.74342 11.0726L4.25658 11.2708ZM11.2967 19.7502H12.7033V18.2502H11.2967V19.7502ZM19.4006 13.8418L19.7437 11.2226L18.2564 11.0278L17.9133 13.647L19.4006 13.8418ZM12.7033 19.7502C13.9446 19.7502 14.9465 19.7516 15.7417 19.6503C16.558 19.5463 17.2523 19.3244 17.8334 18.8115L16.8407 17.687C16.5711 17.925 16.2096 18.0786 15.5522 18.1623C14.8737 18.2488 13.9841 18.2502 12.7033 18.2502V19.7502ZM17.9128 13.6514C17.7539 14.9223 17.6422 15.8048 17.4722 16.4673C17.3076 17.1093 17.1103 17.4489 16.8407 17.687L17.8334 18.8115C18.4145 18.2985 18.7208 17.6371 18.9252 16.84C19.1244 16.0635 19.2472 15.0691 19.4012 13.8374L17.9128 13.6514ZM4.59882 13.8374C4.75278 15.0691 4.87564 16.0635 5.0748 16.84C5.27924 17.6371 5.58552 18.2985 6.16659 18.8115L7.15929 17.687C6.88968 17.4489 6.69242 17.1093 6.52777 16.4673C6.35785 15.8048 6.2461 14.9223 6.08723 13.6514L4.59882 13.8374ZM11.2967 18.2502C10.0159 18.2502 9.12632 18.2488 8.44783 18.1623C7.79043 18.0786 7.42891 17.925 7.15929 17.687L6.16659 18.8115C6.74765 19.3244 7.44198 19.5463 8.25827 19.6503C9.05348 19.7516 10.0554 19.7502 11.2967 19.7502V18.2502Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v5 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","main-menu","dashboard","start","main"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.9258 11.59L19.9258 10.71L15.5558 6.89C14.9458 6.36 14.4258 5.9 13.9458 5.58C13.4458 5.25 12.9058 5 12.2558 5C11.6058 5 11.0658 5.25 10.5658 5.58C10.0958 5.9 9.56581 6.36 8.95581 6.89L4.58581 10.76L3.08581 12.09C2.67581 12.46 2.6358 13.09 2.9958 13.5C3.3658 13.91 3.9958 13.95 4.4058 13.59L4.4958 13.51L4.58581 14.22C4.73581 15.44 4.86581 16.45 5.06581 17.25C5.27581 18.07 5.59581 18.79 6.23581 19.35C6.86581 19.91 7.6158 20.14 8.4658 20.25C9.2758 20.35 10.2958 20.35 11.5358 20.35H12.9458C14.1858 20.35 15.2058 20.35 16.0158 20.25C16.8558 20.14 17.6058 19.91 18.2458 19.35C18.8758 18.79 19.2058 18.08 19.4158 17.25C19.6158 16.46 19.7458 15.44 19.8958 14.22L20.0158 13.31C20.3658 13.39 20.7458 13.3 20.9958 13.01C21.3558 12.59 21.3358 11.95 20.9258 11.59ZM14.2058 15.29C13.6858 15.81 12.9958 16.1 12.2658 16.1C10.7458 16.1 9.5158 14.87 9.5158 13.35C9.5158 11.83 10.7458 10.6 12.2658 10.6C13.7858 10.6 15.0158 11.83 15.0158 13.35C15.0158 14.08 14.7258 14.78 14.2058 15.29Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v5 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","store","location","main","menu","start","address","shop","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C12.5523 15 13.0523 14.7761 13.4142 14.4142C13.7761 14.0523 14 13.5523 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v6 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","main-menu","dashboard","navigation","start","hq","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v6 circle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["home","main-menu","dashboard","location","store","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.36598 7.30494L5 11.1717L5.34303 13.7444C5.65585 16.247 5.81226 17.4982 6.66294 18.2492C7.51362 19.0002 8.77464 19.0002 11.2967 19.0002H12.7033C15.2254 19.0002 16.4864 19.0002 17.3371 18.2492C18.1877 17.4982 18.3442 16.247 18.657 13.7444L19 11.1252L14.634 7.30494C13.379 6.20679 12.7515 5.65771 12 5.65771C11.2485 5.65771 10.621 6.20679 9.36598 7.30494Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M3.00274 11.9387C2.69266 12.2134 2.66391 12.6874 2.93854 12.9974C3.21317 13.3075 3.68717 13.3363 3.99726 13.0616L3.00274 11.9387ZM9.36598 7.30494L8.8721 6.7405L8.86873 6.74349L9.36598 7.30494ZM14.634 7.30494L14.1401 7.86938V7.86938L14.634 7.30494ZM19.5061 12.5646C19.8178 12.8374 20.2917 12.8058 20.5644 12.4941C20.8372 12.1823 20.8056 11.7085 20.4939 11.4357L19.5061 12.5646ZM5.34303 13.7444L6.08726 13.6514L6.08645 13.6453L5.34303 13.7444ZM18.657 13.7444L17.9133 13.647L17.9128 13.6514L18.657 13.7444ZM3.99726 13.0616L5.49726 11.7332L4.50274 10.6102L3.00274 11.9387L3.99726 13.0616ZM5.49726 11.7332L9.86324 7.8664L8.86873 6.74349L4.50274 10.6102L5.49726 11.7332ZM14.1401 7.86938L18.5061 11.6896L19.4939 10.5607L15.1279 6.74051L14.1401 7.86938ZM18.5061 11.6896L19.5061 12.5646L20.4939 11.4357L19.4939 10.5607L18.5061 11.6896ZM9.85986 7.86938C10.5022 7.30736 10.9316 6.93344 11.2907 6.69162C11.6323 6.46164 11.8305 6.40771 12 6.40771V4.90771C11.4181 4.90771 10.9268 5.12833 10.4529 5.44742C9.99662 5.75468 9.48483 6.20437 8.8721 6.74051L9.85986 7.86938ZM15.1279 6.74051C14.5152 6.20437 14.0034 5.75468 13.5471 5.44742C13.0732 5.12833 12.5819 4.90771 12 4.90771V6.40771C12.1695 6.40771 12.3677 6.46164 12.7093 6.69162C13.0684 6.93344 13.4978 7.30736 14.1401 7.86938L15.1279 6.74051ZM4.25658 11.2708L4.59961 13.8435L6.08645 13.6453L5.74342 11.0726L4.25658 11.2708ZM11.2967 19.7502H12.7033V18.2502H11.2967V19.7502ZM19.4006 13.8418L19.7437 11.2226L18.2564 11.0278L17.9133 13.647L19.4006 13.8418ZM12.7033 19.7502C13.9446 19.7502 14.9465 19.7516 15.7417 19.6503C16.558 19.5463 17.2523 19.3244 17.8334 18.8115L16.8407 17.687C16.5711 17.925 16.2096 18.0786 15.5522 18.1623C14.8737 18.2488 13.9841 18.2502 12.7033 18.2502V19.7502ZM17.9128 13.6514C17.7539 14.9223 17.6422 15.8048 17.4722 16.4673C17.3076 17.1093 17.1103 17.4489 16.8407 17.687L17.8334 18.8115C18.4145 18.2985 18.7208 17.6371 18.9252 16.84C19.1244 16.0635 19.2472 15.0691 19.4012 13.8374L17.9128 13.6514ZM4.59882 13.8374C4.75278 15.0691 4.87564 16.0635 5.0748 16.84C5.27924 17.6371 5.58552 18.2985 6.16659 18.8115L7.15929 17.687C6.88968 17.4489 6.69242 17.1093 6.52777 16.4673C6.35785 15.8048 6.2461 14.9223 6.08723 13.6514L4.59882 13.8374ZM11.2967 18.2502C10.0159 18.2502 9.12632 18.2488 8.44783 18.1623C7.79043 18.0786 7.42891 17.925 7.15929 17.687L6.16659 18.8115C6.74765 19.3244 7.44198 19.5463 8.25827 19.6503C9.05348 19.7516 10.0554 19.7502 11.2967 19.7502V18.2502Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v6 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","location","address","store","main","main-menu","dashboard","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.0026 12.6587C20.7494 12.9481 20.3663 13.0564 20.0166 12.9728L19.8993 13.8684L19.8985 13.8742L19.8912 13.9332C19.7417 15.1293 19.6178 16.1207 19.4174 16.9021C19.2063 17.725 18.8818 18.4401 18.2489 18.9989C17.6159 19.5577 16.8661 19.7909 16.0233 19.8983C15.2231 20.0002 14.224 20.0002 13.0186 20.0002H11.4814C10.276 20.0002 9.27695 20.0002 8.47669 19.8983C7.63392 19.7909 6.88412 19.5577 6.25115 18.9989C5.61817 18.4401 5.29372 17.725 5.08265 16.9021C4.88223 16.1207 4.75834 15.1293 4.60886 13.9332L4.60127 13.8725L4.50701 13.1656L4.41302 13.2488C3.99958 13.615 3.36757 13.5766 3.0014 13.1632C2.63523 12.7497 2.67355 12.1177 3.087 11.7516L8.95749 6.55237L9.00291 6.51262C9.59153 5.99752 10.1026 5.55027 10.5633 5.24006C11.0592 4.90611 11.5993 4.65771 12.25 4.65771C12.9007 4.65771 13.4408 4.90611 13.9367 5.24006C14.3974 5.55027 14.9085 5.99751 15.4971 6.5126L20.9085 11.2476C21.3242 11.6113 21.3663 12.243 21.0026 12.6587ZM12.25 9.5C10.8693 9.5 9.75002 10.6193 9.75002 12C9.75002 13.3807 10.8693 14.5 12.25 14.5C12.9402 14.5 13.5659 14.2196 14.0178 13.7678C14.4696 13.3159 14.75 12.6902 14.75 12C14.75 10.6193 13.6307 9.5 12.25 9.5ZM13.25 16.5C13.25 15.9477 12.8023 15.5 12.25 15.5C11.6977 15.5 11.25 15.9477 11.25 16.5V18C11.25 18.5523 11.6977 19 12.25 19C12.8023 19 13.25 18.5523 13.25 18V16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v6 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","main-menu","headquarters","store","business","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 12L14.634 7.30477C13.379 6.20661 12.7515 5.65754 12 5.65754C11.2485 5.65754 10.621 6.20661 9.36598 7.30476L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11L5.34303 13.7442C5.65585 16.2468 5.81226 17.4981 6.66294 18.249C7.51362 19 8.77464 19 11.2967 19H12.7033C15.2254 19 16.4864 19 17.3371 18.249C18.1877 17.4981 18.3442 16.2468 18.657 13.7442L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v7 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","location","store","outlet","headquarters","main","address","return","main-screen","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10L6.56202 13.5039C6.30007 15.5994 6.1691 16.6472 6.76621 17.3236C7.36332 18 8.41925 18 10.5311 18H13.4689C15.5807 18 16.6367 18 17.2338 17.3236C17.8309 16.6472 17.6999 15.5994 17.438 13.5039L17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 16V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 11L14.325 7.66068C13.2023 6.85877 12.6409 6.45781 12 6.45781C11.3591 6.45781 10.7977 6.85877 9.67505 7.66068L5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v7 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","location","store","address","main","main-menu","search","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.56202 13.5041L7.05252 9.53411L9.67505 7.66088C10.7977 6.85897 11.3591 6.45801 12 6.45801C12.6409 6.45801 13.2023 6.85897 14.325 7.66088L17 9.57163L17.438 13.5041C17.6999 15.5996 17.8309 16.6474 17.2338 17.3238C16.6367 18.0002 15.5807 18.0002 13.4689 18.0002H10.5311C8.41925 18.0002 7.36332 18.0002 6.76621 17.3238C6.1691 16.6474 6.30007 15.5996 6.56202 13.5041Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M7.05252 9.53411L6.56202 13.5041C6.30007 15.5996 6.1691 16.6474 6.76621 17.3238C7.36332 18.0002 8.41925 18.0002 10.5311 18.0002H13.4689C15.5807 18.0002 16.6367 18.0002 17.2338 17.3238C17.8309 16.6474 17.6999 15.5996 17.438 13.5041L17 9.57163M19 11.0002L14.325 7.66088C13.2023 6.85897 12.6409 6.45801 12 6.45801C11.3591 6.45801 10.7977 6.85897 9.67505 7.66088L5 11.0002"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 16V18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home v7 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","dashboard","main-menu","start","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.4188 11.8139L18.2419 11.6876L18.4312 13.3866L18.4391 13.4503C18.5626 14.438 18.6682 15.2822 18.658 15.9612C18.6471 16.6846 18.506 17.3938 17.9835 17.9856C17.4611 18.5774 16.7749 18.8054 16.0584 18.906C15.3859 19.0003 14.5351 19.0003 13.5397 19.0002H10.4605C9.46502 19.0003 8.61422 19.0003 7.94176 18.906C7.22522 18.8054 6.53906 18.5774 6.01661 17.9856C5.49416 17.3938 5.35304 16.6846 5.34216 15.9612C5.33194 15.2822 5.43752 14.438 5.56104 13.4502L5.78093 11.6714L5.58132 11.8139C5.1319 12.1349 4.50735 12.0309 4.18634 11.5814C3.86534 11.132 3.96943 10.5075 4.41884 10.1865L9.13624 6.81689C9.66131 6.44179 10.1217 6.11289 10.5325 5.88461C10.9767 5.63779 11.4481 5.45801 12.0001 5.45801C12.5521 5.45801 13.0234 5.63779 13.4676 5.88461C13.8784 6.11289 14.3388 6.44179 14.8639 6.8169L19.5813 10.1865C20.0307 10.5075 20.1348 11.132 19.8138 11.5814C19.4928 12.0309 18.8683 12.1349 18.4188 11.8139ZM9.50009 11.5C9.50009 10.1193 10.6194 9 12.0001 9C13.3808 9 14.5001 10.1193 14.5001 11.5C14.5001 12.1902 14.2197 12.8159 13.7679 13.2678C13.316 13.7196 12.6903 14 12.0001 14C10.6194 14 9.50009 12.8807 9.50009 11.5ZM12.0001 15C12.5524 15 13.0001 15.4477 13.0001 16V16.5C13.0001 17.0523 12.5524 17.5 12.0001 17.5C11.4478 17.5 11.0001 17.0523 11.0001 16.5V16C11.0001 15.4477 11.4478 15 12.0001 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v7 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","address","main-menu","headquarters","store","shop","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10L6.56202 13.5039C6.30007 15.5994 6.1691 16.6472 6.76621 17.3236C7.36332 18 8.41925 18 10.5311 18H13.4689C15.5807 18 16.6367 18 17.2338 17.3236C17.8309 16.6472 17.6999 15.5994 17.438 13.5039L17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 16V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 11L14.325 7.66068C13.2023 6.85877 12.6409 6.45781 12 6.45781C11.3591 6.45781 10.7977 6.85877 9.67505 7.66068L5 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home v8 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","house","location","address","store","main","dashboard","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.56202 14.4961C6.77057 16.1645 6.87484 16.9987 7.44196 17.4994C8.00908 18 8.84976 18 10.5311 18H13.4689C15.1502 18 15.9909 18 16.558 17.4994C17.1252 16.9987 17.2294 16.1645 17.438 14.4961L18 10M6 10L9.43927 7.13395C10.6637 6.11359 11.2759 5.60342 12 5.60342C12.7241 5.60342 13.3363 6.11359 14.5607 7.13395L18 10M6 10L5 11M18 10L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 16V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home v8 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","location","store","shop","main","main-menu","dashboard","hq","headquarters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.56202 14.4961L6 10L9.43927 7.13395C10.6637 6.11359 11.2759 5.60342 12 5.60342C12.7241 5.60342 13.3363 6.11359 14.5607 7.13395L18 10L17.438 14.4961C17.2294 16.1645 17.1252 16.9987 16.558 17.4994C15.9909 18 15.1502 18 13.4689 18H10.5311C8.84976 18 8.00908 18 7.44196 17.4994C6.87484 16.9987 6.77057 16.1645 6.56202 14.4961Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 10L6.56202 14.4961C6.77057 16.1645 6.87484 16.9987 7.44196 17.4994C8.00908 18 8.84976 18 10.5311 18H13.4689C15.1502 18 15.9909 18 16.558 17.4994C17.1252 16.9987 17.2294 16.1645 17.438 14.4961L18 10M6 10L9.43927 7.13395C10.6637 6.11359 11.2759 5.60342 12 5.60342C12.7241 5.60342 13.3363 6.11359 14.5607 7.13395L18 10M6 10L5 11M18 10L19 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 16V18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home v8 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","store","main-menu","homepage","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 11.7072C19.4507 11.9636 19.0896 12.0517 18.7614 11.9714L18.4227 14.6805C18.325 15.4632 18.2401 16.1424 18.1011 16.6842C17.9516 17.2673 17.711 17.8155 17.2198 18.2491C16.7286 18.6828 16.1548 18.8534 15.5577 18.9295C15.0028 19.0002 14.3183 19.0001 13.5296 19.0001H10.4704C9.68169 19.0001 8.99719 19.0002 8.44233 18.9295C7.84517 18.8534 7.27135 18.6828 6.78016 18.2491C6.28896 17.8155 6.04843 17.2673 5.89888 16.6842C5.75991 16.1424 5.67505 15.4632 5.57727 14.6805L5.23863 11.9714C4.91036 12.0517 4.54932 11.9636 4.29289 11.7072C3.90237 11.3167 3.90237 10.6835 4.29289 10.293L5.32497 9.26092L8.8439 6.32847C9.41772 5.85023 9.91725 5.43391 10.3663 5.14508C10.8504 4.83377 11.3739 4.60352 12 4.60352C12.6261 4.60352 13.1496 4.83377 13.6337 5.14509C14.0827 5.4339 14.5823 5.85022 15.1561 6.32846L18.675 9.26092L19.7071 10.293C20.0976 10.6835 20.0976 11.3167 19.7071 11.7072ZM9.5 11C9.5 9.61929 10.6193 8.5 12 8.5C13.3807 8.5 14.5 9.61929 14.5 11C14.5 11.6902 14.2196 12.3159 13.7678 12.7678C13.3159 13.2196 12.6902 13.5 12 13.5C10.6193 13.5 9.5 12.3807 9.5 11ZM12 14.5C12.5523 14.5 13 14.9477 13 15.5V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15.5C11 14.9477 11.4477 14.5 12 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v8 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","location","address","main-menu","start","dashboard","outlet","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.56202 14.4961C6.77057 16.1645 6.87484 16.9987 7.44196 17.4994C8.00908 18 8.84976 18 10.5311 18H13.4689C15.1502 18 15.9909 18 16.558 17.4994C17.1252 16.9987 17.2294 16.1645 17.438 14.4961L18 10M6 10L9.43927 7.13395C10.6637 6.11359 11.2759 5.60342 12 5.60342C12.7241 5.60342 13.3363 6.11359 14.5607 7.13395L18 10M6 10L5 11M18 10L19 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 16V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home v9 circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","dashboard","main-menu","start","default-screen","navigation","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M19 10L14.325 6.66068C13.2023 5.85877 12.6409 5.45781 12 5.45781C11.3591 5.45781 10.7977 5.85877 9.67505 6.66068L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 12V14M18 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home v9 circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","location","main","menu","homepage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12.0002L6 9.28591L9.67505 6.66088C10.7977 5.85897 11.3591 5.45801 12 5.45801C12.6409 5.45801 13.2023 5.85897 14.325 6.66088L18 9.28591V12.0002C18 14.8286 18 16.2428 17.1213 17.1215C16.2426 18.0002 14.8284 18.0002 12 18.0002C9.17157 18.0002 7.75736 18.0002 6.87868 17.1215C6 16.2428 6 14.8286 6 12.0002Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 9.28591L6 12.0002C6 14.8286 6 16.2428 6.87868 17.1215C7.75736 18.0002 9.17157 18.0002 12 18.0002C14.8284 18.0002 16.2426 18.0002 17.1213 17.1215C18 16.2428 18 14.8286 18 12.0002V9.28591M19 10.0002L14.325 6.66088C13.2023 5.85897 12.6409 5.45801 12 5.45801C11.3591 5.45801 10.7977 5.85897 9.67505 6.66088L5 10.0002"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "home v9 circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","dashboard","main-menu","location","premises","outlet","store","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.5769 9.74L18.5869 9.03C18.5869 9.03 18.5769 9.02 18.5669 9.01L14.8969 6.39C13.6869 5.52 12.9569 5 11.9969 5C11.0369 5 10.3069 5.52 9.08691 6.39L5.42691 9C5.42691 9 5.40691 9.02 5.39691 9.02L4.41693 9.72C3.96693 10.04 3.86692 10.67 4.18692 11.12C4.37692 11.39 4.68692 11.54 4.99692 11.54V12.54C4.99692 15.54 4.99693 17.2 6.16693 18.37C7.33693 19.54 8.98692 19.54 11.9969 19.54C15.0069 19.54 16.6569 19.54 17.8269 18.37C18.9969 17.2 18.9969 15.54 18.9969 12.54V11.54C19.3069 11.54 19.63 11.39 19.82 11.12C20.14 10.67 20.0269 10.06 19.5769 9.74ZM11.9969 15.3C10.4769 15.3 9.24692 14.07 9.24692 12.55C9.24692 11.03 10.4769 9.8 11.9969 9.8C13.5169 9.8 14.7469 11.03 14.7469 12.55C14.7469 14.07 13.5169 15.3 11.9969 15.3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "home v9 circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","address","location","return","main-menu","main","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 10L14.325 6.66068C13.2023 5.85877 12.6409 5.45781 12 5.45781C11.3591 5.45781 10.7977 5.85877 9.67505 6.66068L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 12V14M18 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "home-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["home","dashboard","main-menu","start","house","navigation","main"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18V16C10 14.8954 10.8954 14 12 14V14C13.1046 14 14 14.8954 14 16V18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "home-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","main","menu","dashboard","start"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V9.42857L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L18 9.5V12C18 14.8284 18 16.2426 17.1213 17.1213C16.2426 18 14.8284 18 12 18C9.17157 18 7.75736 18 6.87868 17.1213C6 16.2426 6 14.8284 6 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L18 9.5L19 10M6 9.42857V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 16V18L14 18V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "home-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","store","main-menu","location","homepage","address","return-to-home"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.4552 8.8L19.0052 8.58V6.7C19.0052 6.15 18.5552 5.7 18.0052 5.7C17.4552 5.7 17.0052 6.15 17.0052 6.7V7.43L14.4852 5.96C13.4352 5.36 12.8052 5 12.0052 5C11.2052 5 10.5752 5.36 9.52522 5.96L5.51522 8.25C5.51522 8.25 5.50522 8.25 5.49522 8.25L4.50522 8.82C4.02522 9.09 3.85522 9.7 4.13522 10.18C4.31522 10.5 4.65522 10.68 5.00522 10.68V11.68C5.00522 14.68 5.00522 16.34 6.17522 17.51C7.34522 18.68 9.00522 18.68 12.0052 18.68C15.0052 18.68 16.6652 18.68 17.8352 17.51C19.0052 16.34 19.0052 14.68 19.0052 11.68V10.68C19.3752 10.68 19.7252 10.48 19.8952 10.13C20.1452 9.64 19.9552 9.05 19.4552 8.8ZM14.7552 16.5C14.7552 16.91 14.4152 17.25 14.0052 17.25H10.0052C9.59522 17.25 9.25522 16.91 9.25522 16.5V14.77C9.25522 13.25 10.4852 12.02 12.0052 12.02C13.5252 12.02 14.7552 13.25 14.7552 14.77V16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    home: {
        defaultColors: ["#3D4C66"],
        keywords: ["home","store","main-menu","location","homepage","address","return-to-home"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10L8.5 8L10.0154 7.13403C10.9844 6.58035 11.4689 6.3035 12 6.3035C12.5311 6.3035 13.0156 6.58035 13.9846 7.13403L15.5 8L19 10M6 10V12C6 14.8284 6 16.2426 6.87868 17.1213C7.75736 18 9.17157 18 12 18V18C14.8284 18 16.2426 18 17.1213 17.1213C18 16.2426 18 14.8284 18 12V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 18V16C10 14.8954 10.8954 14 12 14V14C13.1046 14 14 14.8954 14 16V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Home_discount-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","discount","percentage","sale","promotion","house","real-estate","discount-home","property-discount","home-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 10L5.4597 14.597C5.71648 17.1648 5.84487 18.4487 6.70195 19.2244C7.55902 20 8.84932 20 11.4299 20H12.5701C15.1507 20 16.441 20 17.2981 19.2244C18.1551 18.4487 18.2835 17.1648 18.5403 14.597L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16L14 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 11.1341C10.9781 11.4102 11.142 12.0217 10.8659 12.4999C10.5898 12.9781 9.9783 13.142 9.50008 12.8659C9.02187 12.5898 8.85802 11.9783 9.13412 11.5001C9.41022 11.0219 10.0217 10.858 10.4999 11.1341Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 15.1341C14.9781 15.4102 15.142 16.0217 14.8659 16.4999C14.5898 16.9781 13.9783 17.142 13.5001 16.8659C13.0219 16.5898 12.858 15.9783 13.1341 15.5001C13.4102 15.0219 14.0217 14.858 14.4999 15.1341Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Home_discount-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","house","home","real-estate","deal","price-cut","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.6 6.8L4.94634 10.2902L5.43454 14.6281C5.70339 17.1822 5.83781 18.4592 6.69357 19.2296C7.54933 20 8.83341 20 11.4016 20H12.5984C15.1666 20 16.4507 20 17.3064 19.2296C18.1622 18.4592 18.2966 17.1822 18.5655 14.6281L19 10.25L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M4.94634 10.2902L4.49634 9.69025H4.49634L4.94634 10.2902ZM9.6 6.8L9.15 6.2L9.6 6.8ZM14.4 6.8L14.85 6.2V6.2L14.4 6.8ZM19.55 11.6C19.8814 11.8485 20.3515 11.7814 20.6 11.45C20.8485 11.1186 20.7814 10.6485 20.45 10.4L19.55 11.6ZM5.43454 14.6281L6.18044 14.5496L6.17983 14.5442L5.43454 14.6281ZM18.5655 14.6281L19.3114 14.7066L19.3118 14.7022L18.5655 14.6281ZM17.3064 19.2296L17.8082 19.787L17.8082 19.787L17.3064 19.2296ZM4.45 11.6L5.39634 10.8902L4.49634 9.69025L3.55 10.4L4.45 11.6ZM5.39634 10.8902L10.05 7.4L9.15 6.2L4.49634 9.69025L5.39634 10.8902ZM13.95 7.4L18.55 10.85L19.45 9.65L14.85 6.2L13.95 7.4ZM18.55 10.85L19.55 11.6L20.45 10.4L19.45 9.65L18.55 10.85ZM10.05 7.4C10.642 6.95601 11.035 6.66272 11.3606 6.47318C11.6692 6.29358 11.8478 6.25 12 6.25V4.75C11.4856 4.75 11.0419 4.92309 10.606 5.17682C10.1872 5.42061 9.71357 5.77733 9.15 6.2L10.05 7.4ZM14.85 6.2C14.2864 5.77733 13.8128 5.42061 13.394 5.17682C12.9581 4.92309 12.5144 4.75 12 4.75V6.25C12.1522 6.25 12.3308 6.29358 12.6394 6.47318C12.965 6.66272 13.358 6.95601 13.95 7.4L14.85 6.2ZM4.20104 10.3741L4.68924 14.712L6.17983 14.5442L5.69163 10.2064L4.20104 10.3741ZM11.4016 20.75H12.5984V19.25H11.4016V20.75ZM19.3118 14.7022L19.7463 10.3241L18.2537 10.1759L17.8191 14.554L19.3118 14.7022ZM12.5984 20.75C13.8625 20.75 14.8823 20.7514 15.6902 20.6476C16.5193 20.541 17.2235 20.3134 17.8082 19.787L16.8046 18.6722C16.5336 18.9162 16.1678 19.0738 15.4989 19.1598C14.8088 19.2486 13.9025 19.25 12.5984 19.25V20.75ZM17.8196 14.5496C17.6831 15.8465 17.5867 16.7477 17.4263 17.4247C17.2707 18.081 17.0756 18.4282 16.8046 18.6722L17.8082 19.787C18.393 19.2605 18.693 18.5841 18.8858 17.7707C19.0737 16.9781 19.179 15.9638 19.3113 14.7066L17.8196 14.5496ZM4.68866 14.7066C4.82099 15.9638 4.9263 16.9781 5.11418 17.7707C5.30699 18.5841 5.60699 19.2605 6.19176 19.787L7.19537 18.6722C6.92439 18.4282 6.72929 18.081 6.57374 17.4247C6.41325 16.7477 6.31693 15.8465 6.18042 14.5496L4.68866 14.7066ZM11.4016 19.25C10.0975 19.25 9.19117 19.2486 8.50106 19.1598C7.83215 19.0738 7.46636 18.9162 7.19537 18.6722L6.19176 19.787C6.77654 20.3134 7.48066 20.541 8.30978 20.6476C9.11769 20.7514 10.1375 20.75 11.4016 20.75V19.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M10 16L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 11.1341C10.9781 11.4102 11.142 12.0217 10.8659 12.4999C10.5898 12.9781 9.9783 13.142 9.50008 12.8659C9.02187 12.5898 8.85802 11.9783 9.13412 11.5001C9.41022 11.0219 10.0217 10.858 10.4999 11.1341Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.4999 15.1341C14.9781 15.4102 15.142 16.0217 14.8659 16.4999C14.5898 16.9781 13.9783 17.142 13.5001 16.8659C13.0219 16.5898 12.858 15.9783 13.1341 15.5001C13.4102 15.0219 14.0217 14.858 14.4999 15.1341Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Home_discount-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","price reduction","home discount","loyalty program","offer","special offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 4C11.4248 4 10.9384 4.1929 10.4805 4.45965C10.0618 4.70355 9.59331 5.05497 9.05693 5.45734L3.40006 9.7C2.95823 10.0314 2.86869 10.6582 3.20006 11.1C3.43472 11.4129 3.81752 11.5491 4.17788 11.4843L4.46514 14.2007L4.4656 14.2052L4.47133 14.2619C4.59586 15.4931 4.69872 16.51 4.88464 17.3121C5.08 18.1548 5.39311 18.8879 6.02394 19.4668L6.02824 19.4707C6.66729 20.0503 7.43097 20.2927 8.29156 20.4042C9.10853 20.5101 10.1302 20.51 11.3635 20.51H12.6367C13.8699 20.51 14.8916 20.5101 15.7086 20.4042C16.5691 20.2927 17.3328 20.0503 17.9719 19.4707C18.6097 18.8922 18.9269 18.158 19.123 17.3121C19.3114 16.4993 19.4117 15.4676 19.5333 14.2177L19.535 14.201L19.8222 11.4843C20.1826 11.5491 20.5654 11.4129 20.8001 11.1C21.1314 10.6582 21.0419 10.0314 20.6001 9.7L14.9432 5.45735C14.4068 5.05498 13.9384 4.70355 13.5196 4.45965C13.0617 4.1929 12.5753 4 12.0001 4ZM8.96771 11.6251C9.31285 11.0273 10.0772 10.8225 10.675 11.1677C11.2728 11.5128 11.4776 12.2772 11.1325 12.875C10.7874 13.4727 10.023 13.6776 9.42518 13.3324C8.8274 12.9873 8.62258 12.2229 8.96771 11.6251ZM14.7572 11.5429C15.1477 11.9335 15.1477 12.5666 14.7572 12.9571L10.7572 16.9571C10.3667 17.3477 9.73352 17.3477 9.34299 16.9571C8.95247 16.5666 8.95247 15.9335 9.34299 15.5429L13.343 11.5429C13.7335 11.1524 14.3667 11.1524 14.7572 11.5429ZM14.675 15.1677C14.0772 14.8225 13.3128 15.0273 12.9677 15.6251C12.6226 16.2229 12.8274 16.9873 13.4252 17.3324C14.023 17.6776 14.7874 17.4727 15.1325 16.875C15.4776 16.2772 15.2728 15.5128 14.675 15.1677Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Home_discount: {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","sale","promotion","price reduction","home discount","loyalty program","offer","special offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11L14.4 6.8C13.2444 5.93333 12.6667 5.5 12 5.5C11.3333 5.5 10.7556 5.93333 9.6 6.8L4 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 10L5.4597 14.597C5.71648 17.1648 5.84487 18.4487 6.70195 19.2244C7.55902 20 8.84932 20 11.4299 20H12.5701C15.1507 20 16.441 20 17.2981 19.2244C18.1551 18.4487 18.2835 17.1648 18.5403 14.597L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 16L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 11.1341C10.9781 11.4102 11.142 12.0217 10.8659 12.4999C10.5898 12.9781 9.9783 13.142 9.50008 12.8659C9.02187 12.5898 8.85802 11.9783 9.13412 11.5001C9.41022 11.0219 10.0217 10.858 10.4999 11.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 15.1341C14.9781 15.4102 15.142 16.0217 14.8659 16.4999C14.5898 16.9781 13.9783 17.142 13.5001 16.8659C13.0219 16.5898 12.858 15.9783 13.1341 15.5001C13.4102 15.0219 14.0217 14.858 14.4999 15.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Home_search-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["home","search","find","location","store","inventory","item-lookup","lookup","menu-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L14.1213 15.1213M14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Home_search-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","search","find","location","lookup","main","menu","query","address","house"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L14.1213 15.1213M14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Home_search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","location","search","find","store","homepage","main-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 10.7002C10.9 10.7002 10 11.6002 10 12.7002C10 13.8002 10.9 14.7002 12 14.7002C12.53 14.7002 13.04 14.4902 13.42 14.1102C13.8 13.7302 14 13.2302 14 12.7002C14 11.6002 13.1 10.7002 12 10.7002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.46 8.43C18.92 7.5 18.05 7 16.47 6.1L14.48 4.96C13.43 4.36 12.8 4 12 4C11.2 4 10.57 4.36 9.52 4.96L7.52 6.1C5.94 7 5.08 7.5 4.54 8.43C4 9.36 4 10.36 4 12.18V12.7C4 15.7 4 17.36 5.17 18.53C6.34 19.7 8 19.7 11 19.7H13C16 19.7 17.66 19.7 18.83 18.53C20 17.36 20 15.7 20 12.7V12.18C20 10.36 20 9.36 19.46 8.43ZM15.71 14.99C16.1 15.38 16.1 16.01 15.71 16.4C15.32 16.79 14.69 16.79 14.3 16.4L14.04 16.14C13.43 16.5 12.73 16.69 12.01 16.69C9.8 16.69 8.01 14.9 8.01 12.69C8.01 10.48 9.8 8.69 12.01 8.69C14.22 8.69 16.01 10.48 16.01 12.69C16.01 13.42 15.82 14.11 15.46 14.72L15.72 14.98L15.71 14.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Home_search: {
        defaultColors: ["#3D4C66"],
        keywords: ["home","house","location","search","find","store","homepage","main-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V12.4819C5 10.783 5 9.93354 5.40527 9.23519C5.81054 8.53683 6.54808 8.11538 8.02317 7.27248L10.0154 6.13403C10.9844 5.58035 11.4689 5.3035 12 5.3035C12.5311 5.3035 13.0156 5.58035 13.9846 6.13403L15.9768 7.27248C17.4519 8.11538 18.1895 8.53683 18.5947 9.23519C19 9.93354 19 10.783 19 12.4819V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 16L14.1213 15.1213M14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "hook-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["anchor","hook","secure","loyalty","membership","saved","holding","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13C18 16.3137 15.3137 19 12 19C8.68629 19 6 16.3137 6 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 13L19 15M6 13L5 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hook-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["anchor","hook","shipping","hold","confirm","stability","dock","secured","loyalty","customer-retention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13C18 16.3137 15.3137 19 12 19C8.68629 19 6 16.3137 6 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 13L19 15M6 13L5 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hook-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hook","anchor","attachment","secure","hold","connection","loyalty","rewards","membership","stable","fixed","relation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 9.86384 14.7252 11.4299 13 11.874V13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H13V17.9C15.2757 17.438 16.9901 15.4305 17 13.0208C16.9989 12.9676 17.0021 12.9147 17.0094 12.8625C17.0279 12.7277 17.0733 12.6015 17.14 12.4894C17.2169 12.3596 17.3239 12.2459 17.4571 12.1601C17.5469 12.1019 17.6466 12.0578 17.7531 12.0307C17.8797 11.9983 18.0091 11.9918 18.1344 12.009C18.4106 12.0467 18.667 12.1991 18.8297 12.4417C18.8577 12.4832 18.8827 12.527 18.9043 12.5726L19.8944 14.5528C20.1414 15.0467 19.9412 15.6474 19.4472 15.8944C19.1023 16.0668 18.7054 16.0213 18.4132 15.81C17.3307 18.2769 14.8666 20 12 20C9.1334 20 6.66925 18.2769 5.58681 15.8099C5.29458 16.0213 4.89767 16.0669 4.55276 15.8944C4.05878 15.6474 3.85856 15.0467 4.10555 14.5528L5.0966 12.5707C5.18213 12.391 5.31965 12.2409 5.4897 12.1398C5.60168 12.0732 5.72776 12.0279 5.86239 12.0094C5.98645 11.992 6.11459 11.9978 6.24012 12.029C6.49575 12.092 6.71269 12.2533 6.84852 12.4706C6.92537 12.5935 6.97626 12.7343 6.9935 12.8853C6.99862 12.9294 7.00084 12.9739 7.00003 13.0186C7.00882 15.4293 8.72362 17.4379 11 17.9V15H10C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13H11V11.874C9.27477 11.4299 8 9.86384 8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    hook: {
        defaultColors: ["#3D4C66"],
        keywords: ["hook","anchor","attachment","secure","hold","connection","loyalty","rewards","membership","stable","fixed","relation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15L6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 19V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hospital-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hospital","pharmacy","medical","health","plus","add","building","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20V19C10 17.8954 10.8954 17 12 17V17C13.1046 17 14 17.8954 14 19V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14L6 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hospital-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hospital","clinic","pharmacy","medical","health","prescription","dispensary","medicine","first-aid","emergency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 20H10V19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19V20Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM4 20.75H10V19.25H4V20.75ZM10 20.75H14V19.25H10V20.75ZM14 20.75H20V19.25H14V20.75ZM10.75 20V19H9.25V20H10.75ZM13.25 19V20H14.75V19H13.25ZM12 17.75C12.6904 17.75 13.25 18.3096 13.25 19H14.75C14.75 17.4812 13.5188 16.25 12 16.25V17.75ZM10.75 19C10.75 18.3096 11.3096 17.75 12 17.75V16.25C10.4812 16.25 9.25 17.4812 9.25 19H10.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18 14L6 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hospital-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hospital","medical","clinic","healthcare","pharmacy","medicine","first-aid","treatment","doctor","health","plus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417V13H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H13V6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V7H10C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9H11V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 14.5L5 19H4C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H9V19C9 17.3431 10.3431 16 12 16C13.6569 16 15 17.3431 15 19V21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H19V14.5H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hospital-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["hospital","pharmacy","medical","health","clinic","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hospital-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hospital","medical","pharmacy","health","clinic","medicine","prescription","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20V18C10 16.8954 10.8954 16 12 16V16C13.1046 16 14 16.8954 14 18V20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "hospital-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hospital","medical","health","pharmacy","medicine","clinic","dispensary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.4142 4.58579L16.8839 5.11612L16.8839 5.11612L17.4142 4.58579ZM6.58579 4.58579L7.11612 5.11612L6.58579 4.58579ZM4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM5.25 8V20H6.75V8H5.25ZM18.75 20V8H17.25V20H18.75ZM10 4.75H14V3.25H10V4.75ZM18.75 8C18.75 7.07839 18.7516 6.31174 18.6701 5.70552C18.5857 5.07773 18.4 4.51093 17.9445 4.05546L16.8839 5.11612C17.0142 5.24643 17.1214 5.44393 17.1835 5.90539C17.2484 6.38843 17.25 7.03599 17.25 8H18.75ZM14 4.75C14.964 4.75 15.6116 4.75159 16.0946 4.81654C16.5561 4.87858 16.7536 4.9858 16.8839 5.11612L17.9445 4.05546C17.4891 3.59999 16.9223 3.41432 16.2945 3.32991C15.6883 3.24841 14.9216 3.25 14 3.25V4.75ZM6.75 8C6.75 7.03599 6.75159 6.38843 6.81654 5.90539C6.87858 5.44393 6.9858 5.24643 7.11612 5.11612L6.05546 4.05546C5.59999 4.51093 5.41432 5.07773 5.32991 5.70552C5.24841 6.31174 5.25 7.07839 5.25 8H6.75ZM10 3.25C9.07839 3.25 8.31174 3.24841 7.70552 3.32991C7.07773 3.41432 6.51093 3.59999 6.05546 4.05546L7.11612 5.11612C7.24643 4.9858 7.44393 4.87858 7.90539 4.81654C8.38843 4.75159 9.03599 4.75 10 4.75V3.25ZM4 20.75H6V19.25H4V20.75ZM6 20.75H18V19.25H6V20.75ZM18 20.75H20V19.25H18V20.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 20H10V18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18V20Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75V19.25ZM20 20.75C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25V20.75ZM4 20.75H10V19.25H4V20.75ZM10 20.75H14V19.25H10V20.75ZM14 20.75H20V19.25H14V20.75ZM10.75 20V18H9.25V20H10.75ZM13.25 18V20H14.75V18H13.25ZM12 16.75C12.6904 16.75 13.25 17.3096 13.25 18H14.75C14.75 16.4812 13.5188 15.25 12 15.25V16.75ZM10.75 18C10.75 17.3096 11.3096 16.75 12 16.75V15.25C10.4812 15.25 9.25 16.4812 9.25 18H10.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hospital-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["hospital","pharmacy","medical","health","first-aid","clinic","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 3.08215C8.28387 2.99991 9.04768 2.99995 9.93417 3H14.0658C14.9523 2.99995 15.7161 2.99991 16.3278 3.08215C16.9833 3.17028 17.6117 3.36902 18.1213 3.87868C18.631 4.38835 18.8297 5.0167 18.9179 5.67221C19.0001 6.28387 19.0001 7.04769 19 7.93417L19 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21L15 21V18C15 16.3431 13.6569 15 12 15C10.3431 15 9 16.3431 9 18V21L4 21C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19H5L5 7.93417C4.99995 7.04769 4.9999 6.28387 5.08214 5.67221C5.17027 5.0167 5.36902 4.38835 5.87868 3.87868C6.38834 3.36902 7.01669 3.17028 7.67221 3.08215ZM12 12C11.4477 12 11 11.5523 11 11V10H10C9.44772 10 9 9.55228 9 9C9 8.44772 9.44772 8 10 8H11V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V8H14C14.5523 8 15 8.44772 15 9C15 9.55228 14.5523 10 14 10H13V11C13 11.5523 12.5523 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    hospital: {
        defaultColors: ["#3D4C66"],
        keywords: ["hospital","pharmacy","medical","health","first-aid","clinic","healthcare"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 20V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 20H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20V19C10 17.8954 10.8954 17 12 17V17C13.1046 17 14 17.8954 14 19V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14L6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7L12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hosptial-symbol-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["add","plus","supplement","health","aid","medical","pharmacy","increase","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9L9 8C9 7.06812 9 6.60218 9.15224 6.23463C9.35523 5.74458 9.74458 5.35523 10.2346 5.15224C10.6022 5 11.0681 5 12 5V5C12.9319 5 13.3978 5 13.7654 5.15224C14.2554 5.35523 14.6448 5.74458 14.8478 6.23463C15 6.60218 15 7.06812 15 8L15 9M9 15L9 16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19V19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16L15 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9L16 9C16.9319 9 17.3978 9 17.7654 9.15224C18.2554 9.35523 18.6448 9.74458 18.8478 10.2346C19 10.6022 19 11.0681 19 12V12C19 12.9319 19 13.3978 18.8478 13.7654C18.6448 14.2554 18.2554 14.6448 17.7654 14.8478C17.3978 15 16.9319 15 16 15L15 15M9 9L8 9C7.06812 9 6.60217 9 6.23463 9.15224C5.74458 9.35523 5.35523 9.74458 5.15224 10.2346C5 10.6022 5 11.0681 5 12V12C5 12.9319 5 13.3978 5.15224 13.7654C5.35523 14.2554 5.74458 14.6448 6.23463 14.8478C6.60218 15 7.06812 15 8 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hosptial-symbol-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["plus","add","increase","create","new","positive","health","supplement","medicine","hospital"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8478 13.7656C19 13.398 19 12.9321 19 12.0002C19 11.0683 19 10.6024 18.8478 10.2349C18.6448 9.7448 18.2554 9.35545 17.7654 9.15246C17.3978 9.00022 16.9319 9.00022 16 9.00022C15.4477 9.00022 15.0001 8.55225 15.0002 8V7.99998C15.0002 7.06811 15.0002 6.60217 14.8479 6.23463C14.645 5.74458 14.2556 5.35523 13.7656 5.15224C13.398 5 12.9321 5 12.0002 5C11.0683 5 10.6024 5 10.2348 5.15224C9.74476 5.35523 9.35542 5.74458 9.15243 6.23463C9.00019 6.60217 9.00019 7.06812 9.00019 8C9.00008 8.55231 8.55231 9.00022 8 9.00022C7.06812 9.00022 6.60218 9.00022 6.23463 9.15246C5.74458 9.35545 5.35523 9.7448 5.15224 10.2349C5 10.6024 5 11.0683 5 12.0002C5 12.9321 5 13.398 5.15224 13.7656C5.35523 14.2556 5.74458 14.645 6.23463 14.848C6.60217 15.0002 7.06812 15.0002 8 15.0002C8.55219 15.0002 9.00008 15.4478 9.00019 16C9.00019 16.9319 9.00019 17.3978 9.15243 17.7654C9.35542 18.2554 9.74476 18.6448 10.2348 18.8478C10.6024 19 11.0683 19 12.0002 19C12.9321 19 13.398 19 13.7656 18.8478C14.2556 18.6448 14.645 18.2554 14.8479 17.7654C15.0002 17.3978 15.0002 16.9319 15.0002 16C15.0001 15.4479 15.4479 15.0002 16 15.0002C16.9319 15.0002 17.3978 15.0002 17.7654 14.848C18.2554 14.645 18.6448 14.2556 18.8478 13.7656Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hosptial-symbol-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["plus","add","create","new","health","medical","hospital","pharmacy","medicine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0002 4C12.4388 3.99999 12.8493 3.99998 13.1626 4.02135C13.4924 4.04385 13.8223 4.09336 14.1482 4.22836C14.8833 4.53284 15.4673 5.11687 15.7718 5.85195C15.9068 6.17788 15.9563 6.50779 15.9788 6.83761C16.0002 7.15087 16.0002 7.56158 16.0002 8.00022C16.4388 8.00021 16.8491 8.0002 17.1624 8.02157C17.4922 8.04407 17.8221 8.09358 18.1481 8.22858C18.8831 8.53306 19.4672 9.11709 19.7716 9.85217C19.9066 10.1781 19.9561 10.508 19.9787 10.8378C20 11.1511 20 11.5616 20 12.0002C20 12.4389 20 12.8493 19.9787 13.1626C19.9561 13.4924 19.9066 13.8223 19.7716 14.1483C19.4672 14.8834 18.8831 15.4674 18.1481 15.7719C17.8221 15.9069 17.4922 15.9564 17.1624 15.9789C16.8491 16.0002 16.4388 16.0002 16.0002 16.0002C16.0002 16.4389 16.0002 16.8491 15.9788 17.1624C15.9563 17.4922 15.9068 17.8221 15.7718 18.1481C15.4673 18.8831 14.8833 19.4672 14.1482 19.7716C13.8223 19.9066 13.4924 19.9561 13.1626 19.9787C12.8493 20 12.4388 20 12.0002 20C11.5615 20 11.1511 20 10.8378 19.9787C10.508 19.9561 10.1781 19.9066 9.85214 19.7716C9.11705 19.4672 8.53303 18.8831 8.22855 18.1481C8.09355 17.8221 8.04404 17.4922 8.02154 17.1624C8.00016 16.8491 8.00018 16.4388 8.00019 16.0002H7.99821C7.56031 16.0002 7.15041 16.0002 6.83762 15.9789C6.50779 15.9564 6.17788 15.9069 5.85195 15.7719C5.11687 15.4674 4.53284 14.8834 4.22836 14.1483C4.09336 13.8223 4.04386 13.4924 4.02135 13.1626C3.99998 12.8493 3.99999 12.4389 4 12.0002C3.99999 11.5616 3.99998 11.1511 4.02135 10.8378C4.04386 10.508 4.09336 10.1781 4.22836 9.85217C4.53284 9.11709 5.11687 8.53306 5.85195 8.22858C6.17788 8.09358 6.50779 8.04407 6.83762 8.02157C7.15088 8.0002 7.56135 8.00021 8 8.00022C7.99999 7.56157 8.00016 7.15088 8.02154 6.83762C8.04404 6.50779 8.09355 6.17788 8.22855 5.85195C8.53303 5.11687 9.11705 4.53284 9.85214 4.22836C10.1781 4.09336 10.508 4.04385 10.8378 4.02135C11.1511 3.99998 11.5615 3.99999 12.0002 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hosptial-symbol": {
        defaultColors: ["#3D4C66"],
        keywords: ["plus","add","addition","new","create","increase","expand","positive","sum","total"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 9L16 9C16.9319 9 17.3978 9 17.7654 9.15224C18.2554 9.35523 18.6448 9.74458 18.8478 10.2346C19 10.6022 19 11.0681 19 12V12C19 12.9319 19 13.3978 18.8478 13.7654C18.6448 14.2554 18.2554 14.6448 17.7654 14.8478C17.3978 15 16.9319 15 16 15L15 15M9 9L8 9C7.06812 9 6.60217 9 6.23463 9.15224C5.74458 9.35523 5.35523 9.74458 5.15224 10.2346C5 10.6022 5 11.0681 5 12V12C5 12.9319 5 13.3978 5.15224 13.7654C5.35523 14.2554 5.74458 14.6448 6.23463 14.8478C6.60218 15 7.06812 15 8 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L9 8C9 7.06812 9 6.60218 9.15224 6.23463C9.35523 5.74458 9.74458 5.35523 10.2346 5.15224C10.6022 5 11.0681 5 12 5V5C12.9319 5 13.3978 5 13.7654 5.15224C14.2554 5.35523 14.6448 5.74458 14.8478 6.23463C15 6.60218 15 7.06812 15 8L15 9M9 15L9 16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19V19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","order-pending","wait-time","payment-pending","transaction-pending","countdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 7.24945C16 8.26919 16 8.77906 15.8553 9.22786C15.688 9.74719 15.3821 10.211 14.9707 10.5695C14.6152 10.8792 14.1465 11.0801 13.2092 11.4818V11.4818C12.7951 11.6593 12.588 11.748 12.3744 11.7887C12.127 11.8359 11.873 11.8359 11.6256 11.7887C11.412 11.748 11.2049 11.6593 10.7908 11.4818V11.4818C9.85348 11.0801 9.38483 10.8792 9.02931 10.5695C8.6179 10.211 8.31205 9.74719 8.14466 9.22786C8 8.77906 8 8.26919 8 7.24945L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18V16.7506C8 15.7308 8 15.2209 8.14466 14.7721C8.31205 14.2528 8.6179 13.789 9.02931 13.4305C9.38483 13.1208 9.85348 12.9199 10.7908 12.5182V12.5182C11.2049 12.3407 11.412 12.252 11.6256 12.2113C11.873 12.1641 12.127 12.1641 12.3744 12.2113C12.588 12.252 12.7951 12.3407 13.2092 12.5182V12.5182C14.1465 12.9199 14.6152 13.1208 14.9707 13.4305C15.3821 13.789 15.688 14.2528 15.8553 14.7721C16 15.2209 16 15.7308 16 16.7506V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","order-pending","transaction-pending","busy","timeout","queue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 7.24945C16 8.26919 16 8.77906 15.8553 9.22786C15.688 9.74719 15.3821 10.211 14.9707 10.5695C14.6152 10.8792 14.1465 11.0801 13.2092 11.4818V11.4818C12.7951 11.6593 12.588 11.748 12.3744 11.7887C12.127 11.8359 11.873 11.8359 11.6256 11.7887C11.412 11.748 11.2049 11.6593 10.7908 11.4818V11.4818C9.85348 11.0801 9.38483 10.8792 9.02931 10.5695C8.6179 10.211 8.31205 9.74719 8.14466 9.22786C8 8.77906 8 8.26919 8 7.24945L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18V16.7506C8 15.7308 8 15.2209 8.14466 14.7721C8.31205 14.2528 8.6179 13.789 9.02931 13.4305C9.38483 13.1208 9.85348 12.9199 10.7908 12.5182V12.5182C11.2049 12.3407 11.412 12.252 11.6256 12.2113C11.873 12.1641 12.127 12.1641 12.3744 12.2113C12.588 12.252 12.7951 12.3407 13.2092 12.5182V12.5182C14.1465 12.9199 14.6152 13.1208 14.9707 13.4305C15.3821 13.789 15.688 14.2528 15.8553 14.7721C16 15.2209 16 15.7308 16 16.7506V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","timer","order-processing","transaction-pending","clock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7H17L17.0001 7.39453C17.0006 8.27241 17.001 8.93301 16.8071 9.53463C16.5839 10.2271 16.1761 10.8455 15.6276 11.3234C15.319 11.5923 14.9555 11.796 14.5185 12C14.9555 12.204 15.319 12.4077 15.6276 12.6766C16.1761 13.1545 16.5839 13.7729 16.8071 14.4654C17.001 15.067 17.0006 15.7276 17.0001 16.6055L17 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H7L6.99994 16.6055C6.99938 15.7276 6.99896 15.067 7.19287 14.4654C7.41606 13.7729 7.82387 13.1545 8.37241 12.6766C8.68102 12.4077 9.04446 12.204 9.48147 12C9.04446 11.796 8.68102 11.5923 8.37241 11.3234C7.82387 10.8455 7.41606 10.2271 7.19288 9.53463C6.99896 8.93301 6.99938 8.27241 6.99994 7.39452L7 7H6C5.44772 7 5 6.55228 5 6ZM9 17H15V16.7505C15 15.6621 14.9884 15.3422 14.9036 15.0789C14.792 14.7327 14.5881 14.4235 14.3138 14.1845C14.1052 14.0028 13.8158 13.8662 12.8153 13.4374C12.3609 13.2426 12.2691 13.2092 12.1872 13.1936C12.0635 13.17 11.9365 13.17 11.8128 13.1936C11.7309 13.2092 11.6391 13.2426 11.1847 13.4374C10.1842 13.8662 9.89476 14.0028 9.6862 14.1845C9.41193 14.4235 9.20803 14.7327 9.09643 15.0789C9.01158 15.3422 9 15.6621 9 16.7505V17ZM9 7H15V7.24945C15 8.33794 14.9884 8.6578 14.9036 8.92108C14.792 9.2673 14.5881 9.57653 14.3138 9.81549C14.1052 9.99719 13.8158 10.1338 12.8153 10.5626C12.3609 10.7574 12.2691 10.7908 12.1872 10.8064C12.0635 10.83 11.9365 10.83 11.8128 10.8064C11.7309 10.7908 11.6391 10.7574 11.1847 10.5626C10.1842 10.1338 9.89477 9.9972 9.68621 9.81549C9.41194 9.57653 9.20803 9.2673 9.09644 8.92108C9.01158 8.6578 9 8.33794 9 7.24945V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","loading","processing","order-pending","transaction-pending","clock","delay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 7.24945C16 8.26919 16 8.77906 15.8553 9.22786C15.688 9.74719 15.3821 10.211 14.9707 10.5695C14.6152 10.8792 14.1465 11.0801 13.2092 11.4818V11.4818C12.7951 11.6593 12.588 11.748 12.3744 11.7887C12.127 11.8359 11.873 11.8359 11.6256 11.7887C11.412 11.748 11.2049 11.6593 10.7908 11.4818V11.4818C9.85348 11.0801 9.38483 10.8792 9.02931 10.5695C8.6179 10.211 8.31205 9.74719 8.14466 9.22786C8 8.77906 8 8.26919 8 7.24945L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18V16.7506C8 15.7308 8 15.2209 8.14466 14.7721C8.31205 14.2528 8.6179 13.789 9.02931 13.4305C9.38483 13.1208 9.85348 12.9199 10.7908 12.5182V12.5182C11.2049 12.3407 11.412 12.252 11.6256 12.2113C11.873 12.1641 12.127 12.1641 12.3744 12.2113C12.588 12.252 12.7951 12.3407 13.2092 12.5182V12.5182C14.1465 12.9199 14.6152 13.1208 14.9707 13.4305C15.3821 13.789 15.688 14.2528 15.8553 14.7721C16 15.2209 16 15.7308 16 16.7506V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hourglass","time","wait","pending","processing","loading","delay","transaction-pending","order-pending","timer","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 9.42525C16 9.69708 16 9.833 15.968 9.95651C15.9221 10.1331 15.8289 10.2938 15.6983 10.4212C15.6069 10.5103 15.4889 10.5778 15.2529 10.7126V10.7126C14.6138 11.0779 14.2942 11.2605 14.1599 11.4825C13.9674 11.8006 13.9674 12.1994 14.1599 12.5175C14.2942 12.7395 14.6138 12.9221 15.2529 13.2874V13.2874C15.4889 13.4222 15.6069 13.4897 15.6983 13.5788C15.8289 13.7062 15.9221 13.8669 15.968 14.0435C16 14.167 16 14.3029 16 14.5748V18M8 6L8 9.42525C8 9.69708 8 9.833 8.03204 9.95651C8.07786 10.1331 8.17112 10.2938 8.30173 10.4212C8.39307 10.5103 8.51108 10.5778 8.74709 10.7126V10.7126C9.38625 11.0779 9.70582 11.2605 9.84009 11.4825C10.0326 11.8006 10.0326 12.1994 9.84009 12.5175C9.70582 12.7395 9.38625 12.9221 8.74709 13.2874V13.2874C8.51108 13.4222 8.39307 13.4897 8.30173 13.5788C8.17112 13.7062 8.07786 13.8669 8.03204 14.0435C8 14.167 8 14.3029 8 14.5748V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","timeout","order-processing","payment-pending","transaction-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7H17L17 9.42525L17.0001 9.48256C17.0007 9.6922 17.0015 9.95487 16.9359 10.2076C16.8443 10.5608 16.6578 10.8823 16.3965 11.1371C16.2096 11.3194 15.9812 11.449 15.7989 11.5525L15.749 11.5809C15.4158 11.7713 15.2146 11.887 15.0761 11.9804C15.0727 11.9827 15.0694 11.9849 15.0662 11.9871C15.0596 11.9916 15.0534 11.9959 15.0476 12C15.0562 12.006 15.0657 12.0126 15.0761 12.0196C15.2146 12.113 15.4158 12.2287 15.749 12.4191L15.7989 12.4475C15.9812 12.551 16.2096 12.6806 16.3965 12.8629C16.6578 13.1177 16.8443 13.4392 16.9359 13.7924C17.0015 14.0451 17.0007 14.3078 17.0001 14.5174L17 14.5748V17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H7V14.5748L6.99988 14.5174C6.99928 14.3078 6.99851 14.0451 7.06408 13.7924C7.15572 13.4392 7.34224 13.1177 7.60345 12.8629C7.79037 12.6806 8.0188 12.551 8.20112 12.4475L8.25095 12.4191C8.58423 12.2287 8.78538 12.113 8.92387 12.0196C8.9343 12.0126 8.94379 12.006 8.9524 12C8.94379 11.994 8.9343 11.9874 8.92387 11.9804C8.78538 11.887 8.58423 11.7713 8.25095 11.5809L8.20113 11.5525C8.01881 11.449 7.79037 11.3194 7.60345 11.1371C7.34224 10.8823 7.15572 10.5608 7.06408 10.2076C6.99851 9.95488 6.99928 9.6922 6.99988 9.48257L7 9.42525L7 7H6C5.44772 7 5 6.55228 5 6ZM9 17H15V14.5748C15 14.4296 14.9997 14.3554 14.9971 14.3015L14.9969 14.2964L14.9926 14.2937C14.9471 14.2647 14.8828 14.2276 14.7568 14.1556L14.7273 14.1388C14.4331 13.9707 14.1657 13.8179 13.958 13.6779C13.7485 13.5366 13.4866 13.3365 13.3043 13.0351C12.9193 12.3987 12.9193 11.6013 13.3043 10.9649C13.4866 10.6635 13.7485 10.4634 13.958 10.3221C14.1658 10.182 14.4331 10.0293 14.7273 9.86119L14.7568 9.84438C14.8828 9.77236 14.9471 9.73532 14.9926 9.70632L14.9969 9.70359L14.9971 9.69853C14.9997 9.64461 15 9.57041 15 9.42525L15 7H9L9 9.42525C9 9.57041 9.00026 9.64461 9.00285 9.69853L9.00311 9.70359L9.00738 9.70632C9.05291 9.73532 9.11719 9.77236 9.24323 9.84438L9.27262 9.86117C9.56691 10.0293 9.83421 10.182 10.042 10.3221C10.2515 10.4634 10.5134 10.6635 10.6957 10.9649C11.0807 11.6013 11.0807 12.3987 10.6957 13.0351C10.5134 13.3365 10.2515 13.5366 10.042 13.6779C9.83425 13.8179 9.567 13.9706 9.27276 14.1387L9.24323 14.1556C9.11719 14.2276 9.05291 14.2647 9.00738 14.2937L9.00311 14.2964L9.00285 14.3015C9.00026 14.3554 9 14.4296 9 14.5748V17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hourglass","time","waiting","pending","processing","duration","late","delay","transaction-pending","order-pending","payment-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 9.42525C16 9.69708 16 9.833 15.968 9.95651C15.9221 10.1331 15.8289 10.2938 15.6983 10.4212C15.6069 10.5103 15.4889 10.5778 15.2529 10.7126V10.7126C14.6138 11.0779 14.2942 11.2605 14.1599 11.4825C13.9674 11.8006 13.9674 12.1994 14.1599 12.5175C14.2942 12.7395 14.6138 12.9221 15.2529 13.2874V13.2874C15.4889 13.4222 15.6069 13.4897 15.6983 13.5788C15.8289 13.7062 15.9221 13.8669 15.968 14.0435C16 14.167 16 14.3029 16 14.5748V18M8 6L8 9.42525C8 9.69708 8 9.833 8.03204 9.95651C8.07786 10.1331 8.17112 10.2938 8.30173 10.4212C8.39307 10.5103 8.51108 10.5778 8.74709 10.7126V10.7126C9.38625 11.0779 9.70582 11.2605 9.84009 11.4825C10.0326 11.8006 10.0326 12.1994 9.84009 12.5175C9.70582 12.7395 9.38625 12.9221 8.74709 13.2874V13.2874C8.51108 13.4222 8.39307 13.4897 8.30173 13.5788C8.17112 13.7062 8.07786 13.8669 8.03204 14.0435C8 14.167 8 14.3029 8 14.5748V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","transaction-pending","order-pending","timer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6L16 9.42525C16 9.69708 16 9.833 15.968 9.95651C15.9221 10.1331 15.8289 10.2938 15.6983 10.4212C15.6069 10.5103 15.4889 10.5778 15.2529 10.7126V10.7126C14.6138 11.0779 14.2942 11.2605 14.1599 11.4825C13.9674 11.8006 13.9674 12.1994 14.1599 12.5175C14.2942 12.7395 14.6138 12.9221 15.2529 13.2874V13.2874C15.4889 13.4222 15.6069 13.4897 15.6983 13.5788C15.8289 13.7062 15.9221 13.8669 15.968 14.0435C16 14.167 16 14.3029 16 14.5748V18M8 6L8 9.42525C8 9.69708 8 9.833 8.03204 9.95651C8.07786 10.1331 8.17112 10.2938 8.30173 10.4212C8.39307 10.5103 8.51108 10.5778 8.74709 10.7126V10.7126C9.38625 11.0779 9.70582 11.2605 9.84009 11.4825C10.0326 11.8006 10.0326 12.1994 9.84009 12.5175C9.70582 12.7395 9.38625 12.9221 8.74709 13.2874V13.2874C8.51108 13.4222 8.39307 13.4897 8.30173 13.5788C8.17112 13.7062 8.07786 13.8669 8.03204 14.0435C8 14.167 8 14.3029 8 14.5748V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","loading","duration","timer","out-of-stock","unavailable","backorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9C10 9.37378 10.4041 9.80671 10.9656 9.88001L11.5329 9.96518C11.6872 9.98835 11.8435 10 12 10C12.1565 10 12.3128 9.98835 12.4671 9.96518L13.0344 9.88001C13.5959 9.80671 14 9.37378 14 9M14 15C14 14.6262 13.5959 14.1933 13.0344 14.12L12.4671 14.0348C12.3128 14.0116 12.1565 14 12 14C11.8435 14 11.6872 14.0116 11.5329 14.0348L10.9656 14.12C10.4041 14.1933 10 14.6262 10 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 20L7.00874 14.9366C7.00874 13.657 8.01811 12.5553 9.42039 12.3043L11.4165 12.0007M11.4165 12.0007L9.42039 11.59C8.01812 11.339 7.00874 10.2373 7.00874 8.9577L7.00874 4M11.4165 12.0007H12.5871M17.0011 20L16.9924 14.9366C16.9924 13.657 15.9836 12.5553 14.5821 12.3043L12.5871 12.0007M12.5871 12.0007L14.5821 11.59C15.9836 11.339 16.9924 10.2373 16.9924 8.9577L16.9924 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5.00874 3.25C4.59452 3.25 4.25874 3.58579 4.25874 4C4.25874 4.41421 4.59452 4.75 5.00874 4.75V3.25ZM5 19.25C4.58579 19.25 4.25 19.5858 4.25 20C4.25 20.4142 4.58579 20.75 5 20.75V19.25ZM18.9913 4.75C19.4055 4.75 19.7413 4.41421 19.7413 4C19.7413 3.58579 19.4055 3.25 18.9913 3.25V4.75ZM19 20.75C19.4142 20.75 19.75 20.4142 19.75 20C19.75 19.5858 19.4142 19.25 19 19.25V20.75ZM5.00874 4.75H7.00874V3.25H5.00874V4.75ZM7.00874 4.75H12.0087V3.25H7.00874V4.75ZM12 19.25H7V20.75H12V19.25ZM7 19.25H5V20.75H7V19.25ZM5.00874 4.75H7.00762V3.25H5.00874V4.75ZM12 19.25H6.99888V20.75H12V19.25ZM6.99888 19.25H5V20.75H6.99888V19.25ZM18.9913 3.25H16.9924V4.75H18.9913V3.25ZM12 20.75H17.0011V19.25H12V20.75ZM17.0011 20.75H19V19.25H17.0011V20.75ZM7.00762 4.75H16.9924V3.25H7.00762V4.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
            </svg>
        )
    },
    "hourglass 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hourglass","time","pending","waiting","processing","duration","timer","loading","delay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9C10 9.37378 10.4041 9.80671 10.9656 9.88001L11.5329 9.96518C11.6872 9.98835 11.8435 10 12 10C12.1565 10 12.3128 9.98835 12.4671 9.96518L13.0344 9.88001C13.5959 9.80671 14 9.37378 14 9M14 15C14 14.6262 13.5959 14.1933 13.0344 14.12L12.4671 14.0348C12.3128 14.0116 12.1565 14 12 14C11.8435 14 11.6872 14.0116 11.5329 14.0348L10.9656 14.12C10.4041 14.1933 10 14.6262 10 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.00014 20L6.25014 19.9987L6.24884 20.75H7.00014V20ZM7.00887 14.9366L7.75887 14.9379V14.9366H7.00887ZM9.42052 12.3043L9.30775 11.5629L9.29805 11.5643L9.2884 11.5661L9.42052 12.3043ZM7.00888 8.9577H7.75888H7.00888ZM7.00888 4V3.25H6.25888L6.25888 4L7.00888 4ZM9.42053 11.59L9.5717 10.8553L9.5622 10.8534L9.55265 10.8517L9.42053 11.59ZM6.99902 19.25C6.58481 19.25 6.24902 19.5858 6.24902 20C6.24902 20.4142 6.58481 20.75 6.99902 20.75V19.25ZM7.00776 3.25C6.59354 3.25 6.25776 3.58579 6.25776 4C6.25776 4.41421 6.59354 4.75 7.00776 4.75V3.25ZM17.0013 20V20.75H17.7526L17.7513 19.9987L17.0013 20ZM16.9925 14.9366H16.2425L16.2425 14.9379L16.9925 14.9366ZM14.5822 12.3043L14.7144 11.5661L14.7048 11.5643L14.6951 11.5629L14.5822 12.3043ZM16.9925 8.9577L16.2425 8.95769V8.9577H16.9925ZM16.9925 4L17.7425 4V3.25H16.9925V4ZM14.5822 11.59L14.45 10.8517L14.4405 10.8534L14.431 10.8554L14.5822 11.59ZM7.75014 20.0013L7.75887 14.9379L6.25888 14.9353L6.25014 19.9987L7.75014 20.0013ZM9.5333 13.0458L11.5294 12.7422L11.3038 11.2593L9.30775 11.5629L9.5333 13.0458ZM7.75887 14.9366C7.75887 14.0771 8.44887 13.2401 9.55264 13.0426L9.2884 11.5661C7.58763 11.8704 6.25887 13.2369 6.25887 14.9366H7.75887ZM7.75888 8.9577L7.75888 4L6.25888 4L6.25888 8.9577H7.75888ZM11.5678 11.2661L9.5717 10.8553L9.26935 12.3246L11.2654 12.7353L11.5678 11.2661ZM6.25888 8.9577C6.25888 10.6574 7.58764 12.0239 9.28841 12.3282L9.55265 10.8517C8.44887 10.6542 7.75888 9.81717 7.75888 8.9577H6.25888ZM7.00888 4.75H12.0089V3.25H7.00888V4.75ZM12.0001 19.25H7.00014V20.75H12.0001V19.25ZM12.0001 19.25H6.99902V20.75H12.0001V19.25ZM17.7513 19.9987L17.7425 14.9353L16.2425 14.9379L16.2513 20.0013L17.7513 19.9987ZM14.6951 11.5629L12.7001 11.2593L12.4744 12.7422L14.4694 13.0458L14.6951 11.5629ZM17.7425 14.9366C17.7425 13.2372 16.4147 11.8705 14.7144 11.5661L14.45 13.0426C15.5527 13.24 16.2425 14.0768 16.2425 14.9366H17.7425ZM17.7425 8.9577L17.7425 4L16.2425 4L16.2425 8.95769L17.7425 8.9577ZM12.7385 12.7353L14.7335 12.3245L14.431 10.8554L12.436 11.2661L12.7385 12.7353ZM16.2425 8.9577C16.2425 9.81748 15.5527 10.6542 14.45 10.8517L14.7144 12.3282C16.4147 12.0238 17.7425 10.6571 17.7425 8.9577H16.2425ZM12.0001 20.75H17.0013V19.25H12.0001V20.75ZM7.00776 4.75H16.9925V3.25H7.00776V4.75ZM11.4166 12.7507H12.5872V11.2507H11.4166V12.7507Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M19 4H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 20H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","timeout","clock","timer","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00914 3C4.45686 3 4.00914 3.44772 4.00914 4C4.00914 4.55228 4.45686 5 5.00914 5H6.00914L6.00914 8.9577C6.00914 10.2444 6.71114 11.3427 7.74904 11.997C6.70556 12.6506 5.99913 13.7521 5.99913 15.043L5.99888 19H5C4.44771 19 4 19.4477 4 20C4 20.5523 4.44771 21 5 21L19 21C19.5523 21 20 20.5523 20 20C20 19.4477 19.5523 19 19 19H17.9825L17.9828 15.043C17.9828 13.7564 17.2808 12.658 16.2429 12.0037C17.2864 11.3502 17.9928 10.2486 17.9928 8.9577L17.9928 5H19C19.5523 5 20 4.55228 20 4C20 3.44772 19.5523 3 19 3H5.00914ZM10.9891 7.85001C10.9167 7.36888 10.5016 7 10.0002 7C9.44796 7 9.00024 7.44772 9.00024 8C9.00024 8.53555 9.27522 8.98197 9.58052 9.2746C9.89824 9.57915 10.3309 9.80315 10.8255 9.87015L11.3847 9.9541C11.5883 9.98467 11.7942 10 12.0002 10C12.2063 10 12.4122 9.98467 12.6158 9.9541L13.175 9.87015C13.6696 9.80315 14.1022 9.57915 14.42 9.2746C14.7253 8.98196 15.0002 8.53555 15.0002 8C15.0002 7.44772 14.5525 7 14.0002 7C13.4989 7 13.0838 7.36888 13.0114 7.85001C12.9862 7.86654 12.9499 7.8826 12.9052 7.88843L12.8957 7.88967L12.3189 7.97626C12.2138 7.99204 12.1072 8 12.0002 8C11.8933 8 11.7867 7.99204 11.6816 7.97626L11.1048 7.88967L11.0953 7.88843C11.0506 7.88259 11.0143 7.86654 10.9891 7.85001ZM11.6816 16.0237C11.7867 16.008 11.8933 16 12.0002 16C12.1072 16 12.2138 16.008 12.3189 16.0237L12.8957 16.1103L12.9052 16.1116C12.9499 16.1174 12.9862 16.1335 13.0114 16.15C13.0838 16.6311 13.4989 17 14.0002 17C14.5525 17 15.0002 16.5523 15.0002 16C15.0002 15.4645 14.7253 15.018 14.42 14.7254C14.1022 14.4208 13.6696 14.1968 13.175 14.1299L12.6158 14.0459C12.4122 14.0153 12.2063 14 12.0002 14C11.7942 14 11.5883 14.0153 11.3847 14.0459L10.8255 14.1299C10.3309 14.1968 9.89825 14.4208 9.58051 14.7254C9.27522 15.018 9.00024 15.4645 9.00024 16C9.00024 16.5523 9.44796 17 10.0002 17C10.5015 17 10.9167 16.6311 10.9891 16.15C11.0143 16.1335 11.0506 16.1174 11.0953 16.1116L11.1048 16.1103L11.6816 16.0237Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","delay","processing","loading","timeout","schedule","timer","countdown","busy","duration","queue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9C10 9.37378 10.4041 9.80671 10.9656 9.88001L11.5329 9.96518C11.6872 9.98835 11.8435 10 12 10C12.1565 10 12.3128 9.98835 12.4671 9.96518L13.0344 9.88001C13.5959 9.80671 14 9.37378 14 9M14 15C14 14.6262 13.5959 14.1933 13.0344 14.12L12.4671 14.0348C12.3128 14.0116 12.1565 14 12 14C11.8435 14 11.6872 14.0116 11.5329 14.0348L10.9656 14.12C10.4041 14.1933 10 14.6262 10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.00873 14.9366L7.75873 14.9379V14.9366H7.00873ZM9.42038 12.3043L9.30761 11.5629L9.29791 11.5643L9.28826 11.5661L9.42038 12.3043ZM7.00874 8.9577H7.75874H7.00874ZM9.42039 11.59L9.57156 10.8553L9.56206 10.8534L9.55251 10.8517L9.42039 11.59ZM5.00874 3.25C4.59452 3.25 4.25874 3.58579 4.25874 4C4.25874 4.41421 4.59452 4.75 5.00874 4.75V3.25ZM5 19.25C4.58579 19.25 4.25 19.5858 4.25 20C4.25 20.4142 4.58579 20.75 5 20.75V19.25ZM16.9924 14.9366H16.2424L16.2424 14.9379L16.9924 14.9366ZM14.5821 12.3043L14.7143 11.5661L14.7046 11.5643L14.6949 11.5629L14.5821 12.3043ZM16.9924 8.9577L16.2424 8.95769V8.9577H16.9924ZM14.5821 11.59L14.4499 10.8517L14.4403 10.8534L14.4308 10.8554L14.5821 11.59ZM18.9913 4.75C19.4055 4.75 19.7413 4.41421 19.7413 4C19.7413 3.58579 19.4055 3.25 18.9913 3.25V4.75ZM19 20.75C19.4142 20.75 19.75 20.4142 19.75 20C19.75 19.5858 19.4142 19.25 19 19.25V20.75ZM7.75 20.0013L7.75873 14.9379L6.25874 14.9353L6.25 19.9987L7.75 20.0013ZM9.53316 13.0458L11.5293 12.7422L11.3037 11.2593L9.30761 11.5629L9.53316 13.0458ZM7.75873 14.9366C7.75873 14.0771 8.44873 13.2401 9.5525 13.0426L9.28826 11.5661C7.58749 11.8704 6.25873 13.2369 6.25873 14.9366H7.75873ZM7.75874 8.9577L7.75874 4L6.25874 4L6.25874 8.9577H7.75874ZM11.5677 11.2661L9.57156 10.8553L9.26921 12.3246L11.2653 12.7353L11.5677 11.2661ZM6.25874 8.9577C6.25874 10.6574 7.5875 12.0239 9.28827 12.3282L9.55251 10.8517C8.44873 10.6542 7.75874 9.81717 7.75874 8.9577H6.25874ZM5.00874 4.75H7.00874V3.25H5.00874V4.75ZM7.00874 4.75H12.0087V3.25H7.00874V4.75ZM12 19.25H7V20.75H12V19.25ZM7 19.25H5V20.75H7V19.25ZM5.00874 4.75H7.00762V3.25H5.00874V4.75ZM12 19.25H6.99888V20.75H12V19.25ZM6.99888 19.25H5V20.75H6.99888V19.25ZM17.7511 19.9987L17.7424 14.9353L16.2424 14.9379L16.2511 20.0013L17.7511 19.9987ZM14.6949 11.5629L12.6999 11.2593L12.4743 12.7422L14.4692 13.0458L14.6949 11.5629ZM17.7424 14.9366C17.7424 13.2372 16.4145 11.8705 14.7143 11.5661L14.4499 13.0426C15.5526 13.24 16.2424 14.0768 16.2424 14.9366H17.7424ZM17.7424 8.9577L17.7424 4L16.2424 4L16.2424 8.95769L17.7424 8.9577ZM12.7384 12.7353L14.7333 12.3245L14.4308 10.8554L12.4358 11.2661L12.7384 12.7353ZM16.2424 8.9577C16.2424 9.81748 15.5526 10.6542 14.4499 10.8517L14.7143 12.3282C16.4145 12.0238 17.7424 10.6571 17.7424 8.9577H16.2424ZM18.9913 3.25H16.9924V4.75H18.9913V3.25ZM12 20.75H17.0011V19.25H12V20.75ZM17.0011 20.75H19V19.25H17.0011V20.75ZM7.00762 4.75H16.9924V3.25H7.00762V4.75ZM11.4165 12.7507H12.5871V11.2507H11.4165V12.7507Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass 5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","timeout","timer","order-pending","transaction-pending","payment-processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00775 14.9366L6.99902 20H17.0013L16.9925 14.9366C16.9925 13.657 15.9837 12.5553 14.5822 12.3043L13.0001 12.0007L14.5822 11.59C15.9837 11.339 16.9925 10.2373 16.9925 8.9577L16.9925 4H7.00775L7.00776 8.9577C7.00776 10.2373 8.01657 11.339 9.41806 11.59L11.0001 12L9.41806 12.3043C8.01657 12.5553 7.00775 13.657 7.00775 14.9366Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00873 4H7.00762H16.9924H18.9913M5 20H6.99888H17.0011H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","wait-time","loading"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00775 14.9366L6.99902 20H17.0013L16.9925 14.9366C16.9925 13.657 15.9837 12.5553 14.5822 12.3043L13.0001 12.0007L14.5822 11.59C15.9837 11.339 16.9925 10.2373 16.9925 8.9577L16.9925 4H7.00775L7.00776 8.9577C7.00776 10.2373 8.01657 11.339 9.41806 11.59L11.0001 12L9.41806 12.3043C8.01657 12.5553 7.00775 13.657 7.00775 14.9366Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 20H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 4H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","duration","timer","delay","order-processing","payment-pending","transaction-pending","time-elapsed","session-timeout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00873 3C4.45645 3 4.00873 3.44772 4.00873 4C4.00873 4.55228 4.45645 5 5.00873 5H6.00772L6.00772 8.9577C6.00772 10.2449 6.71007 11.3438 7.74859 11.9981C6.70584 12.6517 6 13.7529 6 15.0433L6 19H5C4.44772 19 4 19.4477 4 20C4 20.5523 4.44772 21 5 21H6.95575C6.97046 21.0007 6.98521 21.001 7 21.001L16.9848 21.001C16.9995 21.001 17.0143 21.0007 17.029 21H19C19.5523 21 20 20.5523 20 20C20 19.4477 19.5523 19 19 19H17.9848L17.9848 15.0433C17.9848 13.7561 17.2824 12.6572 16.2439 12.0029C17.2867 11.3493 17.9925 10.2481 17.9925 8.9577L17.9925 5H19C19.5523 5 20 4.55228 20 4C20 3.44772 19.5523 3 19 3H5.00873ZM15.9925 5H8.00772L8.00772 8.95769C8.00772 9.67754 8.59116 10.426 9.59428 10.6056C9.61936 10.6101 9.64426 10.6155 9.66892 10.6219L11.251 11.032C11.6712 11.1409 11.9595 11.5014 11.9963 11.9103C12.0013 11.8571 12.0105 11.8035 12.0244 11.7501C12.1242 11.3649 12.4355 11.0905 12.8016 11.0191L14.3309 10.622C14.3557 10.6156 14.3807 10.6101 14.4059 10.6056C15.409 10.426 15.9925 9.67754 15.9925 8.95769L15.9925 5ZM15.9848 19L15.9848 15.0433C15.9848 14.3234 15.4013 13.575 14.3982 13.3954C14.3731 13.3909 14.3482 13.3854 14.3236 13.379L12.7415 12.969C12.3213 12.8601 12.033 12.4996 11.9961 12.0907C11.9912 12.1439 11.982 12.1975 11.9681 12.2509C11.8683 12.6361 11.557 12.9105 11.1909 12.9819L9.66162 13.3789C9.63682 13.3854 9.61178 13.3909 9.58656 13.3954C8.58344 13.575 8 14.3234 8 15.0433L8 19H15.9848Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","loading","order-pending","transaction-pending","wait","processing","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.99888 20L7.00761 14.9366C7.00761 13.657 8.01643 12.5553 9.41792 12.3043L11 12L9.41792 11.59C8.01643 11.339 7.00762 10.2373 7.00762 8.9577L7.00762 4M6.99888 20H5M6.99888 20H17.0011M7.00762 4H5.00873M7.00762 4H16.9924M17.0011 20L16.9924 14.9366C16.9924 13.657 15.9836 12.5553 14.5821 12.3043L13 12.0007L14.5821 11.59C15.9836 11.339 16.9924 10.2373 16.9924 8.9577L16.9924 4M17.0011 20H19M16.9924 4H18.9913"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hourglass","time","waiting","pending","delayed","processing","loading","duration","timer","clock","order-pending","payment-pending","transaction-pending","session-timeout","busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 4L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31348C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645V11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645V11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hourglass","time","wait","pending","processing","duration","delay","timeout","order-pending","payment-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 4L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31348C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645V11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645V11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","loading","history","transaction-history","order-processing","payment-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5L18 6.0338C18 6.86668 18 7.56408 17.9429 8.13901C17.8826 8.74644 17.7527 9.29922 17.4436 9.82228C17.393 9.90775 17.3394 9.99131 17.2826 10.0728C16.9354 10.5714 16.4867 10.9194 15.9594 11.2268C15.536 11.4736 15.0154 11.7197 14.4048 12C15.0154 12.2803 15.536 12.5264 15.9594 12.7732C16.4867 13.0806 16.9355 13.4286 17.2826 13.9272C17.3394 14.0087 17.393 14.0922 17.4436 14.1777C17.7527 14.7008 17.8826 15.2535 17.9429 15.861C18 16.4359 18 17.1333 18 17.9662L18 19C18.5523 19 19 19.4477 19 20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20C5 19.4477 5.44772 19 6 19L6 17.9662C5.99998 17.1333 5.99997 16.4359 6.05707 15.861C6.1174 15.2535 6.24732 14.7008 6.55645 14.1777C6.60696 14.0922 6.66064 14.0087 6.71738 13.9272C7.06456 13.4286 7.51328 13.0806 8.04065 12.7732C8.46403 12.5264 8.98464 12.2803 9.59521 12C8.98464 11.7197 8.46403 11.4736 8.04064 11.2268C7.51328 10.9194 7.06455 10.5714 6.71737 10.0728C6.66064 9.99131 6.60696 9.90775 6.55645 9.82228C6.24731 9.29922 6.1174 8.74644 6.05706 8.13901C5.99996 7.56408 5.99998 6.86667 6 6.03378L6 5C5.44772 5 5 4.55228 5 4ZM8.00001 19H16V18.0144C16 17.1208 15.9989 16.5231 15.9527 16.0587C15.9087 15.6156 15.83 15.3784 15.7218 15.1953C15.6965 15.1526 15.6697 15.1108 15.6413 15.07C15.5198 14.8955 15.3368 14.7253 14.9521 14.501C14.5489 14.266 14.0058 14.0165 13.1931 13.6449C12.3518 13.2603 12.1836 13.2038 12.028 13.1995C12.0093 13.1989 11.9907 13.1989 11.9721 13.1995C11.8165 13.2038 11.6483 13.2603 10.8069 13.6449C9.9942 14.0165 9.45112 14.266 9.04787 14.501C8.66325 14.7253 8.48021 14.8955 8.35869 15.07C8.33032 15.1108 8.30348 15.1526 8.27823 15.1953C8.17002 15.3784 8.09128 15.6156 8.04728 16.0587C8.00114 16.5231 8.00001 17.1208 8.00001 18.0144V19ZM8 5H16V5.98557C16 6.8792 15.9989 7.47686 15.9527 7.94134C15.9087 8.38436 15.83 8.62161 15.7218 8.80469C15.6965 8.84743 15.6697 8.88921 15.6413 8.92995C15.5198 9.10447 15.3368 9.27473 14.9521 9.49894C14.5489 9.73401 14.0058 9.98353 13.1931 10.3551C12.3517 10.7397 12.1836 10.7962 12.028 10.8005C12.0093 10.8011 11.9907 10.8011 11.9721 10.8005C11.8164 10.7962 11.6483 10.7397 10.8069 10.3551C9.9942 9.98353 9.45112 9.73401 9.04787 9.49894C8.66324 9.27473 8.48021 9.10447 8.35869 8.92995C8.33032 8.88921 8.30348 8.84743 8.27822 8.80469C8.17002 8.62161 8.09127 8.38436 8.04727 7.94134C8.00114 7.47686 8 6.8792 8 5.98557V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass-end-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","loading","processing","delay","hold","queue","timer","clock","waiting-time","order-pending","transaction-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    fill={colors?.[0] || "#2797E8"}
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-end-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","order-pending","transaction-pending","timer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-end-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","delay","processing","loading","order-pending","transaction-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5L6 6.03378C5.99998 6.86667 5.99996 7.56408 6.05706 8.13901C6.1174 8.74644 6.24731 9.29922 6.55645 9.82228C6.60696 9.90775 6.66064 9.99131 6.71737 10.0728C7.06455 10.5714 7.51328 10.9194 8.04064 11.2268C8.46403 11.4736 8.98464 11.7197 9.59521 12C8.98464 12.2803 8.46403 12.5264 8.04065 12.7732C7.51328 13.0806 7.06456 13.4286 6.71738 13.9272C6.66064 14.0087 6.60696 14.0922 6.55645 14.1777C6.24732 14.7008 6.1174 15.2535 6.05707 15.861C5.99997 16.4359 5.99998 17.1333 6 17.9662L6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19L18 17.9662C18 17.1333 18 16.4359 17.9429 15.861C17.8826 15.2535 17.7527 14.7008 17.4436 14.1777C17.393 14.0922 17.3394 14.0087 17.2826 13.9272C16.9355 13.4286 16.4867 13.0806 15.9594 12.7732C15.536 12.5264 15.0154 12.2803 14.4048 12C15.0154 11.7197 15.536 11.4736 15.9594 11.2268C16.4867 10.9194 16.9354 10.5714 17.2826 10.0728C17.3394 9.99131 17.393 9.90775 17.4436 9.82228C17.7527 9.29922 17.8826 8.74644 17.9429 8.13901C18 7.56408 18 6.86668 18 6.0338L18 5C18.5523 5 19 4.55228 19 4C19 3.44772 18.5523 3 18 3H6ZM8.35869 8.92995C8.33032 8.88921 8.30348 8.84743 8.27822 8.80469C8.17002 8.62161 8.09127 8.38436 8.04727 7.94134C8.00114 7.47686 8 6.8792 8 5.98557L8 5L16 5V5.98557C16 6.8792 15.9989 7.47686 15.9527 7.94134C15.9087 8.38436 15.83 8.62161 15.7218 8.80469C15.6965 8.84743 15.6697 8.88921 15.6413 8.92995C15.5198 9.10447 15.3368 9.27473 14.9521 9.49894C14.5489 9.73401 14.0058 9.98353 13.1931 10.3551C12.3517 10.7397 12.1836 10.7962 12.028 10.8005C12.0093 10.8011 11.9907 10.8011 11.9721 10.8005C11.8164 10.7962 11.6483 10.7397 10.8069 10.3551C9.9942 9.98353 9.45112 9.73401 9.04787 9.49894C8.66324 9.27473 8.48021 9.10447 8.35869 8.92995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass-end": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","order-pending","transaction-pending","payment-pending","timeout","duration","elapsed-time","hold","delayed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-half-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","timer","order-pending","transaction-pending","loading","waiting-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 8.5H7L8 9.5L11 11.5H12.5L15.5 10.5L17 8.5Z" fill={colors?.[0] || "#2797E8"} />
                <path d="M7 15.5L17 15.5L16 14.5L13 12.5L11.5 12.5L8.5 13.5L7 15.5Z" fill={colors?.[0] || "#2797E8"} />
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-half-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["hourglass","time","waiting","pending","processing","delay","timer","clock","busy","loading","in-progress","estimated-time","order-processing","payment-processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 8.5H7L8 9.5L11 11.5H12.5L15.5 10.5L17 8.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path d="M7 15.5L17 15.5L16 14.5L13 12.5L11.5 12.5L8.5 13.5L7 15.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-half-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delayed","transaction","timeout","timer","clock","loading"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44771 5 6 5L6 6.03379C5.99998 6.86667 5.99996 7.56408 6.05706 8.13901C6.11739 8.74645 6.24731 9.29923 6.55644 9.82228C6.60696 9.90776 6.66064 9.99132 6.71737 10.0728C7.06455 10.5714 7.51327 10.9194 8.04064 11.2268C8.46402 11.4736 8.98464 11.7197 9.59521 12C8.98464 12.2803 8.46403 12.5264 8.04064 12.7732C7.51328 13.0806 7.06455 13.4286 6.71737 13.9272C6.66064 14.0087 6.60696 14.0922 6.55645 14.1777C6.24732 14.7008 6.1174 15.2536 6.05706 15.861C5.99996 16.4359 5.99998 17.1333 6 17.9662L6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19L18 17.9662C18 17.1333 18 16.4359 17.9429 15.861C17.8826 15.2536 17.7527 14.7008 17.4436 14.1777C17.393 14.0922 17.3394 14.0087 17.2826 13.9272C16.9354 13.4286 16.4867 13.0806 15.9594 12.7732C15.536 12.5264 15.0154 12.2803 14.4048 12C15.0154 11.7197 15.536 11.4736 15.9594 11.2268C16.4867 10.9194 16.9354 10.5714 17.2826 10.0728C17.3394 9.99132 17.393 9.90776 17.4436 9.82228C17.7527 9.29923 17.8826 8.74645 17.9429 8.13901C18 7.56409 18 6.86668 18 6.03381L18 5C18.5523 5 19 4.55228 19 4C19 3.44772 18.5523 3 18 3H6ZM8.41117 9H15.5888C15.6077 8.97663 15.625 8.95333 15.6413 8.92995C15.6697 8.88921 15.6965 8.84743 15.7218 8.8047C15.83 8.62162 15.9087 8.38437 15.9527 7.94134C15.9989 7.47687 16 6.8792 16 5.98558V5.00001L8 5.00001L8 5.98557C8 6.8792 8.00114 7.47687 8.04727 7.94134C8.09127 8.38437 8.17002 8.62162 8.27822 8.8047C8.30348 8.84743 8.33032 8.88922 8.35868 8.92995C8.37496 8.95333 8.39234 8.97663 8.41117 9ZM15.5888 15H8.41117C8.39235 15.0234 8.37497 15.0467 8.35869 15.07C8.33032 15.1108 8.30348 15.1526 8.27822 15.1953C8.17002 15.3784 8.09127 15.6156 8.04727 16.0587C8.00114 16.5231 8 17.1208 8 18.0144V19H16V18.0144C16 17.1208 15.9989 16.5231 15.9527 16.0587C15.9087 15.6156 15.83 15.3784 15.7218 15.1953C15.6965 15.1526 15.6697 15.1108 15.6413 15.07C15.625 15.0467 15.6077 15.0234 15.5888 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass-half": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","pending","waiting","delay","process","loading","duration","timer","in-progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 8.5H7L8 9.5L11 11.5H12.5L15.5 10.5L17 8.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path d="M7 15.5L17 15.5L16 14.5L13 12.5L11.5 12.5L8.5 13.5L7 15.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V18.0144C17 16.2666 17 15.3927 16.5827 14.6865C16.5448 14.6224 16.5045 14.5597 16.462 14.4986C15.9933 13.8255 15.1985 13.4622 13.6088 12.7355C12.8443 12.386 12.462 12.2112 12.0559 12.1999C12.0186 12.1988 11.9814 12.1988 11.9441 12.1999C11.538 12.2112 11.1557 12.386 10.3912 12.7355C8.80155 13.4622 8.00673 13.8255 7.53803 14.4986C7.49548 14.5597 7.45522 14.6224 7.41733 14.6865C7 15.3927 7 16.2666 7 18.0144V19.5C7 19.7761 7.22386 20 7.5 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-start-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["hourglass","time","wait","pending","loading","processing","delay","timeout","duration","session","timer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    fill={colors?.[0] || "#2797E8"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-start-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","loading","delay","processing","timer","duration","hourglass-start","order-pending","payment-pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hourglass-start-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","delayed","order-pending","transaction-pending","loading"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5L18 6.0338C18 6.86668 18 7.56408 17.9429 8.13901C17.8826 8.74644 17.7527 9.29922 17.4436 9.82228C17.393 9.90775 17.3394 9.99131 17.2826 10.0728C16.9354 10.5714 16.4867 10.9194 15.9594 11.2268C15.536 11.4736 15.0154 11.7197 14.4048 12C15.0154 12.2803 15.536 12.5264 15.9594 12.7732C16.4867 13.0806 16.9354 13.4286 17.2826 13.9272C17.3394 14.0087 17.393 14.0922 17.4436 14.1777C17.7527 14.7008 17.8826 15.2535 17.9429 15.861C18 16.4359 18 17.1333 18 17.9662V19C18.5523 19 19 19.4477 19 20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20C5 19.4477 5.44772 19 6 19L6 17.9662C5.99998 17.1333 5.99996 16.4359 6.05706 15.861C6.11739 15.2535 6.24731 14.7008 6.55644 14.1777C6.60696 14.0922 6.66064 14.0087 6.71737 13.9272C7.06455 13.4286 7.51328 13.0806 8.04064 12.7732C8.46402 12.5264 8.98464 12.2803 9.59521 12C8.98464 11.7197 8.46402 11.4736 8.04064 11.2268C7.51327 10.9194 7.06455 10.5714 6.71737 10.0728C6.66064 9.99131 6.60696 9.90775 6.55644 9.82228C6.24731 9.29922 6.11739 8.74644 6.05706 8.13901C5.99996 7.56408 5.99998 6.86667 6 6.03378V5C5.44771 5 5 4.55228 5 4ZM8 19H16V18.0144C16 17.1208 15.9989 16.5231 15.9527 16.0587C15.9087 15.6156 15.83 15.3784 15.7218 15.1953C15.6965 15.1526 15.6697 15.1108 15.6413 15.07C15.5198 14.8955 15.3368 14.7253 14.9521 14.501C14.5489 14.266 14.0058 14.0165 13.1931 13.6449C12.3517 13.2603 12.1836 13.2038 12.028 13.1995C12.0093 13.1989 11.9907 13.1989 11.972 13.1995C11.8164 13.2038 11.6483 13.2603 10.8069 13.6449C9.9942 14.0165 9.45111 14.266 9.04787 14.501C8.66324 14.7253 8.48021 14.8955 8.35869 15.07C8.33032 15.1108 8.30348 15.1526 8.27822 15.1953C8.17002 15.3784 8.09127 15.6156 8.04727 16.0587C8.00114 16.5231 8 17.1208 8 18.0144V19ZM8.35868 8.92995C8.33032 8.88921 8.30348 8.84743 8.27822 8.80469C8.17002 8.62161 8.09127 8.38436 8.04727 7.94134C8.00114 7.47686 8 6.8792 8 5.98557L8 5L16 5V5.98557C16 6.8792 15.9989 7.47686 15.9527 7.94134C15.9087 8.38436 15.83 8.62161 15.7218 8.80469C15.6965 8.84743 15.6697 8.88921 15.6413 8.92995C15.5198 9.10447 15.3368 9.27473 14.9521 9.49894C14.5489 9.73401 14.0058 9.98353 13.1931 10.3551C12.3517 10.7397 12.1836 10.7962 12.0279 10.8005C12.0093 10.8011 11.9907 10.8011 11.972 10.8005C11.8164 10.7962 11.6483 10.7397 10.8069 10.3551C9.9942 9.98353 9.45111 9.73401 9.04786 9.49894C8.66324 9.27473 8.48021 9.10447 8.35868 8.92995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hourglass-start": {
        defaultColors: ["#3d4c66", "#000000"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","timer","duration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 4L16.5 4C16.7761 4 17 4.22386 17 4.5L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31349C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4.5C7 4.22386 7.22386 4 7.5 4Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    hourglass: {
        defaultColors: ["#3D4C66"],
        keywords: ["hourglass","time","waiting","pending","processing","loading","delay","timer","duration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 4L17 5.98557C17 7.73342 17 8.60735 16.5827 9.31348C16.5448 9.37759 16.5045 9.44026 16.462 9.50137C15.9933 10.1745 15.1985 10.5378 13.6088 11.2645V11.2645C12.8443 11.614 12.462 11.7888 12.0559 11.8001C12.0186 11.8012 11.9814 11.8012 11.9441 11.8001C11.538 11.7888 11.1557 11.614 10.3912 11.2645V11.2645C8.80155 10.5378 8.00673 10.1745 7.53803 9.50137C7.49548 9.44026 7.45522 9.37759 7.41733 9.31349C7 8.60735 7 7.73342 7 5.98557L7 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18.0144C7 16.2666 7 15.3927 7.41733 14.6865C7.45522 14.6224 7.49548 14.5597 7.53803 14.4986C8.00673 13.8255 8.80155 13.4622 10.3912 12.7355V12.7355C11.1557 12.386 11.538 12.2112 11.9441 12.1999C11.9814 12.1988 12.0186 12.1988 12.0559 12.1999C12.462 12.2112 12.8443 12.386 13.6088 12.7355V12.7355C15.1985 13.4622 15.9933 13.8255 16.462 14.4986C16.5045 14.5597 16.5448 14.6224 16.5827 14.6865C17 15.3927 17 16.2666 17 18.0144V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "House Water-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["flood","damage","insurance","claim","disaster","alert","warning","repair","maintenance","hazard","emergency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.66667L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L20 9.66667M5 18V9.66667M19 18V6.02381"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 19L5.4179 18.4328C6.08667 18.1653 6.84762 18.2781 7.41007 18.7281L7.85803 19.0864C8.53813 19.6305 9.49214 19.6719 10.2168 19.1888L10.8906 18.7396C11.5624 18.2917 12.4376 18.2917 13.1094 18.7396L13.7832 19.1888C14.5079 19.6719 15.4619 19.6305 16.142 19.0864L16.5899 18.7281C17.1524 18.2781 17.9133 18.1653 18.5821 18.4328L20 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "House Water-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["home","house","water","plumbing","utilities","property","real-estate","service","location","address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18.6V9.08336L9.98452 6.17572C10.9677 5.60219 11.4593 5.31543 12 5.31543C12.5407 5.31543 13.0323 5.60219 14.0155 6.17572L19 9.08336L19 18.6L18.5821 18.4329C17.9133 18.1654 17.1524 18.2781 16.5899 18.7281L16.142 19.0864C15.4619 19.6305 14.5079 19.6719 13.7832 19.1888L13.1094 18.7396C12.4376 18.2918 11.5624 18.2918 10.8906 18.7396L10.2168 19.1888C9.49214 19.6719 8.53813 19.6305 7.85803 19.0864L7.41007 18.7281C6.84762 18.2781 6.08667 18.1654 5.4179 18.4329L5 18.6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19 18.6L18.7215 19.2964H18.7215L19 18.6ZM19.75 6.02383C19.75 5.60962 19.4142 5.27383 19 5.27383C18.5858 5.27383 18.25 5.60962 18.25 6.02383H19.75ZM19.6221 10.3145C19.9799 10.5232 20.4391 10.4024 20.6478 10.0446C20.8565 9.6868 20.7357 9.22757 20.3779 9.01885L19.6221 10.3145ZM14.0155 6.17572L14.3934 5.52789V5.52789L14.0155 6.17572ZM9.98452 6.17572L10.3624 6.82356L9.98452 6.17572ZM3.72146 18.3037C3.33687 18.4575 3.14981 18.894 3.30364 19.2786C3.45748 19.6632 3.89396 19.8502 4.27854 19.6964L3.72146 18.3037ZM5.4179 18.4329L5.69644 19.1292H5.69644L5.4179 18.4329ZM7.41007 18.7281L7.87859 18.1424H7.87859L7.41007 18.7281ZM10.2168 19.1888L10.6328 19.8128H10.6328L10.2168 19.1888ZM10.8906 18.7396L10.4746 18.1156H10.4746L10.8906 18.7396ZM13.1094 18.7396L12.6934 19.3637L13.1094 18.7396ZM13.7832 19.1888L14.1992 18.5648L13.7832 19.1888ZM16.142 19.0864L15.6734 18.5008L16.142 19.0864ZM16.5899 18.7281L17.0585 19.3137L16.5899 18.7281ZM18.5821 18.4329L18.8606 17.7365L18.5821 18.4329ZM19.7215 19.6964C20.106 19.8502 20.5425 19.6632 20.6964 19.2786C20.8502 18.894 20.6631 18.4575 20.2785 18.3037L19.7215 19.6964ZM3.6221 9.01885C3.26431 9.22756 3.14346 9.6868 3.35217 10.0446C3.56088 10.4024 4.02011 10.5232 4.3779 10.3145L3.6221 9.01885ZM4.25 9.08336V18.6H5.75V9.08336H4.25ZM19.75 18.6L19.75 9.08336L18.25 9.08336L18.25 18.6H19.75ZM19.75 9.08336V6.02383H18.25V9.08336H19.75ZM18.6221 9.73119L19.6221 10.3145L20.3779 9.01885L19.3779 8.43552L18.6221 9.73119ZM14.3934 5.52789C13.9145 5.24853 13.5088 5.01092 13.1538 4.8485C12.7837 4.67915 12.4156 4.56543 12 4.56543V6.06543C12.1251 6.06543 12.2731 6.09509 12.5298 6.21251C12.8015 6.33685 13.1333 6.52938 13.6376 6.82356L14.3934 5.52789ZM10.3624 6.82356C10.8667 6.52938 11.1985 6.33685 11.4702 6.21251C11.7269 6.09509 11.8749 6.06543 12 6.06543V4.56543C11.5844 4.56543 11.2163 4.67915 10.8462 4.8485C10.4912 5.01092 10.0855 5.24853 9.60661 5.52789L10.3624 6.82356ZM4.27854 19.6964L5.27854 19.2964L4.72146 17.9037L3.72146 18.3037L4.27854 19.6964ZM5.27854 19.2964L5.69644 19.1292L5.13936 17.7365L4.72146 17.9037L5.27854 19.2964ZM6.94155 19.3137L7.38951 19.6721L8.32655 18.5008L7.87859 18.1424L6.94155 19.3137ZM10.6328 19.8128L11.3066 19.3637L10.4746 18.1156L9.80079 18.5648L10.6328 19.8128ZM12.6934 19.3637L13.3672 19.8128L14.1992 18.5648L13.5254 18.1156L12.6934 19.3637ZM16.6105 19.6721L17.0585 19.3137L16.1214 18.1424L15.6734 18.5008L16.6105 19.6721ZM18.3036 19.1292L18.7215 19.2964L19.2785 17.9037L18.8606 17.7365L18.3036 19.1292ZM18.7215 19.2964L19.7215 19.6964L20.2785 18.3037L19.2785 17.9037L18.7215 19.2964ZM17.0585 19.3137C17.41 19.0325 17.8856 18.962 18.3036 19.1292L18.8606 17.7365C17.9411 17.3687 16.8948 17.5237 16.1214 18.1424L17.0585 19.3137ZM13.3672 19.8128C14.3636 20.4771 15.6754 20.4202 16.6105 19.6721L15.6734 18.5008C15.2484 18.8408 14.6521 18.8667 14.1992 18.5648L13.3672 19.8128ZM11.3066 19.3637C11.7265 19.0837 12.2735 19.0837 12.6934 19.3637L13.5254 18.1156C12.6017 17.4998 11.3983 17.4998 10.4746 18.1156L11.3066 19.3637ZM7.38951 19.6721C8.32465 20.4202 9.63641 20.4771 10.6328 19.8128L9.80079 18.5648C9.34787 18.8667 8.75161 18.8408 8.32655 18.5008L7.38951 19.6721ZM5.69644 19.1292C6.11442 18.962 6.59002 19.0325 6.94155 19.3137L7.87859 18.1424C7.10522 17.5237 6.05891 17.3687 5.13936 17.7365L5.69644 19.1292ZM13.6376 6.82356L18.6221 9.73119L19.3779 8.43552L14.3934 5.52789L13.6376 6.82356ZM4.3779 10.3145L5.3779 9.73119L4.6221 8.43552L3.6221 9.01885L4.3779 10.3145ZM5.3779 9.73119L10.3624 6.82356L9.60661 5.52789L4.6221 8.43552L5.3779 9.73119Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 19L5.4179 18.4328C6.08667 18.1653 6.84762 18.2781 7.41007 18.7281L7.85803 19.0864C8.53813 19.6305 9.49214 19.6719 10.2168 19.1888L10.8906 18.7396C11.5624 18.2917 12.4376 18.2917 13.1094 18.7396L13.7832 19.1888C14.5079 19.6719 15.4619 19.6305 16.142 19.0864L16.5899 18.7281C17.1524 18.2781 17.9133 18.1653 18.5821 18.4328L20 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "House Water-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["house","water","damage","flood","insurance","property","real-estate","weather","alert","warning","hazard","disaster","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.78564 19.2192C6.50442 18.9942 6.12394 18.9378 5.78956 19.0716L4.37166 19.6387C3.85887 19.8438 3.2769 19.5944 3.07179 19.0816C2.86668 18.5688 3.11609 17.9869 3.62888 17.7818L5.04677 17.2146C6.04993 16.8133 7.19136 16.9825 8.03503 17.6574L8.48299 18.0158C8.82304 18.2878 9.30005 18.3085 9.66239 18.067L10.3362 17.6178C11.3439 16.946 12.6567 16.946 13.6644 17.6178L14.3381 18.067C14.7005 18.3085 15.1775 18.2878 15.5175 18.0158L15.9655 17.6574C16.8092 16.9825 17.9506 16.8133 18.9538 17.2146L20.3717 17.7818C20.8844 17.9869 21.1339 18.5688 20.9287 19.0816C20.7236 19.5944 20.1417 19.8438 19.6289 19.6387L18.211 19.0716C17.8766 18.9378 17.4961 18.9942 17.2149 19.2192L16.7669 19.5775C15.7468 20.3937 14.3158 20.4558 13.2287 19.7311L12.555 19.2819C12.2191 19.058 11.7815 19.058 11.4456 19.2819L10.7718 19.7311C9.68477 20.4558 8.25375 20.3937 7.2336 19.5775L6.78564 19.2192Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.508 8.49L20.008 8.2V5.71C20.008 5.16 19.558 4.71 19.008 4.71C18.458 4.71 18.008 5.16 18.008 5.71V7.03L14.528 5C14.058 4.72 13.638 4.48 13.268 4.31C12.878 4.13 12.478 4 12.008 4C11.538 4 11.138 4.13 10.748 4.31C10.378 4.48 9.95805 4.72 9.48805 5L4.49805 7.91L3.49805 8.49C3.01805 8.77 2.85804 9.38 3.13804 9.86C3.32804 10.18 3.65805 10.34 3.99805 10.34V16.45L5.04805 16.03C6.04805 15.63 7.19805 15.8 8.03805 16.47L8.48805 16.83C8.82805 17.1 9.30805 17.12 9.66805 16.88L10.338 16.43C11.348 15.76 12.6581 15.76 13.6681 16.43L14.338 16.88C14.698 17.12 15.178 17.1 15.518 16.83L15.968 16.47C16.808 15.8 17.958 15.63 18.958 16.03L20.008 16.45V10.34C20.348 10.34 20.688 10.18 20.868 9.86C21.148 9.38 20.988 8.77 20.508 8.49ZM13.768 13.45C13.298 13.92 12.668 14.18 11.998 14.18C10.618 14.18 9.49805 13.06 9.49805 11.68C9.49805 10.3 10.618 9.18 11.998 9.18C13.378 9.18 14.498 10.3 14.498 11.68C14.498 12.35 14.238 12.98 13.768 13.45Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "House Water": {
        defaultColors: ["#3D4C66"],
        keywords: ["flood","damage","insurance","property","water-damage","disaster","house","real-estate","loss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.66667L8 7.33333L9.98452 6.1757C10.9677 5.60217 11.4593 5.31541 12 5.31541C12.5407 5.31541 13.0323 5.60217 14.0155 6.1757L16 7.33333L20 9.66667M5 18V9.66667M19 18V6.02381"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13C9 14.6569 10.3431 16 12 16C12.8284 16 13.5784 15.6642 14.1213 15.1213C14.6642 14.5784 15 13.8284 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 19L5.4179 18.4328C6.08667 18.1653 6.84762 18.2781 7.41007 18.7281L7.85803 19.0864C8.53813 19.6305 9.49214 19.6719 10.2168 19.1888L10.8906 18.7396C11.5624 18.2917 12.4376 18.2917 13.1094 18.7396L13.7832 19.1888C14.5079 19.6719 15.4619 19.6305 16.142 19.0864L16.5899 18.7281C17.1524 18.2781 17.9133 18.1653 18.5821 18.4328L20 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "hq-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["hq","headquarters","location","store","shop","brand","company"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M11 10L11 12M11 14L11 12M8 14L8 12M11 12L9.5 12L8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.2498 11.4998L15.2499 12.5L16.7499 12.4999L16.7498 11.4997L15.2498 11.4998ZM13.75 12.5001V11.4999H12.25V12.5001H13.75ZM13.75 11.4999C13.75 11.0857 14.0857 10.75 14.4999 10.75V9.25C13.2573 9.25 12.25 10.2573 12.25 11.4999H13.75ZM16.7498 11.4997C16.7497 10.2572 15.7424 9.25 14.4999 9.25V10.75C14.914 10.75 15.2497 11.0857 15.2498 11.4998L16.7498 11.4997ZM15.2499 12.5C15.2499 12.9142 14.9141 13.25 14.4999 13.25V14.75C15.7426 14.75 16.75 13.7425 16.7499 12.4999L15.2499 12.5ZM12.25 12.5001C12.25 13.7427 13.2573 14.75 14.4999 14.75V13.25C14.0858 13.25 13.75 12.9142 13.75 12.5001H12.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M15.4697 14.5303C15.7626 14.8232 16.2374 14.8232 16.5303 14.5303C16.8232 14.2374 16.8232 13.7626 16.5303 13.4697L15.4697 14.5303ZM15.5303 12.4697C15.2374 12.1768 14.7626 12.1768 14.4697 12.4697C14.1768 12.7626 14.1768 13.2374 14.4697 13.5303L15.5303 12.4697ZM16.5303 13.4697L15.5303 12.4697L14.4697 13.5303L15.4697 14.5303L16.5303 13.4697Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "hq-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["hq","headquarters","location","store","establishment","management","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M11 10L11 12M11 14L11 12M8 14L8 12M11 12L9.5 12L8 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.2498 11.4998L15.2499 12.5L16.7499 12.4999L16.7498 11.4997L15.2498 11.4998ZM13.75 12.5001V11.4999H12.25V12.5001H13.75ZM13.75 11.4999C13.75 11.0857 14.0857 10.75 14.4999 10.75V9.25C13.2573 9.25 12.25 10.2573 12.25 11.4999H13.75ZM16.7498 11.4997C16.7497 10.2572 15.7424 9.25 14.4999 9.25V10.75C14.914 10.75 15.2497 11.0857 15.2498 11.4998L16.7498 11.4997ZM15.2499 12.5C15.2499 12.9142 14.9141 13.25 14.4999 13.25V14.75C15.7426 14.75 16.75 13.7425 16.7499 12.4999L15.2499 12.5ZM12.25 12.5001C12.25 13.7427 13.2573 14.75 14.4999 14.75V13.25C14.0858 13.25 13.75 12.9142 13.75 12.5001H12.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.4697 14.5303C15.7626 14.8232 16.2374 14.8232 16.5303 14.5303C16.8232 14.2374 16.8232 13.7626 16.5303 13.4697L15.4697 14.5303ZM15.5303 12.4697C15.2374 12.1768 14.7626 12.1768 14.4697 12.4697C14.1768 12.7626 14.1768 13.2374 14.4697 13.5303L15.5303 12.4697ZM16.5303 13.4697L15.5303 12.4697L14.4697 13.5303L15.4697 14.5303L16.5303 13.4697Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "hq-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hq","headquarters","location","management","organization","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.75 11.4999C13.75 11.0857 14.0857 10.75 14.4999 10.75C14.914 10.75 15.2497 11.0857 15.2498 11.4998L15.2498 12.2927C14.986 12.1997 14.6806 12.2587 14.4697 12.4697C14.2672 12.6722 14.2047 12.9617 14.2822 13.2179C13.9742 13.1246 13.75 12.8385 13.75 12.5001V11.4999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM8.75 10C8.75 9.58579 8.41421 9.25 8 9.25C7.58579 9.25 7.25 9.58579 7.25 10L7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41422 14.75 8.75 14.4142 8.75 14V12.75H10.25V14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14L11.75 10C11.75 9.58579 11.4142 9.25 11 9.25C10.5858 9.25 10.25 9.58579 10.25 10L10.25 11.25H8.75V10ZM16.7499 12.4999C16.7499 12.8472 16.6712 13.1762 16.5306 13.47C16.8232 13.7629 16.8231 14.2375 16.5303 14.5303C16.2376 14.8231 15.763 14.8232 15.47 14.5307C15.1763 14.6713 14.8473 14.75 14.4999 14.75C13.2573 14.75 12.25 13.7427 12.25 12.5001V11.4999C12.25 10.2573 13.2573 9.25 14.4999 9.25C15.7424 9.25 16.7497 10.2572 16.7498 11.4997L16.7499 12.4999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    hq: {
        defaultColors: ["#3D4C66"],
        keywords: ["hq","headquarters","location","management","organization","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L8 12M11 10L11 12M11 14L11 12M8 14L8 12M11 12L9.5 12L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.2498 11.4998L15.2499 12.5L16.7499 12.4999L16.7498 11.4997L15.2498 11.4998ZM13.75 12.5001V11.4999H12.25V12.5001H13.75ZM13.75 11.4999C13.75 11.0857 14.0857 10.75 14.4999 10.75V9.25C13.2573 9.25 12.25 10.2573 12.25 11.4999H13.75ZM16.7498 11.4997C16.7497 10.2572 15.7424 9.25 14.4999 9.25V10.75C14.914 10.75 15.2497 11.0857 15.2498 11.4998L16.7498 11.4997ZM15.2499 12.5C15.2499 12.9142 14.9141 13.25 14.4999 13.25V14.75C15.7426 14.75 16.75 13.7425 16.7499 12.4999L15.2499 12.5ZM12.25 12.5001C12.25 13.7427 13.2573 14.75 14.4999 14.75V13.25C14.0858 13.25 13.75 12.9142 13.75 12.5001H12.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.4697 14.5303C15.7626 14.8232 16.2374 14.8232 16.5303 14.5303C16.8232 14.2374 16.8232 13.7626 16.5303 13.4697L15.4697 14.5303ZM15.5303 12.4697C15.2374 12.1768 14.7626 12.1768 14.4697 12.4697C14.1768 12.7626 14.1768 13.2374 14.4697 13.5303L15.5303 12.4697ZM16.5303 13.4697L15.5303 12.4697L14.4697 13.5303L15.4697 14.5303L16.5303 13.4697Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "html-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shield","badge","5","version","update","security","software"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H10L10 12H14V14.3333L12 15L10 14.3333"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.94868 16.3841L6.09025 6.08305C6.04167 5.50003 6.50176 5 7.0868 5H12H16.9132C17.4982 5 17.9583 5.50003 17.9097 6.08305L17.0513 16.3841C17.0199 16.7616 16.7779 17.0889 16.4262 17.2295L12.3714 18.8514C12.133 18.9468 11.867 18.9468 11.6286 18.8514L7.57383 17.2295C7.22215 17.0889 6.98013 16.7616 6.94868 16.3841Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "html-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["html5","badge","web","technology","software","development","coding","programming","website","webpage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.94868 16.3841L6.09025 6.08305C6.04167 5.50003 6.50176 5 7.0868 5H12H16.9132C17.4982 5 17.9583 5.50003 17.9097 6.08305L17.0513 16.3841C17.0199 16.7616 16.7779 17.0889 16.4262 17.2295L12.3714 18.8514C12.133 18.9468 11.867 18.9468 11.6286 18.8514L7.57383 17.2295C7.22215 17.0889 6.98013 16.7616 6.94868 16.3841Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9H10L10 12H14V14.3333L12 15L10 14.3333"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    html: {
        defaultColors: ["#3D4C66"],
        keywords: ["html5","badge","web","technology","software","development","coding","programming","website","webpage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H10L10 12H14V14.3333L12 15L10 14.3333"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.94868 16.3841L6.09025 6.08305C6.04167 5.50003 6.50176 5 7.0868 5H12H16.9132C17.4982 5 17.9583 5.50003 17.9097 6.08305L17.0513 16.3841C17.0199 16.7616 16.7779 17.0889 16.4262 17.2295L12.3714 18.8514C12.133 18.9468 11.867 18.9468 11.6286 18.8514L7.57383 17.2295C7.22215 17.0889 6.98013 16.7616 6.94868 16.3841Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "html-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["badge","shield","5","five","version","update","secure","security","compliant","standard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.09396 6.16609C4.99679 5.00005 5.91697 4 7.08705 4H16.9135C18.0835 4 19.0037 5.00005 18.9065 6.16609L18.0481 16.4671C17.9852 17.2221 17.5012 17.8767 16.7978 18.158L12.743 19.7799C12.2662 19.9706 11.7343 19.9706 11.2575 19.7799L7.20269 18.158C6.49933 17.8767 6.01529 17.2221 5.95238 16.4671L5.09396 6.16609ZM10.0003 8C9.73505 8 9.4807 8.10536 9.29316 8.29289C9.10563 8.48043 9.00027 8.73478 9.00027 9V12C9.00027 12.5523 9.44799 13 10.0003 13H13.0003V13.6126L12.0003 13.9459L10.3165 13.3847C9.79256 13.21 9.22624 13.4932 9.05159 14.0171C8.87694 14.541 9.1601 15.1074 9.68404 15.282L11.684 15.9487C11.8893 16.0171 12.1112 16.0171 12.3165 15.9487L14.3165 15.282C14.7248 15.1459 15.0003 14.7638 15.0003 14.3333V12C15.0003 11.4477 14.5526 11 14.0003 11H11.0003V10H14.0003C14.5526 10 15.0003 9.55228 15.0003 9C15.0003 8.44772 14.5526 8 14.0003 8H10.0003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "I-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["cursor","text-input","input","type","typing","I-beam","vertical-bar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "I-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["text","input","cursor","type","writing","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "I-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","column","vertical-line","details","show-details","display-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7C10 6.44772 10.4477 6 11 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8V16C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H11C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16V8C10.4477 8 10 7.55228 10 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "I-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["align-center","center","alignment","text","format","paragraph"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM7 18.25C6.58579 18.25 6.25 18.5858 6.25 19C6.25 19.4142 6.58579 19.75 7 19.75V18.25ZM17 19.75C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25V19.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75ZM7 19.75H17V18.25H7V19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "I-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["align-center","text-align","formatting","layout","paragraph"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM7 18.25C6.58579 18.25 6.25 18.5858 6.25 19C6.25 19.4142 6.58579 19.75 7 19.75V18.25ZM17 19.75C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25V19.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75ZM7 19.75H17V18.25H7V19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "I-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["align-top","vertical-align","layout","formatting","text-alignment","user-interface","design"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM7 18.25C6.58579 18.25 6.25 18.5858 6.25 19C6.25 19.4142 6.58579 19.75 7 19.75V18.25ZM17 19.75C17.4142 19.75 17.75 19.4142 17.75 19C17.75 18.5858 17.4142 18.25 17 18.25V19.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75ZM7 19.75H17V18.25H7V19.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "i-cursor-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["resize","adjust","scale","dimensions","stretch","expand","contract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C13.7909 5 12 6.79086 12 9V15C12 17.2091 13.7909 19 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5C10.2091 5 12 6.79086 12 9V15C12 17.2091 10.2091 19 8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "I-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["i","cursor","text-input","insertion","select","input","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H13V18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18H11V6H7C6.44772 6 6 5.55228 6 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "i-cursor-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["select","text","edit","cursor","resize","text-edit","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C13.7909 5 12 6.79086 12 9V15C12 17.2091 13.7909 19 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5C10.2091 5 12 6.79086 12 9V15C12 17.2091 10.2091 19 8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "i-cursor-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["resize","adjust","expand","contract","size","dimensions","edit","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5C7 4.44772 7.44772 4 8 4C9.6356 4 11.0878 4.78534 12 5.99951C12.9122 4.78534 14.3644 4 16 4C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6C14.3431 6 13 7.34315 13 9V11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13V15C13 16.6569 14.3431 18 16 18C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20C14.3644 20 12.9122 19.2147 12 18.0005C11.0878 19.2147 9.6356 20 8 20C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18C9.65685 18 11 16.6569 11 15V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H11V9C11 7.34315 9.65685 6 8 6C7.44772 6 7 5.55228 7 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "i-cursor": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","select","cursor","editing","input","highlight","i-cursor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5C13.7909 5 12 6.79086 12 9V15C12 17.2091 13.7909 19 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 5C10.2091 5 12 6.79086 12 9V15C12 17.2091 10.2091 19 8 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ID card-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["id","card","id-card","employee","profile","identity","license","identification","member","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.23463 9.15224C7.60218 9 8.06812 9 9 9C9.93188 9 10.3978 9 10.7654 9.15224C11.2554 9.35523 11.6448 9.74458 11.8478 10.2346C12 10.6022 12 11.0681 12 12C12 12.9319 12 13.3978 11.8478 13.7654C11.6448 14.2554 11.2554 14.6448 10.7654 14.8478C10.3978 15 9.93188 15 9 15C8.06812 15 7.60218 15 7.23463 14.8478C6.74458 14.6448 6.35523 14.2554 6.15224 13.7654C6 13.3978 6 12.9319 6 12C6 11.0681 6 10.6022 6.15224 10.2346C6.35523 9.74458 6.74458 9.35523 7.23463 9.15224Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M15 11H18M18 13H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    I: {
        defaultColors: ["#3D4C66"],
        keywords: ["id","card","id-card","employee","profile","identity","license","identification","member","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "ID card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["id","card","profile","customer","identification","member","discount","loyalty","rewards","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M15 11H18M18 13H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7.23463 9.15224C7.60218 9 8.06812 9 9 9C9.93188 9 10.3978 9 10.7654 9.15224C11.2554 9.35523 11.6448 9.74458 11.8478 10.2346C12 10.6022 12 11.0681 12 12C12 12.9319 12 13.3978 11.8478 13.7654C11.6448 14.2554 11.2554 14.6448 10.7654 14.8478C10.3978 15 9.93188 15 9 15C8.06812 15 7.60218 15 7.23463 14.8478C6.74458 14.6448 6.35523 14.2554 6.15224 13.7654C6 13.3978 6 12.9319 6 12C6 11.0681 6 10.6022 6.15224 10.2346C6.35523 9.74458 6.74458 9.35523 7.23463 9.15224Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "ID card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["id","card","profile","member","customer","identification","customer-profile","loyalty","loyalty-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82768 21.7565 6.64711 21.8813 7.57494C22.0001 8.4587 22 9.57531 22 10.9294V13.0705C22 14.4247 22.0001 15.5413 21.8813 16.4251C21.7565 17.3529 21.4845 18.1723 20.8284 18.8284C20.1723 19.4845 19.3529 19.7565 18.4251 19.8813C17.5413 20.0001 16.4247 20 15.0707 20H8.92943C7.57534 20 6.45868 20.0001 5.57494 19.8813C4.64711 19.7565 3.82769 19.4845 3.17158 18.8284C2.51547 18.1723 2.2435 17.3529 2.11876 16.4251C1.99994 15.5413 1.99997 14.4247 2 13.0706V10.9294C1.99997 9.57533 1.99994 8.45869 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45869 3.99994 7.57529 3.99997 8.9294 4H15.0706ZM8.5 8.5C7.4128 8.5 6.86921 8.5 6.44041 8.67762C5.86867 8.91443 5.41443 9.36867 5.17762 9.94041C5 10.3692 5 10.9128 5 12C5 13.0872 5 13.6308 5.17762 14.0596C5.41443 14.6313 5.86867 15.0856 6.44041 15.3224C6.86921 15.5 7.4128 15.5 8.5 15.5C9.5872 15.5 10.1308 15.5 10.5596 15.3224C11.1313 15.0856 11.5856 14.6313 11.8224 14.0596C12 13.6308 12 13.0872 12 12C12 10.9128 12 10.3692 11.8224 9.94041C11.5856 9.36867 11.1313 8.91443 10.5596 8.67762C10.1308 8.5 9.5872 8.5 8.5 8.5ZM15 9.5C14.4477 9.5 14 9.94772 14 10.5C14 11.0523 14.4477 11.5 15 11.5H18C18.5523 11.5 19 11.0523 19 10.5C19 9.94772 18.5523 9.5 18 9.5H15ZM15 12.5C14.4477 12.5 14 12.9477 14 13.5C14 14.0523 14.4477 14.5 15 14.5H18C18.5523 14.5 19 14.0523 19 13.5C19 12.9477 18.5523 12.5 18 12.5H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ID card": {
        defaultColors: ["#3D4C66"],
        keywords: ["id","card","profile","customer","membership","loyalty","account","details","user","identification","verify","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 11H18M18 13H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.23463 9.15224C7.60218 9 8.06812 9 9 9C9.93188 9 10.3978 9 10.7654 9.15224C11.2554 9.35523 11.6448 9.74458 11.8478 10.2346C12 10.6022 12 11.0681 12 12C12 12.9319 12 13.3978 11.8478 13.7654C11.6448 14.2554 11.2554 14.6448 10.7654 14.8478C10.3978 15 9.93188 15 9 15C8.06812 15 7.60218 15 7.23463 14.8478C6.74458 14.6448 6.35523 14.2554 6.15224 13.7654C6 13.3978 6 12.9319 6 12C6 11.0681 6 10.6022 6.15224 10.2346C6.35523 9.74458 6.74458 9.35523 7.23463 9.15224Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "II-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["quantity","number","two","double","amount","items","count"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L9 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L15 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17L16 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17L10 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "II-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["columns","two","pair","quantity","number","II","count"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17L16 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "II-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["quantity","two","double","amount","multiplier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L10 16C10.5523 16 11 16.4477 11 17C11 17.5523 10.5523 18 10 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16L8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6H10C10.5523 6 11 6.44772 11 7C11 7.55228 10.5523 8 10 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 8L16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H14C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16L14 8C13.4477 8 13 7.55228 13 7C13 6.44772 13.4477 6 14 6H16C16.5523 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    II: {
        defaultColors: ["#3D4C66"],
        keywords: ["quantity","two","double","amount","multiplier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17L16 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "III-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["III","three","quantity","number","count","items","third","limit","level","stage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "III-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["three","quantity","number","count","III","tally"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "III-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["number-three","III","tally","quantity-3","third","amount-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7C4 6.44772 4.44772 6 5 6H7C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8V16C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16V8C4.44772 8 4 7.55228 4 7ZM10 7C10 6.44772 10.4477 6 11 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8V16C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H11C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16V8C10.4477 8 10 7.55228 10 7ZM16 7C16 6.44772 16.4477 6 17 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8V16C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H17C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16V8C16.4477 8 16 7.55228 16 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    III: {
        defaultColors: ["#3D4C66"],
        keywords: ["number-three","III","tally","quantity-3","third","amount-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L13 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "incognito-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["incognito","private","anonymous","spy","hidden","user","security","privacy","guest","mask"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L16.7292 7.18768C16.3899 6.16979 16.2203 5.66085 15.7986 5.48619C15.3769 5.31153 14.8971 5.55145 13.9374 6.03128L12.8944 6.55279C12.4555 6.77224 12.2361 6.88197 12 6.88197C11.7639 6.88197 11.5445 6.77224 11.1056 6.55279L10.0626 6.03128C9.10289 5.55145 8.62306 5.31153 8.20139 5.48619C7.77972 5.66085 7.61007 6.16979 7.27077 7.18768L6 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M20 11H4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16H11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="8" cy="16" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="16" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "incognito-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["incognito","anonymous","private","user","guest","customer","hidden"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L16.7292 7.18763C16.3899 6.16974 16.2203 5.6608 15.7986 5.48614C15.3769 5.31148 14.8971 5.5514 13.9374 6.03123L12.8944 6.55274C12.4555 6.77219 12.2361 6.88192 12 6.88192C11.7639 6.88192 11.5445 6.77219 11.1056 6.55274L10.0626 6.03123C9.10289 5.5514 8.62306 5.31148 8.20139 5.48614C7.77972 5.6608 7.61007 6.16974 7.27077 7.18763L6 11H18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16.7292 7.18763L16.0177 7.4248V7.4248L16.7292 7.18763ZM7.27077 7.18763L6.55926 6.95046L7.27077 7.18763ZM10.0626 6.03123L9.72716 6.70205V6.70205L10.0626 6.03123ZM11.1056 6.55274L11.441 5.88192V5.88192L11.1056 6.55274ZM12.8944 6.55274L13.2298 7.22356V7.22356L12.8944 6.55274ZM13.9374 6.03123L13.602 5.36041V5.36041L13.9374 6.03123ZM15.7986 5.48614L15.5116 6.17905L15.5116 6.17905L15.7986 5.48614ZM8.20139 5.48614L7.91437 4.79323V4.79323L8.20139 5.48614ZM20 11.75C20.4142 11.75 20.75 11.4142 20.75 11C20.75 10.5857 20.4142 10.25 20 10.25V11.75ZM4 10.25C3.58579 10.25 3.25 10.5857 3.25 11C3.25 11.4142 3.58579 11.75 4 11.75V10.25ZM16.0177 7.4248L17.2885 11.2371L18.7115 10.7628L17.4407 6.95046L16.0177 7.4248ZM6.71151 11.2371L7.98229 7.4248L6.55926 6.95046L5.28849 10.7628L6.71151 11.2371ZM9.72716 6.70205L10.7702 7.22356L11.441 5.88192L10.398 5.36041L9.72716 6.70205ZM13.2298 7.22356L14.2728 6.70205L13.602 5.36041L12.559 5.88192L13.2298 7.22356ZM10.7702 7.22356C11.1417 7.40934 11.5453 7.63192 12 7.63192V6.13192C11.9998 6.13192 11.9996 6.13192 11.9985 6.13181C11.9974 6.13168 11.9941 6.13123 11.9879 6.12983C11.9747 6.12685 11.9491 6.11967 11.9038 6.10184C11.8025 6.06192 11.672 5.99743 11.441 5.88192L10.7702 7.22356ZM12.559 5.88192C12.328 5.99743 12.1975 6.06192 12.0962 6.10184C12.0509 6.11967 12.0253 6.12685 12.0121 6.12983C12.0059 6.13123 12.0026 6.13168 12.0015 6.13181C12.0004 6.13192 12.0002 6.13192 12 6.13192V7.63192C12.4547 7.63192 12.8583 7.40934 13.2298 7.22356L12.559 5.88192ZM17.4407 6.95046C17.2783 6.46305 17.1328 6.0212 16.9662 5.68647C16.7902 5.33275 16.5341 4.979 16.0856 4.79323L15.5116 6.17905C15.5121 6.17927 15.5109 6.17869 15.5097 6.1779C15.5089 6.17729 15.5124 6.17957 15.5203 6.18822C15.5382 6.20781 15.5732 6.25412 15.6234 6.35488C15.7318 6.57276 15.8409 6.89433 16.0177 7.4248L17.4407 6.95046ZM14.2728 6.70205C14.773 6.45199 15.0775 6.30171 15.3082 6.22434C15.4149 6.18855 15.4725 6.18058 15.499 6.17937C15.5107 6.17884 15.5148 6.17972 15.5137 6.17954C15.5124 6.17932 15.5111 6.17883 15.5116 6.17905L16.0856 4.79323C15.6371 4.60745 15.2059 4.67654 14.8313 4.80216C14.4768 4.92104 14.0616 5.13064 13.602 5.36041L14.2728 6.70205ZM7.98229 7.4248C8.15911 6.89433 8.26816 6.57276 8.37661 6.35488C8.42676 6.25412 8.4618 6.20781 8.47969 6.18822C8.48758 6.17957 8.4911 6.17729 8.49025 6.1779C8.48914 6.17869 8.48787 6.17927 8.4884 6.17905L7.91437 4.79323C7.46587 4.97901 7.20984 5.33275 7.03377 5.68647C6.86715 6.0212 6.72173 6.46305 6.55926 6.95046L7.98229 7.4248ZM10.398 5.36041C9.93844 5.13064 9.52318 4.92104 9.16867 4.80216C8.79405 4.67654 8.36287 4.60745 7.91437 4.79323L8.4884 6.17905C8.48893 6.17883 8.48762 6.17932 8.48627 6.17954C8.48524 6.17972 8.48935 6.17884 8.50104 6.17937C8.52754 6.18058 8.58507 6.18855 8.69178 6.22434C8.92253 6.30171 9.22702 6.45199 9.72716 6.70205L10.398 5.36041ZM20 10.25H18V11.75H20V10.25ZM18 10.25H6V11.75H18V10.25ZM6 10.25H4V11.75H6V10.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M13 16H11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="8"
                    cy="16"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="16"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "incognito-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["incognito","anonymous","privacy","customer","guest","hidden","private","mask","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4565 4.11022C10.4742 4.1191 10.492 4.12799 10.5098 4.13689L11.5528 4.65839C11.7877 4.77584 11.9068 4.8344 11.9955 4.86933L12 4.87111L12.0045 4.86933C12.0932 4.8344 12.2123 4.77584 12.4472 4.65839L13.4902 4.13689C13.508 4.12799 13.5258 4.1191 13.5435 4.11023C13.977 3.89339 14.3915 3.68607 14.7518 3.56522C15.1538 3.43043 15.6536 3.34375 16.1813 3.56234C16.709 3.78093 17.0011 4.19562 17.19 4.57515C17.3594 4.91543 17.5059 5.35509 17.6591 5.81493C17.6653 5.83375 17.6716 5.85261 17.6779 5.87149L18.7208 9.00003H20C20.5523 9.00003 21 9.44775 21 10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10C3 9.44775 3.44772 9.00003 4 9.00003H5.27924L6.32209 5.87149C6.32838 5.85261 6.33466 5.83375 6.34093 5.81493C6.49412 5.3551 6.64058 4.91543 6.80996 4.57515C6.99887 4.19562 7.29098 3.78093 7.8187 3.56234C8.34643 3.34375 8.84621 3.43043 9.24816 3.56522C9.60854 3.68607 10.023 3.89339 10.4565 4.11022Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 16.0001C4.25 13.929 5.92893 12.2501 8 12.2501C9.81422 12.2501 11.3275 13.5384 11.675 15.2501H12.325C12.6725 13.5384 14.1858 12.2501 16 12.2501C18.0711 12.2501 19.75 13.929 19.75 16.0001C19.75 18.0712 18.0711 19.7501 16 19.7501C14.1858 19.7501 12.6725 18.4618 12.325 16.7501H11.675C11.3275 18.4618 9.81422 19.7501 8 19.7501C5.92893 19.7501 4.25 18.0712 4.25 16.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    incognito: {
        defaultColors: ["#3D4C66"],
        keywords: ["incognito","anonymous","privacy","customer","guest","hidden","private","mask","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L16.7292 7.18768C16.3899 6.16979 16.2203 5.66085 15.7986 5.48619C15.3769 5.31153 14.8971 5.55145 13.9374 6.03128L12.8944 6.55279C12.4555 6.77224 12.2361 6.88197 12 6.88197C11.7639 6.88197 11.5445 6.77224 11.1056 6.55279L10.0626 6.03128C9.10289 5.55145 8.62306 5.31153 8.20139 5.48619C7.77972 5.66085 7.61007 6.16979 7.27077 7.18768L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 11H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16H11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="8" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "infinity 2-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","limitless","unending","subscription","loyalty","repeat","continuous","perpetual","always"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L11.5147 11.5147C9.26428 9.26428 5.23824 7.69737 4.21252 10.7102C4.07474 11.1148 4 11.5487 4 12C4 12.4513 4.07474 12.8852 4.21252 13.2898C5.23824 16.3026 9.26428 14.7357 11.5147 12.4853L12 12ZM12 12L12.4853 12.4853C14.7357 14.7357 18.7618 16.3026 19.7875 13.2898C19.9253 12.8852 20 12.4513 20 12C20 11.5487 19.9253 11.1148 19.7875 10.7102C18.7618 7.69737 14.7357 9.26428 12.4853 11.5147L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "infinity 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["infinity","loop","limitless","unlimited","loyalty program","subscription","recurring","continuous","endless","always","forever"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.043 12L12.5282 11.5147C14.7787 9.26428 18.8047 7.69737 19.8304 10.7102C19.9682 11.1148 20.043 11.5487 20.043 12C20.043 12.4513 19.9682 12.8852 19.8304 13.2898C18.8047 16.3026 14.7787 14.7357 12.5282 12.4853L12.043 12ZM12.043 12L12 11.957"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12C4 12.4513 4.07474 12.8852 4.21252 13.2898C5.23824 16.3026 9.26428 14.7357 11.5147 12.4853L12 12L11.5147 11.5147C9.26428 9.26428 5.23824 7.69737 4.21252 10.7102C4.07474 11.1148 4 11.5487 4 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12 12L11.5147 11.5147C9.26428 9.26428 5.23824 7.69737 4.21252 10.7102C4.07474 11.1148 4 11.5487 4 12C4 12.4513 4.07474 12.8852 4.21252 13.2898C5.23824 16.3026 9.26428 14.7357 11.5147 12.4853L12 12ZM12 12L12.043 11.957"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "infinity 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","continuous","recurring","subscription","loyalty program","endless","limitless","all you can eat","always available"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.86779 10.1656C5.59818 10.2826 5.33535 10.5148 5.15916 11.0323C5.05625 11.3346 5 11.6596 5 11.9999C5 12.3401 5.05625 12.6652 5.15916 12.9674C5.33535 13.4849 5.59818 13.7172 5.86779 13.8341C6.1723 13.9663 6.61502 14.0047 7.19945 13.8824C8.29444 13.6531 9.57954 12.9207 10.5767 11.9999C9.57954 11.0791 8.29444 10.3466 7.19945 10.1174C6.61502 9.99505 6.17231 10.0335 5.86779 10.1656ZM12.0215 13.387C10.8103 14.5316 9.17179 15.5128 7.60925 15.8399C6.77765 16.014 5.88088 16.02 5.07171 15.6689C4.22762 15.3026 3.60256 14.6009 3.26588 13.612C3.09323 13.1049 3 12.5623 3 11.9999C3 11.4375 3.09323 10.8949 3.26588 10.3877C3.60256 9.39885 4.22762 8.69714 5.07171 8.3309C5.88088 7.9798 6.77765 7.98574 7.60925 8.15983C9.17179 8.48694 10.8103 9.46817 12.0215 10.6128C13.2326 9.46817 14.8712 8.48694 16.4337 8.15983C17.2653 7.98574 18.1621 7.9798 18.9713 8.3309C19.8153 8.69714 20.4404 9.39885 20.7771 10.3877C20.9497 10.8949 21.043 11.4375 21.043 11.9999C21.043 12.5623 20.9497 13.1049 20.7771 13.612C20.4404 14.6009 19.8153 15.3026 18.9713 15.6689C18.1621 16.02 17.2653 16.014 16.4337 15.8399C14.8712 15.5128 13.2326 14.5316 12.0215 13.387ZM13.4663 11.9999C14.4634 12.9207 15.7485 13.6531 16.8435 13.8824C17.428 14.0047 17.8707 13.9663 18.1752 13.8341C18.4448 13.7172 18.7076 13.4849 18.8838 12.9674C18.9867 12.6652 19.043 12.3401 19.043 11.9999C19.043 11.6596 18.9867 11.3346 18.8838 11.0323C18.7076 10.5148 18.4448 10.2826 18.1752 10.1656C17.8707 10.0335 17.428 9.99505 16.8435 10.1174C15.7485 10.3466 14.4634 11.0791 13.4663 11.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "infinity 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","always","continuous","loyalty","subscription","membership","recurring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L11.5147 11.5147C9.26428 9.26428 5.23824 7.69737 4.21252 10.7102C4.07474 11.1148 4 11.5487 4 12C4 12.4513 4.07474 12.8852 4.21252 13.2898C5.23824 16.3026 9.26428 14.7357 11.5147 12.4853L12 12ZM12 12L12.4853 12.4853C14.7357 14.7357 18.7618 16.3026 19.7875 13.2898C19.9253 12.8852 20 12.4513 20 12C20 11.5487 19.9253 11.1148 19.7875 10.7102C18.7618 7.69737 14.7357 9.26428 12.4853 11.5147L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "infinity-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","continuous","recurring","subscription","membership","loyalty-program","always","limitless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12ZM12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "infinity-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["infinity","unlimited","repeat","loyalty program","subscription","recurring","endless","forever"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "infinity-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","endless","unlimited","loyalty program","subscriptions","recurring","always","permanence","long-term"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.82343 9.85336C5.88385 8.71555 7.57199 8.71555 8.63241 9.85336L10.633 12L8.63241 14.1466C7.57199 15.2845 5.88385 15.2845 4.82343 14.1466C3.72552 12.9686 3.72552 11.0314 4.82343 9.85336ZM12 10.5333L10.0955 8.48978C8.24424 6.50341 5.2116 6.50341 3.36033 8.48978C1.54656 10.4359 1.54656 13.5641 3.36033 15.5102C5.2116 17.4966 8.24424 17.4966 10.0955 15.5102L12 13.4667L13.9045 15.5102C15.7558 17.4966 18.7884 17.4966 20.6397 15.5102C22.4534 13.5641 22.4534 10.4359 20.6397 8.48978C18.7884 6.50341 15.7558 6.50341 13.9045 8.48978L12 10.5333ZM13.367 12L15.3676 14.1466C16.428 15.2845 18.1161 15.2845 19.1766 14.1466C20.2745 12.9686 20.2745 11.0314 19.1766 9.85336C18.1161 8.71555 16.428 8.71555 15.3676 9.85336L13.367 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "infinity-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","continuous","stock","inventory","unlimited-stock","unlimited-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "infinity-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["infinity","loop","continuous","recurring","subscription","loyalty","unlimited","perpetual"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "infinity-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["infinity","limitless","unlimited","loyalty-program","subscriptions","endless","recurring","repeat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "info 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["info","information","details","help","support","question","about","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 14.5714L12 11L11 11M12 16L11 16M12 16L13 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "infinity-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","limitless","always","continuous","repeat","recurring","loyalty-program","subscription","unlimited-items","frequent","endless","eternal","repeat-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.36033 8.48978C5.2116 6.50341 8.24424 6.50341 10.0955 8.48978L12 10.5333L13.9045 8.48978C15.7558 6.50341 18.7884 6.50341 20.6397 8.48978C22.4534 10.4359 22.4534 13.5641 20.6397 15.5102C18.7884 17.4966 15.7558 17.4966 13.9045 15.5102L12 13.4667L10.0955 15.5102C8.24424 17.4966 5.2116 17.4966 3.36033 15.5102C1.54656 13.5641 1.54656 10.4359 3.36033 8.48978ZM8.63241 9.85336C7.57199 8.71555 5.88385 8.71555 4.82343 9.85336C3.72552 11.0314 3.72552 12.9686 4.82343 14.1466C5.88385 15.2845 7.57199 15.2845 8.63241 14.1466L10.633 12L8.63241 9.85336Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    infinity: {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","unlimited","limitless","always","continuous","repeat","recurring","loyalty-program","subscription","unlimited-items","frequent","endless","eternal","repeat-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12L9.36396 9.17157C7.90812 7.60948 5.54773 7.60948 4.09188 9.17157C2.63604 10.7337 2.63604 13.2663 4.09188 14.8284C5.54773 16.3905 7.90812 16.3905 9.36396 14.8284L12 12ZM12 12L14.636 14.8284C16.0919 16.3905 18.4523 16.3905 19.9081 14.8284C21.364 13.2663 21.364 10.7337 19.9081 9.17157C18.4523 7.60948 16.0919 7.60948 14.636 9.17157L12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "info 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["info","information","details","about","help","support","faq","question","more-info","instructions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 14.5714L12 11L11 11M12 16L11 16M12 16L13 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "info 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","question","about","more-info","description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM11 9C11 9.55228 11.4477 10 12 10C12.5523 10 13 9.55228 13 9V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V9ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15L13 12C13 11.4477 12.5523 11 12 11H11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "info 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","faq","about","more-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 14.5714L12 11L11 11M12 16L11 16M12 16L13 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "info 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["info","information","details","help","support","about","more-info","question","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12M12 10L12 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "info 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["info","information","details","help","support","about","question","more-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12M12 10L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "info 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","about","description","more-info","item-details","product-information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.485 19.9915 16.7364 18.364 18.364C16.7364 19.9915 14.485 21 12 21C7.02944 21 3 16.9706 3 12ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16L13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12L11 16ZM11 9C11 9.55229 11.4477 10 12 10C12.5523 10 13 9.55228 13 9V8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44772 11 8L11 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "info 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","about","question","question-mark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 12M12 10L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "info-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["info","information","details","help","support","more-info","about","description","explain","question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "info-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","question","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.2089 19.1035 16.2102 17.6569 17.6569C16.2102 19.1035 14.2089 20 12 20C7.58172 20 4 16.4183 4 12ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V9ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13C13 12.4477 12.5523 12 12 12H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "info-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["info","information","details","help","support","about","more-info","question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    info: {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","about","more-info","question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "input-method-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["A","input","keyboard","text","alphanumeric","search","filter","sort","discount","edit","apply","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15L12 9L9 15M14 13L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "input-method-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["input","keyboard","alphabet","A","text","search","find","filter","query","sort","arrange","group","customer","account","data","information","lookup","settings","admin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15L12 9L9 15M14 13L10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "input-method-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["A","text","input","alphabetical","keyboard","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0002 11.2361L12.3822 12H11.6183L12.0002 11.2361Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM12.8946 8.55279C12.7253 8.214 12.379 8 12.0002 8C11.6214 8 11.2752 8.214 11.1058 8.55279L9.11478 12.5348C9.10831 12.5471 9.10208 12.5596 9.09611 12.5722L8.10579 14.5528C7.8588 15.0468 8.05903 15.6474 8.55301 15.8944C9.04698 16.1414 9.64766 15.9412 9.89465 15.4472L10.6183 14H13.3822L14.1058 15.4472C14.3528 15.9412 14.9535 16.1414 15.4474 15.8944C15.9414 15.6474 16.1416 15.0468 15.8946 14.5528L14.9044 12.5722C14.8984 12.5596 14.8921 12.5471 14.8856 12.5347L12.8946 8.55279Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "input-method": {
        defaultColors: ["#3D4C66"],
        keywords: ["input","alpha","alphabet","keyboard","input-method","text","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 15L12 9L9 15M14 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "instagram-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["social-media","instagram","share","promote","marketing","network","profile","online","customer-engagement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "instagram-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["circle","rounded-square","button","record","profile","account","placeholder","settings","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "instagram-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["social-media","instagram","share","connect","marketing","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57536 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57535 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4246 3.99997 13.0706 4ZM12 7.25C9.37665 7.25 7.25 9.37665 7.25 12C7.25 14.6234 9.37665 16.75 12 16.75C14.6234 16.75 16.75 14.6234 16.75 12C16.75 9.37665 14.6234 7.25 12 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    instagram: {
        defaultColors: ["#3D4C66"],
        keywords: ["social-media","instagram","share","connect","marketing","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 6.77772C19 7.78661 19 9.19108 19 12C19 14.8089 19 16.2134 18.3259 17.2223C18.034 17.659 17.659 18.034 17.2223 18.3259C16.2134 19 14.8089 19 12 19C9.19108 19 7.78661 19 6.77772 18.3259C6.34096 18.034 5.96596 17.659 5.67412 17.2223C5 16.2134 5 14.8089 5 12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5C14.8089 5 16.2134 5 17.2223 5.67412C17.659 5.96596 18.034 6.34096 18.3259 6.77772Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "intersect-circle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["intersect","circle","circles","overlap","overlapping","relationship","association","relation","connectivity","link","group","combine","merge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C11.2386 9 9 11.2386 9 14C9 16.7614 11.2386 19 14 19C16.7614 19 19 16.7614 19 14C19 11.2386 16.7614 9 14 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "intersect-circle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["intersect","overlap","combination","group","merge","union","circles","intersect-circle-2","overlay","layers","options","settings","configurations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C11.2386 9 9 11.2386 9 14C9 16.7614 11.2386 19 14 19C16.7614 19 19 16.7614 19 14C19 11.2386 16.7614 9 14 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "intersect-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["intersect","overlap","circles","relations","dependencies","connections","link","bond"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10C6 7.79086 7.79086 6 10 6C11.0722 6 12.046 6.4219 12.7642 7.10875C13.1653 7.03729 13.5783 7 14 7C14.4306 7 14.8521 7.03888 15.2612 7.11332C14.2409 5.25761 12.2673 4 10 4C6.68629 4 4 6.68629 4 10C4 12.2673 5.25761 14.2409 7.11332 15.2612C7.03888 14.8521 7 14.4306 7 14C7 13.5783 7.03729 13.1653 7.10875 12.7642C6.4219 12.046 6 11.0722 6 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0026 13.8733C11.0009 13.9153 11 13.9576 11 14C11 14.6696 11.2193 15.2879 11.5901 15.787C13.6257 15.229 15.229 13.6257 15.787 11.5901C15.2879 11.2193 14.6696 11 14 11C13.9576 11 13.9153 11.0009 13.8733 11.0026C13.5111 12.4061 12.4061 13.5111 11.0026 13.8733Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 10C11.7909 10 10 11.7909 10 14C10 16.2091 11.7909 18 14 18C16.2091 18 18 16.2091 18 14C18 11.7909 16.2091 10 14 10ZM8 14C8 10.6863 10.6863 8 14 8C17.3137 8 20 10.6863 20 14C20 17.3137 17.3137 20 14 20C10.6863 20 8 17.3137 8 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "intersect-circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["intersect","intersecting","overlap","overlapping","circles","linked","link","merge","combined","association","relation","relationship","union","integration","connectivity","connection","intersect-circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9C11.2386 9 9 11.2386 9 14C9 16.7614 11.2386 19 14 19C16.7614 19 19 16.7614 19 14C19 11.2386 16.7614 9 14 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "intersect-square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["overlay","intersection","overlap","stack","group","layer","combine","merge","association","relation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 14.5981C7.19615 15 8.13077 15 10 15C11.8692 15 12.8038 15 13.5 14.5981C13.9561 14.3348 14.3348 13.9561 14.5981 13.5C15 12.8038 15 11.8692 15 10C15 8.13077 15 7.19615 14.5981 6.5C14.3348 6.04394 13.9561 5.66523 13.5 5.40192C12.8038 5 11.8692 5 10 5C8.13077 5 7.19615 5 6.5 5.40192C6.04394 5.66523 5.66523 6.04394 5.40192 6.5C5 7.19615 5 8.13077 5 10C5 11.8692 5 12.8038 5.40192 13.5C5.66523 13.9561 6.04394 14.3348 6.5 14.5981Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 18.5981C11.1962 19 12.1308 19 14 19C15.8692 19 16.8038 19 17.5 18.5981C17.9561 18.3348 18.3348 17.9561 18.5981 17.5C19 16.8038 19 15.8692 19 14C19 12.1308 19 11.1962 18.5981 10.5C18.3348 10.0439 17.9561 9.66523 17.5 9.40192C16.8038 9 15.8692 9 14 9C12.1308 9 11.1962 9 10.5 9.40192C10.0439 9.66523 9.66523 10.0439 9.40192 10.5C9 11.1962 9 12.1308 9 14C9 15.8692 9 16.8038 9.40192 17.5C9.66523 17.9561 10.0439 18.3348 10.5 18.5981Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "intersect-square-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["square","intersect","overlap","group","combine","merge","collection","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 14.5981C7.19615 15 8.13077 15 10 15C11.8692 15 12.8038 15 13.5 14.5981C13.9561 14.3348 14.3348 13.9561 14.5981 13.5C15 12.8038 15 11.8692 15 10C15 8.13077 15 7.19615 14.5981 6.5C14.3348 6.04394 13.9561 5.66523 13.5 5.40192C12.8038 5 11.8692 5 10 5C8.13077 5 7.19615 5 6.5 5.40192C6.04394 5.66523 5.66523 6.04394 5.40192 6.5C5 7.19615 5 8.13077 5 10C5 11.8692 5 12.8038 5.40192 13.5C5.66523 13.9561 6.04394 14.3348 6.5 14.5981Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 18.5981C11.1962 19 12.1308 19 14 19C15.8692 19 16.8038 19 17.5 18.5981C17.9561 18.3348 18.3348 17.9561 18.5981 17.5C19 16.8038 19 15.8692 19 14C19 12.1308 19 11.1962 18.5981 10.5C18.3348 10.0439 17.9561 9.66523 17.5 9.40192C16.8038 9 15.8692 9 14 9C12.1308 9 11.1962 9 10.5 9.40192C10.0439 9.66523 9.66523 10.0439 9.40192 10.5C9 11.1962 9 12.1308 9 14C9 15.8692 9 16.8038 9.40192 17.5C9.66523 17.9561 10.0439 18.3348 10.5 18.5981Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "intersect-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["duplicate","copy","clone","intersect","square","duplicate-item","copy-item","clone-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.046 4H9.95396C9.0585 3.99999 8.31952 3.99997 7.71983 4.05432C7.09615 4.11085 6.52564 4.23242 6 4.5359C5.39192 4.88697 4.88697 5.39192 4.5359 6C4.23242 6.52564 4.11085 7.09615 4.05432 7.71983C3.99997 8.31952 3.99999 9.05848 4 9.95394V10.046C3.99999 10.9415 3.99997 11.6805 4.05432 12.2802C4.11085 12.9039 4.23242 13.4744 4.5359 14C4.88697 14.6081 5.39192 15.113 6 15.4641C6.32362 15.6509 6.66425 15.7688 7.02382 15.845C6.99992 15.3173 6.99996 14.7228 7 14.0805V13.9196C7 13.8566 7 13.7941 7.00001 13.7321C7.00001 13.7321 7.00002 13.7321 7.00001 13.7321C6.69598 13.5565 6.44349 13.304 6.26795 13C6.16951 12.8295 6.09011 12.5846 6.04616 12.0996C6.00096 11.6009 6 10.953 6 10C6 9.04698 6.00096 8.39908 6.04616 7.90036C6.09011 7.41539 6.16951 7.17051 6.26795 7C6.44349 6.69596 6.69596 6.44349 7 6.26795C7.17051 6.16951 7.41539 6.09011 7.90036 6.04616C8.39908 6.00096 9.04698 6 10 6C10.953 6 11.6009 6.00096 12.0996 6.04616C12.5846 6.09011 12.8295 6.16951 13 6.26795C13.304 6.44349 13.5565 6.69596 13.7321 7C13.732 7 13.7321 7.00001 13.7321 7C13.7941 6.99998 13.8566 7 13.9196 7H14.0805C14.7228 6.99996 15.3173 6.99992 15.845 7.02382C15.7688 6.66425 15.6509 6.32362 15.4641 6C15.113 5.39192 14.6081 4.88697 14 4.5359C13.4744 4.23242 12.9039 4.11085 12.2802 4.05432C11.6805 3.99997 10.9415 3.99999 10.046 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9966 11.0409C15.5548 11.0019 14.9621 11 14 11C13.999 11 13.9979 11 13.9968 11C13.9923 11.4437 13.9811 11.7988 13.9538 12.0996C13.9099 12.5846 13.8305 12.8295 13.7321 13C13.5565 13.304 13.304 13.5565 13 13.7321C12.8295 13.8305 12.5846 13.9099 12.0996 13.9538C11.7988 13.9811 11.4437 13.9923 11 13.9968C11 13.9979 11 13.999 11 14C11 14.9621 11.0019 15.5548 11.0409 15.9966C11.5071 15.9914 11.9189 15.9784 12.2802 15.9457C12.9039 15.8892 13.4744 15.7676 14 15.4641C14.6081 15.113 15.113 14.6081 15.4641 14C15.7676 13.4744 15.8892 12.9039 15.9457 12.2802C15.9784 11.9189 15.9914 11.5071 15.9966 11.0409Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.954 8H14.046C14.9415 7.99998 15.6805 7.99997 16.2802 8.05432C16.9039 8.11085 17.4744 8.23242 18 8.5359C18.6081 8.88697 19.113 9.39192 19.4641 10C19.7676 10.5256 19.8892 11.0961 19.9457 11.7198C20 12.3195 20 13.0585 20 13.9539V14.0461C20 14.9415 20 15.6805 19.9457 16.2802C19.8892 16.9039 19.7676 17.4744 19.4641 18C19.113 18.6081 18.6081 19.113 18 19.4641C17.4744 19.7676 16.9039 19.8892 16.2802 19.9457C15.6805 20 14.9415 20 14.0461 20H13.9539C13.0585 20 12.3195 20 11.7198 19.9457C11.0961 19.8892 10.5256 19.7676 10 19.4641C9.39192 19.113 8.88697 18.6081 8.5359 18C8.23242 17.4744 8.11085 16.9039 8.05432 16.2802C7.99997 15.6805 7.99998 14.9415 8 14.046V13.954C7.99998 13.0585 7.99997 12.3195 8.05432 11.7198C8.11085 11.0961 8.23242 10.5256 8.5359 10C8.88697 9.39192 9.39192 8.88697 10 8.5359C10.5256 8.23242 11.0961 8.11085 11.7198 8.05432C12.3195 7.99997 13.0585 7.99998 13.954 8ZM11.9004 10.0462C11.4154 10.0901 11.1705 10.1695 11 10.2679C10.696 10.4435 10.4435 10.696 10.2679 11C10.1695 11.1705 10.0901 11.4154 10.0462 11.9004C10.001 12.3991 10 13.047 10 14C10 14.953 10.001 15.6009 10.0462 16.0996C10.0901 16.5846 10.1695 16.8295 10.2679 17C10.4435 17.304 10.696 17.5565 11 17.7321C11.1705 17.8305 11.4154 17.9099 11.9004 17.9538C12.3991 17.999 13.047 18 14 18C14.953 18 15.6009 17.999 16.0996 17.9538C16.5846 17.9099 16.8295 17.8305 17 17.7321C17.304 17.5565 17.5565 17.304 17.7321 17C17.8305 16.8295 17.9099 16.5846 17.9538 16.0996C17.999 15.6009 18 14.953 18 14C18 13.047 17.999 12.3991 17.9538 11.9004C17.9099 11.4154 17.8305 11.1705 17.7321 11C17.5565 10.696 17.304 10.4435 17 10.2679C16.8295 10.1695 16.5846 10.0901 16.0996 10.0462C15.6009 10.001 14.953 10 14 10C13.047 10 12.3991 10.001 11.9004 10.0462Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "intersect-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["intersect","overlap","layers","combine","merge","unite","junction","duplicate","compare","relations","relationship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 14.5981C7.19615 15 8.13077 15 10 15C11.8692 15 12.8038 15 13.5 14.5981C13.9561 14.3348 14.3348 13.9561 14.5981 13.5C15 12.8038 15 11.8692 15 10C15 8.13077 15 7.19615 14.5981 6.5C14.3348 6.04394 13.9561 5.66523 13.5 5.40192C12.8038 5 11.8692 5 10 5C8.13077 5 7.19615 5 6.5 5.40192C6.04394 5.66523 5.66523 6.04394 5.40192 6.5C5 7.19615 5 8.13077 5 10C5 11.8692 5 12.8038 5.40192 13.5C5.66523 13.9561 6.04394 14.3348 6.5 14.5981Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 18.5981C11.1962 19 12.1308 19 14 19C15.8692 19 16.8038 19 17.5 18.5981C17.9561 18.3348 18.3348 17.9561 18.5981 17.5C19 16.8038 19 15.8692 19 14C19 12.1308 19 11.1962 18.5981 10.5C18.3348 10.0439 17.9561 9.66523 17.5 9.40192C16.8038 9 15.8692 9 14 9C12.1308 9 11.1962 9 10.5 9.40192C10.0439 9.66523 9.66523 10.0439 9.40192 10.5C9 11.1962 9 12.1308 9 14C9 15.8692 9 16.8038 9.40192 17.5C9.66523 17.9561 10.0439 18.3348 10.5 18.5981Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Iron-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["iron","laundry","clothing","service","cleaning","pressing","dry-cleaning","garment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10L20 16H6L6.33333 15C7.32865 12.014 10.123 10 13.2705 10H19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6H14.8769C16.3768 6 17.1267 6 17.6693 6.42359C18.2118 6.84718 18.3937 7.57474 18.7575 9.02986L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L4 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Iron-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["iron","laundry","service","cleaning","pressing","garment","clothes","repair"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7H13.8769C15.3768 7 16.1267 7 16.6693 7.42359C17.2118 7.84718 17.3937 8.57474 17.7575 10.0299L18 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L19 17H5L6.0883 13.7351C6.52832 12.4151 6.74832 11.755 7.2721 11.3775C7.79587 11 8.49159 11 9.88304 11H18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Iron-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["iron","laundry","cleaning","service","apparel","clothing","care"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7H13.8769C15.3768 7 16.1267 7 16.6693 7.42359C17.2118 7.84718 17.3937 8.57474 17.7575 10.0299L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L19 17H5L6.0883 13.7351C6.52832 12.4151 6.74832 11.755 7.2721 11.3775C7.79587 11 8.49159 11 9.88304 11H18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Iron-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["iron","laundry","cleaning","pressing","garment-care","clothing","dry-cleaning","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5134 8.04588C15.1436 8.00167 14.6512 8 13.8769 8H12C11.4477 8 11 7.55229 11 7C11 6.44772 11.4477 6 12 6L13.9326 6C14.6349 5.99996 15.2482 5.99992 15.7508 6.06003C16.2934 6.12491 16.8165 6.2698 17.2847 6.63539C17.7529 7.00097 18.0203 7.47327 18.2149 7.9839C18.3951 8.45692 18.5438 9.05194 18.7141 9.73328L18.9678 10.7481C18.9722 10.7649 18.9761 10.7818 18.9796 10.7989C18.9828 10.8146 18.9857 10.8303 18.9881 10.846L19.9864 16.8356C20.0347 17.1256 19.953 17.4221 19.763 17.6464C19.573 17.8707 19.294 18 19 18H5.00001C4.67856 18 4.37672 17.8455 4.18877 17.5847C4.00081 17.3239 3.94967 16.9887 4.05132 16.6838L5.1562 13.3691C5.36199 12.7517 5.54236 12.2104 5.74211 11.7811C5.95805 11.3169 6.23619 10.8915 6.68739 10.5663C7.1386 10.2411 7.63012 10.1117 8.13877 10.0536C8.60928 9.99993 9.17976 9.99996 9.83063 10L16.7191 10C16.5687 9.40244 16.4617 8.99984 16.3459 8.69591C16.2229 8.37308 16.1281 8.2698 16.0539 8.2118C15.9796 8.1538 15.8564 8.0869 15.5134 8.04588Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Iron-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["iron","laundry","cleaning","service","apparel","clothing","pressing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L19 17H5L6.0883 13.7351C6.52832 12.4151 6.74832 11.755 7.2721 11.3775C7.79587 11 8.49159 11 9.88304 11H18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7H13.8769C15.3768 7 16.1267 7 16.6693 7.42359C17.2118 7.84718 17.3937 8.57474 17.7575 10.0299L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Iron-21": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["iron","laundry","service","cleaning","dry-cleaning","pressing","garment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H14.8769C16.3768 6 17.1267 6 17.6693 6.42359C18.2118 6.84718 18.3937 7.57474 18.7575 9.02986L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 18L4 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 9L20 15H6L6.33333 14C7.32865 11.014 10.123 9 13.2705 9H19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Iron-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["iron","laundry","clothing","fabric","cleaning","garment","service","alterations","pressing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 18C3 17.45 3.45 17 4 17H20C20.55 17 21 17.45 21 18C21 18.55 20.55 19 20 19H4C3.45 19 3 18.55 3 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.96 8.76002C19.97 8.79002 19.99 8.84002 19.99 8.84002V8.87002L20.99 14.87C21.04 15.16 20.96 15.46 20.77 15.68C20.58 15.9 20.3 16.03 20.01 16.03H6.01002C5.69002 16.03 5.39002 15.87 5.20002 15.61C5.01002 15.35 4.96002 15.01 5.06002 14.71L5.39002 13.71C6.53002 10.32 9.70002 8.03002 13.28 8.03002H17.61C17.56 7.89002 17.51 7.76002 17.46 7.65002C17.33 7.36002 17.23 7.26002 17.16 7.21002C17.09 7.16002 16.97 7.10002 16.65 7.06002C16.3 7.02002 15.85 7.02002 15.13 7.02002H13.01C12.46 7.02002 12.01 6.57002 12.01 6.02002C12.01 5.47002 12.46 5.02002 13.01 5.02002H15.18C15.83 5.02002 16.4 5.02002 16.87 5.07002C17.38 5.13002 17.87 5.25002 18.32 5.58002C18.78 5.90002 19.05 6.33002 19.27 6.79002C19.4603 7.19914 19.6325 7.70785 19.8296 8.29029C19.8397 8.32001 19.8498 8.34992 19.86 8.38002L19.96 8.69002V8.76002ZM16 10C15.45 10 15 10.45 15 11C15 11.55 15.45 12 16 12H17C17.55 12 18 11.55 18 11C18 10.45 17.55 10 17 10H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Iron: {
        defaultColors: ["#3D4C66"],
        keywords: ["iron","laundry","clothing","fabric","cleaning","garment","service","alterations","pressing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10L20 16H6L6.33333 15C7.32865 12.014 10.123 10 13.2705 10H19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 6H14.8769C16.3768 6 17.1267 6 17.6693 6.42359C18.2118 6.84718 18.3937 7.57474 18.7575 9.02986L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "iso-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["iso","settings","configurations","options","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H10C9.44772 10 9 10.4477 9 11V11C9 11.5523 9.44772 12 10 12V12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "iso-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ISO","standard","compliance","validation","certification","regulation","quality","assurance","security","verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H10C9.44772 10 9 10.4477 9 11V11C9 11.5523 9.44772 12 10 12V12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "iso-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["iso","standard","settings","configuration","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.92943 4H15.0706C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82769 21.7565 6.64711 21.8813 7.57494C22.0001 8.4587 22 9.57533 22 10.9294V13.0706C22 14.4247 22.0001 15.5413 21.8813 16.4251C21.7565 17.3529 21.4845 18.1723 20.8284 18.8284C20.1723 19.4845 19.3529 19.7565 18.4251 19.8813C17.5413 20.0001 16.4247 20 15.0706 20H8.92935C7.57527 20 6.45868 20.0001 5.57494 19.8813C4.64711 19.7565 3.82769 19.4845 3.17158 18.8284C2.51547 18.1723 2.2435 17.3529 2.11876 16.4251C1.99994 15.5413 1.99997 14.4247 2 13.0706V10.9294C1.99997 9.57531 1.99994 8.45868 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45868 3.99994 7.57535 3.99997 8.92943 4ZM7 10C7 9.44772 6.55229 9 6 9C5.44772 9 5 9.44772 5 10V14C5 14.5523 5.44772 15 6 15C6.55229 15 7 14.5523 7 14V10ZM10 9C8.89543 9 8 9.89543 8 11C8 12.1046 8.89543 13 10 13H9C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15H10C11.1046 15 12 14.1046 12 13C12 11.8954 11.1046 11 10 11H11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9H10ZM16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    iso: {
        defaultColors: ["#3D4C66"],
        keywords: ["iso","standard","settings","configuration","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H10C9.44772 10 9 10.4477 9 11V11C9 11.5523 9.44772 12 10 12V12C10.5523 12 11 12.4477 11 13V13C11 13.5523 10.5523 14 10 14H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "italic-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["italic","text","font","formatting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 7L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17H12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "italic-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["italic","text-formatting","font","style","oblique"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 7L10 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17H12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "italic-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["italic","text","format","font","style","edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6H14.0312C14.0104 5.99935 13.9896 5.99935 13.9689 6H12C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8H12.5226L9.32265 16H8C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H9.99011C9.99635 18.0001 10.0026 18.0001 10.0088 18H12C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16H11.4767L14.6767 8H16C16.5523 8 17 7.55228 17 7C17 6.44772 16.5523 6 16 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    italic: {
        defaultColors: ["#3D4C66"],
        keywords: ["italic","text","format","font","style","edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 7L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 17H12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IV-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["four","iv","number","item-number","quantity","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L14 17L10 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IV-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["iv","roman-numerals","number-4","table","group","group-size","order-size","seat-number","four"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L14 17L10 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IV-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["IV","four","quantity","item-count","number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7.00027C3 6.44798 3.44772 6.00027 4 6.00027H6C6.55228 6.00027 7 6.44798 7 7.00027C7 7.55255 6.55228 8.00027 6 8.00027V16.0003C6.55228 16.0003 7 16.448 7 17.0003C7 17.5526 6.55228 18.0003 6 18.0003H4C3.44772 18.0003 3 17.5526 3 17.0003C3 16.448 3.44772 16.0003 4 16.0003V8.00027C3.44772 8.00027 3 7.55255 3 7.00027Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.4369 7.90001C12.7703 7.73784 13 7.39588 13 7.00027C13 6.44798 12.5523 6.00027 12 6.00027H11.0227C11.0074 5.99991 10.9921 5.99991 10.9767 6.00027H10C9.44772 6.00027 9 6.44798 9 7.00027C9 7.55255 9.44772 8.00027 10 8.00027H10.323L14.0715 17.3717C14.2234 17.7513 14.5911 18.0003 15 18.0003C15.4089 18.0003 15.7766 17.7513 15.9285 17.3717L19.677 8.00027H20C20.5523 8.00027 21 7.55255 21 7.00027C21 6.44798 20.5523 6.00027 20 6.00027H19.0233C19.0079 5.99991 18.9926 5.99991 18.9773 6.00027H18C17.4477 6.00027 17 6.44798 17 7.00027C17 7.39588 17.2297 7.73784 17.5631 7.90001L15 14.3077L12.4369 7.90001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    IV: {
        defaultColors: ["#3D4C66"],
        keywords: ["IV","four","quantity","item-count","number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L14 17L10 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IX-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["IX","9","roman-numerals","discount-code","number-nine","item-number","section-nine","ninth-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 7L14 12M14 12L10 7M14 12L10 17M14 12L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L11 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IX-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["IX","roman numeral","nine","9","discount","amount off","percentage off","quantity","item number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 7L14 12M14 12L10 7M14 12L10 17M14 12L18 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L11 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "IX-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["IX","9","roman-numerals","version-9","ninth","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C12 7.23651 11.9179 7.45384 11.7806 7.62504L14 10.3993L16.2194 7.62505C16.0821 7.45384 16 7.23651 16 7C16 6.44772 16.4477 6 17 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H18.4807L15.2806 12L18.4806 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H18.0127C18.0047 18.0001 17.9966 18.0001 17.9885 18H17C16.4477 18 16 17.5523 16 17C16 16.7635 16.0821 16.5462 16.2193 16.375L14 13.6008L11.7807 16.375C11.9179 16.5462 12 16.7635 12 17C12 17.5523 11.5523 18 11 18H10.0116H9.98719H9C8.44772 18 8 17.5523 8 17C8 16.4477 8.44772 16 9 16H9.51941L12.7194 12L9.51935 8H9C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6H9.99926H9.99948H11C11.5523 6 12 6.44772 12 7ZM7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8V16C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18H6H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16V8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H6H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    IX: {
        defaultColors: ["#3D4C66"],
        keywords: ["IX","9","roman-numerals","version-9","ninth","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 7L14 12M14 12L10 7M14 12L10 17M14 12L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L11 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L11 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "J-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["J","hook","item","product","hold","suspend","hang"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "J-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["letter-j","j","initial","keyboard","input","jumpto","jump-to","lookup","search","transaction","customer","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "J-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-j","j","alphabet","initial","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C16.5523 4 17 4.44771 17 5L17 15C17 17.7614 14.7614 20 12 20C9.23857 20 7 17.7614 7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15C9 16.6569 10.3431 18 12 18C13.6569 18 15 16.6569 15 15L15 5C15 4.44772 15.4477 4 16 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    J: {
        defaultColors: ["#3D4C66"],
        keywords: ["letter-j","j","alphabet","initial","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Js-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["javascript","js","programming","script","settings","configuration","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15H9C9.55228 15 10 14.5523 10 14V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9H14.5C13.6716 9 13 9.67157 13 10.5V10.5C13 11.3284 13.6716 12 14.5 12V12C15.3284 12 16 12.6716 16 13.5V13.5C16 14.3284 15.3284 15 14.5 15H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Js-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["JS","JavaScript","settings","configuration","preferences","options","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15H9C9.55228 15 10 14.5523 10 14V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9H14.5C13.6716 9 13 9.67157 13 10.5V10.5C13 11.3284 13.6716 12 14.5 12V12C15.3284 12 16 12.6716 16 13.5V13.5C16 14.3284 15.3284 15 14.5 15H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Js-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["JS","JavaScript","programming","scripting","development","software","technology"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 3.25H14.0549C15.4225 3.24998 16.5248 3.24997 17.3918 3.36653C18.2919 3.48754 19.0497 3.74644 19.6517 4.34835C20.2536 4.95027 20.5125 5.70814 20.6335 6.60825C20.75 7.47522 20.75 8.57754 20.75 9.94513V14.0549C20.75 15.4225 20.75 16.5248 20.6335 17.3918C20.5125 18.2919 20.2536 19.0497 19.6517 19.6517C19.0497 20.2536 18.2919 20.5125 17.3918 20.6335C16.5248 20.75 15.4225 20.75 14.0549 20.75H9.94513C8.57754 20.75 7.47522 20.75 6.60825 20.6335C5.70814 20.5125 4.95027 20.2536 4.34835 19.6517C3.74644 19.0497 3.48754 18.2919 3.36653 17.3918C3.24997 16.5248 3.24998 15.4225 3.25 14.0549V9.94513C3.24998 8.57755 3.24997 7.47521 3.36653 6.60825C3.48754 5.70814 3.74644 4.95027 4.34835 4.34835C4.95027 3.74644 5.70814 3.48754 6.60825 3.36653C7.47521 3.24997 8.57755 3.24998 9.94513 3.25ZM10.75 9C10.75 8.58579 10.4142 8.25 10 8.25C9.58579 8.25 9.25 8.58579 9.25 9V14C9.25 14.1381 9.13807 14.25 9 14.25H7C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H9C9.9665 15.75 10.75 14.9665 10.75 14V9ZM13.75 10.5C13.75 10.0858 14.0858 9.75 14.5 9.75H16C16.4142 9.75 16.75 9.41421 16.75 9C16.75 8.58579 16.4142 8.25 16 8.25H14.5C13.2574 8.25 12.25 9.25736 12.25 10.5C12.25 11.7426 13.2574 12.75 14.5 12.75C14.9142 12.75 15.25 13.0858 15.25 13.5C15.25 13.9142 14.9142 14.25 14.5 14.25H13C12.5858 14.25 12.25 14.5858 12.25 15C12.25 15.4142 12.5858 15.75 13 15.75H14.5C15.7426 15.75 16.75 14.7426 16.75 13.5C16.75 12.2574 15.7426 11.25 14.5 11.25C14.0858 11.25 13.75 10.9142 13.75 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Js: {
        defaultColors: ["#3D4C66"],
        keywords: ["JS","JavaScript","programming","scripting","development","software","technology"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15H9C9.55228 15 10 14.5523 10 14V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9H14.5C13.6716 9 13 9.67157 13 10.5V10.5C13 11.3284 13.6716 12 14.5 12V12C15.3284 12 16 12.6716 16 13.5V13.5C16 14.3284 15.3284 15 14.5 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "jukebox-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["jukebox","music","audio","entertainment","settings","configuration","sound","equalizer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 9V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H13C14.8856 5 15.8284 5 16.4142 5.58579C17 6.17157 17 7.11438 17 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14C7 15.1046 7.89543 16 9 16C9.55228 16 10.0523 15.7761 10.4142 15.4142C10.7761 15.0523 11 14.5523 11 14C11 12.8954 10.1046 12 9 12C7.89543 12 7 12.8954 7 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14H14M17 16H15M17 12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "jukebox-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["music","entertainment","radio","jukebox","sound","audio","menu","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 9V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H13C14.8856 5 15.8284 5 16.4142 5.58579C17 6.17157 17 7.11438 17 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14C7 15.1046 7.89543 16 9 16C9.55228 16 10.0523 15.7761 10.4142 15.4142C10.7761 15.0523 11 14.5523 11 14C11 12.8954 10.1046 12 9 12C7.89543 12 7 12.8954 7 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14H14M17 16H15M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "jukebox-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["jukebox","music","audio","settings","configuration","entertainment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0658 4H10.9342C10.0477 3.99995 9.28387 3.99991 8.67221 4.08215C8.0167 4.17028 7.38835 4.36902 6.87868 4.87868C6.36902 5.38835 6.17028 6.0167 6.08215 6.67221C6.02881 7.06895 6.01008 7.52969 6.00352 8.0464C5.88862 8.05613 5.77814 8.0679 5.67221 8.08215C5.0167 8.17028 4.38835 8.36902 3.87868 8.87868C3.36902 9.38835 3.17028 10.0167 3.08215 10.6722C2.99991 11.2839 2.99995 12.0477 3 12.9342V15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20H16.0658C16.9523 20.0001 17.7161 20.0001 18.3278 19.9179C18.9833 19.8297 19.6117 19.631 20.1213 19.1213C20.631 18.6117 20.8297 17.9833 20.9179 17.3278C21.0001 16.7161 21.0001 15.9523 21 15.0658V12.9342C21.0001 12.0477 21.0001 11.2839 20.9179 10.6722C20.8297 10.0167 20.631 9.38835 20.1213 8.87868C19.6117 8.36902 18.9833 8.17028 18.3278 8.08215C18.2219 8.0679 18.1114 8.05613 17.9965 8.0464C17.9899 7.52969 17.9712 7.06895 17.9179 6.67221C17.8297 6.0167 17.631 5.38835 17.1213 4.87868C16.6117 4.36902 15.9833 4.17028 15.3278 4.08215C14.7161 3.99991 13.9523 3.99995 13.0658 4ZM15.9955 8H8.00455C8.01103 7.55932 8.02666 7.21873 8.06431 6.93871C8.12263 6.50497 8.21677 6.36902 8.2929 6.2929C8.36902 6.21677 8.50497 6.12263 8.93871 6.06431C9.40122 6.00213 10.0289 6 11 6H13C13.9711 6 14.5988 6.00213 15.0613 6.06431C15.495 6.12263 15.631 6.21677 15.7071 6.2929C15.7832 6.36902 15.8774 6.50497 15.9357 6.93871C15.9733 7.21873 15.989 7.55932 15.9955 8ZM6.5 14C6.5 12.6193 7.61929 11.5 9 11.5C10.3807 11.5 11.5 12.6193 11.5 14C11.5 14.6901 11.2191 15.3165 10.7678 15.7678C10.3165 16.2191 9.69008 16.5 9 16.5C7.61929 16.5 6.5 15.3807 6.5 14ZM17 12C17.4142 12 17.75 12.3358 17.75 12.75C17.75 13.1642 17.4142 13.5 17 13.5H14C13.5858 13.5 13.25 13.1642 13.25 12.75C13.25 12.3358 13.5858 12 14 12H17ZM17 14.5C17.4142 14.5 17.75 14.8358 17.75 15.25C17.75 15.6642 17.4142 16 17 16H15C14.5858 16 14.25 15.6642 14.25 15.25C14.25 14.8358 14.5858 14.5 15 14.5H17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    jukebox: {
        defaultColors: ["#3D4C66"],
        keywords: ["jukebox","music","audio","settings","configuration","entertainment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H16C17.8856 9 18.8284 9 19.4142 9.58579C20 10.1716 20 11.1144 20 13V15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 9V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H13C14.8856 5 15.8284 5 16.4142 5.58579C17 6.17157 17 7.11438 17 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 14C7 15.1046 7.89543 16 9 16C9.55228 16 10.0523 15.7761 10.4142 15.4142C10.7761 15.0523 11 14.5523 11 14C11 12.8954 10.1046 12 9 12C7.89543 12 7 12.8954 7 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14H14M17 16H15M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "K-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["K","keyboard-shortcut","shortcut","key","label","identifier","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 19C8.75 19.4142 8.41421 19.75 8 19.75C7.58579 19.75 7.25 19.4142 7.25 19H8.75ZM7.25 5C7.25 4.58579 7.58579 4.25 8 4.25C8.41421 4.25 8.75 4.58579 8.75 5H7.25ZM15.4143 4.53148C15.6731 4.20803 16.1451 4.15559 16.4685 4.41435C16.792 4.67311 16.8444 5.14507 16.5857 5.46852L15.4143 4.53148ZM16.6163 18.5727C16.8524 18.9131 16.7677 19.3803 16.4273 19.6163C16.0869 19.8524 15.6197 19.7677 15.3837 19.4273L16.6163 18.5727ZM10.8 11.5L10.2143 11.0315L10.843 10.2457L11.4163 11.0727L10.8 11.5ZM7.25 19V15H8.75V19H7.25ZM7.25 15V5H8.75V15H7.25ZM7.41435 14.5315L15.4143 4.53148L16.5857 5.46852L8.58565 15.4685L7.41435 14.5315ZM7.41435 14.5315L10.2143 11.0315L11.3857 11.9685L8.58565 15.4685L7.41435 14.5315ZM11.4163 11.0727L16.6163 18.5727L15.3837 19.4273L10.1837 11.9273L11.4163 11.0727Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "K-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["K","keyboard","key","knowledge","cashier","button","pos","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 19C8.75 19.4142 8.41421 19.75 8 19.75C7.58579 19.75 7.25 19.4142 7.25 19H8.75ZM7.25 5C7.25 4.58579 7.58579 4.25 8 4.25C8.41421 4.25 8.75 4.58579 8.75 5H7.25ZM15.4143 4.53148C15.6731 4.20803 16.1451 4.15559 16.4685 4.41435C16.792 4.67311 16.8444 5.14507 16.5857 5.46852L15.4143 4.53148ZM16.6163 18.5727C16.8524 18.9131 16.7677 19.3803 16.4273 19.6163C16.0869 19.8524 15.6197 19.7677 15.3837 19.4273L16.6163 18.5727ZM10.8 11.5L10.2143 11.0315L10.843 10.2457L11.4163 11.0727L10.8 11.5ZM7.25 19V15H8.75V19H7.25ZM7.25 15V5H8.75V15H7.25ZM7.41435 14.5315L15.4143 4.53148L16.5857 5.46852L8.58565 15.4685L7.41435 14.5315ZM7.41435 14.5315L10.2143 11.0315L11.3857 11.9685L8.58565 15.4685L7.41435 14.5315ZM11.4163 11.0727L16.6163 18.5727L15.3837 19.4273L10.1837 11.9273L11.4163 11.0727Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "K-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["K","keyboard","key","discount","coupon","code","keyboard-shortcut","shortcut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6246 4.21917C16.1933 3.87416 15.5641 3.94408 15.219 4.37534L8.99991 12.1493V5.00004C8.99991 4.44775 8.55219 4.00004 7.99991 4.00004C7.44763 4.00004 6.99991 4.44775 6.99991 5.00004V19C6.99991 19.5523 7.44763 20 7.99991 20C8.55219 20 8.99991 19.5523 8.99991 19V15.3508L10.7426 13.1724L15.1781 19.5698C15.4928 20.0237 16.1158 20.1365 16.5697 19.8218C17.0236 19.5072 17.1364 18.8841 16.8217 18.4303L12.0464 11.5427L16.7808 5.62473C17.1258 5.19347 17.0559 4.56418 16.6246 4.21917Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    K: {
        defaultColors: ["#3D4C66"],
        keywords: ["K","keyboard","key","discount","coupon","code","keyboard-shortcut","shortcut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 19C8.75 19.4142 8.41421 19.75 8 19.75C7.58579 19.75 7.25 19.4142 7.25 19H8.75ZM7.25 5C7.25 4.58579 7.58579 4.25 8 4.25C8.41421 4.25 8.75 4.58579 8.75 5H7.25ZM15.4143 4.53148C15.6731 4.20803 16.1451 4.15559 16.4685 4.41435C16.792 4.67311 16.8444 5.14507 16.5857 5.46852L15.4143 4.53148ZM16.6163 18.5727C16.8524 18.9131 16.7677 19.3803 16.4273 19.6163C16.0869 19.8524 15.6197 19.7677 15.3837 19.4273L16.6163 18.5727ZM10.8 11.5L10.2143 11.0315L10.843 10.2457L11.4163 11.0727L10.8 11.5ZM7.25 19V15H8.75V19H7.25ZM7.25 15V5H8.75V15H7.25ZM7.41435 14.5315L15.4143 4.53148L16.5857 5.46852L8.58565 15.4685L7.41435 14.5315ZM7.41435 14.5315L10.2143 11.0315L11.3857 11.9685L8.58565 15.4685L7.41435 14.5315ZM11.4163 11.0727L16.6163 18.5727L15.3837 19.4273L10.1837 11.9273L11.4163 11.0727Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Kanban: {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["K","keyboard","key","discount","coupon","code","keyboard-shortcut","shortcut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_48465)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.418 6.00008H6.582C6.16587 5.99508 5.76541 6.22907 5.46873 6.65056C5.17204 7.07206 5.00343 7.64654 5 8.24761V16.7538C5.0077 18.0049 5.71584 19.0103 6.582 18.9999H9.418C9.83413 19.0049 10.2346 18.7709 10.5313 18.3494C10.828 17.9279 10.9966 17.3535 11 16.7524V8.24761C10.9966 7.64654 10.828 7.07206 10.5313 6.65056C10.2346 6.22907 9.83413 5.99508 9.418 6.00008Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.582 18.9999H17.417C17.8333 19.0053 18.234 18.7715 18.5309 18.3499C18.8278 17.9284 18.9966 17.3537 19 16.7524V8.2476C18.9966 7.64654 18.828 7.07206 18.5313 6.65056C18.2346 6.22907 17.8341 5.99508 17.418 6.00008H14.582C14.1659 5.99508 13.7654 6.22907 13.4687 6.65056C13.172 7.07206 13.0034 7.64654 13 8.2476V16.7524C13.0034 17.3534 13.172 17.9279 13.4687 18.3494C13.7654 18.7709 14.1659 19.0049 14.582 18.9999Z"
                        stroke={colors?.[0] || "#3D4C66"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <line x1="7" y1="9.5" x2="9" y2="9.5" stroke={colors?.[0] || "#3D4C66"} />
                    <line x1="7" y1="11.5" x2="9" y2="11.5" stroke={colors?.[0] || "#3D4C66"} />
                    <line x1="7" y1="13.5" x2="9" y2="13.5" stroke={colors?.[0] || "#3D4C66"} />
                    <line x1="15" y1="9.5" x2="17" y2="9.5" stroke={colors?.[0] || "#3D4C66"} />
                    <line x1="15" y1="11.5" x2="17" y2="11.5" stroke={colors?.[0] || "#3D4C66"} />
                    <line x1="15" y1="13.5" x2="17" y2="13.5" stroke={colors?.[0] || "#3D4C66"} />
                </g>
                <defs>
                    <clipPath id="clip0_1_48465">
                        <rect width="24" height="24" fill={colors?.[1] || "#FFFFFF"} />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Key-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["key","authentication","security","minus","revoke","remove-access","delete-key","authorization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00488 12V15M5.00488 12V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H3"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8C14.7909 8 13 9.79086 13 12C13 14.2091 14.7909 16 17 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Key-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["key","security","access","lock","password","permissions","admin","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V13C6 13.9428 6 14.4142 6.29289 14.7071C6.29289 14.7071 6.29289 14.7071 6.29289 14.7071C6.58579 15 7.05719 15 8 15V15C8.94281 15 9.41421 15 9.70711 14.7071C9.70711 14.7071 9.70711 14.7071 9.70711 14.7071C10 14.4142 10 13.9428 10 13V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L4 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Key-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trumpet","promotion","notification","alert","announcement","special-offer","deal","event","marketing","attention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V13C6 13.9428 6 14.4142 6.29289 14.7071C6.29289 14.7071 6.29289 14.7071 6.29289 14.7071C6.58579 15 7.05719 15 8 15V15C8.94281 15 9.41421 15 9.70711 14.7071C9.70711 14.7071 9.70711 14.7071 9.70711 14.7071C10 14.4142 10 13.9428 10 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 12L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Key-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["key","security","access","authentication","authorization","permissions","admin","settings","lock","unlock","password","encryption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.126 11C13.5701 9.27477 15.1362 8 17 8C19.2091 8 21 9.79086 21 12C21 14.2091 19.2091 16 17 16C15.1362 16 13.5701 14.7252 13.126 13L11 13L11 13.0544C11.0001 13.4785 11.0002 13.8906 10.9545 14.2305C10.903 14.6137 10.7774 15.051 10.4142 15.4142C10.051 15.7774 9.61374 15.903 9.23053 15.9545C8.89063 16.0002 8.47853 16.0001 8.05447 16H7.9456C7.52155 16.0001 7.1094 16.0002 6.76949 15.9545C6.38629 15.903 5.94902 15.7774 5.5858 15.4142C5.22258 15.051 5.09706 14.6137 5.04554 14.2305C4.99984 13.8906 4.99992 13.4785 5.00001 13.0544L5.00001 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L13.126 11ZM17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10ZM9.00001 13H7.00001C7.00001 13.4997 7.00214 13.7738 7.02771 13.964L7.02871 13.9713L7.03599 13.9723C7.22618 13.9979 7.50034 14 8.00001 14C8.49969 14 8.77385 13.9979 8.96404 13.9723L8.97132 13.9713L8.97232 13.964C8.99789 13.7738 9.00001 13.4997 9.00001 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Key-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["key","security","access","authorization","lock","password","login","authentication","admin","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00488 12V15M5.00488 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8C14.7909 8 13 9.79086 13 12C13 14.2091 14.7909 16 17 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Key-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["key","access","security","permissions","unlock","authorization","admin","settings","password"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12V13C6 13.9428 6 14.4142 6.29289 14.7071C6.29289 14.7071 6.29289 14.7071 6.29289 14.7071C6.58579 15 7.05719 15 8 15V15C8.94281 15 9.41421 15 9.70711 14.7071C9.70711 14.7071 9.70711 14.7071 9.70711 14.7071C10 14.4142 10 13.9428 10 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 12L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Key-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["key","security","access","password","authentication","authorization","permissions","lock","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 7C14.581 7 12.5633 8.71776 12.1 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H4V14C4 14.5523 4.44772 15 5 15C5.55228 15 6 14.5523 6 14V13H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V13H12.1C12.5633 15.2822 14.581 17 17 17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7ZM15 12C15 11.4477 15.4477 11 16 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H16C15.4477 13 15 12.5523 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Key: {
        defaultColors: ["#3D4C66"],
        keywords: ["key","security","access","password","authentication","authorization","permissions","lock","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00488 12V15M5.00488 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8C14.7909 8 13 9.79086 13 12C13 14.2091 14.7909 16 17 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["keyboard","input","keypad","settings","customization","options","configuration","menu","shortcuts","macros","admin","manager","cashier","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["keyboard","keypad","numeric-pad","number-input","custom-keyboard","shortcuts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","keypad","input","numbers","pin","pin-code","password","custom-keyboard","custom-keypad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45869 21 9.57529 21 10.9294V13.0705C21 14.4246 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0707 20H9.92943C8.57535 20 7.45868 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99997 9.57534 2.99994 8.45868 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57527 3.99997 9.92936 4H14.0706ZM6.5 9C6.5 8.44772 6.94772 8 7.5 8H8.5C9.05229 8 9.5 8.44772 9.5 9C9.5 9.55229 9.05229 10 8.5 10H7.5C6.94772 10 6.5 9.55229 6.5 9ZM6.5 12C6.5 11.4477 6.94772 11 7.5 11H8.5C9.05229 11 9.5 11.4477 9.5 12C9.5 12.5523 9.05229 13 8.5 13H7.5C6.94772 13 6.5 12.5523 6.5 12ZM11.5 8C10.9477 8 10.5 8.44772 10.5 9C10.5 9.55229 10.9477 10 11.5 10H12.5C13.0523 10 13.5 9.55229 13.5 9C13.5 8.44772 13.0523 8 12.5 8H11.5ZM10.5 12C10.5 11.4477 10.9477 11 11.5 11H12.5C13.0523 11 13.5 11.4477 13.5 12C13.5 12.5523 13.0523 13 12.5 13H11.5C10.9477 13 10.5 12.5523 10.5 12ZM15.5 8C14.9477 8 14.5 8.44772 14.5 9C14.5 9.55229 14.9477 10 15.5 10H16.5C17.0523 10 17.5 9.55229 17.5 9C17.5 8.44772 17.0523 8 16.5 8H15.5ZM14.5 12C14.5 11.4477 14.9477 11 15.5 11H16.5C17.0523 11 17.5 11.4477 17.5 12C17.5 12.5523 17.0523 13 16.5 13H15.5C14.9477 13 14.5 12.5523 14.5 12ZM7.5 14C6.94772 14 6.5 14.4477 6.5 15C6.5 15.5523 6.94772 16 7.5 16H16.5C17.0523 16 17.5 15.5523 17.5 15C17.5 14.4477 17.0523 14 16.5 14H7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "keyboard-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","keypad","custom-keyboard","settings","input","number-pad","numeric-keypad","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["keyboard","off","disable","blocked","restricted","unavailable","access-denied","no-input","input-disabled","numeric-pad-off","pin-pad-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "keyboard-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["keyboard","disabled","unavailable","offline","input-off","no-input","remove-keyboard","blocked","inactive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "keyboard-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","off","disabled","input-disabled","text-disabled","keyboard-off","disable-keyboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.20711 2.79289C3.81658 2.40237 3.18342 2.40237 2.79289 2.79289C2.40237 3.18342 2.40237 3.81658 2.79289 4.20711L19.7929 21.2071C20.1834 21.5976 20.8166 21.5976 21.2071 21.2071C21.5976 20.8166 21.5976 20.1834 21.2071 19.7929L20.315 18.9008C21 18.0084 21 16.6032 21 14V10C21 7.17157 21 5.75736 20.1213 4.87868C19.2426 4 17.8284 4 15 4H9C7.49125 4 6.3849 4 5.54758 4.13337L4.20711 2.79289ZM11.1642 9.75L10.2649 8.85066C10.3341 8.50799 10.6369 8.25 11 8.25H13C13.4142 8.25 13.75 8.58579 13.75 9C13.75 9.41421 13.4142 9.75 13 9.75H11.1642ZM12.6642 11.25L13.6955 12.2813C13.7306 12.1944 13.75 12.0995 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25H12.6642ZM15.6642 14.25L17.1493 15.7351C17.492 15.6659 17.75 15.3631 17.75 15C17.75 14.5858 17.4142 14.25 17 14.25H15.6642ZM14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H17C17.4142 8.25 17.75 8.58579 17.75 9C17.75 9.41421 17.4142 9.75 17 9.75H15C14.5858 9.75 14.25 9.41421 14.25 9ZM14.25 12C14.25 11.5858 14.5858 11.25 15 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H15C14.5858 12.75 14.25 12.4142 14.25 12ZM3.21664 6.13085L6.27375 9.18796C6.34166 9.45114 6.54886 9.65834 6.81204 9.72625L8.33579 11.25H7C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H9C9.22894 12.75 9.43393 12.6474 9.5715 12.4857L11.3358 14.25H7C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H12.8358L17.0664 19.9806C16.476 20 15.7937 20 15 20H9C6.17157 20 4.75736 20 3.87868 19.1213C3 18.2426 3 16.8284 3 14V10C3 8.22644 3 7.00894 3.21664 6.13085Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "keyboard-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","off","disabled","blocked","input-off","no-input","restricted","keyboard-disabled","text-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "keyboard-onscreen-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["keyboard","onscreen","virtual-keyboard","input","number-pad","numpad","password","pin","enter","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-onscreen-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["keyboard","onscreen","input","typing","virtual keyboard","payment","amount","pin","password","numpad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "keyboard-onscreen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","onscreen","virtual-keyboard","input","number-pad","keypad","payment","pin-pad"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.0706 4H9.92943C8.57534 3.99997 7.45868 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C3.10045 7.7111 3.08497 7.85278 3.07187 8H20.9281C20.915 7.85278 20.8996 7.7111 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4247 3.99997 14.0706 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 10V13.0706C21 14.4247 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0706 20H9.92936C8.57527 20 7.45868 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706L3.0016 10H21ZM4.5 12C4.5 11.4477 4.94772 11 5.5 11H6.5C7.05229 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05229 13 6.5 13H5.5C4.94772 13 4.5 12.5523 4.5 12ZM8.5 12C8.5 11.4477 8.94772 11 9.5 11H10.5C11.0523 11 11.5 11.4477 11.5 12C11.5 12.5523 11.0523 13 10.5 13H9.5C8.94772 13 8.5 12.5523 8.5 12ZM13.5 11C12.9477 11 12.5 11.4477 12.5 12C12.5 12.5523 12.9477 13 13.5 13H14.5C15.0523 13 15.5 12.5523 15.5 12C15.5 11.4477 15.0523 11 14.5 11H13.5ZM16.5 12C16.5 11.4477 16.9477 11 17.5 11H18.5C19.0523 11 19.5 11.4477 19.5 12C19.5 12.5523 19.0523 13 18.5 13H17.5C16.9477 13 16.5 12.5523 16.5 12ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "keyboard-onscreen": {
        defaultColors: ["#3D4C66"],
        keywords: ["keyboard","onscreen","input","data","enter","numeric","keypad","calculator","pin","password"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 9H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "kip-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["kip","currency","money","lao","laos","payment","amount","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 6V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967C16.2374 5.17678 15.7626 5.17678 15.4697 5.46967L16.5303 6.53033ZM10.5303 12.5303L16.5303 6.53033L15.4697 5.46967L9.46967 11.4697L10.5303 12.5303Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16.5303 17.4697C16.8232 17.7626 16.8232 18.2374 16.5303 18.5303C16.2374 18.8232 15.7626 18.8232 15.4697 18.5303L16.5303 17.4697ZM15.4697 18.5303L9.46967 12.5303L10.5303 11.4697L16.5303 17.4697L15.4697 18.5303Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "kip-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["kip","currency","sign","symbol","international-currency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C10.5523 5 11 5.44772 11 6V9.61601C11.3091 9.2766 11.6742 8.91151 12.0748 8.51102C12.0902 8.49555 12.1058 8.48004 12.1213 8.46447L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L13.5355 9.87868C13.0671 10.3471 12.7124 10.7032 12.4444 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H12.4444C12.7124 13.2968 13.0672 13.6529 13.5355 14.1213L16.7071 17.2929C17.0976 17.6834 17.0976 18.3166 16.7071 18.7071C16.3166 19.0976 15.6834 19.0976 15.2929 18.7071L12.0748 15.489C11.6742 15.0885 11.3091 14.7234 11 14.384V18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9V6C9 5.44772 9.44772 5 10 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "kip-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["kip","sign","currency","payment","kip-sign","laos","lao"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967C16.2374 5.17678 15.7626 5.17678 15.4697 5.46967L16.5303 6.53033ZM10.5303 12.5303L16.5303 6.53033L15.4697 5.46967L9.46967 11.4697L10.5303 12.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5303 17.4697C16.8232 17.7626 16.8232 18.2374 16.5303 18.5303C16.2374 18.8232 15.7626 18.8232 15.4697 18.5303L16.5303 17.4697ZM15.4697 18.5303L9.46967 12.5303L10.5303 11.4697L16.5303 17.4697L15.4697 18.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "kip-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","kip","laos","laotian","payment","cash","finance","money","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967C16.2374 5.17678 15.7626 5.17678 15.4697 5.46967L16.5303 6.53033ZM10.5303 12.5303L16.5303 6.53033L15.4697 5.46967L9.46967 11.4697L10.5303 12.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5303 17.4697C16.8232 17.7626 16.8232 18.2374 16.5303 18.5303C16.2374 18.8232 15.7626 18.8232 15.4697 18.5303L16.5303 17.4697ZM15.4697 18.5303L9.46967 12.5303L10.5303 11.4697L16.5303 17.4697L15.4697 18.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "L-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["L-shape","corner","layout","structure","alignment","position","category","section","division","divider","organize","organizer","shelving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19L10 19C9.05719 19 8.58579 19 8.29289 18.7071C8 18.4142 8 17.9428 8 17L8.00001 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "L-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["L","letter","layout","section","level","category","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19L10 19C9.05719 19 8.58579 19 8.29289 18.7071C8 18.4142 8 17.9428 8 17L8.00001 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    L: {
        defaultColors: ["#3D4C66"],
        keywords: ["L","letter","layout","section","level","category","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19L10 19C9.05719 19 8.58579 19 8.29289 18.7071C8 18.4142 8 17.9428 8 17L8.00001 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "L-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["l-shape","corner","angle","layout","floorplan","menu-layout","interface","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 20C9.96372 20 9.98186 20 10 20L16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18L10 18C9.50034 18 9.22618 17.9979 9.03599 17.9723C9.03351 17.972 9.03108 17.9716 9.02871 17.9713C9.02838 17.9689 9.02804 17.9665 9.02771 17.964C9.00214 17.7738 9.00001 17.4997 9.00001 17L9.00002 4.99999C9.00002 4.4477 8.55231 3.99999 8.00002 3.99999C7.44774 3.99999 7.00002 4.4477 7.00002 4.99999L7.00001 17C7.00001 17.0181 7.00001 17.0363 7.00001 17.0544C6.99992 17.4785 6.99984 17.8906 7.04554 18.2305C7.09706 18.6137 7.22258 19.051 7.5858 19.4142C7.94902 19.7774 8.38629 19.9029 8.76949 19.9545C9.10941 20.0002 9.52154 20.0001 9.94561 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "label-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["label","tag","price-tag","discount","sale","offer","special","promotion","information","next","continue","arrow","right","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.85297 17H15.2811C15.6861 17 15.8886 17 16.0656 16.9301C16.1658 16.8905 16.2589 16.835 16.3414 16.7657C16.4871 16.6433 16.5835 16.4653 16.7762 16.1091L18.5621 12.8091C18.738 12.4842 18.8259 12.3217 18.8519 12.1483C18.8666 12.05 18.8666 11.95 18.8519 11.8517C18.8259 11.6783 18.738 11.5158 18.5621 11.1909L18.5621 11.1909L16.7762 7.89089C16.5835 7.53473 16.4871 7.35666 16.3414 7.23425C16.2589 7.16498 16.1658 7.10949 16.0656 7.06992C15.8886 7 15.6861 7 15.2811 7H7.85298C6.81758 7 6.29988 7 6.01629 7.25044C5.86011 7.38835 5.75092 7.57161 5.70395 7.7746C5.61868 8.14321 5.86508 8.59851 6.35787 9.50911L7.26801 11.1909C7.44386 11.5158 7.53178 11.6783 7.55779 11.8517C7.57252 11.95 7.57252 12.05 7.55779 12.1483C7.53178 12.3217 7.44386 12.4842 7.26801 12.8091L6.35787 14.4909L6.35787 14.4909C5.86508 15.4015 5.61868 15.8568 5.70395 16.2254C5.75092 16.4284 5.86011 16.6116 6.01629 16.7496C6.29988 17 6.81758 17 7.85297 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "label-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["label","tag","ribbon","price","product","discount","offer","item","special","mark","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.85297 17H15.2811C15.6861 17 15.8886 17 16.0656 16.9301C16.1658 16.8905 16.2589 16.835 16.3414 16.7657C16.4871 16.6433 16.5835 16.4653 16.7762 16.1091L18.5621 12.8091C18.738 12.4842 18.8259 12.3217 18.8519 12.1483C18.8666 12.05 18.8666 11.95 18.8519 11.8517C18.8259 11.6783 18.738 11.5158 18.5621 11.1909L18.5621 11.1909L16.7762 7.89089C16.5835 7.53473 16.4871 7.35666 16.3414 7.23425C16.2589 7.16498 16.1658 7.10949 16.0656 7.06992C15.8886 7 15.6861 7 15.2811 7H7.85298C6.81758 7 6.29988 7 6.01629 7.25044C5.86011 7.38835 5.75092 7.57161 5.70395 7.7746C5.61868 8.14321 5.86508 8.59851 6.35787 9.50911L7.26801 11.1909C7.44386 11.5158 7.53178 11.6783 7.55779 11.8517C7.57252 11.95 7.57252 12.05 7.55779 12.1483C7.53178 12.3217 7.44386 12.4842 7.26801 12.8091L6.35787 14.4909L6.35787 14.4909C5.86508 15.4015 5.61868 15.8568 5.70395 16.2254C5.75092 16.4284 5.86011 16.6116 6.01629 16.7496C6.29988 17 6.81758 17 7.85297 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "label-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["label","tag","category","next","forward","process","workflow","discount","coupon","promo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.62989 18H15.6504C16.1421 18 16.388 18 16.603 17.9161C16.7247 17.8686 16.8377 17.802 16.9379 17.7189C17.1149 17.572 17.2319 17.3583 17.466 16.9309L19.6347 12.9709C19.8482 12.581 19.955 12.386 19.9866 12.1779C20.0045 12.06 20.0045 11.94 19.9866 11.8221C19.955 11.614 19.8482 11.419 19.6347 11.0291L17.466 7.06906C17.2319 6.64168 17.1149 6.42799 16.9379 6.2811C16.8377 6.19797 16.7247 6.13138 16.603 6.0839C16.388 6 16.1421 6 15.6504 6H6.62989C5.37254 6 4.74386 6 4.39948 6.30052C4.20983 6.46602 4.07722 6.68593 4.02019 6.92952C3.91664 7.37185 4.21586 7.91821 4.81429 9.01094L5.91952 11.0291C6.13307 11.419 6.23984 11.614 6.27142 11.8221C6.28931 11.94 6.28931 12.06 6.27142 12.1779C6.23984 12.386 6.13307 12.581 5.91952 12.9709L4.81429 14.9891C4.21586 16.0818 3.91664 16.6281 4.02019 17.0705C4.07722 17.3141 4.20983 17.534 4.39948 17.6995C4.74386 18 5.37254 18 6.62989 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Label-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["receipt","dollar","transaction","payment","sales","balance","invoice","money","bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.4877V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V19.4877C19 19.7235 19 19.8414 18.9231 19.9015C18.8462 19.9615 18.7318 19.9329 18.503 19.8757L15 19L12 20L9 19L5.49701 19.8757C5.26823 19.9329 5.15384 19.9615 5.07692 19.9015C5 19.8414 5 19.7235 5 19.4877Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Label-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["receipt","dollar","money","payment","transaction","sales","invoice","bill","checkout","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Label-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","payment","transaction","sales","finance","invoice","bill","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93425 3H15.0659C15.9524 2.99995 16.7162 2.99991 17.3279 3.08215C17.9834 3.17028 18.6117 3.36902 19.1214 3.87868C19.6311 4.38835 19.8298 5.0167 19.9179 5.67221C20.0002 6.28386 20.0001 7.04767 20.0001 7.93413L20.0001 19.4877L20.0001 19.5114C20.0003 19.6035 20.0007 19.7619 19.9802 19.9037C19.954 20.0845 19.87 20.4309 19.5386 20.6897C19.2071 20.9485 18.8507 20.9459 18.6689 20.9275C18.5264 20.913 18.3727 20.8742 18.2835 20.8517L18.2605 20.8459L15.0401 20.0408L12.3163 20.9487C12.111 21.0171 11.8891 21.0171 11.6839 20.9487L8.96011 20.0408L5.73963 20.8459L5.71665 20.8517C5.6274 20.8742 5.47379 20.913 5.33124 20.9275C5.14944 20.9459 4.79305 20.9485 4.46159 20.6897C4.13012 20.4309 4.04616 20.0845 4.02 19.9037C3.99948 19.7619 3.99984 19.6035 4.00005 19.5114L4.00008 19.4877L4.00008 7.93417C4.00003 7.04769 3.99999 6.28387 4.08222 5.67221C4.17035 5.0167 4.3691 4.38835 4.87876 3.87868C5.38842 3.36902 6.01678 3.17028 6.67229 3.08215C7.28395 2.99991 8.04777 2.99995 8.93425 3ZM12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25C11.0858 7.25 10.75 7.58579 10.75 8V8.37803C9.87611 8.68691 9.25 9.52034 9.25 10.5C9.25 11.7426 10.2574 12.75 11.5 12.75H12.3333C12.9159 12.75 13.25 13.1582 13.25 13.5C13.25 13.8418 12.9159 14.25 12.3333 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H10.75V16C10.75 16.4142 11.0858 16.75 11.5 16.75C11.9142 16.75 12.25 16.4142 12.25 16V15.75H12.3333C13.5917 15.75 14.75 14.815 14.75 13.5C14.75 12.185 13.5917 11.25 12.3333 11.25H11.5C11.0858 11.25 10.75 10.9142 10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75H13C13.4142 9.75 13.75 9.41421 13.75 9C13.75 8.58579 13.4142 8.25 13 8.25H12.25V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Label-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","money","transaction","sales","finance","bill","invoice","purchase","payment","cost","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 20V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 20L9 19L12 20L15 19L19 19.9997"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    label: {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","dollar","money","transaction","sales","finance","bill","invoice","purchase","payment","cost","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.85297 17H15.2811C15.6861 17 15.8886 17 16.0656 16.9301C16.1658 16.8905 16.2589 16.835 16.3414 16.7657C16.4871 16.6433 16.5835 16.4653 16.7762 16.1091L18.5621 12.8091C18.738 12.4842 18.8259 12.3217 18.8519 12.1483C18.8666 12.05 18.8666 11.95 18.8519 11.8517C18.8259 11.6783 18.738 11.5158 18.5621 11.1909L18.5621 11.1909L16.7762 7.89089C16.5835 7.53473 16.4871 7.35666 16.3414 7.23425C16.2589 7.16498 16.1658 7.10949 16.0656 7.06992C15.8886 7 15.6861 7 15.2811 7H7.85298C6.81758 7 6.29988 7 6.01629 7.25044C5.86011 7.38835 5.75092 7.57161 5.70395 7.7746C5.61868 8.14321 5.86508 8.59851 6.35787 9.50911L7.26801 11.1909C7.44386 11.5158 7.53178 11.6783 7.55779 11.8517C7.57252 11.95 7.57252 12.05 7.55779 12.1483C7.53178 12.3217 7.44386 12.4842 7.26801 12.8091L6.35787 14.4909L6.35787 14.4909C5.86508 15.4015 5.61868 15.8568 5.70395 16.2254C5.75092 16.4284 5.86011 16.6116 6.01629 16.7496C6.29988 17 6.81758 17 7.85297 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lamp-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lamp","light","table-lamp","furniture","lighting","table","home","decor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19L8.36176 19C8.75099 19 9.10486 18.7741 9.26877 18.4211L9.6598 17.5789C9.82371 17.2259 10.1776 17 10.5668 17L13.4332 17C13.8224 17 14.1763 17.2259 14.3402 17.5789L14.7312 18.4211C14.8951 18.7741 15.249 19 15.6382 19L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8769 13H11.1231C8.76483 13 7.5857 13 6.98514 12.2308C6.38459 11.4616 6.67057 10.3177 7.24254 8.02986C7.60632 6.57474 7.78821 5.84718 8.33073 5.42359C8.87325 5 9.6232 5 11.1231 5H12.8769C14.3768 5 15.1267 5 15.6693 5.42359C16.2118 5.84718 16.3937 6.57474 16.7575 8.02986C17.3294 10.3177 17.6154 11.4616 17.0149 12.2308C16.4143 13 15.2352 13 12.8769 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lamp-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","lamp","furniture","location","table-service","night","light","setting","decoration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0673 4C11.0858 4 11.1043 4 11.1229 4L12.9324 4C13.6347 3.99996 14.2481 3.99992 14.7507 4.06003C15.2932 4.12491 15.8163 4.2698 16.2845 4.63539C16.7528 5.00097 17.0202 5.47327 17.2147 5.9839C17.3949 6.45693 17.5437 7.05198 17.714 7.73335L17.7457 7.86034C18.0161 8.94188 18.2453 9.85831 18.3206 10.5987C18.4002 11.3818 18.332 12.1686 17.8029 12.8462C17.2739 13.5238 16.5271 13.7809 15.748 13.8936C15.022 13.9986 14.0939 14 12.9998 14L12.9998 16H13.433C14.2115 16 14.9192 16.4517 15.247 17.1578L15.6381 18L16.9998 18C17.5521 18 17.9998 18.4477 17.9998 19C17.9998 19.5523 17.5521 20 16.9998 20H15.6381C14.8596 20 14.1519 19.5483 13.8241 18.8422L13.433 18H12.0008L11.9989 18H10.5667L10.1756 18.8422C9.8478 19.5483 9.14007 20 8.3616 20H6.99984C6.44756 20 5.99984 19.5523 5.99984 19C5.99984 18.4477 6.44756 18 6.99984 18L8.3616 18L8.75263 17.1578C9.08045 16.4517 9.78819 16 10.5667 16H10.9998L10.9998 14C9.90581 14 8.97764 13.9986 8.25165 13.8936C7.47263 13.7809 6.72583 13.5238 6.19678 12.8462C5.66773 12.1686 5.5995 11.3818 5.67911 10.5987C5.75438 9.85831 5.98354 8.94187 6.25398 7.86033C6.26005 7.83608 6.26613 7.81174 6.27223 7.78733C6.27675 7.76927 6.28125 7.75126 6.28573 7.73332C6.45603 7.05197 6.60475 6.45693 6.78496 5.9839C6.97949 5.47327 7.24692 5.00097 7.71516 4.63539C8.18339 4.2698 8.70645 4.12491 9.24901 4.06003C9.75162 3.99992 10.365 3.99996 11.0673 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lamp-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chair","table","seat","location","booth","restaurant","management","seating","available","occupied","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19L8.36176 19C8.75099 19 9.10486 18.7741 9.26877 18.4211L9.6598 17.5789C9.82371 17.2259 10.1776 17 10.5668 17L13.4332 17C13.8224 17 14.1763 17.2259 14.3402 17.5789L14.7312 18.4211C14.8951 18.7741 15.249 19 15.6382 19L17 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8769 13H11.1231C8.76483 13 7.5857 13 6.98514 12.2308C6.38459 11.4616 6.67057 10.3177 7.24254 8.02986C7.60632 6.57474 7.78821 5.84718 8.33073 5.42359C8.87325 5 9.6232 5 11.1231 5H12.8769C14.3768 5 15.1267 5 15.6693 5.42359C16.2118 5.84718 16.3937 6.57474 16.7575 8.02986C17.3294 10.3177 17.6154 11.4616 17.0149 12.2308C16.4143 13 15.2352 13 12.8769 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    lamp: {
        defaultColors: ["#3D4C66"],
        keywords: ["chair","table","seat","location","booth","restaurant","management","seating","available","occupied","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8769 13H11.1231C8.76483 13 7.5857 13 6.98514 12.2308C6.38459 11.4616 6.67057 10.3177 7.24254 8.02986C7.60632 6.57474 7.78821 5.84718 8.33073 5.42359C8.87325 5 9.6232 5 11.1231 5H12.8769C14.3768 5 15.1267 5 15.6693 5.42359C16.2118 5.84718 16.3937 6.57474 16.7575 8.02986C17.3294 10.3177 17.6154 11.4616 17.0149 12.2308C16.4143 13 15.2352 13 12.8769 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 13L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19L8.36176 19C8.75099 19 9.10486 18.7741 9.26877 18.4211L9.6598 17.5789C9.82371 17.2259 10.1776 17 10.5668 17L13.4332 17C13.8224 17 14.1763 17.2259 14.3402 17.5789L14.7312 18.4211C14.8951 18.7741 15.249 19 15.6382 19L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "landline-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","telephone","contact","support","customer-service","call","landline","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.81226 13.454C6.38327 11.3127 6.66878 10.2421 7.47713 9.62103C8.28547 9 9.39354 9 11.6097 9H12.3903C14.6065 9 15.7145 9 16.5229 9.62103C17.3312 10.2421 17.6167 11.3127 18.1877 13.454L18.9254 16.2201C18.9749 16.4059 19 16.5974 19 16.7897V16.7897C19 18.0104 18.0104 19 16.7897 19H7.21035C5.98961 19 5 18.0104 5 16.7897V16.7897C5 16.5974 5.02509 16.4059 5.07463 16.2201L5.81226 13.454Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M10 7V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5.25 9V9C4.21627 9 3.54393 7.91214 4.00623 6.98754L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.75 9V9C19.7837 9 20.4561 7.91214 19.9938 6.98754L19.5528 6.10557C19.214 5.428 18.5215 5 17.7639 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "landline-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","landline","call","contact","support","customer service","communication","help","dial","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.81226 13.454C6.38327 11.3127 6.66878 10.2421 7.47713 9.62103C8.28547 9 9.39354 9 11.6097 9H12.3903C14.6065 9 15.7145 9 16.5229 9.62103C17.3312 10.2421 17.6167 11.3127 18.1877 13.454L18.9254 16.2201C18.9749 16.4059 19 16.5974 19 16.7897C19 18.0104 18.0104 19 16.7897 19H7.21035C5.98961 19 5 18.0104 5 16.7897C5 16.5974 5.02509 16.4059 5.07463 16.2201L5.81226 13.454Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 7V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5.25 9V9C4.21627 9 3.54393 7.91214 4.00623 6.98754L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.75 9V9C19.7837 9 20.4561 7.91214 19.9938 6.98754L19.5528 6.10557C19.214 5.428 18.5215 5 17.7639 5H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "landline-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","landline","contact","support","call","customer-service","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.4496 8H11.5504H11.5503C10.4928 7.99997 9.61196 7.99995 8.8978 8.08458C8.14383 8.17393 7.46753 8.36736 6.86789 8.82805C6.26825 9.28874 5.9071 9.89236 5.6265 10.5979C5.36071 11.2661 5.13377 12.1172 4.86131 13.1391L4.8613 13.1391L4.1084 15.9625C4.03644 16.2323 4 16.5104 4 16.7897C4 18.5627 5.43732 20 7.21035 20H16.7897C18.5627 20 20 18.5627 20 16.7897C20 16.5104 19.9636 16.2323 19.8916 15.9625L19.1387 13.1391L19.1387 13.1391C18.8662 12.1172 18.6393 11.2661 18.3735 10.5979C18.0929 9.89236 17.7317 9.28874 17.1321 8.82805C16.5325 8.36736 15.8562 8.17393 15.1022 8.08458C14.388 7.99995 13.5072 7.99997 12.4497 8H12.4496ZM14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16C13.1046 16 14 15.1046 14 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.91883 4.77016C4.38466 3.83851 5.33688 3.25 6.3785 3.25H17.9064C18.948 3.25 19.9002 3.83851 20.366 4.77016L20.807 5.65213C21.1953 6.42874 21.0605 7.28324 20.6069 7.89127C20.3838 8.19022 20.0871 8.38785 19.7485 8.47339C19.4229 8.55565 19.1041 8.52346 18.8307 8.44692C18.2965 8.29735 17.8075 7.94457 17.46 7.57734L16.6772 6.75H7.35946L6.87766 7.3494C6.52196 7.79191 5.9953 8.20355 5.42402 8.37662C5.13189 8.46512 4.78404 8.50372 4.43228 8.40147C4.06309 8.29414 3.7601 8.05146 3.5538 7.70555C3.20249 7.11653 3.12828 6.35126 3.47784 5.65213L3.91883 4.77016Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    landline: {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","landline","contact","support","call","customer-service","telephone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.81226 13.454C6.38327 11.3127 6.66878 10.2421 7.47713 9.62103C8.28547 9 9.39354 9 11.6097 9H12.3903C14.6065 9 15.7145 9 16.5229 9.62103C17.3312 10.2421 17.6167 11.3127 18.1877 13.454L18.9254 16.2201C18.9749 16.4059 19 16.5974 19 16.7897V16.7897C19 18.0104 18.0104 19 16.7897 19H7.21035C5.98961 19 5 18.0104 5 16.7897V16.7897C5 16.5974 5.02509 16.4059 5.07463 16.2201L5.81226 13.454Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 7V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5.25 9V9C4.21627 9 3.54393 7.91214 4.00623 6.98754L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.75 9V9C19.7837 9 20.4561 7.91214 19.9938 6.98754L19.5528 6.10557C19.214 5.428 18.5215 5 17.7639 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "landmark-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["landmark","building","location","store","branch","bank","finance","institution","architecture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00047 19M9.99976 11L10 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 19L17.9999 11M14 11L14.0002 19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 19L20 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "landmark-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["building","landmark","bank","finance","history","location","government","institution","authority","legal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00047 19M9.99976 11L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 19L17.9999 11M14 11L14.0002 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.87749 8.36754L5.0883 7.73509C5.52832 6.41505 5.74832 5.75503 6.2721 5.37752C6.79587 5 7.49159 5 8.88304 5H11.9993H12.0007H15.117C16.5084 5 17.2041 5 17.7279 5.37752C18.2517 5.75503 18.4717 6.41505 18.9117 7.73509L19.1225 8.36754C19.5229 9.5688 19.7231 10.1694 19.4238 10.5847C19.1245 11 18.4914 11 17.2251 11H6.77485C5.50862 11 4.87551 11 4.57618 10.5847C4.27686 10.1694 4.47707 9.5688 4.87749 8.36754Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 19L20 19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    landmark: {
        defaultColors: ["#3D4C66"],
        keywords: ["building","landmark","bank","finance","history","location","government","institution","authority","legal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 19L20 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 11L6.00047 19M9.99976 11L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 19L17.9999 11M14 11L14.0002 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "landmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bank","finance","transaction","history","record","institution","banking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.01 18.01H19.01V11.91C19.53 11.81 19.94 11.6 20.25 11.18C20.85 10.35 20.55 9.44 20.09 8.06L19.88 7.42C19.41 6 19.12 5.14 18.34 4.57C17.55 4 16.65 4 15.14 4H8.89C7.39 4 6.48 4 5.69 4.57C4.9 5.14 4.62 6 4.14 7.42L3.93 8.05C3.47 9.43 3.17 10.34 3.77 11.17C4.08 11.6 4.49 11.8 5 11.9V18H4C3.45 18 3 18.45 3 19C3 19.55 3.45 20 4 20H20.01C20.56 20 21 19.55 21 19C21 18.45 20.56 18.01 20.01 18.01ZM13.01 12.01V18.01H11.01V12.01H13.01ZM15.01 12.01H17.01V18.01H15.01V12.01ZM7.01 12.01H9.01V18.01H7.01V12.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "langua-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["e","s","es","initials","edit","settings","options","language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H15C14.0572 8 13.5858 8 13.2929 8.29289C13 8.58579 13 9.05719 13 10V10C13 10.9428 13 11.4142 13.2929 11.7071C13.5858 12 14.0572 12 15 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 16H15C15.9428 16 16.4142 16 16.7071 15.7071C17 15.4142 17 14.9428 17 14V14C17 13.0572 17 12.5858 16.7071 12.2929C16.4142 12 15.9428 12 15 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M11 16H9C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14V12M7 12H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "langua-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ES","language","translation","spanish","customer-language","internationalization","language-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H15C14.0572 8 13.5858 8 13.2929 8.29289C13 8.58579 13 9.05719 13 10V10C13 10.9428 13 11.4142 13.2929 11.7071C13.5858 12 14.0572 12 15 12V12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 16H15C15.9428 16 16.4142 16 16.7071 15.7071C17 15.4142 17 14.9428 17 14V14C17 13.0572 17 12.5858 16.7071 12.2929C16.4142 12 15.9428 12 15 12V12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M11 16H9C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14V12M7 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "langua-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["language","spanish","international","localization","ES"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94561 7.00001C7.52154 6.99992 7.10941 6.99984 6.76949 7.04554C6.38629 7.09706 5.94902 7.22259 5.5858 7.5858C5.22259 7.94902 5.09706 8.38629 5.04554 8.76949C4.99984 9.10941 4.99992 9.52154 5.00001 9.94561V14.0544C4.99992 14.4785 4.99984 14.8906 5.04554 15.2305C5.09706 15.6137 5.22259 16.051 5.5858 16.4142C5.94902 16.7774 6.38629 16.903 6.76949 16.9545C7.10941 17.0002 7.52153 17.0001 7.94559 17L10 17C10.5523 17 11 16.5523 11 16C11 15.4477 10.5523 15 10 15H8.00001C7.50034 15 7.22618 14.9979 7.03599 14.9723L7.02871 14.9713L7.02771 14.964C7.00214 14.7738 7.00001 14.4997 7.00001 14V13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H7.00001V10C7.00001 9.50034 7.00214 9.22618 7.02771 9.03599L7.02871 9.02871L7.03599 9.02771C7.22618 9.00214 7.50034 9.00001 8.00001 9.00001H10C10.5523 9.00001 11 8.5523 11 8.00001C11 7.44773 10.5523 7.00001 10 7.00001L7.94561 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 7.00001L18 7.00001C18.5523 7.00001 19 7.44773 19 8.00001C19 8.5523 18.5523 9.00001 18 9.00001H16C15.5003 9.00001 15.2262 9.00214 15.036 9.02771L15.0287 9.02871L15.0277 9.03599C15.0021 9.22618 15 9.50034 15 10C15 10.4997 15.0021 10.7738 15.0277 10.964L15.0287 10.9713L15.036 10.9723C15.2252 10.9978 15.4975 11 15.9924 11L16 11L16.0544 11C16.4785 10.9999 16.8906 10.9998 17.2305 11.0455C17.6137 11.097 18.051 11.2226 18.4142 11.5858C18.7774 11.949 18.9029 12.3863 18.9545 12.7695C19.0002 13.1094 19.0001 13.5215 19 13.9456V14.0544C19.0001 14.4785 19.0002 14.8906 18.9545 15.2305C18.9029 15.6137 18.7774 16.051 18.4142 16.4142C18.051 16.7774 17.6137 16.9029 17.2305 16.9545C16.8906 17.0002 16.4785 17.0001 16.0544 17L14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15H16C16.4997 15 16.7738 14.9979 16.964 14.9723L16.9713 14.9713L16.9723 14.964C16.9979 14.7738 17 14.4997 17 14C17 13.5003 16.9979 13.2262 16.9723 13.036L16.9713 13.0287L16.964 13.0277C16.7748 13.0022 16.5025 13 16.0076 13L16 13L15.9456 13C15.5215 13.0001 15.1094 13.0002 14.7695 12.9545C14.3863 12.903 13.949 12.7774 13.5858 12.4142C13.2226 12.051 13.0971 11.6137 13.0455 11.2305C12.9998 10.8906 12.9999 10.4785 13 10.0544V9.94561C12.9999 9.52154 12.9998 9.10941 13.0455 8.76949C13.0971 8.38629 13.2226 7.94902 13.5858 7.5858C13.949 7.22259 14.3863 7.09706 14.7695 7.04554C15.1094 6.99984 15.5215 6.99992 15.9456 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "language-french-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["french","language","fr","france","translation","international","region","locale","change-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 8H15C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V10C17 10.9428 17 11.4142 16.7071 11.7071C16.4142 12 15.9428 12 15 12H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 16V8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16L15 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M7 16V12M7 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "language-french-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["french","language","fr","translation","internationalization","locale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 8H15C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V10C17 10.9428 17 11.4142 16.7071 11.7071C16.4142 12 15.9428 12 15 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 16V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M7 16V12M7 12H11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    langua: {
        defaultColors: ["#3D4C66"],
        keywords: ["french","language","fr","translation","internationalization","locale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H15C14.0572 8 13.5858 8 13.2929 8.29289C13 8.58579 13 9.05719 13 10V10C13 10.9428 13 11.4142 13.2929 11.7071C13.5858 12 14.0572 12 15 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 16H15C15.9428 16 16.4142 16 16.7071 15.7071C17 15.4142 17 14.9428 17 14V14C17 13.0572 17 12.5858 16.7071 12.2929C16.4142 12 15.9428 12 15 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M11 16H9C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14V12M7 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "language-french-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["french","language","france","fr","international","translation","region"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94561 7.00001C7.52154 6.99992 7.10941 6.99984 6.76949 7.04554C6.38629 7.09706 5.94902 7.22259 5.5858 7.5858C5.22259 7.94902 5.09706 8.38629 5.04554 8.76949C4.99984 9.10941 4.99992 9.52154 5.00001 9.94561L5.00001 16C5.00001 16.5523 5.44773 17 6.00001 17C6.5523 17 7.00001 16.5523 7.00001 16V13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H7.00001V10C7.00001 9.50034 7.00214 9.22618 7.02771 9.03599L7.02871 9.02871L7.03599 9.02771C7.22618 9.00214 7.50034 9.00001 8.00001 9.00001H10C10.5523 9.00001 11 8.5523 11 8.00001C11 7.44773 10.5523 7.00001 10 7.00001L7.94561 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4142 12.4142C17.153 12.6755 16.8534 12.8138 16.5632 12.89L17.8945 15.5526C18.1414 16.0465 17.9412 16.6472 17.4472 16.8942C16.9533 17.1412 16.3526 16.941 16.1056 16.447L14.3821 13H14V16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16V8.00001C12 7.93099 12.007 7.86357 12.0203 7.79848C12.1136 7.34279 12.5167 7 13 7L13.0054 7.00001L15.0544 7.00001C15.4785 6.99992 15.8906 6.99984 16.2305 7.04554C16.6137 7.09706 17.051 7.22259 17.4142 7.5858C17.7774 7.94902 17.903 8.38629 17.9545 8.76949C18.0002 9.10939 18.0001 9.52149 18 9.94554V10.0544C18.0001 10.4785 18.0002 10.8906 17.9545 11.2305C17.903 11.6137 17.7774 12.051 17.4142 12.4142ZM15 9.00001C15.4997 9.00001 15.7738 9.00214 15.964 9.02771L15.9713 9.02871L15.9723 9.03599C15.9979 9.22618 16 9.50034 16 10C16 10.4997 15.9979 10.7738 15.9723 10.964L15.9713 10.9713L15.964 10.9723C15.7776 10.9974 15.5104 10.9999 15.0292 11C15.0092 10.9994 14.9893 10.9994 14.9692 11H14V9.00001H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "language-us-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["language","united states","us","localization","region","currency","international","english"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H16C15.0572 8 14.5858 8 14.2929 8.29289C14 8.58579 14 9.05719 14 10V10C14 10.9428 14 11.4142 14.2929 11.7071C14.5858 12 15.0572 12 16 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H16C16.9428 16 17.4142 16 17.7071 15.7071C18 15.4142 18 14.9428 18 14V14C18 13.0572 18 12.5858 17.7071 12.2929C17.4142 12 16.9428 12 16 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8V14C6 14.9428 6 15.4142 6.29289 15.7071C6.58579 16 7.05719 16 8 16H10C10.9428 16 11.4142 16 11.7071 15.7071C12 15.4142 12 14.9428 12 14V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "language-french": {
        defaultColors: ["#3D4C66"],
        keywords: ["fr","france","french","language","locale","international","region","french-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 8H15C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V10C17 10.9428 17 11.4142 16.7071 11.7071C16.4142 12 15.9428 12 15 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 16V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16L15 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 8H9C8.05719 8 7.58579 8 7.29289 8.29289C7 8.58579 7 9.05719 7 10V12M7 16V12M7 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "language-us-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["language","us","united-states","english","international","region","country","locale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9456 7.00001L18 7.00001C18.5523 7.00001 19 7.44773 19 8.00001C19 8.5523 18.5523 9.00001 18 9.00001H16C15.5003 9.00001 15.2262 9.00214 15.036 9.02771L15.0287 9.02871L15.0277 9.03599C15.0021 9.22618 15 9.50034 15 10C15 10.4997 15.0021 10.7738 15.0277 10.964L15.0287 10.9713L15.036 10.9723C15.2252 10.9978 15.4975 11 15.9924 11L16 11L16.0544 11C16.4785 10.9999 16.8906 10.9998 17.2305 11.0455C17.6137 11.097 18.051 11.2226 18.4142 11.5858C18.7774 11.949 18.9029 12.3863 18.9545 12.7695C19.0002 13.1094 19.0001 13.5215 19 13.9456V14.0544C19.0001 14.4785 19.0002 14.8906 18.9545 15.2305C18.9029 15.6137 18.7774 16.051 18.4142 16.4142C18.051 16.7774 17.6137 16.9029 17.2305 16.9545C16.8906 17.0002 16.4785 17.0001 16.0544 17L14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15H16C16.4997 15 16.7738 14.9979 16.964 14.9723L16.9713 14.9713L16.9723 14.964C16.9979 14.7738 17 14.4997 17 14C17 13.5003 16.9979 13.2262 16.9723 13.036L16.9713 13.0287L16.964 13.0277C16.7748 13.0022 16.5025 13 16.0076 13L16 13L15.9456 13C15.5215 13.0001 15.1094 13.0002 14.7695 12.9545C14.3863 12.903 13.949 12.7774 13.5858 12.4142C13.2226 12.051 13.0971 11.6137 13.0455 11.2305C12.9998 10.8906 12.9999 10.4785 13 10.0544V9.94561C12.9999 9.52155 12.9998 9.1094 13.0455 8.76949C13.0971 8.38629 13.2226 7.94902 13.5858 7.5858C13.949 7.22259 14.3863 7.09706 14.7695 7.04554C15.1094 6.99984 15.5215 6.99992 15.9456 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.00001 8C6.00001 7.44772 5.5523 7 5.00001 7C4.44773 7 4.00001 7.44772 4.00001 8L4.00001 14.0544C3.99992 14.4785 3.99984 14.8906 4.04554 15.2305C4.09706 15.6137 4.22259 16.051 4.5858 16.4142C4.94902 16.7774 5.38629 16.903 5.76949 16.9545C6.10941 17.0002 6.52153 17.0001 6.94559 17H9.05443C9.47849 17.0001 9.89062 17.0002 10.2305 16.9545C10.6137 16.903 11.051 16.7774 11.4142 16.4142C11.7774 16.051 11.903 15.6137 11.9545 15.2305C12.0002 14.8906 12.0001 14.4785 12 14.0544L12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8V14C10 14.4997 9.99789 14.7738 9.97232 14.964L9.97132 14.9713L9.96404 14.9723C9.77385 14.9979 9.49969 15 9.00001 15H7.00001C6.50034 15 6.22618 14.9979 6.03599 14.9723L6.02871 14.9713L6.02771 14.964C6.00214 14.7738 6.00001 14.4997 6.00001 14V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "language-us-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["us","united-states","language","location","region","country"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H16C15.0572 8 14.5858 8 14.2929 8.29289C14 8.58579 14 9.05719 14 10V10C14 10.9428 14 11.4142 14.2929 11.7071C14.5858 12 15.0572 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H16C16.9428 16 17.4142 16 17.7071 15.7071C18 15.4142 18 14.9428 18 14V14C18 13.0572 18 12.5858 17.7071 12.2929C17.4142 12 16.9428 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8V14C6 14.9428 6 15.4142 6.29289 15.7071C6.58579 16 7.05719 16 8 16H10C10.9428 16 11.4142 16 11.7071 15.7071C12 15.4142 12 14.9428 12 14V8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "layout-bottom-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["minimize","hide","minimize-panel","dock","dock-bottom","hide-keyboard","bottom-panel","hide-element"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 16H7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "language-us": {
        defaultColors: ["#3D4C66"],
        keywords: ["US","USA","united-states","united states","language","locale","currency","location","region","settings","localization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H16C15.0572 8 14.5858 8 14.2929 8.29289C14 8.58579 14 9.05719 14 10V10C14 10.9428 14 11.4142 14.2929 11.7071C14.5858 12 15.0572 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H16C16.9428 16 17.4142 16 17.7071 15.7071C18 15.4142 18 14.9428 18 14V14C18 13.0572 18 12.5858 17.7071 12.2929C17.4142 12 16.9428 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8V14C6 14.9428 6 15.4142 6.29289 15.7071C6.58579 16 7.05719 16 8 16H10C10.9428 16 11.4142 16 11.7071 15.7071C12 15.4142 12 14.9428 12 14V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "layout-bottom-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["layout","panel","bottom","section","information","order-summary","transaction-details","details","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M17 16H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","hide","collapse","less","remove","subtract","line","horizontal-line","bottom","dock","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 14.0706L3 9.92943C2.99997 8.57534 2.99994 7.45867 3.11876 6.57493C3.2435 5.6471 3.51547 4.82767 4.17158 4.17157C4.82769 3.51546 5.64711 3.24349 6.57494 3.11875C7.4587 2.99993 8.5753 2.99996 9.92942 2.99999L14.0706 2.99999C15.4247 2.99996 16.5413 2.99993 17.4251 3.11875C18.3529 3.24349 19.1723 3.51546 19.8284 4.17157C20.4845 4.82768 20.7565 5.6471 20.8813 6.57493C21.0001 7.45869 21 8.5753 21 9.9294L21 14.0705C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8812C16.5413 21.0001 15.4247 21 14.0706 21L9.92943 21C8.57535 21 7.45868 21.0001 6.57494 20.8812C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706ZM17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15L7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17L17 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "layout-column-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["layout","column","split","view","screen","arrangement","table","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20L12 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "layout-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","minimize","hide","bottom","layout","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 16H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-column-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["split","divide","columns","layout","table","sections","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 20L12 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-column-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","columns","split","view","category","grouping","sections","menu","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 3H9.92943C8.57535 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57527 3 9.92936V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.5753 21 9.92942 21L11 21L11 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 21L14.0705 21C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92946C21 8.57535 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3H13L13 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "layout-column": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","column","grid","two-column","sections","split","divide","arrange","display","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 20L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-right-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["layout","right","section","panel","sidebar","interface","ui","display","cashier-view","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 17L16 7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "layout-right-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["layout","interface","right-panel","sidebar","display","order-details","split-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 17L16 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","view","section","split","panel","interface","dashboard","partition","divide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 21L9.92943 21C8.57534 21 7.45867 21.0001 6.57493 20.8812C5.6471 20.7565 4.82767 20.4845 4.17157 19.8284C3.51546 19.1723 3.24349 18.3529 3.11875 17.4251C2.99993 16.5413 2.99996 15.4247 2.99999 14.0706L2.99999 9.92945C2.99996 8.57534 2.99993 7.45869 3.11874 6.57493C3.24349 5.6471 3.51545 4.82768 4.17156 4.17157C4.82767 3.51546 5.6471 3.24349 6.57493 3.11875C7.45868 2.99993 8.57529 2.99996 9.9294 3L14.0705 2.99999C15.4247 2.99996 16.5413 2.99993 17.4251 3.11875C18.3529 3.24349 19.1723 3.51546 19.8284 4.17157C20.4845 4.82767 20.7565 5.6471 20.8812 6.57493C21.0001 7.45867 21 8.57527 21 9.92935L21 14.0706C21 15.4247 21.0001 16.5413 20.8812 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8812C16.5413 21.0001 15.4247 21 14.0706 21ZM17 7C17 6.44771 16.5523 6 16 6C15.4477 6 15 6.44771 15 7L15 17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17L17 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "layout-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","grid","section","area","organize","display","interface","table","block","column","panel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 17L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-top-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["subtract","minus","remove","decrease","reduce","box","container","order","discount","remove-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M17 8H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-top-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["drawer","cash","cash-drawer","money","storage","box","register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.45869 21 8.57533 21 9.92944V9.92946V14.0706V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H14.0705H9.92944H9.92942C8.5753 21 7.45869 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V14.0706V9.92939V9.92936C2.99997 8.57527 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57531 2.99997 9.9294 3H9.92943ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9H17C17.5523 9 18 8.55229 18 8C18 7.44772 17.5523 7 17 7H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "layout-top-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["layout","tab","panel","section","interface","display","menu","dashboard","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 8H7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "layout-top": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","layout","position","top","screen","template","container","view","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 8H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "left-from-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["back","previous","return","undo","left","restart","start-over","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 17M12 7L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14L18 14C18.9428 14 19.4142 14 19.7071 13.7071C20 13.4142 20 12.9428 20 12V12C20 11.0572 20 10.5858 19.7071 10.2929C19.4142 10 18.9428 10 18 10L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17L7.84373 13.5364C6.98928 12.8244 6.56205 12.4684 6.56205 12C6.56205 11.5316 6.98928 11.1756 7.84373 10.4636L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 6L4 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-from-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["back","return","previous","left","arrow","undo","go-back","step-back","exit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.84403 13.5381L12 17V14L20 14V10L12 10V7L7.84343 10.4652C6.98912 11.1774 6.56196 11.5335 6.56205 12.0019C6.56214 12.4702 6.98944 12.8262 7.84403 13.5381Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 6L4 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-from-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","previous","undo","rewind","left","go-back","previous-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.5 5C4.05228 5 4.5 5.44772 4.5 6V18C4.5 18.5523 4.05228 19 3.5 19C2.94772 19 2.5 18.5523 2.5 18V6C2.5 5.44772 2.94772 5 3.5 5ZM12.9241 6.09437C13.2755 6.25893 13.5 6.61195 13.5 7V9H20.5C21.0523 9 21.5 9.44772 21.5 10V14C21.5 14.5523 21.0523 15 20.5 15H13.5V17C13.5 17.388 13.2756 17.7409 12.9242 17.9055C12.5729 18.0701 12.1581 18.0167 11.86 17.7683L7.704 14.3064C7.68834 14.2934 7.6727 14.2803 7.6571 14.2674C7.27047 13.9454 6.90261 13.6391 6.64055 13.349C6.34936 13.0267 6.06216 12.59 6.06205 12.0021C6.06194 11.4141 6.34896 10.9774 6.64002 10.6549C6.90197 10.3647 7.26971 10.0583 7.65621 9.73617C7.67181 9.72316 7.68744 9.71014 7.7031 9.69708L11.8597 6.2319C12.1577 5.98342 12.5726 5.92981 12.9241 6.09437Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "left-from-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","left","back","return","previous","undo","remove","delete","exit","cancel","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 17M12 7L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14L18 14C18.9428 14 19.4142 14 19.7071 13.7071C20 13.4142 20 12.9428 20 12V12C20 11.0572 20 10.5858 19.7071 10.2929C19.4142 10 18.9428 10 18 10L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17L7.84373 13.5364C6.98928 12.8244 6.56205 12.4684 6.56205 12C6.56205 11.5316 6.98928 11.1756 7.84373 10.4636L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 6L4 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-sidebar-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sidebar","navigation","menu","left","section","panel","view","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 17L8 7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "left-sidebar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sidebar","menu","navigation","options","settings","left-sidebar","tabs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 17L8 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "left-sidebar": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","sidebar","navigation","options","settings","category","left-menu","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 17L8 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "left-to-bracket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["login","logout","back","return","arrow-left","exit","sign-out","previous","go-back","return-to-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 10L14 8M14 16L14 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 8L10 12L14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H18V14L14 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-to-bracket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","return","arrow-left","previous","undo","go-back","exit","leave","retreat","cancel","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.84144 17.8991C9.57626 17.9979 10.5575 18 12 18H14C14.5523 18 15 18.4477 15 19C15 19.5523 14.5523 20 14 20H12C11.9764 20 11.9529 20 11.9294 20C10.5753 20 9.4587 20.0001 8.57494 19.8813C7.64711 19.7565 6.82769 19.4845 6.17158 18.8284C5.51547 18.1723 5.2435 17.3529 5.11876 16.4251C4.99994 15.5413 4.99997 14.4247 5 13.0706L5 10.9294C4.99997 9.57531 4.99994 8.4587 5.11876 7.57494C5.2435 6.64711 5.51547 5.82768 6.17158 5.17158C6.82768 4.51547 7.64711 4.2435 8.57494 4.11875C9.4587 3.99994 10.5753 3.99997 11.9294 4L14 4C14.5523 4 15 4.44772 15 5C15 5.55229 14.5523 6 14 6L12 6C10.5575 6 9.57625 6.00213 8.84143 6.10092C8.13538 6.19585 7.80836 6.36322 7.58579 6.58579C7.36322 6.80836 7.19585 7.13538 7.10092 7.84143C7.00213 8.57625 7 9.55752 7 11L7 13C7 14.4425 7.00213 15.4238 7.10092 16.1586C7.19585 16.8646 7.36322 17.1916 7.58579 17.4142C7.80836 17.6368 8.13538 17.8042 8.84144 17.8991Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.3827 16.9239C14.009 17.0786 13.5789 16.9931 13.2929 16.7071L9.2929 12.7071C8.90237 12.3166 8.90237 11.6834 9.2929 11.2929L13.2929 7.29287C13.5789 7.00687 14.009 6.92131 14.3827 7.0761C14.7564 7.23088 15 7.59551 15 7.99998V8.99998L18 8.99998C18.5523 8.99998 19 9.44769 19 9.99998L19 14C19 14.5523 18.5523 15 18 15H15V16C15 16.4044 14.7564 16.7691 14.3827 16.9239Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "left-to-bracket-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["back","return","undo","previous","left","arrow","exit","logout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 14V10L14 10V8L10 12L14 16L14 14L18 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-to-bracket": {
        defaultColors: ["#3D4C66"],
        keywords: ["login","sign-in","enter","return","back","previous","arrow-left","input"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 19H12C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 10L14 8M14 16L14 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 8L10 12L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H18V14L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "left-sidebar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","sidebar","navigation","options","settings","panel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.5753 21 9.92942V14.0705C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92946C8.57535 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92943C2.99997 8.57535 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM7 17C7 17.5523 7.44772 18 8 18C8.55229 18 9 17.5523 9 17L9 7C9 6.44772 8.55229 6 8 6C7.44772 6 7 6.44772 7 7L7 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "like-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["like","approve","confirm","thumbs-up","success","agreement","ok","accept","receipt-accepted","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14V18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18V14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25V10.75ZM13.1644 9.01361L12.4246 8.89031L13.1644 9.01361ZM12.8644 6.25153L12.4246 8.89031L13.9042 9.13691L14.344 6.49812L12.8644 6.25153ZM8.72761 12.1819L10.3414 5.72677L8.88618 5.36297L7.27239 11.8181L8.72761 12.1819ZM14.344 6.49812C14.6274 4.79782 13.3162 3.25 11.5924 3.25V4.75C12.3893 4.75 12.9954 5.46552 12.8644 6.25153L14.344 6.49812ZM10.3414 5.72677C10.4849 5.15272 11.0007 4.75 11.5924 4.75V3.25C10.3124 3.25 9.19663 4.12116 8.88618 5.36297L10.3414 5.72677ZM12.4246 8.89031C12.2624 9.86381 13.0131 10.75 14 10.75V9.25C13.94 9.25 13.8943 9.19611 13.9042 9.13691L12.4246 8.89031Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8 12V16C8 17.8856 8 18.8284 8.58579 19.4142C9.17157 20 10.1144 20 12 20H12.7762C15.0116 20 16.1292 20 16.9407 19.3708C17.7522 18.7416 18.0305 17.6591 18.5872 15.4942L19.3576 12.4981C19.6531 11.349 19.8008 10.7745 19.5006 10.3872C19.2003 10 18.6071 10 17.4207 10H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 17V15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "like-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumb-up","like","approve","confirm","accept","validation","agreement","customer-satisfaction","good","positive","ok"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9262 5.31316C11.2367 4.07136 12.3524 3.2002 13.6325 3.2002C15.3562 3.2002 16.6674 4.74801 16.384 6.44832L15.9442 9.0871C15.9344 9.1463 15.98 9.2002 16.04 9.2002H19.4607C19.478 9.2002 19.4953 9.20019 19.5125 9.20019C20.0611 9.20014 20.5521 9.20009 20.9405 9.25635C21.3604 9.31717 21.8115 9.46276 22.1333 9.87786C22.4552 10.293 22.4839 10.7661 22.4382 11.1879C22.396 11.578 22.2736 12.0535 22.137 12.5849L21.342 15.6763C21.0735 16.7205 20.8555 17.5684 20.5987 18.23C20.3309 18.9198 19.9933 19.4849 19.4403 19.9137C18.8873 20.3425 18.256 20.5287 17.5212 20.6163C16.8164 20.7002 15.9409 20.7002 14.8628 20.7002H13.988C13.0896 20.7002 12.3403 20.7003 11.7456 20.6203C11.1178 20.5359 10.551 20.3502 10.0955 19.8947C9.64003 19.4393 9.45436 18.8725 9.36995 18.2447C9.28998 17.6499 9.29001 16.9007 9.29004 16.0022L9.29004 11.8579L10.9262 5.31316Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.54004 12.7002C3.98775 12.7002 3.54004 13.1479 3.54004 13.7002V17.7002C3.54004 18.2525 3.98775 18.7002 4.54004 18.7002C5.09232 18.7002 5.54004 18.2525 5.54004 17.7002V13.7002C5.54004 13.1479 5.09232 12.7002 4.54004 12.7002ZM1.54004 13.7002C1.54004 12.0433 2.88318 10.7002 4.54004 10.7002C6.19689 10.7002 7.54004 12.0433 7.54004 13.7002V17.7002C7.54004 19.357 6.19689 20.7002 4.54004 20.7002C2.88318 20.7002 1.54004 19.357 1.54004 17.7002V13.7002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "like-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["like","thumb-up","approve","confirmation","agree","okay","valid","accept","success","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1644 9.01361L13.6042 6.37483C13.8114 5.13167 12.8527 4 11.5924 4C10.6565 4 9.84077 4.63694 9.61378 5.54487L8 12V16C8 17.8856 8 18.8284 8.58579 19.4142C9.17157 20 10.1144 20 12 20H12.7762C15.0116 20 16.1292 20 16.9407 19.3708C17.7522 18.7416 18.0305 17.6591 18.5872 15.4942L19.3576 12.4981C19.6531 11.349 19.8008 10.7745 19.5006 10.3872C19.2003 10 18.6071 10 17.4207 10H14C13.4765 10 13.0783 9.52996 13.1644 9.01361Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14V18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18V14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="2"
                />
            </svg>
        )
    },
    like: {
        defaultColors: ["#3D4C66"],
        keywords: ["like","thumb-up","approve","confirmation","agree","okay","valid","accept","success","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25V10.75ZM13.1644 9.01361L12.4246 8.89031L13.1644 9.01361ZM12.8644 6.25153L12.4246 8.89031L13.9042 9.13691L14.344 6.49812L12.8644 6.25153ZM8.72761 12.1819L10.3414 5.72677L8.88618 5.36297L7.27239 11.8181L8.72761 12.1819ZM14.344 6.49812C14.6274 4.79782 13.3162 3.25 11.5924 3.25V4.75C12.3893 4.75 12.9954 5.46552 12.8644 6.25153L14.344 6.49812ZM10.3414 5.72677C10.4849 5.15272 11.0007 4.75 11.5924 4.75V3.25C10.3124 3.25 9.19663 4.12116 8.88618 5.36297L10.3414 5.72677ZM12.4246 8.89031C12.2624 9.86381 13.0131 10.75 14 10.75V9.25C13.94 9.25 13.8943 9.19611 13.9042 9.13691L12.4246 8.89031Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 12V16C8 17.8856 8 18.8284 8.58579 19.4142C9.17157 20 10.1144 20 12 20H12.7762C15.0116 20 16.1292 20 16.9407 19.3708C17.7522 18.7416 18.0305 17.6591 18.5872 15.4942L19.3576 12.4981C19.6531 11.349 19.8008 10.7745 19.5006 10.3872C19.2003 10 18.6071 10 17.4207 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14V18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18V14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 17V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "line-axis-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["analytics","reporting","sales-trends","trends","data","statistics","graphs","growth","metrics","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L4 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L4 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 11L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L20 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "line-axis-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["axis","graph","trend","analysis","growth","sales-growth","increase","performance","metrics","statistics","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.64021 12.7682L9.93866 8.35287L15.2459 13.6601L14.0614 14.6472L10.7144 11.3002C10.6449 11.2291 10.5669 11.1704 10.4834 11.1243C10.3327 11.041 10.165 10.9996 9.99734 11C9.88153 11.0002 9.7654 11.0205 9.65456 11.0613C9.54561 11.1013 9.44223 11.1609 9.34987 11.2401L3.35984 16.2318C2.93556 16.5854 2.87824 17.2159 3.2318 17.6402C3.58537 18.0645 4.21593 18.1218 4.64021 17.7682L9.93866 13.3529L13.2857 16.6999C13.3626 16.7786 13.4499 16.8421 13.5436 16.8901C13.8181 17.0307 14.1472 17.038 14.4301 16.9031C14.5061 16.8669 14.5785 16.8206 14.6452 16.7641L16.6659 15.0801L19.2929 17.7071C19.6834 18.0976 20.3166 18.0976 20.7071 17.7071C21.0976 17.3166 21.0976 16.6834 20.7071 16.2929L18.2087 13.7945L20.6402 11.7682C21.0645 11.4147 21.1218 10.7841 20.7682 10.3598C20.4147 9.93556 19.7841 9.87824 19.3598 10.2318L16.7887 12.3745L10.7144 6.30015C10.6449 6.22909 10.5669 6.17039 10.4834 6.12433C10.3327 6.041 10.165 5.99956 9.99734 6C9.88153 6.00025 9.7654 6.02051 9.65456 6.0613C9.54561 6.10132 9.44223 6.16092 9.34986 6.24012L3.35984 11.2318C2.93556 11.5854 2.87824 12.2159 3.2318 12.6402C3.58537 13.0645 4.21593 13.1218 4.64021 12.7682Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "line-axis-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["graph","chart","sales","analytics","trends","statistics","performance","growth","data","metrics","reporting","insights"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L4 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L4 12" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 11L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L20 17" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "line-axis": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","trend","analysis","analytics","sales-trend","performance","growth","increase","metrics","reporting","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L4 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 11L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 7L20 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Line-End-Square-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["connection","linked","relation","table","join","database","line","end","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 12L4 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="14"
                    y="9"
                    width="6"
                    height="6"
                    rx="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Line-End-Square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["drag","handle","edit","adjust","reorder","change","resize","control","line"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 12L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="14" y="9" width="6" height="6" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Line-End-Square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","connect","link","linked","on","off","setting","settings","option","options","enable","disable","payment-method","customer-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13L13.02 13C13.02 13.05 13.02 13.11 13.02 13.16C13.04 13.49 13.09 13.82 13.23 14.15C13.53 14.89 14.12 15.47 14.85 15.77C15.18 15.91 15.51 15.95 15.84 15.98C16.15 16 16.53 16 16.97 16H17.03C17.47 16 17.85 16 18.16 15.98C18.49 15.96 18.82 15.91 19.15 15.77C19.88 15.47 20.47 14.88 20.77 14.15C20.91 13.82 20.95 13.49 20.98 13.16C21 12.85 21 12.47 21 12.03V11.97C21 11.53 21 11.15 20.98 10.84C20.96 10.51 20.91 10.18 20.77 9.85C20.47 9.11 19.88 8.53 19.15 8.23C18.82 8.1 18.49 8.05 18.16 8.02C17.85 8 17.47 8 17.03 8L16.97 8C16.53 8 16.15 8 15.84 8.02C15.51 8.04 15.18 8.09 14.85 8.23C14.11 8.53 13.53 9.12 13.23 9.85C13.09 10.18 13.05 10.51 13.02 10.84C13.02 10.89 13.02 10.95 13.02 11L4 11C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Line-Start-Square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["start","square","line","connection","link","chain","process","workflow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="4" y="9" width="6" height="6" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Line-End-Square": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","connect","chain","relation","affiliate","join","square","line","reference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="14" y="9" width="6" height="6" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 12L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Line-Start-Square-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["start","slider","toggle","line","rectangle","round","rounded-square","switch","enable","disable","options","settings","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12L10 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="4"
                    y="9"
                    width="6"
                    height="6"
                    rx="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Line-Start-Square": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","line","connect","start","flow","process","link","sequence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="9" width="6" height="6" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M20 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Line-Start-Square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","enable","disable","activate","deactivate","on-off","setting","preference","status","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 11H10.98C10.98 10.95 10.98 10.89 10.98 10.84C10.96 10.51 10.91 10.18 10.77 9.85C10.47 9.11 9.88 8.53 9.15 8.23C8.82 8.09 8.49 8.05 8.16 8.02C7.85 8 7.47 8 7.03 8H6.97C6.53 8 6.15 8 5.84 8.02C5.51 8.04 5.18 8.09 4.85 8.23C4.12 8.53 3.53 9.12 3.23 9.85C3.09 10.18 3.05 10.51 3.02 10.84C3 11.15 3 11.53 3 11.97V12.03C3 12.47 3 12.85 3.02 13.16C3.04 13.49 3.09 13.82 3.23 14.15C3.53 14.89 4.12 15.47 4.85 15.77C5.18 15.9 5.51 15.95 5.84 15.98C6.15 16 6.53 16 6.97 16H7.03C7.47 16 7.85 16 8.16 15.98C8.49 15.96 8.82 15.91 9.15 15.77C9.89 15.47 10.47 14.88 10.77 14.15C10.91 13.82 10.95 13.49 10.98 13.16C10.98 13.11 10.98 13.05 10.98 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "link slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","broken-link","disable","disconnect","unlink","connection-error","network-error","offline","unavailable","blocked","disabled-feature","unsupported"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2173 5.78268C17.1737 4.73911 15.4818 4.73911 14.4382 5.78268L11.8415 8.37934C11.451 8.76986 10.8178 8.76986 10.4273 8.37934C10.0368 7.98882 10.0368 7.35565 10.4273 6.96513L13.024 4.36847C14.8486 2.54385 17.8069 2.54384 19.6315 4.36847C21.4561 6.19309 21.4561 9.15138 19.6315 10.976L17.0348 13.5727C16.6443 13.9632 16.0112 13.9632 15.6206 13.5727C15.2301 13.1821 15.2301 12.549 15.6206 12.1584L18.2173 9.56179C19.2609 8.51822 19.2609 6.82625 18.2173 5.78268ZM5.29286 5.29289C5.68338 4.90237 6.31655 4.90237 6.70707 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3165 19.0976 17.6834 19.0976 17.2929 18.7071L5.29286 6.70711C4.90233 6.31658 4.90233 5.68342 5.29286 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.37934 10.4273C8.76986 10.8179 8.76986 11.451 8.37934 11.8416L5.78268 14.4382C4.73911 15.4818 4.73911 17.1737 5.78268 18.2173C6.82625 19.2609 8.51821 19.2609 9.56179 18.2173L12.1584 15.6207C12.549 15.2301 13.1821 15.2301 13.5727 15.6207C13.9632 16.0112 13.9632 16.6444 13.5727 17.0349L10.976 19.6315C9.15138 21.4562 6.19309 21.4562 4.36847 19.6315C2.54384 17.8069 2.54384 14.8486 4.36847 13.024L6.96513 10.4273C7.35565 10.0368 7.98882 10.0368 8.37934 10.4273Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "link slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["link","slash","disable","unlink","remove-link","disconnected","no-connection","link-broken"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1344 7.67223L13.7311 5.07557C15.1652 3.64148 17.4903 3.64148 18.9244 5.07557C20.3585 6.50967 20.3585 8.8348 18.9244 10.2689L16.3278 12.8656M12.8656 16.3278L10.2689 18.9244C8.8348 20.3585 6.50967 20.3585 5.07557 18.9244C3.64148 17.4903 3.64148 15.1652 5.07557 13.7311L7.67223 11.1344"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5.9411 5.94092L18.0588 18.0587"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "link slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["link","disabled","broken","remove-link","unlink","no-link","connection-error","error","disconnect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1344 7.67223L13.7311 5.07557C15.1652 3.64148 17.4903 3.64148 18.9244 5.07557C20.3585 6.50967 20.3585 8.8348 18.9244 10.2689L16.3277 12.8656M5.9411 5.94113L18.0588 18.0589"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.8656 16.3276L10.2689 18.9243C8.8348 20.3584 6.50967 20.3584 5.07557 18.9243C3.64148 17.4902 3.64148 15.165 5.07557 13.7309L7.67223 11.1343"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "link slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlink","remove-link","disconnect","disabled","deactivate","stop","broken-link","disable-feature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1344 7.67223L13.7311 5.07557C15.1652 3.64148 17.4903 3.64148 18.9244 5.07557C20.3585 6.50967 20.3585 8.8348 18.9244 10.2689L16.3278 12.8656M12.8656 16.3278L10.2689 18.9244C8.8348 20.3585 6.50967 20.3585 5.07557 18.9244C3.64148 17.4903 3.64148 15.1652 5.07557 13.7311L7.67223 11.1344M5.94113 5.94113L18.0589 18.0589"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "link-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","chain","connect","relation","related","affiliation","associate","association","connection","network","relationship","attachments","resources","external-link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2635 4.49895C14.2621 2.50035 17.5024 2.50035 19.501 4.49895C21.4997 6.49756 21.4997 9.73794 19.501 11.7365L17.5599 13.6777C15.5613 15.6763 12.3209 15.6763 10.3223 13.6777C9.93181 13.2871 9.93181 12.654 10.3223 12.2635C10.7129 11.8729 11.346 11.8729 11.7365 12.2635C12.9541 13.481 14.9282 13.481 16.1457 12.2635L18.0868 10.3223C19.3044 9.10477 19.3044 7.13072 18.0868 5.91317C16.8693 4.69561 14.8952 4.69561 13.6777 5.91317L11.7365 7.85429C11.346 8.24482 10.7129 8.24482 10.3223 7.85429C9.9318 7.46377 9.9318 6.8306 10.3223 6.44008L12.2635 4.49895Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2635 11.7365C11.0459 10.519 9.07185 10.519 7.85429 11.7365L5.91317 13.6777C4.69561 14.8952 4.69561 16.8693 5.91317 18.0868C7.13072 19.3044 9.10477 19.3044 10.3223 18.0868L12.2635 16.1457C12.654 15.7552 13.2871 15.7552 13.6777 16.1457C14.0682 16.5362 14.0682 17.1694 13.6777 17.5599L11.7365 19.501C9.73794 21.4997 6.49756 21.4996 4.49895 19.501C2.50035 17.5024 2.50035 14.2621 4.49895 12.2635L6.44008 10.3223C8.43868 8.32372 11.6791 8.32372 13.6777 10.3223C14.0682 10.7129 14.0682 11.346 13.6777 11.7365C13.2871 12.1271 12.654 12.1271 12.2635 11.7365Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "link-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["link","chain","connect","connection","relationship","associate","integration","url","hyperlink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0294 12.9706C12.6375 14.5786 15.2447 14.5786 16.8528 12.9706L18.7939 11.0294C20.402 9.42135 20.402 6.81414 18.7939 5.20606C17.1858 3.59798 14.5786 3.59798 12.9705 5.20606L11.0294 7.14719"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.9706 11.0293C11.3625 9.42122 8.75527 9.42122 7.14719 11.0293L5.20606 12.9704C3.59798 14.5785 3.59798 17.1857 5.20606 18.7938C6.81414 20.4019 9.42136 20.4019 11.0294 18.7938L12.9706 16.8527"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "link-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["link","connect","relation","relationship","association","inventory-link","product-relation","user-link","account-link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.0294 12.9706C12.6375 14.5786 15.2447 14.5786 16.8528 12.9706L18.7939 11.0294C20.402 9.42135 20.402 6.81414 18.7939 5.20606C17.1858 3.59798 14.5786 3.59798 12.9705 5.20606L11.0294 7.14719"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.9706 11.0293C11.3625 9.42122 8.75527 9.42122 7.14719 11.0293L5.20606 12.9704C3.59798 14.5785 3.59798 17.1857 5.20606 18.7938C6.81414 20.4019 9.42136 20.4019 11.0294 18.7938L12.9706 16.8527"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Linkedin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["linkedin","social media","connect","network","profile","business","professional","account","link","share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16V13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Linkedin: {
        defaultColors: ["#3D4C66"],
        keywords: ["linkedin","social media","connect","network","profile","business","professional","account","link","share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16V13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    link: {
        defaultColors: ["#3D4C66"],
        keywords: ["linkedin","social media","connect","network","profile","business","professional","account","link","share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9706 11.0294C11.3625 9.42136 8.75527 9.42136 7.14719 11.0294L5.20606 12.9706C3.59798 14.5786 3.59798 17.1859 5.20606 18.7939C6.81414 20.402 9.42136 20.402 11.0294 18.7939L12.9706 16.8528M11.0294 12.9706C12.6375 14.5786 15.2447 14.5786 16.8528 12.9706L18.7939 11.0294C20.402 9.42135 20.402 6.81414 18.7939 5.20606C17.1859 3.59798 14.5786 3.59798 12.9706 5.20606L11.0294 7.14719"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Linkedin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["linkedin","social","network","profile","connect","business","professional","employee","job"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11V16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16V13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13V16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Linkedin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["linkedin","profile","social","network","connection","professional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 6C7.55228 6 8 6.44772 8 7V8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8V7C6 6.44772 6.44772 6 7 6ZM7 10C7.55228 10 8 10.4477 8 11V16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16V11C6 10.4477 6.44772 10 7 10ZM14 9C11.7909 9 10 10.7909 10 13V16C10 16.5523 10.4477 17 11 17C11.5523 17 12 16.5523 12 16V13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13V16C16 16.5523 16.4477 17 17 17C17.5523 17 18 16.5523 18 16V13C18 10.7909 16.2091 9 14 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-check-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","check","checklist","order-list","task-list","inventory-list","completed","done","verified","approved","order-confirmation","item-check","item-list","mark-as-done"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H9V6H5V10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L6 18L5 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-check-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","check","task","complete","order","items","confirmation","done","tick","checkmark","todo","checklist","validated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H9V6H5V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L6 18L5 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","check","complete","order-list","complete-order","tasks","done","confirmation","items","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5C4.44772 5 4 5.44772 4 6V10C4 10.5523 4.44772 11 5 11H9C9.55228 11 10 10.5523 10 10V6C10 5.44772 9.55228 5 9 5H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L6.70711 18.7071C6.51957 18.8946 6.26522 19 6 19C5.73478 19 5.48043 18.8946 5.29289 18.7071L4.29289 17.7071C3.90237 17.3166 3.90237 16.6834 4.29289 16.2929C4.68342 15.9024 5.31658 15.9024 5.70711 16.2929L6 16.5858L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7H19C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C12 11.4477 12.4477 11 13 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19L19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17L13 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","check","checkmark","order","order-list","items","complete","done","confirmation","receipt","invoice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H9V6H5V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L6 18L5 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-indefinite-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","menu","options","categories","inventory","items","products","display","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H9V6H5V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-indefinite-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","menu","options","settings","configuration","display","layout","categories","filters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H9V6H5V10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-left-arrow-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","back","return","item-list","order-list","previous","left-arrow","go-back","remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 13.9999L13 11.9999M13 11.9999L14.9999 10M13 11.9999L19 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 14L11 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10L11 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-indefinite-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","categories","group","grid","selection","layout","dashboard","report","inventory","customers","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6C4 5.44772 4.44772 5 5 5H9C9.55228 5 10 5.44772 10 6V10C10 10.5523 9.55228 11 9 11H5C4.44772 11 4 10.5523 4 10V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 16C4 14.3431 5.34315 13 7 13C8.65685 13 10 14.3431 10 16C10 17.6569 8.65685 19 7 19C5.34315 19 4 17.6569 4 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7H19C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C12 11.4477 12.4477 11 13 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19L19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17L13 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-indefinite": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","inventory","category","options","selection","filter","settings","menu","products","items","sort","group","organize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H9V6H5V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-left-arrow-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","items","back","arrow-left","previous","move","indent","decrease-indent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14L11 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10L11 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13.9999L13 11.9999M13 11.9999L14.9999 10M13 11.9999L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-left-arrow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","back","return","navigation","collapse","hide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 14C4 13.4477 4.44772 13 5 13H10C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H5C4.44772 15 4 14.5523 4 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 10C4 9.44772 4.44772 9 5 9H10C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11H5C4.44772 11 4 10.5523 4 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.707 9.29288C16.0975 9.6834 16.0975 10.3166 15.707 10.7071L15.4141 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L15.4143 13L15.7071 13.2928C16.0976 13.6833 16.0976 14.3164 15.7071 14.707C15.3166 15.0975 14.6834 15.0975 14.2929 14.707L12.2929 12.7071C11.9024 12.3165 11.9024 11.6834 12.2929 11.2928L14.2928 9.2929C14.6833 8.90237 15.3164 8.90236 15.707 9.29288Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "List-left-arrow": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","back","return","previous","collapse","minimize","hide","left-arrow","item-list","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14L11 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10L11 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13.9999L13 11.9999M13 11.9999L14.9999 10M13 11.9999L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-music-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","playlist","entertainment","queue","background-music","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6C6 5.44772 6.44772 5 7 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H7C6.44772 7 6 6.55228 6 6ZM12 8C12 6.34315 13.3431 5 15 5C16.6569 5 18 6.34315 18 8C18 8.82815 17.6631 9.57952 17.1213 10.1213C16.5795 10.6631 15.8282 11 15 11C14.6494 11 14.3128 10.9398 14 10.8293V15C14 16.1043 13.5512 17.1057 12.8284 17.8284C12.1057 18.5512 11.1043 19 10 19C7.79086 19 6 17.2091 6 15C6 12.7909 7.79086 11 10 11C10.7286 11 11.4117 11.1948 12 11.5351V8ZM12 15C12 13.8954 11.1046 13 10 13C8.89543 13 8 13.8954 8 15C8 16.1046 8.89543 17 10 17C10.5526 17 11.0512 16.7772 11.4142 16.4142C11.7772 16.0512 12 15.5526 12 15ZM14 8C14 8.55228 14.4477 9 15 9C15.2764 9 15.525 8.88917 15.7071 8.70711C15.8892 8.52505 16 8.27642 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8ZM6 9C6 8.44772 6.44772 8 7 8H8.5C9.05228 8 9.5 8.44772 9.5 9C9.5 9.55228 9.05228 10 8.5 10H7C6.44772 10 6 9.55228 6 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-music-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","song","playlist","entertainment","sound","audio","jukebox","ambiance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8C13 9.10457 13.8954 10 15 10C15.5523 10 16.0523 9.77614 16.4142 9.41421C16.7761 9.05228 17 8.55228 17 8C17 6.89543 16.1046 6 15 6C13.8954 6 13 6.89543 13 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8L13 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 6H11M9 9H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "list-music-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","playlist","queue","entertainment","audio","sound","background-music","jingle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-music-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","song","playlist","queue","menu","entertainment","list-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-music-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","entertainment","playlist","sound","ambiance","atmosphere","background-music","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 6H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-music-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","note","song","playlist","entertainment","audio","ambiance","jukebox","soundtrack","volume","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5528 5.10558C12.8916 4.93619 13.297 4.97274 13.6 5.20001L17.6 8.20001C18.0418 8.53138 18.1314 9.15818 17.8 9.60001C17.4686 10.0418 16.8418 10.1314 16.4 9.80001L14 8.00001V15C14 16.1043 13.5512 17.1057 12.8284 17.8284C12.1057 18.5512 11.1043 19 10 19C7.79086 19 6 17.2091 6 15C6 12.7909 7.79086 11 10 11C10.7286 11 11.4117 11.1948 12 11.5351V6.00001C12 5.62123 12.214 5.27497 12.5528 5.10558ZM12 15C12 13.8954 11.1046 13 10 13C8.89543 13 8 13.8954 8 15C8 16.1046 8.89543 17 10 17C10.5526 17 11.0512 16.7772 11.4142 16.4142C11.7772 16.0512 12 15.5526 12 15ZM5 6.00001C5 5.44772 5.44772 5.00001 6 5.00001H9C9.55228 5.00001 10 5.44772 10 6.00001C10 6.55229 9.55228 7.00001 9 7.00001H6C5.44772 7.00001 5 6.55229 5 6.00001ZM5 9.00001C5 8.44772 5.44772 8.00001 6 8.00001H7.5C8.05228 8.00001 8.5 8.44772 8.5 9.00001C8.5 9.55229 8.05228 10 7.5 10H6C5.44772 10 5 9.55229 5 9.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-music": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","list","songs","playlist","entertainment","audio","background-music","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8C13 9.10457 13.8954 10 15 10C15.5523 10 16.0523 9.77614 16.4142 9.41421C16.7761 9.05228 17 8.55228 17 8C17 6.89543 16.1046 6 15 6C13.8954 6 13 6.89543 13 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 6H11M9 9H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "list-music-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","playlist","queue","song","audio","entertainment","background-music","select-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 16.6569 8.34315 18 10 18C10.8284 18 11.5784 17.6642 12.1213 17.1213C12.6642 16.5784 13 15.8284 13 15C13 13.3431 11.6569 12 10 12C8.34315 12 7 13.3431 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8C13 9.10457 13.8954 10 15 10C15.5523 10 16.0523 9.77614 16.4142 9.41421C16.7761 9.05228 17 8.55228 17 8C17 6.89543 16.1046 6 15 6C13.8954 6 13 6.89543 13 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 6H11M9 9H7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "list-ordered--1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","ordered","menu","numbered","sequence","options","steps","process","queue","priority","tasks","schedule","workflow","steps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H6M6 10V6L5 7M6 10H7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18H5V17C5 16.4477 5.44772 16 6 16V16C6.55228 16 7 15.5523 7 15V15C7 14.4477 6.55228 14 6 14L5 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L11 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-ordered--2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","ordered","numbered","items","menu","queue","sequence","rank","listing","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10H6M6 10V6L5 7M6 10H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18H5V17C5 16.4477 5.44772 16 6 16V16C6.55228 16 7 15.5523 7 15V15C7 14.4477 6.55228 14 6 14L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H11"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L11 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-ordered--3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","ordered","numbered","sequence","options","settings","menu","inventory","categories","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7H19C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.38268 5.07615C6.75636 5.23093 7 5.59557 7 6.00003V9.00003C7.55228 9.00003 8 9.44774 8 10C8 10.5523 7.55228 11 7 11H5C4.44772 11 4 10.5523 4 10C4 9.44774 4.44772 9.00003 5 9.00003V8.00003C4.74408 8.00003 4.48816 7.9024 4.29289 7.70714C3.90237 7.31661 3.90237 6.68345 4.29289 6.29292L5.29289 5.29292C5.57889 5.00692 6.00901 4.92137 6.38268 5.07615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 13H6C7.10457 13 8 13.8954 8 15C8 16.1046 7.10457 17 6 17H7C7.55228 17 8 17.4477 8 18C8 18.5523 7.55228 19 7 19H5C4.44772 19 4 18.5523 4 18V17C4 15.8954 4.89543 15 6 15H5C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 12C10 11.4477 10.4477 11 11 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H11C10.4477 13 10 12.5523 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19L19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17L11 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-radio-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","radio","options","menu","select","choice","selection","settings","preferences","configure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.89543 5.89543 6 7 6C8.10457 6 9 6.89543 9 8C9 9.10457 8.10457 10 7 10C5.89543 10 5 9.10457 5 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 8C6.5 7.72386 6.72386 7.5 7 7.5C7.27614 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.27614 6.5 8Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-ordered-": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","ordered-list","number","item","sequence","checkout-sequence","order-sequence","menu-list","menu","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 10H6M6 10V6L5 7M6 10H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L11 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18H5V17C5 16.4477 5.44772 16 6 16V16C6.55228 16 7 15.5523 7 15V15C7 14.4477 6.55228 14 6 14L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-radio-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","radio","options","menu","choices","select","settings","configuration","customize","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.89543 5.89543 6 7 6C8.10457 6 9 6.89543 9 8C9 9.10457 8.10457 10 7 10C5.89543 10 5 9.10457 5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 8C6.5 7.72386 6.72386 7.5 7 7.5C7.27614 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.27614 6.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "list-radio-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","options","radio","selection","menu","settings","preferences","display","items","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.5 8C6.5 7.72386 6.72386 7.5 7 7.5C7.27614 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.27614 6.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 8C4 6.34315 5.34315 5 7 5C8.65685 5 10 6.34315 10 8C10 9.65685 8.65685 11 7 11C5.34315 11 4 9.65685 4 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 16C4 14.3431 5.34315 13 7 13C8.65685 13 10 14.3431 10 16C10 17.6569 8.65685 19 7 19C5.34315 19 4 17.6569 4 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7H19C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C12 11.4477 12.4477 11 13 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19L19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17L13 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "list-radio": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","radio","options","menu","settings","configuration","choices","select","selection","alternatives","list-radio","filters"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8C5 6.89543 5.89543 6 7 6C8.10457 6 9 6.89543 9 8C9 9.10457 8.10457 10 7 10C5.89543 10 5 9.10457 5 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 8C6.5 7.72386 6.72386 7.5 7 7.5C7.27614 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.27614 6.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L13 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-right-arrow-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","items","menu","options","arrow","select","order-options","more","details","details-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 13.9999L11 11.9999M11 11.9999L9.00012 10M11 11.9999L5 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 14L19 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L19 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-right-arrow-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","arrow","import","insert","add-to-list","insert-list","item-import"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 14L19 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L19 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13.9999L11 11.9999M11 11.9999L9.00012 10M11 11.9999L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "List-right-arrow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["import","order","import-order","arrow","list","menu","options","process","load"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 14C13 13.4477 13.4477 13 14 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H14C13.4477 15 13 14.5523 13 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 10C13 9.44772 13.4477 9 14 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H14C13.4477 11 13 10.5523 13 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29303 9.29288C8.68356 8.90236 9.31672 8.90237 9.70724 9.2929L11.7071 11.2928C12.0976 11.6834 12.0976 12.3165 11.7071 12.7071L9.7071 14.707C9.31656 15.0975 8.6834 15.0975 8.29288 14.707C7.90236 14.3164 7.90237 13.6833 8.2929 13.2928L8.58571 13L5.00001 13C4.44773 13 4.00001 12.5523 4 12C3.99999 11.4477 4.4477 11 4.99999 11L8.58587 11L8.293 10.7071C7.90249 10.3166 7.9025 9.6834 8.29303 9.29288Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "List-right-arrow": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","arrow","right","select","choose","enter","details","order-details","options","more-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 14L19 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L19 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 6L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13.9999L11 11.9999M11 11.9999L9.00012 10M11 11.9999L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Loading-1": {
        defaultColors: ["#E5E5E5", "#3D4C66"],
        keywords: ["loading","spinner","progress","waiting","syncing","processing","buffering","updating","connecting","transaction-pending","order-processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Loading-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["loading","spinner","progress","waiting","updating","processing","syncing","buffering","connecting","pending","calculating","fetching"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7V5C11 4.44772 11.4477 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 16C12.5523 16 13 16.4477 13 17V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V17C11 16.4477 11.4477 16 12 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 11H7C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H17C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2929 14.2929C14.6834 13.9023 15.3165 13.9023 15.7071 14.2929L17.7071 16.2929C18.0976 16.6834 18.0976 17.3165 17.7071 17.7071C17.3165 18.0976 16.6834 18.0976 16.2929 17.7071L14.2929 15.7071C13.9023 15.3165 13.9023 14.6834 14.2929 14.2929Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7071 6.29293C18.0976 6.68345 18.0976 7.31662 17.7071 7.70714L15.7071 9.70714C15.3165 10.0977 14.6834 10.0977 14.2929 9.70714C13.9023 9.31662 13.9023 8.68346 14.2929 8.29293L16.2929 6.29293C16.6834 5.90241 17.3165 5.90241 17.7071 6.29293Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Loading-2": {
        defaultColors: ["#E5E5E5", "#3D4C66"],
        keywords: ["loading","spinner","progress","waiting","processing","syncing","data transfer","busy","refreshing","updating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Loading-4": {
        defaultColors: ["#3D4C66", "#E5E5E5"],
        keywords: ["loading","spinner","waiting","processing","syncing","updating","buffering","connecting","authenticating","downloading","uploading","calculating","retrieving","fetching"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Loading-5": {
        defaultColors: ["#3D4C66", "#E5E5E5"],
        keywords: ["loading","spinner","progress","waiting","syncing","refreshing","processing","wait","updating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Loading-7": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["loading","spinner","processing","waiting","sync","refresh","order-processing","transaction-pending","payment-processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7V5C11 4.44772 11.4477 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 16C12.5523 16 13 16.4477 13 17V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V17C11 16.4477 11.4477 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 11H7C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H17C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2929 14.2929C14.6834 13.9023 15.3165 13.9023 15.7071 14.2929L17.7071 16.2929C18.0976 16.6834 18.0976 17.3165 17.7071 17.7071C17.3165 18.0976 16.6834 18.0976 16.2929 17.7071L14.2929 15.7071C13.9023 15.3165 13.9023 14.6834 14.2929 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7071 6.29293C18.0976 6.68345 18.0976 7.31662 17.7071 7.70714L15.7071 9.70714C15.3165 10.0977 14.6834 10.0977 14.2929 9.70714C13.9023 9.31662 13.9023 8.68346 14.2929 8.29293L16.2929 6.29293C16.6834 5.90241 17.3165 5.90241 17.7071 6.29293Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Loading-6": {
        defaultColors: ["#3D4C66", "#E5E5E5"],
        keywords: ["loading","spinner","progress","waiting","syncing","processing","updating","buffering","connecting","retrieving","order-processing","transaction-pending","system-busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Loading: {
        defaultColors: ["#E5E5E5", "#3D4C66"],
        keywords: ["loading","spinner","progress","waiting","syncing","processing","updating","buffering","connecting","retrieving","order-processing","transaction-pending","system-busy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 7V5" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 12L5 12" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L17 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L15 15" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L7 7" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L7 17" stroke={colors?.[0] || "#E5E5E5"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","map","pin","address","store","customer-location","delivery-address","outlet","branch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C12.8284 14 13.5784 13.6642 14.1213 13.1213C14.6642 12.5784 15 11.8284 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","address","store","delivery","pickup","customer-location","shipping-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.71979 3.25 4.25 6.71979 4.25 11C4.25 13.1399 5.11827 15.0784 6.51992 16.4801C7.36639 17.3265 8.40867 17.9787 9.574 18.3625L11.4351 20.4934C11.5775 20.6564 11.7835 20.75 12 20.75C12.2165 20.75 12.4225 20.6564 12.5649 20.4934L14.426 18.3625C15.5913 17.9787 16.6336 17.3265 17.4801 16.4801C18.8817 15.0784 19.75 13.1399 19.75 11C19.75 6.71979 16.2802 3.25 12 3.25ZM12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 11.8284 14.6642 12.5784 14.1213 13.1213C13.5784 13.6642 12.8284 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","address","store","delivery-address","pickup-location","customer-location","shipping-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C12.8284 14 13.5784 13.6642 14.1213 13.1213C14.6642 12.5784 15 11.8284 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.6"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","address","store-location","delivery-address","gps","navigation","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 12.6569 10.3431 14 12 14C12.8284 14 13.5784 13.6642 14.1213 13.1213C14.6642 12.5784 15 11.8284 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","map","pin","address","delivery","store-location","customer-location","pickup","shipping","destination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10.8571C19 7.07005 15.866 4 12 4C8.13401 4 5 7.07005 5 10.8571C5 12.6134 5.67399 14.2154 6.78242 15.4286L12 20L17.2176 15.4286C18.326 14.2154 19 12.6134 19 10.8571Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","gps","address","store-location","delivery-address","customer-location","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10.8571C19 7.07005 15.866 4 12 4C8.13401 4 5 7.07005 5 10.8571C5 12.6134 5.67399 14.2154 6.78242 15.4286L12 20L17.2176 15.4286C18.326 14.2154 19 12.6134 19 10.8571Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","gps","address","store-location","customer-location","delivery-address","shipping-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.73445 3.25 4.25 6.64133 4.25 10.8571C4.25 12.8097 5.00026 14.5899 6.22873 15.9345C6.24745 15.955 6.26729 15.9744 6.28817 15.9927L11.5058 20.5641C11.7886 20.812 12.2114 20.812 12.4942 20.5641L17.7118 15.9927C17.7327 15.9744 17.7526 15.955 17.7713 15.9345C18.9997 14.5899 19.75 12.8097 19.75 10.8571C19.75 6.64133 16.2656 3.25 12 3.25ZM12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","map","address","store-location","delivery-address","customer-location","pickup-location","navigation","maps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 11.1258 7.37209 12.1647 8 13.0005L12 19L16 13.0005C16.6279 12.1647 17 11.1258 17 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","store","address","gps","navigation","customer-location","store-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 11.1258 7.37209 12.1647 8 13.0005L12 19L16 13.0005C16.6279 12.1647 17 11.1258 17 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map-pin","address","store-location","delivery-address","map","pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4.25C8.82436 4.25 6.25 6.82436 6.25 10C6.25 11.286 6.67306 12.4753 7.38728 13.4335L11.376 19.416C11.5151 19.6247 11.7492 19.75 12 19.75C12.2508 19.75 12.4849 19.6247 12.624 19.416L16.6127 13.4335C17.3269 12.4753 17.75 11.286 17.75 10C17.75 6.82436 15.1756 4.25 12 4.25ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 9.44771 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 8.34315 10.3431 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","address","store","pickup","delivery","tracking","GPS","navigation","here"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05025 6.06245C9.78392 3.31252 14.2161 3.31252 16.9497 6.06245C19.6834 8.81237 19.6834 13.2709 16.9497 16.0208L12 20L7.05025 16.0208C4.31658 13.2709 4.31658 8.81237 7.05025 6.06245Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","map","pin","address","delivery","store","pickup","geotag","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05025 6.06245C9.78392 3.31252 14.2161 3.31252 16.9497 6.06245C19.6834 8.81237 19.6834 13.2709 16.9497 16.0208L12 20L7.05025 16.0208C4.31658 13.2709 4.31658 8.81237 7.05025 6.06245Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","pin","map","address","store","pickup","delivery","gps","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10.8571C19 7.07005 15.866 4 12 4C8.13401 4 5 7.07005 5 10.8571C5 12.6134 5.67399 14.2154 6.78242 15.4286L12 20L17.2176 15.4286C18.326 14.2154 19 12.6134 19 10.8571Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-arrow-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","navigation","location","direction","send","submit","next","proceed","checkout","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4551 9.11989L15.2552 14.9863C14.3312 17.4503 13.8692 18.6823 13.1344 18.6405C12.3996 18.5986 12.0805 17.3221 11.4422 14.7691L11.291 14.1643C11.1492 13.5971 11.0783 13.3135 10.8825 13.1177C10.6866 12.9218 10.403 12.8509 9.83583 12.7091L9.23091 12.5579C6.67795 11.9197 5.40147 11.6005 5.35961 10.8658C5.31776 10.131 6.54975 9.66897 9.01372 8.74496L14.8801 6.54499C16.6554 5.87926 17.543 5.5464 17.9983 6.00171C18.4536 6.45702 18.1208 7.34465 17.4551 9.11989Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","address","store","customer","delivery","pickup","navigation","gps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05025 6.06245C9.78392 3.31252 14.2161 3.31252 16.9497 6.06245C19.6834 8.81237 19.6834 13.2709 16.9497 16.0208L12 20L7.05025 16.0208C4.31658 13.2709 4.31658 8.81237 7.05025 6.06245Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.6"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","address","store","delivery","pickup","GPS","navigation","destination","point of sale","branch","store location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4816 5.53369C14.4547 2.48877 9.54527 2.48877 6.51835 5.53369C3.49388 8.57615 3.49388 13.5071 6.51835 16.5496L6.54779 16.5792L12 20.9623L17.4522 16.5792L17.4816 16.5496C20.5061 13.5071 20.5061 8.57615 17.4816 5.53369ZM15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "location-arrow-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["direction","navigate","arrow","send","submit","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4551 9.11989L15.2552 14.9863C14.3312 17.4503 13.8692 18.6823 13.1344 18.6405C12.3996 18.5986 12.0805 17.3221 11.4422 14.7691L11.291 14.1643C11.1492 13.5971 11.0783 13.3135 10.8825 13.1177C10.6866 12.9218 10.403 12.8509 9.83583 12.7091L9.23091 12.5579C6.67795 11.9197 5.40147 11.6005 5.35961 10.8658C5.31776 10.131 6.54975 9.66897 9.01372 8.74496L14.8801 6.54499C16.6554 5.87926 17.543 5.5464 17.9983 6.00171C18.4536 6.45702 18.1208 7.34465 17.4551 9.11989Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-arrow": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","navigation","send","direction","point","arrow","gps","shipping","delivery","address","current-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4551 9.11989L15.2552 14.9863C14.3312 17.4503 13.8692 18.6823 13.1344 18.6405C12.3996 18.5986 12.0805 17.3221 11.4422 14.7691L11.291 14.1643C11.1492 13.5971 11.0783 13.3135 10.8825 13.1177C10.6866 12.9218 10.403 12.8509 9.83583 12.7091L9.23091 12.5579C6.67795 11.9197 5.40147 11.6005 5.35961 10.8658C5.31776 10.131 6.54975 9.66897 9.01372 8.74496L14.8801 6.54499C16.6554 5.87926 17.543 5.5464 17.9983 6.00171C18.4536 6.45702 18.1208 7.34465 17.4551 9.11989Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-arrow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","location","navigation","direction","send","submit","next","forward","checkout","delivery","shipping","order-tracking","gps","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6551 5.08457C17.1896 4.95931 17.9486 4.88828 18.5264 5.50736C19.1043 6.12645 19.038 6.93971 18.9211 7.5124C18.8032 8.09003 18.5479 8.81919 18.2559 9.65336L16.1306 15.7255C15.7169 16.9077 15.3732 17.8899 15.0404 18.5644C14.8701 18.9095 14.6637 19.2581 14.3944 19.5234C14.1004 19.813 13.704 20.0268 13.2204 19.9973C12.7368 19.9678 12.3656 19.7071 12.1043 19.3837C11.8648 19.0873 11.6966 18.7159 11.564 18.3523C11.3049 17.6416 11.0675 16.624 10.7817 15.3991L10.6214 14.7122C10.55 14.406 10.5122 14.2492 10.4756 14.1404L10.4739 14.1352L10.4691 14.1334C10.3675 14.0941 10.2211 14.0537 9.93541 13.9772L9.29417 13.8054C8.15094 13.4992 7.20112 13.2448 6.53787 12.9672C6.19852 12.8251 5.85187 12.6449 5.57524 12.3884C5.27334 12.1084 5.03009 11.7107 5.00254 11.1925C4.975 10.6744 5.17452 10.2497 5.44479 9.93474C5.69244 9.64618 6.01775 9.42497 6.33985 9.24255C6.96939 8.886 7.8861 8.51771 8.98949 8.07442L14.6568 5.79732C15.4354 5.48442 16.1159 5.21091 16.6551 5.08457Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","check","valid","verified","order-placed","delivery-location","delivery","approved","confirmed","point-of-sale","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","check","location-check","approved-location","confirmed-location","location-services-enabled","geolocation","check-mark","tick","verified","approved","confirmed","completed","success","delivery","route","route-optimized"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","check","verified","approved","confirmed","geolocation","delivery-location","service-area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.71979 3.25 4.25 6.71979 4.25 11C4.25 13.1399 5.11827 15.0784 6.51992 16.4801C7.36639 17.3265 8.40867 17.9787 9.574 18.3625L11.4351 20.4934C11.5775 20.6564 11.7835 20.75 12 20.75C12.2165 20.75 12.4225 20.6564 12.5649 20.4934L14.426 18.3625C15.5913 17.9787 16.6336 17.3265 17.4801 16.4801C18.8817 15.0784 19.75 13.1399 19.75 11C19.75 6.71979 16.2802 3.25 12 3.25ZM14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L11 11.5858L10.7071 11.2929C10.3166 10.9024 9.68342 10.9024 9.29289 11.2929C8.90237 11.6834 8.90237 12.3166 9.29289 12.7071L10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L14.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","cross","cancel","remove","disable","delete","address","wrong","incorrect","map","pin","navigation","error","unavailable","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 9M14 13L10 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","check","valid","address","gps","verified","delivery-location","correct"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","pin","cancel","remove","delete","unavailable","out-of-stock","error","cross","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 9M14 13L10 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","cross","remove","cancel","disable","error","unavailable","store-closed","delete-location","store","map","pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.71979 3.25 4.25 6.71979 4.25 11C4.25 13.1399 5.11827 15.0784 6.51992 16.4801C7.36639 17.3265 8.40867 17.9787 9.574 18.3625L11.4351 20.4934C11.5775 20.6564 11.7835 20.75 12 20.75C12.2165 20.75 12.4225 20.6564 12.5649 20.4934L14.426 18.3625C15.5913 17.9787 16.6336 17.3265 17.4801 16.4801C18.8817 15.0784 19.75 13.1399 19.75 11C19.75 6.71979 16.2802 3.25 12 3.25ZM14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289L12 9.58579L10.7071 8.29289C10.3166 7.90237 9.68342 7.90237 9.29289 8.29289C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711L10.5858 11L9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L12 12.4142L13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929L13.4142 11L14.7071 9.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","cross","error","cancel","remove-location","delete-location","disable-location","block-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 13L14 9M14 13L10 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","minus","remove location","disable location","map pin","subtract","remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","remove location","delete location","disable location","location minus","minus","subtract","remove","discount","decrease","reduce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 11L14 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","remove location","remove","minus","disable location","map-pin","map","delivery-area","service-area","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.71979 3.25 4.25 6.71979 4.25 11C4.25 13.1399 5.11827 15.0784 6.51992 16.4801C7.36639 17.3265 8.40867 17.9787 9.574 18.3625L11.4351 20.4934C11.5775 20.6564 11.7835 20.75 12 20.75C12.2165 20.75 12.4225 20.6564 12.5649 20.4934L14.426 18.3625C15.5913 17.9787 16.6336 17.3265 17.4801 16.4801C18.8817 15.0784 19.75 13.1399 19.75 11C19.75 6.71979 16.2802 3.25 12 3.25ZM13 10C13 10 12.5523 10 12 10C11.4477 10 11 10 11 10H10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12H11C11 12 11.4477 12 12 12C12.5523 12 13 12 13 12H14C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","remove","minus","delete","map","pin","remove-location","disable-location","hide-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 12.933 5.7835 14.683 7.05025 15.9497C7.86157 16.7611 8.87111 17.3741 10 17.7101L12 20L14 17.7101C15.1289 17.3741 16.1384 16.7611 16.9497 15.9497C18.2165 14.683 19 12.933 19 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "location-pin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["location","pin","map","address","customer-location","delivery-address","store-location","business-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-pin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["location","map","pin","store-location","customer-location","delivery-address","address","navigation","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-pin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","map","pin","address","store-location","delivery-address","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.91865 16.1834C7.36963 16.5022 7.47679 17.1263 7.15799 17.5772C7.0353 17.7508 7 17.8896 7 18C7 18.2456 7.22509 18.7372 8.20457 19.2269C9.12424 19.6867 10.4647 20 12 20C13.5353 20 14.8758 19.6867 15.7954 19.2269C16.7749 18.7372 17 18.2456 17 18C17 17.8896 16.9647 17.7508 16.842 17.5772C16.5232 17.1263 16.6304 16.5022 17.0814 16.1834C17.5323 15.8646 18.1564 15.9718 18.4752 16.4228C18.7947 16.8748 19 17.4091 19 18C19 19.4113 17.8819 20.4197 16.6899 21.0157C15.438 21.6417 13.7784 22 12 22C10.2216 22 8.56205 21.6417 7.31015 21.0157C6.11805 20.4197 5 19.4113 5 18C5 17.4091 5.20532 16.8748 5.52483 16.4228C5.84363 15.9718 6.46767 15.8646 6.91865 16.1834Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C8.25757 3.25 5.25 6.3427 5.25 10.125C5.25 12.0182 6.00248 13.7364 7.22159 14.9809C7.95087 15.7253 8.84851 16.3018 9.85356 16.6449L11.4301 18.4876C11.5726 18.6541 11.7808 18.75 12 18.75C12.2192 18.75 12.4274 18.6541 12.5699 18.4876L14.1464 16.6449C15.1515 16.3018 16.0491 15.7253 16.7784 14.9809C17.9975 13.7364 18.75 12.0182 18.75 10.125C18.75 6.3427 15.7424 3.25 12 3.25ZM12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "location-pin-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","pin","map","address","store","delivery","pickup","destination","gps","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.05025 14.9497L6.51992 15.4801L6.54636 15.5065L6.57529 15.5302L7.05025 14.9497ZM12 3V3.75V3ZM12 19L11.525 19.5804L12 19.9691L12.475 19.5804L12 19ZM16.9497 14.9497L17.4247 15.5302L17.4536 15.5065L17.4801 15.4801L16.9497 14.9497ZM16.9497 5.05025L16.4194 5.58058L16.9497 5.05025ZM7.58058 14.4194C5.13981 11.9786 5.13981 8.02136 7.58058 5.58058L6.51992 4.51992C3.49336 7.54649 3.49336 12.4535 6.51992 15.4801L7.58058 14.4194ZM7.58058 5.58058C8.80112 4.36005 10.3993 3.75 12 3.75V2.25C10.0178 2.25 8.03306 3.00679 6.51992 4.51992L7.58058 5.58058ZM12.475 18.4196L7.52521 14.3693L6.57529 15.5302L11.525 19.5804L12.475 18.4196ZM17.4801 15.4801C20.5066 12.4535 20.5066 7.54649 17.4801 4.51992L16.4194 5.58058C18.8602 8.02136 18.8602 11.9786 16.4194 14.4194L17.4801 15.4801ZM17.4801 4.51992C15.9669 3.00679 13.9822 2.25 12 2.25V3.75C13.6007 3.75 15.1989 4.36005 16.4194 5.58058L17.4801 4.51992ZM12.475 19.5804L17.4247 15.5302L16.4748 14.3693L11.525 18.4196L12.475 19.5804Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-pin-5": {
        defaultColors: ["#8E5EE5", "#3D4C66", "#2797E8"],
        keywords: ["location","pin","map","gps","address","store-location","customer-location","delivery-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V21"
                    stroke={colors?.[0] || "#8E5EE5"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.05025 14.9497L6.51992 15.4801L6.54636 15.5065L6.57529 15.5302L7.05025 14.9497ZM12 3V3.75V3ZM12 19L11.525 19.5804L12 19.9691L12.475 19.5804L12 19ZM16.9497 14.9497L17.4247 15.5302L17.4536 15.5065L17.4801 15.4801L16.9497 14.9497ZM16.9497 5.05025L16.4194 5.58058L16.9497 5.05025ZM7.58058 14.4194C5.13981 11.9786 5.13981 8.02136 7.58058 5.58058L6.51992 4.51992C3.49336 7.54649 3.49336 12.4535 6.51992 15.4801L7.58058 14.4194ZM7.58058 5.58058C8.80112 4.36005 10.3993 3.75 12 3.75V2.25C10.0178 2.25 8.03306 3.00679 6.51992 4.51992L7.58058 5.58058ZM12.475 18.4196L7.52521 14.3693L6.57529 15.5302L11.525 19.5804L12.475 18.4196ZM17.4801 15.4801C20.5066 12.4535 20.5066 7.54649 17.4801 4.51992L16.4194 5.58058C18.8602 8.02136 18.8602 11.9786 16.4194 14.4194L17.4801 15.4801ZM17.4801 4.51992C15.9669 3.00679 13.9822 2.25 12 2.25V3.75C13.6007 3.75 15.1989 4.36005 16.4194 5.58058L17.4801 4.51992ZM12.475 19.5804L17.4247 15.5302L16.4748 14.3693L11.525 18.4196L12.475 19.5804Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[2] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-pin-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","map","pin","gps","address","store-location","customer-location","delivery-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05025 5.05025C4.31658 7.78392 4.31658 12.2161 7.05025 14.9497L12 19L16.9497 14.9497C19.6834 12.2161 19.6834 7.78392 16.9497 5.05025C15.5829 3.68342 13.7915 3 12 3C10.2085 3 8.41709 3.68342 7.05025 5.05025Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M11.25 21C11.25 21.4142 11.5858 21.75 12 21.75C12.4142 21.75 12.75 21.4142 12.75 21H11.25ZM7.05025 14.9497L6.51992 15.4801L6.54636 15.5065L6.57529 15.5302L7.05025 14.9497ZM7.05025 5.05025L7.58058 5.58058L7.05025 5.05025ZM16.9497 14.9497L17.4247 15.5302L17.4536 15.5065L17.4801 15.4801L16.9497 14.9497ZM16.9497 5.05025L16.4194 5.58058V5.58058L16.9497 5.05025ZM11.25 19V21H12.75V19H11.25ZM7.58058 14.4194C5.13981 11.9786 5.13981 8.02136 7.58058 5.58058L6.51992 4.51992C3.49336 7.54649 3.49336 12.4535 6.51992 15.4801L7.58058 14.4194ZM7.58058 5.58058C8.80112 4.36005 10.3993 3.75 12 3.75V2.25C10.0178 2.25 8.03306 3.00679 6.51992 4.51992L7.58058 5.58058ZM12.475 18.4196L7.52521 14.3693L6.57529 15.5302L11.525 19.5804L12.475 18.4196ZM17.4801 15.4801C20.5066 12.4535 20.5066 7.54649 17.4801 4.51992L16.4194 5.58058C18.8602 8.02136 18.8602 11.9786 16.4194 14.4194L17.4801 15.4801ZM17.4801 4.51992C15.9669 3.00679 13.9822 2.25 12 2.25V3.75C13.6007 3.75 15.1989 4.36005 16.4194 5.58058L17.4801 4.51992ZM12.475 19.5804L17.4247 15.5302L16.4748 14.3693L11.525 18.4196L12.475 19.5804Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "location-pin-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","pin","map","address","delivery-address","customer-location","store-location","coordinates","navigation","route","direction","branch","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.37839 15.6921L11 19.4738V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V19.4738L17.6216 15.6921L17.6569 15.6569C20.781 12.5327 20.781 7.46734 17.6569 4.34315C16.095 2.78124 14.0458 2 12 2C9.95417 2 7.90505 2.78124 6.34315 4.34315C3.21895 7.46734 3.21895 12.5327 6.34315 15.6569L6.37839 15.6921ZM12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "location-pin": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","pin","map","address","store-location","delivery-address","customer-location","business-location","shop-location","coordinates","find-location","destination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-plus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["location","add-location","plus","add","map-pin","new-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 11H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["location","add-location","new-location","plus","add","map","add-address","pin","add-pin","new-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 11H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Location-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","add","new","plus","add-location","new-location","store","add-store","new-store","add-branch","new-branch","branch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 10.7976C3 5.90757 7.15171 2 12 2C16.8483 2 21 5.90757 21 10.7976C21 14.2828 18.9649 17.2902 16.0219 18.7143L16.0031 18.7231C15.6435 18.888 15.016 19.2426 14.3918 19.7384C13.7607 20.2396 13.2032 20.8297 12.8944 21.4472C12.725 21.786 12.3788 22 12 22C11.6212 22 11.275 21.786 11.1056 21.4472C10.7968 20.8297 10.2393 20.2396 9.60821 19.7384C8.98398 19.2426 8.35654 18.888 7.9969 18.7231L7.97814 18.7143C5.03514 17.2902 3 14.2828 3 10.7976ZM12 14C11.4477 14 11 13.5523 11 13V12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10H11V9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V10H14C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12H13V13C13 13.5523 12.5523 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","plus","add","new-location","add-location","map","pin","new","create-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 11H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 3C7.67223 3 4 6.49109 4 10.7976C4 13.883 5.80086 16.5498 8.41371 17.8141C9.2758 18.2094 11.2 19.4 12 21C12.8 19.4 14.7242 18.2094 15.5863 17.8141C18.1991 16.5498 20 13.883 20 10.7976C20 6.49109 16.3278 3 12 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Location-user 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["location","user","customer","profile","member","delivery","address","pickup","find-customer","locate","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 16.2241C9.18448 15.4442 10.5484 15 12 15C13.4516 15 14.8155 15.4442 16 16.2241"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="10" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Location-user 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","location","customer","profile","employee","user-location","customer-location","employee-location","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16.2241C9.18448 15.4442 10.5484 15 12 15C13.4516 15 14.8155 15.4442 16 16.2241"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="10"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Location-user 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","user","customer","address","map","pin","customer-location","delivery-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="10" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 16.2241C9.18448 15.4442 10.5484 15 12 15C13.4516 15 14.8155 15.4442 16 16.2241"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location-user 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","user","customer","employee","profile","pin","map","address","delivery-address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C7.81154 3.25 4.25 6.67654 4.25 10.9312C4.25 13.9672 5.99519 16.5946 8.53114 17.8412L8.54531 17.8479C8.8685 17.9985 9.42603 18.3189 9.98043 18.7662C10.5396 19.2173 11.0442 19.7564 11.3271 20.3312C11.4533 20.5876 11.7142 20.75 12 20.75C12.2858 20.75 12.5467 20.5876 12.6729 20.3312C12.9558 19.7564 13.4604 19.2173 14.0196 18.7662C14.574 18.3189 15.1315 17.9985 15.4547 17.8479L15.4689 17.8412C18.0048 16.5946 19.75 13.9672 19.75 10.9312C19.75 6.67654 16.1885 3.25 12 3.25ZM11.9999 7.5C10.6192 7.5 9.49994 8.61929 9.49994 10C9.49994 11.3807 10.6192 12.5 11.9999 12.5C13.3806 12.5 14.4999 11.3807 14.4999 10C14.4999 8.61929 13.3806 7.5 11.9999 7.5ZM11.9999 13.25C10.828 13.25 9.709 13.5119 8.6849 13.9859C8.309 14.1599 8.14532 14.6056 8.31931 14.9815C8.4933 15.3574 8.93907 15.5211 9.31497 15.3471C10.1502 14.9605 11.0549 14.75 11.9999 14.75C12.945 14.75 13.8497 14.9605 14.6849 15.3471C15.0608 15.5211 15.5066 15.3574 15.6806 14.9815C15.8546 14.6056 15.6909 14.1599 15.315 13.9859C14.2909 13.5119 13.1719 13.25 11.9999 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-user-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["location","user","customer","employee","staff","member","account","profile","find-user","pin","map-pin","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L9.12127 16.5149C9.30316 15.7874 9.3941 15.4236 9.66536 15.2118C9.93663 15 10.3116 15 11.0616 15H12.9384C13.6884 15 14.0634 15 14.3346 15.2118C14.6059 15.4236 14.6968 15.7874 14.8787 16.5149L15 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="10" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Location-user-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["customer","user","location","profile","account","employee","pin","map-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="10"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                />
                <path
                    d="M9 17L9.12127 16.5149C9.30316 15.7874 9.3941 15.4236 9.66536 15.2118C9.93663 15 10.3116 15 11.0616 15H12.9384C13.6884 15 14.0634 15 14.3346 15.2118C14.6059 15.4236 14.6968 15.7874 14.8787 16.5149L15 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Location-user-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","user","customer","address","map","person","pin","marker","client","delivery","shipping address","customer location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C7.81 3 4.25 6.43 4.25 10.68C4.25 13.72 6 16.34 8.53 17.59H8.54C8.86 17.75 9.42 18.07 9.98 18.51C10.54 18.96 11.04 19.5 11.33 20.08C11.46 20.34 11.72 20.5 12 20.5C12.28 20.5 12.55 20.34 12.67 20.08C12.95 19.51 13.46 18.97 14.02 18.51C14.57 18.06 15.13 17.74 15.46 17.59H15.47C18.01 16.34 19.75 13.71 19.75 10.67C19.75 6.43 16.19 3 12 3ZM12 7C13.38 7 14.5 8.12 14.5 9.5C14.5 10.88 13.38 12 12 12C10.62 12 9.5 10.88 9.5 9.5C9.5 8.12 10.62 7 12 7ZM14.93 15.48C14.87 15.5 14.81 15.5 14.75 15.5C14.41 15.5 14.11 15.27 14.02 14.93C14.02 14.93 14.02 14.93 14.02 14.92C14 14.84 13.99 14.79 13.98 14.74C13.97 14.7 13.96 14.67 13.95 14.64C13.92 14.57 13.85 14.52 13.78 14.51C13.71 14.5 13.63 14.51 13.48 14.51H10.54C10.39 14.51 10.3 14.51 10.24 14.51C10.17 14.53 10.1 14.58 10.07 14.64C10.04 14.7 10.03 14.79 9.99 14.93C9.91 15.27 9.6 15.5 9.26 15.5C9.2 15.5 9.14 15.5 9.08 15.48C8.68 15.38 8.43 14.97 8.53 14.57C8.6 14.3 8.64 14.15 8.72 13.98C8.96 13.5 9.4 13.15 9.92 13.04C10.1 13 10.27 13 10.54 13H13.48C13.75 13 13.92 13 14.1 13.04C14.63 13.15 15.06 13.5 15.3 13.98C15.34 14.07 15.38 14.16 15.41 14.27C15.44 14.36 15.46 14.45 15.49 14.57C15.59 14.97 15.35 15.38 14.94 15.48H14.93Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Location-user": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","user","customer","address","profile","employee","delivery","pickup","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.2132 4 5 7.10319 5 10.9312C5 13.6737 6.57576 16.0443 8.86199 17.1681C9.61633 17.5195 11.3 18.5778 12 20C12.7 18.5778 14.3837 17.5195 15.138 17.1681C17.4242 16.0443 19 13.6737 19 10.9312C19 7.10319 15.7868 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="10" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 17L9.12127 16.5149C9.30316 15.7874 9.3941 15.4236 9.66536 15.2118C9.93663 15 10.3116 15 11.0616 15H12.9384C13.6884 15 14.0634 15 14.3346 15.2118C14.6059 15.4236 14.6968 15.7874 14.8787 16.5149L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Location: {
        defaultColors: ["#3D4C66"],
        keywords: ["location","user","customer","address","profile","employee","delivery","pickup","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 11.1258 7.37209 12.1647 8 13.0005L12 19L16 13.0005C16.6279 12.1647 17 11.1258 17 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock xx-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","password","access","restricted","unlock","authentication","protected","admin","permissions","lock-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M9 16L11 14M11 16L9 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16L15 14M15 16L13 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "lock xx-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","password","authentication","access","restricted","privacy","protected","authorization","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9.07612C17.9751 9.17203 18.6314 9.38879 19.1213 9.87868C20 10.7574 20 12.1716 20 15C20 17.8284 20 19.2426 19.1213 20.1213C18.2426 21 16.8284 21 14 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15C4 12.1716 4 10.7574 4.87868 9.87868C5.36857 9.38879 6.02491 9.17203 7 9.07612V8ZM15 8V9.00174C14.6878 9 14.355 9 14 9H10C9.64496 9 9.31221 9 9 9.00174V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM8.70711 13.2929C8.31658 12.9024 7.68342 12.9024 7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071L7.58579 15L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L9 16.4142L9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071C11.0976 16.3166 11.0976 15.6834 10.7071 15.2929L10.4142 15L10.7071 14.7071C11.0976 14.3166 11.0976 13.6834 10.7071 13.2929C10.3166 12.9024 9.68342 12.9024 9.29289 13.2929L9 13.5858L8.70711 13.2929ZM15 13.5858L14.7071 13.2929C14.3166 12.9024 13.6834 12.9024 13.2929 13.2929C12.9024 13.6834 12.9024 14.3166 13.2929 14.7071L13.5858 15L13.2929 15.2929C12.9024 15.6834 12.9024 16.3166 13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071L15 16.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L16.4142 15L16.7071 14.7071C17.0976 14.3166 17.0976 13.6834 16.7071 13.2929C16.3166 12.9024 15.6834 12.9024 15.2929 13.2929L15 13.5858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock xx-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["lock","security","locked","secure","access","password","authorization","restriction","protection","unavailable","restricted","private"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="10"
                    width="14"
                    height="10"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L11 14M11 16L9 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16L15 14M15 16L13 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "lock xx": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","password","authentication","authorization","locked","secure","private","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 16L11 14M11 16L9 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16L15 14M15 16L13 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "lock-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","locked","password","authentication","authorization","permissions","access","protect","privacy","secure","safe","admin","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","safe","password","protection","login","authentication","restricted","access","locked","unlocked","admin","settings","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","private","safe","admin","access","locked","authorize","lock-screen","padlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.0173C18.5534 10.0641 19.48 10.2374 20.1213 10.8787C21 11.7574 21 13.1716 21 16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284 3 16C3 13.1716 3 11.7574 3.87868 10.8787C4.51998 10.2374 5.44655 10.0641 7 10.0173V7ZM15 7V10H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","protected","access","authorization","restricted","admin","settings","privacy","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20V20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","secure","authentication","authorization","password","protection","access","lockdown","safe","locked","login","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 10H6V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14V10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75V9.25ZM20 10.75C20.4142 10.75 20.75 10.4142 20.75 10C20.75 9.58579 20.4142 9.25 20 9.25V10.75ZM6.87868 19.1213L6.34835 19.6517L6.34835 19.6517L6.87868 19.1213ZM17.1213 19.1213L17.6517 19.6517L17.6517 19.6517L17.1213 19.1213ZM4 10.75H6V9.25H4V10.75ZM6 10.75H18V9.25H6V10.75ZM18 10.75H20V9.25H18V10.75ZM17.25 10V14H18.75V10H17.25ZM6.75 14V10H5.25V14H6.75ZM12 19.25C10.5646 19.25 9.56347 19.2484 8.80812 19.1469C8.07435 19.0482 7.68577 18.8678 7.40901 18.591L6.34835 19.6517C6.95027 20.2536 7.70814 20.5125 8.60825 20.6335C9.48678 20.7516 10.607 20.75 12 20.75V19.25ZM5.25 14C5.25 15.393 5.24841 16.5132 5.36652 17.3918C5.48754 18.2919 5.74643 19.0497 6.34835 19.6517L7.40901 18.591C7.13225 18.3142 6.9518 17.9257 6.85315 17.1919C6.75159 16.4365 6.75 15.4354 6.75 14H5.25ZM17.25 14C17.25 15.4354 17.2484 16.4365 17.1469 17.1919C17.0482 17.9257 16.8678 18.3142 16.591 18.591L17.6517 19.6517C18.2536 19.0497 18.5125 18.2919 18.6335 17.3918C18.7516 16.5132 18.75 15.393 18.75 14H17.25ZM12 20.75C13.393 20.75 14.5132 20.7516 15.3918 20.6335C16.2919 20.5125 17.0497 20.2536 17.6517 19.6517L16.591 18.591C16.3142 18.8678 15.9257 19.0482 15.1919 19.1469C14.4365 19.2484 13.4354 19.25 12 19.25V20.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","safe","secure","access","password","locked","authorization","admin","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20V20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","permissions","restricted","locked","safe","protected","user-permissions","admin-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H19L19 13.0706C19 14.4247 19.0001 15.5413 18.8812 16.4251C18.7565 17.3529 18.4845 18.1723 17.8284 18.8284C17.1723 19.4845 16.3529 19.7565 15.4251 19.8812C14.5413 20.0001 13.4247 20 12.0706 20H11.9294C10.5753 20 9.45869 20.0001 8.57494 19.8812C7.64711 19.7565 6.82768 19.4845 6.17157 18.8284C5.51546 18.1723 5.2435 17.3529 5.11875 16.4251C4.99993 15.5413 4.99996 14.4247 5 13.0706L5 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H7V7ZM15 7V8H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","authentication","authorization","access","restriction","safe","secure","locked","admin","permissions","user-access","password","privacy","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","password","authentication","authorization","secure","access","restriction","privacy","locked","safe","protection","admin","settings","configuration","control","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","permission","access","locked","safe","secure","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.0333C17.0966 10.0392 17.19 10.0461 17.2802 10.0543C17.9039 10.1109 18.4744 10.2324 19 10.5359C19.6081 10.887 20.113 11.3919 20.4641 12C20.7676 12.5256 20.8892 13.0961 20.9457 13.7198C21 14.3195 21 15.0584 21 15.9539V16.046C21 16.9414 21 17.6805 20.9457 18.2802C20.8892 18.9039 20.7676 19.4744 20.4641 20C20.113 20.6081 19.6081 21.113 19 21.4641C18.4744 21.7676 17.9039 21.8892 17.2802 21.9457C16.6805 22 15.9415 22 15.0461 22H8.95394C8.05849 22 7.31952 22 6.71983 21.9457C6.09615 21.8892 5.52565 21.7676 5 21.4641C4.39193 21.113 3.88697 20.6081 3.5359 20C3.23242 19.4744 3.11085 18.9039 3.05433 18.2802C2.99997 17.6805 2.99999 16.9415 3 16.0461V15.954C2.99999 15.0585 2.99997 14.3195 3.05433 13.7198C3.11085 13.0961 3.23242 12.5256 3.5359 12C3.88697 11.3919 4.39193 10.887 5 10.5359C5.52565 10.2324 6.09615 10.1109 6.71983 10.0543C6.81005 10.0461 6.90342 10.0392 7 10.0333V7ZM15 7V10H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","password","protection","secure","blocked","access","restricted","locked","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="5"
                    y="10"
                    width="14"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","privacy","restricted","access","permissions","secured","locked","safe","confidential"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="10"
                    y="14"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","padlock","security","access","admin","authorization","restricted","secure","payment-security","transaction-security","lock-screen","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="11" width="14" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","locked","access","password","authentication","authorization","permissions","safe","secure","privacy","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="5" y="11" width="14" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","authentication","permissions","safe","locked","restricted","admin","authorization","access","password","settings","control","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="5"
                    y="11"
                    width="14"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","unlocked","open","security","access","authorize","allowed","permission"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","secure","security","locked","access","permissions","authorization","restriction","safe","password","admin","private"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.1601C17.3508 10.2364 17.6835 10.3532 18 10.5359C18.6081 10.887 19.113 11.3919 19.4641 12C19.7676 12.5256 19.8892 13.0961 19.9457 13.7198C20 14.3195 20 15.0585 20 15.9539V16.0461C20 16.9415 20 17.6805 19.9457 18.2802C19.8892 18.9039 19.7676 19.4744 19.4641 20C19.113 20.6081 18.6081 21.113 18 21.4641C17.4744 21.7676 16.9039 21.8892 16.2802 21.9457C15.6805 22 14.9415 22 14.0461 22H9.95394C9.05849 22 8.31952 22 7.71983 21.9457C7.09615 21.8892 6.52564 21.7676 6 21.4641C5.39193 21.113 4.88697 20.6081 4.5359 20C4.23242 19.4744 4.11085 18.9039 4.05432 18.2802C3.99997 17.6805 3.99999 16.9415 4 16.0461V15.954C3.99999 15.0585 3.99997 14.3195 4.05432 13.7198C4.11085 13.0961 4.23242 12.5256 4.5359 12C4.88697 11.3919 5.39193 10.887 6 10.5359C6.31647 10.3532 6.6492 10.2364 7 10.1601V7ZM15 7V10.003C14.704 9.99999 14.3863 9.99999 14.046 10H9.95396C9.61369 9.99999 9.29602 9.99999 9 10.003V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15V17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-25": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["unlock","unlocked","security","access","open","permissions","authorized","authenticate","unblock","release","safe","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="4" y="10" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unlock","unlocked","security","open","access","clear","allow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="4"
                    y="10"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","permission","locked","secure","admin","settings","privacy","protected","control","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","unlocked","security","open","access","allow","permission","unblock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9C17 9.01113 16.9998 9.02222 16.9995 9.03327C17.0962 9.03918 17.1898 9.04613 17.2802 9.05432C17.9039 9.11085 18.4744 9.23242 19 9.5359C19.6081 9.88697 20.113 10.3919 20.4641 11C20.7676 11.5256 20.8892 12.0961 20.9457 12.7198C21 13.3195 21 14.0584 21 14.9539V15.046C21 15.9414 21 16.6805 20.9457 17.2802C20.8892 17.9039 20.7676 18.4744 20.4641 19C20.113 19.6081 19.6081 20.113 19 20.4641C18.4744 20.7676 17.9039 20.8892 17.2802 20.9457C16.6805 21 15.9415 21 15.0461 21H8.95394C8.05849 21 7.31952 21 6.71983 20.9457C6.09615 20.8892 5.52565 20.7676 5 20.4641C4.39193 20.113 3.88697 19.6081 3.5359 19C3.23242 18.4744 3.11085 17.9039 3.05433 17.2802C2.99997 16.6805 2.99999 15.9415 3 15.0461V14.954C2.99999 14.0585 2.99997 13.3195 3.05433 12.7198C3.11085 12.0961 3.23242 11.5256 3.5359 11C3.88697 10.3919 4.39193 9.88697 5 9.5359C5.52565 9.23242 6.09615 9.11085 6.71983 9.05432C7.31952 8.99997 8.05848 8.99998 8.95393 9H15V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55229 8 8 8C7.44772 8 7 7.55228 7 7ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-29": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","secure","admin","locked","authorization","permission","access","settings","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="4" y="10" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","privacy","locked","authentication","authorization","access","permissions","restrict","admin","safe","secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9.07612C17.9751 9.17203 18.6314 9.38879 19.1213 9.87868C20 10.7574 20 12.1716 20 15C20 17.8284 20 19.2426 19.1213 20.1213C18.2426 21 16.8284 21 14 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15C4 12.1716 4 10.7574 4.87868 9.87868C5.36857 9.38879 6.02491 9.17203 7 9.07612V8ZM15 8V9.00174C14.6878 9 14.355 9 14 9H10C9.64496 9 9.31221 9 9 9.00174V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","authentication","authorization","restricted","protected","safe","secure","privacy","control","permissions","admin","password","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9.0333C17.0966 9.0392 17.19 9.04615 17.2802 9.05432C17.9039 9.11085 18.4744 9.23242 19 9.5359C19.6081 9.88697 20.113 10.3919 20.4641 11C20.7676 11.5256 20.8892 12.0961 20.9457 12.7198C21 13.3195 21 14.0584 21 14.9539V15.046C21 15.9414 21 16.6805 20.9457 17.2802C20.8892 17.9039 20.7676 18.4744 20.4641 19C20.113 19.6081 19.6081 20.113 19 20.4641C18.4744 20.7676 17.9039 20.8892 17.2802 20.9457C16.6805 21 15.9415 21 15.0461 21H8.95394C8.05849 21 7.31952 21 6.71983 20.9457C6.09615 20.8892 5.52565 20.7676 5 20.4641C4.39193 20.113 3.88697 19.6081 3.5359 19C3.23242 18.4744 3.11085 17.9039 3.05433 17.2802C2.99997 16.6805 2.99999 15.9415 3 15.0461V14.954C2.99999 14.0585 2.99997 13.3195 3.05433 12.7198C3.11085 12.0961 3.23242 11.5256 3.5359 11C3.88697 10.3919 4.39193 9.88697 5 9.5359C5.52565 9.23242 6.09615 9.11085 6.71983 9.05432C6.81005 9.04615 6.90342 9.0392 7 9.0333V8ZM15 8V9H9V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-30": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","protected","access","password","authorization","privacy","safe","restricted","control","locked","secure","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="4"
                    y="10"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","authentication","authorization","privacy","protect","payment","transaction","secure-payment","secure-transaction","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","privacy","locked","secure","access","authorization","permissions","restricted","admin","safe","protection","password","user-lock","customer-lock","price-lock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-34": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","password","access","restricted","safe","unlock","authorize","lock-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","safe","protected","access-denied","restricted","locked","password","authorize","authentication","secure-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10C17 10.0325 16.9984 10.0647 16.9954 10.0964C18.2342 11.3583 19 13.0903 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 13.0903 5.76581 11.3583 7.00458 10.0964C7.00155 10.0647 7 10.0325 7 10V8ZM15 8V8.67391C14.0906 8.24194 13.0731 8 12 8C10.9269 8 9.90943 8.24194 9 8.67391V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.3062 14.1652 17.4175 13 17.8293V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V17.8293C9.83481 17.4175 9 16.3062 9 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-36": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","password","privacy","protect","locked","secure","access-denied","restricted","safe","authentication","authorization","permissions","encrypted","confidential"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-37": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","security","padlock","secure","privacy","access-control","authorization","authentication","permissions","restricted","locked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-38": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","safe","protected","access","authentication","privacy","settings","permissions","control","authorization","unlock","password","admin","closed","secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-39": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","secure","privacy","locked","access","permissions","authorization","restricted","safe","password","protect","protection","admin","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10C17 10.0325 16.9984 10.0647 16.9954 10.0964C18.2342 11.3583 19 13.0903 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 13.0903 5.76581 11.3583 7.00458 10.0964C7.00155 10.0647 7 10.0325 7 10V7ZM15 7V8.67391C14.0906 8.24194 13.0731 8 12 8C10.9269 8 9.90943 8.24194 9 8.67391V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","access","restricted","protection","locked","secure","admin","authorization","permission"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["lock","security","password","authorization","permission","restricted","access","protect","safe","secure","admin","settings","control","privacy","authenticate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","security","protected","locked","access","authorization","permissions","safe","secure","checkout-lock","admin-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.0173C18.5534 10.0641 19.48 10.2374 20.1213 10.8787C21 11.7574 21 13.1716 21 16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284 3 16C3 13.1716 3 11.7574 3.87868 10.8787C4.51998 10.2374 5.44655 10.0641 7 10.0173V7ZM15 7V10H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","security","secure","padlock","access","password","protect","locked","safe","privacy","authorization","admin","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="10"
                    y="14"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","unlock","security","access","permissions","authorized","locked","safe","privacy","authenticate","restricted"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","unlock","security","open","safe","restriction","permissions","authorization","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["unlock","unlocked","open","access","authorize","security","unblock","clear","exemption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unlock","open","unlocked","access","clear","permission","authorize","checkout","security-off","release"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="5"
                    y="11"
                    width="14"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","unlock","open","security","access","unlocked","authorization","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.1601C17.3508 10.2364 17.6835 10.3532 18 10.5359C18.6081 10.887 19.113 11.3919 19.4641 12C19.7676 12.5256 19.8892 13.0961 19.9457 13.7198C20 14.3195 20 15.0585 20 15.9539V16.0461C20 16.9415 20 17.6805 19.9457 18.2802C19.8892 18.9039 19.7676 19.4744 19.4641 20C19.113 20.6081 18.6081 21.113 18 21.4641C17.4744 21.7676 16.9039 21.8892 16.2802 21.9457C15.6805 22 14.9415 22 14.0461 22H9.95394C9.05849 22 8.31952 22 7.71983 21.9457C7.09615 21.8892 6.52565 21.7676 6 21.4641C5.39193 21.113 4.88697 20.6081 4.5359 20C4.23242 19.4744 4.11085 18.9039 4.05433 18.2802C3.99997 17.6805 3.99999 16.9415 4 16.0461V15.954C3.99999 15.0585 3.99997 14.3195 4.05433 13.7198C4.11085 13.0961 4.23242 12.5256 4.5359 12C4.88697 11.3919 5.39193 10.887 6 10.5359C6.52565 10.2324 7.09615 10.1109 7.71983 10.0543C8.31952 9.99997 9.05848 9.99998 9.95393 10H14.046C14.3863 9.99999 14.704 9.99999 15 10.003V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55229 8 8 8C7.44772 8 7 7.55228 7 7ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15V17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","security","access","unlocked","open","permission","allow","authorize","authorize-transaction","unblock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20V20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-open-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["unlock","open","access","unlocked","permission","clearance","authorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 10V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20V20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 10H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unlock","security","access","open","unlocked","permissions","authorization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 10H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14V10H6V14C6 16.8284 6 18.2426 6.87868 19.1213C7.75736 20 9.17157 20 12 20C14.8284 20 16.2426 20 17.1213 19.1213C18 18.2426 18 16.8284 18 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.87868 19.1213L6.34835 19.6517L6.34835 19.6517L6.87868 19.1213ZM17.1213 19.1213L17.6517 19.6517L17.6517 19.6517L17.1213 19.1213ZM4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75V9.25ZM20 10.75C20.4142 10.75 20.75 10.4142 20.75 10C20.75 9.58579 20.4142 9.25 20 9.25V10.75ZM17.25 10V14H18.75V10H17.25ZM6.75 14V10H5.25V14H6.75ZM12 19.25C10.5646 19.25 9.56347 19.2484 8.80812 19.1469C8.07435 19.0482 7.68577 18.8678 7.40901 18.591L6.34835 19.6517C6.95027 20.2536 7.70814 20.5125 8.60825 20.6335C9.48678 20.7516 10.607 20.75 12 20.75V19.25ZM5.25 14C5.25 15.393 5.24841 16.5132 5.36652 17.3918C5.48754 18.2919 5.74643 19.0497 6.34835 19.6517L7.40901 18.591C7.13225 18.3142 6.9518 17.9257 6.85315 17.1919C6.75159 16.4365 6.75 15.4354 6.75 14H5.25ZM17.25 14C17.25 15.4354 17.2484 16.4365 17.1469 17.1919C17.0482 17.9257 16.8678 18.3142 16.591 18.591L17.6517 19.6517C18.2536 19.0497 18.5125 18.2919 18.6335 17.3918C18.7516 16.5132 18.75 15.393 18.75 14H17.25ZM12 20.75C13.393 20.75 14.5132 20.7516 15.3918 20.6335C16.2919 20.5125 17.0497 20.2536 17.6517 19.6517L16.591 18.591C16.3142 18.8678 15.9257 19.0482 15.1919 19.1469C14.4365 19.2484 13.4354 19.25 12 19.25V20.75ZM4 10.75H6V9.25H4V10.75ZM6 10.75H18V9.25H6V10.75ZM18 10.75H20V9.25H18V10.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12 14V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","open","access","unlocked","permission","allow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H19L19 14.0706C19 15.4247 19.0001 16.5413 18.8812 17.4251C18.7565 18.3529 18.4845 19.1723 17.8284 19.8284C17.1723 20.4845 16.3529 20.7565 15.4251 20.8812C14.5413 21.0001 13.4247 21 12.0706 21H11.9294C10.5753 21 9.45869 21.0001 8.57494 20.8812C7.64711 20.7565 6.82768 20.4845 6.17157 19.8284C5.51546 19.1723 5.2435 18.3529 5.11875 17.4251C4.99993 16.5413 4.99996 15.4247 5 14.0706L5 11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H15V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","open","unlocked","access","unrestricted","permission","available","security-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-open-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["unlock","unlocked","access","open","authorize","permission","unblock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="10" y="14" width="4" height="4" rx="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "lock-open-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unlock","security","open","access","unlocked","permission","clearance","disable","unblock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="10"
                    y="14"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "lock-open-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock","unlock","open","security","access","permission","unlocked","safe","authorization","checkout","unlock-terminal","allow-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="5"
                    y="10"
                    width="14"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","unlock","open","security","access","authorized","permission","clearance","bypass","override","disable","unlocked-features","unlock-discount","unlock-item","unlocked-price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.0333C17.0966 10.0392 17.19 10.0461 17.2802 10.0543C17.9039 10.1109 18.4744 10.2324 19 10.5359C19.6081 10.887 20.113 11.3919 20.4641 12C20.7676 12.5256 20.8892 13.0961 20.9457 13.7198C21 14.3195 21 15.0584 21 15.9539V16.046C21 16.9414 21 17.6805 20.9457 18.2802C20.8892 18.9039 20.7676 19.4744 20.4641 20C20.113 20.6081 19.6081 21.113 19 21.4641C18.4744 21.7676 17.9039 21.8892 17.2802 21.9457C16.6805 22 15.9415 22 15.0461 22H8.95394C8.05849 22 7.31952 22 6.71983 21.9457C6.09615 21.8892 5.52565 21.7676 5 21.4641C4.39193 21.113 3.88697 20.6081 3.5359 20C3.23242 19.4744 3.11085 18.9039 3.05433 18.2802C2.99997 17.6805 2.99999 16.9415 3 16.0461V15.954C2.99999 15.0585 2.99997 14.3195 3.05433 13.7198C3.11085 13.0961 3.23242 12.5256 3.5359 12C3.88697 11.3919 4.39193 10.887 5 10.5359C5.52565 10.2324 6.09615 10.1109 6.71983 10.0543C7.31952 9.99997 8.05848 9.99998 8.95393 10H15V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55229 8 8 8C7.44772 8 7 7.55228 7 7ZM12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock-open","open","unlocked","access","permissions","security","settings","admin","authorize","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","unlock","open","security","access","permission","clearance","authorize","authorization","unlocked","unsecured"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock-open","unlock","security","access","open","authorized","unlocked","permission"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","open","security","unlocked","access","allow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10C17 10.0325 16.9984 10.0647 16.9954 10.0964C18.2342 11.3583 19 13.0903 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 12.9267 5.9026 11.063 7.33309 9.78265C8.57085 8.67482 10.2078 8 12 8C13.0731 8 14.0906 8.24194 15 8.67391V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7ZM9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.3062 14.1652 17.4175 13 17.8293V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V17.8293C9.83481 17.4175 9 16.3062 9 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","unlock","unlocked","security","access","open","unblock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-open-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock-open","unlocked","access","permission","authorization","security","unlock","open"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","open","unlock","security","access","unlocked","permission","allow","authorization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10C17 10.0325 16.9984 10.0646 16.9954 10.0963C18.2353 11.3593 19 13.0903 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 12.9268 5.90125 11.0642 7.33333 9.78242C8.57176 8.67399 10.2072 8 12 8C13.0736 8 14.0907 8.24169 15 8.67363V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock","open","unlock","access","security","unlocked","authorized","permission","unblock","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9C17 9.02552 16.999 9.05081 16.9972 9.07584C17.9738 9.17161 18.631 9.38832 19.1213 9.87868C20 10.7574 20 12.1716 20 15C20 17.8284 20 19.2426 19.1213 20.1213C18.2426 21 16.8284 21 14 21H10C7.17157 21 5.75736 21 4.87868 20.1213C4 19.2426 4 17.8284 4 15C4 12.1716 4 10.7574 4.87868 9.87868C5.75736 9 7.17157 9 10 9H14C14.355 9 14.6878 9 15 9.00174L15 9V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-25": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","unlock","open","security","access","authorized","unlocked","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 21C15.3137 21 18 18.3137 18 15C18 13.223 17.2275 11.6264 16 10.5278C14.9385 9.57771 13.5367 9 12 9C10.4633 9 9.06151 9.57771 8 10.5278C6.7725 11.6264 6 13.223 6 15C6 18.3137 8.68629 21 12 21Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","open","security","access","unlocked","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lock-open-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","unlock","open","security","access","authorization","permission","unlocked","safe","allow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="4" y="11" width="16" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lock-open","unlock","security","unlocked","access","allowed","permission","open"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlocked","access","permission","allow","authorize","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.0173C18.5534 10.0641 19.48 10.2374 20.1213 10.8787C21 11.7574 21 13.1716 21 16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284 3 16C3 13.1716 3 11.7574 3.87868 10.8787C4.75736 10 6.17157 10 9 10H15V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7ZM10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lock-open-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["unlock","unlocked","access","open","security","permission","allowed","authorize","clearance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="5" y="11" width="14" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lock","unlock","open","security","access","unlocked","authorization","permissions","clear","exemption","allowed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="5" y="11" width="14" height="10" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 17L12 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lock-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["lock-open","unlocked","access","open","security","authorization","permission","unlock-price","edit-price","override"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    lock: {
        defaultColors: ["#3D4C66"],
        keywords: ["lock-open","unlocked","access","open","security","authorization","permission","unlock-price","edit-price","override"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="10" width="14" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 16L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10V8C16 5.79086 14.2091 4 12 4V4C9.79086 4 8 5.79086 8 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Locker-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["locker","safe","security","storage","lock","unlock","vault","deposit","cash-drawer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12H15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Locker-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["locker","safe","storage","security","vault","cash","secure","deposit","pickup","order-pickup","reserved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Locker-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["locker","storage","delivery","pickup","order-pickup","order-storage","package","safe","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 21C16.4477 21 16 20.5523 16 20L16 19C16 18.4477 16.4477 18 17 18C17.5523 18 18 18.4477 18 19L18 20C18 20.5523 17.5523 21 17 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 21C6.44772 21 6 20.5523 6 20L6 19C6 18.4477 6.44772 18 7 18C7.55228 18 8 18.4477 8 19L8 20C8 20.5523 7.55228 21 7 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V13.0706V10.9294V10.9294C3.99997 9.57527 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57531 3.99997 10.9294 4H10.9294ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.1043 16 14.1057 15.5512 14.8284 14.8284C15.3253 14.3316 15.6927 13.7031 15.8738 13H20V11H15.874C15.4299 9.27477 13.8638 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Locker: {
        defaultColors: ["#3D4C66"],
        keywords: ["locker","storage","delivery","pickup","order-pickup","order-storage","package","safe","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "looped-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["command","keyboard","shortcut","settings","options","menu","navigation","control","mac","action"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V14H14V10H10Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4V4C8.65685 4 10 5.34315 10 7V10H7C5.34315 10 4 8.65685 4 7V7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17C4 15.3431 5.34315 14 7 14H10V17C10 18.6569 8.65685 20 7 20V20C5.34315 20 4 18.6569 4 17V17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 7C14 5.34315 15.3431 4 17 4V4C18.6569 4 20 5.34315 20 7V7C20 8.65685 18.6569 10 17 10H14V7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H17C18.6569 14 20 15.3431 20 17V17C20 18.6569 18.6569 20 17 20V20C15.3431 20 14 18.6569 14 17V14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "looped-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["loop","repetition","shortcut","command","settings","options","preferences","menu","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V14H14V10H10Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4V4C8.65685 4 10 5.34315 10 7V10H7C5.34315 10 4 8.65685 4 7V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17C4 15.3431 5.34315 14 7 14H10V17C10 18.6569 8.65685 20 7 20V20C5.34315 20 4 18.6569 4 17V17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 7C14 5.34315 15.3431 4 17 4V4C18.6569 4 20 5.34315 20 7V7C20 8.65685 18.6569 10 17 10H14V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H17C18.6569 14 20 15.3431 20 17V17C20 18.6569 18.6569 20 17 20V20C15.3431 20 14 18.6569 14 17V14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    looped: {
        defaultColors: ["#3D4C66"],
        keywords: ["loop","repetition","shortcut","command","settings","options","preferences","menu","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V14H14V10H10Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4V4C8.65685 4 10 5.34315 10 7V10H7C5.34315 10 4 8.65685 4 7V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17C4 15.3431 5.34315 14 7 14H10V17C10 18.6569 8.65685 20 7 20V20C5.34315 20 4 18.6569 4 17V17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 7C14 5.34315 15.3431 4 17 4V4C18.6569 4 20 5.34315 20 7V7C20 8.65685 18.6569 10 17 10H14V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H17C18.6569 14 20 15.3431 20 17V17C20 18.6569 18.6569 20 17 20V20C15.3431 20 14 18.6569 14 17V14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "looped-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","loop","cmd","command","history","redo","repeat-transaction","re-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7V9H13V7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7C21 9.20914 19.2091 11 17 11H15V13H17C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17V15H11V17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13H9V11H7C4.79086 11 3 9.20914 3 7ZM9 9V7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9H9ZM11 11V13H13V11H11ZM9 15H7C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17V15ZM15 15V17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15H15ZM15 9H17C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Lotion-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["lotion","soap","dispenser","product","item","hygiene","cosmetic","sale","retail","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8V8C14 7.05719 14 6.58579 13.7071 6.29289C13.4142 6 12.9428 6 12 6V6C11.0572 6 10.5858 6 10.2929 6.29289C10 6.58579 10 7.05719 10 8V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8H10C8.11438 8 7.17157 8 6.58579 8.58579C6 9.17157 6 10.1144 6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12C18 10.1144 18 9.17157 17.4142 8.58579C16.8284 8 15.8856 8 14 8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 4H10.2545C9.90026 4 9.55239 4.09408 9.24645 4.27262L8 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4V6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Lotion-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["lotion","soap","dispenser","product","item","sale","hygiene","cleaning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6H11.5C11.0341 6 10.8011 6 10.6173 6.07612C10.3723 6.17761 10.1776 6.37229 10.0761 6.61732C10 6.80109 10 7.03406 10 7.5C10 7.96594 10 8.19891 10.0761 8.38268C10.1776 8.62771 10.3723 8.82239 10.6173 8.92388C10.8011 9 11.0341 9 11.5 9H13C13.5523 9 14 8.55228 14 8C14 7.05719 14 6.58579 13.7071 6.29289C13.4142 6 12.9428 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 4H10.2545C9.90026 4 9.55239 4.09408 9.24645 4.27262L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8H10C8.11438 8 7.17157 8 6.58579 8.58579C6 9.17157 6 10.1144 6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12C18 10.1144 18 9.17157 17.4142 8.58579C16.8284 8 15.8856 8 14 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Lotion-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lotion","soap","dispenser","product","item","beauty","personal care","hygiene","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.67 9.71001C18.59 9.08001 18.4 8.52001 17.94 8.06001C17.48 7.60001 16.92 7.42001 16.29 7.33001C15.92 7.28001 15.48 7.26001 14.98 7.26001C14.98 7.09001 14.97 6.92001 14.95 6.77001C14.9 6.39001 14.77 5.95001 14.41 5.59001C14.05 5.23001 13.61 5.10001 13.23 5.05001C13.16 5.05001 13.08 5.03001 13 5.03001V4.01001H14C14.55 4.01001 15 3.56001 15 3.01001C15 2.46001 14.55 2 14 2L10.2773 2.01001C9.74734 2.01001 9.2 2.15001 8.74 2.42001L7.49 3.15001C7.01 3.43001 6.85 4.04001 7.13 4.52001C7.41 5.00001 8.02 5.16001 8.5 4.88001L9.75 4.15001C9.9 4.06001 10.08 4.01001 10.25 4.01001H11V5.02001C11 5.02001 10.92 5.02001 10.88 5.02001C10.69 5.03001 10.46 5.06001 10.23 5.16001C9.74 5.36001 9.35 5.75001 9.15 6.24001C9.05 6.47001 9.02 6.70001 9.01 6.89001C9.01 7.00001 9.01 7.13001 9.01 7.26001C8.52 7.26001 8.08 7.28001 7.71 7.33001C7.08 7.41001 6.52 7.60001 6.06 8.06001C5.6 8.52001 5.42 9.08001 5.33 9.71001C5.25 10.3 5.25 11.05 5.25 11.95V16.05C5.25 16.95 5.25 17.7 5.33 18.29C5.41 18.92 5.6 19.48 6.06 19.94C6.52 20.4 7.08 20.58 7.71 20.67C8.3 20.75 9.05 20.75 9.95 20.75H14.05C14.95 20.75 15.7 20.75 16.29 20.67C16.92 20.59 17.48 20.4 17.94 19.94C18.4 19.48 18.58 18.92 18.67 18.29C18.75 17.7 18.75 16.95 18.75 16.05V11.95C18.75 11.05 18.75 10.3 18.67 9.71001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Lotion: {
        defaultColors: ["#3D4C66"],
        keywords: ["lotion","soap","dispenser","product","item","beauty","personal care","hygiene","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8H10C8.11438 8 7.17157 8 6.58579 8.58579C6 9.17157 6 10.1144 6 12V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16V12C18 10.1144 18 9.17157 17.4142 8.58579C16.8284 8 15.8856 8 14 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 8V8C14 7.05719 14 6.58579 13.7071 6.29289C13.4142 6 12.9428 6 12 6V6C11.0572 6 10.5858 6 10.2929 6.29289C10 6.58579 10 7.05719 10 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 4H10.2545C9.90026 4 9.55239 4.09408 9.24645 4.27262L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "low-priority-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","priority","low-priority","list","order","reorder","arrow","move","shift"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H10C6.68629 5 4 7.68629 4 11V11C4 14.3137 6.68629 17 10 17H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 5H20M20 17H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11H20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15L12 17L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "low-priority-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["reorder","repeat","cycle","transaction-history","order-history","previous-order","load-order","arrow","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H10C6.68629 5 4 7.68629 4 11V11C4 14.3137 6.68629 17 10 17H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 5H20M20 17H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15L12 17L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "low-priority-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["history","order-history","recent","recent-orders","list","arrow","reload","refresh","previous","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 11C3 7.13401 6.13401 4 10 4H12C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6H10C7.23858 6 5 8.23858 5 11C5 13.6155 7.0083 15.7616 9.56695 15.9812L9.29289 15.7071C8.90237 15.3166 8.90237 14.6834 9.29289 14.2929C9.68342 13.9024 10.3166 13.9024 10.7071 14.2929L12.7071 16.2929C13.0976 16.6834 13.0976 17.3166 12.7071 17.7071L10.7071 19.7071C10.3166 20.0976 9.68342 20.0976 9.29289 19.7071C8.90237 19.3166 8.90237 18.6834 9.29289 18.2929L9.59718 17.9886C5.91863 17.7799 3 14.7308 3 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 5C15 4.44772 15.4477 4 16 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H16C15.4477 6 15 5.55228 15 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 18C15.4477 18 15 17.5523 15 17C15 16.4477 15.4477 16 16 16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 11C15 10.4477 15.4477 10 16 10H20C20.5523 10 21 10.4477 21 11C21 11.5523 20.5523 12 20 12H16C15.4477 12 15 11.5523 15 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "low-priority": {
        defaultColors: ["#3D4C66"],
        keywords: ["redo","repeat","reapply","transaction","history","resume","order-history","restore","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H10C6.68629 5 4 7.68629 4 11V11C4 14.3137 6.68629 17 10 17H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 5H20M20 17H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 11H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15L12 17L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lte-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["lte","network","connection","data","signal","connectivity","internet","mobile","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9V15H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L15 15L15 12M15 12L15 9H18M15 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9V15M11 9H13M11 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lte-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["LTE","connection","network","data","mobile","connectivity","signal","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9V15H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L15 15L15 12M15 12L15 9H18M15 12L18 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9V15M11 9H13M11 9H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lte-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["LTE","network","connectivity","data","connection","signal","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 8C5.55228 8 6 8.44772 6 9V14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H5C4.44772 16 4 15.5523 4 15V9C4 8.44772 4.44772 8 5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9C15 8.44772 15.4477 8 16 8H19C19.5523 8 20 8.44772 20 9C20 9.55229 19.5523 10 19 10H17V11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L17 13L17 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16L16 16C15.7348 16 15.4804 15.8946 15.2929 15.7071C15.1054 15.5196 15 15.2652 15 15L15 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9C8 8.44772 8.44772 8 9 8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5523 10 13 10H12V15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15V10H9C8.44772 10 8 9.55228 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    lte: {
        defaultColors: ["#3D4C66"],
        keywords: ["LTE","network","connectivity","data","connection","signal","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9V15H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L15 15L15 12M15 12L15 9H18M15 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 9V15M11 9H13M11 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "lunch-dining-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["burger","hamburger","food","menu","order","sandwich","restaurant","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V9C4 8.07003 4 7.60504 4.10222 7.22354C4.37962 6.18827 5.18827 5.37962 6.22354 5.10222C6.60504 5 7.07003 5 8 5H16C16.93 5 17.395 5 17.7765 5.10222C18.8117 5.37962 19.6204 6.18827 19.8978 7.22354C20 7.60504 20 8.07003 20 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 17V15H4V17C4 17.9428 4 18.4142 4.29289 18.7071C4.58579 19 5.05719 19 6 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13L5.33333 12C6.12346 11.4074 7.20988 11.4074 8 12V12C8.79012 12.5926 9.87654 12.5926 10.6667 12V12C11.4568 11.4074 12.5432 11.4074 13.3333 12V12C14.1235 12.5926 15.2099 12.5926 16 12V12C16.7901 11.4074 17.8765 11.4074 18.6667 12L20 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lunch-dining-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["burger","hamburger","food","menu","item","order","sandwich"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.88425 4.25002C7.92228 4.25004 7.96087 4.25005 8.00004 4.25005H16C16.0392 4.25005 16.0778 4.25004 16.1158 4.25002C16.9338 4.24975 17.492 4.24957 17.9706 4.37783C19.2647 4.72458 20.2755 5.73538 20.6223 7.02948C20.7275 7.42236 20.744 7.84881 20.7486 8.39365C20.7486 8.40197 20.7487 8.41052 20.7488 8.41927C20.7499 8.53612 20.7513 8.68909 20.7342 8.82303C20.7128 8.98982 20.6523 9.23199 20.4466 9.43943C20.24 9.64775 19.997 9.70974 19.8311 9.73219C19.6971 9.75031 19.5437 9.75017 19.4258 9.75007C19.417 9.75006 19.4084 9.75005 19.4 9.75005H4.60004C4.59167 9.75005 4.58308 9.75006 4.57428 9.75007C4.45639 9.75017 4.30297 9.75031 4.16899 9.73219C4.00307 9.70974 3.7601 9.64775 3.5535 9.43943C3.34777 9.23199 3.28724 8.98982 3.26593 8.82303C3.24882 8.6891 3.25023 8.53615 3.2513 8.4193C3.25138 8.41054 3.25146 8.40198 3.25153 8.39365C3.25604 7.84881 3.27255 7.42236 3.37782 7.02948C3.72457 5.73538 4.73538 4.72458 6.02947 4.37783C6.50813 4.24957 7.06628 4.24975 7.88425 4.25002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25004 15C3.25004 14.5858 3.58583 14.25 4.00004 14.25H20C20.4143 14.25 20.75 14.5858 20.75 15L20.75 17.0448C20.7501 17.4776 20.7501 17.8744 20.7067 18.1973C20.659 18.5527 20.5465 18.9285 20.2375 19.2375C19.9285 19.5465 19.5527 19.659 19.1973 19.7067C18.8744 19.7502 18.4776 19.7501 18.0448 19.7501L6.00004 19.75C5.98509 19.75 5.97017 19.7501 5.9553 19.7501C5.52248 19.7501 5.12565 19.7502 4.80284 19.7067C4.44736 19.659 4.07163 19.5465 3.76261 19.2375C3.45358 18.9285 3.34114 18.5527 3.29334 18.1973C3.24994 17.8744 3.24999 17.4776 3.25004 17.0448C3.25004 17.0299 3.25004 17.015 3.25004 17V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.2167 11.4C11.2735 10.6075 12.7266 10.6075 13.7834 11.4C14.3068 11.7926 15.0266 11.7926 15.55 11.4C16.6068 10.6075 18.0599 10.6075 19.1167 11.4L20.45 12.4C20.7814 12.6486 20.8486 13.1187 20.6 13.45C20.3515 13.7814 19.8814 13.8486 19.55 13.6L18.2167 12.6C17.6933 12.2075 16.9735 12.2075 16.45 12.6C15.3933 13.3926 13.9402 13.3926 12.8834 12.6C12.3599 12.2075 11.6402 12.2075 11.1167 12.6C10.0599 13.3926 8.60683 13.3926 7.55004 12.6C7.02659 12.2075 6.30683 12.2075 5.78338 12.6L4.45004 13.6C4.11867 13.8486 3.64857 13.7814 3.40004 13.45C3.15152 13.1187 3.21867 12.6486 3.55004 12.4L4.88338 11.4C5.94017 10.6075 7.39325 10.6075 8.45004 11.4C8.9735 11.7926 9.69325 11.7926 10.2167 11.4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "lunch-dining-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["burger","sandwich","food","menu","order","item","meal","fast-food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5H8C7.07003 5 6.60504 5 6.22354 5.10222C5.18827 5.37962 4.37962 6.18827 4.10222 7.22354C4.0248 7.51249 4.00602 7.84932 4.00146 8.39981C3.99913 8.6816 3.99796 8.8225 4.08598 8.91125C4.17399 9 4.316 9 4.6 9H19.4C19.684 9 19.826 9 19.914 8.91125C20.002 8.8225 20.0009 8.6816 19.9985 8.39981C19.994 7.84932 19.9752 7.51249 19.8978 7.22354C19.6204 6.18827 18.8117 5.37962 17.7765 5.10222C17.395 5 16.93 5 16 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 17V15H4V17C4 17.9428 4 18.4142 4.29289 18.7071C4.58579 19 5.05719 19 6 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13L5.33333 12C6.12346 11.4074 7.20988 11.4074 8 12V12C8.79012 12.5926 9.87654 12.5926 10.6667 12V12C11.4568 11.4074 12.5432 11.4074 13.3333 12V12C14.1235 12.5926 15.2099 12.5926 16 12V12C16.7901 11.4074 17.8765 11.4074 18.6667 12L20 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "lunch-dining": {
        defaultColors: ["#3D4C66"],
        keywords: ["burger","hamburger","food","menu-item","sandwich","order","lunch","dining","meal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9V9C4 8.07003 4 7.60504 4.10222 7.22354C4.37962 6.18827 5.18827 5.37962 6.22354 5.10222C6.60504 5 7.07003 5 8 5H16C16.93 5 17.395 5 17.7765 5.10222C18.8117 5.37962 19.6204 6.18827 19.8978 7.22354C20 7.60504 20 8.07003 20 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 17V15H4V17C4 17.9428 4 18.4142 4.29289 18.7071C4.58579 19 5.05719 19 6 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13L5.33333 12C6.12346 11.4074 7.20988 11.4074 8 12V12C8.79012 12.5926 9.87654 12.5926 10.6667 12V12C11.4568 11.4074 12.5432 11.4074 13.3333 12V12C14.1235 12.5926 15.2099 12.5926 16 12V12C16.7901 11.4074 17.8765 11.4074 18.6667 12L20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "M-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["M","menu","more","modify","multiple"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V13.4721C6 10.1205 6 8.44465 6.77025 8.26282C7.54049 8.08099 8.28995 9.57989 9.78885 12.5777L10.2111 13.4223C10.9917 14.9834 11.382 15.7639 12 15.7639C12.618 15.7639 13.0083 14.9834 13.7889 13.4223L14.2111 12.5777C15.7101 9.57989 16.4595 8.08099 17.2298 8.26282C18 8.44465 18 10.1205 18 13.4721V19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "M-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["M","menu","modify","management","markdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V13.4721C6 10.1205 6 8.44465 6.77025 8.26282C7.54049 8.08099 8.28995 9.57989 9.78885 12.5777L10.2111 13.4223C10.9917 14.9834 11.382 15.7639 12 15.7639C12.618 15.7639 13.0083 14.9834 13.7889 13.4223L14.2111 12.5777C15.7101 9.57989 16.4595 8.08099 17.2298 8.26282C18 8.44465 18 10.1205 18 13.4721V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "M-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["M","menu","modifier","option","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.1056 10.7277C11.5111 11.5387 11.7663 12.0432 11.9865 12.3588L12 12.3779L12.0135 12.3588C12.2337 12.0432 12.4889 11.5387 12.8944 10.7277L13.3493 9.81785C14.0712 8.37406 14.653 7.21046 15.1545 6.43662C15.407 6.04707 15.6896 5.67452 16.0188 5.41085C16.3708 5.1289 16.8707 4.90317 17.4595 5.04218C18.0483 5.18118 18.3945 5.60663 18.5833 6.01624C18.7598 6.39929 18.8459 6.85888 18.8975 7.32022C19 8.23666 19 9.53759 19 11.1518V18.0002C19 18.5525 18.5523 19.0002 18 19.0002C17.4477 19.0002 17 18.5525 17 18.0002V11.2247C17 9.52106 16.9984 8.33366 16.9099 7.54258C16.9055 7.50265 16.9009 7.46469 16.8961 7.42862C16.8758 7.45878 16.8547 7.49067 16.8329 7.52438C16.3999 8.19237 15.8675 9.25371 15.1056 10.7775L14.6833 11.6221L14.6495 11.6896L14.6495 11.6897C14.2883 12.4122 13.9682 13.0525 13.6535 13.5035C13.3332 13.9624 12.8203 14.5165 12 14.5165C11.1797 14.5165 10.6668 13.9624 10.3465 13.5035C10.0317 13.0525 9.71166 12.4122 9.35048 11.6896L9.31672 11.6221L8.89443 10.7775C8.13252 9.25371 7.60008 8.19237 7.16714 7.52438C7.14529 7.49067 7.1242 7.45878 7.10386 7.42862C7.09915 7.46469 7.09455 7.50265 7.09008 7.54258C7.00158 8.33366 7 9.52106 7 11.2247V18.0002C7 18.5525 6.55229 19.0002 6 19.0002C5.44772 19.0002 5 18.5525 5 18.0002V11.1518V11.1518C4.99998 9.53758 4.99996 8.23665 5.10248 7.32022C5.15409 6.85888 5.24022 6.39929 5.41674 6.01624C5.6055 5.60663 5.95167 5.18118 6.5405 5.04218C7.12932 4.90317 7.62921 5.1289 7.98123 5.41085C8.31041 5.67452 8.59299 6.04707 8.84547 6.43662C9.34701 7.21045 9.92878 8.37405 10.6507 9.81784L10.6507 9.81785L11.1056 10.7277Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    M: {
        defaultColors: ["#3D4C66"],
        keywords: ["M","menu","modifier","option","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 19V13.4721C6 10.1205 6 8.44465 6.77025 8.26282C7.54049 8.08099 8.28995 9.57989 9.78885 12.5777L10.2111 13.4223C10.9917 14.9834 11.382 15.7639 12 15.7639C12.618 15.7639 13.0083 14.9834 13.7889 13.4223L14.2111 12.5777C15.7101 9.57989 16.4595 8.08099 17.2298 8.26282C18 8.44465 18 10.1205 18 13.4721V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "magnet-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["magnet","attract","loyalty","customer-retention","customer","membership","rewards","connect","collect","coupon","promotions","engagement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 9H5M15 9H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 5.44772 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6V12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12V6C5 5.44772 5.44772 5 6 5H8C8.55228 5 9 5.44772 9 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "magnet-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["u-shape","horseshoe","magnet","coupon","loyalty","rewards","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 9H5M15 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 5.44772 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6V12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12V6C5 5.44772 5.44772 5 6 5H8C8.55228 5 9 5.44772 9 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "magnet-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["magnet","sticky","attract","attach","hold","secure","keep","retention","save","favorite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6C4 4.89543 4.89543 4 6 4H8C9.10457 4 10 4.89543 10 6V7H4V6Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M4 9V12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12V9H14V12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12V9H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M14 7H20V6C20 4.89543 19.1046 4 18 4H16C14.8954 4 14 4.89543 14 6V7Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    magnet: {
        defaultColors: ["#3D4C66"],
        keywords: ["magnet","sticky","attract","attach","hold","secure","keep","retention","save","favorite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 9H5M15 9H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 5.44772 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6V12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12V6C5 5.44772 5.44772 5 6 5H8C8.55228 5 9 5.44772 9 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mail a-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["email","contact","support","notification","send","message","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "mail a-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["email","contact","customer","communication","support","notification","at-symbol","username","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "mail a-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["email","contact","support","communication","address","customer-email","send-email","contact-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.6569 18.6569 15 17 15C16.3247 15 15.7015 14.7769 15.2001 14.4003C14.4703 15.3717 13.3085 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 12.5523 16.4477 13 17 13C17.5523 13 18 12.5523 18 12C18 8.68629 15.3137 6 12 6ZM14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mail a": {
        defaultColors: ["#3D4C66"],
        keywords: ["email","contact","customer","notification","receipt","send","address","at-sign"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Mail-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mail","email","message","notification","updates","communication","send","receipt","invoice","statement","report","transaction","history","records"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8L10.0154 10.866C11.2452 11.5687 12.7548 11.5687 13.9846 10.866L19 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mail-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["email","mail","message","contact","notification","updates","alerts","receipt","invoice","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8L10.0154 10.866C11.2452 11.5687 12.7548 11.5687 13.9846 10.866L19 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mail-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","email","message","notification","updates","communication","inbox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.48 11.7299C13.72 12.1699 12.86 12.3899 12 12.3899C11.14 12.3899 10.28 12.1699 9.52002 11.7299L4.12 8.60986C4 9.50986 4 10.5999 4 11.9899C4 14.9899 3.99998 16.6499 5.16998 17.8199C6.33998 18.9899 8 18.9899 11 18.9899H13C16 18.9899 17.66 18.9899 18.83 17.8199C20 16.6499 20 14.9899 20 11.9899C20 10.5999 20 9.50986 19.88 8.60986L14.48 11.7299Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.5098 10C11.4298 10.53 12.5697 10.52 13.4897 10L19.2397 6.68C19.1197 6.5 18.9898 6.33 18.8298 6.17C17.6598 5 16.0098 5 12.9998 5H10.9998C7.99976 5 6.33974 5 5.16974 6.17C5.00974 6.33 4.87977 6.5 4.75977 6.67L10.5098 9.99V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mail-envelope-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mail","envelope","message","inbox","notification","receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-envelope-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mail","email","envelope","message","notification","inbox","receipt","send","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-envelope-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","envelope","message","inbox","notification","communication","send","receive","email","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.83 6.17C17.66 5 16.01 5 13 5H11C8 5 6.33998 5 5.16998 6.17C3.99998 7.34 4 9 4 12C4 15 3.99998 16.66 5.16998 17.83C6.33998 19 8 19 11 19H13C16 19 17.66 19 18.83 17.83C20 16.66 20 15 20 12C20 9 20 7.34 18.83 6.17ZM16.45 10.89L14.24 12C13.54 12.35 12.77 12.52 12 12.52C11.23 12.52 10.46 12.35 9.76001 12L7.54999 10.89C7.05999 10.64 6.85998 10.04 7.09998 9.55C7.34998 9.06 7.95 8.85 8.44 9.1L10.65 10.21C11.49 10.63 12.49 10.63 13.33 10.21L15.54 9.1C16.04 8.85 16.63 9.05 16.88 9.55C17.13 10.04 16.93 10.64 16.43 10.89H16.45Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mail-envelope-open-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["archive","file","receipt","box","document","open","invoice","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12L13.7889 10.8944C12.6627 10.3314 11.3373 10.3314 10.2111 10.8944L8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-envelope-open-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["email","mail","open","read","message","notification","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12L13.7889 10.8944C12.6627 10.3314 11.3373 10.3314 10.2111 10.8944L8 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-envelope-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","envelope","open","notification","alert","message","new-order","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.83 6.17C17.66 5 16.01 5 13 5H11C8 5 6.33998 5 5.16998 6.17C3.99998 7.34 4 9 4 12C4 15 3.99998 16.66 5.16998 17.83C6.33998 19 8 19 11 19H13C16 19 17.66 19 18.83 17.83C20 16.66 20 15 20 12C20 9 20 7.34 18.83 6.17ZM16.9 12.44C16.65 12.93 16.05 13.13 15.56 12.89L13.35 11.78C12.51 11.36 11.51 11.36 10.67 11.78L8.46002 12.89C8.32002 12.96 8.16001 13 8.01001 13C7.64001 13 7.28999 12.8 7.10999 12.45C6.85999 11.96 7.06 11.36 7.56 11.11L9.77002 10C11.17 9.3 12.84 9.3 14.24 10L16.45 11.11C16.94 11.36 17.14 11.96 16.9 12.45V12.44Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mail-envelope-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","envelope","open","message","notification","email","inbox","communication","customer-message","transaction-alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12L13.7889 10.8944C12.6627 10.3314 11.3373 10.3314 10.2111 10.8944L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-envelope": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","envelope","message","notification","email","inbox","updates","receipt","digital-receipt","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L10.2111 11.1056C11.3373 11.6686 12.6627 11.6686 13.7889 11.1056L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mail-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["mail","email","send","message","notification","delivery","communication","updates","promotions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10L12.2111 12.1056C13.3373 12.6686 14.6627 12.6686 15.7889 12.1056L20 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17H13C11.1308 17 10.1962 17 9.5 16.5981C9.04394 16.3348 8.66523 15.9561 8.40192 15.5C8 14.8038 8 13.8692 8 12C8 10.1308 8 9.19615 8.40192 8.5C8.66523 8.04394 9.04394 7.66523 9.5 7.40192C10.1962 7 11.1308 7 13 7H15C16.8692 7 17.8038 7 18.5 7.40192C18.9561 7.66523 19.3348 8.04394 19.5981 8.5C20 9.19615 20 10.1308 20 12C20 13.8692 20 14.8038 19.5981 15.5C19.3348 15.9561 18.9561 16.3348 18.5 16.5981C17.8038 17 16.8692 17 15 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3 10L5 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14L5 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mail-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mail","email","message","notification","send","inbox","communication","transaction-receipt","statements","promotions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17H13C11.1308 17 10.1962 17 9.5 16.5981C9.04394 16.3348 8.66523 15.9561 8.40192 15.5C8 14.8038 8 13.8692 8 12C8 10.1308 8 9.19615 8.40192 8.5C8.66523 8.04394 9.04394 7.66523 9.5 7.40192C10.1962 7 11.1308 7 13 7H15C16.8692 7 17.8038 7 18.5 7.40192C18.9561 7.66523 19.3348 8.04394 19.5981 8.5C20 9.19615 20 10.1308 20 12C20 13.8692 20 14.8038 19.5981 15.5C19.3348 15.9561 18.9561 16.3348 18.5 16.5981C17.8038 17 16.8692 17 15 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 7H11C9.9911 7 9.09852 7.49802 8.55469 8.26164C7.89551 9.18722 8.64201 10.321 9.65836 10.8292L12.2111 12.1056C13.3373 12.6686 14.6627 12.6686 15.7889 12.1056L18.3416 10.8292C19.358 10.321 20.1045 9.18722 19.4453 8.26164C18.9015 7.49802 18.0089 7 17 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M19.4453 8.26164L20.0562 7.82657L19.4453 8.26164ZM8.55469 8.26164L7.94378 7.82657H7.94378L8.55469 8.26164ZM15.7889 12.1056L15.4534 11.4348L15.7889 12.1056ZM18.3416 10.8292L18.6771 11.5L18.3416 10.8292ZM12.2111 12.1056L11.8757 12.7764L12.2111 12.1056ZM9.65836 10.8292L9.99377 10.1584L9.65836 10.8292ZM11 7.75H17V6.25H11V7.75ZM17 7.75C17.7561 7.75 18.4252 8.12221 18.8344 8.69672L20.0562 7.82657C19.3777 6.87384 18.2617 6.25 17 6.25V7.75ZM11 6.25C9.73828 6.25 8.62229 6.87384 7.94378 7.82657L9.1656 8.69672C9.57475 8.12221 10.2439 7.75 11 7.75V6.25ZM16.1243 12.7764L18.6771 11.5L18.0062 10.1584L15.4534 11.4348L16.1243 12.7764ZM12.5466 11.4348L9.99377 10.1584L9.32295 11.5L11.8757 12.7764L12.5466 11.4348ZM15.4534 11.4348C14.5385 11.8922 13.4615 11.8922 12.5466 11.4348L11.8757 12.7764C13.213 13.445 14.787 13.445 16.1243 12.7764L15.4534 11.4348ZM7.94378 7.82657C7.42104 8.56058 7.47903 9.38048 7.80734 10.0373C8.12312 10.669 8.69544 11.1862 9.32295 11.5L9.99377 10.1584C9.60492 9.96394 9.29582 9.66021 9.14906 9.3666C9.01483 9.09807 9.02917 8.88829 9.1656 8.69672L7.94378 7.82657ZM18.8344 8.69672C18.9708 8.88829 18.9852 9.09807 18.8509 9.3666C18.7042 9.66021 18.3951 9.96394 18.0062 10.1584L18.6771 11.5C19.3046 11.1862 19.8769 10.669 20.1927 10.0373C20.521 9.38048 20.579 8.56058 20.0562 7.82657L18.8344 8.69672Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M3 10L5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14L5 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mail-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","mail","email","send","notification","communication","inbox","outbox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.4998 11.4502C21.2498 11.6402 20.9998 11.8102 20.7298 11.9502L17.3298 13.6502C15.5498 14.5402 13.4598 14.5402 11.6798 13.6502L8.27977 11.9502C8.00977 11.8102 7.74977 11.6402 7.50977 11.4502C7.50977 11.5902 7.50977 11.7202 7.50977 11.8702C7.50977 13.8502 7.50977 14.9402 8.04977 15.8702C8.39977 16.4802 8.90977 16.9902 9.50977 17.3302C10.4398 17.8702 11.5298 17.8702 13.5098 17.8702H15.5098C17.4898 17.8702 18.5798 17.8702 19.5098 17.3302C20.1198 16.9802 20.6198 16.4702 20.9698 15.8702C21.5098 14.9402 21.5098 13.8502 21.5098 11.8702C21.5098 11.7202 21.5098 11.5902 21.5098 11.4502H21.4998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.81966 11.3701L12.3697 12.6501C13.7097 13.3201 15.2797 13.3201 16.6197 12.6501L19.1697 11.3701C19.7997 11.0601 20.3697 10.5401 20.6897 9.91012C21.0197 9.25012 21.0797 8.43012 20.5497 7.70012C19.8697 6.75012 18.7597 6.12012 17.4897 6.12012H11.4897C10.2297 6.12012 9.10966 6.74012 8.42966 7.70012C7.90966 8.43012 7.96966 9.25012 8.28966 9.91012C8.60966 10.5401 9.17966 11.0601 9.80966 11.3701H9.81966Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.5 8.87012H3.5C2.95 8.87012 2.5 9.32012 2.5 9.87012C2.5 10.4201 2.95 10.8701 3.5 10.8701H5.5C6.05 10.8701 6.5 10.4201 6.5 9.87012C6.5 9.32012 6.05 8.87012 5.5 8.87012Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.5 12.8701H4.5C3.95 12.8701 3.5 13.3201 3.5 13.8701C3.5 14.4201 3.95 14.8701 4.5 14.8701H5.5C6.05 14.8701 6.5 14.4201 6.5 13.8701C6.5 13.3201 6.05 12.8701 5.5 12.8701Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Mail-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["email","mail","message","send","notification","receipt","delivery","order-confirmation","shipping-notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17H13C11.1308 17 10.1962 17 9.5 16.5981C9.04394 16.3348 8.66523 15.9561 8.40192 15.5C8 14.8038 8 13.8692 8 12C8 10.1308 8 9.19615 8.40192 8.5C8.66523 8.04394 9.04394 7.66523 9.5 7.40192C10.1962 7 11.1308 7 13 7H15C16.8692 7 17.8038 7 18.5 7.40192C18.9561 7.66523 19.3348 8.04394 19.5981 8.5C20 9.19615 20 10.1308 20 12C20 13.8692 20 14.8038 19.5981 15.5C19.3348 15.9561 18.9561 16.3348 18.5 16.5981C17.8038 17 16.8692 17 15 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L12.2111 12.1056C13.3373 12.6686 14.6627 12.6686 15.7889 12.1056L20 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-open-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mail","open","inbox","notification","message","order-received","new-order","open-mail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10L18 9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5L10 5C8.11438 5 7.17157 5 6.58579 5.58579C6 6.17157 6 7.11438 6 9L6 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 9L10.0154 11.866C11.2452 12.5687 12.7548 12.5687 13.9846 11.866L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L10 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-open-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mail","open","receipt","pending","documents","invoice","report","open-receipt","open-invoice","open-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 10L18 9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5L10 5C8.11438 5 7.17157 5 6.58579 5.58579C6 6.17157 6 7.11438 6 9L6 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 13V9L10.0154 11.866C11.2452 12.5687 12.7548 12.5687 13.9846 11.866L19 9V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 9L5.3721 8.34882C5.13998 8.21617 4.85479 8.21713 4.62355 8.35132C4.39232 8.48551 4.25 8.73265 4.25 9H5ZM19 9H19.75C19.75 8.73265 19.6077 8.48551 19.3764 8.35132C19.1452 8.21713 18.86 8.21617 18.6279 8.34882L19 9ZM5.87868 18.1213L6.40901 17.591L6.40901 17.591L5.87868 18.1213ZM13.9846 11.866L14.3567 12.5172H14.3567L13.9846 11.866ZM10.0154 11.866L9.64334 12.5172L10.0154 11.866ZM4.25 9V13H5.75V9H4.25ZM11 19.75H13V18.25H11V19.75ZM19.75 13V9H18.25V13H19.75ZM13 19.75C14.393 19.75 15.5132 19.7516 16.3918 19.6335C17.2919 19.5125 18.0497 19.2536 18.6517 18.6516L17.591 17.591C17.3142 17.8678 16.9257 18.0482 16.1919 18.1469C15.4365 18.2484 14.4354 18.25 13 18.25V19.75ZM18.25 13C18.25 14.4354 18.2484 15.4365 18.1469 16.1919C18.0482 16.9257 17.8678 17.3142 17.591 17.591L18.6517 18.6516C19.2536 18.0497 19.5125 17.2919 19.6335 16.3918C19.7516 15.5132 19.75 14.393 19.75 13H18.25ZM4.25 13C4.25 14.393 4.24841 15.5132 4.36652 16.3918C4.48754 17.2919 4.74643 18.0497 5.34835 18.6517L6.40901 17.591C6.13225 17.3142 5.9518 16.9257 5.85315 16.1919C5.75159 15.4365 5.75 14.4354 5.75 13H4.25ZM11 18.25C9.56458 18.25 8.56347 18.2484 7.80812 18.1469C7.07435 18.0482 6.68577 17.8678 6.40901 17.591L5.34835 18.6516C5.95027 19.2536 6.70814 19.5125 7.60825 19.6335C8.48678 19.7516 9.60699 19.75 11 19.75V18.25ZM14.3567 12.5172L19.3721 9.65118L18.6279 8.34882L13.6125 11.2148L14.3567 12.5172ZM10.3875 11.2148L5.3721 8.34882L4.6279 9.65118L9.64334 12.5172L10.3875 11.2148ZM13.6125 11.2148C12.6133 11.7857 11.3867 11.7857 10.3875 11.2148L9.64334 12.5172C11.1036 13.3516 12.8964 13.3516 14.3567 12.5172L13.6125 11.2148Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 8L10 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "mail-open-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","open","inbox","messages","notification","delivery","order","receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.38 8.4999C19.26 8.4299 19.13 8.3999 19 8.3999C18.99 6.7699 18.89 5.7999 18.12 5.0299C17.24 4.1499 16.09 4.1499 14 4.1499H10C7.91 4.1499 6.76 4.1499 5.88 5.0299C5.11 5.7999 5.02 6.7699 5 8.3999C4.87 8.3999 4.74 8.4299 4.62 8.4999C4.39 8.6299 4.25 8.8799 4.25 9.1499V13.1499C4.25 14.5399 4.25 15.6599 4.37 16.5399C4.49 17.4399 4.74998 18.1999 5.34998 18.7999C5.94998 19.3999 6.70999 19.6599 7.60999 19.7799C8.48999 19.8999 9.61 19.8999 11 19.8999H13C14.39 19.8999 15.51 19.8999 16.39 19.7799C17.29 19.6599 18.05 19.3999 18.65 18.7999C19.25 18.1999 19.51 17.4399 19.63 16.5399C19.75 15.6599 19.75 14.5399 19.75 13.1499V9.1499C19.75 8.8799 19.61 8.6399 19.38 8.4999ZM17 9.4299L13.61 11.3699C12.61 11.9399 11.38 11.9399 10.39 11.3699L7 9.4299V9.1499C7 7.6999 6.99998 6.7399 7.28998 6.4399C7.57998 6.1399 8.54 6.1499 10 6.1499H14C15.45 6.1499 16.41 6.1499 16.71 6.4399C17 6.7299 17 7.6899 17 9.1499V9.4299Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 7.1499H10C9.45 7.1499 9 7.5999 9 8.1499C9 8.6999 9.45 9.1499 10 9.1499H14C14.55 9.1499 15 8.6999 15 8.1499C15 7.5999 14.55 7.1499 14 7.1499Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mail-open": {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","email","open","inbox","messages","notification","new-orders","update","information","alerts","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10L18 9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5L10 5C8.11438 5 7.17157 5 6.58579 5.58579C6 6.17157 6 7.11438 6 9L6 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 9L10.0154 11.866C11.2452 12.5687 12.7548 12.5687 13.9846 11.866L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Mail: {
        defaultColors: ["#3D4C66"],
        keywords: ["mail","email","open","inbox","messages","notification","new-orders","update","information","alerts","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 18H11C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12C5 9.17157 5 7.75736 5.87868 6.87868C6.75736 6 8.17157 6 11 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 8L10.0154 10.866C11.2452 11.5687 12.7548 11.5687 13.9846 10.866L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Male-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["female","woman","customer","gender","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20V16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18L14 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C15.3137 16 18 13.3137 18 10C18 8.34315 17.3284 6.84314 16.2426 5.75736C15.1569 4.67157 13.6569 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Male-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["female","gender","customer","user","employee","account","loyalty-program","demographic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18L14 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C15.3137 16 18 13.3137 18 10C18 8.34315 17.3284 6.84314 16.2426 5.75736C15.1569 4.67157 13.6569 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Male-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["female","gender","customer","employee","woman","demographic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path
                    d="M10 18L14 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C15.3137 16 18 13.3137 18 10C18 8.34315 17.3284 6.84314 16.2426 5.75736C15.1569 4.67157 13.6569 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "male-female-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["gender","male","female","sex","customer","demographics","gender-selection","customer-profile","gender-identity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 17C14.3137 17 17 14.3137 17 11C17 9.34315 16.3284 7.84314 15.2426 6.75736C14.1569 5.67157 12.6569 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 21V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 19L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3H15M19 3V7M19 3L15.2338 6.7662"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "male-female-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["gender","male","female","sex","customer-gender","employee-gender","demographics","customer","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 19L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3H15M19 3V7M19 3L15.2338 6.7662"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 17C14.3137 17 17 14.3137 17 11C17 9.34315 16.3284 7.84314 15.2426 6.75736C14.1569 5.67157 12.6569 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "male-female": {
        defaultColors: ["#3D4C66"],
        keywords: ["male","female","gender","customer-type","demographic","customer","gender-identity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 17C14.3137 17 17 14.3137 17 11C17 9.34315 16.3284 7.84314 15.2426 6.75736C14.1569 5.67157 12.6569 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 21V17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 19L13 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3H15M19 3V7M19 3L15.2338 6.7662"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "male-female-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["gender","male","female","sex","demographics","customer","customer-type","staff","staff-type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 2C14.4477 2 14 2.44772 14 3C14 3.55228 14.4477 4 15 4H16.5858L15.1921 5.39368C14.0239 4.51899 12.5719 4 11 4C7.13401 4 4 7.13401 4 11C4 14.5265 6.60771 17.4439 10 17.9291V18H9C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20H10V21C10 21.5523 10.4477 22 11 22C11.5523 22 12 21.5523 12 21V20H13C13.5523 20 14 19.5523 14 19C14 18.4477 13.5523 18 13 18H12V17.9291C15.3923 17.4439 18 14.5265 18 11C18 9.42809 17.481 7.97614 16.6063 6.8079L18 5.41421V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7V3C20 2.44772 19.5523 2 19 2H15ZM14.4316 7.36349C14.4602 7.40179 14.4919 7.43851 14.5267 7.4733C14.5615 7.5081 14.5982 7.53979 14.6365 7.56839C15.4828 8.46473 16 9.67108 16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C12.3289 6 13.5353 6.51722 14.4316 7.36349Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Male: {
        defaultColors: ["#3D4C66"],
        keywords: ["gender","male","female","sex","demographics","customer","customer-type","staff","staff-type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 18L14 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C15.3137 16 18 13.3137 18 10C18 8.34315 17.3284 6.84314 16.2426 5.75736C15.1569 4.67157 13.6569 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map mark-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["map","location","store","branch","address","delivery","pickup","navigation","place","mark","marker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19.546L7.617 17.775M10.233 16L7.617 17.771"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L19 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14H6.69425C5.88508 14 5.4805 14 5.20075 14.237C4.92101 14.474 4.85449 14.873 4.72147 15.6712L4.38813 17.6712C4.20796 18.7522 4.11788 19.2927 4.41744 19.6464C4.71701 20 5.26498 20 6.36092 20H17.6391C18.735 20 19.283 20 19.5826 19.6464C19.8821 19.2927 19.792 18.7522 19.6119 17.6712L19.2785 15.6712C19.1455 14.873 19.079 14.474 18.7992 14.237C18.5195 14 18.1149 14 17.3057 14H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map mark-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["map","location","address","pin","store","customer","delivery","navigation","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.69425 14H7H17H17.3057C18.1149 14 18.5195 14 18.7992 14.237C19.079 14.474 19.1455 14.873 19.2785 15.6712L19.6119 17.6712C19.792 18.7522 19.8821 19.2927 19.5826 19.6464C19.283 20 18.735 20 17.6391 20H6.36092C5.26498 20 4.71701 20 4.41744 19.6464C4.11788 19.2927 4.20796 18.7522 4.38813 17.6712L4.72147 15.6712C4.85449 14.873 4.92101 14.474 5.20075 14.237C5.4805 14 5.88508 14 6.69425 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19.5459L7.617 17.7749"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L19 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map mark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","location","address","store","customer","delivery","navigation","route","mark","pin","gps","place"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.54012 15.9352C8.01012 15.6552 7.53012 15.3052 7.09012 14.9152C6.97012 14.8152 6.86012 14.7152 6.75012 14.6052C6.61012 14.4652 6.49012 14.3152 6.36012 14.1752C6.17012 13.9452 5.98012 13.7052 5.82012 13.4452C5.37012 13.4752 5.02012 13.5652 4.71012 13.8352C4.22012 14.2452 4.13012 14.8052 3.97012 15.7152L3.64012 17.7152C3.50012 18.5752 3.40012 19.1952 3.53012 19.7052L4.22012 19.1852L8.54012 15.9452V15.9352Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.3501 17.7152L20.0601 16.0052L18.7401 17.1852L16.2201 19.4252L14.5401 20.9252H17.6401C18.8801 20.9252 19.6301 20.9252 20.1601 20.3052C20.6801 19.6852 20.5601 18.9552 20.3601 17.7252L20.3501 17.7152Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.0701 14.8652L19.6601 14.3452C19.5701 14.1552 19.4501 13.9752 19.2801 13.8252C18.9701 13.5552 18.6101 13.4752 18.1701 13.4352C18.0001 13.6852 17.8201 13.9252 17.6301 14.1652C17.5101 14.3152 17.3801 14.4652 17.2401 14.5952C17.1301 14.7052 17.0101 14.8052 16.9001 14.9052C16.2101 15.5252 15.4101 16.0252 14.5301 16.3552L13.0701 18.0652C12.8001 18.3752 12.4201 18.5552 12.0101 18.5552C11.6001 18.5552 11.2101 18.3752 10.9501 18.0652L9.88012 16.8152L6.43012 19.4052L5.46012 20.1352L4.62012 20.7652C5.07012 20.8952 5.64012 20.9052 6.38012 20.9052H12.3001L13.9801 19.4052L19.0901 14.8652H19.0701Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.68012 13.6952C7.84012 13.8652 8.02012 14.0252 8.20012 14.1652C8.56012 14.4552 8.96012 14.7152 9.38012 14.9152C9.60012 15.0252 9.83012 15.1152 10.0601 15.1952C10.1701 15.2352 10.2701 15.2952 10.3401 15.3852L11.9201 17.2252C11.9201 17.2252 11.9701 17.2652 12.0001 17.2652C12.0301 17.2652 12.0601 17.2552 12.0801 17.2252L13.6601 15.3852C13.7401 15.2952 13.8301 15.2352 13.9401 15.1952C14.1701 15.1152 14.4001 15.0252 14.6201 14.9152C15.0401 14.7152 15.4401 14.4552 15.8001 14.1652C15.9801 14.0152 16.1601 13.8552 16.3201 13.6952C16.4101 13.6052 16.4801 13.5152 16.5701 13.4152C17.5301 12.3152 18.1101 10.8752 18.1101 9.2952C18.1101 5.8552 15.3801 3.0752 12.0101 3.0752C8.64012 3.0752 5.89012 5.85519 5.89012 9.28519C5.89012 10.8652 6.47012 12.3152 7.43012 13.4052C7.51012 13.4952 7.59012 13.5952 7.68012 13.6852V13.6952ZM11.9901 6.1652C13.6501 6.1652 14.9901 7.5052 14.9901 9.16519C14.9901 10.8252 13.6501 12.1652 11.9901 12.1652C10.3301 12.1652 8.99012 10.8252 8.99012 9.16519C8.99012 7.5052 10.3301 6.1652 11.9901 6.1652Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "map mark": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","location","address","store","pickup","delivery","point","pin","navigation","map-marker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14H6.69425C5.88508 14 5.4805 14 5.20075 14.237C4.92101 14.474 4.85449 14.873 4.72147 15.6712L4.38813 17.6712C4.20796 18.7522 4.11788 19.2927 4.41744 19.6464C4.71701 20 5.26498 20 6.36092 20H17.6391C18.735 20 19.283 20 19.5826 19.6464C19.8821 19.2927 19.792 18.7522 19.6119 17.6712L19.2785 15.6712C19.1455 14.873 19.079 14.474 18.7992 14.237C18.5195 14 18.1149 14 17.3057 14H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10.125C18 6.74226 15.3137 4 12 4C8.68629 4 6 6.74226 6 10.125C6 11.8164 6.67157 13.3476 7.75736 14.456C8.45277 15.1659 9.31809 15.7024 10.2857 15.9964L12 18L13.7143 15.9964C14.6819 15.7024 15.5472 15.1659 16.2426 14.456C17.3284 13.3476 18 11.8164 18 10.125Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19.546L7.617 17.775M10.233 16L7.617 17.771"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L19 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map-pin 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["map","pin","location","store-locator","address","destination","navigation","point-of-sale","customer-location","delivery-address","find-store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 16C17.0521 16.2826 19 17.0451 19 17.9414C19 19.0783 15.866 20 12 20C8.13401 20 5 19.0783 5 17.9414C5 17.0451 6.94789 16.2826 9.66667 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map-pin 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["map","location","pin","store","address","navigation","gps","point-of-sale","delivery","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="9"
                    r="5"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 16C17.0521 16.2826 19 17.0451 19 17.9414C19 19.0783 15.866 20 12 20C8.13401 20 5 19.0783 5 17.9414C5 17.0451 6.94789 16.2826 9.66667 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map-pin 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","store","delivery","navigation","point","gps","destination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.3333 16C17.0521 16.2826 19 17.0451 19 17.9414C19 19.0783 15.866 20 12 20C8.13401 20 5 19.0783 5 17.9414C5 17.0451 6.94789 16.2826 9.66667 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "map-pin 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","store-location","customer-location","delivery-address","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.3999 8.9999C6.3999 5.90711 8.90711 3.3999 11.9999 3.3999C15.0927 3.3999 17.5999 5.90711 17.5999 8.9999C17.5999 11.7513 15.6156 14.0393 13 14.5109V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14.5109C8.38429 14.0394 6.3999 11.7514 6.3999 8.9999ZM11 7C11 6.44772 11.4477 6 12 6C13.6569 6 15 7.34315 15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 7.55228 11 7ZM13.9005 15.9338C13.9736 15.3864 14.4767 15.0019 15.0241 15.075C16.2874 15.2437 17.4184 15.5217 18.2631 15.8998C18.6827 16.0877 19.0837 16.3229 19.3944 16.6238C19.7071 16.9265 20 17.3703 20 17.9414C20 18.7197 19.4694 19.2518 19.0208 19.5638C18.5427 19.8962 17.9161 20.1552 17.2319 20.3564C15.8503 20.7627 14.0008 21 12 21C9.99918 21 8.14972 20.7627 6.76812 20.3564C6.08387 20.1552 5.45732 19.8962 4.97923 19.5638C4.5306 19.2518 4 18.7197 4 17.9414C4 17.3704 4.29285 16.9266 4.60554 16.6238C4.91623 16.323 5.31713 16.0877 5.73673 15.8999C6.58134 15.5218 7.71221 15.2438 8.97537 15.075C9.52279 15.0019 10.0259 15.3864 10.099 15.9338C10.1721 16.4812 9.78764 16.9843 9.24022 17.0574C8.08047 17.2124 7.15744 17.4552 6.55388 17.7253C6.3774 17.8043 6.24551 17.8781 6.15004 17.9414C6.38419 18.0969 6.77369 18.2734 7.33239 18.4377C8.48429 18.7764 10.1348 19 12 19C13.8652 19 15.5157 18.7764 16.6676 18.4377C17.2263 18.2734 17.6158 18.0969 17.85 17.9414C17.7545 17.8781 17.6225 17.8043 17.446 17.7253C16.8424 17.4551 15.9192 17.2123 14.7593 17.0574C14.2119 16.9842 13.8274 16.4812 13.9005 15.9338Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "map-pin 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["location","map","pin","store-locator","address","delivery-address","customer-location","find-store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["map","pin","location","store","address","branch","shop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="9"
                    r="5"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","store-location","delivery-address","customer-location","find-location","find-store","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 8.75C6 5.57436 8.57436 3 11.75 3C14.9256 3 17.5 5.57436 17.5 8.75C17.5 11.4964 15.5746 13.793 13 14.3637V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14.4515C8.17873 14.084 6 11.6714 6 8.75ZM11 7C11 6.44772 11.4477 6 12 6C13.6569 6 15 7.34315 15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 7.55228 11 7ZM18.4752 15.4228C18.1564 14.9718 17.5323 14.8646 17.0814 15.1834C16.6304 15.5022 16.5232 16.1263 16.842 16.5772C16.9647 16.7508 17 16.8896 17 17C17 17.2456 16.7749 17.7372 15.7954 18.2269C14.8758 18.6867 13.5353 19 12 19C10.4647 19 9.12424 18.6867 8.20457 18.2269C7.22509 17.7372 7 17.2456 7 17C7 16.8896 7.0353 16.7508 7.15799 16.5772C7.47679 16.1263 7.36963 15.5022 6.91865 15.1834C6.46767 14.8646 5.84363 14.9718 5.52483 15.4228C5.20532 15.8748 5 16.4091 5 17C5 18.4113 6.11805 19.4197 7.31015 20.0157C8.56205 20.6417 10.2216 21 12 21C13.7784 21 15.438 20.6417 16.6899 20.0157C17.8819 19.4197 19 18.4113 19 17C19 16.4091 18.7947 15.8748 18.4752 15.4228Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "map-pin 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","store","find","destination","customer","delivery","pickup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.34141 16C6.12031 16.3128 6 16.6494 6 17C6 18.6569 8.68629 20 12 20C13.6569 20 15.1569 19.6642 16.2426 19.1213C17.3284 18.5784 18 17.8284 18 17C18 16.6494 17.8797 16.3128 17.6586 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["map","pin","location","address","delivery","store-location","customer-location","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16C6.63505 16.3372 5 17.0607 5 17.8989C5 19.0593 8.13401 20 12 20C15.866 20 19 19.0593 19 17.8989C19 17.0607 17.3649 16.3372 15 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "map-pin 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["map","location","pin","marker","store","address","customer","delivery-address","store-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16C6.63505 16.3372 5 17.0607 5 17.8989C5 19.0593 8.13401 20 12 20C15.866 20 19 19.0593 19 17.8989C19 17.0607 17.3649 16.3372 15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "map-pin 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","delivery","store-location","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.419 15.2822 12.4367 13 12.9V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V12.9C8.71776 12.4367 7 10.419 7 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.14116 16.99C9.68792 16.912 10.0679 16.4056 9.98999 15.8588C9.91203 15.3121 9.40559 14.9321 8.85884 15.01C7.62381 15.1861 6.51785 15.4703 5.69122 15.855C5.28009 16.0463 4.88755 16.2855 4.58397 16.5903C4.27709 16.8983 4 17.3398 4 17.8989C4 18.6736 4.51877 19.2111 4.97136 19.5323C5.44984 19.8718 6.07736 20.1367 6.76277 20.3424C8.1463 20.7577 9.99768 21 12 21C14.0023 21 15.8537 20.7577 17.2372 20.3424C17.9226 20.1367 18.5502 19.8718 19.0286 19.5323C19.4812 19.2111 20 18.6736 20 17.8989C20 17.3398 19.7229 16.8983 19.416 16.5903C19.1124 16.2855 18.7199 16.0463 18.3088 15.855C17.4821 15.4703 16.3762 15.1861 15.1412 15.01C14.5944 14.9321 14.088 15.3121 14.01 15.8588C13.9321 16.4056 14.3121 16.912 14.8588 16.99C15.9888 17.1511 16.8828 17.3973 17.4649 17.6682C17.6488 17.7538 17.7818 17.8328 17.8744 17.8989L17.8712 17.9012C17.6412 18.0644 17.2436 18.2523 16.6623 18.4268C15.5123 18.772 13.8637 19 12 19C10.1363 19 8.48771 18.772 7.33774 18.4268C6.75639 18.2523 6.35878 18.0644 6.12883 17.9012L6.12555 17.8989C6.21819 17.8328 6.35124 17.7538 6.53507 17.6682C7.1172 17.3973 8.01124 17.1511 9.14116 16.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "map-pin 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","store","shop","delivery","pickup","geo","point","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16C6.63505 16.3372 5 17.0607 5 17.8989C5 19.0593 8.13401 20 12 20C15.866 20 19 19.0593 19 17.8989C19 17.0607 17.3649 16.3372 15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "map-pin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","magnify","magnifier","lookup","scan","search-item","find-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 9C14 7.89543 13.1046 7 12 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["map","pin","location","address","delivery","store-locator","geo-location","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9C17 11.7614 14.7614 14 12 14C9.23858 14 7 11.7614 7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C13.1046 7 14 7.89543 14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","customer-location","store-location","delivery-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9C17 11.7614 14.7614 14 12 14C9.23858 14 7 11.7614 7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C13.1046 7 14 7.89543 14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "map-pin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["map","pin","location","address","customer","delivery","navigation","store-location","store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 14.917C15.8377 14.441 18 11.973 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 11.973 8.16229 14.441 11 14.917V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V14.917ZM11 7C11 6.44772 11.4477 6 12 6C13.6569 6 15 7.34315 15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 7.55228 11 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Mastercard-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mastercard","credit-card","payment","transaction","card","bank"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15C11.6569 15 13 13.6569 13 12C13 10.3431 11.6569 9 10 9C8.34315 9 7 10.3431 7 12C7 13.6569 8.34315 15 10 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15C15.6569 15 17 13.6569 17 12C17 10.3431 15.6569 9 14 9C12.3431 9 11 10.3431 11 12C11 13.6569 12.3431 15 14 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mastercard-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mastercard","payment","credit-card","debit-card","card","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16C11.2091 16 13 14.2091 13 12C13 9.79087 11.2091 8 9 8C6.79087 8 5 9.79087 5 12C5 14.2091 6.79087 16 9 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 16C17.2091 16 19 14.2091 19 12C19 9.79087 17.2091 8 15 8C12.7909 8 11 9.79087 11 12C11 14.2091 12.7909 16 15 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mastercard-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","loyalty","rewards","recurring","unlimited","program","mastercard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 12C7.25 10.7574 8.25736 9.75 9.5 9.75C10.1252 9.75 10.6911 10.0046 11.0995 10.4175C10.8752 10.8987 10.75 11.4354 10.75 12C10.75 12.5655 10.8729 13.0994 11.0991 13.583C10.6907 13.9956 10.1249 14.25 9.5 14.25C8.25736 14.25 7.25 13.2426 7.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 14.25C13.7181 14.25 13.0289 13.8518 12.6246 13.2436C12.3879 12.8877 12.25 12.4611 12.25 12C12.25 11.5389 12.3879 11.1123 12.6246 10.7564C13.0289 10.1482 13.7181 9.75 14.5 9.75C15.7426 9.75 16.75 10.7574 16.75 12C16.75 13.2426 15.7426 14.25 14.5 14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM9.5 8.25C10.4608 8.25 11.337 8.61171 12 9.20499C12.663 8.61171 13.5392 8.25 14.5 8.25C16.5711 8.25 18.25 9.92894 18.25 12C18.25 14.0711 16.5711 15.75 14.5 15.75C13.5392 15.75 12.663 15.3883 12 14.795C11.337 15.3883 10.4608 15.75 9.5 15.75C7.42894 15.75 5.75 14.0711 5.75 12C5.75 9.92894 7.42894 8.25 9.5 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Mastercard: {
        defaultColors: ["#3D4C66"],
        keywords: ["infinity","loyalty","rewards","recurring","unlimited","program","mastercard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15C11.6569 15 13 13.6569 13 12C13 10.3431 11.6569 9 10 9C8.34315 9 7 10.3431 7 12C7 13.6569 8.34315 15 10 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15C15.6569 15 17 13.6569 17 12C17 10.3431 15.6569 9 14 9C12.3431 9 11 10.3431 11 12C11 13.6569 12.3431 15 14 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "maximize-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["expand","fullscreen","maximize","resize","arrows","view","layout","stretch","increase","full-screen","enlarge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8.16645L4 5.46939C4 4.65787 4.65787 4 5.46939 4L8.16645 4C9.47554 4 10.1311 5.58274 9.20546 6.5084L6.5084 9.20547C5.58274 10.1311 4 9.47554 4 8.16645Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15.8335L20 18.5306C20 19.3421 19.3421 20 18.5306 20L15.8335 20C14.5245 20 13.8689 18.4173 14.7945 17.4916L17.4916 14.7945C18.4173 13.8689 20 14.5245 20 15.8335Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.16645 20H5.46939C4.65787 20 4 19.3421 4 18.5306V15.8335C4 14.5245 5.58274 13.8689 6.5084 14.7945L9.20547 17.4916C10.1311 18.4173 9.47554 20 8.16645 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8335 4L18.5306 4C19.3421 4 20 4.65787 20 5.46939L20 8.16645C20 9.47554 18.4173 10.1311 17.4916 9.20547L14.7945 6.5084C13.8689 5.58274 14.5245 4 15.8335 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "maximize-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["maximize","expand","fullscreen","arrows","screen","size","enlarge","view","extend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8.16645L4 5.46939C4 4.65787 4.65787 4 5.46939 4L8.16645 4C9.47554 4 10.1311 5.58274 9.20546 6.5084L6.5084 9.20547C5.58274 10.1311 4 9.47554 4 8.16645Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15.8335L20 18.5306C20 19.3421 19.3421 20 18.5306 20L15.8335 20C14.5245 20 13.8689 18.4173 14.7945 17.4916L17.4916 14.7945C18.4173 13.8689 20 14.5245 20 15.8335Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.16645 20H5.46939C4.65787 20 4 19.3421 4 18.5306V15.8335C4 14.5245 5.58274 13.8689 6.5084 14.7945L9.20547 17.4916C10.1311 18.4173 9.47554 20 8.16645 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8335 4L18.5306 4C19.3421 4 20 4.65787 20 5.46939L20 8.16645C20 9.47554 18.4173 10.1311 17.4916 9.20547L14.7945 6.5084C13.8689 5.58274 14.5245 4 15.8335 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L12 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "maximize-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["maximize","fullscreen","expand","enlarge","resize","full-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.73068C3 3.77485 3.77485 3 4.73068 3L9.26585 3C10.8077 3 11.5799 4.86419 10.4896 5.95446L8.92915 7.51494L12 10.5858L15.0709 7.51494L13.5104 5.95446C12.4201 4.86419 13.1923 3 14.7342 3L19.2693 3C20.2251 3 21 3.77485 21 4.73068V9.26585C21 10.8077 19.1358 11.5799 18.0455 10.4896L16.4851 8.92915L13.4142 12L16.4851 15.0709L18.0455 13.5104C19.1358 12.4201 21 13.1923 21 14.7342V19.2693C21 20.2251 20.2251 21 19.2693 21H14.7342C13.1923 21 12.4201 19.1358 13.5104 18.0455L15.0709 16.4851L12 13.4142L8.92915 16.4851L10.4896 18.0455C11.5799 19.1358 10.8077 21 9.26585 21H4.73068C3.77485 21 3 20.2251 3 19.2693L3 14.7342C3 13.1923 4.86419 12.4201 5.95446 13.5104L7.51493 15.0709L10.5858 12L7.51494 8.92915L5.95446 10.4896C4.86419 11.5799 3 10.8077 3 9.26585L3 4.73068Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    maximize: {
        defaultColors: ["#3D4C66"],
        keywords: ["maximize","fullscreen","expand","enlarge","resize","full-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8.16645L4 5.46939C4 4.65787 4.65787 4 5.46939 4L8.16645 4C9.47554 4 10.1311 5.58274 9.20546 6.5084L6.5084 9.20547C5.58274 10.1311 4 9.47554 4 8.16645Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 8L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15.8335L20 18.5306C20 19.3421 19.3421 20 18.5306 20L15.8335 20C14.5245 20 13.8689 18.4173 14.7945 17.4916L17.4916 14.7945C18.4173 13.8689 20 14.5245 20 15.8335Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.16645 20H5.46939C4.65787 20 4 19.3421 4 18.5306V15.8335C4 14.5245 5.58274 13.8689 6.5084 14.7945L9.20547 17.4916C10.1311 18.4173 9.47554 20 8.16645 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 16L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8335 4L18.5306 4C19.3421 4 20 4.65787 20 5.46939L20 8.16645C20 9.47554 18.4173 10.1311 17.4916 9.20547L14.7945 6.5084C13.8689 5.58274 14.5245 4 15.8335 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medal","reward","first","place","ranking","employee-of-the-month","achievement","loyalty","promotion","tier","membership","level"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="9" y="8" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 8L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","award","first","place","promotion","loyalty","reward","achievement","recognition","loyalty-program","best-seller","top-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.3675 19.5442L10.4225 19.8592C8.92755 20.3575 8.18008 20.6066 7.74803 20.223C7.73759 20.2138 7.72734 20.2043 7.71729 20.1946C7.30169 19.7932 7.49279 19.0288 7.87498 17.5001C8.05322 16.7871 8.14234 16.4306 8.40517 16.2199C8.41193 16.2144 8.41876 16.2091 8.42566 16.2039C8.69388 16 9.06133 16 9.79625 16H14.2038C14.9387 16 15.3061 16 15.5743 16.2039C15.5812 16.2091 15.5881 16.2144 15.5948 16.2199C15.8577 16.4306 15.9468 16.7871 16.125 17.5001L16.125 17.5001C16.5072 19.0288 16.6983 19.7932 16.2827 20.1946C16.2727 20.2043 16.2624 20.2138 16.252 20.223C15.8199 20.6066 15.0724 20.3575 13.5775 19.8592L12.6325 19.5442C12.319 19.4397 12.1623 19.3874 12 19.3874C11.8377 19.3874 11.681 19.4397 11.3675 19.5442Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="9" y="8" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 8L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","award","loyalty","reward","achievement","discount","vip","promotion","ranking","top-seller","best-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.74 15.87C17 15.67 17.25 15.46 17.48 15.23C18.94 13.77 19.75 11.82 19.75 9.75C19.75 5.48 16.27 2 12 2C7.73 2 4.25 5.48 4.25 9.75C4.25 12.24 5.43 14.45 7.26 15.87C7.11 16.18 7.02 16.55 6.9 17.01C6.46 18.79 6.19 19.86 7.01 20.65L7.08 20.72C7.43 21.03 7.82 21.16 8.27 21.16C8.92 21.16 9.71 20.9 10.73 20.56L11.68 20.24C11.84 20.19 11.94 20.15 11.96 20.13C12.05 20.14 12.14 20.18 12.3 20.24L13.25 20.56C14.99 21.14 16.04 21.49 16.96 20.66C17.79 19.86 17.52 18.78 17.08 17C16.97 16.54 16.87 16.18 16.72 15.87H16.74ZM8.25 9.25C8.25 8.01 9.26 7 10.5 7C11.74 7 12.75 8.01 12.75 9.25V10.25C12.75 11.49 11.74 12.5 10.5 12.5C9.26 12.5 8.25 11.49 8.25 10.25V9.25ZM14.25 11.75V7.75C14.25 7.34 14.59 7 15 7C15.41 7 15.75 7.34 15.75 7.75V11.75C15.75 12.16 15.41 12.5 15 12.5C14.59 12.5 14.25 12.16 14.25 11.75ZM11.05 18.35L10.1 18.67C9.48 18.88 8.83 19.09 8.49 19.15C8.52 18.8 8.69 18.14 8.85 17.49C8.9 17.28 8.96 17.06 9.01 16.9C9.93 17.29 10.94 17.5 12.01 17.5C13.08 17.5 14.07 17.29 15.01 16.9C15.06 17.06 15.11 17.29 15.17 17.49C15.32 18.1 15.49 18.78 15.53 19.14C15.18 19.08 14.54 18.87 13.91 18.66L12.96 18.34C12.24 18.1 11.79 18.1 11.07 18.34"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.5 11C10.91 11 11.25 10.66 11.25 10.25V9.25C11.25 8.84 10.91 8.5 10.5 8.5C10.09 8.5 9.75 8.84 9.75 9.25V10.25C9.75 10.66 10.09 11 10.5 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","reward","achievement","loyalty","promotion","discount","tier","level","vip","member","ribbon","badge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="8" width="3" height="4" rx="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 8L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medal","award","loyalty","rewards","recognition","achievement","winner","promotion","vip","badge","gift","certificate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="9" y="7" width="6" height="6" rx="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Medal-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","reward","achievement","loyalty","vip","points","discount","promotion","tier","badge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.3675 19.5442L10.4225 19.8592C8.92755 20.3575 8.18008 20.6066 7.74803 20.223C7.73759 20.2138 7.72734 20.2043 7.71729 20.1946C7.30169 19.7932 7.49279 19.0288 7.87498 17.5001C8.05322 16.7871 8.14234 16.4306 8.40517 16.2199C8.41193 16.2144 8.41876 16.2091 8.42566 16.2039C8.69388 16 9.06133 16 9.79625 16H14.2038C14.9387 16 15.3061 16 15.5743 16.2039C15.5812 16.2091 15.5881 16.2144 15.5948 16.2199C15.8577 16.4306 15.9468 16.7871 16.125 17.5001L16.125 17.5001C16.5072 19.0288 16.6983 19.7932 16.2827 20.1946C16.2727 20.2043 16.2624 20.2138 16.252 20.223C15.8199 20.6066 15.0724 20.3575 13.5775 19.8592L12.6325 19.5442C12.319 19.4397 12.1623 19.3874 12 19.3874C11.8377 19.3874 11.681 19.4397 11.3675 19.5442Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="9"
                    y="7"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Medal-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","reward","achievement","loyalty","points","customer-reward","staff-reward","bonus","employee-of-the-month","customer-loyalty","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.74 15.87C17 15.67 17.25 15.46 17.48 15.23C18.94 13.77 19.75 11.82 19.75 9.75C19.75 5.48 16.27 2 12 2C7.73 2 4.25 5.48 4.25 9.75C4.25 12.24 5.43 14.45 7.26 15.87C7.11 16.18 7.02 16.55 6.9 17.01C6.46 18.79 6.19 19.86 7.01 20.65L7.08 20.72C7.43 21.03 7.82 21.16 8.27 21.16C8.92 21.16 9.71 20.9 10.73 20.56L11.68 20.24C11.84 20.19 11.94 20.15 11.96 20.13C12.05 20.14 12.14 20.18 12.3 20.24L13.25 20.56C14.99 21.14 16.04 21.49 16.96 20.66C17.79 19.86 17.52 18.78 17.08 17C16.97 16.54 16.87 16.18 16.72 15.87H16.74ZM12 5.75C14.21 5.75 16 7.54 16 9.75C16 11.96 14.21 13.75 12 13.75C9.79 13.75 8 11.96 8 9.75C8 7.54 9.79 5.75 12 5.75ZM11.05 18.35L10.1 18.67C9.48 18.88 8.83 19.09 8.49 19.15C8.52 18.8 8.69 18.14 8.85 17.49C8.9 17.28 8.96 17.06 9.01 16.9C9.93 17.29 10.94 17.5 12.01 17.5C13.08 17.5 14.07 17.29 15.01 16.9C15.06 17.06 15.11 17.29 15.17 17.49C15.32 18.1 15.49 18.78 15.53 19.14C15.18 19.08 14.54 18.87 13.91 18.66L12.96 18.34C12.24 18.1 11.79 18.1 11.07 18.34"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 11.75C13.1046 11.75 14 10.8546 14 9.75C14 8.64543 13.1046 7.75 12 7.75C10.8954 7.75 10 8.64543 10 9.75C10 10.8546 10.8954 11.75 12 11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal-Badge 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medal","badge","award","loyalty","ranking","tier","reward","achievement","second","2"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 13L13.8 13C13.3582 13 13 12.6418 13 12.2V12.2C13 11.7582 13.3582 11.4 13.8 11.4L15 11.4C15.5523 11.4 16 10.9523 16 10.4L16 10C16 9.44771 15.5523 9 15 9L13 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","badge","ranking","achievement","second","second-place","sales-target","level-two","tier-two"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 13L13.8 13C13.3582 13 13 12.6418 13 12.2V12.2C13 11.7582 13.3582 11.4 13.8 11.4L15 11.4C15.5523 11.4 16 10.9523 16 10.4L16 10C16 9.44771 15.5523 9 15 9L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","award","second","second-place","discount","loyalty","tier","membership","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 11C9.91 11 10.25 10.66 10.25 10.25V9.25C10.25 8.84 9.91 8.5 9.5 8.5C9.09 8.5 8.75 8.84 8.75 9.25V10.25C8.75 10.66 9.09 11 9.5 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.75 9.75C19.75 5.48 16.27 2 12 2C7.73 2 4.25 5.48 4.25 9.75C4.25 12.13 5.33 14.25 7.02 15.68C7.02 15.71 7 15.73 7 15.75V17.98C7 19.43 7 20.39 7.83 20.99C8.16 21.23 8.5 21.32 8.88 21.32C9.46 21.32 10.12 21.1 10.95 20.82L12 20.47L13.05 20.82C13.88 21.1 14.54 21.32 15.11 21.32C15.49 21.32 15.83 21.22 16.16 20.99C16.99 20.39 16.99 19.43 16.99 17.98V15.75C16.99 15.75 16.98 15.7 16.97 15.68C18.66 14.26 19.74 12.13 19.74 9.75H19.75ZM16 11C16.41 11 16.75 11.34 16.75 11.75C16.75 12.16 16.41 12.5 16 12.5H13.8C12.94 12.5 12.25 11.8 12.25 10.95C12.25 10.1 12.95 9.4 13.8 9.4H15C15.14 9.4 15.25 9.29 15.25 9.15V8.75C15.25 8.61 15.14 8.5 15 8.5H13C12.59 8.5 12.25 8.16 12.25 7.75C12.25 7.34 12.59 7 13 7H15C15.96 7 16.75 7.79 16.75 8.75V9.15C16.75 10.11 15.96 10.9 15 10.9H13.8V11H16ZM9.5 7C10.74 7 11.75 8.01 11.75 9.25V10.25C11.75 11.49 10.74 12.5 9.5 12.5C8.26 12.5 7.25 11.49 7.25 10.25V9.25C7.25 8.01 8.26 7 9.5 7ZM10.32 18.92C9.85001 19.08 9.31999 19.25 9.03999 19.3C8.99999 19.02 9 18.47 9 17.97V16.89C9.63 17.15 10.3 17.33 11 17.42V18.69L10.32 18.92ZM15 17.97C15 18.47 15 19.02 14.96 19.3C14.68 19.25 14.16 19.08 13.69 18.92L13.01 18.69V17.42C13.71 17.33 14.38 17.15 15.01 16.89V17.97H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal-Badge 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","award","ranking","top","second","2nd","tier","loyalty","program","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 13L13.8 13C13.3582 13 13 12.6418 13 12.2V12.2C13 11.7582 13.3582 11.4 13.8 11.4L15 11.4C15.5523 11.4 16 10.9523 16 10.4L16 10C16 9.44771 15.5523 9 15 9L13 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medal","badge","achievement","reward","loyalty","tier","rank","member-level","status","bronze","sale-target"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11L16 11M16 11L16 10C16 9.44772 15.5523 9 15 9L13 9M16 11L16 12C16 12.5523 15.5523 13 15 13L13 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","loyalty","reward","achievement","points","tier","vip","program","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 11C9.91 11 10.25 10.66 10.25 10.25V9.25C10.25 8.84 9.91 8.5 9.5 8.5C9.09 8.5 8.75 8.84 8.75 9.25V10.25C8.75 10.66 9.09 11 9.5 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.75 9.75C19.75 5.48 16.27 2 12 2C7.73 2 4.25 5.48 4.25 9.75C4.25 12.13 5.33 14.25 7.02 15.68C7.02 15.71 7 15.73 7 15.75V17.98C7 19.43 7 20.39 7.83 20.99C8.16 21.23 8.5 21.32 8.88 21.32C9.46 21.32 10.12 21.1 10.95 20.82L12 20.47L13.05 20.82C13.88 21.1 14.54 21.32 15.11 21.32C15.49 21.32 15.83 21.22 16.16 20.99C16.99 20.39 16.99 19.43 16.99 17.98V15.75C16.99 15.75 16.98 15.7 16.97 15.68C18.66 14.26 19.74 12.13 19.74 9.75H19.75ZM9.5 7C10.74 7 11.75 8.01 11.75 9.25V10.25C11.75 11.49 10.74 12.5 9.5 12.5C8.26 12.5 7.25 11.49 7.25 10.25V9.25C7.25 8.01 8.26 7 9.5 7ZM15 12.5H13C12.59 12.5 12.25 12.16 12.25 11.75C12.25 11.34 12.59 11 13 11H15C15.14 11 15.25 10.89 15.25 10.75V10.5H13C12.59 10.5 12.25 10.16 12.25 9.75C12.25 9.34 12.59 9 13 9H15.25V8.75C15.25 8.61 15.14 8.5 15 8.5H13C12.59 8.5 12.25 8.16 12.25 7.75C12.25 7.34 12.59 7 13 7H15C15.96 7 16.75 7.79 16.75 8.75V10.75C16.75 11.71 15.96 12.5 15 12.5ZM10.32 18.92C9.85001 19.08 9.31999 19.25 9.03999 19.3C8.99999 19.02 9 18.47 9 17.97V16.89C9.63 17.15 10.3 17.33 11 17.42V18.69L10.32 18.92ZM15 17.97C15 18.47 15 19.02 14.96 19.3C14.68 19.25 14.16 19.08 13.69 18.92L13.01 18.69V17.42C13.71 17.33 14.38 17.15 15.01 16.89V17.97H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal-Badge 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","badge","achievement","award","loyalty","points","rewards","tier","membership","loyalty-program","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11L16 11M16 11L16 10C16 9.44772 15.5523 9 15 9L13 9M16 11L16 12C16 12.5523 15.5523 13 15 13L13 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","loyalty","reward","rank","tier","award","promotion","vip","achievement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11 10.5V11.5C11 12.3284 10.3284 13 9.5 13C8.67157 13 8 12.3284 8 11.5V10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11L16 11M16 11L16 10C16 9.44772 15.5523 9 15 9L13 9M16 11L16 12C16 12.5523 15.5523 13 15 13L13 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Medal-Badge 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["medal","badge","award","loyalty","reward","achievement","recognition","member","vip","premium","points","tier","program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 16L18.2251 16C19.4914 16 20.1245 16 20.4238 15.5847C20.7231 15.1694 20.5229 14.5688 20.1225 13.3675L19.6667 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 8L18.2251 8C19.4914 8 20.1245 8 20.4238 8.41529C20.7231 8.83058 20.5229 9.4312 20.1225 10.6325L19.6667 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8L5.77485 8C4.50862 8 3.87551 8 3.57618 8.41529C3.27686 8.83058 3.47707 9.4312 3.87748 10.6325L4.33333 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16L5.77485 16C4.50862 16 3.87551 16 3.57618 15.5847C3.27686 15.1694 3.47707 14.5688 3.87749 13.3675L4.33333 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Medal-Badge 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","badge","ribbon","award","loyalty","rewards","achievements","promotion","discount","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.77518 8H7.00033L7.00033 16H5.77519C4.50896 16 3.87584 16 3.57652 15.5847C3.27719 15.1694 3.4774 14.5688 3.87782 13.3675L4.12285 12.6325C4.22733 12.319 4.27957 12.1623 4.27957 12C4.27957 11.8377 4.22733 11.681 4.12285 11.3675L3.87782 10.6325C3.4774 9.43121 3.27719 8.83058 3.57652 8.41529C3.87584 8 4.50896 8 5.77518 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.2248 16L16.9997 16L16.9997 8L18.2248 8C19.491 8 20.1242 8 20.4235 8.41529C20.7228 8.83058 20.5226 9.4312 20.1222 10.6325L19.8772 11.3675C19.7727 11.681 19.7204 11.8377 19.7204 12C19.7204 12.1623 19.7727 12.319 19.8772 12.6325L20.1222 13.3675C20.5226 14.5688 20.7228 15.1694 20.4235 15.5847C20.1242 16 19.491 16 18.2248 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Medal-Badge 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","reward","loyalty","promotion","discount","achievement","award","recognition","tier","vip","member","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.8641 13.19L21.6041 12.4C21.5541 12.23 21.5241 12.14 21.5041 12.07C21.5041 12.04 21.4941 12.02 21.4941 12.01C21.4941 12.01 21.4941 12.01 21.4941 12C21.4941 12 21.4941 11.97 21.5041 11.94C21.5241 11.87 21.5541 11.78 21.6041 11.61L21.8641 10.82C22.0541 10.26 22.1998 9.77 22.2698 9.36C22.3498 8.92 22.3641 8.42 22.0441 7.98C21.7241 7.54 21.2441 7.38 20.8041 7.31C20.3941 7.25 19.8741 7.25 19.2841 7.25H16.7941C15.5741 6.02 13.8741 5.25 12.0041 5.25C10.1341 5.25 8.43415 6.02 7.21415 7.25H4.72413C4.13413 7.25 3.61414 7.25 3.20414 7.31C2.76414 7.37 2.29415 7.53 1.96415 7.98C1.64415 8.43 1.64413 8.93 1.72413 9.36C1.79413 9.77 1.96414 10.26 2.14414 10.82C2.14414 10.84 2.15413 10.85 2.16413 10.87L2.41413 11.61C2.46413 11.78 2.49414 11.87 2.51414 11.94C2.51414 11.97 2.52414 11.99 2.52414 12C2.52414 12 2.52414 12 2.52414 12.01C2.52414 12.01 2.52414 12.04 2.51414 12.07C2.49414 12.14 2.46413 12.23 2.41413 12.4L2.16413 13.14C2.16413 13.14 2.15414 13.17 2.14414 13.19C1.95414 13.75 1.79413 14.24 1.72413 14.65C1.64413 15.09 1.64415 15.59 1.96415 16.03C2.28415 16.48 2.76414 16.63 3.20414 16.7C3.61414 16.76 4.13413 16.76 4.72413 16.76H7.21415C8.43415 17.99 10.1341 18.75 12.0041 18.75C13.8741 18.75 15.5741 17.99 16.7941 16.76H19.2841C19.8741 16.76 20.3941 16.76 20.8041 16.7C21.2441 16.64 21.7141 16.48 22.0441 16.03C22.3641 15.58 22.3498 15.08 22.2698 14.65C22.1998 14.24 22.0441 13.75 21.8641 13.19ZM4.78412 15.26C4.12412 15.26 3.71415 15.26 3.43415 15.22C3.30415 15.2 3.23414 15.18 3.20414 15.16C3.20414 15.13 3.20413 15.06 3.22413 14.93C3.27413 14.64 3.40414 14.26 3.61414 13.63L3.85413 12.89C3.85413 12.89 3.86412 12.85 3.87412 12.83C3.95412 12.58 4.05414 12.31 4.05414 12.02C4.05414 11.73 3.96412 11.46 3.87412 11.21C3.87412 11.19 3.86413 11.17 3.85413 11.15L3.61414 10.41C3.40414 9.79 3.27413 9.4 3.22413 9.11C3.20413 8.98 3.20414 8.91 3.20414 8.88C3.23414 8.87 3.29415 8.84 3.43415 8.82C3.72415 8.78 4.13412 8.78 4.78412 8.78H6.09412C5.56412 9.74 5.26414 10.85 5.26414 12.03C5.26414 13.21 5.56412 14.32 6.09412 15.28H4.78412V15.26ZM11.0141 14.76C9.49414 14.76 8.26413 13.53 8.26413 12.01C8.26413 10.49 9.49414 9.26 11.0141 9.26C12.5341 9.26 13.7641 10.49 13.7641 12.01C13.7641 13.53 12.5341 14.76 11.0141 14.76ZM15.7641 14.01C15.7641 14.42 15.4241 14.76 15.0141 14.76C14.6041 14.76 14.2641 14.42 14.2641 14.01V10.01C14.2641 9.6 14.6041 9.26 15.0141 9.26C15.4241 9.26 15.7641 9.6 15.7641 10.01V14.01ZM20.1641 12.82C20.1641 12.82 20.1741 12.86 20.1841 12.88L20.4341 13.62C20.6441 14.24 20.7641 14.63 20.8241 14.92C20.8441 15.05 20.8441 15.12 20.8441 15.15C20.8141 15.16 20.7541 15.19 20.6141 15.21C20.3241 15.25 19.9141 15.25 19.2641 15.25H17.9541C18.4841 14.29 18.7841 13.18 18.7841 12C18.7841 10.82 18.4841 9.71 17.9541 8.75H19.2641C19.9241 8.75 20.3341 8.75 20.6141 8.79C20.7541 8.81 20.8141 8.83 20.8441 8.85C20.8441 8.88 20.8441 8.95 20.8241 9.08C20.7741 9.37 20.6441 9.75 20.4341 10.38L20.1841 11.12C20.1841 11.12 20.1741 11.16 20.1641 11.18C20.0841 11.43 19.9941 11.7 19.9941 11.99C19.9941 12.28 20.0841 12.55 20.1641 12.8V12.82Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0141 13.26C11.7045 13.26 12.2641 12.7004 12.2641 12.01C12.2641 11.3196 11.7045 10.76 11.0141 10.76C10.3238 10.76 9.76413 11.3196 9.76413 12.01C9.76413 12.7004 10.3238 13.26 11.0141 13.26Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal-Badge 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","reward","loyalty","promotion","achievement","tier","level","award","recognition","vip","member","program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10C12.1046 10 13 10.8954 13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 16L18.2251 16C19.4914 16 20.1245 16 20.4238 15.5847C20.7231 15.1694 20.5229 14.5688 20.1225 13.3675L19.6667 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 8L18.2251 8C19.4914 8 20.1245 8 20.4238 8.41529C20.7231 8.83058 20.5229 9.4312 20.1225 10.6325L19.6667 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8L5.77485 8C4.50862 8 3.87551 8 3.57618 8.41529C3.27686 8.83058 3.47707 9.4312 3.87748 10.6325L4.33333 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16L5.77485 16C4.50862 16 3.87551 16 3.57618 15.5847C3.27686 15.1694 3.47707 14.5688 3.87749 13.3675L4.33333 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Medal-Badge-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medal","badge","award","loyalty","rewards","recognition","achievement","top performer","employee of the month","discounts","promotion","tier","points","loyalty program","vip","achievement badge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 13V9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Medal-Badge-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["medal","badge","loyalty","rewards","achievements","promotions","member","discount","tier","points"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 13V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Medal-Badge-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","loyalty","achievement","reward","recognition","promotion","employee-of-the-month","top-seller","sales-award"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11C11.6904 11 12.25 10.4404 12.25 9.75C12.25 9.05964 11.6904 8.5 11 8.5C10.3096 8.5 9.75 9.05964 9.75 9.75C9.75 10.4404 10.3096 11 11 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.75 9.75C19.75 5.48 16.27 2 12 2C7.73 2 4.25 5.48 4.25 9.75C4.25 12.12 5.32 14.24 7 15.66V17.97C7 19.42 7 20.38 7.83 20.98C8.16 21.22 8.5 21.31 8.88 21.31C9.46 21.31 10.12 21.09 10.95 20.81L12 20.46L13.05 20.81C13.88 21.09 14.54 21.31 15.11 21.31C15.49 21.31 15.83 21.21 16.16 20.98C16.99 20.38 16.99 19.42 16.99 17.97V15.74C16.99 15.74 16.98 15.69 16.97 15.67C18.66 14.25 19.74 12.12 19.74 9.74L19.75 9.75ZM8.25 9.75C8.25 8.23 9.48 7 11 7C12.52 7 13.75 8.23 13.75 9.75C13.75 11.27 12.52 12.5 11 12.5C9.48 12.5 8.25 11.27 8.25 9.75ZM15.75 11.75C15.75 12.16 15.41 12.5 15 12.5C14.59 12.5 14.25 12.16 14.25 11.75V7.75C14.25 7.34 14.59 7 15 7C15.41 7 15.75 7.34 15.75 7.75V11.75ZM10.32 18.92C9.85 19.08 9.32 19.25 9.04 19.3C9 19.02 9 18.47 9 17.97V16.89C9.63 17.15 10.3 17.33 11 17.42V18.69L10.32 18.92ZM15 17.97C15 18.47 15 19.02 14.96 19.3C14.68 19.25 14.16 19.08 13.69 18.92L13.01 18.69V17.42C13.71 17.33 14.38 17.15 15.01 16.89V17.97H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Medal-Badge": {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","reward","loyalty","loyalty-program","award","achievement","recognition","promotion","tier","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11C5 7.13401 8.13401 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 17L8 18.2251C8 19.4914 8 20.1245 8.41529 20.4238C8.83058 20.7231 9.4312 20.5229 10.6325 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 17L16 18.2251C16 19.4914 16 20.1245 15.5847 20.4238C15.1694 20.7231 14.5688 20.5229 13.3675 20.1225L12 19.6667"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 18L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 13V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Medal: {
        defaultColors: ["#3D4C66"],
        keywords: ["medal","badge","reward","loyalty","loyalty-program","award","achievement","recognition","promotion","tier","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10C5 13.866 8.13401 17 12 17C13.933 17 15.683 16.2165 16.9497 14.9497C18.2165 13.683 19 11.933 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.25 16L7.88364 17.4654C7.4934 19.0264 7.29828 19.8069 7.73251 20.209C8.16674 20.6111 8.92996 20.3567 10.4564 19.8479L11.3675 19.5442C11.681 19.4397 11.8377 19.3874 12 19.3874C12.1623 19.3874 12.319 19.4397 12.6325 19.5442L13.5436 19.8479C15.07 20.3567 15.8333 20.6111 16.2675 20.209C16.7017 19.8069 16.5066 19.0264 16.1164 17.4654L15.75 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="9" y="7" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "medicine-pills-jar-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["medicine","pills","jar","pharmacy","prescription","drugs","medication","bottle","health","healthcare","supplements"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 12H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M18 16H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M15 8L15 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 8L12 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L9 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["medicine","pills","jar","prescription","pharmacy","inventory","drugs","medication","health","bottle","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16V11.6569C18 10.8394 18 10.4306 17.8478 10.0631C17.6955 9.69552 17.4065 9.40649 16.8284 8.82844L16.8284 8.82843L16 8H9.41421C8.83737 8 8.54895 8 8.28018 8.07661C8.13253 8.1187 7.99022 8.17764 7.85606 8.25229C7.61183 8.38817 7.40789 8.59211 7 9C6.59211 9.40789 6.38817 9.61183 6.25229 9.85606C6.17764 9.99022 6.1187 10.1325 6.07661 10.2802C6 10.5489 6 10.8374 6 11.4142V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","bottle","container","product","inventory","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.96557 3.50011L9 3.5L9 7.50002L6.96557 7.50013C6.76046 7.50021 6.53866 7.5003 6.35145 7.47512C6.13212 7.44564 5.85193 7.3698 5.61614 7.134C5.38033 6.8982 5.3045 6.61801 5.27501 6.39869C5.24984 6.21147 5.24993 5.98968 5.25001 5.78456L5.25001 5.21567C5.24993 5.01056 5.24984 4.78876 5.27501 4.60155C5.3045 4.38222 5.38033 4.10203 5.61613 3.86623C5.85193 3.63043 6.13212 3.5546 6.35145 3.52511C6.53866 3.49994 6.76046 3.50003 6.96557 3.50011Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.0345 7.50013L15 7.50014V3.50012L17.0345 3.50011C17.2396 3.50003 17.4614 3.49994 17.6486 3.52511C17.8679 3.5546 18.1481 3.63044 18.3839 3.86624C18.6197 4.10204 18.6955 4.38222 18.725 4.60155C18.7502 4.78876 18.7501 5.01057 18.75 5.21568V5.78459C18.7501 5.9897 18.7502 6.21148 18.725 6.39869C18.6955 6.61801 18.6197 6.8982 18.3839 7.134C18.1481 7.3698 17.8679 7.44564 17.6486 7.47512C17.4614 7.5003 17.2396 7.50021 17.0345 7.50013Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M10.5 7.50002L13.5 7.50014V3.50012L10.5 3.5L10.5 7.50002Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M6.70938 8.58407C6.84848 8.37543 7.08265 8.2501 7.33342 8.2501H16.6667C16.9175 8.2501 17.1517 8.37543 17.2908 8.58407L18.0013 9.64976C18.2873 10.0782 18.5134 10.4167 18.6321 10.8087C18.7508 11.2008 18.7505 11.6078 18.7501 12.123L18.7501 12.2501H5.25004L5.25004 12.123C5.24967 11.6078 5.24938 11.2008 5.36808 10.8087C5.48678 10.4167 5.71281 10.0782 5.99887 9.64976L6.70938 8.58407Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M5.25007 15.2501L5.25006 13.7501H18.7501L18.7501 15.2501H5.25007Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M5.32999 18.2946C5.27172 17.8611 5.25592 17.3456 5.25165 16.7501H18.7485C18.7442 17.3456 18.7284 17.8611 18.6702 18.2946C18.5858 18.9224 18.4001 19.4892 17.9446 19.9446C17.4892 20.4001 16.9224 20.5858 16.2946 20.6702C15.6998 20.7502 14.9506 20.7501 14.0521 20.7501H9.94809C9.04962 20.7501 8.30038 20.7502 7.7056 20.6702C7.07781 20.5858 6.51101 20.4001 6.05554 19.9446C5.60007 19.4892 5.4144 18.9224 5.32999 18.2946Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "medicine-pills-jar-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","container","medicine","pills","inventory","stock","medical","pharmacy","prescription"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.35145 3.52501C6.53866 3.49984 6.76046 3.49993 6.96557 3.50001H17.0345C17.2396 3.49993 17.4614 3.49984 17.6486 3.52501C17.8679 3.5545 18.1481 3.63034 18.3839 3.86614C18.6197 4.10194 18.6955 4.38212 18.725 4.60145C18.7502 4.78866 18.7501 5.01047 18.75 5.21558V5.78449C18.7501 5.9896 18.7502 6.21138 18.725 6.39859C18.6955 6.61791 18.6197 6.8981 18.3839 7.1339C18.1481 7.3697 17.8679 7.44554 17.6486 7.47502C17.4614 7.5002 17.2396 7.50011 17.0345 7.50003H6.96557C6.76046 7.50011 6.53866 7.5002 6.35145 7.47502C6.13212 7.44554 5.85193 7.3697 5.61614 7.1339C5.38033 6.8981 5.3045 6.61791 5.27501 6.39859C5.24984 6.21137 5.24993 5.98958 5.25001 5.78446L5.25001 5.21557C5.24993 5.01046 5.24984 4.78866 5.27501 4.60145C5.3045 4.38212 5.38033 4.10193 5.61613 3.86613C5.85193 3.63033 6.13212 3.5545 6.35145 3.52501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.33342 8.25C7.08265 8.25 6.84848 8.37533 6.70938 8.58397L5.99887 9.64966C5.71281 10.0781 5.48678 10.4166 5.36808 10.8086C5.24938 11.2007 5.24967 11.6077 5.25004 12.1229L5.25008 16.052C5.25005 16.9505 5.25003 17.6997 5.32999 18.2945C5.4144 18.9223 5.60007 19.4891 6.05554 19.9445C6.51101 20.4 7.07781 20.5857 7.7056 20.6701C8.30038 20.7501 9.04962 20.75 9.94809 20.75H14.0521C14.9506 20.75 15.6998 20.7501 16.2946 20.6701C16.9224 20.5857 17.4892 20.4 17.9446 19.9445C18.4001 19.4891 18.5858 18.9223 18.6702 18.2945C18.7501 17.6997 18.7501 16.9505 18.7501 16.052L18.7501 12.1229C18.7505 11.6077 18.7508 11.2007 18.6321 10.8086C18.5134 10.4166 18.2873 10.0781 18.0013 9.64966L17.2908 8.58397C17.1517 8.37533 16.9175 8.25 16.6667 8.25H7.33342ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75H14C14.4142 13.75 14.75 13.4142 14.75 13C14.75 12.5858 14.4142 12.25 14 12.25H10ZM10 16.25C9.58579 16.25 9.25 16.5858 9.25 17C9.25 17.4142 9.58579 17.75 10 17.75H14C14.4142 17.75 14.75 17.4142 14.75 17C14.75 16.5858 14.4142 16.25 14 16.25H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "medicine-pills-jar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["medicine","pills","jar","prescription","pharmacy","drugs","medication","bottle","healthcare","vitamins","supplements","inventory","dispense","refill","dosage","rx"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16V11.6569C18 10.8394 18 10.4306 17.8478 10.0631C17.6955 9.69552 17.4065 9.40649 16.8284 8.82844L16.8284 8.82843L16 8H9.41421C8.83737 8 8.54895 8 8.28018 8.07661C8.13253 8.1187 7.99022 8.17764 7.85606 8.25229C7.61183 8.38817 7.40789 8.59211 7 9C6.59211 9.40789 6.38817 9.61183 6.25229 9.85606C6.17764 9.99022 6.1187 10.1325 6.07661 10.2802C6 10.5489 6 10.8374 6 11.4142V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7L15 5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L9 5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "medicine-pills-jar-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","medicine","pills","prescription","drugs","pharmacy","health","medical","bottle","medication","supplements","retail","product","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V15C12 15.9428 12 16.4142 11.7071 16.7071C11.4142 17 10.9428 17 10 17H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["jar","bottle","container","stock","inventory","pharmacy","medicine","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V15C12 15.9428 12 16.4142 11.7071 16.7071C11.4142 17 10.9428 17 10 17H6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["medicine","pills","jar","pharmacy","prescription","medication","health","supplements","drugs","bottle","container","inventory","stock","refill","medical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16V11.6569C18 10.8394 18 10.4306 17.8478 10.0631C17.6955 9.69552 17.4065 9.40649 16.8284 8.82844L16.8284 8.82843L16 8H9.41421C8.83737 8 8.54895 8 8.28018 8.07661C8.13253 8.1187 7.99022 8.17764 7.85606 8.25229C7.61183 8.38817 7.40789 8.59211 7 9C6.59211 9.40789 6.38817 9.61183 6.25229 9.85606C6.17764 9.99022 6.1187 10.1325 6.07661 10.2802C6 10.5489 6 10.8374 6 11.4142V16C6 17.8856 6 18.8284 6.58579 19.4142C7.17157 20 8.11438 20 10 20H14C15.8856 20 16.8284 20 17.4142 19.4142C18 18.8284 18 17.8856 18 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H10C10.9428 11 11.4142 11 11.7071 11.2929C12 11.5858 12 12.0572 12 13V15C12 15.9428 12 16.4142 11.7071 16.7071C11.4142 17 10.9428 17 10 17H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","container","product","inventory","storage","item","sale","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.35145 3.52501C6.53866 3.49984 6.76046 3.49993 6.96557 3.50001H17.0345C17.2396 3.49993 17.4614 3.49984 17.6486 3.52501C17.8679 3.5545 18.1481 3.63034 18.3839 3.86614C18.6197 4.10194 18.6955 4.38212 18.725 4.60145C18.7502 4.78866 18.7501 5.01047 18.75 5.21558V5.78449C18.7501 5.9896 18.7502 6.21138 18.725 6.39859C18.6955 6.61791 18.6197 6.8981 18.3839 7.1339C18.1481 7.3697 17.8679 7.44554 17.6486 7.47502C17.4614 7.5002 17.2396 7.50011 17.0345 7.50003H6.96557C6.76046 7.50011 6.53866 7.5002 6.35145 7.47502C6.13212 7.44554 5.85193 7.3697 5.61614 7.1339C5.38033 6.8981 5.3045 6.61791 5.27501 6.39859C5.24984 6.21137 5.24993 5.98958 5.25001 5.78446L5.25001 5.21557C5.24993 5.01046 5.24984 4.78866 5.27501 4.60145C5.3045 4.38212 5.38033 4.10193 5.61613 3.86613C5.85193 3.63033 6.13212 3.5545 6.35145 3.52501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.33342 8.25C7.08265 8.25 6.84848 8.37533 6.70938 8.58397L5.99887 9.64966C5.71281 10.0781 5.48678 10.4166 5.36808 10.8086C5.24938 11.2007 5.24967 11.6077 5.25004 12.1229L5.25008 16.052C5.25005 16.9505 5.25003 17.6997 5.32999 18.2945C5.4144 18.9223 5.60007 19.4891 6.05554 19.9445C6.51101 20.4 7.07781 20.5857 7.7056 20.6701C8.30038 20.7501 9.04962 20.75 9.94809 20.75H14.0521C14.9506 20.75 15.6998 20.7501 16.2946 20.6701C16.9224 20.5857 17.4892 20.4 17.9446 19.9445C18.4001 19.4891 18.5858 18.9223 18.6702 18.2945C18.7501 17.6997 18.7501 16.9505 18.7501 16.052L18.7501 12.1229C18.7505 11.6077 18.7508 11.2007 18.6321 10.8086C18.5134 10.4166 18.2873 10.0781 18.0013 9.64966L17.2908 8.58397C17.1517 8.37533 16.9175 8.25 16.6667 8.25H7.33342ZM8.96092 12.25H10.0391C10.2392 12.2499 10.4771 12.2497 10.681 12.2862C10.9469 12.3339 11.236 12.4552 11.4536 12.7453C11.6481 13.0047 11.7045 13.294 11.7279 13.5266C11.7501 13.7463 11.75 14.0147 11.75 14.3008V15.6993C11.75 15.9854 11.7501 16.2538 11.7279 16.4735C11.7045 16.7061 11.6481 16.9954 11.4536 17.2548C11.236 17.5449 10.9469 17.6662 10.681 17.7139C10.4771 17.7504 10.2393 17.7502 10.0391 17.7501H8.96092C8.76077 17.7502 8.52295 17.7504 8.31903 17.7139C8.05309 17.6662 7.76402 17.5449 7.54645 17.2548C7.35194 16.9954 7.29555 16.7061 7.27209 16.4735C7.24994 16.2538 7.24997 15.9854 7.25 15.6993V14.3008C7.24997 14.0147 7.24994 13.7463 7.27209 13.5266C7.29555 13.294 7.35194 13.0047 7.54645 12.7453C7.76402 12.4552 8.05309 12.3339 8.31903 12.2862C8.52295 12.2497 8.76077 12.2499 8.96092 12.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "medicine-pills-jar-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["medicine","pills","jar","prescription","drugs","medication","pharmacy","inventory","health","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["jar","medicine","pills","pharmacy","prescription","drugs","health","medical","inventory","stock","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicine-pills-jar": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","container","product","pharmacy","medicine","health","inventory","storage","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4H16C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6C18 6.94281 18 7.41421 17.7071 7.70711C17.4142 8 16.9428 8 16 8H8C7.05719 8 6.58579 8 6.29289 7.70711C6 7.41421 6 6.94281 6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 12H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M18 16H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M15 8L15 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 8L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 8L9 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 8L16.8284 8.82843C17.4065 9.40649 17.6955 9.69552 17.8478 10.0631C18 10.4306 18 10.8394 18 11.6569V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V11.6569C6 10.8394 6 10.4306 6.15224 10.0631C6.30448 9.69552 6.59351 9.40649 7.17157 8.82843L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "medicne-search-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","link","related","lookup","connection","verify","item-search","product-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7574 10.7574L9.51472 12C8.82843 12.6863 8.82843 13.799 9.51472 14.4853C10.201 15.1716 11.3137 15.1716 12 14.4853L13.2426 13.2426M10.7574 10.7574L13.2426 13.2426M10.7574 10.7574L12 9.51472C12.6863 8.82843 13.799 8.82843 14.4853 9.51472C15.1716 10.201 15.1716 11.3137 14.4853 12L13.2426 13.2426"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "medicne-search-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["search","link","find-link","connect","relation","linked","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.7574 10.7574L9.51472 12C8.82843 12.6863 8.82843 13.799 9.51472 14.4853C10.201 15.1716 11.3137 15.1716 12 14.4853L13.2426 13.2426M10.7574 10.7574L13.2426 13.2426M10.7574 10.7574L12 9.51472C12.6863 8.82843 13.799 8.82843 14.4853 9.51472C15.1716 10.201 15.1716 11.3137 14.4853 12L13.2426 13.2426"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "medicne-search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["link","search","find","connect","relation","lookup","item-lookup","product-search","link-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.7071 10.2218C13.0029 9.92606 13.4824 9.92606 13.7782 10.2218C14.0739 10.5176 14.0739 10.9971 13.7782 11.2929L13.2426 11.8284L12.1716 10.7574L12.7071 10.2218Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.2218 12.7071L10.7574 12.1716L11.8284 13.2426L11.2929 13.7782C10.9971 14.0739 10.5176 14.0739 10.2218 13.7782C9.92606 13.4824 9.92606 13.0029 10.2218 12.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM15.1924 8.80761C14.1156 7.7308 12.3697 7.7308 11.2929 8.80761L8.80761 11.2929C7.7308 12.3697 7.7308 14.1156 8.80761 15.1924C9.88443 16.2692 11.6303 16.2692 12.7071 15.1924L15.1924 12.7071C16.2692 11.6303 16.2692 9.88443 15.1924 8.80761Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "medicne-search": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","link","chain","lookup","connection","reference","relationship"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.7574 10.7574L9.51472 12C8.82843 12.6863 8.82843 13.799 9.51472 14.4853C10.201 15.1716 11.3137 15.1716 12 14.4853L13.2426 13.2426M10.7574 10.7574L13.2426 13.2426M10.7574 10.7574L12 9.51472C12.6863 8.82843 13.799 8.82843 14.4853 9.51472C15.1716 10.201 15.1716 11.3137 14.4853 12L13.2426 13.2426"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","announcement","promotion","discount","sale","notification","alert","special offer","marketing","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15L8 17C8 18.1046 8.89543 19 10 19V19C11.1046 19 12 18.1046 12 17L12 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 14V14C18.1046 14 19 13.1046 19 12V12C19 10.8954 18.1046 10 17 10V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 6L6.82861 9.12966C5.74169 9.46409 5 10.4683 5 11.6055V11.6055C5 12.6774 5.66011 13.6385 6.66051 14.0233L17 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 5C17 6.08387 17 14.7849 17 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","special-offer","discount","alert","notification","loudspeaker","broadcast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14.376L8 16.5C8 17.8807 9.11929 19 10.5 19C11.8807 19 13 17.8807 13 16.5L13 16C13 15.4185 12.5896 14.9179 12.0194 14.8039L8.36872 14.0737C8.25049 14.0501 8.19138 14.0383 8.1445 14.0518C8.09183 14.067 8.04772 14.1032 8.02247 14.1519C8 14.1952 8 14.2555 8 14.376Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M18 6L6 9.69231V13.3846L18 18V6Z" fill={colors?.[1] || "#D9D1E0"} />
                <path
                    d="M18.75 5C18.75 4.58579 18.4142 4.25 18 4.25C17.5858 4.25 17.25 4.58579 17.25 5H18.75ZM17.25 19C17.25 19.4142 17.5858 19.75 18 19.75C18.4142 19.75 18.75 19.4142 18.75 19L17.25 19ZM6.75 8C6.75 7.58579 6.41421 7.25 6 7.25C5.58579 7.25 5.25 7.58579 5.25 8H6.75ZM5.25 15C5.25 15.4142 5.58579 15.75 6 15.75C6.41421 15.75 6.75 15.4142 6.75 15H5.25ZM6.22056 10.4091L18.2206 6.71683L17.7794 5.28317L5.77944 8.97547L6.22056 10.4091ZM18.2692 17.3L6.26923 12.6846L5.73077 14.0846L17.7308 18.7L18.2692 17.3ZM17.25 5V6H18.75V5H17.25ZM17.25 6V18H18.75V6H17.25ZM17.25 18L17.25 19L18.75 19L18.75 18L17.25 18ZM5.25 8V9.69231H6.75V8H5.25ZM5.25 9.69231V13.3846H6.75V9.69231H5.25ZM5.25 13.3846V15H6.75V13.3846H5.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6 8C6 8.54194 6 12.8925 6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","discount","special offer","notification","alert","news","broadcast","marketing","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 5C19 4.44772 18.5523 4 18 4C17.4477 4 17 4.44772 17 5V5.26143L7 8.33835V8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8V15C5 15.5523 5.44772 16 6 16C6.55212 16 6.99973 15.5526 7 15.0005V16.5C7 18.433 8.567 20 10.5 20C12.093 20 13.4374 18.9358 13.8611 17.4795L13.8611 17.4795L17 18.6868V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19L19 5ZM11.9783 16.7554L9 15.6099V16.5C9 17.3284 9.67157 18 10.5 18C11.2414 18 11.8571 17.4622 11.9783 16.7554Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","discount","sale","notification","alert","broadcast","megaphone","special offer","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 13.3846L16 18M4 9.69231L16 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 8C4 8.54194 4 12.8925 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 14L6 16.5C6 17.8807 7.11929 19 8.5 19V19C9.88071 19 11 17.8807 11 16.5L11 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","alert","discount","sale","special-offer","marketing","notification","broadcast","promotion","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14L6 16.5C6 17.8807 7.11929 19 8.5 19V19C9.88071 19 11 17.8807 11 16.5L11 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M4 13.3846L16 18M4 9.69231L16 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 8C4 8.54194 4 12.8925 4 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","discount","sale","alert","special-offer","broadcast","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 14.376L6 16.5C6 17.8807 7.11929 19 8.5 19C9.88071 19 11 17.8807 11 16.5L11 16C11 15.4185 10.5896 14.9179 10.0194 14.8039L6.36872 14.0737C6.25049 14.0501 6.19138 14.0383 6.1445 14.0518C6.09183 14.067 6.04772 14.1032 6.02247 14.1519C6 14.1952 6 14.2555 6 14.376Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 6L4 9.69231V13.3846L16 18V6Z" fill={colors?.[1] || "#D9D1E0"} />
                <path
                    d="M16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19L15.25 19ZM4.75 8C4.75 7.58579 4.41421 7.25 4 7.25C3.58579 7.25 3.25 7.58579 3.25 8H4.75ZM3.25 15C3.25 15.4142 3.58579 15.75 4 15.75C4.41421 15.75 4.75 15.4142 4.75 15H3.25ZM4.22056 10.4091L16.2206 6.71683L15.7794 5.28317L3.77944 8.97547L4.22056 10.4091ZM16.2692 17.3L4.26923 12.6846L3.73077 14.0846L15.7308 18.7L16.2692 17.3ZM15.25 5V6H16.75V5H15.25ZM15.25 6V18H16.75V6H15.25ZM15.25 18L15.25 19L16.75 19L16.75 18L15.25 18ZM3.25 8V9.69231H4.75V8H3.25ZM3.25 9.69231V13.3846H4.75V9.69231H3.25ZM3.25 13.3846V15H4.75V13.3846H3.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M4 8C4 8.54194 4 12.8925 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","discount","special-offer","alert","notification","marketing","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V5.26143L4 8.33835V8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8V15C2 15.5523 2.44772 16 3 16C3.55228 16 4 15.5523 4 15L4.00002 14.8407L5 15.2253V16.5C5 18.433 6.567 20 8.5 20C9.96647 20 11.2223 19.0981 11.7431 17.8187L14 18.6868V19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19L16 5ZM9.87506 17.1003L7 15.9945V16.5C7 17.3284 7.67157 18 8.5 18C9.11499 18 9.64353 17.6299 9.87506 17.1003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.7076 8.70711C20.0981 8.31658 20.0981 7.68342 19.7076 7.29289C19.3171 6.90237 18.6839 6.90237 18.2934 7.29289L17.2934 8.29289C16.9029 8.68342 16.9029 9.31658 17.2934 9.70711C17.6839 10.0976 18.3171 10.0976 18.7076 9.70711L19.7076 8.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.2929 16.7071L17.2929 15.7071C16.9024 15.3166 16.9024 14.6834 17.2929 14.2929C17.6834 13.9024 18.3166 13.9024 18.7071 14.2929L19.7071 15.2929C20.0976 15.6834 20.0976 16.3166 19.7071 16.7071C19.3166 17.0976 18.6834 17.0976 18.2929 16.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","alert","notification","sale","discount","special-offer","marketing","broadcast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15L8 17C8 18.1046 8.89543 19 10 19V19C11.1046 19 12 18.1046 12 17L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 6L8.33958 8.87266C8.17025 8.93616 8.08558 8.96791 7.99709 8.98395C7.9086 9 7.81818 9 7.63733 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H7.63733C7.81818 15 7.9086 15 7.99709 15.016C8.08558 15.0321 8.17025 15.0638 8.33958 15.1273L16 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 9.46452 8 13.1935 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","discount","alert","notification","special-offer","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15L8 17C8 18.1046 8.89543 19 10 19V19C11.1046 19 12 18.1046 12 17L12 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L8.33958 8.87266C8.17025 8.93616 8.08558 8.96791 7.99709 8.98395C7.9086 9 7.81818 9 7.63733 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H7.63733C7.81818 15 7.9086 15 7.99709 15.016C8.08558 15.0321 8.17025 15.0638 8.33958 15.1273L16 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 9.46452 8 13.1935 8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","discount","sale","special-offer","alert","notification","customer-alert","advertise","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15.4541L8 17C8 18.1046 8.89543 19 10 19C11.1046 19 12 18.1046 12 17L12 16.2173C12 16.0896 11.9131 15.9783 11.7892 15.9473L8.44058 15.1101C8.37931 15.0948 8.34867 15.0872 8.32391 15.0852C8.16864 15.0728 8.0297 15.1813 8.00408 15.3349C8 15.3594 8 15.391 8 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H7.63733C7.81818 15 7.9086 15 7.99709 15.016C8.08558 15.0321 8.17026 15.0638 8.33958 15.1273L16 18V6L8.33958 8.87266C8.17025 8.93616 8.08558 8.96791 7.99709 8.98395C7.9086 9 7.81818 9 7.63733 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M8.33958 8.87266L8.07624 8.17041L8.07623 8.17041L8.33958 8.87266ZM8.33958 15.1273L8.60292 14.4251H8.60292L8.33958 15.1273ZM7.99709 15.016L7.86327 15.754L7.86327 15.754L7.99709 15.016ZM7.99709 8.98395L7.86327 8.24599L7.86327 8.24599L7.99709 8.98395ZM16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19L15.25 19ZM4.75 13V11H3.25V13H4.75ZM6 9.75H7.63733V8.25H6V9.75ZM7.63733 14.25H6V15.75H7.63733V14.25ZM8.60292 9.5749L16.2633 6.70225L15.7367 5.29775L8.07624 8.17041L8.60292 9.5749ZM16.2633 17.2978L8.60292 14.4251L8.07624 15.8296L15.7367 18.7022L16.2633 17.2978ZM7.63733 15.75C7.73278 15.75 7.78524 15.7501 7.82513 15.7515C7.84281 15.7522 7.85274 15.7529 7.85803 15.7534C7.86056 15.7536 7.86199 15.7538 7.8626 15.7539C7.86292 15.754 7.8631 15.754 7.86317 15.754C7.86324 15.754 7.86327 15.754 7.86327 15.754L8.13091 14.2781C7.96093 14.2473 7.79249 14.25 7.63733 14.25V15.75ZM8.60292 14.4251C8.45766 14.3706 8.30089 14.3089 8.13091 14.2781L7.86327 15.754C7.86328 15.754 7.8633 15.754 7.86337 15.754C7.86344 15.754 7.86362 15.7541 7.86394 15.7542C7.86453 15.7543 7.86594 15.7546 7.86839 15.7553C7.87352 15.7567 7.88308 15.7595 7.89986 15.7651C7.93771 15.7778 7.98687 15.7961 8.07624 15.8296L8.60292 14.4251ZM7.63733 9.75C7.79249 9.75 7.96093 9.75274 8.13091 9.72192L7.86327 8.24599C7.86327 8.24599 7.86324 8.24599 7.86317 8.24601C7.8631 8.24602 7.86292 8.24604 7.8626 8.24609C7.86199 8.24617 7.86056 8.24635 7.85803 8.24659C7.85274 8.2471 7.84281 8.24784 7.82513 8.24847C7.78524 8.24989 7.73278 8.25 7.63733 8.25V9.75ZM8.07623 8.17041C7.98687 8.20392 7.9377 8.22225 7.89986 8.23492C7.88308 8.24054 7.87352 8.24333 7.86839 8.24471C7.86594 8.24538 7.86453 8.24571 7.86394 8.24584C7.86363 8.24592 7.86344 8.24595 7.86337 8.24597C7.8633 8.24598 7.86328 8.24599 7.86327 8.24599L8.13091 9.72192C8.30089 9.6911 8.45765 9.62938 8.60292 9.5749L8.07623 8.17041ZM4.75 11C4.75 10.5074 4.75159 10.2134 4.77992 10.0027C4.79291 9.90611 4.8082 9.85774 4.81716 9.83596C4.81923 9.83092 4.82085 9.8276 4.82186 9.82567C4.82286 9.82376 4.82341 9.82292 4.82347 9.82283C4.82351 9.82277 4.82335 9.823 4.82307 9.82335C4.82279 9.8237 4.82277 9.82368 4.82322 9.82322L3.76256 8.76256C3.45354 9.07159 3.34109 9.44731 3.2933 9.80279C3.24841 10.1367 3.25 10.5498 3.25 11H4.75ZM6 8.25C5.5498 8.25 5.1367 8.24841 4.80279 8.2933C4.44731 8.34109 4.07159 8.45354 3.76256 8.76256L4.82322 9.82322C4.82368 9.82277 4.8237 9.82279 4.82335 9.82307C4.823 9.82335 4.82277 9.82351 4.82283 9.82347C4.82292 9.82341 4.82376 9.82286 4.82567 9.82186C4.8276 9.82085 4.83092 9.81923 4.83596 9.81716C4.85774 9.8082 4.90611 9.79291 5.00266 9.77992C5.21339 9.75159 5.50739 9.75 6 9.75V8.25ZM3.25 13C3.25 13.4502 3.24841 13.8633 3.2933 14.1972C3.34109 14.5527 3.45354 14.9284 3.76256 15.2374L4.82322 14.1768C4.82277 14.1763 4.82279 14.1763 4.82307 14.1766C4.82335 14.177 4.82351 14.1772 4.82347 14.1772C4.82341 14.1771 4.82286 14.1762 4.82186 14.1743C4.82085 14.1724 4.81923 14.1691 4.81716 14.164C4.8082 14.1423 4.79291 14.0939 4.77992 13.9973C4.75159 13.7866 4.75 13.4926 4.75 13H3.25ZM6 14.25C5.50739 14.25 5.21339 14.2484 5.00266 14.2201C4.90611 14.2071 4.85774 14.1918 4.83596 14.1828C4.83092 14.1808 4.8276 14.1791 4.82567 14.1781C4.82376 14.1771 4.82292 14.1766 4.82283 14.1765C4.82277 14.1765 4.823 14.1766 4.82335 14.1769C4.8237 14.1772 4.82368 14.1772 4.82322 14.1768L3.76256 15.2374C4.07159 15.5465 4.44731 15.6589 4.80279 15.7067C5.1367 15.7516 5.5498 15.75 6 15.75V14.25ZM15.25 5V6H16.75V5H15.25ZM15.25 6V18H16.75V6H15.25ZM15.25 18L15.25 19L16.75 19L16.75 18L15.25 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M4 11V13C4 13.9428 4 14.4142 4.29289 14.7071C4.58579 15 5.05719 15 6 15H7.63733C7.82647 15 8 14.826 8 14.6368L8 9.36324C8 9.1741 7.82647 9 7.63733 9H6C5.05719 9 4.58579 9 4.29289 9.29289C4 9.58579 4 10.0572 4 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.29289 9.29289L4.82322 9.82322L4.82322 9.82322L4.29289 9.29289ZM8 9.36324H7.25V9.36324L8 9.36324ZM8 14.6368H8.75H8ZM4.75 13V11H3.25V13H4.75ZM6 9.75H7.63733V8.25H6V9.75ZM7.63733 14.25H6V15.75H7.63733V14.25ZM4.75 11C4.75 10.5074 4.75159 10.2134 4.77992 10.0027C4.79291 9.90611 4.8082 9.85774 4.81716 9.83596C4.81923 9.83092 4.82085 9.8276 4.82186 9.82567C4.82286 9.82376 4.82341 9.82292 4.82347 9.82283C4.82351 9.82277 4.82335 9.823 4.82307 9.82335C4.82279 9.8237 4.82277 9.82368 4.82322 9.82322L3.76256 8.76256C3.45354 9.07159 3.34109 9.44731 3.2933 9.80279C3.24841 10.1367 3.25 10.5498 3.25 11H4.75ZM6 8.25C5.5498 8.25 5.1367 8.24841 4.80279 8.2933C4.44731 8.34109 4.07159 8.45354 3.76256 8.76256L4.82322 9.82322C4.82368 9.82277 4.8237 9.82279 4.82335 9.82307C4.823 9.82335 4.82277 9.82351 4.82283 9.82347C4.82292 9.82341 4.82376 9.82286 4.82567 9.82186C4.8276 9.82085 4.83092 9.81923 4.83596 9.81716C4.85774 9.8082 4.90611 9.79291 5.00266 9.77992C5.21339 9.75159 5.50739 9.75 6 9.75V8.25ZM3.25 13C3.25 13.4502 3.24841 13.8633 3.2933 14.1972C3.34109 14.5527 3.45354 14.9284 3.76256 15.2374L4.82322 14.1768C4.82277 14.1763 4.82279 14.1763 4.82307 14.1766C4.82335 14.177 4.82351 14.1772 4.82347 14.1772C4.82341 14.1771 4.82286 14.1762 4.82186 14.1743C4.82085 14.1724 4.81923 14.1691 4.81716 14.164C4.8082 14.1423 4.79291 14.0939 4.77992 13.9973C4.75159 13.7866 4.75 13.4926 4.75 13H3.25ZM6 14.25C5.50739 14.25 5.21339 14.2484 5.00266 14.2201C4.90611 14.2071 4.85774 14.1918 4.83596 14.1828C4.83092 14.1808 4.8276 14.1791 4.82567 14.1781C4.82376 14.1771 4.82292 14.1766 4.82283 14.1765C4.82277 14.1765 4.823 14.1766 4.82335 14.1769C4.8237 14.1772 4.82368 14.1772 4.82322 14.1768L3.76256 15.2374C4.07159 15.5465 4.44731 15.6589 4.80279 15.7067C5.1367 15.7516 5.5498 15.75 6 15.75V14.25ZM7.25 9.36324L7.25 14.6368H8.75L8.75 9.36324L7.25 9.36324ZM7.63733 9.75C7.50204 9.75 7.40911 9.69098 7.3587 9.64046C7.3083 9.58996 7.25 9.49752 7.25 9.36324H8.75C8.75 9.03982 8.60493 8.76576 8.42049 8.58093C8.23602 8.39607 7.96176 8.25 7.63733 8.25V9.75ZM7.63733 15.75C7.96169 15.75 8.23593 15.604 8.42043 15.4192C8.60491 15.2343 8.75 14.9603 8.75 14.6368H7.25C7.25 14.5025 7.30832 14.41 7.35875 14.3595C7.4092 14.309 7.50212 14.25 7.63733 14.25V15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","special offer","discount","sale","megaphone","broadcast","notify","notification","alert","marketing","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C16.5523 4 17 4.44772 17 5L17 19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V18.693L12.8438 17.958C12.444 19.1451 11.3218 20 10 20C8.34315 20 7 18.6569 7 17V16L5.94554 16C5.52152 16.0001 5.10938 16.0002 4.76949 15.9545C4.38629 15.903 3.94902 15.7774 3.5858 15.4142C3.22259 15.051 3.09706 14.6137 3.04554 14.2305C2.99984 13.8906 2.99992 13.4785 3.00001 13.0544V10.9456C2.99992 10.5215 2.99984 10.1094 3.04554 9.76948C3.09706 9.38628 3.22259 8.949 3.5858 8.58579C3.94902 8.22257 4.38629 8.09705 4.76949 8.04553C5.10941 7.99983 5.52153 7.99991 5.9456 7.99999L7.63734 8C7.73447 8 7.78182 7.99986 7.81624 7.99863L7.81842 7.99855L7.82049 7.99786C7.85315 7.98692 7.89753 7.97043 7.98847 7.93633L15 5.307V5C15 4.44772 15.4477 4 16 4ZM9 16.6667V17C9 17.5523 9.44772 18 10 18C10.4417 18 10.8166 17.7136 10.9489 17.3163L9 16.6667Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.7076 8.70711L19.7076 9.70711C19.3171 10.0976 18.6839 10.0976 18.2934 9.70711C17.9029 9.31658 17.9029 8.68342 18.2934 8.29289L19.2934 7.29289C19.6839 6.90237 20.3171 6.90237 20.7076 7.29289C21.0981 7.68342 21.0981 8.31658 20.7076 8.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.2929 16.7071L18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929C18.6834 13.9024 19.3166 13.9024 19.7071 14.2929L20.7071 15.2929C21.0976 15.6834 21.0976 16.3166 20.7071 16.7071C20.3166 17.0976 19.6834 17.0976 19.2929 16.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 12C18 11.4477 18.4477 11 19 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H19C18.4477 13 18 12.5523 18 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","sale","special-offer","notification","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="17"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 15.4541L8 17C8 18.1046 8.89543 19 10 19C11.1046 19 12 18.1046 12 17L12 16.2173C12 16.0896 11.9131 15.9783 11.7892 15.9473L8.44058 15.1101C8.37931 15.0948 8.34867 15.0872 8.32391 15.0852C8.16864 15.0728 8.0297 15.1813 8.00408 15.3349C8 15.3594 8 15.391 8 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 6L6.82861 9.12966C5.74169 9.46409 5 10.4683 5 11.6055C5 12.6774 5.66011 13.6385 6.66051 14.0233L17 18V6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.82861 9.12966L7.04917 9.84649L6.82861 9.12966ZM6.66051 14.0233L6.92974 13.3233H6.92974L6.66051 14.0233ZM17.75 5C17.75 4.58579 17.4142 4.25 17 4.25C16.5858 4.25 16.25 4.58579 16.25 5H17.75ZM16.25 19C16.25 19.4142 16.5858 19.75 17 19.75C17.4142 19.75 17.75 19.4142 17.75 19L16.25 19ZM7.04917 9.84649L17.2206 6.71683L16.7794 5.28317L6.60805 8.41282L7.04917 9.84649ZM17.2692 17.3L6.92974 13.3233L6.39128 14.7233L16.7308 18.7L17.2692 17.3ZM5.75 11.6055C5.75 10.7976 6.27695 10.0841 7.04917 9.84649L6.60805 8.41282C5.20644 8.84409 4.25 10.1391 4.25 11.6055H5.75ZM4.25 11.6055C4.25 12.9877 5.10124 14.2271 6.39128 14.7233L6.92974 13.3233C6.21899 13.0499 5.75 12.367 5.75 11.6055H4.25ZM16.25 5V6H17.75V5H16.25ZM16.25 6V18H17.75V6H16.25ZM16.25 18L16.25 19L17.75 19L17.75 18L16.25 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","megaphone","loudspeaker","promotion","discount","special-offer","marketing","notification","alert","sale","broadcast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70135 8.89012L16.2372 5.71151L15.7628 4.28849L6.227 7.4671L6.70135 8.89012ZM16.2885 18.3077L6.50618 14.2317L5.92926 15.6164L15.7115 19.6923L16.2885 18.3077ZM4.75 11.5975C4.75 10.3691 5.53602 9.27856 6.70135 8.89012L6.227 7.4671C4.44917 8.05971 3.25 9.72346 3.25 11.5975H4.75ZM3.25 11.5975C3.25 13.3551 4.30683 14.9403 5.92926 15.6164L6.50618 14.2317C5.44272 13.7886 4.75 12.7495 4.75 11.5975H3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 15V17C6 18.1046 6.89543 19 8 19V19C9.10457 19 10 18.1046 10 17V16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 9.5C13.5858 9.5 13.25 9.83579 13.25 10.25C13.25 10.6642 13.5858 11 14 11V9.5ZM15.7678 13.9843L16.2616 14.5487H16.2616L15.7678 13.9843ZM14 13.875C13.5858 13.875 13.25 14.2108 13.25 14.625C13.25 15.0392 13.5858 15.375 14 15.375V13.875ZM15.164 18.7246L14.7441 19.3461L15.164 18.7246ZM15.0329 5.37166L15.4993 5.95899V5.95899L15.0329 5.37166ZM14 11C15.0637 11 15.75 11.7345 15.75 12.4375H17.25C17.25 10.7242 15.6977 9.5 14 9.5V11ZM15.75 12.4375C15.75 12.7993 15.5841 13.1484 15.2739 13.4199L16.2616 14.5487C16.8562 14.0285 17.25 13.2838 17.25 12.4375H15.75ZM15.2739 13.4199C14.9622 13.6926 14.514 13.875 14 13.875V15.375C14.8667 15.375 15.6686 15.0677 16.2616 14.5487L15.2739 13.4199ZM18.25 12C18.25 13.8564 17.9261 15.5014 17.432 16.6543C17.1843 17.2321 16.9087 17.6518 16.6409 17.9161C16.3763 18.1772 16.1606 18.25 16 18.25V19.75C16.6678 19.75 17.2413 19.431 17.6946 18.9837C18.1446 18.5396 18.5154 17.9341 18.8107 17.2452C19.4024 15.8646 19.75 14.0096 19.75 12H18.25ZM16 5.75C16.1606 5.75 16.3763 5.82276 16.6409 6.08391C16.9087 6.34823 17.1843 6.7679 17.432 7.34569C17.9261 8.49861 18.25 10.1436 18.25 12H19.75C19.75 9.99037 19.4024 8.13539 18.8107 6.75481C18.5154 6.06586 18.1446 5.4604 17.6946 5.01628C17.2413 4.56899 16.6678 4.25 16 4.25V5.75ZM16 18.25C15.8837 18.25 15.747 18.2133 15.5839 18.1032L14.7441 19.3461C15.1118 19.5945 15.536 19.75 16 19.75V18.25ZM15.5839 18.1032C15.1656 17.8205 14.6926 17.1296 14.3261 16.0084C13.9695 14.9175 13.75 13.5276 13.75 12H12.25C12.25 13.6614 12.4875 15.2115 12.9004 16.4745C13.3033 17.7072 13.9124 18.7841 14.7441 19.3461L15.5839 18.1032ZM13.75 12C13.75 10.5268 13.9542 9.18088 14.289 8.10764C14.6314 7.01036 15.0807 6.29141 15.4993 5.95899L14.5665 4.78432C13.8028 5.39082 13.2356 6.4478 12.8571 7.66084C12.4711 8.89793 12.25 10.3968 12.25 12H13.75ZM15.4993 5.95899C15.7008 5.79904 15.8664 5.75 16 5.75V4.25C15.4569 4.25 14.972 4.46237 14.5665 4.78432L15.4993 5.95899Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","discount","sale","alert","special offer","marketing","notice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V17C6 18.1046 6.89543 19 8 19V19C9.10457 19 10 18.1046 10 17V16.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.70135 8.89012L16.2372 5.71151L15.7628 4.28849L6.227 7.4671L6.70135 8.89012ZM16.2885 18.3077L6.50618 14.2317L5.92926 15.6164L15.7115 19.6923L16.2885 18.3077ZM4.75 11.5975C4.75 10.3691 5.53602 9.27856 6.70135 8.89012L6.227 7.4671C4.44917 8.05971 3.25 9.72346 3.25 11.5975H4.75ZM3.25 11.5975C3.25 13.3551 4.30683 14.9403 5.92926 15.6164L6.50618 14.2317C5.44272 13.7886 4.75 12.7495 4.75 11.5975H3.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 10.25C15.3807 10.25 16.5 11.2294 16.5 12.4375C16.5 13.0416 16.2202 13.5884 15.7678 13.9843C15.3154 14.3802 14.6904 14.625 14 14.625"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19C17.6569 19 19 15.866 19 12C19 8.13401 17.6569 5 16 5C15.6616 5 15.3364 5.1307 15.0329 5.37166C13.8506 6.31057 13 8.92352 13 12C13 15.189 13.9139 17.88 15.164 18.7246C15.4294 18.9039 15.7099 19 16 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","sale","discount","special-offer","alert","notification","marketing","broadcast","shout","loudspeaker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15.4541L6 17C6 18.1046 6.89543 19 8 19C9.10457 19 10 18.1046 10 17L10 16.2173C10 16.0896 9.9131 15.9783 9.78922 15.9473L6.44058 15.1101C6.37931 15.0948 6.34867 15.0872 6.32391 15.0852C6.16864 15.0728 6.0297 15.1813 6.00408 15.3349C6 15.3594 6 15.391 6 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 5L6.46418 8.17861C4.99259 8.66914 4 10.0463 4 11.5975C4 13.0523 4.87478 14.3645 6.21772 14.9241L16 19C17.6569 19 19 15.866 19 12C19 8.13401 17.6569 5 16 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.46418 8.17861L6.70135 8.89012H6.70135L6.46418 8.17861ZM16 5V4.25H15.8783L15.7628 4.28849L16 5ZM16 19L15.7115 19.6923L15.85 19.75H16V19ZM6.21772 14.9241L6.50618 14.2317H6.50618L6.21772 14.9241ZM6.70135 8.89012L16.2372 5.71151L15.7628 4.28849L6.227 7.4671L6.70135 8.89012ZM16.2885 18.3077L6.50618 14.2317L5.92926 15.6164L15.7115 19.6923L16.2885 18.3077ZM4.75 11.5975C4.75 10.3691 5.53602 9.27856 6.70135 8.89012L6.22701 7.4671C4.44917 8.05971 3.25 9.72346 3.25 11.5975H4.75ZM3.25 11.5975C3.25 13.3551 4.30683 14.9403 5.92926 15.6164L6.50618 14.2317C5.44272 13.7886 4.75 12.7495 4.75 11.5975H3.25ZM18.25 12C18.25 13.8564 17.9261 15.5014 17.432 16.6543C17.1843 17.2321 16.9087 17.6518 16.6409 17.9161C16.3763 18.1772 16.1606 18.25 16 18.25V19.75C16.6678 19.75 17.2413 19.431 17.6946 18.9837C18.1446 18.5396 18.5154 17.9341 18.8107 17.2452C19.4024 15.8646 19.75 14.0096 19.75 12H18.25ZM16 5.75C16.1606 5.75 16.3763 5.82276 16.6409 6.08391C16.9087 6.34823 17.1843 6.7679 17.432 7.34569C17.9261 8.49861 18.25 10.1436 18.25 12H19.75C19.75 9.99037 19.4024 8.13539 18.8107 6.75481C18.5154 6.06586 18.1446 5.4604 17.6946 5.01628C17.2413 4.56899 16.6678 4.25 16 4.25V5.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M16 19C17.6569 19 19 15.866 19 12C19 8.13401 17.6569 5 16 5C15.6616 5 15.3364 5.1307 15.0329 5.37166C13.8506 6.31057 13 8.92352 13 12C13 15.189 13.9139 17.88 15.164 18.7246C15.4294 18.9039 15.7099 19 16 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5 12.4374C16.5 11.2292 15.7678 9.99986 13.0976 10.2226C13.0976 10.2226 12.5 10.4999 13.0976 14.5866C13.788 14.5866 15.3154 14.38 15.7678 13.9842C16.2202 13.5883 16.5 13.0414 16.5 12.4374Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","sale","discount","special-offer","megaphone","loudspeaker","alert","notification","broadcast","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.72 4.37252C15.0946 4.14451 15.5252 4 16 4C16.7524 4 17.3855 4.36003 17.8702 4.83835C18.3505 5.31243 18.7373 5.94885 19.0405 6.65633C19.6484 8.07486 20 9.96482 20 12C20 14.0352 19.6484 15.9251 19.0405 17.3437C18.7373 18.0512 18.3505 18.6876 17.8702 19.1617C17.3855 19.64 16.7524 20 16 20C15.4781 20 15.0059 19.8247 14.6042 19.5532C14.5476 19.515 14.492 19.4746 14.4375 19.4322L10.8505 17.9377C10.4568 19.1353 9.32939 20 8 20C6.34315 20 5 18.6569 5 17V15.3944C3.76467 14.5475 3 13.1348 3 11.5974C3 9.61581 4.26802 7.85652 6.14795 7.22988L14.72 4.37252ZM7 16.3333V17C7 17.5523 7.44772 18 8 18C8.4974 18 8.90997 17.6369 8.98707 17.1612L7 16.3333ZM15.6548 6.15477C15.8222 6.02182 15.9346 6 16 6C16.076 6 16.2321 6.03173 16.4653 6.26184C16.7028 6.4962 16.9625 6.8849 17.2022 7.44417C17.68 8.55915 18 10.1692 18 12C18 13.8308 17.68 15.4409 17.2022 16.5558C16.9625 17.1151 16.7028 17.5038 16.4653 17.7382C16.2321 17.9683 16.076 18 16 18C15.9417 18 15.8528 17.9832 15.7239 17.896C15.3745 17.66 14.9242 17.0333 14.5637 15.9307C14.5284 15.8227 14.4945 15.7116 14.4619 15.5975C15.2095 15.5077 15.8942 15.2024 16.4263 14.7369C17.0682 14.1752 17.5 13.3645 17.5 12.4375C17.5 10.6454 15.9611 9.37565 14.2567 9.2588C14.3327 8.87521 14.4239 8.51477 14.5277 8.1821C14.864 7.10413 15.2937 6.44151 15.6548 6.15477ZM15.1093 13.2317C14.8614 13.4486 14.5045 13.604 14.0866 13.623C14.0304 13.1075 14 12.5637 14 12C14 11.7457 14.0062 11.4955 14.0181 11.2501C14.9649 11.2583 15.5 11.9063 15.5 12.4375C15.5 12.7186 15.3721 13.0017 15.1093 13.2317Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","sale","discount","alert","notification","megaphone","loudspeaker","special-offer","marketing","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5H15.75V3.95943L14.7628 4.28849L15 5ZM15 19L14.7115 19.6923L15.75 20.125V19H15ZM5.70135 8.89012L15.2372 5.71151L14.7628 4.28849L5.227 7.4671L5.70135 8.89012ZM15.2885 18.3077L5.50618 14.2317L4.92926 15.6164L14.7115 19.6923L15.2885 18.3077ZM14.25 5V19H15.75V5H14.25ZM3.75 11.5975C3.75 10.3691 4.53602 9.27856 5.70135 8.89012L5.227 7.4671C3.44917 8.05971 2.25 9.72346 2.25 11.5975H3.75ZM2.25 11.5975C2.25 13.3551 3.30683 14.9403 4.92926 15.6164L5.50618 14.2317C4.44272 13.7886 3.75 12.7495 3.75 11.5975H2.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 14V14C16.1046 14 17 13.1046 17 12V12C17 10.8954 16.1046 10 15 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 15V17C5 18.1046 5.89543 19 7 19V19C8.10457 19 9 18.1046 9 17V16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["megaphone","announcement","promotion","sale","discount","alert","notification","special-offer","broadcast","loudspeaker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 14V14C16.1046 14 17 13.1046 17 12V12C17 10.8954 16.1046 10 15 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 15V17C5 18.1046 5.89543 19 7 19V19C8.10457 19 9 18.1046 9 17V16.5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5H15.75V3.95943L14.7628 4.28849L15 5ZM15 19L14.7115 19.6923L15.75 20.125V19H15ZM5.70135 8.89012L15.2372 5.71151L14.7628 4.28849L5.227 7.4671L5.70135 8.89012ZM15.2885 18.3077L5.50618 14.2317L4.92926 15.6164L14.7115 19.6923L15.2885 18.3077ZM14.25 5V19H15.75V5H14.25ZM3.75 11.5975C3.75 10.3691 4.53602 9.27856 5.70135 8.89012L5.227 7.4671C3.44917 8.05971 2.25 9.72346 2.25 11.5975H3.75ZM2.25 11.5975C2.25 13.3551 3.30683 14.9403 4.92926 15.6164L5.50618 14.2317C4.44272 13.7886 3.75 12.7495 3.75 11.5975H2.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","discount","sale","special-offer","alert","notification","broadcast","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15.4541L5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17L9 16.2173C9 16.0896 8.9131 15.9783 8.78922 15.9473L5.44058 15.1101C5.37931 15.0948 5.34867 15.0872 5.32391 15.0852C5.16864 15.0728 5.0297 15.1813 5.00408 15.3349C5 15.3594 5 15.391 5 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="15"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 5L5.46418 8.17861C3.99259 8.66914 3 10.0463 3 11.5975C3 13.0523 3.87478 14.3645 5.21772 14.9241L15 19V5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5.46418 8.17861L5.70135 8.89012H5.70135L5.46418 8.17861ZM15 5H15.75V3.95943L14.7628 4.28849L15 5ZM15 19L14.7115 19.6923L15.75 20.125V19H15ZM5.21772 14.9241L5.50618 14.2317H5.50618L5.21772 14.9241ZM5.70135 8.89012L15.2372 5.71151L14.7628 4.28849L5.227 7.4671L5.70135 8.89012ZM15.2885 18.3077L5.50618 14.2317L4.92926 15.6164L14.7115 19.6923L15.2885 18.3077ZM14.25 5V19H15.75V5H14.25ZM3.75 11.5975C3.75 10.3691 4.53602 9.27856 5.70135 8.89012L5.22701 7.4671C3.44917 8.05971 2.25 9.72346 2.25 11.5975H3.75ZM2.25 11.5975C2.25 13.3551 3.30683 14.9403 4.92926 15.6164L5.50618 14.2317C4.44272 13.7886 3.75 12.7495 3.75 11.5975H2.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","special offer","discount","sale","broadcast","attention","news","alert","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5 4V9.17071C16.6652 9.58254 17.5 10.6938 17.5 12C17.5 13.3062 16.6652 14.4175 15.5 14.8293V20L9.36927 17.8787C8.99364 19.1068 7.85113 20 6.5 20C4.84315 20 3.5 18.6569 3.5 17V15.3944C2.26467 14.5475 1.5 13.1348 1.5 11.5974C1.5 9.61583 2.76802 7.85654 4.64795 7.2299L15.5 4ZM5.5 16.3333L7.48707 17.1613C7.40996 17.6369 6.99739 18 6.5 18C5.94772 18 5.5 17.5523 5.5 17V16.3333ZM21.2076 8.70711C21.5981 8.31658 21.5981 7.68342 21.2076 7.29289C20.8171 6.90237 20.1839 6.90237 19.7934 7.29289L18.7934 8.29289C18.4029 8.68342 18.4029 9.31658 18.7934 9.70711C19.1839 10.0976 19.8171 10.0976 20.2076 9.70711L21.2076 8.70711ZM19.5 11C18.9477 11 18.5 11.4477 18.5 12C18.5 12.5523 18.9477 13 19.5 13H21.5C22.0523 13 22.5 12.5523 22.5 12C22.5 11.4477 22.0523 11 21.5 11H19.5ZM18.7929 14.2929C18.4024 14.6834 18.4024 15.3166 18.7929 15.7071L19.7929 16.7071C20.1834 17.0976 20.8166 17.0976 21.2071 16.7071C21.5976 16.3166 21.5976 15.6834 21.2071 15.2929L20.2071 14.2929C19.8166 13.9024 19.1834 13.9024 18.7929 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","alert","sale","discount","special offer","notification","sound","loudspeaker","marketing","advertise","broadcast","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.70135 8.89012L14.2372 5.71151L13.7628 4.28849L4.227 7.4671L4.70135 8.89012ZM14.2885 18.3077L4.50618 14.2317L3.92926 15.6164L13.7115 19.6923L14.2885 18.3077ZM2.75 11.5975C2.75 10.3691 3.53602 9.27856 4.70135 8.89012L4.227 7.4671C2.44917 8.05971 1.25 9.72346 1.25 11.5975H2.75ZM1.25 11.5975C1.25 13.3551 2.30683 14.9403 3.92926 15.6164L4.50618 14.2317C3.44272 13.7886 2.75 12.7495 2.75 11.5975H1.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 15V17C4 18.1046 4.89543 19 6 19V19C7.10457 19 8 18.1046 8 17V16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9.5C11.5858 9.5 11.25 9.83579 11.25 10.25C11.25 10.6642 11.5858 11 12 11V9.5ZM13.7678 13.9843L14.2616 14.5487H14.2616L13.7678 13.9843ZM12 13.875C11.5858 13.875 11.25 14.2108 11.25 14.625C11.25 15.0392 11.5858 15.375 12 15.375V13.875ZM13.164 18.7246L12.7441 19.3461L13.164 18.7246ZM13.0329 5.37166L13.4993 5.95899V5.95899L13.0329 5.37166ZM12 11C13.0637 11 13.75 11.7345 13.75 12.4375H15.25C15.25 10.7242 13.6977 9.5 12 9.5V11ZM13.75 12.4375C13.75 12.7993 13.5841 13.1484 13.2739 13.4199L14.2616 14.5487C14.8562 14.0285 15.25 13.2838 15.25 12.4375H13.75ZM13.2739 13.4199C12.9622 13.6926 12.514 13.875 12 13.875V15.375C12.8667 15.375 13.6686 15.0677 14.2616 14.5487L13.2739 13.4199ZM16.25 12C16.25 13.8564 15.9261 15.5014 15.432 16.6543C15.1843 17.2321 14.9087 17.6518 14.6409 17.9161C14.3763 18.1772 14.1606 18.25 14 18.25V19.75C14.6678 19.75 15.2413 19.431 15.6946 18.9837C16.1446 18.5396 16.5154 17.9341 16.8107 17.2452C17.4024 15.8646 17.75 14.0096 17.75 12H16.25ZM14 5.75C14.1606 5.75 14.3763 5.82276 14.6409 6.08391C14.9087 6.34823 15.1843 6.7679 15.432 7.34569C15.9261 8.49861 16.25 10.1436 16.25 12H17.75C17.75 9.99037 17.4024 8.13539 16.8107 6.75481C16.5154 6.06586 16.1446 5.4604 15.6946 5.01628C15.2413 4.56899 14.6678 4.25 14 4.25V5.75ZM14 18.25C13.8837 18.25 13.747 18.2133 13.5839 18.1032L12.7441 19.3461C13.1118 19.5945 13.536 19.75 14 19.75V18.25ZM13.5839 18.1032C13.1656 17.8205 12.6926 17.1296 12.3261 16.0084C11.9695 14.9175 11.75 13.5276 11.75 12H10.25C10.25 13.6614 10.4875 15.2115 10.9004 16.4745C11.3033 17.7072 11.9124 18.7841 12.7441 19.3461L13.5839 18.1032ZM11.75 12C11.75 10.5268 11.9542 9.18088 12.289 8.10764C12.6314 7.01036 13.0807 6.29141 13.4993 5.95899L12.5665 4.78432C11.8028 5.39082 11.2356 6.4478 10.8571 7.66084C10.4711 8.89793 10.25 10.3968 10.25 12H11.75ZM13.4993 5.95899C13.7008 5.79904 13.8664 5.75 14 5.75V4.25C13.4569 4.25 12.972 4.46237 12.5665 4.78432L13.4993 5.95899Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-29": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","discount","special offer","alert","notification","marketing","advertise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15V17C4 18.1046 4.89543 19 6 19V19C7.10457 19 8 18.1046 8 17V16.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10C13.3807 10 14.5 10.9794 14.5 12.1875C14.5 12.7916 14.2202 13.3384 13.7678 13.7343C13.3154 14.1302 12.6904 14.375 12 14.375"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.70135 8.89012L14.2372 5.71151L13.7628 4.28849L4.227 7.4671L4.70135 8.89012ZM14.2885 18.3077L4.50618 14.2317L3.92926 15.6164L13.7115 19.6923L14.2885 18.3077ZM2.75 11.5975C2.75 10.3691 3.53602 9.27856 4.70135 8.89012L4.227 7.4671C2.44917 8.05971 1.25 9.72346 1.25 11.5975H2.75ZM1.25 11.5975C1.25 13.3551 2.30683 14.9403 3.92926 15.6164L4.50618 14.2317C3.44272 13.7886 2.75 12.7495 2.75 11.5975H1.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 19C15.6569 19 17 15.866 17 12C17 8.13401 15.6569 5 14 5C13.6616 5 13.3364 5.1307 13.0329 5.37166C11.8506 6.31057 11 8.92352 11 12C11 15.189 11.9139 17.88 13.164 18.7246C13.4294 18.9039 13.7099 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","special-offer","loudspeaker","megaphone","marketing","alert","notification","sale","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 4C17.5523 4 18 4.44772 18 5V9.17071C19.1652 9.58254 20 10.6938 20 12C20 13.3062 19.1652 14.4175 18 14.8293V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V18.6868L12.9558 17.516C12.7112 18.927 11.4809 20 10 20C8.34315 20 7 18.6569 7 17L7 15.2253L6.30153 14.9566C4.91494 14.4233 4 13.0911 4 11.6055C4 10.0293 5.02802 8.63742 6.53452 8.17388L16 5.26143V5C16 4.44772 16.4477 4 17 4ZM9 15.9945V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V16.7637L9 15.9945Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-30": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","discount","sale","special offer","broadcast","alert","notification","customer-notification","campaign"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 15.4541L4 17C4 18.1046 4.89543 19 6 19C7.10457 19 8 18.1046 8 17L8 16.2173C8 16.0896 7.9131 15.9783 7.78922 15.9473L4.44058 15.1101C4.37931 15.0948 4.34867 15.0872 4.32391 15.0852C4.16864 15.0728 4.0297 15.1813 4.00408 15.3349C4 15.3594 4 15.391 4 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 5L4.46418 8.17861C2.99259 8.66914 2 10.0463 2 11.5975C2 13.0523 2.87478 14.3645 4.21772 14.9241L14 19C15.6569 19 17 15.866 17 12C17 8.13401 15.6569 5 14 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M4.46418 8.17861L4.70135 8.89012H4.70135L4.46418 8.17861ZM14 5V4.25H13.8783L13.7628 4.28849L14 5ZM14 19L13.7115 19.6923L13.85 19.75H14V19ZM4.21772 14.9241L4.50618 14.2317H4.50618L4.21772 14.9241ZM4.70135 8.89012L14.2372 5.71151L13.7628 4.28849L4.227 7.4671L4.70135 8.89012ZM14.2885 18.3077L4.50618 14.2317L3.92926 15.6164L13.7115 19.6923L14.2885 18.3077ZM2.75 11.5975C2.75 10.3691 3.53602 9.27856 4.70135 8.89012L4.22701 7.4671C2.44917 8.05971 1.25 9.72346 1.25 11.5975H2.75ZM1.25 11.5975C1.25 13.3551 2.30683 14.9403 3.92926 15.6164L4.50618 14.2317C3.44272 13.7886 2.75 12.7495 2.75 11.5975H1.25ZM16.25 12C16.25 13.8564 15.9261 15.5014 15.432 16.6543C15.1843 17.2321 14.9087 17.6518 14.6409 17.9161C14.3763 18.1772 14.1606 18.25 14 18.25V19.75C14.6678 19.75 15.2413 19.431 15.6946 18.9837C16.1446 18.5396 16.5154 17.9341 16.8107 17.2452C17.4024 15.8646 17.75 14.0096 17.75 12H16.25ZM14 5.75C14.1606 5.75 14.3763 5.82276 14.6409 6.08391C14.9087 6.34823 15.1843 6.7679 15.432 7.34569C15.9261 8.49861 16.25 10.1436 16.25 12H17.75C17.75 9.99037 17.4024 8.13539 16.8107 6.75481C16.5154 6.06586 16.1446 5.4604 15.6946 5.01628C15.2413 4.56899 14.6678 4.25 14 4.25V5.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M14 19C15.6569 19 17 15.866 17 12C17 8.13401 15.6569 5 14 5C13.6616 5 13.3364 5.1307 13.0329 5.37166C11.8506 6.31057 11 8.92352 11 12C11 15.189 11.9139 17.88 13.164 18.7246C13.4294 18.9039 13.7099 19 14 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.5 12.4374C14.5 11.2292 13.7678 9.99986 11.0976 10.2226C11.0976 10.2226 10.5 10.4999 11.0976 14.5866C11.788 14.5866 13.3154 14.38 13.7678 13.9842C14.2202 13.5883 14.5 13.0414 14.5 12.4374Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.0005 8L19.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","discount","sale","alert","notification","special-offer","megaphone","loudspeaker","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 4C14.7524 4 15.3855 4.36003 15.8702 4.83835C16.3505 5.31243 16.7373 5.94885 17.0405 6.65633C17.6484 8.07486 18 9.96482 18 12C18 14.0352 17.6484 15.9251 17.0405 17.3437C16.7373 18.0512 16.3505 18.6876 15.8702 19.1617C15.3855 19.64 14.7524 20 14 20C13.4781 20 13.0059 19.8247 12.6042 19.5532C12.5297 19.5029 12.457 19.4489 12.3861 19.3915L8.8561 17.9206C8.46751 19.1271 7.33569 20 6 20C4.34315 20 3 18.6569 3 17V15.375C1.76467 14.5281 1 13.1155 1 11.5781C1 9.59644 2.26802 7.83715 4.14795 7.21051L12.7962 4.32777C13.1525 4.12577 13.5571 4 14 4ZM5 16.3139V17C5 17.5523 5.44772 18 6 18C6.50372 18 6.92046 17.6276 6.98985 17.143L5 16.3139ZM13.6548 6.15477C13.8222 6.02182 13.9346 6 14 6C14.076 6 14.2321 6.03173 14.4653 6.26184C14.7028 6.4962 14.9625 6.8849 15.2022 7.44417C15.68 8.55915 16 10.1692 16 12C16 13.8308 15.68 15.4409 15.2022 16.5558C14.9625 17.1151 14.7028 17.5038 14.4653 17.7382C14.2321 17.9683 14.076 18 14 18C13.9417 18 13.8528 17.9832 13.7239 17.896C13.3745 17.66 12.9242 17.0333 12.5637 15.9307C12.5284 15.8227 12.4945 15.7116 12.4619 15.5975C13.2095 15.5077 13.8942 15.2024 14.4263 14.7369C15.0682 14.1752 15.5 13.3645 15.5 12.4375C15.5 10.6454 13.9611 9.37565 12.2567 9.2588C12.3327 8.87521 12.4239 8.51477 12.5277 8.1821C12.864 7.10413 13.2937 6.44151 13.6548 6.15477ZM13.1093 13.2317C12.8614 13.4486 12.5045 13.604 12.0866 13.623C12.0304 13.1075 12 12.5637 12 12C12 11.7457 12.0062 11.4955 12.0181 11.2501C12.9649 11.2583 13.5 11.9063 13.5 12.4375C13.5 12.7186 13.3721 13.0017 13.1093 13.2317Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7076 7.29289C22.0981 7.68342 22.0981 8.31658 21.7076 8.70711L20.7076 9.70711C20.3171 10.0976 19.6839 10.0976 19.2934 9.70711C18.9029 9.31658 18.9029 8.68342 19.2934 8.29289L20.2934 7.29289C20.6839 6.90237 21.3171 6.90237 21.7076 7.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2929 14.2929C19.6834 13.9024 20.3166 13.9024 20.7071 14.2929L21.7071 15.2929C22.0976 15.6834 22.0976 16.3166 21.7071 16.7071C21.3166 17.0976 20.6834 17.0976 20.2929 16.7071L19.2929 15.7071C18.9024 15.3166 18.9024 14.6834 19.2929 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 11.4477 19.4477 11 20 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H20C19.4477 13 19 12.5523 19 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","alert","notification","special-offer","discount","sale","broadcast","loudspeaker","marketing","news"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15L7.76352 18.8176C7.90102 19.5051 8.50469 20 9.20583 20V20C10.134 20 10.8302 19.1508 10.6481 18.2407L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 4V18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.75 4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4H15.75ZM14.25 18C14.25 18.4142 14.5858 18.75 15 18.75C15.4142 18.75 15.75 18.4142 15.75 18H14.25ZM5.75 13V9H4.25V13H5.75ZM15.75 5V4H14.25V5H15.75ZM14.25 17V18H15.75V17H14.25ZM7 7.75H13V6.25H7V7.75ZM13 14.25H7V15.75H13V14.25ZM15.75 17C15.75 15.4812 14.5188 14.25 13 14.25V15.75C13.6904 15.75 14.25 16.3096 14.25 17H15.75ZM14.25 5C14.25 5.69036 13.6904 6.25 13 6.25V7.75C14.5188 7.75 15.75 6.51878 15.75 5H14.25ZM4.25 13C4.25 14.5188 5.48122 15.75 7 15.75V14.25C6.30964 14.25 5.75 13.6904 5.75 13H4.25ZM5.75 9C5.75 8.30964 6.30964 7.75 7 7.75V6.25C5.48122 6.25 4.25 7.48122 4.25 9H5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 8L19 7M18 14L19 15M19 11H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["announcement","promotion","discount","alert","notification","megaphone","speaker","broadcast","advertise","sale","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15L7.76352 18.8176C7.90102 19.5051 8.50469 20 9.20583 20V20C10.134 20 10.8302 19.1508 10.6481 18.2407L10 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 8L19 7M18 14L19 15M19 11H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 4V18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.75 4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4H15.75ZM14.25 18C14.25 18.4142 14.5858 18.75 15 18.75C15.4142 18.75 15.75 18.4142 15.75 18H14.25ZM5.75 13V9H4.25V13H5.75ZM15.75 5V4H14.25V5H15.75ZM14.25 17V18H15.75V17H14.25ZM7 7.75H13V6.25H7V7.75ZM13 14.25H7V15.75H13V14.25ZM15.75 17C15.75 15.4812 14.5188 14.25 13 14.25V15.75C13.6904 15.75 14.25 16.3096 14.25 17H15.75ZM14.25 5C14.25 5.69036 13.6904 6.25 13 6.25V7.75C14.5188 7.75 15.75 6.51878 15.75 5H14.25ZM4.25 13C4.25 14.5188 5.48122 15.75 7 15.75V14.25C6.30964 14.25 5.75 13.6904 5.75 13H4.25ZM5.75 9C5.75 8.30964 6.30964 7.75 7 7.75V6.25C5.48122 6.25 4.25 7.48122 4.25 9H5.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-34": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","discount","sale","special offer","alert","notification","broadcast","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.49895 18.6705L7.91485 15.75L9.38515 15.75L9.9127 18.3878C10.0019 18.8338 9.66073 19.25 9.20583 19.25C8.8622 19.25 8.56634 19.0075 8.49895 18.6705Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 8L19 7M18 14L19 15M19 11H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 5V17C15 15.8954 14.1046 15 13 15H7C5.89543 15 5 14.1046 5 13V9C5 7.89543 5.89543 7 7 7H13C14.1046 7 15 6.10457 15 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M14.25 18C14.25 18.4142 14.5858 18.75 15 18.75C15.4142 18.75 15.75 18.4142 15.75 18H14.25ZM15.75 4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4H15.75ZM15.75 18V17H14.25V18H15.75ZM15.75 17V5H14.25V17H15.75ZM15.75 5V4H14.25V5H15.75ZM5.75 13V9H4.25V13H5.75ZM7 7.75H13V6.25H7V7.75ZM13 14.25H7V15.75H13V14.25ZM15.75 17C15.75 15.4812 14.5188 14.25 13 14.25V15.75C13.6904 15.75 14.25 16.3096 14.25 17H15.75ZM14.25 5C14.25 5.69036 13.6904 6.25 13 6.25V7.75C14.5188 7.75 15.75 6.51878 15.75 5H14.25ZM4.25 13C4.25 14.5188 5.48122 15.75 7 15.75V14.25C6.30964 14.25 5.75 13.6904 5.75 13H4.25ZM5.75 9C5.75 8.30964 6.30964 7.75 7 7.75V6.25C5.48122 6.25 4.25 7.48122 4.25 9H5.75Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M14.25 18C14.25 18.4142 14.5858 18.75 15 18.75C15.4142 18.75 15.75 18.4142 15.75 18H14.25ZM15.75 4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4H15.75ZM14.25 5C14.25 5.41421 14.5858 5.75 15 5.75C15.4142 5.75 15.75 5.41421 15.75 5H14.25ZM15.75 17C15.75 16.5858 15.4142 16.25 15 16.25C14.5858 16.25 14.25 16.5858 14.25 17H15.75ZM15.75 18V4H14.25V18H15.75ZM15.75 5V4H14.25V5H15.75ZM14.25 17V18H15.75V17H14.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-36": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","special-offer","alert","broadcast","megaphone","loudspeaker","notification","marketing","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 5H17.75V3.95943L16.7628 4.28849L17 5ZM17 19L16.7115 19.6923L17.75 20.125V19H17ZM7.70135 8.89012L17.2372 5.71151L16.7628 4.28849L7.227 7.4671L7.70135 8.89012ZM17.2885 18.3077L7.50618 14.2317L6.92926 15.6164L16.7115 19.6923L17.2885 18.3077ZM16.25 5V19H17.75V5H16.25ZM5.75 11.5975C5.75 10.3691 6.53602 9.27856 7.70135 8.89012L7.227 7.4671C5.44917 8.05971 4.25 9.72346 4.25 11.5975H5.75ZM4.25 11.5975C4.25 13.3551 5.30683 14.9403 6.92926 15.6164L7.50618 14.2317C6.44272 13.7886 5.75 12.7495 5.75 11.5975H4.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 14V14C18.1046 14 19 13.1046 19 12V12C19 10.8954 18.1046 10 17 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 15V17C7 18.1046 7.89543 19 9 19V19C10.1046 19 11 18.1046 11 17V16.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","discount","alert","special offer","sale","notification","loudspeaker","broadcast","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L18.7071 8.70711C18.3166 9.09763 17.6834 9.09763 17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289L18.2929 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12H19C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10H18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 13.2929L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L17.2929 14.7071C16.9024 14.3166 16.9024 13.6834 17.2929 13.2929C17.6834 12.9024 18.3166 12.9024 18.7071 13.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 4C16 3.44772 15.5523 3 15 3C14.4477 3 14 3.44772 14 4V5C14 5.55228 13.5523 6 13 6H7C5.34315 6 4 7.34315 4 9V13C4 14.3639 4.91011 15.5151 6.15613 15.8797L6.78294 19.0137C7.01393 20.1687 8.02801 21 9.20583 21C10.7651 21 11.9345 19.5735 11.6287 18.0445L11.2198 16H13C13.5523 16 14 16.4477 14 17V18C14 18.5523 14.4477 19 15 19C15.5523 19 16 18.5523 16 18V4ZM8.2198 16H9.1802L9.66755 18.4368C9.72583 18.7282 9.50297 19 9.20583 19C8.98137 19 8.78812 18.8416 8.7441 18.6215L8.2198 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-37": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","sale","discount","special-offer","notification","alert","advertising","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 14V14C18.1046 14 19 13.1046 19 12V12C19 10.8954 18.1046 10 17 10V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 15V17C7 18.1046 7.89543 19 9 19V19C10.1046 19 11 18.1046 11 17V16.5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 5H17.75V3.95943L16.7628 4.28849L17 5ZM17 19L16.7115 19.6923L17.75 20.125V19H17ZM7.70135 8.89012L17.2372 5.71151L16.7628 4.28849L7.227 7.4671L7.70135 8.89012ZM17.2885 18.3077L7.50618 14.2317L6.92926 15.6164L16.7115 19.6923L17.2885 18.3077ZM16.25 5V19H17.75V5H16.25ZM5.75 11.5975C5.75 10.3691 6.53602 9.27856 7.70135 8.89012L7.227 7.4671C5.44917 8.05971 4.25 9.72346 4.25 11.5975H5.75ZM4.25 11.5975C4.25 13.3551 5.30683 14.9403 6.92926 15.6164L7.50618 14.2317C6.44272 13.7886 5.75 12.7495 5.75 11.5975H4.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-38": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","alert","notification","broadcast","sale","discount","special-offer","marketing","advertising","promotion-alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="17"
                    cy="12"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 15.4541L7 17C7 18.1046 7.89543 19 9 19C10.1046 19 11 18.1046 11 17L11 16.2173C11 16.0896 10.9131 15.9783 10.7892 15.9473L7.44058 15.1101C7.37931 15.0948 7.34867 15.0872 7.32391 15.0852C7.16864 15.0728 7.0297 15.1813 7.00408 15.3349C7 15.3594 7 15.391 7 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 5L7.46418 8.17861C5.99259 8.66914 5 10.0463 5 11.5975C5 13.0523 5.87478 14.3645 7.21772 14.9241L17 19V5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M7.46418 8.17861L7.70135 8.89012H7.70135L7.46418 8.17861ZM17 5H17.75V3.95943L16.7628 4.28849L17 5ZM17 19L16.7115 19.6923L17.75 20.125V19H17ZM7.21772 14.9241L7.50618 14.2317H7.50618L7.21772 14.9241ZM7.70135 8.89012L17.2372 5.71151L16.7628 4.28849L7.227 7.4671L7.70135 8.89012ZM17.2885 18.3077L7.50618 14.2317L6.92926 15.6164L16.7115 19.6923L17.2885 18.3077ZM16.25 5V19H17.75V5H16.25ZM5.75 11.5975C5.75 10.3691 6.53602 9.27856 7.70135 8.89012L7.22701 7.4671C5.44917 8.05971 4.25 9.72346 4.25 11.5975H5.75ZM4.25 11.5975C4.25 13.3551 5.30683 14.9403 6.92926 15.6164L7.50618 14.2317C6.44272 13.7886 5.75 12.7495 5.75 11.5975H4.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-39": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","discount","sale","alert","notification","marketing","advertise","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.6123V9.17046C19.1652 9.5823 20 10.6935 20 11.9998C20 13.306 19.1652 14.4172 18 14.8291V20.4997L11.8505 17.9375C11.4568 19.1351 10.3294 19.9998 9 19.9998C7.34315 19.9998 6 18.6566 6 16.9998V15.3942C4.76467 14.5473 4 13.1346 4 11.5972C4 9.61559 5.26802 7.8563 7.14795 7.22966L18 3.6123ZM8 16.3331V16.9998C8 17.552 8.44772 17.9998 9 17.9998C9.49739 17.9998 9.90996 17.6366 9.98707 17.161L8 16.3331Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","special offer","discount","alert","notification","broadcast","sale","marketing","news"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L5.82861 9.12966C4.74169 9.46409 4 10.4683 4 11.6055V11.6055C4 12.6774 4.66011 13.6385 5.66051 14.0233L16 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 14V17C6 18.1046 6.89543 19 8 19V19C9.10457 19 10 18.1046 10 17V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-40": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","discount","alert","notification","sales","marketing","communication","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L10 17C10 18.1046 10.8954 19 12 19V19C13.1046 19 14 18.1046 14 17L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6L10.3396 8.87266C10.1702 8.93616 10.0856 8.96791 9.99709 8.98395C9.9086 9 9.81818 9 9.63733 9H8C7.05719 9 6.58579 9 6.29289 9.29289C6 9.58579 6 10.0572 6 11V13C6 13.9428 6 14.4142 6.29289 14.7071C6.58579 15 7.05719 15 8 15H9.63733C9.81818 15 9.9086 15 9.99709 15.016C10.0856 15.0321 10.1702 15.0638 10.3396 15.1273L18 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 5C18 6.08387 18 14.7849 18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 9C10 9.46452 10 13.1935 10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-41": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","announcement","promotion","discount","sale","notification","alert","broadcast","customer-service","marketing","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15L10 17C10 18.1046 10.8954 19 12 19V19C13.1046 19 14 18.1046 14 17L14 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 6L10.3396 8.87266C10.1702 8.93616 10.0856 8.96791 9.99709 8.98395C9.9086 9 9.81818 9 9.63733 9H8C7.05719 9 6.58579 9 6.29289 9.29289C6 9.58579 6 10.0572 6 11V13C6 13.9428 6 14.4142 6.29289 14.7071C6.58579 15 7.05719 15 8 15H9.63733C9.81818 15 9.9086 15 9.99709 15.016C10.0856 15.0321 10.1702 15.0638 10.3396 15.1273L18 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 5C18 6.08387 18 14.7849 18 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 9C10 9.46452 10 13.1935 10 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-42": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","discount","sale","special-offer","alert","notification","broadcast","communicate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 15.4541L10 17C10 18.1046 10.8954 19 12 19C13.1046 19 14 18.1046 14 17L14 16.2173C14 16.0896 13.9131 15.9783 13.7892 15.9473L10.4406 15.1101C10.3793 15.0948 10.3487 15.0872 10.3239 15.0852C10.1686 15.0728 10.0297 15.1813 10.0041 15.3349C10 15.3594 10 15.391 10 15.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 11V13C6 13.9428 6 14.4142 6.29289 14.7071C6.58579 15 7.05719 15 8 15H9.63733C9.81818 15 9.9086 15 9.99709 15.016C10.0856 15.0321 10.1703 15.0638 10.3396 15.1273L18 18V6L10.3396 8.87266C10.1703 8.93616 10.0856 8.96791 9.99709 8.98395C9.9086 9 9.81818 9 9.63733 9H8C7.05719 9 6.58579 9 6.29289 9.29289C6 9.58579 6 10.0572 6 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10.3396 8.87266L10.0762 8.17041L10.0762 8.17041L10.3396 8.87266ZM10.3396 15.1273L10.6029 14.4251H10.6029L10.3396 15.1273ZM9.99709 15.016L9.86327 15.754L9.86327 15.754L9.99709 15.016ZM9.99709 8.98395L9.86327 8.24599L9.86327 8.24599L9.99709 8.98395ZM18.75 5C18.75 4.58579 18.4142 4.25 18 4.25C17.5858 4.25 17.25 4.58579 17.25 5H18.75ZM17.25 19C17.25 19.4142 17.5858 19.75 18 19.75C18.4142 19.75 18.75 19.4142 18.75 19L17.25 19ZM6.75 13V11H5.25V13H6.75ZM8 9.75H9.63733V8.25H8V9.75ZM9.63733 14.25H8V15.75H9.63733V14.25ZM10.6029 9.5749L18.2633 6.70225L17.7367 5.29775L10.0762 8.17041L10.6029 9.5749ZM18.2633 17.2978L10.6029 14.4251L10.0762 15.8296L17.7367 18.7022L18.2633 17.2978ZM9.63733 15.75C9.73278 15.75 9.78524 15.7501 9.82513 15.7515C9.84281 15.7522 9.85274 15.7529 9.85803 15.7534C9.86056 15.7536 9.86199 15.7538 9.8626 15.7539C9.86292 15.754 9.8631 15.754 9.86317 15.754C9.86324 15.754 9.86327 15.754 9.86327 15.754L10.1309 14.2781C9.96093 14.2473 9.79249 14.25 9.63733 14.25V15.75ZM10.6029 14.4251C10.4577 14.3706 10.3009 14.3089 10.1309 14.2781L9.86327 15.754C9.86328 15.754 9.8633 15.754 9.86337 15.754C9.86344 15.754 9.86362 15.7541 9.86394 15.7542C9.86453 15.7543 9.86594 15.7546 9.86839 15.7553C9.87352 15.7567 9.88308 15.7595 9.89986 15.7651C9.93771 15.7778 9.98687 15.7961 10.0762 15.8296L10.6029 14.4251ZM9.63733 9.75C9.79249 9.75 9.96093 9.75274 10.1309 9.72192L9.86327 8.24599C9.86327 8.24599 9.86324 8.24599 9.86317 8.24601C9.8631 8.24602 9.86292 8.24604 9.8626 8.24609C9.86199 8.24617 9.86056 8.24635 9.85803 8.24659C9.85274 8.2471 9.84281 8.24784 9.82513 8.24847C9.78524 8.24989 9.73278 8.25 9.63733 8.25V9.75ZM10.0762 8.17041C9.98687 8.20392 9.9377 8.22225 9.89986 8.23492C9.88308 8.24054 9.87352 8.24333 9.86839 8.24471C9.86594 8.24538 9.86453 8.24571 9.86394 8.24584C9.86363 8.24592 9.86344 8.24595 9.86337 8.24597C9.8633 8.24598 9.86328 8.24599 9.86327 8.24599L10.1309 9.72192C10.3009 9.6911 10.4576 9.62938 10.6029 9.5749L10.0762 8.17041ZM6.75 11C6.75 10.5074 6.75159 10.2134 6.77992 10.0027C6.79291 9.90611 6.8082 9.85774 6.81716 9.83596C6.81923 9.83092 6.82085 9.8276 6.82186 9.82567C6.82286 9.82376 6.82341 9.82292 6.82347 9.82283C6.82351 9.82277 6.82335 9.823 6.82307 9.82335C6.82279 9.8237 6.82277 9.82368 6.82322 9.82322L5.76256 8.76256C5.45354 9.07159 5.34109 9.44731 5.2933 9.80279C5.24841 10.1367 5.25 10.5498 5.25 11H6.75ZM8 8.25C7.5498 8.25 7.1367 8.24841 6.80279 8.2933C6.44731 8.34109 6.07159 8.45354 5.76256 8.76256L6.82322 9.82322C6.82368 9.82277 6.8237 9.82279 6.82335 9.82307C6.823 9.82335 6.82277 9.82351 6.82283 9.82347C6.82292 9.82341 6.82376 9.82286 6.82567 9.82186C6.8276 9.82085 6.83092 9.81923 6.83596 9.81716C6.85774 9.8082 6.90611 9.79291 7.00266 9.77992C7.21339 9.75159 7.50739 9.75 8 9.75V8.25ZM5.25 13C5.25 13.4502 5.24841 13.8633 5.2933 14.1972C5.34109 14.5527 5.45354 14.9284 5.76256 15.2374L6.82322 14.1768C6.82277 14.1763 6.82279 14.1763 6.82307 14.1766C6.82335 14.177 6.82351 14.1772 6.82347 14.1772C6.82341 14.1771 6.82286 14.1762 6.82186 14.1743C6.82085 14.1724 6.81923 14.1691 6.81716 14.164C6.8082 14.1423 6.79291 14.0939 6.77992 13.9973C6.75159 13.7866 6.75 13.4926 6.75 13H5.25ZM8 14.25C7.50739 14.25 7.21339 14.2484 7.00266 14.2201C6.90611 14.2071 6.85774 14.1918 6.83596 14.1828C6.83092 14.1808 6.8276 14.1791 6.82567 14.1781C6.82376 14.1771 6.82292 14.1766 6.82283 14.1765C6.82277 14.1765 6.823 14.1766 6.82335 14.1769C6.8237 14.1772 6.82368 14.1772 6.82322 14.1768L5.76256 15.2374C6.07159 15.5465 6.44731 15.6589 6.80279 15.7067C7.1367 15.7516 7.5498 15.75 8 15.75V14.25ZM17.25 5V6H18.75V5H17.25ZM17.25 6V18H18.75V6H17.25ZM17.25 18L17.25 19L18.75 19L18.75 18L17.25 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6 11V13C6 13.9428 6 14.4142 6.29289 14.7071C6.58579 15 7.05719 15 8 15H9.63733C9.82647 15 10 14.826 10 14.6368L10 9.36324C10 9.1741 9.82647 9 9.63733 9H8C7.05719 9 6.58579 9 6.29289 9.29289C6 9.58579 6 10.0572 6 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.29289 9.29289L6.82322 9.82322L6.82322 9.82322L6.29289 9.29289ZM10 9.36324H9.25V9.36324L10 9.36324ZM10 14.6368H10.75H10ZM6.75 13V11H5.25V13H6.75ZM8 9.75H9.63733V8.25H8V9.75ZM9.63733 14.25H8V15.75H9.63733V14.25ZM6.75 11C6.75 10.5074 6.75159 10.2134 6.77992 10.0027C6.79291 9.90611 6.8082 9.85774 6.81716 9.83596C6.81923 9.83092 6.82085 9.8276 6.82186 9.82567C6.82286 9.82376 6.82341 9.82292 6.82347 9.82283C6.82351 9.82277 6.82335 9.823 6.82307 9.82335C6.82279 9.8237 6.82277 9.82368 6.82322 9.82322L5.76256 8.76256C5.45354 9.07159 5.34109 9.44731 5.2933 9.80279C5.24841 10.1367 5.25 10.5498 5.25 11H6.75ZM8 8.25C7.5498 8.25 7.1367 8.24841 6.80279 8.2933C6.44731 8.34109 6.07159 8.45354 5.76256 8.76256L6.82322 9.82322C6.82368 9.82277 6.8237 9.82279 6.82335 9.82307C6.823 9.82335 6.82277 9.82351 6.82283 9.82347C6.82292 9.82341 6.82376 9.82286 6.82567 9.82186C6.8276 9.82085 6.83092 9.81923 6.83596 9.81716C6.85774 9.8082 6.90611 9.79291 7.00266 9.77992C7.21339 9.75159 7.50739 9.75 8 9.75V8.25ZM5.25 13C5.25 13.4502 5.24841 13.8633 5.2933 14.1972C5.34109 14.5527 5.45354 14.9284 5.76256 15.2374L6.82322 14.1768C6.82277 14.1763 6.82279 14.1763 6.82307 14.1766C6.82335 14.177 6.82351 14.1772 6.82347 14.1772C6.82341 14.1771 6.82286 14.1762 6.82186 14.1743C6.82085 14.1724 6.81923 14.1691 6.81716 14.164C6.8082 14.1423 6.79291 14.0939 6.77992 13.9973C6.75159 13.7866 6.75 13.4926 6.75 13H5.25ZM8 14.25C7.50739 14.25 7.21339 14.2484 7.00266 14.2201C6.90611 14.2071 6.85774 14.1918 6.83596 14.1828C6.83092 14.1808 6.8276 14.1791 6.82567 14.1781C6.82376 14.1771 6.82292 14.1766 6.82283 14.1765C6.82277 14.1765 6.823 14.1766 6.82335 14.1769C6.8237 14.1772 6.82368 14.1772 6.82322 14.1768L5.76256 15.2374C6.07159 15.5465 6.44731 15.6589 6.80279 15.7067C7.1367 15.7516 7.5498 15.75 8 15.75V14.25ZM9.25 9.36324L9.25 14.6368H10.75L10.75 9.36324L9.25 9.36324ZM9.63733 9.75C9.50204 9.75 9.40911 9.69098 9.3587 9.64046C9.3083 9.58996 9.25 9.49752 9.25 9.36324H10.75C10.75 9.03982 10.6049 8.76576 10.4205 8.58093C10.236 8.39607 9.96176 8.25 9.63733 8.25V9.75ZM9.63733 15.75C9.96169 15.75 10.2359 15.604 10.4204 15.4192C10.6049 15.2343 10.75 14.9603 10.75 14.6368H9.25C9.25 14.5025 9.30832 14.41 9.35875 14.3595C9.4092 14.309 9.50212 14.25 9.63733 14.25V15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-43": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","alert","notification","special-offer","discount","sale","broadcast","communication","loudspeaker","volume","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 4C18.5523 4 19 4.44772 19 5L19 19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19V18.693L14.8651 17.8924C14.4851 19.1135 13.3461 20 12 20C10.3432 20 9.00001 18.6569 9.00001 17V16L7.9456 16C7.52154 16.0001 7.1094 16.0002 6.76949 15.9545C6.38629 15.903 5.94902 15.7774 5.5858 15.4142C5.22259 15.051 5.09706 14.6137 5.04554 14.2305C4.99984 13.8906 4.99992 13.4785 5.00001 13.0544V10.9456C4.99992 10.5215 4.99984 10.1094 5.04554 9.76948C5.09706 9.38628 5.22259 8.949 5.5858 8.58579C5.94902 8.22257 6.38629 8.09705 6.76949 8.04553C7.10941 7.99983 7.52153 7.99991 7.9456 7.99999L9.63734 8C9.73447 8 9.78182 7.99986 9.81624 7.99863L9.81842 7.99855L9.82049 7.99786C9.85315 7.98692 9.89753 7.97043 9.98847 7.93633L17 5.307V5C17 4.44772 17.4477 4 18 4ZM11 16.443L12.9827 17.1865C12.8953 17.6497 12.4886 18 12 18C11.4477 18 11 17.5523 11 17V16.443ZM9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11L7 13C7 13.5523 7.44772 14 8 14C8.55228 14 9 13.5523 9 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["megaphone","announcement","promotion","discount","sale","alert","notification","special-offer","marketing","advertising","loudspeaker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14.4541L6 16C6 17.1046 6.89543 18 8 18C9.10457 18 10 17.1046 10 16L10 15.2173C10 15.0896 9.9131 14.9783 9.78922 14.9473L6.44058 14.1101C6.37931 14.0948 6.34867 14.0872 6.32391 14.0852C6.16864 14.0728 6.0297 14.1813 6.00408 14.3349C6 14.3594 6 14.391 6 14.4541Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L5.82861 9.12966C4.74169 9.46409 4 10.4683 4 11.6055C4 12.6774 4.66011 13.6385 5.66051 14.0233L16 18V6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5.82861 9.12966L6.04917 9.84649L5.82861 9.12966ZM5.66051 14.0233L5.92974 13.3233H5.92974L5.66051 14.0233ZM16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5H16.75ZM15.25 19C15.25 19.4142 15.5858 19.75 16 19.75C16.4142 19.75 16.75 19.4142 16.75 19L15.25 19ZM6.04917 9.84649L16.2206 6.71683L15.7794 5.28317L5.60805 8.41282L6.04917 9.84649ZM16.2692 17.3L5.92974 13.3233L5.39128 14.7233L15.7308 18.7L16.2692 17.3ZM4.75 11.6055C4.75 10.7976 5.27695 10.0841 6.04917 9.84649L5.60805 8.41282C4.20644 8.84409 3.25 10.1391 3.25 11.6055H4.75ZM3.25 11.6055C3.25 12.9877 4.10124 14.2271 5.39128 14.7233L5.92974 13.3233C5.21899 13.0499 4.75 12.367 4.75 11.6055H3.25ZM15.25 5V6H16.75V5H15.25ZM15.25 6V18H16.75V6H15.25ZM15.25 18L15.25 19L16.75 19L16.75 18L15.25 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","loudspeaker","announcement","promotion","special-offer","discount","alert","notification","broadcast","advertising","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0005 8L18.0005 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 16L18 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 12H18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 14V17C6 18.1046 6.89543 19 8 19V19C9.10457 19 10 18.1046 10 17V16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L5.82861 9.12966C4.74169 9.46409 4 10.4683 4 11.6055V11.6055C4 12.6774 4.66011 13.6385 5.66051 14.0233L16 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 5C16 6.08387 16 14.7849 16 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","promotion","sale","alert","notification","megaphone","loudspeaker","marketing","discount","special-offer","broadcast","news"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 4C15.5523 4 16 4.44772 16 5V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19V18.6868L9.99646 17.147C9.91983 18.7356 8.60757 20 7 20C5.34315 20 4 18.6569 4 17V14.8246C2.78384 14.2242 2 12.9806 2 11.6055C2 10.0293 3.02802 8.63742 4.53452 8.17388L14 5.26143V5C14 4.44772 14.4477 4 15 4ZM6 15.6099V17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17V16.3791L6 15.6099ZM19.7076 8.70711C20.0981 8.31658 20.0981 7.68342 19.7076 7.29289C19.3171 6.90237 18.6839 6.90237 18.2934 7.29289L17.2934 8.29289C16.9029 8.68342 16.9029 9.31658 17.2934 9.70711C17.6839 10.0976 18.3171 10.0976 18.7076 9.70711L19.7076 8.70711ZM17.2929 15.7071C16.9024 15.3166 16.9024 14.6834 17.2929 14.2929C17.6834 13.9024 18.3166 13.9024 18.7071 14.2929L19.7071 15.2929C20.0976 15.6834 20.0976 16.3166 19.7071 16.7071C19.3166 17.0976 18.6834 17.0976 18.2929 16.7071L17.2929 15.7071ZM18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","special-offer","discount","alert","notification","loudspeaker","marketing","advertising","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 13.3846L18 18M6 9.69231L18 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M18 5C18 6.08387 18 14.7849 18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8C6 8.54194 6 12.8925 6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14L8 16.5C8 17.8807 9.11929 19 10.5 19V19C11.8807 19 13 17.8807 13 16.5L13 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","alert","notification","discount","special-offer","marketing","advertising","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 14L8 16.5C8 17.8807 9.11929 19 10.5 19V19C11.8807 19 13 17.8807 13 16.5L13 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M6 13.3846L18 18M6 9.69231L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M18 5C18 6.08387 18 14.7849 18 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8C6 8.54194 6 12.8925 6 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Megaphone-loudspeakers": {
        defaultColors: ["#3D4C66"],
        keywords: ["megaphone","announcement","promotion","sale","discount","notification","alert","communication","message","broadcast","special offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 6L6.82861 9.12966C5.74169 9.46409 5 10.4683 5 11.6055V11.6055C5 12.6774 5.66011 13.6385 6.66051 14.0233L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 15L8 17C8 18.1046 8.89543 19 10 19V19C11.1046 19 12 18.1046 12 17L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 5C17 6.08387 17 14.7849 17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14V14C18.1046 14 19 13.1046 19 12V12C19 10.8954 18.1046 10 17 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "memory-alt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["memory","storage","cpu","chip","processing","system","server","data","database","cache","logs","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="7" width="12" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 11L12 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11L9 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11L15 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "memory-alt-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["memory","storage","data","chip","module","inventory","database","system","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 7L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect
                    x="6"
                    y="7"
                    width="12"
                    height="10"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 11L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11L9 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11L15 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "memory-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["memory","storage","database","configuration","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 6.5359C7.31647 6.35319 7.6492 6.23641 8 6.16007V6C8 5.44772 8.44772 5 9 5C9.55229 5 10 5.44772 10 6V6.00297C10.296 5.99999 10.6137 5.99999 10.954 6L11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6L13.046 6C13.3863 5.99999 13.704 5.99999 14 6.00297V6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6V6.16007C16.3508 6.23641 16.6835 6.35319 17 6.5359C17.6081 6.88697 18.113 7.39192 18.4641 8C18.7676 8.52564 18.8892 9.09615 18.9457 9.71983C19 10.3195 19 11.0585 19 11.9539V12.0461C19 12.9415 19 13.6805 18.9457 14.2802C18.8892 14.9039 18.7676 15.4744 18.4641 16C18.113 16.6081 17.6081 17.113 17 17.4641C16.6835 17.6468 16.3508 17.7636 16 17.8399V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V17.997C13.7041 18 13.3866 18 13.0465 18L13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18L10.9539 18C10.6139 18 10.2959 18 10 17.997V18C10 18.5523 9.55229 19 9 19C8.44772 19 8 18.5523 8 18V17.8399C7.6492 17.7636 7.31647 17.6468 7 17.4641C6.39193 17.113 5.88697 16.6081 5.5359 16C5.23242 15.4744 5.11085 14.9039 5.05433 14.2802C4.99997 13.6805 4.99999 12.9415 5 12.0461V11.9539C4.99999 11.0585 4.99997 10.3195 5.05433 9.71983C5.11085 9.09615 5.23242 8.52564 5.5359 8C5.88697 7.39192 6.39193 6.88697 7 6.5359ZM9 10C9.55229 10 10 10.4477 10 11L10 13C10 13.5523 9.55229 14 9 14C8.44772 14 8 13.5523 8 13L8 11C8 10.4477 8.44772 10 9 10ZM12 10C12.5523 10 13 10.4477 13 11L13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13L11 11C11 10.4477 11.4477 10 12 10ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11L14 13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "memory-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["chip","memory","component","storage","technology","circuit","server","hardware","data","electronic","information","system","core","processing","cpu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="7" width="12" height="10" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 11L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11L9 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 7L9 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 17L9 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 7L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L15 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L15 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 11L15 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "menu-fold-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","collapse","fold","hide","sidebar","navigation","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6L5 9L9 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "menu-fold-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","fold","collapse","hide","navigation","sidebar","drawer","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.8 5.40006C10.1314 5.84189 10.0418 6.46869 9.6 6.80006L6.66667 9.00006L9.6 11.2001C10.0418 11.5314 10.1314 12.1582 9.8 12.6001C9.46863 13.0419 8.84183 13.1314 8.4 12.8001L4.4 9.80006C4.14819 9.6112 4 9.31482 4 9.00006C4 8.6853 4.14819 8.38891 4.4 8.20006L8.4 5.20006C8.84183 4.86869 9.46863 4.95823 9.8 5.40006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12 5.44772 12.4477 5 13 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H13C12.4477 7 12 6.55228 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 12C12 11.4477 12.4477 11 13 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 18C4 17.4477 4.44772 17 5 17L19 17C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19L5 19C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "menu-fold": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","navigation","hide","collapse","options","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6L5 9L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "menu-fold-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["menu","hide","collapse","fold","left","sidebar","navigation","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6L5 9L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 6H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "menu-unfold-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["menu","expand","more","options","navigation","show-more","details","unfold","list","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L19 9L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "menu-unfold-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["menu","expand","more","options","navigation","unfold","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6L19 9L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6H5"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H5"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "menu-unfold-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","expand","more","options","unfold","show-more","navigation","next","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2 5.40006C13.8686 5.84189 13.9582 6.46869 14.4 6.80006L17.3333 9.00006L14.4 11.2001C13.9582 11.5314 13.8686 12.1582 14.2 12.6001C14.5314 13.0419 15.1582 13.1314 15.6 12.8001L19.6 9.80006C19.8518 9.6112 20 9.31482 20 9.00006C20 8.6853 19.8518 8.38891 19.6 8.20006L15.6 5.20006C15.1582 4.86869 14.5314 4.95823 14.2 5.40006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 6.00006C4 5.44777 4.44772 5.00006 5 5.00006H11C11.5523 5.00006 12 5.44777 12 6.00006C12 6.55234 11.5523 7.00006 11 7.00006H5C4.44772 7.00006 4 6.55234 4 6.00006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12.0001C4 11.4478 4.44772 11.0001 5 11.0001H11C11.5523 11.0001 12 11.4478 12 12.0001C12 12.5523 11.5523 13.0001 11 13.0001H5C4.44772 13.0001 4 12.5523 4 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 18.0001C4 17.4478 4.44772 17.0001 5 17.0001L19 17.0001C19.5523 17.0001 20 17.4478 20 18.0001C20 18.5523 19.5523 19.0001 19 19.0001L5 19.0001C4.44772 19.0001 4 18.5523 4 18.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "menu-unfold": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","expand","more","options","settings","navigation","submenu","additional-options","show-more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6L19 9L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-caption-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","chat","communication","support","feedback","notes","comments","dialog","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17V17C17 18.2306 17 18.8459 16.6457 19.1455C16.57 19.2095 16.4853 19.2619 16.3942 19.301C15.9678 19.4839 15.4174 19.2087 14.3167 18.6584L11 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 13L17 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-caption-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","chat","comment","feedback","notification","customer-feedback","order-comment","order-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11L14.3167 18.6584C15.4174 19.2087 15.9678 19.4839 16.3942 19.301C16.4853 19.2619 16.57 19.2095 16.6457 19.1455C17 18.8459 17 18.2306 17 17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M11 17L11.3354 16.3292L11.1771 16.25H11V17ZM14.3167 18.6584L13.9813 19.3292L14.3167 18.6584ZM4.87868 16.1213L4.34835 16.6517L4.34835 16.6517L4.87868 16.1213ZM17 17V16.25C16.5858 16.25 16.25 16.5858 16.25 17H17ZM16.6457 19.1455L17.13 19.7182L17.13 19.7182L16.6457 19.1455ZM16.3942 19.301L16.0985 18.6117L16.3942 19.301ZM19.1213 5.87868L19.6517 5.34835L19.6517 5.34835L19.1213 5.87868ZM10 5.75H14V4.25H10V5.75ZM19.25 11V14H20.75V11H19.25ZM11 16.25H10V17.75H11V16.25ZM14.6521 17.9875L11.3354 16.3292L10.6646 17.6708L13.9813 19.3292L14.6521 17.9875ZM3.25 11C3.25 12.393 3.24841 13.5132 3.36652 14.3918C3.48754 15.2919 3.74643 16.0497 4.34835 16.6517L5.40901 15.591C5.13225 15.3142 4.9518 14.9257 4.85315 14.1919C4.75159 13.4365 4.75 12.4354 4.75 11H3.25ZM10 16.25C8.56458 16.25 7.56347 16.2484 6.80812 16.1469C6.07434 16.0482 5.68577 15.8678 5.40901 15.591L4.34835 16.6517C4.95027 17.2536 5.70814 17.5125 6.60825 17.6335C7.48678 17.7516 8.60699 17.75 10 17.75V16.25ZM19.25 14C19.25 15.2426 18.2426 16.25 17 16.25V17.75C19.0711 17.75 20.75 16.0711 20.75 14H19.25ZM16.25 17C16.25 17.6365 16.2485 18.0404 16.2118 18.3264C16.1757 18.608 16.1231 18.6053 16.1614 18.5729L17.13 19.7182C17.5227 19.3861 17.6472 18.926 17.6996 18.5174C17.7515 18.1132 17.75 17.5941 17.75 17H16.25ZM13.9813 19.3292C14.5127 19.5949 14.9763 19.8283 15.361 19.9627C15.7499 20.0985 16.2172 20.193 16.6898 19.9903L16.0985 18.6117C16.1447 18.5919 16.1236 18.6402 15.8556 18.5466C15.5834 18.4515 15.2214 18.2722 14.6521 17.9875L13.9813 19.3292ZM16.1614 18.5729C16.1425 18.5889 16.1213 18.602 16.0985 18.6117L16.6898 19.9903C16.8492 19.9219 16.9976 19.8302 17.13 19.7182L16.1614 18.5729ZM14 5.75C15.4354 5.75 16.4365 5.75159 17.1919 5.85315C17.9257 5.9518 18.3142 6.13225 18.591 6.40901L19.6517 5.34835C19.0497 4.74643 18.2919 4.48754 17.3918 4.36652C16.5132 4.24841 15.393 4.25 14 4.25V5.75ZM20.75 11C20.75 9.60699 20.7516 8.48678 20.6335 7.60825C20.5125 6.70814 20.2536 5.95027 19.6517 5.34835L18.591 6.40901C18.8678 6.68577 19.0482 7.07434 19.1469 7.80812C19.2484 8.56347 19.25 9.56458 19.25 11H20.75ZM10 4.25C8.60699 4.25 7.48678 4.24841 6.60825 4.36652C5.70814 4.48754 4.95027 4.74643 4.34835 5.34835L5.40901 6.40901C5.68577 6.13225 6.07434 5.9518 6.80812 5.85315C7.56347 5.75159 8.56458 5.75 10 5.75V4.25ZM4.75 11C4.75 9.56458 4.75159 8.56347 4.85315 7.80812C4.9518 7.07434 5.13225 6.68577 5.40901 6.40901L4.34835 5.34835C3.74643 5.95027 3.48754 6.70814 3.36652 7.60825C3.24841 8.48678 3.25 9.60699 3.25 11H4.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M13 10H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 13L17 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-caption-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","comment","feedback","notification","customer-support","conversation","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V14C20.75 15.8152 19.4603 17.3292 17.7472 17.6756C17.7426 17.9917 17.7307 18.2752 17.6996 18.5174C17.6472 18.926 17.5227 19.3862 17.13 19.7182C16.9976 19.8302 16.8492 19.9219 16.6898 19.9903C16.2172 20.193 15.7499 20.0985 15.361 19.9627C14.9867 19.832 14.5378 19.6075 14.0243 19.3507L10.823 17.75H9.94512H9.94512C8.57753 17.75 7.47522 17.75 6.60825 17.6335C5.70814 17.5125 4.95027 17.2536 4.34835 16.6517C3.74644 16.0497 3.48754 15.2919 3.36653 14.3918C3.24997 13.5248 3.24998 12.4225 3.25 11.0549V11.0549V10.9451V10.9451C3.24998 9.57752 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57754 4.24998 9.94511 4.25H9.94513ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55229 6.44772 10 7 10H12C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8H7ZM15 8C14.4477 8 14 8.44772 14 9C14 9.55229 14.4477 10 15 10H17C17.5523 10 18 9.55229 18 9C18 8.44772 17.5523 8 17 8H15ZM7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H9C9.55229 14 10 13.5523 10 13C10 12.4477 9.55229 12 9 12H7ZM12 14H17C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12L12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-caption": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","conversation","feedback","comment","notification","customer-service","support","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17V17C17 18.2306 17 18.8459 16.6457 19.1455C16.57 19.2095 16.4853 19.2619 16.3942 19.301C15.9678 19.4839 15.4174 19.2087 14.3167 18.6584L11 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 13L17 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","chat","comment","note","feedback","support","communication","notification","conversation","inquiry","question","dialog","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","comment","feedback","notification","support","communication","customer-support","inquiry","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","comment","feedback","support","conversation","dialog","notification","alert","customer-service","inquiry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0122 4C17.0256 4 18.6774 4 19.8487 5.17L19.8287 5.18C21 6.35 21 8.01 21 11.01V12.01V12.0101C21 13.99 21 15.08 20.4594 16.01C20.109 16.61 19.6085 17.12 18.9978 17.47C18.5473 17.73 18.0367 17.88 17.3359 17.95C16.3148 18.05 15.7041 18.11 15.4438 18.21C15.3537 18.24 15.2937 18.27 15.2036 18.32C14.9733 18.45 14.703 18.72 14.1224 19.3L14.1223 19.3C13.3415 20.08 12.8309 20.59 12 20.59C11.1691 20.59 10.6585 20.08 9.87764 19.3C9.29699 18.71 9.0367 18.45 8.79644 18.32C8.73322 18.2849 8.68479 18.2646 8.6304 18.2418C8.60727 18.2321 8.58306 18.2219 8.55618 18.21C8.30061 18.1118 7.69759 18.0522 6.71869 17.9554L6.66408 17.95C5.95329 17.88 5.44272 17.73 4.99222 17.47C4.39155 17.11 3.88098 16.61 3.53059 16C3 15.07 3 13.98 3 12V11C3 8 3 6.34 4.1713 5.17C5.3426 4 7.00445 4 10.0078 4H14.0122ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H15C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H9ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-chat v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","conversation","comment","note","feedback","customer-support","notification","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","chat","comment","feedback","note","notification","customer-service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","chat","communication","customer-service","feedback","support","notes","comments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","communication","customer-service","support","feedback","inquiry","conversation","comment","notes","assistance","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17 4 14 4H10C7 4 5.34 4 4.17 5.17C3 6.34 3 8 3 11V12C3 13.98 3 15.07 3.54 16C3.89 16.61 4.4 17.11 5 17.46C5.45 17.72 5.96 17.87 6.67 17.94C7.68 18.04 8.3 18.1 8.56 18.2C8.65 18.24 8.71 18.26 8.8 18.31C9.04 18.45 9.32 18.72 9.88 19.29C10.66 20.07 11.17 20.58 12 20.58C12.83 20.58 13.34 20.07 14.13 19.28C14.69 18.72 14.96 18.44 15.21 18.31C15.3 18.26 15.36 18.23 15.45 18.2C15.71 18.1 16.32 18.04 17.34 17.94C18.04 17.87 18.55 17.72 19 17.46C19.61 17.11 20.11 16.6 20.46 16C21 15.07 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM14 14H10C9.45 14 9 13.55 9 13C9 12.45 9.45 12 10 12H14C14.55 12 15 12.45 15 13C15 13.55 14.55 14 14 14ZM14 10H10C9.45 10 9 9.55 9 9C9 8.45 9.45 8 10 8H14C14.55 8 15 8.45 15 9C15 9.55 14.55 10 14 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-chat-start-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","minus","subtract","decrease","remove","discount","reduce","conversation","delete","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat-start-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","chat","remove","minus","decrease","reduce","discount","delete-message","remove-item","chat-bubble"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat-start-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","minus","remove","decrease","delete","chat-remove","message-remove","discount","remove-item","chat-bubble"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.8487 5.17141C18.6774 4 17.0256 4 14.0122 4H10.0078C7.00445 4 5.3426 4 4.1713 5.17141C3 6.34282 3 8.00482 3 11.0084V12.0096C3 13.992 3 15.0833 3.53059 16.0145C3.88098 16.6252 4.39155 17.1258 4.99222 17.4862C5.44272 17.7466 5.95329 17.8967 6.66408 17.9668C7.6752 18.0669 8.29589 18.127 8.55618 18.2271C8.64628 18.2672 8.70634 18.2872 8.79644 18.3373C9.0367 18.4674 9.29699 18.7277 9.87764 19.3184C10.6585 20.0994 11.1691 20.61 12 20.61C12.8309 20.61 13.3415 20.0994 14.1224 19.3184C14.703 18.7377 14.9733 18.4674 15.2036 18.3373C15.2937 18.2872 15.3537 18.2572 15.4438 18.2271C15.7041 18.127 16.3148 18.0669 17.3359 17.9668C18.0367 17.8967 18.5473 17.7466 18.9978 17.4862C19.6085 17.1358 20.109 16.6252 20.4594 16.0245C21 15.0934 21 14.002 21 12.0197V11.0185C21 8.01483 21 6.35283 19.8287 5.18142L19.8487 5.17141ZM14.0122 12.0096H10.0078C9.45718 12.0096 9.00668 11.5591 9.00668 11.0084C9.00668 10.4578 9.45718 10.0072 10.0078 10.0072H14.0122C14.5628 10.0072 15.0134 10.4578 15.0134 11.0084C15.0134 11.5591 14.5628 12.0096 14.0122 12.0096Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-chat-start": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","remove","minus","delete","subtract","decrease","reduce","minimize","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-chat": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","chat","comment","feedback","note","customer-service","support","notification","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","cross","cancel","remove","delete","error","warning","alert","notification","reject","close","dismiss","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9L14 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","cancel","remove","delete","notification","error","alert","close","cross","dismiss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9L14 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","cross","cancel","delete","remove","notification-remove","alert-remove","error","warning","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7 4 5.34 4 4.17 5.17C3 6.34 3 8 3 11V12C3 13.98 3 15.07 3.53 16C3.88 16.61 4.39001 17.11 4.99001 17.47C5.44001 17.73 5.95 17.88 6.66 17.95C7.67 18.05 8.29 18.11 8.55 18.21C8.64 18.25 8.69999 18.27 8.78999 18.32C9.02999 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM14.71 12.29C15.1 12.68 15.1 13.31 14.71 13.7C14.51 13.9 14.26 13.99 14 13.99C13.74 13.99 13.49 13.89 13.29 13.7L12 12.41L10.71 13.7C10.51 13.9 10.26 13.99 10 13.99C9.74 13.99 9.48999 13.89 9.28999 13.7C8.89999 13.31 8.89999 12.68 9.28999 12.29L10.58 11L9.28999 9.71C8.89999 9.32 8.89999 8.69 9.28999 8.3C9.67999 7.91 10.31 7.91 10.7 8.3L11.99 9.59L13.28 8.3C13.67 7.91 14.3 7.91 14.69 8.3C15.08 8.69 15.08 9.32 14.69 9.71L13.4 11L14.69 12.29H14.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","cross","cancel","notification","error","remove","delete","void","reject","decline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9L10 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9L14 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "message-o-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","notification","alert","communication","chat","feedback","support","comment","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "message-o-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","chat","notification","bubble","info","alert","dialog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "message-o-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","notification","chat","alert","info","customer-feedback","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7 4 5.34001 4 4.17001 5.17C3.00001 6.34 3 8 3 11V12C3 13.98 3 15.07 3.53 16C3.88 16.61 4.38999 17.11 4.98999 17.47C5.43999 17.73 5.95 17.88 6.66 17.95C7.67 18.05 8.28999 18.11 8.54999 18.21C8.63999 18.25 8.70001 18.27 8.79001 18.32C9.03001 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM12 15C9.79 15 8 13.21 8 11C8 8.79 9.79 7 12 7C14.21 7 16 8.79 16 11C16 13.21 14.21 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "message-o": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","comment","notification","alert","communication","feedback","support","chat","dialog","bubble","information","announcement","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "message-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","add","plus","new-message","add-message","notification","new-notification","add-notification","create","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "message-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","add","plus","new","create","notification","alert","add-message","new-message"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.8487 6.1713C18.6774 5 17.0256 5 14.0122 5H10.0078C7.00445 5 5.3426 5 4.1713 6.1713C3 7.3426 3 9.00445 3 12.0078V13.0089C3 14.9911 3 16.0823 3.53059 17.0134C3.88098 17.624 4.39155 18.1246 4.99222 18.485C5.44272 18.7453 5.95329 18.8954 6.66408 18.9655C7.6752 19.0656 8.29589 19.1257 8.55618 19.2258C8.64628 19.2659 8.70634 19.2859 8.79644 19.3359C9.0367 19.4661 9.29699 19.7264 9.87764 20.317C10.6585 21.0979 11.1691 21.6085 12 21.6085C12.8309 21.6085 13.3415 21.0979 14.1224 20.317C14.703 19.7364 14.9733 19.4661 15.2036 19.3359C15.2937 19.2859 15.3537 19.2558 15.4438 19.2258C15.7041 19.1257 16.3148 19.0656 17.3359 18.9655C18.0367 18.8954 18.5473 18.7453 18.9978 18.485C19.6085 18.1346 20.109 17.624 20.4594 17.0234C21 16.0923 21 14.9833 21 13.0011V12C21 8.99666 21.02 7.3426 19.8487 6.1713ZM14.0122 13.0089H13.0111V14.01C13.0111 14.5606 12.5606 15.0111 12.01 15.0111C11.4594 15.0111 11.0089 14.5606 11.0089 14.01V13.0089H10.0078C9.45718 13.0089 9.00668 12.5584 9.00668 12.0078C9.00668 11.4572 9.45718 11.0067 10.0078 11.0067H11.0089V10.0056C11.0089 9.45495 11.4594 9.00445 12.01 9.00445C12.5606 9.00445 13.0111 9.45495 13.0111 10.0056V11.0067H14.0122C14.5628 11.0067 15.0134 11.4572 15.0134 12.0078C15.0134 12.5584 14.5628 13.0089 14.0122 13.0089Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "message-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","add","plus","notification","alert","new-message","add-message","add-notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "message-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","add-message","chat","add-chat","plus","add","new","notification","add-notification","comment","add-comment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9L12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-question-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["help","question","support","faq","customer-service","inquiry","information","assistance","question-mark","message","chat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.0924C10 8.93679 10.8954 8 12 8C13.1046 8 14 8.93679 14 10.0924C14 11.248 13.1046 12.1848 12 12.1848V12.7935M12 14.163L12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-question-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["help","question","support","faq","query","assistance","information","details","request","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.0924C10 8.93679 10.8954 8 12 8C13.1046 8 14 8.93679 14 10.0924C14 11.248 13.1046 12.1848 12 12.1848V12.7935M12 14.163L12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-question-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","query","information","assistance","inquiry","unknown","doubt","uncertainty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17.01 4 14 4H10C7.00001 4 5.34001 4 4.17001 5.17C3.00002 6.34 3 8 3 11V12C3 13.98 3 15.07 3.53 16C3.88 16.61 4.38999 17.11 4.98999 17.47C5.43999 17.73 5.95001 17.88 6.66 17.95C7.67 18.05 8.28999 18.11 8.54999 18.21C8.63999 18.25 8.70001 18.27 8.79001 18.32C9.03001 18.45 9.29 18.71 9.87 19.3C10.65 20.08 11.16 20.59 11.99 20.59C12.82 20.59 13.33 20.08 14.11 19.3C14.69 18.72 14.96 18.45 15.19 18.32C15.28 18.27 15.34 18.24 15.43 18.21C15.69 18.11 16.3 18.05 17.32 17.95C18.02 17.88 18.53 17.73 18.98 17.47C19.59 17.12 20.09 16.61 20.44 16.01C20.98 15.08 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM13 14.92C13 15.47 12.55 15.92 12 15.92C11.45 15.92 11 15.47 11 14.92V14.55C11 14 11.45 13.55 12 13.55C12.55 13.55 13 14 13 14.55V14.92ZM12.97 12.4C12.87 12.84 12.47 13.18 12 13.18C11.45 13.18 11 12.73 11 12.18V11.57C11 11.02 11.45 10.57 12 10.57C12.55 10.57 13 10.08 13 9.48C13 8.88 12.55 8.39 12 8.39C11.45 8.39 11 8.88 11 9.48C11 10.03 10.55 10.48 10 10.48C9.45 10.48 9 10.03 9 9.48C9 7.77 10.35 6.39 12 6.39C13.65 6.39 15 7.78 15 9.48C15 10.83 14.15 11.99 12.97 12.41V12.4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-question": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","query","information","assistance","uncertainty","problem","troubleshooting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10.0924C10 8.93679 10.8954 8 12 8C13.1046 8 14 8.93679 14 10.0924C14 11.248 13.1046 12.1848 12 12.1848V12.7935M12 14.163L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["message","tick","check","confirmation","verified","success","notification","approved","completed","order-confirmed","payment-received","transaction-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L15 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["message","tick","check","confirmation","order-confirmation","payment-confirmation","verified","approved","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C5.83717 16.7927 6.23028 16.8931 6.75843 16.9449L6.75845 16.9449C7.93889 17.0606 8.52911 17.1184 8.9179 17.2712C9.0607 17.3273 9.14783 17.3685 9.28184 17.4432C9.64668 17.6467 9.95971 17.9597 10.5858 18.5858L10.5858 18.5858L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858C14.0403 17.9597 14.3533 17.6467 14.7182 17.4432C14.8522 17.3685 14.9393 17.3273 15.0821 17.2712C15.4709 17.1184 16.0611 17.0606 17.2416 16.9449C17.7697 16.8931 18.1628 16.7927 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Message-tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","tick","chat","bubble","check","checkmark","confirmed","verified","approved","confirmation","notification","alert","success"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.83 5.17C18.66 4 17 4 14 4H10C7 4 5.34 4 4.17 5.17C3 6.34 3 8 3 11V12C3 13.98 3 15.07 3.54 16C3.89 16.61 4.4 17.11 5 17.46C5.45 17.72 5.96 17.87 6.67 17.94C7.68 18.04 8.3 18.1 8.56 18.2C8.65 18.24 8.71 18.26 8.8 18.31C9.04 18.45 9.32 18.72 9.88 19.29C10.66 20.07 11.17 20.58 12 20.58C12.83 20.58 13.34 20.07 14.13 19.28C14.69 18.72 14.96 18.44 15.21 18.31C15.3 18.26 15.36 18.23 15.45 18.2C15.71 18.1 16.32 18.04 17.34 17.94C18.04 17.87 18.55 17.72 19 17.46C19.61 17.11 20.11 16.6 20.46 16C21 15.07 21 13.98 21 12V11C21 8 21 6.34 19.83 5.17ZM15.71 9.71L11.71 13.71C11.51 13.91 11.26 14 11 14C10.74 14 10.49 13.9 10.29 13.71L9.29 12.71C8.9 12.32 8.9 11.69 9.29 11.3C9.68 10.91 10.31 10.91 10.7 11.3L10.99 11.59L14.28 8.3C14.67 7.91 15.3 7.91 15.69 8.3C16.08 8.69 16.08 9.32 15.69 9.71H15.71Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Message-tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["message","tick","confirmation","check","approved","success","valid","order-confirmation","payment-received","status-update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17V17C16.8692 17 17.8038 17 18.5 16.5981C18.9561 16.3348 19.3348 15.9561 19.5981 15.5C20 14.8038 20 13.8692 20 12V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V12C4 13.8692 4 14.8038 4.40192 15.5C4.66523 15.9561 5.04394 16.3348 5.5 16.5981C6.19615 17 7.13077 17 9 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L11 13L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "messenger-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","message","messenger","communication","support","customer-service","contact","feedback","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17.5522C15.726 17.6804 18.8568 14.8742 19 11.2782C18.8568 7.68215 15.726 4.87601 12 5.00422C8.27403 4.87601 5.14315 7.68215 5 11.2782C5.01666 13.1792 5.95114 14.9639 7.527 16.1043L7.5 19L10.5 17.4074C10.9937 17.5038 11.4962 17.5523 12 17.5522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L13 13L11 10L9 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "messenger-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","messenger","communication","support","customer-service","notifications","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17.5522C15.726 17.6804 18.8568 14.8742 19 11.2782C18.8568 7.68215 15.726 4.87601 12 5.00422C8.27403 4.87601 5.14315 7.68215 5 11.2782C5.01666 13.1792 5.95114 14.9639 7.527 16.1043L7.5 19L10.5 17.4074C10.9937 17.5038 11.4962 17.5523 12 17.5522Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L13 13L11 10L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "messenger-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","support","customer service","feedback","inquiry","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4.00369C16.2277 3.87612 19.8333 7.07123 19.9992 11.2384C20.0003 11.2649 20.0003 11.2914 19.9992 11.318C19.8331 15.4907 16.2181 18.6888 11.983 18.5521C11.542 18.5514 11.1019 18.5176 10.6665 18.4511L7.9689 19.8832C7.65748 20.0486 7.28201 20.0377 6.98069 19.8546C6.67938 19.6715 6.49676 19.3432 6.50004 18.9907L6.52245 16.5879C4.94853 15.2641 4.01802 13.3386 4.00004 11.2869C3.9999 11.2708 4.00015 11.2546 4.00079 11.2384C4.16668 7.07123 7.77226 3.87612 12 4.00369ZM15.8322 10.5548C16.1385 10.0953 16.0143 9.47441 15.5548 9.16806C15.0953 8.8617 14.4744 8.98588 14.1681 9.44541L13.0001 11.1973L11.8322 9.44541C11.6467 9.16721 11.3345 9.00011 11.0001 9.00011C10.6658 9.00011 10.3535 9.16721 10.1681 9.44541L8.16806 12.4454C7.8617 12.9049 7.98588 13.5258 8.44541 13.8322C8.90493 14.1385 9.5258 14.0143 9.83216 13.5548L11.0001 11.8029L12.1681 13.5548C12.3535 13.833 12.6658 14.0001 13.0001 14.0001C13.3345 14.0001 13.6467 13.833 13.8322 13.5548L15.8322 10.5548Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    messenger: {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","support","customer service","feedback","inquiry","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17.5522C15.726 17.6804 18.8568 14.8742 19 11.2782C18.8568 7.68215 15.726 4.87601 12 5.00422C8.27403 4.87601 5.14315 7.68215 5 11.2782C5.01666 13.1792 5.95114 14.9639 7.527 16.1043L7.5 19L10.5 17.4074C10.9937 17.5038 11.4962 17.5523 12 17.5522Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L13 13L11 10L9 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mic-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["microphone","mic","voice","audio","speak","voice-command","voice-input"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["microphone","mic","voice","audio","record","input","sound","speak","dictate","notes","comments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="8"
                    y="4"
                    width="8"
                    height="12"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 9V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","mic","voice","audio","input","record","assistance","voice-command","speak"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C9.23858 3 7 5.23858 7 8V12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12V8C17 5.23858 14.7614 3 12 3ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11C11 11.5523 11.4477 12 12 12C12.5523 12 13 11.5523 13 11V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 16.0796 7.05369 19.446 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.9381C16.9463 19.446 20 16.0796 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Mic-record-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["microphone","mic","voice-command","audio","dictation","notes","voice-input","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 8H16M14 12H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic-record-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["microphone","mic","voice-command","audio","voice","record","speak","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="8"
                    y="4"
                    width="8"
                    height="12"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M14 8H16M14 12H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic-record-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","mic","audio","record","voice","note","memo","communication","assistance","voice-command"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 11.45 5.55 11 5 11C4.45 11 4 11.45 4 12C4 16.08 7.05 19.45 11 19.94V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V19.94C16.95 19.45 20 16.08 20 12C20 11.45 19.55 11 19 11C18.45 11 18 11.45 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12V8ZM13 7C12.4477 7 12 7.44772 12 8C12 8.55228 12.4477 9 13 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H13ZM13 11C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Mic-record": {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","record","voice","audio","sound","order","voice-order","record-order","special-request","customer-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 8H16M14 12H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Mic: {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","record","voice","audio","sound","order","voice-order","record-order","special-request","customer-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mickey-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["loyalty","rewards","customer","profile","avatar","account","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 7C3 5.34315 4.34315 4 6 4C7.65685 4 9 5.34315 9 7C9 8.65685 7.65685 10 6 10C4.34315 10 3 8.65685 3 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.34315 16.3431 4 18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mickey-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["customer","profile","account","loyalty","member","entertainment","children","kids"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 7C3 5.34315 4.34315 4 6 4C7.65685 4 9 5.34315 9 7C9 8.65685 7.65685 10 6 10C4.34315 10 3 8.65685 3 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.34315 16.3431 4 18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mickey-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mickey","mouse","character","loyalty","member","rewards","theme-park","entertainment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 3.25C3.92893 3.25 2.25 4.92893 2.25 7C2.25 9.07107 3.92893 10.75 6 10.75C6.02773 10.75 6.05539 10.7497 6.08298 10.7491C5.55206 11.7134 5.25 12.8214 5.25 14C5.25 17.7279 8.27208 20.75 12 20.75C15.7279 20.75 18.75 17.7279 18.75 14C18.75 12.8214 18.4479 11.7134 17.917 10.7491C17.9446 10.7497 17.9723 10.75 18 10.75C20.0711 10.75 21.75 9.07107 21.75 7C21.75 4.92893 20.0711 3.25 18 3.25C15.9289 3.25 14.25 4.92893 14.25 7C14.25 7.22326 14.2695 7.44196 14.3069 7.6545C13.5871 7.39276 12.8102 7.25 12 7.25C11.1898 7.25 10.4129 7.39276 9.69308 7.6545C9.73049 7.44196 9.75 7.22326 9.75 7C9.75 4.92893 8.07107 3.25 6 3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "microchip-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["microchip","chip","processing","cpu","technical","technology","hardware","system","component","circuit","device","electronics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="6" width="12" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="9" y="9" width="6" height="6" rx="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M5 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "microchip-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["microchip","chip","technology","processor","hardware","component","circuit","system","machine","tech"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect
                    x="6"
                    y="6"
                    width="12"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="9"
                    y="9"
                    width="6"
                    height="6"
                    rx="1"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    mickey: {
        defaultColors: ["#3D4C66"],
        keywords: ["microchip","chip","technology","processor","hardware","component","circuit","system","machine","tech"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 7C3 5.34315 4.34315 4 6 4C7.65685 4 9 5.34315 9 7C9 8.65685 7.65685 10 6 10C4.34315 10 3 8.65685 3 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.34315 16.3431 4 18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "microchip-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["microchip","cpu","processor","technology","electronics","component","inventory","system","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 4C14.5523 4 15 4.44772 15 5V5.07187C15.1472 5.08497 15.2889 5.10045 15.4251 5.11876C16.3529 5.2435 17.1723 5.51547 17.8284 6.17158C18.4845 6.82769 18.7565 7.64711 18.8813 8.57494C18.8996 8.7111 18.915 8.85278 18.9281 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H18.9984C19 11.2963 19 11.6061 19 11.9294V12.0706C19 12.3939 19 12.7037 18.9984 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H18.9281C18.915 15.1472 18.8996 15.2889 18.8813 15.4251C18.7565 16.3529 18.4845 17.1723 17.8284 17.8284C17.1723 18.4845 16.3529 18.7565 15.4251 18.8813C15.2889 18.8996 15.1472 18.915 15 18.9281V19C15 19.5523 14.5523 20 14 20C13.4477 20 13 19.5523 13 19V18.9984C12.7037 19 12.3939 19 12.0706 19H11.9294C11.6061 19 11.2963 19 11 18.9984V19C11 19.5523 10.5523 20 10 20C9.44772 20 9 19.5523 9 19V18.9281C8.85278 18.915 8.7111 18.8996 8.57494 18.8813C7.64711 18.7565 6.82769 18.4845 6.17158 17.8284C5.51547 17.1723 5.2435 16.3529 5.11876 15.4251C5.10045 15.2889 5.08497 15.1472 5.07187 15H5C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13H5.0016C4.99999 12.7037 4.99999 12.3939 5 12.0706V11.9294C4.99999 11.6061 4.99999 11.2963 5.0016 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H5.07187C5.08497 8.85278 5.10045 8.71109 5.11876 8.57494C5.2435 7.64711 5.51547 6.82769 6.17158 6.17158C6.82769 5.51547 7.64711 5.2435 8.57494 5.11876C8.71109 5.10045 8.85277 5.08497 9 5.07187V5C9 4.44772 9.44772 4 10 4C10.5523 4 11 4.44772 11 5V5.0016C11.2963 4.99999 11.6061 4.99999 11.9294 5H12.0706C12.3939 4.99999 12.7037 4.99999 13 5.0016V5C13 4.44772 13.4477 4 14 4ZM10.9456 8.00001C10.5215 7.99993 10.1094 7.99984 9.7695 8.04554C9.38629 8.09706 8.94902 8.22259 8.5858 8.5858C8.22259 8.94902 8.09706 9.38629 8.04554 9.7695C7.99984 10.1094 7.99993 10.5215 8.00001 10.9456V13.0544C7.99993 13.4785 7.99984 13.8906 8.04554 14.2305C8.09706 14.6137 8.22259 15.051 8.5858 15.4142C8.94902 15.7774 9.38629 15.903 9.7695 15.9545C10.1094 16.0002 10.5215 16.0001 10.9456 16H13.0544C13.4785 16.0001 13.8906 16.0002 14.2305 15.9545C14.6137 15.903 15.051 15.7774 15.4142 15.4142C15.7774 15.051 15.903 14.6137 15.9545 14.2305C16.0002 13.8906 16.0001 13.4785 16 13.0544V10.9456C16.0001 10.5215 16.0002 10.1094 15.9545 9.7695C15.903 9.38629 15.7774 8.94902 15.4142 8.5858C15.051 8.22259 14.6137 8.09706 14.2305 8.04554C13.8906 7.99984 13.4785 7.99993 13.0544 8.00001H10.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    microchip: {
        defaultColors: ["#3D4C66"],
        keywords: ["microchip","cpu","processor","technology","electronics","component","inventory","system","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="6" width="12" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="9" y="9" width="6" height="6" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 10L18 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 19L10 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 19L14 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 5L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 5L10 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic_off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["microphone","mic","mute","disabled","audio-off","audio","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="8"
                    y="4"
                    width="8"
                    height="12"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 20L19 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic_off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["microphone","mic","off","mute","audio","disabled","no-audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 20L19 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mic_off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","mute","mic-off","audio","disable","no-sound","settings","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8C7 5.23858 9.23858 3 12 3C14.0508 3 15.8132 4.23469 16.5845 6.00127L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L5.68014 16.9056C4.62708 15.551 4 13.8487 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12C6 13.2958 6.41079 14.4957 7.10925 15.4765L7.8284 14.7574C7.30488 13.967 7 13.0191 7 12V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.3421 16.7186L17 10.0607V12C17 14.7614 14.7614 17 12 17C11.4189 17 10.8609 16.9009 10.3421 16.7186Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.57216 17.4885L8.08336 18.9773C8.96549 19.4735 9.95122 19.8073 11 19.9381V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19.9381C16.9463 19.446 20 16.0796 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 15.3137 15.3137 18 12 18C11.1359 18 10.3144 17.8173 9.57216 17.4885Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Mic_off: {
        defaultColors: ["#3D4C66"],
        keywords: ["microphone","mute","mic-off","audio","disable","no-sound","settings","privacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="12" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 20L19 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mill-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["discount","remove-discount","markdown","price-reduction","sale","cancel","void","delete","crossed-out","slash","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16L12 11C12 9.34315 13.3431 8 15 8V8C16.6569 8 18 9.34315 18 11L18 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 16L6 11C6 9.34315 7.34315 8 9 8V8C10.6569 8 12 9.34315 12 11L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 11L6 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18L14 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mill-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["discount","coupon","markdown","sale","price-reduction","promotion","special-offer","reduced-price","price-cut"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16L12 11C12 9.34315 13.3431 8 15 8V8C16.6569 8 18 9.34315 18 11L18 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 16L6 11C6 9.34315 7.34315 8 9 8V8C10.6569 8 12 9.34315 12 11L12 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 11L6 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18L14 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mill-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","coupon","promotion","sale","price-cut","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9898 7.11993C15.9898 7.17993 15.9698 7.24993 15.9498 7.30993L15.3798 9.02993C16.3098 9.20993 16.9998 10.0199 16.9998 10.9899V15.9899C16.9998 16.5399 17.4498 16.9899 17.9998 16.9899C18.5498 16.9899 18.9998 16.5399 18.9998 15.9899V10.9999C18.9998 9.12993 17.7198 7.56993 15.9898 7.11993Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.3198 5.04993C13.7998 4.87993 13.2298 5.15993 13.0598 5.67993L12.2498 8.10993C12.1698 8.18993 12.0798 8.25993 12.0098 8.34993C11.2798 7.51993 10.1998 6.99993 9.00977 6.99993C8.27977 6.99993 7.59977 7.18993 7.00977 7.53993V6.99993C7.00977 6.44993 6.55977 5.99993 6.00977 5.99993C5.45977 5.99993 5 6.44993 5 6.99993L5.00977 15.9999C5.00977 16.5499 5.45977 16.9999 6.00977 16.9999C6.55977 16.9999 7.00977 16.5499 7.00977 15.9999V10.9999C7.00977 9.89993 7.90977 8.99993 9.00977 8.99993C10.1098 8.99993 11.0098 9.89993 11.0098 10.9999V11.8399L9.05977 17.6899C8.88977 18.2099 9.16977 18.7799 9.68977 18.9499C10.2098 19.1199 10.7798 18.8399 10.9498 18.3199L14.9498 6.31993C15.1198 5.79993 14.8398 5.22993 14.3198 5.05993V5.04993Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mill-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["money","currency","transaction","payment","finance","cash","discount","sale","price","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16L12 11C12 9.34315 13.3431 8 15 8V8C16.6569 8 18 9.34315 18 11L18 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 16L6 11C6 9.34315 7.34315 8 9 8V8C10.6569 8 12 9.34315 12 11L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 11L6 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18L14 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "minimize-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["minimize","reduce","shrink","collapse","close","exit","remove","dismiss","cancel","hide","retract","compress","screen-size","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.453 13.2861H14.7555C13.944 13.2861 13.2861 13.944 13.2861 14.7555V17.453C13.2861 18.7621 14.8689 19.4177 15.7945 18.492L18.492 15.7945C19.4177 14.8689 18.7621 13.2861 17.453 13.2861Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 17.3269L21.0006 21.0004"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2861 6.54749L13.2861 9.24497C13.2861 10.0565 13.944 10.7144 14.7555 10.7144L17.453 10.7144C18.7621 10.7144 19.4177 9.13161 18.492 8.20595L15.7945 5.50847C14.8689 4.58281 13.2861 5.2384 13.2861 6.54749Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 6.67358L21.0006 3.00011"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.547 13.2861H9.24448C10.056 13.2861 10.7139 13.944 10.7139 14.7555V17.453C10.7139 18.7621 9.13113 19.4177 8.20546 18.492L5.50798 15.7945C4.58232 14.8689 5.23792 13.2861 6.547 13.2861Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 17.3269L2.99938 21.0004"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.7139 6.54749L10.7139 9.24497C10.7139 10.0565 10.056 10.7144 9.24448 10.7144L6.547 10.7144C5.23791 10.7144 4.58232 9.13161 5.50799 8.20595L8.20547 5.50847C9.13113 4.58281 10.7139 5.2384 10.7139 6.54749Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 6.67358L2.99938 3.00011"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "minimize-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["minimize","shrink","collapse","reduce","close","compress","consolidate","decrease","detach","downsize","contract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.453 13.2861H14.7555C13.944 13.2861 13.2861 13.944 13.2861 14.7555V17.453C13.2861 18.7621 14.8689 19.4177 15.7945 18.492L18.492 15.7945C19.4177 14.8689 18.7621 13.2861 17.453 13.2861Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 17.3269L21.0006 21.0004"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2861 6.54749L13.2861 9.24497C13.2861 10.0565 13.944 10.7144 14.7555 10.7144L17.453 10.7144C18.7621 10.7144 19.4177 9.13161 18.492 8.20595L15.7945 5.50847C14.8689 4.58281 13.2861 5.2384 13.2861 6.54749Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 6.67358L21.0006 3.00011"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.547 13.2861H9.24448C10.056 13.2861 10.7139 13.944 10.7139 14.7555V17.453C10.7139 18.7621 9.13113 19.4177 8.20546 18.492L5.50798 15.7945C4.58232 14.8689 5.23792 13.2861 6.547 13.2861Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 17.3269L2.99938 21.0004"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.7139 6.54749L10.7139 9.24497C10.7139 10.0565 10.056 10.7144 9.24448 10.7144L6.547 10.7144C5.23791 10.7144 4.58232 9.13161 5.50799 8.20595L8.20547 5.50847C9.13113 4.58281 10.7139 5.2384 10.7139 6.54749Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 6.67358L2.99938 3.00011"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "minimize-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","shrink","reduce","collapse","contract","arrows-inward","less","decrease-size","exit-fullscreen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.26931 11C10.2251 11 11 10.2252 11 9.26933V4.73416C11 3.19229 9.1358 2.42011 8.04553 3.51038L6.47732 5.0786C6.44829 5.03949 6.41605 5.00202 6.38058 4.96655L2.70711 1.29308C2.31658 0.902552 1.68342 0.902552 1.29289 1.29308C0.902369 1.6836 0.902369 2.31677 1.29289 2.70729L4.96636 6.38076C5.00183 6.41623 5.0393 6.44848 5.07841 6.4775L3.51037 8.04555C2.42009 9.13582 3.19228 11 4.73414 11L9.26931 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.26931 11C10.2251 11 11 10.2252 11 9.26933V4.73416C11 3.19229 9.1358 2.42011 8.04553 3.51038L6.47732 5.0786C6.44829 5.03949 6.41605 5.00202 6.38058 4.96655L2.70711 1.29308C2.31658 0.902552 1.68342 0.902552 1.29289 1.29308C0.902369 1.6836 0.902369 2.31677 1.29289 2.70729L4.96636 6.38076C5.00183 6.41623 5.0393 6.44848 5.07841 6.4775L3.51037 8.04555C2.42009 9.13582 3.19228 11 4.73414 11L9.26931 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7307 10.9998C13.7749 10.9998 13 10.225 13 9.26914V4.73398C13 3.1921 14.8642 2.41993 15.9545 3.5102L17.5227 5.07841C17.5517 5.0393 17.584 5.00183 17.6194 4.96636L21.2929 1.29289C21.6834 0.902369 22.3166 0.902369 22.7071 1.29289C23.0976 1.68342 23.0976 2.31658 22.7071 2.70711L19.0336 6.38058C18.9982 6.41605 18.9607 6.44829 18.9216 6.47732L20.4896 8.04537C21.5799 9.13564 20.8077 10.9998 19.2659 10.9998L14.7307 10.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7307 10.9998C13.7749 10.9998 13 10.225 13 9.26914V4.73398C13 3.1921 14.8642 2.41993 15.9545 3.5102L17.5227 5.07841C17.5517 5.0393 17.584 5.00183 17.6194 4.96636L21.2929 1.29289C21.6834 0.902369 22.3166 0.902369 22.7071 1.29289C23.0976 1.68342 23.0976 2.31658 22.7071 2.70711L19.0336 6.38058C18.9982 6.41605 18.9607 6.44829 18.9216 6.47732L20.4896 8.04537C21.5799 9.13564 20.8077 10.9998 19.2659 10.9998L14.7307 10.9998Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7307 13C13.7749 13 13 13.7748 13 14.7307L13 19.2658C13 20.8077 14.8642 21.5799 15.9545 20.4896L17.5227 18.9214C17.5517 18.9605 17.584 18.998 17.6194 19.0335L21.2929 22.7069C21.6834 23.0974 22.3166 23.0974 22.7071 22.7069C23.0976 22.3164 23.0976 21.6832 22.7071 21.2927L19.0337 17.6192C18.9982 17.5838 18.9607 17.5515 18.9216 17.5225L20.4897 15.9544C21.5799 14.8642 20.8077 13 19.2659 13L14.7307 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7307 13C13.7749 13 13 13.7748 13 14.7307L13 19.2658C13 20.8077 14.8642 21.5799 15.9545 20.4896L17.5227 18.9214C17.5517 18.9605 17.584 18.998 17.6194 19.0335L21.2929 22.7069C21.6834 23.0974 22.3166 23.0974 22.7071 22.7069C23.0976 22.3164 23.0976 21.6832 22.7071 21.2927L19.0337 17.6192C18.9982 17.5838 18.9607 17.5515 18.9216 17.5225L20.4897 15.9544C21.5799 14.8642 20.8077 13 19.2659 13L14.7307 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.26931 13.0002C10.2251 13.0002 11 13.775 11 14.7309L11 19.266C11 20.8079 9.1358 21.5801 8.04553 20.4898L6.47732 18.9216C6.44829 18.9607 6.41605 18.9982 6.38058 19.0336L2.70711 22.7071C2.31658 23.0976 1.68342 23.0976 1.29289 22.7071C0.902369 22.3166 0.902369 21.6834 1.29289 21.2929L4.96636 17.6194C5.00183 17.584 5.0393 17.5517 5.07841 17.5227L3.51037 15.9546C2.4201 14.8644 3.19228 13.0002 4.73415 13.0002H9.26931Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.26931 13.0002C10.2251 13.0002 11 13.775 11 14.7309L11 19.266C11 20.8079 9.1358 21.5801 8.04553 20.4898L6.47732 18.9216C6.44829 18.9607 6.41605 18.9982 6.38058 19.0336L2.70711 22.7071C2.31658 23.0976 1.68342 23.0976 1.29289 22.7071C0.902369 22.3166 0.902369 21.6834 1.29289 21.2929L4.96636 17.6194C5.00183 17.584 5.0393 17.5517 5.07841 17.5227L3.51037 15.9546C2.4201 14.8644 3.19228 13.0002 4.73415 13.0002H9.26931Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    minimize: {
        defaultColors: ["#3D4C66"],
        keywords: ["minimize","shrink","reduce","collapse","contract","arrows-inward","less","decrease-size","exit-fullscreen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.453 13.2861H14.7555C13.944 13.2861 13.2861 13.944 13.2861 14.7555V17.453C13.2861 18.7621 14.8689 19.4177 15.7945 18.492L18.492 15.7945C19.4177 14.8689 18.7621 13.2861 17.453 13.2861Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 17.3269L21.0006 21.0004"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2861 6.54749L13.2861 9.24497C13.2861 10.0565 13.944 10.7144 14.7555 10.7144L17.453 10.7144C18.7621 10.7144 19.4177 9.13161 18.492 8.20595L15.7945 5.50847C14.8689 4.58281 13.2861 5.2384 13.2861 6.54749Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3271 6.67358L21.0006 3.00011"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.547 13.2861H9.24448C10.056 13.2861 10.7139 13.944 10.7139 14.7555V17.453C10.7139 18.7621 9.13113 19.4177 8.20546 18.492L5.50798 15.7945C4.58232 14.8689 5.23792 13.2861 6.547 13.2861Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 17.3269L2.99938 21.0004"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.7139 6.54749L10.7139 9.24497C10.7139 10.0565 10.056 10.7144 9.24448 10.7144L6.547 10.7144C5.23791 10.7144 4.58232 9.13161 5.50799 8.20595L8.20547 5.50847C9.13113 4.58281 10.7139 5.2384 10.7139 6.54749Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.67285 6.67358L2.99938 3.00011"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "minus-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","subtract","remove","decrease","reduce","discount","delete","less","quantity","decrease-quantity","reduce-quantity","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "minus-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["minus","subtract","remove","decrease","quantity","discount","reduce","delete","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H16" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","subtract","remove","decrease","reduce","discount","delete","line","horizontal-line"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12C7 11.4477 7.44772 11 8 11L16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13L8 13C7.44772 13 7 12.5523 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    minus: {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","subtract","remove","decrease","reduce","discount","delete","line","horizontal-line"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mobile","device","payment","terminal","transaction","checkout","tablet","smartphone","pos","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V18C18 19.8856 18 20.8284 17.4142 21.4142C16.8284 22 15.8856 22 14 22H10C8.11438 22 7.17157 22 6.58579 21.4142C6 20.8284 6 19.8856 6 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mobile","phone","device","payment","scan","app","mobile-payment","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17V7C6 5.11438 6 4.17157 6.58579 3.58579C7.17157 3 8.11438 3 10 3H14C15.8856 3 16.8284 3 17.4142 3.58579C18 4.17157 18 5.11438 18 7V17C18 18.8856 18 19.8284 17.4142 20.4142C16.8284 21 15.8856 21 14 21H10C8.11438 21 7.17157 21 6.58579 20.4142C6 19.8284 6 18.8856 6 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mobile","phone","device","payment","terminal","app","application","pos-system","card","mobile-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.052 2.25H9.94801C9.04957 2.24997 8.30029 2.24995 7.70553 2.32992C7.07773 2.41432 6.51093 2.59999 6.05546 3.05546C5.59999 3.51093 5.41432 4.07773 5.32992 4.70553C5.24995 5.30029 5.24997 6.04954 5.25 6.94798V17.0521C5.24997 17.9505 5.24995 18.6997 5.32992 19.2945C5.41432 19.9223 5.59999 20.4891 6.05546 20.9445C6.51093 21.4 7.07773 21.5857 7.70553 21.6701C8.30031 21.7501 9.04953 21.75 9.94801 21.75H14.052C14.9505 21.75 15.6997 21.7501 16.2945 21.6701C16.9223 21.5857 17.4891 21.4 17.9445 20.9445C18.4 20.4891 18.5857 19.9223 18.6701 19.2945C18.7501 18.6997 18.75 17.9505 18.75 17.052V6.94798C18.75 6.04951 18.7501 5.3003 18.6701 4.70553C18.5857 4.07773 18.4 3.51093 17.9445 3.05546C17.4891 2.59999 16.9223 2.41432 16.2945 2.32992C15.6997 2.24995 14.9504 2.24997 14.052 2.25ZM11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mobile-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["mobile","phone","smartphone","device","app","loyalty","digital","pay","payment","mobile-payment","scan","checkout","terminal","pos","register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17V7C6 5.11438 6 4.17157 6.58579 3.58579C7.17157 3 8.11438 3 10 3H14C15.8856 3 16.8284 3 17.4142 3.58579C18 4.17157 18 5.11438 18 7V17C18 18.8856 18 19.8284 17.4142 20.4142C16.8284 21 15.8856 21 14 21H10C8.11438 21 7.17157 21 6.58579 20.4142C6 19.8284 6 18.8856 6 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 17L18 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 6H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["mobile","phone","device","app","application","payment","mobile-payment","transaction","digital","smartphone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 17L18 17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M6 17V7C6 5.11438 6 4.17157 6.58579 3.58579C7.17157 3 8.11438 3 10 3H14C15.8856 3 16.8284 3 17.4142 3.58579C18 4.17157 18 5.11438 18 7V17C18 18.8856 18 19.8284 17.4142 20.4142C16.8284 21 15.8856 21 14 21H10C8.11438 21 7.17157 21 6.58579 20.4142C6 19.8284 6 18.8856 6 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 6H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mobile","phone","device","payment","scan","scanner","pos","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18V8C6 6.11438 6 5.17157 6.58579 4.58579C7.17157 4 8.11438 4 10 4H14C15.8856 4 16.8284 4 17.4142 4.58579C18 5.17157 18 6.11438 18 8V18C18 19.8856 18 20.8284 17.4142 21.4142C16.8284 22 15.8856 22 14 22H10C8.11438 22 7.17157 22 6.58579 21.4142C6 20.8284 6 19.8856 6 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M6 17L18 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 6H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "mobile-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["mobile","phone","device","payment","mobile-payment","pos","terminal","credit-card","reader"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.052 2.25H9.94801C9.04957 2.24997 8.30029 2.24995 7.70553 2.32992C7.07773 2.41432 6.51093 2.59999 6.05546 3.05546C5.59999 3.51093 5.41432 4.07773 5.32992 4.70553C5.24995 5.30029 5.24997 6.04954 5.25 6.94798V16.25H18.75V6.94798C18.75 6.04951 18.7501 5.3003 18.6701 4.70553C18.5857 4.07773 18.4 3.51093 17.9445 3.05546C17.4891 2.59999 16.9223 2.41432 16.2945 2.32992C15.6997 2.24995 14.9504 2.24997 14.052 2.25ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55229 10.4477 7 11 7H13C13.5523 7 14 6.55229 14 6C14 5.44772 13.5523 5 13 5H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.32992 19.2945C5.27164 18.861 5.25585 18.3455 5.25158 17.75H18.7484C18.7442 18.3455 18.7284 18.861 18.6701 19.2945C18.5857 19.9223 18.4 20.4891 17.9445 20.9445C17.4891 21.4 16.9223 21.5857 16.2945 21.6701C15.6997 21.7501 14.9505 21.75 14.052 21.75H9.94801C9.04953 21.75 8.30031 21.7501 7.70553 21.6701C7.07773 21.5857 6.51093 21.4 6.05546 20.9445C5.59999 20.4891 5.41432 19.9223 5.32992 19.2945Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mobile-data-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","update","change","modify","letter-e","e"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12H15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 8H11C10.0572 8 9.58579 8 9.29289 8.29289C9 8.58579 9 9.05719 9 10V14C9 14.9428 9 15.4142 9.29289 15.7071C9.58579 16 10.0572 16 11 16H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mobile-data-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["E","price","edit","discount","edit-price","adjust","cost","change","modify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 8H11C10.0572 8 9.58579 8 9.29289 8.29289C9 8.58579 9 9.05719 9 10V14C9 14.9428 9 15.4142 9.29289 15.7071C9.58579 16 10.0572 16 11 16H15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mobile-data-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["e","letter-e","edit","extra","employee","email","entry","earnings","electronic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9456 7.00001C10.5215 6.99992 10.1094 6.99984 9.7695 7.04554C9.38629 7.09706 8.94902 7.22259 8.5858 7.5858C8.22259 7.94902 8.09706 8.38629 8.04554 8.76949C7.99984 9.10941 7.99992 9.52154 8.00001 9.94561L8.00001 11.9945C8 11.9964 8 11.9982 8 12C8 12.0018 8 12.0036 8.00001 12.0055L8.00001 14.0544C7.99992 14.4785 7.99984 14.8906 8.04554 15.2305C8.09706 15.6137 8.22259 16.051 8.5858 16.4142C8.94902 16.7774 9.38629 16.903 9.7695 16.9545C10.1094 17.0002 10.5215 17.0001 10.9456 17L15 17C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H11C10.5003 15 10.2262 14.9979 10.036 14.9723L10.0287 14.9713L10.0277 14.964C10.0021 14.7738 10 14.4997 10 14V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H10V10C10 9.50034 10.0021 9.22618 10.0277 9.03599L10.0287 9.02871L10.036 9.02771C10.2262 9.00214 10.5003 9.00001 11 9.00001H15C15.5523 9.00001 16 8.5523 16 8.00001C16 7.44773 15.5523 7.00001 15 7.00001L10.9456 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mobile-data-badge-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["E","Square","Edit","Enable","Employee","POS","Enable employee","Edit employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H12C11.0572 9 10.5858 9 10.2929 9.29289C10 9.58579 10 10.0572 10 11V12M14 15H12C11.0572 15 10.5858 15 10.2929 14.7071C10 14.4142 10 13.9428 10 13V12M10 12H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "mobile-data-badge-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["E","edit","employee","expense","entry","email"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9H12C11.0572 9 10.5858 9 10.2929 9.29289C10 9.58579 10 10.0572 10 11V12M14 15H12C11.0572 15 10.5858 15 10.2929 14.7071C10 14.4142 10 13.9428 10 13V12M10 12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "mobile-data-badge-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["e","edit","employee","employee-profile","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V13.0706V10.9294V10.9294C3.99997 9.57527 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57531 3.99997 10.9294 4H10.9294ZM12 8.00002L11.9456 8.00001C11.5215 7.99992 11.1094 7.99984 10.7695 8.04554C10.3863 8.09706 9.94902 8.22259 9.5858 8.5858C9.22259 8.94902 9.09706 9.38629 9.04554 9.7695C8.99984 10.1094 8.99992 10.5215 9.00001 10.9456L9.00002 11V13L9.00001 13.0544C8.99992 13.4785 8.99984 13.8906 9.04554 14.2305C9.09706 14.6137 9.22259 15.051 9.5858 15.4142C9.94902 15.7774 10.3863 15.903 10.7695 15.9545C11.1094 16.0002 11.5215 16.0001 11.9456 16L12 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H12C11.5003 14 11.2262 13.9979 11.036 13.9723L11.0287 13.9713L11.0277 13.964C11.0021 13.7738 11 13.4997 11 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H11C11 10.5003 11.0021 10.2262 11.0277 10.036L11.0287 10.0287L11.036 10.0277C11.2262 10.0021 11.5003 10 12 10H14C14.5523 10 15 9.5523 15 9.00002C15 8.44773 14.5523 8.00002 14 8.00002H12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "mobile-data-badge": {
        defaultColors: ["#3D4C66"],
        keywords: ["e","edit","square","label","modify","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9H12C11.0572 9 10.5858 9 10.2929 9.29289C10 9.58579 10 10.0572 10 11V12M14 15H12C11.0572 15 10.5858 15 10.2929 14.7071C10 14.4142 10 13.9428 10 13V12M10 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "mobile-data": {
        defaultColors: ["#3D4C66"],
        keywords: ["E","extra","edit","employee","email","enable","expense","export","entry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 8H11C10.0572 8 9.58579 8 9.29289 8.29289C9 8.58579 9 9.05719 9 10V12M15 16H11C10.0572 16 9.58579 16 9.29289 15.7071C9 15.4142 9 14.9428 9 14V12M9 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    mobile: {
        defaultColors: ["#3D4C66"],
        keywords: ["E","extra","edit","employee","email","enable","expense","export","entry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17V7C6 5.11438 6 4.17157 6.58579 3.58579C7.17157 3 8.11438 3 10 3H14C15.8856 3 16.8284 3 17.4142 3.58579C18 4.17157 18 5.11438 18 7V17C18 18.8856 18 19.8284 17.4142 20.4142C16.8284 21 15.8856 21 14 21H10C8.11438 21 7.17157 21 6.58579 20.4142C6 19.8284 6 18.8856 6 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Monitor-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["monitor","screen","display","terminal","pos-terminal","system","point-of-sale","interface","application","software","device","cashier","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 13L4 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Monitor-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["monitor","screen","display","terminal","pos","point-of-sale","interface","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20L12 16L14 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 20H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Monitor-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","screen","display","terminal","pos-terminal","system","point-of-sale","application","interface","view","desktop","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11875C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82768 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92946V10.0705C21 11.4247 21.0001 12.5413 20.8813 13.4251C20.7565 14.3529 20.4845 15.1723 19.8284 15.8284C19.1723 16.4845 18.3529 16.7565 17.4251 16.8813C16.5413 17.0001 15.4247 17 14.0706 17L13.618 17L14.618 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H14.0217C14.0077 21.0003 13.9938 21.0003 13.9799 21H10.0201C10.0062 21.0003 9.99229 21.0003 9.97835 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H9.38197L10.382 17L9.92943 17C8.57531 17 7.4587 17.0001 6.57494 16.8813C5.64711 16.7565 4.82768 16.4845 4.17158 15.8284C3.51547 15.1723 3.2435 14.3529 3.11875 13.4251C2.99994 12.5413 2.99997 11.4247 3 10.0706V9.92943C2.99997 8.57531 2.99994 7.4587 3.11875 6.57494C3.2435 5.64711 3.51547 4.82768 4.17158 4.17158C4.82768 3.51547 5.64711 3.2435 6.57494 3.11875C7.4587 2.99994 8.57531 2.99997 9.92943 3ZM12 18.2361L11.618 19H12.382L12 18.2361Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Monitor-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["monitor","screen","display","terminal","pos","point-of-sale","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20 13L4 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Monitor-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","screen","display","terminal","pos-terminal","interface","system","dashboard","reporting","sales-data","analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92944V10.0706C21 10.7784 21 11.4213 20.9831 12H3.01693C2.99997 11.4213 2.99998 10.7784 3 10.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.12919 13.5C3.25847 14.397 3.53319 15.19 4.17158 15.8284C4.82769 16.4845 5.64711 16.7565 6.57494 16.8813C7.24768 16.9717 8.05535 16.9933 9 16.9984L9 19H8C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H15V16.9984C15.9447 16.9933 16.7523 16.9717 17.4251 16.8813C18.3529 16.7565 19.1723 16.4845 19.8284 15.8284C20.4668 15.19 20.7415 14.397 20.8708 13.5H3.12919ZM11 17V19H13V17H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Monitor-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","display","screen","terminal","pos-terminal","point-of-sale","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Monitor-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["monitor","screen","display","computer","terminal","pos","point-of-sale","system","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Monitor-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["monitor","screen","display","terminal","pos","system","interface","dashboard","sales","transaction","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Monitor-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","screen","display","pos-terminal","checkout","terminal","system","cash-register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57533 2.99997 7.45869 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45869 2.99997 8.57529 3 9.92939V10.0706C2.99997 11.4247 2.99994 12.5413 3.11876 13.4251C3.2435 14.3529 3.51547 15.1723 4.17158 15.8284C4.82769 16.4845 5.64711 16.7565 6.57494 16.8813C7.24768 16.9717 8.05535 16.9933 9 16.9984L9 19H8C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H15V16.9984C15.9447 16.9933 16.7523 16.9717 17.4251 16.8813C18.3529 16.7565 19.1723 16.4845 19.8284 15.8284C20.4845 15.1723 20.7565 14.3529 20.8813 13.4251C21.0001 12.5413 21 11.4247 21 10.0706V9.92946C21 8.57534 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM11 19V17H13V19H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Monitor-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","screen","display","terminal","pos-terminal","device","computer","system-monitor","cashier-screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 20H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 20L12 16L14 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Monitor-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["monitor","screen","display","pos-terminal","terminal","system","computer","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20L12 16L14 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M16 20H8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Monitor-code-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["monitor","computer","code","programming","settings","configuration","system","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L8 10L10 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L16 10L14 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Monitor-code-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["monitor","code","settings","development","customization","terminal","computer","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12L8 10L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L16 10L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Monitor-code": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","code","development","settings","configuration","programming","computer","screen","script"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L8 10L10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L16 10L14 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Monitor-code-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","computer","code","programming","settings","configuration","development","system","source-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.5753 21 9.92942V10.0705C21 11.4247 21.0001 12.5413 20.8813 13.4251C20.7565 14.3529 20.4845 15.1723 19.8284 15.8284C19.1723 16.4845 18.3529 16.7565 17.4251 16.8813C16.7523 16.9717 15.9447 16.9933 15 16.9984V19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H9L9 16.9984C8.05535 16.9933 7.24768 16.9717 6.57494 16.8813C5.64711 16.7565 4.82769 16.4845 4.17158 15.8284C3.51547 15.1723 3.2435 14.3529 3.11876 13.4251C2.99994 12.5413 2.99997 11.4247 3 10.0706V9.92943C2.99997 8.57535 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM11 17V19H13V17H11ZM10.5303 8.53033C10.8232 8.23744 10.8232 7.76257 10.5303 7.46967C10.2374 7.17678 9.76257 7.17678 9.46967 7.46967L7.46967 9.46967C7.17678 9.76256 7.17678 10.2374 7.46967 10.5303L9.46967 12.5303C9.76256 12.8232 10.2374 12.8232 10.5303 12.5303C10.8232 12.2374 10.8232 11.7626 10.5303 11.4697L9.06066 10L10.5303 8.53033ZM14.5303 7.46967C14.2374 7.17678 13.7626 7.17678 13.4697 7.46967C13.1768 7.76256 13.1768 8.23744 13.4697 8.53033L14.9393 10L13.4697 11.4697C13.1768 11.7626 13.1768 12.2374 13.4697 12.5303C13.7626 12.8232 14.2374 12.8232 14.5303 12.5303L16.5303 10.5303C16.671 10.3897 16.75 10.1989 16.75 10C16.75 9.80109 16.671 9.61033 16.5303 9.46967L14.5303 7.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Monitor: {
        defaultColors: ["#3D4C66"],
        keywords: ["monitor","computer","code","programming","settings","configuration","development","system","source-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 13L4 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "moon set-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","night","mode","dark","theme","sleep","inactive","unavailable","closed","hours","off-hours","settings","display","brightness","schedule","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.65893 14.3411C10.8708 16.553 14.4571 16.553 16.669 14.3411C17.2832 13.7268 17.7269 13.0066 18 12.2392C16.0041 12.9495 13.6895 12.5058 12.0918 10.9082C10.4942 9.31053 10.0505 6.99588 10.7608 5C9.99343 5.27309 9.27319 5.71677 8.65893 6.33102C6.44702 8.54293 6.44702 12.1292 8.65893 14.3411Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16H4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 19H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon set-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["night","late-night","moon","dusk","evening","schedule","shift","late-shift","night-shift"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.65893 14.3411C10.8708 16.553 14.4571 16.553 16.669 14.3411C17.2832 13.7268 17.7269 13.0066 18 12.2392C16.0041 12.9495 13.6895 12.5058 12.0918 10.9082C10.4942 9.31053 10.0505 6.99588 10.7608 5C9.99343 5.27309 9.27319 5.71677 8.65893 6.33102C6.44702 8.54293 6.44702 12.1292 8.65893 14.3411Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16H4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 19H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon set-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["night","dark","moon","sleep","off-hours","closed","night-mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7029 5.33532C11.8323 4.97162 11.7409 4.5659 11.4679 4.29292C11.1949 4.01995 10.7892 3.92848 10.4255 4.05791C9.52125 4.37972 8.67324 4.90253 7.95183 5.62394C5.3654 8.21037 5.34949 12.3939 7.90411 15H4C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H20C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15H17.4238C18.1206 14.2891 18.6274 13.4587 18.9421 12.5745C19.0716 12.2108 18.9801 11.8051 18.7071 11.5321C18.4341 11.2592 18.0284 11.1677 17.6647 11.2971C16.0188 11.8829 14.1134 11.5156 12.7989 10.2011C11.4844 8.88659 11.1171 6.98124 11.7029 5.33532Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 18C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18H7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon set": {
        defaultColors: ["#3D4C66"],
        keywords: ["night mode","dark mode","sleep mode","end of day","shift end","night shift"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.65893 14.3411C10.8708 16.553 14.4571 16.553 16.669 14.3411C17.2832 13.7268 17.7269 13.0066 18 12.2392C16.0041 12.9495 13.6895 12.5058 12.0918 10.9082C10.4942 9.31053 10.0505 6.99588 10.7608 5C9.99343 5.27309 9.27319 5.71677 8.65893 6.33102C6.44702 8.54293 6.44702 12.1292 8.65893 14.3411Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 19H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","dark-mode","night-mode","settings","display","ui"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M7 12C7 9.23858 9.23858 7 12 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "moon-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["moon","night","settings","dark-mode","sleep-mode","toggle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="12"
                    cy="12"
                    r="6"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 11C9 9.89543 9.89543 9 11 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["blueberry","fruit","ingredient","menu","add-on","topping","flavor","component"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8C9.34315 8 8 9.34315 8 11C8 11.5523 8.44772 12 9 12C9.55228 12 10 11.5523 10 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["moon","night","dark-mode","sleep","time","schedule","availability","settings","toggle","off-hours","closed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 12C7 9.23858 9.23858 7 12 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "moon-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night","dark","mode","sleep","off","display","brightness"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM8 12C8 9.79086 9.79086 8 12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C8.68629 6 6 8.68629 6 12C6 12.5523 6.44772 13 7 13C7.55228 13 8 12.5523 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night-mode","dark-mode","sleep","time","schedule","off-hours"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C12.7286 16 13.4117 15.8052 14 15.4649C12.8044 14.7733 12 13.4806 12 12C12 10.5194 12.8044 9.22675 14 8.53513C13.4117 8.19479 12.7286 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H20M17 17L18 18M12 19V20M6 18L7 17M4 12H5M7 7L6 6M12 5V4M17 7L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "moon-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","night","dark-mode","theme","display-mode","settings","user-interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C12.7286 16 13.4117 15.8052 14 15.4649C12.8044 14.7733 12 13.4806 12 12C12 10.5194 12.8044 9.22675 14 8.53513C13.4117 8.19479 12.7286 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H20M17 17L18 18M12 19V20M6 18L7 17M4 12H5M7 7L6 6M12 5V4M17 7L18 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "moon-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["moon","night-mode","dark-mode","sleep","settings","theme","display","brightness","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C12.7286 16 13.4117 15.8052 14 15.4649C12.8044 14.7733 12 13.4806 12 12C12 10.5194 12.8044 9.22675 14 8.53513C13.4117 8.19479 12.7286 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H20M17 17L18 18M12 19V20M6 18L7 17M4 12H5M7 7L6 6M12 5V4M17 7L18 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "moon-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night-mode","dark-mode","settings","display","time","off-hours","schedule"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.29289 7.70711C6.68342 8.09763 7.31658 8.09763 7.70711 7.70711C8.09763 7.31658 8.09763 6.68342 7.70711 6.29289L6.70711 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L16.2929 6.29289C15.9024 6.68342 15.9024 7.31658 16.2929 7.70711C16.6834 8.09763 17.3166 8.09763 17.7071 7.70711L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.70711 18.7071L7.70711 17.7071C8.09763 17.3166 8.09763 16.6834 7.70711 16.2929C7.31658 15.9024 6.68342 15.9024 6.29289 16.2929L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.7071 16.2929C17.3166 15.9024 16.6834 15.9024 16.2929 16.2929C15.9024 16.6834 15.9024 17.3166 16.2929 17.7071L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L17.7071 16.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 12C7 9.23858 9.23858 7 12 7C12.9091 7 13.7643 7.24351 14.5007 7.66952C14.8097 7.84827 15 8.17816 15 8.53513C15 8.89209 14.8097 9.22199 14.5007 9.40073C13.6014 9.92096 13 10.8908 13 12C13 13.1092 13.6014 14.079 14.5007 14.5993C14.8097 14.778 15 15.1079 15 15.4649C15 15.8218 14.8097 16.1517 14.5007 16.3305C13.7643 16.7565 12.9091 17 12 17C9.23858 17 7 14.7614 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["dark-mode","settings","preferences","sleep","inactive","idle","night"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 11C9 9.89543 9.89543 9 11 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","dark-mode","light-mode","settings","brightness","sleep","night"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 11C9 9.89543 9.89543 9 11 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep zzz-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sleep","moon","night","zzz","offline","downtime","closed","system-offline","inactive","break"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 5L18 5L17 8H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L15 10L14 12H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep zzz-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sleep","zzz","moon","night","off","offline","pause","inactive","downtime","break"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 5L18 5L17 8H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L15 10L14 12H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep zzz-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","night","moon","zzz","offline","downtime","maintenance","closed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.80926 7.25149C9.90634 6.97871 9.83774 6.67442 9.63301 6.46969C9.42828 6.26496 9.12399 6.19636 8.85121 6.29343C7.91143 6.62789 7.02988 7.17125 6.27942 7.92172C3.57353 10.6276 3.57353 15.0147 6.27942 17.7206C8.98531 20.4265 13.3724 20.4265 16.0783 17.7206C16.8288 16.9701 17.3721 16.0886 17.7066 15.1488C17.8037 14.876 17.7351 14.5717 17.5303 14.367C17.3256 14.1623 17.0213 14.0937 16.7485 14.1908C14.8337 14.8722 12.6156 14.4455 11.085 12.915C9.55449 11.3844 9.12779 9.16634 9.80926 7.25149Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.25 5C15.25 4.58579 15.5858 4.25 16 4.25H18C18.2411 4.25 18.4675 4.36589 18.6084 4.56147C18.7494 4.75704 18.7877 5.00846 18.7115 5.23717L18.0406 7.25H19C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H17C16.7589 8.75 16.5325 8.63411 16.3916 8.43853C16.2506 8.24296 16.2123 7.99154 16.2885 7.76283L16.9594 5.75H16C15.5858 5.75 15.25 5.41421 15.25 5ZM12.25 10C12.25 9.58579 12.5858 9.25 13 9.25H15C15.2599 9.25 15.5013 9.38459 15.638 9.6057C15.7746 9.82681 15.7871 10.1029 15.6708 10.3354L15.2135 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H14C13.7401 12.75 13.4987 12.6154 13.362 12.3943C13.2254 12.1732 13.2129 11.8971 13.3292 11.6646L13.7865 10.75H13C12.5858 10.75 12.25 10.4142 12.25 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon-sleep zzz": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","sleep","zzz","night","downtime","offline","rest","break","closed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 5L18 5L17 8H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L15 10L14 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["moon","sleep","night","closed","late","end-of-day","close-business","night-mode","sleep-mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L16 10L17 12L18 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L12 7L13 8.99999L14 7.99999"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L17 5L18 6.99999L19 5.99999"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["moon","sleep","night","end-of-day","close","closed","shift-end","time-off","downtime"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L16 10L17 12L18 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L12 7L13 8.99999L14 7.99999"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L17 5L18 6.99999L19 5.99999"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "moon-sleep-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["moon","night","sleep","end-of-day","reports","daily-summary","close-day","shift-end"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.30978 6.29292C9.58276 6.5659 9.67423 6.97162 9.54479 7.33532C8.89446 9.16268 9.30205 11.2785 10.7618 12.7382C12.2216 14.198 14.3373 14.6056 16.1647 13.9552C16.5284 13.8258 16.9341 13.9173 17.2071 14.1902C17.4801 14.4632 17.5716 14.8689 17.4421 15.2326C17.0955 16.2066 16.5323 17.1201 15.7551 17.8974C12.9516 20.7009 8.40616 20.7009 5.60264 17.8974C2.79912 15.0939 2.79912 10.5485 5.60264 7.74495C6.37989 6.96769 7.29338 6.40455 8.26739 6.05791C8.63109 5.92848 9.03681 6.01995 9.30978 6.29292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.3944 4.5528C18.2507 4.26529 17.9775 4.06441 17.6602 4.01292C17.3429 3.96144 17.0202 4.06561 16.7929 4.29291L15.7929 5.29291C15.4024 5.68343 15.4024 6.3166 15.7929 6.70712C16.1834 7.09764 16.8166 7.09764 17.2071 6.70712L17.2261 6.68817L17.6056 7.44722C17.7493 7.73473 18.0225 7.9356 18.3398 7.98709C18.6571 8.03858 18.9798 7.9344 19.2071 7.70711L20.2071 6.70711C20.5976 6.31659 20.5976 5.68342 20.2071 5.2929C19.8166 4.90237 19.1834 4.90237 18.7929 5.2929L18.774 5.31184L18.3944 4.5528Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.3944 9.5528C17.2507 9.26529 16.9775 9.06441 16.6602 9.01292C16.3429 8.96144 16.0202 9.06561 15.7929 9.29291L14.7929 10.2929C14.4024 10.6834 14.4024 11.3166 14.7929 11.7071C15.1834 12.0976 15.8166 12.0976 16.2071 11.7071L16.2261 11.6882L16.6056 12.4472C16.7493 12.7347 17.0225 12.9356 17.3398 12.9871C17.6571 13.0386 17.9798 12.9344 18.2071 12.7071L19.2071 11.7071C19.5976 11.3166 19.5976 10.6834 19.2071 10.2929C18.8166 9.90237 18.1834 9.90237 17.7929 10.2929L17.774 10.3118L17.3944 9.5528Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.6602 6.01292C12.9775 6.06441 13.2507 6.26529 13.3944 6.5528L13.774 7.31184L13.7929 7.2929C14.1834 6.90237 14.8166 6.90237 15.2071 7.2929C15.5976 7.68342 15.5976 8.31659 15.2071 8.70711L14.2071 9.70711C13.9798 9.9344 13.6571 10.0386 13.3398 9.98709C13.0225 9.9356 12.7493 9.73473 12.6056 9.44722L12.2261 8.68817L12.2071 8.70712C11.8166 9.09764 11.1834 9.09764 10.7929 8.70712C10.4024 8.3166 10.4024 7.68343 10.7929 7.29291L11.7929 6.29291C12.0202 6.06561 12.3429 5.96144 12.6602 6.01292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "moon-sleep": {
        defaultColors: ["#3D4C66"],
        keywords: ["night","sleep","end-of-day","close","nightly-sales","sleep-mode","away","inactive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80975 17.1903C9.22274 19.6032 13.135 19.6032 15.548 17.1903C16.2181 16.5202 16.7021 15.7344 17 14.8973C14.8227 15.6722 12.2976 15.1882 10.5547 13.4453C8.8118 11.7024 8.32779 9.17732 9.10268 7C8.26556 7.29792 7.47984 7.78193 6.80975 8.45202C4.39675 10.865 4.39675 14.7773 6.80975 17.1903Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 11L16 10L17 12L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8L12 7L13 8.99999L14 7.99999"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L17 5L18 6.99999L19 5.99999"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    moon: {
        defaultColors: ["#3D4C66"],
        keywords: ["night","sleep","end-of-day","close","nightly-sales","sleep-mode","away","inactive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M7 12C7 9.23858 9.23858 7 12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Mountains-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["mountains","location","terrain","destination","explore","outdoors","nature","travel","scenery","area","region"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19V19C17.5554 19 18.3331 19 18.8169 18.7004C19.351 18.3696 19.6987 17.8071 19.7557 17.1814C19.8073 16.6146 19.4595 15.919 18.7639 14.5279L18 13C17.8202 12.6404 17.7303 12.4607 17.657 12.3522C16.864 11.1788 15.136 11.1788 14.343 12.3522C14.2697 12.4607 14.1798 12.6404 14 13V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 19H9.37276C6.51118 19 5.08039 19 4.49242 18.0633C3.90445 17.1265 4.52648 15.838 5.77055 13.261L6.2798 12.2061C7.7977 9.06191 8.55665 7.4898 9.79273 7.47275C11.0288 7.4557 11.8308 9.00628 13.4349 12.1074L13.5402 12.3111L17 19ZM17 19H10.4483"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mountains-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["mountains","scenery","location","environment","outdoors","tourism","travel","range","landscape","backcountry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13L18.7639 14.5279C19.4595 15.919 19.8073 16.6146 19.7557 17.1814C19.6987 17.8071 19.351 18.3696 18.8169 18.7004C18.3331 19 17.5554 19 16 19C14.6656 19 13.9985 19 13.5563 18.7633C12.9667 18.4478 12.5738 17.8585 12.5093 17.1929C12.461 16.6937 12.7176 16.0779 13.2308 14.8462L14 13C14.1798 12.6404 14.2697 12.4607 14.343 12.3522C15.136 11.1788 16.864 11.1788 17.657 12.3522C17.7303 12.4607 17.8202 12.6404 18 13L18 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.77055 13.261L6.2798 12.2061C7.7977 9.06191 8.55665 7.4898 9.79273 7.47275C11.0288 7.4557 11.8308 9.00628 13.4349 12.1074L13.5402 12.3111L17 19H10.4483H9.37276C6.51118 19 5.08039 19 4.49242 18.0633C3.90445 17.1265 4.52648 15.838 5.77055 13.261Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M17 19H9.37276C6.51118 19 5.08039 19 4.49242 18.0633C3.90445 17.1265 4.52648 15.838 5.77055 13.261L6.2798 12.2061C7.7977 9.06191 8.55665 7.4898 9.79273 7.47275C11.0288 7.4557 11.8308 9.00628 13.4349 12.1074L13.5402 12.3111L17 19ZM17 19H10.4483"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mountains-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mountains","range","landscape","environment","locations","inventory","background","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0747 11.1683C13.3995 9.86539 12.8311 8.79351 12.2878 8.03731C11.6835 7.1962 10.9082 6.45732 9.77882 6.4729C8.64944 6.48848 7.89485 7.24846 7.31394 8.10592C6.73871 8.95498 6.14365 10.1877 5.41656 11.6939L4.83429 12.9C4.24256 14.1256 3.74943 15.147 3.48973 15.9795C3.22012 16.8437 3.11927 17.7568 3.64532 18.5949C4.17137 19.433 5.03757 19.7392 5.93305 19.8721C6.79559 20.0001 7.92978 20.0001 9.29076 20.0001L16.9999 20.0001C17.0365 20.0001 17.0729 19.998 17.1088 19.9941C17.3986 19.9888 17.6602 19.9785 17.8932 19.9591C18.3918 19.9176 18.8982 19.8262 19.3433 19.5506C20.1445 19.0544 20.666 18.2106 20.7515 17.2721C20.7989 16.7508 20.6542 16.257 20.4684 15.7924C20.2854 15.3348 20.0089 14.782 19.6777 14.1195L18.859 12.4821C18.7144 12.1925 18.5968 11.957 18.4855 11.7923C17.4588 10.2731 15.3875 10.0651 14.0747 11.1683ZM17.5958 17.9755C17.6412 17.9727 17.6849 17.9695 17.7271 17.966C18.1272 17.9327 18.2515 17.8742 18.2903 17.8502C18.5574 17.6848 18.7312 17.4036 18.7597 17.0907C18.7638 17.0453 18.7605 16.9079 18.6114 16.5352C18.4631 16.1644 18.2251 15.6865 17.8694 14.9751L17.1055 13.4472C17.0139 13.264 16.9512 13.1389 16.9024 13.0454C16.8785 12.9998 16.861 12.9677 16.8478 12.9446C16.8413 12.9333 16.8366 12.9253 16.8332 12.9198C16.8298 12.9143 16.8284 12.9122 16.8284 12.9122C16.4319 12.3255 15.5679 12.3255 15.1714 12.9122C15.1714 12.9122 15.1698 12.9145 15.1666 12.9198C15.1632 12.9253 15.1584 12.9333 15.152 12.9446C15.1388 12.9677 15.1213 12.9998 15.0974 13.0454C15.0892 13.0611 15.0806 13.0777 15.0716 13.0953L17.5958 17.9755Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Mountains: {
        defaultColors: ["#3D4C66"],
        keywords: ["mountains","range","landscape","environment","locations","inventory","background","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 19H9.37276C6.51118 19 5.08039 19 4.49242 18.0633C3.90445 17.1265 4.52648 15.838 5.77055 13.261L6.2798 12.2061C7.7977 9.06191 8.55665 7.4898 9.79273 7.47275C11.0288 7.4557 11.8308 9.00628 13.4349 12.1074L13.5402 12.3111L17 19ZM17 19H10.4483"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19V19C17.5554 19 18.3331 19 18.8169 18.7004C19.351 18.3696 19.6987 17.8071 19.7557 17.1814C19.8073 16.6146 19.4595 15.919 18.7639 14.5279L18 13C17.8202 12.6404 17.7303 12.4607 17.657 12.3522C16.864 11.1788 15.136 11.1788 14.343 12.3522C14.2697 12.4607 14.1798 12.6404 14 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mouse-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["mouse","input","select","scroll","navigation","device","point","click","interaction","cursor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 14V10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10V14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 10L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mouse-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mouse","cursor","select","click","input","device","peripheral"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V11C6 7.68629 8.68629 5 12 5C15.3137 5 18 7.68629 18 11V15C18 18.3137 15.3137 21 12 21C8.68629 21 6 18.3137 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 10L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mouse-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mouse","click","select","input","interface","navigation","cursor","point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25 10C5.25 6.27208 8.27208 3.25 12 3.25C15.7279 3.25 18.75 6.27208 18.75 10V14C18.75 17.7279 15.7279 20.75 12 20.75C8.27208 20.75 5.25 17.7279 5.25 14V10ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Mouse: {
        defaultColors: ["#3D4C66"],
        keywords: ["mouse","click","select","input","interface","navigation","cursor","point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 14V10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10V14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 10L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Mug-hot-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["mug","coffee","tea","drink","beverage","cup","hot-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H18.2478C19.7678 8 21 9.23222 21 10.7522V10.7522C21 11.9677 20.2028 13.0392 19.0386 13.3884L17 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 7H17V11.9C17 13.8641 17 14.8461 16.5579 15.5675C16.3106 15.9712 15.9712 16.3106 15.5675 16.5579C14.8461 17 13.8641 17 11.9 17H10.1C8.13594 17 7.15391 17 6.4325 16.5579C6.02884 16.3106 5.68945 15.9712 5.44208 15.5675C5 14.8461 5 13.8641 5 11.9V7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mug-hot-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["mug","coffee","tea","drink","beverage","hot-drink","cup","menu-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.2478 8H17.0474C17.0212 8 17 8.02124 17 8.04743V13.9114C17 13.9556 17.0426 13.9872 17.0849 13.9745L19.0386 13.3884C20.2028 13.0392 21 11.9677 21 10.7522C21 9.23222 19.7678 8 18.2478 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 7H17V11.9C17 13.8641 17 14.8461 16.5579 15.5675C16.3106 15.9712 15.9712 16.3106 15.5675 16.5579C14.8461 17 13.8641 17 11.9 17H10.1C8.13594 17 7.15391 17 6.4325 16.5579C6.02884 16.3106 5.68945 15.9712 5.44208 15.5675C5 14.8461 5 13.8641 5 11.9V7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Mug-hot-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mug","coffee","tea","beverage","drink","cup","menu-item","order-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 6.75H16.5C16.5 6.34 16.16 6 15.75 6H3.75C3.34 6 3 6.34 3 6.75V11.69C3 12.64 3 13.41 3.06 14.02C3.12 14.66 3.25 15.21 3.55 15.71C3.86 16.21 4.28 16.64 4.79 16.95C5.29 17.26 5.84 17.38 6.48 17.44C7.1 17.5 7.86 17.5 8.81 17.5H10.69C11.64 17.5 12.41 17.5 13.02 17.44C13.66 17.38 14.21 17.25 14.71 16.95C15.21 16.64 15.64 16.22 15.95 15.71C16.16 15.37 16.28 15.01 16.36 14.61L18.08 14.09C19.67 13.61 20.75 12.15 20.75 10.5C20.75 8.43 19.07 6.75 17 6.75ZM17.5 12.18L16.5 12.48C16.5 12.23 16.5 11.97 16.5 11.69V8.75H17C17.97 8.75 18.75 9.53 18.75 10.5C18.75 11.27 18.24 11.96 17.5 12.18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Mug-hot": {
        defaultColors: ["#3D4C66"],
        keywords: ["mug","coffee","tea","drink","beverage","cup","menu-item","order-item","hot-drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8H18.2478C19.7678 8 21 9.23222 21 10.7522V10.7522C21 11.9677 20.2028 13.0392 19.0386 13.3884L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 7H17V11.9C17 13.8641 17 14.8461 16.5579 15.5675C16.3106 15.9712 15.9712 16.3106 15.5675 16.5579C14.8461 17 13.8641 17 11.9 17H10.1C8.13594 17 7.15391 17 6.4325 16.5579C6.02884 16.3106 5.68945 15.9712 5.44208 15.5675C5 14.8461 5 13.8641 5 11.9V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Music-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["music","entertainment","background-music","ambiance","playlist","sound","volume","event","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 9H10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Music-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","sound","audio","notification","alert","background-music","jingle","tone","chime","entertainment","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9H20C20 7.11438 20 6.17157 19.4142 5.58579C18.8284 5 17.8856 5 16 5H14C12.1144 5 11.1716 5 10.5858 5.58579C10 6.17157 10 7.11438 10 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19.4142 5.58579L18.8839 6.11612L18.8839 6.11612L19.4142 5.58579ZM20 8.25H10V9.75H20V8.25ZM9.25 9V16H10.75V9H9.25ZM20.75 15V9H19.25V15H20.75ZM14 5.75H16V4.25H14V5.75ZM20.75 9C20.75 8.07839 20.7516 7.31174 20.6701 6.70552C20.5857 6.07773 20.4 5.51093 19.9445 5.05546L18.8839 6.11612C19.0142 6.24643 19.1214 6.44393 19.1835 6.90539C19.2484 7.38843 19.25 8.03599 19.25 9H20.75ZM16 5.75C16.964 5.75 17.6116 5.75159 18.0946 5.81654C18.5561 5.87858 18.7536 5.9858 18.8839 6.11612L19.9445 5.05546C19.4891 4.59999 18.9223 4.41432 18.2945 4.32991C17.6883 4.24841 16.9216 4.25 16 4.25V5.75ZM10.75 9C10.75 8.03599 10.7516 7.38843 10.8165 6.90539C10.8786 6.44393 10.9858 6.24643 11.1161 6.11612L10.0555 5.05546C9.59999 5.51093 9.41432 6.07773 9.32991 6.70552C9.24841 7.31174 9.25 8.07839 9.25 9H10.75ZM14 4.25C13.0784 4.25 12.3117 4.24841 11.7055 4.32991C11.0777 4.41432 10.5109 4.59999 10.0555 5.05546L11.1161 6.11612C11.2464 5.9858 11.4439 5.87858 11.9054 5.81654C12.3884 5.75159 13.036 5.75 14 5.75V4.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <circle
                    cx="17"
                    cy="15"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="7"
                    cy="16"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Music-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","entertainment","background-music","volume","sound","notification-sound","alert-sound","theme-song"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Music-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["music","entertainment","jukebox","playlist","background-music","sound","volume","music-selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_45007)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.92 6.67C20.83 6.01 20.63 5.39 20.12 4.88C19.61 4.37 18.98 4.17 18.33 4.08C17.72 4 16.95 4 16.07 4H13.94C13.05 4 12.28 4 11.67 4.08C11.01 4.17 10.39 4.37 9.88 4.88C9.37 5.39 9.17 6.02 9.08 6.67C9 7.28 9 8.05 9 8.93V12.55C8.41 12.21 7.73 12 7 12C4.79 12 3 13.79 3 16C3 18.21 4.79 20 7 20C9.21 20 11 18.21 11 16V10H19V11.55C18.41 11.21 17.73 11 17 11C14.79 11 13 12.79 13 15C13 17.21 14.79 19 17 19C19.21 19 21 17.21 21 15V8.93C21 8.04 21 7.28 20.92 6.67Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_45007">
                        <rect width="18" height="16" fill={colors?.[1] || "#FFFFFF"} transform="translate(3 4)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Music-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","audio","entertainment","sound","notification","alert","volume","playlist","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Music-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","sound","audio","entertainment","background-music","restaurant-ambiance","cafe-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="17"
                    cy="15"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="7"
                    cy="16"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Music-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","sound","entertainment","playlist","mood","jingle","advertise","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.92 6.67C20.83 6.01 20.63 5.39 20.12 4.88C19.61 4.37 18.98 4.17 18.33 4.08C17.72 4 16.95 4 16.07 4H13.94C13.05 4 12.28 4 11.67 4.08C11.01 4.17 10.39 4.37 9.88 4.88C9.37 5.39 9.17 6.02 9.08 6.67C9 7.28 9 8.05 9 8.93V12.55C8.41 12.21 7.73 12 7 12C4.79 12 3 13.79 3 16C3 18.21 4.79 20 7 20C9.21 20 11 18.21 11 16V9C11 8.03 11 7.4 11.06 6.94C11.12 6.51 11.21 6.37 11.29 6.29C11.37 6.21 11.5 6.12 11.94 6.06C12.4 6 13.03 6 14 6H16C16.97 6 17.6 6 18.06 6.06C18.49 6.12 18.63 6.21 18.71 6.29C18.79 6.37 18.88 6.5 18.94 6.94C19 7.4 19 8.03 19 9V11.55C18.41 11.21 17.73 11 17 11C14.79 11 13 12.79 13 15C13 17.21 14.79 19 17 19C19.21 19 21 17.21 21 15V8.93C21 8.04 21 7.28 20.92 6.67Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Music-list-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","list","playlist","songs","entertainment","audio","queue","playback","background-music","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M18 17.5V13V17.5Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 19C15.6664 18.9825 15 18.3161 15 17.5C15 16.6839 15.6664 16.0175 16.5 16C17.3336 16.0175 18 16.6839 18 17.5C18 18.3161 17.3336 18.9825 16.5 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18 17.5V13L19 14M18 17.5C18 16.6839 17.3336 16.0175 16.5 16C15.6664 16.0175 15 16.6839 15 17.5C15 18.3161 15.6664 18.9825 16.5 19C17.3336 18.9825 18 18.3161 18 17.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Music-list-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["music","list","playlist","song","audio","menu","options","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17.5V13L19 14M18 17.5C18 16.6839 17.3336 16.0175 16.5 16C15.6664 16.0175 15 16.6839 15 17.5C15 18.3161 15.6664 18.9825 16.5 19C17.3336 18.9825 18 18.3161 18 17.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5L12 5L13.75 5C15.8567 5 16.91 5 17.6667 5.50559C17.9943 5.72447 18.2755 6.00572 18.4944 6.33329C19 7.08996 19 8.14331 19 10.25V10.25"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 9L19 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Music-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","list","song","playlist","menu","entertainment","audio","background-music","queue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 16.5C16 16.25 15.8 16.02 15.5 16C15.2 16.02 15 16.25 15 16.5C15 16.75 15.2 16.98 15.5 17C15.8 16.98 16 16.75 16 16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM7 8C7 7.45 7.45 7 8 7H10C10.55 7 11 7.45 11 8C11 8.55 10.55 9 10 9H8C7.45 9 7 8.55 7 8ZM8 10C7.45 10 7 10.45 7 11C7 11.55 7.45 12 8 12H14C14.55 12 15 11.55 15 11C15 10.45 14.55 10 14 10H8ZM16.62 11.08C16.99 10.93 17.42 11.01 17.71 11.3L18.71 12.3C19.1 12.69 19.1 13.32 18.71 13.71C18.51 13.91 18.26 14 18 14V16.5C18 17.88 16.88 18.97 15.52 19H15.48C14.12 18.97 13 17.88 13 16.5C13 15.12 14.12 14.03 15.48 14H15.52C15.68 14 15.84 14.02 16 14.06V12C16 11.6 16.24 11.23 16.62 11.08ZM8 13C7.45 13 7 13.45 7 14C7 14.55 7.45 15 8 15H12C12.55 15 13 14.55 13 14C13 13.45 12.55 13 12 13H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Music-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","list","playlist","song","menu","queue","entertainment","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17.5V13L19 14M18 17.5C18 16.6839 17.3336 16.0175 16.5 16C15.6664 16.0175 15 16.6839 15 17.5C15 18.3161 15.6664 18.9825 16.5 19C17.3336 18.9825 18 18.3161 18 17.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 11V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5L12 5L13.75 5C15.8567 5 16.91 5 17.6667 5.50559C17.9943 5.72447 18.2755 6.00572 18.4944 6.33329C19 7.08996 19 8.14331 19 10.25V10.25"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 9L19 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "music-note-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","note","background-music","entertainment","audio","sound","jukebox","ambiance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "music-note-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","note","entertainment","sound","event","playlist","background-music","jingle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="10"
                    cy="15"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "music-note-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","song","playlist","sound","volume","entertainment","background music","audio","notification","alert","reward","loyalty program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6 8.20033L13.6 5.20033C13.3 4.97033 12.89 4.94033 12.55 5.11033C12.21 5.28033 12 5.63033 12 6.00033V11.5503C11.41 11.2103 10.73 11.0003 10 11.0003C7.79 11.0003 6 12.7903 6 15.0003C6 17.2103 7.79 19.0003 10 19.0003C12.21 19.0003 14 17.2103 14 15.0003V8.00033L16.4 9.80033C16.84 10.1303 17.47 10.0403 17.8 9.60033C18.13 9.16033 18.04 8.53033 17.6 8.20033Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "music-note-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","audio","entertainment","playlist","song","background-music","soundtrack","mood-setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 7L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224C14.6022 5 15.0681 5 16 5H16.8345C16.9882 5 17.065 5 17.1299 5.00422C18.1321 5.06946 18.9305 5.86786 18.9958 6.87009C19 6.93498 19 7.01183 19 7.16553V7.16553C19 7.29779 19 7.36393 18.9966 7.42202C18.9448 8.31111 18.3114 9.05885 17.4429 9.25608C17.3862 9.26897 17.321 9.27984 17.1905 9.30159L13 10V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "music-note-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","note","entertainment","sound","jingle","audio","volume","restaurant-music","ambiance","playlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 7L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224C14.6022 5 15.0681 5 16 5H16.8345C16.9882 5 17.065 5 17.1299 5.00422C18.1321 5.06946 18.9305 5.86786 18.9958 6.87009C19 6.93498 19 7.01183 19 7.16553V7.16553C19 7.29779 19 7.36393 18.9966 7.42202C18.9448 8.31111 18.3114 9.05885 17.4429 9.25608C17.3862 9.26897 17.321 9.27984 17.1905 9.30159L13 10V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "music-note-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["music","note","sound","ambiance","entertainment","playlist","volume","audio","alert","notification","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 7L13 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8C13 7.06812 13 6.60218 13.1522 6.23463C13.3552 5.74458 13.7446 5.35523 14.2346 5.15224C14.6022 5 15.0681 5 16 5H16.8345C16.9882 5 17.065 5 17.1299 5.00422C18.1321 5.06946 18.9305 5.86786 18.9958 6.87009C19 6.93498 19 7.01183 19 7.16553C19 7.29779 19 7.36393 18.9966 7.42202C18.9448 8.31111 18.3114 9.05885 17.4429 9.25608C17.3862 9.26897 17.321 9.27984 17.1905 9.30159L13 10V8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "music-note-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","note","audio","sound","entertainment","notification","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.065 6.00212C16.0407 6.00054 16.0039 6.00001 15.8345 6.00001H15C14.5204 6.00001 14.2107 6.00055 13.9738 6.01672C13.7458 6.03228 13.6589 6.05889 13.6173 6.07613C13.3723 6.17762 13.1776 6.3723 13.0761 6.61733C13.0589 6.65894 13.0323 6.74577 13.0167 6.97377C13.0005 7.21075 13 7.52039 13 8.00001V8.81955L16.0261 8.3152C16.1697 8.29126 16.2001 8.28578 16.2215 8.28092C16.6557 8.18231 16.9724 7.80844 16.9983 7.36389C16.9996 7.34201 17 7.31115 17 7.16553C17 6.9961 16.9995 6.95932 16.9979 6.93505C16.9653 6.43394 16.5661 6.03474 16.065 6.00212ZM13 10.8471L16.3549 10.288C16.3627 10.2867 16.3704 10.2854 16.3781 10.2841C16.4855 10.2663 16.5784 10.2508 16.6644 10.2313C17.9671 9.93541 18.9173 8.8138 18.9949 7.48016C19.0001 7.39214 19 7.29792 19 7.18904L19 7.16553C19 7.15618 19 7.14693 19 7.13777C19 7.01177 19.0001 6.9035 18.9937 6.80514C18.8958 5.30181 17.6982 4.1042 16.1949 4.00635C16.0965 3.99994 15.9882 3.99997 15.8622 4C15.8531 4.00001 15.8438 4.00001 15.8345 4.00001L14.968 4.00001C14.5294 4 14.1509 3.99999 13.8376 4.02136C13.5078 4.04386 13.1779 4.09337 12.8519 4.22837C12.1169 4.53285 11.5328 5.11687 11.2284 5.85196C11.0934 6.17789 11.0439 6.5078 11.0213 6.83763C11 7.15088 11 7.52937 11 7.96802L11 12.5351C10.4117 12.1948 9.72857 12 9 12C6.79086 12 5 13.7909 5 16C5 18.2091 6.79086 20 9 20C11.2091 20 13 18.2091 13 16V10.8471Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "music-note-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","mute","no-music","sound-off","disable-music","block-music","mute-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "music-note-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","note","slash","disable-music","mute","no-music","sound-off","no-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="10"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "music-note-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","sound-off","disable-audio","disable-sound","music-off","no-music","audio","music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7103 4.28957C19.3203 3.89957 18.6903 3.89957 18.3003 4.28957L15.7703 6.81957L13.6103 5.19957C13.3103 4.96957 12.9003 4.93957 12.5603 5.10957C12.2203 5.27957 12.0103 5.62957 12.0103 5.99957V10.5896L11.3503 11.2496C10.9303 11.0996 10.4803 10.9996 10.0103 10.9996C7.80031 10.9996 6.01031 12.7896 6.01031 14.9996C6.01031 15.4696 6.10031 15.9296 6.25031 16.3496L4.30031 18.2996C3.91031 18.6896 3.91031 19.3196 4.30031 19.7096C4.69031 20.0996 5.32031 20.0996 5.71031 19.7096L19.7103 5.70957C20.1003 5.31957 20.1003 4.68957 19.7103 4.29957V4.28957ZM14.0003 7.99957L14.3303 8.24957L14.0003 8.57957V7.98957V7.99957Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.0003 18.9996C12.2103 18.9996 14.0003 17.2096 14.0003 14.9996V13.4096L8.65031 18.7596C9.07031 18.9096 9.53031 18.9896 10.0003 18.9896V18.9996Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "music-note-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","off","mute","disable","sound","audio","no-music","no-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "music-note": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","note","music-note","entertainment","sound","ambiance","jukebox","menu","settings","volume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15V6L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Music-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","mute","disable-music","sound-off","no-music","audio-off","volume-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 20L20 4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Music-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","mute","disable-music","sound","volume-off","no-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="17"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="7"
                    cy="16"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 20L20 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Music-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","mute","audio","sound","off","disable","no-music","silence","restaurant-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.71 3.28957C20.32 2.89957 19.69 2.89957 19.3 3.28957L18.48 4.10957C17.83 3.99957 17.03 3.99957 16.01 3.99957H14.01C11.92 3.99957 10.77 3.99957 9.88999 4.87957C9.00999 5.75957 9.00999 6.90957 9.00999 8.99957V12.5596C8.41999 12.2196 7.73999 11.9996 7.00999 11.9996C4.79999 11.9996 3 13.7896 3 15.9996C3 16.9996 3.38999 17.8996 3.99999 18.5996L3.30999 19.2896C2.91999 19.6796 2.91999 20.3096 3.30999 20.6996C3.69999 21.0896 4.32999 21.0896 4.71999 20.6996L20.71 4.70957C21.1 4.31957 21.1 3.68957 20.71 3.29957V3.28957ZM11 8.99957C11 7.54957 11 6.58957 11.29 6.28957C11.58 5.98957 12.54 5.99957 14 5.99957H16C16.21 5.99957 16.4 5.99957 16.58 5.99957L11 11.5796V8.98957V8.99957Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.95 16.4596L7.45999 19.9496C9.28999 19.7396 10.74 18.2896 10.95 16.4596Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19 8.41957C19 8.60957 19 8.79957 19 8.99957V11.5596C18.41 11.2196 17.73 10.9996 17 10.9996C16.78 10.9996 16.56 11.0296 16.35 11.0696L13.07 14.3496C13.03 14.5596 13 14.7796 13 14.9996C13 17.2096 14.79 18.9996 17 18.9996C19.21 18.9996 21 17.2096 21 14.9996V8.99957C21 7.96957 21 7.16957 20.89 6.51957L18.99 8.41957H19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Music-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","mute","disable-music","no-music","sound-off","audio-off","stop-music","silence","disable-audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 20L20 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Music: {
        defaultColors: ["#3D4C66"],
        keywords: ["music","mute","disable-music","no-music","sound-off","audio-off","stop-music","silence","disable-audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 9H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16V9C10 7.11438 10 6.17157 10.5858 5.58579C11.1716 5 12.1144 5 14 5H16C17.8856 5 18.8284 5 19.4142 5.58579C20 6.17157 20 7.11438 20 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="17" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "N-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["N","notification","new","novelty","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V11.2409C7 8.6742 7 7.39084 7.69482 7.16817C8.38965 6.9455 9.13559 7.98982 10.6275 10.0785L13.3725 13.9215C14.8644 16.0102 15.6104 17.0545 16.3052 16.8318C17 16.6092 17 15.3258 17 12.7591V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "N-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["N","notifications","news","note","new","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V11.2409C7 8.6742 7 7.39084 7.69482 7.16817C8.38965 6.9455 9.13559 7.98982 10.6275 10.0785L13.3725 13.9215C14.8644 16.0102 15.6104 17.0545 16.3052 16.8318C17 16.6092 17 15.3258 17 12.7591V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "N-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["N","notification","new","number","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 6C17.5523 6 18 6.44772 18 7L18 12.8368C18 14.0541 18.0001 15.0689 17.9048 15.8031C17.856 16.1795 17.7725 16.5739 17.5979 16.9165C17.4072 17.2906 17.0914 17.63 16.6104 17.7841C16.1293 17.9383 15.6751 17.8457 15.3025 17.6521C14.9613 17.4748 14.6641 17.2024 14.4056 16.9245C13.9013 16.3824 13.3115 15.5566 12.604 14.5661L9.81374 10.6597C9.04945 9.58969 8.53476 8.87274 8.13005 8.43767C8.11525 8.42175 8.10092 8.40658 8.08706 8.39214C8.08419 8.41195 8.08134 8.43261 8.07855 8.45417C8.0021 9.04344 8 9.926 8 11.2409V17C8 17.5523 7.55229 18 7 18C6.44772 18 6 17.5523 6 17L6 11.1632C5.99996 9.94593 5.99992 8.93107 6.09517 8.19688C6.144 7.82046 6.22753 7.42614 6.40216 7.08348C6.59279 6.7094 6.90861 6.37003 7.38965 6.21587C7.87069 6.06172 8.32493 6.15431 8.69749 6.3479C9.03875 6.52524 9.33592 6.79756 9.59445 7.07548C10.0987 7.61756 10.6885 8.44341 11.396 9.43393L14.1863 13.3403C14.9506 14.4103 15.4652 15.1273 15.87 15.5623C15.8848 15.5782 15.8991 15.5934 15.9129 15.6079C15.9158 15.5881 15.9187 15.5674 15.9215 15.5458C15.9979 14.9566 16 14.074 16 12.7591V7C16 6.44772 16.4477 6 17 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    N: {
        defaultColors: ["#3D4C66"],
        keywords: ["N","notification","new","number","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V11.2409C7 8.6742 7 7.39084 7.69482 7.16817C8.38965 6.9455 9.13559 7.98982 10.6275 10.0785L13.3725 13.9215C14.8644 16.0102 15.6104 17.0545 16.3052 16.8318C17 16.6092 17 15.3258 17 12.7591V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "naira-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["naira","currency","money","payment","cash","transaction","sales","finance","price","amount","nigeria"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17V7L16 17V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "naira-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["naira","currency","money","payment","cash","transaction","price","amount","total","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.66899 6.05643C8.06974 5.91585 8.51557 6.04374 8.78087 6.37536L11.2806 9.50006H15V7.00006C15 6.44777 15.4477 6.00006 16 6.00006C16.5523 6.00006 17 6.44777 17 7.00006V9.50006H18C18.5523 9.50006 19 9.94777 19 10.5001C19 11.0523 18.5523 11.5001 18 11.5001H17V13.0001H18C18.5523 13.0001 19 13.4478 19 14.0001C19 14.5523 18.5523 15.0001 18 15.0001H17V17.0001C17 17.4247 16.7318 17.8031 16.331 17.9437C15.9303 18.0843 15.4844 17.9564 15.2191 17.6248L13.1194 15.0001H9V17.0001C9 17.5523 8.55228 18.0001 8 18.0001C7.44772 18.0001 7 17.5523 7 17.0001V15.0001H6C5.44772 15.0001 5 14.5523 5 14.0001C5 13.4478 5.44772 13.0001 6 13.0001H7V11.5001H6C5.44772 11.5001 5 11.0523 5 10.5001C5 9.94777 5.44772 9.50006 6 9.50006H7V7.00006C7 6.57537 7.26824 6.197 7.66899 6.05643ZM9 11.5001V13.0001H11.5194L10.3194 11.5001H9ZM12.8806 11.5001L14.0806 13.0001H15V11.5001H12.8806Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "naira-sign-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["naira","currency","money","payment","cash","transaction","price","total","amount","naira-sign"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17V7L16 17V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "naira-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["naira","currency","money","payment","price","transaction","cash","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17V7L16 17V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "navigation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["navigation","arrow-up","scroll-up","back","return","go-back","previous","up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7716 14.0349L12.847 9.35671C12.4553 8.73008 11.5427 8.73017 11.151 9.35688L8.22786 14.035C7.76324 14.7785 8.41233 15.7175 9.27206 15.5455L11.8028 15.0392C11.9323 15.0133 12.0656 15.0133 12.195 15.0392L14.7275 15.5456C15.5874 15.7175 16.2364 14.7784 15.7716 14.0349Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "navigation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["up","arrow","navigation","scroll-up","move-up","increase","more","rise","elevate","ascend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12.847 9.35666L15.7715 14.0349C16.2363 14.7784 15.5873 15.7175 14.7275 15.5456L12.195 15.0392C12.0655 15.0133 11.9322 15.0133 11.8028 15.0392L9.27203 15.5454C8.4123 15.7174 7.76321 14.7785 8.22783 14.0349L11.151 9.35683C11.5426 8.73012 12.4553 8.73003 12.847 9.35666Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    navigation: {
        defaultColors: ["#3D4C66"],
        keywords: ["up","arrow","navigation","scroll-up","move-up","increase","more","rise","elevate","ascend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7716 14.0349L12.847 9.35671C12.4553 8.73008 11.5427 8.73017 11.151 9.35688L8.22786 14.035C7.76324 14.7785 8.41233 15.7175 9.27206 15.5455L11.8028 15.0392C11.9323 15.0133 12.0656 15.0133 12.195 15.0392L14.7275 15.5456C15.5874 15.7175 16.2364 14.7784 15.7716 14.0349Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "navigation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","up","navigation","scroll-up","move-up","increase","raise","ascend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7716 14.0349L12.847 9.35671C12.4553 8.73008 11.5427 8.73017 11.151 9.35688L8.22786 14.035C7.76324 14.7785 8.41233 15.7175 9.27206 15.5455L11.8028 15.0392C11.9323 15.0133 12.0656 15.0133 12.195 15.0392L14.7275 15.5456C15.5874 15.7175 16.2364 14.7784 15.7716 14.0349Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "nest-true-radiant-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["waveform","oscilloscope","sound","audio","frequency","signal","statistics","analytics","chart","graph","volume","equalizer","data-visualization","metrics","trends"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V8C12 6.89543 11.1046 6 10 6V6C8.89543 6 8 6.89543 8 8V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14V8C20 6.89543 19.1046 6 18 6V6C16.8954 6 16 6.89543 16 8L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12L12 16C12 17.1046 12.8954 18 14 18V18C15.1046 18 16 17.1046 16 16L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 10L4 16C4 17.1046 4.89543 18 6 18V18C7.10457 18 8 17.1046 8 16L8 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "nest-true-radiant": {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","graph","signal","oscillate","frequency","vibration","flow","data","analytics","trends","monitoring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V8C12 6.89543 11.1046 6 10 6V6C8.89543 6 8 6.89543 8 8V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14V8C20 6.89543 19.1046 6 18 6V6C16.8954 6 16 6.89543 16 8L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12L12 16C12 17.1046 12.8954 18 14 18V18C15.1046 18 16 17.1046 16 16L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 10L4 16C4 17.1046 4.89543 18 6 18V18C7.10457 18 8 17.1046 8 16L8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "nest-true-radiant-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","signal","graph","flow","process","connection","transfer","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5C8.34315 5 7 6.34315 7 8L7 16C7 16.5523 6.55229 17 6 17C5.44772 17 5 16.5523 5 16L5 10C5 9.44772 4.55228 9 4 9C3.44772 9 3 9.44772 3 10L3 16C3 17.6569 4.34315 19 6 19C7.65685 19 9 17.6569 9 16L9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8L11 16C11 17.6569 12.3431 19 14 19C15.6569 19 17 17.6569 17 16L17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8V14C19 14.5523 19.4477 15 20 15C20.5523 15 21 14.5523 21 14V8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8L15 16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16L13 8C13 6.34315 11.6569 5 10 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "nest-true-radiant-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["wave","sound","frequency","signal","audio","equalizer","waveform","music","adjustment","settings","volume","oscillate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V8C12 6.89543 11.1046 6 10 6V6C8.89543 6 8 6.89543 8 8V12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 14V8C20 6.89543 19.1046 6 18 6V6C16.8954 6 16 6.89543 16 8L16 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12L12 16C12 17.1046 12.8954 18 14 18V18C15.1046 18 16 17.1046 16 16L16 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 10L4 16C4 17.1046 4.89543 18 6 18V18C7.10457 18 8 17.1046 8 16L8 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "network-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["network","connection","hierarchy","relationship","flow","distribution","branch","group","segment","integration","link","share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C14.0681 7 13.6022 7 13.2346 7.15224C12.7446 7.35523 12.3552 7.74458 12.1522 8.23463C12 8.60218 12 9.06812 12 10L12 12M15 17H15C14.0681 17 13.6022 17 13.2346 16.8478C12.7446 16.6448 12.3552 16.2554 12.1522 15.7654C12 15.3978 12 14.9319 12 14L12 12M9 12L12 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7C15 5.34315 16.3431 4 18 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "network-2-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["network","signal","connection","strength","bars","wifi","data","reception","connectivity","statistics","analytics","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["network","connection","split","branch","hierarchy","relationship","options","variants","menu","modifiers","order-modifiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C14.0681 7 13.6022 7 13.2346 7.15224C12.7446 7.35523 12.3552 7.74458 12.1522 8.23463C12 8.60218 12 9.06812 12 10L12 12M15 17H15C14.0681 17 13.6022 17 13.2346 16.8478C12.7446 16.6448 12.3552 16.2554 12.1522 15.7654C12 15.3978 12 14.9319 12 14L12 12M9 12L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7C15 5.34315 16.3431 4 18 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "network-2-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["network","signal","connection","bars","strength","levels","data","connectivity","volume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-2-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chart","graph","sales","statistics","performance","analytics","report","growth","trend","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 13C7.55228 13 8 13.4477 8 14L8 18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18L6 14C6 13.4477 6.44772 13 7 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C11.4477 9 11 9.44772 11 10V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V10C13 9.44772 12.5523 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-3-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["signal","network","connection","strength","wifi","sales-performance","performance","analytics","growth","trend","bars","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-3-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["network","signal","reception","wifi","connection","strength","levels","data","internet","connectivity","bars","sales-data","performance","analytics","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-3-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","signal","bars","connection","strength","wifi","levels","performance","data","reception","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C11.4477 9 11 9.44772 11 10V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V10C13 9.44772 12.5523 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 13C7.55228 13 8 13.4477 8 14L8 18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18L6 14C6 13.4477 6.44772 13 7 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 5C16.4477 5 16 5.44772 16 6V18C16 18.5523 16.4477 19 17 19C17.5523 19 18 18.5523 18 18V6C18 5.44772 17.5523 5 17 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-3-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","signal","connectivity","connection","strength","wifi","reception","data","bars","levels"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-2-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","signal","connection","wifi","strength","connectivity","internet","bars","weak","strong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L7 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","share","connection","split","branch","distribute","replication","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.1283 8.00866C14.0732 8.01078 14.022 8.01342 13.9738 8.01671C13.7458 8.03227 13.6589 8.05888 13.6173 8.07612C13.3723 8.17762 13.1776 8.37229 13.0761 8.61732C13.0589 8.65893 13.0323 8.74576 13.0167 8.97376C13.0005 9.21074 13 9.52038 13 10L13 14C13 14.4796 13.0005 14.7893 13.0167 15.0262C13.0323 15.2542 13.0589 15.3411 13.0761 15.3827C13.1776 15.6277 13.3723 15.8224 13.6173 15.9239C13.6589 15.9411 13.7458 15.9677 13.9738 15.9833C14.022 15.9866 14.0732 15.9892 14.1283 15.9913C14.5753 14.2705 16.1393 13 18 13C20.2091 13 22 14.7909 22 17C22 19.2091 20.2091 21 18 21C16.1334 21 14.5654 19.7214 14.124 17.9923C14.0232 17.9892 13.9277 17.9848 13.8376 17.9787C13.5078 17.9561 13.1779 17.9066 12.852 17.7716C12.1169 17.4672 11.5328 16.8831 11.2284 16.1481C11.0934 15.8221 11.0439 15.4922 11.0214 15.1624C11 14.8491 11 14.4706 11 14.032V13H9.87398C9.42993 14.7252 7.86384 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.86384 8 9.42995 9.27478 9.87399 11H11L11 9.96804C11 9.52938 11 9.15088 11.0213 8.83762C11.0439 8.50779 11.0934 8.17788 11.2284 7.85195C11.5328 7.11687 12.1169 6.53284 12.8519 6.22836C13.1779 6.09336 13.5078 6.04386 13.8376 6.02135C13.9277 6.0152 14.0232 6.01083 14.124 6.00771C14.5654 4.27857 16.1334 3 18 3C20.2091 3 22 4.79086 22 7C22 9.20914 20.2091 11 18 11C16.1393 11 14.5753 9.72949 14.1283 8.00866Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-4-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["network","signal","connection","strength","wifi","reception","connectivity","internet","data","levels","status","service","bandwidth","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19L10 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L5 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19L15 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L20 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-4-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","signal","strength","connection","wifi","reception","connectivity","bars","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19L10 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L20 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-4-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["signal","network","connection","wifi","reception","strength","bars","connectivity","online","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19L10 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19L5 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19L15 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L20 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","wifi","connection","signal","internet","wireless","connectivity","router"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-4-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","signal","connection","strength","wifi","internet","data","reception","connectivity","online","wireless","bars"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 10C9.44772 10 9 10.4477 9 11V19C9 19.5523 9.44772 20 10 20C10.5523 20 11 19.5523 11 19V11C11 10.4477 10.5523 10 10 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 14C5.55228 14 6 14.4477 6 15L6 19C6 19.5523 5.55228 20 5 20C4.44772 20 4 19.5523 4 19L4 15C4 14.4477 4.44772 14 5 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 6C14.4477 6 14 6.44772 14 7V19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19V7C16 6.44772 15.5523 6 15 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 4C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19V5C19 4.44772 19.4477 4 20 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["network","wifi","connection","signal","wireless","internet","connectivity","pos-system","online"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["network","wifi","connection","signal","wireless","connectivity","online","internet","data","sync","cloud"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","wifi","signal","connection","internet","connectivity","online","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C8.13401 6 5 9.13401 5 13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13C19 9.13401 15.866 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 9C9.79086 9 8 10.7909 8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 10.7909 14.2091 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.3062 14.1652 15.4175 13 15.8293L13 19C13 19.5523 12.5523 20 12 20C11.4478 20 11 19.5523 11 19L11 15.8293C9.83481 15.4175 9 14.3062 9 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-bars-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["network","bars","signal","connection","strength","wifi","connectivity","reception"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 14.5V17.5C3 18.3284 3.67157 19 4.5 19C5.32843 19 6 18.3284 6 17.5V14.5C6 13.6716 5.32843 13 4.5 13C3.67157 13 3 13.6716 3 14.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10.5V17.5C8 18.3284 8.67157 19 9.5 19C10.3284 19 11 18.3284 11 17.5V10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V17.5C13 18.3284 13.6716 19 14.5 19C15.3284 19 16 18.3284 16 17.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6.5V17.5C18 18.3284 18.6716 19 19.5 19C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["graph","stats","statistics","chart","report","sales","analytics","performance","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12.5V15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5V12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["signal","network","wifi","connection","bars","strength","connectivity","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 14.5V17.5C3 18.3284 3.67157 19 4.5 19C5.32843 19 6 18.3284 6 17.5V14.5C6 13.6716 5.32843 13 4.5 13C3.67157 13 3 13.6716 3 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10.5V17.5C8 18.3284 8.67157 19 9.5 19C10.3284 19 11 18.3284 11 17.5V10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V17.5C13 18.3284 13.6716 19 14.5 19C15.3284 19 16 18.3284 16 17.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6.5V17.5C18 18.3284 18.6716 19 19.5 19C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","bars","statistics","analytics","sales","performance","metrics","data","reports","trends"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12.5V15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5V12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 8.5V15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-bars-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","strength","network","connection","wifi","data","connectivity","reception","bars","levels","performance","internet","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 14.5V17.5C3 18.3284 3.67157 19 4.5 19C5.32843 19 6 18.3284 6 17.5V14.5C6 13.6716 5.32843 13 4.5 13C3.67157 13 3 13.6716 3 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 10.5V17.5C8 18.3284 8.67157 19 9.5 19C10.3284 19 11 18.3284 11 17.5V10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 8.5V17.5C13 18.3284 13.6716 19 14.5 19C15.3284 19 16 18.3284 16 17.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 6.5V17.5C18 18.3284 18.6716 19 19.5 19C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-bars-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","bars","connectivity","network","strength","reception","sales-trend","performance","analytics","dashboard","data","metrics","growth","inventory","stock","levels","cash-flow","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13.5V16.5C5 17.3284 5.67157 18 6.5 18C7.32843 18 8 17.3284 8 16.5V13.5C8 12.6716 7.32843 12 6.5 12C5.67157 12 5 12.6716 5 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9.5V16.5C10 17.3284 10.6716 18 11.5 18C12.3284 18 13 17.3284 13 16.5V9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7.5V16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["signal","network","wifi","connection","strength","reception","connectivity","bars","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13.5V16.5C5 17.3284 5.67157 18 6.5 18C7.32843 18 8 17.3284 8 16.5V13.5C8 12.6716 7.32843 12 6.5 12C5.67157 12 5 12.6716 5 13.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9.5V16.5C10 17.3284 10.6716 18 11.5 18C12.3284 18 13 17.3284 13 16.5V9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7.5V16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["signal","bars","growth","increase","wifi","network","connection","strength","volume","sales","performance","rising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13.5V16.5C5 17.3284 5.67157 18 6.5 18C7.32843 18 8 17.3284 8 16.5V13.5C8 12.6716 7.32843 12 6.5 12C5.67157 12 5 12.6716 5 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 9.5V16.5C10 17.3284 10.6716 18 11.5 18C12.3284 18 13 17.3284 13 16.5V9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7.5V16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","bars","connection","strength","network","wifi","reception","status","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13.5V16.5C5 17.3284 5.67157 18 6.5 18C7.32843 18 8 17.3284 8 16.5V13.5C8 12.6716 7.32843 12 6.5 12C5.67157 12 5 12.6716 5 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 9.5V16.5C10 17.3284 10.6716 18 11.5 18C12.3284 18 13 17.3284 13 16.5V9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 7.5V16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-bars-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","bars","signal","data","statistics","analytics","performance","growth","sales","trending","reporting","insights","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12.5V15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5V12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["bars","statistics","sales","report","graph","data","analytics","performance","metrics","trend","growth","dashboard","chart","summary","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12.5V15.5C8 16.3284 8.67157 17 9.5 17C10.3284 17 11 16.3284 11 15.5V12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V15.5C13 16.3284 13.6716 17 14.5 17C15.3284 17 16 16.3284 16 15.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-bars": {
        defaultColors: ["#3D4C66"],
        keywords: ["signal","network","connection","strength","wifi","reception","connectivity","service","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 14.5V17.5C3 18.3284 3.67157 19 4.5 19C5.32843 19 6 18.3284 6 17.5V14.5C6 13.6716 5.32843 13 4.5 13C3.67157 13 3 13.6716 3 14.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 10.5V17.5C8 18.3284 8.67157 19 9.5 19C10.3284 19 11 18.3284 11 17.5V10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 8.5V17.5C13 18.3284 13.6716 19 14.5 19C15.3284 19 16 18.3284 16 17.5V8.5C16 7.67157 15.3284 7 14.5 7C13.6716 7 13 7.67157 13 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 6.5V17.5C18 18.3284 18.6716 19 19.5 19C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "network-wired-share-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["network","share","connection","distribution","split","tree","branch","hierarchy","options","flow","process","workflow","system","node","structure","multi-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5V5C14.1144 5 13.1716 5 12.5858 5.58579C12 6.17157 12 7.11438 12 9L12 12M16 19V19C14.1144 19 13.1716 19 12.5858 18.4142C12.5858 18.4142 12.5858 18.4142 12.5858 18.4142C12 17.8284 12 16.8856 12 15L12 12M8 12L12 12M12 12L16 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 3C19.1046 3 20 3.89543 20 5C20 6.10457 19.1046 7 18 7C16.8954 7 16 6.10457 16 5C16 3.89543 16.8954 3 18 3Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "network-wired-share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["network","share","distribution","branches","splitting","tiers","hierarchy","structure","tiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5V5C14.1144 5 13.1716 5 12.5858 5.58579C12 6.17157 12 7.11438 12 9L12 12M16 19V19C14.1144 19 13.1716 19 12.5858 18.4142C12.5858 18.4142 12.5858 18.4142 12.5858 18.4142C12 17.8284 12 16.8856 12 15L12 12M8 12L12 12M12 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 3C19.1046 3 20 3.89543 20 5C20 6.10457 19.1046 7 18 7C16.8954 7 16 6.10457 16 5C16 3.89543 16.8954 3 18 3Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "network-wired-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","share","hierarchy","organization","branch","connections","data-flow","distribution","server","menu-branch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1716 6.00252C14.6462 6.00744 14.254 6.02191 13.9387 6.06431C13.505 6.12263 13.369 6.21677 13.2929 6.2929C13.2168 6.36902 13.1226 6.50497 13.0643 6.93871C13.0021 7.40122 13 8.02893 13 9V11H15.1707C15.5825 9.83482 16.6938 9 18 9C19.6569 9 21 10.3431 21 12C21 13.6569 19.6569 15 18 15C16.6938 15 15.5826 14.1652 15.1707 13H13L13 15C13 15.9711 13.0021 16.5988 13.0643 17.0613C13.1226 17.495 13.2168 17.631 13.2929 17.7071C13.369 17.7832 13.505 17.8774 13.9387 17.9357C14.254 17.9781 14.6462 17.9926 15.1716 17.9975C15.5841 16.8336 16.6947 16 18 16C19.6569 16 21 17.3431 21 19C21 20.6569 19.6569 22 18 22C16.693 22 15.5812 21.1642 15.1699 19.9978C14.6029 19.9927 14.1003 19.9754 13.6722 19.9179C13.0167 19.8297 12.3883 19.631 11.8787 19.1213C11.369 18.6117 11.1703 17.9833 11.0821 17.3278C10.9999 16.7161 10.9999 15.9523 11 15.0659L11 13H8.82929C8.41745 14.1652 7.30621 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.30623 9 8.41747 9.83482 8.8293 11H11L11 8.93417C10.9999 8.0477 10.9999 7.28387 11.0821 6.67221C11.1703 6.0167 11.369 5.38835 11.8787 4.87868C12.3883 4.36902 13.0167 4.17028 13.6722 4.08215C14.1003 4.02459 14.6029 4.00734 15.1699 4.00218C15.5812 2.83585 16.693 2 18 2C19.6569 2 21 3.34315 21 5C21 6.65685 19.6569 8 18 8C16.6947 8 15.5841 7.16639 15.1716 6.00252ZM17 5C17 4.44772 17.4477 4 18 4C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6C17.4477 6 17 5.55228 17 5ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11ZM17 19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19ZM18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "network-wired-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","share","branch","connection","hierarchy","distribution","server","data-flow","structure","system","connections"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5V5C14.1144 5 13.1716 5 12.5858 5.58579C12 6.17157 12 7.11438 12 9L12 12M16 19V19C14.1144 19 13.1716 19 12.5858 18.4142C12.5858 18.4142 12.5858 18.4142 12.5858 18.4142C12 17.8284 12 16.8856 12 15L12 12M8 12L12 12M12 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 3C19.1046 3 20 3.89543 20 5C20 6.10457 19.1046 7 18 7C16.8954 7 16 6.10457 16 5C16 3.89543 16.8954 3 18 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    network: {
        defaultColors: ["#3D4C66"],
        keywords: ["network","share","branch","connection","hierarchy","distribution","server","data-flow","structure","system","connections"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7V7C14.0681 7 13.6022 7 13.2346 7.15224C12.7446 7.35523 12.3552 7.74458 12.1522 8.23463C12 8.60218 12 9.06812 12 10L12 12M15 17H15C14.0681 17 13.6022 17 13.2346 16.8478C12.7446 16.6448 12.3552 16.2554 12.1522 15.7654C12 15.3978 12 14.9319 12 14L12 12M9 12L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 14C19.6569 14 21 15.3431 21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C16.3431 10 15 8.65685 15 7C15 5.34315 16.3431 4 18 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "new-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["new","new-item","add-item","new-product","add-product","update","new-arrival","latest","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 14L16 12L17 14L17 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M13 12L11 12M11 12L11 14L13 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "new-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["new","item","product","add","addition","latest","fresh","new-arrival","new-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 14L16 12L17 14L17 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M13 12L11 12M11 12L11 14L13 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "new-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["new","new-item","add-item","new-product","add-product","latest","recent","updated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57533 2.99997 7.45869 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45869 2.99997 8.57529 3 9.92939V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.57531 21 9.92944 21H14.0705C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92946C21 8.57534 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM7.67082 9.6646C7.51527 9.35349 7.16621 9.19016 6.82769 9.27008C6.48916 9.34999 6.25 9.65218 6.25 10V14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14V13.1771L8.32918 14.3354C8.48474 14.6465 8.83379 14.8099 9.17231 14.7299C9.51084 14.65 9.75 14.3478 9.75 14L9.75 10C9.75 9.5858 9.41421 9.25001 9 9.25001C8.58579 9.25001 8.25 9.5858 8.25 10L8.25 10.823L7.67082 9.6646ZM11 9.25001C10.8011 9.25001 10.6103 9.32903 10.4697 9.46968C10.329 9.61034 10.25 9.8011 10.25 10V14C10.25 14.1989 10.329 14.3897 10.4697 14.5303C10.6103 14.671 10.8011 14.75 11 14.75H13C13.4142 14.75 13.75 14.4142 13.75 14C13.75 13.5858 13.4142 13.25 13 13.25H11.75V12.75L13 12.75C13.4142 12.75 13.75 12.4142 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25L11.75 11.25V10.75H13C13.4142 10.75 13.75 10.4142 13.75 10C13.75 9.5858 13.4142 9.25001 13 9.25001H11ZM15.75 10C15.75 9.5858 15.4142 9.25001 15 9.25001C14.5858 9.25001 14.25 9.5858 14.25 10V14C14.25 14.3478 14.4892 14.65 14.8277 14.7299C15.1662 14.8099 15.5153 14.6465 15.6708 14.3354L16 13.6771L16.3292 14.3354C16.4847 14.6465 16.8338 14.8099 17.1723 14.7299C17.5108 14.65 17.75 14.3478 17.75 14L17.75 10C17.75 9.5858 17.4142 9.25001 17 9.25001C16.5858 9.25001 16.25 9.5858 16.25 10V11.2929C16.171 11.2649 16.0866 11.25 16 11.25C15.9134 11.25 15.829 11.2649 15.75 11.2929V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    new: {
        defaultColors: ["#3D4C66"],
        keywords: ["new","new-item","add-item","new-product","add-product","latest","recent","updated"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L15 14L16 12L17 14L17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M13 12L11 12M11 12L11 14L13 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "news-feed-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["document","list","report","news","feed","sales-report","order-summary","transactions","history","details","receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 12H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15H8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H12C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17158 16 7.11439 16 9.00001L16 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H16.5C17.9045 12 18.6067 12 19.1111 12.3371C19.3295 12.483 19.517 12.6705 19.6629 12.8889C20 13.3933 20 14.0955 20 15.5V15.5C20 16.9045 20 17.6067 19.6629 18.1111C19.517 18.3295 19.3295 18.517 19.1111 18.6629C18.6067 19 17.9045 19 16.5 19H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "news-feed-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["list","menu","options","report","summary","invoice","receipt","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 19H14.5C13.0955 19 12.3933 19 11.8889 18.6629C11.6705 18.517 11.483 18.3295 11.3371 18.1111C11 17.6067 11 16.9045 11 15.5C11 14.0955 11 13.3933 11.3371 12.8889C11.483 12.6705 11.6705 12.483 11.8889 12.3371C12.3933 12 13.0955 12 14.5 12H16.5C17.9045 12 18.6067 12 19.1111 12.3371C19.3295 12.483 19.517 12.6705 19.6629 12.8889C20 13.3933 20 14.0955 20 15.5C20 16.9045 20 17.6067 19.6629 18.1111C19.517 18.3295 19.3295 18.517 19.1111 18.6629C18.6067 19 17.9045 19 16.5 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H12C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17157 16 7.11438 16 9V19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 9H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 12H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "news-feed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["news","feed","list","document","report","menu","invoice","receipt","transaction","history","log"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 4C7.04769 3.99995 6.28387 3.99991 5.67221 4.08215C5.0167 4.17028 4.38835 4.36902 3.87868 4.87868C3.36902 5.38835 3.17028 6.0167 3.08215 6.67221C2.99991 7.28387 2.99995 8.04769 3 8.93417V15.0658C2.99995 15.9523 2.99991 16.7161 3.08215 17.3278C3.17028 17.9833 3.36902 18.6117 3.87868 19.1213C4.38835 19.631 5.0167 19.8297 5.67221 19.9179C6.28387 20.0001 7.04769 20.0001 7.93417 20L17 20L17 8.93417C17.0001 8.04769 17.0001 7.28387 16.9179 6.67221C16.8297 6.0167 16.631 5.38835 16.1213 4.87868C15.6117 4.36902 14.9833 4.17028 14.3278 4.08215C13.7161 3.99991 12.9523 3.99995 12.0658 4H7.93417ZM7 9C7 8.44772 7.44772 8 8 8H12C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10H8C7.44772 10 7 9.55228 7 9ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H8ZM7 15C7 14.4477 7.44772 14 8 14H12C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16H8C7.44772 16 7 15.5523 7 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.5 11.0796V19.9205C18.9046 19.8583 19.2998 19.7396 19.6667 19.4944C19.9943 19.2755 20.2755 18.9943 20.4944 18.6667C20.791 18.2228 20.9026 17.7375 20.9527 17.2443C21.0001 16.7791 21 16.2093 21 15.5486V15.4514C21 14.7907 21.0001 14.2209 20.9527 13.7557C20.9026 13.2625 20.791 12.7772 20.4944 12.3333C20.2755 12.0057 19.9943 11.7245 19.6667 11.5056C19.2998 11.2604 18.9046 11.1417 18.5 11.0796Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "news-feed": {
        defaultColors: ["#3D4C66"],
        keywords: ["news","feed","report","document","paper","list","invoice","receipt","history","transaction-history","sales-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 12H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15H8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H12C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17158 16 7.11439 16 9.00001L16 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 12H16.5C17.9045 12 18.6067 12 19.1111 12.3371C19.3295 12.483 19.517 12.6705 19.6629 12.8889C20 13.3933 20 14.0955 20 15.5V15.5C20 16.9045 20 17.6067 19.6629 18.1111C19.517 18.3295 19.3295 18.517 19.1111 18.6629C18.6067 19 17.9045 19 16.5 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Newspaper-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["report","document","list","receipt","transaction","history","details","invoice","sales-report","records"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V15C20 13.1144 20 12.1716 19.4142 11.5858C18.8284 11 17.8856 11 16 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 19V9C16 7.11438 16 6.17157 15.4142 5.58579C14.8284 5 13.8856 5 12 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L8 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Newspaper-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["document","list","receipt","invoice","report","paper","details","transaction-history","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="11"
                    width="16"
                    height="8"
                    rx="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 15V9C4 7.11438 4 6.17157 4.58579 5.58579C5.17157 5 6.11438 5 8 5H12C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17157 16 7.11438 16 9V15C16 16.8856 16 17.8284 15.4142 18.4142C14.8284 19 13.8856 19 12 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Newspaper-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["reports","list","menu","order-summary","daily-sales","summary","invoice","receipt","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_42902)">
                    <path
                        d="M20.9201 12.6698C20.8301 12.0098 20.6301 11.3898 20.1201 10.8798C19.6101 10.3698 18.9801 10.1698 18.3301 10.0798C18.2301 10.0698 18.1101 10.0598 18.0001 10.0498V15.1098C18.0001 15.9598 18.0001 16.7798 17.9101 17.4598C17.8101 18.2298 17.5601 19.0998 16.8301 19.8298C16.7601 19.8998 16.6901 19.9398 16.6201 19.9998C17.2701 19.9998 17.8501 19.9798 18.3301 19.9198C18.9901 19.8298 19.6101 19.6298 20.1201 19.1198C20.6301 18.6098 20.8301 17.9798 20.9201 17.3298C21.0001 16.7198 21.0001 15.9498 21.0001 15.0698V14.9398C21.0001 14.0498 21.0001 13.2898 20.9201 12.6798V12.6698Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                    <path
                        d="M17 15.07V10.08V8.94C17 8.05 17 7.29 16.92 6.68C16.83 6.02 16.63 5.4 16.12 4.89C15.61 4.38 14.98 4.18 14.33 4.09C13.72 4 12.95 4 12.07 4H7.93C7.04 4 6.28 4 5.67 4.08C5.01 4.17 4.39 4.37 3.88 4.88C3.37 5.39 3.17 6.02 3.08 6.67C3 7.28 3 8.05 3 8.93V15.06C3 15.95 3 16.71 3.08 17.32C3.17 17.98 3.37 18.6 3.88 19.11C4.39 19.62 5.02 19.82 5.67 19.91C6.28 19.99 7.05 19.99 7.93 19.99H12.06C12.95 19.99 13.71 19.99 14.32 19.91C14.65 19.87 14.97 19.79 15.28 19.67C15.58 19.55 15.86 19.37 16.12 19.12C16.63 18.61 16.83 17.98 16.92 17.33C17 16.72 17 15.95 17 15.07ZM7 15C7 14.45 7.45 14 8 14H12C12.55 14 13 14.45 13 15C13 15.55 12.55 16 12 16H8C7.45 16 7 15.55 7 15ZM13 9C13 9.55 12.55 10 12 10H8C7.45 10 7 9.55 7 9C7 8.45 7.45 8 8 8H12C12.55 8 13 8.45 13 9ZM13 12C13 12.55 12.55 13 12 13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H12C12.55 11 13 11.45 13 12Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_42902">
                        <rect width="18" height="16" fill={colors?.[1] || "#FFFFFF"} transform="translate(3 4)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    Newspaper: {
        defaultColors: ["#3D4C66"],
        keywords: ["reports","list","menu","order-summary","daily-sales","summary","invoice","receipt","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11V15C4 16.8856 4 17.8284 4.58579 18.4142C5.17157 19 6.11438 19 8 19H16C17.8856 19 18.8284 19 19.4142 18.4142C20 17.8284 20 16.8856 20 15V15C20 13.1144 20 12.1716 19.4142 11.5858C18.8284 11 17.8856 11 16 11V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 19V9C16 7.11438 16 6.17157 15.4142 5.58579C14.8284 5 13.8856 5 12 5H8C6.11438 5 5.17157 5 4.58579 5.58579C4 6.17157 4 7.11438 4 9V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "next-plan-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["undo","return","back","previous","revert","reverse","cancel","reload","refresh","transaction-history","redo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L16 13L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "next-plan-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["undo","arrow","back","return","reverse","redo","previous","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L16 13L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "next-plan-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","back","return","reverse","previous","arrow-left","revert","rollback","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 10C10.3431 10 9 11.3431 9 13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13C7 10.2386 9.23858 8 12 8C14.0797 8 15.8628 9.26969 16.6165 11.0762C16.9791 10.9258 17.4123 10.998 17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L16.7071 13.7071C16.5142 13.9 16.2621 13.9976 16.0092 14L15.7098 13.9572L15.7182 13.9597L16 14L15.9908 14C15.8962 13.9991 15.8048 13.9851 15.7182 13.9597L15.7098 13.9572C15.6786 13.9478 15.6481 13.9369 15.6183 13.9246C15.5 13.8758 15.3891 13.8033 15.2929 13.7071L14.2929 12.7071C13.9024 12.3166 13.9024 11.6834 14.2929 11.2929C14.3255 11.2603 14.3598 11.2304 14.3955 11.2032L14.4001 11.1998C13.8527 10.4712 12.9814 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "next-plan": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","redo","repeat","reverse","back","return","circular-arrow","transaction-reversal","order-correction","edit","history","rollback","refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L16 13L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "nft-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["NFT","digital asset","collectible","crypto","blockchain","token","unique item","ownership","digital art","digital goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M11 14L11 12M13 12L11 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17 10M16 10L16 12L16 14M16 10L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "nft-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["NFT","non-fungible token","digital asset","crypto","collectibles","blockchain","transaction","digital ownership","art","digital item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M11 14L11 12M13 12L11 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17 10M16 10L16 12L16 14M16 10L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "nft-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["nft","non-fungible token","digital asset","crypto","blockchain","collectible","digital item","digital ownership","tokenized asset","unique item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM7.67082 9.66466C7.51527 9.35355 7.16621 9.19022 6.82769 9.27014C6.48916 9.35005 6.25 9.65224 6.25 10.0001V14.0001C6.25 14.4143 6.58579 14.7501 7 14.7501C7.41421 14.7501 7.75 14.4143 7.75 14.0001V13.1771L8.32918 14.3355C8.48474 14.6466 8.83379 14.8099 9.17231 14.73C9.51084 14.6501 9.75 14.3479 9.75 14.0001L9.75 10.0001C9.75 9.58586 9.41421 9.25007 9 9.25007C8.58579 9.25007 8.25 9.58586 8.25 10.0001L8.25 10.823L7.67082 9.66466ZM11 9.25007C10.8011 9.25007 10.6103 9.32909 10.4697 9.46974C10.329 9.6104 10.25 9.80116 10.25 10.0001V14.0001C10.25 14.4143 10.5858 14.7501 11 14.7501C11.4142 14.7501 11.75 14.4143 11.75 14.0001V12.7501L13 12.7501C13.4142 12.7501 13.75 12.4143 13.75 12.0001C13.75 11.5859 13.4142 11.2501 13 11.2501L11.75 11.2501V10.7501H13C13.4142 10.7501 13.75 10.4143 13.75 10.0001C13.75 9.58586 13.4142 9.25007 13 9.25007H11ZM14.25 10.0001C14.25 10.4143 14.5858 10.7501 15 10.7501H15.25V14.0001C15.25 14.4143 15.5858 14.7501 16 14.7501C16.4142 14.7501 16.75 14.4143 16.75 14.0001V10.7501H17C17.4142 10.7501 17.75 10.4143 17.75 10.0001C17.75 9.58586 17.4142 9.25007 17 9.25007H15C14.5858 9.25007 14.25 9.58586 14.25 10.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "nft-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["nft","token","blockchain","crypto","digital-asset","artwork","unique","collectible"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 16V8L12 4L19 8V16L12 20L5 16Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 16L15 13L8 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="9.5" cy="10.5" r="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "nft-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["nft","image","photo","gallery","asset","digital-asset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 16L15 13L8 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="9.5" cy="10.5" r="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M5 16V8L12 4L19 8V16L12 20L5 16Z" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "nft-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image","media","gallery","stock","photo","landscape","pictures","photos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 16V8L12 4L19 8V16L12 20L5 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M19 16L15 13L8 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="9.5"
                    cy="10.5"
                    r="1.5"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "nft-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["nft","non-fungible token","crypto","cryptocurrency","digital art","collectibles","blockchain","artwork","digital asset","transaction","ownership","token"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.7602 17.2887L14.9803 14.2647L8.47981 19.1401L12 21.1516L18.7602 17.2887Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2.84814L20 7.41957V15.7193L15.0198 11.7351L6.58792 18.059L4 16.5802V7.41957L12 2.84814ZM8 7.5C6.89543 7.5 6 8.39543 6 9.5C6 10.6046 6.89543 11.5 8 11.5C9.10457 11.5 10 10.6046 10 9.5C10 8.39543 9.10457 7.5 8 7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    nft: {
        defaultColors: ["#3D4C66"],
        keywords: ["nft","non-fungible token","crypto","cryptocurrency","digital art","collectibles","blockchain","artwork","digital asset","transaction","ownership","token"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10L9 14L7 10L7 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10L11 10L11 12M11 14L11 12M13 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17 10M16 10L16 12L16 14M16 10L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "no wifi-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["no-wifi","wifi-off","connection-lost","offline","disconnected","network-error","no-signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="16" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 11.9999C7.51257 10.7728 8.6445 9.82042 10 9.34131M17.1973 11.9999C16.4875 10.7728 15.3556 9.82042 14.0001 9.34131"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4L12 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5 10.0233C18.4228 8.40316 16.8346 7.15203 14.9655 6.5M4.5 10.0233C5.57722 8.40316 7.16541 7.15203 9.03451 6.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "no wifi-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["no-wifi","offline","no connection","disconnected","network error","wifi problem","signal lost","connection failed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="16"
                    r="2"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.80273 11.9999C7.51257 10.7728 8.6445 9.82042 10 9.34131M17.1973 11.9999C16.4875 10.7728 15.3556 9.82042 14.0001 9.34131"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4L12 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5 10.0233C18.4228 8.40316 16.8346 7.15203 14.9655 6.5M4.5 10.0233C5.57722 8.40316 7.16541 7.15203 9.03451 6.5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "no wifi-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-wifi","offline","disconnected","no-connection","signal-lost","network-error","connection-problem","data-loss","internet-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="16" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path
                    d="M12 4L12 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2712 6.17089C14.4532 5.64942 15.0234 5.37416 15.5448 5.55608C17.623 6.28106 19.3867 7.67108 20.5827 9.46991C20.8885 9.92981 20.7635 10.5505 20.3036 10.8563C19.8437 11.1621 19.223 11.0372 18.9172 10.5773C17.9588 9.13578 16.546 8.02355 14.8861 7.44447C14.3646 7.26256 14.0893 6.69236 14.2712 6.17089ZM14.0145 9.17689C14.2597 8.68203 14.8596 8.47965 15.3545 8.72486C16.5934 9.33878 17.6236 10.308 18.3129 11.4995C18.5894 11.9776 18.4261 12.5893 17.948 12.8659C17.47 13.1424 16.8582 12.9791 16.5817 12.501C16.0888 11.6489 15.3513 10.9554 14.4665 10.5169C13.9716 10.2717 13.7692 9.67175 14.0145 9.17689Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.72881 6.17092C9.5469 5.64945 8.9767 5.37419 8.45523 5.5561C6.37701 6.28109 4.61339 7.6711 3.41737 9.46993C3.11159 9.92984 3.23653 10.5506 3.69643 10.8563C4.15634 11.1621 4.77705 11.0372 5.08284 10.5773C6.04126 9.13581 7.45402 8.02358 9.114 7.4445C9.63546 7.26258 9.91072 6.69238 9.72881 6.17092ZM9.9856 9.17692C9.74038 8.68206 9.14043 8.47968 8.64557 8.72489C7.40663 9.33881 6.37645 10.308 5.68715 11.4996C5.41061 11.9776 5.57397 12.5894 6.05203 12.8659C6.53009 13.1424 7.14182 12.9791 7.41837 12.501C7.91129 11.6489 8.64875 10.9554 9.53357 10.5169C10.0284 10.2717 10.2308 9.67178 9.9856 9.17692Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "no wifi": {
        defaultColors: ["#3D4C66"],
        keywords: ["no-wifi","offline","disconnected","no-connection","signal-lost","no-service","network-error","connectivity-problem","sync-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="16" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 11.9999C7.51257 10.7728 8.6445 9.82042 10 9.34131M17.1973 11.9999C16.4875 10.7728 15.3556 9.82042 14.0001 9.34131"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 4L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5 10.0233C18.4228 8.40316 16.8346 7.15203 14.9655 6.5M4.5 10.0233C5.57722 8.40316 7.16541 7.15203 9.03451 6.5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "not-equal-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["not-equal","different","variation","discrepancy","mismatch","conflict","error","exception","invalid","incorrect","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 19L14 5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "not-equal-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["not-equal","different","mismatch","error","invalid","discrepancy","issue","flag","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 19L14 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "not-equal-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["not-equal","unequal","difference","different","mismatch","invalid","error","discrepancy","compare","comparison","exclude","exclusion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2747 4.03825C14.8058 4.18997 15.1133 4.74346 14.9615 5.27449L13.8971 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H13.3257L12.7542 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H12.1828L10.9615 19.2745C10.8098 19.8055 10.2563 20.113 9.72529 19.9613C9.19426 19.8096 8.88677 19.2561 9.03849 18.725L10.1028 15H5C4.44772 15 4 14.5523 4 14C4 13.4477 4.44772 13 5 13H10.6742L11.2456 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H11.8171L13.0385 4.72505C13.1902 4.19401 13.7437 3.88652 14.2747 4.03825Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "not-equal": {
        defaultColors: ["#3D4C66"],
        keywords: ["not-equal","unequal","different","conflict","error","invalid","mismatch","disagreement","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 19L14 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 14H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "notes-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["notes","list","document","report","details","order-details","receipt","invoice","transaction-history","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "notes-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["notes","list","document","receipt","invoice","transaction-history","report","details","record","sales-report","summary","bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9L9 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "notes-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["notes","list","menu","details","description","receipt","invoice","record","options","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 4.08215C8.28387 3.99991 9.04769 3.99995 9.93417 4H14.0658C14.9523 3.99995 15.7161 3.99991 16.3278 4.08215C16.9833 4.17028 17.6117 4.36902 18.1213 4.87868C18.631 5.38835 18.8297 6.0167 18.9179 6.67221C19.0001 7.28387 19.0001 8.04769 19 8.93417V15.0658C19.0001 15.9523 19.0001 16.7161 18.9179 17.3278C18.8297 17.9833 18.631 18.6117 18.1213 19.1213C17.6117 19.631 16.9833 19.8297 16.3278 19.9179C15.7161 20.0001 14.9523 20.0001 14.0658 20H9.93417C9.04769 20.0001 8.28387 20.0001 7.67221 19.9179C7.0167 19.8297 6.38835 19.631 5.87868 19.1213C5.36902 18.6117 5.17028 17.9833 5.08215 17.3278C4.99991 16.7161 4.99995 15.9523 5 15.0658V8.93417C4.99995 8.04769 4.99991 7.28387 5.08215 6.67221C5.17028 6.0167 5.36902 5.38835 5.87868 4.87868C6.38835 4.36902 7.0167 4.17028 7.67221 4.08215ZM15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H9C8.44772 10 8 9.55228 8 9C8 8.44771 8.44772 8 9 8L15 8ZM14 12C14 12.5523 13.5523 13 13 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H13C13.5523 11 14 11.4477 14 12ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14H9C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "notes-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["notes","clipboard","list","notepad","order-notes","customer-notes","transaction-notes","receipt-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 5L15.5294 5.88235C14.9791 6.9141 14.704 7.42997 14.229 7.71499C13.754 8 13.1693 8 12 8V8C10.8307 8 10.246 8 9.77101 7.71499C9.29599 7.42997 9.02085 6.9141 8.47059 5.88235L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "notes-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["notes","clipboard","list","order-details","record","details","notepad","receipt","sales-record","transaction-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 5L15.5294 5.88235C14.9791 6.9141 14.704 7.42997 14.229 7.71499C13.754 8 13.1693 8 12 8V8C10.8307 8 10.246 8 9.77101 7.71499C9.29599 7.42997 9.02085 6.9141 8.47059 5.88235L8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "notes-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["notes","document","list","order-details","receipt","transaction-history","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 12L10 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5L15 5C15.4466 5 15.6699 5 15.7572 5.14565C15.8446 5.2913 15.7396 5.48832 15.5294 5.88235C14.9791 6.9141 14.704 7.42997 14.229 7.71499C13.754 8 13.1693 8 12 8C10.8307 8 10.246 8 9.77101 7.71499C9.29599 7.42997 9.02085 6.9141 8.47059 5.88235C8.26044 5.48832 8.15536 5.2913 8.24275 5.14565C8.33014 5 8.55343 5 9 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "notes-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["notes","note","list","task-list","tasks","receipt","order-details","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.67221 4.08215C8.28387 3.99991 9.04769 3.99995 9.93417 4H14.0658C14.9523 3.99995 15.7161 3.99991 16.3278 4.08215C16.9833 4.17028 17.6117 4.36902 18.1213 4.87868C18.631 5.38835 18.8297 6.0167 18.9179 6.67221C19.0001 7.28387 19.0001 8.04769 19 8.93417V15.0658C19.0001 15.9523 19.0001 16.7161 18.9179 17.3278C18.8297 17.9833 18.631 18.6117 18.1213 19.1213C17.6117 19.631 16.9833 19.8297 16.3278 19.9179C15.7161 20.0001 14.9523 20.0001 14.0658 20H9.93417C9.04769 20.0001 8.28387 20.0001 7.67221 19.9179C7.0167 19.8297 6.38835 19.631 5.87868 19.1213C5.36902 18.6117 5.17028 17.9833 5.08215 17.3278C4.99991 16.7161 4.99995 15.9523 5 15.0658V8.93417C4.99995 8.04769 4.99991 7.28387 5.08215 6.67221C5.17028 6.0167 5.36902 5.38835 5.87868 4.87868C6.38835 4.36902 7.0167 4.17028 7.67221 4.08215ZM13.6318 9.48845C13.5111 9.50018 13.3744 9.50013 13.2553 9.50008L10.7446 9.50008C10.6255 9.50013 10.4888 9.50018 10.3682 9.48845C10.2239 9.47443 10.0476 9.43996 9.86719 9.33783C9.68681 9.2357 9.56651 9.1022 9.48029 8.98574C9.40813 8.88828 9.33785 8.77105 9.27663 8.66892L8.53859 7.43885L8.53051 7.42544C8.4998 7.37461 8.44105 7.27734 8.40187 7.18287C8.35683 7.07427 8.24906 6.76307 8.43692 6.43128C8.62478 6.09949 8.94708 6.03179 9.06337 6.01454C9.16453 5.99953 9.27817 5.99987 9.33755 6.00004L9.35321 6.00008L14.6467 6.00008L14.6624 6.00004C14.7218 5.99987 14.8354 5.99953 14.9366 6.01454C15.0529 6.03179 15.3752 6.09949 15.563 6.43128C15.7509 6.76307 15.6431 7.07427 15.5981 7.18287C15.5589 7.27734 15.5001 7.37461 15.4694 7.42543L15.4614 7.43885L14.7233 8.66892C14.6621 8.77104 14.5918 8.88829 14.5197 8.98574C14.4334 9.1022 14.3131 9.2357 14.1328 9.33783C13.9524 9.43996 13.776 9.47443 13.6318 9.48845ZM9 13C9 12.4477 9.44772 12 10 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H10C9.44772 14 9 13.5523 9 13ZM9 16C9 15.4477 9.44772 15 10 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H10C9.44772 17 9 16.5523 9 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "O-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["zero","o","circle","number","void","null","option","none"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10C7 7.23858 9.23858 5 12 5V5C14.7614 5 17 7.23858 17 10V14C17 16.7614 14.7614 19 12 19V19C9.23858 19 7 16.7614 7 14V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    notes: {
        defaultColors: ["#3D4C66"],
        keywords: ["zero","o","circle","number","void","null","option","none"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 15V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V15C18 16.8856 18 17.8284 17.4142 18.4142C16.8284 19 15.8856 19 14 19H10C8.11438 19 7.17157 19 6.58579 18.4142C6 17.8284 6 16.8856 6 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 9L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "O-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["zero","null","empty","void","none","cancelled","voided","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10C7 7.23858 9.23858 5 12 5V5C14.7614 5 17 7.23858 17 10V14C17 16.7614 14.7614 19 12 19V19C9.23858 19 7 16.7614 7 14V10Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "O-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["zero","null","void","empty","reset","cancel","clear","off","disable","circular","oval"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10V14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14V10ZM12 6C9.79086 6 8 7.79086 8 10V14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14V10C16 7.79086 14.2091 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "omega-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["omega","greek-letter","symbol","currency","exchange","configuration","settings","preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 19C5.8 16.3867 5 12.9333 5 11.5333C5 7.92507 8.13401 5 12 5C15.866 5 19 7.92507 19 11.5333C19 12.9333 18.2 16.3867 15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 19H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    O: {
        defaultColors: ["#3D4C66"],
        keywords: ["omega","greek-letter","symbol","currency","exchange","configuration","settings","preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10C7 7.23858 9.23858 5 12 5V5C14.7614 5 17 7.23858 17 10V14C17 16.7614 14.7614 19 12 19V19C9.23858 19 7 16.7614 7 14V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "omega-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["omega","loop","u-shape","symbol","loading","pending","refresh","cycle","waiting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 19C5.8 16.3867 5 12.9333 5 11.5333C5 7.92507 8.13401 5 12 5C15.866 5 19 7.92507 19 11.5333C19 12.9333 18.2 16.3867 15 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 19H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "omega-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["omega","incomplete","pending","waiting","balance","payment","incomplete-payment","pending-payment","waiting-payment","owing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.62019 6 6 8.54122 6 11.5333C6 12.6769 6.69706 15.8282 9.63253 18.2255C9.96004 18.4929 10.0839 18.9375 9.94195 19.3358C9.79998 19.7341 9.42284 20 9 20H5C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18H6.59103C4.57945 15.5342 4 12.8602 4 11.5333C4 7.30893 7.64783 4 12 4C16.3522 4 20 7.30893 20 11.5333C20 12.8602 19.4205 15.5342 17.409 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H15C14.5772 20 14.2 19.7341 14.0581 19.3358C13.9161 18.9375 14.04 18.4929 14.3675 18.2255C17.3029 15.8282 18 12.6769 18 11.5333C18 8.54122 15.3798 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    omega: {
        defaultColors: ["#3D4C66"],
        keywords: ["omega","incomplete","pending","waiting","balance","payment","incomplete-payment","pending-payment","waiting-payment","owing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 19H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19C5.8 16.3867 5 12.9333 5 11.5333C5 7.92507 8.13401 5 12 5C15.866 5 19 7.92507 19 11.5333C19 12.9333 18.2 16.3867 15 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "open-source-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["open-source","fork","branch","code","software","collaboration","development","community","version-control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 14.5987L8.87744 19.3677C6.0107 18.1512 4 15.3104 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 15.3104 17.9893 18.1512 15.1226 19.3677L13.5 14.5987"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 14.5987C9.6033 14.0799 9 13.1104 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.1104 14.3967 14.0799 13.5 14.5987"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "open-source-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["open","source","code","development","public","software","project","api","integration","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 15.3104 17.9893 18.1512 15.1226 19.3677L13.5 14.5987C14.3967 14.0799 15 13.1104 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.1104 9.6033 14.0799 10.5 14.5987L8.87744 19.3677C6.0107 18.1512 4 15.3104 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 14.5987C9.6033 14.0799 9 13.1104 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.1104 14.3967 14.0799 13.5 14.5987"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "open-source-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["open-source","license","code","software","development","community","api","integration","plugin","module"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 15.7258 18.7363 18.9205 15.5132 20.2882C15.2573 20.3968 14.9678 20.394 14.7141 20.2805C14.4604 20.1669 14.2654 19.9529 14.1759 19.6898L12.5592 14.9382C12.5107 14.8042 12.4925 14.6643 12.5024 14.5275C12.5255 14.2081 12.7012 13.9054 12.9993 13.733C13.5997 13.3857 14 12.739 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 12.739 10.4003 13.3857 11.0007 13.733C11.2261 13.8634 11.3816 14.0684 11.4539 14.2986C11.4772 14.3726 11.492 14.4494 11.4976 14.5275C11.5075 14.6643 11.4893 14.8042 11.4408 14.9382L9.82415 19.6898C9.73462 19.9529 9.53961 20.1669 9.2859 20.2805C9.03219 20.394 8.74268 20.3968 8.48681 20.2882C5.26372 18.9205 3 15.7258 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "open-source": {
        defaultColors: ["#3D4C66"],
        keywords: ["open","source","settings","connection","configuration","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 15.3104 17.9893 18.1512 15.1226 19.3677L13.5 14.5987C14.3967 14.0799 15 13.1104 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.1104 9.6033 14.0799 10.5 14.5987L8.87744 19.3677C6.0107 18.1512 4 15.3104 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "order-play-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["order","list","send","arrow","process","queue","checkout","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H6"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L18 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "order-play-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["menu","hamburger-menu","options","list","navigation","go","forward","next","proceed","arrow","send","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "order-play-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","submit","forward","next","lines","transfer","order-fulfillment","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4472 6.10555C15.9532 5.85856 15.3525 6.05878 15.1055 6.55276C15.0336 6.69658 14.9996 6.84945 14.9998 7H6C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H17.9795C18.1786 9.00393 18.3746 8.94803 18.5412 8.84102C18.65 8.77115 18.7463 8.6795 18.8228 8.56849C18.8959 8.46293 18.9492 8.34263 18.9773 8.21296C19.0336 7.9553 18.9843 7.68872 18.8485 7.47057C18.7746 7.35192 18.6752 7.24759 18.5532 7.16681C18.5135 7.14039 18.4718 7.11673 18.4283 7.09611L16.4472 6.10555Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 16C5 15.4477 5.44772 15 6 15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H6C5.44772 17 5 16.5523 5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "order-play": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","submit","arrow","lines","order","checkout","forward","queue","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "P-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["P","letter-p","payment","price","promotion","pending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19V12M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "P-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["P","payment","price","promotion","pay","print"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19V12M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H8Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "P-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["p","payment","parking","promotions","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 4.00001C9.96372 4.00001 9.98186 4.00001 10 4.00001H12.5C14.9853 4.00001 17 6.01473 17 8.50001C17 10.9853 14.9853 13 12.5 13H9.00001V19C9.00001 19.5523 8.5523 20 8.00001 20C7.44773 20 7.00001 19.5523 7.00001 19V7.00001C7.00001 6.98186 7.00001 6.96372 7.00001 6.94561C6.99992 6.52154 6.99984 6.10941 7.04554 5.76949C7.09706 5.38629 7.22259 4.94902 7.5858 4.5858C7.94902 4.22259 8.38629 4.09706 8.76949 4.04554C9.10941 3.99984 9.52154 3.99992 9.94561 4.00001ZM9.00001 11H12.5C13.8807 11 15 9.88073 15 8.50001C15 7.1193 13.8807 6.00001 12.5 6.00001H10C9.50034 6.00001 9.22618 6.00214 9.03599 6.02771C9.03351 6.02804 9.03108 6.02837 9.02871 6.02871C9.02838 6.03108 9.02804 6.03351 9.02771 6.03599C9.00214 6.22618 9.00001 6.50034 9.00001 7.00001V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "package bolt-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["bolt","lightning","fast","electricity","charge","express","instant","power","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 3L11 5.5H13L11.9998 8"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    P: {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","lightning","fast","electricity","charge","express","instant","power","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19V12M8 12V7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "package bolt-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","shipping","delivery","inventory","order","storage","container","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15.8184V8.42838L12.7878 11.5193L12.7878 11.5193C12.3994 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6006 11.6858 11.2122 11.5193L11.2122 11.5193L4 8.42838V15.8184C4 16.4239 4 16.7267 4.15103 16.9693C4.30206 17.2119 4.5737 17.3456 5.11699 17.6129L11.117 20.5653C11.5505 20.7786 11.7673 20.8853 12 20.8853C12.2327 20.8853 12.4495 20.7786 12.883 20.5653L18.883 17.6129C19.4263 17.3456 19.6979 17.2119 19.849 16.9693C20 16.7267 20 16.4239 20 15.8184Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M11.9998 3L11 5.5H13L11.9998 8"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "package bolt-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipping","fast","bolt","lightning","express"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.39392 6.9738C7.55709 7.35452 7.38073 7.79543 7 7.95859L5.90395 8.42833L11.5076 10.8299C11.7122 10.9176 11.8269 10.9662 11.9155 10.9962C11.9551 11.0096 11.9774 11.015 11.989 11.0173C11.9945 11.0184 11.9986 11.0188 11.9986 11.0188L12 11.0189L12.0014 11.0188C12.0014 11.0188 12.0055 11.0184 12.011 11.0173C12.0226 11.015 12.0449 11.0096 12.0845 10.9962C12.1731 10.9662 12.2878 10.9176 12.4924 10.8299L18.0961 8.42833L17 7.95859C16.6193 7.79543 16.4429 7.35452 16.6061 6.9738C16.7693 6.59307 17.2102 6.41671 17.5909 6.57988L20.2954 7.73897C20.5712 7.85716 20.75 8.12831 20.75 8.42833L20.75 15.8497C20.75 16.1254 20.7501 16.3864 20.7271 16.6074C20.7015 16.8541 20.6426 17.1136 20.4857 17.3656C20.3288 17.6176 20.122 17.785 19.912 17.9169C19.7238 18.0351 19.4897 18.1503 19.2422 18.272L13.2142 21.2382L13.1291 21.2803C12.7855 21.4508 12.4138 21.6353 12 21.6353C11.5862 21.6353 11.2145 21.4508 10.871 21.2803L10.7859 21.2382L4.75772 18.272C4.51032 18.1503 4.27615 18.0351 4.08801 17.9169C3.87796 17.785 3.67116 17.6176 3.5143 17.3656C3.35744 17.1136 3.29853 16.8541 3.2729 16.6074C3.24994 16.3864 3.24997 16.1254 3.25 15.8497L3.25 8.42833C3.25 8.12831 3.4288 7.85716 3.70457 7.73897L6.40913 6.57988C6.78985 6.41671 7.23076 6.59307 7.39392 6.9738ZM7.29563 11.7393C6.91491 11.5761 6.474 11.7525 6.31083 12.1332C6.14767 12.5139 6.32403 12.9549 6.70475 13.118L8.70475 13.9752C9.08547 14.1383 9.52638 13.962 9.68955 13.5812C9.85272 13.2005 9.67635 12.7596 9.29563 12.5964L7.29563 11.7393Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2783 2.30363C11.8937 2.14982 11.4572 2.33691 11.3034 2.7215L10.3036 5.2215C10.2112 5.45257 10.2394 5.71443 10.379 5.92049C10.5185 6.12656 10.7511 6.25 11 6.25H11.8921L11.3035 7.72141C11.1496 8.10599 11.3366 8.54248 11.7212 8.69634C12.1058 8.8502 12.5423 8.66317 12.6961 8.27859L13.6963 5.77859C13.7888 5.54752 13.7606 5.28564 13.6211 5.07955C13.4815 4.87346 13.2489 4.75 13 4.75H12.1077L12.6962 3.2785C12.85 2.8939 12.6629 2.45743 12.2783 2.30363Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "package bolt": {
        defaultColors: ["#000000"],
        keywords: ["box","package","bolt","fast","shipping","delivery","express","order","processing","supply","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 3L11 5.5H13L11.9998 8"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package receive-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","down","download","receive","import","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6.00003L12 8L10 6"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8L12 3"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package receive-2": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","receive","receiving","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7.95859C7.38073 7.79543 7.55709 7.35452 7.39392 6.9738C7.23076 6.59307 6.78985 6.41671 6.40913 6.57988L3.70457 7.73897C3.4288 7.85716 3.25 8.12831 3.25 8.42833L3.25 15.8497C3.24997 16.1254 3.24994 16.3864 3.2729 16.6074C3.29853 16.8541 3.35744 17.1136 3.5143 17.3656C3.67116 17.6176 3.87796 17.785 4.08801 17.9169C4.27615 18.0351 4.51032 18.1503 4.75772 18.272L10.7859 21.2382L10.871 21.2803C11.2145 21.4508 11.5862 21.6353 12 21.6353C12.4138 21.6353 12.7855 21.4508 13.1291 21.2803L13.2142 21.2382L19.2422 18.272C19.4897 18.1503 19.7238 18.0351 19.912 17.9169C20.122 17.785 20.3288 17.6176 20.4857 17.3656C20.6426 17.1136 20.7015 16.8541 20.7271 16.6074C20.7501 16.3864 20.75 16.1254 20.75 15.8497L20.75 8.42833C20.75 8.12831 20.5712 7.85716 20.2954 7.73897L17.5909 6.57988C17.2102 6.41671 16.7693 6.59307 16.6061 6.9738C16.4429 7.35452 16.6193 7.79543 17 7.95859L18.0961 8.42833L12.4924 10.8299C12.2878 10.9176 12.1731 10.9662 12.0845 10.9962C12.0449 11.0096 12.0226 11.015 12.011 11.0173C12.0055 11.0184 12.0014 11.0188 12.0014 11.0188L12 11.0189L11.9986 11.0188C11.9986 11.0188 11.9945 11.0184 11.989 11.0173C11.9774 11.015 11.9551 11.0096 11.9155 10.9962C11.8269 10.9662 11.7122 10.9176 11.5076 10.8299L5.90395 8.42833L7 7.95859ZM6.31083 12.1332C6.474 11.7525 6.91491 11.5761 7.29563 11.7393L9.29563 12.5964C9.67635 12.7596 9.85272 13.2005 9.68955 13.5812C9.52638 13.962 9.08547 14.1383 8.70475 13.9752L6.70475 13.118C6.32403 12.9549 6.14767 12.5139 6.31083 12.1332Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.5303 6.53037C14.8232 6.23748 14.8232 5.7626 14.5303 5.46971C14.2374 5.17681 13.7626 5.1768 13.4697 5.46969L12.75 6.18935V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3L11.25 6.18935L10.5303 5.46967C10.2374 5.17678 9.76257 5.17678 9.46967 5.46967C9.17678 5.76256 9.17678 6.23743 9.46967 6.53033L11.4697 8.53033C11.5434 8.60405 11.6286 8.65921 11.7196 8.69582C11.8048 8.73021 11.8979 8.74939 11.9953 8.74999L12 8.75L12.0022 8.75C12.1057 8.74969 12.2043 8.72844 12.2939 8.69025C12.3696 8.65802 12.4412 8.61275 12.5051 8.55444C12.5147 8.5457 12.524 8.53671 12.5331 8.5275L14.5303 6.53037Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "package receive-3": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","storage","container","delivery","shipment","receiving","receive","inbound","stock","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15.8184V8.42838L12.7878 11.5193L12.7878 11.5193C12.3994 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6006 11.6858 11.2122 11.5193L11.2122 11.5193L4 8.42838V15.8184C4 16.4239 4 16.7267 4.15103 16.9693C4.30206 17.2119 4.5737 17.3456 5.11699 17.6129L11.117 20.5653C11.5505 20.7786 11.7673 20.8853 12 20.8853C12.2327 20.8853 12.4495 20.7786 12.883 20.5653L18.883 17.6129C19.4263 17.3456 19.6979 17.2119 19.849 16.9693C20 16.7267 20 16.4239 20 15.8184Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 12.8501L8.5 13.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 6.00003L12 8L10 6" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 8L12 3" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package receive": {
        defaultColors: ["#000000"],
        keywords: ["box","package","receive","inventory","stock","delivery","incoming","add-stock","restock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 6.00003L12 8L10 6" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 8L12 3" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package sent-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","up","upload","increase","rise","ascending","push","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 4.99997L12 3L14 5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 3L12 8"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package sent-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","open-box","inventory","stock","storage","products","warehouse","shipment","delivery","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15.8184V8.42838L12.7878 11.5193L12.7878 11.5193C12.3994 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6006 11.6858 11.2122 11.5193L11.2122 11.5193L4 8.42838V15.8184C4 16.4239 4 16.7267 4.15103 16.9693C4.30206 17.2119 4.5737 17.3456 5.11699 17.6129L11.117 20.5653C11.5505 20.7786 11.7673 20.8853 12 20.8853C12.2327 20.8853 12.4495 20.7786 12.883 20.5653L18.883 17.6129C19.4263 17.3456 19.6979 17.2119 19.849 16.9693C20 16.7267 20 16.4239 20 15.8184Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 4.99997L12 3L14 5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 3L12 8" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "package sent-3": {
        defaultColors: ["#000000"],
        keywords: ["package","sent","shipping","delivery","box","confirmed","order-sent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.39392 6.9738C7.55709 7.35452 7.38073 7.79543 7 7.95859L5.90395 8.42833L11.5076 10.8299C11.7122 10.9176 11.8269 10.9662 11.9155 10.9962C11.9551 11.0096 11.9774 11.015 11.989 11.0173C11.9945 11.0184 11.9986 11.0188 11.9986 11.0188L12 11.0189L12.0014 11.0188C12.0014 11.0188 12.0055 11.0184 12.011 11.0173C12.0226 11.015 12.0449 11.0096 12.0845 10.9962C12.1731 10.9662 12.2878 10.9176 12.4924 10.8299L18.0961 8.42833L17 7.95859C16.6193 7.79543 16.4429 7.35452 16.6061 6.9738C16.7693 6.59307 17.2102 6.41671 17.5909 6.57988L20.2954 7.73897C20.5712 7.85716 20.75 8.12831 20.75 8.42833L20.75 15.8497C20.75 16.1254 20.7501 16.3864 20.7271 16.6074C20.7015 16.8541 20.6426 17.1136 20.4857 17.3656C20.3288 17.6176 20.122 17.785 19.912 17.9169C19.7238 18.0351 19.4897 18.1503 19.2422 18.272L13.2142 21.2382L13.1291 21.2803C12.7855 21.4508 12.4138 21.6353 12 21.6353C11.5862 21.6353 11.2145 21.4508 10.871 21.2803L10.7859 21.2382L4.75772 18.272C4.51032 18.1503 4.27615 18.0351 4.08801 17.9169C3.87796 17.785 3.67116 17.6176 3.5143 17.3656C3.35744 17.1136 3.29853 16.8541 3.2729 16.6074C3.24994 16.3864 3.24997 16.1254 3.25 15.8497L3.25 8.42833C3.25 8.12831 3.4288 7.85716 3.70457 7.73897L6.40913 6.57988C6.78985 6.41671 7.23076 6.59307 7.39392 6.9738ZM7.29563 11.7393C6.91491 11.5761 6.474 11.7525 6.31083 12.1332C6.14767 12.5139 6.32403 12.9549 6.70475 13.118L8.70475 13.9752C9.08547 14.1383 9.52638 13.962 9.68955 13.5812C9.85272 13.2005 9.67635 12.7596 9.29563 12.5964L7.29563 11.7393Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M9.46968 4.46963C9.17678 4.76252 9.17677 5.2374 9.46966 5.53029C9.76255 5.82319 10.2374 5.8232 10.5303 5.53031L11.25 4.81065L11.25 8C11.25 8.41421 11.5858 8.75 12 8.75C12.4142 8.75 12.75 8.41421 12.75 8L12.75 4.81065L13.4697 5.53033C13.7626 5.82322 14.2374 5.82322 14.5303 5.53033C14.8232 5.23744 14.8232 4.76257 14.5303 4.46967L12.5303 2.46967C12.4566 2.39595 12.3714 2.34079 12.2804 2.30418C12.1952 2.26979 12.1021 2.25061 12.0047 2.25001L12 2.25L11.9978 2.25C11.8943 2.25031 11.7957 2.27156 11.7061 2.30975C11.6304 2.34198 11.5588 2.38725 11.4949 2.44556C11.4853 2.4543 11.476 2.46329 11.4669 2.4725L9.46968 4.46963Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "package sent": {
        defaultColors: ["#000000"],
        keywords: ["empty","void","null"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12V21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 8.42838V15.8184C20 16.4239 20 16.7267 19.849 16.9693C19.6979 17.2119 19.4263 17.3456 18.883 17.6129L12.883 20.5653C12.4495 20.7786 12.2327 20.8853 12 20.8853C11.7673 20.8853 11.5505 20.7786 11.117 20.5653L5.11699 17.6129C4.5737 17.3456 4.30206 17.2119 4.15103 16.9693C4 16.7267 4 16.4239 4 15.8184V8.42838M20 8.42838L12.7878 11.5193C12.3995 11.6858 12.2053 11.769 12 11.769C11.7947 11.769 11.6005 11.6858 11.2122 11.5193L4 8.42838M20 8.42838L18.197 7.65565L17.2954 7.26929M4 8.42838L5.80304 7.65565L6.70456 7.26929"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 4.99997L12 3L14 5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 3L12 8" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7 12.4287L9 13.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge add-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","new","create","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.5 14V19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16.5H21" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge add-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","add","plus","inventory","add-item","stock","restock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18.5 14V19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16.5H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "packge box label-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","package","label","print-label","print"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M15 12.2859L17 11.4287V15L15 16V12.2859Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge add": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","inventory","stock","create","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.5 14V19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 16.5H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge box label-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","shipping","inventory","stock","delivery","product","item","merchandise","warehouse","supply-chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 12.5713L17 12V15L15.5 15.7141V12.5713Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge box label-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","label","tag","identification","shipment","delivery","inventory","product","item","stock","goods","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L19.2423 17.2722C19.4897 17.1505 19.7238 17.0353 19.912 16.9171C20.122 16.7852 20.3288 16.6177 20.4857 16.3657C20.6426 16.1137 20.7015 15.8543 20.7271 15.6075C20.7501 15.3866 20.75 15.1256 20.75 14.8499L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549ZM17.4256 11.3825C17.2225 11.2425 16.9636 11.2113 16.7331 11.2991L15.2331 11.8704C14.9422 11.9812 14.75 12.2601 14.75 12.5713V15.7142C14.75 15.9715 14.882 16.2109 15.0996 16.3483C15.3172 16.4857 15.59 16.5019 15.8224 16.3913L17.3224 15.6772C17.5836 15.5528 17.75 15.2893 17.75 15V12C17.75 11.7533 17.6287 11.5224 17.4256 11.3825Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge box label": {
        defaultColors: ["#000000"],
        keywords: ["box","package","label","shipping","delivery","inventory","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M15 12.2859L17 11.4287V15L15 16V12.2859Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge add-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","add","plus","order","add-order","inventory","stock","increase","restock","delivery","receive","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L17.25 18.2525V18.25H16.5C15.5335 18.25 14.75 17.4665 14.75 16.5C14.75 15.5335 15.5335 14.75 16.5 14.75H17.25V14C17.25 13.0335 18.0335 12.25 19 12.25C19.9665 12.25 20.75 13.0335 20.75 14L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 13.25C19.4142 13.25 19.75 13.5858 19.75 14V15.75H21.5C21.9142 15.75 22.25 16.0858 22.25 16.5C22.25 16.9142 21.9142 17.25 21.5 17.25H19.75V19C19.75 19.4142 19.4142 19.75 19 19.75C18.5858 19.75 18.25 19.4142 18.25 19V17.25H16.5C16.0858 17.25 15.75 16.9142 15.75 16.5C15.75 16.0858 16.0858 15.75 16.5 15.75H18.25V14C18.25 13.5858 18.5858 13.25 19 13.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge check-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["check","tick","confirm","approve","accept","valid","verified","complete","order-confirmation","payment-received","transaction-success","item-availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 16.5L17.6667 18L21 15"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge check-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","shipment","inventory","stock","delivery","receive","products","items","crate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.5L17.6667 18L21 15"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge check-3": {
        defaultColors: ["#000000"],
        keywords: ["check","package","order","confirmation","verified","approved","delivery","shipment","checked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L16.0274 18.8541L14.5793 17.5508C13.8609 16.9042 13.8027 15.7977 14.4493 15.0793C15.0958 14.3609 16.2023 14.3027 16.9207 14.9493L17.4167 15.3956L19.5793 13.4493C19.9139 13.1481 20.3327 12.9999 20.75 13L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.3075 14.2483C21.5846 14.5562 21.5596 15.0304 21.2517 15.3075L17.9184 18.3075C17.6332 18.5642 17.2002 18.5642 16.9149 18.3075L15.2483 16.8075C14.9404 16.5304 14.9154 16.0562 15.1925 15.7483C15.4696 15.4404 15.9438 15.4154 16.2517 15.6925L17.4167 16.741L20.2483 14.1925C20.5562 13.9154 21.0304 13.9404 21.3075 14.2483Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge click-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["click","right-arrow","arrow","select","choose","next","forward","enter","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9217 16.9217L19.3087 16.68C20.4403 15.9737 21.006 15.6205 20.9251 15.2139C20.8442 14.8074 20.1863 14.6977 18.8706 14.4784L17.6571 14.2762C16.9017 14.1503 16.524 14.0873 16.3057 14.3057C16.0873 14.524 16.1503 14.9017 16.2762 15.6571L16.4784 16.8706C16.6977 18.1863 16.8074 18.8442 17.2139 18.9251C17.6205 19.006 17.9737 18.4403 18.68 17.3087L18.9217 16.9217ZM18.9217 16.9217L20.7108 18.7108L21.6054 19.6054"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964L14.008 19.0119"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge click-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","parcel","delivery","inventory","stock","storage","container","products","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3987 17.3921L17.2302 16.381C17.1252 15.7514 17.0728 15.4367 17.2547 15.2547C17.4367 15.0728 17.7514 15.1252 18.381 15.2302L19.3921 15.3987C20.4886 15.5814 21.0368 15.6728 21.1043 16.0116C21.1717 16.3504 20.7002 16.6447 19.7573 17.2334L19.4347 17.4347L19.2334 17.7573C18.6447 18.7002 18.3504 19.1717 18.0116 19.1043C17.6728 19.0368 17.5814 18.4886 17.3987 17.3921Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M19.4347 17.4347L19.7573 17.2334C20.7002 16.6447 21.1717 16.3504 21.1043 16.0116C21.0368 15.6728 20.4886 15.5814 19.3921 15.3987L18.381 15.2302C17.7514 15.1252 17.4367 15.0728 17.2547 15.2547C17.0728 15.4367 17.1252 15.7514 17.2302 16.381L17.3987 17.3921C17.5814 18.4886 17.6728 19.0368 18.0116 19.1043C18.3504 19.1717 18.6447 18.7002 19.2334 17.7573L19.4347 17.4347ZM19.4347 17.4347L20.9257 18.9257L21.6712 19.6712"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge click-3": {
        defaultColors: ["#000000"],
        keywords: ["package","box","click","select","choose","pick"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.6938C20.5065 14.6451 20.2513 14.6026 20.0062 14.5618L18.8256 14.365C18.571 14.3224 18.233 14.2659 17.9316 14.2601C17.5694 14.2531 16.9046 14.3068 16.3558 14.8556C15.807 15.4044 15.7533 16.0691 15.7603 16.4313C15.7661 16.7328 15.8227 17.0707 15.8653 17.3254L16.0621 18.506C16.0788 18.6067 16.0959 18.7091 16.1135 18.8117L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.791 15.5398C20.1333 15.5968 20.4473 15.6491 20.7148 15.7079C20.8449 15.7366 20.9641 15.7668 21.0702 15.7998C21.3683 15.8927 21.859 16.0948 21.9674 16.6395C22.0758 17.1843 21.6999 17.5588 21.46 17.7587C21.2618 17.924 20.9924 18.1021 20.6822 18.2981L22.3633 19.9791C22.6073 20.2232 22.6073 20.6189 22.3633 20.863C22.1192 21.1071 21.7235 21.1071 21.4794 20.863L19.7983 19.182C19.6024 19.4921 19.4243 19.7616 19.259 19.9598C19.059 20.1996 18.6845 20.5756 18.1398 20.4671C17.595 20.3587 17.393 19.868 17.3001 19.5699C17.2031 19.2587 17.1307 18.8347 17.05 18.3509L16.8575 17.1957C16.8105 16.9141 16.7645 16.6387 16.7601 16.412C16.7553 16.1607 16.7964 15.8292 17.0629 15.5627C17.3295 15.2961 17.6609 15.255 17.9122 15.2599C18.1389 15.2643 18.4143 15.3102 18.696 15.3572L19.791 15.5398Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge check": {
        defaultColors: ["#000000"],
        keywords: ["box","package","check","inventory","stock","confirmation","order-check","package-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 16.5L17.6667 18L21 15"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge click": {
        defaultColors: ["#000000"],
        keywords: ["box","package","click","select","choose","confirm"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9217 16.9217L19.3087 16.68C20.4403 15.9737 21.006 15.6205 20.9251 15.2139C20.8442 14.8074 20.1863 14.6977 18.8706 14.4784L17.6571 14.2762C16.9017 14.1503 16.524 14.0873 16.3057 14.3057C16.0873 14.524 16.1503 14.9017 16.2762 15.6571L16.4784 16.8706C16.6977 18.1863 16.8074 18.8442 17.2139 18.9251C17.6205 19.006 17.9737 18.4403 18.68 17.3087L18.9217 16.9217ZM18.9217 16.9217L20.7108 18.7108L21.6054 19.6054"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964L14.008 19.0119"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge disable-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["disable","blocked","forbidden","not-allowed","unavailable","cancel","remove","void","prohibited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 16.5C20.5 17.8836 19.3836 19 18 19C16.6164 19 15.5 17.8836 15.5 16.5C15.5 15.1164 16.6164 14 18 14C19.3836 14 20.5 15.1164 20.5 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.333 18.1668L19.6663 14.8335"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge disable-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","disabled","unavailable","out-of-stock","remove-order","cancel-order","inventory-error","item-unavailable","stock-issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 16.5C20.5 17.8836 19.3836 19 18 19C16.6164 19 15.5 17.8836 15.5 16.5C15.5 15.1164 16.6164 14 18 14C19.3836 14 20.5 15.1164 20.5 16.5Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.333 18.1668L19.6663 14.8335"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge disable-3": {
        defaultColors: ["#000000"],
        keywords: ["package","disable","inactive","unavailable","remove","delete","cancel","not-available","blocked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.4673 19.1297C15.1691 18.5695 15.0002 17.9298 15.0002 17.25C15.0002 15.0383 16.7885 13.25 19.0002 13.25C19.628 13.25 20.2217 13.3941 20.75 13.651L20.75 9.75012L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM20.75 14.8114C20.2578 14.4579 19.6537 14.25 19.0002 14.25C17.3407 14.25 16.0002 15.5906 16.0002 17.25C16.0002 17.7713 16.1325 18.2611 16.3654 18.6878C16.8739 19.6194 17.862 20.25 19.0002 20.25C20.6596 20.25 22.0002 18.9094 22.0002 17.25C22.0002 16.2441 21.5076 15.3554 20.75 14.8114ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549ZM17.5002 17.25C17.5002 16.419 18.1692 15.75 19.0002 15.75C19.1348 15.75 19.2652 15.7676 19.3892 15.8005L17.5507 17.639C17.5177 17.515 17.5002 17.3846 17.5002 17.25ZM18.6115 18.6995L20.4497 16.8613C20.4826 16.9852 20.5002 17.1155 20.5002 17.25C20.5002 18.081 19.8312 18.75 19.0002 18.75C18.8656 18.75 18.7354 18.7325 18.6115 18.6995Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge disable": {
        defaultColors: ["#000000"],
        keywords: ["box","package","disable","unavailable","inactive","blocked","order-disable","product-disable","item-disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 16.5C20.5 17.8836 19.3836 19 18 19C16.6164 19 15.5 17.8836 15.5 16.5C15.5 15.1164 16.6164 14 18 14C19.3836 14 20.5 15.1164 20.5 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.333 18.1668L19.6663 14.8335"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge dollar-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["dollar","currency","money","payment","price","cost","sale","revenue","finance","amount","cash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3125 14.875H19.9167M18.3125 14.875C17.5876 14.875 17 15.4626 17 16.1875C17 16.9124 17.5876 17.5 18.3125 17.5H19.0417C19.8471 17.5 20.5 18.0876 20.5 18.8125C20.5 19.5374 19.8471 20.0996 19.0417 20.0996H18.3125M18.3125 14.875V14M17 20.0996L18.3125 20.0996M18.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge dollar-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","dollar","money","payment","value","price","cost","order","checkout","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3125 14.875H19.9167M18.3125 14.875C17.5876 14.875 17 15.4626 17 16.1875C17 16.9124 17.5876 17.5 18.3125 17.5H19.0417C19.8471 17.5 20.5 18.0876 20.5 18.8125C20.5 19.5374 19.8471 20.0996 19.0417 20.0996H18.3125M18.3125 14.875V14M17 20.0996L18.3125 20.0996M18.3125 20.0996V20.9746"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "packge dollar-3": {
        defaultColors: ["#000000"],
        keywords: ["dollar","money","currency","price","payment","sale","transaction","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.9671 18.8838C16.095 18.6508 16.2745 18.4501 16.4901 18.2971C16.0313 17.7877 15.752 17.1134 15.752 16.3739C15.752 15.4177 16.2187 14.572 16.9347 14.05C17.1332 13.3016 17.8153 12.75 18.6263 12.75C19.2212 12.75 19.7469 13.0469 20.063 13.5006C20.3082 13.5093 20.5406 13.5683 20.75 13.6677L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.3763 14.4995C19.376 14.0855 19.0403 13.75 18.6263 13.75C18.2121 13.75 17.8763 14.0858 17.8763 14.5V14.6556C17.2144 14.9449 16.752 15.6054 16.752 16.3739C16.752 17.409 17.5911 18.2482 18.6263 18.2482H19.2509C19.6029 18.2482 19.7501 18.4881 19.7501 18.6225C19.7501 18.6959 19.72 18.7724 19.6401 18.8425C19.557 18.9152 19.4226 18.9751 19.2509 18.9751H17.502C17.0877 18.9751 16.752 19.3109 16.752 19.7251C16.752 20.1393 17.0877 20.4751 17.502 20.4751H17.8763C17.8765 20.8891 18.2122 21.2246 18.6263 21.2246C19.0405 21.2246 19.3763 20.8888 19.3763 20.4746V20.4713C20.3393 20.414 21.2501 19.7012 21.2501 18.6225C21.2501 17.515 20.2788 16.7482 19.2509 16.7482H18.6263C18.4195 16.7482 18.252 16.5806 18.252 16.3739C18.252 16.1671 18.4195 15.9995 18.6263 15.9995H20.0004C20.4146 15.9995 20.7504 15.6638 20.7504 15.2495C20.7504 14.8353 20.4146 14.4995 20.0004 14.4995H19.3763Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge dollar": {
        defaultColors: ["#000000"],
        keywords: ["money","dollar","payment","sale","price","finance","transaction","earnings","cash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3125 14.875H19.9167M18.3125 14.875C17.5876 14.875 17 15.4626 17 16.1875C17 16.9124 17.5876 17.5 18.3125 17.5H19.0417C19.8471 17.5 20.5 18.0876 20.5 18.8125C20.5 19.5374 19.8471 20.0996 19.0417 20.0996H18.3125M18.3125 14.875V14M17 20.0996L18.3125 20.0996M18.3125 20.0996V20.9746"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge edit-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["edit","modify","change","alter","adjustment","correct","revise","update","pencil","writing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3607 19L17.3907 18.9901C17.4839 18.9916 17.5728 18.9564 17.6381 18.892L20.6985 15.8317C20.8917 15.6355 21 15.3711 21 15.0957C21 14.5163 20.4837 14 19.9043 14C19.6289 14 19.3645 14.1083 19.1683 14.3015L16.108 17.3619C16.0436 17.4272 16.0084 17.5161 16.0099 17.6093L16 18.6393C16.0031 18.8354 16.1646 18.9969 16.3607 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge edit-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","stock","storage","container","product","delivery","shipment","order","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0084 14.7068C19.3057 14.4141 19.7062 14.25 20.1234 14.25C21.0012 14.25 21.75 14.9988 21.75 15.8765C21.75 16.2938 21.5859 16.6943 21.2931 16.9916L21.2891 16.9957L18.8366 19.4482C18.6415 19.6402 18.3806 19.7431 18.1131 19.7421L17.2957 19.75L17.2766 19.7499C16.7148 19.741 16.259 19.2851 16.2501 18.7234L16.25 18.7043L16.2579 17.8868C16.2569 17.6194 16.3598 17.3585 16.5518 17.1634L16.556 17.1591L19.0084 14.7068Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "packge edit-3": {
        defaultColors: ["#000000"],
        keywords: ["package","edit","box","edit-order","modify","order","editing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.3117 19.2062C15.274 19.0565 15.2528 18.9001 15.2502 18.7393L15.25 18.7265L15.25 18.6947L15.2579 17.8828C15.2579 17.3594 15.4604 16.8468 15.8391 16.462L15.8489 16.452L18.3068 13.9943C18.7912 13.5173 19.4437 13.25 20.1235 13.25C20.3387 13.25 20.5486 13.2771 20.75 13.328L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.0084 14.7068C19.3057 14.4141 19.7062 14.25 20.1234 14.25C21.0012 14.25 21.75 14.9988 21.75 15.8765C21.75 16.2938 21.5859 16.6943 21.2931 16.9916L21.2891 16.9957L18.8366 19.4482C18.6415 19.6402 18.3806 19.7431 18.1131 19.7421L17.2957 19.75L17.2766 19.7499C16.7148 19.741 16.259 19.2851 16.2501 18.7234L16.25 18.7043L16.2579 17.8868C16.2569 17.6194 16.3598 17.3585 16.5518 17.1634L16.556 17.1591L19.0084 14.7068Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge edit": {
        defaultColors: ["#000000"],
        keywords: ["box","package","edit","modify","order","edit-order","update-order","stock","inventory","edit-stock","edit-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3607 19L17.3907 18.9901C17.4839 18.9916 17.5728 18.9564 17.6381 18.892L20.6985 15.8317C20.8917 15.6355 21 15.3711 21 15.0957C21 14.5163 20.4837 14 19.9043 14C19.6289 14 19.3645 14.1083 19.1683 14.3015L16.108 17.3619C16.0436 17.4272 16.0084 17.5161 16.0099 17.6093L16 18.6393C16.0031 18.8354 16.1646 18.9969 16.3607 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge fast-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["fast","speed","lightning","bolt","quick","flash","rapid","electricity","charge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6667 15L18.0002 17H19.3335L18.6667 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge fast-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","delivery","inventory","shipment","order","stock","cube","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6662 15L17.9997 17H19.333L18.6662 19"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge fast-3": {
        defaultColors: ["#000000"],
        keywords: [],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.8499C20.75 15.1256 20.7501 15.3866 20.7271 15.6075C20.7246 15.6317 20.7218 15.656 20.7186 15.6804C20.6063 15.535 20.4733 15.41 20.3253 15.3082L20.3269 15.3033C20.6325 14.3864 20.1369 13.3953 19.22 13.0898C18.3031 12.7842 17.312 13.2798 17.0065 14.1967L16.3399 16.1967C16.1621 16.7303 16.2516 17.3169 16.5805 17.7733C16.6996 17.9384 16.8447 18.0792 17.0081 18.1917L17.0065 18.1965C16.9841 18.2637 16.966 18.3314 16.9521 18.3991L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.9419 16.3114C20.0452 16.4548 20.0934 16.6281 20.0818 16.8005C20.0775 16.8634 20.0654 16.9261 20.045 16.9872L19.3782 18.9872C19.2472 19.3801 18.8224 19.5925 18.4295 19.4615C18.0365 19.3304 17.8242 18.9057 17.9552 18.5127L18.2929 17.5H18.0002C17.7591 17.5 17.5327 17.3841 17.3917 17.1885C17.2508 16.9929 17.2124 16.7415 17.2886 16.5128L17.9552 14.5128C18.0861 14.1199 18.5109 13.9075 18.9038 14.0384C19.2968 14.1694 19.5092 14.5941 19.3782 14.9871L19.0407 16H19.3335C19.5746 16 19.801 16.1159 19.9419 16.3114Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge fast": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","box","package","fast","speed","express"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6662 15L17.9997 17H19.333L18.6662 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge finger-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["finger","tap","select","choose","point","hand","touch","press","click","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.65 17.5999L17.328 17.2486C17.1821 17.0894 16.9842 17 16.7779 17C16.5716 17 16.3737 17.0894 16.2279 17.2486C15.9657 17.5346 15.925 17.9828 16.1306 18.3193L17.1976 20.0656C17.4017 20.3995 17.7452 20.6 18.113 20.6H20.2008C20.7556 20.6 21.2235 20.1493 21.2923 19.5488L21.4914 17.8107C21.5647 17.1704 21.1608 16.5814 20.577 16.4776L19.3 16.2504V14.9C19.3 14.4029 18.9306 14 18.475 14C18.0194 14 17.65 14.4029 17.65 14.9V17.5999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge finger-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","finger","select","choose","item","inventory","stock","select-item","choose-item","inventory-management","stock-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.65 17.5999L17.328 17.2486C17.1821 17.0894 16.9842 17 16.7779 17C16.5716 17 16.3737 17.0894 16.2279 17.2486C15.9657 17.5346 15.925 17.9828 16.1306 18.3193L17.1976 20.0656C17.4017 20.3995 17.7452 20.6 18.113 20.6H20.2008C20.7556 20.6 21.2235 20.1493 21.2923 19.5488L21.4914 17.8107C21.5647 17.1704 21.1608 16.5814 20.577 16.4776L19.3 16.2504V14.9C19.3 14.4029 18.9306 14 18.475 14C18.0194 14 17.65 14.4029 17.65 14.9V17.5999Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "packge finger-3": {
        defaultColors: ["#000000"],
        keywords: [],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.4643C20.5674 13.6715 19.8973 13 18.9749 13C17.8868 13 17.1499 13.9343 17.1499 14.9V16.0048C16.6988 16.0384 16.2881 16.2483 15.9906 16.5728C15.4203 17.195 15.3446 18.1327 15.7772 18.8408L15.8413 18.9456L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27616 17.0353 4.08802 16.9171C3.87796 16.7852 3.67116 16.6177 3.51431 16.3657C3.35745 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25001 7.42849C3.25001 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81084 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58548 13.56 9.02639 13.3836 9.18955 13.0029C9.35272 12.6222 9.17636 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.828 17.2486L18.15 17.5999V14.9C18.15 14.4029 18.5194 14 18.975 14C19.4306 14 19.8 14.4029 19.8 14.9V16.2504L21.077 16.4776C21.6608 16.5814 22.0647 17.1704 21.9914 17.8107L21.7923 19.5488C21.7235 20.1493 21.2556 20.6 20.7008 20.6H18.613C18.2452 20.6 17.9017 20.3995 17.6976 20.0656L16.6306 18.3193C16.425 17.9828 16.4657 17.5346 16.7279 17.2486C16.8737 17.0894 17.0716 17 17.2779 17C17.4842 17 17.6821 17.0894 17.828 17.2486Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.15 17.5999L17.828 17.2486C17.6821 17.0894 17.4842 17 17.2779 17C17.0716 17 16.8737 17.0894 16.7279 17.2486C16.4657 17.5346 16.425 17.9828 16.6306 18.3193L17.6976 20.0656C17.9017 20.3995 18.2452 20.6 18.613 20.6H20.7008C21.2556 20.6 21.7235 20.1493 21.7923 19.5488L21.9914 17.8107C22.0647 17.1704 21.6608 16.5814 21.077 16.4776L19.8 16.2504V14.9C19.8 14.4029 19.4306 14 18.975 14C18.5194 14 18.15 14.4029 18.15 14.9V17.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge heart-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["heart","favorite","loyalty","rewards","like","customer","love","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5 19L16.374 17.1652C15.8532 16.6341 15.8793 15.8271 16.4336 15.3246C17.25 14.7318 17.7857 15.0114 18.5 15.6764C19.2143 15.0114 19.75 14.7318 20.5664 15.3246C21.1207 15.827 21.1468 16.6341 20.626 17.1652L18.5 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge finger": {
        defaultColors: ["#000000"],
        keywords: ["no-visual-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.65 17.5999L17.328 17.2486C17.1821 17.0894 16.9842 17 16.7779 17C16.5716 17 16.3737 17.0894 16.2279 17.2486C15.9657 17.5346 15.925 17.9828 16.1306 18.3193L17.1976 20.0656C17.4017 20.3995 17.7452 20.6 18.113 20.6H20.2008C20.7556 20.6 21.2235 20.1493 21.2923 19.5488L21.4914 17.8107C21.5647 17.1704 21.1608 16.5814 20.577 16.4776L19.3 16.2504V14.9C19.3 14.4029 18.9306 14 18.475 14C18.0194 14 17.65 14.4029 17.65 14.9V17.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge heart-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","heart","gift","favorite","loyalty","preferred","saved","rewards","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 19L16.374 17.1652C15.8532 16.6341 15.8793 15.8271 16.4336 15.3246C17.25 14.7318 17.7857 15.0114 18.5 15.6764C19.2143 15.0114 19.75 14.7318 20.5664 15.3246C21.1207 15.827 21.1468 16.6341 20.626 17.1652L18.5 19Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge heart-3": {
        defaultColors: ["#000000"],
        keywords: ["favorite","wishlist","loyalty","rewards","save","heart","love"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 10L20.75 14.1705C20.2874 13.9662 19.7533 13.8763 19.1685 14.0182C19.0192 14.0544 18.8797 14.1032 18.75 14.1597C18.6202 14.1032 18.4807 14.0544 18.3313 14.0182C17.4765 13.8108 16.7301 14.0987 16.1568 14.515C16.11 14.549 16.0651 14.5855 16.0223 14.6243C14.9133 15.6296 14.8472 17.322 15.9067 18.4024C15.9378 18.4341 15.9702 18.4645 16.0038 18.4935L16.2785 18.7305L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM19.4043 14.99C19.883 14.8738 20.3284 15.0169 20.7454 15.3168L20.7555 15.3242C20.7731 15.3369 20.7899 15.3506 20.806 15.3651C21.4992 15.9935 21.5367 17.0317 20.8791 17.7022C20.8675 17.7141 20.8554 17.7255 20.8428 17.7364L19.1419 19.2042C18.9167 19.3986 18.5831 19.3986 18.3579 19.2042L17.2532 18.2509L16.6571 17.7364C16.6445 17.7255 16.6324 17.7141 16.6207 17.7023C15.9632 17.0317 16.0006 15.9935 16.6939 15.3651C16.7099 15.3506 16.7268 15.3369 16.7443 15.3242C17.1641 15.0193 17.613 14.8729 18.0955 14.99C18.3373 15.0486 18.5545 15.1677 18.7499 15.3089C18.9454 15.1677 19.1626 15.0486 19.4043 14.99ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge heart": {
        defaultColors: ["#000000"],
        keywords: ["favorite","loyalty","rewards","heart","customer","saved","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5 19L16.374 17.1652C15.8532 16.6341 15.8793 15.8271 16.4336 15.3246C17.25 14.7318 17.7857 15.0114 18.5 15.6764C19.2143 15.0114 19.75 14.7318 20.5664 15.3246C21.1207 15.827 21.1468 16.6341 20.626 17.1652L18.5 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge mobile-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["mobile","phone","device","payment","mobile-payment","terminal","pos-terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1699 19V15C16.1699 14.0572 16.1699 13.5858 16.4628 13.2929C16.7557 13 17.2271 13 18.1699 13H19.5033C20.4461 13 20.9175 13 21.2104 13.2929C21.5033 13.5858 21.5033 14.0572 21.5033 15V19C21.5033 19.9428 21.5033 20.4142 21.2104 20.7071C20.9175 21 20.4461 21 19.5033 21H18.1699C17.2271 21 16.7557 21 16.4628 20.7071C16.1699 20.4142 16.1699 19.9428 16.1699 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M18.3926 18.6665H19.2815" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V10.5194M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge mobile-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","stock","products","shipment","delivery","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.6665 18.25V14.75C16.6665 13.925 16.6665 13.5126 16.9228 13.2563C17.1791 13 17.5915 13 18.4165 13H19.5832C20.4081 13 20.8206 13 21.0769 13.2563C21.3332 13.5126 21.3332 13.925 21.3332 14.75V18.25C21.3332 19.075 21.3332 19.4874 21.0769 19.7437C20.8206 20 20.4081 20 19.5832 20H18.4165C17.5915 20 17.1791 20 16.9228 19.7437C16.6665 19.4874 16.6665 19.075 16.6665 18.25Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M18.7441 17.9583H19.2474" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "packge mobile-3": {
        defaultColors: ["#000000"],
        keywords: ["package","mobile","order","delivery","shipment","box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L7.02622 18.3884C7.27879 18.5824 7.55898 18.7114 7.85984 18.7986L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.854 18.9394L15.854 15.6796C15.8539 15.3843 15.8538 15.0286 15.8954 14.7189C15.9461 14.3422 16.0824 13.8138 16.5313 13.3648C16.9803 12.9159 17.5087 12.7796 17.8854 12.7289C18.1952 12.6873 18.5508 12.6874 18.8461 12.6875H19.987C20.2211 12.6874 20.493 12.6873 20.75 12.708L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.75 13.7122C20.5203 13.6874 20.2465 13.6875 19.9501 13.6875H18.8829C18.5584 13.6875 18.2607 13.6874 18.0186 13.72C17.752 13.7558 17.4702 13.8402 17.2384 14.0719C17.0067 14.3037 16.9223 14.5855 16.8865 14.8521C16.8539 15.0942 16.854 15.3918 16.854 15.7164L16.854 18.8249C16.854 18.8843 16.8541 18.9427 16.8544 19C16.8556 19.2404 16.8613 19.4607 16.8865 19.6479C16.9223 19.9145 17.0067 20.1963 17.2384 20.4281C17.4702 20.6598 17.752 20.7442 18.0186 20.78C18.2607 20.8126 18.5584 20.8125 18.883 20.8125H19.9501C20.2747 20.8125 20.5723 20.8126 20.8144 20.78C21.081 20.7442 21.3628 20.6598 21.5946 20.4281C21.8264 20.1963 21.9107 19.9145 21.9465 19.6479C21.9791 19.4058 21.979 19.1082 21.979 18.7836V15.7164C21.979 15.3918 21.9791 15.0942 21.9465 14.8521C21.9107 14.5855 21.8264 14.3037 21.5946 14.0719C21.5639 14.0412 21.5323 14.0131 21.5 13.9874C21.2884 13.8187 21.0457 13.7511 20.8144 13.72C20.7934 13.7171 20.7719 13.7146 20.75 13.7122ZM19.0839 18.3999C18.7525 18.3999 18.4839 18.6685 18.4839 18.9999C18.4839 19.3313 18.7525 19.5999 19.0839 19.5999H19.7506C20.0819 19.5999 20.3506 19.3313 20.3506 18.9999C20.3506 18.6685 20.0819 18.3999 19.7506 18.3999H19.0839Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge mobile": {
        defaultColors: ["#000000"],
        keywords: ["box","package","mobile","ship","delivery","order","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1699 19V15C16.1699 14.0572 16.1699 13.5858 16.4628 13.2929C16.7557 13 17.2271 13 18.1699 13H19.5033C20.4461 13 20.9175 13 21.2104 13.2929C21.5033 13.5858 21.5033 14.0572 21.5033 15V19C21.5033 19.9428 21.5033 20.4142 21.2104 20.7071C20.9175 21 20.4461 21 19.5033 21H18.1699C17.2271 21 16.7557 21 16.4628 20.7071C16.1699 20.4142 16.1699 19.9428 16.1699 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M18.3926 18.6665H19.2815" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V10.5194M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge moving-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["menu","list","options","settings","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 14.5001L17 14.4999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19.5001L17 19.4999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17H18"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge moving-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","stock","shipment","delivery","products","items","container","storage","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 14.5001L17 14.4999" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 19.5001L17 19.4999" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 17H18" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge moving-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","moving","shipping","delivery","inventory","stock","warehouse","distribution","order-fulfillment","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L16.0038 18.8657C16.0013 18.8274 16 18.7888 16 18.7499C16 17.9714 16.5085 17.3116 17.2114 17.0845C17.0766 16.8364 17 16.5522 17 16.25C17 15.9479 17.0766 15.6636 17.2114 15.4156C16.5084 15.1884 16 14.5285 16 13.7499C16 12.7834 16.7836 12 17.7501 12L20.75 12.0001L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 13.7499C17 13.3357 17.3358 12.9999 17.75 13L19.75 13.0001C20.1643 13.0001 20.5 13.3359 20.5 13.7501C20.5 14.1643 20.1642 14.5001 19.75 14.5001L17.75 14.5C17.3357 14.4999 17 14.1641 17 13.7499Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 18.7499C17 18.3357 17.3358 17.9999 17.75 18L19.75 18.0001C20.1643 18.0001 20.5 18.3359 20.5 18.7501C20.5 19.1643 20.1642 19.5001 19.75 19.5L17.75 19.5C17.3357 19.4999 17 19.1641 17 18.7499Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 16.25C18 15.8358 18.3358 15.5 18.75 15.5H20.75C21.1642 15.5 21.5 15.8358 21.5 16.25C21.5 16.6642 21.1642 17 20.75 17H18.75C18.3358 17 18 16.6642 18 16.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge moving": {
        defaultColors: ["#000000"],
        keywords: ["box","moving","package","delivery","shipping","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 14.5001L17 14.4999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 19.5001L17 19.4999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 17H18" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge open-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["shine","new","item","highlight","new-item","notification","special"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42851V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.2121 19.4263 16.3457 18.883 16.6131L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.6131C4.5737 16.3457 4.30206 16.2121 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42851M20 7.42851L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42851M20 7.42851L18.197 6.65578L17.2954 6.26941M4 7.42851L5.80304 6.65578L6.70456 6.26941"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 2V4M16 3L14.5 5M8 3L9.5 5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge open-2": {
        defaultColors: ["#000000"],
        keywords: ["box","package","open","unpack","shipment","delivery","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 2C12.75 1.58579 12.4143 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4C11.25 4.41421 11.5858 4.75 12 4.75C12.4143 4.75 12.75 4.41421 12.75 4V2Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M8.60004 2.55C8.35152 2.21863 7.88141 2.15147 7.55004 2.4C7.21867 2.64853 7.15152 3.11863 7.40004 3.45L8.90004 5.45C9.14857 5.78137 9.61867 5.84853 9.95004 5.6C10.2814 5.35147 10.3486 4.88137 10.1 4.55L8.60004 2.55Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.6 3.45C16.8486 3.11863 16.7814 2.64853 16.45 2.4C16.1187 2.15147 15.6486 2.21863 15.4 2.55L13.9 4.55C13.6515 4.88137 13.7187 5.35147 14.05 5.6C14.3814 5.84853 14.8515 5.78137 15.1 5.45L16.6 3.45Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 6.95859C7.38073 6.79543 7.55709 6.35452 7.39392 5.9738C7.23076 5.59307 6.78985 5.41671 6.40913 5.57988L3.70457 6.73897C3.4288 6.85716 3.25 7.12831 3.25 7.42833L3.25 14.8497C3.24997 15.1254 3.24994 15.3864 3.2729 15.6074C3.29853 15.8541 3.35744 16.1136 3.5143 16.3656C3.67116 16.6176 3.87796 16.785 4.08801 16.9169C4.27615 17.0351 4.51032 17.1503 4.75772 17.272L10.7859 20.2382L10.871 20.2803C11.2145 20.4508 11.5862 20.6353 12 20.6353C12.4138 20.6353 12.7855 20.4508 13.1291 20.2803L13.2142 20.2382L19.2422 17.272C19.4897 17.1503 19.7238 17.0351 19.912 16.9169C20.122 16.785 20.3288 16.6176 20.4857 16.3656C20.6426 16.1136 20.7015 15.8541 20.7271 15.6074C20.7501 15.3864 20.75 15.1254 20.75 14.8497L20.75 7.42833C20.75 7.12831 20.5712 6.85716 20.2954 6.73897L17.5909 5.57988C17.2102 5.41671 16.7693 5.59307 16.6061 5.9738C16.4429 6.35452 16.6193 6.79543 17 6.95859L18.0961 7.42833L12.4924 9.82991C12.2878 9.91759 12.1731 9.96617 12.0845 9.99622C12.0449 10.0096 12.0226 10.015 12.011 10.0173C12.0055 10.0184 12.0014 10.0188 12.0014 10.0188L12 10.0189L11.9986 10.0188C11.9986 10.0188 11.9945 10.0184 11.989 10.0173C11.9774 10.015 11.9551 10.0096 11.9155 9.99622C11.8269 9.96617 11.7122 9.91759 11.5076 9.8299L5.90395 7.42833L7 6.95859ZM6.31083 11.1332C6.474 10.7525 6.91491 10.5761 7.29563 10.7393L9.29563 11.5964C9.67635 11.7596 9.85272 12.2005 9.68955 12.5812C9.52638 12.962 9.08547 13.1383 8.70475 12.9752L6.70475 12.118C6.32403 11.9549 6.14767 11.5139 6.31083 11.1332Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge open-3": {
        defaultColors: ["#cdd1d8", "#141b34", "#000000"],
        keywords: ["package","box","open","inventory","stock","item","product","receive","receiving","shipment","delivery","new-stock","available"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8184V7.42838L12.7878 10.5193L12.7878 10.5193C12.3994 10.6858 12.2053 10.769 12 10.769C11.7947 10.769 11.6006 10.6858 11.2122 10.5193L11.2122 10.5193L4 7.42838V14.8184C4 15.4239 4 15.7267 4.15103 15.9693C4.30206 16.2119 4.5737 16.3456 5.11699 16.6129L11.117 19.5653C11.5505 19.7786 11.7673 19.8853 12 19.8853C12.2327 19.8853 12.4495 19.7786 12.883 19.5653L18.883 16.6129C19.4263 16.3456 19.6979 16.2119 19.849 15.9693C20 15.7267 20 15.4239 20 14.8184Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42838V14.8184C20 15.4239 20 15.7267 19.849 15.9693C19.6979 16.2119 19.4263 16.3456 18.883 16.6129L12.883 19.5653C12.4495 19.7786 12.2327 19.8853 12 19.8853C11.7673 19.8853 11.5505 19.7786 11.117 19.5653L5.11699 16.6129C4.5737 16.3456 4.30206 16.2119 4.15103 15.9693C4 15.7267 4 15.4239 4 14.8184V7.42838M20 7.42838L12.7878 10.5193C12.3995 10.6858 12.2053 10.769 12 10.769C11.7947 10.769 11.6005 10.6858 11.2122 10.5193L4 7.42838M20 7.42838L18.197 6.65565L17.2954 6.26929M4 7.42838L5.80304 6.65565L6.70456 6.26929"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 2V4M16 3L14.5 5M8 3L9.5 5"
                    stroke={colors?.[1] || "#141B34"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "packge out of stock-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["out of stock","unavailable","disabled","remove","delete","error","incorrect","cancel","cross","out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42851V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.2121 19.4263 16.3457 18.883 16.6131L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.6131C4.5737 16.3457 4.30206 16.2121 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42851M20 7.42851L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42851M20 7.42851L18.197 6.65578L17.2954 6.26941M4 7.42851L5.80304 6.65578L6.70456 6.26941"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 2L14 6" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 2L10 6" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge open": {
        defaultColors: ["#141b34", "#000000"],
        keywords: ["notification","alert","new","message","update","incoming"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42851V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.2121 19.4263 16.3457 18.883 16.6131L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.6131C4.5737 16.3457 4.30206 16.2121 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42851M20 7.42851L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42851M20 7.42851L18.197 6.65578L17.2954 6.26941M4 7.42851L5.80304 6.65578L6.70456 6.26941"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 2V4M16 3L14.5 5M8 3L9.5 5"
                    stroke={colors?.[0] || "#141B34"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge out of stock-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","open","container","inventory","stock","out-of-stock","empty","shipping","products","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8184V7.42838L12.7878 10.5193L12.7878 10.5193C12.3994 10.6858 12.2053 10.769 12 10.769C11.7947 10.769 11.6006 10.6858 11.2122 10.5193L11.2122 10.5193L4 7.42838V14.8184C4 15.4239 4 15.7267 4.15103 15.9693C4.30206 16.2119 4.5737 16.3456 5.11699 16.6129L11.117 19.5653C11.5505 19.7786 11.7673 19.8853 12 19.8853C12.2327 19.8853 12.4495 19.7786 12.883 19.5653L18.883 16.6129C19.4263 16.3456 19.6979 16.2119 19.849 15.9693C20 15.7267 20 15.4239 20 14.8184Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42838V14.8184C20 15.4239 20 15.7267 19.849 15.9693C19.6979 16.2119 19.4263 16.3456 18.883 16.6129L12.883 19.5653C12.4495 19.7786 12.2327 19.8853 12 19.8853C11.7673 19.8853 11.5505 19.7786 11.117 19.5653L5.11699 16.6129C4.5737 16.3456 4.30206 16.2119 4.15103 15.9693C4 15.7267 4 15.4239 4 14.8184V7.42838M20 7.42838L12.7878 10.5193C12.3995 10.6858 12.2053 10.769 12 10.769C11.7947 10.769 11.6005 10.6858 11.2122 10.5193L4 7.42838M20 7.42838L18.197 6.65565L17.2954 6.26929M4 7.42838L5.80304 6.65565L6.70456 6.26929"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 2L14 6" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 2L10 6" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge out of stock-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","out of stock","unavailable","inventory","stock","item","product","disabled","not available"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5303 1.46967C10.2374 1.17678 9.76256 1.17678 9.46967 1.46967C9.17678 1.76256 9.17678 2.23744 9.46967 2.53033L10.9393 4L9.46967 5.46967C9.17678 5.76256 9.17678 6.23744 9.46967 6.53033C9.76256 6.82322 10.2374 6.82322 10.5303 6.53033L12 5.06066L13.4697 6.53033C13.7626 6.82322 14.2374 6.82322 14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L13.0607 4L14.5303 2.53033C14.8232 2.23744 14.8232 1.76256 14.5303 1.46967C14.2374 1.17678 13.7626 1.17678 13.4697 1.46967L12 2.93934L10.5303 1.46967Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.39392 5.9738C7.55709 6.35452 7.38073 6.79543 7 6.95859L5.90395 7.42833L11.5076 9.8299C11.7122 9.91759 11.8269 9.96617 11.9155 9.99622C11.9551 10.0096 11.9774 10.015 11.989 10.0173C11.9945 10.0184 11.9986 10.0188 11.9986 10.0188L12 10.0189L12.0014 10.0188C12.0014 10.0188 12.0055 10.0184 12.011 10.0173C12.0226 10.015 12.0449 10.0096 12.0845 9.99622C12.1731 9.96617 12.2878 9.91759 12.4924 9.82991L18.0961 7.42833L17 6.95859C16.6193 6.79543 16.4429 6.35452 16.6061 5.9738C16.7693 5.59307 17.2102 5.41671 17.5909 5.57988L20.2954 6.73897C20.5712 6.85716 20.75 7.12831 20.75 7.42833L20.75 14.8497C20.75 15.1254 20.7501 15.3864 20.7271 15.6074C20.7015 15.8541 20.6426 16.1136 20.4857 16.3656C20.3288 16.6176 20.122 16.785 19.912 16.9169C19.7238 17.0351 19.4897 17.1503 19.2422 17.272L13.2142 20.2382L13.1291 20.2803C12.7855 20.4508 12.4138 20.6353 12 20.6353C11.5862 20.6353 11.2145 20.4508 10.871 20.2803L10.7859 20.2382L4.75772 17.272C4.51032 17.1503 4.27615 17.0351 4.08801 16.9169C3.87796 16.785 3.67116 16.6176 3.5143 16.3656C3.35744 16.1136 3.29853 15.8541 3.2729 15.6074C3.24994 15.3864 3.24997 15.1254 3.25 14.8497L3.25 7.42833C3.25 7.12831 3.4288 6.85716 3.70457 6.73897L6.40913 5.57988C6.78985 5.41671 7.23076 5.59307 7.39392 5.9738ZM7.29563 10.7393C6.91491 10.5761 6.474 10.7525 6.31083 11.1332C6.14767 11.5139 6.32403 11.9549 6.70475 12.118L8.70475 12.9752C9.08547 13.1383 9.52638 12.962 9.68955 12.5812C9.85272 12.2005 9.67635 11.7596 9.29563 11.5964L7.29563 10.7393Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge out of stock": {
        defaultColors: ["#000000"],
        keywords: ["box","package","out of stock","stock","inventory","unavailable","sold out","error","warning","alert","item","product","supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42851V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.2121 19.4263 16.3457 18.883 16.6131L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.6131C4.5737 16.3457 4.30206 16.2121 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42851M20 7.42851L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42851M20 7.42851L18.197 6.65578L17.2954 6.26941M4 7.42851L5.80304 6.65578L6.70456 6.26941"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 2L14 6" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 2L10 6" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge pin-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["pin","pushpin","location","note","reminder","mark","flag","attention","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.6683 17.3121L21.3307 16.6497C21.643 16.3374 21.7991 16.1813 21.7991 15.9873C21.7991 15.7932 21.643 15.6371 21.3307 15.3248L20.6683 14.6624C20.356 14.3502 20.1999 14.194 20.0059 14.194C19.8118 14.194 19.6557 14.3502 19.3434 14.6624L18.681 15.3248"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6812 15.3249L18.3665 15.4298C17.2728 15.7943 16.7259 15.9766 16.5646 16.3802C16.5302 16.4664 16.5087 16.5573 16.501 16.6498C16.4648 17.083 16.8724 17.4906 17.6875 18.3058V18.3058C18.5027 19.1209 18.9103 19.5285 19.3435 19.4923C19.436 19.4846 19.5269 19.4631 19.6131 19.4287C20.0167 19.2674 20.199 18.7205 20.5635 17.6268L20.6684 17.3121"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.687 18.3057L16.3622 19.6305"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge pin-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","damaged","defect","inventory","shipment","loss","problem","delivery","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.3306 16.6497L20.8246 17.1557C20.7467 17.2335 20.7078 17.2725 20.6791 17.3189C20.6505 17.3653 20.6331 17.4175 20.5983 17.522L20.5633 17.6268C20.1988 18.7205 20.0165 19.2674 19.6129 19.4287C19.5267 19.4631 19.4358 19.4846 19.3432 19.4923C18.9101 19.5285 18.5025 19.1209 17.6873 18.3058C16.8721 17.4906 16.4645 17.083 16.5008 16.6498C16.5085 16.5573 16.5299 16.4664 16.5644 16.3802C16.7257 15.9766 17.2726 15.7943 18.3663 15.4298L18.4712 15.3948C18.5756 15.36 18.6278 15.3426 18.6741 15.3139C18.7205 15.2852 18.7594 15.2463 18.8373 15.1685L19.3433 14.6624L19.3433 14.6624C19.6556 14.3502 19.8117 14.194 20.0057 14.194C20.1998 14.194 20.3559 14.3502 20.6682 14.6624L21.3306 15.3248L21.3306 15.3249C21.6429 15.6371 21.799 15.7933 21.799 15.9873C21.799 16.1813 21.6429 16.3374 21.3306 16.6497Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M17.6865 18.3057L16.3617 19.6305L17.6865 18.3057Z" fill={colors?.[1] || "#000000"} />
                <path d="M17.6865 18.3057L16.3617 19.6305" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "packge pin-3": {
        defaultColors: ["#000000"],
        keywords: ["pin","location","gps","map","marker","store-locator","navigation","address"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.342 20.6354 12.6552 20.5095 12.9475 20.3695C13.0089 20.3401 13.0694 20.3101 13.1291 20.2805L13.2142 20.2384L14.972 19.3734L14.9108 19.3008C14.6389 18.9125 14.3318 18.3203 14.3954 17.56C14.4176 17.2946 14.4791 17.034 14.5779 16.7867C14.9032 15.9728 15.5668 15.5761 15.994 15.37C16.3897 15.1792 16.8897 15.0126 17.363 14.855L17.3739 14.8513L17.7844 14.4408C17.908 14.3171 18.0979 14.1268 18.2958 13.9758C18.5528 13.7797 19.0099 13.5 19.6442 13.5C20.1124 13.5 20.4841 13.6524 20.75 13.8112L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M20.386 14.7708C20.507 14.8632 20.6321 14.9839 20.7494 15.1006L21.5229 15.8741C21.6581 16.0091 21.8072 16.1581 21.9166 16.3014C22.0455 16.4704 22.1874 16.7163 22.1874 17.0432C22.1874 17.3701 22.0455 17.616 21.9166 17.785C21.8072 17.9284 21.6581 18.0774 21.5229 18.2124L20.9622 18.7731L20.8984 18.9649C20.729 19.4731 20.5795 19.9218 20.4168 20.2591C20.2474 20.6104 19.9936 20.9956 19.5298 21.181C19.3745 21.2431 19.2109 21.2817 19.0443 21.2956C18.5464 21.3373 18.1472 21.1062 17.8386 20.8678C17.6798 20.7451 17.5102 20.5922 17.3287 20.4185L16.5303 21.2168C16.2374 21.5097 15.7626 21.5097 15.4697 21.2168C15.1768 20.9239 15.1768 20.449 15.4697 20.1561L16.268 19.3578C16.1225 19.2057 15.9917 19.062 15.881 18.9261C15.8599 18.9001 15.8394 18.8744 15.8198 18.849C15.5814 18.5404 15.3503 18.1411 15.3919 17.6433C15.4058 17.4767 15.4445 17.3131 15.5065 17.1578C15.6919 16.6939 16.0772 16.4402 16.4284 16.2708C16.7657 16.1081 17.2143 15.9586 17.7225 15.7892L17.9141 15.7253L18.475 15.1645C18.61 15.0293 18.759 14.8802 18.9024 14.7708C19.0714 14.6419 19.3172 14.5 19.6442 14.5C19.9711 14.5 20.2169 14.6419 20.386 14.7708Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge pin": {
        defaultColors: ["#000000"],
        keywords: ["pin","location","map","store","mark","place","shop","position"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.6683 17.3121L21.3307 16.6497C21.643 16.3374 21.7991 16.1813 21.7991 15.9873C21.7991 15.7932 21.643 15.6371 21.3307 15.3248L20.6683 14.6624C20.356 14.3502 20.1999 14.194 20.0059 14.194C19.8118 14.194 19.6557 14.3502 19.3434 14.6624L18.681 15.3248"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6812 15.3249L18.3665 15.4298C17.2728 15.7943 16.7259 15.9766 16.5646 16.3802C16.5302 16.4664 16.5087 16.5573 16.501 16.6498C16.4648 17.083 16.8724 17.4906 17.6875 18.3058V18.3058C18.5027 19.1209 18.9103 19.5285 19.3435 19.4923C19.436 19.4846 19.5269 19.4631 19.6131 19.4287C20.0167 19.2674 20.199 18.7205 20.5635 17.6268L20.6684 17.3121"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17.687 18.3057L16.3622 19.6305" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "packge pointer-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cursor","mouse","pointer","select","choose","touch","navigate","interface","ui","ux"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8931 14.8929L15.536 14.5357"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3929 14.5357L18.7501 14.1786"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1786 17.7505L15.5357 17.3934"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1233 19.8211L17.4841 17.4244C17.3337 16.8601 17.2584 16.5779 17.4137 16.4318C17.5691 16.2857 17.8461 16.3781 18.4002 16.5628L20.7174 17.3352C21.4673 17.5851 21.8422 17.7101 21.8525 17.9562C21.8627 18.2023 21.4994 18.358 20.7729 18.6693L20.2198 18.9064C20.1107 18.9531 20.0562 18.9765 20.0127 19.0153C19.9692 19.054 19.9398 19.1055 19.881 19.2085L19.4336 19.9914C19.0669 20.6331 18.8836 20.9539 18.6462 20.923C18.4089 20.8922 18.3137 20.5351 18.1233 19.8211Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge pointer-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","damaged","broken","inventory","stock","package","cube","damaged-goods","defective","issue","problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3931 15.3929L16.036 15.0357"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8929 15.0357L19.2501 14.6786"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.6786 18.2505L16.0357 17.8934"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.6233 20.3211L17.9841 17.9244C17.8337 17.3601 17.7584 17.0779 17.9137 16.9318C18.0691 16.7857 18.3461 16.8781 18.9002 17.0628L21.2174 17.8352C21.9673 18.0851 22.3422 18.2101 22.3525 18.4562C22.3627 18.7023 21.9994 18.858 21.2729 19.1693L20.7198 19.4064C20.6107 19.4531 20.5562 19.4765 20.5127 19.5153C20.4692 19.554 20.4398 19.6055 20.381 19.7085L19.9336 20.4914C19.5669 21.1331 19.3836 21.4539 19.1462 21.423C18.9089 21.3922 18.8137 21.0351 18.6233 20.3211Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge pointer-3": {
        defaultColors: ["#000000"],
        keywords: ["pointer","cursor","select","location","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.8499C20.75 14.9679 20.75 15.0833 20.7482 15.1939C20.6138 14.723 20.3832 14.2803 20.132 14.0182L20.1247 14.0105L20.1172 14.003C19.4885 13.3744 18.4865 13.3955 17.8681 13.9881L17.8415 14.0137L17.5746 14.3102L17.5572 14.2928C16.9286 13.6642 15.9266 13.6853 15.3082 14.2779L15.3006 14.2853L15.293 14.2928C14.6644 14.9214 14.6856 15.9235 15.2782 16.5418L15.2855 16.5495L15.3109 16.5749L15.3028 16.583L15.0128 16.873C14.3841 17.5016 14.4053 18.5037 14.9979 19.122L15.0052 19.1297L15.0128 19.1372C15.0579 19.1824 15.1108 19.2289 15.17 19.276L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M18.5601 14.7101L18.29 15.0101C18.29 15.0101 18.23 15.1001 18.2 15.1401C18.17 15.1901 18.1501 15.2501 18.14 15.3001C18.1 15.4901 18.14 15.7001 18.29 15.8501C18.29 15.8501 18.29 15.8501 18.3 15.8501C18.51 16.0501 18.8301 16.0601 19.0601 15.8901C19.0801 15.8701 19.11 15.8601 19.13 15.8401L19.41 15.5601C19.64 15.3301 19.64 14.9501 19.41 14.7101C19.18 14.4801 18.8 14.4801 18.5601 14.7101Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M21.7101 17.5201C21.6301 17.4601 21.5701 17.4101 21.5201 17.3801C21.3301 17.2901 21.0701 17.2001 20.8001 17.1101C20.7901 17.1101 20.7801 17.1101 20.7601 17.1001L19.6401 16.7301L18.9101 16.4901C18.9101 16.4901 18.8901 16.4901 18.8801 16.4801C18.6901 16.4201 18.3914 16.3401 18.2214 16.3101C18.1914 16.3101 18.2401 16.3201 18.2001 16.3101C18.0101 16.2901 17.7601 16.3101 17.5301 16.5101C17.5301 16.5101 17.5101 16.5301 17.5001 16.5401C17.2801 16.7601 17.2601 17.0301 17.2701 17.2201C17.2701 17.2401 17.2701 17.2701 17.2701 17.2901C17.2901 17.4601 17.3501 17.7001 17.4001 17.9001C17.4001 17.8901 17.4001 17.9101 17.4001 17.9001L17.6301 18.7601L17.9101 19.8201C17.9801 20.0701 18.0401 20.3601 18.1201 20.5501C18.1401 20.6001 18.1801 20.6801 18.2301 20.7501C18.3401 20.9201 18.5101 21.1001 18.8201 21.1401C19.2601 21.2001 19.5301 20.8901 19.6501 20.7401C19.6801 20.7001 19.7201 20.6401 19.7501 20.5801C19.8401 20.4401 19.9301 20.2901 20.0301 20.1201C20.0301 20.1101 20.0401 20.1001 20.0501 20.0901L20.4001 19.4701L20.8301 19.2801C20.8301 19.2801 20.8501 19.2701 20.8701 19.2601C21.1001 19.1601 21.3201 19.0601 21.4901 18.9701C21.5101 18.9601 21.5401 18.9501 21.5601 18.9401C21.7201 18.8401 22.0801 18.6001 22.0601 18.1401C22.0501 17.8301 21.8701 17.6401 21.7101 17.5201Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.2701 15.4899C17.2401 15.4199 17.2001 15.3499 17.1401 15.2899L16.8501 14.9999C16.6201 14.7699 16.2401 14.7699 16.0001 14.9999C15.7701 15.2299 15.7701 15.6099 16.0001 15.8499L16.2901 16.1399C16.3501 16.1899 16.4101 16.2399 16.4801 16.2599C16.6501 16.3299 16.8401 16.3099 17.0001 16.2299C17.0501 16.1999 17.1001 16.1799 17.1401 16.1399C17.1801 16.0999 17.2001 16.0499 17.2301 16.0099C17.3201 15.8499 17.3401 15.6599 17.2701 15.4899Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.5199 18.4601C16.5199 18.4601 16.5499 18.4301 16.5699 18.4201L16.8599 18.1301C17.0899 17.9001 17.0899 17.5301 16.8599 17.2901C16.6999 17.1301 16.4799 17.0901 16.2799 17.1401C16.2299 17.1501 16.1899 17.1701 16.1399 17.2001C16.0899 17.2301 16.0499 17.2501 16.0099 17.2901L15.7199 17.5801C15.4899 17.8101 15.4899 18.1901 15.7199 18.4301C15.9399 18.6501 16.2899 18.6601 16.5199 18.4601Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge pointer": {
        defaultColors: ["#000000"],
        keywords: ["pointer","location","map","address","navigation","gps","pin","here"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8931 14.8929L15.536 14.5357"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3929 14.5357L18.7501 14.1786"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1786 17.7505L15.5357 17.3934"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1233 19.8211L17.4841 17.4244C17.3337 16.8601 17.2584 16.5779 17.4137 16.4318C17.5691 16.2857 17.8461 16.3781 18.4002 16.5628L20.7174 17.3352C21.4673 17.5851 21.8422 17.7101 21.8525 17.9562C21.8627 18.2023 21.4994 18.358 20.7729 18.6693L20.2198 18.9064C20.1107 18.9531 20.0562 18.9765 20.0127 19.0153C19.9692 19.054 19.9398 19.1055 19.881 19.2085L19.4336 19.9914C19.0669 20.6331 18.8836 20.9539 18.6462 20.923C18.4089 20.8922 18.3137 20.5351 18.1233 19.8211Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge process-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["target","bullseye","focus","center","aim","goal","selection","marketing","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5C16 17.8807 17.1193 19 18.5 19C19.8807 19 21 17.8807 21 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 16.5003L18.783 16.2172L18.8538 16.1465"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.0862 18.9734"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge process-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","delivery","shipping","inventory","stock","receiving","products","goods","items","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5C16 17.8807 17.1193 19 18.5 19C19.8807 19 21 17.8807 21 16.5Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 16.5003L18.783 16.2172L18.8538 16.1465"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge process-3": {
        defaultColors: ["#000000"],
        keywords: ["loading","spinner","process","pending","waiting","buffering","syncing","updating","processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.0627C20.0485 13.5516 19.1844 13.25 18.25 13.25C15.9028 13.25 14 15.1528 14 17.5C14 18.2571 14.198 18.9679 14.5449 19.5835L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.25 14.25C16.4551 14.25 15 15.7051 15 17.5C15 18.0986 15.1618 18.6594 15.4442 19.1411C16.0083 20.1036 17.0537 20.75 18.25 20.75C20.0449 20.75 21.5 19.2949 21.5 17.5C21.5 16.7055 21.2149 15.9776 20.7415 15.413C20.1453 14.7021 19.2505 14.25 18.25 14.25ZM19.1341 16.6162C19.427 16.909 19.427 17.3839 19.1341 17.6768L18.7803 18.0306C18.4874 18.3235 18.0126 18.3235 17.7197 18.0306C17.4268 17.7377 17.4268 17.2628 17.7197 16.9699L18.0734 16.6162C18.3663 16.3233 18.8412 16.3233 19.1341 16.6162Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge process": {
        defaultColors: ["#000000"],
        keywords: ["package","process","shipping","delivery","fulfillment","order-processing","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5C16 17.8807 17.1193 19 18.5 19C19.8807 19 21 17.8807 21 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 16.5003L18.783 16.2172L18.8538 16.1465"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.0862 18.9734"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge receive-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","left","back","return","previous","undo","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 14L16 16L18 18"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16L21 16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge receive-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","receive","return","inventory","stock","deliver","delivery","arrow-left","incoming","import"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 14L16 16L18 18" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 16L21 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge receive-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","receive","add","plus","order","add-order","inventory","stock","inbound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L16.5983 18.5732L15.0125 16.9874C14.3291 16.304 14.3292 15.196 15.0126 14.5125L17.0126 12.5126C17.696 11.8291 18.804 11.8291 19.4874 12.5126C19.8929 12.918 20.0578 13.473 19.9822 14L20.75 14L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7803 18.2803C18.4874 18.5732 18.0125 18.5732 17.7196 18.2803L15.7197 16.2803C15.4268 15.9874 15.4268 15.5125 15.7197 15.2197L17.7197 13.2197C18.0126 12.9268 18.4874 12.9268 18.7803 13.2197C19.0732 13.5126 19.0732 13.9874 18.7803 14.2803L18.0607 15L21.25 15C21.6642 15 22 15.3358 22 15.75C22 16.1642 21.6642 16.5 21.25 16.5L18.0606 16.5L18.7803 17.2197C19.0732 17.5126 19.0732 17.9874 18.7803 18.2803Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge receive": {
        defaultColors: ["#000000"],
        keywords: ["box","package","receive","delivery","inventory","stock","inbound","add-stock","add-inventory","restock","add","plus","arrival","incoming"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 14L16 16L18 18" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 16L21 16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge refresh-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["refresh","reload","update","sync","cycle","repeat","restock","inventory","price-update","data-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6192 17.9983C21.4794 18.421 21.2437 18.8057 20.9307 19.1224C20.2624 19.7905 19.3181 20.1044 18.3828 19.9693C17.4474 19.8341 16.6306 19.2658 16.1787 18.4357"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.4433 15.5644C20.9915 14.7343 20.1746 14.166 19.2393 14.0308C18.304 13.8957 17.3596 14.2096 16.6913 14.8777C16.3777 15.1944 16.1411 15.579 16 16.0018"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.292 15.5655H21.6193V14.24"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3289 18.4326H16.0044V19.7581"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.4846 19.2694"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge refresh-3": {
        defaultColors: ["#000000"],
        keywords: ["refresh","reload","update","sync","circular-arrows","retry","repeat","restore","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 13.2309C20.5815 13.2548 20.4209 13.3027 20.2715 13.371C19.9118 13.2134 19.5289 13.1029 19.1314 13.0454C17.7552 12.8466 16.3657 13.3076 15.3814 14.2896L15.3745 14.2965L15.3719 14.2991C14.9039 14.7716 14.551 15.3454 14.3405 15.9762C14.1468 16.5564 14.2741 17.1664 14.626 17.6137C14.3933 17.9109 14.2545 18.2852 14.2545 18.6919C14.2545 19.1863 14.2817 19.4802 14.3193 19.6946L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.0048 17.9418C15.5905 17.9418 15.2548 18.2776 15.2548 18.6918V19.8706C15.2548 20.2848 15.5905 20.6206 16.0048 20.6206C16.2679 20.6206 16.4994 20.485 16.6333 20.2799C17.0442 20.5483 17.5135 20.7286 18.0125 20.8007C19.0783 20.9547 20.1543 20.597 20.9159 19.8356L20.919 19.8325C21.2786 19.4687 21.5493 19.0268 21.7099 18.5412C21.8401 18.1479 21.6268 17.7237 21.2335 17.5936C20.8403 17.4634 20.416 17.6767 20.2859 18.07C20.198 18.3355 20.0502 18.5773 19.8538 18.7764C19.4267 19.2024 18.824 19.4023 18.227 19.3161C18.061 19.2921 17.9009 19.2468 17.75 19.1825C17.8638 19.0509 17.9327 18.8794 17.9327 18.6918C17.9327 18.4364 17.805 18.2108 17.6099 18.0754C17.4887 17.9912 17.3414 17.9418 17.1827 17.9418H16.0048Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.2209 15.6408C19.0789 15.5831 18.9291 15.5421 18.7741 15.5197C18.177 15.4334 17.5741 15.6335 17.147 16.0597C16.9498 16.2592 16.801 16.5015 16.7121 16.7677C16.581 17.1606 16.1561 17.3728 15.7632 17.2416C15.3703 17.1105 15.1581 16.6857 15.2893 16.2928C15.4512 15.8076 15.7227 15.3662 16.0826 15.0028L16.0852 15.0002C16.8468 14.2388 17.9228 13.8811 18.9886 14.0351C19.4877 14.1072 19.9571 14.2876 20.3681 14.556C20.4578 14.4177 20.5918 14.3108 20.75 14.2554C20.8276 14.2282 20.911 14.2135 20.9979 14.2135C21.4121 14.2135 21.7479 14.5493 21.7479 14.9635V16.1422C21.7479 16.5564 21.4121 16.8922 20.9979 16.8922H19.9509H19.8175C19.4033 16.8922 19.0675 16.5564 19.0675 16.1422C19.0675 15.9551 19.136 15.784 19.2494 15.6526L19.2209 15.6408Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge refresh-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","damaged","box","broken","return","refund","inventory-issue","spoiled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.6192 17.9983C21.4794 18.421 21.2437 18.8057 20.9307 19.1224C20.2624 19.7905 19.3181 20.1044 18.3828 19.9693C17.4474 19.8341 16.6306 19.2658 16.1787 18.4357"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.4433 15.5644C20.9915 14.7343 20.1746 14.166 19.2393 14.0308C18.304 13.8957 17.3596 14.2096 16.6913 14.8777C16.3777 15.1944 16.1411 15.579 16 16.0018"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.292 15.5655H21.6193V14.24"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3289 18.4326H16.0044V19.7581"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge refresh": {
        defaultColors: ["#000000"],
        keywords: ["refresh","reload","update","sync","inventory","stock","circular arrows"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6192 17.9983C21.4794 18.421 21.2437 18.8057 20.9307 19.1224C20.2624 19.7905 19.3181 20.1044 18.3828 19.9693C17.4474 19.8341 16.6306 19.2658 16.1787 18.4357"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.4433 15.5644C20.9915 14.7343 20.1746 14.166 19.2393 14.0308C18.304 13.8957 17.3596 14.2096 16.6913 14.8777C16.3777 15.1944 16.1411 15.579 16 16.0018"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.292 15.5655H21.6193V14.24"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3289 18.4326H16.0044V19.7581"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.4846 19.2694"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge remove-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["remove","delete","cancel","cross","close","item-remove","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 15L21 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 15L17 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge remove-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","remove","delete","inventory","stock","item","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 15L21 19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 15L17 19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "packge remove-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","remove","delete","order","remove-order","delete-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7197 14.4697C17.0126 14.1768 17.4874 14.1768 17.7803 14.4697L18.75 15.4393L19.7197 14.4697C20.0126 14.1768 20.4874 14.1768 20.7803 14.4697C21.0732 14.7626 21.0732 15.2374 20.7803 15.5303L19.8107 16.5L20.7803 17.4697C21.0732 17.7626 21.0732 18.2374 20.7803 18.5303C20.4874 18.8232 20.0126 18.8232 19.7197 18.5303L18.75 17.5607L17.7803 18.5303C17.4874 18.8232 17.0126 18.8232 16.7197 18.5303C16.4268 18.2374 16.4268 17.7626 16.7197 17.4697L17.6893 16.5L16.7197 15.5303C16.4268 15.2374 16.4268 14.7626 16.7197 14.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.7927 18.9695C15.3393 18.2897 15.4126 17.3625 16.0126 16.7626L16.2751 16.5L16.0126 16.2374C15.3291 15.554 15.3291 14.446 16.0126 13.7626C16.696 13.0791 17.804 13.0791 18.4874 13.7626L18.75 14.0251L19.0126 13.7626C19.4829 13.2923 20.1543 13.1456 20.75 13.3226L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge remove": {
        defaultColors: ["#000000"],
        keywords: ["box","package","remove","delete","order","remove-order","package-remove","item-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 15L21 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 15L17 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge reshare-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["repeat","arrows","resend","retry","sync","reorder","transaction-history","exchange","replace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.1431 15.4643L21.0002 14.6071L20.1431 13.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8574 16.3213V16.3213C15.8574 15.9227 15.8574 15.7234 15.9012 15.5599C16.0201 15.1163 16.3667 14.7697 16.8104 14.6508C16.9739 14.607 17.1731 14.607 17.5717 14.607L21.0003 14.607"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.7148 18.2856L15.8577 19.1428L16.7148 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.0003 17.4287V17.4287C21.0003 18.2368 21.0003 18.6409 20.7492 18.8919C20.4982 19.143 20.0941 19.143 19.286 19.143H15.8574"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.4846 19.2694"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge reshare-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","order","cube","inventory","shipment","delivery","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1431 15.4643L21.0002 14.6071L20.1431 13.75"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8574 16.3213V16.3213C15.8574 15.9227 15.8574 15.7234 15.9012 15.5599C16.0201 15.1163 16.3667 14.7697 16.8104 14.6508C16.9739 14.607 17.1731 14.607 17.5717 14.607L21.0003 14.607"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.7148 18.2856L15.8577 19.1428L16.7148 19.9999"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.0003 17.4287V17.4287C21.0003 18.2368 21.0003 18.6409 20.7492 18.8919C20.4982 19.143 20.0941 19.143 19.286 19.143H15.8574"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "packge reshare-3": {
        defaultColors: ["#000000"],
        keywords: ["reshare","package","box","share","export","sales-report","transfer","stock-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.1547 20.6354 12.3035 20.6096 12.4471 20.5685C12.6878 20.4995 12.9139 20.3872 13.1291 20.2805L13.2142 20.2384L14.1166 19.7943C14.1069 19.5478 14.1077 19.2895 14.1161 19C14.1501 18.5886 14.3287 18.2007 14.6227 17.9066L14.8076 17.7217C14.3823 17.4025 14.1072 16.894 14.1072 16.3213L14.1071 16.2004C14.1063 15.9143 14.1053 15.5003 14.2107 15.107C14.4914 14.0594 15.3096 13.2411 16.3572 12.9604C16.7505 12.8551 17.1645 12.8561 17.4506 12.8568L17.4965 12.8569L18.6375 12.857L18.9054 12.5126C19.4042 12.0138 20.1291 11.879 20.75 12.1082L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M20.75 13.2966L20.673 13.2197C20.3802 12.9268 19.9053 12.9268 19.6124 13.2197C19.4386 13.3934 19.368 13.6312 19.4004 13.8571L17.495 13.8569C17.1742 13.8565 16.8781 13.8561 16.6159 13.9264C15.9134 14.1146 15.3647 14.6633 15.1764 15.3658C15.1062 15.6281 15.1066 15.9241 15.107 16.245L15.1071 16.3213C15.1071 16.7355 15.4429 17.0713 15.8571 17.0713C16.2713 17.0713 16.6071 16.7355 16.6071 16.3213C16.6071 15.8744 16.6135 15.7981 16.6253 15.7541C16.6749 15.5692 16.8193 15.4248 17.0041 15.3753C17.0482 15.3634 17.1245 15.357 17.5714 15.357L19.4004 15.3571C19.3679 15.583 19.4386 15.8208 19.6124 15.9946C19.8958 16.278 20.3497 16.2872 20.6441 16.0221L20.6478 16.0187C20.6563 16.0109 20.6648 16.0029 20.673 15.9946L21.5302 15.1375C21.6708 14.9968 21.7499 14.8061 21.7499 14.6071C21.7499 14.4082 21.6708 14.2175 21.5302 14.0768L20.75 13.2966Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.4549 18.1516C17.4285 18.0069 17.3594 17.8685 17.2475 17.7566C16.9546 17.4637 16.4797 17.4637 16.1868 17.7566L15.3297 18.6137C15.2235 18.7199 15.1524 18.8547 15.124 19C15.1147 19.0471 15.11 19.0954 15.11 19.1441C15.11 19.1961 15.1154 19.2475 15.1259 19.2977C15.1555 19.4393 15.2258 19.5705 15.3297 19.6744L16.1868 20.5315C16.4797 20.8244 16.9546 20.8244 17.2475 20.5315C17.4212 20.3578 17.4919 20.12 17.4595 19.8941L19.3649 19.8943C19.6857 19.8947 19.9817 19.8951 20.244 19.8248C20.9465 19.6366 21.4952 19.0879 21.6834 18.3854C21.7537 18.1231 21.7533 17.8271 21.7529 17.5063L21.7528 17.4299C21.7528 17.0157 21.417 16.6799 21.0028 16.6799C20.9676 16.6799 20.9329 16.6824 20.8989 16.6871C20.5339 16.7376 20.2528 17.051 20.2528 17.4299C20.2528 17.8768 20.2463 17.9531 20.2345 17.9972C20.185 18.182 20.0406 18.3264 19.8557 18.376C19.8116 18.3878 19.7353 18.3942 19.2885 18.3942L17.4595 18.3941C17.471 18.3137 17.4695 18.2317 17.4549 18.1516Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge reshare": {
        defaultColors: ["#000000"],
        keywords: ["reshare","share","package","box","resend","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.1431 15.4643L21.0002 14.6071L20.1431 13.75"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8574 16.3213V16.3213C15.8574 15.9227 15.8574 15.7234 15.9012 15.5599C16.0201 15.1163 16.3667 14.7697 16.8104 14.6508C16.9739 14.607 17.1731 14.607 17.5717 14.607L21.0003 14.607"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.7148 18.2856L15.8577 19.1428L16.7148 19.9999"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.0003 17.4287V17.4287C21.0003 18.2368 21.0003 18.6409 20.7492 18.8919C20.4982 19.143 20.0941 19.143 19.286 19.143H15.8574"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.4846 19.2694"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge return-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["return","undo","back","reverse","arrow","go-back","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4286 15.4286L20.2143 15.4286C21.2005 15.4286 22 16.2281 22 17.2143V17.2143V17.2143C22 18.2005 21.2005 19 20.2143 19L17 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.1426 14L18.7242 14.4184C18.248 14.8946 18.0099 15.1327 18.0099 15.4286C18.0099 15.7244 18.248 15.9625 18.7242 16.4387L19.1426 16.8571"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge return-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","return","returned","delivery","inventory","stock","item-return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4286 15.4286L20.2143 15.4286C21.2005 15.4286 22 16.2281 22 17.2143V17.2143V17.2143C22 18.2005 21.2005 19 20.2143 19L17 19"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.1426 14L18.7242 14.4184C18.248 14.8946 18.0099 15.1327 18.0099 15.4286C18.0099 15.7244 18.248 15.9625 18.7242 16.4387L19.1426 16.8571"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge return-3": {
        defaultColors: ["#000000"],
        keywords: ["return","undo","revert","transaction-return","sales-return","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L14.0905 19.8071C14.0318 19.6321 14 19.4448 14 19.25C14 18.2835 14.7835 17.5 15.75 17.5H16.0606L15.9351 17.3746C15.7393 17.1789 15.4887 16.9286 15.2972 16.6775C15.06 16.3667 14.7599 15.8636 14.7599 15.1786C14.7599 14.4935 15.06 13.9905 15.2972 13.6796C15.4887 13.4286 15.7393 13.1782 15.9351 12.9826L16.4051 12.5126C17.0886 11.8292 18.1966 11.8291 18.88 12.5126C19.1849 12.8175 19.3538 13.2069 19.3866 13.6054C19.888 13.727 20.35 13.9493 20.75 14.2497L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.1122 13.2197C17.4051 12.9268 17.88 12.9268 18.1729 13.2197C18.4658 13.5126 18.4658 13.9874 18.1729 14.2803L17.9532 14.5H18.5C20.0188 14.5 21.25 15.7312 21.25 17.25C21.25 18.7688 20.0188 20 18.5 20H15.75C15.3358 20 15 19.6642 15 19.25C15 18.8358 15.3358 18.5 15.75 18.5H18.5C19.1904 18.5 19.75 17.9404 19.75 17.25C19.75 16.5596 19.1904 16 18.5 16H18.0961L18.1729 16.0768C18.4658 16.3697 18.4658 16.8446 18.1729 17.1375C17.88 17.4304 17.4051 17.4304 17.1122 17.1375L16.6655 16.6907C16.452 16.4774 16.2423 16.2677 16.0922 16.071C15.9222 15.8482 15.7599 15.5564 15.7599 15.1786C15.7599 14.8007 15.9222 14.5089 16.0922 14.2862C16.2423 14.0894 16.452 13.8798 16.6655 13.6664L17.1122 13.2197Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge return": {
        defaultColors: ["#000000"],
        keywords: ["box","package","return","refund","inventory","stock","shipment","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4286 15.4286L20.2143 15.4286C21.2005 15.4286 22 16.2281 22 17.2143V17.2143V17.2143C22 18.2005 21.2005 19 20.2143 19L17 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.1426 14L18.7242 14.4184C18.248 14.8946 18.0099 15.1327 18.0099 15.4286C18.0099 15.7244 18.248 15.9625 18.7242 16.4387L19.1426 16.8571"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge search-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["search","find","lookup","inventory-search","product-search","customer-search","transaction-search","data-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6581 17.6581L21 19M19.6581 17.6581C20.0459 17.2703 20.2857 16.7346 20.2857 16.1429C20.2857 14.9594 19.3263 14 18.1429 14C16.9594 14 16 14.9594 16 16.1429C16 17.3263 16.9594 18.2857 18.1429 18.2857C18.7346 18.2857 19.2703 18.0459 19.6581 17.6581Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.0862 18.9734"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge search-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","delivery","shipping","inventory","stock","supply","storage","crate","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.6581 17.6581L21 19M19.6581 17.6581C20.0459 17.2703 20.2857 16.7346 20.2857 16.1429C20.2857 14.9594 19.3263 14 18.1429 14C16.9594 14 16 14.9594 16 16.1429C16 17.3263 16.9594 18.2857 18.1429 18.2857C18.7346 18.2857 19.2703 18.0459 19.6581 17.6581Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "packge search-3": {
        defaultColors: ["#000000"],
        keywords: ["search","magnifier","magnifying-glass","find","lookup","browse","inventory-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.5808 19.0738C14.7652 18.3603 14.25 17.3117 14.25 16.1429C14.25 13.9929 15.9929 12.25 18.1429 12.25C19.1456 12.25 20.0599 12.6292 20.75 13.2519L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.25 16.1429C15.25 14.5452 16.5452 13.25 18.1429 13.25C19.7405 13.25 21.0357 14.5452 21.0357 16.1429C21.0357 16.6691 20.8948 17.1631 20.649 17.5884L21.5303 18.4697C21.8232 18.7626 21.8232 19.2374 21.5303 19.5303C21.2374 19.8232 20.7626 19.8232 20.4697 19.5303L19.5884 18.649C19.1631 18.8948 18.6691 19.0357 18.1429 19.0357C16.5452 19.0357 15.25 17.7405 15.25 16.1429ZM18.1429 14.75C17.3736 14.75 16.75 15.3736 16.75 16.1429C16.75 16.9121 17.3736 17.5357 18.1429 17.5357C18.5277 17.5357 18.8749 17.3806 19.1278 17.1278C19.3806 16.8749 19.5357 16.5277 19.5357 16.1429C19.5357 15.3736 18.9121 14.75 18.1429 14.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge search": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","search","find","inventory","stock","lookup","item-search","product-search","locate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6581 17.6581L21 19M19.6581 17.6581C20.0459 17.2703 20.2857 16.7346 20.2857 16.1429C20.2857 14.9594 19.3263 14 18.1429 14C16.9594 14 16 14.9594 16 16.1429C16 17.3263 16.9594 18.2857 18.1429 18.2857C18.7346 18.2857 19.2703 18.0459 19.6581 17.6581Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.0862 18.9734"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11.4287L9 12.2859"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge secure-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["lock","secure","security","privacy","safe","locked","padlock","access","permission"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="17"
                    y="15.875"
                    width="4.375"
                    height="3.125"
                    rx="0.9375"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M20.4375 15.875V15.25C20.4375 14.5596 19.8779 14 19.1875 14V14C18.4971 14 17.9375 14.5596 17.9375 15.25V15.875"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge secure-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","secure","locked","inventory","stock","delivery","shipment","safe","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="17" y="15.875" width="4.375" height="3.125" rx="0.9375" fill={colors?.[1] || "#000000"} stroke={colors?.[1] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M20.4375 15.875V15.25C20.4375 14.5596 19.8779 14 19.1875 14V14C18.4971 14 17.9375 14.5596 17.9375 15.25V15.875"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "packge secure-3": {
        defaultColors: ["#000000"],
        keywords: ["secure","lock","padlock","security","order-secure","payment-secure","transaction-secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.4879 19.1195C15.4439 18.8187 15.3983 18.5238 15.3589 18.2693C15.2967 17.867 15.25 17.5654 15.25 17.5V17.39C15.25 17.14 15.25 16.86 15.27 16.6C15.3 16.31 15.37 15.89 15.61 15.47C15.77 15.19 15.98 14.94 16.23 14.74C16.47 13.33 17.7 12.25 19.19 12.25C19.7615 12.25 20.2957 12.409 20.75 12.6852L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.75 14.0015C20.3835 13.5434 19.8198 13.25 19.1875 13.25C18.0829 13.25 17.1875 14.1454 17.1875 15.25V15.3016C17.1562 15.3167 17.1249 15.3331 17.0938 15.3511C16.8372 15.4992 16.6242 15.7122 16.4761 15.9688C16.3364 16.2107 16.2892 16.4602 16.2688 16.6855C16.25 16.893 16.25 17.1414 16.25 17.4087V17.4662C16.25 17.7335 16.25 17.982 16.2688 18.1895C16.2706 18.2095 16.2726 18.2297 16.2749 18.25C16.2905 18.3892 16.3181 18.5364 16.3724 18.6843C16.3997 18.7584 16.4336 18.8327 16.4761 18.9063C16.6242 19.1628 16.8372 19.3758 17.0938 19.5239C17.3357 19.6636 17.5852 19.7108 17.8105 19.7312C18.018 19.75 18.2664 19.75 18.5338 19.75H19.8412C20.1085 19.75 20.357 19.75 20.5645 19.7312C20.7898 19.7108 21.0393 19.6636 21.2813 19.5239C21.5378 19.3758 21.7508 19.1628 21.8989 18.9063C22.0386 18.6643 22.0858 18.4148 22.1062 18.1895C22.1251 17.982 22.125 17.7335 22.125 17.4662V17.4088C22.125 17.1415 22.1251 16.893 22.1062 16.6855C22.0858 16.4602 22.0386 16.2107 21.8989 15.9688L21.8948 15.9617C21.7469 15.7083 21.5354 15.4978 21.2813 15.3511C21.2501 15.3331 21.2188 15.3166 21.1875 15.3016V15.25C21.1875 14.7777 21.0238 14.3436 20.75 14.0015ZM19.1875 14.75C19.4205 14.75 19.6162 14.9093 19.6718 15.125H18.7033C18.7588 14.9093 18.9545 14.75 19.1875 14.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge secure": {
        defaultColors: ["#000000"],
        keywords: ["box","secure","package","lock","delivery","protected","shipping","closed","safe","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="17" y="15.875" width="4.375" height="3.125" rx="0.9375" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M20.4375 15.875V15.25C20.4375 14.5596 19.8779 14 19.1875 14V14C18.4971 14 17.9375 14.5596 17.9375 15.25V15.875"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge sent-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","next","forward","send","submit","continue","proceed","go"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 14L21 16L19 18"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 16L16 16"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge sent-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","send","outgoing","delivery","ship","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 14L21 16L19 18" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 16L16 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge sent-3": {
        defaultColors: ["#000000"],
        keywords: ["error","warning","alert","notification","issue","problem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L17.7631 18H16.25C15.2835 18 14.5 17.2165 14.5 16.25C14.5 15.2835 15.2835 14.5 16.25 14.5L17.5179 14.5C17.4422 13.973 17.6071 13.418 18.0126 13.0125C18.696 12.3291 19.8041 12.3292 20.4875 13.0126L20.75 13.2751L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7197 13.7197C19.0126 13.4268 19.4875 13.4268 19.7804 13.7197L21.7803 15.7197C22.0732 16.0126 22.0732 16.4875 21.7803 16.7803L19.7803 18.7803C19.4874 19.0732 19.0126 19.0732 18.7197 18.7803C18.4268 18.4874 18.4268 18.0126 18.7197 17.7197L19.4393 17L16.25 17C15.8358 17 15.5 16.6642 15.5 16.25C15.5 15.8358 15.8358 15.5 16.25 15.5L19.4394 15.5L18.7197 14.7803C18.4268 14.4874 18.4268 14.0126 18.7197 13.7197Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge sent": {
        defaultColors: ["#000000"],
        keywords: ["unknown","unclear","not visible"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 14L21 16L19 18" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 16L16 16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge setting-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["settings","cog","gear","options","configuration","preferences","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 15.5335L17.0175 15.9877"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 17.8301L20.9784 18.2844"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 18.2844L17.0175 17.8301"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 15.9877L20.9784 15.5335"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5995 15.0746C19.6133 15.0746 20.4339 15.8965 20.4339 16.909C20.4339 17.9215 19.6133 18.7434 18.5995 18.7434C17.5858 18.7434 16.7651 17.9227 16.7651 16.909C16.7651 15.8952 17.5858 15.0746 18.5995 15.0746"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.7496M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge setting-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","settings","configure","gear","inventory","stock","product-settings","item-settings","product-configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5994 14.1584V15.0793"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5994 18.7385V19.6594"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 15.5335L17.0175 15.9877"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 17.8301L20.9784 18.2844"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 18.2844L17.0175 17.8301"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 15.9877L20.9784 15.5335"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5995 15.0746C19.6133 15.0746 20.4339 15.8965 20.4339 16.909C20.4339 17.9215 19.6133 18.7434 18.5995 18.7434C17.5858 18.7434 16.7651 17.9227 16.7651 16.909C16.7651 15.8952 17.5858 15.0746 18.5995 15.0746"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge setting-3": {
        defaultColors: ["#000000"],
        keywords: ["settings","tools","options","preferences","setup","configuration","gear","cog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.0405 19.3397C14.8159 19.1927 14.6219 18.9916 14.4799 18.7424C14.0724 18.0274 14.2242 17.1464 14.7966 16.6051C14.7956 16.5703 14.7951 16.5355 14.7951 16.5006C14.7951 16.4656 14.7956 16.4307 14.7966 16.3959C14.2242 15.8545 14.0724 14.9735 14.4799 14.2585C14.8909 13.5372 15.7375 13.2194 16.5003 13.4475C16.5579 13.412 16.6166 13.3781 16.6763 13.3458C16.8588 12.5742 17.5521 12 18.3794 12C19.2069 12 19.9002 12.5743 20.0826 13.346C20.1422 13.3782 20.2008 13.4121 20.2583 13.4476C20.4201 13.3992 20.5856 13.3754 20.75 13.3747L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.3793 13C18.7935 13 19.1293 13.3358 19.1293 13.75V14.0266C19.5134 14.1429 19.8597 14.3462 20.1452 14.6135L20.3821 14.4762C20.7404 14.2684 21.1993 14.3905 21.4071 14.7488C21.6148 15.1072 21.4928 15.5661 21.1344 15.7738L20.8964 15.9119C20.9404 16.101 20.9637 16.2981 20.9637 16.5006C20.9637 16.703 20.9404 16.9 20.8964 17.0891L21.1344 17.2271C21.4928 17.4349 21.6148 17.8938 21.4071 18.2521C21.1993 18.6105 20.7404 18.7325 20.3821 18.5248L20.1453 18.3875C19.8598 18.6549 19.5135 18.8582 19.1293 18.9745V19.2509C19.1293 19.6651 18.7935 20.0009 18.3793 20.0009C17.9651 20.0009 17.6293 19.6651 17.6293 19.2509V18.9745C17.2457 18.8585 16.8998 18.6557 16.6145 18.389L16.3715 18.5275C16.0116 18.7326 15.5536 18.6072 15.3485 18.2473C15.1434 17.8874 15.2689 17.4294 15.6288 17.2243L15.8626 17.091C15.8184 16.9014 15.795 16.7037 15.795 16.5006C15.795 16.2973 15.8184 16.0996 15.8627 15.9099L15.6288 15.7766C15.2689 15.5715 15.1434 15.1135 15.3485 14.7537C15.5536 14.3938 16.0116 14.2683 16.3715 14.4734L16.6147 14.612C16.8999 14.3453 17.2457 14.1426 17.6293 14.0266V13.75C17.6293 13.3358 17.9651 13 18.3793 13ZM18.3139 15.4181C17.9623 15.439 17.6561 15.6269 17.4735 15.9037C17.4659 15.9195 17.4577 15.9352 17.4489 15.9506C17.4376 15.9703 17.4256 15.9894 17.4129 16.0077C17.3375 16.1555 17.295 16.323 17.295 16.5006C17.295 16.6779 17.3374 16.8451 17.4126 16.9928C17.4254 17.0112 17.4375 17.0304 17.4489 17.0503C17.4578 17.066 17.4661 17.0818 17.4738 17.0978C17.6562 17.3741 17.9618 17.5617 18.3128 17.5829C18.3347 17.581 18.3569 17.58 18.3793 17.58C18.4017 17.58 18.4239 17.581 18.4458 17.5829C19.014 17.5486 19.4637 17.0769 19.4637 16.5006C19.4637 15.9238 19.0134 15.4519 18.4447 15.4181C18.4231 15.42 18.4013 15.4209 18.3793 15.4209C18.3572 15.4209 18.3354 15.42 18.3139 15.4181Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge setting": {
        defaultColors: ["#000000"],
        keywords: ["settings","gear","cog","options","configure","preferences","system-settings","adjustments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5994 14.1584V15.0793"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5994 18.7385V19.6594"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 15.5335L17.0175 15.9877"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 17.8301L20.9784 18.2844"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2203 18.2844L17.0175 17.8301"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1949 15.9877L20.9784 15.5335"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5995 15.0746C19.6133 15.0746 20.4339 15.8965 20.4339 16.909C20.4339 17.9215 19.6133 18.7434 18.5995 18.7434C17.5858 18.7434 16.7651 17.9227 16.7651 16.909C16.7651 15.8952 17.5858 15.0746 18.5995 15.0746"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.7496M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge shield-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["shield","security","protection","secure","safe","guarantee","warranty","verified","privacy","trust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16.0889V14.8571C15.8225 14.8571 17.3527 14.4258 18 14C18.6473 14.4258 20.1775 14.8571 21 14.8571V16.0889C21 17.9368 19.7631 19.5518 18 20C16.2369 19.5518 15 17.9368 15 16.0889Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge shield-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","stock","order","damaged","broken","defect","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.7408V15.7143C16.6854 15.7143 17.9606 15.3548 18.5 15C19.0394 15.3548 20.3146 15.7143 21 15.7143V16.7408C21 18.2807 19.9693 19.6265 18.5 20C17.0307 19.6265 16 18.2807 16 16.7408Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge shield-3": {
        defaultColors: ["#000000"],
        keywords: ["security","shield","protection","safe","secure","warranty","insurance","guarantee","reliability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.0023 19.3585C14.2132 18.4462 13.75 17.2572 13.75 15.9908V14.9643C13.75 13.9978 14.5335 13.2143 15.5 13.2143C15.6093 13.2143 15.9215 13.172 16.326 13.057C16.5186 13.0022 16.6878 12.9434 16.8208 12.8895C16.887 12.8626 16.9403 12.8386 16.9804 12.8188C17.0182 12.8002 17.036 12.7893 17.0383 12.788C17.622 12.404 18.3781 12.404 18.9618 12.788C18.9641 12.7894 18.9818 12.8002 19.0196 12.8188C19.0597 12.8386 19.113 12.8626 19.1792 12.8895C19.3121 12.9434 19.4814 13.0022 19.674 13.057C20.0785 13.172 20.3907 13.2143 20.5 13.2143C20.5849 13.2143 20.6684 13.2203 20.75 13.232L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M18.4122 13.6234C18.162 13.4589 17.838 13.4589 17.5878 13.6234C17.4138 13.7379 17.0472 13.8915 16.5996 14.0188C16.1566 14.1448 15.7427 14.2143 15.5 14.2143C15.0858 14.2143 14.75 14.5501 14.75 14.9643V15.9908C14.75 17.8651 16.0051 19.5168 17.8152 19.9769C17.9365 20.0077 18.0635 20.0077 18.1848 19.9769C19.9949 19.5168 21.25 17.8651 21.25 15.9908V14.9643C21.25 14.5501 20.9142 14.2143 20.5 14.2143C20.2573 14.2143 19.8433 14.1448 19.4004 14.0188C18.9528 13.8915 18.5862 13.7379 18.4122 13.6234Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge shield": {
        defaultColors: ["#000000"],
        keywords: ["shield","security","protection","safe","secure","warranty","insurance","guarantee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16.0889V14.8571C15.8225 14.8571 17.3527 14.4258 18 14C18.6473 14.4258 20.1775 14.8571 21 14.8571V16.0889C21 17.9368 19.7631 19.5518 18 20C16.2369 19.5518 15 17.9368 15 16.0889Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.633 19.1964"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge time-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["time","clock","schedule","timer","late","duration","appointment","delay","waiting","pending","postpone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.258 19.3809"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.5 17C21.5 18.6603 20.1603 20 18.5 20C16.8397 20 15.5 18.6603 15.5 17C15.5 15.3397 16.8397 14 18.5 14C20.1603 14 21.5 15.3397 21.5 17Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.1122 17.1832H18.0713V16.1428"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge time-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","favorite","like","saved","inventory","product","item","order","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 17C22 18.6603 20.6603 20 19 20C17.3397 20 16 18.6603 16 17C16 15.3397 17.3397 14 19 14C20.6603 14 22 15.3397 22 17Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.6122 17.1832H18.5713V16.1428"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge time-3": {
        defaultColors: ["#000000"],
        keywords: ["calendar","time","schedule","clock","appointment","date","event","reminder","duration","booking","delivery-time","pickup-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 13.6259C20.2163 13.3844 19.6239 13.25 19 13.25C16.6528 13.25 14.75 15.1528 14.75 17.5C14.75 18.1391 14.891 18.7452 15.1437 19.2889L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 14.25C19.6443 14.25 20.2449 14.4375 20.75 14.7609C21.033 14.9421 21.286 15.1659 21.5 15.4232C21.9683 15.9864 22.25 16.7103 22.25 17.5C22.25 19.2949 20.7949 20.75 19 20.75C18.2103 20.75 17.4864 20.4683 16.9232 20C16.5491 19.6888 16.2459 19.2953 16.0415 18.8471C15.8543 18.4367 15.75 17.9805 15.75 17.5C15.75 15.7051 17.2051 14.25 19 14.25ZM19.9644 16.7138C20.0316 16.7138 20.0968 16.7226 20.1588 16.7392C20.4788 16.8248 20.7144 17.1168 20.7144 17.4638C20.7144 17.878 20.3786 18.2138 19.9644 18.2138H18.75C18.4709 18.2138 18.2274 18.0613 18.0982 17.8351C18.0357 17.7256 18 17.5989 18 17.4638V16.25C18 15.8358 18.3358 15.5 18.75 15.5C19.1642 15.5 19.5 15.8358 19.5 16.25V16.7138H19.9644Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge time": {
        defaultColors: ["#000000"],
        keywords: ["clock","time","timer","waiting","package-time","delivery-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.5 17C21.5 18.6603 20.1603 20 18.5 20C16.8397 20 15.5 18.6603 15.5 17C15.5 15.3397 16.8397 14 18.5 14C20.1603 14 21.5 15.3397 21.5 17Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.1122 17.1832H18.0713V16.1428"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.5M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L13.258 19.3809"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge tracking-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["location","map","pin","gps","address","delivery","shipping","store-location","track-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4879 16.025C18.5776 16.0253 18.65 16.0983 18.6498 16.1879C18.6496 16.2776 18.5768 16.3501 18.4871 16.35C18.3974 16.3499 18.3248 16.2772 18.3248 16.1875C18.3246 16.1442 18.3417 16.1027 18.3724 16.0721C18.403 16.0416 18.4447 16.0246 18.4879 16.025"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2998 16.1875C16.2998 17.2116 17.4173 18.3055 18.0548 18.8465C18.4334 19.1677 18.5434 19.165 18.9192 18.8465C19.5573 18.3055 20.6748 17.2116 20.6748 16.1875C20.6748 14.9794 19.6954 14 18.4873 14C17.2792 14 16.2998 14.9794 16.2998 16.1875Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge tracking-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","shipping","delivery","inventory","stock","product","order","packaging","warehouse","supply chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16.1875C16 17.2116 17.1175 18.3055 17.755 18.8465C18.1336 19.1677 18.2436 19.165 18.6194 18.8465C19.2575 18.3055 20.375 17.2116 20.375 16.1875C20.375 14.9794 19.3956 14 18.1875 14C16.9794 14 16 14.9794 16 16.1875Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1881 16.025C18.2778 16.0253 18.3502 16.0983 18.35 16.1879C18.3498 16.2776 18.277 16.3501 18.1873 16.35C18.0976 16.3499 18.025 16.2772 18.025 16.1875C18.0248 16.1442 18.0419 16.1027 18.0726 16.0721C18.1032 16.0416 18.1449 16.0246 18.1881 16.025"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge tracking-3": {
        defaultColors: ["#000000"],
        keywords: ["package","tracking","delivery","box","shipment","status","logistics","order","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L16.2037 18.7673C16.1343 18.6845 16.0657 18.5993 15.9988 18.5118C15.57 17.9516 15 17.0368 15 15.9375C15 13.7629 16.7629 12 18.9375 12C19.5911 12 20.2075 12.1592 20.75 12.4411L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15.9375C16 14.3152 17.3152 13 18.9375 13C20.5598 13 21.875 14.3152 21.875 15.9375C21.875 16.7013 21.471 17.3959 21.082 17.9041C20.677 18.4331 20.1933 18.8812 19.8544 19.1686C19.7551 19.2527 19.6353 19.3495 19.5051 19.4249C19.3668 19.5051 19.1759 19.5857 18.9403 19.5864C18.7045 19.5871 18.5126 19.5073 18.3729 19.4269C18.2413 19.3512 18.1205 19.2538 18.0197 19.1683C17.6812 18.8811 17.1978 18.433 16.7929 17.904C16.404 17.3959 16 16.7013 16 15.9375ZM18.9349 16.6999C19.3574 16.6999 19.6999 16.3574 19.6999 15.9349C19.6999 15.5124 19.3574 15.1699 18.9349 15.1699C18.5124 15.1699 18.1699 15.5124 18.1699 15.9349C18.1699 16.3574 18.5124 16.6999 18.9349 16.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge tracking": {
        defaultColors: ["#000000"],
        keywords: ["package","tracking","box","delivery","shipping","order-status","track-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4879 16.025C18.5776 16.0253 18.65 16.0983 18.6498 16.1879C18.6496 16.2776 18.5768 16.3501 18.4871 16.35C18.3974 16.3499 18.3248 16.2772 18.3248 16.1875C18.3246 16.1442 18.3417 16.1027 18.3724 16.0721C18.403 16.0416 18.4447 16.0246 18.4879 16.025"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.2998 16.1875C16.2998 17.2116 17.4173 18.3055 18.0548 18.8465C18.4334 19.1677 18.5434 19.165 18.9192 18.8465C19.5573 18.3055 20.6748 17.2116 20.6748 16.1875C20.6748 14.9794 19.6954 14 18.4873 14C17.2792 14 16.2998 14.9794 16.2998 16.1875Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge view-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["view","eye","visibility","details","preview","look","inspect","observe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8 18C19.8838 17.9989 20.8527 17.3585 21.4962 16.3528C21.6346 16.1365 21.6346 15.8635 21.4962 15.6472C20.8527 14.6416 19.8838 14.0011 18.8 14C17.7162 14.0011 16.7473 14.6416 16.1038 15.6472C15.9654 15.8635 15.9654 16.1365 16.1038 16.3528C16.7473 17.3585 17.7162 17.9989 18.8 18Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.7501 16.6999C19.1091 16.6999 19.4001 16.4089 19.4001 16.0499C19.4001 15.6909 19.1091 15.3999 18.7501 15.3999C18.3911 15.3999 18.1001 15.6909 18.1001 16.0499C18.1001 16.4089 18.3911 16.6999 18.7501 16.6999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge view-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","delivery","inventory","stock","item","product","shipment","goods","merchandise","supply","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8008 13.25H18.7992C17.3987 13.2515 16.2167 14.0793 15.4721 15.243C15.176 15.7057 15.176 16.2944 15.4721 16.7571C16.2167 17.9207 17.3987 18.7485 18.7992 18.75H18.8008C20.2013 18.7485 21.3833 17.9207 22.1279 16.7571C22.424 16.2944 22.424 15.7057 22.1279 15.243C21.3833 14.0793 20.2013 13.2515 18.8008 13.25ZM19.4001 16.0499C19.4001 16.4089 19.1091 16.6999 18.7501 16.6999C18.3911 16.6999 18.1001 16.4089 18.1001 16.0499C18.1001 15.6909 18.3911 15.3999 18.7501 15.3999C19.1091 15.3999 19.4001 15.6909 19.4001 16.0499Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "packge view-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","view","inventory","stock","product-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L16.0632 18.8365C15.4897 18.4178 15.0059 17.8839 14.6298 17.2961C14.1234 16.5048 14.1234 15.4953 14.6297 14.704C15.5082 13.3312 16.974 12.2519 18.7982 12.25L18.7992 12.25L18.8018 12.25C19.5096 12.2507 20.1635 12.4137 20.75 12.693L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8008 13.25H18.7992C17.3987 13.2515 16.2167 14.0793 15.4721 15.243C15.176 15.7057 15.176 16.2944 15.4721 16.7571C16.2167 17.9207 17.3987 18.7485 18.7992 18.75H18.8008C20.2013 18.7485 21.3833 17.9207 22.1279 16.7571C22.424 16.2944 22.424 15.7057 22.1279 15.243C21.3833 14.0793 20.2013 13.2515 18.8008 13.25ZM19.4001 16.0499C19.4001 16.4089 19.1091 16.6999 18.7501 16.6999C18.3911 16.6999 18.1001 16.4089 18.1001 16.0499C18.1001 15.6909 18.3911 15.3999 18.7501 15.3999C19.1091 15.3999 19.4001 15.6909 19.4001 16.0499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge view": {
        defaultColors: ["#000000"],
        keywords: ["package","view","box","inventory","details","order","shipment","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8 18C19.8838 17.9989 20.8527 17.3585 21.4962 16.3528C21.6346 16.1365 21.6346 15.8635 21.4962 15.6472C20.8527 14.6416 19.8838 14.0011 18.8 14C17.7162 14.0011 16.7473 14.6416 16.1038 15.6472C15.9654 15.8635 15.9654 16.1365 16.1038 16.3528C16.7473 17.3585 17.7162 17.9989 18.8 18Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.7501 16.6999C19.1091 16.6999 19.4001 16.4089 19.4001 16.0499C19.4001 15.6909 19.1091 15.3999 18.7501 15.3999C18.3911 15.3999 18.1001 15.6909 18.1001 16.0499C18.1001 16.4089 18.3911 16.6999 18.7501 16.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V11.1235M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge warning-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["triangle","warning","alert","issue","problem","notification","caution","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.9351 18.83C20.6467 19.1 20.0978 19.1 19 19.1C17.9022 19.1 17.3533 19.1 17.0649 18.83C16.9185 18.6928 16.8166 18.5148 16.7727 18.319C16.6862 17.9335 16.9645 17.4604 17.5211 16.5142C18.0642 15.5908 18.3358 15.1291 18.709 15.0156C18.8987 14.9579 19.1013 14.9579 19.291 15.0156C19.6642 15.1291 19.9358 15.5908 20.4789 16.5142C21.0355 17.4604 21.3138 17.9335 21.2273 18.319C21.1834 18.5148 21.0815 18.6928 20.9351 18.83Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge warning-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","storage","shipment","products","stock","supplies","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.9351 18.83C20.6467 19.1 20.0978 19.1 19 19.1C17.9022 19.1 17.3533 19.1 17.0649 18.83C16.9185 18.6928 16.8166 18.5148 16.7727 18.319C16.6862 17.9335 16.9645 17.4604 17.5211 16.5142C18.0642 15.5908 18.3358 15.1291 18.709 15.0156C18.8987 14.9579 19.1013 14.9579 19.291 15.0156C19.6642 15.1291 19.9358 15.5908 20.4789 16.5142C21.0355 17.4604 21.3138 17.9335 21.2273 18.319C21.1834 18.5148 21.0815 18.6928 20.9351 18.83Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "packge warning": {
        defaultColors: ["#000000"],
        keywords: ["warning","box","package","alert","error","inventory","problem","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.9351 18.83C20.6467 19.1 20.0978 19.1 19 19.1C17.9022 19.1 17.3533 19.1 17.0649 18.83C16.9185 18.6928 16.8166 18.5148 16.7727 18.319C16.6862 17.9335 16.9645 17.4604 17.5211 16.5142C18.0642 15.5908 18.3358 15.1291 18.709 15.0156C18.8987 14.9579 19.1013 14.9579 19.291 15.0156C19.6642 15.1291 19.9358 15.5908 20.4789 16.5142C21.0355 17.4604 21.3138 17.9335 21.2273 18.319C21.1834 18.5148 21.0815 18.6928 20.9351 18.83Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849V12M4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L14.383 18.8273"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge warning-3": {
        defaultColors: ["#000000"],
        keywords: ["warning","alert","exclamation","error","problem","attention","issue","risk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.33789C11.6351 3.33789 11.3016 3.48199 10.9928 3.61544L10.9167 3.64821L3.70457 6.73914C3.4288 6.85732 3.25 7.12847 3.25 7.42849L3.25 14.8499C3.24997 15.1256 3.24994 15.3866 3.2729 15.6075C3.29853 15.8543 3.35744 16.1137 3.5143 16.3657C3.67116 16.6177 3.87796 16.7852 4.08801 16.9171C4.27615 17.0353 4.51032 17.1504 4.75772 17.2721L10.7859 20.2384L10.871 20.2805C11.2145 20.451 11.5862 20.6354 12 20.6354C12.4138 20.6354 12.7855 20.451 13.1291 20.2805L13.2142 20.2384L15.3311 19.1967C15.2065 18.9696 15.1136 18.7248 15.0568 18.4688C14.8868 17.7188 15.1368 17.0688 15.3068 16.6788C15.4768 16.3088 15.7268 15.8788 15.9668 15.4688L16.0468 15.3288C16.0868 15.2621 16.1268 15.1949 16.1668 15.1277C16.3668 14.7916 16.5668 14.4554 16.7668 14.1888C17.0168 13.8588 17.4568 13.3388 18.1868 13.1188C18.7068 12.9588 19.2668 12.9588 19.7968 13.1288C20.1957 13.249 20.508 13.4558 20.75 13.6742L20.75 7.42849C20.75 7.12847 20.5712 6.85732 20.2954 6.73914L13.0833 3.64821L13.0072 3.61544C12.6984 3.48199 12.3649 3.33789 12 3.33789ZM8.2441 6.42557L5.90394 7.42849L11.5076 9.83006C11.7122 9.91775 11.8269 9.96633 11.9155 9.99638C11.9551 10.0098 11.9774 10.0152 11.989 10.0175L11.9959 10.0187L11.9986 10.019L12 10.0191L12.0014 10.019L12.0043 10.0186L12.011 10.0175C12.0226 10.0152 12.0449 10.0098 12.0845 9.99638C12.1731 9.96633 12.2878 9.91775 12.4924 9.83006L14.2773 9.0651L8.2441 6.42557ZM11.5076 5.02693C11.7122 4.93924 11.8269 4.89066 11.9155 4.86061C11.9551 4.84721 11.9774 4.8418 11.989 4.83952C11.9945 4.83845 11.9986 4.83798 11.9986 4.83798L12 4.83789L12.0014 4.83798C12.0014 4.83798 12.0055 4.83845 12.011 4.83952C12.0226 4.8418 12.0449 4.84721 12.0845 4.86061C12.1731 4.89066 12.2878 4.93924 12.4924 5.02693L18.0961 7.42849L16.1678 8.2549L10.1346 5.61537L11.5076 5.02693ZM5.81083 11.5549C5.974 11.1741 6.41491 10.9978 6.79563 11.1609L8.79563 12.0181C9.17635 12.1812 9.35272 12.6222 9.18955 13.0029C9.02638 13.3836 8.58547 13.56 8.20475 13.3968L6.20475 12.5396C5.82403 12.3765 5.64767 11.9356 5.81083 11.5549Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.4836 14.0757C18.8156 13.9748 19.1701 13.9748 19.5021 14.0757C19.9222 14.2035 20.2041 14.5068 20.4157 14.791C20.6227 15.069 20.8437 15.4449 21.0977 15.8766L21.139 15.9469C21.3996 16.3898 21.6257 16.7742 21.7709 17.0964C21.9187 17.4243 22.0497 17.8256 21.952 18.261C21.8751 18.6036 21.6969 18.9151 21.4406 19.1551C21.1148 19.4601 20.7026 19.5507 20.345 19.5895C19.9936 19.6277 19.5476 19.6277 19.0338 19.6277H18.9519C18.4381 19.6277 17.9921 19.6277 17.6408 19.5895C17.2832 19.5507 16.8709 19.4601 16.5452 19.1551C16.2889 18.9151 16.1107 18.6036 16.0338 18.261C15.936 17.8256 16.067 17.4243 16.2148 17.0964C16.36 16.7742 16.5862 16.3898 16.8467 15.9469C16.8536 15.9352 16.8605 15.9234 16.8675 15.9116C16.8744 15.8999 16.8812 15.8883 16.8881 15.8766C17.142 15.4449 17.3631 15.069 17.5701 14.791C17.7817 14.5068 18.0635 14.2035 18.4836 14.0757Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "packge-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["minus","subtract","decrease","reduce","remove","delete","discount","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11.4287L9 12.2859"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 6L16 9" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "packge-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","inventory","stock","storage","shipping","delivery","warehouse","container","item","product","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 14.8185V7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849V14.8185C4 15.424 4 15.7268 4.15103 15.9694C4.30206 16.212 4.5737 16.3457 5.11699 16.613L11.117 19.5654C11.5505 19.7788 11.7673 19.8854 12 19.8854C12.2327 19.8854 12.4495 19.7788 12.883 19.5654L18.883 16.613C19.4263 16.3457 19.6979 16.212 19.849 15.9694C20 15.7268 20 15.424 20 14.8185Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849M20 7.42849L16.3939 8.97396L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7878 10.5194L20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849L11.2122 10.5194C11.6005 10.6859 11.7947 10.7691 12 10.7691C12.2053 10.7691 12.3995 10.6859 12.7878 10.5194L12.7878 10.5194Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 11.8501L8.5 12.7072"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9.00002L8.34814 5.65234"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "packge-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipment","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9928 3.61544C11.3016 3.48199 11.6351 3.33789 12 3.33789C12.3649 3.33789 12.6984 3.48199 13.0072 3.61544L13.0833 3.64821L20.2954 6.73914C20.5712 6.85732 20.75 7.12847 20.75 7.42849L20.75 14.8499C20.75 15.1256 20.7501 15.3866 20.7271 15.6075C20.7015 15.8543 20.6426 16.1137 20.4857 16.3657C20.3288 16.6177 20.122 16.7852 19.912 16.9171C19.7238 17.0353 19.4897 17.1505 19.2423 17.2722L13.2142 20.2384L13.1291 20.2805C12.7855 20.451 12.4138 20.6354 12 20.6354C11.5862 20.6354 11.2145 20.451 10.871 20.2805L10.7859 20.2384L4.75772 17.2721C4.51032 17.1504 4.27615 17.0353 4.08801 16.9171C3.87796 16.7852 3.67116 16.6177 3.5143 16.3657C3.35744 16.1137 3.29853 15.8543 3.2729 15.6075C3.24994 15.3866 3.24997 15.1256 3.25 14.8499L3.25 7.42849C3.25 7.12847 3.4288 6.85732 3.70457 6.73914L10.9167 3.64821L10.9928 3.61544ZM5.90394 7.42849L8.2441 6.42557L14.2773 9.0651L12.4924 9.83006C12.2878 9.91775 12.1731 9.96633 12.0845 9.99638C12.0449 10.0098 12.0226 10.0152 12.011 10.0175L12.0043 10.0186L12.0014 10.019L12 10.0191L11.9986 10.019L11.9959 10.0187L11.989 10.0175C11.9774 10.0152 11.9551 10.0098 11.9155 9.99638C11.8269 9.96633 11.7122 9.91775 11.5076 9.83006L5.90394 7.42849ZM11.9155 4.86061C11.8269 4.89066 11.7122 4.93924 11.5076 5.02693L10.1346 5.61537L16.1678 8.2549L18.0961 7.42849L12.4924 5.02693C12.2878 4.93924 12.1731 4.89066 12.0845 4.86061C12.0449 4.84721 12.0226 4.8418 12.011 4.83952C12.0055 4.83845 12.0014 4.83798 12.0014 4.83798L12 4.83789L11.9986 4.83798C11.9986 4.83798 11.9945 4.83845 11.989 4.83952C11.9774 4.8418 11.9551 4.84721 11.9155 4.86061ZM6.79563 11.1609C6.41491 10.9978 5.974 11.1741 5.81083 11.5549C5.64767 11.9356 5.82403 12.3765 6.20475 12.5396L8.20475 13.3968C8.58547 13.56 9.02638 13.3836 9.18955 13.0029C9.35272 12.6222 9.17635 12.1812 8.79563 12.0181L6.79563 11.1609Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    packge: {
        defaultColors: ["#000000"],
        keywords: ["box","package","delivery","shipment","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M20 7.42849V14.8185C20 15.424 20 15.7268 19.849 15.9694C19.6979 16.212 19.4263 16.3457 18.883 16.613L12.883 19.5654C12.4495 19.7788 12.2327 19.8854 12 19.8854C11.7673 19.8854 11.5505 19.7788 11.117 19.5654L5.11699 16.613C4.5737 16.3457 4.30206 16.212 4.15103 15.9694C4 15.7268 4 15.424 4 14.8185V7.42849M20 7.42849L12.7878 10.5194C12.3995 10.6859 12.2053 10.7691 12 10.7691C11.7947 10.7691 11.6005 10.6859 11.2122 10.5194L4 7.42849M20 7.42849L12.7878 4.33757C12.3995 4.17112 12.2053 4.08789 12 4.08789C11.7947 4.08789 11.6005 4.17112 11.2122 4.33757L4 7.42849"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M7 11.4287L9 12.2859" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 6L16 9" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "pageview-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","lookup","query","magnify","magnifier","inventory-search","item-search","customer-search","transaction-search","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213ZM14.1213 14.1213L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pageview-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","question","faq","help","support","query","customer-support","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213ZM14.1213 14.1213L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    pageview: {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","question","faq","help","support","query","customer-support","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213ZM14.1213 14.1213L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pallet-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["pallet","inventory","stock","warehouse","shelves","storage","products","goods","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V20"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V20"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15V20"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 15H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "pallet-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["pallet","storage","inventory","warehouse","stack","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M3 15H21"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 20H21"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pallet-3": {
        defaultColors: ["#000000"],
        keywords: ["pallet","storage","inventory","warehouse","stock","supply","delivery","shipment","packaging","load","transport","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 15C2 14.4477 2.44772 14 3 14H21C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H20V19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H4V16H3C2.44772 16 2 15.5523 2 15ZM6 16V19H11V16H6ZM13 16V19H18V16H13Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "pallet-box-move-right-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","next","proceed","continue","forward","submit","move-right","advance","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10.5L20 8.49998L18 6.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 8.5L15 8.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pallet-box-move-right-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["conveyor","belt","assembly","line","manufacturing","automation","production","processing","delivery","transfer","material-handling","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="2"
                    y="15"
                    width="20"
                    height="5"
                    rx="2.5"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M5 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M6.35304 4.25C5.82769 4.24996 5.36051 4.24992 4.98334 4.30063C4.5734 4.35574 4.15946 4.48283 3.82115 4.82115C3.48283 5.15946 3.35574 5.5734 3.30063 5.98334C3.24992 6.36051 3.24996 6.82769 3.25 7.35304V9.64697C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8406 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.7501 6.35301 12.75H9.64697C10.1723 12.7501 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8406 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64697V7.35305C12.7501 6.82769 12.7501 6.36051 12.6994 5.98334C12.6443 5.5734 12.5172 5.15946 12.1789 4.82115C11.8406 4.48283 11.4266 4.35574 11.0167 4.30063C10.6395 4.24992 10.1723 4.24996 9.64697 4.25H6.35304Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9.75003 4.25H6.25003L6.25001 6.32833C6.24992 6.46735 6.2498 6.63721 6.26953 6.78398C6.29352 6.96246 6.35838 7.21398 6.57221 7.42782C6.78604 7.64165 7.03757 7.7065 7.21605 7.7305C7.36281 7.75023 7.53267 7.75011 7.67169 7.75001H8.32836C8.46738 7.75011 8.63724 7.75023 8.78401 7.7305C8.96248 7.7065 9.21401 7.64165 9.42785 7.42782C9.64168 7.21398 9.70653 6.96246 9.73053 6.78398C9.75026 6.63721 9.75014 6.46735 9.75004 6.32834L9.75003 4.25Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M18 10.5L20 8.49998L18 6.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 8.5L15 8.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "pageview-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","item-search","product-search","customer-search","transaction-search","inventory-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 12.5526 13.7772 13.0512 13.4142 13.4142C13.0512 13.7772 12.5526 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4H9.92943C8.57536 3.99997 7.45868 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45868 2.99997 9.57529 3 10.9294V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92936 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V10.9294C21 9.57534 21.0001 8.45869 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4246 3.99997 14.0706 4ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C12.7414 16 13.4364 15.7977 14.0318 15.446L14.7929 16.2071C15.1834 16.5976 15.8166 16.5976 16.2071 16.2071C16.5976 15.8166 16.5976 15.1834 16.2071 14.7929L15.446 14.0318C15.7977 13.4364 16 12.7414 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pallet-box-move-right-3": {
        defaultColors: ["#000000"],
        keywords: ["pallet","box","move","right","shipping","inventory","stock","delivery","outbound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25 17.5C1.25 15.7051 2.70507 14.25 4.5 14.25H19.5C21.2949 14.25 22.75 15.7051 22.75 17.5C22.75 19.2949 21.2949 20.75 19.5 20.75H4.5C2.70507 20.75 1.25 19.2949 1.25 17.5ZM5 16.75C5.41421 16.75 5.75 17.0858 5.75 17.5V17.52C5.75 17.9342 5.41421 18.27 5 18.27C4.58579 18.27 4.25 17.9342 4.25 17.52V17.5C4.25 17.0858 4.58579 16.75 5 16.75ZM12 16.75C12.4142 16.75 12.75 17.0858 12.75 17.5V17.52C12.75 17.9342 12.4142 18.27 12 18.27C11.5858 18.27 11.25 17.9342 11.25 17.52V17.5C11.25 17.0858 11.5858 16.75 12 16.75ZM19.75 17.5C19.75 17.0858 19.4142 16.75 19 16.75C18.5858 16.75 18.25 17.0858 18.25 17.5V17.52C18.25 17.9342 18.5858 18.27 19 18.27C19.4142 18.27 19.75 17.9342 19.75 17.52V17.5Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M6.25003 4.25C5.76656 4.25016 5.33567 4.25325 4.98334 4.30062C4.5734 4.35573 4.15946 4.48283 3.82115 4.82114C3.48283 5.15945 3.35574 5.57339 3.30063 5.98334C3.24992 6.3605 3.24996 6.82768 3.25 7.35303V9.64696C3.24996 10.1723 3.24992 10.6395 3.30063 11.0167C3.35574 11.4266 3.48283 11.8405 3.82115 12.1789C4.15946 12.5172 4.5734 12.6443 4.98334 12.6994C5.3605 12.7501 5.82767 12.75 6.35301 12.75H9.64697C10.1723 12.75 10.6395 12.7501 11.0167 12.6994C11.4266 12.6443 11.8406 12.5172 12.1789 12.1789C12.5172 11.8405 12.6443 11.4266 12.6994 11.0167C12.7501 10.6395 12.7501 10.1723 12.75 9.64696V7.35304C12.7501 6.82769 12.7501 6.3605 12.6994 5.98334C12.6443 5.57339 12.5172 5.15945 12.1789 4.82114C11.8406 4.48283 11.4266 4.35573 11.0167 4.30062C10.6643 4.25325 10.2335 4.25016 9.75003 4.25L9.75004 6.32833C9.75014 6.46734 9.75026 6.63721 9.73053 6.78397C9.70653 6.96245 9.64168 7.21398 9.42785 7.42781C9.21401 7.64164 8.96248 7.70649 8.78401 7.73049C8.63724 7.75022 8.46738 7.7501 8.32836 7.75001H7.67169C7.53267 7.7501 7.36281 7.75022 7.21605 7.73049C7.03757 7.70649 6.78604 7.64164 6.57221 7.42781C6.35838 7.21398 6.29352 6.96245 6.26953 6.78397C6.2498 6.6372 6.24992 6.46734 6.25001 6.32833L6.25003 4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.2929 5.7929C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289L20.7071 7.79287C21.0976 8.1834 21.0976 8.81656 20.7071 9.20708L18.7071 11.2071C18.3166 11.5976 17.6835 11.5976 17.2929 11.2071C16.9024 10.8166 16.9024 10.1834 17.2929 9.7929L17.5858 9.49999L15 9.5C14.4477 9.5 14 9.05229 14 8.5C14 7.94772 14.4477 7.5 15 7.5L17.5858 7.49999L17.2929 7.20711C16.9024 6.81659 16.9024 6.18342 17.2929 5.7929Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "pallet-box-move-right": {
        defaultColors: ["#000000"],
        keywords: ["box","pallet","move","inventory","stock","shipping","receiving","warehouse","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="15" width="20" height="5" rx="2.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path d="M5 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5V17.52" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4 9.6V7.4C4 6.26863 4 5.70294 4.35147 5.35147C4.70294 5 5.26863 5 6.4 5H9.6C10.7314 5 11.2971 5 11.6485 5.35147C12 5.70294 12 6.26863 12 7.4V9.6C12 10.7314 12 11.2971 11.6485 11.6485C11.2971 12 10.7314 12 9.6 12H6.4C5.26863 12 4.70294 12 4.35147 11.6485C4 11.2971 4 10.7314 4 9.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 7H8.3C8.62998 7 8.79497 7 8.89749 6.89749C9 6.79497 9 6.62998 9 6.3V5.7C9 5.37002 9 5.20503 8.89749 5.10251C8.79497 5 8.62998 5 8.3 5H7.7C7.37002 5 7.20503 5 7.10251 5.10251C7 5.20503 7 5.37002 7 5.7V6.3C7 6.62998 7 6.79497 7.10251 6.89749C7.20503 7 7.37002 7 7.7 7H8Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10.5L20 8.49998L18 6.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 8.5L15 8.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    pallet: {
        defaultColors: ["#000000"],
        keywords: ["box","pallet","move","inventory","stock","shipping","receiving","warehouse","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 20H21" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 15V20" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "paper-page-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["document","page","list","details","order-details","transaction-details","report","summary","invoice","receipt","notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "paper-page-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","details","report","description","info","paper","page","document","text","receipt","invoice","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "paper-page-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","details","settings","document","receipt","invoice","report","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92944V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57533 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55229 7.44772 10 8 10H11C11.5523 10 12 9.55229 12 9C12 8.44772 11.5523 8 11 8H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "paper-page": {
        defaultColors: ["#3D4C66"],
        keywords: ["report","document","page","list","details","transaction-details","order-details","invoice","receipt","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "paperclip-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["attachment","paperclip","attach","link","add-note","note","receipt","add-receipt","transaction-details","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5801 8.41988L12.358 11.642C11.3694 12.6306 11.3923 14.2564 12.4092 15.2733C13.426 16.2901 15.0518 16.313 16.0404 15.3244L18.5465 12.8183C20.5238 10.8411 20.478 7.58952 18.4442 5.55578C16.4105 3.52204 13.1589 3.47624 11.1817 5.45349L5.45349 11.1817C3.47624 13.1589 3.52204 16.4105 5.55578 18.4442C7.58952 20.478 10.8411 20.5238 12.8183 18.5465"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "paperclip-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","paperclip","link","attach","note","receipt","add-note","add-receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5801 8.41988L12.358 11.642C11.3694 12.6306 11.3923 14.2564 12.4092 15.2733C13.426 16.2901 15.0518 16.313 16.0404 15.3244L18.5465 12.8183C20.5238 10.8411 20.478 7.58952 18.4442 5.55578C16.4105 3.52204 13.1589 3.47624 11.1817 5.45349L5.45349 11.1817C3.47624 13.1589 3.52204 16.4105 5.55578 18.4442C7.58952 20.478 10.8411 20.5238 12.8183 18.5465"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "paperclip-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","paperclip","link","attach","reference","additional-info","file","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4746 4.74644C12.861 2.36003 16.746 2.44338 19.1513 4.84873C21.5567 7.25409 21.64 11.1391 19.2536 13.5255L16.7475 16.0316C15.3497 17.4294 13.0905 17.3689 11.7021 15.9804C10.3136 14.5919 10.2531 12.3327 11.6509 10.9349L14.873 7.71283C15.2635 7.32231 15.8967 7.32231 16.2872 7.71283C16.6778 8.10336 16.6778 8.73652 16.2872 9.12705L13.0651 12.3492C12.4857 12.9286 12.471 13.921 13.1163 14.5662C13.7615 15.2115 14.7539 15.1968 15.3333 14.6174L17.8394 12.1113C19.4075 10.5432 19.3992 7.92507 17.7371 6.26295C16.075 4.60082 13.4569 4.59258 11.8888 6.16066L6.1606 11.8889C4.59252 13.4569 4.60076 16.0751 6.26289 17.7372C7.92501 19.3993 10.5431 19.4075 12.1112 17.8395C12.5017 17.4489 13.1349 17.4489 13.5254 17.8395C13.9159 18.23 13.9159 18.8632 13.5254 19.2537C11.139 21.6401 7.25403 21.5567 4.84867 19.1514C2.44332 16.746 2.35997 12.8611 4.74638 10.4746L10.4746 4.74644Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "paperclip-vertical-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","link","paperclip","connect","attach","file"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L7 14C7 16.7614 9.23858 19 12 19V19C14.7614 19 17 16.7614 17 14L17 8.9375"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L17 8.5C17 6.567 15.433 5 13.5 5V5C11.567 5 10 6.567 10 8.5L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 11.3333L10 14C10 15.1046 10.8954 16 12 16V16C13.1046 16 14 15.1046 14 14L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "paperclip-vertical-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["attachment","paperclip","link","connect","attach","note","details","additional-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L7 14C7 16.7614 9.23858 19 12 19V19C14.7614 19 17 16.7614 17 14L17 8.9375"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L17 8.5C17 6.567 15.433 5 13.5 5V5C11.567 5 10 6.567 10 8.5L10 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 11.3333L10 14C10 15.1046 10.8954 16 12 16V16C13.1046 16 14 15.1046 14 14L14 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "paperclip-vertical-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["attachment","link","paperclip","connect","file","receipt","transaction-history","details","order-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_89742)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.5 4C11.01 4 9 6.01 9 8.5V14C9 15.66 10.34 17 12 17C13.66 17 15 15.66 15 14V9C15 8.45 14.55 8 14 8C13.45 8 13 8.45 13 9V14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14V8.5C11 7.12 12.12 6 13.5 6C14.88 6 16 7.12 16 8.5V14C16 16.21 14.21 18 12 18C9.79 18 8 16.21 8 14V5C8 4.45 7.55 4 7 4C6.45 4 6 4.45 6 5V14C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14V8.5C18 6.01 15.99 4 13.5 4Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_89742">
                        <rect width="12" height="16" fill={colors?.[1] || "#FFFFFF"} transform="translate(6 4)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "paperclip-vertical": {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","paperclip","attach","note","file","connect","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L7 14C7 16.7614 9.23858 19 12 19V19C14.7614 19 17 16.7614 17 14L17 8.9375"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12L17 8.5C17 6.567 15.433 5 13.5 5V5C11.567 5 10 6.567 10 8.5L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 11.3333L10 14C10 15.1046 10.8954 16 12 16V16C13.1046 16 14 15.1046 14 14L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    paperclip: {
        defaultColors: ["#3D4C66"],
        keywords: ["attachment","paperclip","attach","note","file","connect","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5801 8.41988L12.358 11.642C11.3694 12.6306 11.3923 14.2564 12.4092 15.2733C13.426 16.2901 15.0518 16.313 16.0404 15.3244L18.5465 12.8183C20.5238 10.8411 20.478 7.58952 18.4442 5.55578C16.4105 3.52204 13.1589 3.47624 11.1817 5.45349L5.45349 11.1817C3.47624 13.1589 3.52204 16.4105 5.55578 18.4442C7.58952 20.478 10.8411 20.5238 12.8183 18.5465"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "paragraph-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["paragraph","formatting","text","alignment","notes","description","receipt-notes","add-notes","comments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 13H10C7.79086 13 6 11.2091 6 9V9C6 6.79086 7.79086 5 10 5H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19V5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19V5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "paragraph-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["paragraph","text","notes","format","alignment","settings","receipt-notes","order-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 13H10C7.79086 13 6 11.2091 6 9V9C6 6.79086 7.79086 5 10 5H18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "paragraph-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["paragraph","text","notes","description","info","content","format","document"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19V14H10C7.23858 14 5 11.7614 5 9C5 6.23858 7.23858 4 10 4H18C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6H17V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V6H14V19C14 19.5523 13.5523 20 13 20C12.4477 20 12 19.5523 12 19ZM10 6C8.34315 6 7 7.34315 7 9C7 10.6569 8.34315 12 10 12H12V6H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "parentheses-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["parentheses","grouping","options","settings","configuration","open","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C6.79723 5.68679 6 8.63946 6 12C6 15.3605 6.79723 18.3132 8 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4C17.2028 5.68679 18 8.63946 18 12C18 15.3605 17.2028 18.3132 16 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    paragraph: {
        defaultColors: ["#3D4C66"],
        keywords: ["parentheses","grouping","options","settings","configuration","open","close"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 13H10C7.79086 13 6 11.2091 6 9V9C6 6.79086 7.79086 5 10 5H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "parentheses-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["parentheses","brackets","grouping","options","modifiers","notes","comments","quantity","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C6.79723 5.68679 6 8.63946 6 12C6 15.3605 6.79723 18.3132 8 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4C17.2028 5.68679 18 8.63946 18 12C18 15.3605 17.2028 18.3132 16 20"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "parentheses-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["parentheses","syntax","function","grouping","options","configuration","settings","calculator","formula"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.58057 3.18587C9.03025 3.50651 9.13485 4.13098 8.81421 4.58065C7.77623 6.03634 7 8.75641 7 12.0001C7 15.2437 7.77623 17.9638 8.81421 19.4195C9.13485 19.8692 9.03025 20.4936 8.58057 20.8143C8.1309 21.1349 7.50643 21.0303 7.18579 20.5807C5.81823 18.6628 5 15.4775 5 12.0001C5 8.52266 5.81823 5.3374 7.18579 3.41951C7.50643 2.96983 8.1309 2.86523 8.58057 3.18587ZM15.4194 3.18587C15.8691 2.86523 16.4936 2.96983 16.8142 3.41951C18.1818 5.3374 19 8.52266 19 12.0001C19 15.4775 18.1818 18.6628 16.8142 20.5807C16.4936 21.0303 15.8691 21.1349 15.4194 20.8143C14.9698 20.4936 14.8652 19.8692 15.1858 19.4195C16.2238 17.9638 17 15.2437 17 12.0001C17 8.75641 16.2238 6.03634 15.1858 4.58065C14.8652 4.13098 14.9698 3.50651 15.4194 3.18587Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    parentheses: {
        defaultColors: ["#3D4C66"],
        keywords: ["parentheses","syntax","function","grouping","options","configuration","settings","calculator","formula"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C6.79723 5.68679 6 8.63946 6 12C6 15.3605 6.79723 18.3132 8 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4C17.2028 5.68679 18 8.63946 18 12C18 15.3605 17.2028 18.3132 16 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "parking-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["parking","P","available","parking-available","parking-sign","service","location","spot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "parking-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["parking","P","permit","validation","authorization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "parking-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["parking","promo","promotion","coupon","payment","pending","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 7C9.44772 7 9 7.44772 9 8V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V13H12C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7H10ZM12 11H11V9H12C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    parking: {
        defaultColors: ["#3D4C66"],
        keywords: ["parking","promo","promotion","coupon","payment","pending","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "parking_cancel-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["parking","no-parking","cancel","disabled","restriction","unavailable","blocked","error","not-allowed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M6 6L18 18" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "parking_cancel-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["restricted","unavailable","not-allowed","cancel","remove","block","disable","reject","refuse","reservation-cancel","parking-cancel","no-parking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path d="M6 6L18 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    parking_cancel: {
        defaultColors: ["#3D4C66"],
        keywords: ["restricted","unavailable","not-allowed","cancel","remove","block","disable","reject","refuse","reservation-cancel","parking-cancel","no-parking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M6 6L18 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "parking_cancel-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["no","prohibited","not-allowed","cancel","restriction","disable","deactivate","block"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.169 5.14415C5.81189 5.44818 5.47882 5.77962 5.17306 6.13521C5.0432 6.28624 4.91826 6.44163 4.79849 6.60113L6.24381 8.01565L9 10.7131L11.3367 13L16.1073 17.669L17.5526 19.0835C17.7361 18.9395 17.9138 18.7885 18.0854 18.6309C18.4058 18.3367 18.7049 18.0195 18.9799 17.6821C20.2428 16.1326 21 14.1547 21 12C21 7.02944 16.9706 3 12 3C9.77559 3 7.73966 3.80698 6.169 5.14415ZM7.60604 6.55056L9.00331 7.91805C9.04499 7.4041 9.47531 7 10 7H12C13.6569 7 15 8.34315 15 10C15 11.0368 14.4741 11.9507 13.6744 12.4896L17.5429 16.2756C18.4565 15.093 19 13.61 19 12C19 8.13401 15.866 5 12 5C10.3358 5 8.80733 5.58072 7.60604 6.55056ZM12.1421 10.99C12.6271 10.921 13 10.504 13 10C13 9.44772 12.5523 9 12 9H11V9.87219L12.1421 10.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.0312 7.81299C3.37269 9.0637 3 10.4883 3 12C3 16.9706 7.02944 21 12 21C13.617 21 15.1344 20.5736 16.4458 19.8271L14.9293 18.3595C14.0381 18.7706 13.0459 19 12 19C8.13401 19 5 15.866 5 12C5 11.0356 5.19504 10.1167 5.54782 9.28067L4.0312 7.81299Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 17C10.5523 17 11 16.5523 11 16V14.5569L9 12.6215V16C9 16.5523 9.44772 17 10 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Passport-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["passport","id","identification","travel","customer","profile","international"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4L11 4C8.17157 4 6.75736 4 5.87868 4.87868C5 5.75736 5 7.17157 5 10L5 14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20L13 20C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14L19 10C19 7.17157 19 5.75736 18.1213 4.87868C17.2426 4 15.8284 4 13 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 17L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7C10.77 7 9.66969 7.55516 8.93594 8.42857C8.35182 9.12387 8 10.0208 8 11C8 11.9792 8.35182 12.8761 8.93594 13.5714C9.66969 14.4448 10.77 15 12 15M12 7C13.23 7 14.3303 7.55516 15.0641 8.42857C15.6482 9.12387 16 10.0208 16 11C16 11.9792 15.6482 12.8761 15.0641 13.5714C14.3303 14.4448 13.23 15 12 15M12 7C10.9519 7.95789 10.2857 9.39431 10.2857 11C10.2857 12.6057 10.9519 14.0421 12 15M12 7C13.0481 7.95789 13.7143 9.39431 13.7143 11C13.7143 12.6057 13.0481 14.0421 12 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Passport-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["passport","travel","international","customer","identity","loyalty-program","location","globe","world"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4L11 4C8.17157 4 6.75736 4 5.87868 4.87868C5 5.75736 5 7.17157 5 10L5 14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20L13 20C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14L19 10C19 7.17157 19 5.75736 18.1213 4.87868C17.2426 4 15.8284 4 13 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 17L14 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7C10.77 7 9.66969 7.55516 8.93594 8.42857C8.35182 9.12387 8 10.0208 8 11C8 11.9792 8.35182 12.8761 8.93594 13.5714C9.66969 14.4448 10.77 15 12 15M12 7C13.23 7 14.3303 7.55516 15.0641 8.42857C15.6482 9.12387 16 10.0208 16 11C16 11.9792 15.6482 12.8761 15.0641 13.5714C14.3303 14.4448 13.23 15 12 15M12 7C10.9519 7.95789 10.2857 9.39431 10.2857 11C10.2857 12.6057 10.9519 14.0421 12 15M12 7C13.0481 7.95789 13.7143 9.39431 13.7143 11C13.7143 12.6057 13.0481 14.0421 12 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Passport-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["passport","id","scan","verify","identification","document","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2857 10.5C11.2857 9.57354 11.5536 8.72541 12 8.03713C12.4464 8.72541 12.7143 9.57354 12.7143 10.5C12.7143 11.4265 12.4464 12.2746 12 12.9629C11.5536 12.2746 11.2857 11.4265 11.2857 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.28571 10.5C9.28571 11.068 9.35683 11.6198 9.49068 12.145C9.18016 11.6727 9 11.1083 9 10.5C9 9.89171 9.18016 9.32728 9.49068 8.85497C9.35683 9.38024 9.28571 9.93205 9.28571 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7143 10.5C14.7143 11.068 14.6432 11.6198 14.5093 12.145C14.8198 11.6727 15 11.1083 15 10.5C15 9.89171 14.8198 9.32728 14.5093 8.85497C14.6432 9.38024 14.7143 9.93205 14.7143 10.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 21H10.9294C9.57535 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V9.92942C3.99997 8.57532 3.99994 7.45869 4.11876 6.57494C4.2435 5.64711 4.51547 4.82768 5.17158 4.17158C5.82769 3.51547 6.64711 3.2435 7.57494 3.11876C8.45869 2.99994 9.57533 2.99997 10.9294 3H13.0706C14.4247 2.99997 15.5413 2.99994 16.4251 3.11875C17.3529 3.2435 18.1723 3.51546 18.8284 4.17157C19.4845 4.82768 19.7565 5.64711 19.8813 6.57494C20.0001 7.45868 20 8.57534 20 9.92943V14.0706C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21ZM12 5.5C10.4622 5.5 9.0859 6.19543 8.17027 7.28533C7.44045 8.15406 7 9.2769 7 10.5C7 11.7231 7.44045 12.8459 8.17027 13.7147C9.0859 14.8046 10.4622 15.5 12 15.5C13.5378 15.5 14.9141 14.8046 15.8297 13.7147C16.5596 12.8459 17 11.7231 17 10.5C17 9.2769 16.5596 8.15406 15.8297 7.28533C14.9141 6.19543 13.5378 5.5 12 5.5ZM14 19.0001C14.5523 19.0001 15 18.5524 15 18.0001C15 17.4478 14.5523 17.0001 14 17.0001H10C9.44771 17.0001 9 17.4478 9 18.0001C9 18.5524 9.44771 19.0001 10 19.0001H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pause-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pause","stop","hold","suspend","transaction","payment","process","temporary","order-hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14V10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V14C11 14.9428 11 15.4142 10.7071 15.7071C10.4142 16 9.94281 16 9 16C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 14V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V14C17 14.9428 17 15.4142 16.7071 15.7071C16.4142 16 15.9428 16 15 16C14.0572 16 13.5858 16 13.2929 15.7071C13 15.4142 13 14.9428 13 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Passport: {
        defaultColors: ["#3D4C66"],
        keywords: ["pause","stop","hold","suspend","transaction","payment","process","temporary","order-hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4L11 4C8.17157 4 6.75736 4 5.87868 4.87868C5 5.75736 5 7.17157 5 10L5 14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20L13 20C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14L19 10C19 7.17157 19 5.75736 18.1213 4.87868C17.2426 4 15.8284 4 13 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 17L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7C10.77 7 9.66969 7.55516 8.93594 8.42857C8.35182 9.12387 8 10.0208 8 11C8 11.9792 8.35182 12.8761 8.93594 13.5714C9.66969 14.4448 10.77 15 12 15M12 7C13.23 7 14.3303 7.55516 15.0641 8.42857C15.6482 9.12387 16 10.0208 16 11C16 11.9792 15.6482 12.8761 15.0641 13.5714C14.3303 14.4448 13.23 15 12 15M12 7C10.9519 7.95789 10.2857 9.39431 10.2857 11C10.2857 12.6057 10.9519 14.0421 12 15M12 7C13.0481 7.95789 13.7143 9.39431 13.7143 11C13.7143 12.6057 13.0481 14.0421 12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pause-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["pause","hold","suspend","stop","interruption","break","payment-pause","processing-pause"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14V10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V14C11 14.9428 11 15.4142 10.7071 15.7071C10.4142 16 9.94281 16 9 16C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 14V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V14C17 14.9428 17 15.4142 16.7071 15.7071C16.4142 16 15.9428 16 15 16C14.0572 16 13.5858 16 13.2929 15.7071C13 15.4142 13 14.9428 13 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pause-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pause","stop","hold","interruption","wait","suspend","break","on-hold","paused-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94561 7.00001H8.05442C8.47849 6.99992 8.89062 6.99984 9.23053 7.04554C9.61374 7.09706 10.051 7.22259 10.4142 7.5858C10.7774 7.94902 10.903 8.38629 10.9545 8.7695C11.0002 9.10941 11.0001 9.52153 11 9.94559V14.0544C11.0001 14.4785 11.0002 14.8906 10.9545 15.2305C10.903 15.6137 10.7774 16.051 10.4142 16.4142C10.051 16.7774 9.61374 16.903 9.23053 16.9545C8.89062 17.0002 8.4785 17.0001 8.05444 17H7.9456C7.52154 17.0001 7.10941 17.0002 6.7695 16.9545C6.38629 16.903 5.94902 16.7774 5.5858 16.4142C5.22259 16.051 5.09706 15.6137 5.04554 15.2305C4.99984 14.8906 4.99992 14.4785 5.00001 14.0544V9.94561C4.99992 9.52154 4.99984 9.10941 5.04554 8.76949C5.09706 8.38629 5.22259 7.94902 5.5858 7.5858C5.94902 7.22259 6.38629 7.09706 6.76949 7.04554C7.10941 6.99984 7.52154 6.99992 7.94561 7.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 7.00002C15.5216 6.99994 15.1094 6.99986 14.7695 7.04556C14.3863 7.09708 13.949 7.2226 13.5858 7.58582C13.2226 7.94903 13.0971 8.38631 13.0456 8.76951C12.9999 9.10942 12.9999 9.52155 13 9.94562V14.0544C12.9999 14.4785 12.9999 14.8906 13.0456 15.2305C13.0971 15.6138 13.2226 16.051 13.5858 16.4142C13.949 16.7775 14.3863 16.903 14.7695 16.9545C15.1094 17.0002 15.5215 17.0001 15.9456 17H16.0544C16.4785 17.0001 16.8906 17.0002 17.2305 16.9545C17.6138 16.903 18.051 16.7775 18.4142 16.4142C18.7775 16.051 18.903 15.6137 18.9545 15.2305C19.0002 14.8906 19.0001 14.4785 19 14.0545V9.94562C19.0001 9.52155 19.0002 9.10942 18.9545 8.76951C18.903 8.38631 18.7775 7.94903 18.4142 7.58581C18.051 7.2226 17.6138 7.09708 17.2305 7.04556C16.8906 6.99986 16.4785 6.99994 16.0544 7.00002H15.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    pause: {
        defaultColors: ["#3D4C66"],
        keywords: ["pause","stop","hold","interruption","wait","suspend","break","on-hold","paused-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14V10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V14C11 14.9428 11 15.4142 10.7071 15.7071C10.4142 16 9.94281 16 9 16C8.05719 16 7.58579 16 7.29289 15.7071C7 15.4142 7 14.9428 7 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 14V10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V14C17 14.9428 17 15.4142 16.7071 15.7071C16.4142 16 15.9428 16 15 16C14.0572 16 13.5858 16 13.2929 15.7071C13 15.4142 13 14.9428 13 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pen-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","modify","change","update","write","input","create","adjustment","amend","revise","pencil","pen","signature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L5 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.8663 10.5L10.6039 15.7625C10.4601 15.904 10.2645 15.9815 10.0595 15.9782L7.79346 16C7.36211 15.9931 7.00687 15.6379 7 15.2065L7.02177 12.9405C7.0185 12.7355 7.09601 12.5399 7.23755 12.3961L12.5 7.13365M15.8663 10.5L17.3366 9.02975C17.7617 8.598 18 8.01639 18 7.41047C18 6.13583 16.8642 5 15.5895 5C14.9836 5 14.402 5.23828 13.9702 5.6634L12.5 7.13365M15.8663 10.5L12.5 7.13365"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pen-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["edit","write","pen","modify","adjustment","correction","signature","sign","approve"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L5 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7.79346 16L10.0595 15.9782C10.2645 15.9815 10.4601 15.904 10.6039 15.7625L15.8663 10.5L17.3366 9.02975C17.7617 8.598 18 8.01639 18 7.41047C18 6.13583 16.8642 5 15.5895 5C14.9836 5 14.402 5.23828 13.9702 5.6634L12.5 7.13365L7.23755 12.3961C7.09601 12.5399 7.0185 12.7355 7.02177 12.9405L7 15.2065C7.00687 15.6379 7.36211 15.9931 7.79346 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M15.8663 10.5L10.6039 15.7625C10.4601 15.904 10.2645 15.9815 10.0595 15.9782L7.79346 16C7.36211 15.9931 7.00687 15.6379 7 15.2065L7.02177 12.9405C7.0185 12.7355 7.09601 12.5399 7.23755 12.3961L12.5 7.13365M15.8663 10.5L17.3366 9.02975C17.7617 8.598 18 8.01639 18 7.41047C18 6.13583 16.8642 5 15.5895 5C14.9836 5 14.402 5.23828 13.9702 5.6634L12.5 7.13365M15.8663 10.5L12.5 7.13365"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3366 9.02975C17.7617 8.598 18 8.01639 18 7.41047C18 6.13583 16.8642 5 15.5895 5C14.9836 5 14.402 5.23828 13.9702 5.6634L12.5 7.13365L15.8663 10.5L17.3366 9.02975Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pen-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["erase","eraser","clear","correction","remove","edit","modify","delete","backspace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5895 4C17.4165 4 19 5.58354 19 7.41047C19 8.27892 18.6585 9.11257 18.0492 9.73139L11.311 16.4696L11.3053 16.4752C10.9708 16.8045 10.5216 16.9816 10.059 16.9783L7.80306 17C7.79456 17 7.78605 17 7.77754 16.9999C6.80637 16.9844 6.01558 16.1936 6.00013 15.2225C5.99999 15.214 5.99996 15.2054 6.00005 15.1969L6.02172 12.941C6.01835 12.4784 6.19553 12.0292 6.5248 11.6946L13.2631 4.95628L13.2686 4.95085C13.8875 4.34153 14.7211 4 15.5895 4ZM4 19C4 18.4477 4.44772 18 5 18L19 18C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20L5 20C4.44772 20 4 19.5523 4 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pen-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","minus","remove","delete","subtract","edit","discount","reduce","reduction","remove-item","delete-item","subtract-item","edit-item","discount-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4V4C10.8856 4 11.8284 4 12.4142 4.58579C13 5.17157 13 6.11438 13 8V12V14.2333C13 14.8267 13 15.1234 12.9163 15.4036C12.8325 15.6837 12.6698 15.9318 12.3442 16.4279L10.5487 19.164C10.2062 19.6857 9.6241 20 9 20V20C8.3759 20 7.79376 19.6857 7.45134 19.164L5.65581 16.4279C5.33024 15.9318 5.16746 15.6837 5.08373 15.4036C5 15.1234 5 14.8267 5 14.2333V12V8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 8H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 20H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pen-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pen","edit","remove","decrease","subtract","discount","reduce","lower","amount","price","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4V4C10.8856 4 11.8284 4 12.4142 4.58579C13 5.17157 13 6.11438 13 8V12V14.2333C13 14.8267 13 15.1234 12.9163 15.4036C12.8325 15.6837 12.6698 15.9318 12.3442 16.4279L10.5487 19.164C10.2062 19.6857 9.6241 20 9 20V20C8.3759 20 7.79376 19.6857 7.45134 19.164L5.65581 16.4279C5.33024 15.9318 5.16746 15.6837 5.08373 15.4036C5 15.1234 5 14.8267 5 14.2333V12V8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 20H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pen-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["eraser","delete","remove","clear","erase","backspace","discard","correction","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4C10.8856 4 11.8284 4 12.4142 4.58579C13 5.17157 13 6.11438 13 8V12V14.2333C13 14.8267 13 15.1234 12.9163 15.4036C12.8325 15.6837 12.6698 15.9318 12.3442 16.4279L10.5487 19.164C10.2062 19.6857 9.6241 20 9 20C8.3759 20 7.79376 19.6857 7.45134 19.164L5.65581 16.4279C5.33024 15.9318 5.16746 15.6837 5.08373 15.4036C5 15.1234 5 14.8267 5 14.2333V12V8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 8H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 20H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pen-Edit-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["pen","edit","modify","write","change","description","note","annotate","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77861 16.3606L9.91379 16.3525C10.1258 16.3559 10.328 16.2757 10.4768 16.1294L17.439 9.16713C17.8786 8.72066 18.125 8.11922 18.125 7.49264C18.125 6.17455 16.9505 5 15.6324 5C15.0058 5 14.4043 5.2464 13.9579 5.68602L6.99565 12.6482C6.84928 12.797 6.76914 12.9992 6.77251 13.2112L6.76443 14.3464C6.75764 15.3015 6.75424 15.7791 7.05008 16.0749C7.34593 16.3708 7.82349 16.3674 8.77861 16.3606Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19H5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pen-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["eraser","remove","delete","subtract","discount","reduction","cut","takeaway"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.94808 3.25H9.05208C9.95053 3.24997 10.6998 3.24995 11.2946 3.32992C11.9224 3.41432 12.4892 3.59999 12.9446 4.05546C13.4001 4.51093 13.5858 5.07773 13.6702 5.70552C13.7201 6.07715 13.7389 6.50906 13.7459 7H4.25427C4.26129 6.50906 4.28003 6.07715 4.32999 5.70552C4.4144 5.07773 4.60007 4.51093 5.05554 4.05546C5.51101 3.59999 6.07781 3.41432 6.7056 3.32992C7.30037 3.24995 8.04963 3.24997 8.94808 3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.25008 9L4.25004 14.3203C4.24968 14.8289 4.24939 15.2307 4.36521 15.6183C4.48102 16.0059 4.70172 16.3416 4.98105 16.7666L6.82439 19.5755C7.30544 20.3085 8.12329 20.75 9.00008 20.75C9.87687 20.75 10.6947 20.3085 11.1758 19.5755L13.0191 16.7666C13.2984 16.3417 13.5191 16.0058 13.635 15.6183C13.7508 15.2307 13.7505 14.8289 13.7501 14.3203L13.7501 9H4.25008Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0001 20C13.0001 19.4477 13.4478 19 14.0001 19H19.0001C19.5524 19 20.0001 19.4477 20.0001 20C20.0001 20.5523 19.5524 21 19.0001 21H14.0001C13.4478 21 13.0001 20.5523 13.0001 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pen-Edit-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["edit","pen","slash","cancel","delete","remove","disable","block","prohibit","editing-disabled","editing-cancelled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.02861 17.9856L9.33763 17.9763C9.56132 17.9798 9.77463 17.8953 9.93152 17.7409L17.2763 10.3961C17.7401 9.92509 18 9.2906 18 8.6296C18 7.23908 16.7609 6 15.3704 6C14.7094 6 14.0749 6.25994 13.6039 6.72371L6.25914 14.0685C6.10474 14.2254 6.02019 14.4387 6.02375 14.6624L6.01443 15.9714C6.00764 16.9265 6.00424 17.4041 6.30008 17.6999C6.59593 17.9958 7.07349 17.9924 8.02861 17.9856Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pen-Edit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pen","write","modify","alter","adjust","signature","authorize","change","pencil","correction","update","input","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2686 4.95085C13.8875 4.34153 14.7211 4 15.5895 4C17.4165 4 19 5.58354 19 7.41047C19 8.27892 18.6585 9.11254 18.0492 9.73137L18.0437 9.73688L11.3054 16.4752C10.9704 16.8048 10.5206 16.982 10.0574 16.9783L8.9808 16.9859C8.55103 16.9891 8.13399 16.9921 7.79021 16.9481C7.403 16.8986 6.96015 16.7742 6.59298 16.407C6.2258 16.0398 6.10139 15.597 6.05185 15.2098C6.00787 14.866 6.01092 14.449 6.01406 14.0192L6.02173 12.9426C6.01796 12.4794 6.19518 12.0296 6.52481 11.6947L6.53042 11.689L13.2686 4.95085Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pen-Edit-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","write","pen","pencil","modify","adjust","input","amend","notes","comments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77861 16.3606L9.91379 16.3525C10.1258 16.3559 10.328 16.2757 10.4768 16.1294L17.439 9.16713C17.8786 8.72066 18.125 8.11922 18.125 7.49264C18.125 6.17455 16.9505 5 15.6324 5C15.0058 5 14.4043 5.2464 13.9579 5.68602L6.99565 12.6482C6.84928 12.797 6.76914 12.9992 6.77251 13.2112L6.76443 14.3464C6.75764 15.3015 6.75424 15.7791 7.05008 16.0749C7.34593 16.3708 7.82349 16.3674 8.77861 16.3606Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 19H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pen-Edit-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["disable","slash","edit","remove","cancel","delete","erase","void","invalidate","cross-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.02861 17.9856L9.33763 17.9763C9.56132 17.9798 9.77463 17.8953 9.93152 17.7409L17.2763 10.3961C17.7401 9.92509 18 9.2906 18 8.6296C18 7.23908 16.7609 6 15.3704 6C14.7094 6 14.0749 6.25994 13.6039 6.72371L6.25914 14.0685C6.10474 14.2254 6.02019 14.4387 6.02375 14.6624L6.01443 15.9714C6.00764 16.9265 6.00424 17.4041 6.30008 17.6999C6.59593 17.9958 7.07349 17.9924 8.02861 17.9856Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8.02861 17.9856L9.33763 17.9763C9.56132 17.9798 9.77463 17.8953 9.93152 17.7409L17.2763 10.3961C17.7401 9.92509 18 9.2906 18 8.6296C18 7.23908 16.7609 6 15.3704 6C14.7094 6 14.0749 6.25994 13.6039 6.72371L6.25914 14.0685C6.10474 14.2254 6.02019 14.4387 6.02375 14.6624L6.01443 15.9714C6.00764 16.9265 6.00424 17.4041 6.30008 17.6999C6.59593 17.9958 7.07349 17.9924 8.02861 17.9856Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pen-Edit-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pen","slash","remove","delete","disable","cancel","void","edit-slash","pen-slash","remove-item","delete-item","void-item","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L8.74959 10.1638L5.55201 13.3613L5.54641 13.367C5.20387 13.7151 5.01961 14.1827 5.0237 14.6646L5.01406 16.0192C5.01092 16.449 5.00787 16.866 5.05185 17.2098C5.10139 17.597 5.2258 18.0398 5.59298 18.407C5.96015 18.7742 6.403 18.8986 6.79021 18.9481C7.13399 18.9921 7.55101 18.9891 7.98078 18.9859L9.33542 18.9763C9.81729 18.9804 10.2849 18.7962 10.633 18.4536L13.8362 15.2504L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L6.70711 5.29289ZM17.9834 11.1032L16.2504 12.8362L11.1638 7.74961L12.9023 6.01116C13.5604 5.36319 14.4469 5 15.3704 5C17.3132 5 19 6.6868 19 8.6296C19 9.55314 18.6368 10.4396 17.9888 11.0977L17.9834 11.1032Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pen-Edit-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","slash","cancel","remove","delete","discard","reject","void","disable","modification","editing","update","correction","cancellation","revocation","item-cancellation","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.02861 17.9856L9.33763 17.9763C9.56132 17.9798 9.77463 17.8953 9.93152 17.7409L17.2763 10.3961C17.7401 9.92509 18 9.2906 18 8.6296C18 7.23908 16.7609 6 15.3704 6C14.7094 6 14.0749 6.25994 13.6039 6.72371L6.25914 14.0685C6.10474 14.2254 6.02019 14.4387 6.02375 14.6624L6.01443 15.9714C6.00764 16.9265 6.00424 17.4041 6.30008 17.6999C6.59593 17.9958 7.07349 17.9924 8.02861 17.9856Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 18L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pen-Edit": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","edit","modify","write","signature","update","pencil","sign","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19H5M9.91379 16.3525L8.77861 16.3606C7.82349 16.3674 7.34593 16.3708 7.05008 16.0749C6.75424 15.7791 6.75764 15.3015 6.76443 14.3464L6.77251 13.2112C6.76914 12.9992 6.84928 12.797 6.99565 12.6482L13.9579 5.68602C14.4043 5.2464 15.0058 5 15.6324 5C16.9505 5 18.125 6.17455 18.125 7.49264C18.125 8.11922 17.8786 8.72066 17.439 9.16713L10.4768 16.1294C10.328 16.2757 10.1258 16.3559 9.91379 16.3525Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pen-tool-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pen","tool","design","create","edit","drawing","modify","configuration","customize","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 16L15.9355 14.9309C16.9267 13.798 17.4224 13.2316 17.4597 12.5422C17.497 11.8528 17.0653 11.2362 16.2021 10.003L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.63892 10.2301C6.84752 11.3607 6.45183 11.926 6.45801 12.567C6.4642 13.2081 6.87074 13.7656 7.68381 14.8807L8.5 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pen-tool-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["edit","pen","tool","drawing","design","modification","adjust","vector","create"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.3454 10.2077L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.42165 10.5405C6.84281 11.3674 6.55339 11.7809 6.48185 12.2393C6.44795 12.4565 6.45009 12.6777 6.48817 12.8942C6.56855 13.3512 6.8659 13.759 7.4606 14.5745C7.89126 15.1652 8.10659 15.4605 8.39572 15.6562C8.5336 15.7495 8.68259 15.8253 8.83924 15.8817C9.16774 16 9.53322 16 10.2642 16H13.3296C14.0795 16 14.4544 16 14.7934 15.8731C14.8783 15.8414 14.9608 15.8039 15.0405 15.761C15.3593 15.5894 15.6062 15.3072 16.1 14.7429L16.1 14.7429C16.9304 13.7938 17.3456 13.3193 17.437 12.7528C17.4596 12.6132 17.4672 12.4716 17.4599 12.3304C17.4301 11.7573 17.0685 11.2408 16.3454 10.2077Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.75 5.5C12.75 5.08579 12.4142 4.75 12 4.75C11.5858 4.75 11.25 5.08579 11.25 5.5L12.75 5.5ZM12.75 9L12.75 5.5L11.25 5.5L11.25 9L12.75 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pen-tool-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","tool","design","edit","create","customize","adjust","draw","artwork","signature","markup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 4.86872V8.35347C13.9043 8.67993 14.75 9.74117 14.75 10.9999C14.75 12.5187 13.5188 13.7499 12 13.7499C10.4812 13.7499 9.25 12.5187 9.25 10.9999C9.25 9.74117 10.0957 8.67993 11.25 8.35347V4.86865C10.7717 5.04153 10.3623 5.37133 9.98462 5.77118C9.44388 6.34367 8.85901 7.17924 8.14398 8.20077L6.89461 9.98558C6.5426 10.4884 6.24439 10.9144 6.03736 11.2913C5.8171 11.6923 5.66512 12.0972 5.65485 12.564C5.64458 13.0308 5.77861 13.442 5.98102 13.8523C6.17127 14.2379 6.45045 14.6766 6.78001 15.1944L8.08819 17.2502H8.2499C7.14533 17.2502 6.2499 18.1456 6.2499 19.2502C6.2499 20.3547 7.14533 21.2502 8.2499 21.2502H15.7499C16.8545 21.2502 17.7499 20.3547 17.7499 19.2502C17.7499 18.1456 16.8545 17.2502 15.7499 17.2502H15.3708L16.8461 15.3183C17.2524 14.7863 17.5956 14.3369 17.8336 13.9376C18.0865 13.5133 18.2616 13.081 18.2721 12.5772C18.2825 12.0734 18.1254 11.6342 17.8903 11.1998C17.6691 10.7911 17.3448 10.3279 16.9609 9.77949L15.8558 8.20075C15.1408 7.17924 14.5559 6.34367 14.0152 5.77118C13.6376 5.37138 13.2282 5.04163 12.75 4.86872Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 9.74995C11.3096 9.74995 10.75 10.3096 10.75 10.9999C10.75 11.6903 11.3096 12.2499 12 12.2499C12.6904 12.2499 13.25 11.6903 13.25 10.9999C13.25 10.3096 12.6904 9.74995 12 9.74995Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pen-tool-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["disable","remove","delete","cancel","unavailable","inactive","stop","slash","pen","tool"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L15.9355 14.9309C16.9267 13.798 17.4224 13.2316 17.4597 12.5422C17.497 11.8528 17.0653 11.2362 16.2021 10.003L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.63892 10.2301C6.84752 11.3607 6.45183 11.926 6.45801 12.567C6.4642 13.2081 6.87074 13.7656 7.68381 14.8807L8.5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 19L5 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pen-tool-slash-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unavailable","disabled","not-available","blocked","prohibited","crossed-out","pen","tool","editing-disabled","signature-disabled","drawing-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.3454 10.2077L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.42165 10.5405C6.84281 11.3674 6.55339 11.7809 6.48185 12.2393C6.44795 12.4565 6.45009 12.6777 6.48817 12.8942C6.56855 13.3512 6.8659 13.759 7.4606 14.5745C7.89126 15.1652 8.10659 15.4605 8.39572 15.6562C8.5336 15.7495 8.68259 15.8253 8.83924 15.8817C9.16774 16 9.53322 16 10.2642 16H13.3296C14.0795 16 14.4544 16 14.7934 15.8731C14.8783 15.8414 14.9608 15.8039 15.0405 15.761C15.3593 15.5894 15.6062 15.3072 16.1 14.7429L16.1 14.7429C16.9304 13.7938 17.3456 13.3193 17.437 12.7528C17.4596 12.6132 17.4672 12.4716 17.4599 12.3304C17.4301 11.7573 17.0685 11.2408 16.3454 10.2077Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.75 5.5C12.75 5.08579 12.4142 4.75 12 4.75C11.5858 4.75 11.25 5.08579 11.25 5.5L12.75 5.5ZM12.75 9L12.75 5.5L11.25 5.5L11.25 9L12.75 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pen-tool-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","tool","slash","prohibited","disable","edit-mode-off","drawing-off","not-allowed","no-edit","read-only"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L8.75186 7.33765C9.20429 6.70379 9.60531 6.17276 9.98462 5.77118C10.3623 5.37133 10.7717 5.04154 11.25 4.86865V8.35347C10.8888 8.45562 10.5578 8.62972 10.2735 8.85931L11.3477 9.93345C11.5376 9.81705 11.7609 9.74995 12 9.74995C12.6904 9.74995 13.25 10.3096 13.25 10.9999C13.25 11.239 13.1829 11.4624 13.0665 11.6523L14.1406 12.7264C14.5218 12.2544 14.75 11.6538 14.75 10.9999C14.75 9.74117 13.9043 8.67993 12.75 8.35347V4.86872C13.2282 5.04163 13.6376 5.37138 14.0152 5.77118C14.5559 6.34367 15.1408 7.17924 15.8558 8.20075L16.9609 9.77949C17.3448 10.3279 17.6691 10.7911 17.8903 11.1998C18.1254 11.6342 18.2825 12.0734 18.2721 12.5772C18.2616 13.081 18.0865 13.5133 17.8336 13.9376C17.5956 14.3369 17.2524 14.7863 16.8461 15.3183L16.7969 15.3827L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L4.29289 5.70711ZM6.03736 11.2913C6.21777 10.9629 6.46742 10.5972 6.76158 10.1758L17.2065 20.6207C16.8417 21.0082 16.3241 21.2502 15.7499 21.2502H8.2499C7.14533 21.2502 6.2499 20.3547 6.2499 19.2502C6.2499 18.1456 7.14533 17.2502 8.2499 17.2502H8.08819L6.78001 15.1944C6.45045 14.6766 6.17127 14.2379 5.98102 13.8523C5.77861 13.442 5.64458 13.0308 5.65485 12.564C5.66512 12.0972 5.8171 11.6923 6.03736 11.2913Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pen-tool-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","tool","slash","disabled","inactive","edit-disabled","modify-disabled","design-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L15.9355 14.9309C16.9267 13.798 17.4224 13.2316 17.4597 12.5422C17.497 11.8528 17.0653 11.2362 16.2021 10.003L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.63892 10.2301C6.84752 11.3607 6.45183 11.926 6.45801 12.567C6.4642 13.2081 6.87074 13.7656 7.68381 14.8807L8.5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 19L5 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    pen: {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","tool","slash","disabled","inactive","edit-disabled","modify-disabled","design-disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L5 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.8663 10.5L10.6039 15.7625C10.4601 15.904 10.2645 15.9815 10.0595 15.9782L7.79346 16C7.36211 15.9931 7.00687 15.6379 7 15.2065L7.02177 12.9405C7.0185 12.7355 7.09601 12.5399 7.23755 12.3961L12.5 7.13365M15.8663 10.5L17.3366 9.02975C17.7617 8.598 18 8.01639 18 7.41047C18 6.13583 16.8642 5 15.5895 5C14.9836 5 14.402 5.23828 13.9702 5.6634L12.5 7.13365M15.8663 10.5L12.5 7.13365"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pen-tool": {
        defaultColors: ["#3D4C66"],
        keywords: ["pen","ink","design","edit","drawing","signature","annotate","note","markup","create"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L15.9355 14.9309C16.9267 13.798 17.4224 13.2316 17.4597 12.5422C17.497 11.8528 17.0653 11.2362 16.2021 10.003L15.2769 8.68132C13.7865 6.55217 13.0413 5.48759 12 5.48759C10.9587 5.48759 10.2135 6.55217 8.72307 8.68132L7.63892 10.2301C6.84752 11.3607 6.45183 11.926 6.45801 12.567C6.4642 13.2081 6.87074 13.7656 7.68381 14.8807L8.5 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 20H9C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16H15C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 9L12 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Pencil-Edit-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","pencil","modify","update","revise","change","alter","write","notes","description","edit-order","edit-item","edit-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.0249 7.74268L14.1431 9.86416L16.2614 11.9856"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.9321 5C15.166 5 14.4306 5.30175 13.8846 5.84011L12.0249 7.74281L5.29235 14.4857C5.10515 14.6732 5 14.9274 5 15.1923L5 17.977C5 18.5382 5.46169 18.9895 6.02273 18.9767L8.60206 18.9181C8.67637 18.9164 8.75047 18.9251 8.82452 18.9316C9.11509 18.957 9.40455 18.8531 9.61347 18.6439L16.2614 11.9858L18.1612 10.1232C18.6987 9.57646 19 8.83992 19 8.07261C19 7.26589 18.6305 6.49228 18.0704 5.93099C17.51 5.37007 16.7376 5 15.9321 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Pencil-Edit-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["eraser","delete","remove","correction","edit","clear","backspace","undo","erase","item-removal","item-deletion","mistake","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.8846 5.84011C14.4306 5.30175 15.166 5 15.9321 5C16.7376 5 17.51 5.37007 18.0704 5.93099C18.6305 6.49228 19 7.26589 19 8.07261C19 8.83992 18.6987 9.57646 18.1612 10.1232L16.2614 11.9858L9.61347 18.6439C9.40455 18.8531 9.11509 18.957 8.82452 18.9316C8.75047 18.9251 8.67637 18.9164 8.60206 18.9181L6.02273 18.9767C5.46169 18.9895 5 18.5382 5 17.977L5 15.1923C5 14.9274 5.10515 14.6732 5.29235 14.4857L12.0249 7.74281L13.8846 5.84011Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12.0249 7.74281L13.8846 5.84011C14.4306 5.30175 15.166 5 15.9321 5C16.7376 5 17.51 5.37007 18.0704 5.93099C18.6305 6.49228 19 7.26589 19 8.07261C19 8.83992 18.6987 9.57646 18.1612 10.1232L16.2614 11.9858M12.0249 7.74281L14.1432 9.86429L16.2614 11.9858M12.0249 7.74281L5.29235 14.4857C5.10515 14.6732 5 14.9274 5 15.1923L5 17.977C5 18.5382 5.46169 18.9895 6.02273 18.9767L8.60206 18.9181C8.67637 18.9164 8.75047 18.9251 8.82452 18.9316C9.11509 18.957 9.40455 18.8531 9.61347 18.6439L16.2614 11.9858"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.9321 5C15.1659 5 14.4305 5.30175 13.8846 5.84011L12.0249 7.74281L14.1431 9.86429L16.2614 11.9858L18.1611 10.1232C18.6987 9.57646 19 8.83992 19 8.07261C19 7.26589 18.6305 6.49228 18.0704 5.93099C17.51 5.37007 16.7375 5 15.9321 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Pencil-Edit-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","alter","correct","revise","amend","adjustment","item-edit","price-edit","discount-edit","order-edit","receipt-edit","transaction-edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.1245 6.21029L13.1759 5.13455L13.1825 5.12809C13.9154 4.40536 14.9029 4 15.9321 4C17.0412 4 18.0588 4.50447 18.7779 5.2242C19.4965 5.94444 20 6.96331 20 8.07261C20 9.10197 19.5958 10.0903 18.8743 10.8243L18.8678 10.8308L17.7959 11.8817L12.1245 6.21029Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.7201 7.63433L4.5847 13.7792C4.21029 14.1542 4 14.6624 4 15.1923V17.977C4 19.0994 4.92339 20.002 6.04546 19.9765L8.62139 19.9179C8.62345 19.918 8.62892 19.9182 8.63891 19.919C8.64886 19.9197 8.66068 19.9208 8.67762 19.9223L8.73725 19.9278C9.32096 19.9789 9.90197 19.7703 10.3211 19.3505L16.374 13.2883L10.7201 7.63433Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 18C13.4477 18 13 18.4477 13 19C13 19.5523 13.4477 20 14 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pencil-Edit-line-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","write","adjust","correct","revise","amend","edit-order","edit-item","edit-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.604 12.7441L11.2559 17.396"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.42673 13.2761L5.66507 15.5611C5.0599 17.3766 4.75731 18.2843 5.23648 18.7635C5.71565 19.2427 6.62341 18.9401 8.43891 18.3349L10.7239 17.5733C10.9883 17.4851 11.1204 17.4411 11.2343 17.364C11.3482 17.2869 11.4382 17.1805 11.6182 16.9678L18.368 8.99083C18.4739 8.86567 18.5269 8.80306 18.569 8.74617C19.1841 7.91612 19.1364 6.76937 18.4545 5.99327C18.4078 5.94006 18.3498 5.88209 18.2339 5.76614C18.1179 5.6502 18.0599 5.59223 18.0067 5.54549C17.2306 4.86364 16.0839 4.81594 15.2538 5.43098C15.197 5.47313 15.1344 5.52609 15.0092 5.63197L15.0092 5.63202L7.03222 12.3817C6.8195 12.5617 6.71314 12.6517 6.63603 12.7656C6.55891 12.8795 6.51485 13.0117 6.42673 13.2761Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Pencil-Edit-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pencil","edit","modify","change","update","revise","write","correct","adjust","customize","signature","note","annotation","drawing","input","entry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.60408 12.744L15.0092 5.63202C15.1344 5.5261 15.197 5.47314 15.2538 5.43098C16.0839 4.81594 17.2306 4.86364 18.0067 5.54549C18.0599 5.59223 18.1179 5.6502 18.2339 5.76614C18.3498 5.88209 18.4078 5.94006 18.4545 5.99327C19.1364 6.76937 19.1841 7.91612 18.569 8.74617C18.5269 8.80306 18.4739 8.86567 18.368 8.99083L11.256 17.3959L6.60408 12.744Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.60408 12.744L5.66507 15.5611C5.0599 17.3766 4.75731 18.2843 5.23648 18.7635C5.71565 19.2427 6.62341 18.9401 8.43891 18.3349L11.256 17.3959M6.60408 12.744L15.0092 5.63202C15.1344 5.5261 15.197 5.47314 15.2538 5.43098C16.0839 4.81594 17.2306 4.86364 18.0067 5.54549C18.0599 5.59223 18.1179 5.6502 18.2339 5.76614C18.3498 5.88209 18.4078 5.94006 18.4545 5.99327C19.1364 6.76937 19.1841 7.91612 18.569 8.74617C18.5269 8.80306 18.4739 8.86567 18.368 8.99083L11.256 17.3959M6.60408 12.744L11.256 17.3959"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.23648 18.7636C4.75731 18.2845 5.0599 17.3767 5.66507 15.5612C6.04533 14.4204 6.23546 13.85 6.65219 13.6741C6.75538 13.6305 6.86517 13.6046 6.97695 13.5974C7.42836 13.5684 7.8535 13.9936 8.7038 14.8439L9.15626 15.2963C10.0066 16.1466 10.4317 16.5718 10.4027 17.0232C10.3955 17.135 10.3696 17.2447 10.326 17.3479C10.1501 17.7647 9.57971 17.9548 8.43892 18.3351L8.43891 18.3351C6.62341 18.9402 5.71565 19.2428 5.23648 18.7636Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Pencil-Edit-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pencil","edit","modify","change","adjust","write","correct","update","description","remark","annotate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 19C13 18.4477 13.4477 18 14 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H14C13.4477 20 13 19.5523 13 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.6585 4.62751C15.8671 3.73201 17.5367 3.80146 18.6668 4.79423C18.7449 4.86291 18.8249 4.94286 18.921 5.03908L18.9609 5.07898C19.0571 5.17516 19.1371 5.25509 19.2058 5.33326C20.1986 6.46328 20.268 8.13295 19.3725 9.34151C19.3106 9.42511 19.2375 9.51143 19.1496 9.61525L12.0194 18.0419C11.9009 18.1819 11.7462 18.2866 11.5722 18.3446L8.68194 19.308C7.83704 19.5897 7.09829 19.8361 6.51173 19.9404C5.91554 20.0465 5.13053 20.0718 4.52939 19.4706C3.92826 18.8695 3.95356 18.0845 4.05962 17.4883C4.16397 16.9017 4.41028 16.163 4.69199 15.3181L5.65542 12.4278C5.71342 12.2538 5.81815 12.0991 5.95816 11.9806L14.3848 4.8504C14.4886 4.7625 14.5749 4.68946 14.6585 4.62751Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pencil-Edit-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["pencil","edit","modify","change","write","discount","price","edit-price","edit-order","adjust","correction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.60408 12.744L5.66507 15.5611C5.0599 17.3766 4.75731 18.2843 5.23648 18.7635C5.71565 19.2427 6.62341 18.9401 8.43891 18.3349L11.256 17.3959M6.60408 12.744L15.0092 5.63202C15.1344 5.5261 15.197 5.47314 15.2538 5.43098C16.0839 4.81594 17.2306 4.86364 18.0067 5.54549C18.0599 5.59223 18.1179 5.6502 18.2339 5.76614C18.3498 5.88209 18.4078 5.94006 18.4545 5.99327C19.1364 6.76937 19.1841 7.91612 18.569 8.74617C18.5269 8.80306 18.4739 8.86567 18.368 8.99083L11.256 17.3959M6.60408 12.744L11.256 17.3959"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Pencil-Edit": {
        defaultColors: ["#3D4C66"],
        keywords: ["edit","pencil","modify","change","update","revise","adjust","correct","amend","write","input","description","notes","settings","configuration","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L13 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.0249 7.74281L13.8846 5.84011C14.4306 5.30175 15.166 5 15.9321 5C16.7376 5 17.51 5.37007 18.0704 5.93099C18.6305 6.49228 19 7.26589 19 8.07261C19 8.83992 18.6987 9.57646 18.1612 10.1232L16.2614 11.9858M12.0249 7.74281L14.1432 9.86429L16.2614 11.9858M12.0249 7.74281L5.29235 14.4857C5.10515 14.6732 5 14.9274 5 15.1923L5 17.977C5 18.5382 5.46169 18.9895 6.02273 18.9767L8.60206 18.9181C8.67637 18.9164 8.75047 18.9251 8.82452 18.9316C9.11509 18.957 9.40455 18.8531 9.61347 18.6439L16.2614 11.9858"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "percentage-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["percentage","discount","sale","promotion","price-off","coupon","rebate","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 18L18 6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "percentage-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["percentage","discount","sale","promotion","coupon","offer","price-reduction","rebate","off","percent-off","markdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 18L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "percentage-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["percentage","discount","sale","promotion","off","price-cut","markdown","reduced-price","coupon","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.5 8C4.5 6.067 6.067 4.5 8 4.5C9.933 4.5 11.5 6.067 11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5 16C12.5 14.067 14.067 12.5 16 12.5C17.933 12.5 19.5 14.067 19.5 16C19.5 17.933 17.933 19.5 16 19.5C14.067 19.5 12.5 17.933 12.5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L18.7071 6.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "phone-rotate-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["phone","rotate","ringing","call","alert","notification","mobile","device","vibrate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00021 10.0001L7.00038 14.0004C7.00046 15.8694 7.0005 16.8039 7.40235 17.4999C7.66569 17.9561 8.04448 18.3349 8.50064 18.5982C9.19673 19 10.1312 19 12.0002 19C13.8692 19 14.8038 19 15.4999 18.5982C15.956 18.3348 16.3348 17.956 16.5981 17.4999C17 16.8038 17 15.8692 17 14.0002L17 9.99985C16.9999 8.13075 16.9999 7.19619 16.5981 6.50008C16.3347 6.04396 15.956 5.66519 15.4999 5.40187C14.8037 5 13.8692 5 12.0001 5C10.1309 5 9.19631 5 8.50018 5.4019C8.04404 5.66523 7.66528 6.04401 7.40196 6.50016C7.00009 7.19631 7.00013 8.1309 7.00021 10.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 16H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 16C2.66667 13.7909 2.66667 10.2091 4 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 8C21.3333 10.2091 21.3333 13.7909 20 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "phone-rotate-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","rotate","device","orientation","display","screen","mode","layout","switch","phone-rotate","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00021 11.0001L7.00038 15.0004C7.00046 16.8694 7.0005 17.8039 7.40235 18.4999C7.66569 18.9561 8.04448 19.3349 8.50064 19.5982C9.19673 20 10.1312 20 12.0002 20C13.8692 20 14.8038 20 15.4999 19.5982C15.956 19.3348 16.3348 18.956 16.5981 18.4999C17 17.8038 17 16.8692 17 15.0002L17 10.9999C16.9999 9.13075 16.9999 8.19619 16.5981 7.50008C16.3347 7.04396 15.956 6.66519 15.4999 6.40187C14.8037 6 13.8692 6 12.0001 6C10.1309 6 9.19631 6 8.50018 6.4019C8.04404 6.66523 7.66528 7.04401 7.40196 7.50016C7.00009 8.19631 7.00013 9.1309 7.00021 11.0001Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M11 16H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 16C2.66667 13.7909 2.66667 10.2091 4 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 8C21.3333 10.2091 21.3333 13.7909 20 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    percentage: {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","rotate","device","orientation","display","screen","mode","layout","switch","phone-rotate","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 18L18 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "phone-rotate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","rotate","device","orientation","payment-device","credit-card-reader","terminal","card-reader"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0462 5H11.9541H11.9541C11.0586 4.99999 10.3197 4.99997 9.72002 5.05432C9.09635 5.11084 8.52586 5.2324 8.00023 5.53586C7.39205 5.88698 6.88703 6.39202 6.53594 7.00021C6.2325 7.52586 6.11097 8.09635 6.05447 8.72002C6.00015 9.3197 6.00019 10.0586 6.00025 10.9541L6.00042 15.0465V15.0465C6.00044 15.9418 6.00046 16.6807 6.05482 17.2803C6.11136 17.9039 6.23293 18.4743 6.53635 18.9999C6.88747 19.6081 7.39253 20.1131 8.00074 20.4642C8.52633 20.7676 9.09676 20.8892 9.72036 20.9457C10.32 21 11.0589 21 11.9542 21H12.0462C12.9416 21 13.6805 21 14.2802 20.9457C14.9038 20.8892 15.4742 20.7676 15.9998 20.4642C16.6081 20.1131 17.1131 19.608 17.4642 18.9998C17.7677 18.4742 17.8892 17.9038 17.9457 17.2801C18.0001 16.6805 18 15.9416 18 15.0462L18 10.9539V10.9538C18 10.0584 18 9.31947 17.9457 8.71983C17.8891 8.09619 17.7676 7.52572 17.4641 7.00011C17.113 6.39194 16.608 5.88693 15.9999 5.53583C15.4742 5.23239 14.9038 5.11084 14.2801 5.05432C13.6805 4.99997 12.9416 4.99999 12.0462 5H12.0462ZM4.51673 7.14385C4.98957 7.42924 5.14153 8.04389 4.85615 8.51673C4.30483 9.43018 4 10.6884 4 12C4 13.3116 4.30483 14.5698 4.85615 15.4833C5.14153 15.9561 4.98957 16.5708 4.51673 16.8561C4.04389 17.1415 3.42923 16.9896 3.14385 16.5167C2.36184 15.221 2 13.5838 2 12C2 10.4162 2.36184 8.77896 3.14385 7.48327C3.42923 7.01043 4.04389 6.85847 4.51673 7.14385ZM19.1439 15.4833C18.8585 15.9561 19.0104 16.5708 19.4833 16.8561C19.9561 17.1415 20.5708 16.9896 20.8561 16.5167C21.6382 15.221 22 13.5838 22 12C22 10.4162 21.6382 8.77896 20.8561 7.48327C20.5708 7.01043 19.9561 6.85847 19.4833 7.14385C19.0104 7.42924 18.8585 8.0439 19.1439 8.51673C19.6952 9.43018 20 10.6884 20 12C20 13.3116 19.6952 14.5698 19.1439 15.4833ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "picture-in-picture-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["display","screen","expand","fullscreen","arrow","maximize","interface","view","tile-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9H12C13.8856 9 14.8284 9 15.4142 9.58579C16 10.1716 16 11.1144 16 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 15M12 12L9 12M12 12L8 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "picture-in-picture-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["arrow","open","expand","fullscreen","maximize","launch","external-link","new-window","go-to"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13V9H10C12.8284 9 14.2426 9 15.1213 9.87868C16 10.7574 16 12.1716 16 15V19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 15M12 12L9 12M12 12L8 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "picture-in-picture-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["export","send","share","outbound","external","open","new-window","redirect","link","open-link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4H9.92943C8.57533 3.99997 7.45869 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45869 2.99997 9.57529 3 10.9294V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92935 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V10.9294C21 9.5753 21.0001 8.45868 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4247 3.99997 14.0706 4ZM6.84144 6.10092C6.13538 6.19585 5.80836 6.36322 5.58579 6.58579C5.36322 6.80836 5.19585 7.13538 5.10092 7.84144C5.09398 7.89305 5.08752 7.94588 5.0815 8.00001L12.0658 8C12.9523 7.99995 13.7161 7.99991 14.3278 8.08215C14.9833 8.17028 15.6117 8.36902 16.1213 8.87868C16.631 9.38835 16.8297 10.0167 16.9179 10.6722C17.0001 11.2839 17.0001 12.0477 17 12.9342L17 17.9185C17.0541 17.9125 17.107 17.906 17.1586 17.8991C17.8646 17.8042 18.1916 17.6368 18.4142 17.4142C18.6368 17.1916 18.8042 16.8646 18.8991 16.1586C18.9979 15.4238 19 14.4425 19 13V11C19 9.55752 18.9979 8.57626 18.8991 7.84144C18.8042 7.13538 18.6368 6.80836 18.4142 6.58579C18.1916 6.36322 17.8646 6.19585 17.1586 6.10092C16.4238 6.00213 15.4425 6 14 6H10C8.55752 6 7.57626 6.00213 6.84144 6.10092ZM7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L11 14.4142V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V12C13 11.4477 12.5523 11 12 11L9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H9.58579L7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "phone-rotate": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","mobile","vibrate","ringing","notification","alert","incoming call","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00021 10.0001L7.00038 14.0004C7.00046 15.8694 7.0005 16.8039 7.40235 17.4999C7.66569 17.9561 8.04448 18.3349 8.50064 18.5982C9.19673 19 10.1312 19 12.0002 19C13.8692 19 14.8038 19 15.4999 18.5982C15.956 18.3348 16.3348 17.956 16.5981 17.4999C17 16.8038 17 15.8692 17 14.0002L17 9.99985C16.9999 8.13075 16.9999 7.19619 16.5981 6.50008C16.3347 6.04396 15.956 5.66519 15.4999 5.40187C14.8037 5 13.8692 5 12.0001 5C10.1309 5 9.19631 5 8.50018 5.4019C8.04404 5.66523 7.66528 6.04401 7.40196 6.50016C7.00009 7.19631 7.00013 8.1309 7.00021 10.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 16H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 16C2.66667 13.7909 2.66667 10.2091 4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 8C21.3333 10.2091 21.3333 13.7909 20 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "picture-in-picture": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","overlay","arrow","pop-out","expand","fullscreen","display","mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9H12C13.8856 9 14.8284 9 15.4142 9.58579C16 10.1716 16 11.1144 16 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12L12 15M12 12L9 12M12 12L8 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pie-chart-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pie-chart","analytics","chart","data","statistics","report","sales-report","dashboard","performance","metrics","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L12 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "pie-chart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["pie-chart","chart","analytics","statistics","sales-data","data-visualization","reporting","metrics","dashboard","sales-performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 19.5001V4.50024" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19.6708 12L12 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pie-chart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pie-chart","chart","statistics","report","analytics","data","sales","overview","dashboard","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 4.06201C7.05369 4.55411 4 7.9205 4 12.0001C4 16.0797 7.05369 19.4461 11 19.9382V4.06201Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 19.9382C16.6312 19.4854 19.5066 16.5991 19.9427 12.9627C19.8562 12.9871 19.765 13.0001 19.6708 13.0001H13V19.9382Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.9427 11.0375C19.8562 11.0132 19.765 11.0001 19.6708 11.0001H13V4.06201C16.6312 4.51481 19.5066 7.40118 19.9427 11.0375Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pie-chart": {
        defaultColors: ["#3D4C66"],
        keywords: ["pie-chart","chart","report","analysis","statistics","sales","revenue","data","dashboard","performance","metrics","segmentation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 19V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pin 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","location","map","marker","pushpin","note","reminder","flag","position","mark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 10V4M9 4.00004V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 4.00003L17 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","location","map","marker","pushpin","note","reminder","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.0002 4V9.78891C15.0002 9.92655 15.041 10.0611 15.1173 10.1756C16.7008 12.5509 17.4925 13.7385 17.1388 14.6942C17.0754 14.8656 16.9887 15.0276 16.8812 15.1756C16.2822 16 14.8549 16 12.0002 16C9.14555 16 7.71821 16 7.11923 15.1756C7.01174 15.0276 6.92505 14.8657 6.86158 14.6942C6.50789 13.7385 7.29963 12.5509 8.88311 10.1756C8.95947 10.0611 9.00021 9.92655 9.00021 9.7889V4.00002L15.0002 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M15.0002 4V9.78891C15.0002 9.92655 15.041 10.0611 15.1173 10.1756V10.1756C16.7008 12.5509 17.4925 13.7385 17.1388 14.6942C17.0754 14.8656 16.9887 15.0276 16.8812 15.1756C16.2822 16 14.8549 16 12.0002 16C9.14555 16 7.71821 16 7.11923 15.1756C7.01174 15.0276 6.92505 14.8657 6.86158 14.6942C6.50789 13.7385 7.29963 12.5509 8.88311 10.1756V10.1756C8.95947 10.0611 9.00021 9.92655 9.00021 9.7889V4.00002L7.00021 4.00003L17.0002 4"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","selected","choose","setting","configuration","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 10V4M9 4.00004V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 4.00003L17 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","address","mark","map","customer","delivery-address","pickup-location","table","table-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9996 5H15.9996V9.69722C16.7521 10.8259 17.3719 11.7563 17.7508 12.525C18.1359 13.3061 18.4003 14.1651 18.0761 15.0412C17.9809 15.2985 17.8508 15.5415 17.6896 15.7634C17.1405 16.5191 16.2791 16.7756 15.4156 16.8885C14.7636 16.9737 13.9538 16.9938 12.9995 16.9985V20C12.9995 20.5523 12.5518 21 11.9995 21C11.4472 21 10.9995 20.5523 10.9995 20V16.9985C10.0453 16.9938 9.23558 16.9737 8.58367 16.8885C7.72014 16.7757 6.85874 16.5191 6.30963 15.7634C6.1484 15.5415 6.01837 15.2985 5.92316 15.0413C5.59891 14.1651 5.8633 13.3061 6.2484 12.525C6.62737 11.7564 7.24711 10.8259 7.99962 9.69722V5.00003L6.99962 5.00003C6.44734 5.00003 5.99962 4.55232 5.99962 4.00003C5.99962 3.44775 6.44733 3.00003 6.99962 3.00003L16.9996 3C17.5519 3 17.9996 3.44772 17.9996 4C17.9996 4.55228 17.5519 5 16.9996 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","location","reminder","note","message","push-pin","mark","saved-item","bookmark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.17188 14.8286L6.34345 17.657"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.5355 12.7071L16.9497 11.2929M12.707 7.0503L11.2928 8.46451"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2927 8.46469L10.6209 8.68864C8.28595 9.46695 7.11848 9.85611 6.77409 10.7178C6.70052 10.9018 6.65472 11.0959 6.6382 11.2934C6.56089 12.2181 7.43108 13.0883 9.17144 14.8286V14.8286C10.9118 16.569 11.782 17.4392 12.7067 17.3619C12.9042 17.3453 13.0982 17.2995 13.2823 17.226C14.144 16.8816 14.5331 15.7141 15.3114 13.3792L15.5354 12.7073"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7069 7.05026V7.05026C11.9258 6.26921 11.9258 5.00288 12.7069 4.22184V4.22184C13.4879 3.4408 14.7542 3.44079 15.5353 4.22183L19.7779 8.46447C20.559 9.24552 20.559 10.5119 19.7779 11.2929V11.2929C18.9969 12.0739 17.7306 12.0739 16.9495 11.2929V11.2929"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","location","reminder","note","message","flag","mark","pushpin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.17188 14.8286L6.34345 17.657"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.6212 8.6886L10.9307 8.58543C11.0684 8.53955 11.1372 8.5166 11.2013 8.48442C11.2541 8.45793 11.3045 8.42682 11.3518 8.39144C11.4092 8.34846 11.4606 8.29716 11.5632 8.19456C11.7699 7.98778 11.8733 7.8844 11.9351 7.78356C12.0404 7.61176 11.9977 7.71173 12.0492 7.51693C12.0795 7.4026 12.0937 6.79809 12.122 5.58907C12.1337 5.09305 12.3287 4.60054 12.7073 4.22201C13.4883 3.44097 14.7546 3.44097 15.5357 4.22201L19.7783 8.46465C20.5594 9.24569 20.5594 10.512 19.7783 11.2931C19.3998 11.6716 18.9073 11.8667 18.4113 11.8783C17.2023 11.9066 16.5978 11.9208 16.4834 11.9511C16.2886 12.0027 16.3886 11.9599 16.2168 12.0652C16.116 12.127 16.0126 12.2304 15.8058 12.4372L15.8058 12.4372C15.7032 12.5398 15.6519 12.5911 15.6089 12.6486C15.5735 12.6959 15.5424 12.7462 15.5159 12.799C15.4837 12.8632 15.4608 12.932 15.4149 13.0696L15.4149 13.0697L15.3118 13.3791C14.5335 15.7141 14.1443 16.8815 13.2827 17.2259C13.0986 17.2995 12.9046 17.3453 12.707 17.3618C11.7823 17.4391 10.9121 16.569 9.17176 14.8286C7.4314 13.0882 6.56122 12.2181 6.63853 11.2934C6.65504 11.0958 6.70084 10.9018 6.77442 10.7177C7.11881 9.85607 8.28628 9.46691 10.6212 8.6886Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","mark","bookmark","save","reminder","highlight","note","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0626 8.288C9.53052 7.17431 9.7257 5.79998 10.6482 4.87753C11.8182 3.70749 13.7152 3.70749 14.8853 4.87752L19.1225 9.1146C20.2925 10.2846 20.2925 12.1816 19.1225 13.3517C18.2001 14.2741 16.8258 14.4693 15.7122 13.9374L15.0523 14.5973L14.8812 15.1104C14.5113 16.2203 14.203 17.1451 13.8732 17.8291C13.5343 18.5318 13.0791 19.1865 12.2999 19.498C12.0241 19.6082 11.7335 19.6768 11.4375 19.7016C10.6012 19.7715 9.90131 19.3894 9.28387 18.9125C8.84992 18.5772 8.36988 18.1246 7.82506 17.5874L5.70489 19.7075C5.31488 20.0975 4.68253 20.0975 4.29251 19.7075C3.9025 19.3175 3.9025 18.6851 4.29251 18.2951L6.41268 16.175C5.87546 15.6302 5.42284 15.1502 5.08759 14.7162C4.6106 14.0988 4.22854 13.3989 4.29846 12.5627C4.3232 12.2667 4.39181 11.9761 4.50203 11.7003C4.81349 10.9211 5.46822 10.4659 6.17098 10.127C6.85492 9.79713 7.7797 9.48891 8.88962 9.11898L9.40261 8.94798L10.0626 8.288Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin 4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","location","map","marker","flag","pushpin","sales-target","sales-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.2423 11.9998L17.6565 10.5856C18.3232 9.9189 18.6565 9.58557 18.6565 9.17135C18.6565 8.75714 18.3232 8.4238 17.6565 7.75714L16.2423 6.34293C15.5757 5.67627 15.2423 5.34294 14.8281 5.34294C14.4139 5.34294 14.0806 5.67627 13.4139 6.34294L11.9997 7.75714"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 7.75717L11.3279 7.98112C8.99298 8.75943 7.82552 9.14859 7.48113 10.0102C7.40755 10.1943 7.36175 10.3883 7.34523 10.5859C7.26792 11.5106 8.13811 12.3808 9.87847 14.1211V14.1211C11.6188 15.8615 12.489 16.7317 13.4137 16.6543C13.6113 16.6378 13.8053 16.592 13.9894 16.5184C14.851 16.1741 15.2402 15.0066 16.0185 12.6717L16.2424 11.9998"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","location","map","address","mark","marker","position","pushpin","tack","memo","note","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 10.5859L16.5766 11.6662C16.4104 11.8324 16.3273 11.9155 16.2661 12.0145C16.2049 12.1136 16.1678 12.2251 16.0934 12.448L16.0188 12.6719C15.2405 15.0069 14.8513 16.1743 13.9897 16.5187C13.8056 16.5923 13.6116 16.6381 13.414 16.6546C12.4893 16.7319 11.6192 15.8618 9.87879 14.1214C8.13843 12.3811 7.26825 11.5109 7.34556 10.5862C7.36207 10.3886 7.40787 10.1946 7.48145 10.0105C7.82584 9.14888 8.99331 8.75972 11.3282 7.98141L11.5522 7.90676C11.7751 7.83245 11.8866 7.79529 11.9856 7.73408C12.0847 7.67286 12.1678 7.58978 12.3339 7.42361L13.4143 6.34326L13.4143 6.34325C14.081 5.67659 14.4143 5.34326 14.8285 5.34326C15.2427 5.34326 15.5761 5.67659 16.2427 6.34325L17.6569 7.75746C18.3236 8.42412 18.6569 8.75746 18.6569 9.17167C18.6569 9.58589 18.3236 9.91922 17.6569 10.5859Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","marker","note","flag","reminder","important","saved","pinned-item","display","sticky-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5355 12.7071L16.9497 11.2929M12.707 7.0503L11.2928 8.46451"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2927 8.46469L10.6209 8.68864C8.28595 9.46695 7.11848 9.85611 6.77409 10.7178C6.70052 10.9018 6.65472 11.0959 6.6382 11.2934C6.56089 12.2181 7.43108 13.0883 9.17144 14.8286V14.8286C10.9118 16.569 11.782 17.4392 12.7067 17.3619C12.9042 17.3453 13.0982 17.2995 13.2823 17.226C14.144 16.8816 14.5331 15.7141 15.3114 13.3792L15.5354 12.7073"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.17188 14.8286L6.34345 17.657"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.7069 7.05026V7.05026C11.9258 6.26921 11.9258 5.00288 12.7069 4.22184V4.22184C13.4879 3.4408 14.7542 3.44079 15.5353 4.22183L19.7779 8.46447C20.559 9.24552 20.559 10.5119 19.7779 11.2929V11.2929C18.9969 12.0739 17.7306 12.0739 16.9495 11.2929V11.2929"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","address","mark","marker","sales-location","table-location","order-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.9404 16.5147C9.50165 17.0681 9.99617 17.5344 10.4432 17.8798C11.0793 18.3712 11.8004 18.7648 12.662 18.6928C12.9669 18.6673 13.2663 18.5966 13.5504 18.4831C14.3533 18.1622 14.8222 17.4876 15.1714 16.7636C15.5112 16.059 15.8287 15.1062 16.2099 13.9628L16.386 13.4344L17.7093 12.1111C18.0179 11.8026 18.3178 11.5028 18.5319 11.2223C18.7732 10.906 19 10.4965 19 9.96802C19 9.4395 18.7732 9.03004 18.5319 8.71375C18.3178 8.4332 18.0179 8.13341 17.7093 7.82494L16.175 6.29067C15.8665 5.98208 15.5668 5.68218 15.2862 5.46813C14.9699 5.22681 14.5605 5 14.0319 5C13.5034 5 13.094 5.22682 12.7777 5.46813C12.4971 5.68219 12.1973 5.98209 11.8889 6.29068L10.5659 7.61361L10.037 7.78992C8.89354 8.17104 7.94078 8.4886 7.23616 8.82842C6.51213 9.1776 5.83759 9.64654 5.51671 10.4494C5.40316 10.7335 5.33247 11.0329 5.30698 11.3378C5.23495 12.1994 5.62857 12.9205 6.11999 13.5566C6.4654 14.0037 6.93177 14.4983 7.48529 15.0596L5.30136 17.2435C4.89955 17.6453 4.89955 18.2968 5.30136 18.6986C5.70318 19.1005 6.35465 19.1005 6.75647 18.6986L8.9404 16.5147Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","pushpin","location","map","note","reminder","mark","bookmark","highlight","important","sticky-note","pinned-note","sales-target","target-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2423 11.9998L17.6565 10.5856C18.3232 9.9189 18.6565 9.58557 18.6565 9.17135C18.6565 8.75714 18.3232 8.4238 17.6565 7.75714L16.2423 6.34293C15.5757 5.67627 15.2423 5.34294 14.8281 5.34294C14.4139 5.34294 14.0806 5.67627 13.4139 6.34294L11.9997 7.75714"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 7.75717L11.3279 7.98112C8.99298 8.75943 7.82552 9.14859 7.48113 10.0102C7.40755 10.1943 7.36175 10.3883 7.34523 10.5859C7.26792 11.5106 8.13811 12.3808 9.87847 14.1211V14.1211C11.6188 15.8615 12.489 16.7317 13.4137 16.6543C13.6113 16.6378 13.8053 16.592 13.9894 16.5184C14.851 16.1741 15.2402 15.0066 16.0185 12.6717L16.2424 11.9998"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pin 5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["pin","location","mark","note","reminder","highlight","flag","position","place","map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16V20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8H8.99999C7.89543 8 7 7.10457 7 6.00001V6.00001C7 4.89545 7.89542 4.00003 8.99998 4.00002L15 4.00001C16.1046 4 17 4.89543 17 6V6C17 7.10456 16.1046 7.99998 15 7.99999L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 5-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","pushpin","location","map","mark","reminder","notes","bulletin","sticky"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9.00021 9.99999L9.55299 8.89443C9.75846 8.4835 9.45964 7.99999 9.0002 7.99999C7.89563 7.99999 7.00021 7.10457 7.00021 6.00001C7.00021 4.89545 7.89563 4.00002 9.00019 4.00002L15.0002 4C16.1048 4 17.0002 4.89542 17.0002 5.99999C17.0002 7.10455 16.1048 7.99997 15.0002 7.99998C14.5408 7.99999 14.242 8.4835 14.4474 8.89445L15.0002 9.99999L15.1173 10.1756C16.7008 12.5508 17.4925 13.7385 17.1388 14.6941C17.0754 14.8656 16.9887 15.0276 16.8812 15.1756C16.2822 16 14.8549 16 12.0002 16H12.0002C9.14555 16 7.71821 16 7.11923 15.1756C7.01174 15.0276 6.92505 14.8657 6.86158 14.6942C6.50789 13.7385 7.29963 12.5509 8.88311 10.1756L9.00021 9.99999Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","pushpin","note","reminder","position","coordinate","store-location","delivery-area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9996 3L8.9996 3.00002C7.34275 3.00002 5.99962 4.34316 5.99962 6.00001C5.99962 7.45522 7.03574 8.66843 8.4105 8.94217L8.00966 9.68216C7.25262 10.8176 6.62906 11.7529 6.2484 12.525C5.8633 13.3061 5.59891 14.1651 5.92316 15.0413C6.01837 15.2985 6.1484 15.5415 6.30963 15.7634C6.85874 16.5191 7.72014 16.7757 8.58366 16.8885C9.22145 16.9719 10.0514 16.9929 10.9995 16.9982V20C10.9995 20.5523 11.4472 21 11.9995 21C12.5518 21 12.9995 20.5523 12.9995 20V16.9982C13.9478 16.9929 14.7778 16.9718 15.4156 16.8885C16.2791 16.7756 17.1405 16.5191 17.6896 15.7633C17.8508 15.5414 17.9809 15.2985 18.0761 15.0412C18.4003 14.1651 18.1359 13.3061 17.7508 12.525C17.3702 11.7529 16.7466 10.8177 15.9896 9.68223L15.5887 8.94216C16.9635 8.66842 17.9996 7.45521 17.9996 5.99999C17.9996 4.34314 16.6565 2.99999 14.9996 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","marker","map","address","store-location","customer-address","delivery-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8H8.99999C7.89543 8 7 7.10457 7 6.00001V6.00001C7 4.89545 7.89542 4.00003 8.99998 4.00002L15 4.00001C16.1046 4 17 4.89543 17 6V6C17 7.10456 16.1046 7.99998 15 7.99999L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","location","map","mark","sales-location","store-location","address","pinned","place","tack","reminder","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 10V8M9 8.00001V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 4.00001L8.99998 4.00002C7.89542 4.00003 7 4.89545 7 6.00001C7 7.10457 7.89543 8 8.99999 7.99999L15 7.99998C16.1046 7.99997 17 7.10455 17 5.99999C17 4.89543 16.1046 4 15 4.00001Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","mark","map","address","customer-location","push-pin","reminder","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.7977 4.02883C14.4827 3.99994 14.0903 3.99997 13.656 4L10.5477 4C10.1545 3.99997 9.7938 3.99994 9.50105 4.02673C9.19955 4.05433 8.81652 4.11994 8.47173 4.36109C8.02093 4.67639 7.7199 5.16346 7.63949 5.70768C7.578 6.12391 7.69061 6.49585 7.80076 6.77786C7.90772 7.05169 8.06907 7.37433 8.24491 7.72594L8.84592 8.92796L8.45686 9.51156C7.94157 10.2845 7.51648 10.9221 7.23018 11.4504C6.94362 11.9791 6.70487 12.5549 6.74213 13.1788C6.79441 14.0544 7.22731 14.8633 7.92687 15.3925C8.42617 15.7702 9.04052 15.8905 9.64148 15.9452C10.0256 15.9802 10.4788 15.9929 11 15.9974V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V15.9974C13.521 15.9928 13.9741 15.9802 14.358 15.9452C14.959 15.8905 15.5733 15.7702 16.0726 15.3925C16.7722 14.8633 17.2051 14.0544 17.2574 13.1788C17.2946 12.5549 17.0559 11.9791 16.7693 11.4504C16.483 10.9221 16.058 10.2845 15.5427 9.51157L15.1901 8.98267L15.8407 7.9417C16.0709 7.57345 16.2789 7.24068 16.4213 6.95827C16.5649 6.67356 16.7252 6.28659 16.6893 5.83974C16.6431 5.26501 16.3511 4.73819 15.8882 4.3944C15.5283 4.12711 15.1152 4.05796 14.7977 4.02883Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","pushpin","location","note","message","reminder","flag","mark","attach","pinned-item","bulletin","bulletin-board"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8.53019 14.595C9.06553 15 10.0436 15 11.9998 15C13.9559 15 14.934 15 15.4693 14.595C15.9357 14.2422 16.2243 13.703 16.2592 13.1192C16.2992 12.4491 15.7605 11.6411 14.6831 10.025C14.2671 9.40103 14.2552 8.59129 14.6526 7.95539L14.9698 7.448C15.4691 6.64902 15.7188 6.24954 15.6923 5.91987C15.6692 5.6325 15.5232 5.36909 15.2918 5.1972C15.0263 5 14.5552 5 13.613 5H10.5886C9.7314 5 9.3028 5 9.04466 5.18054C8.81926 5.33819 8.66874 5.58173 8.62854 5.85384C8.5825 6.16546 8.77418 6.54882 9.15754 7.31554L9.44887 7.8982L9.44888 7.89823C9.47972 7.95991 9.49514 7.99075 9.50863 8.02005C9.78952 8.63029 9.74529 9.34078 9.39087 9.91147C9.37385 9.93887 9.35472 9.96757 9.31646 10.025C8.23905 11.6411 7.70035 12.4491 7.74036 13.1192C7.77521 13.703 8.06381 14.2422 8.53019 14.595Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","location","map","mark","notes","reminder","position","location-pin","map-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.0002 9.53518V9.78891C15.0002 9.92655 15.041 10.0611 15.1173 10.1756C16.7008 12.5508 17.4925 13.7385 17.1388 14.6941C17.0754 14.8656 16.9887 15.0276 16.8812 15.1756C16.2822 16 14.8549 16 12.0002 16H12.0002C9.14555 16 7.71821 16 7.11923 15.1756C7.01174 15.0276 6.92505 14.8657 6.86158 14.6942C6.50789 13.7385 7.29963 12.5509 8.88311 10.1756C8.95947 10.0611 9.00021 9.92654 9.00021 9.7889V9.53518C9.00021 9.24263 9.00021 9.09636 8.97721 8.99097C8.92472 8.75051 8.96871 8.8541 8.83214 8.64934C8.77228 8.55961 8.38534 8.18615 7.61146 7.43923C7.23459 7.0755 7.00021 6.56512 7.00021 6C7.00021 4.89544 7.89563 4.00002 9.00019 4.00002L15.0002 4C16.1048 4 17.0002 4.89542 17.0002 5.99998C17.0002 6.5651 16.7658 7.07547 16.389 7.4392L16.3889 7.43922C15.6151 8.18614 15.2281 8.5596 15.1683 8.64934C15.0317 8.85409 15.0757 8.7505 15.0232 8.99096C15.0002 9.09635 15.0002 9.24262 15.0002 9.53518Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 4.00001L8.99998 4.00002C7.89542 4.00003 7 4.89545 7 6.00001C7 7.10457 7.89543 8 8.99999 7.99999L15 7.99998C16.1046 7.99997 17 7.10455 17 5.99999C17 4.89543 16.1046 4 15 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","marker","promotion","special","discount","note","notification","reminder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.9997 3L8.9997 3.00002C7.34286 3.00002 5.99973 4.34316 5.99973 6C5.99973 7.30622 6.83454 8.41746 7.99973 8.82929V9.69707C7.24717 10.8258 6.62739 11.7563 6.2484 12.525C5.8633 13.3061 5.59891 14.1652 5.92316 15.0413C6.01837 15.2985 6.1484 15.5415 6.30963 15.7634C6.85874 16.5192 7.72014 16.7757 8.58367 16.8885C9.23563 16.9737 10.0454 16.9938 10.9997 16.9986V20C10.9997 20.5523 11.4474 21 11.9997 21C12.552 21 12.9997 20.5523 12.9997 20V16.9986C13.9539 16.9938 14.7637 16.9737 15.4156 16.8885C16.2791 16.7757 17.1405 16.5191 17.6896 15.7634C17.8508 15.5415 17.9809 15.2985 18.0761 15.0413C18.4003 14.1651 18.1359 13.3061 17.7508 12.525C17.3719 11.7564 16.7522 10.826 15.9997 9.69739V8.82927C17.1649 8.41744 17.9997 7.3062 17.9997 5.99998C17.9997 4.34314 16.6566 3 14.9997 3ZM14.9997 5L8.99971 5.00002C8.44743 5.00002 7.99973 5.44773 7.99973 6C7.99973 6.55228 8.44744 6.99999 8.99972 6.99999L14.9997 6.99997C15.552 6.99997 15.9997 6.55226 15.9997 5.99998C15.9997 5.44771 15.552 5 14.9997 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","note","reminder","mark","flag","sales-target","address","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9L8.58114 10.2566C7.94392 12.1682 7.62531 13.1241 7.96286 13.8466C8.06896 14.0737 8.21682 14.2788 8.39873 14.4513C8.9774 15 9.98493 15 12 15V15C14.0151 15 15.0226 15 15.6013 14.4513C15.7832 14.2788 15.931 14.0737 16.0371 13.8466C16.3747 13.1241 16.0561 12.1682 15.4189 10.2566L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9L8.62127 7.48507C8.33529 6.34114 8.19229 5.76918 8.49257 5.38459C8.79285 5 9.38242 5 10.5616 5L13.4384 5C14.6176 5 15.2072 5 15.5074 5.38459C15.8077 5.76918 15.6647 6.34114 15.3787 7.48507L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11.9999 15L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "pin-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["pin","location","map","address","store","find","mark","point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9999 15L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15.4188 10.2566L15 9L15.3787 7.48507C15.6647 6.34114 15.8077 5.76918 15.5074 5.38459C15.2071 5 14.6175 5 13.4384 5H10.5615C9.38237 5 8.7928 5 8.49252 5.38459C8.19225 5.76918 8.33524 6.34114 8.62122 7.48507L8.71745 7.86998C8.85774 8.43116 8.92789 8.71175 8.91694 8.99681C8.90599 9.28188 8.81453 9.55626 8.63161 10.105L8.63161 10.105L8.58109 10.2566C7.94387 12.1682 7.62526 13.1241 7.96281 13.8466C8.06892 14.0737 8.21678 14.2788 8.39868 14.4513C8.97735 15 9.98489 15 12 15C14.015 15 15.0226 15 15.6012 14.4513C15.7831 14.2788 15.931 14.0737 16.0371 13.8466C16.3746 13.1241 16.056 12.1682 15.4188 10.2566Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pin-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","map","location","mark","position","order-destination","delivery-location","table-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9999 15L12 19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9L8.58114 10.2566C7.94392 12.1682 7.62531 13.1241 7.96286 13.8466C8.06896 14.0737 8.21682 14.2788 8.39873 14.4513C8.9774 15 9.98493 15 12 15V15C14.0151 15 15.0226 15 15.6013 14.4513C15.7832 14.2788 15.931 14.0737 16.0371 13.8466C16.3747 13.1241 16.0561 12.1682 15.4189 10.2566L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9L8.62127 7.48507C8.33529 6.34114 8.19229 5.76918 8.49257 5.38459C8.79285 5 9.38242 5 10.5616 5L13.4384 5C14.6176 5 15.2072 5 15.5074 5.38459C15.8077 5.76918 15.6647 6.34114 15.3787 7.48507L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pin-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pin","location","map","mark","marker","note","reminder","notes","important","location-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 9L9.31669 10.025C8.23928 11.6411 7.70058 12.4491 7.74059 13.1192C7.77544 13.703 8.06404 14.2422 8.53042 14.595C9.06577 15 10.0438 15 12 15V15C13.9562 15 14.9342 15 15.4696 14.595C15.936 14.2422 16.2246 13.703 16.2594 13.1192C16.2994 12.4491 15.7607 11.6411 14.6833 10.025L14 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 9L9.15777 7.31554C8.77441 6.54882 8.58273 6.16546 8.62877 5.85384C8.66898 5.58173 8.81949 5.33819 9.04489 5.18054C9.30303 5 9.73164 5 10.5889 5H13.6132C14.5554 5 15.0265 5 15.292 5.1972C15.5234 5.36909 15.6694 5.6325 15.6925 5.91987C15.719 6.24954 15.4694 6.64902 14.97 7.448L14 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "pin-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","marker","sales-location","store-location","store-map"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.4574 15.9244C14.0423 15.9739 13.5546 15.991 13 15.9969L13.0001 19C13.0001 19.5523 12.5524 20 12.0001 20C11.4478 20 11.0001 19.5523 11.0001 19L11 15.9969C10.4454 15.991 9.95767 15.9739 9.54244 15.9244C8.88157 15.8457 8.2296 15.6691 7.71061 15.177C7.43775 14.9183 7.21597 14.6105 7.0568 14.2699C6.75407 13.6219 6.79265 12.9475 6.92699 12.2957C7.05619 11.6688 7.31091 10.9048 7.61296 9.99871L7.95913 8.96021L7.63562 7.6662C7.50586 7.14755 7.38342 6.65815 7.34206 6.25123C7.29641 5.8022 7.32531 5.25449 7.70422 4.76919C8.08313 4.28389 8.60747 4.12301 9.05417 4.05839C9.45897 3.99983 9.96346 3.99992 10.4981 4.00001L13.5016 4.00001C14.0363 3.99992 14.5407 3.99983 14.9455 4.05839C15.3922 4.12301 15.9166 4.28389 16.2955 4.76919C16.6744 5.25449 16.7033 5.8022 16.6577 6.25123C16.6163 6.65814 16.4939 7.14754 16.3641 7.66617L16.0407 8.95989L16.3869 9.99873C16.689 10.9048 16.9437 11.6688 17.0729 12.2957C17.2072 12.9475 17.2458 13.6219 16.9431 14.2699C16.7839 14.6105 16.5621 14.9183 16.2893 15.177C15.7703 15.6691 15.1183 15.8457 14.4574 15.9244Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pin-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","tag","position","destination","store","address","employee","clock-in","clock-out","attendance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9L9.31669 10.025C8.23928 11.6411 7.70058 12.4491 7.74059 13.1192C7.77544 13.703 8.06404 14.2422 8.53042 14.595C9.06577 15 10.0438 15 12 15V15C13.9562 15 14.9342 15 15.4696 14.595C15.936 14.2422 16.2246 13.703 16.2594 13.1192C16.2994 12.4491 15.7607 11.6411 14.6833 10.025L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 9L9.15777 7.31554C8.77441 6.54882 8.58273 6.16546 8.62877 5.85384C8.66898 5.58173 8.81949 5.33819 9.04489 5.18054C9.30303 5 9.73164 5 10.5889 5H13.6132C14.5554 5 15.0265 5 15.292 5.1972C15.5234 5.36909 15.6694 5.6325 15.6925 5.91987C15.719 6.24954 15.4694 6.64902 14.97 7.448L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 19V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pintrest-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["pin","location","map","promotion","discount","loyalty","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0007 14.914C10.6292 15.1981 11.311 15.3447 12.0007 15.344C14.8093 15.2958 17.0475 12.9806 17.0007 10.172C17.0475 7.36336 14.8093 5.04819 12.0007 5C9.1921 5.04819 6.95393 7.36336 7.00072 10.172C6.99791 11.1755 7.28133 12.1589 7.81772 13.007"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.00098 19L10.001 14.914L11.0002 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    pin: {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","promotion","discount","loyalty","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 10V8M9 8.00001V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10L8.8829 10.1756C7.29942 12.5509 6.50768 13.7385 6.86138 14.6942C6.92484 14.8657 7.01153 15.0276 7.11902 15.1756C7.718 16 9.14534 16 12 16V16C14.8547 16 16.282 16 16.881 15.1756C16.9885 15.0276 17.0752 14.8656 17.1386 14.6942C17.4923 13.7385 16.7006 12.5509 15.1171 10.1756L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 4.00001L8.99998 4.00002C7.89542 4.00003 7 4.89545 7 6.00001C7 7.10457 7.89543 8 8.99999 7.99999L15 7.99998C16.1046 7.99997 17 7.10455 17 5.99999C17 4.89543 16.1046 4 15 4.00001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Pintrest-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["pin","location","map","mark","point","store","favorite","saved","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3097 14.2306C9.93228 14.06 9.48797 14.2276 9.31733 14.605C9.14668 14.9824 9.31431 15.4267 9.69174 15.5974L10.3097 14.2306ZM12.0007 15.344L12.0015 16.0941L12.0136 16.0939L12.0007 15.344ZM17.0007 10.172L16.2508 10.1595C16.2507 10.1678 16.2507 10.1762 16.2508 10.1845L17.0007 10.172ZM12.0007 5L12.0136 4.25011C12.005 4.24996 11.9964 4.24996 11.9879 4.25011L12.0007 5ZM7.00072 10.172L7.75072 10.1741C7.75073 10.1692 7.7507 10.1644 7.75062 10.1595L7.00072 10.172ZM7.18386 13.4079C7.40528 13.758 7.86855 13.8623 8.21862 13.6409C8.56869 13.4194 8.67299 12.9562 8.45158 12.6061L7.18386 13.4079ZM10.7292 15.0923C10.8277 14.69 10.5814 14.284 10.179 14.1855C9.77667 14.087 9.37069 14.3334 9.27222 14.7357L10.7292 15.0923ZM8.27222 18.8217C8.17375 19.224 8.42009 19.63 8.82243 19.7285C9.22477 19.827 9.63075 19.5806 9.72922 19.1783L8.27222 18.8217ZM9.26171 14.7861C9.19105 15.1942 9.46463 15.5823 9.87278 15.653C10.2809 15.7237 10.6691 15.4501 10.7397 15.0419L9.26171 14.7861ZM11.7397 9.26594C11.8104 8.8578 11.5368 8.46966 11.1287 8.39899C10.7205 8.32833 10.3324 8.60191 10.2617 9.01006L11.7397 9.26594ZM9.69174 15.5974C10.4175 15.9255 11.205 16.0949 12.0015 16.094L11.9999 14.594C11.4171 14.5946 10.8408 14.4707 10.3097 14.2306L9.69174 15.5974ZM12.0136 16.0939C15.2362 16.0386 17.8043 13.3822 17.7506 10.1595L16.2508 10.1845C16.2907 12.5791 14.3825 14.553 11.9879 14.5941L12.0136 16.0939ZM17.7506 10.1845C17.8043 6.96184 15.2362 4.30541 12.0136 4.25011L11.9879 5.74989C14.3825 5.79098 16.2907 7.76488 16.2508 10.1595L17.7506 10.1845ZM11.9879 4.25011C8.76523 4.30541 6.19714 6.96184 6.25082 10.1845L7.75062 10.1595C7.71072 7.76488 9.61898 5.79098 12.0136 5.74989L11.9879 4.25011ZM6.25072 10.1699C6.24751 11.316 6.57122 12.4393 7.18386 13.4079L8.45158 12.6061C7.99143 11.8786 7.74831 11.0349 7.75072 10.1741L6.25072 10.1699ZM9.27222 14.7357L8.27222 18.8217L9.72922 19.1783L10.7292 15.0923L9.27222 14.7357ZM10.7397 15.0419L11.7397 9.26594L10.2617 9.01006L9.26171 14.7861L10.7397 15.0419Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    Pintrest: {
        defaultColors: ["#3D4C66"],
        keywords: ["pin","location","map","mark","point","store","favorite","saved","wishlist"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3097 14.2306C9.93228 14.06 9.48797 14.2276 9.31733 14.605C9.14668 14.9824 9.31431 15.4267 9.69174 15.5974L10.3097 14.2306ZM12.0007 15.344L12.0015 16.0941L12.0136 16.0939L12.0007 15.344ZM17.0007 10.172L16.2508 10.1595C16.2507 10.1678 16.2507 10.1762 16.2508 10.1845L17.0007 10.172ZM12.0007 5L12.0136 4.25011C12.005 4.24996 11.9964 4.24996 11.9879 4.25011L12.0007 5ZM7.00072 10.172L7.75072 10.1741C7.75073 10.1692 7.7507 10.1644 7.75062 10.1595L7.00072 10.172ZM7.18386 13.4079C7.40528 13.758 7.86855 13.8623 8.21862 13.6409C8.56869 13.4194 8.67299 12.9562 8.45158 12.6061L7.18386 13.4079ZM10.7292 15.0923C10.8277 14.69 10.5814 14.284 10.179 14.1855C9.77667 14.087 9.37069 14.3334 9.27222 14.7357L10.7292 15.0923ZM8.27222 18.8217C8.17375 19.224 8.42009 19.63 8.82243 19.7285C9.22477 19.827 9.63075 19.5806 9.72922 19.1783L8.27222 18.8217ZM9.26171 14.7861C9.19105 15.1942 9.46463 15.5823 9.87278 15.653C10.2809 15.7237 10.6691 15.4501 10.7397 15.0419L9.26171 14.7861ZM11.7397 9.26594C11.8104 8.8578 11.5368 8.46966 11.1287 8.39899C10.7205 8.32833 10.3324 8.60191 10.2617 9.01006L11.7397 9.26594ZM9.69174 15.5974C10.4175 15.9255 11.205 16.0949 12.0015 16.094L11.9999 14.594C11.4171 14.5946 10.8408 14.4707 10.3097 14.2306L9.69174 15.5974ZM12.0136 16.0939C15.2362 16.0386 17.8043 13.3822 17.7506 10.1595L16.2508 10.1845C16.2907 12.5791 14.3825 14.553 11.9879 14.5941L12.0136 16.0939ZM17.7506 10.1845C17.8043 6.96184 15.2362 4.30541 12.0136 4.25011L11.9879 5.74989C14.3825 5.79098 16.2907 7.76488 16.2508 10.1595L17.7506 10.1845ZM11.9879 4.25011C8.76523 4.30541 6.19714 6.96184 6.25082 10.1845L7.75062 10.1595C7.71072 7.76488 9.61898 5.79098 12.0136 5.74989L11.9879 4.25011ZM6.25072 10.1699C6.24751 11.316 6.57122 12.4393 7.18386 13.4079L8.45158 12.6061C7.99143 11.8786 7.74831 11.0349 7.75072 10.1741L6.25072 10.1699ZM9.27222 14.7357L8.27222 18.8217L9.72922 19.1783L10.7292 15.0923L9.27222 14.7357ZM10.7397 15.0419L11.7397 9.26594L10.2617 9.01006L9.26171 14.7861L10.7397 15.0419Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Pintrest-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pinterest","social-media","pin","save","inspiration","ideas","marketing","promotions","sharing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9836 4.00015C11.995 3.99995 12.0064 3.99995 12.0179 4.00015C15.373 4.05772 18.0477 6.81885 18.0008 10.172C18.0477 13.5251 15.373 16.2863 12.0179 16.3439L12.0018 16.344C11.5677 16.3445 11.1362 16.2966 10.715 16.2019L9.97206 19.2377C9.84077 19.7742 9.29945 20.1026 8.763 19.9713C8.22655 19.84 7.8981 19.2987 8.02939 18.7623L9.02123 14.7096L10.0154 8.96741C10.1096 8.42322 10.6271 8.05844 11.1713 8.15266C11.7155 8.24687 12.0803 8.7644 11.9861 9.30859L11.1313 14.2455C11.4127 14.3105 11.7013 14.3437 11.9916 14.344C14.2444 14.301 16.0384 12.4426 16.0009 10.1887C16.0007 10.1776 16.0007 10.1664 16.0009 10.1553C16.0384 7.90444 14.2493 6.04801 12.0007 6.00018C9.75216 6.04801 7.96309 7.90444 8.00058 10.1553L8.00072 10.1748C7.99844 10.9881 8.22814 11.7851 8.66287 12.4725C8.95809 12.9392 8.81902 13.5569 8.35226 13.8521C7.8855 14.1474 7.2678 14.0083 6.97258 13.5415C6.33625 12.5355 5.99922 11.3692 6.00071 10.1789C5.95005 6.82266 8.62619 4.05776 11.9836 4.00015Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "planet-ringed-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["global","network","system","connected","international","planet","ring","worldwide","organization","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3555 5.98116C17.9203 5.5459 17.0206 5.64502 15.8678 6.16476M5.98116 18.3555C5.54591 17.9203 5.64501 17.0206 6.16473 15.8679"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.3558 5.98096C19.3809 7.00608 17.4419 10.6072 14.0248 14.0243C10.6077 17.4414 7.00657 19.3805 5.98145 18.3553"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "planet-ringed-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["global","worldwide","international","network","planet","earth","location","branch","store","satellite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 13.6113 4.47635 15.1113 5.2959 16.3669C5.14604 16.7871 5.04387 17.1999 5.01126 17.5906C4.96343 18.1637 5.05749 18.8461 5.56702 19.3556C6.16612 19.9547 6.99638 19.9819 7.65032 19.8707C8.33565 19.7541 9.09713 19.4469 9.87271 19.0293C11.4356 18.1878 13.2668 16.7822 15.0244 15.0246C16.7819 13.2671 18.1875 11.4358 19.0291 9.87295C19.4467 9.09738 19.7539 8.3359 19.8704 7.65056C19.9816 6.99663 19.9547 6.16612 19.3556 5.56702C18.8461 5.05748 18.1637 4.96343 17.5905 5.01127C17.1999 5.04387 16.7871 5.14605 16.3669 5.29589C15.1113 4.47635 13.6113 4 12 4ZM10.6599 19.8883C11.0957 19.9617 11.5434 20 12 20C16.4183 20 20 16.4183 20 12C20 11.5434 19.9617 11.0957 19.8883 10.6599C19.8685 10.6976 19.8484 10.7354 19.828 10.7732C19.0009 12.3093 17.6119 14.1214 15.8666 15.8666C14.1214 17.6119 12.3093 19.0009 10.7732 19.828C10.7354 19.8484 10.6976 19.8685 10.6599 19.8883Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "planet-ringed-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["planet","ring","global","worldwide","settings","preferences","system","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3555 5.98116C17.9203 5.5459 17.0206 5.64502 15.8678 6.16476M5.98116 18.3555C5.54591 17.9203 5.64501 17.0206 6.16473 15.8679"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.3558 5.98096C19.3809 7.00608 17.4419 10.6072 14.0248 14.0243C10.6077 17.4414 7.00657 19.3805 5.98145 18.3553"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "planet-ringed": {
        defaultColors: ["#3D4C66"],
        keywords: ["planet","ring","world","international","global","network","settings","configuration","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.8678 6.16476C17.0206 5.64502 17.9203 5.5459 18.3555 5.98116C19.3807 7.00628 17.4416 10.6074 14.0245 14.0245C10.6074 17.4416 7.00628 19.3807 5.98116 18.3555C5.54591 17.9203 5.64501 17.0206 6.16473 15.8679"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Plastic-bag-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","shopping","purchase","checkout","order","cart","package","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8994 6.99999C17.3537 6.99991 17.7907 7.00025 18.1486 7.04981C18.5531 7.10583 19.0182 7.24328 19.3885 7.64564C19.7588 8.04801 19.8572 8.52288 19.8796 8.93066C19.8995 9.29448 19.8628 9.73442 19.8247 10.1913L19.5081 14C19.5052 14 19.5024 14 19.4996 14H4.49957C4.48013 14 4.46083 14.0006 4.44167 14.0016L4.15965 10.1628C4.12628 9.70971 4.09411 9.27293 4.1172 8.91184C4.1431 8.5068 4.24495 8.03629 4.61452 7.63858C4.98409 7.24086 5.44588 7.10481 5.84792 7.04931C6.20635 6.99982 6.64432 6.99991 7.09868 6.99999L7.09972 6.99999C7.56366 4.71739 9.58419 3 11.9996 3C14.4149 3 16.4355 4.71739 16.8994 6.99999ZM14.8285 7C14.4159 5.83506 13.3033 5 11.9996 5C10.6958 5 9.58325 5.83506 9.17067 7H14.8285Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.59559 16C4.65372 16.6474 4.7218 17.2169 4.82295 17.7083C5.00131 18.5747 5.30653 19.3324 5.94987 19.9302C6.59321 20.528 7.37122 20.7769 8.24837 20.8913C9.08224 21.0001 10.1283 21 11.3929 21H12.551C13.8043 21 14.8413 21.0001 15.6688 20.8926C16.5394 20.7795 17.3121 20.5336 17.9535 19.9433C18.595 19.3529 18.9041 18.6033 19.0889 17.745C19.1966 17.245 19.2705 16.6632 19.3356 16H4.59559Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Plastic-bag-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shopping-bag","shopping","bag","checkout","purchase","order","sale","retail","cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 15H18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.4637 14.4971L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.47697 14.4396C5.67071 17.0767 5.76757 18.3953 6.63102 19.1977C7.49447 20 8.81659 20 11.4608 20H12.4843C15.1052 20 16.4156 20 17.2768 19.2075C18.138 18.4149 18.2466 17.109 18.4637 14.4971Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00851 10V8M8 8C8 5.79086 9.79444 4 12 4C14.2056 4 16 5.79086 16 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Plastic-bag": {
        defaultColors: ["#3D4C66"],
        keywords: ["shopping","bag","purchase","checkout","cart","store","retail","order","items","package","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4637 14.4971L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.47697 14.4396C5.67071 17.0767 5.76757 18.3953 6.63102 19.1977C7.49447 20 8.81659 20 11.4608 20H12.4843C15.1052 20 16.4156 20 17.2768 19.2075C18.138 18.4149 18.2466 17.109 18.4637 14.4971Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00851 10V8M8 8C8 5.79086 9.79444 4 12 4C14.2056 4 16 5.79086 16 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 15H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Plastic-bag-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bag","shopping","purchase","checkout","cart","retail","sale","order","package","plastic-bag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4637 14.4971L18.8238 10.1657C18.9081 9.15233 18.9502 8.64564 18.6531 8.32282C18.356 8 17.8476 8 16.8307 8H7.15622C6.14821 8 5.6442 8 5.34751 8.31929C5.05082 8.63858 5.08774 9.14123 5.1616 10.1465L5.47697 14.4396C5.67071 17.0767 5.76757 18.3953 6.63102 19.1977C7.49447 20 8.81659 20 11.4608 20H12.4843C15.1052 20 16.4156 20 17.2768 19.2075C18.138 18.4149 18.2466 17.109 18.4637 14.4971Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00851 10V8M8 8C8 5.79086 9.79444 4 12 4C14.2056 4 16 5.79086 16 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 15H18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "play-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","start","continue","resume","payment","checkout","initiate","begin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["play","triangle","start","resume","continue","video","audio","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","start","begin","continue","resume","sales","start-transaction","start-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.65482 7.53686C8.25397 6.78581 9.17658 6.36716 10.1363 6.41082C10.7995 6.44099 11.3861 6.78815 11.9119 7.172C12.4482 7.56353 13.095 8.12948 13.8891 8.82434L13.9571 8.8839C14.3967 9.2685 14.7728 9.59753 15.057 9.89184C15.3546 10.1999 15.6231 10.5402 15.7801 10.9691C16.0237 11.6349 16.0237 12.3655 15.7801 13.0313C15.6231 13.4602 15.3546 13.8005 15.057 14.1085C14.7728 14.4028 14.3967 14.7319 13.9572 15.1164L13.8891 15.176C13.095 15.8709 12.4482 16.4368 11.9119 16.8284C11.3861 17.2122 10.7995 17.5594 10.1363 17.5895C9.17658 17.6332 8.25397 17.2146 7.65482 16.4635C7.24083 15.9446 7.11579 15.2745 7.05846 14.626C6.99997 13.9646 6.99999 13.1052 7 12.05V11.9504C6.99999 10.8952 6.99997 10.0357 7.05846 9.37434C7.11579 8.72591 7.24082 8.05581 7.65482 7.53686Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "play-list-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["playlist","queue","music","order","menu","play-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 12L19 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 20C13.8885 19.9766 13 19.0881 13 18C13 16.9119 13.8885 16.0234 15 16C16.1115 16.0234 17 16.9119 17 18C17 19.0881 16.1115 19.9766 15 20Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["playlist","queue","play","next","items","options","list","order-details","transaction-details","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 6V12L9 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["playlist","order-list","queue","menu","options","play","arrow","list","order","checkout","items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 6V12L9 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","playlist","queues","display","browse","navigate","jump-to","playback","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.55279 5.10558C4.89157 4.93619 5.29698 4.97274 5.6 5.20001L9.6 8.20001C9.85181 8.38886 10 8.68525 10 9.00001C10 9.31476 9.85181 9.61115 9.6 9.80001L5.6 12.8C5.29698 13.0273 4.89157 13.0638 4.55279 12.8944C4.214 12.725 4 12.3788 4 12V6.00001C4 5.62123 4.214 5.27497 4.55279 5.10558Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6.00001C12 5.44772 12.4477 5.00001 13 5.00001H19C19.5523 5.00001 20 5.44772 20 6.00001C20 6.55229 19.5523 7.00001 19 7.00001H13C12.4477 7.00001 12 6.55229 12 6.00001ZM12 12C12 11.4477 12.4477 11 13 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13C12.4477 13 12 12.5523 12 12ZM4 18C4 17.4477 4.44772 17 5 17L19 17C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19L5 19C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "play-list-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","playlist","menu","options","entertainment","audio","jukebox","background-music","select-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L5 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 12L19 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 20C13.8885 19.9766 13 19.0881 13 18C13 16.9119 13.8885 16.0234 15 16C16.1115 16.0234 17 16.9119 17 18C17 19.0881 16.1115 19.9766 15 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["list","add","new-item","new","add-item","menu","create","plus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L15 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 20"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["queue","playlist","order-list","pending-orders","list","transaction-history","display-queue","display","view","menu","play","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L5 6V12L9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","queue","playlist","entertainment","ambiance","menu","options","settings","background-music","audio","restaurant-playlist","store-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6ZM4 12C4 11.4477 4.44772 11 5 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H5C4.44772 13 4 12.5523 4 12ZM4 18C4 17.4477 4.44772 17 5 17H9C9.55228 17 10 17.4477 10 18C10 18.5523 9.55228 19 9 19H5C4.44772 19 4 18.5523 4 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.6173 11.0761C16.991 10.9213 17.4211 11.0069 17.7071 11.2929L19.7071 13.2929C20.0976 13.6834 20.0976 14.3166 19.7071 14.7071C19.3166 15.0976 18.6834 15.0976 18.2929 14.7071L18 14.4142V18C18 19.6517 16.6567 20.9654 15.021 20.9998C15.007 21.0001 14.993 21.0001 14.979 20.9998C13.3433 20.9654 12 19.6517 12 18C12 16.3483 13.3433 15.0346 14.979 15.0002C14.993 14.9999 15.007 14.9999 15.021 15.0002C15.3634 15.0074 15.6929 15.0707 16 15.1813V12C16 11.5955 16.2436 11.2309 16.6173 11.0761ZM16 18C16 17.4818 15.5765 17.0232 15 17.0004C14.4235 17.0232 14 17.4818 14 18C14 18.5182 14.4235 18.9768 15 18.9996C15.5765 18.9768 16 18.5182 16 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "play-list-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","add","new-item","new","create","menu","menu-add","add-item","options","add-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 7H19C19.55 7 20 6.55 20 6C20 5.45 19.55 5 19 5H5C4.45 5 4 5.45 4 6C4 6.55 4.45 7 5 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 17H5C4.45 17 4 17.45 4 18C4 18.55 4.45 19 5 19H11C11.55 19 12 18.55 12 18C12 17.45 11.55 17 11 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 17H18V16C18 15.45 17.55 15 17 15C16.45 15 16 15.45 16 16V17H15C14.45 17 14 17.45 14 18C14 18.55 14.45 19 15 19H16V20C16 20.55 16.45 21 17 21C17.55 21 18 20.55 18 20V19H19C19.55 19 20 18.55 20 18C20 17.45 19.55 17 19 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "play-list-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","add","new-item","create","plus","new","menu","options","add-item","add-menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 18L5 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L15 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","add","plus","items","menu","new","create","playlist","add-item","add-menu","add-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 18L15 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16L17 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["playlist","music","queue","menu","options","entertainment","audio","song-list","jukebox","background-music","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 12H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18L5 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18L17 12L19 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 20C13.8885 19.9766 13 19.0881 13 18C13 16.9119 13.8885 16.0234 15 16C16.1115 16.0234 17 16.9119 17 18C17 19.0881 16.1115 19.9766 15 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-pause-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["play","pause","resume","on-hold","order","transaction","process","start","stop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.268 9.60952L10.268 9.60953C11.1994 10.4245 11.665 10.8319 11.841 11.3126C12.0034 11.7565 12.0034 12.2435 11.841 12.6874C11.665 13.1681 11.1994 13.5755 10.268 14.3905C8.61614 15.8359 7.79019 16.5586 7.0909 16.5904C6.45106 16.6195 5.83598 16.3404 5.43655 15.8397C5 15.2925 5 14.195 5 12C5 9.80501 5 8.70752 5.43655 8.16029C5.83598 7.6596 6.45105 7.38049 7.0909 7.4096C7.79019 7.44142 8.61614 8.16412 10.268 9.60952Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-pause-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","pause","media","control","transaction","resume","suspend","start","stop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 7C18.4477 7 18 7.44772 18 8V16C18 16.5523 18.4477 17 19 17C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5 7C14.9477 7 14.5 7.44772 14.5 8V16C14.5 16.5523 14.9477 17 15.5 17C16.0523 17 16.5 16.5523 16.5 16V8C16.5 7.44772 16.0523 7 15.5 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.986 8.65663L10.9177 8.59275C10.1203 7.84725 9.47077 7.24004 8.93228 6.81998C8.40434 6.40816 7.81528 6.0357 7.14935 6.00333C6.18561 5.95649 5.25917 6.40565 4.65754 7.21143C4.24182 7.7682 4.11627 8.48712 4.0587 9.18281C3.99998 9.8924 3.99999 10.8144 4 11.9465V12.0534C3.99999 13.1855 3.99998 14.1076 4.0587 14.8172C4.11627 15.5129 4.24182 16.2318 4.65754 16.7886C5.25917 17.5944 6.18561 18.0435 7.14936 17.9967C7.81528 17.9643 8.40435 17.5918 8.93228 17.18C9.47077 16.76 10.1202 16.1528 10.9176 15.4073L10.986 15.3433C11.4274 14.9307 11.805 14.5777 12.0905 14.262C12.3892 13.9315 12.6588 13.5664 12.8165 13.1062C13.0612 12.3919 13.0612 11.6081 12.8165 10.8938C12.6588 10.4336 12.3892 10.0685 12.0905 9.73803C11.805 9.42226 11.4274 9.06925 10.986 8.65663Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "play-pause-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["play","pause","resume","hold","transaction","suspend","playback","control","video","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.268 9.60952L10.268 9.60953C11.1994 10.4245 11.665 10.8319 11.841 11.3126C12.0034 11.7565 12.0034 12.2435 11.841 12.6874C11.665 13.1681 11.1994 13.5755 10.268 14.3905C8.61614 15.8359 7.79019 16.5586 7.0909 16.5904C6.45106 16.6195 5.83598 16.3404 5.43655 15.8397C5 15.2925 5 14.195 5 12C5 9.80501 5 8.70752 5.43655 8.16029C5.83598 7.6596 6.45105 7.38049 7.0909 7.4096C7.79019 7.44142 8.61614 8.16412 10.268 9.60952Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    play: {
        defaultColors: ["#3D4C66"],
        keywords: ["play","pause","resume","hold","transaction","suspend","playback","control","video","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.268 9.60952L13.268 9.60953C14.1994 10.4245 14.665 10.8319 14.841 11.3126C15.0034 11.7565 15.0034 12.2435 14.841 12.6874C14.665 13.1681 14.1994 13.5755 13.268 14.3905C11.6161 15.8359 10.7902 16.5586 10.0909 16.5904C9.45106 16.6195 8.83598 16.3404 8.43655 15.8397C8 15.2925 8 14.195 8 12C8 9.80501 8 8.70752 8.43655 8.16029C8.83598 7.6596 9.45105 7.38049 10.0909 7.4096C10.7902 7.44142 11.6161 8.16412 13.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "play-pause": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","pause","resume","hold","suspend","payment-hold","order-pause","transaction-hold","order-resume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 16V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.268 9.60952L10.268 9.60953C11.1994 10.4245 11.665 10.8319 11.841 11.3126C12.0034 11.7565 12.0034 12.2435 11.841 12.6874C11.665 13.1681 11.1994 13.5755 10.268 14.3905C8.61614 15.8359 7.79019 16.5586 7.0909 16.5904C6.45106 16.6195 5.83598 16.3404 5.43655 15.8397C5 15.2925 5 14.195 5 12C5 9.80501 5 8.70752 5.43655 8.16029C5.83598 7.6596 6.45105 7.38049 7.0909 7.4096C7.79019 7.44142 8.61614 8.16412 10.268 9.60952Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "playstore-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["play","video","arrow","right","media","start","run","content","application","app","integration","external-app","cross"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19L14 9.30798M5 5L14 14.693"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M5 19V5L19 12L5 19Z" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "playstore-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","arrow","right","proceed","continue","playback","launch","start","payment","transaction","confirm","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 5.32323V18.6092L10.1258 11.8186L4 5.32323Z" fill={colors?.[0] || "#3D4C66"} />
                <path d="M5.45851 20L13.8302 15.7465L11.5125 13.289L5.45851 20Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M15.703 14.795L19.4472 12.8927C19.786 12.7206 20 12.3687 20 11.9838C20 11.5989 19.786 11.2471 19.4472 11.075L15.3758 9.00639L12.8668 11.7877L15.703 14.795Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M13.5154 8.06115L5.52218 4L11.4801 10.3173L13.5154 8.06115Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "playstore-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["play","arrow","triangle","start","update","app","install","download"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19V5L19 12L5 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 19L14 9.30798L5 19ZM5 5L14 14.693L5 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M5 19L14 9.30798M5 5L14 14.693"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "plug-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["plug","connector","power","connection","electrical","adapter","electricity","on","enable","connect","source"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H10C9.05719 14 8.58579 14 8.29289 13.7071C8 13.4142 8 12.9428 8 12C8 11.0572 8 10.5858 8.29289 10.2929C8.58579 10 9.05719 10 10 10H14C14.9428 10 15.4142 10 15.7071 10.2929C16 10.5858 16 11.0572 16 12C16 12.9428 16 13.4142 15.7071 13.7071C15.4142 14 14.9428 14 14 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    playstore: {
        defaultColors: ["#3D4C66"],
        keywords: ["plug","connector","power","connection","electrical","adapter","electricity","on","enable","connect","source"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 19V5L19 12L5 19Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M5 19L14 9.30798M5 5L14 14.693"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    plug: {
        defaultColors: ["#3D4C66"],
        keywords: ["plug","connector","power","connection","electrical","adapter","electricity","on","enable","connect","source"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H10C9.05719 14 8.58579 14 8.29289 13.7071C8 13.4142 8 12.9428 8 12C8 11.0572 8 10.5858 8.29289 10.2929C8.58579 10 9.05719 10 10 10H14C14.9428 10 15.4142 10 15.7071 10.2929C16 10.5858 16 11.0572 16 12C16 12.9428 16 13.4142 15.7071 13.7071C15.4142 14 14.9428 14 14 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "plug-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["plug","connect","connection","power","integration","module","extension","add-on"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 14H10C9.05719 14 8.58579 14 8.29289 13.7071C8 13.4142 8 12.9428 8 12C8 11.0572 8 10.5858 8.29289 10.2929C8.58579 10 9.05719 10 10 10H14C14.9428 10 15.4142 10 15.7071 10.2929C16 10.5858 16 11.0572 16 12C16 12.9428 16 13.4142 15.7071 13.7071C15.4142 14 14.9428 14 14 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "plug-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["plug","connection","connect","power","device","electricity","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9973 13.2201C14.7866 13.2484 14.4926 13.25 14 13.25H10C9.5074 13.25 9.21339 13.2484 9.00267 13.2201C8.90611 13.2071 8.85775 13.1918 8.83597 13.1828C8.83305 13.1816 8.83071 13.1806 8.82888 13.1797C8.82755 13.1791 8.82649 13.1786 8.82568 13.1781L8.82324 13.1768L8.82187 13.1743C8.82086 13.1724 8.81924 13.1691 8.81717 13.164C8.80821 13.1423 8.79291 13.0939 8.77993 12.9973C8.7516 12.7866 8.75001 12.4926 8.75001 12C8.75001 11.5074 8.7516 11.2134 8.77993 11.0027C8.79291 10.9061 8.80821 10.8577 8.81717 10.836C8.81924 10.8309 8.82086 10.8276 8.82187 10.8257L8.82324 10.8232L8.82568 10.8219C8.82761 10.8209 8.83093 10.8192 8.83597 10.8172C8.85775 10.8082 8.90611 10.7929 9.00267 10.7799C9.21339 10.7516 9.5074 10.75 10 10.75H14C14.4926 10.75 14.7866 10.7516 14.9973 10.7799C15.0939 10.7929 15.1423 10.8082 15.164 10.8172C15.1691 10.8192 15.1724 10.8209 15.1743 10.8219L15.1768 10.8232L15.1781 10.8257C15.1792 10.8276 15.1808 10.8309 15.1828 10.836C15.1918 10.8577 15.2071 10.9061 15.2201 11.0027C15.2484 11.2134 15.25 11.5074 15.25 12C15.25 12.4926 15.2484 12.7866 15.2201 12.9973C15.2071 13.0939 15.1918 13.1423 15.1828 13.164C15.1818 13.1665 15.1809 13.1686 15.1801 13.1703C15.1793 13.172 15.1787 13.1734 15.1781 13.1743L15.1768 13.1768L15.1743 13.1781C15.1724 13.1791 15.1691 13.1808 15.164 13.1828C15.1423 13.1918 15.0939 13.2071 14.9973 13.2201Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM10.75 8C10.75 7.58579 10.4142 7.25 10 7.25C9.58579 7.25 9.25001 7.58579 9.25001 8V9.25823C9.08958 9.26433 8.93955 9.27491 8.8028 9.2933C8.44732 9.34109 8.07159 9.45354 7.76257 9.76256C7.45355 10.0716 7.3411 10.4473 7.29331 10.8028C7.24991 11.1256 7.24995 11.5224 7.25 11.9552V12.0447C7.24995 12.4776 7.24991 12.8744 7.29331 13.1972C7.3411 13.5527 7.45355 13.9284 7.76257 14.2374C8.07159 14.5465 8.44732 14.6589 8.8028 14.7067C9.12561 14.7501 9.52244 14.7501 9.95525 14.75L11.25 14.75V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V14.75L14.0448 14.75C14.4776 14.7501 14.8744 14.7501 15.1972 14.7067C15.5527 14.6589 15.9284 14.5465 16.2374 14.2374C16.5465 13.9284 16.6589 13.5527 16.7067 13.1972C16.7501 12.8744 16.7501 12.4776 16.75 12.0448V11.9553C16.7501 11.5224 16.7501 11.1256 16.7067 10.8028C16.6589 10.4473 16.5465 10.0716 16.2374 9.76256C15.9284 9.45354 15.5527 9.34109 15.1972 9.2933C15.0605 9.27491 14.9104 9.26433 14.75 9.25823V8C14.75 7.58579 14.4142 7.25 14 7.25C13.5858 7.25 13.25 7.58579 13.25 8V9.25H10.75V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "popsicle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["popsicle","dessert","ice-cream","treat","menu","food","item","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V16H6V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 10L12 20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "popsicle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["popsicle","ice-cream","dessert","treat","food","sweet","item","menu-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10V16H6V10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 10L12 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "printer-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["printer","print","receipt","print-receipt","device","thermal-printer","pos-printer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.4444 5H11.5556C10.0981 5 9.3694 5 8.85285 5.3617C8.66174 5.49551 8.49551 5.66174 8.3617 5.85285C8 6.3694 8 7.09812 8 8.55556C8 8.80102 8.19898 9 8.44444 9H15.5556C15.801 9 16 8.80102 16 8.55556C16 7.09812 16 6.3694 15.6383 5.85285C15.5045 5.66174 15.3383 5.49551 15.1472 5.3617C14.6306 5 13.9019 5 12.4444 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19H10C8.13077 19 7.19615 19 6.5 18.5981C6.04394 18.3348 5.66523 17.9561 5.40192 17.5C5 16.8038 5 15.8692 5 14C5 12.1308 5 11.1962 5.40192 10.5C5.66523 10.0439 6.04394 9.66523 6.5 9.40192C7.19615 9 8.13077 9 10 9H14C15.8692 9 16.8038 9 17.5 9.40192C17.9561 9.66523 18.3348 10.0439 18.5981 10.5C19 11.1962 19 12.1308 19 14C19 15.8692 19 16.8038 18.5981 17.5C18.3348 17.9561 17.9561 18.3348 17.5 18.5981C16.8038 19 15.8692 19 14 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "popsicle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["popsicle","ice-cream","dessert","treat","food","menu-item","order","add-item","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V16C19 16.5523 18.5523 17 18 17H13L13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10L11 17H6C5.44772 17 5 16.5523 5 16V10ZM11 17H13V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    popsicle: {
        defaultColors: ["#3D4C66"],
        keywords: ["popsicle","ice-cream","dessert","treat","food","menu-item","order","add-item","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V16H6V10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 10L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "printer-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["printer","receipt","print","transaction","print-receipt","thermal-printer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5051 4H12.4949C13.1805 3.99997 13.7717 3.99995 14.2535 4.05073C14.7648 4.10462 15.2666 4.22459 15.7207 4.54255C16.0074 4.74328 16.2567 4.99261 16.4575 5.27927C16.7754 5.73336 16.8954 6.23523 16.9493 6.74655C16.9623 6.8697 16.9719 7 16.9791 7.1372C16.774 7.10134 16.5705 7.07655 16.3704 7.05841C15.7248 6.9999 14.9461 6.99995 14.0805 7H9.91956C9.05397 6.99995 8.27518 6.9999 7.62958 7.05841C7.42948 7.07655 7.22602 7.10134 7.0209 7.1372C7.02808 7 7.03775 6.8697 7.05073 6.74655C7.10462 6.23523 7.22459 5.73336 7.54255 5.27927C7.74327 4.99261 7.99261 4.74328 8.27927 4.54255C8.73336 4.22459 9.23523 4.10462 9.74655 4.05073C10.2283 3.99995 10.8195 3.99997 11.5051 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.95396 8H14.046C14.9415 7.99999 15.6805 7.99997 16.2802 8.05432C16.9039 8.11085 17.4744 8.23242 18 8.5359C18.6081 8.88697 19.113 9.39193 19.4641 10C19.7676 10.5256 19.8892 11.0961 19.9457 11.7198C20 12.3195 20 13.0585 20 13.9539V14.0461C20 14.9415 20 15.6805 19.9457 16.2802C19.8892 16.9039 19.7676 17.4744 19.4641 18C19.113 18.6081 18.6081 19.113 18 19.4641C17.4744 19.7676 16.9039 19.8892 16.2802 19.9457C15.6805 20 14.9415 20 14.0461 20H9.95394C9.05849 20 8.31952 20 7.71983 19.9457C7.09615 19.8892 6.52565 19.7676 6 19.4641C5.39193 19.113 4.88697 18.6081 4.5359 18C4.23242 17.4744 4.11085 16.9039 4.05432 16.2802C3.99997 15.6805 3.99999 14.9415 4 14.0461V13.9539C3.99999 13.0585 3.99997 12.3195 4.05432 11.7198C4.11085 11.0961 4.23242 10.5256 4.5359 10C4.88697 9.39193 5.39193 8.88697 6 8.5359C6.52564 8.23242 7.09615 8.11085 7.71983 8.05432C8.31952 7.99997 9.0585 7.99999 9.95396 8ZM14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "printer-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["suitcase","briefcase","bag","report","summary","business","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9V9C8 7.11438 8 6.17157 8.58579 5.58579C9.17157 5 10.1144 5 12 5V5C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17157 16 7.11438 16 9V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10C8.13077 19 7.19615 19 6.5 18.5981C6.04394 18.3348 5.66523 17.9561 5.40192 17.5C5 16.8038 5 15.8692 5 14C5 12.1308 5 11.1962 5.40192 10.5C5.66523 10.0439 6.04394 9.66523 6.5 9.40192C7.19615 9 8.13077 9 10 9H14C15.8692 9 16.8038 9 17.5 9.40192C17.9561 9.66523 18.3348 10.0439 18.5981 10.5C19 11.1962 19 12.1308 19 14C19 15.8692 19 16.8038 18.5981 17.5C18.3348 17.9561 17.9561 18.3348 17.5 18.5981C16.8038 19 15.8692 19 14 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    printer: {
        defaultColors: ["#3D4C66"],
        keywords: ["suitcase","briefcase","bag","report","summary","business","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 12H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10C8.13077 19 7.19615 19 6.5 18.5981C6.04394 18.3348 5.66523 17.9561 5.40192 17.5C5 16.8038 5 15.8692 5 14C5 12.1308 5 11.1962 5.40192 10.5C5.66523 10.0439 6.04394 9.66523 6.5 9.40192C7.19615 9 8.13077 9 10 9H14C15.8692 9 16.8038 9 17.5 9.40192C17.9561 9.66523 18.3348 10.0439 18.5981 10.5C19 11.1962 19 12.1308 19 14C19 15.8692 19 16.8038 18.5981 17.5C18.3348 17.9561 17.9561 18.3348 17.5 18.5981C16.8038 19 15.8692 19 14 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 9V9C8 7.11438 8 6.17157 8.58579 5.58579C9.17157 5 10.1144 5 12 5V5C13.8856 5 14.8284 5 15.4142 5.58579C16 6.17157 16 7.11438 16 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "pro-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["pro","professional","upgrade","premium","enhanced","features","advanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10V9.25C10.5858 9.25 10.25 9.58579 10.25 10L11 10ZM11 12H10.25H11ZM10.25 14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14H10.25ZM11 10.75H12V9.25H11V10.75ZM12 11.25H11V12.75H12V11.25ZM11.75 12V10L10.25 10V12H11.75ZM10.25 12V14H11.75V12H10.25ZM12 10.75C12.1381 10.75 12.25 10.8619 12.25 11H13.75C13.75 10.0335 12.9665 9.25 12 9.25V10.75ZM12 12.75C12.9665 12.75 13.75 11.9665 13.75 11H12.25C12.25 11.1381 12.1381 11.25 12 11.25V12.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M7 10V9.25C6.58579 9.25 6.25 9.58579 6.25 10L7 10ZM7 12H6.25H7ZM6.25 14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14H6.25ZM7 10.75H8V9.25H7V10.75ZM8 11.25H7V12.75H8V11.25ZM7.75 12V10L6.25 10V12H7.75ZM6.25 12V14H7.75V12H6.25ZM8 10.75C8.13807 10.75 8.25 10.8619 8.25 11H9.75C9.75 10.0335 8.9665 9.25 8 9.25V10.75ZM8 12.75C8.9665 12.75 9.75 11.9665 9.75 11H8.25C8.25 11.1381 8.13807 11.25 8 11.25V12.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M11.5303 11.4697C11.2374 11.1768 10.7626 11.1768 10.4697 11.4697C10.1768 11.7626 10.1768 12.2374 10.4697 12.5303L11.5303 11.4697ZM12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L12.4697 14.5303ZM10.4697 12.5303L12.4697 14.5303L13.5303 13.4697L11.5303 11.4697L10.4697 12.5303Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15.75 13V11H14.25V13H15.75ZM16.25 11V13H17.75V11H16.25ZM16 10.75C16.1381 10.75 16.25 10.8619 16.25 11H17.75C17.75 10.0335 16.9665 9.25 16 9.25V10.75ZM16 14.75C16.9665 14.75 17.75 13.9665 17.75 13H16.25C16.25 13.1381 16.1381 13.25 16 13.25V14.75ZM16 13.25C15.8619 13.25 15.75 13.1381 15.75 13H14.25C14.25 13.9665 15.0335 14.75 16 14.75V13.25ZM16 9.25C15.0335 9.25 14.25 10.0335 14.25 11H15.75C15.75 10.8619 15.8619 10.75 16 10.75V9.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "pro-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["pro","professional","upgrade","premium","features","benefits","advanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 10V9.25C10.5858 9.25 10.25 9.58579 10.25 10L11 10ZM11 12H10.25H11ZM10.25 14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14H10.25ZM11 10.75H12V9.25H11V10.75ZM12 11.25H11V12.75H12V11.25ZM11.75 12V10L10.25 10V12H11.75ZM10.25 12V14H11.75V12H10.25ZM12 10.75C12.1381 10.75 12.25 10.8619 12.25 11H13.75C13.75 10.0335 12.9665 9.25 12 9.25V10.75ZM12 12.75C12.9665 12.75 13.75 11.9665 13.75 11H12.25C12.25 11.1381 12.1381 11.25 12 11.25V12.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M7 10V9.25C6.58579 9.25 6.25 9.58579 6.25 10L7 10ZM7 12H6.25H7ZM6.25 14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14H6.25ZM7 10.75H8V9.25H7V10.75ZM8 11.25H7V12.75H8V11.25ZM7.75 12V10L6.25 10V12H7.75ZM6.25 12V14H7.75V12H6.25ZM8 10.75C8.13807 10.75 8.25 10.8619 8.25 11H9.75C9.75 10.0335 8.9665 9.25 8 9.25V10.75ZM8 12.75C8.9665 12.75 9.75 11.9665 9.75 11H8.25C8.25 11.1381 8.13807 11.25 8 11.25V12.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M11.5303 11.4697C11.2374 11.1768 10.7626 11.1768 10.4697 11.4697C10.1768 11.7626 10.1768 12.2374 10.4697 12.5303L11.5303 11.4697ZM12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L12.4697 14.5303ZM10.4697 12.5303L12.4697 14.5303L13.5303 13.4697L11.5303 11.4697L10.4697 12.5303Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M15.75 13V11H14.25V13H15.75ZM16.25 11V13H17.75V11H16.25ZM16 10.75C16.1381 10.75 16.25 10.8619 16.25 11H17.75C17.75 10.0335 16.9665 9.25 16 9.25V10.75ZM16 14.75C16.9665 14.75 17.75 13.9665 17.75 13H16.25C16.25 13.1381 16.1381 13.25 16 13.25V14.75ZM16 13.25C15.8619 13.25 15.75 13.1381 15.75 13H14.25C14.25 13.9665 15.0335 14.75 16 14.75V13.25ZM16 9.25C15.0335 9.25 14.25 10.0335 14.25 11H15.75C15.75 10.8619 15.8619 10.75 16 10.75V9.25Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    pro: {
        defaultColors: ["#3D4C66"],
        keywords: ["pro","professional","upgrade","premium","features","benefits","advanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 10V9.25C10.5858 9.25 10.25 9.58579 10.25 10L11 10ZM11 12H10.25H11ZM10.25 14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14H10.25ZM11 10.75H12V9.25H11V10.75ZM12 11.25H11V12.75H12V11.25ZM11.75 12V10L10.25 10V12H11.75ZM10.25 12V14H11.75V12H10.25ZM12 10.75C12.1381 10.75 12.25 10.8619 12.25 11H13.75C13.75 10.0335 12.9665 9.25 12 9.25V10.75ZM12 12.75C12.9665 12.75 13.75 11.9665 13.75 11H12.25C12.25 11.1381 12.1381 11.25 12 11.25V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 10V9.25C6.58579 9.25 6.25 9.58579 6.25 10L7 10ZM7 12H6.25H7ZM6.25 14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14H6.25ZM7 10.75H8V9.25H7V10.75ZM8 11.25H7V12.75H8V11.25ZM7.75 12V10L6.25 10V12H7.75ZM6.25 12V14H7.75V12H6.25ZM8 10.75C8.13807 10.75 8.25 10.8619 8.25 11H9.75C9.75 10.0335 8.9665 9.25 8 9.25V10.75ZM8 12.75C8.9665 12.75 9.75 11.9665 9.75 11H8.25C8.25 11.1381 8.13807 11.25 8 11.25V12.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.5303 11.4697C11.2374 11.1768 10.7626 11.1768 10.4697 11.4697C10.1768 11.7626 10.1768 12.2374 10.4697 12.5303L11.5303 11.4697ZM12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L12.4697 14.5303ZM10.4697 12.5303L12.4697 14.5303L13.5303 13.4697L11.5303 11.4697L10.4697 12.5303Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 13V11H14.25V13H15.75ZM16.25 11V13H17.75V11H16.25ZM16 10.75C16.1381 10.75 16.25 10.8619 16.25 11H17.75C17.75 10.0335 16.9665 9.25 16 9.25V10.75ZM16 14.75C16.9665 14.75 17.75 13.9665 17.75 13H16.25C16.25 13.1381 16.1381 13.25 16 13.25V14.75ZM16 13.25C15.8619 13.25 15.75 13.1381 15.75 13H14.25C14.25 13.9665 15.0335 14.75 16 14.75V13.25ZM16 9.25C15.0335 9.25 14.25 10.0335 14.25 11H15.75C15.75 10.8619 15.8619 10.75 16 10.75V9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "pro-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pro","premium","upgrade","enhanced","features","professional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 11.25H7.75V10.75H8C8.13807 10.75 8.25 10.8619 8.25 11C8.25 11.1381 8.13807 11.25 8 11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 10.75H11.75V11.25H12C12.1381 11.25 12.25 11.1381 12.25 11C12.25 10.8619 12.1381 10.75 12 10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 11C15.75 10.8619 15.8619 10.75 16 10.75C16.1381 10.75 16.25 10.8619 16.25 11V13C16.25 13.1381 16.1381 13.25 16 13.25C15.8619 13.25 15.75 13.1381 15.75 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4H15C17.8284 4 19.2426 4 20.1213 4.87868C21 5.75736 21 7.17157 21 10V14C21 16.8284 21 18.2426 20.1213 19.1213C19.2426 20 17.8284 20 15 20H9C6.17157 20 4.75736 20 3.87868 19.1213C3 18.2426 3 16.8284 3 14V10C3 7.17157 3 5.75736 3.87868 4.87868C4.75736 4 6.17157 4 9 4ZM7 9.25C6.58579 9.25 6.25 9.58579 6.25 10V14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14V12.75H8C8.9665 12.75 9.75 11.9665 9.75 11C9.75 10.0335 8.9665 9.25 8 9.25H7ZM11 9.25C10.5858 9.25 10.25 9.58579 10.25 10V14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14V13.8107L12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L12.6755 12.6149C13.3066 12.3505 13.75 11.727 13.75 11C13.75 10.0335 12.9665 9.25 12 9.25H11ZM16 9.25C15.0335 9.25 14.25 10.0335 14.25 11V13C14.25 13.9665 15.0335 14.75 16 14.75C16.9665 14.75 17.75 13.9665 17.75 13V11C17.75 10.0335 16.9665 9.25 16 9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "product add-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","add","plus","product","add-product","inventory","add-inventory","new-stock","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M16.5 14V19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product add": {
        defaultColors: ["#000000"],
        keywords: ["product","add","new-product","create","plus","new","item","add-item","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 14V19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product add-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["add","plus","increase","new","create","addition","positive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 14V19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16.5H19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product check-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","check","tick","order","delivered","inventory","stock","approved","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.28571"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.914 15.386L16.7094 15.5905L16.3003 15.9996L15.4822 16.8178L15.0731 16.4087L14.8685 16.2042L14.8174 16.153"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product add-3": {
        defaultColors: ["#000000"],
        keywords: ["add","new","create","plus","product","item","add-item","new-product","add-product","create-product","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.102 19.75 15.1516 19.75 15.2007C19.5294 15.0731 19.2732 15 19 15H18V14C18 13.1716 17.3284 12.5 16.5 12.5C15.6716 12.5 15 13.1716 15 14V15H14C13.1716 15 12.5 15.6716 12.5 16.5C12.5 17.3284 13.1716 18 14 18H15V19C15 19.2732 15 19.5 15 19.75L8.94806 19.75C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 13.25C16.9142 13.25 17.25 13.5858 17.25 14V15.75H19C19.4142 15.75 19.75 16.0858 19.75 16.5C19.75 16.9142 19.4142 17.25 19 17.25H17.25V19C17.25 19.4142 16.9142 19.75 16.5 19.75C16.0858 19.75 15.75 19.4142 15.75 19V17.25H14C13.5858 17.25 13.25 16.9142 13.25 16.5C13.25 16.0858 13.5858 15.75 14 15.75H15.75V14C15.75 13.5858 16.0858 13.25 16.5 13.25Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product check-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["check","checkmark","validate","verify","confirmation","approve","success","completed","confirmed","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5661 14.7837L16.3275 15.0223L15.8502 15.4996L14.8957 16.4541L14.4184 15.9769L14.1798 15.7382L14.1201 15.6786"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15.5C19 13.567 17.433 12 15.5 12C13.567 12 12 13.567 12 15.5C12 17.433 13.567 19 15.5 19C17.433 19 19 17.433 19 15.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product check": {
        defaultColors: ["#000000"],
        keywords: ["product","check","verify","inventory","stock","available","product-check","inventory-check","stock-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5661 14.7837L16.3275 15.0223L15.8502 15.4996L14.8957 16.4541L14.4184 15.9769L14.1798 15.7382L14.1201 15.6786"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 15.5C19 13.567 17.433 12 15.5 12C13.567 12 12 13.567 12 15.5C12 17.433 13.567 19 15.5 19C17.433 19 19 17.433 19 15.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product check-3": {
        defaultColors: ["#000000"],
        keywords: ["product","check","verified","inventory","stock","confirmation","item","availability","checked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V13.8384C18.9833 12.7278 17.7016 12 16.25 12C13.9028 12 12 13.9028 12 16.25C12 17.7016 12.7278 18.9833 13.8384 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 16.25C13 14.4551 14.4551 13 16.25 13C18.0449 13 19.5 14.4551 19.5 16.25C19.5 18.0449 18.0449 19.5 16.25 19.5C14.4551 19.5 13 18.0449 13 16.25ZM17.6005 15.2556C17.3594 15.0144 16.9683 15.0144 16.7272 15.2556L15.7884 16.1944L15.5865 15.9924C15.3453 15.7513 14.9543 15.7513 14.7131 15.9924C14.4719 16.2336 14.4719 16.6246 14.7131 16.8658L15.3517 17.5044C15.4675 17.6202 15.6246 17.6853 15.7884 17.6853C15.9522 17.6853 16.1093 17.6202 16.2251 17.5044L17.6005 16.1289C17.8417 15.8878 17.8417 15.4968 17.6005 15.2556Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product click-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["click","select","choose","arrow","pointer","submit","confirm","next","proceed","done"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9217 15.9217L16.3087 15.68C17.4403 14.9737 18.006 14.6205 17.9251 14.2139C17.8442 13.8074 17.1863 13.6977 15.8706 13.4784L14.6571 13.2762C13.9017 13.1503 13.524 13.0873 13.3057 13.3057C13.0873 13.524 13.1503 13.9017 13.2762 14.6571L13.4784 15.8706C13.6977 17.1863 13.8074 17.8442 14.2139 17.9251C14.6205 18.006 14.9737 17.4403 15.68 16.3087L15.9217 15.9217ZM15.9217 15.9217L17.7108 17.7108L18.6054 18.6054"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product disable-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","disable","out-of-stock","unavailable","remove-product","blocked","package","box","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16.5C19 17.8836 17.8836 19 16.5 19C15.1164 19 14 17.8836 14 16.5C14 15.1164 15.1164 14 16.5 14C17.8836 14 19 15.1164 19 16.5Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.8335 18.1666L18.1668 14.8333"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product click": {
        defaultColors: ["#000000"],
        keywords: ["product","item","select","choose","add-item","add-product","inventory","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9217 15.9217L16.3087 15.68C17.4403 14.9737 18.006 14.6205 17.9251 14.2139C17.8442 13.8074 17.1863 13.6977 15.8706 13.4784L14.6571 13.2762C13.9017 13.1503 13.524 13.0873 13.3057 13.3057C13.0873 13.524 13.1503 13.9017 13.2762 14.6571L13.4784 15.8706C13.6977 17.1863 13.8074 17.8442 14.2139 17.9251C14.6205 18.006 14.9737 17.4403 15.68 16.3087L15.9217 15.9217ZM15.9217 15.9217L17.7108 17.7108L18.6054 18.6054"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product click-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","click","select","choose","product","order","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.3987 16.3921L14.2302 15.381C14.1252 14.7514 14.0728 14.4367 14.2547 14.2547C14.4367 14.0728 14.7514 14.1252 15.381 14.2302L16.3921 14.3987C17.4886 14.5814 18.0368 14.6728 18.1043 15.0116C18.1717 15.3504 17.7002 15.6447 16.7573 16.2334L16.4347 16.4347L16.2334 16.7573C15.6447 17.7002 15.3504 18.1717 15.0116 18.1043C14.6728 18.0368 14.5814 17.4886 14.3987 16.3921Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M16.4347 16.4347L16.7573 16.2334C17.7002 15.6447 18.1717 15.3504 18.1043 15.0116C18.0368 14.6728 17.4886 14.5814 16.3921 14.3987L15.381 14.2302C14.7514 14.1252 14.4367 14.0728 14.2547 14.2547C14.0728 14.4367 14.1252 14.7514 14.2302 15.381L14.3987 16.3921C14.5814 17.4886 14.6728 18.0368 15.0116 18.1043C15.3504 18.1717 15.6447 17.7002 16.2334 16.7573L16.4347 16.4347ZM16.4347 16.4347L17.9257 17.9257L18.6712 18.6712"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product click-3": {
        defaultColors: ["#000000"],
        keywords: ["product","add","click","select","inventory","item","add-product","select-product","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.053C19.3539 13.3536 18.6232 13.101 18.3403 13.0129C17.9196 12.8818 17.3693 12.7903 16.8441 12.7029L15.5775 12.4918C15.2901 12.4436 14.9213 12.3818 14.5995 12.3756C14.2159 12.3681 13.5401 12.4265 12.9833 12.9833C12.4265 13.5401 12.3681 14.2159 12.3756 14.5995C12.3818 14.9213 12.4436 15.2901 12.4918 15.5775L12.7029 16.8441C12.7903 17.3693 12.8818 17.9196 13.0129 18.3403C13.101 18.6232 13.3536 19.3539 14.053 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M15.453 13.3582C15.1446 13.3067 14.837 13.2553 14.5825 13.2504C14.2986 13.2449 13.913 13.2911 13.602 13.602C13.2911 13.913 13.2449 14.2986 13.2504 14.5825C13.2553 14.837 13.3067 15.1446 13.3582 15.453L13.5602 16.6654C13.6532 17.2233 13.7357 17.7188 13.8483 18.0801C13.9511 18.4101 14.1831 18.9839 14.8202 19.1107C15.4573 19.2375 15.8913 18.7963 16.1127 18.5307C16.2855 18.3234 16.4704 18.0471 16.6709 17.7316L18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L17.7316 16.6709C18.0471 16.4704 18.3234 16.2855 18.5307 16.1127C18.7963 15.8913 19.2375 15.4573 19.1107 14.8202C18.9839 14.1831 18.4101 13.9511 18.0801 13.8483C17.7188 13.7357 17.2233 13.6532 16.6654 13.5602L15.453 13.3582Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product disable-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["not-allowed","disabled","unavailable","remove","delete","cancel","prohibited","restriction","sold-out","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16C19 17.6603 17.6603 19 16 19C14.3397 19 13 17.6603 13 16C13 14.3397 14.3397 13 16 13C17.6603 13 19 14.3397 19 16Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L18 14"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product disable-3": {
        defaultColors: ["#000000"],
        keywords: ["product","disable","unavailable","out-of-stock","hidden","deactivate","product-disable","remove-product","product-unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.45528 4.07846C6.97763 4.00991 7.61732 4.00003 8.37112 4V5.96161C8.37112 6.77895 8.37112 7.23012 8.61306 7.6159C8.88114 8.03765 9.34212 8.30901 9.83579 8.34497C10.2902 8.37766 10.6826 8.16842 11.3887 7.78918L11.4116 7.7761C11.4574 7.75322 11.5032 7.73033 11.5457 7.70745C11.6176 7.66821 11.6993 7.63225 11.6993 7.63225L11.7451 7.60936L11.8007 7.63225L12.0884 7.77937H12.0949C12.7684 8.139 13.1542 8.34497 13.5759 8.34497L13.6675 8.33516C14.1644 8.2992 14.6221 8.02784 14.8837 7.6061C15.1256 7.23012 15.1256 6.76915 15.1256 5.95181V4C15.8808 4 16.5216 4.00981 17.0447 4.07846C17.6724 4.16347 18.2413 4.34982 18.6957 4.80426C19.1502 5.26197 19.3365 5.82757 19.4215 6.45528C19.5 7.05031 19.5 7.79899 19.5 8.69806V13.5884C18.7333 12.4778 17.4516 11.75 16 11.75C13.6528 11.75 11.75 13.6528 11.75 16C11.75 17.4516 12.4778 18.7333 13.5884 19.5H8.69806C7.79899 19.5 7.05031 19.5 6.45528 19.4215C5.82757 19.3365 5.2587 19.1502 4.80426 18.6957C4.34982 18.238 4.16347 17.6724 4.07846 17.0447C4 16.4497 4 15.701 4 14.8019V8.69806C4 7.79899 4 7.05031 4.07846 6.45528C4.16347 5.82757 4.34982 5.26197 4.80426 4.80426C5.26197 4.34982 5.82757 4.16347 6.45528 4.07846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.125 14.25C15.0865 14.25 14.25 15.0865 14.25 16.125C14.25 16.3673 14.2955 16.5987 14.3786 16.8109L16.8109 14.3786C16.5987 14.2955 16.3673 14.25 16.125 14.25ZM17.8715 15.4393L15.4393 17.8715C15.6515 17.9545 15.8828 18 16.125 18C17.1635 18 18 17.1635 18 16.125C18 15.8828 17.9545 15.6515 17.8715 15.4393ZM12.75 16.125C12.75 14.258 14.258 12.75 16.125 12.75C17.992 12.75 19.5 14.258 19.5 16.125C19.5 17.992 17.992 19.5 16.125 19.5C14.258 19.5 12.75 17.992 12.75 16.125Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product disable": {
        defaultColors: ["#000000"],
        keywords: ["product","disable","unavailable","deactivate","hide","item","out-of-stock","remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 16C19 17.6603 17.6603 19 16 19C14.3397 19 13 17.6603 13 16C13 14.3397 14.3397 13 16 13C17.6603 13 19 14.3397 19 16Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 18L18 14" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product dollar-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","box","dollar","price","cost","package","inventory","stock","product-price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.8125 13.7749H18.4167M16.8125 13.7749C16.0876 13.7749 15.5 14.3625 15.5 15.0874C15.5 15.8123 16.0876 16.3999 16.8125 16.3999H17.5417C18.3471 16.3999 19 16.9875 19 17.7124C19 18.4373 18.3471 18.9995 17.5417 18.9995H16.8125M16.8125 13.7749V12.8999M15.5 18.9995L16.8125 18.9995M16.8125 18.9995V19.8745"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product dollar-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["dollar","money","currency","payment","price","cost","finance","sale","discount","amount","usd","cash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.8125 13.7749H18.4167M16.8125 13.7749C16.0876 13.7749 15.5 14.3625 15.5 15.0874C15.5 15.8123 16.0876 16.3999 16.8125 16.3999H17.5417C18.3471 16.3999 19 16.9875 19 17.7124C19 18.4373 18.3471 18.9995 17.5417 18.9995H16.8125M16.8125 13.7749V12.8999M15.5 18.9995L16.8125 18.9995M16.8125 18.9995V19.8745"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product dollar": {
        defaultColors: ["#000000"],
        keywords: ["product","dollar","price","money","item","cost","sale","value","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.8125 13.7749H18.4167M16.8125 13.7749C16.0876 13.7749 15.5 14.3625 15.5 15.0874C15.5 15.8123 16.0876 16.3999 16.8125 16.3999H17.5417C18.3471 16.3999 19 16.9875 19 17.7124C19 18.4373 18.3471 18.9995 17.5417 18.9995H16.8125M16.8125 13.7749V12.8999M15.5 18.9995L16.8125 18.9995M16.8125 18.9995V19.8745"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product edit-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["edit","modify","pencil","pen","revise","update","change","adjust","alter","correct","rewrite","product-edit","item-edit","price-edit","description-edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product dollar-3": {
        defaultColors: ["#000000"],
        keywords: [],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V12.6414C19.429 12.2642 18.9508 12.0249 18.4167 12.0249H18.3284C18.0258 11.5018 17.4602 11.1499 16.8125 11.1499C15.9658 11.1499 15.2596 11.7512 15.0975 12.5501C14.2852 13.1001 13.75 14.0304 13.75 15.0874C13.75 16.0081 14.1563 16.834 14.7994 17.3954C14.1817 17.6655 13.75 18.2821 13.75 18.9995C13.75 19.2681 13.8105 19.5226 13.9186 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8125 12.1499C17.2267 12.1499 17.5625 12.4857 17.5625 12.8999V13.0249H18.4167C18.8309 13.0249 19.1667 13.3607 19.1667 13.7749C19.1667 14.1891 18.8309 14.5249 18.4167 14.5249H16.8125C16.5018 14.5249 16.25 14.7767 16.25 15.0874C16.25 15.3981 16.5018 15.6499 16.8125 15.6499H17.5417C18.685 15.6499 19.75 16.5009 19.75 17.7124C19.75 18.9341 18.6783 19.7395 17.5625 19.7494V19.8745C17.5625 20.2887 17.2267 20.6245 16.8125 20.6245C16.3983 20.6245 16.0625 20.2887 16.0625 19.8745V19.7495H15.5C15.0858 19.7495 14.75 19.4137 14.75 18.9995C14.75 18.5853 15.0858 18.2495 15.5 18.2495H17.5417C18.0293 18.2495 18.25 17.9328 18.25 17.7124C18.25 17.4741 18.0092 17.1499 17.5417 17.1499H16.8125C15.6734 17.1499 14.75 16.2265 14.75 15.0874C14.75 14.2129 15.2942 13.4655 16.0625 13.1655V12.8999C16.0625 12.4857 16.3983 12.1499 16.8125 12.1499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product edit-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","edit","modify","product","item","inventory","update","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0084 14.7068C17.3057 14.4141 17.7062 14.25 18.1234 14.25C19.0012 14.25 19.75 14.9988 19.75 15.8765C19.75 16.2938 19.5859 16.6943 19.2931 16.9916L19.2891 16.9957L16.8366 19.4482C16.6415 19.6402 16.3806 19.7431 16.1131 19.7421L15.2957 19.75L15.2766 19.7499C14.7148 19.741 14.259 19.2851 14.2501 18.7234L14.25 18.7043L14.2579 17.8868C14.2569 17.6194 14.3598 17.3585 14.5518 17.1634L14.556 17.1591L17.0084 14.7068Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product edit-3": {
        defaultColors: ["#000000"],
        keywords: ["product","edit","modify","change","item","stock","inventory","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70553 4.33002C7.22754 4.25984 7.86855 4.25127 8.625 4.25024V6.21211C8.625 7.03111 8.625 7.48111 8.868 7.86811C9.138 8.29111 9.597 8.56111 10.092 8.59711C10.546 8.63271 10.9383 8.42181 11.6435 8.04276L11.667 8.03011C11.713 8.00711 11.759 7.98291 11.8006 7.96101C11.873 7.92293 11.9321 7.89182 11.955 7.88611L12 7.86811L12.054 7.88611C12.09 7.89511 12.216 7.95811 12.342 8.03011L12.3474 8.03297C13.0191 8.3912 13.4051 8.59711 13.827 8.59711L13.917 8.58811C14.412 8.55211 14.871 8.28211 15.132 7.85911C15.375 7.48111 15.375 7.02211 15.375 6.20311V4.25024C16.1315 4.25127 16.7725 4.25984 17.2945 4.33002C17.9223 4.41443 18.4891 4.6001 18.9445 5.05557C19.4 5.51104 19.5857 6.07784 19.6701 6.70563C19.7501 7.30041 19.75 8.04965 19.75 8.94812V13.8275C19.2999 13.4674 18.7329 13.2501 18.1235 13.2501C17.4437 13.2501 16.7912 13.5174 16.3068 13.9944L13.8489 16.4521L13.8391 16.4621C13.4604 16.8469 13.2579 17.3595 13.2579 17.8829L13.25 18.6948L13.25 18.7267L13.2502 18.7394C13.2561 19.1082 13.3599 19.4534 13.5367 19.7501H8.94798C8.04951 19.7501 7.3003 19.7502 6.70553 19.6702C6.07773 19.5858 5.51093 19.4001 5.05546 18.9447C4.59999 18.4892 4.41432 17.9224 4.32992 17.2946C4.24995 16.6998 4.24997 15.9506 4.25 15.0521V8.94805C4.24997 8.04961 4.24995 7.30039 4.32992 6.70563C4.41432 6.07784 4.59999 5.51104 5.05546 5.05557C5.51093 4.6001 6.07773 4.41443 6.70553 4.33002Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0084 14.7069C17.3057 14.4142 17.7062 14.2501 18.1234 14.2501C19.0012 14.2501 19.75 14.9989 19.75 15.8766C19.75 16.2939 19.5859 16.6944 19.2931 16.9917L19.2891 16.9958L16.8366 19.4483C16.6415 19.6403 16.3806 19.7432 16.1131 19.7422L15.2957 19.7501L15.2766 19.75C14.7148 19.7411 14.259 19.2852 14.2501 18.7235L14.25 18.7044L14.2579 17.8869C14.2569 17.6195 14.3598 17.3586 14.5518 17.1635L14.556 17.1593L17.0084 14.7069Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product edit": {
        defaultColors: ["#000000"],
        keywords: ["product","edit","modify","change","item","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.3607 19L15.3907 18.9901C15.4839 18.9916 15.5728 18.9564 15.6381 18.892L18.6985 15.8317C18.8917 15.6355 19 15.3711 19 15.0957C19 14.5163 18.4837 14 17.9043 14C17.6289 14 17.3645 14.1083 17.1683 14.3015L14.108 17.3619C14.0436 17.4272 14.0084 17.5161 14.0099 17.6093L14 18.6393C14.0031 18.8354 14.1646 18.9969 14.3607 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product fast-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","fast","speed","shipping","delivery","product","fast-delivery","express"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0001 15L15.5716 16H16.4287L16.0001 17"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product fast-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["bolt","lightning","fast","quick","speed","charge","electricity","energy","rapid","accelerate","power","flash","instant","express"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.4999 15L16 16.5H17L16.4999 18"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5C13 18.433 14.567 20 16.5 20C18.433 20 20 18.433 20 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product fast": {
        defaultColors: ["#000000"],
        keywords: ["lightning","bolt","speed","fast","quick","accelerate","energy","charge","rapid","performance","boost","expedite","hurry","POS","efficiency"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.4999 15L16 16.5H17L16.4999 18"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5C13 18.433 14.567 20 16.5 20C18.433 20 20 18.433 20 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product fast-3": {
        defaultColors: ["#000000"],
        keywords: ["product","fast","product-fast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.62112 4.25C7.86732 4.25003 7.22763 4.25991 6.70528 4.32846C6.07757 4.41347 5.51197 4.59982 5.05426 5.05426C4.59982 5.51197 4.41347 6.07757 4.32846 6.70528C4.25 7.30031 4.25 8.04899 4.25 8.94806V15.0519C4.25 15.951 4.25 16.6997 4.32846 17.2947C4.41347 17.9224 4.59982 18.488 5.05426 18.9457C5.5087 19.4002 6.07757 19.5865 6.70528 19.6715C7.30031 19.75 8.04899 19.75 8.94806 19.75H13.8384C12.7278 18.9833 12 17.7016 12 16.25C12 13.9028 13.9028 12 16.25 12C17.7016 12 18.9833 12.7278 19.75 13.8384V8.94806C19.75 8.04899 19.75 7.30031 19.6715 6.70528C19.5865 6.07757 19.4002 5.51197 18.9457 5.05426C18.4913 4.59982 17.9224 4.41347 17.2947 4.32846C16.7716 4.25981 16.1308 4.25 15.3756 4.25V6.20181C15.3756 7.01915 15.3756 7.48012 15.1337 7.8561C14.8721 8.27784 14.4144 8.5492 13.9175 8.58516L13.8259 8.59497C13.4042 8.59497 13.0184 8.389 12.3449 8.02937H12.3384L12.0507 7.88225L11.9951 7.85936L11.9493 7.88225C11.9493 7.88225 11.8676 7.91821 11.7957 7.95745C11.7532 7.98033 11.7074 8.00322 11.6616 8.0261L11.6387 8.03918C10.9326 8.41842 10.5402 8.62766 10.0858 8.59497C9.59212 8.55901 9.13114 8.28765 8.86306 7.8659C8.62112 7.48012 8.62112 7.02895 8.62112 6.21161V4.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 13C14.4551 13 13 14.4551 13 16.25C13 18.0449 14.4551 19.5 16.25 19.5C18.0449 19.5 19.5 18.0449 19.5 16.25C19.5 14.4551 18.0449 13 16.25 13ZM15.5535 14.7215C15.7073 14.3369 16.1438 14.1498 16.5284 14.3036C16.913 14.4574 17.1001 14.8939 16.9463 15.2785L16.8548 15.5073C17.063 15.5367 17.2513 15.6527 17.3711 15.8295C17.5106 16.0356 17.5388 16.2975 17.4463 16.5285L16.9462 17.7785C16.7924 18.1631 16.3559 18.3502 15.9713 18.1963C15.5867 18.0424 15.3997 17.6059 15.5536 17.2214L15.6451 16.9926C15.4369 16.9632 15.2487 16.8472 15.129 16.6704C14.9894 16.4644 14.9612 16.2025 15.0536 15.9715L15.5535 14.7215Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product finger-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","finger","touch","select","choose","product-select","order-select","inventory-select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 16.5999L15.828 16.2486C15.6821 16.0894 15.4842 16 15.2779 16C15.0716 16 14.8737 16.0894 14.7279 16.2486C14.4657 16.5346 14.425 16.9828 14.6306 17.3193L15.6976 19.0656C15.9017 19.3995 16.2452 19.6 16.613 19.6H18.7008C19.2556 19.6 19.7235 19.1493 19.7923 18.5488L19.9914 16.8107C20.0647 16.1704 19.6608 15.5814 19.077 15.4776L17.8 15.2504V13.9C17.8 13.4029 17.4306 13 16.975 13C16.5194 13 16.15 13.4029 16.15 13.9V16.5999Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product finger-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["finger","hand","point","select","choose","touch","input","action","press","interface","gesture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 16.5999L15.828 16.2486C15.6821 16.0894 15.4842 16 15.2779 16C15.0716 16 14.8737 16.0894 14.7279 16.2486C14.4657 16.5346 14.425 16.9828 14.6306 17.3193L15.6976 19.0656C15.9017 19.3995 16.2452 19.6 16.613 19.6H18.7008C19.2556 19.6 19.7235 19.1493 19.7923 18.5488L19.9914 16.8107C20.0647 16.1704 19.6608 15.5814 19.077 15.4776L17.8 15.2504V13.9C17.8 13.4029 17.4306 13 16.975 13C16.5194 13 16.15 13.4029 16.15 13.9V16.5999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M12.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product finger-3": {
        defaultColors: ["#000000"],
        keywords: ["product","tap","finger","select","choose","item","touch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 16.5999L15.828 16.2486C15.6821 16.0894 15.4842 16 15.2779 16C15.0716 16 14.8737 16.0894 14.7279 16.2486C14.4657 16.5346 14.425 16.9828 14.6306 17.3193L15.6976 19.0656C15.9017 19.3995 16.2452 19.6 16.613 19.6H18.7008C19.2556 19.6 19.7235 19.1493 19.7923 18.5488L19.9914 16.8107C20.0647 16.1704 19.6608 15.5814 19.077 15.4776L17.8 15.2504V13.9C17.8 13.4029 17.4306 13 16.975 13C16.5194 13 16.15 13.4029 16.15 13.9V16.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.6478C19.5959 14.5773 19.4296 14.5246 19.252 14.493L18.7999 14.4126V13.9C18.7999 12.9343 18.0629 12 16.9749 12C15.8868 12 15.1499 12.9343 15.1499 13.9V15.0048C14.6988 15.0384 14.2881 15.2483 13.9906 15.5728C13.4203 16.195 13.3446 17.1327 13.7772 17.8408L14.8442 19.587C14.8785 19.6431 14.9152 19.6975 14.9542 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product finger": {
        defaultColors: ["#000000"],
        keywords: ["finger","product","select","choose","item","touch","select-product","pick"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.15 16.5999L15.828 16.2486C15.6821 16.0894 15.4842 16 15.2779 16C15.0716 16 14.8737 16.0894 14.7279 16.2486C14.4657 16.5346 14.425 16.9828 14.6306 17.3193L15.6976 19.0656C15.9017 19.3995 16.2452 19.6 16.613 19.6H18.7008C19.2556 19.6 19.7235 19.1493 19.7923 18.5488L19.9914 16.8107C20.0647 16.1704 19.6608 15.5814 19.077 15.4776L17.8 15.2504V13.9C17.8 13.4029 17.4306 13 16.975 13C16.5194 13 16.15 13.4029 16.15 13.9V16.5999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product heart-3": {
        defaultColors: ["#000000"],
        keywords: ["favorite","product","like","heart","wishlist","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.387C19.6943 14.3272 19.6356 14.2692 19.5738 14.2132C19.5337 14.1768 19.4916 14.1427 19.4478 14.1108C18.8063 13.6451 18.0222 13.3573 17.1412 13.5711C16.9099 13.6273 16.696 13.7139 16.5001 13.8167C16.3041 13.7139 16.0902 13.6273 15.8589 13.5711C14.9778 13.3574 14.1938 13.6451 13.5523 14.1109C13.5085 14.1427 13.4664 14.1769 13.4263 14.2133C12.2475 15.2818 12.18 17.0702 13.303 18.2155C13.3322 18.2452 13.3625 18.2736 13.394 18.3008L15.0732 19.75C15.0662 19.75 15.0591 19.75 15.0519 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.0071 14.7178C18.4823 14.3367 17.9212 14.1537 17.3181 14.3001C17.0159 14.3734 16.7444 14.5222 16.5 14.6987C16.2557 14.5222 15.9842 14.3734 15.682 14.3001C15.0788 14.1537 14.5178 14.3368 13.993 14.7178C13.9711 14.7338 13.95 14.7508 13.93 14.769C13.0634 15.5545 13.0166 16.8523 13.8385 17.6904C13.8531 17.7053 13.8682 17.7195 13.884 17.7331L16.01 19.5679C16.2915 19.8108 16.7086 19.8108 16.9901 19.5679L19.1161 17.7331C19.1318 17.7195 19.147 17.7053 19.1615 17.6904C19.9835 16.8522 19.9366 15.5545 19.0701 14.769C19.05 14.7508 19.029 14.7337 19.0071 14.7178Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product heart-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","heart","favorite","liked","item","box","package","saved-item","saved-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product heart-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["heart","favorite","like","loyalty","rewards","promotion","save","wishlist","customer","member","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product mobile-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","product","item","mobile","order","delivery","shipment","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.6665 19.25V15.75C15.6665 14.925 15.6665 14.5126 15.9228 14.2563C16.1791 14 16.5915 14 17.4165 14H18.5832C19.4081 14 19.8206 14 20.0769 14.2563C20.3332 14.5126 20.3332 14.925 20.3332 15.75V19.25C20.3332 20.075 20.3332 20.4874 20.0769 20.7437C19.8206 21 19.4081 21 18.5832 21H17.4165C16.5915 21 16.1791 21 15.9228 20.7437C15.6665 20.4874 15.6665 20.075 15.6665 19.25Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.7441 18.9583H18.2474" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product heart": {
        defaultColors: ["#000000"],
        keywords: ["product","favorite","like","wishlist","add-to-favorites","save","heart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 19L14.374 17.1652C13.8532 16.6341 13.8793 15.8271 14.4336 15.3246C15.25 14.7318 15.7857 15.0114 16.5 15.6764C17.2143 15.0114 17.75 14.7318 18.5664 15.3246C19.1207 15.827 19.1468 16.6341 18.626 17.1652L16.5 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product mobile": {
        defaultColors: ["#000000"],
        keywords: ["product","mobile","item","inventory","stock","add-item","add-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H18.3333C19.2761 13 19.7475 13 20.0404 13.2929C20.3333 13.5858 20.3333 14.0572 20.3333 15V19C20.3333 19.9428 20.3333 20.4142 20.0404 20.7071C19.7475 21 19.2761 21 18.3333 21H17C16.0572 21 15.5858 21 15.2929 20.7071C15 20.4142 15 19.9428 15 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 18.6665H18.1115" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product mobile-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["mobile","phone","device","payment","transaction","terminal","pos","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19V15C15 14.0572 15 13.5858 15.2929 13.2929C15.5858 13 16.0572 13 17 13H18.3333C19.2761 13 19.7475 13 20.0404 13.2929C20.3333 13.5858 20.3333 14.0572 20.3333 15V19C20.3333 19.9428 20.3333 20.4142 20.0404 20.7071C19.7475 21 19.2761 21 18.3333 21H17C16.0572 21 15.5858 21 15.2929 20.7071C15 20.4142 15 19.9428 15 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path d="M17.2227 18.6665H18.1115" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product moving-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","product","inventory","stock","shipping","delivery","goods","item","cardboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M18 15.0001L16 14.9999" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 20.0001L16 19.9999" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5H17" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product moving-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["list","menu","options","settings","more","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 15.0001L16 14.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 20.0001L16 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17.5H17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product moving-3": {
        defaultColors: ["#000000"],
        keywords: ["inventory","stock","movement","products","transfer","shipping","delivery","warehouse","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70553 4.33002C7.22754 4.25984 7.86855 4.25127 8.625 4.25024V6.21211C8.625 7.03111 8.625 7.48111 8.868 7.86811C9.138 8.29111 9.597 8.56111 10.092 8.59711C10.546 8.63271 10.9383 8.42181 11.6435 8.04276L11.667 8.03011C11.713 8.00711 11.759 7.98291 11.8006 7.96101C11.873 7.92293 11.9321 7.89182 11.955 7.88611H12.054C12.09 7.89511 12.216 7.95811 12.342 8.03011L12.3474 8.03297C13.0191 8.3912 13.4051 8.59711 13.827 8.59711L13.917 8.58811C14.412 8.55211 14.871 8.28211 15.132 7.85911C15.375 7.48111 15.375 7.02211 15.375 6.20311V4.25024C16.1315 4.25127 16.7725 4.25984 17.2945 4.33002C17.9223 4.41443 18.4891 4.6001 18.9445 5.05557C19.4 5.51104 19.5857 6.07784 19.6701 6.70563C19.7501 7.30041 19.75 8.04965 19.75 8.94812V13.4185C19.5227 13.3105 19.2685 13.2501 19.0001 13.2501L17.0001 13.25C16.0336 13.25 15.25 14.0334 15.25 14.9999C15.25 15.7785 15.7584 16.4384 16.4614 16.6656C16.3266 16.9136 16.25 17.1979 16.25 17.5C16.25 17.8022 16.3266 18.0864 16.4614 18.3345C15.835 18.5369 15.3631 19.0828 15.2677 19.7501C15.1968 19.7501 15.1249 19.7501 15.052 19.7501H8.94798C8.04951 19.7501 7.3003 19.7502 6.70553 19.6702C6.07773 19.5858 5.51093 19.4001 5.05546 18.9447C4.59999 18.4892 4.41432 17.9224 4.32992 17.2946C4.24995 16.6998 4.24997 15.9506 4.25 15.0521V8.94805C4.24997 8.04961 4.24995 7.30039 4.32992 6.70563C4.41432 6.07784 4.59999 5.51104 5.05546 5.05557C5.51093 4.6001 6.07773 4.41443 6.70553 4.33002Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 15.0001C16.25 14.5859 16.5858 14.2501 17 14.2501L19 14.2502C19.4143 14.2502 19.75 14.586 19.75 15.0002C19.75 15.4145 19.4142 15.7502 19 15.7502L17 15.7501C16.5857 15.7501 16.25 15.4143 16.25 15.0001Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 20.0001C16.25 19.5859 16.5858 19.2501 17 19.2501L19 19.2502C19.4143 19.2502 19.75 19.586 19.75 20.0002C19.75 20.4145 19.4142 20.7502 19 20.7502L17 20.7501C16.5857 20.7501 16.25 20.4143 16.25 20.0001Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.25 17.5002C17.25 17.0859 17.5858 16.7502 18 16.7502H20C20.4142 16.7502 20.75 17.0859 20.75 17.5002C20.75 17.9144 20.4142 18.2502 20 18.2502H18C17.5858 18.2502 17.25 17.9144 17.25 17.5002Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product mobile-3": {
        defaultColors: ["#000000"],
        keywords: ["mobile","cellphone","smartphone","device","product","inventory","stock","item","mobile-product","mobile-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V12.61C19.5501 12.5384 19.3598 12.5007 19.1977 12.4789C18.8879 12.4373 18.5323 12.4374 18.237 12.4375H17.0961C16.8008 12.4374 16.4452 12.4373 16.1354 12.4789C15.7587 12.5296 15.2303 12.6659 14.7813 13.1148C14.3324 13.5638 14.1961 14.0922 14.1454 14.4689C14.1038 14.7786 14.1039 15.1343 14.104 15.4296V18.5705C14.1039 18.8658 14.1038 19.2214 14.1454 19.5312C14.1546 19.5996 14.1666 19.673 14.1828 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.1329 13.4375C16.8083 13.4375 16.5107 13.4374 16.2686 13.47C16.002 13.5058 15.7202 13.5902 15.4884 13.8219C15.2567 14.0537 15.1723 14.3355 15.1365 14.6021C15.1039 14.8442 15.104 15.1418 15.104 15.4664V18.5336C15.104 18.8582 15.1039 19.1558 15.1365 19.3979C15.1723 19.6645 15.2567 19.9463 15.4884 20.1781C15.7202 20.4099 16.002 20.4942 16.2686 20.53C16.5107 20.5626 16.8083 20.5625 17.133 20.5625H18.2001C18.5247 20.5625 18.8223 20.5626 19.0644 20.53C19.331 20.4942 19.6128 20.4099 19.8446 20.1781C20.0764 19.9463 20.1607 19.6645 20.1965 19.3979C20.2291 19.1558 20.229 18.8582 20.229 18.5336V15.4664C20.229 15.1418 20.2291 14.8442 20.1965 14.6021C20.1607 14.3355 20.0764 14.0537 19.8446 13.8219C19.6128 13.5902 19.331 13.5058 19.0644 13.47C18.8223 13.4374 18.5247 13.4375 18.2001 13.4375H17.1329ZM17.3339 18.1499C17.0025 18.1499 16.7339 18.4185 16.7339 18.7499C16.7339 19.0813 17.0025 19.3499 17.3339 19.3499H18.0006C18.3319 19.3499 18.6006 19.0813 18.6006 18.7499C18.6006 18.4185 18.3319 18.1499 18.0006 18.1499H17.3339Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product pin-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","pin","pin-1","point","location","map","products","locate-product","set-location","set-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.2626 16.2403L18.6998 16.8032C18.6132 16.8898 18.5699 16.9331 18.538 16.9847C18.5061 17.0363 18.4867 17.0944 18.448 17.2106L18.4091 17.3272C18.0036 18.5438 17.8009 19.1521 17.3519 19.3315C17.256 19.3698 17.1549 19.3937 17.052 19.4023C16.5702 19.4426 16.1168 18.9892 15.21 18.0824C14.3033 17.1757 13.8499 16.7223 13.8902 16.2405C13.8988 16.1376 13.9226 16.0365 13.961 15.9406C14.1404 15.4916 14.7487 15.2889 15.9652 14.8833L16.0819 14.8444C16.1981 14.8057 16.2561 14.7864 16.3077 14.7545C16.3593 14.7226 16.4026 14.6793 16.4892 14.5927L17.0521 14.0298L17.0521 14.0298C17.3994 13.6825 17.5731 13.5088 17.7889 13.5088C18.0047 13.5088 18.1784 13.6825 18.5258 14.0298L19.2626 14.7666L19.2626 14.7667C19.6099 15.114 19.7836 15.2877 19.7836 15.5035C19.7836 15.7193 19.61 15.893 19.2626 16.2403Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.21 18.0823L13.7363 19.556" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product moving": {
        defaultColors: ["#000000"],
        keywords: ["unknown","unclear","not visible"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 15.0001L16 14.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 20.0001L16 19.9999" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17.5H17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M13 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product pin": {
        defaultColors: ["#000000"],
        keywords: ["pin","map","location","store","shop","place","point"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4645 16.8384L19.2321 16.0707C19.594 15.7088 19.775 15.5279 19.775 15.303C19.775 15.0782 19.594 14.8972 19.2321 14.5354L18.4644 13.7677C18.1026 13.4058 17.9216 13.2249 17.6968 13.2249C17.4719 13.2249 17.291 13.4058 16.9291 13.7677L16.1614 14.5354"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1615 14.5354L15.7968 14.6569C14.5293 15.0794 13.8956 15.2907 13.7086 15.7584C13.6687 15.8583 13.6438 15.9637 13.6348 16.0709C13.5929 16.5729 14.0652 17.0452 15.01 17.9899V17.9899C15.9547 18.9346 16.427 19.407 16.929 19.365C17.0362 19.3561 17.1415 19.3312 17.2415 19.2913C17.7092 19.1043 17.9205 18.4706 18.3429 17.2031L18.4645 16.8384"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.0098 17.9897L13.4744 19.5251" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product pin-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["pin","location","map","marker","set-location","mark","tagged","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.4645 16.8384L19.2321 16.0707C19.594 15.7088 19.775 15.5279 19.775 15.303C19.775 15.0782 19.594 14.8972 19.2321 14.5354L18.4644 13.7677C18.1026 13.4058 17.9216 13.2249 17.6968 13.2249C17.4719 13.2249 17.291 13.4058 16.9291 13.7677L16.1614 14.5354"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1615 14.5354L15.7968 14.6569C14.5293 15.0794 13.8956 15.2907 13.7086 15.7584C13.6687 15.8583 13.6438 15.9637 13.6348 16.0709C13.5929 16.5729 14.0652 17.0452 15.01 17.9899V17.9899C15.9547 18.9346 16.427 19.407 16.929 19.365C17.0362 19.3561 17.1415 19.3312 17.2415 19.2913C17.7092 19.1043 17.9205 18.4706 18.3429 17.2031L18.4645 16.8384"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0098 17.9897L13.4744 19.5251"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product pin-3": {
        defaultColors: ["#000000"],
        keywords: ["pin","location","map","store","product","aisle","position","stock","inventory","product-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V12.578L19.6581 12.4861C19.5132 12.341 19.305 12.1325 19.0911 11.9693C18.8177 11.7607 18.3467 11.4749 17.6971 11.4749C17.0474 11.4749 16.5765 11.7607 16.3031 11.9693L15.2164 13.0058L15.1506 13.0278C14.5945 13.213 14.0298 13.4012 13.5876 13.6144C13.1136 13.843 12.422 14.263 12.0839 15.1089C11.9796 15.3699 11.9147 15.645 11.8913 15.9251C11.8154 16.8329 12.2461 17.5178 12.5679 17.9343L12.5778 17.9471L12.2374 18.2875C11.8382 18.6865 11.6721 19.2304 11.739 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7575 13.8787L15.7566 13.8797L15.7553 13.8801C15.7356 13.8869 15.7127 13.8945 15.6815 13.9049L15.5135 13.9609C14.9196 14.1589 14.406 14.33 14.0221 14.5152C13.6242 14.7071 13.2108 14.9841 13.0126 15.4801C12.9451 15.649 12.903 15.8271 12.8879 16.0084C12.8434 16.5406 13.0892 16.9733 13.3593 17.3229C13.5168 17.5268 13.7189 17.7472 13.952 17.9875L12.9445 18.9947C12.6515 19.2875 12.6514 19.7624 12.9443 20.0554C13.2371 20.3483 13.712 20.3484 14.0049 20.0555L15.0126 19.0482C15.253 19.2813 15.4735 19.4835 15.6774 19.641C16.027 19.9111 16.4597 20.1569 16.9919 20.1124C17.1732 20.0973 17.3513 20.0552 17.5202 19.9877C18.0162 19.7895 18.2932 19.3761 18.4851 18.9782C18.6703 18.5943 18.8414 18.0807 19.0394 17.4868L19.0954 17.3187C19.1058 17.2875 19.1134 17.2645 19.1202 17.2449L19.1206 17.2436L19.1216 17.2426C19.1361 17.2278 19.1532 17.2107 19.1765 17.1874L19.7882 16.5757C19.9468 16.4172 20.1143 16.2499 20.2359 16.0904C20.3773 15.9051 20.5254 15.6454 20.5254 15.303C20.5254 14.9607 20.3773 14.7009 20.2359 14.5156C20.1143 14.3562 19.9468 14.1889 19.7882 14.0303L18.9699 13.212C18.8114 13.0534 18.644 12.886 18.4846 12.7643C18.2993 12.6229 18.0395 12.4749 17.6972 12.4749C17.3548 12.4749 17.0951 12.6229 16.9098 12.7643C16.7503 12.886 16.583 13.0534 16.4245 13.212L15.8127 13.8238C15.7895 13.8471 15.7723 13.8642 15.7575 13.8787Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product pointer-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["cursor","arrow","select","choose","pointer","mouse","navigation","link","product selection","ui element"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.3931 13.3929L13.036 13.0357"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8929 13.0357L16.2501 12.6786"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6786 16.2506L13.0357 15.8934"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.6233 18.3211L14.9841 15.9244C14.8337 15.3601 14.7584 15.0779 14.9137 14.9318C15.0691 14.7857 15.3461 14.8781 15.9002 15.0628L18.2174 15.8352C18.9673 16.0851 19.3422 16.2101 19.3525 16.4562C19.3627 16.7023 18.9994 16.858 18.2729 17.1693L17.7198 17.4064C17.6107 17.4531 17.5562 17.4765 17.5127 17.5153C17.4692 17.554 17.4398 17.6055 17.381 17.7085L16.9336 18.4914C16.5669 19.1331 16.3836 19.4539 16.1462 19.423C15.9089 19.3922 15.8137 19.0351 15.6233 18.3211Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product pointer-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","cursor","select","product","inventory","stock","pointer","choose","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.3931 13.3929L13.036 13.0357"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8929 13.0357L16.2501 12.6786"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6786 16.2506L13.0357 15.8934"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.6233 18.3211L14.9841 15.9244C14.8337 15.3601 14.7584 15.0779 14.9137 14.9318C15.0691 14.7857 15.3461 14.8781 15.9002 15.0628L18.2174 15.8352C18.9673 16.0851 19.3422 16.2101 19.3525 16.4562C19.3627 16.7023 18.9994 16.858 18.2729 17.1693L17.7198 17.4064C17.6107 17.4531 17.5562 17.4765 17.5127 17.5153C17.4692 17.554 17.4398 17.6055 17.381 17.7085L16.9336 18.4914C16.5669 19.1331 16.3836 19.4539 16.1462 19.423C15.9089 19.3922 15.8137 19.0351 15.6233 18.3211Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product pointer": {
        defaultColors: ["#000000"],
        keywords: ["product","select","choose","item","pointer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.3931 13.3929L13.036 13.0357"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8929 13.0357L16.2501 12.6786"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.6786 16.2506L13.0357 15.8934"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.6233 18.3211L14.9841 15.9244C14.8337 15.3601 14.7584 15.0779 14.9137 14.9318C15.0691 14.7857 15.3461 14.8781 15.9002 15.0628L18.2174 15.8352C18.9673 16.0851 19.3422 16.2101 19.3525 16.4562C19.3627 16.7023 18.9994 16.858 18.2729 17.1693L17.7198 17.4064C17.6107 17.4531 17.5562 17.4765 17.5127 17.5153C17.4692 17.554 17.4398 17.6055 17.381 17.7085L16.9336 18.4914C16.5669 19.1331 16.3836 19.4539 16.1462 19.423C15.9089 19.3922 15.8137 19.0351 15.6233 18.3211Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product pointer-3": {
        defaultColors: ["#000000"],
        keywords: ["point","pointer","arrow","location","product","select","choose"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.79 18.46C14.58 18.55 14.36 18.6 14.14 18.6C13.73 18.6 13.32 18.44 13.01 18.13C12.7 17.82 12.54 17.43 12.54 17C12.54 16.57 12.71 16.17 13.01 15.87L13.29 15.58C13.29 15.58 13.29 15.58 13.3 15.57H13.29C12.99 15.26 12.82 14.85 12.82 14.43C12.82 14.01 12.99 13.6 13.29 13.3C13.89 12.69 14.95 12.7 15.55 13.3H15.56C15.56 13.3 15.56 13.3 15.57 13.3L15.86 13.01C16.46 12.41 17.52 12.41 18.12 13.01C18.42 13.31 18.59 13.71 18.59 14.14C18.59 14.42 18.51 14.68 18.38 14.92L19.07 15.15C19.33 15.24 19.55 15.32 19.74 15.4C19.74 15.29 19.74 15.18 19.74 15.06V8.95C19.74 8.05 19.74 7.3 19.66 6.71C19.57 6.08 19.39 5.52 18.93 5.06C18.48 4.61 17.91 4.42 17.28 4.33C16.76 4.26 16.12 4.25 15.36 4.25V6.2C15.36 7.02 15.36 7.48 15.12 7.85C14.86 8.27 14.4 8.54 13.9 8.58H13.81C13.39 8.58 13 8.38 12.33 8.02L12.04 7.87L11.98 7.85L11.93 7.87C11.93 7.87 11.85 7.91 11.78 7.95C11.74 7.97 11.67 8 11.63 8.02C10.92 8.41 10.53 8.62 10.08 8.59C9.59 8.55 9.13 8.28 8.86 7.86C8.62 7.47 8.62 7.02 8.62 6.21V4.25C7.87 4.25 7.23 4.25 6.71 4.33C6.08 4.42 5.52 4.6 5.06 5.06C4.6 5.51 4.41 6.08 4.33 6.71C4.25 7.31 4.25 8.05 4.25 8.95V15.05C4.25 15.95 4.25 16.7 4.33 17.29C4.42 17.92 4.6 18.48 5.06 18.94C5.51 19.39 6.08 19.58 6.71 19.67C7.31 19.75 8.05 19.75 8.95 19.75H15.05C15.05 19.75 15.12 19.75 15.16 19.75C15.09 19.56 15.03 19.34 14.96 19.11L14.79 18.46Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.5601 13.7101L16.29 14.0101C16.29 14.0101 16.23 14.1001 16.2 14.1401C16.17 14.1901 16.1501 14.2501 16.14 14.3001C16.1 14.4901 16.14 14.7001 16.29 14.8501C16.29 14.8501 16.29 14.8501 16.3 14.8501C16.51 15.0501 16.83 15.0601 17.0601 14.8901C17.08 14.8701 17.1101 14.8601 17.13 14.8401L17.41 14.5601C17.64 14.3301 17.64 13.9501 17.41 13.7101C17.18 13.4801 16.8 13.4801 16.5601 13.7101Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M19.7101 16.5201C19.6301 16.4601 19.5701 16.4101 19.5201 16.3801C19.3301 16.2901 19.0701 16.2001 18.8001 16.1101C18.7901 16.1101 18.7801 16.1101 18.7601 16.1001L17.6401 15.7301L16.9101 15.4901C16.9101 15.4901 16.8901 15.4901 16.8801 15.4801C16.6901 15.4201 16.3914 15.3401 16.2214 15.3101C16.1914 15.3101 16.2401 15.3201 16.2001 15.3101C16.0101 15.2901 15.7601 15.3101 15.5301 15.5101C15.5301 15.5101 15.5101 15.5301 15.5001 15.5401C15.2801 15.7601 15.2601 16.0301 15.2701 16.2201C15.2701 16.2401 15.2701 16.2701 15.2701 16.2901C15.2901 16.4601 15.3501 16.7001 15.4001 16.9001C15.4001 16.8901 15.4001 16.9101 15.4001 16.9001L15.6301 17.7601L15.9101 18.8201C15.9801 19.0701 16.0401 19.3601 16.1201 19.5501C16.1401 19.6001 16.1801 19.6801 16.2301 19.7501C16.3401 19.9201 16.5101 20.1001 16.8201 20.1401C17.2601 20.2001 17.5301 19.8901 17.6501 19.7401C17.6801 19.7001 17.7201 19.6401 17.7501 19.5801C17.8401 19.4401 17.9301 19.2901 18.0301 19.1201C18.0301 19.1101 18.0401 19.1001 18.0501 19.0901L18.4001 18.4701L18.8301 18.2801C18.8301 18.2801 18.8501 18.2701 18.8701 18.2601C19.1001 18.1601 19.3201 18.0601 19.4901 17.9701C19.5101 17.9601 19.5401 17.9501 19.5601 17.9401C19.7201 17.8401 20.0801 17.6001 20.0601 17.1401C20.0501 16.8301 19.8701 16.6401 19.7101 16.5201Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M15.2701 14.4899C15.2401 14.4199 15.2001 14.3499 15.1401 14.2899L14.8501 13.9999C14.6201 13.7699 14.2401 13.7699 14.0001 13.9999C13.7701 14.2299 13.7701 14.6099 14.0001 14.8499L14.2901 15.1399C14.3501 15.1899 14.4101 15.2399 14.4801 15.2599C14.6501 15.3299 14.8401 15.3099 15.0001 15.2299C15.0501 15.1999 15.1001 15.1799 15.1401 15.1399C15.1801 15.0999 15.2001 15.0499 15.2301 15.0099C15.3201 14.8499 15.3401 14.6599 15.2701 14.4899Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M14.5199 17.4601C14.5199 17.4601 14.5499 17.4301 14.5699 17.4201L14.8599 17.1301C15.0899 16.9001 15.0899 16.5301 14.8599 16.2901C14.6999 16.1301 14.4799 16.0901 14.2799 16.1401C14.2299 16.1501 14.1899 16.1701 14.1399 16.2001C14.0899 16.2301 14.0499 16.2501 14.0099 16.2901L13.7199 16.5801C13.4899 16.8101 13.4899 17.1901 13.7199 17.4301C13.9399 17.6501 14.2899 17.6601 14.5199 17.4601Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product process-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","donut","box","product","order","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 16.5C19 15.1193 17.8807 14 16.5 14C15.1193 14 14 15.1193 14 16.5C14 17.8807 15.1193 19 16.5 19C17.8807 19 19 17.8807 19 16.5Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 16.5004L16.783 16.2174L16.8538 16.1466"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product process-3": {
        defaultColors: ["#000000"],
        keywords: ["product","process","flow","step","sequence","automation","workflow","business-process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V13.7612C18.9704 12.8371 17.8038 12.25 16.5 12.25C14.1528 12.25 12.25 14.1528 12.25 16.5C12.25 17.8038 12.8371 18.9704 13.7612 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.25 16.5C13.25 14.7051 14.7051 13.25 16.5 13.25C18.2949 13.25 19.75 14.7051 19.75 16.5C19.75 18.2949 18.2949 19.75 16.5 19.75C14.7051 19.75 13.25 18.2949 13.25 16.5ZM17.3841 16.6768C17.677 16.3839 17.677 15.909 17.3841 15.6162C17.0912 15.3233 16.6163 15.3233 16.3234 15.6162L15.9697 15.9699C15.6768 16.2628 15.6768 16.7377 15.9697 17.0306C16.2626 17.3235 16.7374 17.3235 17.0303 17.0306L17.3841 16.6768Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product process-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["circle","target","bullseye","scan","focus","aim","select","processing","product process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16.5C19 15.1193 17.8807 14 16.5 14C15.1193 14 14 15.1193 14 16.5C14 17.8807 15.1193 19 16.5 19C17.8807 19 19 17.8807 19 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 16.5004L16.783 16.2174L16.8538 16.1466"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product receive-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","arrow-left","return","product-return","order-return","receive","product","delivery","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M16 15L14 17L16 19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product process": {
        defaultColors: ["#000000"],
        keywords: ["process","workflow","flow","sequence","steps","management","automation","task","operation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16.5C19 15.1193 17.8807 14 16.5 14C15.1193 14 14 15.1193 14 16.5C14 17.8807 15.1193 19 16.5 19C17.8807 19 19 17.8807 19 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 16.5004L16.783 16.2174L16.8538 16.1466"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product receive": {
        defaultColors: ["#000000"],
        keywords: ["inventory","stock","products","box","package","receive","incoming","restock","delivery","shipment","warehouse","add-stock","add-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 15L14 17L16 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 17L19 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product receive-3": {
        defaultColors: ["#000000"],
        keywords: ["product","receive","inventory","stock","delivery","inbound","box","package","add","plus","order","add-order","import"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.2774 19.75 15.4934 19.7488 15.7C19.5284 15.5728 19.2727 15.5 19 15.5L17.4146 15.5C17.6006 14.9723 17.4827 14.3614 17.0606 13.9393C16.4748 13.3535 15.5251 13.3536 14.9393 13.9394L12.9393 15.9394C12.3536 16.5252 12.3536 17.4749 12.9393 18.0607L14.6287 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5303 14.4697C16.8232 14.7626 16.8232 15.2374 16.5303 15.5303L15.8106 16.25L19 16.25C19.4142 16.25 19.75 16.5858 19.75 17C19.75 17.4142 19.4142 17.75 19 17.75L15.8107 17.75L16.5303 18.4697C16.8232 18.7626 16.8232 19.2374 16.5303 19.5303C16.2374 19.8232 15.7626 19.8232 15.4697 19.5303L13.4697 17.5303C13.1768 17.2375 13.1768 16.7626 13.4697 16.4697L15.4696 14.4697C15.7625 14.1768 16.2374 14.1768 16.5303 14.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product refresh-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["refresh","reload","update","synchronize","arrows","cycle","repeat","resync","reapply","rotate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9972 16.9982C18.8573 17.4209 18.6217 17.8056 18.3087 18.1222C17.6403 18.7904 16.696 19.1043 15.7607 18.9691C14.8253 18.834 14.0085 18.2657 13.5566 17.4356"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 14.5644C18.3694 13.7343 17.5526 13.166 16.6172 13.0308C15.6819 12.8957 14.7376 13.2096 14.0692 13.8777C13.7556 14.1944 13.519 14.579 13.3779 15.0018"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 14.5655H18.9973V13.24"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 17.4325H13.3823V18.758"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product receive-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","left","back","return","previous","undo","cancel","go-back","retreat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 15L14 17L16 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 17L19 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product refresh-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","refresh","reload","update","inventory","product","stock","restock","resupply","cycle","rotation","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.9972 16.9982C18.8573 17.4209 18.6217 17.8056 18.3087 18.1222C17.6403 18.7904 16.696 19.1043 15.7607 18.9691C14.8253 18.834 14.0085 18.2657 13.5566 17.4356"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 14.5644C18.3694 13.7343 17.5526 13.166 16.6172 13.0308C15.6819 12.8957 14.7376 13.2096 14.0692 13.8777C13.7556 14.1944 13.519 14.579 13.3779 15.0018"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 14.5655H18.9973V13.24"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 17.4325H13.3823V18.758"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product refresh-3": {
        defaultColors: ["#000000"],
        keywords: ["refresh","update","reload","data","synchronize","inventory","price","product","database","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V12.4373C19.5249 12.3194 19.2688 12.2528 18.9972 12.2528C18.7368 12.2528 18.4908 12.314 18.2726 12.4228C17.9082 12.2574 17.5184 12.142 17.113 12.0835C15.7742 11.89 14.4225 12.3393 13.4658 13.2957L13.4602 13.3014C13.0057 13.7602 12.663 14.3175 12.4585 14.93C12.2673 15.503 12.413 16.1073 12.7883 16.5278C12.5337 16.8147 12.379 17.1924 12.379 17.6062V18.7849C12.379 19.1463 12.497 19.4801 12.6965 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0845 13.9144C14.8461 13.153 15.9221 12.7953 16.988 12.9494C17.487 13.0215 17.9564 13.2018 18.3674 13.4703C18.5011 13.2641 18.7332 13.1277 18.9972 13.1277C19.4114 13.1277 19.7472 13.4635 19.7472 13.8777V15.0564C19.7472 15.4706 19.4114 15.8064 18.9972 15.8064H17.8168C17.4026 15.8064 17.0668 15.4706 17.0668 15.0564C17.0668 14.8693 17.1353 14.6982 17.2487 14.5668C17.0983 14.5029 16.9388 14.4578 16.7734 14.4339C16.1763 14.3476 15.5734 14.5477 15.1464 14.9739C14.9491 15.1734 14.8003 15.4157 14.7114 15.6819C14.5803 16.0748 14.1554 16.287 13.7625 16.1558C13.3696 16.0247 13.1574 15.5999 13.2886 15.207C13.4505 14.7218 13.722 14.2804 14.0819 13.917L14.0845 13.9144ZM19.2328 16.5078C19.6261 16.6379 19.8394 17.0621 19.7093 17.4554C19.5486 17.941 19.2779 18.3829 18.9183 18.7467L18.9152 18.7498C18.1536 19.5112 17.0776 19.8689 16.0118 19.7149C15.5129 19.6428 15.0435 19.4625 14.6326 19.1942C14.4987 19.3992 14.2672 19.5348 14.0041 19.5348C13.5899 19.5348 13.2541 19.199 13.2541 18.7848V17.606C13.2541 17.1918 13.5899 16.856 14.0041 16.856H15.182C15.5962 16.856 15.932 17.1918 15.932 17.606C15.932 17.7936 15.8631 17.9651 15.7493 18.0967C15.9002 18.161 16.0603 18.2063 16.2263 18.2303C16.8233 18.3165 17.4261 18.1166 17.8531 17.6906C18.0495 17.4915 18.1973 17.2497 18.2852 16.9842C18.4153 16.591 18.8396 16.3776 19.2328 16.5078Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product remove-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","remove","delete","cancel","order","remove-order","cancel-order","product","remove-product","delete-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M14 15L18 19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product refresh": {
        defaultColors: ["#000000"],
        keywords: ["refresh","reload","update","sync","data refresh","inventory update","price update","system refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9972 16.9982C18.8573 17.4209 18.6217 17.8056 18.3087 18.1222C17.6403 18.7904 16.696 19.1043 15.7607 18.9691C14.8253 18.834 14.0085 18.2657 13.5566 17.4356"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8213 14.5644C18.3694 13.7343 17.5526 13.166 16.6172 13.0308C15.6819 12.8957 14.7376 13.2096 14.0692 13.8777C13.7556 14.1944 13.519 14.579 13.3779 15.0018"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6699 14.5655H18.9973V13.24"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7069 17.4325H13.3823V18.758"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product remove-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["remove","delete","cancel","close","error","cross","discard","reject","void","refund","remove-item","delete-item","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 15L18 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[0] || "#7E47E1"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product remove-3": {
        defaultColors: ["#000000"],
        keywords: ["product","remove","delete","box","package","inventory","remove-product","delete-product","unavailable","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V13.7005C19.1764 13.369 18.4301 13.4486 17.9393 13.9393L17 14.8787L16.0607 13.9393C15.4749 13.3536 14.5251 13.3536 13.9393 13.9393C13.3536 14.5251 13.3536 15.4749 13.9393 16.0607L14.8787 17L13.9393 17.9393C13.4486 18.4301 13.369 19.1764 13.7005 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4697 14.4697C14.7626 14.1768 15.2374 14.1768 15.5303 14.4697L17 15.9393L18.4697 14.4697C18.7626 14.1768 19.2374 14.1768 19.5303 14.4697C19.8232 14.7626 19.8232 15.2374 19.5303 15.5303L18.0607 17L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L17 18.0607L15.5303 19.5303C15.2374 19.8232 14.7626 19.8232 14.4697 19.5303C14.1768 19.2374 14.1768 18.7626 14.4697 18.4697L15.9393 17L14.4697 15.5303C14.1768 15.2374 14.1768 14.7626 14.4697 14.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product remove": {
        defaultColors: ["#000000"],
        keywords: ["box","package","remove","delete","minus","order","remove-order","delete-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 15L18 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 15L14 19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product reshare-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["sync","resync","refresh","reload","update","rotate","loop","arrows","exchange","reorder","cycle","circulation","repeat","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 17.8233 19.0003 18.0205 18.9575 18.1825C18.8389 18.6312 18.4885 18.9816 18.0398 19.1002C17.8778 19.143 17.6805 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product reshare-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","return","exchange","resend","shipment","delivery","product-return","refund","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 17.8233 19.0003 18.0205 18.9575 18.1825C18.8389 18.6312 18.4885 18.9816 18.0398 19.1002C17.8778 19.143 17.6805 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product reshare-3": {
        defaultColors: ["#000000"],
        keywords: ["product","reshare","exchange","swap","inventory","stock","sharing","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V12.8823L19.3803 12.5126C18.6969 11.8291 17.5889 11.8291 16.9054 12.5126C16.7997 12.6183 16.7104 12.7342 16.6375 12.857L15.4965 12.8569L15.4506 12.8568C15.1645 12.8561 14.7505 12.8551 14.3572 12.9604C13.3096 13.2411 12.4914 14.0594 12.2107 15.107C12.1053 15.5003 12.1063 15.9143 12.1071 16.2004L12.1072 16.2463L12.1072 16.3213C12.1072 16.894 12.3823 17.4025 12.8076 17.7217L12.6227 17.9066C12.2945 18.2348 12.1102 18.68 12.1102 19.1441C12.1102 19.3529 12.1475 19.5578 12.2184 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6124 13.2197C17.9053 12.9268 18.3802 12.9268 18.673 13.2197L19.5302 14.0768C19.6708 14.2175 19.7499 14.4082 19.7499 14.6071C19.7499 14.8061 19.6708 14.9968 19.5302 15.1375L18.673 15.9946C18.3802 16.2875 17.9053 16.2875 17.6124 15.9946C17.4386 15.8208 17.3679 15.583 17.4004 15.3571L15.5714 15.357C15.1245 15.357 15.0482 15.3634 15.0041 15.3753C14.8193 15.4248 14.6749 15.5692 14.6253 15.7541C14.6135 15.7981 14.6071 15.8744 14.6071 16.3213C14.6071 16.7355 14.2713 17.0713 13.8571 17.0713C13.4429 17.0713 13.1071 16.7355 13.1071 16.3213C13.1071 16.2957 13.107 16.2702 13.107 16.245C13.1066 15.9241 13.1062 15.6281 13.1764 15.3658C13.3647 14.6633 13.9134 14.1146 14.6159 13.9264C14.8781 13.8561 15.1742 13.8565 15.495 13.8569C15.5203 13.857 15.5458 13.857 15.5714 13.857L17.4004 13.8571C17.368 13.6312 17.4386 13.3934 17.6124 13.2197Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.2475 20.5316C14.9546 20.8244 14.4797 20.8244 14.1868 20.5316L13.3297 19.6744C13.189 19.5338 13.11 19.343 13.11 19.1441C13.11 18.9452 13.189 18.7544 13.3297 18.6137L14.1868 17.7566C14.4797 17.4637 14.9546 17.4637 15.2475 17.7566C15.4213 17.9304 15.4919 18.1682 15.4595 18.3941L17.2885 18.3942C17.7353 18.3942 17.8116 18.3878 17.8557 18.376C18.0406 18.3264 18.185 18.182 18.2345 17.9972C18.2463 17.9531 18.2528 17.8768 18.2528 17.4299C18.2528 17.0157 18.5886 16.6799 19.0028 16.6799C19.417 16.6799 19.7528 17.0157 19.7528 17.4299C19.7528 17.4555 19.7528 17.481 19.7529 17.5063C19.7533 17.8271 19.7537 18.1231 19.6834 18.3854C19.4952 19.0879 18.9465 19.6366 18.244 19.8249C17.9817 19.8951 17.6857 19.8947 17.3648 19.8943C17.3395 19.8943 17.3141 19.8942 17.2885 19.8942L15.4595 19.8941C15.4919 20.12 15.4212 20.3578 15.2475 20.5316Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product reshare": {
        defaultColors: ["#000000"],
        keywords: ["broken","image","unavailable","error","missing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1431 15.4643L19.0002 14.6071L18.1431 13.75"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8574 16.3213V16.3213C13.8574 15.9227 13.8574 15.7234 13.9012 15.5599C14.0201 15.1163 14.3667 14.7697 14.8104 14.6508C14.9739 14.607 15.1731 14.607 15.5717 14.607L19.0003 14.607"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.7148 18.2856L13.8577 19.1428L14.7148 19.9999"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0003 17.4287V17.4287C19.0003 17.8233 19.0003 18.0205 18.9575 18.1825C18.8389 18.6312 18.4885 18.9816 18.0398 19.1002C17.8778 19.143 17.6805 19.143 17.286 19.143H13.8574"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product return-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","return","undo","arrow-left","product return","refund","reverse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product return": {
        defaultColors: ["#000000"],
        keywords: ["return","product-return","box","package","undo","reverse-transaction","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product return-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["return","arrow-back","undo","refund","exchange","reverse-transaction","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4286 15.4286L17.2143 15.4286C18.2005 15.4286 19 16.2281 19 17.2143V17.2143V17.2143C19 18.2005 18.2005 19 17.2143 19L14 19"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.1426 14L15.7242 14.4184C15.248 14.8946 15.0099 15.1327 15.0099 15.4286C15.0099 15.7244 15.248 15.9625 15.7242 16.4387L16.1426 16.8571"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product search-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","search","find","product-search","item-search","inventory-search","lookup","product","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.6581 17.6581L19 19M17.6581 17.6581C18.0459 17.2703 18.2857 16.7346 18.2857 16.1429C18.2857 14.9594 17.3263 14 16.1429 14C14.9594 14 14 14.9594 14 16.1429C14 17.3263 14.9594 18.2857 16.1429 18.2857C16.7346 18.2857 17.2703 18.0459 17.6581 17.6581Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product return-3": {
        defaultColors: ["#000000"],
        keywords: ["product","return","product-return","box","arrow","undo","refund","reverse","transaction-reversal","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.6705 6.70502C19.5863 6.07686 19.4007 5.51088 18.9445 5.05462C18.4891 4.59928 17.9222 4.41367 17.2941 4.32955C16.772 4.25914 16.131 4.25091 15.3749 4.25V6.20304C15.3749 7.0223 15.3749 7.4813 15.1316 7.85893C14.871 8.28227 14.412 8.552 13.9165 8.58766L13.8269 8.5968C13.4053 8.5968 13.0186 8.39107 12.3475 8.03265L12.342 8.02991C12.2816 7.99516 12.2185 7.96225 12.1682 7.93664C12.1591 7.93207 12.1564 7.93116 12.1481 7.9275L12 7.85893L11.872 7.92293C11.8455 7.93573 11.8363 7.94122 11.8007 7.96042C11.7595 7.98236 11.7129 8.00613 11.6672 8.02991L11.6434 8.04271C10.9384 8.42216 10.5462 8.63246 10.0918 8.5968C9.5971 8.56114 9.1381 8.2905 8.86745 7.86807C8.62423 7.4813 8.62423 7.03144 8.62423 6.21219V4.25C7.86807 4.25091 7.22711 4.25914 6.70502 4.32955C6.07686 4.41367 5.50997 4.59928 5.05462 5.05462C4.59928 5.50997 4.41458 6.07778 4.32955 6.70502C4.25 7.30026 4.25 8.04911 4.25 8.94791V15.0521C4.25 15.95 4.25 16.6997 4.32955 17.2941C4.41367 17.9222 4.59928 18.4882 5.05462 18.9445C5.50997 19.3998 6.07686 19.5854 6.70502 19.6705C7.30026 19.7509 8.04911 19.75 8.94791 19.75H12.5751C12.3465 19.7207 12.2103 19.5991 12.1271 19.462C11.9872 19.248 11.9991 19.0002 11.9991 19.0002C11.9991 18.586 12.3347 18.2505 12.7488 18.2505H16.8634C17.7119 18.2505 18.3995 17.5629 18.3995 16.7144C18.3995 15.8659 17.7119 15.1783 16.8634 15.1783H15.2743L15.4224 15.3264C15.715 15.619 15.715 16.0944 15.4224 16.387C15.1298 16.6796 14.6543 16.6796 14.3618 16.387L13.943 15.9683L13.9146 15.9399C13.7007 15.7269 13.4913 15.5166 13.3413 15.32C13.1713 15.0969 13.0094 14.8052 13.0094 14.4276C13.0094 14.05 13.1713 13.7583 13.3413 13.5352C13.4913 13.3386 13.7016 13.1283 13.9146 12.9153L13.943 12.8869L14.3618 12.4681C14.6543 12.1756 15.1298 12.1756 15.4224 12.4681C15.715 12.7607 15.715 13.2362 15.4224 13.5288L15.2743 13.6769H16.8634C18.2221 13.6769 19.3596 14.5757 19.7463 15.8073C19.7482 15.5669 19.7491 15.3172 19.7491 15.0503V8.94791C19.7491 8.04911 19.7491 7.30026 19.6695 6.70502H19.6705Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product search-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["search","find","magnify","magnifier","lookup","scan","search-product","find-product","search-item","find-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.6581 17.6581L19 19M17.6581 17.6581C18.0459 17.2703 18.2857 16.7346 18.2857 16.1429C18.2857 14.9594 17.3263 14 16.1429 14C14.9594 14 14 14.9594 14 16.1429C14 17.3263 14.9594 18.2857 16.1429 18.2857C16.7346 18.2857 17.2703 18.0459 17.6581 17.6581Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product search": {
        defaultColors: ["#000000"],
        keywords: ["search","magnifier","magnifying-glass","product-search","find","lookup","inventory","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.6581 17.6581L19 19M17.6581 17.6581C18.0459 17.2703 18.2857 16.7346 18.2857 16.1429C18.2857 14.9594 17.3263 14 16.1429 14C14.9594 14 14 14.9594 14 16.1429C14 17.3263 14.9594 18.2857 16.1429 18.2857C16.7346 18.2857 17.2703 18.0459 17.6581 17.6581Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product search-3": {
        defaultColors: ["#000000"],
        keywords: ["search","product-search","find","item-lookup","scan","barcode","inventory-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.8152C19.2095 13.3471 17.7984 12.3 16.1427 12.3C14.0203 12.3 12.2998 14.0206 12.2998 16.1429C12.2998 17.7984 13.3466 19.2093 14.8143 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.25 16.1429C13.25 14.5452 14.5452 13.25 16.1429 13.25C17.7405 13.25 19.0357 14.5452 19.0357 16.1429C19.0357 16.6691 18.8948 17.1631 18.649 17.5884L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L17.5884 18.649C17.1631 18.8948 16.6691 19.0357 16.1429 19.0357C14.5452 19.0357 13.25 17.7405 13.25 16.1429ZM16.1429 14.75C15.3736 14.75 14.75 15.3736 14.75 16.1429C14.75 16.9121 15.3736 17.5357 16.1429 17.5357C16.5277 17.5357 16.8749 17.3806 17.1278 17.1278C17.3806 16.8749 17.5357 16.5277 17.5357 16.1429C17.5357 15.3736 16.9121 14.75 16.1429 14.75Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product secure-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","locked","secure","security","order","delivery","restricted","confidential","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <rect x="14" y="15.875" width="4.375" height="3.125" rx="0.9375" fill={colors?.[1] || "#000000"} stroke={colors?.[1] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M17.4375 15.875V15.25C17.4375 14.5596 16.8779 14 16.1875 14V14C15.4971 14 14.9375 14.5596 14.9375 15.25V15.875"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product secure-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["lock","secure","security","safe","protection","locked","access","password","authenticate","authorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="14"
                    y="15.875"
                    width="4.375"
                    height="3.125"
                    rx="0.9375"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.4375 15.875V15.25C17.4375 14.5596 16.8779 14 16.1875 14V14C15.4971 14 14.9375 14.5596 14.9375 15.25V15.875"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product secure-3": {
        defaultColors: ["#000000"],
        keywords: ["lock","security","secure","padlock","private","unlock","protection","safe","password","privacy","encryption","access","authorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.2037C19.3254 13.0627 18.2264 12.25 16.9375 12.25C15.4559 12.25 14.2251 13.3241 13.9814 14.736C13.7329 14.9402 13.5221 15.1881 13.3601 15.4688C13.118 15.8881 13.0496 16.3003 13.0229 16.5952C12.9999 16.8485 13 17.1357 13 17.3832L13 17.4662L13 17.4918C13 17.7393 12.9999 18.0265 13.0229 18.2798C13.0496 18.5747 13.118 18.9869 13.3601 19.4063C13.4299 19.5272 13.5088 19.6421 13.5959 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9375 13.25C15.8329 13.25 14.9375 14.1454 14.9375 15.25V15.3016C14.9062 15.3167 14.8749 15.3331 14.8438 15.3511C14.5872 15.4992 14.3742 15.7122 14.2261 15.9688C14.0864 16.2107 14.0392 16.4602 14.0188 16.6855C14 16.893 14 17.1414 14 17.4088V17.4662C14 17.7335 14 17.982 14.0188 18.1895C14.0392 18.4148 14.0864 18.6643 14.2261 18.9063C14.3742 19.1628 14.5872 19.3758 14.8438 19.5239C15.0857 19.6636 15.3352 19.7108 15.5605 19.7312C15.768 19.7501 16.0164 19.75 16.2838 19.75H17.5912C17.8585 19.75 18.107 19.7501 18.3145 19.7312C18.5398 19.7108 18.7893 19.6636 19.0313 19.5239C19.2878 19.3758 19.5008 19.1628 19.6489 18.9063C19.7886 18.6643 19.8358 18.4148 19.8562 18.1895C19.8751 17.982 19.875 17.7335 19.875 17.4662V17.4088C19.875 17.1415 19.8751 16.893 19.8562 16.6855C19.8358 16.4602 19.7886 16.2107 19.6489 15.9688C19.5008 15.7122 19.2878 15.4992 19.0313 15.3511C19.0001 15.3331 18.9688 15.3167 18.9375 15.3016V15.25C18.9375 14.1454 18.0421 13.25 16.9375 13.25ZM17.4217 15.125C17.3662 14.9093 17.1705 14.75 16.9375 14.75C16.7045 14.75 16.5088 14.9093 16.4533 15.125H17.4217Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product sent-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["arrow","right","next","forward","process","checkout","continue","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 19L19 17L17 15"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 17L14 17"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product sent-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","send","sent","order-sent","ship","shipped","outbound","delivery","outgoing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path d="M17 19L19 17L17 15" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product sent-3": {
        defaultColors: ["#000000"],
        keywords: ["product","sent","package","box","delivery","shipping","order","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V6.2018V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.2513 19.75 15.4433 19.7491 15.6278L18.0607 13.9393C17.4749 13.3536 16.5251 13.3536 15.9393 13.9393C15.5173 14.3614 15.3993 14.9723 15.5854 15.5L14 15.5C13.1716 15.5 12.5 16.1716 12.5 17C12.5 17.8284 13.1716 18.5 14 18.5L15.5854 18.5C15.4414 18.9084 15.4795 19.3668 15.6999 19.7488C15.4934 19.75 15.2774 19.75 15.0519 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4697 14.4697C16.7626 14.1768 17.2374 14.1768 17.5303 14.4697L19.5303 16.4697C19.8232 16.7625 19.8232 17.2374 19.5303 17.5303L17.5304 19.5303C17.2375 19.8232 16.7626 19.8232 16.4697 19.5303C16.1768 19.2374 16.1768 18.7626 16.4697 18.4697L17.1894 17.75L14 17.75C13.5858 17.75 13.25 17.4142 13.25 17C13.25 16.5858 13.5858 16.25 14 16.25L17.1893 16.25L16.4697 15.5303C16.1768 15.2374 16.1768 14.7626 16.4697 14.4697Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product sent": {
        defaultColors: ["#000000"],
        keywords: ["box","package","sent","delivered","shipping","inventory","products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 19L19 17L17 15" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 17L14 17" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product setting-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","settings","product-settings","inventory-settings","product","inventory","gear","cog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16.5994 14.0408V14.9617"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.6208V19.5417"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.4157L15.0175 15.8699"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.7123L18.9784 18.1666"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.1666L15.0175 17.7123"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.8699L18.9784 15.4157"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 14.957C17.6133 14.957 18.4339 15.7789 18.4339 16.7914C18.4339 17.8039 17.6133 18.6258 16.5995 18.6258C15.5858 18.6258 14.7651 17.8052 14.7651 16.7914C14.7651 15.7777 15.5858 14.957 16.5995 14.957"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product setting-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["settings","gear","cog","configuration","options","system settings","product settings","adjustments","preferences","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5994 14.0408V14.9617"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.6208V19.5417"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.4157L15.0175 15.8699"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.7123L18.9784 18.1666"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.1666L15.0175 17.7123"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.8699L18.9784 15.4157"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 14.957C17.6133 14.957 18.4339 15.7789 18.4339 16.7914C18.4339 17.8039 17.6133 18.6258 16.5995 18.6258C15.5858 18.6258 14.7651 17.8052 14.7651 16.7914C14.7651 15.7777 15.5858 14.957 16.5995 14.957"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product secure": {
        defaultColors: ["#000000"],
        keywords: ["secure","padlock","lock","security","safe","protected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="14" y="15.875" width="4.375" height="3.125" rx="0.9375" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" />
                <path
                    d="M17.4375 15.875V15.25C17.4375 14.5596 16.8779 14 16.1875 14V14C15.4971 14 14.9375 14.5596 14.9375 15.25V15.875"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product setting-3": {
        defaultColors: ["#000000"],
        keywords: ["product","settings","product-settings","configuration","item","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01914 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V14.129C19.3632 13.8976 18.8818 13.8468 18.445 14.0136C18.3286 13.9361 18.207 13.8657 18.0809 13.8031C17.967 13.0876 17.3472 12.5408 16.5996 12.5408C15.8521 12.5408 15.2323 13.0876 15.1184 13.803C14.9921 13.8656 14.8704 13.9361 14.7539 14.0136C14.0744 13.7541 13.2886 14.0215 12.9172 14.6731C12.549 15.3193 12.7136 16.1237 13.272 16.5781C13.2676 16.6486 13.2653 16.7197 13.2653 16.7913C13.2653 16.8629 13.2676 16.9339 13.272 17.0043C12.7136 17.4588 12.549 18.2632 12.9172 18.9094C13.1761 19.3637 13.7461 19.7456 14.3073 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5995 13.2908C17.0137 13.2908 17.3495 13.6265 17.3495 14.0408V14.3174C17.7336 14.4336 18.0799 14.6369 18.3654 14.9043L18.6023 14.7669C18.9606 14.5592 19.4195 14.6812 19.6273 15.0396C19.835 15.3979 19.713 15.8568 19.3546 16.0646L19.1166 16.2026C19.1606 16.3917 19.1839 16.5888 19.1839 16.7913C19.1839 16.9937 19.1606 17.1908 19.1166 17.3799L19.3546 17.5179C19.713 17.7256 19.835 18.1845 19.6273 18.5429C19.4195 18.9012 18.9606 19.0233 18.6023 18.8155L18.3655 18.6783C18.08 18.9456 17.7337 19.149 17.3495 19.2653V19.5417C17.3495 19.9559 17.0137 20.2917 16.5995 20.2917C16.1852 20.2917 15.8495 19.9559 15.8495 19.5417V19.2653C15.4659 19.1493 15.12 18.9465 14.8347 18.6798L14.5917 18.8183C14.2318 19.0234 13.7738 18.8979 13.5687 18.538C13.3636 18.1782 13.4891 17.7202 13.849 17.5151L14.0828 17.3818C14.0386 17.1922 14.0152 16.9945 14.0152 16.7913C14.0152 16.5881 14.0386 16.3904 14.0829 16.2007L13.849 16.0674C13.4891 15.8623 13.3636 15.4043 13.5687 15.0444C13.7738 14.6845 14.2318 14.5591 14.5917 14.7641L14.8349 14.9027C15.1201 14.6361 15.4659 14.4334 15.8495 14.3173V14.0408C15.8495 13.6265 16.1852 13.2908 16.5995 13.2908ZM16.5341 15.7089C16.1825 15.7297 15.8763 15.9176 15.6937 16.1945C15.6861 16.2103 15.6779 16.2259 15.6691 16.2414C15.6578 16.2611 15.6458 16.2801 15.6331 16.2984C15.5577 16.4463 15.5152 16.6138 15.5152 16.7913C15.5152 16.9686 15.5576 17.1359 15.6328 17.2836C15.6456 17.302 15.6577 17.3212 15.6691 17.3411C15.678 17.3567 15.6863 17.3726 15.694 17.3886C15.8764 17.6649 16.182 17.8525 16.533 17.8737C16.5549 17.8718 16.577 17.8708 16.5995 17.8708C16.6219 17.8708 16.6441 17.8718 16.666 17.8737C17.2342 17.8394 17.6839 17.3676 17.6839 16.7913C17.6839 16.2146 17.2336 15.7426 16.6649 15.7089C16.6433 15.7107 16.6215 15.7117 16.5995 15.7117C16.5774 15.7117 16.5556 15.7107 16.5341 15.7089Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product setting": {
        defaultColors: ["#000000"],
        keywords: ["product","settings","product-settings","configure","adjust","item","merchandise","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.5994 14.0408V14.9617"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5994 18.6208V19.5417"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 15.4157L15.0175 15.8699"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 17.7123L18.9784 18.1666"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2203 18.1666L15.0175 17.7123"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1949 15.8699L18.9784 15.4157"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5995 14.957C17.6133 14.957 18.4339 15.7789 18.4339 16.7914C18.4339 17.8039 17.6133 18.6258 16.5995 18.6258C15.5858 18.6258 14.7651 17.8052 14.7651 16.7914C14.7651 15.7777 15.5858 14.957 16.5995 14.957"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product shield-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","shield","security","inventory","protected","warranty","insurance","secure-product","safe-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 15.7408V14.7143C14.6854 14.7143 15.9606 14.3548 16.5 14C17.0394 14.3548 18.3146 14.7143 19 14.7143V15.7408C19 17.2807 17.9693 18.6265 16.5 19C15.0307 18.6265 14 17.2807 14 15.7408Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product shield-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["shield","security","protection","safe","warranty","insurance","product-protection","secure-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15.0889V13.8571C13.8225 13.8571 15.3527 13.4258 16 13C16.6473 13.4258 18.1775 13.8571 19 13.8571V15.0889C19 16.9368 17.7631 18.5518 16 19C14.2369 18.5518 13 16.9368 13 15.0889Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product shield": {
        defaultColors: ["#000000"],
        keywords: ["product","shield","security","protection","inventory","safe","warranty","assurance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15.0889V13.8571C13.8225 13.8571 15.3527 13.4258 16 13C16.6473 13.4258 18.1775 13.8571 19 13.8571V15.0889C19 16.9368 17.7631 18.5518 16 19C14.2369 18.5518 13 16.9368 13 15.0889Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product time-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","product","item","inventory","stock","favorite","wishlist","saved-item","saved-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 17C20 18.6603 18.6603 20 17 20C15.3397 20 14 18.6603 14 17C14 15.3397 15.3397 14 17 14C18.6603 14 20 15.3397 20 17Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.6122 17.1832H16.5713V16.1428"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product shield-3": {
        defaultColors: ["#000000"],
        keywords: ["shield","protection","secure","product","warranty","insurance","safe","security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V13.1327C19.5227 13.0247 19.2684 12.9643 19 12.9643C18.8907 12.9643 18.5785 12.922 18.174 12.807C17.9814 12.7522 17.8121 12.6934 17.6793 12.6395C17.613 12.6126 17.5597 12.5886 17.5196 12.5688C17.4818 12.5502 17.464 12.5393 17.4617 12.538C16.8781 12.154 16.1219 12.154 15.5383 12.538C15.536 12.5393 15.5182 12.5502 15.4804 12.5688C15.4403 12.5886 15.387 12.6126 15.3208 12.6395C15.1878 12.6934 15.0186 12.7522 14.826 12.807C14.4215 12.922 14.1093 12.9643 14 12.9643C13.0335 12.9643 12.25 13.7478 12.25 14.7143V15.7408C12.25 17.3306 12.9799 18.7984 14.1684 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0878 13.3734C16.338 13.2089 16.662 13.2089 16.9122 13.3734C17.0862 13.4879 17.4528 13.6415 17.9004 13.7688C18.3434 13.8948 18.7573 13.9643 19 13.9643C19.4142 13.9643 19.75 14.3001 19.75 14.7143V15.7408C19.75 17.6151 18.4949 19.2668 16.6848 19.7269C16.5635 19.7577 16.4365 19.7577 16.3152 19.7269C14.5051 19.2668 13.25 17.6151 13.25 15.7408V14.7143C13.25 14.3001 13.5858 13.9643 14 13.9643C14.2427 13.9643 14.6566 13.8948 15.0996 13.7688C15.5472 13.6415 15.9138 13.4879 16.0878 13.3734Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product time-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["time","clock","history","schedule","appointment","duration","wait-time","delay","past","reminder","date","service-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 16.5C20 18.437 18.437 20 16.5 20C14.563 20 13 18.437 13 16.5C13 14.563 14.563 13 16.5 13C18.437 13 20 14.563 20 16.5Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.2144 16.7138H16V15.5"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product time-3": {
        defaultColors: ["#000000"],
        keywords: ["clock","time","history","schedule","reminder","product-time","product","time-3"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V13.8384C18.9833 12.7278 17.7016 12 16.25 12C13.9028 12 12 13.9028 12 16.25C12 17.7016 12.7278 18.9833 13.8384 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 16.25C13 14.4551 14.4551 13 16.25 13C18.0449 13 19.5 14.4551 19.5 16.25C19.5 18.0449 18.0449 19.5 16.25 19.5C14.4551 19.5 13 18.0449 13 16.25ZM16.75 15C16.75 14.5858 16.4142 14.25 16 14.25C15.5858 14.25 15.25 14.5858 15.25 15V16.2138C15.25 16.628 15.5858 16.9638 16 16.9638H17.2144C17.6286 16.9638 17.9644 16.628 17.9644 16.2138C17.9644 15.7996 17.6286 15.4638 17.2144 15.4638H16.75V15Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product time": {
        defaultColors: ["#000000"],
        keywords: ["time","product-time","schedule","clock","product-schedule","availability","limited-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 16.5C20 18.437 18.437 20 16.5 20C14.563 20 13 18.437 13 16.5C13 14.563 14.563 13 16.5 13C18.437 13 20 14.563 20 16.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.2144 16.7138H16V15.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V10.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product tracking-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","location","tracking","delivery","shipping","order-tracking","package-location","order","destination"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product tracking-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["location","map","pin","address","store-location","delivery-address","shipping-address","point-of-sale","geotag","geo-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product tracking-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","inventory","stock","product","tracking","shipment","delivery","order","supply chain","warehouse","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.70508 4.32861C7.22852 4.25977 7.86914 4.25 8.62451 4.25L8.62109 6.21143C8.62109 6.54443 8.62109 6.81641 8.63721 7.04785C8.66113 7.38525 8.71973 7.63721 8.86328 7.86572C9.13135 8.2876 9.59229 8.55908 10.0859 8.59473C10.3423 8.61328 10.5791 8.55469 10.8643 8.43164C11.0835 8.33691 11.3315 8.2041 11.6387 8.03906L11.6616 8.02588C11.7075 8.00342 11.7529 7.98047 11.7959 7.95752C11.8677 7.91846 11.9492 7.88232 11.9492 7.88232L11.9951 7.85938L12.0508 7.88232L12.3384 8.0293H12.3447C13.0186 8.38916 13.4043 8.59473 13.8262 8.59473L13.9175 8.58496C14.4146 8.54932 14.8721 8.27783 15.1338 7.85596C15.3755 7.47998 15.3755 7.01904 15.3755 6.20166V4.25C16.1309 4.25 16.7715 4.25977 17.2949 4.32861C17.9224 4.41357 18.4912 4.59961 18.9458 5.0542C19.4004 5.51221 19.5864 6.07764 19.6714 6.70508C19.75 7.30029 19.75 8.04883 19.75 8.94824V13.4912C19.0298 12.6777 17.979 12.1631 16.8101 12.1602H16.8003C14.6323 12.1655 12.8701 13.9312 12.8701 16.1001C12.8701 17.1909 13.4307 18.1084 13.8638 18.6753C14.1797 19.0933 14.5371 19.4609 14.8506 19.75H8.94824C8.39893 19.75 7.90625 19.75 7.47021 19.7319C7.19189 19.7207 6.93701 19.7021 6.70508 19.6714C6.07764 19.5864 5.50879 19.4004 5.0542 18.9458C4.59961 18.4878 4.41357 17.9224 4.32861 17.2949C4.25 16.6997 4.25 15.9512 4.25 15.0518V8.94824C4.25 8.04883 4.25 7.30029 4.32861 6.70508C4.41357 6.07764 4.59961 5.51221 5.0542 5.0542C5.24658 4.86328 5.45752 4.71973 5.68408 4.61133C5.99756 4.46143 6.34082 4.37793 6.70508 4.32861Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M16.8101 13.1602C15.1901 13.1602 13.8701 14.4802 13.8701 16.1002C13.8701 16.8602 14.2701 17.5602 14.6601 18.0702C15.0601 18.6002 15.5501 19.0502 15.8901 19.3302C15.9901 19.4202 16.1101 19.5102 16.2401 19.5902C16.3801 19.6702 16.5701 19.7502 16.8101 19.7502C17.0501 19.7502 17.2401 19.6702 17.3701 19.5902C17.5001 19.5102 17.6201 19.4202 17.7201 19.3302C18.0601 19.0402 18.5401 18.5902 18.9501 18.0702C19.3401 17.5602 19.7401 16.8702 19.7401 16.1002C19.7401 14.4802 18.4201 13.1602 16.8001 13.1602H16.8101ZM16.8101 16.8602C16.3901 16.8602 16.0501 16.5202 16.0501 16.1002C16.0501 15.6802 16.3901 15.3402 16.8101 15.3402C17.2301 15.3402 17.5701 15.6802 17.5701 16.1002C17.5701 16.5202 17.2301 16.8602 16.8101 16.8602Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product tracking": {
        defaultColors: ["#000000"],
        keywords: ["inventory","box","package","product","track","tracking","stock","supply chain","delivery","shipment","warehouse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1881 16.025C16.2778 16.0253 16.3502 16.0983 16.35 16.1879C16.3498 16.2776 16.277 16.3501 16.1873 16.35C16.0976 16.3499 16.025 16.2772 16.025 16.1875C16.0248 16.1442 16.0419 16.1027 16.0726 16.0721C16.1032 16.0416 16.1449 16.0246 16.1881 16.025"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16.1875C14 17.2116 15.1175 18.3055 15.755 18.8465C16.1336 19.1677 16.2436 19.165 16.6194 18.8465C17.2575 18.3055 18.375 17.2116 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product view-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","product","inventory","item","eye","view","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8008 14.25H15.7992C14.3987 14.2515 13.2167 15.0793 12.4721 16.243C12.176 16.7057 12.176 17.2944 12.4721 17.7571C13.2167 18.9207 14.3987 19.7485 15.7992 19.75H15.8008C17.2013 19.7485 18.3833 18.9207 19.1279 17.7571C19.424 17.2944 19.424 16.7057 19.1279 16.243C18.3833 15.0793 17.2013 14.2515 15.8008 14.25ZM16.4001 17.0499C16.4001 17.4089 16.1091 17.6999 15.7501 17.6999C15.3911 17.6999 15.1001 17.4089 15.1001 17.0499C15.1001 16.6909 15.3911 16.3999 15.7501 16.3999C16.1091 16.3999 16.4001 16.6909 16.4001 17.0499Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product view-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["view","eye","look","see","details","preview","inspect","visibility","show","product-view","item-details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8 19C16.8838 18.9989 17.8527 18.3585 18.4962 17.3528C18.6346 17.1365 18.6346 16.8635 18.4962 16.6472C17.8527 15.6416 16.8838 15.0011 15.8 15C14.7162 15.0011 13.7473 15.6416 13.1038 16.6472C12.9654 16.8635 12.9654 17.1365 13.1038 17.3528C13.7473 18.3585 14.7162 18.9989 15.8 19Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7501 17.6999C16.1091 17.6999 16.4001 17.4089 16.4001 17.0499C16.4001 16.6909 16.1091 16.3999 15.7501 16.3999C15.3911 16.3999 15.1001 16.6909 15.1001 17.0499C15.1001 17.4089 15.3911 17.6999 15.7501 17.6999Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product view-3": {
        defaultColors: ["#000000"],
        keywords: ["product","view","details","info","inventory","item","stock","description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.1646 19.75 15.2748 19.7498 15.3827C18.8566 14.1665 17.4811 13.2518 15.8018 13.25L15.7992 13.25L15.7982 13.25C13.974 13.2519 12.5082 14.3312 11.6297 15.704C11.1234 16.4953 11.1234 17.5048 11.6298 18.2961C11.9805 18.8441 12.4248 19.3454 12.9481 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8008 14.25H15.7992C14.3987 14.2515 13.2167 15.0793 12.4721 16.243C12.176 16.7057 12.176 17.2944 12.4721 17.7571C13.2167 18.9207 14.3987 19.7485 15.7992 19.75H15.8008C17.2013 19.7485 18.3833 18.9207 19.1279 17.7571C19.424 17.2944 19.424 16.7057 19.1279 16.243C18.3833 15.0793 17.2013 14.2515 15.8008 14.25ZM16.4001 17.0499C16.4001 17.4089 16.1091 17.6999 15.7501 17.6999C15.3911 17.6999 15.1001 17.4089 15.1001 17.0499C15.1001 16.6909 15.3911 16.3999 15.7501 16.3999C16.1091 16.3999 16.4001 16.6909 16.4001 17.0499Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product view": {
        defaultColors: ["#000000"],
        keywords: ["product","view","item","inventory","list","catalog","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8 19C16.8838 18.9989 17.8527 18.3585 18.4962 17.3528C18.6346 17.1365 18.6346 16.8635 18.4962 16.6472C17.8527 15.6416 16.8838 15.0011 15.8 15C14.7162 15.0011 13.7473 15.6416 13.1038 16.6472C12.9654 16.8635 12.9654 17.1365 13.1038 17.3528C13.7473 18.3585 14.7162 18.9989 15.8 19Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.7501 17.6999C16.1091 17.6999 16.4001 17.4089 16.4001 17.0499C16.4001 16.6909 16.1091 16.3999 15.7501 16.3999C15.3911 16.3999 15.1001 16.6909 15.1001 17.0499C15.1001 17.4089 15.3911 17.6999 15.7501 17.6999Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M11 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V13"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product warning-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["damaged","error","broken","defect","product-warning","product-issue","problem","irregular","spoiled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "product warning-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["triangle","warning","alert","caution","issue","problem","error","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12.5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product warning-3": {
        defaultColors: ["#000000"],
        keywords: ["warning","exclamation","alert","problem","issue","error","attention","notify","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.1102 19.75 15.1678 19.75 15.2248C19.5756 14.9329 19.3992 14.6499 19.2251 14.4162C18.9744 14.0795 18.5317 13.5638 17.8005 13.3414C17.2788 13.1827 16.7217 13.1827 16.2 13.3414C15.4688 13.5638 15.0261 14.0795 14.7754 14.4162L14.0539 15.5574L13.9715 15.6974C13.7276 16.1118 13.4783 16.5356 13.3105 16.9079C13.1366 17.2938 12.8951 17.9437 13.0654 18.7024C13.151 19.0836 13.3163 19.4403 13.5486 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M17.5094 14.2981C17.1775 14.1972 16.8229 14.1972 16.491 14.2981C16.0709 14.4259 15.789 14.7292 15.5774 15.0134C15.3704 15.2914 15.1493 15.6673 14.8954 16.099L14.854 16.1693C14.5935 16.6122 14.3674 16.9966 14.2221 17.3188C14.0744 17.6467 13.9434 18.048 14.0411 18.4834C14.118 18.826 14.2962 19.1375 14.5525 19.3775C14.8783 19.6825 15.2905 19.7731 15.6481 19.812C15.9995 19.8502 16.4454 19.8501 16.9593 19.8501H17.0411C17.555 19.8501 18.0009 19.8502 18.3523 19.812C18.7099 19.7731 19.1221 19.6825 19.4479 19.3775C19.7042 19.1375 19.8824 18.826 19.9593 18.4834C20.057 18.048 19.926 17.6467 19.7783 17.3188C19.633 16.9966 19.4069 16.6122 19.1463 16.1693L19.105 16.099C18.8511 15.6673 18.63 15.2914 18.423 15.0134C18.2114 14.7292 17.9295 14.4259 17.5094 14.2981Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product warning": {
        defaultColors: ["#000000"],
        keywords: ["warning","product","alert","exclamation","inventory","stock","problem","issue","error","flag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9351 18.83C18.6467 19.1 18.0978 19.1 17 19.1C15.9022 19.1 15.3533 19.1 15.0649 18.83C14.9185 18.6928 14.8166 18.5148 14.7727 18.319C14.6862 17.9335 14.9645 17.4604 15.5211 16.5142C16.0642 15.5908 16.3358 15.1291 16.709 15.0156C16.8987 14.9579 17.1013 14.9579 17.291 15.0156C17.6642 15.1291 17.9358 15.5908 18.4789 16.5142C19.0355 17.4604 19.3138 17.9335 19.2273 18.319C19.1834 18.5148 19.0815 18.6928 18.9351 18.83Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.5 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12.5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-hunt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["P","product","price","promotion","pay","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8H12C13.6569 8 15 9.34315 15 11V11C15 12.6569 13.6569 14 12 14H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-hunt": {
        defaultColors: ["#3D4C66"],
        keywords: ["P","payment","pending","process","processing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8H12C13.6569 8 15 9.34315 15 11V11C15 12.6569 13.6569 14 12 14H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-hunt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["P","payment","pending","points","price","promotion","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13V9H12C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM8 8C8 7.44772 8.44772 7 9 7H12C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15H10V16C10 16.5523 9.55228 17 9 17C8.44772 17 8 16.5523 8 16V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "product-hunt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["P","Product","Payment","Price","POS","Category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8H12C13.6569 8 15 9.34315 15 11V11C15 12.6569 13.6569 14 12 14H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-label-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["product","label","package","box","inventory","item","stock","shipping","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-label-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["label","tag","product","price","information","item","discount","offer","rectangle","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-label-3": {
        defaultColors: ["#000000"],
        keywords: ["tag","label","price","product","name","identification","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.5 15.5V13.5H12.5V15.5H8.5Z" fill={colors?.[0] || "#000000"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.70528 4.32846C7.22763 4.25991 7.86732 4.25003 8.62112 4.25V6.21161C8.62112 7.02895 8.62112 7.48012 8.86306 7.8659C9.13114 8.28765 9.59212 8.55901 10.0858 8.59497C10.5402 8.62766 10.9326 8.41842 11.6387 8.03918L11.6616 8.0261C11.7074 8.00322 11.7532 7.98033 11.7957 7.95745C11.8676 7.91821 11.9493 7.88225 11.9493 7.88225L11.9951 7.85936L12.0507 7.88225L12.3384 8.02937H12.3449C13.0184 8.389 13.4042 8.59497 13.8259 8.59497L13.9175 8.58516C14.4144 8.5492 14.8721 8.27784 15.1337 7.8561C15.3756 7.48012 15.3756 7.01915 15.3756 6.20181V4.25C16.1308 4.25 16.7716 4.25981 17.2947 4.32846C17.9224 4.41347 18.4913 4.59982 18.9457 5.05426C19.4002 5.51197 19.5865 6.07757 19.6715 6.70528C19.75 7.30031 19.75 8.04899 19.75 8.94806V15.0519C19.75 15.951 19.75 16.6997 19.6715 17.2947C19.5865 17.9224 19.4002 18.4913 18.9457 18.9457C18.488 19.4002 17.9224 19.5865 17.2947 19.6715C16.6997 19.75 15.951 19.75 15.0519 19.75H8.94806C8.04899 19.75 7.30031 19.75 6.70528 19.6715C6.07757 19.5865 5.5087 19.4002 5.05426 18.9457C4.59982 18.488 4.41347 17.9224 4.32846 17.2947C4.25 16.6997 4.25 15.951 4.25 15.0519V8.94806C4.25 8.04899 4.25 7.30031 4.32846 6.70528C4.41347 6.07757 4.59982 5.51197 5.05426 5.05426C5.51197 4.59982 6.07757 4.41347 6.70528 4.32846ZM8 12.25C7.58579 12.25 7.25 12.5858 7.25 13V16.0012C7.25 16.4155 7.58579 16.7513 8 16.7513H13.0021C13.4163 16.7513 13.7521 16.4155 13.7521 16.0012V13C13.7521 12.5858 13.4163 12.25 13.0021 12.25H8Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product-label": {
        defaultColors: ["#000000"],
        keywords: ["product","label","price","tag","item","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="8"
                    y="13"
                    width="5.00208"
                    height="3.00125"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "product-taped-1": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","order","product","item","taped","sealed","shipment","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773L12.7263 7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5H9Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 14L10 14" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "product-taped-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","taped","sealed","fragile","shipping","delivery","product","item","order","packed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.625 4.25014C7.86855 4.25117 7.22754 4.25973 6.70553 4.32992C6.07773 4.41432 5.51093 4.59999 5.05546 5.05546C4.59999 5.51093 4.41432 6.07773 4.32992 6.70553C4.24995 7.30029 4.24997 8.04949 4.25 8.94794V15.052C4.24997 15.9505 4.24995 16.6997 4.32992 17.2945C4.41432 17.9223 4.59999 18.4891 5.05546 18.9445C5.51093 19.4 6.07773 19.5857 6.70552 19.6701C7.3003 19.7501 8.04951 19.75 8.94798 19.75H15.052C15.9505 19.75 16.6997 19.7501 17.2945 19.6701C17.9223 19.5857 18.4891 19.4 18.9445 18.9445C19.4 18.4891 19.5857 17.9223 19.6701 17.2945C19.7501 16.6997 19.75 15.9505 19.75 15.052V8.94801C19.75 8.04954 19.7501 7.3003 19.6701 6.70552C19.5857 6.07773 19.4 5.51093 18.9445 5.05546C18.4891 4.59999 17.9223 4.41432 17.2945 4.32992C16.7725 4.25973 16.1315 4.25117 15.375 4.25014V6.203C15.375 7.022 15.375 7.481 15.132 7.859C14.871 8.282 14.412 8.552 13.917 8.588L13.827 8.597C13.4051 8.597 13.0191 8.3911 12.3474 8.03286L12.342 8.03C12.216 7.958 12.09 7.895 12.054 7.886L12 7.868L11.955 7.886C11.9321 7.89172 11.873 7.92283 11.8006 7.96091C11.759 7.9828 11.713 8.007 11.667 8.03L11.6435 8.04265C10.9383 8.4217 10.546 8.63261 10.092 8.597C9.597 8.561 9.138 8.291 8.868 7.868C8.625 7.481 8.625 7.031 8.625 6.212V4.25014ZM9.25 14C9.25 13.5858 9.58579 13.25 10 13.25H14C14.4142 13.25 14.75 13.5858 14.75 14C14.75 14.4142 14.4142 14.75 14 14.75H10C9.58579 14.75 9.25 14.4142 9.25 14Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "product-taped": {
        defaultColors: ["#000000"],
        keywords: ["product","item","stock","inventory","package","box","taped","sealed","wrapped","delivery","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 14L10 14" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "product-taped-2": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["minus","remove","subtract","decrease","discount","reduce","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19H9C7.11438 19 6.17157 19 5.58579 18.4142C5 17.8284 5 16.8856 5 15Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5V6.42473C9 7.22257 9 7.6215 9.15356 7.8656C9.32314 8.13515 9.61096 8.30782 9.9286 8.33056C10.2163 8.35115 10.5682 8.16338 11.2722 7.78784V7.78784C11.5221 7.65449 11.6471 7.58782 11.778 7.55811C11.9236 7.52509 12.0747 7.52507 12.2203 7.55806C12.3513 7.58774 12.4763 7.6544 12.7263 7.78773V7.78773C13.4317 8.16384 13.7845 8.3519 14.0726 8.33092C14.3895 8.30785 14.6765 8.13561 14.8459 7.86687C15 7.62247 15 7.2229 15 6.42375V5"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L10 14"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Q-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["queue","inquiry","question","query","request","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4709 19.5296C16.7638 19.8225 17.2387 19.8225 17.5316 19.5296C17.8245 19.2367 17.8245 18.7619 17.5316 18.469L16.4709 19.5296ZM14.5316 15.469C14.2387 15.1761 13.7638 15.1761 13.4709 15.469C13.178 15.7619 13.178 16.2367 13.4709 16.5296L14.5316 15.469ZM16.25 10V14H17.75V10H16.25ZM7.75 14V10H6.25V14H7.75ZM12 18.25C9.65279 18.25 7.75 16.3472 7.75 14H6.25C6.25 17.1756 8.82436 19.75 12 19.75V18.25ZM16.25 14C16.25 16.3472 14.3472 18.25 12 18.25V19.75C15.1756 19.75 17.75 17.1756 17.75 14H16.25ZM12 5.75C14.3472 5.75 16.25 7.65279 16.25 10H17.75C17.75 6.82436 15.1756 4.25 12 4.25V5.75ZM12 4.25C8.82436 4.25 6.25 6.82436 6.25 10H7.75C7.75 7.65279 9.65279 5.75 12 5.75V4.25ZM17.5316 18.469L14.5316 15.469L13.4709 16.5296L16.4709 19.5296L17.5316 18.469Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Q-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["Q","query","queue","question","search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4709 19.5296C16.7638 19.8225 17.2387 19.8225 17.5316 19.5296C17.8245 19.2367 17.8245 18.7619 17.5316 18.469L16.4709 19.5296ZM14.5316 15.469C14.2387 15.1761 13.7638 15.1761 13.4709 15.469C13.178 15.7619 13.178 16.2367 13.4709 16.5296L14.5316 15.469ZM16.25 10V14H17.75V10H16.25ZM7.75 14V10H6.25V14H7.75ZM12 18.25C9.65279 18.25 7.75 16.3472 7.75 14H6.25C6.25 17.1756 8.82436 19.75 12 19.75V18.25ZM16.25 14C16.25 16.3472 14.3472 18.25 12 18.25V19.75C15.1756 19.75 17.75 17.1756 17.75 14H16.25ZM12 5.75C14.3472 5.75 16.25 7.65279 16.25 10H17.75C17.75 6.82436 15.1756 4.25 12 4.25V5.75ZM12 4.25C8.82436 4.25 6.25 6.82436 6.25 10H7.75C7.75 7.65279 9.65279 5.75 12 5.75V4.25ZM17.5316 18.469L14.5316 15.469L13.4709 16.5296L16.4709 19.5296L17.5316 18.469Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Q-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["q","question","query","quick","quantity","quote","qualify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10V14C18 15.2953 17.5895 16.4948 16.8916 17.4754L17.7083 18.2922C18.0989 18.6827 18.0989 19.3159 17.7083 19.7064C17.3178 20.0969 16.6846 20.0969 16.2941 19.7064L15.4777 18.8899C14.4966 19.5889 13.2963 20 12 20C8.68629 20 6 17.3137 6 14V10ZM15.4469 16.0308L14.7083 15.2922C14.3178 14.9017 13.6846 14.9017 13.2941 15.2922C12.9036 15.6827 12.9036 16.3159 13.2941 16.7064L14.0332 17.4455C13.4374 17.7978 12.7423 18 12 18C9.79086 18 8 16.2091 8 14V10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V14C16 14.7413 15.7983 15.4355 15.4469 16.0308Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Q: {
        defaultColors: ["#3D4C66"],
        keywords: ["q","question","query","quick","quantity","quote","qualify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.4709 19.5296C16.7638 19.8225 17.2387 19.8225 17.5316 19.5296C17.8245 19.2367 17.8245 18.7619 17.5316 18.469L16.4709 19.5296ZM14.5316 15.469C14.2387 15.1761 13.7638 15.1761 13.4709 15.469C13.178 15.7619 13.178 16.2367 13.4709 16.5296L14.5316 15.469ZM16.25 10V14H17.75V10H16.25ZM7.75 14V10H6.25V14H7.75ZM12 18.25C9.65279 18.25 7.75 16.3472 7.75 14H6.25C6.25 17.1756 8.82436 19.75 12 19.75V18.25ZM16.25 14C16.25 16.3472 14.3472 18.25 12 18.25V19.75C15.1756 19.75 17.75 17.1756 17.75 14H16.25ZM12 5.75C14.3472 5.75 16.25 7.65279 16.25 10H17.75C17.75 6.82436 15.1756 4.25 12 4.25V5.75ZM12 4.25C8.82436 4.25 6.25 6.82436 6.25 10H7.75C7.75 7.65279 9.65279 5.75 12 5.75V4.25ZM17.5316 18.469L14.5316 15.469L13.4709 16.5296L16.4709 19.5296L17.5316 18.469Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","payment","identification","product-scan","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","scanner","payment","identification","code","data","digital","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L18 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","discount","code","scanner"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.94561 4.00001H8.05442C8.47849 3.99992 8.89062 3.99984 9.23053 4.04554C9.61374 4.09706 10.051 4.22259 10.4142 4.5858C10.7774 4.94902 10.903 5.38629 10.9545 5.7695C11.0002 6.10941 11.0001 6.57597 11 7.00004C11.0001 7.42411 11.0002 7.89062 10.9545 8.23053C10.903 8.61374 10.7774 9.05101 10.4142 9.41423C10.051 9.77744 9.61374 9.90297 9.23053 9.95449C8.89062 10.0002 8.4785 10.0001 8.05444 10H5.9456C5.52154 10.0001 5.10941 10.0002 4.7695 9.95449C4.38629 9.90297 3.94902 9.77744 3.5858 9.41423C3.22259 9.05101 3.09706 8.61374 3.04554 8.23053C2.99984 7.89062 2.99992 7.42411 3.00001 7.00004C2.99992 6.57597 2.99984 6.10941 3.04554 5.76949C3.09706 5.38629 3.22259 4.94902 3.5858 4.5858C3.94902 4.22259 4.38629 4.09706 4.76949 4.04554C5.10941 3.99984 5.52154 3.99992 5.94561 4.00001ZM8 8C8.55229 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6L6 6C5.44772 6 5 6.44772 5 7C5 7.55229 5.44772 8 6 8L8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.94561 14H8.05442C8.47844 13.9999 8.89066 13.9998 9.23053 14.0455C9.61374 14.0971 10.051 14.2226 10.4142 14.5858C10.7774 14.949 10.903 15.3863 10.9545 15.7695C11.0002 16.1094 11.0001 16.576 11 17C11.0001 17.4241 11.0002 17.8906 10.9545 18.2305C10.903 18.6137 10.7774 19.051 10.4142 19.4142C10.051 19.7774 9.61374 19.903 9.23053 19.9545C8.89062 20.0002 8.47849 20.0001 8.05442 20H5.9456C5.52153 20.0001 5.10941 20.0002 4.7695 19.9545C4.38629 19.903 3.94902 19.7774 3.5858 19.4142C3.22259 19.051 3.09706 18.6137 3.04554 18.2305C2.99984 17.8906 2.99992 17.4241 3.00001 17C2.99992 16.576 2.99984 16.1094 3.04554 15.7695C3.09706 15.3863 3.22259 14.949 3.5858 14.5858C3.94902 14.2226 4.38629 14.0971 4.76949 14.0455C5.10937 13.9998 5.52159 13.9999 5.94561 14ZM8 18C8.55229 18 9 17.5523 9 17C9 16.4477 8.55228 16 8 16L6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18L8 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.0544 4.00001H15.9456C15.5215 3.99992 15.1094 3.99984 14.7695 4.04554C14.3863 4.09706 13.949 4.22259 13.5858 4.5858C13.2226 4.94902 13.0971 5.38629 13.0455 5.76949C12.9998 6.1094 12.9999 6.57599 13 7.00004C12.9999 7.42409 12.9998 7.89063 13.0455 8.23053C13.0971 8.61374 13.2226 9.05101 13.5858 9.41423C13.949 9.77744 14.3863 9.90297 14.7695 9.95449C15.1094 10.0002 15.5215 10.0001 15.9456 10H18.0544C18.4785 10.0001 18.8906 10.0002 19.2305 9.95449C19.6137 9.90297 20.051 9.77744 20.4142 9.41423C20.7774 9.05101 20.903 8.61374 20.9545 8.23053C21.0002 7.89062 21.0001 7.42411 21 7.00004C21.0001 6.57597 21.0002 6.10941 20.9545 5.7695C20.903 5.38629 20.7774 4.94902 20.4142 4.5858C20.051 4.22259 19.6137 4.09706 19.2305 4.04554C18.8906 3.99984 18.4785 3.99992 18.0544 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9456 14H18.0544C18.4785 13.9999 18.8906 13.9998 19.2305 14.0455C19.6137 14.0971 20.051 14.2226 20.4142 14.5858C20.7774 14.949 20.903 15.3863 20.9545 15.7695C21.0002 16.1094 21.0001 16.576 21 17C21.0001 17.4241 21.0002 17.8906 20.9545 18.2305C20.903 18.6137 20.7774 19.051 20.4142 19.4142C20.051 19.7774 19.6137 19.903 19.2305 19.9545C18.8906 20.0002 18.4785 20.0001 18.0544 20H15.9456C15.5215 20.0001 15.1094 20.0002 14.7695 19.9545C14.3863 19.903 13.949 19.7774 13.5858 19.4142C13.2226 19.051 13.0971 18.6137 13.0455 18.2305C12.9998 17.8906 12.9999 17.4241 13 17C12.9999 16.576 12.9998 16.1094 13.0455 15.7695C13.0971 15.3863 13.2226 14.949 13.5858 14.5858C13.949 14.2226 14.3863 14.0971 14.7695 14.0455C15.1094 13.9998 15.5216 13.9999 15.9456 14ZM19 17C19 17.5523 18.5523 18 18 18L16 18C15.4477 18 15 17.5523 15 17C15 16.4477 15.4477 16 16 16L18 16C18.5523 16 19 16.4477 19 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 12C21 12.5523 20.5523 13 20 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L20 11C20.5523 11 21 11.4477 21 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","scan-payment","loyalty","loyalty-program","coupon","scan-coupon","mobile-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17V17C14 17.9428 14 18.4142 14.2929 18.7071C14.5858 19 15.0572 19 16 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","payment","barcode","identification","digital-transaction","mobile-payment","verification","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17V17C14 17.9428 14 18.4142 14.2929 18.7071C14.5858 19 15.0572 19 16 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","loyalty","coupon","promotion","identification","verification","data","scanner"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17V17C14 17.9428 14 18.4142 14.2929 18.7071C14.5858 19 15.0572 19 16 19H18C18.9428 19 19.4142 19 19.7071 18.7071C20 18.4142 20 17.9428 20 17V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","scan-qr","scan-barcode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.94561 4.00001H8.05442C8.47849 3.99992 8.89062 3.99984 9.23053 4.04554C9.61374 4.09706 10.051 4.22259 10.4142 4.5858C10.7774 4.94902 10.903 5.38629 10.9545 5.7695C11.0002 6.10941 11.0001 6.57597 11 7.00004C11.0001 7.42411 11.0002 7.89062 10.9545 8.23053C10.903 8.61374 10.7774 9.05101 10.4142 9.41423C10.051 9.77744 9.61374 9.90297 9.23053 9.95449C8.89062 10.0002 8.4785 10.0001 8.05444 10H5.9456C5.52154 10.0001 5.10941 10.0002 4.7695 9.95449C4.38629 9.90297 3.94902 9.77744 3.5858 9.41423C3.22259 9.05101 3.09706 8.61374 3.04554 8.23053C2.99984 7.89062 2.99992 7.42411 3.00001 7.00004C2.99992 6.57597 2.99984 6.10941 3.04554 5.76949C3.09706 5.38629 3.22259 4.94902 3.5858 4.5858C3.94902 4.22259 4.38629 4.09706 4.76949 4.04554C5.10941 3.99984 5.52154 3.99992 5.94561 4.00001ZM9 7C9 7.55228 8.55229 8 8 8L6 8C5.44772 8 5 7.55229 5 7C5 6.44772 5.44772 6 6 6L8 6C8.55228 6 9 6.44772 9 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.94561 14H8.05442C8.47842 13.9999 8.89067 13.9998 9.23053 14.0455C9.61374 14.0971 10.051 14.2226 10.4142 14.5858C10.7774 14.949 10.903 15.3863 10.9545 15.7695C11.0002 16.1094 11.0001 16.5759 11 17C11.0001 17.4241 11.0002 17.8906 10.9545 18.2305C10.903 18.6137 10.7774 19.051 10.4142 19.4142C10.051 19.7774 9.61374 19.903 9.23053 19.9545C8.89062 20.0002 8.47849 20.0001 8.05442 20H5.9456C5.52153 20.0001 5.10941 20.0002 4.7695 19.9545C4.38629 19.903 3.94902 19.7774 3.5858 19.4142C3.22259 19.051 3.09706 18.6137 3.04554 18.2305C2.99984 17.8906 2.99992 17.4241 3.00001 17C2.99992 16.5759 2.99984 16.1094 3.04554 15.7695C3.09706 15.3863 3.22259 14.949 3.5858 14.5858C3.94902 14.2226 4.38629 14.0971 4.76949 14.0455C5.10935 13.9998 5.52161 13.9999 5.94561 14ZM9 17C9 17.5523 8.55229 18 8 18H6C5.44772 18 5 17.5523 5 17C5 16.4477 5.44772 16 6 16H8C8.55228 16 9 16.4477 9 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 4.00001H18.0544C18.4785 3.99992 18.8906 3.99984 19.2305 4.04554C19.6137 4.09706 20.051 4.22259 20.4142 4.5858C20.7774 4.94902 20.903 5.38629 20.9545 5.7695C21.0002 6.10941 21.0001 6.57597 21 7.00004C21.0001 7.42411 21.0002 7.89062 20.9545 8.23053C20.903 8.61374 20.7774 9.05101 20.4142 9.41423C20.051 9.77744 19.6137 9.90297 19.2305 9.95449C18.8906 10.0002 18.4785 10.0001 18.0544 10H15.9456C15.5215 10.0001 15.1094 10.0002 14.7695 9.95449C14.3863 9.90297 13.949 9.77744 13.5858 9.41423C13.2226 9.05101 13.0971 8.61374 13.0455 8.23053C12.9998 7.89063 12.9999 7.42409 13 7.00004C12.9999 6.57599 12.9998 6.1094 13.0455 5.76949C13.0971 5.38629 13.2226 4.94902 13.5858 4.5858C13.949 4.22259 14.3863 4.09706 14.7695 4.04554C15.1094 3.99984 15.5215 3.99992 15.9456 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13L20 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0001 16H20.0001C20.5524 16 21.0001 15.5523 21.0001 15C21.0001 14.4477 20.5524 14 20.0001 14H16.0001C15.4478 14 15.0001 14.4477 15.0001 15C15.0001 15.5523 15.4478 16 16.0001 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0001 18C15.0001 17.4477 14.5524 17 14.0001 17C13.4478 17 13.0001 17.4477 13.0001 18C13.0001 18.0138 12.9998 18.0356 12.9995 18.0609C12.9987 18.1263 12.9976 18.2151 13.0001 18.25C13.0001 19.2165 13.7836 20 14.7501 20H19.2501C20.2166 20 21.0001 19.2165 21.0001 18.25C21.0026 18.2151 21.0015 18.1263 21.0007 18.0609C21.0004 18.0356 21.0001 18.0138 21.0001 18C21.0001 17.4477 20.5524 17 20.0001 17C19.4478 17 19.0001 17.4477 19.0001 18H15.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","payment","identification","product-lookup","inventory","code","scanner","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 15V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 19H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["QR code","scan","barcode","payment","mobile payment","loyalty","coupon","discount","verification","identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 15V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 19H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","loyalty","coupon","discount","verify","identification","mobile-payment","digital-wallet","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M14 15V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 19H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15L20 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","loyalty","coupon","discount","identification","contactless","digital"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76949 4.04554C5.10941 3.99984 5.52154 3.99992 5.94561 4.00001H8.05442C8.47849 3.99992 8.89062 3.99984 9.23053 4.04554C9.61374 4.09706 10.051 4.22259 10.4142 4.5858C10.7774 4.94902 10.903 5.38629 10.9545 5.7695C11.0002 6.10941 11.0001 6.52153 11 6.9456V7.05442C11.0001 7.47849 11.0002 7.89062 10.9545 8.23053C10.903 8.61374 10.7774 9.05101 10.4142 9.41423C10.051 9.77744 9.61374 9.90297 9.23053 9.95449C8.89062 10.0002 8.47849 10.0001 8.05442 10H5.94559C5.52153 10.0001 5.10941 10.0002 4.7695 9.95449C4.38629 9.90297 3.94902 9.77744 3.5858 9.41423C3.22259 9.05101 3.09706 8.61374 3.04554 8.23053C2.99984 7.89062 2.99992 7.47849 3.00001 7.05442V6.94561C2.99992 6.52154 2.99984 6.10941 3.04554 5.76949C3.09706 5.38629 3.22259 4.94902 3.5858 4.5858C3.94902 4.22259 4.38629 4.09706 4.76949 4.04554ZM9 7C9 7.55228 8.55229 8 8 8L6 8C5.44772 8 5 7.55229 5 7C5 6.44772 5.44772 6 6 6L8 6C8.55228 6 9 6.44772 9 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.9456 14H8.05459C8.47859 13.9999 8.89069 13.9998 9.23053 14.0455C9.61374 14.0971 10.051 14.2226 10.4142 14.5858C10.7774 14.949 10.903 15.3863 10.9545 15.7695C11.0002 16.1094 11.0001 16.5759 11 17C11.0001 17.4241 11.0002 17.8906 10.9545 18.2305C10.903 18.6137 10.7774 19.051 10.4142 19.4142C10.051 19.7774 9.61374 19.903 9.23053 19.9545C8.89062 20.0002 8.47849 20.0001 8.05442 20H5.9456C5.52153 20.0001 5.10941 20.0002 4.7695 19.9545C4.38629 19.903 3.94902 19.7774 3.5858 19.4142C3.22259 19.051 3.09706 18.6137 3.04554 18.2305C2.99984 17.8906 2.99992 17.4241 3.00001 17C2.99992 16.5759 2.99984 16.1094 3.04554 15.7695C3.09706 15.3863 3.22259 14.949 3.5858 14.5858C3.94902 14.2226 4.38629 14.0971 4.76949 14.0455C5.10935 13.9998 5.52161 13.9999 5.9456 14ZM9 17C9 17.5523 8.55229 18 8 18H6C5.44772 18 5 17.5523 5 17C5 16.4477 5.44772 16 6 16H8C8.55228 16 9 16.4477 9 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.7695 4.04554C15.1094 3.99984 15.5215 3.99992 15.9456 4.00001H18.0544C18.4785 3.99992 18.8906 3.99984 19.2305 4.04554C19.6137 4.09706 20.051 4.22259 20.4142 4.5858C20.7774 4.94902 20.903 5.38629 20.9545 5.7695C21.0002 6.10941 21.0001 6.52153 21 6.9456V7.05442C21.0001 7.47849 21.0002 7.89062 20.9545 8.23053C20.903 8.61374 20.7774 9.05101 20.4142 9.41423C20.051 9.77744 19.6137 9.90297 19.2305 9.95449C18.8906 10.0002 18.4785 10.0001 18.0544 10H15.9456C15.5215 10.0001 15.1094 10.0002 14.7695 9.95449C14.3863 9.90297 13.949 9.77744 13.5858 9.41423C13.2226 9.05101 13.0971 8.61374 13.0455 8.23053C12.9998 7.89067 12.9999 7.47855 13 7.05455V6.94555C12.9999 6.52155 12.9998 6.10936 13.0455 5.76949C13.0971 5.38629 13.2226 4.94902 13.5858 4.5858C13.949 4.22259 14.3863 4.09706 14.7695 4.04554Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 12C21 12.5523 20.5523 13 20 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L20 11C20.5523 11 21 11.4477 21 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 15C15 14.4477 14.5523 14 14 14C13.4477 14 13 14.4477 13 15V19C13 19.5523 13.4477 20 14 20C14.5523 20 15 19.5523 15 19V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 16H20C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14H17C16.4477 14 16 14.4477 16 15C16 15.5523 16.4477 16 17 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 18C16.4477 18 16 18.4477 16 19C16 19.5523 16.4477 20 17 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["split","group","partition","divide","layout","table","grid","menu","submenu","categorize","arrange","dashboard","modules"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","grid","modules","sections","dashboard","arrangement","group","organize","tiles","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.94561 4.00001H8.05442C8.47849 3.99992 8.89062 3.99984 9.23053 4.04554C9.61374 4.09706 10.051 4.22259 10.4142 4.5858C10.7774 4.94902 10.903 5.38629 10.9545 5.7695C11.0002 6.10941 11.0001 6.57597 11 7.00004C11.0001 7.42411 11.0002 7.89062 10.9545 8.23053C10.903 8.61374 10.7774 9.05101 10.4142 9.41423C10.051 9.77744 9.61374 9.90297 9.23053 9.95449C8.89062 10.0002 8.4785 10.0001 8.05444 10H5.9456C5.52154 10.0001 5.10941 10.0002 4.7695 9.95449C4.38629 9.90297 3.94902 9.77744 3.5858 9.41423C3.22259 9.05101 3.09706 8.61374 3.04554 8.23053C2.99984 7.89062 2.99992 7.42411 3.00001 7.00004C2.99992 6.57597 2.99984 6.10941 3.04554 5.76949C3.09706 5.38629 3.22259 4.94902 3.5858 4.5858C3.94902 4.22259 4.38629 4.09706 4.76949 4.04554C5.10941 3.99984 5.52154 3.99992 5.94561 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.94561 14H8.05442C8.47847 13.9999 8.89064 13.9998 9.23053 14.0455C9.61374 14.0971 10.051 14.2226 10.4142 14.5858C10.7774 14.949 10.903 15.3863 10.9545 15.7695C11.0002 16.1094 11.0001 16.576 11 17C11.0001 17.4241 11.0002 17.8906 10.9545 18.2305C10.903 18.6137 10.7774 19.051 10.4142 19.4142C10.051 19.7774 9.61374 19.903 9.23053 19.9545C8.89062 20.0002 8.47849 20.0001 8.05442 20H5.9456C5.52153 20.0001 5.10941 20.0002 4.7695 19.9545C4.38629 19.903 3.94902 19.7774 3.5858 19.4142C3.22259 19.051 3.09706 18.6137 3.04554 18.2305C2.99984 17.8906 2.99992 17.4241 3.00001 17C2.99992 16.576 2.99984 16.1094 3.04554 15.7695C3.09706 15.3863 3.22259 14.949 3.5858 14.5858C3.94902 14.2226 4.38629 14.0971 4.76949 14.0455C5.10939 13.9998 5.52156 13.9999 5.94561 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 4.00001H18.0544C18.4785 3.99992 18.8906 3.99984 19.2305 4.04554C19.6137 4.09706 20.051 4.22259 20.4142 4.5858C20.7774 4.94902 20.903 5.38629 20.9545 5.7695C21.0002 6.10941 21.0001 6.57597 21 7.00004C21.0001 7.42411 21.0002 7.89062 20.9545 8.23053C20.903 8.61374 20.7774 9.05101 20.4142 9.41423C20.051 9.77744 19.6137 9.90297 19.2305 9.95449C18.8906 10.0002 18.4785 10.0001 18.0544 10H15.9456C15.5215 10.0001 15.1094 10.0002 14.7695 9.95449C14.3863 9.90297 13.949 9.77744 13.5858 9.41423C13.2226 9.05101 13.0971 8.61374 13.0455 8.23053C12.9998 7.89063 12.9999 7.42409 13 7.00004C12.9999 6.57599 12.9998 6.1094 13.0455 5.76949C13.0971 5.38629 13.2226 4.94902 13.5858 4.5858C13.949 4.22259 14.3863 4.09706 14.7695 4.04554C15.1094 3.99984 15.5215 3.99992 15.9456 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 14H18.0544C18.4785 13.9999 18.8906 13.9998 19.2305 14.0455C19.6137 14.0971 20.051 14.2226 20.4142 14.5858C20.7774 14.949 20.903 15.3863 20.9545 15.7695C21.0002 16.1094 21.0001 16.576 21 17C21.0001 17.4241 21.0002 17.8906 20.9545 18.2305C20.903 18.6137 20.7774 19.051 20.4142 19.4142C20.051 19.7774 19.6137 19.903 19.2305 19.9545C18.8906 20.0002 18.4785 20.0001 18.0544 20H15.9456C15.5215 20.0001 15.1094 20.0002 14.7695 19.9545C14.3863 19.903 13.949 19.7774 13.5858 19.4142C13.2226 19.051 13.0971 18.6137 13.0455 18.2305C12.9998 17.8906 12.9999 17.4241 13 17C12.9999 16.576 12.9998 16.1094 13.0455 15.7695C13.0971 15.3863 13.2226 14.949 13.5858 14.5858C13.949 14.2226 14.3863 14.0971 14.7695 14.0455C15.1094 13.9998 15.5215 13.9999 15.9456 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13L20 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","reader","scanner","payment","id-scan","product-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10V9V9C16 8.44772 15.5523 8 15 8V8H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V9V9C8 8.44772 8.44772 8 9 8V8H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14L8 15V15C8 15.5523 8.44772 16 9 16V16L10 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 14L16 15V15C16 15.5523 15.5523 16 15 16V16L14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","identification","code","scan-qr","scan-barcode","product-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10V9V9C16 8.44772 15.5523 8 15 8V8H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V9V9C8 8.44772 8.44772 8 9 8V8H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14L8 15V15C8 15.5523 8.44772 16 9 16V16L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 14L16 15V15C16 15.5523 15.5523 16 15 16V16L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","scanner","code","read","identification","payment","verify","product-scan","price-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10V9V9C16 8.44772 15.5523 8 15 8V8H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 10V9V9C8 8.44772 8.44772 8 9 8V8H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 14L8 15V15C8 15.5523 8.44772 16 9 16V16L10 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 14L16 15V15C16 15.5523 15.5523 16 15 16V16L14 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["QR code","scan","barcode","payment","scan-payment","loyalty","coupon","promotion","digital","reader"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93418 3L9.00001 3C9.55229 3 10 3.44772 10 4C10 4.55229 9.55229 5 9.00001 5H8.00001C7.02893 5 6.40122 5.00213 5.93871 5.06431C5.50497 5.12263 5.36902 5.21677 5.2929 5.2929C5.21677 5.36902 5.12263 5.50497 5.06431 5.93871C5.00213 6.40122 5.00001 7.02893 5.00001 8V9C5.00001 9.55229 4.55229 10 4.00001 10C3.44772 10 3.00001 9.55229 3.00001 9L3 7.93417C2.99995 7.04769 2.99991 6.28387 3.08215 5.67221C3.17028 5.0167 3.36902 4.38835 3.87868 3.87868C4.38835 3.36902 5.0167 3.17028 5.67221 3.08215C6.28387 2.99991 7.04769 2.99995 7.93418 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0658 3L15 3C14.4477 3 14 3.44772 14 4C14 4.55229 14.4477 5 15 5H16C16.9711 5 17.5988 5.00213 18.0613 5.06431C18.495 5.12263 18.631 5.21677 18.7071 5.2929C18.7832 5.36902 18.8774 5.50497 18.9357 5.93871C18.9979 6.40122 19 7.02893 19 8V9C19 9.55229 19.4477 10 20 10C20.5523 10 21 9.55229 21 9L21 7.93417C21 7.04769 21.0001 6.28387 20.9179 5.67221C20.8297 5.0167 20.631 4.38835 20.1213 3.87868C19.6117 3.36902 18.9833 3.17028 18.3278 3.08215C17.7161 2.99991 16.9523 2.99995 16.0658 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0658 21C16.9523 21 17.7161 21.0001 18.3278 20.9179C18.9833 20.8297 19.6117 20.631 20.1213 20.1213C20.631 19.6117 20.8297 18.9833 20.9179 18.3278C21.0001 17.7161 21 16.9523 21 16.0658L21 15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15L19 16C19 16.9711 18.9979 17.5988 18.9357 18.0613C18.8774 18.495 18.7832 18.631 18.7071 18.7071C18.631 18.7832 18.495 18.8774 18.0613 18.9357C17.5988 18.9979 16.9711 19 16 19L15 19C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21L16.0658 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.93418 21L9.00001 21C9.55229 21 10 20.5523 10 20C10 19.4477 9.55229 19 9.00001 19L8.00001 19C7.02893 19 6.40122 18.9979 5.93871 18.9357C5.50497 18.8774 5.36902 18.7832 5.2929 18.7071C5.21677 18.631 5.12263 18.495 5.06431 18.0613C5.00213 17.5988 5.00001 16.9711 5 16V15C5 14.4477 4.55229 14 4 14C3.44772 14 3 14.4477 3 15L3 16.0658C2.99995 16.9523 2.99991 17.7161 3.08215 18.3278C3.17028 18.9833 3.36902 19.6117 3.87868 20.1213C4.38835 20.631 5.0167 20.8297 5.67221 20.9179C6.28387 21.0001 7.04769 21 7.93418 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 6C17.1046 6 18 6.89543 18 8V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V8H15C14.4477 8 14 7.55228 14 7C14 6.44772 14.4477 6 15 6H16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 8C6 6.89543 6.89543 6 8 6H9C9.55229 6 10 6.44772 10 7C10 7.55228 9.55229 8 9 8H8V9C8 9.55228 7.55229 10 7 10C6.44772 10 6 9.55228 6 9V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 18C6.89543 18 6 17.1046 6 16V15C6 14.4477 6.44772 14 7 14C7.55228 14 8 14.4477 8 15L8 16H9C9.55229 16 10 16.4477 10 17C10 17.5523 9.55229 18 9 18H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 16C18 17.1046 17.1046 18 16 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H16V15C16 14.4477 16.4477 14 17 14C17.5523 14 18 14.4477 18 15V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11L6 11C5.44771 11 5 11.4477 5 12C5 12.5523 5.44771 13 6 13L18 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-code-Scan-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","loyalty","coupon","discount","mobile-payment","check-in","identification","verification","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","scanner","payment","digital","mobile","coupon","loyalty","promotion","identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17L18 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-code-Scan": {
        defaultColors: ["#3D4C66"],
        keywords: ["QR-code","scan","payment","mobile-payment","barcode","scanner","digital","code","technology","checkout","point-of-sale","transaction","identification","data","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9H6C5.05719 9 4.58579 9 4.29289 8.70711C4 8.41421 4 7.94281 4 7C4 6.05719 4 5.58579 4.29289 5.29289C4.58579 5 5.05719 5 6 5H8C8.94281 5 9.41421 5 9.70711 5.29289C10 5.58579 10 6.05719 10 7C10 7.94281 10 8.41421 9.70711 8.70711C9.41421 9 8.94281 9 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 19H6C5.05719 19 4.58579 19 4.29289 18.7071C4 18.4142 4 17.9428 4 17C4 16.0572 4 15.5858 4.29289 15.2929C4.58579 15 5.05719 15 6 15H8C8.94281 15 9.41421 15 9.70711 15.2929C10 15.5858 10 16.0572 10 17C10 17.9428 10 18.4142 9.70711 18.7071C9.41421 19 8.94281 19 8 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 9H16C15.0572 9 14.5858 9 14.2929 8.70711C14 8.41421 14 7.94281 14 7C14 6.05719 14 5.58579 14.2929 5.29289C14.5858 5 15.0572 5 16 5H18C18.9428 5 19.4142 5 19.7071 5.29289C20 5.58579 20 6.05719 20 7C20 7.94281 20 8.41421 19.7071 8.70711C19.4142 9 18.9428 9 18 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 19H16C15.0572 19 14.5858 19 14.2929 18.7071C14 18.4142 14 17.9428 14 17C14 16.0572 14 15.5858 14.2929 15.2929C14.5858 15 15.0572 15 16 15H18C18.9428 15 19.4142 15 19.7071 15.2929C20 15.5858 20 16.0572 20 17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-Scan-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-scan","scan","barcode","qr-code","scanner","code","product-scan","payment-scan","identity-scan","read-code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-Scan-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","payment","identification","checkout","reader","pos","scanner","digital","mobile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "QR-Scan-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","scanner","product-scan","payment","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.93418 4C8.04769 3.99995 7.28387 3.99991 6.67221 4.08215C6.0167 4.17028 5.38835 4.36902 4.87868 4.87868C4.36902 5.38835 4.17028 6.0167 4.08215 6.67221C3.99991 7.28387 3.99995 8.04769 4 8.93417L4 9.5C4 10.0523 4.44772 10.5 5 10.5C5.55228 10.5 6 10.0523 6 9.5L6.00001 9C6.00001 8.02893 6.00213 7.40122 6.06431 6.93871C6.12263 6.50497 6.21677 6.36902 6.2929 6.2929C6.36902 6.21677 6.50497 6.12263 6.93871 6.06431C7.40122 6.00213 8.02893 6 9.00001 6H10C10.5523 6 11 5.55229 11 5C11 4.44772 10.5523 4 10 4L8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.9342 7H12.0658C12.9523 6.99995 13.7161 6.99991 14.3278 7.08215C14.9833 7.17028 15.6117 7.36902 16.1213 7.87868C16.631 8.38835 16.8297 9.0167 16.9179 9.67221C16.9696 10.057 16.9888 10.5021 16.9959 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H16.9959C16.9888 13.4979 16.9696 13.943 16.9179 14.3278C16.8297 14.9833 16.631 15.6117 16.1213 16.1213C15.6117 16.631 14.9833 16.8297 14.3278 16.9179C13.7161 17.0001 12.9523 17.0001 12.0658 17H11.9342C11.0477 17.0001 10.2839 17.0001 9.67221 16.9179C9.0167 16.8297 8.38835 16.631 7.87869 16.1213C7.36902 15.6117 7.17028 14.9833 7.08215 14.3278C7.03041 13.943 7.01124 13.4979 7.00415 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H7.00415C7.01124 10.5021 7.03041 10.057 7.08215 9.67221C7.17028 9.0167 7.36902 8.38835 7.87868 7.87868C8.38835 7.36902 9.0167 7.17028 9.67221 7.08215C10.2839 6.99991 11.0477 6.99995 11.9342 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 4L14 4C13.4477 4 13 4.44772 13 5C13 5.55229 13.4477 6 14 6H15C15.9711 6 16.5988 6.00213 17.0613 6.06431C17.495 6.12263 17.631 6.21677 17.7071 6.2929C17.7832 6.36902 17.8774 6.50497 17.9357 6.93871C17.9979 7.40122 18 8.02893 18 9L18 9.5C18 10.0523 18.4477 10.5 19 10.5C19.5523 10.5 20 10.0523 20 9.5L20 8.93417C20 8.04769 20.0001 7.28387 19.9179 6.67221C19.8297 6.0167 19.631 5.38835 19.1213 4.87868C18.6117 4.36902 17.9833 4.17028 17.3278 4.08215C16.7161 3.99991 15.9523 3.99995 15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 20C15.9523 20 16.7161 20.0001 17.3278 19.9179C17.9833 19.8297 18.6117 19.631 19.1213 19.1213C19.631 18.6117 19.8297 17.9833 19.9179 17.3278C20.0001 16.7161 20 15.9523 20 15.0658L20 14.5C20 13.9477 19.5523 13.5 19 13.5C18.4477 13.5 18 13.9477 18 14.5L18 15C18 15.9711 17.9979 16.5988 17.9357 17.0613C17.8774 17.495 17.7832 17.631 17.7071 17.7071C17.631 17.7832 17.495 17.8774 17.0613 17.9357C16.5988 17.9979 15.9711 18 15 18L14 18C13.4477 18 13 18.4477 13 19C13 19.5523 13.4477 20 14 20L15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.93418 20L10 20C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18L9.00001 18C8.02893 18 7.40122 17.9979 6.93871 17.9357C6.50497 17.8774 6.36902 17.7832 6.2929 17.7071C6.21677 17.631 6.12263 17.495 6.06431 17.0613C6.00213 16.5988 6.00001 15.9711 6 15L6 14.5C6 13.9477 5.55228 13.5 5 13.5C4.44772 13.5 4 13.9477 4 14.5L4 15.0658C3.99995 15.9523 3.99991 16.7161 4.08215 17.3278C4.17028 17.9833 4.36902 18.6117 4.87868 19.1213C5.38835 19.631 6.0167 19.8297 6.67221 19.9179C7.28387 20.0001 8.04769 20 8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "QR-Scan": {
        defaultColors: ["#3D4C66"],
        keywords: ["QR","scan","barcode","scanner","payment","scan-item","scan-barcode","item-scan","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 12L18 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Qrcode-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["scan","barcode","qr-code","scanner","scan-item","lookup","identification","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","scanner","payment","identification","code","data","input","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V13C15 13.9428 15 14.4142 14.7071 14.7071C14.4142 15 13.9428 15 13 15H11C10.0572 15 9.58579 15 9.29289 14.7071C9 14.4142 9 13.9428 9 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Qrcode-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["focus","target","scan","center","selection","targeting","scan-item","locate","find","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.93418 4C8.04769 3.99995 7.28387 3.99991 6.67221 4.08215C6.0167 4.17028 5.38835 4.36902 4.87868 4.87868C4.36902 5.38835 4.17028 6.0167 4.08215 6.67221C3.99991 7.28387 3.99995 8.04769 4 8.93417L4.00001 10C4.00001 10.5523 4.44772 11 5.00001 11C5.55229 11 6.00001 10.5523 6.00001 10V9C6.00001 8.02893 6.00213 7.40122 6.06431 6.93871C6.12263 6.50497 6.21677 6.36902 6.2929 6.2929C6.36902 6.21677 6.50497 6.12263 6.93871 6.06431C7.40122 6.00213 8.02893 6 9.00001 6H10C10.5523 6 11 5.55229 11 5C11 4.44772 10.5523 4 10 4L8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20 8.04769 20 8.93417L20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H14C13.4477 6 13 5.55229 13 5C13 4.44772 13.4477 4 14 4L15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 20L14 20C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15L18 14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14L20 15.0658C20 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.93418 20C8.04769 20 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 14C4 13.4477 4.44772 13 5 13C5.55229 13 6 13.4477 6 14V15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9.00001 18L10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20L8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.9456 8.00001C10.5215 7.99992 10.1094 7.99984 9.7695 8.04554C9.38629 8.09706 8.94902 8.22259 8.5858 8.5858C8.22259 8.94902 8.09706 9.38629 8.04554 9.7695C7.99984 10.1094 7.99992 10.5215 8.00001 10.9456V13.0544C7.99992 13.4785 7.99984 13.8906 8.04554 14.2305C8.09706 14.6137 8.22259 15.051 8.5858 15.4142C8.94902 15.7774 9.38629 15.903 9.7695 15.9545C10.1094 16.0002 10.5215 16.0001 10.9456 16H13.0544C13.4785 16.0001 13.8906 16.0002 14.2305 15.9545C14.6137 15.903 15.051 15.7774 15.4142 15.4142C15.7774 15.051 15.903 14.6137 15.9545 14.2305C16.0002 13.8906 16.0001 13.4785 16 13.0544V10.9456C16.0001 10.5215 16.0002 10.1094 15.9545 9.7695C15.903 9.38629 15.7774 8.94902 15.4142 8.5858C15.051 8.22259 14.6137 8.09706 14.2305 8.04554C13.8906 7.99984 13.4785 7.99992 13.0544 8.00001H10.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Qrcode-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["barcode","scan","scanner","qrcode","scan-item","product-scan","identify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["barcode","scan","qr-code","scanner","code","read","identify","identification","product-scan","payment-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["scan","barcode","qr-code","scanner","code","payment","identify","product-scan","price-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","scanner","read","payment","identification","lookup","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.93418 3L9.00001 3C9.55229 3 10 3.44772 10 4C10 4.55229 9.55229 5 9.00001 5H8.00001C7.02893 5 6.40122 5.00213 5.93871 5.06431C5.50497 5.12263 5.36902 5.21677 5.2929 5.2929C5.21677 5.36902 5.12263 5.50497 5.06431 5.93871C5.00213 6.40122 5.00001 7.02893 5.00001 8V9C5.00001 9.55229 4.55229 10 4.00001 10C3.44772 10 3.00001 9.55229 3.00001 9L3 7.93417C2.99995 7.04769 2.99991 6.28387 3.08215 5.67221C3.17028 5.0167 3.36902 4.38835 3.87868 3.87868C4.38835 3.36902 5.0167 3.17028 5.67221 3.08215C6.28387 2.99991 7.04769 2.99995 7.93418 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0658 3L15 3C14.4477 3 14 3.44772 14 4C14 4.55229 14.4477 5 15 5H16C16.9711 5 17.5988 5.00213 18.0613 5.06431C18.495 5.12263 18.631 5.21677 18.7071 5.2929C18.7832 5.36902 18.8774 5.50497 18.9357 5.93871C18.9979 6.40122 19 7.02893 19 8V9C19 9.55229 19.4477 10 20 10C20.5523 10 21 9.55229 21 9L21 7.93417C21 7.04769 21.0001 6.28387 20.9179 5.67221C20.8297 5.0167 20.631 4.38835 20.1213 3.87868C19.6117 3.36902 18.9833 3.17028 18.3278 3.08215C17.7161 2.99991 16.9523 2.99995 16.0658 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.0658 21C16.9523 21 17.7161 21.0001 18.3278 20.9179C18.9833 20.8297 19.6117 20.631 20.1213 20.1213C20.631 19.6117 20.8297 18.9833 20.9179 18.3278C21.0001 17.7161 21 16.9523 21 16.0658L21 15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15L19 16C19 16.9711 18.9979 17.5988 18.9357 18.0613C18.8774 18.495 18.7832 18.631 18.7071 18.7071C18.631 18.7832 18.495 18.8774 18.0613 18.9357C17.5988 18.9979 16.9711 19 16 19L15 19C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21L16.0658 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.93418 21L9.00001 21C9.55229 21 10 20.5523 10 20C10 19.4477 9.55229 19 9.00001 19L8.00001 19C7.02893 19 6.40122 18.9979 5.93871 18.9357C5.50497 18.8774 5.36902 18.7832 5.2929 18.7071C5.21677 18.631 5.12263 18.495 5.06431 18.0613C5.00213 17.5988 5.00001 16.9711 5 16V15C5 14.4477 4.55229 14 4 14C3.44772 14 3 14.4477 3 15L3 16.0658C2.99995 16.9523 2.99991 17.7161 3.08215 18.3278C3.17028 18.9833 3.36902 19.6117 3.87868 20.1213C4.38835 20.631 5.0167 20.8297 5.67221 20.9179C6.28387 21.0001 7.04769 21 7.93418 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13L20 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Qrcode-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","identification","payment","loyalty","coupon","scanner"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9V9C5 8.07003 5 7.60504 5.10222 7.22354C5.37962 6.18827 6.18827 5.37962 7.22354 5.10222C7.60504 5 8.07003 5 9 5V5H10M19 10V9V9C19 8.07003 19 7.60504 18.8978 7.22354C18.6204 6.18827 17.8117 5.37962 16.7765 5.10222C16.395 5 15.93 5 15 5V5H14M19 14V15V15C19 15.93 19 16.395 18.8978 16.7765C18.6204 17.8117 17.8117 18.6204 16.7765 18.8978C16.395 19 15.93 19 15 19V19H14M5 14V15V15C5 15.93 5 16.395 5.10222 16.7765C5.37962 17.8117 6.18827 18.6204 7.22354 18.8978C7.60504 19 8.07003 19 9 19V19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","scanner","payment","identification","product-identification","code","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9V9C5 8.07003 5 7.60504 5.10222 7.22354C5.37962 6.18827 6.18827 5.37962 7.22354 5.10222C7.60504 5 8.07003 5 9 5V5H10M19 10V9V9C19 8.07003 19 7.60504 18.8978 7.22354C18.6204 6.18827 17.8117 5.37962 16.7765 5.10222C16.395 5 15.93 5 15 5V5H14M19 14V15V15C19 15.93 19 16.395 18.8978 16.7765C18.6204 17.8117 17.8117 18.6204 16.7765 18.8978C16.395 19 15.93 19 15 19V19H14M5 14V15V15C5 15.93 5 16.395 5.10222 16.7765C5.37962 17.8117 6.18827 18.6204 7.22354 18.8978C7.60504 19 8.07003 19 9 19V19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","code","scanner","product-scan","payment","digital-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9V9C5 8.07003 5 7.60504 5.10222 7.22354C5.37962 6.18827 6.18827 5.37962 7.22354 5.10222C7.60504 5 8.07003 5 9 5V5H10M19 10V9V9C19 8.07003 19 7.60504 18.8978 7.22354C18.6204 6.18827 17.8117 5.37962 16.7765 5.10222C16.395 5 15.93 5 15 5V5H14M19 14V15V15C19 15.93 19 16.395 18.8978 16.7765C18.6204 17.8117 17.8117 18.6204 16.7765 18.8978C16.395 19 15.93 19 15 19V19H14M5 14V15V15C5 15.93 5 16.395 5.10222 16.7765C5.37962 17.8117 6.18827 18.6204 7.22354 18.8978C7.60504 19 8.07003 19 9 19V19H10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["scan","barcode","qr code","scanner","code","read","capture","identify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.86252 4.00005C8.90771 4.00007 8.95356 4.0001 9.0001 4.0001H10.0001C10.5524 4.0001 11.0001 4.44781 11.0001 5.0001C11.0001 5.55238 10.5524 6.0001 10.0001 6.0001H9.0001C8.00574 6.0001 7.70474 6.00869 7.48246 6.06824C6.79227 6.25318 6.25318 6.79227 6.06824 7.48246C6.00869 7.70474 6.0001 8.00574 6.0001 9.0001V10.0001C6.0001 10.5524 5.55238 11.0001 5.0001 11.0001C4.44781 11.0001 4.0001 10.5524 4.0001 10.0001V9.0001C4.0001 8.95356 4.00007 8.90771 4.00005 8.86252C3.99962 8.06713 3.9993 7.47647 4.13639 6.96482C4.50626 5.58445 5.58445 4.50626 6.96482 4.13639C7.47647 3.9993 8.06713 3.99962 8.86252 4.00005ZM16.5177 6.06824C16.2955 6.00869 15.9944 6.0001 15.0001 6.0001H14.0001C13.4478 6.0001 13.0001 5.55238 13.0001 5.0001C13.0001 4.44781 13.4478 4.0001 14.0001 4.0001H15.0001C15.0466 4.0001 15.0925 4.00007 15.1377 4.00005C15.9331 3.99962 16.5237 3.9993 17.0354 4.13639C18.4157 4.50626 19.4939 5.58445 19.8638 6.96482C20.0009 7.47647 20.0006 8.06713 20.0001 8.86252C20.0001 8.90771 20.0001 8.95356 20.0001 9.0001V10.0001C20.0001 10.5524 19.5524 11.0001 19.0001 11.0001C18.4478 11.0001 18.0001 10.5524 18.0001 10.0001V9.0001C18.0001 8.00574 17.9915 7.70474 17.9319 7.48246C17.747 6.79227 17.2079 6.25318 16.5177 6.06824ZM5.0001 13.0001C5.55238 13.0001 6.0001 13.4478 6.0001 14.0001V15.0001C6.0001 15.9944 6.00869 16.2955 6.06824 16.5177C6.25318 17.2079 6.79227 17.747 7.48246 17.9319C7.70474 17.9915 8.00574 18.0001 9.0001 18.0001H10.0001C10.5524 18.0001 11.0001 18.4478 11.0001 19.0001C11.0001 19.5524 10.5524 20.0001 10.0001 20.0001H9.0001C8.95356 20.0001 8.90771 20.0001 8.86252 20.0001C8.06713 20.0006 7.47647 20.0009 6.96482 19.8638C5.58445 19.4939 4.50626 18.4157 4.13639 17.0354C3.9993 16.5237 3.99962 15.9331 4.00005 15.1377C4.00007 15.0925 4.0001 15.0466 4.0001 15.0001V14.0001C4.0001 13.4478 4.44781 13.0001 5.0001 13.0001ZM19.0001 13.0001C19.5524 13.0001 20.0001 13.4478 20.0001 14.0001V15.0001C20.0001 15.0466 20.0001 15.0925 20.0001 15.1377C20.0006 15.9331 20.0009 16.5237 19.8638 17.0354C19.4939 18.4157 18.4157 19.4939 17.0354 19.8638C16.5237 20.0009 15.9331 20.0006 15.1377 20.0001C15.0925 20.0001 15.0466 20.0001 15.0001 20.0001H14.0001C13.4478 20.0001 13.0001 19.5524 13.0001 19.0001C13.0001 18.4478 13.4478 18.0001 14.0001 18.0001H15.0001C15.9944 18.0001 16.2955 17.9915 16.5177 17.9319C17.2079 17.747 17.747 17.2079 17.9319 16.5177C17.9915 16.2955 18.0001 15.9944 18.0001 15.0001V14.0001C18.0001 13.4478 18.4478 13.0001 19.0001 13.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.0001 12.0001C7.0001 11.4478 7.44781 11.0001 8.0001 11.0001H16.0001C16.5524 11.0001 17.0001 11.4478 17.0001 12.0001C17.0001 12.5524 16.5524 13.0001 16.0001 13.0001H8.0001C7.44781 13.0001 7.0001 12.5524 7.0001 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Qrcode-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["scan","qrcode","barcode","reader","scan-item","scan-barcode","scan-qrcode","remove","subtract","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["QR code","scan","barcode","payment","identification","verify","checkout","scanner","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Qrcode-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["scan","barcode","qr-code","scanner","code","identify","item-lookup","product-lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Qrcode-22": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["qrcode","scan","barcode","scanner","pos","payment","input","capture","item-lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Qrcode-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr","qr-code","scan","scanner","code","barcode","input","data","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.93418 4C8.04769 3.99995 7.28387 3.99991 6.67221 4.08215C6.0167 4.17028 5.38835 4.36902 4.87868 4.87868C4.36902 5.38835 4.17028 6.0167 4.08215 6.67221C3.99991 7.28387 3.99995 8.04769 4 8.93417L4.00001 10C4.00001 10.5523 4.44772 11 5.00001 11C5.55229 11 6.00001 10.5523 6.00001 10V9C6.00001 8.02893 6.00213 7.40122 6.06431 6.93871C6.12263 6.50497 6.21677 6.36902 6.2929 6.2929C6.36902 6.21677 6.50497 6.12263 6.93871 6.06431C7.40122 6.00213 8.02893 6 9.00001 6H10C10.5523 6 11 5.55229 11 5C11 4.44772 10.5523 4 10 4L8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20 8.04769 20 8.93417L20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H14C13.4477 6 13 5.55229 13 5C13 4.44772 13.4477 4 14 4L15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 20L14 20C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15L18 14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14L20 15.0658C20 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.93418 20C8.04769 20 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 14C4 13.4477 4.44772 13 5 13C5.55229 13 6 13.4477 6 14V15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9.00001 18L10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20L8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.9342 7C11.0477 6.99995 10.2839 6.99991 9.67221 7.08215C9.0167 7.17028 8.38835 7.36902 7.87868 7.87868C7.36902 8.38835 7.17028 9.0167 7.08215 9.67221C6.99991 10.2839 6.99995 11.0477 7 11.9342V12.0658C6.99995 12.9523 6.99991 13.7161 7.08215 14.3278C7.17028 14.9833 7.36902 15.6117 7.87869 16.1213C8.38835 16.631 9.0167 16.8297 9.67221 16.9179C10.2839 17.0001 11.0477 17.0001 11.9342 17H12.0658C12.9523 17.0001 13.7161 17.0001 14.3278 16.9179C14.9833 16.8297 15.6117 16.631 16.1213 16.1213C16.631 15.6117 16.8297 14.9833 16.9179 14.3278C17.0001 13.7161 17.0001 12.9523 17 12.0659V11.9342C17.0001 11.0477 17.0001 10.2839 16.9179 9.67221C16.8297 9.0167 16.631 8.38835 16.1213 7.87868C15.6117 7.36902 14.9833 7.17028 14.3278 7.08215C13.7161 6.99991 12.9523 6.99995 12.0658 7H11.9342Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Qrcode-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["scan","barcode","qrcode","scan-code","scanner","code"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 4C8.95604 4 8.97799 4 9.00001 4H10C10.5523 4 11 4.44772 11 5C11 5.55229 10.5523 6 10 6H9.00001C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6.00001 8.02893 6.00001 9L6 9.5C6 10.0523 5.55229 10.5 5 10.5C4.44772 10.5 4 10.0523 4 9.5L4.00001 9C4.00001 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 4C15.044 4 15.022 4 15 4H14C13.4477 4 13 4.44772 13 5C13 5.55229 13.4477 6 14 6H15C15.9711 6 16.5988 6.00213 17.0613 6.06431C17.495 6.12263 17.631 6.21677 17.7071 6.2929C17.7832 6.36902 17.8774 6.50497 17.9357 6.93871C17.9979 7.40122 18 8.02893 18 9L18 9.5C18 10.0523 18.4477 10.5 19 10.5C19.5523 10.5 20 10.0523 20 9.5L20 9C20 8.97799 20 8.95604 20 8.93417C20.0001 8.04769 20.0001 7.28387 19.9179 6.67221C19.8297 6.0167 19.631 5.38835 19.1213 4.87868C18.6117 4.36902 17.9833 4.17028 17.3278 4.08215C16.7161 3.99991 15.9523 3.99995 15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0658 20C15.044 20 15.022 20 15 20H14C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15L18 14.5C18 13.9477 18.4477 13.5 19 13.5C19.5523 13.5 20 13.9477 20 14.5L20 15C20 15.022 20 15.044 20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93418 20C8.95604 20 8.97799 20 9.00001 20H10C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18L9.00001 18C8.02893 18 7.40122 17.9979 6.93871 17.9357C6.50497 17.8774 6.36902 17.7832 6.2929 17.7071C6.21677 17.631 6.12263 17.495 6.06431 17.0613C6.00213 16.5988 6 15.9711 6 15V14.5C6 13.9477 5.55229 13.5 5 13.5C4.44772 13.5 4 13.9477 4 14.5L4 15C4 15.022 4 15.044 4 15.0658C3.99995 15.9523 3.99991 16.7161 4.08215 17.3278C4.17028 17.9833 4.36902 18.6117 4.87868 19.1213C5.38835 19.631 6.0167 19.8297 6.67221 19.9179C7.28387 20.0001 8.04769 20.0001 8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 12C18 12.5523 17.5523 13 17 13H7.00001C6.44772 13 6.00001 12.5523 6.00001 12C6.00001 11.4477 6.44772 11 7.00001 11L17 11C17.5523 11 18 11.4477 18 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Qrcode-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["scan","qr code","barcode","payment","scanner","scan-item","scan-barcode","scan-qr-code","read"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","scanner","payment","identification","verify","lookup","find"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["qr-code","scan","barcode","focus","target","camera","scanner","read-code","identify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","scan-qr","scan-barcode","product-scan","item-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.93418 4C8.04769 3.99995 7.28387 3.99991 6.67221 4.08215C6.0167 4.17028 5.38835 4.36902 4.87868 4.87868C4.36902 5.38835 4.17028 6.0167 4.08215 6.67221C3.99991 7.28387 3.99995 8.04769 4 8.93417L4.00001 10C4.00001 10.5523 4.44772 11 5.00001 11C5.55229 11 6.00001 10.5523 6.00001 10V9C6.00001 8.02893 6.00213 7.40122 6.06431 6.93871C6.12263 6.50497 6.21677 6.36902 6.2929 6.2929C6.36902 6.21677 6.50497 6.12263 6.93871 6.06431C7.40122 6.00213 8.02893 6 9.00001 6H10C10.5523 6 11 5.55229 11 5C11 4.44772 10.5523 4 10 4L8.93418 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20 8.04769 20 8.93417L20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H14C13.4477 6 13 5.55229 13 5C13 4.44772 13.4477 4 14 4L15.0658 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.0658 20L14 20C13.4477 20 13 19.5523 13 19C13 18.4477 13.4477 18 14 18L15 18C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15L18 14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14L20 15.0658C20 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20 15.0658 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.93418 20C8.04769 20 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 14C4 13.4477 4.44772 13 5 13C5.55229 13 6 13.4477 6 14V15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9.00001 18L10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20L8.93418 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 8C9.79086 8 8 9.79086 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Qrcode: {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","barcode","scan-qr","scan-barcode","product-scan","item-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12L17 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["qr-code","scan","barcode","scanner","payment","identification","product-lookup","verification","identity","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V13C15 13.9428 15 14.4142 14.7071 14.7071C14.4142 15 13.9428 15 13 15H11C10.0572 15 9.58579 15 9.29289 14.7071C9 14.4142 9 13.9428 9 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "quote-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["quote","feedback","testimonial","comment","review","customer-feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12C16.8777 13.8325 15.6034 14.8602 14 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C10.8777 13.8325 9.60345 14.8602 8 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H15C14.0572 12 13.5858 12 13.2929 11.7071C13 11.4142 13 10.9428 13 10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H9C8.05719 12 7.58579 12 7.29289 11.7071C7 11.4142 7 10.9428 7 10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "quote-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["quote","comment","feedback","testimonial","description","note","dialog","remark"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12C16.8777 13.8325 15.6034 14.8602 14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C10.8777 13.8325 9.60345 14.8602 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H15C14.0572 12 13.5858 12 13.2929 11.7071C13 11.4142 13 10.9428 13 10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H9C8.05719 12 7.58579 12 7.29289 11.7071C7 11.4142 7 10.9428 7 10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "quote-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["quote","comments","feedback","review","testimonial","notes","description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94561 7.00001C7.52154 6.99992 7.10941 6.99984 6.76949 7.04554C6.38629 7.09706 5.94902 7.22259 5.5858 7.5858C5.22259 7.94902 5.09706 8.38629 5.04554 8.76949C4.99984 9.10941 4.99992 9.52154 5.00001 9.94561V10.0544C4.99992 10.4785 4.99984 10.8906 5.04554 11.2305C5.09706 11.6137 5.22259 12.051 5.5858 12.4142C5.94902 12.7774 6.38629 12.903 6.76949 12.9545C7.10941 13.0002 7.52153 13.0001 7.94559 13L8.69503 13C8.60143 13.1579 8.49106 13.2926 8.36967 13.407C8.02511 13.7317 7.52908 13.9501 6.91319 14.0038C6.36299 14.0518 5.95586 14.5367 6.00384 15.0869C6.05182 15.6371 6.53673 16.0442 7.08693 15.9963C8.07449 15.9101 9.01728 15.5448 9.74128 14.8626C10.4743 14.1718 10.9213 13.2133 10.9978 12.0667C10.9996 12.0396 11.0004 12.0127 11 11.986L11 9.9456C11.0001 9.52154 11.0002 9.10941 10.9545 8.76949C10.903 8.38629 10.7774 7.94902 10.4142 7.5858C10.051 7.22259 9.61374 7.09706 9.23053 7.04554C8.89062 6.99984 8.47849 6.99992 8.05442 7.00001H7.94561Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.9456 7.00001C15.5215 6.99992 15.1094 6.99984 14.7695 7.04554C14.3863 7.09706 13.949 7.22259 13.5858 7.5858C13.2226 7.94902 13.0971 8.38629 13.0455 8.76949C12.9998 9.10941 12.9999 9.52154 13 9.94561V10.0544C12.9999 10.4785 12.9998 10.8906 13.0455 11.2305C13.0971 11.6137 13.2226 12.051 13.5858 12.4142C13.949 12.7774 14.3863 12.903 14.7695 12.9545C15.1094 13.0002 15.5215 13.0001 15.9456 13L16.695 13C16.6014 13.1579 16.4911 13.2926 16.3697 13.407C16.0251 13.7317 15.5291 13.9501 14.9132 14.0038C14.363 14.0518 13.9559 14.5367 14.0038 15.0869C14.0518 15.6371 14.5367 16.0442 15.0869 15.9963C16.0745 15.9101 17.0173 15.5448 17.7413 14.8626C18.4743 14.1718 18.9213 13.2133 18.9978 12.0667C18.9996 12.0396 19.0004 12.0127 19 11.986L19 9.9456C19.0001 9.52154 19.0002 9.10941 18.9545 8.76949C18.903 8.38629 18.7774 7.94902 18.4142 7.5858C18.051 7.22259 17.6137 7.09706 17.2305 7.04554C16.8906 6.99984 16.4785 6.99992 16.0544 7.00001H15.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "quote-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["quote","left-quote","testimonial","review","feedback","comment","customer-review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12C16.8777 13.8325 15.6034 14.8602 14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 12C10.8777 13.8325 9.60345 14.8602 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12H15C14.0572 12 13.5858 12 13.2929 11.7071C13 11.4142 13 10.9428 13 10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 12H9C8.05719 12 7.58579 12 7.29289 11.7071C7 11.4142 7 10.9428 7 10C7 9.05719 7 8.58579 7.29289 8.29289C7.58579 8 8.05719 8 9 8C9.94281 8 10.4142 8 10.7071 8.29289C11 8.58579 11 9.05719 11 10V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "quote-right-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["quote","comment","feedback","testimonial","review","dialog","text","speech"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11C7.12234 9.16749 8.39655 8.13982 10 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11C13.1223 9.16749 14.3966 8.13982 16 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 11L9 11C9.94281 11 10.4142 11 10.7071 11.2929C11 11.5858 11 12.0572 11 13C11 13.9428 11 14.4142 10.7071 14.7071C10.4142 15 9.94281 15 9 15C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13L7 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11L15 11C15.9428 11 16.4142 11 16.7071 11.2929C17 11.5858 17 12.0572 17 13C17 13.9428 17 14.4142 16.7071 14.7071C16.4142 15 15.9428 15 15 15C14.0572 15 13.5858 15 13.2929 14.7071C13 14.4142 13 13.9428 13 13L13 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Qrcode-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["qr-code","scan","square","barcode","payment","checkout","digital","verify","identification","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13V11C9 10.0572 9 9.58579 9.29289 9.29289C9.58579 9 10.0572 9 11 9H13C13.9428 9 14.4142 9 14.7071 9.29289C15 9.58579 15 10.0572 15 11V13C15 13.9428 15 14.4142 14.7071 14.7071C14.4142 15 13.9428 15 13 15H11C10.0572 15 9.58579 15 9.29289 14.7071C9 14.4142 9 13.9428 9 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "quote-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["quote","testimony","review","customer-feedback","comments","feedback","saying","testimonial"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11C7.12234 9.16749 8.39655 8.13982 10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11C13.1223 9.16749 14.3966 8.13982 16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 11L9 11C9.94281 11 10.4142 11 10.7071 11.2929C11 11.5858 11 12.0572 11 13C11 13.9428 11 14.4142 10.7071 14.7071C10.4142 15 9.94281 15 9 15C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13L7 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11L15 11C15.9428 11 16.4142 11 16.7071 11.2929C17 11.5858 17 12.0572 17 13C17 13.9428 17 14.4142 16.7071 14.7071C16.4142 15 15.9428 15 15 15C14.0572 15 13.5858 15 13.2929 14.7071C13 14.4142 13 13.9428 13 13L13 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "quote-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["quote","feedback","comment","testimonial","review"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0545 16.0001C16.4786 16.0002 16.8907 16.0003 17.2306 15.9546C17.6138 15.903 18.0511 15.7775 18.4143 15.4143C18.7775 15.0511 18.903 14.6138 18.9546 14.2306C19.0003 13.8907 19.0002 13.4786 19.0001 13.0545V12.9457C19.0002 12.5216 19.0003 12.1095 18.9546 11.7696C18.903 11.3864 18.7775 10.9491 18.4143 10.5859C18.0511 10.2227 17.6138 10.0971 17.2306 10.0456C16.8907 9.99991 16.4786 9.99999 16.0545 10.0001L15.3051 10.0001C15.3987 9.84221 15.509 9.70747 15.6304 9.59309C15.975 9.2684 16.471 9.04999 17.0869 8.99628C17.6371 8.9483 18.0442 8.46339 17.9963 7.91319C17.9483 7.36299 17.4634 6.95586 16.9132 7.00384C15.9256 7.08996 14.9828 7.45528 14.2588 8.13752C13.5258 8.82828 13.0788 9.78676 13.0023 10.9334C13.0005 10.9605 12.9997 10.9874 13.0001 11.0141L13.0001 13.0545C13 13.4786 12.9999 13.8907 13.0456 14.2306C13.0971 14.6138 13.2227 15.0511 13.5859 15.4143C13.9491 15.7775 14.3864 15.903 14.7696 15.9546C15.1095 16.0003 15.5216 16.0002 15.9457 16.0001H16.0545Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.05449 16.0001C8.47856 16.0002 8.89069 16.0003 9.2306 15.9546C9.61381 15.903 10.0511 15.7775 10.4143 15.4143C10.7775 15.0511 10.903 14.6138 10.9546 14.2306C11.0003 13.8907 11.0002 13.4786 11.0001 13.0545V12.9457C11.0002 12.5216 11.0003 12.1095 10.9546 11.7696C10.903 11.3864 10.7775 10.9491 10.4143 10.5859C10.0511 10.2227 9.61381 10.0971 9.2306 10.0456C8.89069 9.99991 8.47857 9.99999 8.05451 10.0001L7.30507 10.0001C7.39867 9.84221 7.50904 9.70747 7.63043 9.59309C7.97499 9.2684 8.47102 9.04999 9.08691 8.99628C9.63711 8.9483 10.0442 8.46339 9.99626 7.91319C9.94828 7.36299 9.46336 6.95586 8.91317 7.00384C7.92561 7.08996 6.98281 7.45528 6.25882 8.13752C5.52577 8.82828 5.07882 9.78676 5.00226 10.9334C5.00045 10.9605 4.99974 10.9874 5.00008 11.0141L5.00008 13.0545C4.99999 13.4786 4.99991 13.8907 5.04561 14.2306C5.09713 14.6138 5.22266 15.0511 5.58587 15.4143C5.94909 15.7775 6.38636 15.903 6.76957 15.9546C7.10948 16.0003 7.52161 16.0002 7.94568 16.0001H8.05449Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "quote-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["quote","quotation","remark","comment","testimonial","feedback","review","statement","dialog","conversation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11C7.12234 9.16749 8.39655 8.13982 10 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 11C13.1223 9.16749 14.3966 8.13982 16 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 11L9 11C9.94281 11 10.4142 11 10.7071 11.2929C11 11.5858 11 12.0572 11 13C11 13.9428 11 14.4142 10.7071 14.7071C10.4142 15 9.94281 15 9 15C8.05719 15 7.58579 15 7.29289 14.7071C7 14.4142 7 13.9428 7 13L7 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11L15 11C15.9428 11 16.4142 11 16.7071 11.2929C17 11.5858 17 12.0572 17 13C17 13.9428 17 14.4142 16.7071 14.7071C16.4142 15 15.9428 15 15 15C14.0572 15 13.5858 15 13.2929 14.7071C13 14.4142 13 13.9428 13 13L13 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "R-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["R","reports","receipt","refund","return","redo","record","right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19L7.25 19ZM8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8L8.75 8ZM8.75 19L8.75 8L7.25 8L7.25 19L8.75 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M15.3901 19.4358C15.6309 19.7728 16.0993 19.8509 16.4363 19.6101C16.7734 19.3694 16.8514 18.9009 16.6107 18.5639L15.3901 19.4358ZM11.6103 11.564C11.3695 11.227 10.9011 11.1489 10.564 11.3897C10.227 11.6305 10.1489 12.0989 10.3897 12.436L11.6103 11.564ZM16.6107 18.5639L11.6103 11.564L10.3897 12.436L15.3901 19.4358L16.6107 18.5639Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8 7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H10C9.05719 12 8.58579 12 8.29289 11.7071C8 11.4142 8 10.9428 8 10V7Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    R: {
        defaultColors: ["#3D4C66"],
        keywords: ["R","reports","receipt","refund","return","redo","record","right"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19L7.25 19ZM8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8L8.75 8ZM8.75 19L8.75 8L7.25 8L7.25 19L8.75 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.3901 19.4358C15.6309 19.7728 16.0993 19.8509 16.4363 19.6101C16.7734 19.3694 16.8514 18.9009 16.6107 18.5639L15.3901 19.4358ZM11.6103 11.564C11.3695 11.227 10.9011 11.1489 10.564 11.3897C10.227 11.6305 10.1489 12.0989 10.3897 12.436L11.6103 11.564ZM16.6107 18.5639L11.6103 11.564L10.3897 12.436L15.3901 19.4358L16.6107 18.5639Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H10C9.05719 12 8.58579 12 8.29289 11.7071C8 11.4142 8 10.9428 8 10V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "R-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["R","Return","Refund","Report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25 19C7.25 19.4142 7.58579 19.75 8 19.75C8.41421 19.75 8.75 19.4142 8.75 19L7.25 19ZM8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8L8.75 8ZM8.75 19L8.75 8L7.25 8L7.25 19L8.75 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.3901 19.4358C15.6309 19.7728 16.0993 19.8509 16.4363 19.6101C16.7734 19.3694 16.8514 18.9009 16.6107 18.5639L15.3901 19.4358ZM11.6103 11.564C11.3695 11.227 10.9011 11.1489 10.564 11.3897C10.227 11.6305 10.1489 12.0989 10.3897 12.436L11.6103 11.564ZM16.6107 18.5639L11.6103 11.564L10.3897 12.436L15.3901 19.4358L16.6107 18.5639Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 7C8 6.05719 8 5.58579 8.29289 5.29289C8.58579 5 9.05719 5 10 5H12.5C14.433 5 16 6.567 16 8.5C16 10.433 14.433 12 12.5 12H10C9.05719 12 8.58579 12 8.29289 11.7071C8 11.4142 8 10.9428 8 10V7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "R-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["R","return","refund","reset","receipt","record","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94561 4.00001C9.96372 4.00001 9.98186 4.00001 10 4.00001H12.5C14.9853 4.00001 17 6.01473 17 8.50001C17 10.8408 15.2128 12.7641 12.9284 12.9799L16.8137 18.4187C17.1347 18.8681 17.0307 19.4927 16.5813 19.8137C16.1319 20.1347 15.5073 20.0307 15.1863 19.5813L10.4849 13H9.00001L9.00001 19C9.00001 19.5523 8.5523 20 8.00001 20C7.44773 20 7.00001 19.5523 7.00001 19L7.00001 7.00001C7.00001 6.98186 7.00001 6.96372 7.00001 6.94561C6.99992 6.52154 6.99984 6.10941 7.04554 5.76949C7.09706 5.38629 7.22259 4.94902 7.5858 4.5858C7.94902 4.22259 8.38629 4.09706 8.76949 4.04554C9.10941 3.99984 9.52154 3.99992 9.94561 4.00001ZM9.00001 11H12.5C13.8807 11 15 9.88073 15 8.50001C15 7.1193 13.8807 6.00001 12.5 6.00001H10C9.50034 6.00001 9.22618 6.00214 9.03599 6.02771C9.03351 6.02804 9.03108 6.02837 9.02871 6.02871C9.02838 6.03108 9.02804 6.03351 9.02771 6.03599C9.00214 6.22618 9.00001 6.50034 9.00001 7.00001V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "radar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["radar","location","find","search","signal","wifi","connectivity","network","tracking","geolocation","coverage","range","hotspot","receipt-options","customer-tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.1001 12.0001C4.1001 7.63705 7.63705 4.1001 12.0001 4.1001C16.3631 4.1001 19.9001 7.63705 19.9001 12.0001C19.9001 13.3952 19.5385 14.7058 18.9039 15.8433L17.5643 14.5037C17.9085 13.7399 18.1001 12.8924 18.1001 12.0001C18.1001 8.63116 15.369 5.9001 12.0001 5.9001C8.63116 5.9001 5.9001 8.63116 5.9001 12.0001C5.9001 15.369 8.63116 18.1001 12.0001 18.1001C12.8923 18.1001 13.7397 17.9086 14.5036 17.5644L15.8432 18.904C14.7057 19.5385 13.3951 19.9001 12.0001 19.9001C7.63705 19.9001 4.1001 16.3631 4.1001 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.64 13.5795C16.8086 13.0839 16.9001 12.5527 16.9001 12.0001C16.9001 9.2939 14.7063 7.1001 12.0001 7.1001C9.2939 7.1001 7.1001 9.2939 7.1001 12.0001C7.1001 14.7063 9.2939 16.9001 12.0001 16.9001C12.5526 16.9001 13.0838 16.8086 13.5793 16.6401L12.0391 15.0999C12.0261 15.1 12.0131 15.1001 12.0001 15.1001C10.288 15.1001 8.9001 13.7122 8.9001 12.0001C8.9001 10.288 10.288 8.9001 12.0001 8.9001C13.7122 8.9001 15.1001 10.288 15.1001 12.0001C15.1001 12.0132 15.1 12.0263 15.0999 12.0393L16.64 13.5795Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 10.0001C10.8954 10.0001 10 10.8956 10 12.0001C10 13.1047 10.8954 14.0001 12 14.0001C12.219 14.0001 12.4298 13.9649 12.6271 13.8998L16.3637 17.6365C16.7152 17.988 17.285 17.988 17.6365 17.6365C17.988 17.285 17.988 16.7152 17.6365 16.3637L13.8998 12.627C13.9648 12.4298 14 12.2191 14 12.0001C14 10.8956 13.1046 10.0001 12 10.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "radar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["circle","dot","payment-received","cash-received","focus","target","location","customer-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="8"
                    y="8"
                    width="8"
                    height="8"
                    rx="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "radar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["radar","location","target","search","find","signal","tracking","detect","area","scan","proximity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="8" y="8" width="8" height="8" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="11" y="11" width="2" height="2" rx="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M17 17L13 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Radio-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["radio","music","entertainment","broadcast","station","audio","news","settings","preferences","channel","playlist","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 8L13 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="10" cy="14" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M17 16H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    radar: {
        defaultColors: ["#3D4C66"],
        keywords: ["radio","music","entertainment","broadcast","station","audio","news","settings","preferences","channel","playlist","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="8" y="8" width="8" height="8" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="11" y="11" width="2" height="2" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M17 17L13 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Radio-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["radio","music","entertainment","news","announcement","updates","audio","broadcast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M7 8L13 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="10"
                    cy="14"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 16H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Radio-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["radio","music","entertainment","news","broadcast","audio","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.832 3.44541C14.1384 3.90493 14.0142 4.5258 13.5547 4.83216L10.3029 7H14.0706C15.4247 6.99997 16.5413 6.99994 17.4251 7.11876C18.3529 7.2435 19.1723 7.51547 19.8284 8.17158C20.4845 8.82769 20.7565 9.64711 20.8813 10.5749C21.0001 11.4587 21 12.5753 21 13.9294V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92943C8.57531 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V13.9294C2.99997 12.5753 2.99994 11.4587 3.11876 10.5749C3.2435 9.64711 3.51547 8.82769 4.17158 8.17158C4.81105 7.5321 5.60566 7.25754 6.50457 7.12853L12.4453 3.16806C12.9048 2.8617 13.5257 2.98588 13.832 3.44541ZM6 14C6 12.3431 7.34315 11 9 11C10.6569 11 12 12.3431 12 14C12 15.6569 10.6569 17 9 17C7.34315 17 6 15.6569 6 14ZM15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H15ZM14 16C14 15.4477 14.4477 15 15 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H15C14.4477 17 14 16.5523 14 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Radio: {
        defaultColors: ["#3D4C66"],
        keywords: ["radio","music","entertainment","news","broadcast","audio","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14C4 11.1716 4 9.75736 4.87868 8.87868C5.75736 8 7.17157 8 10 8H14C16.8284 8 18.2426 8 19.1213 8.87868C20 9.75736 20 11.1716 20 14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 8L13 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="10" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M17 16H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["drops","water","leak","damage","humidity","spill","wet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L14.5399 14.76C15.7868 16.6058 14.3525 19 12 19C9.64745 19 8.21322 16.6058 9.46007 14.76L12 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5L18.6613 7.6718C19.5459 9.09444 18.5947 11 17 11C15.4053 11 14.4541 9.09444 15.3387 7.6718L17 5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L8.66131 7.6718C9.54589 9.09444 8.59471 11 7 11C5.40529 11 4.45411 9.09444 5.33869 7.6718L7 5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rain","drop","humidity","weather","environmental-control","water"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C12.9278 19 13.7819 18.6841 14.4605 18.154C16.3274 16.6955 15.2987 13.9481 13.9846 11.9769L12 9L10.0154 11.9769C8.70126 13.9481 7.67261 16.6955 9.53954 18.154C10.2181 18.6841 11.0722 19 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11C7.11977 11 7.23708 10.9874 7.35105 10.9632C9.34586 10.5393 8.48027 7.6645 7.48989 5.8818L7 5L6.51011 5.8818C5.51973 7.66449 4.65414 10.5393 6.64895 10.9632C6.76292 10.9874 6.88023 11 7 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["water","drop","rain","humidity","leak","fluid","beverage","drink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.43007 4.05705C7.2537 3.73958 6.91908 3.54269 6.55592 3.54269C6.19275 3.54269 5.85813 3.73958 5.68176 4.05705L5.19187 4.93885C4.66266 5.89143 4.12871 7.19529 4.02015 8.38377C3.96582 8.97849 4.00801 9.64898 4.31337 10.2417C4.64397 10.8835 5.22505 11.32 5.99703 11.484C6.17857 11.5226 6.36552 11.5427 6.55592 11.5427C6.74631 11.5427 6.93326 11.5226 7.1148 11.484C7.88678 11.32 8.46786 10.8835 8.79847 10.2417C9.10382 9.64898 9.14601 8.97849 9.09169 8.38377C8.98313 7.19529 8.44917 5.89143 7.91996 4.93885L7.43007 4.05705Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.3384 4.01436C18.162 3.69689 17.8274 3.5 17.4642 3.5C17.1011 3.5 16.7664 3.69689 16.5901 4.01436L16.1002 4.89616C15.571 5.84873 15.037 7.1526 14.9285 8.34108C14.8741 8.9358 14.9163 9.60629 15.2217 10.199C15.5523 10.8408 16.1334 11.2773 16.9053 11.4413C17.0869 11.4799 17.2738 11.5 17.4642 11.5C17.6546 11.5 17.8416 11.4799 18.0231 11.4413C18.7951 11.2773 19.3762 10.8408 19.7068 10.199C20.0121 9.60629 20.0543 8.9358 20 8.34108C19.8914 7.1526 19.3575 5.84874 18.8283 4.89616L18.3384 4.01436Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.8779 8.44532C12.6924 8.16712 12.3802 8.00002 12.0458 8.00002C11.7115 8.00002 11.3993 8.16712 11.2138 8.44532L9.22919 11.4222C8.53351 12.4657 7.8653 13.7807 7.64433 15.0915C7.41825 16.4325 7.65222 17.9127 8.96976 18.942C9.8179 19.6046 10.8871 20 12.0458 20C13.2046 20 14.2738 19.6046 15.1219 18.942C16.4395 17.9127 16.6734 16.4325 16.4474 15.0915C16.2264 13.7807 15.5582 12.4657 14.8625 11.4222L12.8779 8.44532Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rain-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rain","drops","water","weather","humidity","wet","refresh","discount","loyalty","points","raindrops","rewards","customer","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L14.5399 14.76C15.7868 16.6058 14.3525 19 12 19C9.64745 19 8.21322 16.6058 9.46007 14.76L12 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5L18.6613 7.6718C19.5459 9.09444 18.5947 11 17 11C15.4053 11 14.4541 9.09444 15.3387 7.6718L17 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L8.66131 7.6718C9.54589 9.09444 8.59471 11 7 11C5.40529 11 4.45411 9.09444 5.33869 7.6718L7 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["drops","water","liquid","humidity","leak","discount","loyalty","rewards","fluid","beverage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C11.3958 19 12.658 18.451 13.565 17.5656C15.3159 15.8565 14.2521 13.123 12.8564 11.1133L10 7L7.14356 11.1133C5.74794 13.123 4.68408 15.8565 6.43499 17.5656C7.34204 18.451 8.60423 19 10 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rain","weather","drink","liquid","water","beverage","humidity","leak","spill","restock","refreshments","water-leak","water-damage","water-resistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.84923 4.47196C7.66674 4.17846 7.34563 4 7.00001 4C6.6544 4 6.33329 4.17846 6.15079 4.47196L4.48949 7.14376C3.25565 9.12808 4.50091 12 7.00001 12C9.49912 12 10.7444 9.12808 9.51054 7.14376L7.84923 4.47196Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.8492 4.47196C17.6667 4.17846 17.3456 4 17 4C16.6544 4 16.3333 4.17846 16.1508 4.47196L14.4895 7.14376C13.2556 9.12808 14.5009 12 17 12C19.4991 12 20.7444 9.12808 19.5105 7.14376L17.8492 4.47196Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.8287 10.4402C12.6427 10.165 12.3322 10 12 10C11.6678 10 11.3573 10.165 11.1714 10.4402L8.63143 14.2002C6.85539 16.8294 8.99392 20 12 20C15.0061 20 17.1446 16.8294 15.3686 14.2002L12.8287 10.4402Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rain-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rain","drop","water","weather","humidity","leak","fluid","wet","refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C11.3958 19 12.658 18.451 13.565 17.5656C15.3159 15.8565 14.2521 13.123 12.8564 11.1133L10 7L7.14356 11.1133C5.74794 13.123 4.68408 15.8565 6.43499 17.5656C7.34204 18.451 8.60423 19 10 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["water","drop","rain","drink","liquid","refreshment","humidity","weather","wet","cleaning","spill","potion","tears","leak"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19C11.3958 19 12.658 18.451 13.565 17.5656C15.3159 15.8565 14.2521 13.123 12.8564 11.1133L10 7L7.14356 11.1133C5.74794 13.123 4.68408 15.8565 6.43499 17.5656C7.34204 18.451 8.60423 19 10 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["drops","humidity","liquid","beverage","water","drinks","condiment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.8742 4.51436C17.6978 4.19689 17.3632 4 17 4C16.6368 4 16.3022 4.19689 16.1259 4.51436L15.636 5.39616C15.1068 6.34873 14.5728 7.6526 14.4642 8.84108C14.4099 9.4358 14.4521 10.1063 14.7575 10.699C15.0881 11.3408 15.6691 11.7773 16.4411 11.9413C16.6227 11.9799 16.8096 12 17 12C17.1904 12 17.3774 11.9799 17.5589 11.9413C18.3309 11.7773 18.912 11.3408 19.2426 10.699C19.5479 10.1063 19.5901 9.4358 19.5358 8.84108C19.4272 7.6526 18.8933 6.34873 18.3641 5.39616L17.8742 4.51436Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.8214 6.4296C10.6345 6.16049 10.3276 6 10 6C9.67236 6 9.36551 6.16049 9.17863 6.4296L6.32219 10.5429C5.58327 11.6069 4.88568 12.9243 4.62743 14.2627C4.36406 15.6277 4.54808 17.1212 5.73648 18.2812C6.82701 19.3457 8.3386 20 10 20C11.6614 20 13.173 19.3457 14.2635 18.2812C15.4519 17.1212 15.6359 15.6277 15.3726 14.2627C15.1143 12.9243 14.4167 11.6069 13.6778 10.5429L10.8214 6.4296Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rain-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["rain","water","drop","weather","humidity","wet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C12.9278 19 13.7819 18.6841 14.4605 18.154C16.3274 16.6955 15.2987 13.9481 13.9846 11.9769L12 9L10.0154 11.9769C8.70126 13.9481 7.67261 16.6955 9.53954 18.154C10.2181 18.6841 11.0722 19 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11C7.11977 11 7.23708 10.9874 7.35105 10.9632C9.34586 10.5393 8.48027 7.6645 7.48989 5.8818L7 5L6.51011 5.8818C5.51973 7.66449 4.65414 10.5393 6.64895 10.9632C6.76292 10.9874 6.88023 11 7 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rain-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rain","water","humidity","weather","drops","liquid","wet","leak","service","plumbing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C12.9278 19 13.7819 18.6841 14.4605 18.154C16.3274 16.6955 15.2987 13.9481 13.9846 11.9769L12 9L10.0154 11.9769C8.70126 13.9481 7.67261 16.6955 9.53954 18.154C10.2181 18.6841 11.0722 19 12 19Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11C17.1198 11 17.2371 10.9874 17.3511 10.9632C19.3459 10.5393 18.4803 7.6645 17.4899 5.8818L17 5L16.5101 5.8818C15.5197 7.66449 14.6541 10.5393 16.6489 10.9632C16.7629 10.9874 16.8802 11 17 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 11C7.11977 11 7.23708 10.9874 7.35105 10.9632C9.34586 10.5393 8.48027 7.6645 7.48989 5.8818L7 5L6.51011 5.8818C5.51973 7.66449 4.65414 10.5393 6.64895 10.9632C6.76292 10.9874 6.88023 11 7 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    rain: {
        defaultColors: ["#3D4C66"],
        keywords: ["rain","water","humidity","weather","drops","liquid","wet","leak","service","plumbing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L14.5399 14.76C15.7868 16.6058 14.3525 19 12 19C9.64745 19 8.21322 16.6058 9.46007 14.76L12 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 5L18.6613 7.6718C19.5459 9.09444 18.5947 11 17 11C15.4053 11 14.4541 9.09444 15.3387 7.6718L17 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L8.66131 7.6718C9.54589 9.09444 8.59471 11 7 11C5.40529 11 4.45411 9.09444 5.33869 7.6718L7 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rainbow-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rainbow","weather","promotion","stacked","tiers","levels","rewards","loyalty","wifi","signal","strength","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16C4 11.5817 7.58172 8 12 8C16.4183 8 20 11.5817 20 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16C7 13.2386 9.23858 11 12 11C14.7614 11 17 13.2386 17 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rainbow-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rainbow","loyalty","rewards","vip","celebration","happy","special-offer","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16C4 11.5817 7.58172 8 12 8C16.4183 8 20 11.5817 20 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16C7 13.2386 9.23858 11 12 11C14.7614 11 17 13.2386 17 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rainbow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rainbow","layer","options","menu","settings","configuration","tier","price-levels","discount-tiers"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9C8.13401 9 5 12.134 5 16C5 16.5523 4.55228 17 4 17C3.44772 17 3 16.5523 3 16C3 11.0294 7.02944 7 12 7C16.9706 7 21 11.0294 21 16C21 16.5523 20.5523 17 20 17C19.4477 17 19 16.5523 19 16C19 12.134 15.866 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C9.79086 12 8 13.7909 8 16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16C6 12.6863 8.68629 10 12 10C15.3137 10 18 12.6863 18 16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16C16 13.7909 14.2091 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rainbow-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["rainbow","layer","stacked","loyalty","rewards","tiers","level","ranking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V15C7 12.2386 9.23858 10 12 10C14.7614 10 17 12.2386 17 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 17V15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 10.5817 7.58172 7 12 7C16.4183 7 20 10.5817 20 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rainbow-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rainbow","layers","connection","signal","segments","options","settings","weather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V15C7 12.2386 9.23858 10 12 10C14.7614 10 17 12.2386 17 15V17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 17V15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 10.5817 7.58172 7 12 7C16.4183 7 20 10.5817 20 15V17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rainbow-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["rainbow","loyalty","rewards","customer-level","tiers","program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15V17C19 17.5523 19.4477 18 20 18C20.5523 18 21 17.5523 21 17V15C21 10.0294 16.9706 6 12 6C7.02944 6 3 10.0294 3 15V17C3 17.5523 3.44772 18 4 18C4.55228 18 5 17.5523 5 17V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 11C9.79086 11 8 12.7909 8 15V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V15C6 11.6863 8.68629 9 12 9C15.3137 9 18 11.6863 18 15V17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17V15C16 12.7909 14.2091 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 14C11.4477 14 11 14.4477 11 15V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V15C13 14.4477 12.5523 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rainbow-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rainbow","curves","layers","loyalty program","rewards","points","tiers","membership","categories","deals","promotions","stacked","group","organization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 17V15C7 12.2386 9.23858 10 12 10C14.7614 10 17 12.2386 17 15V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 17V15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15V17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17V15C4 10.5817 7.58172 7 12 7C16.4183 7 20 10.5817 20 15V17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "ramp-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["merge","split","combine","separate","arrow-up","route","branch","merge-items","split-order","combine-payments","route-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12.7597 14.1395C13.5725 15.3587 14.6894 16.3447 16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    rainbow: {
        defaultColors: ["#3D4C66"],
        keywords: ["merge","split","combine","separate","arrow-up","route","branch","merge-items","split-order","combine-payments","route-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16C4 11.5817 7.58172 8 12 8C16.4183 8 20 11.5817 20 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 16C7 13.2386 9.23858 11 12 11C14.7614 11 17 13.2386 17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "ramp-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["split","arrow","up","merge","combine","payment","tender","routing","diverge","apportion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12.7597 14.1395C13.5725 15.3587 14.6894 16.3447 16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ramp-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","merge","transaction","payment","split-payment","share-payment","up","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289L15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711C15.3166 9.09763 14.6834 9.09763 14.2929 8.70711L13 7.41421V12.6972L13.5917 13.5848C14.308 14.6592 15.2922 15.5281 16.4472 16.1056C16.9412 16.3526 17.1414 16.9532 16.8944 17.4472C16.6474 17.9412 16.0468 18.1414 15.5528 17.8944C14.5988 17.4174 13.7365 16.7838 13 16.0236V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13.0155C10.9999 13.0058 10.9999 12.996 11 12.9863V7.41421L9.70711 8.70711C9.31658 9.09763 8.68342 9.09763 8.29289 8.70711C7.90237 8.31658 7.90237 7.68342 8.29289 7.29289L11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ramp-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","diverge","branch","route","split-tender","multi-tender","alternative-payment","split-payment","route-order","divert","divert-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L12.7597 14.1395C13.5725 15.3587 14.6894 16.3447 16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ramp-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["split","diverge","merge","forward","arrow","route","path","branch","transaction","multi-payment","split-tender","payment-routing","order-splitting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L11.2403 14.1395C10.4275 15.3587 9.31062 16.3447 8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ramp-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["split","route","branch","diverge","path","forward","merge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L11.2403 14.1395C10.4275 15.3587 9.31062 16.3447 8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "ramp-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","merge","combine","arrow","redirect","divert","routing","forward","transaction","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0002 4C12.2654 4 12.5198 4.10536 12.7073 4.29289L15.7073 7.29289C16.0979 7.68342 16.0979 8.31658 15.7073 8.70711C15.3168 9.09763 14.6836 9.09763 14.2931 8.70711L13.0002 7.41421V12.9863C13.0004 12.996 13.0004 13.0058 13.0002 13.0155V19C13.0002 19.5523 12.5525 20 12.0002 20C11.4479 20 11.0002 19.5523 11.0002 19V16.0236C10.2637 16.7838 9.40144 17.4174 8.44743 17.8944C7.95345 18.1414 7.35278 17.9412 7.10579 17.4472C6.8588 16.9532 7.05903 16.3526 7.55301 16.1056C8.70797 15.5281 9.69224 14.6592 10.4085 13.5848L11.0002 12.6972V7.41421L9.70733 8.70711C9.3168 9.09763 8.68364 9.09763 8.29311 8.70711C7.90259 8.31658 7.90259 7.68342 8.29311 7.29289L11.2931 4.29289C11.4806 4.10536 11.735 4 12.0002 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "record-voice-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["voice-command","voice","microphone","audio","sound","speaker","customer-service","assistance","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5C19.2357 6.27961 20 8.04738 20 10C20 11.9526 19.2357 13.7204 18 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C16.2357 7.02369 17 8.4379 17 10C17 11.5621 16.2357 12.9763 15 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C6 11.6569 7.34315 13 9 13C10.6569 13 12 11.6569 12 10C12 8.34315 10.6569 7 9 7C7.34315 7 6 8.34315 6 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19L4.0196 18.9294C4.41108 17.5201 4.60681 16.8155 5.14325 16.4077C5.67969 16 6.41102 16 7.87368 16H10.1263C11.589 16 12.3203 16 12.8567 16.4077C13.3932 16.8155 13.5889 17.5201 13.9804 18.9294L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "ramp-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","growth","increase","promotion","upgrade","escalate","forward","send","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L12 5L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L11.2403 14.1395C10.4275 15.3587 9.31062 16.3447 8 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "record-voice-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["voice","microphone","sound","record","audio","customer-service","support","agent","communication","voice-command","voice-search","speak","talk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5C19.2357 6.27961 20 8.04738 20 10C20 11.9526 19.2357 13.7204 18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C16.2357 7.02369 17 8.4379 17 10C17 11.5621 16.2357 12.9763 15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C6 11.6569 7.34315 13 9 13C10.6569 13 12 11.6569 12 10C12 8.34315 10.6569 7 9 7C7.34315 7 6 8.34315 6 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19L4.0196 18.9294C4.41108 17.5201 4.60681 16.8155 5.14325 16.4077C5.67969 16 6.41102 16 7.87368 16H10.1263C11.589 16 12.3203 16 12.8567 16.4077C13.3932 16.8155 13.5889 17.5201 13.9804 18.9294L14 19"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "record-voice-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["voice-command","voice","command","microphone","audio","speak","assistant","help","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3056 4.28066C16.9083 4.66431 16.8973 5.29738 17.2809 5.69466C18.3404 6.79178 19.0003 8.31199 19.0003 10C19.0003 11.688 18.3404 13.2082 17.2809 14.3053C16.8973 14.7026 16.9083 15.3357 17.3056 15.7193C17.7029 16.103 18.3359 16.0919 18.7196 15.6947C20.1315 14.2326 21.0003 12.2172 21.0003 10C21.0003 7.78277 20.1315 5.76744 18.7196 4.30534C18.3359 3.90806 17.7029 3.89701 17.3056 4.28066Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2302 5.36205C13.8778 5.78735 13.937 6.41775 14.3623 6.77008C15.4069 7.63547 16.0003 8.78203 16.0003 10C16.0003 11.218 15.4069 12.3645 14.3623 13.2299C13.937 13.5823 13.8778 14.2127 14.2302 14.638C14.5825 15.0633 15.2129 15.1224 15.6382 14.7701C17.065 13.5881 18.0003 11.9062 18.0003 10C18.0003 8.09378 17.065 6.41191 15.6382 5.22992C15.2129 4.87759 14.5825 4.93675 14.2302 5.36205Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00025 10C5.00025 7.79086 6.79111 6 9.00025 6C11.2094 6 13.0003 7.79086 13.0003 10C13.0003 12.2091 11.2094 14 9.00025 14C6.79112 14 5.00025 12.2091 5.00025 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.81936 15C7.83749 15 7.85568 15 7.87393 15L10.1811 15C10.8658 15 11.4644 14.9999 11.9561 15.0578C12.4871 15.1204 12.9995 15.2599 13.4621 15.6116C13.9248 15.9633 14.1964 16.4196 14.3988 16.9145C14.5862 17.3727 14.7464 17.9495 14.9296 18.6092L14.9638 18.7324C15.1116 19.2645 14.8 19.8157 14.2679 19.9635C13.7358 20.1113 13.1846 19.7998 13.0367 19.2676L13.0171 19.1971C12.815 18.4694 12.6851 18.0077 12.5476 17.6715C12.4201 17.3598 12.3256 17.2599 12.2519 17.2039C12.1781 17.1478 12.0566 17.0835 11.7221 17.0441C11.3614 17.0016 10.8818 17 10.1266 17H7.87393C7.11869 17 6.63912 17.0016 6.27836 17.0441C5.94395 17.0835 5.8224 17.1478 5.74863 17.2039C5.67487 17.2599 5.58037 17.3598 5.45291 17.6715C5.31542 18.0077 5.18551 18.4694 4.98338 19.1971L4.96377 19.2676C4.81596 19.7998 4.26475 20.1113 3.73261 19.9635C3.20047 19.8157 2.88892 19.2645 3.03674 18.7324L3.05634 18.6618C3.06122 18.6442 3.06609 18.6267 3.07094 18.6092C3.25414 17.9495 3.41433 17.3727 3.60172 16.9145C3.80411 16.4196 4.0757 15.9633 4.53838 15.6116C5.00106 15.2599 5.51339 15.1204 6.04441 15.0578C6.53608 14.9999 7.13473 15 7.81936 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "record-voice": {
        defaultColors: ["#3D4C66"],
        keywords: ["voice","sound","communication","microphone","audio","assistance","voice-command","speak","talk","verbal","broadcast","customer-support","alert","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5C19.2357 6.27961 20 8.04738 20 10C20 11.9526 19.2357 13.7204 18 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 6C16.2357 7.02369 17 8.4379 17 10C17 11.5621 16.2357 12.9763 15 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10C6 11.6569 7.34315 13 9 13C10.6569 13 12 11.6569 12 10C12 8.34315 10.6569 7 9 7C7.34315 7 6 8.34315 6 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19L4.0196 18.9294C4.41108 17.5201 4.60681 16.8155 5.14325 16.4077C5.67969 16 6.41102 16 7.87368 16H10.1263C11.589 16 12.3203 16 12.8567 16.4077C13.3932 16.8155 13.5889 17.5201 13.9804 18.9294L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Rectangle 19506": {
        defaultColors: ["#3D4C66"],
        keywords: ["lightning","flash","fast","quick","charge","express","speed","rapid","electricity","power"],
        getIcon: (colors?: string[]) => (
            <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.99981 1L1 4H3L1.99981 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rectangle-code-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["code","brackets","programming","development","edit","source","integration","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 14L9.41421 13.4142C8.74755 12.7475 8.41421 12.4142 8.41421 12C8.41421 11.5858 8.74755 11.2525 9.41421 10.5858L10 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14.5858 13.4142C15.2525 12.7475 15.5858 12.4142 15.5858 12C15.5858 11.5858 15.2525 11.2525 14.5858 10.5858L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rectangle-code-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["code","tag","html","programming","configuration","settings","developer","options","edit","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 14L9.41421 13.4142C8.74755 12.7475 8.41421 12.4142 8.41421 12C8.41421 11.5858 8.74755 11.2525 9.41421 10.5858L10 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14.5858 13.4142C15.2525 12.7475 15.5858 12.4142 15.5858 12C15.5858 11.5858 15.2525 11.2525 14.5858 10.5858L14 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rectangle-code-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","coding","settings","configuration","customization","developer","programming","script","customization-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1213 4H13.8787C15.1291 3.99998 16.1369 3.99997 16.9296 4.10654C17.7526 4.21718 18.4455 4.45388 18.9958 5.00421C19.5461 5.55453 19.7828 6.24744 19.8935 7.0704C20 7.86306 20 8.87089 20 10.1213V13.8787C20 15.1291 20 16.1369 19.8935 16.9296C19.7828 17.7526 19.5461 18.4455 18.9958 18.9958C18.4455 19.5461 17.7526 19.7828 16.9296 19.8935C16.1369 20 15.1291 20 13.8787 20H10.1213C8.87089 20 7.86306 20 7.0704 19.8935C6.24744 19.7828 5.55453 19.5461 5.00421 18.9958C4.45388 18.4455 4.21718 17.7526 4.10654 16.9296C3.99997 16.1369 3.99998 15.1291 4 13.8787V10.1213C3.99998 8.87089 3.99997 7.86306 4.10654 7.0704C4.21718 6.24744 4.45388 5.55453 5.00421 5.00421C5.55453 4.45388 6.24744 4.21718 7.0704 4.10654C7.86306 3.99997 8.87089 3.99998 10.1213 4ZM10.5302 9.46967C10.8231 9.76256 10.8231 10.2374 10.5302 10.5303L9.94439 11.1161C9.59607 11.4644 9.3893 11.6735 9.26033 11.8425C9.20123 11.92 9.17785 11.965 9.16878 11.9867C9.16668 11.9917 9.16548 11.9952 9.16483 11.9973L9.16406 12L9.16483 12.0027C9.16548 12.0048 9.16668 12.0083 9.16878 12.0133C9.17785 12.035 9.20123 12.08 9.26033 12.1575C9.3893 12.3265 9.59607 12.5356 9.94439 12.8839L10.5302 13.4697C10.8231 13.7626 10.8231 14.2374 10.5302 14.5303C10.2373 14.8232 9.76241 14.8232 9.46952 14.5303L8.88373 13.9445C8.87316 13.934 8.86261 13.9234 8.85209 13.9129C8.54601 13.6069 8.26537 13.3263 8.0678 13.0674C7.85023 12.7822 7.66406 12.437 7.66406 12C7.66406 11.563 7.85023 11.2178 8.0678 10.9326C8.26537 10.6737 8.546 10.3931 8.85209 10.0871C8.86261 10.0766 8.87316 10.066 8.88373 10.0555L9.46952 9.46967C9.76241 9.17678 10.2373 9.17678 10.5302 9.46967ZM9.16406 12C9.16406 11.9994 9.16411 11.9996 9.16406 12V12ZM13.4695 9.46967C13.7624 9.17678 14.2373 9.17678 14.5302 9.46967L15.116 10.0555C15.1265 10.066 15.1371 10.0766 15.1476 10.0871C15.4537 10.3931 15.7343 10.6737 15.9319 10.9326C16.1495 11.2178 16.3356 11.563 16.3356 12C16.3356 12.437 16.1495 12.7822 15.9319 13.0674C15.7343 13.3263 15.4537 13.6069 15.1476 13.9129C15.1371 13.9234 15.1265 13.934 15.116 13.9445L14.5302 14.5303C14.2373 14.8232 13.7624 14.8232 13.4695 14.5303C13.1766 14.2374 13.1766 13.7626 13.4695 13.4697L14.0553 12.8839C14.4036 12.5356 14.6104 12.3265 14.7394 12.1575C14.7985 12.08 14.8218 12.035 14.8309 12.0133C14.833 12.0083 14.8342 12.0048 14.8349 12.0027L14.8356 12L14.8349 11.9973C14.8342 11.9952 14.833 11.9917 14.8309 11.9867C14.8218 11.965 14.7985 11.92 14.7394 11.8425C14.6104 11.6735 14.4036 11.4644 14.0553 11.1161L13.4695 10.5303C13.1766 10.2374 13.1766 9.76256 13.4695 9.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rectangle-code": {
        defaultColors: ["#3D4C66"],
        keywords: ["code","customization","settings","configuration","development","programming","script","api","integration","advanced"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 14L9.41421 13.4142C8.74755 12.7475 8.41421 12.4142 8.41421 12C8.41421 11.5858 8.74755 11.2525 9.41421 10.5858L10 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 14L14.5858 13.4142C15.2525 12.7475 15.5858 12.4142 15.5858 12C15.5858 11.5858 15.2525 11.2525 14.5858 10.5858L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["recycle","recycling","eco","environment","sustainability","circular","circular-economy","reuse","waste-management","reduce","pos-recycle","recycle-rewards","eco-friendly"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L9 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L15 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Recyle-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["recycle","refresh","reload","arrows","circular","loop","update","repeat","reorder","restock","inventory","process","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 15V13L5 14M15 7V9L13 8M17 15V13L19 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["recycle","circular","arrows","reload","refresh","update","return","exchange","eco-friendly","sustainability","circular-economy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9L5.65071 15.0287C4.91012 16.3618 5.87406 18 7.39903 18H14H16.601C18.1259 18 19.0899 16.3618 18.3493 15.0287L15 9L13.715 6.85831C12.9382 5.56363 11.0618 5.56363 10.285 6.85831L9 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 15V13L5 14M15 7V9L13 8M17 15V13L19 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","recycling","circular","circular-arrow","eco-friendly","sustainability","environment","returns","recycle-bin","reduce","reuse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5431 9.96244L12.5528 8.97522C12.0588 8.7302 11.8586 8.13433 12.1056 7.64429C12.2143 7.42852 12.3916 7.26925 12.5982 7.17947C12.1466 6.84464 11.4604 6.94003 11.1425 7.46566L9.85754 9.59024C9.5734 10.06 8.95916 10.2124 8.48559 9.9305C8.01202 9.64862 7.85846 9.03927 8.1426 8.56947L9.42758 6.44488C10.5551 4.58057 13.2272 4.52038 14.4545 6.26432C14.6114 6.16287 14.7987 6.10391 14.9999 6.10391C15.5522 6.10391 15.9999 6.54805 15.9999 7.09592V9.0624C16.0007 9.11135 15.9979 9.16018 15.9915 9.20846C15.9579 9.46231 15.8259 9.7012 15.6107 9.86546C15.5835 9.88622 15.5552 9.90571 15.5256 9.92381C15.3486 10.0323 15.1452 10.0816 14.9437 10.0704C14.8248 10.0638 14.7065 10.036 14.5948 9.98692C14.5774 9.97926 14.5601 9.9711 14.5431 9.96244Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.9665 12.7929C7.90202 12.5523 7.74677 12.3355 7.51461 12.1973C7.20359 12.0121 6.83189 12.0143 6.53288 12.1707L4.553 13.1527C4.05903 13.3977 3.85881 13.9936 4.10579 14.4837C4.2348 14.7396 4.46032 14.9161 4.71672 14.9913C4.00325 16.8743 5.3924 19 7.53249 19H10C10.5523 19 11 18.5559 11 18.008C11 17.4601 10.5523 17.016 10 17.016H7.53249C6.90615 17.016 6.47278 16.4698 6.53734 15.9116C6.67572 15.9834 6.83315 16.0241 7.00014 16.0241C7.55241 16.0241 8.00011 15.5799 8.00011 15.032V13.0654C8.00126 12.9972 7.99529 12.9292 7.98249 12.8625C7.97799 12.8391 7.97265 12.8159 7.9665 12.7929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.466 12.1701C17.1672 12.0143 16.796 12.0124 16.4854 12.1973C16.1673 12.3866 15.9936 12.7236 15.9999 13.0668V15.032C15.9999 15.5799 16.4476 16.0241 16.9999 16.0241C17.1668 16.0241 17.3243 15.9834 17.4626 15.9117C17.5272 16.4698 17.0938 17.016 16.4675 17.016H13.9999C13.4477 17.016 13 17.4601 13 18.008C13 18.5559 13.4477 19 13.9999 19H16.4675C18.6076 19 19.9967 16.8743 19.2833 14.9914C19.5397 14.9161 19.7652 14.7396 19.8942 14.4837C20.1412 13.9936 19.941 13.3978 19.447 13.1527L17.466 12.1701Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Recyle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["recycle","recycling","refresh","reload","repeat","loop","circulation","eco-friendly","sustainability","reusable","waste-management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 9L5.65071 15.0287C4.91012 16.3618 5.87406 18 7.39903 18H14H16.601C18.1259 18 19.0899 16.3618 18.3493 15.0287L15 9L13.715 6.85831C12.9382 5.56363 11.0618 5.56363 10.285 6.85831L9 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10 18L9 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L15 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Recyle-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","recycling","return","circular","eco-friendly","sustainability","waste-management","refund","arrows","reload","refresh","cycle","loop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 15V13L5 14M15 7V9L13 8M17 15V13L19 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["recycle","recycling","refresh","reset","circular","arrows","reusable","reuse","cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L4.44721 16.1056C3.78231 17.4354 4.7493 19 6.23607 19H10M18 13L19.5528 16.1056C20.2177 17.4354 19.2507 19 17.7639 19H14M8 9L10.3359 5.49615C11.1275 4.30868 12.8725 4.30868 13.6641 5.49615L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.187 14.615L6 13L4 13.538M16.5 7L16 9L14 8M17 15L18 13L20 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["recycle","recycling","eco-friendly","sustainability","green","return","circular","reduce","reuse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 8.71429L3.84636 15.9614C3.03648 17.2943 3.99596 19 5.55556 19H14.5H18.4444C20.004 19 20.9635 17.2943 20.1536 15.9614L15.75 8.71429L13.6721 5.54796C12.8822 4.34437 11.1178 4.34437 10.3279 5.54795L8.25 8.71429Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 13L4.44721 16.1056C3.78231 17.4354 4.7493 19 6.23607 19H10M18 13L19.5528 16.1056C20.2177 17.4354 19.2507 19 17.7639 19H14M8 9L10.3359 5.49615C11.1275 4.30868 12.8725 4.30868 13.6641 5.49615L16 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.187 14.615L6 13L4 13.538M16.5 7L16 9L14 8M17 15L18 13L20 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Recyle-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","refresh","repeat","process","reprocess","circular","circulation","sustainability","eco-friendly","reload","refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.168 6.38647C11.5638 5.80702 12.4362 5.80702 12.832 6.38647L13.5396 7.42234C13.3582 7.51395 13.2039 7.66043 13.1056 7.85234C12.8586 8.33443 13.0588 8.92065 13.5528 9.1617L15.5382 10.1306C15.5762 10.1498 15.6152 10.1666 15.6551 10.1808C15.7545 10.2165 15.8585 10.2362 15.9629 10.24C16.1329 10.2463 16.3059 10.2104 16.4645 10.129C16.5272 10.0968 16.5858 10.0586 16.6394 10.015C16.7842 9.89774 16.8876 9.74688 16.9456 9.58204C16.9549 9.55564 16.963 9.52876 16.97 9.50143L17.47 7.54955C17.604 7.02665 17.2782 6.49678 16.7424 6.36605C16.2675 6.25018 15.787 6.48679 15.5907 6.90619L14.4961 5.30376C13.3086 3.56541 10.6913 3.56541 9.50391 5.30376L7.16807 8.7233C6.86172 9.17178 6.98589 9.77771 7.44541 10.0767C7.90493 10.3757 8.52578 10.2545 8.83212 9.80601L11.168 6.38647Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.81852 12.6073C6.72632 12.4789 6.60105 12.3705 6.44735 12.2955C6.21476 12.182 5.95852 12.1653 5.72669 12.2297L3.74046 12.7511C3.20715 12.8911 2.89112 13.4266 3.03458 13.9471C3.16517 14.4209 3.63153 14.719 4.11644 14.663L3.553 15.7628C2.55567 17.7095 4.00612 20 6.23621 20H10C10.5523 20 11 19.5631 11 19.0241C11 18.4851 10.5523 18.0481 10 18.0481H6.23621C5.49285 18.0481 5.00936 17.2846 5.3418 16.6357L6.16305 15.0327L6.38139 15.3226C6.70846 15.7569 7.33435 15.8502 7.77935 15.531C8.22436 15.2118 8.31996 14.601 7.99289 14.1667L6.81852 12.6073Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.0483 12.1935C17.8823 12.1854 17.7119 12.2178 17.5526 12.2955C17.5372 12.303 17.522 12.3109 17.5072 12.3191C17.4878 12.3298 17.4688 12.3411 17.4504 12.3529C17.2949 12.4524 17.1757 12.5891 17.0991 12.7445L16.1055 14.6839C15.8585 15.166 16.0587 15.7522 16.5527 15.9933C17.0466 16.2343 17.6473 16.0389 17.8943 15.5568L17.9999 15.3507L18.6582 16.6357C18.9906 17.2846 18.5071 18.0481 17.7638 18.0481H13.9999C13.4477 18.0481 13 18.4851 13 19.0241C13 19.5631 13.4477 20 13.9999 20H17.7638C19.9939 20 21.4443 17.7095 20.447 15.7628L20.1146 15.114C20.4385 15.0772 20.7375 14.8867 20.8942 14.5809C21.1412 14.0988 20.941 13.5126 20.447 13.2715L18.4612 12.3025C18.4287 12.286 18.3952 12.2713 18.3611 12.2584C18.2588 12.2196 18.1533 12.1984 18.0483 12.1935Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Recyle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","recycling","refresh","reload","repeat","circular","arrow","arrows","process","eco","sustainability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.8033 7.46566C12.4394 6.82349 11.5606 6.82349 11.1967 7.46566L9.9929 9.59024C9.72671 10.06 9.15127 10.2124 8.70762 9.9305C8.26397 9.64862 8.12011 9.03927 8.3863 8.56947L9.5901 6.44488C10.6817 4.51837 13.3183 4.51837 14.4099 6.44488L15.6137 8.56947C15.8799 9.03927 15.736 9.64862 15.2924 9.9305C14.8487 10.2124 14.2733 10.06 14.0071 9.59024L12.8033 7.46566ZM7.79798 12.1973C8.24163 12.4791 8.38549 13.0885 8.1193 13.5583L7.01144 15.5136C6.6368 16.1748 7.08657 17.016 7.81474 17.016H8.2528C8.2528 16.7621 8.34426 16.5082 8.52719 16.3145C8.89303 15.9271 9.48618 15.9271 9.85202 16.3145L10.7888 17.3065C11.0567 17.5902 11.1369 18.0169 10.9919 18.3876C10.8469 18.7583 10.5053 19 10.1264 19H7.81474C5.63023 19 4.28092 16.4764 5.40484 14.4928L6.51271 12.5375C6.7789 12.0677 7.35433 11.9154 7.79798 12.1973ZM16.202 12.1973C16.6457 11.9154 17.2211 12.0677 17.4873 12.5375L18.5952 14.4928C19.7191 16.4764 18.3698 19 16.1853 19H13.8736C13.4947 19 13.1531 18.7583 13.0081 18.3876C12.8631 18.0169 12.9433 17.5902 13.2112 17.3065L14.148 16.3145C14.5138 15.9271 15.107 15.9271 15.4728 16.3145C15.6557 16.5082 15.7472 16.7621 15.7472 17.016H16.1853C16.9134 17.016 17.3632 16.1748 16.9886 15.5136L15.8807 13.5583C15.6145 13.0885 15.7584 12.4791 16.202 12.1973Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Recyle-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","circular","arrows","loop","refresh","update","restore","reset","reload","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13L4.44721 16.1056C3.78231 17.4354 4.7493 19 6.23607 19H10M18 13L19.5528 16.1056C20.2177 17.4354 19.2507 19 17.7639 19H14M8 9L10.3359 5.49615C11.1275 4.30868 12.8725 4.30868 13.6641 5.49615L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.187 14.615L6 13L4 13.538M16.5 7L16 9L14 8M17 15L18 13L20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Recyle: {
        defaultColors: ["#3D4C66"],
        keywords: ["recycle","circular","arrows","loop","refresh","update","restore","reset","reload","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 18L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13L5.81739 14.971C5.01756 16.3041 5.97779 18 7.53238 18H10M17 13L18.1826 14.971C18.9824 16.3041 18.0222 18 16.4676 18H14M9 9L10.285 6.85831C11.0618 5.56363 12.9382 5.56363 13.715 6.85831L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "reel-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["reel","play","video","marketing","promotion","tutorial","training","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1058 11.699C10.5322 11.5161 11.0826 11.7913 12.1833 12.3416C13.5069 13.0034 14.1686 13.3343 14.2509 13.8392C14.2683 13.9457 14.2683 14.0543 14.2509 14.1608C14.1686 14.6657 13.5069 14.9966 12.1833 15.6584C11.0826 16.2087 10.5322 16.4839 10.1058 16.301C10.0147 16.2619 9.92995 16.2095 9.85427 16.1455C9.5 15.8459 9.5 15.2306 9.5 14L9.5 14C9.5 12.7694 9.5 12.1541 9.85427 11.8545C9.92995 11.7905 10.0147 11.7381 10.1058 11.699Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5L12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reel-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["reel","video","media","record","film","movie","playback","play","entertainment","promotion","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 8H5C4.44772 8 4 7.55228 4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7C20 7.55228 19.5523 8 19 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 4L12 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.1094 15.9271L12.5039 15.6641C13.6328 14.9115 14.1972 14.5352 14.1972 14C14.1972 13.4648 13.6328 13.0885 12.5038 12.3359L12.1094 12.0729C10.7407 11.1604 10.0563 10.7042 9.52814 10.9868C9 11.2695 9 12.092 9 13.737L9 13.737L9 14.263C9 15.908 9 16.7305 9.52814 17.0132C10.0563 17.2958 10.7407 16.8396 12.1094 15.9271Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reel-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","play","media","content","display","transaction-history","tutorial","guide","instructions","playback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57527 20 10.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0707 20H10.9294C9.57535 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0707V10.9294C3.99997 9.57535 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57527 3.99997 10.9294 4H13.0706ZM7.84144 6.10092C8.57626 6.00213 9.55752 6.00001 11 6.00001L11 8L6.0815 8C6.08752 7.94588 6.09398 7.89305 6.10092 7.84144C6.19585 7.13538 6.36322 6.80836 6.58579 6.58579C6.80836 6.36322 7.13538 6.19585 7.84144 6.10092ZM13 6.00001L13 8L17.9185 8C17.9125 7.94588 17.906 7.89305 17.8991 7.84144C17.8042 7.13538 17.6368 6.80836 17.4142 6.58579C17.1916 6.36322 16.8646 6.19585 16.1586 6.10092C15.4238 6.00213 14.4425 6.00001 13 6.00001ZM14.9769 14.2874C15.0077 14.0971 15.0077 13.9029 14.9769 13.7126C14.8785 13.1041 14.4419 12.7343 14.091 12.4975C13.741 12.2613 13.1603 11.9689 12.6167 11.6951C12.1694 11.4698 11.7598 11.2634 11.4141 11.1418C11.0512 11.0141 10.5707 10.9085 10.0748 11.1228C9.9132 11.1926 9.76279 11.2862 9.62852 11.4006C9.2165 11.7516 9.09542 12.2317 9.0465 12.6157C8.9999 12.9816 8.99995 13.4962 9 14C8.99995 14.5038 8.9999 15.0184 9.0465 15.3843C9.09542 15.7683 9.2165 16.2484 9.62852 16.5994C9.76279 16.7138 9.91321 16.8074 10.0748 16.8773C10.5707 17.0915 11.0512 16.9859 11.4141 16.8582C11.7598 16.7366 12.1694 16.5302 12.6167 16.3048C13.1603 16.0311 13.741 15.7387 14.091 15.5025C14.4419 15.2657 14.8785 14.8959 14.9769 14.2874Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    reel: {
        defaultColors: ["#3D4C66"],
        keywords: ["video","play","media","content","display","transaction-history","tutorial","guide","instructions","playback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1058 11.699C10.5322 11.5161 11.0826 11.7913 12.1833 12.3416C13.5069 13.0034 14.1686 13.3343 14.2509 13.8392C14.2683 13.9457 14.2683 14.0543 14.2509 14.1608C14.1686 14.6657 13.5069 14.9966 12.1833 15.6584C11.0826 16.2087 10.5322 16.4839 10.1058 16.301C10.0147 16.2619 9.92995 16.2095 9.85427 16.1455C9.5 15.8459 9.5 15.2306 9.5 14L9.5 14C9.5 12.7694 9.5 12.1541 9.85427 11.8545C9.92995 11.7905 10.0147 11.7381 10.1058 11.699Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5L12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "refund-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["refund","box","return","arrow-left","withdrawal","payment-reversal","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "refund-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["refund","money-back","return","transaction-reversal","dollar-sign","finance","currency","reimbursement","credit","exchange","money"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 15.866 9.13401 19 13 19C16.866 19 20 15.866 20 12C20 8.13401 16.866 5 13 5C10.2076 5 7.79709 6.63505 6.67363 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L6.6736 9.00001L8.99997 8.50001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 9H14M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "refund-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["refund","money-back","return","transaction","dollar","currency","cashback","reverse-transaction","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 15.866 9.13401 19 13 19C16.866 19 20 15.866 20 12C20 8.13401 16.866 5 13 5C10.2076 5 7.79709 6.63505 6.67363 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L6.6736 9.00001L8.99997 8.50001"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 9H14M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "refund-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["refund","return","money-back","exchange","transaction-reversal","dollar","cashback","reimbursement","credit","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0548 4C9.59484 4 7.41484 5.14 5.97484 6.91L5.86484 6.58C5.71484 6.14 5.23484 5.9 4.78484 6.05C4.33484 6.19 4.09484 6.68 4.24484 7.12L4.91484 9.12C4.92484 9.15 4.95484 9.18 4.96484 9.22C4.99484 9.28 5.02484 9.35 5.07484 9.4C5.09484 9.43 5.12484 9.44 5.15484 9.46C5.21484 9.51 5.26484 9.56 5.33484 9.59C5.33484 9.59 5.34484 9.6 5.35484 9.61C5.38484 9.62 5.41484 9.62 5.44484 9.63C5.50484 9.65 5.56484 9.67 5.63484 9.68C5.68484 9.68 5.73484 9.68 5.78484 9.68C5.82484 9.68 5.86484 9.68 5.89484 9.68L8.22484 9.18C8.68484 9.08 8.97484 8.63 8.87484 8.17C8.77484 7.71 8.32484 7.42 7.86484 7.52L7.65484 7.57C8.77484 6.42 10.3248 5.71 12.0448 5.71C15.4448 5.71 18.1948 8.46 18.1948 11.86C18.1948 15.26 15.4448 18.01 12.0448 18.01C8.64484 18.01 5.90484 15.25 5.90484 11.85C5.90484 11.38 5.52484 11 5.05484 11C4.58484 11 4.20484 11.38 4.20484 11.85C4.20484 16.19 7.71484 19.7 12.0548 19.7C16.3948 19.7 19.9048 16.19 19.9048 11.85C19.9048 7.51 16.3948 4 12.0548 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3848 14H10.0548C9.58484 14 9.20484 14.38 9.20484 14.85C9.20484 15.32 9.58484 15.7 10.0548 15.7H10.7048V15.85C10.7048 16.32 11.0848 16.7 11.5548 16.7C12.0248 16.7 12.4048 16.32 12.4048 15.85V15.7C13.7048 15.7 14.9048 14.72 14.9048 13.35C14.9048 11.98 13.6948 11 12.3848 11H11.5548C11.1948 11 10.9048 10.71 10.9048 10.35C10.9048 9.99 11.1948 9.7 11.5548 9.7H13.0548C13.5248 9.7 13.9048 9.32 13.9048 8.85C13.9048 8.38 13.5248 8 13.0548 8H12.4048V7.85C12.4048 7.38 12.0248 7 11.5548 7C11.0848 7 10.7048 7.38 10.7048 7.85V8.16C9.82484 8.5 9.20484 9.35 9.20484 10.35C9.20484 11.65 10.2548 12.7 11.5548 12.7H12.3848C12.9248 12.7 13.2048 13.07 13.2048 13.35C13.2048 13.63 12.9248 14 12.3848 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "refund-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["refund","money","return","dollar","transaction","credit","cashback","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 15.866 9.13401 19 13 19C16.866 19 20 15.866 20 12C20 8.13401 16.866 5 13 5C10.2076 5 7.79709 6.63505 6.67363 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7L6.6736 9.00001L8.99997 8.50001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5 9H14M12.5 9C11.6716 9 11 9.67157 11 10.5C11 11.3284 11.6716 12 12.5 12H13.3333C14.2538 12 15 12.6716 15 13.5C15 14.3284 14.2538 15 13.3333 15H12.5M12.5 9V8M11 15L12.5 15M12.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "refund-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["refund","box","arrow-left","return","undo","transaction","payment","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 11V13.07C3 14.42 3 15.54 3.12 16.43C3.24 17.36 3.52 18.18 4.17 18.83C4.83 19.49 5.65 19.76 6.57 19.88C7.45 20 8.57 20 9.92 20H14.06C15.41 20 16.53 20 17.41 19.88C18.34 19.76 19.16 19.48 19.81 18.83C20.47 18.17 20.74 17.35 20.86 16.43C20.98 15.55 21 14.35 21 13V11.01H3V11ZM15 16.5H9C8.57 16.5 8.19 16.22 8.05 15.82C7.91 15.41 8.05 14.96 8.4 14.7L10.4 13.2C10.84 12.87 11.47 12.96 11.8 13.4C12.05 13.73 12.06 14.16 11.87 14.5H15C15.55 14.5 16 14.95 16 15.5C16 16.05 15.55 16.5 15 16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.88 7.57C20.76 6.64 20.48 5.82 19.83 5.17C19.18 4.52 18.35 4.24 17.43 4.12C16.54 4 15.42 4 14.07 4H9.93002C8.58002 4 7.46002 4 6.57002 4.12C5.64002 4.24 4.82002 4.52 4.17002 5.17C3.52002 5.82 3.24002 6.65 3.12002 7.57C3.06002 7.99 3.03002 8.47 3.02002 9H21C20.98 8.47 20.94 8 20.88 7.57Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    refund: {
        defaultColors: ["#3D4C66"],
        keywords: ["refund","box","arrow-left","return","undo","transaction","payment","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "refund-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["refund","return","transaction","undo","payment-reversal","reversal","credit","box","cash-drawer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10H4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 14L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Repeat-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","reload","refresh","loop","recurring","transaction","restart","cycle","retry","reorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V17C8.13077 17 7.19615 17 6.5 16.5981C6.04394 16.3348 5.66523 15.9561 5.40192 15.5C5 14.8038 5 13.8692 5 12V12C5 10.1308 5 9.19615 5.40192 8.5C5.66523 8.04394 6.04394 7.66523 6.5 7.40192C7.19615 7 8.13077 7 10 7L14 7C15.8692 7 16.8038 7 17.5 7.40192C17.9561 7.66523 18.3348 8.04394 18.5981 8.5C19 9.19615 19 10.1308 19 12V12C19 13.8692 19 14.8038 18.5981 15.5C18.3348 15.9561 17.9561 16.3348 17.5 16.5981C16.8038 17 15.8692 17 14 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 19L9.58579 18.4142C10.2525 17.7475 10.5858 17.4142 10.5858 17C10.5858 16.5858 10.2525 16.2525 9.58579 15.5858L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Repeat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["repeat","replay","loop","redo","retry","repeat-transaction","recycle","recall","iterate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V17C8.13077 17 7.19615 17 6.5 16.5981C6.04394 16.3348 5.66523 15.9561 5.40192 15.5C5 14.8038 5 13.8692 5 12V12C5 10.1308 5 9.19615 5.40192 8.5C5.66523 8.04394 6.04394 7.66523 6.5 7.40192C7.19615 7 8.13077 7 10 7L14 7C15.8692 7 16.8038 7 17.5 7.40192C17.9561 7.66523 18.3348 8.04394 18.5981 8.5C19 9.19615 19 10.1308 19 12V12C19 13.8692 19 14.8038 18.5981 15.5C18.3348 15.9561 17.9561 16.3348 17.5 16.5981C16.8038 17 15.8692 17 14 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 19L9.58579 18.4142C10.2525 17.7475 10.5858 17.4142 10.5858 17C10.5858 16.5858 10.2525 16.2525 9.58579 15.5858L9 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Repeat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","replay","loop","reorder","recycle","recurring","retry","reprocess","restart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.95396 6H14.046C14.9415 5.99998 15.6805 5.99997 16.2802 6.05432C16.9039 6.11085 17.4744 6.23242 18 6.5359C18.6081 6.88697 19.113 7.39193 19.4641 8C19.7676 8.52564 19.8892 9.09615 19.9457 9.71983C20 10.3195 20 11.0585 20 11.9539V12.0461C20 12.9415 20 13.6805 19.9457 14.2802C19.8892 14.9039 19.7676 15.4744 19.4641 16C19.113 16.6081 18.6081 17.113 18 17.4641C17.4744 17.7676 16.9039 17.8892 16.2802 17.9457C15.6805 18 14.9415 18 14.0461 18H14C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16C14.953 16 15.6009 15.999 16.0996 15.9538C16.5846 15.9099 16.8295 15.8305 17 15.7321C17.304 15.5565 17.5565 15.304 17.7321 15C17.8305 14.8295 17.9099 14.5846 17.9538 14.0996C17.999 13.6009 18 12.953 18 12C18 11.047 17.999 10.3991 17.9538 9.90036C17.9099 9.41539 17.8305 9.17051 17.7321 9C17.5565 8.69596 17.304 8.44349 17 8.26795C16.8295 8.16951 16.5846 8.09011 16.0996 8.04616C15.6009 8.00096 14.953 8 14 8H10C9.04698 8 8.39908 8.00096 7.90036 8.04616C7.41539 8.09011 7.17051 8.16951 7 8.26795C6.69596 8.44349 6.44349 8.69596 6.26795 9C6.16951 9.17051 6.09011 9.41539 6.04616 9.90036C6.00096 10.3991 6 11.047 6 12C6 12.953 6.00096 13.6009 6.04616 14.0996C6.09011 14.5846 6.16951 14.8295 6.26795 15C6.44349 15.304 6.69596 15.5565 7 15.7321C7.17051 15.8305 7.41539 15.9099 7.90036 15.9538C8.09852 15.9718 8.32023 15.9828 8.57527 15.9895L8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929L10.2929 14.8787C10.3057 14.8915 10.3186 14.9043 10.3314 14.9171C10.6313 15.2169 10.9228 15.5083 11.1308 15.781C11.3653 16.0884 11.5858 16.4863 11.5858 17C11.5858 17.5137 11.3653 17.9116 11.1308 18.219C10.9228 18.4917 10.6313 18.7831 10.3314 19.0829C10.3186 19.0957 10.3057 19.1085 10.2929 19.1213L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L8.59527 17.9905C8.27543 17.983 7.98411 17.9696 7.71983 17.9457C7.09615 17.8892 6.52564 17.7676 6 17.4641C5.39193 17.113 4.88697 16.6081 4.5359 16C4.23242 15.4744 4.11085 14.9039 4.05432 14.2802C3.99997 13.6805 3.99998 12.9415 4 12.046V11.954C3.99998 11.0585 3.99997 10.3195 4.05432 9.71983C4.11085 9.09615 4.23242 8.52564 4.5359 8C4.88697 7.39192 5.39192 6.88697 6 6.5359C6.52564 6.23242 7.09615 6.11085 7.71983 6.05432C8.31952 5.99997 9.05849 5.99998 9.95396 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "repeat-top-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["repeat","sync","refresh","arrows","cycle","transaction","history","recurring","reload","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 6L12 6V6C13.8692 6 14.8038 6 15.5 6.40192C15.9561 6.66523 16.3348 7.04394 16.5981 7.5C17 8.19615 17 9.13077 17 11L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 18L12 18V18C10.1308 18 9.19615 18 8.5 17.5981C8.04394 17.3348 7.66523 16.9561 7.40192 16.5C7 15.8038 7 14.8692 7 13L7 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 16L17 18L19 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8L7 6L5 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "repeat-top-bottom-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["repeat","sync","arrows","refresh","cycle","reverse","transaction","history","undo","redo","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L17 18L19 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6L12 6V6C13.8692 6 14.8038 6 15.5 6.40192C15.9561 6.66523 16.3348 7.04394 16.5981 7.5C17 8.19615 17 9.13077 17 11L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 8L7 6L5 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 18L12 18V18C10.1308 18 9.19615 18 8.5 17.5981C8.04394 17.3348 7.66523 16.9561 7.40192 16.5C7 15.8038 7 14.8692 7 13L7 6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "repeat-top-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","refresh","reload","sync","arrows","transaction-repeat","order-repeat","resync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 7C10.9477 7 10.5 6.55229 10.5 6C10.5 5.44772 10.9477 5 11.5 5H12.546C13.4415 4.99999 14.1805 4.99997 14.7802 5.05432C15.4039 5.11085 15.9744 5.23242 16.5 5.5359C17.1081 5.88697 17.613 6.39193 17.9641 7C18.2676 7.52564 18.3892 8.09615 18.4457 8.71983C18.5 9.31952 18.5 10.0585 18.5 10.9539L18.5 15.5858L18.7929 15.2929C19.1834 14.9024 19.8166 14.9024 20.2071 15.2929C20.5976 15.6834 20.5976 16.3166 20.2071 16.7071L18.2074 18.7068C18.0198 18.8944 17.7652 19 17.5 19C17.2348 19 16.9804 18.8946 16.7929 18.7071L14.7929 16.7071C14.4024 16.3166 14.4024 15.6834 14.7929 15.2929C15.1834 14.9024 15.8166 14.9024 16.2071 15.2929L16.5 15.5858V11C16.5 10.047 16.499 9.39908 16.4538 8.90036C16.4099 8.41539 16.3305 8.17051 16.2321 8C16.0565 7.69596 15.804 7.44349 15.5 7.26795C15.3295 7.16951 15.0846 7.09011 14.5996 7.04616C14.1009 7.00096 13.453 7 12.5 7L11.5 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5 17C13.0523 17 13.5 17.4477 13.5 18C13.5 18.5523 13.0523 19 12.5 19H11.454C10.5585 19 9.81952 19 9.21983 18.9457C8.59615 18.8892 8.02564 18.7676 7.5 18.4641C6.89192 18.113 6.38697 17.6081 6.0359 17C5.73242 16.4744 5.61085 15.9039 5.55432 15.2802C5.49997 14.6805 5.49998 13.9415 5.5 13.0461L5.5 8.41421L5.20711 8.70711C4.81658 9.09763 4.18342 9.09763 3.79289 8.70711C3.40237 8.31658 3.40237 7.68342 3.79289 7.29289L5.79263 5.29316C5.98016 5.10562 6.23478 5 6.5 5C6.76522 5 7.01957 5.10536 7.20711 5.29289L9.20711 7.29289C9.59763 7.68342 9.59763 8.31658 9.20711 8.70711C8.81658 9.09763 8.18342 9.09763 7.79289 8.70711L7.5 8.41422V13C7.5 13.953 7.50096 14.6009 7.54616 15.0996C7.59011 15.5846 7.66951 15.8295 7.76795 16C7.94349 16.304 8.19596 16.5565 8.5 16.7321C8.67051 16.8305 8.91539 16.9099 9.40036 16.9538C9.89908 16.999 10.547 17 11.5 17H12.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "repeat-top-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","refresh","reload","sync","cycle","reset","update","revert","reconciliation","synchronize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L17 18L19 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6L12 6V6C13.8692 6 14.8038 6 15.5 6.40192C15.9561 6.66523 16.3348 7.04394 16.5981 7.5C17 8.19615 17 9.13077 17 11L17 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 8L7 6L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 18L12 18V18C10.1308 18 9.19615 18 8.5 17.5981C8.04394 17.3348 7.66523 16.9561 7.40192 16.5C7 15.8038 7 14.8692 7 13L7 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Repeat: {
        defaultColors: ["#3D4C66"],
        keywords: ["repeat","refresh","reload","sync","cycle","reset","update","revert","reconciliation","synchronize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17V17C8.13077 17 7.19615 17 6.5 16.5981C6.04394 16.3348 5.66523 15.9561 5.40192 15.5C5 14.8038 5 13.8692 5 12V12C5 10.1308 5 9.19615 5.40192 8.5C5.66523 8.04394 6.04394 7.66523 6.5 7.40192C7.19615 7 8.13077 7 10 7L14 7C15.8692 7 16.8038 7 17.5 7.40192C17.9561 7.66523 18.3348 8.04394 18.5981 8.5C19 9.19615 19 10.1308 19 12V12C19 13.8692 19 14.8038 18.5981 15.5C18.3348 15.9561 17.9561 16.3348 17.5 16.5981C16.8038 17 15.8692 17 14 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 19L9.58579 18.4142C10.2525 17.7475 10.5858 17.4142 10.5858 17C10.5858 16.5858 10.2525 16.2525 9.58579 15.5858L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reply-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["send","share","forward","next","continue","submit","arrow","right","reply","email","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 8V5L19 11L13 17V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M13 8C8.58172 8 5 11.5817 5 16V18C5 15.2386 7.23858 14 10 14H13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reply-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["reply","forward","send","share","return","redirect","arrow","submit","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 11L13 17V14H10C7.23858 14 5 15.2386 5 18V16C5 11.5817 8.58172 8 13 8V5L19 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reply-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["reply","return","arrow","forward","transfer","redirect","next","re-enter","re-submit","re-order","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.6173 4.07615C12.991 3.92137 13.4211 4.00692 13.7071 4.29292L19.7071 10.2929C20.0976 10.6834 20.0976 11.3166 19.7071 11.7071L13.7071 17.7071C13.4211 17.9931 12.991 18.0787 12.6173 17.9239C12.2436 17.7691 12 17.4045 12 17V15H10C8.74947 15 7.72976 15.2832 7.05074 15.7746C6.41452 16.235 6 16.9291 6 18C6 18.5523 5.55228 19 5 19C4.44772 19 4 18.5523 4 18V16C4 11.3675 7.50005 7.5524 12 7.05496V5.00003C12 4.59557 12.2436 4.23093 12.6173 4.07615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    reply: {
        defaultColors: ["#3D4C66"],
        keywords: ["reply","return","arrow","forward","transfer","redirect","next","re-enter","re-submit","re-order","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 8C8.58172 8 5 11.5817 5 16V18C5 15.2386 7.23858 14 10 14H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 8V5L19 11L13 17V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "request-quote-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["document","dollar","money","payment","bill","invoice","request","quote","price","estimate","financial-document"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11H13M12 11V10M12 11V11C11.4477 11 11 11.4477 11 12V12C11 12.5523 11.4477 13 12 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L11 15M12 15L12 16M12 15V15C12.5523 15 13 14.5523 13 14V14C13 13.4477 12.5523 13 12 13V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "request-quote-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["invoice","dollar","payment","receipt","transaction","quote","price","billing","statement","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11H13M12 11V10M12 11V11C11.4477 11 11 11.4477 11 12V12C11 12.5523 11.4477 13 12 13V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L11 15M12 15L12 16M12 15V15C12.5523 15 13 14.5523 13 14V14C13 13.4477 12.5523 13 12 13V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.4801 9.35012L15.6247 5.78087C15.2299 5.28731 14.6321 5 14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H18.1677C18.529 10 18.7097 10 18.7641 9.88664C18.8186 9.77328 18.7058 9.63222 18.4801 9.35012Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "request-quote-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["document","dollar","currency","money","invoice","bill","price","quote","estimate","request","sales-order","order","transaction","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3137 3.99987C13.0522 3.99921 13.6837 3.99864 14.25 4.08581L14.25 5.052C14.25 5.95048 14.2499 6.6997 14.3299 7.29448C14.4143 7.92227 14.6 8.48907 15.0555 8.94454C15.5109 9.40001 16.0777 9.58568 16.7055 9.67009C17.3003 9.75005 18.0495 9.75003 18.948 9.75L19.2004 9.75002C19.3505 9.75015 19.5362 9.7503 19.6893 9.72797C19.7114 9.72474 19.7386 9.72029 19.7694 9.71381L19.7745 9.7283C20.0011 10.3744 20.0007 11.0588 20.0001 11.9609L20 13.0706C20 14.4247 20.0001 15.5413 19.8813 16.425C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8812C15.5413 20 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20 7.57494 19.8812C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.425C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9293C3.99997 9.57527 3.99994 8.45866 4.11876 7.57492C4.2435 6.64709 4.51547 5.82767 5.17158 5.17156C5.82769 4.51545 6.64711 4.24348 7.57494 4.11874C8.4587 3.99992 9.57532 3.99995 10.9294 3.99998L12.3137 3.99987ZM12.75 10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V10.4184C10.6588 10.6993 10.25 11.3019 10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.1381 13.75 12.25 13.8619 12.25 14C12.25 14.1381 12.1381 14.25 12 14.25H11C10.5858 14.25 10.25 14.5858 10.25 15C10.25 15.4142 10.5858 15.75 11 15.75H11.25V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V15.5816C13.3412 15.3007 13.75 14.6981 13.75 14C13.75 13.0335 12.9665 12.25 12 12.25C11.8619 12.25 11.75 12.1381 11.75 12C11.75 11.8619 11.8619 11.75 12 11.75H13C13.4142 11.75 13.75 11.4142 13.75 11C13.75 10.5858 13.4142 10.25 13 10.25H12.75V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.75 4.9815V5C15.75 5.96401 15.7516 6.61157 15.8165 7.09461C15.8786 7.55607 15.9858 7.75357 16.1161 7.88388C16.2464 8.0142 16.4439 8.12142 16.9054 8.18346C17.2881 8.23492 17.7741 8.24661 18.4389 8.24924L16.039 5.24939C15.9556 5.14506 15.8579 5.05514 15.75 4.9815Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "request-quote": {
        defaultColors: ["#3D4C66"],
        keywords: ["invoice","dollar","currency","money","bill","price","quote","estimate","finance","accounting","document","record","request","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H12.1163C13.5332 5 14.2416 5 14.8577 5.29609C15.4737 5.59218 15.9163 6.1454 16.8015 7.25183L17.6852 8.35652L17.6852 8.35652C18.3363 9.17032 18.6618 9.57721 18.8309 10.0593C19 10.5414 19 11.0625 19 12.1047V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11H13M12 11V10M12 11V11C11.4477 11 11 11.4477 11 12V12C11 12.5523 11.4477 13 12 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L11 15M12 15L12 16M12 15V15C12.5523 15 13 14.5523 13 14V14C13 13.4477 12.5523 13 12 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 5V6C14 7.88562 14 8.82843 14.5858 9.41421C15.1716 10 16.1144 10 18 10H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Reserved-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["reserved","r","restricted","circle","trademark","copyright"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM13.3558 16.3841C13.568 16.7399 14.0284 16.8563 14.3841 16.6442C14.7399 16.432 14.8563 15.9716 14.6442 15.6159L13.3558 16.3841ZM12.2575 11.6137C12.0454 11.2579 11.585 11.1415 11.2292 11.3537C10.8735 11.5658 10.757 12.0262 10.9692 12.382L12.2575 11.6137ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM14.6442 15.6159L12.2575 11.6137L10.9692 12.382L13.3558 16.3841L14.6442 15.6159ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "Reserved-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["reserved","hold","table","section","status","available","unavailable","R"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM13.3558 16.3841C13.568 16.7399 14.0284 16.8563 14.3841 16.6442C14.7399 16.432 14.8563 15.9716 14.6442 15.6159L13.3558 16.3841ZM12.2575 11.6137C12.0454 11.2579 11.585 11.1415 11.2292 11.3537C10.8735 11.5658 10.757 12.0262 10.9692 12.382L12.2575 11.6137ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM14.6442 15.6159L12.2575 11.6137L10.9692 12.382L13.3558 16.3841L14.6442 15.6159ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Reserved-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["R","reserved","table","restaurant","order","booking","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11H11.5445C11.5899 10.9969 11.6353 10.9969 11.6804 11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9H11V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 7C9.44772 7 9 7.44772 9 8V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V13H11.0467L13.1411 16.5122C13.424 16.9865 14.0378 17.1417 14.5122 16.8589C14.9865 16.576 15.1417 15.9622 14.8589 15.4878L13.2209 12.7411C14.2693 12.2735 15 11.2221 15 10C15 8.34315 13.6569 7 12 7H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Reserved: {
        defaultColors: ["#3D4C66"],
        keywords: ["R","reserved","table","restaurant","order","booking","availability"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 8V7.25C9.58579 7.25 9.25 7.58579 9.25 8H10ZM13.3558 16.3841C13.568 16.7399 14.0284 16.8563 14.3841 16.6442C14.7399 16.432 14.8563 15.9716 14.6442 15.6159L13.3558 16.3841ZM12.2575 11.6137C12.0454 11.2579 11.585 11.1415 11.2292 11.3537C10.8735 11.5658 10.757 12.0262 10.9692 12.382L12.2575 11.6137ZM9.25 16C9.25 16.4142 9.58579 16.75 10 16.75C10.4142 16.75 10.75 16.4142 10.75 16H9.25ZM14.6442 15.6159L12.2575 11.6137L10.9692 12.382L13.3558 16.3841L14.6442 15.6159ZM10 8.75H12V7.25H10V8.75ZM12 11.25H10V12.75H12V11.25ZM10.75 12V8H9.25V12H10.75ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25V12.75C13.5188 12.75 14.75 11.5188 14.75 10H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM9.25 12V16H10.75V12H9.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Reshare-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sync","refresh","resync","update","reload","repeat","arrows","cycle","rotation","exchange","reorder","reset","redo","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18L16 18V18C16.93 18 17.395 18 17.7765 17.8978C18.8117 17.6204 19.6204 16.8117 19.8978 15.7765C20 15.395 20 14.93 20 14L20 12.0001C20 9.17182 20 7.7577 19.1214 6.87904C19.1214 6.87902 19.1214 6.879 19.1213 6.87898C18.2427 6.00034 16.8286 6.00026 14.0004 6.00011L12 6M13.991 8L12 6M12 6L13.991 4"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6H8V6C7.07003 6 6.60504 6 6.22354 6.10222C5.18827 6.37962 4.37962 7.18827 4.10222 8.22354C4 8.60504 4 9.07003 4 10V11.9999C4 14.8282 4 16.2423 4.87859 17.121C4.87861 17.121 4.87863 17.121 4.87865 17.121C5.75727 17.9997 7.17139 17.9997 9.99962 17.9999L12 18M10.009 16L12 18M12 18L10.009 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Reshare-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","repeat","cycle","sync","update","retry","loop","exchange","resync","reshare","reorder","retransmit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1376 19C16.9329 19.0005 17.5236 19.0008 18.0353 18.8637C19.4156 18.4938 20.4938 17.4156 20.8637 16.0353C21.0008 15.5236 21.0005 14.933 21 14.1376L21 11.9295C21 10.5755 21 9.45892 20.8812 8.57522C20.7565 7.64744 20.4845 6.82798 19.8284 6.17188C19.1724 5.5158 18.353 5.24382 17.4252 5.11904C16.6156 5.01014 15.6105 5.00099 14.4063 5.00019L14.6997 4.70551C15.0893 4.31411 15.0879 3.68095 14.6965 3.2913C14.3051 2.90166 13.6719 2.90309 13.2823 3.29449L11.2913 5.29449C10.9029 5.68465 10.9029 6.31536 11.2913 6.70551L13.2823 8.70551C13.6719 9.09692 14.3051 9.09834 14.6965 8.7087C15.0879 8.31905 15.0893 7.68589 14.6997 7.29449L14.4068 7.00028C15.6305 7.00152 16.4951 7.01194 17.1586 7.10119C17.8647 7.19614 18.1917 7.36356 18.4142 7.58612C18.6368 7.80869 18.8042 8.13569 18.8991 8.8417C18.9979 9.57647 19 10.5577 19 12.0001V14C19 14.9944 18.9914 15.2954 18.9318 15.5176C18.7469 16.2078 18.2078 16.7469 17.5176 16.9319C17.2953 16.9914 16.9943 17 16 17H15C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19L16.1376 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.86239 5.0002C7.06701 4.99976 6.47635 4.99944 5.9647 5.13654C4.58433 5.50641 3.50614 6.5846 3.13627 7.96497C2.99917 8.47662 2.99949 9.06727 2.99993 9.86265L2.99997 12.0708C2.99994 13.4248 2.99991 14.5413 3.11872 15.425C3.24345 16.3528 3.51547 17.1723 4.17151 17.8284C4.82757 18.4844 5.64694 18.7564 6.57471 18.8812C7.38436 18.9901 8.38948 18.9993 9.59362 19.0001L9.30027 19.2947C8.91062 19.6861 8.91205 20.3193 9.30345 20.7089C9.69486 21.0986 10.328 21.0972 10.7177 20.7058L12.7087 18.7058C13.0971 18.3156 13.0971 17.6849 12.7087 17.2947L10.7177 15.2947C10.328 14.9033 9.69486 14.9019 9.30345 15.2915C8.91205 15.6812 8.91062 16.3144 9.30027 16.7058L9.59316 17C8.36943 16.9987 7.50487 16.9883 6.8413 16.8991C6.1353 16.8041 5.80826 16.6367 5.5857 16.4141C5.36315 16.1916 5.1958 15.8646 5.10088 15.1585C5.0021 14.4238 4.99997 13.4426 4.99997 12.0002L4.99997 10.0002C4.99997 9.00589 5.00856 8.70489 5.06812 8.48261C5.25306 7.79242 5.79215 7.25333 6.48234 7.06839C6.70461 7.00883 7.00562 7.00024 7.99997 7.00024H8.99997C9.55226 7.00024 9.99997 6.55253 9.99997 6.00024C9.99997 5.44796 9.55226 5.00024 8.99997 5.00024L7.86239 5.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Reshare-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sync","refresh","reload","repeat","reorder","update","exchange","return","cycle","loop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18L16 18V18C16.93 18 17.395 18 17.7765 17.8978C18.8117 17.6204 19.6204 16.8117 19.8978 15.7765C20 15.395 20 14.93 20 14L20 12.0001C20 9.17182 20 7.7577 19.1214 6.87904C19.1214 6.87902 19.1214 6.879 19.1213 6.87898C18.2427 6.00034 16.8286 6.00026 14.0004 6.00011L12 6M13.991 8L12 6M12 6L13.991 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6H8V6C7.07003 6 6.60504 6 6.22354 6.10222C5.18827 6.37962 4.37962 7.18827 4.10222 8.22354C4 8.60504 4 9.07003 4 10V11.9999C4 14.8282 4 16.2423 4.87859 17.121C4.87861 17.121 4.87863 17.121 4.87865 17.121C5.75727 17.9997 7.17139 17.9997 9.99962 17.9999L12 18M10.009 16L12 18M12 18L10.009 20"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reshare-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","sync","update","repeat","retry","cycle","circular","resync","reset","recalculate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.75 6H9V6C7.34315 6 6 7.34315 6 9V12C6 14.8282 6 16.2424 6.8786 17.121C7.75721 17.9997 9.17147 17.9998 12 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16L12 18L10 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 18L15 18V18C16.6569 18 18 16.6569 18 15L18 12C18 9.17176 18 7.75764 17.1214 6.87897C16.2428 6.00031 14.8285 6.00021 12 6V6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4933 8L12 6L13.4933 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reshare-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sync","refresh","update","reload","re-sync","synchronize","loop","repeat","cycle","order-sync","inventory-sync","price-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.75 6H9V6C7.34315 6 6 7.34315 6 9V12C6 14.8282 6 16.2424 6.8786 17.121C7.75721 17.9997 9.17147 17.9998 12 18V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16L12 18L10 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 18L15 18V18C16.6569 18 18 16.6569 18 15L18 12C18 9.17176 18 7.75764 17.1214 6.87897C16.2428 6.00031 14.8285 6.00021 12 6V6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4933 8L12 6L13.4933 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reshare-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["refresh","reload","sync","repeat","update","circular","arrows","resync","inventory-sync","price-update","order-refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.75 6H9V6C7.34315 6 6 7.34315 6 9V12C6 14.8282 6 16.2424 6.8786 17.121C7.75721 17.9997 9.17147 17.9998 12 18V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16L12 18L10 20"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.25 18L15 18V18C16.6569 18 18 16.6569 18 15L18 12C18 9.17176 18 7.75764 17.1214 6.87897C16.2428 6.00031 14.8285 6.00021 12 6V6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.4933 8L12 6L13.4933 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Reshare: {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","sync","repeat","update","circular","arrows","resync","inventory-sync","price-update","order-refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18L16 18V18C16.93 18 17.395 18 17.7765 17.8978C18.8117 17.6204 19.6204 16.8117 19.8978 15.7765C20 15.395 20 14.93 20 14L20 12.0001C20 9.17182 20 7.7577 19.1214 6.87904C19.1214 6.87902 19.1214 6.879 19.1213 6.87898C18.2427 6.00034 16.8286 6.00026 14.0004 6.00011L12 6M13.991 8L12 6M12 6L13.991 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 6H8V6C7.07003 6 6.60504 6 6.22354 6.10222C5.18827 6.37962 4.37962 7.18827 4.10222 8.22354C4 8.60504 4 9.07003 4 10V11.9999C4 14.8282 4 16.2423 4.87859 17.121C4.87861 17.121 4.87863 17.121 4.87865 17.121C5.75727 17.9997 7.17139 17.9997 9.99962 17.9999L12 18M10.009 16L12 18M12 18L10.009 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "reshare-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["refresh","reload","sync","update","repeat","reorder","loop","cycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.6918 8.59833C14.0222 9.04087 14.6488 9.13177 15.0914 8.80136C15.5339 8.47094 15.6248 7.84433 15.2944 7.40179L15.008 7.01826C15.4534 7.03227 15.8306 7.05714 16.1586 7.10126C16.8647 7.19623 17.1917 7.36362 17.4143 7.58618C17.6368 7.80875 17.8042 8.13575 17.8991 8.84176C17.9979 9.57654 18 10.5577 18 12.0001V15.0001C18 16.1047 17.1046 17.0001 16 17.0001H15.25C14.6977 17.0001 14.25 17.4478 14.25 18.0001C14.25 18.5524 14.6977 19.0001 15.25 19.0001H16C18.2091 19.0001 20 17.2093 20 15.0001L20 11.9296C20 10.5755 20.0001 9.45898 19.8813 8.57527C19.7565 7.64749 19.4846 6.82811 18.8285 6.17201C18.1725 5.5159 17.353 5.24391 16.4252 5.11911C15.9986 5.06173 15.5177 5.03203 14.9821 5.01666L15.2944 4.59833C15.6248 4.15579 15.5339 3.52918 15.0914 3.19877C14.6488 2.86835 14.0222 2.95925 13.6918 3.40179L12.1986 5.40179C11.9336 5.75664 11.9336 6.24348 12.1986 6.59833L13.6918 8.59833Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 9.00012C6 7.89555 6.89543 7.00012 8 7.00012H8.75C9.30229 7.00012 9.75 6.55241 9.75 6.00012C9.75 5.44784 9.30229 5.00012 8.75 5.00012H8C5.79086 5.00012 4 6.79098 4 9.00012L4 12.0707C3.99997 13.4247 3.99994 14.5413 4.11875 15.425C4.24348 16.3527 4.51542 17.1721 5.17147 17.8282C5.82754 18.4843 6.64696 18.7563 7.57478 18.8811C7.89214 18.9238 8.23954 18.9512 8.61718 18.9687L8.29289 19.293C7.90237 19.6835 7.90237 20.3167 8.29289 20.7072C8.68342 21.0978 9.31658 21.0978 9.70711 20.7072L11.7057 18.7086L11.7179 18.6962C11.8075 18.6039 11.8758 18.4985 11.9227 18.3864C11.9725 18.2676 12 18.1371 12 18.0002C12 17.7296 11.8926 17.4841 11.718 17.3041L11.7056 17.2915L9.70711 15.293C9.31658 14.9025 8.68342 14.9025 8.29289 15.293C7.90237 15.6835 7.90237 16.3167 8.29289 16.7072L8.54859 16.9629C8.2886 16.9482 8.05462 16.9277 7.84139 16.899C7.13529 16.804 6.80828 16.6366 6.58574 16.4141C6.36319 16.1915 6.19583 15.8645 6.10091 15.1585C6.00213 14.4237 6 13.4425 6 12.0001V9.00012Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "resizer-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["resize","resizer","increase","decrease","scale","adjust","grow","shrink","expand","contract","size","configuration","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21L21 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 21L21 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "resizer-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["resize","scale","adjust","size","dimension","expand","shrink"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21L21 11" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 21L21 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "resizer-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["resizer","resize","adjust","size","double-line","two-lines","scale","expand","contract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7071 10.2929C22.0976 10.6834 22.0976 11.3166 21.7071 11.7071L11.7071 21.7071C11.3166 22.0976 10.6834 22.0976 10.2929 21.7071C9.90237 21.3166 9.90237 20.6834 10.2929 20.2929L20.2929 10.2929C20.6834 9.90237 21.3166 9.90237 21.7071 10.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L15.7071 21.7071C15.3166 22.0976 14.6834 22.0976 14.2929 21.7071C13.9024 21.3166 13.9024 20.6834 14.2929 20.2929L20.2929 14.2929C20.6834 13.9024 21.3166 13.9024 21.7071 14.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    resizer: {
        defaultColors: ["#3D4C66"],
        keywords: ["resizer","resize","adjust","size","double-line","two-lines","scale","expand","contract"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21L21 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 21L21 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rest-time-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sleep","rest","pause","break","zz","time-off","timeout","clock","sleep-mode","idle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H20L14 10H20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20C14.866 20 18 16.866 18 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rest-time-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rest","time","sleep","pause","break","downtime","idle","inactive","unavailable","off","snooze","shift-end","end-of-day"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H20L14 10H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20C14.866 20 18 16.866 18 13"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rest-time-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rest","time","pause","break","shift","clock","resume","hold","suspend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4C13 4.55228 13.4477 5 14 5H17.5858L13.2929 9.29289C13.0069 9.57889 12.9214 10.009 13.0761 10.3827C13.2309 10.7564 13.5956 11 14 11H20C20.5523 11 21 10.5523 21 10C21 9.44772 20.5523 9 20 9H16.4142L20.7071 4.70711C20.9931 4.42111 21.0787 3.99099 20.9239 3.61732C20.7691 3.24364 20.4045 3 20 3H14C13.4477 3 13 3.44772 13 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 5C6.58172 5 3 8.58172 3 13C3 17.4183 6.58172 21 11 21C15.4183 21 19 17.4183 19 13C19 12.4477 18.5523 12 18 12C17.4477 12 17 12.4477 17 13C17 16.3137 14.3137 19 11 19C7.68629 19 5 16.3137 5 13C5 9.68629 7.68629 7 11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rest-time": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","rest","pause","break","time-off","unavailable","downtime","off","zzz"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 4H20L14 10H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C7.13401 6 4 9.13401 4 13C4 16.866 7.13401 20 11 20C14.866 20 18 16.866 18 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rhythm-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chart","graph","bars","statistics","sales","performance","analytics","dashboard","reporting","metrics","trends","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11V19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11V19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rhythm-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bar-chart","chart","graph","statistics","sales-data","analytics","dashboard","metrics","performance","trends","analysis","reporting","sales-analysis","inventory","stock-levels"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L10 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7L18 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rhythm-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bars","graph","statistics","sales","report","analytics","dashboard","performance","metrics","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4C10.5523 4 11 4.44772 11 5L11 19C11 19.5523 10.5523 20 10 20C9.44771 20 9 19.5523 9 19L9 5C9 4.44772 9.44771 4 10 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 6C18.5523 6 19 6.44772 19 7V19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19L17 7C17 6.44772 17.4477 6 18 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10C6.55228 10 7 10.4477 7 11V19C7 19.5523 6.55228 20 6 20C5.44772 20 5 19.5523 5 19V11C5 10.4477 5.44772 10 6 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 10C14.5523 10 15 10.4477 15 11V19C15 19.5523 14.5523 20 14 20C13.4477 20 13 19.5523 13 19V11C13 10.4477 13.4477 10 14 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    rhythm: {
        defaultColors: ["#3D4C66"],
        keywords: ["bars","graph","statistics","sales","report","analytics","dashboard","performance","metrics","summary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-from-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["right","arrow","end","finish","complete","next","proceed","payment","checkout","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 17M12 7L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14L6 14C5.05719 14 4.58579 14 4.29289 13.7071C4 13.4142 4 12.9428 4 12V12C4 11.0572 4 10.5858 4.29289 10.2929C4.58579 10 5.05719 10 6 10H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17L16.1563 13.5364C17.0107 12.8244 17.438 12.4684 17.438 12C17.438 11.5316 17.0107 11.1756 16.1563 10.4636L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 6L20 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-from-line-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["right","arrow","send","submit","next","process","confirm","complete","payment","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.156 10.4619L12 7L12 10L4 10L4 14L12 14L12 17L16.1566 13.5348C17.0109 12.8226 17.438 12.4665 17.438 11.9981C17.4379 11.5298 17.0106 11.1738 16.156 10.4619Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 6L20 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-from-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["next","arrow","proceed","continue","complete","checkout","payment","submit","forward","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 19C19.9477 19 19.5 18.5523 19.5 18V6C19.5 5.44771 19.9477 5 20.5 5C21.0523 5 21.5 5.44771 21.5 6V18C21.5 18.5523 21.0523 19 20.5 19ZM11.0759 17.9056C10.7245 17.7411 10.5 17.3881 10.5 17L10.5 15L3.5 15C2.94772 15 2.5 14.5523 2.5 14L2.5 10C2.5 9.44772 2.94772 9 3.5 9L10.5 9L10.5 7C10.5 6.61202 10.7244 6.25905 11.0758 6.09445C11.4271 5.92985 11.8419 5.98333 12.14 6.23165L16.296 9.69359C16.3117 9.70663 16.3273 9.71965 16.3429 9.73265C16.7295 10.0546 17.0974 10.3609 17.3595 10.651C17.6506 10.9733 17.9378 11.41 17.938 11.9979C17.9381 12.5859 17.651 13.0226 17.36 13.3451C17.098 13.6353 16.7303 13.9417 16.3438 14.2638C16.3282 14.2768 16.3126 14.2899 16.2969 14.3029L12.1403 17.7681C11.8423 18.0166 11.4274 18.0702 11.0759 17.9056Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "right-from-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","right","end","finish","complete","transaction","next","process","right-arrow","submit","go","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L12 17M12 7L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 14L6 14C5.05719 14 4.58579 14 4.29289 13.7071C4 13.4142 4 12.9428 4 12V12C4 11.0572 4 10.5858 4.29289 10.2929C4.58579 10 5.05719 10 6 10H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17L16.1563 13.5364C17.0107 12.8244 17.438 12.4684 17.438 12C17.438 11.5316 17.0107 11.1756 16.1563 10.4636L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 6L20 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-to-bracket-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["login","enter","sign-in","arrow-right","access","authenticate","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19H12C14.8284 19 16.2426 19 17.1213 18.1213C18 17.2426 18 15.8284 18 13V11C18 8.17157 18 6.75736 17.1213 5.87868C16.2426 5 14.8284 5 12 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 10V14H10V16L14 12L10 8V10H6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-to-bracket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["login","enter","signin","arrow-right","right","arrow","access","authenticate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1586 6.10092C14.4237 6.00213 13.4425 6 12 6H10C9.44772 6 9 5.55229 9 5C9 4.44772 9.44772 4 10 4H12C12.0236 4 12.0471 4 12.0706 4C13.4247 3.99997 14.5413 3.99994 15.4251 4.11875C16.3529 4.2435 17.1723 4.51547 17.8284 5.17158C18.4845 5.82768 18.7565 6.64711 18.8812 7.57494C19.0001 8.4587 19 9.57531 19 10.9294V13.0706C19 14.4247 19.0001 15.5413 18.8812 16.4251C18.7565 17.3529 18.4845 18.1723 17.8284 18.8284C17.1723 19.4845 16.3529 19.7565 15.4251 19.8813C14.5413 20.0001 13.4247 20 12.0706 20L10 20C9.44772 20 9 19.5523 9 19C9 18.4477 9.44772 18 10 18H12C13.4425 18 14.4237 17.9979 15.1586 17.8991C15.8646 17.8042 16.1916 17.6368 16.4142 17.4142C16.6368 17.1916 16.8042 16.8646 16.8991 16.1586C16.9979 15.4238 17 14.4425 17 13V11C17 9.55752 16.9979 8.57625 16.8991 7.84143C16.8042 7.13538 16.6368 6.80836 16.4142 6.58579C16.1916 6.36322 15.8646 6.19585 15.1586 6.10092Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.61732 7.07612C9.99099 6.92134 10.4211 7.0069 10.7071 7.2929L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L10.7071 16.7071C10.4211 16.9931 9.99099 17.0787 9.61732 16.9239C9.24364 16.7691 9 16.4045 9 16V15H6C5.44772 15 5 14.5523 5 14V10C5 9.44772 5.44772 9 6 9H9V8C9 7.59554 9.24364 7.2309 9.61732 7.07612Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "right-to-bracket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["login","enter","right","arrow","submit","sign-in","authenticate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19H12C14.8284 19 16.2426 19 17.1213 18.1213C18 17.2426 18 15.8284 18 13V11C18 8.17157 18 6.75736 17.1213 5.87868C16.2426 5 14.8284 5 12 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 10L10 8M10 16L10 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8L14 12L10 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L6 10L6 14L10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "right-to-bracket": {
        defaultColors: ["#3D4C66"],
        keywords: ["login","enter","arrow","right","signin","log-in","authenticate","authentication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 19H12C14.8284 19 16.2426 19 17.1213 18.1213C18 17.2426 18 15.8284 18 13V11C18 8.17157 18 6.75736 17.1213 5.87868C16.2426 5 14.8284 5 12 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 10L10 8M10 16L10 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 8L14 12L10 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L6 10L6 14L10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ring-bell-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["food-service","dish","ready","order-ready","serve","kitchen","table-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 8L12 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L19 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14C18 10.6863 15.3137 8 12 8C8.68629 8 6 10.6863 6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ring-bell-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["food-cover","cloche","meal","service","order-ready","ready-order","order","kitchen","served"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16L19 16C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12.5523 6 13 6.44772 13 7V7.07088C16.2796 7.53994 18.8256 10.2821 18.9914 13.6509C19.0293 14.4195 18.4045 15 17.7 15H6.3C5.5955 15 4.97073 14.4195 5.00858 13.6509C5.17444 10.2821 7.72038 7.53994 11 7.07088V7C11 6.44772 11.4477 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ring-bell-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["food-cover","food","dish","meal","serve","service","ready","kitchen","restaurant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8L12 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17.7 14L6.3 14C6.13431 14 5.99922 13.8655 6.00737 13.7C6.16366 10.5257 8.78688 8 12 8C15.2131 8 17.8363 10.5257 17.9926 13.7C18.0008 13.8655 17.8657 14 17.7 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ring-bell": {
        defaultColors: ["#3D4C66"],
        keywords: ["food-tray","food-cover","food-service","waiter","dish","meal","restaurant","kitchen","serving"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 14L18 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 8L12 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14C18 10.6863 15.3137 8 12 8C8.68629 8 6 10.6863 6 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Robot-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["robot","automation","ai","chatbot","customer-service","help","assistant","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 18L13 18C15.8284 18 17.2426 18 18.1213 17.1213C18.1213 17.1213 18.1213 17.1213 18.1213 17.1213C19 16.2426 19 14.8284 19 12V12C19 9.17157 19 7.75736 18.1213 6.87868C18.1213 6.87868 18.1213 6.87868 18.1213 6.87868C17.2426 6 15.8284 6 13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["robot","chatbot","help","support","assistant","automation","ai","customer-service","tech-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["robot","automation","assistance","chatbot","help","settings","system","support","machine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 6V4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","automation","assistant","bot","support","service","agent","ai","machine","tech","technology","customer service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V5.25H13.0549C14.4225 5.24998 15.5248 5.24996 16.3918 5.36652C17.2919 5.48754 18.0497 5.74643 18.6517 6.34835C19.2536 6.95027 19.5125 7.70814 19.6335 8.60825C19.75 9.47522 19.75 10.5775 19.75 11.9451V14.0549C19.75 15.4225 19.75 16.5248 19.6335 17.3918C19.5125 18.2919 19.2536 19.0497 18.6517 19.6516C18.0497 20.2536 17.2919 20.5125 16.3918 20.6335C15.5248 20.75 14.4224 20.75 13.0548 20.75H10.9451C9.57754 20.75 8.47522 20.75 7.60825 20.6335C6.70814 20.5125 5.95027 20.2536 5.34835 19.6517C4.74643 19.0497 4.48754 18.2919 4.36652 17.3918C4.24996 16.5248 4.24998 15.4225 4.25 14.0549V11.9451C4.24998 10.5775 4.24996 9.47522 4.36652 8.60825C4.48754 7.70814 4.74643 6.95027 5.34835 6.34835C5.95027 5.74643 6.70814 5.48754 7.60825 5.36652C8.47522 5.24996 9.57754 5.24998 10.9451 5.25H11V4C11 3.44772 11.4477 3 12 3ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM10 16C9.44771 16 9 16.4477 9 17C9 17.5523 9.44771 18 10 18H14C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2 10C2.55228 10 3 10.4477 3 11V13C3 13.5523 2.55228 14 2 14C1.44772 14 1 13.5523 1 13V11C1 10.4477 1.44772 10 2 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22 10C22.5523 10 23 10.4477 23 11V13C23 13.5523 22.5523 14 22 14C21.4477 14 21 13.5523 21 13V11C21 10.4477 21.4477 10 22 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Robot-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","automation","assistant","support","service","ai","bot","help","machine","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["robot","automation","service","support","assistance","machine","helper","tech","chatbot","artificial-intelligence","ai"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18H13C15.8284 18 17.2426 18 18.1213 17.1213C19 16.2426 19 14.8284 19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 6V4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["robot","automation","assistance","bot","ai","service","machine","virtual-assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["robot","automation","assistant","chat","bot","support","help","service","virtual-assistant","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 7V5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 14V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","customer service","support","chatbot","automation","help","agent"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12V14C2 14.5523 2.44772 15 3 15C3.55228 15 4 14.5523 4 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22 12C22 11.4477 21.5523 11 21 11C20.4477 11 20 11.4477 20 12V14C20 14.5523 20.4477 15 21 15C21.5523 15 22 14.5523 22 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V6.25163C13.9413 6.25678 14.7342 6.27812 15.3918 6.36652C16.2919 6.48754 17.0497 6.74643 17.6517 7.34835C18.2536 7.95027 18.5125 8.70814 18.6335 9.60825C18.75 10.4752 18.75 11.5775 18.75 12.9451V13.0549C18.75 14.4225 18.75 15.5248 18.6335 16.3918C18.5125 17.2919 18.2536 18.0497 17.6517 18.6517C17.0497 19.2536 16.2919 19.5125 15.3918 19.6335C14.5248 19.75 13.4225 19.75 12.0549 19.75H11.9451C10.5775 19.75 9.47522 19.75 8.60825 19.6335C7.70814 19.5125 6.95027 19.2536 6.34835 18.6517C5.74643 18.0497 5.48754 17.2919 5.36652 16.3918C5.24996 15.5248 5.24998 14.4225 5.25 13.0549V12.9451C5.24998 11.5775 5.24996 10.4752 5.36652 9.60825C5.48754 8.70814 5.74643 7.95027 6.34835 7.34835C6.95027 6.74643 7.70814 6.48754 8.60825 6.36652C9.26577 6.27812 10.0587 6.25678 11 6.25163V5C11 4.44772 11.4477 4 12 4ZM12 9.75C10.2051 9.75 8.75 11.2051 8.75 13C8.75 14.7949 10.2051 16.25 12 16.25C13.7949 16.25 15.25 14.7949 15.25 13C15.25 11.2051 13.7949 9.75 12 9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Robot-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","ai","automation","customer-service","help","digital-assistant","virtual-agent","chatbot"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 7.87868C18 8.75736 18 10.1716 18 13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13C6 10.1716 6 8.75736 6.87868 7.87868C7.75736 7 9.17157 7 12 7C14.8284 7 16.2426 7 17.1213 7.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 7V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","automation","service","assistance","chatbot","tech-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V6.25H13.0549C14.4225 6.24998 15.5248 6.24996 16.3918 6.36652C17.2919 6.48754 18.0497 6.74643 18.6516 7.34835C19.2536 7.95027 19.5125 8.70814 19.6335 9.60825C19.75 10.4752 19.75 11.5775 19.75 12.9451V13.0549C19.75 14.4225 19.75 15.5248 19.6335 16.3918C19.5125 17.2919 19.2536 18.0497 18.6516 18.6517C18.0497 19.2536 17.2919 19.5125 16.3918 19.6335C15.5248 19.75 14.4225 19.75 13.0549 19.75L10.9451 19.75C9.57755 19.75 8.47521 19.75 7.60825 19.6335C6.70814 19.5125 5.95027 19.2536 5.34835 18.6517C4.74643 18.0497 4.48754 17.2919 4.36652 16.3918C4.24996 15.5248 4.24998 14.4225 4.25 13.0549V12.9451C4.24998 11.5775 4.24996 10.4752 4.36652 9.60825C4.48754 8.70814 4.74643 7.95027 5.34835 7.34835C5.95027 6.74643 6.70814 6.48754 7.60825 6.36652C8.47521 6.24996 9.57753 6.24998 10.9451 6.25H11V5C11 4.44772 11.4477 4 12 4ZM12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2 11C2.55228 11 3 11.4477 3 12V14C3 14.5523 2.55228 15 2 15C1.44772 15 1 14.5523 1 14V12C1 11.4477 1.44772 11 2 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22 11C22.5523 11 23 11.4477 23 12V14C23 14.5523 22.5523 15 22 15C21.4477 15 21 14.5523 21 14V12C21 11.4477 21.4477 11 22 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Robot-4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["robot","automation","AI","customer-service","chatbot","machine","assistant","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="9" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="15" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["robot","automation","chatbot","assistant","support","ai","machine-learning","digital-assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="9"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="15"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 6V4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Robot-4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","automation","ai","support","chatbot","assistant","help","bot","machine","service","digital assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V5.25H13.0549C14.4225 5.24998 15.5248 5.24996 16.3918 5.36652C17.2919 5.48754 18.0497 5.74643 18.6517 6.34835C19.2536 6.95027 19.5125 7.70814 19.6335 8.60825C19.75 9.47522 19.75 10.5775 19.75 11.9451V14.0549C19.75 15.4225 19.75 16.5248 19.6335 17.3918C19.5125 18.2919 19.2536 19.0497 18.6517 19.6516C18.0497 20.2536 17.2919 20.5125 16.3918 20.6335C15.5248 20.75 14.4224 20.75 13.0548 20.75H10.9451C9.57754 20.75 8.47522 20.75 7.60825 20.6335C6.70814 20.5125 5.95027 20.2536 5.34835 19.6517C4.74643 19.0497 4.48754 18.2919 4.36652 17.3918C4.24996 16.5248 4.24998 15.4225 4.25 14.0549V11.9451C4.24998 10.5775 4.24996 9.47521 4.36652 8.60825C4.48754 7.70814 4.74643 6.95027 5.34835 6.34835C5.95027 5.74643 6.70814 5.48754 7.60825 5.36652C8.47521 5.24996 9.57753 5.24998 10.9451 5.25H11V4C11 3.44772 11.4477 3 12 3ZM9 9.75C7.75736 9.75 6.75 10.7574 6.75 12C6.75 13.2426 7.75736 14.25 9 14.25C10.2426 14.25 11.25 13.2426 11.25 12C11.25 10.7574 10.2426 9.75 9 9.75ZM15 9.75C13.7574 9.75 12.75 10.7574 12.75 12C12.75 13.2426 13.7574 14.25 15 14.25C16.2426 14.25 17.25 13.2426 17.25 12C17.25 10.7574 16.2426 9.75 15 9.75ZM10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.5 10C22.0523 10 22.5 10.4477 22.5 11V13C22.5 13.5523 22.0523 14 21.5 14C20.9477 14 20.5 13.5523 20.5 13V11C20.5 10.4477 20.9477 10 21.5 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.5 11C3.5 10.4477 3.05228 10 2.5 10C1.94772 10 1.5 10.4477 1.5 11V13C1.5 13.5523 1.94772 14 2.5 14C3.05228 14 3.5 13.5523 3.5 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Robot-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","customer-service","ai","automation","help","chatbot","support","assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V14C5 16.8284 5 18.2426 5.87868 19.1213C6.75736 20 8.17157 20 11 20H13C15.8284 20 17.2426 20 18.1213 19.1213C19 18.2426 19 16.8284 19 14V12C19 9.17157 19 7.75736 18.1213 6.87868C17.2426 6 15.8284 6 13 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="9" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="15" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 17H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Robot: {
        defaultColors: ["#3D4C66"],
        keywords: ["robot","customer-service","ai","automation","help","chatbot","support","assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 18L13 18C15.8284 18 17.2426 18 18.1213 17.1213C18.1213 17.1213 18.1213 17.1213 18.1213 17.1213C19 16.2426 19 14.8284 19 12V12C19 9.17157 19 7.75736 18.1213 6.87868C18.1213 6.87868 18.1213 6.87868 18.1213 6.87868C17.2426 6 15.8284 6 13 6H11C8.17157 6 6.75736 6 5.87868 6.87868C5 7.75736 5 9.17157 5 12V12C5 14.8284 5 16.2426 5.87868 17.1213C6.75736 18 8.17157 18 11 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 13V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M3 13L3 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Rocket-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rocket","launch","promotion","boost","speed","fast","express","delivery","start","go","sales","accelerate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.8593 17.1387C13.9356 16.6979 14.9078 16.3791 15.5775 15.9632L15.4381 19.5161C15.4253 19.8412 15.2376 20.1328 14.9474 20.2783L13.6974 20.9051C13.352 21.0783 12.9331 21.0098 12.6583 20.735L10.19 18.2666C10.6126 18.05 11.8224 17.5633 12.8593 17.1387Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.86125 11.1407C7.30202 10.0644 7.6208 9.09221 8.03674 8.42246C9.74504 5.65017 13.7225 1.98224 20.0761 3.26298C20.4086 3.33 20.67 3.59145 20.737 3.92392C22.0178 10.2775 18.3499 14.255 15.5776 15.9633C14.9078 16.3792 13.9357 16.698 12.8594 17.1388M6.86125 11.1407C6.43658 12.1776 5.94995 13.3874 5.73328 13.81L7.96519 16.0343L10.19 18.2667C10.6126 18.0501 11.8224 17.5634 12.8594 17.1388M6.86125 11.1407L12.8594 17.1388"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Rocket-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rocket","launch","promotion","boost","sales","growth","accelerate","fast","speed","increase","campaign","start","new","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.86123 11.1406C7.302 10.0643 7.62078 9.09211 8.03672 8.42236L4.48376 8.56182C4.1587 8.57458 3.86709 8.7623 3.72159 9.05245L3.09476 10.3025C2.92155 10.6479 2.99015 11.0668 3.2649 11.3416L5.73326 13.8099C5.94993 13.3873 6.43657 12.1775 6.86123 11.1406Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.8593 17.1389C13.9356 16.6981 14.9077 16.3793 15.5775 15.9634L15.438 19.5163C15.4253 19.8414 15.2376 20.133 14.9474 20.2785L13.6974 20.9053C13.352 21.0786 12.9331 21.01 12.6583 20.7352L10.1899 18.2668C10.6126 18.0502 11.8223 17.5635 12.8593 17.1389Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.96507 16.0343L5.73315 13.81C5.94983 13.3874 6.43646 12.1776 6.86112 11.1407C7.30189 10.0644 7.62068 9.09221 8.03662 8.42246C9.74492 5.65017 13.7224 1.98224 20.076 3.26298C20.4084 3.33 20.6699 3.59145 20.7369 3.92392C22.0177 10.2775 18.3497 14.255 15.5774 15.9633C14.9077 16.3792 13.9355 16.698 12.8592 17.1388C11.8223 17.5634 10.6125 18.0501 10.1899 18.2667L7.96507 16.0343Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.86121 11.1406L12.8593 17.1387"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Rocket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rocket","launch","speed","fast","promotion","sale","boost","expedited","delivery","express","growth","rapid","quick","accelerate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.41069 7.73578L4.4544 7.81257C3.85712 7.83601 3.31952 8.18139 3.05122 8.71643L2.42439 9.96645C2.10522 10.6029 2.23313 11.3706 2.73462 11.872L4.07367 13.2111L4.17589 13.0117C4.32364 12.7235 4.67089 11.8738 5.05305 10.9387L5.24166 10.4775C5.34541 10.2242 5.44305 9.97438 5.54124 9.72188L5.57097 9.64541C5.65796 9.42157 5.7472 9.19196 5.83612 8.97238C5.99763 8.57349 6.18414 8.14059 6.41069 7.73578Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.7889 19.9263L12.128 21.2654C12.6295 21.7669 13.3971 21.8948 14.0336 21.5757L15.2836 20.9489C15.8187 20.6806 16.1641 20.143 16.1875 19.5457L16.2643 17.5892C15.8595 17.8158 15.4265 18.0023 15.0276 18.1639C14.8081 18.2528 14.5785 18.342 14.3547 18.4289L14.2781 18.4587C14.0256 18.5569 13.7758 18.6546 13.5224 18.7583L13.0612 18.9469C12.1261 19.3291 11.2764 19.6763 10.9883 19.8241L10.7889 19.9263Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.91436 11.475C5.56105 12.3397 5.22538 13.1568 5.06586 13.4679L4.81616 13.955L7.43394 16.5639L7.43575 16.5657L10.0451 19.1839L10.5322 18.9342C10.8433 18.7747 11.6604 18.439 12.5251 18.0857L5.91436 11.475Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2243 2.52787C13.4592 1.16417 9.20841 5.09222 7.39892 8.02797C7.15563 8.41995 6.95259 8.87978 6.76312 9.34771C6.68304 9.54546 6.60254 9.752 6.52135 9.96084L6.53033 9.96967L14.0303 17.4697L14.0393 17.4787C14.2481 17.3976 14.4546 17.3171 14.6524 17.237C15.1203 17.0475 15.5801 16.8445 15.9721 16.6012C18.9079 14.7917 22.8359 10.5409 21.4722 3.77582C21.3455 3.14736 20.8527 2.65455 20.2243 2.52787ZM17.4186 9.41858C16.6399 10.1972 15.3736 10.1933 14.5902 9.40984C13.8067 8.62639 13.8028 7.36007 14.5814 6.58144C15.3601 5.80281 16.6264 5.80669 17.4099 6.59014C18.1933 7.3736 18.1972 8.63995 17.4186 9.41858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Rocket-fly-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rocket","launch","speed","delivery","fast","express","shipping","promotion","boost","quick"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.03672 8.42246C7.62078 9.09221 7.302 10.0644 6.86123 11.1407M8.03672 8.42246L4.48376 8.56192C4.1587 8.57468 3.86709 8.7624 3.72159 9.05255L3.09476 10.3026C2.92155 10.648 2.99015 11.0669 3.2649 11.3417L5.73326 13.81M8.03672 8.42246C9.74502 5.65017 13.7225 1.98224 20.0761 3.26298C20.4085 3.33 20.67 3.59145 20.737 3.92392C22.0178 10.2775 18.3498 14.255 15.5775 15.9633M5.73326 13.81L7.96517 16.0343L10.19 18.2667M5.73326 13.81C5.94993 13.3874 6.43657 12.1776 6.86123 11.1407M6.86123 11.1407L12.8593 17.1388M10.19 18.2667C10.6126 18.0501 11.8224 17.5634 12.8593 17.1388M10.19 18.2667L12.6583 20.7351C12.9331 21.0099 13.352 21.0784 13.6974 20.9052L14.9474 20.2784C15.2376 20.1329 15.4253 19.8413 15.4381 19.5162L15.5775 15.9633M15.5775 15.9633C14.9078 16.3792 13.9356 16.698 12.8593 17.1388"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 16L2 18M6 18L5.00212 18.9979M8 20L6 22"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Rocket-fly-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rocket","launch","success","growth","performance","boost","fast","speed","promotion","special-offer","fast-checkout","quick-sale","accelerate","velocity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8593 17.1389C13.9356 16.6981 14.9077 16.3793 15.5775 15.9634L15.438 19.5163C15.4253 19.8414 15.2376 20.133 14.9474 20.2785L13.6974 20.9053C13.352 21.0786 12.9331 21.01 12.6583 20.7352L10.1899 18.2668C10.6126 18.0502 11.8223 17.5635 12.8593 17.1389Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.86123 11.1406C7.302 10.0643 7.62078 9.09211 8.03672 8.42236L4.48376 8.56182C4.1587 8.57458 3.86709 8.7623 3.72159 9.05245L3.09476 10.3025C2.92155 10.6479 2.99015 11.0668 3.2649 11.3416L5.73326 13.8099C5.94993 13.3873 6.43657 12.1775 6.86123 11.1406Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.96507 16.0343L5.73315 13.81C5.94983 13.3874 6.43646 12.1776 6.86112 11.1407C7.30189 10.0644 7.62068 9.09221 8.03662 8.42246C9.74492 5.65017 13.7224 1.98224 20.076 3.26298C20.4084 3.33 20.6699 3.59145 20.7369 3.92392C22.0177 10.2775 18.3497 14.255 15.5774 15.9633C14.9077 16.3792 13.9355 16.698 12.8592 17.1388C11.8223 17.5634 10.6125 18.0501 10.1899 18.2667L7.96507 16.0343Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M6.86112 11.1407C7.30189 10.0644 7.62068 9.09221 8.03662 8.42246C9.74492 5.65017 13.7224 1.98224 20.076 3.26298C20.4084 3.33 20.6699 3.59145 20.7369 3.92392C22.0177 10.2775 18.3497 14.255 15.5774 15.9633C14.9077 16.3792 13.9355 16.698 12.8592 17.1388M6.86112 11.1407C6.43646 12.1776 5.94983 13.3874 5.73315 13.81L7.96507 16.0343L10.1899 18.2667C10.6125 18.0501 11.8223 17.5634 12.8592 17.1388M6.86112 11.1407L12.8592 17.1388"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.86121 11.1406L12.8593 17.1387"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 16L2 18M6 18L5.00212 18.9979M8 20L6 22"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Rocket-fly-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rocket","launch","speed","fast","promotion","sale","new","start","delivery","express","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.41069 7.73578L4.4544 7.81257C3.85712 7.83601 3.31952 8.18139 3.05122 8.71643L2.42439 9.96645C2.10522 10.6029 2.23313 11.3706 2.73462 11.872L4.07367 13.2111L4.17589 13.0117C4.32364 12.7235 4.67089 11.8738 5.05305 10.9387L5.24166 10.4775C5.34541 10.2242 5.44305 9.97438 5.54124 9.72188L5.57097 9.64541C5.65796 9.42157 5.7472 9.19196 5.83612 8.97238C5.99763 8.57349 6.18414 8.14059 6.41069 7.73578Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.7889 19.9263L12.128 21.2654C12.6295 21.7669 13.3971 21.8948 14.0336 21.5757L15.2836 20.9489C15.8187 20.6806 16.1641 20.143 16.1875 19.5457L16.2643 17.5892C15.8595 17.8158 15.4265 18.0023 15.0276 18.1639C14.8081 18.2528 14.5785 18.342 14.3547 18.4289L14.2781 18.4587C14.0256 18.5569 13.7758 18.6546 13.5224 18.7583L13.0612 18.9469C12.1261 19.3291 11.2764 19.6763 10.9883 19.8241L10.7889 19.9263Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.91436 11.475C5.56105 12.3397 5.22538 13.1568 5.06586 13.4679L4.81616 13.955L7.43394 16.5639L7.43575 16.5657L10.0451 19.1839L10.5322 18.9342C10.8433 18.7747 11.6604 18.439 12.5251 18.0857L5.91436 11.475Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2243 2.52787C13.4592 1.16417 9.20841 5.09222 7.39892 8.02797C7.15563 8.41995 6.95259 8.87978 6.76312 9.34771C6.68304 9.54546 6.60254 9.752 6.52135 9.96084L6.53033 9.96967L14.0303 17.4697L14.0393 17.4787C14.2481 17.3976 14.4546 17.3171 14.6524 17.237C15.1203 17.0475 15.5801 16.8445 15.9721 16.6012C18.9079 14.7917 22.8359 10.5409 21.4722 3.77582C21.3455 3.14736 20.8527 2.65455 20.2243 2.52787ZM17.4186 9.41858C16.6399 10.1972 15.3736 10.1933 14.5902 9.40984C13.8067 8.62639 13.8028 7.36007 14.5814 6.58144C15.3601 5.80281 16.6264 5.80669 17.4099 6.59014C18.1933 7.3736 18.1972 8.63995 17.4186 9.41858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.70711 15.2929C5.09763 15.6834 5.09763 16.3166 4.70711 16.7071L2.70711 18.7071C2.31658 19.0976 1.68342 19.0976 1.29289 18.7071C0.902369 18.3166 0.902369 17.6834 1.29289 17.2929L3.29289 15.2929C3.68342 14.9024 4.31658 14.9024 4.70711 15.2929ZM6.70711 17.2929C7.09763 17.6834 7.09763 18.3166 6.70711 18.7071L5.70922 19.705C5.3187 20.0955 4.68553 20.0955 4.29501 19.705C3.90448 19.3145 3.90448 18.6813 4.29501 18.2908L5.29289 17.2929C5.68342 16.9024 6.31658 16.9024 6.70711 17.2929ZM8.70711 19.2929C9.09763 19.6834 9.09763 20.3166 8.70711 20.7071L6.70711 22.7071C6.31658 23.0976 5.68342 23.0976 5.29289 22.7071C4.90237 22.3166 4.90237 21.6834 5.29289 21.2929L7.29289 19.2929C7.68342 18.9024 8.31658 18.9024 8.70711 19.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Rocket-fly": {
        defaultColors: ["#3D4C66"],
        keywords: ["rocket","launch","promotion","fast","speed","accelerate","boost","go","sales","campaign","growth","shipping","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.03672 8.42246C7.62078 9.09221 7.302 10.0644 6.86123 11.1407M8.03672 8.42246L4.48376 8.56192C4.1587 8.57468 3.86709 8.7624 3.72159 9.05255L3.09476 10.3026C2.92155 10.648 2.99015 11.0669 3.2649 11.3417L5.73326 13.81M8.03672 8.42246C9.74502 5.65017 13.7225 1.98224 20.0761 3.26298C20.4085 3.33 20.67 3.59145 20.737 3.92392C22.0178 10.2775 18.3498 14.255 15.5775 15.9633M5.73326 13.81L7.96517 16.0343L10.19 18.2667M5.73326 13.81C5.94993 13.3874 6.43657 12.1776 6.86123 11.1407M6.86123 11.1407L12.8593 17.1388M10.19 18.2667C10.6126 18.0501 11.8224 17.5634 12.8593 17.1388M10.19 18.2667L12.6583 20.7351C12.9331 21.0099 13.352 21.0784 13.6974 20.9052L14.9474 20.2784C15.2376 20.1329 15.4253 19.8413 15.4381 19.5162L15.5775 15.9633M15.5775 15.9633C14.9078 16.3792 13.9356 16.698 12.8593 17.1388"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 16L2 18M6 18L5.00212 18.9979M8 20L6 22"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Rocket: {
        defaultColors: ["#3D4C66"],
        keywords: ["rocket","launch","promotion","fast","speed","accelerate","boost","go","sales","campaign","growth","shipping","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5902 9.40984C15.3736 10.1933 16.6399 10.1972 17.4186 9.41858C18.1972 8.63995 18.1933 7.3736 17.4099 6.59014C16.6264 5.80669 15.3601 5.80281 14.5814 6.58144C13.8028 7.36007 13.8067 8.62639 14.5902 9.40984Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8.03672 8.42246C7.62078 9.09221 7.302 10.0644 6.86123 11.1407M8.03672 8.42246L4.48376 8.56192C4.1587 8.57468 3.86709 8.7624 3.72159 9.05255L3.09476 10.3026C2.92155 10.648 2.99015 11.0669 3.2649 11.3417L5.73326 13.81M8.03672 8.42246C9.74502 5.65017 13.7225 1.98224 20.0761 3.26298C20.4085 3.33 20.67 3.59145 20.737 3.92392C22.0178 10.2775 18.3498 14.255 15.5775 15.9633M5.73326 13.81L7.96517 16.0343L10.19 18.2667M5.73326 13.81C5.94993 13.3874 6.43657 12.1776 6.86123 11.1407M6.86123 11.1407L12.8593 17.1388M10.19 18.2667C10.6126 18.0501 11.8224 17.5634 12.8593 17.1388M10.19 18.2667L12.6583 20.7351C12.9331 21.0099 13.352 21.0784 13.6974 20.9052L14.9474 20.2784C15.2376 20.1329 15.4253 19.8413 15.4381 19.5162L15.5775 15.9633M15.5775 15.9633C14.9078 16.3792 13.9356 16.698 12.8593 17.1388"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rotate-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rotate","reload","sync","update","refresh","repeat","cycle","revert","reverse","exchange","transfer","reorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rotate-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["rotate","sync","refresh","reload","exchange","cycle","repeat","update","flip","transaction","circular","arrow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rotate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","refresh","reload","cycle","sync","arrows","update","repeat","reset","exchange","reorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.03379 9.74316C4.06936 5.84645 7.70637 3 12.0002 3C14.9129 3 17.5233 4.30974 19.2246 6.3686C19.4079 6.1437 19.6872 6.00007 20 6.00005C20.5522 6.00001 21 6.44769 21 6.99998L21.0002 9.99993C21.0003 10.5022 20.6278 10.9265 20.1298 10.9916C19.6318 11.0566 19.1628 10.7422 19.0338 10.2568C18.2354 7.25264 15.4042 5 12.0002 5C8.59625 5 5.76508 7.25264 4.9667 10.2568C4.82485 10.7906 4.27717 11.1083 3.74341 10.9665C3.20965 10.8246 2.89194 10.2769 3.03379 9.74316ZM20.2571 13.0335C20.7908 13.1754 21.1086 13.7231 20.9667 14.2568C19.9311 18.1535 16.2941 21 12.0002 21C9.08753 21 6.47707 19.6902 4.77584 17.6313C4.59247 17.8563 4.31314 18 4.00025 18C3.44796 18 3.00025 17.5523 3.00025 17L3.00025 14C3.00025 13.4978 3.37274 13.0735 3.87074 13.0084C4.36873 12.9434 4.83771 13.2578 4.9667 13.7432C5.76508 16.7474 8.59625 19 12.0002 19C15.4042 19 18.2354 16.7474 19.0338 13.7432C19.1756 13.2094 19.7233 12.8917 20.2571 13.0335Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rotate-arrow-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rotate","arrow","refresh","reload","redo","repeat","sync","update","reapply","retry","restart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17H17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 15L11 17L9 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rotate-arrow-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rotate","arrow","refresh","reload","repeat","cycle","update","resync","retry","restart","loop","reorder","circular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 17H17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 15L11 17L9 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "rotate-arrow": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","arrow","refresh","reload","repeat","redo","sync","loop","reapply","circular","reset","rollback","retry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 15L11 17L9 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17H17V17C18.6569 17 20 15.6569 20 14V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V11C4 13.8284 4 15.2426 4.87868 16.1213C5.75736 17 7.17157 17 10 17H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "rotate-arrow-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rotate","arrow","reload","refresh","repeat","loop","sync","synchronize","update","redo","reapply","reprocess","retry"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11875C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82768 20.7565 6.64711 20.8813 7.57494C21.0001 8.4587 21 9.57533 21 10.9295V14C21 16.2091 19.2091 18 17 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H17C18.1046 16 19 15.1046 19 14V11C19 9.55752 18.9979 8.57625 18.8991 7.84143C18.8042 7.13538 18.6368 6.80836 18.4142 6.58579C18.1916 6.36322 17.8646 6.19585 17.1586 6.10092C16.4238 6.00213 15.4425 6 14 6H10C8.55752 6 7.57625 6.00213 6.84143 6.10092C6.13538 6.19585 5.80836 6.36322 5.58579 6.58579C5.36322 6.80836 5.19585 7.13538 5.10092 7.84143C5.00213 8.57625 5 9.55752 5 11C5 12.4425 5.00213 13.4238 5.10092 14.1586C5.19585 14.8646 5.36322 15.1916 5.58579 15.4142C5.80836 15.6368 6.13538 15.8042 6.84143 15.8991C7.30497 15.9614 7.86658 15.9853 8.58016 15.9944L8.2929 15.7071C7.90237 15.3166 7.90237 14.6834 8.2929 14.2929C8.68342 13.9024 9.31659 13.9024 9.70711 14.2929L11.7071 16.2929C12.0976 16.6834 12.0976 17.3166 11.7071 17.7071L9.70711 19.7071C9.31659 20.0976 8.68342 20.0976 8.2929 19.7071C7.90237 19.3166 7.90237 18.6834 8.2929 18.2929L8.59089 17.9949C7.82 17.9854 7.14844 17.9584 6.57494 17.8813C5.64711 17.7565 4.82768 17.4845 4.17158 16.8284C3.51547 16.1723 3.2435 15.3529 3.11875 14.4251C2.99994 13.5413 2.99997 12.4247 3 11.0706V10.9294C2.99997 9.57531 2.99994 8.4587 3.11875 7.57494C3.2435 6.64711 3.51547 5.82768 4.17158 5.17158C4.82768 4.51547 5.64711 4.2435 6.57494 4.11875C7.4587 3.99994 8.57531 3.99997 9.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rotate-exclamation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alert","warning","attention","error","update","refresh","retry","resync","exclamation","issue","problem","reloading","loop","sync-error","transaction-failed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rotate-exclamation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rotate","exclamation","alert","warning","update","refresh","sync","error","problem","issue","pending","retrying","reloading"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rotate-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","error","refresh","retry","sync","update","issue","problem","reload","repeat","loop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.03379 9.74316C4.06936 5.84645 7.70637 3 12.0002 3C14.9129 3 17.5234 4.30977 19.2246 6.36866C19.408 6.14377 19.6872 6.00014 20 6.00012C20.5523 6.00008 21 6.44776 21.0001 7.00004L21.0003 9.97995C21.0054 10.2275 20.9177 10.4645 20.7622 10.6478C20.6882 10.7349 20.5989 10.8099 20.497 10.8682C20.3782 10.9363 20.244 10.9808 20.101 10.9951C20.006 11.0048 19.9119 11.0007 19.821 10.984C19.6531 10.9537 19.4998 10.8813 19.3722 10.7783C19.2659 10.6926 19.1764 10.5847 19.1116 10.4591C19.0757 10.3898 19.0477 10.3157 19.0288 10.238C18.2236 7.24323 15.3971 5 12.0002 5C8.59625 5 5.76508 7.25264 4.9667 10.2568C4.82485 10.7906 4.27717 11.1083 3.74341 10.9665C3.20965 10.8246 2.89194 10.2769 3.03379 9.74316Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.8209 13.0162C3.7468 13.0296 3.67554 13.0512 3.6081 13.08C3.42011 13.1598 3.26651 13.2931 3.16071 13.4567C3.10523 13.5422 3.06247 13.6368 3.0351 13.7377C3.01 13.8297 2.99788 13.926 3.0003 14.0239L3.0003 17.0001C3.0003 17.5524 3.44802 18.0001 4.0003 18.0001C4.31321 18.0001 4.59255 17.8564 4.77591 17.6314C6.47714 19.6902 9.08757 21 12.0002 21C16.2941 21 19.9311 18.1535 20.9667 14.2568C21.1085 13.7231 20.7908 13.1754 20.2571 13.0335C19.7233 12.8917 19.1756 13.2094 19.0338 13.7432C18.2354 16.7474 15.4042 19 12.0002 19C8.60398 19 5.77795 16.7576 4.97217 13.7636C4.9537 13.6874 4.92651 13.6147 4.89171 13.5465C4.81609 13.3974 4.70567 13.273 4.57356 13.1806C4.36076 13.0319 4.09165 12.9665 3.8209 13.0162Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.0002 17C11.448 17 11.0002 16.5523 11.0002 16C11.0002 15.4477 11.448 15 12.0002 15C12.5525 15 13.0002 15.4477 13.0002 16C13.0002 16.5523 12.5525 17 12.0002 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0002 13C11.0002 13.5523 11.448 14 12.0002 14C12.5525 14 13.0002 13.5523 13.0002 13L13.0002 8C13.0002 7.44772 12.5525 7 12.0002 7C11.448 7 11.0002 7.44772 11.0002 8L11.0002 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rotate-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","attention","error","refresh","reload","update","retry","repeat","cycle","issue","problem","transaction-error","reprocess","circular","sync-error","data-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 16L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 13L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    rotate: {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","attention","error","refresh","reload","update","retry","repeat","cycle","issue","problem","transaction-error","reprocess","circular","sync-error","data-sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14L4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 7L20.0002 9.99995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "roundabout-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["undo","back","return","reverse","rollback","go-back","previous","rewind"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9H5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L5 9L7 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5C12.7909 5 11 6.79086 11 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 13V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "roundabout-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["undo","back","return","reverse","previous","cancel","go-back","step-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5C12.7909 5 11 6.79086 11 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 9H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L5 9L7 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13V19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "roundabout-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["undo","back","return","revert","previous","recall","go-back","turn-back","roundabout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 6C13.3431 6 12 7.34315 12 9C12 9.55228 11.5523 10 11 10H7.41421L7.70711 10.2929C8.09763 10.6834 8.09763 11.3166 7.70711 11.7071C7.31658 12.0976 6.68342 12.0976 6.29289 11.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289L6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711L7.41421 8H10.1C10.5633 5.71776 12.581 4 15 4C17.7614 4 20 6.23858 20 9C20 11.419 18.2822 13.4367 16 13.9V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19V13C14 12.4477 14.4477 12 15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "route-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["route","path","delivery","shipping","navigation","location","map","order-tracking","tracking","direction","waypoint"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18C12 19.1046 12.8954 20 14 20C14.5523 20 15.0523 19.7761 15.4142 19.4142C15.7761 19.0523 16 18.5523 16 18C16 16.8954 15.1046 16 14 16C12.8954 16 12 16.8954 12 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 6C8 7.10457 8.89543 8 10 8C10.5523 8 11.0523 7.77614 11.4142 7.41421C11.7761 7.05228 12 6.55228 12 6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6L15 6C16.6569 6 18 7.34315 18 9V9C18 10.6569 16.6569 12 15 12H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L9 18C7.34315 18 6 16.6569 6 15V15C6 13.3431 7.34315 12 9 12L12 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "route-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["route","delivery","path","destination","location","shipment","waypoints","tracking","steps"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6H10C8.34315 6 7 7.34315 7 9V9C7 10.6569 8.34315 12 10 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18L13 18C14.6569 18 16 16.6569 16 15V15C16 13.3431 14.6569 12 13 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect
                    x="13"
                    y="3"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="5"
                    y="15"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "roundabout-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","go-back","undo","back","transaction-reversal","reverse-order","previous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 9H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5C12.7909 5 11 6.79086 11 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 7L5 9L7 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "route-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["route","path","connection","workflow","flow","sequence","process","delivery-route","shipping-route","mapping","navigation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7H12.4C12.84 8.58 14.28 9.75 16 9.75C18.07 9.75 19.75 8.07 19.75 6C19.75 3.93 18.07 2.25 16 2.25C14.28 2.25 12.84 3.42 12.4 5H10C7.79 5 6 6.79 6 9C6 11.21 7.79 13 10 13H13C14.1 13 15 13.9 15 15C15 16.1 14.1 17 13 17H11.6C11.16 15.42 9.72 14.25 8 14.25C5.93 14.25 4.25 15.93 4.25 18C4.25 20.07 5.93 21.75 8 21.75C9.72 21.75 11.16 20.58 11.6 19H13C15.21 19 17 17.21 17 15C17 12.79 15.21 11 13 11H10C8.9 11 8 10.1 8 9C8 7.9 8.9 7 10 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "route-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["route","path","delivery","navigation","history","order-tracking","track","waypoints","itinerary","directions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.01 13H15.01C17.22 13 19 11.21 19 9C19 6.79 17.22 5 15.01 5H12.57C12.17 3.98 11.18 3.25 10.01 3.25C8.49 3.25 7.26 4.48 7.26 6C7.26 7.52 8.49 8.75 10.01 8.75C10.77 8.75 11.46 8.44 11.95 7.94C12.22 7.67 12.42 7.35 12.56 7H15C16.1 7 17 7.9 17 9C17 10.1 16.1 11 15 11H9C6.79 11 5 12.79 5 15C5 17.21 6.79 19 9 19H11.44C11.84 20.02 12.83 20.75 14 20.75C14.76 20.75 15.45 20.44 15.94 19.94C16.44 19.44 16.75 18.75 16.75 18C16.75 16.48 15.52 15.25 14 15.25C12.83 15.25 11.84 15.98 11.44 17H9C7.9 17 7 16.1 7 15C7 13.9 7.9 13 9 13H9.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "route-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["route","path","connection","steps","process","workflow","delivery","shipping","order-tracking","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6L15 6C16.6569 6 18 7.34315 18 9V9C18 10.6569 16.6569 12 15 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L9 18C7.34315 18 6 16.6569 6 15V15C6 13.3431 7.34315 12 9 12L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18C12 19.1046 12.8954 20 14 20C14.5523 20 15.0523 19.7761 15.4142 19.4142C15.7761 19.0523 16 18.5523 16 18C16 16.8954 15.1046 16 14 16C12.8954 16 12 16.8954 12 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 6C8 7.10457 8.89543 8 10 8C10.5523 8 11.0523 7.77614 11.4142 7.41421C11.7761 7.05228 12 6.55228 12 6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "route-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["route","path","connection","delivery","tracking","locations","map","destination","waypoint","multi-location","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7C16 8.10457 16.8954 9 18 9C18.5523 9 19.0523 8.77614 19.4142 8.41421C19.7761 8.05228 20 7.55228 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17C4 18.1046 4.89543 19 6 19C6.55228 19 7.05228 18.7761 7.41421 18.4142C7.77614 18.0523 8 17.5523 8 17C8 15.8954 7.10457 15 6 15C4.89543 15 4 15.8954 4 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7V7C15.07 7 14.605 7 14.2235 7.10222C13.1883 7.37962 12.3796 8.18827 12.1022 9.22354C12 9.60504 12 10.07 12 11V13C12 13.93 12 14.395 11.8978 14.7765C11.6204 15.8117 10.8117 16.6204 9.77646 16.8978C9.39496 17 8.92997 17 8 17V17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "route-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["route","path","connection","workflow","flow","steps","process","journey","navigation","order-processing","delivery-route","sales-process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7V7C15.07 7 14.605 7 14.2235 7.10222C13.1883 7.37962 12.3796 8.18827 12.1022 9.22354C12 9.60504 12 10.07 12 11V13C12 13.93 12 14.395 11.8978 14.7765C11.6204 15.8117 10.8117 16.6204 9.77646 16.8978C9.39496 17 8.92997 17 8 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7C16 8.10457 16.8954 9 18 9C18.5523 9 19.0523 8.77614 19.4142 8.41421C19.7761 8.05228 20 7.55228 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17C4 18.1046 4.89543 19 6 19C6.55228 19 7.05228 18.7761 7.41421 18.4142C7.77614 18.0523 8 17.5523 8 17C8 15.8954 7.10457 15 6 15C4.89543 15 4 15.8954 4 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "route-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["route","path","direction","delivery","shipping","navigation","map","waypoint","location","travel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7C16 8.10457 16.8954 9 18 9C18.5523 9 19.0523 8.77614 19.4142 8.41421C19.7761 8.05228 20 7.55228 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 17C4 18.1046 4.89543 19 6 19C6.55228 19 7.05228 18.7761 7.41421 18.4142C7.77614 18.0523 8 17.5523 8 17C8 15.8954 7.10457 15 6 15C4.89543 15 4 15.8954 4 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7V7C15.07 7 14.605 7 14.2235 7.10222C13.1883 7.37962 12.3796 8.18827 12.1022 9.22354C12 9.60504 12 10.07 12 11V13C12 13.93 12 14.395 11.8978 14.7765C11.6204 15.8117 10.8117 16.6204 9.77646 16.8978C9.39496 17 8.92997 17 8 17V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "route-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["route","path","connection","workflow","process","navigation","directions","delivery route","order route","table route","customer route","sales route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.01 4.25C16.84 4.25 15.85 4.98 15.45 6C14.86 6 14.39 6.02 13.97 6.14C12.59 6.51 11.51 7.59 11.14 8.97C11 9.48 11 10.07 11 10.87V13.01C11 14 11 14.31 10.93 14.53C10.74 15.22 10.21 15.76 9.52 15.94C9.35 15.99 9.12 16 8.56 16.01C8.16 14.99 7.17 14.26 6 14.26C4.48 14.26 3.25 15.49 3.25 17.01C3.25 18.53 4.48 19.75 6 19.75C6.76 19.75 7.45 19.45 7.94 18.95C8.21 18.68 8.41 18.36 8.55 18C9.14 18 9.61 17.98 10.03 17.87C11.41 17.5 12.49 16.42 12.86 15.04C13 14.53 13 13.94 13 13.14V11C13 10.01 13 9.7 13.07 9.48C13.25 8.79 13.79 8.25 14.48 8.07C14.65 8.02 14.88 8.01 15.44 8C15.84 9.02 16.83 9.75 18 9.75C18.76 9.75 19.45 9.44 19.94 8.94C20.44 8.44 20.75 7.75 20.75 7C20.75 5.48 19.52 4.25 18 4.25H18.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "route-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["route","path","connection","flow","process","workflow","delivery","shipping","logistics","order-tracking","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6H10C8.34315 6 7 7.34315 7 9V9C7 10.6569 8.34315 12 10 12H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18L13 18C14.6569 18 16 16.6569 16 15V15C16 13.3431 14.6569 12 13 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <rect x="13" y="3" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="5" y="15" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "route-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["route","delivery","path","order-route","shipping","workflow","process","destination","direction","itinerary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 6H10C8.34315 6 7 7.34315 7 9V9C7 10.6569 8.34315 12 10 12H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 18L13 18C14.6569 18 16 16.6569 16 15V15C16 13.3431 14.6569 12 13 12L11 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <rect x="13" y="3" width="6" height="6" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="5" y="15" width="6" height="6" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    route: {
        defaultColors: ["#3D4C66"],
        keywords: ["route","delivery","path","order-route","shipping","workflow","process","destination","direction","itinerary"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18C12 19.1046 12.8954 20 14 20C14.5523 20 15.0523 19.7761 15.4142 19.4142C15.7761 19.0523 16 18.5523 16 18C16 16.8954 15.1046 16 14 16C12.8954 16 12 16.8954 12 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 6C8 7.10457 8.89543 8 10 8C10.5523 8 11.0523 7.77614 11.4142 7.41421C11.7761 7.05228 12 6.55228 12 6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 6L15 6C16.6569 6 18 7.34315 18 9V9C18 10.6569 16.6569 12 15 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L9 18C7.34315 18 6 16.6569 6 15V15C6 13.3431 7.34315 12 9 12L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "router-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tv","television","antenna","offline","disconnected","settings","configuration","device","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6L10.4 10H13.6L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 14H7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L15 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L6 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L18 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "router-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["router","network","connection","internet","wifi","connectivity","device","access","point-of-sale","pos-system","network-connection","local-network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.48541 5.14266C7.95899 4.85851 8.57325 5.01208 8.8574 5.48566L10.9661 9.00012H13.0337L15.1424 5.48566C15.4266 5.01208 16.0408 4.85851 16.5144 5.14266C16.988 5.42681 17.1415 6.04107 16.8574 6.51465L15.3661 9.00012H16.0658C16.9523 9.00007 17.7161 9.00003 18.3278 9.08227C18.9833 9.1704 19.6117 9.36914 20.1213 9.87881C20.631 10.3885 20.8297 11.0168 20.9179 11.6723C21.0001 12.284 21.0001 13.0478 21 13.9343V14.0659C21.0001 14.9524 21.0001 15.7163 20.9179 16.3279C20.8297 16.9834 20.631 17.6118 20.1213 18.1214C19.7895 18.4533 19.4073 18.6534 19 18.7769V19.0001C19 19.5524 18.5523 20.0001 18 20.0001C17.4477 20.0001 17 19.5524 17 19.0001V18.996C16.7065 19.0002 16.3946 19.0001 16.0658 19.0001H7.93417C7.60541 19.0001 7.29352 19.0002 7 18.996V19.0001C7 19.5524 6.55228 20.0001 6 20.0001C5.44772 20.0001 5 19.5524 5 19.0001V18.7769C4.59275 18.6534 4.21056 18.4533 3.87868 18.1214C3.36902 17.6118 3.17028 16.9834 3.08215 16.3279C2.99991 15.7163 2.99995 14.9524 3 14.066V13.9343C2.99995 13.0478 2.99991 12.284 3.08215 11.6723C3.17028 11.0168 3.36902 10.3885 3.87868 9.87881C4.38835 9.36914 5.0167 9.1704 5.67221 9.08227C6.28387 9.00003 7.04768 9.00007 7.93417 9.00012H8.6337L7.14241 6.51465C6.85827 6.04107 7.01183 5.42681 7.48541 5.14266ZM15 13.0001C15 12.4478 14.5523 12.0001 14 12.0001C13.4477 12.0001 13 12.4478 13 13.0001V15.0001C13 15.5524 13.4477 16.0001 14 16.0001C14.5523 16.0001 15 15.5524 15 15.0001V13.0001ZM9 15.0001C9.55228 15.0001 10 14.5524 10 14.0001C10 13.4478 9.55228 13.0001 9 13.0001H7C6.44772 13.0001 6 13.4478 6 14.0001C6 14.5524 6.44772 15.0001 7 15.0001H9ZM17 12.0001C17.5523 12.0001 18 12.4478 18 13.0001V15.0001C18 15.5524 17.5523 16.0001 17 16.0001C16.4477 16.0001 16 15.5524 16 15.0001V13.0001C16 12.4478 16.4477 12.0001 17 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "router-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["router","network","connection","internet","wifi","server","settings","connectivity","system","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15C4 13.1144 4 12.1716 4.58579 11.5858C5.17157 11 6.11438 11 8 11H16C17.8856 11 18.8284 11 19.4142 11.5858C20 12.1716 20 13.1144 20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15H7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14L15 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L17 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 19L6 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8ZM12 8V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 8C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "router-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["router","network","connection","wifi","internet","connectivity","device","settings","configuration","online","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15C4 13.1144 4 12.1716 4.58579 11.5858C5.17157 11 6.11438 11 8 11H16C17.8856 11 18.8284 11 19.4142 11.5858C20 12.1716 20 13.1144 20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14L15 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L17 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 19L6 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8ZM12 8V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 8C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "router-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["router","network","wifi","connection","internet","connectivity","device","offline","online","server","network-status","network-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8ZM12 8V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 19L6 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 19H8C6.11438 19 5.17157 19 4.58579 18.4142C4 17.8284 4 16.8856 4 15C4 13.1144 4 12.1716 4.58579 11.5858C5.17157 11 6.11438 11 8 11H16C17.8856 11 18.8284 11 19.4142 11.5858C20 12.1716 20 13.1144 20 15C20 16.8856 20 17.8284 19.4142 18.4142C18.8284 19 17.8856 19 16 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 15H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14L15 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 14L17 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 8C17.1046 8 18 7.10457 18 6C18 4.89543 17.1046 4 16 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "router-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["router","connection","network","internet","connectivity","wifi","access","server","data-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18L6 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L18 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 6L10.4 10H13.6L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 14H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "router-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["router","network","connection","internet","wifi","connectivity","signal","online","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.64108 6.80145C8.15652 6.99979 8.41359 7.57843 8.21525 8.09387C8.01691 8.60931 7.43827 8.86637 6.92283 8.66803C5.79973 8.23587 5 7.14632 5 5.86751C5 4.58869 5.79973 3.49914 6.92283 3.06698C7.43827 2.86864 8.01691 3.1257 8.21525 3.64114C8.41359 4.15659 8.15652 4.73522 7.64108 4.93356C7.2645 5.07847 7 5.44334 7 5.86751C7 6.29168 7.2645 6.65655 7.64108 6.80145Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6.00003C9 4.34317 10.3431 3.00003 12 3.00003C13.6569 3.00003 15 4.34317 15 6.00003C15 7.30625 14.1652 8.41749 13 8.82932V10H16.0658C16.9523 9.99998 17.7161 9.99994 18.3278 10.0822C18.9833 10.1703 19.6117 10.369 20.1213 10.8787C20.631 11.3884 20.8297 12.0167 20.9179 12.6722C21.0001 13.2839 21.0001 14.0477 21 14.9342V15.0658C21.0001 15.9523 21.0001 16.7162 20.9179 17.3278C20.8297 17.9833 20.631 18.6117 20.1213 19.1214C19.7895 19.4532 19.4073 19.6533 19 19.7768V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V19.9959C16.7065 20.0001 16.3946 20.0001 16.0658 20H7.93417C7.60541 20.0001 7.29352 20.0001 7 19.9959V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V19.7768C4.59275 19.6533 4.21056 19.4532 3.87868 19.1214C3.36902 18.6117 3.17028 17.9833 3.08215 17.3278C2.99991 16.7162 2.99995 15.9523 3 15.0659V14.9342C2.99995 14.0477 2.99991 13.2839 3.08215 12.6722C3.17028 12.0167 3.36902 11.3884 3.87868 10.8787C4.38835 10.369 5.0167 10.1703 5.67221 10.0822C6.28387 9.99994 7.04767 9.99998 7.93415 10H11V8.82932C9.83481 8.41749 9 7.30625 9 6.00003ZM15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V14ZM9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14H7C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16H9ZM17 13C17.5523 13 18 13.4477 18 14V16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V14C16 13.4477 16.4477 13 17 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.7848 3.64117C15.5864 4.15661 15.8435 4.73525 16.3589 4.93359C16.7355 5.07849 17 5.44336 17 5.86753C17 6.2917 16.7355 6.65657 16.3589 6.80148C15.8435 6.99982 15.5864 7.57845 15.7848 8.09389C15.9831 8.60934 16.5617 8.8664 17.0772 8.66806C18.2003 8.2359 19 7.14635 19 5.86753C19 4.58872 18.2003 3.49917 17.0772 3.06701C16.5617 2.86867 15.9831 3.12573 15.7848 3.64117Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    router: {
        defaultColors: ["#3D4C66"],
        keywords: ["router","network","connection","internet","wifi","connectivity","signal","online","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6L10.4 10H13.6L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18H8C6.11438 18 5.17157 18 4.58579 17.4142C4 16.8284 4 15.8856 4 14C4 12.1144 4 11.1716 4.58579 10.5858C5.17157 10 6.11438 10 8 10H16C17.8856 10 18.8284 10 19.4142 10.5858C20 11.1716 20 12.1144 20 14C20 15.8856 20 16.8284 19.4142 17.4142C18.8284 18 17.8856 18 16 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 14H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 13L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L6 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L18 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Rss-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rss","feed","wifi","connection","network","signal","update","updates","subscription","subscribe","news","data-feed","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="15" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Rss-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rss","feed","wifi","signal","broadcast","update","notifications","alerts","news","data-stream","internet","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="9"
                    cy="15"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Rss-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rss","feed","updates","news","notifications","social-media","integration","data-feed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57533 2.99997 7.45869 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45869 2.99997 8.57529 3 9.92939V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.4587 21.0001 8.57531 21 9.92944 21H14.0705C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92946C21 8.57534 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55229 8.44772 8 9 8C12.866 8 16 11.134 16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15C18 10.0294 13.9706 6 9 6ZM8 10C8 9.44772 8.44772 9 9 9C12.3137 9 15 11.6863 15 15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15C13 12.7909 11.2091 11 9 11C8.44772 11 8 10.5523 8 10ZM6.25 15C6.25 13.4812 7.48122 12.25 9 12.25C10.5188 12.25 11.75 13.4812 11.75 15C11.75 16.5188 10.5188 17.75 9 17.75C7.48122 17.75 6.25 16.5188 6.25 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "ruler-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ruler","measurement","dimensions","size","scale","distance","length","width","height","area","volume","quantity","product-size","item-size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 8L4 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16L4 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 18V6C4 5.05719 4 4.58579 4.29289 4.29289C4.58579 4 5.05719 4 6 4H8C8.94281 4 9.41421 4 9.70711 4.29289C10 4.58579 10 5.05719 10 6V12C10 12.9428 10 13.4142 10.2929 13.7071C10.5858 14 11.0572 14 12 14H18C18.9428 14 19.4142 14 19.7071 14.2929C20 14.5858 20 15.0572 20 16V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ruler-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ruler","measure","size","length","measurement","dimensions","increments","distance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8V12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 8V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="3" y="8" width="18" height="8" rx="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    Rss: {
        defaultColors: ["#3D4C66"],
        keywords: ["ruler","measure","size","length","measurement","dimensions","increments","distance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="15" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 15C14 12.2386 11.7614 10 9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 15C17 10.5817 13.4183 7 9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "ruler-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ruler","measurement","size","dimension","length","scale","metrics","unit","calibrate","proportion","gauge","adjust","precision"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 18V6C4 5.05719 4 4.58579 4.29289 4.29289C4.58579 4 5.05719 4 6 4H8C8.94281 4 9.41421 4 9.70711 4.29289C10 4.58579 10 5.05719 10 6V12C10 12.9428 10 13.4142 10.2929 13.7071C10.5858 14 11.0572 14 12 14H18C18.9428 14 19.4142 14 19.7071 14.2929C20 14.5858 20 15.0572 20 16V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8L4 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16L4 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ruler-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["ruler","measurement","dimensions","size","scale","adjust","length","area","volume","price-per-unit","unit-cost","scale-factor","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 18V6C4 5.05719 4 4.58579 4.29289 4.29289C4.58579 4 5.05719 4 6 4H8C8.94281 4 9.41421 4 9.70711 4.29289C10 4.58579 10 5.05719 10 6V12C10 12.9428 10 13.4142 10.2929 13.7071C10.5858 14 11.0572 14 12 14H18C18.9428 14 19.4142 14 19.7071 14.2929C20 14.5858 20 15.0572 20 16V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8L4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 12L4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 16L4 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19L8 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 18L12 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19L16 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ruler-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bread","loaf","bakery","food","item","menu-item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 12V7H16V11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11V7.00415C18.4979 7.01124 18.943 7.03041 19.3278 7.08215C19.9833 7.17028 20.6117 7.36902 21.1213 7.87868C21.631 8.38835 21.8297 9.0167 21.9179 9.67221C22.0001 10.2839 22.0001 11.0477 22 11.9342V12.0658C22.0001 12.9523 22.0001 13.7161 21.9179 14.3278C21.8297 14.9833 21.631 15.6117 21.1213 16.1213C20.6117 16.631 19.9833 16.8297 19.3278 16.9179C18.7161 17.0001 17.9523 17.0001 17.0658 17H6.93417C6.04769 17.0001 5.28387 17.0001 4.67221 16.9179C4.0167 16.8297 3.38835 16.631 2.87868 16.1213C2.36902 15.6117 2.17028 14.9833 2.08215 14.3278C1.99991 13.7161 1.99995 12.9523 2 12.0658V11.9342C1.99995 11.0477 1.99991 10.2839 2.08215 9.67221C2.17028 9.0167 2.36902 8.38835 2.87868 7.87868C3.38835 7.36902 4.0167 7.17028 4.67221 7.08215C5.05703 7.03041 5.50207 7.01124 6 7.00415V11C6 11.5523 6.44772 12 7 12C7.55228 12 8 11.5523 8 11V7H11V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Ruler: {
        defaultColors: ["#3D4C66"],
        keywords: ["bread","loaf","bakery","food","item","menu-item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="8" width="18" height="8" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 8V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 8V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rupee-coin-circle-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["rupee","currency","indian-rupee","money","payment","cash","price","value","circle","indian-currency","coin","finance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75V12.25ZM9 9.75H11V8.25H9V9.75ZM11 12.25H9V13.75H11V12.25ZM12.25 11C12.25 11.6904 11.6904 12.25 11 12.25V13.75C12.5188 13.75 13.75 12.5188 13.75 11H12.25ZM11 9.75C11.6904 9.75 12.25 10.3096 12.25 11H13.75C13.75 9.48122 12.5188 8.25 11 8.25V9.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path d="M9 9H15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11H15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L12 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "ruler-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ruler","measurement","size","dimensions","scale","adjust","length","distance","increment","modify","proportion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.94561 3.00001C5.52154 2.99992 5.10941 2.99984 4.76949 3.04554C4.38629 3.09706 3.94902 3.22259 3.5858 3.5858C3.22259 3.94902 3.09706 4.38629 3.04554 4.76949C2.99984 5.10941 2.99992 5.52154 3.00001 5.94561V7L5 7C5.55228 7 6 7.44771 6 8C6 8.55228 5.55228 9 5 9L3.00001 9L3 11L6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H3V15H5C5.55228 15 6 15.4477 6 16C6 16.5523 5.55228 17 5 17H3L3.00001 18.0544C2.99992 18.4785 2.99984 18.8906 3.04554 19.2305C3.09706 19.6137 3.22259 20.051 3.5858 20.4142C3.94902 20.7774 4.38629 20.903 4.76949 20.9545C5.10941 21.0002 5.52155 21.0001 5.94562 21H7V19C7 18.4477 7.44771 18 8 18C8.55228 18 9 18.4477 9 19V21L11 21L11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18V21L15 21C15 21 15 21 15 21V19C15 18.4477 15.4477 18 16 18C16.5523 18 17 18.4477 17 19V21C17 21 17 21 17 21L18.0544 21C18.4785 21.0001 18.8906 21.0002 19.2305 20.9545C19.6137 20.903 20.051 20.7774 20.4142 20.4142C20.7774 20.051 20.903 19.6137 20.9545 19.2305C21.0002 18.8906 21.0001 18.4785 21 18.0544V15.9456C21.0001 15.5215 21.0002 15.1094 20.9545 14.7695C20.903 14.3863 20.7774 13.949 20.4142 13.5858C20.051 13.2226 19.6137 13.0971 19.2305 13.0455C18.8906 12.9998 18.4785 12.9999 18.0545 13L12 13C11.5003 13 11.2262 12.9979 11.036 12.9723L11.0287 12.9713L11.0277 12.964C11.0021 12.7738 11 12.4997 11 12L11 5.9456C11.0001 5.52157 11.0002 5.10938 10.9545 4.76949C10.903 4.38629 10.7774 3.94902 10.4142 3.5858C10.051 3.22259 9.61374 3.09706 9.23053 3.04554C8.89062 2.99984 8.47849 2.99992 8.05442 3.00001H5.94561Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rupee-coin-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rupee","indian-currency","currency","money","payment","cash","change","balance","indian-rupee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75H11C11.409 9.75 11.772 9.94639 12.0001 10.25H9C8.58579 10.25 8.25 10.5858 8.25 11C8.25 11.4142 8.58579 11.75 9 11.75H12.0001C11.772 12.0536 11.409 12.25 11 12.25H9.33028C8.48928 12.25 8.15903 13.3407 8.85878 13.8072L11.584 15.624C11.9286 15.8538 12.3943 15.7607 12.624 15.416C12.8538 15.0714 12.7607 14.6057 12.416 14.376L11.4275 13.717C12.4942 13.5505 13.3577 12.7709 13.6465 11.75H15C15.4142 11.75 15.75 11.4142 15.75 11C15.75 10.5858 15.4142 10.25 15 10.25H13.6465C13.5972 10.0757 13.5311 9.9084 13.4501 9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rupee-coin-circle-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["rupee","currency","indian-rupee","payment","money","price","transaction","cash","discount","circle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75V12.25ZM9 9.75H11V8.25H9V9.75ZM11 12.25H9V13.75H11V12.25ZM12.25 11C12.25 11.6904 11.6904 12.25 11 12.25V13.75C12.5188 13.75 13.75 12.5188 13.75 11H12.25ZM11 9.75C11.6904 9.75 12.25 10.3096 12.25 11H13.75C13.75 9.48122 12.5188 8.25 11 8.25V9.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path d="M9 9H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11H15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rupee-coin-circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["rupee","currency","indian-rupee","money","payment","cash","refund","change","transaction","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75V12.25ZM9 9.75H11V8.25H9V9.75ZM11 12.25H9V13.75H11V12.25ZM12.25 11C12.25 11.6904 11.6904 12.25 11 12.25V13.75C12.5188 13.75 13.75 12.5188 13.75 11H12.25ZM11 9.75C11.6904 9.75 12.25 10.3096 12.25 11H13.75C13.75 9.48122 12.5188 8.25 11 8.25V9.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M9 9H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 11H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 13L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "rupee-symbol-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["rupee","currency","indian-currency","money","payment","cash","price","total","rupee-symbol","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75V13.25ZM7 7.75H10.5V6.25H7V7.75ZM10.5 13.25H7V14.75H10.5V13.25ZM13.25 10.5C13.25 12.0188 12.0188 13.25 10.5 13.25V14.75C12.8472 14.75 14.75 12.8472 14.75 10.5H13.25ZM10.5 7.75C12.0188 7.75 13.25 8.98122 13.25 10.5H14.75C14.75 8.15279 12.8472 6.25 10.5 6.25V7.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M7 7H17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 10H17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 14L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rupee-symbol-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["indian-rupee","rupee","money","currency","payment","price","cost","indian","exchange","balance","cash","value","finance","amount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75V13.25ZM7 7.75H10.5V6.25H7V7.75ZM10.5 13.25H7V14.75H10.5V13.25ZM13.25 10.5C13.25 12.0188 12.0188 13.25 10.5 13.25V14.75C12.8472 14.75 14.75 12.8472 14.75 10.5H13.25ZM10.5 7.75C12.0188 7.75 13.25 8.98122 13.25 10.5H14.75C14.75 8.15279 12.8472 6.25 10.5 6.25V7.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M7 7H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 10H17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 14L12 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "rupee-symbol-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rupee","indian-currency","currency","payment","money","price","cash","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00009 7C6.00009 6.44772 6.4478 6 7.00009 6H17.0001C17.5524 6 18.0001 6.44772 18.0001 7C18.0001 7.55228 17.5524 8 17.0001 8H14.2423C14.4488 8.30851 14.6182 8.64397 14.744 9H17.0001C17.5524 9 18.0001 9.44772 18.0001 10C18.0001 10.5523 17.5524 11 17.0001 11H14.9726C14.7278 13.2148 12.8755 14.9452 10.6083 14.9987L12.5146 16.1425C12.9882 16.4267 13.1417 17.0409 12.8576 17.5145C12.5734 17.9881 11.9592 18.1416 11.4856 17.8575L6.48559 14.8575C6.10016 14.6262 5.91639 14.1662 6.03637 13.7331C6.15635 13.2999 6.55061 13 7.00009 13H10.5001C11.7096 13 12.7184 12.1411 12.9501 11H7.00009C6.4478 11 6.00009 10.5523 6.00009 10C6.00009 9.44772 6.4478 9 7.00009 9H12.5003C12.0442 8.39278 11.318 8 10.5001 8H7.00009C6.4478 8 6.00009 7.55228 6.00009 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "rupee-symbol": {
        defaultColors: ["#3D4C66"],
        keywords: ["rupee","currency","indian-currency","money","payment","cash","price","cost","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75V13.25ZM7 7.75H10.5V6.25H7V7.75ZM10.5 13.25H7V14.75H10.5V13.25ZM13.25 10.5C13.25 12.0188 12.0188 13.25 10.5 13.25V14.75C12.8472 14.75 14.75 12.8472 14.75 10.5H13.25ZM10.5 7.75C12.0188 7.75 13.25 8.98122 13.25 10.5H14.75C14.75 8.15279 12.8472 6.25 10.5 6.25V7.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M7 7H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 10H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 14L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "S-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["S","letter","alphabet","serial","sequence","settings","options","service","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L11.5 5C9.567 5 8 6.567 8 8.5C8 10.433 9.567 12 11.5 12L12.5 12C14.433 12 16 13.567 16 15.5C16 17.433 14.433 19 12.5 19H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "S-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["S","letter-s","shape","serpentine","settings","options","segment","section","discount","special","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L11.5 5C9.567 5 8 6.567 8 8.5C8 10.433 9.567 12 11.5 12L12.5 12C14.433 12 16 13.567 16 15.5C16 17.433 14.433 19 12.5 19H8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "S-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["s","snake","curve","route","path","way","process","steps","workflow","status","sequence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 6L11.5 6C10.1193 6 9 7.11929 9 8.5C9 9.88071 10.1193 11 11.5 11L12.5 11C14.9853 11 17 13.0147 17 15.5C17 17.9853 14.9853 20 12.5 20H8C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18H12.5C13.8807 18 15 16.8807 15 15.5C15 14.1193 13.8807 13 12.5 13H11.5C9.01472 13 7 10.9853 7 8.5C7 6.01472 9.01472 4 11.5 4L16 4C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    S: {
        defaultColors: ["#3D4C66"],
        keywords: ["s","snake","curve","route","path","way","process","steps","workflow","status","sequence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5L11.5 5C9.567 5 8 6.567 8 8.5C8 10.433 9.567 12 11.5 12L12.5 12C14.433 12 16 13.567 16 15.5C16 17.433 14.433 19 12.5 19H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "safe delivery 2-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["box","package","container","delivery","safe","secure","shipping","received","parcel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2.5C7.58172 2.5 4 5.63401 4 9.5H20C20 5.63401 16.4183 2.5 12 2.5Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 9.5L12 15.5L20 9.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 19.6V17.4C8 16.2686 8 15.7029 8.35147 15.3515C8.70294 15 9.26863 15 10.4 15H13.6C14.7314 15 15.2971 15 15.6485 15.3515C16 15.7029 16 16.2686 16 17.4V19.6C16 20.7314 16 21.2971 15.6485 21.6485C15.2971 22 14.7314 22 13.6 22H12H10.4C9.26863 22 8.70294 22 8.35147 21.6485C8 21.2971 8 20.7314 8 19.6Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17H12.3C12.63 17 12.795 17 12.8975 16.8975C13 16.795 13 16.63 13 16.3V15.7C13 15.37 13 15.205 12.8975 15.1025C12.795 15 12.63 15 12.3 15H11.7C11.37 15 11.205 15 11.1025 15.1025C11 15.205 11 15.37 11 15.7V16.3C11 16.63 11 16.795 11.1025 16.8975C11.205 17 11.37 17 11.7 17H12Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "safe delivery 2-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["mushroom","delivery","package","order","shipping","delivered","box","food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 9.5L12 15.5L20 9.5" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12 2.5C7.58172 2.5 4 5.63401 4 9.5H20C20 5.63401 16.4183 2.5 12 2.5Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19.6V17.4C8 16.2686 8 15.7029 8.35147 15.3515C8.70294 15 9.26863 15 10.4 15H13.6C14.7314 15 15.2971 15 15.6485 15.3515C16 15.7029 16 16.2686 16 17.4V19.6C16 20.7314 16 21.2971 15.6485 21.6485C15.2971 22 14.7314 22 13.6 22H12H10.4C9.26863 22 8.70294 22 8.35147 21.6485C8 21.2971 8 20.7314 8 19.6Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17H12.3C12.63 17 12.795 17 12.8975 16.8975C13 16.795 13 16.63 13 16.3V15H11V16.3C11 16.63 11 16.795 11.1025 16.8975C11.205 17 11.37 17 11.7 17H12Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "safe delivery 2-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","safe","delivery","shipping","fragile","ecommerce","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1.75C7.26471 1.75 3.25 5.12885 3.25 9.5C3.25 9.65266 3.29561 9.79466 3.37394 9.91313C3.43027 10.0466 3.51968 10.1683 3.64071 10.2651L8.94684 14.3057C8.5489 14.3635 8.14942 14.4929 7.82114 14.8211C7.48283 15.1595 7.35574 15.5734 7.30062 15.9833C7.24991 16.3605 7.24995 16.8277 7.25 17.353V19.647C7.24995 20.1723 7.24991 20.6395 7.30062 21.0167C7.35574 21.4266 7.48283 21.8405 7.82114 22.1789C8.15945 22.5172 8.5734 22.6443 8.98334 22.6994C9.36049 22.7501 9.82768 22.75 10.353 22.75H13.647C14.1723 22.75 14.6395 22.7501 15.0167 22.6994C15.4266 22.6443 15.8405 22.5172 16.1789 22.1789C16.5172 21.8405 16.6443 21.4266 16.6994 21.0167C16.7501 20.6395 16.75 20.1723 16.75 19.647V17.353C16.75 16.8277 16.7501 16.3605 16.6994 15.9833C16.6443 15.5734 16.5172 15.1595 16.1789 14.8211C15.8506 14.4929 15.4512 14.3635 15.0533 14.3057L20.3594 10.265C20.4806 10.1681 20.5701 10.0462 20.6264 9.91262C20.7045 9.79425 20.75 9.65244 20.75 9.5C20.75 5.12885 16.7353 1.75 12 1.75ZM13.2507 15.6785C13.1773 15.6307 13.0977 15.5913 13.0134 15.5618C12.8267 15.4965 12.6213 15.4988 12.5266 15.4998L12.5001 15.5001H11.5001L11.4735 15.4998C11.3788 15.4988 11.1734 15.4965 10.9867 15.5618C10.9024 15.5913 10.8229 15.6306 10.7495 15.6784C10.548 15.8098 10.3928 16.0051 10.3118 16.2367C10.2465 16.4234 10.2488 16.6288 10.2498 16.7235L10.2501 16.7501L10.2498 16.7766C10.2488 16.8713 10.2465 17.0767 10.3118 17.2634C10.4223 17.5793 10.6708 17.8278 10.9867 17.9383C11.1734 18.0036 11.3788 18.0013 11.4735 18.0003L11.5001 18.0001H12.5001L12.5266 18.0003C12.6213 18.0013 12.8267 18.0036 13.0134 17.9383C13.3293 17.8278 13.5778 17.5793 13.6883 17.2634C13.7536 17.0767 13.7513 16.8713 13.7503 16.7766L13.7501 16.7501L13.7503 16.7235C13.7513 16.6288 13.7536 16.4234 13.6883 16.2367C13.6073 16.0051 13.4522 15.8098 13.2507 15.6785ZM17.4018 10.25L12.1284 14.25H11.8718L6.59833 10.25H17.4018Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "safe delivery 2": {
        defaultColors: ["#000000"],
        keywords: ["no-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2.5C7.58172 2.5 4 5.63401 4 9.5H20C20 5.63401 16.4183 2.5 12 2.5Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 9.5L12 15.5L20 9.5" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 19.6V17.4C8 16.2686 8 15.7029 8.35147 15.3515C8.70294 15 9.26863 15 10.4 15H13.6C14.7314 15 15.2971 15 15.6485 15.3515C16 15.7029 16 16.2686 16 17.4V19.6C16 20.7314 16 21.2971 15.6485 21.6485C15.2971 22 14.7314 22 13.6 22H12H10.4C9.26863 22 8.70294 22 8.35147 21.6485C8 21.2971 8 20.7314 8 19.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 17H12.3C12.63 17 12.795 17 12.8975 16.8975C13 16.795 13 16.63 13 16.3V15.7C13 15.37 13 15.205 12.8975 15.1025C12.795 15 12.63 15 12.3 15H11.7C11.37 15 11.205 15 11.1025 15.1025C11 15.205 11 15.37 11 15.7V16.3C11 16.63 11 16.795 11.1025 16.8975C11.205 17 11.37 17 11.7 17H12Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "safe delivery-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["delivery","package","box","safe","delivery-box","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13H5.79474C5.93017 13 6.06418 13.0275 6.18866 13.0809L9.31134 14.4191C9.43582 14.4725 9.56983 14.5 9.70526 14.5H11.3377C11.4452 14.5 11.5527 14.5157 11.6518 14.5573C12.0533 14.7259 12.5773 15.0778 12.599 15.5761C12.6112 15.8562 12.3465 16.0438 12.077 16.1209L9.34185 16.9023C9.12073 16.9655 8.88459 16.9505 8.67321 16.8599L6 15.7143"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.5 15.5C12.8743 15.5 15.6128 14.6244 17.1922 14.1022C17.3963 14.0347 17.61 13.9948 17.8237 14.0183C18.4738 14.0896 19.3093 14.3836 19.5163 15.1413C19.6621 15.6753 19.2254 16.1526 18.7415 16.4214L11.2242 20.5977C10.7605 20.8553 10.2135 20.9181 9.70345 20.7724L3.5 19"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5714 5.14286H13.9429C14.2728 5.14286 14.4378 5.14286 14.5403 5.04034C14.6429 4.93783 14.6429 4.77284 14.6429 4.44286V3.7C14.6429 3.37002 14.6429 3.20503 14.5403 3.10251C14.4378 3 14.2728 3 13.9429 3H13.2C12.87 3 12.705 3 12.6025 3.10251C12.5 3.20503 12.5 3.37002 12.5 3.7V4.44286C12.5 4.77284 12.5 4.93783 12.6025 5.04034C12.705 5.14286 12.87 5.14286 13.2 5.14286H13.5714Z"
                    fill={colors?.[0] || "#7E47E1"}
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 8.6V5.4C9 4.26863 9 3.70294 9.35147 3.35147C9.70294 3 10.2686 3 11.4 3H15.6C16.7314 3 17.2971 3 17.6485 3.35147C18 3.70294 18 4.26863 18 5.4V8.6C18 9.73137 18 10.2971 17.6485 10.6485C17.2971 11 16.7314 11 15.6 11H13.5H11.4C10.2686 11 9.70294 11 9.35147 10.6485C9 10.2971 9 9.73137 9 8.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "safe delivery-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["box","package","hand","delivery","receive","shipment","order","shipping","received","deliver"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5 15.5C12.8743 15.5 15.6128 14.6244 17.1922 14.1022C17.3963 14.0347 17.61 13.9948 17.8237 14.0183C18.4738 14.0896 19.3093 14.3836 19.5163 15.1413C19.6621 15.6753 19.2254 16.1526 18.7415 16.4214L11.2242 20.5977C10.7605 20.8553 10.2135 20.9181 9.70345 20.7724L3.5 19"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 13H5.79474C5.93017 13 6.06418 13.0275 6.18866 13.0809L9.31134 14.4191C9.43582 14.4725 9.56983 14.5 9.70526 14.5H11.3377C11.4452 14.5 11.5527 14.5157 11.6518 14.5573C12.0533 14.7259 12.5773 15.0778 12.599 15.5761C12.6112 15.8562 12.3465 16.0438 12.077 16.1209L9.34185 16.9023C9.12073 16.9655 8.88459 16.9505 8.67321 16.8599L6 15.7143"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 8.6V5.4C9 4.26863 9 3.70294 9.35147 3.35147C9.70294 3 10.2686 3 11.4 3H15.6C16.7314 3 17.2971 3 17.6485 3.35147C18 3.70294 18 4.26863 18 5.4V8.6C18 9.73137 18 10.2971 17.6485 10.6485C17.2971 11 16.7314 11 15.6 11H13.5H11.4C10.2686 11 9.70294 11 9.35147 10.6485C9 10.2971 9 9.73137 9 8.6Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5714 5.14286H13.9429C14.2728 5.14286 14.4378 5.14286 14.5403 5.04034C14.6429 4.93783 14.6429 4.77284 14.6429 4.44286V3H12.5V4.44286C12.5 4.77284 12.5 4.93783 12.6025 5.04034C12.705 5.14286 12.87 5.14286 13.2 5.14286H13.5714Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "safe delivery-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","shipping","box","package","safe","fragile","transport","received","confirmed","order","safe-delivery","arrival"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12.25C2.0335 12.25 1.25 13.0335 1.25 14V17.6843C1.25 19.2174 3.41858 19.7718 3.47114 19.7718C3.4206 19.7573 3.52371 19.7718 3.47114 19.7718L9.49741 21.4936C10.1987 21.6939 10.9508 21.6075 11.5884 21.2533L19.1057 17.077C19.4183 16.9034 19.7483 16.6463 19.9825 16.3065C20.224 15.9562 20.3856 15.4776 20.2398 14.9437C20.0693 14.3196 19.6415 13.914 19.2028 13.6682C18.7729 13.4272 18.2959 13.3156 17.9055 13.2728C17.5476 13.2335 17.2201 13.303 16.9567 13.3901C16.1805 13.6467 15.0407 13.988 14.0873 14.2671C14.0529 14.2772 14.0189 14.2872 13.9851 14.297C14.0702 14.5071 14.1175 14.7446 14.1006 15.0073C14.0645 15.568 13.6117 15.8853 13.2732 16.0132L9.84263 17.3096C9.44568 17.4597 9.00375 17.4345 8.62637 17.2404L5.89644 15.8365C5.65087 15.7102 5.55417 15.4088 5.68046 15.1632C5.80675 14.9176 6.1082 14.8209 6.35377 14.9472L9.08371 16.3511C9.2095 16.4158 9.35681 16.4242 9.48913 16.3742L12.9197 15.0778C12.9938 15.0498 13.0476 15.0128 13.0777 14.9813C13.0918 14.9666 13.0979 14.9561 13.1003 14.9511C13.1023 14.9469 13.1026 14.9432 13.1026 14.9432C13.1107 14.8179 13.0332 14.7101 12.966 14.5922C12.9502 14.5968 12.9813 14.5878 12.966 14.5922C12.9052 14.5186 12.8417 14.4526 12.7791 14.3943C12.512 14.1455 12.1972 13.9729 11.9421 13.8658C11.7271 13.7755 11.5152 13.75 11.3377 13.75H9.70526C9.6714 13.75 9.6379 13.7431 9.60678 13.7298L6.4841 12.3915C6.26627 12.2981 6.03174 12.25 5.79474 12.25H3Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M12 2.5C11.5166 2.50016 11.0857 2.50325 10.7333 2.55062C10.3234 2.60573 9.90946 2.73283 9.57115 3.07114C9.23284 3.40945 9.10575 3.82339 9.05063 4.23334C8.99992 4.6105 8.99996 5.07768 9.00001 5.60303L9 8.39702C8.99996 8.92237 8.99992 9.38955 9.05063 9.76672C9.10574 10.1767 9.23283 10.5906 9.57115 10.9289C9.90946 11.2672 10.3234 11.3943 10.7333 11.4494C11.1105 11.5001 11.5777 11.5001 12.103 11.5001H15.397C15.9223 11.5001 16.3895 11.5001 16.7667 11.4494C17.1766 11.3943 17.5905 11.2672 17.9289 10.9289C18.2672 10.5906 18.3943 10.1767 18.4494 9.76672C18.5001 9.38955 18.5 8.92237 18.5 8.39701L18.5 5.60304C18.5001 5.07769 18.5001 4.6105 18.4494 4.23334C18.3943 3.82339 18.2672 3.40945 17.9289 3.07114C17.5906 2.73283 17.1766 2.60573 16.7667 2.55062C16.4144 2.50325 15.9835 2.50016 15.5 2.5L15.5 4C15.5001 4.13902 15.5003 4.30888 15.4805 4.45565C15.4565 4.63412 15.3917 4.88565 15.1779 5.09948C14.964 5.31332 14.7125 5.37817 14.534 5.40216C14.3872 5.4219 14.2174 5.42178 14.0784 5.42168H13.4217C13.2827 5.42178 13.1128 5.4219 12.9661 5.40216C12.7876 5.37817 12.536 5.31332 12.3222 5.09948C12.1084 4.88565 12.0435 4.63412 12.0195 4.45565C11.9998 4.30888 11.9999 4.13902 12 4L12 2.5Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "safe delivery": {
        defaultColors: ["#000000"],
        keywords: ["box","package","safe","delivery","shipping","fragile","handle-with-care","return","order","complete","secured","parcel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13H5.79474C5.93017 13 6.06418 13.0275 6.18866 13.0809L9.31134 14.4191C9.43582 14.4725 9.56983 14.5 9.70526 14.5H11.3377C11.4452 14.5 11.5527 14.5157 11.6518 14.5573C12.0533 14.7259 12.5773 15.0778 12.599 15.5761C12.6112 15.8562 12.3465 16.0438 12.077 16.1209L9.34185 16.9023C9.12073 16.9655 8.88459 16.9505 8.67321 16.8599L6 15.7143"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.5 15.5C12.8743 15.5 15.6128 14.6244 17.1922 14.1022C17.3963 14.0347 17.61 13.9948 17.8237 14.0183C18.4738 14.0896 19.3093 14.3836 19.5163 15.1413C19.6621 15.6753 19.2254 16.1526 18.7415 16.4214L11.2242 20.5977C10.7605 20.8553 10.2135 20.9181 9.70345 20.7724L3.5 19"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 8.6V5.4C9 4.26863 9 3.70294 9.35147 3.35147C9.70294 3 10.2686 3 11.4 3H15.6C16.7314 3 17.2971 3 17.6485 3.35147C18 3.70294 18 4.26863 18 5.4V8.6C18 9.73137 18 10.2971 17.6485 10.6485C17.2971 11 16.7314 11 15.6 11H13.5H11.4C10.2686 11 9.70294 11 9.35147 10.6485C9 10.2971 9 9.73137 9 8.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.5714 5.14286H13.9429C14.2728 5.14286 14.4378 5.14286 14.5403 5.04034C14.6429 4.93783 14.6429 4.77284 14.6429 4.44286V3.7C14.6429 3.37002 14.6429 3.20503 14.5403 3.10251C14.4378 3 14.2728 3 13.9429 3H13.2C12.87 3 12.705 3 12.6025 3.10251C12.5 3.20503 12.5 3.37002 12.5 3.7V4.44286C12.5 4.77284 12.5 4.93783 12.6025 5.04034C12.705 5.14286 12.87 5.14286 13.2 5.14286H13.5714Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "safebox-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["safe","box","vault","remove","subtract","cash","money","security","safebox","discount","reduce","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C10.3431 9 9 10.3432 9 12.0001C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12.0001C15 10.3432 13.6569 9 12 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.5 12H12.5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "safebox-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["safe","vault","money","cash","security","deposit","banking","finance","earnings","payment","safe-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7L16 17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 9.11438 4 8.17157 4.58579 7.58579C5.17157 7 6.11438 7 8 7H16C17.8856 7 18.8284 7 19.4142 7.58579C20 8.17157 20 9.11438 20 11V13C20 14.8856 20 15.8284 19.4142 16.4142C18.8284 17 17.8856 17 16 17H8C6.11438 17 5.17157 17 4.58579 16.4142C4 15.8284 4 14.8856 4 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 19L17 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19L7 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12C8 13.1046 8.89543 14 10 14C10.5523 14 11.0523 13.7761 11.4142 13.4142C11.7761 13.0523 12 12.5523 12 12C12 10.8954 11.1046 10 10 10C8.89543 10 8 10.8954 8 12Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "safebox-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["safe","safebox","money","cash","vault","security","deposit","funds","balance","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18L17 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 18L7 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12V10C4 8.11438 4 7.17157 4.58579 6.58579C5.17157 6 6.11438 6 8 6H16C17.8856 6 18.8284 6 19.4142 6.58579C20 7.17157 20 8.11438 20 10V12C20 13.8856 20 14.8284 19.4142 15.4142C18.8284 16 17.8856 16 16 16H8C6.11438 16 5.17157 16 4.58579 15.4142C4 14.8284 4 13.8856 4 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M16 7V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 11C8 12.1046 8.89543 13 10 13C10.5523 13 11.0523 12.7761 11.4142 12.4142C11.7761 12.0523 12 11.5523 12 11C12 9.89543 11.1046 9 10 9C8.89543 9 8 9.89543 8 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "safebox-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","money","cash","vault","security","funds","cash-drawer","till","safe-box","deposit","balance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.67221 5.08215C6.28387 4.99991 7.04769 4.99995 7.93417 5H16.0658C16.9523 4.99995 17.7161 4.99991 18.3278 5.08215C18.9833 5.17028 19.6117 5.36902 20.1213 5.87868C20.631 6.38835 20.8297 7.0167 20.9179 7.67221C21.0001 8.28388 21.0001 9.0477 21 9.9342V12.0658C21.0001 12.9523 21.0001 13.7161 20.9179 14.3278C20.8297 14.9833 20.631 15.6117 20.1213 16.1213C19.6117 16.631 18.9833 16.8297 18.3278 16.9179C18.223 16.932 18.1136 16.9436 18 16.9533V18C18 18.5523 17.5523 19 17 19C16.4477 19 16 18.5523 16 18V17H8V18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18V16.9533C5.88637 16.9436 5.77706 16.932 5.67221 16.9179C5.0167 16.8297 4.38835 16.631 3.87868 16.1213C3.36902 15.6117 3.17028 14.9833 3.08215 14.3278C2.99991 13.7161 2.99995 12.9523 3 12.0658V9.93417C2.99995 9.04769 2.99991 8.28387 3.08215 7.67221C3.17028 7.0167 3.36902 6.38835 3.87868 5.87868C4.38835 5.36902 5.0167 5.17028 5.67221 5.08215ZM16 8C16.5523 8 17 8.44772 17 9V13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V9C15 8.44772 15.4477 8 16 8ZM7 11C7 9.34315 8.34315 8 10 8C11.6569 8 13 9.34315 13 11C13 11.8282 12.6631 12.5795 12.1213 13.1213C11.5795 13.6631 10.8282 14 10 14C8.34315 14 7 12.6569 7 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "safebox-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","vault","money","cash","secure","security","deposit","cash-drawer","financial","funds","savings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7L16 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 13V11C4 9.11438 4 8.17157 4.58579 7.58579C5.17157 7 6.11438 7 8 7H16C17.8856 7 18.8284 7 19.4142 7.58579C20 8.17157 20 9.11438 20 11V13C20 14.8856 20 15.8284 19.4142 16.4142C18.8284 17 17.8856 17 16 17H8C6.11438 17 5.17157 17 4.58579 16.4142C4 15.8284 4 14.8856 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 19L17 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 19L7 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12C8 13.1046 8.89543 14 10 14C10.5523 14 11.0523 13.7761 11.4142 13.4142C11.7761 13.0523 12 12.5523 12 12C12 10.8954 11.1046 10 10 10C8.89543 10 8 10.8954 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    safebox: {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","vault","money","cash","secure","security","deposit","cash-drawer","financial","funds","savings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C10.3431 9 9 10.3432 9 12.0001C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12.0001C15 10.3432 13.6569 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.5 12H12.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "safebox-21": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["safe","vault","money","cash","security","payment","safe-box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 9C10.3431 9 9 10.3432 9 12.0001C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12.0001C15 10.3432 13.6569 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11.5 12H12.5" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "safebox-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","vault","security","money","cash","transaction","remove","withdraw","payment","refund","discount","minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57536 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57526 4 10.9293V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.4245 19.0814 5.70169 19.2772 6 19.4295V20C6 20.5523 6.44772 21 7 21C7.55229 21 8 20.5523 8 20V19.9281C8.80838 20.0001 9.78389 20 10.9294 20H13.0706C14.216 20 15.1916 20.0001 16 19.9281V20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20V19.4295C18.2983 19.2772 18.5755 19.0814 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57535 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4246 3.99997 13.0706 4ZM12 8C9.79083 8 8 9.79096 8 12.0001C8 14.2092 9.79089 16 12 16C14.2091 16 16 14.2092 16 12.0001C16 9.79096 14.2092 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 11.4477 10.4477 11 11 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H11C10.4477 13 10 12.5523 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "scissor-3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["scissors","cut","remove","delete","discount","coupon","split","divide","separate","trim","reduce","adjustment","price-adjustment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L5 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16L19 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="17" r="2" transform="rotate(-90 7 17)" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="17" cy="17" r="2" transform="rotate(-90 17 17)" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "scissor-3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["scissors","cut","discount","coupon","remove","delete","cancel","reduction","markdown","price-cut","edit","modify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L5 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16L19 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="7"
                    cy="17"
                    r="2"
                    transform="rotate(-90 7 17)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="17"
                    cy="17"
                    r="2"
                    transform="rotate(-90 17 17)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "scissor-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","coupon","discount","remove","edit","split","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.76825 3.35978C5.41468 2.9355 4.78412 2.87818 4.35984 3.23174C3.93556 3.58531 3.87824 4.21587 4.2318 4.64015L10.6983 12.3999L8.83977 14.6302C8.33174 14.2352 7.69334 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6568 5.34315 20 7 20C8.65685 20 10 18.6568 10 17C10 16.8042 9.98125 16.6128 9.94543 16.4275L12 13.962L14.0546 16.4275C14.0188 16.6128 14 16.8042 14 17C14 18.6568 15.3431 20 17 20C18.6569 20 20 18.6568 20 17C20 15.3431 18.6569 14 17 14C16.3067 14 15.6683 14.2352 15.1602 14.6302L13.3017 12.3999L19.7682 4.64015C20.1218 4.21587 20.0644 3.58531 19.6402 3.23174C19.2159 2.87818 18.5853 2.9355 18.2318 3.35978L12 10.8379L5.76825 3.35978ZM6 17C6 17.5523 6.44772 18 7 18C7.55229 18 8 17.5523 8 17C8 16.4477 7.55229 16 7 16C6.44772 16 6 16.4477 6 17ZM17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "scissor-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","discount","remove","delete","trim","adjust","modify","reduce","coupon","voucher","edit","split"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 16L5 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 16L19 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="17" r="2" transform="rotate(-90 7 17)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="17" cy="17" r="2" transform="rotate(-90 17 17)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "scissor-cut-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["scissors","cut","remove","delete","cancel","discount","coupon","remove-item","discount-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="6" cy="16" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "scissor-cut-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","remove","discount","split","divide","delete","cancel","coupon","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7C3 5.34315 4.34315 4 6 4C7.65685 4 9 5.34315 9 7C9 7.46162 8.89574 7.89888 8.70948 8.28953L11.6 10.6983L19.3598 4.2318C19.7841 3.87824 20.4147 3.93556 20.7682 4.35984C21.1218 4.78412 21.0645 5.41468 20.6402 5.76825L13.1621 12L20.6402 18.2318C21.0645 18.5854 21.1218 19.2159 20.7682 19.6402C20.4147 20.0645 19.7841 20.1218 19.3598 19.7682L11.6 13.3017L8.95896 15.5026C8.98595 15.6644 9 15.8306 9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C6.75003 13 7.43577 13.2752 7.96174 13.7302L10.038 12L7.35984 9.76825C7.33657 9.74886 7.31441 9.72863 7.29336 9.70766C6.90174 9.89506 6.46312 10 6 10C4.34315 10 3 8.65685 3 7ZM6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6ZM5 16C5 15.4477 5.44772 15 6 15C6.55228 15 7 15.4477 7 16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "scissor-cut-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["scissors","cut","remove","delete","discount","coupon","void","edit","cancel","split","discount-code","cut-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" fill={colors?.[1] || "#D9D1E0"} stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
                <circle
                    cx="6"
                    cy="16"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "scissor-cut-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","discount","coupon","voucher","split","divide","portion","removal","delete","trim","edit","fragment","separate","reduce","markdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="16" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M3 12L21 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="3 3"
                />
            </svg>
        )
    },
    "scissor-cut-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["scissors","cut","remove","discount","split","reduce","coupon","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12L21 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="3 3"
                />
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="16" r="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "scissor-cut-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["scissors","cut","discount","coupon","remove","delete","split","portion","divide","segment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" fill={colors?.[1] || "#D9D1E0"} stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
                <circle
                    cx="6"
                    cy="16"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3 12L21 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="3 3"
                />
            </svg>
        )
    },
    "scissor-cut": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","remove","discount","coupon","split","cancel","edit","reduction","adjust","delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 5L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="6" cy="7" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="16" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "screen-share-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["screen","share","display","monitor","arrow","right","forward","send","transmit","export","broadcast","cast","screen-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "scissor-cut-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["scissors","cut","discount","reduce","split","divide","portion","remove","delete","sale","trim","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 4C4.34315 4 3 5.34315 3 7C3 8.65685 4.34315 10 6 10C6.46312 10 6.90174 9.89506 7.29336 9.70766C7.31441 9.72863 7.33657 9.74886 7.35984 9.76825L8.83794 11H7.5C6.94772 11 6.5 11.4477 6.5 12C6.5 12.5523 6.94772 13 7.5 13H8.83801L7.96174 13.7302C7.43577 13.2752 6.75003 13 6 13C4.34315 13 3 14.3431 3 16C3 17.6569 4.34315 19 6 19C7.65685 19 9 17.6569 9 16C9 15.8306 8.98595 15.6644 8.95896 15.5026L11.6 13.3017L19.3598 19.7682C19.7841 20.1218 20.4147 20.0645 20.7682 19.6402C21.1218 19.2159 21.0645 18.5854 20.6402 18.2318L14.362 13H16.5C17.0523 13 17.5 12.5523 17.5 12C17.5 11.4477 17.0523 11 16.5 11H14.3621L20.6402 5.76825C21.0645 5.41468 21.1218 4.78412 20.7682 4.35984C20.4147 3.93556 19.7841 3.87824 19.3598 4.2318L11.6 10.6983L8.70948 8.28953C8.89574 7.89888 9 7.46162 9 7C9 5.34315 7.65685 4 6 4ZM5 7C5 6.44772 5.44772 6 6 6C6.55228 6 7 6.44772 7 7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7ZM6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17C6.55228 17 7 16.5523 7 16C7 15.4477 6.55228 15 6 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 13C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H19.5C18.9477 11 18.5 11.4477 18.5 12C18.5 12.5523 18.9477 13 19.5 13H21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.5 13C5.05228 13 5.5 12.5523 5.5 12C5.5 11.4477 5.05228 11 4.5 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H4.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "screen-share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["screen","arrow","share","display","send","transmit","screen-share","output","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "screen-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","share","screen-share","remote","transmit","monitor","display","connect","forward","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.94513 4.25H14.0549C15.4225 4.24998 16.5248 4.24997 17.3918 4.36653C18.2919 4.48754 19.0497 4.74644 19.6517 5.34835C20.2536 5.95027 20.5125 6.70814 20.6335 7.60825C20.75 8.47522 20.75 9.57754 20.75 10.9451V11.0549C20.75 12.4225 20.75 13.5248 20.6335 14.3918C20.5125 15.2919 20.2536 16.0497 19.6517 16.6517C19.0497 17.2536 18.2919 17.5125 17.3918 17.6335C16.5248 17.75 15.4225 17.75 14.0549 17.75H12.75V18.75H14C14.4142 18.75 14.75 19.0858 14.75 19.5C14.75 19.9142 14.4142 20.25 14 20.25H10C9.58579 20.25 9.25 19.9142 9.25 19.5C9.25 19.0858 9.58579 18.75 10 18.75H11.25V17.75H9.94513C8.57755 17.75 7.47522 17.75 6.60825 17.6335C5.70814 17.5125 4.95027 17.2536 4.34835 16.6517C3.74644 16.0497 3.48754 15.2919 3.36653 14.3918C3.24997 13.5248 3.24998 12.4225 3.25 11.0549V10.9451C3.24998 9.57755 3.24997 8.47521 3.36653 7.60825C3.48754 6.70814 3.74644 5.95027 4.34835 5.34835C4.95027 4.74644 5.70814 4.48754 6.60825 4.36653C7.47521 4.24997 8.57755 4.24998 9.94513 4.25ZM13.5304 7.46967C13.2375 7.17678 12.7626 7.17678 12.4697 7.46967C12.1768 7.76256 12.1768 8.23744 12.4697 8.53033L13.1894 9.25L12.8843 9.24998C12.0663 9.24971 11.5081 9.24952 11.0295 9.37778C9.73538 9.72453 8.72458 10.7353 8.37783 12.0294C8.24957 12.5081 8.24976 13.0662 8.25003 13.8842L8.25005 14C8.25005 14.4142 8.58584 14.75 9.00005 14.75C9.41426 14.75 9.75005 14.4142 9.75005 14C9.75005 13.0217 9.75649 12.6797 9.82672 12.4177C10.0348 11.6412 10.6413 11.0347 11.4177 10.8267C11.6798 10.7564 12.0218 10.75 13.0001 10.75H13.1894L12.4697 11.4697C12.1768 11.7626 12.1768 12.2374 12.4697 12.5303C12.7626 12.8232 13.2375 12.8232 13.5304 12.5303L15.5304 10.5303C15.671 10.3897 15.7501 10.1989 15.7501 10C15.7501 9.80109 15.671 9.61032 15.5304 9.46967L13.5304 7.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "screen-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","share","screen-share","arrow","right","display","transmit","send","forward","relay","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "screenshot-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["scissors","cut","discount","coupon","promotion","remove","reduce","edit","split","adjustment","modify","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L15 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L9 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="17" r="2" transform="rotate(-90 7 17)" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="17" cy="17" r="2" transform="rotate(-90 17 17)" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 12V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "screenshot-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cancel","delete","remove","close","error","reject","disable","unlink","disconnect","deactivate","off","no","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L9 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="7"
                    cy="17"
                    r="2"
                    transform="rotate(-90 7 17)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="17"
                    cy="17"
                    r="2"
                    transform="rotate(-90 17 17)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 12V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "screenshot-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["close","cancel","remove","delete","clear","dismiss","exit","cross","button"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.70711 8.2929C8.31659 7.90237 7.68342 7.90237 7.2929 8.2929C6.90237 8.68342 6.90237 9.31659 7.2929 9.70711L10.5858 13L8.90415 14.6817C8.38617 14.2557 7.72295 14 7 14C5.34315 14 4 15.3432 4 17C4 18.6569 5.34315 20 7 20C8.65686 20 10 18.6569 10 17C10 16.8164 9.98352 16.6367 9.95195 16.4623L12 14.4142L14.0481 16.4623C14.0165 16.6367 14 16.8164 14 17C14 18.6569 15.3432 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3432 18.6569 14 17 14C16.2771 14 15.6138 14.2557 15.0959 14.6817L13.4142 13L16.7071 9.70711C17.0976 9.31659 17.0976 8.68342 16.7071 8.2929C16.3166 7.90237 15.6834 7.90237 15.2929 8.2929L12 11.5858L8.70711 8.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93417 4C8.95604 4 8.97799 4 9 4L15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28387 20.0001 8.04769 20 8.93417L20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H9C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6 8.02893 6 9V12C6 12.5523 5.55229 13 5 13C4.44772 13 4 12.5523 4 12V9C4 8.97799 4 8.95604 4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    screenshot: {
        defaultColors: ["#3D4C66"],
        keywords: ["close","cancel","remove","delete","clear","dismiss","exit","cross","button"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L15 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9L9 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="17" r="2" transform="rotate(-90 7 17)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="17" cy="17" r="2" transform="rotate(-90 17 17)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 12V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sd-card-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sd-card","memory","storage","data","external-storage","backup","transfer","import","export","settings","configuration","device","removable-storage","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V10.7C17 10.0072 17 9.66073 16.9242 9.33002C16.8811 9.1417 16.8198 8.95799 16.7414 8.78144C16.6036 8.47142 16.3957 8.19428 15.98 7.64001L15.98 7.64L15.53 7.04C14.9135 6.21805 14.6053 5.80708 14.2007 5.52865C13.9712 5.37069 13.7207 5.24547 13.4567 5.15662C12.9911 5 12.4774 5 11.45 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 11V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 11V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 11V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sd-card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sd-card","memory","storage","file","settings","options","configuration","data","import","export","backup","restore"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V10.7C17 10.0072 17 9.66073 16.9242 9.33002C16.8811 9.1417 16.8198 8.95799 16.7414 8.78144C16.6036 8.47142 16.3957 8.19428 15.98 7.64001L15.98 7.64L15.53 7.04C14.9135 6.21805 14.6053 5.80708 14.2007 5.52865C13.9712 5.37069 13.7207 5.24547 13.4567 5.15662C12.9911 5 12.4774 5 11.45 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 11V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 11V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 11V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sd-card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sd-card","memory","storage","data","file","backup","transfer","import","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5937 4.00006C13.4809 3.99948 14.1516 3.99904 14.7755 4.20895C15.1277 4.32742 15.4616 4.49437 15.7676 4.70498C16.3099 5.07816 16.712 5.61503 17.2438 6.32515L17.8374 7.11656C18.1978 7.5967 18.4705 7.95994 18.6552 8.37538C18.7598 8.61077 18.8414 8.85572 18.899 9.10682C19.0005 9.54997 19.0003 10.0042 19 10.6046V10.6046L19 13.9485C19 14.8894 19 15.6658 18.9403 16.2945C18.878 16.9489 18.7441 17.5459 18.4106 18.0901C18.0807 18.6283 17.6282 19.0809 17.09 19.4107C16.5458 19.7442 15.9488 19.8782 15.2944 19.9404C14.6657 20.0002 13.8892 20.0001 12.9484 20.0001H11.0515C10.1107 20.0001 9.33435 20.0002 8.70561 19.9404C8.05122 19.8782 7.45424 19.7442 6.91001 19.4107C6.37179 19.0809 5.91926 18.6283 5.58944 18.0901C5.25593 17.5459 5.12197 16.9489 5.05975 16.2945C4.99997 15.6658 4.99998 14.8894 5 13.9486V13.9485V10.0517V10.0516C4.99998 9.11083 4.99997 8.33447 5.05975 7.70573C5.12197 7.05134 5.25593 6.45436 5.58944 5.91013C5.91926 5.37191 6.37179 4.91938 6.91001 4.58956C7.45424 4.25605 8.05122 4.12209 8.70561 4.05987C9.33436 4.00009 10.1107 4.0001 11.0516 4.00012L12.5937 4.00006ZM9 8.00012C9.55229 8.00012 10 8.44784 10 9.00012V11.0001C10 11.5524 9.55229 12.0001 9 12.0001C8.44772 12.0001 8 11.5524 8 11.0001V9.00012C8 8.44784 8.44772 8.00012 9 8.00012ZM12 8.00012C12.5523 8.00012 13 8.44784 13 9.00012V11.0001C13 11.5524 12.5523 12.0001 12 12.0001C11.4477 12.0001 11 11.5524 11 11.0001V9.00012C11 8.44784 11.4477 8.00012 12 8.00012ZM16 9.00012C16 8.44784 15.5523 8.00012 15 8.00012C14.4477 8.00012 14 8.44784 14 9.00012V11.0001C14 11.5524 14.4477 12.0001 15 12.0001C15.5523 12.0001 16 11.5524 16 11.0001V9.00012Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sd-card-alert-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["alert","warning","exclamation","mark","attention","issue","problem","error","notification","flag","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L11 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sd-card-alert-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["alert","warning","error","exclamation","point","notification","issue","problem","attention","flag","incorrect","invalid","failure","alert-document","document-error","document-alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L11 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sd-card-alert-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","problem","issue","notification","flag","important","attention","exception","sd-card","memory-card","storage","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7517 4.02183C11.5426 3.9999 11.3291 3.99995 11.0457 4.00001L10.0516 4.00001C9.11073 3.99999 8.33436 3.99998 7.70561 4.05976C7.05122 4.12198 6.45424 4.25594 5.91001 4.58945C5.37179 4.91927 4.91926 5.3718 4.58944 5.91002C4.25593 6.45425 4.12197 7.05123 4.05975 7.70562C3.99997 8.33436 3.99998 9.11073 4 10.0516V13.9484C3.99998 14.8893 3.99997 15.6657 4.05975 16.2944C4.12197 16.9488 4.25593 17.5458 4.58944 18.09C4.91926 18.6282 5.37179 19.0808 5.91001 19.4106C6.45424 19.7441 7.05122 19.878 7.70561 19.9403C8.33436 20 9.11074 20 10.0516 20H11.9484C12.8893 20 13.6656 20 14.2944 19.9403C14.9488 19.878 15.5458 19.7441 16.09 19.4106C16.6282 19.0808 17.0807 18.6282 17.4106 18.09C17.7441 17.5458 17.878 16.9488 17.9403 16.2944C18 15.6657 18 14.8893 18 13.9484L18 11.7805C18.0004 11.1162 18.0006 10.6136 17.8776 10.1278C17.808 9.85281 17.7092 9.58596 17.5831 9.33182C17.3604 8.88293 17.0331 8.50153 16.6005 7.99733L14.5595 5.61611C14.3751 5.40088 14.2362 5.23876 14.0834 5.09426C13.4451 4.49037 12.6256 4.11349 11.7517 4.02183ZM12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8L10 12C10 12.5523 10.4477 13 11 13C11.5523 13 12 12.5523 12 12V8ZM11 14C11.5523 14 12 14.4477 12 15V16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16V15C10 14.4477 10.4477 14 11 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sd-card-alert": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","notification","issue","problem","attention","document-alert","file-alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L11 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sd-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["sd-card","memory","storage","data","backup","export","import","settings","configuration","memory-card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V10.7C17 10.0072 17 9.66073 16.9242 9.33002C16.8811 9.1417 16.8198 8.95799 16.7414 8.78144C16.6036 8.47142 16.3957 8.19428 15.98 7.64001L15.98 7.64L15.53 7.04C14.9135 6.21805 14.6053 5.80708 14.2007 5.52865C13.9712 5.37069 13.7207 5.24547 13.4567 5.15662C12.9911 5 12.4774 5 11.45 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 11V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 11V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 11V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","lookup","inventory-search","customer-search","transaction-search","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.2427 15.2422L19 18.9995" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","magnify","lookup","inventory","customer","transaction","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.2427 15.2422L19 18.9995" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","magnifying-glass","lookup","scan","browse","search-products","find-item","search-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.5719 17.481 14.0239 16.6063 15.1921L19.7071 18.2929C20.0977 18.6835 20.0977 19.3166 19.7071 19.7071C19.3166 20.0977 18.6835 20.0977 18.2929 19.7071L15.1921 16.6063C14.0239 17.481 12.5719 18 11 18C7.13401 18 4 14.866 4 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","inventory-search","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2426 15.2426L19 19M15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","magnify","scan","lookup","inventory-search","customer-search","transaction-search","item-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19.0004L17.0005 17.001" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","lookup","item-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19.0004L17.0005 17.001" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","scan","magnify","search-items","search-products","search-customers","search-orders","search-transactions","search-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.9327 17.2154 14.6841 15.9497 15.9497C14.6841 17.2154 12.9327 18 11 18C7.13401 18 4 14.866 4 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.7076 16.2934C17.3171 15.9029 16.6839 15.9029 16.2934 16.2934C15.9029 16.6839 15.9029 17.3171 16.2934 17.7076L18.2929 19.7071C18.6834 20.0976 19.3165 20.0976 19.7071 19.7071C20.0976 19.3165 20.0976 18.6834 19.7071 18.2929L17.7076 16.2934Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","lookup","scan","item-lookup","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19.0004L17.0005 17.001" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 11C5 14.3137 7.68629 17 11 17C12.6569 17 14.1569 16.3284 15.2426 15.2426C16.3284 14.1569 17 12.6569 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","magnifier","lookup","inventory-search","customer-search","transaction-search","item-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.2427 16.2427L18 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 12C6 15.3137 8.68629 18 12 18C13.6569 18 15.1569 17.3284 16.2426 16.2426C17.3284 15.1569 18 13.6569 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","magnify","magnifying-glass","lookup","scan","search-item","find-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.2427 16.2427L18 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 12C6 15.3137 8.68629 18 12 18C13.6569 18 15.1569 17.3284 16.2426 16.2426C17.3284 15.1569 18 13.6569 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","inventory-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.5719 19 15.0239 18.481 16.1921 17.6063L17.2929 18.7071C17.6835 19.0977 18.3166 19.0977 18.7071 18.7071C19.0977 18.3166 19.0977 17.6835 18.7071 17.2929L17.6063 16.1921C18.481 15.0239 19 13.5719 19 12C19 8.13401 15.866 5 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","scan","inventory-search","customer-search","product-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 16.2426L18 18M16.2426 16.2426C17.3284 15.1569 18 13.6569 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C13.6569 18 15.1569 17.3284 16.2426 16.2426Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","lookup","magnify","item-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19.0004L16.9497 16.9502" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","lookup","magnify","item-search","product-search","customer-search","transaction-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C9.79086 16 8 14.2091 8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","customer-search","product-search","transaction-search","data-lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 14.7614 9.23858 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","lookup","magnify","item-search","customer-search","product-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19.0004L16.9497 16.9502" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","magnify","magnifier","query","inventory-search","customer-search","product-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","magnify","find","lookup","browse","cancel","clear","remove","delete","filter","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L11 12L9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L13 12L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","zoom","magnify","collapse","minimize","reduce","shrink","compress","inventory-search","product-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L11 12L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L13 12L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","magnify","filter","find","lookup","browse","scan","zoom","magnifier","locate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10L11 12L9 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L13 12L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnifier","find","lookup","browse","inventory-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C9.79086 16 8 14.2091 8 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","lookup","magnify","query","inventory-search","item-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C9.79086 16 8 14.2091 8 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","magnifying-glass","query","find-item","search-item","lookup","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM9.70711 9.29289C9.31658 8.90237 8.68342 8.90237 8.29289 9.29289C7.90237 9.68342 7.90237 10.3166 8.29289 10.7071L9.58579 12L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11.7071 12.7071C11.8946 12.5196 12 12.2652 12 12C12 12.2652 12.1054 12.5196 12.2929 12.7071L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929L14.4142 12L15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L12.2929 11.2929C12.1054 11.4804 12 11.7348 12 12C12 11.7348 11.8946 11.4804 11.7071 11.2929L9.70711 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-add-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","add","find","plus","item","add-item","scan","add-scan","find-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","add","find","plus","new-search","search-add","zoom","magnify","new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","add","plus","find","new","item","create-item","search-add"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 15C11.4477 15 11 14.5523 11 14V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13V14C13 14.5523 12.5523 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","add","magnifier","plus","find","new","item","lookup","add-item","search-add","increase","expand","zoom","scan-add","scan-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-aim-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","locate","target","aim","scan","lookup","inventory-search","customer-search","product-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12H16M8 12H9M12 9V8M12 16V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-aim-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","locate","scan","item-lookup","product-search","customer-search","transaction-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V8.12602C9.59439 8.4878 8.4878 9.59439 8.12602 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H8.12602C8.4878 14.4056 9.59439 15.5122 11 15.874V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.874C14.4056 15.5122 15.5122 14.4056 15.874 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H15.874C15.5122 9.59439 14.4056 8.4878 13 8.12602V8ZM14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-aim-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","locate","magnify","magnifying-glass","look-up","scan","browse","investigate","target","aim","focus","precision","accuracy","item-lookup","customer-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12H16M8 12H9M12 9V8M12 16V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-by-image-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["image-search","search","scan","image","product-search","find-product","identify","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L14.5 14.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-by-image-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","magnify","scan","identify","lookup","query","search-item","find-item","image-search","find-by-image"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L14.5 14.5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-aim": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","target","locate","lookup","scan","magnify","magnifying-glass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12H16M8 12H9M12 9V8M12 16V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-by-image-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","image","scan","identify","product-lookup","item-search","visual-search","camera-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.93417 4L10 4C10.5523 4 11 4.44772 11 5C11 5.55229 10.5523 6 10 6H9C8.02893 6 7.40122 6.00213 6.93871 6.06431C6.50497 6.12263 6.36902 6.21677 6.2929 6.2929C6.21677 6.36902 6.12263 6.50497 6.06431 6.93871C6.00213 7.40122 6 8.02893 6 9V10C6 10.5523 5.55229 11 5 11C4.44772 11 4 10.5523 4 10L4 8.93417C3.99995 8.04769 3.99991 7.28387 4.08215 6.67221C4.17028 6.0167 4.36902 5.38835 4.87868 4.87868C5.38835 4.36902 6.0167 4.17028 6.67221 4.08215C7.28387 3.99991 8.04769 3.99995 8.93417 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.0613 6.06431C16.5988 6.00213 15.9711 6 15 6H14C13.4477 6 13 5.55229 13 5C13 4.44772 13.4477 4 14 4L15.0658 4C15.9523 3.99995 16.7161 3.99991 17.3278 4.08215C17.9833 4.17028 18.6117 4.36902 19.1213 4.87868C19.631 5.38835 19.8297 6.0167 19.9179 6.67221C20.0001 7.28382 20.0001 8.04755 20 8.93394L20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V9C18 8.02893 17.9979 7.40122 17.9357 6.93871C17.8774 6.50497 17.7832 6.36902 17.7071 6.2929C17.631 6.21677 17.495 6.12263 17.0613 6.06431Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 14C20 13.4477 19.5523 13 19 13C18.4477 13 18 13.4477 18 14V15C18 15.9711 17.9979 16.5988 17.9357 17.0613C17.8774 17.495 17.7832 17.631 17.7071 17.7071C17.631 17.7832 17.495 17.8774 17.0613 17.9357C16.5988 17.9979 15.9711 18 15 18H14C13.4477 18 13 18.4477 13 19C13 19.5523 13.4477 20 14 20L15.0658 20C15.9523 20.0001 16.7161 20.0001 17.3278 19.9179C17.9833 19.8297 18.6117 19.631 19.1213 19.1213C19.631 18.6117 19.8297 17.9833 19.9179 17.3278C20.0001 16.7161 20.0001 15.9523 20 15.0658L20 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 13C5.55229 13 6 13.4477 6 14L6.00001 15C6.00001 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9.00001 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20L8.93417 20C8.04769 20.0001 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 14C4 13.4477 4.44772 13 5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 12.7418 15.7981 13.4365 15.4462 14.032L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L14.032 15.4462C13.4365 15.7981 12.7418 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-cancel-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","cancel","clear","delete","remove","find","void","search-cancel","find-cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10M10 10L14 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-by-image": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","scan","lookup","identify","image","product-search","item-search","visual-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10V9C5 7.11438 5 6.17157 5.58579 5.58579C6.17157 5 7.11438 5 9 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 14L19 15C19 16.8856 19 17.8284 18.4142 18.4142C17.8284 19 16.8856 19 15 19L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 14L5 15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 15L14.5 14.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-cancel-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","cancel","clear","delete","remove","find","search-cancel","clear-search","delete-search","remove-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10M10 10L14 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-cancel-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","cancel","delete","remove","clear","find","erase","magnify-cancel","search-remove","search-delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L10.5858 12L9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L12 13.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13.4142 12L14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L12 10.5858L10.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-cancel": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","cancel","clear","remove","delete","magnify","magnifying-glass","find","discard","void","refund","erase","item-search","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10M10 10L14 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","check","validate","confirm","find","verify","approved","inventory-check","order-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-check-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","check","validate","confirm","find","approve","magnify","verified","accepted","item-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","check","checkmark","magnifier","validate","confirm","inventory-check","price-check","order-confirmation","payment-received","transaction-complete","item-found","approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L11 11.5858L10.7071 11.2929C10.3166 10.9024 9.68342 10.9024 9.29289 11.2929C8.90237 11.6834 8.90237 12.3166 9.29289 12.7071L10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L14.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","check","inventory-check","verify","validated","confirm","find","complete","lookup","item-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 12L11 13L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-discount-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","discount","promotion","sale","find-discount","magnify","percentage","search-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-discount-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","discount","percentage","sale","promotion","find-discount","lookup-discount","coupon","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-discount-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","percentage","search-discount","promotion","sale","offer","reduced price","loyalty program","coupon","special offer","search","find discount","apply discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM8.4846 9.12509C8.96781 8.28815 10.038 8.0014 10.8749 8.4846C11.7119 8.96781 11.9986 10.038 11.5154 10.8749C11.0322 11.7119 9.96202 11.9986 9.12509 11.5154C8.28815 11.0322 8.0014 9.96202 8.4846 9.12509ZM14.5303 9.46967C14.8232 9.76257 14.8232 10.2374 14.5303 10.5303L10.5303 14.5303C10.2374 14.8232 9.76257 14.8232 9.46967 14.5303C9.17678 14.2374 9.17678 13.7626 9.46967 13.4697L13.4697 9.46967C13.7626 9.17678 14.2374 9.17678 14.5303 9.46967ZM14.8749 12.4846C14.038 12.0014 12.9678 12.2882 12.4846 13.1251C12.0014 13.962 12.2882 15.0322 13.1251 15.5154C13.962 15.9986 15.0322 15.7119 15.5154 14.8749C15.9986 14.038 15.7119 12.9678 14.8749 12.4846Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-discount": {
        defaultColors: ["#3D4C66"],
        keywords: ["discount","search-discount","percentage","promotion","sale","find-discount","apply-discount","coupon","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.4999 9.13412C10.9781 9.41022 11.142 10.0217 10.8659 10.4999C10.5898 10.9781 9.9783 11.142 9.50008 10.8659C9.02187 10.5898 8.85802 9.9783 9.13412 9.50008C9.41022 9.02187 10.0217 8.85802 10.4999 9.13412Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.4999 13.1341C14.9781 13.4102 15.142 14.0217 14.8659 14.4999C14.5898 14.9781 13.9783 15.142 13.5001 14.8659C13.0219 14.5898 12.858 13.9783 13.1341 13.5001C13.4102 13.0219 14.0217 12.858 14.4999 13.1341Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-energy-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","lightning","bolt","fast","quick","energy","power","find","instant","lookup","search-energy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.0025 15L14 12H10L12.0025 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-energy-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","lightning","bolt","fast","find","scan","quick-search","energy","electricity","instant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.0025 15L14 12H10L12.0025 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-energy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["lightning","bolt","energy","flash","quick","fast","search","find","electric","power","scan","instant","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12.8342 9.55528C13.1408 9.09592 13.017 8.47498 12.5576 8.16837C12.0983 7.86176 11.4773 7.98558 11.1707 8.44493L9.16827 11.4449C8.96346 11.7518 8.94422 12.1464 9.11819 12.4717C9.29217 12.797 9.6311 13.0001 10 13.0001H12.1328L11.1701 14.4459C10.864 14.9056 10.9885 15.5264 11.4482 15.8325C11.9079 16.1386 12.5287 16.014 12.8348 15.5543L14.8324 12.5543C15.0367 12.2474 15.0556 11.853 14.8815 11.528C14.7075 11.203 14.3687 11.0001 14 11.0001H11.8698L12.8342 9.55528Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-energy": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","lightning","bolt","energy","fast-search","quick-find","instant","find","magnify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.0025 15L14 12H10L12.0025 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-equal-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","equal","comparison","price-matching","find","magnify","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L14 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-equal-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","equal","match","find","inventory","item-lookup","price-match","comparison"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-equal-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["query","question","comparison","equal","price-comparison","product-comparison","customer-inquiry","help","support","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7071 19.7071C20.0976 19.3165 20.0976 18.6834 19.7071 18.2929L18.3198 16.9056C19.3723 15.5513 20 13.8483 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.8483 20 15.5513 19.3723 16.9056 18.3198L18.2929 19.7071C18.6834 20.0976 19.3165 20.0976 19.7071 19.7071ZM14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9H10C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H14ZM14 15C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H10C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-equal": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","equal","compare","match","find","lookup","filter","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14L14 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-explore-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","inventory-search","customer-search","product-search","lookup","item-lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 14.2091 10 12C10 9.91993 10.7939 8.2107 11.8087 8.01807C11.8716 8.00611 11.9355 8 12 8M12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-explore-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","explore","browse","globe","inventory-search","item-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75 12C8.75 11.2017 9.03785 10.4706 9.51543 9.9048C9.34329 10.5417 9.25 11.2555 9.25 12C9.25 12.7435 9.34306 13.4575 9.51542 14.0952C9.03785 13.5294 8.75 12.7983 8.75 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.9485 8.75491C11.9661 8.75158 11.9831 8.75 12 8.75C12.0169 8.75 12.0339 8.75158 12.0515 8.75491C12.1972 8.78258 12.5035 8.97753 12.7942 9.61315C13.067 10.2098 13.25 11.0474 13.25 12C13.25 13.0134 13.043 13.8937 12.7434 14.493C12.4213 15.1371 12.1152 15.25 12 15.25C11.8848 15.25 11.5787 15.1371 11.2566 14.493C10.957 13.8937 10.75 13.0134 10.75 12C10.75 11.0474 10.933 10.2098 11.2058 9.61315C11.4965 8.97753 11.8028 8.78258 11.9485 8.75491Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.75 12C14.75 12.7435 14.6569 13.4575 14.4846 14.0952C14.9622 13.5294 15.25 12.7983 15.25 12C15.25 11.2017 14.9621 10.4705 14.4846 9.9048C14.6567 10.5417 14.75 11.2555 14.75 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM7.25 12C7.25 9.37665 9.37665 7.25 12 7.25C14.6234 7.25 16.75 9.37665 16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-explore-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","lookup","inventory","product-search","customer-search","explore","browse","magnify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 14.2091 10 12C10 9.91993 10.7939 8.2107 11.8087 8.01807C11.8716 8.00611 11.9355 8 12 8M12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-explore-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","locate","item-lookup","product-search","inventory","compass","navigation","explore","discovery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 14L11 11L14 10L13 13L10 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-explore-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","magnify","magnifier","explore","compass","inventory-lookup","item-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 14L11 11L14 10L13 13L10 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-explore-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","lookup","explore","magnify","magnifier","scan","browse","inventory-search","customer-search","product-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 14L11 11L14 10L13 13L10 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-explore-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","explore","lookup","inventory-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5812 12.4189L11.7906 11.7906L12.4189 11.5812L12.2095 12.2095L11.5812 12.4189Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM14.9487 10.3163C15.0685 9.95692 14.975 9.56075 14.7071 9.29292C14.4393 9.02509 14.0431 8.93157 13.6838 9.05134L10.6838 10.0513C10.3852 10.1509 10.1509 10.3852 10.0513 10.6838L9.05134 13.6838C8.93157 14.0431 9.02509 14.4393 9.29292 14.7071C9.56075 14.975 9.95692 15.0685 10.3163 14.9487L13.3163 13.9487C13.6149 13.8492 13.8492 13.6149 13.9487 13.3163L14.9487 10.3163Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-explore": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","magnify","magnifying-glass","inventory","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 14.2091 10 12C10 9.91993 10.7939 8.2107 11.8087 8.01807C11.8716 8.00611 11.9355 8 12 8M12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-eye-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","eye","find","lookup","scan","magnify","discover","inspect","research","magnifying-glass","search-items","inventory-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse cx="12" cy="12" rx="4" ry="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "search-eye-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","lookup","inventory","item","scan","magnify","magnifier","product-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="12"
                    cy="12"
                    rx="4"
                    ry="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="1" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
            </svg>
        )
    },
    "search-eye-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","look-up","magnify","eye","search-item","browse","scan","research"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 8C10.7 8 9.48455 8.39395 8.57157 9.07868C7.65829 9.76364 7 10.7862 7 12C7 13.2138 7.65829 14.2364 8.57157 14.9213C9.48455 15.6061 10.7 16 12 16C13.3 16 14.5155 15.6061 15.4284 14.9213C16.3417 14.2364 17 13.2138 17 12C17 10.7862 16.3417 9.76364 15.4284 9.07868C14.5155 8.39395 13.3 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-eye": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","look-up","magnify","magnifying-glass","inventory-search","customer-search","transaction-search","product-search","order-search","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse cx="12" cy="12" rx="4" ry="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "search-growth-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["growth","statistics","arrow","graph","analysis","sales","increase","profit","analytics","trending","trend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0005 7L12.0005 13L10.0005 10L5.6001 14.5M18.0005 7H15.0005M18.0005 7V10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19L16.9497 16.9497M19 12C19 13.933 18.2165 15.683 16.9497 16.9497M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-growth-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["growth","arrow","trend","increase","sales","profit","analytics","statistics","performance","metrics","charts","reports","charts","graphs","search","optimization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.0005 7L12.0005 13L10.0005 10L5.6001 14.5M18.0005 7H15.0005M18.0005 7V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19L16.9497 16.9497M19 12C19 13.933 18.2165 15.683 16.9497 16.9497M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-growth": {
        defaultColors: ["#3D4C66"],
        keywords: ["growth","sales","trend","arrow-up","increase","analytics","charts","statistics","performance","metrics","reports","rising","improvement","profits","revenue","diagram"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M19 12C19 13.933 18.2165 15.683 16.9497 16.9497M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.0005 7L12.0005 13L10.0005 10L5.6001 14.5M18.0005 7H15.0005M18.0005 7V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","heart","favorites","customers","loyalty","customer-search","find-customer","favorite-products","search-favorites","customer-loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L9.44877 12.7065C8.82381 12.0427 8.8552 11.0338 9.52037 10.4058C10.5 9.66477 11.1429 10.0143 12 10.8455C12.8572 10.0143 13.5 9.66473 14.4796 10.4057C15.1448 11.0338 15.1762 12.0426 14.5512 12.7065L12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-growth-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["growth","trend","arrow","increase","sales","analytics","metrics","charts","statistics","performance","revenue","profit","data","insights","improvement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.8483 20 15.5513 19.3723 16.9056 18.3198L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L18.3198 16.9056C19.3723 15.5513 20 13.8483 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 13.6571 17.3295 15.1558 16.2426 16.2426C15.1558 17.3295 13.6571 18 12 18C9.70111 18 7.70418 16.7071 6.69668 14.8088L9.85272 11.5813L11.1683 13.5547C11.3345 13.804 11.6037 13.9656 11.9018 13.9951C12.2 14.0247 12.4956 13.919 12.7075 13.7071L17.0004 9.41421V10C17.0004 10.5523 17.4481 11 18.0004 11C18.5527 11 19.0004 10.5523 19.0004 10V7C19.0004 6.44772 18.5527 6 18.0004 6H15.0004C14.4481 6 14.0004 6.44772 14.0004 7C14.0004 7.55228 14.4481 8 15.0004 8H15.5862L12.1558 11.4304L10.8324 9.4453C10.6651 9.19439 10.3936 9.03237 10.0933 9.00433C9.79309 8.9763 9.49622 9.08525 9.28539 9.30085L6.03242 12.6275C6.01098 12.4212 6 12.2119 6 12C6 8.68629 8.68629 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-heart-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","heart","favorites","customer-loyalty","loyalty","find-favorite","customer","find","search-favorites"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L9.44877 12.7065C8.82381 12.0427 8.8552 11.0338 9.52037 10.4058C10.5 9.66477 11.1429 10.0143 12 10.8455C12.8572 10.0143 13.5 9.66473 14.4796 10.4057C15.1448 11.0338 15.1762 12.0426 14.5512 12.7065L12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","heart","favorite","find","customer","loyalty","rewards","customer-search","favorite-item","search-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15L9.44877 12.7065C8.82381 12.0427 8.8552 11.0338 9.52037 10.4058C10.5 9.66477 11.1429 10.0143 12 10.8455C12.8572 10.0143 13.5 9.66473 14.4796 10.4057C15.1448 11.0338 15.1762 12.0426 14.5512 12.7065L12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","heart","favorite","find","loyalty","customer","rewards","preferred","search-heart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12.9488 9.06661C13.726 8.87015 14.4392 9.12135 15.0829 9.60826C15.1119 9.63022 15.1397 9.65374 15.1662 9.67872C16.2302 10.6834 16.2847 12.3241 15.2794 13.392C15.2603 13.4122 15.2405 13.4317 15.2198 13.4502L12.6686 15.7438C12.2884 16.0855 11.7117 16.0855 11.3315 15.7438L8.78025 13.4503C8.75959 13.4317 8.73971 13.4123 8.72066 13.3921C7.71537 12.3242 7.76985 10.6834 8.83385 9.67876C8.8603 9.65378 8.88811 9.63026 8.91713 9.6083C9.56085 9.1214 10.274 8.87019 11.0512 9.06662C11.4021 9.15532 11.7175 9.32668 12 9.5296C12.2826 9.32668 12.5979 9.15532 12.9488 9.06661Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-info-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","info","information","details","magnify","magnifying-glass","help","question","support","find-info","lookup","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-info-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["info","information","search","details","question","help","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-info-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","question","support","faq","search-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V9ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13C13 12.4477 12.5523 12 12 12H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-line-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnifier","analytics","data","reports","statistics","find","lookup","query","filter","insights","graph","diagram"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 9C12.5523 9 13 9.44772 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10C11 9.44772 11.4477 9 12 9ZM9 11C9.55228 11 10 11.4477 10 12V14C10 14.5523 9.55229 15 9 15C8.44772 15 8 14.5523 8 14V12C8 11.4477 8.44772 11 9 11ZM16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-info": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","support","faq","question","product-info","order-info","customer-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15V12H11M12 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","analytics","reports","magnifier","analysis","data","statistics","sales-data","search-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","magnifier","lines","filter","options","lookup","inventory-search","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","query","lookup","information","details","inquiry","scan","barcode","magnify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM9 9C9.55228 9 10 9.44772 10 10V14C10 14.5523 9.55229 15 9 15C8.44772 15 8 14.5523 8 14V10C8 9.44772 8.44772 9 9 9ZM12 9C12.5523 9 13 9.44772 13 10V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V10C11 9.44772 11.4477 9 12 9ZM16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","lookup","filter","magnify","query","barcode","SKU","item-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","analysis","analytics","reports","charts","statistics","data","insights","trends","sales-analysis","performance","monitoring","find","investigate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","analysis","analytics","report","magnifier","bar-chart","stats","insights","data","metrics","trending","trends","search-stats","search-analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","statistics","analytics","sales-data","reporting","insights","metrics","trends","performance","analysis","data-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","statistics","reports","analysis","inventory","lookup","magnify","find","sales-data","search-analytics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","analysis","analytics","graph","statistics","report","find","lookup","trends","sales-analysis","revenue-analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-line-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","analytics","chart","report","analysis","lookup","metrics","sales-data","statistics","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM9 9C9.55228 9 10 9.44772 10 10V14C10 14.5523 9.55229 15 9 15C8.44772 15 8 14.5523 8 14V10C8 9.44772 8.44772 9 9 9ZM12 11C12.5523 11 13 11.4477 13 12V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V12C11 11.4477 11.4477 11 12 11ZM16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","magnify","query","filter","inventory-search","customer-search","transaction-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14L9 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-location-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","location","find-location","find","map-pin","pin","customer-location","customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 12.3885 9.38625 13.1868 10 13.7361L12 15.5L14.0767 13.665C14.6458 13.119 15 12.3509 15 11.5C15 9.84315 13.6569 8.5 12 8.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-location-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","location","find","customer","address","map","lookup","geolocate","track"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 12.3885 9.38625 13.1868 10 13.7361L12 15.5L14.0767 13.665C14.6458 13.119 15 12.3509 15 11.5C15 9.84315 13.6569 8.5 12 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-location-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["location","search","find","map","gps","locate","store-locator","customer-location","delivery-address","pickup-location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 12.5608 13.7705 13.0663 13.3977 13.4306L11.9994 14.6661L10.6645 13.4888C10.2551 13.1212 10 12.5911 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 8C9.79086 8 8 9.79086 8 12C8 13.1848 8.51633 14.2503 9.33307 14.9813L12.0006 17L14.7543 14.9008L14.7691 14.8866C15.5265 14.1598 16 13.1344 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-magnify-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","magnify","lookup","scan","search-item","find-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-location": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","location","find","customer-location","track-order","store-locator","map","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 12.3885 9.38625 13.1868 10 13.7361L12 15.5L14.0767 13.665C14.6458 13.119 15 12.3509 15 11.5C15 9.84315 13.6569 8.5 12 8.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "search-magnify-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","magnify","find","lookup","inventory","customer","order","transaction","item","product","scan","browse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-magnify-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","lookup","scan","item-search","product-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 7C9.23858 7 7 9.23858 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 10.3431 10.3431 9 12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-magnify-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","lookup","inventory","customer","transaction","product","scan","search-item","search-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3245 16.966L18.8699 17.5625L18.8752 17.5665L19.3245 16.966ZM16.966 19.3245L17.5665 18.8751L17.5624 18.8698L16.966 19.3245ZM19.5065 19.5065L20.0368 20.0368L19.5065 19.5065ZM11 17.25C7.54822 17.25 4.75 14.4518 4.75 11H3.25C3.25 15.2802 6.71979 18.75 11 18.75V17.25ZM11 4.75C14.4518 4.75 17.25 7.54822 17.25 11H18.75C18.75 6.71979 15.2802 3.25 11 3.25V4.75ZM11 3.25C6.71979 3.25 3.25 6.71979 3.25 11H4.75C4.75 7.54822 7.54822 4.75 11 4.75V3.25ZM15.4194 15.4194C15.1584 15.6805 14.8744 15.9185 14.5709 16.1302L15.429 17.3605C15.8052 17.0981 16.1569 16.8033 16.4801 16.4801L15.4194 15.4194ZM14.5709 16.1302C13.5588 16.8361 12.3289 17.25 11 17.25V18.75C12.6456 18.75 14.1734 18.2363 15.429 17.3605L14.5709 16.1302ZM17.25 11C17.25 12.329 16.8361 13.5588 16.1301 14.5709L17.3604 15.4291C18.2363 14.1734 18.75 12.6457 18.75 11H17.25ZM16.1301 14.5709C15.9184 14.8744 15.6804 15.1585 15.4194 15.4194L16.4801 16.4801C16.8033 16.1569 17.0981 15.8051 17.3604 15.4291L16.1301 14.5709ZM19.7792 16.3696L17.1999 14.4035L16.2906 15.5965L18.8699 17.5625L19.7792 16.3696ZM17.5624 18.8698L15.5964 16.2907L14.4035 17.2L16.3695 19.7792L17.5624 18.8698ZM16.3655 19.7738C17.2539 20.9611 18.9882 21.0853 20.0368 20.0368L18.9761 18.9761C18.5735 19.3787 17.9076 19.331 17.5664 18.8752L16.3655 19.7738ZM18.8752 17.5665C19.331 17.9076 19.3787 18.5735 18.9761 18.9761L20.0368 20.0368C21.0853 18.9883 20.9611 17.254 19.7739 16.3656L18.8752 17.5665Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 15C8.79086 15 7 13.2091 7 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-magnify-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","magnify","find","lookup","inventory","customer","product","transaction","scan","browse","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.3245 16.966L18.8699 17.5625L18.8752 17.5665L19.3245 16.966ZM16.966 19.3245L17.5665 18.8751L17.5624 18.8698L16.966 19.3245ZM19.5065 19.5065L20.0368 20.0368L19.5065 19.5065ZM11 17.25C7.54822 17.25 4.75 14.4518 4.75 11H3.25C3.25 15.2802 6.71979 18.75 11 18.75V17.25ZM11 4.75C14.4518 4.75 17.25 7.54822 17.25 11H18.75C18.75 6.71979 15.2802 3.25 11 3.25V4.75ZM11 3.25C6.71979 3.25 3.25 6.71979 3.25 11H4.75C4.75 7.54822 7.54822 4.75 11 4.75V3.25ZM15.4194 15.4194C15.1584 15.6805 14.8744 15.9185 14.5709 16.1302L15.429 17.3605C15.8052 17.0981 16.1569 16.8033 16.4801 16.4801L15.4194 15.4194ZM14.5709 16.1302C13.5588 16.8361 12.3289 17.25 11 17.25V18.75C12.6456 18.75 14.1734 18.2363 15.429 17.3605L14.5709 16.1302ZM17.25 11C17.25 12.329 16.8361 13.5588 16.1301 14.5709L17.3604 15.4291C18.2363 14.1734 18.75 12.6457 18.75 11H17.25ZM16.1301 14.5709C15.9184 14.8744 15.6804 15.1585 15.4194 15.4194L16.4801 16.4801C16.8033 16.1569 17.0981 15.8051 17.3604 15.4291L16.1301 14.5709ZM19.7792 16.3696L17.1999 14.4035L16.2906 15.5965L18.8699 17.5625L19.7792 16.3696ZM17.5624 18.8698L15.5964 16.2907L14.4035 17.2L16.3695 19.7792L17.5624 18.8698ZM16.3655 19.7738C17.2539 20.9611 18.9882 21.0853 20.0368 20.0368L18.9761 18.9761C18.5735 19.3787 17.9076 19.331 17.5664 18.8752L16.3655 19.7738ZM18.8752 17.5665C19.331 17.9076 19.3787 18.5735 18.9761 18.9761L20.0368 20.0368C21.0853 18.9883 20.9611 17.254 19.7739 16.3656L18.8752 17.5665Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 15C8.79086 15 7 13.2091 7 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-magnify-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","magnify","find","lookup","inventory","customers","transactions","products","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.7319 15.752L19.3246 16.966C20.1461 17.5808 20.2321 18.7809 19.5065 19.5065C18.7809 20.232 17.5808 20.1461 16.966 19.3245L15.7521 17.732C15.342 17.1939 15.4714 16.4281 15.9498 15.9497C16.4281 15.4714 17.1939 15.3419 17.7319 15.752Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.3246 16.966L18.8699 17.5625L18.8752 17.5665L19.3246 16.966ZM17.7319 15.752L18.1865 15.1555L18.1865 15.1555L17.7319 15.752ZM16.966 19.3245L17.5665 18.8751L17.5625 18.8698L16.966 19.3245ZM15.7521 17.732L16.3485 17.2773L15.7521 17.732ZM19.5065 19.5065L20.0368 20.0368L20.0368 20.0368L19.5065 19.5065ZM15.9498 15.9497L15.4195 15.4194L15.4195 15.4194L15.9498 15.9497ZM19.7792 16.3696L18.1865 15.1555L17.2772 16.3485L18.8699 17.5625L19.7792 16.3696ZM17.5625 18.8698L16.3485 17.2773L15.1556 18.1866L16.3695 19.7792L17.5625 18.8698ZM16.3655 19.7738C17.2539 20.9611 18.9883 21.0853 20.0368 20.0368L18.9762 18.9761C18.5736 19.3787 17.9076 19.331 17.5665 18.8752L16.3655 19.7738ZM18.8752 17.5665C19.3311 17.9076 19.3788 18.5735 18.9762 18.9761L20.0368 20.0368C21.0854 18.9883 20.9612 17.254 19.7739 16.3655L18.8752 17.5665ZM16.4801 16.4801C16.7519 16.2083 17.0997 16.2131 17.2772 16.3485L18.1865 15.1555C17.2881 14.4707 16.1044 14.7345 15.4195 15.4194L16.4801 16.4801ZM15.4195 15.4194C14.7345 16.1044 14.4707 17.2882 15.1556 18.1866L16.3485 17.2773C16.2132 17.0997 16.2083 16.7519 16.4801 16.4801L15.4195 15.4194Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 11C4 14.866 7.13401 18 11 18C12.933 18 14.683 17.2165 15.9497 15.9497C17.2165 14.683 18 12.933 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 15C8.79086 15 7 13.2091 7 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-magnify": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","lookup","scan","inventory-search","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 9.79086 9.79086 8 12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","remove","zoom-out","magnify","magnifier","minus","decrease","reduce","discount","find-less","remove-item","decrease-quantity","reduce-price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-minus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","minus","remove","zoom-out","decrease","quantity","reduction","filter-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","minus","remove","decrease","quantity","discount","reduce","remove-item","search-minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-magnify-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","lookup","inventory","customer","transaction","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.364 18.6581 13.6489 18.056 14.7728C18.1521 14.8256 18.2463 14.8868 18.3381 14.9567L19.9276 16.1684C21.2331 17.1489 21.3686 19.0586 20.2136 20.2136C19.0585 21.3686 17.1488 21.2331 16.1683 19.9276L14.9567 18.3382C14.8868 18.2464 14.8256 18.1521 14.7728 18.056C13.6488 18.6582 12.364 19 11 19C6.58172 19 3 15.4183 3 11ZM8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11C6 13.7614 8.23858 16 11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14C9.34315 14 8 12.6569 8 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","minus","zoom-out","remove","decrease","reduce","quantity","discount","adjustment","item-removal","shrink","deduct","subtract","search-minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M10 12H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-money-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","money","dollar","find","price","search-money","revenue","earnings","find-price","financial-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.5 13.5C10.5 14.3284 11.1716 15 12 15M12 12C12.8284 12 13.5 12.6716 13.5 13.5C13.5 14.3284 12.8284 15 12 15M12 15L12 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.5 10.5C13.5 9.67157 12.8284 9 12 9M12 12C11.1716 12 10.5 11.3284 10.5 10.5C10.5 9.67157 11.1716 9 12 9M12 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-money-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","money","find","dollar","payment","transaction","lookup","price","finance","magnify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11V11C11 11.5523 11.4477 12 12 12V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-money-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","money","dollar","find","price","cost","lookup","search-price","find-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V8.37803C13.6239 8.68691 14.25 9.52034 14.25 10.5C14.25 10.9142 13.9142 11.25 13.5 11.25C13.0858 11.25 12.75 10.9142 12.75 10.5C12.75 10.0858 12.4142 9.75 12 9.75C11.5858 9.75 11.25 10.0858 11.25 10.5C11.25 10.9142 11.5858 11.25 12 11.25L12.0024 11.25C13.244 11.2513 14.25 12.2582 14.25 13.5C14.25 14.4797 13.6239 15.3131 12.75 15.622V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V15.622C10.3761 15.3131 9.75 14.4797 9.75 13.5C9.75 13.0858 10.0858 12.75 10.5 12.75C10.9142 12.75 11.25 13.0858 11.25 13.5C11.25 13.9142 11.5858 14.25 12 14.25C12.4142 14.25 12.75 13.9142 12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75C10.7574 12.75 9.75 11.7426 9.75 10.5C9.75 9.52034 10.3761 8.68691 11.25 8.37803V8C11.25 7.58579 11.5858 7.25 12 7.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-money": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","money","dollar","magnify","find","price","search-money","view","details","cost","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11V11C11 11.5523 11.4477 12 12 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-music-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","search","find","song","audio","entertainment","jukebox","playlist","background-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-music-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["music","search","find","song","entertainment","audio","lookup","browse-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 13.5V9V13.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 15C10.6664 14.9825 10 14.3161 10 13.5C10 12.6839 10.6664 12.0175 11.5 12C12.3336 12.0175 13 12.6839 13 13.5C13 14.3161 12.3336 14.9825 11.5 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-music-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","song","entertainment","background-music","queue","now-playing","playlist","ambiance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM13.7071 8.29292C13.4211 8.00692 12.991 7.92137 12.6173 8.07615C12.2436 8.23093 12 8.59557 12 9.00003V11.0555C11.8448 11.0226 11.6846 11.0037 11.521 11.0002C11.507 11 11.493 11 11.479 11.0002C10.1211 11.0288 9 12.1204 9 13.5C9 14.8797 10.1211 15.9713 11.479 15.9998C11.493 16.0001 11.507 16.0001 11.521 15.9998C12.8789 15.9713 14 14.8797 14 13.5V11C14.2559 11 14.5118 10.9024 14.7071 10.7071C15.0976 10.3166 15.0976 9.68345 14.7071 9.29292L13.7071 8.29292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-music": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","search","audio","song","entertainment","background-music","playlist","select-music","search-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-numbers-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","find","lookup","order-id","transaction-id","customer-id","product-id","invoice-id","query","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.5V11.5C12 10.6716 11.3284 10 10.5 10C9.67157 10 9 10.6716 9 11.5V12.5C9 13.3284 9.67157 14 10.5 14C11.3284 14 12 13.3284 12 12.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-numbers-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","support","help","feedback","question","inquiry","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3165 19.7071 19.7071C19.3165 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM10.5 9C9.11929 9 8 10.1193 8 11.5V12.5C8 13.8807 9.11929 15 10.5 15C11.8807 15 13 13.8807 13 12.5V11.5C13 10.1193 11.8807 9 10.5 9ZM10 11.5C10 11.2239 10.2239 11 10.5 11C10.7761 11 11 11.2239 11 11.5V12.5C11 12.7761 10.7761 13 10.5 13C10.2239 13 10 12.7761 10 12.5V11.5ZM16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-numbers": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","lookup","find","id","number","order-id","customer-id","product-id","invoice-id","transaction-id"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.5V11.5C12 10.6716 11.3284 10 10.5 10C9.67157 10 9 10.6716 9 11.5V12.5C9 13.3284 9.67157 14 10.5 14C11.3284 14 12 13.3284 12 12.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-question-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","question","help","find","query","support","assistance","faq","information","lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-question-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","question","help","find","query","support","faq","lookup","assistance","information","details","investigate","examine","scan","explore","unknown","clarification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-numbers-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","lookup","number","id","item-id","transaction-id","customer-id","invoice-id","product-id"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12.5V11.5C12 10.6716 11.3284 10 10.5 10C9.67157 10 9 10.6716 9 11.5V12.5C9 13.3284 9.67157 14 10.5 14C11.3284 14 12 13.3284 12 12.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-question-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","search","query","information","assistance","unknown","resolve"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.8483 20 15.5513 19.3723 16.9056 18.3198L18.2929 19.7071C18.6834 20.0976 19.3165 20.0976 19.7071 19.7071C20.0976 19.3165 20.0976 18.6834 19.7071 18.2929L18.3198 16.9056C19.3723 15.5513 20 13.8483 20 12C20 7.58172 16.4183 4 12 4ZM12 9C11.4477 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.3062 14.1652 12.4175 13 12.8293V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9ZM13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-question": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","question","help","faq","support","find","query","unknown","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","lookup","query","magnify","magnifier","search-item","search-product","search-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9497 16.9497L18.9497 18.9497"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.9497 16.9497C15.683 18.2165 13.933 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 13.0736 18.7583 14.0907 18.3264 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["search","find","lookup","magnify","query","search-item","search-product","customer-lookup","transaction-lookup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M18.9497 18.9497L16.9497 16.9497C15.683 18.2165 13.933 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 13.0736 18.7583 14.0907 18.3264 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","query","customer-search","item-search","transaction-search","quote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C13.6571 18 15.1558 17.3295 16.2426 16.2426C16.6332 15.8521 17.2663 15.8521 17.6569 16.2426L19.6569 18.2426C20.0474 18.6332 20.0474 19.2663 19.6569 19.6569C19.2663 20.0474 18.6332 20.0474 18.2426 19.6569L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 12.691 19.9122 13.3629 19.7465 14.0046C19.6085 14.5394 19.0631 14.861 18.5283 14.7229C17.9936 14.5849 17.672 14.0395 17.81 13.5047C17.9338 13.0249 18 12.5209 18 12C18 8.68629 15.3137 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-quote-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","lookup","magnify","inventory-search","customer-search","transaction-search","item-search","product-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2426 14.2426C15.3284 13.1569 16 11.6569 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C11.6569 16 13.1569 15.3284 14.2426 14.2426ZM14.2426 14.2426L20 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","find","magnify","lookup","inventory-search","product-search","customer-search","transaction-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2427 14.2427L20 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 10C4 13.3137 6.68629 16 10 16C11.6569 16 13.1569 15.3284 14.2426 14.2426C15.3284 13.1569 16 11.6569 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","find","magnify","lookup","inventory","product","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2427 14.2427L20 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "search-quote": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnify","find","lookup","query","quote","message","comment","review","feedback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9497 18.9497L16.9497 16.9497C15.683 18.2165 13.933 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 13.0736 18.7583 14.0907 18.3264 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-seo-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","seo","analytics","statistics","trend","growth","magnifier","arrow-up","sales","find","explore","research","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 10L12 14L11 12L9 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H15V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-quote-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","magnifier","find","lookup","scan","browse","item-search","product-search","customer-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C11.5723 17 13.0236 16.4816 14.1922 15.6064L19.2929 20.7071C19.6835 21.0977 20.3166 21.0977 20.7071 20.7071C21.0977 20.3166 21.0977 19.6835 20.7071 19.2929L15.6064 14.1922C16.4816 13.0236 17 11.5723 17 10C17 6.13401 13.866 3 10 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-seo-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["search","find","magnify","seo","lookup","item-search","customer-search","transaction-search","product-search","inventory-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569C19.1046 16.2091 20 14.2091 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11L11 13C11 13.5523 11.4477 14 12 14H13M13 12H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10H8C7.44772 10 7 10.4477 7 11V11C7 11.5523 7.44772 12 8 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14H8C8.55228 14 9 13.5523 9 13V13C9 12.4477 8.55228 12 8 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 11V13C15 13.5523 15.4477 14 16 14C16.5523 14 17 13.5523 17 13L17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 20L19 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-seo-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","seo","analysis","optimization","find","inspect","data","information","reports"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.485 21 16.7364 19.9915 18.364 18.364C19.9915 16.7364 21 14.485 21 12C21 7.02944 16.9706 3 12 3ZM8 10.75C7.86193 10.75 7.75 10.8619 7.75 11C7.75 11.1381 7.86193 11.25 8 11.25C8.9665 11.25 9.75 12.0335 9.75 13C9.75 13.9665 8.9665 14.75 8 14.75H7C6.58579 14.75 6.25 14.4142 6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H8C8.13807 13.25 8.25 13.1381 8.25 13C8.25 12.8619 8.13807 12.75 8 12.75C7.0335 12.75 6.25 11.9665 6.25 11C6.25 10.0335 7.0335 9.25 8 9.25H9C9.41421 9.25 9.75 9.58579 9.75 10C9.75 10.4142 9.41421 10.75 9 10.75H8ZM12 10.75C11.8619 10.75 11.75 10.8619 11.75 11V11.25H13C13.4142 11.25 13.75 11.5858 13.75 12C13.75 12.4142 13.4142 12.75 13 12.75H11.75V13C11.75 13.1381 11.8619 13.25 12 13.25H13C13.4142 13.25 13.75 13.5858 13.75 14C13.75 14.4142 13.4142 14.75 13 14.75H12C11.0335 14.75 10.25 13.9665 10.25 13V11C10.25 10.0335 11.0335 9.25 12 9.25H13C13.4142 9.25 13.75 9.58579 13.75 10C13.75 10.4142 13.4142 10.75 13 10.75H12ZM14.25 11C14.25 10.0335 15.0335 9.25 16 9.25C16.9665 9.25 17.75 10.0335 17.75 11V13C17.75 13.9665 16.9665 14.75 16 14.75C15.0335 14.75 14.25 13.9665 14.25 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.2929 19.2929C19.6834 18.9024 20.3166 18.9024 20.7071 19.2929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L19.2929 20.7071C18.9024 20.3166 18.9024 19.6834 19.2929 19.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-seo": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","magnify","magnifier","look-up","item-search","customer-search","order-search","product-search","inventory-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11L11 13C11 13.5523 11.4477 14 12 14H13M13 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 10H8C7.44772 10 7 10.4477 7 11V11C7 11.5523 7.44772 12 8 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14H8C8.55228 14 9 13.5523 9 13V13C9 12.4477 8.55228 12 8 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 11V13C15 13.5523 15.4477 14 16 14C16.5523 14 17 13.5523 17 13L17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 20L19 19M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.2091 19.1046 16.2091 17.6569 17.6569C16.2091 19.1046 14.2091 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-shield-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","shield","security","protection","safe","find","scan","verify","magnify","secure-search","validate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0889V9.85714L12 9L15 9.85714V11.0889C15 12.9368 13.7631 14.5518 12 15C10.2369 14.5518 9 12.9368 9 11.0889Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-shield-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["search","shield","security","protected-search","safe-search","verified-search","trust","authentication","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0889V9.85714L12 9L15 9.85714V11.0889C15 12.9368 13.7631 14.5518 12 15C10.2369 14.5518 9 12.9368 9 11.0889Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-shield-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","search","find","query","secure-search","data-protection","transaction-security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8483 19.3723 15.5513 18.3198 16.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L16.9056 18.3198C15.5513 19.3723 13.8483 20 12 20C7.58172 20 4 16.4183 4 12ZM8.72528 8.89562L11.7253 8.03848C11.9048 7.98717 12.0952 7.98717 12.2747 8.03848L15.2747 8.89562C15.704 9.01828 16 9.41066 16 9.85714V11.0889C16 13.3826 14.4639 15.4055 12.2464 15.9692C12.0847 16.0103 11.9153 16.0103 11.7536 15.9692C9.53609 15.4055 8 13.3826 8 11.0889V9.85714C8 9.41066 8.29598 9.01828 8.72528 8.89562Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-shield": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","shield","secure-search","protected-search","safe-search","security","magnify","magnifying-glass","find","detect","authenticate","authorization","encrypted-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11.0889V9.85714L12 9L15 9.85714V11.0889C15 12.9368 13.7631 14.5518 12 15C10.2369 14.5518 9 12.9368 9 11.0889Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "search-sortby-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","sort","filter","find","magnify","options","inventory-search","transaction-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 19.0004L18.9497 16.9502" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 12C7 15.866 10.134 19 14 19C15.933 19 17.683 18.2165 18.9497 16.9497C20.2165 15.683 21 13.933 21 12C21 8.13401 17.866 5 14 5C10.134 5 7 8.13401 7 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8H3M4 10.9999H3M4 14H3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-sortby-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","sort","filter","find","magnify","magnifying-glass","list","options","inventory-search","product-search","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 19.0004L18.9497 16.9502" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 12C7 15.866 10.134 19 14 19C15.933 19 17.683 18.2165 18.9497 16.9497C20.2165 15.683 21 13.933 21 12C21 8.13401 17.866 5 14 5C10.134 5 7 8.13401 7 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8H3M4 10.9999H3M4 14H3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-sortby-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","filter","sort","sort-by","search-filter","search-sort","search-sort-by","options","list","find","organize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 12C6 7.58172 9.58172 4 14 4C18.4183 4 22 7.58172 22 12C22 13.8483 21.3723 15.5513 20.3198 16.9056L21.7071 18.2929C22.0976 18.6834 22.0976 19.3165 21.7071 19.7071C21.3165 20.0976 20.6834 20.0976 20.2929 19.7071L18.9056 18.3198C17.5513 19.3723 15.8483 20 14 20C9.58172 20 6 16.4183 6 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H5C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7H3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 9.99989C2.44772 9.99989 2 10.4476 2 10.9999C2 11.5522 2.44772 11.9999 3 11.9999H4C4.55228 11.9999 5 11.5522 5 10.9999C5 10.4476 4.55228 9.99989 4 9.99989H3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H4C4.55228 15 5 14.5523 5 14C5 13.4477 4.55228 13 4 13H3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-sortby-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","sort","filter","find","lookup","magnify","magnifying-glass","options","arrange","search-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H4M5 11.9998H4M7 17H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2426 16.2426L20 18M18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-sortby-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["search","sort","filter","magnify","magnifying-glass","find","lookup","organize","arrange","refine","items","products","transactions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H4M5 11.9998H4M7 17H4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2426 16.2426L20 18M18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-sortby-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","sort","filter","find","inventory-search","product-search","customer-search","transaction-search","order-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H4M5 11.9998H4M7 17H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.2426 16.2426L20 18M18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 12C8 15.3137 10.6863 18 14 18C15.6569 18 17.1569 17.3284 18.2426 16.2426C19.3284 15.1569 20 13.6569 20 12C20 8.68629 17.3137 6 14 6C10.6863 6 8 8.68629 8 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-sortby-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","filter","sort","list","inventory","find","scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5C10.134 5 7 8.13401 7 12C7 15.866 10.134 19 14 19C15.5719 19 17.0239 18.481 18.1921 17.6063L19.2929 18.7071C19.6834 19.0976 20.3166 19.0976 20.7071 18.7071C21.0976 18.3166 21.0976 17.6834 20.7071 17.2929L19.6063 16.1921C20.481 15.0239 21 13.5719 21 12C21 8.13401 17.866 5 14 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H7C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 10.9998C3.44772 10.9998 3 11.4475 3 11.9998C3 12.5521 3.44772 12.9998 4 12.9998H5C5.55228 12.9998 6 12.5521 6 11.9998C6 11.4475 5.55228 10.9998 5 10.9998H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H7C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "search-users-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["search","customer","find-customer","user","lookup","find","customer-search"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14.6667C9 15.403 10.3431 16 12 16C12.8284 16 13.5784 15.8508 14.1213 15.6095C14.6642 15.3682 15 15.0349 15 14.6667C15 14.2985 14.7015 14 14.3333 14H9.66667C9.29848 14 9 14.2985 9 14.6667Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 11.1046 10.8954 12 12 12C12.5523 12 13.0523 11.7761 13.4142 11.4142C13.7761 11.0523 14 10.5523 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-users-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["search","users","customer","find-customer","lookup-customer","search-customer","customer-search","find","magnify","magnifying-glass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 19L16.9497 16.9497" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14.6667C9 15.403 10.3431 16 12 16C12.8284 16 13.5784 15.8508 14.1213 15.6095C14.6642 15.3682 15 15.0349 15 14.6667C15 14.2985 14.7015 14 14.3333 14H9.66667C9.29848 14 9 14.2985 9 14.6667Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 11.1046 10.8954 12 12 12C12.5523 12 13.0523 11.7761 13.4142 11.4142C13.7761 11.0523 14 10.5523 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-users-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","customer","user","lookup","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12.5C10.7574 12.5 9.75 11.4926 9.75 10.25C9.75 9.00736 10.7574 8 12 8C13.2426 8 14.25 9.00736 14.25 10.25C14.25 10.8713 13.9979 11.4341 13.591 11.841C13.1841 12.2479 12.6213 12.5 12 12.5ZM12 12.5H9.66667C8.88426 12.5 8.25 13.1343 8.25 13.9167C8.25 14.3451 8.44862 14.6965 8.69246 14.9527C8.93289 15.2053 9.24535 15.3987 9.57408 15.5448C10.2334 15.8379 11.0918 16 12 16C12.9082 16 13.7666 15.8379 14.4259 15.5448C14.7547 15.3987 15.0671 15.2053 15.3075 14.9527C15.5514 14.6965 15.75 14.3451 15.75 13.9167C15.75 13.1343 15.1157 12.5 14.3333 12.5H12ZM17.0824 18.143L16.9264 17.987L16.7522 18.1224C15.4402 19.142 13.7908 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 7.71979 7.71979 4.25 12 4.25C16.2802 4.25 19.75 7.71979 19.75 12C19.75 13.7908 19.142 15.4402 18.1224 16.7522L17.987 16.9264L18.143 17.0824L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L17.0824 18.143Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    search: {
        defaultColors: ["#3D4C66"],
        keywords: ["search","find","customer","user","lookup","query"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "search-sortby": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","sort","filter","find","magnify","magnifying-glass","list","options","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 19L18.9497 16.9497M18.9497 16.9497C20.2165 15.683 21 13.933 21 12C21 8.13401 17.866 5 14 5C10.134 5 7 8.13401 7 12C7 15.866 10.134 19 14 19C15.933 19 17.683 18.2165 18.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8H3M4 10.9999H3M4 14H3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "search-users": {
        defaultColors: ["#3D4C66"],
        keywords: ["search","user","customer","find","lookup","customer-lookup","search-customer","find-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 19L16.9497 16.9497M16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14.6667C9 15.403 10.3431 16 12 16C12.8284 16 13.5784 15.8508 14.1213 15.6095C14.6642 15.3682 15 15.0349 15 14.6667C15 14.2985 14.7015 14 14.3333 14H9.66667C9.29848 14 9 14.2985 9 14.6667Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 10C10 11.1046 10.8954 12 12 12C12.5523 12 13.0523 11.7761 13.4142 11.4142C13.7761 11.0523 14 10.5523 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "send-plane v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["send","submit","arrow","forward","send-order","submit-order","transmit","transmit-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41097C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12V12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963V13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037V10.9037Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.6"
                />
                <path
                    d="M20 12H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "send-plane v2-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["send","plane","airplane","right","arrow","submit","dispatch","send-order","order","delivery","fulfillment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_38310)">
                    <path
                        d="M5.2008 11.0004H20.1808C19.9608 10.3204 19.5008 9.72035 18.8608 9.35035L11.9708 5.58035C8.3508 3.60035 6.5208 2.60035 5.0308 3.57035C4.8508 3.69035 4.6808 3.83035 4.5208 3.98035C3.2808 5.23035 3.8408 7.18035 4.9908 11.0004H5.2008Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                    <path
                        d="M19.5805 12.9902H5.0005C3.8405 16.8402 3.2905 18.7702 4.5305 20.0202C4.6805 20.1702 4.8505 20.3102 5.0305 20.4302C5.4205 20.6802 5.8405 20.8002 6.3105 20.8002C7.6105 20.8002 9.3005 19.8802 11.9705 18.4102L18.7105 14.7202L18.8505 14.6402C19.5005 14.2602 19.9605 13.6602 20.1805 12.9902H19.5805Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_38310">
                        <rect width="16.36" height="17.6" fill={colors?.[1] || "#FFFFFF"} transform="translate(3.82031 3.2002)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Send-plane-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","submit","proceed","next","arrow","right","checkout","payment","confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41097C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12V12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963V13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037V10.9037Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.6"
                />
            </svg>
        )
    },
    "send-plane v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["send","submit","arrow","forward","transaction","confirm","checkout","payment","process","order","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41096C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.6"
                />
                <path
                    d="M20 12H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Send-plane-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["send","submit","forward","arrow","checkout","payment","confirmation","next"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41096C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.6"
                />
            </svg>
        )
    },
    "send-plane v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","send-order","submit","forward","arrow","direction","transmit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41097C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12V12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963V13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037V10.9037Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.6"
                />
                <path
                    d="M20 12H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Send-plane": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","airplane","right-arrow","submit","confirm","checkout","payment","next","proceed","forward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67112 10.9037C5.59629 7.32096 5.05887 5.52957 5.89506 4.68543C5.99765 4.58187 6.11125 4.48983 6.23384 4.41097C7.23309 3.7681 8.87401 4.66547 12.1558 6.46023L18.9033 10.1502C18.9578 10.18 18.9851 10.195 19.0101 10.2096C19.6054 10.5579 19.9792 11.1884 19.9992 11.8778C20 11.9068 20 11.9379 20 12V12C20 12.0621 20 12.0932 19.9992 12.1222C19.9792 12.8116 19.6054 13.4421 19.0101 13.7904C18.9851 13.805 18.9578 13.82 18.9033 13.8498L12.1559 17.5398C8.87401 19.3345 7.23309 20.2319 6.23384 19.589C6.11125 19.5102 5.99765 19.4181 5.89506 19.3146C5.05887 18.4704 5.59629 16.679 6.67112 13.0963V13.0963C6.8264 12.5787 6.90404 12.3199 6.91121 12.0539C6.91218 12.018 6.91218 11.982 6.91121 11.9461C6.90404 11.6801 6.8264 11.4213 6.67112 10.9037V10.9037Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.6"
                />
            </svg>
        )
    },
    "Sensor-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sensor","off","disabled","deactivated","unavailable","offline","function-disabled","sensor-disabled","error","no-signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Send-plane-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","submit","arrow","forward","checkout","payment","confirm","place-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.95666 11.2247C5.07666 11.6247 5.14667 11.8547 5.14667 12.0447C5.14667 12.1747 5.07665 12.4147 4.94665 12.8247C3.75665 16.7847 3.16665 18.7647 4.41665 20.0347C4.56665 20.1847 4.73665 20.3247 4.91665 20.4447C5.30665 20.6947 5.72665 20.8148 6.19665 20.8148C7.49665 20.8148 9.18666 19.8948 11.8567 18.4248L18.5966 14.7347L18.7367 14.6547C19.6367 14.1247 20.1867 13.1947 20.2167 12.1947C20.2167 12.1547 20.2167 12.1047 20.2167 12.0047C20.2167 11.9047 20.2167 11.8647 20.2167 11.8547C20.1867 10.8147 19.6367 9.87475 18.7367 9.35475L11.8466 5.58475C8.22665 3.60475 6.39668 2.60475 4.90668 3.57475C4.72668 3.69475 4.55667 3.83475 4.39667 3.98475C3.14667 5.25475 3.73666 7.23475 4.92666 11.1947"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Sensor-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sensor","off","disabled","mute","sound","notification-off","audio-off","disable-alerts","no-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.50094 7.91516C5.56651 9.03248 5 10.45 5 12C5 13.8705 5.82499 15.548 7.12598 16.7379C7.53352 17.1107 8.16605 17.0824 8.53879 16.6749C8.91152 16.2674 8.8833 15.6348 8.47576 15.2621C7.5541 14.4191 7 13.2634 7 12C7 11.0144 7.33719 10.0944 7.92302 9.33724L8.55382 9.96803C8.20193 10.5635 8 11.2582 8 12C8 14.2091 9.79086 16 12 16C12.7418 16 13.4365 15.7981 14.032 15.4462L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L6.70711 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.7769 13.3627L18.2982 14.884C18.7462 14.0155 19 13.0374 19 12C19 10.1295 18.175 8.45197 16.874 7.26209C16.4665 6.88936 15.8339 6.91757 15.4612 7.32511C15.0885 7.73265 15.1167 8.36519 15.5242 8.73792C16.4459 9.58087 17 10.7366 17 12C17 12.4729 16.9224 12.9307 16.7769 13.3627Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.4515 8.03729L15.9627 12.5485C15.9873 12.3692 16 12.1861 16 12C16 9.79086 14.2091 8 12 8C11.8139 8 11.6308 8.01271 11.4515 8.03729Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Sensor-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sensor","off","disabled","not-available","malfunction","error","connectivity-issue","no-signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 18L6 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Sensor-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["sensor","off","disabled","unavailable","connection-lost","disconnected","no-signal","error","interruption"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 19L5 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "server-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["server","database","data","storage","network","technology","system","backend","cloud","pos-system","inventory","reports","analytics","administration","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11H7C6.06812 11 5.60218 11 5.23463 10.8478C4.74458 10.6448 4.35523 10.2554 4.15224 9.76537C4 9.39782 4 8.93188 4 8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H17C17.9319 5 18.3978 5 18.7654 5.15224C19.2554 5.35523 19.6448 5.74458 19.8478 6.23463C20 6.60218 20 7.06812 20 8C20 8.93188 20 9.39782 19.8478 9.76537C19.6448 10.2554 19.2554 10.6448 18.7654 10.8478C18.3978 11 17.9319 11 17 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 19H7C6.06812 19 5.60218 19 5.23463 18.8478C4.74458 18.6448 4.35523 18.2554 4.15224 17.7654C4 17.3978 4 16.9319 4 16C4 15.0681 4 14.6022 4.15224 14.2346C4.35523 13.7446 4.74458 13.3552 5.23463 13.1522C5.60218 13 6.06812 13 7 13H17C17.9319 13 18.3978 13 18.7654 13.1522C19.2554 13.3552 19.6448 13.7446 19.8478 14.2346C20 14.6022 20 15.0681 20 16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 16H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "server-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["server","database","storage","data","network","hosting","system","backend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11H7C6.06812 11 5.60218 11 5.23463 10.8478C4.74458 10.6448 4.35523 10.2554 4.15224 9.76537C4 9.39782 4 8.93188 4 8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H17C17.9319 5 18.3978 5 18.7654 5.15224C19.2554 5.35523 19.6448 5.74458 19.8478 6.23463C20 6.60218 20 7.06812 20 8C20 8.93188 20 9.39782 19.8478 9.76537C19.6448 10.2554 19.2554 10.6448 18.7654 10.8478C18.3978 11 17.9319 11 17 11Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 19H7C6.06812 19 5.60218 19 5.23463 18.8478C4.74458 18.6448 4.35523 18.2554 4.15224 17.7654C4 17.3978 4 16.9319 4 16C4 15.0681 4 14.6022 4.15224 14.2346C4.35523 13.7446 4.74458 13.3552 5.23463 13.1522C5.60218 13 6.06812 13 7 13H17C17.9319 13 18.3978 13 18.7654 13.1522C19.2554 13.3552 19.6448 13.7446 19.8478 14.2346C20 14.6022 20 15.0681 20 16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M14 16H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "server-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["server","database","data","storage","system","network","hosting","backend","cloud","technology"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.032 3H6.96802C6.52939 2.99999 6.15087 2.99998 5.83762 3.02135C5.50779 3.04385 5.17788 3.09336 4.85195 3.22836C4.11687 3.53284 3.53285 4.11687 3.22836 4.85195C3.09336 5.17788 3.04386 5.50779 3.02135 5.83762C2.99998 6.15086 2.99999 6.52932 3 6.96793V7.03198C2.99999 7.4706 2.99998 7.84914 3.02135 8.16238C3.04386 8.49221 3.09336 8.82212 3.22836 9.14805C3.53285 9.88314 4.11687 10.4672 4.85195 10.7716C5.17788 10.9066 5.50779 10.9561 5.83762 10.9787C6.15088 11 6.52936 11 6.96801 11H17.032C17.4706 11 17.8491 11 18.1624 10.9787C18.4922 10.9561 18.8221 10.9066 19.1481 10.7716C19.8831 10.4672 20.4672 9.88313 20.7716 9.14805C20.9066 8.82212 20.9561 8.49221 20.9787 8.16238C21 7.84913 21 7.47064 21 7.03199V6.96801C21 6.52936 21 6.15088 20.9787 5.83762C20.9561 5.50779 20.9066 5.17788 20.7716 4.85195C20.4672 4.11687 19.8831 3.53284 19.1481 3.22836C18.8221 3.09336 18.4922 3.04385 18.1624 3.02135C17.8491 2.99998 17.4706 2.99999 17.032 3ZM14 7C14 7.55228 13.5523 8 13 8H12C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6H13C13.5523 6 14 6.44772 14 7ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6H16C15.4477 6 15 6.44772 15 7C15 7.55228 15.4477 8 16 8H17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.032 13H6.96802C6.52939 13 6.15087 13 5.83762 13.0213C5.50779 13.0439 5.17788 13.0934 4.85195 13.2284C4.11687 13.5328 3.53285 14.1169 3.22836 14.8519C3.09336 15.1779 3.04386 15.5078 3.02135 15.8376C2.99998 16.1509 2.99999 16.5293 3 16.9679V17.032C2.99999 17.4706 2.99998 17.8491 3.02135 18.1624C3.04386 18.4922 3.09336 18.8221 3.22836 19.1481C3.53285 19.8831 4.11687 20.4672 4.85195 20.7716C5.17788 20.9066 5.50779 20.9561 5.83762 20.9787C6.15088 21 6.52936 21 6.96801 21H17.032C17.4706 21 17.8491 21 18.1624 20.9787C18.4922 20.9561 18.8221 20.9066 19.1481 20.7716C19.8831 20.4672 20.4672 19.8831 20.7716 19.148C20.9066 18.8221 20.9561 18.4922 20.9787 18.1624C21 17.8491 21 17.4706 21 17.032V16.968C21 16.5294 21 16.1509 20.9787 15.8376C20.9561 15.5078 20.9066 15.1779 20.7716 14.8519C20.4672 14.1169 19.8831 13.5328 19.1481 13.2284C18.8221 13.0934 18.4922 13.0439 18.1624 13.0213C17.8491 13 17.4706 13 17.032 13ZM14 17C14 17.5523 13.5523 18 13 18H12C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16H13C13.5523 16 14 16.4477 14 17ZM17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16H16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18H17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    server: {
        defaultColors: ["#3D4C66"],
        keywords: ["server","database","data","storage","system","network","hosting","backend","cloud","technology"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11H7C6.06812 11 5.60218 11 5.23463 10.8478C4.74458 10.6448 4.35523 10.2554 4.15224 9.76537C4 9.39782 4 8.93188 4 8C4 7.06812 4 6.60218 4.15224 6.23463C4.35523 5.74458 4.74458 5.35523 5.23463 5.15224C5.60218 5 6.06812 5 7 5H17C17.9319 5 18.3978 5 18.7654 5.15224C19.2554 5.35523 19.6448 5.74458 19.8478 6.23463C20 6.60218 20 7.06812 20 8C20 8.93188 20 9.39782 19.8478 9.76537C19.6448 10.2554 19.2554 10.6448 18.7654 10.8478C18.3978 11 17.9319 11 17 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 19H7C6.06812 19 5.60218 19 5.23463 18.8478C4.74458 18.6448 4.35523 18.2554 4.15224 17.7654C4 17.3978 4 16.9319 4 16C4 15.0681 4 14.6022 4.15224 14.2346C4.35523 13.7446 4.74458 13.3552 5.23463 13.1522C5.60218 13 6.06812 13 7 13H17C17.9319 13 18.3978 13 18.7654 13.1522C19.2554 13.3552 19.6448 13.7446 19.8478 14.2346C20 14.6022 20 15.0681 20 16C20 16.9319 20 17.3978 19.8478 17.7654C19.6448 18.2554 19.2554 18.6448 18.7654 18.8478C18.3978 19 17.9319 19 17 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 16H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 16H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "setting-cog 10-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","cog","gear","admin","configuration","options","preferences","system","tools","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 10-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","gear","cog","configuration","options","preferences","admin","system","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 10": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configuration","options","system","preferences","tools","admin","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 10-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["setting","settings","cog","gear","options","configuration","admin","preferences","system","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.01 14.01C13.1146 14.01 14.01 13.1146 14.01 12.01C14.01 10.9054 13.1146 10.01 12.01 10.01C10.9054 10.01 10.01 10.9054 10.01 12.01C10.01 13.1146 10.9054 14.01 12.01 14.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.56 10.07L18.31 9.65C18.17 9.6 18.1 9.44 18.16 9.31L18.76 8.01C19.07 7.34 18.93 6.56 18.41 6.04L17.98 5.61C17.46 5.09 16.67 4.95 16.01 5.26L14.71 5.86C14.57 5.92 14.42 5.86 14.37 5.71L13.95 4.45C13.71 3.74 13.04 3.25 12.29 3.25H11.73C10.98 3.25 10.31 3.73 10.07 4.45L9.64999 5.71C9.59999 5.85 9.44 5.92 9.31 5.86L8.00999 5.26C7.33999 4.95 6.55999 5.09 6.03999 5.61L5.61 6.04C5.09 6.56 4.94999 7.35 5.25999 8.01L5.86 9.31C5.92 9.45 5.85999 9.6 5.70999 9.65L4.45 10.07C3.73 10.31 3.25 10.98 3.25 11.73V12.29C3.25 13.04 3.73 13.71 4.45 13.95L5.70999 14.37C5.84999 14.42 5.92 14.58 5.86 14.71L5.25999 16.01C4.94999 16.68 5.09 17.46 5.61 17.98L6.03999 18.41C6.55999 18.93 7.34999 19.07 8.00999 18.76L9.31 18.16C9.45 18.1 9.59999 18.16 9.64999 18.31L10.07 19.57C10.31 20.28 10.98 20.745 11.73 20.745H12.29C13.04 20.745 13.71 20.29 13.95 19.57L14.37 18.31C14.42 18.17 14.58 18.1 14.71 18.16L16.01 18.76C16.68 19.07 17.46 18.93 17.98 18.41L18.41 17.98C18.93 17.46 19.07 16.67 18.76 16.01L18.16 14.71C18.1 14.57 18.16 14.42 18.31 14.37L19.56 13.95C20.28 13.71 20.75 13.04 20.75 12.29V11.73C20.75 10.98 20.28 10.31 19.56 10.07ZM12.01 16.01C9.79999 16.01 8.00999 14.22 8.00999 12.01C8.00999 9.8 9.79999 8.01 12.01 8.01C14.22 8.01 16.01 9.8 16.01 12.01C16.01 14.22 14.22 16.01 12.01 16.01Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 11-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","cog","gear","options","customize","preferences","system","configuration","admin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3964 4.97813L10.4748 4.85099C10.8013 4.32205 11.3784 4 12 4C12.6216 4 13.1987 4.32205 13.5252 4.85099L13.6163 4.9987C13.6525 5.05727 13.6706 5.08655 13.6879 5.11273C14.1238 5.77194 14.9071 6.11259 15.6866 5.98198C15.7175 5.97679 15.7513 5.97004 15.8188 5.95654L16.1567 5.88895C16.7012 5.78003 17.2642 5.95047 17.6568 6.34315C18.0495 6.73583 18.22 7.29876 18.1111 7.8433L18.0505 8.14603C18.0205 8.29597 18.0055 8.37094 17.9966 8.44055C17.9066 9.14414 18.196 9.84277 18.7571 10.2766C18.8127 10.3196 18.8763 10.362 19.0035 10.4468L19.2604 10.618C19.7225 10.9261 20 11.4447 20 12C20 12.5553 19.7225 13.0739 19.2604 13.382L18.9735 13.5732L18.9734 13.5733C18.9163 13.6114 18.8877 13.6304 18.8622 13.6486C18.2186 14.1074 17.9056 14.9022 18.0635 15.6767C18.0698 15.7074 18.0777 15.7409 18.0936 15.8078L18.1335 15.9766C18.2768 16.5815 18.0964 17.2173 17.6568 17.6569C17.2173 18.0964 16.5815 18.2768 15.9766 18.1336L15.8313 18.0992C15.791 18.0896 15.7709 18.0849 15.7526 18.0809C14.9373 17.9039 14.0978 18.2517 13.6464 18.9533C13.6362 18.9691 13.6254 18.9867 13.6037 19.0218L13.5252 19.149C13.1987 19.678 12.6216 20 12 20C11.3784 20 10.8013 19.678 10.4748 19.149L10.3964 19.0219C10.3746 18.9867 10.3638 18.9691 10.3536 18.9533C9.90227 18.2517 9.06279 17.904 8.24749 18.0809C8.22917 18.0849 8.20905 18.0896 8.1688 18.0992L8.02333 18.1336C7.41849 18.2768 6.78265 18.0964 6.34314 17.6569C5.90362 17.2173 5.72321 16.5815 5.86641 15.9766L5.90083 15.8312C5.91036 15.791 5.91513 15.7709 5.9191 15.7525C6.09605 14.9372 5.74832 14.0977 5.04669 13.6464C5.03094 13.6362 5.01337 13.6254 4.97826 13.6037L4.97812 13.6036L4.85099 13.5252C4.32205 13.1987 4 12.6216 4 12C4 11.3784 4.32205 10.8013 4.85099 10.4748L4.97812 10.3964C5.0133 10.3747 5.0309 10.3638 5.04666 10.3537C5.7483 9.90227 6.09603 9.06278 5.91909 8.24748C5.91512 8.22916 5.91035 8.20904 5.90083 8.1688L5.86639 8.02335C5.72321 7.41851 5.90362 6.78266 6.34313 6.34315C6.78264 5.90364 7.4185 5.72322 8.02335 5.86642L8.16876 5.90084C8.20901 5.91037 8.22914 5.91514 8.24746 5.91911C9.06276 6.09605 9.90225 5.74832 10.3536 5.0467C10.3638 5.03093 10.3746 5.01333 10.3964 4.97813L10.3964 4.97813Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 11": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configure","options","system-settings","admin","preferences","adjustments","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3964 4.97813L10.4748 4.85099C10.8013 4.32205 11.3784 4 12 4C12.6216 4 13.1987 4.32205 13.5252 4.85099L13.6163 4.9987C13.6525 5.05727 13.6706 5.08655 13.6879 5.11273C14.1238 5.77194 14.9071 6.11259 15.6866 5.98198C15.7175 5.97679 15.7513 5.97004 15.8188 5.95654L16.1567 5.88895C16.7012 5.78003 17.2642 5.95047 17.6568 6.34315C18.0495 6.73583 18.22 7.29876 18.1111 7.8433L18.0505 8.14603C18.0205 8.29597 18.0055 8.37094 17.9966 8.44055C17.9066 9.14414 18.196 9.84277 18.7571 10.2766C18.8127 10.3196 18.8763 10.362 19.0035 10.4468L19.2604 10.618C19.7225 10.9261 20 11.4447 20 12C20 12.5553 19.7225 13.0739 19.2604 13.382L18.9735 13.5732L18.9734 13.5733C18.9163 13.6114 18.8877 13.6304 18.8622 13.6486C18.2186 14.1074 17.9056 14.9022 18.0635 15.6767C18.0698 15.7074 18.0777 15.7409 18.0936 15.8078L18.1335 15.9766C18.2768 16.5815 18.0964 17.2173 17.6568 17.6569C17.2173 18.0964 16.5815 18.2768 15.9766 18.1336L15.8313 18.0992C15.791 18.0896 15.7709 18.0849 15.7526 18.0809C14.9373 17.9039 14.0978 18.2517 13.6464 18.9533C13.6362 18.9691 13.6254 18.9867 13.6037 19.0218L13.5252 19.149C13.1987 19.678 12.6216 20 12 20C11.3784 20 10.8013 19.678 10.4748 19.149L10.3964 19.0219C10.3746 18.9867 10.3638 18.9691 10.3536 18.9533C9.90227 18.2517 9.06279 17.904 8.24749 18.0809C8.22917 18.0849 8.20905 18.0896 8.1688 18.0992L8.02333 18.1336C7.41849 18.2768 6.78265 18.0964 6.34314 17.6569C5.90362 17.2173 5.72321 16.5815 5.86641 15.9766L5.90083 15.8312C5.91036 15.791 5.91513 15.7709 5.9191 15.7525C6.09605 14.9372 5.74832 14.0977 5.04669 13.6464C5.03094 13.6362 5.01337 13.6254 4.97826 13.6037L4.97812 13.6036L4.85099 13.5252C4.32205 13.1987 4 12.6216 4 12C4 11.3784 4.32205 10.8013 4.85099 10.4748L4.97812 10.3964C5.0133 10.3747 5.0309 10.3638 5.04666 10.3537C5.7483 9.90227 6.09603 9.06278 5.91909 8.24748C5.91512 8.22916 5.91035 8.20904 5.90083 8.1688L5.86639 8.02335C5.72321 7.41851 5.90362 6.78266 6.34313 6.34315C6.78264 5.90364 7.4185 5.72322 8.02335 5.86642L8.16876 5.90084C8.20901 5.91037 8.22914 5.91514 8.24746 5.91911C9.06276 6.09605 9.90225 5.74832 10.3536 5.0467C10.3638 5.03093 10.3746 5.01333 10.3964 4.97813L10.3964 4.97813Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 11-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","options","configuration","admin","preferences","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3964 4.97813L10.4748 4.85099C10.8013 4.32205 11.3784 4 12 4C12.6216 4 13.1987 4.32205 13.5252 4.85099L13.6163 4.9987C13.6525 5.05727 13.6706 5.08655 13.6879 5.11273C14.1238 5.77194 14.9071 6.11259 15.6866 5.98198C15.7175 5.97679 15.7513 5.97004 15.8188 5.95654L16.1567 5.88895C16.7012 5.78003 17.2642 5.95047 17.6568 6.34315C18.0495 6.73583 18.22 7.29876 18.1111 7.8433L18.0505 8.14603C18.0205 8.29597 18.0055 8.37094 17.9966 8.44055C17.9066 9.14414 18.196 9.84277 18.7571 10.2766C18.8127 10.3196 18.8763 10.362 19.0035 10.4468L19.2604 10.618C19.7225 10.9261 20 11.4447 20 12C20 12.5553 19.7225 13.0739 19.2604 13.382L18.9735 13.5732L18.9734 13.5733C18.9163 13.6114 18.8877 13.6304 18.8622 13.6486C18.2186 14.1074 17.9056 14.9022 18.0635 15.6767C18.0698 15.7074 18.0777 15.7409 18.0936 15.8078L18.1335 15.9766C18.2768 16.5815 18.0964 17.2173 17.6568 17.6569C17.2173 18.0964 16.5815 18.2768 15.9766 18.1336L15.8313 18.0992C15.791 18.0896 15.7709 18.0849 15.7526 18.0809C14.9373 17.9039 14.0978 18.2517 13.6464 18.9533C13.6362 18.9691 13.6254 18.9867 13.6037 19.0218L13.5252 19.149C13.1987 19.678 12.6216 20 12 20C11.3784 20 10.8013 19.678 10.4748 19.149L10.3964 19.0219C10.3746 18.9867 10.3638 18.9691 10.3536 18.9533C9.90227 18.2517 9.06279 17.904 8.24749 18.0809C8.22917 18.0849 8.20905 18.0896 8.1688 18.0992L8.02333 18.1336C7.41849 18.2768 6.78265 18.0964 6.34314 17.6569C5.90362 17.2173 5.72321 16.5815 5.86641 15.9766L5.90083 15.8312C5.91036 15.791 5.91513 15.7709 5.9191 15.7525C6.09605 14.9372 5.74832 14.0977 5.04669 13.6464C5.03094 13.6362 5.01337 13.6254 4.97826 13.6037L4.97812 13.6036L4.85099 13.5252C4.32205 13.1987 4 12.6216 4 12C4 11.3784 4.32205 10.8013 4.85099 10.4748L4.97812 10.3964C5.0133 10.3747 5.0309 10.3638 5.04666 10.3537C5.7483 9.90227 6.09603 9.06278 5.91909 8.24748C5.91512 8.22916 5.91035 8.20904 5.90083 8.1688L5.86639 8.02335C5.72321 7.41851 5.90362 6.78266 6.34313 6.34315C6.78264 5.90364 7.4185 5.72322 8.02335 5.86642L8.16876 5.90084C8.20901 5.91037 8.22914 5.91514 8.24746 5.91911C9.06276 6.09605 9.90225 5.74832 10.3536 5.0467C10.3638 5.03093 10.3746 5.01333 10.3964 4.97813L10.3964 4.97813Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 11-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","options","preferences","configuration","setup","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 13.99C13.1046 13.99 14 13.0946 14 11.99C14 10.8854 13.1046 9.99 12 9.99C10.8954 9.99 10 10.8854 10 11.99C10 13.0946 10.8954 13.99 12 13.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.68 9.98L19.42 9.81C19.28 9.72 19.25 9.69 19.22 9.67C18.87 9.4 18.69 8.96 18.74 8.52C18.74 8.48 18.75 8.44 18.79 8.28L18.85 7.98C19.01 7.19 18.76 6.37 18.19 5.8C17.62 5.23 16.8 4.98 16.01 5.14L15.67 5.21C15.6 5.22 15.58 5.23 15.56 5.23C15.07 5.31 14.58 5.1 14.31 4.69C14.31 4.68 14.29 4.66 14.25 4.6L14.16 4.45C13.7 3.7 12.88 3.25 12 3.25C11.12 3.25 10.3 3.7 9.84 4.45L9.73 4.63C9.45 5.07 8.92 5.29 8.41 5.18C8.4 5.18 8.39001 5.18 8.35001 5.16L8.2 5.13C7.34 4.93 6.44001 5.18 5.82001 5.81C5.20001 6.43 4.94 7.34 5.14 8.19L5.17 8.34C5.17 8.34 5.18 8.4 5.19 8.4C5.3 8.91 5.07999 9.43 4.64999 9.72C4.64999 9.72 4.63 9.73 4.59 9.76L4.46001 9.84C3.71001 10.3 3.25 11.12 3.25 12C3.25 12.88 3.71001 13.7 4.46001 14.16L4.59 14.24C4.63 14.26 4.63999 14.27 4.64999 14.27C5.08999 14.55 5.31 15.08 5.19 15.59C5.19 15.59 5.19 15.61 5.17 15.66L5.14 15.81C4.94 16.67 5.19001 17.57 5.82001 18.19C6.44001 18.81 7.35 19.07 8.2 18.87L8.35001 18.84C8.35001 18.84 8.4 18.83 8.41 18.82C8.92 18.71 9.44 18.93 9.73 19.37C9.73 19.37 9.74 19.39 9.77 19.43L9.85001 19.56C10.31 20.31 11.13 20.75 12.01 20.75C12.89 20.75 13.71 20.31 14.17 19.56L14.25 19.43C14.25 19.43 14.28 19.38 14.29 19.37C14.57 18.93 15.1 18.71 15.61 18.82C15.61 18.82 15.63 18.82 15.67 18.84L15.82 18.87C16.68 19.07 17.58 18.82 18.2 18.19C18.82 17.57 19.08 16.66 18.88 15.81L18.84 15.64C18.82 15.57 18.82 15.55 18.82 15.53C18.72 15.05 18.92 14.55 19.32 14.26C19.33 14.26 19.35 14.24 19.41 14.2L19.69 14.01C20.36 13.56 20.75 12.81 20.75 12C20.75 11.19 20.36 10.44 19.69 9.99L19.68 9.98ZM12 15.99C9.79 15.99 8 14.2 8 11.99C8 9.78 9.79 7.99 12 7.99C14.21 7.99 16 9.78 16 11.99C16 14.2 14.21 15.99 12 15.99Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 12-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","member","employee","person","contact","customer-profile","user-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20L9.12127 19.5149C9.30316 18.7874 9.3941 18.4236 9.66536 18.2118C9.93663 18 10.3116 18 11.0616 18H12.9384C13.6884 18 14.0634 18 14.3346 18.2118C14.6059 18.4236 14.6968 18.7874 14.8787 19.5149L15 20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "setting-cog 12-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","employee","customer","person","member","users","customers","employees"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.9477 18H11.0523C10.3114 18 9.94102 18 9.67159 18.207L9.65918 18.2167C9.39304 18.4279 9.3032 18.7872 9.12352 19.5059C9.06703 19.7319 9.03878 19.8449 9.0972 19.9214L9.09985 19.9248C9.1599 20 9.27636 20 9.50927 20H14.4907C14.7236 20 14.8401 20 14.9002 19.9248L14.9028 19.9214C14.9612 19.8449 14.933 19.7319 14.8765 19.5059C14.6968 18.7872 14.607 18.4279 14.3408 18.2167L14.3284 18.207C14.059 18 13.6886 18 12.9477 18Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","options","configuration","preferences","octagon","gear","nut","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.6569V12V13.3431C5 14.1606 5 14.5694 5.15224 14.9369C5.30448 15.3045 5.59351 15.5935 6.17157 16.1716L7.82843 17.8284L7.82844 17.8284C8.40649 18.4065 8.69552 18.6955 9.06306 18.8478C9.4306 19 9.83935 19 10.6569 19H12H13.3431C14.1606 19 14.5694 19 14.9369 18.8478C15.3045 18.6955 15.5935 18.4065 16.1716 17.8284L17.8284 16.1716C18.4065 15.5935 18.6955 15.3045 18.8478 14.9369C19 14.5694 19 14.1606 19 13.3431V12V10.6569C19 9.83935 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L16.1716 6.17157C15.5935 5.59351 15.3045 5.30448 14.9369 5.15224C14.5694 5 14.1606 5 13.3431 5H12H10.6569C9.83935 5 9.4306 5 9.06306 5.15224C8.69552 5.30448 8.40649 5.59351 7.82843 6.17157L6.17157 7.82843C5.59351 8.40649 5.30448 8.69552 5.15224 9.06306C5 9.4306 5 9.83935 5 10.6569Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 12-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","configuration","options","gear","setup","preferences","admin","tools","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.62862 3.25C7.36092 3.25 7.11351 3.39269 6.97944 3.6244L2.35083 11.6244C2.21966 11.8511 2.21626 12.1298 2.34185 12.3596L6.71323 20.3596C6.84474 20.6003 7.09712 20.75 7.37138 20.75H8.03955L8.4029 19.2966C8.48594 18.9642 8.56353 18.6537 8.65907 18.4029C8.76528 18.1242 8.92058 17.8419 9.20394 17.6206C9.4873 17.3994 9.79881 17.3172 10.095 17.2818C10.3615 17.2499 10.6816 17.25 11.0241 17.25H12.9761C13.3187 17.25 13.6388 17.2499 13.9052 17.2818C14.2015 17.3172 14.513 17.3994 14.7963 17.6206C15.0797 17.8419 15.235 18.1242 15.3412 18.4029C15.4367 18.6537 15.5143 18.9642 15.5974 19.2966L15.9607 20.75H16.6286C16.9029 20.75 17.1553 20.6003 17.2868 20.3596L21.6582 12.3596C21.7806 12.1355 21.7806 11.8645 21.6582 11.6404L17.2868 3.64037C17.1553 3.3997 16.9029 3.25 16.6286 3.25H7.62862ZM12.0001 16C13.657 16 15.0001 14.6569 15.0001 13C15.0001 11.3431 13.657 10 12.0001 10C10.3433 10 9.00013 11.3431 9.00013 13C9.00013 14.6569 10.3433 16 12.0001 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 12": {
        defaultColors: ["#3D4C66"],
        keywords: ["profile","user","account","customer","employee","settings","configuration","management","admin","hexagon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="13" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 20L9.12127 19.5149C9.30316 18.7874 9.3941 18.4236 9.66536 18.2118C9.93663 18 10.3116 18 11.0616 18H12.9384C13.6884 18 14.0634 18 14.3346 18.2118C14.6059 18.4236 14.6968 18.7874 14.8787 19.5149L15 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","options","preferences","system","octagon","control","panel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.6569V12V13.3431C5 14.1606 5 14.5694 5.15224 14.9369C5.30448 15.3045 5.59351 15.5935 6.17157 16.1716L7.82843 17.8284L7.82844 17.8284C8.40649 18.4065 8.69552 18.6955 9.06306 18.8478C9.4306 19 9.83935 19 10.6569 19H12H13.3431C14.1606 19 14.5694 19 14.9369 18.8478C15.3045 18.6955 15.5935 18.4065 16.1716 17.8284L17.8284 16.1716C18.4065 15.5935 18.6955 15.3045 18.8478 14.9369C19 14.5694 19 14.1606 19 13.3431V12V10.6569C19 9.83935 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L16.1716 6.17157C15.5935 5.59351 15.3045 5.30448 14.9369 5.15224C14.5694 5 14.1606 5 13.3431 5H12H10.6569C9.83935 5 9.4306 5 9.06306 5.15224C8.69552 5.30448 8.40649 5.59351 7.82843 6.17157L6.17157 7.82843C5.59351 8.40649 5.30448 8.69552 5.15224 9.06306C5 9.4306 5 9.83935 5 10.6569Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","options","configuration","admin","system","preferences","setup","adjust","control","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0002 12.0002C10.0002 10.8957 10.8957 10.0002 12.0002 10.0002C13.1048 10.0002 14.0002 10.8957 14.0002 12.0002C14.0002 13.1048 13.1048 14.0002 12.0002 14.0002C10.8957 14.0002 10.0002 13.1048 10.0002 12.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.6571 4.00028L10.5183 4.00014C9.83951 3.9991 9.23706 3.99817 8.68066 4.22864C8.12425 4.45911 7.69892 4.88576 7.21966 5.36648L7.1216 5.46474L5.46475 7.1216L5.36649 7.21966C4.88576 7.69891 4.45911 8.12425 4.22864 8.68066C3.99817 9.23706 3.9991 9.83951 4.00014 10.5183L4.00028 10.6571V13.3434L4.00014 13.4822C3.9991 14.1611 3.99817 14.7635 4.22864 15.3199C4.45911 15.8763 4.88576 16.3016 5.36648 16.7809L5.46474 16.879L7.12161 18.5358L7.21967 18.6341C7.69892 19.1148 8.12425 19.5414 8.68066 19.7719C9.23706 20.0024 9.83949 20.0015 10.5183 20.0004L10.6571 20.0003H13.3434L13.4822 20.0004C14.161 20.0015 14.7635 20.0024 15.3199 19.7719C15.8763 19.5414 16.3016 19.1148 16.7809 18.6341L16.879 18.5358L18.5358 16.879L18.6341 16.7809C19.1148 16.3017 19.5414 15.8763 19.7719 15.3199C20.0024 14.7635 20.0015 14.1611 20.0004 13.4823L20.0003 13.3434V10.6571L20.0004 10.5183C20.0015 9.83952 20.0024 9.23706 19.7719 8.68066C19.5414 8.12425 19.1148 7.69891 18.6341 7.21966L18.5358 7.1216L16.879 5.46475L16.7809 5.36649C16.3016 4.88576 15.8763 4.45911 15.3199 4.22864C14.7635 3.99817 14.1611 3.9991 13.4822 4.00014L13.3434 4.00028H10.6571ZM12.0002 8.00024C9.79111 8.00024 8.00024 9.79111 8.00024 12.0002C8.00024 14.2094 9.79111 16.0002 12.0002 16.0002C14.2094 16.0002 16.0002 14.2094 16.0002 12.0002C16.0002 9.79111 14.2094 8.00024 12.0002 8.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","options","configuration","preferences","adjust","system","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 10.6569V12V13.3431C5 14.1606 5 14.5694 5.15224 14.9369C5.30448 15.3045 5.59351 15.5935 6.17157 16.1716L7.82843 17.8284L7.82844 17.8284C8.40649 18.4065 8.69552 18.6955 9.06306 18.8478C9.4306 19 9.83935 19 10.6569 19H12H13.3431C14.1606 19 14.5694 19 14.9369 18.8478C15.3045 18.6955 15.5935 18.4065 16.1716 17.8284L17.8284 16.1716C18.4065 15.5935 18.6955 15.3045 18.8478 14.9369C19 14.5694 19 14.1606 19 13.3431V12V10.6569C19 9.83935 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L16.1716 6.17157C15.5935 5.59351 15.3045 5.30448 14.9369 5.15224C14.5694 5 14.1606 5 13.3431 5H12H10.6569C9.83935 5 9.4306 5 9.06306 5.15224C8.69552 5.30448 8.40649 5.59351 7.82843 6.17157L6.17157 7.82843C5.59351 8.40649 5.30448 8.69552 5.15224 9.06306C5 9.4306 5 9.83935 5 10.6569Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flower","option","menu","promotion","rewards","loyalty","seasonal","seasonal-menu","theme"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.45716 5.86112C8.45268 5.33959 7.18593 5.50027 6.34305 6.34315C5.50019 7.18601 5.3395 8.45273 5.861 9.45721C4.78208 9.79875 4 10.808 4 12C4 13.192 4.78208 14.2012 5.861 14.5428C5.3395 15.5473 5.50019 16.814 6.34305 17.6569C7.18593 18.4997 8.45268 18.6604 9.45716 18.1389C9.79869 19.2179 10.8081 20 12 20C13.1919 20 14.2013 19.218 14.5428 18.139C15.5473 18.6604 16.8139 18.4997 17.6568 17.6569C18.4996 16.814 18.6603 15.5473 18.1388 14.5428C19.2178 14.2013 20 13.192 20 12C20 10.808 19.2178 9.79865 18.1388 9.45716C18.6603 8.45269 18.4996 7.186 17.6568 6.34315C16.8139 5.50031 15.5473 5.33961 14.5428 5.86104C14.2013 4.78202 13.1919 4 12 4C10.8081 4 9.79869 4.78206 9.45716 5.86112Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-cog 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","gear","cog","configuration","options","preferences","customize","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.45716 5.86112C8.45268 5.33959 7.18593 5.50027 6.34305 6.34315C5.50019 7.18601 5.3395 8.45273 5.861 9.45721C4.78208 9.79875 4 10.808 4 12C4 13.192 4.78208 14.2012 5.861 14.5428C5.3395 15.5473 5.50019 16.814 6.34305 17.6569C7.18593 18.4997 8.45268 18.6604 9.45716 18.1389C9.79869 19.2179 10.8081 20 12 20C13.1919 20 14.2013 19.218 14.5428 18.139C15.5473 18.6604 16.8139 18.4997 17.6568 17.6569C18.4996 16.814 18.6603 15.5473 18.1388 14.5428C19.2178 14.2013 20 13.192 20 12C20 10.808 19.2178 9.79865 18.1388 9.45716C18.6603 8.45269 18.4996 7.186 17.6568 6.34315C16.8139 5.50031 15.5473 5.33961 14.5428 5.86104C14.2013 4.78202 13.1919 4 12 4C10.8081 4 9.79869 4.78206 9.45716 5.86112Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-cog 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","options","configure","preferences","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.25C10.7523 3.25 9.66194 3.91848 9.06564 4.91587C7.93875 4.63223 6.69504 4.9305 5.81272 5.81282C4.93041 6.69513 4.63214 7.93882 4.91577 9.06571C3.9185 9.66199 3.25 10.7522 3.25 12C3.25 13.2478 3.9185 14.338 4.91577 14.9343C4.63214 16.0612 4.93041 17.3049 5.81272 18.1872C6.69504 19.0695 7.93875 19.3678 9.06564 19.0841C9.66194 20.0815 10.7523 20.75 12 20.75C13.2477 20.75 14.338 20.0815 14.9343 19.0842C16.0612 19.3677 17.3048 19.0695 18.1871 18.1872C19.0694 17.3049 19.3677 16.0613 19.0841 14.9344C20.0814 14.3381 20.75 13.2478 20.75 12C20.75 10.7522 20.0814 9.66187 19.0841 9.06561C19.3677 7.93875 19.0694 6.6951 18.1871 5.81282C17.3048 4.93054 16.0612 4.63226 14.9343 4.91583C14.338 3.91847 13.2477 3.25 12 3.25ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","gear","cog","options","configuration","preferences","admin","system","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18.8198V18.9624C10 19.5354 10.4646 20 11.0376 20H12.9624C13.5355 20 14 19.5355 14 18.9624V18.8197C14 17.9237 15.1016 17.4956 15.7066 18.1567C16.0843 18.5694 16.73 18.5836 17.1256 18.1881L18.1879 17.1257C18.5835 16.7301 18.5693 16.0844 18.1566 15.7067C17.4955 15.1017 17.9236 14 18.8197 14H18.9624C19.5354 14 20 13.5354 20 12.9624V11.0376C20 10.4646 19.5354 10 18.9624 10H18.8197C17.9236 10 17.4956 8.89836 18.1566 8.29333C18.5693 7.9156 18.5836 7.26994 18.1879 6.87433L17.1256 5.81195C16.73 5.41636 16.0843 5.43065 15.7066 5.84335C15.1016 6.50438 14 6.07637 14 5.18029V5.03756C14 4.46453 13.5355 4 12.9624 4H11.0376C10.4646 4 10 4.46455 10 5.03761V5.18022C10 6.07636 8.89831 6.50442 8.29326 5.84336C7.91551 5.43065 7.26983 5.41637 6.87421 5.81199L5.81188 6.87431C5.41627 7.26992 5.43056 7.9156 5.84327 8.29332C6.50432 8.89833 6.07629 10 5.18018 10H5.03756C4.46453 10 4 10.4645 4 11.0376V12.9624C4 13.5355 4.46454 14 5.03757 14H5.1802C6.07631 14 6.50434 15.1017 5.84329 15.7067C5.43057 16.0844 5.41628 16.7301 5.81189 17.1257L6.87421 18.188C7.26983 18.5836 7.91551 18.5694 8.29327 18.1567C8.89831 17.4956 10 17.9237 10 18.8198Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configuration","admin","options","preferences","system","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0054 11.9999C10.0054 10.8953 10.9008 9.99988 12.0054 9.99988C13.1099 9.99988 14.0054 10.8953 14.0054 11.9999C14.0054 13.1044 13.1099 13.9999 12.0054 13.9999C10.9008 13.9999 10.0054 13.1044 10.0054 11.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0429 3.2749C10.0694 3.2749 9.28027 4.06405 9.28027 5.03751V5.18012C9.28027 5.41478 8.99178 5.52687 8.83334 5.35377C8.17677 4.63641 7.05447 4.6116 6.36683 5.29924L5.3045 6.36156C4.61687 7.0492 4.6417 8.17149 5.35907 8.82805C5.53215 8.98646 5.42007 9.2749 5.18545 9.2749H5.04284C4.0694 9.2749 3.28027 10.064 3.28027 11.0375V12.9623C3.28027 13.9358 4.0694 14.7249 5.04284 14.7249H5.18547C5.4201 14.7249 5.53217 15.0133 5.35909 15.1718C4.6417 15.8283 4.61687 16.9506 5.30451 17.6382L6.36683 18.7006C7.05447 19.3882 8.17676 19.3634 8.83334 18.6461C8.99179 18.4729 9.28027 18.585 9.28027 18.8197V18.9623C9.28027 19.9358 10.0694 20.7199 11.0429 20.7199H12.9677C13.9411 20.7199 14.7303 19.9358 14.7303 18.9623V18.8196C14.7303 18.585 15.0187 18.473 15.1771 18.646C15.8336 19.3634 16.9559 19.3882 17.6435 18.7006L18.7059 17.6382C19.3935 16.9506 19.3687 15.8283 18.6513 15.1718C18.4783 15.0134 18.5903 14.7249 18.825 14.7249H18.9677C19.9411 14.7249 20.7154 13.9358 20.7154 12.9623V11.0375C20.7154 10.064 19.9411 9.2749 18.9677 9.2749H18.825C18.5904 9.2749 18.4783 8.98645 18.6514 8.82804C19.3687 8.17147 19.3935 7.04921 18.7059 6.36158L17.6435 5.2992C16.9559 4.61158 15.8336 4.63641 15.1771 5.35378C15.0187 5.52684 14.7303 5.41478 14.7303 5.18019V5.03747C14.7303 4.06403 13.9411 3.2749 12.9677 3.2749H11.0429ZM12.0054 7.99988C9.79623 7.99988 8.00537 9.79074 8.00537 11.9999C8.00537 14.209 9.79623 15.9999 12.0054 15.9999C14.2145 15.9999 16.0054 14.209 16.0054 11.9999C16.0054 9.79074 14.2145 7.99988 12.0054 7.99988Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["setting","settings","gear","cog","system","options","configuration","preferences","admin","administration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.45716 5.86112C8.45268 5.33959 7.18593 5.50027 6.34305 6.34315C5.50019 7.18601 5.3395 8.45273 5.861 9.45721C4.78208 9.79875 4 10.808 4 12C4 13.192 4.78208 14.2012 5.861 14.5428C5.3395 15.5473 5.50019 16.814 6.34305 17.6569C7.18593 18.4997 8.45268 18.6604 9.45716 18.1389C9.79869 19.2179 10.8081 20 12 20C13.1919 20 14.2013 19.218 14.5428 18.139C15.5473 18.6604 16.8139 18.4997 17.6568 17.6569C18.4996 16.814 18.6603 15.5473 18.1388 14.5428C19.2178 14.2013 20 13.192 20 12C20 10.808 19.2178 9.79865 18.1388 9.45716C18.6603 8.45269 18.4996 7.186 17.6568 6.34315C16.8139 5.50031 15.5473 5.33961 14.5428 5.86104C14.2013 4.78202 13.1919 4 12 4C10.8081 4 9.79869 4.78206 9.45716 5.86112Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-cog 4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","options","configure","customization","preferences","system","setup","admin","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18.8198V18.9624C10 19.5354 10.4646 20 11.0376 20H12.9624C13.5355 20 14 19.5355 14 18.9624V18.8197C14 17.9237 15.1016 17.4956 15.7066 18.1567C16.0843 18.5694 16.73 18.5836 17.1256 18.1881L18.1879 17.1257C18.5835 16.7301 18.5693 16.0844 18.1566 15.7067C17.4955 15.1017 17.9236 14 18.8197 14H18.9624C19.5354 14 20 13.5354 20 12.9624V11.0376C20 10.4646 19.5354 10 18.9624 10H18.8197C17.9236 10 17.4956 8.89836 18.1566 8.29333C18.5693 7.9156 18.5836 7.26994 18.1879 6.87433L17.1256 5.81195C16.73 5.41636 16.0843 5.43065 15.7066 5.84335C15.1016 6.50438 14 6.07637 14 5.18029V5.03756C14 4.46453 13.5355 4 12.9624 4H11.0376C10.4646 4 10 4.46455 10 5.03761V5.18022C10 6.07636 8.89831 6.50442 8.29326 5.84336C7.91551 5.43065 7.26983 5.41637 6.87421 5.81199L5.81188 6.87431C5.41627 7.26992 5.43056 7.9156 5.84327 8.29332C6.50432 8.89833 6.07629 10 5.18018 10H5.03756C4.46453 10 4 10.4645 4 11.0376V12.9624C4 13.5355 4.46454 14 5.03757 14H5.1802C6.07631 14 6.50434 15.1017 5.84329 15.7067C5.43057 16.0844 5.41628 16.7301 5.81189 17.1257L6.87421 18.188C7.26983 18.5836 7.91551 18.5694 8.29327 18.1567C8.89831 17.4956 10 17.9237 10 18.8198Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","options","system-settings","configuration","preferences","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 18.8198V18.9624C10 19.5354 10.4646 20 11.0376 20H12.9624C13.5355 20 14 19.5355 14 18.9624V18.8197C14 17.9237 15.1016 17.4956 15.7066 18.1567C16.0843 18.5694 16.73 18.5836 17.1256 18.1881L18.1879 17.1257C18.5835 16.7301 18.5693 16.0844 18.1566 15.7067C17.4955 15.1017 17.9236 14 18.8197 14H18.9624C19.5354 14 20 13.5354 20 12.9624V11.0376C20 10.4646 19.5354 10 18.9624 10H18.8197C17.9236 10 17.4956 8.89836 18.1566 8.29333C18.5693 7.9156 18.5836 7.26994 18.1879 6.87433L17.1256 5.81195C16.73 5.41636 16.0843 5.43065 15.7066 5.84335C15.1016 6.50438 14 6.07637 14 5.18029V5.03756C14 4.46453 13.5355 4 12.9624 4H11.0376C10.4646 4 10 4.46455 10 5.03761V5.18022C10 6.07636 8.89831 6.50442 8.29326 5.84336C7.91551 5.43065 7.26983 5.41637 6.87421 5.81199L5.81188 6.87431C5.41627 7.26992 5.43056 7.9156 5.84327 8.29332C6.50432 8.89833 6.07629 10 5.18018 10H5.03756C4.46453 10 4 10.4645 4 11.0376V12.9624C4 13.5355 4.46454 14 5.03757 14H5.1802C6.07631 14 6.50434 15.1017 5.84329 15.7067C5.43057 16.0844 5.41628 16.7301 5.81189 17.1257L6.87421 18.188C7.26983 18.5836 7.91551 18.5694 8.29327 18.1567C8.89831 17.4956 10 17.9237 10 18.8198Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","cog","gear","options","configuration","preferences","adjust","system-settings","admin","maintenance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17.8943V18.0042C10 19.1064 10.8978 20 12 20C13.1023 20 14 19.1065 14 18.0042V17.8942C14 17.3262 14.6983 17.0549 15.0818 17.4739L15.1994 17.6025C15.8535 18.3172 16.9717 18.3419 17.6568 17.6568C18.3419 16.9718 18.3171 15.8536 17.6024 15.1995L17.4738 15.0818C17.0548 14.6983 17.3262 14 17.8942 14H18.0041C19.1064 14 20 13.1023 20 12C20 10.8977 19.1064 10 18.0042 10H17.8942C17.3262 10 17.0549 9.30172 17.4739 8.91822L17.6025 8.8005C18.3172 8.14636 18.3419 7.02825 17.6568 6.34318C16.9717 5.65808 15.8535 5.68282 15.1994 6.39755L15.0818 6.52611C14.6983 6.94511 14 6.67381 14 6.10582V5.9958C14 4.89355 13.1023 4 12 4C10.8977 4 10 4.89358 10 5.99586V6.10578C10 6.6738 9.30168 6.94513 8.91817 6.52612L8.80041 6.39746C8.14627 5.68277 7.02815 5.65805 6.34307 6.34313C5.65797 7.02823 5.68271 8.14637 6.39743 8.8005L6.52604 8.91821C6.94505 9.3017 6.67374 10 6.10573 10H5.99579C4.89355 10 4 10.8977 4 12C4 13.1022 4.89355 14 5.99581 14H6.10576C6.67377 14 6.94508 14.6983 6.52607 15.0818L6.39746 15.1995C5.68272 15.8536 5.65798 16.9718 6.34308 17.6569C7.02816 18.342 8.14627 18.3172 8.80041 17.6026L8.91818 17.4739C9.30169 17.0549 10 17.3262 10 17.8943Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["flower","floral","decoration","seasonal","spring","sale","discount","promotion","gift","loyalty","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17.8943V18.0042C10 19.1064 10.8978 20 12 20C13.1023 20 14 19.1065 14 18.0042V17.8942C14 17.3262 14.6983 17.0549 15.0818 17.4739L15.1994 17.6025C15.8535 18.3172 16.9717 18.3419 17.6568 17.6568C18.3419 16.9718 18.3171 15.8536 17.6024 15.1995L17.4738 15.0818C17.0548 14.6983 17.3262 14 17.8942 14H18.0041C19.1064 14 20 13.1023 20 12C20 10.8977 19.1064 10 18.0042 10H17.8942C17.3262 10 17.0549 9.30172 17.4739 8.91822L17.6025 8.8005C18.3172 8.14636 18.3419 7.02825 17.6568 6.34318C16.9717 5.65808 15.8535 5.68282 15.1994 6.39755L15.0818 6.52611C14.6983 6.94511 14 6.67381 14 6.10582V5.9958C14 4.89355 13.1023 4 12 4C10.8977 4 10 4.89358 10 5.99586V6.10578C10 6.6738 9.30168 6.94513 8.91817 6.52612L8.80041 6.39746C8.14627 5.68277 7.02815 5.65805 6.34307 6.34313C5.65797 7.02823 5.68271 8.14637 6.39743 8.8005L6.52604 8.91821C6.94505 9.3017 6.67374 10 6.10573 10H5.99579C4.89355 10 4 10.8977 4 12C4 13.1022 4.89355 14 5.99581 14H6.10576C6.67377 14 6.94508 14.6983 6.52607 15.0818L6.39746 15.1995C5.68272 15.8536 5.65798 16.9718 6.34308 17.6569C7.02816 18.342 8.14627 18.3172 8.80041 17.6026L8.91818 17.4739C9.30169 17.0549 10 17.3262 10 17.8943Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configuration","admin","preferences","customize","options","system","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17.8943V18.0042C10 19.1064 10.8978 20 12 20C13.1023 20 14 19.1065 14 18.0042V17.8942C14 17.3262 14.6983 17.0549 15.0818 17.4739L15.1994 17.6025C15.8535 18.3172 16.9717 18.3419 17.6568 17.6568C18.3419 16.9718 18.3171 15.8536 17.6024 15.1995L17.4738 15.0818C17.0548 14.6983 17.3262 14 17.8942 14H18.0041C19.1064 14 20 13.1023 20 12C20 10.8977 19.1064 10 18.0042 10H17.8942C17.3262 10 17.0549 9.30172 17.4739 8.91822L17.6025 8.8005C18.3172 8.14636 18.3419 7.02825 17.6568 6.34318C16.9717 5.65808 15.8535 5.68282 15.1994 6.39755L15.0818 6.52611C14.6983 6.94511 14 6.67381 14 6.10582V5.9958C14 4.89355 13.1023 4 12 4C10.8977 4 10 4.89358 10 5.99586V6.10578C10 6.6738 9.30168 6.94513 8.91817 6.52612L8.80041 6.39746C8.14627 5.68277 7.02815 5.65805 6.34307 6.34313C5.65797 7.02823 5.68271 8.14637 6.39743 8.8005L6.52604 8.91821C6.94505 9.3017 6.67374 10 6.10573 10H5.99579C4.89355 10 4 10.8977 4 12C4 13.1022 4.89355 14 5.99581 14H6.10576C6.67377 14 6.94508 14.6983 6.52607 15.0818L6.39746 15.1995C5.68272 15.8536 5.65798 16.9718 6.34308 17.6569C7.02816 18.342 8.14627 18.3172 8.80041 17.6026L8.91818 17.4739C9.30169 17.0549 10 17.3262 10 17.8943Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.45"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","options","customize","preferences","flower","configurations","system-settings","system-preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0005 12C10.0005 10.8954 10.8959 10 12.0005 10C13.1051 10 14.0005 10.8954 14.0005 12C14.0005 13.1046 13.1051 14 12.0005 14C10.8959 14 10.0005 13.1046 10.0005 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0004 3.27002C10.549 3.27002 9.35616 4.41262 9.27932 5.84852C8.33962 4.88767 6.78853 4.87279 5.83081 5.83052C4.8731 6.78823 4.88796 8.33928 5.84874 9.27898C4.41289 9.35585 3.27539 10.5487 3.27539 12C3.27539 13.4514 4.41291 14.6442 5.84877 14.7211C4.88798 15.6608 4.87311 17.2119 5.83082 18.1696C6.78854 19.1273 8.33962 19.1124 9.27933 18.1516C9.35617 19.5875 10.549 20.725 12.0004 20.725C13.4518 20.725 14.6446 19.5875 14.7215 18.1517C15.6612 19.1124 17.2121 19.1272 18.1698 18.1695C19.1275 17.2118 19.1127 15.6608 18.1519 14.7211C19.5878 14.6443 20.7305 13.4514 20.7305 12C20.7305 10.5486 19.5878 9.35582 18.1519 9.27898C19.1127 8.33927 19.1275 6.78826 18.1698 5.83057C17.2122 4.87288 15.6612 4.88772 14.7215 5.84843C14.6446 4.41257 13.4518 3.27002 12.0004 3.27002ZM12.0005 8.00002C9.79135 8.00002 8.00049 9.79088 8.00049 12C8.00049 14.2092 9.79135 16 12.0005 16C14.2096 16 16.0005 14.2092 16.0005 12C16.0005 9.79088 14.2096 8.00002 12.0005 8.00002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 6-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","gear","cog","configuration","admin","options","system","preferences","customize","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.3249 7.01113L16.9889 5.67514C16.6371 5.32334 16.0996 5.23613 15.6546 5.45863C15.0255 5.77319 14.2636 5.45762 14.0412 4.79033C13.8838 4.31835 13.4422 4 12.9447 4H11.0552C10.5577 4 10.1161 4.31835 9.95874 4.79032C9.73631 5.45759 8.97443 5.77315 8.34532 5.4586C7.90033 5.2361 7.36287 5.32331 7.01108 5.6751L5.6751 7.01109C5.3233 7.36289 5.23609 7.90035 5.45859 8.34534C5.77314 8.97445 5.45759 9.73634 4.79031 9.95877C4.31835 10.1161 4 10.5578 4 11.0553V12.9447C4 13.4422 4.31835 13.8839 4.79033 14.0412C5.45762 14.2637 5.77319 15.0255 5.45863 15.6547C5.23614 16.0996 5.32335 16.6371 5.67514 16.9889L7.01114 18.3249C7.36293 18.6767 7.90039 18.7639 8.34538 18.5414C8.97451 18.2268 9.7364 18.5424 9.95883 19.2097C10.1162 19.6816 10.5578 20 11.0554 20L12.9448 20C13.4423 20 13.8839 19.6817 14.0413 19.2097C14.2637 18.5424 15.0256 18.2268 15.6547 18.5414C16.0997 18.7639 16.6371 18.6767 16.9889 18.3249L18.3249 16.9889C18.6767 16.6371 18.7639 16.0996 18.5414 15.6547C18.2269 15.0255 18.5424 14.2637 19.2097 14.0412C19.6817 13.8839 20 13.4422 20 12.9447V11.0553C20 10.5578 19.6816 10.1161 19.2097 9.95876C18.5424 9.73633 18.2268 8.97446 18.5414 8.34534C18.7639 7.90035 18.6766 7.36292 18.3249 7.01113Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","admin","configuration","preferences","options","maintenance","tools","system","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0552 3.25C10.2349 3.25 9.50663 3.77492 9.24723 4.55314C9.16914 4.78741 8.90163 4.89823 8.68073 4.78778C7.94701 4.42092 7.06082 4.5647 6.48075 5.14477L5.14477 6.48076C4.56469 7.06084 4.42091 7.94703 4.78777 8.68075C4.89822 8.90166 4.7874 9.16917 4.55314 9.24726C3.77492 9.50666 3.25 10.2349 3.25 11.0553V12.9447C3.25 13.765 3.77493 14.4933 4.55316 14.7527C4.78745 14.8308 4.89826 15.0984 4.78781 15.3193C4.42095 16.053 4.56475 16.9391 5.14481 17.5192L6.48081 18.8552C7.06088 19.4353 7.94706 19.5791 8.68079 19.2122C8.9017 19.1017 9.16922 19.2126 9.24731 19.4468C9.50673 20.2251 10.235 20.75 11.0554 20.75L12.9448 20.75C13.7651 20.75 14.4934 20.2251 14.7528 19.4469C14.8309 19.2126 15.0984 19.1018 15.3193 19.2122C16.053 19.5791 16.9392 19.4353 17.5193 18.8552L18.8552 17.5192C19.4353 16.9392 19.5791 16.053 19.2122 15.3192C19.1018 15.0983 19.2126 14.8308 19.4469 14.7527C20.2251 14.4933 20.75 13.765 20.75 12.9447V11.0553C20.75 10.235 20.2251 9.50666 19.4468 9.24725C19.2125 9.16915 19.1017 8.90164 19.2122 8.68075C19.5791 7.94702 19.4352 7.06086 18.8552 6.4808L17.5192 5.14481C16.9391 4.56474 16.0529 4.42094 15.3192 4.78781C15.0983 4.89826 14.8308 4.78745 14.7527 4.55316C14.4933 3.77493 13.765 3.25 12.9447 3.25H11.0552ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 6-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","options","configuration","adjust","customize","preferences","tools","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3249 7.01113L16.9889 5.67514C16.6371 5.32334 16.0996 5.23613 15.6546 5.45863C15.0255 5.77319 14.2636 5.45762 14.0412 4.79033C13.8838 4.31835 13.4422 4 12.9447 4H11.0552C10.5577 4 10.1161 4.31835 9.95874 4.79032C9.73631 5.45759 8.97443 5.77315 8.34532 5.4586C7.90033 5.2361 7.36287 5.32331 7.01108 5.6751L5.6751 7.01109C5.3233 7.36289 5.23609 7.90035 5.45859 8.34534C5.77314 8.97445 5.45759 9.73634 4.79031 9.95877C4.31835 10.1161 4 10.5578 4 11.0553V12.9447C4 13.4422 4.31835 13.8839 4.79033 14.0412C5.45762 14.2637 5.77319 15.0255 5.45863 15.6547C5.23614 16.0996 5.32335 16.6371 5.67514 16.9889L7.01114 18.3249C7.36293 18.6767 7.90039 18.7639 8.34538 18.5414C8.97451 18.2268 9.7364 18.5424 9.95883 19.2097C10.1162 19.6816 10.5578 20 11.0554 20L12.9448 20C13.4423 20 13.8839 19.6817 14.0413 19.2097C14.2637 18.5424 15.0256 18.2268 15.6547 18.5414C16.0997 18.7639 16.6371 18.6767 16.9889 18.3249L18.3249 16.9889C18.6767 16.6371 18.7639 16.0996 18.5414 15.6547C18.2269 15.0255 18.5424 14.2637 19.2097 14.0412C19.6817 13.8839 20 13.4422 20 12.9447V11.0553C20 10.5578 19.6816 10.1161 19.2097 9.95876C18.5424 9.73633 18.2268 8.97446 18.5414 8.34534C18.7639 7.90035 18.6766 7.36292 18.3249 7.01113Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 7-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","cog","gear","options","configuration","admin","system-settings","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.3249 7.01113L16.9889 5.67514L16.9889 5.67513C16.9129 5.59922 16.875 5.56126 16.8374 5.53033C16.5594 5.30183 16.1801 5.24028 15.8442 5.36916C15.7987 5.3866 15.7507 5.41061 15.6546 5.45863L15.6546 5.45863C15.5076 5.53213 15.4341 5.56888 15.3709 5.59054C14.8941 5.75398 14.3701 5.53696 14.1485 5.08421C14.1191 5.02419 14.0931 4.94624 14.0412 4.79033C14.0072 4.68849 13.9903 4.63757 13.9704 4.59308C13.824 4.26438 13.5123 4.0397 13.1541 4.00473C13.1057 4 13.052 4 12.9447 4H11.0552C10.9479 4 10.8942 4 10.8458 4.00473C10.4876 4.03969 10.1759 4.26439 10.0295 4.5931C10.0097 4.63758 9.99268 4.68848 9.95874 4.7903L9.95874 4.79032C9.90678 4.9462 9.8808 5.02414 9.85142 5.08415C9.62981 5.53692 9.10585 5.75395 8.629 5.5905C8.56579 5.56883 8.4923 5.53209 8.34533 5.4586L8.34532 5.4586C8.24928 5.41058 8.20127 5.38657 8.15579 5.36913C7.81983 5.24024 7.44053 5.30179 7.16257 5.5303C7.12495 5.56123 7.08699 5.59919 7.01108 5.6751L7.01108 5.6751L5.6751 7.01109C5.59918 7.08701 5.56122 7.12497 5.53029 7.16259C5.30178 7.44055 5.24023 7.81985 5.36911 8.1558C5.38656 8.20128 5.41057 8.2493 5.45859 8.34534C5.53208 8.49233 5.56883 8.56582 5.59049 8.62902C5.75394 9.10588 5.53691 9.62984 5.08414 9.85146C5.02413 9.88083 4.94619 9.90681 4.79031 9.95877C4.68849 9.99271 4.63758 10.0097 4.5931 10.0295C4.26439 10.1759 4.03969 10.4877 4.00473 10.8458C4 10.8943 4 10.9479 4 11.0553V12.9447C4 13.0521 4 13.1057 4.00473 13.1542C4.0397 13.5123 4.26439 13.8241 4.59309 13.9705C4.63757 13.9903 4.68848 14.0073 4.7903 14.0412L4.79033 14.0412C4.94623 14.0932 5.02418 14.1192 5.0842 14.1486C5.53695 14.3702 5.75397 14.8941 5.59054 15.371C5.56887 15.4342 5.53212 15.5077 5.45863 15.6547C5.41063 15.7507 5.38662 15.7987 5.36918 15.8442C5.24029 16.1801 5.30184 16.5594 5.53036 16.8374C5.56129 16.875 5.59924 16.913 5.67514 16.9889L7.01114 18.3249C7.08705 18.4008 7.12501 18.4387 7.16264 18.4697C7.4406 18.6982 7.81989 18.7597 8.15585 18.6308C8.20132 18.6134 8.24933 18.5894 8.34533 18.5414L8.34538 18.5414C8.49238 18.4679 8.56588 18.4311 8.6291 18.4095C9.10594 18.246 9.62988 18.463 9.85149 18.9158C9.88087 18.9758 9.90686 19.0538 9.95883 19.2097L9.95883 19.2097C9.99277 19.3115 10.0097 19.3624 10.0296 19.4069C10.176 19.7356 10.4877 19.9603 10.8459 19.9953C10.8943 20 10.948 20 11.0554 20L12.9448 20C13.0521 20 13.1058 20 13.1542 19.9953C13.5124 19.9603 13.8241 19.7356 13.9705 19.4069C13.9903 19.3624 14.0073 19.3115 14.0413 19.2097L14.0413 19.2097C14.0932 19.0538 14.1192 18.9759 14.1486 18.9158C14.3702 18.4631 14.8942 18.2461 15.371 18.4095C15.4342 18.4312 15.5077 18.4679 15.6547 18.5414L15.6547 18.5414L15.6548 18.5414C15.7507 18.5894 15.7987 18.6134 15.8442 18.6309C16.1802 18.7598 16.5595 18.6982 16.8374 18.4697C16.8751 18.4388 16.913 18.4008 16.9889 18.3249L18.3249 16.9889C18.4008 16.913 18.4388 16.875 18.4697 16.8374C18.6982 16.5594 18.7598 16.1802 18.6309 15.8442C18.6134 15.7987 18.5894 15.7507 18.5414 15.6547L18.5414 15.6546C18.4679 15.5077 18.4312 15.4342 18.4095 15.371C18.2461 14.8941 18.4631 14.3702 18.9159 14.1485C18.9759 14.1192 19.0538 14.0932 19.2097 14.0412L19.2097 14.0412C19.3115 14.0073 19.3624 13.9903 19.4069 13.9705C19.7356 13.8241 19.9603 13.5123 19.9953 13.1542C20 13.1057 20 13.0521 20 12.9447V11.0553C20 10.9479 20 10.8943 19.9953 10.8458C19.9603 10.4877 19.7356 10.1759 19.4069 10.0295C19.3624 10.0097 19.3115 9.99271 19.2097 9.95876L19.2096 9.95875C19.0538 9.90679 18.9758 9.88081 18.9158 9.85143C18.4631 9.62982 18.246 9.10588 18.4095 8.62903C18.4311 8.56582 18.4679 8.49232 18.5414 8.34534C18.5894 8.24932 18.6134 8.20132 18.6308 8.15585C18.7597 7.81988 18.6982 7.44058 18.4696 7.16261C18.4387 7.12499 18.4008 7.08704 18.3249 7.01113Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 6": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","configuration","options","admin","preferences","system","customize","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.3249 7.01113L16.9889 5.67514C16.6371 5.32334 16.0996 5.23613 15.6546 5.45863C15.0255 5.77319 14.2636 5.45762 14.0412 4.79033C13.8838 4.31835 13.4422 4 12.9447 4H11.0552C10.5577 4 10.1161 4.31835 9.95874 4.79032C9.73631 5.45759 8.97443 5.77315 8.34532 5.4586C7.90033 5.2361 7.36287 5.32331 7.01108 5.6751L5.6751 7.01109C5.3233 7.36289 5.23609 7.90035 5.45859 8.34534C5.77314 8.97445 5.45759 9.73634 4.79031 9.95877C4.31835 10.1161 4 10.5578 4 11.0553V12.9447C4 13.4422 4.31835 13.8839 4.79033 14.0412C5.45762 14.2637 5.77319 15.0255 5.45863 15.6547C5.23614 16.0996 5.32335 16.6371 5.67514 16.9889L7.01114 18.3249C7.36293 18.6767 7.90039 18.7639 8.34538 18.5414C8.97451 18.2268 9.7364 18.5424 9.95883 19.2097C10.1162 19.6816 10.5578 20 11.0554 20L12.9448 20C13.4423 20 13.8839 19.6817 14.0413 19.2097C14.2637 18.5424 15.0256 18.2268 15.6547 18.5414C16.0997 18.7639 16.6371 18.6767 16.9889 18.3249L18.3249 16.9889C18.6767 16.6371 18.7639 16.0996 18.5414 15.6547C18.2269 15.0255 18.5424 14.2637 19.2097 14.0412C19.6817 13.8839 20 13.4422 20 12.9447V11.0553C20 10.5578 19.6816 10.1161 19.2097 9.95876C18.5424 9.73633 18.2268 8.97446 18.5414 8.34534C18.7639 7.90035 18.6766 7.36292 18.3249 7.01113Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 7": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","options","configuration","preferences","system","admin","tools","maintenance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.3249 7.01113L16.9889 5.67514L16.9889 5.67513C16.9129 5.59922 16.875 5.56126 16.8374 5.53033C16.5594 5.30183 16.1801 5.24028 15.8442 5.36916C15.7987 5.3866 15.7507 5.41061 15.6546 5.45863L15.6546 5.45863C15.5076 5.53213 15.4341 5.56888 15.3709 5.59054C14.8941 5.75398 14.3701 5.53696 14.1485 5.08421C14.1191 5.02419 14.0931 4.94624 14.0412 4.79033C14.0072 4.68849 13.9903 4.63757 13.9704 4.59308C13.824 4.26438 13.5123 4.0397 13.1541 4.00473C13.1057 4 13.052 4 12.9447 4H11.0552C10.9479 4 10.8942 4 10.8458 4.00473C10.4876 4.03969 10.1759 4.26439 10.0295 4.5931C10.0097 4.63758 9.99268 4.68848 9.95874 4.7903L9.95874 4.79032C9.90678 4.9462 9.8808 5.02414 9.85142 5.08415C9.62981 5.53692 9.10585 5.75395 8.629 5.5905C8.56579 5.56883 8.4923 5.53209 8.34533 5.4586L8.34532 5.4586C8.24928 5.41058 8.20127 5.38657 8.15579 5.36913C7.81983 5.24024 7.44053 5.30179 7.16257 5.5303C7.12495 5.56123 7.08699 5.59919 7.01108 5.6751L7.01108 5.6751L5.6751 7.01109C5.59918 7.08701 5.56122 7.12497 5.53029 7.16259C5.30178 7.44055 5.24023 7.81985 5.36911 8.1558C5.38656 8.20128 5.41057 8.2493 5.45859 8.34534C5.53208 8.49233 5.56883 8.56582 5.59049 8.62902C5.75394 9.10588 5.53691 9.62984 5.08414 9.85146C5.02413 9.88083 4.94619 9.90681 4.79031 9.95877C4.68849 9.99271 4.63758 10.0097 4.5931 10.0295C4.26439 10.1759 4.03969 10.4877 4.00473 10.8458C4 10.8943 4 10.9479 4 11.0553V12.9447C4 13.0521 4 13.1057 4.00473 13.1542C4.0397 13.5123 4.26439 13.8241 4.59309 13.9705C4.63757 13.9903 4.68848 14.0073 4.7903 14.0412L4.79033 14.0412C4.94623 14.0932 5.02418 14.1192 5.0842 14.1486C5.53695 14.3702 5.75397 14.8941 5.59054 15.371C5.56887 15.4342 5.53212 15.5077 5.45863 15.6547C5.41063 15.7507 5.38662 15.7987 5.36918 15.8442C5.24029 16.1801 5.30184 16.5594 5.53036 16.8374C5.56129 16.875 5.59924 16.913 5.67514 16.9889L7.01114 18.3249C7.08705 18.4008 7.12501 18.4387 7.16264 18.4697C7.4406 18.6982 7.81989 18.7597 8.15585 18.6308C8.20132 18.6134 8.24933 18.5894 8.34533 18.5414L8.34538 18.5414C8.49238 18.4679 8.56588 18.4311 8.6291 18.4095C9.10594 18.246 9.62988 18.463 9.85149 18.9158C9.88087 18.9758 9.90686 19.0538 9.95883 19.2097L9.95883 19.2097C9.99277 19.3115 10.0097 19.3624 10.0296 19.4069C10.176 19.7356 10.4877 19.9603 10.8459 19.9953C10.8943 20 10.948 20 11.0554 20L12.9448 20C13.0521 20 13.1058 20 13.1542 19.9953C13.5124 19.9603 13.8241 19.7356 13.9705 19.4069C13.9903 19.3624 14.0073 19.3115 14.0413 19.2097L14.0413 19.2097C14.0932 19.0538 14.1192 18.9759 14.1486 18.9158C14.3702 18.4631 14.8942 18.2461 15.371 18.4095C15.4342 18.4312 15.5077 18.4679 15.6547 18.5414L15.6547 18.5414L15.6548 18.5414C15.7507 18.5894 15.7987 18.6134 15.8442 18.6309C16.1802 18.7598 16.5595 18.6982 16.8374 18.4697C16.8751 18.4388 16.913 18.4008 16.9889 18.3249L18.3249 16.9889C18.4008 16.913 18.4388 16.875 18.4697 16.8374C18.6982 16.5594 18.7598 16.1802 18.6309 15.8442C18.6134 15.7987 18.5894 15.7507 18.5414 15.6547L18.5414 15.6546C18.4679 15.5077 18.4312 15.4342 18.4095 15.371C18.2461 14.8941 18.4631 14.3702 18.9159 14.1485C18.9759 14.1192 19.0538 14.0932 19.2097 14.0412L19.2097 14.0412C19.3115 14.0073 19.3624 13.9903 19.4069 13.9705C19.7356 13.8241 19.9603 13.5123 19.9953 13.1542C20 13.1057 20 13.0521 20 12.9447V11.0553C20 10.9479 20 10.8943 19.9953 10.8458C19.9603 10.4877 19.7356 10.1759 19.4069 10.0295C19.3624 10.0097 19.3115 9.99271 19.2097 9.95876L19.2096 9.95875C19.0538 9.90679 18.9758 9.88081 18.9158 9.85143C18.4631 9.62982 18.246 9.10588 18.4095 8.62903C18.4311 8.56582 18.4679 8.49232 18.5414 8.34534C18.5894 8.24932 18.6134 8.20132 18.6308 8.15585C18.7597 7.81988 18.6982 7.44058 18.4696 7.16261C18.4387 7.12499 18.4008 7.08704 18.3249 7.01113Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","configuration","admin","options","preferences","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14.26C13.2426 14.26 14.25 13.2527 14.25 12.01C14.25 10.7674 13.2426 9.76001 12 9.76001C10.7574 9.76001 9.75 10.7674 9.75 12.01C9.75 13.2527 10.7574 14.26 12 14.26Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.86 6.49001L17.51 5.14001C17.42 5.05001 17.36 5.00001 17.31 4.96001C16.82 4.56001 16.16 4.45001 15.57 4.68001C15.51 4.70001 15.45 4.73001 15.31 4.80001C15.22 4.85001 15.16 4.88001 15.12 4.89001C15 4.93001 14.87 4.88001 14.82 4.77001C14.8 4.73001 14.78 4.67001 14.74 4.53001C14.7 4.42001 14.68 4.36001 14.66 4.30001C14.4 3.72001 13.85 3.32 13.22 3.25C13.16 3.25 13.08 3.25 12.94 3.25H11.05C10.91 3.25 10.84 3.25 10.77 3.25C10.15 3.31 9.6 3.72001 9.34 4.29001C9.32 4.34001 9.29 4.41001 9.24 4.55001C9.21 4.65001 9.19 4.71001 9.17 4.75001C9.11 4.86001 8.98 4.92001 8.87 4.88001C8.83 4.86001 8.78 4.84001 8.64 4.77001C8.53 4.72001 8.47 4.69001 8.42 4.67001C7.83 4.44001 7.17 4.55001 6.68 4.95001C6.63 4.99001 6.58 5.04001 6.48 5.14001L5.12 6.50001C5.03 6.59001 4.99 6.64001 4.95 6.69001C4.55 7.18001 4.44 7.84001 4.67 8.43001C4.69 8.49001 4.72 8.56001 4.79 8.70001C4.83 8.79001 4.86 8.84001 4.88 8.88001C4.92 9.00001 4.87 9.13001 4.76 9.19001C4.72 9.21001 4.66 9.23001 4.55 9.26001C4.42 9.30001 4.35 9.33001 4.29 9.36001C3.71 9.61001 3.32 10.16 3.25 10.78C3.25 10.85 3.25 10.92 3.25 11.06V12.95C3.25 13.1 3.25 13.17 3.25 13.23C3.31 13.85 3.71 14.4 4.28 14.66C4.34 14.69 4.41 14.71 4.56 14.76C4.66 14.79 4.71 14.81 4.75 14.83C4.86 14.89 4.92 15.02 4.88 15.13C4.86 15.17 4.84 15.22 4.77 15.35C4.71 15.46 4.68 15.53 4.66 15.58C4.44 16.17 4.54 16.83 4.94 17.32C4.98 17.37 5.03 17.42 5.13 17.52L6.47 18.86C6.57 18.96 6.63 19.01 6.68 19.05C7.16 19.45 7.83 19.56 8.42 19.33C8.48 19.31 8.54 19.28 8.67 19.21C8.77 19.16 8.82 19.13 8.86 19.12C8.98 19.08 9.11 19.13 9.17 19.24C9.19 19.28 9.21 19.34 9.25 19.47C9.29 19.59 9.31 19.65 9.34 19.71C9.59 20.28 10.14 20.69 10.77 20.75C10.84 20.75 10.91 20.75 11.05 20.75H12.94C13.08 20.75 13.16 20.75 13.22 20.75C13.84 20.69 14.39 20.28 14.65 19.71C14.68 19.65 14.7 19.58 14.75 19.45C14.78 19.35 14.8 19.29 14.82 19.25C14.87 19.14 15.01 19.08 15.12 19.12C15.16 19.14 15.22 19.17 15.32 19.22C15.45 19.28 15.51 19.31 15.58 19.34C16.17 19.57 16.83 19.46 17.33 19.05C17.38 19.01 17.43 18.96 17.53 18.86L18.88 17.51C18.97 17.42 19.02 17.37 19.06 17.31C19.46 16.82 19.57 16.16 19.34 15.57C19.32 15.51 19.29 15.44 19.22 15.31C19.17 15.21 19.14 15.15 19.13 15.12C19.09 15 19.14 14.87 19.25 14.81C19.29 14.79 19.35 14.77 19.45 14.74C19.59 14.69 19.66 14.67 19.72 14.64C20.29 14.38 20.69 13.84 20.75 13.21C20.75 13.14 20.75 13.07 20.75 12.93V11.04C20.75 10.89 20.75 10.82 20.75 10.76C20.69 10.14 20.29 9.59001 19.71 9.33001C19.65 9.30001 19.59 9.28001 19.45 9.24001C19.35 9.21001 19.29 9.19001 19.25 9.17001C19.14 9.11001 19.08 8.98001 19.12 8.87001C19.14 8.83001 19.16 8.78001 19.21 8.68001C19.28 8.55001 19.31 8.48001 19.33 8.42001C19.56 7.83001 19.45 7.17001 19.05 6.68001C19.01 6.63001 18.96 6.58001 18.87 6.49001M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93001 9.93 8.25001 12 8.25001C14.07 8.25001 15.75 9.93001 15.75 12C15.75 14.07 14.07 15.75 12 15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 7-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","configuration","preferences","admin","system","options","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3249 7.01113L16.9889 5.67514L16.9889 5.67513C16.9129 5.59922 16.875 5.56126 16.8374 5.53033C16.5594 5.30183 16.1801 5.24028 15.8442 5.36916C15.7987 5.3866 15.7507 5.41061 15.6546 5.45863L15.6546 5.45863C15.5076 5.53213 15.4341 5.56888 15.3709 5.59054C14.8941 5.75398 14.3701 5.53696 14.1485 5.08421C14.1191 5.02419 14.0931 4.94624 14.0412 4.79033C14.0072 4.68849 13.9903 4.63757 13.9704 4.59308C13.824 4.26438 13.5123 4.0397 13.1541 4.00473C13.1057 4 13.052 4 12.9447 4H11.0552C10.9479 4 10.8942 4 10.8458 4.00473C10.4876 4.03969 10.1759 4.26439 10.0295 4.5931C10.0097 4.63758 9.99268 4.68848 9.95874 4.7903L9.95874 4.79032C9.90678 4.9462 9.8808 5.02414 9.85142 5.08415C9.62981 5.53692 9.10585 5.75395 8.629 5.5905C8.56579 5.56883 8.4923 5.53209 8.34533 5.4586L8.34532 5.4586C8.24928 5.41058 8.20127 5.38657 8.15579 5.36913C7.81983 5.24024 7.44053 5.30179 7.16257 5.5303C7.12495 5.56123 7.08699 5.59919 7.01108 5.6751L7.01108 5.6751L5.6751 7.01109C5.59918 7.08701 5.56122 7.12497 5.53029 7.16259C5.30178 7.44055 5.24023 7.81985 5.36911 8.1558C5.38656 8.20128 5.41057 8.2493 5.45859 8.34534C5.53208 8.49233 5.56883 8.56582 5.59049 8.62902C5.75394 9.10588 5.53691 9.62984 5.08414 9.85146C5.02413 9.88083 4.94619 9.90681 4.79031 9.95877C4.68849 9.99271 4.63758 10.0097 4.5931 10.0295C4.26439 10.1759 4.03969 10.4877 4.00473 10.8458C4 10.8943 4 10.9479 4 11.0553V12.9447C4 13.0521 4 13.1057 4.00473 13.1542C4.0397 13.5123 4.26439 13.8241 4.59309 13.9705C4.63757 13.9903 4.68848 14.0073 4.7903 14.0412L4.79033 14.0412C4.94623 14.0932 5.02418 14.1192 5.0842 14.1486C5.53695 14.3702 5.75397 14.8941 5.59054 15.371C5.56887 15.4342 5.53212 15.5077 5.45863 15.6547C5.41063 15.7507 5.38662 15.7987 5.36918 15.8442C5.24029 16.1801 5.30184 16.5594 5.53036 16.8374C5.56129 16.875 5.59924 16.913 5.67514 16.9889L7.01114 18.3249C7.08705 18.4008 7.12501 18.4387 7.16264 18.4697C7.4406 18.6982 7.81989 18.7597 8.15585 18.6308C8.20132 18.6134 8.24933 18.5894 8.34533 18.5414L8.34538 18.5414C8.49238 18.4679 8.56588 18.4311 8.6291 18.4095C9.10594 18.246 9.62988 18.463 9.85149 18.9158C9.88087 18.9758 9.90686 19.0538 9.95883 19.2097L9.95883 19.2097C9.99277 19.3115 10.0097 19.3624 10.0296 19.4069C10.176 19.7356 10.4877 19.9603 10.8459 19.9953C10.8943 20 10.948 20 11.0554 20L12.9448 20C13.0521 20 13.1058 20 13.1542 19.9953C13.5124 19.9603 13.8241 19.7356 13.9705 19.4069C13.9903 19.3624 14.0073 19.3115 14.0413 19.2097L14.0413 19.2097C14.0932 19.0538 14.1192 18.9759 14.1486 18.9158C14.3702 18.4631 14.8942 18.2461 15.371 18.4095C15.4342 18.4312 15.5077 18.4679 15.6547 18.5414L15.6547 18.5414L15.6548 18.5414C15.7507 18.5894 15.7987 18.6134 15.8442 18.6309C16.1802 18.7598 16.5595 18.6982 16.8374 18.4697C16.8751 18.4388 16.913 18.4008 16.9889 18.3249L18.3249 16.9889C18.4008 16.913 18.4388 16.875 18.4697 16.8374C18.6982 16.5594 18.7598 16.1802 18.6309 15.8442C18.6134 15.7987 18.5894 15.7507 18.5414 15.6547L18.5414 15.6546C18.4679 15.5077 18.4312 15.4342 18.4095 15.371C18.2461 14.8941 18.4631 14.3702 18.9159 14.1485C18.9759 14.1192 19.0538 14.0932 19.2097 14.0412L19.2097 14.0412C19.3115 14.0073 19.3624 13.9903 19.4069 13.9705C19.7356 13.8241 19.9603 13.5123 19.9953 13.1542C20 13.1057 20 13.0521 20 12.9447V11.0553C20 10.9479 20 10.8943 19.9953 10.8458C19.9603 10.4877 19.7356 10.1759 19.4069 10.0295C19.3624 10.0097 19.3115 9.99271 19.2097 9.95876L19.2096 9.95875C19.0538 9.90679 18.9758 9.88081 18.9158 9.85143C18.4631 9.62982 18.246 9.10588 18.4095 8.62903C18.4311 8.56582 18.4679 8.49232 18.5414 8.34534C18.5894 8.24932 18.6134 8.20132 18.6308 8.15585C18.7597 7.81988 18.6982 7.44058 18.4696 7.16261C18.4387 7.12499 18.4008 7.08704 18.3249 7.01113Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 8-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","configuration","admin","options","system","tools","preferences","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9103 7.59655L16.4034 5.08971C16.4013 5.08753 16.3979 5.08698 16.3951 5.08837C15.3752 5.59834 14.14 5.08674 13.7794 4.00491C13.7784 4.00198 13.7756 4 13.7726 4H10.2274C10.2243 4 10.2215 4.00198 10.2205 4.00491C9.85994 5.08672 8.62473 5.5983 7.60479 5.08833C7.60203 5.08695 7.59869 5.08749 7.5965 5.08968L5.08966 7.59652C5.08748 7.5987 5.08694 7.60204 5.08832 7.60481C5.59829 8.62474 5.08671 9.85997 4.00491 10.2206C4.00198 10.2215 4 10.2243 4 10.2274V13.7726C4 13.7757 4.00198 13.7785 4.00491 13.7794C5.08673 14.14 5.59836 15.3752 5.08838 16.3952C5.087 16.3979 5.08754 16.4013 5.08973 16.4035L7.59657 18.9103C7.59875 18.9125 7.60209 18.913 7.60485 18.9116C8.62481 18.4017 9.86002 18.9133 10.2206 19.9951C10.2216 19.998 10.2244 20 10.2274 20L13.7727 20C13.7757 20 13.7785 19.998 13.7795 19.9951C14.1401 18.9133 15.3753 18.4017 16.3952 18.9117C16.398 18.913 16.4013 18.9125 16.4035 18.9103L18.9103 16.4035C18.9125 16.4013 18.9131 16.398 18.9117 16.3952C18.4017 15.3753 18.9133 14.14 19.9951 13.7794C19.998 13.7785 20 13.7757 20 13.7726V10.2274C20 10.2243 19.998 10.2215 19.9951 10.2206C18.9133 9.85996 18.4016 8.62479 18.9116 7.60484C18.913 7.60207 18.9125 7.59873 18.9103 7.59655Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 8-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","gear","cog","options","configuration","admin","system-preferences","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9103 7.59655L16.4034 5.08971C16.4013 5.08753 16.3979 5.08698 16.3951 5.08837C15.3752 5.59834 14.14 5.08674 13.7794 4.00491C13.7784 4.00198 13.7756 4 13.7726 4H10.2274C10.2243 4 10.2215 4.00198 10.2205 4.00491C9.85994 5.08672 8.62473 5.5983 7.60479 5.08833C7.60203 5.08695 7.59869 5.08749 7.5965 5.08968L5.08966 7.59652C5.08748 7.5987 5.08694 7.60204 5.08832 7.60481C5.59829 8.62474 5.08671 9.85997 4.00491 10.2206C4.00198 10.2215 4 10.2243 4 10.2274V13.7726C4 13.7757 4.00198 13.7785 4.00491 13.7794C5.08673 14.14 5.59836 15.3752 5.08838 16.3952C5.087 16.3979 5.08754 16.4013 5.08973 16.4035L7.59657 18.9103C7.59875 18.9125 7.60209 18.913 7.60485 18.9116C8.62481 18.4017 9.86002 18.9133 10.2206 19.9951C10.2216 19.998 10.2244 20 10.2274 20L13.7727 20C13.7757 20 13.7785 19.998 13.7795 19.9951C14.1401 18.9133 15.3753 18.4017 16.3952 18.9117C16.398 18.913 16.4013 18.9125 16.4035 18.9103L18.9103 16.4035C18.9125 16.4013 18.9131 16.398 18.9117 16.3952C18.4017 15.3753 18.9133 14.14 19.9951 13.7794C19.998 13.7785 20 13.7757 20 13.7726V10.2274C20 10.2243 19.998 10.2215 19.9951 10.2206C18.9133 9.85996 18.4016 8.62479 18.9116 7.60484C18.913 7.60207 18.9125 7.59873 18.9103 7.59655Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configuration","preferences","options","admin","system","tools","setup","manage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.75 9.59L20.19 9.5C19.9 9.39 19.68 9.17 19.56 8.88C19.43 8.57 19.45 8.24 19.62 7.89L19.78 7.48L19.51 7.14L16.48 4.11L16.02 4.45C15.74 4.57 15.43 4.58 15.14 4.45C14.83 4.32 14.61 4.08 14.5 3.77L14.31 3.25H9.68L9.51 3.77C9.41 4.08 9.18 4.33 8.87 4.45C8.56 4.58 8.23 4.57 7.94 4.42L7.45 4.18L4.51 7.13L4.21 7.51L4.42 7.94C4.57 8.24 4.58 8.57 4.45 8.87C4.33 9.16 4.1 9.38 3.81 9.49L3.25 9.59V14.32L3.77 14.49C4.08 14.59 4.33 14.82 4.45 15.13C4.58 15.44 4.56 15.77 4.46 15.98L4.12 16.5L7.01 19.38L7.47 19.95L7.99 19.56C8.27 19.44 8.58 19.43 8.87 19.56C9.18 19.69 9.4 19.93 9.51 20.24L9.69 20.75H14.32L14.49 20.24C14.59 19.93 14.82 19.68 15.13 19.56C15.43 19.43 15.77 19.44 16.06 19.59L16.55 19.83L19.77 16.6L19.62 16.16L19.58 16.06C19.43 15.76 19.42 15.43 19.55 15.13C19.68 14.82 19.92 14.6 20.23 14.49L20.75 14.31V9.59ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 8": {
        defaultColors: ["#3D4C66"],
        keywords: ["setting","cog","gear","settings","configuration","options","preferences","admin","administration","system","customize","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.9103 7.59655L16.4034 5.08971C16.4013 5.08753 16.3979 5.08698 16.3951 5.08837C15.3752 5.59834 14.14 5.08674 13.7794 4.00491C13.7784 4.00198 13.7756 4 13.7726 4H10.2274C10.2243 4 10.2215 4.00198 10.2205 4.00491C9.85994 5.08672 8.62473 5.5983 7.60479 5.08833C7.60203 5.08695 7.59869 5.08749 7.5965 5.08968L5.08966 7.59652C5.08748 7.5987 5.08694 7.60204 5.08832 7.60481C5.59829 8.62474 5.08671 9.85997 4.00491 10.2206C4.00198 10.2215 4 10.2243 4 10.2274V13.7726C4 13.7757 4.00198 13.7785 4.00491 13.7794C5.08673 14.14 5.59836 15.3752 5.08838 16.3952C5.087 16.3979 5.08754 16.4013 5.08973 16.4035L7.59657 18.9103C7.59875 18.9125 7.60209 18.913 7.60485 18.9116C8.62481 18.4017 9.86002 18.9133 10.2206 19.9951C10.2216 19.998 10.2244 20 10.2274 20L13.7727 20C13.7757 20 13.7785 19.998 13.7795 19.9951C14.1401 18.9133 15.3753 18.4017 16.3952 18.9117C16.398 18.913 16.4013 18.9125 16.4035 18.9103L18.9103 16.4035C18.9125 16.4013 18.9131 16.398 18.9117 16.3952C18.4017 15.3753 18.9133 14.14 19.9951 13.7794C19.998 13.7785 20 13.7757 20 13.7726V10.2274C20 10.2243 19.998 10.2215 19.9951 10.2206C18.9133 9.85996 18.4016 8.62479 18.9116 7.60484C18.913 7.60207 18.9125 7.59873 18.9103 7.59655Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "setting-cog 9-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","cog","gear","world","global","international","network","configuration","system-settings","localization","language","regions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M16 12L8 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 12C10 14.2091 10.8954 16 12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8C11.9355 8 11.8716 8.00611 11.8087 8.01807C10.7939 8.2107 10 9.91993 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 9-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","globe","international","configuration","system","network","global","website","internet","connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.85 12.76C9.04 13.57 9.53 14.26 10.2 14.71C10.01 14.15 9.85 13.48 9.79 12.76H8.84H8.85Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.85 11.26H9.8C9.87 10.53 10.03 9.86 10.23 9.29C9.55 9.74 9.04 10.44 8.85 11.26Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.3 9.59C12.2 9.35 12.1 9.15 12.01 9C11.92 9.15 11.82 9.35 11.72 9.59C11.54 10.05 11.38 10.62 11.31 11.26H12.72C12.65 10.62 12.49 10.05 12.31 9.59H12.3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.74 14.55C11.83 14.77 11.92 14.94 12.01 15.07C12.09 14.94 12.19 14.77 12.28 14.55C12.48 14.08 12.65 13.46 12.72 12.76H11.3C11.37 13.46 11.54 14.08 11.74 14.55Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.82 14.71C14.49 14.26 14.98 13.57 15.17 12.76H14.22C14.16 13.48 14.01 14.15 13.81 14.71H13.82Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.56 10.07L18.31 9.65C18.17 9.6 18.1 9.44 18.16 9.31L18.76 8.01C19.07 7.34 18.93 6.56 18.41 6.04L17.98 5.61C17.46 5.09 16.67 4.95 16.01 5.26L14.71 5.86C14.57 5.92 14.42 5.86 14.37 5.71L13.95 4.45C13.71 3.74 13.04 3.25 12.29 3.25H11.73C10.98 3.25 10.31 3.73 10.07 4.45L9.65 5.71C9.6 5.85 9.44001 5.92 9.31001 5.86L8.01 5.26C7.34 4.95 6.56 5.09 6.04 5.61L5.61 6.04C5.09 6.56 4.95 7.35 5.26 8.01L5.86 9.31C5.92 9.45 5.86 9.6 5.71 9.65L4.45 10.07C3.74 10.31 3.25 10.98 3.25 11.73V12.29C3.25 13.04 3.73 13.71 4.45 13.95L5.71 14.37C5.85 14.42 5.92 14.58 5.86 14.71L5.26 16.01C4.95 16.68 5.09 17.46 5.61 17.98L6.04 18.41C6.56 18.93 7.35 19.07 8.01 18.76L9.31001 18.16C9.45001 18.1 9.6 18.16 9.65 18.31L10.07 19.57C10.31 20.28 10.98 20.75 11.73 20.75H12.29C13.04 20.75 13.71 20.29 13.95 19.57L14.37 18.31C14.42 18.17 14.58 18.1 14.71 18.16L16.01 18.76C16.68 19.07 17.46 18.93 17.98 18.41L18.41 17.98C18.93 17.46 19.07 16.67 18.76 16.01L18.16 14.71C18.1 14.57 18.16 14.42 18.31 14.37L19.56 13.95C20.28 13.71 20.75 13.04 20.75 12.29V11.73C20.75 10.98 20.28 10.31 19.56 10.07ZM12.01 16.76C9.39 16.76 7.26 14.63 7.26 12.01C7.26 9.39 9.39 7.26 12.01 7.26C14.63 7.26 16.76 9.39 16.76 12.01C16.76 14.63 14.63 16.76 12.01 16.76Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.79 9.29C13.99 9.86 14.15 10.53 14.22 11.26H15.17C14.98 10.44 14.47 9.74 13.79 9.29Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-cog 9-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","gear","global","world","internet","configuration","preferences","system settings","network settings","website","online"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 12L8 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 12C10 14.2091 10.8954 16 12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8C11.9355 8 11.8716 8.00611 11.8087 8.01807C10.7939 8.2107 10 9.91993 10 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","cog","configuration","gear","hexagon","preferences","admin","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog 9": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","global-settings","gear","cog","configuration","admin","system","preferences","globe","world","international"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.7208 20H12.2792C12.7097 20 13.0918 19.7246 13.2279 19.3162L13.6464 18.0607C13.835 17.495 14.4736 17.219 15.0148 17.4692L16.3164 18.0711C16.6969 18.247 17.1468 18.1669 17.4432 17.8705L17.8705 17.4431C18.167 17.1467 18.247 16.6968 18.0711 16.3163L17.4693 15.0148C17.219 14.4736 17.495 13.835 18.0607 13.6464L19.3162 13.2279C19.7246 13.0918 20 12.7097 20 12.2792V11.7208C20 11.2903 19.7246 10.9082 19.3162 10.7721L18.0607 10.3536C17.495 10.165 17.219 9.52642 17.4692 8.98519L18.0711 7.68361C18.247 7.3031 18.1669 6.85324 17.8705 6.55681L17.4431 6.12946C17.1467 5.83302 16.6968 5.75295 16.3163 5.92891L15.0148 6.53073C14.4736 6.781 13.835 6.505 13.6464 5.9393L13.2279 4.68377C13.0918 4.27543 12.7097 4 12.2792 4H11.7208C11.2903 4 10.9082 4.27543 10.7721 4.68377L10.3536 5.93933C10.165 6.50502 9.52642 6.78102 8.98519 6.53077L7.68361 5.92894C7.3031 5.753 6.85324 5.83307 6.55681 6.1295L6.12946 6.55686C5.83302 6.85329 5.75295 7.30316 5.92891 7.68368L6.53073 8.98517C6.781 9.52641 6.505 10.165 5.9393 10.3536L4.68377 10.7721C4.27543 10.9082 4 11.2903 4 11.7208V12.2792C4 12.7097 4.27543 13.0918 4.68377 13.2279L5.93933 13.6464C6.50502 13.835 6.78102 14.4736 6.53077 15.0148L5.92894 16.3164C5.753 16.6969 5.83307 17.1468 6.1295 17.4432L6.55686 17.8705C6.8533 18.167 7.30316 18.247 7.68368 18.0711L8.98517 17.4693C9.52641 17.219 10.165 17.495 10.3536 18.0607L10.7721 19.3162C10.9082 19.7246 11.2903 20 11.7208 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M16 12L8 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 12C10 14.2091 10.8954 16 12 16C13.1046 16 14 14.2091 14 12C14 9.91993 13.2061 8.2107 12.1913 8.01807C12.1284 8.00611 12.0645 8 12 8C11.9355 8 11.8716 8.00611 11.8087 8.01807C10.7939 8.2107 10 9.91993 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-cog-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","configuration","options","gear","cog","hexagon","adjust","preferences","system","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-cog": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","cog","gear","configuration","options","preferences","admin","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 12L7.37138 20H16.6286L21 12L16.6286 4H7.62862L3 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-cog-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","options","configuration","gear","cog","system","preferences","admin","tools"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.62862 3.25C7.36092 3.25 7.11351 3.39269 6.97944 3.6244L2.35083 11.6244C2.21966 11.8511 2.21626 12.1298 2.34185 12.3596L6.71323 20.3596C6.84474 20.6003 7.09712 20.75 7.37138 20.75H16.6286C16.9029 20.75 17.1553 20.6003 17.2868 20.3596L21.6582 12.3596C21.7806 12.1355 21.7806 11.8645 21.6582 11.6404L17.2868 3.64037C17.1553 3.3997 16.9029 3.25 16.6286 3.25H7.62862ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-gear 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","gear","configuration","options","adjust","customize","system","preferences","management","maintenance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12L20 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9.5 9.5L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9.5 14.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 12C15 10.3432 13.6568 9 12 9V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "setting-gear 2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["settings","gear","cog","configuration","admin","options","adjust","preferences","customize","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 12L20 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9.5 9.5L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9.5 14.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "setting-gear 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","configuration","options","system","preferences","customize","control","management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 4V4.0619C14.4607 4.24405 15.7992 4.82003 16.9057 5.68022L16.9499 5.63608C17.3404 5.24556 17.9735 5.24556 18.3641 5.63608C18.7546 6.0266 18.7546 6.65977 18.3641 7.05029L18.3199 7.09446C19.18 8.20096 19.7559 9.53934 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.9381C19.7559 14.4607 19.18 15.7991 18.3198 16.9057L18.3638 16.9497C18.7544 17.3402 18.7544 17.9734 18.3638 18.3639C17.9733 18.7545 17.3402 18.7545 16.9496 18.3639L16.9056 18.3199C15.7991 19.18 14.4607 19.756 13 19.9381V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C9.53932 19.756 8.20094 19.18 7.09443 18.3199L6.92104 18.4933C6.53055 18.8839 5.89738 18.8839 5.50682 18.4934C5.11626 18.103 5.11621 17.4698 5.5067 17.0792L5.57794 17.008L5.68019 16.9057C4.82001 15.7992 4.24405 14.4607 4.06189 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.06189C4.24404 9.53929 4.81999 8.20088 5.68014 7.09436L5.54289 6.95711C5.15237 6.56658 5.15237 5.93342 5.54289 5.54289C5.93342 5.15237 6.56658 5.15237 6.95711 5.54289L7.09435 5.68014C8.20088 4.81999 9.53929 4.24404 11 4.06189V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4ZM6 12C6 13.2959 6.41081 14.4958 7.10929 15.4766L8.55384 14.032C8.20194 13.4365 8 12.7418 8 12C8 11.2582 8.20193 10.5636 8.55383 9.96804L7.10925 8.52347C6.41079 9.50428 6 10.7042 6 12ZM12.0013 18C13.6535 17.9996 15.1496 17.3315 16.2345 16.2507L16.2425 16.2426L16.2506 16.2346C17.1088 15.3731 17.7069 14.2523 17.917 13L15.874 13C15.4299 14.7252 13.8638 16 12 16C11.2582 16 10.5636 15.7981 9.96806 15.4462L8.52352 16.8908C9.50433 17.5892 10.7042 18 12 18H12.0013ZM8.52346 7.10925L9.96805 8.55384C10.5636 8.20195 11.2582 8.00003 12 8.00003C13.8638 8.00003 15.4299 9.27479 15.874 11H17.917C17.4409 8.16229 14.973 6 12 6C10.7042 6 9.50428 6.41079 8.52346 7.10925ZM12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-gear 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["spark","sparkle","shine","light","effects","clean","cleaning","sanitize","promotion","discount","effect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 12C15 10.3432 13.6568 9 12 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12L20 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9.5 9.5L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9.5 14.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "setting-gear-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sun","brightness","display","settings","adjust","light","theme","daylight"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.34277 17.6572L7.04988 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.0498 7.0498L6.3427 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-gear-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["settings","gear","configuration","options","admin","system-settings","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.34277 17.6572L7.04988 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.0498 7.0498L6.3427 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "setting-gear-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","configuration","options","admin","preferences","customize","system","tools","maintenance","adjustments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V4.06189C14.4607 4.24404 15.7991 4.81999 16.9056 5.68015L16.9497 5.63604C17.3403 5.24551 17.9734 5.24551 18.364 5.63604C18.7545 6.02656 18.7545 6.65973 18.364 7.05025L18.3198 7.09437C19.18 8.20089 19.7559 9.5393 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.9381C19.7559 14.4607 19.18 15.7991 18.3198 16.9056L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364C17.9734 18.7545 17.3403 18.7545 16.9497 18.364L16.9056 18.3198C15.7991 19.18 14.4607 19.756 13 19.9381V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C9.53929 19.756 8.20088 19.18 7.09436 18.3199L7.05025 18.364C6.65973 18.7545 6.02656 18.7545 5.63604 18.364C5.24551 17.9734 5.24551 17.3403 5.63604 16.9497L5.68015 16.9056C4.82 15.7991 4.24406 14.4607 4.06191 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.06191C4.24406 9.5393 4.82 8.20089 5.68015 7.09437L5.63604 7.05025C5.24551 6.65973 5.24551 6.02656 5.63604 5.63604C6.02656 5.24551 6.65973 5.24551 7.05025 5.63604L7.09436 5.68015C8.20088 4.81999 9.53929 4.24404 11 4.06189V4C11 3.44771 11.4477 3 12 3ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "setting-gear": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","gear","cog","configuration","admin","preferences","options","customize","system","tools","maintenance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.34277 17.6572L7.04988 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.9502 7.0498L17.6573 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7.0498 7.0498L6.3427 6.3427"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6572 17.6572L16.9501 16.9501"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "shapes-circle-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","ring","round","void","empty","status","pending","loading","waiting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-circle-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["circle","shape","void","null","blank","round","status","indicator","available","placeholder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-circle": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","ring","status","indicator","loading","void","empty","waiting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["circle","shape","round","select","option","category","void","refund","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-hexagon-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["hexagon","shape","button","category","section","label","tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.23003 12.4529L7.27765 18.4529C7.44815 18.7885 7.79273 19 8.16923 19H12H15.8308C16.2073 19 16.5519 18.7885 16.7224 18.4529L19.77 12.4529C19.9145 12.1683 19.9145 11.8317 19.77 11.5471L16.7224 5.54713C16.5519 5.21146 16.2073 5 15.8308 5L12 5H8.16922C7.79273 5 7.44815 5.21146 7.27765 5.54713L4.23003 11.5471C4.08547 11.8317 4.08547 12.1683 4.23003 12.4529Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shapes-hexagon-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","shape","tile","menu","category","section","module","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.38604 5.09427C6.72704 4.42292 7.41621 4 8.1692 4L15.8308 4C16.5837 4 17.2729 4.42292 17.6139 5.09427L20.6615 11.0943C20.9507 11.6635 20.9507 12.3365 20.6615 12.9057L17.6139 18.9057C17.2729 19.5771 16.5837 20 15.8308 20H8.1692C7.41622 20 6.72705 19.5771 6.38604 18.9057L3.33842 12.9057C3.0493 12.3365 3.0493 11.6635 3.33842 11.0943L6.38604 5.09427Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-hexagon-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","shape","settings","configuration","options","tools","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.23003 12.4529L7.27765 18.4529C7.44815 18.7885 7.79273 19 8.16923 19H12H15.8308C16.2073 19 16.5519 18.7885 16.7224 18.4529L19.77 12.4529C19.9145 12.1683 19.9145 11.8317 19.77 11.5471L16.7224 5.54713C16.5519 5.21146 16.2073 5 15.8308 5L12 5H8.16922C7.79273 5 7.44815 5.21146 7.27765 5.54713L4.23003 11.5471C4.08547 11.8317 4.08547 12.1683 4.23003 12.4529Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shapes-multi-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shapes","multi","triangle","x","circle","square","options","menu","selection","settings","configuration","customize","actions","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="14" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="14" y="14" width="6" height="6" rx="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M12 10L8 4L4 10H12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 10L20 4M20 10L14 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shapes-hexagon": {
        defaultColors: ["#3D4C66"],
        keywords: ["hexagon","shape","category","section","group","organization","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.23003 12.4529L7.27765 18.4529C7.44815 18.7885 7.79273 19 8.16923 19H12H15.8308C16.2073 19 16.5519 18.7885 16.7224 18.4529L19.77 12.4529C19.9145 12.1683 19.9145 11.8317 19.77 11.5471L16.7224 5.54713C16.5519 5.21146 16.2073 5 15.8308 5L12 5H8.16922C7.79273 5 7.44815 5.21146 7.27765 5.54713L4.23003 11.5471C4.08547 11.8317 4.08547 12.1683 4.23003 12.4529Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shapes-multi-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shapes","triangle","cross","circle","square","options","settings","customize","configuration","adjust","functions","choices","selections"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="14"
                    width="6"
                    height="6"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="14"
                    y="14"
                    width="6"
                    height="6"
                    rx="1"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L8 4L4 10H12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 10L20 4M20 10L14 4" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shapes-multi": {
        defaultColors: ["#3D4C66"],
        keywords: ["options","settings","customize","configuration","shapes","multi","interface","menu","control","game","play"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="14" width="6" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="14" y="14" width="6" height="6" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 10L8 4L4 10H12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 10L20 4M20 10L14 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shapes-multi-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["triangle","x","circle","square","shapes","multi","options","settings","configuration","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 17C3 14.7909 4.79086 13 7 13C9.20914 13 11 14.7909 11 17C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.6626 13H19.3374C19.6323 13 19.9194 12.9999 20.1612 13.0229C20.4282 13.0483 20.7412 13.1086 21.045 13.2947C21.3141 13.4596 21.5404 13.6859 21.7053 13.955C21.8914 14.2588 21.9517 14.5718 21.9771 14.8388C22.0001 15.0806 22.0001 15.3677 22 15.6626V18.3374C22.0001 18.6323 22.0001 18.9194 21.9771 19.1612C21.9517 19.4282 21.8914 19.7412 21.7053 20.045C21.5404 20.3141 21.3141 20.5404 21.045 20.7053C20.7412 20.8914 20.4282 20.9517 20.1612 20.9771C19.9194 21.0001 19.6323 21.0001 19.3374 21H16.6626C16.3677 21.0001 16.0806 21.0001 15.8388 20.9771C15.5718 20.9517 15.2588 20.8914 14.955 20.7053C14.6859 20.5404 14.4596 20.3141 14.2947 20.045C14.1086 19.7412 14.0483 19.4282 14.0229 19.1612C13.9999 18.9194 14 18.6323 14 18.3374V15.6626C14 15.3677 13.9999 15.0806 14.0229 14.8388C14.0483 14.5718 14.1086 14.2588 14.2947 13.955C14.4596 13.6859 14.6859 13.4596 14.955 13.2947C15.2588 13.1086 15.5718 13.0483 15.8388 13.0229C16.0806 12.9999 16.3677 13 16.6626 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 3C7.33435 3 7.64659 3.1671 7.83205 3.4453L11.8321 9.4453C12.0366 9.75216 12.0557 10.1467 11.8817 10.4719C11.7077 10.797 11.3688 11 11 11H3C2.63121 11 2.29235 10.797 2.11833 10.4719C1.94431 10.1467 1.96338 9.75216 2.16795 9.4453L6.16795 3.4453C6.35342 3.1671 6.66565 3 7 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2929 3.29289C14.6834 2.90237 15.3166 2.90237 15.7071 3.29289L18 5.58579L20.2929 3.29289C20.6834 2.90237 21.3166 2.90237 21.7071 3.29289C22.0976 3.68342 22.0976 4.31658 21.7071 4.70711L19.4142 7L21.7071 9.29289C22.0976 9.68342 22.0976 10.3166 21.7071 10.7071C21.3166 11.0976 20.6834 11.0976 20.2929 10.7071L18 8.41421L15.7071 10.7071C15.3166 11.0976 14.6834 11.0976 14.2929 10.7071C13.9024 10.3166 13.9024 9.68342 14.2929 9.29289L16.5858 7L14.2929 4.70711C13.9024 4.31658 13.9024 3.68342 14.2929 3.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-portrait-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["rectangle","portrait","display","screen","interface","layout","receipt","ticket","bill","menu","order-summary","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18L6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4L16 4C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6V18C18 18.9428 18 19.4142 17.7071 19.7071C17.4142 20 16.9428 20 16 20H8C7.05719 20 6.58579 20 6.29289 19.7071C6 19.4142 6 18.9428 6 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-portrait-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["receipt","loyalty-card","card","member","profile","customer","rewards","contact","portrait","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18L6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4L16 4C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6V18C18 18.9428 18 19.4142 17.7071 19.7071C17.4142 20 16.9428 20 16 20H8C7.05719 20 6.58579 20 6.29289 19.7071C6 19.4142 6 18.9428 6 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-portrait": {
        defaultColors: ["#3D4C66"],
        keywords: ["receipt","frame","rectangle","display","screen","content","layout","portrait","list","card"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18L6 6C6 5.05719 6 4.58579 6.29289 4.29289C6.58579 4 7.05719 4 8 4L16 4C16.9428 4 17.4142 4 17.7071 4.29289C18 4.58579 18 5.05719 18 6V18C18 18.9428 18 19.4142 17.7071 19.7071C17.4142 20 16.9428 20 16 20H8C7.05719 20 6.58579 20 6.29289 19.7071C6 19.4142 6 18.9428 6 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-rectangle-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["rectangle","box","container","module","section","area","frame","display","placeholder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16L4 8C4 7.05719 4 6.58579 4.29289 6.29289C4.58579 6 5.05719 6 6 6L18 6C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V16C20 16.9428 20 17.4142 19.7071 17.7071C19.4142 18 18.9428 18 18 18H6C5.05719 18 4.58579 18 4.29289 17.7071C4 17.4142 4 16.9428 4 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-portrait-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["card","loyalty-card","credit-card","id-card","reward","discount","payment","profile","customer","receipt","record","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94561 3.00001L8.00001 3.00001L16 3.00001L16.0544 3.00001C16.4785 2.99992 16.8906 2.99984 17.2305 3.04554C17.6137 3.09706 18.051 3.22259 18.4142 3.5858C18.7774 3.94902 18.903 4.38629 18.9545 4.76949C19.0002 5.10941 19.0001 5.52153 19 5.94559V5.9456L19 6.00001V18L19 18.0544V18.0544C19.0001 18.4785 19.0002 18.8906 18.9545 19.2305C18.903 19.6137 18.7774 20.051 18.4142 20.4142C18.051 20.7774 17.6137 20.903 17.2305 20.9545C16.8906 21.0002 16.4785 21.0001 16.0544 21L16 21H8.00001L7.94562 21C7.52155 21.0001 7.10941 21.0002 6.7695 20.9545C6.38629 20.903 5.94902 20.7774 5.5858 20.4142C5.22259 20.051 5.09706 19.6137 5.04554 19.2305C4.99984 18.8906 4.99992 18.4785 5.00001 18.0544L5.00001 18L5.00001 6.00001L5.00001 5.94561C4.99992 5.52154 4.99984 5.10941 5.04554 4.76949C5.09706 4.38629 5.22259 3.94902 5.5858 3.5858C5.94902 3.22259 6.38629 3.09706 6.76949 3.04554C7.10941 2.99984 7.52154 2.99992 7.94561 3.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-rectangle-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["rectangle","rounded-rectangle","shape","placeholder","category","button","layout","section","block"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16L4 8C4 7.05719 4 6.58579 4.29289 6.29289C4.58579 6 5.05719 6 6 6L18 6C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V16C20 16.9428 20 17.4142 19.7071 17.7071C19.4142 18 18.9428 18 18 18H6C5.05719 18 4.58579 18 4.29289 17.7071C4 17.4142 4 16.9428 4 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-rectangle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["rectangle","shape","block","tile","category","section","button","menu","panel","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.94561 5.00001L6.00001 5.00001L18 5.00001L18.0544 5.00001C18.4785 4.99992 18.8906 4.99984 19.2305 5.04554C19.6137 5.09706 20.051 5.22259 20.4142 5.5858C20.7774 5.94902 20.903 6.38629 20.9545 6.7695C21.0002 7.10941 21.0001 7.52155 21 7.94563L21 8.00001V16L21 16.0544C21.0001 16.4785 21.0002 16.8906 20.9545 17.2305C20.903 17.6137 20.7774 18.051 20.4142 18.4142C20.051 18.7774 19.6137 18.903 19.2305 18.9545C18.8906 19.0002 18.4785 19.0001 18.0544 19H18.0544L18 19H6.00001L5.9456 19H5.94559C5.52153 19.0001 5.10941 19.0002 4.76949 18.9545C4.38629 18.903 3.94902 18.7774 3.5858 18.4142C3.22259 18.051 3.09706 17.6137 3.04554 17.2305C2.99984 16.8906 2.99992 16.4785 3.00001 16.0544L3.00001 16L3.00001 8.00001L3.00001 7.94561C2.99992 7.52154 2.99984 7.10941 3.04554 6.76949C3.09706 6.38629 3.22259 5.94902 3.5858 5.5858C3.94902 5.22259 4.38629 5.09706 4.76949 5.04554C5.10941 4.99984 5.52154 4.99992 5.94561 5.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-square-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","box","shapes","layout","design","container","grid","module","section","window","display","screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5 7C5 6.05719 5 5.58579 5.29289 5.29289C5.58579 5 6.05719 5 7 5L17 5C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V17C19 17.9428 19 18.4142 18.7071 18.7071C18.4142 19 17.9428 19 17 19H7C6.05719 19 5.58579 19 5.29289 18.7071C5 18.4142 5 17.9428 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-rectangle": {
        defaultColors: ["#3D4C66"],
        keywords: ["rectangle","square","shape","display","window","frame","section","outline","area","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16L4 8C4 7.05719 4 6.58579 4.29289 6.29289C4.58579 6 5.05719 6 6 6L18 6C18.9428 6 19.4142 6 19.7071 6.29289C20 6.58579 20 7.05719 20 8V16C20 16.9428 20 17.4142 19.7071 17.7071C19.4142 18 18.9428 18 18 18H6C5.05719 18 4.58579 18 4.29289 17.7071C4 17.4142 4 16.9428 4 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","block","module","menu","category","section","group","container","layout","tile","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.94561 4.00001L7.00001 4.00001L17 4.00001L17.0544 4.00001C17.4785 3.99992 17.8906 3.99984 18.2305 4.04554C18.6137 4.09706 19.051 4.22259 19.4142 4.5858C19.7774 4.94902 19.903 5.38629 19.9545 5.76949C20.0002 6.10938 20.0001 6.52146 20 6.94549V6.9456L20 7.00001V17L20 17.0544V17.0545C20.0001 17.4786 20.0002 17.8907 19.9545 18.2305C19.903 18.6137 19.7774 19.051 19.4142 19.4142C19.051 19.7774 18.6137 19.903 18.2305 19.9545C17.8907 20.0002 17.4786 20.0001 17.0545 20H17.0544L17 20H7.00001L6.9456 20H6.94549C6.52146 20.0001 6.10938 20.0002 5.76949 19.9545C5.38629 19.903 4.94902 19.7774 4.5858 19.4142C4.22259 19.051 4.09706 18.6137 4.04554 18.2305C3.99984 17.8906 3.99992 17.4785 4.00001 17.0544L4.00001 17L4.00001 7.00001L4.00001 6.94561C3.99992 6.52154 3.99984 6.10941 4.04554 5.76949C4.09706 5.38629 4.22259 4.94902 4.5858 4.5858C4.94902 4.22259 5.38629 4.09706 5.76949 4.04554C6.10941 3.99984 6.52154 3.99992 6.94561 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shapes-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","shape","block","void","container","placeholder","form","box","module"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5 7C5 6.05719 5 5.58579 5.29289 5.29289C5.58579 5 6.05719 5 7 5L17 5C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V17C19 17.9428 19 18.4142 18.7071 18.7071C18.4142 19 17.9428 19 17 19H7C6.05719 19 5.58579 19 5.29289 18.7071C5 18.4142 5 17.9428 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-square-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["square","shapes","block","category","section","group","inventory","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17L5 7C5 6.05719 5 5.58579 5.29289 5.29289C5.58579 5 6.05719 5 7 5L17 5C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V17C19 17.9428 19 18.4142 18.7071 18.7071C18.4142 19 17.9428 19 17 19H7C6.05719 19 5.58579 19 5.29289 18.7071C5 18.4142 5 17.9428 5 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-triangle-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["triangle","shape","alert","warning","danger","priority","attention","discount","promotion","sort-up","filter-up","arrow-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70987 16.0077L10.2635 8.03885C11.0343 6.68999 11.4197 6.01556 12 6.01556C12.5803 6.01556 12.9657 6.68999 13.7365 8.03885L18.2901 16.0077C19.0506 17.3385 19.4308 18.0039 19.1417 18.5019C18.8527 19 18.0863 19 16.5536 19H7.44636C5.91366 19 5.14731 19 4.85827 18.5019C4.56923 18.0039 4.94944 17.3385 5.70987 16.0077Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-triangle-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["triangle","shape","alert","warning","danger","information","indicator","priority","important"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70987 16.0077L10.2635 8.03885C11.0343 6.68999 11.4197 6.01556 12 6.01556C12.5803 6.01556 12.9657 6.68999 13.7365 8.03885L18.2901 16.0077C19.0506 17.3385 19.4308 18.0039 19.1417 18.5019C18.8527 19 18.0863 19 16.5536 19H7.44636C5.91366 19 5.14731 19 4.85827 18.5019C4.56923 18.0039 4.94944 17.3385 5.70987 16.0077Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-triangle": {
        defaultColors: ["#3D4C66"],
        keywords: ["triangle","shapes","alert","warning","danger","important","priority","notice","risk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70987 16.0077L10.2635 8.03885C11.0343 6.68999 11.4197 6.01556 12 6.01556C12.5803 6.01556 12.9657 6.68999 13.7365 8.03885L18.2901 16.0077C19.0506 17.3385 19.4308 18.0039 19.1417 18.5019C18.8527 19 18.0863 19 16.5536 19H7.44636C5.91366 19 5.14731 19 4.85827 18.5019C4.56923 18.0039 4.94944 17.3385 5.70987 16.0077Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "shapes-triangle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["triangle","shape","menu","options","more","direction","up","top","filter","sort","selection","priority"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.70987 16.0077L10.2635 8.03885C11.0343 6.68999 11.4197 6.01556 12 6.01556C12.5803 6.01556 12.9657 6.68999 13.7365 8.03885L18.2901 16.0077C19.0506 17.3385 19.4308 18.0039 19.1417 18.5019C18.8527 19 18.0863 19 16.5536 19H7.44636C5.91366 19 5.14731 19 4.85827 18.5019C4.56923 18.0039 4.94944 17.3385 5.70987 16.0077Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="2"
                />
            </svg>
        )
    },
    "share-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["share","connection","network","transfer","export","send","connect","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="7" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="17" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 10L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 16L11 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="8" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","export","send","connection","network","distribute","social media","referral","social","link","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7C12 4.79086 13.7909 3 16 3C18.2091 3 20 4.79086 20 7C20 9.20914 18.2091 11 16 11C14.672 11 13.4952 10.3529 12.7677 9.35676L11.5552 10.1651C11.8395 10.7147 12 11.3386 12 12C12 12.4614 11.9219 12.9045 11.7781 13.3169L13.1274 14.2164C13.8545 13.4663 14.8728 13 16 13C18.2091 13 20 14.7909 20 17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 16.6401 12.0475 16.2914 12.1366 15.9596L10.6678 14.9804C9.96002 15.6144 9.02503 16 8 16C5.79086 16 4 14.2091 4 12C4 9.79086 5.79086 8 8 8C8.81468 8 9.57247 8.24355 10.2045 8.66181L12.0248 7.44828C12.0084 7.30112 12 7.15154 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "share-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","social","network","connection","connect","export","send","relationship","affiliate","referral","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 10L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="2"
                    cy="2"
                    r="2"
                    transform="matrix(1 0 0 -1 14 20)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 14L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["share","network","connection","distribute","send","export","social media","referral","affiliate","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 16L11 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="8"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="7"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="17"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "share-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["share","network","connection","connections","link","linked","transfer","send","distribute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 10L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 14L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="9"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="16"
                    cy="6"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="2"
                    cy="2"
                    r="2"
                    transform="matrix(1 0 0 -1 14 20)"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "share-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["share","connection","network","export","transfer","send","distribute","relationship","affiliate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 10L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="2"
                    cy="2"
                    r="2"
                    transform="matrix(1 0 0 -1 14 20)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 14L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="9" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "share-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","network","connection","social","collaborate","transfer","export","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 4.34315 14.3431 3 16 3C17.6569 3 19 4.34315 19 6C19 7.65685 17.6569 9 16 9C15.4617 9 14.9566 8.85824 14.5198 8.61002L12.5244 10.1066C12.8278 10.6702 13 11.315 13 12C13 12.685 12.8278 13.3298 12.5244 13.8934L14.5198 15.39C14.9566 15.1418 15.4617 15 16 15C17.6569 15 19 16.3431 19 18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 13 18C13 17.6135 13.0731 17.2441 13.2062 16.9048L11.1579 15.3686C10.5354 15.7682 9.79475 16 9 16C6.79086 16 5 14.2091 5 12C5 9.79086 6.79086 8 9 8C9.79475 8 10.5354 8.23178 11.1579 8.63143L13.2062 7.09523C13.0731 6.75593 13 6.3865 13 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "share-all-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["share","forward","send","transfer","export","arrow","double-arrow","next","proceed","push","move","transmit","dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18V16C3 11.5817 6.58172 8 11 8V5L17 11L11 17V14H8C5.23858 14 3 15.2386 3 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5L21 11L15 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "share-all-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","right","forward","next","send","submit","process","continue","advance","move-forward","transfer","share","export"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 8C6.58172 8 3 11.5817 3 16V18C3 15.2386 5.23858 14 8 14H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 8V5L17 11L11 17V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M15 5L21 11L15 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "share-all": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","forward","send","transfer","export","arrow","next","queue","send-order","forward-order","export-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 8C6.58172 8 3 11.5817 3 16V18C3 15.2386 5.23858 14 8 14H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 8V5L17 11L11 17V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M15 5L21 11L15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "share-all-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["send","transmit","forward","next","advance","share","push","submit","redirect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289C14.9024 4.68342 14.9024 5.31658 15.2929 5.70711L20.5858 11L15.2929 16.2929C14.9024 16.6834 14.9024 17.3166 15.2929 17.7071C15.6834 18.0976 16.3166 18.0976 16.7071 17.7071L22.7071 11.7071C23.0976 11.3166 23.0976 10.6834 22.7071 10.2929L16.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.6173 4.07615C10.991 3.92137 11.4211 4.00692 11.7071 4.29292L17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071L11.7071 17.7071C11.4211 17.9931 10.991 18.0787 10.6173 17.9239C10.2436 17.7691 10 17.4045 10 17V15H8C6.74947 15 5.72976 15.2832 5.05074 15.7746C4.41452 16.235 4 16.9291 4 18C4 18.5523 3.55228 19 3 19C2.44772 19 2 18.5523 2 18V16C2 11.3675 5.50005 7.5524 10 7.05496V5.00003C10 4.59557 10.2436 4.23093 10.6173 4.07615Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "share-from-square-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["share","export","send","forward","arrow","square","transfer","integration","external","data","transmit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 4H10H8C6.11438 4 5.17157 4 4.58579 4.58579C4 5.17157 4 6.11438 4 8V16C4 17.8856 4 18.8284 4.58579 19.4142C5.17157 20 6.11438 20 8 20H16C17.8856 20 18.8284 20 19.4142 19.4142C20 18.8284 20 17.8856 20 16V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 9L16 13V11H13.375C10.9588 11 9 12.2386 9 15V13C9 8.58172 12.134 7 16 7V5L20 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "share-from-square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["share","send","export","forward","transfer","send-receipt","email-receipt","export-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 4H10H8C6.11438 4 5.17157 4 4.58579 4.58579C4 5.17157 4 6.11438 4 8V16C4 17.8856 4 18.8284 4.58579 19.4142C5.17157 20 6.11438 20 8 20H16C17.8856 20 18.8284 20 19.4142 19.4142C20 18.8284 20 17.8856 20 16V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 7V5L20 9L16 13V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M16 7C12.134 7 9 8.58172 9 13V15C9 12.2386 10.9588 11 13.375 11H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "share-from-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","export","send","transfer","arrow","square","send-receipt","export-data","share-order","transaction","outgoing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.93417 3C7.95604 3 7.97799 3 8 3H11C11.5523 3 12 3.44772 12 4C12 4.55229 11.5523 5 11 5H8C7.02893 5 6.40122 5.00213 5.93871 5.06431C5.50497 5.12263 5.36902 5.21677 5.2929 5.2929C5.21677 5.36902 5.12263 5.50497 5.06431 5.93871C5.00213 6.40122 5 7.02893 5 8V16C5 16.9711 5.00213 17.5988 5.06431 18.0613C5.12263 18.495 5.21677 18.631 5.2929 18.7071C5.36902 18.7832 5.50497 18.8774 5.93871 18.9357C6.40122 18.9979 7.02893 19 8 19H16C16.9711 19 17.5988 18.9979 18.0613 18.9357C18.495 18.8774 18.631 18.7832 18.7071 18.7071C18.7832 18.631 18.8774 18.495 18.9357 18.0613C18.9979 17.5988 19 16.9711 19 16V13.5C19 12.9477 19.4477 12.5 20 12.5C20.5523 12.5 21 12.9477 21 13.5L21 16.0658C21.0001 16.9523 21.0001 17.7161 20.9179 18.3278C20.8297 18.9833 20.631 19.6117 20.1213 20.1213C19.6117 20.631 18.9833 20.8297 18.3278 20.9179C17.7161 21.0001 16.9523 21.0001 16.0658 21H7.9342C7.0477 21.0001 6.28388 21.0001 5.67221 20.9179C5.0167 20.8297 4.38835 20.631 3.87868 20.1213C3.36902 19.6117 3.17028 18.9833 3.08215 18.3278C2.99991 17.7161 2.99995 16.9523 3 16.0658L3 8C3 7.97799 3 7.95604 3 7.93417C2.99995 7.04769 2.99991 6.28387 3.08215 5.67221C3.17028 5.0167 3.36902 4.38835 3.87868 3.87868C4.38835 3.36902 5.0167 3.17028 5.67221 3.08215C6.28387 2.99991 7.04769 2.99995 7.93417 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.6173 4.07613C15.991 3.92134 16.4211 4.0069 16.7071 4.2929L20.7071 8.2929C21.0976 8.68342 21.0976 9.31659 20.7071 9.70711L16.7071 13.7071C16.4211 13.9931 15.991 14.0787 15.6173 13.9239C15.2436 13.7691 15 13.4045 15 13V12H13.375C12.3236 12 11.4803 12.2706 10.9188 12.7351C10.3858 13.1759 10 13.8775 10 15C10 15.5523 9.55229 16 9 16C8.44772 16 8 15.5523 8 15V13C8 10.5263 8.89412 8.70737 10.4512 7.54244C11.7117 6.59943 13.3136 6.1551 15 6.03475V5.00001C15 4.59554 15.2436 4.23091 15.6173 4.07613Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "share-from-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","export","send","arrow","square","forward","transfer","gift","give"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 4H10H8C6.11438 4 5.17157 4 4.58579 4.58579C4 5.17157 4 6.11438 4 8V16C4 17.8856 4 18.8284 4.58579 19.4142C5.17157 20 6.11438 20 8 20H16C17.8856 20 18.8284 20 19.4142 19.4142C20 18.8284 20 17.8856 20 16V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 7V5L20 9L16 13V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M16 7C12.134 7 9 8.58172 9 13V15C9 12.2386 10.9588 11 13.375 11H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","cross","error","security","unprotected","blocked","rejected","denied","invalid","incorrect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.613 19.7508C14.9534 18.6734 18.4311 15.5432 18.9399 9.16949C19.007 8.32865 19.0405 7.90824 18.7858 7.59674C18.5311 7.28524 18.0325 7.22504 17.0354 7.10463C15.9201 6.96995 14.8984 6.65889 13.9242 5.97148C12.8529 5.21553 12.3173 4.83756 12 4.83756C11.6827 4.83756 11.1471 5.21553 10.0758 5.97148C9.11199 6.65158 8.10157 6.9633 7.00012 7.10028C5.98651 7.22633 5.47971 7.28936 5.22564 7.60809C4.97157 7.92682 5.01471 8.35203 5.10099 9.20244C5.72337 15.337 9.08517 18.642 11.3697 19.7444C11.6303 19.8701 11.7605 19.933 11.9844 19.935C12.2083 19.937 12.3432 19.875 12.613 19.7508Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10M14 14L10 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","cross","error","security","denied","unprotected","invalid","cancel","rejected","protection","blocked","inactive","disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3134 4.14917C11.4856 4.07687 11.7202 4 11.9891 4C12.258 4 12.4927 4.07687 12.6649 4.14917C12.8434 4.22412 13.0226 4.32364 13.1956 4.42907C13.5313 4.63363 13.9555 4.93043 14.4675 5.28864L14.4971 5.30936C15.3054 5.87485 16.1604 6.14173 17.1593 6.26132L17.2117 6.26759C17.6663 6.32196 18.0934 6.37303 18.4352 6.45624C18.8036 6.54596 19.242 6.70959 19.5708 7.10831C19.8773 7.47981 19.9712 7.89027 19.9939 8.26226C20.0133 8.58107 19.983 8.95603 19.9529 9.32833L19.9487 9.38063C19.4083 16.0936 15.6839 19.5113 13.0232 20.7257L12.981 20.745C12.7355 20.8578 12.4173 21.004 11.9644 20.9999C11.5119 20.9958 11.2013 20.8464 10.9605 20.7305L10.9212 20.7116C8.31128 19.4631 4.73123 15.8728 4.07241 9.43465L4.06699 9.38178C4.02835 9.00522 3.98946 8.6262 4.00261 8.30332C4.01795 7.92636 4.10546 7.50924 4.41096 7.12927C4.73934 6.72083 5.18325 6.55262 5.55589 6.46017C5.90204 6.3743 6.33562 6.3209 6.79802 6.26395L6.85102 6.25742C7.83578 6.136 8.6812 5.86898 9.48111 5.30936L9.51072 5.28864C10.0227 4.93043 10.4469 4.63363 10.7826 4.42907C10.9557 4.32364 11.1348 4.22412 11.3134 4.14917ZM14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L12 10.5858L10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L10.5858 12L9.29289 13.2929C8.90237 13.6834 8.90237 14.3166 9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L12 13.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13.4142 12L14.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield cross-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shield","cross","error","invalid","disabled","restriction","blocked","cancel","security","failed","transaction-failed","access-denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 14L14 10M14 14L10 10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.9971 7.23651C19.1212 14.9458 15.1827 18.573 12.6132 19.7513C12.3427 19.8753 12.2075 19.9373 11.9844 19.9353C11.7613 19.9333 11.6307 19.8705 11.3695 19.7449C8.8478 18.5329 5.01388 14.6634 5 7.23651M5 7.20006C6.92339 7.20006 8.55745 7.0429 10.0758 5.97148C11.1471 5.21553 11.6827 4.83756 12 4.83756C12.3173 4.83756 12.8529 5.21553 13.9242 5.97148C15.4425 7.0429 17.0766 7.20006 19 7.20006"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    share: {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","cross","error","invalid","disabled","restriction","blocked","cancel","security","failed","transaction-failed","access-denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="7" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="16" cy="17" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 10L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M14 16L11 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "shield cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","cross","error","incorrect","invalid","reject","decline","cancel","protection-failed","unprotected","security-error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9971 7.23651C19.1212 14.9458 15.1827 18.573 12.6132 19.7513C12.3427 19.8753 12.2075 19.9373 11.9844 19.9353C11.7613 19.9333 11.6307 19.8705 11.3695 19.7449C8.8478 18.5329 5.01388 14.6634 5 7.23651M5 7.20006C6.92339 7.20006 8.55745 7.0429 10.0758 5.97148C11.1471 5.21553 11.6827 4.83756 12 4.83756C12.3173 4.83756 12.8529 5.21553 13.9242 5.97148C15.4425 7.0429 17.0766 7.20006 19 7.20006"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10M14 14L10 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield divide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","security","protection","safe","split","divide","access-control","fraud-prevention"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9884 20C14.837 19.2135 20.1504 15.8772 19.9965 8.03444C19.9842 7.64515 19.754 7.29041 19.3899 7.09988C14.7657 4.62916 12.5151 4 11.9847 4C11.4544 4 9.36869 4.59013 5.03239 6.87026C4.41172 7.17555 4.01672 7.77033 4 8.4248C4.01723 15.9885 9.18657 19.2262 11.9884 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 20L12 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield divide-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shield","security","protection","split","divide","secure-transaction","verified","authorized"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20L12 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.9884 20C14.837 19.2135 20.1504 15.8772 19.9965 8.03444C19.9842 7.64515 19.754 7.29041 19.3899 7.09988C14.7657 4.62916 12.5151 4 11.9847 4C11.4544 4 9.36869 4.59013 5.03239 6.87026C4.41172 7.17555 4.01672 7.77033 4 8.4248C4.01723 15.9885 9.18657 19.2262 11.9884 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield divide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["security","shield","protection","split","divided","authorization","access","firewall","safe","secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 20.9913C16.2382 19.76 21.1494 15.9553 20.9965 7.96697L20.9961 7.95465C20.9717 7.1634 20.5177 6.47919 19.858 6.12339C17.5211 4.84373 15.7657 4.03084 14.5124 3.53474C13.8972 3.29122 13.3955 3.12105 13 3.00945L13 20.9913ZM11 3C10.6247 3.10478 10.1532 3.26362 9.57827 3.48925C8.40425 3.94997 6.76539 4.70223 4.57775 5.88083C3.65417 6.35234 3.02707 7.28805 3.00033 8.36099C3.00009 8.37049 2.99998 8.38 3 8.3895C3.01716 16.1113 7.82163 19.7998 11 21L11 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shield","security","protection","check","tick","approved","verified","safe","transaction-safe","payment-safe","order-confirmed","success","validation","authorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9971 7.23651C19.1212 14.9458 15.1827 18.573 12.6132 19.7513C12.3427 19.8753 12.2075 19.9373 11.9844 19.9353C11.7613 19.9333 11.6307 19.8705 11.3695 19.7449C8.8478 18.5329 5.01388 14.6634 5 7.23651M5 7.20006C6.92339 7.20006 8.55745 7.0429 10.0758 5.97148C11.1471 5.21553 11.6827 4.83756 12 4.83756C12.3173 4.83756 12.8529 5.21553 13.9242 5.97148C15.4425 7.0429 17.0766 7.20006 19 7.20006"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield divide": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","warranty","guarantee","defense","secure","firewall","payment-protection","data-security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9884 20C14.837 19.2135 20.1504 15.8772 19.9965 8.03444C19.9842 7.64515 19.754 7.29041 19.3899 7.09988C14.7657 4.62916 12.5151 4 11.9847 4C11.4544 4 9.36869 4.59013 5.03239 6.87026C4.41172 7.17555 4.01672 7.77033 4 8.4248C4.01723 15.9885 9.18657 19.2262 11.9884 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 20L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield tick-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","tick","check","security","verified","approved","payment-accepted","transaction-approved","order-confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9.87418V7C6.91913 7 10.4897 5.99355 12 5C13.5103 5.99355 17.0809 7 19 7V9.87418C19 14.1859 16.1139 17.9542 12 19C7.88605 17.9542 5 14.1859 5 9.87418Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","tick","check","security","validated","verified","approved","safe","payment-accepted","transaction-approved","order-confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.613 19.7508C14.9534 18.6734 18.4311 15.5432 18.9399 9.16949C19.007 8.32865 19.0405 7.90824 18.7858 7.59674C18.5311 7.28524 18.0325 7.22504 17.0354 7.10463C15.9201 6.96995 14.8984 6.65889 13.9242 5.97148C12.8529 5.21553 12.3173 4.83756 12 4.83756C11.6827 4.83756 11.1471 5.21553 10.0758 5.97148C9.11199 6.65158 8.10157 6.9633 7.00012 7.10028C5.98651 7.22633 5.47971 7.28936 5.22564 7.60809C4.97157 7.92682 5.01471 8.35203 5.10099 9.20244C5.72337 15.337 9.08517 18.642 11.3697 19.7444C11.6303 19.8701 11.7605 19.933 11.9844 19.935C12.2083 19.937 12.3432 19.875 12.613 19.7508Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield tick-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shield","tick","check","security","approved","verified","confirmation","safe","protection","valid","transaction-approved","payment-verified","order-confirmation","inventory-checked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9.87418V7C6.91913 7 10.4897 5.99355 12 5C13.5103 5.99355 17.0809 7 19 7V9.87418C19 14.1859 16.1139 17.9542 12 19C7.88605 17.9542 5 14.1859 5 9.87418Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield tick-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","tick","check","approved","verified","security","confirmation","payment-success","transaction-complete","order-confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9.87418V7C6.91913 7 10.4897 5.99355 12 5C13.5103 5.99355 17.0809 7 19 7V9.87418C19 14.1859 16.1139 17.9542 12 19C7.88605 17.9542 5 14.1859 5 9.87418Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","tick","check","verified","approved","security","payment-approved","transaction-approved","order-confirmation","approved-order","safe","protected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3134 4.14917C11.4856 4.07687 11.7202 4 11.9891 4C12.258 4 12.4927 4.07687 12.6649 4.14917C12.8434 4.22412 13.0226 4.32364 13.1956 4.42907C13.5313 4.63363 13.9555 4.93043 14.4675 5.28864L14.4971 5.30936C15.3054 5.87485 16.1604 6.14173 17.1593 6.26132L17.2117 6.26759C17.6663 6.32196 18.0934 6.37303 18.4352 6.45624C18.8036 6.54596 19.242 6.70959 19.5708 7.10831C19.8773 7.47981 19.9712 7.89027 19.9939 8.26226C20.0133 8.58107 19.983 8.95603 19.9529 9.32833L19.9487 9.38063C19.4083 16.0936 15.6839 19.5113 13.0232 20.7257L12.981 20.745C12.7355 20.8578 12.4173 21.004 11.9644 20.9999C11.5119 20.9958 11.2013 20.8464 10.9605 20.7305L10.9212 20.7116C8.31128 19.4631 4.73123 15.8728 4.07241 9.43465L4.06699 9.38178C4.02835 9.00522 3.98946 8.6262 4.00261 8.30332C4.01795 7.92636 4.10546 7.50924 4.41096 7.12927C4.73934 6.72083 5.18325 6.55262 5.55589 6.46017C5.90204 6.3743 6.33562 6.3209 6.79802 6.26395L6.85102 6.25742C7.83578 6.136 8.6812 5.86898 9.48111 5.30936L9.51072 5.28864C10.0227 4.93043 10.4469 4.63363 10.7826 4.42907C10.9557 4.32364 11.1348 4.22412 11.3134 4.14917ZM14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L10.9887 12.5971L10.6956 12.3133C10.2988 11.9292 9.66576 11.9394 9.28158 12.3361C8.89741 12.7329 8.90762 13.366 9.30439 13.7502L10.3044 14.7184C10.6966 15.0982 11.321 15.0932 11.7071 14.7071L14.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","tick","check","security","approved","verified","safe","protection","confirmed","success","valid","trust","secure-transaction","payment-security"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.9971 7.23651C19.1212 14.9458 15.1827 18.573 12.6132 19.7513C12.3427 19.8753 12.2075 19.9373 11.9844 19.9353C11.7613 19.9333 11.6307 19.8705 11.3695 19.7449C8.8478 18.5329 5.01388 14.6634 5 7.23651M5 7.20006C6.92339 7.20006 8.55745 7.0429 10.0758 5.97148C11.1471 5.21553 11.6827 4.83756 12 4.83756C12.3173 4.83756 12.8529 5.21553 13.9242 5.97148C15.4425 7.0429 17.0766 7.20006 19 7.20006"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.0317L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shield","information","info","security","protection","details","verify","validation","privacy","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9.96582L12 9.00002" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","info","information","security","secure","protection","details","help","support","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9.96582L12 9.00002" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield tick-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","tick","check","security","verified","approved","confirmation","validation","authorized","protected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.4504 4.16457C11.784 3.94514 12.216 3.94514 12.5496 4.16457C13.1771 4.57737 14.3313 5.04413 15.6202 5.41073C16.9029 5.77555 18.1737 6 19 6C19.5523 6 20 6.44772 20 7V9.87418C20 14.6318 16.8147 18.8079 12.2464 19.9692C12.0847 20.0103 11.9153 20.0103 11.7536 19.9692C7.18527 18.8079 4 14.6318 4 9.87418V7C4 6.44772 4.44772 6 5 6C5.82626 6 7.09705 5.77555 8.37975 5.41073C9.6687 5.04413 10.8229 4.57737 11.4504 4.16457ZM14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L10.9887 12.5971L10.6956 12.3133C10.2988 11.9292 9.66576 11.9394 9.28158 12.3361C8.89741 12.7329 8.90762 13.366 9.30439 13.7502L10.3044 14.7184C10.6966 15.0982 11.321 15.0932 11.7071 14.7071L14.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["shield","security","protection","safe","warranty","insurance","secure-payment","authorization","approved","access","firewall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9.57049V7C5 6.44772 5.44772 6 6 6H6.76092C8.42662 6 10.0098 5.34874 11.3864 4.43431C11.7574 4.18791 12.2426 4.18791 12.6136 4.43431C13.9902 5.34874 15.5734 6 17.2391 6H18C18.5523 6 19 6.44772 19 7V9.58176C19 14.3979 16.2432 18.6099 12.2777 19.914C12.0974 19.9733 11.9026 19.9733 11.7223 19.914C7.75678 18.6094 5 14.3866 5 9.57049Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","secure","authorization","fraud prevention","verified","compliance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9.57049V7C5 6.44772 5.44772 6 6 6H6.76092C8.42662 6 10.0098 5.34874 11.3864 4.43431C11.7574 4.18791 12.2426 4.18791 12.6136 4.43431C13.9902 5.34874 15.5734 6 17.2391 6H18C18.5523 6 19 6.44772 19 7V9.58176C19 14.3979 16.2432 18.6099 12.2777 19.914C12.0974 19.9733 11.9026 19.9733 11.7223 19.914C7.75678 18.6094 5 14.3866 5 9.57049Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","shield","security","details","protected","help","support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0799 3.17204C11.3948 3.07515 11.7143 3 11.9866 3C12.263 3 12.595 3.07985 12.9234 3.18221C13.2817 3.29389 13.7342 3.46461 14.2869 3.70857C15.3928 4.19667 16.9354 4.99362 18.9841 6.24443C19.6102 6.62118 19.977 7.2977 19.9966 8.00676L19.9968 8.01728C20.1398 16.3467 15.1619 20.0477 12.2908 20.9537C12.0949 21.0155 11.8847 21.0154 11.6889 20.9536C8.86546 20.0625 4.01603 16.4702 4 8.42679L4.00025 8.40245C4.02217 7.42191 4.53794 6.4975 5.39929 6.0065C7.31653 4.85483 8.75676 4.11735 9.79295 3.66394C10.3116 3.43701 10.7384 3.27709 11.0799 3.17204ZM11 8.99998C11 9.55227 11.4477 9.99998 12 9.99998C12.5523 9.99998 13 9.55229 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.4477 11 8.99998ZM11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15L13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12L11 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","warranty","guarantee","secure-payment","loyalty","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1669 3.35761C12.4607 2.8808 11.5393 2.8808 10.8331 3.35761C9.55801 4.21856 8.16616 4.77926 6.76092 4.77926H6C4.89543 4.77926 4 5.68941 4 6.81213V9.42486C4 14.6733 6.9592 19.4156 11.4098 20.9039C11.7931 21.032 12.2069 21.032 12.5901 20.9039C17.0398 19.4165 20 14.6859 20 9.43631V6.81213C20 5.68941 19.1046 4.77926 18 4.77926H17.2391C15.8338 4.77926 14.442 4.21856 13.1669 3.35761Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","secure-payment","loyalty","fraud-prevention","payment-protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9.57049V7C5 6.44772 5.44772 6 6 6H6.76092C8.42662 6 10.0098 5.34874 11.3864 4.43431C11.7574 4.18791 12.2426 4.18791 12.6136 4.43431C13.9902 5.34874 15.5734 6 17.2391 6H18C18.5523 6 19 6.44772 19 7V9.58176C19 14.3979 16.2432 18.6099 12.2777 19.914C12.0974 19.9733 11.9026 19.9733 11.7223 19.914C7.75678 18.6094 5 14.3866 5 9.57049Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Shield-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shield","dollar","money","protection","secure-payment","financial-security","transaction-security","payment-protection","secure-transaction","fraud-protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Shield-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","dollar","money","protection","security","payment-security","financial-protection","secure-transaction","safe-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Shield-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","dollar","money","security","payment-security","financial-security","safe-payment","protected-payment","secured-transaction","fraud-protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 9H13.3333M11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.3333C13.2538 12 14 12.6716 14 13.5C14 14.3284 13.2538 15 12.3333 15H11.5M11.5 9V8M10 15L11.5 15M11.5 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Shield-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","dollar","money","secure-payment","payment-security","financial-protection","transaction-security","sales-protection","currency","protection","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0799 3.17204C11.3948 3.07515 11.7143 3 11.9866 3C12.263 3 12.595 3.07985 12.9234 3.18221C13.2817 3.29389 13.7342 3.46461 14.2869 3.70857C15.3928 4.19667 16.9354 4.99362 18.9841 6.24443C19.6102 6.62118 19.977 7.2977 19.9966 8.00676L19.9969 8.01728C20.1398 16.3467 15.1619 20.0477 12.2908 20.9537C12.0949 21.0155 11.8847 21.0154 11.6889 20.9536C8.86546 20.0625 4.01603 16.4702 4 8.42679L4.00025 8.40245C4.02217 7.42191 4.53794 6.4975 5.39929 6.0065C7.31653 4.85483 8.75676 4.11735 9.79295 3.66394C10.3116 3.43701 10.7384 3.27709 11.0799 3.17204ZM12.25 8C12.25 7.58579 11.9142 7.25 11.5 7.25C11.0858 7.25 10.75 7.58579 10.75 8V8.37803C9.87611 8.68691 9.25 9.52034 9.25 10.5C9.25 11.7426 10.2574 12.75 11.5 12.75H12.3333C12.9159 12.75 13.25 13.1582 13.25 13.5C13.25 13.8418 12.9159 14.25 12.3333 14.25H10C9.58579 14.25 9.25 14.5858 9.25 15C9.25 15.4142 9.58579 15.75 10 15.75H10.75V16C10.75 16.4142 11.0858 16.75 11.5 16.75C11.9142 16.75 12.25 16.4142 12.25 16V15.75H12.3333C13.5917 15.75 14.75 14.815 14.75 13.5C14.75 12.185 13.5917 11.25 12.3333 11.25H11.5C11.0858 11.25 10.75 10.9142 10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75H13.3333C13.7475 9.75 14.0833 9.41421 14.0833 9C14.0833 8.58579 13.7475 8.25 13.3333 8.25H12.25V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-quartered-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shield","security","protection","warranty","insurance","secure-payment","privacy","fraud-protection","data-security","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L12 20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M4 11L20 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-quartered-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","secure-payment","safe","authorized","defense"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 3L3.72528 5.13736C3.29598 5.26349 3 5.66699 3 6.12611V9.50391C3 9.65164 3.00257 9.79888 3.00767 9.94559L11 9.94559V3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.24931 12.0022C4.09443 16.1822 7.02114 19.6565 11 21L11 12.0022H3.24931Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M13 21C16.9789 19.6565 19.9056 16.1822 20.7507 12.0022H13L13 21Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M20.9923 9.94559C20.9974 9.79888 21 9.65164 21 9.50391V6.12611C21 5.66699 20.704 5.26349 20.2747 5.13736L13 3V9.94559L20.9923 9.94559Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-quartered-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","security","protection","plus","add","secure-payment","insurance","warranty","add-item","secure","trust","safe"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 4L12 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 11L20 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shield-quartered": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","security","protection","safe","secure","warranty","guarantee","trust","reliability","approved","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 4L12 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M4 11L20 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "shield-with-heart-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shield","heart","loyalty","security","customer-loyalty","health","safe","favorite","protected","protection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L8.59836 12.7891C7.76507 11.8597 7.80693 10.4474 8.69383 9.56807C10 8.53067 10.8572 9.01998 12 10.1837C13.1429 9.01998 14 8.53062 15.3062 9.56801C16.1931 10.4473 16.2349 11.8597 15.4016 12.7891L12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-with-heart-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shield","heart","security","loyalty","rewards","trust","safe","customer-loyalty","secure-payment","protected","guaranteed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L8.59836 12.7891C7.76507 11.8597 7.80693 10.4474 8.69383 9.56807C10 8.53067 10.8572 9.01998 12 10.1837C13.1429 9.01998 14 8.53062 15.3062 9.56801C16.1931 10.4473 16.2349 11.8597 15.4016 12.7891L12 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shield-with-heart-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","heart","loyalty","security","protection","favorite","favorite-customer","trust","verified","safe","secure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7253 3.03848C11.9048 2.98717 12.0952 2.98717 12.2747 3.03848L20.2747 5.32419C20.704 5.44685 21 5.83923 21 6.28571V9.57049C21 14.944 17.4024 19.6585 12.2464 20.9692C12.0847 21.0103 11.9153 21.0103 11.7536 20.9692C6.59756 19.6585 3 14.944 3 9.57049V6.28571C3 5.83923 3.29598 5.44685 3.72528 5.32419L11.7253 3.03848ZM13.3353 8.08388C14.263 7.83763 15.1239 8.14617 15.9281 8.78491C15.9568 8.8077 15.9842 8.83205 16.0102 8.85785C17.2752 10.112 17.3354 12.1301 16.1462 13.4566C16.1277 13.4773 16.1083 13.4972 16.0881 13.5163L12.6865 16.7272C12.3011 17.0909 11.699 17.0909 11.3136 16.7272L7.91195 13.5163C7.89174 13.4973 7.87234 13.4774 7.85379 13.4567C6.66456 12.1302 6.72484 10.112 7.98977 8.85791C8.01579 8.83211 8.04321 8.80776 8.0719 8.78497C8.87614 8.14623 9.73697 7.83769 10.6647 8.0839C11.1596 8.21524 11.6013 8.49131 12 8.81845C12.3987 8.49131 12.8404 8.21523 13.3353 8.08388Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shield-with-heart": {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","heart","security","safe","love","loyalty","rewards","preferred-customer","trust","guarantee","secure-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9.57049V6.28571L12 4L20 6.28571V9.57049C20 14.4982 16.7017 18.8049 12 20C7.29834 18.8049 4 14.4982 4 9.57049Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L8.59836 12.7891C7.76507 11.8597 7.80693 10.4474 8.69383 9.56807C10 8.53067 10.8572 9.01998 12 10.1837C13.1429 9.01998 14 8.53062 15.3062 9.56801C16.1931 10.4473 16.2349 11.8597 15.4016 12.7891L12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    shield: {
        defaultColors: ["#3D4C66"],
        keywords: ["shield","heart","security","safe","love","loyalty","rewards","preferred-customer","trust","guarantee","secure-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9899 20C14.4824 19.2135 19.1316 15.8772 18.997 8.03444C18.9862 7.64515 18.7847 7.29041 18.4662 7.09988C14.42 4.62916 12.4507 4 11.9866 4C11.5226 4 9.6976 4.59013 5.90334 6.87026C5.36026 7.17555 5.01463 7.77033 5 8.4248C5.01507 15.9885 9.53825 19.2262 11.9899 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9.96582L12 9.00002" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "shipment tracking 3-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["location","map","pin","store","address","point","marker","shop","navigation","pickup","delivery","customer location","service location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V16.4C3 15.2686 3 14.7029 3.35147 14.3515C3.70294 14 4.26863 14 5.4 14H8.6C9.73137 14 10.2971 14 10.6485 14.3515C11 14.7029 11 15.2686 11 16.4V18.6C11 19.7314 11 20.2971 10.6485 20.6485C10.2971 21 9.73137 21 8.6 21H7H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.95238 15.9048H7.20476C7.53474 15.9048 7.69974 15.9048 7.80225 15.8022C7.90476 15.6997 7.90476 15.5347 7.90476 15.2048V14.7C7.90476 14.37 7.90476 14.205 7.80225 14.1025C7.69974 14 7.53475 14 7.20476 14H6.7C6.37002 14 6.20503 14 6.10251 14.1025C6 14.205 6 14.37 6 14.7V15.2048C6 15.5347 6 15.6997 6.10251 15.8022C6.20503 15.9048 6.37002 15.9048 6.7 15.9048H6.95238Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.4417 6.18515C17.5827 6.18569 17.6967 6.30036 17.6963 6.44138C17.6959 6.58241 17.5814 6.69649 17.4404 6.69631C17.2994 6.69613 17.1851 6.58176 17.1851 6.44073C17.1848 6.37266 17.2117 6.3073 17.2599 6.25926C17.3082 6.21122 17.3736 6.18452 17.4417 6.18515Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M17.4417 6.18515C17.5827 6.18569 17.6967 6.30036 17.6963 6.44138C17.6959 6.58241 17.5814 6.69649 17.4404 6.69631C17.2994 6.69613 17.1851 6.58176 17.1851 6.44073C17.1848 6.37266 17.2117 6.3073 17.2599 6.25926C17.3082 6.21122 17.3736 6.18452 17.4417 6.18515"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6.44054C14 8.05122 15.7576 9.77179 16.7603 10.6226C17.3558 11.1279 17.5288 11.1237 18.1198 10.6226C19.1235 9.77179 20.8811 8.05122 20.8811 6.44054C20.8811 4.54038 19.3407 3 17.4405 3C15.5404 3 14 4.54038 14 6.44054Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 21H19C20.1046 21 21 20.1048 21 19.0003C21 18.6874 21 18.3507 21 18V14"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 3L5 3C3.89543 3 3 3.89516 3 4.99973C3 5.31259 3 5.64926 3 6L3 10"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking 3-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["scale","weight","weighing","measurement","balance","portion","food-scale","product-weight"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V16.4C3 15.2686 3 14.7029 3.35147 14.3515C3.70294 14 4.26863 14 5.4 14H8.6C9.73137 14 10.2971 14 10.6485 14.3515C11 14.7029 11 15.2686 11 16.4V18.6C11 19.7314 11 20.2971 10.6485 20.6485C10.2971 21 9.73137 21 8.6 21H7H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.95238 15.9048H7.20476C7.53474 15.9048 7.69974 15.9048 7.80225 15.8022C7.90476 15.6997 7.90476 15.5347 7.90476 15.2048V14H6V15.2048C6 15.5347 6 15.6997 6.10251 15.8022C6.20503 15.9048 6.37002 15.9048 6.7 15.9048H6.95238Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 6.44054C14 8.05122 15.7576 9.77179 16.7603 10.6226C17.3558 11.1279 17.5288 11.1237 18.1198 10.6226C19.1235 9.77179 20.8811 8.05122 20.8811 6.44054C20.8811 4.54038 19.3407 3 17.4405 3C15.5404 3 14 4.54038 14 6.44054Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.4417 6.18515C17.5827 6.18569 17.6967 6.30036 17.6963 6.44138C17.6959 6.58241 17.5814 6.69649 17.4404 6.69631C17.2994 6.69613 17.1851 6.58176 17.1851 6.44073C17.1848 6.37266 17.2117 6.3073 17.2599 6.25926C17.3082 6.21122 17.3736 6.18452 17.4417 6.18515"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 21H19C20.1046 21 21 20.1048 21 19.0003C21 18.6874 21 18.3507 21 18V14"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 3L5 3C3.89543 3 3 3.89516 3 4.99973C3 5.31259 3 5.64926 3 6L3 10"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["location","map","pin","address","store","tracking","delivery","pickup","point","navigation","gps","place"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V15.4C3 14.2686 3 13.7029 3.35147 13.3515C3.70294 13 4.26863 13 5.4 13H9.6C10.7314 13 11.2971 13 11.6485 13.3515C12 13.7029 12 14.2686 12 15.4V18.6C12 19.7314 12 20.2971 11.6485 20.6485C11.2971 21 10.7314 21 9.6 21H7.5H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.50836 15.1769H7.89679C8.22678 15.1769 8.39177 15.1769 8.49428 15.0744C8.59679 14.9718 8.59679 14.8069 8.59679 14.4769V13.7C8.59679 13.37 8.59679 13.205 8.49428 13.1025C8.39177 13 8.22678 13 7.89679 13H7.11992C6.78994 13 6.62495 13 6.52243 13.1025C6.41992 13.205 6.41992 13.37 6.41992 13.7V14.4769C6.41992 14.8069 6.41992 14.9718 6.52243 15.0744C6.62495 15.1769 6.78994 15.1769 7.11992 15.1769H7.50836Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.8714 5.58378C19.0301 5.58439 19.1583 5.71339 19.1579 5.87205C19.1575 6.0307 19.0286 6.15904 18.87 6.15884C18.7113 6.15864 18.5828 6.02997 18.5828 5.87131C18.5824 5.79474 18.6127 5.7212 18.667 5.66715C18.7212 5.61311 18.7949 5.58308 18.8714 5.58378Z"
                    fill={colors?.[0] || "#7E47E1"}
                />
                <path
                    d="M18.8714 5.58378C19.0301 5.58439 19.1583 5.71339 19.1579 5.87205C19.1575 6.0307 19.0286 6.15904 18.87 6.15884C18.7113 6.15864 18.5828 6.02997 18.5828 5.87131C18.5824 5.79474 18.6127 5.7212 18.667 5.66715C18.7212 5.61311 18.7949 5.58308 18.8714 5.58378"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5.87061C15 7.68262 16.9773 9.61826 18.1053 10.5755C18.7752 11.1439 18.9699 11.1391 19.6348 10.5755C20.7639 9.61826 22.7412 7.68262 22.7412 5.87061C22.7412 3.73293 21.0083 2 18.8706 2C16.7329 2 15 3.73293 15 5.87061Z"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 21H17C18.1046 21 19 20.1048 19 19.0003C19 18.6874 19 18.3507 19 18V14"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking 3-3": {
        defaultColors: ["#000000"],
        keywords: ["box","package","shipment","tracking","delivery","order","inventory","stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00003 13C4.51656 13.0002 4.08568 13.0032 3.73335 13.0506C3.32341 13.1057 2.90946 13.2328 2.57115 13.5711C2.23284 13.9095 2.10575 14.3234 2.05063 14.7333C1.99992 15.1105 1.99996 15.5777 2.00001 16.103L2 18.897C1.99996 19.4224 1.99992 19.8896 2.05063 20.2667C2.10574 20.6767 2.23283 21.0906 2.57115 21.4289C2.90946 21.7672 3.3234 21.8943 3.73334 21.9494C4.1105 22.0001 4.57767 22.0001 5.10301 22.0001H8.39697C8.9223 22.0001 9.38951 22.0001 9.76667 21.9494C10.1766 21.8943 10.5905 21.7672 10.9289 21.4289C11.2672 21.0906 11.3943 20.6767 11.4494 20.2667C11.5001 19.8895 11.5 19.4224 11.5 18.897L11.5 16.103C11.5001 15.5777 11.5001 15.1105 11.4494 14.7333C11.3943 14.3234 11.2672 13.9095 10.9289 13.5711C10.5906 13.2328 10.1766 13.1057 9.76667 13.0506C9.41435 13.0033 8.98349 13.0002 8.50003 13L8.50005 14.5C8.50014 14.639 8.50026 14.8089 8.48053 14.9556C8.45654 15.1341 8.39168 15.3856 8.17785 15.5995C7.96402 15.8133 7.71249 15.8782 7.53401 15.9022C7.38725 15.9219 7.21739 15.9218 7.07837 15.9217H6.4217C6.28268 15.9218 6.11282 15.9219 5.96605 15.9022C5.78758 15.8782 5.53605 15.8133 5.32222 15.5995C5.10838 15.3856 5.04353 15.1341 5.01953 14.9556C4.9998 14.8089 4.99992 14.639 5.00002 14.5L5.00003 13Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.25 6.44054C13.25 4.12617 15.1262 2.25 17.4405 2.25C19.7549 2.25 21.6311 4.12617 21.6311 6.44054C21.6311 7.49762 21.0671 8.49558 20.4723 9.27244C19.8616 10.0702 19.1265 10.7524 18.6048 11.1947C18.4517 11.3245 18.2877 11.4555 18.1179 11.554C17.94 11.657 17.7142 11.7492 17.4438 11.75C17.1731 11.7507 16.9463 11.6596 16.7668 11.5563C16.5954 11.4577 16.43 11.326 16.275 11.1945C15.754 10.7523 15.0192 10.0701 14.4086 9.27237C13.814 8.49556 13.25 7.49761 13.25 6.44054ZM18.8002 6.50333C18.802 5.78601 18.2225 5.20276 17.5052 5.20001C17.159 5.19683 16.826 5.33261 16.5807 5.57695C16.3354 5.8213 16.1984 6.15379 16.2002 6.50001C16.2002 7.21732 16.7812 7.79908 17.4986 7.79999C18.2159 7.80091 18.7984 7.22064 18.8002 6.50333Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 13C21.5523 13 22 13.4477 22 14V19.0003C22 20.6573 20.6567 22 19 22H16C15.4477 22 15 21.5523 15 21C15 20.4477 15.4477 20 16 20H19C19.5525 20 20 19.5524 20 19.0003V14C20 13.4477 20.4477 13 21 13Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 11C2.44772 11 2 10.5523 2 10L2 4.99973C2 3.3427 3.34332 2 5 2L8 2C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4L5 4C4.44754 4 4 4.44762 4 4.99973L4 10C4 10.5523 3.55228 11 3 11Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "shipment tracking-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","shipping","delivery","tracking","shipment","location","status","order-status","track-order","package-location","delivery-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V15.4C3 14.2686 3 13.7029 3.35147 13.3515C3.70294 13 4.26863 13 5.4 13H9.6C10.7314 13 11.2971 13 11.6485 13.3515C12 13.7029 12 14.2686 12 15.4V18.6C12 19.7314 12 20.2971 11.6485 20.6485C11.2971 21 10.7314 21 9.6 21H7.5H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.50836 15.1769H7.89679C8.22678 15.1769 8.39177 15.1769 8.49428 15.0744C8.59679 14.9718 8.59679 14.8069 8.59679 14.4769V13H6.41992V14.4769C6.41992 14.8069 6.41992 14.9718 6.52243 15.0744C6.62495 15.1769 6.78994 15.1769 7.11992 15.1769H7.50836Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 5.87061C15 7.68262 16.9773 9.61826 18.1053 10.5755C18.7752 11.1439 18.9699 11.1391 19.6348 10.5755C20.7639 9.61826 22.7412 7.68262 22.7412 5.87061C22.7412 3.73293 21.0083 2 18.8706 2C16.7329 2 15 3.73293 15 5.87061Z"
                    fill={colors?.[1] || "#000000"}
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8714 5.58378C19.0301 5.58439 19.1583 5.71339 19.1579 5.87205C19.1575 6.0307 19.0286 6.15904 18.87 6.15884C18.7113 6.15864 18.5828 6.02997 18.5828 5.87131C18.5824 5.79474 18.6127 5.7212 18.667 5.66715C18.7212 5.61311 18.7949 5.58308 18.8714 5.58378"
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 21H17C18.1046 21 19 20.1048 19 19.0003C19 18.6874 19 18.3507 19 18V14"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking 3": {
        defaultColors: ["#000000"],
        keywords: ["shipment","tracking","package","delivery","logistics","status","update","track-order","shipping","box"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V16.4C3 15.2686 3 14.7029 3.35147 14.3515C3.70294 14 4.26863 14 5.4 14H8.6C9.73137 14 10.2971 14 10.6485 14.3515C11 14.7029 11 15.2686 11 16.4V18.6C11 19.7314 11 20.2971 10.6485 20.6485C10.2971 21 9.73137 21 8.6 21H7H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.95238 15.9048H7.20476C7.53474 15.9048 7.69974 15.9048 7.80225 15.8022C7.90476 15.6997 7.90476 15.5347 7.90476 15.2048V14.7C7.90476 14.37 7.90476 14.205 7.80225 14.1025C7.69974 14 7.53475 14 7.20476 14H6.7C6.37002 14 6.20503 14 6.10251 14.1025C6 14.205 6 14.37 6 14.7V15.2048C6 15.5347 6 15.6997 6.10251 15.8022C6.20503 15.9048 6.37002 15.9048 6.7 15.9048H6.95238Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.4417 6.18515C17.5827 6.18569 17.6967 6.30036 17.6963 6.44138C17.6959 6.58241 17.5814 6.69649 17.4404 6.69631C17.2994 6.69613 17.1851 6.58176 17.1851 6.44073C17.1848 6.37266 17.2117 6.3073 17.2599 6.25926C17.3082 6.21122 17.3736 6.18452 17.4417 6.18515"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6.44054C14 8.05122 15.7576 9.77179 16.7603 10.6226C17.3558 11.1279 17.5288 11.1237 18.1198 10.6226C19.1235 9.77179 20.8811 8.05122 20.8811 6.44054C20.8811 4.54038 19.3407 3 17.4405 3C15.5404 3 14 4.54038 14 6.44054Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 21H19C20.1046 21 21 20.1048 21 19.0003C21 18.6874 21 18.3507 21 18V14"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 3L5 3C3.89543 3 3 3.89516 3 4.99973C3 5.31259 3 5.64926 3 6L3 10"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking-3": {
        defaultColors: ["#000000"],
        keywords: ["shipment","tracking","box","package","delivery","moving","location","shipping","cargo","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00003 13C4.51656 13.0002 4.08568 13.0032 3.73335 13.0506C3.32341 13.1057 2.90946 13.2328 2.57115 13.5711C2.23284 13.9095 2.10575 14.3234 2.05063 14.7333C1.99992 15.1105 1.99996 15.5777 2.00001 16.103L2 18.897C1.99996 19.4224 1.99992 19.8896 2.05063 20.2667C2.10574 20.6767 2.23283 21.0906 2.57115 21.4289C2.90946 21.7672 3.3234 21.8943 3.73334 21.9494C4.1105 22.0001 4.57767 22.0001 5.10301 22.0001H8.39697C8.9223 22.0001 9.38951 22.0001 9.76667 21.9494C10.1766 21.8943 10.5905 21.7672 10.9289 21.4289C11.2672 21.0906 11.3943 20.6767 11.4494 20.2667C11.5001 19.8895 11.5 19.4224 11.5 18.897L11.5 16.103C11.5001 15.5777 11.5001 15.1105 11.4494 14.7333C11.3943 14.3234 11.2672 13.9095 10.9289 13.5711C10.5906 13.2328 10.1766 13.1057 9.76667 13.0506C9.41435 13.0033 8.98349 13.0002 8.50003 13L8.50005 14.5C8.50014 14.639 8.50026 14.8089 8.48053 14.9556C8.45654 15.1341 8.39168 15.3856 8.17785 15.5995C7.96402 15.8133 7.71249 15.8782 7.53401 15.9022C7.38725 15.9219 7.21739 15.9218 7.07837 15.9217H6.4217C6.28268 15.9218 6.11282 15.9219 5.96605 15.9022C5.78758 15.8782 5.53605 15.8133 5.32222 15.5995C5.10838 15.3856 5.04353 15.1341 5.01953 14.9556C4.9998 14.8089 4.99992 14.639 5.00002 14.5L5.00003 13Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.25 6.44054C13.25 4.12617 15.1262 2.25 17.4405 2.25C19.7549 2.25 21.6311 4.12617 21.6311 6.44054C21.6311 7.49762 21.0671 8.49558 20.4723 9.27244C19.8616 10.0702 19.1265 10.7524 18.6048 11.1947C18.4517 11.3245 18.2877 11.4555 18.1179 11.554C17.94 11.657 17.7142 11.7492 17.4438 11.75C17.1731 11.7507 16.9463 11.6596 16.7668 11.5563C16.5954 11.4577 16.43 11.326 16.275 11.1945C15.754 10.7523 15.0192 10.0701 14.4086 9.27237C13.814 8.49556 13.25 7.49761 13.25 6.44054ZM18.8002 6.50333C18.802 5.78601 18.2225 5.20276 17.5052 5.20001C17.159 5.19683 16.826 5.33261 16.5807 5.57695C16.3354 5.8213 16.1984 6.15379 16.2002 6.50001C16.2002 7.21732 16.7812 7.79908 17.4986 7.79999C18.2159 7.80091 18.7984 7.22064 18.8002 6.50333Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 13C21.5523 13 22 13.4477 22 14V19.0003C22 20.6573 20.6567 22 19 22H16C15.4477 22 15 21.5523 15 21C15 20.4477 15.4477 20 16 20H19C19.5525 20 20 19.5524 20 19.0003V14C20 13.4477 20.4477 13 21 13Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "shirt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shirt","t-shirt","clothing","apparel","lightning","bolt","sale","discount","promotion","fashion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5H15.6115C17.2298 5 18.039 5 18.5985 5.47396C19.158 5.94792 19.291 6.74608 19.5571 8.3424L20 11H17M9 5H8.38851C6.77017 5 5.961 5 5.4015 5.47396C4.84201 5.94792 4.70899 6.74608 4.44293 8.3424L4 11H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.3333 12L11 14H13L11.6667 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shirt-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["shirt","clothing","apparel","t-shirt","inventory","product","item","size","style","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C13.8846 14.6667 10.1154 14.6667 7 16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 10C7.24062 11.5159 7.36544 12.9276 7.37447 14.3354C7.38945 16.6701 7.39693 17.8375 7.98193 18.4187C8.56693 19 9.60628 19 11.685 19H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10C16.7594 11.5159 16.6346 12.9276 16.6255 14.3354C16.6106 16.6701 16.6031 17.8375 16.0181 18.4187C15.4331 19 14.3937 19 12.315 19H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12.0345H5.17935C4.56179 12.0345 4.09184 11.4803 4.19281 10.871L4.8158 7.11156C4.93015 6.42152 5.39459 5.83207 6.07055 5.65231C7.56311 5.25539 9.63445 5 12 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12.0345H18.8206C19.4382 12.0345 19.9082 11.4803 19.8072 10.871L19.1842 7.11156C19.0698 6.42152 18.6054 5.83207 17.9295 5.65231C16.4369 5.25539 14.3655 5 12 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shipment tracking": {
        defaultColors: ["#000000"],
        keywords: ["shipment","tracking","delivery","package","box","location","map","shipping","order-status","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 18.6V15.4C3 14.2686 3 13.7029 3.35147 13.3515C3.70294 13 4.26863 13 5.4 13H9.6C10.7314 13 11.2971 13 11.6485 13.3515C12 13.7029 12 14.2686 12 15.4V18.6C12 19.7314 12 20.2971 11.6485 20.6485C11.2971 21 10.7314 21 9.6 21H7.5H5.4C4.26863 21 3.70294 21 3.35147 20.6485C3 20.2971 3 19.7314 3 18.6Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7.50836 15.1769H7.89679C8.22678 15.1769 8.39177 15.1769 8.49428 15.0744C8.59679 14.9718 8.59679 14.8069 8.59679 14.4769V13.7C8.59679 13.37 8.59679 13.205 8.49428 13.1025C8.39177 13 8.22678 13 7.89679 13H7.11992C6.78994 13 6.62495 13 6.52243 13.1025C6.41992 13.205 6.41992 13.37 6.41992 13.7V14.4769C6.41992 14.8069 6.41992 14.9718 6.52243 15.0744C6.62495 15.1769 6.78994 15.1769 7.11992 15.1769H7.50836Z"
                    fill={colors?.[0] || "#000000"}
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.8714 5.58378C19.0301 5.58439 19.1583 5.71339 19.1579 5.87205C19.1575 6.0307 19.0286 6.15904 18.87 6.15884C18.7113 6.15864 18.5828 6.02997 18.5828 5.87131C18.5824 5.79474 18.6127 5.7212 18.667 5.66715C18.7212 5.61311 18.7949 5.58308 18.8714 5.58378"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5.87061C15 7.68262 16.9773 9.61826 18.1053 10.5755C18.7752 11.1439 18.9699 11.1391 19.6348 10.5755C20.7639 9.61826 22.7412 7.68262 22.7412 5.87061C22.7412 3.73293 21.0083 2 18.8706 2C16.7329 2 15 3.73293 15 5.87061Z"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 21H17C18.1046 21 19 20.1048 19 19.0003C19 18.6874 19 18.3507 19 18V14"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shirt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shirt","clothing","apparel","t-shirt","lightning","bolt","power","energy","product","item","sale","discount","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8C13.6569 8 15 6.65685 15 5H15.6115C17.2298 5 18.039 5 18.5985 5.47396C19.158 5.94792 19.291 6.74608 19.5571 8.3424L20 11H17V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15V11H4L4.44293 8.3424C4.70899 6.74608 4.84201 5.94792 5.4015 5.47396C5.961 5 6.77017 5 8.38851 5H9C9 6.65685 10.3431 8 12 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17 11H20L19.5571 8.3424C19.291 6.74608 19.158 5.94792 18.5985 5.47396C18.039 5 17.2298 5 15.6115 5H15C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5H8.38851C6.77017 5 5.961 5 5.4015 5.47396C4.84201 5.94792 4.70899 6.74608 4.44293 8.3424L4 11H7M17 9V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15V9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.3333 12L11 14H13L11.6667 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shirt-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shirt","clothing","apparel","item","product","retail","sale","t-shirt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0002 4C14.4773 4 16.6825 4.26119 18.3119 4.6859C19.4489 4.98224 20.1649 5.93382 20.3364 6.94809L20.972 10.7076C21.1781 11.9261 20.2191 13.0345 18.959 13.0345H17.7829C17.7567 13.4735 17.7422 13.9385 17.7393 14.3721L17.7389 14.3803C17.7316 15.4925 17.7254 16.4411 17.6406 17.1509C17.555 17.8678 17.3696 18.5914 16.8184 19.1281C16.2839 19.6487 15.6005 19.8365 14.9059 19.9199C14.2387 20.0001 13.3912 20 12.386 20H11.614C10.6088 20 9.76132 20.0001 9.09411 19.9199C8.39947 19.8365 7.7161 19.6487 7.18156 19.1281C6.63045 18.5914 6.44503 17.8678 6.35937 17.1509C6.27456 16.4411 6.26838 15.4925 6.26112 14.3802L6.26107 14.3721C6.25823 13.9385 6.24334 13.4735 6.21707 13.0345H5.04102C3.78087 13.0345 2.82194 11.9261 3.02795 10.7076L3.66357 6.94809C3.83505 5.93382 4.55113 4.98224 5.68806 4.6859C7.31747 4.26119 9.52299 4 12.0002 4ZM10.2611 6.04708C10.816 6.01643 11.3971 6.00001 11.9998 6.00001C12.6026 6.00001 13.184 6.01643 13.7389 6.04708C13.3797 6.61883 12.7353 7.00002 12 7.00002C11.2647 7.00002 10.6203 6.61883 10.2611 6.04708ZM8.38604 16.9183C8.37204 16.8011 8.36055 16.6751 8.35108 16.5391C10.6889 15.8204 13.3111 15.8204 15.6489 16.5391C15.6394 16.6751 15.628 16.8011 15.614 16.9183C15.5428 17.5141 15.4259 17.6648 15.3802 17.7094C15.3179 17.77 15.1726 17.8729 14.6576 17.9348C14.1295 17.9982 13.4085 18 12.3212 18H11.6788C10.5915 18 9.87048 17.9982 9.34235 17.9348C8.82736 17.8729 8.68211 17.77 8.61979 17.7094C8.57406 17.6648 8.45723 17.5141 8.38604 16.9183Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shirt-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shirt","clothing","apparel","t-shirt","item","product","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.25805 12.0344C7.33052 12.813 7.3692 13.5747 7.37408 14.3353C7.38905 16.67 7.39654 17.8374 7.98153 18.4186C8.56653 18.9999 9.60589 18.9999 11.6846 18.9999H12.3146C14.3933 18.9999 15.4327 18.9999 16.0177 18.4186C16.6027 17.8374 16.6102 16.67 16.6251 14.3353V14.3353C16.63 13.5747 16.6687 12.813 16.7412 12.0344H18.8203C19.4378 12.0344 19.9078 11.4802 19.8068 10.8709L19.1838 7.11146C19.0695 6.42142 18.605 5.83197 17.9291 5.65221C17.0527 5.41915 16.2174 5.25827 14.9995 5.14585C15.2401 7.52329 12.9761 7.99994 11.9995 7.99994C9.99951 7.99985 8.49951 5.99988 8.99951 5.14575C7.88039 5.25952 6.88832 5.43463 6.07015 5.65221C5.39419 5.83197 4.92976 6.42142 4.81541 7.11146L4.19241 10.8709C4.09145 11.4802 4.56139 12.0344 5.17896 12.0344H7.25805Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M7.37408 14.3353L8.12406 14.3304V14.3304L7.37408 14.3353ZM7.74033 9.88232C7.67539 9.47323 7.29112 9.19424 6.88203 9.25917C6.47294 9.32411 6.19394 9.70838 6.25888 10.1175L7.74033 9.88232ZM7.98153 18.4186L7.45291 18.9507L7.98153 18.4186ZM16.6251 14.3353L15.8751 14.3304V14.3353H16.6251ZM17.7403 10.1175C17.8053 9.70838 17.5263 9.32411 17.1172 9.25917C16.7081 9.19424 16.3238 9.47323 16.2589 9.88233L17.7403 10.1175ZM16.6251 14.3353L17.3751 14.3401V14.3353H16.6251ZM16.0177 18.4186L15.489 17.8866L16.0177 18.4186ZM4.19241 10.8709L3.4525 10.7483V10.7483L4.19241 10.8709ZM4.81541 7.11146L5.55532 7.23407L4.81541 7.11146ZM6.07015 5.65221L6.2629 6.37702L6.07015 5.65221ZM19.8068 10.8709L19.0669 10.9935L19.8068 10.8709ZM19.1838 7.11146L19.9237 6.98885L19.1838 7.11146ZM17.9291 5.65221L18.1218 4.9274V4.9274L17.9291 5.65221ZM14.9995 5.14585L15.0685 4.39903C14.8453 4.37843 14.6246 4.4587 14.4669 4.61786C14.3091 4.77702 14.2308 4.9984 14.2533 5.22136L14.9995 5.14585ZM11.9995 7.99994L11.9995 8.74994H11.9995V7.99994ZM8.99951 5.14575L9.64676 5.52465C9.78942 5.28095 9.78311 4.97779 9.63043 4.74024C9.47775 4.50269 9.20459 4.37104 8.92366 4.3996L8.99951 5.14575ZM8.12406 14.3304C8.11904 13.5475 8.07922 12.7642 8.00483 11.9649L6.51128 12.1039C6.58183 12.8619 6.61936 13.602 6.62409 14.3401L8.12406 14.3304ZM8.00483 11.9649C7.94153 11.2848 7.85327 10.5938 7.74033 9.88232L6.25888 10.1175C6.36719 10.7999 6.45123 11.4587 6.51128 12.1039L8.00483 11.9649ZM6.62409 14.3401C6.63146 15.4892 6.63629 16.4144 6.71914 17.1217C6.80132 17.8235 6.97466 18.4755 7.45291 18.9507L8.51016 17.8866C8.40341 17.7806 8.28051 17.5582 8.20895 16.9473C8.13806 16.342 8.13166 15.5161 8.12406 14.3304L6.62409 14.3401ZM11.6846 18.2499C10.6255 18.2499 9.90059 18.2486 9.36417 18.1828C8.83739 18.1183 8.62909 18.0048 8.51016 17.8866L7.45291 18.9507C7.91897 19.4138 8.52285 19.5909 9.18168 19.6717C9.83086 19.7512 10.665 19.7499 11.6846 19.7499V18.2499ZM17.3751 14.3401C17.3798 13.602 17.4174 12.8619 17.4879 12.1039L15.9944 11.9649C15.92 12.7642 15.8802 13.5475 15.8751 14.3304L17.3751 14.3401ZM17.4879 12.1039C17.548 11.4587 17.632 10.7999 17.7403 10.1175L16.2589 9.88233C16.1459 10.5938 16.0577 11.2848 15.9944 11.9649L17.4879 12.1039ZM15.8751 14.3353V14.3353H17.3751V14.3353H15.8751ZM15.8751 14.3305C15.8675 15.5161 15.8611 16.342 15.7903 16.9473C15.7187 17.5582 15.5958 17.7806 15.489 17.8866L16.5463 18.9507C17.0246 18.4755 17.1979 17.8235 17.2801 17.1218C17.3629 16.4144 17.3677 15.4892 17.3751 14.3401L15.8751 14.3305ZM12.3146 19.7499C13.3342 19.7499 14.1684 19.7512 14.8175 19.6717C15.4764 19.5909 16.0802 19.4138 16.5463 18.9507L15.489 17.8866C15.3701 18.0048 15.1618 18.1183 14.635 18.1828C14.0986 18.2486 13.3737 18.2499 12.3146 18.2499V19.7499ZM4.93232 10.9935L5.55532 7.23407L4.0755 6.98885L3.4525 10.7483L4.93232 10.9935ZM5.17896 12.7844H7.25805V11.2844H5.17896V12.7844ZM5.55532 7.23407C5.62937 6.7872 5.91574 6.46934 6.2629 6.37702L5.8774 4.9274C4.87264 5.1946 4.23014 6.05564 4.0755 6.98885L5.55532 7.23407ZM3.4525 10.7483C3.27582 11.8145 4.09822 12.7844 5.17896 12.7844V11.2844C5.02456 11.2844 4.90708 11.1458 4.93232 10.9935L3.4525 10.7483ZM20.5467 10.7483L19.9237 6.98885L18.4439 7.23407L19.0669 10.9935L20.5467 10.7483ZM18.8203 11.2844H16.7412V12.7844H18.8203V11.2844ZM19.9237 6.98885C19.7691 6.05564 19.1266 5.1946 18.1218 4.9274L17.7363 6.37702C18.0835 6.46934 18.3698 6.7872 18.4439 7.23407L19.9237 6.98885ZM19.0669 10.9935C19.0921 11.1458 18.9746 11.2844 18.8203 11.2844V12.7844C19.901 12.7844 20.7234 11.8145 20.5467 10.7483L19.0669 10.9935ZM11.6846 19.7499H12.3146V18.2499H11.6846V19.7499ZM18.1218 4.9274C17.2043 4.6834 16.3275 4.51525 15.0685 4.39903L14.9306 5.89268C16.1072 6.00129 16.9011 6.1549 17.7363 6.37702L18.1218 4.9274ZM14.2533 5.22136C14.3009 5.6912 14.2216 6.01904 14.1017 6.25351C13.9804 6.49101 13.7931 6.67994 13.5549 6.83065C13.0569 7.14579 12.402 7.24994 11.9995 7.24994V8.74994C12.5736 8.74994 13.539 8.61577 14.357 8.09822C14.7768 7.83259 15.1715 7.45659 15.4374 6.93606C15.705 6.41251 15.8185 5.78923 15.7457 5.07034L14.2533 5.22136ZM6.2629 6.37702C7.0349 6.17172 7.98675 6.00257 9.07536 5.89191L8.92366 4.3996C7.77404 4.51647 6.74173 4.69755 5.8774 4.9274L6.2629 6.37702ZM8.35226 4.76685C8.07632 5.23822 8.12631 5.77048 8.26389 6.18718C8.40597 6.61751 8.67393 7.03832 9.012 7.40299C9.68539 8.12939 10.7491 8.74988 11.9995 8.74994L11.9995 7.24994C11.2499 7.24991 10.5636 6.87037 10.112 6.38322C9.88759 6.14113 9.7493 5.90179 9.68826 5.7169C9.62272 5.51838 9.6727 5.48035 9.64676 5.52465L8.35226 4.76685Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M7.98242 18.4187C8.56742 19 9.60678 19 11.6855 19H12.3155C14.3942 19 15.4336 19 16.0186 18.4187"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C13.8846 14.6667 10.1154 14.6667 7 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shirt-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["shirt","t-shirt","clothing","apparel","item","product","merchandise","retail","inventory","size","style","fashion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 10C7.24062 11.5159 7.36544 12.9276 7.37447 14.3354C7.38945 16.6701 7.39693 17.8375 7.98193 18.4187C8.56693 19 9.60628 19 11.685 19H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10C16.7594 11.5159 16.6346 12.9276 16.6255 14.3354C16.6106 16.6701 16.6031 17.8375 16.0181 18.4187C15.4331 19 14.3937 19 12.315 19H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12.0345H5.17935C4.56179 12.0345 4.09184 11.4803 4.19281 10.871L4.8158 7.11156C4.93015 6.42152 5.39459 5.83207 6.07055 5.65231C7.56311 5.25539 9.63445 5 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12.0345H18.8206C19.4382 12.0345 19.9082 11.4803 19.8072 10.871L19.1842 7.11156C19.0698 6.42152 18.6054 5.83207 17.9295 5.65231C16.4369 5.25539 14.3655 5 12 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 16C13.8846 14.6667 10.1154 14.6667 7 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    shirt: {
        defaultColors: ["#3D4C66"],
        keywords: ["shirt","t-shirt","clothing","apparel","item","product","merchandise","retail","inventory","size","style","fashion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 5H15.6115C17.2298 5 18.039 5 18.5985 5.47396C19.158 5.94792 19.291 6.74608 19.5571 8.3424L20 11H17M9 5H8.38851C6.77017 5 5.961 5 5.4015 5.47396C4.84201 5.94792 4.70899 6.74608 4.44293 8.3424L4 11H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H11C9.11438 19 8.17157 19 7.58579 18.4142C7 17.8284 7 16.8856 7 15V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.3333 12L11 14H13L11.6667 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shocket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["power","outlet","socket","electricity","charging","terminal","plug","electrical","supply","hardware","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C9.23857 7 7 9.23869 7 12.0001C7 14.7615 9.23858 17 12 17C14.7614 17 17 14.7615 17 12.0001C17 9.23869 14.7614 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13V11M14 13V11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shocket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["power","outlet","electricity","plug","power-supply","charge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92944V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57533 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM7 12.0001C7 9.23869 9.23857 7 12 7C14.7614 7 17 9.23869 17 12.0001C17 14.7615 14.7614 17 12 17C9.23858 17 7 14.7615 7 12.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 10C10.5523 10 11 10.4477 11 11V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V11C9 10.4477 9.44772 10 10 10ZM14 10C14.5523 10 15 10.4477 15 11V13C15 13.5523 14.5523 14 14 14C13.4477 14 13 13.5523 13 13V11C13 10.4477 13.4477 10 14 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shocket-2": {
        defaultColors: ["#D9D1E0", "#3D4C66", "#CDD1D8"],
        keywords: ["power","outlet","electric","socket","charge","plug","connection","power-supply","electricity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C9.23857 7 7 9.23869 7 12.0001C7 14.7615 9.23858 17 12 17C14.7614 17 17 14.7615 17 12.0001C17 9.23869 14.7614 7 12 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13V11M14 13V11"
                    stroke={colors?.[2] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shirt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clothing","shirt","t-shirt","fashion","lightning","fast-selling","popular","item","apparel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.37405 4.06695C6.91097 3.99992 7.57083 3.99996 8.32949 4L9.00001 4C9.55229 4 10 4.44772 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 4.44772 14.4477 4 15 4L15.6705 4C16.4292 3.99996 17.089 3.99992 17.626 4.06695C18.2045 4.13918 18.7609 4.30096 19.2449 4.71094C19.7288 5.12093 19.9799 5.64322 20.1463 6.20196C20.3006 6.72054 20.4091 7.37144 20.5338 8.11976L20.9864 10.8356C21.0347 11.1256 20.953 11.4221 20.763 11.6464C20.573 11.8707 20.294 12 20 12H18L18 15.0658C18.0001 15.9523 18.0001 16.7161 17.9179 17.3278C17.8297 17.9833 17.631 18.6117 17.1213 19.1213C16.6117 19.631 15.9833 19.8297 15.3278 19.9179C14.7161 20.0001 13.9523 20.0001 13.0658 20H10.9341C10.0477 20.0001 9.28387 20.0001 8.67222 19.9179C8.0167 19.8297 7.38835 19.631 6.87869 19.1213C6.36902 18.6117 6.17028 17.9833 6.08215 17.3278C5.99991 16.7161 5.99995 15.9523 6 15.0658L6.00001 12H4.00001C3.70606 12 3.42699 11.8707 3.23699 11.6464C3.04698 11.4221 2.96529 11.1256 3.01361 10.8356L3.46625 8.11978C3.59093 7.37144 3.69937 6.72055 3.85376 6.20196C4.02011 5.64322 4.27117 5.12093 4.75514 4.71094C5.2391 4.30096 5.79556 4.13918 6.37405 4.06695ZM13.1654 12.5548C13.4717 12.0953 13.3476 11.4744 12.888 11.1681C12.4285 10.8617 11.8076 10.9859 11.5013 11.4454L10.168 13.4454C9.96338 13.7523 9.94431 14.1468 10.1183 14.472C10.2923 14.7971 10.6312 15.0001 11 15.0001H11.1315L10.8346 15.4454C10.5283 15.9049 10.6524 16.5258 11.112 16.8322C11.5715 17.1385 12.1924 17.0143 12.4987 16.5548L13.8321 14.5548C14.0366 14.248 14.0557 13.8534 13.8817 13.5282C13.7077 13.2031 13.3688 13.0001 13 13.0001H12.8685L13.1654 12.5548Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shocket-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["power","plug","outlet","electricity","charging","connection","system","power-supply","electricity-supply"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.134 4 5 7.13416 5 11.0002C5 14.8661 8.13401 18 12 18C15.866 18 19 14.8661 19 11.0002C19 7.13416 15.866 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14V12M15 14V12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shocket-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["power","outlet","electricity","connection","charge","plug","device","hardware","connect","supply","electric","socket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.134 4 5 7.13416 5 11.0002C5 14.8661 8.13401 18 12 18C15.866 18 19 14.8661 19 11.0002C19 7.13416 15.866 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14V12M15 14V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["jar","canning","food","preserves","product","inventory","storage","item","canned-goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 15L7 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7457 11.0799C18.7899 10.668 18.4918 10.2984 18.0799 10.2543C17.668 10.2101 17.2984 10.5082 17.2543 10.9201L18.7457 11.0799ZM16.2971 18.3616L15.8346 17.7712L16.2971 18.3616ZM16.5982 18.0911L16.0605 17.5683L16.5982 18.0911ZM7.40177 18.0911L6.86399 18.6139L7.40177 18.0911ZM7.70285 18.3616L7.24034 18.9521L7.70285 18.3616ZM5.25427 11.0799L5.56353 13.9663L7.05499 13.8065L6.74573 10.9201L5.25427 11.0799ZM18.4365 13.9663L18.7457 11.0799L17.2543 10.9201L16.945 13.8065L18.4365 13.9663ZM12 19.75C13.1428 19.75 14.0648 19.7512 14.8007 19.6651C15.5543 19.577 16.2014 19.3894 16.7597 18.9521L15.8346 17.7712C15.578 17.9723 15.2373 18.1038 14.6264 18.1753C13.9978 18.2488 13.1788 18.25 12 18.25V19.75ZM16.945 13.8065C16.8194 14.9786 16.731 15.7929 16.5909 16.41C16.4548 17.0098 16.2877 17.3346 16.0605 17.5683L17.136 18.6139C17.6303 18.1054 17.8858 17.482 18.0537 16.742C18.2177 16.0195 18.3147 15.1026 18.4365 13.9663L16.945 13.8065ZM16.7597 18.9521C16.8926 18.8479 17.0183 18.7349 17.136 18.6139L16.0605 17.5683C15.9898 17.641 15.9144 17.7088 15.8346 17.7712L16.7597 18.9521ZM5.56353 13.9663C5.68527 15.1026 5.78231 16.0195 5.94628 16.742C6.11421 17.482 6.36967 18.1054 6.86399 18.6139L7.93955 17.5683C7.71233 17.3346 7.54519 17.0098 7.40908 16.41C7.26902 15.7929 7.18057 14.9786 7.05499 13.8065L5.56353 13.9663ZM12 18.25C10.8212 18.25 10.0022 18.2488 9.37357 18.1753C8.76273 18.1038 8.42197 17.9723 8.16536 17.7712L7.24034 18.9521C7.79862 19.3894 8.44567 19.577 9.19932 19.6651C9.9352 19.7512 10.8572 19.75 12 19.75V18.25ZM6.86399 18.6139C6.98168 18.7349 7.10742 18.8479 7.24034 18.9521L8.16536 17.7712C8.08561 17.7088 8.01016 17.641 7.93955 17.5683L6.86399 18.6139Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shocket-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["power","socket","outlet","charge","electricity","plug","adapter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C8.134 4 5 7.13416 5 11.0002C5 14.8661 8.13401 18 12 18C15.866 18 19 14.8661 19 11.0002C19 7.13416 15.866 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14V12M15 14V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    shocket: {
        defaultColors: ["#3D4C66"],
        keywords: ["power","socket","outlet","charge","electricity","plug","adapter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 7C9.23857 7 7 9.23869 7 12.0001C7 14.7615 9.23858 17 12 17C14.7614 17 17 14.7615 17 12.0001C17 9.23869 14.7614 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 13V11M14 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shop","store","marketplace","online-store","shopping","retail","shop-front","business","purchase","sales","checkout","inventory","products","services"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.35704 13.9621L6 10.6415C5.39551 10.2801 5 9.67964 5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9C19 9.67964 18.6045 10.2801 18 10.6415L17.7364 13.8114C17.5171 16.1508 17.4075 17.3205 16.6846 18.0752C16.5901 18.1738 16.489 18.2659 16.382 18.3507C15.5631 19 14.3883 19 12.0387 19C9.74591 19 8.59953 19 7.78889 18.373C7.68279 18.2909 7.58232 18.2018 7.48814 18.1063C6.7686 17.3765 6.63141 16.2384 6.35704 13.9621Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6.35704 13.9621L5.61127 14.0423L5.61243 14.0518L6.35704 13.9621ZM17.7364 13.8114L18.4832 13.8814L18.4839 13.8736L17.7364 13.8114ZM18 10.6415L17.6151 9.9978L17.6151 9.9978L18 10.6415ZM16.382 18.3507L15.916 17.763L15.916 17.763L16.382 18.3507ZM16.6846 18.0752L16.143 17.5564L16.143 17.5564L16.6846 18.0752ZM7.48814 18.1063L6.95408 18.6329L6.95408 18.6329L7.48814 18.1063ZM7.78889 18.373L8.24776 17.7797H8.24776L7.78889 18.373ZM19 9H19.75V8.90767L19.7276 8.8181L19 9ZM15.0833 9C15.0833 8.58579 14.7475 8.25 14.3333 8.25C13.9191 8.25 13.5833 8.58579 13.5833 9H15.0833ZM10.4167 9C10.4167 8.58579 10.0809 8.25 9.66667 8.25C9.25245 8.25 8.91667 8.58579 8.91667 9H10.4167ZM5 9L4.27239 8.8181L4.25 8.90767V9H5ZM18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM5.2543 10.7217L5.61134 14.0423L7.10274 13.8819L6.7457 10.5613L5.2543 10.7217ZM18.4839 13.8736L18.7474 10.7037L17.2526 10.5794L16.989 13.7493L18.4839 13.8736ZM12.0387 19.75C13.1953 19.75 14.1283 19.7512 14.872 19.6637C15.6335 19.5741 16.2868 19.3834 16.848 18.9384L15.916 17.763C15.6583 17.9674 15.3147 18.1013 14.6967 18.174C14.0609 18.2488 13.2316 18.25 12.0387 18.25V19.75ZM16.9897 13.7414C16.8784 14.9292 16.7997 15.7547 16.6659 16.3808C16.5358 16.9893 16.3704 17.3189 16.143 17.5564L17.2262 18.594C17.7216 18.0768 17.9725 17.4442 18.1328 16.6943C18.2893 15.962 18.3752 15.0331 18.4832 13.8814L16.9897 13.7414ZM16.848 18.9384C16.9817 18.8323 17.1081 18.7173 17.2262 18.594L16.143 17.5564C16.0721 17.6304 15.9963 17.6994 15.916 17.763L16.848 18.9384ZM5.61243 14.0518C5.74748 15.1723 5.85531 16.0768 6.02638 16.7892C6.2016 17.519 6.46128 18.133 6.95408 18.6329L8.02221 17.5797C7.79546 17.3497 7.62677 17.0298 7.48492 16.439C7.33892 15.8309 7.24097 15.0282 7.10165 13.8723L5.61243 14.0518ZM12.0387 18.25C10.8744 18.25 10.0658 18.2488 9.44455 18.1766C8.84105 18.1065 8.50322 17.9773 8.24776 17.7797L7.33001 18.9662C7.8852 19.3956 8.52588 19.58 9.27142 19.6666C9.99924 19.7512 10.9101 19.75 12.0387 19.75V18.25ZM6.95408 18.6329C7.0718 18.7522 7.19739 18.8636 7.33001 18.9662L8.24776 17.7797C8.16819 17.7182 8.09284 17.6513 8.02221 17.5797L6.95408 18.6329ZM18.25 9C18.25 9.37058 18.0348 9.74686 17.6151 9.9978L18.3849 11.2852C19.1742 10.8133 19.75 9.9887 19.75 9H18.25ZM17.6151 9.9978C17.3554 10.1531 17.0291 10.25 16.6667 10.25V11.75C17.2957 11.75 17.8887 11.5819 18.3849 11.2852L17.6151 9.9978ZM16.6667 10.25C15.6796 10.25 15.0833 9.58606 15.0833 9H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9C13.5833 9.58606 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58606 10.4167 9H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9C8.91667 9.58606 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9H8.91667ZM7.33333 10.25C6.9709 10.25 6.64459 10.1531 6.38487 9.9978L5.61513 11.2852C6.1113 11.5819 6.70427 11.75 7.33333 11.75V10.25ZM6.38487 9.9978C5.96516 9.74686 5.75 9.37058 5.75 9H4.25C4.25 9.9887 4.82585 10.8133 5.61513 11.2852L6.38487 9.9978ZM9.12311 5.75H14.8769V4.25H9.12311V5.75ZM18.0299 8.21176L18.2724 9.1819L19.7276 8.8181L19.4851 7.84796L18.0299 8.21176ZM5.72761 9.1819L5.97014 8.21176L4.51493 7.84795L4.27239 8.8181L5.72761 9.1819ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5.05972 8.76114C5.02005 8.91978 4.99429 9.08363 5.0174 9.24551C5.1586 10.2343 6.14164 11 7.33333 11C8.622 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 10.7113 11 12 11C13.2887 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 15.378 11 16.6667 11C17.8584 11 18.8414 10.2343 18.9826 9.24551C19.0057 9.08363 18.9799 8.91978 18.9403 8.76114L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM18.9403 8.76114L18.2127 8.94304V8.94304L18.9403 8.76114ZM5.05972 8.76114L4.33211 8.57924L4.33211 8.57924L5.05972 8.76114ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM18.9826 9.24551L19.7251 9.35153L18.9826 9.24551ZM15.0833 9C15.0833 8.58579 14.7475 8.25 14.3333 8.25C13.9191 8.25 13.5833 8.58579 13.5833 9H15.0833ZM10.4167 9C10.4167 8.58579 10.0809 8.25 9.66667 8.25C9.25245 8.25 8.91667 8.58579 8.91667 9H10.4167ZM5.0174 9.24551L5.75987 9.13948L5.0174 9.24551ZM9.12311 5.75H14.8769V4.25H9.12311V5.75ZM18.0299 8.21176L18.2127 8.94304L19.6679 8.57924L19.4851 7.84796L18.0299 8.21176ZM5.78732 8.94304L5.97014 8.21176L4.51493 7.84795L4.33211 8.57924L5.78732 8.94304ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176ZM18.2401 9.13948C18.1629 9.6803 17.5702 10.25 16.6667 10.25V11.75C18.1465 11.75 19.5199 10.7882 19.7251 9.35153L18.2401 9.13948ZM16.6667 10.25C15.6796 10.25 15.0833 9.58606 15.0833 9H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9C13.5833 9.58606 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58606 10.4167 9H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9C8.91667 9.58606 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9H8.91667ZM7.33333 10.25C6.42979 10.25 5.8371 9.6803 5.75987 9.13948L4.27494 9.35153C4.4801 10.7882 5.85349 11.75 7.33333 11.75V10.25ZM4.33211 8.57924C4.28381 8.77244 4.2315 9.04736 4.27494 9.35153L5.75987 9.13948C5.75708 9.11989 5.7563 9.06712 5.78732 8.94304L4.33211 8.57924ZM18.2127 8.94304C18.2437 9.06712 18.2429 9.11989 18.2401 9.13948L19.7251 9.35153C19.7685 9.04736 19.7162 8.77244 19.6679 8.57924L18.2127 8.94304Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M17 15L7 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cupcake","dessert","food","treat","bakery","item","pastry","menu-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.0675 4C9.08599 4 9.10455 4 9.12316 4L14.9326 4C15.6349 3.99996 16.2483 3.99992 16.7509 4.06003C17.2934 4.12491 17.8165 4.2698 18.2847 4.63539C18.753 5.00097 19.0204 5.47327 19.2149 5.9839C19.3951 6.45693 19.5439 7.05198 19.7142 7.73335L19.9105 8.51861C19.9617 8.72333 20.0228 9.03527 19.9726 9.38688C19.7461 10.9729 18.2426 12 16.6667 12C15.8065 12 14.9587 11.6883 14.3334 11.1455C13.7081 11.6883 12.8603 12 12.0001 12C11.1398 12 10.292 11.6883 9.66672 11.1455C9.04142 11.6883 8.19365 12 7.33339 12C5.7575 12 4.25399 10.9729 4.0275 9.38688C3.97729 9.03527 4.03845 8.72333 4.08963 8.51861L4.27245 7.78733C4.27696 7.76927 4.28146 7.75126 4.28595 7.73332C4.45624 7.05197 4.60497 6.45693 4.78518 5.9839C4.97971 5.47327 5.24714 5.00097 5.71537 4.63539C6.18361 4.2698 6.70667 4.12491 7.24922 4.06003C7.75184 3.99992 8.36518 3.99996 9.0675 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.31068 12.5393L5.47603 14.0774L5.48463 14.1488C5.61578 15.237 5.72447 16.139 5.89663 16.856C6.07742 17.609 6.35226 18.272 6.8894 18.8168C7.01497 18.9441 7.14893 19.0629 7.29039 19.1723C7.89555 19.6404 8.5867 19.8339 9.3559 19.9233C10.0884 20.0084 10.9968 20.0084 12.0929 20.0084H12.2121C13.3358 20.0084 14.2661 20.0084 15.0146 19.9204C15.8 19.828 16.5049 19.6278 17.1166 19.1427C17.2593 19.0296 17.3941 18.9068 17.5201 18.7753C18.0601 18.2115 18.3253 17.5284 18.4906 16.755C18.6481 16.018 18.7349 15.0917 18.8398 13.973L18.8455 13.9132L18.9729 12.3807C18.2715 12.7846 17.4594 13 16.6579 13C15.8572 13 15.0348 12.7786 14.3246 12.3658C13.6144 12.7786 12.792 13 11.9913 13C11.1905 13 10.3681 12.7786 9.65793 12.3658C8.94772 12.7786 8.12536 13 7.3246 13C6.63546 13 5.93842 12.8408 5.31068 12.5393Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shop v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["jar","honey","food","product","inventory","item","stock","preserve","canning","container"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7457 11.0799C18.7899 10.668 18.4918 10.2984 18.0799 10.2543C17.668 10.2101 17.2984 10.5082 17.2543 10.9201L18.7457 11.0799ZM16.2971 18.3616L15.8346 17.7712L16.2971 18.3616ZM16.5982 18.0911L16.0605 17.5683L16.5982 18.0911ZM7.40177 18.0911L6.86399 18.6139L7.40177 18.0911ZM7.70285 18.3616L7.24034 18.9521L7.70285 18.3616ZM5.25427 11.0799L5.56353 13.9663L7.05499 13.8065L6.74573 10.9201L5.25427 11.0799ZM18.4365 13.9663L18.7457 11.0799L17.2543 10.9201L16.945 13.8065L18.4365 13.9663ZM12 19.75C13.1428 19.75 14.0648 19.7512 14.8007 19.6651C15.5543 19.577 16.2014 19.3894 16.7597 18.9521L15.8346 17.7712C15.578 17.9723 15.2373 18.1038 14.6264 18.1753C13.9978 18.2488 13.1788 18.25 12 18.25V19.75ZM16.945 13.8065C16.8194 14.9786 16.731 15.7929 16.5909 16.41C16.4548 17.0098 16.2877 17.3346 16.0605 17.5683L17.136 18.6139C17.6303 18.1054 17.8858 17.482 18.0537 16.742C18.2177 16.0195 18.3147 15.1026 18.4365 13.9663L16.945 13.8065ZM16.7597 18.9521C16.8926 18.8479 17.0183 18.7349 17.136 18.6139L16.0605 17.5683C15.9898 17.641 15.9144 17.7088 15.8346 17.7712L16.7597 18.9521ZM5.56353 13.9663C5.68527 15.1026 5.78231 16.0195 5.94628 16.742C6.11421 17.482 6.36967 18.1054 6.86399 18.6139L7.93955 17.5683C7.71233 17.3346 7.54519 17.0098 7.40908 16.41C7.26902 15.7929 7.18057 14.9786 7.05499 13.8065L5.56353 13.9663ZM12 18.25C10.8212 18.25 10.0022 18.2488 9.37357 18.1753C8.76273 18.1038 8.42197 17.9723 8.16536 17.7712L7.24034 18.9521C7.79862 19.3894 8.44567 19.577 9.19932 19.6651C9.9352 19.7512 10.8572 19.75 12 19.75V18.25ZM6.86399 18.6139C6.98168 18.7349 7.10742 18.8479 7.24034 18.9521L8.16536 17.7712C8.08561 17.7088 8.01016 17.641 7.93955 17.5683L6.86399 18.6139Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 15L7 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop v3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shop","store","building","marketplace","business","commerce","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0008 4H8.47214C7.26932 4 6.66791 4 6.18461 4.2987C5.7013 4.5974 5.43234 5.13531 4.89443 6.21115L4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10H17.7639C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557L19.1056 6.21115C18.5677 5.13531 18.2987 4.5974 17.8154 4.2987C17.3321 4 16.7307 4 15.5279 4H11.9992"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.25 20C13.25 20.4142 13.5858 20.75 14 20.75C14.4142 20.75 14.75 20.4142 14.75 20H13.25ZM10.75 20V18H9.25V20H10.75ZM13.25 18V20H14.75V18H13.25ZM10.75 18C10.75 17.3096 11.3096 16.75 12 16.75V15.25C10.4812 15.25 9.25 16.4812 9.25 18H10.75ZM12 16.75C12.6904 16.75 13.25 17.3096 13.25 18H14.75C14.75 16.4812 13.5188 15.25 12 15.25V16.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M19.7463 10.0746C19.7875 9.66247 19.4868 9.29494 19.0746 9.25372C18.6625 9.21251 18.2949 9.51321 18.2537 9.92537L19.7463 10.0746ZM17.2981 19.2244L16.7948 18.6683L17.2981 19.2244ZM6.70195 19.2244L7.2052 18.6683L6.70195 19.2244ZM4.25372 10.0746L4.71342 14.6716L6.20598 14.5224L5.74628 9.92537L4.25372 10.0746ZM11.4299 20.75H12.5701V19.25H11.4299V20.75ZM19.2866 14.6717L19.7463 10.0746L18.2537 9.92537L17.794 14.5224L19.2866 14.6717ZM12.5701 20.75C13.8403 20.75 14.8649 20.7515 15.6763 20.6469C16.5088 20.5396 17.2156 20.3105 17.8013 19.7804L16.7948 18.6683C16.5235 18.9138 16.1565 19.0726 15.4845 19.1592C14.7913 19.2485 13.8804 19.25 12.5701 19.25V20.75ZM17.794 14.5224C17.6636 15.8262 17.5716 16.7324 17.4137 17.4133C17.2606 18.0734 17.0661 18.4227 16.7948 18.6683L17.8013 19.7804C18.387 19.2504 18.6853 18.5699 18.8749 17.7522C19.0597 16.9553 19.1602 15.9356 19.2866 14.6717L17.794 14.5224ZM4.71342 14.6716C4.83982 15.9356 4.94032 16.9553 5.1251 17.7522C5.31471 18.5699 5.61295 19.2504 6.19869 19.7804L7.2052 18.6683C6.93386 18.4227 6.73938 18.0734 6.58633 17.4133C6.42845 16.7324 6.33637 15.8262 6.20598 14.5224L4.71342 14.6716ZM11.4299 19.25C10.1196 19.25 9.20872 19.2485 8.51548 19.1592C7.84347 19.0726 7.47654 18.9138 7.2052 18.6683L6.19869 19.7804C6.78443 20.3105 7.49118 20.5396 8.32375 20.6469C9.13507 20.7515 10.1597 20.75 11.4299 20.75V19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shop v3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shop","store","building","location","marketplace","home","my-store"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.4597 14.597L5.12121 11.2121C5.09919 10.9919 5.08818 10.8818 5.08519 10.7737C5.07143 10.2753 5.18207 9.78144 5.40712 9.3366C5.45594 9.24011 5.51287 9.14521 5.62675 8.95541C5.7839 8.69351 5.86247 8.56256 5.94953 8.44508C6.35251 7.90137 6.9275 7.50989 7.58107 7.33424C7.72228 7.29629 7.87292 7.27118 8.17419 7.22097L11.5516 6.65807C12.0248 6.5792 12.2614 6.53977 12.5002 6.53828C12.7391 6.53678 12.9762 6.57326 13.4503 6.6462L16.5291 7.11986C17.9506 7.33856 19 8.56172 19 10L18.5403 14.597C18.2835 17.1648 18.1551 18.4487 17.2981 19.2244C16.441 20 15.1507 20 12.5701 20H11.4299C8.84932 20 7.55902 20 6.70195 19.2244C5.84487 18.4487 5.71648 17.1648 5.4597 14.597Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.0008 4H8.47214C7.26932 4 6.66791 4 6.18461 4.2987C5.7013 4.5974 5.43234 5.13531 4.89443 6.21115L4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10H17.7639C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557L19.1056 6.21115C18.5677 5.13531 18.2987 4.5974 17.8154 4.2987C17.3321 4 16.7307 4 15.5279 4H11.9992"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4.44721 7.10557L4.89443 6.21115C5.43234 5.13531 5.7013 4.5974 6.18461 4.2987C6.66791 4 7.26932 4 8.47214 4H11.9992H12.0008H15.5279C16.7307 4 17.3321 4 17.8154 4.2987C18.2987 4.5974 18.5677 5.13531 19.1056 6.21115L19.5528 7.10557L19.5528 7.10559C20.2014 8.40284 20.5257 9.05146 20.2326 9.52573C19.9395 10 19.2143 10 17.7639 10H6.23607C4.78569 10 4.0605 10 3.76738 9.52573C3.47427 9.05146 3.79858 8.40283 4.44721 7.10557Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.0008 4H8.47214C7.26932 4 6.66791 4 6.18461 4.2987C5.7013 4.5974 5.43234 5.13531 4.89443 6.21115L4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10H17.7639C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557L19.1056 6.21115C18.5677 5.13531 18.2987 4.5974 17.8154 4.2987C17.3321 4 16.7307 4 15.5279 4H11.9992"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4.44721 7.10557L4.89443 6.21115C5.43234 5.13531 5.7013 4.5974 6.18461 4.2987C6.66791 4 7.26932 4 8.47214 4H11.9992H12.0008H15.5279C16.7307 4 17.3321 4 17.8154 4.2987C18.2987 4.5974 18.5677 5.13531 19.1056 6.21115L19.5528 7.10557L19.5528 7.10559C20.2014 8.40284 20.5257 9.05146 20.2326 9.52573C19.9395 10 19.2143 10 17.7639 10H6.23607C4.78569 10 4.0605 10 3.76738 9.52573C3.47427 9.05146 3.79858 8.40283 4.44721 7.10557Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.0008 4H8.47214C7.26932 4 6.66791 4 6.18461 4.2987C5.7013 4.5974 5.43234 5.13531 4.89443 6.21115L4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10H17.7639C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557L19.1056 6.21115C18.5677 5.13531 18.2987 4.5974 17.8154 4.2987C17.3321 4 16.7307 4 15.5279 4H11.9992"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 18V20L14 20V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shop","store","building","location","marketplace","business","commerce","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0008 4H8.47214C7.26932 4 6.66791 4 6.18461 4.2987C5.7013 4.5974 5.43234 5.13531 4.89443 6.21115L4.44721 7.10557C3.79858 8.40283 3.47427 9.05146 3.76738 9.52573C4.0605 10 4.78569 10 6.23607 10H17.7639C19.2143 10 19.9395 10 20.2326 9.52573C20.5257 9.05146 20.2014 8.40283 19.5528 7.10557L19.1056 6.21115C18.5677 5.13531 18.2987 4.5974 17.8154 4.2987C17.3321 4 16.7307 4 15.5279 4H11.9992"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19.7463 10.0746C19.7875 9.66247 19.4868 9.29494 19.0746 9.25372C18.6625 9.21251 18.2949 9.51321 18.2537 9.92537L19.7463 10.0746ZM17.2981 19.2244L16.7948 18.6683L17.2981 19.2244ZM6.70195 19.2244L7.2052 18.6683L6.70195 19.2244ZM4.25372 10.0746L4.71342 14.6716L6.20598 14.5224L5.74628 9.92537L4.25372 10.0746ZM11.4299 20.75H12.5701V19.25H11.4299V20.75ZM19.2866 14.6717L19.7463 10.0746L18.2537 9.92537L17.794 14.5224L19.2866 14.6717ZM12.5701 20.75C13.8403 20.75 14.8649 20.7515 15.6763 20.6469C16.5088 20.5396 17.2156 20.3105 17.8013 19.7804L16.7948 18.6683C16.5235 18.9138 16.1565 19.0726 15.4845 19.1592C14.7913 19.2485 13.8804 19.25 12.5701 19.25V20.75ZM17.794 14.5224C17.6636 15.8262 17.5716 16.7324 17.4137 17.4133C17.2606 18.0734 17.0661 18.4227 16.7948 18.6683L17.8013 19.7804C18.387 19.2504 18.6853 18.5699 18.8749 17.7522C19.0597 16.9553 19.1602 15.9356 19.2866 14.6717L17.794 14.5224ZM4.71342 14.6716C4.83982 15.9356 4.94032 16.9553 5.1251 17.7522C5.31471 18.5699 5.61295 19.2504 6.19869 19.7804L7.2052 18.6683C6.93386 18.4227 6.73938 18.0734 6.58633 17.4133C6.42845 16.7324 6.33637 15.8262 6.20598 14.5224L4.71342 14.6716ZM11.4299 19.25C10.1196 19.25 9.20872 19.2485 8.51548 19.1592C7.84347 19.0726 7.47654 18.9138 7.2052 18.6683L6.19869 19.7804C6.78443 20.3105 7.49118 20.5396 8.32375 20.6469C9.13507 20.7515 10.1597 20.75 11.4299 20.75V19.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.25 20C13.25 20.4142 13.5858 20.75 14 20.75C14.4142 20.75 14.75 20.4142 14.75 20H13.25ZM10.75 20V18H9.25V20H10.75ZM13.25 18V20H14.75V18H13.25ZM10.75 18C10.75 17.3096 11.3096 16.75 12 16.75V15.25C10.4812 15.25 9.25 16.4812 9.25 18H10.75ZM12 16.75C12.6904 16.75 13.25 17.3096 13.25 18H14.75C14.75 16.4812 13.5188 15.25 12 15.25V16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shop-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shop","store","marketplace","local-business","sales","purchase","retail","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.375 19C13.375 19.4142 13.7108 19.75 14.125 19.75C14.5392 19.75 14.875 19.4142 14.875 19H13.375ZM10.875 19V17H9.375V19H10.875ZM13.375 17V19H14.875V17H13.375ZM10.875 17C10.875 16.3096 11.4346 15.75 12.125 15.75V14.25C10.6062 14.25 9.375 15.4812 9.375 17H10.875ZM12.125 15.75C12.8154 15.75 13.375 16.3096 13.375 17H14.875C14.875 15.4812 13.6438 14.25 12.125 14.25V15.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M6 11L6.35704 13.9621C6.63141 16.2384 6.7686 17.3765 7.48814 18.1063C7.58232 18.2018 7.68279 18.2909 7.78889 18.373C8.59953 19 9.74591 19 12.0387 19V19C14.3883 19 15.5631 19 16.382 18.3507C16.489 18.2659 16.5901 18.1738 16.6846 18.0752C17.4075 17.3205 17.5171 16.1508 17.7364 13.8114L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "shop v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shop","store","building","purchase","sales","commerce","marketplace","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.42621 3H15.5747C16.1364 2.99997 16.6317 2.99994 17.0447 3.04264C17.4921 3.0889 17.9264 3.19148 18.3416 3.44805C18.7567 3.70463 19.0427 4.04721 19.2841 4.42667C19.507 4.77698 19.7285 5.22003 19.9797 5.72249L20.4477 6.65836C20.4625 6.68809 20.4814 6.71853 20.4933 6.74958L20.4477 6.65836C20.7448 7.25238 21.0479 7.85839 21.1967 8.3133C21.3554 8.79829 21.4623 9.43888 21.0837 10.0515C20.7051 10.6641 20.0843 10.8549 19.5796 10.9299C19.1061 11.0002 18.4992 11.0001 17.835 11C17.8115 11 17.788 11 17.7644 11H6.23651C6.21289 11 6.18935 11 6.16587 11C5.50171 11.0001 4.89475 11.0002 4.42131 10.9299C3.91655 10.8549 3.29577 10.6641 2.91717 10.0515C2.53857 9.43888 2.64547 8.79828 2.80417 8.31329C2.95302 7.85839 3.22453 7.31555 3.52163 6.72154C3.53213 6.70055 3.54266 6.67949 3.55323 6.65836L4.00044 5.76394C4.00738 5.75007 4.01429 5.73624 4.02118 5.72246C4.27237 5.22001 4.49385 4.77697 4.71675 4.42667C4.95819 4.04721 5.24417 3.70463 5.65931 3.44805C6.07446 3.19148 6.50877 3.0889 6.95615 3.04264C7.36915 2.99994 7.86446 2.99997 8.42621 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.1841 11.8865L4.47169 14.7624C4.59442 15.9901 4.69605 17.0066 4.88198 17.8085C5.07769 18.6525 5.39323 19.3882 6.03136 19.9657C6.6695 20.5432 7.43289 20.7839 8.29221 20.8947C8.5851 20.9324 8.9044 20.9566 9.25043 20.9722V19C9.25043 17.4812 10.4816 16.25 12.0004 16.25C13.5192 16.25 14.7504 17.4812 14.7504 19V20.9722C15.0965 20.9566 15.4157 20.9324 15.7086 20.8947C16.568 20.7839 17.3313 20.5432 17.9695 19.9657C18.6076 19.3882 18.9232 18.6525 19.1189 17.8085C19.3048 17.0066 19.4064 15.9901 19.5291 14.7625L19.8167 11.8865C19.7358 11.9044 19.6564 11.9185 19.5796 11.9299C19.1061 12.0002 18.4992 12.0001 17.835 12H6.16587C5.50171 12.0001 4.89475 12.0002 4.42131 11.9299C4.3445 11.9185 4.26501 11.9044 4.1841 11.8865Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.2504 19V20.9993C13.0523 20.9999 12.8479 20.9999 12.6375 20.9999H11.364C11.1535 20.9999 10.9486 20.9999 10.7504 20.9993V19C10.7504 18.3096 11.3101 17.75 12.0004 17.75C12.6908 17.75 13.2504 18.3096 13.2504 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shocket-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["socket","outlet","power","connection","electricity","plug","connect","hardware","device","electrical","electronic","adapter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 11.0002C4.25 6.71997 7.71977 3.25 12 3.25C16.2802 3.25 19.75 6.71997 19.75 11.0002C19.75 15.2804 16.2802 18.75 12 18.75C7.71982 18.75 4.25 15.2804 4.25 11.0002ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V10C11.25 10.4142 11.5858 10.75 12 10.75C12.4142 10.75 12.75 10.4142 12.75 10V8ZM9.75 12C9.75 11.5858 9.41421 11.25 9 11.25C8.58579 11.25 8.25 11.5858 8.25 12V14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14V12ZM15.75 12C15.75 11.5858 15.4142 11.25 15 11.25C14.5858 11.25 14.25 11.5858 14.25 12V14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "shop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","marketplace","location","retail","sales","shop-front","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.05871 4C8.35639 3.99996 7.74305 3.99992 7.24043 4.06003C6.69788 4.12491 6.17482 4.2698 5.70658 4.63539C5.23835 5.00097 4.97092 5.47327 4.77639 5.9839C4.59618 6.45693 4.44746 7.05197 4.27716 7.73332L4.08084 8.51861C4.02966 8.72333 3.9685 9.03527 4.01871 9.38688C4.2452 10.9729 5.74871 12 7.3246 12C8.18486 12 9.03263 11.6883 9.65793 11.1455C10.2832 11.6883 11.131 12 11.9913 12C12.8515 12 13.6993 11.6883 14.3246 11.1455C14.9499 11.6883 15.7977 12 16.6579 12C18.2338 12 19.7373 10.9729 19.9638 9.38688C20.014 9.03527 19.9529 8.72333 19.9017 8.51861L19.7054 7.73335C19.5351 7.05202 19.3863 6.45691 19.2061 5.9839C19.0116 5.47327 18.7442 5.00097 18.276 4.63539C17.8077 4.2698 17.2847 4.12491 16.7421 4.06003C16.2395 3.99992 15.6261 3.99996 14.9238 4H9.05871Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.46724 14.0774L5.30189 12.5393C5.92963 12.8408 6.62667 13 7.31581 13C8.11657 13 8.93893 12.7786 9.64914 12.3658C10.3593 12.7786 11.1817 13 11.9825 13C12.7832 13 13.6056 12.7786 14.3158 12.3658C15.026 12.7786 15.8484 13 16.6491 13C17.4506 13 18.2627 12.7846 18.9641 12.3807L18.8367 13.9132L18.831 13.973C18.7262 15.0917 18.6393 16.0181 18.4818 16.755C18.3165 17.5284 18.0514 18.2115 17.5113 18.7753C17.3853 18.9068 17.2505 19.0296 17.1078 19.1427C16.4961 19.6278 15.7912 19.828 15.0058 19.9204C14.701 19.9562 14.366 19.9775 14 19.9901V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18V19.9764C9.76857 19.9641 9.55102 19.947 9.34711 19.9233C8.57791 19.8339 7.88676 19.6404 7.28161 19.1723C7.14015 19.0629 7.00618 18.9441 6.88062 18.8168C6.34347 18.272 6.06863 17.609 5.88784 16.856C5.71568 16.139 5.60699 15.237 5.47584 14.1488L5.46724 14.0774Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    shop: {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","marketplace","location","retail","sales","shop-front","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11L6.35704 13.9621C6.63141 16.2384 6.7686 17.3765 7.48814 18.1063C7.58232 18.2018 7.68279 18.2909 7.78889 18.373C8.59953 19 9.74591 19 12.0387 19V19C14.3883 19 15.5631 19 16.382 18.3507C16.489 18.2659 16.5901 18.1738 16.6846 18.0752C17.4075 17.3205 17.5171 16.1508 17.7364 13.8114L18 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.375 19C13.375 19.4142 13.7108 19.75 14.125 19.75C14.5392 19.75 14.875 19.4142 14.875 19H13.375ZM10.875 19V17H9.375V19H10.875ZM13.375 17V19H14.875V17H13.375ZM10.875 17C10.875 16.3096 11.4346 15.75 12.125 15.75V14.25C10.6062 14.25 9.375 15.4812 9.375 17H10.875ZM12.125 15.75C12.8154 15.75 13.375 16.3096 13.375 17H14.875C14.875 15.4812 13.6438 14.25 12.125 14.25V15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Shuffle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["shuffle","randomize","interchange","reorder","queue","playlist","mix","exchange","swap","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H8.3698C9.25889 8 10.1171 8.32628 10.7816 8.91695V8.91695C11.5566 9.60585 12 10.5933 12 11.6302V12V12.3698C12 13.4067 11.5566 14.3942 10.7816 15.083V15.083C10.1171 15.6737 9.25889 16 8.3698 16H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 16L15.6302 16C14.7411 16 13.8829 15.6737 13.2184 15.083V15.083C12.4434 14.3942 12 13.4067 12 12.3698L12 12L12 11.6302C12 10.5933 12.4434 9.60585 13.2184 8.91695V8.91695C13.8829 8.32628 14.7411 8 15.6302 8L18 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L18 8L16 6"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18L18 16L16 14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "shop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["shop","store","marketplace","checkout","purchase","location","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.35704 13.9621L6 10.6415C5.39551 10.2801 5 9.67964 5 9L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L19 9C19 9.67964 18.6045 10.2801 18 10.6415L17.7364 13.8114C17.5171 16.1508 17.4075 17.3205 16.6846 18.0752C16.5901 18.1738 16.489 18.2659 16.382 18.3507C15.5631 19 14.3883 19 12.0387 19C9.74591 19 8.59953 19 7.78889 18.373C7.68279 18.2909 7.58232 18.2018 7.48814 18.1063C6.7686 17.3765 6.63141 16.2384 6.35704 13.9621Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6.35704 13.9621L5.61127 14.0423L5.61243 14.0518L6.35704 13.9621ZM17.7364 13.8114L18.4832 13.8814L18.4839 13.8736L17.7364 13.8114ZM18 10.6415L17.6151 9.9978L17.6151 9.9978L18 10.6415ZM16.382 18.3507L15.916 17.763L15.916 17.763L16.382 18.3507ZM16.6846 18.0752L16.143 17.5564L16.143 17.5564L16.6846 18.0752ZM7.48814 18.1063L6.95408 18.6329L6.95408 18.6329L7.48814 18.1063ZM7.78889 18.373L8.24776 17.7797H8.24776L7.78889 18.373ZM19 9H19.75V8.90767L19.7276 8.8181L19 9ZM15.0833 9C15.0833 8.58579 14.7475 8.25 14.3333 8.25C13.9191 8.25 13.5833 8.58579 13.5833 9H15.0833ZM10.4167 9C10.4167 8.58579 10.0809 8.25 9.66667 8.25C9.25245 8.25 8.91667 8.58579 8.91667 9H10.4167ZM5 9L4.27239 8.8181L4.25 8.90767V9H5ZM18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM5.2543 10.7217L5.61134 14.0423L7.10274 13.8819L6.7457 10.5613L5.2543 10.7217ZM18.4839 13.8736L18.7474 10.7037L17.2526 10.5794L16.989 13.7493L18.4839 13.8736ZM12.0387 19.75C13.1953 19.75 14.1283 19.7512 14.872 19.6637C15.6335 19.5741 16.2868 19.3834 16.848 18.9384L15.916 17.763C15.6583 17.9674 15.3147 18.1013 14.6967 18.174C14.0609 18.2488 13.2316 18.25 12.0387 18.25V19.75ZM16.9897 13.7414C16.8784 14.9292 16.7997 15.7547 16.6659 16.3808C16.5358 16.9893 16.3704 17.3189 16.143 17.5564L17.2262 18.594C17.7216 18.0768 17.9725 17.4442 18.1328 16.6943C18.2893 15.962 18.3752 15.0331 18.4832 13.8814L16.9897 13.7414ZM16.848 18.9384C16.9817 18.8323 17.1081 18.7173 17.2262 18.594L16.143 17.5564C16.0721 17.6304 15.9963 17.6994 15.916 17.763L16.848 18.9384ZM5.61243 14.0518C5.74748 15.1723 5.85531 16.0768 6.02638 16.7892C6.2016 17.519 6.46128 18.133 6.95408 18.6329L8.02221 17.5797C7.79546 17.3497 7.62677 17.0298 7.48492 16.439C7.33892 15.8309 7.24097 15.0282 7.10165 13.8723L5.61243 14.0518ZM12.0387 18.25C10.8744 18.25 10.0658 18.2488 9.44455 18.1766C8.84105 18.1065 8.50322 17.9773 8.24776 17.7797L7.33001 18.9662C7.8852 19.3956 8.52588 19.58 9.27142 19.6666C9.99924 19.7512 10.9101 19.75 12.0387 19.75V18.25ZM6.95408 18.6329C7.0718 18.7522 7.19739 18.8636 7.33001 18.9662L8.24776 17.7797C8.16819 17.7182 8.09284 17.6513 8.02221 17.5797L6.95408 18.6329ZM18.25 9C18.25 9.37058 18.0348 9.74686 17.6151 9.9978L18.3849 11.2852C19.1742 10.8133 19.75 9.9887 19.75 9H18.25ZM17.6151 9.9978C17.3554 10.1531 17.0291 10.25 16.6667 10.25V11.75C17.2957 11.75 17.8887 11.5819 18.3849 11.2852L17.6151 9.9978ZM16.6667 10.25C15.6796 10.25 15.0833 9.58606 15.0833 9H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9C13.5833 9.58606 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58606 10.4167 9H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9C8.91667 9.58606 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9H8.91667ZM7.33333 10.25C6.9709 10.25 6.64459 10.1531 6.38487 9.9978L5.61513 11.2852C6.1113 11.5819 6.70427 11.75 7.33333 11.75V10.25ZM6.38487 9.9978C5.96516 9.74686 5.75 9.37058 5.75 9H4.25C4.25 9.9887 4.82585 10.8133 5.61513 11.2852L6.38487 9.9978ZM9.12311 5.75H14.8769V4.25H9.12311V5.75ZM18.0299 8.21176L18.2724 9.1819L19.7276 8.8181L19.4851 7.84796L18.0299 8.21176ZM5.72761 9.1819L5.97014 8.21176L4.51493 7.84795L4.27239 8.8181L5.72761 9.1819ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5.05972 8.76114C5.02005 8.91978 4.99429 9.08363 5.0174 9.24551C5.1586 10.2343 6.14164 11 7.33333 11C8.622 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 10.7113 11 12 11C13.2887 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 15.378 11 16.6667 11C17.8584 11 18.8414 10.2343 18.9826 9.24551C19.0057 9.08363 18.9799 8.91978 18.9403 8.76114L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM18.9403 8.76114L18.2127 8.94304V8.94304L18.9403 8.76114ZM5.05972 8.76114L4.33211 8.57924L4.33211 8.57924L5.05972 8.76114ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM18.9826 9.24551L19.7251 9.35153L18.9826 9.24551ZM15.0833 9C15.0833 8.58579 14.7475 8.25 14.3333 8.25C13.9191 8.25 13.5833 8.58579 13.5833 9H15.0833ZM10.4167 9C10.4167 8.58579 10.0809 8.25 9.66667 8.25C9.25245 8.25 8.91667 8.58579 8.91667 9H10.4167ZM5.0174 9.24551L5.75987 9.13948L5.0174 9.24551ZM9.12311 5.75H14.8769V4.25H9.12311V5.75ZM18.0299 8.21176L18.2127 8.94304L19.6679 8.57924L19.4851 7.84796L18.0299 8.21176ZM5.78732 8.94304L5.97014 8.21176L4.51493 7.84795L4.33211 8.57924L5.78732 8.94304ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176ZM18.2401 9.13948C18.1629 9.6803 17.5702 10.25 16.6667 10.25V11.75C18.1465 11.75 19.5199 10.7882 19.7251 9.35153L18.2401 9.13948ZM16.6667 10.25C15.6796 10.25 15.0833 9.58606 15.0833 9H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9C13.5833 9.58606 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58606 10.4167 9H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9C8.91667 9.58606 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9H8.91667ZM7.33333 10.25C6.42979 10.25 5.8371 9.6803 5.75987 9.13948L4.27494 9.35153C4.4801 10.7882 5.85349 11.75 7.33333 11.75V10.25ZM4.33211 8.57924C4.28381 8.77244 4.2315 9.04736 4.27494 9.35153L5.75987 9.13948C5.75708 9.11989 5.7563 9.06712 5.78732 8.94304L4.33211 8.57924ZM18.2127 8.94304C18.2437 9.06712 18.2429 9.11989 18.2401 9.13948L19.7251 9.35153C19.7685 9.04736 19.7162 8.77244 19.6679 8.57924L18.2127 8.94304Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M10 17V19L14 19V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Shuffle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["shuffle","randomize","reorder","mix","playlist","queue","alternate","change","swap"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H8.3698C9.25889 8 10.1171 8.32628 10.7816 8.91695V8.91695C11.5566 9.60585 12 10.5933 12 11.6302V12V12.3698C12 13.4067 11.5566 14.3942 10.7816 15.083V15.083C10.1171 15.6737 9.25889 16 8.3698 16H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 16L15.6302 16C14.7411 16 13.8829 15.6737 13.2184 15.083V15.083C12.4434 14.3942 12 13.4067 12 12.3698L12 12L12 11.6302C12 10.5933 12.4434 9.60585 13.2184 8.91695V8.91695C13.8829 8.32628 14.7411 8 15.6302 8L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L18 8L16 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18L18 16L16 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Shuffle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["shuffle","randomize","mix","reorder","change","alternate","exchange","swap","permutation","arrow","arrows","playlist","recommendations","suggestions","variants"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.71 13.2901C16.32 12.9001 15.69 12.9001 15.3 13.2901C14.91 13.6801 14.91 14.3101 15.3 14.7001L15.59 15C14.96 14.99 14.36 14.7401 13.89 14.3301C13.33 13.8301 13.01 13.1201 13.01 12.3601V11.6201C13.01 10.8701 13.33 10.1501 13.89 9.65006C14.36 9.23006 14.96 9.01 15.59 9L15.3 9.28006C14.91 9.67006 14.91 10.3001 15.3 10.6901C15.69 11.0801 16.32 11.0801 16.71 10.6901L18.71 8.69006C19.1 8.30006 19.1 7.67006 18.71 7.28006L16.71 5.29006C16.32 4.90006 15.69 4.90006 15.3 5.29006C14.91 5.68006 14.91 6.31006 15.3 6.70006L15.59 7C14.47 7.01 13.39 7.42006 12.56 8.16006C12.35 8.34006 12.17 8.55006 12.01 8.77006C11.84 8.55006 11.66 8.35006 11.46 8.16006C10.61 7.41006 9.52 7 8.38 7H6C5.45 7 5 7.44006 5 7.99006C5 8.54006 5.45 9 6 9H8.37C9.01 9 9.64 9.23006 10.12 9.65006C10.68 10.1501 11 10.8601 11 11.6201V12.3601C11 13.1101 10.68 13.8301 10.12 14.3301C9.64 14.7601 9.02 15 8.37 15H6C5.45 15 5 15.4401 5 15.9901C5 16.5401 5.45 17 6 17H8.37C9.5 17 10.6 16.5701 11.45 15.8201C11.66 15.6401 11.84 15.4301 12 15.2101C12.17 15.4301 12.35 15.6301 12.55 15.8201C13.39 16.5601 14.46 16.9801 15.58 16.9901L15.29 17.2801C14.9 17.6701 14.9 18.3001 15.29 18.6901C15.7336 19.1336 16.31 19.0801 16.7 18.6901L18.7 16.6901C19.09 16.3001 19.09 15.6701 18.7 15.2801L16.7 13.2801L16.71 13.2901Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Shuffle: {
        defaultColors: ["#3D4C66"],
        keywords: ["shuffle","randomize","mix","reorder","change","alternate","exchange","swap","permutation","arrow","arrows","playlist","recommendations","suggestions","variants"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8H8.3698C9.25889 8 10.1171 8.32628 10.7816 8.91695V8.91695C11.5566 9.60585 12 10.5933 12 11.6302V12V12.3698C12 13.4067 11.5566 14.3942 10.7816 15.083V15.083C10.1171 15.6737 9.25889 16 8.3698 16H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 16L15.6302 16C14.7411 16 13.8829 15.6737 13.2184 15.083V15.083C12.4434 14.3942 12 13.4067 12 12.3698L12 12L12 11.6302C12 10.5933 12.4434 9.60585 13.2184 8.91695V8.91695C13.8829 8.32628 14.7411 8 15.6302 8L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 10L18 8L16 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 18L18 16L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sim-card-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sim-card","sim","card","settings","configuration","cellular","mobile","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 12V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 12V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 19V16.7C13 16.0453 13 15.718 12.8526 15.4775C12.7702 15.3429 12.6571 15.2298 12.5225 15.1474C12.282 15 11.9547 15 11.3 15H10.7C10.0453 15 9.71797 15 9.4775 15.1474C9.34295 15.2298 9.22982 15.3429 9.14736 15.4775C9 15.718 9 16.0453 9 16.7V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "sim-card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sim-card","connectivity","network","data","phone","mobile","connection","settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 12V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 12V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 12V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 16.7V19H13V16.7C13 16.0453 13 15.718 12.8526 15.4775C12.7702 15.3429 12.6571 15.2298 12.5225 15.1474C12.282 15 11.9547 15 11.3 15H10.7C10.0453 15 9.71797 15 9.4775 15.1474C9.34295 15.2298 9.22982 15.3429 9.14736 15.4775C9 15.718 9 16.0453 9 16.7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sim-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["sim","sim-card","card","mobile","network","connection","cellular","data","settings","configuration","device","payment","connectivity","identification","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.1 19H11.9C13.8641 19 14.8461 19 15.5675 18.5579C15.9712 18.3106 16.3106 17.9712 16.5579 17.5675C17 16.8461 17 15.8641 17 13.9V12V11.8866C17 11.1194 17 10.7358 16.9082 10.3733C16.856 10.167 16.7819 9.96691 16.6873 9.7763C16.5211 9.44132 16.2715 9.15007 15.7722 8.56758L13.8299 6.30158C13.6167 6.05286 13.5101 5.9285 13.3962 5.82068C12.9174 5.36777 12.3029 5.08511 11.6474 5.01637C11.4914 5 11.3276 5 11 5H10.1C8.13594 5 7.15391 5 6.4325 5.44208C6.02884 5.68945 5.68945 6.02884 5.44208 6.4325C5 7.15391 5 8.13594 5 10.1V13.9C5 15.8641 5 16.8461 5.44208 17.5675C5.68945 17.9712 6.02884 18.3106 6.4325 18.5579C7.15391 19 8.13594 19 10.1 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 12V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 12V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 12V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 19V16.7C13 16.0453 13 15.718 12.8526 15.4775C12.7702 15.3429 12.6571 15.2298 12.5225 15.1474C12.282 15 11.9547 15 11.3 15H10.7C10.0453 15 9.71797 15 9.4775 15.1474C9.34295 15.2298 9.22982 15.3429 9.14736 15.4775C9 15.718 9 16.0453 9 16.7V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "sim-card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sim","sim-card","chip","settings","configuration","device","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.7517 4.02183C12.5426 3.9999 12.3291 3.99995 12.0457 4.00001L11.0516 4.00001C10.1107 3.99999 9.33436 3.99998 8.70561 4.05976C8.05122 4.12198 7.45424 4.25594 6.91001 4.58945C6.37179 4.91927 5.91926 5.3718 5.58944 5.91002C5.25593 6.45425 5.12197 7.05123 5.05975 7.70562C4.99997 8.33436 4.99998 9.11073 5 10.0516V13.9484C4.99998 14.8893 4.99997 15.6657 5.05975 16.2944C5.12197 16.9488 5.25593 17.5458 5.58944 18.09C5.91926 18.6282 6.37179 19.0808 6.91001 19.4106C7.45424 19.7441 8.05122 19.878 8.70561 19.9403C9.33436 20 10.1107 20 11.0516 20H12.9484C13.8893 20 14.6656 20 15.2944 19.9403C15.9488 19.878 16.5458 19.7441 17.09 19.4106C17.6282 19.0808 18.0807 18.6282 18.4106 18.09C18.7441 17.5458 18.878 16.9488 18.9403 16.2944C19 15.6657 19 14.8893 19 13.9484L19 11.7805C19.0004 11.1162 19.0006 10.6136 18.8776 10.1278C18.808 9.85281 18.7092 9.58596 18.5831 9.33182C18.3604 8.88293 18.0331 8.50153 17.6005 7.99733L15.5595 5.61611C15.3751 5.40088 15.2362 5.23876 15.0834 5.09426C14.4451 4.49037 13.6256 4.11349 12.7517 4.02183ZM11.6626 14C11.3677 14 11.0806 13.9999 10.8388 14.0229C10.5718 14.0483 10.2588 14.1086 9.95501 14.2947C9.6859 14.4596 9.45964 14.6859 9.29473 14.955C9.10858 15.2588 9.0483 15.5718 9.02292 15.8388C8.99992 16.0806 8.99996 16.3677 9 16.6626L9.00001 18H15L15 16.6626C15.0001 16.3677 15.0001 16.0806 14.9771 15.8388C14.9517 15.5718 14.8914 15.2588 14.7053 14.955C14.5404 14.6859 14.3141 14.4596 14.045 14.2947C13.7412 14.1086 13.4282 14.0483 13.1612 14.0229C12.9194 13.9999 12.6323 14 12.3374 14H11.6626ZM10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10V12C8 12.5523 8.44772 13 9 13C9.55228 13 10 12.5523 10 12V10ZM12 9C12.5523 9 13 9.44772 13 10V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V10C11 9.44772 11.4477 9 12 9ZM16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "skype-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","communication","message","support","help","contact","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 12.632 18.9163 13.2444 18.7592 13.8267C19.5182 14.4688 20 15.4281 20 16.5C20 18.433 18.433 20 16.5 20C15.4281 20 14.4688 19.5182 13.8267 18.7592C13.2444 18.9163 12.632 19 12 19C8.13401 19 5 15.866 5 12C5 11.368 5.08375 10.7556 5.24075 10.1733C4.48185 9.53124 4 8.57189 4 7.5C4 5.567 5.567 4 7.5 4C8.57189 4 9.53124 4.48185 10.1733 5.24075C10.7556 5.08375 11.368 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9L11.75 9C10.7835 9 10 9.67157 10 10.5C10 11.3284 10.7835 12 11.75 12L12.25 12C13.2165 12 14 12.6716 14 13.5C14 14.3284 13.2165 15 12.25 15H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "skype-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","support","customer-service","online-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7.5C3 5.01472 5.01472 3 7.5 3C8.65027 3 9.70024 3.43243 10.4951 4.14152C10.9831 4.04855 11.4863 4 12 4C16.4183 4 20 7.58172 20 12C20 12.5137 19.9515 13.0169 19.8585 13.5049C20.5676 14.2998 21 15.3497 21 16.5C21 18.9853 18.9853 21 16.5 21C15.3497 21 14.2998 20.5676 13.5049 19.8585C13.0169 19.9515 12.5137 20 12 20C7.58172 20 4 16.4183 4 12C4 11.4863 4.04855 10.9831 4.14152 10.4951C3.43243 9.70024 3 8.65027 3 7.5ZM11.75 10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H11.75C10.3814 8 9 8.98022 9 10.5C9 12.0198 10.3814 13 11.75 13H12.25C12.5039 13 12.7082 13.0885 12.8366 13.1986C12.963 13.3069 13 13.4166 13 13.5C13 13.5834 12.963 13.6931 12.8366 13.8014C12.7082 13.9115 12.5039 14 12.25 14H10C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16H12.25C13.6186 16 15 15.0198 15 13.5C15 11.9802 13.6186 11 12.25 11H11.75C11.4961 11 11.2918 10.9115 11.1634 10.8014C11.037 10.6931 11 10.5834 11 10.5C11 10.4166 11.037 10.3069 11.1634 10.1986C11.2918 10.0885 11.4961 10 11.75 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    skype: {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","communication","support","customer-service","online-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 12.632 18.9163 13.2444 18.7592 13.8267C19.5182 14.4688 20 15.4281 20 16.5C20 18.433 18.433 20 16.5 20C15.4281 20 14.4688 19.5182 13.8267 18.7592C13.2444 18.9163 12.632 19 12 19C8.13401 19 5 15.866 5 12C5 11.368 5.08375 10.7556 5.24075 10.1733C4.48185 9.53124 4 8.57189 4 7.5C4 5.567 5.567 4 7.5 4C8.57189 4 9.53124 4.48185 10.1733 5.24075C10.7556 5.08375 11.368 5 12 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9L11.75 9C10.7835 9 10 9.67157 10 10.5C10 11.3284 10.7835 12 11.75 12L12.25 12C13.2165 12 14 12.6716 14 13.5C14 14.3284 13.2165 15 12.25 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "slider-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["slider","adjust","filter","settings","preferences","control","volume","brightness","quantity","range","price-range","discount-rate","customization","options","display-settings","preference","option","adjustment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="9" width="4" height="6" rx="1" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "slider-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["slider","filter","adjust","settings","options","configuration","preference","range","control","fine-tune","customize","adjust-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 8C12.8954 8 12 8.89543 12 10V14C12 15.1046 12.8954 16 14 16H16C17.1046 16 18 15.1046 18 14V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H18V10C18 8.89543 17.1046 8 16 8H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 12C3 11.4477 3.44772 11 4 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H4C3.44772 13 3 12.5523 3 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "slider-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["slider","settings","adjust","filter","options","preferences","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="9" width="4" height="6" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "slider-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["slider","adjustment","settings","options","filter","preferences","toggle","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="13"
                    y="9"
                    width="4"
                    height="6"
                    rx="1"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "slider-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["slider","adjust","settings","preferences","filter","range","controls","options","equalizer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="9" width="4" height="6" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "slider-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["slider","settings","configuration","adjust","preference","filter","toggle","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="13"
                    y="9"
                    width="4"
                    height="6"
                    rx="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "slider-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["slider","setting","adjust","preference","volume","configuration","filter","price-range","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8C14.3431 8 13 9.34315 13 11V13C13 14.6569 14.3431 16 16 16C17.6569 16 19 14.6569 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19C19 9.34315 17.6569 8 16 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 12C4 11.4477 4.44772 11 5 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    slider: {
        defaultColors: ["#3D4C66"],
        keywords: ["slider","setting","adjust","preference","volume","configuration","filter","price-range","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="13" y="9" width="4" height="6" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "sliders-simple-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sliders","settings","preferences","filter","adjust","options","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="14" y="7" width="4" height="4" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <rect x="6" y="13" width="4" height="4" rx="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "sliders-simple-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sliders","settings","filter","adjust","options","preferences","controls","customize","configuration","sort","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="14"
                    y="7"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="6"
                    y="13"
                    width="4"
                    height="4"
                    rx="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "sliders-simple": {
        defaultColors: ["#3D4C66"],
        keywords: ["sliders","settings","preferences","filter","adjust","options","configurations","sort","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 9L14 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="14" y="7" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="6" y="13" width="4" height="4" rx="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "sliders-simple-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sliders","settings","adjust","preferences","filter","sort","options","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L13.1707 10C13.5825 11.1652 14.6938 12 16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6C14.6938 6 13.5825 6.83481 13.1707 8L6 8C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.8293 16C10.4175 17.1652 9.30622 18 8 18C6.34315 18 5 16.6569 5 15C5 13.3431 6.34315 12 8 12C9.30622 12 10.4175 12.8348 10.8293 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H10.8293Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Smile-teeth-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["pig","animal","farm","menu-item","bacon","pork","food"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16V13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.5 13H10.5C9.67157 13 9 13.6716 9 14.5C9 15.3284 9.67157 16 10.5 16H13.5C14.3284 16 15 15.3284 15 14.5C15 13.6716 14.3284 13 13.5 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Smile-teeth-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["face","expression","unhappy","customer-feedback","customer-satisfaction","alert","warning","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 14.5C9.5 14.8803 9.78306 15.1945 10.15 15.2434V13.7566C9.78306 13.8055 9.5 14.1197 9.5 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 14.5C14.5 14.8803 14.2169 15.1945 13.85 15.2434V13.7566C14.2169 13.8055 14.5 14.1197 14.5 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M12.35 15.25H11.65V13.75H12.35V15.25Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V9ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9V10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10V9ZM10.25 12.25C9.00736 12.25 8 13.2574 8 14.5C8 15.7426 9.00736 16.75 10.25 16.75H13.75C14.9926 16.75 16 15.7426 16 14.5C16 13.2574 14.9926 12.25 13.75 12.25H10.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Smile-teeth-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["pig","animal","food","menu","farm","livestock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16V13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.5 13H10.5C9.67157 13 9 13.6716 9 14.5C9 15.3284 9.67157 16 10.5 16H13.5C14.3284 16 15 15.3284 15 14.5C15 13.6716 14.3284 13 13.5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Smile-teeth": {
        defaultColors: ["#3D4C66"],
        keywords: ["smile","happy","customer","loyalty","feedback","satisfied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 16V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 16V13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 10V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.5 13H10.5C9.67157 13 9 13.6716 9 14.5C9 15.3284 9.67157 16 10.5 16H13.5C14.3284 16 15 15.3284 15 14.5C15 13.6716 14.3284 13 13.5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "skype-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["communication","message","contact","support","chat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 12.632 18.9163 13.2444 18.7592 13.8267C19.5182 14.4688 20 15.4281 20 16.5C20 18.433 18.433 20 16.5 20C15.4281 20 14.4688 19.5182 13.8267 18.7592C13.2444 18.9163 12.632 19 12 19C8.13401 19 5 15.866 5 12C5 11.368 5.08375 10.7556 5.24075 10.1733C4.48185 9.53124 4 8.57189 4 7.5C4 5.567 5.567 4 7.5 4C8.57189 4 9.53124 4.48185 10.1733 5.24075C10.7556 5.08375 11.368 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 9L11.75 9C10.7835 9 10 9.67157 10 10.5C10 11.3284 10.7835 12 11.75 12L12.25 12C13.2165 12 14 12.6716 14 13.5C14 14.3284 13.2165 15 12.25 15H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "snooze-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["snooze","alarm","clock","delay","postpone","reminder","timer","pause","hold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8L7 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8L17 6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 11L14 11L10 15L14 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "snooze-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["snooze","alarm","sleep","delay","postpone","pause","reminder","time","schedule","clock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8L7 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8L17 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="13"
                    r="6"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 11L14 11L10 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "snooze-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alarm","snooze","time","delay","reminder","postpone","wait"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.29289 5.29289C6.68342 4.90237 7.31658 4.90237 7.70711 5.29289C8.09763 5.68342 8.09763 6.31658 7.70711 6.70711L5.70711 8.70711C5.31658 9.09763 4.68342 9.09763 4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289L6.29289 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711C19.3166 9.09763 18.6834 9.09763 18.2929 8.70711L16.2929 6.70711C15.9024 6.31658 15.9024 5.68342 16.2929 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6ZM9.00003 11C9.00003 10.4477 9.44774 10 10 10H14C14.4045 10 14.7691 10.2436 14.9239 10.6173C15.0787 10.991 14.9931 11.4211 14.7071 11.7071L12.4142 14H14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16H10C9.59557 16 9.23093 15.7564 9.07615 15.3827C8.92137 15.009 9.00692 14.5789 9.29292 14.2929L11.5858 12H10C9.44774 12 9.00003 11.5523 9.00003 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "snowflake-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["snowflake","seasonal","holiday","discount","promotion","winter","festive","sale","christmas","new-year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H18M15 12C15 11.1716 14.6642 10.4216 14.1213 9.87868M15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M12 15V18M12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M12 15C11.1716 15 10.4216 14.6642 9.87868 14.1213M9 12H6M9 12C9 12.8284 9.33579 13.5784 9.87868 14.1213M9 12C9 11.1716 9.33579 10.4216 9.87868 9.87868M12 9V6M12 9C12.8284 9 13.5784 9.33579 14.1213 9.87868M12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M12 6L14 4M12 6L10 4M6 12L4 10M6 12L4 14M18 12L20 14M18 12L20 10M8 8V5M8 8H5M8 8L9.87868 9.87868M16 8V5M16 8H19M16 8L14.1213 9.87868M12 18L10 20M12 18L14 20M16 16V19M16 16H19M16 16L14.1213 14.1213M8 16L8 18M8 16L6 16M8 16L9.87868 14.1213"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 4L12 6L10 4M4 10L6 12L4 14M20 14L18 12L20 10M8 5V8H5M16 5V8H19M10 20L12 18L14 20M16 19V16H19M8 18L8 16L6 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="bevel"
                />
            </svg>
        )
    },
    snooze: {
        defaultColors: ["#3D4C66"],
        keywords: ["snowflake","seasonal","holiday","discount","promotion","winter","festive","sale","christmas","new-year"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 6L5 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8L17 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 11L14 11L10 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "snowflake-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["snowflake","winter","seasonal","promotion","discount","cold","holiday","sale","frozen","ice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7071 3.29289C10.3166 2.90237 9.68342 2.90237 9.29289 3.29289C8.90237 3.68342 8.90237 4.31658 9.29289 4.70711L11 6.41421V8.12602C10.633 8.22048 10.2863 8.36573 9.96803 8.55382L9 7.58579V5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V7H5C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9H7.58579L8.55382 9.96803C8.36573 10.2863 8.22048 10.633 8.12602 11H6.41421L4.70711 9.29289C4.31658 8.90237 3.68342 8.90237 3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L4.58579 12L3.29289 13.2929C2.90237 13.6834 2.90237 14.3166 3.29289 14.7071C3.68342 15.0976 4.31658 15.0976 4.70711 14.7071L6.41421 13H8.12602C8.22048 13.367 8.36573 13.7137 8.55382 14.032L7.58579 15L6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17H7L7 18C7 18.5523 7.44772 19 8 19C8.55229 19 9 18.5523 9 18L9 16.4142L9.96803 15.4462C10.2863 15.6343 10.633 15.7795 11 15.874V17.5858L9.29289 19.2929C8.90237 19.6834 8.90237 20.3166 9.29289 20.7071C9.68342 21.0976 10.3166 21.0976 10.7071 20.7071L12 19.4142L13.2929 20.7071C13.6834 21.0976 14.3166 21.0976 14.7071 20.7071C15.0976 20.3166 15.0976 19.6834 14.7071 19.2929L13 17.5858V15.874C13.367 15.7795 13.7137 15.6343 14.032 15.4462L15 16.4142V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H16.4142L15.4462 14.032C15.6343 13.7137 15.7795 13.367 15.874 13H17.5858L19.2929 14.7071C19.6834 15.0976 20.3166 15.0976 20.7071 14.7071C21.0976 14.3166 21.0976 13.6834 20.7071 13.2929L19.4142 12L20.7071 10.7071C21.0976 10.3166 21.0976 9.68342 20.7071 9.29289C20.3166 8.90237 19.6834 8.90237 19.2929 9.29289L17.5858 11H15.874C15.7795 10.633 15.6343 10.2863 15.4462 9.96803L16.4142 9H19C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7H17V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V7.58579L14.032 8.55382C13.7137 8.36573 13.367 8.22048 13 8.12602V6.41421L14.7071 4.70711C15.0976 4.31658 15.0976 3.68342 14.7071 3.29289C14.3166 2.90237 13.6834 2.90237 13.2929 3.29289L12 4.58579L10.7071 3.29289ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "snowflake-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["snowflake","seasonal","winter","holiday","discount","promotion","special-offer","cold","weather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H18M15 12C15 11.1716 14.6642 10.4216 14.1213 9.87868M15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M12 15V18M12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M12 15C11.1716 15 10.4216 14.6642 9.87868 14.1213M9 12H6M9 12C9 12.8284 9.33579 13.5784 9.87868 14.1213M9 12C9 11.1716 9.33579 10.4216 9.87868 9.87868M12 9V6M12 9C12.8284 9 13.5784 9.33579 14.1213 9.87868M12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M12 6L14 4M12 6L10 4M6 12L4 10M6 12L4 14M18 12L20 14M18 12L20 10M8 8V5M8 8H5M8 8L9.87868 9.87868M16 8V5M16 8H19M16 8L14.1213 9.87868M12 18L10 20M12 18L14 20M16 16V19M16 16H19M16 16L14.1213 14.1213M8 16L8 18M8 16L6 16M8 16L9.87868 14.1213"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "snowflake-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["snowflake","winter","seasonal","holiday","promotion","discount","sale","christmas","new-year","cold","ice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9V6M12 9C12.8284 9 13.5784 9.33579 14.1213 9.87868M12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M12 6L14 4M12 6V4M12 6L10 4M15 12H18M15 12C15 11.1716 14.6642 10.4216 14.1213 9.87868M15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M18 12L20 14M18 12L20 10M18 12H20M16 8V5M16 8H19M16 8L14.1213 9.87868M16 8L18 6M12 15V18M12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M12 15C11.1716 15 10.4216 14.6642 9.87868 14.1213M12 18L14 20M12 18V20M12 18L10 20M16 16V19M16 16H19M16 16L14.1213 14.1213M16 16L18 18M9 12H6M9 12C9 11.1716 9.33579 10.4216 9.87868 9.87868M9 12C9 12.8284 9.33579 13.5784 9.87868 14.1213M6 12L4 14M6 12L4 10M6 12H4M8 8V5M8 8H5M8 8L9.87868 9.87868M8 8L6 6M8 16V19M8 16H5M8 16L9.87868 14.1213M8 16L6 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "snowflake-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["snowflake","cold","winter","seasonal","promotion","discount","holiday","freezer","frozen","ice"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9V4M15 12H20M18 6L14.1213 9.87868M12 15V20M18 18L14.1213 14.1213M9 12H4M9.87868 9.87868L6 6M6 18L9.87868 14.1213"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 4L12 6L10 4M20 14L18 12L20 10M16 5V8H19M14 20L12 18L10 20M16 19V16H19M4 14L6 12L4 10M8 5V8H5M8 19V16H5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="bevel"
                />
                <path
                    d="M9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "snowflake-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["snowflake","winter","seasonal","holiday","discount","promotion","sale","cold","christmas","new-year","special-offer","freeze"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7071 3.29289C10.3166 2.90237 9.68342 2.90237 9.29289 3.29289C8.90237 3.68342 8.90237 4.31658 9.29289 4.70711L11 6.41421V8.12602C10.633 8.22048 10.2863 8.36573 9.96803 8.55382L9 7.58579V5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V5.58579L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L5.58579 7H5C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9H7.58579L8.55382 9.96803C8.36573 10.2863 8.22048 10.633 8.12602 11H6.41421L4.70711 9.29289C4.31658 8.90237 3.68342 8.90237 3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L3.64909 11.0633C3.2699 11.2054 3 11.5712 3 12C3 12.4288 3.2699 12.7946 3.64909 12.9367L3.29289 13.2929C2.90237 13.6834 2.90237 14.3166 3.29289 14.7071C3.68342 15.0976 4.31658 15.0976 4.70711 14.7071L6.41421 13H8.12602C8.22048 13.367 8.36573 13.7137 8.55382 14.032L7.58579 15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H5.58579L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L7 18.4142V19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19V16.4142L9.96803 15.4462C10.2863 15.6343 10.633 15.7795 11 15.874V17.5858L9.29289 19.2929C8.90237 19.6834 8.90237 20.3166 9.29289 20.7071C9.68342 21.0976 10.3166 21.0976 10.7071 20.7071L11.0633 20.3509C11.2054 20.7301 11.5712 21 12 21C12.4288 21 12.7946 20.7301 12.9367 20.3509L13.2929 20.7071C13.6834 21.0976 14.3166 21.0976 14.7071 20.7071C15.0976 20.3166 15.0976 19.6834 14.7071 19.2929L13 17.5858V15.874C13.367 15.7795 13.7137 15.6343 14.032 15.4462L15 16.4142V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V18.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L18.4142 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H16.4142L15.4462 14.032C15.6343 13.7137 15.7795 13.367 15.874 13H17.5858L19.2929 14.7071C19.6834 15.0976 20.3166 15.0976 20.7071 14.7071C21.0976 14.3166 21.0976 13.6834 20.7071 13.2929L20.3509 12.9367C20.7301 12.7946 21 12.4288 21 12C21 11.5712 20.7301 11.2054 20.3509 11.0633L20.7071 10.7071C21.0976 10.3166 21.0976 9.68342 20.7071 9.29289C20.3166 8.90237 19.6834 8.90237 19.2929 9.29289L17.5858 11H15.874C15.7795 10.633 15.6343 10.2863 15.4462 9.96803L16.4142 9H19C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7H18.4142L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L17 5.58579V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V7.58579L14.032 8.55382C13.7137 8.36573 13.367 8.22048 13 8.12602V6.41421L14.7071 4.70711C15.0976 4.31658 15.0976 3.68342 14.7071 3.29289C14.3166 2.90237 13.6834 2.90237 13.2929 3.29289L12.9367 3.64909C12.7946 3.2699 12.4288 3 12 3C11.5712 3 11.2054 3.2699 11.0633 3.64909L10.7071 3.29289ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    snowflake: {
        defaultColors: ["#3D4C66"],
        keywords: ["snowflake","winter","seasonal","holiday","discount","promotion","sale","cold","christmas","new-year","special-offer","freeze"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 12H18M15 12C15 11.1716 14.6642 10.4216 14.1213 9.87868M15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M12 15V18M12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M12 15C11.1716 15 10.4216 14.6642 9.87868 14.1213M9 12H6M9 12C9 12.8284 9.33579 13.5784 9.87868 14.1213M9 12C9 11.1716 9.33579 10.4216 9.87868 9.87868M12 9V6M12 9C12.8284 9 13.5784 9.33579 14.1213 9.87868M12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M12 6L14 4M12 6L10 4M6 12L4 10M6 12L4 14M18 12L20 14M18 12L20 10M8 8V5M8 8H5M8 8L9.87868 9.87868M16 8V5M16 8H19M16 8L14.1213 9.87868M12 18L10 20M12 18L14 20M16 16V19M16 16H19M16 16L14.1213 14.1213M8 16L8 18M8 16L6 16M8 16L9.87868 14.1213"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "snowflake-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["snowflake","winter","seasonal","holiday","promotion","discount","deals","special-offer","christmas"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9V6M12 9C12.8284 9 13.5784 9.33579 14.1213 9.87868M12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M12 6L14 4M12 6V4M12 6L10 4M15 12H18M15 12C15 11.1716 14.6642 10.4216 14.1213 9.87868M15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M18 12L20 14M18 12L20 10M18 12H20M16 8V5M16 8H19M16 8L14.1213 9.87868M16 8L18 6M12 15V18M12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M12 15C11.1716 15 10.4216 14.6642 9.87868 14.1213M12 18L14 20M12 18V20M12 18L10 20M16 16V19M16 16H19M16 16L14.1213 14.1213M16 16L18 18M9 12H6M9 12C9 11.1716 9.33579 10.4216 9.87868 9.87868M9 12C9 12.8284 9.33579 13.5784 9.87868 14.1213M6 12L4 14M6 12L4 10M6 12H4M8 8V5M8 8H5M8 8L9.87868 9.87868M8 8L6 6M8 16V19M8 16H5M8 16L9.87868 14.1213M8 16L6 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "sofa-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["furniture","sofa","chair","seating","item","product","inventory","couch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V14H17V9C17 7.11438 17 6.17157 16.4142 5.58579C15.8284 5 14.8856 5 13 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14V11.5C7 10.6716 6.32843 10 5.5 10C4.67157 10 4 10.6716 4 11.5V17.1579C4 17.623 4.37702 18 4.84211 18H19.1579C19.623 18 20 17.623 20 17.1579V11.5C20 10.6716 19.3284 10 18.5 10C17.6716 10 17 10.6716 17 11.5V14H7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18H17V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sofa-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["furniture","sofa","chair","seating","lounge","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9342 4C10.0477 3.99995 9.28387 3.99991 8.67221 4.08215C8.0167 4.17028 7.38835 4.36902 6.87868 4.87868C6.36902 5.38835 6.17028 6.0167 6.08215 6.67221C6.02917 7.06627 6.01034 7.52349 6.00366 8.03597C7.69802 8.28016 9 9.73803 9 11.5V12H15V11.5C15 9.73803 16.302 8.28015 17.9964 8.03597C17.9897 7.52349 17.9708 7.06627 17.9179 6.67221C17.8297 6.0167 17.631 5.38835 17.1213 4.87868C16.6117 4.36902 15.9833 4.17028 15.3278 4.08215C14.7161 3.99991 13.9523 3.99995 13.0658 4H10.9342Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 11.5C3 10.1193 4.11929 9 5.5 9C6.88071 9 8 10.1193 8 11.5V13H16V11.5C16 10.1193 17.1193 9 18.5 9C19.8807 9 21 10.1193 21 11.5V17.1579C21 18.1753 20.1753 19 19.1579 19H18V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V19H8V20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20V19H4.84211C3.82474 19 3 18.1753 3 17.1579V11.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    sofa: {
        defaultColors: ["#3D4C66"],
        keywords: ["furniture","sofa","chair","seating","lounge","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12V9C17 7.11438 17 6.17157 16.4142 5.58579C15.8284 5 14.8856 5 13 5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 14L17 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 14V11.5C7 10.6716 6.32843 10 5.5 10V10C4.67157 10 4 10.6716 4 11.5V17.1579C4 17.623 4.37702 18 4.84211 18H19.1579C19.623 18 20 17.623 20 17.1579V11.5C20 10.6716 19.3284 10 18.5 10V10C17.6716 10 17 10.6716 17 11.5V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18H17V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sofa-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["furniture","sofa","couch","seat","armchair","item","product","category","living-room","interior","merchandise"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 12V9C17 7.11438 17 6.17157 16.4142 5.58579C15.8284 5 14.8856 5 13 5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M7 14L17 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 14V11.5C7 10.6716 6.32843 10 5.5 10V10C4.67157 10 4 10.6716 4 11.5V17.1579C4 17.623 4.37702 18 4.84211 18H19.1579C19.623 18 20 17.623 20 17.1579V11.5C20 10.6716 19.3284 10 18.5 10V10C17.6716 10 17 10.6716 17 11.5V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 20V18H17V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sort-by-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["settings","adjust","filter","sliders","options","preferences","sort","sort-by","arrange","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L20 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L11 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 17C17 18.6569 15.6569 20 14 20C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14C15.6569 14 17 15.3431 17 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["filters","sort","settings","adjust","controls","filter-options","sort-by"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8L6.12602 8C6.57006 9.72523 8.13616 11 10 11C11.8638 11 13.4299 9.72523 13.874 8L20 8C20.5523 8 21 7.55228 21 7C21 6.44771 20.5523 6 20 6L13.874 6C13.4299 4.27477 11.8638 3 10 3C8.13616 3 6.57006 4.27477 6.12602 6L4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 18C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H17.874C17.4299 14.2748 15.8638 13 14 13C12.1362 13 10.5701 14.2748 10.126 16L4 16C3.44771 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18L10.126 18C10.5701 19.7252 12.1362 21 14 21C15.8638 21 17.4299 19.7252 17.874 18H20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","adjust","settings","options","controls","arrange","prioritize","sort-by"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6C12 7.10457 11.1046 8 10 8C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 6L5 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 10.8954 16 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 12L19 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 18C8 16.8954 8.89543 16 10 16C11.1046 16 12 16.8954 12 18C12 19.1046 11.1046 20 10 20C8.89543 20 8 19.1046 8 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 18L5 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","preferences","options","configuration","equalizer","sliders","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 19L18 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 5L6 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 8L4 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 8L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","adjust","settings","options","equalizer","levels","arrange","order","rank","sort-by"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 19L18 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 5L6 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 8L4 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16H10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 8L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","options","controls","equalizer","customize","arrange","order","rank","prioritize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 19C5 19.5523 5.44772 20 6 20C6.55228 20 7 19.5523 7 19L7 9H8C8.55228 9 9 8.55229 9 8C9 7.44772 8.55228 7 8 7H7L7 5C7 4.44771 6.55228 4 6 4C5.44771 4 5 4.44771 5 5L5 7H4C3.44772 7 3 7.44772 3 8C3 8.55229 3.44772 9 4 9H5L5 19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19 5C19 4.44772 18.5523 4 18 4C17.4477 4 17 4.44772 17 5V7H16C15.4477 7 15 7.44772 15 8C15 8.55229 15.4477 9 16 9H17L17 19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V9H20C20.5523 9 21 8.55229 21 8C21 7.44772 20.5523 7 20 7H19V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 20C11.4477 20 11 19.5523 11 19L11 17H10C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15H11L11 5C11 4.44771 11.4477 4 12 4C12.5523 4 13 4.44771 13 5L13 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H13V19C13 19.5523 12.5523 20 12 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","filter","sort","adjust","preference","equalizer","controls","options","configuration","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 19L18 5" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 5L6 19" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 19" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 8L4 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 8L16 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","settings","adjust","controls","options","arrange","reorder","prioritize","sliders","equalizer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7C18.6569 7 20 8.34315 20 10C20 11.6569 18.6569 13 17 13C15.3431 13 14 11.6569 14 10C14 8.34314 15.3431 7 17 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 7L17 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 20L17 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 17L7 20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 4L7 11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 17C5.34315 17 4 15.6569 4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14C10 15.6569 8.65685 17 7 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","settings","adjust","options","controls","arrange","order","prioritize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7C18.6569 7 20 8.34315 20 10C20 11.6569 18.6569 13 17 13C15.3431 13 14 11.6569 14 10C14 8.34314 15.3431 7 17 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 7L17 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 20L17 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 17C5.34315 17 4 15.6569 4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14C10 15.6569 8.65685 17 7 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 17L7 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 4L7 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","filter","adjust","options","settings","preferences","controls","configuration","sliders","equalizer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 7L17 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 20L17 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 17L7 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 4L7 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 7C18.6569 7 20 8.34315 20 10C20 11.6569 18.6569 13 17 13C15.3431 13 14 11.6569 14 10C14 8.34314 15.3431 7 17 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 17C5.34315 17 4 15.6569 4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14C10 15.6569 8.65685 17 7 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sort","filter","options","adjust","settings","preferences","control","sliders","adjustments","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 6L5 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 18L5 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6C12 7.10457 11.1046 8 10 8C8.89543 8 8 7.10457 8 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 10.8954 16 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 18C8 16.8954 8.89543 16 10 16C11.1046 16 12 16.8954 12 18C12 19.1046 11.1046 20 10 20C8.89543 20 8 19.1046 8 18Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-21": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","adjust","settings","options","preferences","configuration","sliders","controls","refine","search-filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 9L8 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L13 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 15L16 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L11 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 15C15 16.1046 14.1046 17 13 17C11.8954 17 11 16.1046 11 15C11 13.8954 11.8954 13 13 13C14.1046 13 15 13.8954 15 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","settings","adjust","options","configuration","preferences","customize","refine","control","sliders","fine-tune"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 9L8 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L13 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 15L16 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L11 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 15C15 16.1046 14.1046 17 13 17C11.8954 17 11 16.1046 11 15C11 13.8954 11.8954 13 13 13C14.1046 13 15 13.8954 15 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","options","settings","adjust","preferences","configuration","customize","arrange","categorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 8.5C10 7.94772 10.4477 7.5 11 7.5C11.5523 7.5 12 7.94772 12 8.5C12 9.05228 11.5523 9.5 11 9.5C10.4477 9.5 10 9.05229 10 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 15.5C14 16.0523 13.5523 16.5 13 16.5C12.4477 16.5 12 16.0523 12 15.5C12 14.9477 12.4477 14.5 13 14.5C13.5523 14.5 14 14.9477 14 15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.57533 21 9.92944V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57533 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM8.1659 9.4863C8.11194 9.49531 8.05652 9.5 8 9.5H7C6.44772 9.5 6 9.05229 6 8.5C6 7.94772 6.44772 7.5 7 7.5H8C8.05652 7.5 8.11194 7.50469 8.1659 7.5137C8.57385 6.34136 9.68867 5.5 11 5.5C12.3062 5.5 13.4175 6.33481 13.8293 7.5L17 7.5C17.5523 7.5 18 7.94772 18 8.5C18 9.05229 17.5523 9.5 17 9.5L13.8293 9.5C13.4175 10.6652 12.3062 11.5 11 11.5C9.68867 11.5 8.57385 10.6586 8.1659 9.4863ZM15.8341 14.5137C15.8881 14.5047 15.9435 14.5 16 14.5H17C17.5523 14.5 18 14.9477 18 15.5C18 16.0523 17.5523 16.5 17 16.5H16C15.9435 16.5 15.8881 16.4953 15.8341 16.4863C15.4262 17.6586 14.3113 18.5 13 18.5C11.6938 18.5 10.5825 17.6652 10.1707 16.5L7 16.5C6.44772 16.5 6 16.0523 6 15.5C6 14.9477 6.44772 14.5 7 14.5L10.1707 14.5C10.5825 13.3348 11.6938 12.5 13 12.5C14.3113 12.5 15.4262 13.3414 15.8341 14.5137Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-22": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sort","filter","options","settings","adjust","configuration","preferences","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 9L8 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L13 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeLinecap="round"
                />
                <path d="M15 15L16 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 15L11 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 15C15 16.1046 14.1046 17 13 17C11.8954 17 11 16.1046 11 15C11 13.8954 11.8954 13 13 13C14.1046 13 15 13.8954 15 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","arrange","filter","options","settings","adjust","priority","order","sort-by","list","organize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10.126L6 4C6 3.44772 6.44771 3 7 3C7.55228 3 8 3.44772 8 4L8 10.126C9.72523 10.5701 11 12.1362 11 14C11 15.8638 9.72523 17.4299 8 17.874V20C8 20.5523 7.55229 21 7 21C6.44772 21 6 20.5523 6 20L6 17.874C4.27477 17.4299 3 15.8638 3 14C3 12.1362 4.27477 10.5701 6 10.126Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 4C18 3.44772 17.5523 3 17 3C16.4477 3 16 3.44772 16 4L16 6.12602C14.2748 6.57006 13 8.13616 13 10C13 11.8638 14.2748 13.4299 16 13.874V20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20V13.874C19.7252 13.4299 21 11.8638 21 10C21 8.13616 19.7252 6.57006 18 6.12602L18 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","sliders","adjust","filter","sort","options","preferences","control","customize","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8C19.1046 8 20 8.89543 20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10C16 8.89543 16.8954 8 18 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 8L18 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 8C7.10457 8 8 8.89543 8 10C8 11.1046 7.10457 12 6 12C4.89543 12 4 11.1046 4 10C4 8.89543 4.89543 8 6 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 8L6 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 19L6 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-25": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","adjust","settings","controls","sliders","options","equalizer","configure","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8C19.1046 8 20 8.89543 20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10C16 8.89543 16.8954 8 18 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 8L18 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 8C7.10457 8 8 8.89543 8 10C8 11.1046 7.10457 12 6 12C4.89543 12 4 11.1046 4 10C4 8.89543 4.89543 8 6 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 8L6 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 19L6 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-26": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["filter","sort","adjust","settings","options","preferences","refine","grouping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8L18 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 19L18 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 8L6 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 19L6 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 8C19.1046 8 20 8.89543 20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10C16 8.89543 16.8954 8 18 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 8C7.10457 8 8 8.89543 8 10C8 11.1046 7.10457 12 6 12C4.89543 12 4 11.1046 4 10C4 8.89543 4.89543 8 6 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","arrange","options","adjust","settings","controls","prioritize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8C9 6.89543 9.89543 6 11 6C12.1046 6 13 6.89543 13 8C13 9.10457 12.1046 10 11 10C9.89543 10 9 9.10457 9 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 8L7 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 16C15 17.1046 14.1046 18 13 18C11.8954 18 11 17.1046 11 16C11 14.8954 11.8954 14 13 14C14.1046 14 15 14.8954 15 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 16H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 16L11 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","sort","options","adjust","settings","preferences","customize","arrange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5C7 4.44772 6.55228 4 6 4C5.44771 4 5 4.44772 5 5L5 7.17071C3.83481 7.58254 3 8.69378 3 10C3 11.3062 3.83481 12.4175 5 12.8293L5 19C5 19.5523 5.44772 20 6 20C6.55229 20 7 19.5523 7 19L7 12.8293C8.16519 12.4175 9 11.3062 9 10C9 8.69378 8.16519 7.58254 7 7.17071L7 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 5L11 11.1707C9.83481 11.5825 9 12.6938 9 14C9 15.3062 9.83481 16.4175 11 16.8293V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V16.8293C14.1652 16.4175 15 15.3062 15 14C15 12.6938 14.1652 11.5825 13 11.1707L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 4C18.5523 4 19 4.44772 19 5L19 7.17071C20.1652 7.58254 21 8.69378 21 10C21 11.3062 20.1652 12.4175 19 12.8293V19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19V12.8293C15.8348 12.4175 15 11.3062 15 10C15 8.69378 15.8348 7.58254 17 7.17071L17 5C17 4.44772 17.4477 4 18 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-29": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","filter","arrange","order","options","settings","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8C9 6.89543 9.89543 6 11 6C12.1046 6 13 6.89543 13 8C13 9.10457 12.1046 10 11 10C9.89543 10 9 9.10457 9 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 8L7 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16H17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 16L11 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 16C15 17.1046 14.1046 18 13 18C11.8954 18 11 17.1046 11 16C11 14.8954 11.8954 14 13 14C14.1046 14 15 14.8954 15 16Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","options","arrange","reorder","prioritize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11C12.3062 11 13.4175 10.1652 13.8293 9L17 9C17.5523 9 18 8.55228 18 8C18 7.44771 17.5523 7 17 7L13.8293 7C13.4175 5.83481 12.3062 5 11 5C9.69378 5 8.58254 5.83481 8.17071 7L7 7C6.44772 7 6 7.44771 6 8C6 8.55228 6.44772 9 7 9L8.17071 9C8.58254 10.1652 9.69378 11 11 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.1707 15L7 15C6.44771 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17L10.1707 17C10.5825 18.1652 11.6938 19 13 19C14.3062 19 15.4175 18.1652 15.8293 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15H15.8293C15.4175 13.8348 14.3062 13 13 13C11.6938 13 10.5825 13.8348 10.1707 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","options","control","arrange","prioritize","customize","modify","categorize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.17071 7L5 7C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5L7.17071 5C7.58254 3.83481 8.69378 3 10 3C11.3062 3 12.4175 3.83481 12.8293 5L19 5C19.5523 5 20 5.44771 20 6C20 6.55228 19.5523 7 19 7L12.8293 7C12.4175 8.16519 11.3062 9 10 9C8.69378 9 7.58254 8.16519 7.17071 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H16.8293C16.4175 9.83481 15.3062 9 14 9C12.6938 9 11.5825 9.83481 11.1707 11L5 11C4.44771 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13L11.1707 13C11.5825 14.1652 12.6938 15 14 15C15.3062 15 16.4175 14.1652 16.8293 13H19Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H7.17071C7.58254 20.1652 8.69378 21 10 21C11.3062 21 12.4175 20.1652 12.8293 19L19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17L12.8293 17C12.4175 15.8348 11.3062 15 10 15C8.69378 15 7.58254 15.8348 7.17071 17H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","controls","preferences","options","refine","arrange","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16M11 16C11 14.8954 10.1046 14 9 14C7.89543 14 7 14.8954 7 16M11 16H19M7 16H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8M13 8C13 9.10457 13.8954 10 15 10C16.1046 10 17 9.10457 17 8M13 8L5 8M17 8L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["filter","sort","settings","adjust","options","preferences","controls","configure","sliders","parameters","customize","ordering"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 16H19M7 16H5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 8L5 8M17 8L19 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8C17 9.10457 16.1046 10 15 10C13.8954 10 13 9.10457 13 8Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-34": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["filter","sort","adjust","settings","options","preferences","customize","controls","sliders","equalizer","configure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 16H19M7 16H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8L5 8M17 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8C17 9.10457 16.1046 10 15 10C13.8954 10 13 9.10457 13 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-30": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["filter","sort","adjust","settings","options","preferences","equalizer","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 8L7 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 8L13 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 16L11 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 16H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 8C9 6.89543 9.89543 6 11 6C12.1046 6 13 6.89543 13 8C13 9.10457 12.1046 10 11 10C9.89543 10 9 9.10457 9 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 16C15 17.1046 14.1046 18 13 18C11.8954 18 11 17.1046 11 16C11 14.8954 11.8954 14 13 14C14.1046 14 15 14.8954 15 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","settings","adjust","options","arrange","customize","equalizer","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 9L12.1707 9C12.5825 10.1652 13.6938 11 15 11C16.3062 11 17.4175 10.1652 17.8293 9H19C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7L17.8293 7C17.4175 5.83481 16.3062 5 15 5C13.6938 5 12.5825 5.83481 12.1707 7L5 7C4.44772 7 4 7.44772 4 8C4 8.55229 4.44772 9 5 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 15C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H6.17071C6.58254 18.1652 7.69378 19 9 19C10.3062 19 11.4175 18.1652 11.8293 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H11.8293C11.4175 13.8348 10.3062 13 9 13C7.69378 13 6.58254 13.8348 6.17071 15H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","arrange","group","inventory","products","sales","data","layout","display","categories","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4C8.65685 4 10 5.34315 10 7C10 8.65685 8.65685 10 7 10C5.34315 10 4 8.65685 4 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 7H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L10 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sort","sort-by","filter","arrange","order","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4C8.65685 4 10 5.34315 10 7C10 8.65685 8.65685 10 7 10C5.34315 10 4 8.65685 4 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 7H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L10 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sort","filter","group","arrange","category","options","organize","display","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7C4 5.34315 5.34315 4 7 4C8.65685 4 10 5.34315 10 7C10 8.65685 8.65685 10 7 10C5.34315 10 4 8.65685 4 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 7H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L10 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","grid","layout","display","arrangement","menu","options","settings","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 7C13 6.44772 13.4477 6 14 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H14C13.4477 8 13 7.55228 13 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16L4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18L10 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sort-by-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["filter","sort","settings","adjust","refine","options","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 7L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L20 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L11 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 17C17 18.6569 15.6569 20 14 20C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14C15.6569 14 17 15.3431 17 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sort-by-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","settings","adjust","options","customize","refine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 7L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 17C17 18.6569 15.6569 20 14 20C12.3431 20 11 18.6569 11 17C11 15.3431 12.3431 14 14 14C15.6569 14 17 15.3431 17 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M17 17L20 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 17L11 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sort-by": {
        defaultColors: ["#3D4C66"],
        keywords: ["sort","filter","adjust","settings","options","configure","sort-by","equalizer","preferences","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 6C8 4.89543 8.89543 4 10 4C11.1046 4 12 4.89543 12 6C12 7.10457 11.1046 8 10 8C8.89543 8 8 7.10457 8 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 6L5 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 6L12 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 10.8954 16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 12L19 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 12L12 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 18C8 16.8954 8.89543 16 10 16C11.1046 16 12 16.8954 12 18C12 19.1046 11.1046 20 10 20C8.89543 20 8 19.1046 8 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 18L5 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 18L12 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sos-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sos","help","emergency","assistance","support","error","problem","report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 10H8C7.44772 10 7 10.4477 7 11V11C7 11.5523 7.44772 12 8 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 10H16C15.4477 10 15 10.4477 15 11V11C15 11.5523 15.4477 12 16 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14H8C8.55228 14 9 13.5523 9 13V13C9 12.4477 8.55228 12 8 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14H16C16.5523 14 17 13.5523 17 13V13C17 12.4477 16.5523 12 16 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13L13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "sos-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sos","help","support","assistance","emergency","problem","alert","notification","warning","critical"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10H8C7.44772 10 7 10.4477 7 11V11C7 11.5523 7.44772 12 8 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 10H16C15.4477 10 15 10.4477 15 11V11C15 11.5523 15.4477 12 16 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14H8C8.55228 14 9 13.5523 9 13V13C9 12.4477 8.55228 12 8 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14H16C16.5523 14 17 13.5523 17 13V13C17 12.4477 16.5523 12 16 12V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13L13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sos-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sos","help","support","emergency","assistance","alert","problem","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.75 11C11.75 10.8619 11.8619 10.75 12 10.75C12.1381 10.75 12.25 10.8619 12.25 11V13C12.25 13.1381 12.1381 13.25 12 13.25C11.8619 13.25 11.75 13.1381 11.75 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.4587 21 8.5753 21 9.92942V14.0705C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92946C8.57535 21 7.4587 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92943C2.99997 8.57535 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM7.75 11C7.75 10.8619 7.86193 10.75 8 10.75H9C9.41422 10.75 9.75 10.4142 9.75 10C9.75 9.58579 9.41422 9.25 9 9.25H8C7.0335 9.25 6.25 10.0335 6.25 11C6.25 11.9665 7.0335 12.75 8 12.75C8.13807 12.75 8.25 12.8619 8.25 13C8.25 13.1381 8.13807 13.25 8 13.25H7C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H8C8.9665 14.75 9.75 13.9665 9.75 13C9.75 12.0335 8.9665 11.25 8 11.25C7.86193 11.25 7.75 11.1381 7.75 11ZM12 9.25C11.0335 9.25 10.25 10.0335 10.25 11V13C10.25 13.9665 11.0335 14.75 12 14.75C12.9665 14.75 13.75 13.9665 13.75 13V11C13.75 10.0335 12.9665 9.25 12 9.25ZM15.75 11C15.75 10.8619 15.8619 10.75 16 10.75H17C17.4142 10.75 17.75 10.4142 17.75 10C17.75 9.58579 17.4142 9.25 17 9.25H16C15.0335 9.25 14.25 10.0335 14.25 11C14.25 11.9665 15.0335 12.75 16 12.75C16.1381 12.75 16.25 12.8619 16.25 13C16.25 13.1381 16.1381 13.25 16 13.25H15C14.5858 13.25 14.25 13.5858 14.25 14C14.25 14.4142 14.5858 14.75 15 14.75H16C16.9665 14.75 17.75 13.9665 17.75 13C17.75 12.0335 16.9665 11.25 16 11.25C15.8619 11.25 15.75 11.1381 15.75 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    sos: {
        defaultColors: ["#3D4C66"],
        keywords: ["sos","help","support","emergency","assistance","alert","problem","issue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 10H8C7.44772 10 7 10.4477 7 11V11C7 11.5523 7.44772 12 8 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 10H16C15.4477 10 15 10.4477 15 11V11C15 11.5523 15.4477 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14H8C8.55228 14 9 13.5523 9 13V13C9 12.4477 8.55228 12 8 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14H16C16.5523 14 17 13.5523 17 13V13C17 12.4477 16.5523 12 16 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 11V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13L13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "sound-module-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","adjust","sliders","levels","configuration","preferences","options","equalizer","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13H17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L18 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sound-module-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","adjust","filter","equalizer","adjustments","options","preferences","configurations","sliders","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13L18 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L18 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6L12 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18L6 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sound-module-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","adjust","sliders","equalizer","options","configuration","filter","controls","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 12V6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6V12C4.45 12 4 12.45 4 13C4 13.55 4.45 14 5 14H7C7.55 14 8 13.55 8 13C8 12.45 7.55 12 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 10H11C10.45 10 10 10.45 10 11C10 11.55 10.45 12 11 12V18C11 18.55 11.45 19 12 19C12.55 19 13 18.55 13 18V12C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12V6C19 5.45 18.55 5 18 5C17.45 5 17 5.45 17 6V12C16.45 12 16 12.45 16 13C16 13.55 16.45 14 17 14H19C19.55 14 20 13.55 20 13C20 12.45 19.55 12 19 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 15C17.45 15 17 15.45 17 16V18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18V16C19 15.45 18.55 15 18 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C12.55 9 13 8.55 13 8V6C13 5.45 12.55 5 12 5C11.45 5 11 5.45 11 6V8C11 8.55 11.45 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 15C5.45 15 5 15.45 5 16V18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18V16C7 15.45 6.55 15 6 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "SoundWave-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sound","wave","equalizer","volume","audio","levels","music","soundwave","notification","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L18 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "SoundWave-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","wave","volume","settings","audio","levels","equalizer","microphone","notification","alerts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L18 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sound-module": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","settings","volume","equalizer","adjust","controls","options","sliders","sound-module","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 13L18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11L12 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 13H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 11H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 13H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L18 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 6L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18L6 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "SoundWave-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","wave","equalizer","volume","audio","settings","notification","alert","signal","intensity","levels","dynamics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C12.5523 5 13 5.44772 13 6V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V6C11 5.44772 11.4477 5 12 5ZM9 8C9.55228 8 10 8.44772 10 9V15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15L8 9C8 8.44772 8.44772 8 9 8ZM15 8C15.5523 8 16 8.44772 16 9L16 15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15L14 9C14 8.44772 14.4477 8 15 8ZM6 10C6.55228 10 7 10.4477 7 11V13C7 13.5523 6.55228 14 6 14C5.44772 14 5 13.5523 5 13L5 11C5 10.4477 5.44772 10 6 10ZM18 10C18.5523 10 19 10.4477 19 11V13C19 13.5523 18.5523 14 18 14C17.4477 14 17 13.5523 17 13V11C17 10.4477 17.4477 10 18 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    SoundWave: {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","wave","equalizer","volume","audio","settings","notification","alert","signal","intensity","levels","dynamics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 11L18 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 13L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "spa-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["spa","wellness","beauty","health","treatment","relaxation","therapy","service","appointment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18C7.31258 18 4 14 4 9C6.31464 9 7.88725 9.7969 9.29156 10.9377C8.95323 13.5212 9.85603 16.2633 12 18ZM12 18C16.6873 18 20 14 20 9C17.6854 9 16.1127 9.7969 14.7084 10.9377C15.0467 13.5212 14.1439 16.2633 12 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.29134 10.9377C9.53744 9.05854 10.4402 7.26329 11.9997 6C13.5592 7.26329 14.462 9.05854 14.7081 10.9377C15.0465 13.5212 14.1437 16.2633 11.9997 18C9.85581 16.2633 8.95301 13.5212 9.29134 10.9377Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "spa-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["spa","wellness","beauty","appointment","service","relaxation","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18C7.31258 18 4 14 4 9C6.31464 9 7.88725 9.7969 9.29156 10.9377C9.53766 9.05854 10.4405 7.26329 12 6C13.5595 7.26329 14.4623 9.05854 14.7084 10.9377C16.1127 9.7969 17.6854 9 20 9C20 14 16.6873 18 12 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 18C7.31258 18 4 14 4 9C6.31464 9 7.88725 9.7969 9.29156 10.9377M12 18C9.85603 16.2633 8.95323 13.5212 9.29156 10.9377M12 18C16.6873 18 20 14 20 9C17.6854 9 16.1127 9.7969 14.7084 10.9377M12 18C14.1439 16.2633 15.0467 13.5212 14.7084 10.9377M9.29156 10.9377C9.53766 9.05854 10.4405 7.26329 12 6C13.5595 7.26329 14.4623 9.05854 14.7084 10.9377"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.29134 10.9377C9.53744 9.05854 10.4402 7.26329 11.9997 6C13.5592 7.26329 14.462 9.05854 14.7081 10.9377C15.0465 13.5212 14.1437 16.2633 11.9997 18C9.85581 16.2633 8.95301 13.5212 9.29134 10.9377Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    spa: {
        defaultColors: ["#3D4C66"],
        keywords: ["spa","wellness","beauty","appointment","service","relaxation","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 18C7.31258 18 4 14 4 9C6.31464 9 7.88725 9.7969 9.29156 10.9377M12 18C9.85603 16.2633 8.95323 13.5212 9.29156 10.9377M12 18C16.6873 18 20 14 20 9C17.6854 9 16.1127 9.7969 14.7084 10.9377M12 18C14.1439 16.2633 15.0467 13.5212 14.7084 10.9377M9.29156 10.9377C9.53766 9.05854 10.4405 7.26329 12 6C13.5595 7.26329 14.4623 9.05854 14.7084 10.9377"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sparkle-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sparkle","shine","promotion","special-offer","discount","new","feature","highlight","popular","trending","award","top","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19C11.7145 15.2586 8.74138 12.2855 5 12C8.74138 11.7145 11.7145 8.74138 12 5C12.2855 8.74138 15.2586 11.7145 19 12C15.2586 12.2855 12.2855 15.2586 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19C11.7145 15.2586 8.74138 12.2855 5 12M12 5C12.2855 8.74138 15.2586 11.7145 19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sparkle-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["sparkle","shine","special","promotion","featured","highlight","new","star","discount","featured-item","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19C11.7145 15.2586 8.74138 12.2855 5 12C8.74138 11.7145 11.7145 8.74138 12 5C12.2855 8.74138 15.2586 11.7145 19 12C15.2586 12.2855 12.2855 15.2586 12 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "spa-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["spa","lotus","flower","wellness","relaxation","service","beauty","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.20022 9.003C7.04005 8.38724 5.69138 8 4 8C3.44772 8 3 8.44772 3 9C3 13.989 6.08248 18.2704 10.7611 18.916C8.38042 16.8088 7.42187 13.663 7.80428 10.743C7.88128 10.155 8.01306 9.57155 8.20022 9.003Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.2389 18.916C17.9175 18.2703 21 13.989 21 9C21 8.44772 20.5523 8 20 8C18.3086 8 16.9599 8.38724 15.7997 9.00299C15.9869 9.57154 16.1187 10.155 16.1957 10.743C16.5781 13.663 15.6195 16.8088 13.2389 18.916Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.29158 10.9377C8.95325 13.5212 9.85606 16.2633 12 18C14.1439 16.2633 15.0467 13.5212 14.7084 10.9377C14.4623 9.05854 13.5595 7.26329 12 6C10.4405 7.26329 9.53768 9.05854 9.29158 10.9377Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    sparkle: {
        defaultColors: ["#3D4C66"],
        keywords: ["spa","lotus","flower","wellness","relaxation","service","beauty","health"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19C11.7145 15.2586 8.74138 12.2855 5 12C8.74138 11.7145 11.7145 8.74138 12 5C12.2855 8.74138 15.2586 11.7145 19 12C15.2586 12.2855 12.2855 15.2586 12 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sparkle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sparkle","highlight","promotion","featured","popular","special","star","favorite"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9971 4.92392C12.9573 4.40266 12.5228 4 12 4C11.4772 4 11.0427 4.40266 11.0029 4.92392C10.755 8.17303 8.17303 10.755 4.92392 11.0029C4.40266 11.0427 4 11.4772 4 12C4 12.5228 4.40266 12.9573 4.92392 12.9971C8.17303 13.245 10.755 15.827 11.0029 19.0761C11.0427 19.5973 11.4772 20 12 20C12.5228 20 12.9573 19.5973 12.9971 19.0761C13.245 15.827 15.827 13.245 19.0761 12.9971C19.5973 12.9573 20 12.5228 20 12C20 11.4772 19.5973 11.0427 19.0761 11.0029C15.827 10.755 13.245 8.17303 12.9971 4.92392Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sparkles-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sparkles","shine","new","featured","popular","promotion","sale","discount","highlight","recommend","special","stars","sparkling","best-seller","trending"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 17C9.79609 14.3276 7.67241 12.2039 5 12C7.67241 11.7961 9.79609 9.67241 10 7C10.2039 9.67241 12.3276 11.7961 15 12C12.3276 12.2039 10.2039 14.3276 10 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C15.8777 7.39655 14.6034 6.12234 13 6C14.6034 5.87766 15.8777 4.60345 16 3C16.1223 4.60345 17.3966 5.87766 19 6C17.3966 6.12234 16.1223 7.39655 16 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 21C15.8777 19.3966 14.6034 18.1223 13 18C14.6034 17.8777 15.8777 16.6034 16 15C16.1223 16.6034 17.3966 17.8777 19 18C17.3966 18.1223 16.1223 19.3966 16 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 17C9.79609 14.3276 7.67241 12.2039 5 12C7.67241 11.7961 9.79609 9.67241 10 7C10.2039 9.67241 12.3276 11.7961 15 12C12.3276 12.2039 10.2039 14.3276 10 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sparkles-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sparkles","shine","special","featured","promotion","new","popular","recommended","deal","trending","spark","highlight","featured-item","discount","stars"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7478 2.94294C16.718 2.552 16.3921 2.25 16 2.25C15.6079 2.25 15.282 2.552 15.2522 2.94294C15.158 4.17719 14.1772 5.158 12.9429 5.25217C12.552 5.282 12.25 5.60792 12.25 6C12.25 6.39208 12.552 6.718 12.9429 6.74783C14.1772 6.842 15.158 7.82281 15.2522 9.05706C15.282 9.448 15.6079 9.75 16 9.75C16.3921 9.75 16.718 9.448 16.7478 9.05706C16.842 7.82281 17.8228 6.842 19.0571 6.74783C19.448 6.718 19.75 6.39208 19.75 6C19.75 5.60792 19.448 5.282 19.0571 5.25217C17.8228 5.158 16.842 4.17719 16.7478 2.94294Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.7478 6.94294C10.718 6.552 10.3921 6.25 10 6.25C9.60792 6.25 9.282 6.552 9.25217 6.94294C9.07644 9.24615 7.24615 11.0764 4.94294 11.2522C4.552 11.282 4.25 11.6079 4.25 12C4.25 12.3921 4.552 12.718 4.94294 12.7478C7.24615 12.9236 9.07644 14.7538 9.25217 17.0571C9.282 17.448 9.60792 17.75 10 17.75C10.3921 17.75 10.718 17.448 10.7478 17.0571C10.9236 14.7538 12.7538 12.9236 15.0571 12.7478C15.448 12.718 15.75 12.3921 15.75 12C15.75 11.6079 15.448 11.282 15.0571 11.2522C12.7538 11.0764 10.9236 9.24615 10.7478 6.94294Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.7478 14.9429C16.718 14.552 16.3921 14.25 16 14.25C15.6079 14.25 15.282 14.552 15.2522 14.9429C15.158 16.1772 14.1772 17.158 12.9429 17.2522C12.552 17.282 12.25 17.6079 12.25 18C12.25 18.3921 12.552 18.718 12.9429 18.7478C14.1772 18.842 15.158 19.8228 15.2522 21.0571C15.282 21.448 15.6079 21.75 16 21.75C16.3921 21.75 16.718 21.448 16.7478 21.0571C16.842 19.8228 17.8228 18.842 19.0571 18.7478C19.448 18.718 19.75 18.3921 19.75 18C19.75 17.6079 19.448 17.282 19.0571 17.2522C17.8228 17.158 16.842 16.1772 16.7478 14.9429Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sparkles-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sparkles","sparkle","special","promotion","featured","highlight","recommended","new","hot","trending","popular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 17C9.79609 14.3276 7.67241 12.2039 5 12C7.67241 11.7961 9.79609 9.67241 10 7C10.2039 9.67241 12.3276 11.7961 15 12C12.3276 12.2039 10.2039 14.3276 10 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C15.8777 7.39655 14.6034 6.12234 13 6C14.6034 5.87766 15.8777 4.60345 16 3C16.1223 4.60345 17.3966 5.87766 19 6C17.3966 6.12234 16.1223 7.39655 16 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 21C15.8777 19.3966 14.6034 18.1223 13 18C14.6034 17.8777 15.8777 16.6034 16 15C16.1223 16.6034 17.3966 17.8777 19 18C17.3966 18.1223 16.1223 19.3966 16 21Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C15.8777 7.39655 14.6034 6.12234 13 6C14.6034 5.87766 15.8777 4.60345 16 3C16.1223 4.60345 17.3966 5.87766 19 6C17.3966 6.12234 16.1223 7.39655 16 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 21C15.8777 19.3966 14.6034 18.1223 13 18C14.6034 17.8777 15.8777 16.6034 16 15C16.1223 16.6034 17.3966 17.8777 19 18C17.3966 18.1223 16.1223 19.3966 16 21Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    sparkles: {
        defaultColors: ["#3D4C66"],
        keywords: ["sparkles","sparkle","special","promotion","featured","highlight","recommended","new","hot","trending","popular"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 17C9.79609 14.3276 7.67241 12.2039 5 12C7.67241 11.7961 9.79609 9.67241 10 7C10.2039 9.67241 12.3276 11.7961 15 12C12.3276 12.2039 10.2039 14.3276 10 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C15.8777 7.39655 14.6034 6.12234 13 6C14.6034 5.87766 15.8777 4.60345 16 3C16.1223 4.60345 17.3966 5.87766 19 6C17.3966 6.12234 16.1223 7.39655 16 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 21C15.8777 19.3966 14.6034 18.1223 13 18C14.6034 17.8777 15.8777 16.6034 16 15C16.1223 16.6034 17.3966 17.8777 19 18C17.3966 18.1223 16.1223 19.3966 16 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "speaker-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["speaker","audio","sound","volume","music","announcement","alert","notification","sound-alert","sound-notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M10 8H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "speaker-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["speaker","volume","sound","announcement","notification","audio","alert","broadcast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                />
                <path d="M10 8H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "speaker-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["speaker","sound","volume","audio","broadcast","notification","announcement","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0706 4H11.9294C10.5753 3.99997 9.45868 3.99994 8.57494 4.11876C7.64711 4.2435 6.82769 4.51547 6.17158 5.17158C5.51547 5.82769 5.2435 6.64711 5.11876 7.57494C4.99994 8.45868 4.99997 9.57531 5 10.9294V13.0706C4.99997 14.4247 4.99994 15.5413 5.11876 16.4251C5.2435 17.3529 5.51547 18.1723 6.17158 18.8284C6.82769 19.4845 7.64711 19.7565 8.57494 19.8813C9.45868 20.0001 10.5753 20 11.9294 20H12.0706C13.4247 20 14.5413 20.0001 15.4251 19.8813C16.3529 19.7565 17.1723 19.4845 17.8284 18.8284C18.4845 18.1723 18.7565 17.3529 18.8813 16.4251C19.0001 15.5413 19 14.4247 19 13.0706V10.9294C19 9.57531 19.0001 8.4587 18.8813 7.57494C18.7565 6.64711 18.4845 5.82769 17.8284 5.17158C17.1723 4.51547 16.3529 4.2435 15.4251 4.11876C14.5413 3.99994 13.4247 3.99997 12.0706 4ZM8 8C8 7.44772 8.44772 7 9 7H10C10.5523 7 11 7.44772 11 8C11 8.55229 10.5523 9 10 9H9C8.44772 9 8 8.55229 8 8ZM14 7C13.4477 7 13 7.44772 13 8C13 8.55229 13.4477 9 14 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H14ZM9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "speed-meter-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["speed","meter","performance","dashboard","analytics","efficiency","indicator","sales","metrics","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.52779 16C6.57771 14.9385 6 13.5367 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.5367 17.4223 14.9385 16.4722 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 10.5L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    speaker: {
        defaultColors: ["#3D4C66"],
        keywords: ["speed","meter","performance","dashboard","analytics","efficiency","indicator","sales","metrics","statistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 13V11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5C14.8284 5 16.2426 5 17.1213 5.87868C18 6.75736 18 8.17157 18 11V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 8H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 8H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "speed-meter-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["speed","meter","performance","dashboard","analytics","productivity","efficiency","sales","indicator","gauge","kpi","target","metrics","monitoring","progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13.2934 9.29244C12.9017 9.10503 12.4631 9.00009 12 9.00009C10.3431 9.00009 9 10.3432 9 12.0001C9 13.6569 10.3431 15.0001 12 15.0001C13.6569 15.0001 15 13.6569 15 12.0001C15 11.5369 14.895 11.0983 14.7076 10.7066C15.0976 10.3161 15.0975 9.68325 14.7071 9.29289C14.3167 8.90252 13.6839 8.90237 13.2934 9.29244ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 13.7922 18.3252 15.4291 17.2173 16.6669C16.849 17.0784 16.2168 17.1135 15.8053 16.7451C15.3938 16.3768 15.3588 15.7446 15.7271 15.3331C16.5194 14.4478 17 13.2812 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 13.2812 7.48059 14.4478 8.27292 15.3331C8.64125 15.7446 8.60623 16.3768 8.1947 16.7451C7.78317 17.1135 7.15098 17.0784 6.78265 16.6669C5.67482 15.4291 5 13.7922 5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "speed-meter-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["speed","meter","performance","efficiency","analytics","dashboard","reporting","sales-performance","metrics","indicator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.52779 16C6.57771 14.9385 6 13.5367 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.5367 17.4223 14.9385 16.4722 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 10.5L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "speed-meter": {
        defaultColors: ["#3D4C66"],
        keywords: ["speed","meter","gauge","performance","efficiency","dashboard","analytics","sales","velocity","productivity","level","progress","report","indicator","target","goals","kpi"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.52779 16C6.57771 14.9385 6 13.5367 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.5367 17.4223 14.9385 16.4722 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 10.5L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "speed-truck-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["truck","delivery","shipping","fast-delivery","order-delivery","out-for-delivery","transport","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00092 18.9941L2 19.0002"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 5H10C11.8856 5 12.8284 5 13.4142 5.58579C14 6.17157 14 7.11438 14 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 15H2M5 9H2M4 12H2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "speed-truck-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","fast","speed","transport","order-delivery","out-for-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.35 15.06L22.13 13.48H15V11.99H21.74C21.74 11.99 21.85 11.99 21.86 11.99L21.62 10.8C21.29 9.15 21.11 8.24 20.35 7.62C19.59 7 18.66 7 16.97 7H14.82C14.71 6.52 14.51 6.14 14.18 5.81C13.37 5 12.26 5 10.24 5H6.24001C4.22001 5 3.1 5 2.3 5.81C1.6 6.51 1.51 7.44 1.5 9H2.25V9.75C2.25 9.75 2.25 9.23 2.25 9H5.25C5.66 9 6 9.34 6 9.75C6 10.16 5.66 10.5 5.25 10.5H1.5V9.67C1.5 9.67 1.50001 9.82315 1.50001 9.85315V16.8531C1.50001 17.8431 1.50001 18.29 1.71001 18.8C1.99001 19.48 2.53001 20.01 3.21001 20.3C3.28001 20.33 3.41 20.38 4.13 20.43C4.08 20.21 4.06 19.99 4.06 19.76C4.06 19.73 4.06 19.7 4.06 19.67C4.06 19.41 4.11 19.17 4.17 18.93C4.54 17.57 5.77 16.56 7.25 16.56C8.73 16.56 10.01 17.61 10.35 19.01C10.41 19.25 10.45 19.5 10.45 19.76C10.45 20.02 10.41 20.27 10.35 20.51H15.15C15.09 20.27 15.05 20.02 15.05 19.76C15.05 19.5 15.09 19.25 15.15 19.01C15.49 17.61 16.75 16.56 18.25 16.56C19.47 16.56 20.51 17.25 21.05 18.25C21.2 18.53 21.32 18.82 21.38 19.14C21.42 19.34 21.44 19.55 21.44 19.76C21.44 19.86 21.42 19.95 21.41 20.05C21.63 19.92 21.84 19.77 22.01 19.57C22.83 18.62 22.68 17.34 22.35 15.06ZM1.5 16.48V14.98H3.25C3.66 14.98 4 15.32 4 15.73C4 16.14 3.66 16.48 3.25 16.48H1.5ZM4.25 13.48H1.5V11.98H4.25C4.66 11.98 5 12.32 5 12.73C5 13.14 4.66 13.48 4.25 13.48Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.25 17.73C6.43 17.73 5.72 18.23 5.41 18.95C5.31 19.18 5.26 19.43 5.25 19.7C5.25 19.71 5.25 19.73 5.25 19.74C5.25 19.99 5.3 20.23 5.39 20.46C5.68 21.21 6.4 21.74 7.25 21.74C8.1 21.74 8.80001 21.22 9.10001 20.49C9.19001 20.26 9.25 20.01 9.25 19.74C9.25 19.47 9.20001 19.22 9.10001 18.99C8.80001 18.26 8.09 17.74 7.25 17.74V17.73Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.06 18.89C19.74 18.21 19.05 17.73 18.25 17.73C17.45 17.73 16.7 18.25 16.4 18.98C16.31 19.2 16.26 19.45 16.25 19.7V19.73C16.25 20 16.3 20.25 16.4 20.48C16.7 21.21 17.41 21.73 18.25 21.73C19.09 21.73 19.85 21.17 20.13 20.39C20.2 20.18 20.25 19.96 20.25 19.73C20.25 19.69 20.25 19.66 20.24 19.62C20.23 19.36 20.17 19.11 20.06 18.89Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M1.5 8.98V9.65C1.5 9.42 1.5 9.19 1.5 8.98Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "speed-truck": {
        defaultColors: ["#3D4C66"],
        keywords: ["delivery","truck","shipping","fast","speed","express","transport","transit","order-delivery","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00092 18.9941L2 19.0002"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 5H10C11.8856 5 12.8284 5 13.4142 5.58579C14 6.17157 14 7.11438 14 9V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 15H2M5 9H2M4 12H2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "speed-truck-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["truck","delivery","shipping","transport","order","route","transit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12L21.353 14.4383C21.654 16.561 21.8046 17.6223 21.2066 18.3112C20.6085 19 19.5365 19 17.3926 19H15.9967L14 18.9998V12.0109V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V18.9998L15.9967 19H17.3926C19.5365 19 20.6085 19 21.2066 18.3112C21.8046 17.6223 21.654 16.561 21.353 14.4383L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.24114 18.8464C3.60777 18.9968 8.07123 19.0019 9 19H14V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 15.75C3.41421 15.75 3.75 15.4142 3.75 15C3.75 14.5858 3.41421 14.25 3 14.25V15.75ZM2 14.25H1.25V15.75H2V14.25ZM5 9.75C5.41421 9.75 5.75 9.41421 5.75 9C5.75 8.58579 5.41421 8.25 5 8.25V9.75ZM2 8.25H1.25V9.75H2V8.25ZM4 12.75C4.41421 12.75 4.75 12.4142 4.75 12C4.75 11.5858 4.41421 11.25 4 11.25V12.75ZM2 11.25H1.25V12.75H2V11.25ZM3 14.25H2V15.75H3V14.25ZM5 8.25H2V9.75H5V8.25ZM4 11.25H2V12.75H4V11.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "speed-up-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["speed","performance","indicator","meter","dashboard","sales performance","transaction speed","efficiency","optimization","analytics","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.70835 18C5.04751 16.5341 4 14.3894 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.3894 18.9525 16.5341 17.2916 18"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "speed-up-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["speed","performance","increase","acceleration","optimize","dashboard","meter","sales-performance","efficiency","analytics","reporting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10L15 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.70835 18C5.04751 16.5341 4 14.3894 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.3894 18.9525 16.5341 17.2916 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "speed-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["speed","performance","meter","gauge","efficiency","optimization","processing-time","transaction-speed","faster","quick","expedited"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13C21 15.6882 19.8202 18.1021 17.9534 19.7497C17.5393 20.1152 16.9074 20.0758 16.5419 19.6617C16.1764 19.2477 16.2158 18.6157 16.6299 18.2503C18.0848 16.9661 19 15.0906 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 15.0906 5.91519 16.9661 7.37008 18.2503C7.78415 18.6157 7.82356 19.2477 7.45809 19.6617C7.09262 20.0758 6.46069 20.1152 6.04662 19.7497C4.17983 18.1021 3 15.6882 3 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.707 10.7071L14.7076 11.7065C14.895 12.0981 15 12.5368 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C12.4631 10 12.9017 10.1049 13.2933 10.2923L14.2927 9.29289C14.6833 8.90237 15.3164 8.90237 15.707 9.29289C16.0975 9.68342 16.0975 10.3166 15.707 10.7071ZM13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "speed-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["speed","performance","optimization","meter","gauge","fast","accelerate","quick","efficiency","throughput","process","timer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.70835 18C5.04751 16.5341 4 14.3894 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.3894 18.9525 16.5341 17.2916 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Spotify-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","audio","entertainment","sound","playlist","subscription","media","settings","volume","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10.7738C15.0173 9.71718 12.0421 8.02665 8 9.71718M15.1577 12.887C14.175 11.8305 11.7893 10.7739 8.42087 11.8305M14.3159 14.9998C13.3332 13.9432 11.7896 12.8866 8.42118 13.9432"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Spotify-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","playlist","entertainment","audio","streaming","soundtrack","mood","atmosphere"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 10.7738C15.0173 9.71718 12.0421 8.02665 8 9.71718M15.1577 12.887C14.175 11.8305 11.7893 10.7739 8.42087 11.8305M14.3159 14.9998C13.3332 13.9432 11.7896 12.8866 8.42118 13.9432"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Spotify-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","entertainment","radio","playlist","audio","sound","background-music","queue-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM16.5491 10.2629C15.38 9.006 12.0783 7.19852 7.71057 9.02522C7.32843 9.18505 7.14821 9.62439 7.30803 10.0065C7.46785 10.3887 7.9072 10.5689 8.28933 10.4091C12.0058 8.85471 14.6544 10.4283 15.4508 11.2845C15.7329 11.5878 16.2074 11.605 16.5107 11.3229C16.814 11.0408 16.8312 10.5662 16.5491 10.2629ZM15.7068 12.3762C14.5027 11.0816 11.8045 9.98302 8.19635 11.1148C7.80113 11.2388 7.58123 11.6597 7.7052 12.0549C7.82917 12.4501 8.25007 12.67 8.64529 12.546C11.774 11.5647 13.8471 12.5792 14.6085 13.3978C14.8906 13.7011 15.3652 13.7183 15.6685 13.4362C15.9718 13.1541 15.9889 12.6795 15.7068 12.3762ZM14.865 14.489C14.3222 13.9053 13.5784 13.273 12.4681 12.9576C11.3615 12.6432 9.97961 12.6683 8.19666 13.2276C7.80143 13.3515 7.58154 13.7724 7.70551 14.1677C7.82948 14.5629 8.25038 14.7828 8.6456 14.6588C10.2311 14.1615 11.3052 14.1866 12.0582 14.4005C12.8074 14.6133 13.3268 15.0376 13.7667 15.5106C14.0488 15.8139 14.5234 15.831 14.8267 15.5489C15.13 15.2668 15.1471 14.7923 14.865 14.489Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Spotify: {
        defaultColors: ["#3D4C66"],
        keywords: ["music","entertainment","radio","playlist","audio","sound","background-music","queue-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M16 10.7738C15.0173 9.71718 12.0421 8.02665 8 9.71718M15.1577 12.887C14.175 11.8305 11.7893 10.7739 8.42087 11.8305M14.3159 14.9998C13.3332 13.9432 11.7896 12.8866 8.42118 13.9432"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["square","block","container","section","module","tile","area","category","group","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","box","container","selection","area","layout","module","section","table","placeholder","frame"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "square-asterisk-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["asterisk","square","discount","promotion","special","offer","loyalty","rewards","points","bonus","sale","marked","flagged","important","square-asterisk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","block","shape","background","ui","tile","placeholder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-asterisk-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["asterisk","note","special","discount","promotion","important","annotation","details","more-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-asterisk-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","asterisk","discount","sale","promotion","special","offer","coupon","label","tag","mark","badge","featured"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM12 7C12.5523 7 13 7.44772 13 8V9.58579L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L14.4142 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H14.4142L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L13 14.4142V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L9.58579 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H9.58579L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L11 9.58579V8C11 7.44772 11.4477 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-asterisk": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","asterisk","snowflake","special-order","notes","additional-options","customization","edit","modify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 15L15 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-B-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["T","text","font","square","transactions","table","tip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-B-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["T","text","title","type","taxes","tab","threshold","table"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 9V15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-B-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","square","type","font","letter","T","taxes","total","tip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9461 4H12.0539C13.4126 3.99999 14.5083 3.99997 15.3874 4.0894C16.2948 4.18171 17.0817 4.3775 17.7779 4.84265C18.3238 5.20745 18.7926 5.6762 19.1573 6.22215C19.6225 6.91829 19.8183 7.70523 19.9106 8.61264C20 9.49172 20 10.5874 20 11.946V12.054C20 13.4126 20 14.5083 19.9106 15.3874C19.8183 16.2948 19.6225 17.0817 19.1573 17.7779C18.7926 18.3238 18.3238 18.7926 17.7779 19.1573C17.0817 19.6225 16.2948 19.8183 15.3874 19.9106C14.5083 20 13.4126 20 12.054 20H11.946C10.5874 20 9.49172 20 8.61264 19.9106C7.70523 19.8183 6.91829 19.6225 6.22215 19.1573C5.6762 18.7926 5.20745 18.3238 4.84265 17.7779C4.3775 17.0817 4.18171 16.2948 4.0894 15.3874C3.99997 14.5083 3.99999 13.4126 4 12.054V11.946C3.99999 10.5874 3.99997 9.49173 4.0894 8.61264C4.18171 7.70523 4.3775 6.91829 4.84265 6.22215C5.20745 5.6762 5.6762 5.20745 6.22215 4.84265C6.91829 4.3775 7.70523 4.18171 8.61264 4.0894C9.49173 3.99997 10.5874 3.99999 11.9461 4ZM8 9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V10H9C8.44772 10 8 9.55229 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-B": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","b","letter-b","item","brand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13.4746 11.8968C13.919 11.9809 14.2844 12.2063 14.5706 12.5731C14.8569 12.9398 15 13.3601 15 13.8338C15 14.2617 14.8945 14.6399 14.6836 14.9685C14.4802 15.2894 14.1827 15.5415 13.791 15.7249C13.3992 15.9083 12.936 16 12.4011 16H9V8H12.2542C12.7891 8 13.2486 8.08787 13.6328 8.26361C14.0245 8.43935 14.3183 8.68386 14.5141 8.99713C14.7175 9.31041 14.8192 9.66571 14.8192 10.063C14.8192 10.5291 14.6949 10.9188 14.4463 11.2321C14.2053 11.5454 13.8814 11.767 13.4746 11.8968ZM10.5819 11.3009H12.0282C12.4049 11.3009 12.6949 11.2168 12.8983 11.0487C13.1017 10.873 13.2034 10.6246 13.2034 10.3037C13.2034 9.98281 13.1017 9.73448 12.8983 9.55874C12.6949 9.383 12.4049 9.29513 12.0282 9.29513H10.5819V11.3009ZM12.1751 14.6934C12.5593 14.6934 12.8569 14.6017 13.0678 14.4183C13.2863 14.235 13.3955 13.9752 13.3955 13.639C13.3955 13.2951 13.2825 13.0277 13.0565 12.8367C12.8305 12.638 12.5254 12.5387 12.1412 12.5387H10.5819V14.6934H12.1751Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-bolt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["lightning","fast","power","energy","flash","charge","electricity","quick","instant","zap","bolt","square-bolt","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-bolt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["electricity","bolt","lightning","fast","quick","charge","power","energy","electric","flash","high-voltage","speed","instant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-bolt-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["lightning","bolt","fast","power","electricity","energy","speed","quick","charge","square-bolt","accelerate","square","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 13L12 8V11H15L12 16V13H9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-bolt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bolt","square","lightning","power","energy","fast","charge","electricity","quick","speed","zap","rush"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM11.0511 8.68386C11.2257 8.1599 11.792 7.87671 12.316 8.05133C12.8399 8.22594 13.1231 8.79225 12.9485 9.3162L12.3873 11H13C13.3214 11 13.6233 11.1546 13.8113 11.4153C13.9992 11.6761 14.0503 12.0114 13.9487 12.3163L12.9485 15.3163C12.7738 15.8402 12.2075 16.1234 11.6835 15.9487C11.1596 15.774 10.8765 15.2077 11.0511 14.6837L11.6125 13H11C10.6786 13 10.3767 12.8455 10.1888 12.5848C10.0008 12.324 9.94966 11.9888 10.0513 11.6839L11.0511 8.68386Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-bolt-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["bolt","lightning","electric","power","charge","fast","quick","energy","square","electric-bill","instant","flash","surge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 13L12 8V11H15L12 16V13H9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-bolt-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["lightning","bolt","fast","square","quick","energy","power","charge","express","speed","instant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 13L12 8V11H15L12 16V13H9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-bolt-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["lightning","bolt","fast","quick","charge","electricity","energy","power","speed","flash","instant","rapid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM12.2669 7.03625C12.7001 7.15623 13 7.55049 13 7.99997V9.99997H15C15.3603 9.99997 15.6927 10.1938 15.8702 10.5073C16.0477 10.8208 16.0429 11.2055 15.8575 11.5145L12.8575 16.5145C12.6262 16.8999 12.1662 17.0837 11.7331 16.9637C11.2999 16.8437 11 16.4494 11 16V14H9C8.63973 14 8.30731 13.8062 8.1298 13.4927C7.9523 13.1792 7.95715 12.7944 8.14251 12.4855L11.1425 7.48547C11.3738 7.10004 11.8338 6.91627 12.2669 7.03625Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-divide-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["divide","split","portion","share","discount","calculation","percentage","split-bill"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-bolt": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","bolt","lightning","electricity","fast","quick","speed","energy","power","charge","rapid","express","accelerate","boost","flash","thunder","zap"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-divide-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["division","divide","split","split-bill","equal","discount","percentage","ratio","math"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M15 12H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 10H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-divide": {
        defaultColors: ["#3D4C66"],
        keywords: ["divide","split","square","percentage","discount","calculation","math","split-tender","split-bill","square-divide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12.5 10H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.5 14H11.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["dollar","square","money","payment","currency","cash","sales","revenue","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17V16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-divide-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["division","divide","split","percentage","discount","price","calculation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8ZM11.5 8C10.9477 8 10.5 8.44772 10.5 9C10.5 9.55228 10.9477 10 11.5 10H12.5C13.0523 10 13.5 9.55228 13.5 9C13.5 8.44772 13.0523 8 12.5 8H11.5ZM9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9ZM11.5 14C10.9477 14 10.5 14.4477 10.5 15C10.5 15.5523 10.9477 16 11.5 16H12.5C13.0523 16 13.5 15.5523 13.5 15C13.5 14.4477 13.0523 14 12.5 14H11.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","money","currency","square","payment","cash","price","cost","finance","transaction","sales","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V11.9268V12.0732V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3H12.0732ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["dollar","square","money","payment","cash","currency","transaction","sales","finance","amount","price","value","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Download-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","square","arrow-down","import","receive","receive-stock","download-report","download-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["dollar","currency","square","payment","cash","money","transaction","sale","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17V16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Download-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["download","arrow-down","import","receive","get","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 13L14.8284 13.1716C13.4951 14.5049 12.8284 15.1716 12 15.1716C11.1716 15.1716 10.5049 14.5049 9.17157 13.1716L9 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Download-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow-down","import","receive","load","square","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8L11 13.5556C10.7032 13.2876 10.3471 12.9329 9.87868 12.4645L9.70711 12.2929C9.31658 11.9024 8.68342 11.9024 8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071L8.51101 13.9252C9.13782 14.5521 9.67789 15.0922 10.1685 15.4666C10.6944 15.8678 11.2792 16.1716 12 16.1716C12.7208 16.1716 13.3056 15.8678 13.8315 15.4666C14.3221 15.0922 14.8622 14.5521 15.489 13.9252L15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929C15.3166 11.9024 14.6834 11.9024 14.2929 12.2929L14.1213 12.4645C13.6529 12.9328 13.2968 13.2876 13 13.5556L13 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-Download": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","arrow-down","import","receive","get","data","order-in","inventory-in","square","file-download","receive-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 13L10.5858 14.5858C11.2525 15.2525 11.5858 15.5858 12 15.5858C12.4142 15.5858 12.7475 15.2525 13.4142 14.5858L15 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15L12 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-heartbeat-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["heartbeat","signal","monitoring","health","pulse","status","activity","real-time","data-stream","metrics","performance","alerts","system-status","tracking"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H14L13 10L11 14L10 12H8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-heartbeat": {
        defaultColors: ["#3D4C66"],
        keywords: ["graph","square","statistics","sales-report","performance","analytics","metrics","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H14L13 10L11 14L10 12H8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-heartbeat-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["heartbeat","pulse","monitoring","activity","trend","statistics","vital-signs","health","activity-log","sales-trend","metrics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H9.38197L10.1056 14.4472C10.275 14.786 10.6212 15 11 15C11.3788 15 11.725 14.786 11.8944 14.4472L13 12.2361L13.1056 12.4472C13.275 12.786 13.6212 13 14 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H14.618L13.8944 9.55279C13.725 9.214 13.3788 9 13 9C12.6212 9 12.275 9.214 12.1056 9.55279L11 11.7639L10.8944 11.5528C10.725 11.214 10.3788 11 10 11H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-heartbeat-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["report","sales-report","analytics","performance","heartbeat","pulse","trend","metric","sales","dashboard","monitoring"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12H14L13 10L11 14L10 12H8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-info-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["info","information","details","square","help","question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-info-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["info","information","details","description","about","help","support","square","square-info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-info-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["information","info","details","help","question","support","square","about","hint","explanation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 11C12.5523 11 13 11.4477 13 12V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V12C11 11.4477 11.4477 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-info": {
        defaultColors: ["#3D4C66"],
        keywords: ["info","information","details","help","square","order-details","item-details","product-information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 12L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 9V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["remove","delete","subtract","quantity","decrease","box","order","discount","reduce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","minus","subtract","remove","decrease","discount","reduction","delete","quantity","remove-item","decrease-quantity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["square","minus","subtract","remove","delete","quantity","decrease","reduction","discount","square-minus","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","minus","subtract","remove","decrease","delete","reduce","discount","less","quantity","item","order","void","square-minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-music-list-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","playlist","song","audio","entertainment","background-music","queue","menu","select-music","jukebox"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13.5V9L16 10M15 13.5C15 12.6839 14.3336 12.0175 13.5 12C12.6664 12.0175 12 12.6839 12 13.5C12 14.3161 12.6664 14.9825 13.5 15C14.3336 14.9825 15 14.3161 15 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H10M8 15H9M8 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-list-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","list","playlist","entertainment","audio","song","queue","jukebox","background-music","ambience"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M15 13.5V9V13.5Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.5 15C12.6664 14.9825 12 14.3161 12 13.5C12 12.6839 12.6664 12.0175 13.5 12C14.3336 12.0175 15 12.6839 15 13.5C15 14.3161 14.3336 14.9825 13.5 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M15 13.5V9L16 10M15 13.5C15 12.6839 14.3336 12.0175 13.5 12C12.6664 12.0175 12 12.6839 12 13.5C12 14.3161 12.6664 14.9825 13.5 15C14.3336 14.9825 15 14.3161 15 13.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H10M8 15H9M8 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","song","list","playlist","menu","entertainment","audio","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 13.5C14 13.25 13.8 13.02 13.5 13C13.2 13.02 13 13.25 13 13.5C13 13.75 13.2 13.98 13.5 14C13.8 13.98 14 13.75 14 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11875C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.4587 20 9.57531 20 10.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57531 20 8.4587 20.0001 7.57494 19.8813C6.64711 19.7565 5.82768 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11875 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.4587 4.11875 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17158C5.82768 4.51547 6.64711 4.2435 7.57494 4.11875C8.4587 3.99994 9.57531 3.99997 10.9294 4ZM14.6173 8.07612C14.991 7.92134 15.4211 8.0069 15.7071 8.29289L16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071C16.5118 10.9024 16.2559 11 16 11V13.5C16 14.8797 14.8789 15.9712 13.521 15.9998C13.507 16.0001 13.493 16.0001 13.479 15.9998C12.1211 15.9712 11 14.8797 11 13.5C11 12.1203 12.1211 11.0288 13.479 11.0002C13.493 10.9999 13.507 10.9999 13.521 11.0002C13.6846 11.0037 13.8448 11.0225 14 11.0555V9C14 8.59554 14.2436 8.2309 14.6173 8.07612ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H9C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8H8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H8ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H9C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-music-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","playlist","entertainment","queue","sound","audio","background-music","ambiance","mood","square","list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13.5V9L16 10M15 13.5C15 12.6839 14.3336 12.0175 13.5 12C12.6664 12.0175 12 12.6839 12 13.5C12 14.3161 12.6664 14.9825 13.5 15C14.3336 14.9825 15 14.3161 15 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 12H10M8 15H9M8 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-note-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["music","note","song","playlist","sound","entertainment","background-music","select-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 13.5V9V13.5Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 15C10.6664 14.9825 10 14.3161 10 13.5C10 12.6839 10.6664 12.0175 11.5 12C12.3336 12.0175 13 12.6839 13 13.5C13 14.3161 12.3336 14.9825 11.5 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-note-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["music","note","square","background-music","entertainment","ambiance","audio","playlist","volume","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-note-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","entertainment","audio","ambiance","mood","playlist","background-music","jingle","sound","sound-effects"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM13.7071 8.29292C13.4211 8.00693 12.991 7.92137 12.6173 8.07615C12.2436 8.23093 12 8.59557 12 9.00003V11.0555C11.8448 11.0226 11.6846 11.0037 11.521 11.0003C11.507 11 11.493 11 11.479 11.0003C10.1211 11.0288 9 12.1204 9 13.5C9 14.8797 10.1211 15.9713 11.479 15.9998C11.493 16.0001 11.507 16.0001 11.521 15.9998C12.8789 15.9713 14 14.8797 14 13.5V11C14.2559 11 14.5118 10.9024 14.7071 10.7071C15.0976 10.3166 15.0976 9.68345 14.7071 9.29292L13.7071 8.29292Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-play-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["play","square","start","resume","process","playback","begin","customer-display","media","video","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.295 8.63037C11.7069 8.69179 12.2179 9.01119 13.24 9.64999C14.1611 10.2257 14.6217 10.5135 14.852 10.8349C15.3512 11.5314 15.3512 12.4686 14.852 13.1651C14.6217 13.4865 14.1611 13.7743 13.24 14.35L13.24 14.35C12.2179 14.9888 11.7069 15.3082 11.295 15.3696C10.4002 15.5031 9.52729 15.0192 9.16621 14.1898C9 13.8079 9 13.2053 9 12L9 12C9 10.7947 9 10.1921 9.16621 9.81024C9.52729 8.98075 10.4002 8.49694 11.295 8.63037Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-music-note": {
        defaultColors: ["#3D4C66"],
        keywords: ["music","entertainment","mood","background-music","selection","playlist","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13.5V9L14 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-play-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["play","play-button","media","start","resume","transaction","payment","execute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.295 8.63037C11.7069 8.69179 12.2179 9.01119 13.24 9.64999C14.1611 10.2257 14.6217 10.5135 14.852 10.8349C15.3512 11.5314 15.3512 12.4686 14.852 13.1651C14.6217 13.4865 14.1611 13.7743 13.24 14.35L13.24 14.35C12.2179 14.9888 11.7069 15.3082 11.295 15.3696C10.4002 15.5031 9.52729 15.0192 9.16621 14.1898C9 13.8079 9 13.2053 9 12L9 12C9 10.7947 9 10.1921 9.16621 9.81024C9.52729 8.98075 10.4002 8.49694 11.295 8.63037Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["square","plus","add","create","new","item","add-item","new-item","increase","quantity","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-play": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","media","video","start","run","launch","begin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.295 8.63037C11.7069 8.69179 12.2179 9.01119 13.24 9.64999C14.1611 10.2257 14.6217 10.5135 14.852 10.8349C15.3512 11.5314 15.3512 12.4686 14.852 13.1651C14.6217 13.4865 14.1611 13.7743 13.24 14.35L13.24 14.35C12.2179 14.9888 11.7069 15.3082 11.295 15.3696C10.4002 15.5031 9.52729 15.0192 9.16621 14.1898C9 13.8079 9 13.2053 9 12L9 12C9 10.7947 9 10.1921 9.16621 9.81024C9.52729 8.98075 10.4002 8.49694 11.295 8.63037Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","plus","add","create","new","item","add-item","new-item","addition","add-new"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8ZM12 9C12.5523 9 13 9.44772 13 10V11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H11V10C11 9.44772 11.4477 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","plus","add","new","create","item","add-item","new-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-play-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","start","resume","video","media","square-play","action","trigger"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V13.0706V10.9294V10.9294C3.99997 9.57527 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57531 3.99997 10.9294 4H10.9294ZM15.4538 10.4082C15.247 10.1379 14.9739 9.92934 14.6948 9.74361C14.4192 9.5602 14.0628 9.35155 13.6362 9.10188L13.6362 9.10186L13.5853 9.07204C13.1103 8.79401 12.7171 8.56385 12.393 8.39834C12.0689 8.23284 11.7221 8.08233 11.3477 8.03004C10.0425 7.84775 8.76917 8.50875 8.24246 9.642C8.09139 9.96703 8.04386 10.3222 8.02192 10.6674C7.99999 11.0126 7.99999 11.4468 8 11.9714V12.0285C7.99999 12.5532 7.99999 12.9874 8.02192 13.3326C8.04386 13.6778 8.09139 14.033 8.24246 14.358C8.76917 15.4913 10.0425 16.1523 11.3477 15.97C11.7221 15.9177 12.0689 15.7672 12.393 15.6017C12.7172 15.4361 13.1104 15.206 13.5853 14.9279L13.6362 14.8981C14.0628 14.6484 14.4192 14.4398 14.6948 14.2564C14.9739 14.0707 15.247 13.8621 15.4538 13.5918C16.1821 12.6402 16.1821 11.3598 15.4538 10.4082Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-plus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["add","plus","create","new","item","square","increase","add-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 10V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 12L14 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-poll-bottom-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["graph","chart","bar-chart","analytics","statistics","sales","performance","data","insights","reporting","trends","metrics","square","square-chart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-poll-bottom-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["graph","bars","chart","statistics","analytics","report","sales","performance","trends","data","analysis","metrics","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M9 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-poll-bottom-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","graph","poll","bottom","report","analytics","sales","statistics","dashboard","performance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM10 11C10 10.4477 9.55229 10 9 10C8.44772 10 8 10.4477 8 11V15C8 15.5523 8.44772 16 9 16C9.55229 16 10 15.5523 10 15V11ZM12 8C12.5523 8 13 8.44772 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.44772 11.4477 8 12 8ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-poll-horizontal-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["list","order-list","options","settings","menu","reports","data","statistics","sort","filter"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-poll-bottom": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","poll","bottom","graph","bar-chart","statistics","sales","trends","analysis","performance","metrics","data","report","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M9 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15V9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-poll-horizontal": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","inventory","reports","settings","square","poll","horizontal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-poll-left-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["list","order-list","details","description","options","menu","items","inventory","report","square","poll"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-poll-horizontal-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","options","menu","settings","configuration","filter","sort","manage","horizontal-lines","order-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 12H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 15H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9H9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-poll-horizontal-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["report","reports","list","inventory","horizontal-lines","menu","options","settings","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H9ZM8 15C8 14.4477 8.44772 14 9 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9C8.44772 16 8 15.5523 8 15ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55229 8.44772 10 9 10H15C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-poll-left-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["list","details","menu","options","settings","configuration","summary","report","record","history","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-poll-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","menu","options","settings","report","details","square","document","summary","order-summary","transaction-details","sales-report"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 3H14.0706C15.4247 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.45869 21 8.5753 21 9.9294V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57535 21 7.45869 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57531 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57535 2.99997 9.92943 3ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8ZM7 9C7 8.44772 7.44772 8 8 8H11C11.5523 8 12 8.44772 12 9C12 9.55229 11.5523 10 11 10H8C7.44772 10 7 9.55229 7 9ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-question-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["question","help","support","faq","unknown","query","assistance","information","customer-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-poll-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["list","order-list","details","description","menu","report","summary","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12L16 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-question-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","faq","unknown","query","information","assistance","troubleshooting","square","contextual-help","settings-help","item-search-help","payment-help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 3.25C5.37665 3.25 3.25 5.37665 3.25 8V16C3.25 18.6234 5.37665 20.75 8 20.75H16C18.6234 20.75 20.75 18.6234 20.75 16V8C20.75 5.37665 18.6234 3.25 16 3.25H8ZM12 9C11.3096 9 10.75 9.55964 10.75 10.25C10.75 10.6642 10.4142 11 10 11C9.58579 11 9.25 10.6642 9.25 10.25C9.25 8.73122 10.4812 7.5 12 7.5C13.5188 7.5 14.75 8.73122 14.75 10.25C14.75 11.5088 13.9043 12.57 12.75 12.8965V13.25C12.75 13.6642 12.4142 14 12 14C11.5858 14 11.25 13.6642 11.25 13.25V12.25C11.25 11.8358 11.5858 11.5 12 11.5C12.6904 11.5 13.25 10.9404 13.25 10.25C13.25 9.55964 12.6904 9 12 9ZM12.75 15.5C12.75 15.0858 12.4142 14.75 12 14.75C11.5858 14.75 11.25 15.0858 11.25 15.5V15.75C11.25 16.1642 11.5858 16.5 12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75V15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-question-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["help","question","support","faq","information","query","assistance","square-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V14C4 16.8284 4 18.2426 4.87868 19.1213C5.75736 20 7.17157 20 10 20H14C16.8284 20 18.2426 20 19.1213 19.1213C20 18.2426 20 16.8284 20 14V12V10C20 7.17157 20 5.75736 19.1213 4.87868C18.2426 4 16.8284 4 14 4H10C7.17157 4 5.75736 4 4.87868 4.87868C4 5.75736 4 7.17157 4 10V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-question": {
        defaultColors: ["#3D4C66"],
        keywords: ["question","help","support","information","faq","square-question"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "square-share-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["share","social","network","connections","send","export","transfer","integrate","referral","social-media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="14.5"
                    cy="8.5"
                    r="1.5"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 11L13 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="1.5"
                    cy="1.5"
                    r="1.5"
                    transform="matrix(1 0 0 -1 13 17)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L13 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "square-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","network","connections","send","export","distribute","link"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V11.9268V12.0732V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3H12.0732ZM13.75 8.5C13.75 8.08579 14.0858 7.75 14.5 7.75C14.9142 7.75 15.25 8.08579 15.25 8.5C15.25 8.91421 14.9142 9.25 14.5 9.25C14.0858 9.25 13.75 8.91421 13.75 8.5ZM14.5 6.25C13.2574 6.25 12.25 7.25736 12.25 8.5C12.25 8.5613 12.2525 8.62202 12.2573 8.68208L11.3409 9.59848C10.9442 9.37652 10.4869 9.25 10 9.25C8.48122 9.25 7.25 10.4812 7.25 12C7.25 13.5188 8.48122 14.75 10 14.75C10.4869 14.75 10.9442 14.6235 11.3409 14.4015L12.2573 15.3179C12.2525 15.378 12.25 15.4387 12.25 15.5C12.25 16.7426 13.2574 17.75 14.5 17.75C15.7426 17.75 16.75 16.7426 16.75 15.5C16.75 14.2574 15.7426 13.25 14.5 13.25C13.8941 13.25 13.3442 13.4895 12.9396 13.879L12.4015 13.3409C12.6235 12.9442 12.75 12.4869 12.75 12C12.75 11.5131 12.6235 11.0558 12.4015 10.6591L12.9396 10.121C13.3442 10.5105 13.8941 10.75 14.5 10.75C15.7426 10.75 16.75 9.74264 16.75 8.5C16.75 7.25736 15.7426 6.25 14.5 6.25ZM8.75 12C8.75 11.3096 9.30964 10.75 10 10.75C10.6904 10.75 11.25 11.3096 11.25 12C11.25 12.6904 10.6904 13.25 10 13.25C9.30964 13.25 8.75 12.6904 8.75 12ZM13.75 15.5C13.75 15.0858 14.0858 14.75 14.5 14.75C14.9142 14.75 15.25 15.0858 15.25 15.5C15.25 15.9142 14.9142 16.25 14.5 16.25C14.0858 16.25 13.75 15.9142 13.75 15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-share-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["share","network","connections","social","media","export","send","square","square-share","link","affiliate","referral"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14.5" cy="8.5" r="1.5" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path d="M11 11L13 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <circle
                    cx="1.5"
                    cy="1.5"
                    r="1.5"
                    transform="matrix(1 0 0 -1 13 17)"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L13 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="10" cy="12" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "square-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","network","connections","data","export","transfer","send","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="14.5" cy="8.5" r="1.5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 11L13 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle
                    cx="1.5"
                    cy="1.5"
                    r="1.5"
                    transform="matrix(1 0 0 -1 13 17)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 13L13 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "square-sliders-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","sliders","adjust","filters","configurations","preferences","controls","options","modify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M8 14H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 10H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 13L10 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-sliders-vertical-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sliders","adjust","settings","preferences","filter","sort","order","configuration","customization","tune"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 8L10 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L14 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 10H9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-sliders-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","adjust","preferences","filter","slider","square","options","configuration","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 14H16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 10H16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 13L10 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-sliders-vertical-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","adjust","sliders","filter","preferences","options","controls","configuration","customize","equalizer","fine-tune"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57535 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57527 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 9.57535 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM10.5 8C10.5 7.44772 10.0523 7 9.5 7C8.94772 7 8.5 7.44772 8.5 8V9C7.94772 9 7.5 9.44772 7.5 10C7.5 10.5523 7.94772 11 8.5 11L8.5 16C8.5 16.5523 8.94772 17 9.5 17C10.0523 17 10.5 16.5523 10.5 16L10.5 11C11.0523 11 11.5 10.5523 11.5 10C11.5 9.44772 11.0523 9 10.5 9V8ZM13.5 16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16V15C16.0523 15 16.5 14.5523 16.5 14C16.5 13.4477 16.0523 13 15.5 13V8C15.5 7.44772 15.0523 7 14.5 7C13.9477 7 13.5 7.44772 13.5 8V13C12.9477 13 12.5 13.4477 12.5 14C12.5 14.5523 12.9477 15 13.5 15V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-sliders-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","sliders","adjust","filter","configure","options","preferences","customize","controls","setup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 13.0706V10.9294C20 9.57535 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4L10.9294 4C9.57535 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57527 4 10.9294L4 13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706ZM16 10.5C16.5523 10.5 17 10.0523 17 9.5C17 8.94772 16.5523 8.5 16 8.5H15C15 7.94772 14.5523 7.5 14 7.5C13.4477 7.5 13 7.94772 13 8.5L8.00001 8.5C7.44772 8.5 7.00001 8.94772 7.00001 9.5C7.00001 10.0523 7.44772 10.5 8.00001 10.5L13 10.5C13 11.0523 13.4477 11.5 14 11.5C14.5523 11.5 15 11.0523 15 10.5H16ZM8.00001 13.5C7.44772 13.5 7.00001 13.9477 7.00001 14.5C7.00001 15.0523 7.44772 15.5 8.00001 15.5H9.00001C9.00001 16.0523 9.44772 16.5 10 16.5C10.5523 16.5 11 16.0523 11 15.5H16C16.5523 15.5 17 15.0523 17 14.5C17 13.9477 16.5523 13.5 16 13.5H11C11 12.9477 10.5523 12.5 10 12.5C9.44772 12.5 9.00001 12.9477 9.00001 13.5H8.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-sliders-vertical-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","sliders","adjust","filter","options","preferences","configuration","controls","adjustments","sort","sort-by","reorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 8L10 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L14 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 10H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-stop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["stop","pause","end","square","block","halt","cancel","suspend","interrupt","standstill","terminal","cutoff","shutdown"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-sliders": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","adjust","filters","preferences","configuration","options","sliders","customize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 14H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 10H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 13L10 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-sliders-vertical": {
        defaultColors: ["#3D4C66"],
        keywords: ["filter","adjust","settings","options","sort","order","price-range","sliders"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 8L10 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 8L14 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 10H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Square-stop-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["stop","square","block","halt","cancel","pause","end","complete","suspend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Square-stop": {
        defaultColors: ["#3D4C66"],
        keywords: ["stop","square","pause","end","cancel","block","halt","restriction","terminate","cutoff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8478 10.2346C15 10.6022 15 11.0681 15 12C15 12.9319 15 13.3978 14.8478 13.7654C14.6448 14.2554 14.2554 14.6448 13.7654 14.8478C13.3978 15 12.9319 15 12 15C11.0681 15 10.6022 15 10.2346 14.8478C9.74458 14.6448 9.35523 14.2554 9.15224 13.7654C9 13.3978 9 12.9319 9 12C9 11.0681 9 10.6022 9.15224 10.2346C9.35523 9.74458 9.74458 9.35523 10.2346 9.15224C10.6022 9 11.0681 9 12 9C12.9319 9 13.3978 9 13.7654 9.15224C14.2554 9.35523 14.6448 9.74458 14.8478 10.2346Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "square-sun-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sun","brightness","day","light","square","display-mode","theme","weather","intensity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12L7 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L16 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L16 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15L16 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L8 16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-stop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["stop","block","square","cancel","pause","hold","suspend","interrupt","void","inactive","disabled","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V13.0706V10.9294V10.9294C3.99997 9.57527 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57531 3.99997 10.9294 4H10.9294ZM11.968 8H12.032H12.032C12.4706 7.99999 12.8491 7.99998 13.1624 8.02135C13.4922 8.04386 13.8221 8.09336 14.1481 8.22836C14.8831 8.53285 15.4672 9.11687 15.7716 9.85195C15.9066 10.1779 15.9561 10.5078 15.9787 10.8376C16 11.1509 16 11.5294 16 11.968V12.032C16 12.4706 16 12.8491 15.9787 13.1624C15.9561 13.4922 15.9066 13.8221 15.7716 14.1481C15.4672 14.8831 14.8831 15.4672 14.1481 15.7716C13.8221 15.9066 13.4922 15.9561 13.1624 15.9787C12.8491 16 12.4706 16 12.032 16H11.968C11.5294 16 11.1509 16 10.8376 15.9787C10.5078 15.9561 10.1779 15.9066 9.85195 15.7716C9.11687 15.4672 8.53285 14.8831 8.22836 14.1481C8.09336 13.8221 8.04386 13.4922 8.02135 13.1624C7.99998 12.8491 7.99999 12.4706 8 12.032V12.032V11.968V11.968C7.99999 11.5293 7.99998 11.1509 8.02135 10.8376C8.04386 10.5078 8.09336 10.1779 8.22836 9.85195C8.53285 9.11687 9.11687 8.53285 9.85195 8.22836C10.1779 8.09336 10.5078 8.04386 10.8376 8.02135C11.1509 7.99998 11.5294 7.99999 11.968 8H11.968Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "square-sun-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sun","brightness","day","light","mode","sunny","weather","display","settings","theme","day-mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12L7 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L16 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L16 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15L16 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L8 16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-sun-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sun","brightness","display","screen","mode","settings","day","daytime","light","adjust"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V8C12.75 8.41421 12.4142 8.75 12 8.75C11.5858 8.75 11.25 8.41421 11.25 8V7C11.25 6.58579 11.5858 6.25 12 6.25ZM12 9.25C10.4812 9.25 9.25 10.4812 9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C12.7592 14.75 13.4477 14.4414 13.9445 13.9445C14.4414 13.4477 14.75 12.7592 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25ZM7 11.25H8C8.41421 11.25 8.75 11.5858 8.75 12C8.75 12.4142 8.41421 12.75 8 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.5858 6.58579 11.25 7 11.25ZM16 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H16C15.5858 12.75 15.25 12.4142 15.25 12C15.25 11.5858 15.5858 11.25 16 11.25ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L9.53033 8.46967C9.82322 8.76256 9.82322 9.23744 9.53033 9.53033C9.23744 9.82322 8.76256 9.82322 8.46967 9.53033L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967ZM16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L15.5303 9.53033C15.2374 9.82322 14.7626 9.82322 14.4697 9.53033C14.1768 9.23744 14.1768 8.76256 14.4697 8.46967L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967ZM12.75 16V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V16C11.25 15.5858 11.5858 15.25 12 15.25C12.4142 15.25 12.75 15.5858 12.75 16ZM14.4697 14.4697C14.7626 14.1768 15.2374 14.1768 15.5303 14.4697L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L14.4697 15.5303C14.1768 15.2374 14.1768 14.7626 14.4697 14.4697ZM9.53033 14.4697C9.82322 14.7626 9.82322 15.2374 9.53033 15.5303L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L8.46967 14.4697C8.76256 14.1768 9.23744 14.1768 9.53033 14.4697Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-T-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["T","text","type","font","transaction","table","tab"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-sun": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","sun","brightness","display","settings","daylight","theme","mode","toggle","square-sun"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 12C10 13.1046 10.8954 14 12 14C12.5523 14 13.0523 13.7761 13.4142 13.4142C13.7761 13.0523 14 12.5523 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 8V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L8 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L16 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15L16 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 15L8 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-T-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["T","square","text","transaction","tip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 9V15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-T": {
        defaultColors: ["#3D4C66"],
        keywords: ["T","text","square","table","transaction","type","tab"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Text-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["text","note","description","receipt","information","edit","format","type","font","details","add-note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 17.2223C19 16.2134 19 14.8089 19 12C19 9.19108 19 7.78661 18.3259 6.77772C18.034 6.34096 17.659 5.96596 17.2223 5.67412C16.2134 5 14.8089 5 12 5C9.19108 5 7.78661 5 6.77772 5.67412C6.34096 5.96596 5.96596 6.34096 5.67412 6.77772C5 7.78661 5 9.19108 5 12C5 14.8089 5 16.2134 5.67412 17.2223C5.96596 17.659 6.34096 18.034 6.77772 18.3259C7.78661 19 9.19108 19 12 19C14.8089 19 16.2134 19 17.2223 18.3259C17.659 18.034 18.034 17.659 18.3259 17.2223Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V9M12 15H10.5M12 15H13.5M12 9H9V10.3333M12 9H15V10.3333"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-Text-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","note","description","edit","add-note","add-description","information","square"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15V9M12 15H11M12 15H13M12 9H9V10M12 9H15V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-Text-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["text","notes","descriptions","edit","details","letter","type","add-note","add-description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15V9M12 15H11M12 15H13M12 9H9V10M12 9H15V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-Text-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","edit","description","note","comments","customize","label","information","square","font"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM9 8C8.44772 8 8 8.44772 8 9V10C8 10.5523 8.44772 11 9 11C9.55229 11 10 10.5523 10 10H11V14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14V10H14C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10V9C16 8.44772 15.5523 8 15 8H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-T-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","T","letter","text","transaction","type","font","style"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9461 4H12.0539C13.4126 3.99999 14.5083 3.99997 15.3874 4.0894C16.2948 4.18171 17.0817 4.3775 17.7779 4.84265C18.3238 5.20745 18.7926 5.6762 19.1573 6.22215C19.6225 6.91829 19.8183 7.70523 19.9106 8.61264C20 9.49172 20 10.5874 20 11.946V12.054C20 13.4126 20 14.5083 19.9106 15.3874C19.8183 16.2948 19.6225 17.0817 19.1573 17.7779C18.7926 18.3238 18.3238 18.7926 17.7779 19.1573C17.0817 19.6225 16.2948 19.8183 15.3874 19.9106C14.5083 20 13.4126 20 12.054 20H11.946C10.5874 20 9.49172 20 8.61264 19.9106C7.70523 19.8183 6.91829 19.6225 6.22215 19.1573C5.6762 18.7926 5.20745 18.3238 4.84265 17.7779C4.3775 17.0817 4.18171 16.2948 4.0894 15.3874C3.99997 14.5083 3.99999 13.4126 4 12.054V11.946C3.99999 10.5874 3.99997 9.49173 4.0894 8.61264C4.18171 7.70523 4.3775 6.91829 4.84265 6.22215C5.20745 5.6762 5.6762 5.20745 6.22215 4.84265C6.91829 4.3775 7.70523 4.18171 8.61264 4.0894C9.49173 3.99997 10.5874 3.99999 11.9461 4ZM8 9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V10H9C8.44772 10 8 9.55229 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-Text-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","square","note","edit","description","add-note","add-description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9461 4H12.0539C13.4126 3.99999 14.5083 3.99997 15.3874 4.0894C16.2948 4.18171 17.0817 4.3775 17.7779 4.84265C18.3238 5.20745 18.7926 5.6762 19.1573 6.22215C19.6225 6.91829 19.8183 7.70523 19.9106 8.61265C20 9.49173 20 10.5874 20 11.946V12.054C20 13.4126 20 14.5083 19.9106 15.3874C19.8183 16.2948 19.6225 17.0817 19.1573 17.7779C18.7926 18.3238 18.3238 18.7926 17.7779 19.1573C17.0817 19.6225 16.2948 19.8183 15.3874 19.9106C14.5083 20 13.4126 20 12.054 20H11.946C10.5874 20 9.49173 20 8.61265 19.9106C7.70523 19.8183 6.91829 19.6225 6.22215 19.1573C5.6762 18.7926 5.20745 18.3238 4.84265 17.7779C4.37751 17.0817 4.18171 16.2948 4.0894 15.3874C3.99997 14.5083 3.99999 13.4126 4 12.054V11.946C3.99999 10.5874 3.99997 9.49173 4.0894 8.61265C4.18171 7.70523 4.37751 6.91829 4.84265 6.22215C5.20745 5.6762 5.6762 5.20745 6.22215 4.84265C6.9183 4.3775 7.70523 4.18171 8.61265 4.0894C9.49173 3.99997 10.5874 3.99999 11.9461 4ZM9 8C8.44772 8 8 8.44772 8 9V10.3333C8 10.8856 8.44772 11.3333 9 11.3333C9.55229 11.3333 10 10.8856 10 10.3333V10H11V14H10.5C9.94772 14 9.5 14.4477 9.5 15C9.5 15.5523 9.94772 16 10.5 16H13.5C14.0523 16 14.5 15.5523 14.5 15C14.5 14.4477 14.0523 14 13.5 14H13V10H14V10.3333C14 10.8856 14.4477 11.3333 15 11.3333C15.5523 11.3333 16 10.8856 16 10.3333V9C16 8.44772 15.5523 8 15 8H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-Text-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["text","T","item-description","tax","tip","total","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 9V15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Text-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","t","square","edit","type","typography","font","format","description","details","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Text-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","T","notes","receipt","description","transaction-details","info"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM8 9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V10H9C8.44772 10 8 9.55229 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-Text-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","square","T","type","letter","font","transaction","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M12 9V15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9H9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-Text-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","description","notes","edit-text","input","comments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 17.2223C19 16.2134 19 14.8089 19 12C19 9.19108 19 7.78661 18.3259 6.77772C18.034 6.34096 17.659 5.96596 17.2223 5.67412C16.2134 5 14.8089 5 12 5C9.19108 5 7.78661 5 6.77772 5.67412C6.34096 5.96596 5.96596 6.34096 5.67412 6.77772C5 7.78661 5 9.19108 5 12C5 14.8089 5 16.2134 5.67412 17.2223C5.96596 17.659 6.34096 18.034 6.77772 18.3259C7.78661 19 9.19108 19 12 19C14.8089 19 16.2134 19 17.2223 18.3259C17.659 18.034 18.034 17.659 18.3259 17.2223Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V9M12 15H10.5M12 15H13.5M12 9H9V10.3333M12 9H15V10.3333"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-Text": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","notes","description","edit-text","add-note","details","info","additional-info","comment","customer-notes","order-notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 15V9M12 15H11M12 15H13M12 9H9V10M12 9H15V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-Text-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","square","edit","description","notes","add-notes","update-notes","add-description","edit-description"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3259 17.2223C19 16.2134 19 14.8089 19 12C19 9.19108 19 7.78661 18.3259 6.77772C18.034 6.34096 17.659 5.96596 17.2223 5.67412C16.2134 5 14.8089 5 12 5C9.19108 5 7.78661 5 6.77772 5.67412C6.34096 5.96596 5.96596 6.34096 5.67412 6.77772C5 7.78661 5 9.19108 5 12C5 14.8089 5 16.2134 5.67412 17.2223C5.96596 17.659 6.34096 18.034 6.77772 18.3259C7.78661 19 9.19108 19 12 19C14.8089 19 16.2134 19 17.2223 18.3259C17.659 18.034 18.034 17.659 18.3259 17.2223Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 15V9M12 15H10.5M12 15H13.5M12 9H9V10.3333M12 9H15V10.3333"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Square-U-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["square","u","letter","coupon","loyalty","discount","user","profile","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 9V12C9 13.6569 10.3431 15 12 15V15C13.6569 15 15 13.6569 15 12V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Square-U-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","u","alphabet","letter","unknown","undefined","user","loyalty","rewards"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V13.0707C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.5413 20.0001 14.4247 20 13.0706 20H10.9294C9.57527 20 8.45868 20.0001 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM10 9C10 8.44772 9.55229 8 9 8C8.44772 8 8 8.44772 8 9V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9V12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Square-U": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","u-shape","rounded","discount","loyalty","upsell","unite","underline","update","unlock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="14" height="14" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 9V12C9 13.6569 10.3431 15 12 15V15C13.6569 15 15 13.6569 15 12V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "square-xmark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["cancel","close","remove","delete","error","incorrect","void","square","x","mark","item-removal","order-cancellation","reject"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Square-U-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["U","letter","square","sales","user","profile","unique","units"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="5"
                    y="5"
                    width="14"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 9V12C9 13.6569 10.3431 15 12 15V15C13.6569 15 15 13.6569 15 12V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "square-xmark-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["square","x","x-mark","remove","delete","cancel","close","error","reject","void","clear","quit","exit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-xmark": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","close","error","square","x","xmark","void","item-void","transaction-cancel","order-cancel","payment-cancel","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V12V8C20 5.79086 18.2091 4 16 4H8C5.79086 4 4 5.79086 4 8V12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M10 14L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L10 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "square-xmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","square","x","close","clear","void","discard","exit","decline","undo"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8ZM14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L13.4142 12L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L12 13.4142L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L10.5858 12L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L12 10.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "squrae-check-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["check","checkmark","square","complete","done","valid","approve","approved","confirmation","confirm","completed","verified","success","tick","okay","payment-received","order-confirmation","order-complete","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    square: {
        defaultColors: ["#3D4C66"],
        keywords: ["check","checkmark","square","complete","done","valid","approve","approved","confirmation","confirm","completed","verified","success","tick","okay","payment-received","order-confirmation","order-complete","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "squrae-check-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","check","checkmark","complete","confirm","validate","approved","accept","payment-received","order-complete","transaction-complete","verified","confirmed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "squrae-check-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["check","checkmark","square","confirmation","validate","approve","success","complete","finished","verified","ok","payment-received","order-complete","transaction-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "squrae-check": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","check","checkmark","validate","confirm","approve","complete","select","choice","ok","success","valid","accept","order-complete","payment-received","transaction-complete","inventory-check","stock-check","delivery-confirmation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 12L11 14L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "stackshare-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["share","network","connection","link","branch","sales-channel","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7H13L11 12L13 17H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.89543 15.8954 5 17 5C18.1046 5 19 5.89543 19 7C19 8.10457 18.1046 9 17 9C15.8954 9 15 8.10457 15 7Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "stackshare-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["share","connection","network","distribute","split","branch","link","connect","relations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7H13L11 12L13 17H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.89543 15.8954 5 17 5C18.1046 5 19 5.89543 19 7C19 8.10457 18.1046 9 17 9C15.8954 9 15 8.10457 15 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    stackshare: {
        defaultColors: ["#3D4C66"],
        keywords: ["share","connection","network","distribute","split","branch","link","connect","relations"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12L11 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 7C15 5.89543 15.8954 5 17 5C18.1046 5 19 5.89543 19 7C19 8.10457 18.1046 9 17 9C15.8954 9 15 8.10457 15 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 7H13L11 12L13 17H15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "steering-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["steering","wheel","navigation","driving","direction","delivery","route","select-route","driver","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C12 15.5817 8.41828 12 4 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 20C12 15.5817 15.5817 12 20 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "stackshare-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","social","network","connection","connected","collaborate","collaboration","send","transfer","forward","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6769 8H14.1707C14.5825 9.16519 15.6938 10 17 10C18.6569 10 20 8.65685 20 7C20 5.34315 18.6569 4 17 4C15.6938 4 14.5825 4.83481 14.1707 6H12.3229L10.3229 11H9.82929C9.41746 9.83481 8.30622 9 7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15C8.30622 15 9.41746 14.1652 9.82929 13H10.3229L12.3229 18H14.1707C14.5825 19.1652 15.6938 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.6938 14 14.5825 14.8348 14.1707 16H13.6769L12.0769 12L13.6769 8ZM17 6C16.4477 6 16 6.44772 16 7C16 7.55228 16.4477 8 17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6ZM8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13C7.55228 13 8 12.5523 8 12ZM16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "steering-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["clothing","underwear","lingerie","fashion","apparel","inventory","products","sales","items","merchandise","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 20C12 15.5817 8.41828 12 4 12H20C15.5817 12 12 15.5817 12 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    steering: {
        defaultColors: ["#3D4C66"],
        keywords: ["clothing","underwear","lingerie","fashion","apparel","inventory","products","sales","items","merchandise","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 20C12 15.5817 8.41828 12 4 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 20C12 15.5817 15.5817 12 20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "stethoscope-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["stethoscope","medical","healthcare","doctor","diagnosis","checkup","prescription","pharmacy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 11V15C9 17.2091 10.7909 19 13 19V19C15.2091 19 17 17.2091 17 15V14.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5 5V7C5 9.20914 6.79086 11 9 11V11C11.2091 11 13 9.20914 13 7V5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "stethoscope-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["stethoscope","medical","healthcare","doctor","prescription","pharmacy","health-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4C5.55228 4 6 4.44772 6 5V7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7V5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V7C14 9.41896 12.2822 11.4367 10 11.9V15C10 16.6569 11.3431 18 13 18C14.6569 18 16 16.6569 16 15V14.8293C14.8348 14.4175 14 13.3062 14 12C14 10.3431 15.3431 9 17 9C18.6569 9 20 10.3431 20 12C20 13.3062 19.1652 14.4175 18 14.8293V15C18 17.7614 15.7614 20 13 20C10.2386 20 8 17.7614 8 15V11.9C5.71776 11.4367 4 9.41896 4 7V5C4 4.44772 4.44772 4 5 4ZM16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "steering-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["steering","control","settings","drive","transport","delivery","navigation","interface","options","driver","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.28174 11.25C3.66216 6.7686 7.4202 3.25 12 3.25C16.5799 3.25 20.3379 6.7686 20.7184 11.25H3.28174Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3.28234 12.757C3.6447 16.9856 7.01447 20.3553 11.243 20.7177C11.1505 18.8437 10.1479 16.8948 8.62657 15.3735C7.10525 13.8522 5.15639 12.8496 3.28234 12.757Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.7571 20.7177C16.9856 20.3553 20.3554 16.9856 20.7178 12.757C18.8437 12.8496 16.8948 13.8522 15.3735 15.3735C13.8522 16.8948 12.8496 18.8437 12.7571 20.7177Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "stethoscope-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["stethoscope","medical","healthcare","doctor","prescription","pharmacy","health","medicine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V7C5 9.20914 6.79086 11 9 11V11C11.2091 11 13 9.20914 13 7V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11V15C9 17.2091 10.7909 19 13 19V19C15.2091 19 17 17.2091 17 15V14.2"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "stop-screen-share-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["screen","share","stop-sharing","disable-screen-share","presentation","no-share","block-share","prevent-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "stop-screen-share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["stop-screen-share","screen-share","disable","block","cancel","presentation","display","restrict","no-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="4"
                    y="5"
                    width="16"
                    height="12"
                    rx="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    stethoscope: {
        defaultColors: ["#3D4C66"],
        keywords: ["stop-screen-share","screen-share","disable","block","cancel","presentation","display","restrict","no-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 5V7C5 9.20914 6.79086 11 9 11V11C11.2091 11 13 9.20914 13 7V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 11V15C9 17.2091 10.7909 19 13 19V19C15.2091 19 17 17.2091 17 15V14.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "stop-screen-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen-share","stop","disabled","screen","block","cancel","presentation","sharing","no-screen-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.87059 4.93125C4.68529 5.0479 4.51112 5.18559 4.34835 5.34835C3.74644 5.95027 3.48754 6.70814 3.36653 7.60825C3.24997 8.47521 3.24998 9.57752 3.25 10.9451V11.0549C3.24998 12.4225 3.24997 13.5248 3.36653 14.3918C3.48754 15.2919 3.74644 16.0497 4.34835 16.6517C4.95027 17.2536 5.70814 17.5125 6.60825 17.6335C7.47522 17.75 8.57753 17.75 9.94512 17.75H11.25V18.75H10C9.58579 18.75 9.25 19.0858 9.25 19.5C9.25 19.9142 9.58579 20.25 10 20.25H14C14.4142 20.25 14.75 19.9142 14.75 19.5C14.75 19.0858 14.4142 18.75 14 18.75H12.75V17.75H14.0549C15.4225 17.75 16.5248 17.75 17.3918 17.6335C17.445 17.6263 17.4977 17.6187 17.5499 17.6105L12.4763 12.537L12.4696 12.5303L12.463 12.5236L10.9495 11.0102C10.4022 11.2991 9.9906 11.8056 9.82659 12.4177C9.76468 12.6487 9.75084 12.9538 9.75 13.7527C9.74957 14.1669 9.41343 14.5024 8.99922 14.5019C8.585 14.5015 8.24957 14.1654 8.25 13.7511C8.25077 13.0144 8.2542 12.4903 8.3777 12.0294C8.61061 11.1602 9.14313 10.4188 9.85987 9.92053L4.87059 4.93125Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.1294 17.0688C19.3147 16.9521 19.4889 16.8144 19.6517 16.6517C20.2536 16.0497 20.5125 15.2919 20.6335 14.3918C20.75 13.5248 20.75 12.4225 20.75 11.0549V10.9451C20.75 9.57754 20.75 8.47522 20.6335 7.60825C20.5125 6.70814 20.2536 5.95027 19.6517 5.34835C19.0497 4.74644 18.2919 4.48754 17.3918 4.36653C16.5248 4.24997 15.4225 4.24998 14.0549 4.25H9.94513C8.57755 4.24998 7.47521 4.24997 6.60825 4.36653C6.55505 4.37368 6.50234 4.38131 6.45013 4.38947L11.3695 9.30882C11.7746 9.24961 12.2517 9.24977 12.8841 9.24998L13.1893 9.25L12.4696 8.53033C12.1767 8.23744 12.1767 7.76256 12.4696 7.46967C12.7625 7.17678 13.2374 7.17678 13.5302 7.46967L15.5302 9.46967C15.6709 9.61032 15.7499 9.80109 15.7499 10C15.7499 10.1989 15.6709 10.3897 15.5302 10.5303L14.0606 12L19.1294 17.0688Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M13 10.9393L12.8108 10.7501L13.1893 10.75L13 10.9393Z" fill={colors?.[0] || "#3D4C66"} />
            </svg>
        )
    },
    "stop-screen-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["screen","share","stop","disable","remove","cancel","block","screen-share","stop-screen","disable-share","cancel-screen-share","block-screen-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="12" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 10L13 10C12.07 10 11.605 10 11.2235 10.1022C10.1883 10.3796 9.37962 11.1883 9.10222 12.2235C9 12.605 9 13.07 9 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 12L15 10L13 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 19V17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "stopwatch-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["stopwatch","time","duration","timer","late","pending","delayed","order-time","wait-time","service-time","delivery-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8L17 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 5H15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="10" y="11" width="2" height="4" rx="1" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14 15L14 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "stopwatch-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["stopwatch","time","duration","timer","pending","elapsed-time","order-time","estimated-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.75 12C10.75 11.8619 10.8619 11.75 11 11.75C11.1381 11.75 11.25 11.8619 11.25 12V14C11.25 14.1381 11.1381 14.25 11 14.25C10.8619 14.25 10.75 14.1381 10.75 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.25 6.2912V5.75H9C8.58579 5.75 8.25 5.41421 8.25 5C8.25 4.58579 8.58579 4.25 9 4.25H15C15.4142 4.25 15.75 4.58579 15.75 5C15.75 5.41421 15.4142 5.75 15 5.75H12.75V6.2912C14.2994 6.46247 15.6907 7.15814 16.7425 8.19679L17.4697 7.46967C17.7626 7.17678 18.2374 7.17678 18.5303 7.46967C18.8232 7.76256 18.8232 8.23744 18.5303 8.53033L17.6914 9.36928C18.3615 10.4176 18.75 11.6635 18.75 13C18.75 16.7279 15.7279 19.75 12 19.75C8.27208 19.75 5.25 16.7279 5.25 13C5.25 9.52558 7.87504 6.66428 11.25 6.2912ZM11 10.25C10.0335 10.25 9.25 11.0335 9.25 12V14C9.25 14.9665 10.0335 15.75 11 15.75C11.9665 15.75 12.75 14.9665 12.75 14V12C12.75 11.0335 11.9665 10.25 11 10.25ZM14.75 11C14.75 10.5858 14.4142 10.25 14 10.25C13.5858 10.25 13.25 10.5858 13.25 11V15C13.25 15.4142 13.5858 15.75 14 15.75C14.4142 15.75 14.75 15.4142 14.75 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "stopwatch-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["stopwatch","time","duration","timer","speed","wait-time","order-time","process-time","delivery-time","service-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8L17 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="13"
                    r="6"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 5H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="10"
                    y="11"
                    width="2"
                    height="4"
                    rx="1"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 15L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Stopwatch-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["stopwatch","time","duration","timer","elapsed-time","order-time","delivery-time","wait-time","clock","speed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 7L16.5858 8.41421" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L7.41421 8.41421" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 11.5L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Stopwatch-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["stopwatch","timer","time","duration","late","speed","performance","order-time","transaction-time","process-time","pending","delay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 7L16.5858 8.41421" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L7.41421 8.41421" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 5H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 11.5L14 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Stopwatch-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["stopwatch","time","duration","timer","clock","waiting","late","elapsed-time","service-time","process-time","order-time","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H13V6.07089C14.1859 6.24052 15.276 6.70742 16.1923 7.39368L17.293 6.29289C17.6836 5.90237 18.3167 5.90237 18.7073 6.29289C19.0978 6.68342 19.0978 7.31658 18.7073 7.70711L17.6064 8.80792C18.4816 9.97648 19 11.4277 19 13C19 16.866 15.866 20 12 20C8.13401 20 5 16.866 5 13C5 11.4277 5.5184 9.97641 6.39362 8.80783L5.29289 7.70711C4.90237 7.31658 4.90237 6.68342 5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289L7.80783 7.39362C8.72407 6.70739 9.81409 6.24052 11 6.07089V5H10C9.44772 5 9 4.55228 9 4ZM13.2934 10.2923C12.9017 10.1049 12.4631 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 12.5368 14.895 12.0982 14.7076 11.7065C15.0976 11.316 15.0975 10.6832 14.7071 10.2928C14.3167 9.90243 13.6839 9.90228 13.2934 10.2923Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    stopwatch: {
        defaultColors: ["#3D4C66"],
        keywords: ["stopwatch","time","duration","timer","clock","waiting","late","elapsed-time","service-time","process-time","order-time","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="13" r="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M9 5H15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 8L17 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <rect x="10" y="11" width="2" height="4" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14 15L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Stopwatch-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["stopwatch","timer","time","duration","speed","waiting","pending","delayed","order-time","delivery-time","service-time","clock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 7L16.5858 8.41421" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 7L7.41421 8.41421" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="13"
                    r="6"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 5H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 11.5L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="13"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Store shop-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","building","marketplace","business","local-business","purchase","retail","point-of-sale","outlet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.02725 12.9729L5.0407 10H18.7151L18.8041 12.8102C18.8962 15.72 18.9422 17.175 18.0582 18.0875C17.1741 19 15.7184 19 12.8071 19H11.0272C8.18705 19 6.76698 19 5.88749 18.1165C5.00799 17.233 5.01441 15.813 5.02725 12.9729Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 17V19L14 19V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.117 5H7.88304C6.49159 5 5.79587 5 5.2721 5.37752C4.74832 5.75503 4.52832 6.41505 4.0883 7.73509C4.02982 7.91055 4 8.09429 4 8.27924V9C4 10.1046 4.89543 11 6 11C7.10457 11 8 10.1046 8 9C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9C12 10.1046 12.8954 11 14 11C15.1046 11 16 10.1046 16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V8.27924C20 8.09429 19.9702 7.91055 19.9117 7.73509C19.4717 6.41505 19.2517 5.75503 18.7279 5.37752C18.2041 5 17.5084 5 16.117 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M19.9117 7.73509L19.2002 7.97226L19.2002 7.97226L19.9117 7.73509ZM5.2721 5.37752L4.83357 4.76908L4.83357 4.76908L5.2721 5.37752ZM4.0883 7.73509L4.79982 7.97226L4.0883 7.73509ZM7.88304 5.75H16.117V4.25H7.88304V5.75ZM16.117 5.75C16.83 5.75 17.3017 5.75113 17.6627 5.79235C18.0046 5.83138 18.1695 5.89953 18.2894 5.98595L19.1664 4.76908C18.7626 4.47799 18.3177 4.35738 17.8329 4.30203C17.3672 4.24887 16.7954 4.25 16.117 4.25V5.75ZM20.6232 7.49792C20.4087 6.85429 20.2289 6.31146 20.0312 5.88651C19.8254 5.44407 19.5703 5.06018 19.1664 4.76908L18.2894 5.98595C18.4093 6.07237 18.5261 6.20724 18.6712 6.5192C18.8245 6.84865 18.9747 7.29585 19.2002 7.97226L20.6232 7.49792ZM7.88304 4.25C7.20459 4.25 6.63278 4.24887 6.16712 4.30203C5.6823 4.35738 5.23744 4.47799 4.83357 4.76908L5.71063 5.98595C5.83053 5.89953 5.99542 5.83138 6.33727 5.79235C6.69827 5.75113 7.17004 5.75 7.88304 5.75V4.25ZM4.79982 7.97226C5.02529 7.29585 5.17555 6.84865 5.32881 6.5192C5.47393 6.20724 5.59073 6.07237 5.71063 5.98595L4.83357 4.76908C4.42969 5.06018 4.1746 5.44407 3.96877 5.88651C3.77108 6.31146 3.59134 6.85429 3.37679 7.49792L4.79982 7.97226ZM11.25 9C11.25 9.69036 10.6904 10.25 10 10.25V11.75C11.5188 11.75 12.75 10.5188 12.75 9H11.25ZM10 10.25C9.30964 10.25 8.75 9.69036 8.75 9H7.25C7.25 10.5188 8.48122 11.75 10 11.75V10.25ZM7.25 9C7.25 9.69036 6.69036 10.25 6 10.25V11.75C7.51878 11.75 8.75 10.5188 8.75 9H7.25ZM6 10.25C5.30964 10.25 4.75 9.69036 4.75 9H3.25C3.25 10.5188 4.48122 11.75 6 11.75V10.25ZM4.75 9V8.27924H3.25V9H4.75ZM15.25 9C15.25 10.5188 16.4812 11.75 18 11.75V10.25C17.3096 10.25 16.75 9.69036 16.75 9H15.25ZM18 11.75C19.5188 11.75 20.75 10.5188 20.75 9H19.25C19.25 9.69036 18.6904 10.25 18 10.25V11.75ZM20.75 9V8.27924H19.25V9H20.75ZM15.25 9C15.25 9.69036 14.6904 10.25 14 10.25V11.75C15.5188 11.75 16.75 10.5188 16.75 9H15.25ZM14 10.25C13.3096 10.25 12.75 9.69036 12.75 9H11.25C11.25 10.5188 12.4812 11.75 14 11.75V10.25ZM3.37679 7.49792C3.29281 7.74985 3.25 8.01368 3.25 8.27924H4.75C4.75 8.1749 4.76682 8.07124 4.79982 7.97226L3.37679 7.49792ZM19.2002 7.97226C19.2332 8.07124 19.25 8.1749 19.25 8.27924H20.75C20.75 8.01368 20.7072 7.74985 20.6232 7.49792L19.2002 7.97226Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M7.25 9C7.25 9.41421 7.58579 9.75 8 9.75C8.41421 9.75 8.75 9.41421 8.75 9H7.25ZM8.75 5V4.25H7.25V5H8.75ZM8.75 9V5H7.25V9H8.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M15.25 9C15.25 9.41421 15.5858 9.75 16 9.75C16.4142 9.75 16.75 9.41421 16.75 9H15.25ZM16.75 5V4.25H15.25V5H16.75ZM16.75 9V5H15.25V9H16.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Store shop-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","market","marketplace","business","location","sales","checkout","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 8L19.9117 7.73509C19.4717 6.41505 19.2517 5.75503 18.7279 5.37752C18.2041 5 17.5084 5 16.117 5H7.88304C6.49159 5 5.79587 5 5.2721 5.37752C4.74832 5.75503 4.52832 6.41505 4.0883 7.73509L4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.25 19C13.25 19.4142 13.5858 19.75 14 19.75C14.4142 19.75 14.75 19.4142 14.75 19H13.25ZM10.75 19V17H9.25V19H10.75ZM13.25 17V19H14.75V17H13.25ZM10.75 17C10.75 16.3096 11.3096 15.75 12 15.75V14.25C10.4812 14.25 9.25 15.4812 9.25 17H10.75ZM12 15.75C12.6904 15.75 13.25 16.3096 13.25 17H14.75C14.75 15.4812 13.5188 14.25 12 14.25V15.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Store shop": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","marketplace","business","location","sales","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 8L19.9117 7.73509C19.4717 6.41505 19.2517 5.75503 18.7279 5.37752C18.2041 5 17.5084 5 16.117 5H7.88304C6.49159 5 5.79587 5 5.2721 5.37752C4.74832 5.75503 4.52832 6.41505 4.0883 7.73509L4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 9V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.25 19C13.25 19.4142 13.5858 19.75 14 19.75C14.4142 19.75 14.75 19.4142 14.75 19H13.25ZM10.75 19V17H9.25V19H10.75ZM13.25 17V19H14.75V17H13.25ZM10.75 17C10.75 16.3096 11.3096 15.75 12 15.75V14.25C10.4812 14.25 9.25 15.4812 9.25 17H10.75ZM12 15.75C12.6904 15.75 13.25 16.3096 13.25 17H14.75C14.75 15.4812 13.5188 14.25 12 14.25V15.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v1-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","marketplace","location","establishment","business","retail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 11L6.00074 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18.0001 19L18 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 19L20 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Store v1-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","building","location","marketplace","sales","business","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00074 19L18.0001 19L18 11H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.87749 8.36754L5.0883 7.73509C5.52832 6.41505 5.74832 5.75503 6.2721 5.37752C6.79587 5 7.49159 5 8.88304 5H11.9993H12.0007H15.117C16.5084 5 17.2041 5 17.7279 5.37752C18.2517 5.75503 18.4717 6.41505 18.9117 7.73509L19.1225 8.36754C19.5229 9.5688 19.7231 10.1694 19.4238 10.5847C19.1245 11 18.4914 11 17.2251 11H6.77485C5.50862 11 4.87551 11 4.57618 10.5847C4.27686 10.1694 4.47707 9.5688 4.87749 8.36754Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 19L20 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 15C11 15.5523 11.4477 16 12 16C12.2761 16 12.5261 15.8881 12.7071 15.7071C12.8881 15.5261 13 15.2761 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Store v1-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","marketplace","location","business","online-store","retail","building","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0002 18.0002H19.0002V11.9002C19.5202 11.8002 19.9302 11.5902 20.2302 11.1702C20.8302 10.3402 20.5302 9.43023 20.0702 8.05023L19.8602 7.41023C19.3902 5.99023 19.1002 5.13023 18.3102 4.56023C17.5202 3.99023 16.6202 3.99023 15.1102 3.99023H8.88023C7.38023 3.99023 6.47023 3.99023 5.68023 4.56023C4.89023 5.13023 4.61023 5.99023 4.13023 7.41023L3.92023 8.04023C3.46023 9.42023 3.16023 10.3302 3.76023 11.1602C4.07023 11.5902 4.48023 11.7902 4.99023 11.8902V17.9902H3.99023C3.44023 17.9902 2.99023 18.4402 2.99023 18.9902C2.99023 19.5402 3.44023 19.9902 3.99023 19.9902H20.0002C20.5502 19.9902 21.0002 19.5402 21.0002 18.9902C21.0002 18.4402 20.5502 17.9902 20.0002 17.9902V18.0002ZM7.00023 18.0002V12.0002H17.0002V18.0002H7.00023Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.0002 13.2502C11.0402 13.2502 10.2502 14.0402 10.2502 15.0002C10.2502 15.9602 11.0402 16.7502 12.0002 16.7502C12.4702 16.7502 12.9102 16.5702 13.2402 16.2402C13.5702 15.9102 13.7502 15.4702 13.7502 15.0002C13.7502 14.0402 12.9602 13.2502 12.0002 13.2502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v1": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","location","point-of-sale","retail","marketplace","business","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 11L6.00074 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18.0001 19L18 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 19L20 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10 15C10 16.1046 10.8954 17 12 17C12.5523 17 13.0523 16.7761 13.4142 16.4142C13.7761 16.0523 14 15.5523 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Store v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","business","location","marketplace","building","establishment","retail","sales","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00074 19L18.0001 19L18 11H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.87749 8.36754L5.0883 7.73509C5.52832 6.41505 5.74832 5.75503 6.2721 5.37752C6.79587 5 7.49159 5 8.88304 5H11.9993H12.0007H15.117C16.5084 5 17.2041 5 17.7279 5.37752C18.2517 5.75503 18.4717 6.41505 18.9117 7.73509L19.1225 8.36754C19.5229 9.5688 19.7231 10.1694 19.4238 10.5847C19.1245 11 18.4914 11 17.2251 11H6.77485C5.50862 11 4.87551 11 4.57618 10.5847C4.27686 10.1694 4.47707 9.5688 4.87749 8.36754Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 19L10 18C10 16.8954 10.8954 16 12 16C13.1044 16 13.9998 16.8953 13.9999 17.9998L14 19L10 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 19L20 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Store shop-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","retail","location","business","marketplace","front","establishment","boutique","commerce"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.83063 4C7.84804 4 7.86551 4 7.88304 4L16.1694 4C16.8202 3.99996 17.3907 3.99993 17.8612 4.05365C18.3699 4.11172 18.8614 4.24107 19.3126 4.56628C19.7638 4.89149 20.042 5.31688 20.2579 5.78106C20.4577 6.21045 20.638 6.75167 20.8438 7.36916L20.8604 7.41887C20.9529 7.69629 21 7.98681 21 8.27924V9C21 10.6569 19.6569 12 18 12C17.2316 12 16.5308 11.7112 16 11.2361C15.4692 11.7112 14.7684 12 14 12C13.2316 12 12.5308 11.7112 12 11.2361C11.4692 11.7112 10.7684 12 10 12C9.23165 12 8.53076 11.7112 8 11.2361C7.46924 11.7112 6.76835 12 6 12C4.34315 12 3 10.6569 3 9V8.27924C3 7.98681 3.04714 7.69629 3.13962 7.41887C3.14516 7.40224 3.15069 7.38566 3.15619 7.36915C3.36198 6.75166 3.54235 6.21044 3.7421 5.78106C3.95804 5.31688 4.23619 4.89149 4.68739 4.56628C5.13859 4.24107 5.63011 4.11172 6.13876 4.05365C6.60927 3.99993 7.17975 3.99996 7.83063 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.02707 13.0391L4.02959 12.4817C4.61123 12.8116 5.28368 13 6.00012 13C6.7287 13 7.41178 12.8052 8.00012 12.4648C8.58847 12.8052 9.27155 13 10.0001 13C10.7287 13 11.4118 12.8052 12.0001 12.4648C12.5885 12.8052 13.2715 13 14.0001 13C14.7287 13 15.4118 12.8052 16.0001 12.4648C16.5885 12.8052 17.2715 13 18.0001 13C18.6464 13 19.2569 12.8467 19.7972 12.5745L19.806 12.8503C19.8501 14.2441 19.8865 15.3918 19.7919 16.3012C19.6928 17.255 19.4373 18.1012 18.7765 18.7833C18.1157 19.4653 17.278 19.7475 16.3278 19.8768C15.6773 19.9653 14.9019 19.9902 14.0001 19.9972V18C14.0001 16.8954 13.1047 16 12.0001 16C10.8956 16 10.0001 16.8954 10.0001 18V19.9982C9.06152 19.9928 8.25838 19.9708 7.58874 19.8806C6.65773 19.7552 5.83572 19.4818 5.1789 18.822C4.52209 18.1622 4.2524 17.3389 4.13122 16.4074C4.01578 15.5199 4.02088 14.3989 4.02707 13.0391L4.02707 13.0391Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v2-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["store","shop","business","location","marketplace","retail","sales","point of sale","POS","ecommerce","establishment","vendor","merchant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_33894)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 18H19V11.9C19.43 11.82 19.9 11.63 20.24 11.17C20.62 10.64 20.61 10.06 20.52 9.6C20.44 9.17 20.27 8.66 20.09 8.12C20.09 8.1 20.08 8.08 20.07 8.06L19.84 7.38C19.63 6.76 19.45 6.22 19.25 5.79C19.03 5.33 18.76 4.9 18.3 4.58C17.85 4.25 17.36 4.13 16.85 4.07C16.39 4 15.82 4 15.17 4H8.83C8.18 4 7.61 4 7.14 4.05C6.63 4.11 6.14 4.24 5.69 4.56C5.24 4.89 4.96 5.31 4.74 5.77C4.54 6.2 4.36 6.74 4.15 7.36C4.15 7.38 4.14 7.39 4.13 7.41L3.92 8.04C3.92 8.04 3.91 8.08 3.9 8.1C3.72 8.65 3.55 9.16 3.47 9.58C3.39 10.04 3.37 10.63 3.76 11.15C4.1 11.62 4.57 11.8 5 11.88V17.98H4C3.45 17.98 3 18.43 3 18.98C3 19.53 3.45 19.98 4 19.98H20C20.55 19.98 21 19.53 21 18.98C21 18.43 20.55 17.98 20 17.98V18ZM14 18V17C14 15.9 13.1 15 12 15C10.9 15 10 15.9 10 17V18H7V12H17V18H14Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_33894">
                        <rect width="18" height="16" fill={colors?.[1] || "#FFFFFF"} transform="translate(3 4)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "Store v2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","marketplace","local-business","establishment","location","point-of-sale","business"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19L13.9999 17.9998C13.9998 16.8953 13.1044 16 12 16V16C10.8954 16 10 16.8954 10 18L10 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 11L6.00074 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18.0001 19L18 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 19L20 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Store v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","marketplace","sales","location","business","outlet","kiosk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 19L13.9999 17.9998C13.9998 16.8953 13.1044 16 12 16V16C10.8954 16 10 16.8954 10 18L10 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 11L6.00074 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18.0001 19L18 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 19L20 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Store v3-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","location","marketplace","retail","business","outlet","point-of-sale","POS"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 11L6.00037 15M6.00074 19L6.00037 15M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M6.00037 15L11 15M11 15V11M11 15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Store v3-2": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","building","location","marketplace","retail","business","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 15L6 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M6 11L6.00037 15L6.00074 19M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M11 11V15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Store v3-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","location","marketplace","sales","retail","business","establishment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12H6.77485C6.7528 12 6.7308 12 6.70886 12C6.63863 12 6.56896 12 6.5 11.9999V14L10 14V12ZM10.0001 16L6.5 16V18L10.0003 18L10.0001 16ZM12.0003 18H17L16.9997 12H12L12.0003 18ZM18.9997 11.9087C19.427 11.8238 19.8992 11.6353 20.2351 11.1694C20.6155 10.6416 20.6028 10.0603 20.5201 9.59564C20.4444 9.17036 20.2743 8.66023 20.0921 8.11386C20.0851 8.09307 20.0782 8.07222 20.0712 8.05132L19.8438 7.36911C19.638 6.75164 19.4576 6.21043 19.2579 5.78106C19.042 5.31688 18.7638 4.89149 18.3126 4.56628C17.8614 4.24107 17.3699 4.11172 16.8612 4.05365C16.3907 3.99993 15.8202 3.99996 15.1694 4L8.88304 4C8.86551 4 8.84804 4 8.83063 4C8.17975 3.99996 7.60927 3.99993 7.13876 4.05365C6.63011 4.11172 6.13859 4.24107 5.68739 4.56628C5.23619 4.89149 4.95804 5.31688 4.7421 5.78106C4.54235 6.21044 4.36198 6.75166 4.15619 7.36914C4.15069 7.38566 4.14516 7.40224 4.13962 7.41887L3.9288 8.05132C3.92183 8.07224 3.91487 8.09311 3.90793 8.11393C3.72571 8.66027 3.55559 9.17037 3.4799 9.59564C3.39721 10.0603 3.38451 10.6416 3.76494 11.1694C3.9722 11.457 4.23144 11.6389 4.5 11.7559V18H4C3.44771 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20L5.49925 20H5.50075L20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18L19 18L18.9997 11.9087Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","location","point-of-sale","sales","retail","marketplace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 11L6.00037 15M6.00074 19L6.00037 15M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M6.00037 15L11 15M11 15V11M11 15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Store v4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","building","marketplace","sales","retail","business","location","outlet","vendor","merchant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.98777 12.9762L5.99958 10H17.9996L18.0783 12.8334C18.1588 15.7333 18.1991 17.1833 17.3157 18.0917C16.4322 19 14.966 19 12.0336 19C9.16431 19 7.72967 19 6.85027 18.1171C5.97087 17.2342 5.97651 15.8149 5.98777 12.9762Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 15L6 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.12311 5H9.66667H14.3331H14.8769C16.3768 5 17.1267 5 17.6693 5.42359C18.2118 5.84718 18.3937 6.57474 18.7575 8.02986L18.9403 8.76114C18.9799 8.91978 19.0057 9.08363 18.9826 9.24551C18.8414 10.2343 17.8584 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9C9.66667 10.1046 8.622 11 7.33333 11C6.14164 11 5.1586 10.2343 5.0174 9.24551C4.99429 9.08363 5.02005 8.91978 5.05972 8.76114L5.24254 8.02986C5.60632 6.57474 5.78821 5.84718 6.33073 5.42359C6.87325 5 7.6232 5 9.12311 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM18.9403 8.76114L18.2127 8.94304V8.94304L18.9403 8.76114ZM5.05972 8.76114L4.33211 8.57924L4.33211 8.57924L5.05972 8.76114ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM18.9826 9.24551L19.7251 9.35153L18.9826 9.24551ZM14.3333 9H15.0833V8.99996L14.3333 9ZM5.0174 9.24551L4.27494 9.35153L5.0174 9.24551ZM9.12311 5.75H9.66667V4.25H9.12311V5.75ZM9.66667 5.75H14.3331V4.25H9.66667V5.75ZM14.3331 5.75H14.8769V4.25H14.3331V5.75ZM18.0299 8.21176L18.2127 8.94304L19.6679 8.57924L19.4851 7.84796L18.0299 8.21176ZM5.78732 8.94304L5.97014 8.21176L4.51493 7.84795L4.33211 8.57924L5.78732 8.94304ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176ZM18.2401 9.13948C18.1629 9.6803 17.5702 10.25 16.6667 10.25V11.75C18.1465 11.75 19.5199 10.7882 19.7251 9.35153L18.2401 9.13948ZM16.6667 10.25C15.6796 10.25 15.0833 9.58606 15.0833 9H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9C13.5833 9.58606 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58606 10.4167 9H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9C8.91667 9.58606 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9H8.91667ZM7.33333 10.25C6.42979 10.25 5.8371 9.6803 5.75987 9.13948L4.27494 9.35153C4.4801 10.7882 5.85349 11.75 7.33333 11.75V10.25ZM10.4167 9V5H8.91667V9H10.4167ZM15.0833 8.99996L15.0831 4.99996L13.5831 5.00004L13.5833 9.00004L15.0833 8.99996ZM4.33211 8.57924C4.28381 8.77244 4.2315 9.04736 4.27494 9.35153L5.75987 9.13948C5.75708 9.11989 5.7563 9.06712 5.78732 8.94304L4.33211 8.57924ZM18.2127 8.94304C18.2437 9.06712 18.2429 9.11989 18.2401 9.13948L19.7251 9.35153C19.7685 9.04736 19.7162 8.77244 19.6679 8.57924L18.2127 8.94304Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","marketplace","business","retail","location","outlet","storefront"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.0675 4C9.08599 4 9.10455 4 9.12316 4L14.9326 4C15.6349 3.99996 16.2483 3.99992 16.7509 4.06003C17.2934 4.12491 17.8165 4.2698 18.2847 4.63539C18.753 5.00097 19.0204 5.47327 19.2149 5.9839C19.3951 6.45693 19.5439 7.05198 19.7142 7.73335L19.9105 8.51861C19.9617 8.72333 20.0228 9.03527 19.9726 9.38688C19.7461 10.9729 18.2426 12 16.6667 12C15.8065 12 14.9587 11.6883 14.3334 11.1455C13.7081 11.6883 12.8603 12 12.0001 12C11.1398 12 10.292 11.6883 9.66672 11.1455C9.04142 11.6883 8.19365 12 7.33339 12C5.75749 12 4.25399 10.9729 4.0275 9.38688C3.97729 9.03527 4.03845 8.72333 4.08963 8.51861L4.27245 7.78733C4.27696 7.76927 4.28146 7.75126 4.28595 7.73332C4.45624 7.05197 4.60497 6.45693 4.78518 5.9839C4.97971 5.47327 5.24714 5.00097 5.71537 4.63539C6.18361 4.2698 6.70667 4.12491 7.24922 4.06003C7.75184 3.99992 8.36518 3.99996 9.0675 4ZM10.6667 9.00001C10.6667 9.41323 11.1135 10 12.0001 10C12.8866 10 13.3334 9.41328 13.3334 9.00007M10.6667 9.00001V6H13.3332L13.3334 9.00007M8.66672 6.00062V9.00001C8.66672 9.41323 8.21994 10 7.33339 10C6.53277 10 6.07123 9.50422 6.00893 9.11417C6.00893 9.11417 6.00927 9.10975 6.0096 9.10656C6.0116 9.08755 6.0169 9.05572 6.02991 9.00368L6.21273 8.2724C6.40053 7.52122 6.52158 7.04388 6.65414 6.69591C6.77713 6.37308 6.87191 6.2698 6.9462 6.2118C7.02049 6.1538 7.14366 6.0869 7.48669 6.04588C7.77795 6.01105 8.14536 6.00263 8.66672 6.00062ZM15.3334 9.00001C15.3334 9.41323 15.7802 10 16.6667 10C17.4673 10 17.9289 9.50422 17.9912 9.11417C17.9912 9.11417 17.9908 9.10975 17.9905 9.10656C17.9885 9.08755 17.9832 9.05572 17.9702 9.00368L17.7874 8.2724C17.5996 7.52122 17.4785 7.04388 17.346 6.69591C17.223 6.37308 17.1282 6.2698 17.0539 6.2118C16.9796 6.1538 16.8564 6.0869 16.5134 6.04588C16.2221 6.01105 15.8547 6.00262 15.3332 6.00062L15.3334 9.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.98797 13.0431L4.98975 12.5935C5.70858 12.9904 6.52964 13.1999 7.33337 13.1999C8.14876 13.1999 8.9595 12.9901 9.6667 12.5997C10.3739 12.9901 11.1846 13.1999 12 13.1999C12.8154 13.1999 13.6262 12.9901 14.3334 12.5997C15.0406 12.9901 15.8513 13.1999 16.6667 13.1999C17.4933 13.1999 18.3383 12.9783 19.0715 12.5591L19.0804 12.8774C19.119 14.2664 19.1508 15.4103 19.0532 16.3165C18.9508 17.2672 18.6933 18.1101 18.033 18.789C17.3711 19.4695 16.5298 19.7493 15.5769 19.8776C14.6665 20.0002 13.5109 20.0001 12.1055 20.0001H11.9636C10.589 20.0001 9.45752 20.0002 8.56396 19.881C7.62798 19.7561 6.80055 19.4838 6.14223 18.8229C5.48551 18.1636 5.21553 17.3408 5.09392 16.4097C4.97806 15.5227 4.98254 14.4022 4.98797 13.0431ZM9.00006 15.5C8.44778 15.5 8.00006 15.9477 8.00006 16.5C8.00006 17.0523 8.44778 17.5 9.00006 17.5H15.0001C15.5523 17.5 16.0001 17.0523 16.0001 16.5C16.0001 15.9477 15.5523 15.5 15.0001 15.5H9.00006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store v3-3": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","building","location","sales","marketplace","commerce","retail","business","establishment","shopfront","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00074 19L18.0001 19L18 11H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.87749 8.36754L5.0883 7.73509C5.52832 6.41505 5.74832 5.75503 6.2721 5.37752C6.79587 5 7.49159 5 8.88304 5H11.9993H12.0007H15.117C16.5084 5 17.2041 5 17.7279 5.37752C18.2517 5.75503 18.4717 6.41505 18.9117 7.73509L19.1225 8.36754C19.5229 9.5688 19.7231 10.1694 19.4238 10.5847C19.1245 11 18.4914 11 17.2251 11H6.77485C5.50862 11 4.87551 11 4.57618 10.5847C4.27686 10.1694 4.47707 9.5688 4.87749 8.36754Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 14.25L5.25 14.25L5.25 15.75L6 15.75L6 14.25ZM11.7496 11C11.7496 10.5858 11.4138 10.25 10.9996 10.25C10.5854 10.25 10.2496 10.5858 10.2496 11H11.7496ZM10.25 19.0001C10.25 19.4143 10.5859 19.75 11.0001 19.75C11.4143 19.75 11.75 19.4141 11.75 18.9999L10.25 19.0001ZM6 15.75L10.9996 15.75L10.9996 14.25L6 14.25L6 15.75ZM11.7496 15V11H10.2496V15H11.7496ZM10.2496 15.0001L10.25 19.0001L11.75 18.9999L11.7496 14.9999L10.2496 15.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M4 19L6.00074 19L11.0004 19H18.0001H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Store v4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","location","marketplace","business","retail","point-of-sale","pos"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9.00001C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9.00001M14.3333 9.00001C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9.00001M14.3333 9.00001L14.3331 5.00001M9.66667 9.00001C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9.00001M9.66667 9.00001V5.00001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 15L6 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M6 11V13C6 15.8284 6 17.2426 6.87868 18.1213C7.75736 19 9.17157 19 12 19V19C14.8284 19 16.2426 19 17.1213 18.1213C18 17.2426 18 15.8284 18 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "store-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["store","shop","business","location","marketplace","sales","point-of-sale","local-business","brick-and-mortar","retail","checkout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9.00001C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9.00001M14.3333 9.00001C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9.00001M14.3333 9.00001L14.3331 5.00001M9.66667 9.00001C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9.00001M9.66667 9.00001V5.00001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.25 19C13.25 19.4142 13.5858 19.75 14 19.75C14.4142 19.75 14.75 19.4142 14.75 19H13.25ZM10.75 19V16H9.25V19H10.75ZM13.25 16V19H14.75V16H13.25ZM11 15.75H13V14.25H11V15.75ZM14.75 16C14.75 15.0335 13.9665 14.25 13 14.25V15.75C13.1381 15.75 13.25 15.8619 13.25 16H14.75ZM10.75 16C10.75 15.8619 10.8619 15.75 11 15.75V14.25C10.0335 14.25 9.25 15.0335 9.25 16H10.75Z"
                    fill={colors?.[1] || "#2797E8"}
                />
                <path
                    d="M5.99958 11L5.99077 12.9732C5.97809 15.8132 5.97175 17.2332 6.85124 18.1166C7.73072 19 9.16197 19 12.0245 19V19C14.9579 19 16.4245 19 17.3086 18.0879C18.1926 17.1759 18.1471 15.7214 18.0562 12.8126L17.9996 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "store-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["store","shop","business","location","marketplace","sales","retail","vendor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.98777 12.9762L5.99958 10H17.9996L18.0783 12.8334C18.1588 15.7333 18.1991 17.1833 17.3157 18.0917C16.4322 19 14.966 19 12.0336 19C9.16431 19 7.72967 19 6.85027 18.1171C5.97087 17.2342 5.97651 15.8149 5.98777 12.9762Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5.05972 8.76114C5.02005 8.91978 4.99429 9.08363 5.0174 9.24551C5.1586 10.2343 6.14164 11 7.33333 11C8.622 11 9.66667 10.1046 9.66667 9.00001C9.66667 10.1046 10.7113 11 12 11C13.2887 11 14.3333 10.1046 14.3333 9.00001C14.3333 10.1046 15.378 11 16.6667 11C17.8584 11 18.8414 10.2343 18.9826 9.24551C19.0057 9.08363 18.9799 8.91978 18.9403 8.76114L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M18.7575 8.02986L19.4851 7.84796V7.84796L18.7575 8.02986ZM18.9403 8.76114L18.2127 8.94304V8.94304L18.9403 8.76114ZM5.05972 8.76114L4.33211 8.57924L4.33211 8.57924L5.05972 8.76114ZM5.24254 8.02986L5.97014 8.21176L5.24254 8.02986ZM17.6693 5.42359L17.2077 6.01474V6.01474L17.6693 5.42359ZM6.33073 5.42359L6.79229 6.01474L6.33073 5.42359ZM18.9826 9.24551L18.2401 9.13948L18.9826 9.24551ZM14.3333 9.00001H15.0833V8.99997L14.3333 9.00001ZM5.0174 9.24551L4.27494 9.35153H4.27494L5.0174 9.24551ZM10.4167 5.00001C10.4167 4.5858 10.0809 4.25001 9.66667 4.25001C9.25245 4.25001 8.91667 4.5858 8.91667 5.00001H10.4167ZM15.0831 4.99997C15.0831 4.58575 14.7473 4.24999 14.3331 4.25001C13.9189 4.25003 13.5831 4.58584 13.5831 5.00005L15.0831 4.99997ZM9.12311 5.75H14.8769V4.25H9.12311V5.75ZM18.0299 8.21176L18.2127 8.94304L19.6679 8.57924L19.4851 7.84796L18.0299 8.21176ZM5.78732 8.94304L5.97014 8.21176L4.51493 7.84795L4.33211 8.57924L5.78732 8.94304ZM14.8769 5.75C15.6451 5.75 16.1551 5.75125 16.5431 5.79764C16.911 5.84164 17.0842 5.91829 17.2077 6.01474L18.1308 4.83244C17.7118 4.5053 17.2388 4.37015 16.7212 4.30825C16.2236 4.24875 15.6086 4.25 14.8769 4.25V5.75ZM19.4851 7.84796C19.3076 7.13811 19.1597 6.54119 18.9813 6.07289C18.7957 5.58574 18.5498 5.15957 18.1308 4.83243L17.2077 6.01474C17.3312 6.11119 17.4476 6.2606 17.5795 6.60691C17.7186 6.97207 17.8435 7.46648 18.0299 8.21176L19.4851 7.84796ZM9.12311 4.25C8.39142 4.25 7.77643 4.24875 7.27885 4.30825C6.76123 4.37015 6.28816 4.5053 5.86917 4.83244L6.79229 6.01474C6.91582 5.91829 7.08898 5.84164 7.45695 5.79764C7.84495 5.75125 8.35489 5.75 9.12311 5.75V4.25ZM5.97014 8.21176C6.15646 7.46648 6.28135 6.97207 6.42047 6.60691C6.5524 6.2606 6.66876 6.11119 6.79229 6.01474L5.86917 4.83244C5.45018 5.15957 5.20433 5.58574 5.01874 6.07289C4.84034 6.54119 4.69239 7.13811 4.51493 7.84795L5.97014 8.21176ZM18.2401 9.13948C18.1629 9.68031 17.5702 10.25 16.6667 10.25V11.75C18.1465 11.75 19.5199 10.7882 19.7251 9.35153L18.2401 9.13948ZM16.6667 10.25C15.6796 10.25 15.0833 9.58607 15.0833 9.00001H13.5833C13.5833 10.6231 15.0764 11.75 16.6667 11.75V10.25ZM13.5833 9.00001C13.5833 9.58607 12.9871 10.25 12 10.25V11.75C13.5902 11.75 15.0833 10.6231 15.0833 9.00001H13.5833ZM12 10.25C11.0129 10.25 10.4167 9.58607 10.4167 9.00001H8.91667C8.91667 10.6231 10.4098 11.75 12 11.75V10.25ZM8.91667 9.00001C8.91667 9.58607 8.32042 10.25 7.33333 10.25V11.75C8.92358 11.75 10.4167 10.6231 10.4167 9.00001H8.91667ZM7.33333 10.25C6.42979 10.25 5.8371 9.68031 5.75987 9.13948L4.27494 9.35153C4.4801 10.7882 5.85349 11.75 7.33333 11.75V10.25ZM10.4167 9.00001V5.00001H8.91667V9.00001H10.4167ZM15.0833 8.99997L15.0831 4.99997L13.5831 5.00005L13.5833 9.00005L15.0833 8.99997ZM4.33211 8.57924C4.28381 8.77244 4.2315 9.04736 4.27494 9.35153L5.75987 9.13948C5.75708 9.11989 5.7563 9.06712 5.78732 8.94304L4.33211 8.57924ZM18.2127 8.94304C18.2437 9.06712 18.2429 9.11989 18.2401 9.13948L19.7251 9.35153C19.7685 9.04736 19.7162 8.77244 19.6679 8.57924L18.2127 8.94304Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M10 16V19L14 19V16C14 15.4477 13.5523 15 13 15H11C10.4477 15 10 15.4477 10 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Store v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","marketplace","vendor","point-of-sale","pos","business","retail","market","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9.00001C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9.00001M14.3333 9.00001C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9.00001M14.3333 9.00001L14.3331 5.00001M9.66667 9.00001C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9.00001M9.66667 9.00001V5.00001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 11V13C6 15.8284 6 17.2426 6.87868 18.1213C7.75736 19 9.17157 19 12 19V19C14.8284 19 16.2426 19 17.1213 18.1213C18 17.2426 18 15.8284 18 13V11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 15L6 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "store-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","building","marketplace","location","establishment","business","venue","retail","sales","point-of-sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.0675 4C9.08599 4 9.10455 4 9.12316 4L14.9326 4C15.6349 3.99996 16.2483 3.99992 16.7509 4.06003C17.2934 4.12491 17.8165 4.2698 18.2847 4.63539C18.753 5.00097 19.0204 5.47327 19.2149 5.9839C19.3951 6.45693 19.5439 7.05198 19.7142 7.73335L19.9105 8.51861C19.9617 8.72333 20.0228 9.03527 19.9726 9.38688C19.7461 10.9729 18.2426 12 16.6667 12C15.8065 12 14.9587 11.6883 14.3334 11.1455C13.7081 11.6883 12.8603 12 12.0001 12C11.1398 12 10.292 11.6883 9.66672 11.1455C9.04142 11.6883 8.19365 12 7.33339 12C5.75749 12 4.25399 10.9729 4.0275 9.38688C3.97729 9.03527 4.03845 8.72333 4.08963 8.51861L4.27245 7.78733C4.27696 7.76927 4.28146 7.75126 4.28595 7.73332C4.45624 7.05197 4.60497 6.45693 4.78518 5.9839C4.97971 5.47327 5.24714 5.00097 5.71537 4.63539C6.18361 4.2698 6.70667 4.12491 7.24922 4.06003C7.75184 3.99992 8.36518 3.99996 9.0675 4ZM10.6667 9.00001C10.6667 9.41323 11.1135 10 12.0001 10C12.8866 10 13.3334 9.41328 13.3334 9.00007M10.6667 9.00001V6H13.3332L13.3334 9.00007M8.66672 6.00062V9.00001C8.66672 9.41323 8.21994 10 7.33339 10C6.53277 10 6.07123 9.50422 6.00893 9.11417C6.00893 9.11417 6.00927 9.10975 6.0096 9.10656C6.0116 9.08755 6.0169 9.05572 6.02991 9.00368L6.21273 8.2724C6.40053 7.52122 6.52158 7.04388 6.65414 6.69591C6.77713 6.37308 6.87191 6.2698 6.9462 6.2118C7.02049 6.1538 7.14366 6.0869 7.48669 6.04588C7.77795 6.01105 8.14536 6.00263 8.66672 6.00062ZM15.3334 9.00001C15.3334 9.41323 15.7802 10 16.6667 10C17.4673 10 17.9289 9.50422 17.9912 9.11417C17.9912 9.11417 17.9908 9.10975 17.9905 9.10656C17.9885 9.08755 17.9832 9.05572 17.9702 9.00368L17.7874 8.2724C17.5996 7.52122 17.4785 7.04388 17.346 6.69591C17.223 6.37308 17.1282 6.2698 17.0539 6.2118C16.9796 6.1538 16.8564 6.0869 16.5134 6.04588C16.2221 6.01105 15.8547 6.00262 15.3332 6.00062L15.3334 9.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.6667 12.9999C17.4894 12.9999 18.3263 12.7722 19.0426 12.3447L19.0585 12.853C19.102 14.2463 19.1379 15.3936 19.0431 16.3027C18.9436 17.2562 18.6879 18.102 18.0271 18.7838C17.3652 19.4667 16.5234 19.748 15.5694 19.8769C15.3154 19.9112 15.0423 19.9359 14.7501 19.9538V17C14.7501 16.0335 13.9666 15.25 13.0001 15.25H11.0001C10.0336 15.25 9.25006 16.0335 9.25006 17V19.9479C9.00687 19.9313 8.77758 19.9094 8.56212 19.8806C7.62721 19.7556 6.80101 19.4829 6.14303 18.822C5.48623 18.1622 5.21651 17.339 5.09528 16.4075C4.9798 15.5201 4.98483 14.3991 4.99094 13.0394L4.99395 12.3662C5.70213 12.7798 6.5246 12.9999 7.33339 12.9999C8.15315 12.9999 8.96748 12.7786 9.66672 12.3697C10.366 12.7786 11.1803 12.9999 12.0001 12.9999C12.8198 12.9999 13.6341 12.7786 14.3334 12.3697C15.0326 12.7786 15.847 12.9999 16.6667 12.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.2501 19.9969C12.8862 19.9999 12.5018 19.9999 12.0966 19.9999H11.9544C11.5298 19.9999 11.1284 19.9999 10.7501 19.9964V17C10.7501 16.8619 10.862 16.75 11.0001 16.75H13.0001C13.1381 16.75 13.2501 16.8619 13.2501 17V19.9969Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Store-old-slash-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["store","shop","closed","unavailable","offline","inactive","disabled","store-closed","shop-closed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 11L6.00037 15M6.00074 19L6.00037 15M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M6.00037 15L11 15M11 15V11M11 15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 19L6.00074 19L11.0004 19H18.0001H20"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4.87749 8.36754L5.0883 7.73509C5.52832 6.41505 5.74832 5.75503 6.2721 5.37752C6.79587 5 7.49159 5 8.88304 5H11.9993H12.0007H15.117C16.5084 5 17.2041 5 17.7279 5.37752C18.2517 5.75503 18.4717 6.41505 18.9117 7.73509L19.1225 8.36754C19.5229 9.5688 19.7231 10.1694 19.4238 10.5847C19.1245 11 18.4914 11 17.2251 11H6.77485C5.50862 11 4.87551 11 4.57618 10.5847C4.27686 10.1694 4.47707 9.5688 4.87749 8.36754Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M20 20L4 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Store-old-slash-1": {
        defaultColors: ["#3D4C66", "#8E5EE5"],
        keywords: ["store","shop","unavailable","closed","inactive","disabled","offline","location-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 11L6.00037 15M6.00074 19L6.00037 15M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M6.00037 15L11 15M11 15V11M11 15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 20L4 4" stroke={colors?.[1] || "#8E5EE5"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Store-old-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","closed","unavailable","disabled","inactive","offline","deactivated","store-closed","store-offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.9996 19.0001C20.9996 18.4501 20.5496 18.0001 19.9996 18.0001H19.4096L18.9996 17.5901V11.9101C19.5196 11.8101 19.9296 11.6001 20.2396 11.1701C20.8396 10.3401 20.5296 9.43006 20.0696 8.05006L19.8596 7.42006C19.3896 5.99006 19.0996 5.13006 18.3096 4.57006C17.5196 4.00006 16.6196 4.00006 15.1096 4.00006H8.87957C7.48957 4.00006 6.61957 4.02006 5.87957 4.47006L4.70957 3.29006C4.31957 2.90006 3.67957 2.90006 3.28957 3.29006C2.89957 3.68006 2.89957 4.32006 3.28957 4.71006L19.2896 20.7101C19.4896 20.9101 19.7396 21.0001 19.9996 21.0001C20.2596 21.0001 20.5096 20.9001 20.7096 20.7101C21.0396 20.3801 21.0696 19.8901 20.8496 19.5001C20.9396 19.3501 20.9996 19.1901 20.9996 19.0001ZM16.9996 12.0001V15.5901L13.4096 12.0001H16.9996Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.9996 18.0001V15.7201L9.99957 13.7201V14.0001H6.99957V12.0001H8.27957L4.02957 7.75006L3.92957 8.06006C3.46957 9.43006 3.16957 10.3401 3.76957 11.1701C4.07957 11.6001 4.48957 11.8001 4.99957 11.9001V18.0001H3.99957C3.44957 18.0001 2.99957 18.4501 2.99957 19.0001C2.99957 19.5501 3.44957 20.0001 3.99957 20.0001H16.2796L14.2796 18.0001H11.9996ZM9.99957 18.0001H6.99957V16.0001H9.99957V18.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "street-view-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["customer","location","user","profile","account","manage","navigate","here","people","staff","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 13V13C17 12.0681 17 11.6022 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13H16.4C15.4572 13 14.9858 13 14.6929 13.2929C14.4 13.5858 14.4 14.0572 14.4 15V16C14.4 16.9428 14.4 17.4142 14.1071 17.7071C13.8142 18 13.3428 18 12.4 18H11.6C10.6572 18 10.1858 18 9.89289 17.7071C9.6 17.4142 9.6 16.9428 9.6 16V15C9.6 14.0572 9.6 13.5858 9.30711 13.2929C9.01421 13 8.54281 13 7.6 13H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3333 16C18.97 16.4196 20 17.0295 20 17.7082C20 18.9739 16.4183 20 12 20C7.58172 20 4 18.9739 4 17.7082C4 17.0295 5.03 16.4197 6.66667 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Store-old-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["store","shop","closed","unavailable","out-of-service","offline","disable","disable-store","store-closed","store-offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 5H8.88304C7.49159 5 6.79587 5 6.2721 5.37752C5.74832 5.75503 5.52832 6.41505 5.0883 7.73509L4.87749 8.36754C4.47707 9.5688 4.27686 10.1694 4.57618 10.5847C4.87551 11 5.50862 11 6.77485 11H17.2251C18.4914 11 19.1245 11 19.4238 10.5847C19.7231 10.1694 19.5229 9.5688 19.1225 8.36754L18.9117 7.73509C18.4717 6.41505 18.2517 5.75503 17.7279 5.37752C17.2041 5 16.5084 5 15.117 5H11.9993"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 11L6.00037 15M6.00074 19L6.00037 15M6.00074 19L11.0004 19M6.00074 19L4 19M18.0001 19L18 11M18.0001 19H20M18.0001 19H11.0004M6.00037 15L11 15M11 15V11M11 15L11.0004 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 20L4 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "street-view-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["customer","person","user","profile","account","client","location","store","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13H7.6C8.54281 13 9.01421 13 9.30711 13.2929C9.6 13.5858 9.6 14.0572 9.6 15V16C9.6 16.9428 9.6 17.4142 9.89289 17.7071C10.1858 18 10.6572 18 11.6 18H12.4C13.3428 18 13.8142 18 14.1071 17.7071C14.4 17.4142 14.4 16.9428 14.4 16V15C14.4 14.0572 14.4 13.5858 14.6929 13.2929C14.9858 13 15.4572 13 16.4 13C16.7314 13 17.0019 12.7311 16.9978 12.3998C16.9911 11.8482 16.9631 11.5132 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3333 16C18.97 16.4196 20 17.0295 20 17.7082C20 18.9739 16.4183 20 12 20C7.58172 20 4 18.9739 4 17.7082C4 17.0295 5.03 16.4197 6.66667 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    store: {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","person","user","profile","account","client","location","store","view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9L18.7575 8.02986C18.3937 6.57474 18.2118 5.84718 17.6693 5.42359C17.1267 5 16.3768 5 14.8769 5H9.12311C7.6232 5 6.87325 5 6.33073 5.42359C5.78821 5.84718 5.60632 6.57474 5.24254 8.02986L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 9.00001C19 10.1046 17.9553 11 16.6667 11C15.378 11 14.3333 10.1046 14.3333 9.00001M14.3333 9.00001C14.3333 10.1046 13.2887 11 12 11C10.7113 11 9.66667 10.1046 9.66667 9.00001M14.3333 9.00001L14.3331 5.00001M9.66667 9.00001C9.66667 10.1046 8.622 11 7.33333 11C6.04467 11 5 10.1046 5 9.00001M9.66667 9.00001V5.00001"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.99958 11L5.99077 12.9732C5.97809 15.8132 5.97175 17.2332 6.85124 18.1166C7.73072 19 9.16197 19 12.0245 19V19C14.9579 19 16.4245 19 17.3086 18.0879C18.1926 17.1759 18.1471 15.7214 18.0562 12.8126L17.9996 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.25 19C13.25 19.4142 13.5858 19.75 14 19.75C14.4142 19.75 14.75 19.4142 14.75 19H13.25ZM10.75 19V16H9.25V19H10.75ZM13.25 16V19H14.75V16H13.25ZM11 15.75H13V14.25H11V15.75ZM14.75 16C14.75 15.0335 13.9665 14.25 13 14.25V15.75C13.1381 15.75 13.25 15.8619 13.25 16H14.75ZM10.75 16C10.75 15.8619 10.8619 15.75 11 15.75V14.25C10.0335 14.25 9.25 15.0335 9.25 16H10.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sun rise-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sunrise","sunset","vacation","resort","beach","daily-special","happy-hour","seafood","ocean","water","view","morning","evening"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8.45455V6M18 9L17 10M7 10L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96572 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "street-view": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","person","user","account","profile","location","address","employee","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 13V13C17 12.0681 17 11.6022 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13H16.4C15.4572 13 14.9858 13 14.6929 13.2929C14.4 13.5858 14.4 14.0572 14.4 15V16C14.4 16.9428 14.4 17.4142 14.1071 17.7071C13.8142 18 13.3428 18 12.4 18H11.6C10.6572 18 10.1858 18 9.89289 17.7071C9.6 17.4142 9.6 16.9428 9.6 16V15C9.6 14.0572 9.6 13.5858 9.30711 13.2929C9.01421 13 8.54281 13 7.6 13H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3333 16C18.97 16.4196 20 17.0295 20 17.7082C20 18.9739 16.4183 20 12 20C7.58172 20 4 18.9739 4 17.7082C4 17.0295 5.03 16.4197 6.66667 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "street-view-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","person","location","user","profile","current-location","service-area","loyalty-member","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3.25C10.4812 3.25 9.25 4.48122 9.25 6C9.25 7.51878 10.4812 8.75 12 8.75C13.5188 8.75 14.75 7.51878 14.75 6C14.75 4.48122 13.5188 3.25 12 3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.1454 9.27077C14.8408 9.24999 14.4697 9.24999 14.0253 9.25H9.97474C9.53028 9.24999 9.15925 9.24999 8.85464 9.27077C8.53754 9.29241 8.23801 9.33905 7.94762 9.45933C7.27379 9.73844 6.73844 10.2738 6.45933 10.9476C6.33905 11.238 6.29241 11.5375 6.27077 11.8546C6.24999 12.1592 6.24999 12.5303 6.25 12.9747V13C6.25 13.4142 6.58579 13.75 7 13.75H7.6C8.09261 13.75 8.38661 13.7516 8.59734 13.7799C8.69389 13.7929 8.74226 13.8082 8.76404 13.8172C8.76908 13.8192 8.7724 13.8209 8.77433 13.8219L8.77676 13.8232L8.77814 13.8257C8.77915 13.8276 8.78077 13.8309 8.78284 13.836C8.7918 13.8577 8.80709 13.9061 8.82008 14.0027C8.84841 14.2134 8.85 14.5074 8.85 15L8.85 16.0447C8.84995 16.4776 8.8499 16.8744 8.8933 17.1972C8.94109 17.5527 9.05354 17.9284 9.36256 18.2374C9.67159 18.5465 10.0473 18.6589 10.4028 18.7067C10.7256 18.7501 11.1224 18.7501 11.5552 18.75H12.4447C12.8776 18.7501 13.2744 18.7501 13.5972 18.7067C13.9527 18.6589 14.3284 18.5465 14.6374 18.2374C14.9465 17.9284 15.0589 17.5527 15.1067 17.1972C15.1501 16.8744 15.1501 16.4776 15.15 16.0448L15.15 15C15.15 14.5074 15.1516 14.2134 15.1799 14.0027C15.1929 13.9061 15.2082 13.8577 15.2172 13.836L15.2194 13.8308L15.2219 13.8257L15.2232 13.8232L15.2257 13.8219L15.2295 13.82L15.236 13.8172C15.2577 13.8082 15.3061 13.7929 15.4027 13.7799C15.6134 13.7516 15.9074 13.75 16.4 13.75C17.141 13.75 17.7571 13.1479 17.7478 12.3906C17.7411 11.8483 17.7182 11.3762 17.5407 10.9476C17.2616 10.2738 16.7262 9.73844 16.0524 9.45933C15.762 9.33905 15.4625 9.29241 15.1454 9.27077Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.3647 16.7516C16.5018 16.2167 17.0467 15.8942 17.5817 16.0313C18.4486 16.2536 19.2263 16.5427 19.8117 16.9097C20.3477 17.2459 21 17.8288 21 18.7082C21 19.5309 20.4258 20.0939 19.9321 20.4283C19.404 20.7859 18.7055 21.0686 17.9322 21.2901C16.3721 21.737 14.2751 22 12 22C9.7249 22 7.62785 21.737 6.06775 21.2901C5.29448 21.0686 4.596 20.7859 4.0679 20.4283C3.57419 20.0939 3 19.5309 3 18.7082C3 17.8288 3.65227 17.2459 4.18833 16.9097C4.7737 16.5427 5.55142 16.2536 6.4183 16.0313C6.95328 15.8942 7.49816 16.2167 7.63533 16.7516C7.7725 17.2866 7.45001 17.8315 6.91503 17.9687C6.14525 18.166 5.58963 18.3917 5.25084 18.6042C5.18778 18.6437 5.13859 18.6784 5.10042 18.708C5.12524 18.7273 5.15467 18.7488 5.18946 18.7723C5.471 18.963 5.94409 19.1742 6.61854 19.3674C7.95387 19.75 9.85682 20 12 20C14.1432 20 16.0461 19.75 17.3815 19.3674C18.0559 19.1742 18.529 18.963 18.8105 18.7723C18.8453 18.7488 18.8748 18.7273 18.8996 18.708C18.8614 18.6784 18.8122 18.6437 18.7492 18.6042C18.4104 18.3917 17.8548 18.166 17.085 17.9687C16.55 17.8315 16.2275 17.2866 16.3647 16.7516Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sun rise-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sunrise","sunset","day-end","day-start","end-of-day","start-of-day","schedule","shift","daily-sales","reports","business-hours"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8.45455V6M18 9L17 10M7 10L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11C9.79086 11 7.8906 12.9576 8 15.3284C8.65537 15.707 9.47351 15.6843 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5265 15.6843 15.3446 15.707 16 15.3284C16 13 14.2091 11 12 11Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M8 15.3284C7.8906 12.9576 9.79086 11 12 11C14.2091 11 16 13 16 15.3284M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96571 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sun rise": {
        defaultColors: ["#3D4C66"],
        keywords: ["sunrise","day-start","new-day","refresh","restart","daily-special","open","opening-hours","daily-deals"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8.45455V6M18 9L17 10M7 10L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96572 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sun rise-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sun","sunrise","sunset","day","night","ocean","water","open","opening","close","closing","shift","morning","evening","daily-report","sales-report","timeline","schedule","refresh","wave","sea"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V8.45455C11 9.00683 11.4477 9.45455 12 9.45455C12.5523 9.45455 13 9.00683 13 8.45455V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071C8.09763 10.3166 8.09763 9.68342 7.70711 9.29289L6.70711 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L16.2929 9.29289C15.9024 9.68342 15.9024 10.3166 16.2929 10.7071C16.6834 11.0976 17.3166 11.0976 17.7071 10.7071L18.7071 9.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.09565 18.5256C6.44433 18.3263 6.87839 18.355 7.19783 18.5984L7.5568 18.8719C8.63078 19.6902 10.1191 19.6902 11.1931 18.8719L11.3939 18.7189C11.7519 18.4461 12.248 18.4461 12.606 18.7189L12.8068 18.8719C13.8808 19.6902 15.3691 19.6902 16.4431 18.8719L16.802 18.5984C17.1215 18.355 17.5555 18.3263 17.9042 18.5256L18.5038 18.8682C18.9833 19.1422 19.5942 18.9756 19.8682 18.4961C20.1422 18.0166 19.9756 17.4057 19.4961 17.1317L18.8965 16.7891C17.8504 16.1913 16.5483 16.2774 15.5899 17.0075L15.231 17.281C14.873 17.5538 14.3769 17.5538 14.0189 17.281L13.8181 17.128C12.7441 16.3097 11.2558 16.3097 10.1818 17.128L9.98097 17.281C9.62298 17.5538 9.12688 17.5538 8.76888 17.281L8.40991 17.0075C7.45158 16.2774 6.14942 16.1913 5.10337 16.7891L4.50379 17.1317C4.02427 17.4057 3.85767 18.0166 4.13168 18.4961C4.40569 18.9756 5.01655 19.1422 5.49607 18.8682L6.09565 18.5256Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5002 16.1943C16.5557 16.1622 16.6103 16.1283 16.6641 16.0925L17.589 15.4759C17.8875 15.2768 18.2699 15.253 18.5909 15.4135L19.5528 15.8944C20.0467 16.1414 20.6474 15.9412 20.8944 15.4472C21.1414 14.9532 20.9412 14.3526 20.4472 14.1056L19.4853 13.6246C18.6131 13.1885 17.5899 13.206 16.7391 13.657C16.0839 11.5984 14.2584 10 12 10C9.78358 10 7.85508 11.5398 7.21798 13.6347C6.37588 13.2056 5.37223 13.1958 4.51465 13.6246L3.55276 14.1056C3.05878 14.3526 2.85856 14.9532 3.10555 15.4472C3.35254 15.9412 3.95321 16.1414 4.44719 15.8944L5.40908 15.4135C5.73005 15.253 6.1124 15.2768 6.41099 15.4759L7.33587 16.0925C7.38961 16.1283 7.44426 16.1622 7.49975 16.1943C8.48304 16.7623 9.71015 16.7284 10.6641 16.0925L11.4453 15.5717C11.7812 15.3477 12.2188 15.3477 12.5547 15.5717L13.3359 16.0925C14.2898 16.7284 15.5169 16.7623 16.5002 16.1943Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sun-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sun","brightness","day","time","schedule","weather","outdoor","season","summer","holiday","vacation","light","morning","noon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1046 16 14.1046 15.5523 14.8284 14.8284C15.5523 14.1046 16 13.1046 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 5V4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L7 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L18 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 7L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sun-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["weather","forecast","cloudy","partly-cloudy","sun","day","seasonal","promotion","seasonal-promotion","special-offer","happy-hour","time-based-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 12.1213C17.6642 11.5784 18 10.8284 18 10C18 8.34315 16.6569 7 15 7C14.1115 7 13.3132 7.38625 12.7639 8M15 5V4M20 10H21M19 6L20 5M11 6L10 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14C15 13.3039 14.8815 12.6356 14.6635 12.014M14.6635 12.014C14.7744 12.0047 14.8867 12 15 12C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H9C5.68629 20 3 17.3137 3 14C3 10.6863 5.68629 8 9 8C11.6176 8 13.8438 9.67628 14.6635 12.014Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sun-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sun","brightness","daylight","mode","light","theme","sunny","open-hours","operating-hours","schedule","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1046 16 14.1046 15.5523 14.8284 14.8284C15.5523 14.1046 16 13.1046 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 5V4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L7 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L18 18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 7L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sun-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sun","day","weather","seasonal","summer","outdoors","solar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C12.5523 3 13 3.44772 13 4V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4C11 3.44772 11.4477 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.3804 17 14.6318 16.4393 15.5355 15.5355C16.4393 14.6318 17 13.3804 17 12C17 9.23858 14.7614 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.70711 18.7071L7.70711 17.7071C8.09763 17.3166 8.09763 16.6834 7.70711 16.2929C7.31658 15.9024 6.68342 15.9024 6.29289 16.2929L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 18C12.5523 18 13 18.4477 13 19V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19C11 18.4477 11.4477 18 12 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 17.2929L17.7071 16.2929C17.3166 15.9024 16.6834 15.9024 16.2929 16.2929C15.9024 16.6834 15.9024 17.3166 16.2929 17.7071L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18 12C18 11.4477 18.4477 11 19 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19C18.4477 13 18 12.5523 18 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L16.2929 6.29289C15.9024 6.68342 15.9024 7.31658 16.2929 7.70711C16.6834 8.09763 17.3166 8.09763 17.7071 7.70711L18.7071 6.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sun-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["weather","cloudy","sun","forecast","today","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5V4M20 10H21M19 6L20 5M11 6L10 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="15"
                    cy="10"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3 14C3 17.3137 5.68629 20 9 20H15C17.2091 20 19 18.2091 19 16C19 13.7909 17.2091 12 15 12C14.8867 12 14.7744 12.0047 14.6635 12.014C13.8438 9.67628 11.6176 8 9 8C5.68629 8 3 10.6863 3 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M15 14C15 13.3039 14.8815 12.6356 14.6635 12.014M14.6635 12.014C14.7744 12.0047 14.8867 12 15 12C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H9C5.68629 20 3 17.3137 3 14C3 10.6863 5.68629 8 9 8C11.6176 8 13.8438 9.67628 14.6635 12.014Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sun-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["weather","cloud","sun","forecast","partly-cloudy","environment","event"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 3C16 2.44772 15.5523 2 15 2C14.4477 2 14 2.44772 14 3V4C14 4.55228 14.4477 5 15 5C15.5523 5 16 4.55228 16 4V3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.7071 3.79289C10.3166 3.40237 9.68342 3.40237 9.29289 3.79289C8.90237 4.18342 8.90237 4.81658 9.29289 5.20711L10.2929 6.20711C10.6834 6.59763 11.3166 6.59763 11.7071 6.20711C12.0976 5.81658 12.0976 5.18342 11.7071 4.79289L10.7071 3.79289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.2071 5.20711C21.5976 4.81658 21.5976 4.18342 21.2071 3.79289C20.8166 3.40237 20.1834 3.40237 19.7929 3.79289L18.7929 4.79289C18.4024 5.18342 18.4024 5.81658 18.7929 6.20711C19.1834 6.59763 19.8166 6.59763 20.2071 6.20711L21.2071 5.20711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 6C13.8152 6 12.7498 6.51635 12.0188 7.33309C11.9451 7.41542 11.8875 7.50659 11.8459 7.60271C10.9766 7.21536 10.0136 7 9 7C5.13401 7 2 10.134 2 14C2 17.866 5.13401 21 9 21H15C17.7614 21 20 18.7614 20 16C20 14.5067 19.3454 13.1663 18.3074 12.2501C18.744 11.6092 19 10.834 19 10C19 7.79086 17.2091 6 15 6ZM16.5623 11.2489C16.8369 10.9062 17 10.4729 17 10C17 8.89543 16.1046 8 15 8C14.4136 8 13.8871 8.25114 13.5199 8.65484C14.2799 9.29826 14.9008 10.1008 15.3312 11.0108C15.7584 11.0387 16.171 11.1203 16.5623 11.2489ZM14.8815 13.007C15.4299 12.9415 15.9276 13.333 15.993 13.8814C16.0259 14.1564 16.0427 14.4359 16.0427 14.719C16.0427 15.2712 15.595 15.719 15.0427 15.719C14.4904 15.719 14.0427 15.2712 14.0427 14.719C14.0427 14.5154 14.0306 14.315 14.0072 14.1186C13.9417 13.5702 14.3331 13.0725 14.8815 13.007Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 9C20.4477 9 20 9.44772 20 10C20 10.5523 20.4477 11 21 11H22C22.5523 11 23 10.5523 23 10C23 9.44772 22.5523 9 22 9H21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "sun-set-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sunset","time","end-of-day","close","closing","day-end","end","finish"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 15H16M16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15M16 15H8M8 15H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8.45455V6M18 9L17 10M7 10L6 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sun-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["weather","sun","cloud","forecast","environment","time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 12.1213C17.6642 11.5784 18 10.8284 18 10C18 8.34315 16.6569 7 15 7C14.1115 7 13.3132 7.38625 12.7639 8M15 5V4M20 10H21M19 6L20 5M11 6L10 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14C15 13.3039 14.8815 12.6356 14.6635 12.014M14.6635 12.014C14.7744 12.0047 14.8867 12 15 12C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H9C5.68629 20 3 17.3137 3 14C3 10.6863 5.68629 8 9 8C11.6176 8 13.8438 9.67628 14.6635 12.014Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "sun-set-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sunset","end-of-day","close-day","closing","shift-end","day-end","logout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 11C9.79086 11 8 12.7909 8 15H16C16 12.7909 14.2091 11 12 11Z" fill={colors?.[0] || "#D9D1E0"} />
                <path
                    d="M20 15H16M16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15M16 15H8M8 15H4"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8.45455V6M18 9L17 10M7 10L6 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    sun: {
        defaultColors: ["#3D4C66"],
        keywords: ["sunset","end-of-day","close-day","closing","shift-end","day-end","logout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 12C8 14.2091 9.79086 16 12 16C13.1046 16 14.1046 15.5523 14.8284 14.8284C15.5523 14.1046 16 13.1046 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 5V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L7 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 19V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L18 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 7L18 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 7L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "sun-set": {
        defaultColors: ["#3D4C66"],
        keywords: ["sun","sunset","horizon","setting","day-end","close-of-day","daily-report","end-of-shift","shift-end","summary","end-of-day","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 8.45455V6M18 9L17 10M20 15H16M16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15M16 15H8M8 15H4M7 10L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 18H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "sun-set-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sunset","weather","time","end-of-day","shift-end","close","closing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V8.45455C11 9.00683 11.4477 9.45455 12 9.45455C12.5523 9.45455 13 9.00683 13 8.45455V6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071C8.09763 10.3166 8.09763 9.68342 7.70711 9.29289L6.70711 8.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L16.2929 9.29289C15.9024 9.68342 15.9024 10.3166 16.2929 10.7071C16.6834 11.0976 17.3166 11.0976 17.7071 10.7071L18.7071 9.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 14H7.10002C7.56329 11.7178 9.58104 10 12 10C14.419 10 16.4367 11.7178 16.9 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 18C6 17.4477 6.44772 17 7 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H7C6.44772 19 6 18.5523 6 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "support-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","customer-support","help","technical-support","contact","service","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10.8L5 9M5 15L9 13.2"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13.2L19 15M19 9L15 10.8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.8 15L9 19M15 19L13.2 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2 9L15 5M9 5L10.8 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "support-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wheel","settings","configurations","support","options","cog","gear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM5 12C5 11.3782 5.08106 10.7754 5.23319 10.2015L8.03578 11.4627C8.01218 11.6384 8 11.8178 8 12C8 12.1822 8.01218 12.3616 8.03578 12.5373L5.2332 13.7985C5.08106 13.2246 5 12.6218 5 12ZM8.79227 9.60994L6.01857 8.36177C6.60108 7.40615 7.40615 6.60108 8.36177 6.01857L9.60994 8.79227C9.29955 9.02391 9.02391 9.29955 8.79227 9.60994ZM11.4627 8.03578C11.6384 8.01218 11.8178 8 12 8C12.1822 8 12.3616 8.01218 12.5373 8.03578L13.7985 5.2332C13.2246 5.08106 12.6218 5 12 5C11.3782 5 10.7754 5.08106 10.2015 5.23319L11.4627 8.03578ZM15.6382 6.01857L14.3901 8.79227C14.7005 9.02392 14.9761 9.29955 15.2077 9.60994L17.9814 8.36177C17.3989 7.40615 16.5939 6.60108 15.6382 6.01857ZM15.9642 11.4627C15.9878 11.6384 16 11.8178 16 12C16 12.1822 15.9878 12.3616 15.9642 12.5373L18.7668 13.7985C18.9189 13.2246 19 12.6218 19 12C19 11.3782 18.9189 10.7754 18.7668 10.2015L15.9642 11.4627ZM17.9814 15.6382L15.2077 14.3901C14.9761 14.7005 14.7005 14.9761 14.3901 15.2077L15.6382 17.9814C16.5939 17.3989 17.3989 16.5939 17.9814 15.6382ZM12 16C12.1822 16 12.3616 15.9878 12.5373 15.9642L13.7985 18.7668C13.2246 18.9189 12.6218 19 12 19C11.3782 19 10.7754 18.9189 10.2015 18.7668L11.4627 15.9642C11.6384 15.9878 11.8178 16 12 16ZM9.60994 15.2077L8.36177 17.9814C7.40615 17.3989 6.60108 16.5939 6.01857 15.6382L8.79227 14.3901C9.02392 14.7005 9.29955 14.9761 9.60994 15.2077Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "support-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","wheel","settings","options","configurations","help","service","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 10.8L5 9M5 15L9 13.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13.2L19 15M19 9L15 10.8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.8 15L9 19M15 19L13.2 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2 9L15 5M9 5L10.8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "support-life-ring-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","life-ring","help","assistance","customer-service","settings","options","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4V8M12 20V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L8 12M20 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 6L9 9M18 18L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 9M6 18L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "support-life-ring-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","help","life ring","customer service","assistance","faq","guidance","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 4V8M12 20V16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L8 12M20 12L16 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 6L9 9M18 18L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 9M6 18L9 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "support-life-ring-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","life ring","help","assistance","customer service","faq","troubleshooting","guidance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 8.99998" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 12C16 9.79087 14.2091 8 12 8V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "support-life-ring-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wheel","settings","configurations","support","life ring","help","options","control","steering"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V4.06189C14.4607 4.24404 15.7991 4.81999 16.9056 5.68014L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L18.3199 7.09436C19.18 8.20088 19.756 9.53929 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.9381C19.756 14.4607 19.18 15.7991 18.3199 16.9056L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L16.9056 18.3199C15.7991 19.18 14.4607 19.756 13 19.9381V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C9.53929 19.756 8.20088 19.18 7.09436 18.3199L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L5.68014 16.9056C4.81999 15.7991 4.24404 14.4607 4.06189 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.06189C4.24404 9.53929 4.81999 8.20088 5.68014 7.09436L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L7.09436 5.68014C8.20088 4.81999 9.53929 4.24404 11 4.06189V4C11 3.44772 11.4477 3 12 3ZM11 6.08296C10.0883 6.23591 9.2464 6.59444 8.52347 7.10925L9.96803 8.55382C10.2863 8.36573 10.633 8.22048 11 8.12602V6.08296ZM13 8.12602C13.367 8.22048 13.7137 8.36573 14.032 8.55382L15.4765 7.10925C14.7536 6.59444 13.9117 6.23591 13 6.08296V8.12602ZM16.8907 8.52347L15.4462 9.96803C15.6343 10.2863 15.7795 10.633 15.874 11H17.917C17.7641 10.0883 17.4056 9.2464 16.8907 8.52347ZM17.917 13H15.874C15.7795 13.367 15.6343 13.7137 15.4462 14.032L16.8907 15.4765C17.4056 14.7536 17.7641 13.9117 17.917 13ZM15.4765 16.8907L14.032 15.4462C13.7137 15.6343 13.367 15.7795 13 15.874V17.917C13.9117 17.7641 14.7536 17.4056 15.4765 16.8907ZM11 17.917V15.874C10.633 15.7795 10.2863 15.6343 9.96803 15.4462L8.52347 16.8907C9.2464 17.4056 10.0883 17.7641 11 17.917ZM7.10925 15.4765L8.55382 14.032C8.36573 13.7137 8.22048 13.367 8.12602 13H6.08296C6.23591 13.9117 6.59444 14.7536 7.10925 15.4765ZM6.08296 11H8.12602C8.22048 10.633 8.36573 10.2863 8.55382 9.96803L7.10925 8.52347C6.59444 9.2464 6.23591 10.0883 6.08296 11ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "support-life-ring-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","help","customer-service","life-ring","assistance","contact","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4V8M12 20V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12L8 12M20 12L16 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 6L9 9M18 18L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 9M6 18L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "support-life-ring-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","help","life ring","customer service","assistance","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="12"
                    r="7"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M19 12H20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L6 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 8.99998" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "support-life-ring-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","life ring","help","assistance","customer support","customer service","service","guidance","troubleshooting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M18 18L15 15M6 6L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M6 18L9 15M18 6L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "support-life-ring-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","help","life ring","assistance","customer service","faq"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M18 18L15 15M6 6L9 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M6 18L9 15M18 6L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "support-life-ring-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","help","lifebuoy","assistance","customer-service","service","rescue","guidance","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 18L15 15M6 6L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 18L9 15M18 6L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "support-life-ring-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","help","life ring","customer service","assistance","faq","guidance","troubleshooting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.38246 4.96799C7.92211 3.73643 9.87505 3 12 3C14.1442 3 16.1133 3.74985 17.6593 5.00162L14.7578 7.82849C13.9673 7.30497 13.0195 7.00009 12.0004 7.00009C10.9813 7.00009 10.0334 7.30497 9.24299 7.82849L6.38246 4.96799Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.96822 6.38217C3.73652 7.92186 3 9.87492 3 12C3 14.125 3.73649 16.0781 4.96814 17.6177L7.82878 14.7575C7.30526 13.9671 7.00038 13.0192 7.00038 12.0001C7.00038 10.981 7.30526 10.0331 7.82878 9.2427L4.96822 6.38217Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.38237 19.0319C7.92203 20.2635 9.87501 21 12 21C14.1059 21 16.0429 20.2767 17.5761 19.065L14.7578 16.1717C13.9673 16.6952 13.0195 17.0001 12.0004 17.0001C10.9813 17.0001 10.0334 16.6952 9.24299 16.1717L6.38237 19.0319Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.9985 17.6592C20.2502 16.1132 21 14.1441 21 12C21 9.89415 20.2768 7.95722 19.0651 6.42407L16.172 9.2427C16.6955 10.0331 17.0004 10.981 17.0004 12.0001C17.0004 13.0192 16.6955 13.9671 16.172 14.7575L18.9985 17.6592Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "support-life-ring-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","help","life ring","settings","configuration","ship wheel","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C12.5523 3 13 3.44772 13 4V4.06189C14.4607 4.24404 15.7991 4.81999 16.9056 5.68014L17.2929 5.29288C17.6834 4.90235 18.3166 4.90235 18.7071 5.29287C19.0976 5.68339 19.0976 6.31656 18.7071 6.70709L18.3198 7.09435C19.18 8.20087 19.7559 9.53929 19.9381 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19.9381C19.7559 14.4607 19.18 15.7991 18.3198 16.9056L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L16.9056 18.3198C15.7991 19.18 14.4607 19.756 13 19.9381V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V19.9381C9.53929 19.756 8.20088 19.18 7.09436 18.3199L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L5.68015 16.9056C4.82 15.7991 4.24406 14.4607 4.06191 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.06191C4.24406 9.5393 4.82 8.20089 5.68015 7.09437L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L7.09436 5.68015C8.20088 4.81999 9.53929 4.24404 11 4.06189V4C11 3.44771 11.4477 3 12 3ZM7.10926 8.52348C6.41081 9.50429 6.00002 10.7042 6.00002 12C6.00002 13.2958 6.41081 14.4957 7.10926 15.4765L8.55382 14.032C8.20194 13.4365 8.00001 12.7418 8.00001 12C8.00001 11.2582 8.20194 10.5635 8.55382 9.96804L7.10926 8.52348ZM9.96803 8.55382L8.52347 7.10926C9.50429 6.41079 10.7042 6 12 6C13.2958 6 14.4957 6.41079 15.4765 7.10925L14.032 8.55382C13.4365 8.20193 12.7418 8 12 8C11.2582 8 10.5635 8.20193 9.96803 8.55382ZM15.4462 9.96804C15.7981 10.5635 16 11.2582 16 12C16 12.7418 15.7981 13.4364 15.4462 14.032L16.8907 15.4765C17.5892 14.4957 18 13.2958 18 12C18 10.7042 17.5892 9.50429 16.8907 8.52347L15.4462 9.96804ZM15.4765 16.8907L14.032 15.4462C13.4365 15.7981 12.7418 16 12 16C11.2582 16 10.5635 15.7981 9.96803 15.4462L8.52347 16.8907C9.50429 17.5892 10.7042 18 12 18C13.2958 18 14.4957 17.5892 15.4765 16.8907ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    support: {
        defaultColors: ["#3D4C66"],
        keywords: ["support","help","life ring","settings","configuration","ship wheel","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 10.8L5 9M5 15L9 13.2"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13.2L19 15M19 9L15 10.8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.8 15L9 19M15 19L13.2 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2 9L15 5M9 5L10.8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "surround-sound-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["surround-sound","audio","sound","volume","broadcast","announcement","alert","notification","speaker","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0242 15C16.6271 14.2361 17 13.1808 17 12.0152C17 10.834 16.6171 9.76616 16 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C7.38289 9.76231 7 10.8248 7 12C7 13.1752 7.38289 14.2377 8 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "surround-sound-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sound","surround","notification","alert","broadcast","volume","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0242 15C16.6271 14.2361 17 13.1808 17 12.0152C17 10.834 16.6171 9.76616 16 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C7.38289 9.76231 7 10.8248 7 12C7 13.1752 7.38289 14.2377 8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "surround-sound-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["broadcast","sound","audio","speaker","volume","multimedia","surround","surround-sound","devices","bluetooth","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 4H9.92943C8.57535 3.99997 7.45868 3.99994 6.57494 4.11876C5.64711 4.2435 4.82769 4.51547 4.17158 5.17158C3.51547 5.82769 3.2435 6.64711 3.11876 7.57494C2.99994 8.45868 2.99997 9.57527 3 10.9294V13.0706C2.99997 14.4247 2.99994 15.5413 3.11876 16.4251C3.2435 17.3529 3.51547 18.1723 4.17158 18.8284C4.82769 19.4845 5.64711 19.7565 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92936 20H14.0706C15.4247 20 16.5413 20.0001 17.4251 19.8813C18.3529 19.7565 19.1723 19.4845 19.8284 18.8284C20.4845 18.1723 20.7565 17.3529 20.8813 16.4251C21.0001 15.5413 21 14.4247 21 13.0706V10.9295C21 9.57537 21.0001 8.45868 20.8813 7.57494C20.7565 6.64711 20.4845 5.82769 19.8284 5.17158C19.1723 4.51547 18.3529 4.2435 17.4251 4.11876C16.5413 3.99994 15.4247 3.99997 14.0706 4ZM16.7788 8.37269C16.4324 7.94258 15.8028 7.87475 15.3727 8.22118C14.9426 8.56762 14.8748 9.19714 15.2212 9.62726C15.6843 10.2022 16 11.0443 16 12.0151C16 12.973 15.6926 13.8059 15.2392 14.3804C14.897 14.8139 14.9711 15.4428 15.4046 15.7849C15.8381 16.1271 16.467 16.053 16.8091 15.6195C17.5615 14.6662 18 13.3885 18 12.0151C18 10.6237 17.5499 9.33006 16.7788 8.37269ZM8.6292 8.22273C9.05846 8.57022 9.12474 9.19991 8.77725 9.62917C8.31489 10.2003 8 11.0363 8 12C8 12.9636 8.3149 13.7996 8.77725 14.3708C9.12474 14.8 9.05846 15.4297 8.6292 15.7772C8.19994 16.1247 7.57025 16.0584 7.22276 15.6292C6.4509 14.6757 6 13.3868 6 12C6 10.6132 6.4509 9.32425 7.22276 8.37078C7.57025 7.94152 8.19994 7.87523 8.6292 8.22273ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "surround-sound": {
        defaultColors: ["#3D4C66"],
        keywords: ["surround-sound","sound","audio","volume","speaker","playback","music","entertainment","device"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19H14C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0242 15C16.6271 14.2361 17 13.1808 17 12.0152C17 10.834 16.6171 9.76616 16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C7.38289 9.76231 7 10.8248 7 12C7 13.1752 7.38289 14.2377 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "support-life-ring": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","life-ring","help","assistance","customer-service","customer-support","faq","radial","waves","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 8.13402 15.866 5 12 5V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 12C16 9.79087 14.2091 8 12 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 12H20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 12H5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 5L12 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 20L12 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 9L6 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 18L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M18 6L15 8.99998" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 18L9 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "swap-calls-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["swap","arrows","transfer","exchange","switch","change","reassign","reverse","trade","convert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 9C6 7.34315 7.34315 6 9 6V6C10.6569 6 12 7.34315 12 9V12L12 15C12 15 12 15 12 15C12 16.6569 13.3431 18 15 18C15 18 15 18 15 18V18C15 18 15 18 15 18C16.6569 18 18 16.6569 18 15C18 15 18 15 18 15V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 14L6 17L3 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L18 7L21 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swap-calls-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["swap","exchange","trade","reverse","return","change","arrows","up-down","toggle","switch","transaction","convert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 17L6 9C6 7.34315 7.34315 6 9 6V6C10.6569 6 12 7.34315 12 9V12L12 15C12 15 12 15 12 15C12 16.6569 13.3431 18 15 18C15 18 15 18 15 18V18C15 18 15 18 15 18C16.6569 18 18 16.6569 18 15C18 15 18 15 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 14L6 17L3 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 10L18 7L21 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swap-calls": {
        defaultColors: ["#3D4C66"],
        keywords: ["swap","switch","change","arrow","arrows","direction","reverse","transaction","exchange","toggle","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15L6 17L4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17L6 9C6 7.34315 7.34315 6 9 6V6C10.6569 6 12 7.34315 12 9V12L12 15C12 15 12 15 12 15C12 16.6569 13.3431 18 15 18C15 18 15 18 15 18V18C15 18 15 18 15 18C16.6569 18 18 16.6569 18 15C18 15 18 15 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 9L18 7L20 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swiming-pool-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["swimming","pool","water","ladder","swim","leisure","activity","pool-access","facility"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14L7 7C7 5.89543 7.89543 5 9 5V5C10.1046 5 11 5.89543 11 7L11 7.72727"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14.5L14 7C14 5.89543 14.8954 5 16 5V5C17.1046 5 18 5.89543 18 7L18 7.72727"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96572 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swiming-pool-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["swimming","pool","water","activity","leisure","recreation","amenity","facility","swim","ladder","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14L7 7C7 5.89543 7.89543 5 9 5V5C10.1046 5 11 5.89543 11 7L11 7.72727"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14.5L14 7C14 5.89543 14.8954 5 16 5V5C17.1046 5 18 5.89543 18 7L18 7.72727"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 11L14 11" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96572 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swiming-pool-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["pool","swimming","water","ladder","swim","recreation","facility"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00022 6C8.44793 6 8.00022 6.44771 8.00022 7V10L13.0002 10V7C13.0002 5.34315 14.3434 4 16.0002 4C17.6571 4 19.0002 5.34315 19.0002 7V7.72727C19.0002 8.27956 18.5525 8.72727 18.0002 8.72727C17.4479 8.72727 17.0002 8.27956 17.0002 7.72727V7C17.0002 6.44772 16.5525 6 16.0002 6C15.4479 6 15.0002 6.44772 15.0002 7L15.0002 14.5C15.0002 14.5325 14.9987 14.5646 14.9956 14.5963C15.1905 14.5972 15.3856 14.5412 15.5549 14.4283L16.4798 13.8118C17.3756 13.2146 18.5226 13.1432 19.4855 13.6246L20.4474 14.1056C20.9414 14.3526 21.1416 14.9532 20.8946 15.4472C20.6477 15.9412 20.047 16.1414 19.553 15.8944L18.5911 15.4135C18.2701 15.253 17.8878 15.2768 17.5892 15.4759L16.6643 16.0925C15.6566 16.7642 14.3438 16.7642 13.3361 16.0925L12.5549 15.5717C12.219 15.3477 11.7814 15.3477 11.4455 15.5717L10.6643 16.0925C9.65662 16.7642 8.34382 16.7642 7.33612 16.0925L6.41123 15.4759C6.11265 15.2768 5.73029 15.253 5.40932 15.4135L4.44743 15.8944C3.95345 16.1414 3.35278 15.9412 3.10579 15.4472C2.8588 14.9532 3.05903 14.3526 3.55301 14.1056L4.51489 13.6246C4.98315 13.3905 5.49495 13.2871 6.00022 13.3114V11.001V10.999V7C6.00022 5.34315 7.34336 4 9.00022 4C10.6571 4 12.0002 5.34315 12.0002 7V7.72727C12.0002 8.27956 11.5525 8.72727 11.0002 8.72727C10.4479 8.72727 10.0002 8.27956 10.0002 7.72727V7C10.0002 6.44772 9.5525 6 9.00022 6ZM8.00022 12V14C8.00022 14.0428 7.99754 14.0849 7.99233 14.1262L8.44552 14.4283C8.78142 14.6523 9.21902 14.6523 9.55492 14.4283L10.3361 13.9075C11.1339 13.3757 12.1228 13.2649 13.0002 13.5751V12H8.00022ZM7.19812 18.5984C6.87868 18.3551 6.44462 18.3264 6.09594 18.5256L5.49636 18.8682C5.01684 19.1423 4.40599 18.9757 4.13198 18.4961C3.85797 18.0166 4.02456 17.4058 4.50408 17.1318L5.10366 16.7891C6.14971 16.1914 7.45188 16.2774 8.41021 17.0076L8.76918 17.2811C9.12717 17.5538 9.62327 17.5538 9.98126 17.2811L10.1821 17.1281C11.2561 16.3098 12.7444 16.3098 13.8183 17.1281L14.0192 17.2811C14.3772 17.5538 14.8733 17.5538 15.2313 17.2811L15.5902 17.0076C16.5486 16.2774 17.8507 16.1914 18.8968 16.7891L19.4964 17.1318C19.9759 17.4058 20.1425 18.0166 19.8685 18.4961C19.5945 18.9757 18.9836 19.1423 18.5041 18.8682L17.9045 18.5256C17.5558 18.3264 17.1218 18.3551 16.8023 18.5984L16.4433 18.8719C15.3694 19.6902 13.8811 19.6902 12.8071 18.8719L12.6063 18.7189C12.2483 18.4462 11.7522 18.4462 11.3942 18.7189L11.1934 18.8719C10.1194 19.6902 8.63107 19.6902 7.55709 18.8719L7.19812 18.5984Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "swap-calls-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["swap","exchange","change","transfer","switch","arrows","toggle","replace","move","reorder"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7C7.89543 7 7 7.89543 7 9V14.5858L8.29289 13.2929C8.68342 12.9024 9.31658 12.9024 9.70711 13.2929C10.0976 13.6834 10.0976 14.3166 9.70711 14.7071L6.70711 17.7071C6.51957 17.8946 6.26522 18 6 18C5.73478 18 5.48043 17.8946 5.29289 17.7071L2.29289 14.7071C1.90237 14.3166 1.90237 13.6834 2.29289 13.2929C2.68342 12.9024 3.31658 12.9024 3.70711 13.2929L5 14.5858V9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9L13 15C13 16.1046 13.8954 17 15 17C16.1046 17 17 16.1046 17 15V9.41421L15.7071 10.7071C15.3166 11.0976 14.6834 11.0976 14.2929 10.7071C13.9024 10.3166 13.9024 9.68342 14.2929 9.29289L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289L21.7071 9.29289C22.0976 9.68342 22.0976 10.3166 21.7071 10.7071C21.3166 11.0976 20.6834 11.0976 20.2929 10.7071L19 9.41421V15C19 17.2091 17.2091 19 15 19C12.7909 19 11 17.2091 11 15L11 9C11 7.89543 10.1046 7 9 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "swiming-pool": {
        defaultColors: ["#3D4C66"],
        keywords: ["pool","swimming","swim","recreation","water","ladder","spa","facility","amenity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14L7 7C7 5.89543 7.89543 5 9 5V5C10.1046 5 11 5.89543 11 7L11 7.72727"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 14.5L14 7C14 5.89543 14.8954 5 16 5V5C17.1046 5 18 5.89543 18 7L18 7.72727"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M7 11L14 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 18L5.59958 17.6574C6.29695 17.2589 7.16506 17.3162 7.80394 17.803L8.16291 18.0765C8.8789 18.622 9.8711 18.622 10.5871 18.0765L10.7879 17.9235C11.5039 17.378 12.4961 17.378 13.2121 17.9235L13.4129 18.0765C14.1289 18.622 15.1211 18.622 15.8371 18.0765L16.1961 17.803C16.8349 17.3162 17.7031 17.2589 18.4004 17.6574L19 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 15L4.96189 14.5191C5.60383 14.1981 6.36854 14.2457 6.96572 14.6438L7.8906 15.2604C8.5624 15.7083 9.4376 15.7083 10.1094 15.2604L10.8906 14.7396C11.5624 14.2917 12.4376 14.2917 13.1094 14.7396L13.8906 15.2604C14.5624 15.7083 15.4376 15.7083 16.1094 15.2604L17.0343 14.6438C17.6315 14.2457 18.3962 14.1981 19.0381 14.5191L20 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-down-alt-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["download","arrow","down","swipe-down","get","receive","import","synchronize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-down-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["swipe","down","arrow","scroll","decrease","reduce","move-down","navigation","load-more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 15.1172C8.16229 14.6412 6 12.1732 6 9.2002C6 5.88649 8.68629 3.2002 12 3.2002C15.3137 3.2002 18 5.88649 18 9.2002C18 12.1732 15.8377 14.6412 13 15.1172C12.9302 15.1289 12.8601 15.1394 12.7895 15.1487C12.9214 15.1318 13 15.1172 13 15.1172V17.786L14.2929 16.4931C14.6834 16.1026 15.3166 16.1026 15.7071 16.4931C16.0976 16.8836 16.0976 17.5168 15.7071 17.9073L14.0828 19.5316C13.783 19.8315 13.4917 20.123 13.219 20.331C12.9116 20.5655 12.5137 20.786 12 20.786C11.4863 20.786 11.0884 20.5655 10.781 20.331C10.5083 20.123 10.217 19.8315 9.91718 19.5316L8.29289 17.9073C7.90237 17.5168 7.90237 16.8836 8.29289 16.4931C8.68342 16.1026 9.31658 16.1026 9.70711 16.4931L11 17.786L11 15.1172Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "swipe-down-alt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["arrow","down","swipe","scroll","refresh","load-more","download","pull-to-refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-right-alt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["swipe","right","next","arrow","proceed","continue","checkout","payment","forward","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L14 12" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7C6.23858 7 4 9.23858 4 12C4 14.7614 6.23858 17 9 17C11.7614 17 14 14.7614 14 12C14 9.23858 11.7614 7 9 7Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-right-alt-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["swipe","right","arrow","next","slide","process","checkout","payment","complete-order","continue","proceed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7C6.23858 7 4 9.23858 4 12C4 14.7614 6.23858 17 9 17C11.7614 17 14 14.7614 14 12C14 9.23858 11.7614 7 9 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-down-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["swipe","down","arrow","decrease","discount","reduce","lower","scroll","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 19V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 17L13.4142 18.5858C12.7475 19.2525 12.4142 19.5858 12 19.5858C11.5858 19.5858 11.2525 19.2525 10.5858 18.5858L9 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-right-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["swipe","right","arrow","next","proceed","continue","forward","submit","checkout","confirm","advance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1241 13C14.648 15.8377 12.18 18 9.20703 18C5.89332 18 3.20703 15.3137 3.20703 12C3.20703 8.68629 5.89332 6 9.20703 6C12.18 6 14.648 8.16229 15.1241 11C15.1358 11.0698 15.1463 11.1401 15.1556 11.2107C15.1386 11.0787 15.1241 11 15.1241 11H17.7928L16.4999 9.70711C16.1094 9.31658 16.1094 8.68342 16.4999 8.29289C16.8904 7.90237 17.5236 7.90237 17.9141 8.29289L19.5384 9.91715C19.8383 10.217 20.1298 10.5083 20.3378 10.781C20.5724 11.0884 20.7928 11.4863 20.7928 12C20.7928 12.5137 20.5724 12.9116 20.3378 13.219C20.1298 13.4917 19.8383 13.783 19.5384 14.0828L17.9141 15.7071C17.5236 16.0976 16.8904 16.0976 16.4999 15.7071C16.1094 15.3166 16.1094 14.6834 16.4999 14.2929L17.7928 13L15.1241 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "swipe-right-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["swipe","right","next","continue","proceed","checkout","arrow","forward","submit","pay","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 7C6.23858 7 4 9.23858 4 12C4 14.7614 6.23858 17 9 17C11.7614 17 14 14.7614 14 12C14 9.23858 11.7614 7 9 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 12L14 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 9L18.5858 10.5858C19.2525 11.2525 19.5858 11.5858 19.5858 12C19.5858 12.4142 19.2525 12.7475 18.5858 13.4142L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-up-alt-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["swipe-up","arrow-up","scroll","upload","next","send","submit","increase","maximize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-up-alt-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["swipe","up","arrow","scroll","payment","process","scroll-up","swipe-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "swipe-up-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","swipe","upload","increase","scroll","scroll-up","send","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 8.86894C11 8.86894 11.0787 8.85436 11.2107 8.83743C8.27004 9.22383 6 11.7398 6 14.786C6 18.0997 8.68629 20.786 12 20.786C15.3137 20.786 18 18.0997 18 14.786C18 11.813 15.8377 9.34502 13 8.86894V6.2002L14.2929 7.49309C14.6834 7.88361 15.3166 7.88361 15.7071 7.49309C16.0976 7.10256 16.0976 6.4694 15.7071 6.07888L14.0828 4.45461C13.783 4.15469 13.4917 3.86321 13.219 3.65517C12.9116 3.42064 12.5137 3.2002 12 3.2002C11.4863 3.2002 11.0884 3.42064 10.781 3.65517C10.5083 3.86321 10.217 4.15468 9.91715 4.4546L8.29289 6.07888C7.90237 6.4694 7.90237 7.10257 8.29289 7.49309C8.68342 7.88361 9.31658 7.88361 9.70711 7.49309L11 6.2002L11 8.86894Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "T-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["T","text","font","title","terminal","threshold"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "T-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["t","text","discount","tier","table","tip","tax"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V6H7C6.44772 6 6 5.55228 6 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "T-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["T","text","discount","t-shape","table","top"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    T: {
        defaultColors: ["#3D4C66"],
        keywords: ["T","text","discount","t-shape","table","top"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.25 19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19H11.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5H12.75ZM7 4.25C6.58579 4.25 6.25 4.58579 6.25 5C6.25 5.41421 6.58579 5.75 7 5.75V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5.75ZM12.75 19V5H11.25V19H12.75ZM7 5.75H17V4.25H7V5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "table-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["table","table-2-1","restaurant","seating","availability","floor-plan","section","dining","room"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["table","grid","tables","restaurant","layout","seating","area","floorplan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M14 10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M5 15H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "table-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","layout","grid","menu","category","arrangement","group","dining-table"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C19.9697 8.23265 19.9923 9.01932 19.998 9.93689C19.9993 9.95776 20 9.9788 20 10C20 10.0174 19.9996 10.0347 19.9987 10.0519C20 10.3322 20 10.6245 20 10.9287V13.0706C20 13.7139 20 14.3036 19.9873 14.8402C19.9957 14.8923 20 14.9456 20 15C20 15.0757 19.9916 15.1494 19.9757 15.2203C19.9587 15.6613 19.93 16.0627 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.1723 19.4845 17.3529 19.7565 16.4251 19.8813C15.7674 19.9697 14.9807 19.9923 14.0631 19.998C14.0422 19.9993 14.0212 20 14 20C13.9826 20 13.9653 19.9996 13.9481 19.9987C13.6676 20 13.3752 20 13.0709 20H10.9294C10.6251 20 10.3323 20 10.0519 19.9987C10.0347 19.9996 10.0174 20 10 20C9.9788 20 9.95776 19.9993 9.93689 19.998C9.01932 19.9923 8.23265 19.9697 7.57494 19.8813C6.64711 19.7565 5.82769 19.4845 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C4.07004 16.0627 4.04131 15.6613 4.02436 15.2203C4.00841 15.1494 4 15.0757 4 15C4 14.9456 4.00434 14.8922 4.0127 14.8402C3.99997 14.3036 3.99998 13.7139 4 13.0706V10.9294C3.99999 10.625 3.99999 10.3325 4.00133 10.052C4.00045 10.0348 4 10.0174 4 10C4 9.97878 4.00066 9.95771 4.00197 9.93681C4.00773 9.01928 4.03033 8.23263 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45869 3.99994 9.57533 3.99997 10.9294 4ZM6.0815 16C6.08752 16.0541 6.09398 16.107 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84144 17.8991C8.17144 17.9435 8.55114 17.9683 9 17.9823V16H6.0815ZM9 14H6.00189C6.00014 13.6933 6 13.3611 6 13V11H9V14ZM11 16L11 18H13L13 16H11ZM13 14H11L11 11H13L13 14ZM15 16V17.9823C15.4489 17.9683 15.8286 17.9435 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.906 16.107 17.9125 16.0541 17.9185 16H15ZM17.9981 14H15V11H18V13C18 13.3611 17.9999 13.6933 17.9981 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "table-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","grid","layout","seats","restaurant","section","area","dine-in","arrangement","seating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 10V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 15H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "swipe-up-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["swipe","arrow","circle","up","swipe-up","scroll-up","upload","refresh","increase","elevation","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 5L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7L10.5858 5.41421C11.2525 4.74755 11.5858 4.41421 12 4.41421C12.4142 4.41421 12.7475 4.74755 13.4142 5.41421L15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "table-3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["table","restaurant","dining","seat","available","occupied","reservation","table-layout","seating-arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M10 10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M14 10V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "table-3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["table","restaurant","seat","dine-in","reservation","booth"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 10V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","tables","seating","layout","restaurant","dining","floorplan","table-layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57533 3.99997 8.45869 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C4.03033 8.23263 4.00773 9.01928 4.00197 9.93681C4.00066 9.95771 4 9.97878 4 10C4 10.0174 4.00045 10.0348 4.00133 10.052C3.99999 10.3325 3.99999 10.6249 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.23265 19.9697 9.01932 19.9923 9.93689 19.998C9.95776 19.9993 9.9788 20 10 20C10.0174 20 10.0347 19.9996 10.0519 19.9987C10.3324 20 10.6248 20 10.9292 20H13.0706C13.375 20 13.6676 20 13.9481 19.9987C13.9653 19.9996 13.9826 20 14 20C14.0212 20 14.0422 19.9993 14.0631 19.998C14.9807 19.9923 15.7674 19.9697 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0707V10.9294C20 10.6251 20 10.3323 19.9987 10.0519C19.9996 10.0347 20 10.0174 20 10C20 9.9788 19.9993 9.95776 19.998 9.93689C19.9923 9.01932 19.9697 8.23265 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM15 17.9823C15.4489 17.9683 15.8286 17.9435 16.1586 17.8991C16.8646 17.8042 17.1916 17.6368 17.4142 17.4142C17.6368 17.1916 17.8042 16.8646 17.8991 16.1586C17.9979 15.4238 18 14.4425 18 13V11H15V17.9823ZM13 11L13 18H11L11 11H13ZM9 17.9823V11H6V13C6 14.4425 6.00213 15.4238 6.10092 16.1586C6.19585 16.8646 6.36322 17.1916 6.58579 17.4142C6.80836 17.6368 7.13538 17.8042 7.84144 17.8991C8.17144 17.9435 8.55114 17.9683 9 17.9823Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "table-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","layout","grid","organization","menu","categories","sections","arrangement","restaurant","table-layout","table-3","table-view"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 10H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 10V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 10V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-alt-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["table","restaurant","dining","seat","available","occupation","reserved","seating"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M14 14L14 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14L10 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 14L5 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-alt-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["table","restaurant-table","floor-plan","seating","layout"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M14 14L14 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M10 14L10 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
                <path d="M19 14L5 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "table-alt": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","seating","restaurant","dining","layout","arrangement","table-management","booth"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 14L5 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14L14 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14L10 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-bar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["table","bar","dining","restaurant","seat","counter","table-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="8" rx="8" ry="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L17.6438 16.5754C17.3907 15.5628 17.2641 15.0565 16.9565 14.6978C16.7832 14.4959 16.5715 14.3306 16.3336 14.2115C15.911 14 15.3891 14 14.3454 14H9.65464C8.61088 14 8.08901 14 7.66643 14.2115C7.42852 14.3306 7.21676 14.4959 7.04355 14.6978C6.73588 15.0565 6.6093 15.5628 6.35616 16.5754L6 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "table-alt-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","restaurant","dining","seats","available","occupied","reservation","seating","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C10.625 3.99999 10.3325 3.99999 10.052 4.00133C10.0348 4.00045 10.0174 4 10 4C9.97878 4 9.95771 4.00066 9.93681 4.00197C9.01928 4.00773 8.23263 4.03033 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45869 3.99997 9.57529 4 10.9294V13.0706C3.99999 13.375 3.99999 13.6675 4.00133 13.948C4.00045 13.9652 4 13.9826 4 14C4 14.0212 4.00066 14.0423 4.00197 14.0632C4.00773 14.9807 4.03033 15.7674 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57527 20 10.9294 20H13.0706C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C19.9697 15.7674 19.9923 14.9807 19.998 14.0631C19.9993 14.0422 20 14.0212 20 14C20 13.9826 19.9996 13.9653 19.9987 13.9481C20 13.6677 20 13.3754 20 13.0711V10.9294C20 9.57534 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.7674 4.03033 14.9807 4.00773 14.0632 4.00197C14.0423 4.00066 14.0212 4 14 4C13.9826 4 13.9652 4.00045 13.948 4.00133C13.6675 3.99999 13.375 3.99999 13.0706 4ZM9 6.01775C8.55114 6.03168 8.17144 6.05655 7.84144 6.10092C7.13538 6.19585 6.80836 6.36322 6.58579 6.58579C6.36322 6.80836 6.19585 7.13538 6.10092 7.84144C6.00213 8.57626 6 9.55752 6 11V13H9L9 6.01775ZM11 13L11 6H13L13 13H11ZM15 6.01775L15 13H18V11C18 9.55752 17.9979 8.57626 17.8991 7.84144C17.8042 7.13538 17.6368 6.80836 17.4142 6.58579C17.1916 6.36322 16.8646 6.19585 16.1586 6.10092C15.8286 6.05655 15.4489 6.03168 15 6.01775Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "table-bar": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","restaurant","bar","seat","dining","table-bar","available","occupied","management","reservation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="8" rx="8" ry="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 18L17.6438 16.5754C17.3907 15.5628 17.2641 15.0565 16.9565 14.6978C16.7832 14.4959 16.5715 14.3306 16.3336 14.2115C15.911 14 15.3891 14 14.3454 14H9.65464C8.61088 14 8.08901 14 7.66643 14.2115C7.42852 14.3306 7.21676 14.4959 7.04355 14.6978C6.73588 15.0565 6.6093 15.5628 6.35616 16.5754L6 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "table-bar-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["table","bar","restaurant","seat","dining","available","order","table-service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 14V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <ellipse
                    cx="12"
                    cy="8"
                    rx="8"
                    ry="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 18L17.6438 16.5754C17.3907 15.5628 17.2641 15.0565 16.9565 14.6978C16.7832 14.4959 16.5715 14.3306 16.3336 14.2115C15.911 14 15.3891 14 14.3454 14H9.65464C8.61088 14 8.08901 14 7.66643 14.2115C7.42852 14.3306 7.21676 14.4959 7.04355 14.6978C6.73588 15.0565 6.6093 15.5628 6.35616 16.5754L6 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "tablet-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tablet","device","pos","point-of-sale","order-taking","payment","register","terminal","menu","display","screen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "table-bar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["table","bar","dining","seat","restaurant","location","section","area"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.10061 5.61564C7.64843 5.22869 9.73373 5 12 5C14.2663 5 16.3516 5.22869 17.8994 5.61564C18.6656 5.8072 19.3566 6.0512 19.8801 6.36064C20.3367 6.63052 21 7.15203 21 8C21 8.84797 20.3367 9.36948 19.8801 9.63936C19.3566 9.9488 18.6656 10.1928 17.8994 10.3844C16.5822 10.7136 14.8759 10.9283 13 10.985V13L14.3837 13C14.8728 13 15.3002 13 15.6564 13.03C16.0372 13.0621 16.4129 13.1329 16.7811 13.3172C17.138 13.4958 17.4556 13.7439 17.7155 14.0467C17.9836 14.3593 18.1434 14.7065 18.2669 15.0682C18.3824 15.4065 18.4861 15.8212 18.6047 16.2957L18.9701 17.7575C19.1041 18.2933 18.7783 18.8362 18.2425 18.9701C17.7067 19.1041 17.1638 18.7783 17.0299 18.2425L16.6737 16.8179C16.5431 16.2954 16.4592 15.9634 16.3742 15.7145C16.2943 15.4803 16.237 15.395 16.1974 15.3489C16.1108 15.248 16.005 15.1653 15.886 15.1057C15.8317 15.0786 15.7351 15.0437 15.4884 15.0229C15.2263 15.0008 14.884 15 14.3454 15H9.65464C9.11602 15 8.77366 15.0008 8.51155 15.0229C8.2649 15.0437 8.16832 15.0786 8.11399 15.1057C7.99504 15.1653 7.88916 15.248 7.80255 15.3489C7.763 15.395 7.70574 15.4803 7.62576 15.7145C7.54076 15.9634 7.45693 16.2954 7.3263 16.8179L6.97014 18.2425C6.83619 18.7783 6.29326 19.1041 5.75746 18.9701C5.22167 18.8362 4.89591 18.2933 5.02986 17.7575L5.39532 16.2956C5.51392 15.8211 5.61757 15.4065 5.73305 15.0682C5.85656 14.7065 6.01643 14.3593 6.28454 14.0467C6.54437 13.7439 6.86201 13.4958 7.21887 13.3172C7.58712 13.1329 7.96276 13.0621 8.34363 13.03C8.69976 13 9.12717 13 9.61627 13L11 13V10.985C9.12411 10.9283 7.41775 10.7136 6.10061 10.3844C5.33439 10.1928 4.64339 9.9488 4.11985 9.63936C3.66326 9.36948 3 8.84797 3 8C3 7.15203 3.66326 6.63052 4.11985 6.36064C4.64339 6.0512 5.33439 5.8072 6.10061 5.61564Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tablet-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tablet","mobile-pos","device","payment","register","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.052 2.25H8.94801C8.04957 2.24997 7.30029 2.24995 6.70553 2.32992C6.07773 2.41432 5.51093 2.59999 5.05546 3.05546C4.59999 3.51093 4.41432 4.07773 4.32992 4.70553C4.24995 5.30029 4.24997 6.04954 4.25 6.94798V17.0521C4.24997 17.9505 4.24995 18.6997 4.32992 19.2945C4.41432 19.9223 4.59999 20.4891 5.05546 20.9445C5.51093 21.4 6.07773 21.5857 6.70553 21.6701C7.30031 21.7501 8.04953 21.75 8.94801 21.75H15.052C15.9505 21.75 16.6997 21.7501 17.2945 21.6701C17.9223 21.5857 18.4891 21.4 18.9445 20.9445C19.4 20.4891 19.5857 19.9223 19.6701 19.2945C19.7501 18.6997 19.75 17.9505 19.75 17.052V6.94798C19.75 6.04951 19.7501 5.3003 19.6701 4.70553C19.5857 4.07773 19.4 3.51093 18.9445 3.05546C18.4891 2.59999 17.9223 2.41432 17.2945 2.32992C16.6997 2.24995 15.9504 2.24997 15.052 2.25ZM11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tablet-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tablet","pos","device","sale","order","checkout","payment","interface","screen","application"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V18C19 19.8856 19 20.8284 18.4142 21.4142C17.8284 22 16.8856 22 15 22H9C7.11438 22 6.17157 22 5.58579 21.4142C5 20.8284 5 19.8856 5 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tablet-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tablet","device","screen","point-of-sale","pos","register","payment","mobile","application"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 17H19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 6H13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tablet-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tablet","device","pos","point-of-sale","sale","system","register","information","screen","touchscreen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18V8C5 6.11438 5 5.17157 5.58579 4.58579C6.17157 4 7.11438 4 9 4H15C16.8856 4 17.8284 4 18.4142 4.58579C19 5.17157 19 6.11438 19 8V18C19 19.8856 19 20.8284 18.4142 21.4142C17.8284 22 16.8856 22 15 22H9C7.11438 22 6.17157 22 5.58579 21.4142C5 20.8284 5 19.8856 5 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 17H19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 6H13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tablet-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["tablet","device","terminal","portable","pos","point-of-sale","information","order-entry","menu","catalog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.052 2.25H8.94801C8.04957 2.24997 7.30029 2.24995 6.70553 2.32992C6.07773 2.41432 5.51093 2.59999 5.05546 3.05546C4.59999 3.51093 4.41432 4.07773 4.32992 4.70553C4.24995 5.30029 4.24997 6.04954 4.25 6.94798V16.25H19.75V6.94798C19.75 6.04951 19.7501 5.3003 19.6701 4.70553C19.5857 4.07773 19.4 3.51093 18.9445 3.05546C18.4891 2.59999 17.9223 2.41432 17.2945 2.32992C16.6997 2.24995 15.9504 2.24997 15.052 2.25ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55229 10.4477 7 11 7H13C13.5523 7 14 6.55229 14 6C14 5.44772 13.5523 5 13 5H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.32992 19.2945C4.27164 18.861 4.25585 18.3455 4.25158 17.75H19.7484C19.7442 18.3455 19.7284 18.861 19.6701 19.2945C19.5857 19.9223 19.4 20.4891 18.9445 20.9445C18.4891 21.4 17.9223 21.5857 17.2945 21.6701C16.6997 21.7501 15.9505 21.75 15.052 21.75H8.94801C8.04953 21.75 7.30031 21.7501 6.70553 21.6701C6.07773 21.5857 5.51093 21.4 5.05546 20.9445C4.59999 20.4891 4.41432 19.9223 4.32992 19.2945Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tablet-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["tablet","device","pos","mobile-pos","screen","payment","order-taking","table-management","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 17H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M11 6H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    tablet: {
        defaultColors: ["#3D4C66"],
        keywords: ["tablet","device","pos","mobile-pos","screen","payment","order-taking","table-management","terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M11 18H13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Tag-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["back","remove","delete","erase","cancel","undo","return","arrow-left","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L12 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.41101 6L15 6C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18L9.58262 18C8.5621 18 8.05184 18 7.61769 17.774C7.18354 17.5479 6.89092 17.1299 6.3057 16.2939L4.72602 14.0372C3.89514 12.8502 3.4797 12.2567 3.50265 11.5887C3.5256 10.9207 3.98079 10.3571 4.89118 9.22997L6.29924 7.48665C6.88934 6.75605 7.1844 6.39075 7.59334 6.19537C8.00229 6 8.47186 6 9.41101 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Tag-cross-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["back","delete","remove","undo","clear","cancel","discard","erase","backspace","correction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L12 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.41101 6L15 6C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18L9.58262 18C8.5621 18 8.05184 18 7.61769 17.774C7.18354 17.5479 6.89092 17.1299 6.3057 16.2939L4.72602 14.0372C3.89514 12.8502 3.4797 12.2567 3.50265 11.5887C3.5256 10.9207 3.98079 10.3571 4.89118 9.22997L6.29924 7.48665C6.88934 6.75605 7.1844 6.39075 7.59334 6.19537C8.00229 6 8.47186 6 9.41101 6Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "tag-tree-house-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tag","price tag","label","discount","item","product","loyalty","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V8.80296C5 7.56274 5 6.94263 5.31411 6.45048C5.62822 5.95833 6.19067 5.69719 7.31555 5.17492L10.3156 3.78206C11.1441 3.39739 11.5584 3.20505 12 3.20505C12.4416 3.20505 12.8559 3.39739 13.6844 3.78206L16.6844 5.17492C17.8093 5.69719 18.3718 5.95833 18.6859 6.45048C19 6.94263 19 7.56274 19 8.80296V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="10" r="2" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path d="M10 17H14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Tag-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["remove","delete","backspace","clear","cancel","undo","erase","discard","chevron-left","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.41101 6L15 6C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18L9.58262 18C8.5621 18 8.05184 18 7.61769 17.774C7.18354 17.5479 6.89092 17.1299 6.3057 16.2939L4.72602 14.0372C3.89514 12.8502 3.4797 12.2567 3.50265 11.5887C3.5256 10.9207 3.98079 10.3571 4.89118 9.22997L6.29924 7.48665C6.88934 6.75605 7.1844 6.39075 7.59334 6.19537C8.00229 6 8.47186 6 9.41101 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 14L12 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tag-tree-house-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["customer","profile","user","account","member","loyalty","customer-info","customer-profile","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V8.80296C5 7.56274 5 6.94263 5.31411 6.45048C5.62822 5.95833 6.19067 5.69719 7.31555 5.17492L10.3156 3.78206C11.1441 3.39739 11.5584 3.20505 12 3.20505C12.4416 3.20505 12.8559 3.39739 13.6844 3.78206L16.6844 5.17492C17.8093 5.69719 18.3718 5.95833 18.6859 6.45048C19 6.94263 19 7.56274 19 8.80296V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="10"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M10 17H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Tag-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tag","remove","delete","cancel","discount","remove-discount","delete-discount","cancel-discount","item-remove","item-delete","item-cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.0002 11.9293V12.0704C22.0002 13.4246 22.0003 14.5412 21.8815 15.4249C21.7567 16.3528 21.4847 17.1722 20.8286 17.8283C20.1725 18.4844 19.3531 18.7564 18.4253 18.8811C17.5415 18.9999 16.4249 18.9999 15.0708 18.9999L9.54273 18.9999C9.06676 18.9999 8.64485 18.9999 8.28953 18.9675C7.90411 18.9323 7.52816 18.8545 7.15609 18.6608C6.78401 18.4671 6.50473 18.2037 6.25487 17.9081C6.02453 17.6356 5.78259 17.29 5.50966 16.9L3.87594 14.5661C3.48704 14.0106 3.14683 13.5247 2.91399 13.0925C2.66246 12.6256 2.48366 12.1303 2.50345 11.5542C2.52324 10.9782 2.73562 10.4963 3.01859 10.0478C3.28054 9.6326 3.6533 9.17114 4.0794 8.64366L5.52151 6.85819L5.62198 6.7335C6.10981 6.12737 6.5433 5.58875 7.16247 5.29294C7.78163 4.99713 8.47302 4.99834 9.25108 4.99969L9.41121 4.99988L15.0708 4.99988C16.4249 4.99984 17.5415 4.99981 18.4253 5.11863C19.3531 5.24337 20.1725 5.51534 20.8286 6.17145C21.4847 6.82756 21.7567 7.64699 21.8815 8.57482C22.0003 9.45857 22.0002 10.5752 22.0002 11.9293ZM16.7076 14.7071C16.3171 15.0976 15.6839 15.0976 15.2934 14.7071L14.0005 13.4142L12.7076 14.7071C12.3171 15.0976 11.6839 15.0976 11.2934 14.7071C10.9029 14.3166 10.9029 13.6834 11.2934 13.2929L12.5863 12L11.2934 10.7071C10.9029 10.3166 10.9029 9.68342 11.2934 9.29289C11.6839 8.90237 12.3171 8.90237 12.7076 9.29289L14.0005 10.5858L15.2934 9.29289C15.6839 8.90237 16.3171 8.90237 16.7076 9.29289C17.0981 9.68342 17.0981 10.3166 16.7076 10.7071L15.4147 12L16.7076 13.2929C17.0981 13.6834 17.0981 14.3166 16.7076 14.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tag-tree-house-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tag","price","label","discount","product-tag","item-tag"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0355 2.61057C10.7217 2.28724 11.3313 2 12 2C12.6687 2 13.2783 2.28724 13.9645 2.61057L14.1056 2.67695L17.1488 4.10449C17.6743 4.35097 18.1371 4.56805 18.5033 4.78981C18.8998 5.02995 19.2589 5.31848 19.5288 5.74583C19.7988 6.17318 19.9066 6.6237 19.9552 7.08822C20.0001 7.5172 20 8.03276 20 8.61815V14.9988C20 16.3669 20.0001 17.4951 19.8812 18.388C19.7565 19.3255 19.4845 20.1534 18.8284 20.8163C18.1723 21.4792 17.3529 21.754 16.4251 21.88C15.5413 22.0001 14.4247 22 13.0706 22H10.9294C9.57532 22 8.45869 22.0001 7.57494 21.88C6.64711 21.754 5.82769 21.4792 5.17158 20.8163C4.51547 20.1534 4.2435 19.3255 4.11876 18.388C3.99994 17.4951 3.99997 16.3669 4.00001 14.9988L4 8.61809C3.99997 8.03276 3.99995 7.51717 4.04481 7.08822C4.09339 6.6237 4.20122 6.17318 4.47117 5.74583C4.74113 5.31848 5.10016 5.02995 5.4967 4.78981C5.86291 4.56805 6.32575 4.35096 6.85127 4.10448L9.89445 2.67694L10.0355 2.61057ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tape-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tape","measurement","length","distance","size","amount","inventory","warehouse","packing","shipping","item-size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 19H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "tag-tree-house": {
        defaultColors: ["#3D4C66"],
        keywords: ["tag","price","label","discount","promotion","identification","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V8.80296C5 7.56274 5 6.94263 5.31411 6.45048C5.62822 5.95833 6.19067 5.69719 7.31555 5.17492L10.3156 3.78206C11.1441 3.39739 11.5584 3.20505 12 3.20505C12.4416 3.20505 12.8559 3.39739 13.6844 3.78206L16.6844 5.17492C17.8093 5.69719 18.3718 5.95833 18.6859 6.45048C19 6.94263 19 7.56274 19 8.80296V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle cx="12" cy="10" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M10 17H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    tape: {
        defaultColors: ["#3D4C66"],
        keywords: ["tag","price","label","discount","promotion","identification","item","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 19H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Target-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["target","focus","bullseye","goal","accuracy","achievement","sales-target","metrics","performance","hit","aim","objective"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "tape-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tape","packing","shipping","packaging","roll","seal","secure","delivery","dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 18H6.70835C5.04751 16.5341 4 14.3894 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20H5C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tape-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tape","roll","packaging","seal","packing","shipping"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 19H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Target-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["target","bullseye","location","find","customer","rewards","loyalty","goal","focus","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Target-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["target","bullseye","location","locator","find","customer","focus","marketing","promotion","advertisement","goal","objective","precision","accuracy","select","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" />
                <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="1"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Target: {
        defaultColors: ["#3D4C66"],
        keywords: ["target","bullseye","location","locator","find","customer","focus","marketing","promotion","advertisement","goal","objective","precision","accuracy","select","selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "temperature-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["temperature","thermometer","temperature-control","adjustment","degrees","celsius","fahrenheit","setting","thermal","heating","cooling"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16C9.55229 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.1229 4.87715C17.9533 3.70762 16.0571 3.70762 14.8876 4.87715L9.69402 10.0707C8.19559 9.85818 6.61612 10.3276 5.4614 11.4823C3.51287 13.4309 3.51287 16.5901 5.4614 18.5386C7.40993 20.4871 10.5691 20.4871 12.5177 18.5386C13.6724 17.3839 14.1418 15.8044 13.9292 14.306L19.1229 9.11239C20.2924 7.94286 20.2924 6.04668 19.1229 4.87715ZM14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L11.7076 13.7066C11.895 14.0982 12 14.5369 12 15C12 16.6569 10.6569 18 9 18C7.34315 18 6 16.6569 6 15C6 13.3431 7.34315 12 9 12C9.46315 12 9.90178 12.105 10.2934 12.2924L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "temperature-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["temperature","hot","cold","degrees","climate","weather","temperature-control","heating","cooling","thermometer","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16C10 14.8954 9.10457 14 8 14C6.89543 14 6 14.8954 6 16C6 17.1046 6.89543 18 8 18C9.10457 18 10 17.1046 10 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 16C4 18.2091 5.79086 20 8 20C10.2091 20 12 18.2091 12 16C12 14.5194 11.1956 13.2267 10 12.5351V6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6V12.5351C4.8044 13.2267 4 14.5194 4 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8H20M14 11H19M14 5H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "temperature-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["temperature","thermometer","weather","cold","hot","temperature-check","alert","notification","warning","frozen","heat"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.1685 12.1894C4.6105 13.7474 4.6105 16.2735 6.16851 17.8315C7.72651 19.3895 10.2525 19.3895 11.8105 17.8315C12.8547 16.7873 13.1991 15.3083 12.8437 13.9774L18.4157 8.40528C19.1948 7.62628 19.1948 6.36326 18.4157 5.58425C17.6367 4.80525 16.3737 4.80525 15.5947 5.58425L10.0226 11.1563C8.69166 10.8009 7.21268 11.1453 6.1685 12.1894Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 15C11 13.8954 10.1046 13 9 13C7.89543 13 7 13.8954 7 15C7 16.1046 7.89543 17 9 17C10.1046 17 11 16.1046 11 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 13L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "temperature-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["temperature","thermometer","heat","cold","adjust-temperature","degrees","weather","temperature-control","menu-temperature"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.1685 12.1894C4.6105 13.7474 4.6105 16.2735 6.16851 17.8315C7.72651 19.3895 10.2525 19.3895 11.8105 17.8315C12.8547 16.7873 13.1991 15.3083 12.8437 13.9774L18.4157 8.40528C19.1948 7.62628 19.1948 6.36326 18.4157 5.58425C17.6367 4.80525 16.3737 4.80525 15.5947 5.58425L10.0226 11.1563C8.69166 10.8009 7.21268 11.1453 6.1685 12.1894Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 15C11 13.8954 10.1046 13 9 13C7.89543 13 7 13.8954 7 15C7 16.1046 7.89543 17 9 17C10.1046 17 11 16.1046 11 15Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 13L14 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "temperature-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["temperature","cold","hot","weather","degrees","inventory","storage","fridge","food-storage","temperature-control","settings","temp-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H14C13.4477 6 13 5.55228 13 5ZM13 8C13 7.44772 13.4477 7 14 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8ZM13 11C13 10.4477 13.4477 10 14 10H19C19.5523 10 20 10.4477 20 11C20 11.5523 19.5523 12 19 12H14C13.4477 12 13 11.5523 13 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16C9 16.5523 8.55229 17 8 17C7.44772 17 7 16.5523 7 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6C5 4.34314 6.34314 3 8 3C9.65685 3 11 4.34315 11 6V11.9998C12.213 12.9109 13 14.3631 13 16C13 18.7614 10.7614 21 8 21C5.23858 21 3 18.7614 3 16C3 14.3631 3.78702 12.9109 5 11.9998V6ZM8 9C8.55228 9 9 9.44772 9 10V13.1707C10.1652 13.5825 11 14.6938 11 16C11 17.6569 9.65685 19 8 19C6.34315 19 5 17.6569 5 16C5 14.6938 5.83481 13.5825 7 13.1707V10C7 9.44772 7.44772 9 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "temperature-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["temperature","thermometer","heat","cold","weather","environment","cooling","heating","temperature-control","temperature-settings","temperature-report","temperature-monitoring","climate-control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16C10 14.8954 9.10457 14 8 14C6.89543 14 6 14.8954 6 16C6 17.1046 6.89543 18 8 18C9.10457 18 10 17.1046 10 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 16C4 18.2091 5.79086 20 8 20C10.2091 20 12 18.2091 12 16C12 14.5194 11.1956 13.2267 10 12.5351V6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6V12.5351C4.8044 13.2267 4 14.5194 4 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8H20M14 11H19M14 5H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "temperature-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["temperature","weather","degrees","hot","cold","thermometer","settings","preferences","options","temperature-control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 16C4 18.2091 5.79086 20 8 20C10.2091 20 12 18.2091 12 16C12 14.5194 11.1956 13.2267 10 12.5351V6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6V12.5351C4.8044 13.2267 4 14.5194 4 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 8H20M14 11H19M14 5H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 16C10 14.8954 9.10457 14 8 14C6.89543 14 6 14.8954 6 16C6 17.1046 6.89543 18 8 18C9.10457 18 10 17.1046 10 16Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 14V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Tennis Ball-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tennis","ball","sports","game","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.6699 4.30378C10.6376 6.35593 11.6498 8.33359 13.5 9.40186C15.3503 10.4701 17.5691 10.3579 19.3302 9.30378"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13.3301 19.6962C13.3624 17.6441 12.3502 15.6664 10.5 14.5981C8.64966 13.5299 6.43086 13.6421 4.66982 14.6962"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    temperature: {
        defaultColors: ["#3D4C66"],
        keywords: ["tennis","ball","sports","game","product","item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.1685 12.1894C4.6105 13.7474 4.6105 16.2735 6.16851 17.8315C7.72651 19.3895 10.2525 19.3895 11.8105 17.8315C12.8547 16.7873 13.1991 15.3083 12.8437 13.9774L18.4157 8.40528C19.1948 7.62628 19.1948 6.36326 18.4157 5.58425C17.6367 4.80525 16.3737 4.80525 15.5947 5.58425L10.0226 11.1563C8.69166 10.8009 7.21268 11.1453 6.1685 12.1894Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 15C11 13.8954 10.1046 13 9 13C7.89543 13 7 13.8954 7 15C7 16.1046 7.89543 17 9 17C10.1046 17 11 16.1046 11 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M11 13L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "terminal-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["terminal","command","prompt","input","console","developer","interface","process","execute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7L11 12L5 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tennis Ball": {
        defaultColors: ["#3D4C66"],
        keywords: ["tennis","ball","sport","activity","games","leisure","recreation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.6699 4.30378C10.6376 6.35593 11.6498 8.33359 13.5 9.40186C15.3503 10.4701 17.5691 10.3579 19.3302 9.30378"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.3301 19.6962C13.3624 17.6441 12.3502 15.6664 10.5 14.5981C8.64966 13.5299 6.43086 13.6421 4.66982 14.6962"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "terminal-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["terminal","command","prompt","input","enter","code","settings","configuration","advanced-options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7L11 12L5 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "terminal-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["terminal","command","input","prompt","settings","configure","code","developer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 17C12 16.4477 12.4477 16 13 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H13C12.4477 18 12 17.5523 12 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.2318 6.35984C3.87824 6.78412 3.93556 7.41468 4.35984 7.76825L9.43797 12L4.35984 16.2318C3.93556 16.5854 3.87824 17.2159 4.2318 17.6402C4.58537 18.0645 5.21593 18.1218 5.64021 17.7682L11.6402 12.7682C11.8682 12.5783 12 12.2968 12 12C12 11.7032 11.8682 11.4218 11.6402 11.2318L5.64021 6.2318C5.21593 5.87824 4.58537 5.93556 4.2318 6.35984Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tennis Ball-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tennis","ball","sports","recreation","activity","leisure","game","equipment","inventory","product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.6699 4.30378C10.6376 6.35593 11.6498 8.33359 13.5 9.40186C15.3503 10.4701 17.5691 10.3579 19.3302 9.30378"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.3301 19.6962C13.3624 17.6441 12.3502 15.6664 10.5 14.5981C8.64966 13.5299 6.43086 13.6421 4.66982 14.6962"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 12C4 16.4183 7.58172 20 12 20C16.1601 20 19.5786 16.8246 19.9639 12.7653C19.9878 12.5134 20 12.2581 20 12C20 7.58172 16.4183 4 12 4C11.7419 4 11.4866 4.01223 11.2347 4.03613C7.17541 4.4214 4 7.83987 4 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "terminal-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["terminal","command","prompt","input","developer","script","customization","advanced-settings","configuration","settings","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26703 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM8.10006 8.20006C7.65823 7.86869 7.03143 7.95823 6.70006 8.40006C6.36869 8.84189 6.45823 9.46869 6.90006 9.80006L9.83339 12.0001L6.90006 14.2001C6.45823 14.5314 6.36869 15.1582 6.70006 15.6001C7.03143 16.0419 7.65823 16.1314 8.10006 15.8001L12.1001 12.8001C12.3519 12.6112 12.5001 12.3148 12.5001 12.0001C12.5001 11.6853 12.3519 11.3889 12.1001 11.2001L8.10006 8.20006ZM13 14.0001C12.4477 14.0001 12 14.4478 12 15.0001C12 15.5523 12.4477 16.0001 13 16.0001H16.5001C17.0523 16.0001 17.5001 15.5523 17.5001 15.0001C17.5001 14.4478 17.0523 14.0001 16.5001 14.0001H13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tennis Ball-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tennis","ball","sports","activity","game","leisure","recreation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0387 7.94849C18.5563 5.01299 15.5132 3 12 3C11.8011 3 11.6037 3.00646 11.4078 3.01921C11.1454 3.62664 11 4.29639 11 5C11 7.76142 13.2386 10 16 10C17.6586 10 19.129 9.19208 20.0387 7.94849Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.7984 10.0967C19.5454 11.2768 17.8573 12 16 12C12.134 12 9 8.86599 9 5C9 4.46865 9.05919 3.95115 9.17133 3.45372C5.58626 4.63972 3 8.01741 3 12C3 12.653 3.06955 13.2898 3.20166 13.9034C4.30248 12.8667 5.73924 12.1827 7.33152 12.0316C7.55179 12.0107 7.77479 12 8 12C11.866 12 15 15.134 15 19C15 19.2252 14.9893 19.4482 14.9684 19.6685C14.9401 19.9671 14.893 20.2602 14.8284 20.5466C18.1521 19.4473 20.6174 16.4633 20.9594 12.8598C20.9863 12.5766 21 12.2897 21 12C21 11.347 20.9304 10.7102 20.7984 10.0967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.5925 20.9808C12.7946 20.513 12.9272 20.0082 12.9774 19.4795C12.9923 19.322 13 19.162 13 19C13 16.2386 10.7614 14 8 14C7.83798 14 7.67804 14.0077 7.52049 14.0226C6.05996 14.1612 4.78235 14.9289 3.9614 16.0516C5.44384 18.9871 8.48685 21 12 21C12.1991 21 12.3967 20.9935 12.5925 20.9808Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "terminal-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["terminal","command","prompt","settings","configuration","developer","admin","shell"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V12C20 8.22876 20 6.34315 18.8284 5.17157C18.8284 5.17157 18.8284 5.17157 18.8284 5.17157C17.6569 4 15.7712 4 12 4V4C8.22876 4 6.34315 4 5.17157 5.17157C5.17157 5.17157 5.17157 5.17157 5.17157 5.17157C4 6.34315 4 8.22876 4 12V12C4 15.7712 4 17.6569 5.17157 18.8284C5.17157 18.8284 5.17157 18.8284 5.17157 18.8284C6.34315 20 8.22876 20 12 20V20C15.7712 20 17.6569 20 18.8284 18.8284C18.8284 18.8284 18.8284 18.8284 18.8284 18.8284C20 17.6569 20 15.7712 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L12 12L8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "terminal-box-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["terminal","command","prompt","input","settings","configuration","code","script"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V12C20 8.22876 20 6.34315 18.8284 5.17157C18.8284 5.17157 18.8284 5.17157 18.8284 5.17157C17.6569 4 15.7712 4 12 4V4C8.22876 4 6.34315 4 5.17157 5.17157C5.17157 5.17157 5.17157 5.17157 5.17157 5.17157C4 6.34315 4 8.22876 4 12V12C4 15.7712 4 17.6569 5.17157 18.8284C5.17157 18.8284 5.17157 18.8284 5.17157 18.8284C6.34315 20 8.22876 20 12 20V20C15.7712 20 17.6569 20 18.8284 18.8284C18.8284 18.8284 18.8284 18.8284 18.8284 18.8284C20 17.6569 20 15.7712 20 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L12 12L8 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Text-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["text","edit","format","description","notes","input","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    terminal: {
        defaultColors: ["#3D4C66"],
        keywords: ["text","edit","format","description","notes","input","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 17H13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7L11 12L5 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Text-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["text","edit","font","format","description","add-text","modify-text","label","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Text-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","letter","T","notes","description","edit","type"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 5C5.44772 5 5 5.44772 5 6V8C5 8.55228 5.44772 9 6 9C6.55228 9 7 8.55228 7 8V7H11V17H9C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H13V7H17V8C17 8.55228 17.4477 9 18 9C18.5523 9 19 8.55228 19 8V6C19 5.44772 18.5523 5 18 5H6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "text-size-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","font","size","increase","larger","a","plus","magnify","zoom-in"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18L6.25 15M15 18L13.75 15M6.25 15L8.15385 10.4308C8.94017 8.54359 9.33333 7.6 10 7.6C10.6667 7.6 11.0598 8.54359 11.8462 10.4308L13.75 15M6.25 15H13.75"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 11H19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "text-size-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["text size","increase","grow","zoom in","font","plus","larger","bigger","increase font size"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18L6.25 15M15 18L13.75 15M6.25 15L8.15385 10.4308C8.94017 8.54359 9.33333 7.6 10 7.6C10.6667 7.6 11.0598 8.54359 11.8462 10.4308L13.75 15M6.25 15H13.75"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 11H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "text-size": {
        defaultColors: ["#3D4C66"],
        keywords: ["text-size","font-size","increase-font","larger-text","zoom-in","accessibility","readability","plus","a+","magnify","view-size","expand","growth","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 18L6.25 15M15 18L13.75 15M6.25 15L8.15385 10.4308C8.94017 8.54359 9.33333 7.6 10 7.6C10.6667 7.6 11.0598 8.54359 11.8462 10.4308L13.75 15M6.25 15H13.75"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 11H19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 13L17 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Text-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["text","disable","clear","remove","delete","formatting","edit","text-edit","remove-formatting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "terminal-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["terminal","command-line","console","developer","advanced-settings","settings","system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 18.8284C20 17.6569 20 15.7712 20 12C20 8.22876 20 6.34315 18.8284 5.17157C17.6569 4 15.7712 4 12 4C8.22876 4 6.34315 4 5.17157 5.17157C4 6.34315 4 8.22876 4 12C4 15.7712 4 17.6569 5.17157 18.8284C6.34315 20 8.22876 20 12 20C15.7712 20 17.6569 20 18.8284 18.8284Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L12 12L8 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "text-size-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text-size","increase-text","font-size","bigger-text","zoom-in","a-plus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.98159 8.81804C9.74663 9.21408 9.48277 9.84091 9.0767 10.8155L7.74977 14.0001H12.2498L10.9228 10.8155C10.5168 9.84091 10.2529 9.21408 10.018 8.81804C10.0117 8.80758 10.0057 8.7975 9.99977 8.78778C9.99386 8.7975 9.9878 8.80758 9.98159 8.81804ZM13.0831 16.0001L14.0767 18.3847C14.2891 18.8945 14.8746 19.1356 15.3844 18.9232C15.8942 18.7108 16.1353 18.1253 15.9228 17.6155L12.769 10.0463C12.759 10.0222 12.749 9.99828 12.7391 9.97443C12.3716 9.09229 12.0543 8.33068 11.738 7.79754C11.4326 7.28284 10.9094 6.6001 9.99977 6.6001C9.09015 6.6001 8.56691 7.28284 8.26154 7.79754C7.94523 8.33067 7.62796 9.09228 7.26047 9.97442C7.25053 9.99828 7.24055 10.0222 7.23054 10.0463L4.0767 17.6155C3.86428 18.1253 4.10536 18.7108 4.61516 18.9232C5.12496 19.1356 5.71043 18.8945 5.92285 18.3847L6.91644 16.0001H13.0831ZM16.9998 8.0001C17.5521 8.0001 17.9998 8.44781 17.9998 9.0001V10.0001H18.9998C19.5521 10.0001 19.9998 10.4478 19.9998 11.0001C19.9998 11.5524 19.5521 12.0001 18.9998 12.0001H17.9998V13.0001C17.9998 13.5524 17.5521 14.0001 16.9998 14.0001C16.4475 14.0001 15.9998 13.5524 15.9998 13.0001V12.0001H14.9998C14.4475 12.0001 13.9998 11.5524 13.9998 11.0001C13.9998 10.4478 14.4475 10.0001 14.9998 10.0001H15.9998V9.0001C15.9998 8.44781 16.4475 8.0001 16.9998 8.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Text-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["text","edit","remove","delete","disable","erase","clear","formatting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Text-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","slash","remove-text","delete-text","clear-text","erase","edit","text-edit","cancel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 6.41421L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L11 14.4142V17H9C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H13V12.4142L17.0633 8.35091C17.2054 8.7301 17.5712 9 18 9C18.5523 9 19 8.55228 19 8V6.41421ZM6 5H15.5858L13.5858 7H13V7.58579L11 9.58579V7H7V8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8V6C5 5.44772 5.44772 5 6 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Text-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["text","slash","remove-text","delete-text","clear-text","edit-text","disable-text","cancel-text"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "text-wrap-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["return","undo","reverse","rollback","transaction-reversal","refund","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18H5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H16C17.6569 12 19 13.3431 19 15V15C19 16.6569 17.6569 18 16 18H12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16L12 18L14 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "text-wrap-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["return","refund","undo","transaction-reversal","revert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H16C17.6569 12 19 13.3431 19 15V15C19 16.6569 17.6569 18 16 18H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16L12 18L14 20"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "text-wrap": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","arrow-left","rollback","revert","go-back","order-return","transaction-reversal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 18H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H16C17.6569 12 19 13.3431 19 15V15C19 16.6569 17.6569 18 16 18H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 16L12 18L14 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "text-wrap-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["return","undo","reverse","transaction","refund","history","rollback","arrow-left","back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H5C4.44772 6 4 5.55228 4 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 17C4 16.4477 4.44772 16 5 16H9C9.55228 16 10 16.4477 10 17C10 17.5523 9.55228 18 9 18H5C4.44772 18 4 17.5523 4 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 11C4 10.4477 4.44772 10 5 10H16C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18H14.4142L14.7071 18.2929C15.0976 18.6834 15.0976 19.3166 14.7071 19.7071C14.3166 20.0976 13.6834 20.0976 13.2929 19.7071L11.2929 17.7071C10.9024 17.3166 10.9024 16.6834 11.2929 16.2929L13.2929 14.2929C13.6834 13.9024 14.3166 13.9024 14.7071 14.2929C15.0976 14.6834 15.0976 15.3166 14.7071 15.7071L14.4142 16H16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12H5C4.44772 12 4 11.5523 4 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "thumbs-down-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["dislike","thumbs-down","negative","decline","reject","cancellation","refund","error","invalid","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11L16 6C16 5.05719 16 4.58579 16.2929 4.29289C16.5858 4 17.0572 4 18 4C18.9428 4 19.4142 4 19.7071 4.29289C20 4.58579 20 5.05719 20 6L20 11C20 11.9428 20 12.4142 19.7071 12.7071C19.4142 13 18.9428 13 18 13C17.0572 13 16.5858 13 16.2929 12.7071C16 12.4142 16 11.9428 16 11Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75L10 13.25ZM10.3958 17.6252L9.65601 17.5019L10.3958 17.6252ZM10.3828 17.7051L11.1246 17.8157L10.3828 17.7051ZM14.3862 18.4551L15.1138 18.637L14.3862 18.4551ZM14.3722 18.5105L13.647 18.319L14.3722 18.5105ZM10.8356 14.9864L11.5754 15.1097L10.8356 14.9864ZM11.1356 17.7485L11.5754 15.1097L10.0958 14.8631L9.65601 17.5019L11.1356 17.7485ZM15.2724 11.8181L13.6586 18.2732L15.1138 18.637L16.7276 12.1819L15.2724 11.8181ZM9.65601 17.5019C9.64956 17.5406 9.6447 17.5695 9.64098 17.5945L11.1246 17.8157C11.1259 17.8067 11.1281 17.7937 11.1356 17.7485L9.65601 17.5019ZM12.4076 19.25C12.3617 19.25 12.3485 19.25 12.3395 19.2498L12.3137 20.7496C12.339 20.75 12.3683 20.75 12.4076 20.75L12.4076 19.25ZM9.64098 17.5945C9.39602 19.2376 10.6527 20.7211 12.3137 20.7496L12.3395 19.2498C11.5845 19.2369 11.0132 18.5626 11.1246 17.8157L9.64098 17.5945ZM13.6586 18.2732C13.651 18.3038 13.6488 18.3123 13.647 18.319L15.0974 18.7019C15.1023 18.6833 15.1072 18.6633 15.1138 18.637L13.6586 18.2732ZM12.4076 20.75C12.4347 20.75 12.4553 20.75 12.4745 20.7498L12.4548 19.2499C12.4478 19.25 12.4391 19.25 12.4076 19.25L12.4076 20.75ZM13.647 18.319C13.5038 18.8618 13.0162 19.2425 12.4548 19.2499L12.4745 20.7498C13.7095 20.7336 14.7821 19.896 15.0974 18.7019L13.647 18.319ZM11.5754 15.1097C11.7376 14.1362 10.9869 13.25 10 13.25L10 14.75C10.06 14.75 10.1057 14.8039 10.0958 14.8631L11.5754 15.1097Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 13L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L10.4484 4C8.96759 4 8.22721 4 7.62059 4.28536C7.2211 4.47329 6.86801 4.74707 6.58652 5.08717C6.15907 5.60361 5.97468 6.32067 5.60591 7.7548L5.49425 8.18904C5.01276 10.0615 4.77202 10.9977 4.96244 11.7428C5.16803 12.5473 5.69784 13.2306 6.42577 13.63C7.09997 14 8.06665 14 10 14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    Text: {
        defaultColors: ["#3D4C66"],
        keywords: ["dislike","thumbs-down","negative","decline","reject","cancellation","refund","error","invalid","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6V18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 18H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 8V6H18V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "thumbs-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs down","dislike","reject","decline","negative","incorrect","error","cancel","wrong","bad","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.4535 20.7002C11.4177 20.7002 11.3903 20.7002 11.3665 20.6998C9.70551 20.6713 8.44881 19.1878 8.69377 17.5447C8.69728 17.5212 8.70179 17.4941 8.7077 17.4587L9.1486 14.8133C9.15846 14.7541 9.11281 14.7002 9.05279 14.7002H9.01959C8.08107 14.7002 7.33076 14.7002 6.73259 14.6515C6.12284 14.6018 5.5902 14.497 5.11774 14.2377C4.20784 13.7384 3.54557 12.8843 3.28858 11.8787C3.15515 11.3566 3.1863 10.8146 3.29003 10.2117C3.3918 9.62023 3.57867 8.89355 3.81241 7.98458L3.93994 7.48863C4.11787 6.79666 4.26241 6.23451 4.41783 5.78296C4.57901 5.3147 4.76833 4.91342 5.06154 4.55916C5.41341 4.13403 5.85476 3.79181 6.35413 3.5569C6.77025 3.36115 7.20603 3.27773 7.69967 3.23825C8.17571 3.20018 8.75614 3.20019 9.47063 3.2002L11.1048 3.2002C12.0033 3.20017 12.7525 3.20014 13.3473 3.28011C13.9751 3.36451 14.5419 3.55018 14.9973 4.00565C15.4528 4.46112 15.6385 5.02792 15.7229 5.65572C15.8028 6.2505 15.8028 6.99972 15.8028 7.8982L15.8028 12.0425L14.1655 18.5916C14.1595 18.6158 14.1548 18.6345 14.1502 18.6521C13.8349 19.8462 12.7622 20.6838 11.5273 20.7C11.5091 20.7002 11.4898 20.7002 11.4649 20.7002L11.4535 20.7002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.8028 11.9502C20.8028 12.9167 20.0193 13.7002 19.0528 13.7002C18.0863 13.7002 17.3028 12.9167 17.3028 11.9502L17.3028 4.95019C17.3028 3.9837 18.0863 3.2002 19.0528 3.2002C20.0193 3.2002 20.8028 3.9837 20.8028 4.95019V11.9502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "thumbs-down-alert-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["thumbs-down","dislike","decline","reject","negative","error","cancel","disapprove","wrong","invalid","failure","low-stock","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11.25C9.58579 11.25 9.25 11.5858 9.25 12C9.25 12.4142 9.58579 12.75 10 12.75L10 11.25ZM10.3958 15.6252L9.65601 15.5019L10.3958 15.6252ZM10.3828 15.7051L11.1246 15.8157L10.3828 15.7051ZM14.3862 16.4551L15.1138 16.637L14.3862 16.4551ZM14.3722 16.5105L13.647 16.319L14.3722 16.5105ZM10.8356 12.9864L11.5754 13.1097L10.8356 12.9864ZM11.1356 15.7485L11.5754 13.1097L10.0958 12.8631L9.65601 15.5019L11.1356 15.7485ZM15.2724 9.8181L13.6586 16.2732L15.1138 16.637L16.7276 10.1819L15.2724 9.8181ZM9.65601 15.5019C9.64956 15.5406 9.6447 15.5695 9.64098 15.5945L11.1246 15.8157C11.1259 15.8067 11.1281 15.7937 11.1356 15.7485L9.65601 15.5019ZM12.4076 17.25C12.3617 17.25 12.3485 17.25 12.3395 17.2498L12.3137 18.7496C12.339 18.75 12.3683 18.75 12.4076 18.75L12.4076 17.25ZM9.64098 15.5945C9.39602 17.2376 10.6527 18.7211 12.3137 18.7496L12.3395 17.2498C11.5845 17.2369 11.0132 16.5626 11.1246 15.8157L9.64098 15.5945ZM13.6586 16.2732C13.651 16.3038 13.6488 16.3123 13.647 16.319L15.0974 16.7019C15.1023 16.6833 15.1072 16.6633 15.1138 16.637L13.6586 16.2732ZM12.4076 18.75C12.4347 18.75 12.4553 18.75 12.4745 18.7498L12.4548 17.2499C12.4478 17.25 12.4391 17.25 12.4076 17.25L12.4076 18.75ZM13.647 16.319C13.5038 16.8618 13.0162 17.2425 12.4548 17.2499L12.4745 18.7498C13.7095 18.7336 14.7821 17.896 15.0974 16.7019L13.647 16.319ZM11.5754 13.1097C11.7376 12.1362 10.9869 11.25 10 11.25L10 12.75C10.06 12.75 10.1057 12.8039 10.0958 12.8631L11.5754 13.1097Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 10L16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6L20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11.2L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L8 4C7.07003 4 6.60504 4 6.22354 4.10222C5.18827 4.37962 4.37962 5.18827 4.10222 6.22354C4 6.60504 4 7.07003 4 8V8C4 8.92997 4 9.39496 4.10222 9.77646C4.37962 10.8117 5.18827 11.6204 6.22354 11.8978C6.60504 12 7.07003 12 8 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 20L12 21" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16.0002 18L17 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 18L7.00024 19" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "thumbs-down-alert-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["thumbs-down","dislike","decline","reject","cancel","error","negative","not ok","problem","issue","disapproved","failed","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.8356 11.9864L10.3958 14.6252C10.3888 14.6671 10.3853 14.6881 10.3828 14.7051C10.2046 15.9001 11.1186 16.979 12.3266 16.9997C12.3438 17 12.365 17 12.4076 17C12.4369 17 12.4515 17 12.4647 16.9998C13.3628 16.9881 14.143 16.3789 14.3722 15.5105C14.3756 15.4978 14.3791 15.4836 14.3862 15.4551L16 9V7C16 5.11438 16 4.17157 15.4142 3.58579C14.8284 3 13.8856 3 12 3H8C7.07003 3 6.60504 3 6.22354 3.10222C5.18827 3.37962 4.37962 4.18827 4.10222 5.22354C4 5.60504 4 6.07003 4 7C4 7.92997 4 8.39496 4.10222 8.77646C4.37962 9.81173 5.18827 10.6204 6.22354 10.8978C6.60504 11 7.07002 11 7.99997 11H8H10C10.5235 11 10.9217 11.47 10.8356 11.9864Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 9L14.3862 15.4551C14.3791 15.4836 14.3756 15.4978 14.3722 15.5105C14.143 16.3789 13.3628 16.9881 12.4647 16.9998C12.4515 17 12.4369 17 12.4076 17C12.365 17 12.3438 17 12.3266 16.9997C11.1186 16.979 10.2046 15.9001 10.3828 14.7051C10.3853 14.6881 10.3888 14.6671 10.3958 14.6252L10.8356 11.9864C10.9217 11.47 10.5235 11 10 11H8C7.07003 11 6.60504 11 6.22354 10.8978C5.18827 10.6204 4.37962 9.81173 4.10222 8.77646C4 8.39496 4 7.92997 4 7C4 6.07003 4 5.60504 4.10222 5.22354C4.37962 4.18827 5.18827 3.37962 6.22354 3.10222C6.60504 3 7.07003 3 8 3L12 3C13.8856 3 14.8284 3 15.4142 3.58579C16 4.17157 16 5.11438 16 7V10.2"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                />
                <path
                    d="M16 9L16 5C16 3.89543 16.8954 3 18 3C19.1046 3 20 3.89543 20 5L20 9C20 10.1046 19.1046 11 18 11C16.8954 11 16 10.1046 16 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="2"
                />
                <path d="M12 20L12 21" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M16.0002 18L17 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M8 18L7.00024 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
            </svg>
        )
    },
    "thumbs-down-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["thumbs-down","dislike","reject","decline","disapprove","negative","not-ok","wrong"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.8356 14.9864L10.3958 17.6252C10.3888 17.6671 10.3853 17.6881 10.3828 17.7051C10.2046 18.9001 11.1186 19.979 12.3266 19.9997C12.3438 20 12.365 20 12.4076 20C12.4369 20 12.4516 20 12.4647 19.9998C13.3628 19.9881 14.143 19.3789 14.3722 18.5105C14.3756 18.4978 14.3791 18.4836 14.3862 18.4551L16 12L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4H10.4484C8.9676 4 8.22721 4 7.62059 4.28536C7.2211 4.47329 6.86802 4.74707 6.58652 5.08717C6.15908 5.60361 5.97469 6.32067 5.60592 7.75479L5.60592 7.7548L5.49425 8.18904C5.01277 10.0615 4.77203 10.9977 4.96245 11.7428C5.16803 12.5473 5.69785 13.2306 6.42577 13.63C7.09998 14 8.06665 14 9.99999 14H10C10.5235 14 10.9217 14.47 10.8356 14.9864Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16 12L14.3862 18.4551C14.3791 18.4836 14.3756 18.4978 14.3722 18.5105C14.143 19.3789 13.3628 19.9881 12.4647 19.9998C12.4516 20 12.4369 20 12.4076 20C12.365 20 12.3438 20 12.3266 19.9997C11.1186 19.979 10.2046 18.9001 10.3828 17.7051C10.3853 17.6881 10.3888 17.6671 10.3958 17.6252L10.8356 14.9864C10.9217 14.47 10.5235 14 10 14C8.06666 14 7.09998 14 6.42577 13.63C5.69785 13.2306 5.16803 12.5473 4.96245 11.7428C4.77203 10.9977 5.01277 10.0615 5.49425 8.18904L5.60592 7.7548C5.97469 6.32067 6.15908 5.60361 6.58652 5.08717C6.86802 4.74707 7.2211 4.47329 7.62059 4.28536C8.22721 4 8.9676 4 10.4484 4L12 4C13.8856 4 14.8284 4 15.4142 4.58579C16 5.17157 16 6.11438 16 8V13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                />
                <path
                    d="M16 11L16 6C16 5.05719 16 4.58579 16.2929 4.29289C16.5858 4 17.0572 4 18 4C18.9428 4 19.4142 4 19.7071 4.29289C20 4.58579 20 5.05719 20 6L20 11C20 11.9428 20 12.4142 19.7071 12.7071C19.4142 13 18.9428 13 18 13C17.0572 13 16.5858 13 16.2929 12.7071C16 12.4142 16 11.9428 16 11Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="2"
                />
            </svg>
        )
    },
    "thumbs-down-alert": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-down","dislike","reject","decline","incorrect","error","invalid","failed","downvote","negative","no","bad","alert","warning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11.25C9.58579 11.25 9.25 11.5858 9.25 12C9.25 12.4142 9.58579 12.75 10 12.75L10 11.25ZM10.3958 15.6252L9.65601 15.5019L10.3958 15.6252ZM10.3828 15.7051L11.1246 15.8157L10.3828 15.7051ZM14.3862 16.4551L15.1138 16.637L14.3862 16.4551ZM14.3722 16.5105L13.647 16.319L14.3722 16.5105ZM10.8356 12.9864L11.5754 13.1097L10.8356 12.9864ZM11.1356 15.7485L11.5754 13.1097L10.0958 12.8631L9.65601 15.5019L11.1356 15.7485ZM15.2724 9.8181L13.6586 16.2732L15.1138 16.637L16.7276 10.1819L15.2724 9.8181ZM9.65601 15.5019C9.64956 15.5406 9.6447 15.5695 9.64098 15.5945L11.1246 15.8157C11.1259 15.8067 11.1281 15.7937 11.1356 15.7485L9.65601 15.5019ZM12.4076 17.25C12.3617 17.25 12.3485 17.25 12.3395 17.2498L12.3137 18.7496C12.339 18.75 12.3683 18.75 12.4076 18.75L12.4076 17.25ZM9.64098 15.5945C9.39602 17.2376 10.6527 18.7211 12.3137 18.7496L12.3395 17.2498C11.5845 17.2369 11.0132 16.5626 11.1246 15.8157L9.64098 15.5945ZM13.6586 16.2732C13.651 16.3038 13.6488 16.3123 13.647 16.319L15.0974 16.7019C15.1023 16.6833 15.1072 16.6633 15.1138 16.637L13.6586 16.2732ZM12.4076 18.75C12.4347 18.75 12.4553 18.75 12.4745 18.7498L12.4548 17.2499C12.4478 17.25 12.4391 17.25 12.4076 17.25L12.4076 18.75ZM13.647 16.319C13.5038 16.8618 13.0162 17.2425 12.4548 17.2499L12.4745 18.7498C13.7095 18.7336 14.7821 17.896 15.0974 16.7019L13.647 16.319ZM11.5754 13.1097C11.7376 12.1362 10.9869 11.25 10 11.25L10 12.75C10.06 12.75 10.1057 12.8039 10.0958 12.8631L11.5754 13.1097Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 11.2L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L8 4C7.07003 4 6.60504 4 6.22354 4.10222C5.18827 4.37962 4.37962 5.18827 4.10222 6.22354C4 6.60504 4 7.07003 4 8V8C4 8.92997 4 9.39496 4.10222 9.77646C4.37962 10.8117 5.18827 11.6204 6.22354 11.8978C6.60504 12 7.07003 12 8 12L10 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L16 6C16 4.89543 16.8954 4 18 4C19.1046 4 20 4.89543 20 6L20 10C20 11.1046 19.1046 12 18 12C16.8954 12 16 11.1046 16 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 20L12 21" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16.0002 18L17 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 18L7.00024 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "thumbs-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-down","dislike","reject","decline","not-approved","cancel","refund","issue","wrong","error","negative","bad","incorrect","no"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75L10 13.25ZM10.3958 17.6252L9.65601 17.5019L10.3958 17.6252ZM10.3828 17.7051L11.1246 17.8157L10.3828 17.7051ZM14.3862 18.4551L15.1138 18.637L14.3862 18.4551ZM14.3722 18.5105L13.647 18.319L14.3722 18.5105ZM10.8356 14.9864L11.5754 15.1097L10.8356 14.9864ZM11.1356 17.7485L11.5754 15.1097L10.0958 14.8631L9.65601 17.5019L11.1356 17.7485ZM15.2724 11.8181L13.6586 18.2732L15.1138 18.637L16.7276 12.1819L15.2724 11.8181ZM9.65601 17.5019C9.64956 17.5406 9.6447 17.5695 9.64098 17.5945L11.1246 17.8157C11.1259 17.8067 11.1281 17.7937 11.1356 17.7485L9.65601 17.5019ZM12.4076 19.25C12.3617 19.25 12.3485 19.25 12.3395 19.2498L12.3137 20.7496C12.339 20.75 12.3683 20.75 12.4076 20.75L12.4076 19.25ZM9.64098 17.5945C9.39602 19.2376 10.6527 20.7211 12.3137 20.7496L12.3395 19.2498C11.5845 19.2369 11.0132 18.5626 11.1246 17.8157L9.64098 17.5945ZM13.6586 18.2732C13.651 18.3038 13.6488 18.3123 13.647 18.319L15.0974 18.7019C15.1023 18.6833 15.1072 18.6633 15.1138 18.637L13.6586 18.2732ZM12.4076 20.75C12.4347 20.75 12.4553 20.75 12.4745 20.7498L12.4548 19.2499C12.4478 19.25 12.4391 19.25 12.4076 19.25L12.4076 20.75ZM13.647 18.319C13.5038 18.8618 13.0162 19.2425 12.4548 19.2499L12.4745 20.7498C13.7095 20.7336 14.7821 19.896 15.0974 18.7019L13.647 18.319ZM11.5754 15.1097C11.7376 14.1362 10.9869 13.25 10 13.25L10 14.75C10.06 14.75 10.1057 14.8039 10.0958 14.8631L11.5754 15.1097Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 13L16 8C16 6.11438 16 5.17157 15.4142 4.58579C14.8284 4 13.8856 4 12 4L10.4484 4C8.96759 4 8.22721 4 7.62059 4.28536C7.2211 4.47329 6.86801 4.74707 6.58652 5.08717C6.15907 5.60361 5.97468 6.32067 5.60591 7.7548L5.49425 8.18904C5.01276 10.0615 4.77202 10.9977 4.96244 11.7428C5.16803 12.5473 5.69784 13.2306 6.42577 13.63C7.09997 14 8.06665 14 10 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 11L16 6C16 5.05719 16 4.58579 16.2929 4.29289C16.5858 4 17.0572 4 18 4C18.9428 4 19.4142 4 19.7071 4.29289C20 4.58579 20 5.05719 20 6L20 11C20 11.9428 20 12.4142 19.7071 12.7071C19.4142 13 18.9428 13 18 13C17.0572 13 16.5858 13 16.2929 12.7071C16 12.4142 16 11.9428 16 11Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "thumbs-down-alert-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-down","dislike","negative","decline","reject","cancel","error","failed","no","incorrect","disapprove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.25 9.95005L14.6128 15.3915C14.6067 15.4156 14.6021 15.4344 14.5974 15.4519C14.2822 16.6461 13.2095 17.4836 11.9745 17.4998C11.9564 17.5 11.9371 17.5 11.9121 17.5H11.9008C11.8649 17.5001 11.8376 17.5001 11.8138 17.4996C10.1528 17.4711 8.89607 15.9877 9.14103 14.3446C9.14454 14.321 9.14905 14.294 9.15496 14.2585L9.59585 11.6131C9.60572 11.5539 9.56007 11.5 9.50005 11.5H7.50005C7.46088 11.5 7.42228 11.5001 7.38425 11.5001C6.56629 11.5003 6.00814 11.5005 5.52948 11.3723C4.23538 11.0255 3.22458 10.0147 2.87783 8.72062C2.74957 8.24196 2.74975 7.68381 2.75002 6.86585C2.75004 6.82782 2.75005 6.78922 2.75005 6.75005C2.75005 6.71088 2.75004 6.67228 2.75002 6.63425C2.74975 5.81629 2.74957 5.25814 2.87783 4.77948C3.22458 3.48538 4.23538 2.47458 5.52948 2.12783C6.00814 1.99957 6.56629 1.99975 7.38425 2.00002C7.42228 2.00004 7.46088 2.00005 7.50005 2.00005L11.552 2.00005C12.4505 2.00002 13.1997 1.99999 13.7945 2.07996C14.4223 2.16437 14.9891 2.35004 15.4446 2.80551C15.9001 3.26098 16.0857 3.82777 16.1701 4.45557C16.2501 5.05035 16.2501 5.79957 16.2501 6.69805L16.25 9.95005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.25 9.75005C21.25 10.7165 20.4665 11.5 19.5 11.5C18.5336 11.5 17.75 10.7165 17.75 9.75005L17.75 3.75005C17.75 2.78355 18.5335 2.00005 19.5 2.00005C20.4665 2.00005 21.25 2.78355 21.25 3.75005V9.75005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5001 21.75C10.9478 21.75 10.5001 21.3023 10.5001 20.75V19.75C10.5001 19.1978 10.9478 18.75 11.5001 18.75C12.0523 18.75 12.5001 19.1978 12.5001 19.75V20.75C12.5001 21.3023 12.0523 21.75 11.5001 21.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.2071 19.4572C16.8165 19.8477 16.1833 19.8476 15.7929 19.4571L14.7931 18.4571C14.4026 18.0665 14.4027 17.4333 14.7933 17.0429C15.1838 16.6524 15.817 16.6525 16.2075 17.043L17.2072 18.043C17.5977 18.4336 17.5976 19.0668 17.2071 19.4572Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.79327 19.4572C6.18385 19.8477 6.81701 19.8476 7.20749 19.4571L8.20724 18.4571C8.59772 18.0665 8.59764 17.4333 8.20707 17.0429C7.8165 16.6524 7.18333 16.6525 6.79286 17.043L5.7931 18.043C5.40262 18.4336 5.4027 19.0668 5.79327 19.4572Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "thumbs-up-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["thumbs-up","like","approve","confirmation","accept","good","okay","valid","order-approved","payment-accepted","verified"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.6449 5.29731C8.65076 5.27386 8.65585 5.25352 8.66091 5.23433C9.00479 3.93159 10.175 3.01791 11.5223 3.00026C11.557 3.00026 11.6645 3 11.6905 3.00044C13.5026 3.03153 14.8735 4.64987 14.6063 6.44236C14.6025 6.46808 14.5976 6.49723 14.5919 6.53147L14.5906 6.53923L14.1805 9C15.0483 9.00011 15.7624 9.00245 16.3405 9.04955C16.9643 9.10038 17.5378 9.20928 18.0553 9.49331C19.0259 10.0259 19.7323 10.937 20.0064 12.0096C20.1526 12.5816 20.1153 13.1641 20.0091 13.7809C19.9056 14.3825 19.5845 15.6312 19.3528 16.5321C19.1768 17.217 19.0301 17.7875 18.8714 18.2486C18.705 18.7319 18.5036 19.1642 18.1838 19.5504C17.8085 20.0039 17.3377 20.3689 16.8051 20.6195C16.3514 20.833 15.8826 20.9204 15.3731 20.9611C14.8869 21 14.2979 21 13.5908 21H13.5908L11.9342 21C11.0477 21.0001 10.2839 21.0001 9.67221 20.9179C9.0167 20.8297 8.38835 20.631 7.87868 20.1213C7.36902 19.6117 7.17028 18.9833 7.08215 18.3278C6.99991 17.7161 6.99995 16.9523 7 16.0658L7 11L8.6449 5.29731Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6.00001 10L5.94561 10C5.52154 9.99992 5.10941 9.99984 4.76949 10.0455C4.38629 10.0971 3.94902 10.2226 3.5858 10.5858C3.22259 10.949 3.09706 11.3863 3.04554 11.7695C2.99984 12.1094 2.99992 12.5215 3.00001 12.9456L3.00001 13V18L3.00001 18.0544C2.99992 18.4785 2.99984 18.8906 3.04554 19.2305C3.09706 19.6137 3.22259 20.051 3.5858 20.4142C3.94902 20.7774 4.38629 20.903 4.76949 20.9545C5.10941 21.0002 5.52154 21.0001 5.9456 21L6.00001 21L6.05442 21C6.47849 21.0001 6.89062 21.0002 7.23053 20.9545C7.61374 20.903 8.05101 20.7774 8.41423 20.4142C8.77744 20.051 8.90297 19.6137 8.95449 19.2305C9.00019 18.8906 9.0001 18.4785 9.00002 18.0544L9.00001 18V13L9.00002 12.9456C9.0001 12.5215 9.00019 12.1094 8.95449 11.7695C8.90297 11.3863 8.77744 10.949 8.41423 10.5858C8.05101 10.2226 7.61374 10.0971 7.23053 10.0455C6.89062 9.99984 6.47849 9.99992 6.05442 10L6.00001 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "thumbs-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-up","like","approve","approved","accept","confirmation","confirm","agree","agreement","positive","order-approved","payment-approved"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5492 3.2002C12.5851 3.20019 12.6124 3.20019 12.6362 3.2006C14.2972 3.2291 15.5539 4.71258 15.309 6.35569C15.3055 6.37923 15.3009 6.40629 15.295 6.44173L14.8541 9.0871C14.8443 9.1463 14.8899 9.2002 14.95 9.2002H14.9832C15.9217 9.20019 16.672 9.20018 17.2702 9.24892C17.8799 9.2986 18.4125 9.4034 18.885 9.66267C19.7949 10.162 20.4572 11.0161 20.7142 12.0217C20.8476 12.5438 20.8164 13.0858 20.7127 13.6887C20.6109 14.2802 20.4241 15.0068 20.1903 15.9158L20.0628 16.4118C19.8849 17.1037 19.7403 17.6659 19.5849 18.1174C19.4237 18.5857 19.2344 18.987 18.9412 19.3412C18.5893 19.7664 18.148 20.1086 17.6486 20.3435C17.2325 20.5392 16.7967 20.6227 16.3031 20.6621C15.827 20.7002 15.2466 20.7002 14.5321 20.7002H12.898C11.9995 20.7002 11.2503 20.7003 10.6555 20.6203C10.0277 20.5359 9.46088 20.3502 9.00541 19.8947C8.54994 19.4393 8.36427 18.8725 8.27986 18.2447C8.1999 17.6499 8.19992 16.9007 8.19995 16.0022L8.19995 11.8579L9.83722 5.30879C9.84326 5.28463 9.84795 5.26586 9.85258 5.24833C10.1678 4.05415 11.2405 3.21661 12.4755 3.20043C12.4936 3.20019 12.5129 3.20019 12.5379 3.2002L12.5492 3.2002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.19995 11.9502C3.19995 10.9837 3.98345 10.2002 4.94995 10.2002C5.91645 10.2002 6.69995 10.9837 6.69995 11.9502V18.9502C6.69995 19.9167 5.91645 20.7002 4.94995 20.7002C3.98345 20.7002 3.19995 19.9167 3.19995 18.9502V11.9502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "thumbs-up-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["thumbs-up","like","approve","confirm","agreement","ok","positive","validation","accept","success","approved-transaction","verified","acknowledged","completed"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 13V18C8 18.9428 8 19.4142 7.70711 19.7071C7.41421 20 6.94281 20 6 20C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V13C4 12.0572 4 11.5858 4.29289 11.2929C4.58579 11 5.05719 11 6 11C6.94281 11 7.41421 11 7.70711 11.2929C8 11.5858 8 12.0572 8 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25V10.75ZM13.6042 6.37483L14.344 6.49812L13.6042 6.37483ZM13.6172 6.29491L12.8754 6.18432L13.6172 6.29491ZM9.61378 5.54487L8.88618 5.36297L9.61378 5.54487ZM9.62779 5.48955L10.353 5.68097L9.62779 5.48955ZM13.1644 9.01361L12.4246 8.89031L13.1644 9.01361ZM12.8644 6.25153L12.4246 8.89031L13.9042 9.13691L14.344 6.49812L12.8644 6.25153ZM8.72761 12.1819L10.3414 5.72677L8.88618 5.36297L7.27239 11.8181L8.72761 12.1819ZM14.344 6.49812C14.3504 6.45942 14.3553 6.43047 14.359 6.4055L12.8754 6.18432C12.8741 6.19328 12.8719 6.2063 12.8644 6.25153L14.344 6.49812ZM11.5924 4.75C11.6383 4.75 11.6515 4.75003 11.6605 4.75018L11.6863 3.2504C11.661 3.24997 11.6317 3.25 11.5924 3.25V4.75ZM14.359 6.4055C14.604 4.76238 13.3473 3.2789 11.6863 3.2504L11.6605 4.75018C12.4155 4.76314 12.9868 5.43745 12.8754 6.18432L14.359 6.4055ZM10.3414 5.72677C10.349 5.6962 10.3512 5.68773 10.353 5.68097L8.90263 5.29813C8.89772 5.31671 8.89275 5.33667 8.88618 5.36297L10.3414 5.72677ZM11.5924 3.25C11.5653 3.25 11.5447 3.24998 11.5255 3.25024L11.5452 4.75011C11.5522 4.75002 11.5609 4.75 11.5924 4.75V3.25ZM10.353 5.68097C10.4962 5.13816 10.9838 4.75746 11.5452 4.75011L11.5255 3.25024C10.2905 3.26642 9.21785 4.10395 8.90263 5.29813L10.353 5.68097ZM12.4246 8.89031C12.2624 9.86381 13.0131 10.75 14 10.75V9.25C13.94 9.25 13.8943 9.19611 13.9042 9.13691L12.4246 8.89031Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8 11V16C8 17.8856 8 18.8284 8.58579 19.4142C9.17157 20 10.1144 20 12 20H13.5516C15.0324 20 15.7728 20 16.3794 19.7146C16.7789 19.5267 17.132 19.2529 17.4135 18.9128C17.8409 18.3964 18.0253 17.6793 18.3941 16.2452L18.5058 15.811C18.9872 13.9385 19.228 13.0023 19.0376 12.2572C18.832 11.4527 18.3022 10.7694 17.5742 10.37C16.9 10 15.9334 10 14 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "thumbs-up-alert-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["thumbs-up","like","agreement","approval","ok","confirmation","accepted","positive","validated","correct"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1644 10.0136L13.6042 7.37483C13.6112 7.33286 13.6147 7.31188 13.6172 7.29491C13.7954 6.09991 12.8814 5.02102 11.6734 5.00029C11.6562 5 11.635 5 11.5924 5C11.5631 5 11.5485 5 11.5353 5.00017C10.6372 5.01194 9.85704 5.62106 9.62779 6.48955C9.62445 6.50222 9.62089 6.51644 9.61378 6.54487L8 13V15C8 16.8856 8 17.8284 8.58579 18.4142C9.17157 19 10.1144 19 12 19H16C16.93 19 17.395 19 17.7765 18.8978C18.8117 18.6204 19.6204 17.8117 19.8978 16.7765C20 16.395 20 15.93 20 15C20 14.07 20 13.605 19.8978 13.2235C19.6204 12.1883 18.8117 11.3796 17.7765 11.1022C17.395 11 16.93 11 16 11H14C13.4765 11 13.0783 10.53 13.1644 10.0136Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8 13L9.61378 6.54487C9.62089 6.51644 9.62445 6.50222 9.62779 6.48955C9.85704 5.62106 10.6372 5.01194 11.5353 5.00017C11.5485 5 11.5631 5 11.5924 5C11.635 5 11.6562 5 11.6734 5.00029C12.8814 5.02102 13.7954 6.09991 13.6172 7.29491C13.6147 7.31188 13.6112 7.33286 13.6042 7.37483L13.1644 10.0136C13.0783 10.53 13.4765 11 14 11H16C16.93 11 17.395 11 17.7765 11.1022C18.8117 11.3796 19.6204 12.1883 19.8978 13.2235C20 13.605 20 14.07 20 15C20 15.93 20 16.395 19.8978 16.7765C19.6204 17.8117 18.8117 18.6204 17.7765 18.8978C17.395 19 16.93 19 16 19H12C10.1144 19 9.17157 19 8.58579 18.4142C8 17.8284 8 16.8856 8 15V11.8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="2"
                />
                <path
                    d="M8 13V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="2"
                />
                <path d="M12 3V2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M7.99976 5L7 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
                <path d="M16 5L16.9998 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="2" strokeLinecap="round" />
            </svg>
        )
    },
    "thumbs-up-alert-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["thumbs-up","approve","agree","confirm","success","completed","approved","verified","okay","like"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 13V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M12 3V2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7.99976 5L7 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5L16.9998 4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 11.75C14.4142 11.75 14.75 11.4142 14.75 11C14.75 10.5858 14.4142 10.25 14 10.25V11.75ZM13.6042 7.37483L14.344 7.49812L13.6042 7.37483ZM13.6172 7.29491L12.8754 7.18432L13.6172 7.29491ZM9.61378 6.54487L8.88618 6.36297L9.61378 6.54487ZM9.62779 6.48955L10.353 6.68097L9.62779 6.48955ZM13.1644 10.0136L12.4246 9.89031L13.1644 10.0136ZM12.8644 7.25153L12.4246 9.89031L13.9042 10.1369L14.344 7.49812L12.8644 7.25153ZM8.72761 13.1819L10.3414 6.72677L8.88618 6.36297L7.27239 12.8181L8.72761 13.1819ZM14.344 7.49812C14.3504 7.45942 14.3553 7.43047 14.359 7.4055L12.8754 7.18432C12.8741 7.19328 12.8719 7.2063 12.8644 7.25153L14.344 7.49812ZM11.5924 5.75C11.6383 5.75 11.6515 5.75003 11.6605 5.75018L11.6863 4.2504C11.661 4.24997 11.6317 4.25 11.5924 4.25V5.75ZM14.359 7.4055C14.604 5.76238 13.3473 4.2789 11.6863 4.2504L11.6605 5.75018C12.4155 5.76314 12.9868 6.43745 12.8754 7.18432L14.359 7.4055ZM10.3414 6.72677C10.349 6.6962 10.3512 6.68773 10.353 6.68097L8.90263 6.29813C8.89772 6.31671 8.89275 6.33667 8.88618 6.36297L10.3414 6.72677ZM11.5924 4.25C11.5653 4.25 11.5447 4.24998 11.5255 4.25024L11.5452 5.75011C11.5522 5.75002 11.5609 5.75 11.5924 5.75V4.25ZM10.353 6.68097C10.4962 6.13816 10.9838 5.75746 11.5452 5.75011L11.5255 4.25024C10.2905 4.26642 9.21785 5.10395 8.90263 6.29813L10.353 6.68097ZM12.4246 9.89031C12.2624 10.8638 13.0131 11.75 14 11.75V10.25C13.94 10.25 13.8943 10.1961 13.9042 10.1369L12.4246 9.89031Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8 12V12.5V13.6V15.4V15.4C8 16.8999 8 17.6498 8.38197 18.1756C8.50532 18.3454 8.65464 18.4947 8.82443 18.618C9.35016 19 10.1001 19 11.6 19H16C16.93 19 17.395 19 17.7765 18.8978C18.8117 18.6204 19.6204 17.8117 19.8978 16.7765C20 16.395 20 15.93 20 15V15C20 14.07 20 13.605 19.8978 13.2235C19.6204 12.1883 18.8117 11.3796 17.7765 11.1022C17.395 11 16.93 11 16 11H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "thumbs-up-alert": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-up","like","approval","accept","success","confirmed","good","ok","positive","check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 11.75C14.4142 11.75 14.75 11.4142 14.75 11C14.75 10.5858 14.4142 10.25 14 10.25V11.75ZM13.6042 7.37483L14.344 7.49812L13.6042 7.37483ZM13.6172 7.29491L12.8754 7.18432L13.6172 7.29491ZM9.61378 6.54487L8.88618 6.36297L9.61378 6.54487ZM9.62779 6.48955L10.353 6.68097L9.62779 6.48955ZM13.1644 10.0136L12.4246 9.89031L13.1644 10.0136ZM12.8644 7.25153L12.4246 9.89031L13.9042 10.1369L14.344 7.49812L12.8644 7.25153ZM8.72761 13.1819L10.3414 6.72677L8.88618 6.36297L7.27239 12.8181L8.72761 13.1819ZM14.344 7.49812C14.3504 7.45942 14.3553 7.43047 14.359 7.4055L12.8754 7.18432C12.8741 7.19328 12.8719 7.2063 12.8644 7.25153L14.344 7.49812ZM11.5924 5.75C11.6383 5.75 11.6515 5.75003 11.6605 5.75018L11.6863 4.2504C11.661 4.24997 11.6317 4.25 11.5924 4.25V5.75ZM14.359 7.4055C14.604 5.76238 13.3473 4.2789 11.6863 4.2504L11.6605 5.75018C12.4155 5.76314 12.9868 6.43745 12.8754 7.18432L14.359 7.4055ZM10.3414 6.72677C10.349 6.6962 10.3512 6.68773 10.353 6.68097L8.90263 6.29813C8.89772 6.31671 8.89275 6.33667 8.88618 6.36297L10.3414 6.72677ZM11.5924 4.25C11.5653 4.25 11.5447 4.24998 11.5255 4.25024L11.5452 5.75011C11.5522 5.75002 11.5609 5.75 11.5924 5.75V4.25ZM10.353 6.68097C10.4962 6.13816 10.9838 5.75746 11.5452 5.75011L11.5255 4.25024C10.2905 4.26642 9.21785 5.10395 8.90263 6.29813L10.353 6.68097ZM12.4246 9.89031C12.2624 10.8638 13.0131 11.75 14 11.75V10.25C13.94 10.25 13.8943 10.1961 13.9042 10.1369L12.4246 9.89031Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 11.8V15C8 16.8856 8 17.8284 8.58579 18.4142C9.17157 19 10.1144 19 12 19H16C16.93 19 17.395 19 17.7765 18.8978C18.8117 18.6204 19.6204 17.8117 19.8978 16.7765C20 16.395 20 15.93 20 15V15C20 14.07 20 13.605 19.8978 13.2235C19.6204 12.1883 18.8117 11.3796 17.7765 11.1022C17.395 11 16.93 11 16 11H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 13V17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17V13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 3V2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7.99976 5L7 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 5L16.9998 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "thumbs-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-up","like","approve","confirm","agree","yes","positive","accept","good","ok","complete","success","validation","customer-satisfaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 9.58579 14.4142 9.25 14 9.25V10.75ZM13.6042 6.37483L14.344 6.49812L13.6042 6.37483ZM13.6172 6.29491L12.8754 6.18432L13.6172 6.29491ZM9.61378 5.54487L8.88618 5.36297L9.61378 5.54487ZM9.62779 5.48955L10.353 5.68097L9.62779 5.48955ZM13.1644 9.01361L12.4246 8.89031L13.1644 9.01361ZM12.8644 6.25153L12.4246 8.89031L13.9042 9.13691L14.344 6.49812L12.8644 6.25153ZM8.72761 12.1819L10.3414 5.72677L8.88618 5.36297L7.27239 11.8181L8.72761 12.1819ZM14.344 6.49812C14.3504 6.45942 14.3553 6.43047 14.359 6.4055L12.8754 6.18432C12.8741 6.19328 12.8719 6.2063 12.8644 6.25153L14.344 6.49812ZM11.5924 4.75C11.6383 4.75 11.6515 4.75003 11.6605 4.75018L11.6863 3.2504C11.661 3.24997 11.6317 3.25 11.5924 3.25V4.75ZM14.359 6.4055C14.604 4.76238 13.3473 3.2789 11.6863 3.2504L11.6605 4.75018C12.4155 4.76314 12.9868 5.43745 12.8754 6.18432L14.359 6.4055ZM10.3414 5.72677C10.349 5.6962 10.3512 5.68773 10.353 5.68097L8.90263 5.29813C8.89772 5.31671 8.89275 5.33667 8.88618 5.36297L10.3414 5.72677ZM11.5924 3.25C11.5653 3.25 11.5447 3.24998 11.5255 3.25024L11.5452 4.75011C11.5522 4.75002 11.5609 4.75 11.5924 4.75V3.25ZM10.353 5.68097C10.4962 5.13816 10.9838 4.75746 11.5452 4.75011L11.5255 3.25024C10.2905 3.26642 9.21785 4.10395 8.90263 5.29813L10.353 5.68097ZM12.4246 8.89031C12.2624 9.86381 13.0131 10.75 14 10.75V9.25C13.94 9.25 13.8943 9.19611 13.9042 9.13691L12.4246 8.89031Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8 11V16C8 17.8856 8 18.8284 8.58579 19.4142C9.17157 20 10.1144 20 12 20H13.5516C15.0324 20 15.7728 20 16.3794 19.7146C16.7789 19.5267 17.132 19.2529 17.4135 18.9128C17.8409 18.3964 18.0253 17.6793 18.3941 16.2452L18.5058 15.811C18.9872 13.9385 19.228 13.0023 19.0376 12.2572C18.832 11.4527 18.3022 10.7694 17.5742 10.37C16.9 10 15.9334 10 14 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 13V18C8 18.9428 8 19.4142 7.70711 19.7071C7.41421 20 6.94281 20 6 20C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V13C4 12.0572 4 11.5858 4.29289 11.2929C4.58579 11 5.05719 11 6 11C6.94281 11 7.41421 11 7.70711 11.2929C8 11.5858 8 12.0572 8 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Ticket v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","reward","promotion","event","admit","sale"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2043 9 12 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10V10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 14V14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19L8 19C6.13077 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "thumbs-up-alert-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["thumbs-up","like","approval","accepted","agree","okay","positive","confirmation","validation","check","approved","good","thumbs","recommend"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.75 13.8L9.38727 8.35859C9.39331 8.33443 9.398 8.31567 9.40263 8.29813C9.71785 7.10395 10.7905 6.26642 12.0255 6.25024C12.0437 6.25 12.063 6.25 12.0879 6.25L12.0993 6.25C12.1351 6.25 12.1625 6.25 12.1863 6.2504C13.8473 6.2789 15.104 7.76238 14.859 9.4055C14.8555 9.42904 14.851 9.4561 14.8451 9.49154L14.4042 12.1369C14.3943 12.1961 14.44 12.25 14.5 12.25H16.5C16.5392 12.25 16.5778 12.25 16.6158 12.25C17.4338 12.2497 17.9919 12.2495 18.4706 12.3778C19.7647 12.7245 20.7755 13.7353 21.1222 15.0294C21.2505 15.5081 21.2503 16.0662 21.25 16.8842C21.25 16.9222 21.25 16.9608 21.25 17C21.25 17.0392 21.25 17.0778 21.25 17.1158C21.2503 17.9338 21.2505 18.4919 21.1222 18.9706C20.7755 20.2647 19.7647 21.2755 18.4706 21.6222C17.9919 21.7505 17.4338 21.7503 16.6158 21.75C16.5778 21.75 16.5392 21.75 16.5 21.75L12.448 21.75C11.5495 21.75 10.8003 21.7501 10.2055 21.6701C9.57773 21.5857 9.01093 21.4 8.55546 20.9445C8.09999 20.4891 7.91432 19.9223 7.82991 19.2945C7.74995 18.6997 7.74997 17.9505 7.75 17.052L7.75 13.8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.75 14C2.75 13.0335 3.5335 12.25 4.5 12.25C5.4665 12.25 6.25 13.0335 6.25 14V20C6.25 20.9665 5.4665 21.75 4.5 21.75C3.5335 21.75 2.75 20.9665 2.75 20V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 2C13.0523 2 13.5 2.44772 13.5 3V4C13.5 4.55228 13.0523 5 12.5 5C11.9477 5 11.5 4.55228 11.5 4V3C11.5 2.44772 11.9477 2 12.5 2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.79298 4.29281C7.18355 3.90233 7.81672 3.90241 8.20719 4.29298L9.20695 5.29298C9.59743 5.68355 9.59735 6.31672 9.20678 6.70719C8.8162 7.09767 8.18304 7.09759 7.79256 6.70702L6.79281 5.70702C6.40233 5.31645 6.40241 4.68328 6.79298 4.29281Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.2068 4.29281C17.8162 3.90233 17.183 3.90241 16.7926 4.29298L15.7928 5.29298C15.4023 5.68355 15.4024 6.31672 15.793 6.70719C16.1836 7.09767 16.8167 7.09759 17.2072 6.70702L18.2069 5.70702C18.5974 5.31645 18.5973 4.68328 18.2068 4.29281Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","receipt","coupon","discount","voucher","reward","point-of-sale","transaction","sale","payment","credit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 13C2.44772 13 2 13.4477 2 14V14.046C1.99999 14.9415 1.99997 15.6805 2.05433 16.2802C2.11085 16.9039 2.23242 17.4744 2.5359 18C2.88697 18.6081 3.39193 19.113 4 19.4641C4.52564 19.7676 5.09615 19.8892 5.71984 19.9457C6.31953 20 7.0585 20 7.95396 20L16.046 20C16.9415 20 17.6805 20 18.2802 19.9457C18.9039 19.8892 19.4744 19.7676 20 19.4641C20.6081 19.113 21.113 18.6081 21.4641 18C21.7676 17.4744 21.8892 16.9039 21.9457 16.2802C22 15.6805 22 14.9415 22 14.046V14C22 13.4477 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 10.5523 22 10V9.95399C22 9.05853 22 8.31952 21.9457 7.71983C21.8892 7.09615 21.7676 6.52564 21.4641 6C21.113 5.39192 20.6081 4.88697 20 4.5359C19.4744 4.23242 18.9039 4.11085 18.2802 4.05432C17.6805 3.99997 16.9415 3.99998 16.046 4L7.95396 4C7.05852 3.99999 6.31951 3.99997 5.71983 4.05433C5.09615 4.11085 4.52564 4.23242 4 4.5359C3.39192 4.88698 2.88697 5.39193 2.5359 6C2.23242 6.52565 2.11085 7.09615 2.05432 7.71984C1.99997 8.31952 1.99999 9.05852 2 9.95396L2 10C2 10.5523 2.44772 11 3 11C3.55228 11 4 11.4477 4 12C4 12.5523 3.55229 13 3 13ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","reward","point","loyalty","offer","promotion","redeem"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 10.8954 4.10457 10 3 10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19H16L8 19H7.99999C6.13076 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14C4.10457 14 5 13.1046 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2043 9 12 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["settings","configuration","options","controls","preferences","system","setup","adjustments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13V12V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V12V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Ticket v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","promotion","event","reward","offer","admit","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2043 9 12 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10V10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 14V14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19L8 19C6.13077 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ticket v3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","adjust","preferences","configuration","options","customize","setup","control panel"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13V12V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V12V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","camera","adjust","preferences","options","configuration","setup","mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13V12V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V12V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","vault","security","cash","money","payment","secure-payment","transaction","finance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.4251 4.11875C17.5413 3.99994 16.4247 3.99997 15.0706 4H8.92943C7.57531 3.99997 6.4587 3.99994 5.57494 4.11875C4.64711 4.2435 3.82768 4.51547 3.17158 5.17158C2.51547 5.82768 2.2435 6.64711 2.11875 7.57494C1.99994 8.4587 1.99997 9.57531 2 10.9294V13.0706C1.99997 14.4247 1.99994 15.5413 2.11875 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82768 19.4845 4.64711 19.7565 5.57494 19.8813C6.4587 20.0001 7.57533 20 8.92946 20H15.0705C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0705V10.9295C22 9.57533 22.0001 8.4587 21.8813 7.57494C21.7565 6.64711 21.4845 5.82768 20.8284 5.17158C20.1723 4.51547 19.3529 4.2435 18.4251 4.11875ZM9 8C11.2091 8 13 9.79086 13 12C13 14.2091 11.2091 16 9 16C6.79086 16 5 14.2091 5 12C5 10.9391 5.42143 9.92172 6.17157 9.17158C6.92172 8.42143 7.93914 8 9 8ZM16 9C16 8.44772 16.4477 8 17 8L18 8C18.5523 8 19 8.44772 19 9C19 9.55229 18.5523 10 18 10L17 10C16.4477 10 16 9.55229 16 9ZM14.5 12C14.5 11.4477 14.9477 11 15.5 11L18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H15.5C14.9477 13 14.5 12.5523 14.5 12ZM16 15C16 14.4477 16.4477 14 17 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H17C16.4477 16 16 15.5523 16 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 10C10.1046 10 11 10.8954 11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 11.4696 7.21072 10.9609 7.58579 10.5858C7.96086 10.2107 8.46957 10 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v4-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","receipt","print","printer","transaction","sale","payment","document","record","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 8.6V15.4C21 15.6811 21 15.8216 20.9134 15.9093C20.8269 15.9969 20.6845 15.9987 20.3998 16.0022C19.8482 16.0089 19.5132 16.0369 19.2346 16.1522C18.7446 16.3552 18.3552 16.7446 18.1522 17.2346C18 17.6022 18 18.0681 18 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H16.2181C17.2022 5 17.7756 5.85618 18.1522 6.76537C18.3552 7.25542 18.7446 7.64477 19.2346 7.84776C19.5132 7.96314 19.8482 7.99108 20.3998 7.99784C20.6845 8.00133 20.8269 8.00308 20.9134 8.09072C21 8.17836 21 8.3189 21 8.6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C12.3431 15 11 13.6569 11 12C11 11.2044 11.3161 10.4413 11.8787 9.87868C12.4413 9.31607 13.2043 9 14 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L9 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L9 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","receipt","purchase","transaction","sale","order","print","print-ticket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 8C22 7.44772 21.5523 7 21 7C20.5204 7 20.2107 6.99946 19.9738 6.98329C19.7458 6.96774 19.6589 6.94112 19.6173 6.92388C19.3723 6.82239 19.1776 6.62771 19.0761 6.38269C19.0589 6.34107 19.0323 6.25424 19.0167 6.02624C19.0005 5.78926 19 5.47963 19 5C19 4.44772 18.5523 4 18 4L8.92943 4C7.57531 3.99997 6.4587 3.99994 5.57494 4.11875C4.64711 4.2435 3.82768 4.51547 3.17158 5.17158C2.51547 5.82768 2.2435 6.64711 2.11875 7.57494C1.99994 8.4587 1.99997 9.57531 2 10.9294V13.0706C1.99997 14.4247 1.99994 15.5413 2.11875 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82768 19.4845 4.64711 19.7565 5.57494 19.8813C6.4587 20.0001 7.57531 20 8.92943 20L18 20C18.5523 20 19 19.5523 19 19C19 18.5204 19.0005 18.2107 19.0167 17.9738C19.0323 17.7458 19.0589 17.6589 19.0761 17.6173C19.1776 17.3723 19.3723 17.1776 19.6173 17.0761C19.6589 17.0589 19.7458 17.0323 19.9738 17.0167C20.2107 17.0005 20.5204 17 21 17C21.5523 17 22 16.5523 22 16V8ZM14 8C16.2091 8 18 9.79086 18 12C18 14.2091 16.2091 16 14 16C11.7909 16 10 14.2091 10 12C10 10.9391 10.4214 9.92172 11.1716 9.17158C11.9217 8.42143 12.9391 8 14 8ZM9 15C9 15.5523 8.55229 16 8 16L7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14L8 14C8.55229 14 9 14.4477 9 15ZM9 12C9 12.5523 8.55229 13 8 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H8C8.55229 11 9 11.4477 9 12ZM9 9C9 9.55229 8.55229 10 8 10H7C6.44772 10 6 9.55229 6 9C6 8.44772 6.44772 8 7 8H8C8.55229 8 9 8.44772 9 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12C12 11.4696 12.2107 10.9609 12.5858 10.5858C12.9609 10.2107 13.4696 10 14 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v4-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ticket","coupon","receipt","discount","transaction","payment","invoice","voucher","sale","order","purchase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C12.3431 15 11 13.6569 11 12C11 11.2044 11.3161 10.4413 11.8787 9.87868C12.4413 9.31607 13.2043 9 14 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L9 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L9 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L9 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21 16V8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M21 8V8C20.0681 8 19.6022 8 19.2346 7.84776C18.7446 7.64477 18.3552 7.25542 18.1522 6.76537C18 6.39782 18 5.93188 18 5V5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 5L9 5C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 16V16C20.0681 16 19.6022 16 19.2346 16.1522C18.7446 16.3552 18.3552 16.7446 18.1522 17.2346C18 17.6022 18 18.0681 18 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Ticket v5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["safe","money","cash","drawer","cash-drawer","register","cash-register","finance","payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v5-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["device","settings","configuration","preferences","options","cash-drawer","sound","volume","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v4": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","receipt","coupon","discount","transaction","purchase","sale","order","voucher","billing","invoice","payment","record"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 16V8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M21 8V8C20.0681 8 19.6022 8 19.2346 7.84776C18.7446 7.64477 18.3552 7.25542 18.1522 6.76537C18 6.39782 18 5.93188 18 5V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 5L9 5C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 16V16C20.0681 16 19.6022 16 19.2346 16.1522C18.7446 16.3552 18.3552 16.7446 18.1522 17.2346C18 17.6022 18 18.0681 18 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C12.3431 15 11 13.6569 11 12C11 11.2044 11.3161 10.4413 11.8787 9.87868C12.4413 9.31607 13.2043 9 14 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L9 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L9 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","vault","money","cash","security","payment","transaction","balance","funds","deposit","withdraw"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.4251 5.11875C17.5413 4.99994 16.4247 4.99997 15.0706 5H8.92943C7.57531 4.99997 6.4587 4.99994 5.57494 5.11875C4.64711 5.2435 3.82768 5.51547 3.17158 6.17158C2.51547 6.82768 2.2435 7.64711 2.11875 8.57494C1.99994 9.4587 1.99997 10.5753 2 11.9294V12.0706C1.99997 13.4247 1.99994 14.5413 2.11875 15.4251C2.2435 16.3529 2.51547 17.1723 3.17158 17.8284C3.82768 18.4845 4.64711 18.7565 5.57494 18.8813C6.4587 19.0001 7.57531 19 8.92943 19H15.0706C16.4247 19 17.5413 19.0001 18.4251 18.8813C19.3529 18.7565 20.1723 18.4845 20.8284 17.8284C21.4845 17.1723 21.7565 16.3529 21.8813 15.4251C22.0001 14.5413 22 13.4247 22 12.0705V11.9295C22 10.5753 22.0001 9.4587 21.8813 8.57494C21.7565 7.64711 21.4845 6.82768 20.8284 6.17158C20.1723 5.51547 19.3529 5.2435 18.4251 5.11875ZM9 8C11.2091 8 13 9.79086 13 12C13 14.2091 11.2091 16 9 16C6.79086 16 5 14.2091 5 12C5 10.9391 5.42143 9.92172 6.17157 9.17158C6.92172 8.42143 7.93914 8 9 8ZM16 9C16 8.44772 16.4477 8 17 8H18C18.5523 8 19 8.44772 19 9C19 9.55229 18.5523 10 18 10L17 10C16.4477 10 16 9.55229 16 9ZM14.5 12C14.5 11.4477 14.9477 11 15.5 11L18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H15.5C14.9477 13 14.5 12.5523 14.5 12ZM16 15C16 14.4477 16.4477 14 17 14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H17C16.4477 16 16 15.5523 16 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 10C10.1046 10 11 10.8954 11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 11.4696 7.21072 10.9609 7.58579 10.5858C7.96086 10.2107 8.46957 10 9 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v5": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","security","record","video","surveillance","cctv","monitoring","footage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.34315 15 6 13.6569 6 12C6 11.2044 6.31607 10.4413 6.87868 9.87868C7.44129 9.31607 8.20435 9 9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L17 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12L15 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["display","screen","monitor","settings","configuration","options","menu","control panel","device","interface","touchscreen"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12L19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v6-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["money","cash","payment","currency","bill","transaction","refund","change","amount","due"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v6": {
        defaultColors: ["#3D4C66"],
        keywords: ["safe","money","cash","payment","vault","security","finance","transaction","register","cash-drawer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["remote","control","settings","configuration","device","options","adjust","input","machine"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 5C16.4247 4.99997 17.5413 4.99994 18.4251 5.11876C19.3529 5.2435 20.1723 5.51547 20.8284 6.17158C21.4845 6.82769 21.7565 7.64711 21.8813 8.57494C22.0001 9.45868 22 10.5753 22 11.9294V12.0705C22 13.4246 22.0001 14.5413 21.8813 15.4251C21.7565 16.3529 21.4845 17.1723 20.8284 17.8284C20.1723 18.4845 19.3529 18.7565 18.4251 18.8813C17.5413 19.0001 16.4247 19 15.0706 19H8.92943C7.57531 19 6.4587 19.0001 5.57494 18.8813C4.64711 18.7565 3.82769 18.4845 3.17158 17.8284C2.51547 17.1723 2.2435 16.3529 2.11876 15.4251C1.99994 14.5413 1.99997 13.4247 2 12.0706V11.9294C1.99997 10.5753 1.99994 9.45869 2.11876 8.57494C2.2435 7.64711 2.51547 6.82769 3.17158 6.17158C3.82769 5.51547 4.64711 5.2435 5.57494 5.11876C6.45869 4.99994 7.57529 4.99997 8.9294 5H15.0706ZM6 8C5.44772 8 5 8.44772 5 9C5 9.55229 5.44772 10 6 10H7C7.55229 10 8 9.55229 8 9C8 8.44772 7.55229 8 7 8L6 8ZM6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16H7C7.55229 16 8 15.5523 8 15C8 14.4477 7.55229 14 7 14H6ZM18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H17C16.4477 14 16 14.4477 16 15C16 15.5523 16.4477 16 17 16H18ZM18 10C18.5523 10 19 9.55229 19 9C19 8.44772 18.5523 8 18 8L17 8C16.4477 8 16 8.44772 16 9C16 9.55229 16.4477 10 17 10H18ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7957 9 12ZM4 12C4 11.4477 4.44772 11 5 11L7 11C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H5C4.44772 13 4 12.5523 4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11L17 11C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13L19 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v7-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ticket","receipt","details","info","transaction","purchase","sale","order-details","transaction-details","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19C8 17.8954 8.89543 17 10 17C11.1046 17 12 17.8954 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C12 6.10457 11.1046 7 10 7C8.89543 7 8 6.10457 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V12V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H8M12 19H17C18.8856 19 19.8284 19 20.4142 18.4142C21 17.8284 21 16.8856 21 15V12V9C21 7.11438 21 6.17157 20.4142 5.58579C19.8284 5 18.8856 5 17 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 9L6 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L6 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9C16.6569 9 18 10.3431 18 12C18 13.6569 16.6569 15 15 15C13.3431 15 12 13.6569 12 12C12 11.2044 12.3161 10.4413 12.8787 9.87868C13.4413 9.31607 14.2043 9 15 9Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v7-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","coupon","discount","receipt","voucher","sale","transaction","point-of-sale","pos","reward","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 17C8.89543 17 8 17.8954 8 19H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H8C8 6.10457 8.89543 7 10 7C11.1046 7 12 6.10457 12 5H17C18.8856 5 19.8284 5 20.4142 5.58579C21 6.17157 21 7.11438 21 9V15C21 16.8856 21 17.8284 20.4142 18.4142C19.8284 19 18.8856 19 17 19H12C12 17.8954 11.1046 17 10 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9L6 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L6 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9C16.6569 9 18 10.3431 18 12C18 13.6569 16.6569 15 15 15C13.3431 15 12 13.6569 12 12C12 11.2044 12.3161 10.4413 12.8787 9.87868C13.4413 9.31607 14.2043 9 15 9Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","sale","promotion","receipt","transaction","reward","loyalty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.8358 10.5858C14.2109 10.2107 14.7196 10 15.25 10C16.3546 10 17.25 10.8954 17.25 12C17.25 13.1046 16.3546 14 15.25 14C14.1454 14 13.25 13.1046 13.25 12C13.25 11.4696 13.4607 10.9609 13.8358 10.5858Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 18C9.44772 18 9.00001 18.4477 9.00001 19C9.00001 19.5523 8.55229 20 8.00001 20L6.93417 20C6.04769 20.0001 5.28387 20.0001 4.67221 19.9179C4.0167 19.8297 3.38835 19.631 2.87868 19.1213C2.36902 18.6117 2.17028 17.9833 2.08215 17.3278C1.99991 16.7161 1.99995 15.9523 2 15.0658V8.93417C1.99995 8.04769 1.99991 7.28387 2.08215 6.67221C2.17028 6.0167 2.36902 5.38835 2.87868 4.87868C3.38835 4.36902 4.0167 4.17028 4.67221 4.08215C5.28387 3.99991 6.04769 3.99995 6.93417 4L8 4.00001C8.55229 4.00001 9 4.44772 9 5C9 5.55229 9.44772 6.00001 10 6.00001C10.5523 6.00001 11 5.55229 11 5C11 4.44772 11.4477 4 12 4L17.0658 4C17.9523 3.99995 18.7161 3.99991 19.3278 4.08215C19.9833 4.17028 20.6117 4.36902 21.1213 4.87868C21.631 5.38835 21.8297 6.0167 21.9179 6.67221C22.0001 7.28388 22.0001 8.0477 22 8.9342V15.0658C22.0001 15.9523 22.0001 16.7161 21.9179 17.3278C21.8297 17.9833 21.631 18.6117 21.1213 19.1213C20.6117 19.631 19.9833 19.8297 19.3278 19.9179C18.7161 20.0001 17.9523 20.0001 17.0658 20L12 20C11.4477 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18ZM7.25 8L5.75 8C5.19772 8 4.75 8.44772 4.75 9C4.75 9.55229 5.19772 10 5.75 10L7.25 10C7.80229 10 8.25 9.55228 8.25 9C8.25 8.44771 7.80228 8 7.25 8ZM15.25 8C14.1891 8 13.1717 8.42143 12.4216 9.17157C11.6714 9.92172 11.25 10.9391 11.25 12C11.25 14.2091 13.0409 16 15.25 16C17.4591 16 19.25 14.2091 19.25 12C19.25 9.79086 17.4591 8 15.25 8ZM8.75 13C9.30229 13 9.75 12.5523 9.75 12C9.75 11.4477 9.30229 11 8.75 11L5.75 11C5.19772 11 4.75 11.4477 4.75 12C4.75 12.5523 5.19772 13 5.75 13H8.75ZM7.25 14H5.75C5.19771 14 4.75 14.4477 4.75 15C4.75 15.5523 5.19772 16 5.75 16L7.25 16C7.80229 16 8.25 15.5523 8.25 15C8.25 14.4477 7.80228 14 7.25 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v8-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["settings","adjust","sliders","preferences","configuration","controls","options","edit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v8-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["settings","adjust","sliders","preferences","options","filter","configuration","equalizer","controls"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["settings","control","adjust","options","configuration","preferences","equalizer","audio","volume","setup","fine-tune"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.4251 5.11875C17.5413 4.99994 16.4247 4.99997 15.0706 5H8.92943C7.57531 4.99997 6.4587 4.99994 5.57494 5.11875C4.64711 5.2435 3.82768 5.51547 3.17158 6.17158C2.51547 6.82768 2.2435 7.64711 2.11875 8.57494C1.99994 9.4587 1.99997 10.5753 2 11.9294V12.0706C1.99997 13.4247 1.99994 14.5413 2.11875 15.4251C2.2435 16.3529 2.51547 17.1723 3.17158 17.8284C3.82768 18.4845 4.64711 18.7565 5.57494 18.8813C6.4587 19.0001 7.57531 19 8.92943 19H15.0706C16.4247 19 17.5413 19.0001 18.4251 18.8813C19.3529 18.7565 20.1723 18.4845 20.8284 17.8284C21.4845 17.1723 21.7565 16.3529 21.8813 15.4251C22.0001 14.5413 22 13.4247 22 12.0705V11.9295C22 10.5753 22.0001 9.4587 21.8813 8.57494C21.7565 7.64711 21.4845 6.82768 20.8284 6.17158C20.1723 5.51547 19.3529 5.2435 18.4251 5.11875ZM5 9C5 8.44772 5.44772 8 6 8L7 8C7.55229 8 8 8.44772 8 9C8 9.55229 7.55229 10 7 10H6C5.44772 10 5 9.55229 5 9ZM5 15C5 14.4477 5.44772 14 6 14H7C7.55229 14 8 14.4477 8 15C8 15.5523 7.55229 16 7 16H6C5.44772 16 5 15.5523 5 15ZM19 15C19 15.5523 18.5523 16 18 16H17C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14H18C18.5523 14 19 14.4477 19 15ZM5 12C5 11.4477 5.44772 11 6 11L9.17071 11C9.58255 9.83481 10.6938 9 12 9C13.3062 9 14.4175 9.83481 14.8293 11L18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13L14.8293 13C14.4175 14.1652 13.3062 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.55928 13.8019 9.31933 13.4179 9.17157 13L6 13C5.44772 13 5 12.5523 5 12ZM19 9C19 9.55229 18.5523 10 18 10H17C16.4477 10 16 9.55229 16 9C16 8.44772 16.4477 8 17 8L18 8C18.5523 8 19 8.44772 19 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket v8": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","reward","promotion","offer","price","cut","certificate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 18H9C6.17157 18 4.75736 18 3.87868 17.1213C3 16.2426 3 14.8284 3 12C3 9.17157 3 7.75736 3.87868 6.87868C4.75736 6 6.17157 6 9 6H15C17.8284 6 19.2426 6 20.1213 6.87868C21 7.75736 21 9.17157 21 12C21 14.8284 21 16.2426 20.1213 17.1213C19.2426 18 17.8284 18 15 18Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 15L5 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 15L19 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12L19 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 9L19 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket v7": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","receipt","coupon","discount","voucher","confirmation","order-details","transaction","sale","event","movie","admit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 19C8 17.8954 8.89543 17 10 17C11.1046 17 12 17.8954 12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5C12 6.10457 11.1046 7 10 7C8.89543 7 8 6.10457 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 19H7C5.11438 19 4.17157 19 3.58579 18.4142C3 17.8284 3 16.8856 3 15V12V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H8M12 19H17C18.8856 19 19.8284 19 20.4142 18.4142C21 17.8284 21 16.8856 21 15V12V9C21 7.11438 21 6.17157 20.4142 5.58579C19.8284 5 18.8856 5 17 5H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 9L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12L6 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 15L6 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9C16.6569 9 18 10.3431 18 12C18 13.6569 16.6569 15 15 15C13.3431 15 12 13.6569 12 12C12 11.2044 12.3161 10.4413 12.8787 9.87868C13.4413 9.31607 14.2043 9 15 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Ticket-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","promotion","receipt","admit-one","event","pass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 10.8954 4.10457 10 3 10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19L8 19C6.13078 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14C4.10457 14 5 13.1046 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Ticket-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","promotion","event","movie","admission","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M3 10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10V10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 14V14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19L8 19C6.13077 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ticket-dollar-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wallet","money","payment","cash","dollar","transaction","finance","sale","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M3 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L21 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 10L12 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11V11C11 11.5523 11.4477 12 12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Ticket-dollar-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","dollar","payment","money","transaction","discount","coupon","price","exchange","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="3"
                    y="5"
                    width="18"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M3 15L8 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L21 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="12"
                    r="5"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 10L12 9" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11V11C11 11.5523 11.4477 12 12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ticket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","voucher","discount","reward","promotion","redemption","redeem","transaction","validation","event","offer","certificate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 11C3.55229 11 4 11.4477 4 12C4 12.5523 3.55229 13 3 13C2.44772 13 2 13.4477 2 14L2 14.046C1.99999 14.9415 1.99997 15.6805 2.05432 16.2802C2.11085 16.9039 2.23242 17.4744 2.5359 18C2.88697 18.6081 3.39192 19.113 4 19.4641C4.52564 19.7676 5.09615 19.8892 5.71983 19.9457C6.31952 20 7.05849 20 7.95396 20L16.046 20C16.9415 20 17.6805 20 18.2802 19.9457C18.9039 19.8892 19.4744 19.7676 20 19.4641C20.6081 19.113 21.113 18.6081 21.4641 18C21.7676 17.4744 21.8892 16.9039 21.9457 16.2802C22 15.6805 22 14.9415 22 14.046V14C22 13.4477 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 10.5523 22 10L22 9.95399C22 9.05851 22 8.31953 21.9457 7.71983C21.8892 7.09615 21.7676 6.52564 21.4641 6C21.113 5.39192 20.6081 4.88697 20 4.5359C19.4744 4.23242 18.9039 4.11085 18.2802 4.05432C17.6805 3.99997 16.9415 3.99998 16.046 4H7.95396C7.05849 3.99998 6.31952 3.99997 5.71983 4.05432C5.09615 4.11085 4.52564 4.23242 4 4.5359C3.39192 4.88697 2.88697 5.39192 2.5359 6C2.23242 6.52564 2.11085 7.09615 2.05432 7.71983C1.99997 8.31952 1.99998 9.05849 2 9.95396L2 10C2 10.5523 2.44772 11 3 11ZM11.9342 7L12 7L12.0658 7C12.9523 6.99995 13.7161 6.99991 14.3278 7.08214C14.9833 7.17027 15.6117 7.36902 16.1213 7.87868C16.631 8.38834 16.8297 9.01669 16.9179 9.67221C17.0001 10.2839 17.0001 11.0477 17 11.9342V12.0658C17.0001 12.9523 17.0001 13.7161 16.9179 14.3278C16.8297 14.9833 16.631 15.6117 16.1213 16.1213C15.6117 16.631 14.9833 16.8297 14.3278 16.9179C13.7161 17.0001 12.9523 17.0001 12.0658 17H11.9342C11.0477 17.0001 10.2839 17.0001 9.67221 16.9179C9.01669 16.8297 8.38834 16.631 7.87868 16.1213C7.36902 15.6117 7.17027 14.9833 7.08214 14.3278C6.99991 13.7161 6.99995 12.9523 7 12.0658L7 12L7 11.9342C6.99995 11.0477 6.99991 10.2839 7.08214 9.67221C7.17027 9.01669 7.36902 8.38834 7.87868 7.87868C8.38834 7.36902 9.01669 7.17027 9.67221 7.08214C10.2839 6.99991 11.0477 6.99995 11.9342 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.29289 9.29289C9.36902 9.21677 9.50497 9.12262 9.9387 9.06431C10.4012 9.00212 11.0289 9 12 9C12.9711 9 13.5988 9.00212 14.0613 9.06431C14.495 9.12262 14.631 9.21677 14.7071 9.29289C14.7832 9.36902 14.8774 9.50497 14.9357 9.9387C14.9979 10.4012 15 11.0289 15 12C15 12.9711 14.9979 13.5988 14.9357 14.0613C14.8774 14.495 14.7832 14.631 14.7071 14.7071C14.631 14.7832 14.495 14.8774 14.0613 14.9357C13.5988 14.9979 12.9711 15 12 15C11.0289 15 10.4012 14.9979 9.9387 14.9357C9.50497 14.8774 9.36902 14.7832 9.29289 14.7071C9.21677 14.631 9.12262 14.495 9.06431 14.0613C9.00212 13.5988 9 12.9711 9 12C9 11.0289 9.00212 10.4012 9.06431 9.9387C9.12262 9.50497 9.21677 9.36902 9.29289 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket-Dollar-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","scan","image","barcode","qr-code","recognize","picture","photo","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M6 12L7 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Ticket-Dollar-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","scan","photo","image","picture","rectangle","center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H18" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Ticket-Dollar-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["price","discount","reward","loyalty","program","cash","money","sale","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="3"
                    y="5"
                    width="18"
                    height="14"
                    rx="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M6 12L7 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 12H18" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Ticket-dollar-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["payment","dollar","money","currency","cash","wallet","transaction","sale","finance","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.92943 4H15.0706C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82769 21.7565 6.64711 21.8813 7.57494C21.9097 7.78658 21.9313 8.01158 21.9478 8.25H16.359C15.3046 7.02538 13.7428 6.25 12 6.25C8.82436 6.25 6.25 8.82436 6.25 12C6.25 12.7985 6.41275 13.5589 6.70689 14.25H2.0034C1.99998 13.8791 1.99999 13.4861 2 13.0706V10.9294C1.99997 9.57533 1.99994 8.45869 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45869 3.99994 7.57533 3.99997 8.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M2.05221 15.75C2.06866 15.9884 2.0903 16.2134 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H15.0706C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706V10.9295C22 10.514 22 10.1209 21.9966 9.75H17.2931C17.5872 10.4411 17.75 11.2015 17.75 12C17.75 15.1756 15.1756 17.75 12 17.75C10.2572 17.75 8.69545 16.9746 7.64097 15.75H2.05221Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V9.25H13C13.4142 9.25 13.75 9.58579 13.75 10C13.75 10.4142 13.4142 10.75 13 10.75H12C11.8619 10.75 11.75 10.8619 11.75 11C11.75 11.1381 11.8619 11.25 12 11.25C12.9665 11.25 13.75 12.0335 13.75 13C13.75 13.6981 13.3412 14.3007 12.75 14.5816V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V14.75H11C10.5858 14.75 10.25 14.4142 10.25 14C10.25 13.5858 10.5858 13.25 11 13.25H12C12.1381 13.25 12.25 13.1381 12.25 13C12.25 12.8619 12.1381 12.75 12 12.75C11.0335 12.75 10.25 11.9665 10.25 11C10.25 10.3019 10.6588 9.69928 11.25 9.41841V9C11.25 8.58579 11.5858 8.25 12 8.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket-Dollar-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","scan","image","payment","capture","security","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0706 4H8.92943H8.9294C7.57529 3.99997 6.45869 3.99994 5.57494 4.11876C4.64711 4.2435 3.82769 4.51547 3.17158 5.17158C2.51547 5.82769 2.2435 6.64711 2.11876 7.57494C1.99994 8.45869 1.99997 9.57529 2 10.9294V10.9294V13.0706V13.0706C1.99997 14.4247 1.99994 15.5413 2.11876 16.4251C2.2435 17.3529 2.51547 18.1723 3.17158 18.8284C3.82769 19.4845 4.64711 19.7565 5.57494 19.8813C6.45868 20.0001 7.57527 20 8.92935 20H8.92943H15.0706H15.0707C16.4247 20 17.5413 20.0001 18.4251 19.8813C19.3529 19.7565 20.1723 19.4845 20.8284 18.8284C21.4845 18.1723 21.7565 17.3529 21.8813 16.4251C22.0001 15.5413 22 14.4247 22 13.0706V13.0705V10.9295V10.9294C22 9.57531 22.0001 8.4587 21.8813 7.57494C21.7565 6.64711 21.4845 5.82769 20.8284 5.17158C20.1723 4.51547 19.3529 4.2435 18.4251 4.11876C17.5413 3.99994 16.4247 3.99997 15.0706 4H15.0706ZM8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12ZM4 12C4 11.4477 4.44772 11 5 11L6 11C6.55229 11 7 11.4477 7 12C7 12.5523 6.55229 13 6 13H5C4.44772 13 4 12.5523 4 12ZM17 12C17 11.4477 17.4477 11 18 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H18C17.4477 13 17 12.5523 17 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Ticket-dollar": {
        defaultColors: ["#3D4C66"],
        keywords: ["payment","dollar","money","wallet","transaction","cash","sale","discount","price","finance","value","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M3 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 9L21 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 15L12 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 10L12 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 10H12C11.4477 10 11 10.4477 11 11V11C11 11.5523 11.4477 12 12 12V12C12.5523 12 13 12.4477 13 13V13C13 13.5523 12.5523 14 12 14H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "ticket-simple-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["ticket","coupon","voucher","discount","event","admission","reward","promotion","sale","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 18V6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M21 10V10C21 8.11438 21 7.17157 20.4142 6.58579C19.8284 6 18.8856 6 17 6H7C5.11438 6 4.17157 6 3.58579 6.58579C3 7.17157 3 8.11438 3 10V10M21 14V14C21 15.8856 21 16.8284 20.4142 17.4142C19.8284 18 18.8856 18 17 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3 16.8284 3 15.8856 3 14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "ticket-simple-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","reward","promotion","sale","certificate","offer","admit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3.03198 16.8604 3.00175 15.9875 3.0001 14.3005C2.99993 14.1348 3.1351 14.0024 3.29896 13.9778C4.26172 13.8335 5 13.003 5 12C5 10.997 4.26172 10.1665 3.29896 10.0222C3.1351 9.99763 2.99993 9.86518 3.0001 9.69949C3.00175 8.0125 3.03198 7.13959 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C20.968 7.13959 20.9983 8.0125 20.9999 9.69949C21.0001 9.86518 20.8649 9.99763 20.701 10.0222C19.7383 10.1665 19 10.997 19 12C19 13.003 19.7383 13.8335 20.701 13.9778C20.8649 14.0024 21.0001 14.1348 20.9999 14.3005C20.9983 15.9875 20.968 16.8604 20.4142 17.4142C19.8284 18 18.8856 18 17 18Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M20.4142 6.58579L20.9445 6.05546V6.05546L20.4142 6.58579ZM20.9999 9.69949L20.2499 9.70023V9.70023L20.9999 9.69949ZM20.9999 14.3005L20.2499 14.2998V14.2998L20.9999 14.3005ZM3.58579 17.4142L4.11612 16.8839L4.11612 16.8839L3.58579 17.4142ZM3.0001 14.3005L3.75009 14.2998L3.0001 14.3005ZM3.58579 6.58579L4.11612 7.11612L3.58579 6.58579ZM3.0001 9.69949L2.2501 9.69876L3.0001 9.69949ZM20.701 13.9778L20.8122 13.2361L20.8122 13.2361L20.701 13.9778ZM20.701 10.0222L20.8122 10.7639L20.701 10.0222ZM3.29896 13.9778L3.18779 13.2361H3.18778L3.29896 13.9778ZM3.29896 10.0222L3.41013 9.28048H3.41013L3.29896 10.0222ZM7 18.75H17V17.25H7V18.75ZM7 6.75H17V5.25H7V6.75ZM17 6.75C17.964 6.75 18.6116 6.75159 19.0946 6.81654C19.5561 6.87858 19.7536 6.9858 19.8839 7.11612L20.9445 6.05546C20.4891 5.59999 19.9223 5.41432 19.2945 5.32991C18.6883 5.24841 17.9216 5.25 17 5.25V6.75ZM21.7499 9.69876C21.7491 8.86992 21.7427 8.16904 21.6553 7.60318C21.5645 7.01537 21.3746 6.48553 20.9445 6.05546L19.8839 7.11612C20.0076 7.23985 20.1097 7.42336 20.1729 7.83221C20.2395 8.263 20.2491 8.84208 20.2499 9.70023L21.7499 9.69876ZM17 18.75C17.9216 18.75 18.6883 18.7516 19.2945 18.6701C19.9223 18.5857 20.4891 18.4 20.9445 17.9445L19.8839 16.8839C19.7536 17.0142 19.5561 17.1214 19.0946 17.1835C18.6116 17.2484 17.964 17.25 17 17.25V18.75ZM20.2499 14.2998C20.2491 15.1579 20.2395 15.737 20.1729 16.1678C20.1097 16.5766 20.0076 16.7601 19.8839 16.8839L20.9445 17.9445C21.3746 17.5145 21.5645 16.9846 21.6553 16.3968C21.7427 15.831 21.7491 15.1301 21.7499 14.3012L20.2499 14.2998ZM7 17.25C6.03599 17.25 5.38843 17.2484 4.90539 17.1835C4.44393 17.1214 4.24643 17.0142 4.11612 16.8839L3.05546 17.9445C3.51093 18.4 4.07773 18.5857 4.70552 18.6701C5.31174 18.7516 6.07839 18.75 7 18.75V17.25ZM2.2501 14.3012C2.25091 15.1301 2.25725 15.831 2.34468 16.3968C2.43549 16.9846 2.62539 17.5145 3.05546 17.9445L4.11612 16.8839C3.99238 16.7601 3.89026 16.5766 3.82709 16.1678C3.76053 15.737 3.75093 15.1579 3.75009 14.2998L2.2501 14.3012ZM7 5.25C6.07839 5.25 5.31174 5.24841 4.70552 5.32991C4.07773 5.41432 3.51093 5.59999 3.05546 6.05546L4.11612 7.11612C4.24643 6.9858 4.44393 6.87858 4.90539 6.81654C5.38843 6.75159 6.03599 6.75 7 6.75V5.25ZM3.75009 9.70023C3.75093 8.84208 3.76053 8.263 3.82709 7.83221C3.89026 7.42336 3.99238 7.23985 4.11612 7.11612L3.05546 6.05546C2.62539 6.48553 2.43549 7.01537 2.34468 7.60318C2.25725 8.16904 2.25091 8.86992 2.2501 9.69876L3.75009 9.70023ZM20.8122 13.2361C20.2112 13.146 19.75 12.6262 19.75 12H18.25C18.25 13.3798 19.2654 14.521 20.5899 14.7195L20.8122 13.2361ZM20.5899 9.28048C19.2654 9.47899 18.25 10.6202 18.25 12H19.75C19.75 11.3738 20.2112 10.854 20.8122 10.7639L20.5899 9.28048ZM3.41013 14.7195C4.7346 14.521 5.75 13.3798 5.75 12H4.25C4.25 12.6262 3.78884 13.146 3.18779 13.2361L3.41013 14.7195ZM3.18779 10.7639C3.78884 10.854 4.25 11.3738 4.25 12H5.75C5.75 10.6202 4.7346 9.47899 3.41013 9.28048L3.18779 10.7639ZM2.2501 9.69876C2.24951 10.3015 2.72518 10.6946 3.18779 10.7639L3.41013 9.28048C3.54502 9.3007 3.75036 9.42889 3.75009 9.70023L2.2501 9.69876ZM3.75009 14.2998C3.75036 14.5711 3.54502 14.6993 3.41013 14.7195L3.18778 13.2361C2.72518 13.3054 2.24951 13.6985 2.2501 14.3012L3.75009 14.2998ZM21.7499 14.3012C21.7505 13.6985 21.2748 13.3054 20.8122 13.2361L20.5899 14.7195C20.455 14.6993 20.2496 14.5711 20.2499 14.2998L21.7499 14.3012ZM20.2499 9.70023C20.2496 9.42889 20.455 9.3007 20.5899 9.28048L20.8122 10.7639C21.2748 10.6946 21.7505 10.3015 21.7499 9.69876L20.2499 9.70023Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M8 18V6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="square" />
            </svg>
        )
    },
    "ticket-simple": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","promotion","reward","sale","event","admission","receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21 10V10C21 8.11438 21 7.17157 20.4142 6.58579C19.8284 6 18.8856 6 17 6H7C5.11438 6 4.17157 6 3.58579 6.58579C3 7.17157 3 8.11438 3 10V10M21 14V14C21 15.8856 21 16.8284 20.4142 17.4142C19.8284 18 18.8856 18 17 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3 16.8284 3 15.8856 3 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 18V6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    Ticket: {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","coupon","discount","voucher","promotion","reward","sale","event","admission","receipt"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10V10C3 8.13077 3 7.19615 3.40192 6.5C3.66523 6.04394 4.04394 5.66523 4.5 5.40192C5.19615 5 6.13077 5 8 5H16C17.8692 5 18.8038 5 19.5 5.40192C19.9561 5.66523 20.3348 6.04394 20.5981 6.5C21 7.19615 21 8.13077 21 10V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21 14V14C21 15.8692 21 16.8038 20.5981 17.5C20.3348 17.9561 19.9561 18.3348 19.5 18.5981C18.8038 19 17.8692 19 16 19L8 19C6.13077 19 5.19615 19 4.5 18.5981C4.04394 18.3348 3.66523 17.9561 3.40192 17.5C3 16.8038 3 15.8692 3 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.4142 8.58579C16 9.17157 16 10.1144 16 12C16 13.8856 16 14.8284 15.4142 15.4142C14.8284 16 13.8856 16 12 16C10.1144 16 9.17157 16 8.58579 15.4142C8 14.8284 8 13.8856 8 12C8 10.1144 8 9.17157 8.58579 8.58579C9.17157 8 10.1144 8 12 8C13.8856 8 14.8284 8 15.4142 8.58579Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "ticket-simple-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ticket","receipt","coupon","discount","voucher","purchase","transaction","order","sale","payment","invoice","refund","credit","gift certificate","reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 9.93417L2 10C2 10.5523 2.44772 11 3 11C3.55229 11 4 11.4477 4 12C4 12.5523 3.55229 13 3 13C2.44772 13 2 13.4477 2 14L2 14.0658C1.99995 14.9523 1.99991 15.7161 2.08215 16.3278C2.17028 16.9833 2.36902 17.6117 2.87868 18.1213C3.38835 18.631 4.0167 18.8297 4.67221 18.9179C5.28387 19.0001 6.11352 19.0001 7 19L7 5C6.11351 4.99995 5.28387 4.99991 4.67221 5.08215C4.0167 5.17028 3.38835 5.36902 2.87868 5.87868C2.36902 6.38835 2.17028 7.0167 2.08215 7.67221C1.99991 8.28387 1.99995 9.04769 2 9.93417Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.3278 5.08215C18.7161 4.99991 17.9523 4.99995 17.0658 5L9 5V19H17.0658C17.9523 19.0001 18.7161 19.0001 19.3278 18.9179C19.9833 18.8297 20.6117 18.631 21.1213 18.1213C21.631 17.6117 21.8297 16.9833 21.9179 16.3278C22.0001 15.7161 22.0001 14.9523 22 14.0658L22 14C22 13.4477 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 10.5523 22 10L22 9.9342C22.0001 9.0477 22.0001 8.28388 21.9179 7.67221C21.8297 7.0167 21.631 6.38835 21.1213 5.87868C20.6117 5.36902 19.9833 5.17028 19.3278 5.08215Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tiktok-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["social-media","trending","popular","marketing","promotion","tiktok","engage","video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 9C15.9 9 15 8.1 15 7V5C15 4.45 14.55 4 14 4C13.45 4 13 4.45 13 5V15.5C13 16.88 11.88 18 10.5 18C9.12 18 8 16.88 8 15.5C8 14.12 9.12 13 10.5 13C11.05 13 11.5 12.55 11.5 12C11.5 11.45 11.05 11 10.5 11C8.01 11 6 13.01 6 15.5C6 17.99 8.01 20 10.5 20C12.67 20 14.48 18.47 14.9 16.43C14.96 16.3 15 16.16 15 16V10.46C15.59 10.8 16.27 11 17 11C17.55 11 18 10.55 18 10C18 9.45 17.55 9 17 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tiktok-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tiktok","social-media","trend","trending","video","promotion","marketing","social"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5V7C14 8.65685 15.3431 10 17 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 12C8.567 12 7 13.567 7 15.5C7 17.433 8.567 19 10.5 19C12.433 19 14 17.433 14 15.5M14 5L14 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tiktok-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tiktok","social-media","marketing","trend","viral","promotion","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5V7C14 8.65685 15.3431 10 17 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 12C8.567 12 7 13.567 7 15.5C7 17.433 8.567 19 10.5 19C12.433 19 14 17.433 14 15.5M14 5L14 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Time-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","late","delay","schedule","reminder","appointment","service-time","order-time","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM10.8322 8.44541C10.5258 7.98588 9.90493 7.8617 9.44541 8.16806C8.98588 8.47441 8.8617 9.09528 9.16806 9.55481L11.1681 12.5548C11.4744 13.0143 12.0953 13.1385 12.5548 12.8322L15.5548 10.8322C16.0143 10.5258 16.1385 9.90493 15.8322 9.44541C15.5258 8.98588 14.9049 8.8617 14.4454 9.16806L12.2775 10.6134L10.8322 8.44541Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Tiktok: {
        defaultColors: ["#3D4C66"],
        keywords: ["clock","time","late","delay","schedule","reminder","appointment","service-time","order-time","wait-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5V7C14 8.65685 15.3431 10 17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 12C8.567 12 7 13.567 7 15.5C7 17.433 8.567 19 10.5 19C12.433 19 14 17.433 14 15.5M14 5L14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Time-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["time","clock","schedule","appointment","timer","late","delay","pending","duration","time-left","elapsed-time","wait-time","hours","minutes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9L12 12L15 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Time-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["time","clock","schedule","appointment","duration","late","delay","timing","hours","minutes","wait-time","service-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 9L12 12L15 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Time-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["clock","time","schedule","late","delay","appointment","timer","duration","waiting","service-time","processing-time","order-time","transaction-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13L11 13L11 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Time-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["time","clock","schedule","appointment","duration","late","history","reminder","wait-time","elapsed-time"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13L11 13L11 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Time-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["time","clock","duration","schedule","appointment","timer","delay","late","history","transaction-history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.2089 19.1035 16.2102 17.6569 17.6569C16.2102 19.1035 14.2089 20 12 20C7.58172 20 4 16.4183 4 12ZM14 14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H12V10C12 9.44772 11.5523 9 11 9C10.4477 9 10 9.44772 10 10V13C10 13.2652 10.1054 13.5196 10.2929 13.7071C10.4804 13.8946 10.7348 14 11 14H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Time-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["time","clock","schedule","delay","wait","history","late","appointment","reminder","timer","duration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 13L11 13L11 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["toggle","switch","off","disable","setting","configuration","permission","deactivate","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    Time: {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","off","disable","setting","configuration","permission","deactivate","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 9L12 12L15 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "toggle-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["toggle","switch","off","disable","inactive","setting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","off","switch","disable","deactivate","hide","inactive"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 12C22 15.3137 19.3137 18 16 18L8 18C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6L16 6C19.3137 6 22 8.68629 22 12ZM12 12C12 14.2091 10.2091 16 8 16C5.79086 16 4 14.2091 4 12C4 9.79086 5.79086 8 8 8C10.2091 8 12 9.79086 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "toggle-on-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["toggle","switch","on","enable","active","feature","setting","availability","status","preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","off","disable","inactive","setting","option","control"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-on-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["toggle","switch","on","enabled","active","status","setting","preference"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-on-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","on","enable","active","settings","feature","mode"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12ZM12 12C12 9.79086 13.7909 8 16 8C18.2091 8 20 9.79086 20 12C20 14.2091 18.2091 16 16 16C13.7909 16 12 14.2091 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tornado-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["process","sync","data","connection","loading","transfer","refresh","update","pending","swirl","spiral","loop"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 17 20 13C20 9.68629 17.3137 7 14 7C10.6863 7 8 9.68629 8 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "toggle-on": {
        defaultColors: ["#3D4C66"],
        keywords: ["toggle","switch","on","enable","active","payment-method","setting","option"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tornado-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","sync","process","update","refresh","spin","rotate","cycle","buffering"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C16.0089 19 19 16.3149 19 13C19 10.2386 16.7614 8 14 8C13.6575 8 13.3231 8.03443 13 8.10002C15.2822 8.56329 17 10.581 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13C7 9.13401 10.134 6 14 6C17.866 6 21 9.13401 21 13C21 17.6851 16.8277 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5ZM9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    tornado: {
        defaultColors: ["#3D4C66"],
        keywords: ["loading","sync","process","update","refresh","spin","rotate","cycle","buffering"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 17 20 13C20 9.68629 17.3137 7 14 7C10.6863 7 8 9.68629 8 13M8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tornado-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["loading","waiting","processing","busy","syncing","rotating","motion","activity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 17 20 13C20 9.68629 17.3137 7 14 7C10.6863 7 8 9.68629 8 13M8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13Z"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "trademark-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trademark","TM","legal","brand","protected","intellectual property"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 8V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8V16" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8V16" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8L16 12L19 8"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "trademark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trademark","brand","protected","registered","intellectual property","legal","rights","ownership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1838 7.05138C13.5921 6.91527 14.0417 7.05572 14.3 7.40006L16.5 10.3334L18.7 7.40006C18.9583 7.05572 19.4079 6.91527 19.8162 7.05138C20.2246 7.1875 20.5 7.56963 20.5 8.00006V16.0001C20.5 16.5524 20.0523 17.0001 19.5 17.0001C18.9477 17.0001 18.5 16.5524 18.5 16.0001V11.0001L17.3 12.6001C17.1111 12.8519 16.8148 13.0001 16.5 13.0001C16.1852 13.0001 15.8889 12.8519 15.7 12.6001L14.5 11.0001V16.0001C14.5 16.5524 14.0523 17.0001 13.5 17.0001C12.9477 17.0001 12.5 16.5524 12.5 16.0001V8.00006C12.5 7.56963 12.7754 7.1875 13.1838 7.05138ZM3.5 8.00006C3.5 7.44778 3.94772 7.00006 4.5 7.00006H10.5C11.0523 7.00006 11.5 7.44778 11.5 8.00006C11.5 8.55235 11.0523 9.00006 10.5 9.00006H8.5V16.0001C8.5 16.5524 8.05228 17.0001 7.5 17.0001C6.94772 17.0001 6.5 16.5524 6.5 16.0001V9.00006H4.5C3.94772 9.00006 3.5 8.55235 3.5 8.00006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "trademark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trademark","legal","intellectual property","brand","rights","protection","registration","compliance","policy","terms","conditions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 8V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8V16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8V16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8L16 12L19 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    trademark: {
        defaultColors: ["#3D4C66"],
        keywords: ["trademark","legal","intellectual property","brand","rights","protection","registration","compliance","policy","terms","conditions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 8V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 8V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 8H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 8V16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 8L16 12L19 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Traffic Cone-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cone","traffic","unavailable","limited","restricted","out-of-stock","error","warning","block","obstacle","maintenance","under-construction","caution","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 14L16 14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9 9L15 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M18 19L14.2072 5.72527C14.0845 5.29597 13.6921 5 13.2456 5L10.7542 5C10.3078 5 9.91537 5.29598 9.79271 5.72528L6 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Traffic Cone-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["traffic-cone","cone","construction","under-construction","warning","alert","block","unavailable","item-unavailable","out-of-stock","maintenance","safety"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.2072 5.72527L18 19L6 19L9.79271 5.72528C9.91537 5.29598 10.3078 5 10.7542 5H13.2456C13.6921 5 14.0845 5.29597 14.2072 5.72527Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M18 19L14.2072 5.72527C14.0845 5.29597 13.6921 5 13.2456 5L10.7542 5C10.3078 5 9.91537 5.29598 9.79271 5.72528L6 19M4 19H20"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14L16 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 9L15 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Traffic Cone": {
        defaultColors: ["#3D4C66"],
        keywords: ["traffic-cone","cone","warning","alert","caution","unavailable","restricted","out-of-service","error","issue","block","blockade"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 14L16 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9 9L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M18 19L14.2072 5.72527C14.0845 5.29597 13.6921 5 13.2456 5L10.7542 5C10.3078 5 9.91537 5.29598 9.79271 5.72528L6 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 19H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "train-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["train","transportation","delivery","shipment","route","travel","railway","transport"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L8 19M7 21L8 19M15 17L16 19M17 21L16 19M8 19H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 3H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7V13C5 14.8856 5 15.8284 5.58579 16.4142C6.17157 17 7.11438 17 9 17H15C16.8856 17 17.8284 17 18.4142 16.4142C19 15.8284 19 14.8856 19 13V7C19 5.11438 19 4.17157 18.4142 3.58579C17.8284 3 16.8856 3 15 3Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9H11.9998M11.9998 3V9M11.9998 9H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H8M14 14H16"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Traffic Cone-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cone","traffic","restriction","unavailable","disabled","maintenance","error","warning","unavailable-item","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7542 4C9.86127 4 9.0765 4.59196 8.83118 5.45057L8.10279 8L15.8971 8L15.1687 5.45055C14.9234 4.59195 14.1386 4 13.2456 4H10.7542Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M16.4685 10L7.53137 10L6.67424 13H17.3257L16.4685 10Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M5.2457 18L6.10282 15H17.8971L18.7543 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44771 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18L5.2457 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    train: {
        defaultColors: ["#3D4C66"],
        keywords: ["cone","traffic","restriction","unavailable","disabled","maintenance","error","warning","unavailable-item","out-of-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 3H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7V13C5 14.8856 5 15.8284 5.58579 16.4142C6.17157 17 7.11438 17 9 17H15C16.8856 17 17.8284 17 18.4142 16.4142C19 15.8284 19 14.8856 19 13V7C19 5.11438 19 4.17157 18.4142 3.58579C17.8284 3 16.8856 3 15 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 9H11.9998M11.9998 3V9M11.9998 9H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H8M14 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17L8 19M7 21L8 19M15 17L16 19M17 21L16 19M8 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "train-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["train","delivery","transport","travel","shipping","cargo","railway"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.052 2.25H8.94801C8.04957 2.24997 7.30029 2.24995 6.70553 2.32992C6.07773 2.41432 5.51093 2.59999 5.05546 3.05546C4.59999 3.51093 4.41432 4.07773 4.32992 4.70553C4.24995 5.30029 4.24997 6.04947 4.25 6.94791V13.052C4.24997 13.9504 4.24995 14.6997 4.32992 15.2945C4.41432 15.9223 4.59999 16.4891 5.05546 16.9445C5.51093 17.4 6.07773 17.5857 6.70553 17.6701C7.02332 17.7128 7.3852 17.7327 7.79038 17.742L6.3291 20.6645C6.14386 21.035 6.29403 21.4855 6.66451 21.6707C7.035 21.856 7.4855 21.7058 7.67074 21.3353L8.46345 19.7499H15.5364L16.3291 21.3353C16.5143 21.7058 16.9648 21.856 17.3353 21.6707C17.7058 21.4855 17.856 21.035 17.6707 20.6645L16.2095 17.742C16.6147 17.7327 16.9766 17.7128 17.2945 17.6701C17.9223 17.5857 18.4891 17.4 18.9445 16.9445C19.4 16.4891 19.5857 15.9223 19.6701 15.2945C19.7501 14.6997 19.75 13.9505 19.75 13.052V6.94801C19.75 6.04954 19.7501 5.3003 19.6701 4.70553C19.5857 4.07773 19.4 3.51093 18.9445 3.05546C18.4891 2.59999 17.9223 2.41432 17.2945 2.32992C16.6997 2.24995 15.9504 2.24997 15.052 2.25ZM9.46341 17.75H14.5364L14.7864 18.2499H9.21345L9.46341 17.75ZM7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H10C10.4142 13.25 10.75 13.5858 10.75 14C10.75 14.4142 10.4142 14.75 10 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14ZM13.25 14C13.25 13.5858 13.5858 13.25 14 13.25H16C16.4142 13.25 16.75 13.5858 16.75 14C16.75 14.4142 16.4142 14.75 16 14.75H14C13.5858 14.75 13.25 14.4142 13.25 14ZM7.98171 3.75H9.01829C9.47416 3.74999 9.8416 3.74999 10.1306 3.78884C10.4306 3.82918 10.6832 3.91548 10.8839 4.11612C11.0845 4.31676 11.1708 4.56938 11.2112 4.86942C11.25 5.15841 11.25 5.52585 11.25 5.98172V6.01829C11.25 6.47415 11.25 6.84159 11.2112 7.13059C11.1708 7.43062 11.0845 7.68325 10.8839 7.88388C10.6832 8.08452 10.4306 8.17082 10.1306 8.21116C9.84159 8.25001 9.47415 8.25001 9.01829 8.25H7.98172C7.52585 8.25001 7.15841 8.25001 6.86942 8.21116C6.56938 8.17082 6.31676 8.08452 6.11612 7.88389C5.91548 7.68325 5.82918 7.43062 5.78884 7.13059C5.74999 6.8416 5.74999 6.47416 5.75 6.0183V5.98171C5.74999 5.52585 5.74999 5.1584 5.78884 4.86942C5.82918 4.56938 5.91548 4.31676 6.11612 4.11612C6.31676 3.91548 6.56938 3.82918 6.86942 3.78884C7.15841 3.74999 7.52585 3.74999 7.98171 3.75ZM14.9817 3.75H16.0183C16.4742 3.74999 16.8416 3.74999 17.1306 3.78884C17.4306 3.82918 17.6832 3.91548 17.8839 4.11612C18.0845 4.31676 18.1708 4.56938 18.2112 4.86942C18.25 5.1584 18.25 5.52583 18.25 5.98168V6.0183C18.25 6.47415 18.25 6.8416 18.2112 7.13059C18.1708 7.43062 18.0845 7.68325 17.8839 7.88388C17.6832 8.08452 17.4306 8.17082 17.1306 8.21116C16.8416 8.25001 16.4742 8.25001 16.0183 8.25H14.9817C14.5258 8.25001 14.1584 8.25001 13.8694 8.21116C13.5694 8.17082 13.3168 8.08452 13.1161 7.88388C12.9155 7.68325 12.8292 7.43062 12.7888 7.13059C12.75 6.84159 12.75 6.47415 12.75 6.01829V5.98172C12.75 5.52585 12.75 5.15841 12.7888 4.86942C12.8292 4.56938 12.9155 4.31676 13.1161 4.11612C13.3168 3.91548 13.5694 3.82918 13.8694 3.78884C14.1584 3.74999 14.5258 3.74999 14.9817 3.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "translate-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["translate","language","localization","internationalization","currency","payment","foreign","text","font","character","multilingual","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 11C10.5 12 11.5 13.5 14.0001 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9C13.8351 10.68 10.5448 14.6712 9 16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "train-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["train","transportation","delivery","shipping","travel","railway","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 17L8 19M7 21L8 19M15 17L16 19M17 21L16 19M8 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 3H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7V13C5 14.8856 5 15.8284 5.58579 16.4142C6.17157 17 7.11438 17 9 17H15C16.8856 17 17.8284 17 18.4142 16.4142C19 15.8284 19 14.8856 19 13V7C19 5.11438 19 4.17157 18.4142 3.58579C17.8284 3 16.8856 3 15 3Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 4H8C7.05719 4 6.58579 4 6.29289 4.29289C6 4.58579 6 5.05719 6 6C6 6.94281 6 7.41421 6.29289 7.70711C6.58579 8 7.05719 8 8 8H9C9.94281 8 10.4142 8 10.7071 7.70711C11 7.41421 11 6.94281 11 6C11 5.05719 11 4.58579 10.7071 4.29289C10.4142 4 9.94281 4 9 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 4H15C14.0572 4 13.5858 4 13.2929 4.29289C13 4.58579 13 5.05719 13 6C13 6.94281 13 7.41421 13.2929 7.70711C13.5858 8 14.0572 8 15 8H16C16.9428 8 17.4142 8 17.7071 7.70711C18 7.41421 18 6.94281 18 6C18 5.05719 18 4.58579 17.7071 4.29289C17.4142 4 16.9428 4 16 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 14H8M14 14H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "translate-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["translate","language","localization","international","multilingual","foreign"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM12 7C12.5523 7 13 7.44772 13 8H16C16.5523 8 17 8.44772 17 9C17 9.55229 16.5523 10 16 10H15.5147C14.872 10.8791 13.9009 12.1005 12.9062 13.2773L12.8632 13.3281C13.3556 13.8961 13.9605 14.5464 14.7071 15.2931C15.0977 15.6836 15.0977 16.3167 14.7072 16.7073C14.3166 17.0978 13.6835 17.0978 13.293 16.7073C12.6071 16.0215 12.0278 15.4053 11.5363 14.8489C10.831 15.6298 10.1643 16.3176 9.65216 16.7582C9.23347 17.1184 8.60208 17.0709 8.24192 16.6522C7.88175 16.2335 7.92919 15.6022 8.34788 15.242C8.82288 14.8334 9.50559 14.1222 10.2561 13.2809C9.71332 12.5488 9.35812 11.9526 9.10555 11.4474C8.85856 10.9535 9.05878 10.3528 9.55276 10.1058C9.69623 10.0341 9.8487 10 9.99889 10C10.3656 10.0001 10.7192 10.2027 10.8944 10.553C11.0506 10.8654 11.2695 11.2479 11.5997 11.7236C12.0971 11.1297 12.5769 10.5383 13.0003 10H9.99889H8C7.44772 10 7 9.55229 7 9C7 8.44772 7.44772 8 8 8H11C11 7.44772 11.4477 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "translate-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["translate","language","international","localization","multilingual","text","character","customer-language","change-language","foreign-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 11C10.5 12 11.5 13.5 14.0001 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9C13.8351 10.68 10.5448 14.6712 9 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "translate-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["translate","language","locale","internationalization","localization","multilingual","currency","region","settings","user-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8C6.50012 9.5 7.50012 11.5 10.0001 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C10 8 7.5 11.5 5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 6H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L16 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H16H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "translate-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["translate","language","localization","international","foreign","currency","switch-language","customer-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5.97694C5.87958 7.00228 5.78091 7.01893 5.6837 7.05134C5.15977 7.22603 4.87665 7.79237 5.05134 8.3163C5.29647 9.0515 5.65528 9.90444 6.22411 10.7712C5.64671 11.3251 5.0583 11.7988 4.4855 12.1425C4.01192 12.4267 3.85836 13.0409 4.14251 13.5145C4.42666 13.9881 5.04092 14.1416 5.5145 13.8575C6.19551 13.4489 6.86265 12.9174 7.49453 12.3229C8.04067 12.8632 8.69599 13.3837 9.48557 13.8575C9.95915 14.1416 10.5734 13.988 10.8576 13.5145C11.1417 13.0409 10.9881 12.4266 10.5146 12.1425C9.85917 11.7492 9.32018 11.3193 8.8743 10.8739C9.03371 10.6891 9.18902 10.5029 9.33975 10.3167C10.2615 9.17805 11.0536 7.9872 11.602 7H12C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5H11.0217C11.0077 4.99971 10.9938 4.99971 10.9799 5H9ZM6.02334 7C6.43314 7.00959 6.81155 7.27246 6.94866 7.6837C7.10897 8.16451 7.32349 8.69701 7.63338 9.24382C7.68431 9.18231 7.73494 9.12045 7.78526 9.0583C8.34799 8.36316 8.85333 7.65277 9.2713 7H6.02334Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 10C16.3788 10 16.725 10.214 16.8944 10.5528L20.8944 18.5528C21.1414 19.0468 20.9412 19.6474 20.4472 19.8944C19.9532 20.1414 19.3526 19.9412 19.1056 19.4472L17.882 17H14.118L12.8944 19.4472C12.6474 19.9412 12.0468 20.1414 11.5528 19.8944C11.0588 19.6474 10.8586 19.0468 11.1056 18.5528L15.1056 10.5528C15.275 10.214 15.6212 10 16 10ZM15.118 15H16.882L16 13.2361L15.118 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "translate-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["translate","language","localization","internationalization","multilingual","foreign","change-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8C6.50012 9.5 7.50012 11.5 10.0001 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C10 8 7.5 11.5 5 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 6H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L16 11L12 19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H16H14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    translate: {
        defaultColors: ["#3D4C66"],
        keywords: ["translate","language","localization","internationalization","multilingual","foreign","change-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 11C10.5 12 11.5 13.5 14.0001 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9C13.8351 10.68 10.5448 14.6712 9 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 9V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "translate-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["translate","language","international","localization","multilingual","foreign","customer-language","menu-language"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8C6.50012 9.5 7.50012 11.5 10.0001 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 6C10 8 7.5 11.5 5 13"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 6H12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 6V5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 19L16 11L12 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H16H14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 10-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","cancel","discard","void","clear","refund","item-removal","order-cancellation","transaction-void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Trash 10-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","trash-can","bin","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 11-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","discard","cancel","clear","void","refund","rollback","trash-order","delete-order","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 10-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","garbage","cancel","void","item-removal","order-cancellation","discount-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.62 6.00392L15.4305 5.62485C15.3106 5.38506 15.1894 5.14248 15.0637 4.94493C14.9197 4.71862 14.7277 4.48061 14.4334 4.29871C14.1391 4.11681 13.8404 4.05157 13.5736 4.02398C13.3407 3.9999 13.0695 3.99995 12.8014 4L11.1986 4.00001C10.9305 3.99995 10.6593 3.9999 10.4264 4.02398C10.1596 4.05157 9.86089 4.11681 9.56657 4.29871C9.27225 4.48061 9.08031 4.71862 8.93631 4.94493C8.81061 5.14248 8.68938 5.38505 8.56954 5.62485L8.38001 6.00392H5C4.44772 6.00392 4 6.45163 4 7.00392C4 7.5562 4.44772 8.00392 5 8.00392H5.07989L5.70289 15.4774C5.77097 16.2946 5.82991 17.0021 5.95172 17.5673C6.08266 18.1747 6.311 18.7493 6.80892 19.2075C7.30683 19.6656 7.89842 19.8454 8.51465 19.9254C9.08794 19.9999 9.79797 19.9998 10.618 19.9998H13.382C14.202 19.9998 14.9121 19.9999 15.4854 19.9254C16.1016 19.8454 16.6932 19.6656 17.1911 19.2075C17.689 18.7493 17.9173 18.1747 18.0483 17.5673C18.1701 17.0021 18.229 16.2946 18.2971 15.4774L18.9201 8.00392H19C19.5523 8.00392 20 7.5562 20 7.00392C20 6.45163 19.5523 6.00392 19 6.00392H15.62Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 11-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","cancel","void","discard","refund","item","order","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.75 7C6.75 6.58579 6.41421 6.25 6 6.25C5.58579 6.25 5.25 6.58579 5.25 7H6.75ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25C17.5858 6.25 17.25 6.58579 17.25 7H18.75ZM6.58579 18.4142L7.11612 17.8839L7.11612 17.8839L6.58579 18.4142ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM6.75 15V7.00391H5.25V15H6.75ZM6.75 7.00391V7H5.25V7.00391H6.75ZM18.75 15V7.00391H17.25V15H18.75ZM18.75 7.00391V7H17.25V7.00391H18.75ZM14 18.25H10V19.75H14V18.25ZM17.25 15C17.25 15.964 17.2484 16.6116 17.1835 17.0946C17.1214 17.5561 17.0142 17.7536 16.8839 17.8839L17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7516 16.6883 18.75 15.9216 18.75 15H17.25ZM14 19.75C14.9216 19.75 15.6883 19.7516 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445L16.8839 17.8839C16.7536 18.0142 16.5561 18.1214 16.0946 18.1835C15.6116 18.2484 14.964 18.25 14 18.25V19.75ZM5.25 15C5.25 15.9216 5.24841 16.6883 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445L7.11612 17.8839C6.9858 17.7536 6.87858 17.5561 6.81654 17.0946C6.75159 16.6116 6.75 15.964 6.75 15H5.25ZM10 18.25C9.03599 18.25 8.38843 18.2484 7.90539 18.1835C7.44393 18.1214 7.24643 18.0142 7.11612 17.8839L6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.31174 19.7516 9.07839 19.75 10 19.75V18.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M10 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 11": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","clear","trash-can","delete-item","remove-item","cancel-item","void-item","clear-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 11-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","clear","void","refund","erase","bin","recycle-bin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.089 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00392H17.911C17.9403 6.00133 17.97 6.00001 18 6.00001C18.03 6.00001 18.0597 6.00133 18.089 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392L19 15.0658C19.0001 15.9523 19.0001 16.7161 18.9179 17.3278C18.8297 17.9833 18.631 18.6117 18.1213 19.1213C17.6117 19.631 16.9833 19.8297 16.3278 19.9179C15.7161 20.0001 14.9523 20.0001 14.0658 20H9.93417C9.04768 20.0001 8.28387 20.0001 7.67221 19.9179C7.01669 19.8297 6.38834 19.631 5.87868 19.1213C5.36902 18.6117 5.17027 17.9833 5.08214 17.3278C4.9999 16.7161 4.99995 15.9523 5 15.0658L5 8.00392C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392H5.911C5.94032 6.00133 5.97001 6.00001 6 6.00001C6.02999 6.00001 6.05968 6.00133 6.089 6.00392ZM11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V11ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 10": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 12-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","erase","clear","garbage","recycle","refund","void-transaction","delete-item","remove-item","cancel-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 12-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin","basket","recycle","trash-can","garbage","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392ZM13.9715 6.53167L13.9838 6.56589C13.9803 6.55424 13.9762 6.54281 13.9715 6.53167ZM13.2625 5.61948C13.4236 5.73896 13.9838 6.56589 13.9838 6.56589C13.9945 6.60122 14 6.63861 14 6.67639C14 6.85512 13.8793 7 13.7303 7L10.2697 7C10.1207 7 10 6.85512 10 6.67639C10 6.62615 10.0097 6.57661 10.0285 6.53167C10.0285 6.53167 10.5578 5.73896 10.7189 5.61948C10.88 5.5 11.0805 5.5 11.4814 5.5L12.5 5.5C12.9009 5.5 13.1014 5.5 13.2625 5.61948ZM10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12V14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14V12ZM12 11C12.5523 11 13 11.4477 13 12V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V12C11 11.4477 11.4477 11 12 11ZM16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 12-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","discard","clear","cancel","void","recycle","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M10 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 12": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","clear","cancel","void","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 13-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","discard","cancel","clear","void","trash-can","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7V6.6C8 6.03995 8 5.75992 8.10899 5.54601C8.20487 5.35785 8.35785 5.20487 8.54601 5.10899C8.75992 5 9.03995 5 9.6 5H12H14.4C14.9601 5 15.2401 5 15.454 5.10899C15.6422 5.20487 15.7951 5.35785 15.891 5.54601C16 5.75992 16 6.03995 16 6.6V7C16 7.27614 15.7761 7.5 15.5 7.5H8.5C8.22386 7.5 8 7.27614 8 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 13.9987V11.9995M12 13.9987V11.9995M14 13.9987V11.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 13-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","cancel","discard","void","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6.75548 16.0657C6.84174 17.1008 6.88486 17.6184 7.11408 18.0101C7.31593 18.355 7.6165 18.6316 7.97701 18.8041C8.38641 19 8.90575 19 9.94443 19H14.0556C15.0943 19 15.6136 19 16.023 18.8041C16.3835 18.6316 16.6841 18.355 16.8859 18.0101C17.1151 17.6184 17.1583 17.1008 17.2445 16.0658L18 7.00049"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.9987V11.9995M12 13.9987V11.9995M14 13.9987V11.9995"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7H19M19 7C18.5444 7.0001 19.4556 6.9999 19 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7V6.6C8 6.03995 8 5.75992 8.10899 5.54601C8.20487 5.35785 8.35785 5.20487 8.54601 5.10899C8.75992 5 9.03995 5 9.6 5H12H14.4C14.9601 5 15.2401 5 15.454 5.10899C15.6422 5.20487 15.7951 5.35785 15.891 5.54601C16 5.75992 16 6.03995 16 6.6V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 13": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","garbage","refund","erase","clear","item-removal","transaction-void","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6.75548 16.0657C6.84174 17.1008 6.88486 17.6184 7.11408 18.0101C7.31593 18.355 7.6165 18.6316 7.97701 18.8041C8.38641 19 8.90575 19 9.94443 19H14.0556C15.0943 19 15.6136 19 16.023 18.8041C16.3835 18.6316 16.6841 18.355 16.8859 18.0101C17.1151 17.6184 17.1583 17.1008 17.2445 16.0658L18 7.00049"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.9987V11.9995M12 13.9987V11.9995M14 13.9987V11.9995"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 7H19M19 7C18.5444 7.0001 19.4556 6.9999 19 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 7V6.6C8 6.03995 8 5.75992 8.10899 5.54601C8.20487 5.35785 8.35785 5.20487 8.54601 5.10899C8.75992 5 9.03995 5 9.6 5H12H14.4C14.9601 5 15.2401 5 15.454 5.10899C15.6422 5.20487 15.7951 5.35785 15.891 5.54601C16 5.75992 16 6.03995 16 6.6V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 14-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin","recycle","garbage","erase","empty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash 13-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","empty","bin","recycle","clear","order-cancel","item-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.86178 4.01695C9.06993 3.99994 9.31573 3.99997 9.56811 4L14.4319 4C14.6843 3.99997 14.9301 3.99994 15.1382 4.01695C15.3668 4.03563 15.6366 4.07969 15.908 4.21799C16.2843 4.40974 16.5903 4.7157 16.782 5.09202C16.9203 5.36345 16.9644 5.63318 16.9831 5.86178C16.9868 5.90745 16.9897 5.95494 16.992 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18.9201L18.2971 15.4774C18.229 16.2945 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2074C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79798 19.9998 9.08795 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2074C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H7.00804C7.01031 5.95494 7.01322 5.90745 7.01695 5.86178C7.03563 5.63318 7.07969 5.36345 7.21799 5.09202C7.40974 4.7157 7.7157 4.40974 8.09202 4.21799C8.36345 4.07969 8.63318 4.03563 8.86178 4.01695ZM10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12V14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14V12ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V12ZM16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 14": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","garbage","cancel","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash 15-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","discard","void","clear","garbage","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 14-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","bin","erase","void","refund","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash 15-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","void","delete-item","remove-item","cancel-order","discard-transaction","void-transaction","clear","empty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "Trash 15-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","clear","void","cancel-order","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.38001 6.00392H5C4.44772 6.00392 4 6.45163 4 7.00392C4 7.5562 4.44772 8.00392 5 8.00392H5.07989L5.70289 15.4774C5.77097 16.2946 5.82991 17.0021 5.95172 17.5673C6.08266 18.1747 6.311 18.7493 6.80892 19.2075C7.30683 19.6656 7.89842 19.8454 8.51465 19.9254C9.08794 19.9999 9.79797 19.9998 10.618 19.9998H13.382C14.202 19.9998 14.9121 19.9999 15.4854 19.9254C16.1016 19.8454 16.6932 19.6656 17.1911 19.2075C17.689 18.7493 17.9173 18.1747 18.0483 17.5673C18.1701 17.0021 18.229 16.2946 18.2971 15.4774L18.9201 8.00392H19C19.5523 8.00392 20 7.5562 20 7.00392C20 6.45163 19.5523 6.00392 19 6.00392H15.62L15.4305 5.62485C15.3106 5.38506 15.1894 5.14248 15.0637 4.94493C14.9197 4.71862 14.7277 4.48061 14.4334 4.29871C14.1391 4.11681 13.8404 4.05157 13.5736 4.02398C13.3407 3.9999 13.0695 3.99995 12.8014 4L11.1986 4.00001C10.9305 3.99995 10.6593 3.9999 10.4264 4.02398C10.1596 4.05157 9.86089 4.11681 9.56657 4.29871C9.27225 4.48061 9.08031 4.71862 8.93631 4.94493C8.81061 5.14248 8.68938 5.38505 8.56954 5.62485L8.38001 6.00392Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 16-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","delete","remove","bin","cancel","void","clear","discard","erase","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722L8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16 11L17 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 15L8 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 15": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","waste","empty","clear","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 14-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","refund","item","order","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.001 3C9.44875 2.99943 9.00057 3.44668 9 3.99897C8.99943 4.55125 9.44668 4.99943 9.99897 5L13.999 5.00414C14.5513 5.00471 14.9994 4.55746 15 4.00517C15.0006 3.45289 14.5533 3.00471 14.001 3.00414L10.001 3ZM4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18.9201L18.2971 15.4774C18.229 16.2945 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2074C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.2021 19.9998 13.3821 19.9998H13.382H13.382H13.382H10.618H10.618H10.618H10.6179C9.79794 19.9998 9.08793 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2074C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391ZM10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 16-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","clear","void","refund","item-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.3214 6.00392H5C4.44772 6.00392 4 6.45163 4 7.00392C4 7.5562 4.44772 8.00392 5 8.00392H5.07989L5.57974 14L8 14C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16H5.74723C5.79992 16.5987 5.85669 17.1264 5.95172 17.5673C6.08266 18.1747 6.311 18.7493 6.80892 19.2075C7.30683 19.6656 7.89842 19.8454 8.51465 19.9254C9.08795 19.9999 9.79798 19.9998 10.618 19.9998H13.382C14.202 19.9998 14.9121 19.9999 15.4854 19.9254C16.1016 19.8454 16.6932 19.6656 17.1911 19.2075C17.689 18.7493 17.9173 18.1747 18.0483 17.5673C18.1701 17.0021 18.229 16.2946 18.2971 15.4774L18.587 12H16C15.4477 12 15 11.5523 15 11C15 10.4477 15.4477 10 16 10H18.7537L18.9201 8.00392H19C19.5523 8.00392 20 7.5562 20 7.00392C20 6.45163 19.5523 6.00392 19 6.00392H16.6786L16.6163 5.84828C16.5077 5.57652 16.3984 5.30322 16.2795 5.08019C16.1435 4.82509 15.9542 4.55375 15.6442 4.34388C15.3342 4.134 15.012 4.05904 14.7246 4.02748C14.4734 3.99989 14.1791 3.99995 13.8864 4.00001L10.1136 4.00001C9.82094 3.99995 9.52661 3.99989 9.27537 4.02748C8.988 4.05904 8.66577 4.134 8.35578 4.34388C8.04578 4.55375 7.85651 4.82509 7.72048 5.08019C7.60156 5.30321 7.4923 5.5765 7.38366 5.84826L7.3214 6.00392Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 16-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","discard","bin","garbage","cancel","void","refund","clear","empty","recycle","waste","dustbin","rubbish"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.29711 6.25722L8.02999 6.92503C8.01018 6.97456 8 7.0274 8 7.08074C8 7.31229 8.18771 7.5 8.41926 7.5L15.5807 7.5C15.8123 7.5 16 7.31229 16 7.08074C16 7.0274 15.9898 6.97456 15.97 6.92503L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M16 11L17 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 16": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin","garbage","erase","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16 11L17 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 15L8 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 17-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","garbage","cancel","void","erase","discard","trash-order","delete-order","remove-order","bin-order","cancel-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7C9.34387 5.84985 10.5566 5 12 5C13.4434 5 14.6561 5.84985 15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 17-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","trash-item","delete-item","remove-item","void-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7.00391H6V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7.00391Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.75 7C6.75 6.58579 6.41421 6.25 6 6.25C5.58579 6.25 5.25 6.58579 5.25 7H6.75ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25C17.5858 6.25 17.25 6.58579 17.25 7H18.75ZM17.4142 18.4142L16.8839 17.8839L16.8839 17.8839L17.4142 18.4142ZM6.58579 18.4142L7.11612 17.8839L7.11612 17.8839L6.58579 18.4142ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM6.75 15V7.00391H5.25V15H6.75ZM6.75 7.00391V7H5.25V7.00391H6.75ZM18.75 15V7.00391H17.25V15H18.75ZM18.75 7.00391V7H17.25V7.00391H18.75ZM14 18.25H10V19.75H14V18.25ZM17.25 15C17.25 15.964 17.2484 16.6116 17.1835 17.0946C17.1214 17.5561 17.0142 17.7536 16.8839 17.8839L17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7516 16.6883 18.75 15.9216 18.75 15H17.25ZM14 19.75C14.9216 19.75 15.6883 19.7516 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445L16.8839 17.8839C16.7536 18.0142 16.5561 18.1214 16.0946 18.1835C15.6116 18.2484 14.964 18.25 14 18.25V19.75ZM5.25 15C5.25 15.9216 5.24841 16.6883 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445L7.11612 17.8839C6.9858 17.7536 6.87858 17.5561 6.81654 17.0946C6.75159 16.6116 6.75 15.964 6.75 15H5.25ZM10 18.25C9.03599 18.25 8.38843 18.2484 7.90539 18.1835C7.44393 18.1214 7.24643 18.0142 7.11612 17.8839L6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.31174 19.7516 9.07839 19.75 10 19.75V18.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M9 14V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.894 6.78901L15 7H9L9.105 6.78901C9.6531 5.6926 10.7737 5 11.9995 5C13.2253 5 14.3459 5.6926 14.894 6.78901Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 7H18L6 7L5 7" fill={colors?.[1] || "#3D4C66"} />
                <path
                    d="M19 7H18L6 7L5 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 14V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 17-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","clear","void","refund","return","trash-can","bin","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6L8.40161 6C9.16927 4.76417 10.5263 4 11.9995 4C13.4727 4 14.8297 4.76417 15.5974 6L19 6C19.5523 6 20 6.44772 20 7C20 7.55229 19.5523 8 19 8L15 8H9ZM18.75 9.25H5.25L5.25 15.052V15.052C5.24997 15.9505 5.24995 16.6997 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.3003 19.7501 9.04951 19.75 9.94798 19.75H14.052C14.9505 19.75 15.6997 19.7501 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7501 16.6997 18.75 15.9505 18.75 15.052L18.75 9.25ZM9 12C9.55229 12 10 12.4477 10 13V15C10 15.5523 9.55229 16 9 16C8.44772 16 8 15.5523 8 15V13C8 12.4477 8.44772 12 9 12ZM12 12C12.5523 12 13 12.4477 13 13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V13C11 12.4477 11.4477 12 12 12ZM15 12C15.5523 12 16 12.4477 16 13V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V13C14 12.4477 14.4477 12 15 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 17": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","clear","trash-item","remove-item","delete-item","void-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7C9.34387 5.84985 10.5566 5 12 5C13.4434 5 14.6561 5.84985 15 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 18-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","clear","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.6325 6.89737L14.9719 7.91581C14.9857 7.95723 14.9549 8 14.9113 8H9.08875C9.04509 8 9.01426 7.95723 9.02806 7.91581L9.36754 6.89737C9.74524 5.76428 10.8056 5 12 5C13.1944 5 14.2548 5.76428 14.6325 6.89737Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 8L18 8H6H5" fill={colors?.[1] || "#D9D1E0"} />
                <path
                    d="M6 8L6.66929 15.3621C6.82635 17.0898 6.90488 17.9537 7.47775 18.4768C8.05062 19 8.91804 19 10.6529 19H12H13.3471C15.082 19 15.9494 19 16.5222 18.4768C17.0951 17.9537 17.1737 17.0898 17.3307 15.3621L18 8H6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6.66929 15.3621L5.92237 15.43L6.66929 15.3621ZM18 8V7.25V8ZM16.5222 18.4768L17.028 19.0307V19.0307L16.5222 18.4768ZM7.47775 18.4768L6.972 19.0307H6.972L7.47775 18.4768ZM19 8.75C19.4142 8.75 19.75 8.41421 19.75 8C19.75 7.58579 19.4142 7.25 19 7.25V8.75ZM5 7.25C4.58579 7.25 4.25 7.58579 4.25 8C4.25 8.41421 4.58579 8.75 5 8.75V7.25ZM5.25308 8.0679L5.92237 15.43L7.41621 15.2942L6.74692 7.9321L5.25308 8.0679ZM18.0776 15.43L18.7469 8.0679L17.2531 7.9321L16.5838 15.2942L18.0776 15.43ZM13.3471 19.75C14.1944 19.75 14.9021 19.7515 15.4667 19.6784C16.0526 19.6026 16.5838 19.4363 17.028 19.0307L16.0165 17.923C15.8878 18.0406 15.6989 18.1358 15.2742 18.1908C14.8281 18.2485 14.2347 18.25 13.3471 18.25V19.75ZM16.5838 15.2942C16.5034 16.1782 16.4482 16.769 16.3504 17.208C16.2572 17.626 16.1452 17.8055 16.0165 17.923L17.028 19.0307C17.4722 18.625 17.6859 18.111 17.8144 17.5344C17.9383 16.9787 18.0009 16.2738 18.0776 15.43L16.5838 15.2942ZM5.92237 15.43C5.99907 16.2738 6.06168 16.9787 6.18556 17.5344C6.31412 18.111 6.52784 18.625 6.972 19.0307L7.98351 17.923C7.8548 17.8055 7.74282 17.626 7.64962 17.208C7.55175 16.769 7.49656 16.1782 7.41621 15.2942L5.92237 15.43ZM10.6529 18.25C9.76529 18.25 9.17186 18.2485 8.72583 18.1908C8.30109 18.1358 8.11222 18.0406 7.98351 17.923L6.972 19.0307C7.41616 19.4363 7.94743 19.6026 8.53332 19.6784C9.09792 19.7515 9.80561 19.75 10.6529 19.75V18.25ZM19 7.25L18 7.25V8.75L19 8.75V7.25ZM10.6529 19.75H12V18.25H10.6529V19.75ZM12 19.75H13.3471V18.25H12V19.75ZM18 7.25H6V8.75H18V7.25ZM6 7.25H5V8.75H6V7.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 8H18L6 8L5 8" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M19 8H18L6 8L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 18-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","cancel","void","discard","clear","empty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8L17.3307 15.3621C17.1737 17.0898 17.0951 17.9537 16.5222 18.4768C15.9494 19 15.082 19 13.3471 19H10.6529C8.91804 19 8.05062 19 7.47775 18.4768C6.90488 17.9537 6.82635 17.0898 6.66929 15.3621L6 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L14.6325 6.89737C14.2548 5.76428 13.1944 5 12 5V5C10.8056 5 9.74524 5.76428 9.36754 6.89737L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 18-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","clear","void","revert","erase","undo","backspace"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3.25C10.4828 3.25 9.13583 4.22085 8.65604 5.6602L8.54278 6H5C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8L19 8C19.5523 8 20 7.55229 20 7C20 6.44772 19.5523 6 19 6H15.4572L15.344 5.6602C14.8642 4.22085 13.5172 3.25 12 3.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.92687 15.479L5.3606 9.25H18.6395L18.0732 15.479C17.9985 16.3011 17.936 16.9895 17.8145 17.5344C17.6859 18.111 17.4722 18.625 17.0281 19.0307C16.5839 19.4363 16.0526 19.6026 15.4667 19.6784C14.9131 19.75 14.2218 19.75 13.3963 19.75H10.6037C9.77823 19.75 9.08701 19.75 8.53337 19.6784C7.94748 19.6026 7.41621 19.4363 6.97205 19.0307C6.52789 18.625 6.31417 18.111 6.18562 17.5344C6.06414 16.9895 6.00158 16.3011 5.92687 15.479ZM11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V13ZM15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 18": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","clear","erase","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8L17.3307 15.3621C17.1737 17.0898 17.0951 17.9537 16.5222 18.4768C15.9494 19 15.082 19 13.3471 19H10.6529C8.91804 19 8.05062 19 7.47775 18.4768C6.90488 17.9537 6.82635 17.0898 6.66929 15.3621L6 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8L14.6325 6.89737C14.2548 5.76428 13.1944 5 12 5V5C10.8056 5 9.74524 5.76428 9.36754 6.89737L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 19-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","bin","clear","void","cancel-order","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L18.6468 8.05046C14.238 8.68029 9.76202 8.68029 5.35319 8.05046L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L15.2604 6.8906C14.9698 6.45463 14.8244 6.23665 14.6033 6.11833C14.3822 6 14.1203 6 13.5963 6H10.4037C9.87974 6 9.61775 6 9.39666 6.11833C9.17557 6.23665 9.03024 6.45463 8.7396 6.8906L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 19-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","bin","empty","clear","refund","void","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.4037 6H13.5963C14.1202 6 14.3822 6 14.6033 6.11833C14.8244 6.23665 14.9697 6.45463 15.2604 6.8906L15.3333 7L15.6666 7.5L15.8333 7.75L15.9166 7.875C15.9522 7.92843 15.9139 8 15.8497 8H8.15023C8.08601 8 8.04771 7.92843 8.08333 7.875L8.16666 7.75L8.33332 7.5L8.66665 7L8.73956 6.89062C9.0302 6.45465 9.17553 6.23666 9.39662 6.11833C9.61772 6 9.8797 6 10.4037 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.63967 15.398L5.88074 8.46879C5.86382 8.31426 6.0241 8.18685 6.17524 8.22324C7.947 8.64978 14.3921 8.92232 17.7289 8.20074C17.863 8.17176 17.9874 8.28024 17.9753 8.41686L17.3601 15.398C17.1889 17.1098 17.1033 17.9658 16.5319 18.4829C15.9605 19 15.1003 19 13.3799 19H10.6198C8.89942 19 8.03922 19 7.46784 18.4829C6.89645 17.9658 6.81086 17.1098 6.63967 15.398Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5.88074 8.46879L6.62628 8.38714L5.88074 8.46879ZM6.63967 15.398L7.38598 15.3233L7.38522 15.3163L6.63967 15.398ZM17.3601 15.398L18.1064 15.4726L18.1072 15.4638L17.3601 15.398ZM17.9753 8.41686L18.7224 8.4827V8.4827L17.9753 8.41686ZM16.5319 18.4829L16.0287 17.9268L16.5319 18.4829ZM7.46784 18.4829L7.97109 17.9268H7.97109L7.46784 18.4829ZM17.7289 8.20074L17.5704 7.46769H17.5704L17.7289 8.20074ZM6.17524 8.22324L6.35078 7.49407L6.17524 8.22324ZM5.1352 8.55045L5.89413 15.4796L7.38522 15.3163L6.62628 8.38714L5.1352 8.55045ZM10.6198 19.75H13.3799V18.25H10.6198V19.75ZM18.1072 15.4638L18.7224 8.4827L17.2282 8.35102L16.613 15.3321L18.1072 15.4638ZM13.3799 19.75C14.2201 19.75 14.9221 19.7514 15.4827 19.6792C16.0645 19.6042 16.5923 19.4398 17.0352 19.0389L16.0287 17.9268C15.9002 18.043 15.7122 18.1372 15.2909 18.1915C14.8484 18.2485 14.2602 18.25 13.3799 18.25V19.75ZM16.6138 15.3233C16.5262 16.1992 16.4662 16.7844 16.3654 17.219C16.2695 17.6328 16.1571 17.8105 16.0287 17.9268L17.0352 19.0389C17.4781 18.6381 17.6942 18.1293 17.8267 17.5579C17.9543 17.0073 18.0228 16.3086 18.1063 15.4726L16.6138 15.3233ZM5.8934 15.4726C5.97699 16.3086 6.0454 17.0073 6.17306 17.5579C6.30557 18.1293 6.52169 18.6381 6.96458 19.0389L7.97109 17.9268C7.8426 17.8105 7.73024 17.6328 7.6343 17.219C7.53352 16.7844 7.47354 16.1992 7.38595 15.3233L5.8934 15.4726ZM10.6198 18.25C9.73957 18.25 9.1513 18.2485 8.70882 18.1915C8.28757 18.1372 8.09958 18.043 7.97109 17.9268L6.96458 19.0389C7.40748 19.4398 7.93528 19.6042 8.51708 19.6792C9.07764 19.7514 9.77967 19.75 10.6198 19.75V18.25ZM17.5704 7.46769C15.9878 7.80992 13.6116 7.92367 11.3756 7.89261C9.12946 7.8614 7.14846 7.68611 6.35078 7.49407L5.99969 8.9524C6.97378 9.18691 9.10119 9.36116 11.3548 9.39246C13.6185 9.42391 16.1332 9.31314 17.8874 8.9338L17.5704 7.46769ZM18.7224 8.4827C18.7794 7.8363 18.1921 7.33325 17.5704 7.46769L17.8874 8.9338C17.5338 9.01026 17.1953 8.72418 17.2282 8.35102L18.7224 8.4827ZM6.62628 8.38714C6.64998 8.6035 6.54494 8.76874 6.44056 8.85434C6.33867 8.93791 6.17995 8.9958 5.99969 8.9524L6.35078 7.49407C6.01939 7.41429 5.70496 7.51769 5.48937 7.6945C5.2713 7.87335 5.09458 8.17956 5.1352 8.55045L6.62628 8.38714Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 8L18.6468 8.05046C14.238 8.68029 9.76202 8.68029 5.35319 8.05046L5 8"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M19 8L18.6468 8.05046C14.238 8.68029 9.76202 8.68029 5.35319 8.05046L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 19": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","clear","void","refund","item","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L18.6468 8.05046C14.238 8.68029 9.76202 8.68029 5.35319 8.05046L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 8L15.2604 6.8906C14.9698 6.45463 14.8244 6.23665 14.6033 6.11833C14.3822 6 14.1203 6 13.5963 6H10.4037C9.87974 6 9.61775 6 9.39666 6.11833C9.17557 6.23665 9.03024 6.45463 8.7396 6.8906L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 19-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","clear","bin","garbage","recycle","refund","item-removal","order-cancellation","void-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.64536 15.5023L5.04566 10.0269L5.07053 10.0304C9.63572 10.6826 14.27 10.687 18.8361 10.0437L18.3554 15.4976L18.3492 15.559C18.2689 16.3624 18.1994 17.0586 18.0705 17.6144C17.9319 18.2122 17.6985 18.7762 17.2032 19.2244C16.7079 19.6727 16.1234 19.8488 15.5149 19.9272C14.949 20.0002 14.2493 20.0001 13.4419 20.0001H10.5583C9.75096 20.0001 9.05125 20.0002 8.48538 19.9272C7.87682 19.8488 7.29238 19.6727 6.79709 19.2244C6.3018 18.7762 6.06838 18.2122 5.92979 17.6144C5.80091 17.0586 5.73133 16.3624 5.65104 15.559L5.64536 15.5023ZM11.0001 14C11.0001 13.4477 10.5524 13 10.0001 13C9.44784 13 9.00013 13.4477 9.00013 14V16C9.00013 16.5523 9.44784 17 10.0001 17C10.5524 17 11.0001 16.5523 11.0001 16V14ZM15.0001 14C15.0001 13.4477 14.5524 13 14.0001 13C13.4478 13 13.0001 13.4477 13.0001 14V16C13.0001 16.5523 13.4478 17 14.0001 17C14.5524 17 15.0001 16.5523 15.0001 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3708 5C10.3818 5.00001 10.3928 5.00001 10.4038 5.00001H13.5964C13.6074 5.00001 13.6184 5.00001 13.6294 5C13.8626 4.99996 14.1004 4.99992 14.3063 5.01912C14.5426 5.04115 14.8068 5.09295 15.0753 5.23666C15.3438 5.38037 15.5334 5.57143 15.6828 5.7558C15.813 5.9165 15.9449 6.11435 16.0742 6.30842L16.7218 7.27987C17.3174 7.21841 17.9121 7.14529 18.5055 7.06052L18.8587 7.01006C19.4054 6.93195 19.912 7.31185 19.9901 7.85859C20.0682 8.40532 19.6883 8.91185 19.1415 8.98996L18.7884 9.04042C14.2857 9.68365 9.71453 9.68365 5.2119 9.04041L4.85871 8.98996C4.31197 8.91185 3.93207 8.40532 4.01018 7.85859C4.08828 7.31185 4.59481 6.93195 5.14155 7.01006L5.49474 7.06051C6.08816 7.14529 6.68281 7.2184 7.27837 7.27986L7.90763 6.33594C7.91373 6.32679 7.91984 6.31762 7.92596 6.30844C8.05528 6.11437 8.18713 5.91652 8.31733 5.75583C8.46672 5.57145 8.65635 5.38038 8.92488 5.23667C9.19342 5.09295 9.45758 5.04115 9.69386 5.01912C9.89979 4.99992 10.1375 4.99996 10.3708 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","cancel","discard","void","clear","erase","bin","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7.00391V14.9998C7 16.8854 7 17.8282 7.58579 18.414C8.17157 18.9998 9.11438 18.9998 11 18.9998H13C14.8856 18.9998 15.8284 18.9998 16.4142 18.414C17 17.8282 17 16.8854 17 14.9998V7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","cancel","void","discard","erase","clear","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18L18 15.0656C18.0001 15.9521 18.0001 16.7159 17.9179 17.3276C17.8297 17.9831 17.631 18.6114 17.1213 19.1211C16.6117 19.6308 15.9833 19.8295 15.3278 19.9176C14.7161 19.9999 13.9523 19.9998 13.0658 19.9998H10.9342C10.0477 19.9998 9.28387 19.9999 8.67221 19.9176C8.01669 19.8295 7.38834 19.6308 6.87868 19.1211C6.36902 18.6114 6.17027 17.9831 6.08214 17.3276C5.9999 16.7159 5.99995 15.9521 6 15.0656L6 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391ZM11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V11ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.99897C9.00057 3.44668 9.44875 2.99943 10.001 3L14.001 3.00414C14.5533 3.00471 15.0006 3.45289 15 4.00517C14.9994 4.55746 14.5513 5.00471 13.999 5.00414L9.99897 5C9.44668 4.99943 8.99943 4.55125 9 3.99897Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","garbage","clear","void","cancel","erase","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7.00391H7V14.9998C7 16.8854 7 17.8282 7.58579 18.414C8.17157 18.9998 9.11438 18.9998 11 18.9998H13C14.8856 18.9998 15.8284 18.9998 16.4142 18.414C17 17.8282 17 16.8854 17 14.9998V7.00391Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM16.4142 18.414L15.8839 17.8837L15.8839 17.8837L16.4142 18.414ZM7.58579 18.414L8.11612 17.8837L8.11612 17.8837L7.58579 18.414ZM5 7.75391H7V6.25391H5V7.75391ZM7 7.75391H17V6.25391H7V7.75391ZM17 7.75391H19V6.25391H17V7.75391ZM7.75 14.9998V7.00391H6.25V14.9998H7.75ZM17.75 14.9998V7.00391H16.25V14.9998H17.75ZM13 18.2498H11V19.7498H13V18.2498ZM16.25 14.9998C16.25 15.9638 16.2484 16.6113 16.1835 17.0944C16.1214 17.5558 16.0142 17.7533 15.8839 17.8837L16.9445 18.9443C17.4 18.4888 17.5857 17.922 17.6701 17.2942C17.7516 16.688 17.75 15.9214 17.75 14.9998H16.25ZM13 19.7498C13.9216 19.7498 14.6883 19.7514 15.2945 19.6699C15.9223 19.5855 16.4891 19.3998 16.9445 18.9443L15.8839 17.8837C15.7536 18.014 15.5561 18.1212 15.0946 18.1832C14.6116 18.2482 13.964 18.2498 13 18.2498V19.7498ZM6.25 14.9998C6.25 15.9214 6.24841 16.688 6.32991 17.2942C6.41432 17.922 6.59999 18.4888 7.05546 18.9443L8.11612 17.8837C7.9858 17.7533 7.87858 17.5558 7.81654 17.0944C7.75159 16.6113 7.75 15.9638 7.75 14.9998H6.25ZM11 18.2498C10.036 18.2498 9.38843 18.2482 8.90539 18.1832C8.44393 18.1212 8.24643 18.014 8.11612 17.8837L7.05546 18.9443C7.51093 19.3998 8.07773 19.5855 8.70552 19.6699C9.31174 19.7514 10.0784 19.7498 11 19.7498V18.2498Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M10 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M10.0008 4.25C9.58656 4.24957 9.25043 4.58501 9.25 4.99922C9.24957 5.41344 9.58501 5.74957 9.99922 5.75L10.0008 4.25ZM13.9992 5.75414C14.4134 5.75457 14.7496 5.41913 14.75 5.00491C14.7504 4.5907 14.415 4.25457 14.0008 4.25414L13.9992 5.75414ZM9.99922 5.75L13.9992 5.75414L14.0008 4.25414L10.0008 4.25L9.99922 5.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 20-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin","garbage","recycle","erase","trash-order","delete-order","remove-item","delete-item","void-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L17.438 15.4961C17.2294 17.1645 17.1252 17.9987 16.558 18.4994C15.9909 19 15.1502 19 13.4689 19H10.5311C8.84976 19 8.00908 19 7.44196 18.4994C6.87484 17.9987 6.77057 17.1645 6.56202 15.4961L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L18.6468 7.94954C14.238 7.31971 9.76202 7.31971 5.35319 7.94954L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","erase","void","clear","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7.00391V14.9998C7 16.8854 7 17.8282 7.58579 18.414C8.17157 18.9998 9.11438 18.9998 11 18.9998H13C14.8856 18.9998 15.8284 18.9998 16.4142 18.414C17 17.8282 17 16.8854 17 14.9998V7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 20-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","garbage","discard","cancel","erase","clear","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.94426 10.3959C10.7222 8.86086 15.7496 9.77678 17.9514 10.4568C18.4524 10.6115 18.7433 11.1007 18.6818 11.5931L18.1763 15.637C18.0772 16.4305 17.994 17.0959 17.859 17.6221C17.7161 18.1793 17.4938 18.6739 17.0545 19.0617C16.6152 19.4495 16.0968 19.6088 15.5262 19.6815C14.9873 19.7502 14.3167 19.7501 13.517 19.7501H10.4831C9.68341 19.7501 9.01282 19.7502 8.47401 19.6815C7.90333 19.6088 7.38498 19.4495 6.94569 19.0617C6.50641 18.6739 6.28405 18.1793 6.14112 17.6221C6.00617 17.0959 5.92302 16.4305 5.82385 15.637L5.29591 11.4134C5.23997 10.966 5.50843 10.536 5.94426 10.3959ZM11.0001 14C11.0001 13.4477 10.5524 13 10.0001 13C9.44784 13 9.00012 13.4477 9.00012 14V15.5C9.00012 16.0523 9.44784 16.5 10.0001 16.5C10.5524 16.5 11.0001 16.0523 11.0001 15.5V14ZM15.0001 14C15.0001 13.4477 14.5524 13 14.0001 13C13.4478 13 13.0001 13.4477 13.0001 14V15.5C13.0001 16.0523 13.4478 16.5 14.0001 16.5C14.5524 16.5 15.0001 16.0523 15.0001 15.5V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.3763 4.25C10.1381 4.24998 9.91106 4.24995 9.71711 4.26803C9.50025 4.28826 9.27193 4.3345 9.0429 4.45708C8.81386 4.57966 8.64874 4.74398 8.51162 4.91321C8.38899 5.06455 8.26309 5.25345 8.13096 5.4517L7.45946 6.45899C7.40715 6.53745 7.37028 6.6197 7.34741 6.70308C6.63423 6.77254 5.92221 6.858 5.2119 6.95948L4.85871 7.00993C4.31197 7.08804 3.93207 7.59457 4.01018 8.1413C4.08828 8.68804 4.59481 9.06794 5.14155 8.98983L5.49474 8.93937C9.80976 8.32294 14.1905 8.32294 18.5055 8.93938L18.8587 8.98983C19.4054 9.06794 19.912 8.68804 19.9901 8.1413C20.0682 7.59457 19.6883 7.08804 19.1415 7.00993L18.7884 6.95948C18.0781 6.85801 17.3661 6.77254 16.6529 6.70308C16.63 6.6197 16.5931 6.53745 16.5408 6.45898L15.8693 5.45168C15.7372 5.25343 15.6113 5.06453 15.4886 4.91319C15.3515 4.74396 15.1864 4.57965 14.9574 4.45707C14.7283 4.3345 14.5 4.28825 14.2832 4.26803C14.0892 4.24995 13.8622 4.24998 13.624 4.25H10.3763Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 20-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","garbage","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.4689 19.0001H10.5311C8.84976 19.0001 8.00908 19.0001 7.44196 18.4995C6.87484 17.9989 6.77057 17.1647 6.56202 15.4963L6.13298 12.064L6.04002 11.3203L6.02001 11.1602C6.00838 11.0671 6.06429 10.9786 6.1536 10.9498C10.7299 9.47809 15.6338 10.2742 17.7613 10.924C17.9014 10.9668 17.9869 11.1048 17.9688 11.2501L17.9375 11.5001L17.875 12.0001L17.75 13.0001L17.5 15.0001L17.438 15.4963C17.2294 17.1647 17.1252 17.9989 16.558 18.4995C15.9909 19.0001 15.1502 19.0001 13.4689 19.0001Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L18.6468 7.94954C14.238 7.31971 9.76202 7.31971 5.35319 7.94954L5 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.4037 5H13.5963C14.1202 5 14.3822 5 14.6033 5.11833C14.8244 5.23665 14.9697 5.45463 15.2604 5.8906L15.3333 6L15.6666 6.5L15.8333 6.75L15.9166 6.875C15.9522 6.92843 15.9139 7 15.8497 7H8.15023C8.08601 7 8.04771 6.92843 8.08333 6.875L8.16666 6.75L8.33332 6.5L8.66665 6L8.73956 5.89062C9.0302 5.45465 9.17553 5.23666 9.39662 5.11833C9.61772 5 9.8797 5 10.4037 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 21-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","discard","clear","cancel","void","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1536 17.2228 16.4766L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 7L6.5 7C5.67157 7 5 7.67157 5 8.5C5 9.32843 5.67157 10 6.5 10L17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 7L15.9487 6.84605C15.3821 5.14642 13.7916 4 12 4V4C10.2084 4 8.61786 5.14642 8.05132 6.84605L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 20": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","item-removal","order-cancellation","product-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 11L17.438 15.4961C17.2294 17.1645 17.1252 17.9987 16.558 18.4994C15.9909 19 15.1502 19 13.4689 19H10.5311C8.84976 19 8.00908 19 7.44196 18.4994C6.87484 17.9987 6.77057 17.1645 6.56202 15.4961L6 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 8L18.6468 7.94954C14.238 7.31971 9.76202 7.31971 5.35319 7.94954L5 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 21-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","clear","cancel","void","item-removal","transaction-cancellation","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.42 3H10.58C9.27 3 8.11 3.8 7.63 5H16.37C15.88 3.8 14.73 3 13.42 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.23 12L5.78 16.6C6 18.46 6.13 19.49 6.98 20.25C7.83 21.01 8.87 21 10.74 21H13.24C15.12 21 16.15 21.01 17.01 20.25C17.86 19.49 17.99 18.4 18.21 16.6L18.76 12H5.23ZM13 15C13 14.45 13.45 14 14 14C14.55 14 15 14.45 15 15V17C15 17.55 14.55 18 14 18C13.45 18 13 17.55 13 17V15ZM9 15C9 14.45 9.45 14 10 14C10.55 14 11 14.45 11 15V17C11 17.55 10.55 18 10 18C9.45 18 9 17.55 9 17V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.5 6.25H6.5C5.26 6.25 4.25 7.26 4.25 8.5C4.25 9.18 4.56 9.78 5.03 10.19C5.33 10.45 5.68 10.63 6.08 10.7C6.21 10.73 6.35 10.74 6.5 10.74H17.5C17.64 10.74 17.78 10.72 17.91 10.7C18.31 10.63 18.66 10.44 18.95 10.19C19.43 9.78 19.75 9.17 19.75 8.49C19.75 7.25 18.73 6.24 17.49 6.24L17.5 6.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 21-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","garbage","cancel","void","clear","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.4189 4L10.5811 4C9.6369 4 8.7986 4.60421 8.5 5.5L8.25 6.25L8.125 6.625C8.06351 6.80949 8.20082 7 8.39529 7L15.2094 7C15.5984 7 15.873 6.61897 15.75 6.25L15.5 5.5C15.2014 4.60421 14.3631 4 13.4189 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1537 17.2228 16.4766V16.4766L17.4 15L17.7 12.5L17.85 11.25L17.925 10.625L17.9625 10.3125C17.9824 10.1463 17.8527 10 17.6853 10H6.15737C6.07367 10 6.00878 10.0731 6.01875 10.1562L6.0375 10.3125L6.075 10.625L6.15 11.25L6.3 12.5L6.6 15L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 7L6.5 7C5.67157 7 5 7.67157 5 8.5C5 9.32843 5.67157 10 6.5 10L17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 22-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","clear","cancel","void","erase","bin","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1536 17.2228 16.4766L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L7 6C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8C5 8.94281 5 9.41421 5.29289 9.70711C5.58579 10 6.05719 10 7 10L17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6L15.843 5.45056C15.6435 4.75239 15.5438 4.4033 15.2765 4.20165C15.0091 4 14.6461 4 13.92 4L10.08 4C9.35392 4 8.99087 4 8.72353 4.20165C8.4562 4.4033 8.35646 4.75239 8.15698 5.45056L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 22-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","clear","cancel","void","item-removal","order-cancellation","transaction-void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.15698 5.45056L8.14568 5.49011L8.14568 5.49012C8.07887 5.72396 8.04546 5.84088 8.10548 5.92044C8.16549 6 8.28709 6 8.53029 6L15.4697 6C15.7129 6 15.8345 6 15.8945 5.92044C15.9545 5.84088 15.9211 5.72396 15.8543 5.49011L15.843 5.45056C15.6435 4.75239 15.5438 4.4033 15.2765 4.20165C15.0091 4 14.6461 4 13.92 4L10.08 4C9.35392 4 8.99087 4 8.72353 4.20165C8.4562 4.4033 8.35646 4.75239 8.15698 5.45056Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 10L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1536 17.2228 16.4766L18 10H6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L7 6C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8C5 8.94281 5 9.41421 5.29289 9.70711C5.58579 10 6.05719 10 7 10L17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 21": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","recycle","erase","garbage","waste","clear","trash-can","delete-item","remove-item","cancel-item","void-item","discard-item","clear-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1536 17.2228 16.4766L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.5 7L6.5 7C5.67157 7 5 7.67157 5 8.5C5 9.32843 5.67157 10 6.5 10L17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 7L15.9487 6.84605C15.3821 5.14642 13.7916 4 12 4V4C10.2084 4 8.61786 5.14642 8.05132 6.84605L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 22": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","clear","void","bin","garbage","recycle","erase","backspace","undo","refund","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 10L6.77719 16.4766C6.97844 18.1536 7.07906 18.9922 7.64705 19.4961C8.21505 20 9.0596 20 10.7487 20H13.2513C14.9404 20 15.785 20 16.3529 19.4961C16.9209 18.9922 17.0216 18.1536 17.2228 16.4766L18 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L7 6C6.05719 6 5.58579 6 5.29289 6.29289C5 6.58579 5 7.05719 5 8C5 8.94281 5 9.41421 5.29289 9.70711C5.58579 10 6.05719 10 7 10L17 10C17.9428 10 18.4142 10 18.7071 9.70711C19 9.41421 19 8.94281 19 8C19 7.05719 19 6.58579 18.7071 6.29289C18.4142 6 17.9428 6 17 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 16V14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 6L15.843 5.45056C15.6435 4.75239 15.5438 4.4033 15.2765 4.20165C15.0091 4 14.6461 4 13.92 4L10.08 4C9.35392 4 8.99087 4 8.72353 4.20165C8.4562 4.4033 8.35646 4.75239 8.15698 5.45056L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash 23-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","cancel","discard","void","clear","erase","trash-order","delete-order","remove-order","cancel-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.6398 15.398L6 9H18L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 23-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","bin","cancel","void","clear","discard","erase","dustbin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.6398 15.398L6 9H18L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 7L5 7L19 7Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.4037 5H13.5963C14.1202 5 14.3822 5 14.6033 5.11833C14.8244 5.23665 14.9697 5.45463 15.2604 5.8906L15.3333 6L15.6666 6.5C15.8091 6.71372 15.6559 7 15.399 7H8.60092C8.34405 7 8.19084 6.71373 8.33332 6.5L8.66665 6L8.73956 5.89062C9.0302 5.45465 9.17553 5.23666 9.39662 5.11833C9.61772 5 9.8797 5 10.4037 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 23-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","garbage","cancel","void","discard","clear","erase","refund","delete-item","remove-item","cancel-order","void-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.69374 4.01912C9.89967 3.99992 10.1374 3.99996 10.3706 4L13.6293 4C13.8625 3.99996 14.1003 3.99992 14.3062 4.01912C14.5425 4.04115 14.8066 4.09295 15.0752 4.23666C15.3437 4.38037 15.5333 4.57143 15.6827 4.7558C15.8129 4.9165 15.9448 5.11435 16.0741 5.30841L16.4987 5.94531C16.5108 5.96342 16.5223 5.98165 16.5334 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H15.4039L15.399 8.00001H8.60093L8.59608 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H7.46661C7.47765 5.98166 7.48921 5.96342 7.50128 5.94532L7.92584 5.30844C8.05517 5.11437 8.18701 4.91652 8.31721 4.75582C8.46661 4.57145 8.65623 4.38038 8.92477 4.23667C9.1933 4.09295 9.45746 4.04115 9.69374 4.01912ZM5.25855 9.32899C5.44813 9.11951 5.71748 9 6 9H18C18.2825 9 18.5519 9.11951 18.7415 9.32899C18.931 9.53848 19.0232 9.81838 18.995 10.0995L18.3491 16.5589C18.2688 17.3623 18.1992 18.0586 18.0704 18.6144C17.9318 19.2121 17.6983 19.7761 17.203 20.2244C16.7078 20.6726 16.1233 20.8487 15.5148 20.9272C14.9489 21.0001 14.2492 21 13.4418 21H10.5582C9.75084 21 9.05112 21.0001 8.48526 20.9272C7.8767 20.8487 7.29226 20.6726 6.79696 20.2244C6.30167 19.7761 6.06825 19.2121 5.92966 18.6144C5.80078 18.0586 5.7312 17.3623 5.65091 16.559L5.00497 10.0995C4.97685 9.81838 5.06897 9.53848 5.25855 9.32899ZM9 13C9.55228 13 10 13.4477 10 14V16C10 16.5523 9.55228 17 9 17C8.44772 17 8 16.5523 8 16V14C8 13.4477 8.44772 13 9 13ZM15 13C15.5523 13 16 13.4477 16 14V16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16V14C14 13.4477 14.4477 13 15 13ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 22-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","garbage","erase","cancel","void","clear","recycle","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.79002 17.16C5.88002 17.95 5.97001 18.63 6.10001 19.17C6.25001 19.76 6.49001 20.31 6.98001 20.74C7.47001 21.18 8.05002 21.35 8.65002 21.42C9.21002 21.49 9.83 21.5 10.63 21.5H13.25C14.04 21.5 14.79 21.49 15.35 21.42C15.95 21.34 16.53 21.17 17.02 20.74C17.51 20.3 17.75 19.75 17.9 19.17C18.04 18.63 18.12 17.94 18.21 17.16L18.77 12.5H5.24002L5.80001 17.16H5.79002ZM13 15.5C13 14.95 13.45 14.5 14 14.5C14.55 14.5 15 14.95 15 15.5V17.5C15 18.05 14.55 18.5 14 18.5C13.45 18.5 13 18.05 13 17.5V15.5ZM9.00002 15.5C9.00002 14.95 9.45002 14.5 10 14.5C10.55 14.5 11 14.95 11 15.5V17.5C11 18.05 10.55 18.5 10 18.5C9.45002 18.5 9.00002 18.05 9.00002 17.5V15.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.75 4.5C16.54 3.78 16.37 3.28 15.88 2.9C15.35 2.5 14.78 2.5 13.92 2.5H10.08C9.22002 2.5 8.66001 2.5 8.12001 2.9C7.63001 3.27 7.46002 3.77 7.25002 4.5H16.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.24 6.26C18.73 5.75 18.08 5.75 17 5.75H7.00001C5.92001 5.75 5.28001 5.75 4.76001 6.26C4.24001 6.77 4.25001 7.42 4.25001 8.5C4.25001 9.58 4.25001 10.22 4.76001 10.74C4.85001 10.83 4.95001 10.88 5.04001 10.94C5.51001 11.23 6.10002 11.25 6.99002 11.25H16.99C17.88 11.25 18.47 11.23 18.94 10.94C19.04 10.88 19.14 10.82 19.22 10.74C19.73 10.23 19.75 9.58 19.75 8.5C19.75 7.42 19.73 6.78 19.22 6.26H19.24Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 23": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","garbage","erase","void","clear","refund","return","void-transaction","delete-item","remove-item","clear-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.6398 15.398L6 9H18L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 24-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","garbage","cancel","void","clear","erase","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.60464 14.4417L6 9H18L17.3954 14.4417C17.2073 16.1343 17.1133 16.9805 16.5438 17.4903C15.9742 18 15.1228 18 13.4198 18H10.5802C8.87723 18 8.02576 18 7.45624 17.4903C6.88672 16.9805 6.79269 16.1343 6.60464 14.4417Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 7L5 7L19 7Z" fill={colors?.[1] || "#3D4C66"} />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.4037 5H13.5963C14.1202 5 14.3822 5 14.6033 5.11833C14.8244 5.23665 14.9697 5.45463 15.2604 5.8906L15.3333 6L15.6666 6.5C15.8091 6.71372 15.6559 7 15.399 7H8.60092C8.34405 7 8.19084 6.71373 8.33332 6.5L8.66665 6L8.73956 5.89062C9.0302 5.45465 9.17553 5.23666 9.39662 5.11833C9.61772 5 9.8797 5 10.4037 5Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 24-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","reset","garbage","bin","dustbin","waste","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.6293 4H10.3706C10.1374 3.99996 9.89966 3.99992 9.69373 4.01912C9.45745 4.04115 9.19329 4.09295 8.92476 4.23667C8.65622 4.38038 8.4666 4.57145 8.3172 4.75583C8.187 4.91651 8.05516 5.11437 7.92583 5.30844L7.50127 5.94532C7.48919 5.96343 7.47764 5.98166 7.46659 6.00001H5C4.44772 6.00001 4 6.44772 4 7.00001C4 7.55229 4.44772 8.00001 5 8.00001H19C19.5523 8.00001 20 7.55229 20 7.00001C20 6.44772 19.5523 6.00001 19 6.00001H16.5334C16.5223 5.98166 16.5108 5.96342 16.4987 5.94531L16.0741 5.30842C15.9448 5.11435 15.8129 4.9165 15.6827 4.7558C15.5333 4.57143 15.3437 4.38037 15.0752 4.23666C14.8066 4.09295 14.5425 4.04115 14.3062 4.01912C14.1003 3.99992 13.8625 3.99996 13.6293 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25488 9.33308C5.44458 9.12113 5.71556 9 6 9H18C18.2844 9 18.5554 9.12113 18.7451 9.33308C18.9348 9.54502 19.0253 9.82773 18.9939 10.1104L18.3825 15.6131C18.2943 16.4072 18.2178 17.0959 18.0844 17.6455C17.9408 18.2367 17.7042 18.7937 17.2107 19.2354C16.7172 19.6771 16.1375 19.8508 15.534 19.9282C14.9731 20.0001 14.2801 20 13.4811 20H10.5189C9.71987 20 9.02695 20.0001 8.466 19.9282C7.86252 19.8508 7.28282 19.6771 6.78933 19.2354C6.29583 18.7937 6.05918 18.2367 5.91563 17.6455C5.78219 17.0959 5.70571 16.4072 5.61752 15.6131L5.00612 10.1104C4.97471 9.82773 5.06518 9.54502 5.25488 9.33308ZM11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V13ZM15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 24-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","cancel","void","erase","bin","garbage","recycle","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.3954 14.4417C17.2073 16.1342 17.1133 16.9805 16.5438 17.4903C15.9742 18 15.1228 18 13.4198 18H10.5802C8.87723 18 8.02576 18 7.45624 17.4903C6.88672 16.9805 6.79269 16.1343 6.60464 14.4417L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 25-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","cancel","void","erase","discard","clear","refund","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6.59178 15.285C6.71762 17.0466 6.78053 17.9275 7.35648 18.4637C7.93242 19 8.81549 19 10.5816 19H13.4184C15.1845 19 16.0676 19 16.6435 18.4637C17.2195 17.9275 17.2824 17.0466 17.4082 15.285L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 7L15.843 6.45056C15.6435 5.75239 15.5438 5.4033 15.2765 5.20165C15.0091 5 14.6461 5 13.92 5L10.08 5C9.35392 5 8.99087 5 8.72353 5.20165C8.4562 5.4033 8.35646 5.75239 8.15698 6.45056L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 7L5 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L10 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L14 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 25-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","discard","bin","clear","cancel","void","undo","item-removal","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.3886 5L9.61144 5C9.33896 5 9.20272 5 9.08338 5.02981C8.82017 5.09556 8.59497 5.26543 8.45945 5.50044C8.398 5.607 8.36057 5.738 8.28571 6L8.14286 6.5C8.07127 6.75057 8.25941 7 8.52001 7L15.48 7C15.7406 7 15.9287 6.75057 15.8571 6.5L15.7143 6C15.6394 5.738 15.602 5.607 15.5406 5.50044C15.405 5.26543 15.1798 5.09556 14.9166 5.02981C14.7973 5 14.661 5 14.3886 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17.4082 15.285L18 7H6L6.59178 15.285C6.71762 17.0466 6.78053 17.9275 7.35648 18.4637C7.93242 19 8.81549 19 10.5816 19H13.4184C15.1845 19 16.0676 19 16.6435 18.4637C17.2195 17.9275 17.2824 17.0466 17.4082 15.285Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M17.4082 15.285L18.1563 15.3384L17.4082 15.285ZM6.59178 15.285L5.84369 15.3384L6.59178 15.285ZM19 7.75C19.4142 7.75 19.75 7.41421 19.75 7C19.75 6.58579 19.4142 6.25 19 6.25V7.75ZM5 6.25C4.58579 6.25 4.25 6.58579 4.25 7C4.25 7.41421 4.58579 7.75 5 7.75V6.25ZM17.2519 6.94656L16.6601 15.2316L18.1563 15.3384L18.7481 7.05344L17.2519 6.94656ZM13.4184 18.25H10.5816V19.75H13.4184V18.25ZM7.33988 15.2316L6.74809 6.94656L5.25191 7.05344L5.84369 15.3384L7.33988 15.2316ZM10.5816 18.25C9.67817 18.25 9.07354 18.2485 8.61981 18.1893C8.18746 18.1328 7.99671 18.0351 7.86757 17.9148L6.84539 19.0126C7.29219 19.4286 7.83094 19.599 8.42565 19.6767C8.99898 19.7515 9.71894 19.75 10.5816 19.75V18.25ZM5.84369 15.3384C5.90515 16.1989 5.95496 16.9172 6.07045 17.4837C6.19026 18.0714 6.39859 18.5966 6.84539 19.0126L7.86757 17.9148C7.73842 17.7946 7.62732 17.6113 7.54022 17.1841C7.44882 16.7357 7.40425 16.1327 7.33988 15.2316L5.84369 15.3384ZM16.6601 15.2316C16.5958 16.1327 16.5512 16.7357 16.4598 17.1841C16.3727 17.6113 16.2616 17.7946 16.1324 17.9148L17.1546 19.0126C17.6014 18.5966 17.8097 18.0714 17.9295 17.4837C18.045 16.9172 18.0948 16.1989 18.1563 15.3384L16.6601 15.2316ZM13.4184 19.75C14.2811 19.75 15.001 19.7515 15.5744 19.6767C16.1691 19.599 16.7078 19.4286 17.1546 19.0126L16.1324 17.9148C16.0033 18.0351 15.8125 18.1328 15.3802 18.1893C14.9265 18.2485 14.3218 18.25 13.4184 18.25V19.75ZM19 6.25H18V7.75H19V6.25ZM18 6.25H6V7.75H18V6.25ZM6 6.25H5V7.75H6V6.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M10 11L10 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L14 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 24": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","clear","void","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.3954 14.4417C17.2073 16.1342 17.1133 16.9805 16.5438 17.4903C15.9742 18 15.1228 18 13.4198 18H10.5802C8.87723 18 8.02576 18 7.45624 17.4903C6.88672 16.9805 6.79269 16.1343 6.60464 14.4417L6 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 25-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","void","clear","garbage","bin","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00023H7.24566L7.32415 5.72551L7.34004 5.66949C7.39679 5.46875 7.46727 5.21937 7.59313 5.00112C7.86419 4.53108 8.31458 4.19135 8.841 4.05985C9.08542 3.9988 9.34457 3.99953 9.55318 4.00012L9.61141 4.00023L14.3885 4.00023L14.4468 4.00012C14.6554 3.99953 14.9145 3.9988 15.1589 4.05985C15.6853 4.19135 16.1357 4.53108 16.4068 5.00112C16.5327 5.21936 16.6031 5.46875 16.6599 5.66949L16.6758 5.72551L16.7543 6.00023H19C19.5523 6.00023 20 6.44795 20 7.00023C20 7.55252 19.5523 8.00023 19 8.00023H18.9311L18.4012 15.4192C18.3422 16.2463 18.2911 16.962 18.1745 17.5339C18.0493 18.1483 17.8247 18.7305 17.325 19.1958C16.8252 19.6611 16.2285 19.8436 15.6067 19.9248C15.028 20.0003 14.3105 20.0003 13.4813 20.0002H13.4813H10.5187H10.5187C9.68946 20.0003 8.97195 20.0003 8.39329 19.9248C7.77152 19.8436 7.17477 19.6611 6.67503 19.1958C6.17528 18.7305 5.95075 18.1483 5.82549 17.5339C5.70892 16.962 5.65784 16.2463 5.59881 15.4192L5.06888 8.00023H5C4.44772 8.00023 4 7.55252 4 7.00023C4 6.44795 4.44772 6.00023 5 6.00023ZM11 11.0002C11 10.448 10.5523 10.0002 10 10.0002C9.44772 10.0002 9 10.448 9 11.0002V15.0002C9 15.5525 9.44772 16.0002 10 16.0002C10.5523 16.0002 11 15.5525 11 15.0002V11.0002ZM15 11.0002C15 10.448 14.5523 10.0002 14 10.0002C13.4477 10.0002 13 10.448 13 11.0002V15.0002C13 15.5525 13.4477 16.0002 14 16.0002C14.5523 16.0002 15 15.5525 15 15.0002V11.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 25": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6.59178 15.285C6.71762 17.0466 6.78053 17.9275 7.35648 18.4637C7.93242 19 8.81549 19 10.5816 19H13.4184C15.1845 19 16.0676 19 16.6435 18.4637C17.2195 17.9275 17.2824 17.0466 17.4082 15.285L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 7L15.843 6.45056C15.6435 5.75239 15.5438 5.4033 15.2765 5.20165C15.0091 5 14.6461 5 13.92 5L10.08 5C9.35392 5 8.99087 5 8.72353 5.20165C8.4562 5.4033 8.35646 5.75239 8.15698 6.45056L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 7L5 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 11L10 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 11L14 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 3-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","clear","erase","reject","recycle","dustbin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","erase","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8V16C19 18.2091 17.2091 20 15 20H9C6.79086 20 5 18.2091 5 16V8C4.44772 8 4 7.55228 4 7ZM11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V11ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H10C9.44772 5 9 4.55228 9 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","garbage","cancel","void","clear","erase","refund","remove-item","delete-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 4-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","clear","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 4-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","bin","garbage","clear","void","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M12 11V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","discard","void","erase","clear","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 16V7H6V16C6 17.6569 7.34315 19 9 19H15C16.6569 19 18 17.6569 18 16Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 7H6M19 7H18M18 7V16C18 17.6569 16.6569 19 15 19H9C7.34315 19 6 17.6569 6 16V7M18 7H6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11V15M14 11V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 4": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","cancel","discard","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 11V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 4-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","item","order","discard","clear","erase","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.99897C9.00057 3.44668 9.44875 2.99943 10.001 3L14.001 3.00414C14.5533 3.00471 15.0006 3.45289 15 4.00517C14.9994 4.55746 14.5513 5.00471 13.999 5.00414L9.99897 5C9.44668 4.99943 8.99943 4.55125 9 3.99897Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18.9201L18.2971 15.4774C18.229 16.2945 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2074C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79798 19.9998 9.08795 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2074C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 5-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","bin","garbage","discard","cancel","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8711 6.80662L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11832C14.3822 5 14.1203 5 13.5963 5L10.4037 5C9.87973 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8.12892 6.80663C8.04486 6.93272 8 7.08087 8 7.23241C8 7.65634 8.34366 8 8.76759 8L15.2324 8C15.6563 8 16 7.65634 16 7.23241C16 7.08087 15.9551 6.93272 15.8711 6.80662Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.75 7C6.75 6.58579 6.41421 6.25 6 6.25C5.58579 6.25 5.25 6.58579 5.25 7H6.75ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25C17.5858 6.25 17.25 6.58579 17.25 7H18.75ZM6.58579 18.4142L7.11612 17.8839L7.11612 17.8839L6.58579 18.4142ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM6.75 15V7.00391H5.25V15H6.75ZM6.75 7.00391V7H5.25V7.00391H6.75ZM18.75 15V7.00391H17.25V15H18.75ZM18.75 7.00391V7H17.25V7.00391H18.75ZM14 18.25H10V19.75H14V18.25ZM17.25 15C17.25 15.964 17.2484 16.6116 17.1835 17.0946C17.1214 17.5561 17.0142 17.7536 16.8839 17.8839L17.9445 18.9445C18.4 18.4891 18.5857 17.9223 18.6701 17.2945C18.7516 16.6883 18.75 15.9216 18.75 15H17.25ZM14 19.75C14.9216 19.75 15.6883 19.7516 16.2945 19.6701C16.9223 19.5857 17.4891 19.4 17.9445 18.9445L16.8839 17.8839C16.7536 18.0142 16.5561 18.1214 16.0946 18.1835C15.6116 18.2484 14.964 18.25 14 18.25V19.75ZM5.25 15C5.25 15.9216 5.24841 16.6883 5.32991 17.2945C5.41432 17.9223 5.59999 18.4891 6.05546 18.9445L7.11612 17.8839C6.9858 17.7536 6.87858 17.5561 6.81654 17.0946C6.75159 16.6116 6.75 15.964 6.75 15H5.25ZM10 18.25C9.03599 18.25 8.38843 18.2484 7.90539 18.1835C7.44393 18.1214 7.24643 18.0142 7.11612 17.8839L6.05546 18.9445C6.51093 19.4 7.07773 19.5857 7.70552 19.6701C8.31174 19.7516 9.07839 19.75 10 19.75V18.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M9 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 5-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","cancel","void","discard","clear","empty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11832C14.3822 5 14.1203 5 13.5963 5L10.4037 5C9.87973 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 5-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","clear","erase","refund","refund item","delete order","remove item","cancel order","void transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.911 6.00391H16.5378L16.0741 5.30841C15.9448 5.11434 15.813 4.91649 15.6827 4.7558C15.5334 4.57143 15.3437 4.38037 15.0752 4.23666C14.8067 4.09295 14.5425 4.04115 14.3062 4.01912C14.1003 3.99992 13.8626 3.99996 13.6293 4L10.3707 4C10.1374 3.99996 9.89969 3.99992 9.69376 4.01912C9.45749 4.04115 9.19333 4.09295 8.9248 4.23666C8.65627 4.38037 8.46664 4.57143 8.31725 4.75581C8.18705 4.91649 8.05519 5.11436 7.92587 5.30842L7.46222 6.00391H6.089C6.05968 6.00132 6.02999 6 6 6C5.97001 6 5.94032 6.00132 5.911 6.00391H5C4.44772 6.00391 4 6.45162 4 7.00391C4 7.55619 4.44772 8.00391 5 8.00391L5 15.0658C4.99995 15.9523 4.9999 16.7161 5.08214 17.3278C5.17027 17.9833 5.36902 18.6117 5.87868 19.1213C6.38834 19.631 7.01669 19.8297 7.67221 19.9179C8.28386 20.0001 9.0477 20.0001 9.93417 20H14.0659C14.9523 20.0001 15.7161 20.0001 16.3278 19.9179C16.9833 19.8297 17.6117 19.631 18.1213 19.1213C18.631 18.6117 18.8297 17.9833 18.9179 17.3278C19.0001 16.7161 19.0001 15.9523 19 15.0658L19 8.00391C19.5523 8.00391 20 7.55619 20 7.00391C20 6.45162 19.5523 6.00391 19 6.00391H18.089C18.0597 6.00132 18.03 6 18 6C17.97 6 17.9403 6.00132 17.911 6.00391ZM9 11C9.55228 11 10 11.4477 10 12V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V12C8 11.4477 8.44772 11 9 11ZM12 11C12.5523 11 13 11.4477 13 12V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V12C11 11.4477 11.4477 11 12 11ZM16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 5": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","garbage","empty","void","clear","erase","refund","void-transaction","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7V15C6 16.8856 6 17.8284 6.58579 18.4142C7.17157 19 8.11438 19 10 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11832C14.3822 5 14.1203 5 13.5963 5L10.4037 5C9.87973 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 6-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","bin","garbage","discard","cancel","clear","erase","void","void-transaction","delete-item","remove-item","clear-cart","delete-order","remove-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2604 5.8906L15.9355 6.90331C15.9776 6.96636 16 7.04043 16 7.1162C16 7.32817 15.8282 7.5 15.6162 7.5H8.3838C8.17183 7.5 8 7.32817 8 7.1162C8 7.04043 8.02243 6.96636 8.06446 6.90331L8.7396 5.8906C9.03024 5.45463 9.17557 5.23665 9.39666 5.11833C9.61775 5 9.87974 5 10.4037 5H13.5963C14.1203 5 14.3822 5 14.6033 5.11833C14.8244 5.23665 14.9698 5.45463 15.2604 5.8906Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 6-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","bin","discard","cancel","void","erase","clear","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L17.3057 15.3322C17.1606 17.0731 17.088 17.9435 16.514 18.4718C15.9399 19 15.0664 19 13.3195 19H10.6805C8.9336 19 8.06013 19 7.48605 18.4718C6.91196 17.9435 6.83942 17.0731 6.69435 15.3322L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 6": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","erase","bin","waste","clear","void","refund","item-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7L17.3057 15.3322C17.1606 17.0731 17.088 17.9435 16.514 18.4718C15.9399 19 15.0664 19 13.3195 19H10.6805C8.9336 19 8.06013 19 7.48605 18.4718C6.91196 17.9435 6.83942 17.0731 6.69435 15.3322L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.2604 5.8906C14.9698 5.45463 14.8244 5.23665 14.6033 5.11833C14.3822 5 14.1203 5 13.5963 5H10.4037C9.87974 5 9.61775 5 9.39666 5.11833C9.17557 5.23665 9.03024 5.45463 8.7396 5.8906L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash 7-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","cancel","discard","clear","bin","erase","void","refund","remove-item","cancel-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 13L10 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 7-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","bin","discard","cancel","clear","void","garbage","recycle","empty","waste","uninstall","erase","unregister","trashcan","dustbin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M14 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 6-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","bin","recycle","clear","erase","trash-can"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.69376 4.01912C9.89969 3.99992 10.1374 3.99996 10.3707 4L13.6294 4C13.8626 3.99996 14.1003 3.99992 14.3062 4.01912C14.5425 4.04115 14.8067 4.09295 15.0752 4.23666C15.3437 4.38037 15.5334 4.57143 15.6827 4.7558C15.8129 4.91648 15.9448 5.11435 16.0741 5.3084L16.5378 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18.9201L18.2971 15.4774C18.229 16.2945 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2074C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79798 19.9998 9.08795 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2074C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H7.46222L7.92588 5.3084C8.05521 5.11434 8.18705 4.91649 8.31725 4.7558C8.46664 4.57143 8.65627 4.38037 8.9248 4.23666C9.19333 4.09294 9.45749 4.04115 9.69376 4.01912ZM11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V12ZM15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 7-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","garbage","bin","dustbin","waste","refund","return"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 7": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","clear","erase","refund","discount","void-transaction","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 8-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","discard","clear","void","cancel","erase","garbage","recycle","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 8-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","garbage","empty","clear","void","erase","refund","void-transaction","cancel-order","delete-item","remove-item","clear-cart"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.4472 5.65837L15.745 6.25396H16.9235L16.9378 6.25264C16.9852 6.24869 17.032 6.24924 17.0778 6.25396H19C19.4142 6.25396 19.75 6.58974 19.75 7.00396C19.75 7.41817 19.4142 7.75396 19 7.75396H17.8154L18.3909 14.6599V14.6599V14.66C18.4716 15.6272 18.5385 16.4304 18.5036 17.0699C18.4669 17.743 18.3135 18.3585 17.8501 18.8621C17.3867 19.3658 16.786 19.5698 16.1183 19.6622C15.4839 19.7501 14.6779 19.7501 13.7074 19.7501H10.2927C9.32211 19.7501 8.51606 19.7501 7.88165 19.6622C7.21397 19.5698 6.61335 19.3658 6.14992 18.8621C5.6865 18.3585 5.53308 17.743 5.49637 17.0699C5.46148 16.4304 5.52844 15.6271 5.60908 14.6599L6.18457 7.75396H5C4.58579 7.75396 4.25 7.41817 4.25 7.00396C4.25 6.58974 4.58579 6.25396 5 6.25396H6.92223C6.96797 6.24924 7.0148 6.24868 7.06229 6.25264L7.07647 6.25396H8.25499L8.55279 5.65837L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L11.1986 4.00001L11.2361 4.00001L12.7639 4.00001L12.8014 4L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.4472 5.65837ZM11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V12ZM15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash 8": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 9-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","discard","bin","garbage","cancel","void","clear","erase","recycle","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 16C17.3284 16 18 16.6716 18 17.5C18 18.3284 17.3284 19 16.5 19C15.6716 19 15 18.3284 15 17.5C15 17.1022 15.158 16.7206 15.4393 16.4393C15.7206 16.158 16.1022 16 16.5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L7.62895 15.3022C7.76184 17.0563 7.82828 17.9333 8.40356 18.4667C8.97883 19 9.8584 19 11.6175 19H16.5455M17 7V15.9992"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 9-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","bin","discard","clear","void","cancel","erase","empty","recycle","refund","void-transaction","cancel-order","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 7H7L7.62895 15.3022C7.76184 17.0563 7.82828 17.9333 8.40356 18.4667C8.97883 19 9.8584 19 11.6175 19H17V15.9992V7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6 6.25C5.58579 6.25 5.25 6.58579 5.25 7C5.25 7.41421 5.58579 7.75 6 7.75V6.25ZM18 7.75C18.4142 7.75 18.75 7.41421 18.75 7C18.75 6.58579 18.4142 6.25 18 6.25V7.75ZM7.62895 15.3022L6.88109 15.3588L7.62895 15.3022ZM17 19V19.75C17.4142 19.75 17.75 19.4142 17.75 19H17ZM6 7.75H7V6.25H6V7.75ZM7 7.75H17V6.25H7V7.75ZM17 7.75H18V6.25H17V7.75ZM8.37681 15.2455L7.74786 6.94334L6.25214 7.05666L6.88109 15.3588L8.37681 15.2455ZM17.75 15.9992V7H16.25V15.9992H17.75ZM6.88109 15.3588C6.946 16.2156 6.9987 16.9309 7.11609 17.495C7.23787 18.0802 7.44743 18.603 7.89365 19.0167L8.91346 17.9167C8.78441 17.797 8.67311 17.6146 8.58463 17.1894C8.49176 16.7431 8.44479 16.1428 8.37681 15.2455L6.88109 15.3588ZM11.6175 18.25C10.7176 18.25 10.1155 18.2485 9.66349 18.1896C9.23285 18.1335 9.04252 18.0363 8.91346 17.9167L7.89365 19.0167C8.33987 19.4303 8.87696 19.5998 9.4697 19.677C10.0411 19.7515 10.7583 19.75 11.6175 19.75V18.25ZM16.25 15.9992V19H17.75V15.9992H16.25ZM17 18.25H11.6175V19.75H17V18.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M11 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 16C17.3284 16 18 16.6716 18 17.5C18 18.3284 17.3284 19 16.5 19C15.6716 19 15 18.3284 15 17.5C15 17.1022 15.158 16.7206 15.4393 16.4393C15.7206 16.158 16.1022 16 16.5 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 8-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","void","discard","clear","erase","refund","undo","backspace","bin","garbage","recycle","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.0003 7.00391H6.99967L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17.0003 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.36102 14.6678L7.10842 14.7301L6.36102 14.6678ZM7.74741 7.06229C7.78181 6.64951 7.47507 6.28699 7.06229 6.25259C6.64951 6.21819 6.28699 6.52493 6.25259 6.93771L7.74741 7.06229ZM17.639 14.6678L16.8916 14.7301L17.639 14.6678ZM17.7474 6.93778C17.713 6.52499 17.3506 6.21822 16.9378 6.25259C16.525 6.28695 16.2182 6.64944 16.2526 7.06222L17.7474 6.93778ZM17.2982 18.3542L16.7463 17.8464L17.2982 18.3542ZM6.70183 18.3542L6.14992 18.8621L6.14992 18.8621L6.70183 18.3542ZM5 7.75391H6.99967V6.25391H5V7.75391ZM6.99967 7.75391H17.0003V6.25391H6.99967V7.75391ZM17.0003 7.75391H19V6.25391H17.0003V7.75391ZM7.10842 14.7301L7.74708 7.06619L6.25227 6.94162L5.61361 14.6055L7.10842 14.7301ZM7.74708 7.0662L7.74741 7.06229L6.25259 6.93771L6.25227 6.94161L7.74708 7.0662ZM18.3864 14.6055L17.7477 6.94162L16.2529 7.06619L16.8916 14.7301L18.3864 14.6055ZM17.7477 6.94168L17.7474 6.93778L16.2526 7.06222L16.2529 7.06613L17.7477 6.94168ZM13.6528 18.25H10.3472V19.75H13.6528V18.25ZM16.8916 14.7301C16.9779 15.7657 17.0344 16.4646 17.0059 16.9882C16.9785 17.4901 16.877 17.7043 16.7463 17.8464L17.8501 18.8621C18.3135 18.3584 18.4669 17.7429 18.5036 17.0699C18.5392 16.4184 18.469 15.597 18.3864 14.6055L16.8916 14.7301ZM13.6528 19.75C14.6478 19.75 15.4721 19.7517 16.1183 19.6622C16.786 19.5697 17.3867 19.3657 17.8501 18.8621L16.7463 17.8464C16.6155 17.9885 16.4105 18.1074 15.9125 18.1764C15.3932 18.2483 14.692 18.25 13.6528 18.25V19.75ZM5.61361 14.6055C5.53098 15.597 5.46083 16.4184 5.49637 17.0699C5.53308 17.7429 5.6865 18.3584 6.14992 18.8621L7.25375 17.8464C7.12297 17.7043 7.02152 17.4901 6.99414 16.9882C6.96558 16.4646 7.02213 15.7657 7.10842 14.7301L5.61361 14.6055ZM10.3472 18.25C9.30804 18.25 8.60679 18.2483 8.08745 18.1764C7.58953 18.1074 7.38453 17.9885 7.25375 17.8464L6.14992 18.8621C6.61335 19.3657 7.21397 19.5697 7.88165 19.6622C8.52792 19.7517 9.35225 19.75 10.3472 19.75V18.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M10 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 9": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","clear","erase","dustbin","waste","recycle","garbage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 16C17.3284 16 18 16.6716 18 17.5C18 18.3284 17.3284 19 16.5 19C15.6716 19 15 18.3284 15 17.5C15 17.1022 15.158 16.7206 15.4393 16.4393C15.7206 16.158 16.1022 16 16.5 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L7.62895 15.3022C7.76184 17.0563 7.82828 17.9333 8.40356 18.4667C8.97883 19 9.8584 19 11.6175 19H16.5455M17 7V15.9992"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 14V12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash 9-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","erase","clear","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.38197 6.00001H6C5.44772 6.00001 5 6.44773 5 7.00001C5 7.55229 5.44772 8.00001 6 8.00001H6.07289L6.63655 15.4403C6.69889 16.2638 6.75284 16.9765 6.87133 17.5459C6.99867 18.1578 7.2246 18.7373 7.72368 19.2C8.22277 19.6627 8.81765 19.8442 9.4374 19.925C10.0141 20.0001 10.7289 20.0001 11.5547 20L17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.2905 19.1411 15.2816 18 15.05V8.00001C18.5523 8.00001 19 7.55229 19 7.00001C19 6.44773 18.5523 6.00001 18 6.00001H15.618L15.4305 5.62485C15.3106 5.38506 15.1894 5.14248 15.0637 4.94493C14.9197 4.71862 14.7277 4.48061 14.4334 4.29871C14.1391 4.11681 13.8404 4.05157 13.5736 4.02398C13.3407 3.9999 13.0695 3.99995 12.8014 4L11.1986 4.00001C10.9305 3.99995 10.6593 3.9999 10.4264 4.02398C10.1596 4.05157 9.86089 4.11681 9.56657 4.29871C9.27225 4.48061 9.08031 4.71862 8.93631 4.94493C8.81061 5.14248 8.68938 5.38505 8.56954 5.62485L8.38197 6.00001ZM12 12C12 11.4477 11.5523 11 11 11C10.4477 11 10 11.4477 10 12V14C10 14.5523 10.4477 15 11 15C11.5523 15 12 14.5523 12 14V12ZM14 11C14.5523 11 15 11.4477 15 12V14C15 14.5523 14.5523 15 14 15C13.4477 15 13 14.5523 13 14V12C13 11.4477 13.4477 11 14 11ZM17.5 18.5C18.0523 18.5 18.5 18.0523 18.5 17.5C18.5 16.9477 18.0523 16.5 17.5 16.5C16.9477 16.5 16.5 16.9477 16.5 17.5C16.5 18.0523 16.9477 18.5 17.5 18.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","delete","remove","cancel","void","clear","discard","recycle","garbage","empty","erase","dustbin","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6L5.73464 16.285C5.86047 18.0466 5.92339 18.9275 6.49933 19.4637C7.07528 20 7.95835 20 9.72448 20H14.2755C16.0417 20 16.9247 20 17.5007 19.4637C18.0766 18.9275 18.1395 18.0466 18.2654 16.285L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 6L15.7029 5.25722C15.4593 4.64832 15.3375 4.34387 15.0836 4.17193C14.8296 4 14.5017 4 13.8459 4L10.1541 4C9.49826 4 9.17035 4 8.9164 4.17193C8.66245 4.34387 8.54067 4.64832 8.29711 5.25722L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 6H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","clear","erase","garbage","recycle","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 5.00001H16.677L16.6163 4.84828C16.5077 4.57652 16.3984 4.30322 16.2795 4.08019C16.1435 3.82509 15.9542 3.55375 15.6442 3.34388C15.3342 3.134 15.012 3.05904 14.7246 3.02748C14.4734 2.99989 14.179 2.99995 13.8864 3.00001L10.1136 3.00001C9.82093 2.99995 9.5266 2.99989 9.27537 3.02748C8.988 3.05904 8.66577 3.134 8.35577 3.34388C8.04578 3.55375 7.85651 3.82509 7.72048 4.08019C7.60156 4.30321 7.4923 4.57651 7.38366 4.84826L7.32297 5.00001H4C3.44772 5.00001 3 5.44773 3 6.00001C3 6.5523 3.44772 7.00001 4 7.00001H4.06888L4.74166 16.419C4.8007 17.2461 4.85178 17.9618 4.96835 18.5336C5.09361 19.148 5.31814 19.7303 5.81788 20.1956C6.31762 20.6609 6.91438 20.8434 7.53615 20.9246C8.11481 21.0001 8.83232 21.0001 9.66152 21H9.66155H14.3385H14.3385C15.1677 21.0001 15.8852 21.0001 16.4639 20.9246C17.0856 20.8434 17.6824 20.6609 18.1821 20.1956C18.6819 19.7303 18.9064 19.148 19.0317 18.5336C19.1482 17.9618 19.1993 17.2461 19.2583 16.419L19.9311 7.00001H20C20.5523 7.00001 21 6.5523 21 6.00001C21 5.44773 20.5523 5.00001 20 5.00001ZM15 12C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H9C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H15ZM14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H10C9.44771 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash line": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","void","discard","garbage","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6L5.73464 16.285C5.86047 18.0466 5.92339 18.9275 6.49933 19.4637C7.07528 20 7.95835 20 9.72448 20H14.2755C16.0417 20 16.9247 20 17.5007 19.4637C18.0766 18.9275 18.1395 18.0466 18.2654 16.285L19 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 6L15.7029 5.25722C15.4593 4.64832 15.3375 4.34387 15.0836 4.17193C14.8296 4 14.5017 4 13.8459 4L10.1541 4C9.49826 4 9.17035 4 8.9164 4.17193C8.66245 4.34387 8.54067 4.64832 8.29711 5.25722L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M20 6H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","bin","done","completed","confirmed","approved","order-complete","refund-processed","transaction-complete","void-complete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash tick-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","checkmark","confirm","approved-deletion","confirmed-deletion","validated-deletion","ok-delete","ok-remove","trash-tick"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","delete","remove","cancel","void","discard","clear","erase","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.29711 5.25722L8.02999 5.92503C8.01018 5.97455 8 6.0274 8 6.08074C8 6.31229 8.18771 6.5 8.41926 6.5L15.5807 6.5C15.8123 6.5 16 6.31229 16 6.08074C16 6.0274 15.9898 5.97456 15.97 5.92503L15.7029 5.25722C15.4593 4.64832 15.3375 4.34387 15.0836 4.17193C14.8296 4 14.5017 4 13.8459 4L10.1541 4C9.49826 4 9.17035 4 8.9164 4.17193C8.66245 4.34386 8.54067 4.64832 8.29711 5.25722Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18.2654 16.285L19 6H5L5.73464 16.285C5.86047 18.0466 5.92339 18.9275 6.49933 19.4637C7.07528 20 7.95835 20 9.72448 20H14.2755C16.0417 20 16.9247 20 17.5007 19.4637C18.0766 18.9275 18.1395 18.0466 18.2654 16.285Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M18.2654 16.285L19.0135 16.3384L18.2654 16.285ZM6.49933 19.4637L7.01042 18.9148V18.9148L6.49933 19.4637ZM17.5007 19.4637L16.9896 18.9148L16.9896 18.9148L17.5007 19.4637ZM20 6.75C20.4142 6.75 20.75 6.41421 20.75 6C20.75 5.58579 20.4142 5.25 20 5.25V6.75ZM4 5.25C3.58579 5.25 3.25 5.58579 3.25 6C3.25 6.41421 3.58579 6.75 4 6.75V5.25ZM18.2519 5.94656L17.5173 16.2316L19.0135 16.3384L19.7481 6.05344L18.2519 5.94656ZM14.2755 19.25H9.72448V20.75H14.2755V19.25ZM6.48274 16.2316L5.74809 5.94656L4.25191 6.05344L4.98655 16.3384L6.48274 16.2316ZM9.72448 19.25C8.82103 19.25 8.21639 19.2485 7.76267 19.1893C7.33032 19.1328 7.13957 19.0351 7.01042 18.9148L5.98825 20.0126C6.43505 20.4286 6.9738 20.599 7.56851 20.6767C8.14183 20.7515 8.8618 20.75 9.72448 20.75V19.25ZM4.98655 16.3384C5.04801 17.1989 5.09781 17.9172 5.21331 18.4837C5.33312 19.0714 5.54145 19.5966 5.98825 20.0126L7.01042 18.9148C6.88128 18.7946 6.77018 18.6113 6.68308 18.1841C6.59168 17.7357 6.5471 17.1327 6.48274 16.2316L4.98655 16.3384ZM17.5173 16.2316C17.4529 17.1327 17.4083 17.7357 17.3169 18.1841C17.2298 18.6113 17.1187 18.7946 16.9896 18.9148L18.0118 20.0126C18.4586 19.5966 18.6669 19.0714 18.7867 18.4837C18.9022 17.9172 18.952 17.1989 19.0135 16.3384L17.5173 16.2316ZM14.2755 20.75C15.1382 20.75 15.8582 20.7515 16.4315 20.6767C17.0262 20.599 17.565 20.4286 18.0118 20.0126L16.9896 18.9148C16.8604 19.0351 16.6697 19.1328 16.2373 19.1893C15.7836 19.2485 15.179 19.25 14.2755 19.25V20.75ZM20 5.25H19V6.75H20V5.25ZM19 5.25H5V6.75H19V5.25ZM5 5.25H4V6.75H5V5.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M9 11L15 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 15L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","discard","confirm-delete","confirmation","approved-delete","recycle","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L11 14L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","discard","done","confirm-delete","approved-delete","completed-delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392ZM14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L11 12.5858L10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L14.7071 11.7071Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","bin","garbage","discard","cancel","clear","void","trash-item","delete-item","remove-item","discard-item","cancel-item","clear-item","void-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M10.0008 4.25C9.58656 4.24957 9.25043 4.58501 9.25 4.99922C9.24957 5.41344 9.58501 5.74957 9.99922 5.75L10.0008 4.25ZM13.9992 5.75414C14.4134 5.75457 14.7496 5.41913 14.75 5.00491C14.7504 4.5907 14.415 4.25457 14.0008 4.25414L13.9992 5.75414ZM9.99922 5.75L13.9992 5.75414L14.0008 4.25414L10.0008 4.25L9.99922 5.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","recycle","clear","erase","trash-order","delete-order","remove-item","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-can-list-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","item","discard","clear","list","remove-item","delete-item","discard-item","clear-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8L15.3307 15.3621C15.1737 17.0898 15.0951 17.9537 14.5222 18.4768C13.9494 19 13.082 19 11.3471 19H8.65286C6.91804 19 6.05062 19 5.47775 18.4768C4.90488 17.9537 4.82635 17.0898 4.66929 15.3621L4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11V15M12 11V15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10H21"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 13L18 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 5L12 5.00414M17 7.00391H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","discard","clear","void","order","item","transaction","refund","sales","erase","waste","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6.00391C4.44772 6.00391 4 6.45162 4 7.00391C4 7.55619 4.44772 8.00391 5 8.00391H5.07989L5.70289 15.4774C5.77097 16.2945 5.82991 17.0021 5.95172 17.5673C6.08266 18.1747 6.311 18.7493 6.80892 19.2074C7.30683 19.6656 7.89842 19.8454 8.51465 19.9254C9.08795 19.9999 9.79798 19.9998 10.618 19.9998H13.382C14.202 19.9998 14.9121 19.9999 15.4854 19.9254C16.1016 19.8454 16.6932 19.6656 17.1911 19.2074C17.689 18.7493 17.9173 18.1747 18.0483 17.5673C18.1701 17.0021 18.229 16.2945 18.2971 15.4774L18.9201 8.00391H19C19.5523 8.00391 20 7.55619 20 7.00391C20 6.45162 19.5523 6.00391 19 6.00391H5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.99897C9.00057 3.44668 9.44875 2.99943 10.001 3L14.001 3.00414C14.5533 3.00471 15.0006 3.45289 15 4.00517C14.9994 4.55746 14.5513 5.00471 13.999 5.00414L9.99897 5C9.44668 4.99943 8.99943 4.55125 9 3.99897Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-can-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","list","order","item","remove-item","void-order","clear","garbage","bin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 7.00391C2 6.45162 2.44772 6.00391 3 6.00391H17C17.5523 6.00391 18 6.45162 18 7.00391C18 7.55619 17.5523 8.00391 17 8.00391H16.9201L16.2971 15.4773C16.229 16.2945 16.1701 17.0021 16.0483 17.5673C15.9173 18.1747 15.689 18.7493 15.1911 19.2074C14.6932 19.6656 14.1016 19.8454 13.4854 19.9254C12.9121 19.9999 12.202 19.9998 11.382 19.9998H8.61801C7.79798 19.9998 7.08795 19.9999 6.51465 19.9254C5.89842 19.8454 5.30683 19.6656 4.80892 19.2074C4.311 18.7493 4.08266 18.1747 3.95172 17.5673C3.82991 17.0021 3.77097 16.2945 3.70289 15.4774L3.07989 8.00391H3C2.44772 8.00391 2 7.55619 2 7.00391ZM9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11V15C7 15.5523 7.44772 16 8 16C8.55228 16 9 15.5523 9 15V11ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 10C18 9.44772 18.4477 9 19 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H19C18.4477 11 18 10.5523 18 10ZM18 13C18 12.4477 18.4477 12 19 12H20C20.5523 12 21 12.4477 21 13C21 13.5523 20.5523 14 20 14H19C18.4477 14 18 13.5523 18 13ZM18 16C18 15.4477 18.4477 15 19 15H19.5C20.0523 15 20.5 15.4477 20.5 16C20.5 16.5523 20.0523 17 19.5 17H19C18.4477 17 18 16.5523 18 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 4.49897C7.00057 3.94668 7.44875 3.49943 8.00103 3.5L12.001 3.50414C12.5533 3.50471 13.0006 3.95289 13 4.50517C12.9994 5.05746 12.5513 5.50471 11.999 5.50414L7.99897 5.5C7.44668 5.49943 6.99943 5.05125 7 4.49897Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-can-list-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","item","void","discard","clear","cancel","trash-can","list","delete-list","remove-list","void-list","discard-list","clear-list","cancel-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7.00391H4L4.69425 15.3321C4.83937 17.0729 4.91193 17.9433 5.48602 18.4716C6.0601 18.9998 6.93354 18.9998 8.68043 18.9998H11.3196C13.0665 18.9998 13.9399 18.9998 14.514 18.4716C15.0881 17.9433 15.1606 17.0729 15.3057 15.3321L16 7.00391Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M3 6.25391C2.58579 6.25391 2.25 6.58969 2.25 7.00391C2.25 7.41812 2.58579 7.75391 3 7.75391V6.25391ZM17 7.75391C17.4142 7.75391 17.75 7.41812 17.75 7.00391C17.75 6.58969 17.4142 6.25391 17 6.25391V7.75391ZM4.69425 15.3321L3.94685 15.3944L4.69425 15.3321ZM15.3057 15.3321L14.5583 15.2698L15.3057 15.3321ZM14.514 18.4716L14.0062 17.9196L14.514 18.4716ZM5.48602 18.4716L5.99384 17.9196H5.99384L5.48602 18.4716ZM3 7.75391H4V6.25391H3V7.75391ZM4 7.75391H16V6.25391H4V7.75391ZM16 7.75391H17V6.25391H16V7.75391ZM5.44166 15.2698L4.74741 6.9416L3.25259 7.06621L3.94685 15.3944L5.44166 15.2698ZM16.0532 15.3944L16.7474 7.06621L15.2526 6.9416L14.5583 15.2698L16.0532 15.3944ZM11.3196 18.2498H8.68043V19.7498H11.3196V18.2498ZM14.5583 15.2698C14.4841 16.1604 14.433 16.7559 14.3376 17.1985C14.2467 17.6201 14.135 17.801 14.0062 17.9196L15.0218 19.0235C15.467 18.6138 15.6787 18.0955 15.8039 17.5146C15.9246 16.9547 15.9823 16.2446 16.0532 15.3944L14.5583 15.2698ZM11.3196 19.7498C12.1728 19.7498 12.8852 19.7512 13.4532 19.6775C14.0425 19.601 14.5766 19.4331 15.0218 19.0235L14.0062 17.9196C13.8773 18.0382 13.6877 18.1345 13.26 18.19C12.811 18.2483 12.2133 18.2498 11.3196 18.2498V19.7498ZM3.94685 15.3944C4.01772 16.2446 4.07543 16.9547 4.19611 17.5146C4.32132 18.0955 4.53299 18.6138 4.97819 19.0235L5.99384 17.9196C5.86495 17.801 5.75331 17.6201 5.66244 17.1985C5.56703 16.7559 5.5159 16.1604 5.44166 15.2698L3.94685 15.3944ZM8.68043 18.2498C7.78674 18.2498 7.18899 18.2483 6.74 18.19C6.31232 18.1345 6.12272 18.0382 5.99384 17.9196L4.97819 19.0235C5.42339 19.4331 5.95755 19.601 6.54684 19.6775C7.11481 19.7512 7.82723 19.7498 8.68043 19.7498V18.2498Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M8 11V15M12 11V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10H21"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 13L18 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 5L12 5.00414"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-circle-1": {
        defaultColors: ["#2797e8", "#3d4c66", "#000000"],
        keywords: ["trash","delete","remove","cancel","void","refund","item removal","order cancellation","transaction void","clear","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.4564 15.3416C17.3076 17.0784 17.2331 17.9467 16.6594 18.4734C16.0857 19 15.2142 19 13.471 19H10.529C8.78584 19 7.91428 19 7.34057 18.4734C6.76686 17.9467 6.69243 17.0784 6.54357 15.3416L6 9"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 7L6 7.75L6 7ZM18 7V6.25V7ZM6 9V8.25H6L6 9ZM18 9V9.75V9ZM5 8H4.25H5ZM19 8L18.25 8L19 8ZM8 9.75C8.41421 9.75 8.75 9.41421 8.75 9C8.75 8.58579 8.41421 8.25 8 8.25V9.75ZM16 8.25C15.5858 8.25 15.25 8.58579 15.25 9C15.25 9.41421 15.5858 9.75 16 9.75V8.25ZM6 7.75L18 7.75V6.25L6 6.25L6 7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75L6 8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8L18.25 8ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8L19.75 8C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75L6 6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-circle-2": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#000000"],
        keywords: ["take-out","container","food","drink","to-go","order","cup"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.6398 15.398L6 9H18L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9L8 9L16 9H18C18.5523 9 19 8.55228 19 8C19 7.44771 18.5523 7 18 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M6 9V8.25V9ZM8 9V9.75V9ZM16 9V8.25V9ZM6 7.75H18V6.25H6V7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75V8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8H18.25ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8H19.75C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75V6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25ZM16 8.25L8 8.25V9.75L16 9.75V8.25Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path
                    d="M15 7L14.8944 6.78885C14.3463 5.69253 13.2257 5 12 5C10.7743 5 9.65374 5.69253 9.10557 6.78885L9 7H15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.8944 6.78885L14.2236 7.12426V7.12426L14.8944 6.78885ZM15 7V7.75H16.2135L15.6708 6.66459L15 7ZM9 7L8.32918 6.66459C8.21293 6.89708 8.22536 7.17319 8.36201 7.3943C8.49867 7.61541 8.74007 7.75 9 7.75V7ZM9.10557 6.78885L8.43475 6.45344V6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9 7.75H15V6.25H9V7.75ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash-circle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","erase","void","clear","item","order","transaction","recycle","bin","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.40211 6C9.1698 4.76417 10.5269 4 12 4C13.4731 4 14.8302 4.76417 15.5979 6H18C19.1046 6 20 6.89543 20 8C20 8.76972 19.5652 9.43789 18.9278 9.77225L18.3491 15.5589C18.2688 16.3623 18.1992 17.0586 18.0703 17.6144C17.9318 18.2121 17.6983 18.7761 17.203 19.2244C16.7077 19.6726 16.1233 19.8487 15.5147 19.9272C14.9489 20.0001 14.2492 20 13.4418 20H10.5582C9.75084 20 9.05112 20.0001 8.48525 19.9272C7.87669 19.8487 7.29225 19.6726 6.79696 19.2244C6.30167 18.7761 6.06825 18.2121 5.92965 17.6144C5.80078 17.0586 5.7312 16.3623 5.65091 15.559L5.07224 9.77225C4.43483 9.43789 4 8.76972 4 8C4 6.89543 4.89543 6 6 6H8.40211ZM12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-can-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","trash-can","delete","remove","cancel","discard","void","item","order","line-item","clear","reset"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8L15.3307 15.3621C15.1737 17.0898 15.0951 17.9537 14.5222 18.4768C13.9494 19 13.082 19 11.3471 19H8.65286C6.91804 19 6.05062 19 5.47775 18.4768C4.90488 17.9537 4.82635 17.0898 4.66929 15.3621L4 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 11V15M12 11V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10H21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 16H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 13L18 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 5L12 5.00414M17 7.00391H3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","cancel","void","discard","erase","clear","refund","item-removal","order-cancellation","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15M10 15L14 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.894 6.78901C14.3459 5.6926 13.2253 5 11.9995 5C10.7737 5 9.6531 5.6926 9.105 6.78901L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","void","trash-can","bin","erase","clear","refund","void-transaction","delete-item","remove-item","cancel-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.0003 7.00391H6.99967L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17.0003 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.36102 14.6678L7.10842 14.7301L6.36102 14.6678ZM7.74741 7.06229C7.78181 6.64951 7.47507 6.28699 7.06229 6.25259C6.64951 6.21819 6.28699 6.52493 6.25259 6.93771L7.74741 7.06229ZM17.639 14.6678L16.8916 14.7301L17.639 14.6678ZM17.7474 6.93778C17.713 6.52499 17.3506 6.21822 16.9378 6.25259C16.525 6.28695 16.2182 6.64944 16.2526 7.06222L17.7474 6.93778ZM17.2982 18.3542L16.7463 17.8464L17.2982 18.3542ZM6.70183 18.3542L6.14992 18.8621L6.14992 18.8621L6.70183 18.3542ZM5 7.75391H6.99967V6.25391H5V7.75391ZM6.99967 7.75391H17.0003V6.25391H6.99967V7.75391ZM17.0003 7.75391H19V6.25391H17.0003V7.75391ZM7.10842 14.7301L7.74708 7.06619L6.25227 6.94162L5.61361 14.6055L7.10842 14.7301ZM7.74708 7.0662L7.74741 7.06229L6.25259 6.93771L6.25227 6.94161L7.74708 7.0662ZM18.3864 14.6055L17.7477 6.94162L16.2529 7.06619L16.8916 14.7301L18.3864 14.6055ZM17.7477 6.94168L17.7474 6.93778L16.2526 7.06222L16.2529 7.06613L17.7477 6.94168ZM13.6528 18.25H10.3472V19.75H13.6528V18.25ZM16.8916 14.7301C16.9779 15.7657 17.0344 16.4646 17.0059 16.9882C16.9785 17.4901 16.877 17.7043 16.7463 17.8464L17.8501 18.8621C18.3135 18.3584 18.4669 17.7429 18.5036 17.0699C18.5392 16.4184 18.469 15.597 18.3864 14.6055L16.8916 14.7301ZM13.6528 19.75C14.6478 19.75 15.4721 19.7517 16.1183 19.6622C16.786 19.5697 17.3867 19.3657 17.8501 18.8621L16.7463 17.8464C16.6155 17.9885 16.4105 18.1074 15.9125 18.1764C15.3932 18.2483 14.692 18.25 13.6528 18.25V19.75ZM5.61361 14.6055C5.53098 15.597 5.46083 16.4184 5.49637 17.0699C5.53308 17.7429 5.6865 18.3584 6.14992 18.8621L7.25375 17.8464C7.12297 17.7043 7.02152 17.4901 6.99414 16.9882C6.96558 16.4646 7.02213 15.7657 7.10842 14.7301L5.61361 14.6055ZM10.3472 18.25C9.30804 18.25 8.60679 18.2483 8.08745 18.1764C7.58953 18.1074 7.38453 17.9885 7.25375 17.8464L6.14992 18.8621C6.61335 19.3657 7.21397 19.5697 7.88165 19.6622C8.52792 19.7517 9.35225 19.75 10.3472 19.75V18.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 11L12 13M12 13L10 15M12 13L14 11M12 13L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-circle": {
        defaultColors: ["#3d4c66", "#000000"],
        keywords: ["circle","ring","void","empty","reset","clear","remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6 7.75L6 7ZM18 7V6.25V7ZM6 9V8.25H6L6 9ZM18 9V9.75V9ZM5 8H4.25H5ZM19 8L18.25 8L19 8ZM8 9.75C8.41421 9.75 8.75 9.41421 8.75 9C8.75 8.58579 8.41421 8.25 8 8.25V9.75ZM16 8.25C15.5858 8.25 15.25 8.58579 15.25 9C15.25 9.41421 15.5858 9.75 16 9.75V8.25ZM6 7.75L18 7.75V6.25L6 6.25L6 7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75L6 8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8L18.25 8ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8L19.75 8C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75L6 6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M18 9L17.4564 15.3416C17.3076 17.0784 17.2331 17.9467 16.6594 18.4734C16.0857 19 15.2142 19 13.471 19H10.529C8.78584 19 7.91428 19 7.34057 18.4734C6.76686 17.9467 6.69243 17.0784 6.54357 15.3416L6 9"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[1] || "#000000"}
                />
                <path
                    d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Trash-Cross-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","item","order","discount","refund","transaction","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.0883 6.00397H8.37998L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00397H16.9117L16.917 6.00351C16.9757 5.99863 17.0335 5.99891 17.0902 6.00397H19C19.5523 6.00397 20 6.45169 20 7.00397C20 7.55626 19.5523 8.00397 19 8.00397H18.0871L18.6413 14.6538C18.7209 15.6084 18.7891 16.4265 18.7533 17.0835C18.715 17.7851 18.5529 18.4675 18.034 19.0314C17.5152 19.5953 16.8486 19.8135 16.1526 19.9099C15.5009 20.0002 14.6799 20.0001 13.7219 20.0001H10.2781C9.32014 20.0001 8.49914 20.0002 7.84736 19.9099C7.15137 19.8135 6.48482 19.5953 5.96595 19.0314C5.44709 18.4675 5.285 17.7851 5.24674 17.0835C5.2109 16.4265 5.27912 15.6083 5.35872 14.6537L5.91287 8.00397H5C4.44772 8.00397 4 7.55626 4 7.00397C4 6.45169 4.44772 6.00397 5 6.00397H6.90985C6.96652 5.99891 7.02441 5.99863 7.08306 6.00352L7.0883 6.00397ZM10.7071 10.2929C10.3166 9.90237 9.68342 9.90237 9.29289 10.2929C8.90237 10.6834 8.90237 11.3166 9.29289 11.7071L10.5858 13L9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L12 14.4142L13.2929 15.7071C13.6834 16.0976 14.3166 16.0976 14.7071 15.7071C15.0976 15.3166 15.0976 14.6834 14.7071 14.2929L13.4142 13L14.7071 11.7071C15.0976 11.3166 15.0976 10.6834 14.7071 10.2929C14.3166 9.90237 13.6834 9.90237 13.2929 10.2929L12 11.5858L10.7071 10.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-Cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","clear","void","delete-order","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.1213 18.1213C16.2426 19 14.8284 19 12 19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V7H18V13C18 15.8284 18 17.2426 17.1213 18.1213Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M17.1213 18.1213L17.6517 18.6517L17.6517 18.6517L17.1213 18.1213ZM6.87868 18.1213L6.34835 18.6517L6.34835 18.6517L6.87868 18.1213ZM18 7H18.75C18.75 6.58579 18.4142 6.25 18 6.25V7ZM6 7V6.25C5.58579 6.25 5.25 6.58579 5.25 7H6ZM12 19.75C13.393 19.75 14.5132 19.7516 15.3918 19.6335C16.2919 19.5125 17.0497 19.2536 17.6517 18.6517L16.591 17.591C16.3142 17.8678 15.9257 18.0482 15.1919 18.1469C14.4365 18.2484 13.4354 18.25 12 18.25V19.75ZM17.25 13C17.25 14.4354 17.2484 15.4365 17.1469 16.1919C17.0482 16.9257 16.8678 17.3142 16.591 17.591L17.6517 18.6517C18.2536 18.0497 18.5125 17.2919 18.6335 16.3918C18.7516 15.5132 18.75 14.393 18.75 13H17.25ZM5.25 13C5.25 14.393 5.24841 15.5132 5.36652 16.3918C5.48754 17.2919 5.74643 18.0497 6.34835 18.6517L7.40901 17.591C7.13225 17.3142 6.9518 16.9257 6.85315 16.1919C6.75159 15.4365 6.75 14.4354 6.75 13H5.25ZM12 18.25C10.5646 18.25 9.56347 18.2484 8.80812 18.1469C8.07434 18.0482 7.68577 17.8678 7.40901 17.591L6.34835 18.6517C6.95027 19.2536 7.70814 19.5125 8.60825 19.6335C9.48678 19.7516 10.607 19.75 12 19.75V18.25ZM18.75 13V7H17.25V13H18.75ZM6 7.75H18V6.25H6V7.75ZM5.25 7V13H6.75V7H5.25Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14.894 6.78901L15 7H9L9.105 6.78901C9.6531 5.6926 10.7737 5 11.9995 5C13.2253 5 14.3459 5.6926 14.894 6.78901Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15M10 15L14 11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M19 7H18L6 7L5 7" fill={colors?.[1] || "#3D4C66"} />
                <path
                    d="M19 7H18L6 7L5 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","clear","erase","bin","garbage","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.75 9.25L5.25 9.25V13.0549C5.24998 14.4224 5.24997 15.5248 5.36653 16.3918C5.48754 17.2919 5.74644 18.0497 6.34835 18.6517C6.95027 19.2536 7.70814 19.5125 8.60825 19.6335C9.47521 19.75 10.5775 19.75 11.9451 19.75H12.0549C13.4225 19.75 14.5248 19.75 15.3918 19.6335C16.2919 19.5125 17.0497 19.2536 17.6517 18.6517C18.2536 18.0497 18.5125 17.2919 18.6335 16.3918C18.75 15.5248 18.75 14.4225 18.75 13.0549V9.25ZM9.79289 11.7929C10.1834 11.4024 10.8166 11.4024 11.2071 11.7929L12 12.5858L12.7929 11.7929C13.1834 11.4024 13.8166 11.4024 14.2071 11.7929C14.5976 12.1834 14.5976 12.8166 14.2071 13.2071L13.4142 14L14.2071 14.7929C14.5976 15.1834 14.5976 15.8166 14.2071 16.2071C13.8166 16.5976 13.1834 16.5976 12.7929 16.2071L12 15.4142L11.2071 16.2071C10.8166 16.5976 10.1834 16.5976 9.79289 16.2071C9.40237 15.8166 9.40237 15.1834 9.79289 14.7929L10.5858 14L9.79289 13.2071C9.40237 12.8166 9.40237 12.1834 9.79289 11.7929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.40161 6C9.16927 4.76417 10.5263 4 11.9995 4C13.4727 4 14.8297 4.76417 15.5974 6L19 6C19.5523 6 20 6.44772 20 7C20 7.55229 19.5523 8 19 8L5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6L8.40161 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-Cross-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","clear","void","refund","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","delete","remove","cancel","void","discard","item-removal","order-cancellation","item","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","erase","item-remove","order-remove","item-delete","order-delete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485ZM14.7071 10.2929C15.0976 10.6834 15.0976 11.3166 14.7071 11.7071L13.4142 13L14.7071 14.2929C15.0976 14.6834 15.0976 15.3166 14.7071 15.7071C14.3166 16.0976 13.6834 16.0976 13.2929 15.7071L12 14.4142L10.7071 15.7071C10.3166 16.0976 9.68342 16.0976 9.29289 15.7071C8.90237 15.3166 8.90237 14.6834 9.29289 14.2929L10.5858 13L9.29289 11.7071C8.90237 11.3166 8.90237 10.6834 9.29289 10.2929C9.68342 9.90237 10.3166 9.90237 10.7071 10.2929L12 11.5858L13.2929 10.2929C13.6834 9.90237 14.3166 9.90237 14.7071 10.2929Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-Cross-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","clear","void","item-removal","order-cancellation","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L12 13M12 13L10 15M12 13L14 11M12 13L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","void","discard","bin","erase","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M14 11L10 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-Cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","cancel","discard","bin","clear","empty","void","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 7V13C18 15.8284 18 17.2426 17.1213 18.1213C16.2426 19 14.8284 19 12 19V19C9.17157 19 7.75736 19 6.87868 18.1213C6 17.2426 6 15.8284 6 13V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 11L14 15M10 15L14 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7L5 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.894 6.78901C14.3459 5.6926 13.2253 5 11.9995 5C10.7737 5 9.6531 5.6926 9.105 6.78901L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-double-line-1": {
        defaultColors: ["#2797e8", "#000000"],
        keywords: ["trash","delete","remove","bin","garbage","discard","cancel","clear","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8L9.5315 6.67126C9.93525 5.66187 10.9129 5 12 5V5C13.0871 5 14.0648 5.66187 14.4685 6.67126L15 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 8.00391H19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18 8L17.4303 15.3107C17.2939 17.0611 17.2257 17.9362 16.6508 18.4681C16.0759 19 15.1981 19 13.4424 19H10.5576C8.80195 19 7.92413 19 7.34919 18.4681C6.77425 17.9362 6.70606 17.0611 6.56967 15.3107L6 8"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 15V12M10 15V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-double-line-10": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#000000"],
        keywords: ["trash","bin","delete","remove","clear","cancel","discard","waste","recycle","empty","garbage","rubbish","dustbin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.6398 15.398L6 9H18L17.3602 15.398C17.189 17.1099 17.1034 17.9658 16.532 18.4829C15.9607 19 15.1005 19 13.38 19H10.62C8.89955 19 8.03935 19 7.46796 18.4829C6.89658 17.9658 6.81099 17.1099 6.6398 15.398Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7H6C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9L8 9L16 9H18C18.5523 9 19 8.55228 19 8C19 7.44771 18.5523 7 18 7Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M6 9V8.25V9ZM8 9V9.75V9ZM16 9V8.25V9ZM6 7.75H18V6.25H6V7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75V8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8H18.25ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8H19.75C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75V6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25ZM16 8.25L8 8.25V9.75L16 9.75V8.25Z"
                    fill={colors?.[2] || "#000000"}
                />
                <path d="M14 15V13M10 15V13" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M15 7L14.8944 6.78885C14.3463 5.69253 13.2257 5 12 5C10.7743 5 9.65374 5.69253 9.10557 6.78885L9 7H15Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14.8944 6.78885L14.2236 7.12426V7.12426L14.8944 6.78885ZM15 7V7.75H16.2135L15.6708 6.66459L15 7ZM9 7L8.32918 6.66459C8.21293 6.89708 8.22536 7.17319 8.36201 7.3943C8.49867 7.61541 8.74007 7.75 9 7.75V7ZM9.10557 6.78885L8.43475 6.45344V6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9 7.75H15V6.25H9V7.75ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-Cross-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","delete","remove","cancel","void","cross","discard","bin","garbage","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 11L12 13M12 13L10 15M12 13L14 11M12 13L14 15"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 7L6.36102 14.6678C6.19209 16.6949 6.10763 17.7084 6.70183 18.3542C7.29604 19 8.31309 19 10.3472 19H13.6528C15.6869 19 16.704 19 17.2982 18.3542C17.8924 17.7084 17.8079 16.6949 17.639 14.6678L17 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-double-line-2": {
        defaultColors: ["#d9d1e0", "#3d4c66", "#000000"],
        keywords: ["trash","delete","remove","discard","void","cancel","clear","erase","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.66929 15.3621L6 8H18L17.3307 15.3621C17.1737 17.0898 17.0951 17.9537 16.5222 18.4768C15.9494 19 15.082 19 13.3471 19H10.6529C8.91804 19 8.05062 19 7.47775 18.4768C6.90488 17.9537 6.82635 17.0898 6.66929 15.3621Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.5315 6.67126L9 8H15L14.4685 6.67126C14.0648 5.66187 13.0871 5 12 5C10.9129 5 9.93525 5.66187 9.5315 6.67126Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M9.5315 6.67126L9 8H15L14.4685 6.67126C14.0648 5.66187 13.0871 5 12 5C10.9129 5 9.93525 5.66187 9.5315 6.67126Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 8.00391H19" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 15V12M10 15V12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "Trash-double-line-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","cancel","void","clear","bin","recycle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 6H15.5979C14.8302 4.76417 13.4731 4 12 4C10.5269 4 9.1698 4.76417 8.40211 6H6C4.89543 6 4 6.89543 4 8C4 8.76973 4.43483 9.43789 5.07224 9.77226L5.65091 15.559C5.7312 16.3623 5.80078 17.0586 5.92966 17.6144C6.06825 18.2121 6.30167 18.7761 6.79696 19.2244C7.29226 19.6726 7.8767 19.8487 8.48526 19.9272C9.05112 20.0001 9.75085 20 10.5582 20H13.4418C14.2492 20 14.9489 20.0001 15.5148 19.9272C16.1233 19.8487 16.7078 19.6726 17.203 19.2244C17.6983 18.7761 17.9318 18.2121 18.0704 17.6144C18.1992 17.0586 18.2688 16.3623 18.3491 15.5589L18.9278 9.77225C19.5652 9.43788 20 8.76972 20 8C20 6.89543 19.1046 6 18 6ZM11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V13ZM15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-double-line-4": {
        defaultColors: ["#000000"],
        keywords: ["trash","delete","remove","cancel","discard","bin","empty","garbage","clear","void","erase"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.00391H19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18 7L17.4082 15.285C17.2824 17.0466 17.2195 17.9275 16.6435 18.4637C16.0676 19 15.1845 19 13.4184 19H10.5816C8.81549 19 7.93242 19 7.35648 18.4637C6.78053 17.9275 6.71762 17.0466 6.59178 15.285L6 7"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 14V12M10 14V12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "Trash-double-line-3": {
        defaultColors: ["#000000"],
        keywords: ["trash","delete","remove","discard","clear","bin","recycle","erase","cancel","void","garbage","waste","refund","item-removal","transaction-reversal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C10.504 4 9.15864 4.91083 8.60303 6.29987L8.32297 7H6C5.97039 7 5.94091 7.00131 5.91166 7.00391H5C4.44772 7.00391 4 7.45162 4 8.00391C4 8.55619 4.44772 9.00391 5 9.00391H5.08714L5.67902 15.5145C5.75269 16.3255 5.81651 17.0279 5.94156 17.5888C6.076 18.1918 6.30668 18.7616 6.80342 19.2153C7.30016 19.6689 7.88849 19.847 8.50124 19.9263C9.07112 20.0001 9.77651 20 10.5907 20H10.5907H13.4094H13.4094C14.2236 20 14.9289 20.0001 15.4988 19.9263C16.1115 19.847 16.6999 19.6689 17.1966 19.2153C17.6933 18.7616 17.924 18.1918 18.0585 17.5888C18.1835 17.0279 18.2473 16.3255 18.321 15.5146L18.9129 9.00391H19C19.5523 9.00391 20 8.55619 20 8.00391C20 7.45162 19.5523 7.00391 19 7.00391H18.0883C18.0591 7.00131 18.0296 7 18 7H15.677L15.397 6.29987C14.8414 4.91082 13.496 4 12 4ZM11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V12ZM15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V12Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "Trash-double-line-6": {
        defaultColors: ["#3d4c66", "#d9d1e0", "#000000"],
        keywords: ["trash","bin","delete","remove","discard","cancel","void","refund"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7L14.8944 6.78885C14.3463 5.69253 13.2257 5 12 5C10.7743 5 9.65374 5.69253 9.10557 6.78885L9 7H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 7L14.8944 6.78885C14.3463 5.69253 13.2257 5 12 5C10.7743 5 9.65374 5.69253 9.10557 6.78885L9 7H15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9997 7.00391H6.00028L6.59178 15.285C6.71762 17.0466 6.78053 17.9275 7.35648 18.4637C7.93242 19 8.81549 19 10.5816 19H13.4184C15.1845 19 16.0676 19 16.6435 18.4637C17.2195 17.9275 17.2824 17.0466 17.4082 15.285L17.9997 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 7.00391H19M18 7L17.4082 15.285C17.2824 17.0466 17.2195 17.9275 16.6435 18.4637C16.0676 19 15.1845 19 13.4184 19H10.5816C8.81549 19 7.93242 19 7.35648 18.4637C6.78053 17.9275 6.71762 17.0466 6.59178 15.285L6 7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 14V12M10 14V12" stroke={colors?.[2] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "Trash-double-line-5": {
        defaultColors: ["#2797e8", "#000000"],
        keywords: ["trash","bin","delete","remove","discard","void","clear","garbage","refund","void-transaction","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 14V12M10 14V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path d="M5 7.00391H19" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18 7L17.4082 15.285C17.2824 17.0466 17.2195 17.9275 16.6435 18.4637C16.0676 19 15.1845 19 13.4184 19H10.5816C8.81549 19 7.93242 19 7.35648 18.4637C6.78053 17.9275 6.71762 17.0466 6.59178 15.285L6 7"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-double-line-7": {
        defaultColors: ["#3d4c66", "#000000"],
        keywords: ["trash","delete","remove","bin","waste","cancel","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.5482 10.2539H5.45181L5.92682 15.479C6.00153 16.3011 6.06409 16.9895 6.18557 17.5344C6.31412 18.111 6.52784 18.625 6.972 19.0307C7.41616 19.4363 7.94744 19.6026 8.53332 19.6784C9.08696 19.7501 9.77818 19.75 10.6037 19.75H13.3963C14.2218 19.75 14.913 19.7501 15.4667 19.6784C16.0526 19.6026 16.5838 19.4363 17.028 19.0307C17.4722 18.625 17.6859 18.111 17.8144 17.5344C17.9359 16.9895 17.9985 16.3011 18.0732 15.479L18.5482 10.2539ZM10 13C10.5523 13 11 13.4477 11 14V15.5C11 16.0523 10.5523 16.5 10 16.5C9.44772 16.5 9 16.0523 9 15.5V14C9 13.4477 9.44772 13 10 13ZM14 13C14.5523 13 15 13.4477 15 14V15.5C15 16.0523 14.5523 16.5 14 16.5C13.4477 16.5 13 16.0523 13 15.5V14C13 13.4477 13.4477 13 14 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 4.25C10.6062 4.25 9.35279 5.09859 8.83514 6.39271L8.59066 7.00391H5C4.44772 7.00391 4 7.45162 4 8.00391C4 8.55619 4.44772 9.00391 5 9.00391H19C19.5523 9.00391 20 8.55619 20 8.00391C20 7.45162 19.5523 7.00391 19 7.00391H15.4093L15.1649 6.39271C14.6472 5.09859 13.3938 4.25 12 4.25Z"
                    fill={colors?.[1] || "#000000"}
                />
            </svg>
        )
    },
    "Trash-double-line-8": {
        defaultColors: ["#000000"],
        keywords: ["trash","delete","remove","discard","bin","clear","cancel","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 7L6 7.75L6 7ZM18 7V6.25V7ZM6 9V8.25H6L6 9ZM18 9V9.75V9ZM5 8H4.25H5ZM19 8L18.25 8L19 8ZM8 9.75C8.41421 9.75 8.75 9.41421 8.75 9C8.75 8.58579 8.41421 8.25 8 8.25V9.75ZM16 8.25C15.5858 8.25 15.25 8.58579 15.25 9C15.25 9.41421 15.5858 9.75 16 9.75V8.25ZM6 7.75L18 7.75V6.25L6 6.25L6 7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75L6 8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8L18.25 8ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8L19.75 8C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75L6 6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    d="M18 9L17.4564 15.3416C17.3076 17.0784 17.2331 17.9467 16.6594 18.4734C16.0857 19 15.2142 19 13.471 19H10.529C8.78584 19 7.91428 19 7.34057 18.4734C6.76686 17.9467 6.69243 17.0784 6.54357 15.3416L6 9"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 15V13M10 15V13" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "Trash-double-line-9": {
        defaultColors: ["#2797e8", "#3d4c66", "#000000"],
        keywords: ["trash","delete","remove","bin","garbage","cancel","void","discard","refund","clear","empty"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 9L17.4564 15.3416C17.3076 17.0784 17.2331 17.9467 16.6594 18.4734C16.0857 19 15.2142 19 13.471 19H10.529C8.78584 19 7.91428 19 7.34057 18.4734C6.76686 17.9467 6.69243 17.0784 6.54357 15.3416L6 9"
                    stroke={colors?.[2] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3292 7.33541C14.5144 7.70589 14.9649 7.85606 15.3354 7.67082C15.7059 7.48558 15.8561 7.03507 15.6708 6.66459L14.3292 7.33541ZM9.10557 6.78885L8.43475 6.45344L9.10557 6.78885ZM14.2236 7.12426L14.3292 7.33541L15.6708 6.66459L15.5652 6.45344L14.2236 7.12426ZM9.67082 7.33541L9.77639 7.12426L8.43475 6.45344L8.32918 6.66459L9.67082 7.33541ZM9.77639 7.12426C10.1975 6.28202 11.0583 5.75 12 5.75V4.25C10.4902 4.25 9.10996 5.10303 8.43475 6.45344L9.77639 7.12426ZM15.5652 6.45344C14.89 5.10303 13.5098 4.25 12 4.25V5.75C12.9417 5.75 13.8025 6.28202 14.2236 7.12426L15.5652 6.45344Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M6 7L6 7.75L6 7ZM18 7V6.25V7ZM6 9V8.25H6L6 9ZM18 9V9.75V9ZM5 8H4.25H5ZM19 8L18.25 8L19 8ZM8 9.75C8.41421 9.75 8.75 9.41421 8.75 9C8.75 8.58579 8.41421 8.25 8 8.25V9.75ZM16 8.25C15.5858 8.25 15.25 8.58579 15.25 9C15.25 9.41421 15.5858 9.75 16 9.75V8.25ZM6 7.75L18 7.75V6.25L6 6.25L6 7.75ZM4.25 8C4.25 8.9665 5.0335 9.75 6 9.75L6 8.25C5.86193 8.25 5.75 8.13807 5.75 8H4.25ZM18.25 8C18.25 8.13807 18.1381 8.25 18 8.25V9.75C18.9665 9.75 19.75 8.9665 19.75 8L18.25 8ZM18 7.75C18.1381 7.75 18.25 7.86193 18.25 8L19.75 8C19.75 7.0335 18.9665 6.25 18 6.25V7.75ZM6 6.25C5.0335 6.25 4.25 7.0335 4.25 8H5.75C5.75 7.86193 5.86193 7.75 6 7.75L6 6.25ZM8 8.25L6 8.25L6 9.75L8 9.75V8.25ZM18 8.25H16V9.75H18V8.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M14 15V13M10 15V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-exclamation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","exclamation","delete","warning","remove","error","void","cancel","discard","alert"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 13L12 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash-exclamation-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","error","warning","alert","exclamation","void","void-transaction","void-sale","void-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.29711 6.25722L8 7L16 7L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L7.44166 15.2698L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0424 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M12 13L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash-double-line": {
        defaultColors: ["#000000"],
        keywords: ["trash","delete","remove","cancel","discard","bin","waste","clear","erase","void","reject","refund","void-transaction","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 8L9.5315 6.67126C9.93525 5.66187 10.9129 5 12 5V5C13.0871 5 14.0648 5.66187 14.4685 6.67126L15 8"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 8.00391H19" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18 8L17.4303 15.3107C17.2939 17.0611 17.2257 17.9362 16.6508 18.4681C16.0759 19 15.1981 19 13.4424 19H10.5576C8.80195 19 7.92413 19 7.34919 18.4681C6.77425 17.9362 6.70606 17.0611 6.56967 15.3107L6 8"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14 15V12M10 15V12" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    },
    "Trash-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","warning","error","alert","trash-exclamation","exclamation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.7029 6.25722C15.4593 5.64832 15.3375 5.34387 15.0836 5.17193C14.8296 5 14.5017 5 13.8459 5L10.1541 5C9.49826 5 9.17035 5 8.9164 5.17193C8.66245 5.34387 8.54067 5.64832 8.29711 6.25722L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 13L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","discard","error","warning","exclamation","alert","void","void-transaction","delete-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00392H7.32142L7.38368 5.84826C7.49232 5.5765 7.60157 5.30321 7.7205 5.08019C7.85653 4.82509 8.0458 4.55375 8.35579 4.34388C8.66579 4.134 8.98801 4.05904 9.27539 4.02748C9.52663 3.99989 9.82096 3.99995 10.1136 4.00001L13.8864 4.00001C14.1791 3.99995 14.4734 3.99989 14.7246 4.02748C15.012 4.05904 15.3342 4.134 15.6442 4.34388C15.9542 4.55375 16.1435 4.82509 16.2795 5.08019C16.3985 5.30322 16.5077 5.57652 16.6164 5.84827L16.6786 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79798 19.9998 9.08795 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392ZM11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5V12ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.5C13 14.9477 12.5523 14.5 12 14.5C11.4477 14.5 11 14.9477 11 15.5V16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-full-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","bin","delete","remove","cancel","void","discard","recycle","clear","trash-full","full-bin","delete-item","remove-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12.1675 6.49737C12.5253 5.42402 12.7042 4.88735 12.4767 4.49671C12.4441 4.44072 12.4061 4.38803 12.3633 4.33938C12.0646 4 11.4989 4 10.3675 4V4C9.7445 4 9.43297 4 9.18921 4.15297C9.15301 4.17569 9.11829 4.20071 9.08529 4.22788C8.86308 4.41076 8.76457 4.70629 8.56754 5.29737L8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7V7C16.2429 6.51415 16.3644 6.27123 16.3791 6.07503C16.4117 5.64276 16.162 5.23876 15.7608 5.07454C15.5787 5 15.3071 5 14.7639 5L14.1056 5C13.6326 5 13.3962 5 13.1951 5.09384C13.1244 5.12684 13.0578 5.16799 12.9967 5.21646C12.8228 5.35433 12.7171 5.56584 12.5056 5.98885L12 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-full-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","delete","remove","cancel","discard","empty","void","erase","clear","refund","trash-full"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9189 4L10.0811 4C9.73594 4 9.56335 4 9.41355 4.04836C9.21382 4.11284 9.03943 4.23853 8.9151 4.40762C8.82185 4.53444 8.76727 4.69818 8.65811 5.02566C8.46104 5.61688 8.36251 5.91248 8.39886 6.15081C8.44734 6.46858 8.64562 6.74367 8.93175 6.89014C9.14634 7 9.45794 7 10.0811 7L10.9189 7C11.2641 7 11.4367 7 11.5865 6.95164C11.7862 6.88716 11.9606 6.76148 12.0849 6.59238C12.1781 6.46556 12.2327 6.30182 12.3419 5.97434C12.539 5.38312 12.6375 5.08752 12.6011 4.84919C12.5527 4.53142 12.3544 4.25633 12.0683 4.10986C11.8537 4 11.5421 4 10.9189 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15.382 5L13.618 5C13.2393 5 12.893 5.214 12.7236 5.55279C12.3912 6.21769 12.8747 7 13.618 7L15.382 7C15.7607 7 16.107 6.786 16.2764 6.44721L16.2764 6.44721C16.6088 5.78231 16.1253 5 15.382 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 7H6L6.69425 15.3282C6.83937 17.069 6.91193 17.9394 7.48602 18.4676C8.0601 18.9959 8.93354 18.9959 10.6804 18.9959H13.3196C15.0665 18.9959 15.9399 18.9959 16.514 18.4676C17.0881 17.9394 17.1606 17.069 17.3057 15.3282L18 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25C4.58579 6.25 4.25 6.58579 4.25 7C4.25 7.41421 4.58579 7.75 5 7.75V6.25ZM19 7.75C19.4142 7.75 19.75 7.41421 19.75 7C19.75 6.58579 19.4142 6.25 19 6.25V7.75ZM6.69425 15.3282L7.44166 15.2659L6.69425 15.3282ZM17.3057 15.3282L16.5583 15.2659L17.3057 15.3282ZM16.514 18.4676L16.0062 17.9157L16.514 18.4676ZM7.48602 18.4676L7.99384 17.9157H7.99384L7.48602 18.4676ZM5 7.75H6V6.25H5V7.75ZM6 7.75H18V6.25H6V7.75ZM18 7.75H19V6.25H18V7.75ZM7.44166 15.2659L6.74741 6.93769L5.25259 7.06231L5.94685 15.3905L7.44166 15.2659ZM18.0532 15.3905L18.7474 7.06231L17.2526 6.93769L16.5583 15.2659L18.0532 15.3905ZM13.3196 18.2459H10.6804V19.7459H13.3196V18.2459ZM16.5583 15.2659C16.4841 16.1565 16.433 16.752 16.3376 17.1946C16.2467 17.6162 16.135 17.7971 16.0062 17.9157L17.0218 19.0196C17.467 18.6099 17.6787 18.0916 17.8039 17.5107C17.9246 16.9508 17.9823 16.2407 18.0532 15.3905L16.5583 15.2659ZM13.3196 19.7459C14.1728 19.7459 14.8852 19.7473 15.4532 19.6736C16.0424 19.5971 16.5766 19.4292 17.0218 19.0196L16.0062 17.9157C15.8773 18.0343 15.6877 18.1305 15.26 18.1861C14.811 18.2444 14.2133 18.2459 13.3196 18.2459V19.7459ZM5.94685 15.3905C6.01772 16.2407 6.07543 16.9508 6.19611 17.5107C6.32132 18.0916 6.53299 18.6099 6.97819 19.0196L7.99384 17.9157C7.86495 17.7971 7.75331 17.6162 7.66244 17.1946C7.56703 16.752 7.5159 16.1565 7.44166 15.2659L5.94685 15.3905ZM10.6804 18.2459C9.78674 18.2459 9.18899 18.2444 8.74 18.1861C8.31232 18.1305 8.12272 18.0343 7.99384 17.9157L6.97819 19.0196C7.42339 19.4292 7.95755 19.5971 8.54684 19.6736C9.11481 19.7473 9.82723 19.7459 10.6804 19.7459V18.2459Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-full-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","empty","bin","garbage","cancel","void","clear","trash-full"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 6.0002C19.5523 6.0002 20 6.44791 20 7.0002C20 7.55248 19.5523 8.0002 19 8.0002H18.9201L18.2971 15.4737C18.229 16.2908 18.1701 16.9984 18.0483 17.5635C17.9173 18.171 17.689 18.7456 17.1911 19.2037C16.6932 19.6619 16.1016 19.8417 15.4854 19.9217C14.9121 19.9961 14.202 19.9961 13.382 19.9961H10.618C9.79798 19.9961 9.08795 19.9961 8.51465 19.9217C7.89842 19.8417 7.30683 19.6619 6.80892 19.2037C6.311 18.7456 6.08266 18.171 5.95172 17.5635C5.82991 16.9984 5.77097 16.2908 5.70289 15.4737L5.07989 8.0002H5C4.44772 8.0002 4 7.55248 4 7.0002C4 6.44791 4.44772 6.0002 5 6.0002H19ZM11 12.0002C11 11.4479 10.5523 11.0002 10 11.0002C9.44772 11.0002 9 11.4479 9 12.0002V14.0002C9 14.5525 9.44772 15.0002 10 15.0002C10.5523 15.0002 11 14.5525 11 14.0002V12.0002ZM15 12.0002C15 11.4479 14.5523 11.0002 14 11.0002C13.4477 11.0002 13 11.4479 13 12.0002V14.0002C13 14.5525 13.4477 15.0002 14 15.0002C14.5523 15.0002 15 14.5525 15 14.0002V12.0002Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.0201 4.97903C17.042 4.8912 17.0621 4.7634 17.08 4.5702C17.14 3.8102 16.7 3.1102 16 2.8202C15.68 2.6902 15.36 2.6902 14.72 2.6902H14.06C13.69 2.6902 13.42 2.6902 13.17 2.7502C13.14 2.6902 13.12 2.6302 13.08 2.5702C13.02 2.4702 12.96 2.3802 12.88 2.2902C12.36 1.7002 11.59 1.7002 10.32 1.7002C9.60004 1.7002 9.17004 1.7002 8.74004 1.9702C8.68004 2.0102 8.62004 2.0502 8.56004 2.1002C8.17004 2.4202 8.03004 2.8302 7.81004 3.5102L7.31995 4.98653H17.0182L17.0201 4.97903Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-full": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","delete","remove","discard","bin","cancel","void","erase","clear","garbage","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7L12.1675 6.49737C12.5253 5.42402 12.7042 4.88735 12.4767 4.49671C12.4441 4.44072 12.4061 4.38803 12.3633 4.33938C12.0646 4 11.4989 4 10.3675 4V4C9.7445 4 9.43297 4 9.18921 4.15297C9.15301 4.17569 9.11829 4.20071 9.08529 4.22788C8.86308 4.41076 8.76457 4.70629 8.56754 5.29737L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7V7C16.2429 6.51415 16.3644 6.27123 16.3791 6.07503C16.4117 5.64276 16.162 5.23876 15.7608 5.07454C15.5787 5 15.3071 5 14.7639 5L14.1056 5C13.6326 5 13.3962 5 13.1951 5.09384C13.1244 5.12684 13.0578 5.16799 12.9967 5.21646C12.8228 5.35433 12.7171 5.56584 12.5056 5.98885L12 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 12V14M14 12V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-plus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","bin","plus","add","new","create","add-new-item","add-item","add-product","add-discount","new-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M12 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","add","plus","restore","recover","add-item","restore-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392ZM12 10C12.5523 10 13 10.4477 13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-plus-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","bin","add","plus","new","create","trash-plus","add-item","new-item","create-item","waste","recycle","add-product"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15V11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 13L10 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","bin","add","plus","add-item","waste","increase","additional"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 15V11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 13L10 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Trash-recycle-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trash","recycle","delete","remove","void","cancel","garbage","bin","waste"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 11L11.25 10.5V10.5C11.559 9.88197 12.441 9.88197 12.75 10.5V10.5L13 11M10 13L9.38333 14.2333C9.20721 14.5856 9.46334 15 9.85714 15V15H10.7143M14 13L14.6167 14.2333C14.7928 14.5856 14.5367 15 14.1429 15V15H13.2857"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-recycle-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","recycle","delete","remove","cancel","void","discard","bin","garbage","trash-can"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9573 6.91459L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9.04271 6.91459C9.01462 6.97076 9 7.03269 9 7.09549C9 7.3189 9.1811 7.5 9.40451 7.5L14.5955 7.5C14.8189 7.5 15 7.3189 15 7.09549C15 7.03269 14.9854 6.97076 14.9573 6.91459Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M11 11L11.25 10.5V10.5C11.559 9.88197 12.441 9.88197 12.75 10.5V10.5L13 11M10 13L9.38333 14.2333C9.20721 14.5856 9.46334 15 9.85714 15V15H10.7143M14 13L14.6167 14.2333C14.7928 14.5856 14.5367 15 14.1429 15V15H13.2857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash-recycle-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","recycle","delete","remove","discard","void","cancel","bin","waste","refund","item-removal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L9.72361 13.5528C9.39116 14.2177 9.87465 15 10.618 15H11M14 13L14.2764 13.5528C14.6088 14.2177 14.1253 15 13.382 15H13M11 11L11.1056 10.7889C11.4741 10.0518 12.5259 10.0518 12.8944 10.7889L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash-recycle-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["trash","recycle","delete","remove","discard","void","cancel","trash-order","delete-order","remove-item","recycle-order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13L9.72361 13.5528C9.39116 14.2177 9.87465 15 10.618 15H11M14 13L14.2764 13.5528C14.6088 14.2177 14.1253 15 13.382 15H13M11 11L11.1056 10.7889C11.4741 10.0518 12.5259 10.0518 12.8944 10.7889L13 11"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Trash-recycle-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","recycle","delete","remove","void","cancel","discard","garbage","bin","trash-bin","recycle-bin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6.00392H8.38001L8.56954 5.62485C8.68938 5.38505 8.81061 5.14248 8.93631 4.94493C9.08031 4.71862 9.27225 4.48061 9.56657 4.29871C9.86089 4.11681 10.1596 4.05157 10.4264 4.02398C10.6593 3.9999 10.9305 3.99995 11.1986 4.00001L12.8014 4C13.0695 3.99995 13.3407 3.9999 13.5736 4.02398C13.8404 4.05157 14.1391 4.11681 14.4334 4.29871C14.7277 4.48061 14.9197 4.71862 15.0637 4.94493C15.1894 5.14248 15.3106 5.38506 15.4305 5.62485L15.62 6.00392H19C19.5523 6.00392 20 6.45163 20 7.00392C20 7.5562 19.5523 8.00392 19 8.00392H18.9201L18.2971 15.4774C18.229 16.2946 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2075C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79797 19.9998 9.08794 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2075C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2946 5.70289 15.4774L5.07989 8.00392H5C4.44772 8.00392 4 7.5562 4 7.00392C4 6.45163 4.44772 6.00392 5 6.00392ZM12.0862 12.0772L12 11.8952L11.9138 12.0772C11.7122 12.5028 11.2218 12.6753 10.8185 12.4625C10.4152 12.2497 10.2517 11.7321 10.4534 11.3065L10.6575 10.8757C11.2106 9.7081 12.7894 9.7081 13.3425 10.8757L13.5467 11.3065C13.7483 11.7321 13.5848 12.2497 13.1815 12.4625C12.7782 12.6753 12.2878 12.5028 12.0862 12.0772ZM10.7323 12.6444C11.1356 12.8572 11.299 13.3748 11.0974 13.8004L10.8717 14.2767H10.9503C11.4012 14.2767 11.7667 14.6625 11.7667 15.1384C11.7667 15.6142 11.4012 16 10.9503 16H10.2505C9.32211 16 8.71826 14.9689 9.13346 14.0925L9.63693 13.0298C9.83858 12.6041 10.329 12.4316 10.7323 12.6444ZM14.3631 13.0298C14.1614 12.6041 13.671 12.4316 13.2677 12.6444C12.8644 12.8572 12.701 13.3748 12.9026 13.8004L13.1283 14.2767H13.0497C12.5988 14.2767 12.2333 14.6625 12.2333 15.1384C12.2333 15.6142 12.5988 16 13.0497 16H13.7495C14.6779 16 15.2817 14.9689 14.8665 14.0925L14.3631 13.0298Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-recycle-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","recycle","delete","remove","discard","clear","void","cancel","garbage","bin","item-removal","order-cancellation"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.001 3C9.44875 2.99943 9.00057 3.44668 9 3.99897C8.99943 4.55125 9.44668 4.99943 9.99897 5L13.999 5.00414C14.5513 5.00471 14.9994 4.55746 15 4.00517C15.0006 3.45289 14.5533 3.00471 14.001 3.00414L10.001 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7.00391C4 6.45162 4.44772 6.00391 5 6.00391H19C19.5523 6.00391 20 6.45162 20 7.00391C20 7.55619 19.5523 8.00391 19 8.00391H18.9201L18.2971 15.4774C18.229 16.2945 18.1701 17.0021 18.0483 17.5673C17.9173 18.1747 17.689 18.7493 17.1911 19.2074C16.6932 19.6656 16.1016 19.8454 15.4854 19.9254C14.9121 19.9999 14.202 19.9998 13.382 19.9998H10.618C9.79798 19.9998 9.08795 19.9999 8.51465 19.9254C7.89842 19.8454 7.30683 19.6656 6.80892 19.2074C6.311 18.7493 6.08266 18.1747 5.95172 17.5673C5.82991 17.0021 5.77097 16.2945 5.70289 15.4774L5.07989 8.00391H5C4.44772 8.00391 4 7.55619 4 7.00391ZM12.0862 12.0772L12 11.8952L11.9138 12.0772C11.7122 12.5028 11.2218 12.6753 10.8185 12.4625C10.4152 12.2497 10.2517 11.7321 10.4534 11.3065L10.6575 10.8757C11.2106 9.7081 12.7894 9.7081 13.3425 10.8757L13.5467 11.3065C13.7483 11.7321 13.5848 12.2497 13.1815 12.4625C12.7782 12.6753 12.2878 12.5028 12.0862 12.0772ZM10.7323 12.6444C11.1356 12.8572 11.299 13.3748 11.0974 13.8004L10.8717 14.2767H10.9503C11.4012 14.2767 11.7667 14.6625 11.7667 15.1384C11.7667 15.6142 11.4012 16 10.9503 16H10.2505C9.32211 16 8.71826 14.9689 9.13346 14.0925L9.63693 13.0298C9.83858 12.6041 10.329 12.4316 10.7323 12.6444ZM14.3631 13.0298C14.1614 12.6041 13.671 12.4316 13.2677 12.6444C12.8644 12.8572 12.701 13.3748 12.9026 13.8004L13.1283 14.2767H13.0497C12.5988 14.2767 12.2333 14.6625 12.2333 15.1384C12.2333 15.6142 12.5988 16 13.0497 16H13.7495C14.6779 16 15.2817 14.9689 14.8665 14.0925L14.3631 13.0298Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Trash-recycle": {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","recycle","delete","remove","cancel","void","bin","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 7L14.5528 6.10557C14.2838 5.56766 14.1493 5.2987 13.9077 5.14935C13.666 5 13.3653 5 12.7639 5L11.2361 5C10.6347 5 10.334 5 10.0923 5.14935C9.85065 5.2987 9.71617 5.56766 9.44721 6.10557L9 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 11L11.25 10.5V10.5C11.559 9.88197 12.441 9.88197 12.75 10.5V10.5L13 11M10 13L9.38333 14.2333C9.20721 14.5856 9.46334 15 9.85714 15V15H10.7143M14 13L14.6167 14.2333C14.7928 14.5856 14.5367 15 14.1429 15V15H13.2857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Trash: {
        defaultColors: ["#3D4C66"],
        keywords: ["trash","recycle","delete","remove","cancel","void","bin","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414M19 7.00391H5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7.00391L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Trash-recycle-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trash","recycle","delete","remove","void","bin","cancel","discard","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 5L14 5.00414"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 7.00391H6L6.69425 15.3321C6.83937 17.0729 6.91193 17.9433 7.48602 18.4716C8.0601 18.9998 8.93354 18.9998 10.6804 18.9998H13.3196C15.0665 18.9998 15.9399 18.9998 16.514 18.4716C17.0881 17.9433 17.1606 17.0729 17.3057 15.3321L18 7.00391Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M5 6.25391C4.58579 6.25391 4.25 6.58969 4.25 7.00391C4.25 7.41812 4.58579 7.75391 5 7.75391V6.25391ZM19 7.75391C19.4142 7.75391 19.75 7.41812 19.75 7.00391C19.75 6.58969 19.4142 6.25391 19 6.25391V7.75391ZM6.69425 15.3321L5.94685 15.3944L6.69425 15.3321ZM17.3057 15.3321L16.5583 15.2698L17.3057 15.3321ZM16.514 18.4716L16.0062 17.9196L16.514 18.4716ZM7.48602 18.4716L7.99384 17.9196H7.99384L7.48602 18.4716ZM5 7.75391H6V6.25391H5V7.75391ZM6 7.75391H18V6.25391H6V7.75391ZM18 7.75391H19V6.25391H18V7.75391ZM7.44166 15.2698L6.74741 6.9416L5.25259 7.06621L5.94685 15.3944L7.44166 15.2698ZM18.0532 15.3944L18.7474 7.06621L17.2526 6.9416L16.5583 15.2698L18.0532 15.3944ZM13.3196 18.2498H10.6804V19.7498H13.3196V18.2498ZM16.5583 15.2698C16.4841 16.1604 16.433 16.7559 16.3376 17.1985C16.2467 17.6201 16.135 17.801 16.0062 17.9196L17.0218 19.0235C17.467 18.6138 17.6787 18.0955 17.8039 17.5146C17.9246 16.9547 17.9823 16.2446 18.0532 15.3944L16.5583 15.2698ZM13.3196 19.7498C14.1728 19.7498 14.8852 19.7512 15.4532 19.6775C16.0425 19.601 16.5766 19.4331 17.0218 19.0235L16.0062 17.9196C15.8773 18.0382 15.6877 18.1345 15.26 18.19C14.811 18.2483 14.2133 18.2498 13.3196 18.2498V19.7498ZM5.94685 15.3944C6.01772 16.2446 6.07543 16.9547 6.19611 17.5146C6.32132 18.0955 6.53299 18.6138 6.97819 19.0235L7.99384 17.9196C7.86495 17.801 7.75331 17.6201 7.66244 17.1985C7.56703 16.7559 7.5159 16.1604 7.44166 15.2698L5.94685 15.3944ZM10.6804 18.2498C9.78674 18.2498 9.18899 18.2483 8.74 18.19C8.31232 18.1345 8.12272 18.0382 7.99384 17.9196L6.97819 19.0235C7.42339 19.4331 7.95755 19.601 8.54684 19.6775C9.11481 19.7512 9.82723 19.7498 10.6804 19.7498V18.2498Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M10 13L9.72361 13.5528C9.39116 14.2177 9.87465 15 10.618 15H11M14 13L14.2764 13.5528C14.6088 14.2177 14.1253 15 13.382 15H13M11 11L11.1056 10.7889C11.4741 10.0518 12.5259 10.0518 12.8944 10.7889L13 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "tree 2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tree","nature","plant","seasonal","outdoor","landscape","garden","menu","categories","products","services","eco-friendly","organic","sustainable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12.6923C4 15.0714 6.0467 17 8.57143 17C9.93679 17 11.1623 16.436 12 15.5417C12.8377 16.436 14.0632 17 15.4286 17C17.9533 17 20 15.0714 20 12.6923C20 10.6272 18.4578 8.90148 16.3995 8.48198C16.5115 8.10867 16.5714 7.71478 16.5714 7.30769C16.5714 4.92862 14.5247 3 12 3C9.47527 3 7.42857 4.92862 7.42857 7.30769C7.42857 7.71478 7.4885 8.10867 7.60049 8.48198C5.54216 8.90148 4 10.6272 4 12.6923Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M11.9968 13L10 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11.9902 21L11.9967 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tree 2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tree","loyalty","growth","organic","eco-friendly","rewards","nature","products","sustainable","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.55 7.79C17.56 7.63 17.57 7.47 17.57 7.31C17.57 4.38 15.07 2 12 2C8.93 2 6.43 4.38 6.43 7.31C6.43 7.47 6.43 7.63 6.45 7.79C4.4 8.6 3 10.53 3 12.7C3 15.63 5.5 18.01 8.57 18.01C9.42 18.01 10.24 17.81 10.99 17.47V13.42L9.29 11.72C8.9 11.33 8.9 10.7 9.29 10.31C9.68 9.92 10.31 9.92 10.7 10.31L10.99 10.6V9.02C10.99 8.47 11.44 8.02 11.99 8.02C12.54 8.02 12.99 8.47 12.99 9.02V17.47C13.74 17.82 14.57 18.02 15.42 18.02C18.49 18.02 21 15.64 21 12.71C21 10.54 19.59 8.61 17.54 7.8L17.55 7.79Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.99 17.47L10.99 21.01C10.99 21.56 11.44 22 11.99 22C12.54 22 12.99 21.56 12.99 21.01L12.99 17.46C12.64 17.3 12.31 17.11 12 16.89C11.69 17.12 11.35 17.31 10.99 17.47Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tree 2": {
        defaultColors: ["#3D4C66"],
        keywords: ["tree","nature","outdoor","eco","organic","plant","garden","sustainable","environment","menu-category","location"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9902 21L11.9967 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11.9968 13L10 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12.6923C4 15.0714 6.0467 17 8.57143 17C9.93679 17 11.1623 16.436 12 15.5417C12.8377 16.436 14.0632 17 15.4286 17C17.9533 17 20 15.0714 20 12.6923C20 10.6272 18.4578 8.90148 16.3995 8.48198C16.5115 8.10867 16.5714 7.71478 16.5714 7.30769C16.5714 4.92862 14.5247 3 12 3C9.47527 3 7.42857 4.92862 7.42857 7.30769C7.42857 7.71478 7.4885 8.10867 7.60049 8.48198C5.54216 8.90148 4 10.6272 4 12.6923Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tree 3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tree","branch","nature","eco","garden","plant","loyalty","rewards","growth","organic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9968 13L10 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16.5 16C18.9853 16 21 14.0206 21 11.5789C21 9.291 19.231 7.40898 16.9635 7.18106C16.4178 5.34296 14.69 4 12.6429 4C10.578 4 8.83791 5.36637 8.30832 7.22902C8.04609 7.1823 7.77595 7.15789 7.5 7.15789C5.01472 7.15789 3 9.13727 3 11.5789C3 14.0206 5.01472 16 7.5 16H16.5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9902 21H11.9967V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tree 3-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tree","nature","eco","sustainable","organic","plant","environment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 16C18.9853 16 21 14.0206 21 11.5789C21 9.291 19.231 7.40898 16.9635 7.18106C16.4178 5.34296 14.69 4 12.6429 4C10.578 4 8.83791 5.36637 8.30832 7.22902C8.04609 7.1823 7.77595 7.15789 7.5 7.15789C5.01472 7.15789 3 9.13727 3 11.5789C3 14.0206 5.01472 16 7.5 16H16.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M16.5 16C18.9853 16 21 14.0206 21 11.5789C21 9.291 19.231 7.40898 16.9635 7.18106C16.4178 5.34296 14.69 4 12.6429 4C10.578 4 8.83791 5.36637 8.30832 7.22902C8.04609 7.1823 7.77595 7.15789 7.5 7.15789C5.01472 7.15789 3 9.13727 3 11.5789C3 14.0206 5.01472 16 7.5 16H16.5Z"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M11.9968 13L10 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11.9902 21H11.9967V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tree 2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tree","plant","nature","eco","organic","location","garden","nursery","outdoor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9968 13L10 11" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M4 12.6923C4 15.0714 6.0467 17 8.57143 17C9.93679 17 11.1623 16.436 12 15.5417C12.8377 16.436 14.0632 17 15.4286 17C17.9533 17 20 15.0714 20 12.6923C20 10.6272 18.4578 8.90148 16.3995 8.48198C16.5115 8.10867 16.5714 7.71478 16.5714 7.30769C16.5714 4.92862 14.5247 3 12 3C9.47527 3 7.42857 4.92862 7.42857 7.30769C7.42857 7.71478 7.4885 8.10867 7.60049 8.48198C5.54216 8.90148 4 10.6272 4 12.6923Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M11.9902 21L11.9967 9" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tree 3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tree","eco","green","nature","sustainability","organic","natural-products"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.7 6.29C16.84 4.33 14.85 3 12.64 3C10.43 3 8.53 4.26 7.64 6.16C4.58 6.08 2 8.54 2 11.58C2 14.62 4.47 17 7.5 17H11V13.41L9.3 11.7C8.91 11.31 8.91 10.68 9.3 10.29C9.69 9.9 10.32 9.9 10.71 10.29L11 10.58V9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9V17H16.5C19.53 17 22 14.57 22 11.58C22 9 20.19 6.83 17.7 6.29Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 20.92C11 20.92 11 20.98 11 21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21L13 17H11L11 20.92Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tree 3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tree","plant","nature","organic","eco-friendly","sustainable","menu","item","category","seasonal","local"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.5 16C18.9853 16 21 14.0206 21 11.5789C21 9.291 19.231 7.40898 16.9635 7.18106C16.4178 5.34296 14.69 4 12.6429 4C10.578 4 8.83791 5.36637 8.30832 7.22902C8.04609 7.1823 7.77595 7.15789 7.5 7.15789C5.01472 7.15789 3 9.13727 3 11.5789C3 14.0206 5.01472 16 7.5 16H16.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11.9902 21H11.9967V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.9968 13L10 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tree-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tree","plant","environment","sustainable","eco-friendly","outdoor","nature","garden","nursery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.0007 13L14 14M12.0007 11L10 12.9079"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 21V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tree-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["upload","import","update","arrow","circle","add","stock","inventory","import-stock","add-stock","update-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0007 13L14 14M12.0007 11L10 12.9079"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 21V10" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "tree-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tree","plant","growth","organic","eco","natural","sustainable","produce","farming","agriculture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C20 5.59 16.41 2 12 2C7.59 2 4 5.59 4 10C4 14.07 7.06 17.44 11 17.93V13.34L10.69 13.64C10.29 14.02 9.66 14.01 9.28 13.61C8.9 13.21 8.91 12.58 9.31 12.2L11 10.59V10.02C11 9.47 11.45 9.02 12 9.02C12.55 9.02 13 9.47 13 10.02V12.39L14.45 13.11C14.94 13.36 15.14 13.96 14.9 14.45C14.72 14.8 14.37 15 14 15C13.85 15 13.7 14.97 13.55 14.89L13 14.61V17.92C16.94 17.43 20 14.06 20 9.99V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 17.93V21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21V17.93C12.67 17.97 12.34 18 12 18C11.66 18 11.33 17.97 11 17.93Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "triangle-exclamation-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["warning","exclamation","alert","error","notification","issue","problem","critical","danger","attention","invalid","incorrect","blocked","suspended","hold","exception"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2001 18.7378C18.3032 20 16.2021 20 12 20C7.79788 20 5.69683 20 4.79986 18.7378C4.68587 18.5774 4.58795 18.4062 4.50749 18.2266C3.87437 16.8136 4.93964 15.0026 7.0702 11.3807C9.14918 7.8464 10.1887 6.07926 11.709 5.93108C11.9025 5.91221 12.0975 5.91221 12.291 5.93108C13.8113 6.07926 14.8508 7.8464 16.9298 11.3807C19.0604 15.0026 20.1256 16.8136 19.4925 18.2266C19.4121 18.4062 19.3141 18.5774 19.2001 18.7378Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 13L12 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "triangle-exclamation-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["warning","error","alert","exclamation","attention","issue","problem","incorrect","out-of-stock","payment-failed","invalid-input","low-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2001 18.7378C18.3032 20 16.2021 20 12 20C7.79788 20 5.69683 20 4.79986 18.7378C4.68587 18.5774 4.58795 18.4062 4.50749 18.2266C3.87437 16.8136 4.93964 15.0026 7.0702 11.3807C9.14918 7.8464 10.1887 6.07926 11.709 5.93108C11.9025 5.91221 12.0975 5.91221 12.291 5.93108C13.8113 6.07926 14.8508 7.8464 16.9298 11.3807C19.0604 15.0026 20.1256 16.8136 19.4925 18.2266C19.4121 18.4062 19.3141 18.5774 19.2001 18.7378Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 13L12 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    tree: {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","error","alert","exclamation","attention","issue","problem","incorrect","out-of-stock","payment-failed","invalid-input","low-stock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12.0007 13L14 14M12.0007 11L10 12.9079"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 17C15.866 17 19 13.866 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 13.866 8.13401 17 12 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "triangle-exclamation-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["alert","warning","error","exclamation","issue","problem","notification","invalid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.4026 4.01877C12.1348 3.99374 11.8652 3.99374 11.5974 4.01877C10.3814 4.13241 9.48697 4.87429 8.69347 5.84125C7.91342 6.79181 6.99207 8.29364 5.94885 9.99413C4.87902 11.7379 4.02103 13.1363 3.52326 14.2752C3.01803 15.4311 2.77173 16.5619 3.27914 17.6477C3.39045 17.8859 3.52592 18.1131 3.68361 18.3258C4.40248 19.2957 5.54389 19.6655 6.83917 19.834C8.11533 20.0001 9.89004 20 12 20C14.11 20 15.8847 20.0001 17.1608 19.834C18.4561 19.6655 19.5975 19.2957 20.3164 18.3258C20.4741 18.1131 20.6096 17.8859 20.7209 17.6477C21.2283 16.5619 20.982 15.4311 20.4767 14.2752C19.979 13.1363 19.121 11.7379 18.0512 9.99416C17.0079 8.29366 16.0866 6.79181 15.3065 5.84125C14.513 4.87429 13.6186 4.13241 12.4026 4.01877ZM12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44771 13 8L13 12C13 12.5523 12.5523 13 12 13ZM12 17C11.4477 17 11 16.5523 11 16V15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V16C13 16.5523 12.5523 17 12 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "triangle-exclamation": {
        defaultColors: ["#3D4C66"],
        keywords: ["warning","alert","exclamation","error","issue","problem","critical","high-priority","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2001 18.7378C18.3032 20 16.2021 20 12 20C7.79788 20 5.69683 20 4.79986 18.7378C4.68587 18.5774 4.58795 18.4062 4.50749 18.2266C3.87437 16.8136 4.93964 15.0026 7.0702 11.3807C9.14918 7.8464 10.1887 6.07926 11.709 5.93108C11.9025 5.91221 12.0975 5.91221 12.291 5.93108C13.8113 6.07926 14.8508 7.8464 16.9298 11.3807C19.0604 15.0026 20.1256 16.8136 19.4925 18.2266C19.4121 18.4062 19.3141 18.5774 19.2001 18.7378Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 13L12 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 16L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "trophy-2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trophy","award","winner","achievement","loyalty","rewards","loyalty-program","best-customer","top-seller","promotion","incentive","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 18L16 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 8L17.8377 8C17.9884 8 18.0638 8 18.1271 8.00811C18.5786 8.06597 18.934 8.42141 18.9919 8.87289C19 8.93619 19 9.01155 19 9.16228V9.16228C19 9.27406 19 9.32996 18.9949 9.38041C18.9588 9.73555 18.7361 10.0445 18.4106 10.1911C18.3643 10.2119 18.3113 10.2296 18.2053 10.2649L16 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8L6.16228 8C6.01155 8 5.93619 8 5.87289 8.00811C5.42141 8.06597 5.06597 8.42141 5.00811 8.87289C5 8.93619 5 9.01155 5 9.16228V9.16228C5 9.27406 5 9.32996 5.00513 9.38041C5.04125 9.73555 5.26393 10.0445 5.58941 10.1911C5.63566 10.2119 5.68868 10.2296 5.79473 10.2649L8 11"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 14C7 12.5 7.06283 6.49122 7 6H16.9995C16.9367 6.49122 17.0001 12.5 12 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 6L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "trophy-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trophy","reward","achievement","winner","award","sales-goal","best-seller","top-performer","loyalty-program","promotion","discount","bonus","leaderboard","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 19L16 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 19L12 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.0908 8L17.7826 8C17.6641 8 17.6049 8 17.5507 8.00592C17.2305 8.04093 16.9468 8.22801 16.7885 8.50852C16.7617 8.55599 16.7384 8.61042 16.6917 8.71929L16.6917 8.71929L15.7155 10.9971C15.6387 11.1765 15.8217 11.357 16 11.2778L19.4601 9.73996C19.7884 9.59404 20 9.26845 20 8.90916C20 8.40705 19.593 8 19.0908 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4.90916 8L6.21743 8C6.33588 8 6.3951 8 6.44928 8.00592C6.76947 8.04093 7.05319 8.22801 7.2115 8.50852C7.23828 8.55599 7.26161 8.61042 7.30827 8.71929L7.30827 8.71929L8.28446 10.9971C8.36134 11.1765 8.17834 11.357 8 11.2778L4.53992 9.73996C4.21159 9.59404 4 9.26845 4 8.90916C4 8.40705 4.40705 8 4.90916 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 14L12.0004 19M12.0004 19L9 18.9993M12.0004 19H14.999"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14C7 12.5 7.06283 6.49122 7 6H16.9995C16.9367 6.49122 17.0001 12.5 12 14Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "trophy-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","reward","achievement","leaderboard","loyalty","vip","promotion","champion","winner","top-seller","milestone","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.1 6.75H17.79C17.79 6.75 17.71 6.75 17.66 6.75C17.69 6.5 17.73 6.26 17.74 6V5.84C17.78 5.63 17.71 5.41 17.57 5.25C17.43 5.09 17.22 5 17.01 5H7.01001C6.80001 5 6.59001 5.1 6.45001 5.25C6.31001 5.41 6.24001 5.63 6.26001 5.84V6C6.29001 6.26 6.33001 6.5 6.35001 6.75H4.91C3.86 6.75 3 7.61 3 8.66C3 9.41 3.45 10.1 4.13 10.4L7.59 11.94C7.66 11.97 7.92002 12.01 8.27002 12.04C9.00002 12.97 9.91002 13.69 10.99 14.15V17.74H8.99002H7.99002C7.44002 17.74 6.99002 18.19 6.99002 18.74C6.99002 19.29 7.44002 19.75 7.99002 19.75H15.99C16.54 19.75 16.99 19.29 16.99 18.74C16.99 18.19 16.54 17.74 15.99 17.74H12.99V14.15C14.07 13.68 14.98 12.97 15.71 12.04C16.01 12.03 16.27 11.99 16.4 11.93L19.86 10.39C20.55 10.08 21 9.4 21 8.65C21 7.6 20.15 6.75 19.1 6.75ZM5.35001 8.75H6.71002C6.77002 8.99 6.85001 9.22 6.92001 9.45L5.35001 8.75ZM17.1 9.45C17.18 9.22 17.25 8.99 17.31 8.75C17.55 8.75 17.75 8.75 17.79 8.75H18.67L17.1 9.45Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "trophy-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","award","winner","reward","achievement","loyalty","loyalty-program","top-customer","best-seller","milestone","promotion","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 8L17.8377 8C17.9884 8 18.0638 8 18.1271 8.00811C18.5786 8.06597 18.934 8.42141 18.9919 8.87289C19 8.93619 19 9.01155 19 9.16228V9.16228C19 9.27406 19 9.32996 18.9949 9.38041C18.9588 9.73555 18.7361 10.0445 18.4106 10.1911C18.3643 10.2119 18.3113 10.2296 18.2053 10.2649L16 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 8L6.16228 8C6.01155 8 5.93619 8 5.87289 8.00811C5.42141 8.06597 5.06597 8.42141 5.00811 8.87289C5 8.93619 5 9.01155 5 9.16228V9.16228C5 9.27406 5 9.32996 5.00513 9.38041C5.04125 9.73555 5.26393 10.0445 5.58941 10.1911C5.63566 10.2119 5.68868 10.2296 5.79473 10.2649L8 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 18L16 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14C7 12.5 7.06283 6.49122 7 6H16.9995C16.9367 6.49122 17.0001 12.5 12 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 6L18 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "trophy-21": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trophy","winner","award","prize","rewards","loyalty","promotion","achievement","top-seller","best-customer","points","badge","leaderboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 20L8 20L8.21082 19.3675L8.21082 19.3675C8.43083 18.7075 8.54083 18.3775 8.80272 18.1888C9.0646 18 9.41246 18 10.1082 18H13.8918C14.5875 18 14.9354 18 15.1973 18.1888C15.4592 18.3775 15.5692 18.7075 15.7892 19.3675L16 20Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 19.25C5.58579 19.25 5.25 19.5858 5.25 20C5.25 20.4142 5.58579 20.75 6 20.75V19.25ZM8 20V20.75V20ZM16 20V20.75V20.75V20ZM18 20.75C18.4142 20.75 18.75 20.4142 18.75 20C18.75 19.5858 18.4142 19.25 18 19.25V20.75ZM15.7892 19.3675L15.0777 19.6047V19.6047L15.7892 19.3675ZM8.21082 19.3675L8.92233 19.6047L8.92748 19.5893L8.93196 19.5736L8.21082 19.3675ZM8.80272 18.1888L9.24125 18.7972L9.24125 18.7972L8.80272 18.1888ZM8.21082 19.3675L7.49931 19.1304L7.49415 19.1458L7.48968 19.1615L8.21082 19.3675ZM15.1973 18.1888L15.6358 17.5803V17.5803L15.1973 18.1888ZM6 20.75H8V19.25H6V20.75ZM8 20.75H16V19.25L8 19.25V20.75ZM16 20.75L18 20.75V19.25L16 19.25V20.75ZM13.8918 17.25H10.1082V18.75H13.8918V17.25ZM16.7115 19.7628L16.5007 19.1304L15.0777 19.6047L15.2885 20.2372L16.7115 19.7628ZM8.71151 20.2372L8.92233 19.6047L7.49931 19.1304L7.28849 19.7628L8.71151 20.2372ZM10.1082 17.25C9.7776 17.25 9.46668 17.2489 9.20769 17.2784C8.92954 17.3102 8.63711 17.3836 8.36418 17.5803L9.24125 18.7972C9.24163 18.7969 9.2417 18.7969 9.24233 18.7965C9.2431 18.7962 9.24672 18.7944 9.25471 18.7917C9.27198 18.786 9.3082 18.7767 9.37784 18.7688C9.53218 18.7511 9.74305 18.75 10.1082 18.75V17.25ZM8.93196 19.5736L8.93196 19.5736L7.48968 19.1615L7.48968 19.1615L8.93196 19.5736ZM8.92233 19.6047C9.0378 19.2583 9.10556 19.0586 9.17108 18.9178C9.20064 18.8542 9.22095 18.8228 9.23183 18.8082C9.23686 18.8015 9.23968 18.7986 9.24029 18.798C9.24079 18.7975 9.24086 18.7975 9.24125 18.7972L8.36418 17.5803C8.09125 17.777 7.92913 18.0312 7.81104 18.2851C7.70109 18.5214 7.60385 18.8167 7.49931 19.1304L8.92233 19.6047ZM13.8918 18.75C14.257 18.75 14.4678 18.7511 14.6222 18.7688C14.6918 18.7767 14.728 18.786 14.7453 18.7917C14.7533 18.7944 14.7569 18.7962 14.7577 18.7965C14.7583 18.7969 14.7584 18.7969 14.7588 18.7972L15.6358 17.5803C15.3629 17.3836 15.0705 17.3102 14.7923 17.2784C14.5333 17.2489 14.2224 17.25 13.8918 17.25V18.75ZM16.5007 19.1304C16.3962 18.8168 16.2989 18.5214 16.189 18.2851C16.0709 18.0312 15.9087 17.777 15.6358 17.5803L14.7588 18.7972C14.7591 18.7975 14.7592 18.7975 14.7597 18.798C14.7603 18.7986 14.7631 18.8015 14.7682 18.8082C14.779 18.8228 14.7994 18.8542 14.8289 18.9178C14.8944 19.0586 14.9622 19.2583 15.0777 19.6047L16.5007 19.1304Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 10L19.4199 8.38675C19.5511 8.29927 19.6167 8.25553 19.6719 8.20545C19.8428 8.05046 19.9548 7.84117 19.989 7.61305C20 7.53935 20 7.46049 20 7.30278C20 7.02128 20 6.88054 19.9719 6.76444C19.8836 6.4005 19.5995 6.11635 19.2356 6.02814C19.1195 6 18.9787 6 18.6972 6L17 6L17 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 10L4.58013 8.38675C4.4489 8.29927 4.38329 8.25553 4.32809 8.20545C4.15725 8.05046 4.04524 7.84117 4.01105 7.61305C4 7.53935 4 7.46049 4 7.30278C4 7.02128 4 6.88054 4.02814 6.76444C4.11635 6.4005 4.4005 6.11635 4.76444 6.02814C4.88054 6 5.02128 6 5.30278 6L7 6L7 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 4H7L7 8.24124C7 9.36919 7 9.93317 7.18245 10.4321C7.30314 10.7622 7.4809 11.0685 7.7076 11.3371C8.0503 11.743 8.53997 12.0228 9.51929 12.5825L9.51931 12.5825C10.4844 13.1339 10.9669 13.4096 11.4834 13.4999C11.8252 13.5597 12.1748 13.5597 12.5166 13.4999C13.0331 13.4096 13.5156 13.1339 14.4807 12.5825C15.46 12.0228 15.9497 11.743 16.2924 11.3371C16.5191 11.0685 16.6969 10.7622 16.8176 10.4321C17 9.93317 17 9.3692 17 8.24126V8.24124V4Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6 3.25C5.58579 3.25 5.25 3.58579 5.25 4C5.25 4.41421 5.58579 4.75 6 4.75V3.25ZM18 4.75C18.4142 4.75 18.75 4.41421 18.75 4C18.75 3.58579 18.4142 3.25 18 3.25V4.75ZM7 8.24124H6.25H7ZM14.4807 12.5825L14.1086 11.9313L14.4807 12.5825ZM12.5166 13.4999L12.6457 14.2387H12.6457L12.5166 13.4999ZM9.51931 12.5825L9.89141 11.9313L9.86558 11.9165L9.83865 11.9038L9.51931 12.5825ZM11.4834 13.4999L11.3543 14.2387H11.3543L11.4834 13.4999ZM7.18245 10.4321L6.47806 10.6897L6.47806 10.6897L7.18245 10.4321ZM9.51929 12.5825L9.14719 13.2336L9.17302 13.2484L9.19995 13.2611L9.51929 12.5825ZM7.7076 11.3371L8.2807 10.8533H8.2807L7.7076 11.3371ZM16.8176 10.4321L17.5219 10.6897V10.6897L16.8176 10.4321ZM16.2924 11.3371L16.8655 11.8209V11.8209L16.2924 11.3371ZM6 4.75H7V3.25H6V4.75ZM7 4.75H17V3.25H7V4.75ZM17 4.75H18V3.25H17V4.75ZM17.75 8.24124V4H16.25V8.24124H17.75ZM6.25 4L6.25 8.24124H7.75L7.75 4L6.25 4ZM14.1086 11.9313C13.095 12.5105 12.7442 12.6988 12.3874 12.7611L12.6457 14.2387C13.322 14.1205 13.9363 13.7573 14.8528 13.2336L14.1086 11.9313ZM9.1472 13.2336C10.0637 13.7573 10.678 14.1205 11.3543 14.2387L11.6126 12.7611C11.2558 12.6988 10.905 12.5105 9.89141 11.9313L9.1472 13.2336ZM12.3874 12.7611C12.1311 12.8059 11.8689 12.8059 11.6126 12.7611L11.3543 14.2387C11.7815 14.3134 12.2185 14.3134 12.6457 14.2387L12.3874 12.7611ZM6.25 8.24124C6.25 9.31231 6.23917 10.0364 6.47806 10.6897L7.88684 10.1746C7.76083 9.82997 7.75 9.42608 7.75 8.24124H6.25ZM9.83865 11.9038L9.83864 11.9038L9.19995 13.2611L9.19996 13.2611L9.83865 11.9038ZM9.8914 11.9313C8.86269 11.3434 8.51738 11.1336 8.2807 10.8533L7.1345 11.8209C7.58323 12.3524 8.21726 12.7022 9.14719 13.2336L9.8914 11.9313ZM6.47806 10.6897C6.62893 11.1023 6.85112 11.4852 7.1345 11.8209L8.2807 10.8533C8.11067 10.6519 7.97736 10.4221 7.88684 10.1746L6.47806 10.6897ZM16.25 8.24124V8.24126H17.75V8.24124H16.25ZM16.25 8.24126C16.25 9.42608 16.2392 9.82998 16.1132 10.1746L17.5219 10.6897C17.7608 10.0364 17.75 9.31232 17.75 8.24126H16.25ZM14.8528 13.2336C15.7827 12.7022 16.4168 12.3524 16.8655 11.8209L15.7193 10.8533C15.4826 11.1336 15.1373 11.3434 14.1086 11.9313L14.8528 13.2336ZM16.1132 10.1746C16.0226 10.4221 15.8893 10.6519 15.7193 10.8533L16.8655 11.8209C17.1489 11.4852 17.3711 11.1023 17.5219 10.6897L16.1132 10.1746Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "trophy-3-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trophy","award","winner","promotion","discount","loyalty","reward","achievement","best-seller","top-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 18L16 18" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 6L18 6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 6L17 9C17 11.7614 14.7614 14 12 14V14V14C9.23858 14 7 11.7614 7 9L7 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M19 10L19 8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L5 8" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "trophy-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["trophy","award","winner","best-seller","achievement","reward","recognition","top-seller","promotion","loyalty","milestone","first-place"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 6L18.6972 6C18.9787 6 19.1195 6 19.2356 6.02814C19.5995 6.11635 19.8836 6.4005 19.9719 6.76444C20 6.88054 20 7.02128 20 7.30278V7.30278C20 7.46049 20 7.53935 19.989 7.61305C19.9548 7.84117 19.8428 8.05046 19.6719 8.20545C19.6167 8.25553 19.5511 8.29927 19.4199 8.38675L17 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 6L5.30278 6C5.02128 6 4.88054 6 4.76444 6.02814C4.4005 6.11635 4.11635 6.4005 4.02814 6.76444C4 6.88054 4 7.02128 4 7.30278V7.30278C4 7.46049 4 7.53935 4.01105 7.61305C4.04524 7.84117 4.15725 8.05046 4.32809 8.20545C4.38329 8.25553 4.4489 8.29927 4.58013 8.38675L7 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path d="M6 4L18 4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 4L17 8.24124C17 9.36919 17 9.93317 16.8176 10.4321C16.6969 10.7622 16.5191 11.0685 16.2924 11.3371C15.9497 11.743 15.46 12.0228 14.4807 12.5825V12.5825C13.5156 13.1339 13.0331 13.4096 12.5166 13.4999C12.1748 13.5597 11.8252 13.5597 11.4834 13.4999C10.9669 13.4096 10.4844 13.1339 9.51931 12.5825V12.5825C8.53997 12.0228 8.05031 11.743 7.7076 11.3371C7.4809 11.0685 7.30314 10.7622 7.18245 10.4321C7 9.93317 7 9.36919 7 8.24124L7 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 20L18 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 20L15.7892 19.3675C15.5692 18.7075 15.4592 18.3775 15.1973 18.1888C14.9354 18 14.5875 18 13.8918 18L10.1082 18C9.41246 18 9.0646 18 8.80272 18.1888C8.54083 18.3775 8.43082 18.7075 8.21082 19.3675L8 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "trophy-3-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","award","achievement","reward","loyalty","loyalty-program","winner","promotion","milestone","recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 5H6C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7V9C6 11.97 8.16 14.43 11 14.91V17H8C7.45 17 7 17.45 7 18C7 18.55 7.45 19 8 19H16C16.55 19 17 18.55 17 18C17 17.45 16.55 17 16 17H13V14.91C15.84 14.43 18 11.97 18 9V7C18.55 7 19 6.55 19 6C19 5.45 18.55 5 18 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 7C19.45 7 19 7.45 19 8V10C19 10.55 19.45 11 20 11C20.55 11 21 10.55 21 10V8C21 7.45 20.55 7 20 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7C3.45 7 3 7.45 3 8V10C3 10.55 3.45 11 4 11C4.55 11 5 10.55 5 10V8C5 7.45 4.55 7 4 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "trophy-3-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["trophy","award","winner","promotion","achievement","reward","loyalty","best-customer","employee-of-the-month","milestone","incentive","sales-goal","top-seller"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 18L16 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6H7L7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9L17 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path
                    d="M6 5.25C5.58579 5.25 5.25 5.58579 5.25 6C5.25 6.41421 5.58579 6.75 6 6.75V5.25ZM18 6.75C18.4142 6.75 18.75 6.41421 18.75 6C18.75 5.58579 18.4142 5.25 18 5.25V6.75ZM17 9H17.75V9L17 9ZM7 9H6.25H7ZM6 6.75H7V5.25H6V6.75ZM7 6.75H17V5.25H7V6.75ZM17 6.75H18V5.25H17V6.75ZM17.75 9L17.75 6L16.25 6L16.25 9L17.75 9ZM6.25 6L6.25 9H7.75L7.75 6L6.25 6ZM6.25 9C6.25 12.1756 8.82436 14.75 12 14.75V13.25C9.65279 13.25 7.75 11.3472 7.75 9H6.25ZM16.25 9C16.25 11.3472 14.3472 13.25 12 13.25V14.75C15.1756 14.75 17.75 12.1756 17.75 9H16.25Z"
                    fill={colors?.[1] || "#D9D1E0"}
                />
                <path d="M19 10L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L5 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "trophy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","award","winner","best","achievement","rewards","loyalty","loyalty-program","promotion","top-seller"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6L18 6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 6L17 9C17 11.7614 14.7614 14 12 14V14V14C9.23858 14 7 11.7614 7 9L7 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M8 18L16 18" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 10L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 10L5 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    trophy: {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","award","winner","best","achievement","rewards","loyalty","loyalty-program","promotion","top-seller"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4L18 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 4L17 8.24124C17 9.36919 17 9.93317 16.8176 10.4321C16.6969 10.7622 16.5191 11.0685 16.2924 11.3371C15.9497 11.743 15.46 12.0228 14.4807 12.5825V12.5825C13.5156 13.1339 13.0331 13.4096 12.5166 13.4999C12.1748 13.5597 11.8252 13.5597 11.4834 13.4999C10.9669 13.4096 10.4844 13.1339 9.51931 12.5825V12.5825C8.53997 12.0228 8.05031 11.743 7.7076 11.3371C7.4809 11.0685 7.30314 10.7622 7.18245 10.4321C7 9.93317 7 9.36919 7 8.24124L7 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M6 20L18 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M16 20L15.7892 19.3675C15.5692 18.7075 15.4592 18.3775 15.1973 18.1888C14.9354 18 14.5875 18 13.8918 18L10.1082 18C9.41246 18 9.0646 18 8.80272 18.1888C8.54083 18.3775 8.43082 18.7075 8.21082 19.3675L8 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 18L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 6L18.6972 6C18.9787 6 19.1195 6 19.2356 6.02814C19.5995 6.11635 19.8836 6.4005 19.9719 6.76444C20 6.88054 20 7.02128 20 7.30278V7.30278C20 7.46049 20 7.53935 19.989 7.61305C19.9548 7.84117 19.8428 8.05046 19.6719 8.20545C19.6167 8.25553 19.5511 8.29927 19.4199 8.38675L17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M7 6L5.30278 6C5.02128 6 4.88054 6 4.76444 6.02814C4.4005 6.11635 4.11635 6.4005 4.02814 6.76444C4 6.88054 4 7.02128 4 7.30278V7.30278C4 7.46049 4 7.53935 4.01105 7.61305C4.04524 7.84117 4.15725 8.05046 4.32809 8.20545C4.38329 8.25553 4.4489 8.29927 4.58013 8.38675L7 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "truck load-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","packages","freight","load","cargo","distribution","route","transit","shipment","supply chain","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 13.0001V11C2 10.0572 2 9.58579 2.29289 9.29289C2.58579 9 3.05719 9 4 9H5.99843M6 13.0001L5.99843 9M12 13.0001V7C12 6.05719 12 5.58579 11.7071 5.29289C11.4142 5 10.9428 5 10 5H7.99843C7.05562 5 6.58421 5 6.29132 5.29289C5.99843 5.58579 5.99843 6.05719 5.99843 7V9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 16V16C2 16.9279 2 17.3918 2.15081 17.7579C2.3544 18.252 2.74728 18.6441 3.24182 18.8467C3.60815 18.9968 4.07241 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H2V17.2857"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M14 12.0109V18.9998L15.9967 19M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck load-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["truck","delivery","shipping","freight","transport","logistics","inventory","stock","receiving","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 13.5V10.9992C2 10.0572 2 9.58615 2.29246 9.29333L2.29333 9.29246C2.58615 9 3.05717 9 3.99921 9C4.94126 9 5.41228 9 5.7051 9.29246L5.70597 9.29333C5.99843 9.58615 5.99843 10.0572 5.99843 10.9992V13.5H2Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 5H9C9.94281 5 10.4142 5 10.7071 5.29289C11 5.58579 11 6.05719 11 7V14H6V9.23529V7C6 6.05719 6 5.58579 6.29289 5.29289C6.58579 5 7.05719 5 8 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12L21.353 14.4383C21.654 16.561 21.8046 17.6223 21.2066 18.3112C20.6085 19 19.5365 19 17.3926 19H15.9967L14 18.9998V12.0109V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V18.9998L15.9967 19H17.3926C19.5365 19 20.6085 19 21.2066 18.3112C21.8046 17.6223 21.654 16.561 21.353 14.4383L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H4C3.05719 13 2.58579 13 2.29289 13.2929C2 13.5858 2 14.0572 2 15V17C2 17.9428 2 18.4142 2.29289 18.7071C2.58579 19 3.05719 19 4 19H11V15C11 14.0572 11 13.5858 10.7071 13.2929C10.4142 13 9.94281 13 9 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck load-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","load","route","distribution","goods"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.25 3.50001H8.25C7.17 3.50001 6.53 3.50001 6.01 4.01001C5.49 4.52001 5.5 5.17001 5.5 6.25001V7.56001C5.15 7.51001 4.75 7.50001 4.25 7.50001C3.18 7.50001 2.53 7.50001 2.01 8.01001C1.5 8.52001 1.5 9.17001 1.5 10.25V11.5H12V6.25001C12 5.17001 12 4.53001 11.49 4.01001C10.98 3.49001 10.33 3.50001 9.25 3.50001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22.35 13.58L22.27 13H13.51V18.25C13.51 18.66 13.85 19 14.26 19H15.16C15.1 18.76 15.06 18.51 15.06 18.25C15.06 17.99 15.1 17.74 15.16 17.5C15.5 16.1 16.76 15.05 18.26 15.05C19.48 15.05 20.52 15.74 21.06 16.74C21.21 17.02 21.33 17.31 21.39 17.63C21.43 17.83 21.45 18.04 21.45 18.25C21.45 18.35 21.43 18.44 21.42 18.54C21.64 18.41 21.85 18.26 22.02 18.06C22.84 17.11 22.68 15.86 22.35 13.58Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22.05 11.5L22 11.15C22 11.15 22 11.11 21.99 11.08L21.63 9.30002C21.3 7.65002 21.12 6.74002 20.36 6.12002C19.6 5.50002 18.67 5.50002 16.98 5.50002H14.25C13.84 5.50002 13.5 5.84002 13.5 6.25002V11.5H22.05Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.25 16.25C6.41 16.25 5.7 16.77 5.4 17.5C5.31 17.73 5.25 17.98 5.25 18.25C5.25 18.52 5.3 18.77 5.4 19C5.7 19.73 6.41 20.25 7.25 20.25C8.09 20.25 8.8 19.73 9.1 19C9.19 18.77 9.25 18.52 9.25 18.25C9.25 17.98 9.2 17.73 9.1 17.5C8.8 16.77 8.09 16.25 7.25 16.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.06 17.41C19.74 16.73 19.05 16.25 18.25 16.25C17.45 16.25 16.7 16.77 16.4 17.5C16.31 17.73 16.25 17.98 16.25 18.25C16.25 18.52 16.3 18.77 16.4 19C16.7 19.73 17.41 20.25 18.25 20.25C19.09 20.25 19.85 19.69 20.13 18.91C20.2 18.7 20.25 18.48 20.25 18.25C20.25 18.21 20.25 18.18 20.24 18.14C20.23 17.88 20.17 17.63 20.06 17.41Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.28001 13C9.28001 13 9.26001 13 9.25001 13H1.51001V14.23C1.51001 14.23 1.51001 14.24 1.51001 14.25V16.25C1.51001 17.33 1.51 17.98 2.02 18.49C2.52 18.98 3.15001 19 4.16001 19C4.10001 18.76 4.06001 18.51 4.06001 18.25C4.06001 17.99 4.10001 17.74 4.16001 17.5C4.50001 16.1 5.76001 15.05 7.26001 15.05C8.76001 15.05 10.02 16.1 10.36 17.5C10.42 17.74 10.46 17.99 10.46 18.25C10.46 18.51 10.42 18.76 10.36 19H11.26C11.67 19 12.01 18.66 12.01 18.25V13H9.28001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck load": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","load","transport","inventory","receiving","shipment","logistics","distribution"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 16V16C2 16.9279 2 17.3918 2.15081 17.7579C2.3544 18.252 2.74728 18.6441 3.24182 18.8467C3.60815 18.9968 4.07241 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H2V17.2857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M14 12.0109V18.9998L15.9967 19M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 15V11C2 10.0572 2 9.58579 2.29289 9.29289C2.58579 9 3.05719 9 4 9H5.99843M6 13.0001L5.99843 9M12 13.0001V7C12 6.05719 12 5.58579 11.7071 5.29289C11.4142 5 10.9428 5 10 5H7.99843C7.05562 5 6.58421 5 6.29132 5.29289C5.99843 5.58579 5.99843 6.05719 5.99843 7V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","out-for-delivery","courier","vehicle","dispatch"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 10H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 14H6" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M2 15V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464C3.60777 18.9968 4.07215 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "trophy-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["trophy","award","winner","achievement","reward","recognition","promotion","sale","best-seller","top-seller","loyalty","customer-reward"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 13.47L9.03 13.49C9.78 13.92 10.37 14.25 10.97 14.42V17.02H10.08C9.76 17.02 9.42999 17.02 9.14999 17.05C8.84999 17.08 8.51 17.17 8.19 17.4C7.87 17.63 7.68 17.93 7.56 18.2C7.45 18.44 7.34999 18.73 7.25999 19.02H5.98C5.43 19.02 4.98 19.47 4.98 20.02C4.98 20.57 5.43 21 5.98 21H17.98C18.53 21 18.98 20.57 18.98 20.02C18.98 19.47 18.53 19.02 17.98 19.02H16.7C16.6 18.73 16.51 18.44 16.4 18.2C16.27 17.92 16.09 17.63 15.77 17.4C15.45 17.17 15.11 17.09 14.81 17.05C14.53 17.02 14.21 17.02 13.88 17.02H12.99V14.42C13.6 14.25 14.2 13.91 14.97 13.47C15.81 12.99 16.44 12.63 16.92 12.13L21.02 9.22C21.21 9.08 21.3 9.01 21.39 8.93C21.7 8.62 21.9 8.23 21.97 7.8C21.99 7.69 22 7.55 22 7.31C22 6.95 21.99 6.75 21.93 6.51C21.75 5.8 21.2 5.25 20.5 5.07C20.25 5 20.04 5 19.68 5H18C18.55 5 19 4.55 19 4C19 3.45 18.55 3 18 3H6C5.45 3 5 3.45 5 4C5 4.55 5.45 5 6 5H4.31999C3.95999 5 3.74 5 3.5 5.06C2.79 5.24 2.24 5.79 2.06 6.5C2 6.74 2 6.96 2 7.32C2 7.55 2 7.67 2.02 7.79C2.09 8.22 2.28999 8.61 2.59999 8.92C2.67999 9 2.76999 9.07 2.95999 9.2L7.63 12.6C8.02 12.87 8.47 13.14 9.02 13.45M4 7.5C4 7.5 4 7.4 4 7.31C4 7.14 4 7.04 3.97 7C4.05 6.99 4.14999 7 4.31999 7H6V8.24C6 8.49 6 8.72 6 8.94L4.13 7.58C4.06 7.53 4.03 7.5 4 7.5ZM19.87 7.57L18 8.89C18 8.68 18 8.46 18 8.23V6.99H19.68C19.84 6.99 19.95 6.99 20 6.97C20 7.05 20 7.15 20 7.31C20 7.39 20 7.45 20.01 7.46C19.98 7.49 19.93 7.52 19.87 7.56V7.57Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","freight","logistics","route","out-for-delivery","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.19995 17.24C1.19995 17.65 1.53995 17.99 1.94995 17.99H3.76995C3.80995 17.44 3.97995 16.92 4.26995 16.49H1.94995C1.52995 16.49 1.19995 16.83 1.19995 17.24Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22.0499 12.57L21.8299 10.99H13.1999V16.49H9.61995C9.90995 16.93 10.0799 17.44 10.1199 17.99H14.7699C14.7899 17.73 14.8399 17.48 14.9199 17.24C15.0099 16.97 15.1199 16.72 15.2699 16.49C15.8399 15.62 16.8199 15.04 17.9399 15.04C18.9299 15.04 19.8099 15.5 20.3899 16.21C20.5499 16.4 20.6899 16.61 20.7999 16.84C20.91 17.07 21 17.31 21.0599 17.56C21.3099 17.43 21.5199 17.27 21.7099 17.05C22.5299 16.1 22.3499 14.85 22.0299 12.58L22.0499 12.57Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.57 9.49L21.33 8.31C21 6.65 20.82 5.74 20.06 5.12C19.3 4.5 18.37 4.5 16.68 4.5H13.95C13.54 4.5 13.2 4.84 13.2 5.25V9.49H21.57Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5 18.2001C5 19.3047 5.89502 20.2002 6.99908 20.2002C8.10314 20.2002 8.99815 19.3046 8.99815 18.2C8.99815 17.0954 8.10314 16.2 6.99908 16.2C5.89502 16.2 5 17.0955 5 18.2001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.999 18.2001C15.999 19.3047 16.894 20.2002 17.9981 20.2002C19.1022 20.2002 19.9972 19.3046 19.9972 18.2C19.9972 17.0954 19.1022 16.2 17.9981 16.2C16.894 16.2 15.999 17.0955 15.999 18.2001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","freight","out-for-delivery","route","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00092 16.9941L2 17.0002"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17H16.0009"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H16.7275C18.297 5 19.0817 5 19.6346 5.45319C20.1876 5.90638 20.3416 6.67585 20.6497 8.21477L21.0071 10L21.353 12.4383C21.654 14.561 21.8046 15.6223 21.2066 16.3112C20.6085 17 19.5365 17 17.3926 17H15.9967L14 16.9998V10.0109V5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 10.0109L21.0071 10M14 10.0109V16.9998L15.9967 17H17.3926C19.5365 17 20.6085 17 21.2066 16.3112C21.8046 15.6223 21.654 14.561 21.353 12.4383L21.0071 10M14 10.0109V5H16.7275C18.297 5 19.0817 5 19.6346 5.45319C20.1876 5.90638 20.3416 6.67585 20.6497 8.21477L21.0071 10"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9.25H13.25V10.75H14V9.25ZM21.5 10.75C21.9142 10.75 22.25 10.4142 22.25 10C22.25 9.58579 21.9142 9.25 21.5 9.25V10.75ZM14 10.75H21.5V9.25H14V10.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M5.00098 17.0001C5.00098 18.1047 5.89599 19.0002 7.00005 19.0002C8.10411 19.0002 8.99913 18.1046 8.99913 17C8.99913 15.8954 8.10411 15 7.00005 15C5.89599 15 5.00098 15.8955 5.00098 17.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 17.0001C16 18.1047 16.895 19.0002 17.9991 19.0002C19.1031 19.0002 19.9982 18.1046 19.9982 17C19.9982 15.8954 19.1031 15 17.9991 15C16.895 15 16 15.8955 16 17.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","outgoing","shipment","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 16H4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M2 16V16C2 16.9279 2 17.3918 2.15081 17.7579C2.3544 18.252 2.74728 18.6441 3.24182 18.8467C3.60815 18.9968 4.07241 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H6C4.11438 13 3.17157 13 2.58579 13.5858C2 14.1716 2 15.1144 2 17V17.2857"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M14 12.0109V18.9998L15.9967 19M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","freight","distribution","pickup","cargo","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 16V16C2 16.9279 2 17.3918 2.15081 17.7579C2.3544 18.252 2.74728 18.6441 3.24182 18.8467C3.60815 18.9968 4.07241 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H6C4.11438 13 3.17157 13 2.58579 13.5858C2 14.1716 2 15.1144 2 17V17.2857"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M14 12.0109V18.9998L15.9967 19M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2 16H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "truck-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0992 6.38853C19.6688 6.02935 19.1715 5.88138 18.6256 5.81374C18.1107 5.74996 17.4733 5.74998 16.7149 5.75L14.0001 5.75001C13.5859 5.75001 13.2501 6.08579 13.2501 6.5L13.2501 10.75H21.5001C21.5142 10.75 21.5283 10.7504 21.5422 10.7512L21.3335 9.60398C21.1977 8.85778 21.0836 8.23058 20.9286 7.73547C20.7643 7.21048 20.5297 6.74772 20.0992 6.38853Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.7918 12.1911C21.7022 12.229 21.6036 12.25 21.5001 12.25L4.97486 12.25C4.53042 12.25 4.15934 12.25 3.85474 12.2708C3.53764 12.2924 3.23812 12.3391 2.94773 12.4593C2.2739 12.7384 1.73855 13.2738 1.45944 13.9476C1.33916 14.238 1.29251 14.5375 1.27088 14.8546C1.26261 14.9758 1.25764 15.1074 1.25464 15.25H2.50011C2.91432 15.25 3.25011 15.5858 3.25011 16C3.25011 16.4142 2.91432 16.75 2.50011 16.75H1.25464C1.25764 16.8926 1.26261 17.0242 1.27088 17.1454C1.29251 17.4625 1.33916 17.762 1.45944 18.0524C1.73855 18.7262 2.2739 19.2616 2.94773 19.5407C3.23812 19.661 3.53764 19.7076 3.85474 19.7292L3.88391 19.7311C3.82906 19.4963 3.80005 19.2516 3.80005 19.0001C3.80005 17.2333 5.23176 15.8 6.99913 15.8C8.76643 15.8 10.1982 17.2332 10.1982 19C10.1982 19.2583 10.1676 19.5094 10.1099 19.75H14.8884C14.8306 19.5095 14.8 19.2584 14.8 19.0001C14.8 17.2333 16.2318 15.8 17.9991 15.8C19.7664 15.8 21.1982 17.2332 21.1982 19C21.1982 19.0955 21.194 19.19 21.1858 19.2833C21.4006 19.1612 21.5979 19.0046 21.773 18.8028C22.2405 18.2643 22.3676 17.615 22.367 16.9118C22.3665 16.242 22.2474 15.4027 22.1036 14.3889L21.7918 12.1911Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.00005 19.0001C5.00005 20.1047 5.89502 21.0002 6.99908 21.0002C8.10314 21.0002 8.9982 20.1047 8.9982 19C8.9982 17.8954 8.10319 17 6.99913 17C5.89507 17 5.00005 17.8955 5.00005 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1047 19.9982 19C19.9982 17.8954 19.1032 17 17.9991 17C16.8951 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["truck","delivery","shipping","transport","vehicle","distribution","logistics","out-for-delivery","order-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12L21.353 14.4383C21.654 16.561 21.8046 17.6223 21.2066 18.3112C20.6085 19 19.5365 19 17.3926 19H15.9967L14 18.9998V12.0109V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V18.9998L15.9967 19H17.3926C19.5365 19 20.6085 19 21.2066 18.3112C21.8046 17.6223 21.654 16.561 21.353 14.4383L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.24114 18.8464C3.60777 18.9968 8.07123 19.0019 9 19H14V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 13H5C4.06812 13 3.60218 13 3.23463 13.1522C2.74458 13.3552 2.35523 13.7446 2.15224 14.2346C2 14.6022 2 15.0681 2 16C2 16.9319 2 17.3978 2.15224 17.7654C2.35523 18.2554 2.74458 18.6448 3.23463 18.8478C3.60218 19 4.06812 19 5 19H17C17.9319 19 18.3978 19 18.7654 18.8478C19.2554 18.6448 19.6448 18.2554 19.8478 17.7654C20 17.3978 20 16.9319 20 16C20 15.0681 20 14.6022 19.8478 14.2346C19.6448 13.7446 19.2554 13.3552 18.7654 13.1522C18.3978 13 17.9319 13 17 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6.5H16.6684C18.2642 6.5 19.0621 6.5 19.6186 6.96438C20.1751 7.42877 20.318 8.21377 20.6038 9.78377L21.0071 12L21.353 14.4383C21.654 16.561 21.8046 17.6223 21.2066 18.3112C20.6085 19 19.5365 19 17.3926 19H15.9967L14 18.9998V12.0109L14 6.5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V18.9998L15.9967 19H17.3926C19.5365 19 20.6085 19 21.2066 18.3112C21.8046 17.6223 21.654 16.561 21.353 14.4383L21.0071 12M14 12.0109L14 6.5H16.6684C18.2642 6.5 19.0621 6.5 19.6186 6.96438C20.1751 7.42877 20.318 8.21377 20.6038 9.78377L21.0071 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10.75H13.25V12.25H14V10.75ZM21.5 12.25C21.9142 12.25 22.25 11.9142 22.25 11.5C22.25 11.0858 21.9142 10.75 21.5 10.75V12.25ZM14 12.25H21.5V10.75H14V12.25Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M2 15.25H1.25V16.75H2V15.25ZM3 16.75C3.41421 16.75 3.75 16.4142 3.75 16C3.75 15.5858 3.41421 15.25 3 15.25V16.75ZM2 16.75H3V15.25H2V16.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery","route","order-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 15V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464C3.60777 18.9968 4.07215 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 9H6" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "truck-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery","route","transit","moving","shipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.06 17.8889C19.74 17.2089 19.05 16.7289 18.25 16.7289C17.45 16.7289 16.7 17.2489 16.4 17.9789C16.31 18.2089 16.25 18.4589 16.25 18.7289C16.25 18.9989 16.3 19.2489 16.4 19.4789C16.7 20.2089 17.41 20.7289 18.25 20.7289C19.09 20.7289 19.85 20.1689 20.13 19.3889C20.2 19.1789 20.25 18.9589 20.25 18.7289C20.25 18.6889 20.25 18.6589 20.24 18.6189C20.23 18.3589 20.17 18.1089 20.06 17.8889Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.25 16.7289C6.43 16.7289 5.72 17.2289 5.41 17.9489C5.31 18.1789 5.26 18.4289 5.25 18.6989C5.25 18.6989 5.25 18.7289 5.25 18.7389C5.25 18.9889 5.3 19.2289 5.39 19.4589C5.68 20.2089 6.4 20.7389 7.25 20.7389C8.1 20.7389 8.8 20.2189 9.1 19.4889C9.14 19.3989 9.17 19.2989 9.19 19.1989C9.22 19.0489 9.25 18.8989 9.25 18.7389C9.25 18.4689 9.2 18.2189 9.1 17.9889C8.8 17.2589 8.09 16.7389 7.25 16.7389V16.7289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M22.35 14.0589L22.13 12.4889H15.01V10.9889L19.78 10.9789H21.88L21.64 9.7989C21.31 8.1389 21.13 7.2289 20.37 6.6089C19.61 5.9889 18.68 5.9889 16.99 5.9889H14.85C14.85 5.9889 14.84 5.9489 14.83 5.9289C14.81 5.8389 14.78 5.7489 14.75 5.6689C14.73 5.6189 14.72 5.5689 14.7 5.5289C14.66 5.4289 14.6 5.3289 14.55 5.2389C14.53 5.2089 14.52 5.1789 14.5 5.1489C14.42 5.0289 14.33 4.9189 14.23 4.8089C14.23 4.8089 14.23 4.8089 14.22 4.7989C14.11 4.6889 14 4.5989 13.88 4.5189C13.85 4.4989 13.82 4.4889 13.79 4.4689C13.69 4.4089 13.6 4.3589 13.49 4.3089C13.45 4.2889 13.4 4.2789 13.35 4.2589C13.26 4.2289 13.17 4.1989 13.08 4.1689C13.01 4.1489 12.93 4.1389 12.85 4.1189C12.78 4.1089 12.71 4.0889 12.64 4.0789C12.62 4.0789 12.59 4.0689 12.57 4.0689C12.48 4.0589 12.38 4.0489 12.29 4.0389C12.25 4.0389 12.21 4.0389 12.16 4.0289C12.02 4.0189 11.87 4.0089 11.71 4.0089C11.67 4.0089 11.64 4.0089 11.61 4.0089C11.43 4.0089 11.24 4.0089 11.04 4.0089C11.02 4.0089 11.01 4.0089 10.99 4.0089C10.85 4.0089 10.69 4.0089 10.54 4.0089C10.45 4.0089 10.37 4.0089 10.28 4.0089H6.25C4.23 3.9789 3.11 3.9789 2.31 4.7889C1.51 5.5989 1.5 6.7089 1.5 8.7289V8.9789H6.25C6.66 8.9789 7 9.3189 7 9.7289C7 10.1389 6.66 10.4789 6.25 10.4789H1.5V11.9789H6.25C6.66 11.9789 7 12.3189 7 12.7289C7 13.1389 6.66 13.4789 6.25 13.4789H1.5V15.7289C1.5 16.7189 1.5 17.2689 1.71 17.7689C1.99 18.4389 2.53 18.9889 3.21 19.2689C3.28 19.2989 3.41 19.3489 4.13 19.3989C4.08 19.1789 4.06 18.9589 4.06 18.7289C4.06 18.6989 4.06 18.6689 4.06 18.6389C4.06 18.3789 4.11 18.1389 4.17 17.8989C4.54 16.5389 5.77 15.5289 7.25 15.5289C8.73 15.5289 10.01 16.5789 10.35 17.9789C10.41 18.2189 10.45 18.4689 10.45 18.7289C10.45 18.9889 10.41 19.2389 10.35 19.4789H15.15C15.09 19.2389 15.05 18.9889 15.05 18.7289C15.05 18.4689 15.09 18.2189 15.15 17.9789C15.49 16.5789 16.75 15.5289 18.25 15.5289C19.47 15.5289 20.51 16.2189 21.05 17.2189C21.2 17.4989 21.32 17.7889 21.38 18.1089C21.42 18.3089 21.44 18.5189 21.44 18.7289C21.44 18.8289 21.42 18.9189 21.41 19.0189C21.63 18.8889 21.84 18.7389 22.01 18.5389C22.83 17.5889 22.67 16.3289 22.35 14.0589Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12L21.353 14.4383C21.654 16.561 21.8046 17.6223 21.2066 18.3112C20.6085 19 19.5365 19 17.3926 19H15.9967L14 18.9998V12.0109V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 12.0109L21.0071 12M14 12.0109V18.9998L15.9967 19H17.3926C19.5365 19 20.6085 19 21.2066 18.3112C21.8046 17.6223 21.654 16.561 21.353 14.4383L21.0071 12M14 12.0109V7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.24114 18.8464C3.60777 18.9968 8.07123 19.0019 9 19H14V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M4 9H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "truck-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","van","moving","package","send","receive","courier","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.34 14.07L22.12 12.49H15V11H21.87L21.63 9.81C21.3 8.15 21.12 7.24 20.36 6.62C19.6 6 18.67 6 16.98 6H14.83C14.72 5.52 14.52 5.14 14.19 4.81C13.38 4 12.27 4 10.25 4H6.25C4.23 4 3.11 4 2.31 4.81C1.51 5.62 1.5 6.73 1.5 8.75V15.75C1.5 16.74 1.5 17.29 1.71 17.79C1.99 18.46 2.53 19.01 3.21 19.29C3.28 19.32 3.41 19.37 4.13 19.42C4.08 19.2 4.06 18.98 4.06 18.75C4.06 18.72 4.06 18.69 4.06 18.66C4.06 18.4 4.11 18.16 4.17 17.92C4.54 16.56 5.77 15.55 7.25 15.55C8.73 15.55 10.01 16.6 10.35 18C10.41 18.24 10.45 18.49 10.45 18.75C10.45 19.01 10.41 19.26 10.35 19.5H15.15C15.09 19.26 15.05 19.01 15.05 18.75C15.05 18.49 15.09 18.24 15.15 18C15.49 16.6 16.75 15.55 18.25 15.55C19.47 15.55 20.51 16.24 21.05 17.24C21.2 17.52 21.32 17.81 21.38 18.13C21.42 18.33 21.44 18.54 21.44 18.75C21.44 18.85 21.42 18.94 21.41 19.04C21.63 18.91 21.84 18.76 22.01 18.56C22.83 17.61 22.65 16.36 22.33 14.09L22.34 14.07ZM6.24 9.49H4.24C3.83 9.49 3.49 9.15 3.49 8.74C3.49 8.33 3.83 7.99 4.24 7.99H6.24C6.65 7.99 6.99 8.33 6.99 8.74C6.99 9.15 6.65 9.49 6.24 9.49Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.24001 16.74C6.42001 16.74 5.71001 17.24 5.40001 17.96C5.30001 18.19 5.25001 18.44 5.24001 18.71C5.24001 18.72 5.24001 18.74 5.24001 18.75C5.24001 19 5.29 19.24 5.38 19.47C5.67 20.22 6.39001 20.75 7.24001 20.75C8.09001 20.75 8.79 20.23 9.09 19.5C9.18 19.27 9.24001 19.02 9.24001 18.75C9.24001 18.48 9.19 18.23 9.09 18C8.79 17.27 8.08001 16.75 7.24001 16.75V16.74Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.05 17.9C19.73 17.22 19.04 16.74 18.24 16.74C17.44 16.74 16.69 17.26 16.39 17.99C16.3 18.22 16.24 18.47 16.24 18.74C16.24 19.01 16.29 19.26 16.39 19.49C16.69 20.22 17.4 20.74 18.24 20.74C19.08 20.74 19.84 20.18 20.12 19.4C20.19 19.19 20.24 18.97 20.24 18.74C20.24 18.7 20.24 18.67 20.23 18.63C20.22 18.37 20.16 18.12 20.05 17.9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "truck-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","logistics","out-for-delivery","route","vehicle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00092 16.9941L2 17.0002"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5L14 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 17.0001C5.00098 18.1047 5.89599 19.0002 7.00005 19.0002C8.10411 19.0002 8.99913 18.1046 8.99913 17C8.99913 15.8954 8.10411 15 7.00005 15C5.89599 15 5.00098 15.8955 5.00098 17.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17.0001C16 18.1047 16.895 19.0002 17.9991 19.0002C19.1031 19.0002 19.9982 18.1046 19.9982 17C19.9982 15.8954 19.1031 15 17.9991 15C16.895 15 16 15.8955 16 17.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10.0109L21.0071 10M14 5H16.7275C18.297 5 19.0817 5 19.6346 5.45319C20.1876 5.90638 20.3416 6.67585 20.6497 8.21477L21.0071 10M21.0071 10L21.72 15.0259C21.8678 16.0682 21.0588 17 20.0061 17V17M14 16.9998L15.9967 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","vehicle","out-for-delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 10.0109L21.0071 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00092 16.9941L2 17.0002"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5L14 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 17H16.0009"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 5H16.7275C18.297 5 19.0817 5 19.6346 5.45319C20.1876 5.90638 20.3416 6.67585 20.6497 8.21477L21.0071 10L21.72 15.0259C21.8678 16.0682 21.0588 17 20.0061 17V17M14 16.9998L15.9967 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 17.0001C5.00098 18.1047 5.89599 19.0002 7.00005 19.0002C8.10411 19.0002 8.99913 18.1046 8.99913 17C8.99913 15.8954 8.10411 15 7.00005 15C5.89599 15 5.00098 15.8955 5.00098 17.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 17.0001C16 18.1047 16.895 19.0002 17.9991 19.0002C19.1031 19.0002 19.9982 18.1046 19.9982 17C19.9982 15.8954 19.1031 15 17.9991 15C16.895 15 16 15.8955 16 17.0001Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-ramp-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["circle","ring","donut","void","zero","none","empty","cancel","void-transaction","refund","discount","remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 19.1694L15.5 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="18.319"
                    cy="16.1066"
                    r="2.68082"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","delivery","shipping","transport","van","out-for-delivery","transit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 15V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464C3.60777 18.9968 4.07215 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 9H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "truck-ramp-3": {
        defaultColors: ["#000000"],
        keywords: ["truck","ramp","delivery","shipping","receiving","inventory","transport","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6C14 4.89543 14.8954 4 16 4H19.9995C21.1041 4 21.9995 4.89543 21.9995 6V16C21.9995 16.0122 21.9994 16.0241 21.9992 16.0358C21.9996 16.0594 21.9998 16.083 21.9998 16.1067C21.9998 18.1396 20.3519 19.7876 18.319 19.7876C16.6698 19.7876 15.2739 18.7029 14.8058 17.208L3.24602 20.139C2.71067 20.2747 2.16665 19.9508 2.03091 19.4154C1.89517 18.8801 2.21912 18.3361 2.75446 18.2003L14 15.349V6ZM16.6382 16.1067C16.6382 15.1784 17.3907 14.4259 18.319 14.4259C19.2473 14.4259 19.9998 15.1784 19.9998 16.1067C19.9998 17.035 19.2473 17.7876 18.319 17.7876C17.3907 17.7876 16.6382 17.035 16.6382 16.1067Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "truck-ramp-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["circle","button","status","indicator","round","complete","finished"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 19.1694L15.5 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="18.319"
                    cy="16.1066"
                    r="2.68082"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-ramp-box-2": {
        defaultColors: ["#cdd1d8", "#000000"],
        keywords: ["package","box","circle","weight","scale","calculate-weight","shipping","delivery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 19.1694L15.5 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.81267 9.65212C5.42113 9.74818 5.07293 9.83361 4.80111 9.94039C4.50566 10.0565 4.2204 10.2269 4.03015 10.5409C3.83989 10.8549 3.82089 11.1867 3.8548 11.5023C3.886 11.7927 3.97148 12.1409 4.06761 12.5324L4.48722 14.242C4.58329 14.6336 4.66871 14.9818 4.7755 15.2536C4.89156 15.5491 5.062 15.8343 5.37603 16.0246C5.69005 16.2148 6.02181 16.2338 6.33742 16.1999C6.62779 16.1687 6.97596 16.0832 7.36748 15.9871L9.82244 15.3846C10.214 15.2885 10.5622 15.2031 10.834 15.0963C11.1295 14.9802 11.4147 14.8098 11.605 14.4958C11.7952 14.1817 11.8142 13.85 11.7803 13.5344C11.7491 13.244 11.6636 12.8958 11.5675 12.5043L11.1479 10.7947C11.0518 10.4031 10.9664 10.0549 10.8596 9.78308C10.7436 9.48764 10.5731 9.20238 10.2591 9.01212C9.94506 8.82186 9.61331 8.80286 9.2977 8.83677C9.00732 8.86797 8.65914 8.95346 8.26761 9.04959L5.81267 9.65212Z"
                    fill={colors?.[0] || "#CDD1D8"}
                />
                <path
                    d="M8.34438 9.03067L5.73586 9.67089L6.11602 11.2199C6.14138 11.3235 6.17236 11.4501 6.21391 11.5559C6.26444 11.6845 6.35879 11.8601 6.55727 11.9804C6.75575 12.1006 6.95508 12.1029 7.09248 12.0882C7.20548 12.076 7.33205 12.0449 7.43564 12.0194L7.92505 11.8993C8.02868 11.8739 8.1553 11.8429 8.26107 11.8014C8.3897 11.7508 8.5653 11.6565 8.68555 11.458C8.80581 11.2595 8.80813 11.0602 8.79337 10.9228C8.78123 10.8098 8.75007 10.6832 8.72456 10.5796L8.34438 9.03067Z"
                    fill={colors?.[1] || "#000000"}
                />
                <circle
                    cx="18.319"
                    cy="16.1066"
                    r="2.68082"
                    fill={colors?.[0] || "#CDD1D8"}
                    stroke={colors?.[0] || "#CDD1D8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-ramp-box-1": {
        defaultColors: ["#7e47e1", "#000000"],
        keywords: ["ramp","inventory","loading","unloading","receiving","delivery","stock","goods","transfer","shipment","dock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18.319" cy="16.1066" r="2.68082" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M3 19.1694L15.5 16" stroke={colors?.[1] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[1] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.0198 8.87207L5.96676 9.6613C5.43102 9.74498 5.05958 10.2404 5.1294 10.7781L5.78996 15.8649"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.17969 9.24023L9.70398 12.5422"
                    stroke={colors?.[0] || "#7E47E1"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-ramp-box": {
        defaultColors: ["#000000"],
        keywords: ["delivery","truck","box","package","shipping","receiving","inventory","stock","transport","supply-chain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18.319" cy="16.1066" r="2.68082" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M3 19.1694L15.5 16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.0198 8.87207L5.96676 9.6613C5.43102 9.74498 5.05958 10.2404 5.1294 10.7781L5.78996 15.8649"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.17969 9.24023L9.70398 12.5422"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "truck-ramp": {
        defaultColors: ["#000000"],
        keywords: ["truck","ramp","loading","delivery","shipping","receiving","transport","dock","freight","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18.319" cy="16.1066" r="2.68082" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M3 19.1694L15.5 16" stroke={colors?.[0] || "#000000"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.9997 5H14.7231C14.1709 5 13.7231 5.44772 13.7231 6V16"
                    stroke={colors?.[0] || "#000000"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    truck: {
        defaultColors: ["#3D4C66"],
        keywords: ["truck","ramp","loading","delivery","shipping","receiving","transport","dock","freight","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 15V15.9991C2 16.9278 2 17.3922 2.15109 17.7586C2.35467 18.2521 2.74715 18.6438 3.24114 18.8464C3.60777 18.9968 4.07215 18.9958 5.00092 18.994V18.994"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 19V9C14 7.11438 14 6.17157 13.4142 5.58579C12.8284 5 11.8856 5 10 5H6C4.11438 5 3.17157 5 2.58579 5.58579C2 6.17157 2 7.11438 2 9V15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19H16.0009"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.00098 19.0001C5.00098 20.1047 5.89599 21.0002 7.00005 21.0002C8.10411 21.0002 8.99913 20.1046 8.99913 19C8.99913 17.8954 8.10411 17 7.00005 17C5.89599 17 5.00098 17.8955 5.00098 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 19.0001C16 20.1047 16.895 21.0002 17.9991 21.0002C19.1031 21.0002 19.9982 20.1046 19.9982 19C19.9982 17.8954 19.1031 17 17.9991 17C16.895 17 16 17.8955 16 19.0001Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12.0109L21.0071 12M14 7H16.7275C18.297 7 19.0817 7 19.6346 7.45319C20.1876 7.90638 20.3416 8.67585 20.6497 10.2148L21.0071 12M21.0071 12L21.72 17.0259C21.8678 18.0682 21.0588 19 20.0061 19V19M14 18.9998L15.9967 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2 10H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 14H6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "truck-ramp-box-3": {
        defaultColors: ["#000000"],
        keywords: ["delivery","truck","box","package","shipping","receiving","inventory","transport","logistics"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.48588 9.45124L6.86602 11.0001C6.89138 11.1038 6.92236 11.2304 6.96391 11.3362C7.01444 11.4648 7.10879 11.6404 7.30727 11.7606C7.50575 11.8809 7.70508 11.8832 7.84248 11.8685C7.95548 11.8563 8.08205 11.8252 8.18564 11.7996L8.67505 11.6795C8.77868 11.6542 8.9053 11.6232 9.01107 11.5816C9.1397 11.5311 9.3153 11.4368 9.43555 11.2383C9.55581 11.0398 9.55813 10.8405 9.54337 10.7031C9.53123 10.5901 9.50007 10.4635 9.47456 10.3599L9.0944 8.81102C9.45476 8.72271 9.77645 8.64619 10.0477 8.61705C10.3633 8.58314 10.6951 8.60214 11.0091 8.7924C11.3231 8.98265 11.4936 9.26791 11.6096 9.56336C11.7164 9.83518 11.8018 10.1834 11.8979 10.5749L12.3175 12.2846C12.4136 12.6761 12.4991 13.0243 12.5303 13.3147C12.5642 13.6303 12.5452 13.962 12.355 14.276C12.1647 14.5901 11.8795 14.7605 11.584 14.8766C11.3122 14.9834 10.964 15.0688 10.5724 15.1649L8.11748 15.7674C7.72596 15.8635 7.37779 15.949 7.08742 15.9802C6.77181 16.0141 6.44005 15.9951 6.12603 15.8048C5.812 15.6146 5.64156 15.3293 5.5255 15.0339C5.41871 14.7621 5.33329 14.4139 5.23722 14.0223L4.81761 12.3127C4.72148 11.9211 4.636 11.573 4.6048 11.2826C4.57089 10.967 4.58989 10.6352 4.78015 10.3212C4.9704 10.0072 5.25566 9.83673 5.55111 9.72067C5.80503 9.62092 6.12559 9.5398 6.48588 9.45124Z"
                    fill={colors?.[0] || "#000000"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6C14 4.89543 14.8954 4 16 4H19.9995C21.1041 4 21.9995 4.89543 21.9995 6V16C21.9995 16.0122 21.9994 16.0241 21.9992 16.0358C21.9996 16.0594 21.9998 16.083 21.9998 16.1067C21.9998 18.1396 20.3519 19.7876 18.319 19.7876C16.6698 19.7876 15.2739 18.7029 14.8058 17.208L3.24602 20.139C2.71067 20.2747 2.16665 19.9508 2.03091 19.4154C1.89517 18.8801 2.21912 18.3361 2.75446 18.2003L14 15.349V6ZM16.6382 16.1067C16.6382 15.1784 17.3907 14.4259 18.319 14.4259C19.2473 14.4259 19.9998 15.1784 19.9998 16.1067C19.9998 17.035 19.2473 17.7876 18.319 17.7876C17.3907 17.7876 16.6382 17.035 16.6382 16.1067Z"
                    fill={colors?.[0] || "#000000"}
                />
            </svg>
        )
    },
    "tumblr-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tumblr","social media","marketing","promotion","blog","share","network","community"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7C11 8.65685 9.65685 10 8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V16C11 17.6569 12.3431 19 14 19H16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "tumblr-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["t","tumblr","social-media","network","share","promote","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18H14C12.9 18 12 17.1 12 16V11H14C14.55 11 15 10.55 15 10C15 9.45 14.55 9 14 9H12V5C12 4.45 11.55 4 11 4C10.45 4 10 4.45 10 5V7C10 8.1 9.1 9 8 9C7.45 9 7 9.45 7 10C7 10.55 7.45 11 8 11H10V16C10 18.21 11.79 20 14 20H16C16.55 20 17 19.55 17 19C17 18.45 16.55 18 16 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    tumblr: {
        defaultColors: ["#3D4C66"],
        keywords: ["t","tumblr","social-media","network","share","promote","marketing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10H14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7C11 8.65685 9.65685 10 8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V16C11 17.6569 12.3431 19 14 19H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv old style-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tv","old","style","retro","television","display","entertainment","media","broadcast","screen","video","channel","vintage","obsolete"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4L11 6H13L14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2427 6 15.8284 6 13 6H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 13C16 11.1144 16 10.1716 15.4142 9.58579C15.4142 9.58579 15.4142 9.58578 15.4142 9.58578C14.8284 9 13.8856 9 12 9V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv old style-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tv","television","display","screen","announcement","news","update","information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4L11 6H13L14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 15V13C5 10.1716 5 8.75736 5.87868 7.87868C6.75736 7 8.17157 7 11 7H13C15.8284 7 17.2426 7 18.1213 7.87868C19 8.75736 19 10.1716 19 13V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.4142 10.5858C16 11.1716 16 12.1144 16 14C16 15.8856 16 16.8284 15.4142 17.4142C14.8284 18 13.8856 18 12 18C10.1144 18 9.17157 18 8.58579 17.4142C8 16.8284 8 15.8856 8 14C8 12.1144 8 11.1716 8.58579 10.5858C9.17157 10 10.1144 10 12 10C13.8856 10 14.8284 10 15.4142 10.5858Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "tumblr-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["tumblr","social media","share","network","blog"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10H14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V7C11 8.65685 9.65685 10 8 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 5V16C11 17.6569 12.3431 19 14 19H16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv old style": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","old","style","retro","tube","display","monitor","entertainment","video","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4L11 6H13L14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 12C19 9.17157 19 7.75736 18.1213 6.87868C17.2427 6 15.8284 6 13 6H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 13C16 11.1144 16 10.1716 15.4142 9.58579C15.4142 9.58579 15.4142 9.58578 15.4142 9.58578C14.8284 9 13.8856 9 12 9V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "TV-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tv","display","screen","advertisement","promotion","menu","digital-menu","queue","order-status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 4L11.2 6H12.8L14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13C7 13.9319 7 14.3978 7.15224 14.7654C7.35523 15.2554 7.74458 15.6448 8.23463 15.8478C8.60218 16 9.06812 16 10 16H14C14.9319 16 15.3978 16 15.7654 15.8478C16.2554 15.6448 16.6448 15.2554 16.8478 14.7654C17 14.3978 17 13.9319 17 13C17 12.0681 17 11.6022 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Tv old style-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","television","display","media","entertainment","promotion","advertisement","screen","customer-display","order-display","menu-board"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.55276 3.10579C10.0467 2.8588 10.6474 3.05903 10.8944 3.55301L11.618 5.00022H12.3819L13.1055 3.55301C13.3525 3.05903 13.9532 2.8588 14.4472 3.10579C14.9412 3.35278 15.1414 3.95345 14.8944 4.44743L14.6139 5.00835C15.2996 5.02009 15.903 5.0488 16.4251 5.119C17.3529 5.24374 18.1723 5.51571 18.8284 6.17182C19.4845 6.82793 19.7565 7.64735 19.8813 8.57518C20.0001 9.45892 20 10.5756 20 11.9297V14.0709C20 15.425 20.0001 16.5416 19.8813 17.4253C19.7565 18.3531 19.4845 19.1726 18.8284 19.8287C18.1723 20.4848 17.3529 20.7568 16.4251 20.8815C15.5413 21.0003 14.4247 21.0003 13.0706 21.0002H10.9294C9.57527 21.0003 8.45868 21.0003 7.57494 20.8815C6.64711 20.7568 5.82769 20.4848 5.17158 19.8287C4.51547 19.1726 4.2435 18.3531 4.11876 17.4253C3.99994 16.5416 3.99997 15.4249 4 14.0709V11.9296C3.99997 10.5755 3.99994 9.45892 4.11876 8.57518C4.2435 7.64735 4.51547 6.82793 5.17158 6.17182C5.82769 5.51571 6.64711 5.24374 7.57494 5.119C8.09704 5.04881 8.70041 5.02009 9.38601 5.00835L9.10555 4.44743C8.85856 3.95345 9.05878 3.35278 9.55276 3.10579ZM11.9342 8.00025H12.0658C12.9523 8.0002 13.7161 8.00015 14.3278 8.08239C14.9833 8.17052 15.6117 8.36927 16.1213 8.87893C16.631 9.38859 16.8297 10.0169 16.9179 10.6725C17.0001 11.2841 17.0001 12.0479 17 12.9344V13.0661C17.0001 13.9526 17.0001 14.7164 16.9179 15.328C16.8297 15.9836 16.631 16.6119 16.1213 17.1216C15.6117 17.6312 14.9833 17.83 14.3278 17.9181C13.7161 18.0003 12.9523 18.0003 12.0658 18.0003H11.9342C11.0477 18.0003 10.2839 18.0003 9.67221 17.9181C9.0167 17.83 8.38835 17.6312 7.87869 17.1216C7.36902 16.6119 7.17028 15.9836 7.08215 15.328C6.99991 14.7164 6.99995 13.9526 7 13.0661V12.9344C6.99995 12.0479 6.99991 11.2841 7.08215 10.6725C7.17028 10.0169 7.36902 9.38859 7.87869 8.87893C8.38835 8.36927 9.0167 8.17052 9.67221 8.08239C10.2839 8.00015 11.0477 8.0002 11.9342 8.00025Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "TV-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["tv","television","display","screen","entertainment","ads","advertising","digital-signage","promotions","menu-board","monitor","video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 4L11.2 6H12.8L14 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13C7 13.9319 7 14.3978 7.15224 14.7654C7.35523 15.2554 7.74458 15.6448 8.23463 15.8478C8.60218 16 9.06812 16 10 16H14C14.9319 16 15.3978 16 15.7654 15.8478C16.2554 15.6448 16.6448 15.2554 16.8478 14.7654C17 14.3978 17 13.9319 17 13C17 12.0681 17 11.6022 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Tv-line-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tv","monitor","screen","dashboard","analytics","charts","reporting","statistics","sales-data","sales","pos","computer","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv-line-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tv","screen","display","charts","statistics","reporting","sales-data","dashboard","analytics","monitor","business-intelligence"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M9 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "TV-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","television","display","screen","entertainment","media","promotion","advertising"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.48554 3.14266C9.95912 2.85851 10.5734 3.01208 10.8575 3.48566L11.7662 5.00015H12.2338L13.1425 3.48566C13.4267 3.01208 14.0409 2.85851 14.5145 3.14266C14.9881 3.42681 15.1417 4.04107 14.8575 4.51465L14.566 5.00046C15.6995 5.00205 16.6515 5.015 17.4251 5.119C18.3529 5.24374 19.1723 5.51571 19.8284 6.17182C20.4845 6.82793 20.7565 7.64735 20.8813 8.57518C21.0001 9.45893 21 10.5756 21 11.9297V14.0708C21 15.4249 21.0001 16.5416 20.8813 17.4253C20.7565 18.3531 20.4845 19.1726 19.8284 19.8287C19.1723 20.4848 18.3529 20.7568 17.4251 20.8815C16.5413 21.0003 15.4247 21.0003 14.0706 21.0002H9.92936C8.57527 21.0003 7.45868 21.0003 6.57494 20.8815C5.64711 20.7568 4.82769 20.4848 4.17158 19.8287C3.51547 19.1726 3.2435 18.3531 3.11876 17.4253C2.99994 16.5416 2.99997 15.425 3 14.0709V11.9296C2.99997 10.5756 2.99994 9.45892 3.11876 8.57518C3.2435 7.64735 3.51547 6.82793 4.17158 6.17182C4.82769 5.51571 5.64711 5.24374 6.57494 5.119C7.34851 5.015 8.30051 5.00205 9.43403 5.00046L9.14254 4.51465C8.85839 4.04107 9.01195 3.42681 9.48554 3.14266ZM9.96802 9.00024H14.032C14.4706 9.00023 14.8491 9.00022 15.1624 9.0216C15.4922 9.0441 15.8221 9.0936 16.1481 9.22861C16.8831 9.53309 17.4672 10.1171 17.7716 10.8522C17.9066 11.1781 17.9562 11.508 17.9787 11.8379C18 12.1511 18 12.5296 18 12.9683V13.0323C18 13.4709 18 13.8494 17.9787 14.1626C17.9562 14.4925 17.9066 14.8224 17.7716 15.1483C17.4672 15.8834 16.8831 16.4674 16.1481 16.7719C15.8221 16.9069 15.4922 16.9564 15.1624 16.9789C14.8491 17.0003 14.4706 17.0003 14.032 17.0002H9.96801C9.52937 17.0003 9.15088 17.0003 8.83762 16.9789C8.50779 16.9564 8.17788 16.9069 7.85195 16.7719C7.11687 16.4674 6.53285 15.8834 6.22837 15.1483C6.09336 14.8224 6.04386 14.4925 6.02135 14.1626C5.99998 13.8494 5.99999 13.4709 6 13.0322V12.9682C5.99999 12.5296 5.99998 12.1511 6.02135 11.8379C6.04386 11.508 6.09336 11.1781 6.22837 10.8522C6.53285 10.1171 7.11687 9.53309 7.85195 9.22861C8.17788 9.0936 8.50779 9.0441 8.83762 9.0216C9.15087 9.00022 9.52939 9.00023 9.96802 9.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tv-line": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","monitor","screen","display","chart","bars","report","sales","statistics","dashboard","analytics","data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 16H10C7.17157 16 5.75736 16 4.87868 15.1213C4 14.2426 4 12.8284 4 10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10C20 12.8284 20 14.2426 19.1213 15.1213C18.2426 16 16.8284 16 14 16Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 16V20M10 20H8M10 20H14M14 20V16M14 20H16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 12V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv-music-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["tv","music","entertainment","display","media","advertising","promotion","screen","audio","video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13.5V9L14.9969 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 3L11.2 5H12.8L14 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv-music-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["tv","music","entertainment","display","advertisement","announcement","menu","digital-signage","tv-music"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M13 13.5V9V13.5Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 15C10.6664 14.9825 10 14.3161 10 13.5C10 12.6839 10.6664 12.0175 11.5 12C12.3336 12.0175 13 12.6839 13 13.5C13 14.3161 12.3336 14.9825 11.5 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13 13.5V9L14.9969 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 3L11.2 5H12.8L14 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv-line-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["display","monitor","chart","statistics","sales-report","analytics","dashboard","reporting","metrics","visualization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92943C8.57533 2.99997 7.45869 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45869 2.99997 8.57529 3 9.92939V10.0706C2.99997 11.4247 2.99994 12.5413 3.11876 13.4251C3.2435 14.3529 3.51547 15.1723 4.17158 15.8284C4.82769 16.4845 5.64711 16.7565 6.57494 16.8813C7.24768 16.9717 8.05535 16.9933 9 16.9984L9 19H8C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H15V16.9984C15.9447 16.9933 16.7523 16.9717 17.4251 16.8813C18.3529 16.7565 19.1723 16.4845 19.8284 15.8284C20.4845 15.1723 20.7565 14.3529 20.8813 13.4251C21.0001 12.5413 21 11.4247 21 10.0706V9.92946C21 8.57534 21.0001 7.4587 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4247 2.99997 14.0706 3ZM11 19V17H13V19H11ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8ZM9.5 10C9.5 9.44772 9.05229 9 8.5 9C7.94772 9 7.5 9.44772 7.5 10V12C7.5 12.5523 7.94772 13 8.5 13C9.05229 13 9.5 12.5523 9.5 12V10ZM16.5 10C16.5 9.44772 16.0523 9 15.5 9C14.9477 9 14.5 9.44772 14.5 10V12C14.5 12.5523 14.9477 13 15.5 13C16.0523 13 16.5 12.5523 16.5 12V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Tv-music-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","music","entertainment","media","playlist","queue","display","audio","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 21C16.4477 21 16 20.5523 16 20L16 19C16 18.4477 16.4477 18 17 18C17.5523 18 18 18.4477 18 19L18 20C18 20.5523 17.5523 21 17 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 21C6.44772 21 6 20.5523 6 20L6 19C6 18.4477 6.44772 18 7 18C7.55228 18 8 18.4477 8 19L8 20C8 20.5523 7.55228 21 7 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H14.0706H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45869 21 9.57533 21 10.9294V10.9295V13.0706V13.0706C21 14.4247 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0706 20H9.92935C8.57527 20 7.45868 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V13.0706V10.9294V10.9294C2.99997 9.57527 2.99994 8.45868 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57531 3.99997 9.9294 4H9.92943ZM12.4745 8.14919C12.7695 7.96701 13.1378 7.95062 13.4478 8.10585L15.4447 9.10585C15.9385 9.35315 16.1383 9.95395 15.891 10.4478C15.6437 10.9416 15.0429 11.1414 14.5491 10.8942L14 10.6192V13.5C14 14.8797 12.8789 15.9712 11.521 15.9998C11.507 16.0001 11.493 16.0001 11.479 15.9998C10.1211 15.9712 9 14.8797 9 13.5C9 12.1203 10.1211 11.0288 11.479 11.0002C11.493 10.9999 11.507 10.9999 11.521 11.0002C11.6846 11.0037 11.8448 11.0225 12 11.0555V9C12 8.65331 12.1796 8.33136 12.4745 8.14919ZM12 13.5C12 13.2533 11.7979 13.0173 11.5 13.0006C11.2021 13.0173 11 13.2533 11 13.5C11 13.7467 11.2021 13.9827 11.5 13.9994C11.7979 13.9827 12 13.7467 12 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.48566 2.14266C9.95924 1.85851 10.5735 2.01208 10.8576 2.48566L11.7663 4.00015H12.234L13.1427 2.48566C13.4268 2.01208 14.0411 1.85851 14.5146 2.14266C14.9882 2.42681 15.1418 3.04107 14.8576 3.51465L13.6576 5.51465C13.4769 5.81585 13.1514 6.00015 12.8002 6.00015H11.2002C10.8489 6.00015 10.5234 5.81585 10.3427 5.51465L9.14266 3.51465C8.85851 3.04107 9.01208 2.42681 9.48566 2.14266Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    TV: {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","music","entertainment","media","playlist","queue","display","audio","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6H14C16.8284 6 18.2426 6 19.1213 6.87868C20 7.75736 20 9.17157 20 12V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10 4L11.2 6H12.8L14 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H10C9.06812 10 8.60218 10 8.23463 10.1522C7.74458 10.3552 7.35523 10.7446 7.15224 11.2346C7 11.6022 7 12.0681 7 13C7 13.9319 7 14.3978 7.15224 14.7654C7.35523 15.2554 7.74458 15.6448 8.23463 15.8478C8.60218 16 9.06812 16 10 16H14C14.9319 16 15.3978 16 15.7654 15.8478C16.2554 15.6448 16.6448 15.2554 16.8478 14.7654C17 14.3978 17 13.9319 17 13C17 12.0681 17 11.6022 16.8478 11.2346C16.6448 10.7446 16.2554 10.3552 15.7654 10.1522C15.3978 10 14.9319 10 14 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "twitch-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["chat","support","customer-service","feedback","message","communication","comment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 20V17H5V6L7 4H19V14L15 17H12L8 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "twitch-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["chat","message","feedback","support","notification","comment","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 20V17H5V6L7 4H19V14L15 17H12L8 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "twitch-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","comment","feedback","support","notification","conversation","communicate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 3.25C6.80109 3.25 6.61032 3.32902 6.46967 3.46967L4.46967 5.46967C4.32902 5.61032 4.25 5.80109 4.25 6V17C4.25 17.4142 4.58579 17.75 5 17.75H7.25V20C7.25 20.2841 7.4105 20.5438 7.66459 20.6708C7.91868 20.7979 8.22274 20.7704 8.45 20.6L12.25 17.75H15C15.1623 17.75 15.3202 17.6974 15.45 17.6L19.45 14.6C19.6389 14.4584 19.75 14.2361 19.75 14V4C19.75 3.58579 19.4142 3.25 19 3.25H7ZM12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8V10C10 10.5523 10.4477 11 11 11C11.5523 11 12 10.5523 12 10V8ZM16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8V10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10V8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    twitch: {
        defaultColors: ["#3D4C66"],
        keywords: ["chat","message","comment","feedback","support","notification","conversation","communicate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 20V17H5V6L7 4H19V14L15 17H12L8 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 8V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Tv-music": {
        defaultColors: ["#3D4C66"],
        keywords: ["tv","television","music","audio","entertainment","playlist","display","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 13.5V9L14.9969 10M13 13.5C13 12.6839 12.3336 12.0175 11.5 12C10.6664 12.0175 10 12.6839 10 13.5C10 14.3161 10.6664 14.9825 11.5 15C12.3336 14.9825 13 14.3161 13 13.5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 20L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 20L7 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 3L11.2 5H12.8L14 3"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "twitter-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["twitter","social media","share","post","marketing","connection","communication","news","feed","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 7L11 13C11 13.93 11 14.395 11.1022 14.7765C11.3796 15.8117 12.1883 16.6204 13.2235 16.8978C13.605 17 14.07 17 15 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M8 9H14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "twitter-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["social media","promotion","marketing","advertising","news","update","connect"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 9H14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 7L11 13C11 13.93 11 14.395 11.1022 14.7765C11.3796 15.8117 12.1883 16.6204 13.2235 16.8978C13.605 17 14.07 17 15 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "twitter-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["twitter","social-media","share","announcement","news","update"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.0001 18L14.8625 18C14.0671 18.0005 13.4765 18.0008 12.9648 17.8637C11.5845 17.4938 10.5063 16.4156 10.1364 15.0353C9.9993 14.5236 9.99962 13.933 10 13.1376L10.0001 9.99997H8C7.44772 9.99997 7 9.55226 7 8.99997C7 8.44769 7.44772 7.99997 8 7.99997H10.0001V7C10.0001 6.44771 10.4478 6 11.0001 6C11.5524 6 12.0001 6.44771 12.0001 7V7.99997H14C14.5523 7.99997 15 8.44769 15 8.99997C15 9.55226 14.5523 9.99997 14 9.99997H12.0001L12.0001 13C12.0001 13.9944 12.0087 14.2954 12.0682 14.5176C12.2532 15.2078 12.7923 15.7469 13.4825 15.9319C13.7047 15.9914 14.0057 16 15.0001 16C15.5524 16 16.0001 16.4477 16.0001 17C16.0001 17.5523 15.5524 18 15.0001 18Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "U-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["u-shape","curve","bracket","horseshoe","container","holding","group","collection","incomplete","pending","transaction","open-order","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L18 13C18 16.3137 15.3137 19 12 19V19C8.68629 19 6 16.3137 6 13L6 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    twitter: {
        defaultColors: ["#3D4C66"],
        keywords: ["u-shape","curve","bracket","horseshoe","container","holding","group","collection","incomplete","pending","transaction","open-order","void"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 9H14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M11 7L11 13C11 13.93 11 14.395 11.1022 14.7765C11.3796 15.8117 12.1883 16.6204 13.2235 16.8978C13.605 17 14.07 17 15 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "U-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["U","letter","alphabet","undo","reverse","transaction","history"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 4C18.5523 4 19 4.44772 19 5L19 13C19 16.866 15.866 20 12 20C8.13401 20 5 16.866 5 13L5 5C5 4.44771 5.44772 4 6 4C6.55229 4 7 4.44771 7 5L7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13L17 5C17 4.44772 17.4477 4 18 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "U-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["U-shape","container","holding","support","collect","gather","receive","item-container","transaction-holder","basket"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L18 13C18 16.3137 15.3137 19 12 19V19C8.68629 19 6 16.3137 6 13L6 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "UI-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ui","user-interface","settings","configuration","options","app","application","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 10V12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    U: {
        defaultColors: ["#3D4C66"],
        keywords: ["ui","user-interface","settings","configuration","options","app","application","menu"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L18 13C18 16.3137 15.3137 19 12 19V19C8.68629 19 6 16.3137 6 13L6 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "UI-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["UI","user interface","settings","configuration","design","customize","theme","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0706 3H9.92944C8.57536 2.99997 7.45868 2.99994 6.57494 3.11876C5.64711 3.2435 4.82769 3.51547 4.17158 4.17158C3.51547 4.82769 3.2435 5.64711 3.11876 6.57494C2.99994 7.45868 2.99997 8.57529 3 9.92937V14.0706C2.99997 15.4247 2.99994 16.5413 3.11876 17.4251C3.2435 18.3529 3.51547 19.1723 4.17158 19.8284C4.82769 20.4845 5.64711 20.7565 6.57494 20.8813C7.45869 21.0001 8.57531 21 9.92942 21H14.0706C15.4247 21 16.5413 21.0001 17.4251 20.8813C18.3529 20.7565 19.1723 20.4845 19.8284 19.8284C20.4845 19.1723 20.7565 18.3529 20.8813 17.4251C21.0001 16.5413 21 15.4247 21 14.0706V9.92944C21 8.57534 21.0001 7.45869 20.8813 6.57494C20.7565 5.64711 20.4845 4.82769 19.8284 4.17158C19.1723 3.51547 18.3529 3.2435 17.4251 3.11876C16.5413 2.99994 15.4246 2.99997 14.0706 3ZM9.5 10C9.5 9.58579 9.16421 9.25 8.75 9.25C8.33579 9.25 8 9.58579 8 10V12C8 13.5188 9.23122 14.75 10.75 14.75C12.2688 14.75 13.5 13.5188 13.5 12V10C13.5 9.58579 13.1642 9.25 12.75 9.25C12.3358 9.25 12 9.58579 12 10V12C12 12.6904 11.4404 13.25 10.75 13.25C10.0596 13.25 9.5 12.6904 9.5 12V10ZM16 10C16 9.58579 15.6642 9.25 15.25 9.25C14.8358 9.25 14.5 9.58579 14.5 10V14C14.5 14.4142 14.8358 14.75 15.25 14.75C15.6642 14.75 16 14.4142 16 14V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "UI-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["ui","user-interface","settings","options","customization","appearance","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 10V12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "umbrella-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["umbrella","protection","warranty","insurance","coverage","secure","secure-order","rain","disaster"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17.76L16 18C16 19.1046 15.1046 20 14 20V20C12.8954 20 12 19.1046 12 18L12 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13C8 11.8954 8.89543 11 10 11C11.1046 11 12 11.8954 12 13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5L12 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    UI: {
        defaultColors: ["#3D4C66"],
        keywords: ["umbrella","protection","warranty","insurance","coverage","secure","secure-order","rain","disaster"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 10V12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 14V10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "umbrella-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["umbrella","protection","insurance","coverage","warranty","service-plan","shield","weather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17.76L16 18C16 19.1046 15.1046 20 14 20V20C12.8954 20 12 19.1046 12 18L12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13C8 11.8954 8.89543 11 10 11C11.1046 11 12 11.8954 12 13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    umbrella: {
        defaultColors: ["#3D4C66"],
        keywords: ["umbrella","protection","insurance","coverage","warranty","service-plan","shield","weather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17.76L16 18C16 19.1046 15.1046 20 14 20V20C12.8954 20 12 19.1046 12 18L12 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 13C4 11.8954 4.89543 11 6 11C7.10457 11 8 11.8954 8 13C8 11.8954 8.89543 11 10 11C11.1046 11 12 11.8954 12 13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 5L12 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "umbrella-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["umbrella","protection","insurance","warranty","coverage","secure","covered","safety"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12C5.44772 12 5 12.4477 5 13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13C3 8.36745 6.50005 4.55237 11 4.05493V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44771 13 4V4.05493C17.4999 4.55237 21 8.36744 21 13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12C17.4477 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V18C13 18.5523 13.4477 19 14 19C14.5523 19 15 18.5523 15 18V17.76C15 17.2077 15.4477 16.76 16 16.76C16.5523 16.76 17 17.2077 17 17.76V18C17 19.6569 15.6569 21 14 21C12.3431 21 11 19.6569 11 18V13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Underline-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["underline","select","edit","text","modify","highlight","special-offer","discount","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7V10C17 12.7614 14.7614 15 12 15V15C9.23858 15 7 12.7614 7 10V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17H18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Underline-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["underline","text","format","typography","highlight","emphasis","search","find","filter","select","options","settings","preference","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7V10C6 13.3137 8.68629 16 12 16H6C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16H12C15.3137 16 18 13.3137 18 10V7C18 6.44772 17.5523 6 17 6C16.4477 6 16 6.44772 16 7V10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Underline-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["underline","text-decoration","format","font","emphasis","edit-text","label"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7V10C17 12.7614 14.7614 15 12 15V15C9.23858 15 7 12.7614 7 10V7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17H18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "unpin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["unpin","remove","cancel","disable","block","unselect","stop-promotion","remove-promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5355 12.7071L16.9497 11.2929M12.707 7.0503L11.2928 8.46451"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2927 8.46469L10.6209 8.68864C8.28595 9.46695 7.11848 9.85611 6.77409 10.7178C6.70052 10.9018 6.65472 11.0959 6.6382 11.2934C6.56089 12.2181 7.43108 13.0883 9.17144 14.8286V14.8286C10.9118 16.569 11.782 17.4392 12.7067 17.3619C12.9042 17.3453 13.0982 17.2995 13.2823 17.226C14.144 16.8816 14.5331 15.7141 15.3114 13.3792L15.5354 12.7073"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.17188 14.8286L6.34345 17.657"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.7069 7.05026V7.05026C11.9258 6.26921 11.9258 5.00288 12.7069 4.22184V4.22184C13.4879 3.4408 14.7542 3.44079 15.5353 4.22183L19.7779 8.46447C20.559 9.24552 20.559 10.5119 19.7779 11.2929V11.2929C18.9969 12.0739 17.7306 12.0739 16.9495 11.2929V11.2929"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "unpin-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["unpin","remove-pin","clear-pin","disable-pin","unstick","remove-sticky","cancel-pin","delete-pin","remove","unpinned","not-pinned"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2423 11.9998L17.6565 10.5856C18.3232 9.9189 18.6565 9.58557 18.6565 9.17135C18.6565 8.75714 18.3232 8.4238 17.6565 7.75714L16.2423 6.34293C15.5757 5.67627 15.2423 5.34294 14.8281 5.34294C14.4139 5.34294 14.0806 5.67627 13.4139 6.34294L11.9997 7.75714"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 7.75717L11.3279 7.98112C8.99298 8.75943 7.82552 9.14859 7.48113 10.0102C7.40755 10.1943 7.36175 10.3883 7.34523 10.5859C7.26792 11.5106 8.13811 12.3808 9.87847 14.1211V14.1211C11.6188 15.8615 12.489 16.7317 13.4137 16.6543C13.6113 16.6378 13.8053 16.592 13.9894 16.5184C14.851 16.1741 15.2402 15.0066 16.0185 12.6717L16.2424 11.9998"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 17L7 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Underline: {
        defaultColors: ["#3D4C66"],
        keywords: ["unpin","remove-pin","clear-pin","disable-pin","unstick","remove-sticky","cancel-pin","delete-pin","remove","unpinned","not-pinned"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 7V10C17 12.7614 14.7614 15 12 15V15C9.23858 15 7 12.7614 7 10V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 17H18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "unpin-2-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unpin","pin","remove","cancel","delete","block","stop","disable","deactivate","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17.6569 10.5859L16.5766 11.6662C16.4104 11.8324 16.3273 11.9155 16.2661 12.0145C16.2049 12.1136 16.1678 12.2251 16.0934 12.448L16.0188 12.6719C15.2405 15.0069 14.8513 16.1743 13.9897 16.5187C13.8056 16.5923 13.6116 16.6381 13.414 16.6546C12.4893 16.7319 11.6192 15.8618 9.87879 14.1214C8.13843 12.3811 7.26825 11.5109 7.34556 10.5862C7.36207 10.3886 7.40787 10.1946 7.48145 10.0105C7.82584 9.14888 8.99331 8.75972 11.3282 7.98141L11.5522 7.90676C11.7751 7.83245 11.8866 7.79529 11.9856 7.73408C12.0847 7.67286 12.1678 7.58978 12.3339 7.42361L13.4143 6.34326L13.4143 6.34325C14.081 5.67659 14.4143 5.34326 14.8285 5.34326C15.2427 5.34326 15.5761 5.67659 16.2427 6.34325L17.6569 7.75746C18.3236 8.42412 18.6569 8.75746 18.6569 9.17167C18.6569 9.58589 18.3236 9.91922 17.6569 10.5859Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 17L7 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "unpin-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["unpin","unpin-item","remove","disable","deactivate","crossed-out","disable-feature","cancel-selection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L15.0695 16.4837C15.0253 16.5854 14.9809 16.6828 14.9361 16.7757C14.5967 17.4794 14.1409 18.135 13.3607 18.4468C13.0845 18.5572 12.7935 18.6259 12.4972 18.6507C11.6598 18.7207 10.959 18.3381 10.3408 17.8605C9.9063 17.5249 9.4257 17.0717 8.88026 16.5339L6.75734 18.6568C6.36682 19.0473 5.73365 19.0473 5.34313 18.6568C4.9526 18.2663 4.9526 17.6331 5.34313 17.2426L7.46604 15.1197C6.92804 14.5741 6.47475 14.0934 6.13904 13.6588C5.66142 13.0406 5.27887 12.3397 5.34887 11.5024C5.37365 11.206 5.44234 10.915 5.55271 10.6389C5.86457 9.85864 6.52016 9.40288 7.22383 9.06351C7.31677 9.01869 7.41414 8.97427 7.51582 8.93003L5.29289 6.70711Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5353 13.1211L10.8785 7.46424L11.7455 6.59719C12.0453 6.29727 12.3367 6.00579 12.6093 5.79775C12.9167 5.56322 13.3147 5.34277 13.8283 5.34277C14.342 5.34277 14.74 5.56321 15.0474 5.79775C15.32 6.00579 15.6114 6.29726 15.9112 6.59718L17.4024 8.08833C17.7023 8.38813 17.9938 8.6795 18.2018 8.95216C18.4363 9.25956 18.6568 9.65752 18.6568 10.1712C18.6568 10.6848 18.4363 11.0828 18.2018 11.3902C17.9938 11.6629 17.7023 11.9542 17.4024 12.254L16.5353 13.1211Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "unpin-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["unpin","remove","delete","cancel","disable","stop","clear","ignore","reject"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.17188 14.8281L6.34345 17.6566"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.6212 8.68811L10.9307 8.58494C11.0684 8.53906 11.1372 8.51612 11.2013 8.48394C11.2541 8.45745 11.3045 8.42633 11.3518 8.39095C11.4092 8.34797 11.4606 8.29667 11.5632 8.19407C11.7699 7.9873 11.8733 7.88391 11.9351 7.78307C12.0404 7.61127 11.9977 7.71125 12.0492 7.51645C12.0795 7.40211 12.0937 6.7976 12.122 5.58858C12.1337 5.09256 12.3287 4.60005 12.7073 4.22153C13.4883 3.44048 14.7546 3.44048 15.5357 4.22152L19.7783 8.46416C20.5594 9.24521 20.5594 10.5115 19.7783 11.2926C19.3998 11.6711 18.9073 11.8662 18.4113 11.8778C17.2023 11.9061 16.5978 11.9203 16.4834 11.9506C16.2886 12.0022 16.3886 11.9594 16.2168 12.0647C16.116 12.1265 16.0126 12.2299 15.8058 12.4367L15.8058 12.4367C15.7032 12.5393 15.6519 12.5906 15.6089 12.6481C15.5735 12.6954 15.5424 12.7457 15.5159 12.7985C15.4837 12.8627 15.4608 12.9315 15.4149 13.0692L15.4149 13.0692L15.3118 13.3786C14.5335 15.7136 14.1443 16.881 13.2827 17.2254C13.0986 17.299 12.9046 17.3448 12.707 17.3613C11.7823 17.4386 10.9121 16.5685 9.17176 14.8281C7.4314 13.0878 6.56122 12.2176 6.63853 11.2929C6.65504 11.0953 6.70084 10.9013 6.77442 10.7172C7.11881 9.85558 8.28628 9.46642 10.6212 8.68811Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "unpin-21": {
        defaultColors: ["#3D4C66"],
        keywords: ["unpin","pin","remove","remove-pin","cancel","cancel-pin","disable","disable-pin","block","block-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2423 11.9998L17.6565 10.5856C18.3232 9.9189 18.6565 9.58557 18.6565 9.17135C18.6565 8.75714 18.3232 8.4238 17.6565 7.75714L16.2423 6.34293C15.5757 5.67627 15.2423 5.34294 14.8281 5.34294C14.4139 5.34294 14.0806 5.67627 13.4139 6.34294L11.9997 7.75714"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 7.75717L11.3279 7.98112C8.99298 8.75943 7.82552 9.14859 7.48113 10.0102C7.40755 10.1943 7.36175 10.3883 7.34523 10.5859C7.26792 11.5106 8.13811 12.3808 9.87847 14.1211V14.1211C11.6188 15.8615 12.489 16.7317 13.4137 16.6543C13.6113 16.6378 13.8053 16.592 13.9894 16.5184C14.851 16.1741 15.2402 15.0066 16.0185 12.6717L16.2424 11.9998"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.87891 14.1211L7.05048 16.9495"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 17L7 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    unpin: {
        defaultColors: ["#3D4C66"],
        keywords: ["unpin","pin","remove","remove-pin","cancel","cancel-pin","disable","disable-pin","block","block-pin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5355 12.7071L16.9497 11.2929M12.707 7.0503L11.2928 8.46451"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2927 8.46469L10.6209 8.68864C8.28595 9.46695 7.11848 9.85611 6.77409 10.7178C6.70052 10.9018 6.65472 11.0959 6.6382 11.2934C6.56089 12.2181 7.43108 13.0883 9.17144 14.8286V14.8286C10.9118 16.569 11.782 17.4392 12.7067 17.3619C12.9042 17.3453 13.0982 17.2995 13.2823 17.226C14.144 16.8816 14.5331 15.7141 15.3114 13.3792L15.5354 12.7073"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.17188 14.8286L6.34345 17.657"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.7069 7.05026V7.05026C11.9258 6.26921 11.9258 5.00288 12.7069 4.22184V4.22184C13.4879 3.4408 14.7542 3.44079 15.5353 4.22183L19.7779 8.46447C20.559 9.24552 20.559 10.5119 19.7779 11.2929V11.2929C18.9969 12.0739 17.7306 12.0739 16.9495 11.2929V11.2929"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M19 18L5 4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "unsplash-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["archive","download","import","receive","save","storage"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 4H9V8H15V4Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 20V10H9V14H15V10H20V20H4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "unpin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["unpin","pin","remove","cancel","disable","deactivate","stop","block","restrict","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.29364 8.70761C8.04969 8.8036 7.82672 8.89889 7.62562 8.99588C6.94117 9.32597 6.35499 9.74597 6.07805 10.4389C5.97688 10.692 5.91391 10.9588 5.89119 11.2304C5.82903 11.974 6.1655 12.6118 6.63007 13.2132C6.95712 13.6365 7.40079 14.1072 7.9356 14.6496L5.63585 16.9494C5.24533 17.3399 5.24533 17.973 5.63585 18.3636C6.02638 18.7541 6.65954 18.7541 7.05007 18.3636L9.34981 16.0638C9.89243 16.5989 10.3633 17.0427 10.7868 17.3699C11.3881 17.8344 12.0259 18.1709 12.7695 18.1087C13.0412 18.086 13.3079 18.023 13.5611 17.9219C14.254 17.6449 14.674 17.0587 15.0041 16.3743C15.101 16.1732 15.1963 15.9502 15.2923 15.7063L18.2929 18.7069C18.6834 19.0974 19.3166 19.0974 19.7071 18.7069C20.0976 18.3163 20.0976 17.6832 19.7071 17.2926L5.70711 3.29265C5.31658 2.90212 4.68342 2.90212 4.29289 3.29265C3.90237 3.68317 3.90237 4.31634 4.29289 4.70686L8.29364 8.70761ZM16.7381 12.6772L11.3227 7.26182C11.3274 7.18386 11.3321 7.07724 11.3369 6.93728C11.3476 6.62585 11.3581 6.17751 11.3723 5.571C11.3883 4.88994 11.6568 4.21144 12.177 3.6912C13.2509 2.61726 14.9921 2.61726 16.0661 3.69119L20.3087 7.93383C21.3827 9.00777 21.3827 10.749 20.3087 11.8229C19.7885 12.3432 19.11 12.6116 18.4289 12.6276C17.8224 12.6418 17.3741 12.6523 17.0627 12.663C16.9227 12.6678 16.8161 12.6725 16.7381 12.6772Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "unsplash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["insert","add","box","package","item","add-item","put-in"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 20V10H9V14H15V10H20V20H4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 4H9V8H15V4Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "unsplash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["box","package","storage","inventory","item","boxes","stack","add-item","add-inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V8C16 8.55228 15.5523 9 15 9H9C8.44772 9 8 8.55228 8 8V4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 12C3 11.4477 3.44772 11 4 11H9C9.55228 11 10 11.4477 10 12V15H14V12C14 11.4477 14.4477 11 15 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "up-from-bracket-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["download","import","receive","arrow-down","tray","data","load","inventory","stock","receive-stock","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18L11 18C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 10L8 10M16 10L14 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 10L12 14L16 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 6L14 6L14 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "up-from-bracket-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["download","import","receive","data-entry","arrow-down","get"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18L11 18C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 6L10 6L10 10H8L12 14L16 10L14 10L14 6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "up-from-bracket-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","data","arrow","inbox","update","get","load","retrieve"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.8991 15.1586C17.9979 14.4237 18 13.4425 18 12V10C18 9.44771 18.4477 9 19 9C19.5523 9 20 9.44771 20 10V12C20 12.0236 20 12.0471 20 12.0706C20 13.4247 20.0001 14.5413 19.8813 15.4251C19.7565 16.3529 19.4845 17.1723 18.8284 17.8284C18.1723 18.4845 17.3529 18.7565 16.4251 18.8812C15.5413 19.0001 14.4247 19 13.0706 19H10.9294C9.57531 19 8.4587 19.0001 7.57494 18.8812C6.64711 18.7565 5.82768 18.4845 5.17158 17.8284C4.51547 17.1723 4.2435 16.3529 4.11876 15.4251C3.99994 14.5413 3.99997 13.4247 4 12.0706L4 10C4 9.44772 4.44772 9 5 9C5.55229 9 6 9.44772 6 10L6 12C6 13.4425 6.00213 14.4237 6.10092 15.1586C6.19585 15.8646 6.36322 16.1916 6.58579 16.4142C6.80836 16.6368 7.13538 16.8042 7.84143 16.8991C8.57625 16.9979 9.55752 17 11 17H13C14.4425 17 15.4238 16.9979 16.1586 16.8991C16.8646 16.8042 17.1916 16.6368 17.4142 16.4142C17.6368 16.1916 17.8042 15.8646 17.8991 15.1586Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9239 9.61732C17.0786 9.99099 16.9931 10.4211 16.7071 10.7071L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29287 10.7071C7.00687 10.4211 6.92131 9.99099 7.0761 9.61732C7.23088 9.24364 7.59551 9 7.99998 9L8.99998 9L8.99998 6C8.99998 5.44772 9.44769 5 9.99998 5L14 5C14.5523 5 15 5.44772 15 6V9H16C16.4044 9 16.7691 9.24364 16.9239 9.61732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    unsplash: {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","data","arrow","inbox","update","get","load","retrieve"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 4H9V8H15V4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 20V10H9V14H15V10H20V20H4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "up-right-from-square-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["export","send","share","external-link","arrow","square","outgoing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V12V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 6L11 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 5H17C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "up-right-from-square-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["export","arrow","square","external link","send","share","upload","transfer","outbound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V12V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 6L11 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 5H17C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "up-from-bracket": {
        defaultColors: ["#3D4C66"],
        keywords: ["download","import","receive","inbox","arrow-down","get","arrival","receive-stock","import-data"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 10V12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18L11 18C8.17157 18 6.75736 18 5.87868 17.1213C5 16.2426 5 14.8284 5 12L5 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 10L8 10M16 10L14 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M8 10L12 14L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 10L10 6L14 6L14 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "up-right-from-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["export","share","send","redirect","square","arrow","outlink","external-link","external"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.93417 4.00001C8.95604 4.00001 8.97799 4.00001 9 4.00001H11.5C12.0523 4.00001 12.5 4.44773 12.5 5.00001C12.5 5.5523 12.0523 6.00001 11.5 6.00001H9C8.02893 6.00001 7.40122 6.00214 6.93871 6.06432C6.50497 6.12264 6.36902 6.21678 6.2929 6.29291C6.21677 6.36903 6.12263 6.50498 6.06431 6.93872C6.00213 7.40122 6 8.02894 6 9.00001V15C6 15.9711 6.00213 16.5988 6.06431 17.0613C6.12263 17.495 6.21677 17.631 6.2929 17.7071C6.36902 17.7832 6.50497 17.8774 6.93871 17.9357C7.40122 17.9979 8.02893 18 9 18H15C15.9711 18 16.5988 17.9979 17.0613 17.9357C17.495 17.8774 17.631 17.7832 17.7071 17.7071C17.7832 17.631 17.8774 17.495 17.9357 17.0613C17.9979 16.5988 18 15.9711 18 15V12.5C18 11.9477 18.4477 11.5 19 11.5C19.5523 11.5 20 11.9477 20 12.5L20 15.0658C20.0001 15.9523 20.0001 16.7161 19.9179 17.3278C19.8297 17.9833 19.631 18.6117 19.1213 19.1213C18.6117 19.631 17.9833 19.8297 17.3278 19.9179C16.7161 20.0001 15.9523 20.0001 15.0658 20H8.93417C8.04769 20.0001 7.28387 20.0001 6.67221 19.9179C6.0167 19.8297 5.38835 19.631 4.87868 19.1213C4.36902 18.6117 4.17028 17.9833 4.08215 17.3278C3.99991 16.7161 3.99995 15.9523 4 15.0658L4 9.00001C4 8.978 4 8.95605 4 8.93418C3.99995 8.0477 3.99991 7.28388 4.08215 6.67222C4.17028 6.01671 4.36902 5.38836 4.87868 4.87869C5.38835 4.36903 6.0167 4.17029 6.67221 4.08215C7.28387 3.99992 8.04769 3.99996 8.93417 4.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.5858 6.00001H15C14.4477 6.00001 14 5.5523 14 5.00001C14 4.44773 14.4477 4.00001 15 4.00001L17.0544 4.00001C17.4785 3.99992 17.8906 3.99984 18.2305 4.04554C18.6137 4.09706 19.051 4.22259 19.4142 4.5858C19.7774 4.94902 19.903 5.38629 19.9545 5.76949C20.0002 6.1094 20.0001 6.52151 20 6.94557L20 9.00001C20 9.5523 19.5523 10 19 10C18.4477 10 18 9.5523 18 9.00001V7.41423L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L16.5858 6.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Upload-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["upload","import","arrow","data","transfer","sync","backup","restore","load","register","send","submit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L9.17157 7.82843C10.5049 6.49509 11.1716 5.82843 12 5.82843C12.8284 5.82843 13.4951 6.49509 14.8284 7.82843L16 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6L12 16" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Upload-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["upload","import","data","transfer","send","backup","restore","push","sync","update","send-data","import-data","upload-data","data-transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L9.17157 7.82843C10.5049 6.49509 11.1716 5.82843 12 5.82843C12.8284 5.82843 13.4951 6.49509 14.8284 7.82843L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "up-right-from-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["export","transfer","data","square","arrow","send","share","move-data","move"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5H9C7.11438 5 6.17157 5 5.58579 5.58579C5 6.17157 5 7.11438 5 9V12V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H15C16.8856 19 17.8284 19 18.4142 18.4142C19 17.8284 19 16.8856 19 15V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M18 6L11 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M15 5H17C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Upload-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["upload","import","data","send","arrow-up","export","backup","sync","save"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 7.44411C10.7032 7.71213 10.3471 8.06685 9.87868 8.53523L8.70711 9.70681C8.31658 10.0973 7.68342 10.0973 7.29289 9.70681C6.90237 9.31628 6.90237 8.68312 7.29289 8.29259L8.46447 7.12102C8.48004 7.10545 8.49556 7.08993 8.51102 7.07446C9.13783 6.44759 9.67789 5.90746 10.1685 5.5331C10.6944 5.1319 11.2792 4.82813 12 4.82812C12.7208 4.82813 13.3056 5.1319 13.8315 5.5331C14.3221 5.90746 14.8622 6.44758 15.489 7.07445L16.7071 8.29259C17.0976 8.68312 17.0976 9.31628 16.7071 9.7068C16.3166 10.0973 15.6834 10.0973 15.2929 9.7068L14.1213 8.53523C13.6529 8.06685 13.2968 7.71213 13 7.44411L13 15.9997C13 16.552 12.5523 16.9997 12 16.9997C11.4477 16.9997 11 16.552 11 15.9997L11 7.44411ZM5 10.9997C5.55229 10.9997 6 11.4474 6 11.9997V12.9997C6 14.4422 6.00213 15.4234 6.10092 16.1583C6.19585 16.8643 6.36322 17.1913 6.58579 17.4139C6.80836 17.6365 7.13538 17.8039 7.84143 17.8988C8.57625 17.9976 9.55752 17.9997 11 17.9997H13C14.4425 17.9997 15.4238 17.9976 16.1586 17.8988C16.8646 17.8039 17.1916 17.6365 17.4142 17.4139C17.6368 17.1913 17.8042 16.8643 17.8991 16.1583C17.9979 15.4234 18 14.4422 18 12.9997V11.9997C18 11.4474 18.4477 10.9997 19 10.9997C19.5523 10.9997 20 11.4474 20 11.9997L20 13.0703C20 14.4244 20.0001 15.541 19.8813 16.4248C19.7565 17.3526 19.4845 18.172 18.8284 18.8281C18.1723 19.4842 17.3529 19.7562 16.4251 19.8809C15.5413 19.9998 14.4247 19.9997 13.0706 19.9997H10.9294C9.57531 19.9997 8.4587 19.9998 7.57494 19.8809C6.64711 19.7562 5.82768 19.4842 5.17158 18.8281C4.51547 18.172 4.2435 17.3526 4.11875 16.4248C3.99994 15.541 3.99997 14.4244 4 13.0703L4 11.9997C4 11.4474 4.44772 10.9997 5 10.9997Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <rect x="5" y="14" width="14" height="6" rx="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    Upload: {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9L9.17157 7.82843C10.5049 6.49509 11.1716 5.82843 12 5.82843C12.8284 5.82843 13.4951 6.49509 14.8284 7.82843L16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 6L12 16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 12V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","person","member","login","staff","clerk","manager","human"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 17.3223C5 15.9898 5.97984 14.86 7.29899 14.6716L11.1515 14.1212C11.575 14.0607 11.7868 14.0305 12 14.0305C12.2132 14.0305 12.425 14.0607 12.8485 14.1212L16.701 14.6716C18.0202 14.86 19 15.9898 19 17.3223C19 18.8012 17.8012 20 16.3223 20H7.67767C6.19883 20 5 18.8012 5 17.3223Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","account","profile","person","staff","employee","member","client","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.0938 13.3719C11.4711 13.3179 11.7327 13.2805 12 13.2805C12.2673 13.2805 12.5289 13.3179 12.9061 13.3719L16.8071 13.9292C18.4957 14.1704 19.75 15.6166 19.75 17.3224C19.75 19.2154 18.2154 20.7501 16.3223 20.7501H7.67767C5.78462 20.7501 4.25 19.2154 4.25 17.3224C4.25 15.6166 5.50429 14.1704 7.19292 13.9292L11.0938 13.3719Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-13": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","member","person","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","staff","manager","login","sign-in","user-profile","user-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.92796 14.25C7.79117 14.2499 7.64728 14.2497 7.51085 14.271C6.91228 14.3644 6.40462 14.7608 6.1688 15.3188C6.11504 15.446 6.08031 15.5857 6.04729 15.7184L6.03878 15.7526L6.01745 15.8377C5.90695 16.2787 5.82273 16.6149 5.81303 16.9096C5.7693 18.2386 6.68274 19.4085 7.98267 19.6884C8.27096 19.7505 8.61749 19.7503 9.07212 19.7501H14.9279C15.3825 19.7503 15.729 19.7505 16.0173 19.6884C17.3172 19.4085 18.2307 18.2386 18.1869 16.9096C18.1772 16.6149 18.093 16.2787 17.9825 15.8378L17.9612 15.7526L17.9527 15.7184C17.9197 15.5857 17.8849 15.446 17.8312 15.3188C17.5954 14.7608 17.0877 14.3644 16.4891 14.271C16.3527 14.2497 16.2088 14.2499 16.072 14.25H7.92796Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","person","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 20L6.17801 18.932C6.56376 16.6174 6.75664 15.4601 7.55038 14.7559C7.58462 14.7255 7.61955 14.6959 7.65515 14.6672C8.48028 14 9.65352 14 12 14V14V14C14.3465 14 15.5197 14 16.3448 14.6672C16.3804 14.6959 16.4154 14.7255 16.4496 14.7559C17.2434 15.4601 17.4362 16.6174 17.822 18.932L18 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","login","users","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M6 20L6.17801 18.932C6.56376 16.6174 6.75664 15.4601 7.55038 14.7559C7.58462 14.7255 7.61955 14.6959 7.65515 14.6672C8.48028 14 9.65352 14 12 14V14V14C14.3465 14 15.5197 14 16.3448 14.6672C16.3804 14.6959 16.4154 14.7255 16.4496 14.7559C17.2434 15.4601 17.4362 16.6174 17.822 18.932L18 20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","member","person","login","register","settings","admin","cashier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.11644 19.3014L6.17801 18.932C6.56376 16.6174 6.75664 15.4601 7.55038 14.7559C7.58462 14.7255 7.61955 14.6959 7.65515 14.6672C8.48028 14 9.65352 14 12 14C14.3465 14 15.5197 14 16.3448 14.6672C16.3804 14.6959 16.4154 14.7255 16.4496 14.7559C17.2434 15.4601 17.4362 16.6174 17.822 18.932L17.822 18.932L17.8836 19.3014C17.9376 19.6257 17.9646 19.7878 17.8748 19.8939C17.7849 20 17.6205 20 17.2917 20H6.70828C6.37949 20 6.2151 20 6.12523 19.8939C6.03536 19.7878 6.06239 19.6257 6.11644 19.3014Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","staff","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12.0478 13.25H11.9522C10.8196 13.25 9.90191 13.25 9.16704 13.3388C8.40227 13.4313 7.74724 13.6282 7.18359 14.084C7.13909 14.1199 7.09542 14.1569 7.05262 14.1949C6.51041 14.676 6.20848 15.2897 5.99154 16.0289C5.78309 16.7391 5.63224 17.6443 5.44605 18.7615L5.37182 19.2068C5.34914 19.3423 5.32068 19.5121 5.31708 19.6614C5.3127 19.8423 5.33869 20.1258 5.55296 20.3787C5.76722 20.6316 6.04252 20.7039 6.22176 20.7293C6.36956 20.7503 6.54179 20.7501 6.67908 20.75H17.3209C17.4582 20.7501 17.6304 20.7503 17.7782 20.7293C17.9575 20.7039 18.2328 20.6316 18.447 20.3787C18.6613 20.1258 18.6873 19.8423 18.6829 19.6614C18.6793 19.5121 18.6509 19.3423 18.6282 19.2069L18.5539 18.7616C18.3677 17.6443 18.2169 16.7391 18.0084 16.0289C17.7915 15.2897 17.4896 14.676 16.9474 14.1949C16.9046 14.1569 16.8609 14.1199 16.8164 14.084C16.2527 13.6282 15.5977 13.4313 14.8329 13.3388C14.0981 13.25 13.1804 13.25 12.0478 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","person","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-20": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15 19H9C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15H15C16.1046 15 17 15.8954 17 17C17 18.1046 16.1046 19 15 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-21": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","user-profile","login","register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15 19H9C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15H15C16.1046 15 17 15.8954 17 17C17 18.1046 16.1046 19 15 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-22": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","admin","user-profile","login","user-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 19H9C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15H15C16.1046 15 17 15.8954 17 17C17 18.1046 16.1046 19 15 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-23": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","avatar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 8.5C7.5 6.01472 9.51472 4 12 4C14.4853 4 16.5 6.01472 16.5 8.5C16.5 10.9853 14.4853 13 12 13C9.51472 13 7.5 10.9853 7.5 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.25 17C6.25 15.4812 7.48122 14.25 9 14.25H15C16.5188 14.25 17.75 15.4812 17.75 17C17.75 18.5188 16.5188 19.75 15 19.75H9C7.48122 19.75 6.25 18.5188 6.25 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-24": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","manager","person","login","access","clerk","waiter","cashier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 17.9943C9.28787 15.3352 14.7121 15.3352 19 17.9943"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","member","person","staff","clerk","salesperson"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <rect
                    x="5"
                    y="14"
                    width="14"
                    height="6"
                    rx="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-26": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","client","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M5 17.9943C9.28787 15.3352 14.7121 15.3352 19 17.9943"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-27": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 9.5C7.5 7.01472 9.51472 5 12 5C14.4853 5 16.5 7.01472 16.5 9.5C16.5 11.9853 14.4853 14 12 14C9.51472 14 7.5 11.9853 7.5 9.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.52692 18.85C9.49196 16.3911 14.5078 16.3911 18.4729 18.85C18.9422 19.1411 19.5587 18.9907 19.8497 18.5214C20.1408 18.052 19.9963 17.4356 19.5269 17.1445C14.9162 14.2852 9.08357 14.2852 4.47286 17.1445C4.00351 17.4356 3.85898 18.052 4.15005 18.5214C4.44112 18.9907 5.05756 19.1411 5.52692 18.85Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-28": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","login","register","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15H11C8.79086 15 7 15.4924 7 17.3333C7 18.2538 7.74619 19 8.66667 19H15.3333C16.2538 19 17 18.2538 17 17.3333C17 15.4924 15.2091 15 13 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-25": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","account","profile","customer","member","person","employee","cashier","salesperson"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 17.9943C9.28787 15.3352 14.7121 15.3352 19 17.9943"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","person","avatar","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4.25 17C4.25 14.9289 5.92893 13.25 8 13.25H16C18.0711 13.25 19.75 14.9289 19.75 17C19.75 19.0711 18.0711 20.75 16 20.75H8C5.92893 20.75 4.25 19.0711 4.25 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-29": {
        defaultColors: ["#2797E8"],
        keywords: ["user","profile","account","customer","employee","staff","manager","person","login","customer-profile","user-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 15H11C8.79086 15 7 15.4924 7 17.3333C7 18.2538 7.74619 19 8.66667 19H15.3333C16.2538 19 17 18.2538 17 17.3333C17 15.4924 15.2091 15 13 15Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-31": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","employee","staff","member","login","register","person","human"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11 14.25C9.86636 14.25 8.72477 14.3718 7.84267 14.8023C7.38929 15.0235 6.98143 15.3373 6.6894 15.7774C6.39479 16.2214 6.25 16.7461 6.25 17.3333C6.25 18.668 7.33198 19.75 8.66667 19.75H15.3333C16.668 19.75 17.75 18.668 17.75 17.3333C17.75 16.7461 17.6052 16.2214 17.3106 15.7774C17.0186 15.3373 16.6107 15.0235 16.1573 14.8023C15.2752 14.3718 14.1336 14.25 13 14.25H11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-30": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","profile","account","employee","manager","cashier","login","access","person","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 15H11C8.79086 15 7 15.4924 7 17.3333C7 18.2538 7.74619 19 8.66667 19H15.3333C16.2538 19 17 18.2538 17 17.3333C17 15.4924 15.2091 15 13 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-33": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","login","sign-in","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="8" rx="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M19 17.4286C19 15.535 15.866 14 12 14C8.13401 14 5 15.535 5 17.4286C5 18.8487 6.15127 20 7.57143 20H16.4286C17.8487 20 19 18.8487 19 17.4286Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-32": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","person","employee","member","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="4" width="8" height="8" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M19 17.4286C19 15.535 15.866 14 12 14C8.13401 14 5 15.535 5 17.4286C5 18.8487 6.15127 20 7.57143 20H16.4286C17.8487 20 19 18.8487 19 17.4286Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-35": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","manager","login","user-profile","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 13.25C9.97793 13.25 8.11032 13.6499 6.72035 14.3307C5.37976 14.9873 4.25 16.0365 4.25 17.4286C4.25 19.2629 5.73705 20.75 7.57143 20.75H16.4286C18.2629 20.75 19.75 19.2629 19.75 17.4286C19.75 16.0365 18.6202 14.9873 17.2796 14.3307C15.8897 13.6499 14.0221 13.25 12 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-36": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","customer","profile","person","employee","staff","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.2918 19L15.7082 19C16.9739 19 18 17.9739 18 16.7082C18 15.0045 16.2071 13.8964 14.6833 14.6584L13.4164 15.2918C13.3435 15.3283 13.307 15.3465 13.2719 15.3629C12.4659 15.7402 11.5341 15.7402 10.7281 15.3629C10.693 15.3465 10.6566 15.3283 10.5836 15.2918L10.5836 15.2918L9.31672 14.6584C7.7929 13.8965 6 15.0045 6 16.7082C6 17.9739 7.02607 19 8.2918 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-34": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","profile","account","employee","staff","member","person","login","users","customers","employees","staffs","members","people"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="8"
                    y="4"
                    width="8"
                    height="8"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 17.4286C19 15.535 15.866 14 12 14C8.13401 14 5 15.535 5 17.4286C5 18.8487 6.15127 20 7.57143 20H16.4286C17.8487 20 19 18.8487 19 17.4286Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-37": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","customer","account","profile","employee","manager","person","staff","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.2918 19L15.7082 19C16.9739 19 18 17.9739 18 16.7082C18 15.0045 16.2071 13.8964 14.6833 14.6584L13.4164 15.2918C13.3435 15.3283 13.307 15.3465 13.2719 15.3629C12.4659 15.7402 11.5341 15.7402 10.7281 15.3629C10.693 15.3465 10.6566 15.3283 10.5836 15.2918L10.5836 15.2918L9.31672 14.6584C7.7929 13.8965 6 15.0045 6 16.7082C6 17.9739 7.02607 19 8.2918 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-39": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","person","member","staff","login","access","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.7082 19.75C17.3881 19.75 18.75 18.3881 18.75 16.7082C18.75 14.447 16.3704 12.9763 14.3479 13.9875L13.081 14.621C13.0045 14.6592 12.9782 14.6723 12.9539 14.6837C12.3494 14.9666 11.6506 14.9666 11.0461 14.6837C11.0218 14.6723 10.9955 14.6592 10.919 14.621L9.65213 13.9875C7.62963 12.9763 5.25 14.447 5.25 16.7082C5.25 18.3881 6.61186 19.75 8.2918 19.75L15.7082 19.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","salesperson","clerk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8649 20H9.13512C7.52621 20 6.33108 18.5101 6.6801 16.9395C6.87764 16.0506 7.54026 15.3379 8.41246 15.0763L10.3077 14.5077C11.4116 14.1765 12.5884 14.1765 13.6923 14.5077L15.5875 15.0763C16.4597 15.3379 17.1224 16.0506 17.3199 16.9395C17.6689 18.5101 16.4738 20 14.8649 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-40": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","person","customer","profile","account","employee","member","client","staff","manager","admin"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M7.78321 14C3.57002 15.245 7.57681 20 12 20C16.4232 20 20.43 15.245 16.2168 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-38": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","person","staff","clerk","associate","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.2918 19L15.7082 19C16.9739 19 18 17.9739 18 16.7082C18 15.0045 16.2071 13.8964 14.6833 14.6584L13.4164 15.2918C13.3435 15.3283 13.307 15.3465 13.2719 15.3629C12.4659 15.7402 11.5341 15.7402 10.7281 15.3629C10.693 15.3465 10.6566 15.3283 10.5836 15.2918L10.5836 15.2918L9.31672 14.6584C7.7929 13.8965 6 15.0045 6 16.7082C6 17.9739 7.02607 19 8.2918 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-41": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M7.78321 14C3.57002 15.245 7.57681 20 12 20C16.4232 20 20.43 15.245 16.2168 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-43": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.57067 13.2807C7.75849 13.2252 7.96058 13.2454 8.13373 13.337C9.48003 14.0487 11.0485 14.6102 12.5 14.5C13.9504 14.3899 15.2184 13.613 15.9205 13.311C16.0814 13.2418 16.2614 13.2311 16.4293 13.2807C17.628 13.6349 18.454 14.3101 18.687 15.2891C18.9088 16.2213 18.5233 17.1633 17.9428 17.9224C16.7757 19.4488 14.4497 20.75 12 20.75C9.55027 20.75 7.22425 19.4488 6.05717 17.9224C5.47673 17.1633 5.09119 16.2213 5.313 15.2891C5.54596 14.3101 6.37201 13.6349 7.57067 13.2807Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-42": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.78321 14C3.57002 15.245 7.57681 20 12 20C16.4232 20 20.43 15.245 16.2168 14"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M7.78321 14C3.57002 15.245 7.57681 20 12 20C16.4232 20 20.43 15.245 16.2168 14C14.6667 14.6667 10.8098 15.6 7.78321 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-44": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","person","employee","member","login","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.16518 14C7.97845 14 7.78773 14.0247 7.61151 14.0865C3.71879 15.4503 7.54781 20 12 20C16.4523 20 20.2811 15.4503 16.3883 14.0865"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-46": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","login","sign-in","staff","team","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.16518 14C7.97845 14 7.78773 14.0247 7.61151 14.0865C3.71879 15.4503 7.54781 20 12 20C16.4523 20 20.2811 15.4503 16.3883 14.0865"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M12 20C7.54781 20 3.71879 15.4503 7.61151 14.0865C7.78773 14.0247 7.97845 14 8.16518 14H15.8347C16.0214 14 16.2121 14.0247 16.3883 14.0865C20.2811 15.4503 16.4523 20 12 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-45": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","customer","account","profile","person","login","staff","employee","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.16518 14C7.97845 14 7.78773 14.0247 7.61151 14.0865C3.71879 15.4503 7.54781 20 12 20C16.4523 20 20.2811 15.4503 16.3883 14.0865"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-47": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","login","register","salesperson"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.16518 13.25C7.91577 13.25 7.63768 13.2826 7.36352 13.3786C6.23351 13.7745 5.47818 14.4777 5.29237 15.4442C5.11602 16.3615 5.50409 17.2762 6.08658 18.0179C7.25685 19.508 9.54517 20.75 12 20.75C14.4549 20.75 16.7432 19.508 17.9134 18.0179C18.4959 17.2762 18.8839 16.3614 18.7075 15.4442C18.5217 14.4777 17.7663 13.7745 16.6363 13.3786C16.3622 13.2826 16.0841 13.25 15.8347 13.25H8.16518Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-49": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","person","member","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14.7436 14H9.25642C8.67203 14 8.37983 14 8.12867 14.0664C7.56786 14.2146 7.09902 14.5989 6.84373 15.1198C6.72939 15.353 6.67209 15.6396 6.55748 16.2126C6.41616 16.9192 6.3455 17.2725 6.37708 17.5747C6.44786 18.2519 6.85832 18.8466 7.46641 19.1529C7.73775 19.2896 8.09315 19.3489 8.80393 19.4673L11.3424 19.8904L11.3424 19.8904C11.6705 19.9451 11.8345 19.9724 12 19.9724C12.1655 19.9724 12.3295 19.9451 12.6576 19.8904L12.6576 19.8904L15.1961 19.4673C15.9069 19.3489 16.2622 19.2896 16.5336 19.1529C17.1417 18.8466 17.5521 18.2519 17.6229 17.5747C17.6545 17.2725 17.5838 16.9192 17.4425 16.2126C17.3279 15.6396 17.2706 15.353 17.1563 15.1198C16.901 14.5989 16.4321 14.2146 15.8713 14.0664C15.6202 14 15.328 14 14.7436 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","salesperson","login","access","person","staff","team","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M14.8649 20H9.13512C7.52621 20 6.33108 18.5101 6.6801 16.9395C6.87764 16.0506 7.54026 15.3379 8.41246 15.0763L10.3077 14.5077C11.4116 14.1765 12.5884 14.1765 13.6923 14.5077L15.5875 15.0763C16.4597 15.3379 17.1224 16.0506 17.3199 16.9395C17.6689 18.5101 16.4738 20 14.8649 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-48": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","customer","account","employee","member","person","staff","clerk","attendant","representative","salesperson"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.7436 14H9.25642C8.67203 14 8.37983 14 8.12867 14.0664C7.56786 14.2146 7.09902 14.5989 6.84373 15.1198C6.72939 15.353 6.67209 15.6396 6.55748 16.2126C6.41616 16.9192 6.3455 17.2725 6.37708 17.5747C6.44786 18.2519 6.85832 18.8466 7.46641 19.1529C7.73775 19.2896 8.09315 19.3489 8.80393 19.4673L11.3424 19.8904L11.3424 19.8904C11.6705 19.9451 11.8345 19.9724 12 19.9724C12.1655 19.9724 12.3295 19.9451 12.6576 19.8904L12.6576 19.8904L15.1961 19.4673C15.9069 19.3489 16.2622 19.2896 16.5336 19.1529C17.1417 18.8466 17.5521 18.2519 17.6229 17.5747C17.6545 17.2725 17.5838 16.9192 17.4425 16.2126C17.3279 15.6396 17.2706 15.353 17.1563 15.1198C16.901 14.5989 16.4321 14.2146 15.8713 14.0664C15.6202 14 15.328 14 14.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-51": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","member","user-profile","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3ZM9.25642 13.2501L9.16612 13.25H9.16611C8.67043 13.2497 8.28472 13.2495 7.93707 13.3413C7.16596 13.5451 6.5213 14.0736 6.17027 14.7898C6.01201 15.1126 5.93661 15.4909 5.83972 15.977L5.82205 16.0656L5.79965 16.1773C5.67991 16.7736 5.58742 17.2343 5.63115 17.6527C5.72846 18.5839 6.29284 19.4016 7.12897 19.8228C7.5047 20.0121 7.96821 20.089 8.56824 20.1885L8.68063 20.2072L11.2072 20.6283L11.2072 20.6283L11.2191 20.6303L11.2191 20.6303L11.267 20.6383C11.5488 20.6853 11.7711 20.7225 12 20.7225C12.2289 20.7225 12.4513 20.6853 12.733 20.6383L12.7809 20.6303L12.7809 20.6304L12.7864 20.6294L15.3194 20.2072L15.4318 20.1885C16.0318 20.089 16.4953 20.0121 16.871 19.8228C17.7072 19.4016 18.2715 18.5839 18.3689 17.6527C18.4126 17.2343 18.3201 16.7736 18.2004 16.1773L18.178 16.0656L18.1603 15.977L18.1603 15.977C18.0634 15.4909 17.988 15.1126 17.8297 14.7898C17.4787 14.0736 16.834 13.5451 16.0629 13.3413C15.7153 13.2495 15.3296 13.2497 14.8339 13.25H14.8339L14.7436 13.2501H9.25642Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-50": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.7436 14H9.25642C8.67203 14 8.37983 14 8.12867 14.0664C7.56786 14.2146 7.09902 14.5989 6.84373 15.1198C6.72939 15.353 6.67209 15.6396 6.55748 16.2126C6.41616 16.9192 6.3455 17.2725 6.37708 17.5747C6.44786 18.2519 6.85832 18.8466 7.46641 19.1529C7.73775 19.2896 8.09315 19.3489 8.80393 19.4673L11.3424 19.8904L11.3424 19.8904C11.6705 19.9451 11.8345 19.9724 12 19.9724C12.1655 19.9724 12.3295 19.9451 12.6576 19.8904L12.6576 19.8904L15.1961 19.4673C15.9069 19.3489 16.2622 19.2896 16.5336 19.1529C17.1417 18.8466 17.5521 18.2519 17.6229 17.5747C17.6545 17.2725 17.5838 16.9192 17.4425 16.2126C17.3279 15.6396 17.2706 15.353 17.1563 15.1198C16.901 14.5989 16.4321 14.2146 15.8713 14.0664C15.6202 14 15.328 14 14.7436 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-52": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","client","role","login","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M15.3074 14H8.69258C8.36753 14 8.205 14 8.05759 14.0221C7.45905 14.1118 6.93333 14.4677 6.62774 14.9902C6.55247 15.1188 6.49211 15.2697 6.37139 15.5715L6.37139 15.5715C6.12785 16.1804 6.00607 16.4848 5.97269 16.7277C5.83358 17.7398 6.47965 18.6941 7.47106 18.9408C7.70894 19 8.03682 19 8.69258 19H12H15.3074C15.9632 19 16.2911 19 16.5289 18.9408C17.5203 18.6941 18.1664 17.7398 18.0273 16.7277C17.9939 16.4848 17.8722 16.1804 17.6286 15.5715L17.6286 15.5715C17.5079 15.2697 17.4475 15.1188 17.3723 14.9902C17.0667 14.4677 16.5409 14.1118 15.9424 14.0221C15.795 14 15.6325 14 15.3074 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-54": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.3074 14H8.69258C8.36753 14 8.205 14 8.05759 14.0221C7.45905 14.1118 6.93333 14.4677 6.62774 14.9902C6.55247 15.1188 6.49211 15.2697 6.37139 15.5715L6.37139 15.5715C6.12785 16.1804 6.00607 16.4848 5.97269 16.7277C5.83358 17.7398 6.47965 18.6941 7.47106 18.9408C7.70894 19 8.03682 19 8.69258 19H12H15.3074C15.9632 19 16.2911 19 16.5289 18.9408C17.5203 18.6941 18.1664 17.7398 18.0273 16.7277C17.9939 16.4848 17.8722 16.1804 17.6286 15.5715L17.6286 15.5715C17.5079 15.2697 17.4475 15.1188 17.3723 14.9902C17.0667 14.4677 16.5409 14.1118 15.9424 14.0221C15.795 14 15.6325 14 15.3074 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-55": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.5 5.51472 14.4853 3.5 12 3.5ZM8.69261 13.75L8.64314 13.75H8.64312C8.36637 13.7499 8.15044 13.7498 7.94644 13.7804C7.12345 13.9038 6.40059 14.3932 5.9804 15.1115C5.87624 15.2895 5.79612 15.4901 5.69343 15.7471L5.67507 15.793L5.63476 15.8937C5.4304 16.4036 5.27596 16.7891 5.22971 17.1256C5.03843 18.5172 5.92678 19.8294 7.28997 20.1686C7.61957 20.2507 8.03477 20.2504 8.58416 20.2501H8.58419L8.69261 20.25H15.3075L15.4159 20.2501H15.4159C15.9653 20.2504 16.3805 20.2507 16.7101 20.1686C18.0733 19.8294 18.9616 18.5172 18.7704 17.1256C18.7241 16.7891 18.5697 16.4036 18.3653 15.8936L18.325 15.793L18.3066 15.747C18.2039 15.49 18.1238 15.2895 18.0197 15.1115C17.5995 14.3932 16.8766 13.9038 16.0536 13.7804C15.8496 13.7498 15.6337 13.7499 15.3569 13.75H15.3569L15.3075 13.75H8.69261Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-53": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M15.3074 14H8.69258C8.36753 14 8.205 14 8.05759 14.0221C7.45905 14.1118 6.93333 14.4677 6.62774 14.9902C6.55247 15.1188 6.49211 15.2697 6.37139 15.5715L6.37139 15.5715C6.12785 16.1804 6.00607 16.4848 5.97269 16.7277C5.83358 17.7398 6.47965 18.6941 7.47106 18.9408C7.70894 19 8.03682 19 8.69258 19H12H15.3074C15.9632 19 16.2911 19 16.5289 18.9408C17.5203 18.6941 18.1664 17.7398 18.0273 16.7277C17.9939 16.4848 17.8722 16.1804 17.6286 15.5715L17.6286 15.5715C17.5079 15.2697 17.4475 15.1188 17.3723 14.9902C17.0667 14.4677 16.5409 14.1118 15.9424 14.0221C15.795 14 15.6325 14 15.3074 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-57": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","person","login","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M6 19L6.0883 18.7351C6.52832 17.4151 6.74832 16.755 7.2721 16.3775C7.79587 16 8.49159 16 9.88304 16H14.117C15.5084 16 16.2041 16 16.7279 16.3775C17.2517 16.755 17.4717 17.4151 17.9117 18.7351L18 19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-56": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","staff","clerk"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 19L6.0883 18.7351C6.52832 17.4151 6.74832 16.755 7.2721 16.3775C7.79587 16 8.49159 16 9.88304 16H14.117C15.5084 16 16.2041 16 16.7279 16.3775C17.2517 16.755 17.4717 17.4151 17.9117 18.7351L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-58": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","login","register","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.3482 16H9.65182C8.48715 16 7.90482 16 7.44022 16.2687C7.3245 16.3356 7.21579 16.414 7.1157 16.5026C6.71387 16.8584 6.52972 17.4108 6.16142 18.5157C6.09462 18.7162 6.06121 18.8164 6.09942 18.8911C6.10865 18.9091 6.12058 18.9257 6.13478 18.9401C6.19358 19 6.2992 19 6.51046 19H17.4895C17.7008 19 17.8064 19 17.8652 18.9401C17.8794 18.9257 17.8913 18.9091 17.9006 18.8911C17.9388 18.8164 17.9054 18.7162 17.8386 18.5157L17.8386 18.5157C17.4703 17.4108 17.2861 16.8584 16.8843 16.5026C16.7842 16.414 16.6755 16.3356 16.5598 16.2687C16.0952 16 15.5129 16 14.3482 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","person","member","login","access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8649 20H9.13512C7.52621 20 6.33108 18.5101 6.6801 16.9395C6.87764 16.0506 7.54026 15.3379 8.41246 15.0763L10.3077 14.5077C11.4116 14.1765 12.5884 14.1765 13.6923 14.5077L15.5875 15.0763C16.4597 15.3379 17.1224 16.0506 17.3199 16.9395C17.6689 18.5101 16.4738 20 14.8649 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-60": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","login","person","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8.2861 20L15.7139 20C17.0331 20 18.159 19.0463 18.3758 17.745C18.6811 15.9133 17.0882 14.3277 15.2579 14.6415L12.7603 15.0697L12.7603 15.0697C12.5076 15.113 12.3813 15.1346 12.2544 15.1454C12.0851 15.1598 11.9149 15.1598 11.7456 15.1454C11.6187 15.1346 11.4924 15.113 11.2397 15.0697L11.2397 15.0697L8.74207 14.6415C6.9118 14.3277 5.31888 15.9133 5.62417 17.745C5.84104 19.0463 6.96689 20 8.2861 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-59": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","person","staff","employee","member","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10ZM9.61708 15.25H14.3828H14.3828C14.9356 15.25 15.4029 15.25 15.7882 15.287C16.1963 15.3263 16.5754 15.4114 16.9352 15.6195C17.0943 15.7115 17.2438 15.8192 17.3814 15.9411C17.6926 16.2166 17.8932 16.5493 18.0595 16.9241C18.2165 17.2779 18.3642 17.7212 18.539 18.2456L18.539 18.2457L18.55 18.2786L18.5565 18.298L18.5565 18.298C18.5837 18.3791 18.6227 18.4959 18.6442 18.603C18.6695 18.729 18.7005 18.9739 18.5682 19.2326C18.5244 19.3183 18.4678 19.3969 18.4003 19.4656C18.1967 19.6729 17.9545 19.7209 17.8271 19.7368C17.7187 19.7503 17.5955 19.7501 17.5099 19.75H17.5099L17.4895 19.75H6.51038L6.48992 19.75H6.48991C6.40433 19.7501 6.28117 19.7503 6.17279 19.7368C6.04531 19.7209 5.80311 19.6729 5.59957 19.4656C5.53209 19.3969 5.47545 19.3183 5.43159 19.2326C5.29932 18.9739 5.33034 18.729 5.35561 18.603C5.3771 18.4959 5.41618 18.3791 5.44334 18.298L5.44983 18.2786L5.46078 18.2457C5.63558 17.7212 5.78334 17.2779 5.94037 16.9241C6.10663 16.5493 6.30728 16.2166 6.61844 15.9411C6.75605 15.8192 6.90554 15.7115 7.06465 15.6195C7.42441 15.4114 7.80356 15.3263 8.21161 15.287C8.59698 15.25 9.06426 15.25 9.61707 15.25H9.61708Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-61": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8.2861 20L15.7139 20C17.0331 20 18.159 19.0463 18.3758 17.745C18.6811 15.9133 17.0882 14.3277 15.2579 14.6415L12.7603 15.0697L12.7603 15.0697C12.5076 15.113 12.3813 15.1346 12.2544 15.1454C12.0851 15.1598 11.9149 15.1598 11.7456 15.1454C11.6187 15.1346 11.4924 15.113 11.2397 15.0697L11.2397 15.0697L8.74207 14.6415C6.9118 14.3277 5.31888 15.9133 5.62417 17.745C5.84104 19.0463 6.96689 20 8.2861 20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-63": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","employee","staff","person","member","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.5 4C10.0147 4 8 6.01472 8 8.5C8 10.9853 10.0147 13 12.5 13C14.9853 13 17 10.9853 17 8.5C17 6.01472 14.9853 4 12.5 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16.257 21C18.086 21 19.647 19.7633 19.9477 18.076C20.3709 15.7008 18.1624 13.6448 15.6248 14.0517L13.0879 14.4584C12.8246 14.5006 12.7464 14.5123 12.6716 14.5183C12.5574 14.5274 12.4426 14.5274 12.3284 14.5183C12.2526 14.5122 12.1734 14.5003 11.9018 14.4568L11.8972 14.456L9.37519 14.0517C6.83758 13.6448 4.62906 15.7008 5.05232 18.076C5.35301 19.7633 6.91396 21 8.74299 21H16.257Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-62": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","login","person","human","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.2861 20L15.7139 20C17.0331 20 18.159 19.0463 18.3758 17.745C18.6811 15.9133 17.0882 14.3277 15.2579 14.6415L12.7603 15.0697L12.7603 15.0697C12.5076 15.113 12.3813 15.1346 12.2544 15.1454C12.0851 15.1598 11.9149 15.1598 11.7456 15.1454C11.6187 15.1346 11.4924 15.113 11.2397 15.0697L11.2397 15.0697L8.74207 14.6415C6.9118 14.3277 5.31888 15.9133 5.62417 17.745C5.84104 19.0463 6.96689 20 8.2861 20Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-64": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","login","access","management","user-profile","customer-profile","employee-profile","staff-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 20V19C7 18.07 7 17.605 7.10222 17.2235C7.37962 16.1883 8.18827 15.3796 9.22354 15.1022C9.60504 15 10.07 15 11 15V15H13V15C13.93 15 14.395 15 14.7765 15.1022C15.8117 15.3796 16.6204 16.1883 16.8978 17.2235C17 17.605 17 18.07 17 19V20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-66": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","users","customers","employees","staffs","members"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 15H11C10.07 15 9.60504 15 9.22354 15.1022C8.18827 15.3796 7.37962 16.1883 7.10222 17.2235C7 17.605 7 18.07 7 19V19.5455C7 19.6895 7 19.7615 7.02422 19.8181C7.05457 19.889 7.11104 19.9454 7.1819 19.9758C7.23847 20 7.31049 20 7.45455 20H16.5455C16.6895 20 16.7615 20 16.8181 19.9758C16.889 19.9454 16.9454 19.889 16.9758 19.8181C17 19.7615 17 19.6895 17 19.5455V19C17 18.07 17 17.605 16.8978 17.2235C16.6204 16.1883 15.8117 15.3796 14.7765 15.1022C14.395 15 13.93 15 13 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-65": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","account","profile","customer","employee","staff","member","person","users","accounts","profiles","customers","employees","staffs","members"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 20V19C7 18.07 7 17.605 7.10222 17.2235C7.37962 16.1883 8.18827 15.3796 9.22354 15.1022C9.60504 15 10.07 15 11 15V15H13V15C13.93 15 14.395 15 14.7765 15.1022C15.8117 15.3796 16.6204 16.1883 16.8978 17.2235C17 17.605 17 18.07 17 19V20"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-68": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","employee","staff","member","person"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5.97297 16.2471C6.15803 15.5333 6.25056 15.1764 6.43348 14.899C6.67738 14.5291 7.03719 14.2507 7.45644 14.1074C7.77087 14 8.13957 14 8.87696 14H15.123C15.8604 14 16.2291 14 16.5436 14.1074C16.9628 14.2507 17.3226 14.5291 17.5665 14.899C17.7494 15.1764 17.842 15.5333 18.027 16.2471V16.2471C18.3209 17.3806 18.4678 17.9474 18.3745 18.4021C18.2501 19.0084 17.8519 19.5229 17.2963 19.7955C16.8796 20 16.294 20 15.123 20H8.87696C7.70595 20 7.12045 20 6.70371 19.7955C6.14806 19.5229 5.74993 19.0084 5.62548 18.4021C5.53215 17.9474 5.67909 17.3806 5.97297 16.2471V16.2471Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-69": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","customer","account","person","employee","staff","member","client","salesperson"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5.97297 16.2471C6.15803 15.5333 6.25056 15.1764 6.43348 14.899C6.67738 14.5291 7.03719 14.2507 7.45644 14.1074C7.77087 14 8.13957 14 8.87696 14H15.123C15.8604 14 16.2291 14 16.5436 14.1074C16.9628 14.2507 17.3226 14.5291 17.5665 14.899C17.7494 15.1764 17.842 15.5333 18.027 16.2471V16.2471C18.3209 17.3806 18.4678 17.9474 18.3745 18.4021C18.2501 19.0084 17.8519 19.5229 17.2963 19.7955C16.8796 20 16.294 20 15.123 20H8.87696C7.70595 20 7.12045 20 6.70371 19.7955C6.14806 19.5229 5.74993 19.0084 5.62548 18.4021C5.53215 17.9474 5.67909 17.3806 5.97297 16.2471V16.2471Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-67": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","contact","client"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8.125C8 5.91586 9.79086 4.125 12 4.125C14.2091 4.125 16 5.91586 16 8.125C16 10.3341 14.2091 12.125 12 12.125C9.79086 12.125 8 10.3341 8 8.125Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.8843 13.375C10.0663 13.3748 9.50814 13.3746 9.02948 13.5028C7.73538 13.8496 6.72458 14.8604 6.37783 16.1545C6.24957 16.6331 6.24975 17.1913 6.25002 18.0093L6.25005 18.6834C6.25002 18.7435 6.24998 18.8219 6.25492 18.8922C6.26072 18.9747 6.27591 19.1008 6.33483 19.2384C6.44104 19.4864 6.63867 19.6841 6.88672 19.7903C7.02429 19.8492 7.1504 19.8644 7.23289 19.8702C7.30321 19.8751 7.38161 19.8751 7.44169 19.8751H16.5584C16.6185 19.8751 16.6969 19.8751 16.7672 19.8702C16.8497 19.8644 16.9758 19.8492 17.1134 19.7903C17.3614 19.6841 17.5591 19.4864 17.6653 19.2384C17.7242 19.1008 17.7394 18.9747 17.7452 18.8922C17.7501 18.8219 17.7501 18.7435 17.7501 18.6834L17.7501 18.0093C17.7503 17.1913 17.7505 16.6331 17.6223 16.1545C17.2755 14.8604 16.2647 13.8496 14.9706 13.5028C14.492 13.3746 13.9338 13.3748 13.1159 13.375H10.8843Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","member","employee","staff","clerk","person","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 8C7.5 5.51472 9.51472 3.5 12 3.5C14.4853 3.5 16.5 5.51472 16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.0922 13.7893C11.3367 13.4159 12.6633 13.4159 13.9078 13.7893L15.8031 14.3579C16.9354 14.6975 17.7956 15.6228 18.052 16.7768C18.5051 18.8158 16.9536 20.75 14.8649 20.75H9.13512C7.04641 20.75 5.49486 18.8158 5.94797 16.7768C6.20442 15.6228 7.06465 14.6975 8.19696 14.3579L10.0922 13.7893Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-70": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","login","person","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M5.97297 16.2471C6.15803 15.5333 6.25056 15.1764 6.43348 14.899C6.67738 14.5291 7.03719 14.2507 7.45644 14.1074C7.77087 14 8.13957 14 8.87696 14H15.123C15.8604 14 16.2291 14 16.5436 14.1074C16.9628 14.2507 17.3226 14.5291 17.5665 14.899C17.7494 15.1764 17.842 15.5333 18.027 16.2471C18.3209 17.3806 18.4678 17.9474 18.3745 18.4021C18.2501 19.0084 17.8519 19.5229 17.2963 19.7955C16.8796 20 16.294 20 15.123 20H8.87696C7.70595 20 7.12045 20 6.70371 19.7955C6.14806 19.5229 5.74993 19.0084 5.62548 18.4021C5.53215 17.9474 5.67909 17.3806 5.97297 16.2471Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-72": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","person","staff","employee","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 20C6 16.6863 8.68629 14 12 14V14C15.3137 14 18 16.6863 18 20V20H6V20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "User-73": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","member","person","staff","client","user-profile","user-account","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 20C6 16.6863 8.68629 14 12 14V14C15.3137 14 18 16.6863 18 20V20H6V20Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-74": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["user","employee","profile","account","customer","person","clerk","waiter","staff","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 20C6 16.6863 8.68629 14 12 14C15.3137 14 18 16.6863 18 20H6Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "User-71": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","users","customers","employees"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.76377 13.2501C8.13801 13.2495 7.64919 13.2491 7.21398 13.3979C6.63751 13.5949 6.14277 13.9777 5.80741 14.4863C5.55423 14.8702 5.43194 15.3435 5.2754 15.9494L5.23984 16.0868C5.09901 16.6299 4.98296 17.0775 4.91616 17.4453C4.84756 17.8229 4.81598 18.1882 4.89086 18.553C5.06197 19.3867 5.6094 20.0941 6.37342 20.469C6.70778 20.633 7.06935 20.6941 7.45211 20.7225C7.82484 20.7501 8.28722 20.7501 8.84834 20.7501H15.1518C15.7129 20.7501 16.1753 20.7501 16.548 20.7225C16.9308 20.6941 17.2923 20.633 17.6267 20.469C18.3907 20.0941 18.9382 19.3867 19.1093 18.553C19.1841 18.1882 19.1526 17.8229 19.084 17.4453C19.0172 17.0775 18.9011 16.6299 18.7603 16.0868L18.7247 15.9494C18.5682 15.3435 18.4459 14.8702 18.1927 14.4863C17.8574 13.9777 17.3626 13.5949 16.7861 13.3979C16.3509 13.2491 15.8621 13.2495 15.2364 13.2501H8.76377Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-76": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","employee","manager","staff","person","client","login","user-account","customer-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17C6 15.3431 7.34315 14 9 14H15C16.6569 14 18 15.3431 18 17V17C18 18.6569 16.6569 20 15 20H9C7.34315 20 6 18.6569 6 17V17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-75": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","clerk","manager"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M18.75 20.7499H13V13.3235C16.2537 13.8067 18.75 16.6118 18.75 19.9999V20.7499Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.25 19.9999C5.25 16.6118 7.74629 13.8067 11 13.3235V20.7499H5.25V19.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-78": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["user","profile","account","customer","employee","manager","admin","person","user-account","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17C6 15.3431 7.34315 14 9 14H15C16.6569 14 18 15.3431 18 17C18 18.6569 16.6569 20 15 20H9C7.34315 20 6 18.6569 6 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-77": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","staff","employee","member","person","login"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 17C6 15.3431 7.34315 14 9 14H15C16.6569 14 18 15.3431 18 17V17C18 18.6569 16.6569 20 15 20H9C7.34315 20 6 18.6569 6 17V17Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","staff","member","person","client","user-profile","user-account","customer-profile","employee-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M5 17.3223C5 15.9898 5.97984 14.86 7.29899 14.6716L11.1515 14.1212C11.575 14.0607 11.7868 14.0305 12 14.0305C12.2132 14.0305 12.425 14.0607 12.8485 14.1212L16.701 14.6716C18.0202 14.86 19 15.9898 19 17.3223V17.3223C19 18.8012 17.8012 20 16.3223 20H7.67767C6.19883 20 5 18.8012 5 17.3223V17.3223Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","person","member","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 17.3223C5 15.9898 5.97984 14.86 7.29899 14.6716L11.1515 14.1212C11.575 14.0607 11.7868 14.0305 12 14.0305C12.2132 14.0305 12.425 14.0607 12.8485 14.1212L16.701 14.6716C18.0202 14.86 19 15.9898 19 17.3223V17.3223C19 18.8012 17.8012 20 16.3223 20H7.67767C6.19883 20 5 18.8012 5 17.3223V17.3223Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-add-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","add","plus","new-user","customer","add-customer","create-account","person","account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 9V5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 7L17 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-add-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","add","new-user","customer","add-customer","employee","add-employee","plus","create-account","register"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="10"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 9V5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 7L17 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-add-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","add","plus","customer","new-customer","create-user","add-user","account","create-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 10.2091 12.2091 12 10 12C7.79086 12 6 10.2091 6 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.04601 13.25H12.7138C13.2094 13.2497 13.5952 13.2495 13.9428 13.3413C14.7139 13.5451 15.3586 14.0736 15.7096 14.7898C15.8679 15.1126 15.9433 15.4909 16.0402 15.977L16.0802 16.1773C16.2 16.7736 16.2925 17.2343 16.2487 17.6527C16.1514 18.5839 15.587 19.4016 14.7509 19.8228C14.3752 20.0121 13.9117 20.089 13.3116 20.1885L10.6129 20.6383C10.3311 20.6853 10.1088 20.7225 9.87988 20.7225C9.65096 20.7225 9.42863 20.6853 9.14684 20.6383L6.44812 20.1885C5.84809 20.089 5.38459 20.0121 5.00886 19.8228C4.17272 19.4016 3.60835 18.5839 3.51103 17.6527C3.4673 17.2343 3.55979 16.7736 3.67953 16.1773L3.7196 15.977C3.81649 15.4909 3.89189 15.1126 4.05015 14.7898C4.40118 14.0736 5.04584 13.5451 5.81695 13.3413C6.16461 13.2495 6.55033 13.2497 7.04601 13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5V6H17C16.4477 6 16 6.44772 16 7C16 7.55228 16.4477 8 17 8H18V9C18 9.55228 18.4477 10 19 10C19.5523 10 20 9.55228 20 9V8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H20V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-add": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","add","plus","new-user","create-user","customer","add-customer","new-customer","account","add-account","new-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M19 9V5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-79": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","staff","clerk","member","persona"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 13.25C6.92893 13.25 5.25 14.9289 5.25 17C5.25 19.0711 6.92893 20.75 9 20.75H15C17.0711 20.75 18.75 19.0711 18.75 17C18.75 14.9289 17.0711 13.25 15 13.25H9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","customer","account","person","employee","manager","staff","role","contact","avatar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.3482 16H11.6518C10.4871 16 9.90482 16 9.44022 16.2687C9.3245 16.3356 9.21579 16.414 9.1157 16.5026C8.71387 16.8584 8.52972 17.4108 8.16142 18.5157C8.09462 18.7162 8.06121 18.8164 8.09942 18.8911C8.10865 18.9091 8.12058 18.9257 8.13478 18.9401C8.19358 19 8.2992 19 8.51046 19H15.4895C15.7008 19 15.8064 19 15.8652 18.9401C15.8794 18.9257 15.8913 18.9091 15.9006 18.8911C15.9388 18.8164 15.9054 18.7162 15.8386 18.5157C15.4703 17.4108 15.2861 16.8584 14.8843 16.5026C14.7842 16.414 14.6755 16.3356 14.5598 16.2687C14.0952 16 13.5129 16 12.3482 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","account","profile","person","employee","manager","staff","user-profile","customer-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45869 21 9.5753 21 10.9294V13.0705C21 14.4247 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C17.4047 19.884 17.3842 19.8867 17.3636 19.8893L16.6875 18.1991C16.4565 17.6216 16.2609 17.1325 16.0561 16.7485C15.8383 16.3401 15.5789 15.9877 15.1877 15.7228C14.7965 15.458 14.373 15.348 13.9129 15.2975C13.4803 15.25 12.9536 15.25 12.3316 15.25H11.6685C11.0465 15.25 10.5198 15.25 10.0873 15.2975C9.62712 15.348 9.20362 15.458 8.81241 15.7228C8.42119 15.9877 8.16182 16.3401 7.94401 16.7485C7.73925 17.1325 7.54366 17.6215 7.31268 18.199L6.63658 19.8893C6.61591 19.8867 6.59536 19.884 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99997 9.57535 2.99994 8.45868 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57534 3.99997 9.92943 4ZM12 7.75C10.2051 7.75 8.75 9.20508 8.75 11C8.75 12.7949 10.2051 14.25 12 14.25C13.7949 14.25 15.25 12.7949 15.25 11C15.25 9.20508 13.7949 7.75 12 7.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.21244 19.9885C8.73488 20 9.30704 20 9.92935 20H14.0706C14.693 20 15.2652 20 15.7877 19.9885L15.3095 18.793C15.0598 18.1688 14.894 17.7571 14.7326 17.4543C14.5798 17.1679 14.4635 17.0439 14.3468 16.9649C14.2301 16.8859 14.0717 16.8239 13.7491 16.7885C13.4081 16.751 12.9643 16.75 12.2919 16.75H11.7082C11.0359 16.75 10.5921 16.751 10.251 16.7885C9.92839 16.8239 9.77004 16.8859 9.65335 16.9649C9.53666 17.0439 9.4203 17.1679 9.26758 17.4543C9.10615 17.7571 8.94034 18.1688 8.69065 18.793L8.21244 19.9885Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-card-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","profile","customer","account","employee","manager","person","user-profile","customer-profile","account-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-contact-list-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","contact","list","customer","profile","account","user-profile","contact-list","customer-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12L19 13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19L11 19C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-contact-list-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["user","contact","list","customer","profile","account","people","contacts","customer-list","user-profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5V3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 5V3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13L19 11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.12603 18.4329L8.37743 17.3016C8.54643 16.5411 9.22095 16 10 16H12.8411C13.6854 16 14.1076 16 14.46 16.1384C14.8375 16.2866 15.1611 16.5462 15.3877 16.8826C15.5992 17.1966 15.6908 17.6087 15.874 18.4329L15.874 18.4329L15.874 18.4329C15.9149 18.6169 15.9353 18.7089 15.9146 18.7819C15.8925 18.8598 15.8398 18.9255 15.7686 18.964C15.7018 19 15.6076 19 15.419 19H8.58096C8.39242 19 8.29815 19 8.23143 18.964C8.16017 18.9255 8.10749 18.8598 8.08538 18.7819C8.06468 18.7089 8.08513 18.6169 8.12603 18.4329Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-contact-list-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","contact","profile","account","member","loyalty","customer-profile","user-account","contact-list"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 2C9.55229 2 10 2.44772 10 3V4.00159C10.2963 3.99998 10.6061 3.99999 10.9294 4H13.0706C13.3939 3.99999 13.7037 3.99998 14 4.00159V3C14 2.44772 14.4477 2 15 2C15.5523 2 16 2.44772 16 3V4.07186C16.1472 4.08496 16.2889 4.10045 16.4251 4.11875C17.3529 4.2435 18.1723 4.51546 18.8284 5.17157C19.4845 5.82768 19.7565 6.64711 19.8813 7.57494C20.0001 8.45869 20 9.57531 20 10.9294L20 13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.3623 19.2945 17.8138 19.5668 17.2025 19.7301L16.8813 18.6289C16.6893 17.9706 16.5273 17.4151 16.3424 16.9778C16.1459 16.5133 15.8948 16.1087 15.4833 15.8C15.0717 15.4913 14.613 15.3636 14.112 15.3051C13.6405 15.25 13.0618 15.25 12.3762 15.25L9.99995 15.25C8.8765 15.25 7.88785 15.9915 7.57329 17.07L6.79743 19.7301C6.18619 19.5668 5.63767 19.2945 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57534 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82768 5.17158 5.17157C5.82769 4.51546 6.64711 4.2435 7.57494 4.11875C7.7111 4.10045 7.85278 4.08496 8 4.07186V3C8 2.44772 8.44772 2 9 2ZM12 7.75C10.2051 7.75 8.75 9.20507 8.75 11C8.75 12.7949 10.2051 14.25 12 14.25C13.7949 14.25 15.25 12.7949 15.25 11C15.25 9.20507 13.7949 7.75 12 7.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.29553 19.9509C9.04283 20.0001 9.92013 20 10.9294 20H13.0706C14.0798 20 14.9571 20 15.7044 19.9509L15.4533 19.09C15.2461 18.3796 15.1076 17.9092 14.9609 17.5622C14.8218 17.2334 14.7051 17.0913 14.5833 17C14.4615 16.9087 14.2925 16.8364 13.9379 16.7949C13.5637 16.7512 13.0733 16.75 12.3333 16.75H9.99995C9.54316 16.75 9.14119 17.0515 9.01329 17.49L8.29553 19.9509Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-contact-list-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["contact","address-book","customer","customer-list","user","contacts","phonebook","directory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12L19 13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19L11 19C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 15L4 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L4 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-contact-list-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["customer","contact","list","address-book","user","customer-list","phonebook","directory"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12L19 13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19L11 19C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 15L4 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L4 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L4 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-contact-list-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["contacts","customer-list","address-book","user-profile","member-directory","customer","user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19H13C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13L19 11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8.12603 18.4329L8.37743 17.3016C8.54643 16.5411 9.22095 16 10 16H12.8411C13.6854 16 14.1076 16 14.46 16.1384C14.8375 16.2866 15.1611 16.5462 15.3877 16.8826C15.5992 17.1966 15.6908 17.6087 15.874 18.4329L15.874 18.4329L15.874 18.4329C15.9149 18.6169 15.9353 18.7089 15.9146 18.7819C15.8925 18.8598 15.8398 18.9255 15.7686 18.964C15.7018 19 15.6076 19 15.419 19H8.58096C8.39242 19 8.29815 19 8.23143 18.964C8.16017 18.9255 8.10749 18.8598 8.08538 18.7819C8.06468 18.7089 8.08513 18.6169 8.12603 18.4329Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M6 15L4 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 12L4 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6 9L4 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-contact-list-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","contact","user","profile","directory","address book","client","customer list","contact list","user management"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9451 4.25H13.0549C14.4224 4.24998 15.5248 4.24997 16.3918 4.36653C17.2919 4.48754 18.0497 4.74644 18.6517 5.34835C19.2536 5.95027 19.5125 6.70814 19.6335 7.60825C19.75 8.47522 19.75 9.57754 19.75 10.9451V13.0549C19.75 14.4225 19.75 15.5248 19.6335 16.3918C19.5125 17.2919 19.2536 18.0497 18.6517 18.6517C18.2228 19.0805 17.7147 19.3353 17.1325 19.49L16.8813 18.6289C16.6893 17.9706 16.5273 17.4151 16.3424 16.9778C16.1459 16.5133 15.8948 16.1087 15.4833 15.8C15.0717 15.4913 14.613 15.3636 14.112 15.3051C13.6405 15.25 13.0618 15.25 12.3761 15.25L9.99995 15.25C8.87649 15.25 7.88785 15.9915 7.57328 17.07L6.86744 19.49C6.28522 19.3352 5.7772 19.0805 5.34835 18.6517C4.74643 18.0497 4.48754 17.2919 4.36652 16.3918C4.34963 16.2661 4.33519 16.1356 4.32284 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H4.25163C4.24999 13.7002 4.24999 13.3852 4.25 13.0549L4.25 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H4.25L4.25 10.9451C4.24999 10.6147 4.24999 10.2998 4.25163 10H4C3.44772 10 3 9.55229 3 9C3 8.44772 3.44772 8 4 8H4.32285C4.33519 7.86442 4.34963 7.73386 4.36652 7.60825C4.48754 6.70814 4.74643 5.95027 5.34835 5.34835C5.95027 4.74644 6.70814 4.48754 7.60825 4.36653C8.47521 4.24997 9.57755 4.24998 10.9451 4.25ZM12 8C10.3431 8 8.99995 9.34315 8.99995 11C8.99995 12.6569 10.3431 14 12 14C13.6568 14 15 12.6569 15 11C15 9.34315 13.6568 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.4533 19.09L15.6327 19.705C14.9064 19.75 14.051 19.75 13.0549 19.75H10.9451C9.94895 19.75 9.09348 19.75 8.36725 19.705L9.01328 17.49C9.14119 17.0515 9.54316 16.75 9.99995 16.75H12.3333C13.0733 16.75 13.5637 16.7512 13.9379 16.7949C14.2925 16.8364 14.4615 16.9087 14.5833 17C14.7051 17.0913 14.8218 17.2334 14.9609 17.5622C15.1076 17.9092 15.2461 18.3796 15.4533 19.09Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-contact-list": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","user","profile","contact","account","people","calendar","appointment","schedule","customer-list","user-profile","contact-list","customer-schedule","user-schedule","contact-schedule","loyalty","loyalty-program"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 12L19 13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19L11 19C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13L5 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 6V4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-cowboy-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","customer","spy","masked-user","profile","unknown","incognito","security","hat","anonymous"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8L15.3243 5.97289C15.0534 5.16022 14.918 4.75388 14.6145 4.56327C14.5194 4.5035 14.4148 4.46019 14.3053 4.43517C13.9559 4.35538 13.5728 4.54693 12.8066 4.93003V4.93003C12.4546 5.10602 12.2786 5.19402 12.0909 5.21116C12.0304 5.21668 11.9696 5.21668 11.9091 5.21116C11.7214 5.19402 11.5454 5.10602 11.1934 4.93003V4.93003C10.4272 4.54693 10.0441 4.35538 9.69474 4.43517C9.58519 4.46019 9.48065 4.5035 9.38549 4.56327C9.08204 4.75388 8.94659 5.16022 8.6757 5.97289L8 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 7V7C14.1053 8.29822 9.89466 8.29822 6 7V7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-cowboy-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","profile","account","cowboy","hat","person","employee","manager"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9487 7.84622L15.3243 5.97306C15.0534 5.16038 14.918 4.75405 14.6145 4.56344C14.5194 4.50367 14.4148 4.46036 14.3053 4.43534C13.9559 4.35555 13.5728 4.5471 12.8066 4.9302C12.4546 5.10619 12.2786 5.19419 12.0909 5.21133C12.0304 5.21685 11.9696 5.21685 11.9091 5.21133C11.7214 5.19419 11.5454 5.10619 11.1934 4.9302C10.4272 4.5471 10.0441 4.35555 9.69474 4.43534C9.58519 4.46036 9.48065 4.50367 9.38549 4.56344C9.08204 4.75405 8.94659 5.16038 8.6757 5.97306L8.05132 7.84622C8.01733 7.94818 7.99895 8.05521 8.00324 8.16261C8.08847 10.2964 9.84527 12.0002 12 12.0002C14.1547 12.0002 15.9115 10.2964 15.9968 8.16261C16.0011 8.05521 15.9827 7.94818 15.9487 7.84622Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M15.3243 5.97306L16.0358 5.73589V5.73588L15.3243 5.97306ZM15.9487 7.84622L15.2372 8.08339L15.2372 8.08339L15.9487 7.84622ZM8.05132 7.84622L7.3398 7.60905L7.3398 7.60905L8.05132 7.84622ZM8.6757 5.97306L7.96419 5.73588L8.6757 5.97306ZM11.1934 4.9302L10.858 5.60102V5.60102L11.1934 4.9302ZM11.9091 5.21133L11.8409 5.95822L11.8409 5.95822L11.9091 5.21133ZM12.8066 4.9302L12.4712 4.25938V4.25938L12.8066 4.9302ZM12.0909 5.21133L12.1591 5.95822L12.1591 5.95822L12.0909 5.21133ZM14.6145 4.56344L15.0134 3.92834L15.0134 3.92834L14.6145 4.56344ZM14.3053 4.43534L14.4723 3.70417L14.4723 3.70417L14.3053 4.43534ZM9.38549 4.56344L8.98656 3.92834L9.38549 4.56344ZM9.69474 4.43534L9.86174 5.16651H9.86174L9.69474 4.43534ZM15.9968 8.16261L16.7462 8.19254V8.19254L15.9968 8.16261ZM8.00324 8.16261L8.75264 8.13268L8.00324 8.16261ZM14.6128 6.21023L15.2372 8.08339L16.6602 7.60905L16.0358 5.73589L14.6128 6.21023ZM8.76283 8.08339L9.38722 6.21023L7.96419 5.73588L7.3398 7.60905L8.76283 8.08339ZM10.858 5.60102C11.157 5.75052 11.4793 5.92521 11.8409 5.95822L11.9773 4.46443C11.9846 4.46511 11.9706 4.4667 11.8997 4.43736C11.8186 4.40378 11.714 4.35199 11.5288 4.25938L10.858 5.60102ZM12.4712 4.25938C12.286 4.35199 12.1814 4.40378 12.1003 4.43736C12.0294 4.4667 12.0154 4.46511 12.0227 4.46443L12.1591 5.95822C12.5207 5.92521 12.843 5.75052 13.142 5.60102L12.4712 4.25938ZM11.8409 5.95822C11.9467 5.96788 12.0533 5.96788 12.1591 5.95822L12.0227 4.46443C12.0076 4.46581 11.9924 4.46581 11.9773 4.46443L11.8409 5.95822ZM16.0358 5.73588C15.906 5.34658 15.7895 4.99345 15.6616 4.71849C15.5281 4.43181 15.3405 4.1338 15.0134 3.92834L14.2156 5.19854C14.1919 5.18369 14.2238 5.18415 14.3017 5.35146C14.385 5.53048 14.4717 5.78686 14.6128 6.21023L16.0358 5.73588ZM13.142 5.60102C13.5412 5.40144 13.7837 5.28144 13.9693 5.21377C14.1426 5.15053 14.1655 5.17273 14.1383 5.16651L14.4723 3.70417C14.0957 3.61816 13.7523 3.69623 13.4552 3.8046C13.1703 3.90853 12.8382 4.07585 12.4712 4.25938L13.142 5.60102ZM15.0134 3.92834C14.8469 3.82374 14.664 3.74795 14.4723 3.70417L14.1383 5.16651C14.1656 5.17277 14.1918 5.18359 14.2156 5.19854L15.0134 3.92834ZM9.38722 6.21023C9.52834 5.78686 9.61501 5.53048 9.69834 5.35146C9.77621 5.18415 9.80806 5.18369 9.78442 5.19854L8.98656 3.92834C8.65947 4.1338 8.47187 4.43181 8.33843 4.71849C8.21045 4.99345 8.09396 5.34658 7.96419 5.73588L9.38722 6.21023ZM11.5288 4.25938C11.1618 4.07586 10.8297 3.90853 10.5448 3.8046C10.2477 3.69623 9.90432 3.61816 9.52775 3.70417L9.86174 5.16651C9.83452 5.17273 9.85737 5.15053 10.0307 5.21377C10.2163 5.28144 10.4588 5.40144 10.858 5.60102L11.5288 4.25938ZM9.78442 5.19854C9.80821 5.18359 9.83435 5.17277 9.86174 5.16651L9.52775 3.70417C9.33604 3.74795 9.15308 3.82374 8.98656 3.92834L9.78442 5.19854ZM15.2474 8.13268C15.1781 9.86587 13.7505 11.2502 12 11.2502V12.7502C14.5589 12.7502 16.6449 10.727 16.7462 8.19254L15.2474 8.13268ZM12 11.2502C10.2495 11.2502 8.82187 9.86587 8.75264 8.13268L7.25384 8.19254C7.35507 10.727 9.44108 12.7502 12 12.7502V11.2502ZM7.3398 7.60905C7.28208 7.78221 7.24535 7.98016 7.25384 8.19254L8.75264 8.13268C8.75254 8.13027 8.75257 8.11416 8.76283 8.08339L7.3398 7.60905ZM15.2372 8.08339C15.2474 8.11416 15.2475 8.13027 15.2474 8.13268L16.7462 8.19254C16.7546 7.98016 16.7179 7.78221 16.6602 7.60905L15.2372 8.08339Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M18 7V7C14.1053 8.29822 9.89466 8.29822 6 7V7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-cowboy-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","security","authorization","cowboy","hat","manager","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.92796 14.2498C7.79118 14.2496 7.64727 14.2495 7.51084 14.2708C6.91228 14.3642 6.40462 14.7606 6.16879 15.3186C6.11504 15.4458 6.08031 15.5854 6.04728 15.7182L6.03878 15.7523L6.01745 15.8375C5.90695 16.2785 5.82272 16.6146 5.81303 16.9094C5.76929 18.2384 6.68274 19.4083 7.98267 19.6882C8.27095 19.7503 8.61749 19.7501 9.07212 19.7498H14.9279C15.3825 19.7501 15.729 19.7503 16.0173 19.6882C17.3172 19.4083 18.2307 18.2384 18.1869 16.9094C18.1772 16.6146 18.093 16.2785 17.9825 15.8375L17.9612 15.7523L17.9527 15.7182C17.9197 15.5854 17.8849 15.4458 17.8312 15.3186C17.5954 14.7606 17.0877 14.3642 16.4891 14.2708C16.3527 14.2495 16.2088 14.2496 16.072 14.2498H7.92796Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.4943 4.24163L11.5289 4.25892C11.7141 4.35154 11.8186 4.40332 11.8998 4.4369C11.9497 4.45756 11.9714 4.46288 11.9773 4.46399C11.9925 4.46537 12.0077 4.46535 12.0228 4.46397C12.0287 4.46287 12.0505 4.45756 12.1004 4.4369C12.1815 4.40332 12.286 4.35154 12.4713 4.25892L12.5058 4.24163C12.8592 4.06492 13.1793 3.9048 13.4553 3.80414C13.7524 3.69578 14.0957 3.6177 14.4723 3.70371C14.664 3.74749 14.847 3.82328 15.0135 3.92788C15.3406 4.13334 15.5282 4.43135 15.6616 4.71803C15.7856 4.98434 15.8988 5.32396 16.0237 5.69876L16.2765 6.45727C13.4673 7.14546 10.5328 7.14547 7.72363 6.4573L7.97647 5.69876C8.10137 5.32396 8.21454 4.98434 8.33849 4.71803C8.47193 4.43135 8.65953 4.13334 8.98662 3.92788C9.15314 3.82328 9.3361 3.74749 9.52781 3.70371C9.90438 3.6177 10.2478 3.69578 10.5448 3.80414C10.8208 3.9048 11.141 4.06492 11.4943 4.24163ZM7.26711 8.4046C7.26116 8.33419 7.25674 8.26334 7.2539 8.19208C7.24541 7.9797 7.28214 7.78175 7.33986 7.60859L7.72363 6.4573C7.25054 6.34141 6.78101 6.206 6.31622 6.05107C5.79228 5.87642 5.22596 6.15958 5.05131 6.68353C4.87667 7.20747 5.15983 7.77379 5.68377 7.94844C6.2066 8.12272 6.73484 8.27477 7.26711 8.4046ZM16.733 8.40456C17.2652 8.27474 17.7934 8.1227 18.3162 7.94844C18.8402 7.77379 19.1233 7.20747 18.9487 6.68353C18.774 6.15958 18.2077 5.87642 17.6838 6.05107C17.219 6.20599 16.7495 6.34139 16.2765 6.45727L16.6603 7.60859C16.718 7.78175 16.7547 7.9797 16.7462 8.19208C16.7434 8.26332 16.739 8.33416 16.733 8.40456ZM16.733 8.40456C13.6236 9.16303 10.3766 9.16304 7.26711 8.4046C7.47279 10.8387 9.51308 12.7497 12.0001 12.7497C14.487 12.7497 16.5273 10.8387 16.733 8.40456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-cowboy": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","security","access","login","employee","staff","manager","agent","cowboy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8L15.3243 5.97289C15.0534 5.16022 14.918 4.75388 14.6145 4.56327C14.5194 4.5035 14.4148 4.46019 14.3053 4.43517C13.9559 4.35538 13.5728 4.54693 12.8066 4.93003V4.93003C12.4546 5.10602 12.2786 5.19402 12.0909 5.21116C12.0304 5.21668 11.9696 5.21668 11.9091 5.21116C11.7214 5.19402 11.5454 5.10602 11.1934 4.93003V4.93003C10.4272 4.54693 10.0441 4.35538 9.69474 4.43517C9.58519 4.46019 9.48065 4.5035 9.38549 4.56327C9.08204 4.75388 8.94659 5.16022 8.6757 5.97289L8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 7V7C14.1053 8.29822 9.89466 8.29822 6 7V7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","person","remove","delete","cancel","close","customer","remove-user","delete-user","cancel-user","user-cross"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20.9997 8.99974L17 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20.9997 5.00049L17 9.00023" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","person","contact","id","identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19L8.0883 18.7351C8.52832 17.4151 8.74832 16.755 9.2721 16.3775C9.79587 16 10.4916 16 11.883 16H12.117C13.5084 16 14.2041 16 14.7279 16.3775C15.2517 16.755 15.4717 17.4151 15.9117 18.7351L16 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","remove","delete","cancel","person","account","remove-user","delete-user","cancel-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.04601 13.25C6.55032 13.2497 6.16461 13.2495 5.81695 13.3413C5.04584 13.5451 4.40118 14.0736 4.05015 14.7898C3.89189 15.1126 3.81649 15.4909 3.7196 15.977L3.67953 16.1773C3.55979 16.7736 3.4673 17.2343 3.51103 17.6527C3.60835 18.5839 4.17272 19.4016 5.00886 19.8228C5.38459 20.0121 5.84809 20.089 6.44812 20.1885L9.14684 20.6383C9.42863 20.6853 9.65096 20.7225 9.87988 20.7225C10.1088 20.7225 10.3311 20.6853 10.6129 20.6383L13.3116 20.1885C13.9117 20.089 14.3752 20.0121 14.7509 19.8228C15.587 19.4016 16.1514 18.5839 16.2487 17.6527C16.2925 17.2343 16.2 16.7736 16.0802 16.1773L16.0402 15.977C15.9433 15.4909 15.8679 15.1126 15.7096 14.7898C15.3586 14.0736 14.7139 13.5451 13.9428 13.3413C13.5952 13.2495 13.2094 13.2497 12.7138 13.25H7.04601Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2929 4.29289C16.6834 3.90237 17.3166 3.90237 17.7071 4.29289L19 5.58579L20.2926 4.29316C20.6832 3.90263 21.3163 3.90263 21.7068 4.29316C22.0974 4.68368 22.0974 5.31685 21.7068 5.70737L20.4142 7L21.7068 8.29263C22.0974 8.68315 22.0974 9.31632 21.7068 9.70684C21.3163 10.0974 20.6832 10.0974 20.2926 9.70684L19 8.41421L17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289L17.5858 7L16.2929 5.70711C15.9024 5.31658 15.9024 4.68342 16.2929 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","person","remove","delete","disable","cancel","customer","customer-remove","user-remove"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20.9997 8.99974L17 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20.9997 5.00049L17 9.00023" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","remove","delete","disable","cancel","user-cancel","customer-cancel","user-delete","customer-delete","access-denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="10"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20.9997 8.99974L17 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20.9997 5.00049L17 9.00023" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-group-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["users","group","customers","loyalty","accounts","multiple-users"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.8 14H9.2C7.43269 14 6 14.4924 6 16.3333C6 17.2538 6.59695 18 7.33333 18H12.6667C13.403 18 14 17.2538 14 16.3333C14 14.4924 12.5673 14 10.8 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14C16.6569 14 18 14.4924 18 16.3333C18 17.2538 17.4404 18 16.75 18"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-group-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["users","group","customers","team","staff","employees","membership","user-group","roles","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2415 18.75H17.1667C18.4648 18.75 19.25 17.5032 19.25 16.3333C19.25 15.1789 18.7782 14.3392 17.9533 13.836C17.1954 13.3738 16.2258 13.25 15.3 13.25H14.8487C15.6052 14.0465 16 15.1143 16 16.3333C16 17.17 15.7436 18.0382 15.2415 18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.3877 12.0547C13.7347 12.1811 14.1093 12.25 14.5 12.25C16.2949 12.25 17.75 10.7949 17.75 9C17.75 7.20507 16.2949 5.75 14.5 5.75C14.1093 5.75 13.7347 5.81895 13.3877 5.94534C14.0819 6.77115 14.5 7.83675 14.5 9C14.5 10.1633 14.0819 11.2288 13.3877 12.0547Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.75 5.75C7.95507 5.75 6.5 7.20507 6.5 9C6.5 10.7949 7.95507 12.25 9.75 12.25C11.5449 12.25 13 10.7949 13 9C13 7.20507 11.5449 5.75 9.75 5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.95 13.25C8.02417 13.25 7.05457 13.3738 6.29671 13.836C5.47182 14.3392 5 15.1789 5 16.3333C5 17.5032 5.78522 18.75 7.08333 18.75H12.4167C13.7148 18.75 14.5 17.5032 14.5 16.3333C14.5 15.1789 14.0282 14.3392 13.2033 13.836C12.4454 13.3738 11.4758 13.25 10.55 13.25H8.95Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-group-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","group","users","customer","customers","multiple-users","team","staff","employees"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.8 14H9.2C7.43269 14 6 14.4924 6 16.3333C6 17.2538 6.59695 18 7.33333 18H12.6667C13.403 18 14 17.2538 14 16.3333C14 14.4924 12.5673 14 10.8 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14C16.6569 14 18 14.4924 18 16.3333C18 17.2538 17.4404 18 16.75 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-group": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","group","users","customer-group","customer-segment","loyalty-program","staff","team","membership","roles","permissions"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.8 14H9.2C7.43269 14 6 14.4924 6 16.3333C6 17.2538 6.59695 18 7.33333 18H12.6667C13.403 18 14 17.2538 14 16.3333C14 14.4924 12.5673 14 10.8 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 14C16.6569 14 18 14.4924 18 16.3333C18 17.2538 17.4404 18 16.75 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-groups-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["users","group","multiple-users","team","staff","employees","roles","permissions","user-accounts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8 14H11.2C9.43269 14 8 14.4924 8 16.3333C8 17.2538 8.59695 18 9.33333 18H14.6667C15.403 18 16 17.2538 16 16.3333C16 14.4924 14.5673 14 12.8 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14C5.34315 14 4 14.4924 4 16.3333C4 17.2538 4.55964 18 5.25 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12C5.34315 12 4 10.6569 4 9C4 7.34315 5.34315 6 7 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.6569 14 20 14.4924 20 16.3333C20 17.2538 19.4404 18 18.75 18"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-groups-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","users","group","groups","team","employees","staff","roles","permissions","management","user-group","employee-group","staff-group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8 14H11.2C9.43269 14 8 14.4924 8 16.3333C8 17.2538 8.59695 18 9.33333 18H14.6667C15.403 18 16 17.2538 16 16.3333C16 14.4924 14.5673 14 12.8 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14C5.34315 14 4 14.4924 4 16.3333C4 17.2538 4.55964 18 5.25 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12C5.34315 12 4 10.6569 4 9C4 7.34315 5.34315 6 7 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.6569 14 20 14.4924 20 16.3333C20 17.2538 19.4404 18 18.75 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-groups": {
        defaultColors: ["#3D4C66"],
        keywords: ["users","group","team","customer-group","staff","employees","roles","permissions","audience","customers","membership"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8 14H11.2C9.43269 14 8 14.4924 8 16.3333C8 17.2538 8.59695 18 9.33333 18H14.6667C15.403 18 16 17.2538 16 16.3333C16 14.4924 14.5673 14 12.8 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 14C5.34315 14 4 14.4924 4 16.3333C4 17.2538 4.55964 18 5.25 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12C5.34315 12 4 10.6569 4 9C4 7.34315 5.34315 6 7 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C18.6569 14 20 14.4924 20 16.3333C20 17.2538 19.4404 18 18.75 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-id-card-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","profile","account","id","information","customer","employee","data","details"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="10" cy="11" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M6 19L6.0883 18.7351C6.52832 17.4151 6.74832 16.755 7.2721 16.3775C7.79587 16 8.49159 16 9.88304 16H10.117C11.5084 16 12.2041 16 12.7279 16.3775C13.2517 16.755 13.4717 17.4151 13.9117 18.7351L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 11L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L15 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-groups-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["users","group","team","staff","employees","roles","permissions","management","user-groups","customer-group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4915 18.75H19.4167C20.7148 18.75 21.5 17.5032 21.5 16.3333C21.5 15.1789 21.0282 14.3392 20.2033 13.836C19.4454 13.3738 18.4758 13.25 17.55 13.25H17.0987C17.8552 14.0465 18.25 15.1143 18.25 16.3333C18.25 17.17 17.9936 18.0382 17.4915 18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.6377 12.0547C15.9847 12.1811 16.3593 12.25 16.75 12.25C18.5449 12.25 20 10.7949 20 9C20 7.20507 18.5449 5.75 16.75 5.75C16.3593 5.75 15.9847 5.81895 15.6377 5.94534C16.3319 6.77115 16.75 7.83675 16.75 9C16.75 10.1633 16.3319 11.2288 15.6377 12.0547Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 5.75C10.2051 5.75 8.75 7.20507 8.75 9C8.75 10.7949 10.2051 12.25 12 12.25C13.7949 12.25 15.25 10.7949 15.25 9C15.25 7.20507 13.7949 5.75 12 5.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M11.2 13.25C10.2742 13.25 9.30457 13.3738 8.54671 13.836C7.72182 14.3392 7.25 15.1789 7.25 16.3333C7.25 17.5032 8.03522 18.75 9.33333 18.75H14.6667C15.9648 18.75 16.75 17.5032 16.75 16.3333C16.75 15.1789 16.2782 14.3392 15.4533 13.836C14.6954 13.3738 13.7258 13.25 12.8 13.25H11.2Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.50852 18.75H4.58333C3.28522 18.75 2.5 17.5032 2.5 16.3333C2.5 15.1789 2.97182 14.3392 3.79671 13.836C4.55457 13.3738 5.52417 13.25 6.45 13.25H6.9013C6.14482 14.0465 5.75 15.1143 5.75 16.3333C5.75 17.17 6.00636 18.0382 6.50852 18.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.36234 12.0547C8.01533 12.1811 7.64072 12.25 7.25 12.25C5.45507 12.25 4 10.7949 4 9C4 7.20507 5.45507 5.75 7.25 5.75C7.64072 5.75 8.01533 5.81895 8.36234 5.94534C7.66815 6.77115 7.25 7.83675 7.25 9C7.25 10.1633 7.66815 11.2288 8.36234 12.0547Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-id-card-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","id","customer","employee","account","user-profile","customer-profile","employee-profile","customer-id","employee-id"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C21.0001 8.45869 21 9.5753 21 10.9294V13.0705C21 14.4247 21.0001 15.5413 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.7818 19.9677 16.0151 19.9913 15.1232 19.9976L14.6101 18.4585C14.4014 17.8321 14.2249 17.3027 14.0313 16.8865C13.8255 16.4441 13.5704 16.0602 13.1665 15.7691C12.7626 15.478 12.3178 15.3574 11.833 15.302C11.3769 15.25 10.8189 15.25 10.1587 15.25H9.84152C9.18127 15.25 8.62331 15.25 8.16721 15.302C7.68239 15.3574 7.23753 15.478 6.83365 15.7691C6.42978 16.0602 6.17469 16.4441 5.96886 16.8865C5.77523 17.3027 5.5988 17.8321 5.39004 18.4584L5.05688 19.4579C4.73686 19.3017 4.4405 19.0974 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99997 9.57535 2.99994 8.45868 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57534 3.99997 9.92943 4ZM6.75009 10.75C6.75009 8.95508 8.20516 7.5 10.0001 7.5C11.795 7.5 13.2501 8.95508 13.2501 10.75C13.2501 12.5449 11.795 14 10.0001 14C8.20516 14 6.75009 12.5449 6.75009 10.75ZM14.2501 9.25C14.2501 8.83579 14.5859 8.5 15.0001 8.5L17.0001 8.5C17.4143 8.5 17.7501 8.83579 17.7501 9.25C17.7501 9.66422 17.4143 10 17.0001 10H15.0001C14.5859 10 14.2501 9.66422 14.2501 9.25ZM15.0001 11.5C14.5859 11.5 14.2501 11.8358 14.2501 12.25C14.2501 12.6642 14.5859 13 15.0001 13H16.0001C16.4143 13 16.7501 12.6642 16.7501 12.25C16.7501 11.8358 16.4143 11.5 16.0001 11.5H15.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6.50037 19.8709C6.52515 19.8744 6.55001 19.8779 6.57494 19.8813C7.45868 20.0001 8.57527 20 9.92935 20H13.5429L13.2003 18.9723C12.9748 18.2959 12.8245 17.8487 12.6713 17.5192C12.5262 17.2072 12.4094 17.0724 12.2895 16.9859C12.1696 16.8995 12.0047 16.8314 11.6628 16.7924C11.3018 16.7511 10.83 16.75 10.1171 16.75H9.88313C9.17013 16.75 8.69836 16.7511 8.33735 16.7924C7.99551 16.8314 7.83062 16.8995 7.71072 16.9859C7.59082 17.0724 7.47402 17.2072 7.3289 17.5192C7.17563 17.8487 7.02537 18.2959 6.79991 18.9723L6.50037 19.8709Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-id-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","profile","id","card","user-profile","customer","member","account","customer-profile","member-profile","staff","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="10" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 19L6.0883 18.7351C6.52832 17.4151 6.74832 16.755 7.2721 16.3775C7.79587 16 8.49159 16 9.88304 16H10.117C11.5084 16 12.2041 16 12.7279 16.3775C13.2517 16.755 13.4717 17.4151 13.9117 18.7351L14 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 11L15 11" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L15 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L15 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-meeting-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["network","connections","nodes","relationship","customer-relations","location","store-locations","multi-location","hub","central","sales-team","collaboration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="12" r="2" transform="rotate(-90 6 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" transform="rotate(180 12 18)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="12" r="2" transform="rotate(90 18 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="2" transform="rotate(90 12 12)" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M10 6V6C9.07003 6 8.60504 6 8.22354 6.10222C7.18827 6.37962 6.37962 7.18827 6.10222 8.22354C6 8.60504 6 9.07003 6 10V10M14 6V6C14.93 6 15.395 6 15.7765 6.10222C16.8117 6.37962 17.6204 7.18827 17.8978 8.22355C18 8.60504 18 9.07003 18 10V10M6 14V14C6 14.93 6 15.395 6.10222 15.7765C6.37962 16.8117 7.18827 17.6204 8.22354 17.8978C8.60504 18 9.07003 18 10 18V18M14 18V18C14.93 18 15.395 18 15.7765 17.8978C16.8117 17.6204 17.6204 16.8117 17.8978 15.7765C18 15.395 18 14.93 18 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-meeting-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["users","group","meeting","team","employees","staff","customers","network","customer-group","user-group","group-discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.8571 6H11.1429C8.71849 6 7.50631 6 6.75315 6.75315C6 7.50631 6 8.71849 6 11.1429V12.8571C6 15.2815 6 16.4937 6.75315 17.2468C7.50631 18 8.71849 18 11.1429 18H12.8571C15.2815 18 16.4937 18 17.2468 17.2468C18 16.4937 18 15.2815 18 12.8571V12.8571L18 11.1429C18 8.71849 18 7.50631 17.2468 6.75315C16.4937 6 15.2815 6 12.8571 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="6"
                    r="2"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="6"
                    cy="12"
                    r="2"
                    transform="rotate(-90 6 12)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="18"
                    r="2"
                    transform="rotate(180 12 18)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="18"
                    cy="12"
                    r="2"
                    transform="rotate(90 18 12)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="2"
                    transform="rotate(90 12 12)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-meeting-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["group","people","team","users","customer-group","table","collaborate","meeting","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.70628 5.004C10.0911 4.11891 10.9733 3.5 12 3.5C13.0267 3.5 13.9089 4.11891 14.2937 5.004C13.8987 5 13.4687 5 13 5H11C10.5313 5 10.1013 5 9.70628 5.004ZM5.004 9.70628C5.02413 7.71753 5.14562 6.61174 5.87868 5.87868C6.61174 5.14562 7.71753 5.02413 9.70628 5.004C9.57358 5.30918 9.5 5.64599 9.5 6C9.5 7.38071 10.6193 8.5 12 8.5C13.3807 8.5 14.5 7.38071 14.5 6C14.5 5.64599 14.4264 5.30918 14.2937 5.004C16.2825 5.02413 17.3883 5.14562 18.1213 5.87868C18.8544 6.61174 18.9759 7.71753 18.996 9.70628C18.6908 9.57358 18.354 9.5 18 9.5C16.6193 9.5 15.5 10.6193 15.5 12C15.5 13.3807 16.6193 14.5 18 14.5C18.354 14.5 18.6908 14.4264 18.996 14.2937C18.9759 16.2825 18.8544 17.3883 18.1213 18.1213C17.3883 18.8544 16.2825 18.9759 14.2937 18.996C14.4264 18.6908 14.5 18.354 14.5 18C14.5 16.6193 13.3807 15.5 12 15.5C10.6193 15.5 9.5 16.6193 9.5 18C9.5 18.354 9.57358 18.6908 9.70628 18.996C7.71753 18.9759 6.61174 18.8544 5.87868 18.1213C5.14562 17.3883 5.02413 16.2825 5.004 14.2937C5.30918 14.4264 5.64599 14.5 6 14.5C7.38071 14.5 8.5 13.3807 8.5 12C8.5 10.6193 7.38071 9.5 6 9.5C5.64599 9.5 5.30918 9.57358 5.004 9.70628ZM5.004 9.70628C5 10.1013 5 10.5313 5 11V13C5 13.4687 5 13.8987 5.004 14.2937C4.11891 13.9089 3.5 13.0267 3.5 12C3.5 10.9733 4.11891 10.0911 5.004 9.70628ZM9.70628 18.996C10.0911 19.8811 10.9733 20.5 12 20.5C13.0267 20.5 13.9089 19.8811 14.2937 18.996C13.8987 19 13.4687 19 13 19H11C10.5313 19 10.1013 19 9.70628 18.996ZM18.996 14.2937C19.8811 13.9089 20.5 13.0267 20.5 12C20.5 10.9733 19.8811 10.0911 18.996 9.70628C19 10.1013 19 10.5313 19 11L19 13C19 13.4687 19 13.8987 18.996 14.2937ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-meeting": {
        defaultColors: ["#3D4C66"],
        keywords: ["network","connection","relationship","loyalty","referral","member","group","connect","team","partnership","structure","integration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="6" cy="12" r="2" transform="rotate(-90 6 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" transform="rotate(180 12 18)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="12" r="2" transform="rotate(90 18 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="12" r="2" transform="rotate(90 12 12)" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M10 6V6C9.07003 6 8.60504 6 8.22354 6.10222C7.18827 6.37962 6.37962 7.18827 6.10222 8.22354C6 8.60504 6 9.07003 6 10V10M14 6V6C14.93 6 15.395 6 15.7765 6.10222C16.8117 6.37962 17.6204 7.18827 17.8978 8.22355C18 8.60504 18 9.07003 18 10V10M6 14V14C6 14.93 6 15.395 6.10222 15.7765C6.37962 16.8117 7.18827 17.6204 8.22354 17.8978C8.60504 18 9.07003 18 10 18V18M14 18V18C14.93 18 15.395 18 15.7765 17.8978C16.8117 17.6204 17.6204 16.8117 17.8978 15.7765C18 15.395 18 14.93 18 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-minus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","minus","remove-user","delete-user","customer","remove-customer","delete-customer","profile","remove-profile","delete-profile","account","remove-account","delete-account"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 7L17 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-minus-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","remove","delete","minus","customer","account","profile","user-minus","delete-user","remove-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="10"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 7L17 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-minus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","remove","delete","minus","account","user-minus","remove-user","delete-user","profile","customer","remove-customer","delete-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.04601 13.25C6.55032 13.2497 6.16461 13.2495 5.81695 13.3413C5.04584 13.5451 4.40118 14.0736 4.05015 14.7898C3.89189 15.1126 3.81649 15.4909 3.7196 15.977L3.67953 16.1773C3.55979 16.7736 3.4673 17.2343 3.51103 17.6527C3.60835 18.5839 4.17272 19.4016 5.00886 19.8228C5.38459 20.0121 5.84809 20.089 6.44812 20.1885L9.14684 20.6383C9.42863 20.6853 9.65096 20.7225 9.87988 20.7225C10.1088 20.7225 10.3311 20.6853 10.6129 20.6383L13.3116 20.1885C13.9117 20.089 14.3752 20.0121 14.7509 19.8228C15.587 19.4016 16.1514 18.5839 16.2487 17.6527C16.2925 17.2343 16.2 16.7736 16.0802 16.1773L16.0402 15.977C15.9433 15.4909 15.8679 15.1126 15.7096 14.7898C15.3586 14.0736 14.7139 13.5451 13.9428 13.3413C13.5952 13.2495 13.2094 13.2497 12.7138 13.25H7.04601Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 7C16 6.44772 16.4477 6 17 6L21 6C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8L17 8C16.4477 8 16 7.55228 16 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-id-card-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","id","user-id","customer","customer-profile","employee","employee-profile","account","account-details","contact","contact-information"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 5H10C7.17157 5 5.75736 5 4.87868 5.87868C4 6.75736 4 8.17157 4 11V13C4 15.8284 4 17.2426 4.87868 18.1213C5.75736 19 7.17157 19 10 19L14 19C16.8284 19 18.2426 19 19.1213 18.1213C20 17.2426 20 15.8284 20 13V11C20 8.17157 20 6.75736 19.1213 5.87868C18.2426 5 16.8284 5 14 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="10"
                    cy="11"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.3482 16H9.65182C8.48715 16 7.90482 16 7.44022 16.2687C7.3245 16.3356 7.21579 16.414 7.1157 16.5026C6.71387 16.8584 6.52972 17.4108 6.16142 18.5157C6.09462 18.7162 6.06121 18.8164 6.09942 18.8911C6.10865 18.9091 6.12058 18.9257 6.13478 18.9401C6.19358 19 6.2992 19 6.51046 19H13.4895C13.7008 19 13.8064 19 13.8652 18.9401C13.8794 18.9257 13.8913 18.9091 13.9006 18.8911C13.9388 18.8164 13.9054 18.7162 13.8386 18.5157C13.4703 17.4108 13.2861 16.8584 12.8843 16.5026C12.7842 16.414 12.6755 16.3356 12.5598 16.2687C12.0952 16 11.5129 16 10.3482 16Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 11L15 11" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 9L15 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 13L15 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-open-arm-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","customer","employee","person","open","arms","greeting","support","help","manager"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20V16C9 13.7909 7.20914 12 5 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20V16C15 13.7909 16.7909 12 19 12V12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="8" r="4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "User-open-arm-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["user","customer","open arms","support","help","welcome","assistance","customer service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20V16C9 13.7909 7.20914 12 5 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20V16C15 13.7909 16.7909 12 19 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-minus": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","minus","remove-user","delete-user","employee","remove-employee","delete-employee","profile","account","disable-account","remove-account","person","customer","remove-customer","delete-customer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M21 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-open-arm": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","open","arms","support","assistance","help","welcome","available","person","figure"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 20V16C9 13.7909 7.20914 12 5 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 20V16C15 13.7909 16.7909 12 19 12V12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "user-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","slash","disabled","deactivated","removed","employee","remove-employee","disable-account","delete-account","user-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 4L4 20" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "user-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","slash","remove","delete","disable","inactive","user-remove","user-delete","user-disable","cancel-user"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 4L4 20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "user-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","slash","disabled","inactive","remove-user","delete-user","deactivate-user","access-denied"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L5.82346 16.7623C5.85081 16.5028 5.92492 16.207 6.01745 15.8377L6.03878 15.7526L6.04729 15.7184C6.08031 15.5857 6.11504 15.446 6.1688 15.3188C6.40462 14.7608 6.91228 14.3644 7.51085 14.271C7.64729 14.2497 7.79117 14.2499 7.92797 14.25L8.33575 14.25L10.0773 12.5085C8.83921 11.8285 8 10.5123 8 9C8 6.79086 9.79086 5 12 5C13.5123 5 14.8285 5.83921 15.5085 7.07732L19.2929 3.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.1642 14.2501L7.77805 19.6362C7.8451 19.656 7.91333 19.6735 7.98267 19.6884C8.27096 19.7505 8.61749 19.7503 9.07212 19.7501H14.9279C15.3825 19.7503 15.729 19.7505 16.0173 19.6884C17.3172 19.4085 18.2307 18.2386 18.1869 16.9096C18.1772 16.6149 18.093 16.2787 17.9825 15.8378L17.9612 15.7526L17.9527 15.7184C17.9197 15.5857 17.8849 15.446 17.8312 15.3188C17.5954 14.7608 17.0877 14.3644 16.4891 14.271C16.3527 14.2497 16.2088 14.2499 16.072 14.25L13.1642 14.2501Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "user-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","disabled","inactive","remove","delete","cancel","authorization","access-denied","no-access"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M14.8401 19H9.15994C8.61909 19 8.34867 19 8.14056 18.9552C7.19515 18.7516 6.53083 17.9008 6.56263 16.9342C6.56964 16.7215 6.63522 16.4591 6.7664 15.9344C6.80843 15.7663 6.82945 15.6822 6.85965 15.6107C6.99441 15.2919 7.2845 15.0654 7.62654 15.012C7.70319 15 7.78985 15 7.96317 15H16.0368C16.2101 15 16.2968 15 16.3735 15.012C16.7155 15.0654 17.0056 15.2919 17.1403 15.6107C17.1705 15.6822 17.1916 15.7663 17.2336 15.9344C17.3648 16.4591 17.4304 16.7215 17.4374 16.9342C17.4692 17.9008 16.8048 18.7516 15.8594 18.9552C15.6513 19 15.3809 19 14.8401 19Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M20 4L4 20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-square-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["user","customer","profile","account","login","employee","manager","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19L13 19C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-square-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","profile","account","customer","employee","manager","person","square-user","staff"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19L13 19C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-open-arm-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","open arms","welcome","support","loyalty","account","person","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2.5C9.23858 2.5 7 4.73858 7 7.5C7 10.2614 9.23858 12.5 12 12.5C14.7614 12.5 17 10.2614 17 7.5C17 4.73858 14.7614 2.5 12 2.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10 20.5C10 21.0522 9.55228 21.5 9 21.5C8.44772 21.5 8 21.0522 8 20.5V16.5C8 14.8431 6.65685 13.5 5 13.5C4.44772 13.5 4 13.0522 4 12.5C4 11.9477 4.44772 11.5 5 11.5C7.76142 11.5 10 13.7385 10 16.5V20.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14 20.5C14 21.0522 14.4477 21.5 15 21.5C15.5523 21.5 16 21.0522 16 20.5V16.5C16 14.8431 17.3431 13.5 19 13.5C19.5523 13.5 20 13.0522 20 12.5C20 11.9477 19.5523 11.5 19 11.5C16.2386 11.5 14 13.7385 14 16.5V20.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-square": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","person","square","customer-profile","account-profile","member","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 5H11C8.17157 5 6.75736 5 5.87868 5.87868C5 6.75736 5 8.17157 5 11V13C5 15.8284 5 17.2426 5.87868 18.1213C6.75736 19 8.17157 19 11 19L13 19C15.8284 19 17.2426 19 18.1213 18.1213C19 17.2426 19 15.8284 19 13V11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="11" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M8 19V19C8.30491 17.6279 8.45737 16.9419 8.93256 16.5139C8.98915 16.4629 9.0486 16.4152 9.11063 16.371C9.6315 16 10.3343 16 11.7398 16H12.2602C13.6657 16 14.3685 16 14.8894 16.371C14.9514 16.4152 15.0109 16.4629 15.0674 16.5139C15.5426 16.9419 15.6951 17.6279 16 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "User-support-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["support","customer-support","help","headphones","agent","remove","minus","decrease","remove-support"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 10C4.89543 10 4 9.10457 4 8C4 6.89543 4.89543 6 6 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 8L11 8" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-support-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer-service","support","help","agent","call-center","assistance","operator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4ZM13 7C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H11C10.4477 9 10 8.55228 10 8C10 7.44772 10.4477 7 11 7H13ZM5.5 7C4.94772 7 4.5 7.44772 4.5 8C4.5 8.55228 4.94772 9 5.5 9C6.05228 9 6.5 9.44772 6.5 10C6.5 10.5523 6.05228 11 5.5 11C3.84315 11 2.5 9.65685 2.5 8C2.5 6.34315 3.84315 5 5.5 5C6.05228 5 6.5 5.44772 6.5 6C6.5 6.55228 6.05228 7 5.5 7ZM17.5 6C17.5 5.44772 17.9477 5 18.5 5C20.1569 5 21.5 6.34315 21.5 8C21.5 9.65685 20.1569 11 18.5 11C17.9477 11 17.5 10.5523 17.5 10C17.5 9.44772 17.9477 9 18.5 9C19.0523 9 19.5 8.55228 19.5 8C19.5 7.44772 19.0523 7 18.5 7C17.9477 7 17.5 6.55228 17.5 6ZM10.8 14.25C9.44346 14.25 8.09693 14.4028 7.06605 14.9268C6.5378 15.1953 6.07363 15.5707 5.74465 16.0872C5.41418 16.606 5.25 17.2203 5.25 17.9167C5.25 19.4523 6.45266 20.75 8 20.75H16C17.5473 20.75 18.75 19.4523 18.75 17.9167C18.75 17.2203 18.5858 16.606 18.2554 16.0872C17.9264 15.5707 17.4622 15.1953 16.934 14.9268C15.9031 14.4028 14.5565 14.25 13.2 14.25H10.8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-square-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","account","profile","customer","employee","member","person","staff","users","customers","employees"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57527 20 10.9294V13.0706C20 14.4247 20.0001 15.5413 19.8813 16.4251C19.7565 17.3529 19.4845 18.1723 18.8284 18.8284C18.4009 19.2559 17.9041 19.5204 17.3531 19.6872L16.9435 18.4584C16.7347 17.8321 16.5583 17.3027 16.3647 16.8865C16.1588 16.4441 15.9037 16.0602 15.4999 15.7691C15.096 15.478 14.6511 15.3574 14.1663 15.302C13.7102 15.25 13.1522 15.25 12.492 15.25H11.5082C10.8479 15.25 10.29 15.25 9.83387 15.302C9.34906 15.3574 8.90419 15.478 8.50032 15.7691C8.09645 16.0602 7.84135 16.4441 7.63553 16.8865C7.44189 17.3027 7.26547 17.8321 7.0567 18.4584L6.64709 19.6873C6.09603 19.5204 5.59913 19.256 5.17158 18.8284C4.51547 18.1723 4.2435 17.3529 4.11876 16.4251C3.99994 15.5413 3.99997 14.4247 4 13.0706V10.9294C3.99997 9.57534 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57534 3.99997 10.9294 4ZM12 7.75C10.2051 7.75 8.75 9.20508 8.75 11C8.75 12.7949 10.2051 14.25 12 14.25C13.7949 14.25 15.25 12.7949 15.25 11C15.25 9.20508 13.7949 7.75 12 7.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.14397 19.9401C8.92341 20.0001 9.85112 20 10.9294 20L13.0706 20C14.1489 20 15.0767 20.0001 15.8562 19.9401L15.5336 18.9723C15.3081 18.2959 15.1579 17.8487 15.0046 17.5192C14.8595 17.2072 14.7427 17.0724 14.6228 16.986C14.5029 16.8995 14.338 16.8314 13.9962 16.7924C13.6351 16.7511 13.1634 16.75 12.4504 16.75H11.5498C10.8368 16.75 10.365 16.7511 10.004 16.7924C9.66217 16.8314 9.49729 16.8995 9.37739 16.986C9.25748 17.0724 9.14069 17.2072 8.99556 17.5192C8.8423 17.8487 8.69204 18.2959 8.46657 18.9723L8.14397 19.9401Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-support": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","headset","customer service","agent","remove","subtract","delete","operator","help","assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 10C4.89543 10 4 9.10457 4 8C4 6.89543 4.89543 6 6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 8L11 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-taking-headphone-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","support","customer-service","agent","headset","call-center","help"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 7L19 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L5 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-support-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","customer-support","agent","help","remove","disable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 10C4.89543 10 4 9.10457 4 8C4 6.89543 4.89543 6 6 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 10C19.1046 10 20 9.10457 20 8C20 6.89543 19.1046 6 18 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13 8L11 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "User-taking-headphone-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["support","help","customer-service","agent","operator","headset","call-center"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 8.5C7.5 6.01472 9.51472 4 12 4C14.4853 4 16.5 6.01472 16.5 8.5C16.5 10.9853 14.4853 13 12 13C9.51472 13 7.5 10.9853 7.5 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7V9C4 9.55229 4.44772 10 5 10C5.55228 10 6 9.55228 6 9V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20 7C20 6.44772 19.5523 6 19 6C18.4477 6 18 6.44772 18 7V9C18 9.55228 18.4477 10 19 10C19.5523 10 20 9.55228 20 9V7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.8 14.25C9.44346 14.25 8.09693 14.4028 7.06605 14.9268C6.5378 15.1953 6.07363 15.5707 5.74465 16.0872C5.41418 16.606 5.25 17.2203 5.25 17.9167C5.25 19.4523 6.45266 20.75 8 20.75H16C17.5473 20.75 18.75 19.4523 18.75 17.9167C18.75 17.2203 18.5858 16.606 18.2554 16.0872C17.9264 15.5707 17.4622 15.1953 16.934 14.9268C15.9031 14.4028 14.5565 14.25 13.2 14.25H10.8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-taking-headphone": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","account","support","help","agent","headset","call-center","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path d="M19 7L19 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L5 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-taking-headphone-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["support","headset","agent","customer-service","operator","representative","help","call-center","assistance","contact","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M19 7L19 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 7L5 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M13.2 15H10.8C8.14903 15 6 15.6155 6 17.9167C6 19.0673 6.89543 20 8 20H16C17.1046 20 18 19.0673 18 17.9167C18 15.6155 15.851 15 13.2 15Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "User-talking-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","customer","support","help","communication","call","talking","audio","broadcast","speaker","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 20L6.24254 19.0299C6.60632 17.5747 6.78821 16.8472 7.33073 16.4236C7.87325 16 8.6232 16 10.1231 16H13.8769C15.3768 16 16.1267 16 16.6693 16.4236C17.2118 16.8472 17.3937 17.5747 17.7575 19.0299L18 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.2378 14C20.5874 10.9751 20.5874 7.02493 18.2378 4M5.76182 13.999C3.41273 10.9743 3.41273 7.0247 5.76182 4"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-talking-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["customer","user","support","help","contact","communication","hands-up","assistance","raise-hand","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.37519 3.21026C6.81138 3.54902 6.89036 4.17724 6.5516 4.61342C4.4828 7.27724 4.4828 10.7219 6.5516 13.3857C6.89036 13.8219 6.81138 14.4501 6.37519 14.7888C5.939 15.1276 5.31078 15.0486 4.97203 14.6124C2.34266 11.2268 2.34266 6.77226 4.97203 3.38667C5.31078 2.95048 5.939 2.8715 6.37519 3.21026Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.6244 3.2103C18.0605 2.87151 18.6888 2.95045 19.0275 3.38661C21.6575 6.77246 21.6575 11.2276 19.0275 14.6135C18.6888 15.0496 18.0605 15.1286 17.6244 14.7898C17.1882 14.451 17.1093 13.8228 17.4481 13.3866C19.5173 10.7226 19.5173 7.27749 17.4481 4.61348C17.1093 4.17731 17.1882 3.54909 17.6244 3.2103Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 5C9.51472 5 7.5 7.01472 7.5 9.5C7.5 11.9853 9.51472 14 12 14C14.4853 14 16.5 11.9853 16.5 9.5C16.5 7.01472 14.4853 5 12 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.0791 15.25H13.9211C14.6334 15.25 15.2337 15.25 15.7212 15.3083C16.2389 15.3702 16.7119 15.5053 17.1309 15.8324C17.5499 16.1596 17.7958 16.5857 17.9814 17.0729C18.1562 17.5317 18.3017 18.1141 18.4745 18.8051L18.5489 19.1026C18.5849 19.2464 18.6293 19.4233 18.6451 19.5791C18.6641 19.7656 18.6601 20.0687 18.4435 20.3462C18.2269 20.6236 17.9337 20.701 17.7482 20.7279C17.5932 20.7503 17.4109 20.7501 17.2626 20.75H6.73758C6.58935 20.7501 6.40698 20.7503 6.25196 20.7279C6.06648 20.701 5.77333 20.6236 5.55671 20.3462C5.34009 20.0687 5.33611 19.7656 5.35506 19.5791C5.3709 19.4233 5.41527 19.2464 5.45134 19.1026L5.52573 18.8051C5.69847 18.1141 5.84403 17.5317 6.01884 17.0729C6.20442 16.5857 6.45027 16.1596 6.86926 15.8324C7.28825 15.5053 7.76133 15.3702 8.27894 15.3083C8.76648 15.25 9.36676 15.25 10.0791 15.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-talking": {
        defaultColors: ["#3D4C66"],
        keywords: ["announcement","notification","alert","user","customer","communication","speaker","talking","broadcast","message","news"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 20L6.24254 19.0299C6.60632 17.5747 6.78821 16.8472 7.33073 16.4236C7.87325 16 8.6232 16 10.1231 16H13.8769C15.3768 16 16.1267 16 16.6693 16.4236C17.2118 16.8472 17.3937 17.5747 17.7575 19.0299L18 20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.2378 14C20.5874 10.9751 20.5874 7.02493 18.2378 4M5.76182 13.999C3.41273 10.9743 3.41273 7.0247 5.76182 4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-tick-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["user","tick","check","verified","approved","authorized","customer","member","staff","employee","valid","account","profile"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L18 10L21 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-talking-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","customer","speaker","sound","communication","support","help","agent","assistance","call","contact"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="9"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6.18638 19.2545L6.24254 19.0299C6.60632 17.5747 6.78821 16.8472 7.33073 16.4236C7.87325 16 8.6232 16 10.1231 16H13.8769C15.3768 16 16.1267 16 16.6693 16.4236C17.2118 16.8472 17.3937 17.5747 17.7575 19.0299L17.8136 19.2545L17.8136 19.2545C17.8994 19.5977 17.9423 19.7692 17.8522 19.8846C17.7621 20 17.5853 20 17.2315 20H6.76847C6.41472 20 6.23785 20 6.14777 19.8846C6.05769 19.7692 6.10059 19.5977 6.18638 19.2545Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.2378 14C20.5874 10.9751 20.5874 7.02493 18.2378 4M5.76182 13.999C3.41273 10.9743 3.41273 7.0247 5.76182 4"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-tick-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","customer","profile","tick","check","approved","verified","customer-verified","account-verified","member"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M7.04601 13.25C6.55032 13.2497 6.16461 13.2495 5.81695 13.3413C5.04584 13.5451 4.40118 14.0736 4.05015 14.7898C3.89189 15.1126 3.81649 15.4909 3.7196 15.977L3.67953 16.1773C3.55979 16.7736 3.4673 17.2343 3.51103 17.6527C3.60835 18.5839 4.17272 19.4016 5.00886 19.8228C5.38459 20.0121 5.84809 20.089 6.44812 20.1885L9.14684 20.6383C9.42863 20.6853 9.65096 20.7225 9.87988 20.7225C10.1088 20.7225 10.3311 20.6853 10.6129 20.6383L13.3116 20.1885C13.9117 20.089 14.3752 20.0121 14.7509 19.8228C15.587 19.4016 16.1514 18.5839 16.2487 17.6527C16.2925 17.2343 16.2 16.7736 16.0802 16.1773L16.0402 15.977C15.9433 15.4909 15.8679 15.1126 15.7096 14.7898C15.3586 14.0736 14.7139 13.5451 13.9428 13.3413C13.5952 13.2495 13.2094 13.2497 12.7138 13.25H7.04601Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7071 6.29289C22.0976 6.68342 22.0976 7.31658 21.7071 7.70711L18.7071 10.7071C18.3166 11.0976 17.6834 11.0976 17.2929 10.7071L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L18 8.58579L20.2929 6.29289C20.6834 5.90237 21.3166 5.90237 21.7071 6.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "User-tick": {
        defaultColors: ["#3D4C66"],
        keywords: ["user","person","profile","account","check","tick","verified","approved","confirmation","customer","member","employee","authorized","valid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L18 10L21 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "User-tick-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["user","tick","check","approved","verified","user-verified","user-approved","account","profile","valid","authorized"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="10"
                    cy="8"
                    r="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.7436 14H7.25642C6.67203 14 6.37983 14 6.12867 14.0664C5.56786 14.2146 5.09902 14.5989 4.84373 15.1198C4.72939 15.353 4.67209 15.6396 4.55748 16.2126C4.41616 16.9192 4.3455 17.2725 4.37708 17.5747C4.44786 18.2519 4.85832 18.8466 5.46641 19.1529C5.73775 19.2896 6.09315 19.3489 6.80393 19.4673L9.3424 19.8904L9.34242 19.8904C9.67046 19.9451 9.83448 19.9724 10 19.9724C10.1655 19.9724 10.3295 19.9451 10.6576 19.8904L10.6576 19.8904L13.1961 19.4673C13.9069 19.3489 14.2622 19.2896 14.5336 19.1529C15.1417 18.8466 15.5521 18.2519 15.6229 17.5747C15.6545 17.2725 15.5838 16.9192 15.4425 16.2126C15.3279 15.6396 15.2706 15.353 15.1563 15.1198C14.901 14.5989 14.4321 14.2146 13.8713 14.0664C13.6202 14 13.328 14 12.7436 14Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 9L18 10L21 7"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    User: {
        defaultColors: ["#3D4C66"],
        keywords: ["user","tick","check","approved","verified","user-verified","user-approved","account","profile","valid","authorized"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <rect x="5" y="14" width="14" height="6" rx="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Ux-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["UX","design","user-experience","interface","customer-experience","development","prototyping","ui","wireframing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10V12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14L15 12M15 12L13 10M15 12L13 14M15 12L17 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Ux-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["ux","user experience","settings","preferences","configuration","customization","adjustments","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10V12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12V10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14L15 12M15 12L13 10M15 12L13 14M15 12L17 10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    Ux: {
        defaultColors: ["#3D4C66"],
        keywords: ["ux","user experience","settings","preferences","configuration","customization","adjustments","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 10V12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14L15 12M15 12L13 10M15 12L13 14M15 12L17 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "V-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["v","verification","validate","verified","valid","volume","vendor"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 17L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Ux-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["ux","user-experience","design","interface","settings","configuration","customization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92944 3H14.0706C15.4246 2.99997 16.5413 2.99994 17.4251 3.11876C18.3529 3.2435 19.1723 3.51547 19.8284 4.17158C20.4845 4.82769 20.7565 5.64711 20.8813 6.57494C21.0001 7.45869 21 8.5753 21 9.9294V14.0706C21 15.4247 21.0001 16.5413 20.8813 17.4251C20.7565 18.3529 20.4845 19.1723 19.8284 19.8284C19.1723 20.4845 18.3529 20.7565 17.4251 20.8813C16.5413 21.0001 15.4247 21 14.0706 21H9.92944C8.57535 21 7.45869 21.0001 6.57494 20.8813C5.64711 20.7565 4.82769 20.4845 4.17158 19.8284C3.51547 19.1723 3.2435 18.3529 3.11876 17.4251C2.99994 16.5413 2.99997 15.4247 3 14.0706V9.92939C2.99997 8.57532 2.99994 7.45868 3.11876 6.57494C3.2435 5.64711 3.51547 4.82769 4.17158 4.17158C4.82769 3.51547 5.64711 3.2435 6.57494 3.11876C7.45868 2.99994 8.57536 2.99997 9.92944 3ZM6.87012 9.25C7.28433 9.25 7.62012 9.58579 7.62012 10V12C7.62012 12.6904 8.17976 13.25 8.87012 13.25C9.56047 13.25 10.1201 12.6904 10.1201 12V10C10.1201 9.58579 10.4559 9.25 10.8701 9.25C11.2843 9.25 11.6201 9.58579 11.6201 10V12C11.6201 13.5188 10.3889 14.75 8.87012 14.75C7.35134 14.75 6.12012 13.5188 6.12012 12V10C6.12012 9.58579 6.4559 9.25 6.87012 9.25ZM13.6504 9.46967C13.3576 9.17678 12.8827 9.17678 12.5898 9.46967C12.2969 9.76256 12.2969 10.2374 12.5898 10.5303L14.0595 12L12.5898 13.4697C12.2969 13.7626 12.2969 14.2374 12.5898 14.5303C12.8827 14.8232 13.3576 14.8232 13.6504 14.5303L15.1201 13.0607L16.5898 14.5303C16.8827 14.8232 17.3576 14.8232 17.6504 14.5303C17.9433 14.2374 17.9433 13.7626 17.6504 13.4697L16.1808 12L17.6504 10.5303C17.9433 10.2374 17.9433 9.76256 17.6504 9.46967C17.3576 9.17678 16.8827 9.17678 16.5898 9.46967L15.1201 10.9393L13.6504 9.46967Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "V-3": {
        defaultColors: ["#3d4c66", "#FFFFFF"],
        keywords: ["letter-v","v","validate","verify","voucher","version"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_34481)">
                    <path
                        d="M17 6H15C14.4 6 14 6.4 14 7C14 7.4 14.2 7.7 14.6 7.9L12 14.3L9.4 7.9C9.8 7.7 10 7.4 10 7C10 6.4 9.6 6 9 6H7C6.4 6 6 6.4 6 7C6 7.6 6.4 8 7 8H7.3L11 17.4C11.2 17.8 11.6 18 12 18C12.4 18 12.8 17.8 12.9 17.4L16.7 8H17C17.6 8 18 7.6 18 7C18 6.4 17.6 6 17 6Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1_34481">
                        <rect width="12" height="12" fill={colors?.[1] || "#FFFFFF"} transform="translate(6 6)" />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    "V-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["verify","validation","V","accept","confirm","valid","voucher"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 17L8 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "V-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-down","dropdown","expand","collapse","options","menu","select"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L13.8383 14.7107C13.0524 16.5445 12.6594 17.4614 12 17.4614C11.3406 17.4614 10.9476 16.5445 10.1617 14.7107L6 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "V-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["arrow-down","collapse","minimize","hide","expandable","view-details","less"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L13.8383 14.7107C13.0524 16.5445 12.6594 17.4614 12 17.4614C11.3406 17.4614 10.9476 16.5445 10.1617 14.7107L6 5"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "V-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["v","down","arrow","discount","validate","voucher","verify","close","collapse","minimize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.60634 4.08062C6.11397 3.86307 6.70185 4.09822 6.9194 4.60585L11.0811 14.3165C11.4873 15.2644 11.7501 15.871 11.9829 16.2538L12.0003 16.282L12.0176 16.2538C12.2504 15.871 12.5132 15.2644 12.9194 14.3165L17.0811 4.60585C17.2987 4.09822 17.8865 3.86307 18.3942 4.08062C18.9018 4.29818 19.137 4.88606 18.9194 5.39369L14.7271 15.1757C14.3604 16.0315 14.0425 16.7734 13.7263 17.2932C13.4182 17.7996 12.8959 18.4612 12.0003 18.4612C11.1046 18.4612 10.5823 17.7996 10.2742 17.2932C9.95799 16.7734 9.64011 16.0315 9.27338 15.1757L5.08111 5.39369C4.86356 4.88606 5.09871 4.29818 5.60634 4.08062Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "V-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["dropdown","arrow-down","select","chevron-down","expand","collapse","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L13.8383 14.7107C13.0524 16.5445 12.6594 17.4614 12 17.4614C11.3406 17.4614 10.9476 16.5445 10.1617 14.7107L6 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vail-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["thermometer","temperature","health","medical","sick","fever","illness","check-temperature","covid","covid-check","health-check"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.29408 12.4575C3.56864 14.183 3.56864 16.9805 5.29408 18.7059C7.01953 20.4314 9.81703 20.4314 11.5425 18.7059C12.6989 17.5495 13.0802 15.9116 12.6866 14.4376L19.353 7.77124C20.2157 6.90851 20.2157 5.50976 19.353 4.64704C18.4902 3.78432 17.0915 3.78432 16.2288 4.64704L9.56241 11.3134C8.0884 10.9198 6.45048 11.3011 5.29408 12.4575Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.87857 16.9497C10.6596 16.1686 10.6596 14.9023 9.87857 14.1212C9.09752 13.3402 7.83119 13.3402 7.05014 14.1212C6.26909 14.9023 6.26909 16.1686 7.05014 16.9497C7.83119 17.7307 9.09752 17.7307 9.87857 16.9497Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8286 9.17139L9.82861 14.1714"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Vail-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["thermometer","temperature","degrees","weather","cold","hot","health","warning","alert","monitoring","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.29408 12.4575C3.56864 14.183 3.56864 16.9805 5.29408 18.7059C7.01953 20.4314 9.81703 20.4314 11.5425 18.7059C12.6989 17.5495 13.0802 15.9116 12.6866 14.4376L19.353 7.77124C20.2157 6.90851 20.2157 5.50976 19.353 4.64704C18.4902 3.78432 17.0915 3.78432 16.2288 4.64704L9.56241 11.3134C8.0884 10.9198 6.45048 11.3011 5.29408 12.4575Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.87857 16.9497C10.6596 16.1686 10.6596 14.9023 9.87857 14.1212C9.09752 13.3402 7.83119 13.3402 7.05014 14.1212C6.26909 14.9023 6.26909 16.1686 7.05014 16.9497C7.83119 17.7307 9.09752 17.7307 9.87857 16.9497Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8286 9.17139L9.82861 14.1714"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    V: {
        defaultColors: ["#3D4C66"],
        keywords: ["thermometer","temperature","degrees","weather","cold","hot","health","warning","alert","monitoring","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 17L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Vail: {
        defaultColors: ["#3D4C66"],
        keywords: ["thermometer","temperature","degrees","weather","cold","hot","health","warning","alert","monitoring","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.29408 12.4575C3.56864 14.183 3.56864 16.9805 5.29408 18.7059C7.01953 20.4314 9.81703 20.4314 11.5425 18.7059C12.6989 17.5495 13.0802 15.9116 12.6866 14.4376L19.353 7.77124C20.2157 6.90851 20.2157 5.50976 19.353 4.64704C18.4902 3.78432 17.0915 3.78432 16.2288 4.64704L9.56241 11.3134C8.0884 10.9198 6.45048 11.3011 5.29408 12.4575Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.87857 16.9497C10.6596 16.1686 10.6596 14.9023 9.87857 14.1212C9.09752 13.3402 7.83119 13.3402 7.05014 14.1212C6.26909 14.9023 6.26909 16.1686 7.05014 16.9497C7.83119 17.7307 9.09752 17.7307 9.87857 16.9497Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.8286 9.17139L9.82861 14.1714"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Vector 586": {
        defaultColors: ["#3D4C66"],
        keywords: ["donut","ring","loader","loading","progress","waiting","pending","buffering"],
        getIcon: (colors?: string[]) => (
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 3C1 1.89543 1.89543 1 3 1C4.10457 1 5 1.89543 5 3C5 4.10457 4.10457 5 3 5C1.89543 5 1 4.10457 1 3Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vail-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["temperature","thermometer","hot","cold","measure","settings","adjust","modifier","discount","fee","surcharge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.8833 4.11671C18.7277 2.9611 16.854 2.9611 15.6984 4.11671L9.32237 10.4928C9.32237 10.4928 6.00448 10.6865 4.76375 11.9272C2.74541 13.9455 2.74542 17.2179 4.76375 19.2362C6.78209 21.2546 10.0545 21.2546 12.0728 19.2362C13.3135 17.9955 13.7907 16.2813 13.5072 14.6776L19.8833 8.30157C21.0389 7.14595 21.0389 5.27233 19.8833 4.11671ZM15.5357 8.46428C15.9262 8.8548 15.9262 9.48797 15.5357 9.87849L11.1721 14.2421C11.7048 15.3572 11.5093 16.7332 10.5857 17.6568C9.4141 18.8284 7.51461 18.8284 6.34304 17.6568C5.17146 16.4852 5.17146 14.5857 6.34304 13.4141C7.26671 12.4905 8.64284 12.295 9.75799 12.8278L14.1215 8.46428C14.512 8.07376 15.1452 8.07376 15.5357 8.46428ZM7.75725 14.8284C8.14777 14.4378 8.78094 14.4378 9.17146 14.8284C9.56199 15.2189 9.56199 15.852 9.17146 16.2426C8.78094 16.6331 8.14777 16.6331 7.75725 16.2426C7.36672 15.852 7.36672 15.2189 7.75725 14.8284Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Vector 593": {
        defaultColors: ["#3D4C66"],
        keywords: ["vertical-bar","pipe","separator","divider","stock","inventory"],
        getIcon: (colors?: string[]) => (
            <svg width="2" height="9" viewBox="0 0 2 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 1L1 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vector 594": {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","subtract","decrease","remove","discount","reduction"],
        getIcon: (colors?: string[]) => (
            <svg width="7" height="2" viewBox="0 0 7 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 1L1 1"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vector 590": {
        defaultColors: ["#3D4C66"],
        keywords: ["minus","subtract","remove","decrease","reduce","delete","discount","lower"],
        getIcon: (colors?: string[]) => (
            <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 1L1 1"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vector-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["diamond","shape","area","selection","tile","layout","highlight","focus","module","section","item","category","navigation","structure"],
        getIcon: (colors?: string[]) => (
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7L7 4L4 1L1 4L4 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "version-share-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["share","version","link","connect","branch","network","relation","share-order","connect-payment","linked-accounts"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8V8C18 9.86923 18 10.8038 17.5981 11.5C17.3348 11.9561 16.9561 12.3348 16.5 12.5981C15.8038 13 14.8692 13 13 13L11 13C9.13077 13 8.19615 13 7.5 12.5981C7.04394 12.3348 6.66523 11.9561 6.40192 11.5C6 10.8038 6 9.86923 6 8V8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="6" cy="6" r="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="6" r="2" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "version-share-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["branch","network","connection","tree","inventory","split","group","server","connected","hierarchy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 8V8C18 9.86923 18 10.8038 17.5981 11.5C17.3348 11.9561 16.9561 12.3348 16.5 12.5981C15.8038 13 14.8692 13 13 13L11 13C9.13077 13 8.19615 13 7.5 12.5981C7.04394 12.3348 6.66523 11.9561 6.40192 11.5C6 10.8038 6 9.86923 6 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="6" cy="6" r="2" fill={colors?.[1] || "#D9D1E0"} stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" />
                <circle
                    cx="12"
                    cy="18"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="18"
                    cy="6"
                    r="2"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "version-share-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["branch","merge","connection","combine","link","group","network","share","sync","affiliate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 3C4.34315 3 3 4.34315 3 6C3 7.30681 3.83556 8.41846 5.00158 8.82985C5.00514 9.38375 5.01672 9.86529 5.05432 10.2802C5.11085 10.9039 5.23242 11.4744 5.5359 12C5.88697 12.6081 6.39192 13.113 7 13.4641C7.52564 13.7676 8.09615 13.8892 8.71983 13.9457C9.31951 14 10.0585 14 10.9539 14H11V15.1707C9.83481 15.5825 9 16.6938 9 18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18C15 16.6938 14.1652 15.5825 13 15.1707L13 14H13.046C13.9415 14 14.6805 14 15.2802 13.9457C15.9039 13.8892 16.4744 13.7676 17 13.4641C17.6081 13.113 18.113 12.6081 18.4641 12C18.7676 11.4744 18.8892 10.9039 18.9457 10.2802C18.9833 9.86529 18.9949 9.38375 18.9984 8.82985C20.1644 8.41846 21 7.30681 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.30557 15.834 8.41636 16.9983 8.82868C16.9948 9.35365 16.9845 9.76103 16.9538 10.0996C16.9099 10.5846 16.8305 10.8295 16.7321 11C16.5565 11.304 16.304 11.5565 16 11.7321C15.8295 11.8305 15.5846 11.9099 15.0996 11.9538C14.6009 11.999 13.953 12 13 12H11C10.047 12 9.39908 11.999 8.90036 11.9538C8.41539 11.9099 8.17051 11.8305 8 11.7321C7.69596 11.5565 7.44349 11.304 7.26795 11C7.16951 10.8295 7.09011 10.5846 7.04616 10.0996C7.01547 9.76103 7.00518 9.35365 7.00173 8.82868C8.16602 8.41636 9 7.30557 9 6C9 4.34315 7.65685 3 6 3ZM5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6ZM11 18C11 17.448 11.4472 17.0005 11.999 17L12.001 17C12.5528 17.0005 13 17.448 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18ZM17 6C17 5.44772 17.4477 5 18 5C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7C17.4477 7 17 6.55228 17 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Vector: {
        defaultColors: ["#3D4C66"],
        keywords: ["branch","merge","connection","combine","link","group","network","share","sync","affiliate"],
        getIcon: (colors?: string[]) => (
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 5H5V1H1V5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "vertical-center-align-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["align","vertical-align","center","vertical-center","layout","distribution","arrange","content-alignment","format"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L9 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9L14 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "version-share": {
        defaultColors: ["#3D4C66"],
        keywords: ["share","branch","merge","connect","connection","split","network","relationship","link","distribution","version-share"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="12" cy="18" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="18" cy="6" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M18 8V8C18 9.86923 18 10.8038 17.5981 11.5C17.3348 11.9561 16.9561 12.3348 16.5 12.5981C15.8038 13 14.8692 13 13 13L11 13C9.13077 13 8.19615 13 7.5 12.5981C7.04394 12.3348 6.66523 11.9561 6.40192 11.5C6 10.8038 6 9.86923 6 8V8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M12 16L12 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-center-align-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","text","layout","vertical-center","center-align","formatting","positioning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9 6C9.55228 6 10 6.44772 10 7V11H13V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H15V15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15V13H10V17C10 17.5523 9.55229 18 9 18C8.44772 18 8 17.5523 8 17V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H8V7C8 6.44772 8.44772 6 9 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vertical-center-align": {
        defaultColors: ["#3D4C66"],
        keywords: ["alignment","vertical","center","adjust","layout","display","interface"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9L14 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-distribute-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["lines","menu","more","options","navigation","list","horizontal-lines","group","grouping","stack"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12L9 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-center-align-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["align","vertical","center","display","layout","arrange","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 7L9 17" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 9L14 15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-distribute-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","hamburger-menu","options","navigation","more","settings","list","filter","sort"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 17C4 16.4477 4.44772 16 5 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vertical-distribute-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["menu","options","settings","hamburger","list","lines"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12L9 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-distribute": {
        defaultColors: ["#3D4C66"],
        keywords: ["menu","options","list","hamburger","lines","stack","navigation","more"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 7H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 17H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 12L9 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-split-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["split","view","layout","table","order-details","details","menu","categories","section"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6H16C15.0572 6 14.5858 6 14.2929 6.29289C14 6.58579 14 7.05719 14 8V16C14 16.9428 14 17.4142 14.2929 17.7071C14.5858 18 15.0572 18 16 18H18C18.9428 18 19.4142 18 19.7071 17.7071C20 17.4142 20 16.9428 20 16V8C20 7.05719 20 6.58579 19.7071 6.29289C19.4142 6 18.9428 6 18 6Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18H4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-split-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["layout","split","sections","columns","interface","panels","configuration","settings","organize","group"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9456 5.00001C15.5215 4.99992 15.1094 4.99984 14.7695 5.04554C14.3863 5.09706 13.949 5.22259 13.5858 5.5858C13.2226 5.94902 13.0971 6.38629 13.0455 6.76949C12.9998 7.10939 12.9999 7.5215 13 7.94555V16.0544C12.9999 16.4785 12.9998 16.8906 13.0455 17.2305C13.0971 17.6137 13.2226 18.051 13.5858 18.4142C13.949 18.7774 14.3863 18.903 14.7695 18.9545C15.1094 19.0002 15.5215 19.0001 15.9455 19H18.0544C18.4785 19.0001 18.8906 19.0002 19.2305 18.9545C19.6137 18.903 20.051 18.7774 20.4142 18.4142C20.7774 18.051 20.903 17.6137 20.9545 17.2305C21.0002 16.8906 21.0001 16.4785 21 16.0544V7.9456C21.0001 7.52153 21.0002 7.10941 20.9545 6.76949C20.903 6.38629 20.7774 5.94902 20.4142 5.5858C20.051 5.22259 19.6137 5.09706 19.2305 5.04554C18.8906 4.99984 18.4785 4.99992 18.0544 5.00001H15.9456Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 6C3 5.44772 3.44772 5 4 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H4C3.44772 7 3 6.55228 3 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H10C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H4C3.44772 15 3 14.5523 3 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9H4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vertical-split-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["split-screen","layout","arrange","screen","vertical-split","view","side-by-side"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6H16C15.0572 6 14.5858 6 14.2929 6.29289C14 6.58579 14 7.05719 14 8V16C14 16.9428 14 17.4142 14.2929 17.7071C14.5858 18 15.0572 18 16 18H18C18.9428 18 19.4142 18 19.7071 17.7071C20 17.4142 20 16.9428 20 16V8C20 7.05719 20 6.58579 19.7071 6.29289C19.4142 6 18.9428 6 18 6Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18H4" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10H10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-top-align-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["align-top","align","top","arrange","interface","layout","vertical-align"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 9L9 19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-top-align-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["vertical align","top align","align","formatting","layout","display","position","sort","arrange","justify"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 9L9 19" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 15" stroke={colors?.[1] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-split": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","layout","view","sections","divide","table","display","arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6H16C15.0572 6 14.5858 6 14.2929 6.29289C14 6.58579 14 7.05719 14 8V16C14 16.9428 14 17.4142 14.2929 17.7071C14.5858 18 15.0572 18 16 18H18C18.9428 18 19.4142 18 19.7071 17.7071C20 17.4142 20 16.9428 20 16V8C20 7.05719 20 6.58579 19.7071 6.29289C19.4142 6 18.9428 6 18 6Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M4 6H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 18H4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 14H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M4 10H10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-top-align": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","vertical","order","receipt","invoice","layout","design"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 6H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 9L9 19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 9L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "VI-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["vi","6","number-6","roman-numerals","version-6"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 7L10 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 7L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vertical-top-align-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["align","top","vertical","sort","arrange","layout","display","interface","format","position"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9 8.5C9.55228 8.5 10 8.94772 10 9.5L10 19C10 19.5523 9.55229 20 9 20C8.44772 20 8 19.5523 8 19L8 9.5C8 8.94772 8.44772 8.5 9 8.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 9.5C16 8.94772 15.5523 8.5 15 8.5C14.4477 8.5 14 8.94772 14 9.5V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V9.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "VI-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["VI","Roman Numerals","Six","Version 6","Sixth","Count","Number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 8L20 16C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H18C17.4477 18 17 17.5523 17 17C17 16.4477 17.4477 16 18 16L18 8C17.4477 8 17 7.55228 17 7C17 6.44772 17.4477 6 18 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.92848 17.3717C9.77661 17.7513 9.4089 18.0003 9 18.0003C8.59109 18.0003 8.22339 17.7513 8.07152 17.3717L4.32297 8.00027H4C3.44772 8.00027 3 7.55255 3 7.00027C3 6.44798 3.44772 6.00027 4 6.00027H6C6.55228 6.00027 7 6.44798 7 7.00027C7 7.39588 6.77027 7.73784 6.43693 7.90001L9 14.3077L11.5631 7.90001C11.2297 7.73784 11 7.39588 11 7.00027C11 6.44798 11.4477 6.00027 12 6.00027H14C14.5523 6.00027 15 6.44798 15 7.00027C15 7.55255 14.5523 8.00027 14 8.00027H13.677L9.92848 17.3717Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    VI: {
        defaultColors: ["#3D4C66"],
        keywords: ["VI","Roman Numerals","Six","Version 6","Sixth","Count","Number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 7L10 17L6 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 7L15 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Video minu-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","camera","minus","decrease","reduce","quantity","remove","video-call","meeting"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video minu-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","camera","remove","discount","cancel","delete","adjustment","decrease"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "VI-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["vi","roman-numerals","number-6","version-6","6","update","v6"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 17L18 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M17 7L19 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 17L19 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14 7L10 17L6 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 7L7 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 7L15 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Video minu-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","minus","remove","delete","cancel","recording","video-recording","remove-video","cancel-recording","disable-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0706 5H9.92943C8.57536 4.99997 7.45868 4.99994 6.57494 5.11876C5.64711 5.2435 4.82769 5.51547 4.17158 6.17158C3.51547 6.82769 3.2435 7.64711 3.11876 8.57494C2.99994 9.45868 2.99997 10.5753 3 11.9294V12.0706C2.99997 13.4247 2.99994 14.5413 3.11876 15.4251C3.2435 16.3529 3.51547 17.1723 4.17158 17.8284C4.82769 18.4845 5.64711 18.7565 6.57494 18.8813C7.4587 19.0001 8.57531 19 9.92943 19H10.0706C11.4247 19 12.5413 19.0001 13.4251 18.8813C14.3529 18.7565 15.1723 18.4845 15.8284 17.8284C16.455 17.2019 16.7312 16.4263 16.8635 15.5497C17.4021 15.8186 17.8949 16.0593 18.3133 16.1962C18.7983 16.3549 19.4389 16.4618 20.0515 16.0832C20.6641 15.7046 20.8549 15.0838 20.9299 14.5791C21.0002 14.1056 21.0001 13.4987 21 12.8345V11.1654C21.0001 10.5012 21.0002 9.89427 20.9299 9.42082C20.8549 8.91606 20.6641 8.29529 20.0515 7.91669C19.4389 7.53809 18.7983 7.64499 18.3133 7.80369C17.8949 7.9406 17.4021 8.18128 16.8635 8.4502C16.7312 7.57361 16.455 6.79813 15.8284 6.17158C15.1723 5.51547 14.3529 5.2435 13.4251 5.11876C12.5413 4.99994 11.4247 4.99997 10.0706 5ZM13 12C13 11.4477 12.5523 11 12 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Video Player-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","play","tutorial","demonstration","training","guide","multimedia","information","display","playback","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1058 11.699C10.5322 11.5161 11.0826 11.7913 12.1833 12.3416C13.5069 13.0034 14.1686 13.3343 14.2509 13.8392C14.2683 13.9457 14.2683 14.0543 14.2509 14.1608C14.1686 14.6657 13.5069 14.9966 12.1833 15.6584C11.0826 16.2087 10.5322 16.4839 10.1058 16.301C10.0147 16.2619 9.92995 16.2095 9.85427 16.1455C9.5 15.8459 9.5 15.2306 9.5 14L9.5 14C9.5 12.7694 9.5 12.1541 9.85427 11.8545C9.92995 11.7905 10.0147 11.7381 10.1058 11.699Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video Player-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["video","play","tutorial","demo","information","help","guide","media","display","stream"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V10C4 7.17157 4 5.75736 4.87868 4.87868C5.75736 4 7.17157 4 10 4H14C16.8284 4 18.2426 4 19.1213 4.87868C20 5.75736 20 7.17157 20 10V14C20 16.8284 20 18.2426 19.1213 19.1213C18.2426 20 16.8284 20 14 20H10C7.17157 20 5.75736 20 4.87868 19.1213C4 18.2426 4 16.8284 4 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 8H5C4.44772 8 4 7.55228 4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7C20 7.55228 19.5523 8 19 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M10.1058 11.699C10.5322 11.5161 11.0826 11.7913 12.1833 12.3416C13.5069 13.0034 14.1686 13.3343 14.2509 13.8392C14.2683 13.9457 14.2683 14.0543 14.2509 14.1608C14.1686 14.6657 13.5069 14.9966 12.1833 15.6584C11.0826 16.2087 10.5322 16.4839 10.1058 16.301C10.0147 16.2619 9.92995 16.2095 9.85427 16.1455C9.5 15.8459 9.5 15.2306 9.5 14L9.5 14C9.5 12.7694 9.5 12.1541 9.85427 11.8545C9.92995 11.7905 10.0147 11.7381 10.1058 11.699Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video Player-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","media","play","tutorial","guide","demonstration","training","instructional","promo","advertisement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 4H10.9294C9.57531 3.99997 8.45868 3.99994 7.57494 4.11876C6.64711 4.2435 5.82769 4.51547 5.17158 5.17158C4.51547 5.82769 4.2435 6.64711 4.11876 7.57494C3.99994 8.45868 3.99997 9.57531 4 10.9294V13.0706C3.99997 14.4247 3.99994 15.5413 4.11876 16.4251C4.2435 17.3529 4.51547 18.1723 5.17158 18.8284C5.82769 19.4845 6.64711 19.7565 7.57494 19.8813C8.45868 20.0001 9.57535 20 10.9294 20H13.0707C14.4247 20 15.5413 20.0001 16.4251 19.8813C17.3529 19.7565 18.1723 19.4845 18.8284 18.8284C19.4845 18.1723 19.7565 17.3529 19.8813 16.4251C20.0001 15.5413 20 14.4247 20 13.0706V10.9294C20 9.57527 20.0001 8.45868 19.8813 7.57494C19.7565 6.64711 19.4845 5.82769 18.8284 5.17158C18.1723 4.51547 17.3529 4.2435 16.4251 4.11876C15.5413 3.99994 14.4247 3.99997 13.0706 4ZM7.84144 6.10092C8.57626 6.00213 10.5575 6.00001 12 6.00001C13.4425 6.00001 15.4238 6.00213 16.1586 6.10092C16.8646 6.19585 17.1916 6.36322 17.4142 6.58579C17.6368 6.80836 17.8042 7.13538 17.8991 7.84144C17.906 7.89305 17.9125 7.94588 17.9185 8L6.0815 8C6.08752 7.94588 6.09398 7.89305 6.10092 7.84144C6.19585 7.13538 6.36322 6.80836 6.58579 6.58579C6.80836 6.36322 7.13538 6.19585 7.84144 6.10092ZM14.9769 14.2874C15.0077 14.0971 15.0077 13.9029 14.9769 13.7126C14.8785 13.1041 14.4419 12.7343 14.091 12.4975C13.741 12.2613 13.1603 11.9689 12.6167 11.6951C12.1694 11.4698 11.7598 11.2634 11.4141 11.1418C11.0512 11.0141 10.5707 10.9085 10.0748 11.1228C9.9132 11.1926 9.76279 11.2862 9.62852 11.4006C9.2165 11.7516 9.09542 12.2317 9.0465 12.6157C8.9999 12.9816 8.99995 13.4962 9 14C8.99995 14.5038 8.9999 15.0184 9.0465 15.3843C9.09542 15.7683 9.2165 16.2484 9.62852 16.5994C9.76279 16.7138 9.91321 16.8074 10.0748 16.8773C10.5707 17.0915 11.0512 16.9859 11.4141 16.8582C11.7598 16.7366 12.1694 16.5302 12.6167 16.3048C13.1603 16.0311 13.741 15.7387 14.091 15.5025C14.4419 15.2657 14.8785 14.8959 14.9769 14.2874Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Video Player": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","play","tutorial","guide","demo","display","advertisement","training"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 13V11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M19 9L5 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1058 11.699C10.5322 11.5161 11.0826 11.7913 12.1833 12.3416C13.5069 13.0034 14.1686 13.3343 14.2509 13.8392C14.2683 13.9457 14.2683 14.0543 14.2509 14.1608C14.1686 14.6657 13.5069 14.9966 12.1833 15.6584C11.0826 16.2087 10.5322 16.4839 10.1058 16.301C10.0147 16.2619 9.92995 16.2095 9.85427 16.1455C9.5 15.8459 9.5 15.2306 9.5 14L9.5 14C9.5 12.7694 9.5 12.1541 9.85427 11.8545C9.92995 11.7905 10.0147 11.7381 10.1058 11.699Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-left-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","camera","arrow","upload","stream","go-live","live-stream","share","promotion","display"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H8V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-left-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","camera","arrow","up","left","upload","send","backup","stream","recording","footage","surveillance","security","transfer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H8V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video minu": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","remove","delete","cancel","video-call","decrease","reduce","minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-left": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","upload","arrow","import","media","transfer","camera","send"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 10L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 10H8V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-right-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","arrow","upload","stream","broadcast","camera","live","outgoing"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L8 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H12V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-left-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","arrow","upload","share","record","broadcast","live","stream"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 5H10.0706C11.4247 4.99997 12.5413 4.99994 13.4251 5.11876C14.3529 5.2435 15.1723 5.51547 15.8284 6.17158C16.455 6.79813 16.7312 7.57361 16.8635 8.4502C17.4021 8.18128 17.8949 7.94059 18.3133 7.80368C18.7983 7.64499 19.4389 7.53809 20.0515 7.91669C20.6641 8.29528 20.8549 8.91606 20.9299 9.42082C21.0002 9.89426 21.0001 10.5012 21 11.1654V12.8345C21.0001 13.4987 21.0002 14.1056 20.9299 14.5791C20.8549 15.0838 20.6641 15.7046 20.0515 16.0832C19.4389 16.4618 18.7983 16.3549 18.3133 16.1962C17.8949 16.0593 17.4021 15.8186 16.8635 15.5497C16.7312 16.4263 16.455 17.2019 15.8284 17.8284C15.1723 18.4845 14.3529 18.7565 13.4251 18.8813C12.5413 19.0001 11.4247 19 10.0706 19H9.92943C8.57531 19 7.4587 19.0001 6.57494 18.8813C5.64711 18.7565 4.82769 18.4845 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11876 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0706V11.9294C2.99997 10.5753 2.99994 9.45868 3.11876 8.57494C3.2435 7.64711 3.51547 6.82769 4.17158 6.17158C4.82769 5.51547 5.64711 5.2435 6.57494 5.11876C7.45868 4.99994 8.57535 4.99997 9.92943 5ZM7.29078 9.29502C7.19595 9.3904 7.12432 9.50014 7.07588 9.61722C7.02699 9.73512 7 9.86441 7 10V13C7 13.5523 7.44772 14 8 14C8.55229 14 9 13.5523 9 13V12.4142L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071C13.0976 14.3166 13.0976 13.6834 12.7071 13.2929L10.4142 11H11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9H8C7.72494 9 7.47581 9.11106 7.29502 9.29078L7.29078 9.29502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "video-arrow-up-right-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","arrow","upload","send","transmit","broadcast","record","promote"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.92943 5H10.0706C11.4247 4.99997 12.5413 4.99994 13.4251 5.11876C14.3529 5.2435 15.1723 5.51547 15.8284 6.17158C16.455 6.79813 16.7312 7.57361 16.8635 8.4502C17.4021 8.18128 17.8949 7.94059 18.3133 7.80368C18.7983 7.64499 19.4389 7.53809 20.0515 7.91669C20.6641 8.29528 20.8549 8.91606 20.9299 9.42082C21.0002 9.89426 21.0001 10.5012 21 11.1654V12.8345C21.0001 13.4987 21.0002 14.1056 20.9299 14.5791C20.8549 15.0838 20.6641 15.7046 20.0515 16.0832C19.4389 16.4618 18.7983 16.3549 18.3133 16.1962C17.8949 16.0593 17.4021 15.8186 16.8635 15.5497C16.7312 16.4263 16.455 17.2019 15.8284 17.8284C15.1723 18.4845 14.3529 18.7565 13.4251 18.8813C12.5413 19.0001 11.4247 19 10.0706 19H9.92943C8.57531 19 7.4587 19.0001 6.57494 18.8813C5.64711 18.7565 4.82769 18.4845 4.17158 17.8284C3.51547 17.1723 3.2435 16.3529 3.11876 15.4251C2.99994 14.5413 2.99997 13.4247 3 12.0706V11.9294C2.99997 10.5753 2.99994 9.45868 3.11876 8.57494C3.2435 7.64711 3.51547 6.82769 4.17158 6.17158C4.82769 5.51547 5.64711 5.2435 6.57494 5.11876C7.45868 4.99994 8.57535 4.99997 9.92943 5ZM12.7092 9.29502C12.804 9.3904 12.8757 9.50014 12.9241 9.61722C12.973 9.73512 13 9.86441 13 10V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V12.4142L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L9.58579 11H9C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9H11.9998C12.2749 9 12.5242 9.11106 12.705 9.29078L12.7092 9.29502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "video-arrow-up-right": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","arrow","export","outgoing","broadcast","stream","upload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "video-arrow-up-right-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","arrow","up","right","record","stream","live","broadcast","tutorial","demonstration","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 10L8 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 10H12V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-cross-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","camera","cross","remove-video","disable-video","cancel-video","no-video","delete-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14L10 12M10 12L12 10M10 12L8 10M10 12L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","cancel","disable","remove","cross","video-off","no-video","video-cancel","stop-recording"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0706 5H9.92943C8.57536 4.99997 7.45868 4.99994 6.57494 5.11876C5.64711 5.2435 4.82769 5.51547 4.17158 6.17158C3.51547 6.82769 3.2435 7.64711 3.11876 8.57494C2.99994 9.45868 2.99997 10.5753 3 11.9294V12.0706C2.99997 13.4247 2.99994 14.5413 3.11876 15.4251C3.2435 16.3529 3.51547 17.1723 4.17158 17.8284C4.82769 18.4845 5.64711 18.7565 6.57494 18.8813C7.4587 19.0001 8.57531 19 9.92943 19H10.0706C11.4247 19 12.5413 19.0001 13.4251 18.8813C14.3529 18.7565 15.1723 18.4845 15.8284 17.8284C16.455 17.2019 16.7312 16.4263 16.8635 15.5497C17.4021 15.8186 17.8949 16.0593 18.3133 16.1962C18.7983 16.3549 19.4389 16.4618 20.0515 16.0832C20.6641 15.7046 20.8549 15.0838 20.9299 14.5791C21.0002 14.1056 21.0001 13.4987 21 12.8345V11.1654C21.0001 10.5012 21.0002 9.89427 20.9299 9.42082C20.8549 8.91606 20.6641 8.29529 20.0515 7.91669C19.4389 7.53809 18.7983 7.64499 18.3133 7.80369C17.8949 7.9406 17.4021 8.18128 16.8635 8.4502C16.7312 7.57361 16.455 6.79813 15.8284 6.17158C15.1723 5.51547 14.3529 5.2435 13.4251 5.11876C12.5413 4.99994 11.4247 4.99997 10.0706 5ZM8.70711 9.29289C8.31658 8.90237 7.68342 8.90237 7.29289 9.29289C6.90237 9.68342 6.90237 10.3166 7.29289 10.7071L8.58579 12L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L10 13.4142L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071C13.0976 14.3166 13.0976 13.6834 12.7071 13.2929L11.4142 12L12.7071 10.7071C13.0976 10.3166 13.0976 9.68342 12.7071 9.29289C12.3166 8.90237 11.6834 8.90237 11.2929 9.29289L10 10.5858L8.70711 9.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Video-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","disable","mute","block","camera","video-off","camera-off","cancel","remove","deactivate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14L10 12M10 12L12 10M10 12L8 10M10 12L12 14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-front-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","camera","call","customer-service","support","video-call","remote-assistance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="10"
                    cy="11"
                    r="2"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M6 18L6.0883 17.7351C6.52832 16.4151 6.74832 15.755 7.2721 15.3775C7.79587 15 8.49159 15 9.88304 15H10.117C11.5084 15 12.2041 15 12.7279 15.3775C13.2517 15.755 13.4717 16.4151 13.9117 17.7351L14 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Video-front-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","call","customer","support","camera","live-feed","security","surveillance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0706 5H9.92944C8.57538 4.99997 7.45867 4.99994 6.57494 5.11876C5.64711 5.2435 4.82769 5.51547 4.17158 6.17158C3.51547 6.82769 3.2435 7.64711 3.11876 8.57494C2.99994 9.45867 2.99997 10.5753 3 11.9294V12.0706C2.99997 13.4247 2.99994 14.5413 3.11876 15.4251C3.2435 16.3529 3.51547 17.1723 4.17158 17.8284C4.3823 18.0392 4.60987 18.2103 4.85247 18.3496L5.31266 17.1991C5.54365 16.6216 5.73925 16.1325 5.94401 15.7485C6.16182 15.3401 6.42119 14.9877 6.81241 14.7228C7.20362 14.458 7.62712 14.348 8.08727 14.2975C8.51984 14.25 9.04653 14.25 9.66853 14.25H10.3316C10.9536 14.25 11.4803 14.25 11.9129 14.2975C12.373 14.348 12.7965 14.458 13.1877 14.7228C13.5789 14.9877 13.8383 15.3401 14.0561 15.7485C14.2609 16.1325 14.4565 16.6216 14.6875 17.1991L15.1477 18.3495C15.3902 18.2102 15.6177 18.0391 15.8284 17.8284C16.455 17.2019 16.7312 16.4264 16.8635 15.5497C17.4021 15.8186 17.8949 16.0593 18.3133 16.1962C18.7983 16.3549 19.4389 16.4618 20.0514 16.0832C20.664 15.7046 20.8549 15.0838 20.9299 14.5791C21.0002 14.1056 21.0001 13.4987 21 12.8345V11.1654C21.0001 10.5012 21.0002 9.89427 20.9299 9.42082C20.8549 8.91606 20.664 8.29529 20.0514 7.91669C19.4389 7.53809 18.7983 7.64499 18.3133 7.80369C17.8949 7.94059 17.4021 8.18127 16.8635 8.45019C16.7312 7.5736 16.455 6.79812 15.8284 6.17158C15.1723 5.51547 14.3529 5.2435 13.4251 5.11876C12.5413 4.99995 11.4246 4.99997 10.0706 5ZM10 8C8.61929 8 7.5 9.11929 7.5 10.5C7.5 11.8807 8.61929 13 10 13C11.3807 13 12.5 11.8807 12.5 10.5C12.5 9.11929 11.3807 8 10 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.7261 18.8346L13.3095 17.793C13.0598 17.1688 12.894 16.7571 12.7326 16.4543C12.5798 16.1679 12.4635 16.0439 12.3468 15.9649C12.2301 15.8859 12.0717 15.8239 11.7491 15.7885C11.4081 15.751 10.9642 15.75 10.2919 15.75H9.7082C9.03589 15.75 8.59207 15.751 8.25102 15.7885C7.92839 15.8239 7.77004 15.8859 7.65335 15.9649C7.53666 16.0439 7.4203 16.1679 7.26758 16.4543C7.10614 16.7571 6.94034 17.1688 6.69065 17.793L6.27399 18.8346C6.37296 18.8522 6.4733 18.8676 6.57494 18.8813C7.4587 19.0001 8.57531 19 9.92943 19H10.0706C11.4247 19 12.5413 19.0001 13.4251 18.8813C13.5268 18.8676 13.6271 18.8521 13.7261 18.8346Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Video-front-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["video","customer","profile","camera","surveillance","security","monitoring","face","record","video-call","staff","employee"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18L6.0883 17.7351C6.52832 16.4151 6.74832 15.755 7.2721 15.3775C7.79587 15 8.49159 15 9.88304 15H10.117C11.5084 15 12.2041 15 12.7279 15.3775C13.2517 15.755 13.4717 16.4151 13.9117 17.7351L14 18"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="11" r="2" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Video-plus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["video","add","plus","stream","record","new-video","add-video","video-add"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-plus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["video","add","plus","create-video","new-video","camera","record","add-recording"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 12V11.2361C20 9.78569 20 9.0605 19.5257 8.76738C19.0515 8.47427 18.4028 8.79858 17.1056 9.44721C16.5677 9.71617 16.2987 9.85065 16.1493 10.0923C16 10.334 16 10.6347 16 11.2361V12.7639C16 13.3653 16 13.666 16.1493 13.9077C16.2987 14.1493 16.5677 14.2838 17.1056 14.5528C18.4028 15.2014 19.0515 15.5257 19.5257 15.2326C20 14.9395 20 14.2143 20 12.7639V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-front": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","record","surveillance","security","stream","live","live-stream","person","user","profile","avatar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="11" r="2" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M6 18L6.0883 17.7351C6.52832 16.4151 6.74832 15.755 7.2721 15.3775C7.79587 15 8.49159 15 9.88304 15H10.117C11.5084 15 12.2041 15 12.7279 15.3775C13.2517 15.755 13.4717 16.4151 13.9117 17.7351L14 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Video-plus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","add","plus","new-video","record","add-video","create-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0706 5H9.92943C8.57536 4.99997 7.45868 4.99994 6.57494 5.11876C5.64711 5.2435 4.82769 5.51547 4.17158 6.17158C3.51547 6.82769 3.2435 7.64711 3.11876 8.57494C2.99994 9.45868 2.99997 10.5753 3 11.9294V12.0706C2.99997 13.4247 2.99994 14.5413 3.11876 15.4251C3.2435 16.3529 3.51547 17.1723 4.17158 17.8284C4.82769 18.4845 5.64711 18.7565 6.57494 18.8813C7.4587 19.0001 8.57531 19 9.92943 19H10.0706C11.4247 19 12.5413 19.0001 13.4251 18.8813C14.3529 18.7565 15.1723 18.4845 15.8284 17.8284C16.455 17.2019 16.7312 16.4263 16.8635 15.5497C17.4021 15.8186 17.8949 16.0593 18.3133 16.1962C18.7983 16.3549 19.4389 16.4618 20.0515 16.0832C20.6641 15.7046 20.8549 15.0838 20.9299 14.5791C21.0002 14.1056 21.0001 13.4987 21 12.8345V11.1654C21.0001 10.5012 21.0002 9.89427 20.9299 9.42082C20.8549 8.91606 20.6641 8.29529 20.0515 7.91669C19.4389 7.53809 18.7983 7.64499 18.3133 7.80369C17.8949 7.9406 17.4021 8.18128 16.8635 8.4502C16.7312 7.57361 16.455 6.79813 15.8284 6.17158C15.1723 5.51547 14.3529 5.2435 13.4251 5.11876C12.5413 4.99994 11.4247 4.99997 10.0706 5ZM11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H9V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H11V10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Video-plus": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","add-video","record","plus","add","create-video","new-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 12H12M10 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Video-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["video","camera","cancel","off","deactivate","remove-video","stop-video"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1213 6.87868C16 7.75736 16 9.17157 16 12C16 14.8284 16 16.2426 15.1213 17.1213C14.2426 18 12.8284 18 10 18C7.17157 18 5.75736 18 4.87868 17.1213C4 16.2426 4 14.8284 4 12C4 9.17157 4 7.75736 4.87868 6.87868C5.75736 6 7.17157 6 10 6C12.8284 6 14.2426 6 15.1213 6.87868Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M8 14L10 12M10 12L12 10M10 12L8 10M10 12L12 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 10L17.1056 9.44721C18.4028 8.79858 19.0515 8.47427 19.5257 8.76738C20 9.0605 20 9.78569 20 11.2361V12V12.7639C20 14.2143 20 14.9395 19.5257 15.2326C19.0515 15.5257 18.4028 15.2014 17.1056 14.5528L16 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "VII-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["VII","seven","quantity","item-count","order-quantity","table-number"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L16 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17L20 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L21 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 17L21 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7L8 17L4 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 7L5 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "VII-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["vii","number","roman-number","quantity","amount","table-number","order-number","version"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17L20 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L21 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 17L21 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7L8 17L4 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 7L5 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "VII-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["vii","roman-numerals","number-7","table","section","identifier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0223 6.00024L13 6.00024C13.5523 6.00024 14 6.44796 14 7.00024C14 7.55253 13.5523 8.00024 13 8.00024H12.677L8.92848 17.3717C8.77662 17.7513 8.40891 18.0003 8.00001 18.0003C7.5911 18.0003 7.22339 17.7513 7.07153 17.3717L3.32297 8.00024H3C2.44772 8.00024 2 7.55253 2 7.00024C2 6.44796 2.44772 6.00024 3 6.00024L3.97766 6.00024C3.99238 5.99992 4.00708 5.99992 4.02174 6.00024L5 6.00024C5.55228 6.00024 6 6.44796 6 7.00024C6 7.39586 5.77027 7.73782 5.43693 7.89999L8.00001 14.3077L10.5631 7.9C10.2297 7.73783 10 7.39587 10 7.00024C10 6.44796 10.4477 6.00024 11 6.00024L11.9783 6.00024C11.9929 5.99992 12.0076 5.99992 12.0223 6.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 7.00024C18 6.44796 17.5523 6.00024 17 6.00024L15 6.00024C14.4477 6.00024 14 6.44796 14 7.00024C14 7.55253 14.4477 8.00024 15 8.00024V16.0002C14.4477 16.0002 14 16.448 14 17.0002C14 17.5525 14.4477 18.0002 15 18.0002H17C17.5523 18.0002 18 17.5525 18 17.0002C18 17.5525 18.4477 18.0002 19 18.0002H21C21.5523 18.0002 22 17.5525 22 17.0002C22 16.448 21.5523 16.0002 21 16.0002V8.00024C21.5523 8.00024 22 7.55253 22 7.00024C22 6.44796 21.5523 6.00024 21 6.00024L19 6.00024C18.4477 6.00024 18 6.44796 18 7.00024ZM18 7.00024C18 7.55253 18.4477 8.00024 19 8.00024V16.0002C18.4477 16.0002 18 16.448 18 17.0002C18 16.448 17.5523 16.0002 17 16.0002V8.00024C17.5523 8.00024 18 7.55253 18 7.00024Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "VIII-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["8","eight","VIII","quantity","number","amount","discount","group","bundle"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17L13 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 17L21 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 7L14 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 7L18 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L22 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L18 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 17L22 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7L6 17L3 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2 7L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "VIII-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["VIII","eight","number","quantity","discount","level","vip-level","tier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17L13 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L17 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 17L21 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 7L14 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 7L18 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L22 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L14 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L18 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 17L22 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7L6 17L3 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2 7L4 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "VIII-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["viii","8","number","quantity","amount","numeric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.02164 5.99976L10 5.99976C10.5523 5.99976 11 6.44747 11 6.99976C11 7.55204 10.5523 7.99976 10 7.99976H9.74405L6.95784 17.2871C6.83094 17.7101 6.44162 17.9998 6.00001 17.9998C5.5584 17.9998 5.16908 17.7101 5.04218 17.2871L2.25598 7.99976H2C1.44772 7.99976 1 7.55204 1 6.99976C1 6.44747 1.44772 5.99976 2 5.99976L2.97838 5.99976C2.9931 5.99943 3.00778 5.99943 3.02242 5.99976L4 5.99976C4.55228 5.99976 5 6.44747 5 6.99976C5 7.43731 4.71898 7.80923 4.32757 7.94487L6.00001 13.5197L7.67245 7.94488C7.28103 7.80925 7 7.43732 7 6.99976C7 6.44747 7.44772 5.99976 8 5.99976L8.97761 5.99976C8.99225 5.99943 9.00692 5.99943 9.02164 5.99976ZM15 6.99976C15 6.44747 14.5523 5.99976 14 5.99976L13.0002 5.99976L13 5.99976L12 5.99976C11.4477 5.99976 11 6.44747 11 6.99976C11 7.55204 11.4477 7.99976 12 7.99976V15.9998C11.4477 15.9998 11 16.4475 11 16.9998C11 17.552 11.4477 17.9998 12 17.9998H13H14C14.5523 17.9998 15 17.552 15 16.9998C15 17.552 15.4477 17.9998 16 17.9998H17H18C18.5523 17.9998 19 17.552 19 16.9998C19 17.552 19.4477 17.9998 20 17.9998H21H22C22.5523 17.9998 23 17.552 23 16.9998C23 16.4475 22.5523 15.9998 22 15.9998V7.99976C22.5523 7.99976 23 7.55204 23 6.99976C23 6.44747 22.5523 5.99976 22 5.99976H21L20.9998 5.99976L20 5.99976C19.4477 5.99976 19 6.44747 19 6.99976C19 6.44747 18.5523 5.99976 18 5.99976H17L16.9998 5.99976L16 5.99976C15.4477 5.99976 15 6.44747 15 6.99976ZM19 6.99976C19 7.55204 19.4477 7.99976 20 7.99976V15.9998C19.4477 15.9998 19 16.4475 19 16.9998C19 16.4475 18.5523 15.9998 18 15.9998V7.99976C18.5523 7.99976 19 7.55204 19 6.99976ZM15 6.99976C15 7.55204 15.4477 7.99976 16 7.99976V15.9998C15.4477 15.9998 15 16.4475 15 16.9998C15 16.4475 14.5523 15.9998 14 15.9998V7.99976C14.5523 7.99976 15 7.55204 15 6.99976Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vip-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["VIP","loyalty","membership","premium","customer","rewards","exclusive","tier","status","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 6L12 7" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 9L7 15L9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9V8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9L15 9ZM14.25 15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15H14.25ZM15 9.75H17V8.25H15V9.75ZM17 12.25H15V13.75H17V12.25ZM15.75 13V9L14.25 9V13H15.75ZM14.25 13V15H15.75V13H14.25ZM17 9.75C17.6904 9.75 18.25 10.3096 18.25 11H19.75C19.75 9.48122 18.5188 8.25 17 8.25V9.75ZM17 13.75C18.5188 13.75 19.75 12.5188 19.75 11H18.25C18.25 11.6904 17.6904 12.25 17 12.25V13.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    VIII: {
        defaultColors: ["#3D4C66"],
        keywords: ["VIP","loyalty","membership","premium","customer","rewards","exclusive","tier","status","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17L13 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 17L17 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 17L21 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 7L14 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 7L18 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 7L22 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 17L14 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 17L18 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M20 17L22 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M9 7L6 17L3 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2 7L4 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M8 7L10 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vip-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["vip","loyalty","membership","premium","exclusive","rewards","customer","benefits"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 15" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 6L12 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 9L7 15L9 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9V8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9L15 9ZM14.25 15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15H14.25ZM15 9.75H17V8.25H15V9.75ZM17 12.25H15V13.75H17V12.25ZM15.75 13V9L14.25 9V13H15.75ZM14.25 13V15H15.75V13H14.25ZM17 9.75C17.6904 9.75 18.25 10.3096 18.25 11H19.75C19.75 9.48122 18.5188 8.25 17 8.25V9.75ZM17 13.75C18.5188 13.75 19.75 12.5188 19.75 11H18.25C18.25 11.6904 17.6904 12.25 17 12.25V13.75Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
            </svg>
        )
    },
    "vip-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["vip","loyalty","member","premium","customer","rewards","privilege"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0003 6C12.5526 6 13.0003 6.44772 13.0003 7V8C13.0003 8.55228 12.5526 9 12.0003 9C11.448 9 11.0003 8.55228 11.0003 8V7C11.0003 6.44772 11.448 6 12.0003 6ZM4.68404 10.0513C5.20799 9.87667 5.77431 10.1598 5.94895 10.6838L7.00027 13.8377L8.05159 10.6838C8.22624 10.1598 8.79256 9.87667 9.3165 10.0513C9.84044 10.226 10.1236 10.7923 9.94895 11.3162L7.94896 17.3162C7.81284 17.7246 7.4307 18 7.00027 18C6.56984 18 6.1877 17.7246 6.05159 17.3162L4.05159 11.3162C3.87694 10.7923 4.1601 10.226 4.68404 10.0513ZM12.0003 10C12.5526 10 13.0003 10.4477 13.0003 11V17C13.0003 17.5523 12.5526 18 12.0003 18C11.448 18 11.0003 17.5523 11.0003 17L11.0003 11C11.0003 10.4477 11.448 10 12.0003 10ZM14.0003 11C14.0003 10.4477 14.448 10 15.0003 10H17.0003C18.6571 10 20.0003 11.3431 20.0003 13C20.0003 14.6569 18.6571 16 17.0003 16H16.0003V17C16.0003 17.5523 15.5526 18 15.0003 18C14.448 18 14.0003 17.5523 14.0003 17V11ZM16.0003 14H17.0003C17.5526 14 18.0003 13.5523 18.0003 13C18.0003 12.4477 17.5526 12 17.0003 12H16.0003V14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vip-box-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["VIP","customer","loyalty","membership","reward","privilege","premium","special","promotion","discount","tier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9L8 15L10 9"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9V8.25C13.8011 8.25 13.6103 8.32902 13.4697 8.46967C13.329 8.61032 13.25 8.80109 13.25 9L14 9ZM13.25 15C13.25 15.4142 13.5858 15.75 14 15.75C14.4142 15.75 14.75 15.4142 14.75 15H13.25ZM14 9.75H16V8.25H14V9.75ZM16 12.25H14V13.75H16V12.25ZM14.75 13V9L13.25 9V13H14.75ZM13.25 13V15H14.75V13H13.25ZM16 9.75C16.6904 9.75 17.25 10.3096 17.25 11H18.75C18.75 9.48122 17.5188 8.25 16 8.25V9.75ZM16 13.75C17.5188 13.75 18.75 12.5188 18.75 11H17.25C17.25 11.6904 16.6904 12.25 16 12.25V13.75Z"
                    fill={colors?.[0] || "#2797E8"}
                />
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    VII: {
        defaultColors: ["#3D4C66"],
        keywords: ["VIP","customer","loyalty","membership","reward","privilege","premium","special","promotion","discount","tier"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 17L16 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17L20 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 7L21 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19 17L21 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M12 7L8 17L4 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3 7L5 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 7L13 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "vip-box-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["vip","customer","loyalty","membership","premium","exclusive","rewards","privilege","tier","account","sales","promotion","discount","offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.25 11C17.25 10.31 16.69 9.75 16 9.75H14.75V12.25H16C16.69 12.25 17.25 11.69 17.25 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21.8987 7.57C21.7785 6.64 21.4983 5.82 20.8477 5.17C20.187 4.51 19.3663 4.24 18.4454 4.12C17.5546 4 16.4335 4 15.0823 4H8.9365C7.58524 4 6.46419 4 5.57335 4.12C4.64248 4.24 3.82171 4.52 3.1711 5.17C2.52049 5.83 2.24023 6.65 2.12011 7.57C2 8.46 2 9.58 2 10.93V13.07C2 14.42 2 15.54 2.12011 16.42C2.24023 17.35 2.52049 18.17 3.1711 18.82C3.82171 19.47 4.65249 19.75 5.57335 19.87C6.45418 19.99 7.57523 19.99 8.92649 19.99H15.0723C16.4235 19.99 17.5446 19.99 18.4254 19.87C19.3563 19.75 20.177 19.47 20.8277 18.82C21.4783 18.17 21.7585 17.34 21.8786 16.42C21.9988 15.54 21.9987 14.42 21.9987 13.07V10.93C21.9987 9.58 22.0188 8.45 21.8987 7.57ZM12.7601 9V15C12.7601 15.41 12.4198 15.75 12.0094 15.75C11.599 15.75 11.2587 15.41 11.2587 15V9C11.2587 8.59 11.599 8.25 12.0094 8.25C12.4198 8.25 12.7601 8.59 12.7601 9ZM5.76353 8.29C6.15389 8.16 6.5843 8.37 6.71442 8.76L8.00563 12.63L9.29684 8.76C9.42696 8.37 9.85737 8.15 10.2477 8.29C10.6381 8.43 10.8583 8.85 10.7182 9.24L8.7163 15.24C8.6162 15.55 8.32593 15.75 8.00563 15.75C7.68533 15.75 7.39506 15.54 7.29496 15.24L5.29309 9.24C5.16297 8.85 5.37316 8.42 5.76353 8.29ZM13.2606 9C13.2606 8.59 13.6009 8.25 14.0113 8.25H16.0131C17.5346 8.25 18.7657 9.48 18.7657 11C18.7657 12.52 17.5346 13.75 16.0131 13.75H14.762V15C14.762 15.41 14.4216 15.75 14.0113 15.75C13.6009 15.75 13.2606 15.41 13.2606 15V9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vip-box-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["vip","loyalty","membership","premium","exclusive","rewards","customer","tier","privilege","benefits","pos","account","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9L12 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9L8 15L10 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9V8.25C13.8011 8.25 13.6103 8.32902 13.4697 8.46967C13.329 8.61032 13.25 8.80109 13.25 9L14 9ZM13.25 15C13.25 15.4142 13.5858 15.75 14 15.75C14.4142 15.75 14.75 15.4142 14.75 15H13.25ZM14 9.75H16V8.25H14V9.75ZM16 12.25H14V13.75H16V12.25ZM14.75 13V9L13.25 9V13H14.75ZM13.25 13V15H14.75V13H13.25ZM16 9.75C16.6904 9.75 17.25 10.3096 17.25 11H18.75C18.75 9.48122 17.5188 8.25 16 8.25V9.75ZM16 13.75C17.5188 13.75 18.75 12.5188 18.75 11H17.25C17.25 11.6904 16.6904 12.25 16 12.25V13.75Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    vip: {
        defaultColors: ["#3D4C66"],
        keywords: ["vip","loyalty","membership","premium","exclusive","rewards","customer","tier","privilege","benefits","pos","account","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12 6L12 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 9L7 15L9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 9V8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9L15 9ZM14.25 15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15H14.25ZM15 9.75H17V8.25H15V9.75ZM17 12.25H15V13.75H17V12.25ZM15.75 13V9L14.25 9V13H15.75ZM14.25 13V15H15.75V13H14.25ZM17 9.75C17.6904 9.75 18.25 10.3096 18.25 11H19.75C19.75 9.48122 18.5188 8.25 17 8.25V9.75ZM17 13.75C18.5188 13.75 19.75 12.5188 19.75 11H18.25C18.25 11.6904 17.6904 12.25 17 12.25V13.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "vip-box": {
        defaultColors: ["#3D4C66"],
        keywords: ["VIP","premium","exclusive","membership","rewards","loyalty","customer","special","promotion","privilege","tier","status"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9L12 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6 9L8 15L10 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 9V8.25C13.8011 8.25 13.6103 8.32902 13.4697 8.46967C13.329 8.61032 13.25 8.80109 13.25 9L14 9ZM13.25 15C13.25 15.4142 13.5858 15.75 14 15.75C14.4142 15.75 14.75 15.4142 14.75 15H13.25ZM14 9.75H16V8.25H14V9.75ZM16 12.25H14V13.75H16V12.25ZM14.75 13V9L13.25 9V13H14.75ZM13.25 13V15H14.75V13H13.25ZM16 9.75C16.6904 9.75 17.25 10.3096 17.25 11H18.75C18.75 9.48122 17.5188 8.25 16 8.25V9.75ZM16 13.75C17.5188 13.75 18.75 12.5188 18.75 11H17.25C17.25 11.6904 16.6904 12.25 16 12.25V13.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3 6.75736 3 8.17157 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 8.17157 21 6.75736 20.1213 5.87868C19.2426 5 17.8284 5 15 5Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "virus-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["virus","covid","health","alert","warning","hazard","infection","sick","bacteria"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7V4M7 12H4M17 12H20M12 17V20M8.00005 8.00005L6.34315 6.34315M8.00005 15.9999L6.34315 17.6569M16 7.99999L17.6569 6.34315M16.0001 16.0001L17.6569 17.6569"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 11V13M11 20H13M20 13V11M13 4H11M5.63604 16.9497L7.05025 18.364M16.9497 18.364L18.364 16.9497M18.364 7.05025L16.9497 5.63604M7.05025 5.63604L5.63604 7.05025"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 10.6739 7.52678 9.40215 8.46446 8.46447C9.40215 7.52678 10.6739 7 12 7Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "virus-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["virus","hazard","warning","alert","issue","problem","error","security","threat","contamination","risk","malware","infection","protection","defense"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 10.6739 7.52678 9.40215 8.46446 8.46447C9.40215 7.52678 10.6739 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7V4M7 12H4M17 12H20M12 17V20M8.00005 8.00005L6.34315 6.34315M8.00005 15.9999L6.34315 17.6569M16 7.99999L17.6569 6.34315M16.0001 16.0001L17.6569 17.6569"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 11V13M11 20H13M20 13V11M13 4H11M5.63604 16.9497L7.05025 18.364M16.9497 18.364L18.364 16.9497M18.364 7.05025L16.9497 5.63604M7.05025 5.63604L5.63604 7.05025"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    virus: {
        defaultColors: ["#3D4C66"],
        keywords: ["virus","hazard","warning","alert","issue","problem","error","security","threat","contamination","risk","malware","infection","protection","defense"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 10.6739 7.52678 9.40215 8.46446 8.46447C9.40215 7.52678 10.6739 7 12 7Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 7V4M7 12H4M17 12H20M12 17V20M8.00005 8.00005L6.34315 6.34315M8.00005 15.9999L6.34315 17.6569M16 7.99999L17.6569 6.34315M16.0001 16.0001L17.6569 17.6569"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 11V13M11 20H13M20 13V11M13 4H11M5.63604 16.9497L7.05025 18.364M16.9497 18.364L18.364 16.9497M18.364 7.05025L16.9497 5.63604M7.05025 5.63604L5.63604 7.05025"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "virus-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["virus","warning","hazard","health","alert","covid","outbreak","sick","hygiene"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 5C10.4477 5 10 4.55228 10 4C10 3.44772 10.4477 3 11 3H13C13.5523 3 14 3.44772 14 4C14 4.55228 13.5523 5 13 5V6.08296C13.9117 6.23591 14.7536 6.59444 15.4765 7.10925L16.2426 6.34315C15.8521 5.95262 15.8521 5.31946 16.2426 4.92893C16.6332 4.53841 17.2663 4.53841 17.6569 4.92893L19.0711 6.34315C19.4616 6.73367 19.4616 7.36684 19.0711 7.75736C18.6805 8.14788 18.0474 8.14788 17.6569 7.75736L16.8907 8.52347C17.4056 9.2464 17.7641 10.0883 17.917 11H19C19 10.4477 19.4477 10 20 10C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13H17.917C17.7641 13.9117 17.4056 14.7536 16.8907 15.4765L17.6569 16.2426C18.0474 15.8521 18.6805 15.8521 19.0711 16.2426C19.4616 16.6332 19.4616 17.2663 19.0711 17.6569L17.6569 19.0711C17.2663 19.4616 16.6332 19.4616 16.2426 19.0711C15.8521 18.6805 15.8521 18.0474 16.2426 17.6569L15.4765 16.8907C14.7536 17.4056 13.9117 17.7641 13 17.917V19C13.5523 19 14 19.4477 14 20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20C10 19.4477 10.4477 19 11 19V17.917C10.0883 17.7641 9.2464 17.4056 8.52347 16.8907L7.75736 17.6569C8.14788 18.0474 8.14788 18.6805 7.75736 19.0711C7.36684 19.4616 6.73367 19.4616 6.34315 19.0711L4.92893 17.6569C4.53841 17.2663 4.53841 16.6332 4.92893 16.2426C5.31946 15.8521 5.95262 15.8521 6.34315 16.2426L7.10925 15.4765C6.59444 14.7536 6.23591 13.9117 6.08296 13H5C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11C3 10.4477 3.44772 10 4 10C4.55228 10 5 10.4477 5 11H6.08389C6.23468 10.108 6.58543 9.26117 7.10957 8.52379L6.34315 7.75736C5.95262 8.14788 5.31946 8.14788 4.92893 7.75736C4.53841 7.36684 4.53841 6.73367 4.92893 6.34315L6.34315 4.92893C6.73367 4.53841 7.36684 4.53841 7.75736 4.92893C8.14788 5.31946 8.14788 5.95262 7.75736 6.34315L8.52379 7.10957C9.26117 6.58543 10.108 6.23468 11 6.08389V5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "voice-recognition-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["voice","audio","sound","microphone","speech","voice-command","scan","voice-scan","audio-scan","sound-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "voice-recognition-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["voice","recognition","sound","audio","microphone","input","speak","voice-command","voice-input"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L16 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 8"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14L8 10"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "voicemail-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["voicemail","message","recording","audio","customer-message","order-note","notification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 15L17 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.45" />
                <circle cx="17" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
                <circle cx="7" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "voice-recognition-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["voice recognition","audio","microphone","sound","speak","input","voice command","recording","voice search","voice assistant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 9C16.5523 9 17 9.44772 17 10L17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14L15 10C15 9.44772 15.4477 9 16 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V8C11 7.44772 11.4477 7 12 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9C8.55229 9 9 9.44772 9 10L9 14C9 14.5523 8.55229 15 8 15C7.44772 15 7 14.5523 7 14L7 10C7 9.44772 7.44772 9 8 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.81246 3L10 3C10.5523 3 11 3.44772 11 4C11 4.55229 10.5523 5 10 5H9.88C8.49702 5 7.55633 5.00196 6.84914 5.09339C6.16842 5.18139 5.84917 5.3371 5.63091 5.54207C5.60037 5.57074 5.57074 5.60037 5.54207 5.63091C5.3371 5.84917 5.18139 6.16842 5.09339 6.84914C5.00196 7.55633 5 8.49702 5 9.88V10C5 10.5523 4.55229 11 4 11C3.44772 11 3 10.5523 3 10L3 9.81246C2.99997 8.51404 2.99994 7.44323 3.10989 6.59272C3.22516 5.70105 3.476 4.9094 4.08413 4.26181C4.14148 4.20074 4.20074 4.14148 4.26181 4.08413C4.90941 3.476 5.70105 3.22516 6.59272 3.10989C7.44323 2.99994 8.51404 2.99997 9.81246 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1875 3L14 3C13.4477 3 13 3.44772 13 4C13 4.55229 13.4477 5 14 5H14.12C15.503 5 16.4437 5.00196 17.1509 5.09339C17.8316 5.18139 18.1508 5.3371 18.3691 5.54207C18.3996 5.57074 18.4293 5.60037 18.4579 5.63091C18.6629 5.84917 18.8186 6.16842 18.9066 6.84914C18.998 7.55633 19 8.49702 19 9.88V10C19 10.5523 19.4477 11 20 11C20.5523 11 21 10.5523 21 10L21 9.81246C21 8.51404 21.0001 7.44323 20.8901 6.59272C20.7748 5.70105 20.524 4.9094 19.9159 4.26181C19.8585 4.20074 19.7993 4.14148 19.7382 4.08413C19.0906 3.476 18.299 3.22516 17.4073 3.10989C16.5568 2.99994 15.486 2.99997 14.1875 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1875 21L14 21C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19H14.12C15.503 19 16.4437 18.998 17.1509 18.9066C17.8316 18.8186 18.1508 18.6629 18.3691 18.4579C18.3996 18.4293 18.4293 18.3996 18.4579 18.3691C18.6629 18.1508 18.8186 17.8316 18.9066 17.1509C18.998 16.4437 19 15.503 19 14.12V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14L21 14.1875C21 15.486 21.0001 16.5568 20.8901 17.4073C20.7748 18.299 20.524 19.0906 19.9159 19.7382C19.8585 19.7993 19.7993 19.8585 19.7382 19.9159C19.0906 20.524 18.299 20.7748 17.4073 20.8901C16.5568 21.0001 15.486 21 14.1875 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.81246 21H10C10.5523 21 11 20.5523 11 20C11 19.4477 10.5523 19 10 19H9.88C8.49702 19 7.55633 18.998 6.84914 18.9066C6.16842 18.8186 5.84917 18.6629 5.63091 18.4579C5.60037 18.4293 5.57074 18.3996 5.54207 18.3691C5.3371 18.1508 5.18139 17.8316 5.09339 17.1509C5.00196 16.4437 5 15.503 5 14.12V14C5 13.4477 4.55229 13 4 13C3.44772 13 3 13.4477 3 14L3 14.1875C2.99997 15.486 2.99994 16.5568 3.10989 17.4073C3.22516 18.299 3.476 19.0906 4.08413 19.7382C4.14148 19.7993 4.20074 19.8585 4.26181 19.9159C4.90941 20.524 5.70105 20.7748 6.59272 20.8901C7.44323 21.0001 8.51404 21 9.81246 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "voicemail-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["voicemail","recording","message","audio","record","playback","saved-message","notes"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 15L17 15" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.45" />
                <circle
                    cx="17"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <circle
                    cx="7"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "voice-recognition": {
        defaultColors: ["#3D4C66"],
        keywords: ["voice","voice-recognition","mic","microphone","input","audio","speak","dictate","voice-command","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 14L16 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 16L12 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 14L8 10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 4H9.88C7.16814 4 5.81222 4 4.94636 4.81309C4.90055 4.85611 4.85611 4.90055 4.81309 4.94636C4 5.81222 4 7.16814 4 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 4H14.12C16.8319 4 18.1878 4 19.0536 4.81309C19.0994 4.85611 19.1439 4.90055 19.1869 4.94636C20 5.81222 20 7.16814 20 9.88V10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 20L14.12 20C16.8319 20 18.1878 20 19.0536 19.1869C19.0994 19.1439 19.1439 19.0994 19.1869 19.0536C20 18.1878 20 16.8319 20 14.12L20 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 20L9.88 20C7.16814 20 5.81222 20 4.94636 19.1869C4.90055 19.1439 4.85611 19.0994 4.81309 19.0536C4 18.1878 4 16.8319 4 14.12L4 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    voicemail: {
        defaultColors: ["#3D4C66"],
        keywords: ["voice","voice-recognition","mic","microphone","input","audio","speak","dictate","voice-command","sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 15L17 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.45" />
                <circle cx="17" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <circle cx="7" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "voicemail-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["voicemail","audio","message","communication","recording","reminder","note"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.5 10C5.39543 10 4.5 10.8954 4.5 12C4.5 13.1046 5.39543 14 6.5 14C7.60457 14 8.5 13.1046 8.5 12C8.5 10.8954 7.60457 10 6.5 10ZM9.96487 14C10.3052 13.4117 10.5 12.7286 10.5 12C10.5 9.79086 8.70914 8 6.5 8C4.29086 8 2.5 9.79086 2.5 12C2.5 14.0398 4.02684 15.754 6 16H17.5C19.7091 16 21.5 14.2091 21.5 12C21.5 9.79086 19.7091 8 17.5 8C15.2909 8 13.5 9.79086 13.5 12C13.5 12.7286 13.6948 13.4117 14.0351 14H9.96487ZM17.5 14C18.6046 14 19.5 13.1046 19.5 12C19.5 10.8954 18.6046 10 17.5 10C16.3954 10 15.5 10.8954 15.5 12C15.5 13.1046 16.3954 14 17.5 14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volcano-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["volcano","hot","alert","warning","issue","danger","hazard","special-offer"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.83479 11.942L6.63479 13.942C5.02328 16.6279 4.21752 17.9708 4.79198 18.9854C5.36644 20 6.93255 20 10.0648 20H12H13.9352C17.0675 20 18.6336 20 19.208 18.9854C19.7825 17.9708 18.9767 16.6279 17.3652 13.942L16.1652 11.942C15.5961 10.9935 15.3115 10.5192 14.853 10.2596C14.3945 10 13.8414 10 12.7352 10H11.2648C10.1586 10 9.60549 10 9.14698 10.2596C8.68848 10.5192 8.40392 10.9935 7.83479 11.942Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14L8.06551 14.9377C8.77051 15.558 9.8122 15.6044 10.5695 15.049L10.8173 14.8673C11.5213 14.3511 12.4787 14.3511 13.1827 14.8673L13.4305 15.049C14.1878 15.6044 15.2295 15.558 15.9345 14.9377L17 14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0007 5L12.0007 7M15 7C15 6.5 15.2 5.4 16 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7C9 6.5 8.8 5.4 8 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volcano-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["volcano","warning","alert","danger","hot","temperature","limit","critical","fire","unstable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 14L8.06551 14.9377C8.77051 15.558 9.8122 15.6044 10.5695 15.049L10.8173 14.8673C11.5213 14.3511 12.4787 14.3511 13.1827 14.8673L13.4305 15.049C14.1878 15.6044 15.2295 15.558 15.9345 14.9377L17 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.83479 11.942L6.63479 13.942C5.02328 16.6279 4.21752 17.9708 4.79198 18.9854C5.36644 20 6.93255 20 10.0648 20H12H13.9352C17.0675 20 18.6336 20 19.208 18.9854C19.7825 17.9708 18.9767 16.6279 17.3652 13.942L16.1652 11.942C15.5961 10.9935 15.3115 10.5192 14.853 10.2596C14.3945 10 13.8414 10 12.7352 10H11.2648C10.1586 10 9.60549 10 9.14698 10.2596C8.68848 10.5192 8.40392 10.9935 7.83479 11.942Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0007 5L12.0007 7M15 7C15 6.5 15.2 5.4 16 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7C9 6.5 8.8 5.4 8 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    volcano: {
        defaultColors: ["#3D4C66"],
        keywords: ["volcano","warning","alert","danger","hot","temperature","limit","critical","fire","unstable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.83479 11.942L6.63479 13.942C5.02328 16.6279 4.21752 17.9708 4.79198 18.9854C5.36644 20 6.93255 20 10.0648 20H12H13.9352C17.0675 20 18.6336 20 19.208 18.9854C19.7825 17.9708 18.9767 16.6279 17.3652 13.942L16.1652 11.942C15.5961 10.9935 15.3115 10.5192 14.853 10.2596C14.3945 10 13.8414 10 12.7352 10H11.2648C10.1586 10 9.60549 10 9.14698 10.2596C8.68848 10.5192 8.40392 10.9935 7.83479 11.942Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 14L8.06551 14.9377C8.77051 15.558 9.8122 15.6044 10.5695 15.049L10.8173 14.8673C11.5213 14.3511 12.4787 14.3511 13.1827 14.8673L13.4305 15.049C14.1878 15.6044 15.2295 15.558 15.9345 14.9377L17 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.0007 5L12.0007 7M15 7C15 6.5 15.2 5.4 16 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 7C9 6.5 8.8 5.4 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["volume","sound","audio","mute","notification","alert","speaker","adjust-volume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 11V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10V14"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["volume","sound","notification","alert","audio","increase-volume","medium-volume","volume-level"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 11V13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["volume","sound","speaker","audio","alert","notification","mute","unmute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.96 8.0725C14.9101 7.43798 14.7902 6.78266 14.4205 6.26256C13.821 5.42 12.8518 4.95191 11.8426 5.00392C11.2132 5.04553 10.6536 5.37839 10.144 5.74246C9.62448 6.11693 8.995 6.66823 8.22565 7.33396L8.18568 7.36517L8.11574 7.42758L8.14571 7.39637L8.17569 7.37557C7.89592 7.61481 7.83597 7.66682 7.78601 7.69803C7.6761 7.76044 7.56619 7.80205 7.4363 7.82285C7.37635 7.83325 7.30641 7.83325 6.93672 7.83325H6.90674C6.49709 7.83325 6.13739 7.83325 5.84763 7.85406C5.53788 7.87486 5.22814 7.91647 4.9184 8.04129C4.12906 8.35335 3.49958 9.00868 3.19983 9.83043C3.07993 10.1529 3.03997 10.4754 3.01998 10.7978C3 11.0995 3 11.4739 3 11.9004V12.0981C3 12.5245 3 12.899 3.01998 13.2007C3.03997 13.5231 3.07993 13.8456 3.19983 14.1681C3.49958 14.9898 4.12906 15.6451 4.9184 15.9572C5.22814 16.082 5.53788 16.1236 5.84763 16.1444C6.13739 16.1652 6.49709 16.1652 6.90674 16.1652H6.93672C7.30641 16.1652 7.37635 16.1652 7.4363 16.1756C7.5562 16.1964 7.6761 16.238 7.78601 16.3005C7.83597 16.3317 7.93589 16.4149 8.22565 16.6645C8.995 17.3302 9.61449 17.8816 10.1341 18.256C10.6436 18.6201 11.2032 18.9634 11.8326 18.9946C12.8418 19.057 13.811 18.5785 14.4105 17.7359C14.7802 17.2158 14.9001 16.5605 14.95 15.926C15 15.2811 15 14.4489 15 13.4191V10.569C15 9.54958 15 8.70702 14.95 8.0621L14.96 8.0725Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.25 10C17.8023 10 18.25 10.4477 18.25 11V13C18.25 13.5523 17.8023 14 17.25 14C16.6977 14 16.25 13.5523 16.25 13V11C16.25 10.4477 16.6977 10 17.25 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.25 9C20.8023 9 21.25 9.44772 21.25 10V14C21.25 14.5523 20.8023 15 20.25 15C19.6977 15 19.25 14.5523 19.25 14V10C19.25 9.44772 19.6977 9 20.25 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volume-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["volume","sound","notification","alert","loud","speaker","audio","mute"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L19 8M17 15L19 16M19 12H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "volcano-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["bag","sack","pouch","gift","reward","tip","money","cash","treasure","loot","collection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2581 9.00022H12.7419C13.2339 9.00019 13.6691 9.00017 14.0338 9.03736C14.4292 9.07769 14.8141 9.16692 15.189 9.38962C15.5639 9.61233 15.8348 9.91264 16.0712 10.2476C16.2893 10.5567 16.5131 10.9481 16.7663 11.3908L17.4528 12.5913L15.823 13.5945C15.5474 13.7641 15.2091 13.7776 14.922 13.6304L12.7793 12.5313C11.9869 12.1249 11.06 12.1249 10.2675 12.5313L8.12484 13.6304C7.83778 13.7776 7.4995 13.7641 7.2239 13.5945L6.29901 13.0252L7.23374 11.3908C7.48687 10.9481 7.71071 10.5567 7.92878 10.2476C8.16518 9.91264 8.43611 9.61233 8.81102 9.38962C9.18594 9.16692 9.57079 9.07769 9.96621 9.03736C10.3309 9.00017 10.7661 9.00019 11.2581 9.00022Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.32274 14.7431C4.90947 15.4864 4.57111 16.1384 4.34613 16.7076C3.99437 17.5974 3.80597 18.5624 4.30023 19.4783C4.79449 20.3942 5.68016 20.7212 6.58844 20.8626C7.47339 21.0003 8.65077 21.0003 10.0752 21.0002H13.9248C15.3492 21.0003 16.5266 21.0003 17.4116 20.8626C18.3198 20.7212 19.2055 20.3942 19.6998 19.4783C20.194 18.5624 20.0056 17.5974 19.6539 16.7076C19.3859 16.0297 18.9571 15.2343 18.4325 14.3071L16.7876 15.3195C15.9608 15.8284 14.946 15.8688 14.0848 15.4271L11.9421 14.3281C11.6779 14.1926 11.369 14.1926 11.1048 14.3281L8.96211 15.4271C8.10093 15.8688 7.08608 15.8284 6.25928 15.3195L5.32274 14.7431Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8944 4.55301C17.1414 5.04698 16.9412 5.64766 16.4472 5.89465C16.3538 5.94133 16.2338 6.06229 16.1326 6.32371C16.033 6.58082 16 6.85619 16 7.00022C16 7.5525 15.5523 8.00022 15 8.00022C14.4477 8.00022 14 7.5525 14 7.00022C14 6.64424 14.067 6.11962 14.2674 5.60172C14.4662 5.08815 14.8462 4.4591 15.5528 4.10579C16.0468 3.8588 16.6474 4.05903 16.8944 4.55301ZM12.0007 4.00022C12.553 4.00022 13.0007 4.44793 13.0007 5.00022V7.00022C13.0007 7.5525 12.553 8.00022 12.0007 8.00022C11.4484 8.00022 11.0007 7.5525 11.0007 7.00022V5.00022C11.0007 4.44793 11.4484 4.00022 12.0007 4.00022Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.10557 4.55301C6.85858 5.04698 7.05881 5.64766 7.55279 5.89465C7.64616 5.94133 7.76624 6.06229 7.86743 6.32371C7.96696 6.58082 8 6.85619 8 7.00022C8 7.5525 8.44772 8.00022 9 8.00022C9.55228 8.00022 10 7.5525 10 7.00022C10 6.64424 9.93304 6.11962 9.73257 5.60172C9.53376 5.08815 9.15384 4.4591 8.44721 4.10579C7.95324 3.8588 7.35256 4.05903 7.10557 4.55301Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volume-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sound","volume","speaker","notification","alert","audio","mute","unmute","low-volume","high-volume","system-sounds","sound-effects"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L19 8M17 15L19 16M19 12H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "volume-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["volume","sound","notification","alert","loud","audio","speaker","mute","unmute","adjust-volume","sound-level","turn-on-sound","turn-off-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.96 8.0725C14.9101 7.43798 14.7902 6.78266 14.4205 6.26256C13.821 5.42 12.8518 4.95191 11.8426 5.00392C11.2132 5.04553 10.6536 5.37839 10.144 5.74246C9.62448 6.11693 8.995 6.66823 8.22565 7.33396L8.18568 7.36517L8.11574 7.42758L8.14571 7.39637L8.17569 7.37557C7.89592 7.61481 7.83597 7.66682 7.78601 7.69803C7.6761 7.76044 7.5662 7.80205 7.4363 7.82285C7.37635 7.83325 7.30641 7.83325 6.93672 7.83325H6.90674C6.49709 7.83325 6.13739 7.83325 5.84763 7.85406C5.53788 7.87486 5.22814 7.91647 4.9184 8.04129C4.12906 8.35335 3.49958 9.00868 3.19983 9.83043C3.07993 10.1529 3.03997 10.4754 3.01998 10.7978C3 11.0995 3 11.4739 3 11.9004V12.0981C3 12.5245 3 12.899 3.01998 13.2007C3.03997 13.5231 3.07993 13.8456 3.19983 14.1681C3.49958 14.9898 4.12906 15.6451 4.9184 15.9572C5.22814 16.082 5.53788 16.1236 5.84763 16.1444C6.13739 16.1652 6.49709 16.1652 6.90674 16.1652H6.93672C7.30641 16.1652 7.37635 16.1652 7.4363 16.1756C7.5562 16.1964 7.6761 16.238 7.78601 16.3005C7.83597 16.3317 7.93589 16.4149 8.22565 16.6645C8.995 17.3302 9.61449 17.8816 10.1341 18.256C10.6436 18.6201 11.2032 18.9634 11.8326 18.9946C12.8418 19.057 13.811 18.5785 14.4105 17.7359C14.7802 17.2158 14.9001 16.5605 14.95 15.926C15 15.2811 15 14.4489 15 13.4191V10.569C15 9.54958 15 8.70702 14.95 8.0621L14.96 8.0725Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.1446 7.55276C20.3916 8.04674 20.1914 8.64741 19.6974 8.8944L17.6974 9.8944C17.2035 10.1414 16.6028 9.94117 16.3558 9.44719C16.1088 8.95321 16.309 8.35254 16.803 8.10555L18.803 7.10555C19.297 6.85856 19.8977 7.05878 20.1446 7.55276ZM16.2502 12C16.2502 11.4477 16.6979 11 17.2502 11H19.2502C19.8025 11 20.2502 11.4477 20.2502 12C20.2502 12.5523 19.8025 13 19.2502 13H17.2502C16.6979 13 16.2502 12.5523 16.2502 12ZM16.3558 14.5528C16.6028 14.0588 17.2035 13.8586 17.6974 14.1055L19.6974 15.1055C20.1914 15.3525 20.3916 15.9532 20.1446 16.4472C19.8977 16.9412 19.297 17.1414 18.803 16.8944L16.803 15.8944C16.309 15.6474 16.1088 15.0467 16.3558 14.5528Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volume-low-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["sound","volume","mute","low-volume","notification","audio","sound-off","decrease-volume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11.9367V12.0632C5 12.9358 5 13.3721 5.1338 13.7192C5.33697 14.2464 5.75361 14.663 6.28076 14.8662C6.62793 15 7.06421 15 7.93675 15C8.27156 15 8.43896 15 8.59986 15.0264C8.84353 15.0664 9.07769 15.1512 9.29048 15.2765C9.431 15.3592 9.56204 15.4684 9.82411 15.6868L9.82412 15.6868C11.4265 17.0221 12.2277 17.6898 12.888 17.7268C13.5594 17.7644 14.2048 17.4621 14.6057 16.9223C15 16.3913 15 15.3682 15 13.3221V10.6779C15 8.63176 15 7.60871 14.6057 7.07773C14.2048 6.53785 13.5594 6.23558 12.888 6.27322C12.2277 6.31024 11.4265 6.97791 9.82411 8.31324L9.82411 8.31324C9.56204 8.53163 9.431 8.64083 9.29048 8.72355C9.07769 8.84881 8.84353 8.93359 8.59986 8.97359C8.43896 9 8.27156 9 7.93675 9C7.06421 9 6.62793 9 6.28076 9.1338C5.75361 9.33697 5.33697 9.75361 5.1338 10.2808C5 10.6279 5 11.0642 5 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11V13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["volume","sound","loud","speaker","notification","alert","audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 9L19 8M17 15L19 16M19 12H17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "volume-low-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["volume","sound","notification","alert","mute","audio","volume-low"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.96 8.0725C14.9101 7.43798 14.7902 6.78266 14.4205 6.26256C13.821 5.42 12.8518 4.95191 11.8426 5.00392C11.2132 5.04553 10.6536 5.37839 10.144 5.74246C9.62448 6.11693 8.995 6.66823 8.22565 7.33396L8.18568 7.36517L8.11574 7.42758L8.14571 7.39637L8.17569 7.37557C7.89592 7.61481 7.83597 7.66682 7.78601 7.69803C7.6761 7.76044 7.56619 7.80205 7.4363 7.82285C7.37635 7.83325 7.30641 7.83325 6.93672 7.83325H6.90674C6.49709 7.83325 6.13739 7.83325 5.84763 7.85406C5.53788 7.87486 5.22814 7.91647 4.9184 8.04129C4.12906 8.35335 3.49958 9.00868 3.19983 9.83043C3.07993 10.1529 3.03997 10.4754 3.01998 10.7978C3 11.0995 3 11.4739 3 11.9004V12.0981C3 12.5245 3 12.899 3.01998 13.2007C3.03997 13.5231 3.07993 13.8456 3.19983 14.1681C3.49958 14.9898 4.12906 15.6451 4.9184 15.9572C5.22814 16.082 5.53788 16.1236 5.84763 16.1444C6.13739 16.1652 6.49709 16.1652 6.90674 16.1652H6.93672C7.30641 16.1652 7.37635 16.1652 7.4363 16.1756C7.5562 16.1964 7.6761 16.238 7.78601 16.3005C7.83597 16.3317 7.93589 16.4149 8.22565 16.6645C8.995 17.3302 9.61449 17.8816 10.1341 18.256C10.6436 18.6201 11.2032 18.9634 11.8326 18.9946C12.8418 19.057 13.811 18.5785 14.4105 17.7359C14.7802 17.2158 14.9001 16.5605 14.95 15.926C15 15.2811 15 14.4489 15 13.4191V10.569C15 9.54958 15 8.70702 14.95 8.0621L14.96 8.0725Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volume-low": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","volume","mute","notification","alert","volume-low","audio","feedback","speaker"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 11.9367V12.0632C5 12.9358 5 13.3721 5.1338 13.7192C5.33697 14.2464 5.75361 14.663 6.28076 14.8662C6.62793 15 7.06421 15 7.93675 15C8.27156 15 8.43896 15 8.59986 15.0264C8.84353 15.0664 9.07769 15.1512 9.29048 15.2765C9.431 15.3592 9.56204 15.4684 9.82411 15.6868L9.82412 15.6868C11.4265 17.0221 12.2277 17.6898 12.888 17.7268C13.5594 17.7644 14.2048 17.4621 14.6057 16.9223C15 16.3913 15 15.3682 15 13.3221V10.6779C15 8.63176 15 7.60871 14.6057 7.07773C14.2048 6.53785 13.5594 6.23558 12.888 6.27322C12.2277 6.31024 11.4265 6.97791 9.82411 8.31324L9.82411 8.31324C9.56204 8.53163 9.431 8.64083 9.29048 8.72355C9.07769 8.84881 8.84353 8.93359 8.59986 8.97359C8.43896 9 8.27156 9 7.93675 9C7.06421 9 6.62793 9 6.28076 9.1338C5.75361 9.33697 5.33697 9.75361 5.1338 10.2808C5 10.6279 5 11.0642 5 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M18 11V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-slash-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["volume-off","mute","sound-off","disable-sound","audio-off","no-sound","silent","no-audio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11.9367V12.0632C7 12.9358 7 13.3721 7.1338 13.7192C7.33697 14.2464 7.75361 14.663 8.28076 14.8662C8.62793 15 9.06421 15 9.93675 15C10.2716 15 10.439 15 10.5999 15.0264C10.8435 15.0664 11.0777 15.1512 11.2905 15.2765C11.431 15.3592 11.562 15.4684 11.8241 15.6868L11.8241 15.6868C13.4265 17.0221 14.2277 17.6898 14.888 17.7268C15.5594 17.7644 16.2048 17.4621 16.6057 16.9223C17 16.3913 17 15.3682 17 13.3221V10.6779C17 8.63176 17 7.60871 16.6057 7.07773C16.2048 6.53785 15.5594 6.23558 14.888 6.27322C14.2277 6.31024 13.4265 6.97791 11.8241 8.31324L11.8241 8.31324C11.562 8.53163 11.431 8.64083 11.2905 8.72355C11.0777 8.84881 10.8435 8.93359 10.5999 8.97359C10.439 9 10.2716 9 9.93675 9C9.06421 9 8.62793 9 8.28076 9.1338C7.75361 9.33697 7.33697 9.75361 7.1338 10.2808C7 10.6279 7 11.0642 7 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "volume-slash-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["mute","volume off","no sound","silent","disable sound","sound off","audio off","notification off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11.9367V12.0632C7 12.9358 7 13.3721 7.1338 13.7192C7.33697 14.2464 7.75361 14.663 8.28076 14.8662C8.62793 15 9.06421 15 9.93675 15C10.2716 15 10.439 15 10.5999 15.0264C10.8435 15.0664 11.0777 15.1512 11.2905 15.2765C11.431 15.3592 11.562 15.4684 11.8241 15.6868L11.8241 15.6868C13.4265 17.0221 14.2277 17.6898 14.888 17.7268C15.5594 17.7644 16.2048 17.4621 16.6057 16.9223C17 16.3913 17 15.3682 17 13.3221V10.6779C17 8.63176 17 7.60871 16.6057 7.07773C16.2048 6.53785 15.5594 6.23558 14.888 6.27322C14.2277 6.31024 13.4265 6.97791 11.8241 8.31324L11.8241 8.31324C11.562 8.53163 11.431 8.64083 11.2905 8.72355C11.0777 8.84881 10.8435 8.93359 10.5999 8.97359C10.439 9 10.2716 9 9.93675 9C9.06421 9 8.62793 9 8.28076 9.1338C7.75361 9.33697 7.33697 9.75361 7.1338 10.2808C7 10.6279 7 11.0642 7 11.9367Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "volume-slash-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","sound off","volume off","notification off","disable audio","silent mode","no sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3005 4.29006C18.6905 3.90006 19.3205 3.90006 19.7105 4.29006V4.30006C20.1005 4.69006 20.1005 5.32006 19.7105 5.71006L5.70048 19.7001C5.31048 20.0901 4.69048 20.0901 4.30048 19.7001C3.91048 19.3101 3.90048 18.6801 4.29048 18.2901L7.11048 15.4601C6.71048 15.1201 6.38048 14.6901 6.19048 14.1701C6.07048 13.8401 6.03048 13.5201 6.01048 13.2001C5.99048 12.9001 5.99048 12.5301 5.99048 12.1001V11.9001C5.99048 11.4801 5.99048 11.1001 6.01048 10.8001C6.03048 10.4701 6.07048 10.1501 6.19048 9.83006C6.49048 9.01006 7.12048 8.35006 7.91048 8.04006C8.22048 7.91006 8.53048 7.87006 8.84048 7.85006C9.13048 7.83006 9.49048 7.83006 9.90048 7.83006H9.93048C10.3005 7.83006 10.3705 7.83006 10.4305 7.82006C10.5605 7.80006 10.6705 7.76006 10.7805 7.70006C10.8156 7.67368 10.8663 7.63185 11.0343 7.49302C11.0574 7.47394 11.0827 7.45302 11.1105 7.43006L11.1305 7.41006C11.1405 7.40006 11.1705 7.38006 11.1705 7.38006L11.1905 7.36006L11.2305 7.33006C11.2605 7.30506 11.288 7.28006 11.3155 7.25506C11.343 7.23006 11.3705 7.20506 11.4005 7.18006L11.4472 7.14003C12.1259 6.55824 12.6812 6.08224 13.1505 5.74006C13.6605 5.37006 14.2205 5.04006 14.8505 5.00006C15.6005 4.96006 16.3305 5.21006 16.9005 5.69006L18.3005 4.29006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.9705 16.45C10.9852 16.4623 11.0017 16.4758 11.0199 16.4906C11.0759 16.5362 11.1475 16.5946 11.2305 16.67C11.2901 16.7242 11.3526 16.7784 11.4133 16.831C11.4646 16.8754 11.5147 16.9188 11.5605 16.96C12.1805 17.5 12.6905 17.94 13.1405 18.26C13.6505 18.62 14.2105 18.97 14.8405 19C15.8505 19.06 16.8205 18.58 17.4205 17.74C17.7905 17.22 17.9105 16.56 17.9605 15.93C18.0105 15.29 18.0105 14.45 18.0105 13.42V9.42004L10.9805 16.45H10.9705Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "volume-low-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["volume","sound","low","mute","notification","alert","audio","adjust-volume"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "volume-xmark-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["volume","mute","sound","audio","disabled","off","no-sound","silence","notification-off","sound-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 14L21 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 14L17 10" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "volume-xmark-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["sound","volume","mute","disable-sound","audio-off","no-sound","silence","mute-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M17 14L21 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 14L17 10" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "volume-slash": {
        defaultColors: ["#3D4C66"],
        keywords: ["sound","mute","volume-off","no-sound","audio-off","silent","disable-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 11.9367V12.0632C7 12.9358 7 13.3721 7.1338 13.7192C7.33697 14.2464 7.75361 14.663 8.28076 14.8662C8.62793 15 9.06421 15 9.93675 15C10.2716 15 10.439 15 10.5999 15.0264C10.8435 15.0664 11.0777 15.1512 11.2905 15.2765C11.431 15.3592 11.562 15.4684 11.8241 15.6868L11.8241 15.6868C13.4265 17.0221 14.2277 17.6898 14.888 17.7268C15.5594 17.7644 16.2048 17.4621 16.6057 16.9223C17 16.3913 17 15.3682 17 13.3221V10.6779C17 8.63176 17 7.60871 16.6057 7.07773C16.2048 6.53785 15.5594 6.23558 14.888 6.27322C14.2277 6.31024 13.4265 6.97791 11.8241 8.31324L11.8241 8.31324C11.562 8.53163 11.431 8.64083 11.2905 8.72355C11.0777 8.84881 10.8435 8.93359 10.5999 8.97359C10.439 9 10.2716 9 9.93675 9C9.06421 9 8.62793 9 8.28076 9.1338C7.75361 9.33697 7.33697 9.75361 7.1338 10.2808C7 10.6279 7 11.0642 7 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "volume-xmark": {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","sound-off","no-sound","disable-sound","volume-off","volume-mute","silent","turn-off-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M17 14L21 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 14L17 10" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    volume: {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","sound-off","no-sound","disable-sound","volume-off","volume-mute","silent","turn-off-sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 11.9367V12.0632C4 12.9358 4 13.3721 4.1338 13.7192C4.33697 14.2464 4.75361 14.663 5.28076 14.8662C5.62793 15 6.06421 15 6.93675 15C7.27156 15 7.43896 15 7.59986 15.0264C7.84353 15.0664 8.07769 15.1512 8.29048 15.2765C8.431 15.3592 8.56204 15.4684 8.82411 15.6868L8.82412 15.6868C10.4265 17.0221 11.2277 17.6898 11.888 17.7268C12.5594 17.7644 13.2048 17.4621 13.6057 16.9223C14 16.3913 14 15.3682 14 13.3221V10.6779C14 8.63176 14 7.60871 13.6057 7.07773C13.2048 6.53785 12.5594 6.23558 11.888 6.27322C11.2277 6.31024 10.4265 6.97791 8.82411 8.31324L8.82411 8.31324C8.56204 8.53163 8.431 8.64083 8.29048 8.72355C8.07769 8.84881 7.84353 8.93359 7.59986 8.97359C7.43896 9 7.27156 9 6.93675 9C6.06421 9 5.62793 9 5.28076 9.1338C4.75361 9.33697 4.33697 9.75361 4.1338 10.2808C4 10.6279 4 11.0642 4 11.9367Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 11V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 10V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "volume-xmark-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["mute","volume off","disable sound","audio off","silent mode","no sound"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.23 8.06972C14.18 7.43972 14.06 6.77972 13.69 6.25972C13.09 5.41972 12.12 4.94972 11.11 4.99972C10.48 5.03972 9.92 5.36972 9.41 5.73972C8.89 6.10972 8.26 6.66972 7.49 7.32972L7.45 7.35972L7.43 7.37972C7.43 7.37972 7.41 7.39972 7.39 7.40972L7.37 7.42972C7.14 7.61972 7.08 7.66972 7.04 7.69972C6.93 7.75972 6.82 7.79972 6.69 7.81972C6.63 7.82972 6.56 7.82972 6.19 7.82972H6.16C5.75 7.82972 5.39 7.82972 5.1 7.84972C4.79 7.86972 4.48 7.90972 4.17 8.03972C3.38 8.34972 2.75 9.00972 2.45 9.82972C2.33 10.1497 2.29 10.4697 2.27 10.7997C2.25 11.0997 2.25 11.4797 2.25 11.8997V12.0997C2.25 12.5297 2.25 12.8997 2.27 13.1997C2.29 13.5197 2.33 13.8397 2.45 14.1697C2.75 14.9897 3.38 15.6497 4.17 15.9597C4.48 16.0797 4.79 16.1297 5.1 16.1497C5.39 16.1697 5.75 16.1697 6.16 16.1697H6.19C6.56 16.1697 6.63 16.1697 6.69 16.1797C6.81 16.1997 6.93 16.2397 7.04 16.2997C7.09 16.3297 7.19 16.4097 7.48 16.6597C8.25 17.3297 8.87 17.8797 9.39 18.2497C9.9 18.6097 10.46 18.9698 11.09 18.9998C12.1 19.0598 13.07 18.5697 13.67 17.7297C14.04 17.2097 14.16 16.5497 14.21 15.9197C14.26 15.2797 14.26 14.4397 14.26 13.4097V10.5597C14.26 9.53972 14.26 8.69972 14.21 8.04972H14.22L14.23 8.06972Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.44 7.37972L7.39 7.42972C7.39 7.42972 7.4 7.42972 7.41 7.41972L7.44 7.38972V7.37972Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.18 11.9997L21.47 10.7097C21.86 10.3197 21.86 9.68972 21.47 9.29972C21.08 8.90972 20.45 8.90972 20.06 9.29972L18.77 10.5897L17.48 9.29972C17.09 8.90972 16.46 8.90972 16.07 9.29972C15.68 9.68972 15.68 10.3197 16.07 10.7097L17.36 11.9997L16.07 13.2897C15.68 13.6797 15.68 14.3097 16.07 14.6997C16.46 15.0897 17.09 15.0897 17.48 14.6997L18.77 13.4097L20.06 14.6997C20.45 15.0897 21.08 15.0897 21.47 14.6997C21.86 14.3097 21.86 13.6797 21.47 13.2897L20.18 11.9997Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Vr-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["VR","Virtual Reality","3D","Experience","Gaming","Entertainment","Simulation","Point of Sale","VR Ready","Technology","Interface","Visualization"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9L10 15L8 15L7 9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Vr-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["vr","virtual reality","game","entertainment","technology","simulation","immersive","experience"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 9.75V12.25H15.25C15.9404 12.25 16.5 11.6904 16.5 11C16.5 10.3096 15.9404 9.75 15.25 9.75H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 3H11.9268C10.1034 2.99997 8.63362 2.99995 7.47767 3.15537C6.27752 3.31672 5.26702 3.66191 4.46447 4.46447C3.66191 5.26702 3.31672 6.27752 3.15537 7.47767C2.99995 8.63362 2.99997 10.1034 3 11.9268V12.0732C2.99997 13.8966 2.99995 15.3664 3.15537 16.5223C3.31672 17.7225 3.66191 18.733 4.46447 19.5355C5.26702 20.3381 6.27752 20.6833 7.47767 20.8446C8.63363 21.0001 10.1034 21 11.9269 21H12.0731C13.8966 21 15.3664 21.0001 16.5223 20.8446C17.7225 20.6833 18.733 20.3381 19.5355 19.5355C20.3381 18.733 20.6833 17.7225 20.8446 16.5223C21.0001 15.3664 21 13.8966 21 12.0731V11.9269C21 10.1034 21.0001 8.63363 20.8446 7.47767C20.6833 6.27752 20.3381 5.26702 19.5355 4.46447C18.733 3.66191 17.7225 3.31672 16.5223 3.15537C15.3664 2.99995 13.8966 2.99997 12.0732 3ZM11.4898 9.12329C11.5579 8.71472 11.2819 8.3283 10.8733 8.2602C10.4647 8.1921 10.0783 8.46812 10.0102 8.8767L9.11465 14.25L8.38534 14.25L7.48979 8.8767C7.42169 8.46812 7.03527 8.1921 6.6267 8.2602C6.21812 8.3283 5.9421 8.71472 6.0102 9.1233L7.0102 15.1233C7.07047 15.4849 7.38337 15.75 7.75 15.75L9.75 15.75C10.1166 15.75 10.4295 15.4849 10.4898 15.1233L11.4898 9.12329ZM13.25 8.25C12.8358 8.25 12.5 8.58578 12.5 9V15C12.5 15.4142 12.8358 15.75 13.25 15.75C13.6642 15.75 14 15.4142 14 15V13.7515C14.5519 13.7568 14.737 13.7777 14.8999 13.8451C15.0976 13.927 15.2699 14.0806 15.8912 14.7019L16.7197 15.5303C17.0126 15.8232 17.4874 15.8232 17.7803 15.5303C18.0732 15.2374 18.0732 14.7626 17.7803 14.4697L16.8665 13.5557C16.7984 13.4875 16.7322 13.4212 16.6674 13.357C17.4659 12.8758 18 12.0003 18 11C18 9.48121 16.7688 8.25 15.25 8.25H13.25Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Vr: {
        defaultColors: ["#3D4C66"],
        keywords: ["vr","virtual reality","game","entertainment","technology","simulation","immersive","experience"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9L10 15L8 15L7 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "vuejs-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["v","double-v","chevron-down","expand","collapse","dropdown","options","menu","settings","preferences"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6L12 18L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L12 13L8 6"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "vuejs-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["vuejs","chevron-down","arrow-down","discount","apply","coupon","scroll-down","see-more","view-more","collapse","reduce","minimize"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6L12 18L5 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L12 13L8 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "vuejs-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["v","double-v","chevron-down","discount","coupon","arrow-down","expand","collapse"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.50403 4.13168C3.98355 3.85767 4.5944 4.02427 4.86841 4.50379L12.0002 16.9844L19.1319 4.50379C19.4059 4.02427 20.0168 3.85767 20.4963 4.13168C20.9758 4.40569 21.1424 5.01655 20.8684 5.49607L12.8684 19.4961C12.6904 19.8076 12.359 19.9999 12.0002 19.9999C11.6413 19.9999 11.31 19.8076 11.1319 19.4961L3.13193 5.49607C2.85792 5.01655 3.02451 4.40569 3.50403 4.13168ZM7.50403 4.13168C7.98355 3.85767 8.5944 4.02427 8.86841 4.50379L12.0002 9.98436L15.1319 4.50379C15.4059 4.02427 16.0168 3.85767 16.4963 4.13168C16.9758 4.40569 17.1424 5.01655 16.8684 5.49607L12.8684 12.4961C12.6904 12.8076 12.359 12.9999 12.0002 12.9999C11.6413 12.9999 11.31 12.8076 11.1319 12.4961L7.13193 5.49607C6.85792 5.01655 7.02451 4.40569 7.50403 4.13168Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Vr-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["VR","Virtual Reality","voucher","reward","loyalty","promotion","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 9L10 15L8 15L7 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 13V9H15C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13H13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 15V13H13.3431C14.1606 13 14.5694 13 14.9369 13.1522C15.3045 13.3045 15.5935 13.5935 16.1716 14.1716L17 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "W-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["w","letter-w","waiting","waveform"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L18 11.5279C18 14.8795 18 16.5554 17.2298 16.7372C16.4595 16.919 15.7101 15.4201 14.2111 12.4223L13.7889 11.5777C13.0083 10.0166 12.618 9.23607 12 9.23607C11.382 9.23607 10.9917 10.0166 10.2111 11.5777L9.78885 12.4223C8.28995 15.4201 7.5405 16.919 6.77025 16.7372C6 16.5554 6 14.8795 6 11.5279L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    vuejs: {
        defaultColors: ["#3D4C66"],
        keywords: ["w","letter-w","waiting","waveform"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 6L12 18L5 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 6L12 13L8 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "W-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["w","letter","alphabet","text","font","write","weigh","weight","w-item"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5C18.5523 5 19 5.44627 19 5.99677V11.868C19 13.477 19 14.7738 18.8975 15.6873C18.8459 16.1471 18.7598 16.6052 18.5833 16.987C18.3945 17.3953 18.0483 17.8194 17.4595 17.958C16.8707 18.0965 16.3708 17.8715 16.0188 17.5905C15.6896 17.3277 15.407 16.9563 15.1545 16.568C14.653 15.7967 14.0712 14.6368 13.3493 13.1977L12.8944 12.2908C12.4889 11.4825 12.2337 10.9796 12.0135 10.665L12 10.646L11.9865 10.665C11.7663 10.9796 11.5111 11.4825 11.1056 12.2908L10.6507 13.1977C9.92879 14.6369 9.34701 15.7967 8.84547 16.568C8.59299 16.9563 8.31041 17.3277 7.98123 17.5905C7.62921 17.8715 7.12932 18.0965 6.5405 17.958C5.95167 17.8194 5.6055 17.3953 5.41674 16.987C5.24022 16.6052 5.15409 16.1471 5.10248 15.6873C4.99996 14.7738 4.99998 13.4771 5 11.8681V11.8681V5.99677C5 5.44627 5.44772 5 6 5C6.55229 5 7 5.44627 7 5.99677L7 11.7954C7 13.4936 7.00158 14.6771 7.09008 15.4656C7.09455 15.5054 7.09915 15.5433 7.10386 15.5792C7.1242 15.5492 7.14529 15.5174 7.16714 15.4838C7.60008 14.8179 8.13252 13.76 8.89443 12.2412L9.31672 11.3993L9.35047 11.332C9.71165 10.6118 10.0317 9.97354 10.3465 9.52404C10.6668 9.0666 11.1797 8.51424 12 8.51424C12.8203 8.51424 13.3332 9.0666 13.6535 9.52404C13.9683 9.97354 14.2884 10.6118 14.6495 11.332C15.4114 12.8509 16.3999 14.8179 16.8329 15.4838C16.8547 15.5174 16.8758 15.5492 16.8961 15.5792C16.9009 15.5433 16.9055 15.5054 16.9099 15.4656C16.9984 14.6771 17 13.4936 17 11.7954V5.99677C17 5.44627 17.4477 5 18 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "W-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["W","letter","alphabet","text","font","name","initials"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L18 11.5279C18 14.8795 18 16.5554 17.2298 16.7372C16.4595 16.919 15.7101 15.4201 14.2111 12.4223L13.7889 11.5777C13.0083 10.0166 12.618 9.23607 12 9.23607C11.382 9.23607 10.9917 10.0166 10.2111 11.5777L9.78885 12.4223C8.28995 15.4201 7.5405 16.919 6.77025 16.7372C6 16.5554 6 14.8795 6 11.5279L6 6"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "walker-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["walker","mobility","assistance","accessibility","disability","medical","equipment","customer-assistance","special-needs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 11H17" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M6 18L8.24254 9.02986C8.60632 7.57474 8.78821 6.84718 9.33073 6.42359C9.87325 6 10.6232 6 12.1231 6H13C14.8856 6 15.8284 6 16.4142 6.58579C17 7.17157 17 8.11438 17 10V16"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect x="16" y="16" width="2" height="2" rx="1" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    W: {
        defaultColors: ["#3D4C66"],
        keywords: ["walker","mobility","assistance","accessibility","disability","medical","equipment","customer-assistance","special-needs"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 6L18 11.5279C18 14.8795 18 16.5554 17.2298 16.7372C16.4595 16.919 15.7101 15.4201 14.2111 12.4223L13.7889 11.5777C13.0083 10.0166 12.618 9.23607 12 9.23607C11.382 9.23607 10.9917 10.0166 10.2111 11.5777L9.78885 12.4223C8.28995 15.4201 7.5405 16.919 6.77025 16.7372C6 16.5554 6 14.8795 6 11.5279L6 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "walker-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["walker","mobility","assistance","accessibility","disability","help","support","aid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0002 15.2674V12H8.53101L6.97038 18.2425C6.83643 18.7783 6.2935 19.1041 5.7577 18.9701C5.22191 18.8362 4.89615 18.2933 5.03009 17.7575L7.28613 8.73332C7.45642 8.05197 7.60515 7.45693 7.78536 6.9839C7.97989 6.47327 8.24732 6.00097 8.71555 5.63539C9.18379 5.2698 9.70685 5.12491 10.2494 5.06003C10.752 4.99993 11.3654 4.99996 12.0677 5L13.0661 5C13.9526 4.99995 14.7164 4.99991 15.328 5.08215C15.9835 5.17028 16.6119 5.36902 17.1216 5.87868C17.6312 6.38835 17.83 7.0167 17.9181 7.67221C18.0003 8.28387 18.0003 9.04769 18.0002 9.93417L18.0002 15.2677C18.5979 15.6135 19 16.2598 19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 16.2596 15.4023 15.6132 16.0002 15.2674Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    walker: {
        defaultColors: ["#3D4C66"],
        keywords: ["walker","mobility","assistance","accessibility","disability","help","support","aid"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18L8.24254 9.02986C8.60632 7.57474 8.78821 6.84718 9.33073 6.42359C9.87325 6 10.6232 6 12.1231 6H13C14.8856 6 15.8284 6 16.4142 6.58579C17 7.17157 17 8.11438 17 10V16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 11H17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <rect x="16" y="16" width="2" height="2" rx="1" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "walker-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sleep","night","rest","employee","break","nap","timeout","pause"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 6H12.1231C10.6232 6 9.87325 6 9.33073 6.42359C8.78821 6.84718 8.60632 7.57474 8.24254 9.02986L7.75 11H17V10C17 8.11438 17 7.17157 16.4142 6.58579C15.8284 6 14.8856 6 13 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M5.27239 17.8181C5.17193 18.2199 5.41625 18.6271 5.8181 18.7276C6.21994 18.8281 6.62715 18.5837 6.72761 18.1819L5.27239 17.8181ZM8.24254 9.02986L7.51493 8.84795L8.24254 9.02986ZM16.25 16C16.25 16.4142 16.5858 16.75 17 16.75C17.4142 16.75 17.75 16.4142 17.75 16H16.25ZM16.4142 6.58579L15.8839 7.11612L15.8839 7.11612L16.4142 6.58579ZM9.33073 6.42359L8.86917 5.83243V5.83244L9.33073 6.42359ZM12.1231 6.75H13V5.25H12.1231V6.75ZM6.72761 18.1819L8.47761 11.1819L7.02239 10.8181L5.27239 17.8181L6.72761 18.1819ZM8.47761 11.1819L8.97014 9.21176L7.51493 8.84795L7.02239 10.8181L8.47761 11.1819ZM16.25 10V11H17.75V10H16.25ZM16.25 11V16H17.75V11H16.25ZM13 6.75C13.964 6.75 14.6116 6.75159 15.0946 6.81654C15.5561 6.87858 15.7536 6.9858 15.8839 7.11612L16.9445 6.05546C16.4891 5.59999 15.9223 5.41432 15.2945 5.32991C14.6883 5.24841 13.9216 5.25 13 5.25V6.75ZM17.75 10C17.75 9.07839 17.7516 8.31174 17.6701 7.70552C17.5857 7.07773 17.4 6.51093 16.9445 6.05546L15.8839 7.11612C16.0142 7.24643 16.1214 7.44393 16.1835 7.90539C16.2484 8.38843 16.25 9.03599 16.25 10H17.75ZM12.1231 5.25C11.3914 5.25 10.7764 5.24875 10.2788 5.30825C9.76123 5.37015 9.28816 5.5053 8.86917 5.83243L9.79229 7.01474C9.91582 6.91829 10.089 6.84164 10.4569 6.79764C10.8449 6.75125 11.3549 6.75 12.1231 6.75V5.25ZM8.97014 9.21176C9.15646 8.46648 9.28135 7.97207 9.42047 7.60691C9.5524 7.2606 9.66876 7.11119 9.79229 7.01474L8.86917 5.83244C8.45018 6.15957 8.20433 6.58574 8.01874 7.07289C7.84034 7.54119 7.69239 8.13811 7.51493 8.84795L8.97014 9.21176ZM7.75 11.75H17V10.25H7.75V11.75Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <rect
                    x="16"
                    y="16"
                    width="2"
                    height="2"
                    rx="1"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "walkie-talkie-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["walkie-talkie","communication","dispatch","radio","device","team communication","alerts","order updates","staff communication","service requests"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 13V13C18.5921 13.4079 18.3882 13.6118 18.2523 13.8561C18.1776 13.9902 18.1187 14.1325 18.0766 14.2802C18 14.5489 18 14.8374 18 15.4142V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H12C10.1144 20 9.17157 20 8.58579 19.4142C8 18.8284 8 17.8856 8 16V15.4142C8 14.8374 8 14.5489 7.92339 14.2802C7.8813 14.1325 7.82236 13.9902 7.74771 13.8561C7.61183 13.6118 7.40789 13.4079 7 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 15L15 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L15 17" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 13V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 3L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 4L14 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.5 8H11.5C11.0341 8 10.8011 8 10.6173 8.07612C10.3723 8.17761 10.1776 8.37229 10.0761 8.61732C10 8.80109 10 9.03406 10 9.5C10 9.96594 10 10.1989 10.0761 10.3827C10.1776 10.6277 10.3723 10.8224 10.6173 10.9239C10.8011 11 11.0341 11 11.5 11H14.5C14.9659 11 15.1989 11 15.3827 10.9239C15.6277 10.8224 15.8224 10.6277 15.9239 10.3827C16 10.1989 16 9.96594 16 9.5C16 9.03406 16 8.80109 15.9239 8.61732C15.8224 8.37229 15.6277 8.17761 15.3827 8.07612C15.1989 8 14.9659 8 14.5 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "walkie-talkie-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["walkie-talkie","communication","team","assistance","support","help","radio","contact","alert","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3V4.22326C6.59275 4.34678 6.21056 4.54682 5.87869 4.87868C5.36903 5.38835 5.17028 6.0167 5.08215 6.67221C4.99991 7.28387 4.99996 8.04769 5.00001 8.93417L5 11.8818C4.99996 12.0153 4.99993 12.1358 5.01368 12.2793L5.0175 12.3201C5.02862 12.4402 5.04319 12.5975 5.0828 12.7501C5.12241 12.9028 5.18615 13.0473 5.23483 13.1577L5.25129 13.1951C5.30958 13.3284 5.50025 13.671 5.7913 14.1939L5.87387 14.3422C5.91119 14.4093 5.94066 14.4805 5.9617 14.5543C5.9911 14.6574 6.00001 14.7809 6.00001 15.4142L6.00001 16.0658C5.99996 16.9523 5.99991 17.7161 6.08215 18.3278C6.17028 18.9833 6.36903 19.6117 6.87869 20.1213C7.38835 20.631 8.0167 20.8297 8.67222 20.9179C9.28388 21.0001 10.0477 21.0001 10.9342 21H13.0658C13.9523 21.0001 14.7161 21.0001 15.3278 20.9179C15.9833 20.8297 16.6117 20.631 17.1213 20.1213C17.631 19.6117 17.8297 18.9833 17.9179 18.3278C18.0001 17.7161 18.0001 16.9523 18 16.0658L18 15.4142C18 14.7809 18.0089 14.6574 18.0383 14.5543C18.0594 14.4805 18.0889 14.4093 18.1262 14.3422L18.2088 14.1937C18.4998 13.6709 18.6904 13.3284 18.7487 13.1951L18.7652 13.1577C18.8139 13.0473 18.8776 12.9028 18.9172 12.7501C18.9568 12.5975 18.9714 12.4402 18.9825 12.3201L18.9863 12.2793C19.0001 12.1358 19.0001 12.0153 19 11.8818L19 8.93417C19.0001 8.04769 19.0001 7.28387 18.9179 6.67221C18.8297 6.0167 18.631 5.38835 18.1213 4.87868C17.6117 4.36902 16.9833 4.17028 16.3278 4.08215C16.223 4.06805 16.1136 4.05637 16 4.04669V4C16 3.44772 15.5523 3 15 3C14.4477 3 14 3.44772 14 4H13C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L9.93418 4C9.60541 3.99998 9.29352 3.99997 9 4.00415V3ZM9 14.5543C9 14.002 9.44772 13.5543 10 13.5543H14C14.5523 13.5543 15 14.002 15 14.5543C15 15.1066 14.5523 15.5543 14 15.5543H10C9.44772 15.5543 9 15.1066 9 14.5543ZM10 17C9.44772 17 9 17.4477 9 18C9 18.5523 9.44772 19 10 19H14C14.5523 19 15 18.5523 15 18C15 17.4477 14.5523 17 14 17H10ZM10.4735 7C10.2635 6.99998 10.0588 6.99996 9.88478 7.01184C9.69441 7.02483 9.46868 7.0553 9.23464 7.15225C8.74458 7.35523 8.35523 7.74458 8.15225 8.23464C8.0553 8.46868 8.02483 8.69441 8.01184 8.88478C7.99996 9.05884 7.99998 9.26343 8 9.47345V9.52648C7.99998 9.7365 7.99996 9.94117 8.01184 10.1152C8.02483 10.3056 8.0553 10.5313 8.15225 10.7654C8.35523 11.2554 8.74458 11.6448 9.23464 11.8478C9.46868 11.9447 9.69441 11.9752 9.88478 11.9882C10.0589 12 10.2635 12 10.4735 12H13.5265C13.7365 12 13.9411 12 14.1152 11.9882C14.3056 11.9752 14.5313 11.9447 14.7654 11.8478C15.2554 11.6448 15.6448 11.2554 15.8478 10.7654C15.9447 10.5313 15.9752 10.3056 15.9882 10.1152C16 9.94115 16 9.73653 16 9.52648V9.47353C16 9.26348 16 9.05886 15.9882 8.88478C15.9752 8.69441 15.9447 8.46868 15.8478 8.23464C15.6448 7.74458 15.2554 7.35523 14.7654 7.15225C14.5313 7.0553 14.3056 7.02483 14.1152 7.01184C13.9412 6.99996 13.7366 6.99998 13.5266 7H10.4735Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "walkie-talkie-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["walkie-talkie","communication","team","staff","assistance","help","radio"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 20H12C10.1144 20 9.17157 20 8.58579 19.4142C8 18.8284 8 17.8856 8 16V15.4142C8 14.8374 8 14.5489 7.92339 14.2802C7.8813 14.1325 7.82236 13.9902 7.74771 13.8561C7.38645 13.2067 7.20582 12.8821 7.16752 12.7945C7.03602 12.4937 7.04042 12.5107 7.00912 12.184C7 12.0888 7 12.0125 7 11.8599V9C7 7.11438 7 6.17157 7.58579 5.58579C8.17157 5 9.11438 5 11 5H15C16.8856 5 17.8284 5 18.4142 5.58579C19 6.17157 19 7.11438 19 9V11.8599C19 12.0125 19 12.0888 18.9909 12.184C18.9596 12.5107 18.964 12.4937 18.8325 12.7945C18.7942 12.8821 18.6136 13.2067 18.2523 13.856L18.2523 13.8561C18.1776 13.9902 18.1187 14.1325 18.0766 14.2802C18 14.5489 18 14.8374 18 15.4142V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 15L15 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L15 17" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 3L9 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 4L14 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4L16 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.5 8H11.5C11.0341 8 10.8011 8 10.6173 8.07612C10.3723 8.17761 10.1776 8.37229 10.0761 8.61732C10 8.80109 10 9.03406 10 9.5C10 9.96594 10 10.1989 10.0761 10.3827C10.1776 10.6277 10.3723 10.8224 10.6173 10.9239C10.8011 11 11.0341 11 11.5 11H14.5C14.9659 11 15.1989 11 15.3827 10.9239C15.6277 10.8224 15.8224 10.6277 15.9239 10.3827C16 10.1989 16 9.96594 16 9.5C16 9.03406 16 8.80109 15.9239 8.61732C15.8224 8.37229 15.6277 8.17761 15.3827 8.07612C15.1989 8 14.9659 8 14.5 8Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "walkie-talkie": {
        defaultColors: ["#3D4C66"],
        keywords: ["walkie-talkie","communication","radio","staff","team","alert","assistance","dispatch","call","talk","transmit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 13V13C18.5921 13.4079 18.3882 13.6118 18.2523 13.8561C18.1776 13.9902 18.1187 14.1325 18.0766 14.2802C18 14.5489 18 14.8374 18 15.4142V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H12C10.1144 20 9.17157 20 8.58579 19.4142C8 18.8284 8 17.8856 8 16V15.4142C8 14.8374 8 14.5489 7.92339 14.2802C7.8813 14.1325 7.82236 13.9902 7.74771 13.8561C7.61183 13.6118 7.40789 13.4079 7 13V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11 15L15 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M11 17L15 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M19 13V9C19 7.11438 19 6.17157 18.4142 5.58579C17.8284 5 16.8856 5 15 5H11C9.11438 5 8.17157 5 7.58579 5.58579C7 6.17157 7 7.11438 7 9V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 3L9 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 4L14 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M16 4L16 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M14.5 8H11.5C11.0341 8 10.8011 8 10.6173 8.07612C10.3723 8.17761 10.1776 8.37229 10.0761 8.61732C10 8.80109 10 9.03406 10 9.5C10 9.96594 10 10.1989 10.0761 10.3827C10.1776 10.6277 10.3723 10.8224 10.6173 10.9239C10.8011 11 11.0341 11 11.5 11H14.5C14.9659 11 15.1989 11 15.3827 10.9239C15.6277 10.8224 15.8224 10.6277 15.9239 10.3827C16 10.1989 16 9.96594 16 9.5C16 9.03406 16 8.80109 15.9239 8.61732C15.8224 8.37229 15.6277 8.17761 15.3827 8.07612C15.1989 8 14.9659 8 14.5 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wallet v2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wallet","payment","cash","money","transaction","balance","finance","refund","account","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H11C13.8284 5 15.2426 5 16.1213 5.87868C17 6.75736 17 8.17157 17 11V13C17 15.8284 17 17.2426 16.1213 18.1213C15.2426 19 13.8284 19 11 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M17 10H15C13.8954 10 13 10.8954 13 12V12C13 13.1046 13.8954 14 15 14H17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="square"
                />
                <path d="M7 9V15" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wallet v2-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wallet","payment","money","cash","finance","transaction","credit-card","debit-card","e-wallet","digital-wallet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 9V15" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10H15C13.8954 10 13 10.8954 13 12V12C13 13.1046 13.8954 14 15 14H17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 5V5C13.8284 5 15.2426 5 16.1213 5.87868C17 6.75736 17 8.17157 17 11V13C17 15.8284 17 17.2426 16.1213 18.1213C15.2426 19 13.8284 19 11 19V19"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Wallet v2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wallet","money","payment","cash","finance","transaction","purse","checkout","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.04 14.75C13.52 14.75 12.29 13.52 12.29 12C12.29 10.48 13.52 9.25 15.04 9.25H17.53C17.49 7.32 17.29 6.09 16.37 5.17C15.2 4 13.54 4 10.54 4H10.04C7.04004 4 5.38004 4 4.21004 5.17C3.04004 6.34 3.04004 8 3.04004 11V13C3.04004 16 3.04004 17.66 4.21004 18.83C5.38004 20 7.04004 20 10.04 20H10.54C13.54 20 15.2 20 16.37 18.83C17.29 17.91 17.49 16.68 17.53 14.75H15.04ZM8.04004 15C8.04004 15.55 7.59004 16 7.04004 16C6.49004 16 6.04004 15.55 6.04004 15V9C6.04004 8.45 6.49004 8 7.04004 8C7.59004 8 8.04004 8.45 8.04004 9V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M15.04 10.75C14.35 10.75 13.79 11.31 13.79 12C13.79 12.69 14.35 13.25 15.04 13.25H17.54C17.54 13.16 17.54 13.09 17.54 13V11C17.54 10.91 17.54 10.84 17.54 10.75H15.04Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M19.81 5.04C19.19 4.42 18.43 4.14 17.38 4C17.43 4.04 17.47 4.08 17.52 4.13C17.77 4.38 17.97 4.65 18.13 4.96C18.3 5.26 18.42 5.61 18.52 6C18.8 7.14 18.8 8.66 18.8 10.82V13.22C18.8 15.38 18.8 16.89 18.52 18.03C18.44 18.42 18.31 18.76 18.13 19.07C17.98 19.37 17.77 19.66 17.52 19.91C17.48 19.95 17.44 19.99 17.39 20.01C18.44 19.88 19.2 19.6 19.81 18.99C20.96 17.84 20.96 16.14 20.96 13.06V10.96C20.96 7.89 20.96 6.19 19.81 5.04Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wallet v2": {
        defaultColors: ["#3D4C66"],
        keywords: ["wallet","payment","money","cash","finance","transaction","sales","tip"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M11 5V5C13.8284 5 15.2426 5 16.1213 5.87868C17 6.75736 17 8.17157 17 11V13C17 15.8284 17 17.2426 16.1213 18.1213C15.2426 19 13.8284 19 11 19V19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M7 9V15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 10H15C13.8954 10 13 10.8954 13 12V12C13 13.1046 13.8954 14 15 14H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wallet-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wallet","payment","money","finance","cash","credit","debit","transaction","checkout","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 10H18C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14H20V10Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wallet-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wallet","payment","money","cash","finance","transaction","sales","checkout","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10H18C16.8954 10 16 10.8954 16 12V12C16 13.1046 16.8954 14 18 14H20"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    Wallet: {
        defaultColors: ["#3D4C66"],
        keywords: ["wallet","payment","money","cash","finance","transaction","sales","checkout","pay"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 13V11C4 8.17157 4 6.75736 4.87868 5.87868C5.75736 5 7.17157 5 10 5H14C16.8284 5 18.2426 5 19.1213 5.87868C20 6.75736 20 8.17157 20 11V13C20 15.8284 20 17.2426 19.1213 18.1213C18.2426 19 16.8284 19 14 19H10C7.17157 19 5.75736 19 4.87868 18.1213C4 17.2426 4 15.8284 4 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path d="M4 9H7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M20 10H18C16.8954 10 16 10.8954 16 12V12C16 13.1046 16.8954 14 18 14H20"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Washing-Machine-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["camera","photo","capture","image","scan","qr-code","barcode","take-picture","media"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 7H16" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["washing machine","laundry","clean","appliance","service","maintenance","equipment","machine","repair","store","laundromat","dry cleaning"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13L15 13" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7L16 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","image","scan","capture","product-image","item-image","take-photo","take-picture"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.7324 12C13.3866 11.4022 12.7403 11 12 11C11.2597 11 10.6134 11.4022 10.2676 12H13.7324Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.2676 14C10.6134 14.5978 11.2597 15 12 15C12.7403 15 13.3866 14.5978 13.7324 14H10.2676Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 3H10.9294C9.57535 2.99997 8.45868 2.99994 7.57494 3.11876C6.64711 3.2435 5.82769 3.51547 5.17158 4.17158C4.51547 4.82769 4.2435 5.64711 4.11876 6.57494C3.99994 7.45868 3.99997 8.57527 4 9.92936V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45869 21.0001 9.57529 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0707V9.92943C20 8.57535 20.0001 7.45868 19.8813 6.57494C19.7565 5.64711 19.4845 4.82769 18.8284 4.17158C18.1723 3.51547 17.3529 3.2435 16.4251 3.11876C15.5413 2.99994 14.4247 2.99997 13.0706 3ZM8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM14 6C13.4477 6 13 6.44772 13 7C13 7.55229 13.4477 8 14 8H16C16.5523 8 17 7.55229 17 7C17 6.44772 16.5523 6 16 6H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Washing-Machine-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["washing-machine","laundry","clean","appliance","service","cleaning-service","schedule","timer","task","automated","process"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 11.5523 11 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Washing-Machine-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["washing-machine","laundry","cleaning","appliance","service","timer","cycle","settings","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 11.5523 11 11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Washing-Machine-14": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["pending","processing","loading","waiting","sync","asynchronous","in-progress"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 11.5523 11 11"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Washing-Machine-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["washing machine","laundry","appliance","cleaning","service","equipment","facilities","self-service","wash","dry","launderette"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14V14C10.9473 13.3509 13.0527 13.3509 15 14V14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["laundry","washing machine","clean","service","appliance","equipment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 3H13.0706C14.4247 2.99997 15.5413 2.99994 16.4251 3.11876C17.3529 3.2435 18.1723 3.51547 18.8284 4.17158C19.4845 4.82769 19.7565 5.64711 19.8813 6.57494C20.0001 7.45868 20 8.57535 20 9.92943V14.0707C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57533 21 8.4587 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V9.9294C3.99997 8.57531 3.99994 7.45868 4.11876 6.57494C4.2435 5.64711 4.51547 4.82769 5.17158 4.17158C5.82769 3.51547 6.64711 3.2435 7.57494 3.11876C8.45868 2.99994 9.57535 2.99997 10.9294 3ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 10C11.5523 10 12 10.4477 12 11C13.1046 11 14 11.8954 14 13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13C10.8954 13 10 12.1046 10 11C10 10.4477 10.4477 10 11 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wallet-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wallet","money","payment","cash","finance","transactions","sales","balance","earnings","revenue"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.92943 4H14.0706C15.4247 3.99997 16.5413 3.99994 17.4251 4.11876C18.3529 4.2435 19.1723 4.51547 19.8284 5.17158C20.4845 5.82769 20.7565 6.64711 20.8813 7.57494C20.9195 7.85916 20.9454 8.16746 20.963 8.5H19C17.067 8.5 15.5 10.067 15.5 12C15.5 13.933 17.067 15.5 19 15.5H20.963C20.9454 15.8325 20.9195 16.1408 20.8813 16.4251C20.7565 17.3529 20.4845 18.1723 19.8284 18.8284C19.1723 19.4845 18.3529 19.7565 17.4251 19.8813C16.5413 20.0001 15.4247 20 14.0707 20H9.92943C8.57535 20 7.45868 20.0001 6.57494 19.8813C5.64711 19.7565 4.82769 19.4845 4.17158 18.8284C3.51547 18.1723 3.2435 17.3529 3.11876 16.4251C2.99994 15.5413 2.99997 14.4247 3 13.0706V10.9294C2.99999 10.6063 2.99999 10.2961 3.0016 10H7C7.55229 10 8 9.55229 8 9C8 8.44772 7.55229 8 7 8H3.07187C3.08497 7.85278 3.10045 7.7111 3.11876 7.57494C3.2435 6.64711 3.51547 5.82769 4.17158 5.17158C4.82769 4.51547 5.64711 4.2435 6.57494 4.11876C7.45868 3.99994 8.57535 3.99997 9.92943 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.9996 13.6527C20.9911 13.8459 20.8317 14 20.6364 14H19C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10H20.6364C20.8317 10 20.9911 10.1541 20.9996 10.3473C20.9999 10.4834 21 10.6222 21 10.7636C21 10.8185 21 10.8738 21 10.9294V13.0705C21 13.1262 21 13.1815 21 13.2364C21 13.3778 20.9999 13.5166 20.9996 13.6527Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Washing-Machine-18": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["laundry","cleaning","washing","machine","service","appliance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9 14V14C10.9473 13.3509 13.0527 13.3509 15 14V14"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["appliance","washing-machine","laundry","cleaning","service","repair","maintenance","home","utilities"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.9779 12.7014C13.8337 11.7384 13.0031 11 12 11C10.9969 11 10.1663 11.7384 10.0221 12.7014C11.3287 12.4504 12.6713 12.4504 13.9779 12.7014Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M10.798 14.5987C11.1329 14.8508 11.5494 15 12 15C12.4506 15 12.8671 14.8508 13.202 14.5987C12.4048 14.4847 11.5952 14.4847 10.798 14.5987Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0706 3H10.9294C9.57535 2.99997 8.45868 2.99994 7.57494 3.11876C6.64711 3.2435 5.82769 3.51547 5.17158 4.17158C4.51547 4.82769 4.2435 5.64711 4.11876 6.57494C3.99994 7.45868 3.99997 8.57527 4 9.92936V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.45869 21.0001 9.57529 21 10.9294 21H13.0705C14.4246 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0707V9.92943C20 8.57535 20.0001 7.45868 19.8813 6.57494C19.7565 5.64711 19.4845 4.82769 18.8284 4.17158C18.1723 3.51547 17.3529 3.2435 16.4251 3.11876C15.5413 2.99994 14.4247 2.99997 13.0706 3ZM8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 13.4411 15.9282 13.8674 15.795 14.2668C15.2654 15.8538 13.7679 17 12 17C10.2321 17 8.7346 15.8538 8.20503 14.2668C8.07177 13.8674 8 13.4411 8 13ZM14 6C13.4477 6 13 6.44772 13 7C13 7.55229 13.4477 8 14 8H16C16.5523 8 17 7.55229 17 7C17 6.44772 16.5523 6 16 6H14Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Washing-Machine-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["camera","photo","image","capture","media","scan","product-scan"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 7H16" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["square","rounded-square","tile","module","app","block","section","category"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0706 3H10.9294C9.57533 2.99997 8.45869 2.99994 7.57494 3.11876C6.64711 3.2435 5.82769 3.51547 5.17158 4.17158C4.51547 4.82769 4.2435 5.64711 4.11876 6.57494C3.99994 7.45869 3.99997 8.57529 4 9.9294V14.0706C3.99997 15.4247 3.99994 16.5413 4.11876 17.4251C4.2435 18.3529 4.51547 19.1723 5.17158 19.8284C5.82769 20.4845 6.64711 20.7565 7.57494 20.8813C8.4587 21.0001 9.57531 21 10.9294 21H13.0705C14.4247 21 15.5413 21.0001 16.4251 20.8813C17.3529 20.7565 18.1723 20.4845 18.8284 19.8284C19.4845 19.1723 19.7565 18.3529 19.8813 17.4251C20.0001 16.5413 20 15.4247 20 14.0707V9.92943C20 8.57534 20.0001 7.45868 19.8813 6.57494C19.7565 5.64711 19.4845 4.82769 18.8284 4.17158C18.1723 3.51547 17.3529 3.2435 16.4251 3.11876C15.5413 2.99994 14.4247 2.99997 13.0706 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Washing-Machine-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["machine","remove","delete","cancel","subtract","service","error","blocked"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 14L15 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-17": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["laundry","washing","machine","cleaning","appliance","service","wash","dry","clean"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 14V14C10.9473 13.3509 13.0527 13.3509 15 14V14" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" />
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M14 7L16 7" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["laundry","washing machine","machine","appliance","settings","configuration","cycle","wash","clothes","appliance-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8L19 8" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M9 14L15 14" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["machine","laundry","washing","appliance","settings","configuration"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0706 3H10.9294C9.57536 2.99997 8.45868 2.99994 7.57494 3.11876C6.64711 3.2435 5.82769 3.51547 5.17158 4.17158C4.51547 4.82769 4.2435 5.64711 4.11876 6.57494C4.10045 6.7111 4.08497 6.85278 4.07187 7H19.9281C19.915 6.85278 19.8996 6.7111 19.8813 6.57494C19.7565 5.64711 19.4845 4.82769 18.8284 4.17158C18.1723 3.51547 17.3529 3.2435 16.4251 3.11876C15.5413 2.99994 14.4246 2.99997 13.0706 3Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 12C12.7403 12 13.3866 12.4022 13.7324 13H10.2676C10.6134 12.4022 11.2597 12 12 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 16C11.2597 16 10.6134 15.5978 10.2676 15H13.7324C13.3866 15.5978 12.7403 16 12 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 9.92866C3.99999 9.60561 3.99999 8.79607 4.0016 8.5H19.9984C20 8.79614 20 9.60574 20 9.92886V14.0707C20 15.4247 20.0001 16.5413 19.8813 17.4251C19.7565 18.3529 19.4845 19.1723 18.8284 19.8284C18.1723 20.4845 17.3529 20.7565 16.4251 20.8813C15.5413 21.0001 14.4247 21 13.0706 21H10.9294C9.57534 21 8.45868 21.0001 7.57494 20.8813C6.64711 20.7565 5.82769 20.4845 5.17158 19.8284C4.51547 19.1723 4.2435 18.3529 4.11876 17.4251C3.99994 16.5413 3.99997 15.4247 4 14.0706V9.92866ZM12 10C9.79086 10 8 11.7909 8 14C8 16.2091 9.79086 18 12 18C14.2091 18 16 16.2091 16 14C16 11.7909 14.2091 10 12 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Washing-Machine-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["washing-machine","machine","laundry","appliance","service","maintenance","repair","equipment","timer","settings","cycle","operation","function"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13L15 13" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7L16 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine-9": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["washing-machine","laundry","machine","service","settings","options","appliance"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M9 13L15 13" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M14 7L16 7" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Washing-Machine": {
        defaultColors: ["#3D4C66"],
        keywords: ["camera","photo","capture","image","media","social-media","picture","photograph","gallery"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M15 7H16" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "watch-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["watch","time","delivery-time","appointment","schedule","reminder","service-time","estimated-time","order-time","clock"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8.27239 18.0896C8.6069 19.4276 8.77415 20.0966 9.25006 20.51C9.30268 20.5557 9.35766 20.5986 9.41476 20.6386C9.93119 21 10.6208 21 12 21V21C13.3792 21 14.0688 21 14.5852 20.6386C14.6423 20.5986 14.6973 20.5557 14.7499 20.51C15.2258 20.0966 15.3931 19.4276 15.7276 18.0896L16 17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 11V13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.7276 5.91043C15.3931 4.5724 15.2258 3.90339 14.7499 3.49004C14.6973 3.44433 14.6423 3.40141 14.5852 3.36145C14.0688 3 13.3792 3 12 3V3C10.6208 3 9.93119 3 9.41476 3.36145C9.35765 3.40141 9.30268 3.44433 9.25006 3.49004C8.77415 3.90339 8.6069 4.5724 8.27239 5.91043L8 7"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="6" y="6" width="12" height="12" rx="6" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "watch-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["watch","time","clock","schedule","appointment","timer","duration","shift","employee time","productivity","waiting time","service time","check in","check out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8.27239 18.0896C8.6069 19.4276 8.77415 20.0966 9.25006 20.51C9.30268 20.5557 9.35766 20.5986 9.41476 20.6386C9.93119 21 10.6208 21 12 21V21C13.3792 21 14.0688 21 14.5852 20.6386C14.6423 20.5986 14.6973 20.5557 14.7499 20.51C15.2258 20.0966 15.3931 19.4276 15.7276 18.0896L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16 7L15.7276 5.91043C15.3931 4.5724 15.2258 3.90339 14.7499 3.49004C14.6973 3.44433 14.6423 3.40141 14.5852 3.36145C14.0688 3 13.3792 3 12 3V3C10.6208 3 9.93119 3 9.41476 3.36145C9.35765 3.40141 9.30268 3.44433 9.25006 3.49004C8.77415 3.90339 8.6069 4.5724 8.27239 5.91043L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="6"
                    y="6"
                    width="12"
                    height="12"
                    rx="6"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 11V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Washing-Machine-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["remove","delete","subtract","decrease","box","machine","inventory","minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 14L15 14" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M5 14V10C5 7.17157 5 5.75736 5.87868 4.87868C6.75736 4 8.17157 4 11 4H13C15.8284 4 17.2426 4 18.1213 4.87868C19 5.75736 19 7.17157 19 10V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H11C8.17157 20 6.75736 20 5.87868 19.1213C5 18.2426 5 16.8284 5 14Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 8L19 8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    watch: {
        defaultColors: ["#3D4C66"],
        keywords: ["remove","delete","subtract","decrease","box","machine","inventory","minus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 17L8.27239 18.0896C8.6069 19.4276 8.77415 20.0966 9.25006 20.51C9.30268 20.5557 9.35766 20.5986 9.41476 20.6386C9.93119 21 10.6208 21 12 21V21C13.3792 21 14.0688 21 14.5852 20.6386C14.6423 20.5986 14.6973 20.5557 14.7499 20.51C15.2258 20.0966 15.3931 19.4276 15.7276 18.0896L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 11V13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 7L15.7276 5.91043C15.3931 4.5724 15.2258 3.90339 14.7499 3.49004C14.6973 3.44433 14.6423 3.40141 14.5852 3.36145C14.0688 3 13.3792 3 12 3V3C10.6208 3 9.93119 3 9.41476 3.36145C9.35765 3.40141 9.30268 3.44433 9.25006 3.49004C8.77415 3.90339 8.6069 4.5724 8.27239 5.91043L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect x="6" y="6" width="12" height="12" rx="6" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "watch-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["watch","smartwatch","wearable","device","time","clock","notifications","alerts","schedule","appointments","reminders","activity-tracking","fitness","mobile-payments","contactless-payment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9491 2H12.0513C12.6972 1.99997 13.2615 1.99994 13.7261 2.05122C14.2263 2.10643 14.7119 2.22931 15.1589 2.54218C15.2445 2.60212 15.327 2.66651 15.4059 2.73506C15.8179 3.09286 16.0549 3.53415 16.2297 4.00599C16.3922 4.44434 16.529 4.99173 16.6856 5.6184L16.9704 6.75747C16.9989 6.87158 17.0066 6.98602 16.9958 7.09676C18.2355 8.35967 19 10.0905 19 12C19 13.9097 18.2353 15.6407 16.9954 16.9037C17.0061 17.0143 16.9984 17.1286 16.9699 17.2425L16.6851 18.3816C16.5285 19.0083 16.3917 19.5557 16.2292 19.994C16.0544 20.4659 15.8174 20.9071 15.4054 21.2649C15.3265 21.3335 15.2441 21.3979 15.1584 21.4578C14.7114 21.7707 14.2258 21.8936 13.7256 21.9488C13.261 22.0001 12.6967 22 12.0508 22H11.9487C11.3028 22 10.7386 22.0001 10.2739 21.9488C9.77374 21.8936 9.28815 21.7707 8.84112 21.4578C8.75547 21.3979 8.67301 21.3335 8.59408 21.2649C8.18213 20.9071 7.94515 20.4659 7.77029 19.994C7.60784 19.5557 7.47102 19.0083 7.3144 18.3816L7.02962 17.2425C7.00109 17.1284 6.99342 17.014 7.00418 16.9032C5.76453 15.6403 5 13.9095 5 12C5 10.0903 5.76471 8.35926 7.00461 7.09632C6.99391 6.98572 7.0016 6.87143 7.03009 6.75747L7.31487 5.61838C7.4715 4.99171 7.60831 4.44433 7.77076 4.00599C7.94562 3.53415 8.18261 3.09286 8.59455 2.73506C8.67348 2.66651 8.75594 2.60212 8.84159 2.54218C9.28862 2.22931 9.77421 2.10643 10.2744 2.05122C10.739 1.99994 11.3032 1.99997 11.9491 2ZM14.3544 4.70099C14.4306 4.90668 14.5034 5.15968 14.591 5.49516C13.7896 5.17568 12.9153 5 12 5C11.0849 5 10.2108 5.17561 9.40956 5.49495C9.49709 5.15957 9.56991 4.90663 9.64612 4.70099C9.75749 4.40048 9.84208 4.30058 9.90604 4.24502C9.93235 4.22217 9.95984 4.20071 9.98839 4.18073C10.0578 4.13215 10.1752 4.07431 10.4938 4.03915C10.8356 4.00142 11.2883 4.00001 12.0002 4.00001C12.7122 4.00001 13.1648 4.00142 13.5067 4.03915C13.8252 4.07431 13.9427 4.13215 14.0121 4.18073C14.0406 4.20071 14.0681 4.22217 14.0944 4.24502C14.1584 4.30058 14.243 4.40048 14.3544 4.70099ZM12 19C11.0847 19 10.2104 18.8243 9.40903 18.5048C9.49659 18.8403 9.56942 19.0933 9.64565 19.299C9.75701 19.5995 9.84161 19.6994 9.90557 19.755C9.93188 19.7778 9.95937 19.7993 9.98792 19.8193C10.0573 19.8679 10.1748 19.9257 10.4933 19.9609C10.8352 19.9986 11.2878 20 11.9998 20C12.7117 20 13.1644 19.9986 13.5062 19.9609C13.8248 19.9257 13.9422 19.8679 14.0116 19.8193C14.0402 19.7993 14.0676 19.7778 14.094 19.755C14.1579 19.6994 14.2425 19.5995 14.3539 19.299C14.4301 19.0934 14.5029 18.8404 14.5904 18.5051C13.7892 18.8244 12.9151 19 12 19ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "water-arrow-down-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["decrease","arrow-down","reduce","discount","price-drop","decrease-stock","lower-price","rollback"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8L12 10L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "water-arrow-down-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-down","decrease","reduce","inventory","stock","decrement","low","running-low","restock","adjust","waves"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 16.5C7.21895 16.5 7.66667 16.9477 7.66667 17.5C7.66667 17.667 7.75457 17.8944 8.04772 18.1142C8.34117 18.3343 8.7924 18.5 9.33333 18.5C9.87427 18.5 10.3255 18.3343 10.619 18.1142C10.9121 17.8944 11 17.667 11 17.5C11 16.9477 11.4477 16.5 12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 17.667 13.0879 17.8944 13.381 18.1142C13.6745 18.3343 14.1257 18.5 14.6667 18.5C15.2076 18.5 15.6588 18.3343 15.9523 18.1142C16.2454 17.8944 16.3333 17.667 16.3333 17.5C16.3333 16.9477 16.781 16.5 17.3333 16.5C17.8856 16.5 18.3333 16.9477 18.3333 17.5C18.3333 17.667 18.4212 17.8944 18.7144 18.1142C19.0078 18.3343 19.4591 18.5 20 18.5C20.5523 18.5 21 18.9477 21 19.5C21 20.0523 20.5523 20.5 20 20.5C19.0682 20.5 18.1861 20.218 17.5144 19.7142C17.4526 19.6678 17.3921 19.6192 17.3333 19.5684C17.2745 19.6192 17.2141 19.6678 17.1523 19.7142C16.4806 20.218 15.5985 20.5 14.6667 20.5C13.7348 20.5 12.8527 20.218 12.181 19.7142C12.1192 19.6678 12.0588 19.6192 12 19.5684C11.9412 19.6192 11.8808 19.6678 11.819 19.7142C11.1473 20.218 10.2652 20.5 9.33333 20.5C8.40151 20.5 7.5194 20.218 6.84772 19.7142C6.7859 19.6679 6.72546 19.6192 6.66667 19.5684C6.60788 19.6192 6.54744 19.6679 6.48562 19.7142C5.81393 20.218 4.93183 20.5 4 20.5C3.44772 20.5 3 20.0523 3 19.5C3 18.9477 3.44772 18.5 4 18.5C4.54093 18.5 4.99216 18.3343 5.28562 18.1142C5.57876 17.8944 5.66667 17.667 5.66667 17.5C5.66667 16.9477 6.11438 16.5 6.66667 16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 12C7.21895 12 7.66667 12.4477 7.66667 13C7.66667 13.167 7.75457 13.3944 8.04772 13.6142C8.34117 13.8343 8.7924 14 9.33333 14C9.87427 14 10.3255 13.8343 10.619 13.6142C10.9121 13.3944 11 13.167 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.167 13.0879 13.3944 13.381 13.6142C13.6745 13.8343 14.1257 14 14.6667 14C15.2076 14 15.6588 13.8343 15.9523 13.6142C16.2454 13.3944 16.3333 13.167 16.3333 13C16.3333 12.4477 16.781 12 17.3333 12C17.8856 12 18.3333 12.4477 18.3333 13C18.3333 13.167 18.4212 13.3944 18.7144 13.6142C19.0078 13.8343 19.4591 14 20 14C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16C19.0682 16 18.1861 15.718 17.5144 15.2142C17.4526 15.1678 17.3921 15.1192 17.3333 15.0684C17.2745 15.1192 17.2141 15.1678 17.1523 15.2142C16.4806 15.718 15.5985 16 14.6667 16C13.7348 16 12.8527 15.718 12.181 15.2142C12.1192 15.1678 12.0588 15.1192 12 15.0684C11.9412 15.1192 11.8808 15.1678 11.819 15.2142C11.1473 15.718 10.2652 16 9.33333 16C8.40151 16 7.5194 15.718 6.84772 15.2142C6.7859 15.1679 6.72546 15.1192 6.66667 15.0684C6.60788 15.1192 6.54744 15.1679 6.48562 15.2142C5.81393 15.718 4.93183 16 4 16C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14C4.54093 14 4.99216 13.8343 5.28562 13.6142C5.57876 13.3944 5.66667 13.167 5.66667 13C5.66667 12.4477 6.11438 12 6.66667 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 4C11.4477 4 11 4.44772 11 5V7.58579L10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289C8.90237 7.68342 8.90237 8.31658 9.29289 8.70711L11.295 10.7092C11.3904 10.804 11.5001 10.8757 11.6172 10.9241C11.7343 10.9727 11.8655 10.9996 12 11C12.1345 10.9996 12.2657 10.9727 12.3828 10.9241C12.4999 10.8757 12.6096 10.804 12.705 10.7092L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L13 7.58579V5C13 4.44772 12.5523 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "water-arrow-down": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow-down","decrease","reduction","drop","low","waves","sales-decrease","stock-decrease","price-drop","discount"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8L12 10L14 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "water-arrow-down-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow","down","water","decrease","reduce","drop","discount","price-drop","decrease-price","lower","decrease-stock","drain"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 8L12 10L14 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "water-arrow-up-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["surge","increase","growth","rising","arrow-up","sales","revenue","profit","trending-up","wave","high-demand"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L12 5L10 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "water-arrow-up-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","growth","sales","profit","revenue","rise","trending-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 12C7.21895 12 7.66667 12.4477 7.66667 13C7.66667 13.167 7.75457 13.3944 8.04772 13.6142C8.34117 13.8343 8.7924 14 9.33333 14C9.87427 14 10.3255 13.8343 10.619 13.6142C10.9121 13.3944 11 13.167 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.167 13.0879 13.3944 13.381 13.6142C13.6745 13.8343 14.1257 14 14.6667 14C15.2076 14 15.6588 13.8343 15.9523 13.6142C16.2454 13.3944 16.3333 13.167 16.3333 13C16.3333 12.4477 16.781 12 17.3333 12C17.8856 12 18.3333 12.4477 18.3333 13C18.3333 13.167 18.4212 13.3944 18.7144 13.6142C19.0078 13.8343 19.4591 14 20 14C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16C19.0682 16 18.1861 15.718 17.5144 15.2142C17.4526 15.1678 17.3921 15.1192 17.3333 15.0684C17.2745 15.1192 17.2141 15.1678 17.1523 15.2142C16.4806 15.718 15.5985 16 14.6667 16C13.7348 16 12.8527 15.718 12.181 15.2142C12.1192 15.1678 12.0588 15.1192 12 15.0684C11.9412 15.1192 11.8808 15.1678 11.819 15.2142C11.1473 15.718 10.2652 16 9.33333 16C8.40151 16 7.5194 15.718 6.84772 15.2142C6.7859 15.1678 6.72546 15.1192 6.66667 15.0684C6.60788 15.1192 6.54744 15.1678 6.48562 15.2142C5.81393 15.718 4.93183 16 4 16C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14C4.54093 14 4.99216 13.8343 5.28562 13.6142C5.57876 13.3944 5.66667 13.167 5.66667 13C5.66667 12.4477 6.11438 12 6.66667 12ZM6.66667 16.5C7.21895 16.5 7.66667 16.9477 7.66667 17.5C7.66667 17.667 7.75457 17.8944 8.04772 18.1142C8.34117 18.3343 8.7924 18.5 9.33333 18.5C9.87427 18.5 10.3255 18.3343 10.619 18.1142C10.9121 17.8944 11 17.667 11 17.5C11 16.9477 11.4477 16.5 12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 17.667 13.0879 17.8944 13.381 18.1142C13.6745 18.3343 14.1257 18.5 14.6667 18.5C15.2076 18.5 15.6588 18.3343 15.9523 18.1142C16.2454 17.8944 16.3333 17.667 16.3333 17.5C16.3333 16.9477 16.781 16.5 17.3333 16.5C17.8856 16.5 18.3333 16.9477 18.3333 17.5C18.3333 17.667 18.4212 17.8944 18.7144 18.1142C19.0078 18.3343 19.4591 18.5 20 18.5C20.5523 18.5 21 18.9477 21 19.5C21 20.0523 20.5523 20.5 20 20.5C19.0682 20.5 18.1861 20.218 17.5144 19.7142C17.4526 19.6678 17.3921 19.6192 17.3333 19.5684C17.2745 19.6192 17.2141 19.6678 17.1523 19.7142C16.4806 20.218 15.5985 20.5 14.6667 20.5C13.7348 20.5 12.8527 20.218 12.181 19.7142C12.1192 19.6679 12.0588 19.6192 12 19.5684C11.9412 19.6192 11.8808 19.6679 11.819 19.7142C11.1473 20.218 10.2652 20.5 9.33333 20.5C8.40151 20.5 7.5194 20.218 6.84772 19.7142C6.7859 19.6678 6.72546 19.6192 6.66667 19.5684C6.60788 19.6192 6.54744 19.6678 6.48562 19.7142C5.81393 20.218 4.93183 20.5 4 20.5C3.44772 20.5 3 20.0523 3 19.5C3 18.9477 3.44772 18.5 4 18.5C4.54093 18.5 4.99216 18.3343 5.28562 18.1142C5.57876 17.8944 5.66667 17.667 5.66667 17.5C5.66667 16.9477 6.11438 16.5 6.66667 16.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289L14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L13 7.41421V10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10V7.41421L10.7071 7.70711C10.3166 8.09763 9.68342 8.09763 9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289L11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "water-arrow-up": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrow","up","increase","waves","sales","growth","revenue","trending","popularity","water"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L12 5L10 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "waterfall-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["waterfall","stream","flow","continuous","cascade","process","continuous-process","automatic"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18V9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 11L13 9" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 17L13 15" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14L10 12" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 17C3.44444 17.4303 5.07231 19.0532 7.33333 18.506C8.98284 18.1067 9.61202 18.2837 10.3254 18.6296C11.344 19.1235 12.656 19.1235 13.6746 18.6296C14.388 18.2837 15.0172 18.1067 16.6667 18.506C18.9277 19.0532 20.5556 17.4303 21 17"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 9L18 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "water-arrow-up-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["arrow-up","peak","surge","increase","rise","growth","sales-increase","trend-up"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 19C18.5272 19 17.3333 18.1046 17.3333 17C17.3333 18.1046 16.1394 19 14.6667 19C13.1939 19 12 18.1046 12 17C12 18.1046 10.8061 19 9.33333 19C7.86057 19 6.66667 18.1046 6.66667 17C6.66667 18.1046 5.47276 19 4 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 15C18.5272 15 17.3333 14.1046 17.3333 13C17.3333 14.1046 16.1394 15 14.6667 15C13.1939 15 12 14.1046 12 13C12 14.1046 10.8061 15 9.33333 15C7.86057 15 6.66667 14.1046 6.66667 13C6.66667 14.1046 5.47276 15 4 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 10V5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 7L12 5L10 7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "waterfall-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["waterfall","filtering","filter","options","advanced-search","configuration","settings","refresh","clean"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 12C11.5 11.4477 11.0523 11 10.5 11C9.94772 11 9.5 11.4477 9.5 12V13C9.5 13.5523 9.94772 14 10.5 14C11.0523 14 11.5 13.5523 11.5 13V12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.5 15C14.5 14.4477 14.0523 14 13.5 14C12.9477 14 12.5 14.4477 12.5 15V16C12.5 16.5523 12.9477 17 13.5 17C14.0523 17 14.5 16.5523 14.5 16V15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93417 4H14.0658C14.9523 3.99995 15.7161 3.99991 16.3278 4.08215C16.9833 4.17028 17.6117 4.36902 18.1213 4.87868C18.631 5.38835 18.8297 6.0167 18.9179 6.67221C19.0001 7.28388 19.0001 8.0477 19 8.9342L19 17.2598C19.6067 16.9522 20.0572 16.5209 20.3044 16.2815C20.7012 15.8974 21.3343 15.9076 21.7185 16.3044C22.1026 16.7012 22.0924 17.3343 21.6956 17.7185L21.6581 17.7549C21.1762 18.2248 19.2029 20.1487 16.4314 19.4779C15.6594 19.2911 15.2061 19.2597 14.9023 19.2849C14.6222 19.3082 14.4129 19.383 14.1109 19.5294C12.8167 20.1569 11.1833 20.1569 9.8891 19.5294C9.58714 19.383 9.37777 19.3082 9.09768 19.2849C8.7939 19.2597 8.34062 19.2911 7.56857 19.4779C4.79711 20.1487 2.82384 18.2248 2.34187 17.7549L2.30444 17.7185C1.90764 17.3343 1.89739 16.7012 2.28154 16.3044C2.66569 15.9076 3.29877 15.8974 3.69556 16.2815C3.94282 16.5209 4.39334 16.9522 5 17.2598L5 8.93417C4.99995 8.04769 4.99991 7.28387 5.08214 6.67221C5.17027 6.0167 5.36902 5.38835 5.87868 4.87868C6.38834 4.36902 7.01669 4.17028 7.67221 4.08215C8.28387 3.99991 9.04768 3.99995 9.93417 4ZM7 17.5561C7.03253 17.5493 7.06523 17.542 7.09809 17.534C7.97556 17.3217 8.66162 17.2419 9.26314 17.2918C9.88835 17.3437 10.3502 17.5303 10.7616 17.7298C11.5048 18.0901 12.4952 18.0901 13.2384 17.7298C13.6498 17.5303 14.1116 17.3437 14.7369 17.2918C15.3384 17.2419 16.0244 17.3217 16.9019 17.534C16.9348 17.542 16.9675 17.5493 17 17.5561V9H14.5V10C14.5 10.5523 14.0523 11 13.5 11C12.9477 11 12.5 10.5523 12.5 10V9L7 9V17.5561Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "waterfall-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["waterfall","stream","flow","water","nature","cascade","refresh","natural","eco","environment","outdoors","landscape"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18.595L6 9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5H14C15.8856 5 16.8284 5 17.4142 5.58579C18 6.17157 18 7.11438 18 9V18.595C17.5868 18.64 17.1406 18.6207 16.6667 18.506C15.0172 18.1067 14.388 18.2837 13.6746 18.6296C12.656 19.1235 11.344 19.1235 10.3254 18.6296C9.61202 18.2837 8.98284 18.1067 7.33333 18.506C6.85938 18.6207 6.41325 18.64 6 18.595Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path
                    d="M6 9H5.25H6ZM18 18.595L18.0812 19.3406L18 18.595ZM3.52167 16.4612C3.22407 16.173 2.74926 16.1807 2.46115 16.4783C2.17304 16.7759 2.18073 17.2507 2.47833 17.5388L3.52167 16.4612ZM7.33333 18.506L7.50976 19.2349H7.50976L7.33333 18.506ZM10.3254 18.6296L9.99816 19.3045L10.3254 18.6296ZM21.5217 17.5388C21.8193 17.2507 21.827 16.7759 21.5388 16.4783C21.2507 16.1807 20.7759 16.173 20.4783 16.4612L21.5217 17.5388ZM16.6667 18.506L16.4902 19.2349H16.4902L16.6667 18.506ZM13.6746 18.6296L14.0018 19.3045L13.6746 18.6296ZM5.25 9L5.25 18.595H6.75L6.75 9H5.25ZM6.75 9C6.75 8.03599 6.75159 7.38843 6.81654 6.90539C6.87858 6.44393 6.9858 6.24643 7.11612 6.11612L6.05546 5.05546C5.59999 5.51093 5.41432 6.07773 5.32991 6.70552C5.24841 7.31174 5.25 8.07839 5.25 9H6.75ZM10 4.25C9.07839 4.25 8.31174 4.24841 7.70552 4.32991C7.07773 4.41432 6.51093 4.59999 6.05546 5.05546L7.11612 6.11612C7.24643 5.9858 7.44393 5.87858 7.90539 5.81654C8.38843 5.75159 9.03599 5.75 10 5.75V4.25ZM17.25 9V18.595H18.75V9H17.25ZM14 4.25H10V5.75H14V4.25ZM18.75 9C18.75 8.07839 18.7516 7.31174 18.6701 6.70552C18.5857 6.07773 18.4 5.51093 17.9445 5.05546L16.8839 6.11612C17.0142 6.24643 17.1214 6.44393 17.1835 6.90539C17.2484 7.38843 17.25 8.03599 17.25 9H18.75ZM14 5.75C14.964 5.75 15.6116 5.75159 16.0946 5.81654C16.5561 5.87858 16.7536 5.9858 16.8839 6.11612L17.9445 5.05546C17.4891 4.59999 16.9223 4.41432 16.2945 4.32991C15.6883 4.24841 14.9216 4.25 14 4.25V5.75ZM2.47833 17.5388C2.82048 17.8701 4.07753 19.14 5.91876 19.3406L6.08125 17.8494C4.80616 17.7105 3.88208 16.8101 3.52167 16.4612L2.47833 17.5388ZM5.91876 19.3406C6.41451 19.3946 6.94798 19.3709 7.50976 19.2349L7.1569 17.777C6.77077 17.8705 6.41198 17.8855 6.08125 17.8494L5.91876 19.3406ZM7.50976 19.2349C8.29499 19.0449 8.77736 19.0075 9.11837 19.0358C9.4416 19.0626 9.68253 19.1514 9.99816 19.3045L10.6526 17.9547C10.2549 17.7619 9.82453 17.5893 9.24246 17.5409C8.67816 17.4941 8.02119 17.5678 7.1569 17.777L7.50976 19.2349ZM20.4783 16.4612C20.1179 16.8101 19.1938 17.7105 17.9188 17.8494L18.0812 19.3406C19.9225 19.14 21.1795 17.8701 21.5217 17.5388L20.4783 16.4612ZM17.9188 17.8494C17.588 17.8855 17.2292 17.8705 16.8431 17.777L16.4902 19.2349C17.052 19.3709 17.5855 19.3946 18.0812 19.3406L17.9188 17.8494ZM16.8431 17.777C15.9788 17.5678 15.3218 17.4941 14.7575 17.5409C14.1755 17.5893 13.7451 17.7619 13.3474 17.9547L14.0018 19.3045C14.3175 19.1514 14.5584 19.0626 14.8816 19.0358C15.2226 19.0075 15.705 19.0449 16.4902 19.2349L16.8431 17.777ZM9.99816 19.3045C11.2234 19.8985 12.7766 19.8985 14.0018 19.3045L13.3474 17.9547C12.5354 18.3484 11.4646 18.3484 10.6526 17.9547L9.99816 19.3045Z"
                    fill={colors?.[0] || "#D9D1E0"}
                />
                <path d="M13 11L13 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 17L13 15" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14L10 12" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 17C3.44444 17.4303 5.07231 19.0532 7.33333 18.506C8.98284 18.1067 9.61202 18.2837 10.3254 18.6296C11.344 19.1235 12.656 19.1235 13.6746 18.6296C14.388 18.2837 15.0172 18.1067 16.6667 18.506C18.9277 19.0532 20.5556 17.4303 21 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 9L18 9" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "wave-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wave","waves","flow","fluid","data-flow","refresh","reload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9C4.51511 9 5.09327 8.89046 5.59391 8.70075C6.20685 8.46848 7.12649 8.46848 7.73942 8.70075C8.24007 8.89046 8.81822 9 9.33333 9C9.84844 9 10.4266 8.89046 10.9272 8.70075C11.5402 8.46848 12.4598 8.46848 13.0728 8.70075C13.5734 8.89046 14.1516 9 14.6667 9C15.1818 9 15.7599 8.89046 16.2606 8.70075C16.8735 8.46848 17.7932 8.46848 18.4061 8.70075C18.9067 8.89046 19.4849 9 20 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13C4.51511 13 5.09327 12.8905 5.59391 12.7007C6.20685 12.4685 7.12649 12.4685 7.73942 12.7007C8.24007 12.8905 8.81822 13 9.33333 13C9.84844 13 10.4266 12.8905 10.9272 12.7007C11.5402 12.4685 12.4598 12.4685 13.0728 12.7007C13.5734 12.8905 14.1516 13 14.6667 13C15.1818 13 15.7599 12.8905 16.2606 12.7007C16.8735 12.4685 17.7932 12.4685 18.4061 12.7007C18.9067 12.8905 19.4849 13 20 13"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 17C4.51511 17 5.09327 16.8905 5.59391 16.7007C6.20685 16.4685 7.12649 16.4685 7.73942 16.7007C8.24007 16.8905 8.81822 17 9.33333 17C9.84844 17 10.4266 16.8905 10.9272 16.7007C11.5402 16.4685 12.4598 16.4685 13.0728 16.7007C13.5734 16.8905 14.1516 17 14.6667 17C15.1818 17 15.7599 16.8905 16.2606 16.7007C16.8735 16.4685 17.7932 16.4685 18.4061 16.7007C18.9067 16.8905 19.4849 17 20 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    waterfall: {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","waves","flow","fluid","data-flow","refresh","reload"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 18V9C6 7.11438 6 6.17157 6.58579 5.58579C7.17157 5 8.11438 5 10 5V5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 18V9C18 7.11438 18 6.17157 17.4142 5.58579C16.8284 5 15.8856 5 14 5H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M13 11L13 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13 17L13 15" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M10 14L10 12" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M3 17C3.44444 17.4303 5.07231 19.0532 7.33333 18.506C8.98284 18.1067 9.61202 18.2837 10.3254 18.6296C11.344 19.1235 12.656 19.1235 13.6746 18.6296C14.388 18.2837 15.0172 18.1067 16.6667 18.506C18.9277 19.0532 20.5556 17.4303 21 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 9L18 9" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "wave-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","water","ocean","sea","fluid","refresh","reset","flow","continuous","pattern","background","seafood","drinks"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 10C7.21895 10 7.66667 10.4477 7.66667 11C7.66667 11.167 7.75457 11.3944 8.04772 11.6142C8.34117 11.8343 8.7924 12 9.33333 12C9.87427 12 10.3255 11.8343 10.619 11.6142C10.9121 11.3944 11 11.167 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11C13 11.167 13.0879 11.3944 13.381 11.6142C13.6745 11.8343 14.1257 12 14.6667 12C15.2076 12 15.6588 11.8343 15.9523 11.6142C16.2454 11.3944 16.3333 11.167 16.3333 11C16.3333 10.4477 16.781 10 17.3333 10C17.8856 10 18.3333 10.4477 18.3333 11C18.3333 11.167 18.4212 11.3944 18.7144 11.6142C19.0078 11.8343 19.4591 12 20 12C20.5523 12 21 12.4477 21 13C21 13.5523 20.5523 14 20 14C19.0682 14 18.1861 13.718 17.5144 13.2142C17.4526 13.1678 17.3921 13.1192 17.3333 13.0684C17.2745 13.1192 17.2141 13.1678 17.1523 13.2142C16.4806 13.718 15.5985 14 14.6667 14C13.7348 14 12.8527 13.718 12.181 13.2142C12.1192 13.1678 12.0588 13.1192 12 13.0684C11.9412 13.1192 11.8808 13.1678 11.819 13.2142C11.1473 13.718 10.2652 14 9.33333 14C8.40151 14 7.5194 13.718 6.84772 13.2142C6.7859 13.1678 6.72546 13.1192 6.66667 13.0684C6.60788 13.1192 6.54744 13.1678 6.48562 13.2142C5.81393 13.718 4.93183 14 4 14C3.44772 14 3 13.5523 3 13C3 12.4477 3.44772 12 4 12C4.54093 12 4.99216 11.8343 5.28562 11.6142C5.57876 11.3944 5.66667 11.167 5.66667 11C5.66667 10.4477 6.11438 10 6.66667 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 5.5C7.21895 5.5 7.66667 5.94772 7.66667 6.5C7.66667 6.66696 7.75457 6.89435 8.04772 7.11421C8.34117 7.3343 8.7924 7.5 9.33333 7.5C9.87427 7.5 10.3255 7.3343 10.619 7.11421C10.9121 6.89435 11 6.66696 11 6.5C11 5.94772 11.4477 5.5 12 5.5C12.5523 5.5 13 5.94772 13 6.5C13 6.66696 13.0879 6.89435 13.381 7.11421C13.6745 7.3343 14.1257 7.5 14.6667 7.5C15.2076 7.5 15.6588 7.3343 15.9523 7.11421C16.2454 6.89435 16.3333 6.66696 16.3333 6.5C16.3333 5.94772 16.781 5.5 17.3333 5.5C17.8856 5.5 18.3333 5.94772 18.3333 6.5C18.3333 6.66696 18.4212 6.89435 18.7144 7.11421C19.0078 7.3343 19.4591 7.5 20 7.5C20.5523 7.5 21 7.94771 21 8.5C21 9.05228 20.5523 9.5 20 9.5C19.0682 9.5 18.1861 9.21798 17.5144 8.71421C17.4526 8.66785 17.3921 8.61921 17.3333 8.56838C17.2745 8.61921 17.2141 8.66785 17.1523 8.71421C16.4806 9.21798 15.5985 9.5 14.6667 9.5C13.7348 9.5 12.8527 9.21798 12.181 8.71421C12.1192 8.66785 12.0588 8.61921 12 8.56838C11.9412 8.61921 11.8808 8.66785 11.819 8.71421C11.1473 9.21798 10.2652 9.5 9.33333 9.5C8.40151 9.5 7.5194 9.21798 6.84772 8.71421C6.7859 8.66785 6.72546 8.61921 6.66667 8.56838C6.60788 8.61921 6.54744 8.66785 6.48562 8.71421C5.81393 9.21798 4.93183 9.5 4 9.5C3.44772 9.5 3 9.05228 3 8.5C3 7.94771 3.44772 7.5 4 7.5C4.54093 7.5 4.99216 7.3343 5.28562 7.11421C5.57876 6.89435 5.66667 6.66696 5.66667 6.5C5.66667 5.94772 6.11438 5.5 6.66667 5.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.66667 14.5C7.21895 14.5 7.66667 14.9477 7.66667 15.5C7.66667 15.667 7.75457 15.8944 8.04772 16.1142C8.34117 16.3343 8.7924 16.5 9.33333 16.5C9.87427 16.5 10.3255 16.3343 10.619 16.1142C10.9121 15.8944 11 15.667 11 15.5C11 14.9477 11.4477 14.5 12 14.5C12.5523 14.5 13 14.9477 13 15.5C13 15.667 13.0879 15.8944 13.381 16.1142C13.6745 16.3343 14.1257 16.5 14.6667 16.5C15.2076 16.5 15.6588 16.3343 15.9523 16.1142C16.2454 15.8944 16.3333 15.667 16.3333 15.5C16.3333 14.9477 16.781 14.5 17.3333 14.5C17.8856 14.5 18.3333 14.9477 18.3333 15.5C18.3333 15.667 18.4212 15.8944 18.7144 16.1142C19.0078 16.3343 19.4591 16.5 20 16.5C20.5523 16.5 21 16.9477 21 17.5C21 18.0523 20.5523 18.5 20 18.5C19.0682 18.5 18.1861 18.218 17.5144 17.7142C17.4526 17.6678 17.3921 17.6192 17.3333 17.5684C17.2745 17.6192 17.2141 17.6678 17.1523 17.7142C16.4806 18.218 15.5985 18.5 14.6667 18.5C13.7348 18.5 12.8527 18.218 12.181 17.7142C12.1192 17.6678 12.0588 17.6192 12 17.5684C11.9412 17.6192 11.8808 17.6678 11.819 17.7142C11.1473 18.218 10.2652 18.5 9.33333 18.5C8.40151 18.5 7.5194 18.218 6.84772 17.7142C6.7859 17.6678 6.72546 17.6192 6.66667 17.5684C6.60788 17.6192 6.54744 17.6678 6.48562 17.7142C5.81393 18.218 4.93183 18.5 4 18.5C3.44772 18.5 3 18.0523 3 17.5C3 16.9477 3.44772 16.5 4 16.5C4.54093 16.5 4.99216 16.3343 5.28562 16.1142C5.57876 15.8944 5.66667 15.667 5.66667 15.5C5.66667 14.9477 6.11438 14.5 6.66667 14.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wave-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wave","waves","sound","volume","settings","configuration","wifi","signal","customer-flow","intensity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9C4.51511 9 5.09327 8.89046 5.59391 8.70075C6.20685 8.46848 7.12649 8.46848 7.73942 8.70075C8.24007 8.89046 8.81822 9 9.33333 9C9.84844 9 10.4266 8.89046 10.9272 8.70075C11.5402 8.46848 12.4598 8.46848 13.0728 8.70075C13.5734 8.89046 14.1516 9 14.6667 9C15.1818 9 15.7599 8.89046 16.2606 8.70075C16.8735 8.46848 17.7932 8.46848 18.4061 8.70075C18.9067 8.89046 19.4849 9 20 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13C4.51511 13 5.09327 12.8905 5.59391 12.7007C6.20685 12.4685 7.12649 12.4685 7.73942 12.7007C8.24007 12.8905 8.81822 13 9.33333 13C9.84844 13 10.4266 12.8905 10.9272 12.7007C11.5402 12.4685 12.4598 12.4685 13.0728 12.7007C13.5734 12.8905 14.1516 13 14.6667 13C15.1818 13 15.7599 12.8905 16.2606 12.7007C16.8735 12.4685 17.7932 12.4685 18.4061 12.7007C18.9067 12.8905 19.4849 13 20 13"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 17C4.51511 17 5.09327 16.8905 5.59391 16.7007C6.20685 16.4685 7.12649 16.4685 7.73942 16.7007C8.24007 16.8905 8.81822 17 9.33333 17C9.84844 17 10.4266 16.8905 10.9272 16.7007C11.5402 16.4685 12.4598 16.4685 13.0728 16.7007C13.5734 16.8905 14.1516 17 14.6667 17C15.1818 17 15.7599 16.8905 16.2606 16.7007C16.8735 16.4685 17.7932 16.4685 18.4061 16.7007C18.9067 16.8905 19.4849 17 20 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["waves","flow","water","refresh","fluid","liquids","beverages","humidity","refreshments"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3333 7.52661C17.8046 7.52661 18.3135 7.59635 18.7604 7.7657C19.1542 7.9149 19.6125 8.00006 20 8.00006C20.5523 8.00006 21 8.44778 21 9.00006C21 9.55235 20.5523 10.0001 20 10.0001C19.3572 10.0001 18.6593 9.86614 18.0517 9.63592C17.8857 9.57301 17.6284 9.52661 17.3333 9.52661C17.0383 9.52661 16.781 9.57301 16.6149 9.63592C16.0074 9.86614 15.3094 10.0001 14.6667 10.0001C14.0239 10.0001 13.3259 9.86614 12.7184 9.63592C12.5524 9.57301 12.2951 9.52661 12 9.52661C11.7049 9.52661 11.4476 9.57301 11.2816 9.63592C10.6741 9.86614 9.97609 10.0001 9.33333 10.0001C8.69058 10.0001 7.99261 9.86614 7.38507 9.63592C7.21904 9.57301 6.96173 9.52661 6.66667 9.52661C6.3716 9.52661 6.11429 9.57301 5.94826 9.63592C5.34072 9.86614 4.64276 10.0001 4 10.0001C3.44772 10.0001 3 9.55235 3 9.00006C3 8.44778 3.44772 8.00006 4 8.00006C4.38746 8.00006 4.84582 7.9149 5.23956 7.7657C5.68646 7.59635 6.19545 7.52661 6.66667 7.52661C7.13789 7.52661 7.64687 7.59635 8.09377 7.7657C8.48752 7.9149 8.94587 8.00006 9.33333 8.00006C9.7208 8.00006 10.1791 7.9149 10.5729 7.7657C11.0198 7.59635 11.5288 7.52661 12 7.52661C12.4712 7.52661 12.9802 7.59635 13.4271 7.7657C13.8209 7.9149 14.2792 8.00006 14.6667 8.00006C15.0541 8.00006 15.5125 7.9149 15.9062 7.7657C16.3531 7.59635 16.8621 7.52661 17.3333 7.52661Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3333 11.5266C17.8046 11.5266 18.3135 11.5963 18.7604 11.7657C19.1542 11.9149 19.6125 12.0001 20 12.0001C20.5523 12.0001 21 12.4478 21 13.0001C21 13.5523 20.5523 14.0001 20 14.0001C19.3572 14.0001 18.6593 13.8661 18.0517 13.6359C17.8857 13.573 17.6284 13.5266 17.3333 13.5266C17.0383 13.5266 16.781 13.573 16.6149 13.6359C16.0074 13.8661 15.3094 14.0001 14.6667 14.0001C14.0239 14.0001 13.3259 13.8661 12.7184 13.6359C12.5524 13.573 12.2951 13.5266 12 13.5266C11.7049 13.5266 11.4476 13.573 11.2816 13.6359C10.6741 13.8661 9.97609 14.0001 9.33333 14.0001C8.69058 14.0001 7.99261 13.8661 7.38507 13.6359C7.21904 13.573 6.96173 13.5266 6.66667 13.5266C6.3716 13.5266 6.11429 13.573 5.94826 13.6359C5.34072 13.8661 4.64276 14.0001 4 14.0001C3.44772 14.0001 3 13.5523 3 13.0001C3 12.4478 3.44772 12.0001 4 12.0001C4.38746 12.0001 4.84582 11.9149 5.23956 11.7657C5.68646 11.5963 6.19545 11.5266 6.66667 11.5266C7.13789 11.5266 7.64687 11.5963 8.09377 11.7657C8.48752 11.9149 8.94587 12.0001 9.33333 12.0001C9.7208 12.0001 10.1791 11.9149 10.5729 11.7657C11.0198 11.5963 11.5288 11.5266 12 11.5266C12.4712 11.5266 12.9802 11.5963 13.4271 11.7657C13.8209 11.9149 14.2792 12.0001 14.6667 12.0001C15.0541 12.0001 15.5125 11.9149 15.9062 11.7657C16.3531 11.5963 16.8621 11.5266 17.3333 11.5266Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3333 15.5266C17.8046 15.5266 18.3135 15.5963 18.7604 15.7657C19.1542 15.9149 19.6125 16.0001 20 16.0001C20.5523 16.0001 21 16.4478 21 17.0001C21 17.5523 20.5523 18.0001 20 18.0001C19.3572 18.0001 18.6593 17.8661 18.0517 17.6359C17.8857 17.573 17.6284 17.5266 17.3333 17.5266C17.0383 17.5266 16.781 17.573 16.6149 17.6359C16.0074 17.8661 15.3094 18.0001 14.6667 18.0001C14.0239 18.0001 13.3259 17.8661 12.7184 17.6359C12.5524 17.573 12.2951 17.5266 12 17.5266C11.7049 17.5266 11.4476 17.573 11.2816 17.6359C10.6741 17.8661 9.97609 18.0001 9.33333 18.0001C8.69058 18.0001 7.99261 17.8661 7.38507 17.6359C7.21904 17.573 6.96173 17.5266 6.66667 17.5266C6.3716 17.5266 6.11429 17.573 5.94826 17.6359C5.34072 17.8661 4.64276 18.0001 4 18.0001C3.44772 18.0001 3 17.5523 3 17.0001C3 16.4478 3.44772 16.0001 4 16.0001C4.38746 16.0001 4.84582 15.9149 5.23956 15.7657C5.68646 15.5963 6.19545 15.5266 6.66667 15.5266C7.13789 15.5266 7.64687 15.5963 8.09377 15.7657C8.48752 15.9149 8.94587 16.0001 9.33333 16.0001C9.7208 16.0001 10.1791 15.9149 10.5729 15.7657C11.0198 15.5963 11.5288 15.5266 12 15.5266C12.4712 15.5266 12.9802 15.5963 13.4271 15.7657C13.8209 15.9149 14.2792 16.0001 14.6667 16.0001C15.0541 16.0001 15.5125 15.9149 15.9062 15.7657C16.3531 15.5963 16.8621 15.5266 17.3333 15.5266Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wave-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","refresh","sync","update","transaction-history","fluctuations","flow","movement"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8L5.4179 7.43284C6.08667 7.16533 6.84762 7.2781 7.41007 7.72806L7.85803 8.08642C8.53813 8.6305 9.49214 8.67191 10.2168 8.18879L10.8906 7.7396C11.5624 7.29173 12.4376 7.29173 13.1094 7.7396L13.7832 8.18879C14.5079 8.67191 15.4619 8.63051 16.142 8.08642L16.5899 7.72806C17.1524 7.2781 17.9133 7.16533 18.5821 7.43284L20 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5.4179 11.4328C6.08667 11.1653 6.84762 11.2781 7.41007 11.7281L7.85803 12.0864C8.53813 12.6305 9.49214 12.6719 10.2168 12.1888L10.8906 11.7396C11.5624 11.2917 12.4376 11.2917 13.1094 11.7396L13.7832 12.1888C14.5079 12.6719 15.4619 12.6305 16.142 12.0864L16.5899 11.7281C17.1524 11.2781 17.9133 11.1653 18.5821 11.4328L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L5.4179 15.4328C6.08667 15.1653 6.84762 15.2781 7.41007 15.7281L7.85803 16.0864C8.53813 16.6305 9.49214 16.6719 10.2168 16.1888L10.8906 15.7396C11.5624 15.2917 12.4376 15.2917 13.1094 15.7396L13.7832 16.1888C14.5079 16.6719 15.4619 16.6305 16.142 16.0864L16.5899 15.7281C17.1524 15.2781 17.9133 15.1653 18.5821 15.4328L20 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wave","level","signal","intensity","refresh","sync","data-transfer","motion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8L5.4179 7.43284C6.08667 7.16533 6.84762 7.2781 7.41007 7.72806L7.85803 8.08642C8.53813 8.6305 9.49214 8.67191 10.2168 8.18879L10.8906 7.7396C11.5624 7.29173 12.4376 7.29173 13.1094 7.7396L13.7832 8.18879C14.5079 8.67191 15.4619 8.63051 16.142 8.08642L16.5899 7.72806C17.1524 7.2781 17.9133 7.16533 18.5821 7.43284L20 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5.4179 11.4328C6.08667 11.1653 6.84762 11.2781 7.41007 11.7281L7.85803 12.0864C8.53813 12.6305 9.49214 12.6719 10.2168 12.1888L10.8906 11.7396C11.5624 11.2917 12.4376 11.2917 13.1094 11.7396L13.7832 12.1888C14.5079 12.6719 15.4619 12.6305 16.142 12.0864L16.5899 11.7281C17.1524 11.2781 17.9133 11.1653 18.5821 11.4328L20 12"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L5.4179 15.4328C6.08667 15.1653 6.84762 15.2781 7.41007 15.7281L7.85803 16.0864C8.53813 16.6305 9.49214 16.6719 10.2168 16.1888L10.8906 15.7396C11.5624 15.2917 12.4376 15.2917 13.1094 15.7396L13.7832 16.1888C14.5079 16.6719 15.4619 16.6305 16.142 16.0864L16.5899 15.7281C17.1524 15.2781 17.9133 15.1653 18.5821 15.4328L20 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wave","sea","water","refresh","ocean","flow","fluid","refreshments","drinks"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 8L5.4179 7.43284C6.08667 7.16533 6.84762 7.2781 7.41007 7.72806L7.85803 8.08642C8.53813 8.6305 9.49214 8.67191 10.2168 8.18879L10.8906 7.7396C11.5624 7.29173 12.4376 7.29173 13.1094 7.7396L13.7832 8.18879C14.5079 8.67191 15.4619 8.63051 16.142 8.08642L16.5899 7.72806C17.1524 7.2781 17.9133 7.16533 18.5821 7.43284L20 8"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L5.4179 11.4328C6.08667 11.1653 6.84762 11.2781 7.41007 11.7281L7.85803 12.0864C8.53813 12.6305 9.49214 12.6719 10.2168 12.1888L10.8906 11.7396C11.5624 11.2917 12.4376 11.2917 13.1094 11.7396L13.7832 12.1888C14.5079 12.6719 15.4619 12.6305 16.142 12.0864L16.5899 11.7281C17.1524 11.2781 17.9133 11.1653 18.5821 11.4328L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 16L5.4179 15.4328C6.08667 15.1653 6.84762 15.2781 7.41007 15.7281L7.85803 16.0864C8.53813 16.6305 9.49214 16.6719 10.2168 16.1888L10.8906 15.7396C11.5624 15.2917 12.4376 15.2917 13.1094 15.7396L13.7832 16.1888C14.5079 16.6719 15.4619 16.6305 16.142 16.0864L16.5899 15.7281C17.1524 15.2781 17.9133 15.1653 18.5821 15.4328L20 16"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["wave","water","refresh","update","flow","sync"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.7854 8.50896C6.50417 8.28398 6.1237 8.2276 5.78931 8.36135L4.37141 8.92851C3.85863 9.13363 3.27666 8.88421 3.07155 8.37143C2.86643 7.85864 3.11585 7.27667 3.62863 7.07156L5.04653 6.5044C6.04968 6.10314 7.19111 6.27228 8.03479 6.94722L8.48275 7.30559C8.8228 7.57763 9.2998 7.59833 9.66214 7.35677L10.3359 6.90758C11.3436 6.23579 12.6564 6.23579 13.6641 6.90758L14.3379 7.35677C14.7002 7.59833 15.1772 7.57763 15.5173 7.30559L15.9653 6.94722C16.8089 6.27228 17.9504 6.10314 18.9535 6.5044L20.3714 7.07156C20.8842 7.27667 21.1336 7.85864 20.9285 8.37143C20.7234 8.88421 20.1414 9.13363 19.6286 8.92851L18.2107 8.36135C17.8763 8.2276 17.4959 8.28398 17.2146 8.50896L16.7667 8.86733C15.7465 9.68345 14.3155 9.74555 13.2285 9.02087L12.5547 8.57169C12.2188 8.34775 11.7812 8.34775 11.4453 8.57169L10.7715 9.02087C9.68452 9.74555 8.25351 9.68345 7.23336 8.86733L6.7854 8.50896Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.7854 12.509C6.50417 12.284 6.1237 12.2276 5.78931 12.3614L4.37141 12.9285C3.85863 13.1336 3.27666 12.8842 3.07155 12.3714C2.86643 11.8586 3.11585 11.2767 3.62863 11.0716L5.04653 10.5044C6.04968 10.1031 7.19111 10.2723 8.03479 10.9472L8.48275 11.3056C8.8228 11.5776 9.2998 11.5983 9.66214 11.3568L10.3359 10.9076C11.3436 10.2358 12.6564 10.2358 13.6641 10.9076L14.3379 11.3568C14.7002 11.5983 15.1772 11.5776 15.5173 11.3056L15.9653 10.9472C16.8089 10.2723 17.9504 10.1031 18.9535 10.5044L20.3714 11.0716C20.8842 11.2767 21.1336 11.8586 20.9285 12.3714C20.7234 12.8842 20.1414 13.1336 19.6286 12.9285L18.2107 12.3614C17.8763 12.2276 17.4959 12.284 17.2146 12.509L16.7667 12.8673C15.7465 13.6834 14.3155 13.7456 13.2285 13.0209L12.5547 12.5717C12.2188 12.3478 11.7812 12.3478 11.4453 12.5717L10.7715 13.0209C9.68452 13.7456 8.25351 13.6834 7.23336 12.8673L6.7854 12.509Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.7854 16.509C6.50417 16.284 6.1237 16.2276 5.78931 16.3614L4.37141 16.9285C3.85863 17.1336 3.27666 16.8842 3.07155 16.3714C2.86643 15.8586 3.11585 15.2767 3.62863 15.0716L5.04653 14.5044C6.04968 14.1031 7.19111 14.2723 8.03479 14.9472L8.48275 15.3056C8.8228 15.5776 9.2998 15.5983 9.66214 15.3568L10.3359 14.9076C11.3436 14.2358 12.6564 14.2358 13.6641 14.9076L14.3379 15.3568C14.7002 15.5983 15.1772 15.5776 15.5173 15.3056L15.9653 14.9472C16.8089 14.2723 17.9504 14.1031 18.9535 14.5044L20.3714 15.0716C20.8842 15.2767 21.1336 15.8586 20.9285 16.3714C20.7234 16.8842 20.1414 17.1336 19.6286 16.9285L18.2107 16.3614C17.8763 16.2276 17.4959 16.284 17.2146 16.509L16.7667 16.8673C15.7465 17.6834 14.3155 17.7456 13.2285 17.0209L12.5547 16.5717C12.2188 16.3478 11.7812 16.3478 11.4453 16.5717L10.7715 17.0209C9.68452 17.7456 8.25351 17.6834 7.23336 16.8673L6.7854 16.509Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wave-10": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wave","waves","water","drink","beverage","refreshment","flow","refresh"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C18.5272 13 17.3333 12.1046 17.3333 11C17.3333 12.1046 16.1394 13 14.6667 13C13.1939 13 12 12.1046 12 11C12 12.1046 10.8061 13 9.33333 13C7.86057 13 6.66667 12.1046 6.66667 11C6.66667 12.1046 5.47276 13 4 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9C18.5272 9 17.3333 8.10457 17.3333 7C17.3333 8.10457 16.1394 9 14.6667 9C13.1939 9 12 8.10457 12 7C12 8.10457 10.8061 9 9.33333 9C7.86057 9 6.66667 8.10457 6.66667 7C6.66667 8.10457 5.47276 9 4 9"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17C18.5272 17 17.3333 16.1046 17.3333 15C17.3333 16.1046 16.1394 17 14.6667 17C13.1939 17 12 16.1046 12 15C12 16.1046 10.8061 17 9.33333 17C7.86057 17 6.66667 16.1046 6.66667 15C6.66667 16.1046 5.47276 17 4 17"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wave","water","ocean","sea","refresh","beverage","drink","liquid","humidity","weather"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C18.5272 13 17.3333 12.1046 17.3333 11C17.3333 12.1046 16.1394 13 14.6667 13C13.1939 13 12 12.1046 12 11C12 12.1046 10.8061 13 9.33333 13C7.86057 13 6.66667 12.1046 6.66667 11C6.66667 12.1046 5.47276 13 4 13"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9C18.5272 9 17.3333 8.10457 17.3333 7C17.3333 8.10457 16.1394 9 14.6667 9C13.1939 9 12 8.10457 12 7C12 8.10457 10.8061 9 9.33333 9C7.86057 9 6.66667 8.10457 6.66667 7C6.66667 8.10457 5.47276 9 4 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17C18.5272 17 17.3333 16.1046 17.3333 15C17.3333 16.1046 16.1394 17 14.6667 17C13.1939 17 12 16.1046 12 15C12 16.1046 10.8061 17 9.33333 17C7.86057 17 6.66667 16.1046 6.66667 15C6.66667 16.1046 5.47276 17 4 17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wave-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["waves","water","refresh","aquatic","liquids","beverages","drinks","flow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 13C18.5272 13 17.3333 12.1046 17.3333 11C17.3333 12.1046 16.1394 13 14.6667 13C13.1939 13 12 12.1046 12 11C12 12.1046 10.8061 13 9.33333 13C7.86057 13 6.66667 12.1046 6.66667 11C6.66667 12.1046 5.47276 13 4 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 9C18.5272 9 17.3333 8.10457 17.3333 7C17.3333 8.10457 16.1394 9 14.6667 9C13.1939 9 12 8.10457 12 7C12 8.10457 10.8061 9 9.33333 9C7.86057 9 6.66667 8.10457 6.66667 7C6.66667 8.10457 5.47276 9 4 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 17C18.5272 17 17.3333 16.1046 17.3333 15C17.3333 16.1046 16.1394 17 14.6667 17C13.1939 17 12 16.1046 12 15C12 16.1046 10.8061 17 9.33333 17C7.86057 17 6.66667 16.1046 6.66667 15C6.66667 16.1046 5.47276 17 4 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "web-cam-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["webcam","camera","security","surveillance","monitoring","video","record","customer-identification","fraud-prevention","age-verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17L14.5528 18.1056C15.2014 19.4028 15.5257 20.0515 15.2326 20.5257C14.9395 21 14.2143 21 12.7639 21L12 21L11.2361 21C9.78569 21 9.0605 21 8.76738 20.5257C8.47427 20.0515 8.79858 19.4028 9.44721 18.1056L10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8C10.3431 8 9 9.34321 9 11.0001C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11.0001C15 9.34321 13.6569 8 12 8Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    wave: {
        defaultColors: ["#3D4C66"],
        keywords: ["webcam","camera","security","surveillance","monitoring","video","record","customer-identification","fraud-prevention","age-verification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 9C4.51511 9 5.09327 8.89046 5.59391 8.70075C6.20685 8.46848 7.12649 8.46848 7.73942 8.70075C8.24007 8.89046 8.81822 9 9.33333 9C9.84844 9 10.4266 8.89046 10.9272 8.70075C11.5402 8.46848 12.4598 8.46848 13.0728 8.70075C13.5734 8.89046 14.1516 9 14.6667 9C15.1818 9 15.7599 8.89046 16.2606 8.70075C16.8735 8.46848 17.7932 8.46848 18.4061 8.70075C18.9067 8.89046 19.4849 9 20 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 13C4.51511 13 5.09327 12.8905 5.59391 12.7007C6.20685 12.4685 7.12649 12.4685 7.73942 12.7007C8.24007 12.8905 8.81822 13 9.33333 13C9.84844 13 10.4266 12.8905 10.9272 12.7007C11.5402 12.4685 12.4598 12.4685 13.0728 12.7007C13.5734 12.8905 14.1516 13 14.6667 13C15.1818 13 15.7599 12.8905 16.2606 12.7007C16.8735 12.4685 17.7932 12.4685 18.4061 12.7007C18.9067 12.8905 19.4849 13 20 13"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 17C4.51511 17 5.09327 16.8905 5.59391 16.7007C6.20685 16.4685 7.12649 16.4685 7.73942 16.7007C8.24007 16.8905 8.81822 17 9.33333 17C9.84844 17 10.4266 16.8905 10.9272 16.7007C11.5402 16.4685 12.4598 16.4685 13.0728 16.7007C13.5734 16.8905 14.1516 17 14.6667 17C15.1818 17 15.7599 16.8905 16.2606 16.7007C16.8735 16.4685 17.7932 16.4685 18.4061 16.7007C18.9067 16.8905 19.4849 17 20 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "web-cam-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["webcam","camera","video","security","surveillance","monitoring","face-scan","facial-recognition","identity","verification","customer-identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9294 4H13.0706C14.4247 3.99997 15.5413 3.99994 16.4251 4.11876C17.3529 4.2435 18.1723 4.51547 18.8284 5.17158C19.4845 5.82769 19.7565 6.64711 19.8813 7.57494C20.0001 8.45868 20 9.57534 20 10.9294V11.0707C20 12.4247 20.0001 13.5413 19.8813 14.4251C19.7565 15.3529 19.4845 16.1723 18.8284 16.8284C18.1723 17.4845 17.3529 17.7565 16.4251 17.8813C16.1686 17.9157 15.8925 17.9402 15.5967 17.9576C15.8465 18.4595 16.0674 18.9194 16.1963 19.3133C16.355 19.7983 16.4619 20.4389 16.0833 21.0515C15.7047 21.6641 15.0839 21.8549 14.5792 21.9299C14.1057 22.0002 13.4988 22.0001 12.8346 22H11.1655C10.5013 22.0001 9.89436 22.0002 9.42092 21.9299C8.91616 21.8549 8.29538 21.6641 7.91678 21.0515C7.53818 20.4389 7.64509 19.7983 7.80378 19.3133C7.93268 18.9194 8.15355 18.4595 8.40338 17.9576C8.10754 17.9402 7.83143 17.9157 7.57494 17.8813C6.64711 17.7565 5.82769 17.4845 5.17158 16.8284C4.51547 16.1723 4.2435 15.3529 4.11876 14.4251C3.99994 13.5413 3.99997 12.4247 4 11.0706V10.9294C3.99997 9.57531 3.99994 8.45868 4.11876 7.57494C4.2435 6.64711 4.51547 5.82769 5.17158 5.17158C5.82769 4.51547 6.64711 4.2435 7.57494 4.11876C8.45868 3.99994 9.57535 3.99997 10.9294 4ZM8 11.0001C8 8.79096 9.79083 7 12 7C14.2092 7 16 8.79096 16 11.0001C16 13.2092 14.2091 15 12 15C9.79089 15 8 13.2092 8 11.0001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "web-cam": {
        defaultColors: ["#3D4C66"],
        keywords: ["webcam","camera","security","surveillance","video","monitor","recording","customer-identification","facial-recognition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 17L14.5528 18.1056C15.2014 19.4028 15.5257 20.0515 15.2326 20.5257C14.9395 21 14.2143 21 12.7639 21L12 21L11.2361 21C9.78569 21 9.0605 21 8.76738 20.5257C8.47427 20.0515 8.79858 19.4028 9.44721 18.1056L10 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 8C10.3431 8 9 9.34321 9 11.0001C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11.0001C15 9.34321 13.6569 8 12 8Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "whatsapp-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["whatsapp","message","chat","customer-service","communication","contact","support","phone","call","order-update","promotion"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0015 20C15.5621 19.9993 18.6936 17.6451 19.6838 14.2248C20.674 10.8045 19.2845 7.1414 16.2751 5.23839C13.2656 3.33538 9.36075 3.65061 6.6955 6.01171C4.03026 8.37282 3.24629 12.2114 4.77225 15.4286L4.00223 18.8571H7.87834C9.12271 19.6072 10.5486 20.0024 12.0015 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00008 9.70438L7.2501 9.70003L8.00008 9.70438ZM12.5716 14.2725L13.3216 14.2783L13.3216 14.2761L12.5716 14.2725ZM15.4927 15.5031L14.9647 14.9705L15.4927 15.5031ZM15.8713 13.6339L15.1776 13.9191H15.1776L15.8713 13.6339ZM14.2875 12.5714L14.2846 13.3214L14.2868 13.3214L14.2875 12.5714ZM9.69947 11.4286L9.69294 12.1785L9.69657 12.1786L9.69947 11.4286ZM9.71934 8.00001L9.71718 8.75L9.71934 8.00001ZM11.4287 9.71425L12.1787 9.71785L12.1787 9.71422L11.4287 9.71425ZM7.25651 9.80231C7.52074 11.8085 8.19206 13.4186 9.27935 14.5831C10.373 15.7544 11.8278 16.4107 13.533 16.6104L13.7075 15.1206C12.2924 14.9548 11.1871 14.4284 10.3757 13.5594C9.55798 12.6836 8.97934 11.3958 8.74366 9.60644L7.25651 9.80231ZM11.8216 14.2668C11.814 15.2649 12.4091 16.1691 13.3291 16.5567L13.9114 15.1743C13.5515 15.0227 13.3186 14.6689 13.3216 14.2783L11.8216 14.2668ZM13.3291 16.5567C14.249 16.9442 15.3118 16.7385 16.0207 16.0357L14.9647 14.9705C14.6873 15.2455 14.2714 15.326 13.9114 15.1743L13.3291 16.5567ZM16.0207 16.0357C16.7296 15.333 16.9445 14.272 16.565 13.3487L15.1776 13.9191C15.3262 14.2803 15.2421 14.6955 14.9647 14.9705L16.0207 16.0357ZM16.565 13.3487C16.1855 12.4255 15.2864 11.8224 14.2882 11.8214L14.2868 13.3214C14.6774 13.3218 15.0291 13.5578 15.1776 13.9191L16.565 13.3487ZM14.2904 11.8214C12.9331 11.8162 11.8281 12.9116 11.8216 14.2689L13.3216 14.2761C13.3241 13.7467 13.7551 13.3194 14.2846 13.3214L14.2904 11.8214ZM9.70601 10.6786C9.17454 10.674 8.74699 10.2402 8.75007 9.70872L7.2501 9.70003C7.24223 11.0582 8.33483 12.1667 9.69294 12.1785L9.70601 10.6786ZM8.75007 9.70872C8.75315 9.17728 9.1857 8.74847 9.71718 8.75L9.7215 7.25001C8.36335 7.2461 7.25797 8.34183 7.2501 9.70003L8.75007 9.70872ZM9.71718 8.75C10.2486 8.75153 10.6787 9.18279 10.6787 9.71428L12.1787 9.71422C12.1786 8.35603 11.0797 7.25392 9.7215 7.25001L9.71718 8.75ZM10.6787 9.71064C10.6761 10.2474 10.2391 10.6806 9.70237 10.6786L9.69657 12.1786C11.0612 12.1838 12.1721 11.0825 12.1787 9.71785L10.6787 9.71064Z"
                    fill={colors?.[1] || "#2797E8"}
                />
            </svg>
        )
    },
    "whatsapp-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["phone","call","contact","customer-service","support","communication","chat","talk","telephone","message"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0015 20C15.5621 19.9993 18.6936 17.6451 19.6838 14.2248C20.674 10.8045 19.2845 7.1414 16.2751 5.23839C13.2656 3.33538 9.36075 3.65061 6.6955 6.01171C4.03026 8.37282 3.24629 12.2114 4.77225 15.4286L4.00223 18.8571H7.87834C9.12271 19.6072 10.5486 20.0024 12.0015 20Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5716 14.2725C12.5663 14.9669 12.9803 15.5959 13.6202 15.8655C14.2602 16.1351 14.9996 15.992 15.4927 15.5031C15.9858 15.0142 16.1353 14.2761 15.8713 13.6339C15.6073 12.9917 14.9819 12.5721 14.2875 12.5714C13.3441 12.5678 12.5761 13.3291 12.5716 14.2725Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.69947 11.4286C8.75469 11.4203 7.99461 10.6492 8.00008 9.70438C8.00556 8.75956 8.77452 7.99729 9.71934 8.00001C10.6642 8.00273 11.4287 8.76941 11.4287 9.71425C11.4241 10.665 10.6502 11.4322 9.69947 11.4286Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
                <path
                    d="M8.00008 9.70438L7.2501 9.70003L8.00008 9.70438ZM12.5716 14.2725L13.3216 14.2783L13.3216 14.2761L12.5716 14.2725ZM15.4927 15.5031L14.9647 14.9705L15.4927 15.5031ZM15.8713 13.6339L15.1776 13.9191H15.1776L15.8713 13.6339ZM14.2875 12.5714L14.2846 13.3214L14.2868 13.3214L14.2875 12.5714ZM9.69947 11.4286L9.69294 12.1785L9.69657 12.1786L9.69947 11.4286ZM9.71934 8.00001L9.71718 8.75L9.71934 8.00001ZM11.4287 9.71425L12.1787 9.71785L12.1787 9.71422L11.4287 9.71425ZM7.25651 9.80231C7.52074 11.8085 8.19206 13.4186 9.27935 14.5831C10.373 15.7544 11.8278 16.4107 13.533 16.6104L13.7075 15.1206C12.2924 14.9548 11.1871 14.4284 10.3757 13.5594C9.55798 12.6836 8.97934 11.3958 8.74366 9.60644L7.25651 9.80231ZM11.8216 14.2668C11.814 15.2649 12.4091 16.1691 13.3291 16.5567L13.9114 15.1743C13.5515 15.0227 13.3186 14.6689 13.3216 14.2783L11.8216 14.2668ZM13.3291 16.5567C14.249 16.9442 15.3118 16.7385 16.0207 16.0357L14.9647 14.9705C14.6873 15.2455 14.2714 15.326 13.9114 15.1743L13.3291 16.5567ZM16.0207 16.0357C16.7296 15.333 16.9445 14.272 16.565 13.3487L15.1776 13.9191C15.3262 14.2803 15.2421 14.6955 14.9647 14.9705L16.0207 16.0357ZM16.565 13.3487C16.1855 12.4255 15.2864 11.8224 14.2882 11.8214L14.2868 13.3214C14.6774 13.3218 15.0291 13.5578 15.1776 13.9191L16.565 13.3487ZM14.2904 11.8214C12.9331 11.8162 11.8281 12.9116 11.8216 14.2689L13.3216 14.2761C13.3241 13.7467 13.7551 13.3194 14.2846 13.3214L14.2904 11.8214ZM9.70601 10.6786C9.17454 10.674 8.74699 10.2402 8.75007 9.70872L7.2501 9.70003C7.24223 11.0582 8.33483 12.1667 9.69294 12.1785L9.70601 10.6786ZM8.75007 9.70872C8.75315 9.17728 9.1857 8.74847 9.71718 8.75L9.7215 7.25001C8.36335 7.2461 7.25797 8.34183 7.2501 9.70003L8.75007 9.70872ZM9.71718 8.75C10.2486 8.75153 10.6787 9.18279 10.6787 9.71428L12.1787 9.71422C12.1786 8.35603 11.0797 7.25392 9.7215 7.25001L9.71718 8.75ZM10.6787 9.71064C10.6761 10.2474 10.2391 10.6806 9.70237 10.6786L9.69657 12.1786C11.0612 12.1838 12.1721 11.0825 12.1787 9.71785L10.6787 9.71064Z"
                    fill={colors?.[1] || "#3D4C66"}
                />
            </svg>
        )
    },
    "whatsapp-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","communication","customer-service","contact","support","call","whatsapp"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.05338 9.98573C9.03504 9.8776 9.01805 9.76735 9.00244 9.65492C9.03273 9.28722 9.3413 8.99892 9.71641 9C10.1093 9.00113 10.4273 9.31928 10.4286 9.71187C10.4254 10.1088 10.1026 10.4288 9.70571 10.4286C9.4106 10.425 9.15911 10.2428 9.05338 9.98573Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M13.5715 14.2773C13.5734 13.8859 13.8921 13.5699 14.2836 13.5714L14.2865 13.5714C14.5758 13.5717 14.8364 13.7465 14.9464 14.0141C15.0564 14.2817 14.9941 14.5892 14.7886 14.7929C14.5832 14.9966 14.275 15.0563 14.0084 14.9439C13.7418 14.8316 13.5693 14.5696 13.5715 14.2802L13.5715 14.2773Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.03244 5.2632C9.03087 2.60693 13.4239 2.25229 16.8096 4.3932C20.1952 6.5341 21.7583 10.6551 20.6444 14.5029C19.5304 18.3508 16.0075 20.9992 12.0018 21C10.4622 21.0023 8.9496 20.608 7.60913 19.8571H4.00228C3.69856 19.8571 3.41131 19.7191 3.22153 19.482C3.03175 19.2449 2.96003 18.9343 3.02658 18.638L3.72353 15.5348C2.206 11.9843 3.12255 7.84104 6.03244 5.2632ZM12.4286 9.71906C12.4217 11.1659 11.2872 12.344 9.86154 12.4242C10.0676 12.7934 10.3014 13.1136 10.5584 13.3888C10.8537 13.705 11.1911 13.9744 11.5729 14.1952C11.6183 12.734 12.8195 11.5665 14.2899 11.5714C15.3888 11.5731 16.3783 12.2372 16.7962 13.2537C17.2142 14.2706 16.9775 15.4392 16.1967 16.2133C15.4524 16.9511 14.354 17.1915 13.3753 16.8427C11.6764 16.6197 10.2093 15.9454 9.09657 14.7537C8.08648 13.6719 7.43093 12.231 7.11026 10.4826C7.03705 10.2341 6.99847 9.9709 7.00005 9.69858C7.00872 8.20259 8.22624 6.9957 9.72217 7.00001C11.2181 7.00432 12.4286 8.21824 12.4286 9.71421L12.4286 9.71906Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    whatsapp: {
        defaultColors: ["#3D4C66"],
        keywords: ["phone","communication","customer-service","contact","support","call","whatsapp"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0015 20C15.5621 19.9993 18.6936 17.6451 19.6838 14.2248C20.674 10.8045 19.2845 7.1414 16.2751 5.23839C13.2656 3.33538 9.36075 3.65061 6.6955 6.01171C4.03026 8.37282 3.24629 12.2114 4.77225 15.4286L4.00223 18.8571H7.87834C9.12271 19.6072 10.5486 20.0024 12.0015 20Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00008 9.70438L7.2501 9.70003L8.00008 9.70438ZM12.5716 14.2725L13.3216 14.2783L13.3216 14.2761L12.5716 14.2725ZM15.4927 15.5031L14.9647 14.9705L15.4927 15.5031ZM15.8713 13.6339L15.1776 13.9191H15.1776L15.8713 13.6339ZM14.2875 12.5714L14.2846 13.3214L14.2868 13.3214L14.2875 12.5714ZM9.69947 11.4286L9.69294 12.1785L9.69657 12.1786L9.69947 11.4286ZM9.71934 8.00001L9.71718 8.75L9.71934 8.00001ZM11.4287 9.71425L12.1787 9.71785L12.1787 9.71422L11.4287 9.71425ZM7.25651 9.80231C7.52074 11.8085 8.19206 13.4186 9.27935 14.5831C10.373 15.7544 11.8278 16.4107 13.533 16.6104L13.7075 15.1206C12.2924 14.9548 11.1871 14.4284 10.3757 13.5594C9.55798 12.6836 8.97934 11.3958 8.74366 9.60644L7.25651 9.80231ZM11.8216 14.2668C11.814 15.2649 12.4091 16.1691 13.3291 16.5567L13.9114 15.1743C13.5515 15.0227 13.3186 14.6689 13.3216 14.2783L11.8216 14.2668ZM13.3291 16.5567C14.249 16.9442 15.3118 16.7385 16.0207 16.0357L14.9647 14.9705C14.6873 15.2455 14.2714 15.326 13.9114 15.1743L13.3291 16.5567ZM16.0207 16.0357C16.7296 15.333 16.9445 14.272 16.565 13.3487L15.1776 13.9191C15.3262 14.2803 15.2421 14.6955 14.9647 14.9705L16.0207 16.0357ZM16.565 13.3487C16.1855 12.4255 15.2864 11.8224 14.2882 11.8214L14.2868 13.3214C14.6774 13.3218 15.0291 13.5578 15.1776 13.9191L16.565 13.3487ZM14.2904 11.8214C12.9331 11.8162 11.8281 12.9116 11.8216 14.2689L13.3216 14.2761C13.3241 13.7467 13.7551 13.3194 14.2846 13.3214L14.2904 11.8214ZM9.70601 10.6786C9.17454 10.674 8.74699 10.2402 8.75007 9.70872L7.2501 9.70003C7.24223 11.0582 8.33483 12.1667 9.69294 12.1785L9.70601 10.6786ZM8.75007 9.70872C8.75315 9.17728 9.1857 8.74847 9.71718 8.75L9.7215 7.25001C8.36335 7.2461 7.25797 8.34183 7.2501 9.70003L8.75007 9.70872ZM9.71718 8.75C10.2486 8.75153 10.6787 9.18279 10.6787 9.71428L12.1787 9.71422C12.1786 8.35603 11.0797 7.25392 9.7215 7.25001L9.71718 8.75ZM10.6787 9.71064C10.6761 10.2474 10.2391 10.6806 9.70237 10.6786L9.69657 12.1786C11.0612 12.1838 12.1721 11.0825 12.1787 9.71785L10.6787 9.71064Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi low-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wifi","low signal","connection","network","connectivity","weak","internet","signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi low-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","low","connection","signal","weak","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi low-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","signal","connection","weak","low","network","offline","connectivity","wifi-low","no-signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0002 11C9.79103 11 8.00017 12.7909 8.00017 15C8.00017 17.2091 9.79103 19 12.0002 19C14.2093 19 16.0002 17.2091 16.0002 15C16.0002 12.7909 14.2093 11 12.0002 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0002 10C10.1508 10 8.53454 11.0036 7.66851 12.5007C7.39196 12.9788 6.78024 13.1421 6.30217 12.8656C5.82411 12.5891 5.66075 11.9773 5.93729 11.4993C7.14612 9.40958 9.40796 8 12.0002 8C14.5925 8 16.8543 9.40958 18.0631 11.4993C18.3397 11.9773 18.1763 12.5891 17.6982 12.8656C17.2202 13.1421 16.6085 12.9788 16.3319 12.5007C15.4659 11.0036 13.8497 10 12.0002 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi low-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","weak-signal","low-connectivity","signal-strength","network","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="14" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 14C17 10.6863 14.3137 8 11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi low-5": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wifi","connection","low-signal","signal","network","connectivity","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="14" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M17 14C17 10.6863 14.3137 8 11 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "web-cam-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["webcam","camera","video","surveillance","security","monitoring","live feed","customer identification","facial recognition","identification"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 21L12.7639 21C14.2143 21 14.9395 21 15.2326 20.5257C15.5257 20.0515 15.2014 19.4028 14.5528 18.1056C14.2838 17.5677 14.1493 17.2987 13.9077 17.1493C13.666 17 13.3653 17 12.7639 17L11.2361 17C10.6347 17 10.334 17 10.0923 17.1493C9.85065 17.2987 9.71617 17.5677 9.44721 18.1056C8.79858 19.4028 8.47427 20.0515 8.76738 20.5257C9.0605 21 9.78569 21 11.2361 21L12 21Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 17H11C8.17157 17 6.75736 17 5.87868 16.1213C5 15.2426 5 13.8284 5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11C19 13.8284 19 15.2426 18.1213 16.1213C17.2426 17 15.8284 17 13 17Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 8C10.3431 8 9 9.34321 9 11.0001C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11.0001C15 9.34321 13.6569 8 12 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi low-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","low-signal","connection","network","weak-signal","offline","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 10C8.79086 10 7 11.7909 7 14C7 16.2091 8.79086 18 11 18C13.2091 18 15 16.2091 15 14C15 11.7909 13.2091 10 11 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8C10 7.44772 10.4477 7 11 7C14.866 7 18 10.134 18 14C18 14.5523 17.5523 15 17 15C16.4477 15 16 14.5523 16 14C16 11.2386 13.7614 9 11 9C10.4477 9 10 8.55228 10 8Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi low": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","weak-signal","low-signal","offline","disconnected","connectivity","wireless"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wifi","connection","network","wireless","internet","connectivity","signal","online","pos-system","network-status","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-10": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","network","connection","signal","wireless","online","connectivity","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="9"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C15 11.6863 12.3137 9 9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-11": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","internet","wireless","signal","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C13.866 7 17 10.134 17 14C17 14.5523 17.4477 15 18 15C18.5523 15 19 14.5523 19 14C19 9.02944 14.9706 5 10 5ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10C11.7614 10 14 12.2386 14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 11.134 12.866 8 9 8ZM5.25 15C5.25 12.9289 6.92893 11.25 9 11.25C11.0711 11.25 12.75 12.9289 12.75 15C12.75 17.0711 11.0711 18.75 9 18.75C6.92893 18.75 5.25 17.0711 5.25 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi low-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","connection","signal","network","weak-signal","disconnected","offline","no-connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="11"
                    cy="14"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 14C17 10.6863 14.3137 8 11 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-12": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","wireless","connectivity","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wifi-14": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wifi","connection","network","signal","wireless","connectivity","internet","online"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wifi-16": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","connectivity","signal","wireless","online","internet","pos-connected","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16C19 9.92487 14.0751 5 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 16C15 12.134 11.866 9 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="8" cy="16" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Wifi-15": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","wireless","internet","online","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 13C5 9.13401 8.13401 6 12 6C15.866 6 19 9.13401 19 13C19 14.7922 18.3252 16.4291 17.2173 17.6669C16.849 18.0784 16.2168 18.1135 15.8053 17.7451C15.3938 17.3768 15.3588 16.7446 15.7271 16.3331C16.5194 15.4478 17 14.2812 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 14.2812 7.48059 15.4478 8.27292 16.3331C8.64125 16.7446 8.60623 17.3768 8.1947 17.7451C7.78317 18.1135 7.15098 18.0784 6.78265 17.6669C5.67482 16.4291 5 14.7922 5 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi-13": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","connection","signal","network","wireless","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wifi-19": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","wireless","connectivity","online","internet","router","connected","service"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 5C7 4.44772 7.44772 4 8 4C14.6274 4 20 9.37258 20 16C20 16.5523 19.5523 17 19 17C18.4477 17 18 16.5523 18 16C18 10.4772 13.5228 6 8 6C7.44772 6 7 5.55228 7 5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 9C7 8.44772 7.44772 8 8 8C12.4183 8 16 11.5817 16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16C14 12.6863 11.3137 10 8 10C7.44772 10 7 9.55228 7 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 16C4 13.7909 5.79086 12 8 12C10.2091 12 12 13.7909 12 16C12 18.2091 10.2091 20 8 20C5.79086 20 4 18.2091 4 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi-17": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","connection","network","wireless","internet","signal","online","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16C19 9.92487 14.0751 5 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 16C15 12.134 11.866 9 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="8" cy="16" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" />
            </svg>
        )
    },
    "Wifi-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","connection","network","wireless","internet","connectivity","signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","network","connection","internet","connectivity","signal","wireless","online","pos-system","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.0001 11C9.79097 11 8.00011 12.7909 8.00011 15C8.00011 17.2091 9.79097 19 12.0001 19C14.2092 19 16.0001 17.2091 16.0001 15C16.0001 12.7909 14.2092 11 12.0001 11Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 10C10.1507 10 8.53448 11.0036 7.66845 12.5007C7.3919 12.9788 6.78018 13.1421 6.30212 12.8656C5.82405 12.5891 5.66069 11.9773 5.93724 11.4993C7.14606 9.40958 9.4079 8 12.0001 8C14.5924 8 16.8542 9.40958 18.0631 11.4993C18.3396 11.9773 18.1762 12.5891 17.6982 12.8656C17.2201 13.1421 16.6084 12.9788 16.3318 12.5007C15.4658 11.0036 13.8496 10 12.0001 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 7C9.21845 7 6.76775 8.41886 5.33284 10.577C5.02705 11.0369 4.40634 11.1618 3.94643 10.856C3.48653 10.5503 3.36159 9.92954 3.66737 9.46963C5.45723 6.77767 8.52085 5 12.0001 5C15.4794 5 18.543 6.77767 20.3328 9.46963C20.6386 9.92954 20.5137 10.5503 20.0538 10.856C19.5939 11.1618 18.9732 11.0369 18.6674 10.577C17.2325 8.41886 14.7818 7 12.0001 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","wireless","connectivity","internet","online","connected","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.364 17.9397C19.9926 16.4196 21 14.3196 21 12C21 9.64957 19.9657 7.52462 18.2987 6M5.70131 6C4.03431 7.52462 3 9.64957 3 12C3 14.3504 4.03431 16.4754 5.70131 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wifi-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","connection","signal","wireless","network","online","connectivity","internet","wifi-5","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.364 17.9397C19.9926 16.4196 21 14.3196 21 12C21 9.64957 19.9657 7.52462 18.2987 6M5.70131 6C4.03431 7.52462 3 9.64957 3 12C3 14.3504 4.03431 16.4754 5.70131 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="3" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wifi-6": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wifi","connection","network","signal","wireless","online","connected","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2426 15.9598C17.3284 14.9464 18 13.5464 18 12C18 10.433 17.3105 9.01641 16.1991 8M7.80087 8C6.68954 9.01641 6 10.433 6 12C6 13.567 6.68954 14.9836 7.80087 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.364 17.9397C19.9926 16.4196 21 14.3196 21 12C21 9.64957 19.9657 7.52462 18.2987 6M5.70131 6C4.03431 7.52462 3 9.64957 3 12C3 14.3504 4.03431 16.4754 5.70131 18"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","signal","wireless","network","internet","connectivity"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.53879 7.32511C8.91152 7.73265 8.8833 8.36519 8.47576 8.73792C7.5541 9.58087 7 10.7366 7 12C7 13.2634 7.5541 14.4191 8.47576 15.2621C8.8833 15.6348 8.91152 16.2674 8.53879 16.6749C8.16605 17.0824 7.53352 17.1107 7.12598 16.7379C5.82499 15.548 5 13.8705 5 12C5 10.1295 5.82499 8.45197 7.12598 7.26209C7.53352 6.88936 8.16605 6.91757 8.53879 7.32511ZM15.4612 7.32511C15.8339 6.91757 16.4665 6.88936 16.874 7.26209C18.175 8.45197 19 10.1295 19 12C19 13.8458 18.1966 15.504 16.925 16.6909C16.5212 17.0677 15.8884 17.0459 15.5116 16.6421C15.1348 16.2384 15.1566 15.6056 15.5603 15.2287C16.4603 14.3888 17 13.247 17 12C17 10.7366 16.4459 9.58087 15.5242 8.73792C15.1167 8.36519 15.0885 7.73265 15.4612 7.32511Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.43922 5.32511C6.81196 5.73265 6.78374 6.36519 6.3762 6.73792C4.89887 8.08908 4 9.95311 4 12C4 14.0469 4.89887 15.9109 6.3762 17.2621C6.78374 17.6348 6.81196 18.2674 6.43922 18.6749C6.06649 19.0824 5.43395 19.1107 5.02641 18.7379C3.16976 17.0398 2 14.654 2 12C2 9.34605 3.16976 6.96017 5.02641 5.26209C5.43395 4.88936 6.06649 4.91757 6.43922 5.32511ZM17.5608 5.32511C17.9335 4.91757 18.566 4.88936 18.9736 5.26209C20.8302 6.96017 22 9.34605 22 12C22 14.619 20.8608 16.9772 19.0463 18.6708C18.6425 19.0476 18.0097 19.0258 17.6329 18.622C17.2561 18.2183 17.2779 17.5855 17.6816 17.2086C19.1245 15.862 20 14.0202 20 12C20 9.95311 19.1011 8.08908 17.6238 6.73792C17.2163 6.36519 17.188 5.73265 17.5608 5.32511Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 8.00001C9.79086 8.00001 8 9.79087 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79087 14.2091 8.00001 12 8.00001Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wifi-18": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wifi","connection","wireless","network","signal","online","internet","connectivity","connected"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 16C19 9.92487 14.0751 5 8 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 16C15 12.134 11.866 9 8 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <circle
                    cx="8"
                    cy="16"
                    r="3"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "Wifi-9": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wifi","connection","connectivity","network","internet","wireless","signal","online","status","network-status","offline","no-connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="15" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C15 11.6863 12.3137 9 9 9"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-cross-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wifi","no-wifi","offline","connection-error","network-error","disconnected","no-connection","signal-lost","internet-down"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wifi-8": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","wireless","online","internet","connectivity","pos-connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 14C18 9.58172 14.4183 6 10 6"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M15 15C15 11.6863 12.3137 9 9 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "Wifi-cross-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","no-wifi","offline","connection-error","network-error","no-network","disconnected","signal-lost","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wifi-cross": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","no-wifi","offline","disconnected","network-error","network-offline","connection-error","no-connection"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M5 19L19 5" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Wifi-cross-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","no-wifi","offline","connection-error","no-connection","signal-off","disconnected","network-error","trouble","error"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.709 4.29006C19.319 3.90006 18.689 3.90006 18.299 4.29006L16.839 5.75006C15.409 4.96006 13.759 4.50006 11.999 4.50006C8.51896 4.50006 5.45896 6.28006 3.66896 8.97006C3.35896 9.43006 3.48896 10.0501 3.94896 10.3601C4.40896 10.6701 5.02896 10.5401 5.33896 10.0801C6.76896 7.92006 9.22896 6.50006 12.009 6.50006C13.199 6.50006 14.329 6.78006 15.349 7.25006L14.219 8.38006C13.519 8.15006 12.779 8.01006 12.009 8.01006C9.41896 8.01006 7.15896 9.42006 5.94896 11.5101C5.66896 11.9901 5.83896 12.6001 6.30896 12.8801C6.78896 13.1601 7.39896 12.9901 7.67896 12.5201C8.54896 11.0201 10.159 10.0201 12.009 10.0201C12.199 10.0201 12.379 10.0301 12.559 10.0501L10.889 11.7201C9.85896 12.0701 9.04896 12.8801 8.69896 13.9101L4.28896 18.2901C3.89896 18.6801 3.89896 19.3101 4.28896 19.7001C4.67896 20.0901 5.30896 20.0901 5.69896 19.7001L19.709 5.71006C20.099 5.32006 20.099 4.69006 19.709 4.30006V4.29006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M20.32 8.97006C20.07 8.60006 19.809 8.24006 19.509 7.90006L18.089 9.32006C18.289 9.56006 18.489 9.81006 18.659 10.0801C18.969 10.5401 19.59 10.6601 20.05 10.3601C20.51 10.0601 20.62 9.43006 20.32 8.97006Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17.149 10.2601L15.729 11.6801C15.949 11.9301 16.149 12.2101 16.329 12.5001C16.609 12.9801 17.219 13.1401 17.699 12.8601C18.179 12.5801 18.339 11.9701 18.059 11.4901C17.799 11.0401 17.499 10.6301 17.149 10.2501V10.2601Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M9.73896 17.6701C10.349 18.1901 11.139 18.5001 11.999 18.5001C13.929 18.5001 15.499 16.9301 15.499 15.0001C15.499 14.1401 15.189 13.3501 14.669 12.7401L9.73896 17.6701Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wifi-find-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wifi","connection","signal","connectivity","network","online","internet","wireless","pos-connection","pos-network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M7 12C7.99804 10.2066 9.86346 9 12 9C14.1365 9 16.002 10.2066 17 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C17.4951 7.58901 14.9218 6 12 6C9.07824 6 6.50489 7.58901 5 10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4697 18.5303C14.7626 18.8232 15.2374 18.8232 15.5303 18.5303C15.8232 18.2374 15.8232 17.7626 15.5303 17.4697L14.4697 18.5303ZM15.5303 17.4697L14.5303 16.4697L13.4697 17.5303L14.4697 18.5303L15.5303 17.4697Z"
                    fill={colors?.[0] || "#2797E8"}
                />
            </svg>
        )
    },
    "wifi-find-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wifi","network","connection","connectivity","internet","signal","chat","speech-bubble","message","support","help","communication"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="12"
                    cy="15"
                    r="3"
                    fill={colors?.[0] || "#3D4C66"}
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M7 12C7.99804 10.2066 9.86346 9 12 9C14.1365 9 16.002 10.2066 17 12"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19 10C17.4951 7.58901 14.9218 6 12 6C9.07824 6 6.50489 7.58901 5 10"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4697 18.5303C14.7626 18.8232 15.2374 18.8232 15.5303 18.5303C15.8232 18.2374 15.8232 17.7626 15.5303 17.4697L14.4697 18.5303ZM15.5303 17.4697L14.5303 16.4697L13.4697 17.5303L14.4697 18.5303L15.5303 17.4697Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wifi-find-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","connectivity","signal","wireless","internet"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 10C10.2543 10 8.70944 10.985 7.87394 12.4863C7.60537 12.9689 6.99644 13.1424 6.51386 12.8738C6.03127 12.6052 5.85777 11.9963 6.12633 11.5137C7.28692 9.42824 9.47292 8 12.0001 8C14.5273 8 16.7133 9.42824 17.8739 11.5137C18.1425 11.9963 17.969 12.6052 17.4864 12.8738C17.0038 13.1424 16.3949 12.9689 16.1263 12.4863C15.2908 10.985 13.746 10 12.0001 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 7C9.4563 7 7.1888 8.38211 5.84845 10.5295C5.55601 10.998 4.93915 11.1407 4.47064 10.8483C4.00213 10.5559 3.85939 9.93901 4.15182 9.4705C5.82125 6.7959 8.70045 5 12.0001 5C15.2998 5 18.179 6.7959 19.8484 9.4705C20.1409 9.93901 19.9981 10.5559 19.5296 10.8483C19.0611 11.1407 18.4443 10.998 18.1518 10.5295C16.8115 8.38211 14.544 7 12.0001 7Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 11C9.791 11 8.00013 12.7909 8.00013 15C8.00013 17.2091 9.791 19 12.0001 19C12.742 19 13.4366 18.7981 14.0321 18.4462L14.2931 18.7071C14.6836 19.0976 15.3168 19.0976 15.7073 18.7071C16.0978 18.3166 16.0978 17.6834 15.7073 17.2929L15.4463 17.0319C15.7982 16.4364 16.0001 15.7418 16.0001 15C16.0001 12.7909 14.2093 11 12.0001 11ZM10.0001 15C10.0001 13.8954 10.8956 13 12.0001 13C13.1047 13 14.0001 13.8954 14.0001 15C14.0001 16.1046 13.1047 17 12.0001 17C10.8956 17 10.0001 16.1046 10.0001 15Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wifi-tethring-off-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["no-wifi","offline","no-connection","connection-error","disconnected","no-network","no-signal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19L5 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wifi-tethring-off-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wifi","no-wifi","offline","connection-lost","disabled","no-connection","disconnected","signal-off","tethering-off"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19L5 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wifi-find": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection","network","signal","wireless","internet","connectivity","offline","no-connection","online","pos-system"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.4697 18.5303C14.7626 18.8232 15.2374 18.8232 15.5303 18.5303C15.8232 18.2374 15.8232 17.7626 15.5303 17.4697L14.4697 18.5303ZM15.5303 17.4697L14.5303 16.4697L13.4697 17.5303L14.4697 18.5303L15.5303 17.4697Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wifi-tethring-off": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","connection-off","no-connection","offline","disconnected","network-error","no-network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.52779 17C6.57771 15.9385 6 14.5367 6 13C6 9.68629 8.68629 7 12 7C15.3137 7 18 9.68629 18 13C18 14.5367 17.4223 15.9385 16.4722 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 12.2044 9.31607 11.4413 9.87868 10.8787C10.4413 10.3161 11.2044 10 12 10Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 19L5 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wifi-tethring-off-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wifi","tethering","off","connection-off","network-off","no-internet","disabled-network","disconnected","offline"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 6C8.13401 6 5 9.13401 5 13C5 14.7922 5.67482 16.4291 6.78265 17.6669C7.15098 18.0784 7.78317 18.1135 8.1947 17.7451C8.60623 17.3768 8.64125 16.7446 8.27292 16.3331C7.48059 15.4478 7 14.2812 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 14.2812 16.5194 15.4478 15.7271 16.3331C15.3588 16.7446 15.3938 17.3768 15.8053 17.7451C16.2168 18.1135 16.849 18.0784 17.2173 17.6669C18.3252 16.4291 19 14.7922 19 13C19 9.13401 15.866 6 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 9C10.9391 9 9.92172 9.42143 9.17157 10.1716C8.42143 10.9217 8 11.9391 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wind-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wind","airflow","draft","ventilation","cooling","weather","forecast","environmental","climate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 11H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11C15.6569 11 17 9.65685 17 8C17 6.34315 15.6569 5 14 5C12.3431 5 11 6.34315 11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13H7"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13C18.6569 13 20 14.3431 20 16C20 17.6569 18.6569 19 17 19C15.3431 19 14 17.6569 14 16"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "wind-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["wind","draft","airflow","weather","environment","air-condition","ventilation","energy","settings","breeze","temperature","fluctuations","forecast"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 11H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11C15.6569 11 17 9.65685 17 8C17 6.34315 15.6569 5 14 5C12.3431 5 11 6.34315 11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13H7"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13C18.6569 13 20 14.3431 20 16C20 17.6569 18.6569 19 17 19C15.3431 19 14 17.6569 14 16"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13C18.6569 13 20 14.3431 20 16C20 17.6569 18.6569 19 17 19C15.3431 19 14 17.6569 14 16C14 14.3431 15.3431 13 17 13Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
            </svg>
        )
    },
    "wind-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wind","weather","environment","airflow","draft","fan","cooling","outdoor","force","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 5.5C12.8954 5.5 12 6.39543 12 7.5C12 8.05228 11.5523 8.5 11 8.5C10.4477 8.5 10 8.05228 10 7.5C10 5.29086 11.7909 3.5 14 3.5C16.2091 3.5 18 5.29086 18 7.5C18 9.70914 16.2091 11.5 14 11.5H4C3.44772 11.5 3 11.0523 3 10.5C3 9.94772 3.44772 9.5 4 9.5H14C15.1046 9.5 16 8.60457 16 7.5C16 6.39543 15.1046 5.5 14 5.5ZM6 13.5C6 12.9477 6.44772 12.5 7 12.5H17C19.2091 12.5 21 14.2909 21 16.5C21 18.7091 19.2091 20.5 17 20.5C14.7909 20.5 13 18.7091 13 16.5C13 15.9477 13.4477 15.5 14 15.5C14.5523 15.5 15 15.9477 15 16.5C15 17.6046 15.8954 18.5 17 18.5C18.1046 18.5 19 17.6046 19 16.5C19 15.3954 18.1046 14.5 17 14.5H7C6.44772 14.5 6 14.0523 6 13.5Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Wifi: {
        defaultColors: ["#3D4C66"],
        keywords: ["wind","weather","environment","airflow","draft","fan","cooling","outdoor","force","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="15" r="3" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M6.80273 12C7.84016 10.2066 9.77919 9 12 9C14.2209 9 16.1599 10.2066 17.1973 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 10.0233C17.8876 7.59826 15.1305 6 12 6C8.86954 6 6.11238 7.59826 4.5 10.0233"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    wind: {
        defaultColors: ["#3D4C66"],
        keywords: ["wind","weather","environment","airflow","draft","fan","cooling","outdoor","force","condition"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14 11H4"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 11C15.6569 11 17 9.65685 17 8C17 6.34315 15.6569 5 14 5C12.3431 5 11 6.34315 11 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M17 13H7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 13C18.6569 13 20 14.3431 20 16C20 17.6569 18.6569 19 17 19C15.3431 19 14 17.6569 14 16"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "windows-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["grid","layout","table","interface","matrix","organization","structure","section","dashboard","windows"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L11 5"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 4L4 5V19L20 20V4Z"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "windows-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["tiles","grid","menu","options","layout","interface","dashboard"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 3.62305L3.93762 4.00195C3.41059 4.03489 3 4.47194 3 5V11H10V3.62305Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path d="M3 13V19C3 19.5281 3.41059 19.9651 3.93762 19.9981L10 20.377L10 13H3Z" fill={colors?.[0] || "#3D4C66"} />
                <path
                    d="M12 20.502L19.9376 20.9981C20.2131 21.0153 20.4835 20.9178 20.6847 20.7288C20.8859 20.5398 21 20.2761 21 20V13H12L12 20.502Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M21 11V4C21 3.72395 20.8859 3.46018 20.6847 3.27117C20.4835 3.08217 20.2131 2.98473 19.9376 3.00195L12 3.49805L12 11H21Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "windows-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["window","add-window","new-window","add","plus"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 4L4 5V19L20 20V4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L11 5"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["wine","glass","drink","alcohol","beverage","wine-glass","menu","cocktail","bar","restaurant","drinks"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13V19" stroke={colors?.[0] || "#2797E8"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 19H17"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 5H20L12 13L4 5Z" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Wine-glass-2-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wine","wine-glass","glass","alcohol","drink","beverage","menu","order","bar","restaurant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14V14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-2-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wine","wine-glass","drink","menu","beverage","alcohol"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 14V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-2-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wine","wineglass","glass","drink","beverage","alcohol","menu-item","order-item","restaurant","bar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00485 3.9005C6.05597 3.38929 6.48614 3 6.99989 3H16.9999C17.5136 3 17.9438 3.38929 17.9949 3.9005L18.3979 7.93027C18.7425 11.3766 16.3094 14.4078 12.9999 14.923V19H16.9999C17.5522 19 17.9999 19.4477 17.9999 20C17.9999 20.5523 17.5522 21 16.9999 21H6.99989C6.4476 21 5.99989 20.5523 5.99989 20C5.99989 19.4477 6.4476 19 6.99989 19H10.9999V14.923C7.69038 14.4078 5.25724 11.3766 5.60187 7.93027L6.00485 3.9005Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wine-glass-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["wine","glass","drink","alcohol","beverage","menu","bar","restaurant","wine-glass"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 4H17L17.403 8.02978C17.7226 11.2263 15.2125 14 12 14V14C8.78754 14 6.27737 11.2263 6.59702 8.02978L7 4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-21": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wine","glass","wine-glass","drink","alcohol","cocktail","menu","beverage","bar","restaurant","order"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 5H20L12 13L4 5Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 13V19" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 19H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wine","glass","drink","cocktail","alcohol","menu-item","beverage","bar","restaurant"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.07615 4.61732C3.23093 4.24364 3.59557 4 4.00003 4H20C20.4045 4 20.7691 4.24364 20.9239 4.61732C21.0787 4.99099 20.9931 5.42111 20.7071 5.70711L13 13.4142V18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H7.00003C6.44774 20 6.00003 19.5523 6.00003 19C6.00003 18.4477 6.44774 18 7.00003 18H11V13.4142L3.29292 5.70711C3.00692 5.42111 2.92137 4.99099 3.07615 4.61732Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wine-glass-lemon-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["cocktail","drink","alcohol","wine","bar","menu","beverage","martini","glass","lime","lemon","refreshment"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7.19613C15.4523 5.6003 17.1369 4.66653 18.7627 5.1105C20.3884 5.55447 21.3397 7.20805 20.8874 8.80387C20.4351 10.3997 18.7505 11.3335 17.1248 10.8895"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 14V20" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 8H19L12 14L5 8Z" stroke={colors?.[1] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "Wine-glass-lemon-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cocktail","drink","beverage","bar","alcohol","martini","menu","order","liquor","glass","wine","add-drink","add-cocktail"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 7.19613C15.4523 5.6003 17.1369 4.66653 18.7627 5.1105C20.3884 5.55447 21.3397 7.20805 20.8874 8.80387C20.4351 10.3997 18.7505 11.3335 17.1248 10.8895"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 8H19L12 14L5 8Z"
                    fill={colors?.[1] || "#D9D1E0"}
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass-lemon-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cocktail","drink","alcohol","beverage","martini","glass","bar","menu","cocktail-menu","drinks-menu","alcoholic-beverage","happy-hour"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.7504 4C16.3804 4 15.1604 4.68994 14.4404 5.74994H17.7504C18.6904 5.74994 19.5304 6.33994 19.8604 7.21994C20.1904 8.09994 19.9304 9.09994 19.2104 9.70994L16.7104 11.8499C17.0404 11.9399 17.3804 11.9999 17.7404 11.9999C19.9504 11.9999 21.7404 10.2099 21.7404 7.99994C21.7404 5.78994 19.9604 4 17.7504 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7504 18.9999H11.7504V14.1299L15.2704 11.1099L16.8404 9.76994L17.2004 9.45994L17.2404 9.42994L18.2404 8.56994C18.4804 8.36994 18.5604 8.02994 18.4604 7.73994C18.3504 7.44994 18.0704 7.24994 17.7604 7.24994H3.75038C3.66038 7.24994 3.57038 7.26994 3.49038 7.29994C3.49038 7.29994 3.48038 7.29994 3.47038 7.29994C3.28038 7.37994 3.12038 7.52994 3.05038 7.72994C2.94038 8.01994 3.03038 8.35994 3.27038 8.55994L9.76038 14.1199V18.9899H5.75038C5.20038 18.9899 4.75038 19.4399 4.75038 19.9899C4.75038 20.5399 5.20038 20.9999 5.75038 20.9999H15.7504C16.3004 20.9999 16.7504 20.5399 16.7504 19.9899C16.7504 19.4399 16.3004 18.9899 15.7504 18.9899V18.9999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Wine-glass-lemon": {
        defaultColors: ["#3D4C66"],
        keywords: ["cocktail","drink","beverage","alcohol","martini","wine-glass","lemon","menu","order","bar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14V20" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 20H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5 8H19L12 14L5 8Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M15 7.19613C15.4523 5.6003 17.1369 4.66653 18.7627 5.1105C20.3884 5.55447 21.3397 7.20805 20.8874 8.80387C20.4351 10.3997 18.7505 11.3335 17.1248 10.8895"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Wine-glass": {
        defaultColors: ["#3D4C66"],
        keywords: ["wine","glass","drink","alcohol","beverage","menu","wine-glass","bar"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13V19" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
                <path
                    d="M7 19H17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4 5H20L12 13L4 5Z" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        )
    },
    "wireless-charging-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wireless","charging","power","electricity","battery","charge","device","pos-terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C7.36635 9.86961 7 10.898 7 12C7 13.102 7.36635 14.1304 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7C4.7643 8.27961 4 10.0474 4 12C4 13.9526 4.7643 15.7204 6 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C16.6337 14.1304 17 13.102 17 12C17 10.898 16.6337 9.86961 16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17C19.2357 15.7204 20 13.9526 20 12C20 10.0474 19.2357 8.27961 18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    windows: {
        defaultColors: ["#3D4C66"],
        keywords: ["wireless","charging","power","electricity","battery","charge","device","pos-terminal"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 4L4 5V19L20 20V4Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12L20 12"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11 19L11 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wireless-charging-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wireless","charging","power","battery","electricity","payment","wireless-payment","contactless","contactless-payment","energy"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.58891 8.19187C9.03526 8.51711 9.13345 9.14262 8.8082 9.58898C8.28897 10.3016 8 11.1264 8 12.0001C8 12.8737 8.28897 13.6986 8.8082 14.4112C9.13345 14.8575 9.03526 15.483 8.58891 15.8083C8.14255 16.1335 7.51704 16.0353 7.1918 15.589C6.44372 14.5623 6 13.3304 6 12.0001C6 10.6697 6.44372 9.43781 7.1918 8.41116C7.51704 7.96481 8.14255 7.86662 8.58891 8.19187Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.69466 6.28066C7.09194 6.66431 7.10299 7.29738 6.71934 7.69466C5.65986 8.79178 5 10.312 5 12C5 13.688 5.65986 15.2082 6.71934 16.3053C7.10299 16.7026 7.09194 17.3357 6.69466 17.7193C6.29738 18.103 5.66431 18.0919 5.28066 17.6947C3.86873 16.2326 3 14.2172 3 12C3 9.78277 3.86873 7.76744 5.28066 6.30534C5.66431 5.90806 6.29738 5.89701 6.69466 6.28066Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.4111 15.8081C14.9647 15.4829 14.8666 14.8574 15.1918 14.411C15.711 13.6984 16 12.8736 16 11.9999C16 11.1263 15.711 10.3014 15.1918 9.58884C14.8666 9.14248 14.9647 8.51697 15.4111 8.19173C15.8575 7.86649 16.483 7.96467 16.8082 8.41102C17.5563 9.43767 18 10.6696 18 11.9999C18 13.3303 17.5563 14.5622 16.8082 15.5888C16.483 16.0352 15.8575 16.1334 15.4111 15.8081Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3053 17.7193C16.9081 17.3357 16.897 16.7026 17.2807 16.3053C18.3401 15.2082 19 13.688 19 12C19 10.312 18.3401 8.79178 17.2807 7.69466C16.897 7.29738 16.9081 6.66431 17.3053 6.28066C17.7026 5.89701 18.3357 5.90806 18.7193 6.30534C20.1313 7.76744 21 9.78277 21 12C21 14.2172 20.1313 16.2326 18.7193 17.6947C18.3357 18.0919 17.7026 18.103 17.3053 17.7193Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.316 8.05133C11.792 7.87671 11.2257 8.1599 11.0511 8.68385L10.0513 11.6839C9.94966 11.9888 10.0008 12.324 10.1888 12.5848C10.3767 12.8455 10.6786 13 11 13H11.6125L11.0511 14.6837C10.8765 15.2077 11.1596 15.774 11.6835 15.9487C12.2075 16.1234 12.7738 15.8402 12.9485 15.3163L13.9487 12.3163C14.0503 12.0114 13.9992 11.6761 13.8113 11.4153C13.6233 11.1546 13.3214 11 13 11H12.3873L12.9485 9.3162C13.1231 8.79225 12.8399 8.22594 12.316 8.05133Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wireless-charging-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wireless","charging","charge","electricity","power","wireless-payment","contactless","energy","electric"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C7.36635 9.86961 7 10.898 7 12C7 13.102 7.36635 14.1304 8 15"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7C4.7643 8.27961 4 10.0474 4 12C4 13.9526 4.7643 15.7204 6 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C16.6337 14.1304 17 13.102 17 12C17 10.898 16.6337 9.86961 16 9"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17C19.2357 15.7204 20 13.9526 20 12C20 10.0474 19.2357 8.27961 18 7"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "won-sign-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["won","currency","korean-won","south-korea","money","payment","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8L9 16L12 8L15 16L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H19"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "wireless-charging": {
        defaultColors: ["#3D4C66"],
        keywords: ["charge","charging","wireless","electricity","power","battery","device","indicator"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 9C7.36635 9.86961 7 10.898 7 12C7 13.102 7.36635 14.1304 8 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6 7C4.7643 8.27961 4 10.0474 4 12C4 13.9526 4.7643 15.7204 6 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 15C16.6337 14.1304 17 13.102 17 12C17 10.898 16.6337 9.86961 16 9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 17C19.2357 15.7204 20 13.9526 20 12C20 10.0474 19.2357 8.27961 18 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9998 9L11 12H13L11.9998 15"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "won-sign-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["currency","won","money","payment","refund","discount","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.64866 7.0637C6.16578 6.86978 6.74219 7.13178 6.93611 7.6489L7.91152 10.25H10.088L11.0635 7.6489C11.2098 7.2586 11.5829 7.00003 11.9998 7.00003C12.4166 7.00003 12.7897 7.2586 12.9361 7.6489L13.9115 10.25H16.088L17.0635 7.6489C17.2574 7.13178 17.8338 6.86978 18.3509 7.0637C18.868 7.25762 19.13 7.83403 18.9361 8.35115L18.224 10.25H19C19.4142 10.25 19.75 10.5858 19.75 11C19.75 11.4142 19.4142 11.75 19 11.75H5C4.58579 11.75 4.25 11.4142 4.25 11C4.25 10.5858 4.58579 10.25 5 10.25H5.77552L5.06345 8.35115C4.86953 7.83403 5.13154 7.25762 5.64866 7.0637Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M8.99978 13.152L8.84902 12.75H6.71302L8.06346 16.3512C8.20982 16.7415 8.58294 17 8.99978 17C9.41663 17 9.78975 16.7415 9.93611 16.3511L11.2865 12.75H9.15054L8.99978 13.152Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M14.0635 16.3512L12.713 12.75H14.849L14.9998 13.152L15.1505 12.75H17.2865L15.9361 16.3511C15.7898 16.7415 15.4166 17 14.9998 17C14.5829 17 14.2098 16.7415 14.0635 16.3512Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "won-sign": {
        defaultColors: ["#3D4C66"],
        keywords: ["won","currency","money","payment","cash","korean-won","price","cost","amount","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8L9 16L12 8L15 16L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "work-space-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["group","team","network","connection","organization","cluster","affiliate"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="7"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 7 16)"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="17"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 17 16)"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="12"
                    cy="8"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 12 8)"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "won-sign-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["won","currency","payment","korea","KRW","money","cash"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 8L9 16L12 8L15 16L18 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "work-space-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["group","menu","options","more","cluster","team","categories","group-items"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 12C9.20914 12 11 13.7909 11 16C11 18.2091 9.20914 20 7 20C4.79086 20 3 18.2091 3 16C3 13.7909 4.79086 12 7 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M17 12C19.2091 12 21 13.7909 21 16C21 18.2091 19.2091 20 17 20C14.7909 20 13 18.2091 13 16C13 13.7909 14.7909 12 17 12Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "work-space-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["group","collection","organization","team","cluster","workspaces","departments","segments","categories"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="7"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 7 16)"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="17"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 17 16)"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="12"
                    cy="8"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 12 8)"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "wrench-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["wrench","tool","settings","configuration","maintenance","repairs","adjustments","options","system-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2844 12.2407C16.4309 9.84066 16.0102 6.87903 14.0224 4.89114C12.0345 2.90324 9.07283 2.48255 6.6728 3.62906L8.69581 5.65207C9.53631 6.49258 9.53631 7.8553 8.69581 8.69581C7.8553 9.53632 6.49258 9.53632 5.65207 8.69581L3.62906 6.6728C2.48255 9.07283 2.90324 12.0345 4.89114 14.0224C6.87903 16.0102 9.84066 16.4309 12.2407 15.2844L17.3259 20.3696C18.1664 21.2101 19.5291 21.2101 20.3696 20.3696C21.2101 19.5291 21.2101 18.1664 20.3696 17.3259L15.2844 12.2407Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.62891 6.67264L5.65192 8.69566C6.49242 9.53616 7.85515 9.53616 8.69566 8.69566C9.53616 7.85515 9.53616 6.49242 8.69566 5.65192L6.67264 3.62891"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "work-space": {
        defaultColors: ["#3D4C66"],
        keywords: ["circles","cluster","group","organization","departments","location","nodes","network"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse
                    cx="7"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 7 16)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="17"
                    cy="16"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 17 16)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <ellipse
                    cx="12"
                    cy="8"
                    rx="3"
                    ry="3"
                    transform="rotate(-90 12 8)"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )
    },
    "wrench-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["wrench","settings","configuration","adjust","repair","maintenance","tools","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.7293 4.18387C12.4324 1.88699 9.01204 1.40311 6.24159 2.72657C5.94868 2.8665 5.74191 3.1399 5.68703 3.45984C5.63215 3.77979 5.73599 4.10646 5.96553 4.336L7.98854 6.35902C8.43852 6.809 8.43852 7.53856 7.98854 7.98854C7.53856 8.43852 6.809 8.43852 6.35902 7.98854L4.336 5.96553C4.10646 5.73599 3.77979 5.63215 3.45984 5.68703C3.1399 5.74191 2.86649 5.94868 2.72657 6.24159C1.40311 9.01204 1.88699 12.4324 4.18387 14.7293C6.30023 16.8457 9.37044 17.4228 12.0072 16.4651L16.6186 21.0766C17.8496 22.3076 19.8455 22.3076 21.0766 21.0766C22.3076 19.8455 22.3076 17.8496 21.0766 16.6186L16.4651 12.0072C17.4228 9.37044 16.8457 6.30023 14.7293 4.18387Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    wrench: {
        defaultColors: ["#3D4C66"],
        keywords: ["wrench","settings","configuration","adjust","repair","maintenance","tools","options"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2844 12.2407C16.4309 9.84066 16.0102 6.87903 14.0224 4.89114C12.0345 2.90324 9.07283 2.48255 6.6728 3.62906L8.69581 5.65207C9.53631 6.49258 9.53631 7.8553 8.69581 8.69581C7.8553 9.53632 6.49258 9.53632 5.65207 8.69581L3.62906 6.6728C2.48255 9.07283 2.90324 12.0345 4.89114 14.0224C6.87903 16.0102 9.84066 16.4309 12.2407 15.2844L17.3259 20.3696C18.1664 21.2101 19.5291 21.2101 20.3696 20.3696C21.2101 19.5291 21.2101 18.1664 20.3696 17.3259L15.2844 12.2407Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.62891 6.67264L5.65192 8.69566C6.49242 9.53616 7.85515 9.53616 8.69566 8.69566C9.53616 7.85515 9.53616 6.49242 8.69566 5.65192L6.67264 3.62891"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "X-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["x","close","remove","cancel","delete","clear","exit","cross"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 12M12 12L8 7M12 12L8 17M12 12L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 17L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "X-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["remove","delete","cancel","close","exit","x"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 12M12 12L8 7M12 12L8 17M12 12L16 17"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 17L9 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#D9D1E0"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "X-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["cancel","remove","delete","close","error","incorrect","invalid","exit","cross","x","void","void-transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 16H16.5L13.3 12L16.5 8H17C17.6 8 18 7.6 18 7C18 6.4 17.6 6 17 6H15C14.4 6 14 6.4 14 7C14 7.2 14.1 7.4 14.2 7.6L12 10.4L9.8 7.6C9.9 7.4 10 7.2 10 7C10 6.4 9.6 6 9 6H7C6.4 6 6 6.4 6 7C6 7.6 6.4 8 7 8H7.5L10.7 12L7.5 16H7C6.4 16 6 16.4 6 17C6 17.6 6.4 18 7 18H9C9.6 18 10 17.6 10 17C10 16.8 9.9 16.6 9.8 16.4L12 13.6L14.2 16.4C14.1 16.6 14 16.8 14 17C14 17.6 14.4 18 15 18H17C17.6 18 18 17.6 18 17C18 16.4 17.6 16 17 16Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "wrench-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["wrench","settings","configuration","maintenance","repair","tools","adjust","options","system-settings"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2844 12.2407C16.4309 9.84066 16.0102 6.87903 14.0224 4.89114C12.0345 2.90324 9.07283 2.48255 6.6728 3.62906L8.69581 5.65207C9.53631 6.49258 9.53631 7.8553 8.69581 8.69581C7.8553 9.53632 6.49258 9.53632 5.65207 8.69581L3.62906 6.6728C2.48255 9.07283 2.90324 12.0345 4.89114 14.0224C6.87903 16.0102 9.84066 16.4309 12.2407 15.2844L17.3259 20.3696C18.1664 21.2101 19.5291 21.2101 20.3696 20.3696C21.2101 19.5291 21.2101 18.1664 20.3696 17.3259L15.2844 12.2407Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.62891 6.67264L5.65192 8.69566C6.49242 9.53616 7.85515 9.53616 8.69566 8.69566C9.53616 7.85515 9.53616 6.49242 8.69566 5.65192L6.67264 3.62891"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "X-5": {
        defaultColors: ["#3D4C66"],
        keywords: ["close","cancel","remove","delete","exit","clear","x"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 12M12 12L6 5M12 12L6 19M12 12L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "X-6": {
        defaultColors: ["#D9D1E0"],
        keywords: ["remove","delete","cancel","clear","close","exit","cross","x"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 12M12 12L6 5M12 12L6 19M12 12L18 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "X-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["close","remove","delete","cancel","exit","x","cross","clear","dismiss"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 12M12 12L6 5M12 12L6 19M12 12L18 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "X-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["close","remove","cancel","delete","exit","cross","dismiss","reject","void","clear"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.34923 4.24076C5.76855 3.88134 6.39985 3.9299 6.75927 4.34923L12 10.4634L17.2408 4.34923C17.6002 3.9299 18.2315 3.88134 18.6508 4.24076C19.0701 4.60018 19.1187 5.23148 18.7593 5.65081L13.3171 12L18.7593 18.3492C19.1187 18.7686 19.0701 19.3999 18.6508 19.7593C18.2315 20.1187 17.6002 20.0701 17.2408 19.6508L12 13.5366L6.75927 19.6508C6.39985 20.0701 5.76855 20.1187 5.34923 19.7593C4.9299 19.3999 4.88134 18.7686 5.24076 18.3492L10.6829 12L5.24076 5.65081C4.88134 5.23148 4.9299 4.60018 5.34923 4.24076Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "xing-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["close","cancel","reject","decline","remove","back","previous","dismiss","clear","delete","return","undo","go-back"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00098 6L9 10L5 14"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3L11 13.9914L16.7143 21"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "xing-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["cancel","delete","remove","back","undo","clear","previous","chevron-left","arrow-left"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00098 6L9 10L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3L11 13.9914L16.7143 21"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "xing-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","chevron","previous","back","scroll-left","navigation","pagination","discount-code","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.5885 2.19155C20.035 2.51656 20.1335 3.14201 19.8085 3.58854L12.262 13.9569L17.4893 20.3682C17.8383 20.7962 17.7742 21.4261 17.3462 21.7751C16.9182 22.1241 16.2882 22.06 15.9392 21.632L10.225 14.6234C9.93797 14.2714 9.92422 13.7702 10.1915 13.403L18.1915 2.4116C18.5165 1.96507 19.1419 1.86655 19.5885 2.19155ZM4.29396 5.29288C4.68453 4.9024 5.31769 4.90248 5.70817 5.29305L9.70719 9.29305C10.0976 9.68359 10.0976 10.3167 9.70711 10.7072L5.70711 14.7072C5.31658 15.0977 4.68342 15.0977 4.29289 14.7072C3.90237 14.3167 3.90237 13.6835 4.29289 13.293L7.58587 9.99998L4.29378 6.70709C3.90331 6.31652 3.90338 5.68335 4.29396 5.29288Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    xing: {
        defaultColors: ["#3D4C66"],
        keywords: ["arrows","chevron","previous","back","scroll-left","navigation","pagination","discount-code","coupon"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.00098 6L9 10L5 14"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19 3L11 13.9914L16.7143 21"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Y-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["Y","fork","split","branch","option","choices","menu","selection","path","route","diverge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 11M12 11L6 5M12 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    X: {
        defaultColors: ["#3D4C66"],
        keywords: ["Y","fork","split","branch","option","choices","menu","selection","path","route","diverge"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7L12 12M12 12L8 7M12 12L8 17M12 12L16 17"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7 7L9 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M7 17L9 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 7L17 7" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 17L17 17" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        )
    },
    "Y-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["Y","option","choice","split","branch","selection","divide","path","route"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7071 4.29289C19.0976 4.68342 19.0976 5.31658 18.7071 5.70711L13 11.4142L13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19L11 11.4142L5.29289 5.70711C4.90237 5.31658 4.90237 4.68342 5.29289 4.29289C5.68342 3.90237 6.31658 3.90237 6.70711 4.29289L12 9.58579L17.2929 4.29289C17.6834 3.90237 18.3166 3.90237 18.7071 4.29289Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "Y-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["y","split","fork","branch","options","choices","menu","path","decision","selection","alternative"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 11M12 11L6 5M12 11L12 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yahoo-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["Y","yahoo","branch","split","fork","options","choices","select","variation","routing","path","decision","workflow"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L12 11L17 5"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yahoo-2": {
        defaultColors: ["#3D4C66", "#D9D1E0"],
        keywords: ["sales-data","analytics","trends","reporting","performance","insights","metrics","charts","graphs","statistics","summary","overview","analysis"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L12 11L17 5"
                    stroke={colors?.[1] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yahoo-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["split","branch","divide","fork","options","path","alternative"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.35984 4.2318C6.78412 3.87824 7.41468 3.93556 7.76825 4.35984L12 9.43798L16.2318 4.35984C16.5854 3.93556 17.2159 3.87824 17.6402 4.2318C18.0645 4.58537 18.1218 5.21593 17.7682 5.64021L13 11.3621L13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19L11 11.3621L6.2318 5.64021C5.87824 5.21593 5.93556 4.58537 6.35984 4.2318Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Y: {
        defaultColors: ["#3D4C66"],
        keywords: ["split","branch","divide","fork","options","path","alternative"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18 5L12 11M12 11L6 5M12 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-coin-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["yen","coin","currency","payment","money","cash","finance","transaction","price","cost","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10M14 14H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    yahoo: {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","coin","currency","payment","money","cash","finance","transaction","price","cost","value"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 11L12 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 5L12 11L17 5"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-coin-4": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","currency","money","payment","cash","change","price","cost","value","square","rounded","japan","japanese"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10M14 15H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-coin-5": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["yen","currency","money","payment","cash","transaction","finance","price","cost","change"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="4" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10M14 15H10"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-coin-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","coin","currency","money","payment","cash","change","finance","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM9.60004 7.55004C9.35152 7.21867 8.88141 7.15152 8.55004 7.40004C8.21867 7.64857 8.15152 8.11867 8.40004 8.45004L10.5 11.25H10C9.58583 11.25 9.25004 11.5858 9.25004 12C9.25004 12.4143 9.58583 12.75 10 12.75H11.25V13.25H10C9.58583 13.25 9.25004 13.5858 9.25004 14C9.25004 14.4143 9.58583 14.75 10 14.75H11.25V16C11.25 16.4143 11.5858 16.75 12 16.75C12.4143 16.75 12.75 16.4143 12.75 16V14.75H14C14.4143 14.75 14.75 14.4143 14.75 14C14.75 13.5858 14.4143 13.25 14 13.25H12.75V12.75H14C14.4143 12.75 14.75 12.4143 14.75 12C14.75 11.5858 14.4143 11.25 14 11.25H13.5L15.6 8.45004C15.8486 8.11867 15.7814 7.64857 15.45 7.40004C15.1187 7.15152 14.6486 7.21867 14.4 7.55004L12 10.75L9.60004 7.55004Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "yen-coin-7": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","currency","money","payment","cash","change","price","cost","total","balance","exchange","finance","transaction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9268 3H12.0732C13.8966 2.99997 15.3664 2.99995 16.5223 3.15537C17.7225 3.31672 18.733 3.66191 19.5355 4.46447C20.3381 5.26702 20.6833 6.27752 20.8446 7.47767C21.0001 8.63363 21 10.1034 21 11.9269V12.0731C21 13.8966 21.0001 15.3664 20.8446 16.5223C20.6833 17.7225 20.3381 18.733 19.5355 19.5355C18.733 20.3381 17.7225 20.6833 16.5223 20.8446C15.3664 21.0001 13.8966 21 12.0731 21H11.9269C10.1034 21 8.63363 21.0001 7.47767 20.8446C6.27752 20.6833 5.26702 20.3381 4.46447 19.5355C3.66191 18.733 3.31672 17.7225 3.15537 16.5223C2.99995 15.3664 2.99997 13.8966 3 12.0732V11.9268C2.99997 10.1034 2.99995 8.63362 3.15537 7.47767C3.31672 6.27752 3.66191 5.26702 4.46447 4.46447C5.26702 3.66191 6.27752 3.31672 7.47767 3.15537C8.63362 2.99995 10.1034 2.99997 11.9268 3ZM9.64024 7.52C9.37515 7.16654 8.87371 7.0949 8.52024 7.36C8.16678 7.6251 8.09515 8.12654 8.36024 8.48L11.1502 12.2H10.0002C9.55842 12.2 9.20024 12.5582 9.20024 13C9.20024 13.4418 9.55842 13.8 10.0002 13.8H11.2002V14.2H10.0002C9.55842 14.2 9.20024 14.5582 9.20024 15C9.20024 15.4418 9.55842 15.8 10.0002 15.8H11.2002V16C11.2002 16.4418 11.5584 16.8 12.0002 16.8C12.4421 16.8 12.8002 16.4418 12.8002 16V15.8H14.0002C14.4421 15.8 14.8002 15.4418 14.8002 15C14.8002 14.5582 14.4421 14.2 14.0002 14.2H12.8002V13.8H14.0002C14.4421 13.8 14.8002 13.4418 14.8002 13C14.8002 12.5582 14.4421 12.2 14.0002 12.2H12.8502L15.6402 8.48C15.9053 8.12654 15.8337 7.6251 15.4802 7.36C15.1268 7.0949 14.6253 7.16654 14.3602 7.52L12.0002 10.6667L9.64024 7.52Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "yen-coin": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","coin","money","currency","payment","cash","change","price","cost","value","finance","transaction","discount","refund","balance","denomination","exchange"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="16" height="16" rx="8" stroke={colors?.[0] || "#3D4C66"} strokeWidth="1.5" />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10M14 14H10"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-symbol-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["yen","currency","payment","money","cash","exchange","price","total","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V14.5V17M12 12L16 7M12 12L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H12H15M15 15H12H9"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-coin-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["yen","currency","money","coin","payment","cash","finance","transaction","exchange","price","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="8"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 12H10M14 14H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-symbol-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","currency","money","payment","cash","finance","price","total","exchange","amount","cost"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V14.5V17M12 12L16 7M12 12L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H12H15M15 15H12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "yen-symbol-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","currency","money","payment","price","cost","cash","finance","charge","yen-symbol"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.37534 6.21917C7.8066 5.87416 8.4359 5.94408 8.78091 6.37534L12 10.3993L15.2192 6.37534C15.5642 5.94408 16.1935 5.87416 16.6247 6.21917C17.056 6.56418 17.1259 7.19347 16.7809 7.62473L13 12.3508V13H15C15.5523 13 16 13.4478 16 14C16 14.5523 15.5523 15 15 15H13V16H15C15.5523 16 16 16.4478 16 17C16 17.5523 15.5523 18 15 18H13V18.5C13 19.0523 12.5523 19.5 12 19.5C11.4478 19.5 11 19.0523 11 18.5V18H9.00004C8.44775 18 8.00004 17.5523 8.00004 17C8.00004 16.4478 8.44775 16 9.00004 16H11V15H9.00004C8.44775 15 8.00004 14.5523 8.00004 14C8.00004 13.4478 8.44775 13 9.00004 13H11V12.3508L7.21917 7.62473C6.87416 7.19347 6.94408 6.56418 7.37534 6.21917Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "yen-coin-6": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["yen","currency","payment","money","cash","japan","japanese","finance","transaction","coin","discount","price"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="4"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12 12V16M12 12L15 8M12 12L9 8"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 13H10M14 15H10"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "youtube-1": {
        defaultColors: ["#3D4C66", "#2797E8"],
        keywords: ["play","video","tutorial","demo","presentation","media","play-button"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.1094 10.0729L12.5039 10.3359C13.6328 11.0885 14.1972 11.4648 14.1972 12C14.1972 12.5352 13.6328 12.9115 12.5038 13.6641L12.1094 13.9271C10.7407 14.8396 10.0563 15.2958 9.52814 15.0132C9 14.7305 9 13.908 9 12.263L9 12.263L9 11.737C9 10.092 9 9.2695 9.52814 8.98684C10.0563 8.70419 10.7407 9.16044 12.1094 10.0729Z"
                    stroke={colors?.[1] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "youtube-2": {
        defaultColors: ["#D9D1E0", "#3D4C66"],
        keywords: ["play","play-button","video","tutorial","instructions","guide"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    fill={colors?.[0] || "#D9D1E0"}
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.1094 10.0729L12.5039 10.3359C13.6328 11.0885 14.1972 11.4648 14.1972 12C14.1972 12.5352 13.6328 12.9115 12.5038 13.6641L12.1094 13.9271C10.7407 14.8396 10.0563 15.2958 9.52814 15.0132C9 14.7305 9 13.908 9 12.263L9 12.263L9 11.737C9 10.092 9 9.2695 9.52814 8.98684C10.0563 8.70419 10.7407 9.16044 12.1094 10.0729Z"
                    fill={colors?.[1] || "#3D4C66"}
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "youtube-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["play","video","media","tutorial","demonstration","guide","instruction"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.92943 4H15.0706C16.4247 3.99997 17.5413 3.99994 18.4251 4.11876C19.3529 4.2435 20.1723 4.51547 20.8284 5.17158C21.4845 5.82769 21.7565 6.64711 21.8813 7.57494C22.0001 8.4587 22 9.57533 22 10.9294V13.0706C22 14.4247 22.0001 15.5413 21.8813 16.4251C21.7565 17.3529 21.4845 18.1723 20.8284 18.8284C20.1723 19.4845 19.3529 19.7565 18.4251 19.8813C17.5413 20.0001 16.4247 20 15.0706 20H8.92935C7.57527 20 6.45868 20.0001 5.57494 19.8813C4.64711 19.7565 3.82769 19.4845 3.17158 18.8284C2.51547 18.1723 2.2435 17.3529 2.11876 16.4251C1.99994 15.5413 1.99997 14.4247 2 13.0706V10.9294C1.99997 9.57531 1.99994 8.45868 2.11876 7.57494C2.2435 6.64711 2.51547 5.82769 3.17158 5.17158C3.82769 4.51547 4.64711 4.2435 5.57494 4.11876C6.45868 3.99994 7.57535 3.99997 8.92943 4ZM14.2678 10.5429C14.6225 10.8647 15 11.3307 15 12C15 12.6693 14.6225 13.1353 14.2678 13.4571C13.9393 13.7551 13.4764 14.0648 12.9753 14.4L12.4763 14.734C11.8624 15.1449 11.3129 15.5127 10.8503 15.7321C10.3716 15.959 9.7028 16.1656 9.02735 15.8027C8.35189 15.4398 8.15209 14.7666 8.07468 14.2409C7.99986 13.7328 7.99993 13.0698 8.00001 12.3292V11.6708C7.99993 10.9301 7.99986 10.2672 8.07468 9.75912C8.15209 9.2334 8.3519 8.56021 9.02735 8.19733C9.7028 7.83444 10.3716 8.04098 10.8503 8.26793C11.3129 8.48726 11.8624 8.85507 12.4763 9.266L12.9753 9.59998C13.4764 9.93523 13.9393 10.2449 14.2678 10.5429Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "yen-symbol": {
        defaultColors: ["#3D4C66"],
        keywords: ["yen","currency","money","payment","cash","transaction","balance","price","cost","discount","total","change","finance","sales"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12V14.5V17M12 12L16 7M12 12L8 7"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 13H12H15M15 15H12H9"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Z-1": {
        defaultColors: ["#3D4C66"],
        keywords: ["z","letter-z","zoom","zero","zone","zip","quantity","zero-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L13.1136 5C14.8158 5 15.6668 5 15.946 5.54242C16.2251 6.08484 15.7304 6.77738 14.7411 8.16248L9.25891 15.8375C8.26956 17.2226 7.77488 17.9152 8.05402 18.4576C8.33316 19 9.18423 19 10.8864 19L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    youtube: {
        defaultColors: ["#3D4C66"],
        keywords: ["z","letter-z","zoom","zero","zone","zip","quantity","zero-out"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13V11C3 8.17157 3 6.75736 3.87868 5.87868C4.75736 5 6.17157 5 9 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V13C21 15.8284 21 17.2426 20.1213 18.1213C19.2426 19 17.8284 19 15 19H9C6.17157 19 4.75736 19 3.87868 18.1213C3 17.2426 3 15.8284 3 13Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                />
                <path
                    d="M12.1094 10.0729L12.5039 10.3359C13.6328 11.0885 14.1972 11.4648 14.1972 12C14.1972 12.5352 13.6328 12.9115 12.5038 13.6641L12.1094 13.9271C10.7407 14.8396 10.0563 15.2958 9.52814 15.0132C9 14.7305 9 13.908 9 12.263L9 12.263L9 11.737C9 10.092 9 9.2695 9.52814 8.98684C10.0563 8.70419 10.7407 9.16044 12.1094 10.0729Z"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Z-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["z","zoom","history","undo","redo","transaction","edit","recent","recall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9177 6.05714C14.5477 6.00265 13.9987 6.00001 13.1136 6.00001L7 6.00001C6.44772 6.00001 6 5.55229 6 5.00001C6 4.44772 6.44772 4.00001 7 4.00001L13.1136 4.00001L13.1886 4C13.9752 3.99993 14.6752 3.99986 15.2091 4.07848C15.7564 4.15908 16.4661 4.36778 16.8351 5.08485C17.2042 5.80191 16.9615 6.50074 16.7089 6.99294C16.4626 7.4731 16.0557 8.04269 15.5984 8.6827L15.5984 8.68271L10.0726 16.4188C9.55819 17.139 9.24125 17.5873 9.07051 17.92L9.0606 17.9396L9.08226 17.9429C9.4523 17.9974 10.0013 18 10.8864 18L17 18C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20L10.8864 20L10.8114 20C10.0248 20.0001 9.32481 20.0002 8.79088 19.9215C8.24358 19.8409 7.53387 19.6322 7.16485 18.9152C6.79584 18.1981 7.03852 17.4993 7.29105 17.0071C7.53741 16.5269 7.94436 15.9573 8.40161 15.3173L13.9274 7.58125C14.4418 6.86102 14.7587 6.41275 14.9295 6.07997L14.9394 6.06043L14.9177 6.05714Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    Z: {
        defaultColors: ["#3D4C66"],
        keywords: ["z","zoom","history","undo","redo","transaction","edit","recent","recall"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L13.1136 5C14.8158 5 15.6668 5 15.946 5.54242C16.2251 6.08484 15.7304 6.77738 14.7411 8.16248L9.25891 15.8375C8.26956 17.2226 7.77488 17.9152 8.05402 18.4576C8.33316 19 9.18423 19 10.8864 19L17 19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "zzz-1": {
        defaultColors: ["#2797E8", "#3D4C66"],
        keywords: ["sleep","zzz","inactive","idle","offline","away","break","pause","downtime","rest","disabled"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4H19L13 12H19"
                    stroke={colors?.[0] || "#2797E8"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H11L5 20H11"
                    stroke={colors?.[1] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "Z-2": {
        defaultColors: ["#D9D1E0"],
        keywords: ["z","letter-z","discount-code","promotion-code","alphabet","coupon","zero","search","zoom","settings","zone"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 5L13.1136 5C14.8158 5 15.6668 5 15.946 5.54242C16.2251 6.08484 15.7304 6.77738 14.7411 8.16248L9.25891 15.8375C8.26956 17.2226 7.77488 17.9152 8.05402 18.4576C8.33316 19 9.18423 19 10.8864 19L17 19"
                    stroke={colors?.[0] || "#D9D1E0"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    "zzz-3": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","zzz","idle","inactive","timeout","unavailable"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6C12 5.44772 12.4477 5 13 5H19C19.3788 5 19.725 5.214 19.8944 5.55279C20.0638 5.89157 20.0273 6.29698 19.8 6.6L15 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H13C12.6212 15 12.275 14.786 12.1056 14.4472C11.9362 14.1084 11.9727 13.703 12.2 13.4L17 7H13C12.4477 7 12 6.55228 12 6Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.00001 10C4.00001 9.44772 4.44772 9 5.00001 9H11C11.3788 9 11.725 9.214 11.8944 9.55279C12.0638 9.89157 12.0273 10.297 11.8 10.6L7.00001 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H5.00001C4.62123 19 4.27497 18.786 4.10558 18.4472C3.93619 18.1084 3.97274 17.703 4.20001 17.4L9.00001 11H5.00001C4.44772 11 4.00001 10.5523 4.00001 10Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "zzz-2": {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","zzz","inactive","timeout","idle","away","paused","do-not-disturb"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4H19L13 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H11L5 20H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    zzz: {
        defaultColors: ["#3D4C66"],
        keywords: ["sleep","zzz","inactive","timeout","idle","away","paused","do-not-disturb"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 4H19L13 12H19"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5 12H11L5 20H11"
                    stroke={colors?.[0] || "#3D4C66"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    },
    vendara: {
        defaultColors: ["#7E57C5", "#00B2E3"],
        keywords: ["sleep","zzz","inactive","timeout","idle","away","paused","do-not-disturb"],
        getIcon: (colors?: string[]) => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9802 6.674V5.69731C19.9802 5.08688 19.2747 4.78166 18.8147 5.17844L13.9072 9.60406C13.1711 10.2755 12.7417 11.2217 12.7417 12.2289V13.2056L19.9802 6.674Z"
                    fill={colors?.[0] || "#7E57C5"}
                />
                <path
                    d="M12.7417 14.7012V18.3027C12.7417 18.9131 13.4471 19.2183 13.9072 18.8216L18.8147 14.3959C19.5508 13.7245 19.9802 12.7783 19.9802 11.7711V8.16956L12.7417 14.7012Z"
                    fill={colors?.[0] || "#7E57C5"}
                />
                <path
                    d="M4 8.16956V11.7711C4 12.7783 4.4294 13.7245 5.16552 14.3959L10.073 18.8216C10.533 19.2183 11.2385 18.9131 11.2385 18.3027V14.7012L4 8.16956Z"
                    fill={colors?.[1] || "#00B2E3"}
                />
                <path
                    d="M11.2687 13.2056V12.2289C11.2687 11.2217 10.8393 10.2755 10.1032 9.60406L5.19579 5.17844C4.73572 4.78166 4.03027 5.08688 4.03027 5.69731V6.674L11.2687 13.2056Z"
                    fill={colors?.[1] || "#00B2E3"}
                />
            </svg>
        )
    },
    "no-variations": {
        defaultColors: ["#758696"],
        keywords: ["bricks","wall","building","construction","structure","stacked","layout","arrangement"],
        getIcon: (colors?: string[]) => (
            <svg width="322" height="78" viewBox="0 0 322 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="2"
                    y="2"
                    width="108"
                    height="30.7742"
                    rx="8"
                    stroke={colors?.[0] || "#758696"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="7 7"
                />
                <rect
                    x="122"
                    y="2"
                    width="78"
                    height="30.7742"
                    rx="8"
                    stroke={colors?.[0] || "#758696"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="7 7"
                />
                <rect
                    x="212"
                    y="2"
                    width="108"
                    height="30.7742"
                    rx="8"
                    stroke={colors?.[0] || "#758696"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="7 7"
                />
                <rect
                    x="61"
                    y="44.7744"
                    width="94"
                    height="30.7742"
                    rx="8"
                    stroke={colors?.[0] || "#758696"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="7 7"
                />
                <rect
                    x="167"
                    y="44.7744"
                    width="94"
                    height="30.7742"
                    rx="8"
                    stroke={colors?.[0] || "#758696"}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray="7 7"
                />
            </svg>
        )
    },
    "scan-card": {
        defaultColors: ["#3D4C66"],
        keywords: ["card","payment","contactless","scan","tap","pay","credit card","debit card","nfc","hand"],
        getIcon: (colors?: string[]) => (
            <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M129.938 38.25C129.938 47.7135 126.855 56.6617 121.03 64.1273C120.894 64.303 120.725 64.4501 120.533 64.5601C120.34 64.6701 120.128 64.7407 119.907 64.768C119.687 64.7952 119.464 64.7784 119.25 64.7186C119.036 64.6589 118.837 64.5573 118.663 64.4198C118.31 64.1445 118.082 63.7406 118.027 63.2968C117.972 62.853 118.095 62.4055 118.37 62.0527C123.73 55.1835 126.56 46.9552 126.56 38.25C126.56 29.5448 123.73 21.3165 118.37 14.445C118.097 14.0925 117.974 13.6461 118.029 13.2034C118.084 12.7607 118.312 12.3577 118.663 12.0825C118.837 11.9452 119.036 11.8437 119.25 11.7839C119.463 11.7241 119.687 11.7072 119.907 11.7342C120.127 11.7612 120.339 11.8315 120.532 11.9411C120.725 12.0507 120.894 12.1974 121.03 12.3728C126.826 19.7505 129.965 28.8677 129.938 38.25ZM108.018 20.3602C107.843 20.4966 107.697 20.666 107.588 20.8589C107.478 21.0517 107.408 21.2642 107.381 21.4843C107.354 21.7043 107.37 21.9275 107.429 22.1412C107.488 22.3548 107.589 22.5548 107.725 22.7295C111.22 27.1845 113.062 32.553 113.062 38.25C113.062 43.947 111.218 49.3133 107.728 53.7705C107.452 54.1232 107.328 54.5709 107.382 55.0152C107.437 55.4596 107.665 55.8641 108.018 56.1398C108.371 56.4154 108.818 56.5397 109.263 56.4853C109.707 56.4309 110.112 56.2022 110.387 55.8495C114.345 50.7938 116.438 44.7075 116.438 38.25C116.438 31.7925 114.345 25.7063 110.385 20.6505C110.11 20.2981 109.706 20.0693 109.262 20.0145C108.818 19.9596 108.371 20.0854 108.018 20.3602ZM97.3463 28.647C97.1724 28.7846 97.0275 28.9552 96.9196 29.1489C96.8117 29.3426 96.7431 29.5556 96.7176 29.7759C96.6921 29.9961 96.7103 30.2192 96.771 30.4324C96.8318 30.6456 96.934 30.8448 97.0718 31.0185C98.7008 33.075 99.5625 35.5793 99.5625 38.25C99.5625 40.9207 98.7007 43.425 97.0695 45.4815C96.7974 45.8329 96.675 46.2774 96.7287 46.7185C96.7824 47.1597 97.008 47.5618 97.3564 47.8376C97.7048 48.1135 98.148 48.2407 98.5897 48.1918C99.0314 48.1429 99.4359 47.9217 99.7155 47.5763C101.805 44.917 102.94 41.6322 102.938 38.25C102.938 34.857 101.792 31.545 99.7155 28.9237C99.4379 28.573 99.0324 28.3469 98.5882 28.295C98.1439 28.2431 97.6972 28.3697 97.3463 28.647ZM88.65 79.0312C92.0905 84.4093 93.2807 90.9236 91.9642 97.1708L88.506 114.939C87.6279 119.413 87.1864 123.961 87.1875 128.52V135C87.1875 135.448 87.0097 135.877 86.6932 136.193C86.3768 136.51 85.9476 136.688 85.5 136.688H53.6197C53.1722 136.688 52.743 136.51 52.4265 136.193C52.11 135.877 51.9322 135.448 51.9322 135V129.877C51.9322 125.37 50.8478 121.165 48.7935 117.713C44.9798 111.312 43.7985 104.074 45.207 96.1875H24.75C18.8573 96.1875 14.0625 91.395 14.0625 85.5V18C14.0625 12.105 18.8573 7.3125 24.75 7.3125H69.75C75.645 7.3125 80.4375 12.105 80.4375 18V66.2625L88.65 79.0312ZM69.75 10.6875H48.9375V70.0065C50.8671 70.6108 52.5588 71.8045 53.775 73.4198L68.3662 92.8125H69.75C71.6887 92.8101 73.5472 92.0389 74.9181 90.6681C76.2889 89.2972 77.0601 87.4387 77.0625 85.5V18C77.0601 16.0613 76.2889 14.2028 74.9181 12.8319C73.5472 11.4611 71.6887 10.6899 69.75 10.6875ZM24.75 92.8125H27.5625V10.6875H24.75C22.8113 10.6899 20.9528 11.4611 19.5819 12.8319C18.2111 14.2028 17.4399 16.0613 17.4375 18V85.5C17.4399 87.4387 18.2111 89.2972 19.5819 90.6681C20.9528 92.0389 22.8113 92.8101 24.75 92.8125ZM30.9375 92.8125H43.866L38.1308 85.1895C36.5735 83.1138 35.9028 80.5055 36.2655 77.9361C36.6282 75.3667 37.9948 73.046 40.0657 71.4825C41.6569 70.2894 43.575 69.6118 45.5625 69.5407V10.6875H30.9375V92.8125ZM85.8128 80.8583L80.4375 72.4995V85.5C80.4375 91.026 76.2075 95.5305 70.8232 96.0795L73.2533 99.3105C73.5224 99.6682 73.6384 100.118 73.5757 100.562C73.5131 101.005 73.2769 101.405 72.9191 101.674C72.5614 101.943 72.1114 102.059 71.6681 101.997C71.2248 101.934 70.8246 101.698 70.5555 101.34L51.0773 75.4492C50.5708 74.7765 49.9368 74.21 49.2114 73.7822C48.4861 73.3544 47.6836 73.0737 46.8497 72.9561C46.0159 72.8385 45.167 72.8862 44.3516 73.0967C43.5363 73.3071 42.7703 73.6761 42.0975 74.1825C40.7394 75.2053 39.843 76.7255 39.6055 78.409C39.3679 80.0925 39.8086 81.8014 40.8307 83.16L48.6 93.4875C48.9375 93.942 49.0185 94.5112 48.8587 95.0175C47.0498 102.886 47.9767 109.748 51.6938 115.987C54.0563 119.959 55.3072 124.762 55.3072 129.877V133.312H83.8125V128.52C83.8125 123.732 84.276 118.944 85.1917 114.291L88.6568 96.4935C89.8023 91.1098 88.7805 85.4938 85.8128 80.8583Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
                <path
                    d="M90.3249 143.999H86.314V137.959H53.3447V143.999H49.3338V135.953C49.3338 134.857 50.2429 133.948 51.3392 133.948H88.3195C89.4158 133.948 90.3249 134.857 90.3249 135.953V143.999Z"
                    fill={colors?.[0] || "#3D4C66"}
                />
            </svg>
        )
    },
    "tap-to-pay-fill": {
        defaultColors: ["#3D4C66"],
        keywords: ["tap-to-pay","contactless","payment","nfc","wireless","transaction","pos","reader","pay"],
        getIcon: (colors?: string[]) => (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.2832 19.9316">
                <g>
                    <rect height="19.9316" opacity="0" width="20.2832" x="0" y="0" />
                    <path
                        d="M19.9219 9.9707C19.9219 15.4688 15.459 19.9316 9.96094 19.9316C4.47266 19.9316 0 15.4688 0 9.9707C0 4.48242 4.47266 0.00976562 9.96094 0.00976562C15.459 0.00976562 19.9219 4.48242 19.9219 9.9707ZM11.3086 3.45703C10.9863 3.69141 10.9277 4.10156 11.1621 4.44336C12.2461 5.95703 12.832 7.91992 12.832 9.9707C12.832 11.9922 12.2363 13.9746 11.1621 15.498C10.9277 15.8301 10.9863 16.2402 11.3086 16.4844C11.6113 16.6992 12.0312 16.6211 12.2754 16.2793C13.5156 14.5215 14.1895 12.2754 14.1895 9.9707C14.1895 7.66602 13.5156 5.43945 12.2754 3.65234C12.041 3.30078 11.6211 3.22266 11.3086 3.45703ZM8.69141 5.22461C8.37891 5.43945 8.30078 5.86914 8.54492 6.2207C9.25781 7.20703 9.66797 8.56445 9.66797 9.9707C9.66797 11.3672 9.25781 12.7246 8.54492 13.7109C8.30078 14.0625 8.37891 14.4922 8.69141 14.707C9.00391 14.9414 9.4043 14.8535 9.64844 14.5312C10.5469 13.2715 11.0449 11.6406 11.0449 9.9707C11.0449 8.26172 10.5469 6.63086 9.64844 5.41016C9.4043 5.07812 9.00391 5 8.69141 5.22461ZM6.09375 6.96289C5.74219 7.20703 5.67383 7.64648 5.9375 8.00781C6.29883 8.48633 6.51367 9.20898 6.51367 9.9707C6.51367 10.7031 6.29883 11.4258 5.9375 11.9238C5.68359 12.2852 5.75195 12.7051 6.09375 12.959C6.40625 13.1738 6.82617 13.0859 7.05078 12.7734C7.57812 12.0703 7.89062 11.0254 7.89062 9.9707C7.89062 8.94531 7.57812 7.90039 7.05078 7.14844C6.81641 6.8457 6.40625 6.75781 6.09375 6.96289Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
            </svg>
        )
    },
    "tap-to-pay-outline": {
        defaultColors: ["#3D4C66"],
        keywords: ["tap-to-pay","contactless","payment","nfc","wireless","transaction","scan","reader","pay","card","credit","debit"],
        getIcon: (colors?: string[]) => (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.2832 19.9316">
                <g>
                    <rect height="19.9316" opacity="0" width="20.2832" x="0" y="0" />
                    <path
                        d="M9.96094 19.9219C15.459 19.9219 19.9219 15.459 19.9219 9.96094C19.9219 4.46289 15.459 0 9.96094 0C4.46289 0 0 4.46289 0 9.96094C0 15.459 4.46289 19.9219 9.96094 19.9219ZM9.96094 18.2617C5.37109 18.2617 1.66016 14.5508 1.66016 9.96094C1.66016 5.37109 5.37109 1.66016 9.96094 1.66016C14.5508 1.66016 18.2617 5.37109 18.2617 9.96094C18.2617 14.5508 14.5508 18.2617 9.96094 18.2617Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                    <path
                        d="M14.0527 9.95117C14.0527 7.72461 13.3887 5.55664 12.1973 3.82812C11.9629 3.49609 11.5625 3.41797 11.25 3.63281C10.9375 3.85742 10.8887 4.26758 11.123 4.58984C12.1582 6.06445 12.7441 7.96875 12.7441 9.95117C12.7441 11.9141 12.1484 13.8477 11.123 15.3125C10.8887 15.6445 10.9375 16.0449 11.25 16.2695C11.5527 16.4844 11.9531 16.3965 12.1973 16.084C13.3887 14.3652 14.0527 12.1973 14.0527 9.95117Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                    <path
                        d="M10.9961 9.95117C10.9961 8.29102 10.5176 6.71875 9.64844 5.52734C9.41406 5.21484 9.02344 5.13672 8.71094 5.36133C8.41797 5.56641 8.34961 5.97656 8.58398 6.31836C9.27734 7.27539 9.66797 8.59375 9.66797 9.95117C9.66797 11.3184 9.27734 12.6367 8.58398 13.5938C8.34961 13.9355 8.41797 14.3457 8.71094 14.5508C9.02344 14.7656 9.41406 14.6973 9.64844 14.375C10.5176 13.1641 10.9961 11.582 10.9961 9.95117Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                    <path
                        d="M7.93945 9.95117C7.93945 8.95508 7.63672 7.94922 7.11914 7.22656C6.89453 6.93359 6.49414 6.8457 6.19141 7.04102C5.84961 7.27539 5.79102 7.70508 6.05469 8.05664C6.40625 8.50586 6.61133 9.21875 6.61133 9.95117C6.61133 10.6641 6.40625 11.377 6.05469 11.8555C5.80078 12.207 5.85938 12.6172 6.19141 12.8613C6.49414 13.0664 6.9043 12.9785 7.11914 12.6758C7.63672 11.9922 7.93945 10.9766 7.93945 9.95117Z"
                        fill={colors?.[0] || "#3D4C66"}
                    />
                </g>
            </svg>
        )
    }
};
